import { reactive, ref as ref$1, shallowReactive, defineComponent, computed, toRefs, unref, h, watch, onMounted, onUnmounted, nextTick, useSlots, watchEffect, onErrorCaptured, onUpdated, markRaw, getCurrentInstance, onBeforeUnmount, Transition, withDirectives, onDeactivated, onActivated, useCssVars, inject, provide, createElementBlock, openBlock, createElementVNode, createVNode, normalizeStyle, readonly, onBeforeUpdate, toRaw, createBlock, normalizeClass, toRef, isRef, Teleport, resolveComponent, mergeProps, withCtx, renderSlot, createSlots, renderList, createTextVNode, toDisplayString, normalizeProps, guardReactiveProps, createCommentVNode, Fragment, useTemplateRef, onBeforeMount, toHandlerKey, withModifiers, resolveDynamicComponent, vShow, resolveDirective, toHandlers, Suspense, withKeys, KeepAlive, createApp } from "vue";
import { buildParameterValue, ParameterDict, Blob as Blob$1, ParameterList as ParameterList$1, Label, Size2D } from "@robovision/data";
import { useI18n, Translation } from "vue-i18n";
import { RouterLink, useRouter, RouterView, onBeforeRouteLeave, onBeforeRouteUpdate, useRoute } from "vue-router";
import { helpers, decimal, email, integer, maxLength, minLength, requiredUnless } from "@vuelidate/validators";
import useVuelidate, { useVuelidate as useVuelidate$1 } from "@vuelidate/core";
const defaultOptions$2 = () => ({
  extraComponents: []
});
let globalOptions$1 = defaultOptions$2();
function provideOptions(options = defaultOptions$2()) {
  globalOptions$1 = options;
}
function useOptions$1() {
  return globalOptions$1;
}
/*!
 * Chart.js v3.9.1
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */
function noop$2() {
}
const uid$2 = /* @__PURE__ */ function() {
  let id3 = 0;
  return function() {
    return id3++;
  };
}();
function isNullOrUndef(value2) {
  return value2 === null || typeof value2 === "undefined";
}
function isArray(value2) {
  if (Array.isArray && Array.isArray(value2)) {
    return true;
  }
  const type2 = Object.prototype.toString.call(value2);
  if (type2.slice(0, 7) === "[object" && type2.slice(-6) === "Array]") {
    return true;
  }
  return false;
}
function isObject$3(value2) {
  return value2 !== null && Object.prototype.toString.call(value2) === "[object Object]";
}
const isNumberFinite = (value2) => (typeof value2 === "number" || value2 instanceof Number) && isFinite(+value2);
function finiteOrDefault(value2, defaultValue) {
  return isNumberFinite(value2) ? value2 : defaultValue;
}
function valueOrDefault(value2, defaultValue) {
  return typeof value2 === "undefined" ? defaultValue : value2;
}
const toPercentage = (value2, dimension) => typeof value2 === "string" && value2.endsWith("%") ? parseFloat(value2) / 100 : value2 / dimension;
const toDimension = (value2, dimension) => typeof value2 === "string" && value2.endsWith("%") ? parseFloat(value2) / 100 * dimension : +value2;
function callback(fn, args, thisArg) {
  if (fn && typeof fn.call === "function") {
    return fn.apply(thisArg, args);
  }
}
function each(loopable, fn, thisArg, reverse) {
  let i3, len, keys2;
  if (isArray(loopable)) {
    len = loopable.length;
    {
      for (i3 = 0; i3 < len; i3++) {
        fn.call(thisArg, loopable[i3], i3);
      }
    }
  } else if (isObject$3(loopable)) {
    keys2 = Object.keys(loopable);
    len = keys2.length;
    for (i3 = 0; i3 < len; i3++) {
      fn.call(thisArg, loopable[keys2[i3]], keys2[i3]);
    }
  }
}
function _elementsEqual(a0, a1) {
  let i3, ilen, v0, v1;
  if (!a0 || !a1 || a0.length !== a1.length) {
    return false;
  }
  for (i3 = 0, ilen = a0.length; i3 < ilen; ++i3) {
    v0 = a0[i3];
    v1 = a1[i3];
    if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) {
      return false;
    }
  }
  return true;
}
function clone$1$1(source) {
  if (isArray(source)) {
    return source.map(clone$1$1);
  }
  if (isObject$3(source)) {
    const target2 = /* @__PURE__ */ Object.create(null);
    const keys2 = Object.keys(source);
    const klen = keys2.length;
    let k3 = 0;
    for (; k3 < klen; ++k3) {
      target2[keys2[k3]] = clone$1$1(source[keys2[k3]]);
    }
    return target2;
  }
  return source;
}
function isValidKey(key) {
  return ["__proto__", "prototype", "constructor"].indexOf(key) === -1;
}
function _merger(key, target2, source, options) {
  if (!isValidKey(key)) {
    return;
  }
  const tval = target2[key];
  const sval = source[key];
  if (isObject$3(tval) && isObject$3(sval)) {
    merge(tval, sval, options);
  } else {
    target2[key] = clone$1$1(sval);
  }
}
function merge(target2, source, options) {
  const sources = isArray(source) ? source : [source];
  const ilen = sources.length;
  if (!isObject$3(target2)) {
    return target2;
  }
  options = options || {};
  const merger = options.merger || _merger;
  for (let i3 = 0; i3 < ilen; ++i3) {
    source = sources[i3];
    if (!isObject$3(source)) {
      continue;
    }
    const keys2 = Object.keys(source);
    for (let k3 = 0, klen = keys2.length; k3 < klen; ++k3) {
      merger(keys2[k3], target2, source, options);
    }
  }
  return target2;
}
function mergeIf(target2, source) {
  return merge(target2, source, { merger: _mergerIf });
}
function _mergerIf(key, target2, source) {
  if (!isValidKey(key)) {
    return;
  }
  const tval = target2[key];
  const sval = source[key];
  if (isObject$3(tval) && isObject$3(sval)) {
    mergeIf(tval, sval);
  } else if (!Object.prototype.hasOwnProperty.call(target2, key)) {
    target2[key] = clone$1$1(sval);
  }
}
const keyResolvers = {
  "": (v) => v,
  x: (o) => o.x,
  y: (o) => o.y
};
function resolveObjectKey(obj, key) {
  const resolver = keyResolvers[key] || (keyResolvers[key] = _getKeyResolver(key));
  return resolver(obj);
}
function _getKeyResolver(key) {
  const keys2 = _splitKey(key);
  return (obj) => {
    for (const k3 of keys2) {
      if (k3 === "") {
        break;
      }
      obj = obj && obj[k3];
    }
    return obj;
  };
}
function _splitKey(key) {
  const parts = key.split(".");
  const keys2 = [];
  let tmp = "";
  for (const part of parts) {
    tmp += part;
    if (tmp.endsWith("\\")) {
      tmp = tmp.slice(0, -1) + ".";
    } else {
      keys2.push(tmp);
      tmp = "";
    }
  }
  return keys2;
}
function _capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
const defined = (value2) => typeof value2 !== "undefined";
const isFunction = (value2) => typeof value2 === "function";
const setsEqual = (a4, b3) => {
  if (a4.size !== b3.size) {
    return false;
  }
  for (const item of a4) {
    if (!b3.has(item)) {
      return false;
    }
  }
  return true;
};
function _isClickEvent(e3) {
  return e3.type === "mouseup" || e3.type === "click" || e3.type === "contextmenu";
}
const PI = Math.PI;
const TAU = 2 * PI;
const PITAU = TAU + PI;
const INFINITY = Number.POSITIVE_INFINITY;
const RAD_PER_DEG = PI / 180;
const HALF_PI = PI / 2;
const QUARTER_PI = PI / 4;
const TWO_THIRDS_PI = PI * 2 / 3;
const log10 = Math.log10;
const sign = Math.sign;
function niceNum(range2) {
  const roundedRange = Math.round(range2);
  range2 = almostEquals(range2, roundedRange, range2 / 1e3) ? roundedRange : range2;
  const niceRange = Math.pow(10, Math.floor(log10(range2)));
  const fraction = range2 / niceRange;
  const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
  return niceFraction * niceRange;
}
function _factorize(value2) {
  const result = [];
  const sqrt = Math.sqrt(value2);
  let i3;
  for (i3 = 1; i3 < sqrt; i3++) {
    if (value2 % i3 === 0) {
      result.push(i3);
      result.push(value2 / i3);
    }
  }
  if (sqrt === (sqrt | 0)) {
    result.push(sqrt);
  }
  result.sort((a4, b3) => a4 - b3).pop();
  return result;
}
function isNumber$2(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}
function almostEquals(x3, y4, epsilon) {
  return Math.abs(x3 - y4) < epsilon;
}
function almostWhole(x3, epsilon) {
  const rounded = Math.round(x3);
  return rounded - epsilon <= x3 && rounded + epsilon >= x3;
}
function _setMinAndMaxByKey(array, target2, property) {
  let i3, ilen, value2;
  for (i3 = 0, ilen = array.length; i3 < ilen; i3++) {
    value2 = array[i3][property];
    if (!isNaN(value2)) {
      target2.min = Math.min(target2.min, value2);
      target2.max = Math.max(target2.max, value2);
    }
  }
}
function toRadians(degrees) {
  return degrees * (PI / 180);
}
function toDegrees(radians) {
  return radians * (180 / PI);
}
function _decimalPlaces(x3) {
  if (!isNumberFinite(x3)) {
    return;
  }
  let e3 = 1;
  let p2 = 0;
  while (Math.round(x3 * e3) / e3 !== x3) {
    e3 *= 10;
    p2++;
  }
  return p2;
}
function getAngleFromPoint(centrePoint, anglePoint) {
  const distanceFromXCenter = anglePoint.x - centrePoint.x;
  const distanceFromYCenter = anglePoint.y - centrePoint.y;
  const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
  let angle2 = Math.atan2(distanceFromYCenter, distanceFromXCenter);
  if (angle2 < -0.5 * PI) {
    angle2 += TAU;
  }
  return {
    angle: angle2,
    distance: radialDistanceFromCenter
  };
}
function distanceBetweenPoints(pt1, pt2) {
  return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
function _angleDiff(a4, b3) {
  return (a4 - b3 + PITAU) % TAU - PI;
}
function _normalizeAngle(a4) {
  return (a4 % TAU + TAU) % TAU;
}
function _angleBetween(angle2, start, end, sameAngleIsFullCircle) {
  const a4 = _normalizeAngle(angle2);
  const s4 = _normalizeAngle(start);
  const e3 = _normalizeAngle(end);
  const angleToStart = _normalizeAngle(s4 - a4);
  const angleToEnd = _normalizeAngle(e3 - a4);
  const startToAngle = _normalizeAngle(a4 - s4);
  const endToAngle = _normalizeAngle(a4 - e3);
  return a4 === s4 || a4 === e3 || sameAngleIsFullCircle && s4 === e3 || angleToStart > angleToEnd && startToAngle < endToAngle;
}
function _limitValue(value2, min2, max2) {
  return Math.max(min2, Math.min(max2, value2));
}
function _int16Range(value2) {
  return _limitValue(value2, -32768, 32767);
}
function _isBetween(value2, start, end, epsilon = 1e-6) {
  return value2 >= Math.min(start, end) - epsilon && value2 <= Math.max(start, end) + epsilon;
}
function _lookup(table, value2, cmp) {
  cmp = cmp || ((index2) => table[index2] < value2);
  let hi = table.length - 1;
  let lo2 = 0;
  let mid;
  while (hi - lo2 > 1) {
    mid = lo2 + hi >> 1;
    if (cmp(mid)) {
      lo2 = mid;
    } else {
      hi = mid;
    }
  }
  return { lo: lo2, hi };
}
const _lookupByKey = (table, key, value2, last2) => _lookup(table, value2, last2 ? (index2) => table[index2][key] <= value2 : (index2) => table[index2][key] < value2);
const _rlookupByKey = (table, key, value2) => _lookup(table, value2, (index2) => table[index2][key] >= value2);
function _filterBetween(values, min2, max2) {
  let start = 0;
  let end = values.length;
  while (start < end && values[start] < min2) {
    start++;
  }
  while (end > start && values[end - 1] > max2) {
    end--;
  }
  return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const arrayEvents = ["push", "pop", "shift", "splice", "unshift"];
function listenArrayEvents(array, listener) {
  if (array._chartjs) {
    array._chartjs.listeners.push(listener);
    return;
  }
  Object.defineProperty(array, "_chartjs", {
    configurable: true,
    enumerable: false,
    value: {
      listeners: [listener]
    }
  });
  arrayEvents.forEach((key) => {
    const method = "_onData" + _capitalize(key);
    const base = array[key];
    Object.defineProperty(array, key, {
      configurable: true,
      enumerable: false,
      value(...args) {
        const res = base.apply(this, args);
        array._chartjs.listeners.forEach((object) => {
          if (typeof object[method] === "function") {
            object[method](...args);
          }
        });
        return res;
      }
    });
  });
}
function unlistenArrayEvents(array, listener) {
  const stub = array._chartjs;
  if (!stub) {
    return;
  }
  const listeners = stub.listeners;
  const index2 = listeners.indexOf(listener);
  if (index2 !== -1) {
    listeners.splice(index2, 1);
  }
  if (listeners.length > 0) {
    return;
  }
  arrayEvents.forEach((key) => {
    delete array[key];
  });
  delete array._chartjs;
}
function _arrayUnique(items) {
  const set2 = /* @__PURE__ */ new Set();
  let i3, ilen;
  for (i3 = 0, ilen = items.length; i3 < ilen; ++i3) {
    set2.add(items[i3]);
  }
  if (set2.size === ilen) {
    return items;
  }
  return Array.from(set2);
}
const requestAnimFrame = function() {
  if (typeof window === "undefined") {
    return function(callback2) {
      return callback2();
    };
  }
  return window.requestAnimationFrame;
}();
function throttled(fn, thisArg, updateFn) {
  const updateArgs2 = updateFn || ((args2) => Array.prototype.slice.call(args2));
  let ticking = false;
  let args = [];
  return function(...rest) {
    args = updateArgs2(rest);
    if (!ticking) {
      ticking = true;
      requestAnimFrame.call(window, () => {
        ticking = false;
        fn.apply(thisArg, args);
      });
    }
  };
}
function debounce$1(fn, delay) {
  let timeout2;
  return function(...args) {
    if (delay) {
      clearTimeout(timeout2);
      timeout2 = setTimeout(fn, delay, args);
    } else {
      fn.apply(this, args);
    }
    return delay;
  };
}
const _toLeftRightCenter = (align) => align === "start" ? "left" : align === "end" ? "right" : "center";
const _alignStartEnd = (align, start, end) => align === "start" ? start : align === "end" ? end : (start + end) / 2;
function _getStartAndCountOfVisiblePoints(meta, points, animationsDisabled) {
  const pointCount = points.length;
  let start = 0;
  let count = pointCount;
  if (meta._sorted) {
    const { iScale, _parsed } = meta;
    const axis = iScale.axis;
    const { min: min2, max: max2, minDefined, maxDefined } = iScale.getUserBounds();
    if (minDefined) {
      start = _limitValue(
        Math.min(
          _lookupByKey(_parsed, iScale.axis, min2).lo,
          animationsDisabled ? pointCount : _lookupByKey(points, axis, iScale.getPixelForValue(min2)).lo
        ),
        0,
        pointCount - 1
      );
    }
    if (maxDefined) {
      count = _limitValue(
        Math.max(
          _lookupByKey(_parsed, iScale.axis, max2, true).hi + 1,
          animationsDisabled ? 0 : _lookupByKey(points, axis, iScale.getPixelForValue(max2), true).hi + 1
        ),
        start,
        pointCount
      ) - start;
    } else {
      count = pointCount - start;
    }
  }
  return { start, count };
}
function _scaleRangesChanged(meta) {
  const { xScale, yScale, _scaleRanges } = meta;
  const newRanges = {
    xmin: xScale.min,
    xmax: xScale.max,
    ymin: yScale.min,
    ymax: yScale.max
  };
  if (!_scaleRanges) {
    meta._scaleRanges = newRanges;
    return true;
  }
  const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
  Object.assign(_scaleRanges, newRanges);
  return changed;
}
const atEdge = (t3) => t3 === 0 || t3 === 1;
const elasticIn = (t3, s4, p2) => -(Math.pow(2, 10 * (t3 -= 1)) * Math.sin((t3 - s4) * TAU / p2));
const elasticOut = (t3, s4, p2) => Math.pow(2, -10 * t3) * Math.sin((t3 - s4) * TAU / p2) + 1;
const effects = {
  linear: (t3) => t3,
  easeInQuad: (t3) => t3 * t3,
  easeOutQuad: (t3) => -t3 * (t3 - 2),
  easeInOutQuad: (t3) => (t3 /= 0.5) < 1 ? 0.5 * t3 * t3 : -0.5 * (--t3 * (t3 - 2) - 1),
  easeInCubic: (t3) => t3 * t3 * t3,
  easeOutCubic: (t3) => (t3 -= 1) * t3 * t3 + 1,
  easeInOutCubic: (t3) => (t3 /= 0.5) < 1 ? 0.5 * t3 * t3 * t3 : 0.5 * ((t3 -= 2) * t3 * t3 + 2),
  easeInQuart: (t3) => t3 * t3 * t3 * t3,
  easeOutQuart: (t3) => -((t3 -= 1) * t3 * t3 * t3 - 1),
  easeInOutQuart: (t3) => (t3 /= 0.5) < 1 ? 0.5 * t3 * t3 * t3 * t3 : -0.5 * ((t3 -= 2) * t3 * t3 * t3 - 2),
  easeInQuint: (t3) => t3 * t3 * t3 * t3 * t3,
  easeOutQuint: (t3) => (t3 -= 1) * t3 * t3 * t3 * t3 + 1,
  easeInOutQuint: (t3) => (t3 /= 0.5) < 1 ? 0.5 * t3 * t3 * t3 * t3 * t3 : 0.5 * ((t3 -= 2) * t3 * t3 * t3 * t3 + 2),
  easeInSine: (t3) => -Math.cos(t3 * HALF_PI) + 1,
  easeOutSine: (t3) => Math.sin(t3 * HALF_PI),
  easeInOutSine: (t3) => -0.5 * (Math.cos(PI * t3) - 1),
  easeInExpo: (t3) => t3 === 0 ? 0 : Math.pow(2, 10 * (t3 - 1)),
  easeOutExpo: (t3) => t3 === 1 ? 1 : -Math.pow(2, -10 * t3) + 1,
  easeInOutExpo: (t3) => atEdge(t3) ? t3 : t3 < 0.5 ? 0.5 * Math.pow(2, 10 * (t3 * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t3 * 2 - 1)) + 2),
  easeInCirc: (t3) => t3 >= 1 ? t3 : -(Math.sqrt(1 - t3 * t3) - 1),
  easeOutCirc: (t3) => Math.sqrt(1 - (t3 -= 1) * t3),
  easeInOutCirc: (t3) => (t3 /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t3 * t3) - 1) : 0.5 * (Math.sqrt(1 - (t3 -= 2) * t3) + 1),
  easeInElastic: (t3) => atEdge(t3) ? t3 : elasticIn(t3, 0.075, 0.3),
  easeOutElastic: (t3) => atEdge(t3) ? t3 : elasticOut(t3, 0.075, 0.3),
  easeInOutElastic(t3) {
    const s4 = 0.1125;
    const p2 = 0.45;
    return atEdge(t3) ? t3 : t3 < 0.5 ? 0.5 * elasticIn(t3 * 2, s4, p2) : 0.5 + 0.5 * elasticOut(t3 * 2 - 1, s4, p2);
  },
  easeInBack(t3) {
    const s4 = 1.70158;
    return t3 * t3 * ((s4 + 1) * t3 - s4);
  },
  easeOutBack(t3) {
    const s4 = 1.70158;
    return (t3 -= 1) * t3 * ((s4 + 1) * t3 + s4) + 1;
  },
  easeInOutBack(t3) {
    let s4 = 1.70158;
    if ((t3 /= 0.5) < 1) {
      return 0.5 * (t3 * t3 * (((s4 *= 1.525) + 1) * t3 - s4));
    }
    return 0.5 * ((t3 -= 2) * t3 * (((s4 *= 1.525) + 1) * t3 + s4) + 2);
  },
  easeInBounce: (t3) => 1 - effects.easeOutBounce(1 - t3),
  easeOutBounce(t3) {
    const m4 = 7.5625;
    const d4 = 2.75;
    if (t3 < 1 / d4) {
      return m4 * t3 * t3;
    }
    if (t3 < 2 / d4) {
      return m4 * (t3 -= 1.5 / d4) * t3 + 0.75;
    }
    if (t3 < 2.5 / d4) {
      return m4 * (t3 -= 2.25 / d4) * t3 + 0.9375;
    }
    return m4 * (t3 -= 2.625 / d4) * t3 + 0.984375;
  },
  easeInOutBounce: (t3) => t3 < 0.5 ? effects.easeInBounce(t3 * 2) * 0.5 : effects.easeOutBounce(t3 * 2 - 1) * 0.5 + 0.5
};
/*!
 * @kurkle/color v0.2.1
 * https://github.com/kurkle/color#readme
 * (c) 2022 Jukka Kurkela
 * Released under the MIT License
 */
function round(v) {
  return v + 0.5 | 0;
}
const lim = (v, l, h6) => Math.max(Math.min(v, h6), l);
function p2b(v) {
  return lim(round(v * 2.55), 0, 255);
}
function n2b(v) {
  return lim(round(v * 255), 0, 255);
}
function b2n(v) {
  return lim(round(v / 2.55) / 100, 0, 1);
}
function n2p(v) {
  return lim(round(v * 100), 0, 100);
}
const map$1 = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 };
const hex$2 = [..."0123456789ABCDEF"];
const h1 = (b3) => hex$2[b3 & 15];
const h2 = (b3) => hex$2[(b3 & 240) >> 4] + hex$2[b3 & 15];
const eq = (b3) => (b3 & 240) >> 4 === (b3 & 15);
const isShort = (v) => eq(v.r) && eq(v.g) && eq(v.b) && eq(v.a);
function hexParse(str) {
  var len = str.length;
  var ret;
  if (str[0] === "#") {
    if (len === 4 || len === 5) {
      ret = {
        r: 255 & map$1[str[1]] * 17,
        g: 255 & map$1[str[2]] * 17,
        b: 255 & map$1[str[3]] * 17,
        a: len === 5 ? map$1[str[4]] * 17 : 255
      };
    } else if (len === 7 || len === 9) {
      ret = {
        r: map$1[str[1]] << 4 | map$1[str[2]],
        g: map$1[str[3]] << 4 | map$1[str[4]],
        b: map$1[str[5]] << 4 | map$1[str[6]],
        a: len === 9 ? map$1[str[7]] << 4 | map$1[str[8]] : 255
      };
    }
  }
  return ret;
}
const alpha = (a4, f) => a4 < 255 ? f(a4) : "";
function hexString(v) {
  var f = isShort(v) ? h1 : h2;
  return v ? "#" + f(v.r) + f(v.g) + f(v.b) + alpha(v.a, f) : void 0;
}
const HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function hsl2rgbn(h6, s4, l) {
  const a4 = s4 * Math.min(l, 1 - l);
  const f = (n, k3 = (n + h6 / 30) % 12) => l - a4 * Math.max(Math.min(k3 - 3, 9 - k3, 1), -1);
  return [f(0), f(8), f(4)];
}
function hsv2rgbn(h6, s4, v) {
  const f = (n, k3 = (n + h6 / 60) % 6) => v - v * s4 * Math.max(Math.min(k3, 4 - k3, 1), 0);
  return [f(5), f(3), f(1)];
}
function hwb2rgbn(h6, w3, b3) {
  const rgb2 = hsl2rgbn(h6, 1, 0.5);
  let i3;
  if (w3 + b3 > 1) {
    i3 = 1 / (w3 + b3);
    w3 *= i3;
    b3 *= i3;
  }
  for (i3 = 0; i3 < 3; i3++) {
    rgb2[i3] *= 1 - w3 - b3;
    rgb2[i3] += w3;
  }
  return rgb2;
}
function hueValue(r, g2, b3, d4, max2) {
  if (r === max2) {
    return (g2 - b3) / d4 + (g2 < b3 ? 6 : 0);
  }
  if (g2 === max2) {
    return (b3 - r) / d4 + 2;
  }
  return (r - g2) / d4 + 4;
}
function rgb2hsl(v) {
  const range2 = 255;
  const r = v.r / range2;
  const g2 = v.g / range2;
  const b3 = v.b / range2;
  const max2 = Math.max(r, g2, b3);
  const min2 = Math.min(r, g2, b3);
  const l = (max2 + min2) / 2;
  let h6, s4, d4;
  if (max2 !== min2) {
    d4 = max2 - min2;
    s4 = l > 0.5 ? d4 / (2 - max2 - min2) : d4 / (max2 + min2);
    h6 = hueValue(r, g2, b3, d4, max2);
    h6 = h6 * 60 + 0.5;
  }
  return [h6 | 0, s4 || 0, l];
}
function calln(f, a4, b3, c3) {
  return (Array.isArray(a4) ? f(a4[0], a4[1], a4[2]) : f(a4, b3, c3)).map(n2b);
}
function hsl2rgb(h6, s4, l) {
  return calln(hsl2rgbn, h6, s4, l);
}
function hwb2rgb(h6, w3, b3) {
  return calln(hwb2rgbn, h6, w3, b3);
}
function hsv2rgb(h6, s4, v) {
  return calln(hsv2rgbn, h6, s4, v);
}
function hue(h6) {
  return (h6 % 360 + 360) % 360;
}
function hueParse(str) {
  const m4 = HUE_RE.exec(str);
  let a4 = 255;
  let v;
  if (!m4) {
    return;
  }
  if (m4[5] !== v) {
    a4 = m4[6] ? p2b(+m4[5]) : n2b(+m4[5]);
  }
  const h6 = hue(+m4[2]);
  const p1 = +m4[3] / 100;
  const p2 = +m4[4] / 100;
  if (m4[1] === "hwb") {
    v = hwb2rgb(h6, p1, p2);
  } else if (m4[1] === "hsv") {
    v = hsv2rgb(h6, p1, p2);
  } else {
    v = hsl2rgb(h6, p1, p2);
  }
  return {
    r: v[0],
    g: v[1],
    b: v[2],
    a: a4
  };
}
function rotate(v, deg) {
  var h6 = rgb2hsl(v);
  h6[0] = hue(h6[0] + deg);
  h6 = hsl2rgb(h6);
  v.r = h6[0];
  v.g = h6[1];
  v.b = h6[2];
}
function hslString(v) {
  if (!v) {
    return;
  }
  const a4 = rgb2hsl(v);
  const h6 = a4[0];
  const s4 = n2p(a4[1]);
  const l = n2p(a4[2]);
  return v.a < 255 ? `hsla(${h6}, ${s4}%, ${l}%, ${b2n(v.a)})` : `hsl(${h6}, ${s4}%, ${l}%)`;
}
const map = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
};
const names$1 = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function unpack() {
  const unpacked = {};
  const keys2 = Object.keys(names$1);
  const tkeys = Object.keys(map);
  let i3, j, k3, ok, nk;
  for (i3 = 0; i3 < keys2.length; i3++) {
    ok = nk = keys2[i3];
    for (j = 0; j < tkeys.length; j++) {
      k3 = tkeys[j];
      nk = nk.replace(k3, map[k3]);
    }
    k3 = parseInt(names$1[ok], 16);
    unpacked[nk] = [k3 >> 16 & 255, k3 >> 8 & 255, k3 & 255];
  }
  return unpacked;
}
let names;
function nameParse(str) {
  if (!names) {
    names = unpack();
    names.transparent = [0, 0, 0, 0];
  }
  const a4 = names[str.toLowerCase()];
  return a4 && {
    r: a4[0],
    g: a4[1],
    b: a4[2],
    a: a4.length === 4 ? a4[3] : 255
  };
}
const RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function rgbParse(str) {
  const m4 = RGB_RE.exec(str);
  let a4 = 255;
  let r, g2, b3;
  if (!m4) {
    return;
  }
  if (m4[7] !== r) {
    const v = +m4[7];
    a4 = m4[8] ? p2b(v) : lim(v * 255, 0, 255);
  }
  r = +m4[1];
  g2 = +m4[3];
  b3 = +m4[5];
  r = 255 & (m4[2] ? p2b(r) : lim(r, 0, 255));
  g2 = 255 & (m4[4] ? p2b(g2) : lim(g2, 0, 255));
  b3 = 255 & (m4[6] ? p2b(b3) : lim(b3, 0, 255));
  return {
    r,
    g: g2,
    b: b3,
    a: a4
  };
}
function rgbString(v) {
  return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${b2n(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const to$1 = (v) => v <= 31308e-7 ? v * 12.92 : Math.pow(v, 1 / 2.4) * 1.055 - 0.055;
const from = (v) => v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function interpolate$1(rgb1, rgb2, t3) {
  const r = from(b2n(rgb1.r));
  const g2 = from(b2n(rgb1.g));
  const b3 = from(b2n(rgb1.b));
  return {
    r: n2b(to$1(r + t3 * (from(b2n(rgb2.r)) - r))),
    g: n2b(to$1(g2 + t3 * (from(b2n(rgb2.g)) - g2))),
    b: n2b(to$1(b3 + t3 * (from(b2n(rgb2.b)) - b3))),
    a: rgb1.a + t3 * (rgb2.a - rgb1.a)
  };
}
function modHSL(v, i3, ratio) {
  if (v) {
    let tmp = rgb2hsl(v);
    tmp[i3] = Math.max(0, Math.min(tmp[i3] + tmp[i3] * ratio, i3 === 0 ? 360 : 1));
    tmp = hsl2rgb(tmp);
    v.r = tmp[0];
    v.g = tmp[1];
    v.b = tmp[2];
  }
}
function clone$2(v, proto) {
  return v ? Object.assign(proto || {}, v) : v;
}
function fromObject(input) {
  var v = { r: 0, g: 0, b: 0, a: 255 };
  if (Array.isArray(input)) {
    if (input.length >= 3) {
      v = { r: input[0], g: input[1], b: input[2], a: 255 };
      if (input.length > 3) {
        v.a = n2b(input[3]);
      }
    }
  } else {
    v = clone$2(input, { r: 0, g: 0, b: 0, a: 1 });
    v.a = n2b(v.a);
  }
  return v;
}
function functionParse(str) {
  if (str.charAt(0) === "r") {
    return rgbParse(str);
  }
  return hueParse(str);
}
class Color {
  constructor(input) {
    if (input instanceof Color) {
      return input;
    }
    const type2 = typeof input;
    let v;
    if (type2 === "object") {
      v = fromObject(input);
    } else if (type2 === "string") {
      v = hexParse(input) || nameParse(input) || functionParse(input);
    }
    this._rgb = v;
    this._valid = !!v;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var v = clone$2(this._rgb);
    if (v) {
      v.a = b2n(v.a);
    }
    return v;
  }
  set rgb(obj) {
    this._rgb = fromObject(obj);
  }
  rgbString() {
    return this._valid ? rgbString(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? hexString(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? hslString(this._rgb) : void 0;
  }
  mix(color2, weight) {
    if (color2) {
      const c1 = this.rgb;
      const c23 = color2.rgb;
      let w22;
      const p2 = weight === w22 ? 0.5 : weight;
      const w3 = 2 * p2 - 1;
      const a4 = c1.a - c23.a;
      const w1 = ((w3 * a4 === -1 ? w3 : (w3 + a4) / (1 + w3 * a4)) + 1) / 2;
      w22 = 1 - w1;
      c1.r = 255 & w1 * c1.r + w22 * c23.r + 0.5;
      c1.g = 255 & w1 * c1.g + w22 * c23.g + 0.5;
      c1.b = 255 & w1 * c1.b + w22 * c23.b + 0.5;
      c1.a = p2 * c1.a + (1 - p2) * c23.a;
      this.rgb = c1;
    }
    return this;
  }
  interpolate(color2, t3) {
    if (color2) {
      this._rgb = interpolate$1(this._rgb, color2._rgb, t3);
    }
    return this;
  }
  clone() {
    return new Color(this.rgb);
  }
  alpha(a4) {
    this._rgb.a = n2b(a4);
    return this;
  }
  clearer(ratio) {
    const rgb2 = this._rgb;
    rgb2.a *= 1 - ratio;
    return this;
  }
  greyscale() {
    const rgb2 = this._rgb;
    const val = round(rgb2.r * 0.3 + rgb2.g * 0.59 + rgb2.b * 0.11);
    rgb2.r = rgb2.g = rgb2.b = val;
    return this;
  }
  opaquer(ratio) {
    const rgb2 = this._rgb;
    rgb2.a *= 1 + ratio;
    return this;
  }
  negate() {
    const v = this._rgb;
    v.r = 255 - v.r;
    v.g = 255 - v.g;
    v.b = 255 - v.b;
    return this;
  }
  lighten(ratio) {
    modHSL(this._rgb, 2, ratio);
    return this;
  }
  darken(ratio) {
    modHSL(this._rgb, 2, -ratio);
    return this;
  }
  saturate(ratio) {
    modHSL(this._rgb, 1, ratio);
    return this;
  }
  desaturate(ratio) {
    modHSL(this._rgb, 1, -ratio);
    return this;
  }
  rotate(deg) {
    rotate(this._rgb, deg);
    return this;
  }
}
function index_esm(input) {
  return new Color(input);
}
function isPatternOrGradient(value2) {
  if (value2 && typeof value2 === "object") {
    const type2 = value2.toString();
    return type2 === "[object CanvasPattern]" || type2 === "[object CanvasGradient]";
  }
  return false;
}
function color(value2) {
  return isPatternOrGradient(value2) ? value2 : index_esm(value2);
}
function getHoverColor(value2) {
  return isPatternOrGradient(value2) ? value2 : index_esm(value2).saturate(0.5).darken(0.1).hexString();
}
const overrides = /* @__PURE__ */ Object.create(null);
const descriptors = /* @__PURE__ */ Object.create(null);
function getScope$1(node, key) {
  if (!key) {
    return node;
  }
  const keys2 = key.split(".");
  for (let i3 = 0, n = keys2.length; i3 < n; ++i3) {
    const k3 = keys2[i3];
    node = node[k3] || (node[k3] = /* @__PURE__ */ Object.create(null));
  }
  return node;
}
function set$2(root2, scope, values) {
  if (typeof scope === "string") {
    return merge(getScope$1(root2, scope), values);
  }
  return merge(getScope$1(root2, ""), scope);
}
class Defaults {
  constructor(_descriptors2) {
    this.animation = void 0;
    this.backgroundColor = "rgba(0,0,0,0.1)";
    this.borderColor = "rgba(0,0,0,0.1)";
    this.color = "#666";
    this.datasets = {};
    this.devicePixelRatio = (context) => context.chart.platform.getDevicePixelRatio();
    this.elements = {};
    this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ];
    this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    };
    this.hover = {};
    this.hoverBackgroundColor = (ctx, options) => getHoverColor(options.backgroundColor);
    this.hoverBorderColor = (ctx, options) => getHoverColor(options.borderColor);
    this.hoverColor = (ctx, options) => getHoverColor(options.color);
    this.indexAxis = "x";
    this.interaction = {
      mode: "nearest",
      intersect: true,
      includeInvisible: false
    };
    this.maintainAspectRatio = true;
    this.onHover = null;
    this.onClick = null;
    this.parsing = true;
    this.plugins = {};
    this.responsive = true;
    this.scale = void 0;
    this.scales = {};
    this.showLine = true;
    this.drawActiveElementsOnTop = true;
    this.describe(_descriptors2);
  }
  set(scope, values) {
    return set$2(this, scope, values);
  }
  get(scope) {
    return getScope$1(this, scope);
  }
  describe(scope, values) {
    return set$2(descriptors, scope, values);
  }
  override(scope, values) {
    return set$2(overrides, scope, values);
  }
  route(scope, name2, targetScope, targetName) {
    const scopeObject = getScope$1(this, scope);
    const targetScopeObject = getScope$1(this, targetScope);
    const privateName = "_" + name2;
    Object.defineProperties(scopeObject, {
      [privateName]: {
        value: scopeObject[name2],
        writable: true
      },
      [name2]: {
        enumerable: true,
        get() {
          const local = this[privateName];
          const target2 = targetScopeObject[targetName];
          if (isObject$3(local)) {
            return Object.assign({}, target2, local);
          }
          return valueOrDefault(local, target2);
        },
        set(value2) {
          this[privateName] = value2;
        }
      }
    });
  }
}
var defaults$1 = new Defaults({
  _scriptable: (name2) => !name2.startsWith("on"),
  _indexable: (name2) => name2 !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: false,
    _indexable: false
  }
});
function toFontString(font) {
  if (!font || isNullOrUndef(font.size) || isNullOrUndef(font.family)) {
    return null;
  }
  return (font.style ? font.style + " " : "") + (font.weight ? font.weight + " " : "") + font.size + "px " + font.family;
}
function _measureText(ctx, data, gc, longest, string) {
  let textWidth = data[string];
  if (!textWidth) {
    textWidth = data[string] = ctx.measureText(string).width;
    gc.push(string);
  }
  if (textWidth > longest) {
    longest = textWidth;
  }
  return longest;
}
function _longestText(ctx, font, arrayOfThings, cache) {
  cache = cache || {};
  let data = cache.data = cache.data || {};
  let gc = cache.garbageCollect = cache.garbageCollect || [];
  if (cache.font !== font) {
    data = cache.data = {};
    gc = cache.garbageCollect = [];
    cache.font = font;
  }
  ctx.save();
  ctx.font = font;
  let longest = 0;
  const ilen = arrayOfThings.length;
  let i3, j, jlen, thing, nestedThing;
  for (i3 = 0; i3 < ilen; i3++) {
    thing = arrayOfThings[i3];
    if (thing !== void 0 && thing !== null && isArray(thing) !== true) {
      longest = _measureText(ctx, data, gc, longest, thing);
    } else if (isArray(thing)) {
      for (j = 0, jlen = thing.length; j < jlen; j++) {
        nestedThing = thing[j];
        if (nestedThing !== void 0 && nestedThing !== null && !isArray(nestedThing)) {
          longest = _measureText(ctx, data, gc, longest, nestedThing);
        }
      }
    }
  }
  ctx.restore();
  const gcLen = gc.length / 2;
  if (gcLen > arrayOfThings.length) {
    for (i3 = 0; i3 < gcLen; i3++) {
      delete data[gc[i3]];
    }
    gc.splice(0, gcLen);
  }
  return longest;
}
function _alignPixel(chart, pixel, width) {
  const devicePixelRatio = chart.currentDevicePixelRatio;
  const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
  return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
function clearCanvas(canvas, ctx) {
  ctx = ctx || canvas.getContext("2d");
  ctx.save();
  ctx.resetTransform();
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.restore();
}
function drawPoint(ctx, options, x3, y4) {
  drawPointLegend(ctx, options, x3, y4);
}
function drawPointLegend(ctx, options, x3, y4, w3) {
  let type2, xOffset, yOffset, size2, cornerRadius, width;
  const style = options.pointStyle;
  const rotation = options.rotation;
  const radius2 = options.radius;
  let rad = (rotation || 0) * RAD_PER_DEG;
  if (style && typeof style === "object") {
    type2 = style.toString();
    if (type2 === "[object HTMLImageElement]" || type2 === "[object HTMLCanvasElement]") {
      ctx.save();
      ctx.translate(x3, y4);
      ctx.rotate(rad);
      ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
      ctx.restore();
      return;
    }
  }
  if (isNaN(radius2) || radius2 <= 0) {
    return;
  }
  ctx.beginPath();
  switch (style) {
    default:
      {
        ctx.arc(x3, y4, radius2, 0, TAU);
      }
      ctx.closePath();
      break;
    case "triangle":
      ctx.moveTo(x3 + Math.sin(rad) * radius2, y4 - Math.cos(rad) * radius2);
      rad += TWO_THIRDS_PI;
      ctx.lineTo(x3 + Math.sin(rad) * radius2, y4 - Math.cos(rad) * radius2);
      rad += TWO_THIRDS_PI;
      ctx.lineTo(x3 + Math.sin(rad) * radius2, y4 - Math.cos(rad) * radius2);
      ctx.closePath();
      break;
    case "rectRounded":
      cornerRadius = radius2 * 0.516;
      size2 = radius2 - cornerRadius;
      xOffset = Math.cos(rad + QUARTER_PI) * size2;
      yOffset = Math.sin(rad + QUARTER_PI) * size2;
      ctx.arc(x3 - xOffset, y4 - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
      ctx.arc(x3 + yOffset, y4 - xOffset, cornerRadius, rad - HALF_PI, rad);
      ctx.arc(x3 + xOffset, y4 + yOffset, cornerRadius, rad, rad + HALF_PI);
      ctx.arc(x3 - yOffset, y4 + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
      ctx.closePath();
      break;
    case "rect":
      if (!rotation) {
        size2 = Math.SQRT1_2 * radius2;
        width = size2;
        ctx.rect(x3 - width, y4 - size2, 2 * width, 2 * size2);
        break;
      }
      rad += QUARTER_PI;
    case "rectRot":
      xOffset = Math.cos(rad) * radius2;
      yOffset = Math.sin(rad) * radius2;
      ctx.moveTo(x3 - xOffset, y4 - yOffset);
      ctx.lineTo(x3 + yOffset, y4 - xOffset);
      ctx.lineTo(x3 + xOffset, y4 + yOffset);
      ctx.lineTo(x3 - yOffset, y4 + xOffset);
      ctx.closePath();
      break;
    case "crossRot":
      rad += QUARTER_PI;
    case "cross":
      xOffset = Math.cos(rad) * radius2;
      yOffset = Math.sin(rad) * radius2;
      ctx.moveTo(x3 - xOffset, y4 - yOffset);
      ctx.lineTo(x3 + xOffset, y4 + yOffset);
      ctx.moveTo(x3 + yOffset, y4 - xOffset);
      ctx.lineTo(x3 - yOffset, y4 + xOffset);
      break;
    case "star":
      xOffset = Math.cos(rad) * radius2;
      yOffset = Math.sin(rad) * radius2;
      ctx.moveTo(x3 - xOffset, y4 - yOffset);
      ctx.lineTo(x3 + xOffset, y4 + yOffset);
      ctx.moveTo(x3 + yOffset, y4 - xOffset);
      ctx.lineTo(x3 - yOffset, y4 + xOffset);
      rad += QUARTER_PI;
      xOffset = Math.cos(rad) * radius2;
      yOffset = Math.sin(rad) * radius2;
      ctx.moveTo(x3 - xOffset, y4 - yOffset);
      ctx.lineTo(x3 + xOffset, y4 + yOffset);
      ctx.moveTo(x3 + yOffset, y4 - xOffset);
      ctx.lineTo(x3 - yOffset, y4 + xOffset);
      break;
    case "line":
      xOffset = Math.cos(rad) * radius2;
      yOffset = Math.sin(rad) * radius2;
      ctx.moveTo(x3 - xOffset, y4 - yOffset);
      ctx.lineTo(x3 + xOffset, y4 + yOffset);
      break;
    case "dash":
      ctx.moveTo(x3, y4);
      ctx.lineTo(x3 + Math.cos(rad) * radius2, y4 + Math.sin(rad) * radius2);
      break;
  }
  ctx.fill();
  if (options.borderWidth > 0) {
    ctx.stroke();
  }
}
function _isPointInArea(point, area, margin) {
  margin = margin || 0.5;
  return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function clipArea(ctx, area) {
  ctx.save();
  ctx.beginPath();
  ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
  ctx.clip();
}
function unclipArea(ctx) {
  ctx.restore();
}
function _steppedLineTo(ctx, previous, target2, flip, mode) {
  if (!previous) {
    return ctx.lineTo(target2.x, target2.y);
  }
  if (mode === "middle") {
    const midpoint = (previous.x + target2.x) / 2;
    ctx.lineTo(midpoint, previous.y);
    ctx.lineTo(midpoint, target2.y);
  } else if (mode === "after" !== !!flip) {
    ctx.lineTo(previous.x, target2.y);
  } else {
    ctx.lineTo(target2.x, previous.y);
  }
  ctx.lineTo(target2.x, target2.y);
}
function _bezierCurveTo(ctx, previous, target2, flip) {
  if (!previous) {
    return ctx.lineTo(target2.x, target2.y);
  }
  ctx.bezierCurveTo(
    flip ? previous.cp1x : previous.cp2x,
    flip ? previous.cp1y : previous.cp2y,
    flip ? target2.cp2x : target2.cp1x,
    flip ? target2.cp2y : target2.cp1y,
    target2.x,
    target2.y
  );
}
function renderText(ctx, text2, x3, y4, font, opts = {}) {
  const lines = isArray(text2) ? text2 : [text2];
  const stroke = opts.strokeWidth > 0 && opts.strokeColor !== "";
  let i3, line;
  ctx.save();
  ctx.font = font.string;
  setRenderOpts(ctx, opts);
  for (i3 = 0; i3 < lines.length; ++i3) {
    line = lines[i3];
    if (stroke) {
      if (opts.strokeColor) {
        ctx.strokeStyle = opts.strokeColor;
      }
      if (!isNullOrUndef(opts.strokeWidth)) {
        ctx.lineWidth = opts.strokeWidth;
      }
      ctx.strokeText(line, x3, y4, opts.maxWidth);
    }
    ctx.fillText(line, x3, y4, opts.maxWidth);
    decorateText(ctx, x3, y4, line, opts);
    y4 += font.lineHeight;
  }
  ctx.restore();
}
function setRenderOpts(ctx, opts) {
  if (opts.translation) {
    ctx.translate(opts.translation[0], opts.translation[1]);
  }
  if (!isNullOrUndef(opts.rotation)) {
    ctx.rotate(opts.rotation);
  }
  if (opts.color) {
    ctx.fillStyle = opts.color;
  }
  if (opts.textAlign) {
    ctx.textAlign = opts.textAlign;
  }
  if (opts.textBaseline) {
    ctx.textBaseline = opts.textBaseline;
  }
}
function decorateText(ctx, x3, y4, line, opts) {
  if (opts.strikethrough || opts.underline) {
    const metrics = ctx.measureText(line);
    const left = x3 - metrics.actualBoundingBoxLeft;
    const right = x3 + metrics.actualBoundingBoxRight;
    const top = y4 - metrics.actualBoundingBoxAscent;
    const bottom = y4 + metrics.actualBoundingBoxDescent;
    const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
    ctx.strokeStyle = ctx.fillStyle;
    ctx.beginPath();
    ctx.lineWidth = opts.decorationWidth || 2;
    ctx.moveTo(left, yDecoration);
    ctx.lineTo(right, yDecoration);
    ctx.stroke();
  }
}
function addRoundedRectPath(ctx, rect) {
  const { x: x3, y: y4, w: w3, h: h6, radius: radius2 } = rect;
  ctx.arc(x3 + radius2.topLeft, y4 + radius2.topLeft, radius2.topLeft, -HALF_PI, PI, true);
  ctx.lineTo(x3, y4 + h6 - radius2.bottomLeft);
  ctx.arc(x3 + radius2.bottomLeft, y4 + h6 - radius2.bottomLeft, radius2.bottomLeft, PI, HALF_PI, true);
  ctx.lineTo(x3 + w3 - radius2.bottomRight, y4 + h6);
  ctx.arc(x3 + w3 - radius2.bottomRight, y4 + h6 - radius2.bottomRight, radius2.bottomRight, HALF_PI, 0, true);
  ctx.lineTo(x3 + w3, y4 + radius2.topRight);
  ctx.arc(x3 + w3 - radius2.topRight, y4 + radius2.topRight, radius2.topRight, 0, -HALF_PI, true);
  ctx.lineTo(x3 + radius2.topLeft, y4);
}
const LINE_HEIGHT = new RegExp(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
const FONT_STYLE = new RegExp(/^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/);
function toLineHeight(value2, size2) {
  const matches = ("" + value2).match(LINE_HEIGHT);
  if (!matches || matches[1] === "normal") {
    return size2 * 1.2;
  }
  value2 = +matches[2];
  switch (matches[3]) {
    case "px":
      return value2;
    case "%":
      value2 /= 100;
      break;
  }
  return size2 * value2;
}
const numberOrZero = (v) => +v || 0;
function _readValueToProps(value2, props4) {
  const ret = {};
  const objProps = isObject$3(props4);
  const keys2 = objProps ? Object.keys(props4) : props4;
  const read2 = isObject$3(value2) ? objProps ? (prop) => valueOrDefault(value2[prop], value2[props4[prop]]) : (prop) => value2[prop] : () => value2;
  for (const prop of keys2) {
    ret[prop] = numberOrZero(read2(prop));
  }
  return ret;
}
function toTRBL(value2) {
  return _readValueToProps(value2, { top: "y", right: "x", bottom: "y", left: "x" });
}
function toTRBLCorners(value2) {
  return _readValueToProps(value2, ["topLeft", "topRight", "bottomLeft", "bottomRight"]);
}
function toPadding(value2) {
  const obj = toTRBL(value2);
  obj.width = obj.left + obj.right;
  obj.height = obj.top + obj.bottom;
  return obj;
}
function toFont(options, fallback) {
  options = options || {};
  fallback = fallback || defaults$1.font;
  let size2 = valueOrDefault(options.size, fallback.size);
  if (typeof size2 === "string") {
    size2 = parseInt(size2, 10);
  }
  let style = valueOrDefault(options.style, fallback.style);
  if (style && !("" + style).match(FONT_STYLE)) {
    console.warn('Invalid font style specified: "' + style + '"');
    style = "";
  }
  const font = {
    family: valueOrDefault(options.family, fallback.family),
    lineHeight: toLineHeight(valueOrDefault(options.lineHeight, fallback.lineHeight), size2),
    size: size2,
    style,
    weight: valueOrDefault(options.weight, fallback.weight),
    string: ""
  };
  font.string = toFontString(font);
  return font;
}
function resolve(inputs, context, index2, info) {
  let i3, ilen, value2;
  for (i3 = 0, ilen = inputs.length; i3 < ilen; ++i3) {
    value2 = inputs[i3];
    if (value2 === void 0) {
      continue;
    }
    if (value2 !== void 0) {
      return value2;
    }
  }
}
function _addGrace(minmax, grace, beginAtZero) {
  const { min: min2, max: max2 } = minmax;
  const change = toDimension(grace, (max2 - min2) / 2);
  const keepZero = (value2, add2) => beginAtZero && value2 === 0 ? 0 : value2 + add2;
  return {
    min: keepZero(min2, -Math.abs(change)),
    max: keepZero(max2, change)
  };
}
function createContext(parentContext, context) {
  return Object.assign(Object.create(parentContext), context);
}
function _createResolver(scopes, prefixes2 = [""], rootScopes = scopes, fallback, getTarget = () => scopes[0]) {
  if (!defined(fallback)) {
    fallback = _resolve("_fallback", scopes);
  }
  const cache = {
    [Symbol.toStringTag]: "Object",
    _cacheable: true,
    _scopes: scopes,
    _rootScopes: rootScopes,
    _fallback: fallback,
    _getTarget: getTarget,
    override: (scope) => _createResolver([scope, ...scopes], prefixes2, rootScopes, fallback)
  };
  return new Proxy(cache, {
    deleteProperty(target2, prop) {
      delete target2[prop];
      delete target2._keys;
      delete scopes[0][prop];
      return true;
    },
    get(target2, prop) {
      return _cached(
        target2,
        prop,
        () => _resolveWithPrefixes(prop, prefixes2, scopes, target2)
      );
    },
    getOwnPropertyDescriptor(target2, prop) {
      return Reflect.getOwnPropertyDescriptor(target2._scopes[0], prop);
    },
    getPrototypeOf() {
      return Reflect.getPrototypeOf(scopes[0]);
    },
    has(target2, prop) {
      return getKeysFromAllScopes(target2).includes(prop);
    },
    ownKeys(target2) {
      return getKeysFromAllScopes(target2);
    },
    set(target2, prop, value2) {
      const storage3 = target2._storage || (target2._storage = getTarget());
      target2[prop] = storage3[prop] = value2;
      delete target2._keys;
      return true;
    }
  });
}
function _attachContext(proxy, context, subProxy, descriptorDefaults) {
  const cache = {
    _cacheable: false,
    _proxy: proxy,
    _context: context,
    _subProxy: subProxy,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: _descriptors(proxy, descriptorDefaults),
    setContext: (ctx) => _attachContext(proxy, ctx, subProxy, descriptorDefaults),
    override: (scope) => _attachContext(proxy.override(scope), context, subProxy, descriptorDefaults)
  };
  return new Proxy(cache, {
    deleteProperty(target2, prop) {
      delete target2[prop];
      delete proxy[prop];
      return true;
    },
    get(target2, prop, receiver) {
      return _cached(
        target2,
        prop,
        () => _resolveWithContext(target2, prop, receiver)
      );
    },
    getOwnPropertyDescriptor(target2, prop) {
      return target2._descriptors.allKeys ? Reflect.has(proxy, prop) ? { enumerable: true, configurable: true } : void 0 : Reflect.getOwnPropertyDescriptor(proxy, prop);
    },
    getPrototypeOf() {
      return Reflect.getPrototypeOf(proxy);
    },
    has(target2, prop) {
      return Reflect.has(proxy, prop);
    },
    ownKeys() {
      return Reflect.ownKeys(proxy);
    },
    set(target2, prop, value2) {
      proxy[prop] = value2;
      delete target2[prop];
      return true;
    }
  });
}
function _descriptors(proxy, defaults2 = { scriptable: true, indexable: true }) {
  const { _scriptable = defaults2.scriptable, _indexable = defaults2.indexable, _allKeys = defaults2.allKeys } = proxy;
  return {
    allKeys: _allKeys,
    scriptable: _scriptable,
    indexable: _indexable,
    isScriptable: isFunction(_scriptable) ? _scriptable : () => _scriptable,
    isIndexable: isFunction(_indexable) ? _indexable : () => _indexable
  };
}
const readKey = (prefix, name2) => prefix ? prefix + _capitalize(name2) : name2;
const needsSubResolver = (prop, value2) => isObject$3(value2) && prop !== "adapters" && (Object.getPrototypeOf(value2) === null || value2.constructor === Object);
function _cached(target2, prop, resolve2) {
  if (Object.prototype.hasOwnProperty.call(target2, prop)) {
    return target2[prop];
  }
  const value2 = resolve2();
  target2[prop] = value2;
  return value2;
}
function _resolveWithContext(target2, prop, receiver) {
  const { _proxy, _context, _subProxy, _descriptors: descriptors2 } = target2;
  let value2 = _proxy[prop];
  if (isFunction(value2) && descriptors2.isScriptable(prop)) {
    value2 = _resolveScriptable(prop, value2, target2, receiver);
  }
  if (isArray(value2) && value2.length) {
    value2 = _resolveArray(prop, value2, target2, descriptors2.isIndexable);
  }
  if (needsSubResolver(prop, value2)) {
    value2 = _attachContext(value2, _context, _subProxy && _subProxy[prop], descriptors2);
  }
  return value2;
}
function _resolveScriptable(prop, value2, target2, receiver) {
  const { _proxy, _context, _subProxy, _stack } = target2;
  if (_stack.has(prop)) {
    throw new Error("Recursion detected: " + Array.from(_stack).join("->") + "->" + prop);
  }
  _stack.add(prop);
  value2 = value2(_context, _subProxy || receiver);
  _stack.delete(prop);
  if (needsSubResolver(prop, value2)) {
    value2 = createSubResolver(_proxy._scopes, _proxy, prop, value2);
  }
  return value2;
}
function _resolveArray(prop, value2, target2, isIndexable) {
  const { _proxy, _context, _subProxy, _descriptors: descriptors2 } = target2;
  if (defined(_context.index) && isIndexable(prop)) {
    value2 = value2[_context.index % value2.length];
  } else if (isObject$3(value2[0])) {
    const arr = value2;
    const scopes = _proxy._scopes.filter((s4) => s4 !== arr);
    value2 = [];
    for (const item of arr) {
      const resolver = createSubResolver(scopes, _proxy, prop, item);
      value2.push(_attachContext(resolver, _context, _subProxy && _subProxy[prop], descriptors2));
    }
  }
  return value2;
}
function resolveFallback(fallback, prop, value2) {
  return isFunction(fallback) ? fallback(prop, value2) : fallback;
}
const getScope = (key, parent) => key === true ? parent : typeof key === "string" ? resolveObjectKey(parent, key) : void 0;
function addScopes(set2, parentScopes, key, parentFallback, value2) {
  for (const parent of parentScopes) {
    const scope = getScope(key, parent);
    if (scope) {
      set2.add(scope);
      const fallback = resolveFallback(scope._fallback, key, value2);
      if (defined(fallback) && fallback !== key && fallback !== parentFallback) {
        return fallback;
      }
    } else if (scope === false && defined(parentFallback) && key !== parentFallback) {
      return null;
    }
  }
  return false;
}
function createSubResolver(parentScopes, resolver, prop, value2) {
  const rootScopes = resolver._rootScopes;
  const fallback = resolveFallback(resolver._fallback, prop, value2);
  const allScopes = [...parentScopes, ...rootScopes];
  const set2 = /* @__PURE__ */ new Set();
  set2.add(value2);
  let key = addScopesFromKey(set2, allScopes, prop, fallback || prop, value2);
  if (key === null) {
    return false;
  }
  if (defined(fallback) && fallback !== prop) {
    key = addScopesFromKey(set2, allScopes, fallback, key, value2);
    if (key === null) {
      return false;
    }
  }
  return _createResolver(
    Array.from(set2),
    [""],
    rootScopes,
    fallback,
    () => subGetTarget(resolver, prop, value2)
  );
}
function addScopesFromKey(set2, allScopes, key, fallback, item) {
  while (key) {
    key = addScopes(set2, allScopes, key, fallback, item);
  }
  return key;
}
function subGetTarget(resolver, prop, value2) {
  const parent = resolver._getTarget();
  if (!(prop in parent)) {
    parent[prop] = {};
  }
  const target2 = parent[prop];
  if (isArray(target2) && isObject$3(value2)) {
    return value2;
  }
  return target2;
}
function _resolveWithPrefixes(prop, prefixes2, scopes, proxy) {
  let value2;
  for (const prefix of prefixes2) {
    value2 = _resolve(readKey(prefix, prop), scopes);
    if (defined(value2)) {
      return needsSubResolver(prop, value2) ? createSubResolver(scopes, proxy, prop, value2) : value2;
    }
  }
}
function _resolve(key, scopes) {
  for (const scope of scopes) {
    if (!scope) {
      continue;
    }
    const value2 = scope[key];
    if (defined(value2)) {
      return value2;
    }
  }
}
function getKeysFromAllScopes(target2) {
  let keys2 = target2._keys;
  if (!keys2) {
    keys2 = target2._keys = resolveKeysFromAllScopes(target2._scopes);
  }
  return keys2;
}
function resolveKeysFromAllScopes(scopes) {
  const set2 = /* @__PURE__ */ new Set();
  for (const scope of scopes) {
    for (const key of Object.keys(scope).filter((k3) => !k3.startsWith("_"))) {
      set2.add(key);
    }
  }
  return Array.from(set2);
}
function _parseObjectDataRadialScale(meta, data, start, count) {
  const { iScale } = meta;
  const { key = "r" } = this._parsing;
  const parsed = new Array(count);
  let i3, ilen, index2, item;
  for (i3 = 0, ilen = count; i3 < ilen; ++i3) {
    index2 = i3 + start;
    item = data[index2];
    parsed[i3] = {
      r: iScale.parse(resolveObjectKey(item, key), index2)
    };
  }
  return parsed;
}
const EPSILON$1 = Number.EPSILON || 1e-14;
const getPoint = (points, i3) => i3 < points.length && !points[i3].skip && points[i3];
const getValueAxis = (indexAxis) => indexAxis === "x" ? "y" : "x";
function splineCurve(firstPoint, middlePoint, afterPoint, t3) {
  const previous = firstPoint.skip ? middlePoint : firstPoint;
  const current = middlePoint;
  const next = afterPoint.skip ? middlePoint : afterPoint;
  const d01 = distanceBetweenPoints(current, previous);
  const d12 = distanceBetweenPoints(next, current);
  let s01 = d01 / (d01 + d12);
  let s12 = d12 / (d01 + d12);
  s01 = isNaN(s01) ? 0 : s01;
  s12 = isNaN(s12) ? 0 : s12;
  const fa = t3 * s01;
  const fb = t3 * s12;
  return {
    previous: {
      x: current.x - fa * (next.x - previous.x),
      y: current.y - fa * (next.y - previous.y)
    },
    next: {
      x: current.x + fb * (next.x - previous.x),
      y: current.y + fb * (next.y - previous.y)
    }
  };
}
function monotoneAdjust(points, deltaK, mK) {
  const pointsLen = points.length;
  let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
  let pointAfter = getPoint(points, 0);
  for (let i3 = 0; i3 < pointsLen - 1; ++i3) {
    pointCurrent = pointAfter;
    pointAfter = getPoint(points, i3 + 1);
    if (!pointCurrent || !pointAfter) {
      continue;
    }
    if (almostEquals(deltaK[i3], 0, EPSILON$1)) {
      mK[i3] = mK[i3 + 1] = 0;
      continue;
    }
    alphaK = mK[i3] / deltaK[i3];
    betaK = mK[i3 + 1] / deltaK[i3];
    squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
    if (squaredMagnitude <= 9) {
      continue;
    }
    tauK = 3 / Math.sqrt(squaredMagnitude);
    mK[i3] = alphaK * tauK * deltaK[i3];
    mK[i3 + 1] = betaK * tauK * deltaK[i3];
  }
}
function monotoneCompute(points, mK, indexAxis = "x") {
  const valueAxis = getValueAxis(indexAxis);
  const pointsLen = points.length;
  let delta, pointBefore, pointCurrent;
  let pointAfter = getPoint(points, 0);
  for (let i3 = 0; i3 < pointsLen; ++i3) {
    pointBefore = pointCurrent;
    pointCurrent = pointAfter;
    pointAfter = getPoint(points, i3 + 1);
    if (!pointCurrent) {
      continue;
    }
    const iPixel = pointCurrent[indexAxis];
    const vPixel = pointCurrent[valueAxis];
    if (pointBefore) {
      delta = (iPixel - pointBefore[indexAxis]) / 3;
      pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
      pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i3];
    }
    if (pointAfter) {
      delta = (pointAfter[indexAxis] - iPixel) / 3;
      pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
      pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i3];
    }
  }
}
function splineCurveMonotone(points, indexAxis = "x") {
  const valueAxis = getValueAxis(indexAxis);
  const pointsLen = points.length;
  const deltaK = Array(pointsLen).fill(0);
  const mK = Array(pointsLen);
  let i3, pointBefore, pointCurrent;
  let pointAfter = getPoint(points, 0);
  for (i3 = 0; i3 < pointsLen; ++i3) {
    pointBefore = pointCurrent;
    pointCurrent = pointAfter;
    pointAfter = getPoint(points, i3 + 1);
    if (!pointCurrent) {
      continue;
    }
    if (pointAfter) {
      const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
      deltaK[i3] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
    }
    mK[i3] = !pointBefore ? deltaK[i3] : !pointAfter ? deltaK[i3 - 1] : sign(deltaK[i3 - 1]) !== sign(deltaK[i3]) ? 0 : (deltaK[i3 - 1] + deltaK[i3]) / 2;
  }
  monotoneAdjust(points, deltaK, mK);
  monotoneCompute(points, mK, indexAxis);
}
function capControlPoint(pt2, min2, max2) {
  return Math.max(Math.min(pt2, max2), min2);
}
function capBezierPoints(points, area) {
  let i3, ilen, point, inArea, inAreaPrev;
  let inAreaNext = _isPointInArea(points[0], area);
  for (i3 = 0, ilen = points.length; i3 < ilen; ++i3) {
    inAreaPrev = inArea;
    inArea = inAreaNext;
    inAreaNext = i3 < ilen - 1 && _isPointInArea(points[i3 + 1], area);
    if (!inArea) {
      continue;
    }
    point = points[i3];
    if (inAreaPrev) {
      point.cp1x = capControlPoint(point.cp1x, area.left, area.right);
      point.cp1y = capControlPoint(point.cp1y, area.top, area.bottom);
    }
    if (inAreaNext) {
      point.cp2x = capControlPoint(point.cp2x, area.left, area.right);
      point.cp2y = capControlPoint(point.cp2y, area.top, area.bottom);
    }
  }
}
function _updateBezierControlPoints(points, options, area, loop, indexAxis) {
  let i3, ilen, point, controlPoints;
  if (options.spanGaps) {
    points = points.filter((pt2) => !pt2.skip);
  }
  if (options.cubicInterpolationMode === "monotone") {
    splineCurveMonotone(points, indexAxis);
  } else {
    let prev = loop ? points[points.length - 1] : points[0];
    for (i3 = 0, ilen = points.length; i3 < ilen; ++i3) {
      point = points[i3];
      controlPoints = splineCurve(
        prev,
        point,
        points[Math.min(i3 + 1, ilen - (loop ? 0 : 1)) % ilen],
        options.tension
      );
      point.cp1x = controlPoints.previous.x;
      point.cp1y = controlPoints.previous.y;
      point.cp2x = controlPoints.next.x;
      point.cp2y = controlPoints.next.y;
      prev = point;
    }
  }
  if (options.capBezierPoints) {
    capBezierPoints(points, area);
  }
}
function _isDomSupported() {
  return typeof window !== "undefined" && typeof document !== "undefined";
}
function _getParentNode(domNode) {
  let parent = domNode.parentNode;
  if (parent && parent.toString() === "[object ShadowRoot]") {
    parent = parent.host;
  }
  return parent;
}
function parseMaxStyle(styleValue, node, parentProperty) {
  let valueInPixels;
  if (typeof styleValue === "string") {
    valueInPixels = parseInt(styleValue, 10);
    if (styleValue.indexOf("%") !== -1) {
      valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    }
  } else {
    valueInPixels = styleValue;
  }
  return valueInPixels;
}
const getComputedStyle$1 = (element) => window.getComputedStyle(element, null);
function getStyle(el, property) {
  return getComputedStyle$1(el).getPropertyValue(property);
}
const positions = ["top", "right", "bottom", "left"];
function getPositionedStyle(styles, style, suffix) {
  const result = {};
  suffix = suffix ? "-" + suffix : "";
  for (let i3 = 0; i3 < 4; i3++) {
    const pos = positions[i3];
    result[pos] = parseFloat(styles[style + "-" + pos + suffix]) || 0;
  }
  result.width = result.left + result.right;
  result.height = result.top + result.bottom;
  return result;
}
const useOffsetPos = (x3, y4, target2) => (x3 > 0 || y4 > 0) && (!target2 || !target2.shadowRoot);
function getCanvasPosition(e3, canvas) {
  const touches = e3.touches;
  const source = touches && touches.length ? touches[0] : e3;
  const { offsetX, offsetY } = source;
  let box = false;
  let x3, y4;
  if (useOffsetPos(offsetX, offsetY, e3.target)) {
    x3 = offsetX;
    y4 = offsetY;
  } else {
    const rect = canvas.getBoundingClientRect();
    x3 = source.clientX - rect.left;
    y4 = source.clientY - rect.top;
    box = true;
  }
  return { x: x3, y: y4, box };
}
function getRelativePosition(evt, chart) {
  if ("native" in evt) {
    return evt;
  }
  const { canvas, currentDevicePixelRatio } = chart;
  const style = getComputedStyle$1(canvas);
  const borderBox = style.boxSizing === "border-box";
  const paddings = getPositionedStyle(style, "padding");
  const borders = getPositionedStyle(style, "border", "width");
  const { x: x3, y: y4, box } = getCanvasPosition(evt, canvas);
  const xOffset = paddings.left + (box && borders.left);
  const yOffset = paddings.top + (box && borders.top);
  let { width, height: height2 } = chart;
  if (borderBox) {
    width -= paddings.width + borders.width;
    height2 -= paddings.height + borders.height;
  }
  return {
    x: Math.round((x3 - xOffset) / width * canvas.width / currentDevicePixelRatio),
    y: Math.round((y4 - yOffset) / height2 * canvas.height / currentDevicePixelRatio)
  };
}
function getContainerSize(canvas, width, height2) {
  let maxWidth, maxHeight;
  if (width === void 0 || height2 === void 0) {
    const container = _getParentNode(canvas);
    if (!container) {
      width = canvas.clientWidth;
      height2 = canvas.clientHeight;
    } else {
      const rect = container.getBoundingClientRect();
      const containerStyle = getComputedStyle$1(container);
      const containerBorder = getPositionedStyle(containerStyle, "border", "width");
      const containerPadding = getPositionedStyle(containerStyle, "padding");
      width = rect.width - containerPadding.width - containerBorder.width;
      height2 = rect.height - containerPadding.height - containerBorder.height;
      maxWidth = parseMaxStyle(containerStyle.maxWidth, container, "clientWidth");
      maxHeight = parseMaxStyle(containerStyle.maxHeight, container, "clientHeight");
    }
  }
  return {
    width,
    height: height2,
    maxWidth: maxWidth || INFINITY,
    maxHeight: maxHeight || INFINITY
  };
}
const round1 = (v) => Math.round(v * 10) / 10;
function getMaximumSize(canvas, bbWidth, bbHeight, aspectRatio) {
  const style = getComputedStyle$1(canvas);
  const margins2 = getPositionedStyle(style, "margin");
  const maxWidth = parseMaxStyle(style.maxWidth, canvas, "clientWidth") || INFINITY;
  const maxHeight = parseMaxStyle(style.maxHeight, canvas, "clientHeight") || INFINITY;
  const containerSize = getContainerSize(canvas, bbWidth, bbHeight);
  let { width, height: height2 } = containerSize;
  if (style.boxSizing === "content-box") {
    const borders = getPositionedStyle(style, "border", "width");
    const paddings = getPositionedStyle(style, "padding");
    width -= paddings.width + borders.width;
    height2 -= paddings.height + borders.height;
  }
  width = Math.max(0, width - margins2.width);
  height2 = Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height2 - margins2.height);
  width = round1(Math.min(width, maxWidth, containerSize.maxWidth));
  height2 = round1(Math.min(height2, maxHeight, containerSize.maxHeight));
  if (width && !height2) {
    height2 = round1(width / 2);
  }
  return {
    width,
    height: height2
  };
}
function retinaScale(chart, forceRatio, forceStyle) {
  const pixelRatio = forceRatio || 1;
  const deviceHeight = Math.floor(chart.height * pixelRatio);
  const deviceWidth = Math.floor(chart.width * pixelRatio);
  chart.height = deviceHeight / pixelRatio;
  chart.width = deviceWidth / pixelRatio;
  const canvas = chart.canvas;
  if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
    canvas.style.height = `${chart.height}px`;
    canvas.style.width = `${chart.width}px`;
  }
  if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
    chart.currentDevicePixelRatio = pixelRatio;
    canvas.height = deviceHeight;
    canvas.width = deviceWidth;
    chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    return true;
  }
  return false;
}
const supportsEventListenerOptions = function() {
  let passiveSupported = false;
  try {
    const options = {
      get passive() {
        passiveSupported = true;
        return false;
      }
    };
    window.addEventListener("test", null, options);
    window.removeEventListener("test", null, options);
  } catch (e3) {
  }
  return passiveSupported;
}();
function readUsedSize(element, property) {
  const value2 = getStyle(element, property);
  const matches = value2 && value2.match(/^(\d+)(\.\d+)?px$/);
  return matches ? +matches[1] : void 0;
}
function _pointInLine(p1, p2, t3, mode) {
  return {
    x: p1.x + t3 * (p2.x - p1.x),
    y: p1.y + t3 * (p2.y - p1.y)
  };
}
function _steppedInterpolation(p1, p2, t3, mode) {
  return {
    x: p1.x + t3 * (p2.x - p1.x),
    y: mode === "middle" ? t3 < 0.5 ? p1.y : p2.y : mode === "after" ? t3 < 1 ? p1.y : p2.y : t3 > 0 ? p2.y : p1.y
  };
}
function _bezierInterpolation(p1, p2, t3, mode) {
  const cp1 = { x: p1.cp2x, y: p1.cp2y };
  const cp2 = { x: p2.cp1x, y: p2.cp1y };
  const a4 = _pointInLine(p1, cp1, t3);
  const b3 = _pointInLine(cp1, cp2, t3);
  const c3 = _pointInLine(cp2, p2, t3);
  const d4 = _pointInLine(a4, b3, t3);
  const e3 = _pointInLine(b3, c3, t3);
  return _pointInLine(d4, e3, t3);
}
const intlCache = /* @__PURE__ */ new Map();
function getNumberFormat(locale2, options) {
  options = options || {};
  const cacheKey = locale2 + JSON.stringify(options);
  let formatter2 = intlCache.get(cacheKey);
  if (!formatter2) {
    formatter2 = new Intl.NumberFormat(locale2, options);
    intlCache.set(cacheKey, formatter2);
  }
  return formatter2;
}
function formatNumber(num, locale2, options) {
  return getNumberFormat(locale2, options).format(num);
}
const getRightToLeftAdapter = function(rectX, width) {
  return {
    x(x3) {
      return rectX + rectX + width - x3;
    },
    setWidth(w3) {
      width = w3;
    },
    textAlign(align) {
      if (align === "center") {
        return align;
      }
      return align === "right" ? "left" : "right";
    },
    xPlus(x3, value2) {
      return x3 - value2;
    },
    leftForLtr(x3, itemWidth) {
      return x3 - itemWidth;
    }
  };
};
const getLeftToRightAdapter = function() {
  return {
    x(x3) {
      return x3;
    },
    setWidth(w3) {
    },
    textAlign(align) {
      return align;
    },
    xPlus(x3, value2) {
      return x3 + value2;
    },
    leftForLtr(x3, _itemWidth) {
      return x3;
    }
  };
};
function getRtlAdapter(rtl, rectX, width) {
  return rtl ? getRightToLeftAdapter(rectX, width) : getLeftToRightAdapter();
}
function overrideTextDirection(ctx, direction) {
  let style, original;
  if (direction === "ltr" || direction === "rtl") {
    style = ctx.canvas.style;
    original = [
      style.getPropertyValue("direction"),
      style.getPropertyPriority("direction")
    ];
    style.setProperty("direction", direction, "important");
    ctx.prevTextDirection = original;
  }
}
function restoreTextDirection(ctx, original) {
  if (original !== void 0) {
    delete ctx.prevTextDirection;
    ctx.canvas.style.setProperty("direction", original[0], original[1]);
  }
}
function propertyFn(property) {
  if (property === "angle") {
    return {
      between: _angleBetween,
      compare: _angleDiff,
      normalize: _normalizeAngle
    };
  }
  return {
    between: _isBetween,
    compare: (a4, b3) => a4 - b3,
    normalize: (x3) => x3
  };
}
function normalizeSegment({ start, end, count, loop, style }) {
  return {
    start: start % count,
    end: end % count,
    loop: loop && (end - start + 1) % count === 0,
    style
  };
}
function getSegment(segment, points, bounds) {
  const { property, start: startBound, end: endBound } = bounds;
  const { between: between2, normalize } = propertyFn(property);
  const count = points.length;
  let { start, end, loop } = segment;
  let i3, ilen;
  if (loop) {
    start += count;
    end += count;
    for (i3 = 0, ilen = count; i3 < ilen; ++i3) {
      if (!between2(normalize(points[start % count][property]), startBound, endBound)) {
        break;
      }
      start--;
      end--;
    }
    start %= count;
    end %= count;
  }
  if (end < start) {
    end += count;
  }
  return { start, end, loop, style: segment.style };
}
function _boundSegment(segment, points, bounds) {
  if (!bounds) {
    return [segment];
  }
  const { property, start: startBound, end: endBound } = bounds;
  const count = points.length;
  const { compare, between: between2, normalize } = propertyFn(property);
  const { start, end, loop, style } = getSegment(segment, points, bounds);
  const result = [];
  let inside = false;
  let subStart = null;
  let value2, point, prevValue;
  const startIsBefore = () => between2(startBound, prevValue, value2) && compare(startBound, prevValue) !== 0;
  const endIsBefore = () => compare(endBound, value2) === 0 || between2(endBound, prevValue, value2);
  const shouldStart2 = () => inside || startIsBefore();
  const shouldStop = () => !inside || endIsBefore();
  for (let i3 = start, prev = start; i3 <= end; ++i3) {
    point = points[i3 % count];
    if (point.skip) {
      continue;
    }
    value2 = normalize(point[property]);
    if (value2 === prevValue) {
      continue;
    }
    inside = between2(value2, startBound, endBound);
    if (subStart === null && shouldStart2()) {
      subStart = compare(value2, startBound) === 0 ? i3 : prev;
    }
    if (subStart !== null && shouldStop()) {
      result.push(normalizeSegment({ start: subStart, end: i3, loop, count, style }));
      subStart = null;
    }
    prev = i3;
    prevValue = value2;
  }
  if (subStart !== null) {
    result.push(normalizeSegment({ start: subStart, end, loop, count, style }));
  }
  return result;
}
function _boundSegments(line, bounds) {
  const result = [];
  const segments = line.segments;
  for (let i3 = 0; i3 < segments.length; i3++) {
    const sub = _boundSegment(segments[i3], line.points, bounds);
    if (sub.length) {
      result.push(...sub);
    }
  }
  return result;
}
function findStartAndEnd(points, count, loop, spanGaps) {
  let start = 0;
  let end = count - 1;
  if (loop && !spanGaps) {
    while (start < count && !points[start].skip) {
      start++;
    }
  }
  while (start < count && points[start].skip) {
    start++;
  }
  start %= count;
  if (loop) {
    end += start;
  }
  while (end > start && points[end % count].skip) {
    end--;
  }
  end %= count;
  return { start, end };
}
function solidSegments(points, start, max2, loop) {
  const count = points.length;
  const result = [];
  let last2 = start;
  let prev = points[start];
  let end;
  for (end = start + 1; end <= max2; ++end) {
    const cur = points[end % count];
    if (cur.skip || cur.stop) {
      if (!prev.skip) {
        loop = false;
        result.push({ start: start % count, end: (end - 1) % count, loop });
        start = last2 = cur.stop ? end : null;
      }
    } else {
      last2 = end;
      if (prev.skip) {
        start = end;
      }
    }
    prev = cur;
  }
  if (last2 !== null) {
    result.push({ start: start % count, end: last2 % count, loop });
  }
  return result;
}
function _computeSegments(line, segmentOptions) {
  const points = line.points;
  const spanGaps = line.options.spanGaps;
  const count = points.length;
  if (!count) {
    return [];
  }
  const loop = !!line._loop;
  const { start, end } = findStartAndEnd(points, count, loop, spanGaps);
  if (spanGaps === true) {
    return splitByStyles(line, [{ start, end, loop }], points, segmentOptions);
  }
  const max2 = end < start ? end + count : end;
  const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
  return splitByStyles(line, solidSegments(points, start, max2, completeLoop), points, segmentOptions);
}
function splitByStyles(line, segments, points, segmentOptions) {
  if (!segmentOptions || !segmentOptions.setContext || !points) {
    return segments;
  }
  return doSplitByStyles(line, segments, points, segmentOptions);
}
function doSplitByStyles(line, segments, points, segmentOptions) {
  const chartContext = line._chart.getContext();
  const baseStyle = readStyle(line.options);
  const { _datasetIndex: datasetIndex, options: { spanGaps } } = line;
  const count = points.length;
  const result = [];
  let prevStyle = baseStyle;
  let start = segments[0].start;
  let i3 = start;
  function addStyle(s4, e3, l, st2) {
    const dir = spanGaps ? -1 : 1;
    if (s4 === e3) {
      return;
    }
    s4 += count;
    while (points[s4 % count].skip) {
      s4 -= dir;
    }
    while (points[e3 % count].skip) {
      e3 += dir;
    }
    if (s4 % count !== e3 % count) {
      result.push({ start: s4 % count, end: e3 % count, loop: l, style: st2 });
      prevStyle = st2;
      start = e3 % count;
    }
  }
  for (const segment of segments) {
    start = spanGaps ? start : segment.start;
    let prev = points[start % count];
    let style;
    for (i3 = start + 1; i3 <= segment.end; i3++) {
      const pt2 = points[i3 % count];
      style = readStyle(segmentOptions.setContext(createContext(chartContext, {
        type: "segment",
        p0: prev,
        p1: pt2,
        p0DataIndex: (i3 - 1) % count,
        p1DataIndex: i3 % count,
        datasetIndex
      })));
      if (styleChanged(style, prevStyle)) {
        addStyle(start, i3 - 1, segment.loop, prevStyle);
      }
      prev = pt2;
      prevStyle = style;
    }
    if (start < i3 - 1) {
      addStyle(start, i3 - 1, segment.loop, prevStyle);
    }
  }
  return result;
}
function readStyle(options) {
  return {
    backgroundColor: options.backgroundColor,
    borderCapStyle: options.borderCapStyle,
    borderDash: options.borderDash,
    borderDashOffset: options.borderDashOffset,
    borderJoinStyle: options.borderJoinStyle,
    borderWidth: options.borderWidth,
    borderColor: options.borderColor
  };
}
function styleChanged(style, prevStyle) {
  return prevStyle && JSON.stringify(style) !== JSON.stringify(prevStyle);
}
/*!
 * Chart.js v3.9.1
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */
class Animator {
  constructor() {
    this._request = null;
    this._charts = /* @__PURE__ */ new Map();
    this._running = false;
    this._lastDate = void 0;
  }
  _notify(chart, anims, date, type2) {
    const callbacks = anims.listeners[type2];
    const numSteps = anims.duration;
    callbacks.forEach((fn) => fn({
      chart,
      initial: anims.initial,
      numSteps,
      currentStep: Math.min(date - anims.start, numSteps)
    }));
  }
  _refresh() {
    if (this._request) {
      return;
    }
    this._running = true;
    this._request = requestAnimFrame.call(window, () => {
      this._update();
      this._request = null;
      if (this._running) {
        this._refresh();
      }
    });
  }
  _update(date = Date.now()) {
    let remaining = 0;
    this._charts.forEach((anims, chart) => {
      if (!anims.running || !anims.items.length) {
        return;
      }
      const items = anims.items;
      let i3 = items.length - 1;
      let draw2 = false;
      let item;
      for (; i3 >= 0; --i3) {
        item = items[i3];
        if (item._active) {
          if (item._total > anims.duration) {
            anims.duration = item._total;
          }
          item.tick(date);
          draw2 = true;
        } else {
          items[i3] = items[items.length - 1];
          items.pop();
        }
      }
      if (draw2) {
        chart.draw();
        this._notify(chart, anims, date, "progress");
      }
      if (!items.length) {
        anims.running = false;
        this._notify(chart, anims, date, "complete");
        anims.initial = false;
      }
      remaining += items.length;
    });
    this._lastDate = date;
    if (remaining === 0) {
      this._running = false;
    }
  }
  _getAnims(chart) {
    const charts = this._charts;
    let anims = charts.get(chart);
    if (!anims) {
      anims = {
        running: false,
        initial: true,
        items: [],
        listeners: {
          complete: [],
          progress: []
        }
      };
      charts.set(chart, anims);
    }
    return anims;
  }
  listen(chart, event, cb) {
    this._getAnims(chart).listeners[event].push(cb);
  }
  add(chart, items) {
    if (!items || !items.length) {
      return;
    }
    this._getAnims(chart).items.push(...items);
  }
  has(chart) {
    return this._getAnims(chart).items.length > 0;
  }
  start(chart) {
    const anims = this._charts.get(chart);
    if (!anims) {
      return;
    }
    anims.running = true;
    anims.start = Date.now();
    anims.duration = anims.items.reduce((acc, cur) => Math.max(acc, cur._duration), 0);
    this._refresh();
  }
  running(chart) {
    if (!this._running) {
      return false;
    }
    const anims = this._charts.get(chart);
    if (!anims || !anims.running || !anims.items.length) {
      return false;
    }
    return true;
  }
  stop(chart) {
    const anims = this._charts.get(chart);
    if (!anims || !anims.items.length) {
      return;
    }
    const items = anims.items;
    let i3 = items.length - 1;
    for (; i3 >= 0; --i3) {
      items[i3].cancel();
    }
    anims.items = [];
    this._notify(chart, anims, Date.now(), "complete");
  }
  remove(chart) {
    return this._charts.delete(chart);
  }
}
var animator = new Animator();
const transparent = "transparent";
const interpolators = {
  boolean(from2, to2, factor) {
    return factor > 0.5 ? to2 : from2;
  },
  color(from2, to2, factor) {
    const c0 = color(from2 || transparent);
    const c1 = c0.valid && color(to2 || transparent);
    return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to2;
  },
  number(from2, to2, factor) {
    return from2 + (to2 - from2) * factor;
  }
};
class Animation {
  constructor(cfg, target2, prop, to2) {
    const currentValue = target2[prop];
    to2 = resolve([cfg.to, to2, currentValue, cfg.from]);
    const from2 = resolve([cfg.from, currentValue, to2]);
    this._active = true;
    this._fn = cfg.fn || interpolators[cfg.type || typeof from2];
    this._easing = effects[cfg.easing] || effects.linear;
    this._start = Math.floor(Date.now() + (cfg.delay || 0));
    this._duration = this._total = Math.floor(cfg.duration);
    this._loop = !!cfg.loop;
    this._target = target2;
    this._prop = prop;
    this._from = from2;
    this._to = to2;
    this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(cfg, to2, date) {
    if (this._active) {
      this._notify(false);
      const currentValue = this._target[this._prop];
      const elapsed = date - this._start;
      const remain = this._duration - elapsed;
      this._start = date;
      this._duration = Math.floor(Math.max(remain, cfg.duration));
      this._total += elapsed;
      this._loop = !!cfg.loop;
      this._to = resolve([cfg.to, to2, currentValue, cfg.from]);
      this._from = resolve([cfg.from, currentValue, to2]);
    }
  }
  cancel() {
    if (this._active) {
      this.tick(Date.now());
      this._active = false;
      this._notify(false);
    }
  }
  tick(date) {
    const elapsed = date - this._start;
    const duration2 = this._duration;
    const prop = this._prop;
    const from2 = this._from;
    const loop = this._loop;
    const to2 = this._to;
    let factor;
    this._active = from2 !== to2 && (loop || elapsed < duration2);
    if (!this._active) {
      this._target[prop] = to2;
      this._notify(true);
      return;
    }
    if (elapsed < 0) {
      this._target[prop] = from2;
      return;
    }
    factor = elapsed / duration2 % 2;
    factor = loop && factor > 1 ? 2 - factor : factor;
    factor = this._easing(Math.min(1, Math.max(0, factor)));
    this._target[prop] = this._fn(from2, to2, factor);
  }
  wait() {
    const promises = this._promises || (this._promises = []);
    return new Promise((res, rej) => {
      promises.push({ res, rej });
    });
  }
  _notify(resolved) {
    const method = resolved ? "res" : "rej";
    const promises = this._promises || [];
    for (let i3 = 0; i3 < promises.length; i3++) {
      promises[i3][method]();
    }
  }
}
const numbers = ["x", "y", "borderWidth", "radius", "tension"];
const colors = ["color", "borderColor", "backgroundColor"];
defaults$1.set("animation", {
  delay: void 0,
  duration: 1e3,
  easing: "easeOutQuart",
  fn: void 0,
  from: void 0,
  loop: void 0,
  to: void 0,
  type: void 0
});
const animationOptions = Object.keys(defaults$1.animation);
defaults$1.describe("animation", {
  _fallback: false,
  _indexable: false,
  _scriptable: (name2) => name2 !== "onProgress" && name2 !== "onComplete" && name2 !== "fn"
});
defaults$1.set("animations", {
  colors: {
    type: "color",
    properties: colors
  },
  numbers: {
    type: "number",
    properties: numbers
  }
});
defaults$1.describe("animations", {
  _fallback: "animation"
});
defaults$1.set("transitions", {
  active: {
    animation: {
      duration: 400
    }
  },
  resize: {
    animation: {
      duration: 0
    }
  },
  show: {
    animations: {
      colors: {
        from: "transparent"
      },
      visible: {
        type: "boolean",
        duration: 0
      }
    }
  },
  hide: {
    animations: {
      colors: {
        to: "transparent"
      },
      visible: {
        type: "boolean",
        easing: "linear",
        fn: (v) => v | 0
      }
    }
  }
});
class Animations {
  constructor(chart, config) {
    this._chart = chart;
    this._properties = /* @__PURE__ */ new Map();
    this.configure(config);
  }
  configure(config) {
    if (!isObject$3(config)) {
      return;
    }
    const animatedProps = this._properties;
    Object.getOwnPropertyNames(config).forEach((key) => {
      const cfg = config[key];
      if (!isObject$3(cfg)) {
        return;
      }
      const resolved = {};
      for (const option of animationOptions) {
        resolved[option] = cfg[option];
      }
      (isArray(cfg.properties) && cfg.properties || [key]).forEach((prop) => {
        if (prop === key || !animatedProps.has(prop)) {
          animatedProps.set(prop, resolved);
        }
      });
    });
  }
  _animateOptions(target2, values) {
    const newOptions = values.options;
    const options = resolveTargetOptions(target2, newOptions);
    if (!options) {
      return [];
    }
    const animations = this._createAnimations(options, newOptions);
    if (newOptions.$shared) {
      awaitAll(target2.options.$animations, newOptions).then(() => {
        target2.options = newOptions;
      }, () => {
      });
    }
    return animations;
  }
  _createAnimations(target2, values) {
    const animatedProps = this._properties;
    const animations = [];
    const running = target2.$animations || (target2.$animations = {});
    const props4 = Object.keys(values);
    const date = Date.now();
    let i3;
    for (i3 = props4.length - 1; i3 >= 0; --i3) {
      const prop = props4[i3];
      if (prop.charAt(0) === "$") {
        continue;
      }
      if (prop === "options") {
        animations.push(...this._animateOptions(target2, values));
        continue;
      }
      const value2 = values[prop];
      let animation = running[prop];
      const cfg = animatedProps.get(prop);
      if (animation) {
        if (cfg && animation.active()) {
          animation.update(cfg, value2, date);
          continue;
        } else {
          animation.cancel();
        }
      }
      if (!cfg || !cfg.duration) {
        target2[prop] = value2;
        continue;
      }
      running[prop] = animation = new Animation(cfg, target2, prop, value2);
      animations.push(animation);
    }
    return animations;
  }
  update(target2, values) {
    if (this._properties.size === 0) {
      Object.assign(target2, values);
      return;
    }
    const animations = this._createAnimations(target2, values);
    if (animations.length) {
      animator.add(this._chart, animations);
      return true;
    }
  }
}
function awaitAll(animations, properties) {
  const running = [];
  const keys2 = Object.keys(properties);
  for (let i3 = 0; i3 < keys2.length; i3++) {
    const anim = animations[keys2[i3]];
    if (anim && anim.active()) {
      running.push(anim.wait());
    }
  }
  return Promise.all(running);
}
function resolveTargetOptions(target2, newOptions) {
  if (!newOptions) {
    return;
  }
  let options = target2.options;
  if (!options) {
    target2.options = newOptions;
    return;
  }
  if (options.$shared) {
    target2.options = options = Object.assign({}, options, { $shared: false, $animations: {} });
  }
  return options;
}
function scaleClip(scale, allowedOverflow) {
  const opts = scale && scale.options || {};
  const reverse = opts.reverse;
  const min2 = opts.min === void 0 ? allowedOverflow : 0;
  const max2 = opts.max === void 0 ? allowedOverflow : 0;
  return {
    start: reverse ? max2 : min2,
    end: reverse ? min2 : max2
  };
}
function defaultClip(xScale, yScale, allowedOverflow) {
  if (allowedOverflow === false) {
    return false;
  }
  const x3 = scaleClip(xScale, allowedOverflow);
  const y4 = scaleClip(yScale, allowedOverflow);
  return {
    top: y4.end,
    right: x3.end,
    bottom: y4.start,
    left: x3.start
  };
}
function toClip(value2) {
  let t3, r, b3, l;
  if (isObject$3(value2)) {
    t3 = value2.top;
    r = value2.right;
    b3 = value2.bottom;
    l = value2.left;
  } else {
    t3 = r = b3 = l = value2;
  }
  return {
    top: t3,
    right: r,
    bottom: b3,
    left: l,
    disabled: value2 === false
  };
}
function getSortedDatasetIndices(chart, filterVisible) {
  const keys2 = [];
  const metasets = chart._getSortedDatasetMetas(filterVisible);
  let i3, ilen;
  for (i3 = 0, ilen = metasets.length; i3 < ilen; ++i3) {
    keys2.push(metasets[i3].index);
  }
  return keys2;
}
function applyStack(stack2, value2, dsIndex, options = {}) {
  const keys2 = stack2.keys;
  const singleMode = options.mode === "single";
  let i3, ilen, datasetIndex, otherValue;
  if (value2 === null) {
    return;
  }
  for (i3 = 0, ilen = keys2.length; i3 < ilen; ++i3) {
    datasetIndex = +keys2[i3];
    if (datasetIndex === dsIndex) {
      if (options.all) {
        continue;
      }
      break;
    }
    otherValue = stack2.values[datasetIndex];
    if (isNumberFinite(otherValue) && (singleMode || (value2 === 0 || sign(value2) === sign(otherValue)))) {
      value2 += otherValue;
    }
  }
  return value2;
}
function convertObjectDataToArray(data) {
  const keys2 = Object.keys(data);
  const adata = new Array(keys2.length);
  let i3, ilen, key;
  for (i3 = 0, ilen = keys2.length; i3 < ilen; ++i3) {
    key = keys2[i3];
    adata[i3] = {
      x: key,
      y: data[key]
    };
  }
  return adata;
}
function isStacked(scale, meta) {
  const stacked = scale && scale.options.stacked;
  return stacked || stacked === void 0 && meta.stack !== void 0;
}
function getStackKey(indexScale, valueScale, meta) {
  return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function getUserBounds(scale) {
  const { min: min2, max: max2, minDefined, maxDefined } = scale.getUserBounds();
  return {
    min: minDefined ? min2 : Number.NEGATIVE_INFINITY,
    max: maxDefined ? max2 : Number.POSITIVE_INFINITY
  };
}
function getOrCreateStack(stacks, stackKey, indexValue) {
  const subStack = stacks[stackKey] || (stacks[stackKey] = {});
  return subStack[indexValue] || (subStack[indexValue] = {});
}
function getLastIndexInStack(stack2, vScale, positive, type2) {
  for (const meta of vScale.getMatchingVisibleMetas(type2).reverse()) {
    const value2 = stack2[meta.index];
    if (positive && value2 > 0 || !positive && value2 < 0) {
      return meta.index;
    }
  }
  return null;
}
function updateStacks(controller, parsed) {
  const { chart, _cachedMeta: meta } = controller;
  const stacks = chart._stacks || (chart._stacks = {});
  const { iScale, vScale, index: datasetIndex } = meta;
  const iAxis = iScale.axis;
  const vAxis = vScale.axis;
  const key = getStackKey(iScale, vScale, meta);
  const ilen = parsed.length;
  let stack2;
  for (let i3 = 0; i3 < ilen; ++i3) {
    const item = parsed[i3];
    const { [iAxis]: index2, [vAxis]: value2 } = item;
    const itemStacks = item._stacks || (item._stacks = {});
    stack2 = itemStacks[vAxis] = getOrCreateStack(stacks, key, index2);
    stack2[datasetIndex] = value2;
    stack2._top = getLastIndexInStack(stack2, vScale, true, meta.type);
    stack2._bottom = getLastIndexInStack(stack2, vScale, false, meta.type);
  }
}
function getFirstScaleId(chart, axis) {
  const scales = chart.scales;
  return Object.keys(scales).filter((key) => scales[key].axis === axis).shift();
}
function createDatasetContext(parent, index2) {
  return createContext(
    parent,
    {
      active: false,
      dataset: void 0,
      datasetIndex: index2,
      index: index2,
      mode: "default",
      type: "dataset"
    }
  );
}
function createDataContext(parent, index2, element) {
  return createContext(parent, {
    active: false,
    dataIndex: index2,
    parsed: void 0,
    raw: void 0,
    element,
    index: index2,
    mode: "default",
    type: "data"
  });
}
function clearStacks(meta, items) {
  const datasetIndex = meta.controller.index;
  const axis = meta.vScale && meta.vScale.axis;
  if (!axis) {
    return;
  }
  items = items || meta._parsed;
  for (const parsed of items) {
    const stacks = parsed._stacks;
    if (!stacks || stacks[axis] === void 0 || stacks[axis][datasetIndex] === void 0) {
      return;
    }
    delete stacks[axis][datasetIndex];
  }
}
const isDirectUpdateMode = (mode) => mode === "reset" || mode === "none";
const cloneIfNotShared = (cached, shared) => shared ? cached : Object.assign({}, cached);
const createStack$1 = (canStack, meta, chart) => canStack && !meta.hidden && meta._stacked && { keys: getSortedDatasetIndices(chart, true), values: null };
class DatasetController {
  constructor(chart, datasetIndex) {
    this.chart = chart;
    this._ctx = chart.ctx;
    this.index = datasetIndex;
    this._cachedDataOpts = {};
    this._cachedMeta = this.getMeta();
    this._type = this._cachedMeta.type;
    this.options = void 0;
    this._parsing = false;
    this._data = void 0;
    this._objectData = void 0;
    this._sharedOptions = void 0;
    this._drawStart = void 0;
    this._drawCount = void 0;
    this.enableOptionSharing = false;
    this.supportsDecimation = false;
    this.$context = void 0;
    this._syncList = [];
    this.initialize();
  }
  initialize() {
    const meta = this._cachedMeta;
    this.configure();
    this.linkScales();
    meta._stacked = isStacked(meta.vScale, meta);
    this.addElements();
  }
  updateIndex(datasetIndex) {
    if (this.index !== datasetIndex) {
      clearStacks(this._cachedMeta);
    }
    this.index = datasetIndex;
  }
  linkScales() {
    const chart = this.chart;
    const meta = this._cachedMeta;
    const dataset = this.getDataset();
    const chooseId = (axis, x3, y4, r) => axis === "x" ? x3 : axis === "r" ? r : y4;
    const xid = meta.xAxisID = valueOrDefault(dataset.xAxisID, getFirstScaleId(chart, "x"));
    const yid = meta.yAxisID = valueOrDefault(dataset.yAxisID, getFirstScaleId(chart, "y"));
    const rid = meta.rAxisID = valueOrDefault(dataset.rAxisID, getFirstScaleId(chart, "r"));
    const indexAxis = meta.indexAxis;
    const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
    const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
    meta.xScale = this.getScaleForId(xid);
    meta.yScale = this.getScaleForId(yid);
    meta.rScale = this.getScaleForId(rid);
    meta.iScale = this.getScaleForId(iid);
    meta.vScale = this.getScaleForId(vid);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(scaleID) {
    return this.chart.scales[scaleID];
  }
  _getOtherScale(scale) {
    const meta = this._cachedMeta;
    return scale === meta.iScale ? meta.vScale : meta.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const meta = this._cachedMeta;
    if (this._data) {
      unlistenArrayEvents(this._data, this);
    }
    if (meta._stacked) {
      clearStacks(meta);
    }
  }
  _dataCheck() {
    const dataset = this.getDataset();
    const data = dataset.data || (dataset.data = []);
    const _data = this._data;
    if (isObject$3(data)) {
      this._data = convertObjectDataToArray(data);
    } else if (_data !== data) {
      if (_data) {
        unlistenArrayEvents(_data, this);
        const meta = this._cachedMeta;
        clearStacks(meta);
        meta._parsed = [];
      }
      if (data && Object.isExtensible(data)) {
        listenArrayEvents(data, this);
      }
      this._syncList = [];
      this._data = data;
    }
  }
  addElements() {
    const meta = this._cachedMeta;
    this._dataCheck();
    if (this.datasetElementType) {
      meta.dataset = new this.datasetElementType();
    }
  }
  buildOrUpdateElements(resetNewElements) {
    const meta = this._cachedMeta;
    const dataset = this.getDataset();
    let stackChanged = false;
    this._dataCheck();
    const oldStacked = meta._stacked;
    meta._stacked = isStacked(meta.vScale, meta);
    if (meta.stack !== dataset.stack) {
      stackChanged = true;
      clearStacks(meta);
      meta.stack = dataset.stack;
    }
    this._resyncElements(resetNewElements);
    if (stackChanged || oldStacked !== meta._stacked) {
      updateStacks(this, meta._parsed);
    }
  }
  configure() {
    const config = this.chart.config;
    const scopeKeys = config.datasetScopeKeys(this._type);
    const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
    this.options = config.createResolver(scopes, this.getContext());
    this._parsing = this.options.parsing;
    this._cachedDataOpts = {};
  }
  parse(start, count) {
    const { _cachedMeta: meta, _data: data } = this;
    const { iScale, _stacked } = meta;
    const iAxis = iScale.axis;
    let sorted = start === 0 && count === data.length ? true : meta._sorted;
    let prev = start > 0 && meta._parsed[start - 1];
    let i3, cur, parsed;
    if (this._parsing === false) {
      meta._parsed = data;
      meta._sorted = true;
      parsed = data;
    } else {
      if (isArray(data[start])) {
        parsed = this.parseArrayData(meta, data, start, count);
      } else if (isObject$3(data[start])) {
        parsed = this.parseObjectData(meta, data, start, count);
      } else {
        parsed = this.parsePrimitiveData(meta, data, start, count);
      }
      const isNotInOrderComparedToPrev = () => cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
      for (i3 = 0; i3 < count; ++i3) {
        meta._parsed[i3 + start] = cur = parsed[i3];
        if (sorted) {
          if (isNotInOrderComparedToPrev()) {
            sorted = false;
          }
          prev = cur;
        }
      }
      meta._sorted = sorted;
    }
    if (_stacked) {
      updateStacks(this, parsed);
    }
  }
  parsePrimitiveData(meta, data, start, count) {
    const { iScale, vScale } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = new Array(count);
    let i3, ilen, index2;
    for (i3 = 0, ilen = count; i3 < ilen; ++i3) {
      index2 = i3 + start;
      parsed[i3] = {
        [iAxis]: singleScale || iScale.parse(labels[index2], index2),
        [vAxis]: vScale.parse(data[index2], index2)
      };
    }
    return parsed;
  }
  parseArrayData(meta, data, start, count) {
    const { xScale, yScale } = meta;
    const parsed = new Array(count);
    let i3, ilen, index2, item;
    for (i3 = 0, ilen = count; i3 < ilen; ++i3) {
      index2 = i3 + start;
      item = data[index2];
      parsed[i3] = {
        x: xScale.parse(item[0], index2),
        y: yScale.parse(item[1], index2)
      };
    }
    return parsed;
  }
  parseObjectData(meta, data, start, count) {
    const { xScale, yScale } = meta;
    const { xAxisKey = "x", yAxisKey = "y" } = this._parsing;
    const parsed = new Array(count);
    let i3, ilen, index2, item;
    for (i3 = 0, ilen = count; i3 < ilen; ++i3) {
      index2 = i3 + start;
      item = data[index2];
      parsed[i3] = {
        x: xScale.parse(resolveObjectKey(item, xAxisKey), index2),
        y: yScale.parse(resolveObjectKey(item, yAxisKey), index2)
      };
    }
    return parsed;
  }
  getParsed(index2) {
    return this._cachedMeta._parsed[index2];
  }
  getDataElement(index2) {
    return this._cachedMeta.data[index2];
  }
  applyStack(scale, parsed, mode) {
    const chart = this.chart;
    const meta = this._cachedMeta;
    const value2 = parsed[scale.axis];
    const stack2 = {
      keys: getSortedDatasetIndices(chart, true),
      values: parsed._stacks[scale.axis]
    };
    return applyStack(stack2, value2, meta.index, { mode });
  }
  updateRangeFromParsed(range2, scale, parsed, stack2) {
    const parsedValue = parsed[scale.axis];
    let value2 = parsedValue === null ? NaN : parsedValue;
    const values = stack2 && parsed._stacks[scale.axis];
    if (stack2 && values) {
      stack2.values = values;
      value2 = applyStack(stack2, parsedValue, this._cachedMeta.index);
    }
    range2.min = Math.min(range2.min, value2);
    range2.max = Math.max(range2.max, value2);
  }
  getMinMax(scale, canStack) {
    const meta = this._cachedMeta;
    const _parsed = meta._parsed;
    const sorted = meta._sorted && scale === meta.iScale;
    const ilen = _parsed.length;
    const otherScale = this._getOtherScale(scale);
    const stack2 = createStack$1(canStack, meta, this.chart);
    const range2 = { min: Number.POSITIVE_INFINITY, max: Number.NEGATIVE_INFINITY };
    const { min: otherMin, max: otherMax } = getUserBounds(otherScale);
    let i3, parsed;
    function _skip() {
      parsed = _parsed[i3];
      const otherValue = parsed[otherScale.axis];
      return !isNumberFinite(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
    }
    for (i3 = 0; i3 < ilen; ++i3) {
      if (_skip()) {
        continue;
      }
      this.updateRangeFromParsed(range2, scale, parsed, stack2);
      if (sorted) {
        break;
      }
    }
    if (sorted) {
      for (i3 = ilen - 1; i3 >= 0; --i3) {
        if (_skip()) {
          continue;
        }
        this.updateRangeFromParsed(range2, scale, parsed, stack2);
        break;
      }
    }
    return range2;
  }
  getAllParsedValues(scale) {
    const parsed = this._cachedMeta._parsed;
    const values = [];
    let i3, ilen, value2;
    for (i3 = 0, ilen = parsed.length; i3 < ilen; ++i3) {
      value2 = parsed[i3][scale.axis];
      if (isNumberFinite(value2)) {
        values.push(value2);
      }
    }
    return values;
  }
  getMaxOverflow() {
    return false;
  }
  getLabelAndValue(index2) {
    const meta = this._cachedMeta;
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const parsed = this.getParsed(index2);
    return {
      label: iScale ? "" + iScale.getLabelForValue(parsed[iScale.axis]) : "",
      value: vScale ? "" + vScale.getLabelForValue(parsed[vScale.axis]) : ""
    };
  }
  _update(mode) {
    const meta = this._cachedMeta;
    this.update(mode || "default");
    meta._clip = toClip(valueOrDefault(this.options.clip, defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
  }
  update(mode) {
  }
  draw() {
    const ctx = this._ctx;
    const chart = this.chart;
    const meta = this._cachedMeta;
    const elements = meta.data || [];
    const area = chart.chartArea;
    const active = [];
    const start = this._drawStart || 0;
    const count = this._drawCount || elements.length - start;
    const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
    let i3;
    if (meta.dataset) {
      meta.dataset.draw(ctx, area, start, count);
    }
    for (i3 = start; i3 < start + count; ++i3) {
      const element = elements[i3];
      if (element.hidden) {
        continue;
      }
      if (element.active && drawActiveElementsOnTop) {
        active.push(element);
      } else {
        element.draw(ctx, area);
      }
    }
    for (i3 = 0; i3 < active.length; ++i3) {
      active[i3].draw(ctx, area);
    }
  }
  getStyle(index2, active) {
    const mode = active ? "active" : "default";
    return index2 === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index2 || 0, mode);
  }
  getContext(index2, active, mode) {
    const dataset = this.getDataset();
    let context;
    if (index2 >= 0 && index2 < this._cachedMeta.data.length) {
      const element = this._cachedMeta.data[index2];
      context = element.$context || (element.$context = createDataContext(this.getContext(), index2, element));
      context.parsed = this.getParsed(index2);
      context.raw = dataset.data[index2];
      context.index = context.dataIndex = index2;
    } else {
      context = this.$context || (this.$context = createDatasetContext(this.chart.getContext(), this.index));
      context.dataset = dataset;
      context.index = context.datasetIndex = this.index;
    }
    context.active = !!active;
    context.mode = mode;
    return context;
  }
  resolveDatasetElementOptions(mode) {
    return this._resolveElementOptions(this.datasetElementType.id, mode);
  }
  resolveDataElementOptions(index2, mode) {
    return this._resolveElementOptions(this.dataElementType.id, mode, index2);
  }
  _resolveElementOptions(elementType, mode = "default", index2) {
    const active = mode === "active";
    const cache = this._cachedDataOpts;
    const cacheKey = elementType + "-" + mode;
    const cached = cache[cacheKey];
    const sharing = this.enableOptionSharing && defined(index2);
    if (cached) {
      return cloneIfNotShared(cached, sharing);
    }
    const config = this.chart.config;
    const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
    const prefixes2 = active ? [`${elementType}Hover`, "hover", elementType, ""] : [elementType, ""];
    const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
    const names2 = Object.keys(defaults$1.elements[elementType]);
    const context = () => this.getContext(index2, active);
    const values = config.resolveNamedOptions(scopes, names2, context, prefixes2);
    if (values.$shared) {
      values.$shared = sharing;
      cache[cacheKey] = Object.freeze(cloneIfNotShared(values, sharing));
    }
    return values;
  }
  _resolveAnimations(index2, transition, active) {
    const chart = this.chart;
    const cache = this._cachedDataOpts;
    const cacheKey = `animation-${transition}`;
    const cached = cache[cacheKey];
    if (cached) {
      return cached;
    }
    let options;
    if (chart.options.animation !== false) {
      const config = this.chart.config;
      const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
      const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
      options = config.createResolver(scopes, this.getContext(index2, active, transition));
    }
    const animations = new Animations(chart, options && options.animations);
    if (options && options._cacheable) {
      cache[cacheKey] = Object.freeze(animations);
    }
    return animations;
  }
  getSharedOptions(options) {
    if (!options.$shared) {
      return;
    }
    return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
  }
  includeOptions(mode, sharedOptions) {
    return !sharedOptions || isDirectUpdateMode(mode) || this.chart._animationsDisabled;
  }
  _getSharedOptions(start, mode) {
    const firstOpts = this.resolveDataElementOptions(start, mode);
    const previouslySharedOptions = this._sharedOptions;
    const sharedOptions = this.getSharedOptions(firstOpts);
    const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
    this.updateSharedOptions(sharedOptions, mode, firstOpts);
    return { sharedOptions, includeOptions };
  }
  updateElement(element, index2, properties, mode) {
    if (isDirectUpdateMode(mode)) {
      Object.assign(element, properties);
    } else {
      this._resolveAnimations(index2, mode).update(element, properties);
    }
  }
  updateSharedOptions(sharedOptions, mode, newOptions) {
    if (sharedOptions && !isDirectUpdateMode(mode)) {
      this._resolveAnimations(void 0, mode).update(sharedOptions, newOptions);
    }
  }
  _setStyle(element, index2, mode, active) {
    element.active = active;
    const options = this.getStyle(index2, active);
    this._resolveAnimations(index2, mode, active).update(element, {
      options: !active && this.getSharedOptions(options) || options
    });
  }
  removeHoverStyle(element, datasetIndex, index2) {
    this._setStyle(element, index2, "active", false);
  }
  setHoverStyle(element, datasetIndex, index2) {
    this._setStyle(element, index2, "active", true);
  }
  _removeDatasetHoverStyle() {
    const element = this._cachedMeta.dataset;
    if (element) {
      this._setStyle(element, void 0, "active", false);
    }
  }
  _setDatasetHoverStyle() {
    const element = this._cachedMeta.dataset;
    if (element) {
      this._setStyle(element, void 0, "active", true);
    }
  }
  _resyncElements(resetNewElements) {
    const data = this._data;
    const elements = this._cachedMeta.data;
    for (const [method, arg1, arg2] of this._syncList) {
      this[method](arg1, arg2);
    }
    this._syncList = [];
    const numMeta = elements.length;
    const numData = data.length;
    const count = Math.min(numData, numMeta);
    if (count) {
      this.parse(0, count);
    }
    if (numData > numMeta) {
      this._insertElements(numMeta, numData - numMeta, resetNewElements);
    } else if (numData < numMeta) {
      this._removeElements(numData, numMeta - numData);
    }
  }
  _insertElements(start, count, resetNewElements = true) {
    const meta = this._cachedMeta;
    const data = meta.data;
    const end = start + count;
    let i3;
    const move = (arr) => {
      arr.length += count;
      for (i3 = arr.length - 1; i3 >= end; i3--) {
        arr[i3] = arr[i3 - count];
      }
    };
    move(data);
    for (i3 = start; i3 < end; ++i3) {
      data[i3] = new this.dataElementType();
    }
    if (this._parsing) {
      move(meta._parsed);
    }
    this.parse(start, count);
    if (resetNewElements) {
      this.updateElements(data, start, count, "reset");
    }
  }
  updateElements(element, start, count, mode) {
  }
  _removeElements(start, count) {
    const meta = this._cachedMeta;
    if (this._parsing) {
      const removed = meta._parsed.splice(start, count);
      if (meta._stacked) {
        clearStacks(meta, removed);
      }
    }
    meta.data.splice(start, count);
  }
  _sync(args) {
    if (this._parsing) {
      this._syncList.push(args);
    } else {
      const [method, arg1, arg2] = args;
      this[method](arg1, arg2);
    }
    this.chart._dataChanges.push([this.index, ...args]);
  }
  _onDataPush() {
    const count = arguments.length;
    this._sync(["_insertElements", this.getDataset().data.length - count, count]);
  }
  _onDataPop() {
    this._sync(["_removeElements", this._cachedMeta.data.length - 1, 1]);
  }
  _onDataShift() {
    this._sync(["_removeElements", 0, 1]);
  }
  _onDataSplice(start, count) {
    if (count) {
      this._sync(["_removeElements", start, count]);
    }
    const newCount = arguments.length - 2;
    if (newCount) {
      this._sync(["_insertElements", start, newCount]);
    }
  }
  _onDataUnshift() {
    this._sync(["_insertElements", 0, arguments.length]);
  }
}
DatasetController.defaults = {};
DatasetController.prototype.datasetElementType = null;
DatasetController.prototype.dataElementType = null;
function getAllScaleValues(scale, type2) {
  if (!scale._cache.$bar) {
    const visibleMetas = scale.getMatchingVisibleMetas(type2);
    let values = [];
    for (let i3 = 0, ilen = visibleMetas.length; i3 < ilen; i3++) {
      values = values.concat(visibleMetas[i3].controller.getAllParsedValues(scale));
    }
    scale._cache.$bar = _arrayUnique(values.sort((a4, b3) => a4 - b3));
  }
  return scale._cache.$bar;
}
function computeMinSampleSize(meta) {
  const scale = meta.iScale;
  const values = getAllScaleValues(scale, meta.type);
  let min2 = scale._length;
  let i3, ilen, curr, prev;
  const updateMinAndPrev = () => {
    if (curr === 32767 || curr === -32768) {
      return;
    }
    if (defined(prev)) {
      min2 = Math.min(min2, Math.abs(curr - prev) || min2);
    }
    prev = curr;
  };
  for (i3 = 0, ilen = values.length; i3 < ilen; ++i3) {
    curr = scale.getPixelForValue(values[i3]);
    updateMinAndPrev();
  }
  prev = void 0;
  for (i3 = 0, ilen = scale.ticks.length; i3 < ilen; ++i3) {
    curr = scale.getPixelForTick(i3);
    updateMinAndPrev();
  }
  return min2;
}
function computeFitCategoryTraits(index2, ruler, options, stackCount) {
  const thickness = options.barThickness;
  let size2, ratio;
  if (isNullOrUndef(thickness)) {
    size2 = ruler.min * options.categoryPercentage;
    ratio = options.barPercentage;
  } else {
    size2 = thickness * stackCount;
    ratio = 1;
  }
  return {
    chunk: size2 / stackCount,
    ratio,
    start: ruler.pixels[index2] - size2 / 2
  };
}
function computeFlexCategoryTraits(index2, ruler, options, stackCount) {
  const pixels = ruler.pixels;
  const curr = pixels[index2];
  let prev = index2 > 0 ? pixels[index2 - 1] : null;
  let next = index2 < pixels.length - 1 ? pixels[index2 + 1] : null;
  const percent = options.categoryPercentage;
  if (prev === null) {
    prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
  }
  if (next === null) {
    next = curr + curr - prev;
  }
  const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
  const size2 = Math.abs(next - prev) / 2 * percent;
  return {
    chunk: size2 / stackCount,
    ratio: options.barPercentage,
    start
  };
}
function parseFloatBar(entry, item, vScale, i3) {
  const startValue = vScale.parse(entry[0], i3);
  const endValue = vScale.parse(entry[1], i3);
  const min2 = Math.min(startValue, endValue);
  const max2 = Math.max(startValue, endValue);
  let barStart = min2;
  let barEnd = max2;
  if (Math.abs(min2) > Math.abs(max2)) {
    barStart = max2;
    barEnd = min2;
  }
  item[vScale.axis] = barEnd;
  item._custom = {
    barStart,
    barEnd,
    start: startValue,
    end: endValue,
    min: min2,
    max: max2
  };
}
function parseValue$2(entry, item, vScale, i3) {
  if (isArray(entry)) {
    parseFloatBar(entry, item, vScale, i3);
  } else {
    item[vScale.axis] = vScale.parse(entry, i3);
  }
  return item;
}
function parseArrayOrPrimitive(meta, data, start, count) {
  const iScale = meta.iScale;
  const vScale = meta.vScale;
  const labels = iScale.getLabels();
  const singleScale = iScale === vScale;
  const parsed = [];
  let i3, ilen, item, entry;
  for (i3 = start, ilen = start + count; i3 < ilen; ++i3) {
    entry = data[i3];
    item = {};
    item[iScale.axis] = singleScale || iScale.parse(labels[i3], i3);
    parsed.push(parseValue$2(entry, item, vScale, i3));
  }
  return parsed;
}
function isFloatBar(custom) {
  return custom && custom.barStart !== void 0 && custom.barEnd !== void 0;
}
function barSign(size2, vScale, actualBase) {
  if (size2 !== 0) {
    return sign(size2);
  }
  return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function borderProps(properties) {
  let reverse, start, end, top, bottom;
  if (properties.horizontal) {
    reverse = properties.base > properties.x;
    start = "left";
    end = "right";
  } else {
    reverse = properties.base < properties.y;
    start = "bottom";
    end = "top";
  }
  if (reverse) {
    top = "end";
    bottom = "start";
  } else {
    top = "start";
    bottom = "end";
  }
  return { start, end, reverse, top, bottom };
}
function setBorderSkipped(properties, options, stack2, index2) {
  let edge = options.borderSkipped;
  const res = {};
  if (!edge) {
    properties.borderSkipped = res;
    return;
  }
  if (edge === true) {
    properties.borderSkipped = { top: true, right: true, bottom: true, left: true };
    return;
  }
  const { start, end, reverse, top, bottom } = borderProps(properties);
  if (edge === "middle" && stack2) {
    properties.enableBorderRadius = true;
    if ((stack2._top || 0) === index2) {
      edge = top;
    } else if ((stack2._bottom || 0) === index2) {
      edge = bottom;
    } else {
      res[parseEdge(bottom, start, end, reverse)] = true;
      edge = top;
    }
  }
  res[parseEdge(edge, start, end, reverse)] = true;
  properties.borderSkipped = res;
}
function parseEdge(edge, a4, b3, reverse) {
  if (reverse) {
    edge = swap(edge, a4, b3);
    edge = startEnd(edge, b3, a4);
  } else {
    edge = startEnd(edge, a4, b3);
  }
  return edge;
}
function swap(orig, v1, v2) {
  return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function startEnd(v, start, end) {
  return v === "start" ? start : v === "end" ? end : v;
}
function setInflateAmount(properties, { inflateAmount }, ratio) {
  properties.inflateAmount = inflateAmount === "auto" ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class BarController extends DatasetController {
  parsePrimitiveData(meta, data, start, count) {
    return parseArrayOrPrimitive(meta, data, start, count);
  }
  parseArrayData(meta, data, start, count) {
    return parseArrayOrPrimitive(meta, data, start, count);
  }
  parseObjectData(meta, data, start, count) {
    const { iScale, vScale } = meta;
    const { xAxisKey = "x", yAxisKey = "y" } = this._parsing;
    const iAxisKey = iScale.axis === "x" ? xAxisKey : yAxisKey;
    const vAxisKey = vScale.axis === "x" ? xAxisKey : yAxisKey;
    const parsed = [];
    let i3, ilen, item, obj;
    for (i3 = start, ilen = start + count; i3 < ilen; ++i3) {
      obj = data[i3];
      item = {};
      item[iScale.axis] = iScale.parse(resolveObjectKey(obj, iAxisKey), i3);
      parsed.push(parseValue$2(resolveObjectKey(obj, vAxisKey), item, vScale, i3));
    }
    return parsed;
  }
  updateRangeFromParsed(range2, scale, parsed, stack2) {
    super.updateRangeFromParsed(range2, scale, parsed, stack2);
    const custom = parsed._custom;
    if (custom && scale === this._cachedMeta.vScale) {
      range2.min = Math.min(range2.min, custom.min);
      range2.max = Math.max(range2.max, custom.max);
    }
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(index2) {
    const meta = this._cachedMeta;
    const { iScale, vScale } = meta;
    const parsed = this.getParsed(index2);
    const custom = parsed._custom;
    const value2 = isFloatBar(custom) ? "[" + custom.start + ", " + custom.end + "]" : "" + vScale.getLabelForValue(parsed[vScale.axis]);
    return {
      label: "" + iScale.getLabelForValue(parsed[iScale.axis]),
      value: value2
    };
  }
  initialize() {
    this.enableOptionSharing = true;
    super.initialize();
    const meta = this._cachedMeta;
    meta.stack = this.getDataset().stack;
  }
  update(mode) {
    const meta = this._cachedMeta;
    this.updateElements(meta.data, 0, meta.data.length, mode);
  }
  updateElements(bars, start, count, mode) {
    const reset = mode === "reset";
    const { index: index2, _cachedMeta: { vScale } } = this;
    const base = vScale.getBasePixel();
    const horizontal = vScale.isHorizontal();
    const ruler = this._getRuler();
    const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
    for (let i3 = start; i3 < start + count; i3++) {
      const parsed = this.getParsed(i3);
      const vpixels = reset || isNullOrUndef(parsed[vScale.axis]) ? { base, head: base } : this._calculateBarValuePixels(i3);
      const ipixels = this._calculateBarIndexPixels(i3, ruler);
      const stack2 = (parsed._stacks || {})[vScale.axis];
      const properties = {
        horizontal,
        base: vpixels.base,
        enableBorderRadius: !stack2 || isFloatBar(parsed._custom) || (index2 === stack2._top || index2 === stack2._bottom),
        x: horizontal ? vpixels.head : ipixels.center,
        y: horizontal ? ipixels.center : vpixels.head,
        height: horizontal ? ipixels.size : Math.abs(vpixels.size),
        width: horizontal ? Math.abs(vpixels.size) : ipixels.size
      };
      if (includeOptions) {
        properties.options = sharedOptions || this.resolveDataElementOptions(i3, bars[i3].active ? "active" : mode);
      }
      const options = properties.options || bars[i3].options;
      setBorderSkipped(properties, options, stack2, index2);
      setInflateAmount(properties, options, ruler.ratio);
      this.updateElement(bars[i3], i3, properties, mode);
    }
  }
  _getStacks(last2, dataIndex) {
    const { iScale } = this._cachedMeta;
    const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta) => meta.controller.options.grouped);
    const stacked = iScale.options.stacked;
    const stacks = [];
    const skipNull = (meta) => {
      const parsed = meta.controller.getParsed(dataIndex);
      const val = parsed && parsed[meta.vScale.axis];
      if (isNullOrUndef(val) || isNaN(val)) {
        return true;
      }
    };
    for (const meta of metasets) {
      if (dataIndex !== void 0 && skipNull(meta)) {
        continue;
      }
      if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === void 0 && meta.stack === void 0) {
        stacks.push(meta.stack);
      }
      if (meta.index === last2) {
        break;
      }
    }
    if (!stacks.length) {
      stacks.push(void 0);
    }
    return stacks;
  }
  _getStackCount(index2) {
    return this._getStacks(void 0, index2).length;
  }
  _getStackIndex(datasetIndex, name2, dataIndex) {
    const stacks = this._getStacks(datasetIndex, dataIndex);
    const index2 = name2 !== void 0 ? stacks.indexOf(name2) : -1;
    return index2 === -1 ? stacks.length - 1 : index2;
  }
  _getRuler() {
    const opts = this.options;
    const meta = this._cachedMeta;
    const iScale = meta.iScale;
    const pixels = [];
    let i3, ilen;
    for (i3 = 0, ilen = meta.data.length; i3 < ilen; ++i3) {
      pixels.push(iScale.getPixelForValue(this.getParsed(i3)[iScale.axis], i3));
    }
    const barThickness = opts.barThickness;
    const min2 = barThickness || computeMinSampleSize(meta);
    return {
      min: min2,
      pixels,
      start: iScale._startPixel,
      end: iScale._endPixel,
      stackCount: this._getStackCount(),
      scale: iScale,
      grouped: opts.grouped,
      ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
    };
  }
  _calculateBarValuePixels(index2) {
    const { _cachedMeta: { vScale, _stacked }, options: { base: baseValue, minBarLength } } = this;
    const actualBase = baseValue || 0;
    const parsed = this.getParsed(index2);
    const custom = parsed._custom;
    const floating = isFloatBar(custom);
    let value2 = parsed[vScale.axis];
    let start = 0;
    let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value2;
    let head, size2;
    if (length !== value2) {
      start = length - value2;
      length = value2;
    }
    if (floating) {
      value2 = custom.barStart;
      length = custom.barEnd - custom.barStart;
      if (value2 !== 0 && sign(value2) !== sign(custom.barEnd)) {
        start = 0;
      }
      start += value2;
    }
    const startValue = !isNullOrUndef(baseValue) && !floating ? baseValue : start;
    let base = vScale.getPixelForValue(startValue);
    if (this.chart.getDataVisibility(index2)) {
      head = vScale.getPixelForValue(start + length);
    } else {
      head = base;
    }
    size2 = head - base;
    if (Math.abs(size2) < minBarLength) {
      size2 = barSign(size2, vScale, actualBase) * minBarLength;
      if (value2 === actualBase) {
        base -= size2 / 2;
      }
      const startPixel = vScale.getPixelForDecimal(0);
      const endPixel = vScale.getPixelForDecimal(1);
      const min2 = Math.min(startPixel, endPixel);
      const max2 = Math.max(startPixel, endPixel);
      base = Math.max(Math.min(base, max2), min2);
      head = base + size2;
    }
    if (base === vScale.getPixelForValue(actualBase)) {
      const halfGrid = sign(size2) * vScale.getLineWidthForValue(actualBase) / 2;
      base += halfGrid;
      size2 -= halfGrid;
    }
    return {
      size: size2,
      base,
      head,
      center: head + size2 / 2
    };
  }
  _calculateBarIndexPixels(index2, ruler) {
    const scale = ruler.scale;
    const options = this.options;
    const skipNull = options.skipNull;
    const maxBarThickness = valueOrDefault(options.maxBarThickness, Infinity);
    let center, size2;
    if (ruler.grouped) {
      const stackCount = skipNull ? this._getStackCount(index2) : ruler.stackCount;
      const range2 = options.barThickness === "flex" ? computeFlexCategoryTraits(index2, ruler, options, stackCount) : computeFitCategoryTraits(index2, ruler, options, stackCount);
      const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index2 : void 0);
      center = range2.start + range2.chunk * stackIndex + range2.chunk / 2;
      size2 = Math.min(maxBarThickness, range2.chunk * range2.ratio);
    } else {
      center = scale.getPixelForValue(this.getParsed(index2)[scale.axis], index2);
      size2 = Math.min(maxBarThickness, ruler.min * ruler.ratio);
    }
    return {
      base: center - size2 / 2,
      head: center + size2 / 2,
      center,
      size: size2
    };
  }
  draw() {
    const meta = this._cachedMeta;
    const vScale = meta.vScale;
    const rects = meta.data;
    const ilen = rects.length;
    let i3 = 0;
    for (; i3 < ilen; ++i3) {
      if (this.getParsed(i3)[vScale.axis] !== null) {
        rects[i3].draw(this._ctx);
      }
    }
  }
}
BarController.id = "bar";
BarController.defaults = {
  datasetElementType: false,
  dataElementType: "bar",
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: true,
  animations: {
    numbers: {
      type: "number",
      properties: ["x", "y", "base", "width", "height"]
    }
  }
};
BarController.overrides = {
  scales: {
    _index_: {
      type: "category",
      offset: true,
      grid: {
        offset: true
      }
    },
    _value_: {
      type: "linear",
      beginAtZero: true
    }
  }
};
class BubbleController extends DatasetController {
  initialize() {
    this.enableOptionSharing = true;
    super.initialize();
  }
  parsePrimitiveData(meta, data, start, count) {
    const parsed = super.parsePrimitiveData(meta, data, start, count);
    for (let i3 = 0; i3 < parsed.length; i3++) {
      parsed[i3]._custom = this.resolveDataElementOptions(i3 + start).radius;
    }
    return parsed;
  }
  parseArrayData(meta, data, start, count) {
    const parsed = super.parseArrayData(meta, data, start, count);
    for (let i3 = 0; i3 < parsed.length; i3++) {
      const item = data[start + i3];
      parsed[i3]._custom = valueOrDefault(item[2], this.resolveDataElementOptions(i3 + start).radius);
    }
    return parsed;
  }
  parseObjectData(meta, data, start, count) {
    const parsed = super.parseObjectData(meta, data, start, count);
    for (let i3 = 0; i3 < parsed.length; i3++) {
      const item = data[start + i3];
      parsed[i3]._custom = valueOrDefault(item && item.r && +item.r, this.resolveDataElementOptions(i3 + start).radius);
    }
    return parsed;
  }
  getMaxOverflow() {
    const data = this._cachedMeta.data;
    let max2 = 0;
    for (let i3 = data.length - 1; i3 >= 0; --i3) {
      max2 = Math.max(max2, data[i3].size(this.resolveDataElementOptions(i3)) / 2);
    }
    return max2 > 0 && max2;
  }
  getLabelAndValue(index2) {
    const meta = this._cachedMeta;
    const { xScale, yScale } = meta;
    const parsed = this.getParsed(index2);
    const x3 = xScale.getLabelForValue(parsed.x);
    const y4 = yScale.getLabelForValue(parsed.y);
    const r = parsed._custom;
    return {
      label: meta.label,
      value: "(" + x3 + ", " + y4 + (r ? ", " + r : "") + ")"
    };
  }
  update(mode) {
    const points = this._cachedMeta.data;
    this.updateElements(points, 0, points.length, mode);
  }
  updateElements(points, start, count, mode) {
    const reset = mode === "reset";
    const { iScale, vScale } = this._cachedMeta;
    const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    for (let i3 = start; i3 < start + count; i3++) {
      const point = points[i3];
      const parsed = !reset && this.getParsed(i3);
      const properties = {};
      const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
      const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
      properties.skip = isNaN(iPixel) || isNaN(vPixel);
      if (includeOptions) {
        properties.options = sharedOptions || this.resolveDataElementOptions(i3, point.active ? "active" : mode);
        if (reset) {
          properties.options.radius = 0;
        }
      }
      this.updateElement(point, i3, properties, mode);
    }
  }
  resolveDataElementOptions(index2, mode) {
    const parsed = this.getParsed(index2);
    let values = super.resolveDataElementOptions(index2, mode);
    if (values.$shared) {
      values = Object.assign({}, values, { $shared: false });
    }
    const radius2 = values.radius;
    if (mode !== "active") {
      values.radius = 0;
    }
    values.radius += valueOrDefault(parsed && parsed._custom, radius2);
    return values;
  }
}
BubbleController.id = "bubble";
BubbleController.defaults = {
  datasetElementType: false,
  dataElementType: "point",
  animations: {
    numbers: {
      type: "number",
      properties: ["x", "y", "borderWidth", "radius"]
    }
  }
};
BubbleController.overrides = {
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  },
  plugins: {
    tooltip: {
      callbacks: {
        title() {
          return "";
        }
      }
    }
  }
};
function getRatioAndOffset(rotation, circumference2, cutout) {
  let ratioX = 1;
  let ratioY = 1;
  let offsetX = 0;
  let offsetY = 0;
  if (circumference2 < TAU) {
    const startAngle = rotation;
    const endAngle = startAngle + circumference2;
    const startX = Math.cos(startAngle);
    const startY = Math.sin(startAngle);
    const endX = Math.cos(endAngle);
    const endY = Math.sin(endAngle);
    const calcMax = (angle2, a4, b3) => _angleBetween(angle2, startAngle, endAngle, true) ? 1 : Math.max(a4, a4 * cutout, b3, b3 * cutout);
    const calcMin = (angle2, a4, b3) => _angleBetween(angle2, startAngle, endAngle, true) ? -1 : Math.min(a4, a4 * cutout, b3, b3 * cutout);
    const maxX = calcMax(0, startX, endX);
    const maxY = calcMax(HALF_PI, startY, endY);
    const minX = calcMin(PI, startX, endX);
    const minY = calcMin(PI + HALF_PI, startY, endY);
    ratioX = (maxX - minX) / 2;
    ratioY = (maxY - minY) / 2;
    offsetX = -(maxX + minX) / 2;
    offsetY = -(maxY + minY) / 2;
  }
  return { ratioX, ratioY, offsetX, offsetY };
}
class DoughnutController extends DatasetController {
  constructor(chart, datasetIndex) {
    super(chart, datasetIndex);
    this.enableOptionSharing = true;
    this.innerRadius = void 0;
    this.outerRadius = void 0;
    this.offsetX = void 0;
    this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(start, count) {
    const data = this.getDataset().data;
    const meta = this._cachedMeta;
    if (this._parsing === false) {
      meta._parsed = data;
    } else {
      let getter = (i4) => +data[i4];
      if (isObject$3(data[start])) {
        const { key = "value" } = this._parsing;
        getter = (i4) => +resolveObjectKey(data[i4], key);
      }
      let i3, ilen;
      for (i3 = start, ilen = start + count; i3 < ilen; ++i3) {
        meta._parsed[i3] = getter(i3);
      }
    }
  }
  _getRotation() {
    return toRadians(this.options.rotation - 90);
  }
  _getCircumference() {
    return toRadians(this.options.circumference);
  }
  _getRotationExtents() {
    let min2 = TAU;
    let max2 = -TAU;
    for (let i3 = 0; i3 < this.chart.data.datasets.length; ++i3) {
      if (this.chart.isDatasetVisible(i3)) {
        const controller = this.chart.getDatasetMeta(i3).controller;
        const rotation = controller._getRotation();
        const circumference2 = controller._getCircumference();
        min2 = Math.min(min2, rotation);
        max2 = Math.max(max2, rotation + circumference2);
      }
    }
    return {
      rotation: min2,
      circumference: max2 - min2
    };
  }
  update(mode) {
    const chart = this.chart;
    const { chartArea } = chart;
    const meta = this._cachedMeta;
    const arcs = meta.data;
    const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
    const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
    const cutout = Math.min(toPercentage(this.options.cutout, maxSize), 1);
    const chartWeight = this._getRingWeight(this.index);
    const { circumference: circumference2, rotation } = this._getRotationExtents();
    const { ratioX, ratioY, offsetX, offsetY } = getRatioAndOffset(rotation, circumference2, cutout);
    const maxWidth = (chartArea.width - spacing) / ratioX;
    const maxHeight = (chartArea.height - spacing) / ratioY;
    const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
    const outerRadius = toDimension(this.options.radius, maxRadius);
    const innerRadius = Math.max(outerRadius * cutout, 0);
    const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
    this.offsetX = offsetX * outerRadius;
    this.offsetY = offsetY * outerRadius;
    meta.total = this.calculateTotal();
    this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
    this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
    this.updateElements(arcs, 0, arcs.length, mode);
  }
  _circumference(i3, reset) {
    const opts = this.options;
    const meta = this._cachedMeta;
    const circumference2 = this._getCircumference();
    if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i3) || meta._parsed[i3] === null || meta.data[i3].hidden) {
      return 0;
    }
    return this.calculateCircumference(meta._parsed[i3] * circumference2 / TAU);
  }
  updateElements(arcs, start, count, mode) {
    const reset = mode === "reset";
    const chart = this.chart;
    const chartArea = chart.chartArea;
    const opts = chart.options;
    const animationOpts = opts.animation;
    const centerX = (chartArea.left + chartArea.right) / 2;
    const centerY = (chartArea.top + chartArea.bottom) / 2;
    const animateScale = reset && animationOpts.animateScale;
    const innerRadius = animateScale ? 0 : this.innerRadius;
    const outerRadius = animateScale ? 0 : this.outerRadius;
    const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
    let startAngle = this._getRotation();
    let i3;
    for (i3 = 0; i3 < start; ++i3) {
      startAngle += this._circumference(i3, reset);
    }
    for (i3 = start; i3 < start + count; ++i3) {
      const circumference2 = this._circumference(i3, reset);
      const arc = arcs[i3];
      const properties = {
        x: centerX + this.offsetX,
        y: centerY + this.offsetY,
        startAngle,
        endAngle: startAngle + circumference2,
        circumference: circumference2,
        outerRadius,
        innerRadius
      };
      if (includeOptions) {
        properties.options = sharedOptions || this.resolveDataElementOptions(i3, arc.active ? "active" : mode);
      }
      startAngle += circumference2;
      this.updateElement(arc, i3, properties, mode);
    }
  }
  calculateTotal() {
    const meta = this._cachedMeta;
    const metaData = meta.data;
    let total = 0;
    let i3;
    for (i3 = 0; i3 < metaData.length; i3++) {
      const value2 = meta._parsed[i3];
      if (value2 !== null && !isNaN(value2) && this.chart.getDataVisibility(i3) && !metaData[i3].hidden) {
        total += Math.abs(value2);
      }
    }
    return total;
  }
  calculateCircumference(value2) {
    const total = this._cachedMeta.total;
    if (total > 0 && !isNaN(value2)) {
      return TAU * (Math.abs(value2) / total);
    }
    return 0;
  }
  getLabelAndValue(index2) {
    const meta = this._cachedMeta;
    const chart = this.chart;
    const labels = chart.data.labels || [];
    const value2 = formatNumber(meta._parsed[index2], chart.options.locale);
    return {
      label: labels[index2] || "",
      value: value2
    };
  }
  getMaxBorderWidth(arcs) {
    let max2 = 0;
    const chart = this.chart;
    let i3, ilen, meta, controller, options;
    if (!arcs) {
      for (i3 = 0, ilen = chart.data.datasets.length; i3 < ilen; ++i3) {
        if (chart.isDatasetVisible(i3)) {
          meta = chart.getDatasetMeta(i3);
          arcs = meta.data;
          controller = meta.controller;
          break;
        }
      }
    }
    if (!arcs) {
      return 0;
    }
    for (i3 = 0, ilen = arcs.length; i3 < ilen; ++i3) {
      options = controller.resolveDataElementOptions(i3);
      if (options.borderAlign !== "inner") {
        max2 = Math.max(max2, options.borderWidth || 0, options.hoverBorderWidth || 0);
      }
    }
    return max2;
  }
  getMaxOffset(arcs) {
    let max2 = 0;
    for (let i3 = 0, ilen = arcs.length; i3 < ilen; ++i3) {
      const options = this.resolveDataElementOptions(i3);
      max2 = Math.max(max2, options.offset || 0, options.hoverOffset || 0);
    }
    return max2;
  }
  _getRingWeightOffset(datasetIndex) {
    let ringWeightOffset = 0;
    for (let i3 = 0; i3 < datasetIndex; ++i3) {
      if (this.chart.isDatasetVisible(i3)) {
        ringWeightOffset += this._getRingWeight(i3);
      }
    }
    return ringWeightOffset;
  }
  _getRingWeight(datasetIndex) {
    return Math.max(valueOrDefault(this.chart.data.datasets[datasetIndex].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
DoughnutController.id = "doughnut";
DoughnutController.defaults = {
  datasetElementType: false,
  dataElementType: "arc",
  animation: {
    animateRotate: true,
    animateScale: false
  },
  animations: {
    numbers: {
      type: "number",
      properties: ["circumference", "endAngle", "innerRadius", "outerRadius", "startAngle", "x", "y", "offset", "borderWidth", "spacing"]
    }
  },
  cutout: "50%",
  rotation: 0,
  circumference: 360,
  radius: "100%",
  spacing: 0,
  indexAxis: "r"
};
DoughnutController.descriptors = {
  _scriptable: (name2) => name2 !== "spacing",
  _indexable: (name2) => name2 !== "spacing"
};
DoughnutController.overrides = {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(chart) {
          const data = chart.data;
          if (data.labels.length && data.datasets.length) {
            const { labels: { pointStyle } } = chart.legend.options;
            return data.labels.map((label, i3) => {
              const meta = chart.getDatasetMeta(0);
              const style = meta.controller.getStyle(i3);
              return {
                text: label,
                fillStyle: style.backgroundColor,
                strokeStyle: style.borderColor,
                lineWidth: style.borderWidth,
                pointStyle,
                hidden: !chart.getDataVisibility(i3),
                index: i3
              };
            });
          }
          return [];
        }
      },
      onClick(e3, legendItem, legend) {
        legend.chart.toggleDataVisibility(legendItem.index);
        legend.chart.update();
      }
    },
    tooltip: {
      callbacks: {
        title() {
          return "";
        },
        label(tooltipItem) {
          let dataLabel = tooltipItem.label;
          const value2 = ": " + tooltipItem.formattedValue;
          if (isArray(dataLabel)) {
            dataLabel = dataLabel.slice();
            dataLabel[0] += value2;
          } else {
            dataLabel += value2;
          }
          return dataLabel;
        }
      }
    }
  }
};
class LineController extends DatasetController {
  initialize() {
    this.enableOptionSharing = true;
    this.supportsDecimation = true;
    super.initialize();
  }
  update(mode) {
    const meta = this._cachedMeta;
    const { dataset: line, data: points = [], _dataset } = meta;
    const animationsDisabled = this.chart._animationsDisabled;
    let { start, count } = _getStartAndCountOfVisiblePoints(meta, points, animationsDisabled);
    this._drawStart = start;
    this._drawCount = count;
    if (_scaleRangesChanged(meta)) {
      start = 0;
      count = points.length;
    }
    line._chart = this.chart;
    line._datasetIndex = this.index;
    line._decimated = !!_dataset._decimated;
    line.points = points;
    const options = this.resolveDatasetElementOptions(mode);
    if (!this.options.showLine) {
      options.borderWidth = 0;
    }
    options.segment = this.options.segment;
    this.updateElement(line, void 0, {
      animated: !animationsDisabled,
      options
    }, mode);
    this.updateElements(points, start, count, mode);
  }
  updateElements(points, start, count, mode) {
    const reset = mode === "reset";
    const { iScale, vScale, _stacked, _dataset } = this._cachedMeta;
    const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const { spanGaps, segment } = this.options;
    const maxGapLength = isNumber$2(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
    const directUpdate = this.chart._animationsDisabled || reset || mode === "none";
    let prevParsed = start > 0 && this.getParsed(start - 1);
    for (let i3 = start; i3 < start + count; ++i3) {
      const point = points[i3];
      const parsed = this.getParsed(i3);
      const properties = directUpdate ? point : {};
      const nullData = isNullOrUndef(parsed[vAxis]);
      const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i3);
      const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i3);
      properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
      properties.stop = i3 > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
      if (segment) {
        properties.parsed = parsed;
        properties.raw = _dataset.data[i3];
      }
      if (includeOptions) {
        properties.options = sharedOptions || this.resolveDataElementOptions(i3, point.active ? "active" : mode);
      }
      if (!directUpdate) {
        this.updateElement(point, i3, properties, mode);
      }
      prevParsed = parsed;
    }
  }
  getMaxOverflow() {
    const meta = this._cachedMeta;
    const dataset = meta.dataset;
    const border = dataset.options && dataset.options.borderWidth || 0;
    const data = meta.data || [];
    if (!data.length) {
      return border;
    }
    const firstPoint = data[0].size(this.resolveDataElementOptions(0));
    const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
    return Math.max(border, firstPoint, lastPoint) / 2;
  }
  draw() {
    const meta = this._cachedMeta;
    meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
    super.draw();
  }
}
LineController.id = "line";
LineController.defaults = {
  datasetElementType: "line",
  dataElementType: "point",
  showLine: true,
  spanGaps: false
};
LineController.overrides = {
  scales: {
    _index_: {
      type: "category"
    },
    _value_: {
      type: "linear"
    }
  }
};
class PolarAreaController extends DatasetController {
  constructor(chart, datasetIndex) {
    super(chart, datasetIndex);
    this.innerRadius = void 0;
    this.outerRadius = void 0;
  }
  getLabelAndValue(index2) {
    const meta = this._cachedMeta;
    const chart = this.chart;
    const labels = chart.data.labels || [];
    const value2 = formatNumber(meta._parsed[index2].r, chart.options.locale);
    return {
      label: labels[index2] || "",
      value: value2
    };
  }
  parseObjectData(meta, data, start, count) {
    return _parseObjectDataRadialScale.bind(this)(meta, data, start, count);
  }
  update(mode) {
    const arcs = this._cachedMeta.data;
    this._updateRadius();
    this.updateElements(arcs, 0, arcs.length, mode);
  }
  getMinMax() {
    const meta = this._cachedMeta;
    const range2 = { min: Number.POSITIVE_INFINITY, max: Number.NEGATIVE_INFINITY };
    meta.data.forEach((element, index2) => {
      const parsed = this.getParsed(index2).r;
      if (!isNaN(parsed) && this.chart.getDataVisibility(index2)) {
        if (parsed < range2.min) {
          range2.min = parsed;
        }
        if (parsed > range2.max) {
          range2.max = parsed;
        }
      }
    });
    return range2;
  }
  _updateRadius() {
    const chart = this.chart;
    const chartArea = chart.chartArea;
    const opts = chart.options;
    const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
    const outerRadius = Math.max(minSize / 2, 0);
    const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
    const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
    this.outerRadius = outerRadius - radiusLength * this.index;
    this.innerRadius = this.outerRadius - radiusLength;
  }
  updateElements(arcs, start, count, mode) {
    const reset = mode === "reset";
    const chart = this.chart;
    const opts = chart.options;
    const animationOpts = opts.animation;
    const scale = this._cachedMeta.rScale;
    const centerX = scale.xCenter;
    const centerY = scale.yCenter;
    const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * PI;
    let angle2 = datasetStartAngle;
    let i3;
    const defaultAngle = 360 / this.countVisibleElements();
    for (i3 = 0; i3 < start; ++i3) {
      angle2 += this._computeAngle(i3, mode, defaultAngle);
    }
    for (i3 = start; i3 < start + count; i3++) {
      const arc = arcs[i3];
      let startAngle = angle2;
      let endAngle = angle2 + this._computeAngle(i3, mode, defaultAngle);
      let outerRadius = chart.getDataVisibility(i3) ? scale.getDistanceFromCenterForValue(this.getParsed(i3).r) : 0;
      angle2 = endAngle;
      if (reset) {
        if (animationOpts.animateScale) {
          outerRadius = 0;
        }
        if (animationOpts.animateRotate) {
          startAngle = endAngle = datasetStartAngle;
        }
      }
      const properties = {
        x: centerX,
        y: centerY,
        innerRadius: 0,
        outerRadius,
        startAngle,
        endAngle,
        options: this.resolveDataElementOptions(i3, arc.active ? "active" : mode)
      };
      this.updateElement(arc, i3, properties, mode);
    }
  }
  countVisibleElements() {
    const meta = this._cachedMeta;
    let count = 0;
    meta.data.forEach((element, index2) => {
      if (!isNaN(this.getParsed(index2).r) && this.chart.getDataVisibility(index2)) {
        count++;
      }
    });
    return count;
  }
  _computeAngle(index2, mode, defaultAngle) {
    return this.chart.getDataVisibility(index2) ? toRadians(this.resolveDataElementOptions(index2, mode).angle || defaultAngle) : 0;
  }
}
PolarAreaController.id = "polarArea";
PolarAreaController.defaults = {
  dataElementType: "arc",
  animation: {
    animateRotate: true,
    animateScale: true
  },
  animations: {
    numbers: {
      type: "number",
      properties: ["x", "y", "startAngle", "endAngle", "innerRadius", "outerRadius"]
    }
  },
  indexAxis: "r",
  startAngle: 0
};
PolarAreaController.overrides = {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(chart) {
          const data = chart.data;
          if (data.labels.length && data.datasets.length) {
            const { labels: { pointStyle } } = chart.legend.options;
            return data.labels.map((label, i3) => {
              const meta = chart.getDatasetMeta(0);
              const style = meta.controller.getStyle(i3);
              return {
                text: label,
                fillStyle: style.backgroundColor,
                strokeStyle: style.borderColor,
                lineWidth: style.borderWidth,
                pointStyle,
                hidden: !chart.getDataVisibility(i3),
                index: i3
              };
            });
          }
          return [];
        }
      },
      onClick(e3, legendItem, legend) {
        legend.chart.toggleDataVisibility(legendItem.index);
        legend.chart.update();
      }
    },
    tooltip: {
      callbacks: {
        title() {
          return "";
        },
        label(context) {
          return context.chart.data.labels[context.dataIndex] + ": " + context.formattedValue;
        }
      }
    }
  },
  scales: {
    r: {
      type: "radialLinear",
      angleLines: {
        display: false
      },
      beginAtZero: true,
      grid: {
        circular: true
      },
      pointLabels: {
        display: false
      },
      startAngle: 0
    }
  }
};
class PieController extends DoughnutController {
}
PieController.id = "pie";
PieController.defaults = {
  cutout: 0,
  rotation: 0,
  circumference: 360,
  radius: "100%"
};
class RadarController extends DatasetController {
  getLabelAndValue(index2) {
    const vScale = this._cachedMeta.vScale;
    const parsed = this.getParsed(index2);
    return {
      label: vScale.getLabels()[index2],
      value: "" + vScale.getLabelForValue(parsed[vScale.axis])
    };
  }
  parseObjectData(meta, data, start, count) {
    return _parseObjectDataRadialScale.bind(this)(meta, data, start, count);
  }
  update(mode) {
    const meta = this._cachedMeta;
    const line = meta.dataset;
    const points = meta.data || [];
    const labels = meta.iScale.getLabels();
    line.points = points;
    if (mode !== "resize") {
      const options = this.resolveDatasetElementOptions(mode);
      if (!this.options.showLine) {
        options.borderWidth = 0;
      }
      const properties = {
        _loop: true,
        _fullLoop: labels.length === points.length,
        options
      };
      this.updateElement(line, void 0, properties, mode);
    }
    this.updateElements(points, 0, points.length, mode);
  }
  updateElements(points, start, count, mode) {
    const scale = this._cachedMeta.rScale;
    const reset = mode === "reset";
    for (let i3 = start; i3 < start + count; i3++) {
      const point = points[i3];
      const options = this.resolveDataElementOptions(i3, point.active ? "active" : mode);
      const pointPosition = scale.getPointPositionForValue(i3, this.getParsed(i3).r);
      const x3 = reset ? scale.xCenter : pointPosition.x;
      const y4 = reset ? scale.yCenter : pointPosition.y;
      const properties = {
        x: x3,
        y: y4,
        angle: pointPosition.angle,
        skip: isNaN(x3) || isNaN(y4),
        options
      };
      this.updateElement(point, i3, properties, mode);
    }
  }
}
RadarController.id = "radar";
RadarController.defaults = {
  datasetElementType: "line",
  dataElementType: "point",
  indexAxis: "r",
  showLine: true,
  elements: {
    line: {
      fill: "start"
    }
  }
};
RadarController.overrides = {
  aspectRatio: 1,
  scales: {
    r: {
      type: "radialLinear"
    }
  }
};
let Element$1 = class Element2 {
  constructor() {
    this.x = void 0;
    this.y = void 0;
    this.active = false;
    this.options = void 0;
    this.$animations = void 0;
  }
  tooltipPosition(useFinalPosition) {
    const { x: x3, y: y4 } = this.getProps(["x", "y"], useFinalPosition);
    return { x: x3, y: y4 };
  }
  hasValue() {
    return isNumber$2(this.x) && isNumber$2(this.y);
  }
  getProps(props4, final) {
    const anims = this.$animations;
    if (!final || !anims) {
      return this;
    }
    const ret = {};
    props4.forEach((prop) => {
      ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
    });
    return ret;
  }
};
Element$1.defaults = {};
Element$1.defaultRoutes = void 0;
const formatters$4 = {
  values(value2) {
    return isArray(value2) ? value2 : "" + value2;
  },
  numeric(tickValue, index2, ticks) {
    if (tickValue === 0) {
      return "0";
    }
    const locale2 = this.chart.options.locale;
    let notation;
    let delta = tickValue;
    if (ticks.length > 1) {
      const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
      if (maxTick < 1e-4 || maxTick > 1e15) {
        notation = "scientific";
      }
      delta = calculateDelta(tickValue, ticks);
    }
    const logDelta = log10(Math.abs(delta));
    const numDecimal = Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
    const options = { notation, minimumFractionDigits: numDecimal, maximumFractionDigits: numDecimal };
    Object.assign(options, this.options.ticks.format);
    return formatNumber(tickValue, locale2, options);
  },
  logarithmic(tickValue, index2, ticks) {
    if (tickValue === 0) {
      return "0";
    }
    const remain = tickValue / Math.pow(10, Math.floor(log10(tickValue)));
    if (remain === 1 || remain === 2 || remain === 5) {
      return formatters$4.numeric.call(this, tickValue, index2, ticks);
    }
    return "";
  }
};
function calculateDelta(tickValue, ticks) {
  let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
  if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) {
    delta = tickValue - Math.floor(tickValue);
  }
  return delta;
}
var Ticks = { formatters: formatters$4 };
defaults$1.set("scale", {
  display: true,
  offset: false,
  reverse: false,
  beginAtZero: false,
  bounds: "ticks",
  grace: 0,
  grid: {
    display: true,
    lineWidth: 1,
    drawBorder: true,
    drawOnChartArea: true,
    drawTicks: true,
    tickLength: 8,
    tickWidth: (_ctx, options) => options.lineWidth,
    tickColor: (_ctx, options) => options.color,
    offset: false,
    borderDash: [],
    borderDashOffset: 0,
    borderWidth: 1
  },
  title: {
    display: false,
    text: "",
    padding: {
      top: 4,
      bottom: 4
    }
  },
  ticks: {
    minRotation: 0,
    maxRotation: 50,
    mirror: false,
    textStrokeWidth: 0,
    textStrokeColor: "",
    padding: 3,
    display: true,
    autoSkip: true,
    autoSkipPadding: 3,
    labelOffset: 0,
    callback: Ticks.formatters.values,
    minor: {},
    major: {},
    align: "center",
    crossAlign: "near",
    showLabelBackdrop: false,
    backdropColor: "rgba(255, 255, 255, 0.75)",
    backdropPadding: 2
  }
});
defaults$1.route("scale.ticks", "color", "", "color");
defaults$1.route("scale.grid", "color", "", "borderColor");
defaults$1.route("scale.grid", "borderColor", "", "borderColor");
defaults$1.route("scale.title", "color", "", "color");
defaults$1.describe("scale", {
  _fallback: false,
  _scriptable: (name2) => !name2.startsWith("before") && !name2.startsWith("after") && name2 !== "callback" && name2 !== "parser",
  _indexable: (name2) => name2 !== "borderDash" && name2 !== "tickBorderDash"
});
defaults$1.describe("scales", {
  _fallback: "scale"
});
defaults$1.describe("scale.ticks", {
  _scriptable: (name2) => name2 !== "backdropPadding" && name2 !== "callback",
  _indexable: (name2) => name2 !== "backdropPadding"
});
function autoSkip(scale, ticks) {
  const tickOpts = scale.options.ticks;
  const ticksLimit = tickOpts.maxTicksLimit || determineMaxTicks(scale);
  const majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
  const numMajorIndices = majorIndices.length;
  const first = majorIndices[0];
  const last2 = majorIndices[numMajorIndices - 1];
  const newTicks = [];
  if (numMajorIndices > ticksLimit) {
    skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
    return newTicks;
  }
  const spacing = calculateSpacing(majorIndices, ticks, ticksLimit);
  if (numMajorIndices > 0) {
    let i3, ilen;
    const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last2 - first) / (numMajorIndices - 1)) : null;
    skip(ticks, newTicks, spacing, isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
    for (i3 = 0, ilen = numMajorIndices - 1; i3 < ilen; i3++) {
      skip(ticks, newTicks, spacing, majorIndices[i3], majorIndices[i3 + 1]);
    }
    skip(ticks, newTicks, spacing, last2, isNullOrUndef(avgMajorSpacing) ? ticks.length : last2 + avgMajorSpacing);
    return newTicks;
  }
  skip(ticks, newTicks, spacing);
  return newTicks;
}
function determineMaxTicks(scale) {
  const offset2 = scale.options.offset;
  const tickLength = scale._tickSize();
  const maxScale = scale._length / tickLength + (offset2 ? 0 : 1);
  const maxChart = scale._maxLength / tickLength;
  return Math.floor(Math.min(maxScale, maxChart));
}
function calculateSpacing(majorIndices, ticks, ticksLimit) {
  const evenMajorSpacing = getEvenSpacing(majorIndices);
  const spacing = ticks.length / ticksLimit;
  if (!evenMajorSpacing) {
    return Math.max(spacing, 1);
  }
  const factors = _factorize(evenMajorSpacing);
  for (let i3 = 0, ilen = factors.length - 1; i3 < ilen; i3++) {
    const factor = factors[i3];
    if (factor > spacing) {
      return factor;
    }
  }
  return Math.max(spacing, 1);
}
function getMajorIndices(ticks) {
  const result = [];
  let i3, ilen;
  for (i3 = 0, ilen = ticks.length; i3 < ilen; i3++) {
    if (ticks[i3].major) {
      result.push(i3);
    }
  }
  return result;
}
function skipMajors(ticks, newTicks, majorIndices, spacing) {
  let count = 0;
  let next = majorIndices[0];
  let i3;
  spacing = Math.ceil(spacing);
  for (i3 = 0; i3 < ticks.length; i3++) {
    if (i3 === next) {
      newTicks.push(ticks[i3]);
      count++;
      next = majorIndices[count * spacing];
    }
  }
}
function skip(ticks, newTicks, spacing, majorStart, majorEnd) {
  const start = valueOrDefault(majorStart, 0);
  const end = Math.min(valueOrDefault(majorEnd, ticks.length), ticks.length);
  let count = 0;
  let length, i3, next;
  spacing = Math.ceil(spacing);
  if (majorEnd) {
    length = majorEnd - majorStart;
    spacing = length / Math.floor(length / spacing);
  }
  next = start;
  while (next < 0) {
    count++;
    next = Math.round(start + count * spacing);
  }
  for (i3 = Math.max(start, 0); i3 < end; i3++) {
    if (i3 === next) {
      newTicks.push(ticks[i3]);
      count++;
      next = Math.round(start + count * spacing);
    }
  }
}
function getEvenSpacing(arr) {
  const len = arr.length;
  let i3, diff;
  if (len < 2) {
    return false;
  }
  for (diff = arr[0], i3 = 1; i3 < len; ++i3) {
    if (arr[i3] - arr[i3 - 1] !== diff) {
      return false;
    }
  }
  return diff;
}
const reverseAlign = (align) => align === "left" ? "right" : align === "right" ? "left" : align;
const offsetFromEdge = (scale, edge, offset2) => edge === "top" || edge === "left" ? scale[edge] + offset2 : scale[edge] - offset2;
function sample(arr, numItems) {
  const result = [];
  const increment = arr.length / numItems;
  const len = arr.length;
  let i3 = 0;
  for (; i3 < len; i3 += increment) {
    result.push(arr[Math.floor(i3)]);
  }
  return result;
}
function getPixelForGridLine(scale, index2, offsetGridLines) {
  const length = scale.ticks.length;
  const validIndex2 = Math.min(index2, length - 1);
  const start = scale._startPixel;
  const end = scale._endPixel;
  const epsilon = 1e-6;
  let lineValue = scale.getPixelForTick(validIndex2);
  let offset2;
  if (offsetGridLines) {
    if (length === 1) {
      offset2 = Math.max(lineValue - start, end - lineValue);
    } else if (index2 === 0) {
      offset2 = (scale.getPixelForTick(1) - lineValue) / 2;
    } else {
      offset2 = (lineValue - scale.getPixelForTick(validIndex2 - 1)) / 2;
    }
    lineValue += validIndex2 < index2 ? offset2 : -offset2;
    if (lineValue < start - epsilon || lineValue > end + epsilon) {
      return;
    }
  }
  return lineValue;
}
function garbageCollect(caches, length) {
  each(caches, (cache) => {
    const gc = cache.gc;
    const gcLen = gc.length / 2;
    let i3;
    if (gcLen > length) {
      for (i3 = 0; i3 < gcLen; ++i3) {
        delete cache.data[gc[i3]];
      }
      gc.splice(0, gcLen);
    }
  });
}
function getTickMarkLength(options) {
  return options.drawTicks ? options.tickLength : 0;
}
function getTitleHeight(options, fallback) {
  if (!options.display) {
    return 0;
  }
  const font = toFont(options.font, fallback);
  const padding = toPadding(options.padding);
  const lines = isArray(options.text) ? options.text.length : 1;
  return lines * font.lineHeight + padding.height;
}
function createScaleContext(parent, scale) {
  return createContext(parent, {
    scale,
    type: "scale"
  });
}
function createTickContext(parent, index2, tick) {
  return createContext(parent, {
    tick,
    index: index2,
    type: "tick"
  });
}
function titleAlign(align, position2, reverse) {
  let ret = _toLeftRightCenter(align);
  if (reverse && position2 !== "right" || !reverse && position2 === "right") {
    ret = reverseAlign(ret);
  }
  return ret;
}
function titleArgs(scale, offset2, position2, align) {
  const { top, left, bottom, right, chart } = scale;
  const { chartArea, scales } = chart;
  let rotation = 0;
  let maxWidth, titleX, titleY;
  const height2 = bottom - top;
  const width = right - left;
  if (scale.isHorizontal()) {
    titleX = _alignStartEnd(align, left, right);
    if (isObject$3(position2)) {
      const positionAxisID = Object.keys(position2)[0];
      const value2 = position2[positionAxisID];
      titleY = scales[positionAxisID].getPixelForValue(value2) + height2 - offset2;
    } else if (position2 === "center") {
      titleY = (chartArea.bottom + chartArea.top) / 2 + height2 - offset2;
    } else {
      titleY = offsetFromEdge(scale, position2, offset2);
    }
    maxWidth = right - left;
  } else {
    if (isObject$3(position2)) {
      const positionAxisID = Object.keys(position2)[0];
      const value2 = position2[positionAxisID];
      titleX = scales[positionAxisID].getPixelForValue(value2) - width + offset2;
    } else if (position2 === "center") {
      titleX = (chartArea.left + chartArea.right) / 2 - width + offset2;
    } else {
      titleX = offsetFromEdge(scale, position2, offset2);
    }
    titleY = _alignStartEnd(align, bottom, top);
    rotation = position2 === "left" ? -HALF_PI : HALF_PI;
  }
  return { titleX, titleY, maxWidth, rotation };
}
class Scale extends Element$1 {
  constructor(cfg) {
    super();
    this.id = cfg.id;
    this.type = cfg.type;
    this.options = void 0;
    this.ctx = cfg.ctx;
    this.chart = cfg.chart;
    this.top = void 0;
    this.bottom = void 0;
    this.left = void 0;
    this.right = void 0;
    this.width = void 0;
    this.height = void 0;
    this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    };
    this.maxWidth = void 0;
    this.maxHeight = void 0;
    this.paddingTop = void 0;
    this.paddingBottom = void 0;
    this.paddingLeft = void 0;
    this.paddingRight = void 0;
    this.axis = void 0;
    this.labelRotation = void 0;
    this.min = void 0;
    this.max = void 0;
    this._range = void 0;
    this.ticks = [];
    this._gridLineItems = null;
    this._labelItems = null;
    this._labelSizes = null;
    this._length = 0;
    this._maxLength = 0;
    this._longestTextCache = {};
    this._startPixel = void 0;
    this._endPixel = void 0;
    this._reversePixels = false;
    this._userMax = void 0;
    this._userMin = void 0;
    this._suggestedMax = void 0;
    this._suggestedMin = void 0;
    this._ticksLength = 0;
    this._borderValue = 0;
    this._cache = {};
    this._dataLimitsCached = false;
    this.$context = void 0;
  }
  init(options) {
    this.options = options.setContext(this.getContext());
    this.axis = options.axis;
    this._userMin = this.parse(options.min);
    this._userMax = this.parse(options.max);
    this._suggestedMin = this.parse(options.suggestedMin);
    this._suggestedMax = this.parse(options.suggestedMax);
  }
  parse(raw, index2) {
    return raw;
  }
  getUserBounds() {
    let { _userMin, _userMax, _suggestedMin, _suggestedMax } = this;
    _userMin = finiteOrDefault(_userMin, Number.POSITIVE_INFINITY);
    _userMax = finiteOrDefault(_userMax, Number.NEGATIVE_INFINITY);
    _suggestedMin = finiteOrDefault(_suggestedMin, Number.POSITIVE_INFINITY);
    _suggestedMax = finiteOrDefault(_suggestedMax, Number.NEGATIVE_INFINITY);
    return {
      min: finiteOrDefault(_userMin, _suggestedMin),
      max: finiteOrDefault(_userMax, _suggestedMax),
      minDefined: isNumberFinite(_userMin),
      maxDefined: isNumberFinite(_userMax)
    };
  }
  getMinMax(canStack) {
    let { min: min2, max: max2, minDefined, maxDefined } = this.getUserBounds();
    let range2;
    if (minDefined && maxDefined) {
      return { min: min2, max: max2 };
    }
    const metas = this.getMatchingVisibleMetas();
    for (let i3 = 0, ilen = metas.length; i3 < ilen; ++i3) {
      range2 = metas[i3].controller.getMinMax(this, canStack);
      if (!minDefined) {
        min2 = Math.min(min2, range2.min);
      }
      if (!maxDefined) {
        max2 = Math.max(max2, range2.max);
      }
    }
    min2 = maxDefined && min2 > max2 ? max2 : min2;
    max2 = minDefined && min2 > max2 ? min2 : max2;
    return {
      min: finiteOrDefault(min2, finiteOrDefault(max2, min2)),
      max: finiteOrDefault(max2, finiteOrDefault(min2, max2))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const data = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
  }
  beforeLayout() {
    this._cache = {};
    this._dataLimitsCached = false;
  }
  beforeUpdate() {
    callback(this.options.beforeUpdate, [this]);
  }
  update(maxWidth, maxHeight, margins2) {
    const { beginAtZero, grace, ticks: tickOpts } = this.options;
    const sampleSize = tickOpts.sampleSize;
    this.beforeUpdate();
    this.maxWidth = maxWidth;
    this.maxHeight = maxHeight;
    this._margins = margins2 = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, margins2);
    this.ticks = null;
    this._labelSizes = null;
    this._gridLineItems = null;
    this._labelItems = null;
    this.beforeSetDimensions();
    this.setDimensions();
    this.afterSetDimensions();
    this._maxLength = this.isHorizontal() ? this.width + margins2.left + margins2.right : this.height + margins2.top + margins2.bottom;
    if (!this._dataLimitsCached) {
      this.beforeDataLimits();
      this.determineDataLimits();
      this.afterDataLimits();
      this._range = _addGrace(this, grace, beginAtZero);
      this._dataLimitsCached = true;
    }
    this.beforeBuildTicks();
    this.ticks = this.buildTicks() || [];
    this.afterBuildTicks();
    const samplingEnabled = sampleSize < this.ticks.length;
    this._convertTicksToLabels(samplingEnabled ? sample(this.ticks, sampleSize) : this.ticks);
    this.configure();
    this.beforeCalculateLabelRotation();
    this.calculateLabelRotation();
    this.afterCalculateLabelRotation();
    if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === "auto")) {
      this.ticks = autoSkip(this, this.ticks);
      this._labelSizes = null;
      this.afterAutoSkip();
    }
    if (samplingEnabled) {
      this._convertTicksToLabels(this.ticks);
    }
    this.beforeFit();
    this.fit();
    this.afterFit();
    this.afterUpdate();
  }
  configure() {
    let reversePixels = this.options.reverse;
    let startPixel, endPixel;
    if (this.isHorizontal()) {
      startPixel = this.left;
      endPixel = this.right;
    } else {
      startPixel = this.top;
      endPixel = this.bottom;
      reversePixels = !reversePixels;
    }
    this._startPixel = startPixel;
    this._endPixel = endPixel;
    this._reversePixels = reversePixels;
    this._length = endPixel - startPixel;
    this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    callback(this.options.afterUpdate, [this]);
  }
  beforeSetDimensions() {
    callback(this.options.beforeSetDimensions, [this]);
  }
  setDimensions() {
    if (this.isHorizontal()) {
      this.width = this.maxWidth;
      this.left = 0;
      this.right = this.width;
    } else {
      this.height = this.maxHeight;
      this.top = 0;
      this.bottom = this.height;
    }
    this.paddingLeft = 0;
    this.paddingTop = 0;
    this.paddingRight = 0;
    this.paddingBottom = 0;
  }
  afterSetDimensions() {
    callback(this.options.afterSetDimensions, [this]);
  }
  _callHooks(name2) {
    this.chart.notifyPlugins(name2, this.getContext());
    callback(this.options[name2], [this]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    callback(this.options.beforeTickToLabelConversion, [this]);
  }
  generateTickLabels(ticks) {
    const tickOpts = this.options.ticks;
    let i3, ilen, tick;
    for (i3 = 0, ilen = ticks.length; i3 < ilen; i3++) {
      tick = ticks[i3];
      tick.label = callback(tickOpts.callback, [tick.value, i3, ticks], this);
    }
  }
  afterTickToLabelConversion() {
    callback(this.options.afterTickToLabelConversion, [this]);
  }
  beforeCalculateLabelRotation() {
    callback(this.options.beforeCalculateLabelRotation, [this]);
  }
  calculateLabelRotation() {
    const options = this.options;
    const tickOpts = options.ticks;
    const numTicks = this.ticks.length;
    const minRotation = tickOpts.minRotation || 0;
    const maxRotation = tickOpts.maxRotation;
    let labelRotation = minRotation;
    let tickWidth, maxHeight, maxLabelDiagonal;
    if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
      this.labelRotation = minRotation;
      return;
    }
    const labelSizes = this._getLabelSizes();
    const maxLabelWidth = labelSizes.widest.width;
    const maxLabelHeight = labelSizes.highest.height;
    const maxWidth = _limitValue(this.chart.width - maxLabelWidth, 0, this.maxWidth);
    tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
    if (maxLabelWidth + 6 > tickWidth) {
      tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
      maxHeight = this.maxHeight - getTickMarkLength(options.grid) - tickOpts.padding - getTitleHeight(options.title, this.chart.options.font);
      maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
      labelRotation = toDegrees(Math.min(
        Math.asin(_limitValue((labelSizes.highest.height + 6) / tickWidth, -1, 1)),
        Math.asin(_limitValue(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin(_limitValue(maxLabelHeight / maxLabelDiagonal, -1, 1))
      ));
      labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
    }
    this.labelRotation = labelRotation;
  }
  afterCalculateLabelRotation() {
    callback(this.options.afterCalculateLabelRotation, [this]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    callback(this.options.beforeFit, [this]);
  }
  fit() {
    const minSize = {
      width: 0,
      height: 0
    };
    const { chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
    const display = this._isVisible();
    const isHorizontal = this.isHorizontal();
    if (display) {
      const titleHeight = getTitleHeight(titleOpts, chart.options.font);
      if (isHorizontal) {
        minSize.width = this.maxWidth;
        minSize.height = getTickMarkLength(gridOpts) + titleHeight;
      } else {
        minSize.height = this.maxHeight;
        minSize.width = getTickMarkLength(gridOpts) + titleHeight;
      }
      if (tickOpts.display && this.ticks.length) {
        const { first, last: last2, widest, highest } = this._getLabelSizes();
        const tickPadding = tickOpts.padding * 2;
        const angleRadians = toRadians(this.labelRotation);
        const cos = Math.cos(angleRadians);
        const sin = Math.sin(angleRadians);
        if (isHorizontal) {
          const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
          minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
        } else {
          const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
          minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
        }
        this._calculatePadding(first, last2, sin, cos);
      }
    }
    this._handleMargins();
    if (isHorizontal) {
      this.width = this._length = chart.width - this._margins.left - this._margins.right;
      this.height = minSize.height;
    } else {
      this.width = minSize.width;
      this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
    }
  }
  _calculatePadding(first, last2, sin, cos) {
    const { ticks: { align, padding }, position: position2 } = this.options;
    const isRotated = this.labelRotation !== 0;
    const labelsBelowTicks = position2 !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const offsetLeft = this.getPixelForTick(0) - this.left;
      const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
      let paddingLeft = 0;
      let paddingRight = 0;
      if (isRotated) {
        if (labelsBelowTicks) {
          paddingLeft = cos * first.width;
          paddingRight = sin * last2.height;
        } else {
          paddingLeft = sin * first.height;
          paddingRight = cos * last2.width;
        }
      } else if (align === "start") {
        paddingRight = last2.width;
      } else if (align === "end") {
        paddingLeft = first.width;
      } else if (align !== "inner") {
        paddingLeft = first.width / 2;
        paddingRight = last2.width / 2;
      }
      this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
      this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
    } else {
      let paddingTop = last2.height / 2;
      let paddingBottom = first.height / 2;
      if (align === "start") {
        paddingTop = 0;
        paddingBottom = first.height;
      } else if (align === "end") {
        paddingTop = last2.height;
        paddingBottom = 0;
      }
      this.paddingTop = paddingTop + padding;
      this.paddingBottom = paddingBottom + padding;
    }
  }
  _handleMargins() {
    if (this._margins) {
      this._margins.left = Math.max(this.paddingLeft, this._margins.left);
      this._margins.top = Math.max(this.paddingTop, this._margins.top);
      this._margins.right = Math.max(this.paddingRight, this._margins.right);
      this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
    }
  }
  afterFit() {
    callback(this.options.afterFit, [this]);
  }
  isHorizontal() {
    const { axis, position: position2 } = this.options;
    return position2 === "top" || position2 === "bottom" || axis === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(ticks) {
    this.beforeTickToLabelConversion();
    this.generateTickLabels(ticks);
    let i3, ilen;
    for (i3 = 0, ilen = ticks.length; i3 < ilen; i3++) {
      if (isNullOrUndef(ticks[i3].label)) {
        ticks.splice(i3, 1);
        ilen--;
        i3--;
      }
    }
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let labelSizes = this._labelSizes;
    if (!labelSizes) {
      const sampleSize = this.options.ticks.sampleSize;
      let ticks = this.ticks;
      if (sampleSize < ticks.length) {
        ticks = sample(ticks, sampleSize);
      }
      this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length);
    }
    return labelSizes;
  }
  _computeLabelSizes(ticks, length) {
    const { ctx, _longestTextCache: caches } = this;
    const widths = [];
    const heights = [];
    let widestLabelSize = 0;
    let highestLabelSize = 0;
    let i3, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height2, nestedLabel;
    for (i3 = 0; i3 < length; ++i3) {
      label = ticks[i3].label;
      tickFont = this._resolveTickFontOptions(i3);
      ctx.font = fontString = tickFont.string;
      cache = caches[fontString] = caches[fontString] || { data: {}, gc: [] };
      lineHeight = tickFont.lineHeight;
      width = height2 = 0;
      if (!isNullOrUndef(label) && !isArray(label)) {
        width = _measureText(ctx, cache.data, cache.gc, width, label);
        height2 = lineHeight;
      } else if (isArray(label)) {
        for (j = 0, jlen = label.length; j < jlen; ++j) {
          nestedLabel = label[j];
          if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
            width = _measureText(ctx, cache.data, cache.gc, width, nestedLabel);
            height2 += lineHeight;
          }
        }
      }
      widths.push(width);
      heights.push(height2);
      widestLabelSize = Math.max(width, widestLabelSize);
      highestLabelSize = Math.max(height2, highestLabelSize);
    }
    garbageCollect(caches, length);
    const widest = widths.indexOf(widestLabelSize);
    const highest = heights.indexOf(highestLabelSize);
    const valueAt = (idx) => ({ width: widths[idx] || 0, height: heights[idx] || 0 });
    return {
      first: valueAt(0),
      last: valueAt(length - 1),
      widest: valueAt(widest),
      highest: valueAt(highest),
      widths,
      heights
    };
  }
  getLabelForValue(value2) {
    return value2;
  }
  getPixelForValue(value2, index2) {
    return NaN;
  }
  getValueForPixel(pixel) {
  }
  getPixelForTick(index2) {
    const ticks = this.ticks;
    if (index2 < 0 || index2 > ticks.length - 1) {
      return null;
    }
    return this.getPixelForValue(ticks[index2].value);
  }
  getPixelForDecimal(decimal2) {
    if (this._reversePixels) {
      decimal2 = 1 - decimal2;
    }
    const pixel = this._startPixel + decimal2 * this._length;
    return _int16Range(this._alignToPixels ? _alignPixel(this.chart, pixel, 0) : pixel);
  }
  getDecimalForPixel(pixel) {
    const decimal2 = (pixel - this._startPixel) / this._length;
    return this._reversePixels ? 1 - decimal2 : decimal2;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: min2, max: max2 } = this;
    return min2 < 0 && max2 < 0 ? max2 : min2 > 0 && max2 > 0 ? min2 : 0;
  }
  getContext(index2) {
    const ticks = this.ticks || [];
    if (index2 >= 0 && index2 < ticks.length) {
      const tick = ticks[index2];
      return tick.$context || (tick.$context = createTickContext(this.getContext(), index2, tick));
    }
    return this.$context || (this.$context = createScaleContext(this.chart.getContext(), this));
  }
  _tickSize() {
    const optionTicks = this.options.ticks;
    const rot = toRadians(this.labelRotation);
    const cos = Math.abs(Math.cos(rot));
    const sin = Math.abs(Math.sin(rot));
    const labelSizes = this._getLabelSizes();
    const padding = optionTicks.autoSkipPadding || 0;
    const w3 = labelSizes ? labelSizes.widest.width + padding : 0;
    const h6 = labelSizes ? labelSizes.highest.height + padding : 0;
    return this.isHorizontal() ? h6 * cos > w3 * sin ? w3 / cos : h6 / sin : h6 * sin < w3 * cos ? h6 / cos : w3 / sin;
  }
  _isVisible() {
    const display = this.options.display;
    if (display !== "auto") {
      return !!display;
    }
    return this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(chartArea) {
    const axis = this.axis;
    const chart = this.chart;
    const options = this.options;
    const { grid, position: position2 } = options;
    const offset2 = grid.offset;
    const isHorizontal = this.isHorizontal();
    const ticks = this.ticks;
    const ticksLength = ticks.length + (offset2 ? 1 : 0);
    const tl = getTickMarkLength(grid);
    const items = [];
    const borderOpts = grid.setContext(this.getContext());
    const axisWidth = borderOpts.drawBorder ? borderOpts.borderWidth : 0;
    const axisHalfWidth = axisWidth / 2;
    const alignBorderValue = function(pixel) {
      return _alignPixel(chart, pixel, axisWidth);
    };
    let borderValue, i3, lineValue, alignedLineValue;
    let tx1, ty1, tx2, ty2, x1, y1, x22, y23;
    if (position2 === "top") {
      borderValue = alignBorderValue(this.bottom);
      ty1 = this.bottom - tl;
      ty2 = borderValue - axisHalfWidth;
      y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
      y23 = chartArea.bottom;
    } else if (position2 === "bottom") {
      borderValue = alignBorderValue(this.top);
      y1 = chartArea.top;
      y23 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
      ty1 = borderValue + axisHalfWidth;
      ty2 = this.top + tl;
    } else if (position2 === "left") {
      borderValue = alignBorderValue(this.right);
      tx1 = this.right - tl;
      tx2 = borderValue - axisHalfWidth;
      x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
      x22 = chartArea.right;
    } else if (position2 === "right") {
      borderValue = alignBorderValue(this.left);
      x1 = chartArea.left;
      x22 = alignBorderValue(chartArea.right) - axisHalfWidth;
      tx1 = borderValue + axisHalfWidth;
      tx2 = this.left + tl;
    } else if (axis === "x") {
      if (position2 === "center") {
        borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
      } else if (isObject$3(position2)) {
        const positionAxisID = Object.keys(position2)[0];
        const value2 = position2[positionAxisID];
        borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value2));
      }
      y1 = chartArea.top;
      y23 = chartArea.bottom;
      ty1 = borderValue + axisHalfWidth;
      ty2 = ty1 + tl;
    } else if (axis === "y") {
      if (position2 === "center") {
        borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
      } else if (isObject$3(position2)) {
        const positionAxisID = Object.keys(position2)[0];
        const value2 = position2[positionAxisID];
        borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value2));
      }
      tx1 = borderValue - axisHalfWidth;
      tx2 = tx1 - tl;
      x1 = chartArea.left;
      x22 = chartArea.right;
    }
    const limit2 = valueOrDefault(options.ticks.maxTicksLimit, ticksLength);
    const step = Math.max(1, Math.ceil(ticksLength / limit2));
    for (i3 = 0; i3 < ticksLength; i3 += step) {
      const optsAtIndex = grid.setContext(this.getContext(i3));
      const lineWidth = optsAtIndex.lineWidth;
      const lineColor = optsAtIndex.color;
      const borderDash = optsAtIndex.borderDash || [];
      const borderDashOffset = optsAtIndex.borderDashOffset;
      const tickWidth = optsAtIndex.tickWidth;
      const tickColor = optsAtIndex.tickColor;
      const tickBorderDash = optsAtIndex.tickBorderDash || [];
      const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
      lineValue = getPixelForGridLine(this, i3, offset2);
      if (lineValue === void 0) {
        continue;
      }
      alignedLineValue = _alignPixel(chart, lineValue, lineWidth);
      if (isHorizontal) {
        tx1 = tx2 = x1 = x22 = alignedLineValue;
      } else {
        ty1 = ty2 = y1 = y23 = alignedLineValue;
      }
      items.push({
        tx1,
        ty1,
        tx2,
        ty2,
        x1,
        y1,
        x2: x22,
        y2: y23,
        width: lineWidth,
        color: lineColor,
        borderDash,
        borderDashOffset,
        tickWidth,
        tickColor,
        tickBorderDash,
        tickBorderDashOffset
      });
    }
    this._ticksLength = ticksLength;
    this._borderValue = borderValue;
    return items;
  }
  _computeLabelItems(chartArea) {
    const axis = this.axis;
    const options = this.options;
    const { position: position2, ticks: optionTicks } = options;
    const isHorizontal = this.isHorizontal();
    const ticks = this.ticks;
    const { align, crossAlign, padding, mirror } = optionTicks;
    const tl = getTickMarkLength(options.grid);
    const tickAndPadding = tl + padding;
    const hTickAndPadding = mirror ? -padding : tickAndPadding;
    const rotation = -toRadians(this.labelRotation);
    const items = [];
    let i3, ilen, tick, label, x3, y4, textAlign, pixel, font, lineHeight, lineCount, textOffset;
    let textBaseline = "middle";
    if (position2 === "top") {
      y4 = this.bottom - hTickAndPadding;
      textAlign = this._getXAxisLabelAlignment();
    } else if (position2 === "bottom") {
      y4 = this.top + hTickAndPadding;
      textAlign = this._getXAxisLabelAlignment();
    } else if (position2 === "left") {
      const ret = this._getYAxisLabelAlignment(tl);
      textAlign = ret.textAlign;
      x3 = ret.x;
    } else if (position2 === "right") {
      const ret = this._getYAxisLabelAlignment(tl);
      textAlign = ret.textAlign;
      x3 = ret.x;
    } else if (axis === "x") {
      if (position2 === "center") {
        y4 = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
      } else if (isObject$3(position2)) {
        const positionAxisID = Object.keys(position2)[0];
        const value2 = position2[positionAxisID];
        y4 = this.chart.scales[positionAxisID].getPixelForValue(value2) + tickAndPadding;
      }
      textAlign = this._getXAxisLabelAlignment();
    } else if (axis === "y") {
      if (position2 === "center") {
        x3 = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
      } else if (isObject$3(position2)) {
        const positionAxisID = Object.keys(position2)[0];
        const value2 = position2[positionAxisID];
        x3 = this.chart.scales[positionAxisID].getPixelForValue(value2);
      }
      textAlign = this._getYAxisLabelAlignment(tl).textAlign;
    }
    if (axis === "y") {
      if (align === "start") {
        textBaseline = "top";
      } else if (align === "end") {
        textBaseline = "bottom";
      }
    }
    const labelSizes = this._getLabelSizes();
    for (i3 = 0, ilen = ticks.length; i3 < ilen; ++i3) {
      tick = ticks[i3];
      label = tick.label;
      const optsAtIndex = optionTicks.setContext(this.getContext(i3));
      pixel = this.getPixelForTick(i3) + optionTicks.labelOffset;
      font = this._resolveTickFontOptions(i3);
      lineHeight = font.lineHeight;
      lineCount = isArray(label) ? label.length : 1;
      const halfCount = lineCount / 2;
      const color2 = optsAtIndex.color;
      const strokeColor = optsAtIndex.textStrokeColor;
      const strokeWidth = optsAtIndex.textStrokeWidth;
      let tickTextAlign = textAlign;
      if (isHorizontal) {
        x3 = pixel;
        if (textAlign === "inner") {
          if (i3 === ilen - 1) {
            tickTextAlign = !this.options.reverse ? "right" : "left";
          } else if (i3 === 0) {
            tickTextAlign = !this.options.reverse ? "left" : "right";
          } else {
            tickTextAlign = "center";
          }
        }
        if (position2 === "top") {
          if (crossAlign === "near" || rotation !== 0) {
            textOffset = -lineCount * lineHeight + lineHeight / 2;
          } else if (crossAlign === "center") {
            textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
          } else {
            textOffset = -labelSizes.highest.height + lineHeight / 2;
          }
        } else {
          if (crossAlign === "near" || rotation !== 0) {
            textOffset = lineHeight / 2;
          } else if (crossAlign === "center") {
            textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
          } else {
            textOffset = labelSizes.highest.height - lineCount * lineHeight;
          }
        }
        if (mirror) {
          textOffset *= -1;
        }
      } else {
        y4 = pixel;
        textOffset = (1 - lineCount) * lineHeight / 2;
      }
      let backdrop;
      if (optsAtIndex.showLabelBackdrop) {
        const labelPadding = toPadding(optsAtIndex.backdropPadding);
        const height2 = labelSizes.heights[i3];
        const width = labelSizes.widths[i3];
        let top = y4 + textOffset - labelPadding.top;
        let left = x3 - labelPadding.left;
        switch (textBaseline) {
          case "middle":
            top -= height2 / 2;
            break;
          case "bottom":
            top -= height2;
            break;
        }
        switch (textAlign) {
          case "center":
            left -= width / 2;
            break;
          case "right":
            left -= width;
            break;
        }
        backdrop = {
          left,
          top,
          width: width + labelPadding.width,
          height: height2 + labelPadding.height,
          color: optsAtIndex.backdropColor
        };
      }
      items.push({
        rotation,
        label,
        font,
        color: color2,
        strokeColor,
        strokeWidth,
        textOffset,
        textAlign: tickTextAlign,
        textBaseline,
        translation: [x3, y4],
        backdrop
      });
    }
    return items;
  }
  _getXAxisLabelAlignment() {
    const { position: position2, ticks } = this.options;
    const rotation = -toRadians(this.labelRotation);
    if (rotation) {
      return position2 === "top" ? "left" : "right";
    }
    let align = "center";
    if (ticks.align === "start") {
      align = "left";
    } else if (ticks.align === "end") {
      align = "right";
    } else if (ticks.align === "inner") {
      align = "inner";
    }
    return align;
  }
  _getYAxisLabelAlignment(tl) {
    const { position: position2, ticks: { crossAlign, mirror, padding } } = this.options;
    const labelSizes = this._getLabelSizes();
    const tickAndPadding = tl + padding;
    const widest = labelSizes.widest.width;
    let textAlign;
    let x3;
    if (position2 === "left") {
      if (mirror) {
        x3 = this.right + padding;
        if (crossAlign === "near") {
          textAlign = "left";
        } else if (crossAlign === "center") {
          textAlign = "center";
          x3 += widest / 2;
        } else {
          textAlign = "right";
          x3 += widest;
        }
      } else {
        x3 = this.right - tickAndPadding;
        if (crossAlign === "near") {
          textAlign = "right";
        } else if (crossAlign === "center") {
          textAlign = "center";
          x3 -= widest / 2;
        } else {
          textAlign = "left";
          x3 = this.left;
        }
      }
    } else if (position2 === "right") {
      if (mirror) {
        x3 = this.left + padding;
        if (crossAlign === "near") {
          textAlign = "right";
        } else if (crossAlign === "center") {
          textAlign = "center";
          x3 -= widest / 2;
        } else {
          textAlign = "left";
          x3 -= widest;
        }
      } else {
        x3 = this.left + tickAndPadding;
        if (crossAlign === "near") {
          textAlign = "left";
        } else if (crossAlign === "center") {
          textAlign = "center";
          x3 += widest / 2;
        } else {
          textAlign = "right";
          x3 = this.right;
        }
      }
    } else {
      textAlign = "right";
    }
    return { textAlign, x: x3 };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror) {
      return;
    }
    const chart = this.chart;
    const position2 = this.options.position;
    if (position2 === "left" || position2 === "right") {
      return { top: 0, left: this.left, bottom: chart.height, right: this.right };
    }
    if (position2 === "top" || position2 === "bottom") {
      return { top: this.top, left: 0, bottom: this.bottom, right: chart.width };
    }
  }
  drawBackground() {
    const { ctx, options: { backgroundColor }, left, top, width, height: height2 } = this;
    if (backgroundColor) {
      ctx.save();
      ctx.fillStyle = backgroundColor;
      ctx.fillRect(left, top, width, height2);
      ctx.restore();
    }
  }
  getLineWidthForValue(value2) {
    const grid = this.options.grid;
    if (!this._isVisible() || !grid.display) {
      return 0;
    }
    const ticks = this.ticks;
    const index2 = ticks.findIndex((t3) => t3.value === value2);
    if (index2 >= 0) {
      const opts = grid.setContext(this.getContext(index2));
      return opts.lineWidth;
    }
    return 0;
  }
  drawGrid(chartArea) {
    const grid = this.options.grid;
    const ctx = this.ctx;
    const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
    let i3, ilen;
    const drawLine = (p1, p2, style) => {
      if (!style.width || !style.color) {
        return;
      }
      ctx.save();
      ctx.lineWidth = style.width;
      ctx.strokeStyle = style.color;
      ctx.setLineDash(style.borderDash || []);
      ctx.lineDashOffset = style.borderDashOffset;
      ctx.beginPath();
      ctx.moveTo(p1.x, p1.y);
      ctx.lineTo(p2.x, p2.y);
      ctx.stroke();
      ctx.restore();
    };
    if (grid.display) {
      for (i3 = 0, ilen = items.length; i3 < ilen; ++i3) {
        const item = items[i3];
        if (grid.drawOnChartArea) {
          drawLine(
            { x: item.x1, y: item.y1 },
            { x: item.x2, y: item.y2 },
            item
          );
        }
        if (grid.drawTicks) {
          drawLine(
            { x: item.tx1, y: item.ty1 },
            { x: item.tx2, y: item.ty2 },
            {
              color: item.tickColor,
              width: item.tickWidth,
              borderDash: item.tickBorderDash,
              borderDashOffset: item.tickBorderDashOffset
            }
          );
        }
      }
    }
  }
  drawBorder() {
    const { chart, ctx, options: { grid } } = this;
    const borderOpts = grid.setContext(this.getContext());
    const axisWidth = grid.drawBorder ? borderOpts.borderWidth : 0;
    if (!axisWidth) {
      return;
    }
    const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
    const borderValue = this._borderValue;
    let x1, x22, y1, y23;
    if (this.isHorizontal()) {
      x1 = _alignPixel(chart, this.left, axisWidth) - axisWidth / 2;
      x22 = _alignPixel(chart, this.right, lastLineWidth) + lastLineWidth / 2;
      y1 = y23 = borderValue;
    } else {
      y1 = _alignPixel(chart, this.top, axisWidth) - axisWidth / 2;
      y23 = _alignPixel(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
      x1 = x22 = borderValue;
    }
    ctx.save();
    ctx.lineWidth = borderOpts.borderWidth;
    ctx.strokeStyle = borderOpts.borderColor;
    ctx.beginPath();
    ctx.moveTo(x1, y1);
    ctx.lineTo(x22, y23);
    ctx.stroke();
    ctx.restore();
  }
  drawLabels(chartArea) {
    const optionTicks = this.options.ticks;
    if (!optionTicks.display) {
      return;
    }
    const ctx = this.ctx;
    const area = this._computeLabelArea();
    if (area) {
      clipArea(ctx, area);
    }
    const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
    let i3, ilen;
    for (i3 = 0, ilen = items.length; i3 < ilen; ++i3) {
      const item = items[i3];
      const tickFont = item.font;
      const label = item.label;
      if (item.backdrop) {
        ctx.fillStyle = item.backdrop.color;
        ctx.fillRect(item.backdrop.left, item.backdrop.top, item.backdrop.width, item.backdrop.height);
      }
      let y4 = item.textOffset;
      renderText(ctx, label, 0, y4, tickFont, item);
    }
    if (area) {
      unclipArea(ctx);
    }
  }
  drawTitle() {
    const { ctx, options: { position: position2, title, reverse } } = this;
    if (!title.display) {
      return;
    }
    const font = toFont(title.font);
    const padding = toPadding(title.padding);
    const align = title.align;
    let offset2 = font.lineHeight / 2;
    if (position2 === "bottom" || position2 === "center" || isObject$3(position2)) {
      offset2 += padding.bottom;
      if (isArray(title.text)) {
        offset2 += font.lineHeight * (title.text.length - 1);
      }
    } else {
      offset2 += padding.top;
    }
    const { titleX, titleY, maxWidth, rotation } = titleArgs(this, offset2, position2, align);
    renderText(ctx, title.text, 0, 0, font, {
      color: title.color,
      maxWidth,
      rotation,
      textAlign: titleAlign(align, position2, reverse),
      textBaseline: "middle",
      translation: [titleX, titleY]
    });
  }
  draw(chartArea) {
    if (!this._isVisible()) {
      return;
    }
    this.drawBackground();
    this.drawGrid(chartArea);
    this.drawBorder();
    this.drawTitle();
    this.drawLabels(chartArea);
  }
  _layers() {
    const opts = this.options;
    const tz = opts.ticks && opts.ticks.z || 0;
    const gz = valueOrDefault(opts.grid && opts.grid.z, -1);
    if (!this._isVisible() || this.draw !== Scale.prototype.draw) {
      return [{
        z: tz,
        draw: (chartArea) => {
          this.draw(chartArea);
        }
      }];
    }
    return [{
      z: gz,
      draw: (chartArea) => {
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawTitle();
      }
    }, {
      z: gz + 1,
      draw: () => {
        this.drawBorder();
      }
    }, {
      z: tz,
      draw: (chartArea) => {
        this.drawLabels(chartArea);
      }
    }];
  }
  getMatchingVisibleMetas(type2) {
    const metas = this.chart.getSortedVisibleDatasetMetas();
    const axisID = this.axis + "AxisID";
    const result = [];
    let i3, ilen;
    for (i3 = 0, ilen = metas.length; i3 < ilen; ++i3) {
      const meta = metas[i3];
      if (meta[axisID] === this.id && (!type2 || meta.type === type2)) {
        result.push(meta);
      }
    }
    return result;
  }
  _resolveTickFontOptions(index2) {
    const opts = this.options.ticks.setContext(this.getContext(index2));
    return toFont(opts.font);
  }
  _maxDigits() {
    const fontSize = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / fontSize;
  }
}
class TypedRegistry {
  constructor(type2, scope, override) {
    this.type = type2;
    this.scope = scope;
    this.override = override;
    this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(type2) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, type2.prototype);
  }
  register(item) {
    const proto = Object.getPrototypeOf(item);
    let parentScope;
    if (isIChartComponent(proto)) {
      parentScope = this.register(proto);
    }
    const items = this.items;
    const id3 = item.id;
    const scope = this.scope + "." + id3;
    if (!id3) {
      throw new Error("class does not have id: " + item);
    }
    if (id3 in items) {
      return scope;
    }
    items[id3] = item;
    registerDefaults(item, scope, parentScope);
    if (this.override) {
      defaults$1.override(item.id, item.overrides);
    }
    return scope;
  }
  get(id3) {
    return this.items[id3];
  }
  unregister(item) {
    const items = this.items;
    const id3 = item.id;
    const scope = this.scope;
    if (id3 in items) {
      delete items[id3];
    }
    if (scope && id3 in defaults$1[scope]) {
      delete defaults$1[scope][id3];
      if (this.override) {
        delete overrides[id3];
      }
    }
  }
}
function registerDefaults(item, scope, parentScope) {
  const itemDefaults = merge(/* @__PURE__ */ Object.create(null), [
    parentScope ? defaults$1.get(parentScope) : {},
    defaults$1.get(scope),
    item.defaults
  ]);
  defaults$1.set(scope, itemDefaults);
  if (item.defaultRoutes) {
    routeDefaults(scope, item.defaultRoutes);
  }
  if (item.descriptors) {
    defaults$1.describe(scope, item.descriptors);
  }
}
function routeDefaults(scope, routes) {
  Object.keys(routes).forEach((property) => {
    const propertyParts = property.split(".");
    const sourceName = propertyParts.pop();
    const sourceScope = [scope].concat(propertyParts).join(".");
    const parts = routes[property].split(".");
    const targetName = parts.pop();
    const targetScope = parts.join(".");
    defaults$1.route(sourceScope, sourceName, targetScope, targetName);
  });
}
function isIChartComponent(proto) {
  return "id" in proto && "defaults" in proto;
}
class Registry {
  constructor() {
    this.controllers = new TypedRegistry(DatasetController, "datasets", true);
    this.elements = new TypedRegistry(Element$1, "elements");
    this.plugins = new TypedRegistry(Object, "plugins");
    this.scales = new TypedRegistry(Scale, "scales");
    this._typedRegistries = [this.controllers, this.scales, this.elements];
  }
  add(...args) {
    this._each("register", args);
  }
  remove(...args) {
    this._each("unregister", args);
  }
  addControllers(...args) {
    this._each("register", args, this.controllers);
  }
  addElements(...args) {
    this._each("register", args, this.elements);
  }
  addPlugins(...args) {
    this._each("register", args, this.plugins);
  }
  addScales(...args) {
    this._each("register", args, this.scales);
  }
  getController(id3) {
    return this._get(id3, this.controllers, "controller");
  }
  getElement(id3) {
    return this._get(id3, this.elements, "element");
  }
  getPlugin(id3) {
    return this._get(id3, this.plugins, "plugin");
  }
  getScale(id3) {
    return this._get(id3, this.scales, "scale");
  }
  removeControllers(...args) {
    this._each("unregister", args, this.controllers);
  }
  removeElements(...args) {
    this._each("unregister", args, this.elements);
  }
  removePlugins(...args) {
    this._each("unregister", args, this.plugins);
  }
  removeScales(...args) {
    this._each("unregister", args, this.scales);
  }
  _each(method, args, typedRegistry) {
    [...args].forEach((arg) => {
      const reg = typedRegistry || this._getRegistryForType(arg);
      if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) {
        this._exec(method, reg, arg);
      } else {
        each(arg, (item) => {
          const itemReg = typedRegistry || this._getRegistryForType(item);
          this._exec(method, itemReg, item);
        });
      }
    });
  }
  _exec(method, registry2, component) {
    const camelMethod = _capitalize(method);
    callback(component["before" + camelMethod], [], component);
    registry2[method](component);
    callback(component["after" + camelMethod], [], component);
  }
  _getRegistryForType(type2) {
    for (let i3 = 0; i3 < this._typedRegistries.length; i3++) {
      const reg = this._typedRegistries[i3];
      if (reg.isForType(type2)) {
        return reg;
      }
    }
    return this.plugins;
  }
  _get(id3, typedRegistry, type2) {
    const item = typedRegistry.get(id3);
    if (item === void 0) {
      throw new Error('"' + id3 + '" is not a registered ' + type2 + ".");
    }
    return item;
  }
}
var registry = new Registry();
class ScatterController extends DatasetController {
  update(mode) {
    const meta = this._cachedMeta;
    const { data: points = [] } = meta;
    const animationsDisabled = this.chart._animationsDisabled;
    let { start, count } = _getStartAndCountOfVisiblePoints(meta, points, animationsDisabled);
    this._drawStart = start;
    this._drawCount = count;
    if (_scaleRangesChanged(meta)) {
      start = 0;
      count = points.length;
    }
    if (this.options.showLine) {
      const { dataset: line, _dataset } = meta;
      line._chart = this.chart;
      line._datasetIndex = this.index;
      line._decimated = !!_dataset._decimated;
      line.points = points;
      const options = this.resolveDatasetElementOptions(mode);
      options.segment = this.options.segment;
      this.updateElement(line, void 0, {
        animated: !animationsDisabled,
        options
      }, mode);
    }
    this.updateElements(points, start, count, mode);
  }
  addElements() {
    const { showLine } = this.options;
    if (!this.datasetElementType && showLine) {
      this.datasetElementType = registry.getElement("line");
    }
    super.addElements();
  }
  updateElements(points, start, count, mode) {
    const reset = mode === "reset";
    const { iScale, vScale, _stacked, _dataset } = this._cachedMeta;
    const firstOpts = this.resolveDataElementOptions(start, mode);
    const sharedOptions = this.getSharedOptions(firstOpts);
    const includeOptions = this.includeOptions(mode, sharedOptions);
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const { spanGaps, segment } = this.options;
    const maxGapLength = isNumber$2(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
    const directUpdate = this.chart._animationsDisabled || reset || mode === "none";
    let prevParsed = start > 0 && this.getParsed(start - 1);
    for (let i3 = start; i3 < start + count; ++i3) {
      const point = points[i3];
      const parsed = this.getParsed(i3);
      const properties = directUpdate ? point : {};
      const nullData = isNullOrUndef(parsed[vAxis]);
      const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i3);
      const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i3);
      properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
      properties.stop = i3 > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
      if (segment) {
        properties.parsed = parsed;
        properties.raw = _dataset.data[i3];
      }
      if (includeOptions) {
        properties.options = sharedOptions || this.resolveDataElementOptions(i3, point.active ? "active" : mode);
      }
      if (!directUpdate) {
        this.updateElement(point, i3, properties, mode);
      }
      prevParsed = parsed;
    }
    this.updateSharedOptions(sharedOptions, mode, firstOpts);
  }
  getMaxOverflow() {
    const meta = this._cachedMeta;
    const data = meta.data || [];
    if (!this.options.showLine) {
      let max2 = 0;
      for (let i3 = data.length - 1; i3 >= 0; --i3) {
        max2 = Math.max(max2, data[i3].size(this.resolveDataElementOptions(i3)) / 2);
      }
      return max2 > 0 && max2;
    }
    const dataset = meta.dataset;
    const border = dataset.options && dataset.options.borderWidth || 0;
    if (!data.length) {
      return border;
    }
    const firstPoint = data[0].size(this.resolveDataElementOptions(0));
    const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
    return Math.max(border, firstPoint, lastPoint) / 2;
  }
}
ScatterController.id = "scatter";
ScatterController.defaults = {
  datasetElementType: false,
  dataElementType: "point",
  showLine: false,
  fill: false
};
ScatterController.overrides = {
  interaction: {
    mode: "point"
  },
  plugins: {
    tooltip: {
      callbacks: {
        title() {
          return "";
        },
        label(item) {
          return "(" + item.label + ", " + item.formattedValue + ")";
        }
      }
    }
  },
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
};
function abstract() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class DateAdapter {
  constructor(options) {
    this.options = options || {};
  }
  init(chartOptions) {
  }
  formats() {
    return abstract();
  }
  parse(value2, format2) {
    return abstract();
  }
  format(timestamp, format2) {
    return abstract();
  }
  add(timestamp, amount, unit) {
    return abstract();
  }
  diff(a4, b3, unit) {
    return abstract();
  }
  startOf(timestamp, unit, weekday) {
    return abstract();
  }
  endOf(timestamp, unit) {
    return abstract();
  }
}
DateAdapter.override = function(members) {
  Object.assign(DateAdapter.prototype, members);
};
var adapters = {
  _date: DateAdapter
};
function binarySearch(metaset, axis, value2, intersect) {
  const { controller, data, _sorted } = metaset;
  const iScale = controller._cachedMeta.iScale;
  if (iScale && axis === iScale.axis && axis !== "r" && _sorted && data.length) {
    const lookupMethod = iScale._reversePixels ? _rlookupByKey : _lookupByKey;
    if (!intersect) {
      return lookupMethod(data, axis, value2);
    } else if (controller._sharedOptions) {
      const el = data[0];
      const range2 = typeof el.getRange === "function" && el.getRange(axis);
      if (range2) {
        const start = lookupMethod(data, axis, value2 - range2);
        const end = lookupMethod(data, axis, value2 + range2);
        return { lo: start.lo, hi: end.hi };
      }
    }
  }
  return { lo: 0, hi: data.length - 1 };
}
function evaluateInteractionItems(chart, axis, position2, handler, intersect) {
  const metasets = chart.getSortedVisibleDatasetMetas();
  const value2 = position2[axis];
  for (let i3 = 0, ilen = metasets.length; i3 < ilen; ++i3) {
    const { index: index2, data } = metasets[i3];
    const { lo: lo2, hi } = binarySearch(metasets[i3], axis, value2, intersect);
    for (let j = lo2; j <= hi; ++j) {
      const element = data[j];
      if (!element.skip) {
        handler(element, index2, j);
      }
    }
  }
}
function getDistanceMetricForAxis(axis) {
  const useX = axis.indexOf("x") !== -1;
  const useY = axis.indexOf("y") !== -1;
  return function(pt1, pt2) {
    const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
    const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
    return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
  };
}
function getIntersectItems(chart, position2, axis, useFinalPosition, includeInvisible) {
  const items = [];
  if (!includeInvisible && !chart.isPointInArea(position2)) {
    return items;
  }
  const evaluationFunc = function(element, datasetIndex, index2) {
    if (!includeInvisible && !_isPointInArea(element, chart.chartArea, 0)) {
      return;
    }
    if (element.inRange(position2.x, position2.y, useFinalPosition)) {
      items.push({ element, datasetIndex, index: index2 });
    }
  };
  evaluateInteractionItems(chart, axis, position2, evaluationFunc, true);
  return items;
}
function getNearestRadialItems(chart, position2, axis, useFinalPosition) {
  let items = [];
  function evaluationFunc(element, datasetIndex, index2) {
    const { startAngle, endAngle } = element.getProps(["startAngle", "endAngle"], useFinalPosition);
    const { angle: angle2 } = getAngleFromPoint(element, { x: position2.x, y: position2.y });
    if (_angleBetween(angle2, startAngle, endAngle)) {
      items.push({ element, datasetIndex, index: index2 });
    }
  }
  evaluateInteractionItems(chart, axis, position2, evaluationFunc);
  return items;
}
function getNearestCartesianItems(chart, position2, axis, intersect, useFinalPosition, includeInvisible) {
  let items = [];
  const distanceMetric = getDistanceMetricForAxis(axis);
  let minDistance = Number.POSITIVE_INFINITY;
  function evaluationFunc(element, datasetIndex, index2) {
    const inRange2 = element.inRange(position2.x, position2.y, useFinalPosition);
    if (intersect && !inRange2) {
      return;
    }
    const center = element.getCenterPoint(useFinalPosition);
    const pointInArea = !!includeInvisible || chart.isPointInArea(center);
    if (!pointInArea && !inRange2) {
      return;
    }
    const distance = distanceMetric(position2, center);
    if (distance < minDistance) {
      items = [{ element, datasetIndex, index: index2 }];
      minDistance = distance;
    } else if (distance === minDistance) {
      items.push({ element, datasetIndex, index: index2 });
    }
  }
  evaluateInteractionItems(chart, axis, position2, evaluationFunc);
  return items;
}
function getNearestItems(chart, position2, axis, intersect, useFinalPosition, includeInvisible) {
  if (!includeInvisible && !chart.isPointInArea(position2)) {
    return [];
  }
  return axis === "r" && !intersect ? getNearestRadialItems(chart, position2, axis, useFinalPosition) : getNearestCartesianItems(chart, position2, axis, intersect, useFinalPosition, includeInvisible);
}
function getAxisItems(chart, position2, axis, intersect, useFinalPosition) {
  const items = [];
  const rangeMethod = axis === "x" ? "inXRange" : "inYRange";
  let intersectsItem = false;
  evaluateInteractionItems(chart, axis, position2, (element, datasetIndex, index2) => {
    if (element[rangeMethod](position2[axis], useFinalPosition)) {
      items.push({ element, datasetIndex, index: index2 });
      intersectsItem = intersectsItem || element.inRange(position2.x, position2.y, useFinalPosition);
    }
  });
  if (intersect && !intersectsItem) {
    return [];
  }
  return items;
}
var Interaction = {
  modes: {
    index(chart, e3, options, useFinalPosition) {
      const position2 = getRelativePosition(e3, chart);
      const axis = options.axis || "x";
      const includeInvisible = options.includeInvisible || false;
      const items = options.intersect ? getIntersectItems(chart, position2, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position2, axis, false, useFinalPosition, includeInvisible);
      const elements = [];
      if (!items.length) {
        return [];
      }
      chart.getSortedVisibleDatasetMetas().forEach((meta) => {
        const index2 = items[0].index;
        const element = meta.data[index2];
        if (element && !element.skip) {
          elements.push({ element, datasetIndex: meta.index, index: index2 });
        }
      });
      return elements;
    },
    dataset(chart, e3, options, useFinalPosition) {
      const position2 = getRelativePosition(e3, chart);
      const axis = options.axis || "xy";
      const includeInvisible = options.includeInvisible || false;
      let items = options.intersect ? getIntersectItems(chart, position2, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position2, axis, false, useFinalPosition, includeInvisible);
      if (items.length > 0) {
        const datasetIndex = items[0].datasetIndex;
        const data = chart.getDatasetMeta(datasetIndex).data;
        items = [];
        for (let i3 = 0; i3 < data.length; ++i3) {
          items.push({ element: data[i3], datasetIndex, index: i3 });
        }
      }
      return items;
    },
    point(chart, e3, options, useFinalPosition) {
      const position2 = getRelativePosition(e3, chart);
      const axis = options.axis || "xy";
      const includeInvisible = options.includeInvisible || false;
      return getIntersectItems(chart, position2, axis, useFinalPosition, includeInvisible);
    },
    nearest(chart, e3, options, useFinalPosition) {
      const position2 = getRelativePosition(e3, chart);
      const axis = options.axis || "xy";
      const includeInvisible = options.includeInvisible || false;
      return getNearestItems(chart, position2, axis, options.intersect, useFinalPosition, includeInvisible);
    },
    x(chart, e3, options, useFinalPosition) {
      const position2 = getRelativePosition(e3, chart);
      return getAxisItems(chart, position2, "x", options.intersect, useFinalPosition);
    },
    y(chart, e3, options, useFinalPosition) {
      const position2 = getRelativePosition(e3, chart);
      return getAxisItems(chart, position2, "y", options.intersect, useFinalPosition);
    }
  }
};
const STATIC_POSITIONS = ["left", "top", "right", "bottom"];
function filterByPosition(array, position2) {
  return array.filter((v) => v.pos === position2);
}
function filterDynamicPositionByAxis(array, axis) {
  return array.filter((v) => STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function sortByWeight(array, reverse) {
  return array.sort((a4, b3) => {
    const v0 = reverse ? b3 : a4;
    const v1 = reverse ? a4 : b3;
    return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
  });
}
function wrapBoxes(boxes) {
  const layoutBoxes = [];
  let i3, ilen, box, pos, stack2, stackWeight;
  for (i3 = 0, ilen = (boxes || []).length; i3 < ilen; ++i3) {
    box = boxes[i3];
    ({ position: pos, options: { stack: stack2, stackWeight = 1 } } = box);
    layoutBoxes.push({
      index: i3,
      box,
      pos,
      horizontal: box.isHorizontal(),
      weight: box.weight,
      stack: stack2 && pos + stack2,
      stackWeight
    });
  }
  return layoutBoxes;
}
function buildStacks(layouts2) {
  const stacks = {};
  for (const wrap of layouts2) {
    const { stack: stack2, pos, stackWeight } = wrap;
    if (!stack2 || !STATIC_POSITIONS.includes(pos)) {
      continue;
    }
    const _stack = stacks[stack2] || (stacks[stack2] = { count: 0, placed: 0, weight: 0, size: 0 });
    _stack.count++;
    _stack.weight += stackWeight;
  }
  return stacks;
}
function setLayoutDims(layouts2, params) {
  const stacks = buildStacks(layouts2);
  const { vBoxMaxWidth, hBoxMaxHeight } = params;
  let i3, ilen, layout;
  for (i3 = 0, ilen = layouts2.length; i3 < ilen; ++i3) {
    layout = layouts2[i3];
    const { fullSize } = layout.box;
    const stack2 = stacks[layout.stack];
    const factor = stack2 && layout.stackWeight / stack2.weight;
    if (layout.horizontal) {
      layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
      layout.height = hBoxMaxHeight;
    } else {
      layout.width = vBoxMaxWidth;
      layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
    }
  }
  return stacks;
}
function buildLayoutBoxes(boxes) {
  const layoutBoxes = wrapBoxes(boxes);
  const fullSize = sortByWeight(layoutBoxes.filter((wrap) => wrap.box.fullSize), true);
  const left = sortByWeight(filterByPosition(layoutBoxes, "left"), true);
  const right = sortByWeight(filterByPosition(layoutBoxes, "right"));
  const top = sortByWeight(filterByPosition(layoutBoxes, "top"), true);
  const bottom = sortByWeight(filterByPosition(layoutBoxes, "bottom"));
  const centerHorizontal = filterDynamicPositionByAxis(layoutBoxes, "x");
  const centerVertical = filterDynamicPositionByAxis(layoutBoxes, "y");
  return {
    fullSize,
    leftAndTop: left.concat(top),
    rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
    chartArea: filterByPosition(layoutBoxes, "chartArea"),
    vertical: left.concat(right).concat(centerVertical),
    horizontal: top.concat(bottom).concat(centerHorizontal)
  };
}
function getCombinedMax(maxPadding, chartArea, a4, b3) {
  return Math.max(maxPadding[a4], chartArea[a4]) + Math.max(maxPadding[b3], chartArea[b3]);
}
function updateMaxPadding(maxPadding, boxPadding) {
  maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
  maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
  maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
  maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function updateDims(chartArea, params, layout, stacks) {
  const { pos, box } = layout;
  const maxPadding = chartArea.maxPadding;
  if (!isObject$3(pos)) {
    if (layout.size) {
      chartArea[pos] -= layout.size;
    }
    const stack2 = stacks[layout.stack] || { size: 0, count: 1 };
    stack2.size = Math.max(stack2.size, layout.horizontal ? box.height : box.width);
    layout.size = stack2.size / stack2.count;
    chartArea[pos] += layout.size;
  }
  if (box.getPadding) {
    updateMaxPadding(maxPadding, box.getPadding());
  }
  const newWidth = Math.max(0, params.outerWidth - getCombinedMax(maxPadding, chartArea, "left", "right"));
  const newHeight = Math.max(0, params.outerHeight - getCombinedMax(maxPadding, chartArea, "top", "bottom"));
  const widthChanged = newWidth !== chartArea.w;
  const heightChanged = newHeight !== chartArea.h;
  chartArea.w = newWidth;
  chartArea.h = newHeight;
  return layout.horizontal ? { same: widthChanged, other: heightChanged } : { same: heightChanged, other: widthChanged };
}
function handleMaxPadding(chartArea) {
  const maxPadding = chartArea.maxPadding;
  function updatePos(pos) {
    const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
    chartArea[pos] += change;
    return change;
  }
  chartArea.y += updatePos("top");
  chartArea.x += updatePos("left");
  updatePos("right");
  updatePos("bottom");
}
function getMargins(horizontal, chartArea) {
  const maxPadding = chartArea.maxPadding;
  function marginForPositions(positions2) {
    const margin = { left: 0, top: 0, right: 0, bottom: 0 };
    positions2.forEach((pos) => {
      margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
    });
    return margin;
  }
  return horizontal ? marginForPositions(["left", "right"]) : marginForPositions(["top", "bottom"]);
}
function fitBoxes(boxes, chartArea, params, stacks) {
  const refitBoxes = [];
  let i3, ilen, layout, box, refit, changed;
  for (i3 = 0, ilen = boxes.length, refit = 0; i3 < ilen; ++i3) {
    layout = boxes[i3];
    box = layout.box;
    box.update(
      layout.width || chartArea.w,
      layout.height || chartArea.h,
      getMargins(layout.horizontal, chartArea)
    );
    const { same, other } = updateDims(chartArea, params, layout, stacks);
    refit |= same && refitBoxes.length;
    changed = changed || other;
    if (!box.fullSize) {
      refitBoxes.push(layout);
    }
  }
  return refit && fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function setBoxDims(box, left, top, width, height2) {
  box.top = top;
  box.left = left;
  box.right = left + width;
  box.bottom = top + height2;
  box.width = width;
  box.height = height2;
}
function placeBoxes(boxes, chartArea, params, stacks) {
  const userPadding = params.padding;
  let { x: x3, y: y4 } = chartArea;
  for (const layout of boxes) {
    const box = layout.box;
    const stack2 = stacks[layout.stack] || { placed: 0, weight: 1 };
    const weight = layout.stackWeight / stack2.weight || 1;
    if (layout.horizontal) {
      const width = chartArea.w * weight;
      const height2 = stack2.size || box.height;
      if (defined(stack2.start)) {
        y4 = stack2.start;
      }
      if (box.fullSize) {
        setBoxDims(box, userPadding.left, y4, params.outerWidth - userPadding.right - userPadding.left, height2);
      } else {
        setBoxDims(box, chartArea.left + stack2.placed, y4, width, height2);
      }
      stack2.start = y4;
      stack2.placed += width;
      y4 = box.bottom;
    } else {
      const height2 = chartArea.h * weight;
      const width = stack2.size || box.width;
      if (defined(stack2.start)) {
        x3 = stack2.start;
      }
      if (box.fullSize) {
        setBoxDims(box, x3, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
      } else {
        setBoxDims(box, x3, chartArea.top + stack2.placed, width, height2);
      }
      stack2.start = x3;
      stack2.placed += height2;
      x3 = box.right;
    }
  }
  chartArea.x = x3;
  chartArea.y = y4;
}
defaults$1.set("layout", {
  autoPadding: true,
  padding: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }
});
var layouts = {
  addBox(chart, item) {
    if (!chart.boxes) {
      chart.boxes = [];
    }
    item.fullSize = item.fullSize || false;
    item.position = item.position || "top";
    item.weight = item.weight || 0;
    item._layers = item._layers || function() {
      return [{
        z: 0,
        draw(chartArea) {
          item.draw(chartArea);
        }
      }];
    };
    chart.boxes.push(item);
  },
  removeBox(chart, layoutItem) {
    const index2 = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
    if (index2 !== -1) {
      chart.boxes.splice(index2, 1);
    }
  },
  configure(chart, item, options) {
    item.fullSize = options.fullSize;
    item.position = options.position;
    item.weight = options.weight;
  },
  update(chart, width, height2, minPadding) {
    if (!chart) {
      return;
    }
    const padding = toPadding(chart.options.layout.padding);
    const availableWidth = Math.max(width - padding.width, 0);
    const availableHeight = Math.max(height2 - padding.height, 0);
    const boxes = buildLayoutBoxes(chart.boxes);
    const verticalBoxes = boxes.vertical;
    const horizontalBoxes = boxes.horizontal;
    each(chart.boxes, (box) => {
      if (typeof box.beforeLayout === "function") {
        box.beforeLayout();
      }
    });
    const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap) => wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
    const params = Object.freeze({
      outerWidth: width,
      outerHeight: height2,
      padding,
      availableWidth,
      availableHeight,
      vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
      hBoxMaxHeight: availableHeight / 2
    });
    const maxPadding = Object.assign({}, padding);
    updateMaxPadding(maxPadding, toPadding(minPadding));
    const chartArea = Object.assign({
      maxPadding,
      w: availableWidth,
      h: availableHeight,
      x: padding.left,
      y: padding.top
    }, padding);
    const stacks = setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
    fitBoxes(boxes.fullSize, chartArea, params, stacks);
    fitBoxes(verticalBoxes, chartArea, params, stacks);
    if (fitBoxes(horizontalBoxes, chartArea, params, stacks)) {
      fitBoxes(verticalBoxes, chartArea, params, stacks);
    }
    handleMaxPadding(chartArea);
    placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
    chartArea.x += chartArea.w;
    chartArea.y += chartArea.h;
    placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
    chart.chartArea = {
      left: chartArea.left,
      top: chartArea.top,
      right: chartArea.left + chartArea.w,
      bottom: chartArea.top + chartArea.h,
      height: chartArea.h,
      width: chartArea.w
    };
    each(boxes.chartArea, (layout) => {
      const box = layout.box;
      Object.assign(box, chart.chartArea);
      box.update(chartArea.w, chartArea.h, { left: 0, top: 0, right: 0, bottom: 0 });
    });
  }
};
class BasePlatform {
  acquireContext(canvas, aspectRatio) {
  }
  releaseContext(context) {
    return false;
  }
  addEventListener(chart, type2, listener) {
  }
  removeEventListener(chart, type2, listener) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(element, width, height2, aspectRatio) {
    width = Math.max(0, width || element.width);
    height2 = height2 || element.height;
    return {
      width,
      height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height2)
    };
  }
  isAttached(canvas) {
    return true;
  }
  updateConfig(config) {
  }
}
class BasicPlatform extends BasePlatform {
  acquireContext(item) {
    return item && item.getContext && item.getContext("2d") || null;
  }
  updateConfig(config) {
    config.options.animation = false;
  }
}
const EXPANDO_KEY = "$chartjs";
const EVENT_TYPES = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
};
const isNullOrEmpty = (value2) => value2 === null || value2 === "";
function initCanvas(canvas, aspectRatio) {
  const style = canvas.style;
  const renderHeight = canvas.getAttribute("height");
  const renderWidth = canvas.getAttribute("width");
  canvas[EXPANDO_KEY] = {
    initial: {
      height: renderHeight,
      width: renderWidth,
      style: {
        display: style.display,
        height: style.height,
        width: style.width
      }
    }
  };
  style.display = style.display || "block";
  style.boxSizing = style.boxSizing || "border-box";
  if (isNullOrEmpty(renderWidth)) {
    const displayWidth = readUsedSize(canvas, "width");
    if (displayWidth !== void 0) {
      canvas.width = displayWidth;
    }
  }
  if (isNullOrEmpty(renderHeight)) {
    if (canvas.style.height === "") {
      canvas.height = canvas.width / (aspectRatio || 2);
    } else {
      const displayHeight = readUsedSize(canvas, "height");
      if (displayHeight !== void 0) {
        canvas.height = displayHeight;
      }
    }
  }
  return canvas;
}
const eventListenerOptions = supportsEventListenerOptions ? { passive: true } : false;
function addListener(node, type2, listener) {
  node.addEventListener(type2, listener, eventListenerOptions);
}
function removeListener(chart, type2, listener) {
  chart.canvas.removeEventListener(type2, listener, eventListenerOptions);
}
function fromNativeEvent(event, chart) {
  const type2 = EVENT_TYPES[event.type] || event.type;
  const { x: x3, y: y4 } = getRelativePosition(event, chart);
  return {
    type: type2,
    chart,
    native: event,
    x: x3 !== void 0 ? x3 : null,
    y: y4 !== void 0 ? y4 : null
  };
}
function nodeListContains(nodeList, canvas) {
  for (const node of nodeList) {
    if (node === canvas || node.contains(canvas)) {
      return true;
    }
  }
}
function createAttachObserver(chart, type2, listener) {
  const canvas = chart.canvas;
  const observer = new MutationObserver((entries2) => {
    let trigger3 = false;
    for (const entry of entries2) {
      trigger3 = trigger3 || nodeListContains(entry.addedNodes, canvas);
      trigger3 = trigger3 && !nodeListContains(entry.removedNodes, canvas);
    }
    if (trigger3) {
      listener();
    }
  });
  observer.observe(document, { childList: true, subtree: true });
  return observer;
}
function createDetachObserver(chart, type2, listener) {
  const canvas = chart.canvas;
  const observer = new MutationObserver((entries2) => {
    let trigger3 = false;
    for (const entry of entries2) {
      trigger3 = trigger3 || nodeListContains(entry.removedNodes, canvas);
      trigger3 = trigger3 && !nodeListContains(entry.addedNodes, canvas);
    }
    if (trigger3) {
      listener();
    }
  });
  observer.observe(document, { childList: true, subtree: true });
  return observer;
}
const drpListeningCharts = /* @__PURE__ */ new Map();
let oldDevicePixelRatio = 0;
function onWindowResize() {
  const dpr = window.devicePixelRatio;
  if (dpr === oldDevicePixelRatio) {
    return;
  }
  oldDevicePixelRatio = dpr;
  drpListeningCharts.forEach((resize, chart) => {
    if (chart.currentDevicePixelRatio !== dpr) {
      resize();
    }
  });
}
function listenDevicePixelRatioChanges(chart, resize) {
  if (!drpListeningCharts.size) {
    window.addEventListener("resize", onWindowResize);
  }
  drpListeningCharts.set(chart, resize);
}
function unlistenDevicePixelRatioChanges(chart) {
  drpListeningCharts.delete(chart);
  if (!drpListeningCharts.size) {
    window.removeEventListener("resize", onWindowResize);
  }
}
function createResizeObserver(chart, type2, listener) {
  const canvas = chart.canvas;
  const container = canvas && _getParentNode(canvas);
  if (!container) {
    return;
  }
  const resize = throttled((width, height2) => {
    const w3 = container.clientWidth;
    listener(width, height2);
    if (w3 < container.clientWidth) {
      listener();
    }
  }, window);
  const observer = new ResizeObserver((entries2) => {
    const entry = entries2[0];
    const width = entry.contentRect.width;
    const height2 = entry.contentRect.height;
    if (width === 0 && height2 === 0) {
      return;
    }
    resize(width, height2);
  });
  observer.observe(container);
  listenDevicePixelRatioChanges(chart, resize);
  return observer;
}
function releaseObserver(chart, type2, observer) {
  if (observer) {
    observer.disconnect();
  }
  if (type2 === "resize") {
    unlistenDevicePixelRatioChanges(chart);
  }
}
function createProxyAndListen(chart, type2, listener) {
  const canvas = chart.canvas;
  const proxy = throttled((event) => {
    if (chart.ctx !== null) {
      listener(fromNativeEvent(event, chart));
    }
  }, chart, (args) => {
    const event = args[0];
    return [event, event.offsetX, event.offsetY];
  });
  addListener(canvas, type2, proxy);
  return proxy;
}
class DomPlatform extends BasePlatform {
  acquireContext(canvas, aspectRatio) {
    const context = canvas && canvas.getContext && canvas.getContext("2d");
    if (context && context.canvas === canvas) {
      initCanvas(canvas, aspectRatio);
      return context;
    }
    return null;
  }
  releaseContext(context) {
    const canvas = context.canvas;
    if (!canvas[EXPANDO_KEY]) {
      return false;
    }
    const initial = canvas[EXPANDO_KEY].initial;
    ["height", "width"].forEach((prop) => {
      const value2 = initial[prop];
      if (isNullOrUndef(value2)) {
        canvas.removeAttribute(prop);
      } else {
        canvas.setAttribute(prop, value2);
      }
    });
    const style = initial.style || {};
    Object.keys(style).forEach((key) => {
      canvas.style[key] = style[key];
    });
    canvas.width = canvas.width;
    delete canvas[EXPANDO_KEY];
    return true;
  }
  addEventListener(chart, type2, listener) {
    this.removeEventListener(chart, type2);
    const proxies = chart.$proxies || (chart.$proxies = {});
    const handlers3 = {
      attach: createAttachObserver,
      detach: createDetachObserver,
      resize: createResizeObserver
    };
    const handler = handlers3[type2] || createProxyAndListen;
    proxies[type2] = handler(chart, type2, listener);
  }
  removeEventListener(chart, type2) {
    const proxies = chart.$proxies || (chart.$proxies = {});
    const proxy = proxies[type2];
    if (!proxy) {
      return;
    }
    const handlers3 = {
      attach: releaseObserver,
      detach: releaseObserver,
      resize: releaseObserver
    };
    const handler = handlers3[type2] || removeListener;
    handler(chart, type2, proxy);
    proxies[type2] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(canvas, width, height2, aspectRatio) {
    return getMaximumSize(canvas, width, height2, aspectRatio);
  }
  isAttached(canvas) {
    const container = _getParentNode(canvas);
    return !!(container && container.isConnected);
  }
}
function _detectPlatform(canvas) {
  if (!_isDomSupported() || typeof OffscreenCanvas !== "undefined" && canvas instanceof OffscreenCanvas) {
    return BasicPlatform;
  }
  return DomPlatform;
}
class PluginService {
  constructor() {
    this._init = [];
  }
  notify(chart, hook, args, filter) {
    if (hook === "beforeInit") {
      this._init = this._createDescriptors(chart, true);
      this._notify(this._init, chart, "install");
    }
    const descriptors2 = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
    const result = this._notify(descriptors2, chart, hook, args);
    if (hook === "afterDestroy") {
      this._notify(descriptors2, chart, "stop");
      this._notify(this._init, chart, "uninstall");
    }
    return result;
  }
  _notify(descriptors2, chart, hook, args) {
    args = args || {};
    for (const descriptor of descriptors2) {
      const plugin2 = descriptor.plugin;
      const method = plugin2[hook];
      const params = [chart, args, descriptor.options];
      if (callback(method, params, plugin2) === false && args.cancelable) {
        return false;
      }
    }
    return true;
  }
  invalidate() {
    if (!isNullOrUndef(this._cache)) {
      this._oldCache = this._cache;
      this._cache = void 0;
    }
  }
  _descriptors(chart) {
    if (this._cache) {
      return this._cache;
    }
    const descriptors2 = this._cache = this._createDescriptors(chart);
    this._notifyStateChanges(chart);
    return descriptors2;
  }
  _createDescriptors(chart, all) {
    const config = chart && chart.config;
    const options = valueOrDefault(config.options && config.options.plugins, {});
    const plugins = allPlugins(config);
    return options === false && !all ? [] : createDescriptors(chart, plugins, options, all);
  }
  _notifyStateChanges(chart) {
    const previousDescriptors = this._oldCache || [];
    const descriptors2 = this._cache;
    const diff = (a4, b3) => a4.filter((x3) => !b3.some((y4) => x3.plugin.id === y4.plugin.id));
    this._notify(diff(previousDescriptors, descriptors2), chart, "stop");
    this._notify(diff(descriptors2, previousDescriptors), chart, "start");
  }
}
function allPlugins(config) {
  const localIds = {};
  const plugins = [];
  const keys2 = Object.keys(registry.plugins.items);
  for (let i3 = 0; i3 < keys2.length; i3++) {
    plugins.push(registry.getPlugin(keys2[i3]));
  }
  const local = config.plugins || [];
  for (let i3 = 0; i3 < local.length; i3++) {
    const plugin2 = local[i3];
    if (plugins.indexOf(plugin2) === -1) {
      plugins.push(plugin2);
      localIds[plugin2.id] = true;
    }
  }
  return { plugins, localIds };
}
function getOpts(options, all) {
  if (!all && options === false) {
    return null;
  }
  if (options === true) {
    return {};
  }
  return options;
}
function createDescriptors(chart, { plugins, localIds }, options, all) {
  const result = [];
  const context = chart.getContext();
  for (const plugin2 of plugins) {
    const id3 = plugin2.id;
    const opts = getOpts(options[id3], all);
    if (opts === null) {
      continue;
    }
    result.push({
      plugin: plugin2,
      options: pluginOpts(chart.config, { plugin: plugin2, local: localIds[id3] }, opts, context)
    });
  }
  return result;
}
function pluginOpts(config, { plugin: plugin2, local }, opts, context) {
  const keys2 = config.pluginScopeKeys(plugin2);
  const scopes = config.getOptionScopes(opts, keys2);
  if (local && plugin2.defaults) {
    scopes.push(plugin2.defaults);
  }
  return config.createResolver(scopes, context, [""], {
    scriptable: false,
    indexable: false,
    allKeys: true
  });
}
function getIndexAxis(type2, options) {
  const datasetDefaults = defaults$1.datasets[type2] || {};
  const datasetOptions = (options.datasets || {})[type2] || {};
  return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || "x";
}
function getAxisFromDefaultScaleID(id3, indexAxis) {
  let axis = id3;
  if (id3 === "_index_") {
    axis = indexAxis;
  } else if (id3 === "_value_") {
    axis = indexAxis === "x" ? "y" : "x";
  }
  return axis;
}
function getDefaultScaleIDFromAxis(axis, indexAxis) {
  return axis === indexAxis ? "_index_" : "_value_";
}
function axisFromPosition(position2) {
  if (position2 === "top" || position2 === "bottom") {
    return "x";
  }
  if (position2 === "left" || position2 === "right") {
    return "y";
  }
}
function determineAxis(id3, scaleOptions) {
  if (id3 === "x" || id3 === "y") {
    return id3;
  }
  return scaleOptions.axis || axisFromPosition(scaleOptions.position) || id3.charAt(0).toLowerCase();
}
function mergeScaleConfig(config, options) {
  const chartDefaults = overrides[config.type] || { scales: {} };
  const configScales = options.scales || {};
  const chartIndexAxis = getIndexAxis(config.type, options);
  const firstIDs = /* @__PURE__ */ Object.create(null);
  const scales = /* @__PURE__ */ Object.create(null);
  Object.keys(configScales).forEach((id3) => {
    const scaleConf = configScales[id3];
    if (!isObject$3(scaleConf)) {
      return console.error(`Invalid scale configuration for scale: ${id3}`);
    }
    if (scaleConf._proxy) {
      return console.warn(`Ignoring resolver passed as options for scale: ${id3}`);
    }
    const axis = determineAxis(id3, scaleConf);
    const defaultId = getDefaultScaleIDFromAxis(axis, chartIndexAxis);
    const defaultScaleOptions = chartDefaults.scales || {};
    firstIDs[axis] = firstIDs[axis] || id3;
    scales[id3] = mergeIf(/* @__PURE__ */ Object.create(null), [{ axis }, scaleConf, defaultScaleOptions[axis], defaultScaleOptions[defaultId]]);
  });
  config.data.datasets.forEach((dataset) => {
    const type2 = dataset.type || config.type;
    const indexAxis = dataset.indexAxis || getIndexAxis(type2, options);
    const datasetDefaults = overrides[type2] || {};
    const defaultScaleOptions = datasetDefaults.scales || {};
    Object.keys(defaultScaleOptions).forEach((defaultID) => {
      const axis = getAxisFromDefaultScaleID(defaultID, indexAxis);
      const id3 = dataset[axis + "AxisID"] || firstIDs[axis] || axis;
      scales[id3] = scales[id3] || /* @__PURE__ */ Object.create(null);
      mergeIf(scales[id3], [{ axis }, configScales[id3], defaultScaleOptions[defaultID]]);
    });
  });
  Object.keys(scales).forEach((key) => {
    const scale = scales[key];
    mergeIf(scale, [defaults$1.scales[scale.type], defaults$1.scale]);
  });
  return scales;
}
function initOptions(config) {
  const options = config.options || (config.options = {});
  options.plugins = valueOrDefault(options.plugins, {});
  options.scales = mergeScaleConfig(config, options);
}
function initData(data) {
  data = data || {};
  data.datasets = data.datasets || [];
  data.labels = data.labels || [];
  return data;
}
function initConfig(config) {
  config = config || {};
  config.data = initData(config.data);
  initOptions(config);
  return config;
}
const keyCache = /* @__PURE__ */ new Map();
const keysCached = /* @__PURE__ */ new Set();
function cachedKeys(cacheKey, generate) {
  let keys2 = keyCache.get(cacheKey);
  if (!keys2) {
    keys2 = generate();
    keyCache.set(cacheKey, keys2);
    keysCached.add(keys2);
  }
  return keys2;
}
const addIfFound = (set2, obj, key) => {
  const opts = resolveObjectKey(obj, key);
  if (opts !== void 0) {
    set2.add(opts);
  }
};
class Config {
  constructor(config) {
    this._config = initConfig(config);
    this._scopeCache = /* @__PURE__ */ new Map();
    this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(type2) {
    this._config.type = type2;
  }
  get data() {
    return this._config.data;
  }
  set data(data) {
    this._config.data = initData(data);
  }
  get options() {
    return this._config.options;
  }
  set options(options) {
    this._config.options = options;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const config = this._config;
    this.clearCache();
    initOptions(config);
  }
  clearCache() {
    this._scopeCache.clear();
    this._resolverCache.clear();
  }
  datasetScopeKeys(datasetType) {
    return cachedKeys(
      datasetType,
      () => [[
        `datasets.${datasetType}`,
        ""
      ]]
    );
  }
  datasetAnimationScopeKeys(datasetType, transition) {
    return cachedKeys(
      `${datasetType}.transition.${transition}`,
      () => [
        [
          `datasets.${datasetType}.transitions.${transition}`,
          `transitions.${transition}`
        ],
        [
          `datasets.${datasetType}`,
          ""
        ]
      ]
    );
  }
  datasetElementScopeKeys(datasetType, elementType) {
    return cachedKeys(
      `${datasetType}-${elementType}`,
      () => [[
        `datasets.${datasetType}.elements.${elementType}`,
        `datasets.${datasetType}`,
        `elements.${elementType}`,
        ""
      ]]
    );
  }
  pluginScopeKeys(plugin2) {
    const id3 = plugin2.id;
    const type2 = this.type;
    return cachedKeys(
      `${type2}-plugin-${id3}`,
      () => [[
        `plugins.${id3}`,
        ...plugin2.additionalOptionScopes || []
      ]]
    );
  }
  _cachedScopes(mainScope, resetCache) {
    const _scopeCache = this._scopeCache;
    let cache = _scopeCache.get(mainScope);
    if (!cache || resetCache) {
      cache = /* @__PURE__ */ new Map();
      _scopeCache.set(mainScope, cache);
    }
    return cache;
  }
  getOptionScopes(mainScope, keyLists, resetCache) {
    const { options, type: type2 } = this;
    const cache = this._cachedScopes(mainScope, resetCache);
    const cached = cache.get(keyLists);
    if (cached) {
      return cached;
    }
    const scopes = /* @__PURE__ */ new Set();
    keyLists.forEach((keys2) => {
      if (mainScope) {
        scopes.add(mainScope);
        keys2.forEach((key) => addIfFound(scopes, mainScope, key));
      }
      keys2.forEach((key) => addIfFound(scopes, options, key));
      keys2.forEach((key) => addIfFound(scopes, overrides[type2] || {}, key));
      keys2.forEach((key) => addIfFound(scopes, defaults$1, key));
      keys2.forEach((key) => addIfFound(scopes, descriptors, key));
    });
    const array = Array.from(scopes);
    if (array.length === 0) {
      array.push(/* @__PURE__ */ Object.create(null));
    }
    if (keysCached.has(keyLists)) {
      cache.set(keyLists, array);
    }
    return array;
  }
  chartOptionScopes() {
    const { options, type: type2 } = this;
    return [
      options,
      overrides[type2] || {},
      defaults$1.datasets[type2] || {},
      { type: type2 },
      defaults$1,
      descriptors
    ];
  }
  resolveNamedOptions(scopes, names2, context, prefixes2 = [""]) {
    const result = { $shared: true };
    const { resolver, subPrefixes } = getResolver(this._resolverCache, scopes, prefixes2);
    let options = resolver;
    if (needContext(resolver, names2)) {
      result.$shared = false;
      context = isFunction(context) ? context() : context;
      const subResolver = this.createResolver(scopes, context, subPrefixes);
      options = _attachContext(resolver, context, subResolver);
    }
    for (const prop of names2) {
      result[prop] = options[prop];
    }
    return result;
  }
  createResolver(scopes, context, prefixes2 = [""], descriptorDefaults) {
    const { resolver } = getResolver(this._resolverCache, scopes, prefixes2);
    return isObject$3(context) ? _attachContext(resolver, context, void 0, descriptorDefaults) : resolver;
  }
}
function getResolver(resolverCache, scopes, prefixes2) {
  let cache = resolverCache.get(scopes);
  if (!cache) {
    cache = /* @__PURE__ */ new Map();
    resolverCache.set(scopes, cache);
  }
  const cacheKey = prefixes2.join();
  let cached = cache.get(cacheKey);
  if (!cached) {
    const resolver = _createResolver(scopes, prefixes2);
    cached = {
      resolver,
      subPrefixes: prefixes2.filter((p2) => !p2.toLowerCase().includes("hover"))
    };
    cache.set(cacheKey, cached);
  }
  return cached;
}
const hasFunction = (value2) => isObject$3(value2) && Object.getOwnPropertyNames(value2).reduce((acc, key) => acc || isFunction(value2[key]), false);
function needContext(proxy, names2) {
  const { isScriptable, isIndexable } = _descriptors(proxy);
  for (const prop of names2) {
    const scriptable = isScriptable(prop);
    const indexable = isIndexable(prop);
    const value2 = (indexable || scriptable) && proxy[prop];
    if (scriptable && (isFunction(value2) || hasFunction(value2)) || indexable && isArray(value2)) {
      return true;
    }
  }
  return false;
}
var version$1 = "3.9.1";
const KNOWN_POSITIONS = ["top", "bottom", "left", "right", "chartArea"];
function positionIsHorizontal(position2, axis) {
  return position2 === "top" || position2 === "bottom" || KNOWN_POSITIONS.indexOf(position2) === -1 && axis === "x";
}
function compare2Level(l1, l2) {
  return function(a4, b3) {
    return a4[l1] === b3[l1] ? a4[l2] - b3[l2] : a4[l1] - b3[l1];
  };
}
function onAnimationsComplete(context) {
  const chart = context.chart;
  const animationOptions2 = chart.options.animation;
  chart.notifyPlugins("afterRender");
  callback(animationOptions2 && animationOptions2.onComplete, [context], chart);
}
function onAnimationProgress(context) {
  const chart = context.chart;
  const animationOptions2 = chart.options.animation;
  callback(animationOptions2 && animationOptions2.onProgress, [context], chart);
}
function getCanvas(item) {
  if (_isDomSupported() && typeof item === "string") {
    item = document.getElementById(item);
  } else if (item && item.length) {
    item = item[0];
  }
  if (item && item.canvas) {
    item = item.canvas;
  }
  return item;
}
const instances = {};
const getChart = (key) => {
  const canvas = getCanvas(key);
  return Object.values(instances).filter((c3) => c3.canvas === canvas).pop();
};
function moveNumericKeys(obj, start, move) {
  const keys2 = Object.keys(obj);
  for (const key of keys2) {
    const intKey = +key;
    if (intKey >= start) {
      const value2 = obj[key];
      delete obj[key];
      if (move > 0 || intKey > start) {
        obj[intKey + move] = value2;
      }
    }
  }
}
function determineLastEvent(e3, lastEvent, inChartArea, isClick) {
  if (!inChartArea || e3.type === "mouseout") {
    return null;
  }
  if (isClick) {
    return lastEvent;
  }
  return e3;
}
let Chart$1 = class Chart {
  constructor(item, userConfig) {
    const config = this.config = new Config(userConfig);
    const initialCanvas = getCanvas(item);
    const existingChart = getChart(initialCanvas);
    if (existingChart) {
      throw new Error(
        "Canvas is already in use. Chart with ID '" + existingChart.id + "' must be destroyed before the canvas with ID '" + existingChart.canvas.id + "' can be reused."
      );
    }
    const options = config.createResolver(config.chartOptionScopes(), this.getContext());
    this.platform = new (config.platform || _detectPlatform(initialCanvas))();
    this.platform.updateConfig(config);
    const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
    const canvas = context && context.canvas;
    const height2 = canvas && canvas.height;
    const width = canvas && canvas.width;
    this.id = uid$2();
    this.ctx = context;
    this.canvas = canvas;
    this.width = width;
    this.height = height2;
    this._options = options;
    this._aspectRatio = this.aspectRatio;
    this._layers = [];
    this._metasets = [];
    this._stacks = void 0;
    this.boxes = [];
    this.currentDevicePixelRatio = void 0;
    this.chartArea = void 0;
    this._active = [];
    this._lastEvent = void 0;
    this._listeners = {};
    this._responsiveListeners = void 0;
    this._sortedMetasets = [];
    this.scales = {};
    this._plugins = new PluginService();
    this.$proxies = {};
    this._hiddenIndices = {};
    this.attached = false;
    this._animationsDisabled = void 0;
    this.$context = void 0;
    this._doResize = debounce$1((mode) => this.update(mode), options.resizeDelay || 0);
    this._dataChanges = [];
    instances[this.id] = this;
    if (!context || !canvas) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    animator.listen(this, "complete", onAnimationsComplete);
    animator.listen(this, "progress", onAnimationProgress);
    this._initialize();
    if (this.attached) {
      this.update();
    }
  }
  get aspectRatio() {
    const { options: { aspectRatio, maintainAspectRatio }, width, height: height2, _aspectRatio } = this;
    if (!isNullOrUndef(aspectRatio)) {
      return aspectRatio;
    }
    if (maintainAspectRatio && _aspectRatio) {
      return _aspectRatio;
    }
    return height2 ? width / height2 : null;
  }
  get data() {
    return this.config.data;
  }
  set data(data) {
    this.config.data = data;
  }
  get options() {
    return this._options;
  }
  set options(options) {
    this.config.options = options;
  }
  _initialize() {
    this.notifyPlugins("beforeInit");
    if (this.options.responsive) {
      this.resize();
    } else {
      retinaScale(this, this.options.devicePixelRatio);
    }
    this.bindEvents();
    this.notifyPlugins("afterInit");
    return this;
  }
  clear() {
    clearCanvas(this.canvas, this.ctx);
    return this;
  }
  stop() {
    animator.stop(this);
    return this;
  }
  resize(width, height2) {
    if (!animator.running(this)) {
      this._resize(width, height2);
    } else {
      this._resizeBeforeDraw = { width, height: height2 };
    }
  }
  _resize(width, height2) {
    const options = this.options;
    const canvas = this.canvas;
    const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
    const newSize = this.platform.getMaximumSize(canvas, width, height2, aspectRatio);
    const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
    const mode = this.width ? "resize" : "attach";
    this.width = newSize.width;
    this.height = newSize.height;
    this._aspectRatio = this.aspectRatio;
    if (!retinaScale(this, newRatio, true)) {
      return;
    }
    this.notifyPlugins("resize", { size: newSize });
    callback(options.onResize, [this, newSize], this);
    if (this.attached) {
      if (this._doResize(mode)) {
        this.render();
      }
    }
  }
  ensureScalesHaveIDs() {
    const options = this.options;
    const scalesOptions = options.scales || {};
    each(scalesOptions, (axisOptions, axisID) => {
      axisOptions.id = axisID;
    });
  }
  buildOrUpdateScales() {
    const options = this.options;
    const scaleOpts = options.scales;
    const scales = this.scales;
    const updated = Object.keys(scales).reduce((obj, id3) => {
      obj[id3] = false;
      return obj;
    }, {});
    let items = [];
    if (scaleOpts) {
      items = items.concat(
        Object.keys(scaleOpts).map((id3) => {
          const scaleOptions = scaleOpts[id3];
          const axis = determineAxis(id3, scaleOptions);
          const isRadial = axis === "r";
          const isHorizontal = axis === "x";
          return {
            options: scaleOptions,
            dposition: isRadial ? "chartArea" : isHorizontal ? "bottom" : "left",
            dtype: isRadial ? "radialLinear" : isHorizontal ? "category" : "linear"
          };
        })
      );
    }
    each(items, (item) => {
      const scaleOptions = item.options;
      const id3 = scaleOptions.id;
      const axis = determineAxis(id3, scaleOptions);
      const scaleType = valueOrDefault(scaleOptions.type, item.dtype);
      if (scaleOptions.position === void 0 || positionIsHorizontal(scaleOptions.position, axis) !== positionIsHorizontal(item.dposition)) {
        scaleOptions.position = item.dposition;
      }
      updated[id3] = true;
      let scale = null;
      if (id3 in scales && scales[id3].type === scaleType) {
        scale = scales[id3];
      } else {
        const scaleClass = registry.getScale(scaleType);
        scale = new scaleClass({
          id: id3,
          type: scaleType,
          ctx: this.ctx,
          chart: this
        });
        scales[scale.id] = scale;
      }
      scale.init(scaleOptions, options);
    });
    each(updated, (hasUpdated, id3) => {
      if (!hasUpdated) {
        delete scales[id3];
      }
    });
    each(scales, (scale) => {
      layouts.configure(this, scale, scale.options);
      layouts.addBox(this, scale);
    });
  }
  _updateMetasets() {
    const metasets = this._metasets;
    const numData = this.data.datasets.length;
    const numMeta = metasets.length;
    metasets.sort((a4, b3) => a4.index - b3.index);
    if (numMeta > numData) {
      for (let i3 = numData; i3 < numMeta; ++i3) {
        this._destroyDatasetMeta(i3);
      }
      metasets.splice(numData, numMeta - numData);
    }
    this._sortedMetasets = metasets.slice(0).sort(compare2Level("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: metasets, data: { datasets } } = this;
    if (metasets.length > datasets.length) {
      delete this._stacks;
    }
    metasets.forEach((meta, index2) => {
      if (datasets.filter((x3) => x3 === meta._dataset).length === 0) {
        this._destroyDatasetMeta(index2);
      }
    });
  }
  buildOrUpdateControllers() {
    const newControllers = [];
    const datasets = this.data.datasets;
    let i3, ilen;
    this._removeUnreferencedMetasets();
    for (i3 = 0, ilen = datasets.length; i3 < ilen; i3++) {
      const dataset = datasets[i3];
      let meta = this.getDatasetMeta(i3);
      const type2 = dataset.type || this.config.type;
      if (meta.type && meta.type !== type2) {
        this._destroyDatasetMeta(i3);
        meta = this.getDatasetMeta(i3);
      }
      meta.type = type2;
      meta.indexAxis = dataset.indexAxis || getIndexAxis(type2, this.options);
      meta.order = dataset.order || 0;
      meta.index = i3;
      meta.label = "" + dataset.label;
      meta.visible = this.isDatasetVisible(i3);
      if (meta.controller) {
        meta.controller.updateIndex(i3);
        meta.controller.linkScales();
      } else {
        const ControllerClass = registry.getController(type2);
        const { datasetElementType, dataElementType } = defaults$1.datasets[type2];
        Object.assign(ControllerClass.prototype, {
          dataElementType: registry.getElement(dataElementType),
          datasetElementType: datasetElementType && registry.getElement(datasetElementType)
        });
        meta.controller = new ControllerClass(this, i3);
        newControllers.push(meta.controller);
      }
    }
    this._updateMetasets();
    return newControllers;
  }
  _resetElements() {
    each(this.data.datasets, (dataset, datasetIndex) => {
      this.getDatasetMeta(datasetIndex).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements();
    this.notifyPlugins("reset");
  }
  update(mode) {
    const config = this.config;
    config.update();
    const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
    const animsDisabled = this._animationsDisabled = !options.animation;
    this._updateScales();
    this._checkEventBindings();
    this._updateHiddenIndices();
    this._plugins.invalidate();
    if (this.notifyPlugins("beforeUpdate", { mode, cancelable: true }) === false) {
      return;
    }
    const newControllers = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let minPadding = 0;
    for (let i3 = 0, ilen = this.data.datasets.length; i3 < ilen; i3++) {
      const { controller } = this.getDatasetMeta(i3);
      const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
      controller.buildOrUpdateElements(reset);
      minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
    }
    minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
    this._updateLayout(minPadding);
    if (!animsDisabled) {
      each(newControllers, (controller) => {
        controller.reset();
      });
    }
    this._updateDatasets(mode);
    this.notifyPlugins("afterUpdate", { mode });
    this._layers.sort(compare2Level("z", "_idx"));
    const { _active, _lastEvent } = this;
    if (_lastEvent) {
      this._eventHandler(_lastEvent, true);
    } else if (_active.length) {
      this._updateHoverStyles(_active, _active, true);
    }
    this.render();
  }
  _updateScales() {
    each(this.scales, (scale) => {
      layouts.removeBox(this, scale);
    });
    this.ensureScalesHaveIDs();
    this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const options = this.options;
    const existingEvents = new Set(Object.keys(this._listeners));
    const newEvents = new Set(options.events);
    if (!setsEqual(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
      this.unbindEvents();
      this.bindEvents();
    }
  }
  _updateHiddenIndices() {
    const { _hiddenIndices } = this;
    const changes = this._getUniformDataChanges() || [];
    for (const { method, start, count } of changes) {
      const move = method === "_removeElements" ? -count : count;
      moveNumericKeys(_hiddenIndices, start, move);
    }
  }
  _getUniformDataChanges() {
    const _dataChanges = this._dataChanges;
    if (!_dataChanges || !_dataChanges.length) {
      return;
    }
    this._dataChanges = [];
    const datasetCount = this.data.datasets.length;
    const makeSet = (idx) => new Set(
      _dataChanges.filter((c3) => c3[0] === idx).map((c3, i3) => i3 + "," + c3.splice(1).join(","))
    );
    const changeSet = makeSet(0);
    for (let i3 = 1; i3 < datasetCount; i3++) {
      if (!setsEqual(changeSet, makeSet(i3))) {
        return;
      }
    }
    return Array.from(changeSet).map((c3) => c3.split(",")).map((a4) => ({ method: a4[1], start: +a4[2], count: +a4[3] }));
  }
  _updateLayout(minPadding) {
    if (this.notifyPlugins("beforeLayout", { cancelable: true }) === false) {
      return;
    }
    layouts.update(this, this.width, this.height, minPadding);
    const area = this.chartArea;
    const noArea = area.width <= 0 || area.height <= 0;
    this._layers = [];
    each(this.boxes, (box) => {
      if (noArea && box.position === "chartArea") {
        return;
      }
      if (box.configure) {
        box.configure();
      }
      this._layers.push(...box._layers());
    }, this);
    this._layers.forEach((item, index2) => {
      item._idx = index2;
    });
    this.notifyPlugins("afterLayout");
  }
  _updateDatasets(mode) {
    if (this.notifyPlugins("beforeDatasetsUpdate", { mode, cancelable: true }) === false) {
      return;
    }
    for (let i3 = 0, ilen = this.data.datasets.length; i3 < ilen; ++i3) {
      this.getDatasetMeta(i3).controller.configure();
    }
    for (let i3 = 0, ilen = this.data.datasets.length; i3 < ilen; ++i3) {
      this._updateDataset(i3, isFunction(mode) ? mode({ datasetIndex: i3 }) : mode);
    }
    this.notifyPlugins("afterDatasetsUpdate", { mode });
  }
  _updateDataset(index2, mode) {
    const meta = this.getDatasetMeta(index2);
    const args = { meta, index: index2, mode, cancelable: true };
    if (this.notifyPlugins("beforeDatasetUpdate", args) === false) {
      return;
    }
    meta.controller._update(mode);
    args.cancelable = false;
    this.notifyPlugins("afterDatasetUpdate", args);
  }
  render() {
    if (this.notifyPlugins("beforeRender", { cancelable: true }) === false) {
      return;
    }
    if (animator.has(this)) {
      if (this.attached && !animator.running(this)) {
        animator.start(this);
      }
    } else {
      this.draw();
      onAnimationsComplete({ chart: this });
    }
  }
  draw() {
    let i3;
    if (this._resizeBeforeDraw) {
      const { width, height: height2 } = this._resizeBeforeDraw;
      this._resize(width, height2);
      this._resizeBeforeDraw = null;
    }
    this.clear();
    if (this.width <= 0 || this.height <= 0) {
      return;
    }
    if (this.notifyPlugins("beforeDraw", { cancelable: true }) === false) {
      return;
    }
    const layers = this._layers;
    for (i3 = 0; i3 < layers.length && layers[i3].z <= 0; ++i3) {
      layers[i3].draw(this.chartArea);
    }
    this._drawDatasets();
    for (; i3 < layers.length; ++i3) {
      layers[i3].draw(this.chartArea);
    }
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(filterVisible) {
    const metasets = this._sortedMetasets;
    const result = [];
    let i3, ilen;
    for (i3 = 0, ilen = metasets.length; i3 < ilen; ++i3) {
      const meta = metasets[i3];
      if (!filterVisible || meta.visible) {
        result.push(meta);
      }
    }
    return result;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(true);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", { cancelable: true }) === false) {
      return;
    }
    const metasets = this.getSortedVisibleDatasetMetas();
    for (let i3 = metasets.length - 1; i3 >= 0; --i3) {
      this._drawDataset(metasets[i3]);
    }
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(meta) {
    const ctx = this.ctx;
    const clip2 = meta._clip;
    const useClip = !clip2.disabled;
    const area = this.chartArea;
    const args = {
      meta,
      index: meta.index,
      cancelable: true
    };
    if (this.notifyPlugins("beforeDatasetDraw", args) === false) {
      return;
    }
    if (useClip) {
      clipArea(ctx, {
        left: clip2.left === false ? 0 : area.left - clip2.left,
        right: clip2.right === false ? this.width : area.right + clip2.right,
        top: clip2.top === false ? 0 : area.top - clip2.top,
        bottom: clip2.bottom === false ? this.height : area.bottom + clip2.bottom
      });
    }
    meta.controller.draw();
    if (useClip) {
      unclipArea(ctx);
    }
    args.cancelable = false;
    this.notifyPlugins("afterDatasetDraw", args);
  }
  isPointInArea(point) {
    return _isPointInArea(point, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(e3, mode, options, useFinalPosition) {
    const method = Interaction.modes[mode];
    if (typeof method === "function") {
      return method(this, e3, options, useFinalPosition);
    }
    return [];
  }
  getDatasetMeta(datasetIndex) {
    const dataset = this.data.datasets[datasetIndex];
    const metasets = this._metasets;
    let meta = metasets.filter((x3) => x3 && x3._dataset === dataset).pop();
    if (!meta) {
      meta = {
        type: null,
        data: [],
        dataset: null,
        controller: null,
        hidden: null,
        xAxisID: null,
        yAxisID: null,
        order: dataset && dataset.order || 0,
        index: datasetIndex,
        _dataset: dataset,
        _parsed: [],
        _sorted: false
      };
      metasets.push(meta);
    }
    return meta;
  }
  getContext() {
    return this.$context || (this.$context = createContext(null, { chart: this, type: "chart" }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(datasetIndex) {
    const dataset = this.data.datasets[datasetIndex];
    if (!dataset) {
      return false;
    }
    const meta = this.getDatasetMeta(datasetIndex);
    return typeof meta.hidden === "boolean" ? !meta.hidden : !dataset.hidden;
  }
  setDatasetVisibility(datasetIndex, visible) {
    const meta = this.getDatasetMeta(datasetIndex);
    meta.hidden = !visible;
  }
  toggleDataVisibility(index2) {
    this._hiddenIndices[index2] = !this._hiddenIndices[index2];
  }
  getDataVisibility(index2) {
    return !this._hiddenIndices[index2];
  }
  _updateVisibility(datasetIndex, dataIndex, visible) {
    const mode = visible ? "show" : "hide";
    const meta = this.getDatasetMeta(datasetIndex);
    const anims = meta.controller._resolveAnimations(void 0, mode);
    if (defined(dataIndex)) {
      meta.data[dataIndex].hidden = !visible;
      this.update();
    } else {
      this.setDatasetVisibility(datasetIndex, visible);
      anims.update(meta, { visible });
      this.update((ctx) => ctx.datasetIndex === datasetIndex ? mode : void 0);
    }
  }
  hide(datasetIndex, dataIndex) {
    this._updateVisibility(datasetIndex, dataIndex, false);
  }
  show(datasetIndex, dataIndex) {
    this._updateVisibility(datasetIndex, dataIndex, true);
  }
  _destroyDatasetMeta(datasetIndex) {
    const meta = this._metasets[datasetIndex];
    if (meta && meta.controller) {
      meta.controller._destroy();
    }
    delete this._metasets[datasetIndex];
  }
  _stop() {
    let i3, ilen;
    this.stop();
    animator.remove(this);
    for (i3 = 0, ilen = this.data.datasets.length; i3 < ilen; ++i3) {
      this._destroyDatasetMeta(i3);
    }
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas, ctx } = this;
    this._stop();
    this.config.clearCache();
    if (canvas) {
      this.unbindEvents();
      clearCanvas(canvas, ctx);
      this.platform.releaseContext(ctx);
      this.canvas = null;
      this.ctx = null;
    }
    this.notifyPlugins("destroy");
    delete instances[this.id];
    this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...args) {
    return this.canvas.toDataURL(...args);
  }
  bindEvents() {
    this.bindUserEvents();
    if (this.options.responsive) {
      this.bindResponsiveEvents();
    } else {
      this.attached = true;
    }
  }
  bindUserEvents() {
    const listeners = this._listeners;
    const platform = this.platform;
    const _add = (type2, listener2) => {
      platform.addEventListener(this, type2, listener2);
      listeners[type2] = listener2;
    };
    const listener = (e3, x3, y4) => {
      e3.offsetX = x3;
      e3.offsetY = y4;
      this._eventHandler(e3);
    };
    each(this.options.events, (type2) => _add(type2, listener));
  }
  bindResponsiveEvents() {
    if (!this._responsiveListeners) {
      this._responsiveListeners = {};
    }
    const listeners = this._responsiveListeners;
    const platform = this.platform;
    const _add = (type2, listener2) => {
      platform.addEventListener(this, type2, listener2);
      listeners[type2] = listener2;
    };
    const _remove = (type2, listener2) => {
      if (listeners[type2]) {
        platform.removeEventListener(this, type2, listener2);
        delete listeners[type2];
      }
    };
    const listener = (width, height2) => {
      if (this.canvas) {
        this.resize(width, height2);
      }
    };
    let detached;
    const attached = () => {
      _remove("attach", attached);
      this.attached = true;
      this.resize();
      _add("resize", listener);
      _add("detach", detached);
    };
    detached = () => {
      this.attached = false;
      _remove("resize", listener);
      this._stop();
      this._resize(0, 0);
      _add("attach", attached);
    };
    if (platform.isAttached(this.canvas)) {
      attached();
    } else {
      detached();
    }
  }
  unbindEvents() {
    each(this._listeners, (listener, type2) => {
      this.platform.removeEventListener(this, type2, listener);
    });
    this._listeners = {};
    each(this._responsiveListeners, (listener, type2) => {
      this.platform.removeEventListener(this, type2, listener);
    });
    this._responsiveListeners = void 0;
  }
  updateHoverStyle(items, mode, enabled) {
    const prefix = enabled ? "set" : "remove";
    let meta, item, i3, ilen;
    if (mode === "dataset") {
      meta = this.getDatasetMeta(items[0].datasetIndex);
      meta.controller["_" + prefix + "DatasetHoverStyle"]();
    }
    for (i3 = 0, ilen = items.length; i3 < ilen; ++i3) {
      item = items[i3];
      const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
      if (controller) {
        controller[prefix + "HoverStyle"](item.element, item.datasetIndex, item.index);
      }
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(activeElements) {
    const lastActive = this._active || [];
    const active = activeElements.map(({ datasetIndex, index: index2 }) => {
      const meta = this.getDatasetMeta(datasetIndex);
      if (!meta) {
        throw new Error("No dataset found at index " + datasetIndex);
      }
      return {
        datasetIndex,
        element: meta.data[index2],
        index: index2
      };
    });
    const changed = !_elementsEqual(active, lastActive);
    if (changed) {
      this._active = active;
      this._lastEvent = null;
      this._updateHoverStyles(active, lastActive);
    }
  }
  notifyPlugins(hook, args, filter) {
    return this._plugins.notify(this, hook, args, filter);
  }
  _updateHoverStyles(active, lastActive, replay) {
    const hoverOptions = this.options.hover;
    const diff = (a4, b3) => a4.filter((x3) => !b3.some((y4) => x3.datasetIndex === y4.datasetIndex && x3.index === y4.index));
    const deactivated = diff(lastActive, active);
    const activated = replay ? active : diff(active, lastActive);
    if (deactivated.length) {
      this.updateHoverStyle(deactivated, hoverOptions.mode, false);
    }
    if (activated.length && hoverOptions.mode) {
      this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
  }
  _eventHandler(e3, replay) {
    const args = {
      event: e3,
      replay,
      cancelable: true,
      inChartArea: this.isPointInArea(e3)
    };
    const eventFilter = (plugin2) => (plugin2.options.events || this.options.events).includes(e3.native.type);
    if (this.notifyPlugins("beforeEvent", args, eventFilter) === false) {
      return;
    }
    const changed = this._handleEvent(e3, replay, args.inChartArea);
    args.cancelable = false;
    this.notifyPlugins("afterEvent", args, eventFilter);
    if (changed || args.changed) {
      this.render();
    }
    return this;
  }
  _handleEvent(e3, replay, inChartArea) {
    const { _active: lastActive = [], options } = this;
    const useFinalPosition = replay;
    const active = this._getActiveElements(e3, lastActive, inChartArea, useFinalPosition);
    const isClick = _isClickEvent(e3);
    const lastEvent = determineLastEvent(e3, this._lastEvent, inChartArea, isClick);
    if (inChartArea) {
      this._lastEvent = null;
      callback(options.onHover, [e3, active, this], this);
      if (isClick) {
        callback(options.onClick, [e3, active, this], this);
      }
    }
    const changed = !_elementsEqual(active, lastActive);
    if (changed || replay) {
      this._active = active;
      this._updateHoverStyles(active, lastActive, replay);
    }
    this._lastEvent = lastEvent;
    return changed;
  }
  _getActiveElements(e3, lastActive, inChartArea, useFinalPosition) {
    if (e3.type === "mouseout") {
      return [];
    }
    if (!inChartArea) {
      return lastActive;
    }
    const hoverOptions = this.options.hover;
    return this.getElementsAtEventForMode(e3, hoverOptions.mode, hoverOptions, useFinalPosition);
  }
};
const invalidatePlugins = () => each(Chart$1.instances, (chart) => chart._plugins.invalidate());
const enumerable = true;
Object.defineProperties(Chart$1, {
  defaults: {
    enumerable,
    value: defaults$1
  },
  instances: {
    enumerable,
    value: instances
  },
  overrides: {
    enumerable,
    value: overrides
  },
  registry: {
    enumerable,
    value: registry
  },
  version: {
    enumerable,
    value: version$1
  },
  getChart: {
    enumerable,
    value: getChart
  },
  register: {
    enumerable,
    value: (...items) => {
      registry.add(...items);
      invalidatePlugins();
    }
  },
  unregister: {
    enumerable,
    value: (...items) => {
      registry.remove(...items);
      invalidatePlugins();
    }
  }
});
function clipArc(ctx, element, endAngle) {
  const { startAngle, pixelMargin, x: x3, y: y4, outerRadius, innerRadius } = element;
  let angleMargin = pixelMargin / outerRadius;
  ctx.beginPath();
  ctx.arc(x3, y4, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
  if (innerRadius > pixelMargin) {
    angleMargin = pixelMargin / innerRadius;
    ctx.arc(x3, y4, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
  } else {
    ctx.arc(x3, y4, pixelMargin, endAngle + HALF_PI, startAngle - HALF_PI);
  }
  ctx.closePath();
  ctx.clip();
}
function toRadiusCorners(value2) {
  return _readValueToProps(value2, ["outerStart", "outerEnd", "innerStart", "innerEnd"]);
}
function parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
  const o = toRadiusCorners(arc.options.borderRadius);
  const halfThickness = (outerRadius - innerRadius) / 2;
  const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
  const computeOuterLimit = (val) => {
    const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
    return _limitValue(val, 0, Math.min(halfThickness, outerArcLimit));
  };
  return {
    outerStart: computeOuterLimit(o.outerStart),
    outerEnd: computeOuterLimit(o.outerEnd),
    innerStart: _limitValue(o.innerStart, 0, innerLimit),
    innerEnd: _limitValue(o.innerEnd, 0, innerLimit)
  };
}
function rThetaToXY(r, theta, x3, y4) {
  return {
    x: x3 + r * Math.cos(theta),
    y: y4 + r * Math.sin(theta)
  };
}
function pathArc(ctx, element, offset2, spacing, end, circular) {
  const { x: x3, y: y4, startAngle: start, pixelMargin, innerRadius: innerR } = element;
  const outerRadius = Math.max(element.outerRadius + spacing + offset2 - pixelMargin, 0);
  const innerRadius = innerR > 0 ? innerR + spacing + offset2 + pixelMargin : 0;
  let spacingOffset = 0;
  const alpha2 = end - start;
  if (spacing) {
    const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
    const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
    const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
    const adjustedAngle = avNogSpacingRadius !== 0 ? alpha2 * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha2;
    spacingOffset = (alpha2 - adjustedAngle) / 2;
  }
  const beta = Math.max(1e-3, alpha2 * outerRadius - offset2 / PI) / outerRadius;
  const angleOffset = (alpha2 - beta) / 2;
  const startAngle = start + angleOffset + spacingOffset;
  const endAngle = end - angleOffset - spacingOffset;
  const { outerStart, outerEnd, innerStart, innerEnd } = parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
  const outerStartAdjustedRadius = outerRadius - outerStart;
  const outerEndAdjustedRadius = outerRadius - outerEnd;
  const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
  const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
  const innerStartAdjustedRadius = innerRadius + innerStart;
  const innerEndAdjustedRadius = innerRadius + innerEnd;
  const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
  const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
  ctx.beginPath();
  if (circular) {
    ctx.arc(x3, y4, outerRadius, outerStartAdjustedAngle, outerEndAdjustedAngle);
    if (outerEnd > 0) {
      const pCenter = rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x3, y4);
      ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + HALF_PI);
    }
    const p4 = rThetaToXY(innerEndAdjustedRadius, endAngle, x3, y4);
    ctx.lineTo(p4.x, p4.y);
    if (innerEnd > 0) {
      const pCenter = rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x3, y4);
      ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + HALF_PI, innerEndAdjustedAngle + Math.PI);
    }
    ctx.arc(x3, y4, innerRadius, endAngle - innerEnd / innerRadius, startAngle + innerStart / innerRadius, true);
    if (innerStart > 0) {
      const pCenter = rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x3, y4);
      ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - HALF_PI);
    }
    const p8 = rThetaToXY(outerStartAdjustedRadius, startAngle, x3, y4);
    ctx.lineTo(p8.x, p8.y);
    if (outerStart > 0) {
      const pCenter = rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x3, y4);
      ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - HALF_PI, outerStartAdjustedAngle);
    }
  } else {
    ctx.moveTo(x3, y4);
    const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x3;
    const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y4;
    ctx.lineTo(outerStartX, outerStartY);
    const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x3;
    const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y4;
    ctx.lineTo(outerEndX, outerEndY);
  }
  ctx.closePath();
}
function drawArc(ctx, element, offset2, spacing, circular) {
  const { fullCircles, startAngle, circumference: circumference2 } = element;
  let endAngle = element.endAngle;
  if (fullCircles) {
    pathArc(ctx, element, offset2, spacing, startAngle + TAU, circular);
    for (let i3 = 0; i3 < fullCircles; ++i3) {
      ctx.fill();
    }
    if (!isNaN(circumference2)) {
      endAngle = startAngle + circumference2 % TAU;
      if (circumference2 % TAU === 0) {
        endAngle += TAU;
      }
    }
  }
  pathArc(ctx, element, offset2, spacing, endAngle, circular);
  ctx.fill();
  return endAngle;
}
function drawFullCircleBorders(ctx, element, inner) {
  const { x: x3, y: y4, startAngle, pixelMargin, fullCircles } = element;
  const outerRadius = Math.max(element.outerRadius - pixelMargin, 0);
  const innerRadius = element.innerRadius + pixelMargin;
  let i3;
  if (inner) {
    clipArc(ctx, element, startAngle + TAU);
  }
  ctx.beginPath();
  ctx.arc(x3, y4, innerRadius, startAngle + TAU, startAngle, true);
  for (i3 = 0; i3 < fullCircles; ++i3) {
    ctx.stroke();
  }
  ctx.beginPath();
  ctx.arc(x3, y4, outerRadius, startAngle, startAngle + TAU);
  for (i3 = 0; i3 < fullCircles; ++i3) {
    ctx.stroke();
  }
}
function drawBorder(ctx, element, offset2, spacing, endAngle, circular) {
  const { options } = element;
  const { borderWidth, borderJoinStyle } = options;
  const inner = options.borderAlign === "inner";
  if (!borderWidth) {
    return;
  }
  if (inner) {
    ctx.lineWidth = borderWidth * 2;
    ctx.lineJoin = borderJoinStyle || "round";
  } else {
    ctx.lineWidth = borderWidth;
    ctx.lineJoin = borderJoinStyle || "bevel";
  }
  if (element.fullCircles) {
    drawFullCircleBorders(ctx, element, inner);
  }
  if (inner) {
    clipArc(ctx, element, endAngle);
  }
  pathArc(ctx, element, offset2, spacing, endAngle, circular);
  ctx.stroke();
}
class ArcElement extends Element$1 {
  constructor(cfg) {
    super();
    this.options = void 0;
    this.circumference = void 0;
    this.startAngle = void 0;
    this.endAngle = void 0;
    this.innerRadius = void 0;
    this.outerRadius = void 0;
    this.pixelMargin = 0;
    this.fullCircles = 0;
    if (cfg) {
      Object.assign(this, cfg);
    }
  }
  inRange(chartX, chartY, useFinalPosition) {
    const point = this.getProps(["x", "y"], useFinalPosition);
    const { angle: angle2, distance } = getAngleFromPoint(point, { x: chartX, y: chartY });
    const { startAngle, endAngle, innerRadius, outerRadius, circumference: circumference2 } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], useFinalPosition);
    const rAdjust = this.options.spacing / 2;
    const _circumference = valueOrDefault(circumference2, endAngle - startAngle);
    const betweenAngles = _circumference >= TAU || _angleBetween(angle2, startAngle, endAngle);
    const withinRadius = _isBetween(distance, innerRadius + rAdjust, outerRadius + rAdjust);
    return betweenAngles && withinRadius;
  }
  getCenterPoint(useFinalPosition) {
    const { x: x3, y: y4, startAngle, endAngle, innerRadius, outerRadius } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], useFinalPosition);
    const { offset: offset2, spacing } = this.options;
    const halfAngle = (startAngle + endAngle) / 2;
    const halfRadius = (innerRadius + outerRadius + spacing + offset2) / 2;
    return {
      x: x3 + Math.cos(halfAngle) * halfRadius,
      y: y4 + Math.sin(halfAngle) * halfRadius
    };
  }
  tooltipPosition(useFinalPosition) {
    return this.getCenterPoint(useFinalPosition);
  }
  draw(ctx) {
    const { options, circumference: circumference2 } = this;
    const offset2 = (options.offset || 0) / 2;
    const spacing = (options.spacing || 0) / 2;
    const circular = options.circular;
    this.pixelMargin = options.borderAlign === "inner" ? 0.33 : 0;
    this.fullCircles = circumference2 > TAU ? Math.floor(circumference2 / TAU) : 0;
    if (circumference2 === 0 || this.innerRadius < 0 || this.outerRadius < 0) {
      return;
    }
    ctx.save();
    let radiusOffset = 0;
    if (offset2) {
      radiusOffset = offset2 / 2;
      const halfAngle = (this.startAngle + this.endAngle) / 2;
      ctx.translate(Math.cos(halfAngle) * radiusOffset, Math.sin(halfAngle) * radiusOffset);
      if (this.circumference >= PI) {
        radiusOffset = offset2;
      }
    }
    ctx.fillStyle = options.backgroundColor;
    ctx.strokeStyle = options.borderColor;
    const endAngle = drawArc(ctx, this, radiusOffset, spacing, circular);
    drawBorder(ctx, this, radiusOffset, spacing, endAngle, circular);
    ctx.restore();
  }
}
ArcElement.id = "arc";
ArcElement.defaults = {
  borderAlign: "center",
  borderColor: "#fff",
  borderJoinStyle: void 0,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: void 0,
  circular: true
};
ArcElement.defaultRoutes = {
  backgroundColor: "backgroundColor"
};
function setStyle(ctx, options, style = options) {
  ctx.lineCap = valueOrDefault(style.borderCapStyle, options.borderCapStyle);
  ctx.setLineDash(valueOrDefault(style.borderDash, options.borderDash));
  ctx.lineDashOffset = valueOrDefault(style.borderDashOffset, options.borderDashOffset);
  ctx.lineJoin = valueOrDefault(style.borderJoinStyle, options.borderJoinStyle);
  ctx.lineWidth = valueOrDefault(style.borderWidth, options.borderWidth);
  ctx.strokeStyle = valueOrDefault(style.borderColor, options.borderColor);
}
function lineTo(ctx, previous, target2) {
  ctx.lineTo(target2.x, target2.y);
}
function getLineMethod(options) {
  if (options.stepped) {
    return _steppedLineTo;
  }
  if (options.tension || options.cubicInterpolationMode === "monotone") {
    return _bezierCurveTo;
  }
  return lineTo;
}
function pathVars(points, segment, params = {}) {
  const count = points.length;
  const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
  const { start: segmentStart, end: segmentEnd } = segment;
  const start = Math.max(paramsStart, segmentStart);
  const end = Math.min(paramsEnd, segmentEnd);
  const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
  return {
    count,
    start,
    loop: segment.loop,
    ilen: end < start && !outside ? count + end - start : end - start
  };
}
function pathSegment(ctx, line, segment, params) {
  const { points, options } = line;
  const { count, start, loop, ilen } = pathVars(points, segment, params);
  const lineMethod = getLineMethod(options);
  let { move = true, reverse } = params || {};
  let i3, point, prev;
  for (i3 = 0; i3 <= ilen; ++i3) {
    point = points[(start + (reverse ? ilen - i3 : i3)) % count];
    if (point.skip) {
      continue;
    } else if (move) {
      ctx.moveTo(point.x, point.y);
      move = false;
    } else {
      lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    prev = point;
  }
  if (loop) {
    point = points[(start + (reverse ? ilen : 0)) % count];
    lineMethod(ctx, prev, point, reverse, options.stepped);
  }
  return !!loop;
}
function fastPathSegment(ctx, line, segment, params) {
  const points = line.points;
  const { count, start, ilen } = pathVars(points, segment, params);
  const { move = true, reverse } = params || {};
  let avgX = 0;
  let countX = 0;
  let i3, point, prevX, minY, maxY, lastY;
  const pointIndex = (index2) => (start + (reverse ? ilen - index2 : index2)) % count;
  const drawX = () => {
    if (minY !== maxY) {
      ctx.lineTo(avgX, maxY);
      ctx.lineTo(avgX, minY);
      ctx.lineTo(avgX, lastY);
    }
  };
  if (move) {
    point = points[pointIndex(0)];
    ctx.moveTo(point.x, point.y);
  }
  for (i3 = 0; i3 <= ilen; ++i3) {
    point = points[pointIndex(i3)];
    if (point.skip) {
      continue;
    }
    const x3 = point.x;
    const y4 = point.y;
    const truncX = x3 | 0;
    if (truncX === prevX) {
      if (y4 < minY) {
        minY = y4;
      } else if (y4 > maxY) {
        maxY = y4;
      }
      avgX = (countX * avgX + x3) / ++countX;
    } else {
      drawX();
      ctx.lineTo(x3, y4);
      prevX = truncX;
      countX = 0;
      minY = maxY = y4;
    }
    lastY = y4;
  }
  drawX();
}
function _getSegmentMethod(line) {
  const opts = line.options;
  const borderDash = opts.borderDash && opts.borderDash.length;
  const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== "monotone" && !opts.stepped && !borderDash;
  return useFastPath ? fastPathSegment : pathSegment;
}
function _getInterpolationMethod(options) {
  if (options.stepped) {
    return _steppedInterpolation;
  }
  if (options.tension || options.cubicInterpolationMode === "monotone") {
    return _bezierInterpolation;
  }
  return _pointInLine;
}
function strokePathWithCache(ctx, line, start, count) {
  let path = line._path;
  if (!path) {
    path = line._path = new Path2D();
    if (line.path(path, start, count)) {
      path.closePath();
    }
  }
  setStyle(ctx, line.options);
  ctx.stroke(path);
}
function strokePathDirect(ctx, line, start, count) {
  const { segments, options } = line;
  const segmentMethod = _getSegmentMethod(line);
  for (const segment of segments) {
    setStyle(ctx, options, segment.style);
    ctx.beginPath();
    if (segmentMethod(ctx, line, segment, { start, end: start + count - 1 })) {
      ctx.closePath();
    }
    ctx.stroke();
  }
}
const usePath2D = typeof Path2D === "function";
function draw(ctx, line, start, count) {
  if (usePath2D && !line.options.segment) {
    strokePathWithCache(ctx, line, start, count);
  } else {
    strokePathDirect(ctx, line, start, count);
  }
}
class LineElement extends Element$1 {
  constructor(cfg) {
    super();
    this.animated = true;
    this.options = void 0;
    this._chart = void 0;
    this._loop = void 0;
    this._fullLoop = void 0;
    this._path = void 0;
    this._points = void 0;
    this._segments = void 0;
    this._decimated = false;
    this._pointsUpdated = false;
    this._datasetIndex = void 0;
    if (cfg) {
      Object.assign(this, cfg);
    }
  }
  updateControlPoints(chartArea, indexAxis) {
    const options = this.options;
    if ((options.tension || options.cubicInterpolationMode === "monotone") && !options.stepped && !this._pointsUpdated) {
      const loop = options.spanGaps ? this._loop : this._fullLoop;
      _updateBezierControlPoints(this._points, options, chartArea, loop, indexAxis);
      this._pointsUpdated = true;
    }
  }
  set points(points) {
    this._points = points;
    delete this._segments;
    delete this._path;
    this._pointsUpdated = false;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = _computeSegments(this, this.options.segment));
  }
  first() {
    const segments = this.segments;
    const points = this.points;
    return segments.length && points[segments[0].start];
  }
  last() {
    const segments = this.segments;
    const points = this.points;
    const count = segments.length;
    return count && points[segments[count - 1].end];
  }
  interpolate(point, property) {
    const options = this.options;
    const value2 = point[property];
    const points = this.points;
    const segments = _boundSegments(this, { property, start: value2, end: value2 });
    if (!segments.length) {
      return;
    }
    const result = [];
    const _interpolate = _getInterpolationMethod(options);
    let i3, ilen;
    for (i3 = 0, ilen = segments.length; i3 < ilen; ++i3) {
      const { start, end } = segments[i3];
      const p1 = points[start];
      const p2 = points[end];
      if (p1 === p2) {
        result.push(p1);
        continue;
      }
      const t3 = Math.abs((value2 - p1[property]) / (p2[property] - p1[property]));
      const interpolated = _interpolate(p1, p2, t3, options.stepped);
      interpolated[property] = point[property];
      result.push(interpolated);
    }
    return result.length === 1 ? result[0] : result;
  }
  pathSegment(ctx, segment, params) {
    const segmentMethod = _getSegmentMethod(this);
    return segmentMethod(ctx, this, segment, params);
  }
  path(ctx, start, count) {
    const segments = this.segments;
    const segmentMethod = _getSegmentMethod(this);
    let loop = this._loop;
    start = start || 0;
    count = count || this.points.length - start;
    for (const segment of segments) {
      loop &= segmentMethod(ctx, this, segment, { start, end: start + count - 1 });
    }
    return !!loop;
  }
  draw(ctx, chartArea, start, count) {
    const options = this.options || {};
    const points = this.points || [];
    if (points.length && options.borderWidth) {
      ctx.save();
      draw(ctx, this, start, count);
      ctx.restore();
    }
    if (this.animated) {
      this._pointsUpdated = false;
      this._path = void 0;
    }
  }
}
LineElement.id = "line";
LineElement.defaults = {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: true,
  cubicInterpolationMode: "default",
  fill: false,
  spanGaps: false,
  stepped: false,
  tension: 0
};
LineElement.defaultRoutes = {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
};
LineElement.descriptors = {
  _scriptable: true,
  _indexable: (name2) => name2 !== "borderDash" && name2 !== "fill"
};
function inRange$1(el, pos, axis, useFinalPosition) {
  const options = el.options;
  const { [axis]: value2 } = el.getProps([axis], useFinalPosition);
  return Math.abs(pos - value2) < options.radius + options.hitRadius;
}
class PointElement extends Element$1 {
  constructor(cfg) {
    super();
    this.options = void 0;
    this.parsed = void 0;
    this.skip = void 0;
    this.stop = void 0;
    if (cfg) {
      Object.assign(this, cfg);
    }
  }
  inRange(mouseX, mouseY, useFinalPosition) {
    const options = this.options;
    const { x: x3, y: y4 } = this.getProps(["x", "y"], useFinalPosition);
    return Math.pow(mouseX - x3, 2) + Math.pow(mouseY - y4, 2) < Math.pow(options.hitRadius + options.radius, 2);
  }
  inXRange(mouseX, useFinalPosition) {
    return inRange$1(this, mouseX, "x", useFinalPosition);
  }
  inYRange(mouseY, useFinalPosition) {
    return inRange$1(this, mouseY, "y", useFinalPosition);
  }
  getCenterPoint(useFinalPosition) {
    const { x: x3, y: y4 } = this.getProps(["x", "y"], useFinalPosition);
    return { x: x3, y: y4 };
  }
  size(options) {
    options = options || this.options || {};
    let radius2 = options.radius || 0;
    radius2 = Math.max(radius2, radius2 && options.hoverRadius || 0);
    const borderWidth = radius2 && options.borderWidth || 0;
    return (radius2 + borderWidth) * 2;
  }
  draw(ctx, area) {
    const options = this.options;
    if (this.skip || options.radius < 0.1 || !_isPointInArea(this, area, this.size(options) / 2)) {
      return;
    }
    ctx.strokeStyle = options.borderColor;
    ctx.lineWidth = options.borderWidth;
    ctx.fillStyle = options.backgroundColor;
    drawPoint(ctx, options, this.x, this.y);
  }
  getRange() {
    const options = this.options || {};
    return options.radius + options.hitRadius;
  }
}
PointElement.id = "point";
PointElement.defaults = {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
};
PointElement.defaultRoutes = {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
};
function getBarBounds(bar, useFinalPosition) {
  const { x: x3, y: y4, base, width, height: height2 } = bar.getProps(["x", "y", "base", "width", "height"], useFinalPosition);
  let left, right, top, bottom, half;
  if (bar.horizontal) {
    half = height2 / 2;
    left = Math.min(x3, base);
    right = Math.max(x3, base);
    top = y4 - half;
    bottom = y4 + half;
  } else {
    half = width / 2;
    left = x3 - half;
    right = x3 + half;
    top = Math.min(y4, base);
    bottom = Math.max(y4, base);
  }
  return { left, top, right, bottom };
}
function skipOrLimit(skip2, value2, min2, max2) {
  return skip2 ? 0 : _limitValue(value2, min2, max2);
}
function parseBorderWidth(bar, maxW, maxH) {
  const value2 = bar.options.borderWidth;
  const skip2 = bar.borderSkipped;
  const o = toTRBL(value2);
  return {
    t: skipOrLimit(skip2.top, o.top, 0, maxH),
    r: skipOrLimit(skip2.right, o.right, 0, maxW),
    b: skipOrLimit(skip2.bottom, o.bottom, 0, maxH),
    l: skipOrLimit(skip2.left, o.left, 0, maxW)
  };
}
function parseBorderRadius(bar, maxW, maxH) {
  const { enableBorderRadius } = bar.getProps(["enableBorderRadius"]);
  const value2 = bar.options.borderRadius;
  const o = toTRBLCorners(value2);
  const maxR = Math.min(maxW, maxH);
  const skip2 = bar.borderSkipped;
  const enableBorder = enableBorderRadius || isObject$3(value2);
  return {
    topLeft: skipOrLimit(!enableBorder || skip2.top || skip2.left, o.topLeft, 0, maxR),
    topRight: skipOrLimit(!enableBorder || skip2.top || skip2.right, o.topRight, 0, maxR),
    bottomLeft: skipOrLimit(!enableBorder || skip2.bottom || skip2.left, o.bottomLeft, 0, maxR),
    bottomRight: skipOrLimit(!enableBorder || skip2.bottom || skip2.right, o.bottomRight, 0, maxR)
  };
}
function boundingRects(bar) {
  const bounds = getBarBounds(bar);
  const width = bounds.right - bounds.left;
  const height2 = bounds.bottom - bounds.top;
  const border = parseBorderWidth(bar, width / 2, height2 / 2);
  const radius2 = parseBorderRadius(bar, width / 2, height2 / 2);
  return {
    outer: {
      x: bounds.left,
      y: bounds.top,
      w: width,
      h: height2,
      radius: radius2
    },
    inner: {
      x: bounds.left + border.l,
      y: bounds.top + border.t,
      w: width - border.l - border.r,
      h: height2 - border.t - border.b,
      radius: {
        topLeft: Math.max(0, radius2.topLeft - Math.max(border.t, border.l)),
        topRight: Math.max(0, radius2.topRight - Math.max(border.t, border.r)),
        bottomLeft: Math.max(0, radius2.bottomLeft - Math.max(border.b, border.l)),
        bottomRight: Math.max(0, radius2.bottomRight - Math.max(border.b, border.r))
      }
    }
  };
}
function inRange(bar, x3, y4, useFinalPosition) {
  const skipX = x3 === null;
  const skipY = y4 === null;
  const skipBoth = skipX && skipY;
  const bounds = bar && !skipBoth && getBarBounds(bar, useFinalPosition);
  return bounds && (skipX || _isBetween(x3, bounds.left, bounds.right)) && (skipY || _isBetween(y4, bounds.top, bounds.bottom));
}
function hasRadius(radius2) {
  return radius2.topLeft || radius2.topRight || radius2.bottomLeft || radius2.bottomRight;
}
function addNormalRectPath(ctx, rect) {
  ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function inflateRect(rect, amount, refRect = {}) {
  const x3 = rect.x !== refRect.x ? -amount : 0;
  const y4 = rect.y !== refRect.y ? -amount : 0;
  const w3 = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x3;
  const h6 = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y4;
  return {
    x: rect.x + x3,
    y: rect.y + y4,
    w: rect.w + w3,
    h: rect.h + h6,
    radius: rect.radius
  };
}
class BarElement extends Element$1 {
  constructor(cfg) {
    super();
    this.options = void 0;
    this.horizontal = void 0;
    this.base = void 0;
    this.width = void 0;
    this.height = void 0;
    this.inflateAmount = void 0;
    if (cfg) {
      Object.assign(this, cfg);
    }
  }
  draw(ctx) {
    const { inflateAmount, options: { borderColor, backgroundColor } } = this;
    const { inner, outer } = boundingRects(this);
    const addRectPath = hasRadius(outer.radius) ? addRoundedRectPath : addNormalRectPath;
    ctx.save();
    if (outer.w !== inner.w || outer.h !== inner.h) {
      ctx.beginPath();
      addRectPath(ctx, inflateRect(outer, inflateAmount, inner));
      ctx.clip();
      addRectPath(ctx, inflateRect(inner, -inflateAmount, outer));
      ctx.fillStyle = borderColor;
      ctx.fill("evenodd");
    }
    ctx.beginPath();
    addRectPath(ctx, inflateRect(inner, inflateAmount));
    ctx.fillStyle = backgroundColor;
    ctx.fill();
    ctx.restore();
  }
  inRange(mouseX, mouseY, useFinalPosition) {
    return inRange(this, mouseX, mouseY, useFinalPosition);
  }
  inXRange(mouseX, useFinalPosition) {
    return inRange(this, mouseX, null, useFinalPosition);
  }
  inYRange(mouseY, useFinalPosition) {
    return inRange(this, null, mouseY, useFinalPosition);
  }
  getCenterPoint(useFinalPosition) {
    const { x: x3, y: y4, base, horizontal } = this.getProps(["x", "y", "base", "horizontal"], useFinalPosition);
    return {
      x: horizontal ? (x3 + base) / 2 : x3,
      y: horizontal ? y4 : (y4 + base) / 2
    };
  }
  getRange(axis) {
    return axis === "x" ? this.width / 2 : this.height / 2;
  }
}
BarElement.id = "bar";
BarElement.defaults = {
  borderSkipped: "start",
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: "auto",
  pointStyle: void 0
};
BarElement.defaultRoutes = {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
};
function _segments(line, target2, property) {
  const segments = line.segments;
  const points = line.points;
  const tpoints = target2.points;
  const parts = [];
  for (const segment of segments) {
    let { start, end } = segment;
    end = _findSegmentEnd(start, end, points);
    const bounds = _getBounds(property, points[start], points[end], segment.loop);
    if (!target2.segments) {
      parts.push({
        source: segment,
        target: bounds,
        start: points[start],
        end: points[end]
      });
      continue;
    }
    const targetSegments = _boundSegments(target2, bounds);
    for (const tgt of targetSegments) {
      const subBounds = _getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
      const fillSources = _boundSegment(segment, points, subBounds);
      for (const fillSource of fillSources) {
        parts.push({
          source: fillSource,
          target: tgt,
          start: {
            [property]: _getEdge(bounds, subBounds, "start", Math.max)
          },
          end: {
            [property]: _getEdge(bounds, subBounds, "end", Math.min)
          }
        });
      }
    }
  }
  return parts;
}
function _getBounds(property, first, last2, loop) {
  if (loop) {
    return;
  }
  let start = first[property];
  let end = last2[property];
  if (property === "angle") {
    start = _normalizeAngle(start);
    end = _normalizeAngle(end);
  }
  return { property, start, end };
}
function _pointsFromSegments(boundary, line) {
  const { x: x3 = null, y: y4 = null } = boundary || {};
  const linePoints = line.points;
  const points = [];
  line.segments.forEach(({ start, end }) => {
    end = _findSegmentEnd(start, end, linePoints);
    const first = linePoints[start];
    const last2 = linePoints[end];
    if (y4 !== null) {
      points.push({ x: first.x, y: y4 });
      points.push({ x: last2.x, y: y4 });
    } else if (x3 !== null) {
      points.push({ x: x3, y: first.y });
      points.push({ x: x3, y: last2.y });
    }
  });
  return points;
}
function _findSegmentEnd(start, end, points) {
  for (; end > start; end--) {
    const point = points[end];
    if (!isNaN(point.x) && !isNaN(point.y)) {
      break;
    }
  }
  return end;
}
function _getEdge(a4, b3, prop, fn) {
  if (a4 && b3) {
    return fn(a4[prop], b3[prop]);
  }
  return a4 ? a4[prop] : b3 ? b3[prop] : 0;
}
function _createBoundaryLine(boundary, line) {
  let points = [];
  let _loop = false;
  if (isArray(boundary)) {
    _loop = true;
    points = boundary;
  } else {
    points = _pointsFromSegments(boundary, line);
  }
  return points.length ? new LineElement({
    points,
    options: { tension: 0 },
    _loop,
    _fullLoop: _loop
  }) : null;
}
function _shouldApplyFill(source) {
  return source && source.fill !== false;
}
function _resolveTarget(sources, index2, propagate) {
  const source = sources[index2];
  let fill2 = source.fill;
  const visited = [index2];
  let target2;
  if (!propagate) {
    return fill2;
  }
  while (fill2 !== false && visited.indexOf(fill2) === -1) {
    if (!isNumberFinite(fill2)) {
      return fill2;
    }
    target2 = sources[fill2];
    if (!target2) {
      return false;
    }
    if (target2.visible) {
      return fill2;
    }
    visited.push(fill2);
    fill2 = target2.fill;
  }
  return false;
}
function _decodeFill(line, index2, count) {
  const fill2 = parseFillOption(line);
  if (isObject$3(fill2)) {
    return isNaN(fill2.value) ? false : fill2;
  }
  let target2 = parseFloat(fill2);
  if (isNumberFinite(target2) && Math.floor(target2) === target2) {
    return decodeTargetIndex(fill2[0], index2, target2, count);
  }
  return ["origin", "start", "end", "stack", "shape"].indexOf(fill2) >= 0 && fill2;
}
function decodeTargetIndex(firstCh, index2, target2, count) {
  if (firstCh === "-" || firstCh === "+") {
    target2 = index2 + target2;
  }
  if (target2 === index2 || target2 < 0 || target2 >= count) {
    return false;
  }
  return target2;
}
function _getTargetPixel(fill2, scale) {
  let pixel = null;
  if (fill2 === "start") {
    pixel = scale.bottom;
  } else if (fill2 === "end") {
    pixel = scale.top;
  } else if (isObject$3(fill2)) {
    pixel = scale.getPixelForValue(fill2.value);
  } else if (scale.getBasePixel) {
    pixel = scale.getBasePixel();
  }
  return pixel;
}
function _getTargetValue(fill2, scale, startValue) {
  let value2;
  if (fill2 === "start") {
    value2 = startValue;
  } else if (fill2 === "end") {
    value2 = scale.options.reverse ? scale.min : scale.max;
  } else if (isObject$3(fill2)) {
    value2 = fill2.value;
  } else {
    value2 = scale.getBaseValue();
  }
  return value2;
}
function parseFillOption(line) {
  const options = line.options;
  const fillOption = options.fill;
  let fill2 = valueOrDefault(fillOption && fillOption.target, fillOption);
  if (fill2 === void 0) {
    fill2 = !!options.backgroundColor;
  }
  if (fill2 === false || fill2 === null) {
    return false;
  }
  if (fill2 === true) {
    return "origin";
  }
  return fill2;
}
function _buildStackLine(source) {
  const { scale, index: index2, line } = source;
  const points = [];
  const segments = line.segments;
  const sourcePoints = line.points;
  const linesBelow = getLinesBelow(scale, index2);
  linesBelow.push(_createBoundaryLine({ x: null, y: scale.bottom }, line));
  for (let i3 = 0; i3 < segments.length; i3++) {
    const segment = segments[i3];
    for (let j = segment.start; j <= segment.end; j++) {
      addPointsBelow(points, sourcePoints[j], linesBelow);
    }
  }
  return new LineElement({ points, options: {} });
}
function getLinesBelow(scale, index2) {
  const below = [];
  const metas = scale.getMatchingVisibleMetas("line");
  for (let i3 = 0; i3 < metas.length; i3++) {
    const meta = metas[i3];
    if (meta.index === index2) {
      break;
    }
    if (!meta.hidden) {
      below.unshift(meta.dataset);
    }
  }
  return below;
}
function addPointsBelow(points, sourcePoint, linesBelow) {
  const postponed = [];
  for (let j = 0; j < linesBelow.length; j++) {
    const line = linesBelow[j];
    const { first, last: last2, point } = findPoint(line, sourcePoint, "x");
    if (!point || first && last2) {
      continue;
    }
    if (first) {
      postponed.unshift(point);
    } else {
      points.push(point);
      if (!last2) {
        break;
      }
    }
  }
  points.push(...postponed);
}
function findPoint(line, sourcePoint, property) {
  const point = line.interpolate(sourcePoint, property);
  if (!point) {
    return {};
  }
  const pointValue = point[property];
  const segments = line.segments;
  const linePoints = line.points;
  let first = false;
  let last2 = false;
  for (let i3 = 0; i3 < segments.length; i3++) {
    const segment = segments[i3];
    const firstValue = linePoints[segment.start][property];
    const lastValue = linePoints[segment.end][property];
    if (_isBetween(pointValue, firstValue, lastValue)) {
      first = pointValue === firstValue;
      last2 = pointValue === lastValue;
      break;
    }
  }
  return { first, last: last2, point };
}
class simpleArc {
  constructor(opts) {
    this.x = opts.x;
    this.y = opts.y;
    this.radius = opts.radius;
  }
  pathSegment(ctx, bounds, opts) {
    const { x: x3, y: y4, radius: radius2 } = this;
    bounds = bounds || { start: 0, end: TAU };
    ctx.arc(x3, y4, radius2, bounds.end, bounds.start, true);
    return !opts.bounds;
  }
  interpolate(point) {
    const { x: x3, y: y4, radius: radius2 } = this;
    const angle2 = point.angle;
    return {
      x: x3 + Math.cos(angle2) * radius2,
      y: y4 + Math.sin(angle2) * radius2,
      angle: angle2
    };
  }
}
function _getTarget(source) {
  const { chart, fill: fill2, line } = source;
  if (isNumberFinite(fill2)) {
    return getLineByIndex(chart, fill2);
  }
  if (fill2 === "stack") {
    return _buildStackLine(source);
  }
  if (fill2 === "shape") {
    return true;
  }
  const boundary = computeBoundary(source);
  if (boundary instanceof simpleArc) {
    return boundary;
  }
  return _createBoundaryLine(boundary, line);
}
function getLineByIndex(chart, index2) {
  const meta = chart.getDatasetMeta(index2);
  const visible = meta && chart.isDatasetVisible(index2);
  return visible ? meta.dataset : null;
}
function computeBoundary(source) {
  const scale = source.scale || {};
  if (scale.getPointPositionForValue) {
    return computeCircularBoundary(source);
  }
  return computeLinearBoundary(source);
}
function computeLinearBoundary(source) {
  const { scale = {}, fill: fill2 } = source;
  const pixel = _getTargetPixel(fill2, scale);
  if (isNumberFinite(pixel)) {
    const horizontal = scale.isHorizontal();
    return {
      x: horizontal ? pixel : null,
      y: horizontal ? null : pixel
    };
  }
  return null;
}
function computeCircularBoundary(source) {
  const { scale, fill: fill2 } = source;
  const options = scale.options;
  const length = scale.getLabels().length;
  const start = options.reverse ? scale.max : scale.min;
  const value2 = _getTargetValue(fill2, scale, start);
  const target2 = [];
  if (options.grid.circular) {
    const center = scale.getPointPositionForValue(0, start);
    return new simpleArc({
      x: center.x,
      y: center.y,
      radius: scale.getDistanceFromCenterForValue(value2)
    });
  }
  for (let i3 = 0; i3 < length; ++i3) {
    target2.push(scale.getPointPositionForValue(i3, value2));
  }
  return target2;
}
function _drawfill(ctx, source, area) {
  const target2 = _getTarget(source);
  const { line, scale, axis } = source;
  const lineOpts = line.options;
  const fillOption = lineOpts.fill;
  const color2 = lineOpts.backgroundColor;
  const { above = color2, below = color2 } = fillOption || {};
  if (target2 && line.points.length) {
    clipArea(ctx, area);
    doFill(ctx, { line, target: target2, above, below, area, scale, axis });
    unclipArea(ctx);
  }
}
function doFill(ctx, cfg) {
  const { line, target: target2, above, below, area, scale } = cfg;
  const property = line._loop ? "angle" : cfg.axis;
  ctx.save();
  if (property === "x" && below !== above) {
    clipVertical(ctx, target2, area.top);
    fill(ctx, { line, target: target2, color: above, scale, property });
    ctx.restore();
    ctx.save();
    clipVertical(ctx, target2, area.bottom);
  }
  fill(ctx, { line, target: target2, color: below, scale, property });
  ctx.restore();
}
function clipVertical(ctx, target2, clipY) {
  const { segments, points } = target2;
  let first = true;
  let lineLoop = false;
  ctx.beginPath();
  for (const segment of segments) {
    const { start, end } = segment;
    const firstPoint = points[start];
    const lastPoint = points[_findSegmentEnd(start, end, points)];
    if (first) {
      ctx.moveTo(firstPoint.x, firstPoint.y);
      first = false;
    } else {
      ctx.lineTo(firstPoint.x, clipY);
      ctx.lineTo(firstPoint.x, firstPoint.y);
    }
    lineLoop = !!target2.pathSegment(ctx, segment, { move: lineLoop });
    if (lineLoop) {
      ctx.closePath();
    } else {
      ctx.lineTo(lastPoint.x, clipY);
    }
  }
  ctx.lineTo(target2.first().x, clipY);
  ctx.closePath();
  ctx.clip();
}
function fill(ctx, cfg) {
  const { line, target: target2, property, color: color2, scale } = cfg;
  const segments = _segments(line, target2, property);
  for (const { source: src, target: tgt, start, end } of segments) {
    const { style: { backgroundColor = color2 } = {} } = src;
    const notShape = target2 !== true;
    ctx.save();
    ctx.fillStyle = backgroundColor;
    clipBounds(ctx, scale, notShape && _getBounds(property, start, end));
    ctx.beginPath();
    const lineLoop = !!line.pathSegment(ctx, src);
    let loop;
    if (notShape) {
      if (lineLoop) {
        ctx.closePath();
      } else {
        interpolatedLineTo(ctx, target2, end, property);
      }
      const targetLoop = !!target2.pathSegment(ctx, tgt, { move: lineLoop, reverse: true });
      loop = lineLoop && targetLoop;
      if (!loop) {
        interpolatedLineTo(ctx, target2, start, property);
      }
    }
    ctx.closePath();
    ctx.fill(loop ? "evenodd" : "nonzero");
    ctx.restore();
  }
}
function clipBounds(ctx, scale, bounds) {
  const { top, bottom } = scale.chart.chartArea;
  const { property, start, end } = bounds || {};
  if (property === "x") {
    ctx.beginPath();
    ctx.rect(start, top, end - start, bottom - top);
    ctx.clip();
  }
}
function interpolatedLineTo(ctx, target2, point, property) {
  const interpolatedPoint = target2.interpolate(point, property);
  if (interpolatedPoint) {
    ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
  }
}
var index = {
  id: "filler",
  afterDatasetsUpdate(chart, _args, options) {
    const count = (chart.data.datasets || []).length;
    const sources = [];
    let meta, i3, line, source;
    for (i3 = 0; i3 < count; ++i3) {
      meta = chart.getDatasetMeta(i3);
      line = meta.dataset;
      source = null;
      if (line && line.options && line instanceof LineElement) {
        source = {
          visible: chart.isDatasetVisible(i3),
          index: i3,
          fill: _decodeFill(line, i3, count),
          chart,
          axis: meta.controller.options.indexAxis,
          scale: meta.vScale,
          line
        };
      }
      meta.$filler = source;
      sources.push(source);
    }
    for (i3 = 0; i3 < count; ++i3) {
      source = sources[i3];
      if (!source || source.fill === false) {
        continue;
      }
      source.fill = _resolveTarget(sources, i3, options.propagate);
    }
  },
  beforeDraw(chart, _args, options) {
    const draw2 = options.drawTime === "beforeDraw";
    const metasets = chart.getSortedVisibleDatasetMetas();
    const area = chart.chartArea;
    for (let i3 = metasets.length - 1; i3 >= 0; --i3) {
      const source = metasets[i3].$filler;
      if (!source) {
        continue;
      }
      source.line.updateControlPoints(area, source.axis);
      if (draw2 && source.fill) {
        _drawfill(chart.ctx, source, area);
      }
    }
  },
  beforeDatasetsDraw(chart, _args, options) {
    if (options.drawTime !== "beforeDatasetsDraw") {
      return;
    }
    const metasets = chart.getSortedVisibleDatasetMetas();
    for (let i3 = metasets.length - 1; i3 >= 0; --i3) {
      const source = metasets[i3].$filler;
      if (_shouldApplyFill(source)) {
        _drawfill(chart.ctx, source, chart.chartArea);
      }
    }
  },
  beforeDatasetDraw(chart, args, options) {
    const source = args.meta.$filler;
    if (!_shouldApplyFill(source) || options.drawTime !== "beforeDatasetDraw") {
      return;
    }
    _drawfill(chart.ctx, source, chart.chartArea);
  },
  defaults: {
    propagate: true,
    drawTime: "beforeDatasetDraw"
  }
};
const positioners = {
  average(items) {
    if (!items.length) {
      return false;
    }
    let i3, len;
    let x3 = 0;
    let y4 = 0;
    let count = 0;
    for (i3 = 0, len = items.length; i3 < len; ++i3) {
      const el = items[i3].element;
      if (el && el.hasValue()) {
        const pos = el.tooltipPosition();
        x3 += pos.x;
        y4 += pos.y;
        ++count;
      }
    }
    return {
      x: x3 / count,
      y: y4 / count
    };
  },
  nearest(items, eventPosition) {
    if (!items.length) {
      return false;
    }
    let x3 = eventPosition.x;
    let y4 = eventPosition.y;
    let minDistance = Number.POSITIVE_INFINITY;
    let i3, len, nearestElement;
    for (i3 = 0, len = items.length; i3 < len; ++i3) {
      const el = items[i3].element;
      if (el && el.hasValue()) {
        const center = el.getCenterPoint();
        const d4 = distanceBetweenPoints(eventPosition, center);
        if (d4 < minDistance) {
          minDistance = d4;
          nearestElement = el;
        }
      }
    }
    if (nearestElement) {
      const tp = nearestElement.tooltipPosition();
      x3 = tp.x;
      y4 = tp.y;
    }
    return {
      x: x3,
      y: y4
    };
  }
};
function pushOrConcat(base, toPush) {
  if (toPush) {
    if (isArray(toPush)) {
      Array.prototype.push.apply(base, toPush);
    } else {
      base.push(toPush);
    }
  }
  return base;
}
function splitNewlines(str) {
  if ((typeof str === "string" || str instanceof String) && str.indexOf("\n") > -1) {
    return str.split("\n");
  }
  return str;
}
function createTooltipItem(chart, item) {
  const { element, datasetIndex, index: index2 } = item;
  const controller = chart.getDatasetMeta(datasetIndex).controller;
  const { label, value: value2 } = controller.getLabelAndValue(index2);
  return {
    chart,
    label,
    parsed: controller.getParsed(index2),
    raw: chart.data.datasets[datasetIndex].data[index2],
    formattedValue: value2,
    dataset: controller.getDataset(),
    dataIndex: index2,
    datasetIndex,
    element
  };
}
function getTooltipSize(tooltip, options) {
  const ctx = tooltip.chart.ctx;
  const { body, footer, title } = tooltip;
  const { boxWidth, boxHeight } = options;
  const bodyFont = toFont(options.bodyFont);
  const titleFont = toFont(options.titleFont);
  const footerFont = toFont(options.footerFont);
  const titleLineCount = title.length;
  const footerLineCount = footer.length;
  const bodyLineItemCount = body.length;
  const padding = toPadding(options.padding);
  let height2 = padding.height;
  let width = 0;
  let combinedBodyLength = body.reduce((count, bodyItem) => count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
  combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
  if (titleLineCount) {
    height2 += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
  }
  if (combinedBodyLength) {
    const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
    height2 += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
  }
  if (footerLineCount) {
    height2 += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
  }
  let widthPadding = 0;
  const maxLineWidth = function(line) {
    width = Math.max(width, ctx.measureText(line).width + widthPadding);
  };
  ctx.save();
  ctx.font = titleFont.string;
  each(tooltip.title, maxLineWidth);
  ctx.font = bodyFont.string;
  each(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
  widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
  each(body, (bodyItem) => {
    each(bodyItem.before, maxLineWidth);
    each(bodyItem.lines, maxLineWidth);
    each(bodyItem.after, maxLineWidth);
  });
  widthPadding = 0;
  ctx.font = footerFont.string;
  each(tooltip.footer, maxLineWidth);
  ctx.restore();
  width += padding.width;
  return { width, height: height2 };
}
function determineYAlign(chart, size2) {
  const { y: y4, height: height2 } = size2;
  if (y4 < height2 / 2) {
    return "top";
  } else if (y4 > chart.height - height2 / 2) {
    return "bottom";
  }
  return "center";
}
function doesNotFitWithAlign(xAlign, chart, options, size2) {
  const { x: x3, width } = size2;
  const caret = options.caretSize + options.caretPadding;
  if (xAlign === "left" && x3 + width + caret > chart.width) {
    return true;
  }
  if (xAlign === "right" && x3 - width - caret < 0) {
    return true;
  }
}
function determineXAlign(chart, options, size2, yAlign) {
  const { x: x3, width } = size2;
  const { width: chartWidth, chartArea: { left, right } } = chart;
  let xAlign = "center";
  if (yAlign === "center") {
    xAlign = x3 <= (left + right) / 2 ? "left" : "right";
  } else if (x3 <= width / 2) {
    xAlign = "left";
  } else if (x3 >= chartWidth - width / 2) {
    xAlign = "right";
  }
  if (doesNotFitWithAlign(xAlign, chart, options, size2)) {
    xAlign = "center";
  }
  return xAlign;
}
function determineAlignment(chart, options, size2) {
  const yAlign = size2.yAlign || options.yAlign || determineYAlign(chart, size2);
  return {
    xAlign: size2.xAlign || options.xAlign || determineXAlign(chart, options, size2, yAlign),
    yAlign
  };
}
function alignX(size2, xAlign) {
  let { x: x3, width } = size2;
  if (xAlign === "right") {
    x3 -= width;
  } else if (xAlign === "center") {
    x3 -= width / 2;
  }
  return x3;
}
function alignY(size2, yAlign, paddingAndSize) {
  let { y: y4, height: height2 } = size2;
  if (yAlign === "top") {
    y4 += paddingAndSize;
  } else if (yAlign === "bottom") {
    y4 -= height2 + paddingAndSize;
  } else {
    y4 -= height2 / 2;
  }
  return y4;
}
function getBackgroundPoint(options, size2, alignment, chart) {
  const { caretSize, caretPadding, cornerRadius } = options;
  const { xAlign, yAlign } = alignment;
  const paddingAndSize = caretSize + caretPadding;
  const { topLeft, topRight, bottomLeft, bottomRight } = toTRBLCorners(cornerRadius);
  let x3 = alignX(size2, xAlign);
  const y4 = alignY(size2, yAlign, paddingAndSize);
  if (yAlign === "center") {
    if (xAlign === "left") {
      x3 += paddingAndSize;
    } else if (xAlign === "right") {
      x3 -= paddingAndSize;
    }
  } else if (xAlign === "left") {
    x3 -= Math.max(topLeft, bottomLeft) + caretSize;
  } else if (xAlign === "right") {
    x3 += Math.max(topRight, bottomRight) + caretSize;
  }
  return {
    x: _limitValue(x3, 0, chart.width - size2.width),
    y: _limitValue(y4, 0, chart.height - size2.height)
  };
}
function getAlignedX(tooltip, align, options) {
  const padding = toPadding(options.padding);
  return align === "center" ? tooltip.x + tooltip.width / 2 : align === "right" ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function getBeforeAfterBodyLines(callback2) {
  return pushOrConcat([], splitNewlines(callback2));
}
function createTooltipContext(parent, tooltip, tooltipItems) {
  return createContext(parent, {
    tooltip,
    tooltipItems,
    type: "tooltip"
  });
}
function overrideCallbacks(callbacks, context) {
  const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
  return override ? callbacks.override(override) : callbacks;
}
let Tooltip$1 = class Tooltip extends Element$1 {
  constructor(config) {
    super();
    this.opacity = 0;
    this._active = [];
    this._eventPosition = void 0;
    this._size = void 0;
    this._cachedAnimations = void 0;
    this._tooltipItems = [];
    this.$animations = void 0;
    this.$context = void 0;
    this.chart = config.chart || config._chart;
    this._chart = this.chart;
    this.options = config.options;
    this.dataPoints = void 0;
    this.title = void 0;
    this.beforeBody = void 0;
    this.body = void 0;
    this.afterBody = void 0;
    this.footer = void 0;
    this.xAlign = void 0;
    this.yAlign = void 0;
    this.x = void 0;
    this.y = void 0;
    this.height = void 0;
    this.width = void 0;
    this.caretX = void 0;
    this.caretY = void 0;
    this.labelColors = void 0;
    this.labelPointStyles = void 0;
    this.labelTextColors = void 0;
  }
  initialize(options) {
    this.options = options;
    this._cachedAnimations = void 0;
    this.$context = void 0;
  }
  _resolveAnimations() {
    const cached = this._cachedAnimations;
    if (cached) {
      return cached;
    }
    const chart = this.chart;
    const options = this.options.setContext(this.getContext());
    const opts = options.enabled && chart.options.animation && options.animations;
    const animations = new Animations(this.chart, opts);
    if (opts._cacheable) {
      this._cachedAnimations = Object.freeze(animations);
    }
    return animations;
  }
  getContext() {
    return this.$context || (this.$context = createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(context, options) {
    const { callbacks } = options;
    const beforeTitle = callbacks.beforeTitle.apply(this, [context]);
    const title = callbacks.title.apply(this, [context]);
    const afterTitle = callbacks.afterTitle.apply(this, [context]);
    let lines = [];
    lines = pushOrConcat(lines, splitNewlines(beforeTitle));
    lines = pushOrConcat(lines, splitNewlines(title));
    lines = pushOrConcat(lines, splitNewlines(afterTitle));
    return lines;
  }
  getBeforeBody(tooltipItems, options) {
    return getBeforeAfterBodyLines(options.callbacks.beforeBody.apply(this, [tooltipItems]));
  }
  getBody(tooltipItems, options) {
    const { callbacks } = options;
    const bodyItems = [];
    each(tooltipItems, (context) => {
      const bodyItem = {
        before: [],
        lines: [],
        after: []
      };
      const scoped = overrideCallbacks(callbacks, context);
      pushOrConcat(bodyItem.before, splitNewlines(scoped.beforeLabel.call(this, context)));
      pushOrConcat(bodyItem.lines, scoped.label.call(this, context));
      pushOrConcat(bodyItem.after, splitNewlines(scoped.afterLabel.call(this, context)));
      bodyItems.push(bodyItem);
    });
    return bodyItems;
  }
  getAfterBody(tooltipItems, options) {
    return getBeforeAfterBodyLines(options.callbacks.afterBody.apply(this, [tooltipItems]));
  }
  getFooter(tooltipItems, options) {
    const { callbacks } = options;
    const beforeFooter = callbacks.beforeFooter.apply(this, [tooltipItems]);
    const footer = callbacks.footer.apply(this, [tooltipItems]);
    const afterFooter = callbacks.afterFooter.apply(this, [tooltipItems]);
    let lines = [];
    lines = pushOrConcat(lines, splitNewlines(beforeFooter));
    lines = pushOrConcat(lines, splitNewlines(footer));
    lines = pushOrConcat(lines, splitNewlines(afterFooter));
    return lines;
  }
  _createItems(options) {
    const active = this._active;
    const data = this.chart.data;
    const labelColors = [];
    const labelPointStyles = [];
    const labelTextColors = [];
    let tooltipItems = [];
    let i3, len;
    for (i3 = 0, len = active.length; i3 < len; ++i3) {
      tooltipItems.push(createTooltipItem(this.chart, active[i3]));
    }
    if (options.filter) {
      tooltipItems = tooltipItems.filter((element, index2, array) => options.filter(element, index2, array, data));
    }
    if (options.itemSort) {
      tooltipItems = tooltipItems.sort((a4, b3) => options.itemSort(a4, b3, data));
    }
    each(tooltipItems, (context) => {
      const scoped = overrideCallbacks(options.callbacks, context);
      labelColors.push(scoped.labelColor.call(this, context));
      labelPointStyles.push(scoped.labelPointStyle.call(this, context));
      labelTextColors.push(scoped.labelTextColor.call(this, context));
    });
    this.labelColors = labelColors;
    this.labelPointStyles = labelPointStyles;
    this.labelTextColors = labelTextColors;
    this.dataPoints = tooltipItems;
    return tooltipItems;
  }
  update(changed, replay) {
    const options = this.options.setContext(this.getContext());
    const active = this._active;
    let properties;
    let tooltipItems = [];
    if (!active.length) {
      if (this.opacity !== 0) {
        properties = {
          opacity: 0
        };
      }
    } else {
      const position2 = positioners[options.position].call(this, active, this._eventPosition);
      tooltipItems = this._createItems(options);
      this.title = this.getTitle(tooltipItems, options);
      this.beforeBody = this.getBeforeBody(tooltipItems, options);
      this.body = this.getBody(tooltipItems, options);
      this.afterBody = this.getAfterBody(tooltipItems, options);
      this.footer = this.getFooter(tooltipItems, options);
      const size2 = this._size = getTooltipSize(this, options);
      const positionAndSize = Object.assign({}, position2, size2);
      const alignment = determineAlignment(this.chart, options, positionAndSize);
      const backgroundPoint = getBackgroundPoint(options, positionAndSize, alignment, this.chart);
      this.xAlign = alignment.xAlign;
      this.yAlign = alignment.yAlign;
      properties = {
        opacity: 1,
        x: backgroundPoint.x,
        y: backgroundPoint.y,
        width: size2.width,
        height: size2.height,
        caretX: position2.x,
        caretY: position2.y
      };
    }
    this._tooltipItems = tooltipItems;
    this.$context = void 0;
    if (properties) {
      this._resolveAnimations().update(this, properties);
    }
    if (changed && options.external) {
      options.external.call(this, { chart: this.chart, tooltip: this, replay });
    }
  }
  drawCaret(tooltipPoint, ctx, size2, options) {
    const caretPosition = this.getCaretPosition(tooltipPoint, size2, options);
    ctx.lineTo(caretPosition.x1, caretPosition.y1);
    ctx.lineTo(caretPosition.x2, caretPosition.y2);
    ctx.lineTo(caretPosition.x3, caretPosition.y3);
  }
  getCaretPosition(tooltipPoint, size2, options) {
    const { xAlign, yAlign } = this;
    const { caretSize, cornerRadius } = options;
    const { topLeft, topRight, bottomLeft, bottomRight } = toTRBLCorners(cornerRadius);
    const { x: ptX, y: ptY } = tooltipPoint;
    const { width, height: height2 } = size2;
    let x1, x22, x3, y1, y23, y32;
    if (yAlign === "center") {
      y23 = ptY + height2 / 2;
      if (xAlign === "left") {
        x1 = ptX;
        x22 = x1 - caretSize;
        y1 = y23 + caretSize;
        y32 = y23 - caretSize;
      } else {
        x1 = ptX + width;
        x22 = x1 + caretSize;
        y1 = y23 - caretSize;
        y32 = y23 + caretSize;
      }
      x3 = x1;
    } else {
      if (xAlign === "left") {
        x22 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
      } else if (xAlign === "right") {
        x22 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
      } else {
        x22 = this.caretX;
      }
      if (yAlign === "top") {
        y1 = ptY;
        y23 = y1 - caretSize;
        x1 = x22 - caretSize;
        x3 = x22 + caretSize;
      } else {
        y1 = ptY + height2;
        y23 = y1 + caretSize;
        x1 = x22 + caretSize;
        x3 = x22 - caretSize;
      }
      y32 = y1;
    }
    return { x1, x2: x22, x3, y1, y2: y23, y3: y32 };
  }
  drawTitle(pt2, ctx, options) {
    const title = this.title;
    const length = title.length;
    let titleFont, titleSpacing, i3;
    if (length) {
      const rtlHelper = getRtlAdapter(options.rtl, this.x, this.width);
      pt2.x = getAlignedX(this, options.titleAlign, options);
      ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
      ctx.textBaseline = "middle";
      titleFont = toFont(options.titleFont);
      titleSpacing = options.titleSpacing;
      ctx.fillStyle = options.titleColor;
      ctx.font = titleFont.string;
      for (i3 = 0; i3 < length; ++i3) {
        ctx.fillText(title[i3], rtlHelper.x(pt2.x), pt2.y + titleFont.lineHeight / 2);
        pt2.y += titleFont.lineHeight + titleSpacing;
        if (i3 + 1 === length) {
          pt2.y += options.titleMarginBottom - titleSpacing;
        }
      }
    }
  }
  _drawColorBox(ctx, pt2, i3, rtlHelper, options) {
    const labelColors = this.labelColors[i3];
    const labelPointStyle = this.labelPointStyles[i3];
    const { boxHeight, boxWidth, boxPadding } = options;
    const bodyFont = toFont(options.bodyFont);
    const colorX = getAlignedX(this, "left", options);
    const rtlColorX = rtlHelper.x(colorX);
    const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
    const colorY = pt2.y + yOffSet;
    if (options.usePointStyle) {
      const drawOptions = {
        radius: Math.min(boxWidth, boxHeight) / 2,
        pointStyle: labelPointStyle.pointStyle,
        rotation: labelPointStyle.rotation,
        borderWidth: 1
      };
      const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
      const centerY = colorY + boxHeight / 2;
      ctx.strokeStyle = options.multiKeyBackground;
      ctx.fillStyle = options.multiKeyBackground;
      drawPoint(ctx, drawOptions, centerX, centerY);
      ctx.strokeStyle = labelColors.borderColor;
      ctx.fillStyle = labelColors.backgroundColor;
      drawPoint(ctx, drawOptions, centerX, centerY);
    } else {
      ctx.lineWidth = isObject$3(labelColors.borderWidth) ? Math.max(...Object.values(labelColors.borderWidth)) : labelColors.borderWidth || 1;
      ctx.strokeStyle = labelColors.borderColor;
      ctx.setLineDash(labelColors.borderDash || []);
      ctx.lineDashOffset = labelColors.borderDashOffset || 0;
      const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth - boxPadding);
      const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - boxPadding - 2);
      const borderRadius = toTRBLCorners(labelColors.borderRadius);
      if (Object.values(borderRadius).some((v) => v !== 0)) {
        ctx.beginPath();
        ctx.fillStyle = options.multiKeyBackground;
        addRoundedRectPath(ctx, {
          x: outerX,
          y: colorY,
          w: boxWidth,
          h: boxHeight,
          radius: borderRadius
        });
        ctx.fill();
        ctx.stroke();
        ctx.fillStyle = labelColors.backgroundColor;
        ctx.beginPath();
        addRoundedRectPath(ctx, {
          x: innerX,
          y: colorY + 1,
          w: boxWidth - 2,
          h: boxHeight - 2,
          radius: borderRadius
        });
        ctx.fill();
      } else {
        ctx.fillStyle = options.multiKeyBackground;
        ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
        ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
        ctx.fillStyle = labelColors.backgroundColor;
        ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
      }
    }
    ctx.fillStyle = this.labelTextColors[i3];
  }
  drawBody(pt2, ctx, options) {
    const { body } = this;
    const { bodySpacing, bodyAlign, displayColors, boxHeight, boxWidth, boxPadding } = options;
    const bodyFont = toFont(options.bodyFont);
    let bodyLineHeight = bodyFont.lineHeight;
    let xLinePadding = 0;
    const rtlHelper = getRtlAdapter(options.rtl, this.x, this.width);
    const fillLineOfText = function(line) {
      ctx.fillText(line, rtlHelper.x(pt2.x + xLinePadding), pt2.y + bodyLineHeight / 2);
      pt2.y += bodyLineHeight + bodySpacing;
    };
    const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
    let bodyItem, textColor, lines, i3, j, ilen, jlen;
    ctx.textAlign = bodyAlign;
    ctx.textBaseline = "middle";
    ctx.font = bodyFont.string;
    pt2.x = getAlignedX(this, bodyAlignForCalculation, options);
    ctx.fillStyle = options.bodyColor;
    each(this.beforeBody, fillLineOfText);
    xLinePadding = displayColors && bodyAlignForCalculation !== "right" ? bodyAlign === "center" ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
    for (i3 = 0, ilen = body.length; i3 < ilen; ++i3) {
      bodyItem = body[i3];
      textColor = this.labelTextColors[i3];
      ctx.fillStyle = textColor;
      each(bodyItem.before, fillLineOfText);
      lines = bodyItem.lines;
      if (displayColors && lines.length) {
        this._drawColorBox(ctx, pt2, i3, rtlHelper, options);
        bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
      }
      for (j = 0, jlen = lines.length; j < jlen; ++j) {
        fillLineOfText(lines[j]);
        bodyLineHeight = bodyFont.lineHeight;
      }
      each(bodyItem.after, fillLineOfText);
    }
    xLinePadding = 0;
    bodyLineHeight = bodyFont.lineHeight;
    each(this.afterBody, fillLineOfText);
    pt2.y -= bodySpacing;
  }
  drawFooter(pt2, ctx, options) {
    const footer = this.footer;
    const length = footer.length;
    let footerFont, i3;
    if (length) {
      const rtlHelper = getRtlAdapter(options.rtl, this.x, this.width);
      pt2.x = getAlignedX(this, options.footerAlign, options);
      pt2.y += options.footerMarginTop;
      ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
      ctx.textBaseline = "middle";
      footerFont = toFont(options.footerFont);
      ctx.fillStyle = options.footerColor;
      ctx.font = footerFont.string;
      for (i3 = 0; i3 < length; ++i3) {
        ctx.fillText(footer[i3], rtlHelper.x(pt2.x), pt2.y + footerFont.lineHeight / 2);
        pt2.y += footerFont.lineHeight + options.footerSpacing;
      }
    }
  }
  drawBackground(pt2, ctx, tooltipSize, options) {
    const { xAlign, yAlign } = this;
    const { x: x3, y: y4 } = pt2;
    const { width, height: height2 } = tooltipSize;
    const { topLeft, topRight, bottomLeft, bottomRight } = toTRBLCorners(options.cornerRadius);
    ctx.fillStyle = options.backgroundColor;
    ctx.strokeStyle = options.borderColor;
    ctx.lineWidth = options.borderWidth;
    ctx.beginPath();
    ctx.moveTo(x3 + topLeft, y4);
    if (yAlign === "top") {
      this.drawCaret(pt2, ctx, tooltipSize, options);
    }
    ctx.lineTo(x3 + width - topRight, y4);
    ctx.quadraticCurveTo(x3 + width, y4, x3 + width, y4 + topRight);
    if (yAlign === "center" && xAlign === "right") {
      this.drawCaret(pt2, ctx, tooltipSize, options);
    }
    ctx.lineTo(x3 + width, y4 + height2 - bottomRight);
    ctx.quadraticCurveTo(x3 + width, y4 + height2, x3 + width - bottomRight, y4 + height2);
    if (yAlign === "bottom") {
      this.drawCaret(pt2, ctx, tooltipSize, options);
    }
    ctx.lineTo(x3 + bottomLeft, y4 + height2);
    ctx.quadraticCurveTo(x3, y4 + height2, x3, y4 + height2 - bottomLeft);
    if (yAlign === "center" && xAlign === "left") {
      this.drawCaret(pt2, ctx, tooltipSize, options);
    }
    ctx.lineTo(x3, y4 + topLeft);
    ctx.quadraticCurveTo(x3, y4, x3 + topLeft, y4);
    ctx.closePath();
    ctx.fill();
    if (options.borderWidth > 0) {
      ctx.stroke();
    }
  }
  _updateAnimationTarget(options) {
    const chart = this.chart;
    const anims = this.$animations;
    const animX = anims && anims.x;
    const animY = anims && anims.y;
    if (animX || animY) {
      const position2 = positioners[options.position].call(this, this._active, this._eventPosition);
      if (!position2) {
        return;
      }
      const size2 = this._size = getTooltipSize(this, options);
      const positionAndSize = Object.assign({}, position2, this._size);
      const alignment = determineAlignment(chart, options, positionAndSize);
      const point = getBackgroundPoint(options, positionAndSize, alignment, chart);
      if (animX._to !== point.x || animY._to !== point.y) {
        this.xAlign = alignment.xAlign;
        this.yAlign = alignment.yAlign;
        this.width = size2.width;
        this.height = size2.height;
        this.caretX = position2.x;
        this.caretY = position2.y;
        this._resolveAnimations().update(this, point);
      }
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(ctx) {
    const options = this.options.setContext(this.getContext());
    let opacity = this.opacity;
    if (!opacity) {
      return;
    }
    this._updateAnimationTarget(options);
    const tooltipSize = {
      width: this.width,
      height: this.height
    };
    const pt2 = {
      x: this.x,
      y: this.y
    };
    opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
    const padding = toPadding(options.padding);
    const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    if (options.enabled && hasTooltipContent) {
      ctx.save();
      ctx.globalAlpha = opacity;
      this.drawBackground(pt2, ctx, tooltipSize, options);
      overrideTextDirection(ctx, options.textDirection);
      pt2.y += padding.top;
      this.drawTitle(pt2, ctx, options);
      this.drawBody(pt2, ctx, options);
      this.drawFooter(pt2, ctx, options);
      restoreTextDirection(ctx, options.textDirection);
      ctx.restore();
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(activeElements, eventPosition) {
    const lastActive = this._active;
    const active = activeElements.map(({ datasetIndex, index: index2 }) => {
      const meta = this.chart.getDatasetMeta(datasetIndex);
      if (!meta) {
        throw new Error("Cannot find a dataset at index " + datasetIndex);
      }
      return {
        datasetIndex,
        element: meta.data[index2],
        index: index2
      };
    });
    const changed = !_elementsEqual(lastActive, active);
    const positionChanged = this._positionChanged(active, eventPosition);
    if (changed || positionChanged) {
      this._active = active;
      this._eventPosition = eventPosition;
      this._ignoreReplayEvents = true;
      this.update(true);
    }
  }
  handleEvent(e3, replay, inChartArea = true) {
    if (replay && this._ignoreReplayEvents) {
      return false;
    }
    this._ignoreReplayEvents = false;
    const options = this.options;
    const lastActive = this._active || [];
    const active = this._getActiveElements(e3, lastActive, replay, inChartArea);
    const positionChanged = this._positionChanged(active, e3);
    const changed = replay || !_elementsEqual(active, lastActive) || positionChanged;
    if (changed) {
      this._active = active;
      if (options.enabled || options.external) {
        this._eventPosition = {
          x: e3.x,
          y: e3.y
        };
        this.update(true, replay);
      }
    }
    return changed;
  }
  _getActiveElements(e3, lastActive, replay, inChartArea) {
    const options = this.options;
    if (e3.type === "mouseout") {
      return [];
    }
    if (!inChartArea) {
      return lastActive;
    }
    const active = this.chart.getElementsAtEventForMode(e3, options.mode, options, replay);
    if (options.reverse) {
      active.reverse();
    }
    return active;
  }
  _positionChanged(active, e3) {
    const { caretX, caretY, options } = this;
    const position2 = positioners[options.position].call(this, active, e3);
    return position2 !== false && (caretX !== position2.x || caretY !== position2.y);
  }
};
Tooltip$1.positioners = positioners;
var plugin_tooltip = {
  id: "tooltip",
  _element: Tooltip$1,
  positioners,
  afterInit(chart, _args, options) {
    if (options) {
      chart.tooltip = new Tooltip$1({ chart, options });
    }
  },
  beforeUpdate(chart, _args, options) {
    if (chart.tooltip) {
      chart.tooltip.initialize(options);
    }
  },
  reset(chart, _args, options) {
    if (chart.tooltip) {
      chart.tooltip.initialize(options);
    }
  },
  afterDraw(chart) {
    const tooltip = chart.tooltip;
    if (tooltip && tooltip._willRender()) {
      const args = {
        tooltip
      };
      if (chart.notifyPlugins("beforeTooltipDraw", args) === false) {
        return;
      }
      tooltip.draw(chart.ctx);
      chart.notifyPlugins("afterTooltipDraw", args);
    }
  },
  afterEvent(chart, args) {
    if (chart.tooltip) {
      const useFinalPosition = args.replay;
      if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) {
        args.changed = true;
      }
    }
  },
  defaults: {
    enabled: true,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (ctx, opts) => opts.bodyFont.size,
    boxWidth: (ctx, opts) => opts.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: true,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: ["x", "y", "width", "height", "caretX", "caretY"]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: {
      beforeTitle: noop$2,
      title(tooltipItems) {
        if (tooltipItems.length > 0) {
          const item = tooltipItems[0];
          const labels = item.chart.data.labels;
          const labelCount = labels ? labels.length : 0;
          if (this && this.options && this.options.mode === "dataset") {
            return item.dataset.label || "";
          } else if (item.label) {
            return item.label;
          } else if (labelCount > 0 && item.dataIndex < labelCount) {
            return labels[item.dataIndex];
          }
        }
        return "";
      },
      afterTitle: noop$2,
      beforeBody: noop$2,
      beforeLabel: noop$2,
      label(tooltipItem) {
        if (this && this.options && this.options.mode === "dataset") {
          return tooltipItem.label + ": " + tooltipItem.formattedValue || tooltipItem.formattedValue;
        }
        let label = tooltipItem.dataset.label || "";
        if (label) {
          label += ": ";
        }
        const value2 = tooltipItem.formattedValue;
        if (!isNullOrUndef(value2)) {
          label += value2;
        }
        return label;
      },
      labelColor(tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
          borderColor: options.borderColor,
          backgroundColor: options.backgroundColor,
          borderWidth: options.borderWidth,
          borderDash: options.borderDash,
          borderDashOffset: options.borderDashOffset,
          borderRadius: 0
        };
      },
      labelTextColor() {
        return this.options.bodyColor;
      },
      labelPointStyle(tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
          pointStyle: options.pointStyle,
          rotation: options.rotation
        };
      },
      afterLabel: noop$2,
      afterBody: noop$2,
      beforeFooter: noop$2,
      footer: noop$2,
      afterFooter: noop$2
    }
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (name2) => name2 !== "filter" && name2 !== "itemSort" && name2 !== "external",
    _indexable: false,
    callbacks: {
      _scriptable: false,
      _indexable: false
    },
    animation: {
      _fallback: false
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: ["interaction"]
};
const addIfString = (labels, raw, index2, addedLabels) => {
  if (typeof raw === "string") {
    index2 = labels.push(raw) - 1;
    addedLabels.unshift({ index: index2, label: raw });
  } else if (isNaN(raw)) {
    index2 = null;
  }
  return index2;
};
function findOrAddLabel(labels, raw, index2, addedLabels) {
  const first = labels.indexOf(raw);
  if (first === -1) {
    return addIfString(labels, raw, index2, addedLabels);
  }
  const last2 = labels.lastIndexOf(raw);
  return first !== last2 ? index2 : first;
}
const validIndex = (index2, max2) => index2 === null ? null : _limitValue(Math.round(index2), 0, max2);
class CategoryScale extends Scale {
  constructor(cfg) {
    super(cfg);
    this._startValue = void 0;
    this._valueRange = 0;
    this._addedLabels = [];
  }
  init(scaleOptions) {
    const added = this._addedLabels;
    if (added.length) {
      const labels = this.getLabels();
      for (const { index: index2, label } of added) {
        if (labels[index2] === label) {
          labels.splice(index2, 1);
        }
      }
      this._addedLabels = [];
    }
    super.init(scaleOptions);
  }
  parse(raw, index2) {
    if (isNullOrUndef(raw)) {
      return null;
    }
    const labels = this.getLabels();
    index2 = isFinite(index2) && labels[index2] === raw ? index2 : findOrAddLabel(labels, raw, valueOrDefault(index2, raw), this._addedLabels);
    return validIndex(index2, labels.length - 1);
  }
  determineDataLimits() {
    const { minDefined, maxDefined } = this.getUserBounds();
    let { min: min2, max: max2 } = this.getMinMax(true);
    if (this.options.bounds === "ticks") {
      if (!minDefined) {
        min2 = 0;
      }
      if (!maxDefined) {
        max2 = this.getLabels().length - 1;
      }
    }
    this.min = min2;
    this.max = max2;
  }
  buildTicks() {
    const min2 = this.min;
    const max2 = this.max;
    const offset2 = this.options.offset;
    const ticks = [];
    let labels = this.getLabels();
    labels = min2 === 0 && max2 === labels.length - 1 ? labels : labels.slice(min2, max2 + 1);
    this._valueRange = Math.max(labels.length - (offset2 ? 0 : 1), 1);
    this._startValue = this.min - (offset2 ? 0.5 : 0);
    for (let value2 = min2; value2 <= max2; value2++) {
      ticks.push({ value: value2 });
    }
    return ticks;
  }
  getLabelForValue(value2) {
    const labels = this.getLabels();
    if (value2 >= 0 && value2 < labels.length) {
      return labels[value2];
    }
    return value2;
  }
  configure() {
    super.configure();
    if (!this.isHorizontal()) {
      this._reversePixels = !this._reversePixels;
    }
  }
  getPixelForValue(value2) {
    if (typeof value2 !== "number") {
      value2 = this.parse(value2);
    }
    return value2 === null ? NaN : this.getPixelForDecimal((value2 - this._startValue) / this._valueRange);
  }
  getPixelForTick(index2) {
    const ticks = this.ticks;
    if (index2 < 0 || index2 > ticks.length - 1) {
      return null;
    }
    return this.getPixelForValue(ticks[index2].value);
  }
  getValueForPixel(pixel) {
    return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
CategoryScale.id = "category";
CategoryScale.defaults = {
  ticks: {
    callback: CategoryScale.prototype.getLabelForValue
  }
};
function generateTicks$1(generationOptions, dataRange) {
  const ticks = [];
  const MIN_SPACING2 = 1e-14;
  const { bounds, step, min: min2, max: max2, precision, count, maxTicks, maxDigits, includeBounds } = generationOptions;
  const unit = step || 1;
  const maxSpaces = maxTicks - 1;
  const { min: rmin, max: rmax } = dataRange;
  const minDefined = !isNullOrUndef(min2);
  const maxDefined = !isNullOrUndef(max2);
  const countDefined = !isNullOrUndef(count);
  const minSpacing = (rmax - rmin) / (maxDigits + 1);
  let spacing = niceNum((rmax - rmin) / maxSpaces / unit) * unit;
  let factor, niceMin, niceMax, numSpaces;
  if (spacing < MIN_SPACING2 && !minDefined && !maxDefined) {
    return [{ value: rmin }, { value: rmax }];
  }
  numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
  if (numSpaces > maxSpaces) {
    spacing = niceNum(numSpaces * spacing / maxSpaces / unit) * unit;
  }
  if (!isNullOrUndef(precision)) {
    factor = Math.pow(10, precision);
    spacing = Math.ceil(spacing * factor) / factor;
  }
  if (bounds === "ticks") {
    niceMin = Math.floor(rmin / spacing) * spacing;
    niceMax = Math.ceil(rmax / spacing) * spacing;
  } else {
    niceMin = rmin;
    niceMax = rmax;
  }
  if (minDefined && maxDefined && step && almostWhole((max2 - min2) / step, spacing / 1e3)) {
    numSpaces = Math.round(Math.min((max2 - min2) / spacing, maxTicks));
    spacing = (max2 - min2) / numSpaces;
    niceMin = min2;
    niceMax = max2;
  } else if (countDefined) {
    niceMin = minDefined ? min2 : niceMin;
    niceMax = maxDefined ? max2 : niceMax;
    numSpaces = count - 1;
    spacing = (niceMax - niceMin) / numSpaces;
  } else {
    numSpaces = (niceMax - niceMin) / spacing;
    if (almostEquals(numSpaces, Math.round(numSpaces), spacing / 1e3)) {
      numSpaces = Math.round(numSpaces);
    } else {
      numSpaces = Math.ceil(numSpaces);
    }
  }
  const decimalPlaces = Math.max(
    _decimalPlaces(spacing),
    _decimalPlaces(niceMin)
  );
  factor = Math.pow(10, isNullOrUndef(precision) ? decimalPlaces : precision);
  niceMin = Math.round(niceMin * factor) / factor;
  niceMax = Math.round(niceMax * factor) / factor;
  let j = 0;
  if (minDefined) {
    if (includeBounds && niceMin !== min2) {
      ticks.push({ value: min2 });
      if (niceMin < min2) {
        j++;
      }
      if (almostEquals(Math.round((niceMin + j * spacing) * factor) / factor, min2, relativeLabelSize(min2, minSpacing, generationOptions))) {
        j++;
      }
    } else if (niceMin < min2) {
      j++;
    }
  }
  for (; j < numSpaces; ++j) {
    ticks.push({ value: Math.round((niceMin + j * spacing) * factor) / factor });
  }
  if (maxDefined && includeBounds && niceMax !== max2) {
    if (ticks.length && almostEquals(ticks[ticks.length - 1].value, max2, relativeLabelSize(max2, minSpacing, generationOptions))) {
      ticks[ticks.length - 1].value = max2;
    } else {
      ticks.push({ value: max2 });
    }
  } else if (!maxDefined || niceMax === max2) {
    ticks.push({ value: niceMax });
  }
  return ticks;
}
function relativeLabelSize(value2, minSpacing, { horizontal, minRotation }) {
  const rad = toRadians(minRotation);
  const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 1e-3;
  const length = 0.75 * minSpacing * ("" + value2).length;
  return Math.min(minSpacing / ratio, length);
}
class LinearScaleBase extends Scale {
  constructor(cfg) {
    super(cfg);
    this.start = void 0;
    this.end = void 0;
    this._startValue = void 0;
    this._endValue = void 0;
    this._valueRange = 0;
  }
  parse(raw, index2) {
    if (isNullOrUndef(raw)) {
      return null;
    }
    if ((typeof raw === "number" || raw instanceof Number) && !isFinite(+raw)) {
      return null;
    }
    return +raw;
  }
  handleTickRangeOptions() {
    const { beginAtZero } = this.options;
    const { minDefined, maxDefined } = this.getUserBounds();
    let { min: min2, max: max2 } = this;
    const setMin = (v) => min2 = minDefined ? min2 : v;
    const setMax = (v) => max2 = maxDefined ? max2 : v;
    if (beginAtZero) {
      const minSign = sign(min2);
      const maxSign = sign(max2);
      if (minSign < 0 && maxSign < 0) {
        setMax(0);
      } else if (minSign > 0 && maxSign > 0) {
        setMin(0);
      }
    }
    if (min2 === max2) {
      let offset2 = 1;
      if (max2 >= Number.MAX_SAFE_INTEGER || min2 <= Number.MIN_SAFE_INTEGER) {
        offset2 = Math.abs(max2 * 0.05);
      }
      setMax(max2 + offset2);
      if (!beginAtZero) {
        setMin(min2 - offset2);
      }
    }
    this.min = min2;
    this.max = max2;
  }
  getTickLimit() {
    const tickOpts = this.options.ticks;
    let { maxTicksLimit, stepSize } = tickOpts;
    let maxTicks;
    if (stepSize) {
      maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
      if (maxTicks > 1e3) {
        console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
        maxTicks = 1e3;
      }
    } else {
      maxTicks = this.computeTickLimit();
      maxTicksLimit = maxTicksLimit || 11;
    }
    if (maxTicksLimit) {
      maxTicks = Math.min(maxTicksLimit, maxTicks);
    }
    return maxTicks;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const opts = this.options;
    const tickOpts = opts.ticks;
    let maxTicks = this.getTickLimit();
    maxTicks = Math.max(2, maxTicks);
    const numericGeneratorOptions = {
      maxTicks,
      bounds: opts.bounds,
      min: opts.min,
      max: opts.max,
      precision: tickOpts.precision,
      step: tickOpts.stepSize,
      count: tickOpts.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: tickOpts.minRotation || 0,
      includeBounds: tickOpts.includeBounds !== false
    };
    const dataRange = this._range || this;
    const ticks = generateTicks$1(numericGeneratorOptions, dataRange);
    if (opts.bounds === "ticks") {
      _setMinAndMaxByKey(ticks, this, "value");
    }
    if (opts.reverse) {
      ticks.reverse();
      this.start = this.max;
      this.end = this.min;
    } else {
      this.start = this.min;
      this.end = this.max;
    }
    return ticks;
  }
  configure() {
    const ticks = this.ticks;
    let start = this.min;
    let end = this.max;
    super.configure();
    if (this.options.offset && ticks.length) {
      const offset2 = (end - start) / Math.max(ticks.length - 1, 1) / 2;
      start -= offset2;
      end += offset2;
    }
    this._startValue = start;
    this._endValue = end;
    this._valueRange = end - start;
  }
  getLabelForValue(value2) {
    return formatNumber(value2, this.chart.options.locale, this.options.ticks.format);
  }
}
class LinearScale extends LinearScaleBase {
  determineDataLimits() {
    const { min: min2, max: max2 } = this.getMinMax(true);
    this.min = isNumberFinite(min2) ? min2 : 0;
    this.max = isNumberFinite(max2) ? max2 : 1;
    this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const horizontal = this.isHorizontal();
    const length = horizontal ? this.width : this.height;
    const minRotation = toRadians(this.options.ticks.minRotation);
    const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 1e-3;
    const tickFont = this._resolveTickFontOptions(0);
    return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
  }
  getPixelForValue(value2) {
    return value2 === null ? NaN : this.getPixelForDecimal((value2 - this._startValue) / this._valueRange);
  }
  getValueForPixel(pixel) {
    return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
  }
}
LinearScale.id = "linear";
LinearScale.defaults = {
  ticks: {
    callback: Ticks.formatters.numeric
  }
};
function isMajor(tickVal) {
  const remain = tickVal / Math.pow(10, Math.floor(log10(tickVal)));
  return remain === 1;
}
function generateTicks(generationOptions, dataRange) {
  const endExp = Math.floor(log10(dataRange.max));
  const endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
  const ticks = [];
  let tickVal = finiteOrDefault(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));
  let exp = Math.floor(log10(tickVal));
  let significand = Math.floor(tickVal / Math.pow(10, exp));
  let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
  do {
    ticks.push({ value: tickVal, major: isMajor(tickVal) });
    ++significand;
    if (significand === 10) {
      significand = 1;
      ++exp;
      precision = exp >= 0 ? 1 : precision;
    }
    tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
  } while (exp < endExp || exp === endExp && significand < endSignificand);
  const lastTick = finiteOrDefault(generationOptions.max, tickVal);
  ticks.push({ value: lastTick, major: isMajor(tickVal) });
  return ticks;
}
class LogarithmicScale extends Scale {
  constructor(cfg) {
    super(cfg);
    this.start = void 0;
    this.end = void 0;
    this._startValue = void 0;
    this._valueRange = 0;
  }
  parse(raw, index2) {
    const value2 = LinearScaleBase.prototype.parse.apply(this, [raw, index2]);
    if (value2 === 0) {
      this._zero = true;
      return void 0;
    }
    return isNumberFinite(value2) && value2 > 0 ? value2 : null;
  }
  determineDataLimits() {
    const { min: min2, max: max2 } = this.getMinMax(true);
    this.min = isNumberFinite(min2) ? Math.max(0, min2) : null;
    this.max = isNumberFinite(max2) ? Math.max(0, max2) : null;
    if (this.options.beginAtZero) {
      this._zero = true;
    }
    this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined, maxDefined } = this.getUserBounds();
    let min2 = this.min;
    let max2 = this.max;
    const setMin = (v) => min2 = minDefined ? min2 : v;
    const setMax = (v) => max2 = maxDefined ? max2 : v;
    const exp = (v, m4) => Math.pow(10, Math.floor(log10(v)) + m4);
    if (min2 === max2) {
      if (min2 <= 0) {
        setMin(1);
        setMax(10);
      } else {
        setMin(exp(min2, -1));
        setMax(exp(max2, 1));
      }
    }
    if (min2 <= 0) {
      setMin(exp(max2, -1));
    }
    if (max2 <= 0) {
      setMax(exp(min2, 1));
    }
    if (this._zero && this.min !== this._suggestedMin && min2 === exp(this.min, 0)) {
      setMin(exp(min2, -1));
    }
    this.min = min2;
    this.max = max2;
  }
  buildTicks() {
    const opts = this.options;
    const generationOptions = {
      min: this._userMin,
      max: this._userMax
    };
    const ticks = generateTicks(generationOptions, this);
    if (opts.bounds === "ticks") {
      _setMinAndMaxByKey(ticks, this, "value");
    }
    if (opts.reverse) {
      ticks.reverse();
      this.start = this.max;
      this.end = this.min;
    } else {
      this.start = this.min;
      this.end = this.max;
    }
    return ticks;
  }
  getLabelForValue(value2) {
    return value2 === void 0 ? "0" : formatNumber(value2, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const start = this.min;
    super.configure();
    this._startValue = log10(start);
    this._valueRange = log10(this.max) - log10(start);
  }
  getPixelForValue(value2) {
    if (value2 === void 0 || value2 === 0) {
      value2 = this.min;
    }
    if (value2 === null || isNaN(value2)) {
      return NaN;
    }
    return this.getPixelForDecimal(value2 === this.min ? 0 : (log10(value2) - this._startValue) / this._valueRange);
  }
  getValueForPixel(pixel) {
    const decimal2 = this.getDecimalForPixel(pixel);
    return Math.pow(10, this._startValue + decimal2 * this._valueRange);
  }
}
LogarithmicScale.id = "logarithmic";
LogarithmicScale.defaults = {
  ticks: {
    callback: Ticks.formatters.logarithmic,
    major: {
      enabled: true
    }
  }
};
function getTickBackdropHeight(opts) {
  const tickOpts = opts.ticks;
  if (tickOpts.display && opts.display) {
    const padding = toPadding(tickOpts.backdropPadding);
    return valueOrDefault(tickOpts.font && tickOpts.font.size, defaults$1.font.size) + padding.height;
  }
  return 0;
}
function measureLabelSize(ctx, font, label) {
  label = isArray(label) ? label : [label];
  return {
    w: _longestText(ctx, font.string, label),
    h: label.length * font.lineHeight
  };
}
function determineLimits(angle2, pos, size2, min2, max2) {
  if (angle2 === min2 || angle2 === max2) {
    return {
      start: pos - size2 / 2,
      end: pos + size2 / 2
    };
  } else if (angle2 < min2 || angle2 > max2) {
    return {
      start: pos - size2,
      end: pos
    };
  }
  return {
    start: pos,
    end: pos + size2
  };
}
function fitWithPointLabels(scale) {
  const orig = {
    l: scale.left + scale._padding.left,
    r: scale.right - scale._padding.right,
    t: scale.top + scale._padding.top,
    b: scale.bottom - scale._padding.bottom
  };
  const limits = Object.assign({}, orig);
  const labelSizes = [];
  const padding = [];
  const valueCount = scale._pointLabels.length;
  const pointLabelOpts = scale.options.pointLabels;
  const additionalAngle = pointLabelOpts.centerPointLabels ? PI / valueCount : 0;
  for (let i3 = 0; i3 < valueCount; i3++) {
    const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i3));
    padding[i3] = opts.padding;
    const pointPosition = scale.getPointPosition(i3, scale.drawingArea + padding[i3], additionalAngle);
    const plFont = toFont(opts.font);
    const textSize = measureLabelSize(scale.ctx, plFont, scale._pointLabels[i3]);
    labelSizes[i3] = textSize;
    const angleRadians = _normalizeAngle(scale.getIndexAngle(i3) + additionalAngle);
    const angle2 = Math.round(toDegrees(angleRadians));
    const hLimits = determineLimits(angle2, pointPosition.x, textSize.w, 0, 180);
    const vLimits = determineLimits(angle2, pointPosition.y, textSize.h, 90, 270);
    updateLimits(limits, orig, angleRadians, hLimits, vLimits);
  }
  scale.setCenterPoint(
    orig.l - limits.l,
    limits.r - orig.r,
    orig.t - limits.t,
    limits.b - orig.b
  );
  scale._pointLabelItems = buildPointLabelItems(scale, labelSizes, padding);
}
function updateLimits(limits, orig, angle2, hLimits, vLimits) {
  const sin = Math.abs(Math.sin(angle2));
  const cos = Math.abs(Math.cos(angle2));
  let x3 = 0;
  let y4 = 0;
  if (hLimits.start < orig.l) {
    x3 = (orig.l - hLimits.start) / sin;
    limits.l = Math.min(limits.l, orig.l - x3);
  } else if (hLimits.end > orig.r) {
    x3 = (hLimits.end - orig.r) / sin;
    limits.r = Math.max(limits.r, orig.r + x3);
  }
  if (vLimits.start < orig.t) {
    y4 = (orig.t - vLimits.start) / cos;
    limits.t = Math.min(limits.t, orig.t - y4);
  } else if (vLimits.end > orig.b) {
    y4 = (vLimits.end - orig.b) / cos;
    limits.b = Math.max(limits.b, orig.b + y4);
  }
}
function buildPointLabelItems(scale, labelSizes, padding) {
  const items = [];
  const valueCount = scale._pointLabels.length;
  const opts = scale.options;
  const extra = getTickBackdropHeight(opts) / 2;
  const outerDistance = scale.drawingArea;
  const additionalAngle = opts.pointLabels.centerPointLabels ? PI / valueCount : 0;
  for (let i3 = 0; i3 < valueCount; i3++) {
    const pointLabelPosition = scale.getPointPosition(i3, outerDistance + extra + padding[i3], additionalAngle);
    const angle2 = Math.round(toDegrees(_normalizeAngle(pointLabelPosition.angle + HALF_PI)));
    const size2 = labelSizes[i3];
    const y4 = yForAngle(pointLabelPosition.y, size2.h, angle2);
    const textAlign = getTextAlignForAngle(angle2);
    const left = leftForTextAlign(pointLabelPosition.x, size2.w, textAlign);
    items.push({
      x: pointLabelPosition.x,
      y: y4,
      textAlign,
      left,
      top: y4,
      right: left + size2.w,
      bottom: y4 + size2.h
    });
  }
  return items;
}
function getTextAlignForAngle(angle2) {
  if (angle2 === 0 || angle2 === 180) {
    return "center";
  } else if (angle2 < 180) {
    return "left";
  }
  return "right";
}
function leftForTextAlign(x3, w3, align) {
  if (align === "right") {
    x3 -= w3;
  } else if (align === "center") {
    x3 -= w3 / 2;
  }
  return x3;
}
function yForAngle(y4, h6, angle2) {
  if (angle2 === 90 || angle2 === 270) {
    y4 -= h6 / 2;
  } else if (angle2 > 270 || angle2 < 90) {
    y4 -= h6;
  }
  return y4;
}
function drawPointLabels(scale, labelCount) {
  const { ctx, options: { pointLabels } } = scale;
  for (let i3 = labelCount - 1; i3 >= 0; i3--) {
    const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i3));
    const plFont = toFont(optsAtIndex.font);
    const { x: x3, y: y4, textAlign, left, top, right, bottom } = scale._pointLabelItems[i3];
    const { backdropColor } = optsAtIndex;
    if (!isNullOrUndef(backdropColor)) {
      const borderRadius = toTRBLCorners(optsAtIndex.borderRadius);
      const padding = toPadding(optsAtIndex.backdropPadding);
      ctx.fillStyle = backdropColor;
      const backdropLeft = left - padding.left;
      const backdropTop = top - padding.top;
      const backdropWidth = right - left + padding.width;
      const backdropHeight = bottom - top + padding.height;
      if (Object.values(borderRadius).some((v) => v !== 0)) {
        ctx.beginPath();
        addRoundedRectPath(ctx, {
          x: backdropLeft,
          y: backdropTop,
          w: backdropWidth,
          h: backdropHeight,
          radius: borderRadius
        });
        ctx.fill();
      } else {
        ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
      }
    }
    renderText(
      ctx,
      scale._pointLabels[i3],
      x3,
      y4 + plFont.lineHeight / 2,
      plFont,
      {
        color: optsAtIndex.color,
        textAlign,
        textBaseline: "middle"
      }
    );
  }
}
function pathRadiusLine(scale, radius2, circular, labelCount) {
  const { ctx } = scale;
  if (circular) {
    ctx.arc(scale.xCenter, scale.yCenter, radius2, 0, TAU);
  } else {
    let pointPosition = scale.getPointPosition(0, radius2);
    ctx.moveTo(pointPosition.x, pointPosition.y);
    for (let i3 = 1; i3 < labelCount; i3++) {
      pointPosition = scale.getPointPosition(i3, radius2);
      ctx.lineTo(pointPosition.x, pointPosition.y);
    }
  }
}
function drawRadiusLine(scale, gridLineOpts, radius2, labelCount) {
  const ctx = scale.ctx;
  const circular = gridLineOpts.circular;
  const { color: color2, lineWidth } = gridLineOpts;
  if (!circular && !labelCount || !color2 || !lineWidth || radius2 < 0) {
    return;
  }
  ctx.save();
  ctx.strokeStyle = color2;
  ctx.lineWidth = lineWidth;
  ctx.setLineDash(gridLineOpts.borderDash);
  ctx.lineDashOffset = gridLineOpts.borderDashOffset;
  ctx.beginPath();
  pathRadiusLine(scale, radius2, circular, labelCount);
  ctx.closePath();
  ctx.stroke();
  ctx.restore();
}
function createPointLabelContext(parent, index2, label) {
  return createContext(parent, {
    label,
    index: index2,
    type: "pointLabel"
  });
}
class RadialLinearScale extends LinearScaleBase {
  constructor(cfg) {
    super(cfg);
    this.xCenter = void 0;
    this.yCenter = void 0;
    this.drawingArea = void 0;
    this._pointLabels = [];
    this._pointLabelItems = [];
  }
  setDimensions() {
    const padding = this._padding = toPadding(getTickBackdropHeight(this.options) / 2);
    const w3 = this.width = this.maxWidth - padding.width;
    const h6 = this.height = this.maxHeight - padding.height;
    this.xCenter = Math.floor(this.left + w3 / 2 + padding.left);
    this.yCenter = Math.floor(this.top + h6 / 2 + padding.top);
    this.drawingArea = Math.floor(Math.min(w3, h6) / 2);
  }
  determineDataLimits() {
    const { min: min2, max: max2 } = this.getMinMax(false);
    this.min = isNumberFinite(min2) && !isNaN(min2) ? min2 : 0;
    this.max = isNumberFinite(max2) && !isNaN(max2) ? max2 : 0;
    this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
  }
  generateTickLabels(ticks) {
    LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
    this._pointLabels = this.getLabels().map((value2, index2) => {
      const label = callback(this.options.pointLabels.callback, [value2, index2], this);
      return label || label === 0 ? label : "";
    }).filter((v, i3) => this.chart.getDataVisibility(i3));
  }
  fit() {
    const opts = this.options;
    if (opts.display && opts.pointLabels.display) {
      fitWithPointLabels(this);
    } else {
      this.setCenterPoint(0, 0, 0, 0);
    }
  }
  setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
    this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
    this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
    this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
  }
  getIndexAngle(index2) {
    const angleMultiplier = TAU / (this._pointLabels.length || 1);
    const startAngle = this.options.startAngle || 0;
    return _normalizeAngle(index2 * angleMultiplier + toRadians(startAngle));
  }
  getDistanceFromCenterForValue(value2) {
    if (isNullOrUndef(value2)) {
      return NaN;
    }
    const scalingFactor = this.drawingArea / (this.max - this.min);
    if (this.options.reverse) {
      return (this.max - value2) * scalingFactor;
    }
    return (value2 - this.min) * scalingFactor;
  }
  getValueForDistanceFromCenter(distance) {
    if (isNullOrUndef(distance)) {
      return NaN;
    }
    const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
  }
  getPointLabelContext(index2) {
    const pointLabels = this._pointLabels || [];
    if (index2 >= 0 && index2 < pointLabels.length) {
      const pointLabel = pointLabels[index2];
      return createPointLabelContext(this.getContext(), index2, pointLabel);
    }
  }
  getPointPosition(index2, distanceFromCenter, additionalAngle = 0) {
    const angle2 = this.getIndexAngle(index2) - HALF_PI + additionalAngle;
    return {
      x: Math.cos(angle2) * distanceFromCenter + this.xCenter,
      y: Math.sin(angle2) * distanceFromCenter + this.yCenter,
      angle: angle2
    };
  }
  getPointPositionForValue(index2, value2) {
    return this.getPointPosition(index2, this.getDistanceFromCenterForValue(value2));
  }
  getBasePosition(index2) {
    return this.getPointPositionForValue(index2 || 0, this.getBaseValue());
  }
  getPointLabelPosition(index2) {
    const { left, top, right, bottom } = this._pointLabelItems[index2];
    return {
      left,
      top,
      right,
      bottom
    };
  }
  drawBackground() {
    const { backgroundColor, grid: { circular } } = this.options;
    if (backgroundColor) {
      const ctx = this.ctx;
      ctx.save();
      ctx.beginPath();
      pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
      ctx.closePath();
      ctx.fillStyle = backgroundColor;
      ctx.fill();
      ctx.restore();
    }
  }
  drawGrid() {
    const ctx = this.ctx;
    const opts = this.options;
    const { angleLines, grid } = opts;
    const labelCount = this._pointLabels.length;
    let i3, offset2, position2;
    if (opts.pointLabels.display) {
      drawPointLabels(this, labelCount);
    }
    if (grid.display) {
      this.ticks.forEach((tick, index2) => {
        if (index2 !== 0) {
          offset2 = this.getDistanceFromCenterForValue(tick.value);
          const optsAtIndex = grid.setContext(this.getContext(index2 - 1));
          drawRadiusLine(this, optsAtIndex, offset2, labelCount);
        }
      });
    }
    if (angleLines.display) {
      ctx.save();
      for (i3 = labelCount - 1; i3 >= 0; i3--) {
        const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i3));
        const { color: color2, lineWidth } = optsAtIndex;
        if (!lineWidth || !color2) {
          continue;
        }
        ctx.lineWidth = lineWidth;
        ctx.strokeStyle = color2;
        ctx.setLineDash(optsAtIndex.borderDash);
        ctx.lineDashOffset = optsAtIndex.borderDashOffset;
        offset2 = this.getDistanceFromCenterForValue(opts.ticks.reverse ? this.min : this.max);
        position2 = this.getPointPosition(i3, offset2);
        ctx.beginPath();
        ctx.moveTo(this.xCenter, this.yCenter);
        ctx.lineTo(position2.x, position2.y);
        ctx.stroke();
      }
      ctx.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const ctx = this.ctx;
    const opts = this.options;
    const tickOpts = opts.ticks;
    if (!tickOpts.display) {
      return;
    }
    const startAngle = this.getIndexAngle(0);
    let offset2, width;
    ctx.save();
    ctx.translate(this.xCenter, this.yCenter);
    ctx.rotate(startAngle);
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    this.ticks.forEach((tick, index2) => {
      if (index2 === 0 && !opts.reverse) {
        return;
      }
      const optsAtIndex = tickOpts.setContext(this.getContext(index2));
      const tickFont = toFont(optsAtIndex.font);
      offset2 = this.getDistanceFromCenterForValue(this.ticks[index2].value);
      if (optsAtIndex.showLabelBackdrop) {
        ctx.font = tickFont.string;
        width = ctx.measureText(tick.label).width;
        ctx.fillStyle = optsAtIndex.backdropColor;
        const padding = toPadding(optsAtIndex.backdropPadding);
        ctx.fillRect(
          -width / 2 - padding.left,
          -offset2 - tickFont.size / 2 - padding.top,
          width + padding.width,
          tickFont.size + padding.height
        );
      }
      renderText(ctx, tick.label, 0, -offset2, tickFont, {
        color: optsAtIndex.color
      });
    });
    ctx.restore();
  }
  drawTitle() {
  }
}
RadialLinearScale.id = "radialLinear";
RadialLinearScale.defaults = {
  display: true,
  animate: true,
  position: "chartArea",
  angleLines: {
    display: true,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0
  },
  grid: {
    circular: false
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: true,
    callback: Ticks.formatters.numeric
  },
  pointLabels: {
    backdropColor: void 0,
    backdropPadding: 2,
    display: true,
    font: {
      size: 10
    },
    callback(label) {
      return label;
    },
    padding: 5,
    centerPointLabels: false
  }
};
RadialLinearScale.defaultRoutes = {
  "angleLines.color": "borderColor",
  "pointLabels.color": "color",
  "ticks.color": "color"
};
RadialLinearScale.descriptors = {
  angleLines: {
    _fallback: "grid"
  }
};
const INTERVALS = {
  millisecond: { common: true, size: 1, steps: 1e3 },
  second: { common: true, size: 1e3, steps: 60 },
  minute: { common: true, size: 6e4, steps: 60 },
  hour: { common: true, size: 36e5, steps: 24 },
  day: { common: true, size: 864e5, steps: 30 },
  week: { common: false, size: 6048e5, steps: 4 },
  month: { common: true, size: 2628e6, steps: 12 },
  quarter: { common: false, size: 7884e6, steps: 4 },
  year: { common: true, size: 3154e7 }
};
const UNITS = Object.keys(INTERVALS);
function sorter(a4, b3) {
  return a4 - b3;
}
function parse$2(scale, input) {
  if (isNullOrUndef(input)) {
    return null;
  }
  const adapter = scale._adapter;
  const { parser, round: round2, isoWeekday } = scale._parseOpts;
  let value2 = input;
  if (typeof parser === "function") {
    value2 = parser(value2);
  }
  if (!isNumberFinite(value2)) {
    value2 = typeof parser === "string" ? adapter.parse(value2, parser) : adapter.parse(value2);
  }
  if (value2 === null) {
    return null;
  }
  if (round2) {
    value2 = round2 === "week" && (isNumber$2(isoWeekday) || isoWeekday === true) ? adapter.startOf(value2, "isoWeek", isoWeekday) : adapter.startOf(value2, round2);
  }
  return +value2;
}
function determineUnitForAutoTicks(minUnit, min2, max2, capacity) {
  const ilen = UNITS.length;
  for (let i3 = UNITS.indexOf(minUnit); i3 < ilen - 1; ++i3) {
    const interval = INTERVALS[UNITS[i3]];
    const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
    if (interval.common && Math.ceil((max2 - min2) / (factor * interval.size)) <= capacity) {
      return UNITS[i3];
    }
  }
  return UNITS[ilen - 1];
}
function determineUnitForFormatting(scale, numTicks, minUnit, min2, max2) {
  for (let i3 = UNITS.length - 1; i3 >= UNITS.indexOf(minUnit); i3--) {
    const unit = UNITS[i3];
    if (INTERVALS[unit].common && scale._adapter.diff(max2, min2, unit) >= numTicks - 1) {
      return unit;
    }
  }
  return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}
function determineMajorUnit(unit) {
  for (let i3 = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i3 < ilen; ++i3) {
    if (INTERVALS[UNITS[i3]].common) {
      return UNITS[i3];
    }
  }
}
function addTick(ticks, time, timestamps) {
  if (!timestamps) {
    ticks[time] = true;
  } else if (timestamps.length) {
    const { lo: lo2, hi } = _lookup(timestamps, time);
    const timestamp = timestamps[lo2] >= time ? timestamps[lo2] : timestamps[hi];
    ticks[timestamp] = true;
  }
}
function setMajorTicks(scale, ticks, map2, majorUnit) {
  const adapter = scale._adapter;
  const first = +adapter.startOf(ticks[0].value, majorUnit);
  const last2 = ticks[ticks.length - 1].value;
  let major, index2;
  for (major = first; major <= last2; major = +adapter.add(major, 1, majorUnit)) {
    index2 = map2[major];
    if (index2 >= 0) {
      ticks[index2].major = true;
    }
  }
  return ticks;
}
function ticksFromTimestamps(scale, values, majorUnit) {
  const ticks = [];
  const map2 = {};
  const ilen = values.length;
  let i3, value2;
  for (i3 = 0; i3 < ilen; ++i3) {
    value2 = values[i3];
    map2[value2] = i3;
    ticks.push({
      value: value2,
      major: false
    });
  }
  return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map2, majorUnit);
}
class TimeScale extends Scale {
  constructor(props4) {
    super(props4);
    this._cache = {
      data: [],
      labels: [],
      all: []
    };
    this._unit = "day";
    this._majorUnit = void 0;
    this._offsets = {};
    this._normalized = false;
    this._parseOpts = void 0;
  }
  init(scaleOpts, opts) {
    const time = scaleOpts.time || (scaleOpts.time = {});
    const adapter = this._adapter = new adapters._date(scaleOpts.adapters.date);
    adapter.init(opts);
    mergeIf(time.displayFormats, adapter.formats());
    this._parseOpts = {
      parser: time.parser,
      round: time.round,
      isoWeekday: time.isoWeekday
    };
    super.init(scaleOpts);
    this._normalized = opts.normalized;
  }
  parse(raw, index2) {
    if (raw === void 0) {
      return null;
    }
    return parse$2(this, raw);
  }
  beforeLayout() {
    super.beforeLayout();
    this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const options = this.options;
    const adapter = this._adapter;
    const unit = options.time.unit || "day";
    let { min: min2, max: max2, minDefined, maxDefined } = this.getUserBounds();
    function _applyBounds(bounds) {
      if (!minDefined && !isNaN(bounds.min)) {
        min2 = Math.min(min2, bounds.min);
      }
      if (!maxDefined && !isNaN(bounds.max)) {
        max2 = Math.max(max2, bounds.max);
      }
    }
    if (!minDefined || !maxDefined) {
      _applyBounds(this._getLabelBounds());
      if (options.bounds !== "ticks" || options.ticks.source !== "labels") {
        _applyBounds(this.getMinMax(false));
      }
    }
    min2 = isNumberFinite(min2) && !isNaN(min2) ? min2 : +adapter.startOf(Date.now(), unit);
    max2 = isNumberFinite(max2) && !isNaN(max2) ? max2 : +adapter.endOf(Date.now(), unit) + 1;
    this.min = Math.min(min2, max2 - 1);
    this.max = Math.max(min2 + 1, max2);
  }
  _getLabelBounds() {
    const arr = this.getLabelTimestamps();
    let min2 = Number.POSITIVE_INFINITY;
    let max2 = Number.NEGATIVE_INFINITY;
    if (arr.length) {
      min2 = arr[0];
      max2 = arr[arr.length - 1];
    }
    return { min: min2, max: max2 };
  }
  buildTicks() {
    const options = this.options;
    const timeOpts = options.time;
    const tickOpts = options.ticks;
    const timestamps = tickOpts.source === "labels" ? this.getLabelTimestamps() : this._generate();
    if (options.bounds === "ticks" && timestamps.length) {
      this.min = this._userMin || timestamps[0];
      this.max = this._userMax || timestamps[timestamps.length - 1];
    }
    const min2 = this.min;
    const max2 = this.max;
    const ticks = _filterBetween(timestamps, min2, max2);
    this._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min2)) : determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
    this._majorUnit = !tickOpts.major.enabled || this._unit === "year" ? void 0 : determineMajorUnit(this._unit);
    this.initOffsets(timestamps);
    if (options.reverse) {
      ticks.reverse();
    }
    return ticksFromTimestamps(this, ticks, this._majorUnit);
  }
  afterAutoSkip() {
    if (this.options.offsetAfterAutoskip) {
      this.initOffsets(this.ticks.map((tick) => +tick.value));
    }
  }
  initOffsets(timestamps) {
    let start = 0;
    let end = 0;
    let first, last2;
    if (this.options.offset && timestamps.length) {
      first = this.getDecimalForValue(timestamps[0]);
      if (timestamps.length === 1) {
        start = 1 - first;
      } else {
        start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
      }
      last2 = this.getDecimalForValue(timestamps[timestamps.length - 1]);
      if (timestamps.length === 1) {
        end = last2;
      } else {
        end = (last2 - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
      }
    }
    const limit2 = timestamps.length < 3 ? 0.5 : 0.25;
    start = _limitValue(start, 0, limit2);
    end = _limitValue(end, 0, limit2);
    this._offsets = { start, end, factor: 1 / (start + 1 + end) };
  }
  _generate() {
    const adapter = this._adapter;
    const min2 = this.min;
    const max2 = this.max;
    const options = this.options;
    const timeOpts = options.time;
    const minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min2, max2, this._getLabelCapacity(min2));
    const stepSize = valueOrDefault(timeOpts.stepSize, 1);
    const weekday = minor === "week" ? timeOpts.isoWeekday : false;
    const hasWeekday = isNumber$2(weekday) || weekday === true;
    const ticks = {};
    let first = min2;
    let time, count;
    if (hasWeekday) {
      first = +adapter.startOf(first, "isoWeek", weekday);
    }
    first = +adapter.startOf(first, hasWeekday ? "day" : minor);
    if (adapter.diff(max2, min2, minor) > 1e5 * stepSize) {
      throw new Error(min2 + " and " + max2 + " are too far apart with stepSize of " + stepSize + " " + minor);
    }
    const timestamps = options.ticks.source === "data" && this.getDataTimestamps();
    for (time = first, count = 0; time < max2; time = +adapter.add(time, stepSize, minor), count++) {
      addTick(ticks, time, timestamps);
    }
    if (time === max2 || options.bounds === "ticks" || count === 1) {
      addTick(ticks, time, timestamps);
    }
    return Object.keys(ticks).sort((a4, b3) => a4 - b3).map((x3) => +x3);
  }
  getLabelForValue(value2) {
    const adapter = this._adapter;
    const timeOpts = this.options.time;
    if (timeOpts.tooltipFormat) {
      return adapter.format(value2, timeOpts.tooltipFormat);
    }
    return adapter.format(value2, timeOpts.displayFormats.datetime);
  }
  _tickFormatFunction(time, index2, ticks, format2) {
    const options = this.options;
    const formats = options.time.displayFormats;
    const unit = this._unit;
    const majorUnit = this._majorUnit;
    const minorFormat = unit && formats[unit];
    const majorFormat = majorUnit && formats[majorUnit];
    const tick = ticks[index2];
    const major = majorUnit && majorFormat && tick && tick.major;
    const label = this._adapter.format(time, format2 || (major ? majorFormat : minorFormat));
    const formatter2 = options.ticks.callback;
    return formatter2 ? callback(formatter2, [label, index2, ticks], this) : label;
  }
  generateTickLabels(ticks) {
    let i3, ilen, tick;
    for (i3 = 0, ilen = ticks.length; i3 < ilen; ++i3) {
      tick = ticks[i3];
      tick.label = this._tickFormatFunction(tick.value, i3, ticks);
    }
  }
  getDecimalForValue(value2) {
    return value2 === null ? NaN : (value2 - this.min) / (this.max - this.min);
  }
  getPixelForValue(value2) {
    const offsets = this._offsets;
    const pos = this.getDecimalForValue(value2);
    return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
  }
  getValueForPixel(pixel) {
    const offsets = this._offsets;
    const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
    return this.min + pos * (this.max - this.min);
  }
  _getLabelSize(label) {
    const ticksOpts = this.options.ticks;
    const tickLabelWidth = this.ctx.measureText(label).width;
    const angle2 = toRadians(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
    const cosRotation = Math.cos(angle2);
    const sinRotation = Math.sin(angle2);
    const tickFontSize = this._resolveTickFontOptions(0).size;
    return {
      w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
      h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
    };
  }
  _getLabelCapacity(exampleTime) {
    const timeOpts = this.options.time;
    const displayFormats = timeOpts.displayFormats;
    const format2 = displayFormats[timeOpts.unit] || displayFormats.millisecond;
    const exampleLabel = this._tickFormatFunction(exampleTime, 0, ticksFromTimestamps(this, [exampleTime], this._majorUnit), format2);
    const size2 = this._getLabelSize(exampleLabel);
    const capacity = Math.floor(this.isHorizontal() ? this.width / size2.w : this.height / size2.h) - 1;
    return capacity > 0 ? capacity : 1;
  }
  getDataTimestamps() {
    let timestamps = this._cache.data || [];
    let i3, ilen;
    if (timestamps.length) {
      return timestamps;
    }
    const metas = this.getMatchingVisibleMetas();
    if (this._normalized && metas.length) {
      return this._cache.data = metas[0].controller.getAllParsedValues(this);
    }
    for (i3 = 0, ilen = metas.length; i3 < ilen; ++i3) {
      timestamps = timestamps.concat(metas[i3].controller.getAllParsedValues(this));
    }
    return this._cache.data = this.normalize(timestamps);
  }
  getLabelTimestamps() {
    const timestamps = this._cache.labels || [];
    let i3, ilen;
    if (timestamps.length) {
      return timestamps;
    }
    const labels = this.getLabels();
    for (i3 = 0, ilen = labels.length; i3 < ilen; ++i3) {
      timestamps.push(parse$2(this, labels[i3]));
    }
    return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
  }
  normalize(values) {
    return _arrayUnique(values.sort(sorter));
  }
}
TimeScale.id = "time";
TimeScale.defaults = {
  bounds: "data",
  adapters: {},
  time: {
    parser: false,
    unit: false,
    round: false,
    isoWeekday: false,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    major: {
      enabled: false
    }
  }
};
function interpolate(table, val, reverse) {
  let lo2 = 0;
  let hi = table.length - 1;
  let prevSource, nextSource, prevTarget, nextTarget;
  if (reverse) {
    if (val >= table[lo2].pos && val <= table[hi].pos) {
      ({ lo: lo2, hi } = _lookupByKey(table, "pos", val));
    }
    ({ pos: prevSource, time: prevTarget } = table[lo2]);
    ({ pos: nextSource, time: nextTarget } = table[hi]);
  } else {
    if (val >= table[lo2].time && val <= table[hi].time) {
      ({ lo: lo2, hi } = _lookupByKey(table, "time", val));
    }
    ({ time: prevSource, pos: prevTarget } = table[lo2]);
    ({ time: nextSource, pos: nextTarget } = table[hi]);
  }
  const span = nextSource - prevSource;
  return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class TimeSeriesScale extends TimeScale {
  constructor(props4) {
    super(props4);
    this._table = [];
    this._minPos = void 0;
    this._tableRange = void 0;
  }
  initOffsets() {
    const timestamps = this._getTimestampsForTable();
    const table = this._table = this.buildLookupTable(timestamps);
    this._minPos = interpolate(table, this.min);
    this._tableRange = interpolate(table, this.max) - this._minPos;
    super.initOffsets(timestamps);
  }
  buildLookupTable(timestamps) {
    const { min: min2, max: max2 } = this;
    const items = [];
    const table = [];
    let i3, ilen, prev, curr, next;
    for (i3 = 0, ilen = timestamps.length; i3 < ilen; ++i3) {
      curr = timestamps[i3];
      if (curr >= min2 && curr <= max2) {
        items.push(curr);
      }
    }
    if (items.length < 2) {
      return [
        { time: min2, pos: 0 },
        { time: max2, pos: 1 }
      ];
    }
    for (i3 = 0, ilen = items.length; i3 < ilen; ++i3) {
      next = items[i3 + 1];
      prev = items[i3 - 1];
      curr = items[i3];
      if (Math.round((next + prev) / 2) !== curr) {
        table.push({ time: curr, pos: i3 / (ilen - 1) });
      }
    }
    return table;
  }
  _getTimestampsForTable() {
    let timestamps = this._cache.all || [];
    if (timestamps.length) {
      return timestamps;
    }
    const data = this.getDataTimestamps();
    const label = this.getLabelTimestamps();
    if (data.length && label.length) {
      timestamps = this.normalize(data.concat(label));
    } else {
      timestamps = data.length ? data : label;
    }
    timestamps = this._cache.all = timestamps;
    return timestamps;
  }
  getDecimalForValue(value2) {
    return (interpolate(this._table, value2) - this._minPos) / this._tableRange;
  }
  getValueForPixel(pixel) {
    const offsets = this._offsets;
    const decimal2 = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
    return interpolate(this._table, decimal2 * this._tableRange + this._minPos, true);
  }
}
TimeSeriesScale.id = "timeseries";
TimeSeriesScale.defaults = TimeScale.defaults;
function _typeof$1(o) {
  "@babel/helpers - typeof";
  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$1(o);
}
function toInteger$1(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}
function requiredArgs$1(required, args) {
  if (args.length < required) {
    throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
  }
}
function toDate$1(argument) {
  requiredArgs$1(1, arguments);
  var argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || _typeof$1(argument) === "object" && argStr === "[object Date]") {
    return new Date(argument.getTime());
  } else if (typeof argument === "number" || argStr === "[object Number]") {
    return new Date(argument);
  } else {
    if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      console.warn(new Error().stack);
    }
    return /* @__PURE__ */ new Date(NaN);
  }
}
function addDays$1(dirtyDate, dirtyAmount) {
  requiredArgs$1(2, arguments);
  var date = toDate$1(dirtyDate);
  var amount = toInteger$1(dirtyAmount);
  if (isNaN(amount)) {
    return /* @__PURE__ */ new Date(NaN);
  }
  if (!amount) {
    return date;
  }
  date.setDate(date.getDate() + amount);
  return date;
}
function addMonths$1(dirtyDate, dirtyAmount) {
  requiredArgs$1(2, arguments);
  var date = toDate$1(dirtyDate);
  var amount = toInteger$1(dirtyAmount);
  if (isNaN(amount)) {
    return /* @__PURE__ */ new Date(NaN);
  }
  if (!amount) {
    return date;
  }
  var dayOfMonth = date.getDate();
  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    return endOfDesiredMonth;
  } else {
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}
function addMilliseconds$1(dirtyDate, dirtyAmount) {
  requiredArgs$1(2, arguments);
  var timestamp = toDate$1(dirtyDate).getTime();
  var amount = toInteger$1(dirtyAmount);
  return new Date(timestamp + amount);
}
var MILLISECONDS_IN_HOUR$2 = 36e5;
function addHours(dirtyDate, dirtyAmount) {
  requiredArgs$1(2, arguments);
  var amount = toInteger$1(dirtyAmount);
  return addMilliseconds$1(dirtyDate, amount * MILLISECONDS_IN_HOUR$2);
}
var defaultOptions$1 = {};
function getDefaultOptions$1() {
  return defaultOptions$1;
}
function startOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs$1(1, arguments);
  var defaultOptions2 = getDefaultOptions$1();
  var weekStartsOn = toInteger$1((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date = toDate$1(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}
function getTimezoneOffsetInMilliseconds$1(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}
function startOfDay$1(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date = toDate$1(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}
var MILLISECONDS_IN_DAY$5 = 864e5;
function differenceInCalendarDays$1(dirtyDateLeft, dirtyDateRight) {
  requiredArgs$1(2, arguments);
  var startOfDayLeft = startOfDay$1(dirtyDateLeft);
  var startOfDayRight = startOfDay$1(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - getTimezoneOffsetInMilliseconds$1(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - getTimezoneOffsetInMilliseconds$1(startOfDayRight);
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY$5);
}
var MILLISECONDS_IN_MINUTE$2 = 6e4;
function addMinutes(dirtyDate, dirtyAmount) {
  requiredArgs$1(2, arguments);
  var amount = toInteger$1(dirtyAmount);
  return addMilliseconds$1(dirtyDate, amount * MILLISECONDS_IN_MINUTE$2);
}
function addQuarters(dirtyDate, dirtyAmount) {
  requiredArgs$1(2, arguments);
  var amount = toInteger$1(dirtyAmount);
  var months = amount * 3;
  return addMonths$1(dirtyDate, months);
}
function addSeconds(dirtyDate, dirtyAmount) {
  requiredArgs$1(2, arguments);
  var amount = toInteger$1(dirtyAmount);
  return addMilliseconds$1(dirtyDate, amount * 1e3);
}
function addWeeks(dirtyDate, dirtyAmount) {
  requiredArgs$1(2, arguments);
  var amount = toInteger$1(dirtyAmount);
  var days = amount * 7;
  return addDays$1(dirtyDate, days);
}
function addYears(dirtyDate, dirtyAmount) {
  requiredArgs$1(2, arguments);
  var amount = toInteger$1(dirtyAmount);
  return addMonths$1(dirtyDate, amount * 12);
}
function compareAsc$1(dirtyDateLeft, dirtyDateRight) {
  requiredArgs$1(2, arguments);
  var dateLeft = toDate$1(dirtyDateLeft);
  var dateRight = toDate$1(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
  } else {
    return diff;
  }
}
var millisecondsInMinute$1 = 6e4;
var millisecondsInHour$1 = 36e5;
var millisecondsInSecond$1 = 1e3;
function isDate$3(value2) {
  requiredArgs$1(1, arguments);
  return value2 instanceof Date || _typeof$1(value2) === "object" && Object.prototype.toString.call(value2) === "[object Date]";
}
function isValid$1(dirtyDate) {
  requiredArgs$1(1, arguments);
  if (!isDate$3(dirtyDate) && typeof dirtyDate !== "number") {
    return false;
  }
  var date = toDate$1(dirtyDate);
  return !isNaN(Number(date));
}
function differenceInCalendarMonths$1(dirtyDateLeft, dirtyDateRight) {
  requiredArgs$1(2, arguments);
  var dateLeft = toDate$1(dirtyDateLeft);
  var dateRight = toDate$1(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}
function differenceInCalendarYears$1(dirtyDateLeft, dirtyDateRight) {
  requiredArgs$1(2, arguments);
  var dateLeft = toDate$1(dirtyDateLeft);
  var dateRight = toDate$1(dirtyDateRight);
  return dateLeft.getFullYear() - dateRight.getFullYear();
}
function compareLocalAsc$1(dateLeft, dateRight) {
  var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
  } else {
    return diff;
  }
}
function differenceInDays$1(dirtyDateLeft, dirtyDateRight) {
  requiredArgs$1(2, arguments);
  var dateLeft = toDate$1(dirtyDateLeft);
  var dateRight = toDate$1(dirtyDateRight);
  var sign2 = compareLocalAsc$1(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarDays$1(dateLeft, dateRight));
  dateLeft.setDate(dateLeft.getDate() - sign2 * difference);
  var isLastDayNotFull = Number(compareLocalAsc$1(dateLeft, dateRight) === -sign2);
  var result = sign2 * (difference - isLastDayNotFull);
  return result === 0 ? 0 : result;
}
function differenceInMilliseconds$1(dateLeft, dateRight) {
  requiredArgs$1(2, arguments);
  return toDate$1(dateLeft).getTime() - toDate$1(dateRight).getTime();
}
var roundingMap$1 = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function trunc(value2) {
    return value2 < 0 ? Math.ceil(value2) : Math.floor(value2);
  }
  // Math.trunc is not supported by IE
};
var defaultRoundingMethod$1 = "trunc";
function getRoundingMethod$1(method) {
  return method ? roundingMap$1[method] : roundingMap$1[defaultRoundingMethod$1];
}
function differenceInHours$1(dateLeft, dateRight, options) {
  requiredArgs$1(2, arguments);
  var diff = differenceInMilliseconds$1(dateLeft, dateRight) / millisecondsInHour$1;
  return getRoundingMethod$1(void 0)(diff);
}
function differenceInMinutes$1(dateLeft, dateRight, options) {
  requiredArgs$1(2, arguments);
  var diff = differenceInMilliseconds$1(dateLeft, dateRight) / millisecondsInMinute$1;
  return getRoundingMethod$1(void 0)(diff);
}
function endOfDay$1(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date = toDate$1(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}
function endOfMonth$1(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date = toDate$1(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}
function isLastDayOfMonth$1(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date = toDate$1(dirtyDate);
  return endOfDay$1(date).getTime() === endOfMonth$1(date).getTime();
}
function differenceInMonths$1(dirtyDateLeft, dirtyDateRight) {
  requiredArgs$1(2, arguments);
  var dateLeft = toDate$1(dirtyDateLeft);
  var dateRight = toDate$1(dirtyDateRight);
  var sign2 = compareAsc$1(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarMonths$1(dateLeft, dateRight));
  var result;
  if (difference < 1) {
    result = 0;
  } else {
    if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) {
      dateLeft.setDate(30);
    }
    dateLeft.setMonth(dateLeft.getMonth() - sign2 * difference);
    var isLastMonthNotFull = compareAsc$1(dateLeft, dateRight) === -sign2;
    if (isLastDayOfMonth$1(toDate$1(dirtyDateLeft)) && difference === 1 && compareAsc$1(dirtyDateLeft, dateRight) === 1) {
      isLastMonthNotFull = false;
    }
    result = sign2 * (difference - Number(isLastMonthNotFull));
  }
  return result === 0 ? 0 : result;
}
function differenceInQuarters(dateLeft, dateRight, options) {
  requiredArgs$1(2, arguments);
  var diff = differenceInMonths$1(dateLeft, dateRight) / 3;
  return getRoundingMethod$1(void 0)(diff);
}
function differenceInSeconds$1(dateLeft, dateRight, options) {
  requiredArgs$1(2, arguments);
  var diff = differenceInMilliseconds$1(dateLeft, dateRight) / 1e3;
  return getRoundingMethod$1(void 0)(diff);
}
function differenceInWeeks(dateLeft, dateRight, options) {
  requiredArgs$1(2, arguments);
  var diff = differenceInDays$1(dateLeft, dateRight) / 7;
  return getRoundingMethod$1(void 0)(diff);
}
function differenceInYears$1(dirtyDateLeft, dirtyDateRight) {
  requiredArgs$1(2, arguments);
  var dateLeft = toDate$1(dirtyDateLeft);
  var dateRight = toDate$1(dirtyDateRight);
  var sign2 = compareAsc$1(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarYears$1(dateLeft, dateRight));
  dateLeft.setFullYear(1584);
  dateRight.setFullYear(1584);
  var isLastYearNotFull = compareAsc$1(dateLeft, dateRight) === -sign2;
  var result = sign2 * (difference - Number(isLastYearNotFull));
  return result === 0 ? 0 : result;
}
function startOfMinute(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date = toDate$1(dirtyDate);
  date.setSeconds(0, 0);
  return date;
}
function startOfQuarter(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date = toDate$1(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3;
  date.setMonth(month, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}
function startOfMonth(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date = toDate$1(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}
function endOfYear(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date = toDate$1(dirtyDate);
  var year = date.getFullYear();
  date.setFullYear(year + 1, 0, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}
function startOfYear(dirtyDate) {
  requiredArgs$1(1, arguments);
  var cleanDate = toDate$1(dirtyDate);
  var date = /* @__PURE__ */ new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}
function endOfHour(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date = toDate$1(dirtyDate);
  date.setMinutes(59, 59, 999);
  return date;
}
function endOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs$1(1, arguments);
  var defaultOptions2 = getDefaultOptions$1();
  var weekStartsOn = toInteger$1((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = void 0) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : void 0) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date = toDate$1(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setDate(date.getDate() + diff);
  date.setHours(23, 59, 59, 999);
  return date;
}
function endOfMinute(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date = toDate$1(dirtyDate);
  date.setSeconds(59, 999);
  return date;
}
function endOfQuarter(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date = toDate$1(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3 + 3;
  date.setMonth(month, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}
function endOfSecond(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date = toDate$1(dirtyDate);
  date.setMilliseconds(999);
  return date;
}
function subMilliseconds$1(dirtyDate, dirtyAmount) {
  requiredArgs$1(2, arguments);
  var amount = toInteger$1(dirtyAmount);
  return addMilliseconds$1(dirtyDate, -amount);
}
var MILLISECONDS_IN_DAY$4 = 864e5;
function getUTCDayOfYear$1(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date = toDate$1(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY$4) + 1;
}
function startOfUTCISOWeek$1(dirtyDate) {
  requiredArgs$1(1, arguments);
  var weekStartsOn = 1;
  var date = toDate$1(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
function getUTCISOWeekYear$1(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date = toDate$1(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = /* @__PURE__ */ new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek$1(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = /* @__PURE__ */ new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek$1(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfUTCISOWeekYear$1(dirtyDate) {
  requiredArgs$1(1, arguments);
  var year = getUTCISOWeekYear$1(dirtyDate);
  var fourthOfJanuary = /* @__PURE__ */ new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek$1(fourthOfJanuary);
  return date;
}
var MILLISECONDS_IN_WEEK$3 = 6048e5;
function getUTCISOWeek$1(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date = toDate$1(dirtyDate);
  var diff = startOfUTCISOWeek$1(date).getTime() - startOfUTCISOWeekYear$1(date).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK$3) + 1;
}
function startOfUTCWeek$1(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs$1(1, arguments);
  var defaultOptions2 = getDefaultOptions$1();
  var weekStartsOn = toInteger$1((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date = toDate$1(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
function getUTCWeekYear$1(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs$1(1, arguments);
  var date = toDate$1(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions2 = getDefaultOptions$1();
  var firstWeekContainsDate = toInteger$1((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var firstWeekOfNextYear = /* @__PURE__ */ new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek$1(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = /* @__PURE__ */ new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek$1(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfUTCWeekYear$1(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs$1(1, arguments);
  var defaultOptions2 = getDefaultOptions$1();
  var firstWeekContainsDate = toInteger$1((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear$1(dirtyDate, options);
  var firstWeek = /* @__PURE__ */ new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek$1(firstWeek, options);
  return date;
}
var MILLISECONDS_IN_WEEK$2 = 6048e5;
function getUTCWeek$1(dirtyDate, options) {
  requiredArgs$1(1, arguments);
  var date = toDate$1(dirtyDate);
  var diff = startOfUTCWeek$1(date, options).getTime() - startOfUTCWeekYear$1(date, options).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK$2) + 1;
}
function addLeadingZeros$1(number, targetLength) {
  var sign2 = number < 0 ? "-" : "";
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = "0" + output;
  }
  return sign2 + output;
}
var formatters$3 = {
  // Year
  y: function y(date, token2) {
    var signedYear = date.getUTCFullYear();
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros$1(token2 === "yy" ? year % 100 : year, token2.length);
  },
  // Month
  M: function M(date, token2) {
    var month = date.getUTCMonth();
    return token2 === "M" ? String(month + 1) : addLeadingZeros$1(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token2) {
    return addLeadingZeros$1(date.getUTCDate(), token2.length);
  },
  // AM or PM
  a: function a(date, token2) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (token2) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function h3(date, token2) {
    return addLeadingZeros$1(date.getUTCHours() % 12 || 12, token2.length);
  },
  // Hour [0-23]
  H: function H(date, token2) {
    return addLeadingZeros$1(date.getUTCHours(), token2.length);
  },
  // Minute
  m: function m(date, token2) {
    return addLeadingZeros$1(date.getUTCMinutes(), token2.length);
  },
  // Second
  s: function s(date, token2) {
    return addLeadingZeros$1(date.getUTCSeconds(), token2.length);
  },
  // Fraction of second
  S: function S(date, token2) {
    var numberOfDigits = token2.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros$1(fractionalSeconds, token2.length);
  }
};
var dayPeriodEnum$1 = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
var formatters$2 = {
  // Era
  G: function G(date, token2, localize2) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token2) {
      case "G":
      case "GG":
      case "GGG":
        return localize2.era(era, {
          width: "abbreviated"
        });
      case "GGGGG":
        return localize2.era(era, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return localize2.era(era, {
          width: "wide"
        });
    }
  },
  // Year
  y: function y2(date, token2, localize2) {
    if (token2 === "yo") {
      var signedYear = date.getUTCFullYear();
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize2.ordinalNumber(year, {
        unit: "year"
      });
    }
    return formatters$3.y(date, token2);
  },
  // Local week-numbering year
  Y: function Y(date, token2, localize2, options) {
    var signedWeekYear = getUTCWeekYear$1(date, options);
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token2 === "YY") {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros$1(twoDigitYear, 2);
    }
    if (token2 === "Yo") {
      return localize2.ordinalNumber(weekYear, {
        unit: "year"
      });
    }
    return addLeadingZeros$1(weekYear, token2.length);
  },
  // ISO week-numbering year
  R: function R(date, token2) {
    var isoWeekYear = getUTCISOWeekYear$1(date);
    return addLeadingZeros$1(isoWeekYear, token2.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token2) {
    var year = date.getUTCFullYear();
    return addLeadingZeros$1(year, token2.length);
  },
  // Quarter
  Q: function Q(date, token2, localize2) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token2) {
      case "Q":
        return String(quarter);
      case "QQ":
        return addLeadingZeros$1(quarter, 2);
      case "Qo":
        return localize2.ordinalNumber(quarter, {
          unit: "quarter"
        });
      case "QQQ":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token2, localize2) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token2) {
      case "q":
        return String(quarter);
      case "qq":
        return addLeadingZeros$1(quarter, 2);
      case "qo":
        return localize2.ordinalNumber(quarter, {
          unit: "quarter"
        });
      case "qqq":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function M2(date, token2, localize2) {
    var month = date.getUTCMonth();
    switch (token2) {
      case "M":
      case "MM":
        return formatters$3.M(date, token2);
      case "Mo":
        return localize2.ordinalNumber(month + 1, {
          unit: "month"
        });
      case "MMM":
        return localize2.month(month, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return localize2.month(month, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return localize2.month(month, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function L(date, token2, localize2) {
    var month = date.getUTCMonth();
    switch (token2) {
      case "L":
        return String(month + 1);
      case "LL":
        return addLeadingZeros$1(month + 1, 2);
      case "Lo":
        return localize2.ordinalNumber(month + 1, {
          unit: "month"
        });
      case "LLL":
        return localize2.month(month, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return localize2.month(month, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return localize2.month(month, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function w(date, token2, localize2, options) {
    var week = getUTCWeek$1(date, options);
    if (token2 === "wo") {
      return localize2.ordinalNumber(week, {
        unit: "week"
      });
    }
    return addLeadingZeros$1(week, token2.length);
  },
  // ISO week of year
  I: function I(date, token2, localize2) {
    var isoWeek = getUTCISOWeek$1(date);
    if (token2 === "Io") {
      return localize2.ordinalNumber(isoWeek, {
        unit: "week"
      });
    }
    return addLeadingZeros$1(isoWeek, token2.length);
  },
  // Day of the month
  d: function d2(date, token2, localize2) {
    if (token2 === "do") {
      return localize2.ordinalNumber(date.getUTCDate(), {
        unit: "date"
      });
    }
    return formatters$3.d(date, token2);
  },
  // Day of year
  D: function D(date, token2, localize2) {
    var dayOfYear = getUTCDayOfYear$1(date);
    if (token2 === "Do") {
      return localize2.ordinalNumber(dayOfYear, {
        unit: "dayOfYear"
      });
    }
    return addLeadingZeros$1(dayOfYear, token2.length);
  },
  // Day of week
  E: function E(date, token2, localize2) {
    var dayOfWeek = date.getUTCDay();
    switch (token2) {
      case "E":
      case "EE":
      case "EEE":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function e(date, token2, localize2, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token2) {
      case "e":
        return String(localDayOfWeek);
      case "ee":
        return addLeadingZeros$1(localDayOfWeek, 2);
      case "eo":
        return localize2.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "eee":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token2, localize2, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token2) {
      case "c":
        return String(localDayOfWeek);
      case "cc":
        return addLeadingZeros$1(localDayOfWeek, token2.length);
      case "co":
        return localize2.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "ccc":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function i(date, token2, localize2) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token2) {
      case "i":
        return String(isoDayOfWeek);
      case "ii":
        return addLeadingZeros$1(isoDayOfWeek, token2.length);
      case "io":
        return localize2.ordinalNumber(isoDayOfWeek, {
          unit: "day"
        });
      case "iii":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function a2(date, token2, localize2) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    switch (token2) {
      case "a":
      case "aa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token2, localize2) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum$1.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum$1.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }
    switch (token2) {
      case "b":
      case "bb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token2, localize2) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum$1.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum$1.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum$1.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum$1.night;
    }
    switch (token2) {
      case "B":
      case "BB":
      case "BBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function h4(date, token2, localize2) {
    if (token2 === "ho") {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return formatters$3.h(date, token2);
  },
  // Hour [0-23]
  H: function H2(date, token2, localize2) {
    if (token2 === "Ho") {
      return localize2.ordinalNumber(date.getUTCHours(), {
        unit: "hour"
      });
    }
    return formatters$3.H(date, token2);
  },
  // Hour [0-11]
  K: function K(date, token2, localize2) {
    var hours = date.getUTCHours() % 12;
    if (token2 === "Ko") {
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros$1(hours, token2.length);
  },
  // Hour [1-24]
  k: function k(date, token2, localize2) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token2 === "ko") {
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros$1(hours, token2.length);
  },
  // Minute
  m: function m2(date, token2, localize2) {
    if (token2 === "mo") {
      return localize2.ordinalNumber(date.getUTCMinutes(), {
        unit: "minute"
      });
    }
    return formatters$3.m(date, token2);
  },
  // Second
  s: function s2(date, token2, localize2) {
    if (token2 === "so") {
      return localize2.ordinalNumber(date.getUTCSeconds(), {
        unit: "second"
      });
    }
    return formatters$3.s(date, token2);
  },
  // Fraction of second
  S: function S2(date, token2) {
    return formatters$3.S(date, token2);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token2, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return "Z";
    }
    switch (token2) {
      case "X":
        return formatTimezoneWithOptionalMinutes$1(timezoneOffset);
      case "XXXX":
      case "XX":
        return formatTimezone$3(timezoneOffset);
      case "XXXXX":
      case "XXX":
      default:
        return formatTimezone$3(timezoneOffset, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token2, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token2) {
      case "x":
        return formatTimezoneWithOptionalMinutes$1(timezoneOffset);
      case "xxxx":
      case "xx":
        return formatTimezone$3(timezoneOffset);
      case "xxxxx":
      case "xxx":
      default:
        return formatTimezone$3(timezoneOffset, ":");
    }
  },
  // Timezone (GMT)
  O: function O(date, token2, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token2) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort$1(timezoneOffset, ":");
      case "OOOO":
      default:
        return "GMT" + formatTimezone$3(timezoneOffset, ":");
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token2, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token2) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort$1(timezoneOffset, ":");
      case "zzzz":
      default:
        return "GMT" + formatTimezone$3(timezoneOffset, ":");
    }
  },
  // Seconds timestamp
  t: function t(date, token2, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1e3);
    return addLeadingZeros$1(timestamp, token2.length);
  },
  // Milliseconds timestamp
  T: function T(date, token2, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros$1(timestamp, token2.length);
  }
};
function formatTimezoneShort$1(offset2, dirtyDelimiter) {
  var sign2 = offset2 > 0 ? "-" : "+";
  var absOffset = Math.abs(offset2);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign2 + String(hours);
  }
  var delimiter = dirtyDelimiter;
  return sign2 + String(hours) + delimiter + addLeadingZeros$1(minutes, 2);
}
function formatTimezoneWithOptionalMinutes$1(offset2, dirtyDelimiter) {
  if (offset2 % 60 === 0) {
    var sign2 = offset2 > 0 ? "-" : "+";
    return sign2 + addLeadingZeros$1(Math.abs(offset2) / 60, 2);
  }
  return formatTimezone$3(offset2, dirtyDelimiter);
}
function formatTimezone$3(offset2, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || "";
  var sign2 = offset2 > 0 ? "-" : "+";
  var absOffset = Math.abs(offset2);
  var hours = addLeadingZeros$1(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros$1(absOffset % 60, 2);
  return sign2 + hours + delimiter + minutes;
}
var dateLongFormatter$1 = function dateLongFormatter(pattern, formatLong2) {
  switch (pattern) {
    case "P":
      return formatLong2.date({
        width: "short"
      });
    case "PP":
      return formatLong2.date({
        width: "medium"
      });
    case "PPP":
      return formatLong2.date({
        width: "long"
      });
    case "PPPP":
    default:
      return formatLong2.date({
        width: "full"
      });
  }
};
var timeLongFormatter$1 = function timeLongFormatter(pattern, formatLong2) {
  switch (pattern) {
    case "p":
      return formatLong2.time({
        width: "short"
      });
    case "pp":
      return formatLong2.time({
        width: "medium"
      });
    case "ppp":
      return formatLong2.time({
        width: "long"
      });
    case "pppp":
    default:
      return formatLong2.time({
        width: "full"
      });
  }
};
var dateTimeLongFormatter$1 = function dateTimeLongFormatter(pattern, formatLong2) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter$1(pattern, formatLong2);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong2.dateTime({
        width: "short"
      });
      break;
    case "PP":
      dateTimeFormat = formatLong2.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      dateTimeFormat = formatLong2.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong2.dateTime({
        width: "full"
      });
      break;
  }
  return dateTimeFormat.replace("{{date}}", dateLongFormatter$1(datePattern, formatLong2)).replace("{{time}}", timeLongFormatter$1(timePattern, formatLong2));
};
var longFormatters$1 = {
  p: timeLongFormatter$1,
  P: dateTimeLongFormatter$1
};
var protectedDayOfYearTokens$1 = ["D", "DD"];
var protectedWeekYearTokens$1 = ["YY", "YYYY"];
function isProtectedDayOfYearToken$1(token2) {
  return protectedDayOfYearTokens$1.indexOf(token2) !== -1;
}
function isProtectedWeekYearToken$1(token2) {
  return protectedWeekYearTokens$1.indexOf(token2) !== -1;
}
function throwProtectedError$1(token2, format2, input) {
  if (token2 === "YYYY") {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token2 === "YY") {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token2 === "D") {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token2 === "DD") {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}
var formatDistanceLocale$1 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};
var formatDistance$1 = function formatDistance(token2, count, options) {
  var result;
  var tokenValue = formatDistanceLocale$1[token2];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }
  return result;
};
function buildFormatLongFn$1(args) {
  return function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format2 = args.formats[width] || args.formats[args.defaultWidth];
    return format2;
  };
}
var dateFormats$1 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
};
var timeFormats$1 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
var dateTimeFormats$1 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong$1 = {
  date: buildFormatLongFn$1({
    formats: dateFormats$1,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn$1({
    formats: timeFormats$1,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn$1({
    formats: dateTimeFormats$1,
    defaultWidth: "full"
  })
};
var formatRelativeLocale$1 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
var formatRelative$1 = function formatRelative(token2, _date, _baseDate, _options) {
  return formatRelativeLocale$1[token2];
};
function buildLocalizeFn$1(args) {
  return function(dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
    var valuesArray;
    if (context === "formatting" && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index2 = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index2];
  };
}
var eraValues$1 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
var quarterValues$1 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};
var monthValues$1 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
};
var dayValues$1 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
};
var dayPeriodValues$1 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
var formattingDayPeriodValues$1 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
var ordinalNumber$1 = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};
var localize$1 = {
  ordinalNumber: ordinalNumber$1,
  era: buildLocalizeFn$1({
    values: eraValues$1,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn$1({
    values: quarterValues$1,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn$1({
    values: monthValues$1,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn$1({
    values: dayValues$1,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn$1({
    values: dayPeriodValues$1,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$1,
    defaultFormattingWidth: "wide"
  })
};
function buildMatchFn$1(args) {
  return function(string) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex$1(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    }) : findKey$1(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    });
    var value2;
    value2 = args.valueCallback ? args.valueCallback(key) : key;
    value2 = options.valueCallback ? options.valueCallback(value2) : value2;
    var rest = string.slice(matchedString.length);
    return {
      value: value2,
      rest
    };
  };
}
function findKey$1(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return void 0;
}
function findIndex$1(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return void 0;
}
function buildMatchPatternFn$1(args) {
  return function(string) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value2 = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value2 = options.valueCallback ? options.valueCallback(value2) : value2;
    var rest = string.slice(matchedString.length);
    return {
      value: value2,
      rest
    };
  };
}
var matchOrdinalNumberPattern$1 = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern$1 = /\d+/i;
var matchEraPatterns$1 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns$1 = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns$1 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns$1 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$1 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns$1 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$1 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns$1 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns$1 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns$1 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match$1 = {
  ordinalNumber: buildMatchPatternFn$1({
    matchPattern: matchOrdinalNumberPattern$1,
    parsePattern: parseOrdinalNumberPattern$1,
    valueCallback: function valueCallback(value2) {
      return parseInt(value2, 10);
    }
  }),
  era: buildMatchFn$1({
    matchPatterns: matchEraPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$1,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn$1({
    matchPatterns: matchQuarterPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$1,
    defaultParseWidth: "any",
    valueCallback: function valueCallback2(index2) {
      return index2 + 1;
    }
  }),
  month: buildMatchFn$1({
    matchPatterns: matchMonthPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$1,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn$1({
    matchPatterns: matchDayPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$1,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn$1({
    matchPatterns: matchDayPeriodPatterns$1,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$1,
    defaultParseWidth: "any"
  })
};
var locale$1 = {
  code: "en-US",
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
var formattingTokensRegExp$4 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp$3 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp$4 = /^'([^]*?)'?$/;
var doubleQuoteRegExp$4 = /''/g;
var unescapedLatinCharacterRegExp$4 = /[a-zA-Z]/;
function format$1(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs$1(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions2 = getDefaultOptions$1();
  var locale2 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions2.locale) !== null && _ref !== void 0 ? _ref : locale$1;
  var firstWeekContainsDate = toInteger$1((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions2.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var weekStartsOn = toInteger$1((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions2.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions2.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  if (!locale2.localize) {
    throw new RangeError("locale must contain localize property");
  }
  if (!locale2.formatLong) {
    throw new RangeError("locale must contain formatLong property");
  }
  var originalDate = toDate$1(dirtyDate);
  if (!isValid$1(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  var timezoneOffset = getTimezoneOffsetInMilliseconds$1(originalDate);
  var utcDate = subMilliseconds$1(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale2,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp$3).map(function(substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      var longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale2.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp$4).map(function(substring) {
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString$4(substring);
    }
    var formatter2 = formatters$2[firstCharacter];
    if (formatter2) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken$1(substring)) {
        throwProtectedError$1(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken$1(substring)) {
        throwProtectedError$1(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter2(utcDate, substring, locale2.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp$4)) {
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
    }
    return substring;
  }).join("");
  return result;
}
function cleanEscapedString$4(input) {
  var matched = input.match(escapedStringRegExp$4);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp$4, "'");
}
function assign$2(target2, object) {
  if (target2 == null) {
    throw new TypeError("assign requires that input parameter not be null or undefined");
  }
  for (var property in object) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      target2[property] = object[property];
    }
  }
  return target2;
}
function _arrayLikeToArray$1(r, a4) {
  (null == a4 || a4 > r.length) && (a4 = r.length);
  for (var e3 = 0, n = Array(a4); e3 < a4; e3++) n[e3] = r[e3];
  return n;
}
function _unsupportedIterableToArray$1(r, a4) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray$1(r, a4);
    var t3 = {}.toString.call(r).slice(8, -1);
    return "Object" === t3 && r.constructor && (t3 = r.constructor.name), "Map" === t3 || "Set" === t3 ? Array.from(r) : "Arguments" === t3 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t3) ? _arrayLikeToArray$1(r, a4) : void 0;
  }
}
function _createForOfIteratorHelper$1(r, e3) {
  var t3 = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t3) {
    if (Array.isArray(r) || (t3 = _unsupportedIterableToArray$1(r)) || e3) {
      t3 && (r = t3);
      var _n2 = 0, F = function F2() {
      };
      return {
        s: F,
        n: function n() {
          return _n2 >= r.length ? {
            done: true
          } : {
            done: false,
            value: r[_n2++]
          };
        },
        e: function e4(r2) {
          throw r2;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o, a4 = true, u3 = false;
  return {
    s: function s4() {
      t3 = t3.call(r);
    },
    n: function n() {
      var r2 = t3.next();
      return a4 = r2.done, r2;
    },
    e: function e4(r2) {
      u3 = true, o = r2;
    },
    f: function f() {
      try {
        a4 || null == t3["return"] || t3["return"]();
      } finally {
        if (u3) throw o;
      }
    }
  };
}
function _assertThisInitialized$1(e3) {
  if (void 0 === e3) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e3;
}
function _setPrototypeOf$1(t3, e3) {
  return _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e4) {
    return t4.__proto__ = e4, t4;
  }, _setPrototypeOf$1(t3, e3);
}
function _inherits$1(t3, e3) {
  if ("function" != typeof e3 && null !== e3) throw new TypeError("Super expression must either be null or a function");
  t3.prototype = Object.create(e3 && e3.prototype, {
    constructor: {
      value: t3,
      writable: true,
      configurable: true
    }
  }), Object.defineProperty(t3, "prototype", {
    writable: false
  }), e3 && _setPrototypeOf$1(t3, e3);
}
function _getPrototypeOf$1(t3) {
  return _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$1(t3);
}
function _isNativeReflectConstruct$1() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$1 = function _isNativeReflectConstruct2() {
    return !!t3;
  })();
}
function _possibleConstructorReturn$1(t3, e3) {
  if (e3 && ("object" == _typeof$1(e3) || "function" == typeof e3)) return e3;
  if (void 0 !== e3) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$1(t3);
}
function _createSuper$1(t3) {
  var r = _isNativeReflectConstruct$1();
  return function() {
    var e3, o = _getPrototypeOf$1(t3);
    if (r) {
      var s4 = _getPrototypeOf$1(this).constructor;
      e3 = Reflect.construct(o, arguments, s4);
    } else e3 = o.apply(this, arguments);
    return _possibleConstructorReturn$1(this, e3);
  };
}
function _classCallCheck$1(a4, n) {
  if (!(a4 instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function toPrimitive$1(t3, r) {
  if ("object" != _typeof$1(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r);
    if ("object" != _typeof$1(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t3);
}
function toPropertyKey$1(t3) {
  var i3 = toPrimitive$1(t3, "string");
  return "symbol" == _typeof$1(i3) ? i3 : i3 + "";
}
function _defineProperties$1(e3, r) {
  for (var t3 = 0; t3 < r.length; t3++) {
    var o = r[t3];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e3, toPropertyKey$1(o.key), o);
  }
}
function _createClass$1(e3, r, t3) {
  return r && _defineProperties$1(e3.prototype, r), Object.defineProperty(e3, "prototype", {
    writable: false
  }), e3;
}
function _defineProperty$1(e3, r, t3) {
  return (r = toPropertyKey$1(r)) in e3 ? Object.defineProperty(e3, r, {
    value: t3,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e3[r] = t3, e3;
}
var TIMEZONE_UNIT_PRIORITY$1 = 10;
var Setter$1 = /* @__PURE__ */ function() {
  function Setter2() {
    _classCallCheck$1(this, Setter2);
    _defineProperty$1(this, "priority", void 0);
    _defineProperty$1(this, "subPriority", 0);
  }
  _createClass$1(Setter2, [{
    key: "validate",
    value: function validate2(_utcDate, _options) {
      return true;
    }
  }]);
  return Setter2;
}();
var ValueSetter$1 = /* @__PURE__ */ function(_Setter) {
  _inherits$1(ValueSetter2, _Setter);
  var _super = _createSuper$1(ValueSetter2);
  function ValueSetter2(value2, validateValue, setValue, priority, subPriority) {
    var _this;
    _classCallCheck$1(this, ValueSetter2);
    _this = _super.call(this);
    _this.value = value2;
    _this.validateValue = validateValue;
    _this.setValue = setValue;
    _this.priority = priority;
    if (subPriority) {
      _this.subPriority = subPriority;
    }
    return _this;
  }
  _createClass$1(ValueSetter2, [{
    key: "validate",
    value: function validate2(utcDate, options) {
      return this.validateValue(utcDate, this.value, options);
    }
  }, {
    key: "set",
    value: function set2(utcDate, flags, options) {
      return this.setValue(utcDate, flags, this.value, options);
    }
  }]);
  return ValueSetter2;
}(Setter$1);
var DateToSystemTimezoneSetter$1 = /* @__PURE__ */ function(_Setter2) {
  _inherits$1(DateToSystemTimezoneSetter2, _Setter2);
  var _super2 = _createSuper$1(DateToSystemTimezoneSetter2);
  function DateToSystemTimezoneSetter2() {
    var _this2;
    _classCallCheck$1(this, DateToSystemTimezoneSetter2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this2), "priority", TIMEZONE_UNIT_PRIORITY$1);
    _defineProperty$1(_assertThisInitialized$1(_this2), "subPriority", -1);
    return _this2;
  }
  _createClass$1(DateToSystemTimezoneSetter2, [{
    key: "set",
    value: function set2(date, flags) {
      if (flags.timestampIsSet) {
        return date;
      }
      var convertedDate = /* @__PURE__ */ new Date(0);
      convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
      convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
      return convertedDate;
    }
  }]);
  return DateToSystemTimezoneSetter2;
}(Setter$1);
var Parser$1 = /* @__PURE__ */ function() {
  function Parser2() {
    _classCallCheck$1(this, Parser2);
    _defineProperty$1(this, "incompatibleTokens", void 0);
    _defineProperty$1(this, "priority", void 0);
    _defineProperty$1(this, "subPriority", void 0);
  }
  _createClass$1(Parser2, [{
    key: "run",
    value: function run2(dateString, token2, match2, options) {
      var result = this.parse(dateString, token2, match2, options);
      if (!result) {
        return null;
      }
      return {
        setter: new ValueSetter$1(result.value, this.validate, this.set, this.priority, this.subPriority),
        rest: result.rest
      };
    }
  }, {
    key: "validate",
    value: function validate2(_utcDate, _value, _options) {
      return true;
    }
  }]);
  return Parser2;
}();
var EraParser$1 = /* @__PURE__ */ function(_Parser) {
  _inherits$1(EraParser2, _Parser);
  var _super = _createSuper$1(EraParser2);
  function EraParser2() {
    var _this;
    _classCallCheck$1(this, EraParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "priority", 140);
    _defineProperty$1(_assertThisInitialized$1(_this), "incompatibleTokens", ["R", "u", "t", "T"]);
    return _this;
  }
  _createClass$1(EraParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "G":
        case "GG":
        case "GGG":
          return match2.era(dateString, {
            width: "abbreviated"
          }) || match2.era(dateString, {
            width: "narrow"
          });
        case "GGGGG":
          return match2.era(dateString, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return match2.era(dateString, {
            width: "wide"
          }) || match2.era(dateString, {
            width: "abbreviated"
          }) || match2.era(dateString, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function set2(date, flags, value2) {
      flags.era = value2;
      date.setUTCFullYear(value2, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return EraParser2;
}(Parser$1);
var numericPatterns$1 = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
};
var timezonePatterns$1 = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function mapValue$1(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }
  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest
  };
}
function parseNumericPattern$1(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseTimezonePattern$1(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  if (matchResult[0] === "Z") {
    return {
      value: 0,
      rest: dateString.slice(1)
    };
  }
  var sign2 = matchResult[1] === "+" ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign2 * (hours * millisecondsInHour$1 + minutes * millisecondsInMinute$1 + seconds * millisecondsInSecond$1),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned$1(dateString) {
  return parseNumericPattern$1(numericPatterns$1.anyDigitsSigned, dateString);
}
function parseNDigits$1(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern$1(numericPatterns$1.singleDigit, dateString);
    case 2:
      return parseNumericPattern$1(numericPatterns$1.twoDigits, dateString);
    case 3:
      return parseNumericPattern$1(numericPatterns$1.threeDigits, dateString);
    case 4:
      return parseNumericPattern$1(numericPatterns$1.fourDigits, dateString);
    default:
      return parseNumericPattern$1(new RegExp("^\\d{1," + n + "}"), dateString);
  }
}
function parseNDigitsSigned$1(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern$1(numericPatterns$1.singleDigitSigned, dateString);
    case 2:
      return parseNumericPattern$1(numericPatterns$1.twoDigitsSigned, dateString);
    case 3:
      return parseNumericPattern$1(numericPatterns$1.threeDigitsSigned, dateString);
    case 4:
      return parseNumericPattern$1(numericPatterns$1.fourDigitsSigned, dateString);
    default:
      return parseNumericPattern$1(new RegExp("^-?\\d{1," + n + "}"), dateString);
  }
}
function dayPeriodEnumToHours$1(dayPeriod) {
  switch (dayPeriod) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function normalizeTwoDigitYear$1(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0;
  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }
  return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex$3(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
var YearParser$1 = /* @__PURE__ */ function(_Parser) {
  _inherits$1(YearParser2, _Parser);
  var _super = _createSuper$1(YearParser2);
  function YearParser2() {
    var _this;
    _classCallCheck$1(this, YearParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "priority", 130);
    _defineProperty$1(_assertThisInitialized$1(_this), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass$1(YearParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      var valueCallback4 = function valueCallback5(year) {
        return {
          year,
          isTwoDigitYear: token2 === "yy"
        };
      };
      switch (token2) {
        case "y":
          return mapValue$1(parseNDigits$1(4, dateString), valueCallback4);
        case "yo":
          return mapValue$1(match2.ordinalNumber(dateString, {
            unit: "year"
          }), valueCallback4);
        default:
          return mapValue$1(parseNDigits$1(token2.length, dateString), valueCallback4);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2.isTwoDigitYear || value2.year > 0;
    }
  }, {
    key: "set",
    value: function set2(date, flags, value2) {
      var currentYear = date.getUTCFullYear();
      if (value2.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear$1(value2.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
      var year = !("era" in flags) || flags.era === 1 ? value2.year : 1 - value2.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return YearParser2;
}(Parser$1);
var LocalWeekYearParser$1 = /* @__PURE__ */ function(_Parser) {
  _inherits$1(LocalWeekYearParser2, _Parser);
  var _super = _createSuper$1(LocalWeekYearParser2);
  function LocalWeekYearParser2() {
    var _this;
    _classCallCheck$1(this, LocalWeekYearParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "priority", 130);
    _defineProperty$1(_assertThisInitialized$1(_this), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]);
    return _this;
  }
  _createClass$1(LocalWeekYearParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      var valueCallback4 = function valueCallback5(year) {
        return {
          year,
          isTwoDigitYear: token2 === "YY"
        };
      };
      switch (token2) {
        case "Y":
          return mapValue$1(parseNDigits$1(4, dateString), valueCallback4);
        case "Yo":
          return mapValue$1(match2.ordinalNumber(dateString, {
            unit: "year"
          }), valueCallback4);
        default:
          return mapValue$1(parseNDigits$1(token2.length, dateString), valueCallback4);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2.isTwoDigitYear || value2.year > 0;
    }
  }, {
    key: "set",
    value: function set2(date, flags, value2, options) {
      var currentYear = getUTCWeekYear$1(date, options);
      if (value2.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear$1(value2.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek$1(date, options);
      }
      var year = !("era" in flags) || flags.era === 1 ? value2.year : 1 - value2.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return startOfUTCWeek$1(date, options);
    }
  }]);
  return LocalWeekYearParser2;
}(Parser$1);
var ISOWeekYearParser$1 = /* @__PURE__ */ function(_Parser) {
  _inherits$1(ISOWeekYearParser2, _Parser);
  var _super = _createSuper$1(ISOWeekYearParser2);
  function ISOWeekYearParser2() {
    var _this;
    _classCallCheck$1(this, ISOWeekYearParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "priority", 130);
    _defineProperty$1(_assertThisInitialized$1(_this), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass$1(ISOWeekYearParser2, [{
    key: "parse",
    value: function parse2(dateString, token2) {
      if (token2 === "R") {
        return parseNDigitsSigned$1(4, dateString);
      }
      return parseNDigitsSigned$1(token2.length, dateString);
    }
  }, {
    key: "set",
    value: function set2(_date, _flags, value2) {
      var firstWeekOfYear = /* @__PURE__ */ new Date(0);
      firstWeekOfYear.setUTCFullYear(value2, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return startOfUTCISOWeek$1(firstWeekOfYear);
    }
  }]);
  return ISOWeekYearParser2;
}(Parser$1);
var ExtendedYearParser$1 = /* @__PURE__ */ function(_Parser) {
  _inherits$1(ExtendedYearParser2, _Parser);
  var _super = _createSuper$1(ExtendedYearParser2);
  function ExtendedYearParser2() {
    var _this;
    _classCallCheck$1(this, ExtendedYearParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "priority", 130);
    _defineProperty$1(_assertThisInitialized$1(_this), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass$1(ExtendedYearParser2, [{
    key: "parse",
    value: function parse2(dateString, token2) {
      if (token2 === "u") {
        return parseNDigitsSigned$1(4, dateString);
      }
      return parseNDigitsSigned$1(token2.length, dateString);
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCFullYear(value2, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return ExtendedYearParser2;
}(Parser$1);
var QuarterParser$1 = /* @__PURE__ */ function(_Parser) {
  _inherits$1(QuarterParser2, _Parser);
  var _super = _createSuper$1(QuarterParser2);
  function QuarterParser2() {
    var _this;
    _classCallCheck$1(this, QuarterParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "priority", 120);
    _defineProperty$1(_assertThisInitialized$1(_this), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass$1(QuarterParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "Q":
        case "QQ":
          return parseNDigits$1(token2.length, dateString);
        case "Qo":
          return match2.ordinalNumber(dateString, {
            unit: "quarter"
          });
        case "QQQ":
          return match2.quarter(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.quarter(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return match2.quarter(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return match2.quarter(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.quarter(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.quarter(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 1 && value2 <= 4;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCMonth((value2 - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return QuarterParser2;
}(Parser$1);
var StandAloneQuarterParser$1 = /* @__PURE__ */ function(_Parser) {
  _inherits$1(StandAloneQuarterParser2, _Parser);
  var _super = _createSuper$1(StandAloneQuarterParser2);
  function StandAloneQuarterParser2() {
    var _this;
    _classCallCheck$1(this, StandAloneQuarterParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "priority", 120);
    _defineProperty$1(_assertThisInitialized$1(_this), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass$1(StandAloneQuarterParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "q":
        case "qq":
          return parseNDigits$1(token2.length, dateString);
        case "qo":
          return match2.ordinalNumber(dateString, {
            unit: "quarter"
          });
        case "qqq":
          return match2.quarter(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.quarter(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return match2.quarter(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return match2.quarter(dateString, {
            width: "wide",
            context: "standalone"
          }) || match2.quarter(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.quarter(dateString, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 1 && value2 <= 4;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCMonth((value2 - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneQuarterParser2;
}(Parser$1);
var MonthParser$1 = /* @__PURE__ */ function(_Parser) {
  _inherits$1(MonthParser2, _Parser);
  var _super = _createSuper$1(MonthParser2);
  function MonthParser2() {
    var _this;
    _classCallCheck$1(this, MonthParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]);
    _defineProperty$1(_assertThisInitialized$1(_this), "priority", 110);
    return _this;
  }
  _createClass$1(MonthParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      var valueCallback4 = function valueCallback5(value2) {
        return value2 - 1;
      };
      switch (token2) {
        case "M":
          return mapValue$1(parseNumericPattern$1(numericPatterns$1.month, dateString), valueCallback4);
        case "MM":
          return mapValue$1(parseNDigits$1(2, dateString), valueCallback4);
        case "Mo":
          return mapValue$1(match2.ordinalNumber(dateString, {
            unit: "month"
          }), valueCallback4);
        case "MMM":
          return match2.month(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.month(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return match2.month(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return match2.month(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.month(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.month(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 0 && value2 <= 11;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCMonth(value2, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return MonthParser2;
}(Parser$1);
var StandAloneMonthParser$1 = /* @__PURE__ */ function(_Parser) {
  _inherits$1(StandAloneMonthParser2, _Parser);
  var _super = _createSuper$1(StandAloneMonthParser2);
  function StandAloneMonthParser2() {
    var _this;
    _classCallCheck$1(this, StandAloneMonthParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "priority", 110);
    _defineProperty$1(_assertThisInitialized$1(_this), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass$1(StandAloneMonthParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      var valueCallback4 = function valueCallback5(value2) {
        return value2 - 1;
      };
      switch (token2) {
        case "L":
          return mapValue$1(parseNumericPattern$1(numericPatterns$1.month, dateString), valueCallback4);
        case "LL":
          return mapValue$1(parseNDigits$1(2, dateString), valueCallback4);
        case "Lo":
          return mapValue$1(match2.ordinalNumber(dateString, {
            unit: "month"
          }), valueCallback4);
        case "LLL":
          return match2.month(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.month(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return match2.month(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return match2.month(dateString, {
            width: "wide",
            context: "standalone"
          }) || match2.month(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.month(dateString, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 0 && value2 <= 11;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCMonth(value2, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneMonthParser2;
}(Parser$1);
function setUTCWeek$1(dirtyDate, dirtyWeek, options) {
  requiredArgs$1(2, arguments);
  var date = toDate$1(dirtyDate);
  var week = toInteger$1(dirtyWeek);
  var diff = getUTCWeek$1(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
var LocalWeekParser$1 = /* @__PURE__ */ function(_Parser) {
  _inherits$1(LocalWeekParser2, _Parser);
  var _super = _createSuper$1(LocalWeekParser2);
  function LocalWeekParser2() {
    var _this;
    _classCallCheck$1(this, LocalWeekParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "priority", 100);
    _defineProperty$1(_assertThisInitialized$1(_this), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]);
    return _this;
  }
  _createClass$1(LocalWeekParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "w":
          return parseNumericPattern$1(numericPatterns$1.week, dateString);
        case "wo":
          return match2.ordinalNumber(dateString, {
            unit: "week"
          });
        default:
          return parseNDigits$1(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 1 && value2 <= 53;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2, options) {
      return startOfUTCWeek$1(setUTCWeek$1(date, value2, options), options);
    }
  }]);
  return LocalWeekParser2;
}(Parser$1);
function setUTCISOWeek$1(dirtyDate, dirtyISOWeek) {
  requiredArgs$1(2, arguments);
  var date = toDate$1(dirtyDate);
  var isoWeek = toInteger$1(dirtyISOWeek);
  var diff = getUTCISOWeek$1(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
var ISOWeekParser$1 = /* @__PURE__ */ function(_Parser) {
  _inherits$1(ISOWeekParser2, _Parser);
  var _super = _createSuper$1(ISOWeekParser2);
  function ISOWeekParser2() {
    var _this;
    _classCallCheck$1(this, ISOWeekParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "priority", 100);
    _defineProperty$1(_assertThisInitialized$1(_this), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass$1(ISOWeekParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "I":
          return parseNumericPattern$1(numericPatterns$1.week, dateString);
        case "Io":
          return match2.ordinalNumber(dateString, {
            unit: "week"
          });
        default:
          return parseNDigits$1(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 1 && value2 <= 53;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      return startOfUTCISOWeek$1(setUTCISOWeek$1(date, value2));
    }
  }]);
  return ISOWeekParser2;
}(Parser$1);
var DAYS_IN_MONTH$1 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR$1 = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DateParser$1 = /* @__PURE__ */ function(_Parser) {
  _inherits$1(DateParser2, _Parser);
  var _super = _createSuper$1(DateParser2);
  function DateParser2() {
    var _this;
    _classCallCheck$1(this, DateParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "priority", 90);
    _defineProperty$1(_assertThisInitialized$1(_this), "subPriority", 1);
    _defineProperty$1(_assertThisInitialized$1(_this), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass$1(DateParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "d":
          return parseNumericPattern$1(numericPatterns$1.date, dateString);
        case "do":
          return match2.ordinalNumber(dateString, {
            unit: "date"
          });
        default:
          return parseNDigits$1(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(date, value2) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex$3(year);
      var month = date.getUTCMonth();
      if (isLeapYear) {
        return value2 >= 1 && value2 <= DAYS_IN_MONTH_LEAP_YEAR$1[month];
      } else {
        return value2 >= 1 && value2 <= DAYS_IN_MONTH$1[month];
      }
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCDate(value2);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DateParser2;
}(Parser$1);
var DayOfYearParser$1 = /* @__PURE__ */ function(_Parser) {
  _inherits$1(DayOfYearParser2, _Parser);
  var _super = _createSuper$1(DayOfYearParser2);
  function DayOfYearParser2() {
    var _this;
    _classCallCheck$1(this, DayOfYearParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "priority", 90);
    _defineProperty$1(_assertThisInitialized$1(_this), "subpriority", 1);
    _defineProperty$1(_assertThisInitialized$1(_this), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass$1(DayOfYearParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "D":
        case "DD":
          return parseNumericPattern$1(numericPatterns$1.dayOfYear, dateString);
        case "Do":
          return match2.ordinalNumber(dateString, {
            unit: "date"
          });
        default:
          return parseNDigits$1(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(date, value2) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex$3(year);
      if (isLeapYear) {
        return value2 >= 1 && value2 <= 366;
      } else {
        return value2 >= 1 && value2 <= 365;
      }
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCMonth(0, value2);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DayOfYearParser2;
}(Parser$1);
function setUTCDay$1(dirtyDate, dirtyDay, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs$1(2, arguments);
  var defaultOptions2 = getDefaultOptions$1();
  var weekStartsOn = toInteger$1((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date = toDate$1(dirtyDate);
  var day = toInteger$1(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
var DayParser$1 = /* @__PURE__ */ function(_Parser) {
  _inherits$1(DayParser2, _Parser);
  var _super = _createSuper$1(DayParser2);
  function DayParser2() {
    var _this;
    _classCallCheck$1(this, DayParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "priority", 90);
    _defineProperty$1(_assertThisInitialized$1(_this), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass$1(DayParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "E":
        case "EE":
        case "EEE":
          return match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return match2.day(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 0 && value2 <= 6;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2, options) {
      date = setUTCDay$1(date, value2, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DayParser2;
}(Parser$1);
var LocalDayParser$1 = /* @__PURE__ */ function(_Parser) {
  _inherits$1(LocalDayParser2, _Parser);
  var _super = _createSuper$1(LocalDayParser2);
  function LocalDayParser2() {
    var _this;
    _classCallCheck$1(this, LocalDayParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "priority", 90);
    _defineProperty$1(_assertThisInitialized$1(_this), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]);
    return _this;
  }
  _createClass$1(LocalDayParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2, options) {
      var valueCallback4 = function valueCallback5(value2) {
        var wholeWeekDays = Math.floor((value2 - 1) / 7) * 7;
        return (value2 + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token2) {
        case "e":
        case "ee":
          return mapValue$1(parseNDigits$1(token2.length, dateString), valueCallback4);
        case "eo":
          return mapValue$1(match2.ordinalNumber(dateString, {
            unit: "day"
          }), valueCallback4);
        case "eee":
          return match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return match2.day(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 0 && value2 <= 6;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2, options) {
      date = setUTCDay$1(date, value2, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return LocalDayParser2;
}(Parser$1);
var StandAloneLocalDayParser$1 = /* @__PURE__ */ function(_Parser) {
  _inherits$1(StandAloneLocalDayParser2, _Parser);
  var _super = _createSuper$1(StandAloneLocalDayParser2);
  function StandAloneLocalDayParser2() {
    var _this;
    _classCallCheck$1(this, StandAloneLocalDayParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "priority", 90);
    _defineProperty$1(_assertThisInitialized$1(_this), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]);
    return _this;
  }
  _createClass$1(StandAloneLocalDayParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2, options) {
      var valueCallback4 = function valueCallback5(value2) {
        var wholeWeekDays = Math.floor((value2 - 1) / 7) * 7;
        return (value2 + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token2) {
        case "c":
        case "cc":
          return mapValue$1(parseNDigits$1(token2.length, dateString), valueCallback4);
        case "co":
          return mapValue$1(match2.ordinalNumber(dateString, {
            unit: "day"
          }), valueCallback4);
        case "ccc":
          return match2.day(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.day(dateString, {
            width: "short",
            context: "standalone"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return match2.day(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return match2.day(dateString, {
            width: "short",
            context: "standalone"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return match2.day(dateString, {
            width: "wide",
            context: "standalone"
          }) || match2.day(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.day(dateString, {
            width: "short",
            context: "standalone"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 0 && value2 <= 6;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2, options) {
      date = setUTCDay$1(date, value2, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneLocalDayParser2;
}(Parser$1);
function setUTCISODay$1(dirtyDate, dirtyDay) {
  requiredArgs$1(2, arguments);
  var day = toInteger$1(dirtyDay);
  if (day % 7 === 0) {
    day = day - 7;
  }
  var weekStartsOn = 1;
  var date = toDate$1(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
var ISODayParser$1 = /* @__PURE__ */ function(_Parser) {
  _inherits$1(ISODayParser2, _Parser);
  var _super = _createSuper$1(ISODayParser2);
  function ISODayParser2() {
    var _this;
    _classCallCheck$1(this, ISODayParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "priority", 90);
    _defineProperty$1(_assertThisInitialized$1(_this), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass$1(ISODayParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      var valueCallback4 = function valueCallback5(value2) {
        if (value2 === 0) {
          return 7;
        }
        return value2;
      };
      switch (token2) {
        case "i":
        case "ii":
          return parseNDigits$1(token2.length, dateString);
        case "io":
          return match2.ordinalNumber(dateString, {
            unit: "day"
          });
        case "iii":
          return mapValue$1(match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          }), valueCallback4);
        case "iiiii":
          return mapValue$1(match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          }), valueCallback4);
        case "iiiiii":
          return mapValue$1(match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          }), valueCallback4);
        case "iiii":
        default:
          return mapValue$1(match2.day(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          }), valueCallback4);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 1 && value2 <= 7;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date = setUTCISODay$1(date, value2);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return ISODayParser2;
}(Parser$1);
var AMPMParser$1 = /* @__PURE__ */ function(_Parser) {
  _inherits$1(AMPMParser2, _Parser);
  var _super = _createSuper$1(AMPMParser2);
  function AMPMParser2() {
    var _this;
    _classCallCheck$1(this, AMPMParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "priority", 80);
    _defineProperty$1(_assertThisInitialized$1(_this), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
    return _this;
  }
  _createClass$1(AMPMParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "a":
        case "aa":
        case "aaa":
          return match2.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return match2.dayPeriod(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCHours(dayPeriodEnumToHours$1(value2), 0, 0, 0);
      return date;
    }
  }]);
  return AMPMParser2;
}(Parser$1);
var AMPMMidnightParser$1 = /* @__PURE__ */ function(_Parser) {
  _inherits$1(AMPMMidnightParser2, _Parser);
  var _super = _createSuper$1(AMPMMidnightParser2);
  function AMPMMidnightParser2() {
    var _this;
    _classCallCheck$1(this, AMPMMidnightParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "priority", 80);
    _defineProperty$1(_assertThisInitialized$1(_this), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
    return _this;
  }
  _createClass$1(AMPMMidnightParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "b":
        case "bb":
        case "bbb":
          return match2.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return match2.dayPeriod(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCHours(dayPeriodEnumToHours$1(value2), 0, 0, 0);
      return date;
    }
  }]);
  return AMPMMidnightParser2;
}(Parser$1);
var DayPeriodParser$1 = /* @__PURE__ */ function(_Parser) {
  _inherits$1(DayPeriodParser2, _Parser);
  var _super = _createSuper$1(DayPeriodParser2);
  function DayPeriodParser2() {
    var _this;
    _classCallCheck$1(this, DayPeriodParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "priority", 80);
    _defineProperty$1(_assertThisInitialized$1(_this), "incompatibleTokens", ["a", "b", "t", "T"]);
    return _this;
  }
  _createClass$1(DayPeriodParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "B":
        case "BB":
        case "BBB":
          return match2.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return match2.dayPeriod(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCHours(dayPeriodEnumToHours$1(value2), 0, 0, 0);
      return date;
    }
  }]);
  return DayPeriodParser2;
}(Parser$1);
var Hour1to12Parser$1 = /* @__PURE__ */ function(_Parser) {
  _inherits$1(Hour1to12Parser2, _Parser);
  var _super = _createSuper$1(Hour1to12Parser2);
  function Hour1to12Parser2() {
    var _this;
    _classCallCheck$1(this, Hour1to12Parser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "priority", 70);
    _defineProperty$1(_assertThisInitialized$1(_this), "incompatibleTokens", ["H", "K", "k", "t", "T"]);
    return _this;
  }
  _createClass$1(Hour1to12Parser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "h":
          return parseNumericPattern$1(numericPatterns$1.hour12h, dateString);
        case "ho":
          return match2.ordinalNumber(dateString, {
            unit: "hour"
          });
        default:
          return parseNDigits$1(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 1 && value2 <= 12;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value2 < 12) {
        date.setUTCHours(value2 + 12, 0, 0, 0);
      } else if (!isPM && value2 === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value2, 0, 0, 0);
      }
      return date;
    }
  }]);
  return Hour1to12Parser2;
}(Parser$1);
var Hour0to23Parser$1 = /* @__PURE__ */ function(_Parser) {
  _inherits$1(Hour0to23Parser2, _Parser);
  var _super = _createSuper$1(Hour0to23Parser2);
  function Hour0to23Parser2() {
    var _this;
    _classCallCheck$1(this, Hour0to23Parser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "priority", 70);
    _defineProperty$1(_assertThisInitialized$1(_this), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
    return _this;
  }
  _createClass$1(Hour0to23Parser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "H":
          return parseNumericPattern$1(numericPatterns$1.hour23h, dateString);
        case "Ho":
          return match2.ordinalNumber(dateString, {
            unit: "hour"
          });
        default:
          return parseNDigits$1(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 0 && value2 <= 23;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCHours(value2, 0, 0, 0);
      return date;
    }
  }]);
  return Hour0to23Parser2;
}(Parser$1);
var Hour0To11Parser$1 = /* @__PURE__ */ function(_Parser) {
  _inherits$1(Hour0To11Parser2, _Parser);
  var _super = _createSuper$1(Hour0To11Parser2);
  function Hour0To11Parser2() {
    var _this;
    _classCallCheck$1(this, Hour0To11Parser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "priority", 70);
    _defineProperty$1(_assertThisInitialized$1(_this), "incompatibleTokens", ["h", "H", "k", "t", "T"]);
    return _this;
  }
  _createClass$1(Hour0To11Parser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "K":
          return parseNumericPattern$1(numericPatterns$1.hour11h, dateString);
        case "Ko":
          return match2.ordinalNumber(dateString, {
            unit: "hour"
          });
        default:
          return parseNDigits$1(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 0 && value2 <= 11;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value2 < 12) {
        date.setUTCHours(value2 + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value2, 0, 0, 0);
      }
      return date;
    }
  }]);
  return Hour0To11Parser2;
}(Parser$1);
var Hour1To24Parser$1 = /* @__PURE__ */ function(_Parser) {
  _inherits$1(Hour1To24Parser2, _Parser);
  var _super = _createSuper$1(Hour1To24Parser2);
  function Hour1To24Parser2() {
    var _this;
    _classCallCheck$1(this, Hour1To24Parser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "priority", 70);
    _defineProperty$1(_assertThisInitialized$1(_this), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
    return _this;
  }
  _createClass$1(Hour1To24Parser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "k":
          return parseNumericPattern$1(numericPatterns$1.hour24h, dateString);
        case "ko":
          return match2.ordinalNumber(dateString, {
            unit: "hour"
          });
        default:
          return parseNDigits$1(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 1 && value2 <= 24;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      var hours = value2 <= 24 ? value2 % 24 : value2;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    }
  }]);
  return Hour1To24Parser2;
}(Parser$1);
var MinuteParser$1 = /* @__PURE__ */ function(_Parser) {
  _inherits$1(MinuteParser2, _Parser);
  var _super = _createSuper$1(MinuteParser2);
  function MinuteParser2() {
    var _this;
    _classCallCheck$1(this, MinuteParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "priority", 60);
    _defineProperty$1(_assertThisInitialized$1(_this), "incompatibleTokens", ["t", "T"]);
    return _this;
  }
  _createClass$1(MinuteParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "m":
          return parseNumericPattern$1(numericPatterns$1.minute, dateString);
        case "mo":
          return match2.ordinalNumber(dateString, {
            unit: "minute"
          });
        default:
          return parseNDigits$1(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 0 && value2 <= 59;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCMinutes(value2, 0, 0);
      return date;
    }
  }]);
  return MinuteParser2;
}(Parser$1);
var SecondParser$1 = /* @__PURE__ */ function(_Parser) {
  _inherits$1(SecondParser2, _Parser);
  var _super = _createSuper$1(SecondParser2);
  function SecondParser2() {
    var _this;
    _classCallCheck$1(this, SecondParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "priority", 50);
    _defineProperty$1(_assertThisInitialized$1(_this), "incompatibleTokens", ["t", "T"]);
    return _this;
  }
  _createClass$1(SecondParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "s":
          return parseNumericPattern$1(numericPatterns$1.second, dateString);
        case "so":
          return match2.ordinalNumber(dateString, {
            unit: "second"
          });
        default:
          return parseNDigits$1(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 0 && value2 <= 59;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCSeconds(value2, 0);
      return date;
    }
  }]);
  return SecondParser2;
}(Parser$1);
var FractionOfSecondParser$1 = /* @__PURE__ */ function(_Parser) {
  _inherits$1(FractionOfSecondParser2, _Parser);
  var _super = _createSuper$1(FractionOfSecondParser2);
  function FractionOfSecondParser2() {
    var _this;
    _classCallCheck$1(this, FractionOfSecondParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "priority", 30);
    _defineProperty$1(_assertThisInitialized$1(_this), "incompatibleTokens", ["t", "T"]);
    return _this;
  }
  _createClass$1(FractionOfSecondParser2, [{
    key: "parse",
    value: function parse2(dateString, token2) {
      var valueCallback4 = function valueCallback5(value2) {
        return Math.floor(value2 * Math.pow(10, -token2.length + 3));
      };
      return mapValue$1(parseNDigits$1(token2.length, dateString), valueCallback4);
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCMilliseconds(value2);
      return date;
    }
  }]);
  return FractionOfSecondParser2;
}(Parser$1);
var ISOTimezoneWithZParser$1 = /* @__PURE__ */ function(_Parser) {
  _inherits$1(ISOTimezoneWithZParser2, _Parser);
  var _super = _createSuper$1(ISOTimezoneWithZParser2);
  function ISOTimezoneWithZParser2() {
    var _this;
    _classCallCheck$1(this, ISOTimezoneWithZParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "priority", 10);
    _defineProperty$1(_assertThisInitialized$1(_this), "incompatibleTokens", ["t", "T", "x"]);
    return _this;
  }
  _createClass$1(ISOTimezoneWithZParser2, [{
    key: "parse",
    value: function parse2(dateString, token2) {
      switch (token2) {
        case "X":
          return parseTimezonePattern$1(timezonePatterns$1.basicOptionalMinutes, dateString);
        case "XX":
          return parseTimezonePattern$1(timezonePatterns$1.basic, dateString);
        case "XXXX":
          return parseTimezonePattern$1(timezonePatterns$1.basicOptionalSeconds, dateString);
        case "XXXXX":
          return parseTimezonePattern$1(timezonePatterns$1.extendedOptionalSeconds, dateString);
        case "XXX":
        default:
          return parseTimezonePattern$1(timezonePatterns$1.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set2(date, flags, value2) {
      if (flags.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value2);
    }
  }]);
  return ISOTimezoneWithZParser2;
}(Parser$1);
var ISOTimezoneParser$1 = /* @__PURE__ */ function(_Parser) {
  _inherits$1(ISOTimezoneParser2, _Parser);
  var _super = _createSuper$1(ISOTimezoneParser2);
  function ISOTimezoneParser2() {
    var _this;
    _classCallCheck$1(this, ISOTimezoneParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "priority", 10);
    _defineProperty$1(_assertThisInitialized$1(_this), "incompatibleTokens", ["t", "T", "X"]);
    return _this;
  }
  _createClass$1(ISOTimezoneParser2, [{
    key: "parse",
    value: function parse2(dateString, token2) {
      switch (token2) {
        case "x":
          return parseTimezonePattern$1(timezonePatterns$1.basicOptionalMinutes, dateString);
        case "xx":
          return parseTimezonePattern$1(timezonePatterns$1.basic, dateString);
        case "xxxx":
          return parseTimezonePattern$1(timezonePatterns$1.basicOptionalSeconds, dateString);
        case "xxxxx":
          return parseTimezonePattern$1(timezonePatterns$1.extendedOptionalSeconds, dateString);
        case "xxx":
        default:
          return parseTimezonePattern$1(timezonePatterns$1.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set2(date, flags, value2) {
      if (flags.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value2);
    }
  }]);
  return ISOTimezoneParser2;
}(Parser$1);
var TimestampSecondsParser$1 = /* @__PURE__ */ function(_Parser) {
  _inherits$1(TimestampSecondsParser2, _Parser);
  var _super = _createSuper$1(TimestampSecondsParser2);
  function TimestampSecondsParser2() {
    var _this;
    _classCallCheck$1(this, TimestampSecondsParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "priority", 40);
    _defineProperty$1(_assertThisInitialized$1(_this), "incompatibleTokens", "*");
    return _this;
  }
  _createClass$1(TimestampSecondsParser2, [{
    key: "parse",
    value: function parse2(dateString) {
      return parseAnyDigitsSigned$1(dateString);
    }
  }, {
    key: "set",
    value: function set2(_date, _flags, value2) {
      return [new Date(value2 * 1e3), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampSecondsParser2;
}(Parser$1);
var TimestampMillisecondsParser$1 = /* @__PURE__ */ function(_Parser) {
  _inherits$1(TimestampMillisecondsParser2, _Parser);
  var _super = _createSuper$1(TimestampMillisecondsParser2);
  function TimestampMillisecondsParser2() {
    var _this;
    _classCallCheck$1(this, TimestampMillisecondsParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "priority", 20);
    _defineProperty$1(_assertThisInitialized$1(_this), "incompatibleTokens", "*");
    return _this;
  }
  _createClass$1(TimestampMillisecondsParser2, [{
    key: "parse",
    value: function parse2(dateString) {
      return parseAnyDigitsSigned$1(dateString);
    }
  }, {
    key: "set",
    value: function set2(_date, _flags, value2) {
      return [new Date(value2), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampMillisecondsParser2;
}(Parser$1);
var parsers$1 = {
  G: new EraParser$1(),
  y: new YearParser$1(),
  Y: new LocalWeekYearParser$1(),
  R: new ISOWeekYearParser$1(),
  u: new ExtendedYearParser$1(),
  Q: new QuarterParser$1(),
  q: new StandAloneQuarterParser$1(),
  M: new MonthParser$1(),
  L: new StandAloneMonthParser$1(),
  w: new LocalWeekParser$1(),
  I: new ISOWeekParser$1(),
  d: new DateParser$1(),
  D: new DayOfYearParser$1(),
  E: new DayParser$1(),
  e: new LocalDayParser$1(),
  c: new StandAloneLocalDayParser$1(),
  i: new ISODayParser$1(),
  a: new AMPMParser$1(),
  b: new AMPMMidnightParser$1(),
  B: new DayPeriodParser$1(),
  h: new Hour1to12Parser$1(),
  H: new Hour0to23Parser$1(),
  K: new Hour0To11Parser$1(),
  k: new Hour1To24Parser$1(),
  m: new MinuteParser$1(),
  s: new SecondParser$1(),
  S: new FractionOfSecondParser$1(),
  X: new ISOTimezoneWithZParser$1(),
  x: new ISOTimezoneParser$1(),
  t: new TimestampSecondsParser$1(),
  T: new TimestampMillisecondsParser$1()
};
var formattingTokensRegExp$3 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp$2 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp$3 = /^'([^]*?)'?$/;
var doubleQuoteRegExp$3 = /''/g;
var notWhitespaceRegExp$1 = /\S/;
var unescapedLatinCharacterRegExp$3 = /[a-zA-Z]/;
function parse$1(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs$1(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var defaultOptions2 = getDefaultOptions$1();
  var locale2 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions2.locale) !== null && _ref !== void 0 ? _ref : locale$1;
  if (!locale2.match) {
    throw new RangeError("locale must contain match property");
  }
  var firstWeekContainsDate = toInteger$1((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions2.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var weekStartsOn = toInteger$1((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions2.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions2.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  if (formatString === "") {
    if (dateString === "") {
      return toDate$1(dirtyReferenceDate);
    } else {
      return /* @__PURE__ */ new Date(NaN);
    }
  }
  var subFnOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale2
  };
  var setters = [new DateToSystemTimezoneSetter$1()];
  var tokens = formatString.match(longFormattingTokensRegExp$2).map(function(substring) {
    var firstCharacter = substring[0];
    if (firstCharacter in longFormatters$1) {
      var longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale2.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp$3);
  var usedTokens = [];
  var _iterator = _createForOfIteratorHelper$1(tokens), _step;
  try {
    var _loop = function _loop2() {
      var token2 = _step.value;
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken$1(token2)) {
        throwProtectedError$1(token2, formatString, dirtyDateString);
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken$1(token2)) {
        throwProtectedError$1(token2, formatString, dirtyDateString);
      }
      var firstCharacter = token2[0];
      var parser = parsers$1[firstCharacter];
      if (parser) {
        var incompatibleTokens = parser.incompatibleTokens;
        if (Array.isArray(incompatibleTokens)) {
          var incompatibleToken = usedTokens.find(function(usedToken) {
            return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
          });
          if (incompatibleToken) {
            throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token2, "` at the same time"));
          }
        } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) {
          throw new RangeError("The format string mustn't contain `".concat(token2, "` and any other token at the same time"));
        }
        usedTokens.push({
          token: firstCharacter,
          fullToken: token2
        });
        var parseResult = parser.run(dateString, token2, locale2.match, subFnOptions);
        if (!parseResult) {
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        }
        setters.push(parseResult.setter);
        dateString = parseResult.rest;
      } else {
        if (firstCharacter.match(unescapedLatinCharacterRegExp$3)) {
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        }
        if (token2 === "''") {
          token2 = "'";
        } else if (firstCharacter === "'") {
          token2 = cleanEscapedString$3(token2);
        }
        if (dateString.indexOf(token2) === 0) {
          dateString = dateString.slice(token2.length);
        } else {
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        }
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done; ) {
      var _ret = _loop();
      if (_typeof$1(_ret) === "object") return _ret.v;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (dateString.length > 0 && notWhitespaceRegExp$1.test(dateString)) {
    return /* @__PURE__ */ new Date(NaN);
  }
  var uniquePrioritySetters = setters.map(function(setter2) {
    return setter2.priority;
  }).sort(function(a4, b3) {
    return b3 - a4;
  }).filter(function(priority, index2, array) {
    return array.indexOf(priority) === index2;
  }).map(function(priority) {
    return setters.filter(function(setter2) {
      return setter2.priority === priority;
    }).sort(function(a4, b3) {
      return b3.subPriority - a4.subPriority;
    });
  }).map(function(setterArray) {
    return setterArray[0];
  });
  var date = toDate$1(dirtyReferenceDate);
  if (isNaN(date.getTime())) {
    return /* @__PURE__ */ new Date(NaN);
  }
  var utcDate = subMilliseconds$1(date, getTimezoneOffsetInMilliseconds$1(date));
  var flags = {};
  var _iterator2 = _createForOfIteratorHelper$1(uniquePrioritySetters), _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
      var setter = _step2.value;
      if (!setter.validate(utcDate, subFnOptions)) {
        return /* @__PURE__ */ new Date(NaN);
      }
      var result = setter.set(utcDate, flags, subFnOptions);
      if (Array.isArray(result)) {
        utcDate = result[0];
        assign$2(flags, result[1]);
      } else {
        utcDate = result;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return utcDate;
}
function cleanEscapedString$3(input) {
  return input.match(escapedStringRegExp$3)[1].replace(doubleQuoteRegExp$3, "'");
}
function startOfHour(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date = toDate$1(dirtyDate);
  date.setMinutes(0, 0, 0);
  return date;
}
function startOfSecond(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date = toDate$1(dirtyDate);
  date.setMilliseconds(0);
  return date;
}
function parseISO$1(argument, options) {
  var _options$additionalDi;
  requiredArgs$1(1, arguments);
  var additionalDigits = toInteger$1((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  }
  if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) {
    return /* @__PURE__ */ new Date(NaN);
  }
  var dateStrings = splitDateString$1(argument);
  var date;
  if (dateStrings.date) {
    var parseYearResult = parseYear$1(dateStrings.date, additionalDigits);
    date = parseDate$1(parseYearResult.restDateString, parseYearResult.year);
  }
  if (!date || isNaN(date.getTime())) {
    return /* @__PURE__ */ new Date(NaN);
  }
  var timestamp = date.getTime();
  var time = 0;
  var offset2;
  if (dateStrings.time) {
    time = parseTime$1(dateStrings.time);
    if (isNaN(time)) {
      return /* @__PURE__ */ new Date(NaN);
    }
  }
  if (dateStrings.timezone) {
    offset2 = parseTimezone$1(dateStrings.timezone);
    if (isNaN(offset2)) {
      return /* @__PURE__ */ new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time);
    var result = /* @__PURE__ */ new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }
  return new Date(timestamp + time + offset2);
}
var patterns$1 = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex$1 = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex$1 = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex$1 = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString$1(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns$1.dateTimeDelimiter);
  var timeString;
  if (array.length > 2) {
    return dateStrings;
  }
  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns$1.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns$1.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }
  if (timeString) {
    var token2 = patterns$1.timezone.exec(timeString);
    if (token2) {
      dateStrings.time = timeString.replace(token2[1], "");
      dateStrings.timezone = token2[1];
    } else {
      dateStrings.time = timeString;
    }
  }
  return dateStrings;
}
function parseYear$1(dateString, additionalDigits) {
  var regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
  var captures = dateString.match(regex);
  if (!captures) return {
    year: NaN,
    restDateString: ""
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null;
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}
function parseDate$1(dateString, year) {
  if (year === null) return /* @__PURE__ */ new Date(NaN);
  var captures = dateString.match(dateRegex$1);
  if (!captures) return /* @__PURE__ */ new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit$1(captures[1]);
  var month = parseDateUnit$1(captures[2]) - 1;
  var day = parseDateUnit$1(captures[3]);
  var week = parseDateUnit$1(captures[4]);
  var dayOfWeek = parseDateUnit$1(captures[5]) - 1;
  if (isWeekDate) {
    if (!validateWeekDate$1(year, week, dayOfWeek)) {
      return /* @__PURE__ */ new Date(NaN);
    }
    return dayOfISOWeekYear$1(year, week, dayOfWeek);
  } else {
    var date = /* @__PURE__ */ new Date(0);
    if (!validateDate$1(year, month, day) || !validateDayOfYearDate$1(year, dayOfYear)) {
      return /* @__PURE__ */ new Date(NaN);
    }
    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}
function parseDateUnit$1(value2) {
  return value2 ? parseInt(value2) : 1;
}
function parseTime$1(timeString) {
  var captures = timeString.match(timeRegex$1);
  if (!captures) return NaN;
  var hours = parseTimeUnit$1(captures[1]);
  var minutes = parseTimeUnit$1(captures[2]);
  var seconds = parseTimeUnit$1(captures[3]);
  if (!validateTime$1(hours, minutes, seconds)) {
    return NaN;
  }
  return hours * millisecondsInHour$1 + minutes * millisecondsInMinute$1 + seconds * 1e3;
}
function parseTimeUnit$1(value2) {
  return value2 && parseFloat(value2.replace(",", ".")) || 0;
}
function parseTimezone$1(timezoneString) {
  if (timezoneString === "Z") return 0;
  var captures = timezoneString.match(timezoneRegex$1);
  if (!captures) return 0;
  var sign2 = captures[1] === "+" ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;
  if (!validateTimezone$1(hours, minutes)) {
    return NaN;
  }
  return sign2 * (hours * millisecondsInHour$1 + minutes * millisecondsInMinute$1);
}
function dayOfISOWeekYear$1(isoWeekYear, week, day) {
  var date = /* @__PURE__ */ new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
var daysInMonths$1 = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex$2(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate$1(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths$1[month] || (isLeapYearIndex$2(year) ? 29 : 28));
}
function validateDayOfYearDate$1(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex$2(year) ? 366 : 365);
}
function validateWeekDate$1(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime$1(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }
  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone$1(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}
/*!
 * chartjs-adapter-date-fns v3.0.0
 * https://www.chartjs.org
 * (c) 2022 chartjs-adapter-date-fns Contributors
 * Released under the MIT license
 */
const FORMATS = {
  datetime: "MMM d, yyyy, h:mm:ss aaaa",
  millisecond: "h:mm:ss.SSS aaaa",
  second: "h:mm:ss aaaa",
  minute: "h:mm aaaa",
  hour: "ha",
  day: "MMM d",
  week: "PP",
  month: "MMM yyyy",
  quarter: "qqq - yyyy",
  year: "yyyy"
};
adapters._date.override({
  _id: "date-fns",
  // DEBUG
  formats: function() {
    return FORMATS;
  },
  parse: function(value2, fmt) {
    if (value2 === null || typeof value2 === "undefined") {
      return null;
    }
    const type2 = typeof value2;
    if (type2 === "number" || value2 instanceof Date) {
      value2 = toDate$1(value2);
    } else if (type2 === "string") {
      if (typeof fmt === "string") {
        value2 = parse$1(value2, fmt, /* @__PURE__ */ new Date(), this.options);
      } else {
        value2 = parseISO$1(value2, this.options);
      }
    }
    return isValid$1(value2) ? value2.getTime() : null;
  },
  format: function(time, fmt) {
    return format$1(time, fmt, this.options);
  },
  add: function(time, amount, unit) {
    switch (unit) {
      case "millisecond":
        return addMilliseconds$1(time, amount);
      case "second":
        return addSeconds(time, amount);
      case "minute":
        return addMinutes(time, amount);
      case "hour":
        return addHours(time, amount);
      case "day":
        return addDays$1(time, amount);
      case "week":
        return addWeeks(time, amount);
      case "month":
        return addMonths$1(time, amount);
      case "quarter":
        return addQuarters(time, amount);
      case "year":
        return addYears(time, amount);
      default:
        return time;
    }
  },
  diff: function(max2, min2, unit) {
    switch (unit) {
      case "millisecond":
        return differenceInMilliseconds$1(max2, min2);
      case "second":
        return differenceInSeconds$1(max2, min2);
      case "minute":
        return differenceInMinutes$1(max2, min2);
      case "hour":
        return differenceInHours$1(max2, min2);
      case "day":
        return differenceInDays$1(max2, min2);
      case "week":
        return differenceInWeeks(max2, min2);
      case "month":
        return differenceInMonths$1(max2, min2);
      case "quarter":
        return differenceInQuarters(max2, min2);
      case "year":
        return differenceInYears$1(max2, min2);
      default:
        return 0;
    }
  },
  startOf: function(time, unit, weekday) {
    switch (unit) {
      case "second":
        return startOfSecond(time);
      case "minute":
        return startOfMinute(time);
      case "hour":
        return startOfHour(time);
      case "day":
        return startOfDay$1(time);
      case "week":
        return startOfWeek(time);
      case "isoWeek":
        return startOfWeek(time, { weekStartsOn: +weekday });
      case "month":
        return startOfMonth(time);
      case "quarter":
        return startOfQuarter(time);
      case "year":
        return startOfYear(time);
      default:
        return time;
    }
  },
  endOf: function(time, unit) {
    switch (unit) {
      case "second":
        return endOfSecond(time);
      case "minute":
        return endOfMinute(time);
      case "hour":
        return endOfHour(time);
      case "day":
        return endOfDay$1(time);
      case "week":
        return endOfWeek(time);
      case "month":
        return endOfMonth$1(time);
      case "quarter":
        return endOfQuarter(time);
      case "year":
        return endOfYear(time);
      default:
        return time;
    }
  }
});
const broadcastChannel = new window.BroadcastChannel("pub-sub-es");
const isString$1 = (key) => typeof key === "string";
const getEventName = (eventName, caseInsensitive) => {
  if (isString$1(eventName) && caseInsensitive) {
    return eventName.toLowerCase();
  }
  return eventName;
};
const createSubscribe = (stack2, options) => (event, handler, times = Number.POSITIVE_INFINITY) => {
  const e3 = getEventName(event, options == null ? void 0 : options.caseInsensitive);
  const listeners = stack2[e3] || [];
  listeners.push({
    handler,
    times: +times || Number.POSITIVE_INFINITY
  });
  stack2[e3] = listeners;
  return { event: e3, handler };
};
const isSubscription = (event) => typeof event === "object";
function createUnsubscribe(stack2, options) {
  function unsubscribe(eventOrSubscription, handlerOrUndefined) {
    let event;
    let handler;
    if (isSubscription(eventOrSubscription)) {
      handler = eventOrSubscription.handler;
      event = eventOrSubscription.event;
    } else {
      event = eventOrSubscription;
      handler = handlerOrUndefined;
    }
    const e3 = getEventName(event, options == null ? void 0 : options.caseInsensitive);
    const listeners = stack2[e3];
    if (!listeners) {
      return;
    }
    const idx = listeners.findIndex((listener) => listener.handler === handler);
    if (idx === -1 || idx >= listeners.length) {
      return;
    }
    listeners.splice(idx, 1);
  }
  return unsubscribe;
}
const hasListeners = (listeners) => {
  return Boolean(listeners);
};
const createPublish = (stack2, options) => {
  const unsubscribe = createUnsubscribe(stack2);
  return (...args) => {
    const [event, news, callOptions] = args;
    const eventName = getEventName(event, options == null ? void 0 : options.caseInsensitive);
    const listenersOrUndefined = stack2[eventName];
    if (!hasListeners(listenersOrUndefined)) {
      return;
    }
    const listeners = [...listenersOrUndefined];
    for (const listener of listeners) {
      if (--listener.times < 1) {
        unsubscribe(eventName, listener.handler);
      }
    }
    const isAsync = (callOptions == null ? void 0 : callOptions.async) !== void 0 ? callOptions.async : options == null ? void 0 : options.async;
    const inform = () => {
      for (const listener of listeners) {
        listener.handler(news);
      }
    };
    if (isAsync) {
      setTimeout(inform, 0);
    } else {
      inform();
    }
    if ((options == null ? void 0 : options.isGlobal) && !(callOptions == null ? void 0 : callOptions.isNoGlobalBroadcast)) {
      try {
        broadcastChannel.postMessage({ event: eventName, news });
      } catch (error) {
        if (error instanceof Error && error.name === "DataCloneError") {
          console.warn(`Could not broadcast '${eventName.toString()}' globally. Payload is not clonable.`);
        } else {
          throw error;
        }
      }
    }
  };
};
function keys(obj) {
  return Object.keys(obj);
}
const createClear = (stack2) => () => {
  for (const event of keys(stack2)) {
    delete stack2[event];
  }
};
const createStack = () => ({});
const createPubSub = (options) => {
  const async = Boolean(options == null ? void 0 : options.async);
  const caseInsensitive = Boolean(options == null ? void 0 : options.caseInsensitive);
  const stack2 = (options == null ? void 0 : options.stack) || createStack();
  return {
    publish: createPublish(stack2, { async, caseInsensitive }),
    subscribe: createSubscribe(stack2, { caseInsensitive }),
    unsubscribe: createUnsubscribe(stack2, { caseInsensitive }),
    clear: createClear(stack2),
    stack: stack2
  };
};
const globalPubSubStack = createStack();
const globalPubSub = {
  publish: createPublish(globalPubSubStack, { isGlobal: true }),
  subscribe: createSubscribe(globalPubSubStack),
  unsubscribe: createUnsubscribe(globalPubSubStack),
  clear: createClear(globalPubSubStack),
  stack: globalPubSubStack
};
broadcastChannel.onmessage = ({ data: { event, news } }) => globalPubSub.publish(event, news, { isNoGlobalBroadcast: true });
var commonjsGlobal$1 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs$1(x3) {
  return x3 && x3.__esModule && Object.prototype.hasOwnProperty.call(x3, "default") ? x3["default"] : x3;
}
var regl = { exports: {} };
(function(module, exports) {
  (function(global2, factory) {
    module.exports = factory();
  })(commonjsGlobal$1, function() {
    var isTypedArray = function(x3) {
      return x3 instanceof Uint8Array || x3 instanceof Uint16Array || x3 instanceof Uint32Array || x3 instanceof Int8Array || x3 instanceof Int16Array || x3 instanceof Int32Array || x3 instanceof Float32Array || x3 instanceof Float64Array || x3 instanceof Uint8ClampedArray;
    };
    var extend2 = function(base, opts) {
      var keys2 = Object.keys(opts);
      for (var i3 = 0; i3 < keys2.length; ++i3) {
        base[keys2[i3]] = opts[keys2[i3]];
      }
      return base;
    };
    var endl = "\n";
    function decodeB64(str) {
      if (typeof atob !== "undefined") {
        return atob(str);
      }
      return "base64:" + str;
    }
    function raise(message) {
      var error = new Error("(regl) " + message);
      console.error(error);
      throw error;
    }
    function check(pred, message) {
      if (!pred) {
        raise(message);
      }
    }
    function encolon(message) {
      if (message) {
        return ": " + message;
      }
      return "";
    }
    function checkParameter(param, possibilities, message) {
      if (!(param in possibilities)) {
        raise("unknown parameter (" + param + ")" + encolon(message) + ". possible values: " + Object.keys(possibilities).join());
      }
    }
    function checkIsTypedArray(data, message) {
      if (!isTypedArray(data)) {
        raise(
          "invalid parameter type" + encolon(message) + ". must be a typed array"
        );
      }
    }
    function standardTypeEh(value2, type2) {
      switch (type2) {
        case "number":
          return typeof value2 === "number";
        case "object":
          return typeof value2 === "object";
        case "string":
          return typeof value2 === "string";
        case "boolean":
          return typeof value2 === "boolean";
        case "function":
          return typeof value2 === "function";
        case "undefined":
          return typeof value2 === "undefined";
        case "symbol":
          return typeof value2 === "symbol";
      }
    }
    function checkTypeOf(value2, type2, message) {
      if (!standardTypeEh(value2, type2)) {
        raise(
          "invalid parameter type" + encolon(message) + ". expected " + type2 + ", got " + typeof value2
        );
      }
    }
    function checkNonNegativeInt(value2, message) {
      if (!(value2 >= 0 && (value2 | 0) === value2)) {
        raise("invalid parameter type, (" + value2 + ")" + encolon(message) + ". must be a nonnegative integer");
      }
    }
    function checkOneOf(value2, list, message) {
      if (list.indexOf(value2) < 0) {
        raise("invalid value" + encolon(message) + ". must be one of: " + list);
      }
    }
    var constructorKeys = [
      "gl",
      "canvas",
      "container",
      "attributes",
      "pixelRatio",
      "extensions",
      "optionalExtensions",
      "profile",
      "onDone"
    ];
    function checkConstructor(obj) {
      Object.keys(obj).forEach(function(key) {
        if (constructorKeys.indexOf(key) < 0) {
          raise('invalid regl constructor argument "' + key + '". must be one of ' + constructorKeys);
        }
      });
    }
    function leftPad(str, n) {
      str = str + "";
      while (str.length < n) {
        str = " " + str;
      }
      return str;
    }
    function ShaderFile() {
      this.name = "unknown";
      this.lines = [];
      this.index = {};
      this.hasErrors = false;
    }
    function ShaderLine(number, line2) {
      this.number = number;
      this.line = line2;
      this.errors = [];
    }
    function ShaderError(fileNumber, lineNumber, message) {
      this.file = fileNumber;
      this.line = lineNumber;
      this.message = message;
    }
    function guessCommand() {
      var error = new Error();
      var stack2 = (error.stack || error).toString();
      var pat = /compileProcedure.*\n\s*at.*\((.*)\)/.exec(stack2);
      if (pat) {
        return pat[1];
      }
      var pat2 = /compileProcedure.*\n\s*at\s+(.*)(\n|$)/.exec(stack2);
      if (pat2) {
        return pat2[1];
      }
      return "unknown";
    }
    function guessCallSite() {
      var error = new Error();
      var stack2 = (error.stack || error).toString();
      var pat = /at REGLCommand.*\n\s+at.*\((.*)\)/.exec(stack2);
      if (pat) {
        return pat[1];
      }
      var pat2 = /at REGLCommand.*\n\s+at\s+(.*)\n/.exec(stack2);
      if (pat2) {
        return pat2[1];
      }
      return "unknown";
    }
    function parseSource(source, command) {
      var lines2 = source.split("\n");
      var lineNumber = 1;
      var fileNumber = 0;
      var files = {
        unknown: new ShaderFile(),
        0: new ShaderFile()
      };
      files.unknown.name = files[0].name = command || guessCommand();
      files.unknown.lines.push(new ShaderLine(0, ""));
      for (var i3 = 0; i3 < lines2.length; ++i3) {
        var line2 = lines2[i3];
        var parts = /^\s*#\s*(\w+)\s+(.+)\s*$/.exec(line2);
        if (parts) {
          switch (parts[1]) {
            case "line":
              var lineNumberInfo = /(\d+)(\s+\d+)?/.exec(parts[2]);
              if (lineNumberInfo) {
                lineNumber = lineNumberInfo[1] | 0;
                if (lineNumberInfo[2]) {
                  fileNumber = lineNumberInfo[2] | 0;
                  if (!(fileNumber in files)) {
                    files[fileNumber] = new ShaderFile();
                  }
                }
              }
              break;
            case "define":
              var nameInfo = /SHADER_NAME(_B64)?\s+(.*)$/.exec(parts[2]);
              if (nameInfo) {
                files[fileNumber].name = nameInfo[1] ? decodeB64(nameInfo[2]) : nameInfo[2];
              }
              break;
          }
        }
        files[fileNumber].lines.push(new ShaderLine(lineNumber++, line2));
      }
      Object.keys(files).forEach(function(fileNumber2) {
        var file = files[fileNumber2];
        file.lines.forEach(function(line3) {
          file.index[line3.number] = line3;
        });
      });
      return files;
    }
    function parseErrorLog(errLog) {
      var result = [];
      errLog.split("\n").forEach(function(errMsg) {
        if (errMsg.length < 5) {
          return;
        }
        var parts = /^ERROR:\s+(\d+):(\d+):\s*(.*)$/.exec(errMsg);
        if (parts) {
          result.push(new ShaderError(
            parts[1] | 0,
            parts[2] | 0,
            parts[3].trim()
          ));
        } else if (errMsg.length > 0) {
          result.push(new ShaderError("unknown", 0, errMsg));
        }
      });
      return result;
    }
    function annotateFiles(files, errors) {
      errors.forEach(function(error) {
        var file = files[error.file];
        if (file) {
          var line2 = file.index[error.line];
          if (line2) {
            line2.errors.push(error);
            file.hasErrors = true;
            return;
          }
        }
        files.unknown.hasErrors = true;
        files.unknown.lines[0].errors.push(error);
      });
    }
    function checkShaderError(gl, shader, source, type2, command) {
      if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        var errLog = gl.getShaderInfoLog(shader);
        var typeName = type2 === gl.FRAGMENT_SHADER ? "fragment" : "vertex";
        checkCommandType(source, "string", typeName + " shader source must be a string", command);
        var files = parseSource(source, command);
        var errors = parseErrorLog(errLog);
        annotateFiles(files, errors);
        Object.keys(files).forEach(function(fileNumber) {
          var file = files[fileNumber];
          if (!file.hasErrors) {
            return;
          }
          var strings = [""];
          var styles = [""];
          function push2(str, style) {
            strings.push(str);
            styles.push(style || "");
          }
          push2("file number " + fileNumber + ": " + file.name + "\n", "color:red;text-decoration:underline;font-weight:bold");
          file.lines.forEach(function(line2) {
            if (line2.errors.length > 0) {
              push2(leftPad(line2.number, 4) + "|  ", "background-color:yellow; font-weight:bold");
              push2(line2.line + endl, "color:red; background-color:yellow; font-weight:bold");
              var offset2 = 0;
              line2.errors.forEach(function(error) {
                var message = error.message;
                var token2 = /^\s*'(.*)'\s*:\s*(.*)$/.exec(message);
                if (token2) {
                  var tokenPat = token2[1];
                  message = token2[2];
                  switch (tokenPat) {
                    case "assign":
                      tokenPat = "=";
                      break;
                  }
                  offset2 = Math.max(line2.line.indexOf(tokenPat, offset2), 0);
                } else {
                  offset2 = 0;
                }
                push2(leftPad("| ", 6));
                push2(leftPad("^^^", offset2 + 3) + endl, "font-weight:bold");
                push2(leftPad("| ", 6));
                push2(message + endl, "font-weight:bold");
              });
              push2(leftPad("| ", 6) + endl);
            } else {
              push2(leftPad(line2.number, 4) + "|  ");
              push2(line2.line + endl, "color:red");
            }
          });
          if (typeof document !== "undefined" && !window.chrome) {
            styles[0] = strings.join("%c");
            console.log.apply(console, styles);
          } else {
            console.log(strings.join(""));
          }
        });
        check.raise("Error compiling " + typeName + " shader, " + files[0].name);
      }
    }
    function checkLinkError(gl, program, fragShader, vertShader, command) {
      if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
        var errLog = gl.getProgramInfoLog(program);
        var fragParse = parseSource(fragShader, command);
        var vertParse = parseSource(vertShader, command);
        var header = 'Error linking program with vertex shader, "' + vertParse[0].name + '", and fragment shader "' + fragParse[0].name + '"';
        if (typeof document !== "undefined") {
          console.log(
            "%c" + header + endl + "%c" + errLog,
            "color:red;text-decoration:underline;font-weight:bold",
            "color:red"
          );
        } else {
          console.log(header + endl + errLog);
        }
        check.raise(header);
      }
    }
    function saveCommandRef(object) {
      object._commandRef = guessCommand();
    }
    function saveDrawCommandInfo(opts, uniforms, attributes, stringStore) {
      saveCommandRef(opts);
      function id3(str) {
        if (str) {
          return stringStore.id(str);
        }
        return 0;
      }
      opts._fragId = id3(opts.static.frag);
      opts._vertId = id3(opts.static.vert);
      function addProps(dict, set2) {
        Object.keys(set2).forEach(function(u3) {
          dict[stringStore.id(u3)] = true;
        });
      }
      var uniformSet = opts._uniformSet = {};
      addProps(uniformSet, uniforms.static);
      addProps(uniformSet, uniforms.dynamic);
      var attributeSet = opts._attributeSet = {};
      addProps(attributeSet, attributes.static);
      addProps(attributeSet, attributes.dynamic);
      opts._hasCount = "count" in opts.static || "count" in opts.dynamic || "elements" in opts.static || "elements" in opts.dynamic;
    }
    function commandRaise(message, command) {
      var callSite = guessCallSite();
      raise(message + " in command " + (command || guessCommand()) + (callSite === "unknown" ? "" : " called from " + callSite));
    }
    function checkCommand(pred, message, command) {
      if (!pred) {
        commandRaise(message, command || guessCommand());
      }
    }
    function checkParameterCommand(param, possibilities, message, command) {
      if (!(param in possibilities)) {
        commandRaise(
          "unknown parameter (" + param + ")" + encolon(message) + ". possible values: " + Object.keys(possibilities).join(),
          command || guessCommand()
        );
      }
    }
    function checkCommandType(value2, type2, message, command) {
      if (!standardTypeEh(value2, type2)) {
        commandRaise(
          "invalid parameter type" + encolon(message) + ". expected " + type2 + ", got " + typeof value2,
          command || guessCommand()
        );
      }
    }
    function checkOptional(block) {
      block();
    }
    function checkFramebufferFormat(attachment, texFormats, rbFormats) {
      if (attachment.texture) {
        checkOneOf(
          attachment.texture._texture.internalformat,
          texFormats,
          "unsupported texture format for attachment"
        );
      } else {
        checkOneOf(
          attachment.renderbuffer._renderbuffer.format,
          rbFormats,
          "unsupported renderbuffer format for attachment"
        );
      }
    }
    var GL_CLAMP_TO_EDGE = 33071;
    var GL_NEAREST = 9728;
    var GL_NEAREST_MIPMAP_NEAREST = 9984;
    var GL_LINEAR_MIPMAP_NEAREST = 9985;
    var GL_NEAREST_MIPMAP_LINEAR = 9986;
    var GL_LINEAR_MIPMAP_LINEAR = 9987;
    var GL_BYTE = 5120;
    var GL_UNSIGNED_BYTE = 5121;
    var GL_SHORT = 5122;
    var GL_UNSIGNED_SHORT = 5123;
    var GL_INT = 5124;
    var GL_UNSIGNED_INT = 5125;
    var GL_FLOAT = 5126;
    var GL_UNSIGNED_SHORT_4_4_4_4 = 32819;
    var GL_UNSIGNED_SHORT_5_5_5_1 = 32820;
    var GL_UNSIGNED_SHORT_5_6_5 = 33635;
    var GL_UNSIGNED_INT_24_8_WEBGL = 34042;
    var GL_HALF_FLOAT_OES = 36193;
    var TYPE_SIZE = {};
    TYPE_SIZE[GL_BYTE] = TYPE_SIZE[GL_UNSIGNED_BYTE] = 1;
    TYPE_SIZE[GL_SHORT] = TYPE_SIZE[GL_UNSIGNED_SHORT] = TYPE_SIZE[GL_HALF_FLOAT_OES] = TYPE_SIZE[GL_UNSIGNED_SHORT_5_6_5] = TYPE_SIZE[GL_UNSIGNED_SHORT_4_4_4_4] = TYPE_SIZE[GL_UNSIGNED_SHORT_5_5_5_1] = 2;
    TYPE_SIZE[GL_INT] = TYPE_SIZE[GL_UNSIGNED_INT] = TYPE_SIZE[GL_FLOAT] = TYPE_SIZE[GL_UNSIGNED_INT_24_8_WEBGL] = 4;
    function pixelSize(type2, channels) {
      if (type2 === GL_UNSIGNED_SHORT_5_5_5_1 || type2 === GL_UNSIGNED_SHORT_4_4_4_4 || type2 === GL_UNSIGNED_SHORT_5_6_5) {
        return 2;
      } else if (type2 === GL_UNSIGNED_INT_24_8_WEBGL) {
        return 4;
      } else {
        return TYPE_SIZE[type2] * channels;
      }
    }
    function isPow2(v) {
      return !(v & v - 1) && !!v;
    }
    function checkTexture2D(info, mipData, limits) {
      var i3;
      var w3 = mipData.width;
      var h6 = mipData.height;
      var c3 = mipData.channels;
      check(
        w3 > 0 && w3 <= limits.maxTextureSize && h6 > 0 && h6 <= limits.maxTextureSize,
        "invalid texture shape"
      );
      if (info.wrapS !== GL_CLAMP_TO_EDGE || info.wrapT !== GL_CLAMP_TO_EDGE) {
        check(
          isPow2(w3) && isPow2(h6),
          "incompatible wrap mode for texture, both width and height must be power of 2"
        );
      }
      if (mipData.mipmask === 1) {
        if (w3 !== 1 && h6 !== 1) {
          check(
            info.minFilter !== GL_NEAREST_MIPMAP_NEAREST && info.minFilter !== GL_NEAREST_MIPMAP_LINEAR && info.minFilter !== GL_LINEAR_MIPMAP_NEAREST && info.minFilter !== GL_LINEAR_MIPMAP_LINEAR,
            "min filter requires mipmap"
          );
        }
      } else {
        check(
          isPow2(w3) && isPow2(h6),
          "texture must be a square power of 2 to support mipmapping"
        );
        check(
          mipData.mipmask === (w3 << 1) - 1,
          "missing or incomplete mipmap data"
        );
      }
      if (mipData.type === GL_FLOAT) {
        if (limits.extensions.indexOf("oes_texture_float_linear") < 0) {
          check(
            info.minFilter === GL_NEAREST && info.magFilter === GL_NEAREST,
            "filter not supported, must enable oes_texture_float_linear"
          );
        }
        check(
          !info.genMipmaps,
          "mipmap generation not supported with float textures"
        );
      }
      var mipimages = mipData.images;
      for (i3 = 0; i3 < 16; ++i3) {
        if (mipimages[i3]) {
          var mw = w3 >> i3;
          var mh = h6 >> i3;
          check(mipData.mipmask & 1 << i3, "missing mipmap data");
          var img = mipimages[i3];
          check(
            img.width === mw && img.height === mh,
            "invalid shape for mip images"
          );
          check(
            img.format === mipData.format && img.internalformat === mipData.internalformat && img.type === mipData.type,
            "incompatible type for mip image"
          );
          if (img.compressed) ;
          else if (img.data) {
            var rowSize = Math.ceil(pixelSize(img.type, c3) * mw / img.unpackAlignment) * img.unpackAlignment;
            check(
              img.data.byteLength === rowSize * mh,
              "invalid data for image, buffer size is inconsistent with image format"
            );
          } else if (img.element) ;
          else if (img.copy) ;
        } else if (!info.genMipmaps) {
          check((mipData.mipmask & 1 << i3) === 0, "extra mipmap data");
        }
      }
      if (mipData.compressed) {
        check(
          !info.genMipmaps,
          "mipmap generation for compressed images not supported"
        );
      }
    }
    function checkTextureCube(texture, info, faces, limits) {
      var w3 = texture.width;
      var h6 = texture.height;
      var c3 = texture.channels;
      check(
        w3 > 0 && w3 <= limits.maxTextureSize && h6 > 0 && h6 <= limits.maxTextureSize,
        "invalid texture shape"
      );
      check(
        w3 === h6,
        "cube map must be square"
      );
      check(
        info.wrapS === GL_CLAMP_TO_EDGE && info.wrapT === GL_CLAMP_TO_EDGE,
        "wrap mode not supported by cube map"
      );
      for (var i3 = 0; i3 < faces.length; ++i3) {
        var face = faces[i3];
        check(
          face.width === w3 && face.height === h6,
          "inconsistent cube map face shape"
        );
        if (info.genMipmaps) {
          check(
            !face.compressed,
            "can not generate mipmap for compressed textures"
          );
          check(
            face.mipmask === 1,
            "can not specify mipmaps and generate mipmaps"
          );
        }
        var mipmaps = face.images;
        for (var j = 0; j < 16; ++j) {
          var img = mipmaps[j];
          if (img) {
            var mw = w3 >> j;
            var mh = h6 >> j;
            check(face.mipmask & 1 << j, "missing mipmap data");
            check(
              img.width === mw && img.height === mh,
              "invalid shape for mip images"
            );
            check(
              img.format === texture.format && img.internalformat === texture.internalformat && img.type === texture.type,
              "incompatible type for mip image"
            );
            if (img.compressed) ;
            else if (img.data) {
              check(
                img.data.byteLength === mw * mh * Math.max(pixelSize(img.type, c3), img.unpackAlignment),
                "invalid data for image, buffer size is inconsistent with image format"
              );
            } else if (img.element) ;
            else if (img.copy) ;
          }
        }
      }
    }
    var check$1 = extend2(check, {
      optional: checkOptional,
      raise,
      commandRaise,
      command: checkCommand,
      parameter: checkParameter,
      commandParameter: checkParameterCommand,
      constructor: checkConstructor,
      type: checkTypeOf,
      commandType: checkCommandType,
      isTypedArray: checkIsTypedArray,
      nni: checkNonNegativeInt,
      oneOf: checkOneOf,
      shaderError: checkShaderError,
      linkError: checkLinkError,
      callSite: guessCallSite,
      saveCommandRef,
      saveDrawInfo: saveDrawCommandInfo,
      framebufferFormat: checkFramebufferFormat,
      guessCommand,
      texture2D: checkTexture2D,
      textureCube: checkTextureCube
    });
    var VARIABLE_COUNTER = 0;
    var DYN_FUNC = 0;
    var DYN_CONSTANT = 5;
    var DYN_ARRAY = 6;
    function DynamicVariable(type2, data) {
      this.id = VARIABLE_COUNTER++;
      this.type = type2;
      this.data = data;
    }
    function escapeStr(str) {
      return str.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
    }
    function splitParts(str) {
      if (str.length === 0) {
        return [];
      }
      var firstChar = str.charAt(0);
      var lastChar = str.charAt(str.length - 1);
      if (str.length > 1 && firstChar === lastChar && (firstChar === '"' || firstChar === "'")) {
        return ['"' + escapeStr(str.substr(1, str.length - 2)) + '"'];
      }
      var parts = /\[(false|true|null|\d+|'[^']*'|"[^"]*")\]/.exec(str);
      if (parts) {
        return splitParts(str.substr(0, parts.index)).concat(splitParts(parts[1])).concat(splitParts(str.substr(parts.index + parts[0].length)));
      }
      var subparts = str.split(".");
      if (subparts.length === 1) {
        return ['"' + escapeStr(str) + '"'];
      }
      var result = [];
      for (var i3 = 0; i3 < subparts.length; ++i3) {
        result = result.concat(splitParts(subparts[i3]));
      }
      return result;
    }
    function toAccessorString(str) {
      return "[" + splitParts(str).join("][") + "]";
    }
    function defineDynamic(type2, data) {
      return new DynamicVariable(type2, toAccessorString(data + ""));
    }
    function isDynamic(x3) {
      return typeof x3 === "function" && !x3._reglType || x3 instanceof DynamicVariable;
    }
    function unbox(x3, path) {
      if (typeof x3 === "function") {
        return new DynamicVariable(DYN_FUNC, x3);
      } else if (typeof x3 === "number" || typeof x3 === "boolean") {
        return new DynamicVariable(DYN_CONSTANT, x3);
      } else if (Array.isArray(x3)) {
        return new DynamicVariable(DYN_ARRAY, x3.map(function(y4, i3) {
          return unbox(y4, path + "[" + i3 + "]");
        }));
      } else if (x3 instanceof DynamicVariable) {
        return x3;
      }
      check$1(false, "invalid option type in uniform " + path);
    }
    var dynamic = {
      DynamicVariable,
      define: defineDynamic,
      isDynamic,
      unbox,
      accessor: toAccessorString
    };
    var raf = {
      next: typeof requestAnimationFrame === "function" ? function(cb) {
        return requestAnimationFrame(cb);
      } : function(cb) {
        return setTimeout(cb, 16);
      },
      cancel: typeof cancelAnimationFrame === "function" ? function(raf2) {
        return cancelAnimationFrame(raf2);
      } : clearTimeout
    };
    var clock = typeof performance !== "undefined" && performance.now ? function() {
      return performance.now();
    } : function() {
      return +/* @__PURE__ */ new Date();
    };
    function createStringStore() {
      var stringIds = { "": 0 };
      var stringValues = [""];
      return {
        id: function(str) {
          var result = stringIds[str];
          if (result) {
            return result;
          }
          result = stringIds[str] = stringValues.length;
          stringValues.push(str);
          return result;
        },
        str: function(id3) {
          return stringValues[id3];
        }
      };
    }
    function createCanvas(element, onDone, pixelRatio) {
      var canvas = document.createElement("canvas");
      extend2(canvas.style, {
        border: 0,
        margin: 0,
        padding: 0,
        top: 0,
        left: 0,
        width: "100%",
        height: "100%"
      });
      element.appendChild(canvas);
      if (element === document.body) {
        canvas.style.position = "absolute";
        extend2(element.style, {
          margin: 0,
          padding: 0
        });
      }
      function resize() {
        var w3 = window.innerWidth;
        var h6 = window.innerHeight;
        if (element !== document.body) {
          var bounds = canvas.getBoundingClientRect();
          w3 = bounds.right - bounds.left;
          h6 = bounds.bottom - bounds.top;
        }
        canvas.width = pixelRatio * w3;
        canvas.height = pixelRatio * h6;
      }
      var resizeObserver;
      if (element !== document.body && typeof ResizeObserver === "function") {
        resizeObserver = new ResizeObserver(function() {
          setTimeout(resize);
        });
        resizeObserver.observe(element);
      } else {
        window.addEventListener("resize", resize, false);
      }
      function onDestroy() {
        if (resizeObserver) {
          resizeObserver.disconnect();
        } else {
          window.removeEventListener("resize", resize);
        }
        element.removeChild(canvas);
      }
      resize();
      return {
        canvas,
        onDestroy
      };
    }
    function createContext2(canvas, contextAttributes) {
      function get2(name2) {
        try {
          return canvas.getContext(name2, contextAttributes);
        } catch (e3) {
          return null;
        }
      }
      return get2("webgl") || get2("experimental-webgl") || get2("webgl-experimental");
    }
    function isHTMLElement(obj) {
      return typeof obj.nodeName === "string" && typeof obj.appendChild === "function" && typeof obj.getBoundingClientRect === "function";
    }
    function isWebGLContext(obj) {
      return typeof obj.drawArrays === "function" || typeof obj.drawElements === "function";
    }
    function parseExtensions(input) {
      if (typeof input === "string") {
        return input.split();
      }
      check$1(Array.isArray(input), "invalid extension array");
      return input;
    }
    function getElement3(desc) {
      if (typeof desc === "string") {
        check$1(typeof document !== "undefined", "not supported outside of DOM");
        return document.querySelector(desc);
      }
      return desc;
    }
    function parseArgs(args_) {
      var args = args_ || {};
      var element, container, canvas, gl;
      var contextAttributes = {};
      var extensions = [];
      var optionalExtensions = [];
      var pixelRatio = typeof window === "undefined" ? 1 : window.devicePixelRatio;
      var profile = false;
      var onDone = function(err) {
        if (err) {
          check$1.raise(err);
        }
      };
      var onDestroy = function() {
      };
      if (typeof args === "string") {
        check$1(
          typeof document !== "undefined",
          "selector queries only supported in DOM environments"
        );
        element = document.querySelector(args);
        check$1(element, "invalid query string for element");
      } else if (typeof args === "object") {
        if (isHTMLElement(args)) {
          element = args;
        } else if (isWebGLContext(args)) {
          gl = args;
          canvas = gl.canvas;
        } else {
          check$1.constructor(args);
          if ("gl" in args) {
            gl = args.gl;
          } else if ("canvas" in args) {
            canvas = getElement3(args.canvas);
          } else if ("container" in args) {
            container = getElement3(args.container);
          }
          if ("attributes" in args) {
            contextAttributes = args.attributes;
            check$1.type(contextAttributes, "object", "invalid context attributes");
          }
          if ("extensions" in args) {
            extensions = parseExtensions(args.extensions);
          }
          if ("optionalExtensions" in args) {
            optionalExtensions = parseExtensions(args.optionalExtensions);
          }
          if ("onDone" in args) {
            check$1.type(
              args.onDone,
              "function",
              "invalid or missing onDone callback"
            );
            onDone = args.onDone;
          }
          if ("profile" in args) {
            profile = !!args.profile;
          }
          if ("pixelRatio" in args) {
            pixelRatio = +args.pixelRatio;
            check$1(pixelRatio > 0, "invalid pixel ratio");
          }
        }
      } else {
        check$1.raise("invalid arguments to regl");
      }
      if (element) {
        if (element.nodeName.toLowerCase() === "canvas") {
          canvas = element;
        } else {
          container = element;
        }
      }
      if (!gl) {
        if (!canvas) {
          check$1(
            typeof document !== "undefined",
            "must manually specify webgl context outside of DOM environments"
          );
          var result = createCanvas(container || document.body, onDone, pixelRatio);
          if (!result) {
            return null;
          }
          canvas = result.canvas;
          onDestroy = result.onDestroy;
        }
        if (contextAttributes.premultipliedAlpha === void 0) contextAttributes.premultipliedAlpha = true;
        gl = createContext2(canvas, contextAttributes);
      }
      if (!gl) {
        onDestroy();
        onDone("webgl not supported, try upgrading your browser or graphics drivers http://get.webgl.org");
        return null;
      }
      return {
        gl,
        canvas,
        container,
        extensions,
        optionalExtensions,
        pixelRatio,
        profile,
        onDone,
        onDestroy
      };
    }
    function createExtensionCache(gl, config) {
      var extensions = {};
      function tryLoadExtension(name_) {
        check$1.type(name_, "string", "extension name must be string");
        var name3 = name_.toLowerCase();
        var ext;
        try {
          ext = extensions[name3] = gl.getExtension(name3);
        } catch (e3) {
        }
        return !!ext;
      }
      for (var i3 = 0; i3 < config.extensions.length; ++i3) {
        var name2 = config.extensions[i3];
        if (!tryLoadExtension(name2)) {
          config.onDestroy();
          config.onDone('"' + name2 + '" extension is not supported by the current WebGL context, try upgrading your system or a different browser');
          return null;
        }
      }
      config.optionalExtensions.forEach(tryLoadExtension);
      return {
        extensions,
        restore: function() {
          Object.keys(extensions).forEach(function(name3) {
            if (extensions[name3] && !tryLoadExtension(name3)) {
              throw new Error("(regl): error restoring extension " + name3);
            }
          });
        }
      };
    }
    function loop(n, f) {
      var result = Array(n);
      for (var i3 = 0; i3 < n; ++i3) {
        result[i3] = f(i3);
      }
      return result;
    }
    var GL_BYTE$1 = 5120;
    var GL_UNSIGNED_BYTE$2 = 5121;
    var GL_SHORT$1 = 5122;
    var GL_UNSIGNED_SHORT$1 = 5123;
    var GL_INT$1 = 5124;
    var GL_UNSIGNED_INT$1 = 5125;
    var GL_FLOAT$2 = 5126;
    function nextPow16(v) {
      for (var i3 = 16; i3 <= 1 << 28; i3 *= 16) {
        if (v <= i3) {
          return i3;
        }
      }
      return 0;
    }
    function log2(v) {
      var r, shift;
      r = (v > 65535) << 4;
      v >>>= r;
      shift = (v > 255) << 3;
      v >>>= shift;
      r |= shift;
      shift = (v > 15) << 2;
      v >>>= shift;
      r |= shift;
      shift = (v > 3) << 1;
      v >>>= shift;
      r |= shift;
      return r | v >> 1;
    }
    function createPool() {
      var bufferPool = loop(8, function() {
        return [];
      });
      function alloc(n) {
        var sz = nextPow16(n);
        var bin = bufferPool[log2(sz) >> 2];
        if (bin.length > 0) {
          return bin.pop();
        }
        return new ArrayBuffer(sz);
      }
      function free(buf2) {
        bufferPool[log2(buf2.byteLength) >> 2].push(buf2);
      }
      function allocType(type2, n) {
        var result = null;
        switch (type2) {
          case GL_BYTE$1:
            result = new Int8Array(alloc(n), 0, n);
            break;
          case GL_UNSIGNED_BYTE$2:
            result = new Uint8Array(alloc(n), 0, n);
            break;
          case GL_SHORT$1:
            result = new Int16Array(alloc(2 * n), 0, n);
            break;
          case GL_UNSIGNED_SHORT$1:
            result = new Uint16Array(alloc(2 * n), 0, n);
            break;
          case GL_INT$1:
            result = new Int32Array(alloc(4 * n), 0, n);
            break;
          case GL_UNSIGNED_INT$1:
            result = new Uint32Array(alloc(4 * n), 0, n);
            break;
          case GL_FLOAT$2:
            result = new Float32Array(alloc(4 * n), 0, n);
            break;
          default:
            return null;
        }
        if (result.length !== n) {
          return result.subarray(0, n);
        }
        return result;
      }
      function freeType(array) {
        free(array.buffer);
      }
      return {
        alloc,
        free,
        allocType,
        freeType
      };
    }
    var pool = createPool();
    pool.zero = createPool();
    var GL_SUBPIXEL_BITS = 3408;
    var GL_RED_BITS = 3410;
    var GL_GREEN_BITS = 3411;
    var GL_BLUE_BITS = 3412;
    var GL_ALPHA_BITS = 3413;
    var GL_DEPTH_BITS = 3414;
    var GL_STENCIL_BITS = 3415;
    var GL_ALIASED_POINT_SIZE_RANGE = 33901;
    var GL_ALIASED_LINE_WIDTH_RANGE = 33902;
    var GL_MAX_TEXTURE_SIZE = 3379;
    var GL_MAX_VIEWPORT_DIMS = 3386;
    var GL_MAX_VERTEX_ATTRIBS = 34921;
    var GL_MAX_VERTEX_UNIFORM_VECTORS = 36347;
    var GL_MAX_VARYING_VECTORS = 36348;
    var GL_MAX_COMBINED_TEXTURE_IMAGE_UNITS = 35661;
    var GL_MAX_VERTEX_TEXTURE_IMAGE_UNITS = 35660;
    var GL_MAX_TEXTURE_IMAGE_UNITS = 34930;
    var GL_MAX_FRAGMENT_UNIFORM_VECTORS = 36349;
    var GL_MAX_CUBE_MAP_TEXTURE_SIZE = 34076;
    var GL_MAX_RENDERBUFFER_SIZE = 34024;
    var GL_VENDOR = 7936;
    var GL_RENDERER = 7937;
    var GL_VERSION = 7938;
    var GL_SHADING_LANGUAGE_VERSION = 35724;
    var GL_MAX_TEXTURE_MAX_ANISOTROPY_EXT = 34047;
    var GL_MAX_COLOR_ATTACHMENTS_WEBGL = 36063;
    var GL_MAX_DRAW_BUFFERS_WEBGL = 34852;
    var GL_TEXTURE_2D = 3553;
    var GL_TEXTURE_CUBE_MAP = 34067;
    var GL_TEXTURE_CUBE_MAP_POSITIVE_X = 34069;
    var GL_TEXTURE0 = 33984;
    var GL_RGBA = 6408;
    var GL_FLOAT$1 = 5126;
    var GL_UNSIGNED_BYTE$1 = 5121;
    var GL_FRAMEBUFFER = 36160;
    var GL_FRAMEBUFFER_COMPLETE = 36053;
    var GL_COLOR_ATTACHMENT0 = 36064;
    var GL_COLOR_BUFFER_BIT$1 = 16384;
    var wrapLimits = function(gl, extensions) {
      var maxAnisotropic = 1;
      if (extensions.ext_texture_filter_anisotropic) {
        maxAnisotropic = gl.getParameter(GL_MAX_TEXTURE_MAX_ANISOTROPY_EXT);
      }
      var maxDrawbuffers = 1;
      var maxColorAttachments = 1;
      if (extensions.webgl_draw_buffers) {
        maxDrawbuffers = gl.getParameter(GL_MAX_DRAW_BUFFERS_WEBGL);
        maxColorAttachments = gl.getParameter(GL_MAX_COLOR_ATTACHMENTS_WEBGL);
      }
      var readFloat = !!extensions.oes_texture_float;
      if (readFloat) {
        var readFloatTexture = gl.createTexture();
        gl.bindTexture(GL_TEXTURE_2D, readFloatTexture);
        gl.texImage2D(GL_TEXTURE_2D, 0, GL_RGBA, 1, 1, 0, GL_RGBA, GL_FLOAT$1, null);
        var fbo = gl.createFramebuffer();
        gl.bindFramebuffer(GL_FRAMEBUFFER, fbo);
        gl.framebufferTexture2D(GL_FRAMEBUFFER, GL_COLOR_ATTACHMENT0, GL_TEXTURE_2D, readFloatTexture, 0);
        gl.bindTexture(GL_TEXTURE_2D, null);
        if (gl.checkFramebufferStatus(GL_FRAMEBUFFER) !== GL_FRAMEBUFFER_COMPLETE) readFloat = false;
        else {
          gl.viewport(0, 0, 1, 1);
          gl.clearColor(1, 0, 0, 1);
          gl.clear(GL_COLOR_BUFFER_BIT$1);
          var pixels = pool.allocType(GL_FLOAT$1, 4);
          gl.readPixels(0, 0, 1, 1, GL_RGBA, GL_FLOAT$1, pixels);
          if (gl.getError()) readFloat = false;
          else {
            gl.deleteFramebuffer(fbo);
            gl.deleteTexture(readFloatTexture);
            readFloat = pixels[0] === 1;
          }
          pool.freeType(pixels);
        }
      }
      var isIE = typeof navigator !== "undefined" && (/MSIE/.test(navigator.userAgent) || /Trident\//.test(navigator.appVersion) || /Edge/.test(navigator.userAgent));
      var npotTextureCube = true;
      if (!isIE) {
        var cubeTexture = gl.createTexture();
        var data = pool.allocType(GL_UNSIGNED_BYTE$1, 36);
        gl.activeTexture(GL_TEXTURE0);
        gl.bindTexture(GL_TEXTURE_CUBE_MAP, cubeTexture);
        gl.texImage2D(GL_TEXTURE_CUBE_MAP_POSITIVE_X, 0, GL_RGBA, 3, 3, 0, GL_RGBA, GL_UNSIGNED_BYTE$1, data);
        pool.freeType(data);
        gl.bindTexture(GL_TEXTURE_CUBE_MAP, null);
        gl.deleteTexture(cubeTexture);
        npotTextureCube = !gl.getError();
      }
      return {
        // drawing buffer bit depth
        colorBits: [
          gl.getParameter(GL_RED_BITS),
          gl.getParameter(GL_GREEN_BITS),
          gl.getParameter(GL_BLUE_BITS),
          gl.getParameter(GL_ALPHA_BITS)
        ],
        depthBits: gl.getParameter(GL_DEPTH_BITS),
        stencilBits: gl.getParameter(GL_STENCIL_BITS),
        subpixelBits: gl.getParameter(GL_SUBPIXEL_BITS),
        // supported extensions
        extensions: Object.keys(extensions).filter(function(ext) {
          return !!extensions[ext];
        }),
        // max aniso samples
        maxAnisotropic,
        // max draw buffers
        maxDrawbuffers,
        maxColorAttachments,
        // point and line size ranges
        pointSizeDims: gl.getParameter(GL_ALIASED_POINT_SIZE_RANGE),
        lineWidthDims: gl.getParameter(GL_ALIASED_LINE_WIDTH_RANGE),
        maxViewportDims: gl.getParameter(GL_MAX_VIEWPORT_DIMS),
        maxCombinedTextureUnits: gl.getParameter(GL_MAX_COMBINED_TEXTURE_IMAGE_UNITS),
        maxCubeMapSize: gl.getParameter(GL_MAX_CUBE_MAP_TEXTURE_SIZE),
        maxRenderbufferSize: gl.getParameter(GL_MAX_RENDERBUFFER_SIZE),
        maxTextureUnits: gl.getParameter(GL_MAX_TEXTURE_IMAGE_UNITS),
        maxTextureSize: gl.getParameter(GL_MAX_TEXTURE_SIZE),
        maxAttributes: gl.getParameter(GL_MAX_VERTEX_ATTRIBS),
        maxVertexUniforms: gl.getParameter(GL_MAX_VERTEX_UNIFORM_VECTORS),
        maxVertexTextureUnits: gl.getParameter(GL_MAX_VERTEX_TEXTURE_IMAGE_UNITS),
        maxVaryingVectors: gl.getParameter(GL_MAX_VARYING_VECTORS),
        maxFragmentUniforms: gl.getParameter(GL_MAX_FRAGMENT_UNIFORM_VECTORS),
        // vendor info
        glsl: gl.getParameter(GL_SHADING_LANGUAGE_VERSION),
        renderer: gl.getParameter(GL_RENDERER),
        vendor: gl.getParameter(GL_VENDOR),
        version: gl.getParameter(GL_VERSION),
        // quirks
        readFloat,
        npotTextureCube
      };
    };
    function isNDArrayLike(obj) {
      return !!obj && typeof obj === "object" && Array.isArray(obj.shape) && Array.isArray(obj.stride) && typeof obj.offset === "number" && obj.shape.length === obj.stride.length && (Array.isArray(obj.data) || isTypedArray(obj.data));
    }
    var values = function(obj) {
      return Object.keys(obj).map(function(key) {
        return obj[key];
      });
    };
    var flattenUtils = {
      shape: arrayShape$1,
      flatten: flattenArray
    };
    function flatten1D(array, nx, out) {
      for (var i3 = 0; i3 < nx; ++i3) {
        out[i3] = array[i3];
      }
    }
    function flatten2D(array, nx, ny, out) {
      var ptr = 0;
      for (var i3 = 0; i3 < nx; ++i3) {
        var row = array[i3];
        for (var j = 0; j < ny; ++j) {
          out[ptr++] = row[j];
        }
      }
    }
    function flatten3D(array, nx, ny, nz, out, ptr_) {
      var ptr = ptr_;
      for (var i3 = 0; i3 < nx; ++i3) {
        var row = array[i3];
        for (var j = 0; j < ny; ++j) {
          var col = row[j];
          for (var k3 = 0; k3 < nz; ++k3) {
            out[ptr++] = col[k3];
          }
        }
      }
    }
    function flattenRec(array, shape, level, out, ptr) {
      var stride = 1;
      for (var i3 = level + 1; i3 < shape.length; ++i3) {
        stride *= shape[i3];
      }
      var n = shape[level];
      if (shape.length - level === 4) {
        var nx = shape[level + 1];
        var ny = shape[level + 2];
        var nz = shape[level + 3];
        for (i3 = 0; i3 < n; ++i3) {
          flatten3D(array[i3], nx, ny, nz, out, ptr);
          ptr += stride;
        }
      } else {
        for (i3 = 0; i3 < n; ++i3) {
          flattenRec(array[i3], shape, level + 1, out, ptr);
          ptr += stride;
        }
      }
    }
    function flattenArray(array, shape, type2, out_) {
      var sz = 1;
      if (shape.length) {
        for (var i3 = 0; i3 < shape.length; ++i3) {
          sz *= shape[i3];
        }
      } else {
        sz = 0;
      }
      var out = out_ || pool.allocType(type2, sz);
      switch (shape.length) {
        case 0:
          break;
        case 1:
          flatten1D(array, shape[0], out);
          break;
        case 2:
          flatten2D(array, shape[0], shape[1], out);
          break;
        case 3:
          flatten3D(array, shape[0], shape[1], shape[2], out, 0);
          break;
        default:
          flattenRec(array, shape, 0, out, 0);
      }
      return out;
    }
    function arrayShape$1(array_) {
      var shape = [];
      for (var array = array_; array.length; array = array[0]) {
        shape.push(array.length);
      }
      return shape;
    }
    var arrayTypes = {
      "[object Int8Array]": 5120,
      "[object Int16Array]": 5122,
      "[object Int32Array]": 5124,
      "[object Uint8Array]": 5121,
      "[object Uint8ClampedArray]": 5121,
      "[object Uint16Array]": 5123,
      "[object Uint32Array]": 5125,
      "[object Float32Array]": 5126,
      "[object Float64Array]": 5121,
      "[object ArrayBuffer]": 5121
    };
    var int8 = 5120;
    var int16 = 5122;
    var int32 = 5124;
    var uint8 = 5121;
    var uint16 = 5123;
    var uint32 = 5125;
    var float = 5126;
    var float32 = 5126;
    var glTypes = {
      int8,
      int16,
      int32,
      uint8,
      uint16,
      uint32,
      float,
      float32
    };
    var dynamic$1 = 35048;
    var stream = 35040;
    var usageTypes = {
      dynamic: dynamic$1,
      stream,
      "static": 35044
    };
    var arrayFlatten = flattenUtils.flatten;
    var arrayShape = flattenUtils.shape;
    var GL_STATIC_DRAW = 35044;
    var GL_STREAM_DRAW = 35040;
    var GL_UNSIGNED_BYTE$3 = 5121;
    var GL_FLOAT$3 = 5126;
    var DTYPES_SIZES = [];
    DTYPES_SIZES[5120] = 1;
    DTYPES_SIZES[5122] = 2;
    DTYPES_SIZES[5124] = 4;
    DTYPES_SIZES[5121] = 1;
    DTYPES_SIZES[5123] = 2;
    DTYPES_SIZES[5125] = 4;
    DTYPES_SIZES[5126] = 4;
    function typedArrayCode(data) {
      return arrayTypes[Object.prototype.toString.call(data)] | 0;
    }
    function copyArray(out, inp) {
      for (var i3 = 0; i3 < inp.length; ++i3) {
        out[i3] = inp[i3];
      }
    }
    function transpose(result, data, shapeX, shapeY, strideX, strideY, offset2) {
      var ptr = 0;
      for (var i3 = 0; i3 < shapeX; ++i3) {
        for (var j = 0; j < shapeY; ++j) {
          result[ptr++] = data[strideX * i3 + strideY * j + offset2];
        }
      }
    }
    function wrapBufferState(gl, stats2, config, destroyBuffer) {
      var bufferCount = 0;
      var bufferSet = {};
      function REGLBuffer(type2) {
        this.id = bufferCount++;
        this.buffer = gl.createBuffer();
        this.type = type2;
        this.usage = GL_STATIC_DRAW;
        this.byteLength = 0;
        this.dimension = 1;
        this.dtype = GL_UNSIGNED_BYTE$3;
        this.persistentData = null;
        if (config.profile) {
          this.stats = { size: 0 };
        }
      }
      REGLBuffer.prototype.bind = function() {
        gl.bindBuffer(this.type, this.buffer);
      };
      REGLBuffer.prototype.destroy = function() {
        destroy3(this);
      };
      var streamPool = [];
      function createStream(type2, data) {
        var buffer = streamPool.pop();
        if (!buffer) {
          buffer = new REGLBuffer(type2);
        }
        buffer.bind();
        initBufferFromData(buffer, data, GL_STREAM_DRAW, 0, 1, false);
        return buffer;
      }
      function destroyStream(stream$$1) {
        streamPool.push(stream$$1);
      }
      function initBufferFromTypedArray(buffer, data, usage) {
        buffer.byteLength = data.byteLength;
        gl.bufferData(buffer.type, data, usage);
      }
      function initBufferFromData(buffer, data, usage, dtype, dimension, persist) {
        var shape;
        buffer.usage = usage;
        if (Array.isArray(data)) {
          buffer.dtype = dtype || GL_FLOAT$3;
          if (data.length > 0) {
            var flatData;
            if (Array.isArray(data[0])) {
              shape = arrayShape(data);
              var dim = 1;
              for (var i3 = 1; i3 < shape.length; ++i3) {
                dim *= shape[i3];
              }
              buffer.dimension = dim;
              flatData = arrayFlatten(data, shape, buffer.dtype);
              initBufferFromTypedArray(buffer, flatData, usage);
              if (persist) {
                buffer.persistentData = flatData;
              } else {
                pool.freeType(flatData);
              }
            } else if (typeof data[0] === "number") {
              buffer.dimension = dimension;
              var typedData = pool.allocType(buffer.dtype, data.length);
              copyArray(typedData, data);
              initBufferFromTypedArray(buffer, typedData, usage);
              if (persist) {
                buffer.persistentData = typedData;
              } else {
                pool.freeType(typedData);
              }
            } else if (isTypedArray(data[0])) {
              buffer.dimension = data[0].length;
              buffer.dtype = dtype || typedArrayCode(data[0]) || GL_FLOAT$3;
              flatData = arrayFlatten(
                data,
                [data.length, data[0].length],
                buffer.dtype
              );
              initBufferFromTypedArray(buffer, flatData, usage);
              if (persist) {
                buffer.persistentData = flatData;
              } else {
                pool.freeType(flatData);
              }
            } else {
              check$1.raise("invalid buffer data");
            }
          }
        } else if (isTypedArray(data)) {
          buffer.dtype = dtype || typedArrayCode(data);
          buffer.dimension = dimension;
          initBufferFromTypedArray(buffer, data, usage);
          if (persist) {
            buffer.persistentData = new Uint8Array(new Uint8Array(data.buffer));
          }
        } else if (isNDArrayLike(data)) {
          shape = data.shape;
          var stride = data.stride;
          var offset2 = data.offset;
          var shapeX = 0;
          var shapeY = 0;
          var strideX = 0;
          var strideY = 0;
          if (shape.length === 1) {
            shapeX = shape[0];
            shapeY = 1;
            strideX = stride[0];
            strideY = 0;
          } else if (shape.length === 2) {
            shapeX = shape[0];
            shapeY = shape[1];
            strideX = stride[0];
            strideY = stride[1];
          } else {
            check$1.raise("invalid shape");
          }
          buffer.dtype = dtype || typedArrayCode(data.data) || GL_FLOAT$3;
          buffer.dimension = shapeY;
          var transposeData2 = pool.allocType(buffer.dtype, shapeX * shapeY);
          transpose(
            transposeData2,
            data.data,
            shapeX,
            shapeY,
            strideX,
            strideY,
            offset2
          );
          initBufferFromTypedArray(buffer, transposeData2, usage);
          if (persist) {
            buffer.persistentData = transposeData2;
          } else {
            pool.freeType(transposeData2);
          }
        } else if (data instanceof ArrayBuffer) {
          buffer.dtype = GL_UNSIGNED_BYTE$3;
          buffer.dimension = dimension;
          initBufferFromTypedArray(buffer, data, usage);
          if (persist) {
            buffer.persistentData = new Uint8Array(new Uint8Array(data));
          }
        } else {
          check$1.raise("invalid buffer data");
        }
      }
      function destroy3(buffer) {
        stats2.bufferCount--;
        destroyBuffer(buffer);
        var handle = buffer.buffer;
        check$1(handle, "buffer must not be deleted already");
        gl.deleteBuffer(handle);
        buffer.buffer = null;
        delete bufferSet[buffer.id];
      }
      function createBuffer(options, type2, deferInit, persistent) {
        stats2.bufferCount++;
        var buffer = new REGLBuffer(type2);
        bufferSet[buffer.id] = buffer;
        function reglBuffer(options2) {
          var usage = GL_STATIC_DRAW;
          var data = null;
          var byteLength = 0;
          var dtype = 0;
          var dimension = 1;
          if (Array.isArray(options2) || isTypedArray(options2) || isNDArrayLike(options2) || options2 instanceof ArrayBuffer) {
            data = options2;
          } else if (typeof options2 === "number") {
            byteLength = options2 | 0;
          } else if (options2) {
            check$1.type(
              options2,
              "object",
              "buffer arguments must be an object, a number or an array"
            );
            if ("data" in options2) {
              check$1(
                data === null || Array.isArray(data) || isTypedArray(data) || isNDArrayLike(data),
                "invalid data for buffer"
              );
              data = options2.data;
            }
            if ("usage" in options2) {
              check$1.parameter(options2.usage, usageTypes, "invalid buffer usage");
              usage = usageTypes[options2.usage];
            }
            if ("type" in options2) {
              check$1.parameter(options2.type, glTypes, "invalid buffer type");
              dtype = glTypes[options2.type];
            }
            if ("dimension" in options2) {
              check$1.type(options2.dimension, "number", "invalid dimension");
              dimension = options2.dimension | 0;
            }
            if ("length" in options2) {
              check$1.nni(byteLength, "buffer length must be a nonnegative integer");
              byteLength = options2.length | 0;
            }
          }
          buffer.bind();
          if (!data) {
            if (byteLength) gl.bufferData(buffer.type, byteLength, usage);
            buffer.dtype = dtype || GL_UNSIGNED_BYTE$3;
            buffer.usage = usage;
            buffer.dimension = dimension;
            buffer.byteLength = byteLength;
          } else {
            initBufferFromData(buffer, data, usage, dtype, dimension, persistent);
          }
          if (config.profile) {
            buffer.stats.size = buffer.byteLength * DTYPES_SIZES[buffer.dtype];
          }
          return reglBuffer;
        }
        function setSubData(data, offset2) {
          check$1(
            offset2 + data.byteLength <= buffer.byteLength,
            "invalid buffer subdata call, buffer is too small.  Can't write data of size " + data.byteLength + " starting from offset " + offset2 + " to a buffer of size " + buffer.byteLength
          );
          gl.bufferSubData(buffer.type, offset2, data);
        }
        function subdata(data, offset_) {
          var offset2 = (offset_ || 0) | 0;
          var shape;
          buffer.bind();
          if (isTypedArray(data) || data instanceof ArrayBuffer) {
            setSubData(data, offset2);
          } else if (Array.isArray(data)) {
            if (data.length > 0) {
              if (typeof data[0] === "number") {
                var converted = pool.allocType(buffer.dtype, data.length);
                copyArray(converted, data);
                setSubData(converted, offset2);
                pool.freeType(converted);
              } else if (Array.isArray(data[0]) || isTypedArray(data[0])) {
                shape = arrayShape(data);
                var flatData = arrayFlatten(data, shape, buffer.dtype);
                setSubData(flatData, offset2);
                pool.freeType(flatData);
              } else {
                check$1.raise("invalid buffer data");
              }
            }
          } else if (isNDArrayLike(data)) {
            shape = data.shape;
            var stride = data.stride;
            var shapeX = 0;
            var shapeY = 0;
            var strideX = 0;
            var strideY = 0;
            if (shape.length === 1) {
              shapeX = shape[0];
              shapeY = 1;
              strideX = stride[0];
              strideY = 0;
            } else if (shape.length === 2) {
              shapeX = shape[0];
              shapeY = shape[1];
              strideX = stride[0];
              strideY = stride[1];
            } else {
              check$1.raise("invalid shape");
            }
            var dtype = Array.isArray(data.data) ? buffer.dtype : typedArrayCode(data.data);
            var transposeData2 = pool.allocType(dtype, shapeX * shapeY);
            transpose(
              transposeData2,
              data.data,
              shapeX,
              shapeY,
              strideX,
              strideY,
              data.offset
            );
            setSubData(transposeData2, offset2);
            pool.freeType(transposeData2);
          } else {
            check$1.raise("invalid data for buffer subdata");
          }
          return reglBuffer;
        }
        if (!deferInit) {
          reglBuffer(options);
        }
        reglBuffer._reglType = "buffer";
        reglBuffer._buffer = buffer;
        reglBuffer.subdata = subdata;
        if (config.profile) {
          reglBuffer.stats = buffer.stats;
        }
        reglBuffer.destroy = function() {
          destroy3(buffer);
        };
        return reglBuffer;
      }
      function restoreBuffers() {
        values(bufferSet).forEach(function(buffer) {
          buffer.buffer = gl.createBuffer();
          gl.bindBuffer(buffer.type, buffer.buffer);
          gl.bufferData(
            buffer.type,
            buffer.persistentData || buffer.byteLength,
            buffer.usage
          );
        });
      }
      if (config.profile) {
        stats2.getTotalBufferSize = function() {
          var total = 0;
          Object.keys(bufferSet).forEach(function(key) {
            total += bufferSet[key].stats.size;
          });
          return total;
        };
      }
      return {
        create: createBuffer,
        createStream,
        destroyStream,
        clear: function() {
          values(bufferSet).forEach(destroy3);
          streamPool.forEach(destroy3);
        },
        getBuffer: function(wrapper) {
          if (wrapper && wrapper._buffer instanceof REGLBuffer) {
            return wrapper._buffer;
          }
          return null;
        },
        restore: restoreBuffers,
        _initBuffer: initBufferFromData
      };
    }
    var points = 0;
    var point = 0;
    var lines = 1;
    var line = 1;
    var triangles = 4;
    var triangle = 4;
    var primTypes = {
      points,
      point,
      lines,
      line,
      triangles,
      triangle,
      "line loop": 2,
      "line strip": 3,
      "triangle strip": 5,
      "triangle fan": 6
    };
    var GL_POINTS = 0;
    var GL_LINES = 1;
    var GL_TRIANGLES = 4;
    var GL_BYTE$2 = 5120;
    var GL_UNSIGNED_BYTE$4 = 5121;
    var GL_SHORT$2 = 5122;
    var GL_UNSIGNED_SHORT$2 = 5123;
    var GL_INT$2 = 5124;
    var GL_UNSIGNED_INT$2 = 5125;
    var GL_ELEMENT_ARRAY_BUFFER = 34963;
    var GL_STREAM_DRAW$1 = 35040;
    var GL_STATIC_DRAW$1 = 35044;
    function wrapElementsState(gl, extensions, bufferState, stats2) {
      var elementSet = {};
      var elementCount = 0;
      var elementTypes = {
        "uint8": GL_UNSIGNED_BYTE$4,
        "uint16": GL_UNSIGNED_SHORT$2
      };
      if (extensions.oes_element_index_uint) {
        elementTypes.uint32 = GL_UNSIGNED_INT$2;
      }
      function REGLElementBuffer(buffer) {
        this.id = elementCount++;
        elementSet[this.id] = this;
        this.buffer = buffer;
        this.primType = GL_TRIANGLES;
        this.vertCount = 0;
        this.type = 0;
      }
      REGLElementBuffer.prototype.bind = function() {
        this.buffer.bind();
      };
      var bufferPool = [];
      function createElementStream(data) {
        var result = bufferPool.pop();
        if (!result) {
          result = new REGLElementBuffer(bufferState.create(
            null,
            GL_ELEMENT_ARRAY_BUFFER,
            true,
            false
          )._buffer);
        }
        initElements(result, data, GL_STREAM_DRAW$1, -1, -1, 0, 0);
        return result;
      }
      function destroyElementStream(elements) {
        bufferPool.push(elements);
      }
      function initElements(elements, data, usage, prim, count, byteLength, type2) {
        elements.buffer.bind();
        var dtype;
        if (data) {
          var predictedType = type2;
          if (!type2 && (!isTypedArray(data) || isNDArrayLike(data) && !isTypedArray(data.data))) {
            predictedType = extensions.oes_element_index_uint ? GL_UNSIGNED_INT$2 : GL_UNSIGNED_SHORT$2;
          }
          bufferState._initBuffer(
            elements.buffer,
            data,
            usage,
            predictedType,
            3
          );
        } else {
          gl.bufferData(GL_ELEMENT_ARRAY_BUFFER, byteLength, usage);
          elements.buffer.dtype = dtype || GL_UNSIGNED_BYTE$4;
          elements.buffer.usage = usage;
          elements.buffer.dimension = 3;
          elements.buffer.byteLength = byteLength;
        }
        dtype = type2;
        if (!type2) {
          switch (elements.buffer.dtype) {
            case GL_UNSIGNED_BYTE$4:
            case GL_BYTE$2:
              dtype = GL_UNSIGNED_BYTE$4;
              break;
            case GL_UNSIGNED_SHORT$2:
            case GL_SHORT$2:
              dtype = GL_UNSIGNED_SHORT$2;
              break;
            case GL_UNSIGNED_INT$2:
            case GL_INT$2:
              dtype = GL_UNSIGNED_INT$2;
              break;
            default:
              check$1.raise("unsupported type for element array");
          }
          elements.buffer.dtype = dtype;
        }
        elements.type = dtype;
        check$1(
          dtype !== GL_UNSIGNED_INT$2 || !!extensions.oes_element_index_uint,
          "32 bit element buffers not supported, enable oes_element_index_uint first"
        );
        var vertCount = count;
        if (vertCount < 0) {
          vertCount = elements.buffer.byteLength;
          if (dtype === GL_UNSIGNED_SHORT$2) {
            vertCount >>= 1;
          } else if (dtype === GL_UNSIGNED_INT$2) {
            vertCount >>= 2;
          }
        }
        elements.vertCount = vertCount;
        var primType = prim;
        if (prim < 0) {
          primType = GL_TRIANGLES;
          var dimension = elements.buffer.dimension;
          if (dimension === 1) primType = GL_POINTS;
          if (dimension === 2) primType = GL_LINES;
          if (dimension === 3) primType = GL_TRIANGLES;
        }
        elements.primType = primType;
      }
      function destroyElements(elements) {
        stats2.elementsCount--;
        check$1(elements.buffer !== null, "must not double destroy elements");
        delete elementSet[elements.id];
        elements.buffer.destroy();
        elements.buffer = null;
      }
      function createElements(options, persistent) {
        var buffer = bufferState.create(null, GL_ELEMENT_ARRAY_BUFFER, true);
        var elements = new REGLElementBuffer(buffer._buffer);
        stats2.elementsCount++;
        function reglElements(options2) {
          if (!options2) {
            buffer();
            elements.primType = GL_TRIANGLES;
            elements.vertCount = 0;
            elements.type = GL_UNSIGNED_BYTE$4;
          } else if (typeof options2 === "number") {
            buffer(options2);
            elements.primType = GL_TRIANGLES;
            elements.vertCount = options2 | 0;
            elements.type = GL_UNSIGNED_BYTE$4;
          } else {
            var data = null;
            var usage = GL_STATIC_DRAW$1;
            var primType = -1;
            var vertCount = -1;
            var byteLength = 0;
            var dtype = 0;
            if (Array.isArray(options2) || isTypedArray(options2) || isNDArrayLike(options2)) {
              data = options2;
            } else {
              check$1.type(options2, "object", "invalid arguments for elements");
              if ("data" in options2) {
                data = options2.data;
                check$1(
                  Array.isArray(data) || isTypedArray(data) || isNDArrayLike(data),
                  "invalid data for element buffer"
                );
              }
              if ("usage" in options2) {
                check$1.parameter(
                  options2.usage,
                  usageTypes,
                  "invalid element buffer usage"
                );
                usage = usageTypes[options2.usage];
              }
              if ("primitive" in options2) {
                check$1.parameter(
                  options2.primitive,
                  primTypes,
                  "invalid element buffer primitive"
                );
                primType = primTypes[options2.primitive];
              }
              if ("count" in options2) {
                check$1(
                  typeof options2.count === "number" && options2.count >= 0,
                  "invalid vertex count for elements"
                );
                vertCount = options2.count | 0;
              }
              if ("type" in options2) {
                check$1.parameter(
                  options2.type,
                  elementTypes,
                  "invalid buffer type"
                );
                dtype = elementTypes[options2.type];
              }
              if ("length" in options2) {
                byteLength = options2.length | 0;
              } else {
                byteLength = vertCount;
                if (dtype === GL_UNSIGNED_SHORT$2 || dtype === GL_SHORT$2) {
                  byteLength *= 2;
                } else if (dtype === GL_UNSIGNED_INT$2 || dtype === GL_INT$2) {
                  byteLength *= 4;
                }
              }
            }
            initElements(
              elements,
              data,
              usage,
              primType,
              vertCount,
              byteLength,
              dtype
            );
          }
          return reglElements;
        }
        reglElements(options);
        reglElements._reglType = "elements";
        reglElements._elements = elements;
        reglElements.subdata = function(data, offset2) {
          buffer.subdata(data, offset2);
          return reglElements;
        };
        reglElements.destroy = function() {
          destroyElements(elements);
        };
        return reglElements;
      }
      return {
        create: createElements,
        createStream: createElementStream,
        destroyStream: destroyElementStream,
        getElements: function(elements) {
          if (typeof elements === "function" && elements._elements instanceof REGLElementBuffer) {
            return elements._elements;
          }
          return null;
        },
        clear: function() {
          values(elementSet).forEach(destroyElements);
        }
      };
    }
    var FLOAT = new Float32Array(1);
    var INT = new Uint32Array(FLOAT.buffer);
    var GL_UNSIGNED_SHORT$4 = 5123;
    function convertToHalfFloat(array) {
      var ushorts = pool.allocType(GL_UNSIGNED_SHORT$4, array.length);
      for (var i3 = 0; i3 < array.length; ++i3) {
        if (isNaN(array[i3])) {
          ushorts[i3] = 65535;
        } else if (array[i3] === Infinity) {
          ushorts[i3] = 31744;
        } else if (array[i3] === -Infinity) {
          ushorts[i3] = 64512;
        } else {
          FLOAT[0] = array[i3];
          var x3 = INT[0];
          var sgn = x3 >>> 31 << 15;
          var exp = (x3 << 1 >>> 24) - 127;
          var frac = x3 >> 13 & (1 << 10) - 1;
          if (exp < -24) {
            ushorts[i3] = sgn;
          } else if (exp < -14) {
            var s4 = -14 - exp;
            ushorts[i3] = sgn + (frac + (1 << 10) >> s4);
          } else if (exp > 15) {
            ushorts[i3] = sgn + 31744;
          } else {
            ushorts[i3] = sgn + (exp + 15 << 10) + frac;
          }
        }
      }
      return ushorts;
    }
    function isArrayLike(s4) {
      return Array.isArray(s4) || isTypedArray(s4);
    }
    var isPow2$1 = function(v) {
      return !(v & v - 1) && !!v;
    };
    var GL_COMPRESSED_TEXTURE_FORMATS = 34467;
    var GL_TEXTURE_2D$1 = 3553;
    var GL_TEXTURE_CUBE_MAP$1 = 34067;
    var GL_TEXTURE_CUBE_MAP_POSITIVE_X$1 = 34069;
    var GL_RGBA$1 = 6408;
    var GL_ALPHA = 6406;
    var GL_RGB = 6407;
    var GL_LUMINANCE = 6409;
    var GL_LUMINANCE_ALPHA = 6410;
    var GL_RGBA4 = 32854;
    var GL_RGB5_A1 = 32855;
    var GL_RGB565 = 36194;
    var GL_UNSIGNED_SHORT_4_4_4_4$1 = 32819;
    var GL_UNSIGNED_SHORT_5_5_5_1$1 = 32820;
    var GL_UNSIGNED_SHORT_5_6_5$1 = 33635;
    var GL_UNSIGNED_INT_24_8_WEBGL$1 = 34042;
    var GL_DEPTH_COMPONENT = 6402;
    var GL_DEPTH_STENCIL = 34041;
    var GL_SRGB_EXT = 35904;
    var GL_SRGB_ALPHA_EXT = 35906;
    var GL_HALF_FLOAT_OES$1 = 36193;
    var GL_COMPRESSED_RGB_S3TC_DXT1_EXT = 33776;
    var GL_COMPRESSED_RGBA_S3TC_DXT1_EXT = 33777;
    var GL_COMPRESSED_RGBA_S3TC_DXT3_EXT = 33778;
    var GL_COMPRESSED_RGBA_S3TC_DXT5_EXT = 33779;
    var GL_COMPRESSED_RGB_ATC_WEBGL = 35986;
    var GL_COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL = 35987;
    var GL_COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL = 34798;
    var GL_COMPRESSED_RGB_PVRTC_4BPPV1_IMG = 35840;
    var GL_COMPRESSED_RGB_PVRTC_2BPPV1_IMG = 35841;
    var GL_COMPRESSED_RGBA_PVRTC_4BPPV1_IMG = 35842;
    var GL_COMPRESSED_RGBA_PVRTC_2BPPV1_IMG = 35843;
    var GL_COMPRESSED_RGB_ETC1_WEBGL = 36196;
    var GL_UNSIGNED_BYTE$5 = 5121;
    var GL_UNSIGNED_SHORT$3 = 5123;
    var GL_UNSIGNED_INT$3 = 5125;
    var GL_FLOAT$4 = 5126;
    var GL_TEXTURE_WRAP_S = 10242;
    var GL_TEXTURE_WRAP_T = 10243;
    var GL_REPEAT = 10497;
    var GL_CLAMP_TO_EDGE$1 = 33071;
    var GL_MIRRORED_REPEAT = 33648;
    var GL_TEXTURE_MAG_FILTER = 10240;
    var GL_TEXTURE_MIN_FILTER = 10241;
    var GL_NEAREST$1 = 9728;
    var GL_LINEAR = 9729;
    var GL_NEAREST_MIPMAP_NEAREST$1 = 9984;
    var GL_LINEAR_MIPMAP_NEAREST$1 = 9985;
    var GL_NEAREST_MIPMAP_LINEAR$1 = 9986;
    var GL_LINEAR_MIPMAP_LINEAR$1 = 9987;
    var GL_GENERATE_MIPMAP_HINT = 33170;
    var GL_DONT_CARE = 4352;
    var GL_FASTEST = 4353;
    var GL_NICEST = 4354;
    var GL_TEXTURE_MAX_ANISOTROPY_EXT = 34046;
    var GL_UNPACK_ALIGNMENT = 3317;
    var GL_UNPACK_FLIP_Y_WEBGL = 37440;
    var GL_UNPACK_PREMULTIPLY_ALPHA_WEBGL = 37441;
    var GL_UNPACK_COLORSPACE_CONVERSION_WEBGL = 37443;
    var GL_BROWSER_DEFAULT_WEBGL = 37444;
    var GL_TEXTURE0$1 = 33984;
    var MIPMAP_FILTERS = [
      GL_NEAREST_MIPMAP_NEAREST$1,
      GL_NEAREST_MIPMAP_LINEAR$1,
      GL_LINEAR_MIPMAP_NEAREST$1,
      GL_LINEAR_MIPMAP_LINEAR$1
    ];
    var CHANNELS_FORMAT = [
      0,
      GL_LUMINANCE,
      GL_LUMINANCE_ALPHA,
      GL_RGB,
      GL_RGBA$1
    ];
    var FORMAT_CHANNELS = {};
    FORMAT_CHANNELS[GL_LUMINANCE] = FORMAT_CHANNELS[GL_ALPHA] = FORMAT_CHANNELS[GL_DEPTH_COMPONENT] = 1;
    FORMAT_CHANNELS[GL_DEPTH_STENCIL] = FORMAT_CHANNELS[GL_LUMINANCE_ALPHA] = 2;
    FORMAT_CHANNELS[GL_RGB] = FORMAT_CHANNELS[GL_SRGB_EXT] = 3;
    FORMAT_CHANNELS[GL_RGBA$1] = FORMAT_CHANNELS[GL_SRGB_ALPHA_EXT] = 4;
    function objectName(str) {
      return "[object " + str + "]";
    }
    var CANVAS_CLASS = objectName("HTMLCanvasElement");
    var OFFSCREENCANVAS_CLASS = objectName("OffscreenCanvas");
    var CONTEXT2D_CLASS = objectName("CanvasRenderingContext2D");
    var BITMAP_CLASS = objectName("ImageBitmap");
    var IMAGE_CLASS = objectName("HTMLImageElement");
    var VIDEO_CLASS = objectName("HTMLVideoElement");
    var PIXEL_CLASSES = Object.keys(arrayTypes).concat([
      CANVAS_CLASS,
      OFFSCREENCANVAS_CLASS,
      CONTEXT2D_CLASS,
      BITMAP_CLASS,
      IMAGE_CLASS,
      VIDEO_CLASS
    ]);
    var TYPE_SIZES = [];
    TYPE_SIZES[GL_UNSIGNED_BYTE$5] = 1;
    TYPE_SIZES[GL_FLOAT$4] = 4;
    TYPE_SIZES[GL_HALF_FLOAT_OES$1] = 2;
    TYPE_SIZES[GL_UNSIGNED_SHORT$3] = 2;
    TYPE_SIZES[GL_UNSIGNED_INT$3] = 4;
    var FORMAT_SIZES_SPECIAL = [];
    FORMAT_SIZES_SPECIAL[GL_RGBA4] = 2;
    FORMAT_SIZES_SPECIAL[GL_RGB5_A1] = 2;
    FORMAT_SIZES_SPECIAL[GL_RGB565] = 2;
    FORMAT_SIZES_SPECIAL[GL_DEPTH_STENCIL] = 4;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGB_S3TC_DXT1_EXT] = 0.5;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_S3TC_DXT1_EXT] = 0.5;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_S3TC_DXT3_EXT] = 1;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_S3TC_DXT5_EXT] = 1;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGB_ATC_WEBGL] = 0.5;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL] = 1;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL] = 1;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGB_PVRTC_4BPPV1_IMG] = 0.5;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGB_PVRTC_2BPPV1_IMG] = 0.25;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_PVRTC_4BPPV1_IMG] = 0.5;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_PVRTC_2BPPV1_IMG] = 0.25;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGB_ETC1_WEBGL] = 0.5;
    function isNumericArray(arr) {
      return Array.isArray(arr) && (arr.length === 0 || typeof arr[0] === "number");
    }
    function isRectArray(arr) {
      if (!Array.isArray(arr)) {
        return false;
      }
      var width = arr.length;
      if (width === 0 || !isArrayLike(arr[0])) {
        return false;
      }
      return true;
    }
    function classString(x3) {
      return Object.prototype.toString.call(x3);
    }
    function isCanvasElement(object) {
      return classString(object) === CANVAS_CLASS;
    }
    function isOffscreenCanvas(object) {
      return classString(object) === OFFSCREENCANVAS_CLASS;
    }
    function isContext2D(object) {
      return classString(object) === CONTEXT2D_CLASS;
    }
    function isBitmap(object) {
      return classString(object) === BITMAP_CLASS;
    }
    function isImageElement(object) {
      return classString(object) === IMAGE_CLASS;
    }
    function isVideoElement(object) {
      return classString(object) === VIDEO_CLASS;
    }
    function isPixelData(object) {
      if (!object) {
        return false;
      }
      var className = classString(object);
      if (PIXEL_CLASSES.indexOf(className) >= 0) {
        return true;
      }
      return isNumericArray(object) || isRectArray(object) || isNDArrayLike(object);
    }
    function typedArrayCode$1(data) {
      return arrayTypes[Object.prototype.toString.call(data)] | 0;
    }
    function convertData(result, data) {
      var n = data.length;
      switch (result.type) {
        case GL_UNSIGNED_BYTE$5:
        case GL_UNSIGNED_SHORT$3:
        case GL_UNSIGNED_INT$3:
        case GL_FLOAT$4:
          var converted = pool.allocType(result.type, n);
          converted.set(data);
          result.data = converted;
          break;
        case GL_HALF_FLOAT_OES$1:
          result.data = convertToHalfFloat(data);
          break;
        default:
          check$1.raise("unsupported texture type, must specify a typed array");
      }
    }
    function preConvert(image, n) {
      return pool.allocType(
        image.type === GL_HALF_FLOAT_OES$1 ? GL_FLOAT$4 : image.type,
        n
      );
    }
    function postConvert(image, data) {
      if (image.type === GL_HALF_FLOAT_OES$1) {
        image.data = convertToHalfFloat(data);
        pool.freeType(data);
      } else {
        image.data = data;
      }
    }
    function transposeData(image, array, strideX, strideY, strideC, offset2) {
      var w3 = image.width;
      var h6 = image.height;
      var c3 = image.channels;
      var n = w3 * h6 * c3;
      var data = preConvert(image, n);
      var p2 = 0;
      for (var i3 = 0; i3 < h6; ++i3) {
        for (var j = 0; j < w3; ++j) {
          for (var k3 = 0; k3 < c3; ++k3) {
            data[p2++] = array[strideX * j + strideY * i3 + strideC * k3 + offset2];
          }
        }
      }
      postConvert(image, data);
    }
    function getTextureSize(format2, type2, width, height2, isMipmap, isCube) {
      var s4;
      if (typeof FORMAT_SIZES_SPECIAL[format2] !== "undefined") {
        s4 = FORMAT_SIZES_SPECIAL[format2];
      } else {
        s4 = FORMAT_CHANNELS[format2] * TYPE_SIZES[type2];
      }
      if (isCube) {
        s4 *= 6;
      }
      if (isMipmap) {
        var total = 0;
        var w3 = width;
        while (w3 >= 1) {
          total += s4 * w3 * w3;
          w3 /= 2;
        }
        return total;
      } else {
        return s4 * width * height2;
      }
    }
    function createTextureSet(gl, extensions, limits, reglPoll, contextState, stats2, config) {
      var mipmapHint = {
        "don't care": GL_DONT_CARE,
        "dont care": GL_DONT_CARE,
        "nice": GL_NICEST,
        "fast": GL_FASTEST
      };
      var wrapModes = {
        "repeat": GL_REPEAT,
        "clamp": GL_CLAMP_TO_EDGE$1,
        "mirror": GL_MIRRORED_REPEAT
      };
      var magFilters = {
        "nearest": GL_NEAREST$1,
        "linear": GL_LINEAR
      };
      var minFilters = extend2({
        "mipmap": GL_LINEAR_MIPMAP_LINEAR$1,
        "nearest mipmap nearest": GL_NEAREST_MIPMAP_NEAREST$1,
        "linear mipmap nearest": GL_LINEAR_MIPMAP_NEAREST$1,
        "nearest mipmap linear": GL_NEAREST_MIPMAP_LINEAR$1,
        "linear mipmap linear": GL_LINEAR_MIPMAP_LINEAR$1
      }, magFilters);
      var colorSpace = {
        "none": 0,
        "browser": GL_BROWSER_DEFAULT_WEBGL
      };
      var textureTypes = {
        "uint8": GL_UNSIGNED_BYTE$5,
        "rgba4": GL_UNSIGNED_SHORT_4_4_4_4$1,
        "rgb565": GL_UNSIGNED_SHORT_5_6_5$1,
        "rgb5 a1": GL_UNSIGNED_SHORT_5_5_5_1$1
      };
      var textureFormats = {
        "alpha": GL_ALPHA,
        "luminance": GL_LUMINANCE,
        "luminance alpha": GL_LUMINANCE_ALPHA,
        "rgb": GL_RGB,
        "rgba": GL_RGBA$1,
        "rgba4": GL_RGBA4,
        "rgb5 a1": GL_RGB5_A1,
        "rgb565": GL_RGB565
      };
      var compressedTextureFormats = {};
      if (extensions.ext_srgb) {
        textureFormats.srgb = GL_SRGB_EXT;
        textureFormats.srgba = GL_SRGB_ALPHA_EXT;
      }
      if (extensions.oes_texture_float) {
        textureTypes.float32 = textureTypes.float = GL_FLOAT$4;
      }
      if (extensions.oes_texture_half_float) {
        textureTypes["float16"] = textureTypes["half float"] = GL_HALF_FLOAT_OES$1;
      }
      if (extensions.webgl_depth_texture) {
        extend2(textureFormats, {
          "depth": GL_DEPTH_COMPONENT,
          "depth stencil": GL_DEPTH_STENCIL
        });
        extend2(textureTypes, {
          "uint16": GL_UNSIGNED_SHORT$3,
          "uint32": GL_UNSIGNED_INT$3,
          "depth stencil": GL_UNSIGNED_INT_24_8_WEBGL$1
        });
      }
      if (extensions.webgl_compressed_texture_s3tc) {
        extend2(compressedTextureFormats, {
          "rgb s3tc dxt1": GL_COMPRESSED_RGB_S3TC_DXT1_EXT,
          "rgba s3tc dxt1": GL_COMPRESSED_RGBA_S3TC_DXT1_EXT,
          "rgba s3tc dxt3": GL_COMPRESSED_RGBA_S3TC_DXT3_EXT,
          "rgba s3tc dxt5": GL_COMPRESSED_RGBA_S3TC_DXT5_EXT
        });
      }
      if (extensions.webgl_compressed_texture_atc) {
        extend2(compressedTextureFormats, {
          "rgb atc": GL_COMPRESSED_RGB_ATC_WEBGL,
          "rgba atc explicit alpha": GL_COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL,
          "rgba atc interpolated alpha": GL_COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL
        });
      }
      if (extensions.webgl_compressed_texture_pvrtc) {
        extend2(compressedTextureFormats, {
          "rgb pvrtc 4bppv1": GL_COMPRESSED_RGB_PVRTC_4BPPV1_IMG,
          "rgb pvrtc 2bppv1": GL_COMPRESSED_RGB_PVRTC_2BPPV1_IMG,
          "rgba pvrtc 4bppv1": GL_COMPRESSED_RGBA_PVRTC_4BPPV1_IMG,
          "rgba pvrtc 2bppv1": GL_COMPRESSED_RGBA_PVRTC_2BPPV1_IMG
        });
      }
      if (extensions.webgl_compressed_texture_etc1) {
        compressedTextureFormats["rgb etc1"] = GL_COMPRESSED_RGB_ETC1_WEBGL;
      }
      var supportedCompressedFormats = Array.prototype.slice.call(
        gl.getParameter(GL_COMPRESSED_TEXTURE_FORMATS)
      );
      Object.keys(compressedTextureFormats).forEach(function(name2) {
        var format2 = compressedTextureFormats[name2];
        if (supportedCompressedFormats.indexOf(format2) >= 0) {
          textureFormats[name2] = format2;
        }
      });
      var supportedFormats = Object.keys(textureFormats);
      limits.textureFormats = supportedFormats;
      var textureFormatsInvert = [];
      Object.keys(textureFormats).forEach(function(key) {
        var val = textureFormats[key];
        textureFormatsInvert[val] = key;
      });
      var textureTypesInvert = [];
      Object.keys(textureTypes).forEach(function(key) {
        var val = textureTypes[key];
        textureTypesInvert[val] = key;
      });
      var magFiltersInvert = [];
      Object.keys(magFilters).forEach(function(key) {
        var val = magFilters[key];
        magFiltersInvert[val] = key;
      });
      var minFiltersInvert = [];
      Object.keys(minFilters).forEach(function(key) {
        var val = minFilters[key];
        minFiltersInvert[val] = key;
      });
      var wrapModesInvert = [];
      Object.keys(wrapModes).forEach(function(key) {
        var val = wrapModes[key];
        wrapModesInvert[val] = key;
      });
      var colorFormats = supportedFormats.reduce(function(color2, key) {
        var glenum = textureFormats[key];
        if (glenum === GL_LUMINANCE || glenum === GL_ALPHA || glenum === GL_LUMINANCE || glenum === GL_LUMINANCE_ALPHA || glenum === GL_DEPTH_COMPONENT || glenum === GL_DEPTH_STENCIL || extensions.ext_srgb && (glenum === GL_SRGB_EXT || glenum === GL_SRGB_ALPHA_EXT)) {
          color2[glenum] = glenum;
        } else if (glenum === GL_RGB5_A1 || key.indexOf("rgba") >= 0) {
          color2[glenum] = GL_RGBA$1;
        } else {
          color2[glenum] = GL_RGB;
        }
        return color2;
      }, {});
      function TexFlags() {
        this.internalformat = GL_RGBA$1;
        this.format = GL_RGBA$1;
        this.type = GL_UNSIGNED_BYTE$5;
        this.compressed = false;
        this.premultiplyAlpha = false;
        this.flipY = false;
        this.unpackAlignment = 1;
        this.colorSpace = GL_BROWSER_DEFAULT_WEBGL;
        this.width = 0;
        this.height = 0;
        this.channels = 0;
      }
      function copyFlags(result, other) {
        result.internalformat = other.internalformat;
        result.format = other.format;
        result.type = other.type;
        result.compressed = other.compressed;
        result.premultiplyAlpha = other.premultiplyAlpha;
        result.flipY = other.flipY;
        result.unpackAlignment = other.unpackAlignment;
        result.colorSpace = other.colorSpace;
        result.width = other.width;
        result.height = other.height;
        result.channels = other.channels;
      }
      function parseFlags(flags, options) {
        if (typeof options !== "object" || !options) {
          return;
        }
        if ("premultiplyAlpha" in options) {
          check$1.type(
            options.premultiplyAlpha,
            "boolean",
            "invalid premultiplyAlpha"
          );
          flags.premultiplyAlpha = options.premultiplyAlpha;
        }
        if ("flipY" in options) {
          check$1.type(
            options.flipY,
            "boolean",
            "invalid texture flip"
          );
          flags.flipY = options.flipY;
        }
        if ("alignment" in options) {
          check$1.oneOf(
            options.alignment,
            [1, 2, 4, 8],
            "invalid texture unpack alignment"
          );
          flags.unpackAlignment = options.alignment;
        }
        if ("colorSpace" in options) {
          check$1.parameter(
            options.colorSpace,
            colorSpace,
            "invalid colorSpace"
          );
          flags.colorSpace = colorSpace[options.colorSpace];
        }
        if ("type" in options) {
          var type2 = options.type;
          check$1(
            extensions.oes_texture_float || !(type2 === "float" || type2 === "float32"),
            "you must enable the OES_texture_float extension in order to use floating point textures."
          );
          check$1(
            extensions.oes_texture_half_float || !(type2 === "half float" || type2 === "float16"),
            "you must enable the OES_texture_half_float extension in order to use 16-bit floating point textures."
          );
          check$1(
            extensions.webgl_depth_texture || !(type2 === "uint16" || type2 === "uint32" || type2 === "depth stencil"),
            "you must enable the WEBGL_depth_texture extension in order to use depth/stencil textures."
          );
          check$1.parameter(
            type2,
            textureTypes,
            "invalid texture type"
          );
          flags.type = textureTypes[type2];
        }
        var w3 = flags.width;
        var h6 = flags.height;
        var c3 = flags.channels;
        var hasChannels = false;
        if ("shape" in options) {
          check$1(
            Array.isArray(options.shape) && options.shape.length >= 2,
            "shape must be an array"
          );
          w3 = options.shape[0];
          h6 = options.shape[1];
          if (options.shape.length === 3) {
            c3 = options.shape[2];
            check$1(c3 > 0 && c3 <= 4, "invalid number of channels");
            hasChannels = true;
          }
          check$1(w3 >= 0 && w3 <= limits.maxTextureSize, "invalid width");
          check$1(h6 >= 0 && h6 <= limits.maxTextureSize, "invalid height");
        } else {
          if ("radius" in options) {
            w3 = h6 = options.radius;
            check$1(w3 >= 0 && w3 <= limits.maxTextureSize, "invalid radius");
          }
          if ("width" in options) {
            w3 = options.width;
            check$1(w3 >= 0 && w3 <= limits.maxTextureSize, "invalid width");
          }
          if ("height" in options) {
            h6 = options.height;
            check$1(h6 >= 0 && h6 <= limits.maxTextureSize, "invalid height");
          }
          if ("channels" in options) {
            c3 = options.channels;
            check$1(c3 > 0 && c3 <= 4, "invalid number of channels");
            hasChannels = true;
          }
        }
        flags.width = w3 | 0;
        flags.height = h6 | 0;
        flags.channels = c3 | 0;
        var hasFormat = false;
        if ("format" in options) {
          var formatStr = options.format;
          check$1(
            extensions.webgl_depth_texture || !(formatStr === "depth" || formatStr === "depth stencil"),
            "you must enable the WEBGL_depth_texture extension in order to use depth/stencil textures."
          );
          check$1.parameter(
            formatStr,
            textureFormats,
            "invalid texture format"
          );
          var internalformat = flags.internalformat = textureFormats[formatStr];
          flags.format = colorFormats[internalformat];
          if (formatStr in textureTypes) {
            if (!("type" in options)) {
              flags.type = textureTypes[formatStr];
            }
          }
          if (formatStr in compressedTextureFormats) {
            flags.compressed = true;
          }
          hasFormat = true;
        }
        if (!hasChannels && hasFormat) {
          flags.channels = FORMAT_CHANNELS[flags.format];
        } else if (hasChannels && !hasFormat) {
          if (flags.channels !== CHANNELS_FORMAT[flags.format]) {
            flags.format = flags.internalformat = CHANNELS_FORMAT[flags.channels];
          }
        } else if (hasFormat && hasChannels) {
          check$1(
            flags.channels === FORMAT_CHANNELS[flags.format],
            "number of channels inconsistent with specified format"
          );
        }
      }
      function setFlags(flags) {
        gl.pixelStorei(GL_UNPACK_FLIP_Y_WEBGL, flags.flipY);
        gl.pixelStorei(GL_UNPACK_PREMULTIPLY_ALPHA_WEBGL, flags.premultiplyAlpha);
        gl.pixelStorei(GL_UNPACK_COLORSPACE_CONVERSION_WEBGL, flags.colorSpace);
        gl.pixelStorei(GL_UNPACK_ALIGNMENT, flags.unpackAlignment);
      }
      function TexImage() {
        TexFlags.call(this);
        this.xOffset = 0;
        this.yOffset = 0;
        this.data = null;
        this.needsFree = false;
        this.element = null;
        this.needsCopy = false;
      }
      function parseImage(image, options) {
        var data = null;
        if (isPixelData(options)) {
          data = options;
        } else if (options) {
          check$1.type(options, "object", "invalid pixel data type");
          parseFlags(image, options);
          if ("x" in options) {
            image.xOffset = options.x | 0;
          }
          if ("y" in options) {
            image.yOffset = options.y | 0;
          }
          if (isPixelData(options.data)) {
            data = options.data;
          }
        }
        check$1(
          !image.compressed || data instanceof Uint8Array,
          "compressed texture data must be stored in a uint8array"
        );
        if (options.copy) {
          check$1(!data, "can not specify copy and data field for the same texture");
          var viewW = contextState.viewportWidth;
          var viewH = contextState.viewportHeight;
          image.width = image.width || viewW - image.xOffset;
          image.height = image.height || viewH - image.yOffset;
          image.needsCopy = true;
          check$1(
            image.xOffset >= 0 && image.xOffset < viewW && image.yOffset >= 0 && image.yOffset < viewH && image.width > 0 && image.width <= viewW && image.height > 0 && image.height <= viewH,
            "copy texture read out of bounds"
          );
        } else if (!data) {
          image.width = image.width || 1;
          image.height = image.height || 1;
          image.channels = image.channels || 4;
        } else if (isTypedArray(data)) {
          image.channels = image.channels || 4;
          image.data = data;
          if (!("type" in options) && image.type === GL_UNSIGNED_BYTE$5) {
            image.type = typedArrayCode$1(data);
          }
        } else if (isNumericArray(data)) {
          image.channels = image.channels || 4;
          convertData(image, data);
          image.alignment = 1;
          image.needsFree = true;
        } else if (isNDArrayLike(data)) {
          var array = data.data;
          if (!Array.isArray(array) && image.type === GL_UNSIGNED_BYTE$5) {
            image.type = typedArrayCode$1(array);
          }
          var shape = data.shape;
          var stride = data.stride;
          var shapeX, shapeY, shapeC, strideX, strideY, strideC;
          if (shape.length === 3) {
            shapeC = shape[2];
            strideC = stride[2];
          } else {
            check$1(shape.length === 2, "invalid ndarray pixel data, must be 2 or 3D");
            shapeC = 1;
            strideC = 1;
          }
          shapeX = shape[0];
          shapeY = shape[1];
          strideX = stride[0];
          strideY = stride[1];
          image.alignment = 1;
          image.width = shapeX;
          image.height = shapeY;
          image.channels = shapeC;
          image.format = image.internalformat = CHANNELS_FORMAT[shapeC];
          image.needsFree = true;
          transposeData(image, array, strideX, strideY, strideC, data.offset);
        } else if (isCanvasElement(data) || isOffscreenCanvas(data) || isContext2D(data)) {
          if (isCanvasElement(data) || isOffscreenCanvas(data)) {
            image.element = data;
          } else {
            image.element = data.canvas;
          }
          image.width = image.element.width;
          image.height = image.element.height;
          image.channels = 4;
        } else if (isBitmap(data)) {
          image.element = data;
          image.width = data.width;
          image.height = data.height;
          image.channels = 4;
        } else if (isImageElement(data)) {
          image.element = data;
          image.width = data.naturalWidth;
          image.height = data.naturalHeight;
          image.channels = 4;
        } else if (isVideoElement(data)) {
          image.element = data;
          image.width = data.videoWidth;
          image.height = data.videoHeight;
          image.channels = 4;
        } else if (isRectArray(data)) {
          var w3 = image.width || data[0].length;
          var h6 = image.height || data.length;
          var c3 = image.channels;
          if (isArrayLike(data[0][0])) {
            c3 = c3 || data[0][0].length;
          } else {
            c3 = c3 || 1;
          }
          var arrayShape2 = flattenUtils.shape(data);
          var n = 1;
          for (var dd = 0; dd < arrayShape2.length; ++dd) {
            n *= arrayShape2[dd];
          }
          var allocData = preConvert(image, n);
          flattenUtils.flatten(data, arrayShape2, "", allocData);
          postConvert(image, allocData);
          image.alignment = 1;
          image.width = w3;
          image.height = h6;
          image.channels = c3;
          image.format = image.internalformat = CHANNELS_FORMAT[c3];
          image.needsFree = true;
        }
        if (image.type === GL_FLOAT$4) {
          check$1(
            limits.extensions.indexOf("oes_texture_float") >= 0,
            "oes_texture_float extension not enabled"
          );
        } else if (image.type === GL_HALF_FLOAT_OES$1) {
          check$1(
            limits.extensions.indexOf("oes_texture_half_float") >= 0,
            "oes_texture_half_float extension not enabled"
          );
        }
      }
      function setImage(info, target2, miplevel) {
        var element = info.element;
        var data = info.data;
        var internalformat = info.internalformat;
        var format2 = info.format;
        var type2 = info.type;
        var width = info.width;
        var height2 = info.height;
        setFlags(info);
        if (element) {
          gl.texImage2D(target2, miplevel, format2, format2, type2, element);
        } else if (info.compressed) {
          gl.compressedTexImage2D(target2, miplevel, internalformat, width, height2, 0, data);
        } else if (info.needsCopy) {
          reglPoll();
          gl.copyTexImage2D(
            target2,
            miplevel,
            format2,
            info.xOffset,
            info.yOffset,
            width,
            height2,
            0
          );
        } else {
          gl.texImage2D(target2, miplevel, format2, width, height2, 0, format2, type2, data || null);
        }
      }
      function setSubImage(info, target2, x3, y4, miplevel) {
        var element = info.element;
        var data = info.data;
        var internalformat = info.internalformat;
        var format2 = info.format;
        var type2 = info.type;
        var width = info.width;
        var height2 = info.height;
        setFlags(info);
        if (element) {
          gl.texSubImage2D(
            target2,
            miplevel,
            x3,
            y4,
            format2,
            type2,
            element
          );
        } else if (info.compressed) {
          gl.compressedTexSubImage2D(
            target2,
            miplevel,
            x3,
            y4,
            internalformat,
            width,
            height2,
            data
          );
        } else if (info.needsCopy) {
          reglPoll();
          gl.copyTexSubImage2D(
            target2,
            miplevel,
            x3,
            y4,
            info.xOffset,
            info.yOffset,
            width,
            height2
          );
        } else {
          gl.texSubImage2D(
            target2,
            miplevel,
            x3,
            y4,
            width,
            height2,
            format2,
            type2,
            data
          );
        }
      }
      var imagePool = [];
      function allocImage() {
        return imagePool.pop() || new TexImage();
      }
      function freeImage(image) {
        if (image.needsFree) {
          pool.freeType(image.data);
        }
        TexImage.call(image);
        imagePool.push(image);
      }
      function MipMap() {
        TexFlags.call(this);
        this.genMipmaps = false;
        this.mipmapHint = GL_DONT_CARE;
        this.mipmask = 0;
        this.images = Array(16);
      }
      function parseMipMapFromShape(mipmap, width, height2) {
        var img = mipmap.images[0] = allocImage();
        mipmap.mipmask = 1;
        img.width = mipmap.width = width;
        img.height = mipmap.height = height2;
        img.channels = mipmap.channels = 4;
      }
      function parseMipMapFromObject(mipmap, options) {
        var imgData = null;
        if (isPixelData(options)) {
          imgData = mipmap.images[0] = allocImage();
          copyFlags(imgData, mipmap);
          parseImage(imgData, options);
          mipmap.mipmask = 1;
        } else {
          parseFlags(mipmap, options);
          if (Array.isArray(options.mipmap)) {
            var mipData = options.mipmap;
            for (var i3 = 0; i3 < mipData.length; ++i3) {
              imgData = mipmap.images[i3] = allocImage();
              copyFlags(imgData, mipmap);
              imgData.width >>= i3;
              imgData.height >>= i3;
              parseImage(imgData, mipData[i3]);
              mipmap.mipmask |= 1 << i3;
            }
          } else {
            imgData = mipmap.images[0] = allocImage();
            copyFlags(imgData, mipmap);
            parseImage(imgData, options);
            mipmap.mipmask = 1;
          }
        }
        copyFlags(mipmap, mipmap.images[0]);
        if (mipmap.compressed && (mipmap.internalformat === GL_COMPRESSED_RGB_S3TC_DXT1_EXT || mipmap.internalformat === GL_COMPRESSED_RGBA_S3TC_DXT1_EXT || mipmap.internalformat === GL_COMPRESSED_RGBA_S3TC_DXT3_EXT || mipmap.internalformat === GL_COMPRESSED_RGBA_S3TC_DXT5_EXT)) {
          check$1(
            mipmap.width % 4 === 0 && mipmap.height % 4 === 0,
            "for compressed texture formats, mipmap level 0 must have width and height that are a multiple of 4"
          );
        }
      }
      function setMipMap(mipmap, target2) {
        var images = mipmap.images;
        for (var i3 = 0; i3 < images.length; ++i3) {
          if (!images[i3]) {
            return;
          }
          setImage(images[i3], target2, i3);
        }
      }
      var mipPool = [];
      function allocMipMap() {
        var result = mipPool.pop() || new MipMap();
        TexFlags.call(result);
        result.mipmask = 0;
        for (var i3 = 0; i3 < 16; ++i3) {
          result.images[i3] = null;
        }
        return result;
      }
      function freeMipMap(mipmap) {
        var images = mipmap.images;
        for (var i3 = 0; i3 < images.length; ++i3) {
          if (images[i3]) {
            freeImage(images[i3]);
          }
          images[i3] = null;
        }
        mipPool.push(mipmap);
      }
      function TexInfo() {
        this.minFilter = GL_NEAREST$1;
        this.magFilter = GL_NEAREST$1;
        this.wrapS = GL_CLAMP_TO_EDGE$1;
        this.wrapT = GL_CLAMP_TO_EDGE$1;
        this.anisotropic = 1;
        this.genMipmaps = false;
        this.mipmapHint = GL_DONT_CARE;
      }
      function parseTexInfo(info, options) {
        if ("min" in options) {
          var minFilter = options.min;
          check$1.parameter(minFilter, minFilters);
          info.minFilter = minFilters[minFilter];
          if (MIPMAP_FILTERS.indexOf(info.minFilter) >= 0 && !("faces" in options)) {
            info.genMipmaps = true;
          }
        }
        if ("mag" in options) {
          var magFilter = options.mag;
          check$1.parameter(magFilter, magFilters);
          info.magFilter = magFilters[magFilter];
        }
        var wrapS = info.wrapS;
        var wrapT = info.wrapT;
        if ("wrap" in options) {
          var wrap = options.wrap;
          if (typeof wrap === "string") {
            check$1.parameter(wrap, wrapModes);
            wrapS = wrapT = wrapModes[wrap];
          } else if (Array.isArray(wrap)) {
            check$1.parameter(wrap[0], wrapModes);
            check$1.parameter(wrap[1], wrapModes);
            wrapS = wrapModes[wrap[0]];
            wrapT = wrapModes[wrap[1]];
          }
        } else {
          if ("wrapS" in options) {
            var optWrapS = options.wrapS;
            check$1.parameter(optWrapS, wrapModes);
            wrapS = wrapModes[optWrapS];
          }
          if ("wrapT" in options) {
            var optWrapT = options.wrapT;
            check$1.parameter(optWrapT, wrapModes);
            wrapT = wrapModes[optWrapT];
          }
        }
        info.wrapS = wrapS;
        info.wrapT = wrapT;
        if ("anisotropic" in options) {
          var anisotropic = options.anisotropic;
          check$1(
            typeof anisotropic === "number" && anisotropic >= 1 && anisotropic <= limits.maxAnisotropic,
            "aniso samples must be between 1 and "
          );
          info.anisotropic = options.anisotropic;
        }
        if ("mipmap" in options) {
          var hasMipMap = false;
          switch (typeof options.mipmap) {
            case "string":
              check$1.parameter(
                options.mipmap,
                mipmapHint,
                "invalid mipmap hint"
              );
              info.mipmapHint = mipmapHint[options.mipmap];
              info.genMipmaps = true;
              hasMipMap = true;
              break;
            case "boolean":
              hasMipMap = info.genMipmaps = options.mipmap;
              break;
            case "object":
              check$1(Array.isArray(options.mipmap), "invalid mipmap type");
              info.genMipmaps = false;
              hasMipMap = true;
              break;
            default:
              check$1.raise("invalid mipmap type");
          }
          if (hasMipMap && !("min" in options)) {
            info.minFilter = GL_NEAREST_MIPMAP_NEAREST$1;
          }
        }
      }
      function setTexInfo(info, target2) {
        gl.texParameteri(target2, GL_TEXTURE_MIN_FILTER, info.minFilter);
        gl.texParameteri(target2, GL_TEXTURE_MAG_FILTER, info.magFilter);
        gl.texParameteri(target2, GL_TEXTURE_WRAP_S, info.wrapS);
        gl.texParameteri(target2, GL_TEXTURE_WRAP_T, info.wrapT);
        if (extensions.ext_texture_filter_anisotropic) {
          gl.texParameteri(target2, GL_TEXTURE_MAX_ANISOTROPY_EXT, info.anisotropic);
        }
        if (info.genMipmaps) {
          gl.hint(GL_GENERATE_MIPMAP_HINT, info.mipmapHint);
          gl.generateMipmap(target2);
        }
      }
      var textureCount = 0;
      var textureSet = {};
      var numTexUnits = limits.maxTextureUnits;
      var textureUnits = Array(numTexUnits).map(function() {
        return null;
      });
      function REGLTexture(target2) {
        TexFlags.call(this);
        this.mipmask = 0;
        this.internalformat = GL_RGBA$1;
        this.id = textureCount++;
        this.refCount = 1;
        this.target = target2;
        this.texture = gl.createTexture();
        this.unit = -1;
        this.bindCount = 0;
        this.texInfo = new TexInfo();
        if (config.profile) {
          this.stats = { size: 0 };
        }
      }
      function tempBind(texture) {
        gl.activeTexture(GL_TEXTURE0$1);
        gl.bindTexture(texture.target, texture.texture);
      }
      function tempRestore() {
        var prev = textureUnits[0];
        if (prev) {
          gl.bindTexture(prev.target, prev.texture);
        } else {
          gl.bindTexture(GL_TEXTURE_2D$1, null);
        }
      }
      function destroy3(texture) {
        var handle = texture.texture;
        check$1(handle, "must not double destroy texture");
        var unit = texture.unit;
        var target2 = texture.target;
        if (unit >= 0) {
          gl.activeTexture(GL_TEXTURE0$1 + unit);
          gl.bindTexture(target2, null);
          textureUnits[unit] = null;
        }
        gl.deleteTexture(handle);
        texture.texture = null;
        texture.params = null;
        texture.pixels = null;
        texture.refCount = 0;
        delete textureSet[texture.id];
        stats2.textureCount--;
      }
      extend2(REGLTexture.prototype, {
        bind: function() {
          var texture = this;
          texture.bindCount += 1;
          var unit = texture.unit;
          if (unit < 0) {
            for (var i3 = 0; i3 < numTexUnits; ++i3) {
              var other = textureUnits[i3];
              if (other) {
                if (other.bindCount > 0) {
                  continue;
                }
                other.unit = -1;
              }
              textureUnits[i3] = texture;
              unit = i3;
              break;
            }
            if (unit >= numTexUnits) {
              check$1.raise("insufficient number of texture units");
            }
            if (config.profile && stats2.maxTextureUnits < unit + 1) {
              stats2.maxTextureUnits = unit + 1;
            }
            texture.unit = unit;
            gl.activeTexture(GL_TEXTURE0$1 + unit);
            gl.bindTexture(texture.target, texture.texture);
          }
          return unit;
        },
        unbind: function() {
          this.bindCount -= 1;
        },
        decRef: function() {
          if (--this.refCount <= 0) {
            destroy3(this);
          }
        }
      });
      function createTexture2D(a4, b3) {
        var texture = new REGLTexture(GL_TEXTURE_2D$1);
        textureSet[texture.id] = texture;
        stats2.textureCount++;
        function reglTexture2D(a5, b4) {
          var texInfo = texture.texInfo;
          TexInfo.call(texInfo);
          var mipData = allocMipMap();
          if (typeof a5 === "number") {
            if (typeof b4 === "number") {
              parseMipMapFromShape(mipData, a5 | 0, b4 | 0);
            } else {
              parseMipMapFromShape(mipData, a5 | 0, a5 | 0);
            }
          } else if (a5) {
            check$1.type(a5, "object", "invalid arguments to regl.texture");
            parseTexInfo(texInfo, a5);
            parseMipMapFromObject(mipData, a5);
          } else {
            parseMipMapFromShape(mipData, 1, 1);
          }
          if (texInfo.genMipmaps) {
            mipData.mipmask = (mipData.width << 1) - 1;
          }
          texture.mipmask = mipData.mipmask;
          copyFlags(texture, mipData);
          check$1.texture2D(texInfo, mipData, limits);
          texture.internalformat = mipData.internalformat;
          reglTexture2D.width = mipData.width;
          reglTexture2D.height = mipData.height;
          tempBind(texture);
          setMipMap(mipData, GL_TEXTURE_2D$1);
          setTexInfo(texInfo, GL_TEXTURE_2D$1);
          tempRestore();
          freeMipMap(mipData);
          if (config.profile) {
            texture.stats.size = getTextureSize(
              texture.internalformat,
              texture.type,
              mipData.width,
              mipData.height,
              texInfo.genMipmaps,
              false
            );
          }
          reglTexture2D.format = textureFormatsInvert[texture.internalformat];
          reglTexture2D.type = textureTypesInvert[texture.type];
          reglTexture2D.mag = magFiltersInvert[texInfo.magFilter];
          reglTexture2D.min = minFiltersInvert[texInfo.minFilter];
          reglTexture2D.wrapS = wrapModesInvert[texInfo.wrapS];
          reglTexture2D.wrapT = wrapModesInvert[texInfo.wrapT];
          return reglTexture2D;
        }
        function subimage(image, x_, y_, level_) {
          check$1(!!image, "must specify image data");
          var x3 = x_ | 0;
          var y4 = y_ | 0;
          var level = level_ | 0;
          var imageData = allocImage();
          copyFlags(imageData, texture);
          imageData.width = 0;
          imageData.height = 0;
          parseImage(imageData, image);
          imageData.width = imageData.width || (texture.width >> level) - x3;
          imageData.height = imageData.height || (texture.height >> level) - y4;
          check$1(
            texture.type === imageData.type && texture.format === imageData.format && texture.internalformat === imageData.internalformat,
            "incompatible format for texture.subimage"
          );
          check$1(
            x3 >= 0 && y4 >= 0 && x3 + imageData.width <= texture.width && y4 + imageData.height <= texture.height,
            "texture.subimage write out of bounds"
          );
          check$1(
            texture.mipmask & 1 << level,
            "missing mipmap data"
          );
          check$1(
            imageData.data || imageData.element || imageData.needsCopy,
            "missing image data"
          );
          tempBind(texture);
          setSubImage(imageData, GL_TEXTURE_2D$1, x3, y4, level);
          tempRestore();
          freeImage(imageData);
          return reglTexture2D;
        }
        function resize(w_, h_) {
          var w3 = w_ | 0;
          var h6 = h_ | 0 || w3;
          if (w3 === texture.width && h6 === texture.height) {
            return reglTexture2D;
          }
          reglTexture2D.width = texture.width = w3;
          reglTexture2D.height = texture.height = h6;
          tempBind(texture);
          for (var i3 = 0; texture.mipmask >> i3; ++i3) {
            var _w = w3 >> i3;
            var _h = h6 >> i3;
            if (!_w || !_h) break;
            gl.texImage2D(
              GL_TEXTURE_2D$1,
              i3,
              texture.format,
              _w,
              _h,
              0,
              texture.format,
              texture.type,
              null
            );
          }
          tempRestore();
          if (config.profile) {
            texture.stats.size = getTextureSize(
              texture.internalformat,
              texture.type,
              w3,
              h6,
              false,
              false
            );
          }
          return reglTexture2D;
        }
        reglTexture2D(a4, b3);
        reglTexture2D.subimage = subimage;
        reglTexture2D.resize = resize;
        reglTexture2D._reglType = "texture2d";
        reglTexture2D._texture = texture;
        if (config.profile) {
          reglTexture2D.stats = texture.stats;
        }
        reglTexture2D.destroy = function() {
          texture.decRef();
        };
        return reglTexture2D;
      }
      function createTextureCube(a0, a1, a23, a32, a4, a5) {
        var texture = new REGLTexture(GL_TEXTURE_CUBE_MAP$1);
        textureSet[texture.id] = texture;
        stats2.cubeCount++;
        var faces = new Array(6);
        function reglTextureCube(a02, a12, a24, a33, a42, a52) {
          var i3;
          var texInfo = texture.texInfo;
          TexInfo.call(texInfo);
          for (i3 = 0; i3 < 6; ++i3) {
            faces[i3] = allocMipMap();
          }
          if (typeof a02 === "number" || !a02) {
            var s4 = a02 | 0 || 1;
            for (i3 = 0; i3 < 6; ++i3) {
              parseMipMapFromShape(faces[i3], s4, s4);
            }
          } else if (typeof a02 === "object") {
            if (a12) {
              parseMipMapFromObject(faces[0], a02);
              parseMipMapFromObject(faces[1], a12);
              parseMipMapFromObject(faces[2], a24);
              parseMipMapFromObject(faces[3], a33);
              parseMipMapFromObject(faces[4], a42);
              parseMipMapFromObject(faces[5], a52);
            } else {
              parseTexInfo(texInfo, a02);
              parseFlags(texture, a02);
              if ("faces" in a02) {
                var faceInput = a02.faces;
                check$1(
                  Array.isArray(faceInput) && faceInput.length === 6,
                  "cube faces must be a length 6 array"
                );
                for (i3 = 0; i3 < 6; ++i3) {
                  check$1(
                    typeof faceInput[i3] === "object" && !!faceInput[i3],
                    "invalid input for cube map face"
                  );
                  copyFlags(faces[i3], texture);
                  parseMipMapFromObject(faces[i3], faceInput[i3]);
                }
              } else {
                for (i3 = 0; i3 < 6; ++i3) {
                  parseMipMapFromObject(faces[i3], a02);
                }
              }
            }
          } else {
            check$1.raise("invalid arguments to cube map");
          }
          copyFlags(texture, faces[0]);
          check$1.optional(function() {
            if (!limits.npotTextureCube) {
              check$1(isPow2$1(texture.width) && isPow2$1(texture.height), "your browser does not support non power or two texture dimensions");
            }
          });
          if (texInfo.genMipmaps) {
            texture.mipmask = (faces[0].width << 1) - 1;
          } else {
            texture.mipmask = faces[0].mipmask;
          }
          check$1.textureCube(texture, texInfo, faces, limits);
          texture.internalformat = faces[0].internalformat;
          reglTextureCube.width = faces[0].width;
          reglTextureCube.height = faces[0].height;
          tempBind(texture);
          for (i3 = 0; i3 < 6; ++i3) {
            setMipMap(faces[i3], GL_TEXTURE_CUBE_MAP_POSITIVE_X$1 + i3);
          }
          setTexInfo(texInfo, GL_TEXTURE_CUBE_MAP$1);
          tempRestore();
          if (config.profile) {
            texture.stats.size = getTextureSize(
              texture.internalformat,
              texture.type,
              reglTextureCube.width,
              reglTextureCube.height,
              texInfo.genMipmaps,
              true
            );
          }
          reglTextureCube.format = textureFormatsInvert[texture.internalformat];
          reglTextureCube.type = textureTypesInvert[texture.type];
          reglTextureCube.mag = magFiltersInvert[texInfo.magFilter];
          reglTextureCube.min = minFiltersInvert[texInfo.minFilter];
          reglTextureCube.wrapS = wrapModesInvert[texInfo.wrapS];
          reglTextureCube.wrapT = wrapModesInvert[texInfo.wrapT];
          for (i3 = 0; i3 < 6; ++i3) {
            freeMipMap(faces[i3]);
          }
          return reglTextureCube;
        }
        function subimage(face, image, x_, y_, level_) {
          check$1(!!image, "must specify image data");
          check$1(typeof face === "number" && face === (face | 0) && face >= 0 && face < 6, "invalid face");
          var x3 = x_ | 0;
          var y4 = y_ | 0;
          var level = level_ | 0;
          var imageData = allocImage();
          copyFlags(imageData, texture);
          imageData.width = 0;
          imageData.height = 0;
          parseImage(imageData, image);
          imageData.width = imageData.width || (texture.width >> level) - x3;
          imageData.height = imageData.height || (texture.height >> level) - y4;
          check$1(
            texture.type === imageData.type && texture.format === imageData.format && texture.internalformat === imageData.internalformat,
            "incompatible format for texture.subimage"
          );
          check$1(
            x3 >= 0 && y4 >= 0 && x3 + imageData.width <= texture.width && y4 + imageData.height <= texture.height,
            "texture.subimage write out of bounds"
          );
          check$1(
            texture.mipmask & 1 << level,
            "missing mipmap data"
          );
          check$1(
            imageData.data || imageData.element || imageData.needsCopy,
            "missing image data"
          );
          tempBind(texture);
          setSubImage(imageData, GL_TEXTURE_CUBE_MAP_POSITIVE_X$1 + face, x3, y4, level);
          tempRestore();
          freeImage(imageData);
          return reglTextureCube;
        }
        function resize(radius_) {
          var radius2 = radius_ | 0;
          if (radius2 === texture.width) {
            return;
          }
          reglTextureCube.width = texture.width = radius2;
          reglTextureCube.height = texture.height = radius2;
          tempBind(texture);
          for (var i3 = 0; i3 < 6; ++i3) {
            for (var j = 0; texture.mipmask >> j; ++j) {
              gl.texImage2D(
                GL_TEXTURE_CUBE_MAP_POSITIVE_X$1 + i3,
                j,
                texture.format,
                radius2 >> j,
                radius2 >> j,
                0,
                texture.format,
                texture.type,
                null
              );
            }
          }
          tempRestore();
          if (config.profile) {
            texture.stats.size = getTextureSize(
              texture.internalformat,
              texture.type,
              reglTextureCube.width,
              reglTextureCube.height,
              false,
              true
            );
          }
          return reglTextureCube;
        }
        reglTextureCube(a0, a1, a23, a32, a4, a5);
        reglTextureCube.subimage = subimage;
        reglTextureCube.resize = resize;
        reglTextureCube._reglType = "textureCube";
        reglTextureCube._texture = texture;
        if (config.profile) {
          reglTextureCube.stats = texture.stats;
        }
        reglTextureCube.destroy = function() {
          texture.decRef();
        };
        return reglTextureCube;
      }
      function destroyTextures() {
        for (var i3 = 0; i3 < numTexUnits; ++i3) {
          gl.activeTexture(GL_TEXTURE0$1 + i3);
          gl.bindTexture(GL_TEXTURE_2D$1, null);
          textureUnits[i3] = null;
        }
        values(textureSet).forEach(destroy3);
        stats2.cubeCount = 0;
        stats2.textureCount = 0;
      }
      if (config.profile) {
        stats2.getTotalTextureSize = function() {
          var total = 0;
          Object.keys(textureSet).forEach(function(key) {
            total += textureSet[key].stats.size;
          });
          return total;
        };
      }
      function restoreTextures() {
        for (var i3 = 0; i3 < numTexUnits; ++i3) {
          var tex = textureUnits[i3];
          if (tex) {
            tex.bindCount = 0;
            tex.unit = -1;
            textureUnits[i3] = null;
          }
        }
        values(textureSet).forEach(function(texture) {
          texture.texture = gl.createTexture();
          gl.bindTexture(texture.target, texture.texture);
          for (var i4 = 0; i4 < 32; ++i4) {
            if ((texture.mipmask & 1 << i4) === 0) {
              continue;
            }
            if (texture.target === GL_TEXTURE_2D$1) {
              gl.texImage2D(
                GL_TEXTURE_2D$1,
                i4,
                texture.internalformat,
                texture.width >> i4,
                texture.height >> i4,
                0,
                texture.internalformat,
                texture.type,
                null
              );
            } else {
              for (var j = 0; j < 6; ++j) {
                gl.texImage2D(
                  GL_TEXTURE_CUBE_MAP_POSITIVE_X$1 + j,
                  i4,
                  texture.internalformat,
                  texture.width >> i4,
                  texture.height >> i4,
                  0,
                  texture.internalformat,
                  texture.type,
                  null
                );
              }
            }
          }
          setTexInfo(texture.texInfo, texture.target);
        });
      }
      function refreshTextures() {
        for (var i3 = 0; i3 < numTexUnits; ++i3) {
          var tex = textureUnits[i3];
          if (tex) {
            tex.bindCount = 0;
            tex.unit = -1;
            textureUnits[i3] = null;
          }
          gl.activeTexture(GL_TEXTURE0$1 + i3);
          gl.bindTexture(GL_TEXTURE_2D$1, null);
          gl.bindTexture(GL_TEXTURE_CUBE_MAP$1, null);
        }
      }
      return {
        create2D: createTexture2D,
        createCube: createTextureCube,
        clear: destroyTextures,
        getTexture: function(wrapper) {
          return null;
        },
        restore: restoreTextures,
        refresh: refreshTextures
      };
    }
    var GL_RENDERBUFFER = 36161;
    var GL_RGBA4$1 = 32854;
    var GL_RGB5_A1$1 = 32855;
    var GL_RGB565$1 = 36194;
    var GL_DEPTH_COMPONENT16 = 33189;
    var GL_STENCIL_INDEX8 = 36168;
    var GL_DEPTH_STENCIL$1 = 34041;
    var GL_SRGB8_ALPHA8_EXT = 35907;
    var GL_RGBA32F_EXT = 34836;
    var GL_RGBA16F_EXT = 34842;
    var GL_RGB16F_EXT = 34843;
    var FORMAT_SIZES = [];
    FORMAT_SIZES[GL_RGBA4$1] = 2;
    FORMAT_SIZES[GL_RGB5_A1$1] = 2;
    FORMAT_SIZES[GL_RGB565$1] = 2;
    FORMAT_SIZES[GL_DEPTH_COMPONENT16] = 2;
    FORMAT_SIZES[GL_STENCIL_INDEX8] = 1;
    FORMAT_SIZES[GL_DEPTH_STENCIL$1] = 4;
    FORMAT_SIZES[GL_SRGB8_ALPHA8_EXT] = 4;
    FORMAT_SIZES[GL_RGBA32F_EXT] = 16;
    FORMAT_SIZES[GL_RGBA16F_EXT] = 8;
    FORMAT_SIZES[GL_RGB16F_EXT] = 6;
    function getRenderbufferSize(format2, width, height2) {
      return FORMAT_SIZES[format2] * width * height2;
    }
    var wrapRenderbuffers = function(gl, extensions, limits, stats2, config) {
      var formatTypes = {
        "rgba4": GL_RGBA4$1,
        "rgb565": GL_RGB565$1,
        "rgb5 a1": GL_RGB5_A1$1,
        "depth": GL_DEPTH_COMPONENT16,
        "stencil": GL_STENCIL_INDEX8,
        "depth stencil": GL_DEPTH_STENCIL$1
      };
      if (extensions.ext_srgb) {
        formatTypes["srgba"] = GL_SRGB8_ALPHA8_EXT;
      }
      if (extensions.ext_color_buffer_half_float) {
        formatTypes["rgba16f"] = GL_RGBA16F_EXT;
        formatTypes["rgb16f"] = GL_RGB16F_EXT;
      }
      if (extensions.webgl_color_buffer_float) {
        formatTypes["rgba32f"] = GL_RGBA32F_EXT;
      }
      var formatTypesInvert = [];
      Object.keys(formatTypes).forEach(function(key) {
        var val = formatTypes[key];
        formatTypesInvert[val] = key;
      });
      var renderbufferCount = 0;
      var renderbufferSet = {};
      function REGLRenderbuffer(renderbuffer) {
        this.id = renderbufferCount++;
        this.refCount = 1;
        this.renderbuffer = renderbuffer;
        this.format = GL_RGBA4$1;
        this.width = 0;
        this.height = 0;
        if (config.profile) {
          this.stats = { size: 0 };
        }
      }
      REGLRenderbuffer.prototype.decRef = function() {
        if (--this.refCount <= 0) {
          destroy3(this);
        }
      };
      function destroy3(rb) {
        var handle = rb.renderbuffer;
        check$1(handle, "must not double destroy renderbuffer");
        gl.bindRenderbuffer(GL_RENDERBUFFER, null);
        gl.deleteRenderbuffer(handle);
        rb.renderbuffer = null;
        rb.refCount = 0;
        delete renderbufferSet[rb.id];
        stats2.renderbufferCount--;
      }
      function createRenderbuffer(a4, b3) {
        var renderbuffer = new REGLRenderbuffer(gl.createRenderbuffer());
        renderbufferSet[renderbuffer.id] = renderbuffer;
        stats2.renderbufferCount++;
        function reglRenderbuffer(a5, b4) {
          var w3 = 0;
          var h6 = 0;
          var format2 = GL_RGBA4$1;
          if (typeof a5 === "object" && a5) {
            var options = a5;
            if ("shape" in options) {
              var shape = options.shape;
              check$1(
                Array.isArray(shape) && shape.length >= 2,
                "invalid renderbuffer shape"
              );
              w3 = shape[0] | 0;
              h6 = shape[1] | 0;
            } else {
              if ("radius" in options) {
                w3 = h6 = options.radius | 0;
              }
              if ("width" in options) {
                w3 = options.width | 0;
              }
              if ("height" in options) {
                h6 = options.height | 0;
              }
            }
            if ("format" in options) {
              check$1.parameter(
                options.format,
                formatTypes,
                "invalid renderbuffer format"
              );
              format2 = formatTypes[options.format];
            }
          } else if (typeof a5 === "number") {
            w3 = a5 | 0;
            if (typeof b4 === "number") {
              h6 = b4 | 0;
            } else {
              h6 = w3;
            }
          } else if (!a5) {
            w3 = h6 = 1;
          } else {
            check$1.raise("invalid arguments to renderbuffer constructor");
          }
          check$1(
            w3 > 0 && h6 > 0 && w3 <= limits.maxRenderbufferSize && h6 <= limits.maxRenderbufferSize,
            "invalid renderbuffer size"
          );
          if (w3 === renderbuffer.width && h6 === renderbuffer.height && format2 === renderbuffer.format) {
            return;
          }
          reglRenderbuffer.width = renderbuffer.width = w3;
          reglRenderbuffer.height = renderbuffer.height = h6;
          renderbuffer.format = format2;
          gl.bindRenderbuffer(GL_RENDERBUFFER, renderbuffer.renderbuffer);
          gl.renderbufferStorage(GL_RENDERBUFFER, format2, w3, h6);
          check$1(
            gl.getError() === 0,
            "invalid render buffer format"
          );
          if (config.profile) {
            renderbuffer.stats.size = getRenderbufferSize(renderbuffer.format, renderbuffer.width, renderbuffer.height);
          }
          reglRenderbuffer.format = formatTypesInvert[renderbuffer.format];
          return reglRenderbuffer;
        }
        function resize(w_, h_) {
          var w3 = w_ | 0;
          var h6 = h_ | 0 || w3;
          if (w3 === renderbuffer.width && h6 === renderbuffer.height) {
            return reglRenderbuffer;
          }
          check$1(
            w3 > 0 && h6 > 0 && w3 <= limits.maxRenderbufferSize && h6 <= limits.maxRenderbufferSize,
            "invalid renderbuffer size"
          );
          reglRenderbuffer.width = renderbuffer.width = w3;
          reglRenderbuffer.height = renderbuffer.height = h6;
          gl.bindRenderbuffer(GL_RENDERBUFFER, renderbuffer.renderbuffer);
          gl.renderbufferStorage(GL_RENDERBUFFER, renderbuffer.format, w3, h6);
          check$1(
            gl.getError() === 0,
            "invalid render buffer format"
          );
          if (config.profile) {
            renderbuffer.stats.size = getRenderbufferSize(
              renderbuffer.format,
              renderbuffer.width,
              renderbuffer.height
            );
          }
          return reglRenderbuffer;
        }
        reglRenderbuffer(a4, b3);
        reglRenderbuffer.resize = resize;
        reglRenderbuffer._reglType = "renderbuffer";
        reglRenderbuffer._renderbuffer = renderbuffer;
        if (config.profile) {
          reglRenderbuffer.stats = renderbuffer.stats;
        }
        reglRenderbuffer.destroy = function() {
          renderbuffer.decRef();
        };
        return reglRenderbuffer;
      }
      if (config.profile) {
        stats2.getTotalRenderbufferSize = function() {
          var total = 0;
          Object.keys(renderbufferSet).forEach(function(key) {
            total += renderbufferSet[key].stats.size;
          });
          return total;
        };
      }
      function restoreRenderbuffers() {
        values(renderbufferSet).forEach(function(rb) {
          rb.renderbuffer = gl.createRenderbuffer();
          gl.bindRenderbuffer(GL_RENDERBUFFER, rb.renderbuffer);
          gl.renderbufferStorage(GL_RENDERBUFFER, rb.format, rb.width, rb.height);
        });
        gl.bindRenderbuffer(GL_RENDERBUFFER, null);
      }
      return {
        create: createRenderbuffer,
        clear: function() {
          values(renderbufferSet).forEach(destroy3);
        },
        restore: restoreRenderbuffers
      };
    };
    var GL_FRAMEBUFFER$1 = 36160;
    var GL_RENDERBUFFER$1 = 36161;
    var GL_TEXTURE_2D$2 = 3553;
    var GL_TEXTURE_CUBE_MAP_POSITIVE_X$2 = 34069;
    var GL_COLOR_ATTACHMENT0$1 = 36064;
    var GL_DEPTH_ATTACHMENT = 36096;
    var GL_STENCIL_ATTACHMENT = 36128;
    var GL_DEPTH_STENCIL_ATTACHMENT = 33306;
    var GL_FRAMEBUFFER_COMPLETE$1 = 36053;
    var GL_FRAMEBUFFER_INCOMPLETE_ATTACHMENT = 36054;
    var GL_FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT = 36055;
    var GL_FRAMEBUFFER_INCOMPLETE_DIMENSIONS = 36057;
    var GL_FRAMEBUFFER_UNSUPPORTED = 36061;
    var GL_HALF_FLOAT_OES$2 = 36193;
    var GL_UNSIGNED_BYTE$6 = 5121;
    var GL_FLOAT$5 = 5126;
    var GL_RGB$1 = 6407;
    var GL_RGBA$2 = 6408;
    var GL_DEPTH_COMPONENT$1 = 6402;
    var colorTextureFormatEnums = [
      GL_RGB$1,
      GL_RGBA$2
    ];
    var textureFormatChannels = [];
    textureFormatChannels[GL_RGBA$2] = 4;
    textureFormatChannels[GL_RGB$1] = 3;
    var textureTypeSizes = [];
    textureTypeSizes[GL_UNSIGNED_BYTE$6] = 1;
    textureTypeSizes[GL_FLOAT$5] = 4;
    textureTypeSizes[GL_HALF_FLOAT_OES$2] = 2;
    var GL_RGBA4$2 = 32854;
    var GL_RGB5_A1$2 = 32855;
    var GL_RGB565$2 = 36194;
    var GL_DEPTH_COMPONENT16$1 = 33189;
    var GL_STENCIL_INDEX8$1 = 36168;
    var GL_DEPTH_STENCIL$2 = 34041;
    var GL_SRGB8_ALPHA8_EXT$1 = 35907;
    var GL_RGBA32F_EXT$1 = 34836;
    var GL_RGBA16F_EXT$1 = 34842;
    var GL_RGB16F_EXT$1 = 34843;
    var colorRenderbufferFormatEnums = [
      GL_RGBA4$2,
      GL_RGB5_A1$2,
      GL_RGB565$2,
      GL_SRGB8_ALPHA8_EXT$1,
      GL_RGBA16F_EXT$1,
      GL_RGB16F_EXT$1,
      GL_RGBA32F_EXT$1
    ];
    var statusCode = {};
    statusCode[GL_FRAMEBUFFER_COMPLETE$1] = "complete";
    statusCode[GL_FRAMEBUFFER_INCOMPLETE_ATTACHMENT] = "incomplete attachment";
    statusCode[GL_FRAMEBUFFER_INCOMPLETE_DIMENSIONS] = "incomplete dimensions";
    statusCode[GL_FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT] = "incomplete, missing attachment";
    statusCode[GL_FRAMEBUFFER_UNSUPPORTED] = "unsupported";
    function wrapFBOState(gl, extensions, limits, textureState, renderbufferState, stats2) {
      var framebufferState = {
        cur: null,
        next: null,
        dirty: false,
        setFBO: null
      };
      var colorTextureFormats = ["rgba"];
      var colorRenderbufferFormats = ["rgba4", "rgb565", "rgb5 a1"];
      if (extensions.ext_srgb) {
        colorRenderbufferFormats.push("srgba");
      }
      if (extensions.ext_color_buffer_half_float) {
        colorRenderbufferFormats.push("rgba16f", "rgb16f");
      }
      if (extensions.webgl_color_buffer_float) {
        colorRenderbufferFormats.push("rgba32f");
      }
      var colorTypes = ["uint8"];
      if (extensions.oes_texture_half_float) {
        colorTypes.push("half float", "float16");
      }
      if (extensions.oes_texture_float) {
        colorTypes.push("float", "float32");
      }
      function FramebufferAttachment(target2, texture, renderbuffer) {
        this.target = target2;
        this.texture = texture;
        this.renderbuffer = renderbuffer;
        var w3 = 0;
        var h6 = 0;
        if (texture) {
          w3 = texture.width;
          h6 = texture.height;
        } else if (renderbuffer) {
          w3 = renderbuffer.width;
          h6 = renderbuffer.height;
        }
        this.width = w3;
        this.height = h6;
      }
      function decRef(attachment) {
        if (attachment) {
          if (attachment.texture) {
            attachment.texture._texture.decRef();
          }
          if (attachment.renderbuffer) {
            attachment.renderbuffer._renderbuffer.decRef();
          }
        }
      }
      function incRefAndCheckShape(attachment, width, height2) {
        if (!attachment) {
          return;
        }
        if (attachment.texture) {
          var texture = attachment.texture._texture;
          var tw = Math.max(1, texture.width);
          var th = Math.max(1, texture.height);
          check$1(
            tw === width && th === height2,
            "inconsistent width/height for supplied texture"
          );
          texture.refCount += 1;
        } else {
          var renderbuffer = attachment.renderbuffer._renderbuffer;
          check$1(
            renderbuffer.width === width && renderbuffer.height === height2,
            "inconsistent width/height for renderbuffer"
          );
          renderbuffer.refCount += 1;
        }
      }
      function attach(location, attachment) {
        if (attachment) {
          if (attachment.texture) {
            gl.framebufferTexture2D(
              GL_FRAMEBUFFER$1,
              location,
              attachment.target,
              attachment.texture._texture.texture,
              0
            );
          } else {
            gl.framebufferRenderbuffer(
              GL_FRAMEBUFFER$1,
              location,
              GL_RENDERBUFFER$1,
              attachment.renderbuffer._renderbuffer.renderbuffer
            );
          }
        }
      }
      function parseAttachment(attachment) {
        var target2 = GL_TEXTURE_2D$2;
        var texture = null;
        var renderbuffer = null;
        var data = attachment;
        if (typeof attachment === "object") {
          data = attachment.data;
          if ("target" in attachment) {
            target2 = attachment.target | 0;
          }
        }
        check$1.type(data, "function", "invalid attachment data");
        var type2 = data._reglType;
        if (type2 === "texture2d") {
          texture = data;
          check$1(target2 === GL_TEXTURE_2D$2);
        } else if (type2 === "textureCube") {
          texture = data;
          check$1(
            target2 >= GL_TEXTURE_CUBE_MAP_POSITIVE_X$2 && target2 < GL_TEXTURE_CUBE_MAP_POSITIVE_X$2 + 6,
            "invalid cube map target"
          );
        } else if (type2 === "renderbuffer") {
          renderbuffer = data;
          target2 = GL_RENDERBUFFER$1;
        } else {
          check$1.raise("invalid regl object for attachment");
        }
        return new FramebufferAttachment(target2, texture, renderbuffer);
      }
      function allocAttachment(width, height2, isTexture, format2, type2) {
        if (isTexture) {
          var texture = textureState.create2D({
            width,
            height: height2,
            format: format2,
            type: type2
          });
          texture._texture.refCount = 0;
          return new FramebufferAttachment(GL_TEXTURE_2D$2, texture, null);
        } else {
          var rb = renderbufferState.create({
            width,
            height: height2,
            format: format2
          });
          rb._renderbuffer.refCount = 0;
          return new FramebufferAttachment(GL_RENDERBUFFER$1, null, rb);
        }
      }
      function unwrapAttachment(attachment) {
        return attachment && (attachment.texture || attachment.renderbuffer);
      }
      function resizeAttachment(attachment, w3, h6) {
        if (attachment) {
          if (attachment.texture) {
            attachment.texture.resize(w3, h6);
          } else if (attachment.renderbuffer) {
            attachment.renderbuffer.resize(w3, h6);
          }
          attachment.width = w3;
          attachment.height = h6;
        }
      }
      var framebufferCount = 0;
      var framebufferSet = {};
      function REGLFramebuffer() {
        this.id = framebufferCount++;
        framebufferSet[this.id] = this;
        this.framebuffer = gl.createFramebuffer();
        this.width = 0;
        this.height = 0;
        this.colorAttachments = [];
        this.depthAttachment = null;
        this.stencilAttachment = null;
        this.depthStencilAttachment = null;
      }
      function decFBORefs(framebuffer) {
        framebuffer.colorAttachments.forEach(decRef);
        decRef(framebuffer.depthAttachment);
        decRef(framebuffer.stencilAttachment);
        decRef(framebuffer.depthStencilAttachment);
      }
      function destroy3(framebuffer) {
        var handle = framebuffer.framebuffer;
        check$1(handle, "must not double destroy framebuffer");
        gl.deleteFramebuffer(handle);
        framebuffer.framebuffer = null;
        stats2.framebufferCount--;
        delete framebufferSet[framebuffer.id];
      }
      function updateFramebuffer(framebuffer) {
        var i3;
        gl.bindFramebuffer(GL_FRAMEBUFFER$1, framebuffer.framebuffer);
        var colorAttachments = framebuffer.colorAttachments;
        for (i3 = 0; i3 < colorAttachments.length; ++i3) {
          attach(GL_COLOR_ATTACHMENT0$1 + i3, colorAttachments[i3]);
        }
        for (i3 = colorAttachments.length; i3 < limits.maxColorAttachments; ++i3) {
          gl.framebufferTexture2D(
            GL_FRAMEBUFFER$1,
            GL_COLOR_ATTACHMENT0$1 + i3,
            GL_TEXTURE_2D$2,
            null,
            0
          );
        }
        gl.framebufferTexture2D(
          GL_FRAMEBUFFER$1,
          GL_DEPTH_STENCIL_ATTACHMENT,
          GL_TEXTURE_2D$2,
          null,
          0
        );
        gl.framebufferTexture2D(
          GL_FRAMEBUFFER$1,
          GL_DEPTH_ATTACHMENT,
          GL_TEXTURE_2D$2,
          null,
          0
        );
        gl.framebufferTexture2D(
          GL_FRAMEBUFFER$1,
          GL_STENCIL_ATTACHMENT,
          GL_TEXTURE_2D$2,
          null,
          0
        );
        attach(GL_DEPTH_ATTACHMENT, framebuffer.depthAttachment);
        attach(GL_STENCIL_ATTACHMENT, framebuffer.stencilAttachment);
        attach(GL_DEPTH_STENCIL_ATTACHMENT, framebuffer.depthStencilAttachment);
        var status = gl.checkFramebufferStatus(GL_FRAMEBUFFER$1);
        if (!gl.isContextLost() && status !== GL_FRAMEBUFFER_COMPLETE$1) {
          check$1.raise("framebuffer configuration not supported, status = " + statusCode[status]);
        }
        gl.bindFramebuffer(GL_FRAMEBUFFER$1, framebufferState.next ? framebufferState.next.framebuffer : null);
        framebufferState.cur = framebufferState.next;
        gl.getError();
      }
      function createFBO(a0, a1) {
        var framebuffer = new REGLFramebuffer();
        stats2.framebufferCount++;
        function reglFramebuffer(a4, b3) {
          var i3;
          check$1(
            framebufferState.next !== framebuffer,
            "can not update framebuffer which is currently in use"
          );
          var width = 0;
          var height2 = 0;
          var needsDepth = true;
          var needsStencil = true;
          var colorBuffer = null;
          var colorTexture = true;
          var colorFormat = "rgba";
          var colorType = "uint8";
          var colorCount = 1;
          var depthBuffer = null;
          var stencilBuffer = null;
          var depthStencilBuffer = null;
          var depthStencilTexture = false;
          if (typeof a4 === "number") {
            width = a4 | 0;
            height2 = b3 | 0 || width;
          } else if (!a4) {
            width = height2 = 1;
          } else {
            check$1.type(a4, "object", "invalid arguments for framebuffer");
            var options = a4;
            if ("shape" in options) {
              var shape = options.shape;
              check$1(
                Array.isArray(shape) && shape.length >= 2,
                "invalid shape for framebuffer"
              );
              width = shape[0];
              height2 = shape[1];
            } else {
              if ("radius" in options) {
                width = height2 = options.radius;
              }
              if ("width" in options) {
                width = options.width;
              }
              if ("height" in options) {
                height2 = options.height;
              }
            }
            if ("color" in options || "colors" in options) {
              colorBuffer = options.color || options.colors;
              if (Array.isArray(colorBuffer)) {
                check$1(
                  colorBuffer.length === 1 || extensions.webgl_draw_buffers,
                  "multiple render targets not supported"
                );
              }
            }
            if (!colorBuffer) {
              if ("colorCount" in options) {
                colorCount = options.colorCount | 0;
                check$1(colorCount > 0, "invalid color buffer count");
              }
              if ("colorTexture" in options) {
                colorTexture = !!options.colorTexture;
                colorFormat = "rgba4";
              }
              if ("colorType" in options) {
                colorType = options.colorType;
                if (!colorTexture) {
                  if (colorType === "half float" || colorType === "float16") {
                    check$1(
                      extensions.ext_color_buffer_half_float,
                      "you must enable EXT_color_buffer_half_float to use 16-bit render buffers"
                    );
                    colorFormat = "rgba16f";
                  } else if (colorType === "float" || colorType === "float32") {
                    check$1(
                      extensions.webgl_color_buffer_float,
                      "you must enable WEBGL_color_buffer_float in order to use 32-bit floating point renderbuffers"
                    );
                    colorFormat = "rgba32f";
                  }
                } else {
                  check$1(
                    extensions.oes_texture_float || !(colorType === "float" || colorType === "float32"),
                    "you must enable OES_texture_float in order to use floating point framebuffer objects"
                  );
                  check$1(
                    extensions.oes_texture_half_float || !(colorType === "half float" || colorType === "float16"),
                    "you must enable OES_texture_half_float in order to use 16-bit floating point framebuffer objects"
                  );
                }
                check$1.oneOf(colorType, colorTypes, "invalid color type");
              }
              if ("colorFormat" in options) {
                colorFormat = options.colorFormat;
                if (colorTextureFormats.indexOf(colorFormat) >= 0) {
                  colorTexture = true;
                } else if (colorRenderbufferFormats.indexOf(colorFormat) >= 0) {
                  colorTexture = false;
                } else {
                  check$1.optional(function() {
                    if (colorTexture) {
                      check$1.oneOf(
                        options.colorFormat,
                        colorTextureFormats,
                        "invalid color format for texture"
                      );
                    } else {
                      check$1.oneOf(
                        options.colorFormat,
                        colorRenderbufferFormats,
                        "invalid color format for renderbuffer"
                      );
                    }
                  });
                }
              }
            }
            if ("depthTexture" in options || "depthStencilTexture" in options) {
              depthStencilTexture = !!(options.depthTexture || options.depthStencilTexture);
              check$1(
                !depthStencilTexture || extensions.webgl_depth_texture,
                "webgl_depth_texture extension not supported"
              );
            }
            if ("depth" in options) {
              if (typeof options.depth === "boolean") {
                needsDepth = options.depth;
              } else {
                depthBuffer = options.depth;
                needsStencil = false;
              }
            }
            if ("stencil" in options) {
              if (typeof options.stencil === "boolean") {
                needsStencil = options.stencil;
              } else {
                stencilBuffer = options.stencil;
                needsDepth = false;
              }
            }
            if ("depthStencil" in options) {
              if (typeof options.depthStencil === "boolean") {
                needsDepth = needsStencil = options.depthStencil;
              } else {
                depthStencilBuffer = options.depthStencil;
                needsDepth = false;
                needsStencil = false;
              }
            }
          }
          var colorAttachments = null;
          var depthAttachment = null;
          var stencilAttachment = null;
          var depthStencilAttachment = null;
          if (Array.isArray(colorBuffer)) {
            colorAttachments = colorBuffer.map(parseAttachment);
          } else if (colorBuffer) {
            colorAttachments = [parseAttachment(colorBuffer)];
          } else {
            colorAttachments = new Array(colorCount);
            for (i3 = 0; i3 < colorCount; ++i3) {
              colorAttachments[i3] = allocAttachment(
                width,
                height2,
                colorTexture,
                colorFormat,
                colorType
              );
            }
          }
          check$1(
            extensions.webgl_draw_buffers || colorAttachments.length <= 1,
            "you must enable the WEBGL_draw_buffers extension in order to use multiple color buffers."
          );
          check$1(
            colorAttachments.length <= limits.maxColorAttachments,
            "too many color attachments, not supported"
          );
          width = width || colorAttachments[0].width;
          height2 = height2 || colorAttachments[0].height;
          if (depthBuffer) {
            depthAttachment = parseAttachment(depthBuffer);
          } else if (needsDepth && !needsStencil) {
            depthAttachment = allocAttachment(
              width,
              height2,
              depthStencilTexture,
              "depth",
              "uint32"
            );
          }
          if (stencilBuffer) {
            stencilAttachment = parseAttachment(stencilBuffer);
          } else if (needsStencil && !needsDepth) {
            stencilAttachment = allocAttachment(
              width,
              height2,
              false,
              "stencil",
              "uint8"
            );
          }
          if (depthStencilBuffer) {
            depthStencilAttachment = parseAttachment(depthStencilBuffer);
          } else if (!depthBuffer && !stencilBuffer && needsStencil && needsDepth) {
            depthStencilAttachment = allocAttachment(
              width,
              height2,
              depthStencilTexture,
              "depth stencil",
              "depth stencil"
            );
          }
          check$1(
            !!depthBuffer + !!stencilBuffer + !!depthStencilBuffer <= 1,
            "invalid framebuffer configuration, can specify exactly one depth/stencil attachment"
          );
          var commonColorAttachmentSize = null;
          for (i3 = 0; i3 < colorAttachments.length; ++i3) {
            incRefAndCheckShape(colorAttachments[i3], width, height2);
            check$1(
              !colorAttachments[i3] || colorAttachments[i3].texture && colorTextureFormatEnums.indexOf(colorAttachments[i3].texture._texture.format) >= 0 || colorAttachments[i3].renderbuffer && colorRenderbufferFormatEnums.indexOf(colorAttachments[i3].renderbuffer._renderbuffer.format) >= 0,
              "framebuffer color attachment " + i3 + " is invalid"
            );
            if (colorAttachments[i3] && colorAttachments[i3].texture) {
              var colorAttachmentSize = textureFormatChannels[colorAttachments[i3].texture._texture.format] * textureTypeSizes[colorAttachments[i3].texture._texture.type];
              if (commonColorAttachmentSize === null) {
                commonColorAttachmentSize = colorAttachmentSize;
              } else {
                check$1(
                  commonColorAttachmentSize === colorAttachmentSize,
                  "all color attachments much have the same number of bits per pixel."
                );
              }
            }
          }
          incRefAndCheckShape(depthAttachment, width, height2);
          check$1(
            !depthAttachment || depthAttachment.texture && depthAttachment.texture._texture.format === GL_DEPTH_COMPONENT$1 || depthAttachment.renderbuffer && depthAttachment.renderbuffer._renderbuffer.format === GL_DEPTH_COMPONENT16$1,
            "invalid depth attachment for framebuffer object"
          );
          incRefAndCheckShape(stencilAttachment, width, height2);
          check$1(
            !stencilAttachment || stencilAttachment.renderbuffer && stencilAttachment.renderbuffer._renderbuffer.format === GL_STENCIL_INDEX8$1,
            "invalid stencil attachment for framebuffer object"
          );
          incRefAndCheckShape(depthStencilAttachment, width, height2);
          check$1(
            !depthStencilAttachment || depthStencilAttachment.texture && depthStencilAttachment.texture._texture.format === GL_DEPTH_STENCIL$2 || depthStencilAttachment.renderbuffer && depthStencilAttachment.renderbuffer._renderbuffer.format === GL_DEPTH_STENCIL$2,
            "invalid depth-stencil attachment for framebuffer object"
          );
          decFBORefs(framebuffer);
          framebuffer.width = width;
          framebuffer.height = height2;
          framebuffer.colorAttachments = colorAttachments;
          framebuffer.depthAttachment = depthAttachment;
          framebuffer.stencilAttachment = stencilAttachment;
          framebuffer.depthStencilAttachment = depthStencilAttachment;
          reglFramebuffer.color = colorAttachments.map(unwrapAttachment);
          reglFramebuffer.depth = unwrapAttachment(depthAttachment);
          reglFramebuffer.stencil = unwrapAttachment(stencilAttachment);
          reglFramebuffer.depthStencil = unwrapAttachment(depthStencilAttachment);
          reglFramebuffer.width = framebuffer.width;
          reglFramebuffer.height = framebuffer.height;
          updateFramebuffer(framebuffer);
          return reglFramebuffer;
        }
        function resize(w_, h_) {
          check$1(
            framebufferState.next !== framebuffer,
            "can not resize a framebuffer which is currently in use"
          );
          var w3 = Math.max(w_ | 0, 1);
          var h6 = Math.max(h_ | 0 || w3, 1);
          if (w3 === framebuffer.width && h6 === framebuffer.height) {
            return reglFramebuffer;
          }
          var colorAttachments = framebuffer.colorAttachments;
          for (var i3 = 0; i3 < colorAttachments.length; ++i3) {
            resizeAttachment(colorAttachments[i3], w3, h6);
          }
          resizeAttachment(framebuffer.depthAttachment, w3, h6);
          resizeAttachment(framebuffer.stencilAttachment, w3, h6);
          resizeAttachment(framebuffer.depthStencilAttachment, w3, h6);
          framebuffer.width = reglFramebuffer.width = w3;
          framebuffer.height = reglFramebuffer.height = h6;
          updateFramebuffer(framebuffer);
          return reglFramebuffer;
        }
        reglFramebuffer(a0, a1);
        return extend2(reglFramebuffer, {
          resize,
          _reglType: "framebuffer",
          _framebuffer: framebuffer,
          destroy: function() {
            destroy3(framebuffer);
            decFBORefs(framebuffer);
          },
          use: function(block) {
            framebufferState.setFBO({
              framebuffer: reglFramebuffer
            }, block);
          }
        });
      }
      function createCubeFBO(options) {
        var faces = Array(6);
        function reglFramebufferCube(a4) {
          var i3;
          check$1(
            faces.indexOf(framebufferState.next) < 0,
            "can not update framebuffer which is currently in use"
          );
          var params = {
            color: null
          };
          var radius2 = 0;
          var colorBuffer = null;
          var colorFormat = "rgba";
          var colorType = "uint8";
          var colorCount = 1;
          if (typeof a4 === "number") {
            radius2 = a4 | 0;
          } else if (!a4) {
            radius2 = 1;
          } else {
            check$1.type(a4, "object", "invalid arguments for framebuffer");
            var options2 = a4;
            if ("shape" in options2) {
              var shape = options2.shape;
              check$1(
                Array.isArray(shape) && shape.length >= 2,
                "invalid shape for framebuffer"
              );
              check$1(
                shape[0] === shape[1],
                "cube framebuffer must be square"
              );
              radius2 = shape[0];
            } else {
              if ("radius" in options2) {
                radius2 = options2.radius | 0;
              }
              if ("width" in options2) {
                radius2 = options2.width | 0;
                if ("height" in options2) {
                  check$1(options2.height === radius2, "must be square");
                }
              } else if ("height" in options2) {
                radius2 = options2.height | 0;
              }
            }
            if ("color" in options2 || "colors" in options2) {
              colorBuffer = options2.color || options2.colors;
              if (Array.isArray(colorBuffer)) {
                check$1(
                  colorBuffer.length === 1 || extensions.webgl_draw_buffers,
                  "multiple render targets not supported"
                );
              }
            }
            if (!colorBuffer) {
              if ("colorCount" in options2) {
                colorCount = options2.colorCount | 0;
                check$1(colorCount > 0, "invalid color buffer count");
              }
              if ("colorType" in options2) {
                check$1.oneOf(
                  options2.colorType,
                  colorTypes,
                  "invalid color type"
                );
                colorType = options2.colorType;
              }
              if ("colorFormat" in options2) {
                colorFormat = options2.colorFormat;
                check$1.oneOf(
                  options2.colorFormat,
                  colorTextureFormats,
                  "invalid color format for texture"
                );
              }
            }
            if ("depth" in options2) {
              params.depth = options2.depth;
            }
            if ("stencil" in options2) {
              params.stencil = options2.stencil;
            }
            if ("depthStencil" in options2) {
              params.depthStencil = options2.depthStencil;
            }
          }
          var colorCubes;
          if (colorBuffer) {
            if (Array.isArray(colorBuffer)) {
              colorCubes = [];
              for (i3 = 0; i3 < colorBuffer.length; ++i3) {
                colorCubes[i3] = colorBuffer[i3];
              }
            } else {
              colorCubes = [colorBuffer];
            }
          } else {
            colorCubes = Array(colorCount);
            var cubeMapParams = {
              radius: radius2,
              format: colorFormat,
              type: colorType
            };
            for (i3 = 0; i3 < colorCount; ++i3) {
              colorCubes[i3] = textureState.createCube(cubeMapParams);
            }
          }
          params.color = Array(colorCubes.length);
          for (i3 = 0; i3 < colorCubes.length; ++i3) {
            var cube = colorCubes[i3];
            check$1(
              typeof cube === "function" && cube._reglType === "textureCube",
              "invalid cube map"
            );
            radius2 = radius2 || cube.width;
            check$1(
              cube.width === radius2 && cube.height === radius2,
              "invalid cube map shape"
            );
            params.color[i3] = {
              target: GL_TEXTURE_CUBE_MAP_POSITIVE_X$2,
              data: colorCubes[i3]
            };
          }
          for (i3 = 0; i3 < 6; ++i3) {
            for (var j = 0; j < colorCubes.length; ++j) {
              params.color[j].target = GL_TEXTURE_CUBE_MAP_POSITIVE_X$2 + i3;
            }
            if (i3 > 0) {
              params.depth = faces[0].depth;
              params.stencil = faces[0].stencil;
              params.depthStencil = faces[0].depthStencil;
            }
            if (faces[i3]) {
              faces[i3](params);
            } else {
              faces[i3] = createFBO(params);
            }
          }
          return extend2(reglFramebufferCube, {
            width: radius2,
            height: radius2,
            color: colorCubes
          });
        }
        function resize(radius_) {
          var i3;
          var radius2 = radius_ | 0;
          check$1(
            radius2 > 0 && radius2 <= limits.maxCubeMapSize,
            "invalid radius for cube fbo"
          );
          if (radius2 === reglFramebufferCube.width) {
            return reglFramebufferCube;
          }
          var colors2 = reglFramebufferCube.color;
          for (i3 = 0; i3 < colors2.length; ++i3) {
            colors2[i3].resize(radius2);
          }
          for (i3 = 0; i3 < 6; ++i3) {
            faces[i3].resize(radius2);
          }
          reglFramebufferCube.width = reglFramebufferCube.height = radius2;
          return reglFramebufferCube;
        }
        reglFramebufferCube(options);
        return extend2(reglFramebufferCube, {
          faces,
          resize,
          _reglType: "framebufferCube",
          destroy: function() {
            faces.forEach(function(f) {
              f.destroy();
            });
          }
        });
      }
      function restoreFramebuffers() {
        framebufferState.cur = null;
        framebufferState.next = null;
        framebufferState.dirty = true;
        values(framebufferSet).forEach(function(fb) {
          fb.framebuffer = gl.createFramebuffer();
          updateFramebuffer(fb);
        });
      }
      return extend2(framebufferState, {
        getFramebuffer: function(object) {
          if (typeof object === "function" && object._reglType === "framebuffer") {
            var fbo = object._framebuffer;
            if (fbo instanceof REGLFramebuffer) {
              return fbo;
            }
          }
          return null;
        },
        create: createFBO,
        createCube: createCubeFBO,
        clear: function() {
          values(framebufferSet).forEach(destroy3);
        },
        restore: restoreFramebuffers
      });
    }
    var GL_FLOAT$6 = 5126;
    var GL_ARRAY_BUFFER$1 = 34962;
    var GL_ELEMENT_ARRAY_BUFFER$1 = 34963;
    var VAO_OPTIONS = [
      "attributes",
      "elements",
      "offset",
      "count",
      "primitive",
      "instances"
    ];
    function AttributeRecord() {
      this.state = 0;
      this.x = 0;
      this.y = 0;
      this.z = 0;
      this.w = 0;
      this.buffer = null;
      this.size = 0;
      this.normalized = false;
      this.type = GL_FLOAT$6;
      this.offset = 0;
      this.stride = 0;
      this.divisor = 0;
    }
    function wrapAttributeState(gl, extensions, limits, stats2, bufferState, elementState, drawState) {
      var NUM_ATTRIBUTES = limits.maxAttributes;
      var attributeBindings = new Array(NUM_ATTRIBUTES);
      for (var i3 = 0; i3 < NUM_ATTRIBUTES; ++i3) {
        attributeBindings[i3] = new AttributeRecord();
      }
      var vaoCount = 0;
      var vaoSet = {};
      var state2 = {
        Record: AttributeRecord,
        scope: {},
        state: attributeBindings,
        currentVAO: null,
        targetVAO: null,
        restore: extVAO() ? restoreVAO : function() {
        },
        createVAO,
        getVAO,
        destroyBuffer,
        setVAO: extVAO() ? setVAOEXT : setVAOEmulated,
        clear: extVAO() ? destroyVAOEXT : function() {
        }
      };
      function destroyBuffer(buffer) {
        for (var i4 = 0; i4 < attributeBindings.length; ++i4) {
          var record = attributeBindings[i4];
          if (record.buffer === buffer) {
            gl.disableVertexAttribArray(i4);
            record.buffer = null;
          }
        }
      }
      function extVAO() {
        return extensions.oes_vertex_array_object;
      }
      function extInstanced() {
        return extensions.angle_instanced_arrays;
      }
      function getVAO(vao) {
        if (typeof vao === "function" && vao._vao) {
          return vao._vao;
        }
        return null;
      }
      function setVAOEXT(vao) {
        if (vao === state2.currentVAO) {
          return;
        }
        var ext = extVAO();
        if (vao) {
          ext.bindVertexArrayOES(vao.vao);
        } else {
          ext.bindVertexArrayOES(null);
        }
        state2.currentVAO = vao;
      }
      function setVAOEmulated(vao) {
        if (vao === state2.currentVAO) {
          return;
        }
        if (vao) {
          vao.bindAttrs();
        } else {
          var exti = extInstanced();
          for (var i4 = 0; i4 < attributeBindings.length; ++i4) {
            var binding = attributeBindings[i4];
            if (binding.buffer) {
              gl.enableVertexAttribArray(i4);
              binding.buffer.bind();
              gl.vertexAttribPointer(i4, binding.size, binding.type, binding.normalized, binding.stride, binding.offfset);
              if (exti && binding.divisor) {
                exti.vertexAttribDivisorANGLE(i4, binding.divisor);
              }
            } else {
              gl.disableVertexAttribArray(i4);
              gl.vertexAttrib4f(i4, binding.x, binding.y, binding.z, binding.w);
            }
          }
          if (drawState.elements) {
            gl.bindBuffer(GL_ELEMENT_ARRAY_BUFFER$1, drawState.elements.buffer.buffer);
          } else {
            gl.bindBuffer(GL_ELEMENT_ARRAY_BUFFER$1, null);
          }
        }
        state2.currentVAO = vao;
      }
      function destroyVAOEXT() {
        values(vaoSet).forEach(function(vao) {
          vao.destroy();
        });
      }
      function REGLVAO() {
        this.id = ++vaoCount;
        this.attributes = [];
        this.elements = null;
        this.ownsElements = false;
        this.count = 0;
        this.offset = 0;
        this.instances = -1;
        this.primitive = 4;
        var extension = extVAO();
        if (extension) {
          this.vao = extension.createVertexArrayOES();
        } else {
          this.vao = null;
        }
        vaoSet[this.id] = this;
        this.buffers = [];
      }
      REGLVAO.prototype.bindAttrs = function() {
        var exti = extInstanced();
        var attributes = this.attributes;
        for (var i4 = 0; i4 < attributes.length; ++i4) {
          var attr = attributes[i4];
          if (attr.buffer) {
            gl.enableVertexAttribArray(i4);
            gl.bindBuffer(GL_ARRAY_BUFFER$1, attr.buffer.buffer);
            gl.vertexAttribPointer(i4, attr.size, attr.type, attr.normalized, attr.stride, attr.offset);
            if (exti && attr.divisor) {
              exti.vertexAttribDivisorANGLE(i4, attr.divisor);
            }
          } else {
            gl.disableVertexAttribArray(i4);
            gl.vertexAttrib4f(i4, attr.x, attr.y, attr.z, attr.w);
          }
        }
        for (var j = attributes.length; j < NUM_ATTRIBUTES; ++j) {
          gl.disableVertexAttribArray(j);
        }
        var elements = elementState.getElements(this.elements);
        if (elements) {
          gl.bindBuffer(GL_ELEMENT_ARRAY_BUFFER$1, elements.buffer.buffer);
        } else {
          gl.bindBuffer(GL_ELEMENT_ARRAY_BUFFER$1, null);
        }
      };
      REGLVAO.prototype.refresh = function() {
        var ext = extVAO();
        if (ext) {
          ext.bindVertexArrayOES(this.vao);
          this.bindAttrs();
          state2.currentVAO = null;
          ext.bindVertexArrayOES(null);
        }
      };
      REGLVAO.prototype.destroy = function() {
        if (this.vao) {
          var extension = extVAO();
          if (this === state2.currentVAO) {
            state2.currentVAO = null;
            extension.bindVertexArrayOES(null);
          }
          extension.deleteVertexArrayOES(this.vao);
          this.vao = null;
        }
        if (this.ownsElements) {
          this.elements.destroy();
          this.elements = null;
          this.ownsElements = false;
        }
        if (vaoSet[this.id]) {
          delete vaoSet[this.id];
          stats2.vaoCount -= 1;
        }
      };
      function restoreVAO() {
        var ext = extVAO();
        if (ext) {
          values(vaoSet).forEach(function(vao) {
            vao.refresh();
          });
        }
      }
      function createVAO(_attr) {
        var vao = new REGLVAO();
        stats2.vaoCount += 1;
        function updateVAO(options) {
          var attributes;
          if (Array.isArray(options)) {
            attributes = options;
            if (vao.elements && vao.ownsElements) {
              vao.elements.destroy();
            }
            vao.elements = null;
            vao.ownsElements = false;
            vao.offset = 0;
            vao.count = 0;
            vao.instances = -1;
            vao.primitive = 4;
          } else {
            check$1(typeof options === "object", "invalid arguments for create vao");
            check$1("attributes" in options, "must specify attributes for vao");
            if (options.elements) {
              var elements = options.elements;
              if (vao.ownsElements) {
                if (typeof elements === "function" && elements._reglType === "elements") {
                  vao.elements.destroy();
                  vao.ownsElements = false;
                } else {
                  vao.elements(elements);
                  vao.ownsElements = false;
                }
              } else if (elementState.getElements(options.elements)) {
                vao.elements = options.elements;
                vao.ownsElements = false;
              } else {
                vao.elements = elementState.create(options.elements);
                vao.ownsElements = true;
              }
            } else {
              vao.elements = null;
              vao.ownsElements = false;
            }
            attributes = options.attributes;
            vao.offset = 0;
            vao.count = -1;
            vao.instances = -1;
            vao.primitive = 4;
            if (vao.elements) {
              vao.count = vao.elements._elements.vertCount;
              vao.primitive = vao.elements._elements.primType;
            }
            if ("offset" in options) {
              vao.offset = options.offset | 0;
            }
            if ("count" in options) {
              vao.count = options.count | 0;
            }
            if ("instances" in options) {
              vao.instances = options.instances | 0;
            }
            if ("primitive" in options) {
              check$1(options.primitive in primTypes, "bad primitive type: " + options.primitive);
              vao.primitive = primTypes[options.primitive];
            }
            check$1.optional(() => {
              var keys2 = Object.keys(options);
              for (var i5 = 0; i5 < keys2.length; ++i5) {
                check$1(VAO_OPTIONS.indexOf(keys2[i5]) >= 0, 'invalid option for vao: "' + keys2[i5] + '" valid options are ' + VAO_OPTIONS);
              }
            });
            check$1(Array.isArray(attributes), "attributes must be an array");
          }
          check$1(attributes.length < NUM_ATTRIBUTES, "too many attributes");
          check$1(attributes.length > 0, "must specify at least one attribute");
          var bufUpdated = {};
          var nattributes = vao.attributes;
          nattributes.length = attributes.length;
          for (var i4 = 0; i4 < attributes.length; ++i4) {
            var spec = attributes[i4];
            var rec = nattributes[i4] = new AttributeRecord();
            var data = spec.data || spec;
            if (Array.isArray(data) || isTypedArray(data) || isNDArrayLike(data)) {
              var buf2;
              if (vao.buffers[i4]) {
                buf2 = vao.buffers[i4];
                if (isTypedArray(data) && buf2._buffer.byteLength >= data.byteLength) {
                  buf2.subdata(data);
                } else {
                  buf2.destroy();
                  vao.buffers[i4] = null;
                }
              }
              if (!vao.buffers[i4]) {
                buf2 = vao.buffers[i4] = bufferState.create(spec, GL_ARRAY_BUFFER$1, false, true);
              }
              rec.buffer = bufferState.getBuffer(buf2);
              rec.size = rec.buffer.dimension | 0;
              rec.normalized = false;
              rec.type = rec.buffer.dtype;
              rec.offset = 0;
              rec.stride = 0;
              rec.divisor = 0;
              rec.state = 1;
              bufUpdated[i4] = 1;
            } else if (bufferState.getBuffer(spec)) {
              rec.buffer = bufferState.getBuffer(spec);
              rec.size = rec.buffer.dimension | 0;
              rec.normalized = false;
              rec.type = rec.buffer.dtype;
              rec.offset = 0;
              rec.stride = 0;
              rec.divisor = 0;
              rec.state = 1;
            } else if (bufferState.getBuffer(spec.buffer)) {
              rec.buffer = bufferState.getBuffer(spec.buffer);
              rec.size = (+spec.size || rec.buffer.dimension) | 0;
              rec.normalized = !!spec.normalized || false;
              if ("type" in spec) {
                check$1.parameter(spec.type, glTypes, "invalid buffer type");
                rec.type = glTypes[spec.type];
              } else {
                rec.type = rec.buffer.dtype;
              }
              rec.offset = (spec.offset || 0) | 0;
              rec.stride = (spec.stride || 0) | 0;
              rec.divisor = (spec.divisor || 0) | 0;
              rec.state = 1;
              check$1(rec.size >= 1 && rec.size <= 4, "size must be between 1 and 4");
              check$1(rec.offset >= 0, "invalid offset");
              check$1(rec.stride >= 0 && rec.stride <= 255, "stride must be between 0 and 255");
              check$1(rec.divisor >= 0, "divisor must be positive");
              check$1(!rec.divisor || !!extensions.angle_instanced_arrays, "ANGLE_instanced_arrays must be enabled to use divisor");
            } else if ("x" in spec) {
              check$1(i4 > 0, "first attribute must not be a constant");
              rec.x = +spec.x || 0;
              rec.y = +spec.y || 0;
              rec.z = +spec.z || 0;
              rec.w = +spec.w || 0;
              rec.state = 2;
            } else {
              check$1(false, "invalid attribute spec for location " + i4);
            }
          }
          for (var j = 0; j < vao.buffers.length; ++j) {
            if (!bufUpdated[j] && vao.buffers[j]) {
              vao.buffers[j].destroy();
              vao.buffers[j] = null;
            }
          }
          vao.refresh();
          return updateVAO;
        }
        updateVAO.destroy = function() {
          for (var j = 0; j < vao.buffers.length; ++j) {
            if (vao.buffers[j]) {
              vao.buffers[j].destroy();
            }
          }
          vao.buffers.length = 0;
          if (vao.ownsElements) {
            vao.elements.destroy();
            vao.elements = null;
            vao.ownsElements = false;
          }
          vao.destroy();
        };
        updateVAO._vao = vao;
        updateVAO._reglType = "vao";
        return updateVAO(_attr);
      }
      return state2;
    }
    var GL_FRAGMENT_SHADER = 35632;
    var GL_VERTEX_SHADER = 35633;
    var GL_ACTIVE_UNIFORMS = 35718;
    var GL_ACTIVE_ATTRIBUTES = 35721;
    function wrapShaderState(gl, stringStore, stats2, config) {
      var fragShaders = {};
      var vertShaders = {};
      function ActiveInfo(name2, id3, location, info) {
        this.name = name2;
        this.id = id3;
        this.location = location;
        this.info = info;
      }
      function insertActiveInfo(list, info) {
        for (var i3 = 0; i3 < list.length; ++i3) {
          if (list[i3].id === info.id) {
            list[i3].location = info.location;
            return;
          }
        }
        list.push(info);
      }
      function getShader(type2, id3, command) {
        var cache = type2 === GL_FRAGMENT_SHADER ? fragShaders : vertShaders;
        var shader = cache[id3];
        if (!shader) {
          var source = stringStore.str(id3);
          shader = gl.createShader(type2);
          gl.shaderSource(shader, source);
          gl.compileShader(shader);
          check$1.shaderError(gl, shader, source, type2, command);
          cache[id3] = shader;
        }
        return shader;
      }
      var programCache = {};
      var programList = [];
      var PROGRAM_COUNTER = 0;
      function REGLProgram(fragId, vertId) {
        this.id = PROGRAM_COUNTER++;
        this.fragId = fragId;
        this.vertId = vertId;
        this.program = null;
        this.uniforms = [];
        this.attributes = [];
        this.refCount = 1;
        if (config.profile) {
          this.stats = {
            uniformsCount: 0,
            attributesCount: 0
          };
        }
      }
      function linkProgram(desc, command, attributeLocations) {
        var i3, info;
        var fragShader = getShader(GL_FRAGMENT_SHADER, desc.fragId);
        var vertShader = getShader(GL_VERTEX_SHADER, desc.vertId);
        var program = desc.program = gl.createProgram();
        gl.attachShader(program, fragShader);
        gl.attachShader(program, vertShader);
        if (attributeLocations) {
          for (i3 = 0; i3 < attributeLocations.length; ++i3) {
            var binding = attributeLocations[i3];
            gl.bindAttribLocation(program, binding[0], binding[1]);
          }
        }
        gl.linkProgram(program);
        check$1.linkError(
          gl,
          program,
          stringStore.str(desc.fragId),
          stringStore.str(desc.vertId),
          command
        );
        var numUniforms = gl.getProgramParameter(program, GL_ACTIVE_UNIFORMS);
        if (config.profile) {
          desc.stats.uniformsCount = numUniforms;
        }
        var uniforms = desc.uniforms;
        for (i3 = 0; i3 < numUniforms; ++i3) {
          info = gl.getActiveUniform(program, i3);
          if (info) {
            if (info.size > 1) {
              for (var j = 0; j < info.size; ++j) {
                var name2 = info.name.replace("[0]", "[" + j + "]");
                insertActiveInfo(uniforms, new ActiveInfo(
                  name2,
                  stringStore.id(name2),
                  gl.getUniformLocation(program, name2),
                  info
                ));
              }
            } else {
              insertActiveInfo(uniforms, new ActiveInfo(
                info.name,
                stringStore.id(info.name),
                gl.getUniformLocation(program, info.name),
                info
              ));
            }
          }
        }
        var numAttributes = gl.getProgramParameter(program, GL_ACTIVE_ATTRIBUTES);
        if (config.profile) {
          desc.stats.attributesCount = numAttributes;
        }
        var attributes = desc.attributes;
        for (i3 = 0; i3 < numAttributes; ++i3) {
          info = gl.getActiveAttrib(program, i3);
          if (info) {
            insertActiveInfo(attributes, new ActiveInfo(
              info.name,
              stringStore.id(info.name),
              gl.getAttribLocation(program, info.name),
              info
            ));
          }
        }
      }
      if (config.profile) {
        stats2.getMaxUniformsCount = function() {
          var m4 = 0;
          programList.forEach(function(desc) {
            if (desc.stats.uniformsCount > m4) {
              m4 = desc.stats.uniformsCount;
            }
          });
          return m4;
        };
        stats2.getMaxAttributesCount = function() {
          var m4 = 0;
          programList.forEach(function(desc) {
            if (desc.stats.attributesCount > m4) {
              m4 = desc.stats.attributesCount;
            }
          });
          return m4;
        };
      }
      function restoreShaders() {
        fragShaders = {};
        vertShaders = {};
        for (var i3 = 0; i3 < programList.length; ++i3) {
          linkProgram(programList[i3], null, programList[i3].attributes.map(function(info) {
            return [info.location, info.name];
          }));
        }
      }
      return {
        clear: function() {
          var deleteShader = gl.deleteShader.bind(gl);
          values(fragShaders).forEach(deleteShader);
          fragShaders = {};
          values(vertShaders).forEach(deleteShader);
          vertShaders = {};
          programList.forEach(function(desc) {
            gl.deleteProgram(desc.program);
          });
          programList.length = 0;
          programCache = {};
          stats2.shaderCount = 0;
        },
        program: function(vertId, fragId, command, attribLocations) {
          check$1.command(vertId >= 0, "missing vertex shader", command);
          check$1.command(fragId >= 0, "missing fragment shader", command);
          var cache = programCache[fragId];
          if (!cache) {
            cache = programCache[fragId] = {};
          }
          var prevProgram = cache[vertId];
          if (prevProgram) {
            prevProgram.refCount++;
            if (!attribLocations) {
              return prevProgram;
            }
          }
          var program = new REGLProgram(fragId, vertId);
          stats2.shaderCount++;
          linkProgram(program, command, attribLocations);
          if (!prevProgram) {
            cache[vertId] = program;
          }
          programList.push(program);
          return extend2(program, {
            destroy: function() {
              program.refCount--;
              if (program.refCount <= 0) {
                gl.deleteProgram(program.program);
                var idx = programList.indexOf(program);
                programList.splice(idx, 1);
                stats2.shaderCount--;
              }
              if (cache[program.vertId].refCount <= 0) {
                gl.deleteShader(vertShaders[program.vertId]);
                delete vertShaders[program.vertId];
                delete programCache[program.fragId][program.vertId];
              }
              if (!Object.keys(programCache[program.fragId]).length) {
                gl.deleteShader(fragShaders[program.fragId]);
                delete fragShaders[program.fragId];
                delete programCache[program.fragId];
              }
            }
          });
        },
        restore: restoreShaders,
        shader: getShader,
        frag: -1,
        vert: -1
      };
    }
    var GL_RGBA$3 = 6408;
    var GL_UNSIGNED_BYTE$7 = 5121;
    var GL_PACK_ALIGNMENT = 3333;
    var GL_FLOAT$7 = 5126;
    function wrapReadPixels(gl, framebufferState, reglPoll, context, glAttributes, extensions, limits) {
      function readPixelsImpl(input) {
        var type2;
        if (framebufferState.next === null) {
          check$1(
            glAttributes.preserveDrawingBuffer,
            'you must create a webgl context with "preserveDrawingBuffer":true in order to read pixels from the drawing buffer'
          );
          type2 = GL_UNSIGNED_BYTE$7;
        } else {
          check$1(
            framebufferState.next.colorAttachments[0].texture !== null,
            "You cannot read from a renderbuffer"
          );
          type2 = framebufferState.next.colorAttachments[0].texture._texture.type;
          check$1.optional(function() {
            if (extensions.oes_texture_float) {
              check$1(
                type2 === GL_UNSIGNED_BYTE$7 || type2 === GL_FLOAT$7,
                "Reading from a framebuffer is only allowed for the types 'uint8' and 'float'"
              );
              if (type2 === GL_FLOAT$7) {
                check$1(limits.readFloat, "Reading 'float' values is not permitted in your browser. For a fallback, please see: https://www.npmjs.com/package/glsl-read-float");
              }
            } else {
              check$1(
                type2 === GL_UNSIGNED_BYTE$7,
                "Reading from a framebuffer is only allowed for the type 'uint8'"
              );
            }
          });
        }
        var x3 = 0;
        var y4 = 0;
        var width = context.framebufferWidth;
        var height2 = context.framebufferHeight;
        var data = null;
        if (isTypedArray(input)) {
          data = input;
        } else if (input) {
          check$1.type(input, "object", "invalid arguments to regl.read()");
          x3 = input.x | 0;
          y4 = input.y | 0;
          check$1(
            x3 >= 0 && x3 < context.framebufferWidth,
            "invalid x offset for regl.read"
          );
          check$1(
            y4 >= 0 && y4 < context.framebufferHeight,
            "invalid y offset for regl.read"
          );
          width = (input.width || context.framebufferWidth - x3) | 0;
          height2 = (input.height || context.framebufferHeight - y4) | 0;
          data = input.data || null;
        }
        if (data) {
          if (type2 === GL_UNSIGNED_BYTE$7) {
            check$1(
              data instanceof Uint8Array,
              "buffer must be 'Uint8Array' when reading from a framebuffer of type 'uint8'"
            );
          } else if (type2 === GL_FLOAT$7) {
            check$1(
              data instanceof Float32Array,
              "buffer must be 'Float32Array' when reading from a framebuffer of type 'float'"
            );
          }
        }
        check$1(
          width > 0 && width + x3 <= context.framebufferWidth,
          "invalid width for read pixels"
        );
        check$1(
          height2 > 0 && height2 + y4 <= context.framebufferHeight,
          "invalid height for read pixels"
        );
        reglPoll();
        var size2 = width * height2 * 4;
        if (!data) {
          if (type2 === GL_UNSIGNED_BYTE$7) {
            data = new Uint8Array(size2);
          } else if (type2 === GL_FLOAT$7) {
            data = data || new Float32Array(size2);
          }
        }
        check$1.isTypedArray(data, "data buffer for regl.read() must be a typedarray");
        check$1(data.byteLength >= size2, "data buffer for regl.read() too small");
        gl.pixelStorei(GL_PACK_ALIGNMENT, 4);
        gl.readPixels(
          x3,
          y4,
          width,
          height2,
          GL_RGBA$3,
          type2,
          data
        );
        return data;
      }
      function readPixelsFBO(options) {
        var result;
        framebufferState.setFBO({
          framebuffer: options.framebuffer
        }, function() {
          result = readPixelsImpl(options);
        });
        return result;
      }
      function readPixels(options) {
        if (!options || !("framebuffer" in options)) {
          return readPixelsImpl(options);
        } else {
          return readPixelsFBO(options);
        }
      }
      return readPixels;
    }
    function slice(x3) {
      return Array.prototype.slice.call(x3);
    }
    function join(x3) {
      return slice(x3).join("");
    }
    function createEnvironment() {
      var varCounter = 0;
      var linkedNames = [];
      var linkedValues = [];
      function link(value2) {
        for (var i3 = 0; i3 < linkedValues.length; ++i3) {
          if (linkedValues[i3] === value2) {
            return linkedNames[i3];
          }
        }
        var name2 = "g" + varCounter++;
        linkedNames.push(name2);
        linkedValues.push(value2);
        return name2;
      }
      function block() {
        var code = [];
        function push2() {
          code.push.apply(code, slice(arguments));
        }
        var vars = [];
        function def() {
          var name2 = "v" + varCounter++;
          vars.push(name2);
          if (arguments.length > 0) {
            code.push(name2, "=");
            code.push.apply(code, slice(arguments));
            code.push(";");
          }
          return name2;
        }
        return extend2(push2, {
          def,
          toString: function() {
            return join([
              vars.length > 0 ? "var " + vars.join(",") + ";" : "",
              join(code)
            ]);
          }
        });
      }
      function scope() {
        var entry = block();
        var exit = block();
        var entryToString = entry.toString;
        var exitToString = exit.toString;
        function save(object, prop) {
          exit(object, prop, "=", entry.def(object, prop), ";");
        }
        return extend2(function() {
          entry.apply(entry, slice(arguments));
        }, {
          def: entry.def,
          entry,
          exit,
          save,
          set: function(object, prop, value2) {
            save(object, prop);
            entry(object, prop, "=", value2, ";");
          },
          toString: function() {
            return entryToString() + exitToString();
          }
        });
      }
      function conditional2() {
        var pred = join(arguments);
        var thenBlock = scope();
        var elseBlock = scope();
        var thenToString = thenBlock.toString;
        var elseToString = elseBlock.toString;
        return extend2(thenBlock, {
          then: function() {
            thenBlock.apply(thenBlock, slice(arguments));
            return this;
          },
          else: function() {
            elseBlock.apply(elseBlock, slice(arguments));
            return this;
          },
          toString: function() {
            var elseClause = elseToString();
            if (elseClause) {
              elseClause = "else{" + elseClause + "}";
            }
            return join([
              "if(",
              pred,
              "){",
              thenToString(),
              "}",
              elseClause
            ]);
          }
        });
      }
      var globalBlock = block();
      var procedures = {};
      function proc(name2, count) {
        var args = [];
        function arg() {
          var name3 = "a" + args.length;
          args.push(name3);
          return name3;
        }
        count = count || 0;
        for (var i3 = 0; i3 < count; ++i3) {
          arg();
        }
        var body = scope();
        var bodyToString = body.toString;
        var result = procedures[name2] = extend2(body, {
          arg,
          toString: function() {
            return join([
              "function(",
              args.join(),
              "){",
              bodyToString(),
              "}"
            ]);
          }
        });
        return result;
      }
      function compile() {
        var code = [
          '"use strict";',
          globalBlock,
          "return {"
        ];
        Object.keys(procedures).forEach(function(name2) {
          code.push('"', name2, '":', procedures[name2].toString(), ",");
        });
        code.push("}");
        var src = join(code).replace(/;/g, ";\n").replace(/}/g, "}\n").replace(/{/g, "{\n");
        var proc2 = Function.apply(null, linkedNames.concat(src));
        return proc2.apply(null, linkedValues);
      }
      return {
        global: globalBlock,
        link,
        block,
        proc,
        scope,
        cond: conditional2,
        compile
      };
    }
    var CUTE_COMPONENTS = "xyzw".split("");
    var GL_UNSIGNED_BYTE$8 = 5121;
    var ATTRIB_STATE_POINTER = 1;
    var ATTRIB_STATE_CONSTANT = 2;
    var DYN_FUNC$1 = 0;
    var DYN_PROP$1 = 1;
    var DYN_CONTEXT$1 = 2;
    var DYN_STATE$1 = 3;
    var DYN_THUNK = 4;
    var DYN_CONSTANT$1 = 5;
    var DYN_ARRAY$1 = 6;
    var S_DITHER = "dither";
    var S_BLEND_ENABLE = "blend.enable";
    var S_BLEND_COLOR = "blend.color";
    var S_BLEND_EQUATION = "blend.equation";
    var S_BLEND_FUNC = "blend.func";
    var S_DEPTH_ENABLE = "depth.enable";
    var S_DEPTH_FUNC = "depth.func";
    var S_DEPTH_RANGE = "depth.range";
    var S_DEPTH_MASK = "depth.mask";
    var S_COLOR_MASK = "colorMask";
    var S_CULL_ENABLE = "cull.enable";
    var S_CULL_FACE = "cull.face";
    var S_FRONT_FACE = "frontFace";
    var S_LINE_WIDTH = "lineWidth";
    var S_POLYGON_OFFSET_ENABLE = "polygonOffset.enable";
    var S_POLYGON_OFFSET_OFFSET = "polygonOffset.offset";
    var S_SAMPLE_ALPHA = "sample.alpha";
    var S_SAMPLE_ENABLE = "sample.enable";
    var S_SAMPLE_COVERAGE = "sample.coverage";
    var S_STENCIL_ENABLE = "stencil.enable";
    var S_STENCIL_MASK = "stencil.mask";
    var S_STENCIL_FUNC = "stencil.func";
    var S_STENCIL_OPFRONT = "stencil.opFront";
    var S_STENCIL_OPBACK = "stencil.opBack";
    var S_SCISSOR_ENABLE = "scissor.enable";
    var S_SCISSOR_BOX = "scissor.box";
    var S_VIEWPORT = "viewport";
    var S_PROFILE = "profile";
    var S_FRAMEBUFFER = "framebuffer";
    var S_VERT = "vert";
    var S_FRAG = "frag";
    var S_ELEMENTS = "elements";
    var S_PRIMITIVE = "primitive";
    var S_COUNT = "count";
    var S_OFFSET = "offset";
    var S_INSTANCES = "instances";
    var S_VAO = "vao";
    var SUFFIX_WIDTH = "Width";
    var SUFFIX_HEIGHT = "Height";
    var S_FRAMEBUFFER_WIDTH = S_FRAMEBUFFER + SUFFIX_WIDTH;
    var S_FRAMEBUFFER_HEIGHT = S_FRAMEBUFFER + SUFFIX_HEIGHT;
    var S_VIEWPORT_WIDTH = S_VIEWPORT + SUFFIX_WIDTH;
    var S_VIEWPORT_HEIGHT = S_VIEWPORT + SUFFIX_HEIGHT;
    var S_DRAWINGBUFFER = "drawingBuffer";
    var S_DRAWINGBUFFER_WIDTH = S_DRAWINGBUFFER + SUFFIX_WIDTH;
    var S_DRAWINGBUFFER_HEIGHT = S_DRAWINGBUFFER + SUFFIX_HEIGHT;
    var NESTED_OPTIONS = [
      S_BLEND_FUNC,
      S_BLEND_EQUATION,
      S_STENCIL_FUNC,
      S_STENCIL_OPFRONT,
      S_STENCIL_OPBACK,
      S_SAMPLE_COVERAGE,
      S_VIEWPORT,
      S_SCISSOR_BOX,
      S_POLYGON_OFFSET_OFFSET
    ];
    var GL_ARRAY_BUFFER$2 = 34962;
    var GL_ELEMENT_ARRAY_BUFFER$2 = 34963;
    var GL_FRAGMENT_SHADER$1 = 35632;
    var GL_VERTEX_SHADER$1 = 35633;
    var GL_TEXTURE_2D$3 = 3553;
    var GL_TEXTURE_CUBE_MAP$2 = 34067;
    var GL_CULL_FACE = 2884;
    var GL_BLEND = 3042;
    var GL_DITHER = 3024;
    var GL_STENCIL_TEST = 2960;
    var GL_DEPTH_TEST = 2929;
    var GL_SCISSOR_TEST = 3089;
    var GL_POLYGON_OFFSET_FILL = 32823;
    var GL_SAMPLE_ALPHA_TO_COVERAGE = 32926;
    var GL_SAMPLE_COVERAGE = 32928;
    var GL_FLOAT$8 = 5126;
    var GL_FLOAT_VEC2 = 35664;
    var GL_FLOAT_VEC3 = 35665;
    var GL_FLOAT_VEC4 = 35666;
    var GL_INT$3 = 5124;
    var GL_INT_VEC2 = 35667;
    var GL_INT_VEC3 = 35668;
    var GL_INT_VEC4 = 35669;
    var GL_BOOL = 35670;
    var GL_BOOL_VEC2 = 35671;
    var GL_BOOL_VEC3 = 35672;
    var GL_BOOL_VEC4 = 35673;
    var GL_FLOAT_MAT2 = 35674;
    var GL_FLOAT_MAT3 = 35675;
    var GL_FLOAT_MAT4 = 35676;
    var GL_SAMPLER_2D = 35678;
    var GL_SAMPLER_CUBE = 35680;
    var GL_TRIANGLES$1 = 4;
    var GL_FRONT = 1028;
    var GL_BACK = 1029;
    var GL_CW = 2304;
    var GL_CCW = 2305;
    var GL_MIN_EXT = 32775;
    var GL_MAX_EXT = 32776;
    var GL_ALWAYS = 519;
    var GL_KEEP = 7680;
    var GL_ZERO = 0;
    var GL_ONE = 1;
    var GL_FUNC_ADD = 32774;
    var GL_LESS = 513;
    var GL_FRAMEBUFFER$2 = 36160;
    var GL_COLOR_ATTACHMENT0$2 = 36064;
    var blendFuncs = {
      "0": 0,
      "1": 1,
      "zero": 0,
      "one": 1,
      "src color": 768,
      "one minus src color": 769,
      "src alpha": 770,
      "one minus src alpha": 771,
      "dst color": 774,
      "one minus dst color": 775,
      "dst alpha": 772,
      "one minus dst alpha": 773,
      "constant color": 32769,
      "one minus constant color": 32770,
      "constant alpha": 32771,
      "one minus constant alpha": 32772,
      "src alpha saturate": 776
    };
    var invalidBlendCombinations = [
      "constant color, constant alpha",
      "one minus constant color, constant alpha",
      "constant color, one minus constant alpha",
      "one minus constant color, one minus constant alpha",
      "constant alpha, constant color",
      "constant alpha, one minus constant color",
      "one minus constant alpha, constant color",
      "one minus constant alpha, one minus constant color"
    ];
    var compareFuncs = {
      "never": 512,
      "less": 513,
      "<": 513,
      "equal": 514,
      "=": 514,
      "==": 514,
      "===": 514,
      "lequal": 515,
      "<=": 515,
      "greater": 516,
      ">": 516,
      "notequal": 517,
      "!=": 517,
      "!==": 517,
      "gequal": 518,
      ">=": 518,
      "always": 519
    };
    var stencilOps = {
      "0": 0,
      "zero": 0,
      "keep": 7680,
      "replace": 7681,
      "increment": 7682,
      "decrement": 7683,
      "increment wrap": 34055,
      "decrement wrap": 34056,
      "invert": 5386
    };
    var shaderType = {
      "frag": GL_FRAGMENT_SHADER$1,
      "vert": GL_VERTEX_SHADER$1
    };
    var orientationType = {
      "cw": GL_CW,
      "ccw": GL_CCW
    };
    function isBufferArgs(x3) {
      return Array.isArray(x3) || isTypedArray(x3) || isNDArrayLike(x3);
    }
    function sortState(state2) {
      return state2.sort(function(a4, b3) {
        if (a4 === S_VIEWPORT) {
          return -1;
        } else if (b3 === S_VIEWPORT) {
          return 1;
        }
        return a4 < b3 ? -1 : 1;
      });
    }
    function Declaration(thisDep, contextDep, propDep, append) {
      this.thisDep = thisDep;
      this.contextDep = contextDep;
      this.propDep = propDep;
      this.append = append;
    }
    function isStatic(decl) {
      return decl && !(decl.thisDep || decl.contextDep || decl.propDep);
    }
    function createStaticDecl(append) {
      return new Declaration(false, false, false, append);
    }
    function createDynamicDecl(dyn, append) {
      var type2 = dyn.type;
      if (type2 === DYN_FUNC$1) {
        var numArgs = dyn.data.length;
        return new Declaration(
          true,
          numArgs >= 1,
          numArgs >= 2,
          append
        );
      } else if (type2 === DYN_THUNK) {
        var data = dyn.data;
        return new Declaration(
          data.thisDep,
          data.contextDep,
          data.propDep,
          append
        );
      } else if (type2 === DYN_CONSTANT$1) {
        return new Declaration(
          false,
          false,
          false,
          append
        );
      } else if (type2 === DYN_ARRAY$1) {
        var thisDep = false;
        var contextDep = false;
        var propDep = false;
        for (var i3 = 0; i3 < dyn.data.length; ++i3) {
          var subDyn = dyn.data[i3];
          if (subDyn.type === DYN_PROP$1) {
            propDep = true;
          } else if (subDyn.type === DYN_CONTEXT$1) {
            contextDep = true;
          } else if (subDyn.type === DYN_STATE$1) {
            thisDep = true;
          } else if (subDyn.type === DYN_FUNC$1) {
            thisDep = true;
            var subArgs = subDyn.data;
            if (subArgs >= 1) {
              contextDep = true;
            }
            if (subArgs >= 2) {
              propDep = true;
            }
          } else if (subDyn.type === DYN_THUNK) {
            thisDep = thisDep || subDyn.data.thisDep;
            contextDep = contextDep || subDyn.data.contextDep;
            propDep = propDep || subDyn.data.propDep;
          }
        }
        return new Declaration(
          thisDep,
          contextDep,
          propDep,
          append
        );
      } else {
        return new Declaration(
          type2 === DYN_STATE$1,
          type2 === DYN_CONTEXT$1,
          type2 === DYN_PROP$1,
          append
        );
      }
    }
    var SCOPE_DECL = new Declaration(false, false, false, function() {
    });
    function reglCore(gl, stringStore, extensions, limits, bufferState, elementState, textureState, framebufferState, uniformState, attributeState, shaderState, drawState, contextState, timer, config) {
      var AttributeRecord2 = attributeState.Record;
      var blendEquations = {
        "add": 32774,
        "subtract": 32778,
        "reverse subtract": 32779
      };
      if (extensions.ext_blend_minmax) {
        blendEquations.min = GL_MIN_EXT;
        blendEquations.max = GL_MAX_EXT;
      }
      var extInstancing = extensions.angle_instanced_arrays;
      var extDrawBuffers = extensions.webgl_draw_buffers;
      var extVertexArrays = extensions.oes_vertex_array_object;
      var currentState = {
        dirty: true,
        profile: config.profile
      };
      var nextState = {};
      var GL_STATE_NAMES = [];
      var GL_FLAGS = {};
      var GL_VARIABLES = {};
      function propName(name2) {
        return name2.replace(".", "_");
      }
      function stateFlag(sname, cap, init) {
        var name2 = propName(sname);
        GL_STATE_NAMES.push(sname);
        nextState[name2] = currentState[name2] = !!init;
        GL_FLAGS[name2] = cap;
      }
      function stateVariable(sname, func, init) {
        var name2 = propName(sname);
        GL_STATE_NAMES.push(sname);
        if (Array.isArray(init)) {
          currentState[name2] = init.slice();
          nextState[name2] = init.slice();
        } else {
          currentState[name2] = nextState[name2] = init;
        }
        GL_VARIABLES[name2] = func;
      }
      stateFlag(S_DITHER, GL_DITHER);
      stateFlag(S_BLEND_ENABLE, GL_BLEND);
      stateVariable(S_BLEND_COLOR, "blendColor", [0, 0, 0, 0]);
      stateVariable(
        S_BLEND_EQUATION,
        "blendEquationSeparate",
        [GL_FUNC_ADD, GL_FUNC_ADD]
      );
      stateVariable(
        S_BLEND_FUNC,
        "blendFuncSeparate",
        [GL_ONE, GL_ZERO, GL_ONE, GL_ZERO]
      );
      stateFlag(S_DEPTH_ENABLE, GL_DEPTH_TEST, true);
      stateVariable(S_DEPTH_FUNC, "depthFunc", GL_LESS);
      stateVariable(S_DEPTH_RANGE, "depthRange", [0, 1]);
      stateVariable(S_DEPTH_MASK, "depthMask", true);
      stateVariable(S_COLOR_MASK, S_COLOR_MASK, [true, true, true, true]);
      stateFlag(S_CULL_ENABLE, GL_CULL_FACE);
      stateVariable(S_CULL_FACE, "cullFace", GL_BACK);
      stateVariable(S_FRONT_FACE, S_FRONT_FACE, GL_CCW);
      stateVariable(S_LINE_WIDTH, S_LINE_WIDTH, 1);
      stateFlag(S_POLYGON_OFFSET_ENABLE, GL_POLYGON_OFFSET_FILL);
      stateVariable(S_POLYGON_OFFSET_OFFSET, "polygonOffset", [0, 0]);
      stateFlag(S_SAMPLE_ALPHA, GL_SAMPLE_ALPHA_TO_COVERAGE);
      stateFlag(S_SAMPLE_ENABLE, GL_SAMPLE_COVERAGE);
      stateVariable(S_SAMPLE_COVERAGE, "sampleCoverage", [1, false]);
      stateFlag(S_STENCIL_ENABLE, GL_STENCIL_TEST);
      stateVariable(S_STENCIL_MASK, "stencilMask", -1);
      stateVariable(S_STENCIL_FUNC, "stencilFunc", [GL_ALWAYS, 0, -1]);
      stateVariable(
        S_STENCIL_OPFRONT,
        "stencilOpSeparate",
        [GL_FRONT, GL_KEEP, GL_KEEP, GL_KEEP]
      );
      stateVariable(
        S_STENCIL_OPBACK,
        "stencilOpSeparate",
        [GL_BACK, GL_KEEP, GL_KEEP, GL_KEEP]
      );
      stateFlag(S_SCISSOR_ENABLE, GL_SCISSOR_TEST);
      stateVariable(
        S_SCISSOR_BOX,
        "scissor",
        [0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight]
      );
      stateVariable(
        S_VIEWPORT,
        S_VIEWPORT,
        [0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight]
      );
      var sharedState = {
        gl,
        context: contextState,
        strings: stringStore,
        next: nextState,
        current: currentState,
        draw: drawState,
        elements: elementState,
        buffer: bufferState,
        shader: shaderState,
        attributes: attributeState.state,
        vao: attributeState,
        uniforms: uniformState,
        framebuffer: framebufferState,
        extensions,
        timer,
        isBufferArgs
      };
      var sharedConstants = {
        primTypes,
        compareFuncs,
        blendFuncs,
        blendEquations,
        stencilOps,
        glTypes,
        orientationType
      };
      check$1.optional(function() {
        sharedState.isArrayLike = isArrayLike;
      });
      if (extDrawBuffers) {
        sharedConstants.backBuffer = [GL_BACK];
        sharedConstants.drawBuffer = loop(limits.maxDrawbuffers, function(i3) {
          if (i3 === 0) {
            return [0];
          }
          return loop(i3, function(j) {
            return GL_COLOR_ATTACHMENT0$2 + j;
          });
        });
      }
      var drawCallCounter = 0;
      function createREGLEnvironment() {
        var env = createEnvironment();
        var link = env.link;
        var global2 = env.global;
        env.id = drawCallCounter++;
        env.batchId = "0";
        var SHARED = link(sharedState);
        var shared = env.shared = {
          props: "a0"
        };
        Object.keys(sharedState).forEach(function(prop) {
          shared[prop] = global2.def(SHARED, ".", prop);
        });
        check$1.optional(function() {
          env.CHECK = link(check$1);
          env.commandStr = check$1.guessCommand();
          env.command = link(env.commandStr);
          env.assert = function(block, pred, message) {
            block(
              "if(!(",
              pred,
              "))",
              this.CHECK,
              ".commandRaise(",
              link(message),
              ",",
              this.command,
              ");"
            );
          };
          sharedConstants.invalidBlendCombinations = invalidBlendCombinations;
        });
        var nextVars = env.next = {};
        var currentVars = env.current = {};
        Object.keys(GL_VARIABLES).forEach(function(variable) {
          if (Array.isArray(currentState[variable])) {
            nextVars[variable] = global2.def(shared.next, ".", variable);
            currentVars[variable] = global2.def(shared.current, ".", variable);
          }
        });
        var constants = env.constants = {};
        Object.keys(sharedConstants).forEach(function(name2) {
          constants[name2] = global2.def(JSON.stringify(sharedConstants[name2]));
        });
        env.invoke = function(block, x3) {
          switch (x3.type) {
            case DYN_FUNC$1:
              var argList = [
                "this",
                shared.context,
                shared.props,
                env.batchId
              ];
              return block.def(
                link(x3.data),
                ".call(",
                argList.slice(0, Math.max(x3.data.length + 1, 4)),
                ")"
              );
            case DYN_PROP$1:
              return block.def(shared.props, x3.data);
            case DYN_CONTEXT$1:
              return block.def(shared.context, x3.data);
            case DYN_STATE$1:
              return block.def("this", x3.data);
            case DYN_THUNK:
              x3.data.append(env, block);
              return x3.data.ref;
            case DYN_CONSTANT$1:
              return x3.data.toString();
            case DYN_ARRAY$1:
              return x3.data.map(function(y4) {
                return env.invoke(block, y4);
              });
          }
        };
        env.attribCache = {};
        var scopeAttribs = {};
        env.scopeAttrib = function(name2) {
          var id3 = stringStore.id(name2);
          if (id3 in scopeAttribs) {
            return scopeAttribs[id3];
          }
          var binding = attributeState.scope[id3];
          if (!binding) {
            binding = attributeState.scope[id3] = new AttributeRecord2();
          }
          var result = scopeAttribs[id3] = link(binding);
          return result;
        };
        return env;
      }
      function parseProfile(options) {
        var staticOptions = options.static;
        var dynamicOptions = options.dynamic;
        var profileEnable;
        if (S_PROFILE in staticOptions) {
          var value2 = !!staticOptions[S_PROFILE];
          profileEnable = createStaticDecl(function(env, scope) {
            return value2;
          });
          profileEnable.enable = value2;
        } else if (S_PROFILE in dynamicOptions) {
          var dyn = dynamicOptions[S_PROFILE];
          profileEnable = createDynamicDecl(dyn, function(env, scope) {
            return env.invoke(scope, dyn);
          });
        }
        return profileEnable;
      }
      function parseFramebuffer(options, env) {
        var staticOptions = options.static;
        var dynamicOptions = options.dynamic;
        if (S_FRAMEBUFFER in staticOptions) {
          var framebuffer = staticOptions[S_FRAMEBUFFER];
          if (framebuffer) {
            framebuffer = framebufferState.getFramebuffer(framebuffer);
            check$1.command(framebuffer, "invalid framebuffer object");
            return createStaticDecl(function(env2, block) {
              var FRAMEBUFFER = env2.link(framebuffer);
              var shared = env2.shared;
              block.set(
                shared.framebuffer,
                ".next",
                FRAMEBUFFER
              );
              var CONTEXT = shared.context;
              block.set(
                CONTEXT,
                "." + S_FRAMEBUFFER_WIDTH,
                FRAMEBUFFER + ".width"
              );
              block.set(
                CONTEXT,
                "." + S_FRAMEBUFFER_HEIGHT,
                FRAMEBUFFER + ".height"
              );
              return FRAMEBUFFER;
            });
          } else {
            return createStaticDecl(function(env2, scope) {
              var shared = env2.shared;
              scope.set(
                shared.framebuffer,
                ".next",
                "null"
              );
              var CONTEXT = shared.context;
              scope.set(
                CONTEXT,
                "." + S_FRAMEBUFFER_WIDTH,
                CONTEXT + "." + S_DRAWINGBUFFER_WIDTH
              );
              scope.set(
                CONTEXT,
                "." + S_FRAMEBUFFER_HEIGHT,
                CONTEXT + "." + S_DRAWINGBUFFER_HEIGHT
              );
              return "null";
            });
          }
        } else if (S_FRAMEBUFFER in dynamicOptions) {
          var dyn = dynamicOptions[S_FRAMEBUFFER];
          return createDynamicDecl(dyn, function(env2, scope) {
            var FRAMEBUFFER_FUNC = env2.invoke(scope, dyn);
            var shared = env2.shared;
            var FRAMEBUFFER_STATE = shared.framebuffer;
            var FRAMEBUFFER = scope.def(
              FRAMEBUFFER_STATE,
              ".getFramebuffer(",
              FRAMEBUFFER_FUNC,
              ")"
            );
            check$1.optional(function() {
              env2.assert(
                scope,
                "!" + FRAMEBUFFER_FUNC + "||" + FRAMEBUFFER,
                "invalid framebuffer object"
              );
            });
            scope.set(
              FRAMEBUFFER_STATE,
              ".next",
              FRAMEBUFFER
            );
            var CONTEXT = shared.context;
            scope.set(
              CONTEXT,
              "." + S_FRAMEBUFFER_WIDTH,
              FRAMEBUFFER + "?" + FRAMEBUFFER + ".width:" + CONTEXT + "." + S_DRAWINGBUFFER_WIDTH
            );
            scope.set(
              CONTEXT,
              "." + S_FRAMEBUFFER_HEIGHT,
              FRAMEBUFFER + "?" + FRAMEBUFFER + ".height:" + CONTEXT + "." + S_DRAWINGBUFFER_HEIGHT
            );
            return FRAMEBUFFER;
          });
        } else {
          return null;
        }
      }
      function parseViewportScissor(options, framebuffer, env) {
        var staticOptions = options.static;
        var dynamicOptions = options.dynamic;
        function parseBox(param) {
          if (param in staticOptions) {
            var box = staticOptions[param];
            check$1.commandType(box, "object", "invalid " + param, env.commandStr);
            var isStatic2 = true;
            var x3 = box.x | 0;
            var y4 = box.y | 0;
            var w3, h6;
            if ("width" in box) {
              w3 = box.width | 0;
              check$1.command(w3 >= 0, "invalid " + param, env.commandStr);
            } else {
              isStatic2 = false;
            }
            if ("height" in box) {
              h6 = box.height | 0;
              check$1.command(h6 >= 0, "invalid " + param, env.commandStr);
            } else {
              isStatic2 = false;
            }
            return new Declaration(
              !isStatic2 && framebuffer && framebuffer.thisDep,
              !isStatic2 && framebuffer && framebuffer.contextDep,
              !isStatic2 && framebuffer && framebuffer.propDep,
              function(env2, scope) {
                var CONTEXT = env2.shared.context;
                var BOX_W = w3;
                if (!("width" in box)) {
                  BOX_W = scope.def(CONTEXT, ".", S_FRAMEBUFFER_WIDTH, "-", x3);
                }
                var BOX_H = h6;
                if (!("height" in box)) {
                  BOX_H = scope.def(CONTEXT, ".", S_FRAMEBUFFER_HEIGHT, "-", y4);
                }
                return [x3, y4, BOX_W, BOX_H];
              }
            );
          } else if (param in dynamicOptions) {
            var dynBox = dynamicOptions[param];
            var result = createDynamicDecl(dynBox, function(env2, scope) {
              var BOX = env2.invoke(scope, dynBox);
              check$1.optional(function() {
                env2.assert(
                  scope,
                  BOX + "&&typeof " + BOX + '==="object"',
                  "invalid " + param
                );
              });
              var CONTEXT = env2.shared.context;
              var BOX_X = scope.def(BOX, ".x|0");
              var BOX_Y = scope.def(BOX, ".y|0");
              var BOX_W = scope.def(
                '"width" in ',
                BOX,
                "?",
                BOX,
                ".width|0:",
                "(",
                CONTEXT,
                ".",
                S_FRAMEBUFFER_WIDTH,
                "-",
                BOX_X,
                ")"
              );
              var BOX_H = scope.def(
                '"height" in ',
                BOX,
                "?",
                BOX,
                ".height|0:",
                "(",
                CONTEXT,
                ".",
                S_FRAMEBUFFER_HEIGHT,
                "-",
                BOX_Y,
                ")"
              );
              check$1.optional(function() {
                env2.assert(
                  scope,
                  BOX_W + ">=0&&" + BOX_H + ">=0",
                  "invalid " + param
                );
              });
              return [BOX_X, BOX_Y, BOX_W, BOX_H];
            });
            if (framebuffer) {
              result.thisDep = result.thisDep || framebuffer.thisDep;
              result.contextDep = result.contextDep || framebuffer.contextDep;
              result.propDep = result.propDep || framebuffer.propDep;
            }
            return result;
          } else if (framebuffer) {
            return new Declaration(
              framebuffer.thisDep,
              framebuffer.contextDep,
              framebuffer.propDep,
              function(env2, scope) {
                var CONTEXT = env2.shared.context;
                return [
                  0,
                  0,
                  scope.def(CONTEXT, ".", S_FRAMEBUFFER_WIDTH),
                  scope.def(CONTEXT, ".", S_FRAMEBUFFER_HEIGHT)
                ];
              }
            );
          } else {
            return null;
          }
        }
        var viewport = parseBox(S_VIEWPORT);
        if (viewport) {
          var prevViewport = viewport;
          viewport = new Declaration(
            viewport.thisDep,
            viewport.contextDep,
            viewport.propDep,
            function(env2, scope) {
              var VIEWPORT = prevViewport.append(env2, scope);
              var CONTEXT = env2.shared.context;
              scope.set(
                CONTEXT,
                "." + S_VIEWPORT_WIDTH,
                VIEWPORT[2]
              );
              scope.set(
                CONTEXT,
                "." + S_VIEWPORT_HEIGHT,
                VIEWPORT[3]
              );
              return VIEWPORT;
            }
          );
        }
        return {
          viewport,
          scissor_box: parseBox(S_SCISSOR_BOX)
        };
      }
      function parseAttribLocations(options, attributes) {
        var staticOptions = options.static;
        var staticProgram = typeof staticOptions[S_FRAG] === "string" && typeof staticOptions[S_VERT] === "string";
        if (staticProgram) {
          if (Object.keys(attributes.dynamic).length > 0) {
            return null;
          }
          var staticAttributes = attributes.static;
          var sAttributes = Object.keys(staticAttributes);
          if (sAttributes.length > 0 && typeof staticAttributes[sAttributes[0]] === "number") {
            var bindings = [];
            for (var i3 = 0; i3 < sAttributes.length; ++i3) {
              check$1(typeof staticAttributes[sAttributes[i3]] === "number", "must specify all vertex attribute locations when using vaos");
              bindings.push([staticAttributes[sAttributes[i3]] | 0, sAttributes[i3]]);
            }
            return bindings;
          }
        }
        return null;
      }
      function parseProgram(options, env, attribLocations) {
        var staticOptions = options.static;
        var dynamicOptions = options.dynamic;
        function parseShader(name2) {
          if (name2 in staticOptions) {
            var id3 = stringStore.id(staticOptions[name2]);
            check$1.optional(function() {
              shaderState.shader(shaderType[name2], id3, check$1.guessCommand());
            });
            var result = createStaticDecl(function() {
              return id3;
            });
            result.id = id3;
            return result;
          } else if (name2 in dynamicOptions) {
            var dyn = dynamicOptions[name2];
            return createDynamicDecl(dyn, function(env2, scope) {
              var str = env2.invoke(scope, dyn);
              var id4 = scope.def(env2.shared.strings, ".id(", str, ")");
              check$1.optional(function() {
                scope(
                  env2.shared.shader,
                  ".shader(",
                  shaderType[name2],
                  ",",
                  id4,
                  ",",
                  env2.command,
                  ");"
                );
              });
              return id4;
            });
          }
          return null;
        }
        var frag = parseShader(S_FRAG);
        var vert = parseShader(S_VERT);
        var program = null;
        var progVar;
        if (isStatic(frag) && isStatic(vert)) {
          program = shaderState.program(vert.id, frag.id, null, attribLocations);
          progVar = createStaticDecl(function(env2, scope) {
            return env2.link(program);
          });
        } else {
          progVar = new Declaration(
            frag && frag.thisDep || vert && vert.thisDep,
            frag && frag.contextDep || vert && vert.contextDep,
            frag && frag.propDep || vert && vert.propDep,
            function(env2, scope) {
              var SHADER_STATE = env2.shared.shader;
              var fragId;
              if (frag) {
                fragId = frag.append(env2, scope);
              } else {
                fragId = scope.def(SHADER_STATE, ".", S_FRAG);
              }
              var vertId;
              if (vert) {
                vertId = vert.append(env2, scope);
              } else {
                vertId = scope.def(SHADER_STATE, ".", S_VERT);
              }
              var progDef = SHADER_STATE + ".program(" + vertId + "," + fragId;
              check$1.optional(function() {
                progDef += "," + env2.command;
              });
              return scope.def(progDef + ")");
            }
          );
        }
        return {
          frag,
          vert,
          progVar,
          program
        };
      }
      function parseDraw(options, env) {
        var staticOptions = options.static;
        var dynamicOptions = options.dynamic;
        var staticDraw = {};
        var vaoActive = false;
        function parseVAO() {
          if (S_VAO in staticOptions) {
            var vao2 = staticOptions[S_VAO];
            if (vao2 !== null && attributeState.getVAO(vao2) === null) {
              vao2 = attributeState.createVAO(vao2);
            }
            vaoActive = true;
            staticDraw.vao = vao2;
            return createStaticDecl(function(env2) {
              var vaoRef = attributeState.getVAO(vao2);
              if (vaoRef) {
                return env2.link(vaoRef);
              } else {
                return "null";
              }
            });
          } else if (S_VAO in dynamicOptions) {
            vaoActive = true;
            var dyn = dynamicOptions[S_VAO];
            return createDynamicDecl(dyn, function(env2, scope) {
              var vaoRef = env2.invoke(scope, dyn);
              return scope.def(env2.shared.vao + ".getVAO(" + vaoRef + ")");
            });
          }
          return null;
        }
        var vao = parseVAO();
        var elementsActive = false;
        function parseElements() {
          if (S_ELEMENTS in staticOptions) {
            var elements2 = staticOptions[S_ELEMENTS];
            staticDraw.elements = elements2;
            if (isBufferArgs(elements2)) {
              var e3 = staticDraw.elements = elementState.create(elements2, true);
              elements2 = elementState.getElements(e3);
              elementsActive = true;
            } else if (elements2) {
              elements2 = elementState.getElements(elements2);
              elementsActive = true;
              check$1.command(elements2, "invalid elements", env.commandStr);
            }
            var result = createStaticDecl(function(env2, scope) {
              if (elements2) {
                var result2 = env2.link(elements2);
                env2.ELEMENTS = result2;
                return result2;
              }
              env2.ELEMENTS = null;
              return null;
            });
            result.value = elements2;
            return result;
          } else if (S_ELEMENTS in dynamicOptions) {
            elementsActive = true;
            var dyn = dynamicOptions[S_ELEMENTS];
            return createDynamicDecl(dyn, function(env2, scope) {
              var shared = env2.shared;
              var IS_BUFFER_ARGS = shared.isBufferArgs;
              var ELEMENT_STATE = shared.elements;
              var elementDefn = env2.invoke(scope, dyn);
              var elements3 = scope.def("null");
              var elementStream = scope.def(IS_BUFFER_ARGS, "(", elementDefn, ")");
              var ifte = env2.cond(elementStream).then(elements3, "=", ELEMENT_STATE, ".createStream(", elementDefn, ");").else(elements3, "=", ELEMENT_STATE, ".getElements(", elementDefn, ");");
              check$1.optional(function() {
                env2.assert(
                  ifte.else,
                  "!" + elementDefn + "||" + elements3,
                  "invalid elements"
                );
              });
              scope.entry(ifte);
              scope.exit(
                env2.cond(elementStream).then(ELEMENT_STATE, ".destroyStream(", elements3, ");")
              );
              env2.ELEMENTS = elements3;
              return elements3;
            });
          } else if (vaoActive) {
            return new Declaration(
              vao.thisDep,
              vao.contextDep,
              vao.propDep,
              function(env2, scope) {
                return scope.def(env2.shared.vao + ".currentVAO?" + env2.shared.elements + ".getElements(" + env2.shared.vao + ".currentVAO.elements):null");
              }
            );
          }
          return null;
        }
        var elements = parseElements();
        function parsePrimitive() {
          if (S_PRIMITIVE in staticOptions) {
            var primitive2 = staticOptions[S_PRIMITIVE];
            staticDraw.primitive = primitive2;
            check$1.commandParameter(primitive2, primTypes, "invalid primitve", env.commandStr);
            return createStaticDecl(function(env2, scope) {
              return primTypes[primitive2];
            });
          } else if (S_PRIMITIVE in dynamicOptions) {
            var dynPrimitive = dynamicOptions[S_PRIMITIVE];
            return createDynamicDecl(dynPrimitive, function(env2, scope) {
              var PRIM_TYPES = env2.constants.primTypes;
              var prim = env2.invoke(scope, dynPrimitive);
              check$1.optional(function() {
                env2.assert(
                  scope,
                  prim + " in " + PRIM_TYPES,
                  "invalid primitive, must be one of " + Object.keys(primTypes)
                );
              });
              return scope.def(PRIM_TYPES, "[", prim, "]");
            });
          } else if (elementsActive) {
            if (isStatic(elements)) {
              if (elements.value) {
                return createStaticDecl(function(env2, scope) {
                  return scope.def(env2.ELEMENTS, ".primType");
                });
              } else {
                return createStaticDecl(function() {
                  return GL_TRIANGLES$1;
                });
              }
            } else {
              return new Declaration(
                elements.thisDep,
                elements.contextDep,
                elements.propDep,
                function(env2, scope) {
                  var elements2 = env2.ELEMENTS;
                  return scope.def(elements2, "?", elements2, ".primType:", GL_TRIANGLES$1);
                }
              );
            }
          } else if (vaoActive) {
            return new Declaration(
              vao.thisDep,
              vao.contextDep,
              vao.propDep,
              function(env2, scope) {
                return scope.def(env2.shared.vao + ".currentVAO?" + env2.shared.vao + ".currentVAO.primitive:" + GL_TRIANGLES$1);
              }
            );
          }
          return null;
        }
        function parseParam(param, isOffset) {
          if (param in staticOptions) {
            var value2 = staticOptions[param] | 0;
            if (isOffset) {
              staticDraw.offset = value2;
            } else {
              staticDraw.instances = value2;
            }
            check$1.command(!isOffset || value2 >= 0, "invalid " + param, env.commandStr);
            return createStaticDecl(function(env2, scope) {
              if (isOffset) {
                env2.OFFSET = value2;
              }
              return value2;
            });
          } else if (param in dynamicOptions) {
            var dynValue = dynamicOptions[param];
            return createDynamicDecl(dynValue, function(env2, scope) {
              var result = env2.invoke(scope, dynValue);
              if (isOffset) {
                env2.OFFSET = result;
                check$1.optional(function() {
                  env2.assert(
                    scope,
                    result + ">=0",
                    "invalid " + param
                  );
                });
              }
              return result;
            });
          } else if (isOffset) {
            if (elementsActive) {
              return createStaticDecl(function(env2, scope) {
                env2.OFFSET = 0;
                return 0;
              });
            } else if (vaoActive) {
              return new Declaration(
                vao.thisDep,
                vao.contextDep,
                vao.propDep,
                function(env2, scope) {
                  return scope.def(env2.shared.vao + ".currentVAO?" + env2.shared.vao + ".currentVAO.offset:0");
                }
              );
            }
          } else if (vaoActive) {
            return new Declaration(
              vao.thisDep,
              vao.contextDep,
              vao.propDep,
              function(env2, scope) {
                return scope.def(env2.shared.vao + ".currentVAO?" + env2.shared.vao + ".currentVAO.instances:-1");
              }
            );
          }
          return null;
        }
        var OFFSET2 = parseParam(S_OFFSET, true);
        function parseVertCount() {
          if (S_COUNT in staticOptions) {
            var count2 = staticOptions[S_COUNT] | 0;
            staticDraw.count = count2;
            check$1.command(
              typeof count2 === "number" && count2 >= 0,
              "invalid vertex count",
              env.commandStr
            );
            return createStaticDecl(function() {
              return count2;
            });
          } else if (S_COUNT in dynamicOptions) {
            var dynCount = dynamicOptions[S_COUNT];
            return createDynamicDecl(dynCount, function(env2, scope) {
              var result2 = env2.invoke(scope, dynCount);
              check$1.optional(function() {
                env2.assert(
                  scope,
                  "typeof " + result2 + '==="number"&&' + result2 + ">=0&&" + result2 + "===(" + result2 + "|0)",
                  "invalid vertex count"
                );
              });
              return result2;
            });
          } else if (elementsActive) {
            if (isStatic(elements)) {
              if (elements) {
                if (OFFSET2) {
                  return new Declaration(
                    OFFSET2.thisDep,
                    OFFSET2.contextDep,
                    OFFSET2.propDep,
                    function(env2, scope) {
                      var result2 = scope.def(
                        env2.ELEMENTS,
                        ".vertCount-",
                        env2.OFFSET
                      );
                      check$1.optional(function() {
                        env2.assert(
                          scope,
                          result2 + ">=0",
                          "invalid vertex offset/element buffer too small"
                        );
                      });
                      return result2;
                    }
                  );
                } else {
                  return createStaticDecl(function(env2, scope) {
                    return scope.def(env2.ELEMENTS, ".vertCount");
                  });
                }
              } else {
                var result = createStaticDecl(function() {
                  return -1;
                });
                check$1.optional(function() {
                  result.MISSING = true;
                });
                return result;
              }
            } else {
              var variable = new Declaration(
                elements.thisDep || OFFSET2.thisDep,
                elements.contextDep || OFFSET2.contextDep,
                elements.propDep || OFFSET2.propDep,
                function(env2, scope) {
                  var elements2 = env2.ELEMENTS;
                  if (env2.OFFSET) {
                    return scope.def(
                      elements2,
                      "?",
                      elements2,
                      ".vertCount-",
                      env2.OFFSET,
                      ":-1"
                    );
                  }
                  return scope.def(elements2, "?", elements2, ".vertCount:-1");
                }
              );
              check$1.optional(function() {
                variable.DYNAMIC = true;
              });
              return variable;
            }
          } else if (vaoActive) {
            var countVariable = new Declaration(
              vao.thisDep,
              vao.contextDep,
              vao.propDep,
              function(env2, scope) {
                return scope.def(env2.shared.vao, ".currentVAO?", env2.shared.vao, ".currentVAO.count:-1");
              }
            );
            return countVariable;
          }
          return null;
        }
        var primitive = parsePrimitive();
        var count = parseVertCount();
        var instances2 = parseParam(S_INSTANCES, false);
        return {
          elements,
          primitive,
          count,
          instances: instances2,
          offset: OFFSET2,
          vao,
          vaoActive,
          elementsActive,
          // static draw props
          static: staticDraw
        };
      }
      function parseGLState(options, env) {
        var staticOptions = options.static;
        var dynamicOptions = options.dynamic;
        var STATE = {};
        GL_STATE_NAMES.forEach(function(prop) {
          var param = propName(prop);
          function parseParam(parseStatic, parseDynamic) {
            if (prop in staticOptions) {
              var value2 = parseStatic(staticOptions[prop]);
              STATE[param] = createStaticDecl(function() {
                return value2;
              });
            } else if (prop in dynamicOptions) {
              var dyn = dynamicOptions[prop];
              STATE[param] = createDynamicDecl(dyn, function(env2, scope) {
                return parseDynamic(env2, scope, env2.invoke(scope, dyn));
              });
            }
          }
          switch (prop) {
            case S_CULL_ENABLE:
            case S_BLEND_ENABLE:
            case S_DITHER:
            case S_STENCIL_ENABLE:
            case S_DEPTH_ENABLE:
            case S_SCISSOR_ENABLE:
            case S_POLYGON_OFFSET_ENABLE:
            case S_SAMPLE_ALPHA:
            case S_SAMPLE_ENABLE:
            case S_DEPTH_MASK:
              return parseParam(
                function(value2) {
                  check$1.commandType(value2, "boolean", prop, env.commandStr);
                  return value2;
                },
                function(env2, scope, value2) {
                  check$1.optional(function() {
                    env2.assert(
                      scope,
                      "typeof " + value2 + '==="boolean"',
                      "invalid flag " + prop,
                      env2.commandStr
                    );
                  });
                  return value2;
                }
              );
            case S_DEPTH_FUNC:
              return parseParam(
                function(value2) {
                  check$1.commandParameter(value2, compareFuncs, "invalid " + prop, env.commandStr);
                  return compareFuncs[value2];
                },
                function(env2, scope, value2) {
                  var COMPARE_FUNCS = env2.constants.compareFuncs;
                  check$1.optional(function() {
                    env2.assert(
                      scope,
                      value2 + " in " + COMPARE_FUNCS,
                      "invalid " + prop + ", must be one of " + Object.keys(compareFuncs)
                    );
                  });
                  return scope.def(COMPARE_FUNCS, "[", value2, "]");
                }
              );
            case S_DEPTH_RANGE:
              return parseParam(
                function(value2) {
                  check$1.command(
                    isArrayLike(value2) && value2.length === 2 && typeof value2[0] === "number" && typeof value2[1] === "number" && value2[0] <= value2[1],
                    "depth range is 2d array",
                    env.commandStr
                  );
                  return value2;
                },
                function(env2, scope, value2) {
                  check$1.optional(function() {
                    env2.assert(
                      scope,
                      env2.shared.isArrayLike + "(" + value2 + ")&&" + value2 + ".length===2&&typeof " + value2 + '[0]==="number"&&typeof ' + value2 + '[1]==="number"&&' + value2 + "[0]<=" + value2 + "[1]",
                      "depth range must be a 2d array"
                    );
                  });
                  var Z_NEAR = scope.def("+", value2, "[0]");
                  var Z_FAR = scope.def("+", value2, "[1]");
                  return [Z_NEAR, Z_FAR];
                }
              );
            case S_BLEND_FUNC:
              return parseParam(
                function(value2) {
                  check$1.commandType(value2, "object", "blend.func", env.commandStr);
                  var srcRGB = "srcRGB" in value2 ? value2.srcRGB : value2.src;
                  var srcAlpha = "srcAlpha" in value2 ? value2.srcAlpha : value2.src;
                  var dstRGB = "dstRGB" in value2 ? value2.dstRGB : value2.dst;
                  var dstAlpha = "dstAlpha" in value2 ? value2.dstAlpha : value2.dst;
                  check$1.commandParameter(srcRGB, blendFuncs, param + ".srcRGB", env.commandStr);
                  check$1.commandParameter(srcAlpha, blendFuncs, param + ".srcAlpha", env.commandStr);
                  check$1.commandParameter(dstRGB, blendFuncs, param + ".dstRGB", env.commandStr);
                  check$1.commandParameter(dstAlpha, blendFuncs, param + ".dstAlpha", env.commandStr);
                  check$1.command(
                    invalidBlendCombinations.indexOf(srcRGB + ", " + dstRGB) === -1,
                    "unallowed blending combination (srcRGB, dstRGB) = (" + srcRGB + ", " + dstRGB + ")",
                    env.commandStr
                  );
                  return [
                    blendFuncs[srcRGB],
                    blendFuncs[dstRGB],
                    blendFuncs[srcAlpha],
                    blendFuncs[dstAlpha]
                  ];
                },
                function(env2, scope, value2) {
                  var BLEND_FUNCS = env2.constants.blendFuncs;
                  check$1.optional(function() {
                    env2.assert(
                      scope,
                      value2 + "&&typeof " + value2 + '==="object"',
                      "invalid blend func, must be an object"
                    );
                  });
                  function read2(prefix, suffix) {
                    var func = scope.def(
                      '"',
                      prefix,
                      suffix,
                      '" in ',
                      value2,
                      "?",
                      value2,
                      ".",
                      prefix,
                      suffix,
                      ":",
                      value2,
                      ".",
                      prefix
                    );
                    check$1.optional(function() {
                      env2.assert(
                        scope,
                        func + " in " + BLEND_FUNCS,
                        "invalid " + prop + "." + prefix + suffix + ", must be one of " + Object.keys(blendFuncs)
                      );
                    });
                    return func;
                  }
                  var srcRGB = read2("src", "RGB");
                  var dstRGB = read2("dst", "RGB");
                  check$1.optional(function() {
                    var INVALID_BLEND_COMBINATIONS = env2.constants.invalidBlendCombinations;
                    env2.assert(
                      scope,
                      INVALID_BLEND_COMBINATIONS + ".indexOf(" + srcRGB + '+", "+' + dstRGB + ") === -1 ",
                      "unallowed blending combination for (srcRGB, dstRGB)"
                    );
                  });
                  var SRC_RGB = scope.def(BLEND_FUNCS, "[", srcRGB, "]");
                  var SRC_ALPHA = scope.def(BLEND_FUNCS, "[", read2("src", "Alpha"), "]");
                  var DST_RGB = scope.def(BLEND_FUNCS, "[", dstRGB, "]");
                  var DST_ALPHA = scope.def(BLEND_FUNCS, "[", read2("dst", "Alpha"), "]");
                  return [SRC_RGB, DST_RGB, SRC_ALPHA, DST_ALPHA];
                }
              );
            case S_BLEND_EQUATION:
              return parseParam(
                function(value2) {
                  if (typeof value2 === "string") {
                    check$1.commandParameter(value2, blendEquations, "invalid " + prop, env.commandStr);
                    return [
                      blendEquations[value2],
                      blendEquations[value2]
                    ];
                  } else if (typeof value2 === "object") {
                    check$1.commandParameter(
                      value2.rgb,
                      blendEquations,
                      prop + ".rgb",
                      env.commandStr
                    );
                    check$1.commandParameter(
                      value2.alpha,
                      blendEquations,
                      prop + ".alpha",
                      env.commandStr
                    );
                    return [
                      blendEquations[value2.rgb],
                      blendEquations[value2.alpha]
                    ];
                  } else {
                    check$1.commandRaise("invalid blend.equation", env.commandStr);
                  }
                },
                function(env2, scope, value2) {
                  var BLEND_EQUATIONS = env2.constants.blendEquations;
                  var RGB = scope.def();
                  var ALPHA = scope.def();
                  var ifte = env2.cond("typeof ", value2, '==="string"');
                  check$1.optional(function() {
                    function checkProp(block, name2, value3) {
                      env2.assert(
                        block,
                        value3 + " in " + BLEND_EQUATIONS,
                        "invalid " + name2 + ", must be one of " + Object.keys(blendEquations)
                      );
                    }
                    checkProp(ifte.then, prop, value2);
                    env2.assert(
                      ifte.else,
                      value2 + "&&typeof " + value2 + '==="object"',
                      "invalid " + prop
                    );
                    checkProp(ifte.else, prop + ".rgb", value2 + ".rgb");
                    checkProp(ifte.else, prop + ".alpha", value2 + ".alpha");
                  });
                  ifte.then(
                    RGB,
                    "=",
                    ALPHA,
                    "=",
                    BLEND_EQUATIONS,
                    "[",
                    value2,
                    "];"
                  );
                  ifte.else(
                    RGB,
                    "=",
                    BLEND_EQUATIONS,
                    "[",
                    value2,
                    ".rgb];",
                    ALPHA,
                    "=",
                    BLEND_EQUATIONS,
                    "[",
                    value2,
                    ".alpha];"
                  );
                  scope(ifte);
                  return [RGB, ALPHA];
                }
              );
            case S_BLEND_COLOR:
              return parseParam(
                function(value2) {
                  check$1.command(
                    isArrayLike(value2) && value2.length === 4,
                    "blend.color must be a 4d array",
                    env.commandStr
                  );
                  return loop(4, function(i3) {
                    return +value2[i3];
                  });
                },
                function(env2, scope, value2) {
                  check$1.optional(function() {
                    env2.assert(
                      scope,
                      env2.shared.isArrayLike + "(" + value2 + ")&&" + value2 + ".length===4",
                      "blend.color must be a 4d array"
                    );
                  });
                  return loop(4, function(i3) {
                    return scope.def("+", value2, "[", i3, "]");
                  });
                }
              );
            case S_STENCIL_MASK:
              return parseParam(
                function(value2) {
                  check$1.commandType(value2, "number", param, env.commandStr);
                  return value2 | 0;
                },
                function(env2, scope, value2) {
                  check$1.optional(function() {
                    env2.assert(
                      scope,
                      "typeof " + value2 + '==="number"',
                      "invalid stencil.mask"
                    );
                  });
                  return scope.def(value2, "|0");
                }
              );
            case S_STENCIL_FUNC:
              return parseParam(
                function(value2) {
                  check$1.commandType(value2, "object", param, env.commandStr);
                  var cmp = value2.cmp || "keep";
                  var ref2 = value2.ref || 0;
                  var mask = "mask" in value2 ? value2.mask : -1;
                  check$1.commandParameter(cmp, compareFuncs, prop + ".cmp", env.commandStr);
                  check$1.commandType(ref2, "number", prop + ".ref", env.commandStr);
                  check$1.commandType(mask, "number", prop + ".mask", env.commandStr);
                  return [
                    compareFuncs[cmp],
                    ref2,
                    mask
                  ];
                },
                function(env2, scope, value2) {
                  var COMPARE_FUNCS = env2.constants.compareFuncs;
                  check$1.optional(function() {
                    function assert() {
                      env2.assert(
                        scope,
                        Array.prototype.join.call(arguments, ""),
                        "invalid stencil.func"
                      );
                    }
                    assert(value2 + "&&typeof ", value2, '==="object"');
                    assert(
                      '!("cmp" in ',
                      value2,
                      ")||(",
                      value2,
                      ".cmp in ",
                      COMPARE_FUNCS,
                      ")"
                    );
                  });
                  var cmp = scope.def(
                    '"cmp" in ',
                    value2,
                    "?",
                    COMPARE_FUNCS,
                    "[",
                    value2,
                    ".cmp]",
                    ":",
                    GL_KEEP
                  );
                  var ref2 = scope.def(value2, ".ref|0");
                  var mask = scope.def(
                    '"mask" in ',
                    value2,
                    "?",
                    value2,
                    ".mask|0:-1"
                  );
                  return [cmp, ref2, mask];
                }
              );
            case S_STENCIL_OPFRONT:
            case S_STENCIL_OPBACK:
              return parseParam(
                function(value2) {
                  check$1.commandType(value2, "object", param, env.commandStr);
                  var fail = value2.fail || "keep";
                  var zfail = value2.zfail || "keep";
                  var zpass = value2.zpass || "keep";
                  check$1.commandParameter(fail, stencilOps, prop + ".fail", env.commandStr);
                  check$1.commandParameter(zfail, stencilOps, prop + ".zfail", env.commandStr);
                  check$1.commandParameter(zpass, stencilOps, prop + ".zpass", env.commandStr);
                  return [
                    prop === S_STENCIL_OPBACK ? GL_BACK : GL_FRONT,
                    stencilOps[fail],
                    stencilOps[zfail],
                    stencilOps[zpass]
                  ];
                },
                function(env2, scope, value2) {
                  var STENCIL_OPS = env2.constants.stencilOps;
                  check$1.optional(function() {
                    env2.assert(
                      scope,
                      value2 + "&&typeof " + value2 + '==="object"',
                      "invalid " + prop
                    );
                  });
                  function read2(name2) {
                    check$1.optional(function() {
                      env2.assert(
                        scope,
                        '!("' + name2 + '" in ' + value2 + ")||(" + value2 + "." + name2 + " in " + STENCIL_OPS + ")",
                        "invalid " + prop + "." + name2 + ", must be one of " + Object.keys(stencilOps)
                      );
                    });
                    return scope.def(
                      '"',
                      name2,
                      '" in ',
                      value2,
                      "?",
                      STENCIL_OPS,
                      "[",
                      value2,
                      ".",
                      name2,
                      "]:",
                      GL_KEEP
                    );
                  }
                  return [
                    prop === S_STENCIL_OPBACK ? GL_BACK : GL_FRONT,
                    read2("fail"),
                    read2("zfail"),
                    read2("zpass")
                  ];
                }
              );
            case S_POLYGON_OFFSET_OFFSET:
              return parseParam(
                function(value2) {
                  check$1.commandType(value2, "object", param, env.commandStr);
                  var factor = value2.factor | 0;
                  var units2 = value2.units | 0;
                  check$1.commandType(factor, "number", param + ".factor", env.commandStr);
                  check$1.commandType(units2, "number", param + ".units", env.commandStr);
                  return [factor, units2];
                },
                function(env2, scope, value2) {
                  check$1.optional(function() {
                    env2.assert(
                      scope,
                      value2 + "&&typeof " + value2 + '==="object"',
                      "invalid " + prop
                    );
                  });
                  var FACTOR = scope.def(value2, ".factor|0");
                  var UNITS2 = scope.def(value2, ".units|0");
                  return [FACTOR, UNITS2];
                }
              );
            case S_CULL_FACE:
              return parseParam(
                function(value2) {
                  var face = 0;
                  if (value2 === "front") {
                    face = GL_FRONT;
                  } else if (value2 === "back") {
                    face = GL_BACK;
                  }
                  check$1.command(!!face, param, env.commandStr);
                  return face;
                },
                function(env2, scope, value2) {
                  check$1.optional(function() {
                    env2.assert(
                      scope,
                      value2 + '==="front"||' + value2 + '==="back"',
                      "invalid cull.face"
                    );
                  });
                  return scope.def(value2, '==="front"?', GL_FRONT, ":", GL_BACK);
                }
              );
            case S_LINE_WIDTH:
              return parseParam(
                function(value2) {
                  check$1.command(
                    typeof value2 === "number" && value2 >= limits.lineWidthDims[0] && value2 <= limits.lineWidthDims[1],
                    "invalid line width, must be a positive number between " + limits.lineWidthDims[0] + " and " + limits.lineWidthDims[1],
                    env.commandStr
                  );
                  return value2;
                },
                function(env2, scope, value2) {
                  check$1.optional(function() {
                    env2.assert(
                      scope,
                      "typeof " + value2 + '==="number"&&' + value2 + ">=" + limits.lineWidthDims[0] + "&&" + value2 + "<=" + limits.lineWidthDims[1],
                      "invalid line width"
                    );
                  });
                  return value2;
                }
              );
            case S_FRONT_FACE:
              return parseParam(
                function(value2) {
                  check$1.commandParameter(value2, orientationType, param, env.commandStr);
                  return orientationType[value2];
                },
                function(env2, scope, value2) {
                  check$1.optional(function() {
                    env2.assert(
                      scope,
                      value2 + '==="cw"||' + value2 + '==="ccw"',
                      "invalid frontFace, must be one of cw,ccw"
                    );
                  });
                  return scope.def(value2 + '==="cw"?' + GL_CW + ":" + GL_CCW);
                }
              );
            case S_COLOR_MASK:
              return parseParam(
                function(value2) {
                  check$1.command(
                    isArrayLike(value2) && value2.length === 4,
                    "color.mask must be length 4 array",
                    env.commandStr
                  );
                  return value2.map(function(v) {
                    return !!v;
                  });
                },
                function(env2, scope, value2) {
                  check$1.optional(function() {
                    env2.assert(
                      scope,
                      env2.shared.isArrayLike + "(" + value2 + ")&&" + value2 + ".length===4",
                      "invalid color.mask"
                    );
                  });
                  return loop(4, function(i3) {
                    return "!!" + value2 + "[" + i3 + "]";
                  });
                }
              );
            case S_SAMPLE_COVERAGE:
              return parseParam(
                function(value2) {
                  check$1.command(typeof value2 === "object" && value2, param, env.commandStr);
                  var sampleValue = "value" in value2 ? value2.value : 1;
                  var sampleInvert = !!value2.invert;
                  check$1.command(
                    typeof sampleValue === "number" && sampleValue >= 0 && sampleValue <= 1,
                    "sample.coverage.value must be a number between 0 and 1",
                    env.commandStr
                  );
                  return [sampleValue, sampleInvert];
                },
                function(env2, scope, value2) {
                  check$1.optional(function() {
                    env2.assert(
                      scope,
                      value2 + "&&typeof " + value2 + '==="object"',
                      "invalid sample.coverage"
                    );
                  });
                  var VALUE = scope.def(
                    '"value" in ',
                    value2,
                    "?+",
                    value2,
                    ".value:1"
                  );
                  var INVERT = scope.def("!!", value2, ".invert");
                  return [VALUE, INVERT];
                }
              );
          }
        });
        return STATE;
      }
      function parseUniforms(uniforms, env) {
        var staticUniforms = uniforms.static;
        var dynamicUniforms = uniforms.dynamic;
        var UNIFORMS = {};
        Object.keys(staticUniforms).forEach(function(name2) {
          var value2 = staticUniforms[name2];
          var result;
          if (typeof value2 === "number" || typeof value2 === "boolean") {
            result = createStaticDecl(function() {
              return value2;
            });
          } else if (typeof value2 === "function") {
            var reglType = value2._reglType;
            if (reglType === "texture2d" || reglType === "textureCube") {
              result = createStaticDecl(function(env2) {
                return env2.link(value2);
              });
            } else if (reglType === "framebuffer" || reglType === "framebufferCube") {
              check$1.command(
                value2.color.length > 0,
                'missing color attachment for framebuffer sent to uniform "' + name2 + '"',
                env.commandStr
              );
              result = createStaticDecl(function(env2) {
                return env2.link(value2.color[0]);
              });
            } else {
              check$1.commandRaise('invalid data for uniform "' + name2 + '"', env.commandStr);
            }
          } else if (isArrayLike(value2)) {
            result = createStaticDecl(function(env2) {
              var ITEM = env2.global.def(
                "[",
                loop(value2.length, function(i3) {
                  check$1.command(
                    typeof value2[i3] === "number" || typeof value2[i3] === "boolean",
                    "invalid uniform " + name2,
                    env2.commandStr
                  );
                  return value2[i3];
                }),
                "]"
              );
              return ITEM;
            });
          } else {
            check$1.commandRaise('invalid or missing data for uniform "' + name2 + '"', env.commandStr);
          }
          result.value = value2;
          UNIFORMS[name2] = result;
        });
        Object.keys(dynamicUniforms).forEach(function(key) {
          var dyn = dynamicUniforms[key];
          UNIFORMS[key] = createDynamicDecl(dyn, function(env2, scope) {
            return env2.invoke(scope, dyn);
          });
        });
        return UNIFORMS;
      }
      function parseAttributes(attributes, env) {
        var staticAttributes = attributes.static;
        var dynamicAttributes = attributes.dynamic;
        var attributeDefs = {};
        Object.keys(staticAttributes).forEach(function(attribute) {
          var value2 = staticAttributes[attribute];
          var id3 = stringStore.id(attribute);
          var record = new AttributeRecord2();
          if (isBufferArgs(value2)) {
            record.state = ATTRIB_STATE_POINTER;
            record.buffer = bufferState.getBuffer(
              bufferState.create(value2, GL_ARRAY_BUFFER$2, false, true)
            );
            record.type = 0;
          } else {
            var buffer = bufferState.getBuffer(value2);
            if (buffer) {
              record.state = ATTRIB_STATE_POINTER;
              record.buffer = buffer;
              record.type = 0;
            } else {
              check$1.command(
                typeof value2 === "object" && value2,
                "invalid data for attribute " + attribute,
                env.commandStr
              );
              if ("constant" in value2) {
                var constant = value2.constant;
                record.buffer = "null";
                record.state = ATTRIB_STATE_CONSTANT;
                if (typeof constant === "number") {
                  record.x = constant;
                } else {
                  check$1.command(
                    isArrayLike(constant) && constant.length > 0 && constant.length <= 4,
                    "invalid constant for attribute " + attribute,
                    env.commandStr
                  );
                  CUTE_COMPONENTS.forEach(function(c3, i3) {
                    if (i3 < constant.length) {
                      record[c3] = constant[i3];
                    }
                  });
                }
              } else {
                if (isBufferArgs(value2.buffer)) {
                  buffer = bufferState.getBuffer(
                    bufferState.create(value2.buffer, GL_ARRAY_BUFFER$2, false, true)
                  );
                } else {
                  buffer = bufferState.getBuffer(value2.buffer);
                }
                check$1.command(!!buffer, 'missing buffer for attribute "' + attribute + '"', env.commandStr);
                var offset2 = value2.offset | 0;
                check$1.command(
                  offset2 >= 0,
                  'invalid offset for attribute "' + attribute + '"',
                  env.commandStr
                );
                var stride = value2.stride | 0;
                check$1.command(
                  stride >= 0 && stride < 256,
                  'invalid stride for attribute "' + attribute + '", must be integer betweeen [0, 255]',
                  env.commandStr
                );
                var size2 = value2.size | 0;
                check$1.command(
                  !("size" in value2) || size2 > 0 && size2 <= 4,
                  'invalid size for attribute "' + attribute + '", must be 1,2,3,4',
                  env.commandStr
                );
                var normalized = !!value2.normalized;
                var type2 = 0;
                if ("type" in value2) {
                  check$1.commandParameter(
                    value2.type,
                    glTypes,
                    "invalid type for attribute " + attribute,
                    env.commandStr
                  );
                  type2 = glTypes[value2.type];
                }
                var divisor = value2.divisor | 0;
                check$1.optional(function() {
                  if ("divisor" in value2) {
                    check$1.command(
                      divisor === 0 || extInstancing,
                      'cannot specify divisor for attribute "' + attribute + '", instancing not supported',
                      env.commandStr
                    );
                    check$1.command(
                      divisor >= 0,
                      'invalid divisor for attribute "' + attribute + '"',
                      env.commandStr
                    );
                  }
                  var command = env.commandStr;
                  var VALID_KEYS = [
                    "buffer",
                    "offset",
                    "divisor",
                    "normalized",
                    "type",
                    "size",
                    "stride"
                  ];
                  Object.keys(value2).forEach(function(prop) {
                    check$1.command(
                      VALID_KEYS.indexOf(prop) >= 0,
                      'unknown parameter "' + prop + '" for attribute pointer "' + attribute + '" (valid parameters are ' + VALID_KEYS + ")",
                      command
                    );
                  });
                });
                record.buffer = buffer;
                record.state = ATTRIB_STATE_POINTER;
                record.size = size2;
                record.normalized = normalized;
                record.type = type2 || buffer.dtype;
                record.offset = offset2;
                record.stride = stride;
                record.divisor = divisor;
              }
            }
          }
          attributeDefs[attribute] = createStaticDecl(function(env2, scope) {
            var cache = env2.attribCache;
            if (id3 in cache) {
              return cache[id3];
            }
            var result = {
              isStream: false
            };
            Object.keys(record).forEach(function(key) {
              result[key] = record[key];
            });
            if (record.buffer) {
              result.buffer = env2.link(record.buffer);
              result.type = result.type || result.buffer + ".dtype";
            }
            cache[id3] = result;
            return result;
          });
        });
        Object.keys(dynamicAttributes).forEach(function(attribute) {
          var dyn = dynamicAttributes[attribute];
          function appendAttributeCode(env2, block) {
            var VALUE = env2.invoke(block, dyn);
            var shared = env2.shared;
            var constants = env2.constants;
            var IS_BUFFER_ARGS = shared.isBufferArgs;
            var BUFFER_STATE = shared.buffer;
            check$1.optional(function() {
              env2.assert(
                block,
                VALUE + "&&(typeof " + VALUE + '==="object"||typeof ' + VALUE + '==="function")&&(' + IS_BUFFER_ARGS + "(" + VALUE + ")||" + BUFFER_STATE + ".getBuffer(" + VALUE + ")||" + BUFFER_STATE + ".getBuffer(" + VALUE + ".buffer)||" + IS_BUFFER_ARGS + "(" + VALUE + '.buffer)||("constant" in ' + VALUE + "&&(typeof " + VALUE + '.constant==="number"||' + shared.isArrayLike + "(" + VALUE + ".constant))))",
                'invalid dynamic attribute "' + attribute + '"'
              );
            });
            var result = {
              isStream: block.def(false)
            };
            var defaultRecord = new AttributeRecord2();
            defaultRecord.state = ATTRIB_STATE_POINTER;
            Object.keys(defaultRecord).forEach(function(key) {
              result[key] = block.def("" + defaultRecord[key]);
            });
            var BUFFER = result.buffer;
            var TYPE = result.type;
            block(
              "if(",
              IS_BUFFER_ARGS,
              "(",
              VALUE,
              ")){",
              result.isStream,
              "=true;",
              BUFFER,
              "=",
              BUFFER_STATE,
              ".createStream(",
              GL_ARRAY_BUFFER$2,
              ",",
              VALUE,
              ");",
              TYPE,
              "=",
              BUFFER,
              ".dtype;",
              "}else{",
              BUFFER,
              "=",
              BUFFER_STATE,
              ".getBuffer(",
              VALUE,
              ");",
              "if(",
              BUFFER,
              "){",
              TYPE,
              "=",
              BUFFER,
              ".dtype;",
              '}else if("constant" in ',
              VALUE,
              "){",
              result.state,
              "=",
              ATTRIB_STATE_CONSTANT,
              ";",
              "if(typeof " + VALUE + '.constant === "number"){',
              result[CUTE_COMPONENTS[0]],
              "=",
              VALUE,
              ".constant;",
              CUTE_COMPONENTS.slice(1).map(function(n) {
                return result[n];
              }).join("="),
              "=0;",
              "}else{",
              CUTE_COMPONENTS.map(function(name2, i3) {
                return result[name2] + "=" + VALUE + ".constant.length>" + i3 + "?" + VALUE + ".constant[" + i3 + "]:0;";
              }).join(""),
              "}}else{",
              "if(",
              IS_BUFFER_ARGS,
              "(",
              VALUE,
              ".buffer)){",
              BUFFER,
              "=",
              BUFFER_STATE,
              ".createStream(",
              GL_ARRAY_BUFFER$2,
              ",",
              VALUE,
              ".buffer);",
              "}else{",
              BUFFER,
              "=",
              BUFFER_STATE,
              ".getBuffer(",
              VALUE,
              ".buffer);",
              "}",
              TYPE,
              '="type" in ',
              VALUE,
              "?",
              constants.glTypes,
              "[",
              VALUE,
              ".type]:",
              BUFFER,
              ".dtype;",
              result.normalized,
              "=!!",
              VALUE,
              ".normalized;"
            );
            function emitReadRecord(name2) {
              block(result[name2], "=", VALUE, ".", name2, "|0;");
            }
            emitReadRecord("size");
            emitReadRecord("offset");
            emitReadRecord("stride");
            emitReadRecord("divisor");
            block("}}");
            block.exit(
              "if(",
              result.isStream,
              "){",
              BUFFER_STATE,
              ".destroyStream(",
              BUFFER,
              ");",
              "}"
            );
            return result;
          }
          attributeDefs[attribute] = createDynamicDecl(dyn, appendAttributeCode);
        });
        return attributeDefs;
      }
      function parseContext(context) {
        var staticContext = context.static;
        var dynamicContext = context.dynamic;
        var result = {};
        Object.keys(staticContext).forEach(function(name2) {
          var value2 = staticContext[name2];
          result[name2] = createStaticDecl(function(env, scope) {
            if (typeof value2 === "number" || typeof value2 === "boolean") {
              return "" + value2;
            } else {
              return env.link(value2);
            }
          });
        });
        Object.keys(dynamicContext).forEach(function(name2) {
          var dyn = dynamicContext[name2];
          result[name2] = createDynamicDecl(dyn, function(env, scope) {
            return env.invoke(scope, dyn);
          });
        });
        return result;
      }
      function parseArguments(options, attributes, uniforms, context, env) {
        var staticOptions = options.static;
        var dynamicOptions = options.dynamic;
        check$1.optional(function() {
          var KEY_NAMES = [
            S_FRAMEBUFFER,
            S_VERT,
            S_FRAG,
            S_ELEMENTS,
            S_PRIMITIVE,
            S_OFFSET,
            S_COUNT,
            S_INSTANCES,
            S_PROFILE,
            S_VAO
          ].concat(GL_STATE_NAMES);
          function checkKeys(dict) {
            Object.keys(dict).forEach(function(key) {
              check$1.command(
                KEY_NAMES.indexOf(key) >= 0,
                'unknown parameter "' + key + '"',
                env.commandStr
              );
            });
          }
          checkKeys(staticOptions);
          checkKeys(dynamicOptions);
        });
        var attribLocations = parseAttribLocations(options, attributes);
        var framebuffer = parseFramebuffer(options);
        var viewportAndScissor = parseViewportScissor(options, framebuffer, env);
        var draw2 = parseDraw(options, env);
        var state2 = parseGLState(options, env);
        var shader = parseProgram(options, env, attribLocations);
        function copyBox(name2) {
          var defn = viewportAndScissor[name2];
          if (defn) {
            state2[name2] = defn;
          }
        }
        copyBox(S_VIEWPORT);
        copyBox(propName(S_SCISSOR_BOX));
        var dirty = Object.keys(state2).length > 0;
        var result = {
          framebuffer,
          draw: draw2,
          shader,
          state: state2,
          dirty,
          scopeVAO: null,
          drawVAO: null,
          useVAO: false,
          attributes: {}
        };
        result.profile = parseProfile(options);
        result.uniforms = parseUniforms(uniforms, env);
        result.drawVAO = result.scopeVAO = draw2.vao;
        if (!result.drawVAO && shader.program && !attribLocations && extensions.angle_instanced_arrays && draw2.static.elements) {
          var useVAO = true;
          var staticBindings = shader.program.attributes.map(function(attr) {
            var binding = attributes.static[attr];
            useVAO = useVAO && !!binding;
            return binding;
          });
          if (useVAO && staticBindings.length > 0) {
            var vao = attributeState.getVAO(attributeState.createVAO({
              attributes: staticBindings,
              elements: draw2.static.elements
            }));
            result.drawVAO = new Declaration(null, null, null, function(env2, scope) {
              return env2.link(vao);
            });
            result.useVAO = true;
          }
        }
        if (attribLocations) {
          result.useVAO = true;
        } else {
          result.attributes = parseAttributes(attributes, env);
        }
        result.context = parseContext(context);
        return result;
      }
      function emitContext(env, scope, context) {
        var shared = env.shared;
        var CONTEXT = shared.context;
        var contextEnter = env.scope();
        Object.keys(context).forEach(function(name2) {
          scope.save(CONTEXT, "." + name2);
          var defn = context[name2];
          var value2 = defn.append(env, scope);
          if (Array.isArray(value2)) {
            contextEnter(CONTEXT, ".", name2, "=[", value2.join(), "];");
          } else {
            contextEnter(CONTEXT, ".", name2, "=", value2, ";");
          }
        });
        scope(contextEnter);
      }
      function emitPollFramebuffer(env, scope, framebuffer, skipCheck) {
        var shared = env.shared;
        var GL = shared.gl;
        var FRAMEBUFFER_STATE = shared.framebuffer;
        var EXT_DRAW_BUFFERS;
        if (extDrawBuffers) {
          EXT_DRAW_BUFFERS = scope.def(shared.extensions, ".webgl_draw_buffers");
        }
        var constants = env.constants;
        var DRAW_BUFFERS = constants.drawBuffer;
        var BACK_BUFFER = constants.backBuffer;
        var NEXT;
        if (framebuffer) {
          NEXT = framebuffer.append(env, scope);
        } else {
          NEXT = scope.def(FRAMEBUFFER_STATE, ".next");
        }
        if (!skipCheck) {
          scope("if(", NEXT, "!==", FRAMEBUFFER_STATE, ".cur){");
        }
        scope(
          "if(",
          NEXT,
          "){",
          GL,
          ".bindFramebuffer(",
          GL_FRAMEBUFFER$2,
          ",",
          NEXT,
          ".framebuffer);"
        );
        if (extDrawBuffers) {
          scope(
            EXT_DRAW_BUFFERS,
            ".drawBuffersWEBGL(",
            DRAW_BUFFERS,
            "[",
            NEXT,
            ".colorAttachments.length]);"
          );
        }
        scope(
          "}else{",
          GL,
          ".bindFramebuffer(",
          GL_FRAMEBUFFER$2,
          ",null);"
        );
        if (extDrawBuffers) {
          scope(EXT_DRAW_BUFFERS, ".drawBuffersWEBGL(", BACK_BUFFER, ");");
        }
        scope(
          "}",
          FRAMEBUFFER_STATE,
          ".cur=",
          NEXT,
          ";"
        );
        if (!skipCheck) {
          scope("}");
        }
      }
      function emitPollState(env, scope, args) {
        var shared = env.shared;
        var GL = shared.gl;
        var CURRENT_VARS = env.current;
        var NEXT_VARS = env.next;
        var CURRENT_STATE = shared.current;
        var NEXT_STATE = shared.next;
        var block = env.cond(CURRENT_STATE, ".dirty");
        GL_STATE_NAMES.forEach(function(prop) {
          var param = propName(prop);
          if (param in args.state) {
            return;
          }
          var NEXT, CURRENT;
          if (param in NEXT_VARS) {
            NEXT = NEXT_VARS[param];
            CURRENT = CURRENT_VARS[param];
            var parts = loop(currentState[param].length, function(i3) {
              return block.def(NEXT, "[", i3, "]");
            });
            block(env.cond(parts.map(function(p2, i3) {
              return p2 + "!==" + CURRENT + "[" + i3 + "]";
            }).join("||")).then(
              GL,
              ".",
              GL_VARIABLES[param],
              "(",
              parts,
              ");",
              parts.map(function(p2, i3) {
                return CURRENT + "[" + i3 + "]=" + p2;
              }).join(";"),
              ";"
            ));
          } else {
            NEXT = block.def(NEXT_STATE, ".", param);
            var ifte = env.cond(NEXT, "!==", CURRENT_STATE, ".", param);
            block(ifte);
            if (param in GL_FLAGS) {
              ifte(
                env.cond(NEXT).then(GL, ".enable(", GL_FLAGS[param], ");").else(GL, ".disable(", GL_FLAGS[param], ");"),
                CURRENT_STATE,
                ".",
                param,
                "=",
                NEXT,
                ";"
              );
            } else {
              ifte(
                GL,
                ".",
                GL_VARIABLES[param],
                "(",
                NEXT,
                ");",
                CURRENT_STATE,
                ".",
                param,
                "=",
                NEXT,
                ";"
              );
            }
          }
        });
        if (Object.keys(args.state).length === 0) {
          block(CURRENT_STATE, ".dirty=false;");
        }
        scope(block);
      }
      function emitSetOptions(env, scope, options, filter) {
        var shared = env.shared;
        var CURRENT_VARS = env.current;
        var CURRENT_STATE = shared.current;
        var GL = shared.gl;
        sortState(Object.keys(options)).forEach(function(param) {
          var defn = options[param];
          if (filter && !filter(defn)) {
            return;
          }
          var variable = defn.append(env, scope);
          if (GL_FLAGS[param]) {
            var flag = GL_FLAGS[param];
            if (isStatic(defn)) {
              if (variable) {
                scope(GL, ".enable(", flag, ");");
              } else {
                scope(GL, ".disable(", flag, ");");
              }
            } else {
              scope(env.cond(variable).then(GL, ".enable(", flag, ");").else(GL, ".disable(", flag, ");"));
            }
            scope(CURRENT_STATE, ".", param, "=", variable, ";");
          } else if (isArrayLike(variable)) {
            var CURRENT = CURRENT_VARS[param];
            scope(
              GL,
              ".",
              GL_VARIABLES[param],
              "(",
              variable,
              ");",
              variable.map(function(v, i3) {
                return CURRENT + "[" + i3 + "]=" + v;
              }).join(";"),
              ";"
            );
          } else {
            scope(
              GL,
              ".",
              GL_VARIABLES[param],
              "(",
              variable,
              ");",
              CURRENT_STATE,
              ".",
              param,
              "=",
              variable,
              ";"
            );
          }
        });
      }
      function injectExtensions(env, scope) {
        if (extInstancing) {
          env.instancing = scope.def(
            env.shared.extensions,
            ".angle_instanced_arrays"
          );
        }
      }
      function emitProfile(env, scope, args, useScope, incrementCounter) {
        var shared = env.shared;
        var STATS = env.stats;
        var CURRENT_STATE = shared.current;
        var TIMER = shared.timer;
        var profileArg = args.profile;
        function perfCounter() {
          if (typeof performance === "undefined") {
            return "Date.now()";
          } else {
            return "performance.now()";
          }
        }
        var CPU_START, QUERY_COUNTER;
        function emitProfileStart(block) {
          CPU_START = scope.def();
          block(CPU_START, "=", perfCounter(), ";");
          if (typeof incrementCounter === "string") {
            block(STATS, ".count+=", incrementCounter, ";");
          } else {
            block(STATS, ".count++;");
          }
          if (timer) {
            if (useScope) {
              QUERY_COUNTER = scope.def();
              block(QUERY_COUNTER, "=", TIMER, ".getNumPendingQueries();");
            } else {
              block(TIMER, ".beginQuery(", STATS, ");");
            }
          }
        }
        function emitProfileEnd(block) {
          block(STATS, ".cpuTime+=", perfCounter(), "-", CPU_START, ";");
          if (timer) {
            if (useScope) {
              block(
                TIMER,
                ".pushScopeStats(",
                QUERY_COUNTER,
                ",",
                TIMER,
                ".getNumPendingQueries(),",
                STATS,
                ");"
              );
            } else {
              block(TIMER, ".endQuery();");
            }
          }
        }
        function scopeProfile(value2) {
          var prev = scope.def(CURRENT_STATE, ".profile");
          scope(CURRENT_STATE, ".profile=", value2, ";");
          scope.exit(CURRENT_STATE, ".profile=", prev, ";");
        }
        var USE_PROFILE;
        if (profileArg) {
          if (isStatic(profileArg)) {
            if (profileArg.enable) {
              emitProfileStart(scope);
              emitProfileEnd(scope.exit);
              scopeProfile("true");
            } else {
              scopeProfile("false");
            }
            return;
          }
          USE_PROFILE = profileArg.append(env, scope);
          scopeProfile(USE_PROFILE);
        } else {
          USE_PROFILE = scope.def(CURRENT_STATE, ".profile");
        }
        var start = env.block();
        emitProfileStart(start);
        scope("if(", USE_PROFILE, "){", start, "}");
        var end = env.block();
        emitProfileEnd(end);
        scope.exit("if(", USE_PROFILE, "){", end, "}");
      }
      function emitAttributes(env, scope, args, attributes, filter) {
        var shared = env.shared;
        function typeLength(x3) {
          switch (x3) {
            case GL_FLOAT_VEC2:
            case GL_INT_VEC2:
            case GL_BOOL_VEC2:
              return 2;
            case GL_FLOAT_VEC3:
            case GL_INT_VEC3:
            case GL_BOOL_VEC3:
              return 3;
            case GL_FLOAT_VEC4:
            case GL_INT_VEC4:
            case GL_BOOL_VEC4:
              return 4;
            default:
              return 1;
          }
        }
        function emitBindAttribute(ATTRIBUTE, size2, record) {
          var GL = shared.gl;
          var LOCATION = scope.def(ATTRIBUTE, ".location");
          var BINDING = scope.def(shared.attributes, "[", LOCATION, "]");
          var STATE = record.state;
          var BUFFER = record.buffer;
          var CONST_COMPONENTS = [
            record.x,
            record.y,
            record.z,
            record.w
          ];
          var COMMON_KEYS = [
            "buffer",
            "normalized",
            "offset",
            "stride"
          ];
          function emitBuffer() {
            scope(
              "if(!",
              BINDING,
              ".buffer){",
              GL,
              ".enableVertexAttribArray(",
              LOCATION,
              ");}"
            );
            var TYPE = record.type;
            var SIZE;
            if (!record.size) {
              SIZE = size2;
            } else {
              SIZE = scope.def(record.size, "||", size2);
            }
            scope(
              "if(",
              BINDING,
              ".type!==",
              TYPE,
              "||",
              BINDING,
              ".size!==",
              SIZE,
              "||",
              COMMON_KEYS.map(function(key) {
                return BINDING + "." + key + "!==" + record[key];
              }).join("||"),
              "){",
              GL,
              ".bindBuffer(",
              GL_ARRAY_BUFFER$2,
              ",",
              BUFFER,
              ".buffer);",
              GL,
              ".vertexAttribPointer(",
              [
                LOCATION,
                SIZE,
                TYPE,
                record.normalized,
                record.stride,
                record.offset
              ],
              ");",
              BINDING,
              ".type=",
              TYPE,
              ";",
              BINDING,
              ".size=",
              SIZE,
              ";",
              COMMON_KEYS.map(function(key) {
                return BINDING + "." + key + "=" + record[key] + ";";
              }).join(""),
              "}"
            );
            if (extInstancing) {
              var DIVISOR = record.divisor;
              scope(
                "if(",
                BINDING,
                ".divisor!==",
                DIVISOR,
                "){",
                env.instancing,
                ".vertexAttribDivisorANGLE(",
                [LOCATION, DIVISOR],
                ");",
                BINDING,
                ".divisor=",
                DIVISOR,
                ";}"
              );
            }
          }
          function emitConstant() {
            scope(
              "if(",
              BINDING,
              ".buffer){",
              GL,
              ".disableVertexAttribArray(",
              LOCATION,
              ");",
              BINDING,
              ".buffer=null;",
              "}if(",
              CUTE_COMPONENTS.map(function(c3, i3) {
                return BINDING + "." + c3 + "!==" + CONST_COMPONENTS[i3];
              }).join("||"),
              "){",
              GL,
              ".vertexAttrib4f(",
              LOCATION,
              ",",
              CONST_COMPONENTS,
              ");",
              CUTE_COMPONENTS.map(function(c3, i3) {
                return BINDING + "." + c3 + "=" + CONST_COMPONENTS[i3] + ";";
              }).join(""),
              "}"
            );
          }
          if (STATE === ATTRIB_STATE_POINTER) {
            emitBuffer();
          } else if (STATE === ATTRIB_STATE_CONSTANT) {
            emitConstant();
          } else {
            scope("if(", STATE, "===", ATTRIB_STATE_POINTER, "){");
            emitBuffer();
            scope("}else{");
            emitConstant();
            scope("}");
          }
        }
        attributes.forEach(function(attribute) {
          var name2 = attribute.name;
          var arg = args.attributes[name2];
          var record;
          if (arg) {
            if (!filter(arg)) {
              return;
            }
            record = arg.append(env, scope);
          } else {
            if (!filter(SCOPE_DECL)) {
              return;
            }
            var scopeAttrib = env.scopeAttrib(name2);
            check$1.optional(function() {
              env.assert(
                scope,
                scopeAttrib + ".state",
                "missing attribute " + name2
              );
            });
            record = {};
            Object.keys(new AttributeRecord2()).forEach(function(key) {
              record[key] = scope.def(scopeAttrib, ".", key);
            });
          }
          emitBindAttribute(
            env.link(attribute),
            typeLength(attribute.info.type),
            record
          );
        });
      }
      function emitUniforms(env, scope, args, uniforms, filter, isBatchInnerLoop) {
        var shared = env.shared;
        var GL = shared.gl;
        var infix;
        for (var i3 = 0; i3 < uniforms.length; ++i3) {
          var uniform = uniforms[i3];
          var name2 = uniform.name;
          var type2 = uniform.info.type;
          var arg = args.uniforms[name2];
          var UNIFORM = env.link(uniform);
          var LOCATION = UNIFORM + ".location";
          var VALUE;
          if (arg) {
            if (!filter(arg)) {
              continue;
            }
            if (isStatic(arg)) {
              var value2 = arg.value;
              check$1.command(
                value2 !== null && typeof value2 !== "undefined",
                'missing uniform "' + name2 + '"',
                env.commandStr
              );
              if (type2 === GL_SAMPLER_2D || type2 === GL_SAMPLER_CUBE) {
                check$1.command(
                  typeof value2 === "function" && (type2 === GL_SAMPLER_2D && (value2._reglType === "texture2d" || value2._reglType === "framebuffer") || type2 === GL_SAMPLER_CUBE && (value2._reglType === "textureCube" || value2._reglType === "framebufferCube")),
                  "invalid texture for uniform " + name2,
                  env.commandStr
                );
                var TEX_VALUE = env.link(value2._texture || value2.color[0]._texture);
                scope(GL, ".uniform1i(", LOCATION, ",", TEX_VALUE + ".bind());");
                scope.exit(TEX_VALUE, ".unbind();");
              } else if (type2 === GL_FLOAT_MAT2 || type2 === GL_FLOAT_MAT3 || type2 === GL_FLOAT_MAT4) {
                check$1.optional(function() {
                  check$1.command(
                    isArrayLike(value2),
                    "invalid matrix for uniform " + name2,
                    env.commandStr
                  );
                  check$1.command(
                    type2 === GL_FLOAT_MAT2 && value2.length === 4 || type2 === GL_FLOAT_MAT3 && value2.length === 9 || type2 === GL_FLOAT_MAT4 && value2.length === 16,
                    "invalid length for matrix uniform " + name2,
                    env.commandStr
                  );
                });
                var MAT_VALUE = env.global.def("new Float32Array([" + Array.prototype.slice.call(value2) + "])");
                var dim = 2;
                if (type2 === GL_FLOAT_MAT3) {
                  dim = 3;
                } else if (type2 === GL_FLOAT_MAT4) {
                  dim = 4;
                }
                scope(
                  GL,
                  ".uniformMatrix",
                  dim,
                  "fv(",
                  LOCATION,
                  ",false,",
                  MAT_VALUE,
                  ");"
                );
              } else {
                switch (type2) {
                  case GL_FLOAT$8:
                    check$1.commandType(value2, "number", "uniform " + name2, env.commandStr);
                    infix = "1f";
                    break;
                  case GL_FLOAT_VEC2:
                    check$1.command(
                      isArrayLike(value2) && value2.length === 2,
                      "uniform " + name2,
                      env.commandStr
                    );
                    infix = "2f";
                    break;
                  case GL_FLOAT_VEC3:
                    check$1.command(
                      isArrayLike(value2) && value2.length === 3,
                      "uniform " + name2,
                      env.commandStr
                    );
                    infix = "3f";
                    break;
                  case GL_FLOAT_VEC4:
                    check$1.command(
                      isArrayLike(value2) && value2.length === 4,
                      "uniform " + name2,
                      env.commandStr
                    );
                    infix = "4f";
                    break;
                  case GL_BOOL:
                    check$1.commandType(value2, "boolean", "uniform " + name2, env.commandStr);
                    infix = "1i";
                    break;
                  case GL_INT$3:
                    check$1.commandType(value2, "number", "uniform " + name2, env.commandStr);
                    infix = "1i";
                    break;
                  case GL_BOOL_VEC2:
                    check$1.command(
                      isArrayLike(value2) && value2.length === 2,
                      "uniform " + name2,
                      env.commandStr
                    );
                    infix = "2i";
                    break;
                  case GL_INT_VEC2:
                    check$1.command(
                      isArrayLike(value2) && value2.length === 2,
                      "uniform " + name2,
                      env.commandStr
                    );
                    infix = "2i";
                    break;
                  case GL_BOOL_VEC3:
                    check$1.command(
                      isArrayLike(value2) && value2.length === 3,
                      "uniform " + name2,
                      env.commandStr
                    );
                    infix = "3i";
                    break;
                  case GL_INT_VEC3:
                    check$1.command(
                      isArrayLike(value2) && value2.length === 3,
                      "uniform " + name2,
                      env.commandStr
                    );
                    infix = "3i";
                    break;
                  case GL_BOOL_VEC4:
                    check$1.command(
                      isArrayLike(value2) && value2.length === 4,
                      "uniform " + name2,
                      env.commandStr
                    );
                    infix = "4i";
                    break;
                  case GL_INT_VEC4:
                    check$1.command(
                      isArrayLike(value2) && value2.length === 4,
                      "uniform " + name2,
                      env.commandStr
                    );
                    infix = "4i";
                    break;
                }
                scope(
                  GL,
                  ".uniform",
                  infix,
                  "(",
                  LOCATION,
                  ",",
                  isArrayLike(value2) ? Array.prototype.slice.call(value2) : value2,
                  ");"
                );
              }
              continue;
            } else {
              VALUE = arg.append(env, scope);
            }
          } else {
            if (!filter(SCOPE_DECL)) {
              continue;
            }
            VALUE = scope.def(shared.uniforms, "[", stringStore.id(name2), "]");
          }
          if (type2 === GL_SAMPLER_2D) {
            check$1(!Array.isArray(VALUE), "must specify a scalar prop for textures");
            scope(
              "if(",
              VALUE,
              "&&",
              VALUE,
              '._reglType==="framebuffer"){',
              VALUE,
              "=",
              VALUE,
              ".color[0];",
              "}"
            );
          } else if (type2 === GL_SAMPLER_CUBE) {
            check$1(!Array.isArray(VALUE), "must specify a scalar prop for cube maps");
            scope(
              "if(",
              VALUE,
              "&&",
              VALUE,
              '._reglType==="framebufferCube"){',
              VALUE,
              "=",
              VALUE,
              ".color[0];",
              "}"
            );
          }
          check$1.optional(function() {
            function emitCheck(pred, message) {
              env.assert(
                scope,
                pred,
                'bad data or missing for uniform "' + name2 + '".  ' + message
              );
            }
            function checkType(type3) {
              check$1(!Array.isArray(VALUE), "must not specify an array type for uniform");
              emitCheck(
                "typeof " + VALUE + '==="' + type3 + '"',
                "invalid type, expected " + type3
              );
            }
            function checkVector(n, type3) {
              if (Array.isArray(VALUE)) {
                check$1(VALUE.length === n, "must have length " + n);
              } else {
                emitCheck(
                  shared.isArrayLike + "(" + VALUE + ")&&" + VALUE + ".length===" + n,
                  "invalid vector, should have length " + n,
                  env.commandStr
                );
              }
            }
            function checkTexture(target2) {
              check$1(!Array.isArray(VALUE), "must not specify a value type");
              emitCheck(
                "typeof " + VALUE + '==="function"&&' + VALUE + '._reglType==="texture' + (target2 === GL_TEXTURE_2D$3 ? "2d" : "Cube") + '"',
                "invalid texture type",
                env.commandStr
              );
            }
            switch (type2) {
              case GL_INT$3:
                checkType("number");
                break;
              case GL_INT_VEC2:
                checkVector(2);
                break;
              case GL_INT_VEC3:
                checkVector(3);
                break;
              case GL_INT_VEC4:
                checkVector(4);
                break;
              case GL_FLOAT$8:
                checkType("number");
                break;
              case GL_FLOAT_VEC2:
                checkVector(2);
                break;
              case GL_FLOAT_VEC3:
                checkVector(3);
                break;
              case GL_FLOAT_VEC4:
                checkVector(4);
                break;
              case GL_BOOL:
                checkType("boolean");
                break;
              case GL_BOOL_VEC2:
                checkVector(2);
                break;
              case GL_BOOL_VEC3:
                checkVector(3);
                break;
              case GL_BOOL_VEC4:
                checkVector(4);
                break;
              case GL_FLOAT_MAT2:
                checkVector(4);
                break;
              case GL_FLOAT_MAT3:
                checkVector(9);
                break;
              case GL_FLOAT_MAT4:
                checkVector(16);
                break;
              case GL_SAMPLER_2D:
                checkTexture(GL_TEXTURE_2D$3);
                break;
              case GL_SAMPLER_CUBE:
                checkTexture(GL_TEXTURE_CUBE_MAP$2);
                break;
            }
          });
          var unroll = 1;
          switch (type2) {
            case GL_SAMPLER_2D:
            case GL_SAMPLER_CUBE:
              var TEX = scope.def(VALUE, "._texture");
              scope(GL, ".uniform1i(", LOCATION, ",", TEX, ".bind());");
              scope.exit(TEX, ".unbind();");
              continue;
            case GL_INT$3:
            case GL_BOOL:
              infix = "1i";
              break;
            case GL_INT_VEC2:
            case GL_BOOL_VEC2:
              infix = "2i";
              unroll = 2;
              break;
            case GL_INT_VEC3:
            case GL_BOOL_VEC3:
              infix = "3i";
              unroll = 3;
              break;
            case GL_INT_VEC4:
            case GL_BOOL_VEC4:
              infix = "4i";
              unroll = 4;
              break;
            case GL_FLOAT$8:
              infix = "1f";
              break;
            case GL_FLOAT_VEC2:
              infix = "2f";
              unroll = 2;
              break;
            case GL_FLOAT_VEC3:
              infix = "3f";
              unroll = 3;
              break;
            case GL_FLOAT_VEC4:
              infix = "4f";
              unroll = 4;
              break;
            case GL_FLOAT_MAT2:
              infix = "Matrix2fv";
              break;
            case GL_FLOAT_MAT3:
              infix = "Matrix3fv";
              break;
            case GL_FLOAT_MAT4:
              infix = "Matrix4fv";
              break;
          }
          if (infix.charAt(0) === "M") {
            scope(GL, ".uniform", infix, "(", LOCATION, ",");
            var matSize = Math.pow(type2 - GL_FLOAT_MAT2 + 2, 2);
            var STORAGE = env.global.def("new Float32Array(", matSize, ")");
            if (Array.isArray(VALUE)) {
              scope(
                "false,(",
                loop(matSize, function(i4) {
                  return STORAGE + "[" + i4 + "]=" + VALUE[i4];
                }),
                ",",
                STORAGE,
                ")"
              );
            } else {
              scope(
                "false,(Array.isArray(",
                VALUE,
                ")||",
                VALUE,
                " instanceof Float32Array)?",
                VALUE,
                ":(",
                loop(matSize, function(i4) {
                  return STORAGE + "[" + i4 + "]=" + VALUE + "[" + i4 + "]";
                }),
                ",",
                STORAGE,
                ")"
              );
            }
            scope(");");
          } else if (unroll > 1) {
            var prev = [];
            var cur = [];
            for (var j = 0; j < unroll; ++j) {
              if (Array.isArray(VALUE)) {
                cur.push(VALUE[j]);
              } else {
                cur.push(scope.def(VALUE + "[" + j + "]"));
              }
              if (isBatchInnerLoop) {
                prev.push(scope.def());
              }
            }
            if (isBatchInnerLoop) {
              scope("if(!", env.batchId, "||", prev.map(function(p2, i4) {
                return p2 + "!==" + cur[i4];
              }).join("||"), "){", prev.map(function(p2, i4) {
                return p2 + "=" + cur[i4] + ";";
              }).join(""));
            }
            scope(GL, ".uniform", infix, "(", LOCATION, ",", cur.join(","), ");");
            if (isBatchInnerLoop) {
              scope("}");
            }
          } else {
            check$1(!Array.isArray(VALUE), "uniform value must not be an array");
            if (isBatchInnerLoop) {
              var prevS = scope.def();
              scope(
                "if(!",
                env.batchId,
                "||",
                prevS,
                "!==",
                VALUE,
                "){",
                prevS,
                "=",
                VALUE,
                ";"
              );
            }
            scope(GL, ".uniform", infix, "(", LOCATION, ",", VALUE, ");");
            if (isBatchInnerLoop) {
              scope("}");
            }
          }
        }
      }
      function emitDraw(env, outer, inner, args) {
        var shared = env.shared;
        var GL = shared.gl;
        var DRAW_STATE = shared.draw;
        var drawOptions = args.draw;
        function emitElements() {
          var defn = drawOptions.elements;
          var ELEMENTS2;
          var scope = outer;
          if (defn) {
            if (defn.contextDep && args.contextDynamic || defn.propDep) {
              scope = inner;
            }
            ELEMENTS2 = defn.append(env, scope);
            if (drawOptions.elementsActive) {
              scope(
                "if(" + ELEMENTS2 + ")" + GL + ".bindBuffer(" + GL_ELEMENT_ARRAY_BUFFER$2 + "," + ELEMENTS2 + ".buffer.buffer);"
              );
            }
          } else {
            ELEMENTS2 = scope.def();
            scope(
              ELEMENTS2,
              "=",
              DRAW_STATE,
              ".",
              S_ELEMENTS,
              ";",
              "if(",
              ELEMENTS2,
              "){",
              GL,
              ".bindBuffer(",
              GL_ELEMENT_ARRAY_BUFFER$2,
              ",",
              ELEMENTS2,
              ".buffer.buffer);}",
              "else if(",
              shared.vao,
              ".currentVAO){",
              ELEMENTS2,
              "=",
              env.shared.elements + ".getElements(" + shared.vao,
              ".currentVAO.elements);",
              !extVertexArrays ? "if(" + ELEMENTS2 + ")" + GL + ".bindBuffer(" + GL_ELEMENT_ARRAY_BUFFER$2 + "," + ELEMENTS2 + ".buffer.buffer);" : "",
              "}"
            );
          }
          return ELEMENTS2;
        }
        function emitCount() {
          var defn = drawOptions.count;
          var COUNT2;
          var scope = outer;
          if (defn) {
            if (defn.contextDep && args.contextDynamic || defn.propDep) {
              scope = inner;
            }
            COUNT2 = defn.append(env, scope);
            check$1.optional(function() {
              if (defn.MISSING) {
                env.assert(outer, "false", "missing vertex count");
              }
              if (defn.DYNAMIC) {
                env.assert(scope, COUNT2 + ">=0", "missing vertex count");
              }
            });
          } else {
            COUNT2 = scope.def(DRAW_STATE, ".", S_COUNT);
            check$1.optional(function() {
              env.assert(scope, COUNT2 + ">=0", "missing vertex count");
            });
          }
          return COUNT2;
        }
        var ELEMENTS = emitElements();
        function emitValue(name2) {
          var defn = drawOptions[name2];
          if (defn) {
            if (defn.contextDep && args.contextDynamic || defn.propDep) {
              return defn.append(env, inner);
            } else {
              return defn.append(env, outer);
            }
          } else {
            return outer.def(DRAW_STATE, ".", name2);
          }
        }
        var PRIMITIVE = emitValue(S_PRIMITIVE);
        var OFFSET2 = emitValue(S_OFFSET);
        var COUNT = emitCount();
        if (typeof COUNT === "number") {
          if (COUNT === 0) {
            return;
          }
        } else {
          inner("if(", COUNT, "){");
          inner.exit("}");
        }
        var INSTANCES, EXT_INSTANCING;
        if (extInstancing) {
          INSTANCES = emitValue(S_INSTANCES);
          EXT_INSTANCING = env.instancing;
        }
        var ELEMENT_TYPE = ELEMENTS + ".type";
        var elementsStatic = drawOptions.elements && isStatic(drawOptions.elements) && !drawOptions.vaoActive;
        function emitInstancing() {
          function drawElements() {
            inner(EXT_INSTANCING, ".drawElementsInstancedANGLE(", [
              PRIMITIVE,
              COUNT,
              ELEMENT_TYPE,
              OFFSET2 + "<<((" + ELEMENT_TYPE + "-" + GL_UNSIGNED_BYTE$8 + ")>>1)",
              INSTANCES
            ], ");");
          }
          function drawArrays() {
            inner(
              EXT_INSTANCING,
              ".drawArraysInstancedANGLE(",
              [PRIMITIVE, OFFSET2, COUNT, INSTANCES],
              ");"
            );
          }
          if (ELEMENTS && ELEMENTS !== "null") {
            if (!elementsStatic) {
              inner("if(", ELEMENTS, "){");
              drawElements();
              inner("}else{");
              drawArrays();
              inner("}");
            } else {
              drawElements();
            }
          } else {
            drawArrays();
          }
        }
        function emitRegular() {
          function drawElements() {
            inner(GL + ".drawElements(" + [
              PRIMITIVE,
              COUNT,
              ELEMENT_TYPE,
              OFFSET2 + "<<((" + ELEMENT_TYPE + "-" + GL_UNSIGNED_BYTE$8 + ")>>1)"
            ] + ");");
          }
          function drawArrays() {
            inner(GL + ".drawArrays(" + [PRIMITIVE, OFFSET2, COUNT] + ");");
          }
          if (ELEMENTS && ELEMENTS !== "null") {
            if (!elementsStatic) {
              inner("if(", ELEMENTS, "){");
              drawElements();
              inner("}else{");
              drawArrays();
              inner("}");
            } else {
              drawElements();
            }
          } else {
            drawArrays();
          }
        }
        if (extInstancing && (typeof INSTANCES !== "number" || INSTANCES >= 0)) {
          if (typeof INSTANCES === "string") {
            inner("if(", INSTANCES, ">0){");
            emitInstancing();
            inner("}else if(", INSTANCES, "<0){");
            emitRegular();
            inner("}");
          } else {
            emitInstancing();
          }
        } else {
          emitRegular();
        }
      }
      function createBody(emitBody, parentEnv, args, program, count) {
        var env = createREGLEnvironment();
        var scope = env.proc("body", count);
        check$1.optional(function() {
          env.commandStr = parentEnv.commandStr;
          env.command = env.link(parentEnv.commandStr);
        });
        if (extInstancing) {
          env.instancing = scope.def(
            env.shared.extensions,
            ".angle_instanced_arrays"
          );
        }
        emitBody(env, scope, args, program);
        return env.compile().body;
      }
      function emitDrawBody(env, draw2, args, program) {
        injectExtensions(env, draw2);
        if (args.useVAO) {
          if (args.drawVAO) {
            draw2(env.shared.vao, ".setVAO(", args.drawVAO.append(env, draw2), ");");
          } else {
            draw2(env.shared.vao, ".setVAO(", env.shared.vao, ".targetVAO);");
          }
        } else {
          draw2(env.shared.vao, ".setVAO(null);");
          emitAttributes(env, draw2, args, program.attributes, function() {
            return true;
          });
        }
        emitUniforms(env, draw2, args, program.uniforms, function() {
          return true;
        }, false);
        emitDraw(env, draw2, draw2, args);
      }
      function emitDrawProc(env, args) {
        var draw2 = env.proc("draw", 1);
        injectExtensions(env, draw2);
        emitContext(env, draw2, args.context);
        emitPollFramebuffer(env, draw2, args.framebuffer);
        emitPollState(env, draw2, args);
        emitSetOptions(env, draw2, args.state);
        emitProfile(env, draw2, args, false, true);
        var program = args.shader.progVar.append(env, draw2);
        draw2(env.shared.gl, ".useProgram(", program, ".program);");
        if (args.shader.program) {
          emitDrawBody(env, draw2, args, args.shader.program);
        } else {
          draw2(env.shared.vao, ".setVAO(null);");
          var drawCache = env.global.def("{}");
          var PROG_ID = draw2.def(program, ".id");
          var CACHED_PROC = draw2.def(drawCache, "[", PROG_ID, "]");
          draw2(
            env.cond(CACHED_PROC).then(CACHED_PROC, ".call(this,a0);").else(
              CACHED_PROC,
              "=",
              drawCache,
              "[",
              PROG_ID,
              "]=",
              env.link(function(program2) {
                return createBody(emitDrawBody, env, args, program2, 1);
              }),
              "(",
              program,
              ");",
              CACHED_PROC,
              ".call(this,a0);"
            )
          );
        }
        if (Object.keys(args.state).length > 0) {
          draw2(env.shared.current, ".dirty=true;");
        }
        if (env.shared.vao) {
          draw2(env.shared.vao, ".setVAO(null);");
        }
      }
      function emitBatchDynamicShaderBody(env, scope, args, program) {
        env.batchId = "a1";
        injectExtensions(env, scope);
        function all() {
          return true;
        }
        emitAttributes(env, scope, args, program.attributes, all);
        emitUniforms(env, scope, args, program.uniforms, all, false);
        emitDraw(env, scope, scope, args);
      }
      function emitBatchBody(env, scope, args, program) {
        injectExtensions(env, scope);
        var contextDynamic = args.contextDep;
        var BATCH_ID = scope.def();
        var PROP_LIST = "a0";
        var NUM_PROPS = "a1";
        var PROPS = scope.def();
        env.shared.props = PROPS;
        env.batchId = BATCH_ID;
        var outer = env.scope();
        var inner = env.scope();
        scope(
          outer.entry,
          "for(",
          BATCH_ID,
          "=0;",
          BATCH_ID,
          "<",
          NUM_PROPS,
          ";++",
          BATCH_ID,
          "){",
          PROPS,
          "=",
          PROP_LIST,
          "[",
          BATCH_ID,
          "];",
          inner,
          "}",
          outer.exit
        );
        function isInnerDefn(defn) {
          return defn.contextDep && contextDynamic || defn.propDep;
        }
        function isOuterDefn(defn) {
          return !isInnerDefn(defn);
        }
        if (args.needsContext) {
          emitContext(env, inner, args.context);
        }
        if (args.needsFramebuffer) {
          emitPollFramebuffer(env, inner, args.framebuffer);
        }
        emitSetOptions(env, inner, args.state, isInnerDefn);
        if (args.profile && isInnerDefn(args.profile)) {
          emitProfile(env, inner, args, false, true);
        }
        if (!program) {
          var progCache = env.global.def("{}");
          var PROGRAM = args.shader.progVar.append(env, inner);
          var PROG_ID = inner.def(PROGRAM, ".id");
          var CACHED_PROC = inner.def(progCache, "[", PROG_ID, "]");
          inner(
            env.shared.gl,
            ".useProgram(",
            PROGRAM,
            ".program);",
            "if(!",
            CACHED_PROC,
            "){",
            CACHED_PROC,
            "=",
            progCache,
            "[",
            PROG_ID,
            "]=",
            env.link(function(program2) {
              return createBody(
                emitBatchDynamicShaderBody,
                env,
                args,
                program2,
                2
              );
            }),
            "(",
            PROGRAM,
            ");}",
            CACHED_PROC,
            ".call(this,a0[",
            BATCH_ID,
            "],",
            BATCH_ID,
            ");"
          );
        } else {
          if (args.useVAO) {
            if (args.drawVAO) {
              if (isInnerDefn(args.drawVAO)) {
                inner(env.shared.vao, ".setVAO(", args.drawVAO.append(env, inner), ");");
              } else {
                outer(env.shared.vao, ".setVAO(", args.drawVAO.append(env, outer), ");");
              }
            } else {
              outer(env.shared.vao, ".setVAO(", env.shared.vao, ".targetVAO);");
            }
          } else {
            outer(env.shared.vao, ".setVAO(null);");
            emitAttributes(env, outer, args, program.attributes, isOuterDefn);
            emitAttributes(env, inner, args, program.attributes, isInnerDefn);
          }
          emitUniforms(env, outer, args, program.uniforms, isOuterDefn, false);
          emitUniforms(env, inner, args, program.uniforms, isInnerDefn, true);
          emitDraw(env, outer, inner, args);
        }
      }
      function emitBatchProc(env, args) {
        var batch = env.proc("batch", 2);
        env.batchId = "0";
        injectExtensions(env, batch);
        var contextDynamic = false;
        var needsContext = true;
        Object.keys(args.context).forEach(function(name2) {
          contextDynamic = contextDynamic || args.context[name2].propDep;
        });
        if (!contextDynamic) {
          emitContext(env, batch, args.context);
          needsContext = false;
        }
        var framebuffer = args.framebuffer;
        var needsFramebuffer = false;
        if (framebuffer) {
          if (framebuffer.propDep) {
            contextDynamic = needsFramebuffer = true;
          } else if (framebuffer.contextDep && contextDynamic) {
            needsFramebuffer = true;
          }
          if (!needsFramebuffer) {
            emitPollFramebuffer(env, batch, framebuffer);
          }
        } else {
          emitPollFramebuffer(env, batch, null);
        }
        if (args.state.viewport && args.state.viewport.propDep) {
          contextDynamic = true;
        }
        function isInnerDefn(defn) {
          return defn.contextDep && contextDynamic || defn.propDep;
        }
        emitPollState(env, batch, args);
        emitSetOptions(env, batch, args.state, function(defn) {
          return !isInnerDefn(defn);
        });
        if (!args.profile || !isInnerDefn(args.profile)) {
          emitProfile(env, batch, args, false, "a1");
        }
        args.contextDep = contextDynamic;
        args.needsContext = needsContext;
        args.needsFramebuffer = needsFramebuffer;
        var progDefn = args.shader.progVar;
        if (progDefn.contextDep && contextDynamic || progDefn.propDep) {
          emitBatchBody(
            env,
            batch,
            args,
            null
          );
        } else {
          var PROGRAM = progDefn.append(env, batch);
          batch(env.shared.gl, ".useProgram(", PROGRAM, ".program);");
          if (args.shader.program) {
            emitBatchBody(
              env,
              batch,
              args,
              args.shader.program
            );
          } else {
            batch(env.shared.vao, ".setVAO(null);");
            var batchCache = env.global.def("{}");
            var PROG_ID = batch.def(PROGRAM, ".id");
            var CACHED_PROC = batch.def(batchCache, "[", PROG_ID, "]");
            batch(
              env.cond(CACHED_PROC).then(CACHED_PROC, ".call(this,a0,a1);").else(
                CACHED_PROC,
                "=",
                batchCache,
                "[",
                PROG_ID,
                "]=",
                env.link(function(program) {
                  return createBody(emitBatchBody, env, args, program, 2);
                }),
                "(",
                PROGRAM,
                ");",
                CACHED_PROC,
                ".call(this,a0,a1);"
              )
            );
          }
        }
        if (Object.keys(args.state).length > 0) {
          batch(env.shared.current, ".dirty=true;");
        }
        if (env.shared.vao) {
          batch(env.shared.vao, ".setVAO(null);");
        }
      }
      function emitScopeProc(env, args) {
        var scope = env.proc("scope", 3);
        env.batchId = "a2";
        var shared = env.shared;
        var CURRENT_STATE = shared.current;
        emitContext(env, scope, args.context);
        if (args.framebuffer) {
          args.framebuffer.append(env, scope);
        }
        sortState(Object.keys(args.state)).forEach(function(name2) {
          var defn = args.state[name2];
          var value2 = defn.append(env, scope);
          if (isArrayLike(value2)) {
            value2.forEach(function(v, i3) {
              scope.set(env.next[name2], "[" + i3 + "]", v);
            });
          } else {
            scope.set(shared.next, "." + name2, value2);
          }
        });
        emitProfile(env, scope, args, true, true);
        [S_ELEMENTS, S_OFFSET, S_COUNT, S_INSTANCES, S_PRIMITIVE].forEach(
          function(opt) {
            var variable = args.draw[opt];
            if (!variable) {
              return;
            }
            scope.set(shared.draw, "." + opt, "" + variable.append(env, scope));
          }
        );
        Object.keys(args.uniforms).forEach(function(opt) {
          var value2 = args.uniforms[opt].append(env, scope);
          if (Array.isArray(value2)) {
            value2 = "[" + value2.join() + "]";
          }
          scope.set(
            shared.uniforms,
            "[" + stringStore.id(opt) + "]",
            value2
          );
        });
        Object.keys(args.attributes).forEach(function(name2) {
          var record = args.attributes[name2].append(env, scope);
          var scopeAttrib = env.scopeAttrib(name2);
          Object.keys(new AttributeRecord2()).forEach(function(prop) {
            scope.set(scopeAttrib, "." + prop, record[prop]);
          });
        });
        if (args.scopeVAO) {
          scope.set(shared.vao, ".targetVAO", args.scopeVAO.append(env, scope));
        }
        function saveShader(name2) {
          var shader = args.shader[name2];
          if (shader) {
            scope.set(shared.shader, "." + name2, shader.append(env, scope));
          }
        }
        saveShader(S_VERT);
        saveShader(S_FRAG);
        if (Object.keys(args.state).length > 0) {
          scope(CURRENT_STATE, ".dirty=true;");
          scope.exit(CURRENT_STATE, ".dirty=true;");
        }
        scope("a1(", env.shared.context, ",a0,", env.batchId, ");");
      }
      function isDynamicObject(object) {
        if (typeof object !== "object" || isArrayLike(object)) {
          return;
        }
        var props4 = Object.keys(object);
        for (var i3 = 0; i3 < props4.length; ++i3) {
          if (dynamic.isDynamic(object[props4[i3]])) {
            return true;
          }
        }
        return false;
      }
      function splatObject(env, options, name2) {
        var object = options.static[name2];
        if (!object || !isDynamicObject(object)) {
          return;
        }
        var globals = env.global;
        var keys2 = Object.keys(object);
        var thisDep = false;
        var contextDep = false;
        var propDep = false;
        var objectRef = env.global.def("{}");
        keys2.forEach(function(key) {
          var value2 = object[key];
          if (dynamic.isDynamic(value2)) {
            if (typeof value2 === "function") {
              value2 = object[key] = dynamic.unbox(value2);
            }
            var deps = createDynamicDecl(value2, null);
            thisDep = thisDep || deps.thisDep;
            propDep = propDep || deps.propDep;
            contextDep = contextDep || deps.contextDep;
          } else {
            globals(objectRef, ".", key, "=");
            switch (typeof value2) {
              case "number":
                globals(value2);
                break;
              case "string":
                globals('"', value2, '"');
                break;
              case "object":
                if (Array.isArray(value2)) {
                  globals("[", value2.join(), "]");
                }
                break;
              default:
                globals(env.link(value2));
                break;
            }
            globals(";");
          }
        });
        function appendBlock(env2, block) {
          keys2.forEach(function(key) {
            var value2 = object[key];
            if (!dynamic.isDynamic(value2)) {
              return;
            }
            var ref2 = env2.invoke(block, value2);
            block(objectRef, ".", key, "=", ref2, ";");
          });
        }
        options.dynamic[name2] = new dynamic.DynamicVariable(DYN_THUNK, {
          thisDep,
          contextDep,
          propDep,
          ref: objectRef,
          append: appendBlock
        });
        delete options.static[name2];
      }
      function compileCommand(options, attributes, uniforms, context, stats2) {
        var env = createREGLEnvironment();
        env.stats = env.link(stats2);
        Object.keys(attributes.static).forEach(function(key) {
          splatObject(env, attributes, key);
        });
        NESTED_OPTIONS.forEach(function(name2) {
          splatObject(env, options, name2);
        });
        var args = parseArguments(options, attributes, uniforms, context, env);
        emitDrawProc(env, args);
        emitScopeProc(env, args);
        emitBatchProc(env, args);
        return extend2(env.compile(), {
          destroy: function() {
            args.shader.program.destroy();
          }
        });
      }
      return {
        next: nextState,
        current: currentState,
        procs: function() {
          var env = createREGLEnvironment();
          var poll = env.proc("poll");
          var refresh = env.proc("refresh");
          var common = env.block();
          poll(common);
          refresh(common);
          var shared = env.shared;
          var GL = shared.gl;
          var NEXT_STATE = shared.next;
          var CURRENT_STATE = shared.current;
          common(CURRENT_STATE, ".dirty=false;");
          emitPollFramebuffer(env, poll);
          emitPollFramebuffer(env, refresh, null, true);
          var INSTANCING;
          if (extInstancing) {
            INSTANCING = env.link(extInstancing);
          }
          if (extensions.oes_vertex_array_object) {
            refresh(env.link(extensions.oes_vertex_array_object), ".bindVertexArrayOES(null);");
          }
          for (var i3 = 0; i3 < limits.maxAttributes; ++i3) {
            var BINDING = refresh.def(shared.attributes, "[", i3, "]");
            var ifte = env.cond(BINDING, ".buffer");
            ifte.then(
              GL,
              ".enableVertexAttribArray(",
              i3,
              ");",
              GL,
              ".bindBuffer(",
              GL_ARRAY_BUFFER$2,
              ",",
              BINDING,
              ".buffer.buffer);",
              GL,
              ".vertexAttribPointer(",
              i3,
              ",",
              BINDING,
              ".size,",
              BINDING,
              ".type,",
              BINDING,
              ".normalized,",
              BINDING,
              ".stride,",
              BINDING,
              ".offset);"
            ).else(
              GL,
              ".disableVertexAttribArray(",
              i3,
              ");",
              GL,
              ".vertexAttrib4f(",
              i3,
              ",",
              BINDING,
              ".x,",
              BINDING,
              ".y,",
              BINDING,
              ".z,",
              BINDING,
              ".w);",
              BINDING,
              ".buffer=null;"
            );
            refresh(ifte);
            if (extInstancing) {
              refresh(
                INSTANCING,
                ".vertexAttribDivisorANGLE(",
                i3,
                ",",
                BINDING,
                ".divisor);"
              );
            }
          }
          refresh(
            env.shared.vao,
            ".currentVAO=null;",
            env.shared.vao,
            ".setVAO(",
            env.shared.vao,
            ".targetVAO);"
          );
          Object.keys(GL_FLAGS).forEach(function(flag) {
            var cap = GL_FLAGS[flag];
            var NEXT = common.def(NEXT_STATE, ".", flag);
            var block = env.block();
            block(
              "if(",
              NEXT,
              "){",
              GL,
              ".enable(",
              cap,
              ")}else{",
              GL,
              ".disable(",
              cap,
              ")}",
              CURRENT_STATE,
              ".",
              flag,
              "=",
              NEXT,
              ";"
            );
            refresh(block);
            poll(
              "if(",
              NEXT,
              "!==",
              CURRENT_STATE,
              ".",
              flag,
              "){",
              block,
              "}"
            );
          });
          Object.keys(GL_VARIABLES).forEach(function(name2) {
            var func = GL_VARIABLES[name2];
            var init = currentState[name2];
            var NEXT, CURRENT;
            var block = env.block();
            block(GL, ".", func, "(");
            if (isArrayLike(init)) {
              var n = init.length;
              NEXT = env.global.def(NEXT_STATE, ".", name2);
              CURRENT = env.global.def(CURRENT_STATE, ".", name2);
              block(
                loop(n, function(i4) {
                  return NEXT + "[" + i4 + "]";
                }),
                ");",
                loop(n, function(i4) {
                  return CURRENT + "[" + i4 + "]=" + NEXT + "[" + i4 + "];";
                }).join("")
              );
              poll(
                "if(",
                loop(n, function(i4) {
                  return NEXT + "[" + i4 + "]!==" + CURRENT + "[" + i4 + "]";
                }).join("||"),
                "){",
                block,
                "}"
              );
            } else {
              NEXT = common.def(NEXT_STATE, ".", name2);
              CURRENT = common.def(CURRENT_STATE, ".", name2);
              block(
                NEXT,
                ");",
                CURRENT_STATE,
                ".",
                name2,
                "=",
                NEXT,
                ";"
              );
              poll(
                "if(",
                NEXT,
                "!==",
                CURRENT,
                "){",
                block,
                "}"
              );
            }
            refresh(block);
          });
          return env.compile();
        }(),
        compile: compileCommand
      };
    }
    function stats() {
      return {
        vaoCount: 0,
        bufferCount: 0,
        elementsCount: 0,
        framebufferCount: 0,
        shaderCount: 0,
        textureCount: 0,
        cubeCount: 0,
        renderbufferCount: 0,
        maxTextureUnits: 0
      };
    }
    var GL_QUERY_RESULT_EXT = 34918;
    var GL_QUERY_RESULT_AVAILABLE_EXT = 34919;
    var GL_TIME_ELAPSED_EXT = 35007;
    var createTimer = function(gl, extensions) {
      if (!extensions.ext_disjoint_timer_query) {
        return null;
      }
      var queryPool = [];
      function allocQuery() {
        return queryPool.pop() || extensions.ext_disjoint_timer_query.createQueryEXT();
      }
      function freeQuery(query) {
        queryPool.push(query);
      }
      var pendingQueries = [];
      function beginQuery(stats2) {
        var query = allocQuery();
        extensions.ext_disjoint_timer_query.beginQueryEXT(GL_TIME_ELAPSED_EXT, query);
        pendingQueries.push(query);
        pushScopeStats(pendingQueries.length - 1, pendingQueries.length, stats2);
      }
      function endQuery() {
        extensions.ext_disjoint_timer_query.endQueryEXT(GL_TIME_ELAPSED_EXT);
      }
      function PendingStats() {
        this.startQueryIndex = -1;
        this.endQueryIndex = -1;
        this.sum = 0;
        this.stats = null;
      }
      var pendingStatsPool = [];
      function allocPendingStats() {
        return pendingStatsPool.pop() || new PendingStats();
      }
      function freePendingStats(pendingStats2) {
        pendingStatsPool.push(pendingStats2);
      }
      var pendingStats = [];
      function pushScopeStats(start, end, stats2) {
        var ps = allocPendingStats();
        ps.startQueryIndex = start;
        ps.endQueryIndex = end;
        ps.sum = 0;
        ps.stats = stats2;
        pendingStats.push(ps);
      }
      var timeSum = [];
      var queryPtr = [];
      function update6() {
        var ptr, i3;
        var n = pendingQueries.length;
        if (n === 0) {
          return;
        }
        queryPtr.length = Math.max(queryPtr.length, n + 1);
        timeSum.length = Math.max(timeSum.length, n + 1);
        timeSum[0] = 0;
        queryPtr[0] = 0;
        var queryTime = 0;
        ptr = 0;
        for (i3 = 0; i3 < pendingQueries.length; ++i3) {
          var query = pendingQueries[i3];
          if (extensions.ext_disjoint_timer_query.getQueryObjectEXT(query, GL_QUERY_RESULT_AVAILABLE_EXT)) {
            queryTime += extensions.ext_disjoint_timer_query.getQueryObjectEXT(query, GL_QUERY_RESULT_EXT);
            freeQuery(query);
          } else {
            pendingQueries[ptr++] = query;
          }
          timeSum[i3 + 1] = queryTime;
          queryPtr[i3 + 1] = ptr;
        }
        pendingQueries.length = ptr;
        ptr = 0;
        for (i3 = 0; i3 < pendingStats.length; ++i3) {
          var stats2 = pendingStats[i3];
          var start = stats2.startQueryIndex;
          var end = stats2.endQueryIndex;
          stats2.sum += timeSum[end] - timeSum[start];
          var startPtr = queryPtr[start];
          var endPtr = queryPtr[end];
          if (endPtr === startPtr) {
            stats2.stats.gpuTime += stats2.sum / 1e6;
            freePendingStats(stats2);
          } else {
            stats2.startQueryIndex = startPtr;
            stats2.endQueryIndex = endPtr;
            pendingStats[ptr++] = stats2;
          }
        }
        pendingStats.length = ptr;
      }
      return {
        beginQuery,
        endQuery,
        pushScopeStats,
        update: update6,
        getNumPendingQueries: function() {
          return pendingQueries.length;
        },
        clear: function() {
          queryPool.push.apply(queryPool, pendingQueries);
          for (var i3 = 0; i3 < queryPool.length; i3++) {
            extensions.ext_disjoint_timer_query.deleteQueryEXT(queryPool[i3]);
          }
          pendingQueries.length = 0;
          queryPool.length = 0;
        },
        restore: function() {
          pendingQueries.length = 0;
          queryPool.length = 0;
        }
      };
    };
    var GL_COLOR_BUFFER_BIT = 16384;
    var GL_DEPTH_BUFFER_BIT = 256;
    var GL_STENCIL_BUFFER_BIT = 1024;
    var GL_ARRAY_BUFFER = 34962;
    var CONTEXT_LOST_EVENT = "webglcontextlost";
    var CONTEXT_RESTORED_EVENT = "webglcontextrestored";
    var DYN_PROP = 1;
    var DYN_CONTEXT = 2;
    var DYN_STATE = 3;
    function find(haystack, needle) {
      for (var i3 = 0; i3 < haystack.length; ++i3) {
        if (haystack[i3] === needle) {
          return i3;
        }
      }
      return -1;
    }
    function wrapREGL(args) {
      var config = parseArgs(args);
      if (!config) {
        return null;
      }
      var gl = config.gl;
      var glAttributes = gl.getContextAttributes();
      var contextLost = gl.isContextLost();
      var extensionState = createExtensionCache(gl, config);
      if (!extensionState) {
        return null;
      }
      var stringStore = createStringStore();
      var stats$$1 = stats();
      var extensions = extensionState.extensions;
      var timer = createTimer(gl, extensions);
      var START_TIME = clock();
      var WIDTH = gl.drawingBufferWidth;
      var HEIGHT = gl.drawingBufferHeight;
      var contextState = {
        tick: 0,
        time: 0,
        viewportWidth: WIDTH,
        viewportHeight: HEIGHT,
        framebufferWidth: WIDTH,
        framebufferHeight: HEIGHT,
        drawingBufferWidth: WIDTH,
        drawingBufferHeight: HEIGHT,
        pixelRatio: config.pixelRatio
      };
      var uniformState = {};
      var drawState = {
        elements: null,
        primitive: 4,
        // GL_TRIANGLES
        count: -1,
        offset: 0,
        instances: -1
      };
      var limits = wrapLimits(gl, extensions);
      var bufferState = wrapBufferState(
        gl,
        stats$$1,
        config,
        destroyBuffer
      );
      var elementState = wrapElementsState(gl, extensions, bufferState, stats$$1);
      var attributeState = wrapAttributeState(
        gl,
        extensions,
        limits,
        stats$$1,
        bufferState,
        elementState,
        drawState
      );
      function destroyBuffer(buffer) {
        return attributeState.destroyBuffer(buffer);
      }
      var shaderState = wrapShaderState(gl, stringStore, stats$$1, config);
      var textureState = createTextureSet(
        gl,
        extensions,
        limits,
        function() {
          core.procs.poll();
        },
        contextState,
        stats$$1,
        config
      );
      var renderbufferState = wrapRenderbuffers(gl, extensions, limits, stats$$1, config);
      var framebufferState = wrapFBOState(
        gl,
        extensions,
        limits,
        textureState,
        renderbufferState,
        stats$$1
      );
      var core = reglCore(
        gl,
        stringStore,
        extensions,
        limits,
        bufferState,
        elementState,
        textureState,
        framebufferState,
        uniformState,
        attributeState,
        shaderState,
        drawState,
        contextState,
        timer,
        config
      );
      var readPixels = wrapReadPixels(
        gl,
        framebufferState,
        core.procs.poll,
        contextState,
        glAttributes,
        extensions,
        limits
      );
      var nextState = core.next;
      var canvas = gl.canvas;
      var rafCallbacks = [];
      var lossCallbacks = [];
      var restoreCallbacks = [];
      var destroyCallbacks = [config.onDestroy];
      var activeRAF = null;
      function handleRAF() {
        if (rafCallbacks.length === 0) {
          if (timer) {
            timer.update();
          }
          activeRAF = null;
          return;
        }
        activeRAF = raf.next(handleRAF);
        poll();
        for (var i3 = rafCallbacks.length - 1; i3 >= 0; --i3) {
          var cb = rafCallbacks[i3];
          if (cb) {
            cb(contextState, null, 0);
          }
        }
        gl.flush();
        if (timer) {
          timer.update();
        }
      }
      function startRAF() {
        if (!activeRAF && rafCallbacks.length > 0) {
          activeRAF = raf.next(handleRAF);
        }
      }
      function stopRAF() {
        if (activeRAF) {
          raf.cancel(handleRAF);
          activeRAF = null;
        }
      }
      function handleContextLoss(event) {
        event.preventDefault();
        contextLost = true;
        stopRAF();
        lossCallbacks.forEach(function(cb) {
          cb();
        });
      }
      function handleContextRestored(event) {
        gl.getError();
        contextLost = false;
        extensionState.restore();
        shaderState.restore();
        bufferState.restore();
        textureState.restore();
        renderbufferState.restore();
        framebufferState.restore();
        attributeState.restore();
        if (timer) {
          timer.restore();
        }
        core.procs.refresh();
        startRAF();
        restoreCallbacks.forEach(function(cb) {
          cb();
        });
      }
      if (canvas) {
        canvas.addEventListener(CONTEXT_LOST_EVENT, handleContextLoss, false);
        canvas.addEventListener(CONTEXT_RESTORED_EVENT, handleContextRestored, false);
      }
      function destroy3() {
        rafCallbacks.length = 0;
        stopRAF();
        if (canvas) {
          canvas.removeEventListener(CONTEXT_LOST_EVENT, handleContextLoss);
          canvas.removeEventListener(CONTEXT_RESTORED_EVENT, handleContextRestored);
        }
        shaderState.clear();
        framebufferState.clear();
        renderbufferState.clear();
        attributeState.clear();
        textureState.clear();
        elementState.clear();
        bufferState.clear();
        if (timer) {
          timer.clear();
        }
        destroyCallbacks.forEach(function(cb) {
          cb();
        });
      }
      function compileProcedure(options) {
        check$1(!!options, "invalid args to regl({...})");
        check$1.type(options, "object", "invalid args to regl({...})");
        function flattenNestedOptions(options2) {
          var result = extend2({}, options2);
          delete result.uniforms;
          delete result.attributes;
          delete result.context;
          delete result.vao;
          if ("stencil" in result && result.stencil.op) {
            result.stencil.opBack = result.stencil.opFront = result.stencil.op;
            delete result.stencil.op;
          }
          function merge2(name2) {
            if (name2 in result) {
              var child = result[name2];
              delete result[name2];
              Object.keys(child).forEach(function(prop) {
                result[name2 + "." + prop] = child[prop];
              });
            }
          }
          merge2("blend");
          merge2("depth");
          merge2("cull");
          merge2("stencil");
          merge2("polygonOffset");
          merge2("scissor");
          merge2("sample");
          if ("vao" in options2) {
            result.vao = options2.vao;
          }
          return result;
        }
        function separateDynamic(object, useArrays) {
          var staticItems = {};
          var dynamicItems = {};
          Object.keys(object).forEach(function(option) {
            var value2 = object[option];
            if (dynamic.isDynamic(value2)) {
              dynamicItems[option] = dynamic.unbox(value2, option);
              return;
            } else if (useArrays && Array.isArray(value2)) {
              for (var i3 = 0; i3 < value2.length; ++i3) {
                if (dynamic.isDynamic(value2[i3])) {
                  dynamicItems[option] = dynamic.unbox(value2, option);
                  return;
                }
              }
            }
            staticItems[option] = value2;
          });
          return {
            dynamic: dynamicItems,
            static: staticItems
          };
        }
        var context = separateDynamic(options.context || {}, true);
        var uniforms = separateDynamic(options.uniforms || {}, true);
        var attributes = separateDynamic(options.attributes || {}, false);
        var opts = separateDynamic(flattenNestedOptions(options), false);
        var stats$$12 = {
          gpuTime: 0,
          cpuTime: 0,
          count: 0
        };
        var compiled = core.compile(opts, attributes, uniforms, context, stats$$12);
        var draw2 = compiled.draw;
        var batch = compiled.batch;
        var scope = compiled.scope;
        var EMPTY_ARRAY = [];
        function reserve(count) {
          while (EMPTY_ARRAY.length < count) {
            EMPTY_ARRAY.push(null);
          }
          return EMPTY_ARRAY;
        }
        function REGLCommand(args2, body) {
          var i3;
          if (contextLost) {
            check$1.raise("context lost");
          }
          if (typeof args2 === "function") {
            return scope.call(this, null, args2, 0);
          } else if (typeof body === "function") {
            if (typeof args2 === "number") {
              for (i3 = 0; i3 < args2; ++i3) {
                scope.call(this, null, body, i3);
              }
            } else if (Array.isArray(args2)) {
              for (i3 = 0; i3 < args2.length; ++i3) {
                scope.call(this, args2[i3], body, i3);
              }
            } else {
              return scope.call(this, args2, body, 0);
            }
          } else if (typeof args2 === "number") {
            if (args2 > 0) {
              return batch.call(this, reserve(args2 | 0), args2 | 0);
            }
          } else if (Array.isArray(args2)) {
            if (args2.length) {
              return batch.call(this, args2, args2.length);
            }
          } else {
            return draw2.call(this, args2);
          }
        }
        return extend2(REGLCommand, {
          stats: stats$$12,
          destroy: function() {
            compiled.destroy();
          }
        });
      }
      var setFBO = framebufferState.setFBO = compileProcedure({
        framebuffer: dynamic.define.call(null, DYN_PROP, "framebuffer")
      });
      function clearImpl(_, options) {
        var clearFlags = 0;
        core.procs.poll();
        var c3 = options.color;
        if (c3) {
          gl.clearColor(+c3[0] || 0, +c3[1] || 0, +c3[2] || 0, +c3[3] || 0);
          clearFlags |= GL_COLOR_BUFFER_BIT;
        }
        if ("depth" in options) {
          gl.clearDepth(+options.depth);
          clearFlags |= GL_DEPTH_BUFFER_BIT;
        }
        if ("stencil" in options) {
          gl.clearStencil(options.stencil | 0);
          clearFlags |= GL_STENCIL_BUFFER_BIT;
        }
        check$1(!!clearFlags, "called regl.clear with no buffer specified");
        gl.clear(clearFlags);
      }
      function clear(options) {
        check$1(
          typeof options === "object" && options,
          "regl.clear() takes an object as input"
        );
        if ("framebuffer" in options) {
          if (options.framebuffer && options.framebuffer_reglType === "framebufferCube") {
            for (var i3 = 0; i3 < 6; ++i3) {
              setFBO(extend2({
                framebuffer: options.framebuffer.faces[i3]
              }, options), clearImpl);
            }
          } else {
            setFBO(options, clearImpl);
          }
        } else {
          clearImpl(null, options);
        }
      }
      function frame(cb) {
        check$1.type(cb, "function", "regl.frame() callback must be a function");
        rafCallbacks.push(cb);
        function cancel() {
          var i3 = find(rafCallbacks, cb);
          check$1(i3 >= 0, "cannot cancel a frame twice");
          function pendingCancel() {
            var index2 = find(rafCallbacks, pendingCancel);
            rafCallbacks[index2] = rafCallbacks[rafCallbacks.length - 1];
            rafCallbacks.length -= 1;
            if (rafCallbacks.length <= 0) {
              stopRAF();
            }
          }
          rafCallbacks[i3] = pendingCancel;
        }
        startRAF();
        return {
          cancel
        };
      }
      function pollViewport() {
        var viewport = nextState.viewport;
        var scissorBox = nextState.scissor_box;
        viewport[0] = viewport[1] = scissorBox[0] = scissorBox[1] = 0;
        contextState.viewportWidth = contextState.framebufferWidth = contextState.drawingBufferWidth = viewport[2] = scissorBox[2] = gl.drawingBufferWidth;
        contextState.viewportHeight = contextState.framebufferHeight = contextState.drawingBufferHeight = viewport[3] = scissorBox[3] = gl.drawingBufferHeight;
      }
      function poll() {
        contextState.tick += 1;
        contextState.time = now2();
        pollViewport();
        core.procs.poll();
      }
      function refresh() {
        textureState.refresh();
        pollViewport();
        core.procs.refresh();
        if (timer) {
          timer.update();
        }
      }
      function now2() {
        return (clock() - START_TIME) / 1e3;
      }
      refresh();
      function addListener2(event, callback2) {
        check$1.type(callback2, "function", "listener callback must be a function");
        var callbacks;
        switch (event) {
          case "frame":
            return frame(callback2);
          case "lost":
            callbacks = lossCallbacks;
            break;
          case "restore":
            callbacks = restoreCallbacks;
            break;
          case "destroy":
            callbacks = destroyCallbacks;
            break;
          default:
            check$1.raise("invalid event, must be one of frame,lost,restore,destroy");
        }
        callbacks.push(callback2);
        return {
          cancel: function() {
            for (var i3 = 0; i3 < callbacks.length; ++i3) {
              if (callbacks[i3] === callback2) {
                callbacks[i3] = callbacks[callbacks.length - 1];
                callbacks.pop();
                return;
              }
            }
          }
        };
      }
      var regl2 = extend2(compileProcedure, {
        // Clear current FBO
        clear,
        // Short cuts for dynamic variables
        prop: dynamic.define.bind(null, DYN_PROP),
        context: dynamic.define.bind(null, DYN_CONTEXT),
        this: dynamic.define.bind(null, DYN_STATE),
        // executes an empty draw command
        draw: compileProcedure({}),
        // Resources
        buffer: function(options) {
          return bufferState.create(options, GL_ARRAY_BUFFER, false, false);
        },
        elements: function(options) {
          return elementState.create(options, false);
        },
        texture: textureState.create2D,
        cube: textureState.createCube,
        renderbuffer: renderbufferState.create,
        framebuffer: framebufferState.create,
        framebufferCube: framebufferState.createCube,
        vao: attributeState.createVAO,
        // Expose context attributes
        attributes: glAttributes,
        // Frame rendering
        frame,
        on: addListener2,
        // System limits
        limits,
        hasExtension: function(name2) {
          return limits.extensions.indexOf(name2.toLowerCase()) >= 0;
        },
        // Read pixels
        read: readPixels,
        // Destroy regl and all associated resources
        destroy: destroy3,
        // Direct GL state manipulation
        _gl: gl,
        _refresh: refresh,
        poll: function() {
          poll();
          if (timer) {
            timer.update();
          }
        },
        // Current time
        now: now2,
        // regl Statistics Information
        stats: stats$$1
      });
      config.onDone(null, regl2);
      return regl2;
    }
    return wrapREGL;
  });
})(regl);
var reglExports = regl.exports;
const createOriginalRegl = /* @__PURE__ */ getDefaultExportFromCjs$1(reglExports);
var EPSILON = 1e-6;
var ARRAY_TYPE = typeof Float32Array !== "undefined" ? Float32Array : Array;
if (!Math.hypot) Math.hypot = function() {
  var y4 = 0, i3 = arguments.length;
  while (i3--) {
    y4 += arguments[i3] * arguments[i3];
  }
  return Math.sqrt(y4);
};
function create$2() {
  var out = new ARRAY_TYPE(16);
  if (ARRAY_TYPE != Float32Array) {
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
  }
  out[0] = 1;
  out[5] = 1;
  out[10] = 1;
  out[15] = 1;
  return out;
}
function clone$1(a4) {
  var out = new ARRAY_TYPE(16);
  out[0] = a4[0];
  out[1] = a4[1];
  out[2] = a4[2];
  out[3] = a4[3];
  out[4] = a4[4];
  out[5] = a4[5];
  out[6] = a4[6];
  out[7] = a4[7];
  out[8] = a4[8];
  out[9] = a4[9];
  out[10] = a4[10];
  out[11] = a4[11];
  out[12] = a4[12];
  out[13] = a4[13];
  out[14] = a4[14];
  out[15] = a4[15];
  return out;
}
function invert(out, a4) {
  var a00 = a4[0], a01 = a4[1], a02 = a4[2], a03 = a4[3];
  var a10 = a4[4], a11 = a4[5], a12 = a4[6], a13 = a4[7];
  var a20 = a4[8], a21 = a4[9], a222 = a4[10], a23 = a4[11];
  var a30 = a4[12], a31 = a4[13], a32 = a4[14], a33 = a4[15];
  var b00 = a00 * a11 - a01 * a10;
  var b01 = a00 * a12 - a02 * a10;
  var b02 = a00 * a13 - a03 * a10;
  var b03 = a01 * a12 - a02 * a11;
  var b04 = a01 * a13 - a03 * a11;
  var b05 = a02 * a13 - a03 * a12;
  var b06 = a20 * a31 - a21 * a30;
  var b07 = a20 * a32 - a222 * a30;
  var b08 = a20 * a33 - a23 * a30;
  var b09 = a21 * a32 - a222 * a31;
  var b10 = a21 * a33 - a23 * a31;
  var b11 = a222 * a33 - a23 * a32;
  var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
  if (!det) {
    return null;
  }
  det = 1 / det;
  out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
  out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
  out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
  out[3] = (a222 * b04 - a21 * b05 - a23 * b03) * det;
  out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
  out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
  out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
  out[7] = (a20 * b05 - a222 * b02 + a23 * b01) * det;
  out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
  out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
  out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
  out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
  out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
  out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
  out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
  out[15] = (a20 * b03 - a21 * b01 + a222 * b00) * det;
  return out;
}
function multiply(out, a4, b3) {
  var a00 = a4[0], a01 = a4[1], a02 = a4[2], a03 = a4[3];
  var a10 = a4[4], a11 = a4[5], a12 = a4[6], a13 = a4[7];
  var a20 = a4[8], a21 = a4[9], a222 = a4[10], a23 = a4[11];
  var a30 = a4[12], a31 = a4[13], a32 = a4[14], a33 = a4[15];
  var b0 = b3[0], b1 = b3[1], b22 = b3[2], b32 = b3[3];
  out[0] = b0 * a00 + b1 * a10 + b22 * a20 + b32 * a30;
  out[1] = b0 * a01 + b1 * a11 + b22 * a21 + b32 * a31;
  out[2] = b0 * a02 + b1 * a12 + b22 * a222 + b32 * a32;
  out[3] = b0 * a03 + b1 * a13 + b22 * a23 + b32 * a33;
  b0 = b3[4];
  b1 = b3[5];
  b22 = b3[6];
  b32 = b3[7];
  out[4] = b0 * a00 + b1 * a10 + b22 * a20 + b32 * a30;
  out[5] = b0 * a01 + b1 * a11 + b22 * a21 + b32 * a31;
  out[6] = b0 * a02 + b1 * a12 + b22 * a222 + b32 * a32;
  out[7] = b0 * a03 + b1 * a13 + b22 * a23 + b32 * a33;
  b0 = b3[8];
  b1 = b3[9];
  b22 = b3[10];
  b32 = b3[11];
  out[8] = b0 * a00 + b1 * a10 + b22 * a20 + b32 * a30;
  out[9] = b0 * a01 + b1 * a11 + b22 * a21 + b32 * a31;
  out[10] = b0 * a02 + b1 * a12 + b22 * a222 + b32 * a32;
  out[11] = b0 * a03 + b1 * a13 + b22 * a23 + b32 * a33;
  b0 = b3[12];
  b1 = b3[13];
  b22 = b3[14];
  b32 = b3[15];
  out[12] = b0 * a00 + b1 * a10 + b22 * a20 + b32 * a30;
  out[13] = b0 * a01 + b1 * a11 + b22 * a21 + b32 * a31;
  out[14] = b0 * a02 + b1 * a12 + b22 * a222 + b32 * a32;
  out[15] = b0 * a03 + b1 * a13 + b22 * a23 + b32 * a33;
  return out;
}
function fromTranslation(out, v) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = 1;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 1;
  out[11] = 0;
  out[12] = v[0];
  out[13] = v[1];
  out[14] = v[2];
  out[15] = 1;
  return out;
}
function fromScaling(out, v) {
  out[0] = v[0];
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = v[1];
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = v[2];
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
function fromRotation(out, rad, axis) {
  var x3 = axis[0], y4 = axis[1], z3 = axis[2];
  var len = Math.hypot(x3, y4, z3);
  var s4, c3, t3;
  if (len < EPSILON) {
    return null;
  }
  len = 1 / len;
  x3 *= len;
  y4 *= len;
  z3 *= len;
  s4 = Math.sin(rad);
  c3 = Math.cos(rad);
  t3 = 1 - c3;
  out[0] = x3 * x3 * t3 + c3;
  out[1] = y4 * x3 * t3 + z3 * s4;
  out[2] = z3 * x3 * t3 - y4 * s4;
  out[3] = 0;
  out[4] = x3 * y4 * t3 - z3 * s4;
  out[5] = y4 * y4 * t3 + c3;
  out[6] = z3 * y4 * t3 + x3 * s4;
  out[7] = 0;
  out[8] = x3 * z3 * t3 + y4 * s4;
  out[9] = y4 * z3 * t3 - x3 * s4;
  out[10] = z3 * z3 * t3 + c3;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
function getTranslation(out, mat) {
  out[0] = mat[12];
  out[1] = mat[13];
  out[2] = mat[14];
  return out;
}
function getScaling(out, mat) {
  var m11 = mat[0];
  var m12 = mat[1];
  var m13 = mat[2];
  var m21 = mat[4];
  var m222 = mat[5];
  var m23 = mat[6];
  var m31 = mat[8];
  var m32 = mat[9];
  var m33 = mat[10];
  out[0] = Math.hypot(m11, m12, m13);
  out[1] = Math.hypot(m21, m222, m23);
  out[2] = Math.hypot(m31, m32, m33);
  return out;
}
function create$1() {
  var out = new ARRAY_TYPE(4);
  if (ARRAY_TYPE != Float32Array) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
  }
  return out;
}
function transformMat4(out, a4, m4) {
  var x3 = a4[0], y4 = a4[1], z3 = a4[2], w3 = a4[3];
  out[0] = m4[0] * x3 + m4[4] * y4 + m4[8] * z3 + m4[12] * w3;
  out[1] = m4[1] * x3 + m4[5] * y4 + m4[9] * z3 + m4[13] * w3;
  out[2] = m4[2] * x3 + m4[6] * y4 + m4[10] * z3 + m4[14] * w3;
  out[3] = m4[3] * x3 + m4[7] * y4 + m4[11] * z3 + m4[15] * w3;
  return out;
}
(function() {
  var vec = create$1();
  return function(a4, stride, offset2, count, fn, arg) {
    var i3, l;
    if (!stride) {
      stride = 4;
    }
    if (!offset2) {
      offset2 = 0;
    }
    if (count) {
      l = Math.min(count * stride + offset2, a4.length);
    } else {
      l = a4.length;
    }
    for (i3 = offset2; i3 < l; i3 += stride) {
      vec[0] = a4[i3];
      vec[1] = a4[i3 + 1];
      vec[2] = a4[i3 + 2];
      vec[3] = a4[i3 + 3];
      fn(vec, vec, arg);
      a4[i3] = vec[0];
      a4[i3 + 1] = vec[1];
      a4[i3 + 2] = vec[2];
      a4[i3 + 3] = vec[3];
    }
    return a4;
  };
})();
function create$3() {
  var out = new ARRAY_TYPE(2);
  if (ARRAY_TYPE != Float32Array) {
    out[0] = 0;
    out[1] = 0;
  }
  return out;
}
function angle(a4, b3) {
  var x1 = a4[0], y1 = a4[1], x22 = b3[0], y23 = b3[1], mag = Math.sqrt(x1 * x1 + y1 * y1) * Math.sqrt(x22 * x22 + y23 * y23), cosine = mag && (x1 * x22 + y1 * y23) / mag;
  return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
(function() {
  var vec = create$3();
  return function(a4, stride, offset2, count, fn, arg) {
    var i3, l;
    if (!stride) {
      stride = 2;
    }
    if (!offset2) {
      offset2 = 0;
    }
    if (count) {
      l = Math.min(count * stride + offset2, a4.length);
    } else {
      l = a4.length;
    }
    for (i3 = offset2; i3 < l; i3 += stride) {
      vec[0] = a4[i3];
      vec[1] = a4[i3 + 1];
      fn(vec, vec, arg);
      a4[i3] = vec[0];
      a4[i3 + 1] = vec[1];
    }
    return a4;
  };
})();
const createCamera = (initTarget = [0, 0], initDistance = 1, initRotation = 0, initViewCenter = [0, 0], initScaleBounds = [
  [0, Infinity],
  [0, Infinity]
], initTranslationBounds = [
  [-Infinity, Infinity],
  [-Infinity, Infinity]
]) => {
  const scratch0 = new Float32Array(16);
  const scratch1 = new Float32Array(16);
  const scratch2 = new Float32Array(16);
  let view = create$2();
  let viewCenter = [...initViewCenter.slice(0, 2), 0, 1];
  const scaleXBounds = Array.isArray(initScaleBounds[0]) ? [...initScaleBounds[0]] : [...initScaleBounds];
  const scaleYBounds = Array.isArray(initScaleBounds[0]) ? [...initScaleBounds[1]] : [...initScaleBounds];
  const translationXBounds = Array.isArray(initTranslationBounds[0]) ? [...initTranslationBounds[0]] : [...initTranslationBounds];
  const translationYBounds = Array.isArray(initTranslationBounds[0]) ? [...initTranslationBounds[1]] : [...initTranslationBounds];
  const getScaling$1 = () => getScaling(scratch0, view).slice(0, 2);
  const getMinScaling = () => {
    const scaling = getScaling$1();
    return Math.min(scaling[0], scaling[1]);
  };
  const getMaxScaling = () => {
    const scaling = getScaling$1();
    return Math.max(scaling[0], scaling[1]);
  };
  const getRotation = () => Math.acos(view[0] / getMaxScaling());
  const getScaleBounds = () => [[...scaleXBounds], [...scaleYBounds]];
  const getTranslationBounds = () => [
    [...translationXBounds],
    [...translationYBounds]
  ];
  const getDistance = () => {
    const scaling = getScaling$1();
    return [1 / scaling[0], 1 / scaling[1]];
  };
  const getMinDistance = () => 1 / getMinScaling();
  const getMaxDistance = () => 1 / getMaxScaling();
  const getTranslation$1 = () => getTranslation(scratch0, view).slice(0, 2);
  const getTarget = () => transformMat4(scratch0, viewCenter, invert(scratch2, view)).slice(0, 2);
  const getView = () => view;
  const getViewCenter = () => viewCenter.slice(0, 2);
  const lookAt = ([x3 = 0, y4 = 0] = [], newDistance = 1, newRotation = 0) => {
    view = create$2();
    translate2([-x3, -y4]);
    rotate2(newRotation);
    scale(1 / newDistance);
  };
  const translate2 = ([x3 = 0, y4 = 0] = []) => {
    scratch0[0] = x3;
    scratch0[1] = y4;
    scratch0[2] = 0;
    const t3 = fromTranslation(scratch1, scratch0);
    multiply(view, t3, view);
  };
  const scale = (d4, mousePos) => {
    const isArray2 = Array.isArray(d4);
    let dx = isArray2 ? d4[0] : d4;
    let dy = isArray2 ? d4[1] : d4;
    if (dx <= 0 || dy <= 0 || dx === 1 && dy === 1) return;
    const scaling = getScaling$1();
    const newXScale = scaling[0] * dx;
    const newYScale = scaling[1] * dy;
    dx = Math.max(scaleXBounds[0], Math.min(newXScale, scaleXBounds[1])) / scaling[0];
    dy = Math.max(scaleYBounds[0], Math.min(newYScale, scaleYBounds[1])) / scaling[1];
    if (dx === 1 && dy === 1) return;
    scratch0[0] = dx;
    scratch0[1] = dy;
    scratch0[2] = 1;
    const s4 = fromScaling(scratch1, scratch0);
    const scaleCenter = mousePos ? [...mousePos, 0] : viewCenter;
    const a4 = fromTranslation(scratch0, scaleCenter);
    multiply(
      view,
      a4,
      multiply(
        view,
        s4,
        multiply(view, invert(scratch2, a4), view)
      )
    );
  };
  const rotate2 = (rad) => {
    const r = create$2();
    fromRotation(r, rad, [0, 0, 1]);
    multiply(view, r, view);
  };
  const setScaleBounds = (newBounds) => {
    const isArray2 = Array.isArray(newBounds[0]);
    scaleXBounds[0] = isArray2 ? newBounds[0][0] : newBounds[0];
    scaleXBounds[1] = isArray2 ? newBounds[0][1] : newBounds[1];
    scaleYBounds[0] = isArray2 ? newBounds[1][0] : newBounds[0];
    scaleYBounds[1] = isArray2 ? newBounds[1][1] : newBounds[1];
  };
  const setTranslationBounds = (newBounds) => {
    const isArray2 = Array.isArray(newBounds[0]);
    translationXBounds[0] = isArray2 ? newBounds[0][0] : newBounds[0];
    translationXBounds[1] = isArray2 ? newBounds[0][1] : newBounds[1];
    translationYBounds[0] = isArray2 ? newBounds[1][0] : newBounds[0];
    translationYBounds[1] = isArray2 ? newBounds[1][1] : newBounds[1];
  };
  const setView = (newView) => {
    if (!newView || newView.length < 16) return;
    view = newView;
  };
  const setViewCenter = (newViewCenter) => {
    viewCenter = [...newViewCenter.slice(0, 2), 0, 1];
  };
  const reset = () => {
    lookAt(initTarget, initDistance, initRotation);
  };
  lookAt(initTarget, initDistance, initRotation);
  return {
    get translation() {
      return getTranslation$1();
    },
    get target() {
      return getTarget();
    },
    get scaling() {
      return getScaling$1();
    },
    get minScaling() {
      return getMinScaling();
    },
    get maxScaling() {
      return getMaxScaling();
    },
    get scaleBounds() {
      return getScaleBounds();
    },
    get translationBounds() {
      return getTranslationBounds();
    },
    get distance() {
      return getDistance();
    },
    get minDistance() {
      return getMinDistance();
    },
    get maxDistance() {
      return getMaxDistance();
    },
    get rotation() {
      return getRotation();
    },
    get view() {
      return getView();
    },
    get viewCenter() {
      return getViewCenter();
    },
    lookAt,
    translate: translate2,
    pan: translate2,
    rotate: rotate2,
    scale,
    zoom: scale,
    reset,
    set: (...args) => {
      console.warn("`set()` is deprecated. Please use `setView()` instead.");
      return setView(...args);
    },
    setScaleBounds,
    setTranslationBounds,
    setView,
    setViewCenter
  };
};
const MOUSE_DOWN_MOVE_ACTIONS = ["pan", "rotate"];
const KEY_MAP = {
  alt: "altKey",
  cmd: "metaKey",
  ctrl: "ctrlKey",
  meta: "metaKey",
  shift: "shiftKey"
};
const dom2dCamera = (element, {
  distance = 1,
  target: target2 = [0, 0],
  rotation = 0,
  isNdc = true,
  isFixed = false,
  isPan = true,
  isPanInverted = [false, true],
  panSpeed = 1,
  isRotate = true,
  rotateSpeed = 1,
  defaultMouseDownMoveAction = "pan",
  mouseDownMoveModKey = "alt",
  isZoom = true,
  zoomSpeed = 1,
  viewCenter,
  scaleBounds,
  translationBounds,
  onKeyDown = () => {
  },
  onKeyUp = () => {
  },
  onMouseDown = () => {
  },
  onMouseUp = () => {
  },
  onMouseMove = () => {
  },
  onWheel: onWheel2 = () => {
  }
} = {}) => {
  let camera = createCamera(
    target2,
    distance,
    rotation,
    viewCenter,
    scaleBounds,
    translationBounds
  );
  let mouseX = 0;
  let mouseY = 0;
  let mouseRelX = 0;
  let mouseRelY = 0;
  let prevMouseX = 0;
  let prevMouseY = 0;
  let isLeftMousePressed = false;
  let scrollDist = 0;
  let width = 1;
  let height2 = 1;
  let aspectRatio = 1;
  let isInteractivelyChanged = false;
  let isProgrammaticallyChanged = false;
  let isMouseDownMoveModActive = false;
  let panOnMouseDownMove = defaultMouseDownMoveAction === "pan";
  let isPanX = isPan;
  let isPanY = isPan;
  let isPanXInverted = isPanInverted;
  let isPanYInverted = isPanInverted;
  let isZoomX = isZoom;
  let isZoomY = isZoom;
  const spreadXYSettings = () => {
    isPanX = Array.isArray(isPan) ? Boolean(isPan[0]) : isPan;
    isPanY = Array.isArray(isPan) ? Boolean(isPan[1]) : isPan;
    isPanXInverted = Array.isArray(isPanInverted) ? Boolean(isPanInverted[0]) : isPanInverted;
    isPanYInverted = Array.isArray(isPanInverted) ? Boolean(isPanInverted[1]) : isPanInverted;
    isZoomX = Array.isArray(isZoom) ? Boolean(isZoom[0]) : isZoom;
    isZoomY = Array.isArray(isZoom) ? Boolean(isZoom[1]) : isZoom;
  };
  spreadXYSettings();
  const transformPanX = isNdc ? (dX) => dX / width * 2 * aspectRatio : (dX) => dX;
  const transformPanY = isNdc ? (dY) => dY / height2 * 2 : (dY) => -dY;
  const transformScaleX = isNdc ? (x3) => (-1 + x3 / width * 2) * aspectRatio : (x3) => x3;
  const transformScaleY = isNdc ? (y4) => 1 - y4 / height2 * 2 : (y4) => y4;
  const tick = () => {
    if (isFixed) {
      const isChanged2 = isProgrammaticallyChanged;
      isProgrammaticallyChanged = false;
      return isChanged2;
    }
    isInteractivelyChanged = false;
    const currentMouseX = mouseX;
    const currentMouseY = mouseY;
    if ((isPanX || isPanY) && isLeftMousePressed && (panOnMouseDownMove && !isMouseDownMoveModActive || !panOnMouseDownMove && isMouseDownMoveModActive)) {
      const dX = isPanXInverted ? prevMouseX - currentMouseX : currentMouseX - prevMouseX;
      const transformedPanX = isPanX ? transformPanX(panSpeed * dX) : 0;
      const dY = isPanYInverted ? prevMouseY - currentMouseY : currentMouseY - prevMouseY;
      const transformedPanY = isPanY ? transformPanY(panSpeed * dY) : 0;
      if (transformedPanX !== 0 || transformedPanY !== 0) {
        camera.pan([transformedPanX, transformedPanY]);
        isInteractivelyChanged = true;
      }
    }
    if ((isZoomX || isZoomY) && scrollDist) {
      const dZ = zoomSpeed * Math.exp(scrollDist / height2);
      const transformedX = transformScaleX(mouseRelX);
      const transformedY = transformScaleY(mouseRelY);
      camera.scale(
        [isZoomX ? 1 / dZ : 1, isZoomY ? 1 / dZ : 1],
        [transformedX, transformedY]
      );
      isInteractivelyChanged = true;
    }
    if (isRotate && isLeftMousePressed && (panOnMouseDownMove && isMouseDownMoveModActive || !panOnMouseDownMove && !isMouseDownMoveModActive) && Math.abs(prevMouseX - currentMouseX) + Math.abs(prevMouseY - currentMouseY) > 0) {
      const wh = width / 2;
      const hh = height2 / 2;
      const x1 = prevMouseX - wh;
      const y1 = hh - prevMouseY;
      const x22 = currentMouseX - wh;
      const y23 = hh - currentMouseY;
      const radians = angle([x1, y1], [x22, y23]);
      const cross = x1 * y23 - x22 * y1;
      camera.rotate(rotateSpeed * radians * Math.sign(cross));
      isInteractivelyChanged = true;
    }
    scrollDist = 0;
    prevMouseX = currentMouseX;
    prevMouseY = currentMouseY;
    const isChanged = isInteractivelyChanged || isProgrammaticallyChanged;
    isProgrammaticallyChanged = false;
    return isChanged;
  };
  const config = ({
    defaultMouseDownMoveAction: newDefaultMouseDownMoveAction = null,
    isFixed: newIsFixed = null,
    isPan: newIsPan = null,
    isPanInverted: newIsPanInverted = null,
    isRotate: newIsRotate = null,
    isZoom: newIsZoom = null,
    panSpeed: newPanSpeed = null,
    rotateSpeed: newRotateSpeed = null,
    zoomSpeed: newZoomSpeed = null,
    mouseDownMoveModKey: newMouseDownMoveModKey = null
  } = {}) => {
    defaultMouseDownMoveAction = newDefaultMouseDownMoveAction !== null && MOUSE_DOWN_MOVE_ACTIONS.includes(newDefaultMouseDownMoveAction) ? newDefaultMouseDownMoveAction : defaultMouseDownMoveAction;
    panOnMouseDownMove = defaultMouseDownMoveAction === "pan";
    isFixed = newIsFixed !== null ? newIsFixed : isFixed;
    isPan = newIsPan !== null ? newIsPan : isPan;
    isPanInverted = newIsPanInverted !== null ? newIsPanInverted : isPanInverted;
    isRotate = newIsRotate !== null ? newIsRotate : isRotate;
    isZoom = newIsZoom !== null ? newIsZoom : isZoom;
    panSpeed = +newPanSpeed > 0 ? newPanSpeed : panSpeed;
    rotateSpeed = +newRotateSpeed > 0 ? newRotateSpeed : rotateSpeed;
    zoomSpeed = +newZoomSpeed > 0 ? newZoomSpeed : zoomSpeed;
    spreadXYSettings();
    mouseDownMoveModKey = newMouseDownMoveModKey !== null && Object.keys(KEY_MAP).includes(newMouseDownMoveModKey) ? newMouseDownMoveModKey : mouseDownMoveModKey;
  };
  const refresh = () => {
    const bBox = element.getBoundingClientRect();
    width = bBox.width;
    height2 = bBox.height;
    aspectRatio = width / height2;
  };
  const keyUpHandler = (event) => {
    isMouseDownMoveModActive = false;
    onKeyUp(event);
  };
  const keyDownHandler = (event) => {
    isMouseDownMoveModActive = event[KEY_MAP[mouseDownMoveModKey]];
    onKeyDown(event);
  };
  const mouseUpHandler = (event) => {
    isLeftMousePressed = false;
    onMouseUp(event);
  };
  const mouseDownHandler = (event) => {
    isLeftMousePressed = event.buttons === 1;
    onMouseDown(event);
  };
  const offsetXSupport = document.createEvent("MouseEvent").offsetX !== void 0;
  const updateMouseRelXY = offsetXSupport ? (event) => {
    mouseRelX = event.offsetX;
    mouseRelY = event.offsetY;
  } : (event) => {
    const bBox = element.getBoundingClientRect();
    mouseRelX = event.clientX - bBox.left;
    mouseRelY = event.clientY - bBox.top;
  };
  const updateMouseXY = (event) => {
    mouseX = event.clientX;
    mouseY = event.clientY;
  };
  const mouseMoveHandler = (event) => {
    updateMouseXY(event);
    onMouseMove(event);
  };
  const wheelHandler = (event) => {
    if (isZoomX || isZoomY) {
      event.preventDefault();
      updateMouseXY(event);
      updateMouseRelXY(event);
      const scale = event.deltaMode === 1 ? 12 : 1;
      scrollDist += scale * (event.deltaY || event.deltaX || 0);
    }
    onWheel2(event);
  };
  const dispose = () => {
    camera = void 0;
    window.removeEventListener("keydown", keyDownHandler);
    window.removeEventListener("keyup", keyUpHandler);
    element.removeEventListener("mousedown", mouseDownHandler);
    window.removeEventListener("mouseup", mouseUpHandler);
    window.removeEventListener("mousemove", mouseMoveHandler);
    element.removeEventListener("wheel", wheelHandler);
  };
  window.addEventListener("keydown", keyDownHandler, { passive: true });
  window.addEventListener("keyup", keyUpHandler, { passive: true });
  element.addEventListener("mousedown", mouseDownHandler, { passive: true });
  window.addEventListener("mouseup", mouseUpHandler, { passive: true });
  window.addEventListener("mousemove", mouseMoveHandler, { passive: true });
  element.addEventListener("wheel", wheelHandler, { passive: false });
  camera.config = config;
  camera.dispose = dispose;
  camera.refresh = refresh;
  camera.tick = tick;
  const withProgrammaticChange = (fn) => function() {
    fn.apply(null, arguments);
    isProgrammaticallyChanged = true;
  };
  camera.lookAt = withProgrammaticChange(camera.lookAt);
  camera.translate = withProgrammaticChange(camera.translate);
  camera.pan = withProgrammaticChange(camera.pan);
  camera.rotate = withProgrammaticChange(camera.rotate);
  camera.scale = withProgrammaticChange(camera.scale);
  camera.zoom = withProgrammaticChange(camera.zoom);
  camera.reset = withProgrammaticChange(camera.reset);
  camera.set = withProgrammaticChange(camera.set);
  camera.setScaleBounds = withProgrammaticChange(camera.setScaleBounds);
  camera.setTranslationBounds = withProgrammaticChange(
    camera.setTranslationBounds
  );
  camera.setView = withProgrammaticChange(camera.setView);
  camera.setViewCenter = withProgrammaticChange(camera.setViewCenter);
  refresh();
  return camera;
};
const FRAGMENT_SHADER$3 = `
precision mediump float;
varying vec4 color;
void main() {
  gl_FragColor = color;
}`;
const VERTEX_SHADER$1 = `
uniform mat4 projectionViewModel;
uniform float aspectRatio;

uniform sampler2D colorTex;
uniform float colorTexRes;
uniform float colorTexEps;
uniform float width;
uniform float useOpacity;
uniform float useColorOpacity;
uniform int miter;

attribute vec3 prevPosition;
attribute vec3 currPosition;
attribute vec3 nextPosition;
attribute float opacity;
attribute float offsetScale;
attribute float colorIndex;

varying vec4 color;

void main() {
  vec2 aspectVec = vec2(aspectRatio, 1.0);
  vec4 prevProjected = projectionViewModel * vec4(prevPosition, 1.0);
  vec4 currProjected = projectionViewModel * vec4(currPosition, 1.0);
  vec4 nextProjected = projectionViewModel * vec4(nextPosition, 1.0);

  // get 2D screen space with W divide and aspect correction
  vec2 prevScreen = prevProjected.xy / prevProjected.w * aspectVec;
  vec2 currScreen = currProjected.xy / currProjected.w * aspectVec;
  vec2 nextScreen = nextProjected.xy / nextProjected.w * aspectVec;

  float len = width;

  // starting point uses (next - current)
  vec2 dir = vec2(0.0);
  if (currScreen == prevScreen) {
    dir = normalize(nextScreen - currScreen);
  }
  // ending point uses (current - previous)
  else if (currScreen == nextScreen) {
    dir = normalize(currScreen - prevScreen);
  }
  // somewhere in middle, needs a join
  else {
    // get directions from (C - B) and (B - A)
    vec2 dirA = normalize((currScreen - prevScreen));
    if (miter == 1) {
      vec2 dirB = normalize((nextScreen - currScreen));
      // now compute the miter join normal and length
      vec2 tangent = normalize(dirA + dirB);
      vec2 perp = vec2(-dirA.y, dirA.x);
      vec2 miter = vec2(-tangent.y, tangent.x);
      len = width / dot(miter, perp);
      dir = tangent;
    } else {
      dir = dirA;
    }
  }

  vec2 normal = vec2(-dir.y, dir.x) * len;
  normal.x /= aspectRatio;
  vec4 offset = vec4(normal * offsetScale, 0.0, 0.0);
  gl_Position = currProjected + offset;

  // Get color from texture
  float colorRowIndex = floor((colorIndex + colorTexEps) / colorTexRes);
  vec2 colorTexIndex = vec2(
    (colorIndex / colorTexRes) - colorRowIndex + colorTexEps,
    colorRowIndex / colorTexRes + colorTexEps
  );

  color = texture2D(colorTex, colorTexIndex);
  color.a = useColorOpacity * color.a + useOpacity * opacity;
}`;
const I2 = new Float32Array([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]);
const FLOAT_BYTES$1 = Float32Array.BYTES_PER_ELEMENT;
const isPositiveNumber$1 = (n) => {
  return n !== void 0 && Number.isFinite(n);
};
const isNestedArray = (arr) => {
  return arr.length > 0 && Array.isArray(arr[0]);
};
const { push, splice } = Array.prototype;
const createMesh = (numPointsPerLine, buffer = []) => {
  let numPrevPoints = 0;
  for (const numPoints of numPointsPerLine) {
    for (let i3 = 0; i3 < numPoints - 1; i3++) {
      const a4 = numPrevPoints + i3 * 2;
      const b3 = a4 + 1;
      const c3 = a4 + 2;
      const d4 = a4 + 3;
      buffer.push(a4, b3, c3, c3, b3, d4);
    }
    numPrevPoints += (numPoints + 2) * 2;
  }
  return buffer;
};
function bufferDuplicate(buffer, stride = 1, dupScale = 1) {
  const out = [];
  const component = new Array(stride * 2);
  for (let i3 = 0, il = buffer.length / stride; i3 < il; i3++) {
    const index2 = i3 * stride;
    for (let j = 0; j < stride; j++) {
      const value2 = buffer[index2 + j];
      component[j] = value2;
      component[j + stride] = value2 * dupScale;
    }
    push.apply(out, component);
  }
  return out;
}
function bufferCopyElement(buffer, sourceElementIndex, targetIndex, stride) {
  const component = new Array(stride);
  const ai = sourceElementIndex * stride;
  for (let i3 = 0; i3 < stride; i3++) {
    component[i3] = buffer[ai + i3];
  }
  splice.call(buffer, targetIndex * stride, 0, ...component);
  return buffer;
}
function bufferIncreaseStride(buffer, stride, newStride, undefValue = 0) {
  const out = [];
  const component = new Array(newStride).fill(undefValue);
  for (let i3 = 0, il = buffer.length / stride; i3 < il; i3++) {
    const index2 = i3 * stride;
    for (let j = 0; j < stride; j++) {
      component[j] = buffer[index2 + j];
    }
    push.apply(out, component);
  }
  return out;
}
const createLine = (regl2, { projection = I2, model = I2, view = I2, points = [], colorIndices = [], color: color2 = [0.8, 0.5, 0, 1], opacity = null, opacities = [], width = 1, widths = [], miter = true, is2d = false, zPos2d = 0 } = {}) => {
  if (!regl2) {
    console.error("Regl instance is undefined.");
    return;
  }
  const pvm = new Float32Array(16);
  let numLines;
  let numPoints;
  let numPointsPerLine;
  let pointsPadded;
  let pointsDup;
  let colorIndicesDup;
  let opacitiesDup;
  let widthsDup;
  let indices;
  let pointBuffer;
  let opacityBuffer;
  let widthBuffer;
  let colorTex;
  let colorTexRes;
  let colorIndexBuffer;
  let attributes;
  let elements;
  let drawLine;
  let dim = is2d ? 2 : 3;
  const useOpacity = () => +(opacities.length === numPoints || opacity !== null);
  const init = () => {
    pointBuffer = regl2.buffer();
    opacityBuffer = regl2.buffer();
    widthBuffer = regl2.buffer();
    colorIndexBuffer = regl2.buffer();
    attributes = {
      prevPosition: {
        // Typing issue in Regl
        buffer: () => pointBuffer,
        offset: 0,
        stride: FLOAT_BYTES$1 * 3
      },
      currPosition: {
        // Typing issue in Regl
        buffer: () => pointBuffer,
        // note that each point is duplicated, hence we need to skip over the first two
        offset: FLOAT_BYTES$1 * 3 * 2,
        stride: FLOAT_BYTES$1 * 3
      },
      nextPosition: {
        // Typing issue in Regl
        buffer: () => pointBuffer,
        // note that each point is duplicated, hence we need to skip over the first four
        offset: FLOAT_BYTES$1 * 3 * 4,
        stride: FLOAT_BYTES$1 * 3
      },
      opacity: {
        // Typing issue in Regl
        buffer: () => opacityBuffer,
        // note that each point is duplicated, hence we need to skip over the first two
        offset: FLOAT_BYTES$1 * 2,
        stride: FLOAT_BYTES$1
      },
      offsetScale: {
        // Typing issue in Regl
        buffer: () => widthBuffer,
        // note that each point is duplicated, hence we need to skip over the first two
        offset: FLOAT_BYTES$1 * 2,
        stride: FLOAT_BYTES$1
      },
      colorIndex: {
        // Typing issue in Regl
        buffer: () => colorIndexBuffer,
        // note that each point is duplicated, hence we need to skip over the first two
        offset: FLOAT_BYTES$1 * 2,
        stride: FLOAT_BYTES$1
      }
    };
    elements = regl2.elements();
    drawLine = regl2({
      attributes,
      depth: { enable: !is2d },
      blend: {
        enable: true,
        func: {
          // biome-ignore lint/style/useNamingConvention: predefined property
          srcRGB: "src alpha",
          srcAlpha: "one",
          // biome-ignore lint/style/useNamingConvention: predefined property
          dstRGB: "one minus src alpha",
          dstAlpha: "one minus src alpha"
        }
      },
      uniforms: {
        projectionViewModel: (context, props4) => {
          const projection2 = context.projection || props4.projection;
          const model2 = context.model || props4.model;
          const view2 = context.view || props4.view;
          return multiply(pvm, projection2, multiply(pvm, view2, model2));
        },
        aspectRatio: ({ viewportWidth, viewportHeight }) => viewportWidth / viewportHeight,
        colorTex: () => colorTex,
        colorTexRes: () => colorTexRes,
        colorTexEps: () => 0.5 / colorTexRes,
        pixelRatio: ({ pixelRatio }) => pixelRatio,
        width: ({ pixelRatio, viewportHeight }) => width / viewportHeight * pixelRatio,
        useOpacity,
        useColorOpacity: () => Number(!useOpacity()),
        miter: Number(Boolean(miter))
      },
      elements: () => elements,
      vert: VERTEX_SHADER$1,
      frag: FRAGMENT_SHADER$3
    });
  };
  const prepare = () => {
    if (numLines === 1 && points.length % dim > 0) {
      console.warn(`The length of points (${numPoints}) does not match the dimensions (${dim}). Incomplete points are ignored.`);
    }
    pointsPadded = points.flat().slice(0, numPoints * dim);
    if (is2d) {
      pointsPadded = bufferIncreaseStride(pointsPadded, 2, 3, zPos2d);
    }
    if (colorIndices.length !== numPoints) {
      colorIndices = new Array(numPoints).fill(0);
    }
    if (widths.length !== numPoints) {
      widths = new Array(numPoints).fill(1);
    }
    const finalColorIndices = colorIndices.slice();
    const finalOpacities = opacities.length === numPoints ? opacities.slice() : new Array(numPoints).fill(opacity === null ? 1 : opacity);
    const finalWidths = widths.slice();
    let k3 = 0;
    for (const n of numPointsPerLine) {
      const lastPointIdx = k3 + n - 1;
      bufferCopyElement(pointsPadded, lastPointIdx, lastPointIdx, 3);
      bufferCopyElement(pointsPadded, k3, k3, 3);
      bufferCopyElement(finalColorIndices, lastPointIdx, lastPointIdx, 1);
      bufferCopyElement(finalColorIndices, k3, k3, 1);
      bufferCopyElement(finalOpacities, lastPointIdx, lastPointIdx, 1);
      bufferCopyElement(finalOpacities, k3, k3, 1);
      bufferCopyElement(finalWidths, lastPointIdx, lastPointIdx, 1);
      bufferCopyElement(finalWidths, k3, k3, 1);
      k3 += n + 2;
    }
    pointsDup = new Float32Array(bufferDuplicate(pointsPadded, 3));
    colorIndicesDup = bufferDuplicate(finalColorIndices);
    opacitiesDup = bufferDuplicate(finalOpacities);
    widthsDup = bufferDuplicate(finalWidths, 1, -1);
    indices = createMesh(numPointsPerLine);
    pointBuffer({
      usage: "dynamic",
      type: "float",
      length: pointsDup.length * FLOAT_BYTES$1,
      data: pointsDup
    });
    opacityBuffer({
      usage: "dynamic",
      type: "float",
      length: opacitiesDup.length * FLOAT_BYTES$1,
      data: opacitiesDup
    });
    widthBuffer({
      usage: "dynamic",
      type: "float",
      length: widthsDup.length * FLOAT_BYTES$1,
      data: widthsDup
    });
    colorIndexBuffer({
      usage: "dynamic",
      type: "float",
      length: colorIndicesDup.length * FLOAT_BYTES$1,
      data: colorIndicesDup
    });
    elements({
      primitive: "triangles",
      usage: "dynamic",
      type: indices.length > 2 ** 16 ? "uint32" : "uint16",
      data: indices
    });
  };
  const clear = () => {
    destroy3();
    init();
  };
  const destroy3 = () => {
    points = [];
    pointsPadded = [];
    pointsDup = new Float32Array();
    widthsDup = [];
    indices = [];
    pointBuffer.destroy();
    widthBuffer.destroy();
    elements.destroy();
  };
  const draw2 = ({ projection: newProjection, model: newModel, view: newView } = {}) => {
    if (newProjection) {
      projection = newProjection;
    }
    if (newModel) {
      model = newModel;
    }
    if (newView) {
      view = newView;
    }
    if (points && points.length > 1) {
      drawLine({ projection, model, view });
    }
  };
  const getPerPointProperty = (property, newValues) => {
    const flatValues = newValues.flat(2);
    if (flatValues.length === numPoints) {
      return flatValues;
    }
    if (flatValues.length === numLines) {
      return numPointsPerLine.flatMap((n, i3) => Array(n).fill(flatValues[i3]));
    }
    return property;
  };
  const getPoints = () => points;
  const setPoints = (newPoints = [], { colorIndices: newColorIndices = colorIndices, opacities: newOpacities = opacities, widths: newWidths = widths, is2d: newIs2d = is2d } = {}) => {
    points = newPoints;
    is2d = newIs2d;
    dim = is2d ? 2 : 3;
    numLines = isNestedArray(points) ? points.length : 1;
    numPointsPerLine = isNestedArray(points) ? points.map((pts) => Math.floor(pts.length / dim)) : [Math.floor(points.length / dim)];
    numPoints = numPointsPerLine.reduce((n, nPts) => n + nPts, 0);
    colorIndices = getPerPointProperty(colorIndices, newColorIndices);
    opacities = getPerPointProperty(opacities, newOpacities);
    widths = getPerPointProperty(widths, newWidths);
    if (points && numPoints > 1) {
      prepare();
    } else {
      clear();
    }
  };
  const createColorTexture = () => {
    const colors2 = isNestedArray(color2) ? color2 : [color2];
    colorTexRes = Math.max(2, Math.ceil(Math.sqrt(colors2.length)));
    const rgba2 = new Uint8Array(colorTexRes ** 2 * 4);
    colors2.forEach((color3, i3) => {
      rgba2[i3 * 4] = Math.min(255, Math.max(0, Math.round(color3[0] * 255)));
      rgba2[i3 * 4 + 1] = Math.min(255, Math.max(0, Math.round(color3[1] * 255)));
      rgba2[i3 * 4 + 2] = Math.min(255, Math.max(0, Math.round(color3[2] * 255)));
      rgba2[i3 * 4 + 3] = Number.isNaN(+color3[3]) ? 255 : Math.min(255, Math.max(0, Math.round(color3[3] * 255)));
    });
    colorTex = regl2.texture({
      data: rgba2,
      shape: [colorTexRes, colorTexRes, 4]
    });
  };
  const setColor2 = (newColor, newOpacity = opacity) => {
    color2 = newColor;
    opacity = newOpacity;
    if (colorTex) {
      colorTex.destroy();
    }
    createColorTexture();
  };
  const getStyle2 = () => ({ color: color2, miter, width });
  const setStyle2 = ({ color: newColor, opacity: newOpacity, miter: newMiter, width: newWidth } = {}) => {
    if (newColor) {
      setColor2(newColor, newOpacity || opacity);
    }
    if (newMiter) {
      miter = Boolean(newMiter);
    }
    if (isPositiveNumber$1(newWidth)) {
      width = newWidth;
    }
  };
  const getBuffer = () => ({
    points: pointBuffer,
    widths: widthBuffer,
    opacities: opacityBuffer,
    colorIndices: colorIndexBuffer
  });
  const getData = () => ({
    points: pointsDup,
    widths: widthsDup,
    opacities: opacitiesDup,
    colorIndices: colorIndicesDup
  });
  init();
  createColorTexture();
  if (points && points.length > 1) {
    setPoints(points);
  }
  return {
    clear,
    destroy: destroy3,
    draw: draw2,
    getPoints,
    setPoints,
    getData,
    getBuffer,
    getStyle: getStyle2,
    setStyle: setStyle2
  };
};
var createLine$1 = createLine;
const cubicIn = (t3) => t3 * t3 * t3;
const cubicInOut = (t3) => t3 < 0.5 ? 4 * t3 * t3 * t3 : (t3 - 1) * (2 * t3 - 2) * (2 * t3 - 2) + 1;
const cubicOut = (t3) => --t3 * t3 * t3 + 1;
const linear = (t3) => t3;
const quadIn = (t3) => t3 * t3;
const quadInOut = (t3) => t3 < 0.5 ? 2 * t3 * t3 : -1 + (4 - 2 * t3) * t3;
const quadOut = (t3) => t3 * (2 - t3);
const identity = (x3) => x3;
const hasSameElements = (a4, b3) => {
  if (a4 === b3) return true;
  if (a4.length !== b3.length) return false;
  const aSet = new Set(a4);
  const bSet = new Set(b3);
  if (aSet.size !== bSet.size) return false;
  return b3.every((element) => aSet.has(element));
};
const max$1 = (v) => v.reduce((_max, a4) => a4 > _max ? a4 : _max, -Infinity);
const rangeMap = (length, mapFn = (x3) => x3) => {
  const out = [];
  for (let i3 = 0; i3 < length; i3++) {
    out.push(mapFn(i3, length));
  }
  return out;
};
const unionIntegers = (v, w3) => {
  const a4 = [];
  v.forEach((x3) => {
    a4[x3] = true;
  });
  w3.forEach((x3) => {
    a4[x3] = true;
  });
  return a4.reduce((union, value2, i3) => {
    if (value2) union.push(i3);
    return union;
  }, []);
};
const assign = (target2, ...sources) => {
  sources.forEach((source) => {
    const descriptors2 = Object.keys(source).reduce((descriptors3, key) => {
      descriptors3[key] = Object.getOwnPropertyDescriptor(source, key);
      return descriptors3;
    }, {});
    Object.getOwnPropertySymbols(source).forEach((symbol) => {
      const descriptor = Object.getOwnPropertyDescriptor(source, symbol);
      if (descriptor.enumerable) {
        descriptors2[symbol] = descriptor;
      }
    });
    Object.defineProperties(target2, descriptors2);
  });
  return target2;
};
const pipe = (...fns) => (
  /**
   * @param {*} x - Some value
   * @return {*} Output of the composed function
   */
  (x3) => fns.reduce((y4, f) => f(y4), x3)
);
const withConstructor = (constructor) => (self2) => assign(
  {
    __proto__: {
      constructor
    }
  },
  self2
);
const withStaticProperty = (name2, value2) => (self2) => assign(self2, {
  get [name2]() {
    return value2;
  }
});
const l2PointDist = (fromX, fromY, toX, toY) => Math.sqrt((fromX - toX) ** 2 + (fromY - toY) ** 2);
const createWorker$1 = (fn) => new Worker(
  window.URL.createObjectURL(
    new Blob([`(${fn.toString()})()`], { type: "text/javascript" })
  )
);
const nextAnimationFrame = (n = 1) => new Promise((resolve2) => {
  let i3 = 0;
  const raf = () => requestAnimationFrame(() => {
    i3++;
    if (i3 < n) raf();
    else resolve2();
  });
  raf();
});
const throttleAndDebounce = (fn, throttleTime, debounceTime = null) => {
  let timeout2;
  let blockedCalls = 0;
  debounceTime = debounceTime === null ? throttleTime : debounceTime;
  const debounced = (...args) => {
    const later = () => {
      if (blockedCalls > 0) {
        fn(...args);
        blockedCalls = 0;
      }
    };
    clearTimeout(timeout2);
    timeout2 = setTimeout(later, debounceTime);
  };
  let isWaiting = false;
  const throttledAndDebounced = (...args) => {
    if (!isWaiting) {
      fn(...args);
      debounced(...args);
      isWaiting = true;
      blockedCalls = 0;
      setTimeout(() => {
        isWaiting = false;
      }, throttleTime);
    } else {
      blockedCalls++;
      debounced(...args);
    }
  };
  throttledAndDebounced.reset = () => {
    isWaiting = false;
  };
  throttledAndDebounced.cancel = () => {
    clearTimeout(timeout2);
  };
  throttledAndDebounced.now = (...args) => fn(...args);
  return throttledAndDebounced;
};
/**
 * KDBush - A fast static index for 2D points
 * @license ISC License
 * @copyright Vladimir Agafonkin 2018
 * @version 4.0.2
 * @see https://github.com/mourner/kdbush/
 */
var createKDBushClass = () => {
  const ARRAY_TYPES = [
    Int8Array,
    Uint8Array,
    Uint8ClampedArray,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array
  ];
  const VERSION = 1;
  const HEADER_SIZE = 8;
  class KDBush2 {
    /**
     * Creates an index from raw `ArrayBuffer` data.
     * @param {ArrayBuffer} data
     */
    static from(data) {
      if (!(data instanceof ArrayBuffer)) {
        throw new Error("Data must be an instance of ArrayBuffer.");
      }
      const [magic, versionAndType] = new Uint8Array(data, 0, 2);
      if (magic !== 219) {
        throw new Error("Data does not appear to be in a KDBush format.");
      }
      const version2 = versionAndType >> 4;
      if (version2 !== VERSION) {
        throw new Error(`Got v${version2} data when expected v${VERSION}.`);
      }
      const ArrayType = ARRAY_TYPES[versionAndType & 15];
      if (!ArrayType) {
        throw new Error("Unrecognized array type.");
      }
      const [nodeSize] = new Uint16Array(data, 2, 1);
      const [numItems] = new Uint32Array(data, 4, 1);
      return new KDBush2(numItems, nodeSize, ArrayType, data);
    }
    /**
     * Creates an index that will hold a given number of items.
     * @param {number} numItems
     * @param {number} [nodeSize=64] Size of the KD-tree node (64 by default).
     * @param {TypedArrayConstructor} [ArrayType=Float64Array] The array type used for coordinates storage (`Float64Array` by default).
     * @param {ArrayBuffer} [data] (For internal use only)
     */
    constructor(numItems, nodeSize = 64, ArrayType = Float64Array, data) {
      if (isNaN(numItems) || numItems < 0)
        throw new Error(`Unexpected numItems value: ${numItems}.`);
      this.numItems = +numItems;
      this.nodeSize = Math.min(Math.max(+nodeSize, 2), 65535);
      this.ArrayType = ArrayType;
      this.IndexArrayType = numItems < 65536 ? Uint16Array : Uint32Array;
      const arrayTypeIndex = ARRAY_TYPES.indexOf(this.ArrayType);
      const coordsByteSize = numItems * 2 * this.ArrayType.BYTES_PER_ELEMENT;
      const idsByteSize = numItems * this.IndexArrayType.BYTES_PER_ELEMENT;
      const padCoords = (8 - idsByteSize % 8) % 8;
      if (arrayTypeIndex < 0) {
        throw new Error(`Unexpected typed array class: ${ArrayType}.`);
      }
      if (data && data instanceof ArrayBuffer) {
        this.data = data;
        this.ids = new this.IndexArrayType(this.data, HEADER_SIZE, numItems);
        this.coords = new this.ArrayType(
          this.data,
          HEADER_SIZE + idsByteSize + padCoords,
          numItems * 2
        );
        this._pos = numItems * 2;
        this._finished = true;
      } else {
        this.data = new ArrayBuffer(
          HEADER_SIZE + coordsByteSize + idsByteSize + padCoords
        );
        this.ids = new this.IndexArrayType(this.data, HEADER_SIZE, numItems);
        this.coords = new this.ArrayType(
          this.data,
          HEADER_SIZE + idsByteSize + padCoords,
          numItems * 2
        );
        this._pos = 0;
        this._finished = false;
        new Uint8Array(this.data, 0, 2).set([
          219,
          (VERSION << 4) + arrayTypeIndex
        ]);
        new Uint16Array(this.data, 2, 1)[0] = nodeSize;
        new Uint32Array(this.data, 4, 1)[0] = numItems;
      }
    }
    /**
     * Add a point to the index.
     * @param {number} x
     * @param {number} y
     * @returns {number} An incremental index associated with the added item (starting from `0`).
     */
    add(x3, y4) {
      const index2 = this._pos >> 1;
      this.ids[index2] = index2;
      this.coords[this._pos++] = x3;
      this.coords[this._pos++] = y4;
      return index2;
    }
    /**
     * Perform indexing of the added points.
     */
    finish() {
      const numAdded = this._pos >> 1;
      if (numAdded !== this.numItems) {
        throw new Error(
          `Added ${numAdded} items when expected ${this.numItems}.`
        );
      }
      sort(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0);
      this._finished = true;
      return this;
    }
    /**
     * Search the index for items within a given bounding box.
     * @param {number} minX
     * @param {number} minY
     * @param {number} maxX
     * @param {number} maxY
     * @returns {number[]} An array of indices correponding to the found items.
     */
    range(minX, minY, maxX, maxY) {
      if (!this._finished)
        throw new Error("Data not yet indexed - call index.finish().");
      const { ids, coords, nodeSize } = this;
      const stack2 = [0, ids.length - 1, 0];
      const result = [];
      while (stack2.length) {
        const axis = stack2.pop() || 0;
        const right = stack2.pop() || 0;
        const left = stack2.pop() || 0;
        if (right - left <= nodeSize) {
          for (let i3 = left; i3 <= right; i3++) {
            const x4 = coords[2 * i3];
            const y5 = coords[2 * i3 + 1];
            if (x4 >= minX && x4 <= maxX && y5 >= minY && y5 <= maxY)
              result.push(ids[i3]);
          }
          continue;
        }
        const m4 = left + right >> 1;
        const x3 = coords[2 * m4];
        const y4 = coords[2 * m4 + 1];
        if (x3 >= minX && x3 <= maxX && y4 >= minY && y4 <= maxY)
          result.push(ids[m4]);
        if (axis === 0 ? minX <= x3 : minY <= y4) {
          stack2.push(left);
          stack2.push(m4 - 1);
          stack2.push(1 - axis);
        }
        if (axis === 0 ? maxX >= x3 : maxY >= y4) {
          stack2.push(m4 + 1);
          stack2.push(right);
          stack2.push(1 - axis);
        }
      }
      return result;
    }
    /**
     * Search the index for items within a given radius.
     * @param {number} qx
     * @param {number} qy
     * @param {number} r Query radius.
     * @returns {number[]} An array of indices correponding to the found items.
     */
    within(qx, qy, r) {
      if (!this._finished)
        throw new Error("Data not yet indexed - call index.finish().");
      const { ids, coords, nodeSize } = this;
      const stack2 = [0, ids.length - 1, 0];
      const result = [];
      const r2 = r * r;
      while (stack2.length) {
        const axis = stack2.pop() || 0;
        const right = stack2.pop() || 0;
        const left = stack2.pop() || 0;
        if (right - left <= nodeSize) {
          for (let i3 = left; i3 <= right; i3++) {
            if (sqDist(coords[2 * i3], coords[2 * i3 + 1], qx, qy) <= r2)
              result.push(ids[i3]);
          }
          continue;
        }
        const m4 = left + right >> 1;
        const x3 = coords[2 * m4];
        const y4 = coords[2 * m4 + 1];
        if (sqDist(x3, y4, qx, qy) <= r2) result.push(ids[m4]);
        if (axis === 0 ? qx - r <= x3 : qy - r <= y4) {
          stack2.push(left);
          stack2.push(m4 - 1);
          stack2.push(1 - axis);
        }
        if (axis === 0 ? qx + r >= x3 : qy + r >= y4) {
          stack2.push(m4 + 1);
          stack2.push(right);
          stack2.push(1 - axis);
        }
      }
      return result;
    }
  }
  function sort(ids, coords, nodeSize, left, right, axis) {
    if (right - left <= nodeSize) return;
    const m4 = left + right >> 1;
    select(ids, coords, m4, left, right, axis);
    sort(ids, coords, nodeSize, left, m4 - 1, 1 - axis);
    sort(ids, coords, nodeSize, m4 + 1, right, 1 - axis);
  }
  function select(ids, coords, k3, left, right, axis) {
    while (right > left) {
      if (right - left > 600) {
        const n = right - left + 1;
        const m4 = k3 - left + 1;
        const z3 = Math.log(n);
        const s4 = 0.5 * Math.exp(2 * z3 / 3);
        const sd = 0.5 * Math.sqrt(z3 * s4 * (n - s4) / n) * (m4 - n / 2 < 0 ? -1 : 1);
        const newLeft = Math.max(left, Math.floor(k3 - m4 * s4 / n + sd));
        const newRight = Math.min(
          right,
          Math.floor(k3 + (n - m4) * s4 / n + sd)
        );
        select(ids, coords, k3, newLeft, newRight, axis);
      }
      const t3 = coords[2 * k3 + axis];
      let i3 = left;
      let j = right;
      swapItem(ids, coords, left, k3);
      if (coords[2 * right + axis] > t3) swapItem(ids, coords, left, right);
      while (i3 < j) {
        swapItem(ids, coords, i3, j);
        i3++;
        j--;
        while (coords[2 * i3 + axis] < t3) i3++;
        while (coords[2 * j + axis] > t3) j--;
      }
      if (coords[2 * left + axis] === t3) swapItem(ids, coords, left, j);
      else {
        j++;
        swapItem(ids, coords, j, right);
      }
      if (j <= k3) left = j + 1;
      if (k3 <= j) right = j - 1;
    }
  }
  function swapItem(ids, coords, i3, j) {
    swap2(ids, i3, j);
    swap2(coords, 2 * i3, 2 * j);
    swap2(coords, 2 * i3 + 1, 2 * j + 1);
  }
  function swap2(arr, i3, j) {
    const tmp = arr[i3];
    arr[i3] = arr[j];
    arr[j] = tmp;
  }
  function sqDist(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
  }
  return KDBush2;
};
var workerFn = () => {
  addEventListener("message", (event) => {
    const points = event.data.points;
    if (!points.length) {
      self.postMessage({ error: new Error("Invalid point data") });
    }
    const index2 = new KDBush(points.length, event.data.nodeSize);
    for (let i3 = 0; i3 < points.length; ++i3) {
      index2.add(points[i3][0], points[i3][1]);
    }
    index2.finish();
    postMessage(index2.data, [index2.data]);
  });
};
const KDBush$1 = createKDBushClass();
const WORKER_THRESHOLD = 1e6;
const createWorker = (fn) => {
  let kdbushStr = createKDBushClass.toString();
  kdbushStr = kdbushStr.substring(10, kdbushStr.length - 18);
  let fnStr = fn.toString();
  fnStr = fnStr.substring(10, fnStr.length - 2);
  return new Worker(
    window.URL.createObjectURL(
      new Blob([`${kdbushStr};${fnStr}`], {
        type: "text/javascript"
      })
    )
  );
};
const createKdbush = (pointsOrIndex, options = { nodeSize: 16, useWorker: void 0 }) => new Promise((resolve2, reject) => {
  if (pointsOrIndex instanceof ArrayBuffer) {
    resolve2(KDBush$1.from(pointsOrIndex));
  } else if ((pointsOrIndex.length < WORKER_THRESHOLD || options.useWorker === false) && options.useWorker !== true) {
    const index2 = new KDBush$1(pointsOrIndex.length, options.nodeSize);
    for (let i3 = 0; i3 < pointsOrIndex.length; ++i3) {
      index2.add(pointsOrIndex[i3][0], pointsOrIndex[i3][1]);
    }
    index2.finish();
    resolve2(index2);
  } else {
    const worker3 = createWorker(workerFn);
    worker3.onmessage = (e3) => {
      if (e3.data.error) reject(e3.data.error);
      else resolve2(KDBush$1.from(e3.data));
      worker3.terminate();
    };
    worker3.postMessage({ points: pointsOrIndex, nodeSize: options.nodeSize });
  }
});
const AUTO = "auto";
const COLOR_NORMAL_IDX = 0;
const COLOR_ACTIVE_IDX = 1;
const COLOR_HOVER_IDX = 2;
const COLOR_BG_IDX = 3;
const COLOR_NUM_STATES = 4;
const FLOAT_BYTES = Float32Array.BYTES_PER_ELEMENT;
const GL_EXTENSIONS = [
  "OES_texture_float",
  "OES_element_index_uint",
  "WEBGL_color_buffer_float",
  "EXT_float_blend"
];
const CLEAR_OPTIONS = {
  color: [0, 0, 0, 0],
  // Transparent background color
  depth: 1
};
const MOUSE_MODE_PANZOOM = "panZoom";
const MOUSE_MODE_LASSO = "lasso";
const MOUSE_MODE_ROTATE = "rotate";
const MOUSE_MODES = [
  MOUSE_MODE_PANZOOM,
  MOUSE_MODE_LASSO,
  MOUSE_MODE_ROTATE
];
const DEFAULT_MOUSE_MODE = MOUSE_MODE_PANZOOM;
const EASING_FNS = {
  cubicIn,
  cubicInOut,
  cubicOut,
  linear,
  quadIn,
  quadInOut,
  quadOut
};
const DEFAULT_EASING = cubicInOut;
const CONTINUOUS = "continuous";
const CATEGORICAL = "categorical";
const VALUE_ZW_DATA_TYPES = [CONTINUOUS, CATEGORICAL];
const LASSO_CLEAR_ON_DESELECT = "deselect";
const LASSO_CLEAR_ON_END = "lassoEnd";
const LASSO_CLEAR_EVENTS = [LASSO_CLEAR_ON_DESELECT, LASSO_CLEAR_ON_END];
const DEFAULT_LASSO_COLOR = [0, 0.666666667, 1, 1];
const DEFAULT_LASSO_LINE_WIDTH = 2;
const DEFAULT_LASSO_INITIATOR = false;
const DEFAULT_LASSO_MIN_DELAY$1 = 10;
const DEFAULT_LASSO_MIN_DIST$1 = 3;
const DEFAULT_LASSO_CLEAR_EVENT = LASSO_CLEAR_ON_END;
const DEFAULT_LASSO_ON_LONG_PRESS = false;
const DEFAULT_LASSO_LONG_PRESS_TIME = 750;
const DEFAULT_LASSO_LONG_PRESS_AFTER_EFFECT_TIME = 500;
const DEFAULT_LASSO_LONG_PRESS_EFFECT_DELAY = 100;
const DEFAULT_LASSO_LONG_PRESS_REVERT_EFFECT_TIME = 250;
const KEY_ACTION_LASSO = "lasso";
const KEY_ACTION_ROTATE = "rotate";
const KEY_ACTION_MERGE = "merge";
const KEY_ACTIONS = [
  KEY_ACTION_LASSO,
  KEY_ACTION_ROTATE,
  KEY_ACTION_MERGE
];
const KEY_ALT = "alt";
const KEY_CMD = "cmd";
const KEY_CTRL = "ctrl";
const KEY_META = "meta";
const KEY_SHIFT = "shift";
const KEYS$2 = [KEY_ALT, KEY_CMD, KEY_CTRL, KEY_META, KEY_SHIFT];
const DEFAULT_KEY_MAP = {
  [KEY_ALT]: KEY_ACTION_ROTATE,
  [KEY_SHIFT]: KEY_ACTION_LASSO,
  [KEY_CMD]: KEY_ACTION_MERGE
};
const DEFAULT_DATA_ASPECT_RATIO = 1;
const DEFAULT_WIDTH = AUTO;
const DEFAULT_HEIGHT = AUTO;
const DEFAULT_GAMMA = 1;
const MIN_POINT_SIZE = 1;
const DEFAULT_POINT_SIZE = 6;
const DEFAULT_POINT_SIZE_SELECTED = 2;
const DEFAULT_POINT_OUTLINE_WIDTH = 2;
const DEFAULT_SIZE_BY = null;
const DEFAULT_POINT_CONNECTION_SIZE = 2;
const DEFAULT_POINT_CONNECTION_SIZE_ACTIVE = 2;
const DEFAULT_POINT_CONNECTION_SIZE_BY = null;
const DEFAULT_POINT_CONNECTION_OPACITY = null;
const DEFAULT_POINT_CONNECTION_OPACITY_BY = null;
const DEFAULT_POINT_CONNECTION_OPACITY_ACTIVE = 0.66;
const DEFAULT_OPACITY = 1;
const DEFAULT_OPACITY_BY = null;
const DEFAULT_OPACITY_BY_DENSITY_FILL = 0.15;
const DEFAULT_OPACITY_BY_DENSITY_DEBOUNCE_TIME = 25;
const DEFAULT_OPACITY_INACTIVE_MAX = 1;
const DEFAULT_OPACITY_INACTIVE_SCALE = 1;
const DEFAULT_COLOR_BY = null;
const DEFAULT_COLOR_NORMAL = [0.66, 0.66, 0.66, DEFAULT_OPACITY];
const DEFAULT_COLOR_ACTIVE = [0, 0.55, 1, 1];
const DEFAULT_COLOR_HOVER = [1, 1, 1, 1];
const DEFAULT_COLOR_BG = [0, 0, 0, 1];
const DEFAULT_POINT_CONNECTION_COLOR_BY = null;
const DEFAULT_POINT_CONNECTION_COLOR_NORMAL = [0.66, 0.66, 0.66, 0.2];
const DEFAULT_POINT_CONNECTION_COLOR_ACTIVE = [0, 0.55, 1, 1];
const DEFAULT_POINT_CONNECTION_COLOR_HOVER = [1, 1, 1, 1];
const DEFAULT_ANNOTATION_LINE_COLOR = [1, 1, 1, 0.5];
const DEFAULT_ANNOTATION_LINE_WIDTH = 1;
const DEFAULT_ANNOTATION_HVLINE_LIMIT = 1e3;
const DEFAULT_TARGET = [0, 0];
const DEFAULT_DISTANCE = 1;
const DEFAULT_ROTATION = 0;
const DEFAULT_VIEW = new Float32Array([
  1,
  0,
  0,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  1
]);
const IMAGE_LOAD_ERROR = "IMAGE_LOAD_ERROR";
const DEFAULT_BACKGROUND_IMAGE = null;
const DEFAULT_SHOW_RETICLE = false;
const DEFAULT_RETICLE_COLOR = [1, 1, 1, 0.5];
const DEFAULT_DESELECT_ON_DBL_CLICK = true;
const DEFAULT_DESELECT_ON_ESCAPE = true;
const DEFAULT_SHOW_POINT_CONNECTIONS = false;
const DEFAULT_POINT_CONNECTION_MAX_INT_POINTS_PER_SEGMENT = 100;
const DEFAULT_POINT_CONNECTION_INT_POINTS_TOLERANCE = 1 / 500;
const DEFAULT_POINT_SIZE_MOUSE_DETECTION = "auto";
const DEFAULT_PERFORMANCE_MODE = false;
const SINGLE_CLICK_DELAY = 200;
const LONG_CLICK_TIME = 500;
const Z_NAMES = /* @__PURE__ */ new Set(["z", "valueZ", "valueA", "value1", "category"]);
const W_NAMES = /* @__PURE__ */ new Set(["w", "valueW", "valueB", "value2", "value"]);
const DEFAULT_IMAGE_LOAD_TIMEOUT = 15e3;
const DEFAULT_SPATIAL_INDEX_USE_WORKER = void 0;
const ERROR_POINTS_NOT_DRAWN = "Points have not been drawn";
const checkReglExtensions = (regl2, silent) => {
  if (!regl2) return false;
  return GL_EXTENSIONS.reduce((every, EXTENSION) => {
    if (!regl2.hasExtension(EXTENSION)) {
      {
        console.warn(
          `WebGL: ${EXTENSION} extension not supported. Scatterplot might not render properly`
        );
      }
      return false;
    }
    return every;
  }, true);
};
const createRegl = (canvas) => {
  const gl = canvas.getContext("webgl", {
    antialias: true,
    preserveDrawingBuffer: true
  });
  const extensions = [];
  GL_EXTENSIONS.forEach((EXTENSION) => {
    if (gl.getExtension(EXTENSION)) {
      extensions.push(EXTENSION);
    } else {
      console.warn(
        `WebGL: ${EXTENSION} extension not supported. Scatterplot might not render properly`
      );
    }
  });
  return createOriginalRegl({ gl, extensions });
};
const dist = (x1, y1, x22, y23) => Math.sqrt((x1 - x22) ** 2 + (y1 - y23) ** 2);
const getBBox = (positions2d) => {
  let xMin = Infinity;
  let xMax = -Infinity;
  let yMin = Infinity;
  let yMax = -Infinity;
  for (let i3 = 0; i3 < positions2d.length; i3 += 2) {
    xMin = positions2d[i3] < xMin ? positions2d[i3] : xMin;
    xMax = positions2d[i3] > xMax ? positions2d[i3] : xMax;
    yMin = positions2d[i3 + 1] < yMin ? positions2d[i3 + 1] : yMin;
    yMax = positions2d[i3 + 1] > yMax ? positions2d[i3 + 1] : yMax;
  }
  return [xMin, yMin, xMax, yMax];
};
const isValidBBox = ([xMin, yMin, xMax, yMax]) => Number.isFinite(xMin) && Number.isFinite(yMin) && Number.isFinite(xMax) && Number.isFinite(yMax) && xMax - xMin > 0 && yMax - yMin > 0;
const hexToRgb$2 = (hex2, isNormalize = false) => hex2.replace(
  /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
  (m4, r, g2, b3) => `#${r}${r}${g2}${g2}${b3}${b3}`
).substring(1).match(/.{2}/g).map((x3) => parseInt(x3, 16) / 255 ** isNormalize);
const isConditionalArray = (a4, condition, { minLength: minLength2 = 0 } = {}) => Array.isArray(a4) && a4.length >= minLength2 && a4.every(condition);
const isPositiveNumber = (x3) => !Number.isNaN(+x3) && +x3 >= 0;
const isStrictlyPositiveNumber = (x3) => !Number.isNaN(+x3) && +x3 > 0;
const limit = (choices, defaultChoice) => (choice) => choices.indexOf(choice) >= 0 ? choice : defaultChoice;
const loadImage = (src, isCrossOrigin = false, timeout2 = DEFAULT_IMAGE_LOAD_TIMEOUT) => new Promise((resolve2, reject) => {
  const image = new Image();
  if (isCrossOrigin) image.crossOrigin = "anonymous";
  image.src = src;
  image.onload = () => {
    resolve2(image);
  };
  const rejectPromise = () => {
    reject(new Error(IMAGE_LOAD_ERROR));
  };
  image.onerror = rejectPromise;
  setTimeout(rejectPromise, timeout2);
});
const createTextureFromUrl = (regl2, url, timeout2 = DEFAULT_IMAGE_LOAD_TIMEOUT) => new Promise((resolve2, reject) => {
  loadImage(
    url,
    url.indexOf(window.location.origin) !== 0 && url.indexOf("base64") === -1,
    timeout2
  ).then((image) => {
    resolve2(regl2.texture(image));
  }).catch((error) => {
    reject(error);
  });
});
const hexToRgba = (hex2, isNormalize = false) => [
  ...hexToRgb$2(hex2, isNormalize),
  255 ** !isNormalize
];
const isHex = (hex2) => /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(hex2);
const isNormFloat = (x3) => x3 >= 0 && x3 <= 1;
const isNormFloatArray = (a4) => Array.isArray(a4) && a4.every(isNormFloat);
const isPointInPolygon = (polygon, [px, py] = []) => {
  let x1;
  let y1;
  let x22;
  let y23;
  let isWithin = false;
  for (let i3 = 0, j = polygon.length - 2; i3 < polygon.length; i3 += 2) {
    x1 = polygon[i3];
    y1 = polygon[i3 + 1];
    x22 = polygon[j];
    y23 = polygon[j + 1];
    if (y1 > py !== y23 > py && px < (x22 - x1) * (py - y1) / (y23 - y1) + x1)
      isWithin = !isWithin;
    j = i3;
  }
  return isWithin;
};
const isString = (s4) => typeof s4 === "string" || s4 instanceof String;
const isUint8 = (x3) => Number.isInteger(x3) && x3 >= 0 && x3 <= 255;
const isUint8Array = (a4) => Array.isArray(a4) && a4.every(isUint8);
const isRgb = (rgb2) => rgb2.length === 3 && (isNormFloatArray(rgb2) || isUint8Array(rgb2));
const isRgba = (rgba2) => rgba2.length === 4 && (isNormFloatArray(rgba2) || isUint8Array(rgba2));
const isMultipleColors = (color2) => Array.isArray(color2) && color2.length && (Array.isArray(color2[0]) || isString(color2[0]));
const max$2 = (a4, b3) => a4 > b3 ? a4 : b3;
const min = (a4, b3) => a4 < b3 ? a4 : b3;
const toRgba = (color2, shouldNormalize) => {
  if (isRgba(color2)) {
    const isNormalized = isNormFloatArray(color2);
    if (shouldNormalize && isNormalized || !shouldNormalize && !isNormalized)
      return color2;
    if (shouldNormalize && !isNormalized) return color2.map((x3) => x3 / 255);
    return color2.map((x3) => x3 * 255);
  }
  if (isRgb(color2)) {
    const base = 255 ** !shouldNormalize;
    const isNormalized = isNormFloatArray(color2);
    if (shouldNormalize && isNormalized || !shouldNormalize && !isNormalized)
      return [...color2, base];
    if (shouldNormalize && !isNormalized)
      return [...color2.map((x3) => x3 / 255), base];
    return [...color2.map((x3) => x3 * 255), base];
  }
  if (isHex(color2)) return hexToRgba(color2, shouldNormalize);
  console.warn(
    "Only HEX, RGB, and RGBA are handled by this function. Returning white instead."
  );
  return shouldNormalize ? [1, 1, 1, 1] : [255, 255, 255, 255];
};
const flipObj = (obj) => Object.entries(obj).reduce((out, [key, value2]) => {
  if (out[value2]) {
    out[value2] = [...out[value2], key];
  } else {
    out[value2] = key;
  }
  return out;
}, {});
const rgbBrightness = (rgb2) => 0.21 * rgb2[0] + 0.72 * rgb2[1] + 0.07 * rgb2[2];
const clip = (value2, minValue2, maxValue2) => Math.min(maxValue2, Math.max(minValue2, value2));
const toArrayOrientedPoints = (points) => new Promise((resolve2, reject) => {
  if (!points || Array.isArray(points)) {
    resolve2(points);
  } else {
    const length = Array.isArray(points.x) || ArrayBuffer.isView(points.x) ? points.x.length : 0;
    const getX = (Array.isArray(points.x) || ArrayBuffer.isView(points.x)) && ((i3) => points.x[i3]);
    const getY = (Array.isArray(points.y) || ArrayBuffer.isView(points.y)) && ((i3) => points.y[i3]);
    const getL = (Array.isArray(points.line) || ArrayBuffer.isView(points.line)) && ((i3) => points.line[i3]);
    const getLO = (Array.isArray(points.lineOrder) || ArrayBuffer.isView(points.lineOrder)) && ((i3) => points.lineOrder[i3]);
    const components2 = Object.keys(points);
    const getZ = (() => {
      const z3 = components2.find((c3) => Z_NAMES.has(c3));
      return z3 && (Array.isArray(points[z3]) || ArrayBuffer.isView(points[z3])) && ((i3) => points[z3][i3]);
    })();
    const getW = (() => {
      const w3 = components2.find((c3) => W_NAMES.has(c3));
      return w3 && (Array.isArray(points[w3]) || ArrayBuffer.isView(points[w3])) && ((i3) => points[w3][i3]);
    })();
    if (getX && getY && getZ && getW && getL && getLO) {
      resolve2(
        points.x.map((x3, i3) => [
          x3,
          getY(i3),
          getZ(i3),
          getW(i3),
          getL(i3),
          getLO(i3)
        ])
      );
    } else if (getX && getY && getZ && getW && getL) {
      resolve2(
        Array.from({ length }, (_, i3) => [
          getX(i3),
          getY(i3),
          getZ(i3),
          getW(i3),
          getL(i3)
        ])
      );
    } else if (getX && getY && getZ && getW) {
      resolve2(
        Array.from({ length }, (_, i3) => [getX(i3), getY(i3), getZ(i3), getW(i3)])
      );
    } else if (getX && getY && getZ) {
      resolve2(Array.from({ length }, (_, i3) => [getX(i3), getY(i3), getZ(i3)]));
    } else if (getX && getY) {
      resolve2(Array.from({ length }, (_, i3) => [getX(i3), getY(i3)]));
    } else {
      reject(new Error("You need to specify at least x and y"));
    }
  }
});
const isHorizontalLine = (annotation) => Number.isFinite(annotation.y) && !("x" in annotation);
const isVerticalLine = (annotation) => Number.isFinite(annotation.x) && !("y" in annotation);
const isDomRect = (annotation) => Number.isFinite(annotation.x) && Number.isFinite(annotation.y) && Number.isFinite(annotation.width) && Number.isFinite(annotation.height);
const isRect = (annotation) => Number.isFinite(annotation.x1) && Number.isFinite(annotation.y1) && Number.isFinite(annotation.x2) && Number.isFinite(annotation.x2);
const isPolygon = (annotation) => "vertices" in annotation && annotation.vertices.length > 1;
const createRenderer = (options = {}) => {
  let {
    regl: regl2,
    canvas = document.createElement("canvas"),
    gamma = DEFAULT_GAMMA
  } = options;
  let isDestroyed = false;
  regl2 || (regl2 = createRegl(canvas));
  const isSupportingAllGlExtensions = checkReglExtensions(regl2);
  const fboRes = [canvas.width, canvas.height];
  const fbo = regl2.framebuffer({
    width: fboRes[0],
    height: fboRes[1],
    colorFormat: "rgba",
    colorType: "float"
  });
  const renderToCanvas = regl2({
    vert: `
      precision highp float;
      attribute vec2 xy;
      void main () {
        gl_Position = vec4(xy, 0, 1);
      }`,
    frag: `
      precision highp float;
      uniform vec2 srcRes;
      uniform sampler2D src;
      uniform float gamma;

      vec3 approxLinearToSRGB (vec3 rgb, float gamma) {
        return pow(clamp(rgb, vec3(0), vec3(1)), vec3(1.0 / gamma));
      }

      void main () {
        vec4 color = texture2D(src, gl_FragCoord.xy / srcRes);
        gl_FragColor = vec4(approxLinearToSRGB(color.rgb, gamma), color.a);
      }`,
    attributes: {
      xy: [-4, -4, 4, -4, 0, 4]
    },
    uniforms: {
      src: () => fbo,
      srcRes: () => fboRes,
      gamma: () => gamma
    },
    count: 3,
    depth: { enable: false },
    blend: {
      enable: true,
      func: {
        srcRGB: "one",
        srcAlpha: "one",
        dstRGB: "one minus src alpha",
        dstAlpha: "one minus src alpha"
      }
    }
  });
  const copyTo = (targetCanvas) => {
    const ctx = targetCanvas.getContext("2d");
    ctx.clearRect(0, 0, targetCanvas.width, targetCanvas.height);
    ctx.drawImage(
      canvas,
      (canvas.width - targetCanvas.width) / 2,
      (canvas.height - targetCanvas.height) / 2,
      targetCanvas.width,
      targetCanvas.height,
      0,
      0,
      targetCanvas.width,
      targetCanvas.height
    );
  };
  const render = (draw2, targetCanvas) => {
    regl2.clear(CLEAR_OPTIONS);
    fbo.use(() => {
      regl2.clear(CLEAR_OPTIONS);
      draw2();
    });
    renderToCanvas();
    copyTo(targetCanvas);
  };
  const refresh = () => {
    regl2.poll();
  };
  const drawFns = /* @__PURE__ */ new Set();
  const onFrame = (draw2) => {
    drawFns.add(draw2);
    return () => {
      drawFns.delete(draw2);
    };
  };
  const frame = regl2.frame(() => {
    const iterator = drawFns.values();
    let result = iterator.next();
    while (!result.done) {
      result.value();
      result = iterator.next();
    }
  });
  const resize = () => {
    canvas.width = window.innerWidth * window.devicePixelRatio;
    canvas.height = window.innerHeight * window.devicePixelRatio;
    fboRes[0] = canvas.width;
    fboRes[1] = canvas.height;
    fbo.resize(...fboRes);
  };
  if (!options.canvas) {
    window.addEventListener("resize", resize);
    window.addEventListener("orientationchange", resize);
    resize();
  }
  const destroy3 = () => {
    isDestroyed = true;
    window.removeEventListener("resize", resize);
    window.removeEventListener("orientationchange", resize);
    frame.cancel();
    canvas = void 0;
    regl2.destroy();
    regl2 = void 0;
  };
  return {
    /**
     * Get the associated canvas element
     * @return {HTMLCanvasElement} The associated canvas element
     */
    get canvas() {
      return canvas;
    },
    /**
     * Get the associated Regl instance
     * @return {import('regl').Regl} The associated Regl instance
     */
    get regl() {
      return regl2;
    },
    /**
     * Get the gamma value
     * @return {number} The gamma value
     */
    get gamma() {
      return gamma;
    },
    /**
     * Set gamma to a new value
     * @param {number} newGamma - The new gamma value
     */
    set gamma(newGamma) {
      gamma = +newGamma;
    },
    /**
     * Get whether the browser supports all necessary WebGL features
     * @return {boolean} If `true` the browser supports all necessary WebGL features
     */
    get isSupported() {
      return isSupportingAllGlExtensions;
    },
    /**
     * Get whether the renderer (and its Regl instance) is destroyed
     * @return {boolean} If `true` the renderer is destroyed
     */
    get isDestroyed() {
      return isDestroyed;
    },
    render,
    onFrame,
    refresh,
    destroy: destroy3
  };
};
const DEFAULT_LASSO_START_INITIATOR_SHOW = true;
const DEFAULT_LASSO_MIN_DELAY = 8;
const DEFAULT_LASSO_MIN_DIST = 2;
const LASSO_SHOW_START_INITIATOR_TIME = 2500;
const LASSO_HIDE_START_INITIATOR_TIME = 250;
const createLongPressElements = () => {
  const longPress = document.createElement("div");
  const longPressId = Math.random().toString(36).substring(2, 5) + Math.random().toString(36).substring(2, 5);
  longPress.id = `lasso-long-press-${longPressId}`;
  longPress.style.position = "fixed";
  longPress.style.width = "1.25rem";
  longPress.style.height = "1.25rem";
  longPress.style.pointerEvents = "none";
  longPress.style.transform = "translate(-50%,-50%)";
  const longPressCircle = document.createElement("div");
  longPressCircle.style.position = "absolute";
  longPressCircle.style.top = 0;
  longPressCircle.style.left = 0;
  longPressCircle.style.width = "1.25rem";
  longPressCircle.style.height = "1.25rem";
  longPressCircle.style.clipPath = "inset(0px 0px 0px 50%)";
  longPressCircle.style.opacity = 0;
  longPress.appendChild(longPressCircle);
  const longPressCircleLeft = document.createElement("div");
  longPressCircleLeft.style.position = "absolute";
  longPressCircleLeft.style.top = 0;
  longPressCircleLeft.style.left = 0;
  longPressCircleLeft.style.width = "0.8rem";
  longPressCircleLeft.style.height = "0.8rem";
  longPressCircleLeft.style.border = "0.2rem solid currentcolor";
  longPressCircleLeft.style.borderRadius = "0.8rem";
  longPressCircleLeft.style.clipPath = "inset(0px 50% 0px 0px)";
  longPressCircleLeft.style.transform = "rotate(0deg)";
  longPressCircle.appendChild(longPressCircleLeft);
  const longPressCircleRight = document.createElement("div");
  longPressCircleRight.style.position = "absolute";
  longPressCircleRight.style.top = 0;
  longPressCircleRight.style.left = 0;
  longPressCircleRight.style.width = "0.8rem";
  longPressCircleRight.style.height = "0.8rem";
  longPressCircleRight.style.border = "0.2rem solid currentcolor";
  longPressCircleRight.style.borderRadius = "0.8rem";
  longPressCircleRight.style.clipPath = "inset(0px 50% 0px 0px)";
  longPressCircleRight.style.transform = "rotate(0deg)";
  longPressCircle.appendChild(longPressCircleRight);
  const longPressEffect = document.createElement("div");
  longPressEffect.style.position = "absolute";
  longPressEffect.style.top = 0;
  longPressEffect.style.left = 0;
  longPressEffect.style.width = "1.25rem";
  longPressEffect.style.height = "1.25rem";
  longPressEffect.style.borderRadius = "1.25rem";
  longPressEffect.style.background = "currentcolor";
  longPressEffect.style.transform = "scale(0)";
  longPressEffect.style.opacity = 0;
  longPress.appendChild(longPressEffect);
  return {
    longPress,
    longPressCircle,
    longPressCircleLeft,
    longPressCircleRight,
    longPressEffect
  };
};
const getInTime = (p2, time, extraTime) => (1 - p2) * time + extraTime;
const getMainInAnimation = (t3, d4) => `${t3}ms ease-out mainIn ${d4}ms 1 normal forwards`;
const getEffectInAnimation = (t3, d4) => `${t3}ms ease-out effectIn ${d4}ms 1 normal forwards`;
const getCircleLeftInAnimation = (t3, d4) => `${t3}ms linear leftSpinIn ${d4}ms 1 normal forwards`;
const getCircleRightInAnimation = (t3, d4) => `${t3}ms linear rightSpinIn ${d4}ms 1 normal forwards`;
const getCircleInAnimation = (t3, d4) => `${t3}ms linear circleIn ${d4}ms 1 normal forwards`;
const getMainIn = (mainEffectPercent, currentColor, targetColor) => `
  @keyframes mainIn {
    0% {
      color: ${currentColor};
      opacity: 0;
    }
    0%, ${mainEffectPercent}% {
      color: ${currentColor};
      opacity: 1;
    }
    100% {
      color: ${targetColor};
      opacity: 0.8;
    }
  }
`;
const getEffectIn = (mainEffectPercent, afterEffectPercent, opacity, scale) => `
  @keyframes effectIn {
    0%, ${mainEffectPercent}% {
      opacity: ${opacity};
      transform: scale(${scale});
    }
    ${afterEffectPercent}% {
      opacity: 0.66;
      transform: scale(1.5);
    }
    99% {
      opacity: 0;
      transform: scale(2);
    }
    100% {
      opacity: 0;
      transform: scale(0);
    }
  }
`;
const getCircleIn = (halfMainEffectPercent, clipPath, opacity) => `
  @keyframes circleIn {
    0% {
      clip-path: ${clipPath};
      opacity: ${opacity};
    }
    ${halfMainEffectPercent}% {
      clip-path: ${clipPath};
      opacity: 1;
    }
    ${halfMainEffectPercent + 0.01}%, 100% {
      clip-path: inset(0);
      opacity: 1;
    }
  }
`;
const getCircleLeftIn = (mainEffectPercent, angle2) => `
  @keyframes leftSpinIn {
    0% {
      transform: rotate(${angle2}deg);
    }
    ${mainEffectPercent}%, 100% {
      transform: rotate(360deg);
    }
  }
`;
const getCircleRightIn = (halfMainEffectPercent, angle2) => `
  @keyframes rightSpinIn {
    0% {
      transform: rotate(${angle2}deg);
    }
    ${halfMainEffectPercent}%, 100% {
      transform: rotate(180deg);
    }
  }
`;
const createLongPressInAnimations = ({
  time = DEFAULT_LASSO_LONG_PRESS_TIME,
  extraTime = DEFAULT_LASSO_LONG_PRESS_AFTER_EFFECT_TIME,
  delay = DEFAULT_LASSO_LONG_PRESS_EFFECT_DELAY,
  currentColor,
  targetColor,
  effectOpacity,
  effectScale,
  circleLeftRotation,
  circleRightRotation,
  circleClipPath,
  circleOpacity
}) => {
  const p2 = circleLeftRotation / 360;
  const actualTime = getInTime(p2, time, extraTime);
  const longPressPercent = Math.round((1 - p2) * time / actualTime * 100);
  const halfLongPressPercent = Math.round(longPressPercent / 2);
  const afterEffectPercent = longPressPercent + (100 - longPressPercent) / 4;
  return {
    rules: {
      main: getMainIn(longPressPercent, currentColor, targetColor),
      effect: getEffectIn(
        longPressPercent,
        afterEffectPercent,
        effectOpacity,
        effectScale
      ),
      circleRight: getCircleRightIn(halfLongPressPercent, circleRightRotation),
      circleLeft: getCircleLeftIn(longPressPercent, circleLeftRotation),
      circle: getCircleIn(halfLongPressPercent, circleClipPath, circleOpacity)
    },
    names: {
      main: getMainInAnimation(actualTime, delay),
      effect: getEffectInAnimation(actualTime, delay),
      circleLeft: getCircleLeftInAnimation(actualTime, delay),
      circleRight: getCircleRightInAnimation(actualTime, delay),
      circle: getCircleInAnimation(actualTime, delay)
    }
  };
};
const getMainOutAnimation = (t3) => `${t3}ms linear mainOut 0s 1 normal forwards`;
const getEffectOutAnimation = (t3) => `${t3}ms linear effectOut 0s 1 normal forwards`;
const getCircleLeftOutAnimation = (t3) => `${t3}ms linear leftSpinOut 0s 1 normal forwards`;
const getCircleRightOutAnimation = (t3) => `${t3}ms linear rightSpinOut 0s 1 normal forwards`;
const getCircleOutAnimation = (t3) => `${t3}ms linear circleOut 0s 1 normal forwards`;
const getMainOut = (currentColor, targetColor) => `
  @keyframes mainOut {
    0% {
      color: ${currentColor};
    }
    100% {
      color: ${targetColor};
    }
  }
`;
const getEffectOut = (opacity, scale) => `
  @keyframes effectOut {
    0% {
      opacity: ${opacity};
      transform: scale(${scale});
    }
    99% {
      opacity: 0;
      transform: scale(${scale + 0.5});
    }
    100% {
      opacity: 0;
      transform: scale(0);
    }
  }
`;
const getCircleRightOut = (halfEffectPercent, angle2) => `
  @keyframes rightSpinOut {
    0%, ${halfEffectPercent}% {
      transform: rotate(${angle2}deg);
    }
    100% {
      transform: rotate(0deg);
    }
`;
const getCircleLeftOut = (angle2) => `
  @keyframes leftSpinOut {
    0% {
      transform: rotate(${angle2}deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
`;
const getCircleOut = (halfEffectPercent, clipPath, opacity) => `
  @keyframes circleOut {
    0%, ${halfEffectPercent}% {
      clip-path: ${clipPath};
      opacity: ${opacity};
    }
    ${halfEffectPercent + 0.01}% {
      clip-path: inset(0 0 0 50%);
      opacity: ${opacity};
    }
    100% {
      clip-path: inset(0 0 0 50%);
      opacity: 0;
    }
  }
`;
const createLongPressOutAnimations = ({
  time = DEFAULT_LASSO_LONG_PRESS_REVERT_EFFECT_TIME,
  currentColor,
  targetColor,
  effectOpacity,
  effectScale,
  circleLeftRotation,
  circleRightRotation,
  circleClipPath,
  circleOpacity
}) => {
  const p2 = circleLeftRotation / 360;
  const actualTime = p2 * time;
  const rotatedPercent = Math.min(100, p2 * 100);
  const halfPercent = rotatedPercent > 50 ? Math.round((1 - 50 / rotatedPercent) * 100) : 0;
  return {
    rules: {
      main: getMainOut(currentColor, targetColor),
      effect: getEffectOut(effectOpacity, effectScale),
      circleRight: getCircleRightOut(halfPercent, circleRightRotation),
      circleLeft: getCircleLeftOut(circleLeftRotation),
      circle: getCircleOut(halfPercent, circleClipPath, circleOpacity)
    },
    names: {
      main: getMainOutAnimation(actualTime),
      effect: getEffectOutAnimation(actualTime),
      circleRight: getCircleLeftOutAnimation(actualTime),
      circleLeft: getCircleRightOutAnimation(actualTime),
      circle: getCircleOutAnimation(actualTime)
    }
  };
};
const ifNotNull = (v, alternative = null) => v === null ? alternative : v;
let cachedLassoStylesheets;
const getLassoStylesheets = () => {
  if (!cachedLassoStylesheets) {
    const lassoStyleEl = document.createElement("style");
    document.head.appendChild(lassoStyleEl);
    cachedLassoStylesheets = lassoStyleEl.sheet;
  }
  return cachedLassoStylesheets;
};
const addRule = (rule) => {
  const lassoStylesheets = getLassoStylesheets();
  const currentNumRules = lassoStylesheets.rules.length;
  lassoStylesheets.insertRule(rule, currentNumRules);
  return currentNumRules;
};
const removeRule = (index2) => {
  getLassoStylesheets().deleteRule(index2);
};
const inAnimation = `${LASSO_SHOW_START_INITIATOR_TIME}ms ease scaleInFadeOut 0s 1 normal backwards`;
const createInAnimationRule = (opacity, scale, rotate2) => `
@keyframes scaleInFadeOut {
  0% {
    opacity: ${opacity};
    transform: translate(-50%,-50%) scale(${scale}) rotate(${rotate2}deg);
  }
  10% {
    opacity: 1;
    transform: translate(-50%,-50%) scale(1) rotate(${rotate2 + 20}deg);
  }
  100% {
    opacity: 0;
    transform: translate(-50%,-50%) scale(0.9) rotate(${rotate2 + 60}deg);
  }
}
`;
let inAnimationRuleIndex = null;
const outAnimation = `${LASSO_HIDE_START_INITIATOR_TIME}ms ease fadeScaleOut 0s 1 normal backwards`;
const createOutAnimationRule = (opacity, scale, rotate2) => `
@keyframes fadeScaleOut {
  0% {
    opacity: ${opacity};
    transform: translate(-50%,-50%) scale(${scale}) rotate(${rotate2}deg);
  }
  100% {
    opacity: 0;
    transform: translate(-50%,-50%) scale(0) rotate(${rotate2}deg);
  }
}
`;
let outAnimationRuleIndex = null;
const createLasso = (element, {
  onDraw: initialOnDraw = identity,
  onStart: initialOnStart = identity,
  onEnd: initialOnEnd = identity,
  enableInitiator: initialenableInitiator = DEFAULT_LASSO_START_INITIATOR_SHOW,
  initiatorParentElement: initialInitiatorParentElement = document.body,
  longPressIndicatorParentElement: initialLongPressIndicatorParentElement = document.body,
  minDelay: initialMinDelay = DEFAULT_LASSO_MIN_DELAY,
  minDist: initialMinDist = DEFAULT_LASSO_MIN_DIST,
  pointNorm: initialPointNorm = identity
} = {}) => {
  let enableInitiator = initialenableInitiator;
  let initiatorParentElement = initialInitiatorParentElement;
  let longPressIndicatorParentElement = initialLongPressIndicatorParentElement;
  let onDraw = initialOnDraw;
  let onStart = initialOnStart;
  let onEnd = initialOnEnd;
  let pointNorm = initialPointNorm;
  const initiator = document.createElement("div");
  const initiatorId = Math.random().toString(36).substring(2, 5) + Math.random().toString(36).substring(2, 5);
  initiator.id = `lasso-initiator-${initiatorId}`;
  initiator.style.position = "fixed";
  initiator.style.display = "flex";
  initiator.style.justifyContent = "center";
  initiator.style.alignItems = "center";
  initiator.style.zIndex = 99;
  initiator.style.width = "4rem";
  initiator.style.height = "4rem";
  initiator.style.borderRadius = "4rem";
  initiator.style.opacity = 0.5;
  initiator.style.transform = "translate(-50%,-50%) scale(0) rotate(0deg)";
  const {
    longPress,
    longPressCircle,
    longPressCircleLeft,
    longPressCircleRight,
    longPressEffect
  } = createLongPressElements();
  let isMouseDown = false;
  let isLasso = false;
  let lassoPos = [];
  let lassoPosFlat = [];
  let lassoPrevMousePos;
  let longPressIsStarting = false;
  let longPressMainInAnimationRuleIndex = null;
  let longPressEffectInAnimationRuleIndex = null;
  let longPressCircleLeftInAnimationRuleIndex = null;
  let longPressCircleRightInAnimationRuleIndex = null;
  let longPressCircleInAnimationRuleIndex = null;
  let longPressMainOutAnimationRuleIndex = null;
  let longPressEffectOutAnimationRuleIndex = null;
  let longPressCircleLeftOutAnimationRuleIndex = null;
  let longPressCircleRightOutAnimationRuleIndex = null;
  let longPressCircleOutAnimationRuleIndex = null;
  const mouseUpHandler = () => {
    isMouseDown = false;
  };
  const getMousePosition = (event) => {
    const { left, top } = element.getBoundingClientRect();
    return [event.clientX - left, event.clientY - top];
  };
  window.addEventListener("mouseup", mouseUpHandler);
  const resetInitiatorStyle = () => {
    initiator.style.opacity = 0.5;
    initiator.style.transform = "translate(-50%,-50%) scale(0) rotate(0deg)";
  };
  const getCurrentTransformStyle = (node, hasRotated) => {
    const computedStyle = getComputedStyle(node);
    const opacity = +computedStyle.opacity;
    const m4 = computedStyle.transform.match(/([0-9.-]+)+/g);
    const a4 = +m4[0];
    const b3 = +m4[1];
    const scale = Math.sqrt(a4 * a4 + b3 * b3);
    let rotate2 = Math.atan2(b3, a4) * (180 / Math.PI);
    rotate2 = hasRotated && rotate2 <= 0 ? 360 + rotate2 : rotate2;
    return { opacity, scale, rotate: rotate2 };
  };
  const showInitiator = (event) => {
    if (!enableInitiator || isMouseDown) return;
    const x3 = event.clientX;
    const y4 = event.clientY;
    initiator.style.top = `${y4}px`;
    initiator.style.left = `${x3}px`;
    const style = getCurrentTransformStyle(initiator);
    const opacity = style.opacity;
    const scale = style.scale;
    const rotate2 = style.rotate;
    initiator.style.opacity = opacity;
    initiator.style.transform = `translate(-50%,-50%) scale(${scale}) rotate(${rotate2}deg)`;
    initiator.style.animation = "none";
    nextAnimationFrame().then(() => {
      if (inAnimationRuleIndex !== null) removeRule(inAnimationRuleIndex);
      inAnimationRuleIndex = addRule(
        createInAnimationRule(opacity, scale, rotate2)
      );
      initiator.style.animation = inAnimation;
      nextAnimationFrame().then(() => {
        resetInitiatorStyle();
      });
    });
  };
  const hideInitiator = () => {
    const { opacity, scale, rotate: rotate2 } = getCurrentTransformStyle(initiator);
    initiator.style.opacity = opacity;
    initiator.style.transform = `translate(-50%,-50%) scale(${scale}) rotate(${rotate2}deg)`;
    initiator.style.animation = "none";
    nextAnimationFrame(2).then(() => {
      if (outAnimationRuleIndex !== null) removeRule(outAnimationRuleIndex);
      outAnimationRuleIndex = addRule(
        createOutAnimationRule(opacity, scale, rotate2)
      );
      initiator.style.animation = outAnimation;
      nextAnimationFrame().then(() => {
        resetInitiatorStyle();
      });
    });
  };
  const showLongPressIndicator = (x3, y4, {
    time = DEFAULT_LASSO_LONG_PRESS_TIME,
    extraTime = DEFAULT_LASSO_LONG_PRESS_AFTER_EFFECT_TIME,
    delay = DEFAULT_LASSO_LONG_PRESS_EFFECT_DELAY
  } = {
    time: DEFAULT_LASSO_LONG_PRESS_TIME,
    extraTime: DEFAULT_LASSO_LONG_PRESS_AFTER_EFFECT_TIME,
    delay: DEFAULT_LASSO_LONG_PRESS_EFFECT_DELAY
  }) => {
    longPressIsStarting = true;
    const mainStyle = getComputedStyle(longPress);
    longPress.style.color = mainStyle.color;
    longPress.style.top = `${y4}px`;
    longPress.style.left = `${x3}px`;
    longPress.style.animation = "none";
    const circleStyle = getComputedStyle(longPressCircle);
    longPressCircle.style.clipPath = circleStyle.clipPath;
    longPressCircle.style.opacity = circleStyle.opacity;
    longPressCircle.style.animation = "none";
    const effectStyle = getCurrentTransformStyle(longPressEffect);
    longPressEffect.style.opacity = effectStyle.opacity;
    longPressEffect.style.transform = `scale(${effectStyle.scale})`;
    longPressEffect.style.animation = "none";
    const circleLeftStyle = getCurrentTransformStyle(longPressCircleLeft);
    longPressCircleLeft.style.transform = `rotate(${circleLeftStyle.rotate}deg)`;
    longPressCircleLeft.style.animation = "none";
    const circleRightStyle = getCurrentTransformStyle(longPressCircleRight);
    longPressCircleRight.style.transform = `rotate(${circleRightStyle.rotate}deg)`;
    longPressCircleRight.style.animation = "none";
    nextAnimationFrame().then(() => {
      if (!longPressIsStarting) return;
      if (longPressCircleInAnimationRuleIndex !== null)
        removeRule(longPressCircleInAnimationRuleIndex);
      if (longPressCircleRightInAnimationRuleIndex !== null)
        removeRule(longPressCircleRightInAnimationRuleIndex);
      if (longPressCircleLeftInAnimationRuleIndex !== null)
        removeRule(longPressCircleLeftInAnimationRuleIndex);
      if (longPressEffectInAnimationRuleIndex !== null)
        removeRule(longPressEffectInAnimationRuleIndex);
      if (longPressMainInAnimationRuleIndex !== null)
        removeRule(longPressMainInAnimationRuleIndex);
      const { rules, names: names2 } = createLongPressInAnimations({
        time,
        extraTime,
        delay,
        currentColor: mainStyle.color || "currentcolor",
        targetColor: longPress.dataset.activeColor,
        effectOpacity: effectStyle.opacity || 0,
        effectScale: effectStyle.scale || 0,
        circleLeftRotation: circleLeftStyle.rotate || 0,
        circleRightRotation: circleRightStyle.rotate || 0,
        circleClipPath: circleStyle.clipPath || "inset(0 0 0 50%)",
        circleOpacity: circleStyle.opacity || 0
      });
      longPressMainInAnimationRuleIndex = addRule(rules.main);
      longPressEffectInAnimationRuleIndex = addRule(rules.effect);
      longPressCircleLeftInAnimationRuleIndex = addRule(rules.circleLeft);
      longPressCircleRightInAnimationRuleIndex = addRule(rules.circleRight);
      longPressCircleInAnimationRuleIndex = addRule(rules.circle);
      longPress.style.animation = names2.main;
      longPressEffect.style.animation = names2.effect;
      longPressCircleLeft.style.animation = names2.circleLeft;
      longPressCircleRight.style.animation = names2.circleRight;
      longPressCircle.style.animation = names2.circle;
    });
  };
  const hideLongPressIndicator = ({ time = DEFAULT_LASSO_LONG_PRESS_REVERT_EFFECT_TIME } = {
    time: DEFAULT_LASSO_LONG_PRESS_REVERT_EFFECT_TIME
  }) => {
    if (!longPressIsStarting) return;
    longPressIsStarting = false;
    const mainStyle = getComputedStyle(longPress);
    longPress.style.color = mainStyle.color;
    longPress.style.animation = "none";
    const circleStyle = getComputedStyle(longPressCircle);
    longPressCircle.style.clipPath = circleStyle.clipPath;
    longPressCircle.style.opacity = circleStyle.opacity;
    longPressCircle.style.animation = "none";
    const effectStyle = getCurrentTransformStyle(longPressEffect);
    longPressEffect.style.opacity = effectStyle.opacity;
    longPressEffect.style.transform = `scale(${effectStyle.scale})`;
    longPressEffect.style.animation = "none";
    const isAnimatedMoreThan50Percent = circleStyle.clipPath.slice(-2, -1) === "x";
    const circleLeftStyle = getCurrentTransformStyle(
      longPressCircleLeft,
      isAnimatedMoreThan50Percent
    );
    longPressCircleLeft.style.transform = `rotate(${circleLeftStyle.rotate}deg)`;
    longPressCircleLeft.style.animation = "none";
    const circleRightStyle = getCurrentTransformStyle(longPressCircleRight);
    longPressCircleRight.style.transform = `rotate(${circleRightStyle.rotate}deg)`;
    longPressCircleRight.style.animation = "none";
    nextAnimationFrame().then(() => {
      if (longPressCircleOutAnimationRuleIndex !== null)
        removeRule(longPressCircleOutAnimationRuleIndex);
      if (longPressCircleRightOutAnimationRuleIndex !== null)
        removeRule(longPressCircleRightOutAnimationRuleIndex);
      if (longPressCircleLeftOutAnimationRuleIndex !== null)
        removeRule(longPressCircleLeftOutAnimationRuleIndex);
      if (longPressEffectOutAnimationRuleIndex !== null)
        removeRule(longPressEffectOutAnimationRuleIndex);
      if (longPressMainOutAnimationRuleIndex !== null)
        removeRule(longPressMainOutAnimationRuleIndex);
      const { rules, names: names2 } = createLongPressOutAnimations({
        time,
        currentColor: mainStyle.color || "currentcolor",
        targetColor: longPress.dataset.color,
        effectOpacity: effectStyle.opacity || 0,
        effectScale: effectStyle.scale || 0,
        circleLeftRotation: circleLeftStyle.rotate || 0,
        circleRightRotation: circleRightStyle.rotate || 0,
        circleClipPath: circleStyle.clipPath || "inset(0px)",
        circleOpacity: circleStyle.opacity || 1
      });
      longPressMainOutAnimationRuleIndex = addRule(rules.main);
      longPressEffectOutAnimationRuleIndex = addRule(rules.effect);
      longPressCircleLeftOutAnimationRuleIndex = addRule(rules.circleLeft);
      longPressCircleRightOutAnimationRuleIndex = addRule(rules.circleRight);
      longPressCircleOutAnimationRuleIndex = addRule(rules.circle);
      longPress.style.animation = names2.main;
      longPressEffect.style.animation = names2.effect;
      longPressCircleLeft.style.animation = names2.circleLeft;
      longPressCircleRight.style.animation = names2.circleRight;
      longPressCircle.style.animation = names2.circle;
    });
  };
  const draw2 = () => {
    onDraw(lassoPos, lassoPosFlat);
  };
  const extend2 = (currMousePos) => {
    if (!lassoPrevMousePos) {
      if (!isLasso) {
        isLasso = true;
        onStart();
      }
      lassoPrevMousePos = currMousePos;
      const point = pointNorm(currMousePos);
      lassoPos = [point];
      lassoPosFlat = [point[0], point[1]];
    } else {
      const d4 = l2PointDist(
        currMousePos[0],
        currMousePos[1],
        lassoPrevMousePos[0],
        lassoPrevMousePos[1]
      );
      if (d4 > DEFAULT_LASSO_MIN_DIST) {
        lassoPrevMousePos = currMousePos;
        const point = pointNorm(currMousePos);
        lassoPos.push(point);
        lassoPosFlat.push(point[0], point[1]);
        if (lassoPos.length > 1) {
          draw2();
        }
      }
    }
  };
  const extendDb = throttleAndDebounce(
    extend2,
    DEFAULT_LASSO_MIN_DELAY,
    DEFAULT_LASSO_MIN_DELAY
  );
  const extendPublic = (event, debounced) => {
    const mousePosition = getMousePosition(event);
    if (debounced) return extendDb(mousePosition);
    return extend2(mousePosition);
  };
  const clear = () => {
    lassoPos = [];
    lassoPosFlat = [];
    lassoPrevMousePos = void 0;
    draw2();
  };
  const initiatorClickHandler = (event) => {
    showInitiator(event);
  };
  const initiatorMouseDownHandler = () => {
    isMouseDown = true;
    isLasso = true;
    clear();
    onStart();
  };
  const initiatorMouseLeaveHandler = () => {
    hideInitiator();
  };
  const end = ({ merge: merge2 = false } = {}) => {
    isLasso = false;
    const currLassoPos = [...lassoPos];
    const currLassoPosFlat = [...lassoPosFlat];
    extendDb.cancel();
    clear();
    if (currLassoPos.length) {
      onEnd(currLassoPos, currLassoPosFlat, { merge: merge2 });
    }
    return currLassoPos;
  };
  const set2 = ({
    onDraw: newOnDraw = null,
    onStart: newOnStart = null,
    onEnd: newOnEnd = null,
    enableInitiator: newEnableInitiator = null,
    initiatorParentElement: newInitiatorParentElement = null,
    longPressIndicatorParentElement: newLongPressIndicatorParentElement = null,
    minDelay: newMinDelay = null,
    minDist: newMinDist = null,
    pointNorm: newPointNorm = null
  } = {}) => {
    onDraw = ifNotNull(newOnDraw, onDraw);
    onStart = ifNotNull(newOnStart, onStart);
    onEnd = ifNotNull(newOnEnd, onEnd);
    enableInitiator = ifNotNull(newEnableInitiator, enableInitiator);
    pointNorm = ifNotNull(newPointNorm, pointNorm);
    if (newInitiatorParentElement !== null && newInitiatorParentElement !== initiatorParentElement) {
      initiatorParentElement.removeChild(initiator);
      newInitiatorParentElement.appendChild(initiator);
      initiatorParentElement = newInitiatorParentElement;
    }
    if (newLongPressIndicatorParentElement !== null && newLongPressIndicatorParentElement !== longPressIndicatorParentElement) {
      longPressIndicatorParentElement.removeChild(longPress);
      newLongPressIndicatorParentElement.appendChild(longPress);
      longPressIndicatorParentElement = newLongPressIndicatorParentElement;
    }
    if (enableInitiator) {
      initiator.addEventListener("click", initiatorClickHandler);
      initiator.addEventListener("mousedown", initiatorMouseDownHandler);
      initiator.addEventListener("mouseleave", initiatorMouseLeaveHandler);
    } else {
      initiator.removeEventListener("mousedown", initiatorMouseDownHandler);
      initiator.removeEventListener("mouseleave", initiatorMouseLeaveHandler);
    }
  };
  const destroy3 = () => {
    initiatorParentElement.removeChild(initiator);
    longPressIndicatorParentElement.removeChild(longPress);
    window.removeEventListener("mouseup", mouseUpHandler);
    initiator.removeEventListener("click", initiatorClickHandler);
    initiator.removeEventListener("mousedown", initiatorMouseDownHandler);
    initiator.removeEventListener("mouseleave", initiatorMouseLeaveHandler);
  };
  const withPublicMethods = () => (self2) => assign(self2, {
    clear,
    destroy: destroy3,
    end,
    extend: extendPublic,
    set: set2,
    showInitiator,
    hideInitiator,
    showLongPressIndicator,
    hideLongPressIndicator
  });
  initiatorParentElement.appendChild(initiator);
  longPressIndicatorParentElement.appendChild(longPress);
  set2({
    onDraw,
    onStart,
    onEnd,
    enableInitiator,
    initiatorParentElement
  });
  return pipe(
    withStaticProperty("initiator", initiator),
    withStaticProperty("longPressIndicator", longPress),
    withPublicMethods(),
    withConstructor(createLasso)
  )({});
};
const FRAGMENT_SHADER$2 = `
precision mediump float;

uniform sampler2D texture;

varying vec2 uv;

void main () {
  gl_FragColor = texture2D(texture, uv);
}
`;
const VERTEX_SHADER = `
precision mediump float;

uniform mat4 modelViewProjection;

attribute vec2 position;

varying vec2 uv;

void main () {
  uv = position;
  gl_Position = modelViewProjection * vec4(-1.0 + 2.0 * uv.x, 1.0 - 2.0 * uv.y, 0, 1);
}
`;
const FRAGMENT_SHADER$1 = `
precision highp float;

varying vec4 color;
varying float finalPointSize;

float linearstep(float edge0, float edge1, float x) {
  return clamp((x - edge0) / (edge1 - edge0), 0.0, 1.0);
}

void main() {
  vec2 c = gl_PointCoord * 2.0 - 1.0;
  float sdf = length(c) * finalPointSize;
  float alpha = linearstep(finalPointSize + 0.5, finalPointSize - 0.5, sdf);

  gl_FragColor = vec4(color.rgb, alpha * color.a);
}
`;
const FRAGMENT_SHADER = `precision highp float;

varying vec4 color;

void main() {
  gl_FragColor = color;
}
`;
const createVertexShader = (globalState) => `
precision highp float;

uniform sampler2D colorTex;
uniform float colorTexRes;
uniform float colorTexEps;
uniform sampler2D stateTex;
uniform float stateTexRes;
uniform float stateTexEps;
uniform float devicePixelRatio;
uniform sampler2D encodingTex;
uniform float encodingTexRes;
uniform float encodingTexEps;
uniform float pointSizeExtra;
uniform float pointOpacityMax;
uniform float pointOpacityScale;
uniform float numPoints;
uniform float globalState;
uniform float isColoredByZ;
uniform float isColoredByW;
uniform float isOpacityByZ;
uniform float isOpacityByW;
uniform float isOpacityByDensity;
uniform float isSizedByZ;
uniform float isSizedByW;
uniform float colorMultiplicator;
uniform float opacityMultiplicator;
uniform float opacityDensity;
uniform float sizeMultiplicator;
uniform float numColorStates;
uniform float pointScale;
uniform mat4 modelViewProjection;

attribute vec2 stateIndex;

varying vec4 color;
varying float finalPointSize;

void main() {
  vec4 state = texture2D(stateTex, stateIndex);

  gl_Position = modelViewProjection * vec4(state.x, state.y, 0.0, 1.0);

  // Determine color index
  float colorIndexZ =  isColoredByZ * floor(state.z * colorMultiplicator);
  float colorIndexW =  isColoredByW * floor(state.w * colorMultiplicator);

  // Multiply by the number of color states per color
  // I.e., normal, active, hover, background, etc.
  float colorIndex = (colorIndexZ + colorIndexW) * numColorStates;

  // Half a "pixel" or "texel" in texture coordinates
  float colorLinearIndex = colorIndex + globalState;

  // Need to add cEps here to avoid floating point issue that can lead to
  // dramatic changes in which color is loaded as floor(3/2.9999) = 1 but
  // floor(3/3.0001) = 0!
  float colorRowIndex = floor((colorLinearIndex + colorTexEps) / colorTexRes);

  vec2 colorTexIndex = vec2(
    (colorLinearIndex / colorTexRes) - colorRowIndex + colorTexEps,
    colorRowIndex / colorTexRes + colorTexEps
  );

  color = texture2D(colorTex, colorTexIndex);

  // Retrieve point size
  float pointSizeIndexZ = isSizedByZ * floor(state.z * sizeMultiplicator);
  float pointSizeIndexW = isSizedByW * floor(state.w * sizeMultiplicator);
  float pointSizeIndex = pointSizeIndexZ + pointSizeIndexW;

  float pointSizeRowIndex = floor((pointSizeIndex + encodingTexEps) / encodingTexRes);
  vec2 pointSizeTexIndex = vec2(
    (pointSizeIndex / encodingTexRes) - pointSizeRowIndex + encodingTexEps,
    pointSizeRowIndex / encodingTexRes + encodingTexEps
  );
  float pointSize = texture2D(encodingTex, pointSizeTexIndex).x;

  // Retrieve opacity
  ${(() => {
  if (globalState === 3) return "";
  return `
        if (isOpacityByDensity < 0.5) {
          float opacityIndexZ = isOpacityByZ * floor(state.z * opacityMultiplicator);
          float opacityIndexW = isOpacityByW * floor(state.w * opacityMultiplicator);
          float opacityIndex = opacityIndexZ + opacityIndexW;

          float opacityRowIndex = floor((opacityIndex + encodingTexEps) / encodingTexRes);
          vec2 opacityTexIndex = vec2(
            (opacityIndex / encodingTexRes) - opacityRowIndex + encodingTexEps,
            opacityRowIndex / encodingTexRes + encodingTexEps
          );
          color.a = texture2D(encodingTex, opacityTexIndex)[${1 + globalState}];
        } else {
          color.a = min(1.0, opacityDensity + globalState);
        }
      `;
})()}

  color.a = min(pointOpacityMax, color.a) * pointOpacityScale;
  finalPointSize = (pointSize * pointScale) + pointSizeExtra;
  gl_PointSize = finalPointSize;
}
`;
const SHADER$1 = `precision highp float;

uniform sampler2D startStateTex;
uniform sampler2D endStateTex;
uniform float t;

varying vec2 particleTextureIndex;

void main() {
  // Interpolate x, y, and value
  vec3 start = texture2D(startStateTex, particleTextureIndex).xyw;
  vec3 end = texture2D(endStateTex, particleTextureIndex).xyw;
  vec3 curr = start * (1.0 - t) + end * t;

  // The category cannot be interpolated
  float endCategory = texture2D(endStateTex, particleTextureIndex).z;

  gl_FragColor = vec4(curr.xy, endCategory, curr.z);
}`;
const SHADER = `precision highp float;

attribute vec2 position;
varying vec2 particleTextureIndex;

void main() {
  // map normalized device coords to texture coords
  particleTextureIndex = 0.5 * (1.0 + position);

  gl_Position = vec4(position, 0, 1);
}`;
const worker = function worker2() {
  const catmullRom = (t3, p0, p1, p2, p3) => {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 * t3 * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t3 * t3 + v0 * t3 + p1;
  };
  const interpolatePoint = (t3, points, maxPointIdx) => {
    const p2 = maxPointIdx * t3;
    const intPoint = Math.floor(p2);
    const weight = p2 - intPoint;
    const p0 = points[Math.max(0, intPoint - 1)];
    const p1 = points[intPoint];
    const p22 = points[Math.min(maxPointIdx, intPoint + 1)];
    const p3 = points[Math.min(maxPointIdx, intPoint + 2)];
    return [
      catmullRom(weight, p0[0], p1[0], p22[0], p3[0]),
      catmullRom(weight, p0[1], p1[1], p22[1], p3[1])
    ];
  };
  const sqDist = (x1, y1, x22, y23) => (x1 - x22) ** 2 + (y1 - y23) ** 2;
  /**
   * Douglas Peucker square segment distance
   * Implementation from https://github.com/mourner/simplify-js
   * @author Vladimir Agafonkin
   * @copyright Vladimir Agafonkin 2013
   * @license BSD
   * @param {array} p - Point
   * @param {array} p1 - First boundary point
   * @param {array} p2 - Second boundary point
   * @return {number} Distance
   */
  const sqSegDist = (p2, p1, p22) => {
    let x3 = p1[0];
    let y4 = p1[1];
    let dx = p22[0] - x3;
    let dy = p22[1] - y4;
    if (dx !== 0 || dy !== 0) {
      const t3 = ((p2[0] - x3) * dx + (p2[1] - y4) * dy) / (dx * dx + dy * dy);
      if (t3 > 1) {
        x3 = p22[0];
        y4 = p22[1];
      } else if (t3 > 0) {
        x3 += dx * t3;
        y4 += dy * t3;
      }
    }
    dx = p2[0] - x3;
    dy = p2[1] - y4;
    return dx * dx + dy * dy;
  };
  /**
   * Douglas Peucker step function
   * Implementation from https://github.com/mourner/simplify-js
   * @author Vladimir Agafonkin
   * @copyright Vladimir Agafonkin 2013
   * @license BSD
   * @param   {[type]}  points  [description]
   * @param   {[type]}  first  [description]
   * @param   {[type]}  last  [description]
   * @param   {[type]}  tolerance  [description]
   * @param   {[type]}  simplified  [description]
   * @return  {[type]}  [description]
   */
  const simplifyDPStep = (points, first, last2, tolerance, simplified) => {
    let maxDist = tolerance;
    let index2;
    for (let i3 = first + 1; i3 < last2; i3++) {
      const dist2 = sqSegDist(points[i3], points[first], points[last2]);
      if (dist2 > maxDist) {
        index2 = i3;
        maxDist = dist2;
      }
    }
    if (maxDist > tolerance) {
      if (index2 - first > 1)
        simplifyDPStep(points, first, index2, tolerance, simplified);
      simplified.push(points[index2]);
      if (last2 - index2 > 1)
        simplifyDPStep(points, index2, last2, tolerance, simplified);
    }
  };
  /**
   * Douglas Peucker. Implementation from https://github.com/mourner/simplify-js
   * @author Vladimir Agafonkin
   * @copyright Vladimir Agafonkin 2013
   * @license BSD
   * @param {array} points - List of points to be simplified
   * @param {number} tolerance - Tolerance level. Points below this distance level will be ignored
   * @return {array} Simplified point list
   */
  const simplifyDouglasPeucker = (points, tolerance) => {
    const last2 = points.length - 1;
    const simplified = [points[0]];
    simplifyDPStep(points, 0, last2, tolerance, simplified);
    simplified.push(points[last2]);
    return simplified;
  };
  const interpolatePoints = (points, { maxIntPointsPerSegment = 100, tolerance = 2e-3 } = {}) => {
    const numPoints = points.length;
    const maxPointIdx = numPoints - 1;
    const maxOutPoints = maxPointIdx * maxIntPointsPerSegment + 1;
    const sqTolerance = tolerance ** 2;
    let outPoints = [];
    let prevPoint;
    for (let i3 = 0; i3 < numPoints - 1; i3++) {
      let segmentPoints = [points[i3].slice(0, 2)];
      prevPoint = points[i3];
      for (let j = 1; j < maxIntPointsPerSegment; j++) {
        const t3 = (i3 * maxIntPointsPerSegment + j) / maxOutPoints;
        const intPoint = interpolatePoint(t3, points, maxPointIdx);
        if (sqDist(prevPoint[0], prevPoint[1], intPoint[0], intPoint[1]) > sqTolerance) {
          segmentPoints.push(intPoint);
          prevPoint = intPoint;
        }
      }
      segmentPoints.push(points[i3 + 1]);
      segmentPoints = simplifyDouglasPeucker(segmentPoints, sqTolerance);
      outPoints = outPoints.concat(
        segmentPoints.slice(0, segmentPoints.length - 1)
      );
    }
    outPoints.push(points[points.length - 1].slice(0, 2));
    return outPoints.flat();
  };
  const groupPoints = (points) => {
    const groupedPoints = {};
    const isOrdered = !Number.isNaN(+points[0][5]);
    points.forEach((point) => {
      const segId = point[4];
      if (!groupedPoints[segId]) groupedPoints[segId] = [];
      if (isOrdered) groupedPoints[segId][point[5]] = point;
      else groupedPoints[segId].push(point);
    });
    Object.entries(groupedPoints).forEach((idPoints) => {
      groupedPoints[idPoints[0]] = idPoints[1].filter((v) => v);
      groupedPoints[idPoints[0]].reference = idPoints[1][0];
    });
    return groupedPoints;
  };
  self.onmessage = function onmessage(event) {
    const numPoints = event.data.points ? +event.data.points.length : 0;
    if (!numPoints)
      self.postMessage({ error: new Error("No points provided") });
    event.data.points;
    const groupedPoints = groupPoints(event.data.points);
    self.postMessage({
      points: Object.entries(groupedPoints).reduce(
        (curvePoints, idAndPoints) => {
          curvePoints[idAndPoints[0]] = interpolatePoints(
            idAndPoints[1],
            event.data.options
          );
          curvePoints[idAndPoints[0]].reference = idAndPoints[1].reference;
          return curvePoints;
        },
        {}
      )
    });
  };
};
const createSplineCurve = (points, options = { tolerance: 2e-3, maxIntPointsPerSegment: 100 }) => new Promise((resolve2, reject) => {
  const worker$1 = createWorker$1(worker);
  worker$1.onmessage = (e3) => {
    if (e3.data.error) reject(e3.data.error);
    else resolve2(e3.data.points);
    worker$1.terminate();
  };
  worker$1.postMessage({ points, options });
});
var version = "1.10.2";
const deprecations = {
  showRecticle: "showReticle",
  recticleColor: "reticleColor"
};
const checkDeprecations = (properties) => {
  Object.keys(properties).filter((prop) => deprecations[prop]).forEach((name2) => {
    console.warn(
      `regl-scatterplot: the "${name2}" property is deprecated. Please use "${deprecations[name2]}" instead.`
    );
    properties[deprecations[name2]] = properties[name2];
    delete properties[name2];
  });
};
const getEncodingType = (type2, defaultValue, { allowSegment = false, allowDensity = false, allowInherit = false } = {}) => {
  if (Z_NAMES.has(type2)) return "valueZ";
  if (W_NAMES.has(type2)) return "valueW";
  if (type2 === "segment") return allowSegment ? "segment" : defaultValue;
  if (type2 === "density") return allowDensity ? "density" : defaultValue;
  if (type2 === "inherit") return allowInherit ? "inherit" : defaultValue;
  return defaultValue;
};
const getEncodingIdx = (type2) => {
  switch (type2) {
    case "valueZ":
      return 2;
    case "valueW":
      return 3;
    default:
      return null;
  }
};
const createScatterplot = (initialProperties = {}) => {
  const pubSub = createPubSub({
    async: !initialProperties.syncEvents,
    caseInsensitive: true
  });
  const scratch = new Float32Array(16);
  const pvm = new Float32Array(16);
  const mousePosition = [0, 0];
  checkDeprecations(initialProperties);
  let {
    renderer,
    backgroundColor = DEFAULT_COLOR_BG,
    backgroundImage = DEFAULT_BACKGROUND_IMAGE,
    canvas = document.createElement("canvas"),
    colorBy = DEFAULT_COLOR_BY,
    deselectOnDblClick = DEFAULT_DESELECT_ON_DBL_CLICK,
    deselectOnEscape = DEFAULT_DESELECT_ON_ESCAPE,
    lassoColor = DEFAULT_LASSO_COLOR,
    lassoLineWidth = DEFAULT_LASSO_LINE_WIDTH,
    lassoMinDelay = DEFAULT_LASSO_MIN_DELAY$1,
    lassoMinDist = DEFAULT_LASSO_MIN_DIST$1,
    lassoClearEvent = DEFAULT_LASSO_CLEAR_EVENT,
    lassoInitiator = DEFAULT_LASSO_INITIATOR,
    lassoInitiatorParentElement = document.body,
    lassoOnLongPress = DEFAULT_LASSO_ON_LONG_PRESS,
    lassoLongPressTime = DEFAULT_LASSO_LONG_PRESS_TIME,
    lassoLongPressAfterEffectTime = DEFAULT_LASSO_LONG_PRESS_AFTER_EFFECT_TIME,
    lassoLongPressEffectDelay = DEFAULT_LASSO_LONG_PRESS_EFFECT_DELAY,
    lassoLongPressRevertEffectTime = DEFAULT_LASSO_LONG_PRESS_REVERT_EFFECT_TIME,
    keyMap = DEFAULT_KEY_MAP,
    mouseMode = DEFAULT_MOUSE_MODE,
    showReticle = DEFAULT_SHOW_RETICLE,
    reticleColor = DEFAULT_RETICLE_COLOR,
    pointColor = DEFAULT_COLOR_NORMAL,
    pointColorActive = DEFAULT_COLOR_ACTIVE,
    pointColorHover = DEFAULT_COLOR_HOVER,
    showPointConnections = DEFAULT_SHOW_POINT_CONNECTIONS,
    pointConnectionColor = DEFAULT_POINT_CONNECTION_COLOR_NORMAL,
    pointConnectionColorActive = DEFAULT_POINT_CONNECTION_COLOR_ACTIVE,
    pointConnectionColorHover = DEFAULT_POINT_CONNECTION_COLOR_HOVER,
    pointConnectionColorBy = DEFAULT_POINT_CONNECTION_COLOR_BY,
    pointConnectionOpacity = DEFAULT_POINT_CONNECTION_OPACITY,
    pointConnectionOpacityBy = DEFAULT_POINT_CONNECTION_OPACITY_BY,
    pointConnectionOpacityActive = DEFAULT_POINT_CONNECTION_OPACITY_ACTIVE,
    pointConnectionSize = DEFAULT_POINT_CONNECTION_SIZE,
    pointConnectionSizeActive = DEFAULT_POINT_CONNECTION_SIZE_ACTIVE,
    pointConnectionSizeBy = DEFAULT_POINT_CONNECTION_SIZE_BY,
    pointConnectionMaxIntPointsPerSegment = DEFAULT_POINT_CONNECTION_MAX_INT_POINTS_PER_SEGMENT,
    pointConnectionTolerance = DEFAULT_POINT_CONNECTION_INT_POINTS_TOLERANCE,
    pointSize = DEFAULT_POINT_SIZE,
    pointSizeSelected = DEFAULT_POINT_SIZE_SELECTED,
    pointSizeMouseDetection = DEFAULT_POINT_SIZE_MOUSE_DETECTION,
    pointOutlineWidth = DEFAULT_POINT_OUTLINE_WIDTH,
    opacity = AUTO,
    opacityBy = DEFAULT_OPACITY_BY,
    opacityByDensityFill = DEFAULT_OPACITY_BY_DENSITY_FILL,
    opacityInactiveMax = DEFAULT_OPACITY_INACTIVE_MAX,
    opacityInactiveScale = DEFAULT_OPACITY_INACTIVE_SCALE,
    sizeBy = DEFAULT_SIZE_BY,
    height: height2 = DEFAULT_HEIGHT,
    width = DEFAULT_WIDTH,
    annotationLineColor = DEFAULT_ANNOTATION_LINE_COLOR,
    annotationLineWidth = DEFAULT_ANNOTATION_LINE_WIDTH,
    annotationHVLineLimit = DEFAULT_ANNOTATION_HVLINE_LIMIT
  } = initialProperties;
  let currentWidth = width === AUTO ? 1 : width;
  let currentHeight = height2 === AUTO ? 1 : height2;
  const {
    performanceMode = DEFAULT_PERFORMANCE_MODE,
    opacityByDensityDebounceTime = DEFAULT_OPACITY_BY_DENSITY_DEBOUNCE_TIME,
    spatialIndexUseWorker = DEFAULT_SPATIAL_INDEX_USE_WORKER
  } = initialProperties;
  renderer || (renderer = createRenderer({
    regl: initialProperties.regl,
    gamma: initialProperties.gamma
  }));
  backgroundColor = toRgba(backgroundColor, true);
  lassoColor = toRgba(lassoColor, true);
  reticleColor = toRgba(reticleColor, true);
  let isDestroyed = false;
  let backgroundColorBrightness = rgbBrightness(backgroundColor);
  let camera;
  let lasso;
  let annotations;
  let mouseDown = false;
  let mouseDownTime = null;
  let mouseDownPosition = [0, 0];
  let mouseDownTimeout = -1;
  let selectedPoints = [];
  const selectedPointsSet = /* @__PURE__ */ new Set();
  const selectedPointsConnectionSet = /* @__PURE__ */ new Set();
  let isPointsFiltered = false;
  const filteredPointsSet = /* @__PURE__ */ new Set();
  let points = [];
  let numPoints = 0;
  let numPointsInView = 0;
  let lassoActive = false;
  let lassoPointsCurr = [];
  let spatialIndex;
  let viewAspectRatio;
  let dataAspectRatio = initialProperties.aspectRatio || DEFAULT_DATA_ASPECT_RATIO;
  let projectionLocal;
  let projection;
  let model;
  let pointConnections;
  let pointConnectionMap;
  let computingPointConnectionCurves;
  let reticleHLine;
  let reticleVLine;
  let computedPointSizeMouseDetection;
  let keyActionMap = flipObj(keyMap);
  let lassoInitiatorTimeout;
  let topRightNdc;
  let bottomLeftNdc;
  let preventEventView = false;
  let draw2 = true;
  let drawReticleOnce = false;
  let canvasObserver;
  pointColor = isMultipleColors(pointColor) ? [...pointColor] : [pointColor];
  pointColorActive = isMultipleColors(pointColorActive) ? [...pointColorActive] : [pointColorActive];
  pointColorHover = isMultipleColors(pointColorHover) ? [...pointColorHover] : [pointColorHover];
  pointColor = pointColor.map((color2) => toRgba(color2, true));
  pointColorActive = pointColorActive.map((color2) => toRgba(color2, true));
  pointColorHover = pointColorHover.map((color2) => toRgba(color2, true));
  opacity = !Array.isArray(opacity) && Number.isNaN(+opacity) ? pointColor[0][3] : opacity;
  opacity = isConditionalArray(opacity, isPositiveNumber, {
    minLength: 1
  }) ? [...opacity] : [opacity];
  pointSize = isConditionalArray(pointSize, isPositiveNumber, {
    minLength: 1
  }) ? [...pointSize] : [pointSize];
  let minPointScale = MIN_POINT_SIZE / pointSize[0];
  if (pointConnectionColor === "inherit") {
    pointConnectionColor = [...pointColor];
  } else {
    pointConnectionColor = isMultipleColors(pointConnectionColor) ? [...pointConnectionColor] : [pointConnectionColor];
    pointConnectionColor = pointConnectionColor.map(
      (color2) => toRgba(color2, true)
    );
  }
  if (pointConnectionColorActive === "inherit") {
    pointConnectionColorActive = [...pointColorActive];
  } else {
    pointConnectionColorActive = isMultipleColors(pointConnectionColorActive) ? [...pointConnectionColorActive] : [pointConnectionColorActive];
    pointConnectionColorActive = pointConnectionColorActive.map(
      (color2) => toRgba(color2, true)
    );
  }
  if (pointConnectionColorHover === "inherit") {
    pointConnectionColorHover = [...pointColorHover];
  } else {
    pointConnectionColorHover = isMultipleColors(pointConnectionColorHover) ? [...pointConnectionColorHover] : [pointConnectionColorHover];
    pointConnectionColorHover = pointConnectionColorHover.map(
      (color2) => toRgba(color2, true)
    );
  }
  if (pointConnectionOpacity === "inherit") {
    pointConnectionOpacity = [...opacity];
  } else {
    pointConnectionOpacity = isConditionalArray(
      pointConnectionOpacity,
      isPositiveNumber,
      {
        minLength: 1
      }
    ) ? [...pointConnectionOpacity] : [pointConnectionOpacity];
  }
  if (pointConnectionSize === "inherit") {
    pointConnectionSize = [...pointSize];
  } else {
    pointConnectionSize = isConditionalArray(
      pointConnectionSize,
      isPositiveNumber,
      {
        minLength: 1
      }
    ) ? [...pointConnectionSize] : [pointConnectionSize];
  }
  colorBy = getEncodingType(colorBy, DEFAULT_COLOR_BY);
  opacityBy = getEncodingType(opacityBy, DEFAULT_OPACITY_BY, {
    allowDensity: true
  });
  sizeBy = getEncodingType(sizeBy, DEFAULT_SIZE_BY);
  pointConnectionColorBy = getEncodingType(
    pointConnectionColorBy,
    DEFAULT_POINT_CONNECTION_COLOR_BY,
    { allowSegment: true, allowInherit: true }
  );
  pointConnectionOpacityBy = getEncodingType(
    pointConnectionOpacityBy,
    DEFAULT_POINT_CONNECTION_OPACITY_BY,
    { allowSegment: true }
  );
  pointConnectionSizeBy = getEncodingType(
    pointConnectionSizeBy,
    DEFAULT_POINT_CONNECTION_SIZE_BY,
    { allowSegment: true }
  );
  let stateTex;
  let prevStateTex;
  let tmpStateTex;
  let tmpStateBuffer;
  let stateTexRes = 0;
  let stateTexEps = 0;
  let normalPointsIndexBuffer;
  let selectedPointsIndexBuffer;
  let hoveredPointIndexBuffer;
  let cameraZoomTargetStart;
  let cameraZoomTargetEnd;
  let cameraZoomDistanceStart;
  let cameraZoomDistanceEnd;
  let isTransitioning = false;
  let transitionStartTime = null;
  let transitionDuration;
  let transitionEasing;
  let preTransitionShowReticle = showReticle;
  let colorTex;
  let colorTexRes = 0;
  let encodingTex;
  let encodingTexRes = 0;
  let isViewChanged = false;
  let isPointsDrawn = false;
  let isAnnotationsDrawn = false;
  let isMouseOverCanvasChecked = false;
  let valueZDataType = CATEGORICAL;
  let valueWDataType = CATEGORICAL;
  let hoveredPoint;
  let isMouseInCanvas = false;
  let xScale = initialProperties.xScale || null;
  let yScale = initialProperties.yScale || null;
  let xDomainStart = 0;
  let xDomainSize = 0;
  let yDomainStart = 0;
  let yDomainSize = 0;
  if (xScale) {
    xDomainStart = xScale.domain()[0];
    xDomainSize = xScale.domain()[1] - xScale.domain()[0];
    xScale.range([0, currentWidth]);
  }
  if (yScale) {
    yDomainStart = yScale.domain()[0];
    yDomainSize = yScale.domain()[1] - yScale.domain()[0];
    yScale.range([currentHeight, 0]);
  }
  const getNdcX = (x3) => -1 + x3 / currentWidth * 2;
  const getNdcY = (y4) => 1 + y4 / currentHeight * -2;
  const getMouseGlPos = () => [
    getNdcX(mousePosition[0]),
    getNdcY(mousePosition[1])
  ];
  const getScatterGlPos = (xGl, yGl) => {
    const v = [xGl, yGl, 1, 1];
    const mvp = invert(
      scratch,
      multiply(
        scratch,
        projectionLocal,
        multiply(scratch, camera.view, model)
      )
    );
    transformMat4(v, v, mvp);
    return v.slice(0, 2);
  };
  const getPointSizeNdc = (pointSizeIncrease = 0) => {
    const pointScale = getPointScale();
    const heightNdc = topRightNdc[1] - bottomLeftNdc[1];
    const pxNdc = heightNdc / canvas.height;
    return (computedPointSizeMouseDetection * pointScale + pointSizeIncrease) * pxNdc;
  };
  const getPoints = () => {
    if (isPointsFiltered)
      return points.filter((_, i3) => filteredPointsSet.has(i3));
    return points;
  };
  const getPointsInBBox = (x0, y0, x1, y1) => {
    const pointsInBBox = spatialIndex.range(x0, y0, x1, y1);
    if (isPointsFiltered)
      return pointsInBBox.filter((i3) => filteredPointsSet.has(i3));
    return pointsInBBox;
  };
  const raycast = () => {
    const [xGl, yGl] = getMouseGlPos();
    const [xNdc, yNdc] = getScatterGlPos(xGl, yGl);
    const pointSizeNdc = getPointSizeNdc(4);
    const pointsInBBox = getPointsInBBox(
      xNdc - pointSizeNdc,
      yNdc - pointSizeNdc,
      xNdc + pointSizeNdc,
      yNdc + pointSizeNdc
    );
    let minDist = pointSizeNdc;
    let clostestPoint = -1;
    pointsInBBox.forEach((idx) => {
      const [ptX, ptY] = points[idx];
      const d4 = dist(ptX, ptY, xNdc, yNdc);
      if (d4 < minDist) {
        minDist = d4;
        clostestPoint = idx;
      }
    });
    return clostestPoint;
  };
  const lassoExtend = (lassoPoints, lassoPointsFlat) => {
    lassoPointsCurr = lassoPoints;
    lasso.setPoints(lassoPointsFlat);
    pubSub.publish("lassoExtend", { coordinates: lassoPoints });
  };
  const findPointsInLasso = (lassoPolygon) => {
    const bBox = getBBox(lassoPolygon);
    if (!isValidBBox(bBox)) return [];
    const pointsInBBox = getPointsInBBox(...bBox);
    const pointsInPolygon = [];
    pointsInBBox.forEach((pointIdx) => {
      if (isPointInPolygon(lassoPolygon, points[pointIdx]))
        pointsInPolygon.push(pointIdx);
    });
    return pointsInPolygon;
  };
  const lassoClear = () => {
    lassoPointsCurr = [];
    if (lasso) lasso.clear();
  };
  const hasPointConnections = (point) => point && point.length > 4;
  const setPointConnectionColorState = (pointIdxs, stateIndex) => {
    if (computingPointConnectionCurves || !showPointConnections || !hasPointConnections(points[pointIdxs[0]]))
      return;
    const isNormal = stateIndex === 0;
    const lineIdCacher = stateIndex === 1 ? (lineId) => selectedPointsConnectionSet.add(lineId) : identity;
    const lineIds = Object.keys(
      pointIdxs.reduce((ids, pointIdx) => {
        const point = points[pointIdx];
        const isStruct = Array.isArray(point[4]);
        const lineId = isStruct ? point[4][0] : point[4];
        ids[lineId] = true;
        return ids;
      }, {})
    );
    const buffer = pointConnections.getData().opacities;
    lineIds.filter((lineId) => !selectedPointsConnectionSet.has(+lineId)).forEach((lineId) => {
      const index2 = pointConnectionMap[lineId][0];
      const numPointPerLine = pointConnectionMap[lineId][2];
      const pointOffset = pointConnectionMap[lineId][3];
      const bufferStart = index2 * 4 + pointOffset * 2;
      const bufferEnd = bufferStart + numPointPerLine * 2 + 4;
      if (buffer.__original__ === void 0) {
        buffer.__original__ = buffer.slice();
      }
      for (let i3 = bufferStart; i3 < bufferEnd; i3++) {
        buffer[i3] = isNormal ? (
          // eslint-disable-next-line no-underscore-dangle
          buffer.__original__[i3]
        ) : pointConnectionOpacityActive;
      }
      lineIdCacher(lineId);
    });
    pointConnections.getBuffer().opacities.subdata(buffer, 0);
  };
  const indexToStateTexCoord = (index2) => [
    index2 % stateTexRes / stateTexRes + stateTexEps,
    Math.floor(index2 / stateTexRes) / stateTexRes + stateTexEps
  ];
  const isPointsFilteredOut = (pointIdx) => isPointsFiltered && !filteredPointsSet.has(pointIdx);
  const deselect = ({ preventEvent = false } = {}) => {
    if (lassoClearEvent === LASSO_CLEAR_ON_DESELECT) lassoClear();
    if (selectedPoints.length) {
      if (!preventEvent) pubSub.publish("deselect");
      selectedPointsConnectionSet.clear();
      setPointConnectionColorState(selectedPoints, 0);
      selectedPoints = [];
      selectedPointsSet.clear();
      draw2 = true;
    }
  };
  const select = (pointIdxs, { merge: merge2 = false, preventEvent = false } = {}) => {
    const newSelectedPoints = Array.isArray(pointIdxs) ? pointIdxs : [pointIdxs];
    const currSelectedPoints = [...selectedPoints];
    if (merge2) {
      selectedPoints = unionIntegers(selectedPoints, newSelectedPoints);
      if (currSelectedPoints.length === selectedPoints.length) {
        draw2 = true;
        return;
      }
    } else {
      if (selectedPoints && selectedPoints.length)
        setPointConnectionColorState(selectedPoints, 0);
      if (currSelectedPoints.length > 0 && newSelectedPoints.length === 0) {
        deselect({ preventEvent });
        return;
      }
      selectedPoints = newSelectedPoints;
    }
    if (hasSameElements(currSelectedPoints, selectedPoints)) {
      draw2 = true;
      return;
    }
    const selectedPointsBuffer = [];
    selectedPointsSet.clear();
    selectedPointsConnectionSet.clear();
    for (let i3 = selectedPoints.length - 1; i3 >= 0; i3--) {
      const pointIdx = selectedPoints[i3];
      if (pointIdx < 0 || pointIdx >= numPoints || isPointsFilteredOut(pointIdx)) {
        selectedPoints.splice(i3, 1);
        continue;
      }
      selectedPointsSet.add(pointIdx);
      selectedPointsBuffer.push.apply(
        selectedPointsBuffer,
        indexToStateTexCoord(pointIdx)
      );
    }
    selectedPointsIndexBuffer({
      usage: "dynamic",
      type: "float",
      data: selectedPointsBuffer
    });
    setPointConnectionColorState(selectedPoints, 1);
    if (!preventEvent) pubSub.publish("select", { points: selectedPoints });
    draw2 = true;
  };
  const hover = (point, { showReticleOnce = false, preventEvent = false } = {}) => {
    let needsRedraw = false;
    const isFilteredOut = isPointsFiltered && !filteredPointsSet.has(point);
    if (!isFilteredOut && point >= 0 && point < numPoints) {
      needsRedraw = true;
      const oldHoveredPoint = hoveredPoint;
      const newHoveredPoint = point !== hoveredPoint;
      if (+oldHoveredPoint >= 0 && newHoveredPoint && !selectedPointsSet.has(oldHoveredPoint)) {
        setPointConnectionColorState([oldHoveredPoint], 0);
      }
      hoveredPoint = point;
      hoveredPointIndexBuffer.subdata(indexToStateTexCoord(point));
      if (!selectedPointsSet.has(point))
        setPointConnectionColorState([point], 2);
      if (newHoveredPoint && !preventEvent)
        pubSub.publish("pointover", hoveredPoint);
    } else {
      needsRedraw = +hoveredPoint >= 0;
      if (needsRedraw) {
        if (!selectedPointsSet.has(hoveredPoint)) {
          setPointConnectionColorState([hoveredPoint], 0);
        }
        if (!preventEvent) {
          pubSub.publish("pointout", hoveredPoint);
        }
      }
      hoveredPoint = void 0;
    }
    if (needsRedraw) {
      draw2 = true;
      drawReticleOnce = showReticleOnce;
    }
  };
  const getRelativeMousePosition = (event) => {
    const rect = canvas.getBoundingClientRect();
    mousePosition[0] = event.clientX - rect.left;
    mousePosition[1] = event.clientY - rect.top;
    return [...mousePosition];
  };
  const lassoStart = () => {
    camera.config({ isFixed: true });
    mouseDown = true;
    lassoActive = true;
    lassoClear();
    if (mouseDownTimeout >= 0) {
      clearTimeout(mouseDownTimeout);
      mouseDownTimeout = -1;
    }
    pubSub.publish("lassoStart");
  };
  const lassoEnd = (lassoPoints, lassoPointsFlat, { merge: merge2 = false } = {}) => {
    camera.config({ isFixed: false });
    lassoPointsCurr = [...lassoPoints];
    const pointsInLasso = findPointsInLasso(lassoPointsFlat);
    select(pointsInLasso, { merge: merge2 });
    pubSub.publish("lassoEnd", {
      coordinates: lassoPointsCurr
    });
    if (lassoClearEvent === LASSO_CLEAR_ON_END) lassoClear();
  };
  const lassoManager = createLasso(canvas, {
    onStart: lassoStart,
    onDraw: lassoExtend,
    onEnd: lassoEnd,
    enableInitiator: lassoInitiator,
    initiatorParentElement: lassoInitiatorParentElement,
    pointNorm: ([x3, y4]) => getScatterGlPos(getNdcX(x3), getNdcY(y4))
  });
  const checkLassoMode = () => mouseMode === MOUSE_MODE_LASSO;
  const checkModKey = (event, action) => {
    switch (keyActionMap[action]) {
      case KEY_ALT:
        return event.altKey;
      case KEY_CMD:
        return event.metaKey;
      case KEY_CTRL:
        return event.ctrlKey;
      case KEY_META:
        return event.metaKey;
      case KEY_SHIFT:
        return event.shiftKey;
      default:
        return false;
    }
  };
  const checkIfMouseIsOverCanvas = (event) => document.elementsFromPoint(event.clientX, event.clientY).some((element) => element === canvas);
  const mouseDownHandler = (event) => {
    if (!isPointsDrawn || event.buttons !== 1) return;
    mouseDown = true;
    mouseDownTime = performance.now();
    mouseDownPosition = getRelativeMousePosition(event);
    lassoActive = checkLassoMode() || checkModKey(event, KEY_ACTION_LASSO);
    if (!lassoActive && lassoOnLongPress) {
      lassoManager.showLongPressIndicator(event.clientX, event.clientY, {
        time: lassoLongPressTime,
        extraTime: lassoLongPressAfterEffectTime,
        delay: lassoLongPressEffectDelay
      });
      mouseDownTimeout = setTimeout(() => {
        mouseDownTimeout = -1;
        lassoActive = true;
      }, lassoLongPressTime);
    }
  };
  const mouseUpHandler = (event) => {
    if (!isPointsDrawn) return;
    mouseDown = false;
    if (mouseDownTimeout >= 0) {
      clearTimeout(mouseDownTimeout);
      mouseDownTimeout = -1;
    }
    if (lassoActive) {
      event.preventDefault();
      lassoActive = false;
      lassoManager.end({
        merge: checkModKey(event, KEY_ACTION_MERGE)
      });
    }
    if (lassoOnLongPress) {
      lassoManager.hideLongPressIndicator({
        time: lassoLongPressRevertEffectTime
      });
    }
  };
  const mouseClickHandler = (event) => {
    if (!isPointsDrawn) return;
    event.preventDefault();
    const currentMousePosition = getRelativeMousePosition(event);
    if (dist(...currentMousePosition, ...mouseDownPosition) >= lassoMinDist)
      return;
    const clickTime = performance.now() - mouseDownTime;
    if (!lassoInitiator || clickTime < LONG_CLICK_TIME) {
      const clostestPoint = raycast();
      if (clostestPoint >= 0) {
        if (selectedPoints.length && lassoClearEvent === LASSO_CLEAR_ON_DESELECT) {
          lassoClear();
        }
        select([clostestPoint], {
          merge: checkModKey(event, KEY_ACTION_MERGE)
        });
      } else if (!lassoInitiatorTimeout) {
        lassoInitiatorTimeout = setTimeout(() => {
          lassoInitiatorTimeout = null;
          lassoManager.showInitiator(event);
        }, SINGLE_CLICK_DELAY);
      }
    }
  };
  const mouseDblClickHandler = (event) => {
    lassoManager.hideInitiator();
    if (lassoInitiatorTimeout) {
      clearTimeout(lassoInitiatorTimeout);
      lassoInitiatorTimeout = null;
    }
    if (deselectOnDblClick) {
      event.preventDefault();
      deselect();
    }
  };
  const mouseMoveHandler = (event) => {
    if (!isMouseOverCanvasChecked) {
      isMouseInCanvas = checkIfMouseIsOverCanvas(event);
      isMouseOverCanvasChecked = true;
    }
    if (!isPointsDrawn || !isMouseInCanvas && !mouseDown) return;
    const currentMousePosition = getRelativeMousePosition(event);
    const mouseMoveDist = dist(...currentMousePosition, ...mouseDownPosition);
    const mouseMovedMin = mouseMoveDist >= lassoMinDist;
    if (isMouseInCanvas && !lassoActive) {
      hover(raycast());
    }
    if (lassoActive) {
      event.preventDefault();
      lassoManager.extend(event, true);
    } else if (mouseDown && lassoOnLongPress && mouseMovedMin) {
      lassoManager.hideLongPressIndicator({
        time: lassoLongPressRevertEffectTime
      });
    }
    if (mouseDownTimeout >= 0 && mouseMovedMin) {
      clearTimeout(mouseDownTimeout);
      mouseDownTimeout = -1;
    }
    if (mouseDown) draw2 = true;
  };
  const blurHandler = () => {
    hoveredPoint = void 0;
    isMouseInCanvas = false;
    isMouseOverCanvasChecked = false;
    if (!isPointsDrawn) return;
    if (+hoveredPoint >= 0 && !selectedPointsSet.has(hoveredPoint))
      setPointConnectionColorState([hoveredPoint], 0);
    mouseUpHandler();
    draw2 = true;
  };
  const createEncodingTexture = () => {
    const maxEncoding = Math.max(pointSize.length, opacity.length);
    encodingTexRes = Math.max(2, Math.ceil(Math.sqrt(maxEncoding)));
    const rgba2 = new Float32Array(encodingTexRes ** 2 * 4);
    for (let i3 = 0; i3 < maxEncoding; i3++) {
      rgba2[i3 * 4] = pointSize[i3] || 0;
      rgba2[i3 * 4 + 1] = Math.min(1, opacity[i3] || 0);
      const activeOpacity = Number(
        (pointColorActive[i3] || pointColorActive[0])[3]
      );
      rgba2[i3 * 4 + 2] = Math.min(
        1,
        Number.isNaN(activeOpacity) ? 1 : activeOpacity
      );
      const hoverOpacity = Number(
        (pointColorHover[i3] || pointColorHover[0])[3]
      );
      rgba2[i3 * 4 + 3] = Math.min(
        1,
        Number.isNaN(hoverOpacity) ? 1 : hoverOpacity
      );
    }
    return renderer.regl.texture({
      data: rgba2,
      shape: [encodingTexRes, encodingTexRes, 4],
      type: "float"
    });
  };
  const getColors = (baseColor2 = pointColor, activeColor = pointColorActive, hoverColor = pointColorHover) => {
    const n = baseColor2.length;
    const n2 = activeColor.length;
    const n3 = hoverColor.length;
    const colors2 = [];
    if (n === n2 && n2 === n3) {
      for (let i3 = 0; i3 < n; i3++) {
        colors2.push(
          baseColor2[i3],
          activeColor[i3],
          hoverColor[i3],
          backgroundColor
        );
      }
    } else {
      for (let i3 = 0; i3 < n; i3++) {
        const rgbaOpaque = [
          baseColor2[i3][0],
          baseColor2[i3][1],
          baseColor2[i3][2],
          1
        ];
        const colorActive = colorBy === DEFAULT_COLOR_BY ? activeColor[0] : rgbaOpaque;
        const colorHover = colorBy === DEFAULT_COLOR_BY ? hoverColor[0] : rgbaOpaque;
        colors2.push(baseColor2[i3], colorActive, colorHover, backgroundColor);
      }
    }
    return colors2;
  };
  const createColorTexture = () => {
    const colors2 = getColors();
    const numColors = colors2.length;
    colorTexRes = Math.max(2, Math.ceil(Math.sqrt(numColors)));
    const rgba2 = new Float32Array(colorTexRes ** 2 * 4);
    colors2.forEach((color2, i3) => {
      rgba2[i3 * 4] = color2[0];
      rgba2[i3 * 4 + 1] = color2[1];
      rgba2[i3 * 4 + 2] = color2[2];
      rgba2[i3 * 4 + 3] = color2[3];
    });
    return renderer.regl.texture({
      data: rgba2,
      shape: [colorTexRes, colorTexRes, 4],
      type: "float"
    });
  };
  const updateProjectionMatrix = (widthRatio, heightRatio) => {
    projection[0] = widthRatio / viewAspectRatio;
    projection[5] = heightRatio;
  };
  const updateViewAspectRatio = () => {
    viewAspectRatio = currentWidth / currentHeight;
    projectionLocal = fromScaling([], [1 / viewAspectRatio, 1, 1]);
    projection = fromScaling([], [1 / viewAspectRatio, 1, 1]);
    model = fromScaling([], [dataAspectRatio, 1, 1]);
  };
  const setDataAspectRatio = (newDataAspectRatio) => {
    if (+newDataAspectRatio <= 0) return;
    dataAspectRatio = newDataAspectRatio;
  };
  const setColors = (getter, setter) => (newColors) => {
    if (!newColors || !newColors.length) return;
    const colors2 = getter();
    const prevColors = [...colors2];
    let tmpColors = isMultipleColors(newColors) ? newColors : [newColors];
    tmpColors = tmpColors.map((color2) => toRgba(color2, true));
    if (colorTex) colorTex.destroy();
    try {
      setter(tmpColors);
      colorTex = createColorTexture();
    } catch (e3) {
      console.error("Invalid colors. Switching back to default colors.");
      setter(prevColors);
      colorTex = createColorTexture();
    }
  };
  const setPointColor = setColors(
    () => pointColor,
    (colors2) => {
      pointColor = colors2;
    }
  );
  const setPointColorActive = setColors(
    () => pointColorActive,
    (colors2) => {
      pointColorActive = colors2;
    }
  );
  const setPointColorHover = setColors(
    () => pointColorHover,
    (colors2) => {
      pointColorHover = colors2;
    }
  );
  const computeDomainView = () => {
    const xyStartPt = getScatterGlPos(-1, -1);
    const xyEndPt = getScatterGlPos(1, 1);
    const xStart = (xyStartPt[0] + 1) / 2;
    const xEnd = (xyEndPt[0] + 1) / 2;
    const yStart = (xyStartPt[1] + 1) / 2;
    const yEnd = (xyEndPt[1] + 1) / 2;
    const xDomainView = [
      xDomainStart + xStart * xDomainSize,
      xDomainStart + xEnd * xDomainSize
    ];
    const yDomainView = [
      yDomainStart + yStart * yDomainSize,
      yDomainStart + yEnd * yDomainSize
    ];
    return [xDomainView, yDomainView];
  };
  const updateScales = () => {
    if (!xScale && !yScale) return;
    const [xDomainView, yDomainView] = computeDomainView();
    if (xScale) xScale.domain(xDomainView);
    if (yScale) yScale.domain(yDomainView);
  };
  const setCurrentHeight = (newCurrentHeight) => {
    currentHeight = Math.max(1, newCurrentHeight);
    canvas.height = Math.floor(currentHeight * window.devicePixelRatio);
    if (yScale) {
      yScale.range([currentHeight, 0]);
      updateScales();
    }
  };
  const setHeight = (newHeight) => {
    if (newHeight === AUTO) {
      height2 = newHeight;
      canvas.style.height = "100%";
      window.requestAnimationFrame(() => {
        if (canvas) setCurrentHeight(canvas.getBoundingClientRect().height);
      });
      return;
    }
    if (!+newHeight || +newHeight <= 0) return;
    height2 = +newHeight;
    setCurrentHeight(height2);
    canvas.style.height = `${height2}px`;
  };
  const computePointSizeMouseDetection = () => {
    computedPointSizeMouseDetection = pointSizeMouseDetection;
    if (pointSizeMouseDetection === AUTO) {
      computedPointSizeMouseDetection = Array.isArray(pointSize) ? max$1(pointSize) : pointSize;
    }
  };
  const setPointSize = (newPointSize) => {
    if (isConditionalArray(newPointSize, isPositiveNumber, { minLength: 1 }))
      pointSize = [...newPointSize];
    if (isStrictlyPositiveNumber(+newPointSize)) pointSize = [+newPointSize];
    minPointScale = MIN_POINT_SIZE / pointSize[0];
    encodingTex = createEncodingTexture();
    computePointSizeMouseDetection();
  };
  const setPointSizeSelected = (newPointSizeSelected) => {
    if (!+newPointSizeSelected || +newPointSizeSelected < 0) return;
    pointSizeSelected = +newPointSizeSelected;
  };
  const setPointOutlineWidth = (newPointOutlineWidth) => {
    if (!+newPointOutlineWidth || +newPointOutlineWidth < 0) return;
    pointOutlineWidth = +newPointOutlineWidth;
  };
  const setCurrentWidth = (newCurrentWidth) => {
    currentWidth = Math.max(1, newCurrentWidth);
    canvas.width = Math.floor(currentWidth * window.devicePixelRatio);
    if (xScale) {
      xScale.range([0, currentWidth]);
      updateScales();
    }
  };
  const setWidth = (newWidth) => {
    if (newWidth === AUTO) {
      width = newWidth;
      canvas.style.width = "100%";
      window.requestAnimationFrame(() => {
        if (canvas) setCurrentWidth(canvas.getBoundingClientRect().width);
      });
      return;
    }
    if (!+newWidth || +newWidth <= 0) return;
    width = +newWidth;
    setCurrentWidth(width);
    canvas.style.width = `${currentWidth}px`;
  };
  const setOpacity = (newOpacity) => {
    if (isConditionalArray(newOpacity, isPositiveNumber, { minLength: 1 }))
      opacity = [...newOpacity];
    if (isStrictlyPositiveNumber(+newOpacity)) opacity = [+newOpacity];
    encodingTex = createEncodingTexture();
  };
  const getEncodingDataType = (type2) => {
    switch (type2) {
      case "valueZ":
        return valueZDataType;
      case "valueW":
        return valueWDataType;
      default:
        return null;
    }
  };
  const getEncodingValueToIdx = (type2, rangeValues) => {
    switch (type2) {
      case CONTINUOUS:
        return (value2) => Math.round(value2 * (rangeValues.length - 1));
      case CATEGORICAL:
      default:
        return identity;
    }
  };
  const setColorBy = (type2) => {
    colorBy = getEncodingType(type2, DEFAULT_COLOR_BY);
  };
  const setOpacityBy = (type2) => {
    opacityBy = getEncodingType(type2, DEFAULT_OPACITY_BY, {
      allowDensity: true
    });
  };
  const setSizeBy = (type2) => {
    sizeBy = getEncodingType(type2, DEFAULT_SIZE_BY);
  };
  const setPointConnectionColorBy = (type2) => {
    pointConnectionColorBy = getEncodingType(
      type2,
      DEFAULT_POINT_CONNECTION_COLOR_BY,
      { allowSegment: true, allowInherit: true }
    );
  };
  const setPointConnectionOpacityBy = (type2) => {
    pointConnectionOpacityBy = getEncodingType(
      type2,
      DEFAULT_POINT_CONNECTION_OPACITY_BY,
      { allowSegment: true }
    );
  };
  const setPointConnectionSizeBy = (type2) => {
    pointConnectionSizeBy = getEncodingType(
      type2,
      DEFAULT_POINT_CONNECTION_SIZE_BY,
      { allowSegment: true }
    );
  };
  const getResolution = () => [canvas.width, canvas.height];
  const getBackgroundImage = () => backgroundImage;
  const getColorTex = () => colorTex;
  const getColorTexRes = () => colorTexRes;
  const getColorTexEps = () => 0.5 / colorTexRes;
  const getDevicePixelRatio = () => window.devicePixelRatio;
  const getNormalPointsIndexBuffer = () => normalPointsIndexBuffer;
  const getSelectedPointsIndexBuffer = () => selectedPointsIndexBuffer;
  const getEncodingTex = () => encodingTex;
  const getEncodingTexRes = () => encodingTexRes;
  const getEncodingTexEps = () => 0.5 / encodingTexRes;
  const getNormalPointSizeExtra = () => 0;
  const getStateTex = () => tmpStateTex || stateTex;
  const getStateTexRes = () => stateTexRes;
  const getStateTexEps = () => 0.5 / stateTexRes;
  const getProjection = () => projection;
  const getView = () => camera.view;
  const getModel = () => model;
  const getModelViewProjection = () => multiply(pvm, projection, multiply(pvm, camera.view, model));
  const getPointScale = () => {
    if (camera.scaling[0] > 1)
      return Math.asinh(max$2(1, camera.scaling[0])) / Math.asinh(1) * window.devicePixelRatio;
    return max$2(minPointScale, camera.scaling[0]) * window.devicePixelRatio;
  };
  const getNormalNumPoints = () => isPointsFiltered ? filteredPointsSet.size : numPoints;
  const getSelectedNumPoints = () => selectedPoints.length;
  const getPointOpacityMaxBase = () => getSelectedNumPoints() > 0 ? opacityInactiveMax : 1;
  const getPointOpacityScaleBase = () => getSelectedNumPoints() > 0 ? opacityInactiveScale : 1;
  const getIsColoredByZ = () => +(colorBy === "valueZ");
  const getIsColoredByW = () => +(colorBy === "valueW");
  const getIsOpacityByZ = () => +(opacityBy === "valueZ");
  const getIsOpacityByW = () => +(opacityBy === "valueW");
  const getIsOpacityByDensity = () => +(opacityBy === "density");
  const getIsSizedByZ = () => +(sizeBy === "valueZ");
  const getIsSizedByW = () => +(sizeBy === "valueW");
  const getColorMultiplicator = () => {
    if (colorBy === "valueZ")
      return valueZDataType === CONTINUOUS ? pointColor.length - 1 : 1;
    return valueWDataType === CONTINUOUS ? pointColor.length - 1 : 1;
  };
  const getOpacityMultiplicator = () => {
    if (opacityBy === "valueZ")
      return valueZDataType === CONTINUOUS ? opacity.length - 1 : 1;
    return valueWDataType === CONTINUOUS ? opacity.length - 1 : 1;
  };
  const getSizeMultiplicator = () => {
    if (sizeBy === "valueZ")
      return valueZDataType === CONTINUOUS ? pointSize.length - 1 : 1;
    return valueWDataType === CONTINUOUS ? pointSize.length - 1 : 1;
  };
  const getOpacityDensity = (context) => {
    if (opacityBy !== "density") return 1;
    const pointScale = getPointScale();
    const p2 = pointSize[0] * pointScale;
    const s4 = 2 / (2 / camera.view[0]) * (2 / (2 / camera.view[5]));
    const H4 = context.viewportHeight;
    const W2 = context.viewportWidth;
    let alpha2 = opacityByDensityFill * W2 * H4 / (numPointsInView * p2 * p2) * min(1, s4);
    alpha2 *= performanceMode ? 1 : 1 / (0.25 * Math.PI);
    const clampedPointDeviceSize = max$2(MIN_POINT_SIZE, p2) + 0.5;
    alpha2 *= (p2 / clampedPointDeviceSize) ** 2;
    return min(1, max$2(0, alpha2));
  };
  const updatePoints = renderer.regl({
    framebuffer: () => tmpStateBuffer,
    vert: SHADER,
    frag: SHADER$1,
    attributes: {
      position: [-4, 0, 4, 4, 4, -4]
    },
    uniforms: {
      startStateTex: () => prevStateTex,
      endStateTex: () => stateTex,
      t: (ctx, props4) => props4.t
    },
    count: 3
  });
  const drawPoints = (getPointSizeExtra, getNumPoints, getStateIndexBuffer, globalState = COLOR_NORMAL_IDX, getPointOpacityMax = getPointOpacityMaxBase, getPointOpacityScale = getPointOpacityScaleBase) => renderer.regl({
    frag: performanceMode ? FRAGMENT_SHADER : FRAGMENT_SHADER$1,
    vert: createVertexShader(globalState),
    blend: {
      enable: !performanceMode,
      func: {
        srcRGB: "src alpha",
        srcAlpha: "one",
        dstRGB: "one minus src alpha",
        dstAlpha: "one minus src alpha"
      }
    },
    depth: { enable: false },
    attributes: {
      stateIndex: {
        buffer: getStateIndexBuffer,
        size: 2
      }
    },
    uniforms: {
      resolution: getResolution,
      modelViewProjection: getModelViewProjection,
      devicePixelRatio: getDevicePixelRatio,
      pointScale: getPointScale,
      encodingTex: getEncodingTex,
      encodingTexRes: getEncodingTexRes,
      encodingTexEps: getEncodingTexEps,
      pointOpacityMax: getPointOpacityMax,
      pointOpacityScale: getPointOpacityScale,
      pointSizeExtra: getPointSizeExtra,
      globalState,
      colorTex: getColorTex,
      colorTexRes: getColorTexRes,
      colorTexEps: getColorTexEps,
      stateTex: getStateTex,
      stateTexRes: getStateTexRes,
      stateTexEps: getStateTexEps,
      isColoredByZ: getIsColoredByZ,
      isColoredByW: getIsColoredByW,
      isOpacityByZ: getIsOpacityByZ,
      isOpacityByW: getIsOpacityByW,
      isOpacityByDensity: getIsOpacityByDensity,
      isSizedByZ: getIsSizedByZ,
      isSizedByW: getIsSizedByW,
      colorMultiplicator: getColorMultiplicator,
      opacityMultiplicator: getOpacityMultiplicator,
      opacityDensity: getOpacityDensity,
      sizeMultiplicator: getSizeMultiplicator,
      numColorStates: COLOR_NUM_STATES
    },
    count: getNumPoints,
    primitive: "points"
  });
  const drawPointBodies = drawPoints(
    getNormalPointSizeExtra,
    getNormalNumPoints,
    getNormalPointsIndexBuffer
  );
  const drawHoveredPoint = drawPoints(
    getNormalPointSizeExtra,
    () => 1,
    () => hoveredPointIndexBuffer,
    COLOR_HOVER_IDX,
    () => 1,
    () => 1
  );
  const drawSelectedPointOutlines = drawPoints(
    () => (pointSizeSelected + pointOutlineWidth * 2) * window.devicePixelRatio,
    getSelectedNumPoints,
    getSelectedPointsIndexBuffer,
    COLOR_ACTIVE_IDX,
    () => 1,
    () => 1
  );
  const drawSelectedPointInnerBorder = drawPoints(
    () => (pointSizeSelected + pointOutlineWidth) * window.devicePixelRatio,
    getSelectedNumPoints,
    getSelectedPointsIndexBuffer,
    COLOR_BG_IDX,
    () => 1,
    () => 1
  );
  const drawSelectedPointBodies = drawPoints(
    () => pointSizeSelected * window.devicePixelRatio,
    getSelectedNumPoints,
    getSelectedPointsIndexBuffer,
    COLOR_ACTIVE_IDX,
    () => 1,
    () => 1
  );
  const drawSelectedPoints = () => {
    drawSelectedPointOutlines();
    drawSelectedPointInnerBorder();
    drawSelectedPointBodies();
  };
  const drawBackgroundImage = renderer.regl({
    frag: FRAGMENT_SHADER$2,
    vert: VERTEX_SHADER,
    attributes: {
      position: [0, 1, 0, 0, 1, 0, 0, 1, 1, 1, 1, 0]
    },
    uniforms: {
      modelViewProjection: getModelViewProjection,
      texture: getBackgroundImage
    },
    count: 6
  });
  const drawPolygon2d = renderer.regl({
    vert: `
      precision mediump float;
      uniform mat4 modelViewProjection;
      attribute vec2 position;
      void main () {
        gl_Position = modelViewProjection * vec4(position, 0, 1);
      }`,
    frag: `
      precision mediump float;
      uniform vec4 color;
      void main () {
        gl_FragColor = vec4(color.rgb, 0.2);
      }`,
    depth: { enable: false },
    blend: {
      enable: true,
      func: {
        srcRGB: "src alpha",
        srcAlpha: "one",
        dstRGB: "one minus src alpha",
        dstAlpha: "one minus src alpha"
      }
    },
    attributes: {
      position: () => lassoPointsCurr
    },
    uniforms: {
      modelViewProjection: getModelViewProjection,
      color: () => lassoColor
    },
    elements: () => Array.from({ length: lassoPointsCurr.length - 2 }, (_, i3) => [
      0,
      i3 + 1,
      i3 + 2
    ])
  });
  const drawReticle = () => {
    if (!(hoveredPoint >= 0)) return;
    const [x3, y4] = points[hoveredPoint].slice(0, 2);
    const v = [x3, y4, 0, 1];
    multiply(
      scratch,
      projection,
      multiply(scratch, camera.view, model)
    );
    transformMat4(v, v, scratch);
    reticleHLine.setPoints([-1, v[1], 1, v[1]]);
    reticleVLine.setPoints([v[0], 1, v[0], -1]);
    reticleHLine.draw();
    reticleVLine.draw();
    drawPoints(
      () => (pointSizeSelected + pointOutlineWidth * 2) * window.devicePixelRatio,
      () => 1,
      hoveredPointIndexBuffer,
      COLOR_ACTIVE_IDX
    )();
    drawPoints(
      () => (pointSizeSelected + pointOutlineWidth) * window.devicePixelRatio,
      () => 1,
      hoveredPointIndexBuffer,
      COLOR_BG_IDX
    )();
  };
  const createPointIndex = (numNewPoints) => {
    const index2 = new Float32Array(numNewPoints * 2);
    let j = 0;
    for (let i3 = 0; i3 < numNewPoints; ++i3) {
      const texCoord = indexToStateTexCoord(i3);
      index2[j] = texCoord[0];
      index2[j + 1] = texCoord[1];
      j += 2;
    }
    return index2;
  };
  const createStateTexture = (newPoints, dataTypes = {}) => {
    const numNewPoints = newPoints.length;
    stateTexRes = Math.max(2, Math.ceil(Math.sqrt(numNewPoints)));
    stateTexEps = 0.5 / stateTexRes;
    const data = new Float32Array(stateTexRes ** 2 * 4);
    let zIsInts = true;
    let wIsInts = true;
    let k3 = 0;
    let z3 = 0;
    let w3 = 0;
    for (let i3 = 0; i3 < numNewPoints; ++i3) {
      k3 = i3 * 4;
      data[k3] = newPoints[i3][0];
      data[k3 + 1] = newPoints[i3][1];
      z3 = newPoints[i3][2] || 0;
      w3 = newPoints[i3][3] || 0;
      data[k3 + 2] = z3;
      data[k3 + 3] = w3;
      zIsInts && (zIsInts = Number.isInteger(z3));
      wIsInts && (wIsInts = Number.isInteger(w3));
    }
    if (dataTypes.z && VALUE_ZW_DATA_TYPES.includes(dataTypes.z)) {
      valueZDataType = dataTypes.z;
    } else {
      valueZDataType = zIsInts ? CATEGORICAL : CONTINUOUS;
    }
    if (dataTypes.w && VALUE_ZW_DATA_TYPES.includes(dataTypes.w)) {
      valueWDataType = dataTypes.w;
    } else {
      valueWDataType = wIsInts ? CATEGORICAL : CONTINUOUS;
    }
    return renderer.regl.texture({
      data,
      shape: [stateTexRes, stateTexRes, 4],
      type: "float"
    });
  };
  const cachePoints = (newPoints, dataTypes = {}) => {
    if (!stateTex) return false;
    if (isTransitioning) {
      const tmp = prevStateTex;
      prevStateTex = tmpStateTex;
      tmp.destroy();
    } else {
      prevStateTex = stateTex;
    }
    tmpStateTex = createStateTexture(newPoints, dataTypes);
    tmpStateBuffer = renderer.regl.framebuffer({
      color: tmpStateTex,
      depth: false,
      stencil: false
    });
    stateTex = void 0;
    return true;
  };
  const hasCachedPoints = () => Boolean(prevStateTex && tmpStateTex);
  const clearCachedPoints = () => {
    if (prevStateTex) {
      prevStateTex.destroy();
      prevStateTex = void 0;
    }
    if (tmpStateTex) {
      tmpStateTex.destroy();
      tmpStateTex = void 0;
    }
  };
  const setPoints = (newPoints, options = {}) => new Promise((resolve2) => {
    isPointsDrawn = false;
    const preventFilterReset = (options == null ? void 0 : options.preventFilterReset) && newPoints.length === numPoints;
    numPoints = newPoints.length;
    numPointsInView = numPoints;
    if (stateTex) stateTex.destroy();
    stateTex = createStateTexture(newPoints, {
      z: options.zDataType,
      w: options.wDataType
    });
    if (!preventFilterReset) {
      normalPointsIndexBuffer({
        usage: "static",
        type: "float",
        data: createPointIndex(numPoints)
      });
    }
    createKdbush(options.spatialIndex || newPoints, {
      useWorker: spatialIndexUseWorker
    }).then((newSearchIndex) => {
      spatialIndex = newSearchIndex;
      points = newPoints;
      isPointsDrawn = true;
    }).then(resolve2);
  });
  const cacheCamera = (newTarget, newDistance) => {
    cameraZoomTargetStart = camera.target;
    cameraZoomTargetEnd = newTarget;
    cameraZoomDistanceStart = camera.distance[0];
    cameraZoomDistanceEnd = newDistance;
  };
  const hasCachedCamera = () => Boolean(
    cameraZoomTargetStart !== void 0 && cameraZoomTargetEnd !== void 0 && cameraZoomDistanceStart !== void 0 && cameraZoomDistanceEnd !== void 0
  );
  const clearCachedCamera = () => {
    cameraZoomTargetStart = void 0;
    cameraZoomTargetEnd = void 0;
    cameraZoomDistanceStart = void 0;
    cameraZoomDistanceEnd = void 0;
  };
  const getPointConnectionColorIndices = (curvePoints) => {
    const colorEncoding = pointConnectionColorBy === "inherit" ? colorBy : pointConnectionColorBy;
    if (colorEncoding === "segment") {
      const maxColorIdx = pointConnectionColor.length - 1;
      if (maxColorIdx < 1) return [];
      return curvePoints.reduce((colorIndices, curve, index2) => {
        let totalLength = 0;
        const segLengths = [];
        for (let i3 = 2; i3 < curve.length; i3 += 2) {
          const segLength = Math.sqrt(
            (curve[i3 - 2] - curve[i3]) ** 2 + (curve[i3 - 1] - curve[i3 + 1]) ** 2
          );
          segLengths.push(segLength);
          totalLength += segLength;
        }
        colorIndices[index2] = [0];
        let cumLength = 0;
        for (let i3 = 0; i3 < curve.length / 2 - 1; i3++) {
          cumLength += segLengths[i3];
          colorIndices[index2].push(
            Math.floor(cumLength / totalLength * maxColorIdx) * 4
          );
        }
        return colorIndices;
      }, []);
    }
    if (colorEncoding) {
      const encodingIdx = getEncodingIdx(colorEncoding);
      const encodingValueToIdx = getEncodingValueToIdx(
        getEncodingDataType(colorEncoding),
        pointConnectionColorBy === "inherit" ? pointColor : pointConnectionColor
      );
      return pointConnectionMap.reduce(
        (colorIndices, [index2, referencePoint]) => {
          colorIndices[index2] = encodingValueToIdx(referencePoint[encodingIdx]) * 4;
          return colorIndices;
        },
        []
      );
    }
    return Array(pointConnectionMap.length).fill(0);
  };
  const getPointConnectionOpacities = () => {
    const opacityEncoding = pointConnectionOpacityBy === "inherit" ? opacityBy : pointConnectionOpacityBy;
    if (opacityEncoding === "segment") {
      const maxOpacityIdx = pointConnectionOpacity.length - 1;
      if (maxOpacityIdx < 1) return [];
      return pointConnectionMap.reduce(
        // eslint-disable-next-line no-unused-vars
        (opacities, [index2, referencePoint, length]) => {
          opacities[index2] = rangeMap(
            length,
            (i3) => pointConnectionOpacity[Math.floor(i3 / (length - 1) * maxOpacityIdx)]
          );
          return opacities;
        },
        []
      );
    }
    if (opacityEncoding) {
      const encodingIdx = getEncodingIdx(opacityEncoding);
      const encodingRangeMap = pointConnectionOpacityBy === "inherit" ? opacity : pointConnectionOpacity;
      const encodingValueToIdx = getEncodingValueToIdx(
        getEncodingDataType(opacityEncoding),
        encodingRangeMap
      );
      return pointConnectionMap.reduce((opacities, [index2, referencePoint]) => {
        opacities[index2] = encodingRangeMap[encodingValueToIdx(referencePoint[encodingIdx])];
        return opacities;
      }, []);
    }
    return void 0;
  };
  const getPointConnectionWidths = () => {
    const sizeEncoding = pointConnectionSizeBy === "inherit" ? sizeBy : pointConnectionSizeBy;
    if (sizeEncoding === "segment") {
      const maxSizeIdx = pointConnectionSize.length - 1;
      if (maxSizeIdx < 1) return [];
      return pointConnectionMap.reduce(
        // eslint-disable-next-line no-unused-vars
        (widths, [index2, referencePoint, length]) => {
          widths[index2] = rangeMap(
            length,
            (i3) => pointConnectionSize[Math.floor(i3 / (length - 1) * maxSizeIdx)]
          );
          return widths;
        },
        []
      );
    }
    if (sizeEncoding) {
      const encodingIdx = getEncodingIdx(sizeEncoding);
      const encodingRangeMap = pointConnectionSizeBy === "inherit" ? pointSize : pointConnectionSize;
      const encodingValueToIdx = getEncodingValueToIdx(
        getEncodingDataType(sizeEncoding),
        encodingRangeMap
      );
      return pointConnectionMap.reduce((widths, [index2, referencePoint]) => {
        widths[index2] = encodingRangeMap[encodingValueToIdx(referencePoint[encodingIdx])];
        return widths;
      }, []);
    }
    return void 0;
  };
  const setPointConnectionMap = (curvePoints) => {
    pointConnectionMap = [];
    let cumLinePoints = 0;
    Object.keys(curvePoints).forEach((id3, index2) => {
      pointConnectionMap[id3] = [
        index2,
        curvePoints[id3].reference,
        curvePoints[id3].length / 2,
        // Used for offsetting in the buffer manipulations on
        // hovering and selecting
        cumLinePoints
      ];
      cumLinePoints += curvePoints[id3].length / 2;
    });
  };
  const setPointConnections = (newPoints) => new Promise((resolve2) => {
    pointConnections.setPoints([]);
    if (!newPoints || !newPoints.length) {
      resolve2();
    } else {
      computingPointConnectionCurves = true;
      createSplineCurve(newPoints, {
        maxIntPointsPerSegment: pointConnectionMaxIntPointsPerSegment,
        tolerance: pointConnectionTolerance
      }).then((curvePoints) => {
        setPointConnectionMap(curvePoints);
        const curvePointValues = Object.values(curvePoints);
        pointConnections.setPoints(
          curvePointValues.length === 1 ? curvePointValues[0] : curvePointValues,
          {
            colorIndices: getPointConnectionColorIndices(curvePointValues),
            opacities: getPointConnectionOpacities(),
            widths: getPointConnectionWidths()
          }
        );
        computingPointConnectionCurves = false;
        resolve2();
      });
    }
  });
  const unfilter = ({ preventEvent = false } = {}) => {
    isPointsFiltered = false;
    filteredPointsSet.clear();
    normalPointsIndexBuffer.subdata(createPointIndex(numPoints));
    return new Promise((resolve2) => {
      const finish = () => {
        pubSub.subscribe(
          "draw",
          () => {
            if (!preventEvent) pubSub.publish("unfilter");
            resolve2();
          },
          1
        );
        draw2 = true;
      };
      if (showPointConnections || hasPointConnections(points[0])) {
        setPointConnections(getPoints()).then(() => {
          if (!preventEvent) pubSub.publish("pointConnectionsDraw");
          finish();
        });
      } else {
        finish();
      }
    });
  };
  const filter = (pointIdxs, { preventEvent = false } = {}) => {
    const filteredPoints = Array.isArray(pointIdxs) ? pointIdxs : [pointIdxs];
    isPointsFiltered = true;
    filteredPointsSet.clear();
    const filteredPointsBuffer = [];
    const filteredSelectedPoints = [];
    for (let i3 = filteredPoints.length - 1; i3 >= 0; i3--) {
      const pointIdx = filteredPoints[i3];
      if (pointIdx < 0 || pointIdx >= numPoints) {
        filteredPoints.splice(i3, 1);
        continue;
      }
      filteredPointsSet.add(pointIdx);
      filteredPointsBuffer.push.apply(
        filteredPointsBuffer,
        indexToStateTexCoord(pointIdx)
      );
      if (selectedPointsSet.has(pointIdx))
        filteredSelectedPoints.push(pointIdx);
    }
    normalPointsIndexBuffer.subdata(filteredPointsBuffer);
    select(filteredSelectedPoints, { preventEvent });
    if (!filteredPointsSet.has(hoveredPoint)) hover(-1, { preventEvent });
    return new Promise((resolve2) => {
      const finish = () => {
        pubSub.subscribe(
          "draw",
          () => {
            if (!preventEvent)
              pubSub.publish("filter", { points: filteredPoints });
            resolve2();
          },
          1
        );
        draw2 = true;
      };
      if (showPointConnections || hasPointConnections(points[0])) {
        setPointConnections(getPoints()).then(() => {
          if (!preventEvent) pubSub.publish("pointConnectionsDraw");
          select(filteredSelectedPoints, { preventEvent });
          finish();
        });
      } else {
        finish();
      }
    });
  };
  const getPointsInView = () => getPointsInBBox(
    bottomLeftNdc[0],
    bottomLeftNdc[1],
    topRightNdc[0],
    topRightNdc[1]
  );
  const getNumPointsInView = () => {
    numPointsInView = getPointsInView().length;
  };
  const getNumPointsInViewDb = throttleAndDebounce(
    getNumPointsInView,
    opacityByDensityDebounceTime
  );
  const tweenCamera = (t3) => {
    const [xStart, yStart] = cameraZoomTargetStart;
    const [xEnd, yEnd] = cameraZoomTargetEnd;
    const ti = 1 - t3;
    const targetX = xStart * ti + xEnd * t3;
    const targetY = yStart * ti + yEnd * t3;
    const distance = cameraZoomDistanceStart * ti + cameraZoomDistanceEnd * t3;
    camera.lookAt([targetX, targetY], distance);
  };
  const isTransitioningPoints = () => hasCachedPoints();
  const isTransitioningCamera = () => hasCachedCamera();
  const tween = (duration2, easing) => {
    if (!transitionStartTime) transitionStartTime = performance.now();
    const dt2 = performance.now() - transitionStartTime;
    const t3 = clip(easing(dt2 / duration2), 0, 1);
    if (isTransitioningPoints()) {
      updatePoints({ t: t3 });
    }
    if (isTransitioningCamera()) {
      tweenCamera(t3);
    }
    return dt2 < duration2;
  };
  const endTransition = () => {
    isTransitioning = false;
    transitionStartTime = null;
    transitionDuration = void 0;
    transitionEasing = void 0;
    showReticle = preTransitionShowReticle;
    clearCachedPoints();
    clearCachedCamera();
    pubSub.publish("transitionEnd");
  };
  const startTransition = ({ duration: duration2 = 500, easing = DEFAULT_EASING }) => {
    if (isTransitioning) pubSub.publish("transitionEnd");
    isTransitioning = true;
    transitionStartTime = null;
    transitionDuration = duration2;
    transitionEasing = isString(easing) ? EASING_FNS[easing] || DEFAULT_EASING : easing;
    preTransitionShowReticle = showReticle;
    showReticle = false;
    pubSub.publish("transitionStart");
  };
  const publicDraw = (newPoints, options = {}) => {
    if (isDestroyed) {
      return Promise.reject(new Error("The instance was already destroyed"));
    }
    return toArrayOrientedPoints(newPoints).then(
      (newPointsArray) => new Promise((resolve2) => {
        if (isDestroyed) {
          resolve2();
          return;
        }
        let pointsCached = false;
        if (!options.preventFilterReset || (newPointsArray == null ? void 0 : newPointsArray.length) !== numPoints) {
          isPointsFiltered = false;
          filteredPointsSet.clear();
        }
        const drawPointConnections = newPointsArray && hasPointConnections(newPointsArray[0]) && (showPointConnections || options.showPointConnectionsOnce);
        const { zDataType, wDataType } = options;
        new Promise((resolveDraw) => {
          if (newPointsArray) {
            if (options.transition) {
              if (newPointsArray.length === numPoints) {
                pointsCached = cachePoints(newPointsArray, {
                  z: zDataType,
                  w: wDataType
                });
              } else {
                console.warn(
                  "Cannot transition! The number of points between the previous and current draw call must be identical."
                );
              }
            }
            setPoints(newPointsArray, {
              zDataType,
              wDataType,
              preventFilterReset: options.preventFilterReset,
              spatialIndex: options.spatialIndex
            }).then(() => {
              if (options.hover !== void 0) {
                hover(options.hover, { preventEvent: true });
              }
              if (options.select !== void 0) {
                select(options.select, { preventEvent: true });
              }
              if (options.filter !== void 0) {
                filter(options.filter, { preventEvent: true });
              }
              if (drawPointConnections) {
                setPointConnections(newPointsArray).then(() => {
                  pubSub.publish("pointConnectionsDraw");
                  draw2 = true;
                  drawReticleOnce = options.showReticleOnce;
                }).then(resolve2);
              } else {
                resolveDraw();
              }
            });
          } else {
            resolveDraw();
          }
        }).then(() => {
          if (options.transition && pointsCached) {
            if (drawPointConnections) {
              Promise.all([
                new Promise((resolveTransition) => {
                  pubSub.subscribe(
                    "transitionEnd",
                    () => {
                      draw2 = true;
                      drawReticleOnce = options.showReticleOnce;
                      resolveTransition();
                    },
                    1
                  );
                }),
                new Promise((resolveDraw) => {
                  pubSub.subscribe("pointConnectionsDraw", resolveDraw, 1);
                })
              ]).then(resolve2);
            } else {
              pubSub.subscribe(
                "transitionEnd",
                () => {
                  draw2 = true;
                  drawReticleOnce = options.showReticleOnce;
                  resolve2();
                },
                1
              );
            }
            startTransition({
              duration: options.transitionDuration,
              easing: options.transitionEasing
            });
          } else {
            if (drawPointConnections) {
              Promise.all([
                new Promise((resolveDraw) => {
                  pubSub.subscribe("draw", resolveDraw, 1);
                }),
                new Promise((resolveDraw) => {
                  pubSub.subscribe("pointConnectionsDraw", resolveDraw, 1);
                })
              ]).then(resolve2);
            } else {
              pubSub.subscribe("draw", resolve2, 1);
            }
            draw2 = true;
            drawReticleOnce = options.showReticleOnce;
          }
        });
      })
    );
  };
  const drawAnnotations = (newAnnotations) => {
    if (isDestroyed) {
      return Promise.reject(new Error("The instance was already destroyed"));
    }
    isAnnotationsDrawn = false;
    if (newAnnotations.length === 0) {
      return new Promise((resolve2) => {
        annotations.clear();
        pubSub.subscribe("draw", resolve2, 1);
        isAnnotationsDrawn = true;
        draw2 = true;
      });
    }
    return new Promise((resolve2) => {
      const newPoints = [];
      const newColors = /* @__PURE__ */ new Map();
      const newColorIndices = [];
      const newWidths = [];
      let maxNewColorIdx = -1;
      const addColorAndWidth = (annotation) => {
        newWidths.push(annotation.lineWidth || annotationLineWidth);
        const color2 = toRgba(annotation.lineColor || annotationLineColor, true);
        const colorId = `[${color2.join(",")}]`;
        if (newColors.has(colorId)) {
          const { idx } = newColors.get(colorId);
          newColorIndices.push(idx);
        } else {
          const idx = ++maxNewColorIdx;
          newColors.set(colorId, { idx, color: color2 });
          newColorIndices.push(idx);
        }
      };
      for (const annotation of newAnnotations) {
        if (isHorizontalLine(annotation)) {
          newPoints.push([
            annotation.x1 ?? -annotationHVLineLimit,
            annotation.y,
            annotation.x2 ?? annotationHVLineLimit,
            annotation.y
          ]);
          addColorAndWidth(annotation);
          continue;
        }
        if (isVerticalLine(annotation)) {
          newPoints.push([
            annotation.x,
            annotation.y1 ?? -annotationHVLineLimit,
            annotation.x,
            annotation.y2 ?? annotationHVLineLimit
          ]);
          addColorAndWidth(annotation);
          continue;
        }
        if (isRect(annotation)) {
          newPoints.push([
            annotation.x1,
            annotation.y1,
            annotation.x2,
            annotation.y1,
            annotation.x2,
            annotation.y2,
            annotation.x1,
            annotation.y2,
            annotation.x1,
            annotation.y1
          ]);
          addColorAndWidth(annotation);
          continue;
        }
        if (isDomRect(annotation)) {
          newPoints.push([
            annotation.x,
            annotation.y,
            annotation.x + annotation.width,
            annotation.y,
            annotation.x + annotation.width,
            annotation.y + annotation.height,
            annotation.x,
            annotation.y + annotation.height,
            annotation.x,
            annotation.y
          ]);
          addColorAndWidth(annotation);
          continue;
        }
        if (isPolygon(annotation)) {
          newPoints.push(annotation.vertices.flatMap(identity));
          addColorAndWidth(annotation);
        }
      }
      annotations.setStyle({
        color: Array.from(newColors.values()).sort((a4, b3) => a4.idx > b3.idx ? 1 : -1).map(({ color: color2 }) => color2)
      });
      annotations.setPoints(
        newPoints.length === 1 ? newPoints.flat() : newPoints,
        {
          colorIndices: newColorIndices,
          widths: newWidths
        }
      );
      pubSub.subscribe("draw", resolve2, 1);
      isAnnotationsDrawn = true;
      draw2 = true;
    });
  };
  const withDraw = (f) => (...args) => {
    const out = f(...args);
    draw2 = true;
    return new Promise((resolve2) => {
      pubSub.subscribe("draw", () => resolve2(out), 1);
    });
  };
  const getBBoxOfPoints = (pointIdxs) => {
    let xMin = Infinity;
    let xMax = -Infinity;
    let yMin = Infinity;
    let yMax = -Infinity;
    for (let i3 = 0; i3 < pointIdxs.length; i3++) {
      const [x3, y4] = points[pointIdxs[i3]];
      xMin = Math.min(xMin, x3);
      xMax = Math.max(xMax, x3);
      yMin = Math.min(yMin, y4);
      yMax = Math.max(yMax, y4);
    }
    return { x: xMin, y: yMin, width: xMax - xMin, height: yMax - yMin };
  };
  const zoomToArea = (rect, options = {}) => new Promise((resolve2) => {
    const target2 = transformMat4(
      [],
      [rect.x + rect.width / 2, rect.y + rect.height / 2, 0, 0],
      model
    ).slice(0, 2);
    const vFOV = 2 * Math.atan(1);
    const aspectRatio = viewAspectRatio / dataAspectRatio;
    const distance = rect.height * aspectRatio >= rect.width ? (
      // Distance is based on the height of the bounding box
      rect.height / 2 / Math.tan(vFOV / 2)
    ) : (
      // Distance is based on the width of the bounding box
      rect.width / 2 / Math.tan(vFOV / 2) / aspectRatio
    );
    if (options.transition) {
      camera.config({ isFixed: true });
      cacheCamera(target2, distance);
      pubSub.subscribe(
        "transitionEnd",
        () => {
          resolve2();
          camera.config({ isFixed: false });
        },
        1
      );
      startTransition({
        duration: options.transitionDuration,
        easing: options.transitionEasing
      });
    } else {
      camera.lookAt(target2, distance);
      pubSub.subscribe("draw", resolve2, 1);
      draw2 = true;
    }
  });
  const zoomToPoints = (pointIdxs, options = {}) => {
    if (!isPointsDrawn)
      return Promise.reject(new Error(ERROR_POINTS_NOT_DRAWN));
    const rect = getBBoxOfPoints(pointIdxs);
    const cX = rect.x + rect.width / 2;
    const cY = rect.y + rect.height / 2;
    const pointSizeNdc = getPointSizeNdc();
    const scale = 1 + (options.padding || 0);
    const w3 = Math.max(rect.width, pointSizeNdc) * scale;
    const h6 = Math.max(rect.height, pointSizeNdc) * scale;
    const x3 = cX - w3 / 2;
    const y4 = cY - h6 / 2;
    return zoomToArea({ x: x3, y: y4, width: w3, height: h6 }, options);
  };
  const zoomToLocation = (target2, distance, options = {}) => new Promise((resolve2) => {
    if (options.transition) {
      camera.config({ isFixed: true });
      cacheCamera(target2, distance);
      pubSub.subscribe(
        "transitionEnd",
        () => {
          resolve2();
          camera.config({ isFixed: false });
        },
        1
      );
      startTransition({
        duration: options.transitionDuration,
        easing: options.transitionEasing
      });
    } else {
      camera.lookAt(target2, distance);
      pubSub.subscribe("draw", resolve2, 1);
      draw2 = true;
    }
  });
  const zoomToOrigin = (options = {}) => zoomToLocation([0, 0], 1, options);
  const getScreenPosition = (pointIdx) => {
    if (!isPointsDrawn) throw new Error(ERROR_POINTS_NOT_DRAWN);
    const point = points[pointIdx];
    if (!point) return void 0;
    const v = [point[0], point[1], 0, 1];
    multiply(
      scratch,
      projectionLocal,
      multiply(scratch, camera.view, model)
    );
    transformMat4(v, v, scratch);
    const x3 = currentWidth * (v[0] + 1) / 2;
    const y4 = currentHeight * (0.5 - v[1] / 2);
    return [x3, y4];
  };
  const updatePointConnectionStyle = () => {
    pointConnections.setStyle({
      color: getColors(
        pointConnectionColor,
        pointConnectionColorActive,
        pointConnectionColorHover
      ),
      opacity: pointConnectionOpacity === null ? null : pointConnectionOpacity[0],
      width: pointConnectionSize[0]
    });
  };
  const updateLassoInitiatorStyle = () => {
    const v = Math.round(backgroundColorBrightness) > 0.5 ? 0 : 255;
    lassoManager.initiator.style.border = `1px dashed rgba(${v}, ${v}, ${v}, 0.33)`;
    lassoManager.initiator.style.background = `rgba(${v}, ${v}, ${v}, 0.1)`;
  };
  const updateLassoLongPressIndicatorStyle = () => {
    const v = Math.round(backgroundColorBrightness) > 0.5 ? 0 : 255;
    lassoManager.longPressIndicator.style.color = `rgb(${v}, ${v}, ${v})`;
    lassoManager.longPressIndicator.dataset.color = `rgb(${v}, ${v}, ${v})`;
    const rgb2 = lassoColor.map((c3) => Math.round(c3 * 255));
    lassoManager.longPressIndicator.dataset.activeColor = `rgb(${rgb2[0]}, ${rgb2[1]}, ${rgb2[2]})`;
  };
  const setBackgroundColor = (newBackgroundColor) => {
    if (!newBackgroundColor) return;
    backgroundColor = toRgba(newBackgroundColor, true);
    backgroundColorBrightness = rgbBrightness(backgroundColor);
    updateLassoInitiatorStyle();
    updateLassoLongPressIndicatorStyle();
  };
  const setBackgroundImage = (newBackgroundImage) => {
    if (!newBackgroundImage) {
      backgroundImage = null;
    } else if (isString(newBackgroundImage)) {
      createTextureFromUrl(renderer.regl, newBackgroundImage).then((texture) => {
        backgroundImage = texture;
        draw2 = true;
        pubSub.publish("backgroundImageReady");
      }).catch(() => {
        console.error(`Count not create texture from ${newBackgroundImage}`);
        backgroundImage = null;
      });
    } else if (newBackgroundImage._reglType === "texture2d") {
      backgroundImage = newBackgroundImage;
    } else {
      backgroundImage = null;
    }
  };
  const setCameraDistance = (distance) => {
    if (distance > 0) camera.lookAt(camera.target, distance, camera.rotation);
  };
  const setCameraRotation = (rotation) => {
    if (rotation !== null)
      camera.lookAt(camera.target, camera.distance[0], rotation);
  };
  const setCameraTarget = (target2) => {
    if (target2) camera.lookAt(target2, camera.distance[0], camera.rotation);
  };
  const setCameraView = (view2) => {
    if (view2) camera.setView(view2);
  };
  const setLassoColor = (newLassoColor) => {
    if (!newLassoColor) return;
    lassoColor = toRgba(newLassoColor, true);
    lasso.setStyle({ color: lassoColor });
    const rgb2 = lassoColor.map((c3) => Math.round(c3 * 255));
    lassoManager.longPressIndicator.dataset.activeColor = `rgb(${rgb2[0]}, ${rgb2[1]}, ${rgb2[2]})`;
  };
  const setLassoLineWidth = (newLassoLineWidth) => {
    if (Number.isNaN(+newLassoLineWidth) || +newLassoLineWidth < 1) return;
    lassoLineWidth = +newLassoLineWidth;
    lasso.setStyle({ width: lassoLineWidth });
  };
  const setLassoMinDelay = (newLassoMinDelay) => {
    if (!+newLassoMinDelay) return;
    lassoMinDelay = +newLassoMinDelay;
    lassoManager.set({
      minDelay: lassoMinDelay
    });
  };
  const setLassoMinDist = (newLassoMinDist) => {
    if (!+newLassoMinDist) return;
    lassoMinDist = +newLassoMinDist;
    lassoManager.set({
      minDist: lassoMinDist
    });
  };
  const setLassoClearEvent = (newLassoClearEvent) => {
    lassoClearEvent = limit(
      LASSO_CLEAR_EVENTS,
      lassoClearEvent
    )(newLassoClearEvent);
  };
  const setLassoInitiator = (newLassoInitiator) => {
    lassoInitiator = Boolean(newLassoInitiator);
    lassoManager.set({
      enableInitiator: lassoInitiator
    });
  };
  const setLassoInitiatorParentElement = (newLassoInitiatorParentElement) => {
    lassoInitiatorParentElement = newLassoInitiatorParentElement;
    lassoManager.set({
      startInitiatorParentElement: lassoInitiatorParentElement
    });
  };
  const setLassoOnLongPress = (newLassoOnLongPress) => {
    lassoOnLongPress = Boolean(newLassoOnLongPress);
  };
  const setLassoLongPressTime = (newLassoOnLongPressTime) => {
    lassoLongPressTime = Number(newLassoOnLongPressTime);
  };
  const setLassoLongPressAfterEffectTime = (newTime) => {
    lassoLongPressAfterEffectTime = Number(newTime);
  };
  const setLassoLongPressEffectDelay = (newDelay) => {
    lassoLongPressEffectDelay = Number(newDelay);
  };
  const setLassoLongPressRevertEffectTime = (newTime) => {
    lassoLongPressRevertEffectTime = Number(newTime);
  };
  const setKeyMap = (newKeyMap) => {
    keyMap = Object.entries(newKeyMap).reduce((map2, [key, value2]) => {
      if (KEYS$2.includes(key) && KEY_ACTIONS.includes(value2)) {
        map2[key] = value2;
      }
      return map2;
    }, {});
    keyActionMap = flipObj(keyMap);
    if (keyActionMap[KEY_ACTION_ROTATE]) {
      camera.config({
        isRotate: true,
        mouseDownMoveModKey: keyActionMap[KEY_ACTION_ROTATE]
      });
    } else {
      camera.config({
        isRotate: false
      });
    }
  };
  const setMouseMode = (newMouseMode) => {
    mouseMode = limit(MOUSE_MODES, MOUSE_MODE_PANZOOM)(newMouseMode);
    camera.config({
      defaultMouseDownMoveAction: mouseMode === MOUSE_MODE_ROTATE ? "rotate" : "pan"
    });
  };
  const setShowReticle = (newShowReticle) => {
    if (newShowReticle === null) return;
    showReticle = newShowReticle;
  };
  const setReticleColor = (newReticleColor) => {
    if (!newReticleColor) return;
    reticleColor = toRgba(newReticleColor, true);
    reticleHLine.setStyle({ color: reticleColor });
    reticleVLine.setStyle({ color: reticleColor });
  };
  const setXScale = (newXScale) => {
    if (!newXScale) return;
    xScale = newXScale;
    xDomainStart = newXScale.domain()[0];
    xDomainSize = newXScale ? newXScale.domain()[1] - newXScale.domain()[0] : 0;
    xScale.range([0, currentWidth]);
    updateScales();
  };
  const setYScale = (newYScale) => {
    if (!newYScale) return;
    yScale = newYScale;
    yDomainStart = yScale.domain()[0];
    yDomainSize = yScale ? yScale.domain()[1] - yScale.domain()[0] : 0;
    yScale.range([currentHeight, 0]);
    updateScales();
  };
  const setDeselectOnDblClick = (newDeselectOnDblClick) => {
    deselectOnDblClick = !!newDeselectOnDblClick;
  };
  const setDeselectOnEscape = (newDeselectOnEscape) => {
    deselectOnEscape = !!newDeselectOnEscape;
  };
  const setShowPointConnections = (newShowPointConnections) => {
    showPointConnections = !!newShowPointConnections;
    if (showPointConnections) {
      if (isPointsDrawn && hasPointConnections(points[0])) {
        setPointConnections(getPoints()).then(() => {
          pubSub.publish("pointConnectionsDraw");
          draw2 = true;
        });
      }
    } else {
      setPointConnections();
    }
  };
  const setPointConnectionColors = (setter, getInheritance) => (newColors) => {
    if (newColors === "inherit") {
      setter([...getInheritance()]);
    } else {
      const tmpColors = isMultipleColors(newColors) ? newColors : [newColors];
      setter(tmpColors.map((color2) => toRgba(color2, true)));
    }
    updatePointConnectionStyle();
  };
  const setPointConnectionColor = setPointConnectionColors(
    (newColors) => {
      pointConnectionColor = newColors;
    },
    () => pointColor
  );
  const setPointConnectionColorActive = setPointConnectionColors(
    (newColors) => {
      pointConnectionColorActive = newColors;
    },
    () => pointColorActive
  );
  const setPointConnectionColorHover = setPointConnectionColors(
    (newColors) => {
      pointConnectionColorHover = newColors;
    },
    () => pointColorHover
  );
  const setPointConnectionOpacity = (newOpacity) => {
    if (isConditionalArray(newOpacity, isPositiveNumber, { minLength: 1 }))
      pointConnectionOpacity = [...newOpacity];
    if (isStrictlyPositiveNumber(+newOpacity))
      pointConnectionOpacity = [+newOpacity];
    pointConnectionColor = pointConnectionColor.map((color2) => {
      color2[3] = !Number.isNaN(+pointConnectionOpacity[0]) ? +pointConnectionOpacity[0] : color2[3];
      return color2;
    });
    updatePointConnectionStyle();
  };
  const setPointConnectionOpacityActive = (newOpacity) => {
    if (!Number.isNaN(+newOpacity) && +newOpacity)
      pointConnectionOpacityActive = +newOpacity;
  };
  const setPointConnectionSize = (newPointConnectionSize) => {
    if (isConditionalArray(newPointConnectionSize, isPositiveNumber, {
      minLength: 1
    }))
      pointConnectionSize = [...newPointConnectionSize];
    if (isStrictlyPositiveNumber(+newPointConnectionSize))
      pointConnectionSize = [+newPointConnectionSize];
    updatePointConnectionStyle();
  };
  const setPointConnectionSizeActive = (newPointConnectionSizeActive) => {
    if (!Number.isNaN(+newPointConnectionSizeActive) && +newPointConnectionSizeActive)
      pointConnectionSizeActive = Math.max(0, newPointConnectionSizeActive);
  };
  const setPointConnectionMaxIntPointsPerSegment = (newPointConnectionMaxIntPointsPerSegment) => {
    pointConnectionMaxIntPointsPerSegment = Math.max(
      0,
      newPointConnectionMaxIntPointsPerSegment
    );
  };
  const setPointConnectionTolerance = (newPointConnectionTolerance) => {
    pointConnectionTolerance = Math.max(0, newPointConnectionTolerance);
  };
  const setPointSizeMouseDetection = (newPointSizeMouseDetection) => {
    pointSizeMouseDetection = newPointSizeMouseDetection;
    computePointSizeMouseDetection();
  };
  const setOpacityByDensityFill = (newOpacityByDensityFill) => {
    opacityByDensityFill = +newOpacityByDensityFill;
  };
  const setOpacityInactiveMax = (newOpacityInactiveMax) => {
    opacityInactiveMax = +newOpacityInactiveMax;
  };
  const setOpacityInactiveScale = (newOpacityInactiveScale) => {
    opacityInactiveScale = +newOpacityInactiveScale;
  };
  const setAnnotationLineColor = (newAnnotationLineColor) => {
    annotationLineColor = toRgba(newAnnotationLineColor);
  };
  const setAnnotationLineWidth = (newAnnotationLineWidth) => {
    annotationLineWidth = +newAnnotationLineWidth;
  };
  const setAnnotationHVLineLimit = (newAnnotationHVLineLimit) => {
    annotationHVLineLimit = +newAnnotationHVLineLimit;
  };
  const setGamma = (newGamma) => {
    renderer.gamma = newGamma;
  };
  const get2 = (property) => {
    checkDeprecations({ property: true });
    if (property === "aspectRatio") return dataAspectRatio;
    if (property === "background") return backgroundColor;
    if (property === "backgroundColor") return backgroundColor;
    if (property === "backgroundImage") return backgroundImage;
    if (property === "camera") return camera;
    if (property === "cameraTarget") return camera.target;
    if (property === "cameraDistance") return camera.distance[0];
    if (property === "cameraRotation") return camera.rotation;
    if (property === "cameraView") return camera.view;
    if (property === "canvas") return canvas;
    if (property === "colorBy") return colorBy;
    if (property === "sizeBy") return sizeBy;
    if (property === "deselectOnDblClick") return deselectOnDblClick;
    if (property === "deselectOnEscape") return deselectOnEscape;
    if (property === "height") return height2;
    if (property === "lassoColor") return lassoColor;
    if (property === "lassoLineWidth") return lassoLineWidth;
    if (property === "lassoMinDelay") return lassoMinDelay;
    if (property === "lassoMinDist") return lassoMinDist;
    if (property === "lassoClearEvent") return lassoClearEvent;
    if (property === "lassoInitiator") return lassoInitiator;
    if (property === "lassoInitiatorElement") return lassoManager.initiator;
    if (property === "lassoInitiatorParentElement")
      return lassoInitiatorParentElement;
    if (property === "keyMap") return { ...keyMap };
    if (property === "mouseMode") return mouseMode;
    if (property === "opacity")
      return opacity.length === 1 ? opacity[0] : opacity;
    if (property === "opacityBy") return opacityBy;
    if (property === "opacityByDensityFill") return opacityByDensityFill;
    if (property === "opacityByDensityDebounceTime")
      return opacityByDensityDebounceTime;
    if (property === "opacityInactiveMax") return opacityInactiveMax;
    if (property === "opacityInactiveScale") return opacityInactiveScale;
    if (property === "points") return points;
    if (property === "hoveredPoint") return hoveredPoint;
    if (property === "selectedPoints") return [...selectedPoints];
    if (property === "filteredPoints")
      return isPointsFiltered ? Array.from(filteredPointsSet) : Array.from({ length: points.length }, (_, i3) => i3);
    if (property === "pointsInView") return getPointsInView();
    if (property === "pointColor")
      return pointColor.length === 1 ? pointColor[0] : pointColor;
    if (property === "pointColorActive")
      return pointColorActive.length === 1 ? pointColorActive[0] : pointColorActive;
    if (property === "pointColorHover")
      return pointColorHover.length === 1 ? pointColorHover[0] : pointColorHover;
    if (property === "pointOutlineWidth") return pointOutlineWidth;
    if (property === "pointSize")
      return pointSize.length === 1 ? pointSize[0] : pointSize;
    if (property === "pointSizeSelected") return pointSizeSelected;
    if (property === "pointSizeMouseDetection") return pointSizeMouseDetection;
    if (property === "showPointConnections") return showPointConnections;
    if (property === "pointConnectionColor")
      return pointConnectionColor.length === 1 ? pointConnectionColor[0] : pointConnectionColor;
    if (property === "pointConnectionColorActive")
      return pointConnectionColorActive.length === 1 ? pointConnectionColorActive[0] : pointConnectionColorActive;
    if (property === "pointConnectionColorHover")
      return pointConnectionColorHover.length === 1 ? pointConnectionColorHover[0] : pointConnectionColorHover;
    if (property === "pointConnectionColorBy") return pointConnectionColorBy;
    if (property === "pointConnectionOpacity")
      return pointConnectionOpacity.length === 1 ? pointConnectionOpacity[0] : pointConnectionOpacity;
    if (property === "pointConnectionOpacityBy")
      return pointConnectionOpacityBy;
    if (property === "pointConnectionOpacityActive")
      return pointConnectionOpacityActive;
    if (property === "pointConnectionSize")
      return pointConnectionSize.length === 1 ? pointConnectionSize[0] : pointConnectionSize;
    if (property === "pointConnectionSizeActive")
      return pointConnectionSizeActive;
    if (property === "pointConnectionSizeBy") return pointConnectionSizeBy;
    if (property === "pointConnectionMaxIntPointsPerSegment")
      return pointConnectionMaxIntPointsPerSegment;
    if (property === "pointConnectionTolerance")
      return pointConnectionTolerance;
    if (property === "reticleColor") return reticleColor;
    if (property === "regl") return renderer.regl;
    if (property === "showReticle") return showReticle;
    if (property === "version") return version;
    if (property === "width") return width;
    if (property === "xScale") return xScale;
    if (property === "yScale") return yScale;
    if (property === "performanceMode") return performanceMode;
    if (property === "gamma") return renderer.gamma;
    if (property === "renderer") return renderer;
    if (property === "isDestroyed") return isDestroyed;
    if (property === "isPointsDrawn") return isPointsDrawn;
    if (property === "isPointsFiltered") return isPointsFiltered;
    if (property === "isAnnotationsDrawn") return isAnnotationsDrawn;
    if (property === "zDataType") return valueZDataType;
    if (property === "wDataType") return valueWDataType;
    if (property === "spatialIndex") return spatialIndex == null ? void 0 : spatialIndex.data;
    if (property === "annotationLineColor") return annotationLineColor;
    if (property === "annotationLineWidth") return annotationLineWidth;
    if (property === "annotationHVLineLimit") return annotationHVLineLimit;
    return void 0;
  };
  const set2 = (properties = {}) => {
    checkDeprecations(properties);
    if (properties.backgroundColor !== void 0 || properties.background !== void 0) {
      setBackgroundColor(properties.backgroundColor || properties.background);
    }
    if (properties.backgroundImage !== void 0) {
      setBackgroundImage(properties.backgroundImage);
    }
    if (properties.cameraTarget !== void 0) {
      setCameraTarget(properties.cameraTarget);
    }
    if (properties.cameraDistance !== void 0) {
      setCameraDistance(properties.cameraDistance);
    }
    if (properties.cameraRotation !== void 0) {
      setCameraRotation(properties.cameraRotation);
    }
    if (properties.cameraView !== void 0) {
      setCameraView(properties.cameraView);
    }
    if (properties.colorBy !== void 0) {
      setColorBy(properties.colorBy);
    }
    if (properties.pointColor !== void 0) {
      setPointColor(properties.pointColor);
    }
    if (properties.pointColorActive !== void 0) {
      setPointColorActive(properties.pointColorActive);
    }
    if (properties.pointColorHover !== void 0) {
      setPointColorHover(properties.pointColorHover);
    }
    if (properties.pointSize !== void 0) {
      setPointSize(properties.pointSize);
    }
    if (properties.pointSizeSelected !== void 0) {
      setPointSizeSelected(properties.pointSizeSelected);
    }
    if (properties.pointSizeMouseDetection !== void 0) {
      setPointSizeMouseDetection(properties.pointSizeMouseDetection);
    }
    if (properties.sizeBy !== void 0) {
      setSizeBy(properties.sizeBy);
    }
    if (properties.opacity !== void 0) {
      setOpacity(properties.opacity);
    }
    if (properties.showPointConnections !== void 0) {
      setShowPointConnections(properties.showPointConnections);
    }
    if (properties.pointConnectionColor !== void 0) {
      setPointConnectionColor(properties.pointConnectionColor);
    }
    if (properties.pointConnectionColorActive !== void 0) {
      setPointConnectionColorActive(properties.pointConnectionColorActive);
    }
    if (properties.pointConnectionColorHover !== void 0) {
      setPointConnectionColorHover(properties.pointConnectionColorHover);
    }
    if (properties.pointConnectionColorBy !== void 0) {
      setPointConnectionColorBy(properties.pointConnectionColorBy);
    }
    if (properties.pointConnectionOpacityBy !== void 0) {
      setPointConnectionOpacityBy(properties.pointConnectionOpacityBy);
    }
    if (properties.pointConnectionOpacity !== void 0) {
      setPointConnectionOpacity(properties.pointConnectionOpacity);
    }
    if (properties.pointConnectionOpacityActive !== void 0) {
      setPointConnectionOpacityActive(properties.pointConnectionOpacityActive);
    }
    if (properties.pointConnectionSize !== void 0) {
      setPointConnectionSize(properties.pointConnectionSize);
    }
    if (properties.pointConnectionSizeActive !== void 0) {
      setPointConnectionSizeActive(properties.pointConnectionSizeActive);
    }
    if (properties.pointConnectionSizeBy !== void 0) {
      setPointConnectionSizeBy(properties.pointConnectionSizeBy);
    }
    if (properties.pointConnectionMaxIntPointsPerSegment !== void 0) {
      setPointConnectionMaxIntPointsPerSegment(
        properties.pointConnectionMaxIntPointsPerSegment
      );
    }
    if (properties.pointConnectionTolerance !== void 0) {
      setPointConnectionTolerance(properties.pointConnectionTolerance);
    }
    if (properties.opacityBy !== void 0) {
      setOpacityBy(properties.opacityBy);
    }
    if (properties.lassoColor !== void 0) {
      setLassoColor(properties.lassoColor);
    }
    if (properties.lassoLineWidth !== void 0) {
      setLassoLineWidth(properties.lassoLineWidth);
    }
    if (properties.lassoMinDelay !== void 0) {
      setLassoMinDelay(properties.lassoMinDelay);
    }
    if (properties.lassoMinDist !== void 0) {
      setLassoMinDist(properties.lassoMinDist);
    }
    if (properties.lassoClearEvent !== void 0) {
      setLassoClearEvent(properties.lassoClearEvent);
    }
    if (properties.lassoInitiator !== void 0) {
      setLassoInitiator(properties.lassoInitiator);
    }
    if (properties.lassoInitiatorParentElement !== void 0) {
      setLassoInitiatorParentElement(properties.lassoInitiatorParentElement);
    }
    if (properties.lassoOnLongPress !== void 0) {
      setLassoOnLongPress(properties.lassoOnLongPress);
    }
    if (properties.lassoLongPressTime !== void 0) {
      setLassoLongPressTime(properties.lassoLongPressTime);
    }
    if (properties.lassoLongPressAfterEffectTime !== void 0) {
      setLassoLongPressAfterEffectTime(
        properties.lassoLongPressAfterEffectTime
      );
    }
    if (properties.lassoLongPressEffectDelay !== void 0) {
      setLassoLongPressEffectDelay(properties.lassoLongPressEffectDelay);
    }
    if (properties.lassoLongPressRevertEffectTime !== void 0) {
      setLassoLongPressRevertEffectTime(
        properties.lassoLongPressRevertEffectTime
      );
    }
    if (properties.keyMap !== void 0) {
      setKeyMap(properties.keyMap);
    }
    if (properties.mouseMode !== void 0) {
      setMouseMode(properties.mouseMode);
    }
    if (properties.showReticle !== void 0) {
      setShowReticle(properties.showReticle);
    }
    if (properties.reticleColor !== void 0) {
      setReticleColor(properties.reticleColor);
    }
    if (properties.pointOutlineWidth !== void 0) {
      setPointOutlineWidth(properties.pointOutlineWidth);
    }
    if (properties.height !== void 0) {
      setHeight(properties.height);
    }
    if (properties.width !== void 0) {
      setWidth(properties.width);
    }
    if (properties.aspectRatio !== void 0) {
      setDataAspectRatio(properties.aspectRatio);
    }
    if (properties.xScale !== void 0) {
      setXScale(properties.xScale);
    }
    if (properties.yScale !== void 0) {
      setYScale(properties.yScale);
    }
    if (properties.deselectOnDblClick !== void 0) {
      setDeselectOnDblClick(properties.deselectOnDblClick);
    }
    if (properties.deselectOnEscape !== void 0) {
      setDeselectOnEscape(properties.deselectOnEscape);
    }
    if (properties.opacityByDensityFill !== void 0) {
      setOpacityByDensityFill(properties.opacityByDensityFill);
    }
    if (properties.opacityInactiveMax !== void 0) {
      setOpacityInactiveMax(properties.opacityInactiveMax);
    }
    if (properties.opacityInactiveScale !== void 0) {
      setOpacityInactiveScale(properties.opacityInactiveScale);
    }
    if (properties.gamma !== void 0) {
      setGamma(properties.gamma);
    }
    if (properties.annotationLineColor !== void 0) {
      setAnnotationLineColor(properties.annotationLineColor);
    }
    if (properties.annotationLineWidth !== void 0) {
      setAnnotationLineWidth(properties.annotationLineWidth);
    }
    if (properties.annotationHVLineLimit !== void 0) {
      setAnnotationHVLineLimit(properties.annotationHVLineLimit);
    }
    return new Promise((resolve2) => {
      window.requestAnimationFrame(() => {
        if (!canvas) return;
        updateViewAspectRatio();
        camera.refresh();
        renderer.refresh();
        draw2 = true;
        resolve2();
      });
    });
  };
  const view = (cameraView, { preventEvent = false } = {}) => {
    setCameraView(cameraView);
    draw2 = true;
    preventEventView = preventEvent;
  };
  const initCamera = () => {
    if (!camera)
      camera = dom2dCamera(canvas, { isPanInverted: [false, true] });
    if (initialProperties.cameraView) {
      camera.setView(clone$1(initialProperties.cameraView));
    } else if (initialProperties.cameraTarget || initialProperties.cameraDistance || initialProperties.cameraRotation) {
      camera.lookAt(
        [...initialProperties.cameraTarget || DEFAULT_TARGET],
        initialProperties.cameraDistance || DEFAULT_DISTANCE,
        initialProperties.cameraRotation || DEFAULT_ROTATION
      );
    } else {
      camera.setView(clone$1(DEFAULT_VIEW));
    }
    topRightNdc = getScatterGlPos(1, 1);
    bottomLeftNdc = getScatterGlPos(-1, -1);
  };
  const reset = ({ preventEvent = false } = {}) => {
    initCamera();
    updateScales();
    if (preventEvent) return;
    pubSub.publish("view", {
      view: camera.view,
      camera,
      xScale,
      yScale
    });
  };
  const keyUpHandler = ({ key }) => {
    switch (key) {
      case "Escape":
        if (deselectOnEscape) deselect();
        break;
    }
  };
  const mouseEnterCanvasHandler = () => {
    isMouseInCanvas = true;
    isMouseOverCanvasChecked = true;
  };
  const mouseLeaveCanvasHandler = () => {
    hover();
    isMouseInCanvas = false;
    isMouseOverCanvasChecked = true;
    draw2 = true;
  };
  const wheelHandler = () => {
    draw2 = true;
  };
  const clearPoints = () => {
    setPoints([]);
    pointConnections.clear();
  };
  const clearPointConnections = () => {
    pointConnections.clear();
  };
  const clearAnnotations = () => {
    drawAnnotations([]);
  };
  const clear = () => {
    clearPoints();
    clearAnnotations();
  };
  const resizeHandler = () => {
    camera.refresh();
    const autoWidth = width === AUTO;
    const autoHeight = height2 === AUTO;
    if (autoWidth || autoHeight) {
      const { width: newWidth, height: newHeight } = canvas.getBoundingClientRect();
      if (autoWidth) setCurrentWidth(newWidth);
      if (autoHeight) setCurrentHeight(newHeight);
      updateViewAspectRatio();
      draw2 = true;
    }
  };
  const exportFn = () => canvas.getContext("2d").getImageData(0, 0, canvas.width, canvas.height);
  const init = () => {
    updateViewAspectRatio();
    initCamera();
    updateScales();
    lasso = createLine$1(renderer.regl, {
      color: lassoColor,
      width: lassoLineWidth,
      is2d: true
    });
    pointConnections = createLine$1(renderer.regl, {
      color: getColors(
        pointConnectionColor,
        pointConnectionColorActive,
        pointConnectionColorHover
      ),
      opacity: pointConnectionOpacity === null ? null : pointConnectionOpacity[0],
      width: pointConnectionSize[0],
      is2d: true
    });
    reticleHLine = createLine$1(renderer.regl, {
      color: reticleColor,
      width: 1,
      is2d: true
    });
    reticleVLine = createLine$1(renderer.regl, {
      color: reticleColor,
      width: 1,
      is2d: true
    });
    annotations = createLine$1(renderer.regl, {
      color: annotationLineColor,
      width: annotationLineWidth,
      is2d: true
    });
    computePointSizeMouseDetection();
    canvas.addEventListener("wheel", wheelHandler);
    normalPointsIndexBuffer = renderer.regl.buffer();
    selectedPointsIndexBuffer = renderer.regl.buffer();
    hoveredPointIndexBuffer = renderer.regl.buffer({
      usage: "dynamic",
      type: "float",
      length: FLOAT_BYTES * 2
      // This buffer is fixed to exactly 1 point consisting of 2 coordinates
    });
    colorTex = createColorTexture();
    encodingTex = createEncodingTexture();
    const whenSet = set2({
      backgroundImage,
      width,
      height: height2,
      keyMap
    });
    updateLassoInitiatorStyle();
    updateLassoLongPressIndicatorStyle();
    window.addEventListener("keyup", keyUpHandler, false);
    window.addEventListener("blur", blurHandler, false);
    window.addEventListener("mouseup", mouseUpHandler, false);
    window.addEventListener("mousemove", mouseMoveHandler, false);
    canvas.addEventListener("mousedown", mouseDownHandler, false);
    canvas.addEventListener("mouseenter", mouseEnterCanvasHandler, false);
    canvas.addEventListener("mouseleave", mouseLeaveCanvasHandler, false);
    canvas.addEventListener("click", mouseClickHandler, false);
    canvas.addEventListener("dblclick", mouseDblClickHandler, false);
    if ("ResizeObserver" in window) {
      canvasObserver = new ResizeObserver(resizeHandler);
      canvasObserver.observe(canvas);
    } else {
      window.addEventListener("resize", resizeHandler);
      window.addEventListener("orientationchange", resizeHandler);
    }
    whenSet.then(() => {
      pubSub.publish("init");
    });
  };
  const cancelFrameListener = renderer.onFrame(() => {
    isViewChanged = camera.tick();
    if (!(isPointsDrawn || isAnnotationsDrawn) || !(draw2 || isTransitioning))
      return;
    if (isTransitioning && !tween(transitionDuration, transitionEasing))
      endTransition();
    if (isViewChanged) {
      topRightNdc = getScatterGlPos(1, 1);
      bottomLeftNdc = getScatterGlPos(-1, -1);
      if (opacityBy === "density") getNumPointsInViewDb();
    }
    renderer.render(() => {
      const widthRatio = canvas.width / renderer.canvas.width;
      const heightRatio = canvas.height / renderer.canvas.height;
      updateProjectionMatrix(widthRatio, heightRatio);
      if (backgroundImage && backgroundImage._reglType) {
        drawBackgroundImage();
      }
      if (lassoPointsCurr.length > 2) drawPolygon2d();
      if (!isTransitioning) {
        pointConnections.draw({
          projection: getProjection(),
          model: getModel(),
          view: getView()
        });
      }
      if (isPointsDrawn) drawPointBodies();
      if (!mouseDown && (showReticle || drawReticleOnce)) drawReticle();
      if (hoveredPoint >= 0) drawHoveredPoint();
      if (selectedPoints.length) drawSelectedPoints();
      annotations.draw({
        projection: getProjection(),
        model: getModel(),
        view: getView()
      });
      lasso.draw({
        projection: getProjection(),
        model: getModel(),
        view: getView()
      });
    }, canvas);
    const renderView = {
      view: camera.view,
      camera,
      xScale,
      yScale
    };
    if (isViewChanged) {
      updateScales();
      if (preventEventView) {
        preventEventView = false;
      } else {
        pubSub.publish("view", renderView);
      }
    }
    draw2 = false;
    drawReticleOnce = false;
    pubSub.publish("drawing", renderView, { async: false });
    pubSub.publish("draw", renderView);
  });
  const redraw = () => {
    draw2 = true;
  };
  const destroy3 = () => {
    isPointsDrawn = false;
    isAnnotationsDrawn = false;
    isDestroyed = true;
    cancelFrameListener();
    window.removeEventListener("keyup", keyUpHandler, false);
    window.removeEventListener("blur", blurHandler, false);
    window.removeEventListener("mouseup", mouseUpHandler, false);
    window.removeEventListener("mousemove", mouseMoveHandler, false);
    canvas.removeEventListener("mousedown", mouseDownHandler, false);
    canvas.removeEventListener("mouseenter", mouseEnterCanvasHandler, false);
    canvas.removeEventListener("mouseleave", mouseLeaveCanvasHandler, false);
    canvas.removeEventListener("click", mouseClickHandler, false);
    canvas.removeEventListener("dblclick", mouseDblClickHandler, false);
    canvas.removeEventListener("wheel", wheelHandler, false);
    if (canvasObserver) {
      canvasObserver.disconnect();
    } else {
      window.removeEventListener("resize", resizeHandler);
      window.removeEventListener("orientationchange", resizeHandler);
    }
    canvas = void 0;
    camera.dispose();
    camera = void 0;
    lasso.destroy();
    lassoManager.destroy();
    pointConnections.destroy();
    reticleHLine.destroy();
    reticleVLine.destroy();
    if (!initialProperties.renderer && !renderer.isDestroyed) {
      renderer.destroy();
    }
    pubSub.publish("destroy");
    pubSub.clear();
  };
  init();
  return {
    /**
     * Get whether the browser supports all necessary WebGL features
     * @return {boolean} If `true` the browser supports all necessary WebGL features
     */
    get isSupported() {
      return renderer.isSupported;
    },
    clear: withDraw(clear),
    clearPoints: withDraw(clearPoints),
    clearPointConnections: withDraw(clearPointConnections),
    clearAnnotations: withDraw(clearAnnotations),
    createTextureFromUrl: (url, timeout2 = DEFAULT_IMAGE_LOAD_TIMEOUT) => createTextureFromUrl(renderer.regl, url, timeout2),
    deselect,
    destroy: destroy3,
    draw: publicDraw,
    drawAnnotations,
    filter,
    get: get2,
    getScreenPosition,
    hover,
    redraw,
    refresh: renderer.refresh,
    reset: withDraw(reset),
    select,
    set: set2,
    export: exportFn,
    subscribe: pubSub.subscribe,
    unfilter,
    unsubscribe: pubSub.unsubscribe,
    view,
    zoomToLocation,
    zoomToArea,
    zoomToPoints,
    zoomToOrigin
  };
};
/*! @license DOMPurify 3.2.6 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.6/LICENSE */
const {
  entries,
  setPrototypeOf,
  isFrozen,
  getPrototypeOf,
  getOwnPropertyDescriptor
} = Object;
let {
  freeze,
  seal,
  create
} = Object;
let {
  apply: apply$2,
  construct
} = typeof Reflect !== "undefined" && Reflect;
if (!freeze) {
  freeze = function freeze2(x3) {
    return x3;
  };
}
if (!seal) {
  seal = function seal2(x3) {
    return x3;
  };
}
if (!apply$2) {
  apply$2 = function apply2(fun, thisValue, args) {
    return fun.apply(thisValue, args);
  };
}
if (!construct) {
  construct = function construct2(Func, args) {
    return new Func(...args);
  };
}
const arrayForEach = unapply(Array.prototype.forEach);
const arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
const arrayPop = unapply(Array.prototype.pop);
const arrayPush = unapply(Array.prototype.push);
const arraySplice = unapply(Array.prototype.splice);
const stringToLowerCase = unapply(String.prototype.toLowerCase);
const stringToString = unapply(String.prototype.toString);
const stringMatch = unapply(String.prototype.match);
const stringReplace = unapply(String.prototype.replace);
const stringIndexOf = unapply(String.prototype.indexOf);
const stringTrim = unapply(String.prototype.trim);
const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
const regExpTest = unapply(RegExp.prototype.test);
const typeErrorCreate = unconstruct(TypeError);
function unapply(func) {
  return function(thisArg) {
    if (thisArg instanceof RegExp) {
      thisArg.lastIndex = 0;
    }
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return apply$2(func, thisArg, args);
  };
}
function unconstruct(func) {
  return function() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return construct(func, args);
  };
}
function addToSet(set2, array) {
  let transformCaseFunc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : stringToLowerCase;
  if (setPrototypeOf) {
    setPrototypeOf(set2, null);
  }
  let l = array.length;
  while (l--) {
    let element = array[l];
    if (typeof element === "string") {
      const lcElement = transformCaseFunc(element);
      if (lcElement !== element) {
        if (!isFrozen(array)) {
          array[l] = lcElement;
        }
        element = lcElement;
      }
    }
    set2[element] = true;
  }
  return set2;
}
function cleanArray(array) {
  for (let index2 = 0; index2 < array.length; index2++) {
    const isPropertyExist = objectHasOwnProperty(array, index2);
    if (!isPropertyExist) {
      array[index2] = null;
    }
  }
  return array;
}
function clone(object) {
  const newObject = create(null);
  for (const [property, value2] of entries(object)) {
    const isPropertyExist = objectHasOwnProperty(object, property);
    if (isPropertyExist) {
      if (Array.isArray(value2)) {
        newObject[property] = cleanArray(value2);
      } else if (value2 && typeof value2 === "object" && value2.constructor === Object) {
        newObject[property] = clone(value2);
      } else {
        newObject[property] = value2;
      }
    }
  }
  return newObject;
}
function lookupGetter(object, prop) {
  while (object !== null) {
    const desc = getOwnPropertyDescriptor(object, prop);
    if (desc) {
      if (desc.get) {
        return unapply(desc.get);
      }
      if (typeof desc.value === "function") {
        return unapply(desc.value);
      }
    }
    object = getPrototypeOf(object);
  }
  function fallbackValue() {
    return null;
  }
  return fallbackValue;
}
const html$1 = freeze(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]);
const svg$1 = freeze(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]);
const svgFilters = freeze(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]);
const svgDisallowed = freeze(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]);
const mathMl$1 = freeze(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]);
const mathMlDisallowed = freeze(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]);
const text = freeze(["#text"]);
const html = freeze(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]);
const svg = freeze(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]);
const mathMl = freeze(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]);
const xml = freeze(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]);
const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm);
const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
const TMPLIT_EXPR = seal(/\$\{[\w\W]*/gm);
const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/);
const ARIA_ATTR = seal(/^aria-[\-\w]+$/);
const IS_ALLOWED_URI = seal(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
);
const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
const ATTR_WHITESPACE = seal(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
);
const DOCTYPE_NAME = seal(/^html$/i);
const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
var EXPRESSIONS = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR,
  ATTR_WHITESPACE,
  CUSTOM_ELEMENT,
  DATA_ATTR,
  DOCTYPE_NAME,
  ERB_EXPR,
  IS_ALLOWED_URI,
  IS_SCRIPT_OR_DATA,
  MUSTACHE_EXPR,
  TMPLIT_EXPR
});
const NODE_TYPE = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
};
const getGlobal = function getGlobal2() {
  return typeof window === "undefined" ? null : window;
};
const _createTrustedTypesPolicy = function _createTrustedTypesPolicy2(trustedTypes, purifyHostElement) {
  if (typeof trustedTypes !== "object" || typeof trustedTypes.createPolicy !== "function") {
    return null;
  }
  let suffix = null;
  const ATTR_NAME = "data-tt-policy-suffix";
  if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) {
    suffix = purifyHostElement.getAttribute(ATTR_NAME);
  }
  const policyName = "dompurify" + (suffix ? "#" + suffix : "");
  try {
    return trustedTypes.createPolicy(policyName, {
      createHTML(html2) {
        return html2;
      },
      createScriptURL(scriptUrl) {
        return scriptUrl;
      }
    });
  } catch (_) {
    console.warn("TrustedTypes policy " + policyName + " could not be created.");
    return null;
  }
};
const _createHooksMap = function _createHooksMap2() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function createDOMPurify() {
  let window2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getGlobal();
  const DOMPurify = (root2) => createDOMPurify(root2);
  DOMPurify.version = "3.2.6";
  DOMPurify.removed = [];
  if (!window2 || !window2.document || window2.document.nodeType !== NODE_TYPE.document || !window2.Element) {
    DOMPurify.isSupported = false;
    return DOMPurify;
  }
  let {
    document: document2
  } = window2;
  const originalDocument = document2;
  const currentScript = originalDocument.currentScript;
  const {
    DocumentFragment,
    HTMLTemplateElement,
    Node: Node2,
    Element: Element3,
    NodeFilter,
    NamedNodeMap = window2.NamedNodeMap || window2.MozNamedAttrMap,
    HTMLFormElement,
    DOMParser,
    trustedTypes
  } = window2;
  const ElementPrototype = Element3.prototype;
  const cloneNode = lookupGetter(ElementPrototype, "cloneNode");
  const remove2 = lookupGetter(ElementPrototype, "remove");
  const getNextSibling = lookupGetter(ElementPrototype, "nextSibling");
  const getChildNodes = lookupGetter(ElementPrototype, "childNodes");
  const getParentNode = lookupGetter(ElementPrototype, "parentNode");
  if (typeof HTMLTemplateElement === "function") {
    const template = document2.createElement("template");
    if (template.content && template.content.ownerDocument) {
      document2 = template.content.ownerDocument;
    }
  }
  let trustedTypesPolicy;
  let emptyHTML = "";
  const {
    implementation: implementation2,
    createNodeIterator,
    createDocumentFragment,
    getElementsByTagName
  } = document2;
  const {
    importNode
  } = originalDocument;
  let hooks = _createHooksMap();
  DOMPurify.isSupported = typeof entries === "function" && typeof getParentNode === "function" && implementation2 && implementation2.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: MUSTACHE_EXPR2,
    ERB_EXPR: ERB_EXPR2,
    TMPLIT_EXPR: TMPLIT_EXPR2,
    DATA_ATTR: DATA_ATTR2,
    ARIA_ATTR: ARIA_ATTR2,
    IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA2,
    ATTR_WHITESPACE: ATTR_WHITESPACE2,
    CUSTOM_ELEMENT: CUSTOM_ELEMENT2
  } = EXPRESSIONS;
  let {
    IS_ALLOWED_URI: IS_ALLOWED_URI$1
  } = EXPRESSIONS;
  let ALLOWED_TAGS = null;
  const DEFAULT_ALLOWED_TAGS = addToSet({}, [...html$1, ...svg$1, ...svgFilters, ...mathMl$1, ...text]);
  let ALLOWED_ATTR = null;
  const DEFAULT_ALLOWED_ATTR = addToSet({}, [...html, ...svg, ...mathMl, ...xml]);
  let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
    tagNameCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    },
    attributeNameCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: false
    }
  }));
  let FORBID_TAGS = null;
  let FORBID_ATTR = null;
  let ALLOW_ARIA_ATTR = true;
  let ALLOW_DATA_ATTR = true;
  let ALLOW_UNKNOWN_PROTOCOLS = false;
  let ALLOW_SELF_CLOSE_IN_ATTR = true;
  let SAFE_FOR_TEMPLATES = false;
  let SAFE_FOR_XML = true;
  let WHOLE_DOCUMENT = false;
  let SET_CONFIG = false;
  let FORCE_BODY = false;
  let RETURN_DOM = false;
  let RETURN_DOM_FRAGMENT = false;
  let RETURN_TRUSTED_TYPE = false;
  let SANITIZE_DOM = true;
  let SANITIZE_NAMED_PROPS = false;
  const SANITIZE_NAMED_PROPS_PREFIX = "user-content-";
  let KEEP_CONTENT = true;
  let IN_PLACE = false;
  let USE_PROFILES = {};
  let FORBID_CONTENTS = null;
  const DEFAULT_FORBID_CONTENTS = addToSet({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let DATA_URI_TAGS = null;
  const DEFAULT_DATA_URI_TAGS = addToSet({}, ["audio", "video", "img", "source", "image", "track"]);
  let URI_SAFE_ATTRIBUTES = null;
  const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]);
  const MATHML_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
  const SVG_NAMESPACE = "http://www.w3.org/2000/svg";
  const HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
  let NAMESPACE = HTML_NAMESPACE;
  let IS_EMPTY_INPUT = false;
  let ALLOWED_NAMESPACES = null;
  const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);
  let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ["mi", "mo", "mn", "ms", "mtext"]);
  let HTML_INTEGRATION_POINTS = addToSet({}, ["annotation-xml"]);
  const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ["title", "style", "font", "a", "script"]);
  let PARSER_MEDIA_TYPE = null;
  const SUPPORTED_PARSER_MEDIA_TYPES = ["application/xhtml+xml", "text/html"];
  const DEFAULT_PARSER_MEDIA_TYPE = "text/html";
  let transformCaseFunc = null;
  let CONFIG = null;
  const formElement = document2.createElement("form");
  const isRegexOrFunction = function isRegexOrFunction2(testValue) {
    return testValue instanceof RegExp || testValue instanceof Function;
  };
  const _parseConfig = function _parseConfig2() {
    let cfg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (CONFIG && CONFIG === cfg) {
      return;
    }
    if (!cfg || typeof cfg !== "object") {
      cfg = {};
    }
    cfg = clone(cfg);
    PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
    SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
    transformCaseFunc = PARSER_MEDIA_TYPE === "application/xhtml+xml" ? stringToString : stringToLowerCase;
    ALLOWED_TAGS = objectHasOwnProperty(cfg, "ALLOWED_TAGS") ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
    ALLOWED_ATTR = objectHasOwnProperty(cfg, "ALLOWED_ATTR") ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
    ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, "ALLOWED_NAMESPACES") ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
    URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, "ADD_URI_SAFE_ATTR") ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
    DATA_URI_TAGS = objectHasOwnProperty(cfg, "ADD_DATA_URI_TAGS") ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
    FORBID_CONTENTS = objectHasOwnProperty(cfg, "FORBID_CONTENTS") ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
    FORBID_TAGS = objectHasOwnProperty(cfg, "FORBID_TAGS") ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : clone({});
    FORBID_ATTR = objectHasOwnProperty(cfg, "FORBID_ATTR") ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : clone({});
    USE_PROFILES = objectHasOwnProperty(cfg, "USE_PROFILES") ? cfg.USE_PROFILES : false;
    ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false;
    ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false;
    ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false;
    ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false;
    SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false;
    SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false;
    WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false;
    RETURN_DOM = cfg.RETURN_DOM || false;
    RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false;
    RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false;
    FORCE_BODY = cfg.FORCE_BODY || false;
    SANITIZE_DOM = cfg.SANITIZE_DOM !== false;
    SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false;
    KEEP_CONTENT = cfg.KEEP_CONTENT !== false;
    IN_PLACE = cfg.IN_PLACE || false;
    IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
    NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
    MATHML_TEXT_INTEGRATION_POINTS = cfg.MATHML_TEXT_INTEGRATION_POINTS || MATHML_TEXT_INTEGRATION_POINTS;
    HTML_INTEGRATION_POINTS = cfg.HTML_INTEGRATION_POINTS || HTML_INTEGRATION_POINTS;
    CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
    if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
      CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
    }
    if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
      CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
    }
    if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === "boolean") {
      CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
    }
    if (SAFE_FOR_TEMPLATES) {
      ALLOW_DATA_ATTR = false;
    }
    if (RETURN_DOM_FRAGMENT) {
      RETURN_DOM = true;
    }
    if (USE_PROFILES) {
      ALLOWED_TAGS = addToSet({}, text);
      ALLOWED_ATTR = [];
      if (USE_PROFILES.html === true) {
        addToSet(ALLOWED_TAGS, html$1);
        addToSet(ALLOWED_ATTR, html);
      }
      if (USE_PROFILES.svg === true) {
        addToSet(ALLOWED_TAGS, svg$1);
        addToSet(ALLOWED_ATTR, svg);
        addToSet(ALLOWED_ATTR, xml);
      }
      if (USE_PROFILES.svgFilters === true) {
        addToSet(ALLOWED_TAGS, svgFilters);
        addToSet(ALLOWED_ATTR, svg);
        addToSet(ALLOWED_ATTR, xml);
      }
      if (USE_PROFILES.mathMl === true) {
        addToSet(ALLOWED_TAGS, mathMl$1);
        addToSet(ALLOWED_ATTR, mathMl);
        addToSet(ALLOWED_ATTR, xml);
      }
    }
    if (cfg.ADD_TAGS) {
      if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
        ALLOWED_TAGS = clone(ALLOWED_TAGS);
      }
      addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
    }
    if (cfg.ADD_ATTR) {
      if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
        ALLOWED_ATTR = clone(ALLOWED_ATTR);
      }
      addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
    }
    if (cfg.ADD_URI_SAFE_ATTR) {
      addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
    }
    if (cfg.FORBID_CONTENTS) {
      if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
        FORBID_CONTENTS = clone(FORBID_CONTENTS);
      }
      addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
    }
    if (KEEP_CONTENT) {
      ALLOWED_TAGS["#text"] = true;
    }
    if (WHOLE_DOCUMENT) {
      addToSet(ALLOWED_TAGS, ["html", "head", "body"]);
    }
    if (ALLOWED_TAGS.table) {
      addToSet(ALLOWED_TAGS, ["tbody"]);
      delete FORBID_TAGS.tbody;
    }
    if (cfg.TRUSTED_TYPES_POLICY) {
      if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== "function") {
        throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      }
      if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== "function") {
        throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      }
      trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
      emptyHTML = trustedTypesPolicy.createHTML("");
    } else {
      if (trustedTypesPolicy === void 0) {
        trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
      }
      if (trustedTypesPolicy !== null && typeof emptyHTML === "string") {
        emptyHTML = trustedTypesPolicy.createHTML("");
      }
    }
    if (freeze) {
      freeze(cfg);
    }
    CONFIG = cfg;
  };
  const ALL_SVG_TAGS = addToSet({}, [...svg$1, ...svgFilters, ...svgDisallowed]);
  const ALL_MATHML_TAGS = addToSet({}, [...mathMl$1, ...mathMlDisallowed]);
  const _checkValidNamespace = function _checkValidNamespace2(element) {
    let parent = getParentNode(element);
    if (!parent || !parent.tagName) {
      parent = {
        namespaceURI: NAMESPACE,
        tagName: "template"
      };
    }
    const tagName = stringToLowerCase(element.tagName);
    const parentTagName = stringToLowerCase(parent.tagName);
    if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
      return false;
    }
    if (element.namespaceURI === SVG_NAMESPACE) {
      if (parent.namespaceURI === HTML_NAMESPACE) {
        return tagName === "svg";
      }
      if (parent.namespaceURI === MATHML_NAMESPACE) {
        return tagName === "svg" && (parentTagName === "annotation-xml" || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
      }
      return Boolean(ALL_SVG_TAGS[tagName]);
    }
    if (element.namespaceURI === MATHML_NAMESPACE) {
      if (parent.namespaceURI === HTML_NAMESPACE) {
        return tagName === "math";
      }
      if (parent.namespaceURI === SVG_NAMESPACE) {
        return tagName === "math" && HTML_INTEGRATION_POINTS[parentTagName];
      }
      return Boolean(ALL_MATHML_TAGS[tagName]);
    }
    if (element.namespaceURI === HTML_NAMESPACE) {
      if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
        return false;
      }
      if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
        return false;
      }
      return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
    }
    if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && ALLOWED_NAMESPACES[element.namespaceURI]) {
      return true;
    }
    return false;
  };
  const _forceRemove = function _forceRemove2(node) {
    arrayPush(DOMPurify.removed, {
      element: node
    });
    try {
      getParentNode(node).removeChild(node);
    } catch (_) {
      remove2(node);
    }
  };
  const _removeAttribute = function _removeAttribute2(name2, element) {
    try {
      arrayPush(DOMPurify.removed, {
        attribute: element.getAttributeNode(name2),
        from: element
      });
    } catch (_) {
      arrayPush(DOMPurify.removed, {
        attribute: null,
        from: element
      });
    }
    element.removeAttribute(name2);
    if (name2 === "is") {
      if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
        try {
          _forceRemove(element);
        } catch (_) {
        }
      } else {
        try {
          element.setAttribute(name2, "");
        } catch (_) {
        }
      }
    }
  };
  const _initDocument = function _initDocument2(dirty) {
    let doc = null;
    let leadingWhitespace = null;
    if (FORCE_BODY) {
      dirty = "<remove></remove>" + dirty;
    } else {
      const matches = stringMatch(dirty, /^[\r\n\t ]+/);
      leadingWhitespace = matches && matches[0];
    }
    if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && NAMESPACE === HTML_NAMESPACE) {
      dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + "</body></html>";
    }
    const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
    if (NAMESPACE === HTML_NAMESPACE) {
      try {
        doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
      } catch (_) {
      }
    }
    if (!doc || !doc.documentElement) {
      doc = implementation2.createDocument(NAMESPACE, "template", null);
      try {
        doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
      } catch (_) {
      }
    }
    const body = doc.body || doc.documentElement;
    if (dirty && leadingWhitespace) {
      body.insertBefore(document2.createTextNode(leadingWhitespace), body.childNodes[0] || null);
    }
    if (NAMESPACE === HTML_NAMESPACE) {
      return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? "html" : "body")[0];
    }
    return WHOLE_DOCUMENT ? doc.documentElement : body;
  };
  const _createNodeIterator = function _createNodeIterator2(root2) {
    return createNodeIterator.call(
      root2.ownerDocument || root2,
      root2,
      // eslint-disable-next-line no-bitwise
      NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION,
      null
    );
  };
  const _isClobbered = function _isClobbered2(element) {
    return element instanceof HTMLFormElement && (typeof element.nodeName !== "string" || typeof element.textContent !== "string" || typeof element.removeChild !== "function" || !(element.attributes instanceof NamedNodeMap) || typeof element.removeAttribute !== "function" || typeof element.setAttribute !== "function" || typeof element.namespaceURI !== "string" || typeof element.insertBefore !== "function" || typeof element.hasChildNodes !== "function");
  };
  const _isNode = function _isNode2(value2) {
    return typeof Node2 === "function" && value2 instanceof Node2;
  };
  function _executeHooks(hooks2, currentNode, data) {
    arrayForEach(hooks2, (hook) => {
      hook.call(DOMPurify, currentNode, data, CONFIG);
    });
  }
  const _sanitizeElements = function _sanitizeElements2(currentNode) {
    let content = null;
    _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
    if (_isClobbered(currentNode)) {
      _forceRemove(currentNode);
      return true;
    }
    const tagName = transformCaseFunc(currentNode.nodeName);
    _executeHooks(hooks.uponSanitizeElement, currentNode, {
      tagName,
      allowedTags: ALLOWED_TAGS
    });
    if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w!]/g, currentNode.innerHTML) && regExpTest(/<[/\w!]/g, currentNode.textContent)) {
      _forceRemove(currentNode);
      return true;
    }
    if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
      _forceRemove(currentNode);
      return true;
    }
    if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
      _forceRemove(currentNode);
      return true;
    }
    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
      if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
        if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) {
          return false;
        }
        if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) {
          return false;
        }
      }
      if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
        const parentNode = getParentNode(currentNode) || currentNode.parentNode;
        const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
        if (childNodes && parentNode) {
          const childCount = childNodes.length;
          for (let i3 = childCount - 1; i3 >= 0; --i3) {
            const childClone = cloneNode(childNodes[i3], true);
            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
            parentNode.insertBefore(childClone, getNextSibling(currentNode));
          }
        }
      }
      _forceRemove(currentNode);
      return true;
    }
    if (currentNode instanceof Element3 && !_checkValidNamespace(currentNode)) {
      _forceRemove(currentNode);
      return true;
    }
    if ((tagName === "noscript" || tagName === "noembed" || tagName === "noframes") && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
      _forceRemove(currentNode);
      return true;
    }
    if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
      content = currentNode.textContent;
      arrayForEach([MUSTACHE_EXPR2, ERB_EXPR2, TMPLIT_EXPR2], (expr) => {
        content = stringReplace(content, expr, " ");
      });
      if (currentNode.textContent !== content) {
        arrayPush(DOMPurify.removed, {
          element: currentNode.cloneNode()
        });
        currentNode.textContent = content;
      }
    }
    _executeHooks(hooks.afterSanitizeElements, currentNode, null);
    return false;
  };
  const _isValidAttribute = function _isValidAttribute2(lcTag, lcName, value2) {
    if (SANITIZE_DOM && (lcName === "id" || lcName === "name") && (value2 in document2 || value2 in formElement)) {
      return false;
    }
    if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR2, lcName)) ;
    else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR2, lcName)) ;
    else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
      if (
        // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        lcName === "is" && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value2) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value2))
      ) ;
      else {
        return false;
      }
    } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
    else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value2, ATTR_WHITESPACE2, ""))) ;
    else if ((lcName === "src" || lcName === "xlink:href" || lcName === "href") && lcTag !== "script" && stringIndexOf(value2, "data:") === 0 && DATA_URI_TAGS[lcTag]) ;
    else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA2, stringReplace(value2, ATTR_WHITESPACE2, ""))) ;
    else if (value2) {
      return false;
    } else ;
    return true;
  };
  const _isBasicCustomElement = function _isBasicCustomElement2(tagName) {
    return tagName !== "annotation-xml" && stringMatch(tagName, CUSTOM_ELEMENT2);
  };
  const _sanitizeAttributes = function _sanitizeAttributes2(currentNode) {
    _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
    const {
      attributes
    } = currentNode;
    if (!attributes || _isClobbered(currentNode)) {
      return;
    }
    const hookEvent = {
      attrName: "",
      attrValue: "",
      keepAttr: true,
      allowedAttributes: ALLOWED_ATTR,
      forceKeepAttr: void 0
    };
    let l = attributes.length;
    while (l--) {
      const attr = attributes[l];
      const {
        name: name2,
        namespaceURI,
        value: attrValue
      } = attr;
      const lcName = transformCaseFunc(name2);
      const initValue = attrValue;
      let value2 = name2 === "value" ? initValue : stringTrim(initValue);
      hookEvent.attrName = lcName;
      hookEvent.attrValue = value2;
      hookEvent.keepAttr = true;
      hookEvent.forceKeepAttr = void 0;
      _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
      value2 = hookEvent.attrValue;
      if (SANITIZE_NAMED_PROPS && (lcName === "id" || lcName === "name")) {
        _removeAttribute(name2, currentNode);
        value2 = SANITIZE_NAMED_PROPS_PREFIX + value2;
      }
      if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value2)) {
        _removeAttribute(name2, currentNode);
        continue;
      }
      if (hookEvent.forceKeepAttr) {
        continue;
      }
      if (!hookEvent.keepAttr) {
        _removeAttribute(name2, currentNode);
        continue;
      }
      if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value2)) {
        _removeAttribute(name2, currentNode);
        continue;
      }
      if (SAFE_FOR_TEMPLATES) {
        arrayForEach([MUSTACHE_EXPR2, ERB_EXPR2, TMPLIT_EXPR2], (expr) => {
          value2 = stringReplace(value2, expr, " ");
        });
      }
      const lcTag = transformCaseFunc(currentNode.nodeName);
      if (!_isValidAttribute(lcTag, lcName, value2)) {
        _removeAttribute(name2, currentNode);
        continue;
      }
      if (trustedTypesPolicy && typeof trustedTypes === "object" && typeof trustedTypes.getAttributeType === "function") {
        if (namespaceURI) ;
        else {
          switch (trustedTypes.getAttributeType(lcTag, lcName)) {
            case "TrustedHTML": {
              value2 = trustedTypesPolicy.createHTML(value2);
              break;
            }
            case "TrustedScriptURL": {
              value2 = trustedTypesPolicy.createScriptURL(value2);
              break;
            }
          }
        }
      }
      if (value2 !== initValue) {
        try {
          if (namespaceURI) {
            currentNode.setAttributeNS(namespaceURI, name2, value2);
          } else {
            currentNode.setAttribute(name2, value2);
          }
          if (_isClobbered(currentNode)) {
            _forceRemove(currentNode);
          } else {
            arrayPop(DOMPurify.removed);
          }
        } catch (_) {
          _removeAttribute(name2, currentNode);
        }
      }
    }
    _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
  };
  const _sanitizeShadowDOM = function _sanitizeShadowDOM2(fragment) {
    let shadowNode = null;
    const shadowIterator = _createNodeIterator(fragment);
    _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
    while (shadowNode = shadowIterator.nextNode()) {
      _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
      _sanitizeElements(shadowNode);
      _sanitizeAttributes(shadowNode);
      if (shadowNode.content instanceof DocumentFragment) {
        _sanitizeShadowDOM2(shadowNode.content);
      }
    }
    _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
  };
  DOMPurify.sanitize = function(dirty) {
    let cfg = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    let body = null;
    let importedNode = null;
    let currentNode = null;
    let returnNode = null;
    IS_EMPTY_INPUT = !dirty;
    if (IS_EMPTY_INPUT) {
      dirty = "<!-->";
    }
    if (typeof dirty !== "string" && !_isNode(dirty)) {
      if (typeof dirty.toString === "function") {
        dirty = dirty.toString();
        if (typeof dirty !== "string") {
          throw typeErrorCreate("dirty is not a string, aborting");
        }
      } else {
        throw typeErrorCreate("toString is not a function");
      }
    }
    if (!DOMPurify.isSupported) {
      return dirty;
    }
    if (!SET_CONFIG) {
      _parseConfig(cfg);
    }
    DOMPurify.removed = [];
    if (typeof dirty === "string") {
      IN_PLACE = false;
    }
    if (IN_PLACE) {
      if (dirty.nodeName) {
        const tagName = transformCaseFunc(dirty.nodeName);
        if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
          throw typeErrorCreate("root node is forbidden and cannot be sanitized in-place");
        }
      }
    } else if (dirty instanceof Node2) {
      body = _initDocument("<!---->");
      importedNode = body.ownerDocument.importNode(dirty, true);
      if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === "BODY") {
        body = importedNode;
      } else if (importedNode.nodeName === "HTML") {
        body = importedNode;
      } else {
        body.appendChild(importedNode);
      }
    } else {
      if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
      dirty.indexOf("<") === -1) {
        return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
      }
      body = _initDocument(dirty);
      if (!body) {
        return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : "";
      }
    }
    if (body && FORCE_BODY) {
      _forceRemove(body.firstChild);
    }
    const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
    while (currentNode = nodeIterator.nextNode()) {
      _sanitizeElements(currentNode);
      _sanitizeAttributes(currentNode);
      if (currentNode.content instanceof DocumentFragment) {
        _sanitizeShadowDOM(currentNode.content);
      }
    }
    if (IN_PLACE) {
      return dirty;
    }
    if (RETURN_DOM) {
      if (RETURN_DOM_FRAGMENT) {
        returnNode = createDocumentFragment.call(body.ownerDocument);
        while (body.firstChild) {
          returnNode.appendChild(body.firstChild);
        }
      } else {
        returnNode = body;
      }
      if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) {
        returnNode = importNode.call(originalDocument, returnNode, true);
      }
      return returnNode;
    }
    let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
    if (WHOLE_DOCUMENT && ALLOWED_TAGS["!doctype"] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
      serializedHTML = "<!DOCTYPE " + body.ownerDocument.doctype.name + ">\n" + serializedHTML;
    }
    if (SAFE_FOR_TEMPLATES) {
      arrayForEach([MUSTACHE_EXPR2, ERB_EXPR2, TMPLIT_EXPR2], (expr) => {
        serializedHTML = stringReplace(serializedHTML, expr, " ");
      });
    }
    return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
  };
  DOMPurify.setConfig = function() {
    let cfg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _parseConfig(cfg);
    SET_CONFIG = true;
  };
  DOMPurify.clearConfig = function() {
    CONFIG = null;
    SET_CONFIG = false;
  };
  DOMPurify.isValidAttribute = function(tag, attr, value2) {
    if (!CONFIG) {
      _parseConfig({});
    }
    const lcTag = transformCaseFunc(tag);
    const lcName = transformCaseFunc(attr);
    return _isValidAttribute(lcTag, lcName, value2);
  };
  DOMPurify.addHook = function(entryPoint, hookFunction) {
    if (typeof hookFunction !== "function") {
      return;
    }
    arrayPush(hooks[entryPoint], hookFunction);
  };
  DOMPurify.removeHook = function(entryPoint, hookFunction) {
    if (hookFunction !== void 0) {
      const index2 = arrayLastIndexOf(hooks[entryPoint], hookFunction);
      return index2 === -1 ? void 0 : arraySplice(hooks[entryPoint], index2, 1)[0];
    }
    return arrayPop(hooks[entryPoint]);
  };
  DOMPurify.removeHooks = function(entryPoint) {
    hooks[entryPoint] = [];
  };
  DOMPurify.removeAllHooks = function() {
    hooks = _createHooksMap();
  };
  return DOMPurify;
}
createDOMPurify();
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value2) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value: value2 }) : obj[key] = value2;
var __publicField = (obj, key, value2) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value2);
var HttpStatusCode$1;
(function(HttpStatusCode2) {
  HttpStatusCode2[HttpStatusCode2["CONTINUE"] = 100] = "CONTINUE";
  HttpStatusCode2[HttpStatusCode2["SWITCHING_PROTOCOLS"] = 101] = "SWITCHING_PROTOCOLS";
  HttpStatusCode2[HttpStatusCode2["PROCESSING"] = 102] = "PROCESSING";
  HttpStatusCode2[HttpStatusCode2["OK"] = 200] = "OK";
  HttpStatusCode2[HttpStatusCode2["CREATED"] = 201] = "CREATED";
  HttpStatusCode2[HttpStatusCode2["ACCEPTED"] = 202] = "ACCEPTED";
  HttpStatusCode2[HttpStatusCode2["NON_AUTHORITATIVE_INFORMATION"] = 203] = "NON_AUTHORITATIVE_INFORMATION";
  HttpStatusCode2[HttpStatusCode2["NO_CONTENT"] = 204] = "NO_CONTENT";
  HttpStatusCode2[HttpStatusCode2["RESET_CONTENT"] = 205] = "RESET_CONTENT";
  HttpStatusCode2[HttpStatusCode2["PARTIAL_CONTENT"] = 206] = "PARTIAL_CONTENT";
  HttpStatusCode2[HttpStatusCode2["MULTI_STATUS"] = 207] = "MULTI_STATUS";
  HttpStatusCode2[HttpStatusCode2["ALREADY_REPORTED"] = 208] = "ALREADY_REPORTED";
  HttpStatusCode2[HttpStatusCode2["IM_USED"] = 226] = "IM_USED";
  HttpStatusCode2[HttpStatusCode2["MULTIPLE_CHOICES"] = 300] = "MULTIPLE_CHOICES";
  HttpStatusCode2[HttpStatusCode2["MOVED_PERMANENTLY"] = 301] = "MOVED_PERMANENTLY";
  HttpStatusCode2[HttpStatusCode2["FOUND"] = 302] = "FOUND";
  HttpStatusCode2[HttpStatusCode2["SEE_OTHER"] = 303] = "SEE_OTHER";
  HttpStatusCode2[HttpStatusCode2["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
  HttpStatusCode2[HttpStatusCode2["USE_PROXY"] = 305] = "USE_PROXY";
  HttpStatusCode2[HttpStatusCode2["SWITCH_PROXY"] = 306] = "SWITCH_PROXY";
  HttpStatusCode2[HttpStatusCode2["TEMPORARY_REDIRECT"] = 307] = "TEMPORARY_REDIRECT";
  HttpStatusCode2[HttpStatusCode2["PERMANENT_REDIRECT"] = 308] = "PERMANENT_REDIRECT";
  HttpStatusCode2[HttpStatusCode2["BAD_REQUEST"] = 400] = "BAD_REQUEST";
  HttpStatusCode2[HttpStatusCode2["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
  HttpStatusCode2[HttpStatusCode2["PAYMENT_REQUIRED"] = 402] = "PAYMENT_REQUIRED";
  HttpStatusCode2[HttpStatusCode2["FORBIDDEN"] = 403] = "FORBIDDEN";
  HttpStatusCode2[HttpStatusCode2["NOT_FOUND"] = 404] = "NOT_FOUND";
  HttpStatusCode2[HttpStatusCode2["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
  HttpStatusCode2[HttpStatusCode2["NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
  HttpStatusCode2[HttpStatusCode2["PROXY_AUTHENTICATION_REQUIRED"] = 407] = "PROXY_AUTHENTICATION_REQUIRED";
  HttpStatusCode2[HttpStatusCode2["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
  HttpStatusCode2[HttpStatusCode2["CONFLICT"] = 409] = "CONFLICT";
  HttpStatusCode2[HttpStatusCode2["GONE"] = 410] = "GONE";
  HttpStatusCode2[HttpStatusCode2["LENGTH_REQUIRED"] = 411] = "LENGTH_REQUIRED";
  HttpStatusCode2[HttpStatusCode2["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
  HttpStatusCode2[HttpStatusCode2["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
  HttpStatusCode2[HttpStatusCode2["URI_TOO_LONG"] = 414] = "URI_TOO_LONG";
  HttpStatusCode2[HttpStatusCode2["UNSUPPORTED_MEDIA_TYPE"] = 415] = "UNSUPPORTED_MEDIA_TYPE";
  HttpStatusCode2[HttpStatusCode2["RANGE_NOT_SATISFIABLE"] = 416] = "RANGE_NOT_SATISFIABLE";
  HttpStatusCode2[HttpStatusCode2["EXPECTATION_FAILED"] = 417] = "EXPECTATION_FAILED";
  HttpStatusCode2[HttpStatusCode2["I_AM_A_TEAPOT"] = 418] = "I_AM_A_TEAPOT";
  HttpStatusCode2[HttpStatusCode2["MISDIRECTED_REQUEST"] = 421] = "MISDIRECTED_REQUEST";
  HttpStatusCode2[HttpStatusCode2["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
  HttpStatusCode2[HttpStatusCode2["LOCKED"] = 423] = "LOCKED";
  HttpStatusCode2[HttpStatusCode2["FAILED_DEPENDENCY"] = 424] = "FAILED_DEPENDENCY";
  HttpStatusCode2[HttpStatusCode2["UPGRADE_REQUIRED"] = 426] = "UPGRADE_REQUIRED";
  HttpStatusCode2[HttpStatusCode2["PRECONDITION_REQUIRED"] = 428] = "PRECONDITION_REQUIRED";
  HttpStatusCode2[HttpStatusCode2["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
  HttpStatusCode2[HttpStatusCode2["REQUEST_HEADER_FIELDS_TOO_LARGE"] = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE";
  HttpStatusCode2[HttpStatusCode2["UNAVAILABLE_FOR_LEGAL_REASONS"] = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS";
  HttpStatusCode2[HttpStatusCode2["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
  HttpStatusCode2[HttpStatusCode2["NOT_IMPLEMENTED"] = 501] = "NOT_IMPLEMENTED";
  HttpStatusCode2[HttpStatusCode2["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
  HttpStatusCode2[HttpStatusCode2["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
  HttpStatusCode2[HttpStatusCode2["GATEWAY_TIMEOUT"] = 504] = "GATEWAY_TIMEOUT";
  HttpStatusCode2[HttpStatusCode2["HTTP_VERSION_NOT_SUPPORTED"] = 505] = "HTTP_VERSION_NOT_SUPPORTED";
  HttpStatusCode2[HttpStatusCode2["VARIANT_ALSO_NEGOTIATES"] = 506] = "VARIANT_ALSO_NEGOTIATES";
  HttpStatusCode2[HttpStatusCode2["INSUFFICIENT_STORAGE"] = 507] = "INSUFFICIENT_STORAGE";
  HttpStatusCode2[HttpStatusCode2["LOOP_DETECTED"] = 508] = "LOOP_DETECTED";
  HttpStatusCode2[HttpStatusCode2["NOT_EXTENDED"] = 510] = "NOT_EXTENDED";
  HttpStatusCode2[HttpStatusCode2["NETWORK_AUTHENTICATION_REQUIRED"] = 511] = "NETWORK_AUTHENTICATION_REQUIRED";
})(HttpStatusCode$1 || (HttpStatusCode$1 = {}));
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
  }
}
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || _typeof(argument) === "object" && argStr === "[object Date]") {
    return new Date(argument.getTime());
  } else if (typeof argument === "number" || argStr === "[object Number]") {
    return new Date(argument);
  } else {
    if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      console.warn(new Error().stack);
    }
    return /* @__PURE__ */ new Date(NaN);
  }
}
function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return /* @__PURE__ */ new Date(NaN);
  }
  if (!amount) {
    return date;
  }
  date.setDate(date.getDate() + amount);
  return date;
}
function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return /* @__PURE__ */ new Date(NaN);
  }
  if (!amount) {
    return date;
  }
  var dayOfMonth = date.getDate();
  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    return endOfDesiredMonth;
  } else {
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}
function add(dirtyDate, duration2) {
  requiredArgs(2, arguments);
  if (!duration2 || _typeof(duration2) !== "object") return /* @__PURE__ */ new Date(NaN);
  var years = duration2.years ? toInteger(duration2.years) : 0;
  var months = duration2.months ? toInteger(duration2.months) : 0;
  var weeks = duration2.weeks ? toInteger(duration2.weeks) : 0;
  var days = duration2.days ? toInteger(duration2.days) : 0;
  var hours = duration2.hours ? toInteger(duration2.hours) : 0;
  var minutes = duration2.minutes ? toInteger(duration2.minutes) : 0;
  var seconds = duration2.seconds ? toInteger(duration2.seconds) : 0;
  var date = toDate(dirtyDate);
  var dateWithMonths = months || years ? addMonths(date, months + years * 12) : date;
  var dateWithDays = days || weeks ? addDays(dateWithMonths, days + weeks * 7) : dateWithMonths;
  var minutesToAdd = minutes + hours * 60;
  var secondsToAdd = seconds + minutesToAdd * 60;
  var msToAdd = secondsToAdd * 1e3;
  var finalDate = new Date(dateWithDays.getTime() + msToAdd);
  return finalDate;
}
function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}
function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}
var MILLISECONDS_IN_DAY$2 = 864e5;
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - getTimezoneOffsetInMilliseconds(startOfDayRight);
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY$2);
}
function compareAsc(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
  } else {
    return diff;
  }
}
var millisecondsInMinute = 6e4;
var millisecondsInHour = 36e5;
var millisecondsInSecond = 1e3;
function isDate$2(value2) {
  requiredArgs(1, arguments);
  return value2 instanceof Date || _typeof(value2) === "object" && Object.prototype.toString.call(value2) === "[object Date]";
}
function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate$2(dirtyDate) && typeof dirtyDate !== "number") {
    return false;
  }
  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}
function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}
function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() - dateRight.getFullYear();
}
function compareLocalAsc(dateLeft, dateRight) {
  var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
  } else {
    return diff;
  }
}
function differenceInDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign2 = compareLocalAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight));
  dateLeft.setDate(dateLeft.getDate() - sign2 * difference);
  var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign2);
  var result = sign2 * (difference - isLastDayNotFull);
  return result === 0 ? 0 : result;
}
function differenceInMilliseconds(dateLeft, dateRight) {
  requiredArgs(2, arguments);
  return toDate(dateLeft).getTime() - toDate(dateRight).getTime();
}
var roundingMap = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function trunc2(value2) {
    return value2 < 0 ? Math.ceil(value2) : Math.floor(value2);
  }
  // Math.trunc is not supported by IE
};
var defaultRoundingMethod = "trunc";
function getRoundingMethod(method) {
  return roundingMap[defaultRoundingMethod];
}
function differenceInHours(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInHour;
  return getRoundingMethod()(diff);
}
function differenceInMinutes(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInMinute;
  return getRoundingMethod()(diff);
}
function endOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}
function endOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}
function isLastDayOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  return endOfDay(date).getTime() === endOfMonth(date).getTime();
}
function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign2 = compareAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight));
  var result;
  if (difference < 1) {
    result = 0;
  } else {
    if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) {
      dateLeft.setDate(30);
    }
    dateLeft.setMonth(dateLeft.getMonth() - sign2 * difference);
    var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign2;
    if (isLastDayOfMonth(toDate(dirtyDateLeft)) && difference === 1 && compareAsc(dirtyDateLeft, dateRight) === 1) {
      isLastMonthNotFull = false;
    }
    result = sign2 * (difference - Number(isLastMonthNotFull));
  }
  return result === 0 ? 0 : result;
}
function differenceInSeconds(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / 1e3;
  return getRoundingMethod()(diff);
}
function differenceInYears(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign2 = compareAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarYears(dateLeft, dateRight));
  dateLeft.setFullYear(1584);
  dateRight.setFullYear(1584);
  var isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign2;
  var result = sign2 * (difference - Number(isLastYearNotFull));
  return result === 0 ? 0 : result;
}
function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}
var MILLISECONDS_IN_DAY$1 = 864e5;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY$1) + 1;
}
function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = /* @__PURE__ */ new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = /* @__PURE__ */ new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = /* @__PURE__ */ new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}
var MILLISECONDS_IN_WEEK$1 = 6048e5;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}
function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions2 = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var firstWeekOfNextYear = /* @__PURE__ */ new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = /* @__PURE__ */ new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = /* @__PURE__ */ new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}
var MILLISECONDS_IN_WEEK = 6048e5;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
function addLeadingZeros(number, targetLength) {
  var sign2 = number < 0 ? "-" : "";
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = "0" + output;
  }
  return sign2 + output;
}
var formatters$1 = {
  // Year
  y: function y3(date, token2) {
    var signedYear = date.getUTCFullYear();
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token2 === "yy" ? year % 100 : year, token2.length);
  },
  // Month
  M: function M3(date, token2) {
    var month = date.getUTCMonth();
    return token2 === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d3(date, token2) {
    return addLeadingZeros(date.getUTCDate(), token2.length);
  },
  // AM or PM
  a: function a3(date, token2) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (token2) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function h5(date, token2) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token2.length);
  },
  // Hour [0-23]
  H: function H3(date, token2) {
    return addLeadingZeros(date.getUTCHours(), token2.length);
  },
  // Minute
  m: function m3(date, token2) {
    return addLeadingZeros(date.getUTCMinutes(), token2.length);
  },
  // Second
  s: function s3(date, token2) {
    return addLeadingZeros(date.getUTCSeconds(), token2.length);
  },
  // Fraction of second
  S: function S3(date, token2) {
    var numberOfDigits = token2.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token2.length);
  }
};
var dayPeriodEnum = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
var formatters = {
  // Era
  G: function G2(date, token2, localize2) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token2) {
      case "G":
      case "GG":
      case "GGG":
        return localize2.era(era, {
          width: "abbreviated"
        });
      case "GGGGG":
        return localize2.era(era, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return localize2.era(era, {
          width: "wide"
        });
    }
  },
  // Year
  y: function y22(date, token2, localize2) {
    if (token2 === "yo") {
      var signedYear = date.getUTCFullYear();
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize2.ordinalNumber(year, {
        unit: "year"
      });
    }
    return formatters$1.y(date, token2);
  },
  // Local week-numbering year
  Y: function Y2(date, token2, localize2, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token2 === "YY") {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }
    if (token2 === "Yo") {
      return localize2.ordinalNumber(weekYear, {
        unit: "year"
      });
    }
    return addLeadingZeros(weekYear, token2.length);
  },
  // ISO week-numbering year
  R: function R2(date, token2) {
    var isoWeekYear = getUTCISOWeekYear(date);
    return addLeadingZeros(isoWeekYear, token2.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u2(date, token2) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token2.length);
  },
  // Quarter
  Q: function Q2(date, token2, localize2) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token2) {
      case "Q":
        return String(quarter);
      case "QQ":
        return addLeadingZeros(quarter, 2);
      case "Qo":
        return localize2.ordinalNumber(quarter, {
          unit: "quarter"
        });
      case "QQQ":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function q2(date, token2, localize2) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token2) {
      case "q":
        return String(quarter);
      case "qq":
        return addLeadingZeros(quarter, 2);
      case "qo":
        return localize2.ordinalNumber(quarter, {
          unit: "quarter"
        });
      case "qqq":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function M22(date, token2, localize2) {
    var month = date.getUTCMonth();
    switch (token2) {
      case "M":
      case "MM":
        return formatters$1.M(date, token2);
      case "Mo":
        return localize2.ordinalNumber(month + 1, {
          unit: "month"
        });
      case "MMM":
        return localize2.month(month, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return localize2.month(month, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return localize2.month(month, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function L2(date, token2, localize2) {
    var month = date.getUTCMonth();
    switch (token2) {
      case "L":
        return String(month + 1);
      case "LL":
        return addLeadingZeros(month + 1, 2);
      case "Lo":
        return localize2.ordinalNumber(month + 1, {
          unit: "month"
        });
      case "LLL":
        return localize2.month(month, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return localize2.month(month, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return localize2.month(month, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function w2(date, token2, localize2, options) {
    var week = getUTCWeek(date, options);
    if (token2 === "wo") {
      return localize2.ordinalNumber(week, {
        unit: "week"
      });
    }
    return addLeadingZeros(week, token2.length);
  },
  // ISO week of year
  I: function I3(date, token2, localize2) {
    var isoWeek = getUTCISOWeek(date);
    if (token2 === "Io") {
      return localize2.ordinalNumber(isoWeek, {
        unit: "week"
      });
    }
    return addLeadingZeros(isoWeek, token2.length);
  },
  // Day of the month
  d: function d22(date, token2, localize2) {
    if (token2 === "do") {
      return localize2.ordinalNumber(date.getUTCDate(), {
        unit: "date"
      });
    }
    return formatters$1.d(date, token2);
  },
  // Day of year
  D: function D2(date, token2, localize2) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token2 === "Do") {
      return localize2.ordinalNumber(dayOfYear, {
        unit: "dayOfYear"
      });
    }
    return addLeadingZeros(dayOfYear, token2.length);
  },
  // Day of week
  E: function E2(date, token2, localize2) {
    var dayOfWeek = date.getUTCDay();
    switch (token2) {
      case "E":
      case "EE":
      case "EEE":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function e2(date, token2, localize2, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token2) {
      case "e":
        return String(localDayOfWeek);
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      case "eo":
        return localize2.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "eee":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function c2(date, token2, localize2, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token2) {
      case "c":
        return String(localDayOfWeek);
      case "cc":
        return addLeadingZeros(localDayOfWeek, token2.length);
      case "co":
        return localize2.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "ccc":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function i2(date, token2, localize2) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token2) {
      case "i":
        return String(isoDayOfWeek);
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token2.length);
      case "io":
        return localize2.ordinalNumber(isoDayOfWeek, {
          unit: "day"
        });
      case "iii":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function a22(date, token2, localize2) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    switch (token2) {
      case "a":
      case "aa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b2(date, token2, localize2) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }
    switch (token2) {
      case "b":
      case "bb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B2(date, token2, localize2) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token2) {
      case "B":
      case "BB":
      case "BBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function h22(date, token2, localize2) {
    if (token2 === "ho") {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return formatters$1.h(date, token2);
  },
  // Hour [0-23]
  H: function H22(date, token2, localize2) {
    if (token2 === "Ho") {
      return localize2.ordinalNumber(date.getUTCHours(), {
        unit: "hour"
      });
    }
    return formatters$1.H(date, token2);
  },
  // Hour [0-11]
  K: function K2(date, token2, localize2) {
    var hours = date.getUTCHours() % 12;
    if (token2 === "Ko") {
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros(hours, token2.length);
  },
  // Hour [1-24]
  k: function k2(date, token2, localize2) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token2 === "ko") {
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros(hours, token2.length);
  },
  // Minute
  m: function m22(date, token2, localize2) {
    if (token2 === "mo") {
      return localize2.ordinalNumber(date.getUTCMinutes(), {
        unit: "minute"
      });
    }
    return formatters$1.m(date, token2);
  },
  // Second
  s: function s22(date, token2, localize2) {
    if (token2 === "so") {
      return localize2.ordinalNumber(date.getUTCSeconds(), {
        unit: "second"
      });
    }
    return formatters$1.s(date, token2);
  },
  // Fraction of second
  S: function S22(date, token2) {
    return formatters$1.S(date, token2);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X2(date, token2, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return "Z";
    }
    switch (token2) {
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "XXXX":
      case "XX":
        return formatTimezone$1(timezoneOffset);
      case "XXXXX":
      case "XXX":
      default:
        return formatTimezone$1(timezoneOffset, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x2(date, token2, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token2) {
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "xxxx":
      case "xx":
        return formatTimezone$1(timezoneOffset);
      case "xxxxx":
      case "xxx":
      default:
        return formatTimezone$1(timezoneOffset, ":");
    }
  },
  // Timezone (GMT)
  O: function O2(date, token2, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token2) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "OOOO":
      default:
        return "GMT" + formatTimezone$1(timezoneOffset, ":");
    }
  },
  // Timezone (specific non-location)
  z: function z2(date, token2, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token2) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "zzzz":
      default:
        return "GMT" + formatTimezone$1(timezoneOffset, ":");
    }
  },
  // Seconds timestamp
  t: function t2(date, token2, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1e3);
    return addLeadingZeros(timestamp, token2.length);
  },
  // Milliseconds timestamp
  T: function T2(date, token2, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token2.length);
  }
};
function formatTimezoneShort(offset2, dirtyDelimiter) {
  var sign2 = offset2 > 0 ? "-" : "+";
  var absOffset = Math.abs(offset2);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign2 + String(hours);
  }
  var delimiter = dirtyDelimiter;
  return sign2 + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset2, dirtyDelimiter) {
  if (offset2 % 60 === 0) {
    var sign2 = offset2 > 0 ? "-" : "+";
    return sign2 + addLeadingZeros(Math.abs(offset2) / 60, 2);
  }
  return formatTimezone$1(offset2, dirtyDelimiter);
}
function formatTimezone$1(offset2, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || "";
  var sign2 = offset2 > 0 ? "-" : "+";
  var absOffset = Math.abs(offset2);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign2 + hours + delimiter + minutes;
}
var dateLongFormatter2 = function dateLongFormatter22(pattern, formatLong2) {
  switch (pattern) {
    case "P":
      return formatLong2.date({
        width: "short"
      });
    case "PP":
      return formatLong2.date({
        width: "medium"
      });
    case "PPP":
      return formatLong2.date({
        width: "long"
      });
    case "PPPP":
    default:
      return formatLong2.date({
        width: "full"
      });
  }
};
var timeLongFormatter2 = function timeLongFormatter22(pattern, formatLong2) {
  switch (pattern) {
    case "p":
      return formatLong2.time({
        width: "short"
      });
    case "pp":
      return formatLong2.time({
        width: "medium"
      });
    case "ppp":
      return formatLong2.time({
        width: "long"
      });
    case "pppp":
    default:
      return formatLong2.time({
        width: "full"
      });
  }
};
var dateTimeLongFormatter2 = function dateTimeLongFormatter22(pattern, formatLong2) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter2(pattern, formatLong2);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong2.dateTime({
        width: "short"
      });
      break;
    case "PP":
      dateTimeFormat = formatLong2.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      dateTimeFormat = formatLong2.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong2.dateTime({
        width: "full"
      });
      break;
  }
  return dateTimeFormat.replace("{{date}}", dateLongFormatter2(datePattern, formatLong2)).replace("{{time}}", timeLongFormatter2(timePattern, formatLong2));
};
var longFormatters = {
  p: timeLongFormatter2,
  P: dateTimeLongFormatter2
};
var protectedDayOfYearTokens = ["D", "DD"];
var protectedWeekYearTokens = ["YY", "YYYY"];
function isProtectedDayOfYearToken(token2) {
  return protectedDayOfYearTokens.indexOf(token2) !== -1;
}
function isProtectedWeekYearToken(token2) {
  return protectedWeekYearTokens.indexOf(token2) !== -1;
}
function throwProtectedError(token2, format2, input) {
  if (token2 === "YYYY") {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token2 === "YY") {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token2 === "D") {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token2 === "DD") {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};
var formatDistance2 = function formatDistance22(token2, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token2];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }
  return result;
};
function buildFormatLongFn(args) {
  return function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format2 = args.formats[width] || args.formats[args.defaultWidth];
    return format2;
  };
}
var dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
};
var timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
var formatRelative2 = function formatRelative22(token2, _date, _baseDate, _options) {
  return formatRelativeLocale[token2];
};
function buildLocalizeFn(args) {
  return function(dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
    var valuesArray;
    if (context === "formatting" && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index2 = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index2];
  };
}
var eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
var quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};
var monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
};
var dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
};
var dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
var ordinalNumber2 = function ordinalNumber22(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};
var localize = {
  ordinalNumber: ordinalNumber2,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback2(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
function buildMatchFn(args) {
  return function(string) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    });
    var value2;
    value2 = args.valueCallback ? args.valueCallback(key) : key;
    value2 = options.valueCallback ? options.valueCallback(value2) : value2;
    var rest = string.slice(matchedString.length);
    return {
      value: value2,
      rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return void 0;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return void 0;
}
function buildMatchPatternFn(args) {
  return function(string) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value2 = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value2 = options.valueCallback ? options.valueCallback(value2) : value2;
    var rest = string.slice(matchedString.length);
    return {
      value: value2,
      rest
    };
  };
}
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback3(value2) {
      return parseInt(value2, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: function valueCallback22(index2) {
      return index2 + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};
var locale = {
  code: "en-US",
  formatDistance: formatDistance2,
  formatLong,
  formatRelative: formatRelative2,
  localize,
  match,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
var formattingTokensRegExp$2 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp$2 = /^'([^]*?)'?$/;
var doubleQuoteRegExp$2 = /''/g;
var unescapedLatinCharacterRegExp$2 = /[a-zA-Z]/;
function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions2 = getDefaultOptions();
  var locale$12 = (_ref = (_options$locale = void 0) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions2.locale) !== null && _ref !== void 0 ? _ref : locale;
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = void 0) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : void 0) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions2.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = void 0) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : void 0) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions2.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions2.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  if (!locale$12.localize) {
    throw new RangeError("locale must contain localize property");
  }
  if (!locale$12.formatLong) {
    throw new RangeError("locale must contain formatLong property");
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale$12,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp$1).map(function(substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale$12.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp$2).map(function(substring) {
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString$2(substring);
    }
    var formatter2 = formatters[firstCharacter];
    if (formatter2) {
      if (isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter2(utcDate, substring, locale$12.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp$2)) {
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
    }
    return substring;
  }).join("");
  return result;
}
function cleanEscapedString$2(input) {
  var matched = input.match(escapedStringRegExp$2);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp$2, "'");
}
function assign$1(target2, object) {
  if (target2 == null) {
    throw new TypeError("assign requires that input parameter not be null or undefined");
  }
  for (var property in object) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      target2[property] = object[property];
    }
  }
  return target2;
}
var defaultFormat$1 = ["years", "months", "weeks", "days", "hours", "minutes", "seconds"];
function formatDuration$2(duration2, options) {
  var _ref, _options$locale, _options$format, _options$zero, _options$delimiter;
  if (arguments.length < 1) {
    throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
  }
  var defaultOptions2 = getDefaultOptions();
  var locale$12 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions2.locale) !== null && _ref !== void 0 ? _ref : locale;
  var format2 = (_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : defaultFormat$1;
  var zero = (_options$zero = options === null || options === void 0 ? void 0 : options.zero) !== null && _options$zero !== void 0 ? _options$zero : false;
  var delimiter = (_options$delimiter = options === null || options === void 0 ? void 0 : options.delimiter) !== null && _options$delimiter !== void 0 ? _options$delimiter : " ";
  if (!locale$12.formatDistance) {
    return "";
  }
  var result = format2.reduce(function(acc, unit) {
    var token2 = "x".concat(unit.replace(/(^.)/, function(m32) {
      return m32.toUpperCase();
    }));
    var value2 = duration2[unit];
    if (typeof value2 === "number" && (zero || duration2[unit])) {
      return acc.concat(locale$12.formatDistance(token2, value2));
    }
    return acc;
  }, []).join(delimiter);
  return result;
}
function intervalToDuration(interval) {
  requiredArgs(1, arguments);
  var start = toDate(interval.start);
  var end = toDate(interval.end);
  if (isNaN(start.getTime())) throw new RangeError("Start Date is invalid");
  if (isNaN(end.getTime())) throw new RangeError("End Date is invalid");
  var duration2 = {};
  duration2.years = Math.abs(differenceInYears(end, start));
  var sign2 = compareAsc(end, start);
  var remainingMonths = add(start, {
    years: sign2 * duration2.years
  });
  duration2.months = Math.abs(differenceInMonths(end, remainingMonths));
  var remainingDays = add(remainingMonths, {
    months: sign2 * duration2.months
  });
  duration2.days = Math.abs(differenceInDays(end, remainingDays));
  var remainingHours = add(remainingDays, {
    days: sign2 * duration2.days
  });
  duration2.hours = Math.abs(differenceInHours(end, remainingHours));
  var remainingMinutes = add(remainingHours, {
    hours: sign2 * duration2.hours
  });
  duration2.minutes = Math.abs(differenceInMinutes(end, remainingMinutes));
  var remainingSeconds = add(remainingMinutes, {
    minutes: sign2 * duration2.minutes
  });
  duration2.seconds = Math.abs(differenceInSeconds(end, remainingSeconds));
  return duration2;
}
function _arrayLikeToArray(r, a32) {
  (null == a32 || a32 > r.length) && (a32 = r.length);
  for (var e22 = 0, n = Array(a32); e22 < a32; e22++) n[e22] = r[e22];
  return n;
}
function _unsupportedIterableToArray(r, a32) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a32);
    var t22 = {}.toString.call(r).slice(8, -1);
    return "Object" === t22 && r.constructor && (t22 = r.constructor.name), "Map" === t22 || "Set" === t22 ? Array.from(r) : "Arguments" === t22 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t22) ? _arrayLikeToArray(r, a32) : void 0;
  }
}
function _createForOfIteratorHelper(r, e22) {
  var t22 = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t22) {
    if (Array.isArray(r) || (t22 = _unsupportedIterableToArray(r)) || e22) {
      t22 && (r = t22);
      var _n2 = 0, F = function F2() {
      };
      return {
        s: F,
        n: function n() {
          return _n2 >= r.length ? {
            done: true
          } : {
            done: false,
            value: r[_n2++]
          };
        },
        e: function e3(r2) {
          throw r2;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o, a32 = true, u22 = false;
  return {
    s: function s32() {
      t22 = t22.call(r);
    },
    n: function n() {
      var r2 = t22.next();
      return a32 = r2.done, r2;
    },
    e: function e3(r2) {
      u22 = true, o = r2;
    },
    f: function f() {
      try {
        a32 || null == t22["return"] || t22["return"]();
      } finally {
        if (u22) throw o;
      }
    }
  };
}
function _assertThisInitialized(e22) {
  if (void 0 === e22) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e22;
}
function _setPrototypeOf(t22, e22) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t3, e3) {
    return t3.__proto__ = e3, t3;
  }, _setPrototypeOf(t22, e22);
}
function _inherits(t22, e22) {
  if ("function" != typeof e22 && null !== e22) throw new TypeError("Super expression must either be null or a function");
  t22.prototype = Object.create(e22 && e22.prototype, {
    constructor: {
      value: t22,
      writable: true,
      configurable: true
    }
  }), Object.defineProperty(t22, "prototype", {
    writable: false
  }), e22 && _setPrototypeOf(t22, e22);
}
function _getPrototypeOf(t22) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t3) {
    return t3.__proto__ || Object.getPrototypeOf(t3);
  }, _getPrototypeOf(t22);
}
function _isNativeReflectConstruct() {
  try {
    var t22 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t3) {
  }
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct2() {
    return !!t22;
  })();
}
function _possibleConstructorReturn(t22, e22) {
  if (e22 && ("object" == _typeof(e22) || "function" == typeof e22)) return e22;
  if (void 0 !== e22) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t22);
}
function _createSuper(t22) {
  var r = _isNativeReflectConstruct();
  return function() {
    var e22, o = _getPrototypeOf(t22);
    if (r) {
      var s32 = _getPrototypeOf(this).constructor;
      e22 = Reflect.construct(o, arguments, s32);
    } else e22 = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e22);
  };
}
function _classCallCheck(a32, n) {
  if (!(a32 instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function toPrimitive(t22, r) {
  if ("object" != _typeof(t22) || !t22) return t22;
  var e22 = t22[Symbol.toPrimitive];
  if (void 0 !== e22) {
    var i22 = e22.call(t22, r);
    if ("object" != _typeof(i22)) return i22;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t22);
}
function toPropertyKey(t22) {
  var i22 = toPrimitive(t22, "string");
  return "symbol" == _typeof(i22) ? i22 : i22 + "";
}
function _defineProperties(e22, r) {
  for (var t22 = 0; t22 < r.length; t22++) {
    var o = r[t22];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e22, toPropertyKey(o.key), o);
  }
}
function _createClass(e22, r, t22) {
  return r && _defineProperties(e22.prototype, r), Object.defineProperty(e22, "prototype", {
    writable: false
  }), e22;
}
function _defineProperty(e22, r, t22) {
  return (r = toPropertyKey(r)) in e22 ? Object.defineProperty(e22, r, {
    value: t22,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e22[r] = t22, e22;
}
var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /* @__PURE__ */ function() {
  function Setter2() {
    _classCallCheck(this, Setter2);
    _defineProperty(this, "priority", void 0);
    _defineProperty(this, "subPriority", 0);
  }
  _createClass(Setter2, [{
    key: "validate",
    value: function validate2(_utcDate, _options) {
      return true;
    }
  }]);
  return Setter2;
}();
var ValueSetter = /* @__PURE__ */ function(_Setter) {
  _inherits(ValueSetter2, _Setter);
  var _super = _createSuper(ValueSetter2);
  function ValueSetter2(value2, validateValue, setValue, priority, subPriority) {
    var _this;
    _classCallCheck(this, ValueSetter2);
    _this = _super.call(this);
    _this.value = value2;
    _this.validateValue = validateValue;
    _this.setValue = setValue;
    _this.priority = priority;
    if (subPriority) {
      _this.subPriority = subPriority;
    }
    return _this;
  }
  _createClass(ValueSetter2, [{
    key: "validate",
    value: function validate2(utcDate, options) {
      return this.validateValue(utcDate, this.value, options);
    }
  }, {
    key: "set",
    value: function set2(utcDate, flags, options) {
      return this.setValue(utcDate, flags, this.value, options);
    }
  }]);
  return ValueSetter2;
}(Setter);
var DateToSystemTimezoneSetter = /* @__PURE__ */ function(_Setter2) {
  _inherits(DateToSystemTimezoneSetter2, _Setter2);
  var _super2 = _createSuper(DateToSystemTimezoneSetter2);
  function DateToSystemTimezoneSetter2() {
    var _this2;
    _classCallCheck(this, DateToSystemTimezoneSetter2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this2), "priority", TIMEZONE_UNIT_PRIORITY);
    _defineProperty(_assertThisInitialized(_this2), "subPriority", -1);
    return _this2;
  }
  _createClass(DateToSystemTimezoneSetter2, [{
    key: "set",
    value: function set2(date, flags) {
      if (flags.timestampIsSet) {
        return date;
      }
      var convertedDate = /* @__PURE__ */ new Date(0);
      convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
      convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
      return convertedDate;
    }
  }]);
  return DateToSystemTimezoneSetter2;
}(Setter);
var Parser = /* @__PURE__ */ function() {
  function Parser2() {
    _classCallCheck(this, Parser2);
    _defineProperty(this, "incompatibleTokens", void 0);
    _defineProperty(this, "priority", void 0);
    _defineProperty(this, "subPriority", void 0);
  }
  _createClass(Parser2, [{
    key: "run",
    value: function run2(dateString, token2, match2, options) {
      var result = this.parse(dateString, token2, match2, options);
      if (!result) {
        return null;
      }
      return {
        setter: new ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
        rest: result.rest
      };
    }
  }, {
    key: "validate",
    value: function validate2(_utcDate, _value, _options) {
      return true;
    }
  }]);
  return Parser2;
}();
var EraParser = /* @__PURE__ */ function(_Parser) {
  _inherits(EraParser2, _Parser);
  var _super = _createSuper(EraParser2);
  function EraParser2() {
    var _this;
    _classCallCheck(this, EraParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 140);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["R", "u", "t", "T"]);
    return _this;
  }
  _createClass(EraParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "G":
        case "GG":
        case "GGG":
          return match2.era(dateString, {
            width: "abbreviated"
          }) || match2.era(dateString, {
            width: "narrow"
          });
        case "GGGGG":
          return match2.era(dateString, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return match2.era(dateString, {
            width: "wide"
          }) || match2.era(dateString, {
            width: "abbreviated"
          }) || match2.era(dateString, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function set2(date, flags, value2) {
      flags.era = value2;
      date.setUTCFullYear(value2, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return EraParser2;
}(Parser);
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }
  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest
  };
}
function parseNumericPattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseTimezonePattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  if (matchResult[0] === "Z") {
    return {
      value: 0,
      rest: dateString.slice(1)
    };
  }
  var sign2 = matchResult[1] === "+" ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign2 * (hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * millisecondsInSecond),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, dateString);
    default:
      return parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
  }
}
function parseNDigitsSigned(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);
    default:
      return parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
  }
}
function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0;
  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }
  return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex$1(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
var YearParser = /* @__PURE__ */ function(_Parser) {
  _inherits(YearParser2, _Parser);
  var _super = _createSuper(YearParser2);
  function YearParser2() {
    var _this;
    _classCallCheck(this, YearParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 130);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(YearParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      var valueCallback32 = function valueCallback4(year) {
        return {
          year,
          isTwoDigitYear: token2 === "yy"
        };
      };
      switch (token2) {
        case "y":
          return mapValue(parseNDigits(4, dateString), valueCallback32);
        case "yo":
          return mapValue(match2.ordinalNumber(dateString, {
            unit: "year"
          }), valueCallback32);
        default:
          return mapValue(parseNDigits(token2.length, dateString), valueCallback32);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2.isTwoDigitYear || value2.year > 0;
    }
  }, {
    key: "set",
    value: function set2(date, flags, value2) {
      var currentYear = date.getUTCFullYear();
      if (value2.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value2.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
      var year = !("era" in flags) || flags.era === 1 ? value2.year : 1 - value2.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return YearParser2;
}(Parser);
var LocalWeekYearParser = /* @__PURE__ */ function(_Parser) {
  _inherits(LocalWeekYearParser2, _Parser);
  var _super = _createSuper(LocalWeekYearParser2);
  function LocalWeekYearParser2() {
    var _this;
    _classCallCheck(this, LocalWeekYearParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 130);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]);
    return _this;
  }
  _createClass(LocalWeekYearParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      var valueCallback32 = function valueCallback4(year) {
        return {
          year,
          isTwoDigitYear: token2 === "YY"
        };
      };
      switch (token2) {
        case "Y":
          return mapValue(parseNDigits(4, dateString), valueCallback32);
        case "Yo":
          return mapValue(match2.ordinalNumber(dateString, {
            unit: "year"
          }), valueCallback32);
        default:
          return mapValue(parseNDigits(token2.length, dateString), valueCallback32);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2.isTwoDigitYear || value2.year > 0;
    }
  }, {
    key: "set",
    value: function set2(date, flags, value2, options) {
      var currentYear = getUTCWeekYear(date, options);
      if (value2.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value2.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek(date, options);
      }
      var year = !("era" in flags) || flags.era === 1 ? value2.year : 1 - value2.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return startOfUTCWeek(date, options);
    }
  }]);
  return LocalWeekYearParser2;
}(Parser);
var ISOWeekYearParser = /* @__PURE__ */ function(_Parser) {
  _inherits(ISOWeekYearParser2, _Parser);
  var _super = _createSuper(ISOWeekYearParser2);
  function ISOWeekYearParser2() {
    var _this;
    _classCallCheck(this, ISOWeekYearParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 130);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(ISOWeekYearParser2, [{
    key: "parse",
    value: function parse2(dateString, token2) {
      if (token2 === "R") {
        return parseNDigitsSigned(4, dateString);
      }
      return parseNDigitsSigned(token2.length, dateString);
    }
  }, {
    key: "set",
    value: function set2(_date, _flags, value2) {
      var firstWeekOfYear = /* @__PURE__ */ new Date(0);
      firstWeekOfYear.setUTCFullYear(value2, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return startOfUTCISOWeek(firstWeekOfYear);
    }
  }]);
  return ISOWeekYearParser2;
}(Parser);
var ExtendedYearParser = /* @__PURE__ */ function(_Parser) {
  _inherits(ExtendedYearParser2, _Parser);
  var _super = _createSuper(ExtendedYearParser2);
  function ExtendedYearParser2() {
    var _this;
    _classCallCheck(this, ExtendedYearParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 130);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(ExtendedYearParser2, [{
    key: "parse",
    value: function parse2(dateString, token2) {
      if (token2 === "u") {
        return parseNDigitsSigned(4, dateString);
      }
      return parseNDigitsSigned(token2.length, dateString);
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCFullYear(value2, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return ExtendedYearParser2;
}(Parser);
var QuarterParser = /* @__PURE__ */ function(_Parser) {
  _inherits(QuarterParser2, _Parser);
  var _super = _createSuper(QuarterParser2);
  function QuarterParser2() {
    var _this;
    _classCallCheck(this, QuarterParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 120);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(QuarterParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "Q":
        case "QQ":
          return parseNDigits(token2.length, dateString);
        case "Qo":
          return match2.ordinalNumber(dateString, {
            unit: "quarter"
          });
        case "QQQ":
          return match2.quarter(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.quarter(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return match2.quarter(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return match2.quarter(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.quarter(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.quarter(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 1 && value2 <= 4;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCMonth((value2 - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return QuarterParser2;
}(Parser);
var StandAloneQuarterParser = /* @__PURE__ */ function(_Parser) {
  _inherits(StandAloneQuarterParser2, _Parser);
  var _super = _createSuper(StandAloneQuarterParser2);
  function StandAloneQuarterParser2() {
    var _this;
    _classCallCheck(this, StandAloneQuarterParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 120);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(StandAloneQuarterParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "q":
        case "qq":
          return parseNDigits(token2.length, dateString);
        case "qo":
          return match2.ordinalNumber(dateString, {
            unit: "quarter"
          });
        case "qqq":
          return match2.quarter(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.quarter(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return match2.quarter(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return match2.quarter(dateString, {
            width: "wide",
            context: "standalone"
          }) || match2.quarter(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.quarter(dateString, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 1 && value2 <= 4;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCMonth((value2 - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneQuarterParser2;
}(Parser);
var MonthParser = /* @__PURE__ */ function(_Parser) {
  _inherits(MonthParser2, _Parser);
  var _super = _createSuper(MonthParser2);
  function MonthParser2() {
    var _this;
    _classCallCheck(this, MonthParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]);
    _defineProperty(_assertThisInitialized(_this), "priority", 110);
    return _this;
  }
  _createClass(MonthParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      var valueCallback32 = function valueCallback4(value2) {
        return value2 - 1;
      };
      switch (token2) {
        case "M":
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback32);
        case "MM":
          return mapValue(parseNDigits(2, dateString), valueCallback32);
        case "Mo":
          return mapValue(match2.ordinalNumber(dateString, {
            unit: "month"
          }), valueCallback32);
        case "MMM":
          return match2.month(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.month(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return match2.month(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return match2.month(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.month(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.month(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 0 && value2 <= 11;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCMonth(value2, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return MonthParser2;
}(Parser);
var StandAloneMonthParser = /* @__PURE__ */ function(_Parser) {
  _inherits(StandAloneMonthParser2, _Parser);
  var _super = _createSuper(StandAloneMonthParser2);
  function StandAloneMonthParser2() {
    var _this;
    _classCallCheck(this, StandAloneMonthParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 110);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(StandAloneMonthParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      var valueCallback32 = function valueCallback4(value2) {
        return value2 - 1;
      };
      switch (token2) {
        case "L":
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback32);
        case "LL":
          return mapValue(parseNDigits(2, dateString), valueCallback32);
        case "Lo":
          return mapValue(match2.ordinalNumber(dateString, {
            unit: "month"
          }), valueCallback32);
        case "LLL":
          return match2.month(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.month(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return match2.month(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return match2.month(dateString, {
            width: "wide",
            context: "standalone"
          }) || match2.month(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.month(dateString, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 0 && value2 <= 11;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCMonth(value2, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneMonthParser2;
}(Parser);
function setUTCWeek(dirtyDate, dirtyWeek, options) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var week = toInteger(dirtyWeek);
  var diff = getUTCWeek(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
var LocalWeekParser = /* @__PURE__ */ function(_Parser) {
  _inherits(LocalWeekParser2, _Parser);
  var _super = _createSuper(LocalWeekParser2);
  function LocalWeekParser2() {
    var _this;
    _classCallCheck(this, LocalWeekParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 100);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]);
    return _this;
  }
  _createClass(LocalWeekParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "w":
          return parseNumericPattern(numericPatterns.week, dateString);
        case "wo":
          return match2.ordinalNumber(dateString, {
            unit: "week"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 1 && value2 <= 53;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2, options) {
      return startOfUTCWeek(setUTCWeek(date, value2, options), options);
    }
  }]);
  return LocalWeekParser2;
}(Parser);
function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var isoWeek = toInteger(dirtyISOWeek);
  var diff = getUTCISOWeek(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
var ISOWeekParser = /* @__PURE__ */ function(_Parser) {
  _inherits(ISOWeekParser2, _Parser);
  var _super = _createSuper(ISOWeekParser2);
  function ISOWeekParser2() {
    var _this;
    _classCallCheck(this, ISOWeekParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 100);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(ISOWeekParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "I":
          return parseNumericPattern(numericPatterns.week, dateString);
        case "Io":
          return match2.ordinalNumber(dateString, {
            unit: "week"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 1 && value2 <= 53;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      return startOfUTCISOWeek(setUTCISOWeek(date, value2));
    }
  }]);
  return ISOWeekParser2;
}(Parser);
var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DateParser = /* @__PURE__ */ function(_Parser) {
  _inherits(DateParser2, _Parser);
  var _super = _createSuper(DateParser2);
  function DateParser2() {
    var _this;
    _classCallCheck(this, DateParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 90);
    _defineProperty(_assertThisInitialized(_this), "subPriority", 1);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(DateParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "d":
          return parseNumericPattern(numericPatterns.date, dateString);
        case "do":
          return match2.ordinalNumber(dateString, {
            unit: "date"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(date, value2) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex$1(year);
      var month = date.getUTCMonth();
      if (isLeapYear) {
        return value2 >= 1 && value2 <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value2 >= 1 && value2 <= DAYS_IN_MONTH[month];
      }
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCDate(value2);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DateParser2;
}(Parser);
var DayOfYearParser = /* @__PURE__ */ function(_Parser) {
  _inherits(DayOfYearParser2, _Parser);
  var _super = _createSuper(DayOfYearParser2);
  function DayOfYearParser2() {
    var _this;
    _classCallCheck(this, DayOfYearParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 90);
    _defineProperty(_assertThisInitialized(_this), "subpriority", 1);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(DayOfYearParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "D":
        case "DD":
          return parseNumericPattern(numericPatterns.dayOfYear, dateString);
        case "Do":
          return match2.ordinalNumber(dateString, {
            unit: "date"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(date, value2) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex$1(year);
      if (isLeapYear) {
        return value2 >= 1 && value2 <= 366;
      } else {
        return value2 >= 1 && value2 <= 365;
      }
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCMonth(0, value2);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DayOfYearParser2;
}(Parser);
function setUTCDay(dirtyDate, dirtyDay, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(2, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date = toDate(dirtyDate);
  var day = toInteger(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
var DayParser = /* @__PURE__ */ function(_Parser) {
  _inherits(DayParser2, _Parser);
  var _super = _createSuper(DayParser2);
  function DayParser2() {
    var _this;
    _classCallCheck(this, DayParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 90);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(DayParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "E":
        case "EE":
        case "EEE":
          return match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return match2.day(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 0 && value2 <= 6;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2, options) {
      date = setUTCDay(date, value2, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DayParser2;
}(Parser);
var LocalDayParser = /* @__PURE__ */ function(_Parser) {
  _inherits(LocalDayParser2, _Parser);
  var _super = _createSuper(LocalDayParser2);
  function LocalDayParser2() {
    var _this;
    _classCallCheck(this, LocalDayParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 90);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]);
    return _this;
  }
  _createClass(LocalDayParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2, options) {
      var valueCallback32 = function valueCallback4(value2) {
        var wholeWeekDays = Math.floor((value2 - 1) / 7) * 7;
        return (value2 + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token2) {
        case "e":
        case "ee":
          return mapValue(parseNDigits(token2.length, dateString), valueCallback32);
        case "eo":
          return mapValue(match2.ordinalNumber(dateString, {
            unit: "day"
          }), valueCallback32);
        case "eee":
          return match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return match2.day(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 0 && value2 <= 6;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2, options) {
      date = setUTCDay(date, value2, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return LocalDayParser2;
}(Parser);
var StandAloneLocalDayParser = /* @__PURE__ */ function(_Parser) {
  _inherits(StandAloneLocalDayParser2, _Parser);
  var _super = _createSuper(StandAloneLocalDayParser2);
  function StandAloneLocalDayParser2() {
    var _this;
    _classCallCheck(this, StandAloneLocalDayParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 90);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]);
    return _this;
  }
  _createClass(StandAloneLocalDayParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2, options) {
      var valueCallback32 = function valueCallback4(value2) {
        var wholeWeekDays = Math.floor((value2 - 1) / 7) * 7;
        return (value2 + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token2) {
        case "c":
        case "cc":
          return mapValue(parseNDigits(token2.length, dateString), valueCallback32);
        case "co":
          return mapValue(match2.ordinalNumber(dateString, {
            unit: "day"
          }), valueCallback32);
        case "ccc":
          return match2.day(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.day(dateString, {
            width: "short",
            context: "standalone"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return match2.day(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return match2.day(dateString, {
            width: "short",
            context: "standalone"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return match2.day(dateString, {
            width: "wide",
            context: "standalone"
          }) || match2.day(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.day(dateString, {
            width: "short",
            context: "standalone"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 0 && value2 <= 6;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2, options) {
      date = setUTCDay(date, value2, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneLocalDayParser2;
}(Parser);
function setUTCISODay(dirtyDate, dirtyDay) {
  requiredArgs(2, arguments);
  var day = toInteger(dirtyDay);
  if (day % 7 === 0) {
    day = day - 7;
  }
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
var ISODayParser = /* @__PURE__ */ function(_Parser) {
  _inherits(ISODayParser2, _Parser);
  var _super = _createSuper(ISODayParser2);
  function ISODayParser2() {
    var _this;
    _classCallCheck(this, ISODayParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 90);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(ISODayParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      var valueCallback32 = function valueCallback4(value2) {
        if (value2 === 0) {
          return 7;
        }
        return value2;
      };
      switch (token2) {
        case "i":
        case "ii":
          return parseNDigits(token2.length, dateString);
        case "io":
          return match2.ordinalNumber(dateString, {
            unit: "day"
          });
        case "iii":
          return mapValue(match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          }), valueCallback32);
        case "iiiii":
          return mapValue(match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          }), valueCallback32);
        case "iiiiii":
          return mapValue(match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          }), valueCallback32);
        case "iiii":
        default:
          return mapValue(match2.day(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          }), valueCallback32);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 1 && value2 <= 7;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date = setUTCISODay(date, value2);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return ISODayParser2;
}(Parser);
var AMPMParser = /* @__PURE__ */ function(_Parser) {
  _inherits(AMPMParser2, _Parser);
  var _super = _createSuper(AMPMParser2);
  function AMPMParser2() {
    var _this;
    _classCallCheck(this, AMPMParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 80);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
    return _this;
  }
  _createClass(AMPMParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "a":
        case "aa":
        case "aaa":
          return match2.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return match2.dayPeriod(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCHours(dayPeriodEnumToHours(value2), 0, 0, 0);
      return date;
    }
  }]);
  return AMPMParser2;
}(Parser);
var AMPMMidnightParser = /* @__PURE__ */ function(_Parser) {
  _inherits(AMPMMidnightParser2, _Parser);
  var _super = _createSuper(AMPMMidnightParser2);
  function AMPMMidnightParser2() {
    var _this;
    _classCallCheck(this, AMPMMidnightParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 80);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
    return _this;
  }
  _createClass(AMPMMidnightParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "b":
        case "bb":
        case "bbb":
          return match2.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return match2.dayPeriod(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCHours(dayPeriodEnumToHours(value2), 0, 0, 0);
      return date;
    }
  }]);
  return AMPMMidnightParser2;
}(Parser);
var DayPeriodParser = /* @__PURE__ */ function(_Parser) {
  _inherits(DayPeriodParser2, _Parser);
  var _super = _createSuper(DayPeriodParser2);
  function DayPeriodParser2() {
    var _this;
    _classCallCheck(this, DayPeriodParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 80);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["a", "b", "t", "T"]);
    return _this;
  }
  _createClass(DayPeriodParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "B":
        case "BB":
        case "BBB":
          return match2.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return match2.dayPeriod(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCHours(dayPeriodEnumToHours(value2), 0, 0, 0);
      return date;
    }
  }]);
  return DayPeriodParser2;
}(Parser);
var Hour1to12Parser = /* @__PURE__ */ function(_Parser) {
  _inherits(Hour1to12Parser2, _Parser);
  var _super = _createSuper(Hour1to12Parser2);
  function Hour1to12Parser2() {
    var _this;
    _classCallCheck(this, Hour1to12Parser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 70);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["H", "K", "k", "t", "T"]);
    return _this;
  }
  _createClass(Hour1to12Parser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "h":
          return parseNumericPattern(numericPatterns.hour12h, dateString);
        case "ho":
          return match2.ordinalNumber(dateString, {
            unit: "hour"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 1 && value2 <= 12;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value2 < 12) {
        date.setUTCHours(value2 + 12, 0, 0, 0);
      } else if (!isPM && value2 === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value2, 0, 0, 0);
      }
      return date;
    }
  }]);
  return Hour1to12Parser2;
}(Parser);
var Hour0to23Parser = /* @__PURE__ */ function(_Parser) {
  _inherits(Hour0to23Parser2, _Parser);
  var _super = _createSuper(Hour0to23Parser2);
  function Hour0to23Parser2() {
    var _this;
    _classCallCheck(this, Hour0to23Parser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 70);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
    return _this;
  }
  _createClass(Hour0to23Parser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "H":
          return parseNumericPattern(numericPatterns.hour23h, dateString);
        case "Ho":
          return match2.ordinalNumber(dateString, {
            unit: "hour"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 0 && value2 <= 23;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCHours(value2, 0, 0, 0);
      return date;
    }
  }]);
  return Hour0to23Parser2;
}(Parser);
var Hour0To11Parser = /* @__PURE__ */ function(_Parser) {
  _inherits(Hour0To11Parser2, _Parser);
  var _super = _createSuper(Hour0To11Parser2);
  function Hour0To11Parser2() {
    var _this;
    _classCallCheck(this, Hour0To11Parser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 70);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["h", "H", "k", "t", "T"]);
    return _this;
  }
  _createClass(Hour0To11Parser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "K":
          return parseNumericPattern(numericPatterns.hour11h, dateString);
        case "Ko":
          return match2.ordinalNumber(dateString, {
            unit: "hour"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 0 && value2 <= 11;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value2 < 12) {
        date.setUTCHours(value2 + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value2, 0, 0, 0);
      }
      return date;
    }
  }]);
  return Hour0To11Parser2;
}(Parser);
var Hour1To24Parser = /* @__PURE__ */ function(_Parser) {
  _inherits(Hour1To24Parser2, _Parser);
  var _super = _createSuper(Hour1To24Parser2);
  function Hour1To24Parser2() {
    var _this;
    _classCallCheck(this, Hour1To24Parser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 70);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
    return _this;
  }
  _createClass(Hour1To24Parser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "k":
          return parseNumericPattern(numericPatterns.hour24h, dateString);
        case "ko":
          return match2.ordinalNumber(dateString, {
            unit: "hour"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 1 && value2 <= 24;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      var hours = value2 <= 24 ? value2 % 24 : value2;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    }
  }]);
  return Hour1To24Parser2;
}(Parser);
var MinuteParser = /* @__PURE__ */ function(_Parser) {
  _inherits(MinuteParser2, _Parser);
  var _super = _createSuper(MinuteParser2);
  function MinuteParser2() {
    var _this;
    _classCallCheck(this, MinuteParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 60);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["t", "T"]);
    return _this;
  }
  _createClass(MinuteParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "m":
          return parseNumericPattern(numericPatterns.minute, dateString);
        case "mo":
          return match2.ordinalNumber(dateString, {
            unit: "minute"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 0 && value2 <= 59;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCMinutes(value2, 0, 0);
      return date;
    }
  }]);
  return MinuteParser2;
}(Parser);
var SecondParser = /* @__PURE__ */ function(_Parser) {
  _inherits(SecondParser2, _Parser);
  var _super = _createSuper(SecondParser2);
  function SecondParser2() {
    var _this;
    _classCallCheck(this, SecondParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 50);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["t", "T"]);
    return _this;
  }
  _createClass(SecondParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "s":
          return parseNumericPattern(numericPatterns.second, dateString);
        case "so":
          return match2.ordinalNumber(dateString, {
            unit: "second"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 0 && value2 <= 59;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCSeconds(value2, 0);
      return date;
    }
  }]);
  return SecondParser2;
}(Parser);
var FractionOfSecondParser = /* @__PURE__ */ function(_Parser) {
  _inherits(FractionOfSecondParser2, _Parser);
  var _super = _createSuper(FractionOfSecondParser2);
  function FractionOfSecondParser2() {
    var _this;
    _classCallCheck(this, FractionOfSecondParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 30);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["t", "T"]);
    return _this;
  }
  _createClass(FractionOfSecondParser2, [{
    key: "parse",
    value: function parse2(dateString, token2) {
      var valueCallback32 = function valueCallback4(value2) {
        return Math.floor(value2 * Math.pow(10, -token2.length + 3));
      };
      return mapValue(parseNDigits(token2.length, dateString), valueCallback32);
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCMilliseconds(value2);
      return date;
    }
  }]);
  return FractionOfSecondParser2;
}(Parser);
var ISOTimezoneWithZParser = /* @__PURE__ */ function(_Parser) {
  _inherits(ISOTimezoneWithZParser2, _Parser);
  var _super = _createSuper(ISOTimezoneWithZParser2);
  function ISOTimezoneWithZParser2() {
    var _this;
    _classCallCheck(this, ISOTimezoneWithZParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 10);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["t", "T", "x"]);
    return _this;
  }
  _createClass(ISOTimezoneWithZParser2, [{
    key: "parse",
    value: function parse2(dateString, token2) {
      switch (token2) {
        case "X":
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
        case "XX":
          return parseTimezonePattern(timezonePatterns.basic, dateString);
        case "XXXX":
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
        case "XXXXX":
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
        case "XXX":
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set2(date, flags, value2) {
      if (flags.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value2);
    }
  }]);
  return ISOTimezoneWithZParser2;
}(Parser);
var ISOTimezoneParser = /* @__PURE__ */ function(_Parser) {
  _inherits(ISOTimezoneParser2, _Parser);
  var _super = _createSuper(ISOTimezoneParser2);
  function ISOTimezoneParser2() {
    var _this;
    _classCallCheck(this, ISOTimezoneParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 10);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["t", "T", "X"]);
    return _this;
  }
  _createClass(ISOTimezoneParser2, [{
    key: "parse",
    value: function parse2(dateString, token2) {
      switch (token2) {
        case "x":
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
        case "xx":
          return parseTimezonePattern(timezonePatterns.basic, dateString);
        case "xxxx":
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
        case "xxxxx":
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
        case "xxx":
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set2(date, flags, value2) {
      if (flags.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value2);
    }
  }]);
  return ISOTimezoneParser2;
}(Parser);
var TimestampSecondsParser = /* @__PURE__ */ function(_Parser) {
  _inherits(TimestampSecondsParser2, _Parser);
  var _super = _createSuper(TimestampSecondsParser2);
  function TimestampSecondsParser2() {
    var _this;
    _classCallCheck(this, TimestampSecondsParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 40);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", "*");
    return _this;
  }
  _createClass(TimestampSecondsParser2, [{
    key: "parse",
    value: function parse2(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set2(_date, _flags, value2) {
      return [new Date(value2 * 1e3), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampSecondsParser2;
}(Parser);
var TimestampMillisecondsParser = /* @__PURE__ */ function(_Parser) {
  _inherits(TimestampMillisecondsParser2, _Parser);
  var _super = _createSuper(TimestampMillisecondsParser2);
  function TimestampMillisecondsParser2() {
    var _this;
    _classCallCheck(this, TimestampMillisecondsParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 20);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", "*");
    return _this;
  }
  _createClass(TimestampMillisecondsParser2, [{
    key: "parse",
    value: function parse2(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set2(_date, _flags, value2) {
      return [new Date(value2), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampMillisecondsParser2;
}(Parser);
var parsers = {
  G: new EraParser(),
  y: new YearParser(),
  Y: new LocalWeekYearParser(),
  R: new ISOWeekYearParser(),
  u: new ExtendedYearParser(),
  Q: new QuarterParser(),
  q: new StandAloneQuarterParser(),
  M: new MonthParser(),
  L: new StandAloneMonthParser(),
  w: new LocalWeekParser(),
  I: new ISOWeekParser(),
  d: new DateParser(),
  D: new DayOfYearParser(),
  E: new DayParser(),
  e: new LocalDayParser(),
  c: new StandAloneLocalDayParser(),
  i: new ISODayParser(),
  a: new AMPMParser(),
  b: new AMPMMidnightParser(),
  B: new DayPeriodParser(),
  h: new Hour1to12Parser(),
  H: new Hour0to23Parser(),
  K: new Hour0To11Parser(),
  k: new Hour1To24Parser(),
  m: new MinuteParser(),
  s: new SecondParser(),
  S: new FractionOfSecondParser(),
  X: new ISOTimezoneWithZParser(),
  x: new ISOTimezoneParser(),
  t: new TimestampSecondsParser(),
  T: new TimestampMillisecondsParser()
};
var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp$1 = /^'([^]*?)'?$/;
var doubleQuoteRegExp$1 = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;
function parse$3(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var defaultOptions2 = getDefaultOptions();
  var locale$12 = (_ref = (_options$locale = void 0) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions2.locale) !== null && _ref !== void 0 ? _ref : locale;
  if (!locale$12.match) {
    throw new RangeError("locale must contain match property");
  }
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = void 0) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : void 0) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions2.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = void 0) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : void 0) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions2.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions2.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  if (formatString === "") {
    if (dateString === "") {
      return toDate(dirtyReferenceDate);
    } else {
      return /* @__PURE__ */ new Date(NaN);
    }
  }
  var subFnOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale$12
  };
  var setters = [new DateToSystemTimezoneSetter()];
  var tokens = formatString.match(longFormattingTokensRegExp).map(function(substring) {
    var firstCharacter = substring[0];
    if (firstCharacter in longFormatters) {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale$12.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp$1);
  var usedTokens = [];
  var _iterator = _createForOfIteratorHelper(tokens), _step;
  try {
    var _loop = function _loop2() {
      var token2 = _step.value;
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(token2)) {
        throwProtectedError(token2, formatString, dirtyDateString);
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(token2)) {
        throwProtectedError(token2, formatString, dirtyDateString);
      }
      var firstCharacter = token2[0];
      var parser = parsers[firstCharacter];
      if (parser) {
        var incompatibleTokens = parser.incompatibleTokens;
        if (Array.isArray(incompatibleTokens)) {
          var incompatibleToken = usedTokens.find(function(usedToken) {
            return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
          });
          if (incompatibleToken) {
            throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token2, "` at the same time"));
          }
        } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) {
          throw new RangeError("The format string mustn't contain `".concat(token2, "` and any other token at the same time"));
        }
        usedTokens.push({
          token: firstCharacter,
          fullToken: token2
        });
        var parseResult = parser.run(dateString, token2, locale$12.match, subFnOptions);
        if (!parseResult) {
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        }
        setters.push(parseResult.setter);
        dateString = parseResult.rest;
      } else {
        if (firstCharacter.match(unescapedLatinCharacterRegExp$1)) {
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        }
        if (token2 === "''") {
          token2 = "'";
        } else if (firstCharacter === "'") {
          token2 = cleanEscapedString$1(token2);
        }
        if (dateString.indexOf(token2) === 0) {
          dateString = dateString.slice(token2.length);
        } else {
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        }
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done; ) {
      var _ret = _loop();
      if (_typeof(_ret) === "object") return _ret.v;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return /* @__PURE__ */ new Date(NaN);
  }
  var uniquePrioritySetters = setters.map(function(setter2) {
    return setter2.priority;
  }).sort(function(a32, b22) {
    return b22 - a32;
  }).filter(function(priority, index2, array) {
    return array.indexOf(priority) === index2;
  }).map(function(priority) {
    return setters.filter(function(setter2) {
      return setter2.priority === priority;
    }).sort(function(a32, b22) {
      return b22.subPriority - a32.subPriority;
    });
  }).map(function(setterArray) {
    return setterArray[0];
  });
  var date = toDate(dirtyReferenceDate);
  if (isNaN(date.getTime())) {
    return /* @__PURE__ */ new Date(NaN);
  }
  var utcDate = subMilliseconds(date, getTimezoneOffsetInMilliseconds(date));
  var flags = {};
  var _iterator2 = _createForOfIteratorHelper(uniquePrioritySetters), _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
      var setter = _step2.value;
      if (!setter.validate(utcDate, subFnOptions)) {
        return /* @__PURE__ */ new Date(NaN);
      }
      var result = setter.set(utcDate, flags, subFnOptions);
      if (Array.isArray(result)) {
        utcDate = result[0];
        assign$1(flags, result[1]);
      } else {
        utcDate = result;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return utcDate;
}
function cleanEscapedString$1(input) {
  return input.match(escapedStringRegExp$1)[1].replace(doubleQuoteRegExp$1, "'");
}
var formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function lightFormat(dirtyDate, formatStr) {
  requiredArgs(2, arguments);
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var tokens = formatStr.match(formattingTokensRegExp);
  if (!tokens) return "";
  var result = tokens.map(function(substring) {
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter2 = formatters$1[firstCharacter];
    if (formatter2) {
      return formatter2(utcDate, substring);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
    }
    return substring;
  }).join("");
  return result;
}
function cleanEscapedString(input) {
  var matches = input.match(escapedStringRegExp);
  if (!matches) {
    return input;
  }
  return matches[1].replace(doubleQuoteRegExp, "'");
}
function parseISO(argument, options) {
  var _options$additionalDi;
  requiredArgs(1, arguments);
  var additionalDigits = toInteger((_options$additionalDi = void 0) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  }
  if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) {
    return /* @__PURE__ */ new Date(NaN);
  }
  var dateStrings = splitDateString(argument);
  var date;
  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }
  if (!date || isNaN(date.getTime())) {
    return /* @__PURE__ */ new Date(NaN);
  }
  var timestamp = date.getTime();
  var time = 0;
  var offset2;
  if (dateStrings.time) {
    time = parseTime(dateStrings.time);
    if (isNaN(time)) {
      return /* @__PURE__ */ new Date(NaN);
    }
  }
  if (dateStrings.timezone) {
    offset2 = parseTimezone(dateStrings.timezone);
    if (isNaN(offset2)) {
      return /* @__PURE__ */ new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time);
    var result = /* @__PURE__ */ new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }
  return new Date(timestamp + time + offset2);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString;
  if (array.length > 2) {
    return dateStrings;
  }
  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }
  if (timeString) {
    var token2 = patterns.timezone.exec(timeString);
    if (token2) {
      dateStrings.time = timeString.replace(token2[1], "");
      dateStrings.timezone = token2[1];
    } else {
      dateStrings.time = timeString;
    }
  }
  return dateStrings;
}
function parseYear(dateString, additionalDigits) {
  var regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
  var captures = dateString.match(regex);
  if (!captures) return {
    year: NaN,
    restDateString: ""
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null;
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}
function parseDate(dateString, year) {
  if (year === null) return /* @__PURE__ */ new Date(NaN);
  var captures = dateString.match(dateRegex);
  if (!captures) return /* @__PURE__ */ new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;
  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return /* @__PURE__ */ new Date(NaN);
    }
    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = /* @__PURE__ */ new Date(0);
    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return /* @__PURE__ */ new Date(NaN);
    }
    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}
function parseDateUnit(value2) {
  return value2 ? parseInt(value2) : 1;
}
function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN;
  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);
  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }
  return hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1e3;
}
function parseTimeUnit(value2) {
  return value2 && parseFloat(value2.replace(",", ".")) || 0;
}
function parseTimezone(timezoneString) {
  if (timezoneString === "Z") return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign2 = captures[1] === "+" ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;
  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }
  return sign2 * (hours * millisecondsInHour + minutes * millisecondsInMinute);
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = /* @__PURE__ */ new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }
  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}
function startOfToday() {
  return startOfDay(Date.now());
}
function dateSort(x22, y32) {
  const valueX = typeof x22 === "string" ? parseISO(x22) : new Date(x22);
  const valueY = typeof y32 === "string" ? parseISO(y32) : new Date(y32);
  const invalidX = !isValid(valueX);
  const invalidY = !isValid(valueY);
  if (invalidX && invalidY)
    return 0;
  if (invalidX)
    return 1;
  if (invalidY)
    return -1;
  return compareAsc(valueX, valueY);
}
function defaultSort(x22, y32) {
  if (x22 == null && y32 == null)
    return 0;
  if (x22 == null)
    return 1;
  if (y32 == null)
    return -1;
  if (x22 < y32)
    return -1;
  if (x22 > y32)
    return 1;
  return 0;
}
const naturalSortFn = new Intl.Collator(void 0, {
  numeric: true,
  sensitivity: "base"
}).compare;
function naturalSort(x22, y32) {
  if (x22 == null && y32 == null)
    return 0;
  if (x22 == null)
    return 1;
  if (y32 == null)
    return -1;
  return naturalSortFn(x22, y32);
}
function arrayShallowEqual(arr1, arr2) {
  if (arr1.length !== arr2.length)
    return false;
  return arr1.every((a32) => arr2.includes(a32));
}
function distinct(array) {
  return [...new Set(array)];
}
function distinctByKey(array, key) {
  const result = [];
  const uniqueSet = /* @__PURE__ */ new Set();
  for (let i22 = 0; i22 < array.length; i22++) {
    const value2 = array[i22][key];
    if (uniqueSet.has(value2))
      continue;
    uniqueSet.add(value2);
    result.push(array[i22]);
  }
  return result;
}
function flatten(array) {
  return [].concat(...array);
}
function last(arr) {
  return arr[arr.length - 1];
}
function sortByDate(array, key, asc = true) {
  const sortFn = (a32, b22) => {
    const x22 = asc ? a32[key] : b22[key];
    const y32 = asc ? b22[key] : a32[key];
    return dateSort(x22, y32);
  };
  return Array.from(array).sort(sortFn);
}
function sortByKey(array, key, asc = true, keySortFn = defaultSort) {
  const sortFn = (a32, b22) => {
    const x22 = asc ? a32[key] : b22[key];
    const y32 = asc ? b22[key] : a32[key];
    return keySortFn(x22, y32);
  };
  return Array.from(array).sort(sortFn);
}
async function wait(timeout2) {
  return new Promise((resolve2) => setTimeout(resolve2, timeout2));
}
function getContrastColor(color2, darkColor = "black", lightColor = "white") {
  const colorString = color2.charAt(0) === "#" ? color2.substring(1, 7) : color2;
  const r = parseInt(colorString.substring(0, 2), 16);
  const g2 = parseInt(colorString.substring(2, 4), 16);
  const b22 = parseInt(colorString.substring(4, 6), 16);
  return r * 0.299 + g2 * 0.587 + b22 * 0.114 > 186 ? darkColor : lightColor;
}
var DateTemplates$1;
(function(DateTemplates2) {
  DateTemplates2["Days"] = "MMMM d";
  DateTemplates2["Long"] = "yyyy-MM-dd HH:mm:ss";
  DateTemplates2["Short"] = "yyyy-MM-dd";
})(DateTemplates$1 || (DateTemplates$1 = {}));
function formatDate$1(value2, fmt = DateTemplates$1.Long) {
  const date = value2 instanceof Date ? value2 : parseISO(value2);
  return isValid(date) ? lightFormat(date, fmt) : "";
}
function formatDuration$1(duration2) {
  return formatDuration$2(intervalToDuration({
    end: duration2,
    start: 0
  }), { delimiter: " " });
}
function formatInterval(start, end) {
  const diff = differenceInSeconds(end, start);
  const hours = Math.floor(diff / 3600);
  const minutes = Math.floor(diff / 60 % 60);
  const seconds = diff % 60;
  return hours ? `${hours}h ${minutes}m` : minutes ? `${minutes}m ${seconds}s` : `${seconds}s`;
}
({
  isMac: (() => {
    try {
      return window.navigator.platform.toUpperCase().indexOf("MAC") >= 0;
    } catch {
      return false;
    }
  })()
});
function isInputElement(el) {
  if (!el)
    return false;
  return el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement || el instanceof HTMLDivElement && !!el.isContentEditable;
}
async function getFiles(items) {
  const entryFiles = [];
  for (let i22 = 0; i22 < items.length; i22++) {
    const item = items[i22].webkitGetAsEntry();
    item && entryFiles.push(item);
  }
  const filePromises = entryFiles.map(scanFiles);
  const files = await Promise.all(filePromises);
  return flatten(files);
}
function readEntries(reader) {
  return new Promise((resolve2, reject) => {
    reader.readEntries(resolve2, reject);
  });
}
function readFile(item) {
  return new Promise((resolve2, reject) => {
    item.file(resolve2, reject);
  });
}
async function scanDirectories(item) {
  const reader = item.createReader();
  const result = [];
  let entries2;
  do {
    entries2 = await readEntries(reader);
    result.push(...entries2);
  } while (entries2.length > 0);
  return result;
}
async function scanFiles(item) {
  if (item.isFile) {
    const file = await readFile(item);
    return [file];
  } else if (item.isDirectory) {
    const entries2 = await scanDirectories(item);
    const filePromises = entries2.map(scanFiles);
    const files = await Promise.all(filePromises);
    return flatten(files);
  } else {
    return [];
  }
}
const K$1 = 1024;
const SIZES$3 = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
function formatBytes(bytes, decimals = 1) {
  if (!bytes)
    return "0 MB";
  if (bytes === 1)
    return "1 Byte";
  const i22 = Math.floor(Math.log(bytes) / Math.log(K$1));
  return `${parseFloat((bytes / Math.pow(K$1, i22)).toFixed(decimals))} ${SIZES$3[i22]}`;
}
function isFiniteNumber(value2) {
  return Number.isFinite(value2) && !Number.isNaN(value2);
}
function fromEntries(iterable) {
  return [...iterable].reduce((obj, [k22, v]) => {
    obj[k22] = v;
    return obj;
  }, {});
}
function filterObject(o, filterfn) {
  const entries2 = Object.entries(o);
  const filtered = entries2.filter(([key, value2]) => filterfn(value2, key));
  return fromEntries(filtered);
}
function unwrap(v) {
  if (!v)
    return v;
  if (typeof v === "object" && "value" in v)
    return v.value;
  return v;
}
const DefaultOptions = {
  darkMode: false,
  layout: {},
  navigation: {},
  notification: {},
  session: {},
  tables: {
    carousel: true,
    queryParamsFilters: true
  },
  warnAutomation: true
};
const globalOptions = {
  ...DefaultOptions
};
function useOptions() {
  return readonly(globalOptions);
}
function useAutomation(id3) {
  const { warnAutomation } = useOptions();
  if (!id3 && warnAutomation) {
    try {
      const instance = getCurrentInstance();
      let node = instance;
      const hierarchy = [];
      while (node) {
        hierarchy.unshift(node.type.name ?? node.type.__file ?? "?");
        node = node.parent;
      }
      if (hierarchy.length) {
        console.warn(`Missing data-automation for ${hierarchy.join(" > ")}`);
      } else {
        console.warn("Missing data-automation somewhere (not enough information to determine where)");
      }
    } catch {
      console.warn("Missing data-automation somewhere (not enough information to determine where)");
    }
  }
  const buildId = (suffix) => {
    if (!id3) return void 0;
    if (typeof id3 === "string") {
      return suffix ? `${id3}__${suffix}` : id3;
    }
    if (!id3.value) return void 0;
    return suffix ? `${id3.value}__${suffix}` : id3.value;
  };
  const dataAttrs = computed(() => {
    const instance = getCurrentInstance();
    const attrs = instance == null ? void 0 : instance.attrs;
    if (!attrs) return void 0;
    return filterObject(attrs, (_, key) => key.startsWith("data-"));
  });
  return {
    buildId,
    dataAttrs
  };
}
const OFFSET = 10;
const SCROLLBAR_OFFSET = 15;
function useChartTooltip(chart, caret) {
  const tooltipGhostRef = useTemplateRef("tooltipGhost");
  const style = ref$1({
    height: "0px",
    left: "0px",
    overflow: "auto",
    top: "0px",
    width: "0px"
  });
  const timeout2 = ref$1(null);
  function getXDeviation() {
    const offsetWidth = getTooltipWidth();
    if (caret.value.x <= offsetWidth / 2) {
      return offsetWidth / 2 + OFFSET;
    }
    if (chart.value.width - caret.value.x <= offsetWidth / 2) {
      return -offsetWidth / 2 + -OFFSET;
    }
    return 0;
  }
  function getLeft() {
    if (!tooltipGhostRef.value || !chart) return 0;
    return chart.value.position.x + caret.value.x + getXDeviation();
  }
  function getTop() {
    if (!tooltipGhostRef.value || !chart) return 0;
    return chart.value.position.y + caret.value.y + OFFSET;
  }
  function updateTooltipSizeAndPosition() {
    if (!tooltipGhostRef.value || !chart.value) return;
    style.value = {
      height: `${getTooltipHeight()}px`,
      left: `${getLeft()}px`,
      overflow: getTooltipHeight() < tooltipGhostRef.value.offsetHeight ? "auto" : "hidden",
      top: `${getTop()}px`,
      width: `${getTooltipWidth()}px`
    };
  }
  function getTooltipWidth() {
    return tooltipGhostRef.value.offsetWidth + SCROLLBAR_OFFSET;
  }
  function getTooltipHeight() {
    return Math.min(tooltipGhostRef.value.offsetHeight, getMaxHeight());
  }
  function getMaxHeight() {
    return window.innerHeight - chart.value.top - caret.value.y - OFFSET;
  }
  watch([chart, caret], () => {
    timeout2.value = window.setTimeout(() => {
      updateTooltipSizeAndPosition();
    }, 1);
  }, {
    deep: true,
    immediate: true
  });
  onUnmounted(() => {
    if (timeout2.value) {
      window.clearTimeout(timeout2.value);
    }
  });
  return { style };
}
const state$1 = reactive({});
function useCollapsed(name2, value2) {
  if (state$1[name2] === void 0) {
    state$1[name2] = value2 === void 0 ? true : value2;
  }
  const collapsed = toRef(state$1, name2);
  function toggleCollapsed() {
    state$1[name2] = !state$1[name2];
  }
  return {
    collapsed,
    toggleCollapsed
  };
}
/*!
 * Quasar Framework v2.17.2
 * (c) 2015-present Razvan Stoenescu
 * Released under the MIT License.
 */
var attachPoint$1 = null;
function getAttachPoint$1() {
  if (attachPoint$1 !== null) return attachPoint$1;
  return attachPoint$1 = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {};
}
if (typeof __QUASAR_SSR__ !== "boolean") {
  getAttachPoint$1().__QUASAR_SSR__ = false;
}
if (typeof __QUASAR_SSR_CLIENT__ !== "boolean") {
  getAttachPoint$1().__QUASAR_SSR_CLIENT__ = false;
}
if (typeof __QUASAR_SSR_PWA__ !== "boolean") {
  getAttachPoint$1().__QUASAR_SSR_PWA__ = false;
}
function injectProp$1(target2, propName, get2, set2) {
  Object.defineProperty(target2, propName, {
    get: get2,
    set: set2,
    enumerable: true
  });
  return target2;
}
function injectMultipleProps$1(target2, props4) {
  for (const key in props4) {
    injectProp$1(target2, key, props4[key]);
  }
  return target2;
}
var isRuntimeSsrPreHydration$1 = ref$1(
  __QUASAR_SSR_CLIENT__ && (__QUASAR_SSR_PWA__ ? document.body.getAttribute("data-server-rendered") !== null : true)
);
var preHydrationBrowser$1;
function getMatch$1(userAgent2, platformMatch) {
  const match2 = /(edg|edge|edga|edgios)\/([\w.]+)/.exec(userAgent2) || /(opr)[\/]([\w.]+)/.exec(userAgent2) || /(vivaldi)[\/]([\w.]+)/.exec(userAgent2) || /(chrome|crios)[\/]([\w.]+)/.exec(userAgent2) || /(version)(applewebkit)[\/]([\w.]+).*(safari)[\/]([\w.]+)/.exec(userAgent2) || /(webkit)[\/]([\w.]+).*(version)[\/]([\w.]+).*(safari)[\/]([\w.]+)/.exec(userAgent2) || /(firefox|fxios)[\/]([\w.]+)/.exec(userAgent2) || /(webkit)[\/]([\w.]+)/.exec(userAgent2) || /(opera)(?:.*version|)[\/]([\w.]+)/.exec(userAgent2) || [];
  return {
    browser: match2[5] || match2[3] || match2[1] || "",
    version: match2[4] || match2[2] || "0",
    platform: platformMatch[0] || ""
  };
}
function getPlatformMatch$1(userAgent2) {
  return /(ipad)/.exec(userAgent2) || /(ipod)/.exec(userAgent2) || /(windows phone)/.exec(userAgent2) || /(iphone)/.exec(userAgent2) || /(kindle)/.exec(userAgent2) || /(silk)/.exec(userAgent2) || /(android)/.exec(userAgent2) || /(win)/.exec(userAgent2) || /(mac)/.exec(userAgent2) || /(linux)/.exec(userAgent2) || /(cros)/.exec(userAgent2) || /(playbook)/.exec(userAgent2) || /(bb)/.exec(userAgent2) || /(blackberry)/.exec(userAgent2) || [];
}
var hasTouch$1 = "ontouchstart" in window || window.navigator.maxTouchPoints > 0;
function getPlatform$1(UA) {
  const userAgent2 = UA.toLowerCase();
  const platformMatch = getPlatformMatch$1(userAgent2);
  const matched = getMatch$1(userAgent2, platformMatch);
  const browser = {
    mobile: false,
    desktop: false,
    cordova: false,
    capacitor: false,
    nativeMobile: false,
    // nativeMobileWrapper: void 0,
    electron: false,
    bex: false,
    linux: false,
    mac: false,
    win: false,
    cros: false,
    chrome: false,
    firefox: false,
    opera: false,
    safari: false,
    vivaldi: false,
    edge: false,
    edgeChromium: false,
    ie: false,
    webkit: false,
    android: false,
    ios: false,
    ipad: false,
    iphone: false,
    ipod: false,
    kindle: false,
    winphone: false,
    blackberry: false,
    playbook: false,
    silk: false
  };
  if (matched.browser) {
    browser[matched.browser] = true;
    browser.version = matched.version;
    browser.versionNumber = parseInt(matched.version, 10);
  }
  if (matched.platform) {
    browser[matched.platform] = true;
  }
  const knownMobiles = browser.android || browser.ios || browser.bb || browser.blackberry || browser.ipad || browser.iphone || browser.ipod || browser.kindle || browser.playbook || browser.silk || browser["windows phone"];
  if (knownMobiles === true || userAgent2.indexOf("mobile") !== -1) {
    browser.mobile = true;
  } else {
    browser.desktop = true;
  }
  if (browser["windows phone"]) {
    browser.winphone = true;
    delete browser["windows phone"];
  }
  if (browser.edga || browser.edgios || browser.edg) {
    browser.edge = true;
    matched.browser = "edge";
  } else if (browser.crios) {
    browser.chrome = true;
    matched.browser = "chrome";
  } else if (browser.fxios) {
    browser.firefox = true;
    matched.browser = "firefox";
  }
  if (browser.ipod || browser.ipad || browser.iphone) {
    browser.ios = true;
  }
  if (browser.vivaldi) {
    matched.browser = "vivaldi";
    browser.vivaldi = true;
  }
  if (
    // Chrome, Opera 15+, Vivaldi and Safari are webkit based browsers
    browser.chrome || browser.opr || browser.safari || browser.vivaldi || browser.mobile === true && browser.ios !== true && knownMobiles !== true
  ) {
    browser.webkit = true;
  }
  if (browser.opr) {
    matched.browser = "opera";
    browser.opera = true;
  }
  if (browser.safari) {
    if (browser.blackberry || browser.bb) {
      matched.browser = "blackberry";
      browser.blackberry = true;
    } else if (browser.playbook) {
      matched.browser = "playbook";
      browser.playbook = true;
    } else if (browser.android) {
      matched.browser = "android";
      browser.android = true;
    } else if (browser.kindle) {
      matched.browser = "kindle";
      browser.kindle = true;
    } else if (browser.silk) {
      matched.browser = "silk";
      browser.silk = true;
    }
  }
  browser.name = matched.browser;
  browser.platform = matched.platform;
  {
    if (userAgent2.indexOf("electron") !== -1) {
      browser.electron = true;
    } else if (document.location.href.indexOf("-extension://") !== -1) {
      browser.bex = true;
    } else {
      if (window.Capacitor !== void 0) {
        browser.capacitor = true;
        browser.nativeMobile = true;
        browser.nativeMobileWrapper = "capacitor";
      } else if (window._cordovaNative !== void 0 || window.cordova !== void 0) {
        browser.cordova = true;
        browser.nativeMobile = true;
        browser.nativeMobileWrapper = "cordova";
      }
      if (isRuntimeSsrPreHydration$1.value === true) {
        preHydrationBrowser$1 = { is: { ...browser } };
      }
      if (hasTouch$1 === true && browser.mac === true && (browser.desktop === true && browser.safari === true || browser.nativeMobile === true && browser.android !== true && browser.ios !== true && browser.ipad !== true)) {
        delete browser.mac;
        delete browser.desktop;
        const platform = Math.min(window.innerHeight, window.innerWidth) > 414 ? "ipad" : "iphone";
        Object.assign(browser, {
          mobile: true,
          ios: true,
          platform,
          [platform]: true
        });
      }
      if (browser.mobile !== true && window.navigator.userAgentData && window.navigator.userAgentData.mobile) {
        delete browser.desktop;
        browser.mobile = true;
      }
    }
  }
  return browser;
}
var userAgent$1 = navigator.userAgent || navigator.vendor || window.opera;
var ssrClient$1 = {
  has: {
    touch: false,
    webStorage: false
  },
  within: { iframe: false }
};
var client$1 = {
  userAgent: userAgent$1,
  is: getPlatform$1(userAgent$1),
  has: {
    touch: hasTouch$1
  },
  within: {
    iframe: window.self !== window.top
  }
};
var Platform$1 = {
  install(opts) {
    const { $q } = opts;
    if (isRuntimeSsrPreHydration$1.value === true) {
      opts.onSSRHydrated.push(() => {
        Object.assign($q.platform, client$1);
        isRuntimeSsrPreHydration$1.value = false;
      });
      $q.platform = reactive(this);
    } else {
      $q.platform = this;
    }
  }
};
{
  let hasWebStorage;
  injectProp$1(client$1.has, "webStorage", () => {
    if (hasWebStorage !== void 0) {
      return hasWebStorage;
    }
    try {
      if (window.localStorage) {
        hasWebStorage = true;
        return true;
      }
    } catch (_) {
    }
    hasWebStorage = false;
    return false;
  });
  Object.assign(Platform$1, client$1);
  if (isRuntimeSsrPreHydration$1.value === true) {
    Object.assign(Platform$1, preHydrationBrowser$1, ssrClient$1);
    preHydrationBrowser$1 = null;
  }
}
var Platform_default$1 = Platform$1;
function createComponent$1(raw) {
  return markRaw(defineComponent(raw));
}
function createDirective$1(raw) {
  return markRaw(raw);
}
var createReactivePlugin$1 = (state2, plugin2) => {
  const reactiveState = reactive(state2);
  for (const name2 in state2) {
    injectProp$1(
      plugin2,
      name2,
      () => reactiveState[name2],
      (val) => {
        reactiveState[name2] = val;
      }
    );
  }
  return plugin2;
};
var listenOpts$1 = {
  hasPassive: false,
  passiveCapture: true,
  notPassiveCapture: true
};
try {
  const opts = Object.defineProperty({}, "passive", {
    get() {
      Object.assign(listenOpts$1, {
        hasPassive: true,
        passive: { passive: true },
        notPassive: { passive: false },
        passiveCapture: { passive: true, capture: true },
        notPassiveCapture: { passive: false, capture: true }
      });
    }
  });
  window.addEventListener("qtest", null, opts);
  window.removeEventListener("qtest", null, opts);
} catch (_) {
}
function noop$1() {
}
function leftClick$1(e22) {
  return e22.button === 0;
}
function position$1(e22) {
  if (e22.touches && e22.touches[0]) {
    e22 = e22.touches[0];
  } else if (e22.changedTouches && e22.changedTouches[0]) {
    e22 = e22.changedTouches[0];
  } else if (e22.targetTouches && e22.targetTouches[0]) {
    e22 = e22.targetTouches[0];
  }
  return {
    top: e22.clientY,
    left: e22.clientX
  };
}
function getEventPath$1(e22) {
  if (e22.path) {
    return e22.path;
  }
  if (e22.composedPath) {
    return e22.composedPath();
  }
  const path = [];
  let el = e22.target;
  while (el) {
    path.push(el);
    if (el.tagName === "HTML") {
      path.push(document);
      path.push(window);
      return path;
    }
    el = el.parentElement;
  }
}
function stop$1(e22) {
  e22.stopPropagation();
}
function prevent$1(e22) {
  e22.cancelable !== false && e22.preventDefault();
}
function stopAndPrevent$1(e22) {
  e22.cancelable !== false && e22.preventDefault();
  e22.stopPropagation();
}
function preventDraggable$1(el, status) {
  if (el === void 0 || status === true && el.__dragPrevented === true) {
    return;
  }
  const fn = status === true ? (el2) => {
    el2.__dragPrevented = true;
    el2.addEventListener("dragstart", prevent$1, listenOpts$1.notPassiveCapture);
  } : (el2) => {
    delete el2.__dragPrevented;
    el2.removeEventListener("dragstart", prevent$1, listenOpts$1.notPassiveCapture);
  };
  el.querySelectorAll("a, img").forEach(fn);
}
function addEvt$1(ctx, targetName, events) {
  const name2 = `__q_${targetName}_evt`;
  ctx[name2] = ctx[name2] !== void 0 ? ctx[name2].concat(events) : events;
  events.forEach((evt) => {
    evt[0].addEventListener(evt[1], ctx[evt[2]], listenOpts$1[evt[3]]);
  });
}
function cleanEvt$1(ctx, targetName) {
  const name2 = `__q_${targetName}_evt`;
  if (ctx[name2] !== void 0) {
    ctx[name2].forEach((evt) => {
      evt[0].removeEventListener(evt[1], ctx[evt[2]], listenOpts$1[evt[3]]);
    });
    ctx[name2] = void 0;
  }
}
function debounce_default$1(fn, wait2 = 250, immediate) {
  let timer2 = null;
  function debounced() {
    const args = arguments;
    const later = () => {
      timer2 = null;
      {
        fn.apply(this, args);
      }
    };
    if (timer2 !== null) {
      clearTimeout(timer2);
    }
    timer2 = setTimeout(later, wait2);
  }
  debounced.cancel = () => {
    timer2 !== null && clearTimeout(timer2);
  };
  return debounced;
}
var SIZE_LIST$1 = ["sm", "md", "lg", "xl"];
var { passive: passive$1 } = listenOpts$1;
createReactivePlugin$1({
  width: 0,
  height: 0,
  name: "xs",
  sizes: {
    sm: 600,
    md: 1024,
    lg: 1440,
    xl: 1920
  },
  lt: {
    sm: true,
    md: true,
    lg: true,
    xl: true
  },
  gt: {
    xs: false,
    sm: false,
    md: false,
    lg: false
  },
  xs: true,
  sm: false,
  md: false,
  lg: false,
  xl: false
}, {
  setSizes: noop$1,
  setDebounce: noop$1,
  install({ $q, onSSRHydrated }) {
    $q.screen = this;
    if (this.__installed === true) {
      if ($q.config.screen !== void 0) {
        if ($q.config.screen.bodyClasses === false) {
          document.body.classList.remove(`screen--${this.name}`);
        } else {
          this.__update(true);
        }
      }
      return;
    }
    const { visualViewport } = window;
    const target2 = visualViewport || window;
    const scrollingElement = document.scrollingElement || document.documentElement;
    const getSize = visualViewport === void 0 || client$1.is.mobile === true ? () => [
      Math.max(window.innerWidth, scrollingElement.clientWidth),
      Math.max(window.innerHeight, scrollingElement.clientHeight)
    ] : () => [
      visualViewport.width * visualViewport.scale + window.innerWidth - scrollingElement.clientWidth,
      visualViewport.height * visualViewport.scale + window.innerHeight - scrollingElement.clientHeight
    ];
    const classes = $q.config.screen !== void 0 && $q.config.screen.bodyClasses === true;
    this.__update = (force) => {
      const [w22, h138] = getSize();
      if (h138 !== this.height) {
        this.height = h138;
      }
      if (w22 !== this.width) {
        this.width = w22;
      } else if (force !== true) {
        return;
      }
      let s32 = this.sizes;
      this.gt.xs = w22 >= s32.sm;
      this.gt.sm = w22 >= s32.md;
      this.gt.md = w22 >= s32.lg;
      this.gt.lg = w22 >= s32.xl;
      this.lt.sm = w22 < s32.sm;
      this.lt.md = w22 < s32.md;
      this.lt.lg = w22 < s32.lg;
      this.lt.xl = w22 < s32.xl;
      this.xs = this.lt.sm;
      this.sm = this.gt.xs === true && this.lt.md === true;
      this.md = this.gt.sm === true && this.lt.lg === true;
      this.lg = this.gt.md === true && this.lt.xl === true;
      this.xl = this.gt.lg;
      s32 = this.xs === true && "xs" || this.sm === true && "sm" || this.md === true && "md" || this.lg === true && "lg" || "xl";
      if (s32 !== this.name) {
        if (classes === true) {
          document.body.classList.remove(`screen--${this.name}`);
          document.body.classList.add(`screen--${s32}`);
        }
        this.name = s32;
      }
    };
    let updateEvt, updateSizes = {}, updateDebounce = 16;
    this.setSizes = (sizes) => {
      SIZE_LIST$1.forEach((name2) => {
        if (sizes[name2] !== void 0) {
          updateSizes[name2] = sizes[name2];
        }
      });
    };
    this.setDebounce = (deb) => {
      updateDebounce = deb;
    };
    const start = () => {
      const style2 = getComputedStyle(document.body);
      if (style2.getPropertyValue("--q-size-sm")) {
        SIZE_LIST$1.forEach((name2) => {
          this.sizes[name2] = parseInt(style2.getPropertyValue(`--q-size-${name2}`), 10);
        });
      }
      this.setSizes = (sizes) => {
        SIZE_LIST$1.forEach((name2) => {
          if (sizes[name2]) {
            this.sizes[name2] = sizes[name2];
          }
        });
        this.__update(true);
      };
      this.setDebounce = (delay) => {
        updateEvt !== void 0 && target2.removeEventListener("resize", updateEvt, passive$1);
        updateEvt = delay > 0 ? debounce_default$1(this.__update, delay) : this.__update;
        target2.addEventListener("resize", updateEvt, passive$1);
      };
      this.setDebounce(updateDebounce);
      if (Object.keys(updateSizes).length !== 0) {
        this.setSizes(updateSizes);
        updateSizes = void 0;
      } else {
        this.__update();
      }
      classes === true && this.name === "xs" && document.body.classList.add("screen--xs");
    };
    if (isRuntimeSsrPreHydration$1.value === true) {
      onSSRHydrated.push(start);
    } else {
      start();
    }
  }
});
var Plugin$1 = createReactivePlugin$1({
  isActive: false,
  mode: false
}, {
  __media: void 0,
  set(val) {
    Plugin$1.mode = val;
    if (val === "auto") {
      if (Plugin$1.__media === void 0) {
        Plugin$1.__media = window.matchMedia("(prefers-color-scheme: dark)");
        Plugin$1.__updateMedia = () => {
          Plugin$1.set("auto");
        };
        Plugin$1.__media.addListener(Plugin$1.__updateMedia);
      }
      val = Plugin$1.__media.matches;
    } else if (Plugin$1.__media !== void 0) {
      Plugin$1.__media.removeListener(Plugin$1.__updateMedia);
      Plugin$1.__media = void 0;
    }
    Plugin$1.isActive = val === true;
    document.body.classList.remove(`body--${val === true ? "light" : "dark"}`);
    document.body.classList.add(`body--${val === true ? "dark" : "light"}`);
  },
  toggle() {
    {
      Plugin$1.set(Plugin$1.isActive === false);
    }
  },
  install({ $q, ssrContext }) {
    const { dark } = $q.config;
    $q.dark = this;
    if (this.__installed !== true) {
      this.set(dark !== void 0 ? dark : false);
    }
  }
});
function shouldIgnoreKey$1(evt) {
  return evt !== Object(evt) || evt.isComposing === true || evt.qKeyEvent === true;
}
function isKeyCode$1(evt, keyCodes4) {
  return shouldIgnoreKey$1(evt) === true ? false : [].concat(keyCodes4).includes(evt.keyCode);
}
var en_US_default$1 = {
  isoName: "en-US",
  nativeName: "English (US)",
  label: {
    clear: "Clear",
    ok: "OK",
    cancel: "Cancel",
    close: "Close",
    set: "Set",
    select: "Select",
    reset: "Reset",
    remove: "Remove",
    update: "Update",
    create: "Create",
    search: "Search",
    filter: "Filter",
    refresh: "Refresh",
    expand: (label) => label ? `Expand "${label}"` : "Expand",
    collapse: (label) => label ? `Collapse "${label}"` : "Collapse"
  },
  date: {
    days: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
    daysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
    months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
    monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
    firstDayOfWeek: 0,
    // 0-6, 0 - Sunday, 1 Monday, ...
    format24h: false,
    pluralDay: "days"
  },
  table: {
    noData: "No data available",
    noResults: "No matching records found",
    loading: "Loading...",
    selectedRecords: (rows) => rows === 1 ? "1 record selected." : (rows === 0 ? "No" : rows) + " records selected.",
    recordsPerPage: "Records per page:",
    allRows: "All",
    pagination: (start, end, total) => start + "-" + end + " of " + total,
    columns: "Columns"
  },
  editor: {
    url: "URL",
    bold: "Bold",
    italic: "Italic",
    strikethrough: "Strikethrough",
    underline: "Underline",
    unorderedList: "Unordered List",
    orderedList: "Ordered List",
    subscript: "Subscript",
    superscript: "Superscript",
    hyperlink: "Hyperlink",
    toggleFullscreen: "Toggle Fullscreen",
    quote: "Quote",
    left: "Left align",
    center: "Center align",
    right: "Right align",
    justify: "Justify align",
    print: "Print",
    outdent: "Decrease indentation",
    indent: "Increase indentation",
    removeFormat: "Remove formatting",
    formatting: "Formatting",
    fontSize: "Font Size",
    align: "Align",
    hr: "Insert Horizontal Rule",
    undo: "Undo",
    redo: "Redo",
    heading1: "Heading 1",
    heading2: "Heading 2",
    heading3: "Heading 3",
    heading4: "Heading 4",
    heading5: "Heading 5",
    heading6: "Heading 6",
    paragraph: "Paragraph",
    code: "Code",
    size1: "Very small",
    size2: "A bit small",
    size3: "Normal",
    size4: "Medium-large",
    size5: "Big",
    size6: "Very big",
    size7: "Maximum",
    defaultFont: "Default Font",
    viewSource: "View Source"
  },
  tree: {
    noNodes: "No nodes available",
    noResults: "No matching nodes found"
  }
};
function getLocale$1() {
  const val = Array.isArray(navigator.languages) === true && navigator.languages.length !== 0 ? navigator.languages[0] : navigator.language;
  if (typeof val === "string") {
    return val.split(/[-_]/).map((v, i22) => i22 === 0 ? v.toLowerCase() : i22 > 1 || v.length < 4 ? v.toUpperCase() : v[0].toUpperCase() + v.slice(1).toLowerCase()).join("-");
  }
}
var Plugin2$1 = createReactivePlugin$1({
  __qLang: {}
}, {
  // props: object
  // __langConfig: object
  getLocale: getLocale$1,
  set(langObject = en_US_default$1, ssrContext) {
    const lang = {
      ...langObject,
      rtl: langObject.rtl === true,
      getLocale: getLocale$1
    };
    {
      lang.set = Plugin2$1.set;
      if (Plugin2$1.__langConfig === void 0 || Plugin2$1.__langConfig.noHtmlAttrs !== true) {
        const el = document.documentElement;
        el.setAttribute("dir", lang.rtl === true ? "rtl" : "ltr");
        el.setAttribute("lang", lang.isoName);
      }
      Object.assign(Plugin2$1.__qLang, lang);
    }
  },
  install({ $q, lang, ssrContext }) {
    {
      $q.lang = Plugin2$1.__qLang;
      Plugin2$1.__langConfig = $q.config.lang;
      if (this.__installed === true) {
        lang !== void 0 && this.set(lang);
      } else {
        this.props = new Proxy(this.__qLang, {
          get() {
            return Reflect.get(...arguments);
          },
          ownKeys(target2) {
            return Reflect.ownKeys(target2).filter((key) => key !== "set" && key !== "getLocale");
          }
        });
        this.set(lang || en_US_default$1);
      }
    }
  }
});
var Lang_default$1 = Plugin2$1;
var material_icons_default$1 = {
  name: "material-icons",
  type: {
    positive: "check_circle",
    negative: "warning",
    info: "info",
    warning: "priority_high"
  },
  arrow: {
    up: "arrow_upward",
    right: "arrow_forward",
    down: "arrow_downward",
    left: "arrow_back",
    dropdown: "arrow_drop_down"
  },
  chevron: {
    left: "chevron_left",
    right: "chevron_right"
  },
  colorPicker: {
    spectrum: "gradient",
    tune: "tune",
    palette: "style"
  },
  pullToRefresh: {
    icon: "refresh"
  },
  carousel: {
    left: "chevron_left",
    right: "chevron_right",
    up: "keyboard_arrow_up",
    down: "keyboard_arrow_down",
    navigationIcon: "lens"
  },
  chip: {
    remove: "cancel",
    selected: "check"
  },
  datetime: {
    arrowLeft: "chevron_left",
    arrowRight: "chevron_right",
    now: "access_time",
    today: "today"
  },
  editor: {
    bold: "format_bold",
    italic: "format_italic",
    strikethrough: "strikethrough_s",
    underline: "format_underlined",
    unorderedList: "format_list_bulleted",
    orderedList: "format_list_numbered",
    subscript: "vertical_align_bottom",
    superscript: "vertical_align_top",
    hyperlink: "link",
    toggleFullscreen: "fullscreen",
    quote: "format_quote",
    left: "format_align_left",
    center: "format_align_center",
    right: "format_align_right",
    justify: "format_align_justify",
    print: "print",
    outdent: "format_indent_decrease",
    indent: "format_indent_increase",
    removeFormat: "format_clear",
    formatting: "text_format",
    fontSize: "format_size",
    align: "format_align_left",
    hr: "remove",
    undo: "undo",
    redo: "redo",
    heading: "format_size",
    code: "code",
    size: "format_size",
    font: "font_download",
    viewSource: "code"
  },
  expansionItem: {
    icon: "keyboard_arrow_down",
    denseIcon: "arrow_drop_down"
  },
  fab: {
    icon: "add",
    activeIcon: "close"
  },
  field: {
    clear: "cancel",
    error: "error"
  },
  pagination: {
    first: "first_page",
    prev: "keyboard_arrow_left",
    next: "keyboard_arrow_right",
    last: "last_page"
  },
  rating: {
    icon: "grade"
  },
  stepper: {
    done: "check",
    active: "edit",
    error: "warning"
  },
  tabs: {
    left: "chevron_left",
    right: "chevron_right",
    up: "keyboard_arrow_up",
    down: "keyboard_arrow_down"
  },
  table: {
    arrowUp: "arrow_upward",
    warning: "warning",
    firstPage: "first_page",
    prevPage: "chevron_left",
    nextPage: "chevron_right",
    lastPage: "last_page"
  },
  tree: {
    icon: "play_arrow"
  },
  uploader: {
    done: "done",
    clear: "clear",
    add: "add_box",
    upload: "cloud_upload",
    removeQueue: "clear_all",
    removeUploaded: "done_all"
  }
};
var Plugin3$1 = createReactivePlugin$1({
  iconMapFn: null,
  __qIconSet: {}
}, {
  // props: object
  set(setObject, ssrContext) {
    const def = { ...setObject };
    {
      def.set = Plugin3$1.set;
      Object.assign(Plugin3$1.__qIconSet, def);
    }
  },
  install({ $q, iconSet, ssrContext }) {
    {
      if ($q.config.iconMapFn !== void 0) {
        this.iconMapFn = $q.config.iconMapFn;
      }
      $q.iconSet = this.__qIconSet;
      injectProp$1($q, "iconMapFn", () => this.iconMapFn, (val) => {
        this.iconMapFn = val;
      });
      if (this.__installed === true) {
        iconSet !== void 0 && this.set(iconSet);
      } else {
        this.props = new Proxy(this.__qIconSet, {
          get() {
            return Reflect.get(...arguments);
          },
          ownKeys(target2) {
            return Reflect.ownKeys(target2).filter((key) => key !== "set");
          }
        });
        this.set(iconSet || material_icons_default$1);
      }
    }
  }
});
var quasarKey = "_q_";
var timelineKey$1 = "_q_t_";
var stepperKey$1 = "_q_s_";
var layoutKey$1 = "_q_l_";
var pageContainerKey$1 = "_q_pc_";
var fabKey$1 = "_q_f_";
var formKey$1 = "_q_fo_";
var tabsKey$1 = "_q_tabs_";
var uploaderKey$1 = "_q_u_";
function emptyRenderFn$1() {
}
var globalConfig$1 = {};
function isDeepEqual$1(a32, b22) {
  if (a32 === b22) {
    return true;
  }
  if (a32 !== null && b22 !== null && typeof a32 === "object" && typeof b22 === "object") {
    if (a32.constructor !== b22.constructor) {
      return false;
    }
    let length, i22;
    if (a32.constructor === Array) {
      length = a32.length;
      if (length !== b22.length) {
        return false;
      }
      for (i22 = length; i22-- !== 0; ) {
        if (isDeepEqual$1(a32[i22], b22[i22]) !== true) {
          return false;
        }
      }
      return true;
    }
    if (a32.constructor === Map) {
      if (a32.size !== b22.size) {
        return false;
      }
      let iter = a32.entries();
      i22 = iter.next();
      while (i22.done !== true) {
        if (b22.has(i22.value[0]) !== true) {
          return false;
        }
        i22 = iter.next();
      }
      iter = a32.entries();
      i22 = iter.next();
      while (i22.done !== true) {
        if (isDeepEqual$1(i22.value[1], b22.get(i22.value[0])) !== true) {
          return false;
        }
        i22 = iter.next();
      }
      return true;
    }
    if (a32.constructor === Set) {
      if (a32.size !== b22.size) {
        return false;
      }
      const iter = a32.entries();
      i22 = iter.next();
      while (i22.done !== true) {
        if (b22.has(i22.value[0]) !== true) {
          return false;
        }
        i22 = iter.next();
      }
      return true;
    }
    if (a32.buffer != null && a32.buffer.constructor === ArrayBuffer) {
      length = a32.length;
      if (length !== b22.length) {
        return false;
      }
      for (i22 = length; i22-- !== 0; ) {
        if (a32[i22] !== b22[i22]) {
          return false;
        }
      }
      return true;
    }
    if (a32.constructor === RegExp) {
      return a32.source === b22.source && a32.flags === b22.flags;
    }
    if (a32.valueOf !== Object.prototype.valueOf) {
      return a32.valueOf() === b22.valueOf();
    }
    if (a32.toString !== Object.prototype.toString) {
      return a32.toString() === b22.toString();
    }
    const keys2 = Object.keys(a32).filter((key) => a32[key] !== void 0);
    length = keys2.length;
    if (length !== Object.keys(b22).filter((key) => b22[key] !== void 0).length) {
      return false;
    }
    for (i22 = length; i22-- !== 0; ) {
      const key = keys2[i22];
      if (isDeepEqual$1(a32[key], b22[key]) !== true) {
        return false;
      }
    }
    return true;
  }
  return a32 !== a32 && b22 !== b22;
}
function isObject$1(v) {
  return v !== null && typeof v === "object" && Array.isArray(v) !== true;
}
function isDate$1(v) {
  return Object.prototype.toString.call(v) === "[object Date]";
}
function isRegexp$1(v) {
  return Object.prototype.toString.call(v) === "[object RegExp]";
}
function isNumber$1(v) {
  return typeof v === "number" && isFinite(v);
}
function createChildApp$1(appCfg, parentApp) {
  const app2 = createApp(appCfg);
  app2.config.globalProperties = parentApp.config.globalProperties;
  const { reload, ...appContext } = parentApp._context;
  Object.assign(app2._context, appContext);
  return app2;
}
var units$1 = ["B", "KB", "MB", "GB", "TB", "PB"];
function humanStorageSize$1(bytes, decimals = 1) {
  let u22 = 0;
  while (parseInt(bytes, 10) >= 1024 && u22 < units$1.length - 1) {
    bytes /= 1024;
    ++u22;
  }
  return `${bytes.toFixed(decimals)}${units$1[u22]}`;
}
function between$1(v, min2, max2) {
  return max2 <= min2 ? min2 : Math.min(max2, Math.max(min2, v));
}
function normalizeToInterval$1(v, min2, max2) {
  if (max2 <= min2) {
    return min2;
  }
  const size2 = max2 - min2 + 1;
  let index2 = min2 + (v - min2) % size2;
  if (index2 < min2) {
    index2 = size2 + index2;
  }
  return index2 === 0 ? 0 : index2;
}
function pad$1(v, length = 2, char = "0") {
  if (v === void 0 || v === null) {
    return v;
  }
  const val = "" + v;
  return val.length >= length ? val : new Array(length - val.length + 1).join(char) + val;
}
var xhr$1 = XMLHttpRequest;
var open$1 = xhr$1.prototype.open;
var positionValues$1 = ["top", "right", "bottom", "left"];
var stack$1 = [];
var highjackCount$1 = 0;
function translate$1({ p: p2, pos, active, horiz, reverse, dir }) {
  let x22 = 1, y32 = 1;
  if (horiz === true) {
    if (reverse === true) {
      x22 = -1;
    }
    if (pos === "bottom") {
      y32 = -1;
    }
    return { transform: `translate3d(${x22 * (p2 - 100)}%,${active ? 0 : y32 * -200}%,0)` };
  }
  if (reverse === true) {
    y32 = -1;
  }
  if (pos === "right") {
    x22 = -1;
  }
  return { transform: `translate3d(${active ? 0 : dir * x22 * -200}%,${y32 * (p2 - 100)}%,0)` };
}
function inc$1(p2, amount) {
  if (typeof amount !== "number") {
    if (p2 < 25) {
      amount = Math.random() * 3 + 3;
    } else if (p2 < 65) {
      amount = Math.random() * 3;
    } else if (p2 < 85) {
      amount = Math.random() * 2;
    } else if (p2 < 99) {
      amount = 0.6;
    } else {
      amount = 0;
    }
  }
  return between$1(p2 + amount, 0, 100);
}
function highjackAjax$1(stackEntry) {
  highjackCount$1++;
  stack$1.push(stackEntry);
  if (highjackCount$1 > 1) return;
  xhr$1.prototype.open = function(_, url) {
    const stopStack = [];
    const loadStart = () => {
      stack$1.forEach((entry) => {
        if (entry.hijackFilter.value === null || entry.hijackFilter.value(url) === true) {
          entry.start();
          stopStack.push(entry.stop);
        }
      });
    };
    const loadEnd = () => {
      stopStack.forEach((stop2) => {
        stop2();
      });
    };
    this.addEventListener("loadstart", loadStart, { once: true });
    this.addEventListener("loadend", loadEnd, { once: true });
    open$1.apply(this, arguments);
  };
}
function restoreAjax$1(start) {
  stack$1 = stack$1.filter((entry) => entry.start !== start);
  highjackCount$1 = Math.max(0, highjackCount$1 - 1);
  if (highjackCount$1 === 0) {
    xhr$1.prototype.open = open$1;
  }
}
var QAjaxBar_default$1 = createComponent$1({
  name: "QAjaxBar",
  props: {
    position: {
      type: String,
      default: "top",
      validator: (val) => positionValues$1.includes(val)
    },
    size: {
      type: String,
      default: "2px"
    },
    color: String,
    skipHijack: Boolean,
    reverse: Boolean,
    hijackFilter: Function
  },
  emits: ["start", "stop"],
  setup(props4, { emit }) {
    const { proxy } = getCurrentInstance();
    const progress = ref$1(0);
    const onScreen = ref$1(false);
    const animate = ref$1(true);
    let sessions = 0, timer2 = null, speed;
    const classes = computed(
      () => `q-loading-bar q-loading-bar--${props4.position}` + (props4.color !== void 0 ? ` bg-${props4.color}` : "") + (animate.value === true ? "" : " no-transition")
    );
    const horizontal = computed(() => props4.position === "top" || props4.position === "bottom");
    const sizeProp = computed(() => horizontal.value === true ? "height" : "width");
    const style2 = computed(() => {
      const active = onScreen.value;
      const obj = translate$1({
        p: progress.value,
        pos: props4.position,
        active,
        horiz: horizontal.value,
        reverse: proxy.$q.lang.rtl === true && ["top", "bottom"].includes(props4.position) ? props4.reverse === false : props4.reverse,
        dir: proxy.$q.lang.rtl === true ? -1 : 1
      });
      obj[sizeProp.value] = props4.size;
      obj.opacity = active ? 1 : 0;
      return obj;
    });
    const attributes = computed(() => onScreen.value === true ? {
      role: "progressbar",
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-valuenow": progress.value
    } : { "aria-hidden": "true" });
    function start(newSpeed = 300) {
      const oldSpeed = speed;
      speed = Math.max(0, newSpeed) || 0;
      sessions++;
      if (sessions > 1) {
        if (oldSpeed === 0 && newSpeed > 0) {
          planNextStep();
        } else if (timer2 !== null && oldSpeed > 0 && newSpeed <= 0) {
          clearTimeout(timer2);
          timer2 = null;
        }
        return sessions;
      }
      timer2 !== null && clearTimeout(timer2);
      emit("start");
      progress.value = 0;
      timer2 = setTimeout(() => {
        timer2 = null;
        animate.value = true;
        newSpeed > 0 && planNextStep();
      }, onScreen._value === true ? 500 : 1);
      if (onScreen._value !== true) {
        onScreen.value = true;
        animate.value = false;
      }
      return sessions;
    }
    function increment(amount) {
      if (sessions > 0) {
        progress.value = inc$1(progress.value, amount);
      }
      return sessions;
    }
    function stop2() {
      sessions = Math.max(0, sessions - 1);
      if (sessions > 0) {
        return sessions;
      }
      if (timer2 !== null) {
        clearTimeout(timer2);
        timer2 = null;
      }
      emit("stop");
      const end = () => {
        animate.value = true;
        progress.value = 100;
        timer2 = setTimeout(() => {
          timer2 = null;
          onScreen.value = false;
        }, 1e3);
      };
      if (progress.value === 0) {
        timer2 = setTimeout(end, 1);
      } else {
        end();
      }
      return sessions;
    }
    function planNextStep() {
      if (progress.value < 100) {
        timer2 = setTimeout(() => {
          timer2 = null;
          increment();
          planNextStep();
        }, speed);
      }
    }
    let hijacked;
    onMounted(() => {
      if (props4.skipHijack !== true) {
        hijacked = true;
        highjackAjax$1({
          start,
          stop: stop2,
          hijackFilter: computed(() => props4.hijackFilter || null)
        });
      }
    });
    onBeforeUnmount(() => {
      timer2 !== null && clearTimeout(timer2);
      hijacked === true && restoreAjax$1(start);
    });
    Object.assign(proxy, { start, stop: stop2, increment });
    return () => h("div", {
      class: classes.value,
      style: style2.value,
      ...attributes.value
    });
  }
});
var useSizeDefaults$1 = {
  xs: 18,
  sm: 24,
  md: 32,
  lg: 38,
  xl: 46
};
var useSizeProps$1 = {
  size: String
};
function use_size_default$1(props4, sizes = useSizeDefaults$1) {
  return computed(() => props4.size !== void 0 ? { fontSize: props4.size in sizes ? `${sizes[props4.size]}px` : props4.size } : null);
}
function hSlot$1(slot, otherwise) {
  return slot !== void 0 ? slot() || otherwise : otherwise;
}
function hUniqueSlot$1(slot, otherwise) {
  if (slot !== void 0) {
    const vnode = slot();
    if (vnode !== void 0 && vnode !== null) {
      return vnode.slice();
    }
  }
  return otherwise;
}
function hMergeSlot$1(slot, source) {
  return slot !== void 0 ? source.concat(slot()) : source;
}
function hMergeSlotSafely$1(slot, source) {
  if (slot === void 0) {
    return source;
  }
  return source !== void 0 ? source.concat(slot()) : slot();
}
function hDir$1(tag, data, children, key, condition, getDirsFn) {
  data.key = key + condition;
  const vnode = h(tag, data, children);
  return condition === true ? withDirectives(vnode, getDirsFn()) : vnode;
}
var defaultViewBox$1 = "0 0 24 24";
var sameFn$1 = (i22) => i22;
var ionFn$1 = (i22) => `ionicons ${i22}`;
var libMap$1 = {
  "mdi-": (i22) => `mdi ${i22}`,
  "icon-": sameFn$1,
  // fontawesome equiv
  "bt-": (i22) => `bt ${i22}`,
  "eva-": (i22) => `eva ${i22}`,
  "ion-md": ionFn$1,
  "ion-ios": ionFn$1,
  "ion-logo": ionFn$1,
  "iconfont ": sameFn$1,
  "ti-": (i22) => `themify-icon ${i22}`,
  "bi-": (i22) => `bootstrap-icons ${i22}`
};
var matMap$1 = {
  o_: "-outlined",
  r_: "-round",
  s_: "-sharp"
};
var symMap$1 = {
  sym_o_: "-outlined",
  sym_r_: "-rounded",
  sym_s_: "-sharp"
};
var libRE$1 = new RegExp("^(" + Object.keys(libMap$1).join("|") + ")");
var matRE$1 = new RegExp("^(" + Object.keys(matMap$1).join("|") + ")");
var symRE$1 = new RegExp("^(" + Object.keys(symMap$1).join("|") + ")");
var mRE$1 = /^[Mm]\s?[-+]?\.?\d/;
var imgRE$1 = /^img:/;
var svgUseRE$1 = /^svguse:/;
var ionRE$1 = /^ion-/;
var faRE$1 = /^(fa-(classic|sharp|solid|regular|light|brands|duotone|thin)|[lf]a[srlbdk]?) /;
var QIcon_default$1 = createComponent$1({
  name: "QIcon",
  props: {
    ...useSizeProps$1,
    tag: {
      type: String,
      default: "i"
    },
    name: String,
    color: String,
    left: Boolean,
    right: Boolean
  },
  setup(props4, { slots }) {
    const { proxy: { $q } } = getCurrentInstance();
    const sizeStyle = use_size_default$1(props4);
    const classes = computed(
      () => "q-icon" + (props4.left === true ? " on-left" : "") + (props4.right === true ? " on-right" : "") + (props4.color !== void 0 ? ` text-${props4.color}` : "")
    );
    const type2 = computed(() => {
      let cls;
      let icon = props4.name;
      if (icon === "none" || !icon) {
        return { none: true };
      }
      if ($q.iconMapFn !== null) {
        const res = $q.iconMapFn(icon);
        if (res !== void 0) {
          if (res.icon !== void 0) {
            icon = res.icon;
            if (icon === "none" || !icon) {
              return { none: true };
            }
          } else {
            return {
              cls: res.cls,
              content: res.content !== void 0 ? res.content : " "
            };
          }
        }
      }
      if (mRE$1.test(icon) === true) {
        const [def, viewBox = defaultViewBox$1] = icon.split("|");
        return {
          svg: true,
          viewBox,
          nodes: def.split("&&").map((path) => {
            const [d32, style2, transform] = path.split("@@");
            return h("path", { style: style2, d: d32, transform });
          })
        };
      }
      if (imgRE$1.test(icon) === true) {
        return {
          img: true,
          src: icon.substring(4)
        };
      }
      if (svgUseRE$1.test(icon) === true) {
        const [def, viewBox = defaultViewBox$1] = icon.split("|");
        return {
          svguse: true,
          src: def.substring(7),
          viewBox
        };
      }
      let content = " ";
      const matches = icon.match(libRE$1);
      if (matches !== null) {
        cls = libMap$1[matches[1]](icon);
      } else if (faRE$1.test(icon) === true) {
        cls = icon;
      } else if (ionRE$1.test(icon) === true) {
        cls = `ionicons ion-${$q.platform.is.ios === true ? "ios" : "md"}${icon.substring(3)}`;
      } else if (symRE$1.test(icon) === true) {
        cls = "notranslate material-symbols";
        const matches2 = icon.match(symRE$1);
        if (matches2 !== null) {
          icon = icon.substring(6);
          cls += symMap$1[matches2[1]];
        }
        content = icon;
      } else {
        cls = "notranslate material-icons";
        const matches2 = icon.match(matRE$1);
        if (matches2 !== null) {
          icon = icon.substring(2);
          cls += matMap$1[matches2[1]];
        }
        content = icon;
      }
      return {
        cls,
        content
      };
    });
    return () => {
      const data = {
        class: classes.value,
        style: sizeStyle.value,
        "aria-hidden": "true",
        role: "presentation"
      };
      if (type2.value.none === true) {
        return h(props4.tag, data, hSlot$1(slots.default));
      }
      if (type2.value.img === true) {
        return h(props4.tag, data, hMergeSlot$1(slots.default, [
          h("img", { src: type2.value.src })
        ]));
      }
      if (type2.value.svg === true) {
        return h(props4.tag, data, hMergeSlot$1(slots.default, [
          h("svg", {
            viewBox: type2.value.viewBox || "0 0 24 24"
          }, type2.value.nodes)
        ]));
      }
      if (type2.value.svguse === true) {
        return h(props4.tag, data, hMergeSlot$1(slots.default, [
          h("svg", {
            viewBox: type2.value.viewBox
          }, [
            h("use", { "xlink:href": type2.value.src })
          ])
        ]));
      }
      if (type2.value.cls !== void 0) {
        data.class += " " + type2.value.cls;
      }
      return h(props4.tag, data, hMergeSlot$1(slots.default, [
        type2.value.content
      ]));
    };
  }
});
var QAvatar_default = createComponent$1({
  name: "QAvatar",
  props: {
    ...useSizeProps$1,
    fontSize: String,
    color: String,
    textColor: String,
    icon: String,
    square: Boolean,
    rounded: Boolean
  },
  setup(props4, { slots }) {
    const sizeStyle = use_size_default$1(props4);
    const classes = computed(
      () => "q-avatar" + (props4.color ? ` bg-${props4.color}` : "") + (props4.textColor ? ` text-${props4.textColor} q-chip--colored` : "") + (props4.square === true ? " q-avatar--square" : props4.rounded === true ? " rounded-borders" : "")
    );
    const contentStyle = computed(() => props4.fontSize ? { fontSize: props4.fontSize } : null);
    return () => {
      const icon = props4.icon !== void 0 ? [h(QIcon_default$1, { name: props4.icon })] : void 0;
      return h("div", {
        class: classes.value,
        style: sizeStyle.value
      }, [
        h("div", {
          class: "q-avatar__content row flex-center overflow-hidden",
          style: contentStyle.value
        }, hMergeSlotSafely$1(slots.default, icon))
      ]);
    };
  }
});
var alignValues$1 = ["top", "middle", "bottom"];
createComponent$1({
  name: "QBadge",
  props: {
    color: String,
    textColor: String,
    floating: Boolean,
    transparent: Boolean,
    multiLine: Boolean,
    outline: Boolean,
    rounded: Boolean,
    label: [Number, String],
    align: {
      type: String,
      validator: (v) => alignValues$1.includes(v)
    }
  },
  setup(props4, { slots }) {
    const style2 = computed(() => {
      return props4.align !== void 0 ? { verticalAlign: props4.align } : null;
    });
    const classes = computed(() => {
      const text2 = props4.outline === true ? props4.color || props4.textColor : props4.textColor;
      return `q-badge flex inline items-center no-wrap q-badge--${props4.multiLine === true ? "multi" : "single"}-line` + (props4.outline === true ? " q-badge--outline" : props4.color !== void 0 ? ` bg-${props4.color}` : "") + (text2 !== void 0 ? ` text-${text2}` : "") + (props4.floating === true ? " q-badge--floating" : "") + (props4.rounded === true ? " q-badge--rounded" : "") + (props4.transparent === true ? " q-badge--transparent" : "");
    });
    return () => h("div", {
      class: classes.value,
      style: style2.value,
      role: "status",
      "aria-label": props4.label
    }, hMergeSlot$1(slots.default, props4.label !== void 0 ? [props4.label] : []));
  }
});
var useDarkProps$1 = {
  dark: {
    type: Boolean,
    default: null
  }
};
function use_dark_default$1(props4, $q) {
  return computed(() => props4.dark === null ? $q.dark.isActive : props4.dark);
}
createComponent$1({
  name: "QBanner",
  props: {
    ...useDarkProps$1,
    inlineActions: Boolean,
    dense: Boolean,
    rounded: Boolean
  },
  setup(props4, { slots }) {
    const { proxy: { $q } } = getCurrentInstance();
    const isDark = use_dark_default$1(props4, $q);
    const classes = computed(
      () => "q-banner row items-center" + (props4.dense === true ? " q-banner--dense" : "") + (isDark.value === true ? " q-banner--dark q-dark" : "") + (props4.rounded === true ? " rounded-borders" : "")
    );
    const actionClass = computed(
      () => `q-banner__actions row items-center justify-end col-${props4.inlineActions === true ? "auto" : "all"}`
    );
    return () => {
      const child = [
        h("div", {
          class: "q-banner__avatar col-auto row items-center self-start"
        }, hSlot$1(slots.avatar)),
        h("div", {
          class: "q-banner__content col text-body2"
        }, hSlot$1(slots.default))
      ];
      const actions = hSlot$1(slots.action);
      actions !== void 0 && child.push(
        h("div", { class: actionClass.value }, actions)
      );
      return h("div", {
        class: classes.value + (props4.inlineActions === false && actions !== void 0 ? " q-banner--top-padding" : ""),
        role: "alert"
      }, child);
    };
  }
});
createComponent$1({
  name: "QBar",
  props: {
    ...useDarkProps$1,
    dense: Boolean
  },
  setup(props4, { slots }) {
    const { proxy: { $q } } = getCurrentInstance();
    const isDark = use_dark_default$1(props4, $q);
    const classes = computed(
      () => `q-bar row no-wrap items-center q-bar--${props4.dense === true ? "dense" : "standard"}  q-bar--${isDark.value === true ? "dark" : "light"}`
    );
    return () => h("div", {
      class: classes.value,
      role: "toolbar"
    }, hSlot$1(slots.default));
  }
});
var alignMap$1 = {
  left: "start",
  center: "center",
  right: "end",
  between: "between",
  around: "around",
  evenly: "evenly",
  stretch: "stretch"
};
var alignValues2$1 = Object.keys(alignMap$1);
var useAlignProps$1 = {
  align: {
    type: String,
    validator: (v) => alignValues2$1.includes(v)
  }
};
function use_align_default$1(props4) {
  return computed(() => {
    const align = props4.align === void 0 ? props4.vertical === true ? "stretch" : "left" : props4.align;
    return `${props4.vertical === true ? "items" : "justify"}-${alignMap$1[align]}`;
  });
}
function getParentProxy$1(proxy) {
  if (Object(proxy.$parent) === proxy.$parent) {
    return proxy.$parent;
  }
  let { parent } = proxy.$;
  while (Object(parent) === parent) {
    if (Object(parent.proxy) === parent.proxy) {
      return parent.proxy;
    }
    parent = parent.parent;
  }
}
function fillNormalizedVNodes$1(children, vnode) {
  if (typeof vnode.type === "symbol") {
    if (Array.isArray(vnode.children) === true) {
      vnode.children.forEach((child) => {
        fillNormalizedVNodes$1(children, child);
      });
    }
  } else {
    children.add(vnode);
  }
}
function getNormalizedVNodes$1(vnodes) {
  const children = /* @__PURE__ */ new Set();
  vnodes.forEach((vnode) => {
    fillNormalizedVNodes$1(children, vnode);
  });
  return Array.from(children);
}
function vmHasRouter$1(vm2) {
  return vm2.appContext.config.globalProperties.$router !== void 0;
}
function vmIsDestroyed$1(vm2) {
  return vm2.isUnmounted === true || vm2.isDeactivated === true;
}
var disabledValues$1 = ["", true];
createComponent$1({
  name: "QBreadcrumbs",
  props: {
    ...useAlignProps$1,
    separator: {
      type: String,
      default: "/"
    },
    separatorColor: String,
    activeColor: {
      type: String,
      default: "primary"
    },
    gutter: {
      type: String,
      validator: (v) => ["none", "xs", "sm", "md", "lg", "xl"].includes(v),
      default: "sm"
    }
  },
  setup(props4, { slots }) {
    const alignClass = use_align_default$1(props4);
    const classes = computed(
      () => `flex items-center ${alignClass.value}${props4.gutter === "none" ? "" : ` q-gutter-${props4.gutter}`}`
    );
    const sepClass = computed(() => props4.separatorColor ? ` text-${props4.separatorColor}` : "");
    const activeClass = computed(() => ` text-${props4.activeColor}`);
    return () => {
      if (slots.default === void 0) return;
      const vnodes = getNormalizedVNodes$1(
        hSlot$1(slots.default)
      );
      if (vnodes.length === 0) return;
      let els = 1;
      const child = [], len = vnodes.filter((c3) => c3.type !== void 0 && c3.type.name === "QBreadcrumbsEl").length, separator = slots.separator !== void 0 ? slots.separator : () => props4.separator;
      vnodes.forEach((comp) => {
        if (comp.type !== void 0 && comp.type.name === "QBreadcrumbsEl") {
          const middle = els < len;
          const disabled = comp.props !== null && disabledValues$1.includes(comp.props.disable);
          const cls = (middle === true ? "" : " q-breadcrumbs--last") + (disabled !== true && middle === true ? activeClass.value : "");
          els++;
          child.push(
            h("div", {
              class: `flex items-center${cls}`
            }, [comp])
          );
          if (middle === true) {
            child.push(
              h("div", {
                class: "q-breadcrumbs__separator" + sepClass.value
              }, separator())
            );
          }
        } else {
          child.push(comp);
        }
      });
      return h("div", {
        class: "q-breadcrumbs"
      }, [
        h("div", { class: classes.value }, child)
      ]);
    };
  }
});
function getOriginalPath$1(record) {
  return record ? record.aliasOf ? record.aliasOf.path : record.path : "";
}
function isSameRouteRecord$1(a32, b22) {
  return (a32.aliasOf || a32) === (b22.aliasOf || b22);
}
function includesParams$1(outer, inner) {
  for (const key in inner) {
    const innerValue = inner[key], outerValue = outer[key];
    if (typeof innerValue === "string") {
      if (innerValue !== outerValue) {
        return false;
      }
    } else if (Array.isArray(outerValue) === false || outerValue.length !== innerValue.length || innerValue.some((value2, i22) => value2 !== outerValue[i22])) {
      return false;
    }
  }
  return true;
}
function isEquivalentArray$1(a32, b22) {
  return Array.isArray(b22) === true ? a32.length === b22.length && a32.every((value2, i22) => value2 === b22[i22]) : a32.length === 1 && a32[0] === b22;
}
function isSameRouteLocationParamsValue$1(a32, b22) {
  return Array.isArray(a32) === true ? isEquivalentArray$1(a32, b22) : Array.isArray(b22) === true ? isEquivalentArray$1(b22, a32) : a32 === b22;
}
function isSameRouteLocationParams$1(a32, b22) {
  if (Object.keys(a32).length !== Object.keys(b22).length) {
    return false;
  }
  for (const key in a32) {
    if (isSameRouteLocationParamsValue$1(a32[key], b22[key]) === false) {
      return false;
    }
  }
  return true;
}
var useRouterLinkNonMatchingProps$1 = {
  // router-link
  to: [String, Object],
  replace: Boolean,
  // regular <a> link
  href: String,
  target: String,
  // state
  disable: Boolean
};
var useRouterLinkProps$1 = {
  ...useRouterLinkNonMatchingProps$1,
  // router-link
  exact: Boolean,
  activeClass: {
    type: String,
    default: "q-router-link--active"
  },
  exactActiveClass: {
    type: String,
    default: "q-router-link--exact-active"
  }
};
function use_router_link_default$1({ fallbackTag, useDisableForRouterLinkProps = true } = {}) {
  const vm2 = getCurrentInstance();
  const { props: props4, proxy, emit } = vm2;
  const hasRouter = vmHasRouter$1(vm2);
  const hasHrefLink = computed(() => props4.disable !== true && props4.href !== void 0);
  const hasRouterLinkProps = useDisableForRouterLinkProps === true ? computed(
    () => hasRouter === true && props4.disable !== true && hasHrefLink.value !== true && props4.to !== void 0 && props4.to !== null && props4.to !== ""
  ) : computed(
    () => hasRouter === true && hasHrefLink.value !== true && props4.to !== void 0 && props4.to !== null && props4.to !== ""
  );
  const resolvedLink = computed(() => hasRouterLinkProps.value === true ? getLink(props4.to) : null);
  const hasRouterLink = computed(() => resolvedLink.value !== null);
  const hasLink = computed(() => hasHrefLink.value === true || hasRouterLink.value === true);
  const linkTag = computed(() => props4.type === "a" || hasLink.value === true ? "a" : props4.tag || fallbackTag || "div");
  const linkAttrs = computed(() => hasHrefLink.value === true ? {
    href: props4.href,
    target: props4.target
  } : hasRouterLink.value === true ? {
    href: resolvedLink.value.href,
    target: props4.target
  } : {});
  const linkActiveIndex = computed(() => {
    if (hasRouterLink.value === false) {
      return -1;
    }
    const { matched } = resolvedLink.value, { length } = matched, routeMatched = matched[length - 1];
    if (routeMatched === void 0) {
      return -1;
    }
    const currentMatched = proxy.$route.matched;
    if (currentMatched.length === 0) {
      return -1;
    }
    const index2 = currentMatched.findIndex(
      isSameRouteRecord$1.bind(null, routeMatched)
    );
    if (index2 !== -1) {
      return index2;
    }
    const parentRecordPath = getOriginalPath$1(matched[length - 2]);
    return (
      // we are dealing with nested routes
      length > 1 && getOriginalPath$1(routeMatched) === parentRecordPath && currentMatched[currentMatched.length - 1].path !== parentRecordPath ? currentMatched.findIndex(
        isSameRouteRecord$1.bind(null, matched[length - 2])
      ) : index2
    );
  });
  const linkIsActive = computed(
    () => hasRouterLink.value === true && linkActiveIndex.value !== -1 && includesParams$1(proxy.$route.params, resolvedLink.value.params)
  );
  const linkIsExactActive = computed(
    () => linkIsActive.value === true && linkActiveIndex.value === proxy.$route.matched.length - 1 && isSameRouteLocationParams$1(proxy.$route.params, resolvedLink.value.params)
  );
  const linkClass = computed(() => hasRouterLink.value === true ? linkIsExactActive.value === true ? ` ${props4.exactActiveClass} ${props4.activeClass}` : props4.exact === true ? "" : linkIsActive.value === true ? ` ${props4.activeClass}` : "" : "");
  function getLink(to2) {
    try {
      return proxy.$router.resolve(to2);
    } catch (_) {
    }
    return null;
  }
  function navigateToRouterLink(e22, { returnRouterError, to: to2 = props4.to, replace: replace2 = props4.replace } = {}) {
    if (props4.disable === true) {
      e22.preventDefault();
      return Promise.resolve(false);
    }
    if (
      // don't redirect with control keys;
      // should match RouterLink from Vue Router
      e22.metaKey || e22.altKey || e22.ctrlKey || e22.shiftKey || e22.button !== void 0 && e22.button !== 0 || props4.target === "_blank"
    ) {
      return Promise.resolve(false);
    }
    e22.preventDefault();
    const promise = proxy.$router[replace2 === true ? "replace" : "push"](to2);
    return returnRouterError === true ? promise : promise.then(() => {
    }).catch(() => {
    });
  }
  function navigateOnClick(e22) {
    if (hasRouterLink.value === true) {
      const go = (opts) => navigateToRouterLink(e22, opts);
      emit("click", e22, go);
      e22.defaultPrevented !== true && go();
    } else {
      emit("click", e22);
    }
  }
  return {
    hasRouterLink,
    hasHrefLink,
    hasLink,
    linkTag,
    resolvedLink,
    linkIsActive,
    linkIsExactActive,
    linkClass,
    linkAttrs,
    getLink,
    navigateToRouterLink,
    navigateOnClick
  };
}
createComponent$1({
  name: "QBreadcrumbsEl",
  props: {
    ...useRouterLinkProps$1,
    label: String,
    icon: String,
    tag: {
      type: String,
      default: "span"
    }
  },
  emits: ["click"],
  setup(props4, { slots }) {
    const { linkTag, linkAttrs, linkClass, navigateOnClick } = use_router_link_default$1();
    const data = computed(() => {
      return {
        class: "q-breadcrumbs__el q-link flex inline items-center relative-position " + (props4.disable !== true ? "q-link--focusable" + linkClass.value : "q-breadcrumbs__el--disable"),
        ...linkAttrs.value,
        onClick: navigateOnClick
      };
    });
    const iconClass = computed(
      () => "q-breadcrumbs__el-icon" + (props4.label !== void 0 ? " q-breadcrumbs__el-icon--with-label" : "")
    );
    return () => {
      const child = [];
      props4.icon !== void 0 && child.push(
        h(QIcon_default$1, {
          class: iconClass.value,
          name: props4.icon
        })
      );
      props4.label !== void 0 && child.push(props4.label);
      return h(
        linkTag.value,
        { ...data.value },
        hMergeSlot$1(slots.default, child)
      );
    };
  }
});
var useSpinnerProps$1 = {
  size: {
    type: [String, Number],
    default: "1em"
  },
  color: String
};
function useSpinner$1(props4) {
  return {
    cSize: computed(() => props4.size in useSizeDefaults$1 ? `${useSizeDefaults$1[props4.size]}px` : props4.size),
    classes: computed(
      () => "q-spinner" + (props4.color ? ` text-${props4.color}` : "")
    )
  };
}
var QSpinner_default$1 = createComponent$1({
  name: "QSpinner",
  props: {
    ...useSpinnerProps$1,
    thickness: {
      type: Number,
      default: 5
    }
  },
  setup(props4) {
    const { cSize, classes } = useSpinner$1(props4);
    return () => h("svg", {
      class: classes.value + " q-spinner-mat",
      width: cSize.value,
      height: cSize.value,
      viewBox: "25 25 50 50"
    }, [
      h("circle", {
        class: "path",
        cx: "50",
        cy: "50",
        r: "20",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": props4.thickness,
        "stroke-miterlimit": "10"
      })
    ]);
  }
});
function offset$1(el) {
  if (el === window) {
    return { top: 0, left: 0 };
  }
  const { top, left } = el.getBoundingClientRect();
  return { top, left };
}
function height$1(el) {
  return el === window ? window.innerHeight : el.getBoundingClientRect().height;
}
function css$1(element, css2) {
  const style2 = element.style;
  for (const prop in css2) {
    style2[prop] = css2[prop];
  }
}
function getElement$1(el) {
  if (el === void 0 || el === null) {
    return void 0;
  }
  if (typeof el === "string") {
    try {
      return document.querySelector(el) || void 0;
    } catch (err) {
      return void 0;
    }
  }
  const target2 = unref(el);
  if (target2) {
    return target2.$el || target2;
  }
}
function childHasFocus$1(el, focusedEl) {
  if (el === void 0 || el === null || el.contains(focusedEl) === true) {
    return true;
  }
  for (let next = el.nextElementSibling; next !== null; next = next.nextElementSibling) {
    if (next.contains(focusedEl)) {
      return true;
    }
  }
  return false;
}
function throttle_default$1(fn, limit2 = 250) {
  let wait2 = false, result;
  return function() {
    if (wait2 === false) {
      wait2 = true;
      setTimeout(() => {
        wait2 = false;
      }, limit2);
      result = fn.apply(this, arguments);
    }
    return result;
  };
}
function showRipple$1(evt, el, ctx, forceCenter) {
  ctx.modifiers.stop === true && stop$1(evt);
  const color2 = ctx.modifiers.color;
  let center = ctx.modifiers.center;
  center = center === true || forceCenter === true;
  const node = document.createElement("span"), innerNode = document.createElement("span"), pos = position$1(evt), { left, top, width: width3, height: height2 } = el.getBoundingClientRect(), diameter2 = Math.sqrt(width3 * width3 + height2 * height2), radius2 = diameter2 / 2, centerX = `${(width3 - diameter2) / 2}px`, x22 = center ? centerX : `${pos.left - left - radius2}px`, centerY = `${(height2 - diameter2) / 2}px`, y32 = center ? centerY : `${pos.top - top - radius2}px`;
  innerNode.className = "q-ripple__inner";
  css$1(innerNode, {
    height: `${diameter2}px`,
    width: `${diameter2}px`,
    transform: `translate3d(${x22},${y32},0) scale3d(.2,.2,1)`,
    opacity: 0
  });
  node.className = `q-ripple${color2 ? " text-" + color2 : ""}`;
  node.setAttribute("dir", "ltr");
  node.appendChild(innerNode);
  el.appendChild(node);
  const abort = () => {
    node.remove();
    clearTimeout(timer2);
  };
  ctx.abort.push(abort);
  let timer2 = setTimeout(() => {
    innerNode.classList.add("q-ripple__inner--enter");
    innerNode.style.transform = `translate3d(${centerX},${centerY},0) scale3d(1,1,1)`;
    innerNode.style.opacity = 0.2;
    timer2 = setTimeout(() => {
      innerNode.classList.remove("q-ripple__inner--enter");
      innerNode.classList.add("q-ripple__inner--leave");
      innerNode.style.opacity = 0;
      timer2 = setTimeout(() => {
        node.remove();
        ctx.abort.splice(ctx.abort.indexOf(abort), 1);
      }, 275);
    }, 250);
  }, 50);
}
function updateModifiers$1(ctx, { modifiers, value: value2, arg }) {
  const cfg = Object.assign({}, ctx.cfg.ripple, modifiers, value2);
  ctx.modifiers = {
    early: cfg.early === true,
    stop: cfg.stop === true,
    center: cfg.center === true,
    color: cfg.color || arg,
    keyCodes: [].concat(cfg.keyCodes || 13)
  };
}
var Ripple_default$1 = createDirective$1(
  {
    name: "ripple",
    beforeMount(el, binding) {
      const cfg = binding.instance.$.appContext.config.globalProperties.$q.config || {};
      if (cfg.ripple === false) {
        return;
      }
      const ctx = {
        cfg,
        enabled: binding.value !== false,
        modifiers: {},
        abort: [],
        start(evt) {
          if (ctx.enabled === true && evt.qSkipRipple !== true && evt.type === (ctx.modifiers.early === true ? "pointerdown" : "click")) {
            showRipple$1(evt, el, ctx, evt.qKeyEvent === true);
          }
        },
        keystart: throttle_default$1((evt) => {
          if (ctx.enabled === true && evt.qSkipRipple !== true && isKeyCode$1(evt, ctx.modifiers.keyCodes) === true && evt.type === `key${ctx.modifiers.early === true ? "down" : "up"}`) {
            showRipple$1(evt, el, ctx, true);
          }
        }, 300)
      };
      updateModifiers$1(ctx, binding);
      el.__qripple = ctx;
      addEvt$1(ctx, "main", [
        [el, "pointerdown", "start", "passive"],
        [el, "click", "start", "passive"],
        [el, "keydown", "keystart", "passive"],
        [el, "keyup", "keystart", "passive"]
      ]);
    },
    updated(el, binding) {
      if (binding.oldValue !== binding.value) {
        const ctx = el.__qripple;
        if (ctx !== void 0) {
          ctx.enabled = binding.value !== false;
          if (ctx.enabled === true && Object(binding.value) === binding.value) {
            updateModifiers$1(ctx, binding);
          }
        }
      }
    },
    beforeUnmount(el) {
      const ctx = el.__qripple;
      if (ctx !== void 0) {
        ctx.abort.forEach((fn) => {
          fn();
        });
        cleanEvt$1(ctx, "main");
        delete el._qripple;
      }
    }
  }
);
var btnPadding$1 = {
  none: 0,
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32
};
var defaultSizes$1 = {
  xs: 8,
  sm: 10,
  md: 14,
  lg: 20,
  xl: 24
};
var formTypes$1 = ["button", "submit", "reset"];
var mediaTypeRE$1 = /[^\s]\/[^\s]/;
var btnDesignOptions$1 = ["flat", "outline", "push", "unelevated"];
function getBtnDesign$1(props4, defaultValue) {
  if (props4.flat === true) return "flat";
  if (props4.outline === true) return "outline";
  if (props4.push === true) return "push";
  if (props4.unelevated === true) return "unelevated";
  return defaultValue;
}
function getBtnDesignAttr$1(props4) {
  const design = getBtnDesign$1(props4);
  return design !== void 0 ? { [design]: true } : {};
}
var nonRoundBtnProps$1 = {
  ...useSizeProps$1,
  ...useRouterLinkNonMatchingProps$1,
  type: {
    type: String,
    default: "button"
  },
  label: [Number, String],
  icon: String,
  iconRight: String,
  ...btnDesignOptions$1.reduce(
    (acc, val) => (acc[val] = Boolean) && acc,
    {}
  ),
  square: Boolean,
  rounded: Boolean,
  glossy: Boolean,
  size: String,
  fab: Boolean,
  fabMini: Boolean,
  padding: String,
  color: String,
  textColor: String,
  noCaps: Boolean,
  noWrap: Boolean,
  dense: Boolean,
  tabindex: [Number, String],
  ripple: {
    type: [Boolean, Object],
    default: true
  },
  align: {
    ...useAlignProps$1.align,
    default: "center"
  },
  stack: Boolean,
  stretch: Boolean,
  loading: {
    type: Boolean,
    default: null
  },
  disable: Boolean
};
var useBtnProps$1 = {
  ...nonRoundBtnProps$1,
  round: Boolean
};
function use_btn_default$1(props4) {
  const sizeStyle = use_size_default$1(props4, defaultSizes$1);
  const alignClass = use_align_default$1(props4);
  const { hasRouterLink, hasLink, linkTag, linkAttrs, navigateOnClick } = use_router_link_default$1({
    fallbackTag: "button"
  });
  const style2 = computed(() => {
    const obj = props4.fab === false && props4.fabMini === false ? sizeStyle.value : {};
    return props4.padding !== void 0 ? Object.assign({}, obj, {
      padding: props4.padding.split(/\s+/).map((v) => v in btnPadding$1 ? btnPadding$1[v] + "px" : v).join(" "),
      minWidth: "0",
      minHeight: "0"
    }) : obj;
  });
  const isRounded = computed(
    () => props4.rounded === true || props4.fab === true || props4.fabMini === true
  );
  const isActionable = computed(
    () => props4.disable !== true && props4.loading !== true
  );
  const tabIndex = computed(() => isActionable.value === true ? props4.tabindex || 0 : -1);
  const design = computed(() => getBtnDesign$1(props4, "standard"));
  const attributes = computed(() => {
    const acc = { tabindex: tabIndex.value };
    if (hasLink.value === true) {
      Object.assign(acc, linkAttrs.value);
    } else if (formTypes$1.includes(props4.type) === true) {
      acc.type = props4.type;
    }
    if (linkTag.value === "a") {
      if (props4.disable === true) {
        acc["aria-disabled"] = "true";
      } else if (acc.href === void 0) {
        acc.role = "button";
      }
      if (hasRouterLink.value !== true && mediaTypeRE$1.test(props4.type) === true) {
        acc.type = props4.type;
      }
    } else if (props4.disable === true) {
      acc.disabled = "";
      acc["aria-disabled"] = "true";
    }
    if (props4.loading === true && props4.percentage !== void 0) {
      Object.assign(acc, {
        role: "progressbar",
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": props4.percentage
      });
    }
    return acc;
  });
  const classes = computed(() => {
    let colors2;
    if (props4.color !== void 0) {
      if (props4.flat === true || props4.outline === true) {
        colors2 = `text-${props4.textColor || props4.color}`;
      } else {
        colors2 = `bg-${props4.color} text-${props4.textColor || "white"}`;
      }
    } else if (props4.textColor) {
      colors2 = `text-${props4.textColor}`;
    }
    const shape = props4.round === true ? "round" : `rectangle${isRounded.value === true ? " q-btn--rounded" : props4.square === true ? " q-btn--square" : ""}`;
    return `q-btn--${design.value} q-btn--${shape}` + (colors2 !== void 0 ? " " + colors2 : "") + (isActionable.value === true ? " q-btn--actionable q-focusable q-hoverable" : props4.disable === true ? " disabled" : "") + (props4.fab === true ? " q-btn--fab" : props4.fabMini === true ? " q-btn--fab-mini" : "") + (props4.noCaps === true ? " q-btn--no-uppercase" : "") + (props4.dense === true ? " q-btn--dense" : "") + (props4.stretch === true ? " no-border-radius self-stretch" : "") + (props4.glossy === true ? " glossy" : "") + (props4.square ? " q-btn--square" : "");
  });
  const innerClasses = computed(
    () => alignClass.value + (props4.stack === true ? " column" : " row") + (props4.noWrap === true ? " no-wrap text-no-wrap" : "") + (props4.loading === true ? " q-btn__content--hidden" : "")
  );
  return {
    classes,
    style: style2,
    innerClasses,
    attributes,
    hasLink,
    linkTag,
    navigateOnClick,
    isActionable
  };
}
var { passiveCapture: passiveCapture$1 } = listenOpts$1;
var touchTarget$1 = null;
var keyboardTarget$1 = null;
var mouseTarget$1 = null;
var QBtn_default$1 = createComponent$1({
  name: "QBtn",
  props: {
    ...useBtnProps$1,
    percentage: Number,
    darkPercentage: Boolean,
    onTouchstart: [Function, Array]
  },
  emits: ["click", "keydown", "mousedown", "keyup"],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const {
      classes,
      style: style2,
      innerClasses,
      attributes,
      hasLink,
      linkTag,
      navigateOnClick,
      isActionable
    } = use_btn_default$1(props4);
    const rootRef = ref$1(null);
    const blurTargetRef = ref$1(null);
    let localTouchTargetEl = null, avoidMouseRipple, mouseTimer = null;
    const hasLabel = computed(
      () => props4.label !== void 0 && props4.label !== null && props4.label !== ""
    );
    const ripple = computed(() => props4.disable === true || props4.ripple === false ? false : {
      keyCodes: hasLink.value === true ? [13, 32] : [13],
      ...props4.ripple === true ? {} : props4.ripple
    });
    const rippleProps = computed(() => ({ center: props4.round }));
    const percentageStyle = computed(() => {
      const val = Math.max(0, Math.min(100, props4.percentage));
      return val > 0 ? { transition: "transform 0.6s", transform: `translateX(${val - 100}%)` } : {};
    });
    const onEvents = computed(() => {
      if (props4.loading === true) {
        return {
          onMousedown: onLoadingEvt,
          onTouchstart: onLoadingEvt,
          onClick: onLoadingEvt,
          onKeydown: onLoadingEvt,
          onKeyup: onLoadingEvt
        };
      }
      if (isActionable.value === true) {
        const acc = {
          onClick,
          onKeydown: onKeydown2,
          onMousedown
        };
        if (proxy.$q.platform.has.touch === true) {
          const suffix = props4.onTouchstart !== void 0 ? "" : "Passive";
          acc[`onTouchstart${suffix}`] = onTouchstart;
        }
        return acc;
      }
      return {
        // needed; especially for disabled <a> tags
        onClick: stopAndPrevent$1
      };
    });
    const nodeProps = computed(() => ({
      ref: rootRef,
      class: "q-btn q-btn-item non-selectable no-outline " + classes.value,
      style: style2.value,
      ...attributes.value,
      ...onEvents.value
    }));
    function onClick(e22) {
      if (rootRef.value === null) return;
      if (e22 !== void 0) {
        if (e22.defaultPrevented === true) {
          return;
        }
        const el = document.activeElement;
        if (props4.type === "submit" && el !== document.body && rootRef.value.contains(el) === false && el.contains(rootRef.value) === false) {
          rootRef.value.focus();
          const onClickCleanup = () => {
            document.removeEventListener("keydown", stopAndPrevent$1, true);
            document.removeEventListener("keyup", onClickCleanup, passiveCapture$1);
            rootRef.value !== null && rootRef.value.removeEventListener("blur", onClickCleanup, passiveCapture$1);
          };
          document.addEventListener("keydown", stopAndPrevent$1, true);
          document.addEventListener("keyup", onClickCleanup, passiveCapture$1);
          rootRef.value.addEventListener("blur", onClickCleanup, passiveCapture$1);
        }
      }
      navigateOnClick(e22);
    }
    function onKeydown2(e22) {
      if (rootRef.value === null) return;
      emit("keydown", e22);
      if (isKeyCode$1(e22, [13, 32]) === true && keyboardTarget$1 !== rootRef.value) {
        keyboardTarget$1 !== null && cleanup();
        if (e22.defaultPrevented !== true) {
          rootRef.value.focus();
          keyboardTarget$1 = rootRef.value;
          rootRef.value.classList.add("q-btn--active");
          document.addEventListener("keyup", onPressEnd, true);
          rootRef.value.addEventListener("blur", onPressEnd, passiveCapture$1);
        }
        stopAndPrevent$1(e22);
      }
    }
    function onTouchstart(e22) {
      if (rootRef.value === null) return;
      emit("touchstart", e22);
      if (e22.defaultPrevented === true) return;
      if (touchTarget$1 !== rootRef.value) {
        touchTarget$1 !== null && cleanup();
        touchTarget$1 = rootRef.value;
        localTouchTargetEl = e22.target;
        localTouchTargetEl.addEventListener("touchcancel", onPressEnd, passiveCapture$1);
        localTouchTargetEl.addEventListener("touchend", onPressEnd, passiveCapture$1);
      }
      avoidMouseRipple = true;
      mouseTimer !== null && clearTimeout(mouseTimer);
      mouseTimer = setTimeout(() => {
        mouseTimer = null;
        avoidMouseRipple = false;
      }, 200);
    }
    function onMousedown(e22) {
      if (rootRef.value === null) return;
      e22.qSkipRipple = avoidMouseRipple === true;
      emit("mousedown", e22);
      if (e22.defaultPrevented !== true && mouseTarget$1 !== rootRef.value) {
        mouseTarget$1 !== null && cleanup();
        mouseTarget$1 = rootRef.value;
        rootRef.value.classList.add("q-btn--active");
        document.addEventListener("mouseup", onPressEnd, passiveCapture$1);
      }
    }
    function onPressEnd(e22) {
      if (rootRef.value === null) return;
      if (e22 !== void 0 && e22.type === "blur" && document.activeElement === rootRef.value) {
        return;
      }
      if (e22 !== void 0 && e22.type === "keyup") {
        if (keyboardTarget$1 === rootRef.value && isKeyCode$1(e22, [13, 32]) === true) {
          const evt = new MouseEvent("click", e22);
          evt.qKeyEvent = true;
          e22.defaultPrevented === true && prevent$1(evt);
          e22.cancelBubble === true && stop$1(evt);
          rootRef.value.dispatchEvent(evt);
          stopAndPrevent$1(e22);
          e22.qKeyEvent = true;
        }
        emit("keyup", e22);
      }
      cleanup();
    }
    function cleanup(destroying) {
      const blurTarget = blurTargetRef.value;
      if (destroying !== true && (touchTarget$1 === rootRef.value || mouseTarget$1 === rootRef.value) && blurTarget !== null && blurTarget !== document.activeElement) {
        blurTarget.setAttribute("tabindex", -1);
        blurTarget.focus();
      }
      if (touchTarget$1 === rootRef.value) {
        if (localTouchTargetEl !== null) {
          localTouchTargetEl.removeEventListener("touchcancel", onPressEnd, passiveCapture$1);
          localTouchTargetEl.removeEventListener("touchend", onPressEnd, passiveCapture$1);
        }
        touchTarget$1 = localTouchTargetEl = null;
      }
      if (mouseTarget$1 === rootRef.value) {
        document.removeEventListener("mouseup", onPressEnd, passiveCapture$1);
        mouseTarget$1 = null;
      }
      if (keyboardTarget$1 === rootRef.value) {
        document.removeEventListener("keyup", onPressEnd, true);
        rootRef.value !== null && rootRef.value.removeEventListener("blur", onPressEnd, passiveCapture$1);
        keyboardTarget$1 = null;
      }
      rootRef.value !== null && rootRef.value.classList.remove("q-btn--active");
    }
    function onLoadingEvt(evt) {
      stopAndPrevent$1(evt);
      evt.qSkipRipple = true;
    }
    onBeforeUnmount(() => {
      cleanup(true);
    });
    Object.assign(proxy, {
      click: (e22) => {
        if (isActionable.value === true) {
          onClick(e22);
        }
      }
    });
    return () => {
      let inner = [];
      props4.icon !== void 0 && inner.push(
        h(QIcon_default$1, {
          name: props4.icon,
          left: props4.stack !== true && hasLabel.value === true,
          role: "img"
        })
      );
      hasLabel.value === true && inner.push(
        h("span", { class: "block" }, [props4.label])
      );
      inner = hMergeSlot$1(slots.default, inner);
      if (props4.iconRight !== void 0 && props4.round === false) {
        inner.push(
          h(QIcon_default$1, {
            name: props4.iconRight,
            right: props4.stack !== true && hasLabel.value === true,
            role: "img"
          })
        );
      }
      const child = [
        h("span", {
          class: "q-focus-helper",
          ref: blurTargetRef
        })
      ];
      if (props4.loading === true && props4.percentage !== void 0) {
        child.push(
          h("span", {
            class: "q-btn__progress absolute-full overflow-hidden" + (props4.darkPercentage === true ? " q-btn__progress--dark" : "")
          }, [
            h("span", {
              class: "q-btn__progress-indicator fit block",
              style: percentageStyle.value
            })
          ])
        );
      }
      child.push(
        h("span", {
          class: "q-btn__content text-center col items-center q-anchor--skip " + innerClasses.value
        }, inner)
      );
      props4.loading !== null && child.push(
        h(Transition, {
          name: "q-transition--fade"
        }, () => props4.loading === true ? [
          h("span", {
            key: "loading",
            class: "absolute-full flex flex-center"
          }, slots.loading !== void 0 ? slots.loading() : [h(QSpinner_default$1)])
        ] : null)
      );
      return withDirectives(
        h(
          linkTag.value,
          nodeProps.value,
          child
        ),
        [[
          Ripple_default$1,
          ripple.value,
          void 0,
          rippleProps.value
        ]]
      );
    };
  }
});
var QBtnGroup_default$1 = createComponent$1({
  name: "QBtnGroup",
  props: {
    unelevated: Boolean,
    outline: Boolean,
    flat: Boolean,
    rounded: Boolean,
    square: Boolean,
    push: Boolean,
    stretch: Boolean,
    glossy: Boolean,
    spread: Boolean
  },
  setup(props4, { slots }) {
    const classes = computed(() => {
      const cls = ["unelevated", "outline", "flat", "rounded", "square", "push", "stretch", "glossy"].filter((t22) => props4[t22] === true).map((t22) => `q-btn-group--${t22}`).join(" ");
      return `q-btn-group row no-wrap${cls.length !== 0 ? " " + cls : ""}` + (props4.spread === true ? " q-btn-group--spread" : " inline");
    });
    return () => h("div", { class: classes.value }, hSlot$1(slots.default));
  }
});
function clearSelection$1() {
  if (window.getSelection !== void 0) {
    const selection = window.getSelection();
    if (selection.empty !== void 0) {
      selection.empty();
    } else if (selection.removeAllRanges !== void 0) {
      selection.removeAllRanges();
      Platform_default$1.is.mobile !== true && selection.addRange(document.createRange());
    }
  } else if (document.selection !== void 0) {
    document.selection.empty();
  }
}
var useAnchorStaticProps$1 = {
  /* SSR does not know about Element */
  target: {
    type: [Boolean, String, Element],
    default: true
  },
  noParentEvent: Boolean
};
var useAnchorProps$1 = {
  ...useAnchorStaticProps$1,
  contextMenu: Boolean
};
function use_anchor_default$1({
  showing,
  avoidEmit,
  // required for QPopupProxy (true)
  configureAnchorEl
  // optional
}) {
  const { props: props4, proxy, emit } = getCurrentInstance();
  const anchorEl = ref$1(null);
  let touchTimer = null;
  function canShow(evt) {
    return anchorEl.value === null ? false : evt === void 0 || evt.touches === void 0 || evt.touches.length <= 1;
  }
  const anchorEvents = {};
  if (configureAnchorEl === void 0) {
    Object.assign(anchorEvents, {
      hide(evt) {
        proxy.hide(evt);
      },
      toggle(evt) {
        proxy.toggle(evt);
        evt.qAnchorHandled = true;
      },
      toggleKey(evt) {
        isKeyCode$1(evt, 13) === true && anchorEvents.toggle(evt);
      },
      contextClick(evt) {
        proxy.hide(evt);
        prevent$1(evt);
        nextTick(() => {
          proxy.show(evt);
          evt.qAnchorHandled = true;
        });
      },
      prevent: prevent$1,
      mobileTouch(evt) {
        anchorEvents.mobileCleanup(evt);
        if (canShow(evt) !== true) {
          return;
        }
        proxy.hide(evt);
        anchorEl.value.classList.add("non-selectable");
        const target2 = evt.target;
        addEvt$1(anchorEvents, "anchor", [
          [target2, "touchmove", "mobileCleanup", "passive"],
          [target2, "touchend", "mobileCleanup", "passive"],
          [target2, "touchcancel", "mobileCleanup", "passive"],
          [anchorEl.value, "contextmenu", "prevent", "notPassive"]
        ]);
        touchTimer = setTimeout(() => {
          touchTimer = null;
          proxy.show(evt);
          evt.qAnchorHandled = true;
        }, 300);
      },
      mobileCleanup(evt) {
        anchorEl.value.classList.remove("non-selectable");
        if (touchTimer !== null) {
          clearTimeout(touchTimer);
          touchTimer = null;
        }
        if (showing.value === true && evt !== void 0) {
          clearSelection$1();
        }
      }
    });
    configureAnchorEl = function(context = props4.contextMenu) {
      if (props4.noParentEvent === true || anchorEl.value === null) return;
      let evts;
      if (context === true) {
        if (proxy.$q.platform.is.mobile === true) {
          evts = [
            [anchorEl.value, "touchstart", "mobileTouch", "passive"]
          ];
        } else {
          evts = [
            [anchorEl.value, "mousedown", "hide", "passive"],
            [anchorEl.value, "contextmenu", "contextClick", "notPassive"]
          ];
        }
      } else {
        evts = [
          [anchorEl.value, "click", "toggle", "passive"],
          [anchorEl.value, "keyup", "toggleKey", "passive"]
        ];
      }
      addEvt$1(anchorEvents, "anchor", evts);
    };
  }
  function unconfigureAnchorEl() {
    cleanEvt$1(anchorEvents, "anchor");
  }
  function setAnchorEl(el) {
    anchorEl.value = el;
    while (anchorEl.value.classList.contains("q-anchor--skip")) {
      anchorEl.value = anchorEl.value.parentNode;
    }
    configureAnchorEl();
  }
  function pickAnchorEl() {
    if (props4.target === false || props4.target === "" || proxy.$el.parentNode === null) {
      anchorEl.value = null;
    } else if (props4.target === true) {
      setAnchorEl(proxy.$el.parentNode);
    } else {
      let el = props4.target;
      if (typeof props4.target === "string") {
        try {
          el = document.querySelector(props4.target);
        } catch (err) {
          el = void 0;
        }
      }
      if (el !== void 0 && el !== null) {
        anchorEl.value = el.$el || el;
        configureAnchorEl();
      } else {
        anchorEl.value = null;
        console.error(`Anchor: target "${props4.target}" not found`);
      }
    }
  }
  watch(() => props4.contextMenu, (val) => {
    if (anchorEl.value !== null) {
      unconfigureAnchorEl();
      configureAnchorEl(val);
    }
  });
  watch(() => props4.target, () => {
    if (anchorEl.value !== null) {
      unconfigureAnchorEl();
    }
    pickAnchorEl();
  });
  watch(() => props4.noParentEvent, (val) => {
    if (anchorEl.value !== null) {
      if (val === true) {
        unconfigureAnchorEl();
      } else {
        configureAnchorEl();
      }
    }
  });
  onMounted(() => {
    pickAnchorEl();
    if (avoidEmit !== true && props4.modelValue === true && anchorEl.value === null) {
      emit("update:modelValue", false);
    }
  });
  onBeforeUnmount(() => {
    touchTimer !== null && clearTimeout(touchTimer);
    unconfigureAnchorEl();
  });
  return {
    anchorEl,
    canShow,
    anchorEvents
  };
}
function use_scroll_target_default$1(props4, configureScrollTarget) {
  const localScrollTarget = ref$1(null);
  let scrollFn;
  function changeScrollEvent(scrollTarget, fn) {
    const fnProp = `${fn !== void 0 ? "add" : "remove"}EventListener`;
    const fnHandler = fn !== void 0 ? fn : scrollFn;
    if (scrollTarget !== window) {
      scrollTarget[fnProp]("scroll", fnHandler, listenOpts$1.passive);
    }
    window[fnProp]("scroll", fnHandler, listenOpts$1.passive);
    scrollFn = fn;
  }
  function unconfigureScrollTarget() {
    if (localScrollTarget.value !== null) {
      changeScrollEvent(localScrollTarget.value);
      localScrollTarget.value = null;
    }
  }
  const noParentEventWatcher = watch(() => props4.noParentEvent, () => {
    if (localScrollTarget.value !== null) {
      unconfigureScrollTarget();
      configureScrollTarget();
    }
  });
  onBeforeUnmount(noParentEventWatcher);
  return {
    localScrollTarget,
    unconfigureScrollTarget,
    changeScrollEvent
  };
}
var useModelToggleProps$1 = {
  modelValue: {
    type: Boolean,
    default: null
  },
  "onUpdate:modelValue": [Function, Array]
};
var useModelToggleEmits$1 = [
  "beforeShow",
  "show",
  "beforeHide",
  "hide"
];
function use_model_toggle_default$1({
  showing,
  canShow,
  // optional
  hideOnRouteChange,
  // optional
  handleShow,
  // optional
  handleHide,
  // optional
  processOnMount
  // optional
}) {
  const vm2 = getCurrentInstance();
  const { props: props4, emit, proxy } = vm2;
  let payload;
  function toggle(evt) {
    if (showing.value === true) {
      hide(evt);
    } else {
      show(evt);
    }
  }
  function show(evt) {
    if (props4.disable === true || evt !== void 0 && evt.qAnchorHandled === true || canShow !== void 0 && canShow(evt) !== true) {
      return;
    }
    const listener = props4["onUpdate:modelValue"] !== void 0;
    if (listener === true && true) {
      emit("update:modelValue", true);
      payload = evt;
      nextTick(() => {
        if (payload === evt) {
          payload = void 0;
        }
      });
    }
    if (props4.modelValue === null || listener === false || false) {
      processShow(evt);
    }
  }
  function processShow(evt) {
    if (showing.value === true) {
      return;
    }
    showing.value = true;
    emit("beforeShow", evt);
    if (handleShow !== void 0) {
      handleShow(evt);
    } else {
      emit("show", evt);
    }
  }
  function hide(evt) {
    if (props4.disable === true) {
      return;
    }
    const listener = props4["onUpdate:modelValue"] !== void 0;
    if (listener === true && true) {
      emit("update:modelValue", false);
      payload = evt;
      nextTick(() => {
        if (payload === evt) {
          payload = void 0;
        }
      });
    }
    if (props4.modelValue === null || listener === false || false) {
      processHide(evt);
    }
  }
  function processHide(evt) {
    if (showing.value === false) {
      return;
    }
    showing.value = false;
    emit("beforeHide", evt);
    if (handleHide !== void 0) {
      handleHide(evt);
    } else {
      emit("hide", evt);
    }
  }
  function processModelChange(val) {
    if (props4.disable === true && val === true) {
      if (props4["onUpdate:modelValue"] !== void 0) {
        emit("update:modelValue", false);
      }
    } else if (val === true !== showing.value) {
      const fn = val === true ? processShow : processHide;
      fn(payload);
    }
  }
  watch(() => props4.modelValue, processModelChange);
  if (hideOnRouteChange !== void 0 && vmHasRouter$1(vm2) === true) {
    watch(() => proxy.$route.fullPath, () => {
      if (hideOnRouteChange.value === true && showing.value === true) {
        hide();
      }
    });
  }
  processOnMount === true && onMounted(() => {
    processModelChange(props4.modelValue);
  });
  const publicMethods = { show, hide, toggle };
  Object.assign(proxy, publicMethods);
  return publicMethods;
}
var queue$1 = [];
var waitFlags$1 = [];
function clearFlag$1(flag) {
  waitFlags$1 = waitFlags$1.filter((entry) => entry !== flag);
}
function addFocusWaitFlag$1(flag) {
  clearFlag$1(flag);
  waitFlags$1.push(flag);
}
function removeFocusWaitFlag$1(flag) {
  clearFlag$1(flag);
  if (waitFlags$1.length === 0 && queue$1.length !== 0) {
    queue$1[queue$1.length - 1]();
    queue$1 = [];
  }
}
function addFocusFn$1(fn) {
  if (waitFlags$1.length === 0) {
    fn();
  } else {
    queue$1.push(fn);
  }
}
function removeFocusFn$1(fn) {
  queue$1 = queue$1.filter((entry) => entry !== fn);
}
var nodesList$1 = [];
var portalTypeList$1 = [];
var portalIndex$1 = 1;
var target$1 = document.body;
function createGlobalNode$1(id3, portalType) {
  const el = document.createElement("div");
  el.id = portalType !== void 0 ? `q-portal--${portalType}--${portalIndex$1++}` : id3;
  if (globalConfig$1.globalNodes !== void 0) {
    const cls = globalConfig$1.globalNodes.class;
    if (cls !== void 0) {
      el.className = cls;
    }
  }
  target$1.appendChild(el);
  nodesList$1.push(el);
  portalTypeList$1.push(portalType);
  return el;
}
function removeGlobalNode$1(el) {
  const nodeIndex = nodesList$1.indexOf(el);
  nodesList$1.splice(nodeIndex, 1);
  portalTypeList$1.splice(nodeIndex, 1);
  el.remove();
}
function changeGlobalNodesTarget$1(newTarget) {
  if (newTarget === target$1) return;
  target$1 = newTarget;
  if (target$1 === document.body || portalTypeList$1.reduce((acc, type2) => type2 === "dialog" ? acc + 1 : acc, 0) < 2) {
    nodesList$1.forEach((node) => {
      if (node.contains(target$1) === false) {
        target$1.appendChild(node);
      }
    });
    return;
  }
  const lastDialogIndex = portalTypeList$1.lastIndexOf("dialog");
  for (let i22 = 0; i22 < nodesList$1.length; i22++) {
    const el = nodesList$1[i22];
    if ((i22 === lastDialogIndex || portalTypeList$1[i22] !== "dialog") && el.contains(target$1) === false) {
      target$1.appendChild(el);
    }
  }
}
var portalProxyList$1 = [];
function getPortalProxy$1(el) {
  return portalProxyList$1.find(
    (proxy) => proxy.contentEl !== null && proxy.contentEl.contains(el)
  );
}
function closePortalMenus$1(proxy, evt) {
  do {
    if (proxy.$options.name === "QMenu") {
      proxy.hide(evt);
      if (proxy.$props.separateClosePopup === true) {
        return getParentProxy$1(proxy);
      }
    } else if (proxy.__qPortal === true) {
      const parent = getParentProxy$1(proxy);
      if (parent !== void 0 && parent.$options.name === "QPopupProxy") {
        proxy.hide(evt);
        return parent;
      } else {
        return proxy;
      }
    }
    proxy = getParentProxy$1(proxy);
  } while (proxy !== void 0 && proxy !== null);
}
function closePortals$1(proxy, evt, depth) {
  while (depth !== 0 && proxy !== void 0 && proxy !== null) {
    if (proxy.__qPortal === true) {
      depth--;
      if (proxy.$options.name === "QMenu") {
        proxy = closePortalMenus$1(proxy, evt);
        continue;
      }
      proxy.hide(evt);
    }
    proxy = getParentProxy$1(proxy);
  }
}
var QPortal$1 = createComponent$1({
  name: "QPortal",
  setup(_, { slots }) {
    return () => slots.default();
  }
});
function isOnGlobalDialog$1(vm2) {
  vm2 = vm2.parent;
  while (vm2 !== void 0 && vm2 !== null) {
    if (vm2.type.name === "QGlobalDialog") {
      return true;
    }
    if (vm2.type.name === "QDialog" || vm2.type.name === "QMenu") {
      return false;
    }
    vm2 = vm2.parent;
  }
  return false;
}
function use_portal_default$1(vm2, innerRef, renderPortalContent, type2) {
  const portalIsActive = ref$1(false);
  const portalIsAccessible = ref$1(false);
  let portalEl = null;
  const focusObj = {};
  const onGlobalDialog = type2 === "dialog" && isOnGlobalDialog$1(vm2);
  function showPortal(isReady) {
    if (isReady === true) {
      removeFocusWaitFlag$1(focusObj);
      portalIsAccessible.value = true;
      return;
    }
    portalIsAccessible.value = false;
    if (portalIsActive.value === false) {
      if (onGlobalDialog === false && portalEl === null) {
        portalEl = createGlobalNode$1(false, type2);
      }
      portalIsActive.value = true;
      portalProxyList$1.push(vm2.proxy);
      addFocusWaitFlag$1(focusObj);
    }
  }
  function hidePortal(isReady) {
    portalIsAccessible.value = false;
    if (isReady !== true) return;
    removeFocusWaitFlag$1(focusObj);
    portalIsActive.value = false;
    const index2 = portalProxyList$1.indexOf(vm2.proxy);
    if (index2 !== -1) {
      portalProxyList$1.splice(index2, 1);
    }
    if (portalEl !== null) {
      removeGlobalNode$1(portalEl);
      portalEl = null;
    }
  }
  onUnmounted(() => {
    hidePortal(true);
  });
  vm2.proxy.__qPortal = true;
  injectProp$1(vm2.proxy, "contentEl", () => innerRef.value);
  return {
    showPortal,
    hidePortal,
    portalIsActive,
    portalIsAccessible,
    renderPortal: () => onGlobalDialog === true ? renderPortalContent() : portalIsActive.value === true ? [h(Teleport, { to: portalEl }, h(QPortal$1, renderPortalContent))] : void 0
  };
}
var useTransitionProps$1 = {
  transitionShow: {
    type: String,
    default: "fade"
  },
  transitionHide: {
    type: String,
    default: "fade"
  },
  transitionDuration: {
    type: [String, Number],
    default: 300
  }
};
function use_transition_default$1(props4, defaultShowFn = () => {
}, defaultHideFn = () => {
}) {
  return {
    transitionProps: computed(() => {
      const show = `q-transition--${props4.transitionShow || defaultShowFn()}`;
      const hide = `q-transition--${props4.transitionHide || defaultHideFn()}`;
      return {
        appear: true,
        enterFromClass: `${show}-enter-from`,
        enterActiveClass: `${show}-enter-active`,
        enterToClass: `${show}-enter-to`,
        leaveFromClass: `${hide}-leave-from`,
        leaveActiveClass: `${hide}-leave-active`,
        leaveToClass: `${hide}-leave-to`
      };
    }),
    transitionStyle: computed(() => `--q-transition-duration: ${props4.transitionDuration}ms`)
  };
}
function use_tick_default$1() {
  let tickFn;
  const vm2 = getCurrentInstance();
  function removeTick() {
    tickFn = void 0;
  }
  onDeactivated(removeTick);
  onBeforeUnmount(removeTick);
  return {
    removeTick,
    registerTick(fn) {
      tickFn = fn;
      nextTick(() => {
        if (tickFn === fn) {
          vmIsDestroyed$1(vm2) === false && tickFn();
          tickFn = void 0;
        }
      });
    }
  };
}
function use_timeout_default$1() {
  let timer2 = null;
  const vm2 = getCurrentInstance();
  function removeTimeout() {
    if (timer2 !== null) {
      clearTimeout(timer2);
      timer2 = null;
    }
  }
  onDeactivated(removeTimeout);
  onBeforeUnmount(removeTimeout);
  return {
    removeTimeout,
    registerTimeout(fn, delay) {
      removeTimeout();
      if (vmIsDestroyed$1(vm2) === false) {
        timer2 = setTimeout(() => {
          timer2 = null;
          fn();
        }, delay);
      }
    }
  };
}
var scrollTargetProp$1 = [Element, String];
var scrollTargets$1 = [null, document, document.body, document.scrollingElement, document.documentElement];
function getScrollTarget$1(el, targetEl) {
  let target2 = getElement$1(targetEl);
  if (target2 === void 0) {
    if (el === void 0 || el === null) {
      return window;
    }
    target2 = el.closest(".scroll,.scroll-y,.overflow-auto");
  }
  return scrollTargets$1.includes(target2) ? window : target2;
}
function getScrollHeight$1(el) {
  return (el === window ? document.body : el).scrollHeight;
}
function getVerticalScrollPosition$1(scrollTarget) {
  return scrollTarget === window ? window.pageYOffset || window.scrollY || document.body.scrollTop || 0 : scrollTarget.scrollTop;
}
function getHorizontalScrollPosition$1(scrollTarget) {
  return scrollTarget === window ? window.pageXOffset || window.scrollX || document.body.scrollLeft || 0 : scrollTarget.scrollLeft;
}
function animVerticalScrollTo$1(el, to2, duration2 = 0) {
  const prevTime = arguments[3] === void 0 ? performance.now() : arguments[3];
  const pos = getVerticalScrollPosition$1(el);
  if (duration2 <= 0) {
    if (pos !== to2) {
      setScroll$1(el, to2);
    }
    return;
  }
  requestAnimationFrame((nowTime) => {
    const frameTime = nowTime - prevTime;
    const newPos = pos + (to2 - pos) / Math.max(frameTime, duration2) * frameTime;
    setScroll$1(el, newPos);
    if (newPos !== to2) {
      animVerticalScrollTo$1(el, to2, duration2 - frameTime, nowTime);
    }
  });
}
function animHorizontalScrollTo$1(el, to2, duration2 = 0) {
  const prevTime = arguments[3] === void 0 ? performance.now() : arguments[3];
  const pos = getHorizontalScrollPosition$1(el);
  if (duration2 <= 0) {
    if (pos !== to2) {
      setHorizontalScroll$1(el, to2);
    }
    return;
  }
  requestAnimationFrame((nowTime) => {
    const frameTime = nowTime - prevTime;
    const newPos = pos + (to2 - pos) / Math.max(frameTime, duration2) * frameTime;
    setHorizontalScroll$1(el, newPos);
    if (newPos !== to2) {
      animHorizontalScrollTo$1(el, to2, duration2 - frameTime, nowTime);
    }
  });
}
function setScroll$1(scrollTarget, offset2) {
  if (scrollTarget === window) {
    window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, offset2);
    return;
  }
  scrollTarget.scrollTop = offset2;
}
function setHorizontalScroll$1(scrollTarget, offset2) {
  if (scrollTarget === window) {
    window.scrollTo(offset2, window.pageYOffset || window.scrollY || document.body.scrollTop || 0);
    return;
  }
  scrollTarget.scrollLeft = offset2;
}
function setVerticalScrollPosition$1(scrollTarget, offset2, duration2) {
  if (duration2) {
    animVerticalScrollTo$1(scrollTarget, offset2, duration2);
    return;
  }
  setScroll$1(scrollTarget, offset2);
}
function setHorizontalScrollPosition$1(scrollTarget, offset2, duration2) {
  if (duration2) {
    animHorizontalScrollTo$1(scrollTarget, offset2, duration2);
    return;
  }
  setHorizontalScroll$1(scrollTarget, offset2);
}
var size$1;
function getScrollbarWidth$1() {
  if (size$1 !== void 0) {
    return size$1;
  }
  const inner = document.createElement("p"), outer = document.createElement("div");
  css$1(inner, {
    width: "100%",
    height: "200px"
  });
  css$1(outer, {
    position: "absolute",
    top: "0px",
    left: "0px",
    visibility: "hidden",
    width: "200px",
    height: "150px",
    overflow: "hidden"
  });
  outer.appendChild(inner);
  document.body.appendChild(outer);
  const w1 = inner.offsetWidth;
  outer.style.overflow = "scroll";
  let w22 = inner.offsetWidth;
  if (w1 === w22) {
    w22 = outer.clientWidth;
  }
  outer.remove();
  size$1 = w1 - w22;
  return size$1;
}
function hasScrollbar$1(el, onY = true) {
  if (!el || el.nodeType !== Node.ELEMENT_NODE) {
    return false;
  }
  return onY ? el.scrollHeight > el.clientHeight && (el.classList.contains("scroll") || el.classList.contains("overflow-auto") || ["auto", "scroll"].includes(window.getComputedStyle(el)["overflow-y"])) : el.scrollWidth > el.clientWidth && (el.classList.contains("scroll") || el.classList.contains("overflow-auto") || ["auto", "scroll"].includes(window.getComputedStyle(el)["overflow-x"]));
}
var handlers$1 = [];
var escDown$1;
function onKeydown$1(evt) {
  escDown$1 = evt.keyCode === 27;
}
function onBlur$1() {
  if (escDown$1 === true) {
    escDown$1 = false;
  }
}
function onKeyup$1(evt) {
  if (escDown$1 === true) {
    escDown$1 = false;
    if (isKeyCode$1(evt, 27) === true) {
      handlers$1[handlers$1.length - 1](evt);
    }
  }
}
function update$1(action) {
  window[action]("keydown", onKeydown$1);
  window[action]("blur", onBlur$1);
  window[action]("keyup", onKeyup$1);
  escDown$1 = false;
}
function addEscapeKey$1(fn) {
  if (client$1.is.desktop === true) {
    handlers$1.push(fn);
    if (handlers$1.length === 1) {
      update$1("addEventListener");
    }
  }
}
function removeEscapeKey$1(fn) {
  const index2 = handlers$1.indexOf(fn);
  if (index2 !== -1) {
    handlers$1.splice(index2, 1);
    if (handlers$1.length === 0) {
      update$1("removeEventListener");
    }
  }
}
var handlers2$1 = [];
function trigger$1(e22) {
  handlers2$1[handlers2$1.length - 1](e22);
}
function addFocusout$1(fn) {
  if (client$1.is.desktop === true) {
    handlers2$1.push(fn);
    if (handlers2$1.length === 1) {
      document.body.addEventListener("focusin", trigger$1);
    }
  }
}
function removeFocusout$1(fn) {
  const index2 = handlers2$1.indexOf(fn);
  if (index2 !== -1) {
    handlers2$1.splice(index2, 1);
    if (handlers2$1.length === 0) {
      document.body.removeEventListener("focusin", trigger$1);
    }
  }
}
var { notPassiveCapture: notPassiveCapture$1 } = listenOpts$1;
var registeredList$1 = [];
function globalHandler$1(evt) {
  const target2 = evt.target;
  if (target2 === void 0 || target2.nodeType === 8 || target2.classList.contains("no-pointer-events") === true) {
    return;
  }
  let portalIndex2 = portalProxyList$1.length - 1;
  while (portalIndex2 >= 0) {
    const proxy = portalProxyList$1[portalIndex2].$;
    if (proxy.type.name === "QTooltip") {
      portalIndex2--;
      continue;
    }
    if (proxy.type.name !== "QDialog") {
      break;
    }
    if (proxy.props.seamless !== true) {
      return;
    }
    portalIndex2--;
  }
  for (let i22 = registeredList$1.length - 1; i22 >= 0; i22--) {
    const state2 = registeredList$1[i22];
    if ((state2.anchorEl.value === null || state2.anchorEl.value.contains(target2) === false) && (target2 === document.body || state2.innerRef.value !== null && state2.innerRef.value.contains(target2) === false)) {
      evt.qClickOutside = true;
      state2.onClickOutside(evt);
    } else {
      return;
    }
  }
}
function addClickOutside$1(clickOutsideProps) {
  registeredList$1.push(clickOutsideProps);
  if (registeredList$1.length === 1) {
    document.addEventListener("mousedown", globalHandler$1, notPassiveCapture$1);
    document.addEventListener("touchstart", globalHandler$1, notPassiveCapture$1);
  }
}
function removeClickOutside$1(clickOutsideProps) {
  const index2 = registeredList$1.findIndex((h138) => h138 === clickOutsideProps);
  if (index2 !== -1) {
    registeredList$1.splice(index2, 1);
    if (registeredList$1.length === 0) {
      document.removeEventListener("mousedown", globalHandler$1, notPassiveCapture$1);
      document.removeEventListener("touchstart", globalHandler$1, notPassiveCapture$1);
    }
  }
}
var vpLeft$1;
var vpTop$1;
function validatePosition$1(pos) {
  const parts = pos.split(" ");
  if (parts.length !== 2) {
    return false;
  }
  if (["top", "center", "bottom"].includes(parts[0]) !== true) {
    console.error("Anchor/Self position must start with one of top/center/bottom");
    return false;
  }
  if (["left", "middle", "right", "start", "end"].includes(parts[1]) !== true) {
    console.error("Anchor/Self position must end with one of left/middle/right/start/end");
    return false;
  }
  return true;
}
function validateOffset$1(val) {
  if (!val) {
    return true;
  }
  if (val.length !== 2) {
    return false;
  }
  if (typeof val[0] !== "number" || typeof val[1] !== "number") {
    return false;
  }
  return true;
}
var horizontalPos$1 = {
  "start#ltr": "left",
  "start#rtl": "right",
  "end#ltr": "right",
  "end#rtl": "left"
};
["left", "middle", "right"].forEach((pos) => {
  horizontalPos$1[`${pos}#ltr`] = pos;
  horizontalPos$1[`${pos}#rtl`] = pos;
});
function parsePosition$1(pos, rtl) {
  const parts = pos.split(" ");
  return {
    vertical: parts[0],
    horizontal: horizontalPos$1[`${parts[1]}#${rtl === true ? "rtl" : "ltr"}`]
  };
}
function getAnchorProps$1(el, offset2) {
  let { top, left, right, bottom, width: width3, height: height2 } = el.getBoundingClientRect();
  if (offset2 !== void 0) {
    top -= offset2[1];
    left -= offset2[0];
    bottom += offset2[1];
    right += offset2[0];
    width3 += offset2[0];
    height2 += offset2[1];
  }
  return {
    top,
    bottom,
    height: height2,
    left,
    right,
    width: width3,
    middle: left + (right - left) / 2,
    center: top + (bottom - top) / 2
  };
}
function getAbsoluteAnchorProps$1(el, absoluteOffset, offset2) {
  let { top, left } = el.getBoundingClientRect();
  top += absoluteOffset.top;
  left += absoluteOffset.left;
  if (offset2 !== void 0) {
    top += offset2[1];
    left += offset2[0];
  }
  return {
    top,
    bottom: top + 1,
    height: 1,
    left,
    right: left + 1,
    width: 1,
    middle: left,
    center: top
  };
}
function getTargetProps$1(width3, height2) {
  return {
    top: 0,
    center: height2 / 2,
    bottom: height2,
    left: 0,
    middle: width3 / 2,
    right: width3
  };
}
function getTopLeftProps$1(anchorProps, targetProps, anchorOrigin, selfOrigin) {
  return {
    top: anchorProps[anchorOrigin.vertical] - targetProps[selfOrigin.vertical],
    left: anchorProps[anchorOrigin.horizontal] - targetProps[selfOrigin.horizontal]
  };
}
function setPosition$1(cfg, retryNumber = 0) {
  if (cfg.targetEl === null || cfg.anchorEl === null || retryNumber > 5) {
    return;
  }
  if (cfg.targetEl.offsetHeight === 0 || cfg.targetEl.offsetWidth === 0) {
    setTimeout(() => {
      setPosition$1(cfg, retryNumber + 1);
    }, 10);
    return;
  }
  const {
    targetEl,
    offset: offset2,
    anchorEl,
    anchorOrigin,
    selfOrigin,
    absoluteOffset,
    fit,
    cover,
    maxHeight,
    maxWidth
  } = cfg;
  if (client$1.is.ios === true && window.visualViewport !== void 0) {
    const el = document.body.style;
    const { offsetLeft: left, offsetTop: top } = window.visualViewport;
    if (left !== vpLeft$1) {
      el.setProperty("--q-pe-left", left + "px");
      vpLeft$1 = left;
    }
    if (top !== vpTop$1) {
      el.setProperty("--q-pe-top", top + "px");
      vpTop$1 = top;
    }
  }
  const { scrollLeft, scrollTop } = targetEl;
  const anchorProps = absoluteOffset === void 0 ? getAnchorProps$1(anchorEl, cover === true ? [0, 0] : offset2) : getAbsoluteAnchorProps$1(anchorEl, absoluteOffset, offset2);
  Object.assign(targetEl.style, {
    top: 0,
    left: 0,
    minWidth: null,
    minHeight: null,
    maxWidth,
    maxHeight,
    visibility: "visible"
  });
  const { offsetWidth: origElWidth, offsetHeight: origElHeight } = targetEl;
  const { elWidth, elHeight } = fit === true || cover === true ? { elWidth: Math.max(anchorProps.width, origElWidth), elHeight: cover === true ? Math.max(anchorProps.height, origElHeight) : origElHeight } : { elWidth: origElWidth, elHeight: origElHeight };
  let elStyle = { maxWidth, maxHeight };
  if (fit === true || cover === true) {
    elStyle.minWidth = anchorProps.width + "px";
    if (cover === true) {
      elStyle.minHeight = anchorProps.height + "px";
    }
  }
  Object.assign(targetEl.style, elStyle);
  const targetProps = getTargetProps$1(elWidth, elHeight);
  let props4 = getTopLeftProps$1(anchorProps, targetProps, anchorOrigin, selfOrigin);
  if (absoluteOffset === void 0 || offset2 === void 0) {
    applyBoundaries$1(props4, anchorProps, targetProps, anchorOrigin, selfOrigin);
  } else {
    const { top, left } = props4;
    applyBoundaries$1(props4, anchorProps, targetProps, anchorOrigin, selfOrigin);
    let hasChanged = false;
    if (props4.top !== top) {
      hasChanged = true;
      const offsetY = 2 * offset2[1];
      anchorProps.center = anchorProps.top -= offsetY;
      anchorProps.bottom -= offsetY + 2;
    }
    if (props4.left !== left) {
      hasChanged = true;
      const offsetX = 2 * offset2[0];
      anchorProps.middle = anchorProps.left -= offsetX;
      anchorProps.right -= offsetX + 2;
    }
    if (hasChanged === true) {
      props4 = getTopLeftProps$1(anchorProps, targetProps, anchorOrigin, selfOrigin);
      applyBoundaries$1(props4, anchorProps, targetProps, anchorOrigin, selfOrigin);
    }
  }
  elStyle = {
    top: props4.top + "px",
    left: props4.left + "px"
  };
  if (props4.maxHeight !== void 0) {
    elStyle.maxHeight = props4.maxHeight + "px";
    if (anchorProps.height > props4.maxHeight) {
      elStyle.minHeight = elStyle.maxHeight;
    }
  }
  if (props4.maxWidth !== void 0) {
    elStyle.maxWidth = props4.maxWidth + "px";
    if (anchorProps.width > props4.maxWidth) {
      elStyle.minWidth = elStyle.maxWidth;
    }
  }
  Object.assign(targetEl.style, elStyle);
  if (targetEl.scrollTop !== scrollTop) {
    targetEl.scrollTop = scrollTop;
  }
  if (targetEl.scrollLeft !== scrollLeft) {
    targetEl.scrollLeft = scrollLeft;
  }
}
function applyBoundaries$1(props4, anchorProps, targetProps, anchorOrigin, selfOrigin) {
  const currentHeight = targetProps.bottom, currentWidth = targetProps.right, margin = getScrollbarWidth$1(), innerHeight = window.innerHeight - margin, innerWidth = document.body.clientWidth;
  if (props4.top < 0 || props4.top + currentHeight > innerHeight) {
    if (selfOrigin.vertical === "center") {
      props4.top = anchorProps[anchorOrigin.vertical] > innerHeight / 2 ? Math.max(0, innerHeight - currentHeight) : 0;
      props4.maxHeight = Math.min(currentHeight, innerHeight);
    } else if (anchorProps[anchorOrigin.vertical] > innerHeight / 2) {
      const anchorY = Math.min(
        innerHeight,
        anchorOrigin.vertical === "center" ? anchorProps.center : anchorOrigin.vertical === selfOrigin.vertical ? anchorProps.bottom : anchorProps.top
      );
      props4.maxHeight = Math.min(currentHeight, anchorY);
      props4.top = Math.max(0, anchorY - currentHeight);
    } else {
      props4.top = Math.max(
        0,
        anchorOrigin.vertical === "center" ? anchorProps.center : anchorOrigin.vertical === selfOrigin.vertical ? anchorProps.top : anchorProps.bottom
      );
      props4.maxHeight = Math.min(currentHeight, innerHeight - props4.top);
    }
  }
  if (props4.left < 0 || props4.left + currentWidth > innerWidth) {
    props4.maxWidth = Math.min(currentWidth, innerWidth);
    if (selfOrigin.horizontal === "middle") {
      props4.left = anchorProps[anchorOrigin.horizontal] > innerWidth / 2 ? Math.max(0, innerWidth - currentWidth) : 0;
    } else if (anchorProps[anchorOrigin.horizontal] > innerWidth / 2) {
      const anchorX = Math.min(
        innerWidth,
        anchorOrigin.horizontal === "middle" ? anchorProps.middle : anchorOrigin.horizontal === selfOrigin.horizontal ? anchorProps.right : anchorProps.left
      );
      props4.maxWidth = Math.min(currentWidth, anchorX);
      props4.left = Math.max(0, anchorX - props4.maxWidth);
    } else {
      props4.left = Math.max(
        0,
        anchorOrigin.horizontal === "middle" ? anchorProps.middle : anchorOrigin.horizontal === selfOrigin.horizontal ? anchorProps.left : anchorProps.right
      );
      props4.maxWidth = Math.min(currentWidth, innerWidth - props4.left);
    }
  }
}
var QMenu_default$1 = createComponent$1({
  name: "QMenu",
  inheritAttrs: false,
  props: {
    ...useAnchorProps$1,
    ...useModelToggleProps$1,
    ...useDarkProps$1,
    ...useTransitionProps$1,
    persistent: Boolean,
    autoClose: Boolean,
    separateClosePopup: Boolean,
    noRouteDismiss: Boolean,
    noRefocus: Boolean,
    noFocus: Boolean,
    fit: Boolean,
    cover: Boolean,
    square: Boolean,
    anchor: {
      type: String,
      validator: validatePosition$1
    },
    self: {
      type: String,
      validator: validatePosition$1
    },
    offset: {
      type: Array,
      validator: validateOffset$1
    },
    scrollTarget: scrollTargetProp$1,
    touchPosition: Boolean,
    maxHeight: {
      type: String,
      default: null
    },
    maxWidth: {
      type: String,
      default: null
    }
  },
  emits: [
    ...useModelToggleEmits$1,
    "click",
    "escapeKey"
  ],
  setup(props4, { slots, emit, attrs }) {
    let refocusTarget = null, absoluteOffset, unwatchPosition, avoidAutoClose;
    const vm2 = getCurrentInstance();
    const { proxy } = vm2;
    const { $q } = proxy;
    const innerRef = ref$1(null);
    const showing = ref$1(false);
    const hideOnRouteChange = computed(
      () => props4.persistent !== true && props4.noRouteDismiss !== true
    );
    const isDark = use_dark_default$1(props4, $q);
    const { registerTick, removeTick } = use_tick_default$1();
    const { registerTimeout } = use_timeout_default$1();
    const { transitionProps, transitionStyle } = use_transition_default$1(props4);
    const { localScrollTarget, changeScrollEvent, unconfigureScrollTarget } = use_scroll_target_default$1(props4, configureScrollTarget);
    const { anchorEl, canShow } = use_anchor_default$1({ showing });
    const { hide } = use_model_toggle_default$1({
      showing,
      canShow,
      handleShow,
      handleHide,
      hideOnRouteChange,
      processOnMount: true
    });
    const { showPortal, hidePortal, renderPortal } = use_portal_default$1(vm2, innerRef, renderPortalContent, "menu");
    const clickOutsideProps = {
      anchorEl,
      innerRef,
      onClickOutside(e22) {
        if (props4.persistent !== true && showing.value === true) {
          hide(e22);
          if (
            // always prevent touch event
            e22.type === "touchstart" || e22.target.classList.contains("q-dialog__backdrop")
          ) {
            stopAndPrevent$1(e22);
          }
          return true;
        }
      }
    };
    const anchorOrigin = computed(
      () => parsePosition$1(
        props4.anchor || (props4.cover === true ? "center middle" : "bottom start"),
        $q.lang.rtl
      )
    );
    const selfOrigin = computed(() => props4.cover === true ? anchorOrigin.value : parsePosition$1(props4.self || "top start", $q.lang.rtl));
    const menuClass = computed(
      () => (props4.square === true ? " q-menu--square" : "") + (isDark.value === true ? " q-menu--dark q-dark" : "")
    );
    const onEvents = computed(() => props4.autoClose === true ? { onClick: onAutoClose } : {});
    const handlesFocus = computed(
      () => showing.value === true && props4.persistent !== true
    );
    watch(handlesFocus, (val) => {
      if (val === true) {
        addEscapeKey$1(onEscapeKey);
        addClickOutside$1(clickOutsideProps);
      } else {
        removeEscapeKey$1(onEscapeKey);
        removeClickOutside$1(clickOutsideProps);
      }
    });
    function focus() {
      addFocusFn$1(() => {
        let node = innerRef.value;
        if (node && node.contains(document.activeElement) !== true) {
          node = node.querySelector("[autofocus][tabindex], [data-autofocus][tabindex]") || node.querySelector("[autofocus] [tabindex], [data-autofocus] [tabindex]") || node.querySelector("[autofocus], [data-autofocus]") || node;
          node.focus({ preventScroll: true });
        }
      });
    }
    function handleShow(evt) {
      refocusTarget = props4.noRefocus === false ? document.activeElement : null;
      addFocusout$1(onFocusout);
      showPortal();
      configureScrollTarget();
      absoluteOffset = void 0;
      if (evt !== void 0 && (props4.touchPosition || props4.contextMenu)) {
        const pos = position$1(evt);
        if (pos.left !== void 0) {
          const { top, left } = anchorEl.value.getBoundingClientRect();
          absoluteOffset = { left: pos.left - left, top: pos.top - top };
        }
      }
      if (unwatchPosition === void 0) {
        unwatchPosition = watch(
          () => $q.screen.width + "|" + $q.screen.height + "|" + props4.self + "|" + props4.anchor + "|" + $q.lang.rtl,
          updatePosition
        );
      }
      if (props4.noFocus !== true) {
        document.activeElement.blur();
      }
      registerTick(() => {
        updatePosition();
        props4.noFocus !== true && focus();
      });
      registerTimeout(() => {
        if ($q.platform.is.ios === true) {
          avoidAutoClose = props4.autoClose;
          innerRef.value.click();
        }
        updatePosition();
        showPortal(true);
        emit("show", evt);
      }, props4.transitionDuration);
    }
    function handleHide(evt) {
      removeTick();
      hidePortal();
      anchorCleanup(true);
      if (refocusTarget !== null && // menu was hidden from code or ESC plugin
      (evt === void 0 || evt.qClickOutside !== true)) {
        ((evt && evt.type.indexOf("key") === 0 ? refocusTarget.closest('[tabindex]:not([tabindex^="-"])') : void 0) || refocusTarget).focus();
        refocusTarget = null;
      }
      registerTimeout(() => {
        hidePortal(true);
        emit("hide", evt);
      }, props4.transitionDuration);
    }
    function anchorCleanup(hiding) {
      absoluteOffset = void 0;
      if (unwatchPosition !== void 0) {
        unwatchPosition();
        unwatchPosition = void 0;
      }
      if (hiding === true || showing.value === true) {
        removeFocusout$1(onFocusout);
        unconfigureScrollTarget();
        removeClickOutside$1(clickOutsideProps);
        removeEscapeKey$1(onEscapeKey);
      }
      if (hiding !== true) {
        refocusTarget = null;
      }
    }
    function configureScrollTarget() {
      if (anchorEl.value !== null || props4.scrollTarget !== void 0) {
        localScrollTarget.value = getScrollTarget$1(anchorEl.value, props4.scrollTarget);
        changeScrollEvent(localScrollTarget.value, updatePosition);
      }
    }
    function onAutoClose(e22) {
      if (avoidAutoClose !== true) {
        closePortalMenus$1(proxy, e22);
        emit("click", e22);
      } else {
        avoidAutoClose = false;
      }
    }
    function onFocusout(evt) {
      if (handlesFocus.value === true && props4.noFocus !== true && childHasFocus$1(innerRef.value, evt.target) !== true) {
        focus();
      }
    }
    function onEscapeKey(evt) {
      emit("escapeKey");
      hide(evt);
    }
    function updatePosition() {
      setPosition$1({
        targetEl: innerRef.value,
        offset: props4.offset,
        anchorEl: anchorEl.value,
        anchorOrigin: anchorOrigin.value,
        selfOrigin: selfOrigin.value,
        absoluteOffset,
        fit: props4.fit,
        cover: props4.cover,
        maxHeight: props4.maxHeight,
        maxWidth: props4.maxWidth
      });
    }
    function renderPortalContent() {
      return h(
        Transition,
        transitionProps.value,
        () => showing.value === true ? h("div", {
          role: "menu",
          ...attrs,
          ref: innerRef,
          tabindex: -1,
          class: [
            "q-menu q-position-engine scroll" + menuClass.value,
            attrs.class
          ],
          style: [
            attrs.style,
            transitionStyle.value
          ],
          ...onEvents.value
        }, hSlot$1(slots.default)) : null
      );
    }
    onBeforeUnmount(anchorCleanup);
    Object.assign(proxy, { focus, updatePosition });
    return renderPortal;
  }
});
var buf$1;
var bufIdx$1 = 0;
var hexBytes$1 = new Array(256);
for (let i22 = 0; i22 < 256; i22++) {
  hexBytes$1[i22] = (i22 + 256).toString(16).substring(1);
}
var randomBytes$1 = (() => {
  const lib2 = typeof crypto !== "undefined" ? crypto : typeof window !== "undefined" ? window.crypto || window.msCrypto : void 0;
  if (lib2 !== void 0) {
    if (lib2.randomBytes !== void 0) {
      return lib2.randomBytes;
    }
    if (lib2.getRandomValues !== void 0) {
      return (n) => {
        const bytes = new Uint8Array(n);
        lib2.getRandomValues(bytes);
        return bytes;
      };
    }
  }
  return (n) => {
    const r = [];
    for (let i22 = n; i22 > 0; i22--) {
      r.push(Math.floor(Math.random() * 256));
    }
    return r;
  };
})();
var BUFFER_SIZE$1 = 4096;
function uid_default$1() {
  if (buf$1 === void 0 || bufIdx$1 + 16 > BUFFER_SIZE$1) {
    bufIdx$1 = 0;
    buf$1 = randomBytes$1(BUFFER_SIZE$1);
  }
  const b22 = Array.prototype.slice.call(buf$1, bufIdx$1, bufIdx$1 += 16);
  b22[6] = b22[6] & 15 | 64;
  b22[8] = b22[8] & 63 | 128;
  return hexBytes$1[b22[0]] + hexBytes$1[b22[1]] + hexBytes$1[b22[2]] + hexBytes$1[b22[3]] + "-" + hexBytes$1[b22[4]] + hexBytes$1[b22[5]] + "-" + hexBytes$1[b22[6]] + hexBytes$1[b22[7]] + "-" + hexBytes$1[b22[8]] + hexBytes$1[b22[9]] + "-" + hexBytes$1[b22[10]] + hexBytes$1[b22[11]] + hexBytes$1[b22[12]] + hexBytes$1[b22[13]] + hexBytes$1[b22[14]] + hexBytes$1[b22[15]];
}
function parseValue$1(val) {
  return val === void 0 || val === null ? null : val;
}
function getId$1(val, required) {
  return val === void 0 || val === null ? required === true ? `f_${uid_default$1()}` : null : val;
}
function use_id_default$1({ getValue, required = true } = {}) {
  if (isRuntimeSsrPreHydration$1.value === true) {
    const id3 = getValue !== void 0 ? ref$1(parseValue$1(getValue())) : ref$1(null);
    if (required === true && id3.value === null) {
      onMounted(() => {
        id3.value = `f_${uid_default$1()}`;
      });
    }
    if (getValue !== void 0) {
      watch(getValue, (newId) => {
        id3.value = getId$1(newId, required);
      });
    }
    return id3;
  }
  return getValue !== void 0 ? computed(() => getId$1(getValue(), required)) : ref$1(`f_${uid_default$1()}`);
}
var btnPropsList$1 = Object.keys(nonRoundBtnProps$1);
function passBtnProps$1(props4) {
  return btnPropsList$1.reduce((acc, key) => {
    const val = props4[key];
    if (val !== void 0) {
      acc[key] = val;
    }
    return acc;
  }, {});
}
var QBtnDropdown_default$1 = createComponent$1({
  name: "QBtnDropdown",
  props: {
    ...nonRoundBtnProps$1,
    ...useTransitionProps$1,
    modelValue: Boolean,
    split: Boolean,
    dropdownIcon: String,
    contentClass: [Array, String, Object],
    contentStyle: [Array, String, Object],
    cover: Boolean,
    persistent: Boolean,
    noRouteDismiss: Boolean,
    autoClose: Boolean,
    menuAnchor: {
      type: String,
      default: "bottom end"
    },
    menuSelf: {
      type: String,
      default: "top end"
    },
    menuOffset: Array,
    disableMainBtn: Boolean,
    disableDropdown: Boolean,
    noIconAnimation: Boolean,
    toggleAriaLabel: String
  },
  emits: ["update:modelValue", "click", "beforeShow", "show", "beforeHide", "hide"],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const showing = ref$1(props4.modelValue);
    const menuRef = ref$1(null);
    const targetUid = use_id_default$1();
    const ariaAttrs = computed(() => {
      const acc = {
        "aria-expanded": showing.value === true ? "true" : "false",
        "aria-haspopup": "true",
        "aria-controls": targetUid.value,
        "aria-label": props4.toggleAriaLabel || proxy.$q.lang.label[showing.value === true ? "collapse" : "expand"](props4.label)
      };
      if (props4.disable === true || (props4.split === false && props4.disableMainBtn === true || props4.disableDropdown === true)) {
        acc["aria-disabled"] = "true";
      }
      return acc;
    });
    const iconClass = computed(
      () => "q-btn-dropdown__arrow" + (showing.value === true && props4.noIconAnimation === false ? " rotate-180" : "") + (props4.split === false ? " q-btn-dropdown__arrow-container" : "")
    );
    const btnDesignAttr = computed(() => getBtnDesignAttr$1(props4));
    const btnProps = computed(() => passBtnProps$1(props4));
    watch(() => props4.modelValue, (val) => {
      menuRef.value !== null && menuRef.value[val ? "show" : "hide"]();
    });
    watch(() => props4.split, hide);
    function onBeforeShow(e22) {
      showing.value = true;
      emit("beforeShow", e22);
    }
    function onShow(e22) {
      emit("show", e22);
      emit("update:modelValue", true);
    }
    function onBeforeHide(e22) {
      showing.value = false;
      emit("beforeHide", e22);
    }
    function onHide(e22) {
      emit("hide", e22);
      emit("update:modelValue", false);
    }
    function onClick(e22) {
      emit("click", e22);
    }
    function onClickHide(e22) {
      stop$1(e22);
      hide();
      emit("click", e22);
    }
    function toggle(evt) {
      menuRef.value !== null && menuRef.value.toggle(evt);
    }
    function show(evt) {
      menuRef.value !== null && menuRef.value.show(evt);
    }
    function hide(evt) {
      menuRef.value !== null && menuRef.value.hide(evt);
    }
    Object.assign(proxy, {
      show,
      hide,
      toggle
    });
    onMounted(() => {
      props4.modelValue === true && show();
    });
    return () => {
      const Arrow = [
        h(QIcon_default$1, {
          class: iconClass.value,
          name: props4.dropdownIcon || proxy.$q.iconSet.arrow.dropdown
        })
      ];
      props4.disableDropdown !== true && Arrow.push(
        h(QMenu_default$1, {
          ref: menuRef,
          id: targetUid.value,
          class: props4.contentClass,
          style: props4.contentStyle,
          cover: props4.cover,
          fit: true,
          persistent: props4.persistent,
          noRouteDismiss: props4.noRouteDismiss,
          autoClose: props4.autoClose,
          anchor: props4.menuAnchor,
          self: props4.menuSelf,
          offset: props4.menuOffset,
          separateClosePopup: true,
          transitionShow: props4.transitionShow,
          transitionHide: props4.transitionHide,
          transitionDuration: props4.transitionDuration,
          onBeforeShow,
          onShow,
          onBeforeHide,
          onHide
        }, slots.default)
      );
      if (props4.split === false) {
        return h(QBtn_default$1, {
          class: "q-btn-dropdown q-btn-dropdown--simple",
          ...btnProps.value,
          ...ariaAttrs.value,
          disable: props4.disable === true || props4.disableMainBtn === true,
          noWrap: true,
          round: false,
          onClick
        }, {
          default: () => hSlot$1(slots.label, []).concat(Arrow),
          loading: slots.loading
        });
      }
      return h(QBtnGroup_default$1, {
        class: "q-btn-dropdown q-btn-dropdown--split no-wrap q-btn-item",
        rounded: props4.rounded,
        square: props4.square,
        ...btnDesignAttr.value,
        glossy: props4.glossy,
        stretch: props4.stretch
      }, () => [
        h(QBtn_default$1, {
          class: "q-btn-dropdown--current",
          ...btnProps.value,
          disable: props4.disable === true || props4.disableMainBtn === true,
          noWrap: true,
          round: false,
          onClick: onClickHide
        }, {
          default: slots.label,
          loading: slots.loading
        }),
        h(QBtn_default$1, {
          class: "q-btn-dropdown__arrow-container q-anchor--skip",
          ...ariaAttrs.value,
          ...btnDesignAttr.value,
          disable: props4.disable === true || props4.disableDropdown === true,
          rounded: props4.rounded,
          color: props4.color,
          textColor: props4.textColor,
          dense: props4.dense,
          size: props4.size,
          padding: props4.padding,
          ripple: props4.ripple
        }, () => Arrow)
      ]);
    };
  }
});
var useFormProps$1 = {
  name: String
};
function useFormAttrs$1(props4) {
  return computed(() => ({
    type: "hidden",
    name: props4.name,
    value: props4.modelValue
  }));
}
function useFormInject$1(formAttrs = {}) {
  return (child, action, className) => {
    child[action](
      h("input", {
        class: "hidden" + (className || ""),
        ...formAttrs.value
      })
    );
  };
}
function useFormInputNameAttr$1(props4) {
  return computed(() => props4.name || props4.for);
}
createComponent$1({
  name: "QBtnToggle",
  props: {
    ...useFormProps$1,
    modelValue: {
      required: true
    },
    options: {
      type: Array,
      required: true,
      validator: (v) => v.every(
        (opt) => ("label" in opt || "icon" in opt || "slot" in opt) && "value" in opt
      )
    },
    // To avoid seeing the active raise shadow through
    // the transparent button, give it a color (even white)
    color: String,
    textColor: String,
    toggleColor: {
      type: String,
      default: "primary"
    },
    toggleTextColor: String,
    outline: Boolean,
    flat: Boolean,
    unelevated: Boolean,
    rounded: Boolean,
    push: Boolean,
    glossy: Boolean,
    size: String,
    padding: String,
    noCaps: Boolean,
    noWrap: Boolean,
    dense: Boolean,
    readonly: Boolean,
    disable: Boolean,
    stack: Boolean,
    stretch: Boolean,
    spread: Boolean,
    clearable: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    }
  },
  emits: ["update:modelValue", "clear", "click"],
  setup(props4, { slots, emit }) {
    const hasActiveValue = computed(
      () => props4.options.find((opt) => opt.value === props4.modelValue) !== void 0
    );
    const formAttrs = computed(() => ({
      type: "hidden",
      name: props4.name,
      value: props4.modelValue
    }));
    const injectFormInput = useFormInject$1(formAttrs);
    const btnDesignAttr = computed(() => getBtnDesignAttr$1(props4));
    const btnOptionDesign = computed(() => ({
      rounded: props4.rounded,
      dense: props4.dense,
      ...btnDesignAttr.value
    }));
    const btnOptions = computed(() => props4.options.map((item, i22) => {
      const { attrs, value: value2, slot, ...opt } = item;
      return {
        slot,
        props: {
          key: i22,
          "aria-pressed": value2 === props4.modelValue ? "true" : "false",
          ...attrs,
          ...opt,
          ...btnOptionDesign.value,
          disable: props4.disable === true || opt.disable === true,
          // Options that come from the button specific options first, then from general props
          color: value2 === props4.modelValue ? mergeOpt(opt, "toggleColor") : mergeOpt(opt, "color"),
          textColor: value2 === props4.modelValue ? mergeOpt(opt, "toggleTextColor") : mergeOpt(opt, "textColor"),
          noCaps: mergeOpt(opt, "noCaps") === true,
          noWrap: mergeOpt(opt, "noWrap") === true,
          size: mergeOpt(opt, "size"),
          padding: mergeOpt(opt, "padding"),
          ripple: mergeOpt(opt, "ripple"),
          stack: mergeOpt(opt, "stack") === true,
          stretch: mergeOpt(opt, "stretch") === true,
          onClick(e22) {
            set2(value2, item, e22);
          }
        }
      };
    }));
    function set2(value2, opt, e22) {
      if (props4.readonly !== true) {
        if (props4.modelValue === value2) {
          if (props4.clearable === true) {
            emit("update:modelValue", null, null);
            emit("clear");
          }
        } else {
          emit("update:modelValue", value2, opt);
        }
        emit("click", e22);
      }
    }
    function mergeOpt(opt, key) {
      return opt[key] === void 0 ? props4[key] : opt[key];
    }
    function getContent() {
      const child = btnOptions.value.map((opt) => {
        return h(QBtn_default$1, opt.props, opt.slot !== void 0 ? slots[opt.slot] : void 0);
      });
      if (props4.name !== void 0 && props4.disable !== true && hasActiveValue.value === true) {
        injectFormInput(child, "push");
      }
      return hMergeSlot$1(slots.default, child);
    }
    return () => h(QBtnGroup_default$1, {
      class: "q-btn-toggle",
      ...btnDesignAttr.value,
      rounded: props4.rounded,
      stretch: props4.stretch,
      glossy: props4.glossy,
      spread: props4.spread
    }, getContent);
  }
});
var QCard_default$1 = createComponent$1({
  name: "QCard",
  props: {
    ...useDarkProps$1,
    tag: {
      type: String,
      default: "div"
    },
    square: Boolean,
    flat: Boolean,
    bordered: Boolean
  },
  setup(props4, { slots }) {
    const { proxy: { $q } } = getCurrentInstance();
    const isDark = use_dark_default$1(props4, $q);
    const classes = computed(
      () => "q-card" + (isDark.value === true ? " q-card--dark q-dark" : "") + (props4.bordered === true ? " q-card--bordered" : "") + (props4.square === true ? " q-card--square no-border-radius" : "") + (props4.flat === true ? " q-card--flat no-shadow" : "")
    );
    return () => h(props4.tag, { class: classes.value }, hSlot$1(slots.default));
  }
});
var QCardSection_default$1 = createComponent$1({
  name: "QCardSection",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    horizontal: Boolean
  },
  setup(props4, { slots }) {
    const classes = computed(
      () => `q-card__section q-card__section--${props4.horizontal === true ? "horiz row no-wrap" : "vert"}`
    );
    return () => h(props4.tag, { class: classes.value }, hSlot$1(slots.default));
  }
});
var QCardActions_default$1 = createComponent$1({
  name: "QCardActions",
  props: {
    ...useAlignProps$1,
    vertical: Boolean
  },
  setup(props4, { slots }) {
    const alignClass = use_align_default$1(props4);
    const classes = computed(
      () => `q-card__actions ${alignClass.value} q-card__actions--${props4.vertical === true ? "vert column" : "horiz row"}`
    );
    return () => h("div", { class: classes.value }, hSlot$1(slots.default));
  }
});
var modifiersAll$1 = {
  left: true,
  right: true,
  up: true,
  down: true,
  horizontal: true,
  vertical: true
};
var directionList$1 = Object.keys(modifiersAll$1);
modifiersAll$1.all = true;
function getModifierDirections$1(mod2) {
  const dir = {};
  for (const direction of directionList$1) {
    if (mod2[direction] === true) {
      dir[direction] = true;
    }
  }
  if (Object.keys(dir).length === 0) {
    return modifiersAll$1;
  }
  if (dir.horizontal === true) {
    dir.left = dir.right = true;
  } else if (dir.left === true && dir.right === true) {
    dir.horizontal = true;
  }
  if (dir.vertical === true) {
    dir.up = dir.down = true;
  } else if (dir.up === true && dir.down === true) {
    dir.vertical = true;
  }
  if (dir.horizontal === true && dir.vertical === true) {
    dir.all = true;
  }
  return dir;
}
var avoidNodeNamesList$1 = ["INPUT", "TEXTAREA"];
function shouldStart$1(evt, ctx) {
  return ctx.event === void 0 && evt.target !== void 0 && evt.target.draggable !== true && typeof ctx.handler === "function" && avoidNodeNamesList$1.includes(evt.target.nodeName.toUpperCase()) === false && (evt.qClonedBy === void 0 || evt.qClonedBy.indexOf(ctx.uid) === -1);
}
function parseArg$1(arg) {
  const data = [0.06, 6, 50];
  if (typeof arg === "string" && arg.length) {
    arg.split(":").forEach((val, index2) => {
      const v = parseFloat(val);
      v && (data[index2] = v);
    });
  }
  return data;
}
var TouchSwipe_default$1 = createDirective$1(
  {
    name: "touch-swipe",
    beforeMount(el, { value: value2, arg, modifiers }) {
      if (modifiers.mouse !== true && client$1.has.touch !== true) {
        return;
      }
      const mouseCapture = modifiers.mouseCapture === true ? "Capture" : "";
      const ctx = {
        handler: value2,
        sensitivity: parseArg$1(arg),
        direction: getModifierDirections$1(modifiers),
        noop: noop$1,
        mouseStart(evt) {
          if (shouldStart$1(evt, ctx) && leftClick$1(evt)) {
            addEvt$1(ctx, "temp", [
              [document, "mousemove", "move", `notPassive${mouseCapture}`],
              [document, "mouseup", "end", "notPassiveCapture"]
            ]);
            ctx.start(evt, true);
          }
        },
        touchStart(evt) {
          if (shouldStart$1(evt, ctx)) {
            const target2 = evt.target;
            addEvt$1(ctx, "temp", [
              [target2, "touchmove", "move", "notPassiveCapture"],
              [target2, "touchcancel", "end", "notPassiveCapture"],
              [target2, "touchend", "end", "notPassiveCapture"]
            ]);
            ctx.start(evt);
          }
        },
        start(evt, mouseEvent) {
          client$1.is.firefox === true && preventDraggable$1(el, true);
          const pos = position$1(evt);
          ctx.event = {
            x: pos.left,
            y: pos.top,
            time: Date.now(),
            mouse: mouseEvent === true,
            dir: false
          };
        },
        move(evt) {
          if (ctx.event === void 0) {
            return;
          }
          if (ctx.event.dir !== false) {
            stopAndPrevent$1(evt);
            return;
          }
          const time = Date.now() - ctx.event.time;
          if (time === 0) {
            return;
          }
          const pos = position$1(evt), distX = pos.left - ctx.event.x, absX = Math.abs(distX), distY = pos.top - ctx.event.y, absY = Math.abs(distY);
          if (ctx.event.mouse !== true) {
            if (absX < ctx.sensitivity[1] && absY < ctx.sensitivity[1]) {
              ctx.end(evt);
              return;
            }
          } else if (window.getSelection().toString() !== "") {
            ctx.end(evt);
            return;
          } else if (absX < ctx.sensitivity[2] && absY < ctx.sensitivity[2]) {
            return;
          }
          const velX = absX / time, velY = absY / time;
          if (ctx.direction.vertical === true && absX < absY && absX < 100 && velY > ctx.sensitivity[0]) {
            ctx.event.dir = distY < 0 ? "up" : "down";
          }
          if (ctx.direction.horizontal === true && absX > absY && absY < 100 && velX > ctx.sensitivity[0]) {
            ctx.event.dir = distX < 0 ? "left" : "right";
          }
          if (ctx.direction.up === true && absX < absY && distY < 0 && absX < 100 && velY > ctx.sensitivity[0]) {
            ctx.event.dir = "up";
          }
          if (ctx.direction.down === true && absX < absY && distY > 0 && absX < 100 && velY > ctx.sensitivity[0]) {
            ctx.event.dir = "down";
          }
          if (ctx.direction.left === true && absX > absY && distX < 0 && absY < 100 && velX > ctx.sensitivity[0]) {
            ctx.event.dir = "left";
          }
          if (ctx.direction.right === true && absX > absY && distX > 0 && absY < 100 && velX > ctx.sensitivity[0]) {
            ctx.event.dir = "right";
          }
          if (ctx.event.dir !== false) {
            stopAndPrevent$1(evt);
            if (ctx.event.mouse === true) {
              document.body.classList.add("no-pointer-events--children");
              document.body.classList.add("non-selectable");
              clearSelection$1();
              ctx.styleCleanup = (withDelay) => {
                ctx.styleCleanup = void 0;
                document.body.classList.remove("non-selectable");
                const remove2 = () => {
                  document.body.classList.remove("no-pointer-events--children");
                };
                if (withDelay === true) {
                  setTimeout(remove2, 50);
                } else {
                  remove2();
                }
              };
            }
            ctx.handler({
              evt,
              touch: ctx.event.mouse !== true,
              mouse: ctx.event.mouse,
              direction: ctx.event.dir,
              duration: time,
              distance: {
                x: absX,
                y: absY
              }
            });
          } else {
            ctx.end(evt);
          }
        },
        end(evt) {
          if (ctx.event === void 0) {
            return;
          }
          cleanEvt$1(ctx, "temp");
          client$1.is.firefox === true && preventDraggable$1(el, false);
          ctx.styleCleanup !== void 0 && ctx.styleCleanup(true);
          evt !== void 0 && ctx.event.dir !== false && stopAndPrevent$1(evt);
          ctx.event = void 0;
        }
      };
      el.__qtouchswipe = ctx;
      if (modifiers.mouse === true) {
        const capture = modifiers.mouseCapture === true || modifiers.mousecapture === true ? "Capture" : "";
        addEvt$1(ctx, "main", [
          [el, "mousedown", "mouseStart", `passive${capture}`]
        ]);
      }
      client$1.has.touch === true && addEvt$1(ctx, "main", [
        [el, "touchstart", "touchStart", `passive${modifiers.capture === true ? "Capture" : ""}`],
        [el, "touchmove", "noop", "notPassiveCapture"]
        // cannot be passive (ex: iOS scroll)
      ]);
    },
    updated(el, bindings) {
      const ctx = el.__qtouchswipe;
      if (ctx !== void 0) {
        if (bindings.oldValue !== bindings.value) {
          typeof bindings.value !== "function" && ctx.end();
          ctx.handler = bindings.value;
        }
        ctx.direction = getModifierDirections$1(bindings.modifiers);
      }
    },
    beforeUnmount(el) {
      const ctx = el.__qtouchswipe;
      if (ctx !== void 0) {
        cleanEvt$1(ctx, "main");
        cleanEvt$1(ctx, "temp");
        client$1.is.firefox === true && preventDraggable$1(el, false);
        ctx.styleCleanup !== void 0 && ctx.styleCleanup();
        delete el.__qtouchswipe;
      }
    }
  }
);
function use_render_cache_default$1() {
  let cache = /* @__PURE__ */ Object.create(null);
  return {
    getCache: (key, defaultValue) => cache[key] === void 0 ? cache[key] = typeof defaultValue === "function" ? defaultValue() : defaultValue : cache[key],
    setCache(key, obj) {
      cache[key] = obj;
    },
    hasCache(key) {
      return Object.hasOwnProperty.call(cache, key);
    },
    clearCache(key) {
      if (key !== void 0) {
        delete cache[key];
      } else {
        cache = /* @__PURE__ */ Object.create(null);
      }
    }
  };
}
var usePanelChildProps$1 = {
  name: { required: true },
  disable: Boolean
};
var PanelWrapper$1 = {
  setup(_, { slots }) {
    return () => h("div", {
      class: "q-panel scroll",
      role: "tabpanel"
    }, hSlot$1(slots.default));
  }
};
var usePanelProps$1 = {
  modelValue: {
    required: true
  },
  animated: Boolean,
  infinite: Boolean,
  swipeable: Boolean,
  vertical: Boolean,
  transitionPrev: String,
  transitionNext: String,
  transitionDuration: {
    type: [String, Number],
    default: 300
  },
  keepAlive: Boolean,
  keepAliveInclude: [String, Array, RegExp],
  keepAliveExclude: [String, Array, RegExp],
  keepAliveMax: Number
};
var usePanelEmits$1 = ["update:modelValue", "beforeTransition", "transition"];
function use_panel_default$1() {
  const { props: props4, emit, proxy } = getCurrentInstance();
  const { getCache } = use_render_cache_default$1();
  const { registerTimeout } = use_timeout_default$1();
  let panels, forcedPanelTransition;
  const panelIndex = ref$1(null);
  const panelTransition = ref$1(null);
  function onSwipe(evt) {
    const dir = props4.vertical === true ? "up" : "left";
    goToPanelByOffset((proxy.$q.lang.rtl === true ? -1 : 1) * (evt.direction === dir ? 1 : -1));
  }
  const panelDirectives = computed(() => {
    return [[
      TouchSwipe_default$1,
      onSwipe,
      void 0,
      {
        horizontal: props4.vertical !== true,
        vertical: props4.vertical,
        mouse: true
      }
    ]];
  });
  const transitionPrev = computed(
    () => props4.transitionPrev || `slide-${props4.vertical === true ? "down" : "right"}`
  );
  const transitionNext = computed(
    () => props4.transitionNext || `slide-${props4.vertical === true ? "up" : "left"}`
  );
  const transitionStyle = computed(
    () => `--q-transition-duration: ${props4.transitionDuration}ms`
  );
  const contentKey = computed(() => typeof props4.modelValue === "string" || typeof props4.modelValue === "number" ? props4.modelValue : String(props4.modelValue));
  const keepAliveProps = computed(() => ({
    include: props4.keepAliveInclude,
    exclude: props4.keepAliveExclude,
    max: props4.keepAliveMax
  }));
  const needsUniqueKeepAliveWrapper = computed(
    () => props4.keepAliveInclude !== void 0 || props4.keepAliveExclude !== void 0
  );
  watch(() => props4.modelValue, (newVal, oldVal) => {
    const index2 = isValidPanelName(newVal) === true ? getPanelIndex(newVal) : -1;
    if (forcedPanelTransition !== true) {
      updatePanelTransition(
        index2 === -1 ? 0 : index2 < getPanelIndex(oldVal) ? -1 : 1
      );
    }
    if (panelIndex.value !== index2) {
      panelIndex.value = index2;
      emit("beforeTransition", newVal, oldVal);
      registerTimeout(() => {
        emit("transition", newVal, oldVal);
      }, props4.transitionDuration);
    }
  });
  function nextPanel() {
    goToPanelByOffset(1);
  }
  function previousPanel() {
    goToPanelByOffset(-1);
  }
  function goToPanel(name2) {
    emit("update:modelValue", name2);
  }
  function isValidPanelName(name2) {
    return name2 !== void 0 && name2 !== null && name2 !== "";
  }
  function getPanelIndex(name2) {
    return panels.findIndex((panel) => {
      return panel.props.name === name2 && panel.props.disable !== "" && panel.props.disable !== true;
    });
  }
  function getEnabledPanels() {
    return panels.filter((panel) => {
      return panel.props.disable !== "" && panel.props.disable !== true;
    });
  }
  function updatePanelTransition(direction) {
    const val = direction !== 0 && props4.animated === true && panelIndex.value !== -1 ? "q-transition--" + (direction === -1 ? transitionPrev.value : transitionNext.value) : null;
    if (panelTransition.value !== val) {
      panelTransition.value = val;
    }
  }
  function goToPanelByOffset(direction, startIndex = panelIndex.value) {
    let index2 = startIndex + direction;
    while (index2 !== -1 && index2 < panels.length) {
      const opt = panels[index2];
      if (opt !== void 0 && opt.props.disable !== "" && opt.props.disable !== true) {
        updatePanelTransition(direction);
        forcedPanelTransition = true;
        emit("update:modelValue", opt.props.name);
        setTimeout(() => {
          forcedPanelTransition = false;
        });
        return;
      }
      index2 += direction;
    }
    if (props4.infinite === true && panels.length !== 0 && startIndex !== -1 && startIndex !== panels.length) {
      goToPanelByOffset(direction, direction === -1 ? panels.length : -1);
    }
  }
  function updatePanelIndex() {
    const index2 = getPanelIndex(props4.modelValue);
    if (panelIndex.value !== index2) {
      panelIndex.value = index2;
    }
    return true;
  }
  function getPanelContentChild() {
    const panel = isValidPanelName(props4.modelValue) === true && updatePanelIndex() && panels[panelIndex.value];
    return props4.keepAlive === true ? [
      h(KeepAlive, keepAliveProps.value, [
        h(
          needsUniqueKeepAliveWrapper.value === true ? getCache(contentKey.value, () => ({ ...PanelWrapper$1, name: contentKey.value })) : PanelWrapper$1,
          { key: contentKey.value, style: transitionStyle.value },
          () => panel
        )
      ])
    ] : [
      h("div", {
        class: "q-panel scroll",
        style: transitionStyle.value,
        key: contentKey.value,
        role: "tabpanel"
      }, [panel])
    ];
  }
  function getPanelContent() {
    if (panels.length === 0) {
      return;
    }
    return props4.animated === true ? [h(Transition, { name: panelTransition.value }, getPanelContentChild)] : getPanelContentChild();
  }
  function updatePanelsList(slots) {
    panels = getNormalizedVNodes$1(
      hSlot$1(slots.default, [])
    ).filter(
      (panel) => panel.props !== null && panel.props.slot === void 0 && isValidPanelName(panel.props.name) === true
    );
    return panels.length;
  }
  function getPanels() {
    return panels;
  }
  Object.assign(proxy, {
    next: nextPanel,
    previous: previousPanel,
    goTo: goToPanel
  });
  return {
    panelIndex,
    panelDirectives,
    updatePanelsList,
    updatePanelIndex,
    getPanelContent,
    getEnabledPanels,
    getPanels,
    isValidPanelName,
    keepAliveProps,
    needsUniqueKeepAliveWrapper,
    goToPanelByOffset,
    goToPanel,
    nextPanel,
    previousPanel
  };
}
var counter$1 = 0;
var useFullscreenProps$1 = {
  fullscreen: Boolean,
  noRouteFullscreenExit: Boolean
};
var useFullscreenEmits$1 = ["update:fullscreen", "fullscreen"];
function use_fullscreen_default$1() {
  const vm2 = getCurrentInstance();
  const { props: props4, emit, proxy } = vm2;
  let fullscreenFillerNode, container;
  const inFullscreen = ref$1(false);
  vmHasRouter$1(vm2) === true && watch(() => proxy.$route.fullPath, () => {
    props4.noRouteFullscreenExit !== true && exitFullscreen();
  });
  watch(() => props4.fullscreen, (v) => {
    if (inFullscreen.value !== v) {
      toggleFullscreen();
    }
  });
  watch(inFullscreen, (v) => {
    emit("update:fullscreen", v);
    emit("fullscreen", v);
  });
  function toggleFullscreen() {
    if (inFullscreen.value === true) {
      exitFullscreen();
    } else {
      setFullscreen();
    }
  }
  function setFullscreen() {
    if (inFullscreen.value === true) {
      return;
    }
    inFullscreen.value = true;
    container = proxy.$el.parentNode;
    container.replaceChild(fullscreenFillerNode, proxy.$el);
    document.body.appendChild(proxy.$el);
    counter$1++;
    if (counter$1 === 1) {
      document.body.classList.add("q-body--fullscreen-mixin");
    }
  }
  function exitFullscreen() {
    if (inFullscreen.value !== true) {
      return;
    }
    container.replaceChild(proxy.$el, fullscreenFillerNode);
    inFullscreen.value = false;
    counter$1 = Math.max(0, counter$1 - 1);
    if (counter$1 === 0) {
      document.body.classList.remove("q-body--fullscreen-mixin");
      if (proxy.$el.scrollIntoView !== void 0) {
        setTimeout(() => {
          proxy.$el.scrollIntoView();
        });
      }
    }
  }
  onBeforeMount(() => {
    fullscreenFillerNode = document.createElement("span");
  });
  onMounted(() => {
    props4.fullscreen === true && setFullscreen();
  });
  onBeforeUnmount(exitFullscreen);
  Object.assign(proxy, {
    toggleFullscreen,
    setFullscreen,
    exitFullscreen
  });
  return {
    inFullscreen,
    toggleFullscreen
  };
}
var navigationPositionOptions$1 = ["top", "right", "bottom", "left"];
var controlTypeOptions$1 = ["regular", "flat", "outline", "push", "unelevated"];
createComponent$1({
  name: "QCarousel",
  props: {
    ...useDarkProps$1,
    ...usePanelProps$1,
    ...useFullscreenProps$1,
    transitionPrev: {
      // usePanelParentProps override
      type: String,
      default: "fade"
    },
    transitionNext: {
      // usePanelParentProps override
      type: String,
      default: "fade"
    },
    height: String,
    padding: Boolean,
    controlColor: String,
    controlTextColor: String,
    controlType: {
      type: String,
      validator: (v) => controlTypeOptions$1.includes(v),
      default: "flat"
    },
    autoplay: [Number, Boolean],
    arrows: Boolean,
    prevIcon: String,
    nextIcon: String,
    navigation: Boolean,
    navigationPosition: {
      type: String,
      validator: (v) => navigationPositionOptions$1.includes(v)
    },
    navigationIcon: String,
    navigationActiveIcon: String,
    thumbnails: Boolean
  },
  emits: [
    ...useFullscreenEmits$1,
    ...usePanelEmits$1
  ],
  setup(props4, { slots }) {
    const { proxy: { $q } } = getCurrentInstance();
    const isDark = use_dark_default$1(props4, $q);
    let timer2 = null, panelsLen;
    const {
      updatePanelsList,
      getPanelContent,
      panelDirectives,
      goToPanel,
      previousPanel,
      nextPanel,
      getEnabledPanels,
      panelIndex
    } = use_panel_default$1();
    const { inFullscreen } = use_fullscreen_default$1();
    const style2 = computed(() => inFullscreen.value !== true && props4.height !== void 0 ? { height: props4.height } : {});
    const direction = computed(() => props4.vertical === true ? "vertical" : "horizontal");
    const navigationPosition = computed(
      () => props4.navigationPosition || (props4.vertical === true ? "right" : "bottom")
    );
    const classes = computed(
      () => `q-carousel q-panel-parent q-carousel--with${props4.padding === true ? "" : "out"}-padding` + (inFullscreen.value === true ? " fullscreen" : "") + (isDark.value === true ? " q-carousel--dark q-dark" : "") + (props4.arrows === true ? ` q-carousel--arrows-${direction.value}` : "") + (props4.navigation === true ? ` q-carousel--navigation-${navigationPosition.value}` : "")
    );
    const arrowIcons = computed(() => {
      const ico = [
        props4.prevIcon || $q.iconSet.carousel[props4.vertical === true ? "up" : "left"],
        props4.nextIcon || $q.iconSet.carousel[props4.vertical === true ? "down" : "right"]
      ];
      return props4.vertical === false && $q.lang.rtl === true ? ico.reverse() : ico;
    });
    const navIcon = computed(() => props4.navigationIcon || $q.iconSet.carousel.navigationIcon);
    const navActiveIcon = computed(() => props4.navigationActiveIcon || navIcon.value);
    const controlProps = computed(() => ({
      color: props4.controlColor,
      textColor: props4.controlTextColor,
      round: true,
      [props4.controlType]: true,
      dense: true
    }));
    watch(() => props4.modelValue, () => {
      if (props4.autoplay) {
        startTimer();
      }
    });
    watch(() => props4.autoplay, (val) => {
      if (val) {
        startTimer();
      } else if (timer2 !== null) {
        clearTimeout(timer2);
        timer2 = null;
      }
    });
    function startTimer() {
      const duration2 = isNumber$1(props4.autoplay) === true ? Math.abs(props4.autoplay) : 5e3;
      timer2 !== null && clearTimeout(timer2);
      timer2 = setTimeout(() => {
        timer2 = null;
        if (duration2 >= 0) {
          nextPanel();
        } else {
          previousPanel();
        }
      }, duration2);
    }
    onMounted(() => {
      props4.autoplay && startTimer();
    });
    onBeforeUnmount(() => {
      timer2 !== null && clearTimeout(timer2);
    });
    function getNavigationContainer(type2, mapping) {
      return h("div", {
        class: `q-carousel__control q-carousel__navigation no-wrap absolute flex q-carousel__navigation--${type2} q-carousel__navigation--${navigationPosition.value}` + (props4.controlColor !== void 0 ? ` text-${props4.controlColor}` : "")
      }, [
        h("div", {
          class: "q-carousel__navigation-inner flex flex-center no-wrap"
        }, getEnabledPanels().map(mapping))
      ]);
    }
    function getContent() {
      const node = [];
      if (props4.navigation === true) {
        const fn = slots["navigation-icon"] !== void 0 ? slots["navigation-icon"] : (opts) => h(QBtn_default$1, {
          key: "nav" + opts.name,
          class: `q-carousel__navigation-icon q-carousel__navigation-icon--${opts.active === true ? "" : "in"}active`,
          ...opts.btnProps,
          onClick: opts.onClick
        });
        const maxIndex = panelsLen - 1;
        node.push(
          getNavigationContainer("buttons", (panel, index2) => {
            const name2 = panel.props.name;
            const active = panelIndex.value === index2;
            return fn({
              index: index2,
              maxIndex,
              name: name2,
              active,
              btnProps: {
                icon: active === true ? navActiveIcon.value : navIcon.value,
                size: "sm",
                ...controlProps.value
              },
              onClick: () => {
                goToPanel(name2);
              }
            });
          })
        );
      } else if (props4.thumbnails === true) {
        const color2 = props4.controlColor !== void 0 ? ` text-${props4.controlColor}` : "";
        node.push(getNavigationContainer("thumbnails", (panel) => {
          const slide = panel.props;
          return h("img", {
            key: "tmb#" + slide.name,
            class: `q-carousel__thumbnail q-carousel__thumbnail--${slide.name === props4.modelValue ? "" : "in"}active` + color2,
            src: slide.imgSrc || slide["img-src"],
            onClick: () => {
              goToPanel(slide.name);
            }
          });
        }));
      }
      if (props4.arrows === true && panelIndex.value >= 0) {
        if (props4.infinite === true || panelIndex.value > 0) {
          node.push(
            h("div", {
              key: "prev",
              class: `q-carousel__control q-carousel__arrow q-carousel__prev-arrow q-carousel__prev-arrow--${direction.value} absolute flex flex-center`
            }, [
              h(QBtn_default$1, {
                icon: arrowIcons.value[0],
                ...controlProps.value,
                onClick: previousPanel
              })
            ])
          );
        }
        if (props4.infinite === true || panelIndex.value < panelsLen - 1) {
          node.push(
            h("div", {
              key: "next",
              class: `q-carousel__control q-carousel__arrow q-carousel__next-arrow q-carousel__next-arrow--${direction.value} absolute flex flex-center`
            }, [
              h(QBtn_default$1, {
                icon: arrowIcons.value[1],
                ...controlProps.value,
                onClick: nextPanel
              })
            ])
          );
        }
      }
      return hMergeSlot$1(slots.control, node);
    }
    return () => {
      panelsLen = updatePanelsList(slots);
      return h("div", {
        class: classes.value,
        style: style2.value
      }, [
        hDir$1(
          "div",
          { class: "q-carousel__slides-container" },
          getPanelContent(),
          "sl-cont",
          props4.swipeable,
          () => panelDirectives.value
        )
      ].concat(getContent()));
    };
  }
});
createComponent$1({
  name: "QCarouselSlide",
  props: {
    ...usePanelChildProps$1,
    imgSrc: String
  },
  setup(props4, { slots }) {
    const style2 = computed(() => props4.imgSrc ? { backgroundImage: `url("${props4.imgSrc}")` } : {});
    return () => h("div", {
      class: "q-carousel__slide",
      style: style2.value
    }, hSlot$1(slots.default));
  }
});
createComponent$1({
  name: "QCarouselControl",
  props: {
    position: {
      type: String,
      default: "bottom-right",
      validator: (v) => [
        "top-right",
        "top-left",
        "bottom-right",
        "bottom-left",
        "top",
        "right",
        "bottom",
        "left"
      ].includes(v)
    },
    offset: {
      type: Array,
      default: () => [18, 18],
      validator: (v) => v.length === 2
    }
  },
  setup(props4, { slots }) {
    const classes = computed(() => `q-carousel__control absolute absolute-${props4.position}`);
    const style2 = computed(() => ({
      margin: `${props4.offset[1]}px ${props4.offset[0]}px`
    }));
    return () => h("div", {
      class: classes.value,
      style: style2.value
    }, hSlot$1(slots.default));
  }
});
createComponent$1({
  name: "QChatMessage",
  props: {
    sent: Boolean,
    label: String,
    bgColor: String,
    textColor: String,
    name: String,
    avatar: String,
    text: Array,
    stamp: String,
    size: String,
    labelHtml: Boolean,
    nameHtml: Boolean,
    textHtml: Boolean,
    stampHtml: Boolean
  },
  setup(props4, { slots }) {
    const op = computed(() => props4.sent === true ? "sent" : "received");
    const textClass = computed(
      () => `q-message-text-content q-message-text-content--${op.value}` + (props4.textColor !== void 0 ? ` text-${props4.textColor}` : "")
    );
    const messageClass = computed(
      () => `q-message-text q-message-text--${op.value}` + (props4.bgColor !== void 0 ? ` text-${props4.bgColor}` : "")
    );
    const containerClass = computed(
      () => "q-message-container row items-end no-wrap" + (props4.sent === true ? " reverse" : "")
    );
    const sizeClass = computed(() => props4.size !== void 0 ? `col-${props4.size}` : "");
    const domProps = computed(() => ({
      msg: props4.textHtml === true ? "innerHTML" : "textContent",
      stamp: props4.stampHtml === true ? "innerHTML" : "textContent",
      name: props4.nameHtml === true ? "innerHTML" : "textContent",
      label: props4.labelHtml === true ? "innerHTML" : "textContent"
    }));
    function wrapStamp(node) {
      if (slots.stamp !== void 0) {
        return [node, h("div", { class: "q-message-stamp" }, slots.stamp())];
      }
      if (props4.stamp) {
        return [
          node,
          h("div", {
            class: "q-message-stamp",
            [domProps.value.stamp]: props4.stamp
          })
        ];
      }
      return [node];
    }
    function getText(contentList, withSlots) {
      const content = withSlots === true ? contentList.length > 1 ? (text2) => text2 : (text2) => h("div", [text2]) : (text2) => h("div", { [domProps.value.msg]: text2 });
      return contentList.map((msg, index2) => h("div", {
        key: index2,
        class: messageClass.value
      }, [
        h("div", { class: textClass.value }, wrapStamp(content(msg)))
      ]));
    }
    return () => {
      const container = [];
      if (slots.avatar !== void 0) {
        container.push(slots.avatar());
      } else if (props4.avatar !== void 0) {
        container.push(
          h("img", {
            class: `q-message-avatar q-message-avatar--${op.value}`,
            src: props4.avatar,
            "aria-hidden": "true"
          })
        );
      }
      const msg = [];
      if (slots.name !== void 0) {
        msg.push(
          h("div", { class: `q-message-name q-message-name--${op.value}` }, slots.name())
        );
      } else if (props4.name !== void 0) {
        msg.push(
          h("div", {
            class: `q-message-name q-message-name--${op.value}`,
            [domProps.value.name]: props4.name
          })
        );
      }
      if (slots.default !== void 0) {
        msg.push(
          getText(
            getNormalizedVNodes$1(slots.default()),
            true
          )
        );
      } else if (props4.text !== void 0) {
        msg.push(getText(props4.text));
      }
      container.push(
        h("div", { class: sizeClass.value }, msg)
      );
      const child = [];
      if (slots.label !== void 0) {
        child.push(
          h("div", { class: "q-message-label" }, slots.label())
        );
      } else if (props4.label !== void 0) {
        child.push(
          h("div", {
            class: "q-message-label",
            [domProps.value.label]: props4.label
          })
        );
      }
      child.push(
        h("div", { class: containerClass.value }, container)
      );
      return h("div", {
        class: `q-message q-message-${op.value}`
      }, child);
    };
  }
});
function use_refocus_target_default$1(props4, rootRef) {
  const refocusRef = ref$1(null);
  const refocusTargetEl = computed(() => {
    if (props4.disable === true) {
      return null;
    }
    return h("span", {
      ref: refocusRef,
      class: "no-outline",
      tabindex: -1
    });
  });
  function refocusTarget(e22) {
    const root2 = rootRef.value;
    if (e22 !== void 0 && e22.type.indexOf("key") === 0) {
      if (root2 !== null && document.activeElement !== root2 && root2.contains(document.activeElement) === true) {
        root2.focus();
      }
    } else if (refocusRef.value !== null && (e22 === void 0 || root2 !== null && root2.contains(e22.target) === true)) {
      refocusRef.value.focus();
    }
  }
  return {
    refocusTargetEl,
    refocusTarget
  };
}
var option_sizes_default$1 = {
  xs: 30,
  sm: 35,
  md: 40,
  lg: 50,
  xl: 60
};
var useCheckboxProps$1 = {
  ...useDarkProps$1,
  ...useSizeProps$1,
  ...useFormProps$1,
  modelValue: {
    required: true,
    default: null
  },
  val: {},
  trueValue: { default: true },
  falseValue: { default: false },
  indeterminateValue: { default: null },
  checkedIcon: String,
  uncheckedIcon: String,
  indeterminateIcon: String,
  toggleOrder: {
    type: String,
    validator: (v) => v === "tf" || v === "ft"
  },
  toggleIndeterminate: Boolean,
  label: String,
  leftLabel: Boolean,
  color: String,
  keepColor: Boolean,
  dense: Boolean,
  disable: Boolean,
  tabindex: [String, Number]
};
var useCheckboxEmits$1 = ["update:modelValue"];
function use_checkbox_default$1(type2, getInner) {
  const { props: props4, slots, emit, proxy } = getCurrentInstance();
  const { $q } = proxy;
  const isDark = use_dark_default$1(props4, $q);
  const rootRef = ref$1(null);
  const { refocusTargetEl, refocusTarget } = use_refocus_target_default$1(props4, rootRef);
  const sizeStyle = use_size_default$1(props4, option_sizes_default$1);
  const modelIsArray = computed(
    () => props4.val !== void 0 && Array.isArray(props4.modelValue)
  );
  const index2 = computed(() => {
    const val = toRaw(props4.val);
    return modelIsArray.value === true ? props4.modelValue.findIndex((opt) => toRaw(opt) === val) : -1;
  });
  const isTrue = computed(() => modelIsArray.value === true ? index2.value !== -1 : toRaw(props4.modelValue) === toRaw(props4.trueValue));
  const isFalse = computed(() => modelIsArray.value === true ? index2.value === -1 : toRaw(props4.modelValue) === toRaw(props4.falseValue));
  const isIndeterminate = computed(
    () => isTrue.value === false && isFalse.value === false
  );
  const tabindex = computed(() => props4.disable === true ? -1 : props4.tabindex || 0);
  const classes = computed(
    () => `q-${type2} cursor-pointer no-outline row inline no-wrap items-center` + (props4.disable === true ? " disabled" : "") + (isDark.value === true ? ` q-${type2}--dark` : "") + (props4.dense === true ? ` q-${type2}--dense` : "") + (props4.leftLabel === true ? " reverse" : "")
  );
  const innerClass = computed(() => {
    const state2 = isTrue.value === true ? "truthy" : isFalse.value === true ? "falsy" : "indet";
    const color2 = props4.color !== void 0 && (props4.keepColor === true || (type2 === "toggle" ? isTrue.value === true : isFalse.value !== true)) ? ` text-${props4.color}` : "";
    return `q-${type2}__inner relative-position non-selectable q-${type2}__inner--${state2}${color2}`;
  });
  const formAttrs = computed(() => {
    const prop = { type: "checkbox" };
    props4.name !== void 0 && Object.assign(prop, {
      // see https://vuejs.org/guide/extras/render-function.html#creating-vnodes (.prop)
      ".checked": isTrue.value,
      "^checked": isTrue.value === true ? "checked" : void 0,
      name: props4.name,
      value: modelIsArray.value === true ? props4.val : props4.trueValue
    });
    return prop;
  });
  const injectFormInput = useFormInject$1(formAttrs);
  const attributes = computed(() => {
    const attrs = {
      tabindex: tabindex.value,
      role: type2 === "toggle" ? "switch" : "checkbox",
      "aria-label": props4.label,
      "aria-checked": isIndeterminate.value === true ? "mixed" : isTrue.value === true ? "true" : "false"
    };
    if (props4.disable === true) {
      attrs["aria-disabled"] = "true";
    }
    return attrs;
  });
  function onClick(e22) {
    if (e22 !== void 0) {
      stopAndPrevent$1(e22);
      refocusTarget(e22);
    }
    if (props4.disable !== true) {
      emit("update:modelValue", getNextValue(), e22);
    }
  }
  function getNextValue() {
    if (modelIsArray.value === true) {
      if (isTrue.value === true) {
        const val = props4.modelValue.slice();
        val.splice(index2.value, 1);
        return val;
      }
      return props4.modelValue.concat([props4.val]);
    }
    if (isTrue.value === true) {
      if (props4.toggleOrder !== "ft" || props4.toggleIndeterminate === false) {
        return props4.falseValue;
      }
    } else if (isFalse.value === true) {
      if (props4.toggleOrder === "ft" || props4.toggleIndeterminate === false) {
        return props4.trueValue;
      }
    } else {
      return props4.toggleOrder !== "ft" ? props4.trueValue : props4.falseValue;
    }
    return props4.indeterminateValue;
  }
  function onKeydown2(e22) {
    if (e22.keyCode === 13 || e22.keyCode === 32) {
      stopAndPrevent$1(e22);
    }
  }
  function onKeyup2(e22) {
    if (e22.keyCode === 13 || e22.keyCode === 32) {
      onClick(e22);
    }
  }
  const getInnerContent = getInner(isTrue, isIndeterminate);
  Object.assign(proxy, { toggle: onClick });
  return () => {
    const inner = getInnerContent();
    props4.disable !== true && injectFormInput(
      inner,
      "unshift",
      ` q-${type2}__native absolute q-ma-none q-pa-none`
    );
    const child = [
      h("div", {
        class: innerClass.value,
        style: sizeStyle.value,
        "aria-hidden": "true"
      }, inner)
    ];
    if (refocusTargetEl.value !== null) {
      child.push(refocusTargetEl.value);
    }
    const label = props4.label !== void 0 ? hMergeSlot$1(slots.default, [props4.label]) : hSlot$1(slots.default);
    label !== void 0 && child.push(
      h("div", {
        class: `q-${type2}__label q-anchor--skip`
      }, label)
    );
    return h("div", {
      ref: rootRef,
      class: classes.value,
      ...attributes.value,
      onClick,
      onKeydown: onKeydown2,
      onKeyup: onKeyup2
    }, child);
  };
}
var createBgNode$1 = () => h("div", {
  key: "svg",
  class: "q-checkbox__bg absolute"
}, [
  h("svg", {
    class: "q-checkbox__svg fit absolute-full",
    viewBox: "0 0 24 24"
  }, [
    h("path", {
      class: "q-checkbox__truthy",
      fill: "none",
      d: "M1.73,12.91 8.1,19.28 22.79,4.59"
    }),
    h("path", {
      class: "q-checkbox__indet",
      d: "M4,14H20V10H4"
    })
  ])
]);
var QCheckbox_default$1 = createComponent$1({
  name: "QCheckbox",
  props: useCheckboxProps$1,
  emits: useCheckboxEmits$1,
  setup(props4) {
    const bgNode = createBgNode$1();
    function getInner(isTrue, isIndeterminate) {
      const icon = computed(
        () => (isTrue.value === true ? props4.checkedIcon : isIndeterminate.value === true ? props4.indeterminateIcon : props4.uncheckedIcon) || null
      );
      return () => icon.value !== null ? [
        h("div", {
          key: "icon",
          class: "q-checkbox__icon-container absolute-full flex flex-center no-wrap"
        }, [
          h(QIcon_default$1, {
            class: "q-checkbox__icon",
            name: icon.value
          })
        ])
      ] : [bgNode];
    }
    return use_checkbox_default$1("checkbox", getInner);
  }
});
var defaultSizes2$1 = {
  xs: 8,
  sm: 10,
  md: 14,
  lg: 20,
  xl: 24
};
var QChip_default$1 = createComponent$1({
  name: "QChip",
  props: {
    ...useDarkProps$1,
    ...useSizeProps$1,
    dense: Boolean,
    icon: String,
    iconRight: String,
    iconRemove: String,
    iconSelected: String,
    label: [String, Number],
    color: String,
    textColor: String,
    modelValue: {
      type: Boolean,
      default: true
    },
    selected: {
      type: Boolean,
      default: null
    },
    square: Boolean,
    outline: Boolean,
    clickable: Boolean,
    removable: Boolean,
    removeAriaLabel: String,
    tabindex: [String, Number],
    disable: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    }
  },
  emits: ["update:modelValue", "update:selected", "remove", "click"],
  setup(props4, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const isDark = use_dark_default$1(props4, $q);
    const sizeStyle = use_size_default$1(props4, defaultSizes2$1);
    const hasLeftIcon = computed(() => props4.selected === true || props4.icon !== void 0);
    const leftIcon = computed(() => props4.selected === true ? props4.iconSelected || $q.iconSet.chip.selected : props4.icon);
    const removeIcon = computed(() => props4.iconRemove || $q.iconSet.chip.remove);
    const isClickable = computed(
      () => props4.disable === false && (props4.clickable === true || props4.selected !== null)
    );
    const classes = computed(() => {
      const text2 = props4.outline === true ? props4.color || props4.textColor : props4.textColor;
      return "q-chip row inline no-wrap items-center" + (props4.outline === false && props4.color !== void 0 ? ` bg-${props4.color}` : "") + (text2 ? ` text-${text2} q-chip--colored` : "") + (props4.disable === true ? " disabled" : "") + (props4.dense === true ? " q-chip--dense" : "") + (props4.outline === true ? " q-chip--outline" : "") + (props4.selected === true ? " q-chip--selected" : "") + (isClickable.value === true ? " q-chip--clickable cursor-pointer non-selectable q-hoverable" : "") + (props4.square === true ? " q-chip--square" : "") + (isDark.value === true ? " q-chip--dark q-dark" : "");
    });
    const attributes = computed(() => {
      const chip = props4.disable === true ? { tabindex: -1, "aria-disabled": "true" } : { tabindex: props4.tabindex || 0 };
      const remove2 = {
        ...chip,
        role: "button",
        "aria-hidden": "false",
        "aria-label": props4.removeAriaLabel || $q.lang.label.remove
      };
      return { chip, remove: remove2 };
    });
    function onKeyup2(e22) {
      e22.keyCode === 13 && onClick(e22);
    }
    function onClick(e22) {
      if (!props4.disable) {
        emit("update:selected", !props4.selected);
        emit("click", e22);
      }
    }
    function onRemove(e22) {
      if (e22.keyCode === void 0 || e22.keyCode === 13) {
        stopAndPrevent$1(e22);
        if (props4.disable === false) {
          emit("update:modelValue", false);
          emit("remove");
        }
      }
    }
    function getContent() {
      const child = [];
      isClickable.value === true && child.push(
        h("div", { class: "q-focus-helper" })
      );
      hasLeftIcon.value === true && child.push(
        h(QIcon_default$1, {
          class: "q-chip__icon q-chip__icon--left",
          name: leftIcon.value
        })
      );
      const label = props4.label !== void 0 ? [h("div", { class: "ellipsis" }, [props4.label])] : void 0;
      child.push(
        h("div", {
          class: "q-chip__content col row no-wrap items-center q-anchor--skip"
        }, hMergeSlotSafely$1(slots.default, label))
      );
      props4.iconRight && child.push(
        h(QIcon_default$1, {
          class: "q-chip__icon q-chip__icon--right",
          name: props4.iconRight
        })
      );
      props4.removable === true && child.push(
        h(QIcon_default$1, {
          class: "q-chip__icon q-chip__icon--remove cursor-pointer",
          name: removeIcon.value,
          ...attributes.value.remove,
          onClick: onRemove,
          onKeyup: onRemove
        })
      );
      return child;
    }
    return () => {
      if (props4.modelValue === false) return;
      const data = {
        class: classes.value,
        style: sizeStyle.value
      };
      isClickable.value === true && Object.assign(
        data,
        attributes.value.chip,
        { onClick, onKeyup: onKeyup2 }
      );
      return hDir$1(
        "div",
        data,
        getContent(),
        "ripple",
        props4.ripple !== false && props4.disable !== true,
        () => [[Ripple_default$1, props4.ripple]]
      );
    };
  }
});
var useCircularCommonProps$1 = {
  ...useSizeProps$1,
  min: {
    type: Number,
    default: 0
  },
  max: {
    type: Number,
    default: 100
  },
  color: String,
  centerColor: String,
  trackColor: String,
  fontSize: String,
  rounded: Boolean,
  // ratio
  thickness: {
    type: Number,
    default: 0.2,
    validator: (v) => v >= 0 && v <= 1
  },
  angle: {
    type: Number,
    default: 0
  },
  showValue: Boolean,
  reverse: Boolean,
  instantFeedback: Boolean
};
var radius$1 = 50;
var diameter$1 = 2 * radius$1;
var circumference$1 = diameter$1 * Math.PI;
var strokeDashArray$1 = Math.round(circumference$1 * 1e3) / 1e3;
var QCircularProgress_default$1 = createComponent$1({
  name: "QCircularProgress",
  props: {
    ...useCircularCommonProps$1,
    value: {
      type: Number,
      default: 0
    },
    animationSpeed: {
      type: [String, Number],
      default: 600
    },
    indeterminate: Boolean
  },
  setup(props4, { slots }) {
    const { proxy: { $q } } = getCurrentInstance();
    const sizeStyle = use_size_default$1(props4);
    const svgStyle = computed(() => {
      const angle2 = ($q.lang.rtl === true ? -1 : 1) * props4.angle;
      return {
        transform: props4.reverse !== ($q.lang.rtl === true) ? `scale3d(-1, 1, 1) rotate3d(0, 0, 1, ${-90 - angle2}deg)` : `rotate3d(0, 0, 1, ${angle2 - 90}deg)`
      };
    });
    const circleStyle = computed(() => props4.instantFeedback !== true && props4.indeterminate !== true ? { transition: `stroke-dashoffset ${props4.animationSpeed}ms ease 0s, stroke ${props4.animationSpeed}ms ease` } : "");
    const viewBox = computed(() => diameter$1 / (1 - props4.thickness / 2));
    const viewBoxAttr = computed(
      () => `${viewBox.value / 2} ${viewBox.value / 2} ${viewBox.value} ${viewBox.value}`
    );
    const normalized = computed(() => between$1(props4.value, props4.min, props4.max));
    const range2 = computed(() => props4.max - props4.min);
    const strokeWidth = computed(() => props4.thickness / 2 * viewBox.value);
    const strokeDashOffset = computed(() => {
      const dashRatio = (props4.max - normalized.value) / range2.value;
      const dashGap = props4.rounded === true && normalized.value < props4.max && dashRatio < 0.25 ? strokeWidth.value / 2 * (1 - dashRatio / 0.25) : 0;
      return circumference$1 * dashRatio + dashGap;
    });
    function getCircle({ thickness, offset: offset2, color: color2, cls, rounded }) {
      return h("circle", {
        class: "q-circular-progress__" + cls + (color2 !== void 0 ? ` text-${color2}` : ""),
        style: circleStyle.value,
        fill: "transparent",
        stroke: "currentColor",
        "stroke-width": thickness,
        "stroke-dasharray": strokeDashArray$1,
        "stroke-dashoffset": offset2,
        "stroke-linecap": rounded,
        cx: viewBox.value,
        cy: viewBox.value,
        r: radius$1
      });
    }
    return () => {
      const svgChild = [];
      props4.centerColor !== void 0 && props4.centerColor !== "transparent" && svgChild.push(
        h("circle", {
          class: `q-circular-progress__center text-${props4.centerColor}`,
          fill: "currentColor",
          r: radius$1 - strokeWidth.value / 2,
          cx: viewBox.value,
          cy: viewBox.value
        })
      );
      props4.trackColor !== void 0 && props4.trackColor !== "transparent" && svgChild.push(
        getCircle({
          cls: "track",
          thickness: strokeWidth.value,
          offset: 0,
          color: props4.trackColor
        })
      );
      svgChild.push(
        getCircle({
          cls: "circle",
          thickness: strokeWidth.value,
          offset: strokeDashOffset.value,
          color: props4.color,
          rounded: props4.rounded === true ? "round" : void 0
        })
      );
      const child = [
        h("svg", {
          class: "q-circular-progress__svg",
          style: svgStyle.value,
          viewBox: viewBoxAttr.value,
          "aria-hidden": "true"
        }, svgChild)
      ];
      props4.showValue === true && child.push(
        h("div", {
          class: "q-circular-progress__text absolute-full row flex-center content-center",
          style: { fontSize: props4.fontSize }
        }, slots.default !== void 0 ? slots.default() : [h("div", normalized.value)])
      );
      return h("div", {
        class: `q-circular-progress q-circular-progress--${props4.indeterminate === true ? "in" : ""}determinate`,
        style: sizeStyle.value,
        role: "progressbar",
        "aria-valuemin": props4.min,
        "aria-valuemax": props4.max,
        "aria-valuenow": props4.indeterminate === true ? void 0 : normalized.value
      }, hMergeSlotSafely$1(slots.internal, child));
    };
  }
});
function getChanges$1(evt, ctx, isFinal) {
  const pos = position$1(evt);
  let dir, distX = pos.left - ctx.event.x, distY = pos.top - ctx.event.y, absX = Math.abs(distX), absY = Math.abs(distY);
  const direction = ctx.direction;
  if (direction.horizontal === true && direction.vertical !== true) {
    dir = distX < 0 ? "left" : "right";
  } else if (direction.horizontal !== true && direction.vertical === true) {
    dir = distY < 0 ? "up" : "down";
  } else if (direction.up === true && distY < 0) {
    dir = "up";
    if (absX > absY) {
      if (direction.left === true && distX < 0) {
        dir = "left";
      } else if (direction.right === true && distX > 0) {
        dir = "right";
      }
    }
  } else if (direction.down === true && distY > 0) {
    dir = "down";
    if (absX > absY) {
      if (direction.left === true && distX < 0) {
        dir = "left";
      } else if (direction.right === true && distX > 0) {
        dir = "right";
      }
    }
  } else if (direction.left === true && distX < 0) {
    dir = "left";
    if (absX < absY) {
      if (direction.up === true && distY < 0) {
        dir = "up";
      } else if (direction.down === true && distY > 0) {
        dir = "down";
      }
    }
  } else if (direction.right === true && distX > 0) {
    dir = "right";
    if (absX < absY) {
      if (direction.up === true && distY < 0) {
        dir = "up";
      } else if (direction.down === true && distY > 0) {
        dir = "down";
      }
    }
  }
  let synthetic = false;
  if (dir === void 0 && isFinal === false) {
    if (ctx.event.isFirst === true || ctx.event.lastDir === void 0) {
      return {};
    }
    dir = ctx.event.lastDir;
    synthetic = true;
    if (dir === "left" || dir === "right") {
      pos.left -= distX;
      absX = 0;
      distX = 0;
    } else {
      pos.top -= distY;
      absY = 0;
      distY = 0;
    }
  }
  return {
    synthetic,
    payload: {
      evt,
      touch: ctx.event.mouse !== true,
      mouse: ctx.event.mouse === true,
      position: pos,
      direction: dir,
      isFirst: ctx.event.isFirst,
      isFinal: isFinal === true,
      duration: Date.now() - ctx.event.time,
      distance: {
        x: absX,
        y: absY
      },
      offset: {
        x: distX,
        y: distY
      },
      delta: {
        x: pos.left - ctx.event.lastX,
        y: pos.top - ctx.event.lastY
      }
    }
  };
}
var uid$1 = 0;
var TouchPan_default$1 = createDirective$1(
  {
    name: "touch-pan",
    beforeMount(el, { value: value2, modifiers }) {
      if (modifiers.mouse !== true && client$1.has.touch !== true) {
        return;
      }
      function handleEvent(evt, mouseEvent) {
        if (modifiers.mouse === true && mouseEvent === true) {
          stopAndPrevent$1(evt);
        } else {
          modifiers.stop === true && stop$1(evt);
          modifiers.prevent === true && prevent$1(evt);
        }
      }
      const ctx = {
        uid: "qvtp_" + uid$1++,
        handler: value2,
        modifiers,
        direction: getModifierDirections$1(modifiers),
        noop: noop$1,
        mouseStart(evt) {
          if (shouldStart$1(evt, ctx) && leftClick$1(evt)) {
            addEvt$1(ctx, "temp", [
              [document, "mousemove", "move", "notPassiveCapture"],
              [document, "mouseup", "end", "passiveCapture"]
            ]);
            ctx.start(evt, true);
          }
        },
        touchStart(evt) {
          if (shouldStart$1(evt, ctx)) {
            const target2 = evt.target;
            addEvt$1(ctx, "temp", [
              [target2, "touchmove", "move", "notPassiveCapture"],
              [target2, "touchcancel", "end", "passiveCapture"],
              [target2, "touchend", "end", "passiveCapture"]
            ]);
            ctx.start(evt);
          }
        },
        start(evt, mouseEvent) {
          client$1.is.firefox === true && preventDraggable$1(el, true);
          ctx.lastEvt = evt;
          if (mouseEvent === true || modifiers.stop === true) {
            if (ctx.direction.all !== true && (mouseEvent !== true || ctx.modifiers.mouseAllDir !== true && ctx.modifiers.mousealldir !== true)) {
              const clone2 = evt.type.indexOf("mouse") !== -1 ? new MouseEvent(evt.type, evt) : new TouchEvent(evt.type, evt);
              evt.defaultPrevented === true && prevent$1(clone2);
              evt.cancelBubble === true && stop$1(clone2);
              Object.assign(clone2, {
                qKeyEvent: evt.qKeyEvent,
                qClickOutside: evt.qClickOutside,
                qAnchorHandled: evt.qAnchorHandled,
                qClonedBy: evt.qClonedBy === void 0 ? [ctx.uid] : evt.qClonedBy.concat(ctx.uid)
              });
              ctx.initialEvent = {
                target: evt.target,
                event: clone2
              };
            }
            stop$1(evt);
          }
          const { left, top } = position$1(evt);
          ctx.event = {
            x: left,
            y: top,
            time: Date.now(),
            mouse: mouseEvent === true,
            detected: false,
            isFirst: true,
            isFinal: false,
            lastX: left,
            lastY: top
          };
        },
        move(evt) {
          if (ctx.event === void 0) {
            return;
          }
          const pos = position$1(evt), distX = pos.left - ctx.event.x, distY = pos.top - ctx.event.y;
          if (distX === 0 && distY === 0) {
            return;
          }
          ctx.lastEvt = evt;
          const isMouseEvt = ctx.event.mouse === true;
          const start = () => {
            handleEvent(evt, isMouseEvt);
            let cursor;
            if (modifiers.preserveCursor !== true && modifiers.preservecursor !== true) {
              cursor = document.documentElement.style.cursor || "";
              document.documentElement.style.cursor = "grabbing";
            }
            isMouseEvt === true && document.body.classList.add("no-pointer-events--children");
            document.body.classList.add("non-selectable");
            clearSelection$1();
            ctx.styleCleanup = (withDelayedFn) => {
              ctx.styleCleanup = void 0;
              if (cursor !== void 0) {
                document.documentElement.style.cursor = cursor;
              }
              document.body.classList.remove("non-selectable");
              if (isMouseEvt === true) {
                const remove2 = () => {
                  document.body.classList.remove("no-pointer-events--children");
                };
                if (withDelayedFn !== void 0) {
                  setTimeout(() => {
                    remove2();
                    withDelayedFn();
                  }, 50);
                } else {
                  remove2();
                }
              } else if (withDelayedFn !== void 0) {
                withDelayedFn();
              }
            };
          };
          if (ctx.event.detected === true) {
            ctx.event.isFirst !== true && handleEvent(evt, ctx.event.mouse);
            const { payload, synthetic } = getChanges$1(evt, ctx, false);
            if (payload !== void 0) {
              if (ctx.handler(payload) === false) {
                ctx.end(evt);
              } else {
                if (ctx.styleCleanup === void 0 && ctx.event.isFirst === true) {
                  start();
                }
                ctx.event.lastX = payload.position.left;
                ctx.event.lastY = payload.position.top;
                ctx.event.lastDir = synthetic === true ? void 0 : payload.direction;
                ctx.event.isFirst = false;
              }
            }
            return;
          }
          if (ctx.direction.all === true || isMouseEvt === true && (ctx.modifiers.mouseAllDir === true || ctx.modifiers.mousealldir === true)) {
            start();
            ctx.event.detected = true;
            ctx.move(evt);
            return;
          }
          const absX = Math.abs(distX), absY = Math.abs(distY);
          if (absX !== absY) {
            if (ctx.direction.horizontal === true && absX > absY || ctx.direction.vertical === true && absX < absY || ctx.direction.up === true && absX < absY && distY < 0 || ctx.direction.down === true && absX < absY && distY > 0 || ctx.direction.left === true && absX > absY && distX < 0 || ctx.direction.right === true && absX > absY && distX > 0) {
              ctx.event.detected = true;
              ctx.move(evt);
            } else {
              ctx.end(evt, true);
            }
          }
        },
        end(evt, abort) {
          if (ctx.event === void 0) {
            return;
          }
          cleanEvt$1(ctx, "temp");
          client$1.is.firefox === true && preventDraggable$1(el, false);
          if (abort === true) {
            ctx.styleCleanup !== void 0 && ctx.styleCleanup();
            if (ctx.event.detected !== true && ctx.initialEvent !== void 0) {
              ctx.initialEvent.target.dispatchEvent(ctx.initialEvent.event);
            }
          } else if (ctx.event.detected === true) {
            ctx.event.isFirst === true && ctx.handler(getChanges$1(evt === void 0 ? ctx.lastEvt : evt, ctx).payload);
            const { payload } = getChanges$1(evt === void 0 ? ctx.lastEvt : evt, ctx, true);
            const fn = () => {
              ctx.handler(payload);
            };
            if (ctx.styleCleanup !== void 0) {
              ctx.styleCleanup(fn);
            } else {
              fn();
            }
          }
          ctx.event = void 0;
          ctx.initialEvent = void 0;
          ctx.lastEvt = void 0;
        }
      };
      el.__qtouchpan = ctx;
      if (modifiers.mouse === true) {
        const capture = modifiers.mouseCapture === true || modifiers.mousecapture === true ? "Capture" : "";
        addEvt$1(ctx, "main", [
          [el, "mousedown", "mouseStart", `passive${capture}`]
        ]);
      }
      client$1.has.touch === true && addEvt$1(ctx, "main", [
        [el, "touchstart", "touchStart", `passive${modifiers.capture === true ? "Capture" : ""}`],
        [el, "touchmove", "noop", "notPassiveCapture"]
        // cannot be passive (ex: iOS scroll)
      ]);
    },
    updated(el, bindings) {
      const ctx = el.__qtouchpan;
      if (ctx !== void 0) {
        if (bindings.oldValue !== bindings.value) {
          typeof value !== "function" && ctx.end();
          ctx.handler = bindings.value;
        }
        ctx.direction = getModifierDirections$1(bindings.modifiers);
      }
    },
    beforeUnmount(el) {
      const ctx = el.__qtouchpan;
      if (ctx !== void 0) {
        ctx.event !== void 0 && ctx.end();
        cleanEvt$1(ctx, "main");
        cleanEvt$1(ctx, "temp");
        client$1.is.firefox === true && preventDraggable$1(el, false);
        ctx.styleCleanup !== void 0 && ctx.styleCleanup();
        delete el.__qtouchpan;
      }
    }
  }
);
var markerPrefixClass$1 = "q-slider__marker-labels";
var defaultMarkerConvertFn$1 = (v) => ({ value: v });
var defaultMarkerLabelRenderFn$1 = ({ marker }) => h("div", {
  key: marker.value,
  style: marker.style,
  class: marker.classes
}, marker.label);
var keyCodes$1 = [34, 37, 40, 33, 39, 38];
var useSliderProps$1 = {
  ...useDarkProps$1,
  ...useFormProps$1,
  min: {
    type: Number,
    default: 0
  },
  max: {
    type: Number,
    default: 100
  },
  innerMin: Number,
  innerMax: Number,
  step: {
    type: Number,
    default: 1,
    validator: (v) => v >= 0
  },
  snap: Boolean,
  vertical: Boolean,
  reverse: Boolean,
  color: String,
  markerLabelsClass: String,
  label: Boolean,
  labelColor: String,
  labelTextColor: String,
  labelAlways: Boolean,
  switchLabelSide: Boolean,
  markers: [Boolean, Number],
  markerLabels: [Boolean, Array, Object, Function],
  switchMarkerLabelsSide: Boolean,
  trackImg: String,
  trackColor: String,
  innerTrackImg: String,
  innerTrackColor: String,
  selectionColor: String,
  selectionImg: String,
  thumbSize: {
    type: String,
    default: "20px"
  },
  trackSize: {
    type: String,
    default: "4px"
  },
  disable: Boolean,
  readonly: Boolean,
  dense: Boolean,
  tabindex: [String, Number],
  thumbColor: String,
  thumbPath: {
    type: String,
    default: "M 4, 10 a 6,6 0 1,0 12,0 a 6,6 0 1,0 -12,0"
  }
};
var useSliderEmits$1 = ["pan", "update:modelValue", "change"];
function use_slider_default$1({ updateValue: updateValue2, updatePosition, getDragging, formAttrs }) {
  const { props: props4, emit, slots, proxy: { $q } } = getCurrentInstance();
  const isDark = use_dark_default$1(props4, $q);
  const injectFormInput = useFormInject$1(formAttrs);
  const active = ref$1(false);
  const preventFocus = ref$1(false);
  const focus = ref$1(false);
  const dragging = ref$1(false);
  const axis = computed(() => props4.vertical === true ? "--v" : "--h");
  const labelSide = computed(() => "-" + (props4.switchLabelSide === true ? "switched" : "standard"));
  const isReversed = computed(() => props4.vertical === true ? props4.reverse === true : props4.reverse !== ($q.lang.rtl === true));
  const innerMin = computed(() => isNaN(props4.innerMin) === true || props4.innerMin < props4.min ? props4.min : props4.innerMin);
  const innerMax = computed(() => isNaN(props4.innerMax) === true || props4.innerMax > props4.max ? props4.max : props4.innerMax);
  const editable = computed(() => props4.disable !== true && props4.readonly !== true && innerMin.value < innerMax.value);
  const roundValueFn = computed(() => {
    if (props4.step === 0) {
      return (v) => v;
    }
    const decimals = (String(props4.step).trim().split(".")[1] || "").length;
    return (v) => parseFloat(v.toFixed(decimals));
  });
  const keyStep = computed(() => props4.step === 0 ? 1 : props4.step);
  const tabindex = computed(() => editable.value === true ? props4.tabindex || 0 : -1);
  const trackLen = computed(() => props4.max - props4.min);
  const innerBarLen = computed(() => innerMax.value - innerMin.value);
  const innerMinRatio = computed(() => convertModelToRatio(innerMin.value));
  const innerMaxRatio = computed(() => convertModelToRatio(innerMax.value));
  const positionProp = computed(() => props4.vertical === true ? isReversed.value === true ? "bottom" : "top" : isReversed.value === true ? "right" : "left");
  const sizeProp = computed(() => props4.vertical === true ? "height" : "width");
  const thicknessProp = computed(() => props4.vertical === true ? "width" : "height");
  const orientation = computed(() => props4.vertical === true ? "vertical" : "horizontal");
  const attributes = computed(() => {
    const acc = {
      role: "slider",
      "aria-valuemin": innerMin.value,
      "aria-valuemax": innerMax.value,
      "aria-orientation": orientation.value,
      "data-step": props4.step
    };
    if (props4.disable === true) {
      acc["aria-disabled"] = "true";
    } else if (props4.readonly === true) {
      acc["aria-readonly"] = "true";
    }
    return acc;
  });
  const classes = computed(
    () => `q-slider q-slider${axis.value} q-slider--${active.value === true ? "" : "in"}active inline no-wrap ` + (props4.vertical === true ? "row" : "column") + (props4.disable === true ? " disabled" : " q-slider--enabled" + (editable.value === true ? " q-slider--editable" : "")) + (focus.value === "both" ? " q-slider--focus" : "") + (props4.label || props4.labelAlways === true ? " q-slider--label" : "") + (props4.labelAlways === true ? " q-slider--label-always" : "") + (isDark.value === true ? " q-slider--dark" : "") + (props4.dense === true ? " q-slider--dense q-slider--dense" + axis.value : "")
  );
  function getPositionClass(name2) {
    const cls = "q-slider__" + name2;
    return `${cls} ${cls}${axis.value} ${cls}${axis.value}${labelSide.value}`;
  }
  function getAxisClass(name2) {
    const cls = "q-slider__" + name2;
    return `${cls} ${cls}${axis.value}`;
  }
  const selectionBarClass = computed(() => {
    const color2 = props4.selectionColor || props4.color;
    return "q-slider__selection absolute" + (color2 !== void 0 ? ` text-${color2}` : "");
  });
  const markerClass = computed(() => getAxisClass("markers") + " absolute overflow-hidden");
  const trackContainerClass = computed(() => getAxisClass("track-container"));
  const pinClass = computed(() => getPositionClass("pin"));
  const labelClass = computed(() => getPositionClass("label"));
  const textContainerClass = computed(() => getPositionClass("text-container"));
  const markerLabelsContainerClass = computed(
    () => getPositionClass("marker-labels-container") + (props4.markerLabelsClass !== void 0 ? ` ${props4.markerLabelsClass}` : "")
  );
  const trackClass = computed(
    () => "q-slider__track relative-position no-outline" + (props4.trackColor !== void 0 ? ` bg-${props4.trackColor}` : "")
  );
  const trackStyle = computed(() => {
    const acc = { [thicknessProp.value]: props4.trackSize };
    if (props4.trackImg !== void 0) {
      acc.backgroundImage = `url(${props4.trackImg}) !important`;
    }
    return acc;
  });
  const innerBarClass = computed(
    () => "q-slider__inner absolute" + (props4.innerTrackColor !== void 0 ? ` bg-${props4.innerTrackColor}` : "")
  );
  const innerBarStyle = computed(() => {
    const innerDiff = innerMaxRatio.value - innerMinRatio.value;
    const acc = {
      [positionProp.value]: `${100 * innerMinRatio.value}%`,
      [sizeProp.value]: innerDiff === 0 ? "2px" : `${100 * innerDiff}%`
    };
    if (props4.innerTrackImg !== void 0) {
      acc.backgroundImage = `url(${props4.innerTrackImg}) !important`;
    }
    return acc;
  });
  function convertRatioToModel(ratio) {
    const { min: min2, max: max2, step } = props4;
    let model = min2 + ratio * (max2 - min2);
    if (step > 0) {
      const modulo = (model - innerMin.value) % step;
      model += (Math.abs(modulo) >= step / 2 ? (modulo < 0 ? -1 : 1) * step : 0) - modulo;
    }
    model = roundValueFn.value(model);
    return between$1(model, innerMin.value, innerMax.value);
  }
  function convertModelToRatio(model) {
    return trackLen.value === 0 ? 0 : (model - props4.min) / trackLen.value;
  }
  function getDraggingRatio(evt, dragging2) {
    const pos = position$1(evt), val = props4.vertical === true ? between$1((pos.top - dragging2.top) / dragging2.height, 0, 1) : between$1((pos.left - dragging2.left) / dragging2.width, 0, 1);
    return between$1(
      isReversed.value === true ? 1 - val : val,
      innerMinRatio.value,
      innerMaxRatio.value
    );
  }
  const markerStep = computed(
    () => isNumber$1(props4.markers) === true ? props4.markers : keyStep.value
  );
  const markerTicks = computed(() => {
    const acc = [];
    const step = markerStep.value;
    const max2 = props4.max;
    let value2 = props4.min;
    do {
      acc.push(value2);
      value2 += step;
    } while (value2 < max2);
    acc.push(max2);
    return acc;
  });
  const markerLabelClass = computed(() => {
    const prefix = ` ${markerPrefixClass$1}${axis.value}-`;
    return markerPrefixClass$1 + `${prefix}${props4.switchMarkerLabelsSide === true ? "switched" : "standard"}${prefix}${isReversed.value === true ? "rtl" : "ltr"}`;
  });
  const markerLabelsList = computed(() => {
    if (props4.markerLabels === false) {
      return null;
    }
    return getMarkerList(props4.markerLabels).map((entry, index2) => ({
      index: index2,
      value: entry.value,
      label: entry.label || entry.value,
      classes: markerLabelClass.value + (entry.classes !== void 0 ? " " + entry.classes : ""),
      style: {
        ...getMarkerLabelStyle(entry.value),
        ...entry.style || {}
      }
    }));
  });
  const markerScope = computed(() => ({
    markerList: markerLabelsList.value,
    markerMap: markerLabelsMap.value,
    classes: markerLabelClass.value,
    // TODO ts definition
    getStyle: getMarkerLabelStyle
  }));
  const markerStyle = computed(() => {
    const size2 = innerBarLen.value === 0 ? "2px" : 100 * markerStep.value / innerBarLen.value;
    return {
      ...innerBarStyle.value,
      backgroundSize: props4.vertical === true ? `2px ${size2}%` : `${size2}% 2px`
    };
  });
  function getMarkerList(def) {
    if (def === false) {
      return null;
    }
    if (def === true) {
      return markerTicks.value.map(defaultMarkerConvertFn$1);
    }
    if (typeof def === "function") {
      return markerTicks.value.map((value2) => {
        const item = def(value2);
        return isObject$1(item) === true ? { ...item, value: value2 } : { value: value2, label: item };
      });
    }
    const filterFn = ({ value: value2 }) => value2 >= props4.min && value2 <= props4.max;
    if (Array.isArray(def) === true) {
      return def.map((item) => isObject$1(item) === true ? item : { value: item }).filter(filterFn);
    }
    return Object.keys(def).map((key) => {
      const item = def[key];
      const value2 = Number(key);
      return isObject$1(item) === true ? { ...item, value: value2 } : { value: value2, label: item };
    }).filter(filterFn);
  }
  function getMarkerLabelStyle(val) {
    return { [positionProp.value]: `${100 * (val - props4.min) / trackLen.value}%` };
  }
  const markerLabelsMap = computed(() => {
    if (props4.markerLabels === false) {
      return null;
    }
    const acc = {};
    markerLabelsList.value.forEach((entry) => {
      acc[entry.value] = entry;
    });
    return acc;
  });
  function getMarkerLabelsContent() {
    if (slots["marker-label-group"] !== void 0) {
      return slots["marker-label-group"](markerScope.value);
    }
    const fn = slots["marker-label"] || defaultMarkerLabelRenderFn$1;
    return markerLabelsList.value.map((marker) => fn({
      marker,
      ...markerScope.value
    }));
  }
  const panDirective = computed(() => {
    return [[
      TouchPan_default$1,
      onPan,
      void 0,
      {
        [orientation.value]: true,
        prevent: true,
        stop: true,
        mouse: true,
        mouseAllDir: true
      }
    ]];
  });
  function onPan(event) {
    if (event.isFinal === true) {
      if (dragging.value !== void 0) {
        updatePosition(event.evt);
        event.touch === true && updateValue2(true);
        dragging.value = void 0;
        emit("pan", "end");
      }
      active.value = false;
      focus.value = false;
    } else if (event.isFirst === true) {
      dragging.value = getDragging(event.evt);
      updatePosition(event.evt);
      updateValue2();
      active.value = true;
      emit("pan", "start");
    } else {
      updatePosition(event.evt);
      updateValue2();
    }
  }
  function onBlur2() {
    focus.value = false;
  }
  function onActivate(evt) {
    updatePosition(evt, getDragging(evt));
    updateValue2();
    preventFocus.value = true;
    active.value = true;
    document.addEventListener("mouseup", onDeactivate, true);
  }
  function onDeactivate() {
    preventFocus.value = false;
    active.value = false;
    updateValue2(true);
    onBlur2();
    document.removeEventListener("mouseup", onDeactivate, true);
  }
  function onMobileClick(evt) {
    updatePosition(evt, getDragging(evt));
    updateValue2(true);
  }
  function onKeyup2(evt) {
    if (keyCodes$1.includes(evt.keyCode)) {
      updateValue2(true);
    }
  }
  function getTextContainerStyle(ratio) {
    if (props4.vertical === true) {
      return null;
    }
    const p2 = $q.lang.rtl !== props4.reverse ? 1 - ratio : ratio;
    return {
      transform: `translateX(calc(${2 * p2 - 1} * ${props4.thumbSize} / 2 + ${50 - 100 * p2}%))`
    };
  }
  function getThumbRenderFn(thumb) {
    const focusClass = computed(() => preventFocus.value === false && (focus.value === thumb.focusValue || focus.value === "both") ? " q-slider--focus" : "");
    const classes2 = computed(
      () => `q-slider__thumb q-slider__thumb${axis.value} q-slider__thumb${axis.value}-${isReversed.value === true ? "rtl" : "ltr"} absolute non-selectable` + focusClass.value + (thumb.thumbColor.value !== void 0 ? ` text-${thumb.thumbColor.value}` : "")
    );
    const style2 = computed(() => ({
      width: props4.thumbSize,
      height: props4.thumbSize,
      [positionProp.value]: `${100 * thumb.ratio.value}%`,
      zIndex: focus.value === thumb.focusValue ? 2 : void 0
    }));
    const pinColor = computed(() => thumb.labelColor.value !== void 0 ? ` text-${thumb.labelColor.value}` : "");
    const textContainerStyle = computed(() => getTextContainerStyle(thumb.ratio.value));
    const textClass = computed(() => "q-slider__text" + (thumb.labelTextColor.value !== void 0 ? ` text-${thumb.labelTextColor.value}` : ""));
    return () => {
      const thumbContent = [
        h("svg", {
          class: "q-slider__thumb-shape absolute-full",
          viewBox: "0 0 20 20",
          "aria-hidden": "true"
        }, [
          h("path", { d: props4.thumbPath })
        ]),
        h("div", { class: "q-slider__focus-ring fit" })
      ];
      if (props4.label === true || props4.labelAlways === true) {
        thumbContent.push(
          h("div", {
            class: pinClass.value + " absolute fit no-pointer-events" + pinColor.value
          }, [
            h("div", {
              class: labelClass.value,
              style: { minWidth: props4.thumbSize }
            }, [
              h("div", {
                class: textContainerClass.value,
                style: textContainerStyle.value
              }, [
                h("span", { class: textClass.value }, thumb.label.value)
              ])
            ])
          ])
        );
        if (props4.name !== void 0 && props4.disable !== true) {
          injectFormInput(thumbContent, "push");
        }
      }
      return h("div", {
        class: classes2.value,
        style: style2.value,
        ...thumb.getNodeData()
      }, thumbContent);
    };
  }
  function getContent(selectionBarStyle, trackContainerTabindex, trackContainerEvents, injectThumb) {
    const trackContent = [];
    props4.innerTrackColor !== "transparent" && trackContent.push(
      h("div", {
        key: "inner",
        class: innerBarClass.value,
        style: innerBarStyle.value
      })
    );
    props4.selectionColor !== "transparent" && trackContent.push(
      h("div", {
        key: "selection",
        class: selectionBarClass.value,
        style: selectionBarStyle.value
      })
    );
    props4.markers !== false && trackContent.push(
      h("div", {
        key: "marker",
        class: markerClass.value,
        style: markerStyle.value
      })
    );
    injectThumb(trackContent);
    const content = [
      hDir$1(
        "div",
        {
          key: "trackC",
          class: trackContainerClass.value,
          tabindex: trackContainerTabindex.value,
          ...trackContainerEvents.value
        },
        [
          h("div", {
            class: trackClass.value,
            style: trackStyle.value
          }, trackContent)
        ],
        "slide",
        editable.value,
        () => panDirective.value
      )
    ];
    if (props4.markerLabels !== false) {
      const action = props4.switchMarkerLabelsSide === true ? "unshift" : "push";
      content[action](
        h("div", {
          key: "markerL",
          class: markerLabelsContainerClass.value
        }, getMarkerLabelsContent())
      );
    }
    return content;
  }
  onBeforeUnmount(() => {
    document.removeEventListener("mouseup", onDeactivate, true);
  });
  return {
    state: {
      active,
      focus,
      preventFocus,
      dragging,
      editable,
      classes,
      tabindex,
      attributes,
      roundValueFn,
      keyStep,
      trackLen,
      innerMin,
      innerMinRatio,
      innerMax,
      innerMaxRatio,
      positionProp,
      sizeProp,
      isReversed
    },
    methods: {
      onActivate,
      onMobileClick,
      onBlur: onBlur2,
      onKeyup: onKeyup2,
      getContent,
      getThumbRenderFn,
      convertRatioToModel,
      convertModelToRatio,
      getDraggingRatio
    }
  };
}
var getNodeData$1 = () => ({});
var QSlider_default$1 = createComponent$1({
  name: "QSlider",
  props: {
    ...useSliderProps$1,
    modelValue: {
      required: true,
      default: null,
      validator: (v) => typeof v === "number" || v === null
    },
    labelValue: [String, Number]
  },
  emits: useSliderEmits$1,
  setup(props4, { emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const { state: state2, methods } = use_slider_default$1({
      updateValue: updateValue2,
      updatePosition,
      getDragging,
      formAttrs: useFormAttrs$1(props4)
    });
    const rootRef = ref$1(null);
    const curRatio = ref$1(0);
    const model = ref$1(0);
    function normalizeModel() {
      model.value = props4.modelValue === null ? state2.innerMin.value : between$1(props4.modelValue, state2.innerMin.value, state2.innerMax.value);
    }
    watch(
      () => `${props4.modelValue}|${state2.innerMin.value}|${state2.innerMax.value}`,
      normalizeModel
    );
    normalizeModel();
    const modelRatio = computed(() => methods.convertModelToRatio(model.value));
    const ratio = computed(() => state2.active.value === true ? curRatio.value : modelRatio.value);
    const selectionBarStyle = computed(() => {
      const acc = {
        [state2.positionProp.value]: `${100 * state2.innerMinRatio.value}%`,
        [state2.sizeProp.value]: `${100 * (ratio.value - state2.innerMinRatio.value)}%`
      };
      if (props4.selectionImg !== void 0) {
        acc.backgroundImage = `url(${props4.selectionImg}) !important`;
      }
      return acc;
    });
    const getThumb = methods.getThumbRenderFn({
      focusValue: true,
      getNodeData: getNodeData$1,
      ratio,
      label: computed(() => props4.labelValue !== void 0 ? props4.labelValue : model.value),
      thumbColor: computed(() => props4.thumbColor || props4.color),
      labelColor: computed(() => props4.labelColor),
      labelTextColor: computed(() => props4.labelTextColor)
    });
    const trackContainerEvents = computed(() => {
      if (state2.editable.value !== true) {
        return {};
      }
      return $q.platform.is.mobile === true ? { onClick: methods.onMobileClick } : {
        onMousedown: methods.onActivate,
        onFocus,
        onBlur: methods.onBlur,
        onKeydown: onKeydown2,
        onKeyup: methods.onKeyup
      };
    });
    function updateValue2(change) {
      if (model.value !== props4.modelValue) {
        emit("update:modelValue", model.value);
      }
      change === true && emit("change", model.value);
    }
    function getDragging() {
      return rootRef.value.getBoundingClientRect();
    }
    function updatePosition(event, dragging = state2.dragging.value) {
      const ratio2 = methods.getDraggingRatio(event, dragging);
      model.value = methods.convertRatioToModel(ratio2);
      curRatio.value = props4.snap !== true || props4.step === 0 ? ratio2 : methods.convertModelToRatio(model.value);
    }
    function onFocus() {
      state2.focus.value = true;
    }
    function onKeydown2(evt) {
      if (!keyCodes$1.includes(evt.keyCode)) {
        return;
      }
      stopAndPrevent$1(evt);
      const stepVal = ([34, 33].includes(evt.keyCode) ? 10 : 1) * state2.keyStep.value, offset2 = ([34, 37, 40].includes(evt.keyCode) ? -1 : 1) * (state2.isReversed.value === true ? -1 : 1) * (props4.vertical === true ? -1 : 1) * stepVal;
      model.value = between$1(
        state2.roundValueFn.value(model.value + offset2),
        state2.innerMin.value,
        state2.innerMax.value
      );
      updateValue2();
    }
    return () => {
      const content = methods.getContent(
        selectionBarStyle,
        state2.tabindex,
        trackContainerEvents,
        (node) => {
          node.push(getThumb());
        }
      );
      return h("div", {
        ref: rootRef,
        class: state2.classes.value + (props4.modelValue === null ? " q-slider--no-value" : ""),
        ...state2.attributes.value,
        "aria-valuenow": props4.modelValue
      }, content);
    };
  }
});
function use_hydration_default$1() {
  const isHydrated = ref$1(!isRuntimeSsrPreHydration$1.value);
  if (isHydrated.value === false) {
    onMounted(() => {
      isHydrated.value = true;
    });
  }
  return { isHydrated };
}
var hasObserver$1 = typeof ResizeObserver !== "undefined";
var resizeProps$1 = hasObserver$1 === true ? {} : {
  style: "display:block;position:absolute;top:0;left:0;right:0;bottom:0;height:100%;width:100%;overflow:hidden;pointer-events:none;z-index:-1;",
  url: "about:blank"
};
var QResizeObserver_default$1 = createComponent$1({
  name: "QResizeObserver",
  props: {
    debounce: {
      type: [String, Number],
      default: 100
    }
  },
  emits: ["resize"],
  setup(props4, { emit }) {
    let timer2 = null, targetEl, size2 = { width: -1, height: -1 };
    function trigger3(immediately) {
      if (immediately === true || props4.debounce === 0 || props4.debounce === "0") {
        emitEvent();
      } else if (timer2 === null) {
        timer2 = setTimeout(emitEvent, props4.debounce);
      }
    }
    function emitEvent() {
      if (timer2 !== null) {
        clearTimeout(timer2);
        timer2 = null;
      }
      if (targetEl) {
        const { offsetWidth: width3, offsetHeight: height2 } = targetEl;
        if (width3 !== size2.width || height2 !== size2.height) {
          size2 = { width: width3, height: height2 };
          emit("resize", size2);
        }
      }
    }
    const { proxy } = getCurrentInstance();
    proxy.trigger = trigger3;
    if (hasObserver$1 === true) {
      let observer;
      const init = (stop2) => {
        targetEl = proxy.$el.parentNode;
        if (targetEl) {
          observer = new ResizeObserver(trigger3);
          observer.observe(targetEl);
          emitEvent();
        } else if (stop2 !== true) {
          nextTick(() => {
            init(true);
          });
        }
      };
      onMounted(() => {
        init();
      });
      onBeforeUnmount(() => {
        timer2 !== null && clearTimeout(timer2);
        if (observer !== void 0) {
          if (observer.disconnect !== void 0) {
            observer.disconnect();
          } else if (targetEl) {
            observer.unobserve(targetEl);
          }
        }
      });
      return noop$1;
    } else {
      let cleanup = function() {
        if (timer2 !== null) {
          clearTimeout(timer2);
          timer2 = null;
        }
        if (curDocView !== void 0) {
          if (curDocView.removeEventListener !== void 0) {
            curDocView.removeEventListener("resize", trigger3, listenOpts$1.passive);
          }
          curDocView = void 0;
        }
      }, onObjLoad = function() {
        cleanup();
        if (targetEl && targetEl.contentDocument) {
          curDocView = targetEl.contentDocument.defaultView;
          curDocView.addEventListener("resize", trigger3, listenOpts$1.passive);
          emitEvent();
        }
      };
      const { isHydrated } = use_hydration_default$1();
      let curDocView;
      onMounted(() => {
        nextTick(() => {
          targetEl = proxy.$el;
          targetEl && onObjLoad();
        });
      });
      onBeforeUnmount(cleanup);
      return () => {
        if (isHydrated.value === true) {
          return h("object", {
            class: "q--avoid-card-border",
            style: resizeProps$1.style,
            tabindex: -1,
            // fix for Firefox
            type: "text/html",
            data: resizeProps$1.url,
            "aria-hidden": "true",
            onLoad: onObjLoad
          });
        }
      };
    }
  }
});
var rtlHasScrollBug$1 = false;
if (!__QUASAR_SSR__) {
  const scroller = document.createElement("div");
  scroller.setAttribute("dir", "rtl");
  Object.assign(scroller.style, {
    width: "1px",
    height: "1px",
    overflow: "auto"
  });
  const spacer = document.createElement("div");
  Object.assign(spacer.style, {
    width: "1000px",
    height: "1px"
  });
  document.body.appendChild(scroller);
  scroller.appendChild(spacer);
  scroller.scrollLeft = -1e3;
  rtlHasScrollBug$1 = scroller.scrollLeft >= 0;
  scroller.remove();
}
function getIndicatorClass$1(color2, top, vertical) {
  const pos = vertical === true ? ["left", "right"] : ["top", "bottom"];
  return `absolute-${top === true ? pos[0] : pos[1]}${color2 ? ` text-${color2}` : ""}`;
}
var alignValues3$1 = ["left", "center", "right", "justify"];
var QTabs_default$1 = createComponent$1({
  name: "QTabs",
  props: {
    modelValue: [Number, String],
    align: {
      type: String,
      default: "center",
      validator: (v) => alignValues3$1.includes(v)
    },
    breakpoint: {
      type: [String, Number],
      default: 600
    },
    vertical: Boolean,
    shrink: Boolean,
    stretch: Boolean,
    activeClass: String,
    activeColor: String,
    activeBgColor: String,
    indicatorColor: String,
    leftIcon: String,
    rightIcon: String,
    outsideArrows: Boolean,
    mobileArrows: Boolean,
    switchIndicator: Boolean,
    narrowIndicator: Boolean,
    inlineLabel: Boolean,
    noCaps: Boolean,
    dense: Boolean,
    contentClass: String,
    "onUpdate:modelValue": [Function, Array]
  },
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const { registerTick: registerScrollTick } = use_tick_default$1();
    const { registerTick: registerUpdateArrowsTick } = use_tick_default$1();
    const { registerTick: registerAnimateTick } = use_tick_default$1();
    const { registerTimeout: registerFocusTimeout, removeTimeout: removeFocusTimeout } = use_timeout_default$1();
    const { registerTimeout: registerScrollToTabTimeout, removeTimeout: removeScrollToTabTimeout } = use_timeout_default$1();
    const rootRef = ref$1(null);
    const contentRef = ref$1(null);
    const currentModel = ref$1(props4.modelValue);
    const scrollable = ref$1(false);
    const leftArrow = ref$1(true);
    const rightArrow = ref$1(false);
    const justify = ref$1(false);
    const tabDataList = [];
    const tabDataListLen = ref$1(0);
    const hasFocus = ref$1(false);
    let animateTimer = null, scrollTimer = null, unwatchRoute;
    const tabProps = computed(() => ({
      activeClass: props4.activeClass,
      activeColor: props4.activeColor,
      activeBgColor: props4.activeBgColor,
      indicatorClass: getIndicatorClass$1(
        props4.indicatorColor,
        props4.switchIndicator,
        props4.vertical
      ),
      narrowIndicator: props4.narrowIndicator,
      inlineLabel: props4.inlineLabel,
      noCaps: props4.noCaps
    }));
    const hasActiveTab = computed(() => {
      const len = tabDataListLen.value;
      const val = currentModel.value;
      for (let i22 = 0; i22 < len; i22++) {
        if (tabDataList[i22].name.value === val) {
          return true;
        }
      }
      return false;
    });
    const alignClass = computed(() => {
      const align = scrollable.value === true ? "left" : justify.value === true ? "justify" : props4.align;
      return `q-tabs__content--align-${align}`;
    });
    const classes = computed(
      () => `q-tabs row no-wrap items-center q-tabs--${scrollable.value === true ? "" : "not-"}scrollable q-tabs--${props4.vertical === true ? "vertical" : "horizontal"} q-tabs__arrows--${props4.outsideArrows === true ? "outside" : "inside"} q-tabs--mobile-with${props4.mobileArrows === true ? "" : "out"}-arrows` + (props4.dense === true ? " q-tabs--dense" : "") + (props4.shrink === true ? " col-shrink" : "") + (props4.stretch === true ? " self-stretch" : "")
    );
    const innerClass = computed(
      () => "q-tabs__content scroll--mobile row no-wrap items-center self-stretch hide-scrollbar relative-position " + alignClass.value + (props4.contentClass !== void 0 ? ` ${props4.contentClass}` : "")
    );
    const domProps = computed(() => props4.vertical === true ? { container: "height", content: "offsetHeight", scroll: "scrollHeight" } : { container: "width", content: "offsetWidth", scroll: "scrollWidth" });
    const isRTL = computed(() => props4.vertical !== true && $q.lang.rtl === true);
    const rtlPosCorrection = computed(() => rtlHasScrollBug$1 === false && isRTL.value === true);
    watch(isRTL, updateArrows);
    watch(() => props4.modelValue, (name2) => {
      updateModel2({ name: name2, setCurrent: true, skipEmit: true });
    });
    watch(() => props4.outsideArrows, recalculateScroll);
    function updateModel2({ name: name2, setCurrent, skipEmit }) {
      if (currentModel.value === name2) return;
      if (skipEmit !== true && props4["onUpdate:modelValue"] !== void 0) {
        emit("update:modelValue", name2);
      }
      if (setCurrent === true || props4["onUpdate:modelValue"] === void 0) {
        animate(currentModel.value, name2);
        currentModel.value = name2;
      }
    }
    function recalculateScroll() {
      registerScrollTick(() => {
        updateContainer({
          width: rootRef.value.offsetWidth,
          height: rootRef.value.offsetHeight
        });
      });
    }
    function updateContainer(domSize) {
      if (domProps.value === void 0 || contentRef.value === null) return;
      const size2 = domSize[domProps.value.container], scrollSize = Math.min(
        contentRef.value[domProps.value.scroll],
        Array.prototype.reduce.call(
          contentRef.value.children,
          (acc, el) => acc + (el[domProps.value.content] || 0),
          0
        )
      ), scroll = size2 > 0 && scrollSize > size2;
      scrollable.value = scroll;
      scroll === true && registerUpdateArrowsTick(updateArrows);
      justify.value = size2 < parseInt(props4.breakpoint, 10);
    }
    function animate(oldName, newName) {
      const oldTab = oldName !== void 0 && oldName !== null && oldName !== "" ? tabDataList.find((tab) => tab.name.value === oldName) : null, newTab = newName !== void 0 && newName !== null && newName !== "" ? tabDataList.find((tab) => tab.name.value === newName) : null;
      if (hadActivated === true) {
        hadActivated = false;
      } else if (oldTab && newTab) {
        const oldEl = oldTab.tabIndicatorRef.value, newEl = newTab.tabIndicatorRef.value;
        if (animateTimer !== null) {
          clearTimeout(animateTimer);
          animateTimer = null;
        }
        oldEl.style.transition = "none";
        oldEl.style.transform = "none";
        newEl.style.transition = "none";
        newEl.style.transform = "none";
        const oldPos = oldEl.getBoundingClientRect(), newPos = newEl.getBoundingClientRect();
        newEl.style.transform = props4.vertical === true ? `translate3d(0,${oldPos.top - newPos.top}px,0) scale3d(1,${newPos.height ? oldPos.height / newPos.height : 1},1)` : `translate3d(${oldPos.left - newPos.left}px,0,0) scale3d(${newPos.width ? oldPos.width / newPos.width : 1},1,1)`;
        registerAnimateTick(() => {
          animateTimer = setTimeout(() => {
            animateTimer = null;
            newEl.style.transition = "transform .25s cubic-bezier(.4, 0, .2, 1)";
            newEl.style.transform = "none";
          }, 70);
        });
      }
      if (newTab && scrollable.value === true) {
        scrollToTabEl(newTab.rootRef.value);
      }
    }
    function scrollToTabEl(el) {
      const { left, width: width3, top, height: height2 } = contentRef.value.getBoundingClientRect(), newPos = el.getBoundingClientRect();
      let offset2 = props4.vertical === true ? newPos.top - top : newPos.left - left;
      if (offset2 < 0) {
        contentRef.value[props4.vertical === true ? "scrollTop" : "scrollLeft"] += Math.floor(offset2);
        updateArrows();
        return;
      }
      offset2 += props4.vertical === true ? newPos.height - height2 : newPos.width - width3;
      if (offset2 > 0) {
        contentRef.value[props4.vertical === true ? "scrollTop" : "scrollLeft"] += Math.ceil(offset2);
        updateArrows();
      }
    }
    function updateArrows() {
      const content = contentRef.value;
      if (content === null) return;
      const rect = content.getBoundingClientRect(), pos = props4.vertical === true ? content.scrollTop : Math.abs(content.scrollLeft);
      if (isRTL.value === true) {
        leftArrow.value = Math.ceil(pos + rect.width) < content.scrollWidth - 1;
        rightArrow.value = pos > 0;
      } else {
        leftArrow.value = pos > 0;
        rightArrow.value = props4.vertical === true ? Math.ceil(pos + rect.height) < content.scrollHeight : Math.ceil(pos + rect.width) < content.scrollWidth;
      }
    }
    function animScrollTo(value2) {
      scrollTimer !== null && clearInterval(scrollTimer);
      scrollTimer = setInterval(() => {
        if (scrollTowards(value2) === true) {
          stopAnimScroll();
        }
      }, 5);
    }
    function scrollToStart() {
      animScrollTo(rtlPosCorrection.value === true ? Number.MAX_SAFE_INTEGER : 0);
    }
    function scrollToEnd() {
      animScrollTo(rtlPosCorrection.value === true ? 0 : Number.MAX_SAFE_INTEGER);
    }
    function stopAnimScroll() {
      if (scrollTimer !== null) {
        clearInterval(scrollTimer);
        scrollTimer = null;
      }
    }
    function onKbdNavigate(keyCode, fromEl) {
      const tabs = Array.prototype.filter.call(
        contentRef.value.children,
        (el) => el === fromEl || el.matches && el.matches(".q-tab.q-focusable") === true
      );
      const len = tabs.length;
      if (len === 0) return;
      if (keyCode === 36) {
        scrollToTabEl(tabs[0]);
        tabs[0].focus();
        return true;
      }
      if (keyCode === 35) {
        scrollToTabEl(tabs[len - 1]);
        tabs[len - 1].focus();
        return true;
      }
      const dirPrev = keyCode === (props4.vertical === true ? 38 : 37);
      const dirNext = keyCode === (props4.vertical === true ? 40 : 39);
      const dir = dirPrev === true ? -1 : dirNext === true ? 1 : void 0;
      if (dir !== void 0) {
        const rtlDir = isRTL.value === true ? -1 : 1;
        const index2 = tabs.indexOf(fromEl) + dir * rtlDir;
        if (index2 >= 0 && index2 < len) {
          scrollToTabEl(tabs[index2]);
          tabs[index2].focus({ preventScroll: true });
        }
        return true;
      }
    }
    const posFn = computed(() => rtlPosCorrection.value === true ? { get: (content) => Math.abs(content.scrollLeft), set: (content, pos) => {
      content.scrollLeft = -pos;
    } } : props4.vertical === true ? { get: (content) => content.scrollTop, set: (content, pos) => {
      content.scrollTop = pos;
    } } : { get: (content) => content.scrollLeft, set: (content, pos) => {
      content.scrollLeft = pos;
    } });
    function scrollTowards(value2) {
      const content = contentRef.value, { get: get2, set: set2 } = posFn.value;
      let done = false, pos = get2(content);
      const direction = value2 < pos ? -1 : 1;
      pos += direction * 5;
      if (pos < 0) {
        done = true;
        pos = 0;
      } else if (direction === -1 && pos <= value2 || direction === 1 && pos >= value2) {
        done = true;
        pos = value2;
      }
      set2(content, pos);
      updateArrows();
      return done;
    }
    function hasQueryIncluded(targetQuery, matchingQuery) {
      for (const key in targetQuery) {
        if (targetQuery[key] !== matchingQuery[key]) {
          return false;
        }
      }
      return true;
    }
    function updateActiveRoute() {
      let name2 = null, bestScore = { matchedLen: 0, queryDiff: 9999, hrefLen: 0 };
      const list = tabDataList.filter((tab) => tab.routeData !== void 0 && tab.routeData.hasRouterLink.value === true);
      const { hash: currentHash, query: currentQuery } = proxy.$route;
      const currentQueryLen = Object.keys(currentQuery).length;
      for (const tab of list) {
        const exact = tab.routeData.exact.value === true;
        if (tab.routeData[exact === true ? "linkIsExactActive" : "linkIsActive"].value !== true) {
          continue;
        }
        const { hash, query, matched, href: href2 } = tab.routeData.resolvedLink.value;
        const queryLen = Object.keys(query).length;
        if (exact === true) {
          if (hash !== currentHash) {
            continue;
          }
          if (queryLen !== currentQueryLen || hasQueryIncluded(currentQuery, query) === false) {
            continue;
          }
          name2 = tab.name.value;
          break;
        }
        if (hash !== "" && hash !== currentHash) {
          continue;
        }
        if (queryLen !== 0 && hasQueryIncluded(query, currentQuery) === false) {
          continue;
        }
        const newScore = {
          matchedLen: matched.length,
          queryDiff: currentQueryLen - queryLen,
          hrefLen: href2.length - hash.length
        };
        if (newScore.matchedLen > bestScore.matchedLen) {
          name2 = tab.name.value;
          bestScore = newScore;
          continue;
        } else if (newScore.matchedLen !== bestScore.matchedLen) {
          continue;
        }
        if (newScore.queryDiff < bestScore.queryDiff) {
          name2 = tab.name.value;
          bestScore = newScore;
        } else if (newScore.queryDiff !== bestScore.queryDiff) {
          continue;
        }
        if (newScore.hrefLen > bestScore.hrefLen) {
          name2 = tab.name.value;
          bestScore = newScore;
        }
      }
      if (name2 === null && tabDataList.some((tab) => tab.routeData === void 0 && tab.name.value === currentModel.value) === true) {
        hadActivated = false;
        return;
      }
      updateModel2({ name: name2, setCurrent: true });
    }
    function onFocusin(e22) {
      removeFocusTimeout();
      if (hasFocus.value !== true && rootRef.value !== null && e22.target && typeof e22.target.closest === "function") {
        const tab = e22.target.closest(".q-tab");
        if (tab && rootRef.value.contains(tab) === true) {
          hasFocus.value = true;
          scrollable.value === true && scrollToTabEl(tab);
        }
      }
    }
    function onFocusout() {
      registerFocusTimeout(() => {
        hasFocus.value = false;
      }, 30);
    }
    function verifyRouteModel() {
      if ($tabs.avoidRouteWatcher === false) {
        registerScrollToTabTimeout(updateActiveRoute);
      } else {
        removeScrollToTabTimeout();
      }
    }
    function watchRoute() {
      if (unwatchRoute === void 0) {
        const unwatch = watch(() => proxy.$route.fullPath, verifyRouteModel);
        unwatchRoute = () => {
          unwatch();
          unwatchRoute = void 0;
        };
      }
    }
    function registerTab(tabData) {
      tabDataList.push(tabData);
      tabDataListLen.value++;
      recalculateScroll();
      if (tabData.routeData === void 0 || proxy.$route === void 0) {
        registerScrollToTabTimeout(() => {
          if (scrollable.value === true) {
            const value2 = currentModel.value;
            const newTab = value2 !== void 0 && value2 !== null && value2 !== "" ? tabDataList.find((tab) => tab.name.value === value2) : null;
            newTab && scrollToTabEl(newTab.rootRef.value);
          }
        });
      } else {
        watchRoute();
        if (tabData.routeData.hasRouterLink.value === true) {
          verifyRouteModel();
        }
      }
    }
    function unregisterTab(tabData) {
      tabDataList.splice(tabDataList.indexOf(tabData), 1);
      tabDataListLen.value--;
      recalculateScroll();
      if (unwatchRoute !== void 0 && tabData.routeData !== void 0) {
        if (tabDataList.every((tab) => tab.routeData === void 0) === true) {
          unwatchRoute();
        }
        verifyRouteModel();
      }
    }
    const $tabs = {
      currentModel,
      tabProps,
      hasFocus,
      hasActiveTab,
      registerTab,
      unregisterTab,
      verifyRouteModel,
      updateModel: updateModel2,
      onKbdNavigate,
      avoidRouteWatcher: false
      // false | string (uid)
    };
    provide(tabsKey$1, $tabs);
    function cleanup() {
      animateTimer !== null && clearTimeout(animateTimer);
      stopAnimScroll();
      unwatchRoute !== void 0 && unwatchRoute();
    }
    let hadRouteWatcher, hadActivated;
    onBeforeUnmount(cleanup);
    onDeactivated(() => {
      hadRouteWatcher = unwatchRoute !== void 0;
      cleanup();
    });
    onActivated(() => {
      if (hadRouteWatcher === true) {
        watchRoute();
        hadActivated = true;
        verifyRouteModel();
      }
      recalculateScroll();
    });
    return () => {
      return h("div", {
        ref: rootRef,
        class: classes.value,
        role: "tablist",
        onFocusin,
        onFocusout
      }, [
        h(QResizeObserver_default$1, { onResize: updateContainer }),
        h("div", {
          ref: contentRef,
          class: innerClass.value,
          onScroll: updateArrows
        }, hSlot$1(slots.default)),
        h(QIcon_default$1, {
          class: "q-tabs__arrow q-tabs__arrow--left absolute q-tab__icon" + (leftArrow.value === true ? "" : " q-tabs__arrow--faded"),
          name: props4.leftIcon || $q.iconSet.tabs[props4.vertical === true ? "up" : "left"],
          onMousedownPassive: scrollToStart,
          onTouchstartPassive: scrollToStart,
          onMouseupPassive: stopAnimScroll,
          onMouseleavePassive: stopAnimScroll,
          onTouchendPassive: stopAnimScroll
        }),
        h(QIcon_default$1, {
          class: "q-tabs__arrow q-tabs__arrow--right absolute q-tab__icon" + (rightArrow.value === true ? "" : " q-tabs__arrow--faded"),
          name: props4.rightIcon || $q.iconSet.tabs[props4.vertical === true ? "down" : "right"],
          onMousedownPassive: scrollToEnd,
          onTouchstartPassive: scrollToEnd,
          onMouseupPassive: stopAnimScroll,
          onMouseleavePassive: stopAnimScroll,
          onTouchendPassive: stopAnimScroll
        })
      ]);
    };
  }
});
var id$1 = 0;
var useTabEmits$1 = ["click", "keydown"];
var useTabProps$1 = {
  icon: String,
  label: [Number, String],
  alert: [Boolean, String],
  alertIcon: String,
  name: {
    type: [Number, String],
    default: () => `t_${id$1++}`
  },
  noCaps: Boolean,
  tabindex: [String, Number],
  disable: Boolean,
  contentClass: String,
  ripple: {
    type: [Boolean, Object],
    default: true
  }
};
function use_tab_default$1(props4, slots, emit, routeData) {
  const $tabs = inject(tabsKey$1, emptyRenderFn$1);
  if ($tabs === emptyRenderFn$1) {
    console.error("QTab/QRouteTab component needs to be child of QTabs");
    return emptyRenderFn$1;
  }
  const { proxy } = getCurrentInstance();
  const blurTargetRef = ref$1(null);
  const rootRef = ref$1(null);
  const tabIndicatorRef = ref$1(null);
  const ripple = computed(() => props4.disable === true || props4.ripple === false ? false : Object.assign(
    { keyCodes: [13, 32], early: true },
    props4.ripple === true ? {} : props4.ripple
  ));
  const isActive = computed(() => $tabs.currentModel.value === props4.name);
  const classes = computed(
    () => "q-tab relative-position self-stretch flex flex-center text-center" + (isActive.value === true ? " q-tab--active" + ($tabs.tabProps.value.activeClass ? " " + $tabs.tabProps.value.activeClass : "") + ($tabs.tabProps.value.activeColor ? ` text-${$tabs.tabProps.value.activeColor}` : "") + ($tabs.tabProps.value.activeBgColor ? ` bg-${$tabs.tabProps.value.activeBgColor}` : "") : " q-tab--inactive") + (props4.icon && props4.label && $tabs.tabProps.value.inlineLabel === false ? " q-tab--full" : "") + (props4.noCaps === true || $tabs.tabProps.value.noCaps === true ? " q-tab--no-caps" : "") + (props4.disable === true ? " disabled" : " q-focusable q-hoverable cursor-pointer") + (routeData !== void 0 ? routeData.linkClass.value : "")
  );
  const innerClass = computed(
    () => "q-tab__content self-stretch flex-center relative-position q-anchor--skip non-selectable " + ($tabs.tabProps.value.inlineLabel === true ? "row no-wrap q-tab__content--inline" : "column") + (props4.contentClass !== void 0 ? ` ${props4.contentClass}` : "")
  );
  const tabIndex = computed(() => props4.disable === true || $tabs.hasFocus.value === true || isActive.value === false && $tabs.hasActiveTab.value === true ? -1 : props4.tabindex || 0);
  function onClick(e22, keyboard) {
    if (keyboard !== true && blurTargetRef.value !== null) {
      blurTargetRef.value.focus();
    }
    if (props4.disable === true) {
      if (routeData !== void 0 && routeData.hasRouterLink.value === true) {
        stopAndPrevent$1(e22);
      }
      return;
    }
    if (routeData === void 0) {
      $tabs.updateModel({ name: props4.name });
      emit("click", e22);
      return;
    }
    if (routeData.hasRouterLink.value === true) {
      const go = (opts = {}) => {
        let hardError;
        const reqId = opts.to === void 0 || isDeepEqual$1(opts.to, props4.to) === true ? $tabs.avoidRouteWatcher = uid_default$1() : null;
        return routeData.navigateToRouterLink(e22, { ...opts, returnRouterError: true }).catch((err) => {
          hardError = err;
        }).then((softError) => {
          if (reqId === $tabs.avoidRouteWatcher) {
            $tabs.avoidRouteWatcher = false;
            if (hardError === void 0 && (softError === void 0 || softError.message !== void 0 && softError.message.startsWith("Avoided redundant navigation") === true)) {
              $tabs.updateModel({ name: props4.name });
            }
          }
          if (opts.returnRouterError === true) {
            return hardError !== void 0 ? Promise.reject(hardError) : softError;
          }
        });
      };
      emit("click", e22, go);
      e22.defaultPrevented !== true && go();
      return;
    }
    emit("click", e22);
  }
  function onKeydown2(e22) {
    if (isKeyCode$1(e22, [13, 32])) {
      onClick(e22, true);
    } else if (shouldIgnoreKey$1(e22) !== true && e22.keyCode >= 35 && e22.keyCode <= 40 && e22.altKey !== true && e22.metaKey !== true) {
      $tabs.onKbdNavigate(e22.keyCode, proxy.$el) === true && stopAndPrevent$1(e22);
    }
    emit("keydown", e22);
  }
  function getContent() {
    const narrow = $tabs.tabProps.value.narrowIndicator, content = [], indicator = h("div", {
      ref: tabIndicatorRef,
      class: [
        "q-tab__indicator",
        $tabs.tabProps.value.indicatorClass
      ]
    });
    props4.icon !== void 0 && content.push(
      h(QIcon_default$1, {
        class: "q-tab__icon",
        name: props4.icon
      })
    );
    props4.label !== void 0 && content.push(
      h("div", { class: "q-tab__label" }, props4.label)
    );
    props4.alert !== false && content.push(
      props4.alertIcon !== void 0 ? h(QIcon_default$1, {
        class: "q-tab__alert-icon",
        color: props4.alert !== true ? props4.alert : void 0,
        name: props4.alertIcon
      }) : h("div", {
        class: "q-tab__alert" + (props4.alert !== true ? ` text-${props4.alert}` : "")
      })
    );
    narrow === true && content.push(indicator);
    const node = [
      h("div", { class: "q-focus-helper", tabindex: -1, ref: blurTargetRef }),
      h("div", { class: innerClass.value }, hMergeSlot$1(slots.default, content))
    ];
    narrow === false && node.push(indicator);
    return node;
  }
  const tabData = {
    name: computed(() => props4.name),
    rootRef,
    tabIndicatorRef,
    routeData
  };
  onBeforeUnmount(() => {
    $tabs.unregisterTab(tabData);
  });
  onMounted(() => {
    $tabs.registerTab(tabData);
  });
  function renderTab(tag, customData) {
    const data = {
      ref: rootRef,
      class: classes.value,
      tabindex: tabIndex.value,
      role: "tab",
      "aria-selected": isActive.value === true ? "true" : "false",
      "aria-disabled": props4.disable === true ? "true" : void 0,
      onClick,
      onKeydown: onKeydown2,
      ...customData
    };
    return withDirectives(
      h(tag, data, getContent()),
      [[Ripple_default$1, ripple.value]]
    );
  }
  return { renderTab, $tabs };
}
var QTab_default$1 = createComponent$1({
  name: "QTab",
  props: useTabProps$1,
  emits: useTabEmits$1,
  setup(props4, { slots, emit }) {
    const { renderTab } = use_tab_default$1(props4, slots, emit);
    return () => renderTab("div");
  }
});
var QTabPanels_default$1 = createComponent$1({
  name: "QTabPanels",
  props: {
    ...usePanelProps$1,
    ...useDarkProps$1
  },
  emits: usePanelEmits$1,
  setup(props4, { slots }) {
    const vm2 = getCurrentInstance();
    const isDark = use_dark_default$1(props4, vm2.proxy.$q);
    const { updatePanelsList, getPanelContent, panelDirectives } = use_panel_default$1();
    const classes = computed(
      () => "q-tab-panels q-panel-parent" + (isDark.value === true ? " q-tab-panels--dark q-dark" : "")
    );
    return () => {
      updatePanelsList(slots);
      return hDir$1(
        "div",
        { class: classes.value },
        getPanelContent(),
        "pan",
        props4.swipeable,
        () => panelDirectives.value
      );
    };
  }
});
var QTabPanel_default$1 = createComponent$1({
  name: "QTabPanel",
  props: usePanelChildProps$1,
  setup(_, { slots }) {
    return () => h("div", { class: "q-tab-panel", role: "tabpanel" }, hSlot$1(slots.default));
  }
});
var hex$1 = /^#[0-9a-fA-F]{3}([0-9a-fA-F]{3})?$/;
var hexa$1 = /^#[0-9a-fA-F]{4}([0-9a-fA-F]{4})?$/;
var hexOrHexa$1 = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/;
var rgb$1 = /^rgb\(((0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),){2}(0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5])\)$/;
var rgba$1 = /^rgba\(((0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),){2}(0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),(0|0\.[0-9]+[1-9]|0\.[1-9]+|1)\)$/;
var testPattern$1 = {
  date: (v) => /^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(v),
  time: (v) => /^([0-1]?\d|2[0-3]):[0-5]\d$/.test(v),
  fulltime: (v) => /^([0-1]?\d|2[0-3]):[0-5]\d:[0-5]\d$/.test(v),
  timeOrFulltime: (v) => /^([0-1]?\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/.test(v),
  // -- RFC 5322 --
  // -- Added in v2.6.6 --
  // This is a basic helper validation.
  // For something more complex (like RFC 822) you should write and use your own rule.
  // We won't be accepting PRs to enhance the one below because of the reason above.
  // eslint-disable-next-line
  email: (v) => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v),
  hexColor: (v) => hex$1.test(v),
  hexaColor: (v) => hexa$1.test(v),
  hexOrHexaColor: (v) => hexOrHexa$1.test(v),
  rgbColor: (v) => rgb$1.test(v),
  rgbaColor: (v) => rgba$1.test(v),
  rgbOrRgbaColor: (v) => rgb$1.test(v) || rgba$1.test(v),
  hexOrRgbColor: (v) => hex$1.test(v) || rgb$1.test(v),
  hexaOrRgbaColor: (v) => hexa$1.test(v) || rgba$1.test(v),
  anyColor: (v) => hexOrHexa$1.test(v) || rgb$1.test(v) || rgba$1.test(v)
};
var reRGBA$1 = /^rgb(a)?\((\d{1,3}),(\d{1,3}),(\d{1,3}),?([01]?\.?\d*?)?\)$/;
function rgbToHex$1({ r, g: g2, b: b22, a: a32 }) {
  const alpha2 = a32 !== void 0;
  r = Math.round(r);
  g2 = Math.round(g2);
  b22 = Math.round(b22);
  if (r > 255 || g2 > 255 || b22 > 255 || alpha2 && a32 > 100) {
    throw new TypeError("Expected 3 numbers below 256 (and optionally one below 100)");
  }
  a32 = alpha2 ? (Math.round(255 * a32 / 100) | 1 << 8).toString(16).slice(1) : "";
  return "#" + (b22 | g2 << 8 | r << 16 | 1 << 24).toString(16).slice(1) + a32;
}
function rgbToString$1({ r, g: g2, b: b22, a: a32 }) {
  return `rgb${a32 !== void 0 ? "a" : ""}(${r},${g2},${b22}${a32 !== void 0 ? "," + a32 / 100 : ""})`;
}
function hexToRgb$1(hex2) {
  if (typeof hex2 !== "string") {
    throw new TypeError("Expected a string");
  }
  hex2 = hex2.replace(/^#/, "");
  if (hex2.length === 3) {
    hex2 = hex2[0] + hex2[0] + hex2[1] + hex2[1] + hex2[2] + hex2[2];
  } else if (hex2.length === 4) {
    hex2 = hex2[0] + hex2[0] + hex2[1] + hex2[1] + hex2[2] + hex2[2] + hex2[3] + hex2[3];
  }
  const num = parseInt(hex2, 16);
  return hex2.length > 6 ? { r: num >> 24 & 255, g: num >> 16 & 255, b: num >> 8 & 255, a: Math.round((num & 255) / 2.55) } : { r: num >> 16, g: num >> 8 & 255, b: num & 255 };
}
function hsvToRgb$1({ h: h138, s: s32, v, a: a32 }) {
  let r, g2, b22;
  s32 = s32 / 100;
  v = v / 100;
  h138 = h138 / 360;
  const i22 = Math.floor(h138 * 6), f = h138 * 6 - i22, p2 = v * (1 - s32), q3 = v * (1 - f * s32), t22 = v * (1 - (1 - f) * s32);
  switch (i22 % 6) {
    case 0:
      r = v;
      g2 = t22;
      b22 = p2;
      break;
    case 1:
      r = q3;
      g2 = v;
      b22 = p2;
      break;
    case 2:
      r = p2;
      g2 = v;
      b22 = t22;
      break;
    case 3:
      r = p2;
      g2 = q3;
      b22 = v;
      break;
    case 4:
      r = t22;
      g2 = p2;
      b22 = v;
      break;
    case 5:
      r = v;
      g2 = p2;
      b22 = q3;
      break;
  }
  return {
    r: Math.round(r * 255),
    g: Math.round(g2 * 255),
    b: Math.round(b22 * 255),
    a: a32
  };
}
function rgbToHsv$1({ r, g: g2, b: b22, a: a32 }) {
  const max2 = Math.max(r, g2, b22), min2 = Math.min(r, g2, b22), d32 = max2 - min2, s32 = max2 === 0 ? 0 : d32 / max2, v = max2 / 255;
  let h138;
  switch (max2) {
    case min2:
      h138 = 0;
      break;
    case r:
      h138 = g2 - b22 + d32 * (g2 < b22 ? 6 : 0);
      h138 /= 6 * d32;
      break;
    case g2:
      h138 = b22 - r + d32 * 2;
      h138 /= 6 * d32;
      break;
    case b22:
      h138 = r - g2 + d32 * 4;
      h138 /= 6 * d32;
      break;
  }
  return {
    h: Math.round(h138 * 360),
    s: Math.round(s32 * 100),
    v: Math.round(v * 100),
    a: a32
  };
}
function textToRgb$1(str) {
  if (typeof str !== "string") {
    throw new TypeError("Expected a string");
  }
  const color2 = str.replace(/ /g, "");
  const m32 = reRGBA$1.exec(color2);
  if (m32 === null) {
    return hexToRgb$1(color2);
  }
  const rgb2 = {
    r: Math.min(255, parseInt(m32[2], 10)),
    g: Math.min(255, parseInt(m32[3], 10)),
    b: Math.min(255, parseInt(m32[4], 10))
  };
  if (m32[1]) {
    const alpha2 = parseFloat(m32[5]);
    rgb2.a = Math.min(1, isNaN(alpha2) === true ? 1 : alpha2) * 100;
  }
  return rgb2;
}
function lighten$2(color2, percent) {
  if (typeof color2 !== "string") {
    throw new TypeError("Expected a string as color");
  }
  if (typeof percent !== "number") {
    throw new TypeError("Expected a numeric percent");
  }
  const rgb2 = textToRgb$1(color2), t22 = percent < 0 ? 0 : 255, p2 = Math.abs(percent) / 100, R3 = rgb2.r, G3 = rgb2.g, B3 = rgb2.b;
  return "#" + (16777216 + (Math.round((t22 - R3) * p2) + R3) * 65536 + (Math.round((t22 - G3) * p2) + G3) * 256 + (Math.round((t22 - B3) * p2) + B3)).toString(16).slice(1);
}
function luminosity$1(color2) {
  if (typeof color2 !== "string" && (!color2 || color2.r === void 0)) {
    throw new TypeError("Expected a string or a {r, g, b} object as color");
  }
  const rgb2 = typeof color2 === "string" ? textToRgb$1(color2) : color2, r = rgb2.r / 255, g2 = rgb2.g / 255, b22 = rgb2.b / 255, R3 = r <= 0.03928 ? r / 12.92 : Math.pow((r + 0.055) / 1.055, 2.4), G3 = g2 <= 0.03928 ? g2 / 12.92 : Math.pow((g2 + 0.055) / 1.055, 2.4), B3 = b22 <= 0.03928 ? b22 / 12.92 : Math.pow((b22 + 0.055) / 1.055, 2.4);
  return 0.2126 * R3 + 0.7152 * G3 + 0.0722 * B3;
}
function brightness(color2) {
  if (typeof color2 !== "string" && (!color2 || color2.r === void 0)) {
    throw new TypeError("Expected a string or a {r, g, b} object as color");
  }
  const rgb2 = typeof color2 === "string" ? textToRgb$1(color2) : color2;
  return (rgb2.r * 299 + rgb2.g * 587 + rgb2.b * 114) / 1e3;
}
function blend(fgColor, bgColor) {
  if (typeof fgColor !== "string" && (!fgColor || fgColor.r === void 0)) {
    throw new TypeError("Expected a string or a {r, g, b[, a]} object as fgColor");
  }
  if (typeof bgColor !== "string" && (!bgColor || bgColor.r === void 0)) {
    throw new TypeError("Expected a string or a {r, g, b[, a]} object as bgColor");
  }
  const rgb1 = typeof fgColor === "string" ? textToRgb$1(fgColor) : fgColor, r1 = rgb1.r / 255, g1 = rgb1.g / 255, b1 = rgb1.b / 255, a1 = rgb1.a !== void 0 ? rgb1.a / 100 : 1, rgb2 = typeof bgColor === "string" ? textToRgb$1(bgColor) : bgColor, r2 = rgb2.r / 255, g2 = rgb2.g / 255, b22 = rgb2.b / 255, a222 = rgb2.a !== void 0 ? rgb2.a / 100 : 1, a32 = a1 + a222 * (1 - a1), r = Math.round((r1 * a1 + r2 * a222 * (1 - a1)) / a32 * 255), g3 = Math.round((g1 * a1 + g2 * a222 * (1 - a1)) / a32 * 255), b3 = Math.round((b1 * a1 + b22 * a222 * (1 - a1)) / a32 * 255);
  const ret = { r, g: g3, b: b3, a: Math.round(a32 * 100) };
  return typeof fgColor === "string" ? rgbToHex$1(ret) : ret;
}
function changeAlpha(color2, offset2) {
  if (typeof color2 !== "string") {
    throw new TypeError("Expected a string as color");
  }
  if (offset2 === void 0 || offset2 < -1 || offset2 > 1) {
    throw new TypeError("Expected offset to be between -1 and 1");
  }
  const { r, g: g2, b: b22, a: a32 } = textToRgb$1(color2);
  const alpha2 = a32 !== void 0 ? a32 / 100 : 0;
  return rgbToHex$1({
    r,
    g: g2,
    b: b22,
    a: Math.round(Math.min(1, Math.max(0, alpha2 + offset2)) * 100)
  });
}
function getPaletteColor$1(colorName) {
  if (typeof colorName !== "string") {
    throw new TypeError("Expected a string as color");
  }
  const el = document.createElement("div");
  el.className = `text-${colorName} invisible fixed no-pointer-events`;
  document.body.appendChild(el);
  const result = getComputedStyle(el).getPropertyValue("color");
  el.remove();
  return rgbToHex$1(textToRgb$1(result));
}
var colors_default = {
  rgbToHex: rgbToHex$1,
  hexToRgb: hexToRgb$1,
  hsvToRgb: hsvToRgb$1,
  rgbToHsv: rgbToHsv$1,
  textToRgb: textToRgb$1,
  lighten: lighten$2,
  luminosity: luminosity$1,
  brightness,
  blend,
  changeAlpha,
  getPaletteColor: getPaletteColor$1
};
var palette$1 = [
  "rgb(255,204,204)",
  "rgb(255,230,204)",
  "rgb(255,255,204)",
  "rgb(204,255,204)",
  "rgb(204,255,230)",
  "rgb(204,255,255)",
  "rgb(204,230,255)",
  "rgb(204,204,255)",
  "rgb(230,204,255)",
  "rgb(255,204,255)",
  "rgb(255,153,153)",
  "rgb(255,204,153)",
  "rgb(255,255,153)",
  "rgb(153,255,153)",
  "rgb(153,255,204)",
  "rgb(153,255,255)",
  "rgb(153,204,255)",
  "rgb(153,153,255)",
  "rgb(204,153,255)",
  "rgb(255,153,255)",
  "rgb(255,102,102)",
  "rgb(255,179,102)",
  "rgb(255,255,102)",
  "rgb(102,255,102)",
  "rgb(102,255,179)",
  "rgb(102,255,255)",
  "rgb(102,179,255)",
  "rgb(102,102,255)",
  "rgb(179,102,255)",
  "rgb(255,102,255)",
  "rgb(255,51,51)",
  "rgb(255,153,51)",
  "rgb(255,255,51)",
  "rgb(51,255,51)",
  "rgb(51,255,153)",
  "rgb(51,255,255)",
  "rgb(51,153,255)",
  "rgb(51,51,255)",
  "rgb(153,51,255)",
  "rgb(255,51,255)",
  "rgb(255,0,0)",
  "rgb(255,128,0)",
  "rgb(255,255,0)",
  "rgb(0,255,0)",
  "rgb(0,255,128)",
  "rgb(0,255,255)",
  "rgb(0,128,255)",
  "rgb(0,0,255)",
  "rgb(128,0,255)",
  "rgb(255,0,255)",
  "rgb(245,0,0)",
  "rgb(245,123,0)",
  "rgb(245,245,0)",
  "rgb(0,245,0)",
  "rgb(0,245,123)",
  "rgb(0,245,245)",
  "rgb(0,123,245)",
  "rgb(0,0,245)",
  "rgb(123,0,245)",
  "rgb(245,0,245)",
  "rgb(214,0,0)",
  "rgb(214,108,0)",
  "rgb(214,214,0)",
  "rgb(0,214,0)",
  "rgb(0,214,108)",
  "rgb(0,214,214)",
  "rgb(0,108,214)",
  "rgb(0,0,214)",
  "rgb(108,0,214)",
  "rgb(214,0,214)",
  "rgb(163,0,0)",
  "rgb(163,82,0)",
  "rgb(163,163,0)",
  "rgb(0,163,0)",
  "rgb(0,163,82)",
  "rgb(0,163,163)",
  "rgb(0,82,163)",
  "rgb(0,0,163)",
  "rgb(82,0,163)",
  "rgb(163,0,163)",
  "rgb(92,0,0)",
  "rgb(92,46,0)",
  "rgb(92,92,0)",
  "rgb(0,92,0)",
  "rgb(0,92,46)",
  "rgb(0,92,92)",
  "rgb(0,46,92)",
  "rgb(0,0,92)",
  "rgb(46,0,92)",
  "rgb(92,0,92)",
  "rgb(255,255,255)",
  "rgb(205,205,205)",
  "rgb(178,178,178)",
  "rgb(153,153,153)",
  "rgb(127,127,127)",
  "rgb(102,102,102)",
  "rgb(76,76,76)",
  "rgb(51,51,51)",
  "rgb(25,25,25)",
  "rgb(0,0,0)"
];
var thumbPath$1 = "M5 5 h10 v10 h-10 v-10 z";
var alphaTrackImg$1 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAH0lEQVQoU2NkYGAwZkAFZ5G5jPRRgOYEVDeB3EBjBQBOZwTVugIGyAAAAABJRU5ErkJggg==";
var QColor_default = createComponent$1({
  name: "QColor",
  props: {
    ...useDarkProps$1,
    ...useFormProps$1,
    modelValue: String,
    defaultValue: String,
    defaultView: {
      type: String,
      default: "spectrum",
      validator: (v) => ["spectrum", "tune", "palette"].includes(v)
    },
    formatModel: {
      type: String,
      default: "auto",
      validator: (v) => ["auto", "hex", "rgb", "hexa", "rgba"].includes(v)
    },
    palette: Array,
    noHeader: Boolean,
    noHeaderTabs: Boolean,
    noFooter: Boolean,
    square: Boolean,
    flat: Boolean,
    bordered: Boolean,
    disable: Boolean,
    readonly: Boolean
  },
  emits: ["update:modelValue", "change"],
  setup(props4, { emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const isDark = use_dark_default$1(props4, $q);
    const { getCache } = use_render_cache_default$1();
    const spectrumRef = ref$1(null);
    const errorIconRef = ref$1(null);
    const forceHex = computed(() => props4.formatModel === "auto" ? null : props4.formatModel.indexOf("hex") !== -1);
    const forceAlpha = computed(() => props4.formatModel === "auto" ? null : props4.formatModel.indexOf("a") !== -1);
    const topView = ref$1(
      props4.formatModel === "auto" ? props4.modelValue === void 0 || props4.modelValue === null || props4.modelValue === "" || props4.modelValue.startsWith("#") ? "hex" : "rgb" : props4.formatModel.startsWith("hex") ? "hex" : "rgb"
    );
    const view = ref$1(props4.defaultView);
    const model = ref$1(parseModel(props4.modelValue || props4.defaultValue));
    const editable = computed(() => props4.disable !== true && props4.readonly !== true);
    const isHex2 = computed(
      () => props4.modelValue === void 0 || props4.modelValue === null || props4.modelValue === "" || props4.modelValue.startsWith("#")
    );
    const isOutputHex = computed(() => forceHex.value !== null ? forceHex.value : isHex2.value);
    const formAttrs = computed(() => ({
      type: "hidden",
      name: props4.name,
      value: model.value[isOutputHex.value === true ? "hex" : "rgb"]
    }));
    const injectFormInput = useFormInject$1(formAttrs);
    const hasAlpha = computed(() => forceAlpha.value !== null ? forceAlpha.value : model.value.a !== void 0);
    const currentBgColor = computed(() => ({
      backgroundColor: model.value.rgb || "#000"
    }));
    const headerClass = computed(() => {
      const light = model.value.a !== void 0 && model.value.a < 65 ? true : luminosity$1(model.value) > 0.4;
      return `q-color-picker__header-content q-color-picker__header-content--${light ? "light" : "dark"}`;
    });
    const spectrumStyle = computed(() => ({
      background: `hsl(${model.value.h},100%,50%)`
    }));
    const spectrumPointerStyle = computed(() => ({
      top: `${100 - model.value.v}%`,
      [$q.lang.rtl === true ? "right" : "left"]: `${model.value.s}%`
    }));
    const computedPalette = computed(() => props4.palette !== void 0 && props4.palette.length !== 0 ? props4.palette : palette$1);
    const classes = computed(
      () => "q-color-picker" + (props4.bordered === true ? " q-color-picker--bordered" : "") + (props4.square === true ? " q-color-picker--square no-border-radius" : "") + (props4.flat === true ? " q-color-picker--flat no-shadow" : "") + (props4.disable === true ? " disabled" : "") + (isDark.value === true ? " q-color-picker--dark q-dark" : "")
    );
    const attributes = computed(() => props4.disable === true ? { "aria-disabled": "true" } : {});
    const spectrumDirective = computed(() => {
      return [[
        TouchPan_default$1,
        onSpectrumPan,
        void 0,
        { prevent: true, stop: true, mouse: true }
      ]];
    });
    watch(() => props4.modelValue, (v) => {
      const localModel = parseModel(v || props4.defaultValue);
      if (localModel.hex !== model.value.hex) {
        model.value = localModel;
      }
    });
    watch(() => props4.defaultValue, (v) => {
      if (!props4.modelValue && v) {
        const localModel = parseModel(v);
        if (localModel.hex !== model.value.hex) {
          model.value = localModel;
        }
      }
    });
    function updateModel2(rgb2, change) {
      model.value.hex = rgbToHex$1(rgb2);
      model.value.rgb = rgbToString$1(rgb2);
      model.value.r = rgb2.r;
      model.value.g = rgb2.g;
      model.value.b = rgb2.b;
      model.value.a = rgb2.a;
      const value2 = model.value[isOutputHex.value === true ? "hex" : "rgb"];
      emit("update:modelValue", value2);
      change === true && emit("change", value2);
    }
    function parseModel(v) {
      const alpha2 = forceAlpha.value !== void 0 ? forceAlpha.value : props4.formatModel === "auto" ? null : props4.formatModel.indexOf("a") !== -1;
      if (typeof v !== "string" || v.length === 0 || testPattern$1.anyColor(v.replace(/ /g, "")) !== true) {
        return {
          h: 0,
          s: 0,
          v: 0,
          r: 0,
          g: 0,
          b: 0,
          a: alpha2 === true ? 100 : void 0,
          hex: void 0,
          rgb: void 0
        };
      }
      const model2 = textToRgb$1(v);
      if (alpha2 === true && model2.a === void 0) {
        model2.a = 100;
      }
      model2.hex = rgbToHex$1(model2);
      model2.rgb = rgbToString$1(model2);
      return Object.assign(model2, rgbToHsv$1(model2));
    }
    function changeSpectrum(left, top, change) {
      const panel = spectrumRef.value;
      if (panel === null) return;
      const width3 = panel.clientWidth, height2 = panel.clientHeight, rect = panel.getBoundingClientRect();
      let x22 = Math.min(width3, Math.max(0, left - rect.left));
      if ($q.lang.rtl === true) {
        x22 = width3 - x22;
      }
      const y32 = Math.min(height2, Math.max(0, top - rect.top)), s32 = Math.round(100 * x22 / width3), v = Math.round(100 * Math.max(0, Math.min(1, -(y32 / height2) + 1))), rgb2 = hsvToRgb$1({
        h: model.value.h,
        s: s32,
        v,
        a: hasAlpha.value === true ? model.value.a : void 0
      });
      model.value.s = s32;
      model.value.v = v;
      updateModel2(rgb2, change);
    }
    function onHue(val, change) {
      const h138 = Math.round(val);
      const rgb2 = hsvToRgb$1({
        h: h138,
        s: model.value.s,
        v: model.value.v,
        a: hasAlpha.value === true ? model.value.a : void 0
      });
      model.value.h = h138;
      updateModel2(rgb2, change);
    }
    function onHueChange(val) {
      onHue(val, true);
    }
    function onNumericChange(value2, formatModel, max2, evt, change) {
      evt !== void 0 && stop$1(evt);
      if (!/^[0-9]+$/.test(value2)) {
        change === true && proxy.$forceUpdate();
        return;
      }
      const val = Math.floor(Number(value2));
      if (val < 0 || val > max2) {
        change === true && proxy.$forceUpdate();
        return;
      }
      const rgb2 = {
        r: formatModel === "r" ? val : model.value.r,
        g: formatModel === "g" ? val : model.value.g,
        b: formatModel === "b" ? val : model.value.b,
        a: hasAlpha.value === true ? formatModel === "a" ? val : model.value.a : void 0
      };
      if (formatModel !== "a") {
        const hsv = rgbToHsv$1(rgb2);
        model.value.h = hsv.h;
        model.value.s = hsv.s;
        model.value.v = hsv.v;
      }
      updateModel2(rgb2, change);
      if (evt !== void 0 && change !== true && evt.target.selectionEnd !== void 0) {
        const index2 = evt.target.selectionEnd;
        nextTick(() => {
          evt.target.setSelectionRange(index2, index2);
        });
      }
    }
    function onEditorChange(evt, change) {
      let rgb2;
      const inp = evt.target.value;
      stop$1(evt);
      if (topView.value === "hex") {
        if (inp.length !== (hasAlpha.value === true ? 9 : 7) || !/^#[0-9A-Fa-f]+$/.test(inp)) {
          return true;
        }
        rgb2 = hexToRgb$1(inp);
      } else {
        let model2;
        if (!inp.endsWith(")")) {
          return true;
        } else if (hasAlpha.value !== true && inp.startsWith("rgb(")) {
          model2 = inp.substring(4, inp.length - 1).split(",").map((n) => parseInt(n, 10));
          if (model2.length !== 3 || !/^rgb\([0-9]{1,3},[0-9]{1,3},[0-9]{1,3}\)$/.test(inp)) {
            return true;
          }
        } else if (hasAlpha.value === true && inp.startsWith("rgba(")) {
          model2 = inp.substring(5, inp.length - 1).split(",");
          if (model2.length !== 4 || !/^rgba\([0-9]{1,3},[0-9]{1,3},[0-9]{1,3},(0|0\.[0-9]+[1-9]|0\.[1-9]+|1)\)$/.test(inp)) {
            return true;
          }
          for (let i22 = 0; i22 < 3; i22++) {
            const v2 = parseInt(model2[i22], 10);
            if (v2 < 0 || v2 > 255) {
              return true;
            }
            model2[i22] = v2;
          }
          const v = parseFloat(model2[3]);
          if (v < 0 || v > 1) {
            return true;
          }
          model2[3] = v;
        } else {
          return true;
        }
        if (model2[0] < 0 || model2[0] > 255 || model2[1] < 0 || model2[1] > 255 || model2[2] < 0 || model2[2] > 255 || hasAlpha.value === true && (model2[3] < 0 || model2[3] > 1)) {
          return true;
        }
        rgb2 = {
          r: model2[0],
          g: model2[1],
          b: model2[2],
          a: hasAlpha.value === true ? model2[3] * 100 : void 0
        };
      }
      const hsv = rgbToHsv$1(rgb2);
      model.value.h = hsv.h;
      model.value.s = hsv.s;
      model.value.v = hsv.v;
      updateModel2(rgb2, change);
      if (change !== true) {
        const index2 = evt.target.selectionEnd;
        nextTick(() => {
          evt.target.setSelectionRange(index2, index2);
        });
      }
    }
    function onPalettePick(color2) {
      const def = parseModel(color2);
      const rgb2 = { r: def.r, g: def.g, b: def.b, a: def.a };
      if (rgb2.a === void 0) {
        rgb2.a = model.value.a;
      }
      model.value.h = def.h;
      model.value.s = def.s;
      model.value.v = def.v;
      updateModel2(rgb2, true);
    }
    function onSpectrumPan(evt) {
      if (evt.isFinal) {
        changeSpectrum(
          evt.position.left,
          evt.position.top,
          true
        );
      } else {
        onSpectrumChange(evt);
      }
    }
    const onSpectrumChange = throttle_default$1(
      (evt) => {
        changeSpectrum(evt.position.left, evt.position.top);
      },
      20
    );
    function onSpectrumClick(evt) {
      changeSpectrum(
        evt.pageX - window.pageXOffset,
        evt.pageY - window.pageYOffset,
        true
      );
    }
    function onActivate(evt) {
      changeSpectrum(
        evt.pageX - window.pageXOffset,
        evt.pageY - window.pageYOffset
      );
    }
    function updateErrorIcon(val) {
      if (errorIconRef.value !== null) {
        errorIconRef.value.$el.style.opacity = val ? 1 : 0;
      }
    }
    function setTopView(val) {
      topView.value = val;
    }
    function getHeader() {
      const child = [];
      props4.noHeaderTabs !== true && child.push(
        h(QTabs_default$1, {
          class: "q-color-picker__header-tabs",
          modelValue: topView.value,
          dense: true,
          align: "justify",
          "onUpdate:modelValue": setTopView
        }, () => [
          h(QTab_default$1, {
            label: "HEX" + (hasAlpha.value === true ? "A" : ""),
            name: "hex",
            ripple: false
          }),
          h(QTab_default$1, {
            label: "RGB" + (hasAlpha.value === true ? "A" : ""),
            name: "rgb",
            ripple: false
          })
        ])
      );
      child.push(
        h("div", {
          class: "q-color-picker__header-banner row flex-center no-wrap"
        }, [
          h("input", {
            class: "fit",
            value: model.value[topView.value],
            ...editable.value !== true ? { readonly: true } : {},
            ...getCache("topIn", {
              onInput: (evt) => {
                updateErrorIcon(onEditorChange(evt) === true);
              },
              onChange: stop$1,
              onBlur: (evt) => {
                onEditorChange(evt, true) === true && proxy.$forceUpdate();
                updateErrorIcon(false);
              }
            })
          }),
          h(QIcon_default$1, {
            ref: errorIconRef,
            class: "q-color-picker__error-icon absolute no-pointer-events",
            name: $q.iconSet.type.negative
          })
        ])
      );
      return h("div", {
        class: "q-color-picker__header relative-position overflow-hidden"
      }, [
        h("div", { class: "q-color-picker__header-bg absolute-full" }),
        h("div", {
          class: headerClass.value,
          style: currentBgColor.value
        }, child)
      ]);
    }
    function getContent() {
      return h(QTabPanels_default$1, {
        modelValue: view.value,
        animated: true
      }, () => [
        h(QTabPanel_default$1, {
          class: "q-color-picker__spectrum-tab overflow-hidden",
          name: "spectrum"
        }, getSpectrumTab),
        h(QTabPanel_default$1, {
          class: "q-pa-md q-color-picker__tune-tab",
          name: "tune"
        }, getTuneTab),
        h(QTabPanel_default$1, {
          class: "q-color-picker__palette-tab",
          name: "palette"
        }, getPaletteTab)
      ]);
    }
    function setView(val) {
      view.value = val;
    }
    function getFooter() {
      return h("div", {
        class: "q-color-picker__footer relative-position overflow-hidden"
      }, [
        h(QTabs_default$1, {
          class: "absolute-full",
          modelValue: view.value,
          dense: true,
          align: "justify",
          "onUpdate:modelValue": setView
        }, () => [
          h(QTab_default$1, {
            icon: $q.iconSet.colorPicker.spectrum,
            name: "spectrum",
            ripple: false
          }),
          h(QTab_default$1, {
            icon: $q.iconSet.colorPicker.tune,
            name: "tune",
            ripple: false
          }),
          h(QTab_default$1, {
            icon: $q.iconSet.colorPicker.palette,
            name: "palette",
            ripple: false
          })
        ])
      ]);
    }
    function getSpectrumTab() {
      const data = {
        ref: spectrumRef,
        class: "q-color-picker__spectrum non-selectable relative-position cursor-pointer" + (editable.value !== true ? " readonly" : ""),
        style: spectrumStyle.value,
        ...editable.value === true ? {
          onClick: onSpectrumClick,
          onMousedown: onActivate
        } : {}
      };
      const child = [
        h("div", { style: { paddingBottom: "100%" } }),
        h("div", { class: "q-color-picker__spectrum-white absolute-full" }),
        h("div", { class: "q-color-picker__spectrum-black absolute-full" }),
        h("div", {
          class: "absolute",
          style: spectrumPointerStyle.value
        }, [
          model.value.hex !== void 0 ? h("div", { class: "q-color-picker__spectrum-circle" }) : null
        ])
      ];
      const sliders = [
        h(QSlider_default$1, {
          class: "q-color-picker__hue non-selectable",
          modelValue: model.value.h,
          min: 0,
          max: 360,
          trackSize: "8px",
          innerTrackColor: "transparent",
          selectionColor: "transparent",
          readonly: editable.value !== true,
          thumbPath: thumbPath$1,
          "onUpdate:modelValue": onHue,
          onChange: onHueChange
        })
      ];
      hasAlpha.value === true && sliders.push(
        h(QSlider_default$1, {
          class: "q-color-picker__alpha non-selectable",
          modelValue: model.value.a,
          min: 0,
          max: 100,
          trackSize: "8px",
          trackColor: "white",
          innerTrackColor: "transparent",
          selectionColor: "transparent",
          trackImg: alphaTrackImg$1,
          readonly: editable.value !== true,
          hideSelection: true,
          thumbPath: thumbPath$1,
          ...getCache("alphaSlide", {
            "onUpdate:modelValue": (value2) => onNumericChange(value2, "a", 100),
            onChange: (value2) => onNumericChange(value2, "a", 100, void 0, true)
          })
        })
      );
      return [
        hDir$1("div", data, child, "spec", editable.value, () => spectrumDirective.value),
        h("div", { class: "q-color-picker__sliders" }, sliders)
      ];
    }
    function getTuneTab() {
      return [
        h("div", { class: "row items-center no-wrap" }, [
          h("div", "R"),
          h(QSlider_default$1, {
            modelValue: model.value.r,
            min: 0,
            max: 255,
            color: "red",
            dark: isDark.value,
            readonly: editable.value !== true,
            ...getCache("rSlide", {
              "onUpdate:modelValue": (value2) => onNumericChange(value2, "r", 255),
              onChange: (value2) => onNumericChange(value2, "r", 255, void 0, true)
            })
          }),
          h("input", {
            value: model.value.r,
            maxlength: 3,
            readonly: editable.value !== true,
            onChange: stop$1,
            ...getCache("rIn", {
              onInput: (evt) => onNumericChange(evt.target.value, "r", 255, evt),
              onBlur: (evt) => onNumericChange(evt.target.value, "r", 255, evt, true)
            })
          })
        ]),
        h("div", { class: "row items-center no-wrap" }, [
          h("div", "G"),
          h(QSlider_default$1, {
            modelValue: model.value.g,
            min: 0,
            max: 255,
            color: "green",
            dark: isDark.value,
            readonly: editable.value !== true,
            ...getCache("gSlide", {
              "onUpdate:modelValue": (value2) => onNumericChange(value2, "g", 255),
              onChange: (value2) => onNumericChange(value2, "g", 255, void 0, true)
            })
          }),
          h("input", {
            value: model.value.g,
            maxlength: 3,
            readonly: editable.value !== true,
            onChange: stop$1,
            ...getCache("gIn", {
              onInput: (evt) => onNumericChange(evt.target.value, "g", 255, evt),
              onBlur: (evt) => onNumericChange(evt.target.value, "g", 255, evt, true)
            })
          })
        ]),
        h("div", { class: "row items-center no-wrap" }, [
          h("div", "B"),
          h(QSlider_default$1, {
            modelValue: model.value.b,
            min: 0,
            max: 255,
            color: "blue",
            readonly: editable.value !== true,
            dark: isDark.value,
            ...getCache("bSlide", {
              "onUpdate:modelValue": (value2) => onNumericChange(value2, "b", 255),
              onChange: (value2) => onNumericChange(value2, "b", 255, void 0, true)
            })
          }),
          h("input", {
            value: model.value.b,
            maxlength: 3,
            readonly: editable.value !== true,
            onChange: stop$1,
            ...getCache("bIn", {
              onInput: (evt) => onNumericChange(evt.target.value, "b", 255, evt),
              onBlur: (evt) => onNumericChange(evt.target.value, "b", 255, evt, true)
            })
          })
        ]),
        hasAlpha.value === true ? h("div", { class: "row items-center no-wrap" }, [
          h("div", "A"),
          h(QSlider_default$1, {
            modelValue: model.value.a,
            color: "grey",
            readonly: editable.value !== true,
            dark: isDark.value,
            ...getCache("aSlide", {
              "onUpdate:modelValue": (value2) => onNumericChange(value2, "a", 100),
              onChange: (value2) => onNumericChange(value2, "a", 100, void 0, true)
            })
          }),
          h("input", {
            value: model.value.a,
            maxlength: 3,
            readonly: editable.value !== true,
            onChange: stop$1,
            ...getCache("aIn", {
              onInput: (evt) => onNumericChange(evt.target.value, "a", 100, evt),
              onBlur: (evt) => onNumericChange(evt.target.value, "a", 100, evt, true)
            })
          })
        ]) : null
      ];
    }
    function getPaletteTab() {
      const fn = (color2) => h("div", {
        class: "q-color-picker__cube col-auto",
        style: { backgroundColor: color2 },
        ...editable.value === true ? getCache("palette#" + color2, {
          onClick: () => {
            onPalettePick(color2);
          }
        }) : {}
      });
      return [
        h("div", {
          class: "row items-center q-color-picker__palette-rows" + (editable.value === true ? " q-color-picker__palette-rows--editable" : "")
        }, computedPalette.value.map(fn))
      ];
    }
    return () => {
      const child = [getContent()];
      if (props4.name !== void 0 && props4.disable !== true) {
        injectFormInput(child, "push");
      }
      props4.noHeader !== true && child.unshift(
        getHeader()
      );
      props4.noFooter !== true && child.push(
        getFooter()
      );
      return h("div", {
        class: classes.value,
        ...attributes.value
      }, child);
    };
  }
});
var breaks$1 = [
  -61,
  9,
  38,
  199,
  426,
  686,
  756,
  818,
  1111,
  1181,
  1210,
  1635,
  2060,
  2097,
  2192,
  2262,
  2324,
  2394,
  2456,
  3178
];
function toJalaali$1(gy, gm, gd) {
  if (Object.prototype.toString.call(gy) === "[object Date]") {
    gd = gy.getDate();
    gm = gy.getMonth() + 1;
    gy = gy.getFullYear();
  }
  return d2j$1(g2d$1(gy, gm, gd));
}
function toGregorian$1(jy, jm, jd) {
  return d2g$1(j2d$1(jy, jm, jd));
}
function isLeapJalaaliYear$1(jy) {
  return jalCalLeap$1(jy) === 0;
}
function jalaaliMonthLength$1(jy, jm) {
  if (jm <= 6) return 31;
  if (jm <= 11) return 30;
  if (isLeapJalaaliYear$1(jy)) return 30;
  return 29;
}
function jalCalLeap$1(jy) {
  const bl = breaks$1.length;
  let jp = breaks$1[0], jm, jump, leap, n, i22;
  if (jy < jp || jy >= breaks$1[bl - 1]) {
    throw new Error("Invalid Jalaali year " + jy);
  }
  for (i22 = 1; i22 < bl; i22 += 1) {
    jm = breaks$1[i22];
    jump = jm - jp;
    if (jy < jm) {
      break;
    }
    jp = jm;
  }
  n = jy - jp;
  if (jump - n < 6) {
    n = n - jump + div$1(jump + 4, 33) * 33;
  }
  leap = mod$1(mod$1(n + 1, 33) - 1, 4);
  if (leap === -1) {
    leap = 4;
  }
  return leap;
}
function jalCal$1(jy, withoutLeap) {
  const bl = breaks$1.length, gy = jy + 621;
  let leapJ = -14, jp = breaks$1[0], jm, jump, leap, n, i22;
  if (jy < jp || jy >= breaks$1[bl - 1]) {
    throw new Error("Invalid Jalaali year " + jy);
  }
  for (i22 = 1; i22 < bl; i22 += 1) {
    jm = breaks$1[i22];
    jump = jm - jp;
    if (jy < jm) {
      break;
    }
    leapJ = leapJ + div$1(jump, 33) * 8 + div$1(mod$1(jump, 33), 4);
    jp = jm;
  }
  n = jy - jp;
  leapJ = leapJ + div$1(n, 33) * 8 + div$1(mod$1(n, 33) + 3, 4);
  if (mod$1(jump, 33) === 4 && jump - n === 4) {
    leapJ += 1;
  }
  const leapG = div$1(gy, 4) - div$1((div$1(gy, 100) + 1) * 3, 4) - 150;
  const march = 20 + leapJ - leapG;
  if (!withoutLeap) {
    if (jump - n < 6) {
      n = n - jump + div$1(jump + 4, 33) * 33;
    }
    leap = mod$1(mod$1(n + 1, 33) - 1, 4);
    if (leap === -1) {
      leap = 4;
    }
  }
  return {
    leap,
    gy,
    march
  };
}
function j2d$1(jy, jm, jd) {
  const r = jalCal$1(jy, true);
  return g2d$1(r.gy, 3, r.march) + (jm - 1) * 31 - div$1(jm, 7) * (jm - 7) + jd - 1;
}
function d2j$1(jdn) {
  const gy = d2g$1(jdn).gy;
  let jy = gy - 621, jd, jm, k22;
  const r = jalCal$1(jy, false), jdn1f = g2d$1(gy, 3, r.march);
  k22 = jdn - jdn1f;
  if (k22 >= 0) {
    if (k22 <= 185) {
      jm = 1 + div$1(k22, 31);
      jd = mod$1(k22, 31) + 1;
      return {
        jy,
        jm,
        jd
      };
    } else {
      k22 -= 186;
    }
  } else {
    jy -= 1;
    k22 += 179;
    if (r.leap === 1) {
      k22 += 1;
    }
  }
  jm = 7 + div$1(k22, 30);
  jd = mod$1(k22, 30) + 1;
  return {
    jy,
    jm,
    jd
  };
}
function g2d$1(gy, gm, gd) {
  let d32 = div$1((gy + div$1(gm - 8, 6) + 100100) * 1461, 4) + div$1(153 * mod$1(gm + 9, 12) + 2, 5) + gd - 34840408;
  d32 = d32 - div$1(div$1(gy + 100100 + div$1(gm - 8, 6), 100) * 3, 4) + 752;
  return d32;
}
function d2g$1(jdn) {
  let j = 4 * jdn + 139361631;
  j = j + div$1(div$1(4 * jdn + 183187720, 146097) * 3, 4) * 4 - 3908;
  const i22 = div$1(mod$1(j, 1461), 4) * 5 + 308, gd = div$1(mod$1(i22, 153), 5) + 1, gm = mod$1(div$1(i22, 153), 12) + 1, gy = div$1(j, 1461) - 100100 + div$1(8 - gm, 6);
  return {
    gy,
    gm,
    gd
  };
}
function div$1(a32, b22) {
  return ~~(a32 / b22);
}
function mod$1(a32, b22) {
  return a32 - ~~(a32 / b22) * b22;
}
var calendars$1 = ["gregorian", "persian"];
var useDatetimeProps$1 = {
  // should define modelValue in the target component
  mask: {
    type: String
  },
  locale: Object,
  calendar: {
    type: String,
    validator: (v) => calendars$1.includes(v),
    default: "gregorian"
  },
  landscape: Boolean,
  color: String,
  textColor: String,
  square: Boolean,
  flat: Boolean,
  bordered: Boolean,
  readonly: Boolean,
  disable: Boolean
};
var useDatetimeEmits$1 = ["update:modelValue"];
function getDayHash$1(date) {
  return date.year + "/" + pad$1(date.month) + "/" + pad$1(date.day);
}
function use_datetime_default$1(props4, $q) {
  const editable = computed(() => {
    return props4.disable !== true && props4.readonly !== true;
  });
  const tabindex = computed(() => {
    return editable.value === true ? 0 : -1;
  });
  const headerClass = computed(() => {
    const cls = [];
    props4.color !== void 0 && cls.push(`bg-${props4.color}`);
    props4.textColor !== void 0 && cls.push(`text-${props4.textColor}`);
    return cls.join(" ");
  });
  function getLocale2() {
    return props4.locale !== void 0 ? { ...$q.lang.date, ...props4.locale } : $q.lang.date;
  }
  function getCurrentDate(dateOnly) {
    const d32 = /* @__PURE__ */ new Date();
    const timeFill = dateOnly === true ? null : 0;
    if (props4.calendar === "persian") {
      const jDate = toJalaali$1(d32);
      return {
        year: jDate.jy,
        month: jDate.jm,
        day: jDate.jd
      };
    }
    return {
      year: d32.getFullYear(),
      month: d32.getMonth() + 1,
      day: d32.getDate(),
      hour: timeFill,
      minute: timeFill,
      second: timeFill,
      millisecond: timeFill
    };
  }
  return {
    editable,
    tabindex,
    headerClass,
    getLocale: getLocale2,
    getCurrentDate
  };
}
var MILLISECONDS_IN_DAY$3 = 864e5;
var MILLISECONDS_IN_HOUR$1 = 36e5;
var MILLISECONDS_IN_MINUTE$1 = 6e4;
var defaultMask$1 = "YYYY-MM-DDTHH:mm:ss.SSSZ";
var token$1 = /\[((?:[^\]\\]|\\]|\\)*)\]|do|d{1,4}|Mo|M{1,4}|m{1,2}|wo|w{1,2}|Qo|Do|DDDo|D{1,4}|YY(?:YY)?|H{1,2}|h{1,2}|s{1,2}|S{1,3}|Z{1,2}|a{1,2}|[AQExX]/g;
var reverseToken$1 = /(\[[^\]]*\])|do|d{1,4}|Mo|M{1,4}|m{1,2}|wo|w{1,2}|Qo|Do|DDDo|D{1,4}|YY(?:YY)?|H{1,2}|h{1,2}|s{1,2}|S{1,3}|Z{1,2}|a{1,2}|[AQExX]|([.*+:?^,\s${}()|\\]+)/g;
var regexStore$1 = {};
function getRegexData$1(mask, dateLocale) {
  const days = "(" + dateLocale.days.join("|") + ")", key = mask + days;
  if (regexStore$1[key] !== void 0) {
    return regexStore$1[key];
  }
  const daysShort = "(" + dateLocale.daysShort.join("|") + ")", months = "(" + dateLocale.months.join("|") + ")", monthsShort = "(" + dateLocale.monthsShort.join("|") + ")";
  const map2 = {};
  let index2 = 0;
  const regexText = mask.replace(reverseToken$1, (match2) => {
    index2++;
    switch (match2) {
      case "YY":
        map2.YY = index2;
        return "(-?\\d{1,2})";
      case "YYYY":
        map2.YYYY = index2;
        return "(-?\\d{1,4})";
      case "M":
        map2.M = index2;
        return "(\\d{1,2})";
      case "Mo":
        map2.M = index2++;
        return "(\\d{1,2}(st|nd|rd|th))";
      case "MM":
        map2.M = index2;
        return "(\\d{2})";
      case "MMM":
        map2.MMM = index2;
        return monthsShort;
      case "MMMM":
        map2.MMMM = index2;
        return months;
      case "D":
        map2.D = index2;
        return "(\\d{1,2})";
      case "Do":
        map2.D = index2++;
        return "(\\d{1,2}(st|nd|rd|th))";
      case "DD":
        map2.D = index2;
        return "(\\d{2})";
      case "H":
        map2.H = index2;
        return "(\\d{1,2})";
      case "HH":
        map2.H = index2;
        return "(\\d{2})";
      case "h":
        map2.h = index2;
        return "(\\d{1,2})";
      case "hh":
        map2.h = index2;
        return "(\\d{2})";
      case "m":
        map2.m = index2;
        return "(\\d{1,2})";
      case "mm":
        map2.m = index2;
        return "(\\d{2})";
      case "s":
        map2.s = index2;
        return "(\\d{1,2})";
      case "ss":
        map2.s = index2;
        return "(\\d{2})";
      case "S":
        map2.S = index2;
        return "(\\d{1})";
      case "SS":
        map2.S = index2;
        return "(\\d{2})";
      case "SSS":
        map2.S = index2;
        return "(\\d{3})";
      case "A":
        map2.A = index2;
        return "(AM|PM)";
      case "a":
        map2.a = index2;
        return "(am|pm)";
      case "aa":
        map2.aa = index2;
        return "(a\\.m\\.|p\\.m\\.)";
      case "ddd":
        return daysShort;
      case "dddd":
        return days;
      case "Q":
      case "d":
      case "E":
        return "(\\d{1})";
      case "do":
        index2++;
        return "(\\d{1}(st|nd|rd|th))";
      case "Qo":
        return "(1st|2nd|3rd|4th)";
      case "DDD":
      case "DDDD":
        return "(\\d{1,3})";
      case "DDDo":
        index2++;
        return "(\\d{1,3}(st|nd|rd|th))";
      case "w":
        return "(\\d{1,2})";
      case "wo":
        index2++;
        return "(\\d{1,2}(st|nd|rd|th))";
      case "ww":
        return "(\\d{2})";
      case "Z":
        map2.Z = index2;
        return "(Z|[+-]\\d{2}:\\d{2})";
      case "ZZ":
        map2.ZZ = index2;
        return "(Z|[+-]\\d{2}\\d{2})";
      case "X":
        map2.X = index2;
        return "(-?\\d+)";
      case "x":
        map2.x = index2;
        return "(-?\\d{4,})";
      default:
        index2--;
        if (match2[0] === "[") {
          match2 = match2.substring(1, match2.length - 1);
        }
        return match2.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
  });
  const res = { map: map2, regex: new RegExp("^" + regexText) };
  regexStore$1[key] = res;
  return res;
}
function getDateLocale$1(paramDateLocale, langProps) {
  return paramDateLocale !== void 0 ? paramDateLocale : langProps !== void 0 ? langProps.date : en_US_default$1.date;
}
function formatTimezone$2(offset2, delimeter = "") {
  const sign2 = offset2 > 0 ? "-" : "+", absOffset = Math.abs(offset2), hours = Math.floor(absOffset / 60), minutes = absOffset % 60;
  return sign2 + pad$1(hours) + delimeter + pad$1(minutes);
}
function __splitDate$1(str, mask, dateLocale, calendar, defaultModel) {
  const date = {
    year: null,
    month: null,
    day: null,
    hour: null,
    minute: null,
    second: null,
    millisecond: null,
    timezoneOffset: null,
    dateHash: null,
    timeHash: null
  };
  defaultModel !== void 0 && Object.assign(date, defaultModel);
  if (str === void 0 || str === null || str === "" || typeof str !== "string") {
    return date;
  }
  if (mask === void 0) {
    mask = defaultMask$1;
  }
  const langOpts = getDateLocale$1(dateLocale, Lang_default$1.props), months = langOpts.months, monthsShort = langOpts.monthsShort;
  const { regex, map: map2 } = getRegexData$1(mask, langOpts);
  const match2 = str.match(regex);
  if (match2 === null) {
    return date;
  }
  let tzString = "";
  if (map2.X !== void 0 || map2.x !== void 0) {
    const stamp = parseInt(match2[map2.X !== void 0 ? map2.X : map2.x], 10);
    if (isNaN(stamp) === true || stamp < 0) {
      return date;
    }
    const d32 = new Date(stamp * (map2.X !== void 0 ? 1e3 : 1));
    date.year = d32.getFullYear();
    date.month = d32.getMonth() + 1;
    date.day = d32.getDate();
    date.hour = d32.getHours();
    date.minute = d32.getMinutes();
    date.second = d32.getSeconds();
    date.millisecond = d32.getMilliseconds();
  } else {
    if (map2.YYYY !== void 0) {
      date.year = parseInt(match2[map2.YYYY], 10);
    } else if (map2.YY !== void 0) {
      const y32 = parseInt(match2[map2.YY], 10);
      date.year = y32 < 0 ? y32 : 2e3 + y32;
    }
    if (map2.M !== void 0) {
      date.month = parseInt(match2[map2.M], 10);
      if (date.month < 1 || date.month > 12) {
        return date;
      }
    } else if (map2.MMM !== void 0) {
      date.month = monthsShort.indexOf(match2[map2.MMM]) + 1;
    } else if (map2.MMMM !== void 0) {
      date.month = months.indexOf(match2[map2.MMMM]) + 1;
    }
    if (map2.D !== void 0) {
      date.day = parseInt(match2[map2.D], 10);
      if (date.year === null || date.month === null || date.day < 1) {
        return date;
      }
      const maxDay = calendar !== "persian" ? new Date(date.year, date.month, 0).getDate() : jalaaliMonthLength$1(date.year, date.month);
      if (date.day > maxDay) {
        return date;
      }
    }
    if (map2.H !== void 0) {
      date.hour = parseInt(match2[map2.H], 10) % 24;
    } else if (map2.h !== void 0) {
      date.hour = parseInt(match2[map2.h], 10) % 12;
      if (map2.A && match2[map2.A] === "PM" || map2.a && match2[map2.a] === "pm" || map2.aa && match2[map2.aa] === "p.m.") {
        date.hour += 12;
      }
      date.hour = date.hour % 24;
    }
    if (map2.m !== void 0) {
      date.minute = parseInt(match2[map2.m], 10) % 60;
    }
    if (map2.s !== void 0) {
      date.second = parseInt(match2[map2.s], 10) % 60;
    }
    if (map2.S !== void 0) {
      date.millisecond = parseInt(match2[map2.S], 10) * 10 ** (3 - match2[map2.S].length);
    }
    if (map2.Z !== void 0 || map2.ZZ !== void 0) {
      tzString = map2.Z !== void 0 ? match2[map2.Z].replace(":", "") : match2[map2.ZZ];
      date.timezoneOffset = (tzString[0] === "+" ? -1 : 1) * (60 * tzString.slice(1, 3) + 1 * tzString.slice(3, 5));
    }
  }
  date.dateHash = pad$1(date.year, 6) + "/" + pad$1(date.month) + "/" + pad$1(date.day);
  date.timeHash = pad$1(date.hour) + ":" + pad$1(date.minute) + ":" + pad$1(date.second) + tzString;
  return date;
}
function getWeekOfYear$1(date) {
  const thursday = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  thursday.setDate(thursday.getDate() - (thursday.getDay() + 6) % 7 + 3);
  const firstThursday = new Date(thursday.getFullYear(), 0, 4);
  firstThursday.setDate(firstThursday.getDate() - (firstThursday.getDay() + 6) % 7 + 3);
  const ds = thursday.getTimezoneOffset() - firstThursday.getTimezoneOffset();
  thursday.setHours(thursday.getHours() - ds);
  const weekDiff = (thursday - firstThursday) / (MILLISECONDS_IN_DAY$3 * 7);
  return 1 + Math.floor(weekDiff);
}
function startOfDate$1(date, unit, utc) {
  const t22 = new Date(date), prefix = `set${""}`;
  switch (unit) {
    case "year":
    case "years":
      t22[`${prefix}Month`](0);
    case "month":
    case "months":
      t22[`${prefix}Date`](1);
    case "day":
    case "days":
    case "date":
      t22[`${prefix}Hours`](0);
    case "hour":
    case "hours":
      t22[`${prefix}Minutes`](0);
    case "minute":
    case "minutes":
      t22[`${prefix}Seconds`](0);
    case "second":
    case "seconds":
      t22[`${prefix}Milliseconds`](0);
  }
  return t22;
}
function getDiff$1(t22, sub, interval) {
  return (t22.getTime() - t22.getTimezoneOffset() * MILLISECONDS_IN_MINUTE$1 - (sub.getTime() - sub.getTimezoneOffset() * MILLISECONDS_IN_MINUTE$1)) / interval;
}
function getDateDiff$1(date, subtract, unit = "days") {
  const t22 = new Date(date), sub = new Date(subtract);
  switch (unit) {
    case "years":
    case "year":
      return t22.getFullYear() - sub.getFullYear();
    case "months":
    case "month":
      return (t22.getFullYear() - sub.getFullYear()) * 12 + t22.getMonth() - sub.getMonth();
    case "days":
    case "day":
    case "date":
      return getDiff$1(startOfDate$1(t22, "day"), startOfDate$1(sub, "day"), MILLISECONDS_IN_DAY$3);
    case "hours":
    case "hour":
      return getDiff$1(startOfDate$1(t22, "hour"), startOfDate$1(sub, "hour"), MILLISECONDS_IN_HOUR$1);
    case "minutes":
    case "minute":
      return getDiff$1(startOfDate$1(t22, "minute"), startOfDate$1(sub, "minute"), MILLISECONDS_IN_MINUTE$1);
    case "seconds":
    case "second":
      return getDiff$1(startOfDate$1(t22, "second"), startOfDate$1(sub, "second"), 1e3);
  }
}
function getDayOfYear$1(date) {
  return getDateDiff$1(date, startOfDate$1(date, "year"), "days") + 1;
}
function getOrdinal$1(n) {
  if (n >= 11 && n <= 13) {
    return `${n}th`;
  }
  switch (n % 10) {
    case 1:
      return `${n}st`;
    case 2:
      return `${n}nd`;
    case 3:
      return `${n}rd`;
  }
  return `${n}th`;
}
var formatter$1 = {
  // Year: 00, 01, ..., 99
  YY(date, dateLocale, forcedYear) {
    const y32 = this.YYYY(date, dateLocale, forcedYear) % 100;
    return y32 >= 0 ? pad$1(y32) : "-" + pad$1(Math.abs(y32));
  },
  // Year: 1900, 1901, ..., 2099
  YYYY(date, _dateLocale, forcedYear) {
    return forcedYear !== void 0 && forcedYear !== null ? forcedYear : date.getFullYear();
  },
  // Month: 1, 2, ..., 12
  M(date) {
    return date.getMonth() + 1;
  },
  // Month: 1st, 2nd, ..., 12th
  Mo(date) {
    return getOrdinal$1(date.getMonth() + 1);
  },
  // Month: 01, 02, ..., 12
  MM(date) {
    return pad$1(date.getMonth() + 1);
  },
  // Month Short Name: Jan, Feb, ...
  MMM(date, dateLocale) {
    return dateLocale.monthsShort[date.getMonth()];
  },
  // Month Name: January, February, ...
  MMMM(date, dateLocale) {
    return dateLocale.months[date.getMonth()];
  },
  // Quarter: 1, 2, 3, 4
  Q(date) {
    return Math.ceil((date.getMonth() + 1) / 3);
  },
  // Quarter: 1st, 2nd, 3rd, 4th
  Qo(date) {
    return getOrdinal$1(this.Q(date));
  },
  // Day of month: 1, 2, ..., 31
  D(date) {
    return date.getDate();
  },
  // Day of month: 1st, 2nd, ..., 31st
  Do(date) {
    return getOrdinal$1(date.getDate());
  },
  // Day of month: 01, 02, ..., 31
  DD(date) {
    return pad$1(date.getDate());
  },
  // Day of year: 1, 2, ..., 366
  DDD(date) {
    return getDayOfYear$1(date);
  },
  // Day of year: 1st, 2nd, ..., 366th
  DDDo(date) {
    return getOrdinal$1(getDayOfYear$1(date));
  },
  // Day of year: 001, 002, ..., 366
  DDDD(date) {
    return pad$1(getDayOfYear$1(date), 3);
  },
  // Day of week: 0, 1, ..., 6
  d(date) {
    return date.getDay();
  },
  // Day of week: 0th, 1st, ..., 6th
  do(date) {
    return getOrdinal$1(date.getDay());
  },
  // Day of week: Su, Mo, ...
  dd(date, dateLocale) {
    return dateLocale.days[date.getDay()].slice(0, 2);
  },
  // Day of week: Sun, Mon, ...
  ddd(date, dateLocale) {
    return dateLocale.daysShort[date.getDay()];
  },
  // Day of week: Sunday, Monday, ...
  dddd(date, dateLocale) {
    return dateLocale.days[date.getDay()];
  },
  // Day of ISO week: 1, 2, ..., 7
  E(date) {
    return date.getDay() || 7;
  },
  // Week of Year: 1 2 ... 52 53
  w(date) {
    return getWeekOfYear$1(date);
  },
  // Week of Year: 1st 2nd ... 52nd 53rd
  wo(date) {
    return getOrdinal$1(getWeekOfYear$1(date));
  },
  // Week of Year: 01 02 ... 52 53
  ww(date) {
    return pad$1(getWeekOfYear$1(date));
  },
  // Hour: 0, 1, ... 23
  H(date) {
    return date.getHours();
  },
  // Hour: 00, 01, ..., 23
  HH(date) {
    return pad$1(date.getHours());
  },
  // Hour: 1, 2, ..., 12
  h(date) {
    const hours = date.getHours();
    return hours === 0 ? 12 : hours > 12 ? hours % 12 : hours;
  },
  // Hour: 01, 02, ..., 12
  hh(date) {
    return pad$1(this.h(date));
  },
  // Minute: 0, 1, ..., 59
  m(date) {
    return date.getMinutes();
  },
  // Minute: 00, 01, ..., 59
  mm(date) {
    return pad$1(date.getMinutes());
  },
  // Second: 0, 1, ..., 59
  s(date) {
    return date.getSeconds();
  },
  // Second: 00, 01, ..., 59
  ss(date) {
    return pad$1(date.getSeconds());
  },
  // 1/10 of second: 0, 1, ..., 9
  S(date) {
    return Math.floor(date.getMilliseconds() / 100);
  },
  // 1/100 of second: 00, 01, ..., 99
  SS(date) {
    return pad$1(Math.floor(date.getMilliseconds() / 10));
  },
  // Millisecond: 000, 001, ..., 999
  SSS(date) {
    return pad$1(date.getMilliseconds(), 3);
  },
  // Meridiem: AM, PM
  A(date) {
    return date.getHours() < 12 ? "AM" : "PM";
  },
  // Meridiem: am, pm
  a(date) {
    return date.getHours() < 12 ? "am" : "pm";
  },
  // Meridiem: a.m., p.m.
  aa(date) {
    return date.getHours() < 12 ? "a.m." : "p.m.";
  },
  // Timezone: -01:00, +00:00, ... +12:00
  Z(date, _dateLocale, _forcedYear, forcedTimezoneOffset) {
    const tzOffset = forcedTimezoneOffset === void 0 || forcedTimezoneOffset === null ? date.getTimezoneOffset() : forcedTimezoneOffset;
    return formatTimezone$2(tzOffset, ":");
  },
  // Timezone: -0100, +0000, ... +1200
  ZZ(date, _dateLocale, _forcedYear, forcedTimezoneOffset) {
    const tzOffset = forcedTimezoneOffset === void 0 || forcedTimezoneOffset === null ? date.getTimezoneOffset() : forcedTimezoneOffset;
    return formatTimezone$2(tzOffset);
  },
  // Seconds timestamp: 512969520
  X(date) {
    return Math.floor(date.getTime() / 1e3);
  },
  // Milliseconds timestamp: 512969520900
  x(date) {
    return date.getTime();
  }
};
function formatDate$2(val, mask, dateLocale, __forcedYear, __forcedTimezoneOffset) {
  if (val !== 0 && !val || val === Infinity || val === -Infinity) {
    return;
  }
  const date = new Date(val);
  if (isNaN(date)) {
    return;
  }
  if (mask === void 0) {
    mask = defaultMask$1;
  }
  const locale2 = getDateLocale$1(dateLocale, Lang_default$1.props);
  return mask.replace(
    token$1,
    (match2, text2) => match2 in formatter$1 ? formatter$1[match2](date, locale2, __forcedYear, __forcedTimezoneOffset) : text2 === void 0 ? match2 : text2.split("\\]").join("]")
  );
}
var yearsInterval$1 = 20;
var views$1 = ["Calendar", "Years", "Months"];
var viewIsValid$1 = (v) => views$1.includes(v);
var yearMonthValidator$1 = (v) => /^-?[\d]+\/[0-1]\d$/.test(v);
var lineStr$1 = " — ";
function getMonthHash$1(date) {
  return date.year + "/" + pad$1(date.month);
}
var QDate_default = createComponent$1({
  name: "QDate",
  props: {
    ...useDatetimeProps$1,
    ...useFormProps$1,
    ...useDarkProps$1,
    modelValue: {
      required: true,
      validator: (val) => typeof val === "string" || Array.isArray(val) === true || Object(val) === val || val === null
    },
    multiple: Boolean,
    range: Boolean,
    title: String,
    subtitle: String,
    mask: {
      ...useDatetimeProps$1.mask,
      // this mask is forced
      // when using persian calendar
      default: "YYYY/MM/DD"
    },
    defaultYearMonth: {
      type: String,
      validator: yearMonthValidator$1
    },
    yearsInMonthView: Boolean,
    events: [Array, Function],
    eventColor: [String, Function],
    emitImmediately: Boolean,
    options: [Array, Function],
    navigationMinYearMonth: {
      type: String,
      validator: yearMonthValidator$1
    },
    navigationMaxYearMonth: {
      type: String,
      validator: yearMonthValidator$1
    },
    noUnset: Boolean,
    firstDayOfWeek: [String, Number],
    todayBtn: Boolean,
    minimal: Boolean,
    defaultView: {
      type: String,
      default: "Calendar",
      validator: viewIsValid$1
    }
  },
  emits: [
    ...useDatetimeEmits$1,
    "rangeStart",
    "rangeEnd",
    "navigation"
  ],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const isDark = use_dark_default$1(props4, $q);
    const { getCache } = use_render_cache_default$1();
    const { tabindex, headerClass, getLocale: getLocale2, getCurrentDate } = use_datetime_default$1(props4, $q);
    let lastEmitValue;
    const formAttrs = useFormAttrs$1(props4);
    const injectFormInput = useFormInject$1(formAttrs);
    const blurTargetRef = ref$1(null);
    const innerMask = ref$1(getMask());
    const innerLocale = ref$1(getLocale2());
    const mask = computed(() => getMask());
    const locale2 = computed(() => getLocale2());
    const today = computed(() => getCurrentDate());
    const viewModel = ref$1(getViewModel(innerMask.value, innerLocale.value));
    const view = ref$1(props4.defaultView);
    const direction = computed(() => $q.lang.rtl === true ? "right" : "left");
    const monthDirection = ref$1(direction.value);
    const yearDirection = ref$1(direction.value);
    const year = viewModel.value.year;
    const startYear = ref$1(year - year % yearsInterval$1 - (year < 0 ? yearsInterval$1 : 0));
    const editRange = ref$1(null);
    const classes = computed(() => {
      const type2 = props4.landscape === true ? "landscape" : "portrait";
      return `q-date q-date--${type2} q-date--${type2}-${props4.minimal === true ? "minimal" : "standard"}` + (isDark.value === true ? " q-date--dark q-dark" : "") + (props4.bordered === true ? " q-date--bordered" : "") + (props4.square === true ? " q-date--square no-border-radius" : "") + (props4.flat === true ? " q-date--flat no-shadow" : "") + (props4.disable === true ? " disabled" : props4.readonly === true ? " q-date--readonly" : "");
    });
    const computedColor = computed(() => {
      return props4.color || "primary";
    });
    const computedTextColor = computed(() => {
      return props4.textColor || "white";
    });
    const isImmediate = computed(
      () => props4.emitImmediately === true && props4.multiple !== true && props4.range !== true
    );
    const normalizedModel = computed(() => Array.isArray(props4.modelValue) === true ? props4.modelValue : props4.modelValue !== null && props4.modelValue !== void 0 ? [props4.modelValue] : []);
    const daysModel = computed(
      () => normalizedModel.value.filter((date) => typeof date === "string").map((date) => decodeString(date, innerMask.value, innerLocale.value)).filter(
        (date) => date.dateHash !== null && date.day !== null && date.month !== null && date.year !== null
      )
    );
    const rangeModel = computed(() => {
      const fn = (date) => decodeString(date, innerMask.value, innerLocale.value);
      return normalizedModel.value.filter((date) => isObject$1(date) === true && date.from !== void 0 && date.to !== void 0).map((range2) => ({ from: fn(range2.from), to: fn(range2.to) })).filter((range2) => range2.from.dateHash !== null && range2.to.dateHash !== null && range2.from.dateHash < range2.to.dateHash);
    });
    const getNativeDateFn = computed(() => props4.calendar !== "persian" ? (model) => new Date(model.year, model.month - 1, model.day) : (model) => {
      const gDate = toGregorian$1(model.year, model.month, model.day);
      return new Date(gDate.gy, gDate.gm - 1, gDate.gd);
    });
    const encodeObjectFn = computed(() => props4.calendar === "persian" ? getDayHash$1 : (date, mask2, locale22) => formatDate$2(
      new Date(
        date.year,
        date.month - 1,
        date.day,
        date.hour,
        date.minute,
        date.second,
        date.millisecond
      ),
      mask2 === void 0 ? innerMask.value : mask2,
      locale22 === void 0 ? innerLocale.value : locale22,
      date.year,
      date.timezoneOffset
    ));
    const daysInModel = computed(
      () => daysModel.value.length + rangeModel.value.reduce(
        (acc, range2) => acc + 1 + getDateDiff$1(
          getNativeDateFn.value(range2.to),
          getNativeDateFn.value(range2.from)
        ),
        0
      )
    );
    const headerTitle = computed(() => {
      if (props4.title !== void 0 && props4.title !== null && props4.title.length !== 0) {
        return props4.title;
      }
      if (editRange.value !== null) {
        const model2 = editRange.value.init;
        const date2 = getNativeDateFn.value(model2);
        return innerLocale.value.daysShort[date2.getDay()] + ", " + innerLocale.value.monthsShort[model2.month - 1] + " " + model2.day + lineStr$1 + "?";
      }
      if (daysInModel.value === 0) {
        return lineStr$1;
      }
      if (daysInModel.value > 1) {
        return `${daysInModel.value} ${innerLocale.value.pluralDay}`;
      }
      const model = daysModel.value[0];
      const date = getNativeDateFn.value(model);
      if (isNaN(date.valueOf()) === true) {
        return lineStr$1;
      }
      if (innerLocale.value.headerTitle !== void 0) {
        return innerLocale.value.headerTitle(date, model);
      }
      return innerLocale.value.daysShort[date.getDay()] + ", " + innerLocale.value.monthsShort[model.month - 1] + " " + model.day;
    });
    const minSelectedModel = computed(() => {
      const model = daysModel.value.concat(rangeModel.value.map((range2) => range2.from)).sort((a32, b22) => a32.year - b22.year || a32.month - b22.month);
      return model[0];
    });
    const maxSelectedModel = computed(() => {
      const model = daysModel.value.concat(rangeModel.value.map((range2) => range2.to)).sort((a32, b22) => b22.year - a32.year || b22.month - a32.month);
      return model[0];
    });
    const headerSubtitle = computed(() => {
      if (props4.subtitle !== void 0 && props4.subtitle !== null && props4.subtitle.length !== 0) {
        return props4.subtitle;
      }
      if (daysInModel.value === 0) {
        return lineStr$1;
      }
      if (daysInModel.value > 1) {
        const from2 = minSelectedModel.value;
        const to2 = maxSelectedModel.value;
        const month = innerLocale.value.monthsShort;
        return month[from2.month - 1] + (from2.year !== to2.year ? " " + from2.year + lineStr$1 + month[to2.month - 1] + " " : from2.month !== to2.month ? lineStr$1 + month[to2.month - 1] : "") + " " + to2.year;
      }
      return daysModel.value[0].year;
    });
    const dateArrow = computed(() => {
      const val = [$q.iconSet.datetime.arrowLeft, $q.iconSet.datetime.arrowRight];
      return $q.lang.rtl === true ? val.reverse() : val;
    });
    const computedFirstDayOfWeek = computed(() => props4.firstDayOfWeek !== void 0 ? Number(props4.firstDayOfWeek) : innerLocale.value.firstDayOfWeek);
    const daysOfWeek = computed(() => {
      const days2 = innerLocale.value.daysShort, first = computedFirstDayOfWeek.value;
      return first > 0 ? days2.slice(first, 7).concat(days2.slice(0, first)) : days2;
    });
    const daysInMonth2 = computed(() => {
      const date = viewModel.value;
      return props4.calendar !== "persian" ? new Date(date.year, date.month, 0).getDate() : jalaaliMonthLength$1(date.year, date.month);
    });
    const evtColor = computed(() => typeof props4.eventColor === "function" ? props4.eventColor : () => props4.eventColor);
    const minNav = computed(() => {
      if (props4.navigationMinYearMonth === void 0) {
        return null;
      }
      const data = props4.navigationMinYearMonth.split("/");
      return { year: parseInt(data[0], 10), month: parseInt(data[1], 10) };
    });
    const maxNav = computed(() => {
      if (props4.navigationMaxYearMonth === void 0) {
        return null;
      }
      const data = props4.navigationMaxYearMonth.split("/");
      return { year: parseInt(data[0], 10), month: parseInt(data[1], 10) };
    });
    const navBoundaries = computed(() => {
      const data = {
        month: { prev: true, next: true },
        year: { prev: true, next: true }
      };
      if (minNav.value !== null && minNav.value.year >= viewModel.value.year) {
        data.year.prev = false;
        if (minNav.value.year === viewModel.value.year && minNav.value.month >= viewModel.value.month) {
          data.month.prev = false;
        }
      }
      if (maxNav.value !== null && maxNav.value.year <= viewModel.value.year) {
        data.year.next = false;
        if (maxNav.value.year === viewModel.value.year && maxNav.value.month <= viewModel.value.month) {
          data.month.next = false;
        }
      }
      return data;
    });
    const daysMap = computed(() => {
      const map2 = {};
      daysModel.value.forEach((entry) => {
        const hash = getMonthHash$1(entry);
        if (map2[hash] === void 0) {
          map2[hash] = [];
        }
        map2[hash].push(entry.day);
      });
      return map2;
    });
    const rangeMap2 = computed(() => {
      const map2 = {};
      rangeModel.value.forEach((entry) => {
        const hashFrom = getMonthHash$1(entry.from);
        const hashTo = getMonthHash$1(entry.to);
        if (map2[hashFrom] === void 0) {
          map2[hashFrom] = [];
        }
        map2[hashFrom].push({
          from: entry.from.day,
          to: hashFrom === hashTo ? entry.to.day : void 0,
          range: entry
        });
        if (hashFrom < hashTo) {
          let hash;
          const { year: year2, month } = entry.from;
          const cur = month < 12 ? { year: year2, month: month + 1 } : { year: year2 + 1, month: 1 };
          while ((hash = getMonthHash$1(cur)) <= hashTo) {
            if (map2[hash] === void 0) {
              map2[hash] = [];
            }
            map2[hash].push({
              from: void 0,
              to: hash === hashTo ? entry.to.day : void 0,
              range: entry
            });
            cur.month++;
            if (cur.month > 12) {
              cur.year++;
              cur.month = 1;
            }
          }
        }
      });
      return map2;
    });
    const rangeView = computed(() => {
      if (editRange.value === null) {
        return;
      }
      const { init, initHash, final, finalHash } = editRange.value;
      const [from2, to2] = initHash <= finalHash ? [init, final] : [final, init];
      const fromHash = getMonthHash$1(from2);
      const toHash = getMonthHash$1(to2);
      if (fromHash !== viewMonthHash.value && toHash !== viewMonthHash.value) {
        return;
      }
      const view2 = {};
      if (fromHash === viewMonthHash.value) {
        view2.from = from2.day;
        view2.includeFrom = true;
      } else {
        view2.from = 1;
      }
      if (toHash === viewMonthHash.value) {
        view2.to = to2.day;
        view2.includeTo = true;
      } else {
        view2.to = daysInMonth2.value;
      }
      return view2;
    });
    const viewMonthHash = computed(() => getMonthHash$1(viewModel.value));
    const selectionDaysMap = computed(() => {
      const map2 = {};
      if (props4.options === void 0) {
        for (let i22 = 1; i22 <= daysInMonth2.value; i22++) {
          map2[i22] = true;
        }
        return map2;
      }
      const fn = typeof props4.options === "function" ? props4.options : (date) => props4.options.includes(date);
      for (let i22 = 1; i22 <= daysInMonth2.value; i22++) {
        const dayHash = viewMonthHash.value + "/" + pad$1(i22);
        map2[i22] = fn(dayHash);
      }
      return map2;
    });
    const eventDaysMap = computed(() => {
      const map2 = {};
      if (props4.events === void 0) {
        for (let i22 = 1; i22 <= daysInMonth2.value; i22++) {
          map2[i22] = false;
        }
      } else {
        const fn = typeof props4.events === "function" ? props4.events : (date) => props4.events.includes(date);
        for (let i22 = 1; i22 <= daysInMonth2.value; i22++) {
          const dayHash = viewMonthHash.value + "/" + pad$1(i22);
          map2[i22] = fn(dayHash) === true && evtColor.value(dayHash);
        }
      }
      return map2;
    });
    const viewDays = computed(() => {
      let date, endDay;
      const { year: year2, month } = viewModel.value;
      if (props4.calendar !== "persian") {
        date = new Date(year2, month - 1, 1);
        endDay = new Date(year2, month - 1, 0).getDate();
      } else {
        const gDate = toGregorian$1(year2, month, 1);
        date = new Date(gDate.gy, gDate.gm - 1, gDate.gd);
        let prevJM = month - 1;
        let prevJY = year2;
        if (prevJM === 0) {
          prevJM = 12;
          prevJY--;
        }
        endDay = jalaaliMonthLength$1(prevJY, prevJM);
      }
      return {
        days: date.getDay() - computedFirstDayOfWeek.value - 1,
        endDay
      };
    });
    const days = computed(() => {
      const res = [];
      const { days: days2, endDay } = viewDays.value;
      const len = days2 < 0 ? days2 + 7 : days2;
      if (len < 6) {
        for (let i22 = endDay - len; i22 <= endDay; i22++) {
          res.push({ i: i22, fill: true });
        }
      }
      const index2 = res.length;
      for (let i22 = 1; i22 <= daysInMonth2.value; i22++) {
        const day = { i: i22, event: eventDaysMap.value[i22], classes: [] };
        if (selectionDaysMap.value[i22] === true) {
          day.in = true;
          day.flat = true;
        }
        res.push(day);
      }
      if (daysMap.value[viewMonthHash.value] !== void 0) {
        daysMap.value[viewMonthHash.value].forEach((day) => {
          const i22 = index2 + day - 1;
          Object.assign(res[i22], {
            selected: true,
            unelevated: true,
            flat: false,
            color: computedColor.value,
            textColor: computedTextColor.value
          });
        });
      }
      if (rangeMap2.value[viewMonthHash.value] !== void 0) {
        rangeMap2.value[viewMonthHash.value].forEach((entry) => {
          if (entry.from !== void 0) {
            const from2 = index2 + entry.from - 1;
            const to2 = index2 + (entry.to || daysInMonth2.value) - 1;
            for (let day = from2; day <= to2; day++) {
              Object.assign(res[day], {
                range: entry.range,
                unelevated: true,
                color: computedColor.value,
                textColor: computedTextColor.value
              });
            }
            Object.assign(res[from2], {
              rangeFrom: true,
              flat: false
            });
            entry.to !== void 0 && Object.assign(res[to2], {
              rangeTo: true,
              flat: false
            });
          } else if (entry.to !== void 0) {
            const to2 = index2 + entry.to - 1;
            for (let day = index2; day <= to2; day++) {
              Object.assign(res[day], {
                range: entry.range,
                unelevated: true,
                color: computedColor.value,
                textColor: computedTextColor.value
              });
            }
            Object.assign(res[to2], {
              flat: false,
              rangeTo: true
            });
          } else {
            const to2 = index2 + daysInMonth2.value - 1;
            for (let day = index2; day <= to2; day++) {
              Object.assign(res[day], {
                range: entry.range,
                unelevated: true,
                color: computedColor.value,
                textColor: computedTextColor.value
              });
            }
          }
        });
      }
      if (rangeView.value !== void 0) {
        const from2 = index2 + rangeView.value.from - 1;
        const to2 = index2 + rangeView.value.to - 1;
        for (let day = from2; day <= to2; day++) {
          res[day].color = computedColor.value;
          res[day].editRange = true;
        }
        if (rangeView.value.includeFrom === true) {
          res[from2].editRangeFrom = true;
        }
        if (rangeView.value.includeTo === true) {
          res[to2].editRangeTo = true;
        }
      }
      if (viewModel.value.year === today.value.year && viewModel.value.month === today.value.month) {
        res[index2 + today.value.day - 1].today = true;
      }
      const left = res.length % 7;
      if (left > 0) {
        const afterDays = 7 - left;
        for (let i22 = 1; i22 <= afterDays; i22++) {
          res.push({ i: i22, fill: true });
        }
      }
      res.forEach((day) => {
        let cls = "q-date__calendar-item ";
        if (day.fill === true) {
          cls += "q-date__calendar-item--fill";
        } else {
          cls += `q-date__calendar-item--${day.in === true ? "in" : "out"}`;
          if (day.range !== void 0) {
            cls += ` q-date__range${day.rangeTo === true ? "-to" : day.rangeFrom === true ? "-from" : ""}`;
          }
          if (day.editRange === true) {
            cls += ` q-date__edit-range${day.editRangeFrom === true ? "-from" : ""}${day.editRangeTo === true ? "-to" : ""}`;
          }
          if (day.range !== void 0 || day.editRange === true) {
            cls += ` text-${day.color}`;
          }
        }
        day.classes = cls;
      });
      return res;
    });
    const attributes = computed(() => props4.disable === true ? { "aria-disabled": "true" } : {});
    watch(() => props4.modelValue, (v) => {
      if (lastEmitValue === v) {
        lastEmitValue = 0;
      } else {
        const model = getViewModel(innerMask.value, innerLocale.value);
        updateViewModel(model.year, model.month, model);
      }
    });
    watch(view, () => {
      if (blurTargetRef.value !== null && proxy.$el.contains(document.activeElement) === true) {
        blurTargetRef.value.focus();
      }
    });
    watch(() => viewModel.value.year + "|" + viewModel.value.month, () => {
      emit("navigation", { year: viewModel.value.year, month: viewModel.value.month });
    });
    watch(mask, (val) => {
      updateValue2(val, innerLocale.value, "mask");
      innerMask.value = val;
    });
    watch(locale2, (val) => {
      updateValue2(innerMask.value, val, "locale");
      innerLocale.value = val;
    });
    function setToday() {
      const { year: year2, month, day } = today.value;
      const date = {
        // contains more props than needed (hour, minute, second, millisecond)
        // but those aren't used in the processing of this "date" variable
        ...viewModel.value,
        // overwriting with today's date
        year: year2,
        month,
        day
      };
      const monthMap = daysMap.value[getMonthHash$1(date)];
      if (monthMap === void 0 || monthMap.includes(date.day) === false) {
        addToModel(date);
      }
      setCalendarTo(date.year, date.month);
    }
    function setView(viewMode) {
      if (viewIsValid$1(viewMode) === true) {
        view.value = viewMode;
      }
    }
    function offsetCalendar(type2, descending) {
      if (["month", "year"].includes(type2)) {
        const fn = type2 === "month" ? goToMonth : goToYear;
        fn(descending === true ? -1 : 1);
      }
    }
    function setCalendarTo(year2, month) {
      view.value = "Calendar";
      updateViewModel(year2, month);
    }
    function setEditingRange(from2, to2) {
      if (props4.range === false || !from2) {
        editRange.value = null;
        return;
      }
      const init = Object.assign({ ...viewModel.value }, from2);
      const final = to2 !== void 0 ? Object.assign({ ...viewModel.value }, to2) : init;
      editRange.value = {
        init,
        initHash: getDayHash$1(init),
        final,
        finalHash: getDayHash$1(final)
      };
      setCalendarTo(init.year, init.month);
    }
    function getMask() {
      return props4.calendar === "persian" ? "YYYY/MM/DD" : props4.mask;
    }
    function decodeString(date, mask2, locale22) {
      return __splitDate$1(
        date,
        mask2,
        locale22,
        props4.calendar,
        {
          hour: 0,
          minute: 0,
          second: 0,
          millisecond: 0
        }
      );
    }
    function getViewModel(mask2, locale22) {
      const model = Array.isArray(props4.modelValue) === true ? props4.modelValue : props4.modelValue ? [props4.modelValue] : [];
      if (model.length === 0) {
        return getDefaultViewModel();
      }
      const target2 = model[model.length - 1];
      const decoded = decodeString(
        target2.from !== void 0 ? target2.from : target2,
        mask2,
        locale22
      );
      return decoded.dateHash === null ? getDefaultViewModel() : decoded;
    }
    function getDefaultViewModel() {
      let year2, month;
      if (props4.defaultYearMonth !== void 0) {
        const d32 = props4.defaultYearMonth.split("/");
        year2 = parseInt(d32[0], 10);
        month = parseInt(d32[1], 10);
      } else {
        const d32 = today.value !== void 0 ? today.value : getCurrentDate();
        year2 = d32.year;
        month = d32.month;
      }
      return {
        year: year2,
        month,
        day: 1,
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
        dateHash: year2 + "/" + pad$1(month) + "/01"
      };
    }
    function goToMonth(offset2) {
      let year2 = viewModel.value.year;
      let month = Number(viewModel.value.month) + offset2;
      if (month === 13) {
        month = 1;
        year2++;
      } else if (month === 0) {
        month = 12;
        year2--;
      }
      updateViewModel(year2, month);
      isImmediate.value === true && emitImmediately("month");
    }
    function goToYear(offset2) {
      const year2 = Number(viewModel.value.year) + offset2;
      updateViewModel(year2, viewModel.value.month);
      isImmediate.value === true && emitImmediately("year");
    }
    function setYear(year2) {
      updateViewModel(year2, viewModel.value.month);
      view.value = props4.defaultView === "Years" ? "Months" : "Calendar";
      isImmediate.value === true && emitImmediately("year");
    }
    function setMonth(month) {
      updateViewModel(viewModel.value.year, month);
      view.value = "Calendar";
      isImmediate.value === true && emitImmediately("month");
    }
    function toggleDate(date, monthHash) {
      const month = daysMap.value[monthHash];
      const fn = month !== void 0 && month.includes(date.day) === true ? removeFromModel : addToModel;
      fn(date);
    }
    function getShortDate(date) {
      return { year: date.year, month: date.month, day: date.day };
    }
    function updateViewModel(year2, month, time) {
      if (minNav.value !== null && year2 <= minNav.value.year) {
        if (month < minNav.value.month || year2 < minNav.value.year) {
          month = minNav.value.month;
        }
        year2 = minNav.value.year;
      }
      if (maxNav.value !== null && year2 >= maxNav.value.year) {
        if (month > maxNav.value.month || year2 > maxNav.value.year) {
          month = maxNav.value.month;
        }
        year2 = maxNav.value.year;
      }
      if (time !== void 0) {
        const { hour, minute, second, millisecond, timezoneOffset, timeHash } = time;
        Object.assign(viewModel.value, { hour, minute, second, millisecond, timezoneOffset, timeHash });
      }
      const newHash = year2 + "/" + pad$1(month) + "/01";
      if (newHash !== viewModel.value.dateHash) {
        monthDirection.value = viewModel.value.dateHash < newHash === ($q.lang.rtl !== true) ? "left" : "right";
        if (year2 !== viewModel.value.year) {
          yearDirection.value = monthDirection.value;
        }
        nextTick(() => {
          startYear.value = year2 - year2 % yearsInterval$1 - (year2 < 0 ? yearsInterval$1 : 0);
          Object.assign(viewModel.value, {
            year: year2,
            month,
            day: 1,
            dateHash: newHash
          });
        });
      }
    }
    function emitValue(val, action, date) {
      const value2 = val !== null && val.length === 1 && props4.multiple === false ? val[0] : val;
      lastEmitValue = value2;
      const { reason, details } = getEmitParams(action, date);
      emit("update:modelValue", value2, reason, details);
    }
    function emitImmediately(reason) {
      const date = daysModel.value[0] !== void 0 && daysModel.value[0].dateHash !== null ? { ...daysModel.value[0] } : { ...viewModel.value };
      nextTick(() => {
        date.year = viewModel.value.year;
        date.month = viewModel.value.month;
        const maxDay = props4.calendar !== "persian" ? new Date(date.year, date.month, 0).getDate() : jalaaliMonthLength$1(date.year, date.month);
        date.day = Math.min(Math.max(1, date.day), maxDay);
        const value2 = encodeEntry(date);
        lastEmitValue = value2;
        const { details } = getEmitParams("", date);
        emit("update:modelValue", value2, reason, details);
      });
    }
    function getEmitParams(action, date) {
      return date.from !== void 0 ? {
        reason: `${action}-range`,
        details: {
          ...getShortDate(date.target),
          from: getShortDate(date.from),
          to: getShortDate(date.to)
        }
      } : {
        reason: `${action}-day`,
        details: getShortDate(date)
      };
    }
    function encodeEntry(date, mask2, locale22) {
      return date.from !== void 0 ? { from: encodeObjectFn.value(date.from, mask2, locale22), to: encodeObjectFn.value(date.to, mask2, locale22) } : encodeObjectFn.value(date, mask2, locale22);
    }
    function addToModel(date) {
      let value2;
      if (props4.multiple === true) {
        if (date.from !== void 0) {
          const fromHash = getDayHash$1(date.from);
          const toHash = getDayHash$1(date.to);
          const days2 = daysModel.value.filter((day) => day.dateHash < fromHash || day.dateHash > toHash);
          const ranges = rangeModel.value.filter(({ from: from2, to: to2 }) => to2.dateHash < fromHash || from2.dateHash > toHash);
          value2 = days2.concat(ranges).concat(date).map((entry) => encodeEntry(entry));
        } else {
          const model = normalizedModel.value.slice();
          model.push(encodeEntry(date));
          value2 = model;
        }
      } else {
        value2 = encodeEntry(date);
      }
      emitValue(value2, "add", date);
    }
    function removeFromModel(date) {
      if (props4.noUnset === true) {
        return;
      }
      let model = null;
      if (props4.multiple === true && Array.isArray(props4.modelValue) === true) {
        const val = encodeEntry(date);
        if (date.from !== void 0) {
          model = props4.modelValue.filter(
            (date2) => date2.from !== void 0 ? date2.from !== val.from && date2.to !== val.to : true
          );
        } else {
          model = props4.modelValue.filter((date2) => date2 !== val);
        }
        if (model.length === 0) {
          model = null;
        }
      }
      emitValue(model, "remove", date);
    }
    function updateValue2(mask2, locale22, reason) {
      const model = daysModel.value.concat(rangeModel.value).map((entry) => encodeEntry(entry, mask2, locale22)).filter((entry) => {
        return entry.from !== void 0 ? entry.from.dateHash !== null && entry.to.dateHash !== null : entry.dateHash !== null;
      });
      emit("update:modelValue", (props4.multiple === true ? model : model[0]) || null, reason);
    }
    function getHeader() {
      if (props4.minimal === true) return;
      return h("div", {
        class: "q-date__header " + headerClass.value
      }, [
        h("div", {
          class: "relative-position"
        }, [
          h(Transition, {
            name: "q-transition--fade"
          }, () => h("div", {
            key: "h-yr-" + headerSubtitle.value,
            class: "q-date__header-subtitle q-date__header-link " + (view.value === "Years" ? "q-date__header-link--active" : "cursor-pointer"),
            tabindex: tabindex.value,
            ...getCache("vY", {
              onClick() {
                view.value = "Years";
              },
              onKeyup(e22) {
                e22.keyCode === 13 && (view.value = "Years");
              }
            })
          }, [headerSubtitle.value]))
        ]),
        h("div", {
          class: "q-date__header-title relative-position flex no-wrap"
        }, [
          h("div", {
            class: "relative-position col"
          }, [
            h(Transition, {
              name: "q-transition--fade"
            }, () => h("div", {
              key: "h-sub" + headerTitle.value,
              class: "q-date__header-title-label q-date__header-link " + (view.value === "Calendar" ? "q-date__header-link--active" : "cursor-pointer"),
              tabindex: tabindex.value,
              ...getCache("vC", {
                onClick() {
                  view.value = "Calendar";
                },
                onKeyup(e22) {
                  e22.keyCode === 13 && (view.value = "Calendar");
                }
              })
            }, [headerTitle.value]))
          ]),
          props4.todayBtn === true ? h(QBtn_default$1, {
            class: "q-date__header-today self-start",
            icon: $q.iconSet.datetime.today,
            flat: true,
            size: "sm",
            round: true,
            tabindex: tabindex.value,
            onClick: setToday
          }) : null
        ])
      ]);
    }
    function getNavigation({ label, type: type2, key, dir, goTo, boundaries, cls }) {
      return [
        h("div", {
          class: "row items-center q-date__arrow"
        }, [
          h(QBtn_default$1, {
            round: true,
            dense: true,
            size: "sm",
            flat: true,
            icon: dateArrow.value[0],
            tabindex: tabindex.value,
            disable: boundaries.prev === false,
            ...getCache("go-#" + type2, { onClick() {
              goTo(-1);
            } })
          })
        ]),
        h("div", {
          class: "relative-position overflow-hidden flex flex-center" + cls
        }, [
          h(Transition, {
            name: "q-transition--jump-" + dir
          }, () => h("div", { key }, [
            h(QBtn_default$1, {
              flat: true,
              dense: true,
              noCaps: true,
              label,
              tabindex: tabindex.value,
              ...getCache("view#" + type2, { onClick: () => {
                view.value = type2;
              } })
            })
          ]))
        ]),
        h("div", {
          class: "row items-center q-date__arrow"
        }, [
          h(QBtn_default$1, {
            round: true,
            dense: true,
            size: "sm",
            flat: true,
            icon: dateArrow.value[1],
            tabindex: tabindex.value,
            disable: boundaries.next === false,
            ...getCache("go+#" + type2, { onClick() {
              goTo(1);
            } })
          })
        ])
      ];
    }
    const renderViews = {
      Calendar: () => [
        h("div", {
          key: "calendar-view",
          class: "q-date__view q-date__calendar"
        }, [
          h("div", {
            class: "q-date__navigation row items-center no-wrap"
          }, getNavigation({
            label: innerLocale.value.months[viewModel.value.month - 1],
            type: "Months",
            key: viewModel.value.month,
            dir: monthDirection.value,
            goTo: goToMonth,
            boundaries: navBoundaries.value.month,
            cls: " col"
          }).concat(getNavigation({
            label: viewModel.value.year,
            type: "Years",
            key: viewModel.value.year,
            dir: yearDirection.value,
            goTo: goToYear,
            boundaries: navBoundaries.value.year,
            cls: ""
          }))),
          h("div", {
            class: "q-date__calendar-weekdays row items-center no-wrap"
          }, daysOfWeek.value.map((day) => h("div", { class: "q-date__calendar-item" }, [h("div", day)]))),
          h("div", {
            class: "q-date__calendar-days-container relative-position overflow-hidden"
          }, [
            h(Transition, {
              name: "q-transition--slide-" + monthDirection.value
            }, () => h("div", {
              key: viewMonthHash.value,
              class: "q-date__calendar-days fit"
            }, days.value.map((day) => h("div", { class: day.classes }, [
              day.in === true ? h(
                QBtn_default$1,
                {
                  class: day.today === true ? "q-date__today" : "",
                  dense: true,
                  flat: day.flat,
                  unelevated: day.unelevated,
                  color: day.color,
                  textColor: day.textColor,
                  label: day.i,
                  tabindex: tabindex.value,
                  ...getCache("day#" + day.i, {
                    onClick: () => {
                      onDayClick(day.i);
                    },
                    onMouseover: () => {
                      onDayMouseover(day.i);
                    }
                  })
                },
                day.event !== false ? () => h("div", { class: "q-date__event bg-" + day.event }) : null
              ) : h("div", "" + day.i)
            ]))))
          ])
        ])
      ],
      Months() {
        const currentYear = viewModel.value.year === today.value.year;
        const isDisabled = (month) => {
          return minNav.value !== null && viewModel.value.year === minNav.value.year && minNav.value.month > month || maxNav.value !== null && viewModel.value.year === maxNav.value.year && maxNav.value.month < month;
        };
        const content = innerLocale.value.monthsShort.map((month, i22) => {
          const active = viewModel.value.month === i22 + 1;
          return h("div", {
            class: "q-date__months-item flex flex-center"
          }, [
            h(QBtn_default$1, {
              class: currentYear === true && today.value.month === i22 + 1 ? "q-date__today" : null,
              flat: active !== true,
              label: month,
              unelevated: active,
              color: active === true ? computedColor.value : null,
              textColor: active === true ? computedTextColor.value : null,
              tabindex: tabindex.value,
              disable: isDisabled(i22 + 1),
              ...getCache("month#" + i22, { onClick: () => {
                setMonth(i22 + 1);
              } })
            })
          ]);
        });
        props4.yearsInMonthView === true && content.unshift(
          h("div", { class: "row no-wrap full-width" }, [
            getNavigation({
              label: viewModel.value.year,
              type: "Years",
              key: viewModel.value.year,
              dir: yearDirection.value,
              goTo: goToYear,
              boundaries: navBoundaries.value.year,
              cls: " col"
            })
          ])
        );
        return h("div", {
          key: "months-view",
          class: "q-date__view q-date__months flex flex-center"
        }, content);
      },
      Years() {
        const start = startYear.value, stop2 = start + yearsInterval$1, years = [];
        const isDisabled = (year2) => {
          return minNav.value !== null && minNav.value.year > year2 || maxNav.value !== null && maxNav.value.year < year2;
        };
        for (let i22 = start; i22 <= stop2; i22++) {
          const active = viewModel.value.year === i22;
          years.push(
            h("div", {
              class: "q-date__years-item flex flex-center"
            }, [
              h(QBtn_default$1, {
                key: "yr" + i22,
                class: today.value.year === i22 ? "q-date__today" : null,
                flat: !active,
                label: i22,
                dense: true,
                unelevated: active,
                color: active === true ? computedColor.value : null,
                textColor: active === true ? computedTextColor.value : null,
                tabindex: tabindex.value,
                disable: isDisabled(i22),
                ...getCache("yr#" + i22, { onClick: () => {
                  setYear(i22);
                } })
              })
            ])
          );
        }
        return h("div", {
          class: "q-date__view q-date__years flex flex-center"
        }, [
          h("div", {
            class: "col-auto"
          }, [
            h(QBtn_default$1, {
              round: true,
              dense: true,
              flat: true,
              icon: dateArrow.value[0],
              tabindex: tabindex.value,
              disable: isDisabled(start),
              ...getCache("y-", { onClick: () => {
                startYear.value -= yearsInterval$1;
              } })
            })
          ]),
          h("div", {
            class: "q-date__years-content col self-stretch row items-center"
          }, years),
          h("div", {
            class: "col-auto"
          }, [
            h(QBtn_default$1, {
              round: true,
              dense: true,
              flat: true,
              icon: dateArrow.value[1],
              tabindex: tabindex.value,
              disable: isDisabled(stop2),
              ...getCache("y+", { onClick: () => {
                startYear.value += yearsInterval$1;
              } })
            })
          ])
        ]);
      }
    };
    function onDayClick(dayIndex) {
      const day = { ...viewModel.value, day: dayIndex };
      if (props4.range === false) {
        toggleDate(day, viewMonthHash.value);
        return;
      }
      if (editRange.value === null) {
        const dayProps = days.value.find((day2) => day2.fill !== true && day2.i === dayIndex);
        if (props4.noUnset !== true && dayProps.range !== void 0) {
          removeFromModel({ target: day, from: dayProps.range.from, to: dayProps.range.to });
          return;
        }
        if (dayProps.selected === true) {
          removeFromModel(day);
          return;
        }
        const initHash = getDayHash$1(day);
        editRange.value = {
          init: day,
          initHash,
          final: day,
          finalHash: initHash
        };
        emit("rangeStart", getShortDate(day));
      } else {
        const initHash = editRange.value.initHash, finalHash = getDayHash$1(day), payload = initHash <= finalHash ? { from: editRange.value.init, to: day } : { from: day, to: editRange.value.init };
        editRange.value = null;
        addToModel(initHash === finalHash ? day : { target: day, ...payload });
        emit("rangeEnd", {
          from: getShortDate(payload.from),
          to: getShortDate(payload.to)
        });
      }
    }
    function onDayMouseover(dayIndex) {
      if (editRange.value !== null) {
        const final = { ...viewModel.value, day: dayIndex };
        Object.assign(editRange.value, {
          final,
          finalHash: getDayHash$1(final)
        });
      }
    }
    Object.assign(proxy, {
      setToday,
      setView,
      offsetCalendar,
      setCalendarTo,
      setEditingRange
    });
    return () => {
      const content = [
        h("div", {
          class: "q-date__content col relative-position"
        }, [
          h(Transition, {
            name: "q-transition--fade"
          }, renderViews[view.value])
        ])
      ];
      const def = hSlot$1(slots.default);
      def !== void 0 && content.push(
        h("div", { class: "q-date__actions" }, def)
      );
      if (props4.name !== void 0 && props4.disable !== true) {
        injectFormInput(content, "push");
      }
      return h("div", {
        class: classes.value,
        ...attributes.value
      }, [
        getHeader(),
        h("div", {
          ref: blurTargetRef,
          class: "q-date__main col column",
          tabindex: -1
        }, content)
      ]);
    };
  }
});
function use_history_default$1(showing, hide, hideOnRouteChange) {
  function removeFromHistory() {
  }
  onBeforeUnmount(() => {
    showing.value === true && removeFromHistory();
  });
  return {
    removeFromHistory,
    addToHistory() {
    }
  };
}
var registered$1 = 0;
var scrollPositionX$1;
var scrollPositionY$1;
var maxScrollTop$1;
var vpPendingUpdate$1 = false;
var bodyLeft$1;
var bodyTop$1;
var href$1;
var closeTimer$1 = null;
function onWheel$1(e22) {
  if (shouldPreventScroll$1(e22)) {
    stopAndPrevent$1(e22);
  }
}
function shouldPreventScroll$1(e22) {
  if (e22.target === document.body || e22.target.classList.contains("q-layout__backdrop")) {
    return true;
  }
  const path = getEventPath$1(e22), shift = e22.shiftKey && !e22.deltaX, scrollY = !shift && Math.abs(e22.deltaX) <= Math.abs(e22.deltaY), delta = shift || scrollY ? e22.deltaY : e22.deltaX;
  for (let index2 = 0; index2 < path.length; index2++) {
    const el = path[index2];
    if (hasScrollbar$1(el, scrollY)) {
      return scrollY ? delta < 0 && el.scrollTop === 0 ? true : delta > 0 && el.scrollTop + el.clientHeight === el.scrollHeight : delta < 0 && el.scrollLeft === 0 ? true : delta > 0 && el.scrollLeft + el.clientWidth === el.scrollWidth;
    }
  }
  return true;
}
function onAppleScroll$1(e22) {
  if (e22.target === document) {
    document.scrollingElement.scrollTop = document.scrollingElement.scrollTop;
  }
}
function onAppleResize$1(evt) {
  if (vpPendingUpdate$1 === true) {
    return;
  }
  vpPendingUpdate$1 = true;
  requestAnimationFrame(() => {
    vpPendingUpdate$1 = false;
    const { height: height2 } = evt.target, { clientHeight, scrollTop } = document.scrollingElement;
    if (maxScrollTop$1 === void 0 || height2 !== window.innerHeight) {
      maxScrollTop$1 = clientHeight - height2;
      document.scrollingElement.scrollTop = scrollTop;
    }
    if (scrollTop > maxScrollTop$1) {
      document.scrollingElement.scrollTop -= Math.ceil((scrollTop - maxScrollTop$1) / 8);
    }
  });
}
function apply$1(action) {
  const body = document.body, hasViewport = window.visualViewport !== void 0;
  if (action === "add") {
    const { overflowY, overflowX } = window.getComputedStyle(body);
    scrollPositionX$1 = getHorizontalScrollPosition$1(window);
    scrollPositionY$1 = getVerticalScrollPosition$1(window);
    bodyLeft$1 = body.style.left;
    bodyTop$1 = body.style.top;
    href$1 = window.location.href;
    body.style.left = `-${scrollPositionX$1}px`;
    body.style.top = `-${scrollPositionY$1}px`;
    if (overflowX !== "hidden" && (overflowX === "scroll" || body.scrollWidth > window.innerWidth)) {
      body.classList.add("q-body--force-scrollbar-x");
    }
    if (overflowY !== "hidden" && (overflowY === "scroll" || body.scrollHeight > window.innerHeight)) {
      body.classList.add("q-body--force-scrollbar-y");
    }
    body.classList.add("q-body--prevent-scroll");
    document.qScrollPrevented = true;
    if (client$1.is.ios === true) {
      if (hasViewport === true) {
        window.scrollTo(0, 0);
        window.visualViewport.addEventListener("resize", onAppleResize$1, listenOpts$1.passiveCapture);
        window.visualViewport.addEventListener("scroll", onAppleResize$1, listenOpts$1.passiveCapture);
        window.scrollTo(0, 0);
      } else {
        window.addEventListener("scroll", onAppleScroll$1, listenOpts$1.passiveCapture);
      }
    }
  }
  if (client$1.is.desktop === true && client$1.is.mac === true) {
    window[`${action}EventListener`]("wheel", onWheel$1, listenOpts$1.notPassive);
  }
  if (action === "remove") {
    if (client$1.is.ios === true) {
      if (hasViewport === true) {
        window.visualViewport.removeEventListener("resize", onAppleResize$1, listenOpts$1.passiveCapture);
        window.visualViewport.removeEventListener("scroll", onAppleResize$1, listenOpts$1.passiveCapture);
      } else {
        window.removeEventListener("scroll", onAppleScroll$1, listenOpts$1.passiveCapture);
      }
    }
    body.classList.remove("q-body--prevent-scroll");
    body.classList.remove("q-body--force-scrollbar-x");
    body.classList.remove("q-body--force-scrollbar-y");
    document.qScrollPrevented = false;
    body.style.left = bodyLeft$1;
    body.style.top = bodyTop$1;
    if (window.location.href === href$1) {
      window.scrollTo(scrollPositionX$1, scrollPositionY$1);
    }
    maxScrollTop$1 = void 0;
  }
}
function prevent_scroll_default$1(state2) {
  let action = "add";
  if (state2 === true) {
    registered$1++;
    if (closeTimer$1 !== null) {
      clearTimeout(closeTimer$1);
      closeTimer$1 = null;
      return;
    }
    if (registered$1 > 1) {
      return;
    }
  } else {
    if (registered$1 === 0) {
      return;
    }
    registered$1--;
    if (registered$1 > 0) {
      return;
    }
    action = "remove";
    if (client$1.is.ios === true && client$1.is.nativeMobile === true) {
      closeTimer$1 !== null && clearTimeout(closeTimer$1);
      closeTimer$1 = setTimeout(() => {
        apply$1(action);
        closeTimer$1 = null;
      }, 100);
      return;
    }
  }
  apply$1(action);
}
function use_prevent_scroll_default$1() {
  let currentState;
  return {
    preventBodyScroll(state2) {
      if (state2 !== currentState && (currentState !== void 0 || state2 === true)) {
        currentState = state2;
        prevent_scroll_default$1(state2);
      }
    }
  };
}
var maximizedModals$1 = 0;
var positionClass$1 = {
  standard: "fixed-full flex-center",
  top: "fixed-top justify-center",
  bottom: "fixed-bottom justify-center",
  right: "fixed-right items-center",
  left: "fixed-left items-center"
};
var defaultTransitions$1 = {
  standard: ["scale", "scale"],
  top: ["slide-down", "slide-up"],
  bottom: ["slide-up", "slide-down"],
  right: ["slide-left", "slide-right"],
  left: ["slide-right", "slide-left"]
};
var QDialog_default$1 = createComponent$1({
  name: "QDialog",
  inheritAttrs: false,
  props: {
    ...useModelToggleProps$1,
    ...useTransitionProps$1,
    transitionShow: String,
    // override useTransitionProps
    transitionHide: String,
    // override useTransitionProps
    persistent: Boolean,
    autoClose: Boolean,
    allowFocusOutside: Boolean,
    noEscDismiss: Boolean,
    noBackdropDismiss: Boolean,
    noRouteDismiss: Boolean,
    noRefocus: Boolean,
    noFocus: Boolean,
    noShake: Boolean,
    seamless: Boolean,
    maximized: Boolean,
    fullWidth: Boolean,
    fullHeight: Boolean,
    square: Boolean,
    backdropFilter: String,
    position: {
      type: String,
      default: "standard",
      validator: (val) => ["standard", "top", "bottom", "left", "right"].includes(val)
    }
  },
  emits: [
    ...useModelToggleEmits$1,
    "shake",
    "click",
    "escapeKey"
  ],
  setup(props4, { slots, emit, attrs }) {
    const vm2 = getCurrentInstance();
    const innerRef = ref$1(null);
    const showing = ref$1(false);
    const animating = ref$1(false);
    let shakeTimeout = null, refocusTarget = null, isMaximized, avoidAutoClose;
    const hideOnRouteChange = computed(
      () => props4.persistent !== true && props4.noRouteDismiss !== true && props4.seamless !== true
    );
    const { preventBodyScroll } = use_prevent_scroll_default$1();
    const { registerTimeout } = use_timeout_default$1();
    const { registerTick, removeTick } = use_tick_default$1();
    const { transitionProps, transitionStyle } = use_transition_default$1(
      props4,
      () => defaultTransitions$1[props4.position][0],
      () => defaultTransitions$1[props4.position][1]
    );
    const backdropStyle = computed(() => transitionStyle.value + (props4.backdropFilter !== void 0 ? `;backdrop-filter:${props4.backdropFilter};-webkit-backdrop-filter:${props4.backdropFilter}` : ""));
    const { showPortal, hidePortal, portalIsAccessible, renderPortal } = use_portal_default$1(
      vm2,
      innerRef,
      renderPortalContent,
      "dialog"
    );
    const { hide } = use_model_toggle_default$1({
      showing,
      hideOnRouteChange,
      handleShow,
      handleHide,
      processOnMount: true
    });
    use_history_default$1(showing);
    const classes = computed(
      () => `q-dialog__inner flex no-pointer-events q-dialog__inner--${props4.maximized === true ? "maximized" : "minimized"} q-dialog__inner--${props4.position} ${positionClass$1[props4.position]}` + (animating.value === true ? " q-dialog__inner--animating" : "") + (props4.fullWidth === true ? " q-dialog__inner--fullwidth" : "") + (props4.fullHeight === true ? " q-dialog__inner--fullheight" : "") + (props4.square === true ? " q-dialog__inner--square" : "")
    );
    const useBackdrop = computed(() => showing.value === true && props4.seamless !== true);
    const onEvents = computed(() => props4.autoClose === true ? { onClick: onAutoClose } : {});
    const rootClasses = computed(() => [
      `q-dialog fullscreen no-pointer-events q-dialog--${useBackdrop.value === true ? "modal" : "seamless"}`,
      attrs.class
    ]);
    watch(() => props4.maximized, (state2) => {
      showing.value === true && updateMaximized(state2);
    });
    watch(useBackdrop, (val) => {
      preventBodyScroll(val);
      if (val === true) {
        addFocusout$1(onFocusChange);
        addEscapeKey$1(onEscapeKey);
      } else {
        removeFocusout$1(onFocusChange);
        removeEscapeKey$1(onEscapeKey);
      }
    });
    function handleShow(evt) {
      refocusTarget = props4.noRefocus === false && document.activeElement !== null ? document.activeElement : null;
      updateMaximized(props4.maximized);
      showPortal();
      animating.value = true;
      if (props4.noFocus !== true) {
        document.activeElement !== null && document.activeElement.blur();
        registerTick(focus);
      } else {
        removeTick();
      }
      registerTimeout(() => {
        if (vm2.proxy.$q.platform.is.ios === true) {
          if (props4.seamless !== true && document.activeElement) {
            const { top, bottom } = document.activeElement.getBoundingClientRect(), { innerHeight } = window, height2 = window.visualViewport !== void 0 ? window.visualViewport.height : innerHeight;
            if (top > 0 && bottom > height2 / 2) {
              document.scrollingElement.scrollTop = Math.min(
                document.scrollingElement.scrollHeight - height2,
                bottom >= innerHeight ? Infinity : Math.ceil(document.scrollingElement.scrollTop + bottom - height2 / 2)
              );
            }
            document.activeElement.scrollIntoView();
          }
          avoidAutoClose = true;
          innerRef.value.click();
          avoidAutoClose = false;
        }
        showPortal(true);
        animating.value = false;
        emit("show", evt);
      }, props4.transitionDuration);
    }
    function handleHide(evt) {
      removeTick();
      cleanup(true);
      animating.value = true;
      hidePortal();
      if (refocusTarget !== null) {
        ((evt && evt.type.indexOf("key") === 0 ? refocusTarget.closest('[tabindex]:not([tabindex^="-"])') : void 0) || refocusTarget).focus();
        refocusTarget = null;
      }
      registerTimeout(() => {
        hidePortal(true);
        animating.value = false;
        emit("hide", evt);
      }, props4.transitionDuration);
    }
    function focus(selector) {
      addFocusFn$1(() => {
        let node = innerRef.value;
        if (node === null) return;
        if (selector !== void 0) {
          const target2 = node.querySelector(selector);
          if (target2 !== null) {
            target2.focus({ preventScroll: true });
            return;
          }
        }
        if (node.contains(document.activeElement) !== true) {
          node = node.querySelector("[autofocus][tabindex], [data-autofocus][tabindex]") || node.querySelector("[autofocus] [tabindex], [data-autofocus] [tabindex]") || node.querySelector("[autofocus], [data-autofocus]") || node;
          node.focus({ preventScroll: true });
        }
      });
    }
    function shake(focusTarget) {
      if (focusTarget && typeof focusTarget.focus === "function") {
        focusTarget.focus({ preventScroll: true });
      } else {
        focus();
      }
      emit("shake");
      const node = innerRef.value;
      if (node !== null) {
        node.classList.remove("q-animate--scale");
        node.classList.add("q-animate--scale");
        shakeTimeout !== null && clearTimeout(shakeTimeout);
        shakeTimeout = setTimeout(() => {
          shakeTimeout = null;
          if (innerRef.value !== null) {
            node.classList.remove("q-animate--scale");
            focus();
          }
        }, 170);
      }
    }
    function onEscapeKey() {
      if (props4.seamless !== true) {
        if (props4.persistent === true || props4.noEscDismiss === true) {
          props4.maximized !== true && props4.noShake !== true && shake();
        } else {
          emit("escapeKey");
          hide();
        }
      }
    }
    function cleanup(hiding) {
      if (shakeTimeout !== null) {
        clearTimeout(shakeTimeout);
        shakeTimeout = null;
      }
      if (hiding === true || showing.value === true) {
        updateMaximized(false);
        if (props4.seamless !== true) {
          preventBodyScroll(false);
          removeFocusout$1(onFocusChange);
          removeEscapeKey$1(onEscapeKey);
        }
      }
      if (hiding !== true) {
        refocusTarget = null;
      }
    }
    function updateMaximized(active) {
      if (active === true) {
        if (isMaximized !== true) {
          maximizedModals$1 < 1 && document.body.classList.add("q-body--dialog");
          maximizedModals$1++;
          isMaximized = true;
        }
      } else if (isMaximized === true) {
        if (maximizedModals$1 < 2) {
          document.body.classList.remove("q-body--dialog");
        }
        maximizedModals$1--;
        isMaximized = false;
      }
    }
    function onAutoClose(e22) {
      if (avoidAutoClose !== true) {
        hide(e22);
        emit("click", e22);
      }
    }
    function onBackdropClick(e22) {
      if (props4.persistent !== true && props4.noBackdropDismiss !== true) {
        hide(e22);
      } else if (props4.noShake !== true) {
        shake();
      }
    }
    function onFocusChange(evt) {
      if (props4.allowFocusOutside !== true && portalIsAccessible.value === true && childHasFocus$1(innerRef.value, evt.target) !== true) {
        focus('[tabindex]:not([tabindex="-1"])');
      }
    }
    Object.assign(vm2.proxy, {
      // expose public methods
      focus,
      shake,
      // private but needed by QSelect
      __updateRefocusTarget(target2) {
        refocusTarget = target2 || null;
      }
    });
    onBeforeUnmount(cleanup);
    function renderPortalContent() {
      return h("div", {
        role: "dialog",
        "aria-modal": useBackdrop.value === true ? "true" : "false",
        ...attrs,
        class: rootClasses.value
      }, [
        h(Transition, {
          name: "q-transition--fade",
          appear: true
        }, () => useBackdrop.value === true ? h("div", {
          class: "q-dialog__backdrop fixed-full",
          style: backdropStyle.value,
          "aria-hidden": "true",
          tabindex: -1,
          onClick: onBackdropClick
        }) : null),
        h(
          Transition,
          transitionProps.value,
          () => showing.value === true ? h("div", {
            ref: innerRef,
            class: classes.value,
            style: transitionStyle.value,
            tabindex: -1,
            ...onEvents.value
          }, hSlot$1(slots.default)) : null
        )
      ]);
    }
    return renderPortal;
  }
});
var duration$1 = 150;
var QDrawer_default = createComponent$1({
  name: "QDrawer",
  inheritAttrs: false,
  props: {
    ...useModelToggleProps$1,
    ...useDarkProps$1,
    side: {
      type: String,
      default: "left",
      validator: (v) => ["left", "right"].includes(v)
    },
    width: {
      type: Number,
      default: 300
    },
    mini: Boolean,
    miniToOverlay: Boolean,
    miniWidth: {
      type: Number,
      default: 57
    },
    noMiniAnimation: Boolean,
    breakpoint: {
      type: Number,
      default: 1023
    },
    showIfAbove: Boolean,
    behavior: {
      type: String,
      validator: (v) => ["default", "desktop", "mobile"].includes(v),
      default: "default"
    },
    bordered: Boolean,
    elevated: Boolean,
    overlay: Boolean,
    persistent: Boolean,
    noSwipeOpen: Boolean,
    noSwipeClose: Boolean,
    noSwipeBackdrop: Boolean
  },
  emits: [
    ...useModelToggleEmits$1,
    "onLayout",
    "miniState"
  ],
  setup(props4, { slots, emit, attrs }) {
    const vm2 = getCurrentInstance();
    const { proxy: { $q } } = vm2;
    const isDark = use_dark_default$1(props4, $q);
    const { preventBodyScroll } = use_prevent_scroll_default$1();
    const { registerTimeout, removeTimeout } = use_timeout_default$1();
    const $layout = inject(layoutKey$1, emptyRenderFn$1);
    if ($layout === emptyRenderFn$1) {
      console.error("QDrawer needs to be child of QLayout");
      return emptyRenderFn$1;
    }
    let lastDesktopState, timerMini = null, layoutTotalWidthWatcher;
    const belowBreakpoint = ref$1(
      props4.behavior === "mobile" || props4.behavior !== "desktop" && $layout.totalWidth.value <= props4.breakpoint
    );
    const isMini = computed(
      () => props4.mini === true && belowBreakpoint.value !== true
    );
    const size2 = computed(() => isMini.value === true ? props4.miniWidth : props4.width);
    const showing = ref$1(
      props4.showIfAbove === true && belowBreakpoint.value === false ? true : props4.modelValue === true
    );
    const hideOnRouteChange = computed(
      () => props4.persistent !== true && (belowBreakpoint.value === true || onScreenOverlay.value === true)
    );
    function handleShow(evt, noEvent) {
      evt !== false && $layout.animate();
      applyPosition(0);
      if (belowBreakpoint.value === true) {
        const otherInstance = $layout.instances[otherSide.value];
        if (otherInstance !== void 0 && otherInstance.belowBreakpoint === true) {
          otherInstance.hide(false);
        }
        applyBackdrop(1);
        $layout.isContainer.value !== true && preventBodyScroll(true);
      } else {
        applyBackdrop(0);
        evt !== false && setScrollable(false);
      }
      registerTimeout(() => {
        evt !== false && setScrollable(true);
        noEvent !== true && emit("show", evt);
      }, duration$1);
    }
    function handleHide(evt, noEvent) {
      evt !== false && $layout.animate();
      applyBackdrop(0);
      applyPosition(stateDirection.value * size2.value);
      cleanup();
      if (noEvent !== true) {
        registerTimeout(() => {
          emit("hide", evt);
        }, duration$1);
      } else {
        removeTimeout();
      }
    }
    const { show, hide } = use_model_toggle_default$1({
      showing,
      hideOnRouteChange,
      handleShow,
      handleHide
    });
    use_history_default$1(showing);
    const instance = {
      belowBreakpoint,
      hide
    };
    const rightSide = computed(() => props4.side === "right");
    const stateDirection = computed(
      () => ($q.lang.rtl === true ? -1 : 1) * (rightSide.value === true ? 1 : -1)
    );
    const flagBackdropBg = ref$1(0);
    const flagPanning = ref$1(false);
    const flagMiniAnimate = ref$1(false);
    const flagContentPosition = ref$1(
      // starting with "hidden" for SSR
      size2.value * stateDirection.value
    );
    const otherSide = computed(() => rightSide.value === true ? "left" : "right");
    const offset2 = computed(() => showing.value === true && belowBreakpoint.value === false && props4.overlay === false ? props4.miniToOverlay === true ? props4.miniWidth : size2.value : 0);
    const fixed = computed(
      () => props4.overlay === true || props4.miniToOverlay === true || $layout.view.value.indexOf(rightSide.value ? "R" : "L") !== -1 || $q.platform.is.ios === true && $layout.isContainer.value === true
    );
    const onLayout = computed(
      () => props4.overlay === false && showing.value === true && belowBreakpoint.value === false
    );
    const onScreenOverlay = computed(
      () => props4.overlay === true && showing.value === true && belowBreakpoint.value === false
    );
    const backdropClass = computed(
      () => "fullscreen q-drawer__backdrop" + (showing.value === false && flagPanning.value === false ? " hidden" : "")
    );
    const backdropStyle = computed(() => ({
      backgroundColor: `rgba(0,0,0,${flagBackdropBg.value * 0.4})`
    }));
    const headerSlot = computed(() => rightSide.value === true ? $layout.rows.value.top[2] === "r" : $layout.rows.value.top[0] === "l");
    const footerSlot = computed(() => rightSide.value === true ? $layout.rows.value.bottom[2] === "r" : $layout.rows.value.bottom[0] === "l");
    const aboveStyle = computed(() => {
      const css2 = {};
      if ($layout.header.space === true && headerSlot.value === false) {
        if (fixed.value === true) {
          css2.top = `${$layout.header.offset}px`;
        } else if ($layout.header.space === true) {
          css2.top = `${$layout.header.size}px`;
        }
      }
      if ($layout.footer.space === true && footerSlot.value === false) {
        if (fixed.value === true) {
          css2.bottom = `${$layout.footer.offset}px`;
        } else if ($layout.footer.space === true) {
          css2.bottom = `${$layout.footer.size}px`;
        }
      }
      return css2;
    });
    const style2 = computed(() => {
      const style3 = {
        width: `${size2.value}px`,
        transform: `translateX(${flagContentPosition.value}px)`
      };
      return belowBreakpoint.value === true ? style3 : Object.assign(style3, aboveStyle.value);
    });
    const contentClass = computed(
      () => "q-drawer__content fit " + ($layout.isContainer.value !== true ? "scroll" : "overflow-auto")
    );
    const classes = computed(
      () => `q-drawer q-drawer--${props4.side}` + (flagMiniAnimate.value === true ? " q-drawer--mini-animate" : "") + (props4.bordered === true ? " q-drawer--bordered" : "") + (isDark.value === true ? " q-drawer--dark q-dark" : "") + (flagPanning.value === true ? " no-transition" : showing.value === true ? "" : " q-layout--prevent-focus") + (belowBreakpoint.value === true ? " fixed q-drawer--on-top q-drawer--mobile q-drawer--top-padding" : ` q-drawer--${isMini.value === true ? "mini" : "standard"}` + (fixed.value === true || onLayout.value !== true ? " fixed" : "") + (props4.overlay === true || props4.miniToOverlay === true ? " q-drawer--on-top" : "") + (headerSlot.value === true ? " q-drawer--top-padding" : ""))
    );
    const openDirective = computed(() => {
      const dir = $q.lang.rtl === true ? props4.side : otherSide.value;
      return [[
        TouchPan_default$1,
        onOpenPan,
        void 0,
        {
          [dir]: true,
          mouse: true
        }
      ]];
    });
    const contentCloseDirective = computed(() => {
      const dir = $q.lang.rtl === true ? otherSide.value : props4.side;
      return [[
        TouchPan_default$1,
        onClosePan,
        void 0,
        {
          [dir]: true,
          mouse: true
        }
      ]];
    });
    const backdropCloseDirective = computed(() => {
      const dir = $q.lang.rtl === true ? otherSide.value : props4.side;
      return [[
        TouchPan_default$1,
        onClosePan,
        void 0,
        {
          [dir]: true,
          mouse: true,
          mouseAllDir: true
        }
      ]];
    });
    function updateBelowBreakpoint() {
      updateLocal(belowBreakpoint, props4.behavior === "mobile" || props4.behavior !== "desktop" && $layout.totalWidth.value <= props4.breakpoint);
    }
    watch(belowBreakpoint, (val) => {
      if (val === true) {
        lastDesktopState = showing.value;
        showing.value === true && hide(false);
      } else if (props4.overlay === false && props4.behavior !== "mobile" && lastDesktopState !== false) {
        if (showing.value === true) {
          applyPosition(0);
          applyBackdrop(0);
          cleanup();
        } else {
          show(false);
        }
      }
    });
    watch(() => props4.side, (newSide, oldSide) => {
      if ($layout.instances[oldSide] === instance) {
        $layout.instances[oldSide] = void 0;
        $layout[oldSide].space = false;
        $layout[oldSide].offset = 0;
      }
      $layout.instances[newSide] = instance;
      $layout[newSide].size = size2.value;
      $layout[newSide].space = onLayout.value;
      $layout[newSide].offset = offset2.value;
    });
    watch($layout.totalWidth, () => {
      if ($layout.isContainer.value === true || document.qScrollPrevented !== true) {
        updateBelowBreakpoint();
      }
    });
    watch(
      () => props4.behavior + props4.breakpoint,
      updateBelowBreakpoint
    );
    watch($layout.isContainer, (val) => {
      showing.value === true && preventBodyScroll(val !== true);
      val === true && updateBelowBreakpoint();
    });
    watch($layout.scrollbarWidth, () => {
      applyPosition(showing.value === true ? 0 : void 0);
    });
    watch(offset2, (val) => {
      updateLayout("offset", val);
    });
    watch(onLayout, (val) => {
      emit("onLayout", val);
      updateLayout("space", val);
    });
    watch(rightSide, () => {
      applyPosition();
    });
    watch(size2, (val) => {
      applyPosition();
      updateSizeOnLayout(props4.miniToOverlay, val);
    });
    watch(() => props4.miniToOverlay, (val) => {
      updateSizeOnLayout(val, size2.value);
    });
    watch(() => $q.lang.rtl, () => {
      applyPosition();
    });
    watch(() => props4.mini, () => {
      if (props4.noMiniAnimation) return;
      if (props4.modelValue === true) {
        animateMini();
        $layout.animate();
      }
    });
    watch(isMini, (val) => {
      emit("miniState", val);
    });
    function applyPosition(position2) {
      if (position2 === void 0) {
        nextTick(() => {
          position2 = showing.value === true ? 0 : size2.value;
          applyPosition(stateDirection.value * position2);
        });
      } else {
        if ($layout.isContainer.value === true && rightSide.value === true && (belowBreakpoint.value === true || Math.abs(position2) === size2.value)) {
          position2 += stateDirection.value * $layout.scrollbarWidth.value;
        }
        flagContentPosition.value = position2;
      }
    }
    function applyBackdrop(x22) {
      flagBackdropBg.value = x22;
    }
    function setScrollable(v) {
      const action = v === true ? "remove" : $layout.isContainer.value !== true ? "add" : "";
      action !== "" && document.body.classList[action]("q-body--drawer-toggle");
    }
    function animateMini() {
      timerMini !== null && clearTimeout(timerMini);
      if (vm2.proxy && vm2.proxy.$el) {
        vm2.proxy.$el.classList.add("q-drawer--mini-animate");
      }
      flagMiniAnimate.value = true;
      timerMini = setTimeout(() => {
        timerMini = null;
        flagMiniAnimate.value = false;
        if (vm2 && vm2.proxy && vm2.proxy.$el) {
          vm2.proxy.$el.classList.remove("q-drawer--mini-animate");
        }
      }, 150);
    }
    function onOpenPan(evt) {
      if (showing.value !== false) {
        return;
      }
      const width3 = size2.value, position2 = between$1(evt.distance.x, 0, width3);
      if (evt.isFinal === true) {
        const opened = position2 >= Math.min(75, width3);
        if (opened === true) {
          show();
        } else {
          $layout.animate();
          applyBackdrop(0);
          applyPosition(stateDirection.value * width3);
        }
        flagPanning.value = false;
        return;
      }
      applyPosition(
        ($q.lang.rtl === true ? rightSide.value !== true : rightSide.value) ? Math.max(width3 - position2, 0) : Math.min(0, position2 - width3)
      );
      applyBackdrop(
        between$1(position2 / width3, 0, 1)
      );
      if (evt.isFirst === true) {
        flagPanning.value = true;
      }
    }
    function onClosePan(evt) {
      if (showing.value !== true) {
        return;
      }
      const width3 = size2.value, dir = evt.direction === props4.side, position2 = ($q.lang.rtl === true ? dir !== true : dir) ? between$1(evt.distance.x, 0, width3) : 0;
      if (evt.isFinal === true) {
        const opened = Math.abs(position2) < Math.min(75, width3);
        if (opened === true) {
          $layout.animate();
          applyBackdrop(1);
          applyPosition(0);
        } else {
          hide();
        }
        flagPanning.value = false;
        return;
      }
      applyPosition(stateDirection.value * position2);
      applyBackdrop(between$1(1 - position2 / width3, 0, 1));
      if (evt.isFirst === true) {
        flagPanning.value = true;
      }
    }
    function cleanup() {
      preventBodyScroll(false);
      setScrollable(true);
    }
    function updateLayout(prop, val) {
      $layout.update(props4.side, prop, val);
    }
    function updateLocal(prop, val) {
      if (prop.value !== val) {
        prop.value = val;
      }
    }
    function updateSizeOnLayout(miniToOverlay, size3) {
      updateLayout("size", miniToOverlay === true ? props4.miniWidth : size3);
    }
    $layout.instances[props4.side] = instance;
    updateSizeOnLayout(props4.miniToOverlay, size2.value);
    updateLayout("space", onLayout.value);
    updateLayout("offset", offset2.value);
    if (props4.showIfAbove === true && props4.modelValue !== true && showing.value === true && props4["onUpdate:modelValue"] !== void 0) {
      emit("update:modelValue", true);
    }
    onMounted(() => {
      emit("onLayout", onLayout.value);
      emit("miniState", isMini.value);
      lastDesktopState = props4.showIfAbove === true;
      const fn = () => {
        const action = showing.value === true ? handleShow : handleHide;
        action(false, true);
      };
      if ($layout.totalWidth.value !== 0) {
        nextTick(fn);
        return;
      }
      layoutTotalWidthWatcher = watch($layout.totalWidth, () => {
        layoutTotalWidthWatcher();
        layoutTotalWidthWatcher = void 0;
        if (showing.value === false && props4.showIfAbove === true && belowBreakpoint.value === false) {
          show(false);
        } else {
          fn();
        }
      });
    });
    onBeforeUnmount(() => {
      layoutTotalWidthWatcher !== void 0 && layoutTotalWidthWatcher();
      if (timerMini !== null) {
        clearTimeout(timerMini);
        timerMini = null;
      }
      showing.value === true && cleanup();
      if ($layout.instances[props4.side] === instance) {
        $layout.instances[props4.side] = void 0;
        updateLayout("size", 0);
        updateLayout("offset", 0);
        updateLayout("space", false);
      }
    });
    return () => {
      const child = [];
      if (belowBreakpoint.value === true) {
        props4.noSwipeOpen === false && child.push(
          withDirectives(
            h("div", {
              key: "open",
              class: `q-drawer__opener fixed-${props4.side}`,
              "aria-hidden": "true"
            }),
            openDirective.value
          )
        );
        child.push(
          hDir$1(
            "div",
            {
              ref: "backdrop",
              class: backdropClass.value,
              style: backdropStyle.value,
              "aria-hidden": "true",
              onClick: hide
            },
            void 0,
            "backdrop",
            props4.noSwipeBackdrop !== true && showing.value === true,
            () => backdropCloseDirective.value
          )
        );
      }
      const mini = isMini.value === true && slots.mini !== void 0;
      const content = [
        h(
          "div",
          {
            ...attrs,
            key: "" + mini,
            // required otherwise Vue will not diff correctly
            class: [
              contentClass.value,
              attrs.class
            ]
          },
          mini === true ? slots.mini() : hSlot$1(slots.default)
        )
      ];
      if (props4.elevated === true && showing.value === true) {
        content.push(
          h("div", {
            class: "q-layout__shadow absolute-full overflow-hidden no-pointer-events"
          })
        );
      }
      child.push(
        hDir$1(
          "aside",
          { ref: "content", class: classes.value, style: style2.value },
          content,
          "contentclose",
          props4.noSwipeClose !== true && belowBreakpoint.value === true,
          () => contentCloseDirective.value
        )
      );
      return h("div", { class: "q-drawer-container" }, child);
    };
  }
});
function getBlockElement$1(el, parent) {
  if (parent && el === parent) {
    return null;
  }
  const nodeName = el.nodeName.toLowerCase();
  if (["div", "li", "ul", "ol", "blockquote"].includes(nodeName) === true) {
    return el;
  }
  const style2 = window.getComputedStyle ? window.getComputedStyle(el) : el.currentStyle, display = style2.display;
  if (display === "block" || display === "table") {
    return el;
  }
  return getBlockElement$1(el.parentNode);
}
function isChildOf$1(el, parent, orSame) {
  return !el || el === document.body ? false : orSame === true && el === parent || (parent === document ? document.body : parent).contains(el.parentNode);
}
function createRange$1(node, chars, range2) {
  if (!range2) {
    range2 = document.createRange();
    range2.selectNode(node);
    range2.setStart(node, 0);
  }
  if (chars.count === 0) {
    range2.setEnd(node, chars.count);
  } else if (chars.count > 0) {
    if (node.nodeType === Node.TEXT_NODE) {
      if (node.textContent.length < chars.count) {
        chars.count -= node.textContent.length;
      } else {
        range2.setEnd(node, chars.count);
        chars.count = 0;
      }
    } else {
      for (let lp = 0; chars.count !== 0 && lp < node.childNodes.length; lp++) {
        range2 = createRange$1(node.childNodes[lp], chars, range2);
      }
    }
  }
  return range2;
}
var urlRegex$1 = /^https?:\/\//;
var Caret$1 = class Caret {
  constructor(el, eVm) {
    this.el = el;
    this.eVm = eVm;
    this._range = null;
  }
  get selection() {
    if (this.el) {
      const sel = document.getSelection();
      if (isChildOf$1(sel.anchorNode, this.el, true) && isChildOf$1(sel.focusNode, this.el, true)) {
        return sel;
      }
    }
    return null;
  }
  get hasSelection() {
    return this.selection !== null ? this.selection.toString().length !== 0 : false;
  }
  get range() {
    const sel = this.selection;
    if (sel !== null && sel.rangeCount) {
      return sel.getRangeAt(0);
    }
    return this._range;
  }
  get parent() {
    const range2 = this.range;
    if (range2 !== null) {
      const node = range2.startContainer;
      return node.nodeType === document.ELEMENT_NODE ? node : node.parentNode;
    }
    return null;
  }
  get blockParent() {
    const parent = this.parent;
    if (parent !== null) {
      return getBlockElement$1(parent, this.el);
    }
    return null;
  }
  save(range2 = this.range) {
    if (range2 !== null) {
      this._range = range2;
    }
  }
  restore(range2 = this._range) {
    const r = document.createRange(), sel = document.getSelection();
    if (range2 !== null) {
      r.setStart(range2.startContainer, range2.startOffset);
      r.setEnd(range2.endContainer, range2.endOffset);
      sel.removeAllRanges();
      sel.addRange(r);
    } else {
      sel.selectAllChildren(this.el);
      sel.collapseToEnd();
    }
  }
  savePosition() {
    let charCount = -1, node;
    const selection = document.getSelection(), parentEl = this.el.parentNode;
    if (selection.focusNode && isChildOf$1(selection.focusNode, parentEl)) {
      node = selection.focusNode;
      charCount = selection.focusOffset;
      while (node && node !== parentEl) {
        if (node !== this.el && node.previousSibling) {
          node = node.previousSibling;
          charCount += node.textContent.length;
        } else {
          node = node.parentNode;
        }
      }
    }
    this.savedPos = charCount;
  }
  restorePosition(length = 0) {
    if (this.savedPos > 0 && this.savedPos < length) {
      const selection = window.getSelection(), range2 = createRange$1(this.el, { count: this.savedPos });
      if (range2) {
        range2.collapse(false);
        selection.removeAllRanges();
        selection.addRange(range2);
      }
    }
  }
  hasParent(name2, spanLevel) {
    const el = spanLevel ? this.parent : this.blockParent;
    return el !== null ? el.nodeName.toLowerCase() === name2.toLowerCase() : false;
  }
  hasParents(list, recursive, el = this.parent) {
    if (el === null) {
      return false;
    }
    if (list.includes(el.nodeName.toLowerCase()) === true) {
      return true;
    }
    return recursive === true ? this.hasParents(list, recursive, el.parentNode) : false;
  }
  is(cmd, param) {
    if (this.selection === null) {
      return false;
    }
    switch (cmd) {
      case "formatBlock":
        return param === "DIV" && this.parent === this.el || this.hasParent(param, param === "PRE");
      case "link":
        return this.hasParent("A", true);
      case "fontSize":
        return document.queryCommandValue(cmd) === param;
      case "fontName":
        const res = document.queryCommandValue(cmd);
        return res === `"${param}"` || res === param;
      case "fullscreen":
        return this.eVm.inFullscreen.value;
      case "viewsource":
        return this.eVm.isViewingSource.value;
      case void 0:
        return false;
      default:
        const state2 = document.queryCommandState(cmd);
        return param !== void 0 ? state2 === param : state2;
    }
  }
  getParentAttribute(attrib) {
    if (this.parent !== null) {
      return this.parent.getAttribute(attrib);
    }
    return null;
  }
  can(name2) {
    if (name2 === "outdent") {
      return this.hasParents(["blockquote", "li"], true);
    }
    if (name2 === "indent") {
      return this.hasParents(["li"], true);
    }
    if (name2 === "link") {
      return this.selection !== null || this.is("link");
    }
  }
  apply(cmd, param, done = noop$1) {
    if (cmd === "formatBlock") {
      if (["BLOCKQUOTE", "H1", "H2", "H3", "H4", "H5", "H6"].includes(param) && this.is(cmd, param)) {
        cmd = "outdent";
        param = null;
      }
      if (param === "PRE" && this.is(cmd, "PRE")) {
        param = "P";
      }
    } else if (cmd === "print") {
      done();
      const win = window.open();
      win.document.write(`
        <!doctype html>
        <html>
          <head>
            <title>Print - ${document.title}</title>
          </head>
          <body>
            <div>${this.el.innerHTML}</div>
          </body>
        </html>
      `);
      win.print();
      win.close();
      return;
    } else if (cmd === "link") {
      const link = this.getParentAttribute("href");
      if (link === null) {
        const selection = this.selectWord(this.selection);
        const url = selection ? selection.toString() : "";
        if (!url.length) {
          if (!this.range || !this.range.cloneContents().querySelector("img")) {
            return;
          }
        }
        this.eVm.editLinkUrl.value = urlRegex$1.test(url) ? url : "https://";
        document.execCommand("createLink", false, this.eVm.editLinkUrl.value);
        this.save(selection.getRangeAt(0));
      } else {
        this.eVm.editLinkUrl.value = link;
        this.range.selectNodeContents(this.parent);
        this.save();
      }
      return;
    } else if (cmd === "fullscreen") {
      this.eVm.toggleFullscreen();
      done();
      return;
    } else if (cmd === "viewsource") {
      this.eVm.isViewingSource.value = this.eVm.isViewingSource.value === false;
      this.eVm.setContent(this.eVm.props.modelValue);
      done();
      return;
    }
    document.execCommand(cmd, false, param);
    done();
  }
  selectWord(sel) {
    if (sel === null || sel.isCollapsed !== true || /* IE 11 */
    sel.modify === void 0) {
      return sel;
    }
    const range2 = document.createRange();
    range2.setStart(sel.anchorNode, sel.anchorOffset);
    range2.setEnd(sel.focusNode, sel.focusOffset);
    const direction = range2.collapsed ? ["backward", "forward"] : ["forward", "backward"];
    range2.detach();
    const endNode = sel.focusNode, endOffset = sel.focusOffset;
    sel.collapse(sel.anchorNode, sel.anchorOffset);
    sel.modify("move", direction[0], "character");
    sel.modify("move", direction[1], "word");
    sel.extend(endNode, endOffset);
    sel.modify("extend", direction[1], "character");
    sel.modify("extend", direction[0], "word");
    return sel;
  }
};
var QTooltip_default$1 = createComponent$1({
  name: "QTooltip",
  inheritAttrs: false,
  props: {
    ...useAnchorStaticProps$1,
    ...useModelToggleProps$1,
    ...useTransitionProps$1,
    maxHeight: {
      type: String,
      default: null
    },
    maxWidth: {
      type: String,
      default: null
    },
    transitionShow: {
      ...useTransitionProps$1.transitionShow,
      default: "jump-down"
    },
    transitionHide: {
      ...useTransitionProps$1.transitionHide,
      default: "jump-up"
    },
    anchor: {
      type: String,
      default: "bottom middle",
      validator: validatePosition$1
    },
    self: {
      type: String,
      default: "top middle",
      validator: validatePosition$1
    },
    offset: {
      type: Array,
      default: () => [14, 14],
      validator: validateOffset$1
    },
    scrollTarget: scrollTargetProp$1,
    delay: {
      type: Number,
      default: 0
    },
    hideDelay: {
      type: Number,
      default: 0
    },
    persistent: Boolean
  },
  emits: [
    ...useModelToggleEmits$1
  ],
  setup(props4, { slots, emit, attrs }) {
    let unwatchPosition, observer;
    const vm2 = getCurrentInstance();
    const { proxy: { $q } } = vm2;
    const innerRef = ref$1(null);
    const showing = ref$1(false);
    const anchorOrigin = computed(() => parsePosition$1(props4.anchor, $q.lang.rtl));
    const selfOrigin = computed(() => parsePosition$1(props4.self, $q.lang.rtl));
    const hideOnRouteChange = computed(() => props4.persistent !== true);
    const { registerTick, removeTick } = use_tick_default$1();
    const { registerTimeout } = use_timeout_default$1();
    const { transitionProps, transitionStyle } = use_transition_default$1(props4);
    const { localScrollTarget, changeScrollEvent, unconfigureScrollTarget } = use_scroll_target_default$1(props4, configureScrollTarget);
    const { anchorEl, canShow, anchorEvents } = use_anchor_default$1({ showing, configureAnchorEl });
    const { show, hide } = use_model_toggle_default$1({
      showing,
      canShow,
      handleShow,
      handleHide,
      hideOnRouteChange,
      processOnMount: true
    });
    Object.assign(anchorEvents, { delayShow, delayHide });
    const { showPortal, hidePortal, renderPortal } = use_portal_default$1(vm2, innerRef, renderPortalContent, "tooltip");
    if ($q.platform.is.mobile === true) {
      const clickOutsideProps = {
        anchorEl,
        innerRef,
        onClickOutside(e22) {
          hide(e22);
          if (e22.target.classList.contains("q-dialog__backdrop")) {
            stopAndPrevent$1(e22);
          }
          return true;
        }
      };
      const hasClickOutside = computed(
        () => (
          // it doesn't has external model
          // (null is the default value)
          props4.modelValue === null && props4.persistent !== true && showing.value === true
        )
      );
      watch(hasClickOutside, (val) => {
        const fn = val === true ? addClickOutside$1 : removeClickOutside$1;
        fn(clickOutsideProps);
      });
      onBeforeUnmount(() => {
        removeClickOutside$1(clickOutsideProps);
      });
    }
    function handleShow(evt) {
      showPortal();
      registerTick(() => {
        observer = new MutationObserver(() => updatePosition());
        observer.observe(innerRef.value, { attributes: false, childList: true, characterData: true, subtree: true });
        updatePosition();
        configureScrollTarget();
      });
      if (unwatchPosition === void 0) {
        unwatchPosition = watch(
          () => $q.screen.width + "|" + $q.screen.height + "|" + props4.self + "|" + props4.anchor + "|" + $q.lang.rtl,
          updatePosition
        );
      }
      registerTimeout(() => {
        showPortal(true);
        emit("show", evt);
      }, props4.transitionDuration);
    }
    function handleHide(evt) {
      removeTick();
      hidePortal();
      anchorCleanup();
      registerTimeout(() => {
        hidePortal(true);
        emit("hide", evt);
      }, props4.transitionDuration);
    }
    function anchorCleanup() {
      if (observer !== void 0) {
        observer.disconnect();
        observer = void 0;
      }
      if (unwatchPosition !== void 0) {
        unwatchPosition();
        unwatchPosition = void 0;
      }
      unconfigureScrollTarget();
      cleanEvt$1(anchorEvents, "tooltipTemp");
    }
    function updatePosition() {
      setPosition$1({
        targetEl: innerRef.value,
        offset: props4.offset,
        anchorEl: anchorEl.value,
        anchorOrigin: anchorOrigin.value,
        selfOrigin: selfOrigin.value,
        maxHeight: props4.maxHeight,
        maxWidth: props4.maxWidth
      });
    }
    function delayShow(evt) {
      if ($q.platform.is.mobile === true) {
        clearSelection$1();
        document.body.classList.add("non-selectable");
        const target2 = anchorEl.value;
        const evts = ["touchmove", "touchcancel", "touchend", "click"].map((e22) => [target2, e22, "delayHide", "passiveCapture"]);
        addEvt$1(anchorEvents, "tooltipTemp", evts);
      }
      registerTimeout(() => {
        show(evt);
      }, props4.delay);
    }
    function delayHide(evt) {
      if ($q.platform.is.mobile === true) {
        cleanEvt$1(anchorEvents, "tooltipTemp");
        clearSelection$1();
        setTimeout(() => {
          document.body.classList.remove("non-selectable");
        }, 10);
      }
      registerTimeout(() => {
        hide(evt);
      }, props4.hideDelay);
    }
    function configureAnchorEl() {
      if (props4.noParentEvent === true || anchorEl.value === null) return;
      const evts = $q.platform.is.mobile === true ? [
        [anchorEl.value, "touchstart", "delayShow", "passive"]
      ] : [
        [anchorEl.value, "mouseenter", "delayShow", "passive"],
        [anchorEl.value, "mouseleave", "delayHide", "passive"]
      ];
      addEvt$1(anchorEvents, "anchor", evts);
    }
    function configureScrollTarget() {
      if (anchorEl.value !== null || props4.scrollTarget !== void 0) {
        localScrollTarget.value = getScrollTarget$1(anchorEl.value, props4.scrollTarget);
        const fn = props4.noParentEvent === true ? updatePosition : hide;
        changeScrollEvent(localScrollTarget.value, fn);
      }
    }
    function getTooltipContent() {
      return showing.value === true ? h("div", {
        ...attrs,
        ref: innerRef,
        class: [
          "q-tooltip q-tooltip--style q-position-engine no-pointer-events",
          attrs.class
        ],
        style: [
          attrs.style,
          transitionStyle.value
        ],
        role: "tooltip"
      }, hSlot$1(slots.default)) : null;
    }
    function renderPortalContent() {
      return h(Transition, transitionProps.value, getTooltipContent);
    }
    onBeforeUnmount(anchorCleanup);
    Object.assign(vm2.proxy, { updatePosition });
    return renderPortal;
  }
});
var QItem_default$1 = createComponent$1({
  name: "QItem",
  props: {
    ...useDarkProps$1,
    ...useRouterLinkProps$1,
    tag: {
      type: String,
      default: "div"
    },
    active: {
      type: Boolean,
      default: null
    },
    clickable: Boolean,
    dense: Boolean,
    insetLevel: Number,
    tabindex: [String, Number],
    focused: Boolean,
    manualFocus: Boolean
  },
  emits: ["click", "keyup"],
  setup(props4, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const isDark = use_dark_default$1(props4, $q);
    const { hasLink, linkAttrs, linkClass, linkTag, navigateOnClick } = use_router_link_default$1();
    const rootRef = ref$1(null);
    const blurTargetRef = ref$1(null);
    const isActionable = computed(
      () => props4.clickable === true || hasLink.value === true || props4.tag === "label"
    );
    const isClickable = computed(
      () => props4.disable !== true && isActionable.value === true
    );
    const classes = computed(
      () => "q-item q-item-type row no-wrap" + (props4.dense === true ? " q-item--dense" : "") + (isDark.value === true ? " q-item--dark" : "") + (hasLink.value === true && props4.active === null ? linkClass.value : props4.active === true ? ` q-item--active${props4.activeClass !== void 0 ? ` ${props4.activeClass}` : ""}` : "") + (props4.disable === true ? " disabled" : "") + (isClickable.value === true ? " q-item--clickable q-link cursor-pointer " + (props4.manualFocus === true ? "q-manual-focusable" : "q-focusable q-hoverable") + (props4.focused === true ? " q-manual-focusable--focused" : "") : "")
    );
    const style2 = computed(() => {
      if (props4.insetLevel === void 0) {
        return null;
      }
      const dir = $q.lang.rtl === true ? "Right" : "Left";
      return {
        ["padding" + dir]: 16 + props4.insetLevel * 56 + "px"
      };
    });
    function onClick(e22) {
      if (isClickable.value === true) {
        if (blurTargetRef.value !== null) {
          if (e22.qKeyEvent !== true && document.activeElement === rootRef.value) {
            blurTargetRef.value.focus();
          } else if (document.activeElement === blurTargetRef.value) {
            rootRef.value.focus();
          }
        }
        navigateOnClick(e22);
      }
    }
    function onKeyup2(e22) {
      if (isClickable.value === true && isKeyCode$1(e22, [13, 32]) === true) {
        stopAndPrevent$1(e22);
        e22.qKeyEvent = true;
        const evt = new MouseEvent("click", e22);
        evt.qKeyEvent = true;
        rootRef.value.dispatchEvent(evt);
      }
      emit("keyup", e22);
    }
    function getContent() {
      const child = hUniqueSlot$1(slots.default, []);
      isClickable.value === true && child.unshift(
        h("div", { class: "q-focus-helper", tabindex: -1, ref: blurTargetRef })
      );
      return child;
    }
    return () => {
      const data = {
        ref: rootRef,
        class: classes.value,
        style: style2.value,
        role: "listitem",
        onClick,
        onKeyup: onKeyup2
      };
      if (isClickable.value === true) {
        data.tabindex = props4.tabindex || "0";
        Object.assign(data, linkAttrs.value);
      } else if (isActionable.value === true) {
        data["aria-disabled"] = "true";
      }
      return h(
        linkTag.value,
        data,
        getContent()
      );
    };
  }
});
var QItemSection_default$1 = createComponent$1({
  name: "QItemSection",
  props: {
    avatar: Boolean,
    thumbnail: Boolean,
    side: Boolean,
    top: Boolean,
    noWrap: Boolean
  },
  setup(props4, { slots }) {
    const classes = computed(
      () => `q-item__section column q-item__section--${props4.avatar === true || props4.side === true || props4.thumbnail === true ? "side" : "main"}` + (props4.top === true ? " q-item__section--top justify-start" : " justify-center") + (props4.avatar === true ? " q-item__section--avatar" : "") + (props4.thumbnail === true ? " q-item__section--thumbnail" : "") + (props4.noWrap === true ? " q-item__section--nowrap" : "")
    );
    return () => h("div", { class: classes.value }, hSlot$1(slots.default));
  }
});
function run$1(e22, btn, eVm) {
  if (btn.handler) {
    btn.handler(e22, eVm, eVm.caret);
  } else {
    eVm.runCmd(btn.cmd, btn.param);
  }
}
function getGroup$1(children) {
  return h("div", { class: "q-editor__toolbar-group" }, children);
}
function getBtn$1(eVm, btn, clickHandler, active = false) {
  const toggled = active || (btn.type === "toggle" ? btn.toggled ? btn.toggled(eVm) : btn.cmd && eVm.caret.is(btn.cmd, btn.param) : false), child = [];
  if (btn.tip && eVm.$q.platform.is.desktop) {
    const Key = btn.key ? h("div", [
      h("small", `(CTRL + ${String.fromCharCode(btn.key)})`)
    ]) : null;
    child.push(
      h(QTooltip_default$1, { delay: 1e3 }, () => [
        h("div", { innerHTML: btn.tip }),
        Key
      ])
    );
  }
  return h(QBtn_default$1, {
    ...eVm.buttonProps.value,
    icon: btn.icon !== null ? btn.icon : void 0,
    color: toggled ? btn.toggleColor || eVm.props.toolbarToggleColor : btn.color || eVm.props.toolbarColor,
    textColor: toggled && !eVm.props.toolbarPush ? null : btn.textColor || eVm.props.toolbarTextColor,
    label: btn.label,
    disable: btn.disable ? typeof btn.disable === "function" ? btn.disable(eVm) : true : false,
    size: "sm",
    onClick(e22) {
      clickHandler && clickHandler();
      run$1(e22, btn, eVm);
    }
  }, () => child);
}
function getDropdown$1(eVm, btn) {
  const onlyIcons = btn.list === "only-icons";
  let label = btn.label, icon = btn.icon !== null ? btn.icon : void 0, contentClass, Items;
  function closeDropdown() {
    Dropdown.component.proxy.hide();
  }
  if (onlyIcons) {
    Items = btn.options.map((btn2) => {
      const active = btn2.type === void 0 ? eVm.caret.is(btn2.cmd, btn2.param) : false;
      if (active) {
        label = btn2.tip;
        icon = btn2.icon !== null ? btn2.icon : void 0;
      }
      return getBtn$1(eVm, btn2, closeDropdown, active);
    });
    contentClass = eVm.toolbarBackgroundClass.value;
    Items = [
      getGroup$1(Items)
    ];
  } else {
    const activeClass = eVm.props.toolbarToggleColor !== void 0 ? `text-${eVm.props.toolbarToggleColor}` : null;
    const inactiveClass = eVm.props.toolbarTextColor !== void 0 ? `text-${eVm.props.toolbarTextColor}` : null;
    const noIcons = btn.list === "no-icons";
    Items = btn.options.map((btn2) => {
      const disable = btn2.disable ? btn2.disable(eVm) : false;
      const active = btn2.type === void 0 ? eVm.caret.is(btn2.cmd, btn2.param) : false;
      if (active) {
        label = btn2.tip;
        icon = btn2.icon !== null ? btn2.icon : void 0;
      }
      const htmlTip = btn2.htmlTip;
      return h(QItem_default$1, {
        active,
        activeClass,
        clickable: true,
        disable,
        dense: true,
        onClick(e22) {
          closeDropdown();
          eVm.contentRef.value !== null && eVm.contentRef.value.focus();
          eVm.caret.restore();
          run$1(e22, btn2, eVm);
        }
      }, () => [
        noIcons === true ? null : h(
          QItemSection_default$1,
          {
            class: active ? activeClass : inactiveClass,
            side: true
          },
          () => h(QIcon_default$1, { name: btn2.icon !== null ? btn2.icon : void 0 })
        ),
        h(
          QItemSection_default$1,
          htmlTip ? () => h("div", { class: "text-no-wrap", innerHTML: btn2.htmlTip }) : btn2.tip ? () => h("div", { class: "text-no-wrap" }, btn2.tip) : void 0
        )
      ]);
    });
    contentClass = [eVm.toolbarBackgroundClass.value, inactiveClass];
  }
  const highlight = btn.highlight && label !== btn.label;
  const Dropdown = h(QBtnDropdown_default$1, {
    ...eVm.buttonProps.value,
    noCaps: true,
    noWrap: true,
    color: highlight ? eVm.props.toolbarToggleColor : eVm.props.toolbarColor,
    textColor: highlight && !eVm.props.toolbarPush ? null : eVm.props.toolbarTextColor,
    label: btn.fixedLabel ? btn.label : label,
    icon: btn.fixedIcon ? btn.icon !== null ? btn.icon : void 0 : icon,
    contentClass,
    onShow: (evt) => eVm.emit("dropdownShow", evt),
    onHide: (evt) => eVm.emit("dropdownHide", evt),
    onBeforeShow: (evt) => eVm.emit("dropdownBeforeShow", evt),
    onBeforeHide: (evt) => eVm.emit("dropdownBeforeHide", evt)
  }, () => Items);
  return Dropdown;
}
function getToolbar$1(eVm) {
  if (eVm.caret) {
    return eVm.buttons.value.filter((f) => {
      return !eVm.isViewingSource.value || f.find((fb) => fb.cmd === "viewsource");
    }).map((group) => getGroup$1(
      group.map((btn) => {
        if (eVm.isViewingSource.value && btn.cmd !== "viewsource") {
          return false;
        }
        if (btn.type === "slot") {
          return hSlot$1(eVm.slots[btn.slot]);
        }
        if (btn.type === "dropdown") {
          return getDropdown$1(eVm, btn);
        }
        return getBtn$1(eVm, btn);
      })
    ));
  }
}
function getFonts$1(defaultFont, defaultFontLabel, defaultFontIcon, fonts = {}) {
  const aliases = Object.keys(fonts);
  if (aliases.length === 0) {
    return {};
  }
  const def = {
    default_font: {
      cmd: "fontName",
      param: defaultFont,
      icon: defaultFontIcon,
      tip: defaultFontLabel
    }
  };
  aliases.forEach((alias) => {
    const name2 = fonts[alias];
    def[alias] = {
      cmd: "fontName",
      param: name2,
      icon: defaultFontIcon,
      tip: name2,
      htmlTip: `<font face="${name2}">${name2}</font>`
    };
  });
  return def;
}
function getLinkEditor$1(eVm) {
  if (eVm.caret) {
    const color2 = eVm.props.toolbarColor || eVm.props.toolbarTextColor;
    let link = eVm.editLinkUrl.value;
    const updateLink = () => {
      eVm.caret.restore();
      if (link !== eVm.editLinkUrl.value) {
        document.execCommand("createLink", false, link === "" ? " " : link);
      }
      eVm.editLinkUrl.value = null;
    };
    return [
      h("div", { class: `q-mx-xs text-${color2}` }, `${eVm.$q.lang.editor.url}: `),
      h("input", {
        key: "qedt_btm_input",
        class: "col q-editor__link-input",
        value: link,
        onInput: (evt) => {
          stop$1(evt);
          link = evt.target.value;
        },
        onKeydown: (evt) => {
          if (shouldIgnoreKey$1(evt) === true) {
            return;
          }
          switch (evt.keyCode) {
            case 13:
              prevent$1(evt);
              return updateLink();
            case 27:
              prevent$1(evt);
              eVm.caret.restore();
              if (!eVm.editLinkUrl.value || eVm.editLinkUrl.value === "https://") {
                document.execCommand("unlink");
              }
              eVm.editLinkUrl.value = null;
              break;
          }
        }
      }),
      getGroup$1([
        h(QBtn_default$1, {
          key: "qedt_btm_rem",
          tabindex: -1,
          ...eVm.buttonProps.value,
          label: eVm.$q.lang.label.remove,
          noCaps: true,
          onClick: () => {
            eVm.caret.restore();
            document.execCommand("unlink");
            eVm.editLinkUrl.value = null;
          }
        }),
        h(QBtn_default$1, {
          key: "qedt_btm_upd",
          ...eVm.buttonProps.value,
          label: eVm.$q.lang.label.update,
          noCaps: true,
          onClick: updateLink
        })
      ])
    ];
  }
}
var listenerRE$1 = /^on[A-Z]/;
function use_split_attrs_default$1() {
  const { attrs, vnode } = getCurrentInstance();
  const acc = {
    listeners: ref$1({}),
    attributes: ref$1({})
  };
  function update6() {
    const attributes = {};
    const listeners = {};
    for (const key in attrs) {
      if (key !== "class" && key !== "style" && listenerRE$1.test(key) === false) {
        attributes[key] = attrs[key];
      }
    }
    for (const key in vnode.props) {
      if (listenerRE$1.test(key) === true) {
        listeners[key] = vnode.props[key];
      }
    }
    acc.attributes.value = attributes;
    acc.listeners.value = listeners;
  }
  onBeforeUpdate(update6);
  update6();
  return acc;
}
var toString$1 = Object.prototype.toString;
var hasOwn$2 = Object.prototype.hasOwnProperty;
var notPlainObject$1 = new Set(
  ["Boolean", "Number", "String", "Function", "Array", "Date", "RegExp"].map((name2) => "[object " + name2 + "]")
);
function isPlainObject$1(obj) {
  if (obj !== Object(obj) || notPlainObject$1.has(toString$1.call(obj)) === true) {
    return false;
  }
  if (obj.constructor && hasOwn$2.call(obj, "constructor") === false && hasOwn$2.call(obj.constructor.prototype, "isPrototypeOf") === false) {
    return false;
  }
  let key;
  for (key in obj) {
  }
  return key === void 0 || hasOwn$2.call(obj, key);
}
function extend$1() {
  let options, name2, src, copy, copyIsArray, clone2, target2 = arguments[0] || {}, i22 = 1, deep = false;
  const length = arguments.length;
  if (typeof target2 === "boolean") {
    deep = target2;
    target2 = arguments[1] || {};
    i22 = 2;
  }
  if (Object(target2) !== target2 && typeof target2 !== "function") {
    target2 = {};
  }
  if (length === i22) {
    target2 = this;
    i22--;
  }
  for (; i22 < length; i22++) {
    if ((options = arguments[i22]) !== null) {
      for (name2 in options) {
        src = target2[name2];
        copy = options[name2];
        if (target2 === copy) {
          continue;
        }
        if (deep === true && copy && ((copyIsArray = Array.isArray(copy)) || isPlainObject$1(copy) === true)) {
          if (copyIsArray === true) {
            clone2 = Array.isArray(src) === true ? src : [];
          } else {
            clone2 = isPlainObject$1(src) === true ? src : {};
          }
          target2[name2] = extend$1(deep, clone2, copy);
        } else if (copy !== void 0) {
          target2[name2] = copy;
        }
      }
    }
  }
  return target2;
}
createComponent$1({
  name: "QEditor",
  props: {
    ...useDarkProps$1,
    ...useFullscreenProps$1,
    modelValue: {
      type: String,
      required: true
    },
    readonly: Boolean,
    disable: Boolean,
    minHeight: {
      type: String,
      default: "10rem"
    },
    maxHeight: String,
    height: String,
    definitions: Object,
    fonts: Object,
    placeholder: String,
    toolbar: {
      type: Array,
      validator: (v) => v.length === 0 || v.every((group) => group.length),
      // long line on purpose for API validation purposes:
      default: () => [["left", "center", "right", "justify"], ["bold", "italic", "underline", "strike"], ["undo", "redo"]]
    },
    toolbarColor: String,
    toolbarBg: String,
    toolbarTextColor: String,
    toolbarToggleColor: {
      type: String,
      default: "primary"
    },
    toolbarOutline: Boolean,
    toolbarPush: Boolean,
    toolbarRounded: Boolean,
    paragraphTag: {
      type: String,
      validator: (v) => ["div", "p"].includes(v),
      default: "div"
    },
    contentStyle: Object,
    contentClass: [Object, Array, String],
    square: Boolean,
    flat: Boolean,
    dense: Boolean
  },
  emits: [
    ...useFullscreenEmits$1,
    "update:modelValue",
    "keydown",
    "click",
    "focus",
    "blur",
    "dropdownShow",
    "dropdownHide",
    "dropdownBeforeShow",
    "dropdownBeforeHide",
    "linkShow",
    "linkHide"
  ],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const isDark = use_dark_default$1(props4, $q);
    const { inFullscreen, toggleFullscreen } = use_fullscreen_default$1();
    const splitAttrs = use_split_attrs_default$1();
    const rootRef = ref$1(null);
    const contentRef = ref$1(null);
    const editLinkUrl = ref$1(null);
    const isViewingSource = ref$1(false);
    const editable = computed(() => !props4.readonly && !props4.disable);
    let defaultFont, offsetBottom;
    let lastEmit = props4.modelValue;
    {
      document.execCommand("defaultParagraphSeparator", false, props4.paragraphTag);
      defaultFont = window.getComputedStyle(document.body).fontFamily;
    }
    const toolbarBackgroundClass = computed(() => props4.toolbarBg ? ` bg-${props4.toolbarBg}` : "");
    const buttonProps = computed(() => {
      const flat = props4.toolbarOutline !== true && props4.toolbarPush !== true;
      return {
        type: "a",
        flat,
        noWrap: true,
        outline: props4.toolbarOutline,
        push: props4.toolbarPush,
        rounded: props4.toolbarRounded,
        dense: true,
        color: props4.toolbarColor,
        disable: !editable.value,
        size: "sm"
      };
    });
    const buttonDef = computed(() => {
      const e22 = $q.lang.editor, i22 = $q.iconSet.editor;
      return {
        bold: { cmd: "bold", icon: i22.bold, tip: e22.bold, key: 66 },
        italic: { cmd: "italic", icon: i22.italic, tip: e22.italic, key: 73 },
        strike: { cmd: "strikeThrough", icon: i22.strikethrough, tip: e22.strikethrough, key: 83 },
        underline: { cmd: "underline", icon: i22.underline, tip: e22.underline, key: 85 },
        unordered: { cmd: "insertUnorderedList", icon: i22.unorderedList, tip: e22.unorderedList },
        ordered: { cmd: "insertOrderedList", icon: i22.orderedList, tip: e22.orderedList },
        subscript: { cmd: "subscript", icon: i22.subscript, tip: e22.subscript, htmlTip: "x<subscript>2</subscript>" },
        superscript: { cmd: "superscript", icon: i22.superscript, tip: e22.superscript, htmlTip: "x<superscript>2</superscript>" },
        link: { cmd: "link", disable: (eVm2) => eVm2.caret && !eVm2.caret.can("link"), icon: i22.hyperlink, tip: e22.hyperlink, key: 76 },
        fullscreen: { cmd: "fullscreen", icon: i22.toggleFullscreen, tip: e22.toggleFullscreen, key: 70 },
        viewsource: { cmd: "viewsource", icon: i22.viewSource, tip: e22.viewSource },
        quote: { cmd: "formatBlock", param: "BLOCKQUOTE", icon: i22.quote, tip: e22.quote, key: 81 },
        left: { cmd: "justifyLeft", icon: i22.left, tip: e22.left },
        center: { cmd: "justifyCenter", icon: i22.center, tip: e22.center },
        right: { cmd: "justifyRight", icon: i22.right, tip: e22.right },
        justify: { cmd: "justifyFull", icon: i22.justify, tip: e22.justify },
        print: { type: "no-state", cmd: "print", icon: i22.print, tip: e22.print, key: 80 },
        outdent: { type: "no-state", disable: (eVm2) => eVm2.caret && !eVm2.caret.can("outdent"), cmd: "outdent", icon: i22.outdent, tip: e22.outdent },
        indent: { type: "no-state", disable: (eVm2) => eVm2.caret && !eVm2.caret.can("indent"), cmd: "indent", icon: i22.indent, tip: e22.indent },
        removeFormat: { type: "no-state", cmd: "removeFormat", icon: i22.removeFormat, tip: e22.removeFormat },
        hr: { type: "no-state", cmd: "insertHorizontalRule", icon: i22.hr, tip: e22.hr },
        undo: { type: "no-state", cmd: "undo", icon: i22.undo, tip: e22.undo, key: 90 },
        redo: { type: "no-state", cmd: "redo", icon: i22.redo, tip: e22.redo, key: 89 },
        h1: { cmd: "formatBlock", param: "H1", icon: i22.heading1 || i22.heading, tip: e22.heading1, htmlTip: `<h1 class="q-ma-none">${e22.heading1}</h1>` },
        h2: { cmd: "formatBlock", param: "H2", icon: i22.heading2 || i22.heading, tip: e22.heading2, htmlTip: `<h2 class="q-ma-none">${e22.heading2}</h2>` },
        h3: { cmd: "formatBlock", param: "H3", icon: i22.heading3 || i22.heading, tip: e22.heading3, htmlTip: `<h3 class="q-ma-none">${e22.heading3}</h3>` },
        h4: { cmd: "formatBlock", param: "H4", icon: i22.heading4 || i22.heading, tip: e22.heading4, htmlTip: `<h4 class="q-ma-none">${e22.heading4}</h4>` },
        h5: { cmd: "formatBlock", param: "H5", icon: i22.heading5 || i22.heading, tip: e22.heading5, htmlTip: `<h5 class="q-ma-none">${e22.heading5}</h5>` },
        h6: { cmd: "formatBlock", param: "H6", icon: i22.heading6 || i22.heading, tip: e22.heading6, htmlTip: `<h6 class="q-ma-none">${e22.heading6}</h6>` },
        p: { cmd: "formatBlock", param: props4.paragraphTag, icon: i22.heading, tip: e22.paragraph },
        code: { cmd: "formatBlock", param: "PRE", icon: i22.code, htmlTip: `<code>${e22.code}</code>` },
        "size-1": { cmd: "fontSize", param: "1", icon: i22.size1 || i22.size, tip: e22.size1, htmlTip: `<font size="1">${e22.size1}</font>` },
        "size-2": { cmd: "fontSize", param: "2", icon: i22.size2 || i22.size, tip: e22.size2, htmlTip: `<font size="2">${e22.size2}</font>` },
        "size-3": { cmd: "fontSize", param: "3", icon: i22.size3 || i22.size, tip: e22.size3, htmlTip: `<font size="3">${e22.size3}</font>` },
        "size-4": { cmd: "fontSize", param: "4", icon: i22.size4 || i22.size, tip: e22.size4, htmlTip: `<font size="4">${e22.size4}</font>` },
        "size-5": { cmd: "fontSize", param: "5", icon: i22.size5 || i22.size, tip: e22.size5, htmlTip: `<font size="5">${e22.size5}</font>` },
        "size-6": { cmd: "fontSize", param: "6", icon: i22.size6 || i22.size, tip: e22.size6, htmlTip: `<font size="6">${e22.size6}</font>` },
        "size-7": { cmd: "fontSize", param: "7", icon: i22.size7 || i22.size, tip: e22.size7, htmlTip: `<font size="7">${e22.size7}</font>` }
      };
    });
    const buttons = computed(() => {
      const userDef = props4.definitions || {};
      const def = props4.definitions || props4.fonts ? extend$1(
        true,
        {},
        buttonDef.value,
        userDef,
        getFonts$1(
          defaultFont,
          $q.lang.editor.defaultFont,
          $q.iconSet.editor.font,
          props4.fonts
        )
      ) : buttonDef.value;
      return props4.toolbar.map(
        (group) => group.map((token2) => {
          if (token2.options) {
            return {
              type: "dropdown",
              icon: token2.icon,
              label: token2.label,
              size: "sm",
              dense: true,
              fixedLabel: token2.fixedLabel,
              fixedIcon: token2.fixedIcon,
              highlight: token2.highlight,
              list: token2.list,
              options: token2.options.map((item) => def[item])
            };
          }
          const obj = def[token2];
          if (obj) {
            return obj.type === "no-state" || userDef[token2] && (obj.cmd === void 0 || buttonDef.value[obj.cmd] && buttonDef.value[obj.cmd].type === "no-state") ? obj : Object.assign({ type: "toggle" }, obj);
          } else {
            return {
              type: "slot",
              slot: token2
            };
          }
        })
      );
    });
    const eVm = {
      $q,
      props: props4,
      slots,
      emit,
      // caret (will get injected after mount)
      inFullscreen,
      toggleFullscreen,
      runCmd,
      isViewingSource,
      editLinkUrl,
      toolbarBackgroundClass,
      buttonProps,
      contentRef,
      buttons,
      setContent
    };
    watch(() => props4.modelValue, (v) => {
      if (lastEmit !== v) {
        lastEmit = v;
        setContent(v, true);
      }
    });
    watch(editLinkUrl, (v) => {
      emit(`link${v ? "Show" : "Hide"}`);
    });
    const hasToolbar = computed(() => props4.toolbar && props4.toolbar.length !== 0);
    const keys2 = computed(() => {
      const k22 = {}, add2 = (btn) => {
        if (btn.key) {
          k22[btn.key] = {
            cmd: btn.cmd,
            param: btn.param
          };
        }
      };
      buttons.value.forEach((group) => {
        group.forEach((token2) => {
          if (token2.options) {
            token2.options.forEach(add2);
          } else {
            add2(token2);
          }
        });
      });
      return k22;
    });
    const innerStyle = computed(() => inFullscreen.value ? props4.contentStyle : [
      {
        minHeight: props4.minHeight,
        height: props4.height,
        maxHeight: props4.maxHeight
      },
      props4.contentStyle
    ]);
    const classes = computed(
      () => `q-editor q-editor--${isViewingSource.value === true ? "source" : "default"}` + (props4.disable === true ? " disabled" : "") + (inFullscreen.value === true ? " fullscreen column" : "") + (props4.square === true ? " q-editor--square no-border-radius" : "") + (props4.flat === true ? " q-editor--flat" : "") + (props4.dense === true ? " q-editor--dense" : "") + (isDark.value === true ? " q-editor--dark q-dark" : "")
    );
    const innerClass = computed(() => [
      props4.contentClass,
      "q-editor__content",
      { col: inFullscreen.value, "overflow-auto": inFullscreen.value || props4.maxHeight }
    ]);
    const attributes = computed(() => props4.disable === true ? { "aria-disabled": "true" } : {});
    function onInput() {
      if (contentRef.value !== null) {
        const prop = `inner${isViewingSource.value === true ? "Text" : "HTML"}`;
        const val = contentRef.value[prop];
        if (val !== props4.modelValue) {
          lastEmit = val;
          emit("update:modelValue", val);
        }
      }
    }
    function onKeydown2(e22) {
      emit("keydown", e22);
      if (e22.ctrlKey !== true || shouldIgnoreKey$1(e22) === true) {
        refreshToolbar();
        return;
      }
      const key = e22.keyCode;
      const target2 = keys2.value[key];
      if (target2 !== void 0) {
        const { cmd, param } = target2;
        stopAndPrevent$1(e22);
        runCmd(cmd, param, false);
      }
    }
    function onClick(e22) {
      refreshToolbar();
      emit("click", e22);
    }
    function onBlur2(e22) {
      if (contentRef.value !== null) {
        const { scrollTop, scrollHeight } = contentRef.value;
        offsetBottom = scrollHeight - scrollTop;
      }
      eVm.caret.save();
      emit("blur", e22);
    }
    function onFocus(e22) {
      nextTick(() => {
        if (contentRef.value !== null && offsetBottom !== void 0) {
          contentRef.value.scrollTop = contentRef.value.scrollHeight - offsetBottom;
        }
      });
      emit("focus", e22);
    }
    function onFocusin(e22) {
      const root2 = rootRef.value;
      if (root2 !== null && root2.contains(e22.target) === true && (e22.relatedTarget === null || root2.contains(e22.relatedTarget) !== true)) {
        const prop = `inner${isViewingSource.value === true ? "Text" : "HTML"}`;
        eVm.caret.restorePosition(contentRef.value[prop].length);
        refreshToolbar();
      }
    }
    function onFocusout(e22) {
      const root2 = rootRef.value;
      if (root2 !== null && root2.contains(e22.target) === true && (e22.relatedTarget === null || root2.contains(e22.relatedTarget) !== true)) {
        eVm.caret.savePosition();
        refreshToolbar();
      }
    }
    function onPointerStart() {
      offsetBottom = void 0;
    }
    function onSelectionchange(e22) {
      eVm.caret.save();
    }
    function setContent(v, restorePosition) {
      if (contentRef.value !== null) {
        if (restorePosition === true) {
          eVm.caret.savePosition();
        }
        const prop = `inner${isViewingSource.value === true ? "Text" : "HTML"}`;
        contentRef.value[prop] = v;
        if (restorePosition === true) {
          eVm.caret.restorePosition(contentRef.value[prop].length);
          refreshToolbar();
        }
      }
    }
    function runCmd(cmd, param, update6 = true) {
      focus();
      eVm.caret.restore();
      eVm.caret.apply(cmd, param, () => {
        focus();
        eVm.caret.save();
        if (update6) {
          refreshToolbar();
        }
      });
    }
    function refreshToolbar() {
      setTimeout(() => {
        editLinkUrl.value = null;
        proxy.$forceUpdate();
      }, 1);
    }
    function focus() {
      addFocusFn$1(() => {
        contentRef.value !== null && contentRef.value.focus({ preventScroll: true });
      });
    }
    function getContentEl() {
      return contentRef.value;
    }
    onMounted(() => {
      eVm.caret = proxy.caret = new Caret$1(contentRef.value, eVm);
      setContent(props4.modelValue);
      refreshToolbar();
      document.addEventListener("selectionchange", onSelectionchange);
    });
    onBeforeUnmount(() => {
      document.removeEventListener("selectionchange", onSelectionchange);
    });
    Object.assign(proxy, {
      runCmd,
      refreshToolbar,
      focus,
      getContentEl
    });
    return () => {
      let toolbars;
      if (hasToolbar.value) {
        const bars = [
          h("div", {
            key: "qedt_top",
            class: "q-editor__toolbar row no-wrap scroll-x" + toolbarBackgroundClass.value
          }, getToolbar$1(eVm))
        ];
        editLinkUrl.value !== null && bars.push(
          h("div", {
            key: "qedt_btm",
            class: "q-editor__toolbar row no-wrap items-center scroll-x" + toolbarBackgroundClass.value
          }, getLinkEditor$1(eVm))
        );
        toolbars = h("div", {
          key: "toolbar_ctainer",
          class: "q-editor__toolbars-container"
        }, bars);
      }
      return h("div", {
        ref: rootRef,
        class: classes.value,
        style: { height: inFullscreen.value === true ? "100%" : null },
        ...attributes.value,
        onFocusin,
        onFocusout
      }, [
        toolbars,
        h("div", {
          ref: contentRef,
          style: innerStyle.value,
          class: innerClass.value,
          contenteditable: editable.value,
          placeholder: props4.placeholder,
          ...{},
          ...splitAttrs.listeners.value,
          onInput,
          onKeydown: onKeydown2,
          onClick,
          onBlur: onBlur2,
          onFocus,
          // clean saved scroll position
          onMousedown: onPointerStart,
          onTouchstartPassive: onPointerStart
        })
      ]);
    };
  }
});
var QItemLabel_default$1 = createComponent$1({
  name: "QItemLabel",
  props: {
    overline: Boolean,
    caption: Boolean,
    header: Boolean,
    lines: [Number, String]
  },
  setup(props4, { slots }) {
    const parsedLines = computed(() => parseInt(props4.lines, 10));
    const classes = computed(
      () => "q-item__label" + (props4.overline === true ? " q-item__label--overline text-overline" : "") + (props4.caption === true ? " q-item__label--caption text-caption" : "") + (props4.header === true ? " q-item__label--header" : "") + (parsedLines.value === 1 ? " ellipsis" : "")
    );
    const style2 = computed(() => {
      return props4.lines !== void 0 && parsedLines.value > 1 ? {
        overflow: "hidden",
        display: "-webkit-box",
        "-webkit-box-orient": "vertical",
        "-webkit-line-clamp": parsedLines.value
      } : null;
    });
    return () => h("div", {
      style: style2.value,
      class: classes.value
    }, hSlot$1(slots.default));
  }
});
var QSlideTransition_default$1 = createComponent$1({
  name: "QSlideTransition",
  props: {
    appear: Boolean,
    duration: {
      type: Number,
      default: 300
    }
  },
  emits: ["show", "hide"],
  setup(props4, { slots, emit }) {
    let animating = false, doneFn, element;
    let timer2 = null, timerFallback = null, animListener, lastEvent;
    function cleanup() {
      doneFn && doneFn();
      doneFn = null;
      animating = false;
      if (timer2 !== null) {
        clearTimeout(timer2);
        timer2 = null;
      }
      if (timerFallback !== null) {
        clearTimeout(timerFallback);
        timerFallback = null;
      }
      element !== void 0 && element.removeEventListener("transitionend", animListener);
      animListener = null;
    }
    function begin(el, height2, done) {
      if (height2 !== void 0) {
        el.style.height = `${height2}px`;
      }
      el.style.transition = `height ${props4.duration}ms cubic-bezier(.25, .8, .50, 1)`;
      animating = true;
      doneFn = done;
    }
    function end(el, event) {
      el.style.overflowY = null;
      el.style.height = null;
      el.style.transition = null;
      cleanup();
      event !== lastEvent && emit(event);
    }
    function onEnter(el, done) {
      let pos = 0;
      element = el;
      if (animating === true) {
        cleanup();
        pos = el.offsetHeight === el.scrollHeight ? 0 : void 0;
      } else {
        lastEvent = "hide";
        el.style.overflowY = "hidden";
      }
      begin(el, pos, done);
      timer2 = setTimeout(() => {
        timer2 = null;
        el.style.height = `${el.scrollHeight}px`;
        animListener = (evt) => {
          timerFallback = null;
          if (Object(evt) !== evt || evt.target === el) {
            end(el, "show");
          }
        };
        el.addEventListener("transitionend", animListener);
        timerFallback = setTimeout(animListener, props4.duration * 1.1);
      }, 100);
    }
    function onLeave(el, done) {
      let pos;
      element = el;
      if (animating === true) {
        cleanup();
      } else {
        lastEvent = "show";
        el.style.overflowY = "hidden";
        pos = el.scrollHeight;
      }
      begin(el, pos, done);
      timer2 = setTimeout(() => {
        timer2 = null;
        el.style.height = 0;
        animListener = (evt) => {
          timerFallback = null;
          if (Object(evt) !== evt || evt.target === el) {
            end(el, "hide");
          }
        };
        el.addEventListener("transitionend", animListener);
        timerFallback = setTimeout(animListener, props4.duration * 1.1);
      }, 100);
    }
    onBeforeUnmount(() => {
      animating === true && cleanup();
    });
    return () => h(Transition, {
      css: false,
      appear: props4.appear,
      onEnter,
      onLeave
    }, slots.default);
  }
});
var insetMap$1 = {
  true: "inset",
  item: "item-inset",
  "item-thumbnail": "item-thumbnail-inset"
};
var margins$1 = {
  xs: 2,
  sm: 4,
  md: 8,
  lg: 16,
  xl: 24
};
var QSeparator_default$1 = createComponent$1({
  name: "QSeparator",
  props: {
    ...useDarkProps$1,
    spaced: [Boolean, String],
    inset: [Boolean, String],
    vertical: Boolean,
    color: String,
    size: String
  },
  setup(props4) {
    const vm2 = getCurrentInstance();
    const isDark = use_dark_default$1(props4, vm2.proxy.$q);
    const orientation = computed(() => props4.vertical === true ? "vertical" : "horizontal");
    const orientClass = computed(() => ` q-separator--${orientation.value}`);
    const insetClass = computed(() => props4.inset !== false ? `${orientClass.value}-${insetMap$1[props4.inset]}` : "");
    const classes = computed(
      () => `q-separator${orientClass.value}${insetClass.value}` + (props4.color !== void 0 ? ` bg-${props4.color}` : "") + (isDark.value === true ? " q-separator--dark" : "")
    );
    const style2 = computed(() => {
      const acc = {};
      if (props4.size !== void 0) {
        acc[props4.vertical === true ? "width" : "height"] = props4.size;
      }
      if (props4.spaced !== false) {
        const size2 = props4.spaced === true ? `${margins$1.md}px` : props4.spaced in margins$1 ? `${margins$1[props4.spaced]}px` : props4.spaced;
        const dir = props4.vertical === true ? ["Left", "Right"] : ["Top", "Bottom"];
        acc[`margin${dir[0]}`] = acc[`margin${dir[1]}`] = size2;
      }
      return acc;
    });
    return () => h("hr", {
      class: classes.value,
      style: style2.value,
      "aria-orientation": orientation.value
    });
  }
});
var itemGroups$1 = shallowReactive({});
var LINK_PROPS$1 = Object.keys(useRouterLinkProps$1);
var QExpansionItem_default = createComponent$1({
  name: "QExpansionItem",
  props: {
    ...useRouterLinkProps$1,
    ...useModelToggleProps$1,
    ...useDarkProps$1,
    icon: String,
    label: String,
    labelLines: [Number, String],
    caption: String,
    captionLines: [Number, String],
    dense: Boolean,
    toggleAriaLabel: String,
    expandIcon: String,
    expandedIcon: String,
    expandIconClass: [Array, String, Object],
    duration: {},
    headerInsetLevel: Number,
    contentInsetLevel: Number,
    expandSeparator: Boolean,
    defaultOpened: Boolean,
    hideExpandIcon: Boolean,
    expandIconToggle: Boolean,
    switchToggleSide: Boolean,
    denseToggle: Boolean,
    group: String,
    popup: Boolean,
    headerStyle: [Array, String, Object],
    headerClass: [Array, String, Object]
  },
  emits: [
    ...useModelToggleEmits$1,
    "click",
    "afterShow",
    "afterHide"
  ],
  setup(props4, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const isDark = use_dark_default$1(props4, $q);
    const showing = ref$1(
      props4.modelValue !== null ? props4.modelValue : props4.defaultOpened
    );
    const blurTargetRef = ref$1(null);
    const targetUid = use_id_default$1();
    const { show, hide, toggle } = use_model_toggle_default$1({ showing });
    let uniqueId, exitGroup;
    const classes = computed(
      () => `q-expansion-item q-item-type q-expansion-item--${showing.value === true ? "expanded" : "collapsed"} q-expansion-item--${props4.popup === true ? "popup" : "standard"}`
    );
    const contentStyle = computed(() => {
      if (props4.contentInsetLevel === void 0) {
        return null;
      }
      const dir = $q.lang.rtl === true ? "Right" : "Left";
      return {
        ["padding" + dir]: props4.contentInsetLevel * 56 + "px"
      };
    });
    const hasLink = computed(
      () => props4.disable !== true && (props4.href !== void 0 || props4.to !== void 0 && props4.to !== null && props4.to !== "")
    );
    const linkProps = computed(() => {
      const acc = {};
      LINK_PROPS$1.forEach((key) => {
        acc[key] = props4[key];
      });
      return acc;
    });
    const isClickable = computed(
      () => hasLink.value === true || props4.expandIconToggle !== true
    );
    const expansionIcon = computed(() => props4.expandedIcon !== void 0 && showing.value === true ? props4.expandedIcon : props4.expandIcon || $q.iconSet.expansionItem[props4.denseToggle === true ? "denseIcon" : "icon"]);
    const activeToggleIcon = computed(
      () => props4.disable !== true && (hasLink.value === true || props4.expandIconToggle === true)
    );
    const headerSlotScope = computed(() => ({
      expanded: showing.value === true,
      detailsId: targetUid.value,
      toggle,
      show,
      hide
    }));
    const toggleAriaAttrs = computed(() => {
      const toggleAriaLabel = props4.toggleAriaLabel !== void 0 ? props4.toggleAriaLabel : $q.lang.label[showing.value === true ? "collapse" : "expand"](props4.label);
      return {
        role: "button",
        "aria-expanded": showing.value === true ? "true" : "false",
        "aria-controls": targetUid.value,
        "aria-label": toggleAriaLabel
      };
    });
    watch(() => props4.group, (name2) => {
      exitGroup !== void 0 && exitGroup();
      name2 !== void 0 && enterGroup();
    });
    function onHeaderClick(e22) {
      hasLink.value !== true && toggle(e22);
      emit("click", e22);
    }
    function toggleIconKeyboard(e22) {
      e22.keyCode === 13 && toggleIcon(e22, true);
    }
    function toggleIcon(e22, keyboard) {
      keyboard !== true && blurTargetRef.value !== null && blurTargetRef.value.focus();
      toggle(e22);
      stopAndPrevent$1(e22);
    }
    function onShow() {
      emit("afterShow");
    }
    function onHide() {
      emit("afterHide");
    }
    function enterGroup() {
      if (uniqueId === void 0) {
        uniqueId = uid_default$1();
      }
      if (showing.value === true) {
        itemGroups$1[props4.group] = uniqueId;
      }
      const show2 = watch(showing, (val) => {
        if (val === true) {
          itemGroups$1[props4.group] = uniqueId;
        } else if (itemGroups$1[props4.group] === uniqueId) {
          delete itemGroups$1[props4.group];
        }
      });
      const group = watch(
        () => itemGroups$1[props4.group],
        (val, oldVal) => {
          if (oldVal === uniqueId && val !== void 0 && val !== uniqueId) {
            hide();
          }
        }
      );
      exitGroup = () => {
        show2();
        group();
        if (itemGroups$1[props4.group] === uniqueId) {
          delete itemGroups$1[props4.group];
        }
        exitGroup = void 0;
      };
    }
    function getToggleIcon() {
      const data = {
        class: [
          `q-focusable relative-position cursor-pointer${props4.denseToggle === true && props4.switchToggleSide === true ? " items-end" : ""}`,
          props4.expandIconClass
        ],
        side: props4.switchToggleSide !== true,
        avatar: props4.switchToggleSide
      };
      const child = [
        h(QIcon_default$1, {
          class: "q-expansion-item__toggle-icon" + (props4.expandedIcon === void 0 && showing.value === true ? " q-expansion-item__toggle-icon--rotated" : ""),
          name: expansionIcon.value
        })
      ];
      if (activeToggleIcon.value === true) {
        Object.assign(data, {
          tabindex: 0,
          ...toggleAriaAttrs.value,
          onClick: toggleIcon,
          onKeyup: toggleIconKeyboard
        });
        child.unshift(
          h("div", {
            ref: blurTargetRef,
            class: "q-expansion-item__toggle-focus q-icon q-focus-helper q-focus-helper--rounded",
            tabindex: -1
          })
        );
      }
      return h(QItemSection_default$1, data, () => child);
    }
    function getHeaderChild() {
      let child;
      if (slots.header !== void 0) {
        child = [].concat(slots.header(headerSlotScope.value));
      } else {
        child = [
          h(QItemSection_default$1, () => [
            h(QItemLabel_default$1, { lines: props4.labelLines }, () => props4.label || ""),
            props4.caption ? h(QItemLabel_default$1, { lines: props4.captionLines, caption: true }, () => props4.caption) : null
          ])
        ];
        props4.icon && child[props4.switchToggleSide === true ? "push" : "unshift"](
          h(QItemSection_default$1, {
            side: props4.switchToggleSide === true,
            avatar: props4.switchToggleSide !== true
          }, () => h(QIcon_default$1, { name: props4.icon }))
        );
      }
      if (props4.disable !== true && props4.hideExpandIcon !== true) {
        child[props4.switchToggleSide === true ? "unshift" : "push"](
          getToggleIcon()
        );
      }
      return child;
    }
    function getHeader() {
      const data = {
        ref: "item",
        style: props4.headerStyle,
        class: props4.headerClass,
        dark: isDark.value,
        disable: props4.disable,
        dense: props4.dense,
        insetLevel: props4.headerInsetLevel
      };
      if (isClickable.value === true) {
        data.clickable = true;
        data.onClick = onHeaderClick;
        Object.assign(
          data,
          hasLink.value === true ? linkProps.value : toggleAriaAttrs.value
        );
      }
      return h(QItem_default$1, data, getHeaderChild);
    }
    function getTransitionChild() {
      return withDirectives(
        h("div", {
          key: "e-content",
          class: "q-expansion-item__content relative-position",
          style: contentStyle.value,
          id: targetUid.value
        }, hSlot$1(slots.default)),
        [[
          vShow,
          showing.value
        ]]
      );
    }
    function getContent() {
      const node = [
        getHeader(),
        h(QSlideTransition_default$1, {
          duration: props4.duration,
          onShow,
          onHide
        }, getTransitionChild)
      ];
      if (props4.expandSeparator === true) {
        node.push(
          h(QSeparator_default$1, {
            class: "q-expansion-item__border q-expansion-item__border--top absolute-top",
            dark: isDark.value
          }),
          h(QSeparator_default$1, {
            class: "q-expansion-item__border q-expansion-item__border--bottom absolute-bottom",
            dark: isDark.value
          })
        );
      }
      return node;
    }
    props4.group !== void 0 && enterGroup();
    onBeforeUnmount(() => {
      exitGroup !== void 0 && exitGroup();
    });
    return () => h("div", { class: classes.value }, [
      h("div", { class: "q-expansion-item__container relative-position" }, getContent())
    ]);
  }
});
var labelPositions$1 = ["top", "right", "bottom", "left"];
var useFabProps$1 = {
  type: {
    type: String,
    default: "a"
  },
  outline: Boolean,
  push: Boolean,
  flat: Boolean,
  unelevated: Boolean,
  color: String,
  textColor: String,
  glossy: Boolean,
  square: Boolean,
  padding: String,
  label: {
    type: [String, Number],
    default: ""
  },
  labelPosition: {
    type: String,
    default: "right",
    validator: (v) => labelPositions$1.includes(v)
  },
  externalLabel: Boolean,
  hideLabel: {
    type: Boolean
  },
  labelClass: [Array, String, Object],
  labelStyle: [Array, String, Object],
  disable: Boolean,
  tabindex: [Number, String]
};
function use_fab_default$1(props4, showing) {
  return {
    formClass: computed(
      () => `q-fab--form-${props4.square === true ? "square" : "rounded"}`
    ),
    stacked: computed(
      () => props4.externalLabel === false && ["top", "bottom"].includes(props4.labelPosition)
    ),
    labelProps: computed(() => {
      if (props4.externalLabel === true) {
        const hideLabel = props4.hideLabel === null ? showing.value === false : props4.hideLabel;
        return {
          action: "push",
          data: {
            class: [
              props4.labelClass,
              `q-fab__label q-tooltip--style q-fab__label--external q-fab__label--external-${props4.labelPosition}` + (hideLabel === true ? " q-fab__label--external-hidden" : "")
            ],
            style: props4.labelStyle
          }
        };
      }
      return {
        action: ["left", "top"].includes(props4.labelPosition) ? "unshift" : "push",
        data: {
          class: [
            props4.labelClass,
            `q-fab__label q-fab__label--internal q-fab__label--internal-${props4.labelPosition}` + (props4.hideLabel === true ? " q-fab__label--internal-hidden" : "")
          ],
          style: props4.labelStyle
        }
      };
    })
  };
}
var directions$1 = ["up", "right", "down", "left"];
var alignValues4$1 = ["left", "center", "right"];
createComponent$1({
  name: "QFab",
  props: {
    ...useFabProps$1,
    ...useModelToggleProps$1,
    icon: String,
    activeIcon: String,
    hideIcon: Boolean,
    hideLabel: {
      ...useFabProps$1.hideLabel,
      default: null
    },
    direction: {
      type: String,
      default: "right",
      validator: (v) => directions$1.includes(v)
    },
    persistent: Boolean,
    verticalActionsAlign: {
      type: String,
      default: "center",
      validator: (v) => alignValues4$1.includes(v)
    }
  },
  emits: useModelToggleEmits$1,
  setup(props4, { slots }) {
    const triggerRef = ref$1(null);
    const showing = ref$1(props4.modelValue === true);
    const targetUid = use_id_default$1();
    const { proxy: { $q } } = getCurrentInstance();
    const { formClass, labelProps } = use_fab_default$1(props4, showing);
    const hideOnRouteChange = computed(() => props4.persistent !== true);
    const { hide, toggle } = use_model_toggle_default$1({
      showing,
      hideOnRouteChange
    });
    const slotScope = computed(() => ({ opened: showing.value }));
    const classes = computed(
      () => `q-fab z-fab row inline justify-center q-fab--align-${props4.verticalActionsAlign} ${formClass.value}` + (showing.value === true ? " q-fab--opened" : " q-fab--closed")
    );
    const actionClass = computed(
      () => `q-fab__actions flex no-wrap inline q-fab__actions--${props4.direction} q-fab__actions--${showing.value === true ? "opened" : "closed"}`
    );
    const actionAttrs = computed(() => {
      const attrs = {
        id: targetUid.value,
        role: "menu"
      };
      if (showing.value !== true) {
        attrs["aria-hidden"] = "true";
      }
      return attrs;
    });
    const iconHolderClass = computed(
      () => `q-fab__icon-holder  q-fab__icon-holder--${showing.value === true ? "opened" : "closed"}`
    );
    function getIcon(kebab, camel) {
      const slotFn = slots[kebab];
      const classes2 = `q-fab__${kebab} absolute-full`;
      return slotFn === void 0 ? h(QIcon_default$1, { class: classes2, name: props4[camel] || $q.iconSet.fab[camel] }) : h("div", { class: classes2 }, slotFn(slotScope.value));
    }
    function getTriggerContent() {
      const child = [];
      props4.hideIcon !== true && child.push(
        h("div", { class: iconHolderClass.value }, [
          getIcon("icon", "icon"),
          getIcon("active-icon", "activeIcon")
        ])
      );
      if (props4.label !== "" || slots.label !== void 0) {
        child[labelProps.value.action](
          h("div", labelProps.value.data, slots.label !== void 0 ? slots.label(slotScope.value) : [props4.label])
        );
      }
      return hMergeSlot$1(slots.tooltip, child);
    }
    provide(fabKey$1, {
      showing,
      onChildClick(evt) {
        hide(evt);
        if (triggerRef.value !== null) {
          triggerRef.value.$el.focus();
        }
      }
    });
    return () => h("div", {
      class: classes.value
    }, [
      h(QBtn_default$1, {
        ref: triggerRef,
        class: formClass.value,
        ...props4,
        noWrap: true,
        stack: props4.stacked,
        align: void 0,
        icon: void 0,
        label: void 0,
        noCaps: true,
        fab: true,
        "aria-expanded": showing.value === true ? "true" : "false",
        "aria-haspopup": "true",
        "aria-controls": targetUid.value,
        onClick: toggle
      }, getTriggerContent),
      h("div", { class: actionClass.value, ...actionAttrs.value }, hSlot$1(slots.default))
    ]);
  }
});
var anchorMap$1 = {
  start: "self-end",
  center: "self-center",
  end: "self-start"
};
var anchorValues$1 = Object.keys(anchorMap$1);
createComponent$1({
  name: "QFabAction",
  props: {
    ...useFabProps$1,
    icon: {
      type: String,
      default: ""
    },
    anchor: {
      type: String,
      validator: (v) => anchorValues$1.includes(v)
    },
    to: [String, Object],
    replace: Boolean
  },
  emits: ["click"],
  setup(props4, { slots, emit }) {
    const $fab = inject(fabKey$1, () => ({
      showing: { value: true },
      onChildClick: noop$1
    }));
    const { formClass, labelProps } = use_fab_default$1(props4, $fab.showing);
    const classes = computed(() => {
      const align = anchorMap$1[props4.anchor];
      return formClass.value + (align !== void 0 ? ` ${align}` : "");
    });
    const isDisabled = computed(
      () => props4.disable === true || $fab.showing.value !== true
    );
    function click(e22) {
      $fab.onChildClick(e22);
      emit("click", e22);
    }
    function getContent() {
      const child = [];
      if (slots.icon !== void 0) {
        child.push(slots.icon());
      } else if (props4.icon !== "") {
        child.push(
          h(QIcon_default$1, { name: props4.icon })
        );
      }
      if (props4.label !== "" || slots.label !== void 0) {
        child[labelProps.value.action](
          h("div", labelProps.value.data, slots.label !== void 0 ? slots.label() : [props4.label])
        );
      }
      return hMergeSlot$1(slots.default, child);
    }
    const vm2 = getCurrentInstance();
    Object.assign(vm2.proxy, { click });
    return () => h(QBtn_default$1, {
      class: classes.value,
      ...props4,
      noWrap: true,
      stack: props4.stacked,
      icon: void 0,
      label: void 0,
      noCaps: true,
      fabMini: true,
      disable: isDisabled.value,
      onClick: click
    }, getContent);
  }
});
function use_form_child_default$1({ validate: validate2, resetValidation, requiresQForm }) {
  const $form = inject(formKey$1, false);
  if ($form !== false) {
    const { props: props4, proxy } = getCurrentInstance();
    Object.assign(proxy, { validate: validate2, resetValidation });
    watch(() => props4.disable, (val) => {
      if (val === true) {
        typeof resetValidation === "function" && resetValidation();
        $form.unbindComponent(proxy);
      } else {
        $form.bindComponent(proxy);
      }
    });
    onMounted(() => {
      props4.disable !== true && $form.bindComponent(proxy);
    });
    onBeforeUnmount(() => {
      props4.disable !== true && $form.unbindComponent(proxy);
    });
  } else if (requiresQForm === true) {
    console.error("Parent QForm not found on useFormChild()!");
  }
}
var lazyRulesValues$1 = [true, false, "ondemand"];
var useValidateProps$1 = {
  modelValue: {},
  error: {
    type: Boolean,
    default: null
  },
  errorMessage: String,
  noErrorIcon: Boolean,
  rules: Array,
  reactiveRules: Boolean,
  lazyRules: {
    type: [Boolean, String],
    default: false,
    // statement unneeded but avoids future vue implementation changes
    validator: (v) => lazyRulesValues$1.includes(v)
  }
};
function use_validate_default$1(focused, innerLoading) {
  const { props: props4, proxy } = getCurrentInstance();
  const innerError = ref$1(false);
  const innerErrorMessage = ref$1(null);
  const isDirtyModel = ref$1(false);
  use_form_child_default$1({ validate: validate2, resetValidation });
  let validateIndex = 0, unwatchRules;
  const hasRules = computed(
    () => props4.rules !== void 0 && props4.rules !== null && props4.rules.length !== 0
  );
  const canDebounceValidate = computed(() => props4.disable !== true && hasRules.value === true && innerLoading.value === false);
  const hasError = computed(
    () => props4.error === true || innerError.value === true
  );
  const errorMessage = computed(() => typeof props4.errorMessage === "string" && props4.errorMessage.length !== 0 ? props4.errorMessage : innerErrorMessage.value);
  watch(() => props4.modelValue, () => {
    isDirtyModel.value = true;
    if (canDebounceValidate.value === true && props4.lazyRules === false) {
      debouncedValidate();
    }
  });
  function onRulesChange() {
    if (props4.lazyRules !== "ondemand" && canDebounceValidate.value === true && isDirtyModel.value === true) {
      debouncedValidate();
    }
  }
  watch(() => props4.reactiveRules, (val) => {
    if (val === true) {
      if (unwatchRules === void 0) {
        unwatchRules = watch(() => props4.rules, onRulesChange, { immediate: true, deep: true });
      }
    } else if (unwatchRules !== void 0) {
      unwatchRules();
      unwatchRules = void 0;
    }
  }, { immediate: true });
  watch(() => props4.lazyRules, onRulesChange);
  watch(focused, (val) => {
    if (val === true) {
      isDirtyModel.value = true;
    } else if (canDebounceValidate.value === true && props4.lazyRules !== "ondemand") {
      debouncedValidate();
    }
  });
  function resetValidation() {
    validateIndex++;
    innerLoading.value = false;
    isDirtyModel.value = false;
    innerError.value = false;
    innerErrorMessage.value = null;
    debouncedValidate.cancel();
  }
  function validate2(val = props4.modelValue) {
    if (props4.disable === true || hasRules.value === false) {
      return true;
    }
    const index2 = ++validateIndex;
    const setDirty = innerLoading.value !== true ? () => {
      isDirtyModel.value = true;
    } : () => {
    };
    const update6 = (err, msg) => {
      err === true && setDirty();
      innerError.value = err;
      innerErrorMessage.value = msg || null;
      innerLoading.value = false;
    };
    const promises = [];
    for (let i22 = 0; i22 < props4.rules.length; i22++) {
      const rule = props4.rules[i22];
      let res;
      if (typeof rule === "function") {
        res = rule(val, testPattern$1);
      } else if (typeof rule === "string" && testPattern$1[rule] !== void 0) {
        res = testPattern$1[rule](val);
      }
      if (res === false || typeof res === "string") {
        update6(true, res);
        return false;
      } else if (res !== true && res !== void 0) {
        promises.push(res);
      }
    }
    if (promises.length === 0) {
      update6(false);
      return true;
    }
    innerLoading.value = true;
    return Promise.all(promises).then(
      (res) => {
        if (res === void 0 || Array.isArray(res) === false || res.length === 0) {
          index2 === validateIndex && update6(false);
          return true;
        }
        const msg = res.find((r) => r === false || typeof r === "string");
        index2 === validateIndex && update6(msg !== void 0, msg);
        return msg === void 0;
      },
      (e22) => {
        if (index2 === validateIndex) {
          console.error(e22);
          update6(true);
        }
        return false;
      }
    );
  }
  const debouncedValidate = debounce_default$1(validate2, 0);
  onBeforeUnmount(() => {
    unwatchRules !== void 0 && unwatchRules();
    debouncedValidate.cancel();
  });
  Object.assign(proxy, { resetValidation, validate: validate2 });
  injectProp$1(proxy, "hasError", () => hasError.value);
  return {
    isDirtyModel,
    hasRules,
    hasError,
    errorMessage,
    validate: validate2,
    resetValidation
  };
}
function fieldValueIsFilled$1(val) {
  return val !== void 0 && val !== null && ("" + val).length !== 0;
}
var useNonInputFieldProps$1 = {
  ...useDarkProps$1,
  ...useValidateProps$1,
  label: String,
  stackLabel: Boolean,
  hint: String,
  hideHint: Boolean,
  prefix: String,
  suffix: String,
  labelColor: String,
  color: String,
  bgColor: String,
  filled: Boolean,
  outlined: Boolean,
  borderless: Boolean,
  standout: [Boolean, String],
  square: Boolean,
  loading: Boolean,
  labelSlot: Boolean,
  bottomSlots: Boolean,
  hideBottomSpace: Boolean,
  rounded: Boolean,
  dense: Boolean,
  itemAligned: Boolean,
  counter: Boolean,
  clearable: Boolean,
  clearIcon: String,
  disable: Boolean,
  readonly: Boolean,
  autofocus: Boolean,
  for: String
};
var useFieldProps$1 = {
  ...useNonInputFieldProps$1,
  maxlength: [Number, String]
};
var useFieldEmits$1 = ["update:modelValue", "clear", "focus", "blur"];
function useFieldState$1({ requiredForAttr = true, tagProp, changeEvent = false } = {}) {
  const { props: props4, proxy } = getCurrentInstance();
  const isDark = use_dark_default$1(props4, proxy.$q);
  const targetUid = use_id_default$1({
    required: requiredForAttr,
    getValue: () => props4.for
  });
  return {
    requiredForAttr,
    changeEvent,
    tag: tagProp === true ? computed(() => props4.tag) : { value: "label" },
    isDark,
    editable: computed(
      () => props4.disable !== true && props4.readonly !== true
    ),
    innerLoading: ref$1(false),
    focused: ref$1(false),
    hasPopupOpen: false,
    splitAttrs: use_split_attrs_default$1(),
    targetUid,
    rootRef: ref$1(null),
    targetRef: ref$1(null),
    controlRef: ref$1(null)
    /**
         * user supplied additionals:
    
         * innerValue - computed
         * floatingLabel - computed
         * inputRef - computed
    
         * fieldClass - computed
         * hasShadow - computed
    
         * controlEvents - Object with fn(e)
    
         * getControl - fn
         * getInnerAppend - fn
         * getControlChild - fn
         * getShadowControl - fn
         * showPopup - fn
         */
  };
}
function use_field_default$1(state2) {
  const { props: props4, emit, slots, attrs, proxy } = getCurrentInstance();
  const { $q } = proxy;
  let focusoutTimer = null;
  if (state2.hasValue === void 0) {
    state2.hasValue = computed(() => fieldValueIsFilled$1(props4.modelValue));
  }
  if (state2.emitValue === void 0) {
    state2.emitValue = (value2) => {
      emit("update:modelValue", value2);
    };
  }
  if (state2.controlEvents === void 0) {
    state2.controlEvents = {
      onFocusin: onControlFocusin,
      onFocusout: onControlFocusout
    };
  }
  Object.assign(state2, {
    clearValue,
    onControlFocusin,
    onControlFocusout,
    focus
  });
  if (state2.computedCounter === void 0) {
    state2.computedCounter = computed(() => {
      if (props4.counter !== false) {
        const len = typeof props4.modelValue === "string" || typeof props4.modelValue === "number" ? ("" + props4.modelValue).length : Array.isArray(props4.modelValue) === true ? props4.modelValue.length : 0;
        const max2 = props4.maxlength !== void 0 ? props4.maxlength : props4.maxValues;
        return len + (max2 !== void 0 ? " / " + max2 : "");
      }
    });
  }
  const {
    isDirtyModel,
    hasRules,
    hasError,
    errorMessage,
    resetValidation
  } = use_validate_default$1(state2.focused, state2.innerLoading);
  const floatingLabel = state2.floatingLabel !== void 0 ? computed(() => props4.stackLabel === true || state2.focused.value === true || state2.floatingLabel.value === true) : computed(() => props4.stackLabel === true || state2.focused.value === true || state2.hasValue.value === true);
  const shouldRenderBottom = computed(
    () => props4.bottomSlots === true || props4.hint !== void 0 || hasRules.value === true || props4.counter === true || props4.error !== null
  );
  const styleType = computed(() => {
    if (props4.filled === true) {
      return "filled";
    }
    if (props4.outlined === true) {
      return "outlined";
    }
    if (props4.borderless === true) {
      return "borderless";
    }
    if (props4.standout) {
      return "standout";
    }
    return "standard";
  });
  const classes = computed(
    () => `q-field row no-wrap items-start q-field--${styleType.value}` + (state2.fieldClass !== void 0 ? ` ${state2.fieldClass.value}` : "") + (props4.rounded === true ? " q-field--rounded" : "") + (props4.square === true ? " q-field--square" : "") + (floatingLabel.value === true ? " q-field--float" : "") + (hasLabel.value === true ? " q-field--labeled" : "") + (props4.dense === true ? " q-field--dense" : "") + (props4.itemAligned === true ? " q-field--item-aligned q-item-type" : "") + (state2.isDark.value === true ? " q-field--dark" : "") + (state2.getControl === void 0 ? " q-field--auto-height" : "") + (state2.focused.value === true ? " q-field--focused" : "") + (hasError.value === true ? " q-field--error" : "") + (hasError.value === true || state2.focused.value === true ? " q-field--highlighted" : "") + (props4.hideBottomSpace !== true && shouldRenderBottom.value === true ? " q-field--with-bottom" : "") + (props4.disable === true ? " q-field--disabled" : props4.readonly === true ? " q-field--readonly" : "")
  );
  const contentClass = computed(
    () => "q-field__control relative-position row no-wrap" + (props4.bgColor !== void 0 ? ` bg-${props4.bgColor}` : "") + (hasError.value === true ? " text-negative" : typeof props4.standout === "string" && props4.standout.length !== 0 && state2.focused.value === true ? ` ${props4.standout}` : props4.color !== void 0 ? ` text-${props4.color}` : "")
  );
  const hasLabel = computed(
    () => props4.labelSlot === true || props4.label !== void 0
  );
  const labelClass = computed(
    () => "q-field__label no-pointer-events absolute ellipsis" + (props4.labelColor !== void 0 && hasError.value !== true ? ` text-${props4.labelColor}` : "")
  );
  const controlSlotScope = computed(() => ({
    id: state2.targetUid.value,
    editable: state2.editable.value,
    focused: state2.focused.value,
    floatingLabel: floatingLabel.value,
    modelValue: props4.modelValue,
    emitValue: state2.emitValue
  }));
  const attributes = computed(() => {
    const acc = {};
    if (state2.targetUid.value) {
      acc.for = state2.targetUid.value;
    }
    if (props4.disable === true) {
      acc["aria-disabled"] = "true";
    }
    return acc;
  });
  function focusHandler() {
    const el = document.activeElement;
    let target2 = state2.targetRef !== void 0 && state2.targetRef.value;
    if (target2 && (el === null || el.id !== state2.targetUid.value)) {
      target2.hasAttribute("tabindex") === true || (target2 = target2.querySelector("[tabindex]"));
      if (target2 && target2 !== el) {
        target2.focus({ preventScroll: true });
      }
    }
  }
  function focus() {
    addFocusFn$1(focusHandler);
  }
  function blur() {
    removeFocusFn$1(focusHandler);
    const el = document.activeElement;
    if (el !== null && state2.rootRef.value.contains(el)) {
      el.blur();
    }
  }
  function onControlFocusin(e22) {
    if (focusoutTimer !== null) {
      clearTimeout(focusoutTimer);
      focusoutTimer = null;
    }
    if (state2.editable.value === true && state2.focused.value === false) {
      state2.focused.value = true;
      emit("focus", e22);
    }
  }
  function onControlFocusout(e22, then) {
    focusoutTimer !== null && clearTimeout(focusoutTimer);
    focusoutTimer = setTimeout(() => {
      focusoutTimer = null;
      if (document.hasFocus() === true && (state2.hasPopupOpen === true || state2.controlRef === void 0 || state2.controlRef.value === null || state2.controlRef.value.contains(document.activeElement) !== false)) {
        return;
      }
      if (state2.focused.value === true) {
        state2.focused.value = false;
        emit("blur", e22);
      }
      then !== void 0 && then();
    });
  }
  function clearValue(e22) {
    stopAndPrevent$1(e22);
    if ($q.platform.is.mobile !== true) {
      const el = state2.targetRef !== void 0 && state2.targetRef.value || state2.rootRef.value;
      el.focus();
    } else if (state2.rootRef.value.contains(document.activeElement) === true) {
      document.activeElement.blur();
    }
    if (props4.type === "file") {
      state2.inputRef.value.value = null;
    }
    emit("update:modelValue", null);
    state2.changeEvent === true && emit("change", null);
    emit("clear", props4.modelValue);
    nextTick(() => {
      const isDirty = isDirtyModel.value;
      resetValidation();
      isDirtyModel.value = isDirty;
    });
  }
  function onClearableKeyup(evt) {
    [13, 32].includes(evt.keyCode) && clearValue(evt);
  }
  function getContent() {
    const node = [];
    slots.prepend !== void 0 && node.push(
      h("div", {
        class: "q-field__prepend q-field__marginal row no-wrap items-center",
        key: "prepend",
        onClick: prevent$1
      }, slots.prepend())
    );
    node.push(
      h("div", {
        class: "q-field__control-container col relative-position row no-wrap q-anchor--skip"
      }, getControlContainer())
    );
    hasError.value === true && props4.noErrorIcon === false && node.push(
      getInnerAppendNode("error", [
        h(QIcon_default$1, { name: $q.iconSet.field.error, color: "negative" })
      ])
    );
    if (props4.loading === true || state2.innerLoading.value === true) {
      node.push(
        getInnerAppendNode(
          "inner-loading-append",
          slots.loading !== void 0 ? slots.loading() : [h(QSpinner_default$1, { color: props4.color })]
        )
      );
    } else if (props4.clearable === true && state2.hasValue.value === true && state2.editable.value === true) {
      node.push(
        getInnerAppendNode("inner-clearable-append", [
          h(QIcon_default$1, {
            class: "q-field__focusable-action",
            name: props4.clearIcon || $q.iconSet.field.clear,
            tabindex: 0,
            role: "button",
            "aria-hidden": "false",
            "aria-label": $q.lang.label.clear,
            onKeyup: onClearableKeyup,
            onClick: clearValue
          })
        ])
      );
    }
    slots.append !== void 0 && node.push(
      h("div", {
        class: "q-field__append q-field__marginal row no-wrap items-center",
        key: "append",
        onClick: prevent$1
      }, slots.append())
    );
    state2.getInnerAppend !== void 0 && node.push(
      getInnerAppendNode("inner-append", state2.getInnerAppend())
    );
    state2.getControlChild !== void 0 && node.push(
      state2.getControlChild()
    );
    return node;
  }
  function getControlContainer() {
    const node = [];
    props4.prefix !== void 0 && props4.prefix !== null && node.push(
      h("div", {
        class: "q-field__prefix no-pointer-events row items-center"
      }, props4.prefix)
    );
    if (state2.getShadowControl !== void 0 && state2.hasShadow.value === true) {
      node.push(
        state2.getShadowControl()
      );
    }
    if (state2.getControl !== void 0) {
      node.push(state2.getControl());
    } else if (slots.rawControl !== void 0) {
      node.push(slots.rawControl());
    } else if (slots.control !== void 0) {
      node.push(
        h("div", {
          ref: state2.targetRef,
          class: "q-field__native row",
          tabindex: -1,
          ...state2.splitAttrs.attributes.value,
          "data-autofocus": props4.autofocus === true || void 0
        }, slots.control(controlSlotScope.value))
      );
    }
    hasLabel.value === true && node.push(
      h("div", {
        class: labelClass.value
      }, hSlot$1(slots.label, props4.label))
    );
    props4.suffix !== void 0 && props4.suffix !== null && node.push(
      h("div", {
        class: "q-field__suffix no-pointer-events row items-center"
      }, props4.suffix)
    );
    return node.concat(hSlot$1(slots.default));
  }
  function getBottom() {
    let msg, key;
    if (hasError.value === true) {
      if (errorMessage.value !== null) {
        msg = [h("div", { role: "alert" }, errorMessage.value)];
        key = `q--slot-error-${errorMessage.value}`;
      } else {
        msg = hSlot$1(slots.error);
        key = "q--slot-error";
      }
    } else if (props4.hideHint !== true || state2.focused.value === true) {
      if (props4.hint !== void 0) {
        msg = [h("div", props4.hint)];
        key = `q--slot-hint-${props4.hint}`;
      } else {
        msg = hSlot$1(slots.hint);
        key = "q--slot-hint";
      }
    }
    const hasCounter = props4.counter === true || slots.counter !== void 0;
    if (props4.hideBottomSpace === true && hasCounter === false && msg === void 0) {
      return;
    }
    const main = h("div", {
      key,
      class: "q-field__messages col"
    }, msg);
    return h("div", {
      class: "q-field__bottom row items-start q-field__bottom--" + (props4.hideBottomSpace !== true ? "animated" : "stale"),
      onClick: prevent$1
    }, [
      props4.hideBottomSpace === true ? main : h(Transition, { name: "q-transition--field-message" }, () => main),
      hasCounter === true ? h("div", {
        class: "q-field__counter"
      }, slots.counter !== void 0 ? slots.counter() : state2.computedCounter.value) : null
    ]);
  }
  function getInnerAppendNode(key, content) {
    return content === null ? null : h("div", {
      key,
      class: "q-field__append q-field__marginal row no-wrap items-center q-anchor--skip"
    }, content);
  }
  let shouldActivate = false;
  onDeactivated(() => {
    shouldActivate = true;
  });
  onActivated(() => {
    shouldActivate === true && props4.autofocus === true && proxy.focus();
  });
  props4.autofocus === true && onMounted(() => {
    proxy.focus();
  });
  onBeforeUnmount(() => {
    focusoutTimer !== null && clearTimeout(focusoutTimer);
  });
  Object.assign(proxy, { focus, blur });
  return function renderField() {
    const labelAttrs = state2.getControl === void 0 && slots.control === void 0 ? {
      ...state2.splitAttrs.attributes.value,
      "data-autofocus": props4.autofocus === true || void 0,
      ...attributes.value
    } : attributes.value;
    return h(state2.tag.value, {
      ref: state2.rootRef,
      class: [
        classes.value,
        attrs.class
      ],
      style: attrs.style,
      ...labelAttrs
    }, [
      slots.before !== void 0 ? h("div", {
        class: "q-field__before q-field__marginal row no-wrap items-center",
        onClick: prevent$1
      }, slots.before()) : null,
      h("div", {
        class: "q-field__inner relative-position col self-stretch"
      }, [
        h("div", {
          ref: state2.controlRef,
          class: contentClass.value,
          tabindex: -1,
          ...state2.controlEvents
        }, getContent()),
        shouldRenderBottom.value === true ? getBottom() : null
      ]),
      slots.after !== void 0 ? h("div", {
        class: "q-field__after q-field__marginal row no-wrap items-center",
        onClick: prevent$1
      }, slots.after()) : null
    ]);
  };
}
var QField_default$1 = createComponent$1({
  name: "QField",
  inheritAttrs: false,
  props: {
    ...useFieldProps$1,
    tag: {
      type: String,
      default: "label"
    }
  },
  emits: useFieldEmits$1,
  setup() {
    return use_field_default$1(
      useFieldState$1({ tagProp: true })
    );
  }
});
function filterFiles$1(files, rejectedFiles, failedPropValidation, filterFn) {
  const acceptedFiles = [];
  files.forEach((file) => {
    if (filterFn(file) === true) {
      acceptedFiles.push(file);
    } else {
      rejectedFiles.push({ failedPropValidation, file });
    }
  });
  return acceptedFiles;
}
function stopAndPreventDrag$1(e22) {
  e22 && e22.dataTransfer && (e22.dataTransfer.dropEffect = "copy");
  stopAndPrevent$1(e22);
}
var useFileProps$1 = {
  multiple: Boolean,
  accept: String,
  capture: String,
  maxFileSize: [Number, String],
  maxTotalSize: [Number, String],
  maxFiles: [Number, String],
  filter: Function
};
var useFileEmits$1 = ["rejected"];
function use_file_default$1({
  editable,
  dnd,
  getFileInput,
  addFilesToQueue
}) {
  const { props: props4, emit, proxy } = getCurrentInstance();
  const dndRef = ref$1(null);
  const extensions = computed(() => props4.accept !== void 0 ? props4.accept.split(",").map((ext) => {
    ext = ext.trim();
    if (ext === "*") {
      return "*/";
    } else if (ext.endsWith("/*")) {
      ext = ext.slice(0, ext.length - 1);
    }
    return ext.toUpperCase();
  }) : null);
  const maxFilesNumber = computed(() => parseInt(props4.maxFiles, 10));
  const maxTotalSizeNumber = computed(() => parseInt(props4.maxTotalSize, 10));
  function pickFiles(e22) {
    if (editable.value) {
      if (e22 !== Object(e22)) {
        e22 = { target: null };
      }
      if (e22.target !== null && e22.target.matches('input[type="file"]') === true) {
        e22.clientX === 0 && e22.clientY === 0 && stop$1(e22);
      } else {
        const input = getFileInput();
        input && input !== e22.target && input.click(e22);
      }
    }
  }
  function addFiles(files) {
    if (editable.value && files) {
      addFilesToQueue(null, files);
    }
  }
  function processFiles(e22, filesToProcess, currentFileList, append) {
    let files = Array.from(filesToProcess || e22.target.files);
    const rejectedFiles = [];
    const done = () => {
      if (rejectedFiles.length !== 0) {
        emit("rejected", rejectedFiles);
      }
    };
    if (props4.accept !== void 0 && extensions.value.indexOf("*/") === -1) {
      files = filterFiles$1(files, rejectedFiles, "accept", (file) => {
        return extensions.value.some((ext) => file.type.toUpperCase().startsWith(ext) || file.name.toUpperCase().endsWith(ext));
      });
      if (files.length === 0) {
        return done();
      }
    }
    if (props4.maxFileSize !== void 0) {
      const maxFileSize = parseInt(props4.maxFileSize, 10);
      files = filterFiles$1(files, rejectedFiles, "max-file-size", (file) => {
        return file.size <= maxFileSize;
      });
      if (files.length === 0) {
        return done();
      }
    }
    if (props4.multiple !== true && files.length !== 0) {
      files = [files[0]];
    }
    files.forEach((file) => {
      file.__key = file.webkitRelativePath + file.lastModified + file.name + file.size;
    });
    if (append === true) {
      const filenameMap = currentFileList.map((entry) => entry.__key);
      files = filterFiles$1(files, rejectedFiles, "duplicate", (file) => {
        return filenameMap.includes(file.__key) === false;
      });
    }
    if (files.length === 0) {
      return done();
    }
    if (props4.maxTotalSize !== void 0) {
      let size2 = append === true ? currentFileList.reduce((total, file) => total + file.size, 0) : 0;
      files = filterFiles$1(files, rejectedFiles, "max-total-size", (file) => {
        size2 += file.size;
        return size2 <= maxTotalSizeNumber.value;
      });
      if (files.length === 0) {
        return done();
      }
    }
    if (typeof props4.filter === "function") {
      const filteredFiles = props4.filter(files);
      files = filterFiles$1(files, rejectedFiles, "filter", (file) => {
        return filteredFiles.includes(file);
      });
    }
    if (props4.maxFiles !== void 0) {
      let filesNumber = append === true ? currentFileList.length : 0;
      files = filterFiles$1(files, rejectedFiles, "max-files", () => {
        filesNumber++;
        return filesNumber <= maxFilesNumber.value;
      });
      if (files.length === 0) {
        return done();
      }
    }
    done();
    if (files.length !== 0) {
      return files;
    }
  }
  function onDragover(e22) {
    stopAndPreventDrag$1(e22);
    dnd.value !== true && (dnd.value = true);
  }
  function onDragleave(e22) {
    stopAndPrevent$1(e22);
    const gone = e22.relatedTarget !== null || client$1.is.safari !== true ? e22.relatedTarget !== dndRef.value : document.elementsFromPoint(e22.clientX, e22.clientY).includes(dndRef.value) === false;
    gone === true && (dnd.value = false);
  }
  function onDrop(e22) {
    stopAndPreventDrag$1(e22);
    const files = e22.dataTransfer.files;
    if (files.length !== 0) {
      addFilesToQueue(null, files);
    }
    dnd.value = false;
  }
  function getDndNode(type2) {
    if (dnd.value === true) {
      return h("div", {
        ref: dndRef,
        class: `q-${type2}__dnd absolute-full`,
        onDragenter: stopAndPreventDrag$1,
        onDragover: stopAndPreventDrag$1,
        onDragleave,
        onDrop
      });
    }
  }
  Object.assign(proxy, { pickFiles, addFiles });
  return {
    pickFiles,
    addFiles,
    onDragover,
    onDragleave,
    processFiles,
    getDndNode,
    maxFilesNumber,
    maxTotalSizeNumber
  };
}
function use_file_dom_props_default$1(props4, typeGuard) {
  function getFormDomProps() {
    const model = props4.modelValue;
    try {
      const dt2 = "DataTransfer" in window ? new DataTransfer() : "ClipboardEvent" in window ? new ClipboardEvent("").clipboardData : void 0;
      if (Object(model) === model) {
        ("length" in model ? Array.from(model) : [model]).forEach((file) => {
          dt2.items.add(file);
        });
      }
      return {
        files: dt2.files
      };
    } catch (e22) {
      return {
        files: void 0
      };
    }
  }
  return typeGuard === true ? computed(() => {
    if (props4.type !== "file") {
      return;
    }
    return getFormDomProps();
  }) : computed(getFormDomProps);
}
var QFile_default = createComponent$1({
  name: "QFile",
  inheritAttrs: false,
  props: {
    ...useNonInputFieldProps$1,
    ...useFormProps$1,
    ...useFileProps$1,
    /* SSR does not know about File & FileList */
    modelValue: [File, FileList, Array],
    append: Boolean,
    useChips: Boolean,
    displayValue: [String, Number],
    tabindex: {
      type: [String, Number],
      default: 0
    },
    counterLabel: Function,
    inputClass: [Array, String, Object],
    inputStyle: [Array, String, Object]
  },
  emits: [
    ...useFieldEmits$1,
    ...useFileEmits$1
  ],
  setup(props4, { slots, emit, attrs }) {
    const { proxy } = getCurrentInstance();
    const state2 = useFieldState$1();
    const inputRef = ref$1(null);
    const dnd = ref$1(false);
    const nameProp = useFormInputNameAttr$1(props4);
    const {
      pickFiles,
      onDragover,
      onDragleave,
      processFiles,
      getDndNode
    } = use_file_default$1({ editable: state2.editable, dnd, getFileInput, addFilesToQueue });
    const formDomProps = use_file_dom_props_default$1(props4);
    const innerValue = computed(() => Object(props4.modelValue) === props4.modelValue ? "length" in props4.modelValue ? Array.from(props4.modelValue) : [props4.modelValue] : []);
    const hasValue = computed(() => fieldValueIsFilled$1(innerValue.value));
    const selectedString = computed(
      () => innerValue.value.map((file) => file.name).join(", ")
    );
    const totalSize = computed(
      () => humanStorageSize$1(
        innerValue.value.reduce((acc, file) => acc + file.size, 0)
      )
    );
    const counterProps = computed(() => ({
      totalSize: totalSize.value,
      filesNumber: innerValue.value.length,
      maxFiles: props4.maxFiles
    }));
    const inputAttrs = computed(() => ({
      tabindex: -1,
      type: "file",
      title: "",
      // try to remove default tooltip,
      accept: props4.accept,
      capture: props4.capture,
      name: nameProp.value,
      ...attrs,
      id: state2.targetUid.value,
      disabled: state2.editable.value !== true
    }));
    const fieldClass = computed(
      () => "q-file q-field--auto-height" + (dnd.value === true ? " q-file--dnd" : "")
    );
    const isAppending = computed(
      () => props4.multiple === true && props4.append === true
    );
    function removeAtIndex(index2) {
      const files = innerValue.value.slice();
      files.splice(index2, 1);
      emitValue(files);
    }
    function removeFile(file) {
      const index2 = innerValue.value.indexOf(file);
      if (index2 !== -1) {
        removeAtIndex(index2);
      }
    }
    function emitValue(files) {
      emit("update:modelValue", props4.multiple === true ? files : files[0]);
    }
    function onKeydown2(e22) {
      e22.keyCode === 13 && prevent$1(e22);
    }
    function onKeyup2(e22) {
      if (e22.keyCode === 13 || e22.keyCode === 32) {
        pickFiles(e22);
      }
    }
    function getFileInput() {
      return inputRef.value;
    }
    function addFilesToQueue(e22, fileList) {
      const files = processFiles(e22, fileList, innerValue.value, isAppending.value);
      const fileInput = getFileInput();
      if (fileInput !== void 0 && fileInput !== null) {
        fileInput.value = "";
      }
      if (files === void 0) return;
      if (props4.multiple === true ? props4.modelValue && files.every((f) => innerValue.value.includes(f)) : props4.modelValue === files[0]) {
        return;
      }
      emitValue(
        isAppending.value === true ? innerValue.value.concat(files) : files
      );
    }
    function getFiller() {
      return [
        h("input", {
          class: [props4.inputClass, "q-file__filler"],
          style: props4.inputStyle
        })
      ];
    }
    function getSelection2() {
      if (slots.file !== void 0) {
        return innerValue.value.length === 0 ? getFiller() : innerValue.value.map(
          (file, index2) => slots.file({ index: index2, file, ref: this })
        );
      }
      if (slots.selected !== void 0) {
        return innerValue.value.length === 0 ? getFiller() : slots.selected({ files: innerValue.value, ref: this });
      }
      if (props4.useChips === true) {
        return innerValue.value.length === 0 ? getFiller() : innerValue.value.map((file, i22) => h(QChip_default$1, {
          key: "file-" + i22,
          removable: state2.editable.value,
          dense: true,
          textColor: props4.color,
          tabindex: props4.tabindex,
          onRemove: () => {
            removeAtIndex(i22);
          }
        }, () => h("span", {
          class: "ellipsis",
          textContent: file.name
        })));
      }
      const textContent = props4.displayValue !== void 0 ? props4.displayValue : selectedString.value;
      return textContent.length !== 0 ? [
        h("div", {
          class: props4.inputClass,
          style: props4.inputStyle,
          textContent
        })
      ] : getFiller();
    }
    function getInput() {
      const data = {
        ref: inputRef,
        ...inputAttrs.value,
        ...formDomProps.value,
        class: "q-field__input fit absolute-full cursor-pointer",
        onChange: addFilesToQueue
      };
      if (props4.multiple === true) {
        data.multiple = true;
      }
      return h("input", data);
    }
    Object.assign(state2, {
      fieldClass,
      emitValue,
      hasValue,
      inputRef,
      innerValue,
      floatingLabel: computed(
        () => hasValue.value === true || fieldValueIsFilled$1(props4.displayValue)
      ),
      computedCounter: computed(() => {
        if (props4.counterLabel !== void 0) {
          return props4.counterLabel(counterProps.value);
        }
        const max2 = props4.maxFiles;
        return `${innerValue.value.length}${max2 !== void 0 ? " / " + max2 : ""} (${totalSize.value})`;
      }),
      getControlChild: () => getDndNode("file"),
      getControl: () => {
        const data = {
          ref: state2.targetRef,
          class: "q-field__native row items-center cursor-pointer",
          tabindex: props4.tabindex
        };
        if (state2.editable.value === true) {
          Object.assign(data, { onDragover, onDragleave, onKeydown: onKeydown2, onKeyup: onKeyup2 });
        }
        return h("div", data, [getInput()].concat(getSelection2()));
      }
    });
    Object.assign(proxy, {
      removeAtIndex,
      removeFile,
      getNativeElement: () => inputRef.value
      // deprecated
    });
    injectProp$1(proxy, "nativeEl", () => inputRef.value);
    return use_field_default$1(state2);
  }
});
createComponent$1({
  name: "QFooter",
  props: {
    modelValue: {
      type: Boolean,
      default: true
    },
    reveal: Boolean,
    bordered: Boolean,
    elevated: Boolean,
    heightHint: {
      type: [String, Number],
      default: 50
    }
  },
  emits: ["reveal", "focusin"],
  setup(props4, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const $layout = inject(layoutKey$1, emptyRenderFn$1);
    if ($layout === emptyRenderFn$1) {
      console.error("QFooter needs to be child of QLayout");
      return emptyRenderFn$1;
    }
    const size2 = ref$1(parseInt(props4.heightHint, 10));
    const revealed = ref$1(true);
    const windowHeight = ref$1(
      isRuntimeSsrPreHydration$1.value === true || $layout.isContainer.value === true ? 0 : window.innerHeight
    );
    const fixed = computed(
      () => props4.reveal === true || $layout.view.value.indexOf("F") !== -1 || $q.platform.is.ios && $layout.isContainer.value === true
    );
    const containerHeight = computed(() => $layout.isContainer.value === true ? $layout.containerHeight.value : windowHeight.value);
    const offset2 = computed(() => {
      if (props4.modelValue !== true) {
        return 0;
      }
      if (fixed.value === true) {
        return revealed.value === true ? size2.value : 0;
      }
      const offset3 = $layout.scroll.value.position + containerHeight.value + size2.value - $layout.height.value;
      return offset3 > 0 ? offset3 : 0;
    });
    const hidden = computed(
      () => props4.modelValue !== true || fixed.value === true && revealed.value !== true
    );
    const revealOnFocus = computed(
      () => props4.modelValue === true && hidden.value === true && props4.reveal === true
    );
    const classes = computed(
      () => "q-footer q-layout__section--marginal " + (fixed.value === true ? "fixed" : "absolute") + "-bottom" + (props4.bordered === true ? " q-footer--bordered" : "") + (hidden.value === true ? " q-footer--hidden" : "") + (props4.modelValue !== true ? " q-layout--prevent-focus" + (fixed.value !== true ? " hidden" : "") : "")
    );
    const style2 = computed(() => {
      const view = $layout.rows.value.bottom, css2 = {};
      if (view[0] === "l" && $layout.left.space === true) {
        css2[$q.lang.rtl === true ? "right" : "left"] = `${$layout.left.size}px`;
      }
      if (view[2] === "r" && $layout.right.space === true) {
        css2[$q.lang.rtl === true ? "left" : "right"] = `${$layout.right.size}px`;
      }
      return css2;
    });
    function updateLayout(prop, val) {
      $layout.update("footer", prop, val);
    }
    function updateLocal(prop, val) {
      if (prop.value !== val) {
        prop.value = val;
      }
    }
    function onResize({ height: height2 }) {
      updateLocal(size2, height2);
      updateLayout("size", height2);
    }
    function updateRevealed() {
      if (props4.reveal !== true) return;
      const { direction, position: position2, inflectionPoint } = $layout.scroll.value;
      updateLocal(revealed, direction === "up" || position2 - inflectionPoint < 100 || $layout.height.value - containerHeight.value - position2 - size2.value < 300);
    }
    function onFocusin(evt) {
      if (revealOnFocus.value === true) {
        updateLocal(revealed, true);
      }
      emit("focusin", evt);
    }
    watch(() => props4.modelValue, (val) => {
      updateLayout("space", val);
      updateLocal(revealed, true);
      $layout.animate();
    });
    watch(offset2, (val) => {
      updateLayout("offset", val);
    });
    watch(() => props4.reveal, (val) => {
      val === false && updateLocal(revealed, props4.modelValue);
    });
    watch(revealed, (val) => {
      $layout.animate();
      emit("reveal", val);
    });
    watch([size2, $layout.scroll, $layout.height], updateRevealed);
    watch(() => $q.screen.height, (val) => {
      $layout.isContainer.value !== true && updateLocal(windowHeight, val);
    });
    const instance = {};
    $layout.instances.footer = instance;
    props4.modelValue === true && updateLayout("size", size2.value);
    updateLayout("space", props4.modelValue);
    updateLayout("offset", offset2.value);
    onBeforeUnmount(() => {
      if ($layout.instances.footer === instance) {
        $layout.instances.footer = void 0;
        updateLayout("size", 0);
        updateLayout("offset", 0);
        updateLayout("space", false);
      }
    });
    return () => {
      const child = hMergeSlot$1(slots.default, [
        h(QResizeObserver_default$1, {
          debounce: 0,
          onResize
        })
      ]);
      props4.elevated === true && child.push(
        h("div", {
          class: "q-layout__shadow absolute-full overflow-hidden no-pointer-events"
        })
      );
      return h("footer", {
        class: classes.value,
        style: style2.value,
        onFocusin
      }, child);
    };
  }
});
createComponent$1({
  name: "QForm",
  props: {
    autofocus: Boolean,
    noErrorFocus: Boolean,
    noResetFocus: Boolean,
    greedy: Boolean,
    onSubmit: Function
  },
  emits: ["reset", "validationSuccess", "validationError"],
  setup(props4, { slots, emit }) {
    const vm2 = getCurrentInstance();
    const rootRef = ref$1(null);
    let validateIndex = 0;
    const registeredComponents = [];
    function validate2(shouldFocus) {
      const focus2 = typeof shouldFocus === "boolean" ? shouldFocus : props4.noErrorFocus !== true;
      const index2 = ++validateIndex;
      const emitEvent = (res, ref73) => {
        emit(`validation${res === true ? "Success" : "Error"}`, ref73);
      };
      const validateComponent = (comp) => {
        const valid = comp.validate();
        return typeof valid.then === "function" ? valid.then(
          (valid2) => ({ valid: valid2, comp }),
          (err) => ({ valid: false, comp, err })
        ) : Promise.resolve({ valid, comp });
      };
      const errorsPromise = props4.greedy === true ? Promise.all(registeredComponents.map(validateComponent)).then((res) => res.filter((r) => r.valid !== true)) : registeredComponents.reduce(
        (acc, comp) => acc.then(() => {
          return validateComponent(comp).then((r) => {
            if (r.valid === false) {
              return Promise.reject(r);
            }
          });
        }),
        Promise.resolve()
      ).catch((error) => [error]);
      return errorsPromise.then((errors) => {
        if (errors === void 0 || errors.length === 0) {
          index2 === validateIndex && emitEvent(true);
          return true;
        }
        if (index2 === validateIndex) {
          const { comp, err } = errors[0];
          err !== void 0 && console.error(err);
          emitEvent(false, comp);
          if (focus2 === true) {
            const activeError = errors.find(({ comp: comp2 }) => typeof comp2.focus === "function" && vmIsDestroyed$1(comp2.$) === false);
            if (activeError !== void 0) {
              activeError.comp.focus();
            }
          }
        }
        return false;
      });
    }
    function resetValidation() {
      validateIndex++;
      registeredComponents.forEach((comp) => {
        typeof comp.resetValidation === "function" && comp.resetValidation();
      });
    }
    function submit(evt) {
      evt !== void 0 && stopAndPrevent$1(evt);
      const index2 = validateIndex + 1;
      validate2().then((val) => {
        if (index2 === validateIndex && val === true) {
          if (props4.onSubmit !== void 0) {
            emit("submit", evt);
          } else if (evt !== void 0 && evt.target !== void 0 && typeof evt.target.submit === "function") {
            evt.target.submit();
          }
        }
      });
    }
    function reset(evt) {
      evt !== void 0 && stopAndPrevent$1(evt);
      emit("reset");
      nextTick(() => {
        resetValidation();
        if (props4.autofocus === true && props4.noResetFocus !== true) {
          focus();
        }
      });
    }
    function focus() {
      addFocusFn$1(() => {
        if (rootRef.value === null) return;
        const target2 = rootRef.value.querySelector("[autofocus][tabindex], [data-autofocus][tabindex]") || rootRef.value.querySelector("[autofocus] [tabindex], [data-autofocus] [tabindex]") || rootRef.value.querySelector("[autofocus], [data-autofocus]") || Array.prototype.find.call(rootRef.value.querySelectorAll("[tabindex]"), (el) => el.tabIndex !== -1);
        target2 !== null && target2 !== void 0 && target2.focus({ preventScroll: true });
      });
    }
    provide(formKey$1, {
      bindComponent(vmProxy) {
        registeredComponents.push(vmProxy);
      },
      unbindComponent(vmProxy) {
        const index2 = registeredComponents.indexOf(vmProxy);
        if (index2 !== -1) {
          registeredComponents.splice(index2, 1);
        }
      }
    });
    let shouldActivate = false;
    onDeactivated(() => {
      shouldActivate = true;
    });
    onActivated(() => {
      shouldActivate === true && props4.autofocus === true && focus();
    });
    onMounted(() => {
      props4.autofocus === true && focus();
    });
    Object.assign(vm2.proxy, {
      validate: validate2,
      resetValidation,
      submit,
      reset,
      focus,
      getValidationComponents: () => registeredComponents
    });
    return () => h("form", {
      class: "q-form",
      ref: rootRef,
      onSubmit: submit,
      onReset: reset
    }, hSlot$1(slots.default));
  }
});
var QHeader_default = createComponent$1({
  name: "QHeader",
  props: {
    modelValue: {
      type: Boolean,
      default: true
    },
    reveal: Boolean,
    revealOffset: {
      type: Number,
      default: 250
    },
    bordered: Boolean,
    elevated: Boolean,
    heightHint: {
      type: [String, Number],
      default: 50
    }
  },
  emits: ["reveal", "focusin"],
  setup(props4, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const $layout = inject(layoutKey$1, emptyRenderFn$1);
    if ($layout === emptyRenderFn$1) {
      console.error("QHeader needs to be child of QLayout");
      return emptyRenderFn$1;
    }
    const size2 = ref$1(parseInt(props4.heightHint, 10));
    const revealed = ref$1(true);
    const fixed = computed(
      () => props4.reveal === true || $layout.view.value.indexOf("H") !== -1 || $q.platform.is.ios && $layout.isContainer.value === true
    );
    const offset2 = computed(() => {
      if (props4.modelValue !== true) {
        return 0;
      }
      if (fixed.value === true) {
        return revealed.value === true ? size2.value : 0;
      }
      const offset3 = size2.value - $layout.scroll.value.position;
      return offset3 > 0 ? offset3 : 0;
    });
    const hidden = computed(
      () => props4.modelValue !== true || fixed.value === true && revealed.value !== true
    );
    const revealOnFocus = computed(
      () => props4.modelValue === true && hidden.value === true && props4.reveal === true
    );
    const classes = computed(
      () => "q-header q-layout__section--marginal " + (fixed.value === true ? "fixed" : "absolute") + "-top" + (props4.bordered === true ? " q-header--bordered" : "") + (hidden.value === true ? " q-header--hidden" : "") + (props4.modelValue !== true ? " q-layout--prevent-focus" : "")
    );
    const style2 = computed(() => {
      const view = $layout.rows.value.top, css2 = {};
      if (view[0] === "l" && $layout.left.space === true) {
        css2[$q.lang.rtl === true ? "right" : "left"] = `${$layout.left.size}px`;
      }
      if (view[2] === "r" && $layout.right.space === true) {
        css2[$q.lang.rtl === true ? "left" : "right"] = `${$layout.right.size}px`;
      }
      return css2;
    });
    function updateLayout(prop, val) {
      $layout.update("header", prop, val);
    }
    function updateLocal(prop, val) {
      if (prop.value !== val) {
        prop.value = val;
      }
    }
    function onResize({ height: height2 }) {
      updateLocal(size2, height2);
      updateLayout("size", height2);
    }
    function onFocusin(evt) {
      if (revealOnFocus.value === true) {
        updateLocal(revealed, true);
      }
      emit("focusin", evt);
    }
    watch(() => props4.modelValue, (val) => {
      updateLayout("space", val);
      updateLocal(revealed, true);
      $layout.animate();
    });
    watch(offset2, (val) => {
      updateLayout("offset", val);
    });
    watch(() => props4.reveal, (val) => {
      val === false && updateLocal(revealed, props4.modelValue);
    });
    watch(revealed, (val) => {
      $layout.animate();
      emit("reveal", val);
    });
    watch($layout.scroll, (scroll) => {
      props4.reveal === true && updateLocal(
        revealed,
        scroll.direction === "up" || scroll.position <= props4.revealOffset || scroll.position - scroll.inflectionPoint < 100
      );
    });
    const instance = {};
    $layout.instances.header = instance;
    props4.modelValue === true && updateLayout("size", size2.value);
    updateLayout("space", props4.modelValue);
    updateLayout("offset", offset2.value);
    onBeforeUnmount(() => {
      if ($layout.instances.header === instance) {
        $layout.instances.header = void 0;
        updateLayout("size", 0);
        updateLayout("offset", 0);
        updateLayout("space", false);
      }
    });
    return () => {
      const child = hUniqueSlot$1(slots.default, []);
      props4.elevated === true && child.push(
        h("div", {
          class: "q-layout__shadow absolute-full overflow-hidden no-pointer-events"
        })
      );
      child.push(
        h(QResizeObserver_default$1, {
          debounce: 0,
          onResize
        })
      );
      return h("header", {
        class: classes.value,
        style: style2.value,
        onFocusin
      }, child);
    };
  }
});
var useRatioProps$1 = {
  ratio: [String, Number]
};
function use_ratio_default$1(props4, naturalRatio) {
  return computed(() => {
    const ratio = Number(
      props4.ratio || (naturalRatio !== void 0 ? naturalRatio.value : void 0)
    );
    return isNaN(ratio) !== true && ratio > 0 ? { paddingBottom: `${100 / ratio}%` } : null;
  });
}
var defaultRatio$1 = 1.7778;
var QImg_default = createComponent$1({
  name: "QImg",
  props: {
    ...useRatioProps$1,
    src: String,
    srcset: String,
    sizes: String,
    alt: String,
    crossorigin: String,
    decoding: String,
    referrerpolicy: String,
    draggable: Boolean,
    loading: {
      type: String,
      default: "lazy"
    },
    loadingShowDelay: {
      type: [Number, String],
      default: 0
    },
    fetchpriority: {
      type: String,
      default: "auto"
    },
    width: String,
    height: String,
    initialRatio: {
      type: [Number, String],
      default: defaultRatio$1
    },
    placeholderSrc: String,
    errorSrc: String,
    fit: {
      type: String,
      default: "cover"
    },
    position: {
      type: String,
      default: "50% 50%"
    },
    imgClass: String,
    imgStyle: Object,
    noSpinner: Boolean,
    noNativeMenu: Boolean,
    noTransition: Boolean,
    spinnerColor: String,
    spinnerSize: String
  },
  emits: ["load", "error"],
  setup(props4, { slots, emit }) {
    const naturalRatio = ref$1(props4.initialRatio);
    const ratioStyle = use_ratio_default$1(props4, naturalRatio);
    const vm2 = getCurrentInstance();
    const { registerTimeout: registerLoadTimeout, removeTimeout: removeLoadTimeout } = use_timeout_default$1();
    const { registerTimeout: registerLoadShowTimeout, removeTimeout: removeLoadShowTimeout } = use_timeout_default$1();
    const placeholderImg = computed(() => props4.placeholderSrc !== void 0 ? { src: props4.placeholderSrc } : null);
    const errorImg = computed(() => props4.errorSrc !== void 0 ? { src: props4.errorSrc, __qerror: true } : null);
    const images = [
      ref$1(null),
      ref$1(placeholderImg.value)
    ];
    const position2 = ref$1(0);
    const isLoading = ref$1(false);
    const hasError = ref$1(false);
    const classes = computed(
      () => `q-img q-img--${props4.noNativeMenu === true ? "no-" : ""}menu`
    );
    const style2 = computed(() => ({
      width: props4.width,
      height: props4.height
    }));
    const imgClass = computed(
      () => `q-img__image ${props4.imgClass !== void 0 ? props4.imgClass + " " : ""}q-img__image--with${props4.noTransition === true ? "out" : ""}-transition q-img__image--`
    );
    const imgStyle = computed(() => ({
      ...props4.imgStyle,
      objectFit: props4.fit,
      objectPosition: props4.position
    }));
    function setLoading() {
      removeLoadShowTimeout();
      if (props4.loadingShowDelay === 0) {
        isLoading.value = true;
        return;
      }
      registerLoadShowTimeout(() => {
        isLoading.value = true;
      }, props4.loadingShowDelay);
    }
    function clearLoading() {
      removeLoadShowTimeout();
      isLoading.value = false;
    }
    function onLoad({ target: target2 }) {
      if (vmIsDestroyed$1(vm2) === false) {
        removeLoadTimeout();
        naturalRatio.value = target2.naturalHeight === 0 ? 0.5 : target2.naturalWidth / target2.naturalHeight;
        waitForCompleteness(target2, 1);
      }
    }
    function waitForCompleteness(target2, count) {
      if (count === 1e3 || vmIsDestroyed$1(vm2) === true) return;
      if (target2.complete === true) {
        onReady(target2);
      } else {
        registerLoadTimeout(() => {
          waitForCompleteness(target2, count + 1);
        }, 50);
      }
    }
    function onReady(target2) {
      if (vmIsDestroyed$1(vm2) === true) return;
      position2.value = position2.value ^ 1;
      images[position2.value].value = null;
      clearLoading();
      if (target2.getAttribute("__qerror") !== "true") {
        hasError.value = false;
      }
      emit("load", target2.currentSrc || target2.src);
    }
    function onError(err) {
      removeLoadTimeout();
      clearLoading();
      hasError.value = true;
      images[position2.value].value = errorImg.value;
      images[position2.value ^ 1].value = placeholderImg.value;
      emit("error", err);
    }
    function getImage(index2) {
      const img = images[index2].value;
      const data = {
        key: "img_" + index2,
        class: imgClass.value,
        style: imgStyle.value,
        alt: props4.alt,
        crossorigin: props4.crossorigin,
        decoding: props4.decoding,
        referrerpolicy: props4.referrerpolicy,
        height: props4.height,
        width: props4.width,
        loading: props4.loading,
        fetchpriority: props4.fetchpriority,
        "aria-hidden": "true",
        draggable: props4.draggable,
        ...img
      };
      if (position2.value === index2) {
        Object.assign(data, {
          class: data.class + "current",
          onLoad,
          onError
        });
      } else {
        data.class += "loaded";
      }
      return h(
        "div",
        { class: "q-img__container absolute-full", key: "img" + index2 },
        h("img", data)
      );
    }
    function getContent() {
      if (isLoading.value === false) {
        return h("div", {
          key: "content",
          class: "q-img__content absolute-full q-anchor--skip"
        }, hSlot$1(slots[hasError.value === true ? "error" : "default"]));
      }
      return h("div", {
        key: "loading",
        class: "q-img__loading absolute-full flex flex-center"
      }, slots.loading !== void 0 ? slots.loading() : props4.noSpinner === true ? void 0 : [
        h(QSpinner_default$1, {
          color: props4.spinnerColor,
          size: props4.spinnerSize
        })
      ]);
    }
    {
      let watchSrc = function() {
        watch(
          () => props4.src || props4.srcset || props4.sizes ? {
            src: props4.src,
            srcset: props4.srcset,
            sizes: props4.sizes
          } : null,
          (imgProps) => {
            removeLoadTimeout();
            hasError.value = false;
            if (imgProps === null) {
              clearLoading();
              images[position2.value ^ 1].value = placeholderImg.value;
            } else {
              setLoading();
            }
            images[position2.value].value = imgProps;
          },
          { immediate: true }
        );
      };
      if (isRuntimeSsrPreHydration$1.value === true) {
        onMounted(watchSrc);
      } else {
        watchSrc();
      }
    }
    return () => {
      const content = [];
      if (ratioStyle.value !== null) {
        content.push(
          h("div", { key: "filler", style: ratioStyle.value })
        );
      }
      if (images[0].value !== null) {
        content.push(
          getImage(0)
        );
      }
      if (images[1].value !== null) {
        content.push(
          getImage(1)
        );
      }
      content.push(
        h(Transition, { name: "q-transition--fade" }, getContent)
      );
      return h("div", {
        key: "main",
        class: classes.value,
        style: style2.value,
        role: "img",
        "aria-label": props4.alt
      }, content);
    };
  }
});
var { passive: passive2$1 } = listenOpts$1;
var QInfiniteScroll_default = createComponent$1({
  name: "QInfiniteScroll",
  props: {
    offset: {
      type: Number,
      default: 500
    },
    debounce: {
      type: [String, Number],
      default: 100
    },
    scrollTarget: scrollTargetProp$1,
    initialIndex: {
      type: Number,
      default: 0
    },
    disable: Boolean,
    reverse: Boolean
  },
  emits: ["load"],
  setup(props4, { slots, emit }) {
    const isFetching = ref$1(false);
    const isWorking = ref$1(true);
    const rootRef = ref$1(null);
    const loadingRef = ref$1(null);
    let index2 = props4.initialIndex;
    let localScrollTarget, poll;
    const classes = computed(
      () => "q-infinite-scroll__loading" + (isFetching.value === true ? "" : " invisible")
    );
    function immediatePoll() {
      if (props4.disable === true || isFetching.value === true || isWorking.value === false) {
        return;
      }
      const scrollHeight = getScrollHeight$1(localScrollTarget), scrollPosition = getVerticalScrollPosition$1(localScrollTarget), containerHeight = height$1(localScrollTarget);
      if (props4.reverse === false) {
        if (Math.round(scrollPosition + containerHeight + props4.offset) >= Math.round(scrollHeight)) {
          trigger3();
        }
      } else if (Math.round(scrollPosition) <= props4.offset) {
        trigger3();
      }
    }
    function trigger3() {
      if (props4.disable === true || isFetching.value === true || isWorking.value === false) {
        return;
      }
      index2++;
      isFetching.value = true;
      const heightBefore = getScrollHeight$1(localScrollTarget);
      emit("load", index2, (isDone) => {
        if (isWorking.value === true) {
          isFetching.value = false;
          nextTick(() => {
            if (props4.reverse === true) {
              const heightAfter = getScrollHeight$1(localScrollTarget), scrollPosition = getVerticalScrollPosition$1(localScrollTarget), heightDifference = heightAfter - heightBefore;
              setVerticalScrollPosition$1(localScrollTarget, scrollPosition + heightDifference);
            }
            if (isDone === true) {
              stop2();
            } else if (rootRef.value) {
              rootRef.value.closest("body") && poll();
            }
          });
        }
      });
    }
    function reset() {
      index2 = 0;
    }
    function resume() {
      if (isWorking.value === false) {
        isWorking.value = true;
        localScrollTarget.addEventListener("scroll", poll, passive2$1);
      }
      immediatePoll();
    }
    function stop2() {
      if (isWorking.value === true) {
        isWorking.value = false;
        isFetching.value = false;
        localScrollTarget.removeEventListener("scroll", poll, passive2$1);
        if (poll !== void 0 && poll.cancel !== void 0) {
          poll.cancel();
        }
      }
    }
    function updateScrollTarget() {
      if (localScrollTarget && isWorking.value === true) {
        localScrollTarget.removeEventListener("scroll", poll, passive2$1);
      }
      localScrollTarget = getScrollTarget$1(rootRef.value, props4.scrollTarget);
      if (isWorking.value === true) {
        localScrollTarget.addEventListener("scroll", poll, passive2$1);
        if (props4.reverse === true) {
          const scrollHeight = getScrollHeight$1(localScrollTarget), containerHeight = height$1(localScrollTarget);
          setVerticalScrollPosition$1(localScrollTarget, scrollHeight - containerHeight);
        }
        immediatePoll();
      }
    }
    function setIndex(newIndex) {
      index2 = newIndex;
    }
    function setDebounce(val) {
      val = parseInt(val, 10);
      const oldPoll = poll;
      poll = val <= 0 ? immediatePoll : debounce_default$1(immediatePoll, isNaN(val) === true ? 100 : val);
      if (localScrollTarget && isWorking.value === true) {
        if (oldPoll !== void 0) {
          localScrollTarget.removeEventListener("scroll", oldPoll, passive2$1);
        }
        localScrollTarget.addEventListener("scroll", poll, passive2$1);
      }
    }
    function updateSvgAnimations(isRetry) {
      if (renderLoadingSlot.value === true) {
        if (loadingRef.value === null) {
          isRetry !== true && nextTick(() => {
            updateSvgAnimations(true);
          });
          return;
        }
        const action = `${isFetching.value === true ? "un" : ""}pauseAnimations`;
        Array.from(loadingRef.value.getElementsByTagName("svg")).forEach((el) => {
          el[action]();
        });
      }
    }
    const renderLoadingSlot = computed(() => props4.disable !== true && isWorking.value === true);
    watch([isFetching, renderLoadingSlot], () => {
      updateSvgAnimations();
    });
    watch(() => props4.disable, (val) => {
      if (val === true) {
        stop2();
      } else {
        resume();
      }
    });
    watch(() => props4.reverse, () => {
      if (isFetching.value === false && isWorking.value === true) {
        immediatePoll();
      }
    });
    watch(() => props4.scrollTarget, updateScrollTarget);
    watch(() => props4.debounce, setDebounce);
    let scrollPos = false;
    onActivated(() => {
      if (scrollPos !== false && localScrollTarget) {
        setVerticalScrollPosition$1(localScrollTarget, scrollPos);
      }
    });
    onDeactivated(() => {
      scrollPos = localScrollTarget ? getVerticalScrollPosition$1(localScrollTarget) : false;
    });
    onBeforeUnmount(() => {
      if (isWorking.value === true) {
        localScrollTarget.removeEventListener("scroll", poll, passive2$1);
      }
    });
    onMounted(() => {
      setDebounce(props4.debounce);
      updateScrollTarget();
      isFetching.value === false && updateSvgAnimations();
    });
    const vm2 = getCurrentInstance();
    Object.assign(vm2.proxy, {
      poll: () => {
        poll !== void 0 && poll();
      },
      trigger: trigger3,
      stop: stop2,
      reset,
      resume,
      setIndex,
      updateScrollTarget
    });
    return () => {
      const child = hUniqueSlot$1(slots.default, []);
      if (renderLoadingSlot.value === true) {
        child[props4.reverse === false ? "push" : "unshift"](
          h("div", { ref: loadingRef, class: classes.value }, hSlot$1(slots.loading))
        );
      }
      return h("div", {
        class: "q-infinite-scroll",
        ref: rootRef
      }, child);
    };
  }
});
var QInnerLoading_default = createComponent$1({
  name: "QInnerLoading",
  props: {
    ...useDarkProps$1,
    ...useTransitionProps$1,
    showing: Boolean,
    color: String,
    size: {
      type: [String, Number],
      default: "42px"
    },
    label: String,
    labelClass: String,
    labelStyle: [String, Array, Object]
  },
  setup(props4, { slots }) {
    const vm2 = getCurrentInstance();
    const isDark = use_dark_default$1(props4, vm2.proxy.$q);
    const { transitionProps, transitionStyle } = use_transition_default$1(props4);
    const classes = computed(
      () => "q-inner-loading q--avoid-card-border absolute-full column flex-center" + (isDark.value === true ? " q-inner-loading--dark" : "")
    );
    const labelClass = computed(
      () => "q-inner-loading__label" + (props4.labelClass !== void 0 ? ` ${props4.labelClass}` : "")
    );
    function getInner() {
      const child = [
        h(QSpinner_default$1, {
          size: props4.size,
          color: props4.color
        })
      ];
      if (props4.label !== void 0) {
        child.push(
          h("div", {
            class: labelClass.value,
            style: props4.labelStyle
          }, [props4.label])
        );
      }
      return child;
    }
    function getContent() {
      return props4.showing === true ? h(
        "div",
        { class: classes.value, style: transitionStyle.value },
        slots.default !== void 0 ? slots.default() : getInner()
      ) : null;
    }
    return () => h(Transition, transitionProps.value, getContent);
  }
});
var NAMED_MASKS$1 = {
  date: "####/##/##",
  datetime: "####/##/## ##:##",
  time: "##:##",
  fulltime: "##:##:##",
  phone: "(###) ### - ####",
  card: "#### #### #### ####"
};
var TOKENS$1 = {
  "#": { pattern: "[\\d]", negate: "[^\\d]" },
  S: { pattern: "[a-zA-Z]", negate: "[^a-zA-Z]" },
  N: { pattern: "[0-9a-zA-Z]", negate: "[^0-9a-zA-Z]" },
  A: { pattern: "[a-zA-Z]", negate: "[^a-zA-Z]", transform: (v) => v.toLocaleUpperCase() },
  a: { pattern: "[a-zA-Z]", negate: "[^a-zA-Z]", transform: (v) => v.toLocaleLowerCase() },
  X: { pattern: "[0-9a-zA-Z]", negate: "[^0-9a-zA-Z]", transform: (v) => v.toLocaleUpperCase() },
  x: { pattern: "[0-9a-zA-Z]", negate: "[^0-9a-zA-Z]", transform: (v) => v.toLocaleLowerCase() }
};
var KEYS$1 = Object.keys(TOKENS$1);
KEYS$1.forEach((key) => {
  TOKENS$1[key].regex = new RegExp(TOKENS$1[key].pattern);
});
var tokenRegexMask$1 = new RegExp("\\\\([^.*+?^${}()|([\\]])|([.*+?^${}()|[\\]])|([" + KEYS$1.join("") + "])|(.)", "g");
var escRegex$1 = /[.*+?^${}()|[\]\\]/g;
var MARKER$1 = String.fromCharCode(1);
var useMaskProps$1 = {
  mask: String,
  reverseFillMask: Boolean,
  fillMask: [Boolean, String],
  unmaskedValue: Boolean
};
function use_mask_default$1(props4, emit, emitValue, inputRef) {
  let maskMarked, maskReplaced, computedMask, computedUnmask, pastedTextStart, selectionAnchor;
  const hasMask = ref$1(null);
  const innerValue = ref$1(getInitialMaskedValue());
  function getIsTypeText() {
    return props4.autogrow === true || ["textarea", "text", "search", "url", "tel", "password"].includes(props4.type);
  }
  watch(() => props4.type + props4.autogrow, updateMaskInternals);
  watch(() => props4.mask, (v) => {
    if (v !== void 0) {
      updateMaskValue(innerValue.value, true);
    } else {
      const val = unmaskValue(innerValue.value);
      updateMaskInternals();
      props4.modelValue !== val && emit("update:modelValue", val);
    }
  });
  watch(() => props4.fillMask + props4.reverseFillMask, () => {
    hasMask.value === true && updateMaskValue(innerValue.value, true);
  });
  watch(() => props4.unmaskedValue, () => {
    hasMask.value === true && updateMaskValue(innerValue.value);
  });
  function getInitialMaskedValue() {
    updateMaskInternals();
    if (hasMask.value === true) {
      const masked = maskValue(unmaskValue(props4.modelValue));
      return props4.fillMask !== false ? fillWithMask(masked) : masked;
    }
    return props4.modelValue;
  }
  function getPaddedMaskMarked(size2) {
    if (size2 < maskMarked.length) {
      return maskMarked.slice(-size2);
    }
    let pad2 = "", localMaskMarked = maskMarked;
    const padPos = localMaskMarked.indexOf(MARKER$1);
    if (padPos !== -1) {
      for (let i22 = size2 - localMaskMarked.length; i22 > 0; i22--) {
        pad2 += MARKER$1;
      }
      localMaskMarked = localMaskMarked.slice(0, padPos) + pad2 + localMaskMarked.slice(padPos);
    }
    return localMaskMarked;
  }
  function updateMaskInternals() {
    hasMask.value = props4.mask !== void 0 && props4.mask.length !== 0 && getIsTypeText();
    if (hasMask.value === false) {
      computedUnmask = void 0;
      maskMarked = "";
      maskReplaced = "";
      return;
    }
    const localComputedMask = NAMED_MASKS$1[props4.mask] === void 0 ? props4.mask : NAMED_MASKS$1[props4.mask], fillChar = typeof props4.fillMask === "string" && props4.fillMask.length !== 0 ? props4.fillMask.slice(0, 1) : "_", fillCharEscaped = fillChar.replace(escRegex$1, "\\$&"), unmask = [], extract = [], mask = [];
    let firstMatch = props4.reverseFillMask === true, unmaskChar = "", negateChar = "";
    localComputedMask.replace(tokenRegexMask$1, (_, char1, esc, token2, char2) => {
      if (token2 !== void 0) {
        const c3 = TOKENS$1[token2];
        mask.push(c3);
        negateChar = c3.negate;
        if (firstMatch === true) {
          extract.push("(?:" + negateChar + "+)?(" + c3.pattern + "+)?(?:" + negateChar + "+)?(" + c3.pattern + "+)?");
          firstMatch = false;
        }
        extract.push("(?:" + negateChar + "+)?(" + c3.pattern + ")?");
      } else if (esc !== void 0) {
        unmaskChar = "\\" + (esc === "\\" ? "" : esc);
        mask.push(esc);
        unmask.push("([^" + unmaskChar + "]+)?" + unmaskChar + "?");
      } else {
        const c3 = char1 !== void 0 ? char1 : char2;
        unmaskChar = c3 === "\\" ? "\\\\\\\\" : c3.replace(escRegex$1, "\\\\$&");
        mask.push(c3);
        unmask.push("([^" + unmaskChar + "]+)?" + unmaskChar + "?");
      }
    });
    const unmaskMatcher = new RegExp(
      "^" + unmask.join("") + "(" + (unmaskChar === "" ? "." : "[^" + unmaskChar + "]") + "+)?" + (unmaskChar === "" ? "" : "[" + unmaskChar + "]*") + "$"
    ), extractLast = extract.length - 1, extractMatcher = extract.map((re2, index2) => {
      if (index2 === 0 && props4.reverseFillMask === true) {
        return new RegExp("^" + fillCharEscaped + "*" + re2);
      } else if (index2 === extractLast) {
        return new RegExp(
          "^" + re2 + "(" + (negateChar === "" ? "." : negateChar) + "+)?" + (props4.reverseFillMask === true ? "$" : fillCharEscaped + "*")
        );
      }
      return new RegExp("^" + re2);
    });
    computedMask = mask;
    computedUnmask = (val) => {
      const unmaskMatch = unmaskMatcher.exec(props4.reverseFillMask === true ? val : val.slice(0, mask.length + 1));
      if (unmaskMatch !== null) {
        val = unmaskMatch.slice(1).join("");
      }
      const extractMatch = [], extractMatcherLength = extractMatcher.length;
      for (let i22 = 0, str = val; i22 < extractMatcherLength; i22++) {
        const m32 = extractMatcher[i22].exec(str);
        if (m32 === null) {
          break;
        }
        str = str.slice(m32.shift().length);
        extractMatch.push(...m32);
      }
      if (extractMatch.length !== 0) {
        return extractMatch.join("");
      }
      return val;
    };
    maskMarked = mask.map((v) => typeof v === "string" ? v : MARKER$1).join("");
    maskReplaced = maskMarked.split(MARKER$1).join(fillChar);
  }
  function updateMaskValue(rawVal, updateMaskInternalsFlag, inputType) {
    const inp = inputRef.value, end = inp.selectionEnd, endReverse = inp.value.length - end, unmasked = unmaskValue(rawVal);
    updateMaskInternalsFlag === true && updateMaskInternals();
    const preMasked = maskValue(unmasked), masked = props4.fillMask !== false ? fillWithMask(preMasked) : preMasked, changed2 = innerValue.value !== masked;
    inp.value !== masked && (inp.value = masked);
    changed2 === true && (innerValue.value = masked);
    document.activeElement === inp && nextTick(() => {
      if (masked === maskReplaced) {
        const cursor = props4.reverseFillMask === true ? maskReplaced.length : 0;
        inp.setSelectionRange(cursor, cursor, "forward");
        return;
      }
      if (inputType === "insertFromPaste" && props4.reverseFillMask !== true) {
        const maxEnd = inp.selectionEnd;
        let cursor = end - 1;
        for (let i22 = pastedTextStart; i22 <= cursor && i22 < maxEnd; i22++) {
          if (maskMarked[i22] !== MARKER$1) {
            cursor++;
          }
        }
        moveCursor.right(inp, cursor);
        return;
      }
      if (["deleteContentBackward", "deleteContentForward"].indexOf(inputType) !== -1) {
        const cursor = props4.reverseFillMask === true ? end === 0 ? masked.length > preMasked.length ? 1 : 0 : Math.max(0, masked.length - (masked === maskReplaced ? 0 : Math.min(preMasked.length, endReverse) + 1)) + 1 : end;
        inp.setSelectionRange(cursor, cursor, "forward");
        return;
      }
      if (props4.reverseFillMask === true) {
        if (changed2 === true) {
          const cursor = Math.max(0, masked.length - (masked === maskReplaced ? 0 : Math.min(preMasked.length, endReverse + 1)));
          if (cursor === 1 && end === 1) {
            inp.setSelectionRange(cursor, cursor, "forward");
          } else {
            moveCursor.rightReverse(inp, cursor);
          }
        } else {
          const cursor = masked.length - endReverse;
          inp.setSelectionRange(cursor, cursor, "backward");
        }
      } else {
        if (changed2 === true) {
          const cursor = Math.max(0, maskMarked.indexOf(MARKER$1), Math.min(preMasked.length, end) - 1);
          moveCursor.right(inp, cursor);
        } else {
          const cursor = end - 1;
          moveCursor.right(inp, cursor);
        }
      }
    });
    const val = props4.unmaskedValue === true ? unmaskValue(masked) : masked;
    if (String(props4.modelValue) !== val && (props4.modelValue !== null || val !== "")) {
      emitValue(val, true);
    }
  }
  function moveCursorForPaste(inp, start, end) {
    const preMasked = maskValue(unmaskValue(inp.value));
    start = Math.max(0, maskMarked.indexOf(MARKER$1), Math.min(preMasked.length, start));
    pastedTextStart = start;
    inp.setSelectionRange(start, end, "forward");
  }
  const moveCursor = {
    left(inp, cursor) {
      const noMarkBefore = maskMarked.slice(cursor - 1).indexOf(MARKER$1) === -1;
      let i22 = Math.max(0, cursor - 1);
      for (; i22 >= 0; i22--) {
        if (maskMarked[i22] === MARKER$1) {
          cursor = i22;
          noMarkBefore === true && cursor++;
          break;
        }
      }
      if (i22 < 0 && maskMarked[cursor] !== void 0 && maskMarked[cursor] !== MARKER$1) {
        return moveCursor.right(inp, 0);
      }
      cursor >= 0 && inp.setSelectionRange(cursor, cursor, "backward");
    },
    right(inp, cursor) {
      const limit2 = inp.value.length;
      let i22 = Math.min(limit2, cursor + 1);
      for (; i22 <= limit2; i22++) {
        if (maskMarked[i22] === MARKER$1) {
          cursor = i22;
          break;
        } else if (maskMarked[i22 - 1] === MARKER$1) {
          cursor = i22;
        }
      }
      if (i22 > limit2 && maskMarked[cursor - 1] !== void 0 && maskMarked[cursor - 1] !== MARKER$1) {
        return moveCursor.left(inp, limit2);
      }
      inp.setSelectionRange(cursor, cursor, "forward");
    },
    leftReverse(inp, cursor) {
      const localMaskMarked = getPaddedMaskMarked(inp.value.length);
      let i22 = Math.max(0, cursor - 1);
      for (; i22 >= 0; i22--) {
        if (localMaskMarked[i22 - 1] === MARKER$1) {
          cursor = i22;
          break;
        } else if (localMaskMarked[i22] === MARKER$1) {
          cursor = i22;
          if (i22 === 0) {
            break;
          }
        }
      }
      if (i22 < 0 && localMaskMarked[cursor] !== void 0 && localMaskMarked[cursor] !== MARKER$1) {
        return moveCursor.rightReverse(inp, 0);
      }
      cursor >= 0 && inp.setSelectionRange(cursor, cursor, "backward");
    },
    rightReverse(inp, cursor) {
      const limit2 = inp.value.length, localMaskMarked = getPaddedMaskMarked(limit2), noMarkBefore = localMaskMarked.slice(0, cursor + 1).indexOf(MARKER$1) === -1;
      let i22 = Math.min(limit2, cursor + 1);
      for (; i22 <= limit2; i22++) {
        if (localMaskMarked[i22 - 1] === MARKER$1) {
          cursor = i22;
          cursor > 0 && noMarkBefore === true && cursor--;
          break;
        }
      }
      if (i22 > limit2 && localMaskMarked[cursor - 1] !== void 0 && localMaskMarked[cursor - 1] !== MARKER$1) {
        return moveCursor.leftReverse(inp, limit2);
      }
      inp.setSelectionRange(cursor, cursor, "forward");
    }
  };
  function onMaskedClick(e22) {
    emit("click", e22);
    selectionAnchor = void 0;
  }
  function onMaskedKeydown(e22) {
    emit("keydown", e22);
    if (shouldIgnoreKey$1(e22) === true || e22.altKey === true) {
      return;
    }
    const inp = inputRef.value, start = inp.selectionStart, end = inp.selectionEnd;
    if (!e22.shiftKey) {
      selectionAnchor = void 0;
    }
    if (e22.keyCode === 37 || e22.keyCode === 39) {
      if (e22.shiftKey && selectionAnchor === void 0) {
        selectionAnchor = inp.selectionDirection === "forward" ? start : end;
      }
      const fn = moveCursor[(e22.keyCode === 39 ? "right" : "left") + (props4.reverseFillMask === true ? "Reverse" : "")];
      e22.preventDefault();
      fn(inp, selectionAnchor === start ? end : start);
      if (e22.shiftKey) {
        const cursor = inp.selectionStart;
        inp.setSelectionRange(Math.min(selectionAnchor, cursor), Math.max(selectionAnchor, cursor), "forward");
      }
    } else if (e22.keyCode === 8 && props4.reverseFillMask !== true && start === end) {
      moveCursor.left(inp, start);
      inp.setSelectionRange(inp.selectionStart, end, "backward");
    } else if (e22.keyCode === 46 && props4.reverseFillMask === true && start === end) {
      moveCursor.rightReverse(inp, end);
      inp.setSelectionRange(start, inp.selectionEnd, "forward");
    }
  }
  function maskValue(val) {
    if (val === void 0 || val === null || val === "") {
      return "";
    }
    if (props4.reverseFillMask === true) {
      return maskValueReverse(val);
    }
    const mask = computedMask;
    let valIndex = 0, output = "";
    for (let maskIndex = 0; maskIndex < mask.length; maskIndex++) {
      const valChar = val[valIndex], maskDef = mask[maskIndex];
      if (typeof maskDef === "string") {
        output += maskDef;
        valChar === maskDef && valIndex++;
      } else if (valChar !== void 0 && maskDef.regex.test(valChar)) {
        output += maskDef.transform !== void 0 ? maskDef.transform(valChar) : valChar;
        valIndex++;
      } else {
        return output;
      }
    }
    return output;
  }
  function maskValueReverse(val) {
    const mask = computedMask, firstTokenIndex = maskMarked.indexOf(MARKER$1);
    let valIndex = val.length - 1, output = "";
    for (let maskIndex = mask.length - 1; maskIndex >= 0 && valIndex !== -1; maskIndex--) {
      const maskDef = mask[maskIndex];
      let valChar = val[valIndex];
      if (typeof maskDef === "string") {
        output = maskDef + output;
        valChar === maskDef && valIndex--;
      } else if (valChar !== void 0 && maskDef.regex.test(valChar)) {
        do {
          output = (maskDef.transform !== void 0 ? maskDef.transform(valChar) : valChar) + output;
          valIndex--;
          valChar = val[valIndex];
        } while (firstTokenIndex === maskIndex && valChar !== void 0 && maskDef.regex.test(valChar));
      } else {
        return output;
      }
    }
    return output;
  }
  function unmaskValue(val) {
    return typeof val !== "string" || computedUnmask === void 0 ? typeof val === "number" ? computedUnmask("" + val) : val : computedUnmask(val);
  }
  function fillWithMask(val) {
    if (maskReplaced.length - val.length <= 0) {
      return val;
    }
    return props4.reverseFillMask === true && val.length !== 0 ? maskReplaced.slice(0, -val.length) + val : val + maskReplaced.slice(val.length);
  }
  return {
    innerValue,
    hasMask,
    moveCursorForPaste,
    updateMaskValue,
    onMaskedKeydown,
    onMaskedClick
  };
}
var isJapanese$1 = /[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf]/;
var isChinese$1 = /[\u4e00-\u9fff\u3400-\u4dbf\u{20000}-\u{2a6df}\u{2a700}-\u{2b73f}\u{2b740}-\u{2b81f}\u{2b820}-\u{2ceaf}\uf900-\ufaff\u3300-\u33ff\ufe30-\ufe4f\uf900-\ufaff\u{2f800}-\u{2fa1f}]/u;
var isKorean$1 = /[\u3131-\u314e\u314f-\u3163\uac00-\ud7a3]/;
var isPlainText$1 = /[a-z0-9_ -]$/i;
function use_key_composition_default$1(onInput) {
  return function onComposition(e22) {
    if (e22.type === "compositionend" || e22.type === "change") {
      if (e22.target.qComposing !== true) return;
      e22.target.qComposing = false;
      onInput(e22);
    } else if (e22.type === "compositionupdate" && e22.target.qComposing !== true && typeof e22.data === "string") {
      const isComposing = client$1.is.firefox === true ? isPlainText$1.test(e22.data) === false : isJapanese$1.test(e22.data) === true || isChinese$1.test(e22.data) === true || isKorean$1.test(e22.data) === true;
      if (isComposing === true) {
        e22.target.qComposing = true;
      }
    }
  };
}
var QInput_default$1 = createComponent$1({
  name: "QInput",
  inheritAttrs: false,
  props: {
    ...useFieldProps$1,
    ...useMaskProps$1,
    ...useFormProps$1,
    // override of useFieldProps > modelValue
    modelValue: [String, Number, FileList],
    shadowText: String,
    type: {
      type: String,
      default: "text"
    },
    debounce: [String, Number],
    autogrow: Boolean,
    // makes a textarea
    inputClass: [Array, String, Object],
    inputStyle: [Array, String, Object]
  },
  emits: [
    ...useFieldEmits$1,
    "paste",
    "change",
    "keydown",
    "click",
    "animationend"
  ],
  setup(props4, { emit, attrs }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const temp = {};
    let emitCachedValue = NaN, typedNumber, stopValueWatcher, emitTimer = null, emitValueFn;
    const inputRef = ref$1(null);
    const nameProp = useFormInputNameAttr$1(props4);
    const {
      innerValue,
      hasMask,
      moveCursorForPaste,
      updateMaskValue,
      onMaskedKeydown,
      onMaskedClick
    } = use_mask_default$1(props4, emit, emitValue, inputRef);
    const formDomProps = use_file_dom_props_default$1(
      props4,
      /* type guard */
      true
    );
    const hasValue = computed(() => fieldValueIsFilled$1(innerValue.value));
    const onComposition = use_key_composition_default$1(onInput);
    const state2 = useFieldState$1({ changeEvent: true });
    const isTextarea = computed(
      () => props4.type === "textarea" || props4.autogrow === true
    );
    const isTypeText = computed(
      () => isTextarea.value === true || ["text", "search", "url", "tel", "password"].includes(props4.type)
    );
    const onEvents = computed(() => {
      const evt = {
        ...state2.splitAttrs.listeners.value,
        onInput,
        onPaste,
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        onChange,
        onBlur: onFinishEditing,
        onFocus: stop$1
      };
      evt.onCompositionstart = evt.onCompositionupdate = evt.onCompositionend = onComposition;
      if (hasMask.value === true) {
        evt.onKeydown = onMaskedKeydown;
        evt.onClick = onMaskedClick;
      }
      if (props4.autogrow === true) {
        evt.onAnimationend = onAnimationend;
      }
      return evt;
    });
    const inputAttrs = computed(() => {
      const attrs2 = {
        tabindex: 0,
        "data-autofocus": props4.autofocus === true || void 0,
        rows: props4.type === "textarea" ? 6 : void 0,
        "aria-label": props4.label,
        name: nameProp.value,
        ...state2.splitAttrs.attributes.value,
        id: state2.targetUid.value,
        maxlength: props4.maxlength,
        disabled: props4.disable === true,
        readonly: props4.readonly === true
      };
      if (isTextarea.value === false) {
        attrs2.type = props4.type;
      }
      if (props4.autogrow === true) {
        attrs2.rows = 1;
      }
      return attrs2;
    });
    watch(() => props4.type, () => {
      if (inputRef.value) {
        inputRef.value.value = props4.modelValue;
      }
    });
    watch(() => props4.modelValue, (v) => {
      if (hasMask.value === true) {
        if (stopValueWatcher === true) {
          stopValueWatcher = false;
          if (String(v) === emitCachedValue) {
            return;
          }
        }
        updateMaskValue(v);
      } else if (innerValue.value !== v) {
        innerValue.value = v;
        if (props4.type === "number" && temp.hasOwnProperty("value") === true) {
          if (typedNumber === true) {
            typedNumber = false;
          } else {
            delete temp.value;
          }
        }
      }
      props4.autogrow === true && nextTick(adjustHeight);
    });
    watch(() => props4.autogrow, (val) => {
      if (val === true) {
        nextTick(adjustHeight);
      } else if (inputRef.value !== null && attrs.rows > 0) {
        inputRef.value.style.height = "auto";
      }
    });
    watch(() => props4.dense, () => {
      props4.autogrow === true && nextTick(adjustHeight);
    });
    function focus() {
      addFocusFn$1(() => {
        const el = document.activeElement;
        if (inputRef.value !== null && inputRef.value !== el && (el === null || el.id !== state2.targetUid.value)) {
          inputRef.value.focus({ preventScroll: true });
        }
      });
    }
    function select() {
      inputRef.value !== null && inputRef.value.select();
    }
    function onPaste(e22) {
      if (hasMask.value === true && props4.reverseFillMask !== true) {
        const inp = e22.target;
        moveCursorForPaste(inp, inp.selectionStart, inp.selectionEnd);
      }
      emit("paste", e22);
    }
    function onInput(e22) {
      if (!e22 || !e22.target) {
        return;
      }
      if (props4.type === "file") {
        emit("update:modelValue", e22.target.files);
        return;
      }
      const val = e22.target.value;
      if (e22.target.qComposing === true) {
        temp.value = val;
        return;
      }
      if (hasMask.value === true) {
        updateMaskValue(val, false, e22.inputType);
      } else {
        emitValue(val);
        if (isTypeText.value === true && e22.target === document.activeElement) {
          const { selectionStart, selectionEnd } = e22.target;
          if (selectionStart !== void 0 && selectionEnd !== void 0) {
            nextTick(() => {
              if (e22.target === document.activeElement && val.indexOf(e22.target.value) === 0) {
                e22.target.setSelectionRange(selectionStart, selectionEnd);
              }
            });
          }
        }
      }
      props4.autogrow === true && adjustHeight();
    }
    function onAnimationend(e22) {
      emit("animationend", e22);
      adjustHeight();
    }
    function emitValue(val, stopWatcher) {
      emitValueFn = () => {
        emitTimer = null;
        if (props4.type !== "number" && temp.hasOwnProperty("value") === true) {
          delete temp.value;
        }
        if (props4.modelValue !== val && emitCachedValue !== val) {
          emitCachedValue = val;
          stopWatcher === true && (stopValueWatcher = true);
          emit("update:modelValue", val);
          nextTick(() => {
            emitCachedValue === val && (emitCachedValue = NaN);
          });
        }
        emitValueFn = void 0;
      };
      if (props4.type === "number") {
        typedNumber = true;
        temp.value = val;
      }
      if (props4.debounce !== void 0) {
        emitTimer !== null && clearTimeout(emitTimer);
        temp.value = val;
        emitTimer = setTimeout(emitValueFn, props4.debounce);
      } else {
        emitValueFn();
      }
    }
    function adjustHeight() {
      requestAnimationFrame(() => {
        const inp = inputRef.value;
        if (inp !== null) {
          const parentStyle = inp.parentNode.style;
          const { scrollTop } = inp;
          const { overflowY, maxHeight } = $q.platform.is.firefox === true ? {} : window.getComputedStyle(inp);
          const changeOverflow = overflowY !== void 0 && overflowY !== "scroll";
          changeOverflow === true && (inp.style.overflowY = "hidden");
          parentStyle.marginBottom = inp.scrollHeight - 1 + "px";
          inp.style.height = "1px";
          inp.style.height = inp.scrollHeight + "px";
          changeOverflow === true && (inp.style.overflowY = parseInt(maxHeight, 10) < inp.scrollHeight ? "auto" : "hidden");
          parentStyle.marginBottom = "";
          inp.scrollTop = scrollTop;
        }
      });
    }
    function onChange(e22) {
      onComposition(e22);
      if (emitTimer !== null) {
        clearTimeout(emitTimer);
        emitTimer = null;
      }
      emitValueFn !== void 0 && emitValueFn();
      emit("change", e22.target.value);
    }
    function onFinishEditing(e22) {
      e22 !== void 0 && stop$1(e22);
      if (emitTimer !== null) {
        clearTimeout(emitTimer);
        emitTimer = null;
      }
      emitValueFn !== void 0 && emitValueFn();
      typedNumber = false;
      stopValueWatcher = false;
      delete temp.value;
      props4.type !== "file" && setTimeout(() => {
        if (inputRef.value !== null) {
          inputRef.value.value = innerValue.value !== void 0 ? innerValue.value : "";
        }
      });
    }
    function getCurValue() {
      return temp.hasOwnProperty("value") === true ? temp.value : innerValue.value !== void 0 ? innerValue.value : "";
    }
    onBeforeUnmount(() => {
      onFinishEditing();
    });
    onMounted(() => {
      props4.autogrow === true && adjustHeight();
    });
    Object.assign(state2, {
      innerValue,
      fieldClass: computed(
        () => `q-${isTextarea.value === true ? "textarea" : "input"}` + (props4.autogrow === true ? " q-textarea--autogrow" : "")
      ),
      hasShadow: computed(
        () => props4.type !== "file" && typeof props4.shadowText === "string" && props4.shadowText.length !== 0
      ),
      inputRef,
      emitValue,
      hasValue,
      floatingLabel: computed(
        () => hasValue.value === true && (props4.type !== "number" || isNaN(innerValue.value) === false) || fieldValueIsFilled$1(props4.displayValue)
      ),
      getControl: () => {
        return h(isTextarea.value === true ? "textarea" : "input", {
          ref: inputRef,
          class: [
            "q-field__native q-placeholder",
            props4.inputClass
          ],
          style: props4.inputStyle,
          ...inputAttrs.value,
          ...onEvents.value,
          ...props4.type !== "file" ? { value: getCurValue() } : formDomProps.value
        });
      },
      getShadowControl: () => {
        return h("div", {
          class: "q-field__native q-field__shadow absolute-bottom no-pointer-events" + (isTextarea.value === true ? "" : " text-no-wrap")
        }, [
          h("span", { class: "invisible" }, getCurValue()),
          h("span", props4.shadowText)
        ]);
      }
    });
    const renderFn = use_field_default$1(state2);
    Object.assign(proxy, {
      focus,
      select,
      getNativeElement: () => inputRef.value
      // deprecated
    });
    injectProp$1(proxy, "nativeEl", () => inputRef.value);
    return renderFn;
  }
});
var defaultCfg$1 = {
  threshold: 0,
  root: null,
  rootMargin: "0px"
};
function update2$1(el, ctx, value2) {
  let handler, cfg, changed2;
  if (typeof value2 === "function") {
    handler = value2;
    cfg = defaultCfg$1;
    changed2 = ctx.cfg === void 0;
  } else {
    handler = value2.handler;
    cfg = Object.assign({}, defaultCfg$1, value2.cfg);
    changed2 = ctx.cfg === void 0 || isDeepEqual$1(ctx.cfg, cfg) === false;
  }
  if (ctx.handler !== handler) {
    ctx.handler = handler;
  }
  if (changed2 === true) {
    ctx.cfg = cfg;
    ctx.observer !== void 0 && ctx.observer.unobserve(el);
    ctx.observer = new IntersectionObserver(([entry]) => {
      if (typeof ctx.handler === "function") {
        if (entry.rootBounds === null && document.body.contains(el) === true) {
          ctx.observer.unobserve(el);
          ctx.observer.observe(el);
          return;
        }
        const res = ctx.handler(entry, ctx.observer);
        if (res === false || ctx.once === true && entry.isIntersecting === true) {
          destroy$1(el);
        }
      }
    }, cfg);
    ctx.observer.observe(el);
  }
}
function destroy$1(el) {
  const ctx = el.__qvisible;
  if (ctx !== void 0) {
    ctx.observer !== void 0 && ctx.observer.unobserve(el);
    delete el.__qvisible;
  }
}
var Intersection_default$1 = createDirective$1(
  {
    name: "intersection",
    mounted(el, { modifiers, value: value2 }) {
      const ctx = {
        once: modifiers.once === true
      };
      update2$1(el, ctx, value2);
      el.__qvisible = ctx;
    },
    updated(el, binding) {
      const ctx = el.__qvisible;
      ctx !== void 0 && update2$1(el, ctx, binding.value);
    },
    beforeUnmount: destroy$1
  }
);
var QIntersection_default = createComponent$1({
  name: "QIntersection",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    once: Boolean,
    transition: String,
    transitionDuration: {
      type: [String, Number],
      default: 300
    },
    ssrPrerender: Boolean,
    margin: String,
    threshold: [Number, Array],
    root: {
      default: null
    },
    disable: Boolean,
    onVisibility: Function
  },
  setup(props4, { slots, emit }) {
    const showing = ref$1(isRuntimeSsrPreHydration$1.value === true ? props4.ssrPrerender : false);
    const intersectionProps = computed(() => props4.root !== void 0 || props4.margin !== void 0 || props4.threshold !== void 0 ? {
      handler: trigger3,
      cfg: {
        root: props4.root,
        rootMargin: props4.margin,
        threshold: props4.threshold
      }
    } : trigger3);
    const hasDirective = computed(
      () => props4.disable !== true && (isRuntimeSsrPreHydration$1.value !== true || props4.once !== true || props4.ssrPrerender !== true)
    );
    const directives2 = computed(() => {
      return [[
        Intersection_default$1,
        intersectionProps.value,
        void 0,
        { once: props4.once }
      ]];
    });
    const transitionStyle = computed(
      () => `--q-transition-duration: ${props4.transitionDuration}ms`
    );
    function trigger3(entry) {
      if (showing.value !== entry.isIntersecting) {
        showing.value = entry.isIntersecting;
        props4.onVisibility !== void 0 && emit("visibility", showing.value);
      }
    }
    function getContent() {
      if (showing.value === true) {
        return [h("div", { key: "content", style: transitionStyle.value }, hSlot$1(slots.default))];
      }
      if (slots.hidden !== void 0) {
        return [h("div", { key: "hidden", style: transitionStyle.value }, slots.hidden())];
      }
    }
    return () => {
      const child = props4.transition ? [
        h(Transition, {
          name: "q-transition--" + props4.transition
        }, getContent)
      ] : getContent();
      return hDir$1(
        props4.tag,
        { class: "q-intersection" },
        child,
        "main",
        hasDirective.value,
        () => directives2.value
      );
    };
  }
});
var roleAttrExceptions$1 = ["ul", "ol"];
var QList_default$1 = createComponent$1({
  name: "QList",
  props: {
    ...useDarkProps$1,
    bordered: Boolean,
    dense: Boolean,
    separator: Boolean,
    padding: Boolean,
    tag: {
      type: String,
      default: "div"
    }
  },
  setup(props4, { slots }) {
    const vm2 = getCurrentInstance();
    const isDark = use_dark_default$1(props4, vm2.proxy.$q);
    const role = computed(
      () => roleAttrExceptions$1.includes(props4.tag) ? null : "list"
    );
    const classes = computed(
      () => "q-list" + (props4.bordered === true ? " q-list--bordered" : "") + (props4.dense === true ? " q-list--dense" : "") + (props4.separator === true ? " q-list--separator" : "") + (isDark.value === true ? " q-list--dark" : "") + (props4.padding === true ? " q-list--padding" : "")
    );
    return () => h(props4.tag, { class: classes.value, role: role.value }, hSlot$1(slots.default));
  }
});
var keyCodes2$1 = [34, 37, 40, 33, 39, 38];
var commonPropsName$1 = Object.keys(useCircularCommonProps$1);
createComponent$1({
  name: "QKnob",
  props: {
    ...useFormProps$1,
    ...useCircularCommonProps$1,
    modelValue: {
      type: Number,
      required: true
    },
    innerMin: Number,
    innerMax: Number,
    step: {
      type: Number,
      default: 1,
      validator: (v) => v >= 0
    },
    tabindex: {
      type: [Number, String],
      default: 0
    },
    disable: Boolean,
    readonly: Boolean
  },
  emits: ["update:modelValue", "change", "dragValue"],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const model = ref$1(props4.modelValue);
    const dragging = ref$1(false);
    const innerMin = computed(() => isNaN(props4.innerMin) === true || props4.innerMin < props4.min ? props4.min : props4.innerMin);
    const innerMax = computed(() => isNaN(props4.innerMax) === true || props4.innerMax > props4.max ? props4.max : props4.innerMax);
    let centerPosition;
    function normalizeModel() {
      model.value = props4.modelValue === null ? innerMin.value : between$1(props4.modelValue, innerMin.value, innerMax.value);
      updateValue2(true);
    }
    watch(
      () => `${props4.modelValue}|${innerMin.value}|${innerMax.value}`,
      normalizeModel
    );
    normalizeModel();
    const editable = computed(() => props4.disable === false && props4.readonly === false);
    const classes = computed(
      () => "q-knob non-selectable" + (editable.value === true ? " q-knob--editable" : props4.disable === true ? " disabled" : "")
    );
    const decimals = computed(() => (String(props4.step).trim().split(".")[1] || "").length);
    const step = computed(() => props4.step === 0 ? 1 : props4.step);
    const instantFeedback = computed(() => props4.instantFeedback === true || dragging.value === true);
    const onEvents = $q.platform.is.mobile === true ? computed(() => editable.value === true ? { onClick } : {}) : computed(() => editable.value === true ? {
      onMousedown,
      onClick,
      onKeydown: onKeydown2,
      onKeyup: onKeyup2
    } : {});
    const attrs = computed(() => editable.value === true ? { tabindex: props4.tabindex } : { [`aria-${props4.disable === true ? "disabled" : "readonly"}`]: "true" });
    const circularProps = computed(() => {
      const agg = {};
      commonPropsName$1.forEach((name2) => {
        agg[name2] = props4[name2];
      });
      return agg;
    });
    function pan(event) {
      if (event.isFinal) {
        updatePosition(event.evt, true);
        dragging.value = false;
      } else if (event.isFirst) {
        updateCenterPosition();
        dragging.value = true;
        updatePosition(event.evt);
      } else {
        updatePosition(event.evt);
      }
    }
    const directives2 = computed(() => {
      return [[
        TouchPan_default$1,
        pan,
        void 0,
        { prevent: true, stop: true, mouse: true }
      ]];
    });
    function updateCenterPosition() {
      const { top, left, width: width3, height: height2 } = proxy.$el.getBoundingClientRect();
      centerPosition = {
        top: top + height2 / 2,
        left: left + width3 / 2
      };
    }
    function onMousedown(evt) {
      updateCenterPosition();
      updatePosition(evt);
    }
    function onClick(evt) {
      updateCenterPosition();
      updatePosition(evt, true);
    }
    function onKeydown2(evt) {
      if (!keyCodes2$1.includes(evt.keyCode)) {
        return;
      }
      stopAndPrevent$1(evt);
      const stepVal = ([34, 33].includes(evt.keyCode) ? 10 : 1) * step.value, offset2 = [34, 37, 40].includes(evt.keyCode) ? -stepVal : stepVal;
      model.value = between$1(
        parseFloat((model.value + offset2).toFixed(decimals.value)),
        innerMin.value,
        innerMax.value
      );
      updateValue2();
    }
    function updatePosition(evt, change) {
      const pos = position$1(evt), height2 = Math.abs(pos.top - centerPosition.top), distance = Math.sqrt(
        height2 ** 2 + Math.abs(pos.left - centerPosition.left) ** 2
      );
      let angle2 = Math.asin(height2 / distance) * (180 / Math.PI);
      if (pos.top < centerPosition.top) {
        angle2 = centerPosition.left < pos.left ? 90 - angle2 : 270 + angle2;
      } else {
        angle2 = centerPosition.left < pos.left ? angle2 + 90 : 270 - angle2;
      }
      if ($q.lang.rtl === true) {
        angle2 = normalizeToInterval$1(-angle2 - props4.angle, 0, 360);
      } else if (props4.angle) {
        angle2 = normalizeToInterval$1(angle2 - props4.angle, 0, 360);
      }
      if (props4.reverse === true) {
        angle2 = 360 - angle2;
      }
      let newModel = props4.min + angle2 / 360 * (props4.max - props4.min);
      if (step.value !== 0) {
        const modulo = newModel % step.value;
        newModel = newModel - modulo + (Math.abs(modulo) >= step.value / 2 ? (modulo < 0 ? -1 : 1) * step.value : 0);
        newModel = parseFloat(newModel.toFixed(decimals.value));
      }
      newModel = between$1(newModel, innerMin.value, innerMax.value);
      emit("dragValue", newModel);
      if (model.value !== newModel) {
        model.value = newModel;
      }
      updateValue2(change);
    }
    function onKeyup2(evt) {
      if (keyCodes2$1.includes(evt.keyCode)) {
        updateValue2(true);
      }
    }
    function updateValue2(change) {
      props4.modelValue !== model.value && emit("update:modelValue", model.value);
      change === true && emit("change", model.value);
    }
    const formAttrs = useFormAttrs$1(props4);
    function getNameInput() {
      return h("input", formAttrs.value);
    }
    return () => {
      const data = {
        class: classes.value,
        role: "slider",
        "aria-valuemin": innerMin.value,
        "aria-valuemax": innerMax.value,
        "aria-valuenow": props4.modelValue,
        ...attrs.value,
        ...circularProps.value,
        value: model.value,
        instantFeedback: instantFeedback.value,
        ...onEvents.value
      };
      const child = {
        default: slots.default
      };
      if (editable.value === true && props4.name !== void 0) {
        child.internal = getNameInput;
      }
      return hDir$1(
        QCircularProgress_default$1,
        data,
        child,
        "knob",
        editable.value,
        () => directives2.value
      );
    };
  }
});
var { passive: passive3$1 } = listenOpts$1;
var axisValues$1 = ["both", "horizontal", "vertical"];
var QScrollObserver_default$1 = createComponent$1({
  name: "QScrollObserver",
  props: {
    axis: {
      type: String,
      validator: (v) => axisValues$1.includes(v),
      default: "vertical"
    },
    debounce: [String, Number],
    scrollTarget: scrollTargetProp$1
  },
  emits: ["scroll"],
  setup(props4, { emit }) {
    const scroll = {
      position: {
        top: 0,
        left: 0
      },
      direction: "down",
      directionChanged: false,
      delta: {
        top: 0,
        left: 0
      },
      inflectionPoint: {
        top: 0,
        left: 0
      }
    };
    let clearTimer = null, localScrollTarget, parentEl;
    watch(() => props4.scrollTarget, () => {
      unconfigureScrollTarget();
      configureScrollTarget();
    });
    function emitEvent() {
      clearTimer !== null && clearTimer();
      const top = Math.max(0, getVerticalScrollPosition$1(localScrollTarget));
      const left = getHorizontalScrollPosition$1(localScrollTarget);
      const delta = {
        top: top - scroll.position.top,
        left: left - scroll.position.left
      };
      if (props4.axis === "vertical" && delta.top === 0 || props4.axis === "horizontal" && delta.left === 0) {
        return;
      }
      const curDir = Math.abs(delta.top) >= Math.abs(delta.left) ? delta.top < 0 ? "up" : "down" : delta.left < 0 ? "left" : "right";
      scroll.position = { top, left };
      scroll.directionChanged = scroll.direction !== curDir;
      scroll.delta = delta;
      if (scroll.directionChanged === true) {
        scroll.direction = curDir;
        scroll.inflectionPoint = scroll.position;
      }
      emit("scroll", { ...scroll });
    }
    function configureScrollTarget() {
      localScrollTarget = getScrollTarget$1(parentEl, props4.scrollTarget);
      localScrollTarget.addEventListener("scroll", trigger3, passive3$1);
      trigger3(true);
    }
    function unconfigureScrollTarget() {
      if (localScrollTarget !== void 0) {
        localScrollTarget.removeEventListener("scroll", trigger3, passive3$1);
        localScrollTarget = void 0;
      }
    }
    function trigger3(immediately) {
      if (immediately === true || props4.debounce === 0 || props4.debounce === "0") {
        emitEvent();
      } else if (clearTimer === null) {
        const [timer2, fn] = props4.debounce ? [setTimeout(emitEvent, props4.debounce), clearTimeout] : [requestAnimationFrame(emitEvent), cancelAnimationFrame];
        clearTimer = () => {
          fn(timer2);
          clearTimer = null;
        };
      }
    }
    const { proxy } = getCurrentInstance();
    watch(() => proxy.$q.lang.rtl, emitEvent);
    onMounted(() => {
      parentEl = proxy.$el.parentNode;
      configureScrollTarget();
    });
    onBeforeUnmount(() => {
      clearTimer !== null && clearTimer();
      unconfigureScrollTarget();
    });
    Object.assign(proxy, {
      trigger: trigger3,
      getPosition: () => scroll
    });
    return noop$1;
  }
});
var QLayout_default = createComponent$1({
  name: "QLayout",
  props: {
    container: Boolean,
    view: {
      type: String,
      default: "hhh lpr fff",
      validator: (v) => /^(h|l)h(h|r) lpr (f|l)f(f|r)$/.test(v.toLowerCase())
    },
    onScroll: Function,
    onScrollHeight: Function,
    onResize: Function
  },
  setup(props4, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const rootRef = ref$1(null);
    const height2 = ref$1($q.screen.height);
    const width3 = ref$1(props4.container === true ? 0 : $q.screen.width);
    const scroll = ref$1({ position: 0, direction: "down", inflectionPoint: 0 });
    const containerHeight = ref$1(0);
    const scrollbarWidth = ref$1(isRuntimeSsrPreHydration$1.value === true ? 0 : getScrollbarWidth$1());
    const classes = computed(
      () => "q-layout q-layout--" + (props4.container === true ? "containerized" : "standard")
    );
    const style2 = computed(() => props4.container === false ? { minHeight: $q.screen.height + "px" } : null);
    const targetStyle = computed(() => scrollbarWidth.value !== 0 ? { [$q.lang.rtl === true ? "left" : "right"]: `${scrollbarWidth.value}px` } : null);
    const targetChildStyle = computed(() => scrollbarWidth.value !== 0 ? {
      [$q.lang.rtl === true ? "right" : "left"]: 0,
      [$q.lang.rtl === true ? "left" : "right"]: `-${scrollbarWidth.value}px`,
      width: `calc(100% + ${scrollbarWidth.value}px)`
    } : null);
    function onPageScroll(data) {
      if (props4.container === true || document.qScrollPrevented !== true) {
        const info = {
          position: data.position.top,
          direction: data.direction,
          directionChanged: data.directionChanged,
          inflectionPoint: data.inflectionPoint.top,
          delta: data.delta.top
        };
        scroll.value = info;
        props4.onScroll !== void 0 && emit("scroll", info);
      }
    }
    function onPageResize(data) {
      const { height: newHeight, width: newWidth } = data;
      let resized = false;
      if (height2.value !== newHeight) {
        resized = true;
        height2.value = newHeight;
        props4.onScrollHeight !== void 0 && emit("scrollHeight", newHeight);
        updateScrollbarWidth();
      }
      if (width3.value !== newWidth) {
        resized = true;
        width3.value = newWidth;
      }
      if (resized === true && props4.onResize !== void 0) {
        emit("resize", data);
      }
    }
    function onContainerResize({ height: height3 }) {
      if (containerHeight.value !== height3) {
        containerHeight.value = height3;
        updateScrollbarWidth();
      }
    }
    function updateScrollbarWidth() {
      if (props4.container === true) {
        const width4 = height2.value > containerHeight.value ? getScrollbarWidth$1() : 0;
        if (scrollbarWidth.value !== width4) {
          scrollbarWidth.value = width4;
        }
      }
    }
    let animateTimer = null;
    const $layout = {
      instances: {},
      view: computed(() => props4.view),
      isContainer: computed(() => props4.container),
      rootRef,
      height: height2,
      containerHeight,
      scrollbarWidth,
      totalWidth: computed(() => width3.value + scrollbarWidth.value),
      rows: computed(() => {
        const rows = props4.view.toLowerCase().split(" ");
        return {
          top: rows[0].split(""),
          middle: rows[1].split(""),
          bottom: rows[2].split("")
        };
      }),
      header: reactive({ size: 0, offset: 0, space: false }),
      right: reactive({ size: 300, offset: 0, space: false }),
      footer: reactive({ size: 0, offset: 0, space: false }),
      left: reactive({ size: 300, offset: 0, space: false }),
      scroll,
      animate() {
        if (animateTimer !== null) {
          clearTimeout(animateTimer);
        } else {
          document.body.classList.add("q-body--layout-animate");
        }
        animateTimer = setTimeout(() => {
          animateTimer = null;
          document.body.classList.remove("q-body--layout-animate");
        }, 155);
      },
      update(part, prop, val) {
        $layout[part][prop] = val;
      }
    };
    provide(layoutKey$1, $layout);
    if (getScrollbarWidth$1() > 0) {
      let restoreScrollbar = function() {
        timer2 = null;
        el.classList.remove("hide-scrollbar");
      }, hideScrollbar = function() {
        if (timer2 === null) {
          if (el.scrollHeight > $q.screen.height) {
            return;
          }
          el.classList.add("hide-scrollbar");
        } else {
          clearTimeout(timer2);
        }
        timer2 = setTimeout(restoreScrollbar, 300);
      }, updateScrollEvent = function(action) {
        if (timer2 !== null && action === "remove") {
          clearTimeout(timer2);
          restoreScrollbar();
        }
        window[`${action}EventListener`]("resize", hideScrollbar);
      };
      let timer2 = null;
      const el = document.body;
      watch(
        () => props4.container !== true ? "add" : "remove",
        updateScrollEvent
      );
      props4.container !== true && updateScrollEvent("add");
      onUnmounted(() => {
        updateScrollEvent("remove");
      });
    }
    return () => {
      const content = hMergeSlot$1(slots.default, [
        h(QScrollObserver_default$1, { onScroll: onPageScroll }),
        h(QResizeObserver_default$1, { onResize: onPageResize })
      ]);
      const layout = h("div", {
        class: classes.value,
        style: style2.value,
        ref: props4.container === true ? void 0 : rootRef,
        tabindex: -1
      }, content);
      if (props4.container === true) {
        return h("div", {
          class: "q-layout-container overflow-hidden",
          ref: rootRef
        }, [
          h(QResizeObserver_default$1, { onResize: onContainerResize }),
          h("div", {
            class: "absolute-full",
            style: targetStyle.value
          }, [
            h("div", {
              class: "scroll",
              style: targetChildStyle.value
            }, [layout])
          ])
        ]);
      }
      return layout;
    };
  }
});
var separatorValues$1 = ["horizontal", "vertical", "cell", "none"];
var QMarkupTable_default$1 = createComponent$1({
  name: "QMarkupTable",
  props: {
    ...useDarkProps$1,
    dense: Boolean,
    flat: Boolean,
    bordered: Boolean,
    square: Boolean,
    wrapCells: Boolean,
    separator: {
      type: String,
      default: "horizontal",
      validator: (v) => separatorValues$1.includes(v)
    }
  },
  setup(props4, { slots }) {
    const vm2 = getCurrentInstance();
    const isDark = use_dark_default$1(props4, vm2.proxy.$q);
    const classes = computed(
      () => `q-markup-table q-table__container q-table__card q-table--${props4.separator}-separator` + (isDark.value === true ? " q-table--dark q-table__card--dark q-dark" : "") + (props4.dense === true ? " q-table--dense" : "") + (props4.flat === true ? " q-table--flat" : "") + (props4.bordered === true ? " q-table--bordered" : "") + (props4.square === true ? " q-table--square" : "") + (props4.wrapCells === false ? " q-table--no-wrap" : "")
    );
    return () => h("div", {
      class: classes.value
    }, [
      h("table", { class: "q-table" }, hSlot$1(slots.default))
    ]);
  }
});
createComponent$1({
  name: "QNoSsr",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    placeholder: String
  },
  setup(props4, { slots }) {
    const { isHydrated } = use_hydration_default$1();
    return () => {
      if (isHydrated.value === true) {
        const node2 = hSlot$1(slots.default);
        return node2 === void 0 ? node2 : node2.length > 1 ? h(props4.tag, {}, node2) : node2[0];
      }
      const data = {
        class: "q-no-ssr-placeholder"
      };
      const node = hSlot$1(slots.placeholder);
      if (node !== void 0) {
        return node.length > 1 ? h(props4.tag, data, node) : node[0];
      }
      if (props4.placeholder !== void 0) {
        return h(props4.tag, data, props4.placeholder);
      }
    };
  }
});
var createSvg$1 = () => h("svg", {
  key: "svg",
  class: "q-radio__bg absolute non-selectable",
  viewBox: "0 0 24 24"
}, [
  h("path", {
    d: "M12,22a10,10 0 0 1 -10,-10a10,10 0 0 1 10,-10a10,10 0 0 1 10,10a10,10 0 0 1 -10,10m0,-22a12,12 0 0 0 -12,12a12,12 0 0 0 12,12a12,12 0 0 0 12,-12a12,12 0 0 0 -12,-12"
  }),
  h("path", {
    class: "q-radio__check",
    d: "M12,6a6,6 0 0 0 -6,6a6,6 0 0 0 6,6a6,6 0 0 0 6,-6a6,6 0 0 0 -6,-6"
  })
]);
var QRadio_default$1 = createComponent$1({
  name: "QRadio",
  props: {
    ...useDarkProps$1,
    ...useSizeProps$1,
    ...useFormProps$1,
    modelValue: { required: true },
    val: { required: true },
    label: String,
    leftLabel: Boolean,
    checkedIcon: String,
    uncheckedIcon: String,
    color: String,
    keepColor: Boolean,
    dense: Boolean,
    disable: Boolean,
    tabindex: [String, Number]
  },
  emits: ["update:modelValue"],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const isDark = use_dark_default$1(props4, proxy.$q);
    const sizeStyle = use_size_default$1(props4, option_sizes_default$1);
    const rootRef = ref$1(null);
    const { refocusTargetEl, refocusTarget } = use_refocus_target_default$1(props4, rootRef);
    const isTrue = computed(() => toRaw(props4.modelValue) === toRaw(props4.val));
    const classes = computed(
      () => "q-radio cursor-pointer no-outline row inline no-wrap items-center" + (props4.disable === true ? " disabled" : "") + (isDark.value === true ? " q-radio--dark" : "") + (props4.dense === true ? " q-radio--dense" : "") + (props4.leftLabel === true ? " reverse" : "")
    );
    const innerClass = computed(() => {
      const color2 = props4.color !== void 0 && (props4.keepColor === true || isTrue.value === true) ? ` text-${props4.color}` : "";
      return `q-radio__inner relative-position q-radio__inner--${isTrue.value === true ? "truthy" : "falsy"}${color2}`;
    });
    const icon = computed(
      () => (isTrue.value === true ? props4.checkedIcon : props4.uncheckedIcon) || null
    );
    const tabindex = computed(() => props4.disable === true ? -1 : props4.tabindex || 0);
    const formAttrs = computed(() => {
      const prop = { type: "radio" };
      props4.name !== void 0 && Object.assign(prop, {
        // see https://vuejs.org/guide/extras/render-function.html#creating-vnodes (.prop)
        ".checked": isTrue.value === true,
        "^checked": isTrue.value === true ? "checked" : void 0,
        name: props4.name,
        value: props4.val
      });
      return prop;
    });
    const injectFormInput = useFormInject$1(formAttrs);
    function onClick(e22) {
      if (e22 !== void 0) {
        stopAndPrevent$1(e22);
        refocusTarget(e22);
      }
      if (props4.disable !== true && isTrue.value !== true) {
        emit("update:modelValue", props4.val, e22);
      }
    }
    function onKeydown2(e22) {
      if (e22.keyCode === 13 || e22.keyCode === 32) {
        stopAndPrevent$1(e22);
      }
    }
    function onKeyup2(e22) {
      if (e22.keyCode === 13 || e22.keyCode === 32) {
        onClick(e22);
      }
    }
    Object.assign(proxy, { set: onClick });
    const svg2 = createSvg$1();
    return () => {
      const content = icon.value !== null ? [
        h("div", {
          key: "icon",
          class: "q-radio__icon-container absolute-full flex flex-center no-wrap"
        }, [
          h(QIcon_default$1, {
            class: "q-radio__icon",
            name: icon.value
          })
        ])
      ] : [svg2];
      props4.disable !== true && injectFormInput(
        content,
        "unshift",
        " q-radio__native q-ma-none q-pa-none"
      );
      const child = [
        h("div", {
          class: innerClass.value,
          style: sizeStyle.value,
          "aria-hidden": "true"
        }, content)
      ];
      if (refocusTargetEl.value !== null) {
        child.push(refocusTargetEl.value);
      }
      const label = props4.label !== void 0 ? hMergeSlot$1(slots.default, [props4.label]) : hSlot$1(slots.default);
      label !== void 0 && child.push(
        h("div", {
          class: "q-radio__label q-anchor--skip"
        }, label)
      );
      return h("div", {
        ref: rootRef,
        class: classes.value,
        tabindex: tabindex.value,
        role: "radio",
        "aria-label": props4.label,
        "aria-checked": isTrue.value === true ? "true" : "false",
        "aria-disabled": props4.disable === true ? "true" : void 0,
        onClick,
        onKeydown: onKeydown2,
        onKeyup: onKeyup2
      }, child);
    };
  }
});
var QToggle_default$1 = createComponent$1({
  name: "QToggle",
  props: {
    ...useCheckboxProps$1,
    icon: String,
    iconColor: String
  },
  emits: useCheckboxEmits$1,
  setup(props4) {
    function getInner(isTrue, isIndeterminate) {
      const icon = computed(
        () => (isTrue.value === true ? props4.checkedIcon : isIndeterminate.value === true ? props4.indeterminateIcon : props4.uncheckedIcon) || props4.icon
      );
      const color2 = computed(() => isTrue.value === true ? props4.iconColor : null);
      return () => [
        h("div", { class: "q-toggle__track" }),
        h(
          "div",
          {
            class: "q-toggle__thumb absolute flex flex-center no-wrap"
          },
          icon.value !== void 0 ? [
            h(QIcon_default$1, {
              name: icon.value,
              color: color2.value
            })
          ] : void 0
        )
      ];
    }
    return use_checkbox_default$1("toggle", getInner);
  }
});
var components$1$1 = {
  radio: QRadio_default$1,
  checkbox: QCheckbox_default$1,
  toggle: QToggle_default$1
};
var typeValues$1 = Object.keys(components$1$1);
function getPropValueFn$1(userPropName, defaultPropName) {
  if (typeof userPropName === "function") return userPropName;
  const propName = userPropName !== void 0 ? userPropName : defaultPropName;
  return (opt) => opt[propName];
}
var QOptionGroup_default$1 = createComponent$1({
  name: "QOptionGroup",
  props: {
    ...useDarkProps$1,
    modelValue: {
      required: true
    },
    options: {
      type: Array,
      validator: (opts) => opts.every(isObject$1),
      default: () => []
    },
    optionValue: [Function, String],
    optionLabel: [Function, String],
    optionDisable: [Function, String],
    name: String,
    type: {
      type: String,
      default: "radio",
      validator: (v) => typeValues$1.includes(v)
    },
    color: String,
    keepColor: Boolean,
    dense: Boolean,
    size: String,
    leftLabel: Boolean,
    inline: Boolean,
    disable: Boolean
  },
  emits: ["update:modelValue"],
  setup(props4, { emit, slots }) {
    const { proxy: { $q } } = getCurrentInstance();
    const arrayModel = Array.isArray(props4.modelValue);
    if (props4.type === "radio") {
      if (arrayModel === true) {
        console.error("q-option-group: model should not be array");
      }
    } else if (arrayModel === false) {
      console.error("q-option-group: model should be array in your case");
    }
    const isDark = use_dark_default$1(props4, $q);
    const component = computed(() => components$1$1[props4.type]);
    const getOptionValue = computed(() => getPropValueFn$1(props4.optionValue, "value"));
    const getOptionLabel = computed(() => getPropValueFn$1(props4.optionLabel, "label"));
    const getOptionDisable = computed(() => getPropValueFn$1(props4.optionDisable, "disable"));
    const innerOptions = computed(() => props4.options.map((opt) => ({
      val: getOptionValue.value(opt),
      name: opt.name === void 0 ? props4.name : opt.name,
      disable: props4.disable || getOptionDisable.value(opt),
      leftLabel: opt.leftLabel === void 0 ? props4.leftLabel : opt.leftLabel,
      color: opt.color === void 0 ? props4.color : opt.color,
      checkedIcon: opt.checkedIcon,
      uncheckedIcon: opt.uncheckedIcon,
      dark: opt.dark === void 0 ? isDark.value : opt.dark,
      size: opt.size === void 0 ? props4.size : opt.size,
      dense: props4.dense,
      keepColor: opt.keepColor === void 0 ? props4.keepColor : opt.keepColor
    })));
    const classes = computed(
      () => "q-option-group q-gutter-x-sm" + (props4.inline === true ? " q-option-group--inline" : "")
    );
    const attrs = computed(() => {
      const attrs2 = { role: "group" };
      if (props4.type === "radio") {
        attrs2.role = "radiogroup";
        if (props4.disable === true) {
          attrs2["aria-disabled"] = "true";
        }
      }
      return attrs2;
    });
    function onUpdateModelValue(value2) {
      emit("update:modelValue", value2);
    }
    return () => h("div", {
      class: classes.value,
      ...attrs.value
    }, props4.options.map((opt, i22) => {
      const child = slots["label-" + i22] !== void 0 ? () => slots["label-" + i22](opt) : slots.label !== void 0 ? () => slots.label(opt) : void 0;
      return h("div", [
        h(component.value, {
          label: child === void 0 ? getOptionLabel.value(opt) : null,
          modelValue: props4.modelValue,
          "onUpdate:modelValue": onUpdateModelValue,
          ...innerOptions.value[i22]
        }, child)
      ]);
    }));
  }
});
var QPage_default = createComponent$1({
  name: "QPage",
  props: {
    padding: Boolean,
    styleFn: Function
  },
  setup(props4, { slots }) {
    const { proxy: { $q } } = getCurrentInstance();
    const $layout = inject(layoutKey$1, emptyRenderFn$1);
    if ($layout === emptyRenderFn$1) {
      console.error("QPage needs to be a deep child of QLayout");
      return emptyRenderFn$1;
    }
    const $pageContainer = inject(pageContainerKey$1, emptyRenderFn$1);
    if ($pageContainer === emptyRenderFn$1) {
      console.error("QPage needs to be child of QPageContainer");
      return emptyRenderFn$1;
    }
    const style2 = computed(() => {
      const offset2 = ($layout.header.space === true ? $layout.header.size : 0) + ($layout.footer.space === true ? $layout.footer.size : 0);
      if (typeof props4.styleFn === "function") {
        const height2 = $layout.isContainer.value === true ? $layout.containerHeight.value : $q.screen.height;
        return props4.styleFn(offset2, height2);
      }
      return {
        minHeight: $layout.isContainer.value === true ? $layout.containerHeight.value - offset2 + "px" : $q.screen.height === 0 ? offset2 !== 0 ? `calc(100vh - ${offset2}px)` : "100vh" : $q.screen.height - offset2 + "px"
      };
    });
    const classes = computed(
      () => `q-page${props4.padding === true ? " q-layout-padding" : ""}`
    );
    return () => h("main", {
      class: classes.value,
      style: style2.value
    }, hSlot$1(slots.default));
  }
});
var QPageContainer_default = createComponent$1({
  name: "QPageContainer",
  setup(_, { slots }) {
    const { proxy: { $q } } = getCurrentInstance();
    const $layout = inject(layoutKey$1, emptyRenderFn$1);
    if ($layout === emptyRenderFn$1) {
      console.error("QPageContainer needs to be child of QLayout");
      return emptyRenderFn$1;
    }
    provide(pageContainerKey$1, true);
    const style2 = computed(() => {
      const css2 = {};
      if ($layout.header.space === true) {
        css2.paddingTop = `${$layout.header.size}px`;
      }
      if ($layout.right.space === true) {
        css2[`padding${$q.lang.rtl === true ? "Left" : "Right"}`] = `${$layout.right.size}px`;
      }
      if ($layout.footer.space === true) {
        css2.paddingBottom = `${$layout.footer.size}px`;
      }
      if ($layout.left.space === true) {
        css2[`padding${$q.lang.rtl === true ? "Right" : "Left"}`] = `${$layout.left.size}px`;
      }
      return css2;
    });
    return () => h("div", {
      class: "q-page-container",
      style: style2.value
    }, hSlot$1(slots.default));
  }
});
var usePageStickyProps$1 = {
  position: {
    type: String,
    default: "bottom-right",
    validator: (v) => [
      "top-right",
      "top-left",
      "bottom-right",
      "bottom-left",
      "top",
      "right",
      "bottom",
      "left"
    ].includes(v)
  },
  offset: {
    type: Array,
    validator: (v) => v.length === 2
  },
  expand: Boolean
};
function use_page_sticky_default$1() {
  const { props: props4, proxy: { $q } } = getCurrentInstance();
  const $layout = inject(layoutKey$1, emptyRenderFn$1);
  if ($layout === emptyRenderFn$1) {
    console.error("QPageSticky needs to be child of QLayout");
    return emptyRenderFn$1;
  }
  const attach = computed(() => {
    const pos = props4.position;
    return {
      top: pos.indexOf("top") !== -1,
      right: pos.indexOf("right") !== -1,
      bottom: pos.indexOf("bottom") !== -1,
      left: pos.indexOf("left") !== -1,
      vertical: pos === "top" || pos === "bottom",
      horizontal: pos === "left" || pos === "right"
    };
  });
  const top = computed(() => $layout.header.offset);
  const right = computed(() => $layout.right.offset);
  const bottom = computed(() => $layout.footer.offset);
  const left = computed(() => $layout.left.offset);
  const style2 = computed(() => {
    let posX = 0, posY = 0;
    const side = attach.value;
    const dir = $q.lang.rtl === true ? -1 : 1;
    if (side.top === true && top.value !== 0) {
      posY = `${top.value}px`;
    } else if (side.bottom === true && bottom.value !== 0) {
      posY = `${-bottom.value}px`;
    }
    if (side.left === true && left.value !== 0) {
      posX = `${dir * left.value}px`;
    } else if (side.right === true && right.value !== 0) {
      posX = `${-dir * right.value}px`;
    }
    const css2 = { transform: `translate(${posX}, ${posY})` };
    if (props4.offset) {
      css2.margin = `${props4.offset[1]}px ${props4.offset[0]}px`;
    }
    if (side.vertical === true) {
      if (left.value !== 0) {
        css2[$q.lang.rtl === true ? "right" : "left"] = `${left.value}px`;
      }
      if (right.value !== 0) {
        css2[$q.lang.rtl === true ? "left" : "right"] = `${right.value}px`;
      }
    } else if (side.horizontal === true) {
      if (top.value !== 0) {
        css2.top = `${top.value}px`;
      }
      if (bottom.value !== 0) {
        css2.bottom = `${bottom.value}px`;
      }
    }
    return css2;
  });
  const classes = computed(
    () => `q-page-sticky row flex-center fixed-${props4.position} q-page-sticky--${props4.expand === true ? "expand" : "shrink"}`
  );
  function getStickyContent(slots) {
    const content = hSlot$1(slots.default);
    return h(
      "div",
      {
        class: classes.value,
        style: style2.value
      },
      props4.expand === true ? content : [h("div", content)]
    );
  }
  return {
    $layout,
    getStickyContent
  };
}
createComponent$1({
  name: "QPageScroller",
  props: {
    ...usePageStickyProps$1,
    scrollOffset: {
      type: Number,
      default: 1e3
    },
    reverse: Boolean,
    duration: {
      type: Number,
      default: 300
    },
    offset: {
      ...usePageStickyProps$1.offset,
      default: () => [18, 18]
    }
  },
  emits: ["click"],
  setup(props4, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const { $layout, getStickyContent } = use_page_sticky_default$1();
    const rootRef = ref$1(null);
    let heightWatcher;
    const scrollHeight = computed(() => $layout.height.value - ($layout.isContainer.value === true ? $layout.containerHeight.value : $q.screen.height));
    function isVisible() {
      return props4.reverse === true ? scrollHeight.value - $layout.scroll.value.position > props4.scrollOffset : $layout.scroll.value.position > props4.scrollOffset;
    }
    const showing = ref$1(isVisible());
    function updateVisibility() {
      const newVal = isVisible();
      if (showing.value !== newVal) {
        showing.value = newVal;
      }
    }
    function updateReverse() {
      if (props4.reverse === true) {
        if (heightWatcher === void 0) {
          heightWatcher = watch(scrollHeight, updateVisibility);
        }
      } else {
        cleanup();
      }
    }
    watch($layout.scroll, updateVisibility);
    watch(() => props4.reverse, updateReverse);
    function cleanup() {
      if (heightWatcher !== void 0) {
        heightWatcher();
        heightWatcher = void 0;
      }
    }
    function onClick(e22) {
      const target2 = getScrollTarget$1(
        $layout.isContainer.value === true ? rootRef.value : $layout.rootRef.value
      );
      setVerticalScrollPosition$1(
        target2,
        props4.reverse === true ? $layout.height.value : 0,
        props4.duration
      );
      emit("click", e22);
    }
    function getContent() {
      return showing.value === true ? h("div", {
        ref: rootRef,
        class: "q-page-scroller",
        onClick
      }, getStickyContent(slots)) : null;
    }
    updateReverse();
    onBeforeUnmount(cleanup);
    return () => h(
      Transition,
      { name: "q-transition--fade" },
      getContent
    );
  }
});
createComponent$1({
  name: "QPageSticky",
  props: usePageStickyProps$1,
  setup(_, { slots }) {
    const { getStickyContent } = use_page_sticky_default$1();
    return () => getStickyContent(slots);
  }
});
function getBool$1(val, otherwise) {
  return [true, false].includes(val) ? val : otherwise;
}
createComponent$1({
  name: "QPagination",
  props: {
    ...useDarkProps$1,
    modelValue: {
      type: Number,
      required: true
    },
    min: {
      type: [Number, String],
      default: 1
    },
    max: {
      type: [Number, String],
      required: true
    },
    maxPages: {
      type: [Number, String],
      default: 0,
      validator: (v) => (typeof v === "string" ? parseInt(v, 10) : v) >= 0
    },
    inputStyle: [Array, String, Object],
    inputClass: [Array, String, Object],
    size: String,
    disable: Boolean,
    input: Boolean,
    iconPrev: String,
    iconNext: String,
    iconFirst: String,
    iconLast: String,
    toFn: Function,
    boundaryLinks: {
      type: Boolean,
      default: null
    },
    boundaryNumbers: {
      type: Boolean,
      default: null
    },
    directionLinks: {
      type: Boolean,
      default: null
    },
    ellipses: {
      type: Boolean,
      default: null
    },
    ripple: {
      type: [Boolean, Object],
      default: null
    },
    round: Boolean,
    rounded: Boolean,
    flat: Boolean,
    outline: Boolean,
    unelevated: Boolean,
    push: Boolean,
    glossy: Boolean,
    color: {
      type: String,
      default: "primary"
    },
    textColor: String,
    activeDesign: {
      type: String,
      default: "",
      values: (v) => v === "" || btnDesignOptions$1.includes(v)
    },
    activeColor: String,
    activeTextColor: String,
    gutter: String,
    padding: {
      type: String,
      default: "3px 2px"
    }
  },
  emits: ["update:modelValue"],
  setup(props4, { emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const isDark = use_dark_default$1(props4, $q);
    const minProp = computed(() => parseInt(props4.min, 10));
    const maxProp = computed(() => parseInt(props4.max, 10));
    const maxPagesProp = computed(() => parseInt(props4.maxPages, 10));
    const inputPlaceholder = computed(() => model.value + " / " + maxProp.value);
    const boundaryLinksProp = computed(() => getBool$1(props4.boundaryLinks, props4.input));
    const boundaryNumbersProp = computed(() => getBool$1(props4.boundaryNumbers, !props4.input));
    const directionLinksProp = computed(() => getBool$1(props4.directionLinks, props4.input));
    const ellipsesProp = computed(() => getBool$1(props4.ellipses, !props4.input));
    const newPage = ref$1(null);
    const model = computed({
      get: () => props4.modelValue,
      set: (val) => {
        val = parseInt(val, 10);
        if (props4.disable || isNaN(val)) {
          return;
        }
        const value2 = between$1(val, minProp.value, maxProp.value);
        if (props4.modelValue !== value2) {
          emit("update:modelValue", value2);
        }
      }
    });
    watch(() => `${minProp.value}|${maxProp.value}`, () => {
      model.value = props4.modelValue;
    });
    const classes = computed(
      () => "q-pagination row no-wrap items-center" + (props4.disable === true ? " disabled" : "")
    );
    const gutterProp = computed(() => props4.gutter in btnPadding$1 ? `${btnPadding$1[props4.gutter]}px` : props4.gutter || null);
    const gutterStyle = computed(() => gutterProp.value !== null ? `--q-pagination-gutter-parent:-${gutterProp.value};--q-pagination-gutter-child:${gutterProp.value}` : null);
    const icons = computed(() => {
      const ico = [
        props4.iconFirst || $q.iconSet.pagination.first,
        props4.iconPrev || $q.iconSet.pagination.prev,
        props4.iconNext || $q.iconSet.pagination.next,
        props4.iconLast || $q.iconSet.pagination.last
      ];
      return $q.lang.rtl === true ? ico.reverse() : ico;
    });
    const attrs = computed(() => ({
      "aria-disabled": props4.disable === true ? "true" : "false",
      role: "navigation"
    }));
    const btnDesignProp = computed(() => getBtnDesign$1(props4, "flat"));
    const btnProps = computed(() => ({
      [btnDesignProp.value]: true,
      round: props4.round,
      rounded: props4.rounded,
      padding: props4.padding,
      color: props4.color,
      textColor: props4.textColor,
      size: props4.size,
      ripple: props4.ripple !== null ? props4.ripple : true
    }));
    const btnActiveDesignProp = computed(() => {
      const acc = { [btnDesignProp.value]: false };
      if (props4.activeDesign !== "") {
        acc[props4.activeDesign] = true;
      }
      return acc;
    });
    const activeBtnProps = computed(() => ({
      ...btnActiveDesignProp.value,
      color: props4.activeColor || props4.color,
      textColor: props4.activeTextColor || props4.textColor
    }));
    const btnConfig = computed(() => {
      let maxPages = Math.max(
        maxPagesProp.value,
        1 + (ellipsesProp.value ? 2 : 0) + (boundaryNumbersProp.value ? 2 : 0)
      );
      const acc = {
        pgFrom: minProp.value,
        pgTo: maxProp.value,
        ellipsesStart: false,
        ellipsesEnd: false,
        boundaryStart: false,
        boundaryEnd: false,
        marginalStyle: {
          minWidth: `${Math.max(2, String(maxProp.value).length)}em`
        }
      };
      if (maxPagesProp.value && maxPages < maxProp.value - minProp.value + 1) {
        maxPages = 1 + Math.floor(maxPages / 2) * 2;
        acc.pgFrom = Math.max(minProp.value, Math.min(maxProp.value - maxPages + 1, props4.modelValue - Math.floor(maxPages / 2)));
        acc.pgTo = Math.min(maxProp.value, acc.pgFrom + maxPages - 1);
        if (boundaryNumbersProp.value) {
          acc.boundaryStart = true;
          acc.pgFrom++;
        }
        if (ellipsesProp.value && acc.pgFrom > minProp.value + (boundaryNumbersProp.value ? 1 : 0)) {
          acc.ellipsesStart = true;
          acc.pgFrom++;
        }
        if (boundaryNumbersProp.value) {
          acc.boundaryEnd = true;
          acc.pgTo--;
        }
        if (ellipsesProp.value && acc.pgTo < maxProp.value - (boundaryNumbersProp.value ? 1 : 0)) {
          acc.ellipsesEnd = true;
          acc.pgTo--;
        }
      }
      return acc;
    });
    function set2(value2) {
      model.value = value2;
    }
    function setByOffset(offset2) {
      model.value = model.value + offset2;
    }
    const inputEvents = computed(() => {
      function updateModel2() {
        model.value = newPage.value;
        newPage.value = null;
      }
      return {
        "onUpdate:modelValue": (val) => {
          newPage.value = val;
        },
        onKeyup: (e22) => {
          isKeyCode$1(e22, 13) === true && updateModel2();
        },
        onBlur: updateModel2
      };
    });
    function getBtn2(cfg, page, active) {
      const data = {
        "aria-label": page,
        "aria-current": "false",
        ...btnProps.value,
        ...cfg
      };
      if (active === true) {
        Object.assign(data, {
          "aria-current": "true",
          ...activeBtnProps.value
        });
      }
      if (page !== void 0) {
        if (props4.toFn !== void 0) {
          data.to = props4.toFn(page);
        } else {
          data.onClick = () => {
            set2(page);
          };
        }
      }
      return h(QBtn_default$1, data);
    }
    Object.assign(proxy, { set: set2, setByOffset });
    return () => {
      const contentStart = [];
      const contentEnd = [];
      let contentMiddle;
      if (boundaryLinksProp.value === true) {
        contentStart.push(
          getBtn2({
            key: "bls",
            disable: props4.disable || props4.modelValue <= minProp.value,
            icon: icons.value[0]
          }, minProp.value)
        );
        contentEnd.unshift(
          getBtn2({
            key: "ble",
            disable: props4.disable || props4.modelValue >= maxProp.value,
            icon: icons.value[3]
          }, maxProp.value)
        );
      }
      if (directionLinksProp.value === true) {
        contentStart.push(
          getBtn2({
            key: "bdp",
            disable: props4.disable || props4.modelValue <= minProp.value,
            icon: icons.value[1]
          }, props4.modelValue - 1)
        );
        contentEnd.unshift(
          getBtn2({
            key: "bdn",
            disable: props4.disable || props4.modelValue >= maxProp.value,
            icon: icons.value[2]
          }, props4.modelValue + 1)
        );
      }
      if (props4.input !== true) {
        contentMiddle = [];
        const { pgFrom, pgTo, marginalStyle: style2 } = btnConfig.value;
        if (btnConfig.value.boundaryStart === true) {
          const active = minProp.value === props4.modelValue;
          contentStart.push(
            getBtn2({
              key: "bns",
              style: style2,
              disable: props4.disable,
              label: minProp.value
            }, minProp.value, active)
          );
        }
        if (btnConfig.value.boundaryEnd === true) {
          const active = maxProp.value === props4.modelValue;
          contentEnd.unshift(
            getBtn2({
              key: "bne",
              style: style2,
              disable: props4.disable,
              label: maxProp.value
            }, maxProp.value, active)
          );
        }
        if (btnConfig.value.ellipsesStart === true) {
          contentStart.push(
            getBtn2({
              key: "bes",
              style: style2,
              disable: props4.disable,
              label: "…",
              ripple: false
            }, pgFrom - 1)
          );
        }
        if (btnConfig.value.ellipsesEnd === true) {
          contentEnd.unshift(
            getBtn2({
              key: "bee",
              style: style2,
              disable: props4.disable,
              label: "…",
              ripple: false
            }, pgTo + 1)
          );
        }
        for (let i22 = pgFrom; i22 <= pgTo; i22++) {
          contentMiddle.push(
            getBtn2({
              key: `bpg${i22}`,
              style: style2,
              disable: props4.disable,
              label: i22
            }, i22, i22 === props4.modelValue)
          );
        }
      }
      return h("div", {
        class: classes.value,
        ...attrs.value
      }, [
        h("div", {
          class: "q-pagination__content row no-wrap items-center",
          style: gutterStyle.value
        }, [
          ...contentStart,
          props4.input === true ? h(QInput_default$1, {
            class: "inline",
            style: { width: `${inputPlaceholder.value.length / 1.5}em` },
            type: "number",
            dense: true,
            value: newPage.value,
            disable: props4.disable,
            dark: isDark.value,
            borderless: true,
            inputClass: props4.inputClass,
            inputStyle: props4.inputStyle,
            placeholder: inputPlaceholder.value,
            min: minProp.value,
            max: maxProp.value,
            ...inputEvents.value
          }) : h("div", {
            class: "q-pagination__middle row justify-center"
          }, contentMiddle),
          ...contentEnd
        ])
      ]);
    };
  }
});
function frame_debounce_default$1(fn) {
  let wait2 = false, frame, callArgs;
  function debounced() {
    callArgs = arguments;
    if (wait2 === true) return;
    wait2 = true;
    frame = window.requestAnimationFrame(() => {
      fn.apply(this, callArgs);
      callArgs = void 0;
      wait2 = false;
    });
  }
  debounced.cancel = () => {
    window.cancelAnimationFrame(frame);
    wait2 = false;
  };
  return debounced;
}
var { passive: passive4$1 } = listenOpts$1;
createComponent$1({
  name: "QParallax",
  props: {
    src: String,
    height: {
      type: Number,
      default: 500
    },
    speed: {
      type: Number,
      default: 1,
      validator: (v) => v >= 0 && v <= 1
    },
    scrollTarget: scrollTargetProp$1,
    onScroll: Function
  },
  setup(props4, { slots, emit }) {
    const percentScrolled = ref$1(0);
    const rootRef = ref$1(null);
    const mediaParentRef = ref$1(null);
    const mediaRef = ref$1(null);
    let isWorking, mediaEl, mediaHeight, resizeHandler, observer, localScrollTarget;
    watch(() => props4.height, () => {
      isWorking === true && updatePos();
    });
    watch(() => props4.scrollTarget, () => {
      if (isWorking === true) {
        stop2();
        start();
      }
    });
    let update6 = (percentage) => {
      percentScrolled.value = percentage;
      props4.onScroll !== void 0 && emit("scroll", percentage);
    };
    function updatePos() {
      let containerTop, containerHeight, containerBottom;
      if (localScrollTarget === window) {
        containerTop = 0;
        containerBottom = containerHeight = window.innerHeight;
      } else {
        containerTop = offset$1(localScrollTarget).top;
        containerHeight = height$1(localScrollTarget);
        containerBottom = containerTop + containerHeight;
      }
      const top = offset$1(rootRef.value).top;
      const bottom = top + props4.height;
      if (observer !== void 0 || bottom > containerTop && top < containerBottom) {
        const percent = (containerBottom - top) / (props4.height + containerHeight);
        setPos((mediaHeight - props4.height) * percent * props4.speed);
        update6(percent);
      }
    }
    let setPos = (offset2) => {
      mediaEl.style.transform = `translate3d(-50%,${Math.round(offset2)}px,0)`;
    };
    function onResize() {
      mediaHeight = mediaEl.naturalHeight || mediaEl.videoHeight || height$1(mediaEl);
      isWorking === true && updatePos();
    }
    function start() {
      isWorking = true;
      localScrollTarget = getScrollTarget$1(rootRef.value, props4.scrollTarget);
      localScrollTarget.addEventListener("scroll", updatePos, passive4$1);
      window.addEventListener("resize", resizeHandler, passive4$1);
      updatePos();
    }
    function stop2() {
      if (isWorking === true) {
        isWorking = false;
        localScrollTarget.removeEventListener("scroll", updatePos, passive4$1);
        window.removeEventListener("resize", resizeHandler, passive4$1);
        localScrollTarget = void 0;
        setPos.cancel();
        update6.cancel();
        resizeHandler.cancel();
      }
    }
    onMounted(() => {
      setPos = frame_debounce_default$1(setPos);
      update6 = frame_debounce_default$1(update6);
      resizeHandler = frame_debounce_default$1(onResize);
      mediaEl = slots.media !== void 0 ? mediaParentRef.value.children[0] : mediaRef.value;
      mediaEl.onload = mediaEl.onloadstart = mediaEl.loadedmetadata = onResize;
      onResize();
      mediaEl.style.display = "initial";
      if (window.IntersectionObserver !== void 0) {
        observer = new IntersectionObserver((entries2) => {
          const fn = entries2[0].isIntersecting === true ? start : stop2;
          fn();
        });
        observer.observe(rootRef.value);
      } else {
        start();
      }
    });
    onBeforeUnmount(() => {
      stop2();
      observer !== void 0 && observer.disconnect();
      mediaEl.onload = mediaEl.onloadstart = mediaEl.loadedmetadata = null;
    });
    return () => {
      return h("div", {
        ref: rootRef,
        class: "q-parallax",
        style: { height: `${props4.height}px` }
      }, [
        h("div", {
          ref: mediaParentRef,
          class: "q-parallax__media absolute-full"
        }, slots.media !== void 0 ? slots.media() : [
          h("img", {
            ref: mediaRef,
            src: props4.src
          })
        ]),
        h(
          "div",
          { class: "q-parallax__content absolute-full column flex-center" },
          slots.content !== void 0 ? slots.content({ percentScrolled: percentScrolled.value }) : hSlot$1(slots.default)
        )
      ]);
    };
  }
});
function cloneDeep$1(data, hash = /* @__PURE__ */ new WeakMap()) {
  if (Object(data) !== data) return data;
  if (hash.has(data)) return hash.get(data);
  const result = data instanceof Date ? new Date(data) : data instanceof RegExp ? new RegExp(data.source, data.flags) : data instanceof Set ? /* @__PURE__ */ new Set() : data instanceof Map ? /* @__PURE__ */ new Map() : typeof data.constructor !== "function" ? /* @__PURE__ */ Object.create(null) : data.prototype !== void 0 && typeof data.prototype.constructor === "function" ? data : new data.constructor();
  if (typeof data.constructor === "function" && typeof data.valueOf === "function") {
    const val = data.valueOf();
    if (Object(val) !== val) {
      const result2 = new data.constructor(val);
      hash.set(data, result2);
      return result2;
    }
  }
  hash.set(data, result);
  if (data instanceof Set) {
    data.forEach((val) => {
      result.add(cloneDeep$1(val, hash));
    });
  } else if (data instanceof Map) {
    data.forEach((val, key) => {
      result.set(key, cloneDeep$1(val, hash));
    });
  }
  return Object.assign(
    result,
    ...Object.keys(data).map((key) => ({ [key]: cloneDeep$1(data[key], hash) }))
  );
}
createComponent$1({
  name: "QPopupEdit",
  props: {
    modelValue: {
      required: true
    },
    title: String,
    buttons: Boolean,
    labelSet: String,
    labelCancel: String,
    color: {
      type: String,
      default: "primary"
    },
    validate: {
      type: Function,
      default: () => true
    },
    autoSave: Boolean,
    /* menu props overrides */
    cover: {
      type: Boolean,
      default: true
    },
    /* end of menu props */
    disable: Boolean
  },
  emits: [
    "update:modelValue",
    "save",
    "cancel",
    "beforeShow",
    "show",
    "beforeHide",
    "hide"
  ],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const menuRef = ref$1(null);
    const initialValue = ref$1("");
    const currentModel = ref$1("");
    let validated = false;
    const scope = computed(() => {
      return injectProp$1({
        initialValue: initialValue.value,
        validate: props4.validate,
        set: set2,
        cancel,
        updatePosition
      }, "value", () => currentModel.value, (val) => {
        currentModel.value = val;
      });
    });
    function set2() {
      if (props4.validate(currentModel.value) === false) {
        return;
      }
      if (hasModelChanged() === true) {
        emit("save", currentModel.value, initialValue.value);
        emit("update:modelValue", currentModel.value);
      }
      closeMenu();
    }
    function cancel() {
      if (hasModelChanged() === true) {
        emit("cancel", currentModel.value, initialValue.value);
      }
      closeMenu();
    }
    function updatePosition() {
      nextTick(() => {
        menuRef.value.updatePosition();
      });
    }
    function hasModelChanged() {
      return isDeepEqual$1(currentModel.value, initialValue.value) === false;
    }
    function closeMenu() {
      validated = true;
      menuRef.value.hide();
    }
    function onBeforeShow() {
      validated = false;
      initialValue.value = cloneDeep$1(props4.modelValue);
      currentModel.value = cloneDeep$1(props4.modelValue);
      emit("beforeShow");
    }
    function onShow() {
      emit("show");
    }
    function onBeforeHide() {
      if (validated === false && hasModelChanged() === true) {
        if (props4.autoSave === true && props4.validate(currentModel.value) === true) {
          emit("save", currentModel.value, initialValue.value);
          emit("update:modelValue", currentModel.value);
        } else {
          emit("cancel", currentModel.value, initialValue.value);
        }
      }
      emit("beforeHide");
    }
    function onHide() {
      emit("hide");
    }
    function getContent() {
      const child = slots.default !== void 0 ? [].concat(slots.default(scope.value)) : [];
      props4.title && child.unshift(
        h("div", { class: "q-dialog__title q-mt-sm q-mb-sm" }, props4.title)
      );
      props4.buttons === true && child.push(
        h("div", { class: "q-popup-edit__buttons row justify-center no-wrap" }, [
          h(QBtn_default$1, {
            flat: true,
            color: props4.color,
            label: props4.labelCancel || $q.lang.label.cancel,
            onClick: cancel
          }),
          h(QBtn_default$1, {
            flat: true,
            color: props4.color,
            label: props4.labelSet || $q.lang.label.set,
            onClick: set2
          })
        ])
      );
      return child;
    }
    Object.assign(proxy, {
      set: set2,
      cancel,
      show(e22) {
        menuRef.value !== null && menuRef.value.show(e22);
      },
      hide(e22) {
        menuRef.value !== null && menuRef.value.hide(e22);
      },
      updatePosition
    });
    return () => {
      if (props4.disable === true) return;
      return h(QMenu_default$1, {
        ref: menuRef,
        class: "q-popup-edit",
        cover: props4.cover,
        onBeforeShow,
        onShow,
        onBeforeHide,
        onHide,
        onEscapeKey: cancel
      }, getContent);
    };
  }
});
var QPopupProxy_default = createComponent$1({
  name: "QPopupProxy",
  props: {
    ...useAnchorProps$1,
    breakpoint: {
      type: [String, Number],
      default: 450
    }
  },
  emits: ["show", "hide"],
  setup(props4, { slots, emit, attrs }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const showing = ref$1(false);
    const popupRef = ref$1(null);
    const breakpoint = computed(() => parseInt(props4.breakpoint, 10));
    const { canShow } = use_anchor_default$1({ showing });
    function getType() {
      return $q.screen.width < breakpoint.value || $q.screen.height < breakpoint.value ? "dialog" : "menu";
    }
    const type2 = ref$1(getType());
    const popupProps = computed(
      () => type2.value === "menu" ? { maxHeight: "99vh" } : {}
    );
    watch(() => getType(), (val) => {
      if (showing.value !== true) {
        type2.value = val;
      }
    });
    function onShow(evt) {
      showing.value = true;
      emit("show", evt);
    }
    function onHide(evt) {
      showing.value = false;
      type2.value = getType();
      emit("hide", evt);
    }
    Object.assign(proxy, {
      show(evt) {
        canShow(evt) === true && popupRef.value.show(evt);
      },
      hide(evt) {
        popupRef.value.hide(evt);
      },
      toggle(evt) {
        popupRef.value.toggle(evt);
      }
    });
    injectProp$1(proxy, "currentComponent", () => ({
      type: type2.value,
      ref: popupRef.value
    }));
    return () => {
      const data = {
        ref: popupRef,
        ...popupProps.value,
        ...attrs,
        onShow,
        onHide
      };
      let component;
      if (type2.value === "dialog") {
        component = QDialog_default$1;
      } else {
        component = QMenu_default$1;
        Object.assign(data, {
          target: props4.target,
          contextMenu: props4.contextMenu,
          noParentEvent: true,
          separateClosePopup: true
        });
      }
      return h(component, data, slots.default);
    };
  }
});
var defaultSizes3$1 = {
  xs: 2,
  sm: 4,
  md: 6,
  lg: 10,
  xl: 14
};
function width2$1(val, reverse, $q) {
  return {
    transform: reverse === true ? `translateX(${$q.lang.rtl === true ? "-" : ""}100%) scale3d(${-val},1,1)` : `scale3d(${val},1,1)`
  };
}
var QLinearProgress_default$1 = createComponent$1({
  name: "QLinearProgress",
  props: {
    ...useDarkProps$1,
    ...useSizeProps$1,
    value: {
      type: Number,
      default: 0
    },
    buffer: Number,
    color: String,
    trackColor: String,
    reverse: Boolean,
    stripe: Boolean,
    indeterminate: Boolean,
    query: Boolean,
    rounded: Boolean,
    animationSpeed: {
      type: [String, Number],
      default: 2100
    },
    instantFeedback: Boolean
  },
  setup(props4, { slots }) {
    const { proxy } = getCurrentInstance();
    const isDark = use_dark_default$1(props4, proxy.$q);
    const sizeStyle = use_size_default$1(props4, defaultSizes3$1);
    const motion = computed(() => props4.indeterminate === true || props4.query === true);
    const widthReverse = computed(() => props4.reverse !== props4.query);
    const style2 = computed(() => ({
      ...sizeStyle.value !== null ? sizeStyle.value : {},
      "--q-linear-progress-speed": `${props4.animationSpeed}ms`
    }));
    const classes = computed(
      () => "q-linear-progress" + (props4.color !== void 0 ? ` text-${props4.color}` : "") + (props4.reverse === true || props4.query === true ? " q-linear-progress--reverse" : "") + (props4.rounded === true ? " rounded-borders" : "")
    );
    const trackStyle = computed(() => width2$1(props4.buffer !== void 0 ? props4.buffer : 1, widthReverse.value, proxy.$q));
    const transitionSuffix = computed(() => `with${props4.instantFeedback === true ? "out" : ""}-transition`);
    const trackClass = computed(
      () => `q-linear-progress__track absolute-full q-linear-progress__track--${transitionSuffix.value} q-linear-progress__track--${isDark.value === true ? "dark" : "light"}` + (props4.trackColor !== void 0 ? ` bg-${props4.trackColor}` : "")
    );
    const modelStyle = computed(() => width2$1(motion.value === true ? 1 : props4.value, widthReverse.value, proxy.$q));
    const modelClass = computed(
      () => `q-linear-progress__model absolute-full q-linear-progress__model--${transitionSuffix.value} q-linear-progress__model--${motion.value === true ? "in" : ""}determinate`
    );
    const stripeStyle = computed(() => ({ width: `${props4.value * 100}%` }));
    const stripeClass = computed(
      () => `q-linear-progress__stripe absolute-${props4.reverse === true ? "right" : "left"} q-linear-progress__stripe--${transitionSuffix.value}`
    );
    return () => {
      const child = [
        h("div", {
          class: trackClass.value,
          style: trackStyle.value
        }),
        h("div", {
          class: modelClass.value,
          style: modelStyle.value
        })
      ];
      props4.stripe === true && motion.value === false && child.push(
        h("div", {
          class: stripeClass.value,
          style: stripeStyle.value
        })
      );
      return h("div", {
        class: classes.value,
        style: style2.value,
        role: "progressbar",
        "aria-valuemin": 0,
        "aria-valuemax": 1,
        "aria-valuenow": props4.indeterminate === true ? void 0 : props4.value
      }, hMergeSlot$1(slots.default, child));
    };
  }
});
var PULLER_HEIGHT$1 = 40;
var OFFSET_TOP$1 = 20;
createComponent$1({
  name: "QPullToRefresh",
  props: {
    color: String,
    bgColor: String,
    icon: String,
    noMouse: Boolean,
    disable: Boolean,
    scrollTarget: scrollTargetProp$1
  },
  emits: ["refresh"],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const state2 = ref$1("pull");
    const pullRatio = ref$1(0);
    const pulling = ref$1(false);
    const pullPosition = ref$1(-PULLER_HEIGHT$1);
    const animating = ref$1(false);
    const positionCSS = ref$1({});
    const style2 = computed(() => ({
      opacity: pullRatio.value,
      transform: `translateY(${pullPosition.value}px) rotate(${pullRatio.value * 360}deg)`
    }));
    const classes = computed(
      () => "q-pull-to-refresh__puller row flex-center" + (animating.value === true ? " q-pull-to-refresh__puller--animating" : "") + (props4.bgColor !== void 0 ? ` bg-${props4.bgColor}` : "")
    );
    function pull(event) {
      if (event.isFinal === true) {
        if (pulling.value === true) {
          pulling.value = false;
          if (state2.value === "pulled") {
            state2.value = "refreshing";
            animateTo({ pos: OFFSET_TOP$1 });
            trigger3();
          } else if (state2.value === "pull") {
            animateTo({ pos: -PULLER_HEIGHT$1, ratio: 0 });
          }
        }
        return;
      }
      if (animating.value === true || state2.value === "refreshing") {
        return false;
      }
      if (event.isFirst === true) {
        if (getVerticalScrollPosition$1(localScrollTarget) !== 0 || event.direction !== "down") {
          if (pulling.value === true) {
            pulling.value = false;
            state2.value = "pull";
            animateTo({ pos: -PULLER_HEIGHT$1, ratio: 0 });
          }
          return false;
        }
        pulling.value = true;
        const { top, left } = $el.getBoundingClientRect();
        positionCSS.value = {
          top: top + "px",
          left: left + "px",
          width: window.getComputedStyle($el).getPropertyValue("width")
        };
      }
      prevent$1(event.evt);
      const distance = Math.min(140, Math.max(0, event.distance.y));
      pullPosition.value = distance - PULLER_HEIGHT$1;
      pullRatio.value = between$1(distance / (OFFSET_TOP$1 + PULLER_HEIGHT$1), 0, 1);
      const newState = pullPosition.value > OFFSET_TOP$1 ? "pulled" : "pull";
      if (state2.value !== newState) {
        state2.value = newState;
      }
    }
    const directives2 = computed(() => {
      const modifiers = { down: true };
      if (props4.noMouse !== true) {
        modifiers.mouse = true;
      }
      return [[
        TouchPan_default$1,
        pull,
        void 0,
        modifiers
      ]];
    });
    const contentClass = computed(
      () => `q-pull-to-refresh__content${pulling.value === true ? " no-pointer-events" : ""}`
    );
    function trigger3() {
      emit("refresh", () => {
        animateTo({ pos: -PULLER_HEIGHT$1, ratio: 0 }, () => {
          state2.value = "pull";
        });
      });
    }
    let $el, localScrollTarget, timer2 = null;
    function animateTo({ pos, ratio }, done) {
      animating.value = true;
      pullPosition.value = pos;
      if (ratio !== void 0) {
        pullRatio.value = ratio;
      }
      timer2 !== null && clearTimeout(timer2);
      timer2 = setTimeout(() => {
        timer2 = null;
        animating.value = false;
        done && done();
      }, 300);
    }
    function updateScrollTarget() {
      localScrollTarget = getScrollTarget$1($el, props4.scrollTarget);
    }
    watch(() => props4.scrollTarget, updateScrollTarget);
    onMounted(() => {
      $el = proxy.$el;
      updateScrollTarget();
    });
    onBeforeUnmount(() => {
      timer2 !== null && clearTimeout(timer2);
    });
    Object.assign(proxy, { trigger: trigger3, updateScrollTarget });
    return () => {
      const child = [
        h("div", { class: contentClass.value }, hSlot$1(slots.default)),
        h("div", {
          class: "q-pull-to-refresh__puller-container fixed row flex-center no-pointer-events z-top",
          style: positionCSS.value
        }, [
          h("div", {
            class: classes.value,
            style: style2.value
          }, [
            state2.value !== "refreshing" ? h(QIcon_default$1, {
              name: props4.icon || $q.iconSet.pullToRefresh.icon,
              color: props4.color,
              size: "32px"
            }) : h(QSpinner_default$1, {
              size: "24px",
              color: props4.color
            })
          ])
        ])
      ];
      return hDir$1(
        "div",
        { class: "q-pull-to-refresh" },
        child,
        "main",
        props4.disable === false,
        () => directives2.value
      );
    };
  }
});
var dragType$1 = {
  MIN: 0,
  RANGE: 1,
  MAX: 2
};
var QRange_default = createComponent$1({
  name: "QRange",
  props: {
    ...useSliderProps$1,
    modelValue: {
      type: Object,
      default: () => ({ min: null, max: null }),
      validator: (v) => "min" in v && "max" in v
    },
    dragRange: Boolean,
    dragOnlyRange: Boolean,
    leftLabelColor: String,
    leftLabelTextColor: String,
    rightLabelColor: String,
    rightLabelTextColor: String,
    leftLabelValue: [String, Number],
    rightLabelValue: [String, Number],
    leftThumbColor: String,
    rightThumbColor: String
  },
  emits: useSliderEmits$1,
  setup(props4, { emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const { state: state2, methods } = use_slider_default$1({
      updateValue: updateValue2,
      updatePosition,
      getDragging,
      formAttrs: computed(() => ({
        type: "hidden",
        name: props4.name,
        value: `${props4.modelValue.min}|${props4.modelValue.max}`
      }))
    });
    const rootRef = ref$1(null);
    const curMinRatio = ref$1(0);
    const curMaxRatio = ref$1(0);
    const model = ref$1({ min: 0, max: 0 });
    function normalizeModel() {
      model.value.min = props4.modelValue.min === null ? state2.innerMin.value : between$1(props4.modelValue.min, state2.innerMin.value, state2.innerMax.value);
      model.value.max = props4.modelValue.max === null ? state2.innerMax.value : between$1(props4.modelValue.max, state2.innerMin.value, state2.innerMax.value);
    }
    watch(
      () => `${props4.modelValue.min}|${props4.modelValue.max}|${state2.innerMin.value}|${state2.innerMax.value}`,
      normalizeModel
    );
    normalizeModel();
    const modelMinRatio = computed(() => methods.convertModelToRatio(model.value.min));
    const modelMaxRatio = computed(() => methods.convertModelToRatio(model.value.max));
    const ratioMin = computed(() => state2.active.value === true ? curMinRatio.value : modelMinRatio.value);
    const ratioMax = computed(() => state2.active.value === true ? curMaxRatio.value : modelMaxRatio.value);
    const selectionBarStyle = computed(() => {
      const acc = {
        [state2.positionProp.value]: `${100 * ratioMin.value}%`,
        [state2.sizeProp.value]: `${100 * (ratioMax.value - ratioMin.value)}%`
      };
      if (props4.selectionImg !== void 0) {
        acc.backgroundImage = `url(${props4.selectionImg}) !important`;
      }
      return acc;
    });
    const trackContainerEvents = computed(() => {
      if (state2.editable.value !== true) {
        return {};
      }
      if ($q.platform.is.mobile === true) {
        return { onClick: methods.onMobileClick };
      }
      const evt = { onMousedown: methods.onActivate };
      if (props4.dragRange === true || props4.dragOnlyRange === true) {
        Object.assign(evt, {
          onFocus: () => {
            state2.focus.value = "both";
          },
          onBlur: methods.onBlur,
          onKeydown: onKeydown2,
          onKeyup: methods.onKeyup
        });
      }
      return evt;
    });
    function getEvents(side) {
      return $q.platform.is.mobile !== true && state2.editable.value === true && props4.dragOnlyRange !== true ? {
        onFocus: () => {
          state2.focus.value = side;
        },
        onBlur: methods.onBlur,
        onKeydown: onKeydown2,
        onKeyup: methods.onKeyup
      } : {};
    }
    const thumbTabindex = computed(() => props4.dragOnlyRange !== true ? state2.tabindex.value : null);
    const trackContainerTabindex = computed(() => $q.platform.is.mobile !== true && (props4.dragRange || props4.dragOnlyRange === true) ? state2.tabindex.value : null);
    const minThumbRef = ref$1(null);
    const minEvents = computed(() => getEvents("min"));
    const getMinThumb = methods.getThumbRenderFn({
      focusValue: "min",
      getNodeData: () => ({
        ref: minThumbRef,
        key: "tmin",
        ...minEvents.value,
        tabindex: thumbTabindex.value
      }),
      ratio: ratioMin,
      label: computed(() => props4.leftLabelValue !== void 0 ? props4.leftLabelValue : model.value.min),
      thumbColor: computed(() => props4.leftThumbColor || props4.thumbColor || props4.color),
      labelColor: computed(() => props4.leftLabelColor || props4.labelColor),
      labelTextColor: computed(() => props4.leftLabelTextColor || props4.labelTextColor)
    });
    const maxEvents = computed(() => getEvents("max"));
    const getMaxThumb = methods.getThumbRenderFn({
      focusValue: "max",
      getNodeData: () => ({
        ...maxEvents.value,
        key: "tmax",
        tabindex: thumbTabindex.value
      }),
      ratio: ratioMax,
      label: computed(() => props4.rightLabelValue !== void 0 ? props4.rightLabelValue : model.value.max),
      thumbColor: computed(() => props4.rightThumbColor || props4.thumbColor || props4.color),
      labelColor: computed(() => props4.rightLabelColor || props4.labelColor),
      labelTextColor: computed(() => props4.rightLabelTextColor || props4.labelTextColor)
    });
    function updateValue2(change) {
      if (model.value.min !== props4.modelValue.min || model.value.max !== props4.modelValue.max) {
        emit("update:modelValue", { ...model.value });
      }
      change === true && emit("change", { ...model.value });
    }
    function getDragging(event) {
      const { left, top, width: width3, height: height2 } = rootRef.value.getBoundingClientRect(), sensitivity = props4.dragOnlyRange === true ? 0 : props4.vertical === true ? minThumbRef.value.offsetHeight / (2 * height2) : minThumbRef.value.offsetWidth / (2 * width3);
      const dragging = {
        left,
        top,
        width: width3,
        height: height2,
        valueMin: model.value.min,
        valueMax: model.value.max,
        ratioMin: modelMinRatio.value,
        ratioMax: modelMaxRatio.value
      };
      const ratio = methods.getDraggingRatio(event, dragging);
      if (props4.dragOnlyRange !== true && ratio < dragging.ratioMin + sensitivity) {
        dragging.type = dragType$1.MIN;
      } else if (props4.dragOnlyRange === true || ratio < dragging.ratioMax - sensitivity) {
        if (props4.dragRange === true || props4.dragOnlyRange === true) {
          dragging.type = dragType$1.RANGE;
          Object.assign(dragging, {
            offsetRatio: ratio,
            offsetModel: methods.convertRatioToModel(ratio),
            rangeValue: dragging.valueMax - dragging.valueMin,
            rangeRatio: dragging.ratioMax - dragging.ratioMin
          });
        } else {
          dragging.type = dragging.ratioMax - ratio < ratio - dragging.ratioMin ? dragType$1.MAX : dragType$1.MIN;
        }
      } else {
        dragging.type = dragType$1.MAX;
      }
      return dragging;
    }
    function updatePosition(event, dragging = state2.dragging.value) {
      let pos;
      const ratio = methods.getDraggingRatio(event, dragging);
      const localModel = methods.convertRatioToModel(ratio);
      switch (dragging.type) {
        case dragType$1.MIN:
          if (ratio <= dragging.ratioMax) {
            pos = {
              minR: ratio,
              maxR: dragging.ratioMax,
              min: localModel,
              max: dragging.valueMax
            };
            state2.focus.value = "min";
          } else {
            pos = {
              minR: dragging.ratioMax,
              maxR: ratio,
              min: dragging.valueMax,
              max: localModel
            };
            state2.focus.value = "max";
          }
          break;
        case dragType$1.MAX:
          if (ratio >= dragging.ratioMin) {
            pos = {
              minR: dragging.ratioMin,
              maxR: ratio,
              min: dragging.valueMin,
              max: localModel
            };
            state2.focus.value = "max";
          } else {
            pos = {
              minR: ratio,
              maxR: dragging.ratioMin,
              min: localModel,
              max: dragging.valueMin
            };
            state2.focus.value = "min";
          }
          break;
        case dragType$1.RANGE:
          const ratioDelta = ratio - dragging.offsetRatio, minR = between$1(dragging.ratioMin + ratioDelta, state2.innerMinRatio.value, state2.innerMaxRatio.value - dragging.rangeRatio), modelDelta = localModel - dragging.offsetModel, min2 = between$1(dragging.valueMin + modelDelta, state2.innerMin.value, state2.innerMax.value - dragging.rangeValue);
          pos = {
            minR,
            maxR: minR + dragging.rangeRatio,
            min: state2.roundValueFn.value(min2),
            max: state2.roundValueFn.value(min2 + dragging.rangeValue)
          };
          state2.focus.value = "both";
          break;
      }
      model.value = model.value.min === null || model.value.max === null ? { min: pos.min || props4.min, max: pos.max || props4.max } : { min: pos.min, max: pos.max };
      if (props4.snap !== true || props4.step === 0) {
        curMinRatio.value = pos.minR;
        curMaxRatio.value = pos.maxR;
      } else {
        curMinRatio.value = methods.convertModelToRatio(model.value.min);
        curMaxRatio.value = methods.convertModelToRatio(model.value.max);
      }
    }
    function onKeydown2(evt) {
      if (!keyCodes$1.includes(evt.keyCode)) {
        return;
      }
      stopAndPrevent$1(evt);
      const stepVal = ([34, 33].includes(evt.keyCode) ? 10 : 1) * state2.keyStep.value, offset2 = ([34, 37, 40].includes(evt.keyCode) ? -1 : 1) * (state2.isReversed.value === true ? -1 : 1) * (props4.vertical === true ? -1 : 1) * stepVal;
      if (state2.focus.value === "both") {
        const interval = model.value.max - model.value.min;
        const min2 = between$1(
          state2.roundValueFn.value(model.value.min + offset2),
          state2.innerMin.value,
          state2.innerMax.value - interval
        );
        model.value = {
          min: min2,
          max: state2.roundValueFn.value(min2 + interval)
        };
      } else if (state2.focus.value === false) {
        return;
      } else {
        const which = state2.focus.value;
        model.value = {
          ...model.value,
          [which]: between$1(
            state2.roundValueFn.value(model.value[which] + offset2),
            which === "min" ? state2.innerMin.value : model.value.min,
            which === "max" ? state2.innerMax.value : model.value.max
          )
        };
      }
      updateValue2();
    }
    return () => {
      const content = methods.getContent(
        selectionBarStyle,
        trackContainerTabindex,
        trackContainerEvents,
        (node) => {
          node.push(
            getMinThumb(),
            getMaxThumb()
          );
        }
      );
      return h("div", {
        ref: rootRef,
        class: "q-range " + state2.classes.value + (props4.modelValue.min === null || props4.modelValue.max === null ? " q-slider--no-value" : ""),
        ...state2.attributes.value,
        "aria-valuenow": props4.modelValue.min + "|" + props4.modelValue.max
      }, content);
    };
  }
});
createComponent$1({
  name: "QRating",
  props: {
    ...useSizeProps$1,
    ...useFormProps$1,
    modelValue: {
      type: Number,
      required: true
    },
    max: {
      type: [String, Number],
      default: 5
    },
    icon: [String, Array],
    iconHalf: [String, Array],
    iconSelected: [String, Array],
    iconAriaLabel: [String, Array],
    color: [String, Array],
    colorHalf: [String, Array],
    colorSelected: [String, Array],
    noReset: Boolean,
    noDimming: Boolean,
    readonly: Boolean,
    disable: Boolean
  },
  emits: ["update:modelValue"],
  setup(props4, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const sizeStyle = use_size_default$1(props4);
    const formAttrs = useFormAttrs$1(props4);
    const injectFormInput = useFormInject$1(formAttrs);
    const mouseModel = ref$1(0);
    let iconRefs = {};
    const editable = computed(
      () => props4.readonly !== true && props4.disable !== true
    );
    const classes = computed(
      () => `q-rating row inline items-center q-rating--${editable.value === true ? "" : "non-"}editable` + (props4.noDimming === true ? " q-rating--no-dimming" : "") + (props4.disable === true ? " disabled" : "") + (props4.color !== void 0 && Array.isArray(props4.color) === false ? ` text-${props4.color}` : "")
    );
    const iconData = computed(() => {
      const iconLen = Array.isArray(props4.icon) === true ? props4.icon.length : 0, selIconLen = Array.isArray(props4.iconSelected) === true ? props4.iconSelected.length : 0, halfIconLen = Array.isArray(props4.iconHalf) === true ? props4.iconHalf.length : 0, colorLen = Array.isArray(props4.color) === true ? props4.color.length : 0, selColorLen = Array.isArray(props4.colorSelected) === true ? props4.colorSelected.length : 0, halfColorLen = Array.isArray(props4.colorHalf) === true ? props4.colorHalf.length : 0;
      return {
        iconLen,
        icon: iconLen > 0 ? props4.icon[iconLen - 1] : props4.icon,
        selIconLen,
        selIcon: selIconLen > 0 ? props4.iconSelected[selIconLen - 1] : props4.iconSelected,
        halfIconLen,
        halfIcon: halfIconLen > 0 ? props4.iconHalf[selIconLen - 1] : props4.iconHalf,
        colorLen,
        color: colorLen > 0 ? props4.color[colorLen - 1] : props4.color,
        selColorLen,
        selColor: selColorLen > 0 ? props4.colorSelected[selColorLen - 1] : props4.colorSelected,
        halfColorLen,
        halfColor: halfColorLen > 0 ? props4.colorHalf[halfColorLen - 1] : props4.colorHalf
      };
    });
    const iconLabel = computed(() => {
      if (typeof props4.iconAriaLabel === "string") {
        const label = props4.iconAriaLabel.length !== 0 ? `${props4.iconAriaLabel} ` : "";
        return (i22) => `${label}${i22}`;
      }
      if (Array.isArray(props4.iconAriaLabel) === true) {
        const iMax = props4.iconAriaLabel.length;
        if (iMax > 0) {
          return (i22) => props4.iconAriaLabel[Math.min(i22, iMax) - 1];
        }
      }
      return (i22, label) => `${label} ${i22}`;
    });
    const stars = computed(() => {
      const acc = [], icons = iconData.value, ceil = Math.ceil(props4.modelValue), tabindex = editable.value === true ? 0 : null;
      const halfIndex = props4.iconHalf === void 0 || ceil === props4.modelValue ? -1 : ceil;
      for (let i22 = 1; i22 <= props4.max; i22++) {
        const active = mouseModel.value === 0 && props4.modelValue >= i22 || mouseModel.value > 0 && mouseModel.value >= i22, half = halfIndex === i22 && mouseModel.value < i22, exSelected = mouseModel.value > 0 && (half === true ? ceil : props4.modelValue) >= i22 && mouseModel.value < i22, color2 = half === true ? i22 <= icons.halfColorLen ? props4.colorHalf[i22 - 1] : icons.halfColor : icons.selColor !== void 0 && active === true ? i22 <= icons.selColorLen ? props4.colorSelected[i22 - 1] : icons.selColor : i22 <= icons.colorLen ? props4.color[i22 - 1] : icons.color, name2 = (half === true ? i22 <= icons.halfIconLen ? props4.iconHalf[i22 - 1] : icons.halfIcon : icons.selIcon !== void 0 && (active === true || exSelected === true) ? i22 <= icons.selIconLen ? props4.iconSelected[i22 - 1] : icons.selIcon : i22 <= icons.iconLen ? props4.icon[i22 - 1] : icons.icon) || $q.iconSet.rating.icon;
        acc.push({
          name: (half === true ? i22 <= icons.halfIconLen ? props4.iconHalf[i22 - 1] : icons.halfIcon : icons.selIcon !== void 0 && (active === true || exSelected === true) ? i22 <= icons.selIconLen ? props4.iconSelected[i22 - 1] : icons.selIcon : i22 <= icons.iconLen ? props4.icon[i22 - 1] : icons.icon) || $q.iconSet.rating.icon,
          attrs: {
            tabindex,
            role: "radio",
            "aria-checked": props4.modelValue === i22 ? "true" : "false",
            "aria-label": iconLabel.value(i22, name2)
          },
          iconClass: "q-rating__icon" + (active === true || half === true ? " q-rating__icon--active" : "") + (exSelected === true ? " q-rating__icon--exselected" : "") + (mouseModel.value === i22 ? " q-rating__icon--hovered" : "") + (color2 !== void 0 ? ` text-${color2}` : "")
        });
      }
      return acc;
    });
    const attributes = computed(() => {
      const attrs = { role: "radiogroup" };
      if (props4.disable === true) {
        attrs["aria-disabled"] = "true";
      }
      if (props4.readonly === true) {
        attrs["aria-readonly"] = "true";
      }
      return attrs;
    });
    function set2(value2) {
      if (editable.value === true) {
        const model = between$1(parseInt(value2, 10), 1, parseInt(props4.max, 10)), newVal = props4.noReset !== true && props4.modelValue === model ? 0 : model;
        newVal !== props4.modelValue && emit("update:modelValue", newVal);
        mouseModel.value = 0;
      }
    }
    function setHoverValue(value2) {
      if (editable.value === true) {
        mouseModel.value = value2;
      }
    }
    function onKeyup2(e22, i22) {
      switch (e22.keyCode) {
        case 13:
        case 32:
          set2(i22);
          return stopAndPrevent$1(e22);
        case 37:
        case 40:
          if (iconRefs[`rt${i22 - 1}`]) {
            iconRefs[`rt${i22 - 1}`].focus();
          }
          return stopAndPrevent$1(e22);
        case 39:
        case 38:
          if (iconRefs[`rt${i22 + 1}`]) {
            iconRefs[`rt${i22 + 1}`].focus();
          }
          return stopAndPrevent$1(e22);
      }
    }
    function resetMouseModel() {
      mouseModel.value = 0;
    }
    onBeforeUpdate(() => {
      iconRefs = {};
    });
    return () => {
      const child = [];
      stars.value.forEach(({ iconClass, name: name2, attrs }, index2) => {
        const i22 = index2 + 1;
        child.push(
          h("div", {
            key: i22,
            ref: (el) => {
              iconRefs[`rt${i22}`] = el;
            },
            class: "q-rating__icon-container flex flex-center",
            ...attrs,
            onClick() {
              set2(i22);
            },
            onMouseover() {
              setHoverValue(i22);
            },
            onMouseout: resetMouseModel,
            onFocus() {
              setHoverValue(i22);
            },
            onBlur: resetMouseModel,
            onKeyup(e22) {
              onKeyup2(e22, i22);
            }
          }, hMergeSlot$1(
            slots[`tip-${i22}`],
            [h(QIcon_default$1, { class: iconClass, name: name2 })]
          ))
        );
      });
      if (props4.name !== void 0 && props4.disable !== true) {
        injectFormInput(child, "push");
      }
      return h("div", {
        class: classes.value,
        style: sizeStyle.value,
        ...attributes.value
      }, child);
    };
  }
});
createComponent$1({
  name: "QResponsive",
  props: useRatioProps$1,
  setup(props4, { slots }) {
    const ratioStyle = use_ratio_default$1(props4);
    return () => h("div", {
      class: "q-responsive"
    }, [
      h("div", {
        class: "q-responsive__filler overflow-hidden"
      }, [
        h("div", { style: ratioStyle.value })
      ]),
      h("div", {
        class: "q-responsive__content absolute-full fit"
      }, hSlot$1(slots.default))
    ]);
  }
});
var ScrollAreaControls_default$1 = createComponent$1({
  props: [
    "store",
    "barStyle",
    "verticalBarStyle",
    "horizontalBarStyle"
  ],
  setup(props4) {
    return () => [
      h("div", {
        class: props4.store.scroll.vertical.barClass.value,
        style: [props4.barStyle, props4.verticalBarStyle],
        "aria-hidden": "true",
        onMousedown: props4.store.onVerticalMousedown
      }),
      h("div", {
        class: props4.store.scroll.horizontal.barClass.value,
        style: [props4.barStyle, props4.horizontalBarStyle],
        "aria-hidden": "true",
        onMousedown: props4.store.onHorizontalMousedown
      }),
      withDirectives(
        h("div", {
          ref: props4.store.scroll.vertical.ref,
          class: props4.store.scroll.vertical.thumbClass.value,
          style: props4.store.scroll.vertical.style.value,
          "aria-hidden": "true"
        }),
        props4.store.thumbVertDir
      ),
      withDirectives(
        h("div", {
          ref: props4.store.scroll.horizontal.ref,
          class: props4.store.scroll.horizontal.thumbClass.value,
          style: props4.store.scroll.horizontal.style.value,
          "aria-hidden": "true"
        }),
        props4.store.thumbHorizDir
      )
    ];
  }
});
var axisList$1 = ["vertical", "horizontal"];
var dirProps$1 = {
  vertical: { offset: "offsetY", scroll: "scrollTop", dir: "down", dist: "y" },
  horizontal: { offset: "offsetX", scroll: "scrollLeft", dir: "right", dist: "x" }
};
var panOpts$1 = {
  prevent: true,
  mouse: true,
  mouseAllDir: true
};
var getMinThumbSize$1 = (size2) => size2 >= 250 ? 50 : Math.ceil(size2 / 5);
var QScrollArea_default = createComponent$1({
  name: "QScrollArea",
  props: {
    ...useDarkProps$1,
    thumbStyle: Object,
    verticalThumbStyle: Object,
    horizontalThumbStyle: Object,
    barStyle: [Array, String, Object],
    verticalBarStyle: [Array, String, Object],
    horizontalBarStyle: [Array, String, Object],
    verticalOffset: {
      type: Array,
      default: [0, 0]
    },
    horizontalOffset: {
      type: Array,
      default: [0, 0]
    },
    contentStyle: [Array, String, Object],
    contentActiveStyle: [Array, String, Object],
    delay: {
      type: [String, Number],
      default: 1e3
    },
    visible: {
      type: Boolean,
      default: null
    },
    tabindex: [String, Number],
    onScroll: Function
  },
  setup(props4, { slots, emit }) {
    const tempShowing = ref$1(false);
    const panning = ref$1(false);
    const hover = ref$1(false);
    const container = {
      vertical: ref$1(0),
      horizontal: ref$1(0)
    };
    const scroll = {
      vertical: {
        ref: ref$1(null),
        position: ref$1(0),
        size: ref$1(0)
      },
      horizontal: {
        ref: ref$1(null),
        position: ref$1(0),
        size: ref$1(0)
      }
    };
    const { proxy } = getCurrentInstance();
    const isDark = use_dark_default$1(props4, proxy.$q);
    let timer2 = null, panRefPos;
    const targetRef = ref$1(null);
    const classes = computed(
      () => "q-scrollarea" + (isDark.value === true ? " q-scrollarea--dark" : "")
    );
    Object.assign(container, {
      verticalInner: computed(() => container.vertical.value - props4.verticalOffset[0] - props4.verticalOffset[1]),
      horizontalInner: computed(() => container.horizontal.value - props4.horizontalOffset[0] - props4.horizontalOffset[1])
    });
    scroll.vertical.percentage = computed(() => {
      const diff2 = scroll.vertical.size.value - container.vertical.value;
      if (diff2 <= 0) {
        return 0;
      }
      const p2 = between$1(scroll.vertical.position.value / diff2, 0, 1);
      return Math.round(p2 * 1e4) / 1e4;
    });
    scroll.vertical.thumbHidden = computed(() => (props4.visible === null ? hover.value : props4.visible) !== true && tempShowing.value === false && panning.value === false || scroll.vertical.size.value <= container.vertical.value + 1);
    scroll.vertical.thumbStart = computed(() => props4.verticalOffset[0] + scroll.vertical.percentage.value * (container.verticalInner.value - scroll.vertical.thumbSize.value));
    scroll.vertical.thumbSize = computed(
      () => Math.round(
        between$1(
          container.verticalInner.value * container.verticalInner.value / scroll.vertical.size.value,
          getMinThumbSize$1(container.verticalInner.value),
          container.verticalInner.value
        )
      )
    );
    scroll.vertical.style = computed(() => ({
      ...props4.thumbStyle,
      ...props4.verticalThumbStyle,
      top: `${scroll.vertical.thumbStart.value}px`,
      height: `${scroll.vertical.thumbSize.value}px`,
      right: `${props4.horizontalOffset[1]}px`
    }));
    scroll.vertical.thumbClass = computed(() => "q-scrollarea__thumb q-scrollarea__thumb--v absolute-right" + (scroll.vertical.thumbHidden.value === true ? " q-scrollarea__thumb--invisible" : ""));
    scroll.vertical.barClass = computed(() => "q-scrollarea__bar q-scrollarea__bar--v absolute-right" + (scroll.vertical.thumbHidden.value === true ? " q-scrollarea__bar--invisible" : ""));
    scroll.horizontal.percentage = computed(() => {
      const diff2 = scroll.horizontal.size.value - container.horizontal.value;
      if (diff2 <= 0) {
        return 0;
      }
      const p2 = between$1(Math.abs(scroll.horizontal.position.value) / diff2, 0, 1);
      return Math.round(p2 * 1e4) / 1e4;
    });
    scroll.horizontal.thumbHidden = computed(() => (props4.visible === null ? hover.value : props4.visible) !== true && tempShowing.value === false && panning.value === false || scroll.horizontal.size.value <= container.horizontal.value + 1);
    scroll.horizontal.thumbStart = computed(() => props4.horizontalOffset[0] + scroll.horizontal.percentage.value * (container.horizontalInner.value - scroll.horizontal.thumbSize.value));
    scroll.horizontal.thumbSize = computed(
      () => Math.round(
        between$1(
          container.horizontalInner.value * container.horizontalInner.value / scroll.horizontal.size.value,
          getMinThumbSize$1(container.horizontalInner.value),
          container.horizontalInner.value
        )
      )
    );
    scroll.horizontal.style = computed(() => ({
      ...props4.thumbStyle,
      ...props4.horizontalThumbStyle,
      [proxy.$q.lang.rtl === true ? "right" : "left"]: `${scroll.horizontal.thumbStart.value}px`,
      width: `${scroll.horizontal.thumbSize.value}px`,
      bottom: `${props4.verticalOffset[1]}px`
    }));
    scroll.horizontal.thumbClass = computed(() => "q-scrollarea__thumb q-scrollarea__thumb--h absolute-bottom" + (scroll.horizontal.thumbHidden.value === true ? " q-scrollarea__thumb--invisible" : ""));
    scroll.horizontal.barClass = computed(() => "q-scrollarea__bar q-scrollarea__bar--h absolute-bottom" + (scroll.horizontal.thumbHidden.value === true ? " q-scrollarea__bar--invisible" : ""));
    const mainStyle = computed(() => scroll.vertical.thumbHidden.value === true && scroll.horizontal.thumbHidden.value === true ? props4.contentStyle : props4.contentActiveStyle);
    function getScroll() {
      const info = {};
      axisList$1.forEach((axis) => {
        const data = scroll[axis];
        Object.assign(info, {
          [axis + "Position"]: data.position.value,
          [axis + "Percentage"]: data.percentage.value,
          [axis + "Size"]: data.size.value,
          [axis + "ContainerSize"]: container[axis].value,
          [axis + "ContainerInnerSize"]: container[axis + "Inner"].value
        });
      });
      return info;
    }
    const emitScroll = debounce_default$1(() => {
      const info = getScroll();
      info.ref = proxy;
      emit("scroll", info);
    }, 0);
    function localSetScrollPosition(axis, offset2, duration2) {
      if (axisList$1.includes(axis) === false) {
        console.error("[QScrollArea]: wrong first param of setScrollPosition (vertical/horizontal)");
        return;
      }
      const fn = axis === "vertical" ? setVerticalScrollPosition$1 : setHorizontalScrollPosition$1;
      fn(targetRef.value, offset2, duration2);
    }
    function updateContainer({ height: height2, width: width3 }) {
      let change = false;
      if (container.vertical.value !== height2) {
        container.vertical.value = height2;
        change = true;
      }
      if (container.horizontal.value !== width3) {
        container.horizontal.value = width3;
        change = true;
      }
      change === true && startTimer();
    }
    function updateScroll({ position: position2 }) {
      let change = false;
      if (scroll.vertical.position.value !== position2.top) {
        scroll.vertical.position.value = position2.top;
        change = true;
      }
      if (scroll.horizontal.position.value !== position2.left) {
        scroll.horizontal.position.value = position2.left;
        change = true;
      }
      change === true && startTimer();
    }
    function updateScrollSize({ height: height2, width: width3 }) {
      if (scroll.horizontal.size.value !== width3) {
        scroll.horizontal.size.value = width3;
        startTimer();
      }
      if (scroll.vertical.size.value !== height2) {
        scroll.vertical.size.value = height2;
        startTimer();
      }
    }
    function onPanThumb(e22, axis) {
      const data = scroll[axis];
      if (e22.isFirst === true) {
        if (data.thumbHidden.value === true) {
          return;
        }
        panRefPos = data.position.value;
        panning.value = true;
      } else if (panning.value !== true) {
        return;
      }
      if (e22.isFinal === true) {
        panning.value = false;
      }
      const dProp = dirProps$1[axis];
      const multiplier = (data.size.value - container[axis].value) / (container[axis + "Inner"].value - data.thumbSize.value);
      const distance = e22.distance[dProp.dist];
      const pos = panRefPos + (e22.direction === dProp.dir ? 1 : -1) * distance * multiplier;
      setScroll3(pos, axis);
    }
    function onMousedown(evt, axis) {
      const data = scroll[axis];
      if (data.thumbHidden.value !== true) {
        const startOffset = axis === "vertical" ? props4.verticalOffset[0] : props4.horizontalOffset[0];
        const offset2 = evt[dirProps$1[axis].offset] - startOffset;
        const thumbStart = data.thumbStart.value - startOffset;
        if (offset2 < thumbStart || offset2 > thumbStart + data.thumbSize.value) {
          const targetThumbStart = offset2 - data.thumbSize.value / 2;
          const percentage = between$1(targetThumbStart / (container[axis + "Inner"].value - data.thumbSize.value), 0, 1);
          setScroll3(percentage * Math.max(0, data.size.value - container[axis].value), axis);
        }
        if (data.ref.value !== null) {
          data.ref.value.dispatchEvent(new MouseEvent(evt.type, evt));
        }
      }
    }
    function startTimer() {
      tempShowing.value = true;
      timer2 !== null && clearTimeout(timer2);
      timer2 = setTimeout(() => {
        timer2 = null;
        tempShowing.value = false;
      }, props4.delay);
      props4.onScroll !== void 0 && emitScroll();
    }
    function setScroll3(offset2, axis) {
      targetRef.value[dirProps$1[axis].scroll] = offset2;
    }
    let mouseEventTimer = null;
    function onMouseenter() {
      if (mouseEventTimer !== null) {
        clearTimeout(mouseEventTimer);
      }
      mouseEventTimer = setTimeout(() => {
        mouseEventTimer = null;
        hover.value = true;
      }, proxy.$q.platform.is.ios ? 50 : 0);
    }
    function onMouseleave() {
      if (mouseEventTimer !== null) {
        clearTimeout(mouseEventTimer);
        mouseEventTimer = null;
      }
      hover.value = false;
    }
    let scrollPosition = null;
    watch(() => proxy.$q.lang.rtl, (rtl) => {
      if (targetRef.value !== null) {
        setHorizontalScrollPosition$1(
          targetRef.value,
          Math.abs(scroll.horizontal.position.value) * (rtl === true ? -1 : 1)
        );
      }
    });
    onDeactivated(() => {
      scrollPosition = {
        top: scroll.vertical.position.value,
        left: scroll.horizontal.position.value
      };
    });
    onActivated(() => {
      if (scrollPosition === null) return;
      const scrollTarget = targetRef.value;
      if (scrollTarget !== null) {
        setHorizontalScrollPosition$1(scrollTarget, scrollPosition.left);
        setVerticalScrollPosition$1(scrollTarget, scrollPosition.top);
      }
    });
    onBeforeUnmount(emitScroll.cancel);
    Object.assign(proxy, {
      getScrollTarget: () => targetRef.value,
      getScroll,
      getScrollPosition: () => ({
        top: scroll.vertical.position.value,
        left: scroll.horizontal.position.value
      }),
      getScrollPercentage: () => ({
        top: scroll.vertical.percentage.value,
        left: scroll.horizontal.percentage.value
      }),
      setScrollPosition: localSetScrollPosition,
      setScrollPercentage(axis, percentage, duration2) {
        localSetScrollPosition(
          axis,
          percentage * (scroll[axis].size.value - container[axis].value) * (axis === "horizontal" && proxy.$q.lang.rtl === true ? -1 : 1),
          duration2
        );
      }
    });
    const store = {
      scroll,
      thumbVertDir: [[
        TouchPan_default$1,
        (e22) => {
          onPanThumb(e22, "vertical");
        },
        void 0,
        { vertical: true, ...panOpts$1 }
      ]],
      thumbHorizDir: [[
        TouchPan_default$1,
        (e22) => {
          onPanThumb(e22, "horizontal");
        },
        void 0,
        { horizontal: true, ...panOpts$1 }
      ]],
      onVerticalMousedown(evt) {
        onMousedown(evt, "vertical");
      },
      onHorizontalMousedown(evt) {
        onMousedown(evt, "horizontal");
      }
    };
    return () => {
      return h("div", {
        class: classes.value,
        onMouseenter,
        onMouseleave
      }, [
        h("div", {
          ref: targetRef,
          class: "q-scrollarea__container scroll relative-position fit hide-scrollbar",
          tabindex: props4.tabindex !== void 0 ? props4.tabindex : void 0
        }, [
          h("div", {
            class: "q-scrollarea__content absolute",
            style: mainStyle.value
          }, hMergeSlot$1(slots.default, [
            h(QResizeObserver_default$1, {
              debounce: 0,
              onResize: updateScrollSize
            })
          ])),
          h(QScrollObserver_default$1, {
            axis: "both",
            onScroll: updateScroll
          })
        ]),
        h(QResizeObserver_default$1, {
          debounce: 0,
          onResize: updateContainer
        }),
        h(ScrollAreaControls_default$1, {
          store,
          barStyle: props4.barStyle,
          verticalBarStyle: props4.verticalBarStyle,
          horizontalBarStyle: props4.horizontalBarStyle
        })
      ]);
    };
  }
});
var aggBucketSize$1 = 1e3;
var scrollToEdges$1 = [
  "start",
  "center",
  "end",
  "start-force",
  "center-force",
  "end-force"
];
var filterProto$1 = Array.prototype.filter;
var setOverflowAnchor$1 = __QUASAR_SSR__ || window.getComputedStyle(document.body).overflowAnchor === void 0 ? noop$1 : function(contentEl, index2) {
  if (contentEl === null) {
    return;
  }
  if (contentEl._qOverflowAnimationFrame !== void 0) {
    cancelAnimationFrame(contentEl._qOverflowAnimationFrame);
  }
  contentEl._qOverflowAnimationFrame = requestAnimationFrame(() => {
    if (contentEl === null) {
      return;
    }
    contentEl._qOverflowAnimationFrame = void 0;
    const children = contentEl.children || [];
    filterProto$1.call(children, (el2) => el2.dataset && el2.dataset.qVsAnchor !== void 0).forEach((el2) => {
      delete el2.dataset.qVsAnchor;
    });
    const el = children[index2];
    if (el && el.dataset) {
      el.dataset.qVsAnchor = "";
    }
  });
};
function sumFn$1(acc, h138) {
  return acc + h138;
}
function getScrollDetails$1(parent, child, beforeRef, afterRef, horizontal, rtl, stickyStart, stickyEnd) {
  const parentCalc = parent === window ? document.scrollingElement || document.documentElement : parent, propElSize = horizontal === true ? "offsetWidth" : "offsetHeight", details = {
    scrollStart: 0,
    scrollViewSize: -stickyStart - stickyEnd,
    scrollMaxSize: 0,
    offsetStart: -stickyStart,
    offsetEnd: -stickyEnd
  };
  if (horizontal === true) {
    if (parent === window) {
      details.scrollStart = window.pageXOffset || window.scrollX || document.body.scrollLeft || 0;
      details.scrollViewSize += document.documentElement.clientWidth;
    } else {
      details.scrollStart = parentCalc.scrollLeft;
      details.scrollViewSize += parentCalc.clientWidth;
    }
    details.scrollMaxSize = parentCalc.scrollWidth;
    if (rtl === true) {
      details.scrollStart = (rtlHasScrollBug$1 === true ? details.scrollMaxSize - details.scrollViewSize : 0) - details.scrollStart;
    }
  } else {
    if (parent === window) {
      details.scrollStart = window.pageYOffset || window.scrollY || document.body.scrollTop || 0;
      details.scrollViewSize += document.documentElement.clientHeight;
    } else {
      details.scrollStart = parentCalc.scrollTop;
      details.scrollViewSize += parentCalc.clientHeight;
    }
    details.scrollMaxSize = parentCalc.scrollHeight;
  }
  if (beforeRef !== null) {
    for (let el = beforeRef.previousElementSibling; el !== null; el = el.previousElementSibling) {
      if (el.classList.contains("q-virtual-scroll--skip") === false) {
        details.offsetStart += el[propElSize];
      }
    }
  }
  if (afterRef !== null) {
    for (let el = afterRef.nextElementSibling; el !== null; el = el.nextElementSibling) {
      if (el.classList.contains("q-virtual-scroll--skip") === false) {
        details.offsetEnd += el[propElSize];
      }
    }
  }
  if (child !== parent) {
    const parentRect = parentCalc.getBoundingClientRect(), childRect = child.getBoundingClientRect();
    if (horizontal === true) {
      details.offsetStart += childRect.left - parentRect.left;
      details.offsetEnd -= childRect.width;
    } else {
      details.offsetStart += childRect.top - parentRect.top;
      details.offsetEnd -= childRect.height;
    }
    if (parent !== window) {
      details.offsetStart += details.scrollStart;
    }
    details.offsetEnd += details.scrollMaxSize - details.offsetStart;
  }
  return details;
}
function setScroll2$1(parent, scroll, horizontal, rtl) {
  if (scroll === "end") {
    scroll = (parent === window ? document.body : parent)[horizontal === true ? "scrollWidth" : "scrollHeight"];
  }
  if (parent === window) {
    if (horizontal === true) {
      if (rtl === true) {
        scroll = (rtlHasScrollBug$1 === true ? document.body.scrollWidth - document.documentElement.clientWidth : 0) - scroll;
      }
      window.scrollTo(scroll, window.pageYOffset || window.scrollY || document.body.scrollTop || 0);
    } else {
      window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, scroll);
    }
  } else if (horizontal === true) {
    if (rtl === true) {
      scroll = (rtlHasScrollBug$1 === true ? parent.scrollWidth - parent.offsetWidth : 0) - scroll;
    }
    parent.scrollLeft = scroll;
  } else {
    parent.scrollTop = scroll;
  }
}
function sumSize$1(sizeAgg, size2, from2, to2) {
  if (from2 >= to2) {
    return 0;
  }
  const lastTo = size2.length, fromAgg = Math.floor(from2 / aggBucketSize$1), toAgg = Math.floor((to2 - 1) / aggBucketSize$1) + 1;
  let total = sizeAgg.slice(fromAgg, toAgg).reduce(sumFn$1, 0);
  if (from2 % aggBucketSize$1 !== 0) {
    total -= size2.slice(fromAgg * aggBucketSize$1, from2).reduce(sumFn$1, 0);
  }
  if (to2 % aggBucketSize$1 !== 0 && to2 !== lastTo) {
    total -= size2.slice(to2, toAgg * aggBucketSize$1).reduce(sumFn$1, 0);
  }
  return total;
}
var commonVirtScrollProps$1 = {
  virtualScrollSliceSize: {
    type: [Number, String],
    default: 10
  },
  virtualScrollSliceRatioBefore: {
    type: [Number, String],
    default: 1
  },
  virtualScrollSliceRatioAfter: {
    type: [Number, String],
    default: 1
  },
  virtualScrollItemSize: {
    type: [Number, String],
    default: 24
  },
  virtualScrollStickySizeStart: {
    type: [Number, String],
    default: 0
  },
  virtualScrollStickySizeEnd: {
    type: [Number, String],
    default: 0
  },
  tableColspan: [Number, String]
};
var commonVirtScrollPropsList$1 = Object.keys(commonVirtScrollProps$1);
var useVirtualScrollProps$1 = {
  virtualScrollHorizontal: Boolean,
  onVirtualScroll: Function,
  ...commonVirtScrollProps$1
};
function useVirtualScroll$1({
  virtualScrollLength,
  getVirtualScrollTarget,
  getVirtualScrollEl,
  virtualScrollItemSizeComputed
  // optional
}) {
  const vm2 = getCurrentInstance();
  const { props: props4, emit, proxy } = vm2;
  const { $q } = proxy;
  let prevScrollStart, prevToIndex, localScrollViewSize, virtualScrollSizesAgg = [], virtualScrollSizes;
  const virtualScrollPaddingBefore = ref$1(0);
  const virtualScrollPaddingAfter = ref$1(0);
  const virtualScrollSliceSizeComputed = ref$1({});
  const beforeRef = ref$1(null);
  const afterRef = ref$1(null);
  const contentRef = ref$1(null);
  const virtualScrollSliceRange = ref$1({ from: 0, to: 0 });
  const colspanAttr = computed(() => props4.tableColspan !== void 0 ? props4.tableColspan : 100);
  if (virtualScrollItemSizeComputed === void 0) {
    virtualScrollItemSizeComputed = computed(() => props4.virtualScrollItemSize);
  }
  const needsReset = computed(() => virtualScrollItemSizeComputed.value + ";" + props4.virtualScrollHorizontal);
  const needsSliceRecalc = computed(
    () => needsReset.value + ";" + props4.virtualScrollSliceRatioBefore + ";" + props4.virtualScrollSliceRatioAfter
  );
  watch(needsSliceRecalc, () => {
    setVirtualScrollSize();
  });
  watch(needsReset, reset);
  function reset() {
    localResetVirtualScroll(prevToIndex, true);
  }
  function refresh(toIndex) {
    localResetVirtualScroll(toIndex === void 0 ? prevToIndex : toIndex);
  }
  function scrollTo(toIndex, edge) {
    const scrollEl = getVirtualScrollTarget();
    if (scrollEl === void 0 || scrollEl === null || scrollEl.nodeType === 8) {
      return;
    }
    const scrollDetails = getScrollDetails$1(
      scrollEl,
      getVirtualScrollEl(),
      beforeRef.value,
      afterRef.value,
      props4.virtualScrollHorizontal,
      $q.lang.rtl,
      props4.virtualScrollStickySizeStart,
      props4.virtualScrollStickySizeEnd
    );
    localScrollViewSize !== scrollDetails.scrollViewSize && setVirtualScrollSize(scrollDetails.scrollViewSize);
    setVirtualScrollSliceRange(
      scrollEl,
      scrollDetails,
      Math.min(virtualScrollLength.value - 1, Math.max(0, parseInt(toIndex, 10) || 0)),
      0,
      scrollToEdges$1.indexOf(edge) !== -1 ? edge : prevToIndex !== -1 && toIndex > prevToIndex ? "end" : "start"
    );
  }
  function localOnVirtualScrollEvt() {
    const scrollEl = getVirtualScrollTarget();
    if (scrollEl === void 0 || scrollEl === null || scrollEl.nodeType === 8) {
      return;
    }
    const scrollDetails = getScrollDetails$1(
      scrollEl,
      getVirtualScrollEl(),
      beforeRef.value,
      afterRef.value,
      props4.virtualScrollHorizontal,
      $q.lang.rtl,
      props4.virtualScrollStickySizeStart,
      props4.virtualScrollStickySizeEnd
    ), listLastIndex = virtualScrollLength.value - 1, listEndOffset = scrollDetails.scrollMaxSize - scrollDetails.offsetStart - scrollDetails.offsetEnd - virtualScrollPaddingAfter.value;
    if (prevScrollStart === scrollDetails.scrollStart) {
      return;
    }
    if (scrollDetails.scrollMaxSize <= 0) {
      setVirtualScrollSliceRange(scrollEl, scrollDetails, 0, 0);
      return;
    }
    localScrollViewSize !== scrollDetails.scrollViewSize && setVirtualScrollSize(scrollDetails.scrollViewSize);
    updateVirtualScrollSizes(virtualScrollSliceRange.value.from);
    const scrollMaxStart = Math.floor(scrollDetails.scrollMaxSize - Math.max(scrollDetails.scrollViewSize, scrollDetails.offsetEnd) - Math.min(virtualScrollSizes[listLastIndex], scrollDetails.scrollViewSize / 2));
    if (scrollMaxStart > 0 && Math.ceil(scrollDetails.scrollStart) >= scrollMaxStart) {
      setVirtualScrollSliceRange(
        scrollEl,
        scrollDetails,
        listLastIndex,
        scrollDetails.scrollMaxSize - scrollDetails.offsetEnd - virtualScrollSizesAgg.reduce(sumFn$1, 0)
      );
      return;
    }
    let toIndex = 0, listOffset = scrollDetails.scrollStart - scrollDetails.offsetStart, offset2 = listOffset;
    if (listOffset <= listEndOffset && listOffset + scrollDetails.scrollViewSize >= virtualScrollPaddingBefore.value) {
      listOffset -= virtualScrollPaddingBefore.value;
      toIndex = virtualScrollSliceRange.value.from;
      offset2 = listOffset;
    } else {
      for (let j = 0; listOffset >= virtualScrollSizesAgg[j] && toIndex < listLastIndex; j++) {
        listOffset -= virtualScrollSizesAgg[j];
        toIndex += aggBucketSize$1;
      }
    }
    while (listOffset > 0 && toIndex < listLastIndex) {
      listOffset -= virtualScrollSizes[toIndex];
      if (listOffset > -scrollDetails.scrollViewSize) {
        toIndex++;
        offset2 = listOffset;
      } else {
        offset2 = virtualScrollSizes[toIndex] + listOffset;
      }
    }
    setVirtualScrollSliceRange(
      scrollEl,
      scrollDetails,
      toIndex,
      offset2
    );
  }
  function setVirtualScrollSliceRange(scrollEl, scrollDetails, toIndex, offset2, align) {
    const alignForce = typeof align === "string" && align.indexOf("-force") !== -1;
    const alignEnd = alignForce === true ? align.replace("-force", "") : align;
    const alignRange = alignEnd !== void 0 ? alignEnd : "start";
    let from2 = Math.max(0, toIndex - virtualScrollSliceSizeComputed.value[alignRange]), to2 = from2 + virtualScrollSliceSizeComputed.value.total;
    if (to2 > virtualScrollLength.value) {
      to2 = virtualScrollLength.value;
      from2 = Math.max(0, to2 - virtualScrollSliceSizeComputed.value.total);
    }
    prevScrollStart = scrollDetails.scrollStart;
    const rangeChanged = from2 !== virtualScrollSliceRange.value.from || to2 !== virtualScrollSliceRange.value.to;
    if (rangeChanged === false && alignEnd === void 0) {
      emitScroll(toIndex);
      return;
    }
    const { activeElement } = document;
    const contentEl = contentRef.value;
    if (rangeChanged === true && contentEl !== null && contentEl !== activeElement && contentEl.contains(activeElement) === true) {
      contentEl.addEventListener("focusout", onBlurRefocusFn);
      setTimeout(() => {
        contentEl !== null && contentEl.removeEventListener("focusout", onBlurRefocusFn);
      });
    }
    setOverflowAnchor$1(contentEl, toIndex - from2);
    const sizeBefore = alignEnd !== void 0 ? virtualScrollSizes.slice(from2, toIndex).reduce(sumFn$1, 0) : 0;
    if (rangeChanged === true) {
      const tempTo = to2 >= virtualScrollSliceRange.value.from && from2 <= virtualScrollSliceRange.value.to ? virtualScrollSliceRange.value.to : to2;
      virtualScrollSliceRange.value = { from: from2, to: tempTo };
      virtualScrollPaddingBefore.value = sumSize$1(virtualScrollSizesAgg, virtualScrollSizes, 0, from2);
      virtualScrollPaddingAfter.value = sumSize$1(virtualScrollSizesAgg, virtualScrollSizes, to2, virtualScrollLength.value);
      requestAnimationFrame(() => {
        if (virtualScrollSliceRange.value.to !== to2 && prevScrollStart === scrollDetails.scrollStart) {
          virtualScrollSliceRange.value = { from: virtualScrollSliceRange.value.from, to: to2 };
          virtualScrollPaddingAfter.value = sumSize$1(virtualScrollSizesAgg, virtualScrollSizes, to2, virtualScrollLength.value);
        }
      });
    }
    requestAnimationFrame(() => {
      if (prevScrollStart !== scrollDetails.scrollStart) {
        return;
      }
      if (rangeChanged === true) {
        updateVirtualScrollSizes(from2);
      }
      const sizeAfter = virtualScrollSizes.slice(from2, toIndex).reduce(sumFn$1, 0), posStart = sizeAfter + scrollDetails.offsetStart + virtualScrollPaddingBefore.value, posEnd = posStart + virtualScrollSizes[toIndex];
      let scrollPosition = posStart + offset2;
      if (alignEnd !== void 0) {
        const sizeDiff = sizeAfter - sizeBefore;
        const scrollStart = scrollDetails.scrollStart + sizeDiff;
        scrollPosition = alignForce !== true && scrollStart < posStart && posEnd < scrollStart + scrollDetails.scrollViewSize ? scrollStart : alignEnd === "end" ? posEnd - scrollDetails.scrollViewSize : posStart - (alignEnd === "start" ? 0 : Math.round((scrollDetails.scrollViewSize - virtualScrollSizes[toIndex]) / 2));
      }
      prevScrollStart = scrollPosition;
      setScroll2$1(
        scrollEl,
        scrollPosition,
        props4.virtualScrollHorizontal,
        $q.lang.rtl
      );
      emitScroll(toIndex);
    });
  }
  function updateVirtualScrollSizes(from2) {
    const contentEl = contentRef.value;
    if (contentEl) {
      const children = filterProto$1.call(
        contentEl.children,
        (el) => el.classList && el.classList.contains("q-virtual-scroll--skip") === false
      ), childrenLength = children.length, sizeFn = props4.virtualScrollHorizontal === true ? (el) => el.getBoundingClientRect().width : (el) => el.offsetHeight;
      let index2 = from2, size2, diff2;
      for (let i22 = 0; i22 < childrenLength; ) {
        size2 = sizeFn(children[i22]);
        i22++;
        while (i22 < childrenLength && children[i22].classList.contains("q-virtual-scroll--with-prev") === true) {
          size2 += sizeFn(children[i22]);
          i22++;
        }
        diff2 = size2 - virtualScrollSizes[index2];
        if (diff2 !== 0) {
          virtualScrollSizes[index2] += diff2;
          virtualScrollSizesAgg[Math.floor(index2 / aggBucketSize$1)] += diff2;
        }
        index2++;
      }
    }
  }
  function onBlurRefocusFn() {
    contentRef.value !== null && contentRef.value !== void 0 && contentRef.value.focus();
  }
  function localResetVirtualScroll(toIndex, fullReset) {
    const defaultSize = 1 * virtualScrollItemSizeComputed.value;
    if (fullReset === true || Array.isArray(virtualScrollSizes) === false) {
      virtualScrollSizes = [];
    }
    const oldVirtualScrollSizesLength = virtualScrollSizes.length;
    virtualScrollSizes.length = virtualScrollLength.value;
    for (let i22 = virtualScrollLength.value - 1; i22 >= oldVirtualScrollSizesLength; i22--) {
      virtualScrollSizes[i22] = defaultSize;
    }
    const jMax = Math.floor((virtualScrollLength.value - 1) / aggBucketSize$1);
    virtualScrollSizesAgg = [];
    for (let j = 0; j <= jMax; j++) {
      let size2 = 0;
      const iMax = Math.min((j + 1) * aggBucketSize$1, virtualScrollLength.value);
      for (let i22 = j * aggBucketSize$1; i22 < iMax; i22++) {
        size2 += virtualScrollSizes[i22];
      }
      virtualScrollSizesAgg.push(size2);
    }
    prevToIndex = -1;
    prevScrollStart = void 0;
    virtualScrollPaddingBefore.value = sumSize$1(virtualScrollSizesAgg, virtualScrollSizes, 0, virtualScrollSliceRange.value.from);
    virtualScrollPaddingAfter.value = sumSize$1(virtualScrollSizesAgg, virtualScrollSizes, virtualScrollSliceRange.value.to, virtualScrollLength.value);
    if (toIndex >= 0) {
      updateVirtualScrollSizes(virtualScrollSliceRange.value.from);
      nextTick(() => {
        scrollTo(toIndex);
      });
    } else {
      onVirtualScrollEvt();
    }
  }
  function setVirtualScrollSize(scrollViewSize) {
    if (scrollViewSize === void 0 && typeof window !== "undefined") {
      const scrollEl = getVirtualScrollTarget();
      if (scrollEl !== void 0 && scrollEl !== null && scrollEl.nodeType !== 8) {
        scrollViewSize = getScrollDetails$1(
          scrollEl,
          getVirtualScrollEl(),
          beforeRef.value,
          afterRef.value,
          props4.virtualScrollHorizontal,
          $q.lang.rtl,
          props4.virtualScrollStickySizeStart,
          props4.virtualScrollStickySizeEnd
        ).scrollViewSize;
      }
    }
    localScrollViewSize = scrollViewSize;
    const virtualScrollSliceRatioBefore = parseFloat(props4.virtualScrollSliceRatioBefore) || 0;
    const virtualScrollSliceRatioAfter = parseFloat(props4.virtualScrollSliceRatioAfter) || 0;
    const multiplier = 1 + virtualScrollSliceRatioBefore + virtualScrollSliceRatioAfter;
    const view = scrollViewSize === void 0 || scrollViewSize <= 0 ? 1 : Math.ceil(scrollViewSize / virtualScrollItemSizeComputed.value);
    const baseSize = Math.max(
      1,
      view,
      Math.ceil((props4.virtualScrollSliceSize > 0 ? props4.virtualScrollSliceSize : 10) / multiplier)
    );
    virtualScrollSliceSizeComputed.value = {
      total: Math.ceil(baseSize * multiplier),
      start: Math.ceil(baseSize * virtualScrollSliceRatioBefore),
      center: Math.ceil(baseSize * (0.5 + virtualScrollSliceRatioBefore)),
      end: Math.ceil(baseSize * (1 + virtualScrollSliceRatioBefore)),
      view
    };
  }
  function padVirtualScroll(tag, content) {
    const paddingSize = props4.virtualScrollHorizontal === true ? "width" : "height";
    const style2 = {
      ["--q-virtual-scroll-item-" + paddingSize]: virtualScrollItemSizeComputed.value + "px"
    };
    return [
      tag === "tbody" ? h(tag, {
        class: "q-virtual-scroll__padding",
        key: "before",
        ref: beforeRef
      }, [
        h("tr", [
          h("td", {
            style: { [paddingSize]: `${virtualScrollPaddingBefore.value}px`, ...style2 },
            colspan: colspanAttr.value
          })
        ])
      ]) : h(tag, {
        class: "q-virtual-scroll__padding",
        key: "before",
        ref: beforeRef,
        style: { [paddingSize]: `${virtualScrollPaddingBefore.value}px`, ...style2 }
      }),
      h(tag, {
        class: "q-virtual-scroll__content",
        key: "content",
        ref: contentRef,
        tabindex: -1
      }, content.flat()),
      tag === "tbody" ? h(tag, {
        class: "q-virtual-scroll__padding",
        key: "after",
        ref: afterRef
      }, [
        h("tr", [
          h("td", {
            style: { [paddingSize]: `${virtualScrollPaddingAfter.value}px`, ...style2 },
            colspan: colspanAttr.value
          })
        ])
      ]) : h(tag, {
        class: "q-virtual-scroll__padding",
        key: "after",
        ref: afterRef,
        style: { [paddingSize]: `${virtualScrollPaddingAfter.value}px`, ...style2 }
      })
    ];
  }
  function emitScroll(index2) {
    if (prevToIndex !== index2) {
      props4.onVirtualScroll !== void 0 && emit("virtualScroll", {
        index: index2,
        from: virtualScrollSliceRange.value.from,
        to: virtualScrollSliceRange.value.to - 1,
        direction: index2 < prevToIndex ? "decrease" : "increase",
        ref: proxy
      });
      prevToIndex = index2;
    }
  }
  setVirtualScrollSize();
  const onVirtualScrollEvt = debounce_default$1(
    localOnVirtualScrollEvt,
    $q.platform.is.ios === true ? 120 : 35
  );
  onBeforeMount(() => {
    setVirtualScrollSize();
  });
  let shouldActivate = false;
  onDeactivated(() => {
    shouldActivate = true;
  });
  onActivated(() => {
    if (shouldActivate !== true) return;
    const scrollEl = getVirtualScrollTarget();
    if (prevScrollStart !== void 0 && scrollEl !== void 0 && scrollEl !== null && scrollEl.nodeType !== 8) {
      setScroll2$1(
        scrollEl,
        prevScrollStart,
        props4.virtualScrollHorizontal,
        $q.lang.rtl
      );
    } else {
      scrollTo(prevToIndex);
    }
  });
  __QUASAR_SSR__ || onBeforeUnmount(() => {
    onVirtualScrollEvt.cancel();
  });
  Object.assign(proxy, { scrollTo, reset, refresh });
  return {
    virtualScrollSliceRange,
    virtualScrollSliceSizeComputed,
    setVirtualScrollSize,
    onVirtualScrollEvt,
    localResetVirtualScroll,
    padVirtualScroll,
    scrollTo,
    reset,
    refresh
  };
}
var validateNewValueMode$1 = (v) => ["add", "add-unique", "toggle"].includes(v);
var reEscapeList$1 = ".*+?^${}()|[]\\";
var fieldPropsList$1 = Object.keys(useFieldProps$1);
function getPropValueFn2$1(userPropName, defaultPropName) {
  if (typeof userPropName === "function") return userPropName;
  const propName = userPropName !== void 0 ? userPropName : defaultPropName;
  return (opt) => opt !== null && typeof opt === "object" && propName in opt ? opt[propName] : opt;
}
var QSelect_default$1 = createComponent$1({
  name: "QSelect",
  inheritAttrs: false,
  props: {
    ...useVirtualScrollProps$1,
    ...useFormProps$1,
    ...useFieldProps$1,
    // override of useFieldProps > modelValue
    modelValue: {
      required: true
    },
    multiple: Boolean,
    displayValue: [String, Number],
    displayValueHtml: Boolean,
    dropdownIcon: String,
    options: {
      type: Array,
      default: () => []
    },
    optionValue: [Function, String],
    optionLabel: [Function, String],
    optionDisable: [Function, String],
    hideSelected: Boolean,
    hideDropdownIcon: Boolean,
    fillInput: Boolean,
    maxValues: [Number, String],
    optionsDense: Boolean,
    optionsDark: {
      type: Boolean,
      default: null
    },
    optionsSelectedClass: String,
    optionsHtml: Boolean,
    optionsCover: Boolean,
    menuShrink: Boolean,
    menuAnchor: String,
    menuSelf: String,
    menuOffset: Array,
    popupContentClass: String,
    popupContentStyle: [String, Array, Object],
    popupNoRouteDismiss: Boolean,
    useInput: Boolean,
    useChips: Boolean,
    newValueMode: {
      type: String,
      validator: validateNewValueMode$1
    },
    mapOptions: Boolean,
    emitValue: Boolean,
    disableTabSelection: Boolean,
    inputDebounce: {
      type: [Number, String],
      default: 500
    },
    inputClass: [Array, String, Object],
    inputStyle: [Array, String, Object],
    tabindex: {
      type: [String, Number],
      default: 0
    },
    autocomplete: String,
    transitionShow: {},
    transitionHide: {},
    transitionDuration: {},
    behavior: {
      type: String,
      validator: (v) => ["default", "menu", "dialog"].includes(v),
      default: "default"
    },
    // override of useVirtualScrollProps > virtualScrollItemSize (no default)
    virtualScrollItemSize: useVirtualScrollProps$1.virtualScrollItemSize.type,
    onNewValue: Function,
    onFilter: Function
  },
  emits: [
    ...useFieldEmits$1,
    "add",
    "remove",
    "inputValue",
    "keyup",
    "keypress",
    "keydown",
    "popupShow",
    "popupHide",
    "filterAbort"
  ],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const menu = ref$1(false);
    const dialog = ref$1(false);
    const optionIndex = ref$1(-1);
    const inputValue = ref$1("");
    const dialogFieldFocused = ref$1(false);
    const innerLoadingIndicator = ref$1(false);
    let filterTimer = null, inputValueTimer = null, innerValueCache, hasDialog, userInputValue, filterId = null, defaultInputValue, transitionShowComputed, searchBuffer, searchBufferExp;
    const inputRef = ref$1(null);
    const targetRef = ref$1(null);
    const menuRef = ref$1(null);
    const dialogRef = ref$1(null);
    const menuContentRef = ref$1(null);
    const nameProp = useFormInputNameAttr$1(props4);
    const onComposition = use_key_composition_default$1(onInput);
    const virtualScrollLength = computed(() => Array.isArray(props4.options) ? props4.options.length : 0);
    const virtualScrollItemSizeComputed = computed(() => props4.virtualScrollItemSize === void 0 ? props4.optionsDense === true ? 24 : 48 : props4.virtualScrollItemSize);
    const {
      virtualScrollSliceRange,
      virtualScrollSliceSizeComputed,
      localResetVirtualScroll,
      padVirtualScroll,
      onVirtualScrollEvt,
      scrollTo,
      setVirtualScrollSize
    } = useVirtualScroll$1({
      virtualScrollLength,
      getVirtualScrollTarget,
      getVirtualScrollEl,
      virtualScrollItemSizeComputed
    });
    const state2 = useFieldState$1();
    const innerValue = computed(() => {
      const mapNull = props4.mapOptions === true && props4.multiple !== true, val = props4.modelValue !== void 0 && (props4.modelValue !== null || mapNull === true) ? props4.multiple === true && Array.isArray(props4.modelValue) ? props4.modelValue : [props4.modelValue] : [];
      if (props4.mapOptions === true && Array.isArray(props4.options) === true) {
        const cache = props4.mapOptions === true && innerValueCache !== void 0 ? innerValueCache : [];
        const values = val.map((v) => getOption(v, cache));
        return props4.modelValue === null && mapNull === true ? values.filter((v) => v !== null) : values;
      }
      return val;
    });
    const innerFieldProps = computed(() => {
      const acc = {};
      fieldPropsList$1.forEach((key) => {
        const val = props4[key];
        if (val !== void 0) {
          acc[key] = val;
        }
      });
      return acc;
    });
    const isOptionsDark = computed(() => props4.optionsDark === null ? state2.isDark.value : props4.optionsDark);
    const hasValue = computed(() => fieldValueIsFilled$1(innerValue.value));
    const computedInputClass = computed(() => {
      let cls = "q-field__input q-placeholder col";
      if (props4.hideSelected === true || innerValue.value.length === 0) {
        return [cls, props4.inputClass];
      }
      cls += " q-field__input--padding";
      return props4.inputClass === void 0 ? cls : [cls, props4.inputClass];
    });
    const menuContentClass = computed(
      () => (props4.virtualScrollHorizontal === true ? "q-virtual-scroll--horizontal" : "") + (props4.popupContentClass ? " " + props4.popupContentClass : "")
    );
    const noOptions = computed(() => virtualScrollLength.value === 0);
    const selectedString = computed(
      () => innerValue.value.map((opt) => getOptionLabel.value(opt)).join(", ")
    );
    const ariaCurrentValue = computed(() => props4.displayValue !== void 0 ? props4.displayValue : selectedString.value);
    const needsHtmlFn = computed(() => props4.optionsHtml === true ? () => true : (opt) => opt !== void 0 && opt !== null && opt.html === true);
    const valueAsHtml = computed(() => props4.displayValueHtml === true || props4.displayValue === void 0 && (props4.optionsHtml === true || innerValue.value.some(needsHtmlFn.value)));
    const tabindex = computed(() => state2.focused.value === true ? props4.tabindex : -1);
    const comboboxAttrs = computed(() => {
      const attrs = {
        tabindex: props4.tabindex,
        role: "combobox",
        "aria-label": props4.label,
        "aria-readonly": props4.readonly === true ? "true" : "false",
        "aria-autocomplete": props4.useInput === true ? "list" : "none",
        "aria-expanded": menu.value === true ? "true" : "false",
        "aria-controls": `${state2.targetUid.value}_lb`
      };
      if (optionIndex.value >= 0) {
        attrs["aria-activedescendant"] = `${state2.targetUid.value}_${optionIndex.value}`;
      }
      return attrs;
    });
    const listboxAttrs = computed(() => ({
      id: `${state2.targetUid.value}_lb`,
      role: "listbox",
      "aria-multiselectable": props4.multiple === true ? "true" : "false"
    }));
    const selectedScope = computed(() => {
      return innerValue.value.map((opt, i22) => ({
        index: i22,
        opt,
        html: needsHtmlFn.value(opt),
        selected: true,
        removeAtIndex: removeAtIndexAndFocus,
        toggleOption,
        tabindex: tabindex.value
      }));
    });
    const optionScope = computed(() => {
      if (virtualScrollLength.value === 0) {
        return [];
      }
      const { from: from2, to: to2 } = virtualScrollSliceRange.value;
      return props4.options.slice(from2, to2).map((opt, i22) => {
        const disable = isOptionDisabled.value(opt) === true;
        const active = isOptionSelected(opt) === true;
        const index2 = from2 + i22;
        const itemProps = {
          clickable: true,
          active,
          activeClass: computedOptionsSelectedClass.value,
          manualFocus: true,
          focused: false,
          disable,
          tabindex: -1,
          dense: props4.optionsDense,
          dark: isOptionsDark.value,
          role: "option",
          "aria-selected": active === true ? "true" : "false",
          id: `${state2.targetUid.value}_${index2}`,
          onClick: () => {
            toggleOption(opt);
          }
        };
        if (disable !== true) {
          optionIndex.value === index2 && (itemProps.focused = true);
          if ($q.platform.is.desktop === true) {
            itemProps.onMousemove = () => {
              menu.value === true && setOptionIndex(index2);
            };
          }
        }
        return {
          index: index2,
          opt,
          html: needsHtmlFn.value(opt),
          label: getOptionLabel.value(opt),
          selected: itemProps.active,
          focused: itemProps.focused,
          toggleOption,
          setOptionIndex,
          itemProps
        };
      });
    });
    const dropdownArrowIcon = computed(() => props4.dropdownIcon !== void 0 ? props4.dropdownIcon : $q.iconSet.arrow.dropdown);
    const squaredMenu = computed(
      () => props4.optionsCover === false && props4.outlined !== true && props4.standout !== true && props4.borderless !== true && props4.rounded !== true
    );
    const computedOptionsSelectedClass = computed(() => props4.optionsSelectedClass !== void 0 ? props4.optionsSelectedClass : props4.color !== void 0 ? `text-${props4.color}` : "");
    const getOptionValue = computed(() => getPropValueFn2$1(props4.optionValue, "value"));
    const getOptionLabel = computed(() => getPropValueFn2$1(props4.optionLabel, "label"));
    const isOptionDisabled = computed(() => getPropValueFn2$1(props4.optionDisable, "disable"));
    const innerOptionsValue = computed(() => innerValue.value.map(getOptionValue.value));
    const inputControlEvents = computed(() => {
      const evt = {
        onInput,
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        onChange: onComposition,
        onKeydown: onTargetKeydown,
        onKeyup: onTargetAutocomplete,
        onKeypress: onTargetKeypress,
        onFocus: selectInputText,
        onClick(e22) {
          hasDialog === true && stop$1(e22);
        }
      };
      evt.onCompositionstart = evt.onCompositionupdate = evt.onCompositionend = onComposition;
      return evt;
    });
    watch(innerValue, (val) => {
      innerValueCache = val;
      if (props4.useInput === true && props4.fillInput === true && props4.multiple !== true && state2.innerLoading.value !== true && (dialog.value !== true && menu.value !== true || hasValue.value !== true)) {
        userInputValue !== true && resetInputValue();
        if (dialog.value === true || menu.value === true) {
          filter("");
        }
      }
    }, { immediate: true });
    watch(() => props4.fillInput, resetInputValue);
    watch(menu, updateMenu);
    watch(virtualScrollLength, rerenderMenu);
    function getEmittingOptionValue(opt) {
      return props4.emitValue === true ? getOptionValue.value(opt) : opt;
    }
    function removeAtIndex(index2) {
      if (index2 !== -1 && index2 < innerValue.value.length) {
        if (props4.multiple === true) {
          const model = props4.modelValue.slice();
          emit("remove", { index: index2, value: model.splice(index2, 1)[0] });
          emit("update:modelValue", model);
        } else {
          emit("update:modelValue", null);
        }
      }
    }
    function removeAtIndexAndFocus(index2) {
      removeAtIndex(index2);
      state2.focus();
    }
    function add2(opt, unique) {
      const val = getEmittingOptionValue(opt);
      if (props4.multiple !== true) {
        props4.fillInput === true && updateInputValue(
          getOptionLabel.value(opt),
          true,
          true
        );
        emit("update:modelValue", val);
        return;
      }
      if (innerValue.value.length === 0) {
        emit("add", { index: 0, value: val });
        emit("update:modelValue", props4.multiple === true ? [val] : val);
        return;
      }
      if (unique === true && isOptionSelected(opt) === true) {
        return;
      }
      if (props4.maxValues !== void 0 && props4.modelValue.length >= props4.maxValues) {
        return;
      }
      const model = props4.modelValue.slice();
      emit("add", { index: model.length, value: val });
      model.push(val);
      emit("update:modelValue", model);
    }
    function toggleOption(opt, keepOpen) {
      if (state2.editable.value !== true || opt === void 0 || isOptionDisabled.value(opt) === true) {
        return;
      }
      const optValue = getOptionValue.value(opt);
      if (props4.multiple !== true) {
        if (keepOpen !== true) {
          updateInputValue(
            props4.fillInput === true ? getOptionLabel.value(opt) : "",
            true,
            true
          );
          hidePopup();
        }
        targetRef.value !== null && targetRef.value.focus();
        if (innerValue.value.length === 0 || isDeepEqual$1(getOptionValue.value(innerValue.value[0]), optValue) !== true) {
          emit("update:modelValue", props4.emitValue === true ? optValue : opt);
        }
        return;
      }
      (hasDialog !== true || dialogFieldFocused.value === true) && state2.focus();
      selectInputText();
      if (innerValue.value.length === 0) {
        const val = props4.emitValue === true ? optValue : opt;
        emit("add", { index: 0, value: val });
        emit("update:modelValue", props4.multiple === true ? [val] : val);
        return;
      }
      const model = props4.modelValue.slice(), index2 = innerOptionsValue.value.findIndex((v) => isDeepEqual$1(v, optValue));
      if (index2 !== -1) {
        emit("remove", { index: index2, value: model.splice(index2, 1)[0] });
      } else {
        if (props4.maxValues !== void 0 && model.length >= props4.maxValues) {
          return;
        }
        const val = props4.emitValue === true ? optValue : opt;
        emit("add", { index: model.length, value: val });
        model.push(val);
      }
      emit("update:modelValue", model);
    }
    function setOptionIndex(index2) {
      if ($q.platform.is.desktop !== true) return;
      const val = index2 !== -1 && index2 < virtualScrollLength.value ? index2 : -1;
      if (optionIndex.value !== val) {
        optionIndex.value = val;
      }
    }
    function moveOptionSelection(offset2 = 1, skipInputValue) {
      if (menu.value === true) {
        let index2 = optionIndex.value;
        do {
          index2 = normalizeToInterval$1(
            index2 + offset2,
            -1,
            virtualScrollLength.value - 1
          );
        } while (index2 !== -1 && index2 !== optionIndex.value && isOptionDisabled.value(props4.options[index2]) === true);
        if (optionIndex.value !== index2) {
          setOptionIndex(index2);
          scrollTo(index2);
          if (skipInputValue !== true && props4.useInput === true && props4.fillInput === true) {
            setInputValue(
              index2 >= 0 ? getOptionLabel.value(props4.options[index2]) : defaultInputValue,
              true
            );
          }
        }
      }
    }
    function getOption(value2, valueCache) {
      const fn = (opt) => isDeepEqual$1(getOptionValue.value(opt), value2);
      return props4.options.find(fn) || valueCache.find(fn) || value2;
    }
    function isOptionSelected(opt) {
      const val = getOptionValue.value(opt);
      return innerOptionsValue.value.find((v) => isDeepEqual$1(v, val)) !== void 0;
    }
    function selectInputText(e22) {
      if (props4.useInput === true && targetRef.value !== null && (e22 === void 0 || targetRef.value === e22.target && e22.target.value === selectedString.value)) {
        targetRef.value.select();
      }
    }
    function onTargetKeyup(e22) {
      if (isKeyCode$1(e22, 27) === true && menu.value === true) {
        stop$1(e22);
        hidePopup();
        resetInputValue();
      }
      emit("keyup", e22);
    }
    function onTargetAutocomplete(e22) {
      const { value: value2 } = e22.target;
      if (e22.keyCode !== void 0) {
        onTargetKeyup(e22);
        return;
      }
      e22.target.value = "";
      if (filterTimer !== null) {
        clearTimeout(filterTimer);
        filterTimer = null;
      }
      if (inputValueTimer !== null) {
        clearTimeout(inputValueTimer);
        inputValueTimer = null;
      }
      resetInputValue();
      if (typeof value2 === "string" && value2.length !== 0) {
        const needle = value2.toLocaleLowerCase();
        const findFn = (extractFn) => {
          const option = props4.options.find((opt) => String(extractFn.value(opt)).toLocaleLowerCase() === needle);
          if (option === void 0) return false;
          if (innerValue.value.indexOf(option) === -1) {
            toggleOption(option);
          } else {
            hidePopup();
          }
          return true;
        };
        const fillFn = (afterFilter) => {
          if (findFn(getOptionValue) !== true && afterFilter !== true && findFn(getOptionLabel) !== true) {
            filter(value2, true, () => fillFn(true));
          }
        };
        fillFn();
      } else {
        state2.clearValue(e22);
      }
    }
    function onTargetKeypress(e22) {
      emit("keypress", e22);
    }
    function onTargetKeydown(e22) {
      emit("keydown", e22);
      if (shouldIgnoreKey$1(e22) === true) {
        return;
      }
      const newValueModeValid = inputValue.value.length !== 0 && (props4.newValueMode !== void 0 || props4.onNewValue !== void 0);
      const tabShouldSelect = e22.shiftKey !== true && props4.disableTabSelection !== true && props4.multiple !== true && (optionIndex.value !== -1 || newValueModeValid === true);
      if (e22.keyCode === 27) {
        prevent$1(e22);
        return;
      }
      if (e22.keyCode === 9 && tabShouldSelect === false) {
        closeMenu();
        return;
      }
      if (e22.target === void 0 || e22.target.id !== state2.targetUid.value || state2.editable.value !== true) return;
      if (e22.keyCode === 40 && state2.innerLoading.value !== true && menu.value === false) {
        stopAndPrevent$1(e22);
        showPopup();
        return;
      }
      if (e22.keyCode === 8 && (props4.useChips === true || props4.clearable === true) && props4.hideSelected !== true && inputValue.value.length === 0) {
        if (props4.multiple === true && Array.isArray(props4.modelValue) === true) {
          removeAtIndex(props4.modelValue.length - 1);
        } else if (props4.multiple !== true && props4.modelValue !== null) {
          emit("update:modelValue", null);
        }
        return;
      }
      if ((e22.keyCode === 35 || e22.keyCode === 36) && (typeof inputValue.value !== "string" || inputValue.value.length === 0)) {
        stopAndPrevent$1(e22);
        optionIndex.value = -1;
        moveOptionSelection(e22.keyCode === 36 ? 1 : -1, props4.multiple);
      }
      if ((e22.keyCode === 33 || e22.keyCode === 34) && virtualScrollSliceSizeComputed.value !== void 0) {
        stopAndPrevent$1(e22);
        optionIndex.value = Math.max(
          -1,
          Math.min(
            virtualScrollLength.value,
            optionIndex.value + (e22.keyCode === 33 ? -1 : 1) * virtualScrollSliceSizeComputed.value.view
          )
        );
        moveOptionSelection(e22.keyCode === 33 ? 1 : -1, props4.multiple);
      }
      if (e22.keyCode === 38 || e22.keyCode === 40) {
        stopAndPrevent$1(e22);
        moveOptionSelection(e22.keyCode === 38 ? -1 : 1, props4.multiple);
      }
      const optionsLength = virtualScrollLength.value;
      if (searchBuffer === void 0 || searchBufferExp < Date.now()) {
        searchBuffer = "";
      }
      if (optionsLength > 0 && props4.useInput !== true && e22.key !== void 0 && e22.key.length === 1 && e22.altKey === false && e22.ctrlKey === false && e22.metaKey === false && (e22.keyCode !== 32 || searchBuffer.length !== 0)) {
        menu.value !== true && showPopup(e22);
        const char = e22.key.toLocaleLowerCase(), keyRepeat = searchBuffer.length === 1 && searchBuffer[0] === char;
        searchBufferExp = Date.now() + 1500;
        if (keyRepeat === false) {
          stopAndPrevent$1(e22);
          searchBuffer += char;
        }
        const searchRe = new RegExp("^" + searchBuffer.split("").map((l) => reEscapeList$1.indexOf(l) !== -1 ? "\\" + l : l).join(".*"), "i");
        let index2 = optionIndex.value;
        if (keyRepeat === true || index2 < 0 || searchRe.test(getOptionLabel.value(props4.options[index2])) !== true) {
          do {
            index2 = normalizeToInterval$1(index2 + 1, -1, optionsLength - 1);
          } while (index2 !== optionIndex.value && (isOptionDisabled.value(props4.options[index2]) === true || searchRe.test(getOptionLabel.value(props4.options[index2])) !== true));
        }
        if (optionIndex.value !== index2) {
          nextTick(() => {
            setOptionIndex(index2);
            scrollTo(index2);
            if (index2 >= 0 && props4.useInput === true && props4.fillInput === true) {
              setInputValue(getOptionLabel.value(props4.options[index2]), true);
            }
          });
        }
        return;
      }
      if (e22.keyCode !== 13 && (e22.keyCode !== 32 || props4.useInput === true || searchBuffer !== "") && (e22.keyCode !== 9 || tabShouldSelect === false)) return;
      e22.keyCode !== 9 && stopAndPrevent$1(e22);
      if (optionIndex.value !== -1 && optionIndex.value < optionsLength) {
        toggleOption(props4.options[optionIndex.value]);
        return;
      }
      if (newValueModeValid === true) {
        const done = (val, mode) => {
          if (mode) {
            if (validateNewValueMode$1(mode) !== true) {
              return;
            }
          } else {
            mode = props4.newValueMode;
          }
          updateInputValue("", props4.multiple !== true, true);
          if (val === void 0 || val === null) {
            return;
          }
          const fn = mode === "toggle" ? toggleOption : add2;
          fn(val, mode === "add-unique");
          if (props4.multiple !== true) {
            targetRef.value !== null && targetRef.value.focus();
            hidePopup();
          }
        };
        if (props4.onNewValue !== void 0) {
          emit("newValue", inputValue.value, done);
        } else {
          done(inputValue.value);
        }
        if (props4.multiple !== true) {
          return;
        }
      }
      if (menu.value === true) {
        closeMenu();
      } else if (state2.innerLoading.value !== true) {
        showPopup();
      }
    }
    function getVirtualScrollEl() {
      return hasDialog === true ? menuContentRef.value : menuRef.value !== null && menuRef.value.contentEl !== null ? menuRef.value.contentEl : void 0;
    }
    function getVirtualScrollTarget() {
      return getVirtualScrollEl();
    }
    function getSelection2() {
      if (props4.hideSelected === true) {
        return [];
      }
      if (slots["selected-item"] !== void 0) {
        return selectedScope.value.map((scope) => slots["selected-item"](scope)).slice();
      }
      if (slots.selected !== void 0) {
        return [].concat(slots.selected());
      }
      if (props4.useChips === true) {
        return selectedScope.value.map((scope, i22) => h(QChip_default$1, {
          key: "option-" + i22,
          removable: state2.editable.value === true && isOptionDisabled.value(scope.opt) !== true,
          dense: true,
          textColor: props4.color,
          tabindex: tabindex.value,
          onRemove() {
            scope.removeAtIndex(i22);
          }
        }, () => h("span", {
          class: "ellipsis",
          [scope.html === true ? "innerHTML" : "textContent"]: getOptionLabel.value(scope.opt)
        })));
      }
      return [
        h("span", {
          [valueAsHtml.value === true ? "innerHTML" : "textContent"]: ariaCurrentValue.value
        })
      ];
    }
    function getAllOptions() {
      if (noOptions.value === true) {
        return slots["no-option"] !== void 0 ? slots["no-option"]({ inputValue: inputValue.value }) : void 0;
      }
      const fn = slots.option !== void 0 ? slots.option : (scope) => {
        return h(QItem_default$1, {
          key: scope.index,
          ...scope.itemProps
        }, () => {
          return h(
            QItemSection_default$1,
            () => h(
              QItemLabel_default$1,
              () => h("span", {
                [scope.html === true ? "innerHTML" : "textContent"]: scope.label
              })
            )
          );
        });
      };
      let options = padVirtualScroll("div", optionScope.value.map(fn));
      if (slots["before-options"] !== void 0) {
        options = slots["before-options"]().concat(options);
      }
      return hMergeSlot$1(slots["after-options"], options);
    }
    function getInput(fromDialog, isTarget) {
      const attrs = isTarget === true ? { ...comboboxAttrs.value, ...state2.splitAttrs.attributes.value } : void 0;
      const data = {
        ref: isTarget === true ? targetRef : void 0,
        key: "i_t",
        class: computedInputClass.value,
        style: props4.inputStyle,
        value: inputValue.value !== void 0 ? inputValue.value : "",
        // required for Android in order to show ENTER key when in form
        type: "search",
        ...attrs,
        id: isTarget === true ? state2.targetUid.value : void 0,
        maxlength: props4.maxlength,
        autocomplete: props4.autocomplete,
        "data-autofocus": fromDialog === true || props4.autofocus === true || void 0,
        disabled: props4.disable === true,
        readonly: props4.readonly === true,
        ...inputControlEvents.value
      };
      if (fromDialog !== true && hasDialog === true) {
        if (Array.isArray(data.class) === true) {
          data.class = [...data.class, "no-pointer-events"];
        } else {
          data.class += " no-pointer-events";
        }
      }
      return h("input", data);
    }
    function onInput(e22) {
      if (filterTimer !== null) {
        clearTimeout(filterTimer);
        filterTimer = null;
      }
      if (inputValueTimer !== null) {
        clearTimeout(inputValueTimer);
        inputValueTimer = null;
      }
      if (e22 && e22.target && e22.target.qComposing === true) {
        return;
      }
      setInputValue(e22.target.value || "");
      userInputValue = true;
      defaultInputValue = inputValue.value;
      if (state2.focused.value !== true && (hasDialog !== true || dialogFieldFocused.value === true)) {
        state2.focus();
      }
      if (props4.onFilter !== void 0) {
        filterTimer = setTimeout(() => {
          filterTimer = null;
          filter(inputValue.value);
        }, props4.inputDebounce);
      }
    }
    function setInputValue(val, emitImmediately) {
      if (inputValue.value !== val) {
        inputValue.value = val;
        if (emitImmediately === true || props4.inputDebounce === 0 || props4.inputDebounce === "0") {
          emit("inputValue", val);
        } else {
          inputValueTimer = setTimeout(() => {
            inputValueTimer = null;
            emit("inputValue", val);
          }, props4.inputDebounce);
        }
      }
    }
    function updateInputValue(val, noFiltering, internal) {
      userInputValue = internal !== true;
      if (props4.useInput === true) {
        setInputValue(val, true);
        if (noFiltering === true || internal !== true) {
          defaultInputValue = val;
        }
        noFiltering !== true && filter(val);
      }
    }
    function filter(val, keepClosed, afterUpdateFn) {
      if (props4.onFilter === void 0 || keepClosed !== true && state2.focused.value !== true) {
        return;
      }
      if (state2.innerLoading.value === true) {
        emit("filterAbort");
      } else {
        state2.innerLoading.value = true;
        innerLoadingIndicator.value = true;
      }
      if (val !== "" && props4.multiple !== true && innerValue.value.length !== 0 && userInputValue !== true && val === getOptionLabel.value(innerValue.value[0])) {
        val = "";
      }
      const localFilterId = setTimeout(() => {
        menu.value === true && (menu.value = false);
      }, 10);
      filterId !== null && clearTimeout(filterId);
      filterId = localFilterId;
      emit(
        "filter",
        val,
        (fn, afterFn) => {
          if ((keepClosed === true || state2.focused.value === true) && filterId === localFilterId) {
            clearTimeout(filterId);
            typeof fn === "function" && fn();
            innerLoadingIndicator.value = false;
            nextTick(() => {
              state2.innerLoading.value = false;
              if (state2.editable.value === true) {
                if (keepClosed === true) {
                  menu.value === true && hidePopup();
                } else if (menu.value === true) {
                  updateMenu(true);
                } else {
                  menu.value = true;
                }
              }
              typeof afterFn === "function" && nextTick(() => {
                afterFn(proxy);
              });
              typeof afterUpdateFn === "function" && nextTick(() => {
                afterUpdateFn(proxy);
              });
            });
          }
        },
        () => {
          if (state2.focused.value === true && filterId === localFilterId) {
            clearTimeout(filterId);
            state2.innerLoading.value = false;
            innerLoadingIndicator.value = false;
          }
          menu.value === true && (menu.value = false);
        }
      );
    }
    function getMenu() {
      return h(QMenu_default$1, {
        ref: menuRef,
        class: menuContentClass.value,
        style: props4.popupContentStyle,
        modelValue: menu.value,
        fit: props4.menuShrink !== true,
        cover: props4.optionsCover === true && noOptions.value !== true && props4.useInput !== true,
        anchor: props4.menuAnchor,
        self: props4.menuSelf,
        offset: props4.menuOffset,
        dark: isOptionsDark.value,
        noParentEvent: true,
        noRefocus: true,
        noFocus: true,
        noRouteDismiss: props4.popupNoRouteDismiss,
        square: squaredMenu.value,
        transitionShow: props4.transitionShow,
        transitionHide: props4.transitionHide,
        transitionDuration: props4.transitionDuration,
        separateClosePopup: true,
        ...listboxAttrs.value,
        onScrollPassive: onVirtualScrollEvt,
        onBeforeShow: onControlPopupShow,
        onBeforeHide: onMenuBeforeHide,
        onShow: onMenuShow
      }, getAllOptions);
    }
    function onMenuBeforeHide(e22) {
      onControlPopupHide(e22);
      closeMenu();
    }
    function onMenuShow() {
      setVirtualScrollSize();
    }
    function onDialogFieldFocus(e22) {
      stop$1(e22);
      targetRef.value !== null && targetRef.value.focus();
      dialogFieldFocused.value = true;
      window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, 0);
    }
    function onDialogFieldBlur(e22) {
      stop$1(e22);
      nextTick(() => {
        dialogFieldFocused.value = false;
      });
    }
    function getDialog() {
      const content = [
        h(QField_default$1, {
          class: `col-auto ${state2.fieldClass.value}`,
          ...innerFieldProps.value,
          for: state2.targetUid.value,
          dark: isOptionsDark.value,
          square: true,
          loading: innerLoadingIndicator.value,
          itemAligned: false,
          filled: true,
          stackLabel: inputValue.value.length !== 0,
          ...state2.splitAttrs.listeners.value,
          onFocus: onDialogFieldFocus,
          onBlur: onDialogFieldBlur
        }, {
          ...slots,
          rawControl: () => state2.getControl(true),
          before: void 0,
          after: void 0
        })
      ];
      menu.value === true && content.push(
        h("div", {
          ref: menuContentRef,
          class: menuContentClass.value + " scroll",
          style: props4.popupContentStyle,
          ...listboxAttrs.value,
          onClick: prevent$1,
          onScrollPassive: onVirtualScrollEvt
        }, getAllOptions())
      );
      return h(QDialog_default$1, {
        ref: dialogRef,
        modelValue: dialog.value,
        position: props4.useInput === true ? "top" : void 0,
        transitionShow: transitionShowComputed,
        transitionHide: props4.transitionHide,
        transitionDuration: props4.transitionDuration,
        noRouteDismiss: props4.popupNoRouteDismiss,
        onBeforeShow: onControlPopupShow,
        onBeforeHide: onDialogBeforeHide,
        onHide: onDialogHide,
        onShow: onDialogShow
      }, () => h("div", {
        class: "q-select__dialog" + (isOptionsDark.value === true ? " q-select__dialog--dark q-dark" : "") + (dialogFieldFocused.value === true ? " q-select__dialog--focused" : "")
      }, content));
    }
    function onDialogBeforeHide(e22) {
      onControlPopupHide(e22);
      if (dialogRef.value !== null) {
        dialogRef.value.__updateRefocusTarget(
          state2.rootRef.value.querySelector(".q-field__native > [tabindex]:last-child")
        );
      }
      state2.focused.value = false;
    }
    function onDialogHide(e22) {
      hidePopup();
      state2.focused.value === false && emit("blur", e22);
      resetInputValue();
    }
    function onDialogShow() {
      const el = document.activeElement;
      if ((el === null || el.id !== state2.targetUid.value) && targetRef.value !== null && targetRef.value !== el) {
        targetRef.value.focus();
      }
      setVirtualScrollSize();
    }
    function closeMenu() {
      if (dialog.value === true) {
        return;
      }
      optionIndex.value = -1;
      if (menu.value === true) {
        menu.value = false;
      }
      if (state2.focused.value === false) {
        if (filterId !== null) {
          clearTimeout(filterId);
          filterId = null;
        }
        if (state2.innerLoading.value === true) {
          emit("filterAbort");
          state2.innerLoading.value = false;
          innerLoadingIndicator.value = false;
        }
      }
    }
    function showPopup(e22) {
      if (state2.editable.value !== true) {
        return;
      }
      if (hasDialog === true) {
        state2.onControlFocusin(e22);
        dialog.value = true;
        nextTick(() => {
          state2.focus();
        });
      } else {
        state2.focus();
      }
      if (props4.onFilter !== void 0) {
        filter(inputValue.value);
      } else if (noOptions.value !== true || slots["no-option"] !== void 0) {
        menu.value = true;
      }
    }
    function hidePopup() {
      dialog.value = false;
      closeMenu();
    }
    function resetInputValue() {
      props4.useInput === true && updateInputValue(
        props4.multiple !== true && props4.fillInput === true && innerValue.value.length !== 0 ? getOptionLabel.value(innerValue.value[0]) || "" : "",
        true,
        true
      );
    }
    function updateMenu(show) {
      let optionIndex2 = -1;
      if (show === true) {
        if (innerValue.value.length !== 0) {
          const val = getOptionValue.value(innerValue.value[0]);
          optionIndex2 = props4.options.findIndex((v) => isDeepEqual$1(getOptionValue.value(v), val));
        }
        localResetVirtualScroll(optionIndex2);
      }
      setOptionIndex(optionIndex2);
    }
    function rerenderMenu(newLength, oldLength) {
      if (menu.value === true && state2.innerLoading.value === false) {
        localResetVirtualScroll(-1, true);
        nextTick(() => {
          if (menu.value === true && state2.innerLoading.value === false) {
            if (newLength > oldLength) {
              localResetVirtualScroll();
            } else {
              updateMenu(true);
            }
          }
        });
      }
    }
    function updateMenuPosition() {
      if (dialog.value === false && menuRef.value !== null) {
        menuRef.value.updatePosition();
      }
    }
    function onControlPopupShow(e22) {
      e22 !== void 0 && stop$1(e22);
      emit("popupShow", e22);
      state2.hasPopupOpen = true;
      state2.onControlFocusin(e22);
    }
    function onControlPopupHide(e22) {
      e22 !== void 0 && stop$1(e22);
      emit("popupHide", e22);
      state2.hasPopupOpen = false;
      state2.onControlFocusout(e22);
    }
    function updatePreState() {
      hasDialog = $q.platform.is.mobile !== true && props4.behavior !== "dialog" ? false : props4.behavior !== "menu" && (props4.useInput === true ? slots["no-option"] !== void 0 || props4.onFilter !== void 0 || noOptions.value === false : true);
      transitionShowComputed = $q.platform.is.ios === true && hasDialog === true && props4.useInput === true ? "fade" : props4.transitionShow;
    }
    onBeforeUpdate(updatePreState);
    onUpdated(updateMenuPosition);
    updatePreState();
    onBeforeUnmount(() => {
      filterTimer !== null && clearTimeout(filterTimer);
      inputValueTimer !== null && clearTimeout(inputValueTimer);
    });
    Object.assign(proxy, {
      showPopup,
      hidePopup,
      removeAtIndex,
      add: add2,
      toggleOption,
      getOptionIndex: () => optionIndex.value,
      setOptionIndex,
      moveOptionSelection,
      filter,
      updateMenuPosition,
      updateInputValue,
      isOptionSelected,
      getEmittingOptionValue,
      isOptionDisabled: (...args) => isOptionDisabled.value.apply(null, args) === true,
      getOptionValue: (...args) => getOptionValue.value.apply(null, args),
      getOptionLabel: (...args) => getOptionLabel.value.apply(null, args)
    });
    Object.assign(state2, {
      innerValue,
      fieldClass: computed(
        () => `q-select q-field--auto-height q-select--with${props4.useInput !== true ? "out" : ""}-input q-select--with${props4.useChips !== true ? "out" : ""}-chips q-select--${props4.multiple === true ? "multiple" : "single"}`
      ),
      inputRef,
      targetRef,
      hasValue,
      showPopup,
      floatingLabel: computed(
        () => props4.hideSelected !== true && hasValue.value === true || typeof inputValue.value === "number" || inputValue.value.length !== 0 || fieldValueIsFilled$1(props4.displayValue)
      ),
      getControlChild: () => {
        if (state2.editable.value !== false && (dialog.value === true || noOptions.value !== true || slots["no-option"] !== void 0)) {
          return hasDialog === true ? getDialog() : getMenu();
        } else if (state2.hasPopupOpen === true) {
          state2.hasPopupOpen = false;
        }
      },
      controlEvents: {
        onFocusin(e22) {
          state2.onControlFocusin(e22);
        },
        onFocusout(e22) {
          state2.onControlFocusout(e22, () => {
            resetInputValue();
            closeMenu();
          });
        },
        onClick(e22) {
          prevent$1(e22);
          if (hasDialog !== true && menu.value === true) {
            closeMenu();
            targetRef.value !== null && targetRef.value.focus();
            return;
          }
          showPopup(e22);
        }
      },
      getControl: (fromDialog) => {
        const child = getSelection2();
        const isTarget = fromDialog === true || dialog.value !== true || hasDialog !== true;
        if (props4.useInput === true) {
          child.push(getInput(fromDialog, isTarget));
        } else if (state2.editable.value === true) {
          const attrs2 = isTarget === true ? comboboxAttrs.value : void 0;
          child.push(
            h("input", {
              ref: isTarget === true ? targetRef : void 0,
              key: "d_t",
              class: "q-select__focus-target",
              id: isTarget === true ? state2.targetUid.value : void 0,
              value: ariaCurrentValue.value,
              readonly: true,
              "data-autofocus": fromDialog === true || props4.autofocus === true || void 0,
              ...attrs2,
              onKeydown: onTargetKeydown,
              onKeyup: onTargetKeyup,
              onKeypress: onTargetKeypress
            })
          );
          if (isTarget === true && typeof props4.autocomplete === "string" && props4.autocomplete.length !== 0) {
            child.push(
              h("input", {
                class: "q-select__autocomplete-input",
                autocomplete: props4.autocomplete,
                tabindex: -1,
                onKeyup: onTargetAutocomplete
              })
            );
          }
        }
        if (nameProp.value !== void 0 && props4.disable !== true && innerOptionsValue.value.length !== 0) {
          const opts = innerOptionsValue.value.map((value2) => h("option", { value: value2, selected: true }));
          child.push(
            h("select", {
              class: "hidden",
              name: nameProp.value,
              multiple: props4.multiple
            }, opts)
          );
        }
        const attrs = props4.useInput === true || isTarget !== true ? void 0 : state2.splitAttrs.attributes.value;
        return h("div", {
          class: "q-field__native row items-center",
          ...attrs,
          ...state2.splitAttrs.listeners.value
        }, child);
      },
      getInnerAppend: () => props4.loading !== true && innerLoadingIndicator.value !== true && props4.hideDropdownIcon !== true ? [
        h(QIcon_default$1, {
          class: "q-select__dropdown-icon" + (menu.value === true ? " rotate-180" : ""),
          name: dropdownArrowIcon.value
        })
      ] : null
    });
    return use_field_default$1(state2);
  }
});
var skeletonTypes$1 = [
  "text",
  "rect",
  "circle",
  "QBtn",
  "QBadge",
  "QChip",
  "QToolbar",
  "QCheckbox",
  "QRadio",
  "QToggle",
  "QSlider",
  "QRange",
  "QInput",
  "QAvatar"
];
var skeletonAnimations$1 = [
  "wave",
  "pulse",
  "pulse-x",
  "pulse-y",
  "fade",
  "blink",
  "none"
];
var QSkeleton_default = createComponent$1({
  name: "QSkeleton",
  props: {
    ...useDarkProps$1,
    tag: {
      type: String,
      default: "div"
    },
    type: {
      type: String,
      validator: (v) => skeletonTypes$1.includes(v),
      default: "rect"
    },
    animation: {
      type: String,
      validator: (v) => skeletonAnimations$1.includes(v),
      default: "wave"
    },
    animationSpeed: {
      type: [String, Number],
      default: 1500
    },
    square: Boolean,
    bordered: Boolean,
    size: String,
    width: String,
    height: String
  },
  setup(props4, { slots }) {
    const vm2 = getCurrentInstance();
    const isDark = use_dark_default$1(props4, vm2.proxy.$q);
    const style2 = computed(() => {
      const size2 = props4.size !== void 0 ? [props4.size, props4.size] : [props4.width, props4.height];
      return {
        "--q-skeleton-speed": `${props4.animationSpeed}ms`,
        width: size2[0],
        height: size2[1]
      };
    });
    const classes = computed(
      () => `q-skeleton q-skeleton--${isDark.value === true ? "dark" : "light"} q-skeleton--type-${props4.type}` + (props4.animation !== "none" ? ` q-skeleton--anim q-skeleton--anim-${props4.animation}` : "") + (props4.square === true ? " q-skeleton--square" : "") + (props4.bordered === true ? " q-skeleton--bordered" : "")
    );
    return () => h(props4.tag, {
      class: classes.value,
      style: style2.value
    }, hSlot$1(slots.default));
  }
});
var slotsDef$1 = [
  ["left", "center", "start", "width"],
  ["right", "center", "end", "width"],
  ["top", "start", "center", "height"],
  ["bottom", "end", "center", "height"]
];
createComponent$1({
  name: "QSlideItem",
  props: {
    ...useDarkProps$1,
    leftColor: String,
    rightColor: String,
    topColor: String,
    bottomColor: String,
    onSlide: Function
  },
  emits: ["action", "top", "right", "bottom", "left"],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const isDark = use_dark_default$1(props4, $q);
    const { getCache } = use_render_cache_default$1();
    const contentRef = ref$1(null);
    let timer2 = null, pan = {}, dirRefs = {}, dirContentRefs = {};
    const langDir = computed(() => $q.lang.rtl === true ? { left: "right", right: "left" } : { left: "left", right: "right" });
    const classes = computed(
      () => "q-slide-item q-item-type overflow-hidden" + (isDark.value === true ? " q-slide-item--dark q-dark" : "")
    );
    function reset() {
      contentRef.value.style.transform = "translate(0,0)";
    }
    function emitSlide(side, ratio, isReset) {
      props4.onSlide !== void 0 && emit("slide", { side, ratio, isReset });
    }
    function onPan(evt) {
      const node = contentRef.value;
      if (evt.isFirst) {
        pan = {
          dir: null,
          size: { left: 0, right: 0, top: 0, bottom: 0 },
          scale: 0
        };
        node.classList.add("no-transition");
        slotsDef$1.forEach((slotName) => {
          if (slots[slotName[0]] !== void 0) {
            const node2 = dirContentRefs[slotName[0]];
            node2.style.transform = "scale(1)";
            pan.size[slotName[0]] = node2.getBoundingClientRect()[slotName[3]];
          }
        });
        pan.axis = evt.direction === "up" || evt.direction === "down" ? "Y" : "X";
      } else if (evt.isFinal) {
        node.classList.remove("no-transition");
        if (pan.scale === 1) {
          node.style.transform = `translate${pan.axis}(${pan.dir * 100}%)`;
          timer2 !== null && clearTimeout(timer2);
          timer2 = setTimeout(() => {
            timer2 = null;
            emit(pan.showing, { reset });
            emit("action", { side: pan.showing, reset });
          }, 230);
        } else {
          node.style.transform = "translate(0,0)";
          emitSlide(pan.showing, 0, true);
        }
        return;
      } else {
        evt.direction = pan.axis === "X" ? evt.offset.x < 0 ? "left" : "right" : evt.offset.y < 0 ? "up" : "down";
      }
      if (slots.left === void 0 && evt.direction === langDir.value.right || slots.right === void 0 && evt.direction === langDir.value.left || slots.top === void 0 && evt.direction === "down" || slots.bottom === void 0 && evt.direction === "up") {
        node.style.transform = "translate(0,0)";
        return;
      }
      let showing, dir, dist2;
      if (pan.axis === "X") {
        dir = evt.direction === "left" ? -1 : 1;
        showing = dir === 1 ? langDir.value.left : langDir.value.right;
        dist2 = evt.distance.x;
      } else {
        dir = evt.direction === "up" ? -2 : 2;
        showing = dir === 2 ? "top" : "bottom";
        dist2 = evt.distance.y;
      }
      if (pan.dir !== null && Math.abs(dir) !== Math.abs(pan.dir)) {
        return;
      }
      if (pan.dir !== dir) {
        ["left", "right", "top", "bottom"].forEach((d32) => {
          if (dirRefs[d32]) {
            dirRefs[d32].style.visibility = showing === d32 ? "visible" : "hidden";
          }
        });
        pan.showing = showing;
        pan.dir = dir;
      }
      pan.scale = Math.max(0, Math.min(1, (dist2 - 40) / pan.size[showing]));
      node.style.transform = `translate${pan.axis}(${dist2 * dir / Math.abs(dir)}px)`;
      dirContentRefs[showing].style.transform = `scale(${pan.scale})`;
      emitSlide(showing, pan.scale, false);
    }
    onBeforeUpdate(() => {
      dirRefs = {};
      dirContentRefs = {};
    });
    onBeforeUnmount(() => {
      timer2 !== null && clearTimeout(timer2);
    });
    Object.assign(proxy, { reset });
    return () => {
      const content = [], slotsList = {
        left: slots[langDir.value.right] !== void 0,
        right: slots[langDir.value.left] !== void 0,
        up: slots.bottom !== void 0,
        down: slots.top !== void 0
      }, dirs = Object.keys(slotsList).filter((key) => slotsList[key] === true);
      slotsDef$1.forEach((slotName) => {
        const dir = slotName[0];
        if (slots[dir] !== void 0) {
          content.push(
            h("div", {
              key: dir,
              ref: (el) => {
                dirRefs[dir] = el;
              },
              class: `q-slide-item__${dir} absolute-full row no-wrap items-${slotName[1]} justify-${slotName[2]}` + (props4[dir + "Color"] !== void 0 ? ` bg-${props4[dir + "Color"]}` : "")
            }, [
              h("div", { ref: (el) => {
                dirContentRefs[dir] = el;
              } }, slots[dir]())
            ])
          );
        }
      });
      const node = h("div", {
        key: `${dirs.length === 0 ? "only-" : ""} content`,
        ref: contentRef,
        class: "q-slide-item__content"
      }, hSlot$1(slots.default));
      if (dirs.length === 0) {
        content.push(node);
      } else {
        content.push(
          withDirectives(node, getCache("dir#" + dirs.join(""), () => {
            const modifiers = {
              prevent: true,
              stop: true,
              mouse: true
            };
            dirs.forEach((dir) => {
              modifiers[dir] = true;
            });
            return [[
              TouchPan_default$1,
              onPan,
              void 0,
              modifiers
            ]];
          }))
        );
      }
      return h("div", { class: classes.value }, content);
    };
  }
});
var QSpace_default = createComponent$1({
  name: "QSpace",
  setup() {
    const space = h("div", { class: "q-space" });
    return () => space;
  }
});
var innerHTML$1 = '<g transform="matrix(1 0 0 -1 0 80)"><rect width="10" height="20" rx="3"><animate attributeName="height" begin="0s" dur="4.3s" values="20;45;57;80;64;32;66;45;64;23;66;13;64;56;34;34;2;23;76;79;20" calcMode="linear" repeatCount="indefinite"></animate></rect><rect x="15" width="10" height="80" rx="3"><animate attributeName="height" begin="0s" dur="2s" values="80;55;33;5;75;23;73;33;12;14;60;80" calcMode="linear" repeatCount="indefinite"></animate></rect><rect x="30" width="10" height="50" rx="3"><animate attributeName="height" begin="0s" dur="1.4s" values="50;34;78;23;56;23;34;76;80;54;21;50" calcMode="linear" repeatCount="indefinite"></animate></rect><rect x="45" width="10" height="30" rx="3"><animate attributeName="height" begin="0s" dur="2s" values="30;45;13;80;56;72;45;76;34;23;67;30" calcMode="linear" repeatCount="indefinite"></animate></rect></g>';
createComponent$1({
  name: "QSpinnerAudio",
  props: useSpinnerProps$1,
  setup(props4) {
    const { cSize, classes } = useSpinner$1(props4);
    return () => h("svg", {
      class: classes.value,
      fill: "currentColor",
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 55 80",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML$1
    });
  }
});
var innerHTML2$1 = '<g transform="translate(1 1)" stroke-width="2" fill="none" fill-rule="evenodd"><circle cx="5" cy="50" r="5"><animate attributeName="cy" begin="0s" dur="2.2s" values="50;5;50;50" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="cx" begin="0s" dur="2.2s" values="5;27;49;5" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="27" cy="5" r="5"><animate attributeName="cy" begin="0s" dur="2.2s" from="5" to="5" values="5;50;50;5" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="cx" begin="0s" dur="2.2s" from="27" to="27" values="27;49;5;27" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="49" cy="50" r="5"><animate attributeName="cy" begin="0s" dur="2.2s" values="50;50;5;50" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="cx" from="49" to="49" begin="0s" dur="2.2s" values="49;5;27;49" calcMode="linear" repeatCount="indefinite"></animate></circle></g>';
createComponent$1({
  name: "QSpinnerBall",
  props: useSpinnerProps$1,
  setup(props4) {
    const { cSize, classes } = useSpinner$1(props4);
    return () => h("svg", {
      class: classes.value,
      stroke: "currentColor",
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 57 57",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML2$1
    });
  }
});
var innerHTML3$1 = '<rect y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.5s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="y" begin="0.5s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"></animate></rect><rect x="30" y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.25s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="y" begin="0.25s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"></animate></rect><rect x="60" width="15" height="140" rx="6"><animate attributeName="height" begin="0s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="y" begin="0s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"></animate></rect><rect x="90" y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.25s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="y" begin="0.25s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"></animate></rect><rect x="120" y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.5s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="y" begin="0.5s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"></animate></rect>';
createComponent$1({
  name: "QSpinnerBars",
  props: useSpinnerProps$1,
  setup(props4) {
    const { cSize, classes } = useSpinner$1(props4);
    return () => h("svg", {
      class: classes.value,
      fill: "currentColor",
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 135 140",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML3$1
    });
  }
});
var innerHTML4$1 = '<rect x="25" y="25" width="50" height="50" fill="none" stroke-width="4" stroke="currentColor"><animateTransform id="spinnerBox" attributeName="transform" type="rotate" from="0 50 50" to="180 50 50" dur="0.5s" begin="rectBox.end"></animateTransform></rect><rect x="27" y="27" width="46" height="50" fill="currentColor"><animate id="rectBox" attributeName="height" begin="0s;spinnerBox.end" dur="1.3s" from="50" to="0" fill="freeze"></animate></rect>';
createComponent$1({
  name: "QSpinnerBox",
  props: useSpinnerProps$1,
  setup(props4) {
    const { cSize, classes } = useSpinner$1(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML4$1
    });
  }
});
var innerHTML5$1 = '<circle cx="50" cy="50" r="48" fill="none" stroke-width="4" stroke-miterlimit="10" stroke="currentColor"></circle><line stroke-linecap="round" stroke-width="4" stroke-miterlimit="10" stroke="currentColor" x1="50" y1="50" x2="85" y2="50.5"><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="2s" repeatCount="indefinite"></animateTransform></line><line stroke-linecap="round" stroke-width="4" stroke-miterlimit="10" stroke="currentColor" x1="50" y1="50" x2="49.5" y2="74"><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="15s" repeatCount="indefinite"></animateTransform></line>';
createComponent$1({
  name: "QSpinnerClock",
  props: useSpinnerProps$1,
  setup(props4) {
    const { cSize, classes } = useSpinner$1(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML5$1
    });
  }
});
var innerHTML6$1 = '<rect x="0" y="0" width="100" height="100" fill="none"></rect><path d="M78,19H22c-6.6,0-12,5.4-12,12v31c0,6.6,5.4,12,12,12h37.2c0.4,3,1.8,5.6,3.7,7.6c2.4,2.5,5.1,4.1,9.1,4 c-1.4-2.1-2-7.2-2-10.3c0-0.4,0-0.8,0-1.3h8c6.6,0,12-5.4,12-12V31C90,24.4,84.6,19,78,19z" fill="currentColor"></path><circle cx="30" cy="47" r="5" fill="#fff"><animate attributeName="opacity" from="0" to="1" values="0;1;1" keyTimes="0;0.2;1" dur="1s" repeatCount="indefinite"></animate></circle><circle cx="50" cy="47" r="5" fill="#fff"><animate attributeName="opacity" from="0" to="1" values="0;0;1;1" keyTimes="0;0.2;0.4;1" dur="1s" repeatCount="indefinite"></animate></circle><circle cx="70" cy="47" r="5" fill="#fff"><animate attributeName="opacity" from="0" to="1" values="0;0;1;1" keyTimes="0;0.4;0.6;1" dur="1s" repeatCount="indefinite"></animate></circle>';
createComponent$1({
  name: "QSpinnerComment",
  props: useSpinnerProps$1,
  setup(props4) {
    const { cSize, classes } = useSpinner$1(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      innerHTML: innerHTML6$1
    });
  }
});
var innerHTML7$1 = '<rect x="0" y="0" width="100" height="100" fill="none"></rect><g transform="translate(25 25)"><rect x="-20" y="-20" width="40" height="40" fill="currentColor" opacity="0.9"><animateTransform attributeName="transform" type="scale" from="1.5" to="1" repeatCount="indefinite" begin="0s" dur="1s" calcMode="spline" keySplines="0.2 0.8 0.2 0.8" keyTimes="0;1"></animateTransform></rect></g><g transform="translate(75 25)"><rect x="-20" y="-20" width="40" height="40" fill="currentColor" opacity="0.8"><animateTransform attributeName="transform" type="scale" from="1.5" to="1" repeatCount="indefinite" begin="0.1s" dur="1s" calcMode="spline" keySplines="0.2 0.8 0.2 0.8" keyTimes="0;1"></animateTransform></rect></g><g transform="translate(25 75)"><rect x="-20" y="-20" width="40" height="40" fill="currentColor" opacity="0.7"><animateTransform attributeName="transform" type="scale" from="1.5" to="1" repeatCount="indefinite" begin="0.3s" dur="1s" calcMode="spline" keySplines="0.2 0.8 0.2 0.8" keyTimes="0;1"></animateTransform></rect></g><g transform="translate(75 75)"><rect x="-20" y="-20" width="40" height="40" fill="currentColor" opacity="0.6"><animateTransform attributeName="transform" type="scale" from="1.5" to="1" repeatCount="indefinite" begin="0.2s" dur="1s" calcMode="spline" keySplines="0.2 0.8 0.2 0.8" keyTimes="0;1"></animateTransform></rect></g>';
createComponent$1({
  name: "QSpinnerCube",
  props: useSpinnerProps$1,
  setup(props4) {
    const { cSize, classes } = useSpinner$1(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      innerHTML: innerHTML7$1
    });
  }
});
var innerHTML8$1 = '<circle cx="15" cy="15" r="15"><animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="60" cy="15" r="9" fill-opacity=".3"><animate attributeName="r" from="9" to="9" begin="0s" dur="0.8s" values="9;15;9" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="fill-opacity" from=".5" to=".5" begin="0s" dur="0.8s" values=".5;1;.5" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="105" cy="15" r="15"><animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite"></animate></circle>';
createComponent$1({
  name: "QSpinnerDots",
  props: useSpinnerProps$1,
  setup(props4) {
    const { cSize, classes } = useSpinner$1(props4);
    return () => h("svg", {
      class: classes.value,
      fill: "currentColor",
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 120 30",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML8$1
    });
  }
});
var innerHTML9$1 = '<g transform="translate(20 50)"><rect x="-10" y="-30" width="20" height="60" fill="currentColor" opacity="0.6"><animateTransform attributeName="transform" type="scale" from="2" to="1" begin="0s" repeatCount="indefinite" dur="1s" calcMode="spline" keySplines="0.1 0.9 0.4 1" keyTimes="0;1" values="2;1"></animateTransform></rect></g><g transform="translate(50 50)"><rect x="-10" y="-30" width="20" height="60" fill="currentColor" opacity="0.8"><animateTransform attributeName="transform" type="scale" from="2" to="1" begin="0.1s" repeatCount="indefinite" dur="1s" calcMode="spline" keySplines="0.1 0.9 0.4 1" keyTimes="0;1" values="2;1"></animateTransform></rect></g><g transform="translate(80 50)"><rect x="-10" y="-30" width="20" height="60" fill="currentColor" opacity="0.9"><animateTransform attributeName="transform" type="scale" from="2" to="1" begin="0.2s" repeatCount="indefinite" dur="1s" calcMode="spline" keySplines="0.1 0.9 0.4 1" keyTimes="0;1" values="2;1"></animateTransform></rect></g>';
createComponent$1({
  name: "QSpinnerFacebook",
  props: useSpinnerProps$1,
  setup(props4) {
    const { cSize, classes } = useSpinner$1(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 100 100",
      xmlns: "http://www.w3.org/2000/svg",
      preserveAspectRatio: "xMidYMid",
      innerHTML: innerHTML9$1
    });
  }
});
var innerHTML10$1 = '<g transform="translate(-20,-20)"><path d="M79.9,52.6C80,51.8,80,50.9,80,50s0-1.8-0.1-2.6l-5.1-0.4c-0.3-2.4-0.9-4.6-1.8-6.7l4.2-2.9c-0.7-1.6-1.6-3.1-2.6-4.5 L70,35c-1.4-1.9-3.1-3.5-4.9-4.9l2.2-4.6c-1.4-1-2.9-1.9-4.5-2.6L59.8,27c-2.1-0.9-4.4-1.5-6.7-1.8l-0.4-5.1C51.8,20,50.9,20,50,20 s-1.8,0-2.6,0.1l-0.4,5.1c-2.4,0.3-4.6,0.9-6.7,1.8l-2.9-4.1c-1.6,0.7-3.1,1.6-4.5,2.6l2.1,4.6c-1.9,1.4-3.5,3.1-5,4.9l-4.5-2.1 c-1,1.4-1.9,2.9-2.6,4.5l4.1,2.9c-0.9,2.1-1.5,4.4-1.8,6.8l-5,0.4C20,48.2,20,49.1,20,50s0,1.8,0.1,2.6l5,0.4 c0.3,2.4,0.9,4.7,1.8,6.8l-4.1,2.9c0.7,1.6,1.6,3.1,2.6,4.5l4.5-2.1c1.4,1.9,3.1,3.5,5,4.9l-2.1,4.6c1.4,1,2.9,1.9,4.5,2.6l2.9-4.1 c2.1,0.9,4.4,1.5,6.7,1.8l0.4,5.1C48.2,80,49.1,80,50,80s1.8,0,2.6-0.1l0.4-5.1c2.3-0.3,4.6-0.9,6.7-1.8l2.9,4.2 c1.6-0.7,3.1-1.6,4.5-2.6L65,69.9c1.9-1.4,3.5-3,4.9-4.9l4.6,2.2c1-1.4,1.9-2.9,2.6-4.5L73,59.8c0.9-2.1,1.5-4.4,1.8-6.7L79.9,52.6 z M50,65c-8.3,0-15-6.7-15-15c0-8.3,6.7-15,15-15s15,6.7,15,15C65,58.3,58.3,65,50,65z" fill="currentColor"><animateTransform attributeName="transform" type="rotate" from="90 50 50" to="0 50 50" dur="1s" repeatCount="indefinite"></animateTransform></path></g><g transform="translate(20,20) rotate(15 50 50)"><path d="M79.9,52.6C80,51.8,80,50.9,80,50s0-1.8-0.1-2.6l-5.1-0.4c-0.3-2.4-0.9-4.6-1.8-6.7l4.2-2.9c-0.7-1.6-1.6-3.1-2.6-4.5 L70,35c-1.4-1.9-3.1-3.5-4.9-4.9l2.2-4.6c-1.4-1-2.9-1.9-4.5-2.6L59.8,27c-2.1-0.9-4.4-1.5-6.7-1.8l-0.4-5.1C51.8,20,50.9,20,50,20 s-1.8,0-2.6,0.1l-0.4,5.1c-2.4,0.3-4.6,0.9-6.7,1.8l-2.9-4.1c-1.6,0.7-3.1,1.6-4.5,2.6l2.1,4.6c-1.9,1.4-3.5,3.1-5,4.9l-4.5-2.1 c-1,1.4-1.9,2.9-2.6,4.5l4.1,2.9c-0.9,2.1-1.5,4.4-1.8,6.8l-5,0.4C20,48.2,20,49.1,20,50s0,1.8,0.1,2.6l5,0.4 c0.3,2.4,0.9,4.7,1.8,6.8l-4.1,2.9c0.7,1.6,1.6,3.1,2.6,4.5l4.5-2.1c1.4,1.9,3.1,3.5,5,4.9l-2.1,4.6c1.4,1,2.9,1.9,4.5,2.6l2.9-4.1 c2.1,0.9,4.4,1.5,6.7,1.8l0.4,5.1C48.2,80,49.1,80,50,80s1.8,0,2.6-0.1l0.4-5.1c2.3-0.3,4.6-0.9,6.7-1.8l2.9,4.2 c1.6-0.7,3.1-1.6,4.5-2.6L65,69.9c1.9-1.4,3.5-3,4.9-4.9l4.6,2.2c1-1.4,1.9-2.9,2.6-4.5L73,59.8c0.9-2.1,1.5-4.4,1.8-6.7L79.9,52.6 z M50,65c-8.3,0-15-6.7-15-15c0-8.3,6.7-15,15-15s15,6.7,15,15C65,58.3,58.3,65,50,65z" fill="currentColor"><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="90 50 50" dur="1s" repeatCount="indefinite"></animateTransform></path></g>';
createComponent$1({
  name: "QSpinnerGears",
  props: useSpinnerProps$1,
  setup(props4) {
    const { cSize, classes } = useSpinner$1(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML10$1
    });
  }
});
var innerHTML11$1 = '<circle cx="12.5" cy="12.5" r="12.5"><animate attributeName="fill-opacity" begin="0s" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="12.5" cy="52.5" r="12.5" fill-opacity=".5"><animate attributeName="fill-opacity" begin="100ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="52.5" cy="12.5" r="12.5"><animate attributeName="fill-opacity" begin="300ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="52.5" cy="52.5" r="12.5"><animate attributeName="fill-opacity" begin="600ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="92.5" cy="12.5" r="12.5"><animate attributeName="fill-opacity" begin="800ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="92.5" cy="52.5" r="12.5"><animate attributeName="fill-opacity" begin="400ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="12.5" cy="92.5" r="12.5"><animate attributeName="fill-opacity" begin="700ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="52.5" cy="92.5" r="12.5"><animate attributeName="fill-opacity" begin="500ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="92.5" cy="92.5" r="12.5"><animate attributeName="fill-opacity" begin="200ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle>';
createComponent$1({
  name: "QSpinnerGrid",
  props: useSpinnerProps$1,
  setup(props4) {
    const { cSize, classes } = useSpinner$1(props4);
    return () => h("svg", {
      class: classes.value,
      fill: "currentColor",
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 105 105",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML11$1
    });
  }
});
var innerHTML12$1 = '<path d="M30.262 57.02L7.195 40.723c-5.84-3.976-7.56-12.06-3.842-18.063 3.715-6 11.467-7.65 17.306-3.68l4.52 3.76 2.6-5.274c3.716-6.002 11.47-7.65 17.304-3.68 5.84 3.97 7.56 12.054 3.842 18.062L34.49 56.118c-.897 1.512-2.793 1.915-4.228.9z" fill-opacity=".5"><animate attributeName="fill-opacity" begin="0s" dur="1.4s" values="0.5;1;0.5" calcMode="linear" repeatCount="indefinite"></animate></path><path d="M105.512 56.12l-14.44-24.272c-3.716-6.008-1.996-14.093 3.843-18.062 5.835-3.97 13.588-2.322 17.306 3.68l2.6 5.274 4.52-3.76c5.84-3.97 13.593-2.32 17.308 3.68 3.718 6.003 1.998 14.088-3.842 18.064L109.74 57.02c-1.434 1.014-3.33.61-4.228-.9z" fill-opacity=".5"><animate attributeName="fill-opacity" begin="0.7s" dur="1.4s" values="0.5;1;0.5" calcMode="linear" repeatCount="indefinite"></animate></path><path d="M67.408 57.834l-23.01-24.98c-5.864-6.15-5.864-16.108 0-22.248 5.86-6.14 15.37-6.14 21.234 0L70 16.168l4.368-5.562c5.863-6.14 15.375-6.14 21.235 0 5.863 6.14 5.863 16.098 0 22.247l-23.007 24.98c-1.43 1.556-3.757 1.556-5.188 0z"></path>';
createComponent$1({
  name: "QSpinnerHearts",
  props: useSpinnerProps$1,
  setup(props4) {
    const { cSize, classes } = useSpinner$1(props4);
    return () => h("svg", {
      class: classes.value,
      fill: "currentColor",
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 140 64",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML12$1
    });
  }
});
var innerHTML13$1 = '<g><path fill="none" stroke="currentColor" stroke-width="5" stroke-miterlimit="10" d="M58.4,51.7c-0.9-0.9-1.4-2-1.4-2.3s0.5-0.4,1.4-1.4 C70.8,43.8,79.8,30.5,80,15.5H70H30H20c0.2,15,9.2,28.1,21.6,32.3c0.9,0.9,1.4,1.2,1.4,1.5s-0.5,1.6-1.4,2.5 C29.2,56.1,20.2,69.5,20,85.5h10h40h10C79.8,69.5,70.8,55.9,58.4,51.7z"></path><clipPath id="uil-hourglass-clip1"><rect x="15" y="20" width="70" height="25"><animate attributeName="height" from="25" to="0" dur="1s" repeatCount="indefinite" values="25;0;0" keyTimes="0;0.5;1"></animate><animate attributeName="y" from="20" to="45" dur="1s" repeatCount="indefinite" values="20;45;45" keyTimes="0;0.5;1"></animate></rect></clipPath><clipPath id="uil-hourglass-clip2"><rect x="15" y="55" width="70" height="25"><animate attributeName="height" from="0" to="25" dur="1s" repeatCount="indefinite" values="0;25;25" keyTimes="0;0.5;1"></animate><animate attributeName="y" from="80" to="55" dur="1s" repeatCount="indefinite" values="80;55;55" keyTimes="0;0.5;1"></animate></rect></clipPath><path d="M29,23c3.1,11.4,11.3,19.5,21,19.5S67.9,34.4,71,23H29z" clip-path="url(#uil-hourglass-clip1)" fill="currentColor"></path><path d="M71.6,78c-3-11.6-11.5-20-21.5-20s-18.5,8.4-21.5,20H71.6z" clip-path="url(#uil-hourglass-clip2)" fill="currentColor"></path><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="180 50 50" repeatCount="indefinite" dur="1s" values="0 50 50;0 50 50;180 50 50" keyTimes="0;0.7;1"></animateTransform></g>';
createComponent$1({
  name: "QSpinnerHourglass",
  props: useSpinnerProps$1,
  setup(props4) {
    const { cSize, classes } = useSpinner$1(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML13$1
    });
  }
});
var innerHTML14$1 = '<path d="M24.3,30C11.4,30,5,43.3,5,50s6.4,20,19.3,20c19.3,0,32.1-40,51.4-40C88.6,30,95,43.3,95,50s-6.4,20-19.3,20C56.4,70,43.6,30,24.3,30z" fill="none" stroke="currentColor" stroke-width="8" stroke-dasharray="10.691205342610678 10.691205342610678" stroke-dashoffset="0"><animate attributeName="stroke-dashoffset" from="0" to="21.382410685221355" begin="0" dur="2s" repeatCount="indefinite" fill="freeze"></animate></path>';
createComponent$1({
  name: "QSpinnerInfinity",
  props: useSpinnerProps$1,
  setup(props4) {
    const { cSize, classes } = useSpinner$1(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      innerHTML: innerHTML14$1
    });
  }
});
var innerHTML15$1 = '<g stroke-width="4" stroke-linecap="round"><line y1="17" y2="29" transform="translate(32,32) rotate(180)"><animate attributeName="stroke-opacity" dur="750ms" values="1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0;1" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(210)"><animate attributeName="stroke-opacity" dur="750ms" values="0;1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(240)"><animate attributeName="stroke-opacity" dur="750ms" values=".1;0;1;.85;.7;.65;.55;.45;.35;.25;.15;.1" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(270)"><animate attributeName="stroke-opacity" dur="750ms" values=".15;.1;0;1;.85;.7;.65;.55;.45;.35;.25;.15" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(300)"><animate attributeName="stroke-opacity" dur="750ms" values=".25;.15;.1;0;1;.85;.7;.65;.55;.45;.35;.25" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(330)"><animate attributeName="stroke-opacity" dur="750ms" values=".35;.25;.15;.1;0;1;.85;.7;.65;.55;.45;.35" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(0)"><animate attributeName="stroke-opacity" dur="750ms" values=".45;.35;.25;.15;.1;0;1;.85;.7;.65;.55;.45" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(30)"><animate attributeName="stroke-opacity" dur="750ms" values=".55;.45;.35;.25;.15;.1;0;1;.85;.7;.65;.55" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(60)"><animate attributeName="stroke-opacity" dur="750ms" values=".65;.55;.45;.35;.25;.15;.1;0;1;.85;.7;.65" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(90)"><animate attributeName="stroke-opacity" dur="750ms" values=".7;.65;.55;.45;.35;.25;.15;.1;0;1;.85;.7" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(120)"><animate attributeName="stroke-opacity" dur="750ms" values=".85;.7;.65;.55;.45;.35;.25;.15;.1;0;1;.85" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(150)"><animate attributeName="stroke-opacity" dur="750ms" values="1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0;1" repeatCount="indefinite"></animate></line></g>';
createComponent$1({
  name: "QSpinnerIos",
  props: useSpinnerProps$1,
  setup(props4) {
    const { cSize, classes } = useSpinner$1(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      stroke: "currentColor",
      fill: "currentColor",
      viewBox: "0 0 64 64",
      innerHTML: innerHTML15$1
    });
  }
});
var innerHTML16$1 = '<circle cx="50" cy="50" r="44" fill="none" stroke-width="4" stroke-opacity=".5" stroke="currentColor"></circle><circle cx="8" cy="54" r="6" fill="currentColor" stroke-width="3" stroke="currentColor"><animateTransform attributeName="transform" type="rotate" from="0 50 48" to="360 50 52" dur="2s" repeatCount="indefinite"></animateTransform></circle>';
createComponent$1({
  name: "QSpinnerOrbit",
  props: useSpinnerProps$1,
  setup(props4) {
    const { cSize, classes } = useSpinner$1(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML16$1
    });
  }
});
var innerHTML17$1 = '<g transform="translate(1 1)" stroke-width="2" fill="none" fill-rule="evenodd"><circle stroke-opacity=".5" cx="18" cy="18" r="18"></circle><path d="M36 18c0-9.94-8.06-18-18-18"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite"></animateTransform></path></g>';
createComponent$1({
  name: "QSpinnerOval",
  props: useSpinnerProps$1,
  setup(props4) {
    const { cSize, classes } = useSpinner$1(props4);
    return () => h("svg", {
      class: classes.value,
      stroke: "currentColor",
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 38 38",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML17$1
    });
  }
});
var innerHTML18$1 = '<path d="M0 50A50 50 0 0 1 50 0L50 50L0 50" fill="currentColor" opacity="0.5"><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="0.8s" repeatCount="indefinite"></animateTransform></path><path d="M50 0A50 50 0 0 1 100 50L50 50L50 0" fill="currentColor" opacity="0.5"><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="1.6s" repeatCount="indefinite"></animateTransform></path><path d="M100 50A50 50 0 0 1 50 100L50 50L100 50" fill="currentColor" opacity="0.5"><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="2.4s" repeatCount="indefinite"></animateTransform></path><path d="M50 100A50 50 0 0 1 0 50L50 50L50 100" fill="currentColor" opacity="0.5"><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="3.2s" repeatCount="indefinite"></animateTransform></path>';
createComponent$1({
  name: "QSpinnerPie",
  props: useSpinnerProps$1,
  setup(props4) {
    const { cSize, classes } = useSpinner$1(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML18$1
    });
  }
});
var innerHTML19$1 = '<g fill="none" fill-rule="evenodd" stroke-width="2"><circle cx="22" cy="22" r="1"><animate attributeName="r" begin="0s" dur="1.8s" values="1; 20" calcMode="spline" keyTimes="0; 1" keySplines="0.165, 0.84, 0.44, 1" repeatCount="indefinite"></animate><animate attributeName="stroke-opacity" begin="0s" dur="1.8s" values="1; 0" calcMode="spline" keyTimes="0; 1" keySplines="0.3, 0.61, 0.355, 1" repeatCount="indefinite"></animate></circle><circle cx="22" cy="22" r="1"><animate attributeName="r" begin="-0.9s" dur="1.8s" values="1; 20" calcMode="spline" keyTimes="0; 1" keySplines="0.165, 0.84, 0.44, 1" repeatCount="indefinite"></animate><animate attributeName="stroke-opacity" begin="-0.9s" dur="1.8s" values="1; 0" calcMode="spline" keyTimes="0; 1" keySplines="0.3, 0.61, 0.355, 1" repeatCount="indefinite"></animate></circle></g>';
createComponent$1({
  name: "QSpinnerPuff",
  props: useSpinnerProps$1,
  setup(props4) {
    const { cSize, classes } = useSpinner$1(props4);
    return () => h("svg", {
      class: classes.value,
      stroke: "currentColor",
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 44 44",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML19$1
    });
  }
});
var innerHTML20$1 = '<g transform="scale(0.55)"><circle cx="30" cy="150" r="30" fill="currentColor"><animate attributeName="opacity" from="0" to="1" dur="1s" begin="0" repeatCount="indefinite" keyTimes="0;0.5;1" values="0;1;1"></animate></circle><path d="M90,150h30c0-49.7-40.3-90-90-90v30C63.1,90,90,116.9,90,150z" fill="currentColor"><animate attributeName="opacity" from="0" to="1" dur="1s" begin="0.1" repeatCount="indefinite" keyTimes="0;0.5;1" values="0;1;1"></animate></path><path d="M150,150h30C180,67.2,112.8,0,30,0v30C96.3,30,150,83.7,150,150z" fill="currentColor"><animate attributeName="opacity" from="0" to="1" dur="1s" begin="0.2" repeatCount="indefinite" keyTimes="0;0.5;1" values="0;1;1"></animate></path></g>';
createComponent$1({
  name: "QSpinnerRadio",
  props: useSpinnerProps$1,
  setup(props4) {
    const { cSize, classes } = useSpinner$1(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML20$1
    });
  }
});
var innerHTML21$1 = '<g fill="none" fill-rule="evenodd" transform="translate(1 1)" stroke-width="2"><circle cx="22" cy="22" r="6"><animate attributeName="r" begin="1.5s" dur="3s" values="6;22" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="stroke-opacity" begin="1.5s" dur="3s" values="1;0" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="stroke-width" begin="1.5s" dur="3s" values="2;0" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="22" cy="22" r="6"><animate attributeName="r" begin="3s" dur="3s" values="6;22" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="stroke-opacity" begin="3s" dur="3s" values="1;0" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="stroke-width" begin="3s" dur="3s" values="2;0" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="22" cy="22" r="8"><animate attributeName="r" begin="0s" dur="1.5s" values="6;1;2;3;4;5;6" calcMode="linear" repeatCount="indefinite"></animate></circle></g>';
createComponent$1({
  name: "QSpinnerRings",
  props: useSpinnerProps$1,
  setup(props4) {
    const { cSize, classes } = useSpinner$1(props4);
    return () => h("svg", {
      class: classes.value,
      stroke: "currentColor",
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 45 45",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML21$1
    });
  }
});
var innerHTML22$1 = '<defs><linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a"><stop stop-color="currentColor" stop-opacity="0" offset="0%"></stop><stop stop-color="currentColor" stop-opacity=".631" offset="63.146%"></stop><stop stop-color="currentColor" offset="100%"></stop></linearGradient></defs><g transform="translate(1 1)" fill="none" fill-rule="evenodd"><path d="M36 18c0-9.94-8.06-18-18-18" stroke="url(#a)" stroke-width="2"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.9s" repeatCount="indefinite"></animateTransform></path><circle fill="currentColor" cx="36" cy="18" r="1"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.9s" repeatCount="indefinite"></animateTransform></circle></g>';
createComponent$1({
  name: "QSpinnerTail",
  props: useSpinnerProps$1,
  setup(props4) {
    const { cSize, classes } = useSpinner$1(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 38 38",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML22$1
    });
  }
});
createComponent$1({
  name: "QSplitter",
  props: {
    ...useDarkProps$1,
    modelValue: {
      type: Number,
      required: true
    },
    reverse: Boolean,
    unit: {
      type: String,
      default: "%",
      validator: (v) => ["%", "px"].includes(v)
    },
    limits: {
      type: Array,
      validator: (v) => {
        if (v.length !== 2) return false;
        if (typeof v[0] !== "number" || typeof v[1] !== "number") return false;
        return v[0] >= 0 && v[0] <= v[1];
      }
    },
    emitImmediately: Boolean,
    horizontal: Boolean,
    disable: Boolean,
    beforeClass: [Array, String, Object],
    afterClass: [Array, String, Object],
    separatorClass: [Array, String, Object],
    separatorStyle: [Array, String, Object]
  },
  emits: ["update:modelValue"],
  setup(props4, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const isDark = use_dark_default$1(props4, $q);
    const rootRef = ref$1(null);
    const sideRefs = {
      before: ref$1(null),
      after: ref$1(null)
    };
    const classes = computed(
      () => `q-splitter no-wrap ${props4.horizontal === true ? "q-splitter--horizontal column" : "q-splitter--vertical row"} q-splitter--${props4.disable === true ? "disabled" : "workable"}` + (isDark.value === true ? " q-splitter--dark" : "")
    );
    const propName = computed(() => props4.horizontal === true ? "height" : "width");
    const side = computed(() => props4.reverse !== true ? "before" : "after");
    const computedLimits = computed(() => props4.limits !== void 0 ? props4.limits : props4.unit === "%" ? [10, 90] : [50, Infinity]);
    function getCSSValue(value2) {
      return (props4.unit === "%" ? value2 : Math.round(value2)) + props4.unit;
    }
    const styles = computed(() => ({
      [side.value]: {
        [propName.value]: getCSSValue(props4.modelValue)
      }
    }));
    let __dir, __maxValue, __value, __multiplier, __normalized;
    function pan(evt) {
      if (evt.isFirst === true) {
        const size2 = rootRef.value.getBoundingClientRect()[propName.value];
        __dir = props4.horizontal === true ? "up" : "left";
        __maxValue = props4.unit === "%" ? 100 : size2;
        __value = Math.min(__maxValue, computedLimits.value[1], Math.max(computedLimits.value[0], props4.modelValue));
        __multiplier = (props4.reverse !== true ? 1 : -1) * (props4.horizontal === true ? 1 : $q.lang.rtl === true ? -1 : 1) * (props4.unit === "%" ? size2 === 0 ? 0 : 100 / size2 : 1);
        rootRef.value.classList.add("q-splitter--active");
        return;
      }
      if (evt.isFinal === true) {
        if (__normalized !== props4.modelValue) {
          emit("update:modelValue", __normalized);
        }
        rootRef.value.classList.remove("q-splitter--active");
        return;
      }
      const val = __value + __multiplier * (evt.direction === __dir ? -1 : 1) * evt.distance[props4.horizontal === true ? "y" : "x"];
      __normalized = Math.min(__maxValue, computedLimits.value[1], Math.max(computedLimits.value[0], val));
      sideRefs[side.value].value.style[propName.value] = getCSSValue(__normalized);
      if (props4.emitImmediately === true && props4.modelValue !== __normalized) {
        emit("update:modelValue", __normalized);
      }
    }
    const sepDirective = computed(() => {
      return [[
        TouchPan_default$1,
        pan,
        void 0,
        {
          [props4.horizontal === true ? "vertical" : "horizontal"]: true,
          prevent: true,
          stop: true,
          mouse: true,
          mouseAllDir: true
        }
      ]];
    });
    function normalize2(val, limits) {
      if (val < limits[0]) {
        emit("update:modelValue", limits[0]);
      } else if (val > limits[1]) {
        emit("update:modelValue", limits[1]);
      }
    }
    watch(() => props4.modelValue, (v) => {
      normalize2(v, computedLimits.value);
    });
    watch(() => props4.limits, () => {
      nextTick(() => {
        normalize2(props4.modelValue, computedLimits.value);
      });
    });
    return () => {
      const child = [
        h("div", {
          ref: sideRefs.before,
          class: [
            "q-splitter__panel q-splitter__before" + (props4.reverse === true ? " col" : ""),
            props4.beforeClass
          ],
          style: styles.value.before
        }, hSlot$1(slots.before)),
        h("div", {
          class: [
            "q-splitter__separator",
            props4.separatorClass
          ],
          style: props4.separatorStyle,
          "aria-disabled": props4.disable === true ? "true" : void 0
        }, [
          hDir$1(
            "div",
            { class: "q-splitter__separator-area absolute-full" },
            hSlot$1(slots.separator),
            "sep",
            props4.disable !== true,
            () => sepDirective.value
          )
        ]),
        h("div", {
          ref: sideRefs.after,
          class: [
            "q-splitter__panel q-splitter__after" + (props4.reverse === true ? "" : " col"),
            props4.afterClass
          ],
          style: styles.value.after
        }, hSlot$1(slots.after))
      ];
      return h("div", {
        class: classes.value,
        ref: rootRef
      }, hMergeSlot$1(slots.default, child));
    };
  }
});
var StepHeader_default$1 = createComponent$1({
  name: "StepHeader",
  props: {
    stepper: {},
    step: {},
    goToPanel: Function
  },
  setup(props4, { attrs }) {
    const { proxy: { $q } } = getCurrentInstance();
    const blurRef = ref$1(null);
    const isActive = computed(() => props4.stepper.modelValue === props4.step.name);
    const isDisable = computed(() => {
      const opt = props4.step.disable;
      return opt === true || opt === "";
    });
    const isError2 = computed(() => {
      const opt = props4.step.error;
      return opt === true || opt === "";
    });
    const isDone = computed(() => {
      const opt = props4.step.done;
      return isDisable.value === false && (opt === true || opt === "");
    });
    const headerNav = computed(() => {
      const opt = props4.step.headerNav, nav = opt === true || opt === "" || opt === void 0;
      return isDisable.value === false && props4.stepper.headerNav && nav;
    });
    const hasPrefix = computed(() => {
      return props4.step.prefix && (isActive.value === false || props4.stepper.activeIcon === "none") && (isError2.value === false || props4.stepper.errorIcon === "none") && (isDone.value === false || props4.stepper.doneIcon === "none");
    });
    const icon = computed(() => {
      const defaultIcon = props4.step.icon || props4.stepper.inactiveIcon;
      if (isActive.value === true) {
        const icon2 = props4.step.activeIcon || props4.stepper.activeIcon;
        return icon2 === "none" ? defaultIcon : icon2 || $q.iconSet.stepper.active;
      }
      if (isError2.value === true) {
        const icon2 = props4.step.errorIcon || props4.stepper.errorIcon;
        return icon2 === "none" ? defaultIcon : icon2 || $q.iconSet.stepper.error;
      }
      if (isDisable.value === false && isDone.value === true) {
        const icon2 = props4.step.doneIcon || props4.stepper.doneIcon;
        return icon2 === "none" ? defaultIcon : icon2 || $q.iconSet.stepper.done;
      }
      return defaultIcon;
    });
    const color2 = computed(() => {
      const errorColor = isError2.value === true ? props4.step.errorColor || props4.stepper.errorColor : void 0;
      if (isActive.value === true) {
        const color22 = props4.step.activeColor || props4.stepper.activeColor || props4.step.color;
        return color22 !== void 0 ? color22 : errorColor;
      }
      if (errorColor !== void 0) {
        return errorColor;
      }
      if (isDisable.value === false && isDone.value === true) {
        return props4.step.doneColor || props4.stepper.doneColor || props4.step.color || props4.stepper.inactiveColor;
      }
      return props4.step.color || props4.stepper.inactiveColor;
    });
    const classes = computed(() => {
      return "q-stepper__tab col-grow flex items-center no-wrap relative-position" + (color2.value !== void 0 ? ` text-${color2.value}` : "") + (isError2.value === true ? " q-stepper__tab--error q-stepper__tab--error-with-" + (hasPrefix.value === true ? "prefix" : "icon") : "") + (isActive.value === true ? " q-stepper__tab--active" : "") + (isDone.value === true ? " q-stepper__tab--done" : "") + (headerNav.value === true ? " q-stepper__tab--navigation q-focusable q-hoverable" : "") + (isDisable.value === true ? " q-stepper__tab--disabled" : "");
    });
    const ripple = computed(() => props4.stepper.headerNav !== true ? false : headerNav.value);
    function onActivate() {
      blurRef.value !== null && blurRef.value.focus();
      isActive.value === false && props4.goToPanel(props4.step.name);
    }
    function onKeyup2(e22) {
      if (e22.keyCode === 13 && isActive.value === false) {
        props4.goToPanel(props4.step.name);
      }
    }
    return () => {
      const data = { class: classes.value };
      if (headerNav.value === true) {
        data.onClick = onActivate;
        data.onKeyup = onKeyup2;
        Object.assign(
          data,
          isDisable.value === true ? { tabindex: -1, "aria-disabled": "true" } : { tabindex: attrs.tabindex || 0 }
        );
      }
      const child = [
        h("div", { class: "q-focus-helper", tabindex: -1, ref: blurRef }),
        h("div", { class: "q-stepper__dot row flex-center q-stepper__line relative-position" }, [
          h("span", { class: "row flex-center" }, [
            hasPrefix.value === true ? props4.step.prefix : h(QIcon_default$1, { name: icon.value })
          ])
        ])
      ];
      if (props4.step.title !== void 0 && props4.step.title !== null) {
        const content = [
          h("div", { class: "q-stepper__title" }, props4.step.title)
        ];
        if (props4.step.caption !== void 0 && props4.step.caption !== null) {
          content.push(
            h("div", { class: "q-stepper__caption" }, props4.step.caption)
          );
        }
        child.push(
          h("div", {
            class: "q-stepper__label q-stepper__line relative-position"
          }, content)
        );
      }
      return withDirectives(
        h("div", data, child),
        [[Ripple_default$1, ripple.value]]
      );
    };
  }
});
function getStepWrapper$1(slots) {
  return h("div", {
    class: "q-stepper__step-content"
  }, [
    h("div", {
      class: "q-stepper__step-inner"
    }, hSlot$1(slots.default))
  ]);
}
var PanelWrapper2$1 = {
  setup(_, { slots }) {
    return () => getStepWrapper$1(slots);
  }
};
createComponent$1({
  name: "QStep",
  props: {
    ...usePanelChildProps$1,
    icon: String,
    color: String,
    title: {
      type: String,
      required: true
    },
    caption: String,
    prefix: [String, Number],
    doneIcon: String,
    doneColor: String,
    activeIcon: String,
    activeColor: String,
    errorIcon: String,
    errorColor: String,
    headerNav: {
      type: Boolean,
      default: true
    },
    done: Boolean,
    error: Boolean,
    onScroll: [Function, Array]
  },
  setup(props4, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const $stepper = inject(stepperKey$1, emptyRenderFn$1);
    if ($stepper === emptyRenderFn$1) {
      console.error("QStep needs to be a child of QStepper");
      return emptyRenderFn$1;
    }
    const { getCache } = use_render_cache_default$1();
    const rootRef = ref$1(null);
    const isActive = computed(() => $stepper.value.modelValue === props4.name);
    const scrollEvent = computed(() => $q.platform.is.ios !== true && $q.platform.is.chrome === true || isActive.value !== true || $stepper.value.vertical !== true ? {} : {
      onScroll(e22) {
        const { target: target2 } = e22;
        if (target2.scrollTop > 0) {
          target2.scrollTop = 0;
        }
        props4.onScroll !== void 0 && emit("scroll", e22);
      }
    });
    const contentKey = computed(() => typeof props4.name === "string" || typeof props4.name === "number" ? props4.name : String(props4.name));
    function getStepContent() {
      const vertical = $stepper.value.vertical;
      if (vertical === true && $stepper.value.keepAlive === true) {
        return h(
          KeepAlive,
          $stepper.value.keepAliveProps.value,
          isActive.value === true ? [
            h(
              $stepper.value.needsUniqueKeepAliveWrapper.value === true ? getCache(contentKey.value, () => ({ ...PanelWrapper2$1, name: contentKey.value })) : PanelWrapper2$1,
              { key: contentKey.value },
              slots.default
            )
          ] : void 0
        );
      }
      return vertical !== true || isActive.value === true ? getStepWrapper$1(slots) : void 0;
    }
    return () => h(
      "div",
      { ref: rootRef, class: "q-stepper__step", role: "tabpanel", ...scrollEvent.value },
      $stepper.value.vertical === true ? [
        h(StepHeader_default$1, {
          stepper: $stepper.value,
          step: props4,
          goToPanel: $stepper.value.goToPanel
        }),
        $stepper.value.animated === true ? h(QSlideTransition_default$1, getStepContent) : getStepContent()
      ] : [getStepContent()]
    );
  }
});
var camelRE$1 = /(-\w)/g;
function camelizeProps$1(props4) {
  const acc = {};
  for (const key in props4) {
    const newKey = key.replace(camelRE$1, (m32) => m32[1].toUpperCase());
    acc[newKey] = props4[key];
  }
  return acc;
}
createComponent$1({
  name: "QStepper",
  props: {
    ...useDarkProps$1,
    ...usePanelProps$1,
    flat: Boolean,
    bordered: Boolean,
    alternativeLabels: Boolean,
    headerNav: Boolean,
    contracted: Boolean,
    headerClass: String,
    inactiveColor: String,
    inactiveIcon: String,
    doneIcon: String,
    doneColor: String,
    activeIcon: String,
    activeColor: String,
    errorIcon: String,
    errorColor: String
  },
  emits: usePanelEmits$1,
  setup(props4, { slots }) {
    const vm2 = getCurrentInstance();
    const isDark = use_dark_default$1(props4, vm2.proxy.$q);
    const {
      updatePanelsList,
      isValidPanelName,
      updatePanelIndex,
      getPanelContent,
      getPanels,
      panelDirectives,
      goToPanel,
      keepAliveProps,
      needsUniqueKeepAliveWrapper
    } = use_panel_default$1();
    provide(stepperKey$1, computed(() => ({
      goToPanel,
      keepAliveProps,
      needsUniqueKeepAliveWrapper,
      ...props4
    })));
    const classes = computed(
      () => `q-stepper q-stepper--${props4.vertical === true ? "vertical" : "horizontal"}` + (props4.flat === true ? " q-stepper--flat" : "") + (props4.bordered === true ? " q-stepper--bordered" : "") + (isDark.value === true ? " q-stepper--dark q-dark" : "")
    );
    const headerClasses = computed(
      () => `q-stepper__header row items-stretch justify-between q-stepper__header--${props4.alternativeLabels === true ? "alternative" : "standard"}-labels` + (props4.flat === false || props4.bordered === true ? " q-stepper__header--border" : "") + (props4.contracted === true ? " q-stepper__header--contracted" : "") + (props4.headerClass !== void 0 ? ` ${props4.headerClass}` : "")
    );
    function getContent() {
      const top = hSlot$1(slots.message, []);
      if (props4.vertical === true) {
        isValidPanelName(props4.modelValue) && updatePanelIndex();
        const content = h("div", {
          class: "q-stepper__content"
        }, hSlot$1(slots.default));
        return top === void 0 ? [content] : top.concat(content);
      }
      return [
        h(
          "div",
          { class: headerClasses.value },
          getPanels().map((panel) => {
            const step = camelizeProps$1(panel.props);
            return h(StepHeader_default$1, {
              key: step.name,
              stepper: props4,
              step,
              goToPanel
            });
          })
        ),
        top,
        hDir$1(
          "div",
          { class: "q-stepper__content q-panel-parent" },
          getPanelContent(),
          "cont",
          props4.swipeable,
          () => panelDirectives.value
        )
      ];
    }
    return () => {
      updatePanelsList(slots);
      return h("div", {
        class: classes.value
      }, hMergeSlot$1(slots.navigation, getContent()));
    };
  }
});
createComponent$1({
  name: "QStepperNavigation",
  setup(_, { slots }) {
    return () => h("div", { class: "q-stepper__nav" }, hSlot$1(slots.default));
  }
});
var QTh_default$1 = createComponent$1({
  name: "QTh",
  props: {
    props: Object,
    autoWidth: Boolean
  },
  emits: ["click"],
  setup(props4, { slots, emit }) {
    const vm2 = getCurrentInstance();
    const { proxy: { $q } } = vm2;
    const onClick = (evt) => {
      emit("click", evt);
    };
    return () => {
      if (props4.props === void 0) {
        return h("th", {
          class: props4.autoWidth === true ? "q-table--col-auto-width" : "",
          onClick
        }, hSlot$1(slots.default));
      }
      let col, child;
      const name2 = vm2.vnode.key;
      if (name2) {
        col = props4.props.colsMap[name2];
        if (col === void 0) return;
      } else {
        col = props4.props.col;
      }
      if (col.sortable === true) {
        const action = col.align === "right" ? "unshift" : "push";
        child = hUniqueSlot$1(slots.default, []);
        child[action](
          h(QIcon_default$1, {
            class: col.__iconClass,
            name: $q.iconSet.table.arrowUp
          })
        );
      } else {
        child = hSlot$1(slots.default);
      }
      const data = {
        class: col.__thClass + (props4.autoWidth === true ? " q-table--col-auto-width" : ""),
        style: col.headerStyle,
        onClick: (evt) => {
          col.sortable === true && props4.props.sort(col);
          onClick(evt);
        }
      };
      return h("th", data, child);
    };
  }
});
function get_table_middle_default$1(props4, content) {
  return h("div", props4, [
    h("table", { class: "q-table" }, content)
  ]);
}
var comps$1 = {
  list: QList_default$1,
  table: QMarkupTable_default$1
};
var typeOptions$1 = ["list", "table", "__qtable"];
var QVirtualScroll_default$1 = createComponent$1({
  name: "QVirtualScroll",
  props: {
    ...useVirtualScrollProps$1,
    type: {
      type: String,
      default: "list",
      validator: (v) => typeOptions$1.includes(v)
    },
    items: {
      type: Array,
      default: () => []
    },
    itemsFn: Function,
    itemsSize: Number,
    scrollTarget: scrollTargetProp$1
  },
  setup(props4, { slots, attrs }) {
    let localScrollTarget;
    const rootRef = ref$1(null);
    const virtualScrollLength = computed(() => props4.itemsSize >= 0 && props4.itemsFn !== void 0 ? parseInt(props4.itemsSize, 10) : Array.isArray(props4.items) ? props4.items.length : 0);
    const {
      virtualScrollSliceRange,
      localResetVirtualScroll,
      padVirtualScroll,
      onVirtualScrollEvt
    } = useVirtualScroll$1({
      virtualScrollLength,
      getVirtualScrollTarget,
      getVirtualScrollEl
    });
    const virtualScrollScope = computed(() => {
      if (virtualScrollLength.value === 0) {
        return [];
      }
      const mapFn = (item, i22) => ({
        index: virtualScrollSliceRange.value.from + i22,
        item
      });
      return props4.itemsFn === void 0 ? props4.items.slice(virtualScrollSliceRange.value.from, virtualScrollSliceRange.value.to).map(mapFn) : props4.itemsFn(virtualScrollSliceRange.value.from, virtualScrollSliceRange.value.to - virtualScrollSliceRange.value.from).map(mapFn);
    });
    const classes = computed(
      () => "q-virtual-scroll q-virtual-scroll" + (props4.virtualScrollHorizontal === true ? "--horizontal" : "--vertical") + (props4.scrollTarget !== void 0 ? "" : " scroll")
    );
    const attributes = computed(() => props4.scrollTarget !== void 0 ? {} : { tabindex: 0 });
    watch(virtualScrollLength, () => {
      localResetVirtualScroll();
    });
    watch(() => props4.scrollTarget, () => {
      unconfigureScrollTarget();
      configureScrollTarget();
    });
    function getVirtualScrollEl() {
      return rootRef.value.$el || rootRef.value;
    }
    function getVirtualScrollTarget() {
      return localScrollTarget;
    }
    function configureScrollTarget() {
      localScrollTarget = getScrollTarget$1(getVirtualScrollEl(), props4.scrollTarget);
      localScrollTarget.addEventListener("scroll", onVirtualScrollEvt, listenOpts$1.passive);
    }
    function unconfigureScrollTarget() {
      if (localScrollTarget !== void 0) {
        localScrollTarget.removeEventListener("scroll", onVirtualScrollEvt, listenOpts$1.passive);
        localScrollTarget = void 0;
      }
    }
    function __getVirtualChildren() {
      let child = padVirtualScroll(
        props4.type === "list" ? "div" : "tbody",
        virtualScrollScope.value.map(slots.default)
      );
      if (slots.before !== void 0) {
        child = slots.before().concat(child);
      }
      return hMergeSlot$1(slots.after, child);
    }
    onBeforeMount(() => {
      localResetVirtualScroll();
    });
    onMounted(() => {
      configureScrollTarget();
    });
    onActivated(() => {
      configureScrollTarget();
    });
    onDeactivated(() => {
      unconfigureScrollTarget();
    });
    onBeforeUnmount(() => {
      unconfigureScrollTarget();
    });
    return () => {
      if (slots.default === void 0) {
        console.error("QVirtualScroll: default scoped slot is required for rendering");
        return;
      }
      return props4.type === "__qtable" ? get_table_middle_default$1(
        { ref: rootRef, class: "q-table__middle " + classes.value },
        __getVirtualChildren()
      ) : h(comps$1[props4.type], {
        ...attrs,
        ref: rootRef,
        class: [attrs.class, classes.value],
        ...attributes.value
      }, __getVirtualChildren);
    };
  }
});
function sortDate$1(a32, b22) {
  return new Date(a32) - new Date(b22);
}
var useTableSortProps$1 = {
  sortMethod: Function,
  binaryStateSort: Boolean,
  columnSortOrder: {
    type: String,
    validator: (v) => v === "ad" || v === "da",
    default: "ad"
  }
};
function useTableSort$1(props4, computedPagination, colList, setPagination) {
  const columnToSort = computed(() => {
    const { sortBy } = computedPagination.value;
    return sortBy ? colList.value.find((def) => def.name === sortBy) || null : null;
  });
  const computedSortMethod = computed(() => props4.sortMethod !== void 0 ? props4.sortMethod : (data, sortBy, descending) => {
    const col = colList.value.find((def) => def.name === sortBy);
    if (col === void 0 || col.field === void 0) {
      return data;
    }
    const dir = descending === true ? -1 : 1, val = typeof col.field === "function" ? (v) => col.field(v) : (v) => v[col.field];
    return data.sort((a32, b22) => {
      let A2 = val(a32), B3 = val(b22);
      if (col.rawSort !== void 0) {
        return col.rawSort(A2, B3, a32, b22) * dir;
      }
      if (A2 === null || A2 === void 0) {
        return -1 * dir;
      }
      if (B3 === null || B3 === void 0) {
        return 1 * dir;
      }
      if (col.sort !== void 0) {
        return col.sort(A2, B3, a32, b22) * dir;
      }
      if (isNumber$1(A2) === true && isNumber$1(B3) === true) {
        return (A2 - B3) * dir;
      }
      if (isDate$1(A2) === true && isDate$1(B3) === true) {
        return sortDate$1(A2, B3) * dir;
      }
      if (typeof A2 === "boolean" && typeof B3 === "boolean") {
        return (A2 - B3) * dir;
      }
      [A2, B3] = [A2, B3].map((s32) => (s32 + "").toLocaleString().toLowerCase());
      return A2 < B3 ? -1 * dir : A2 === B3 ? 0 : dir;
    });
  });
  function sort(col) {
    let sortOrder = props4.columnSortOrder;
    if (isObject$1(col) === true) {
      if (col.sortOrder) {
        sortOrder = col.sortOrder;
      }
      col = col.name;
    } else {
      const def = colList.value.find((def2) => def2.name === col);
      if (def !== void 0 && def.sortOrder) {
        sortOrder = def.sortOrder;
      }
    }
    let { sortBy, descending } = computedPagination.value;
    if (sortBy !== col) {
      sortBy = col;
      descending = sortOrder === "da";
    } else if (props4.binaryStateSort === true) {
      descending = !descending;
    } else if (descending === true) {
      if (sortOrder === "ad") {
        sortBy = null;
      } else {
        descending = false;
      }
    } else {
      if (sortOrder === "ad") {
        descending = true;
      } else {
        sortBy = null;
      }
    }
    setPagination({ sortBy, descending, page: 1 });
  }
  return {
    columnToSort,
    computedSortMethod,
    sort
  };
}
var useTableFilterProps$1 = {
  filter: [String, Object],
  filterMethod: Function
};
function useTableFilter$1(props4, setPagination) {
  const computedFilterMethod = computed(() => props4.filterMethod !== void 0 ? props4.filterMethod : (rows, terms, cols, cellValue) => {
    const lowerTerms = terms ? terms.toLowerCase() : "";
    return rows.filter(
      (row) => cols.some((col) => {
        const val = cellValue(col, row) + "";
        const haystack = val === "undefined" || val === "null" ? "" : val.toLowerCase();
        return haystack.indexOf(lowerTerms) !== -1;
      })
    );
  });
  watch(
    () => props4.filter,
    () => {
      nextTick(() => {
        setPagination({ page: 1 }, true);
      });
    },
    { deep: true }
  );
  return { computedFilterMethod };
}
function samePagination$1(oldPag, newPag) {
  for (const prop in newPag) {
    if (newPag[prop] !== oldPag[prop]) {
      return false;
    }
  }
  return true;
}
function fixPagination$1(p2) {
  if (p2.page < 1) {
    p2.page = 1;
  }
  if (p2.rowsPerPage !== void 0 && p2.rowsPerPage < 1) {
    p2.rowsPerPage = 0;
  }
  return p2;
}
var useTablePaginationProps$1 = {
  pagination: Object,
  rowsPerPageOptions: {
    type: Array,
    default: () => [5, 7, 10, 15, 20, 25, 50, 0]
  },
  "onUpdate:pagination": [Function, Array]
};
function useTablePaginationState$1(vm2, getCellValue) {
  const { props: props4, emit } = vm2;
  const innerPagination = ref$1(
    Object.assign({
      sortBy: null,
      descending: false,
      page: 1,
      rowsPerPage: props4.rowsPerPageOptions.length !== 0 ? props4.rowsPerPageOptions[0] : 5
    }, props4.pagination)
  );
  const computedPagination = computed(() => {
    const pag = props4["onUpdate:pagination"] !== void 0 ? { ...innerPagination.value, ...props4.pagination } : innerPagination.value;
    return fixPagination$1(pag);
  });
  const isServerSide = computed(() => computedPagination.value.rowsNumber !== void 0);
  function sendServerRequest(pagination) {
    requestServerInteraction({
      pagination,
      filter: props4.filter
    });
  }
  function requestServerInteraction(prop = {}) {
    nextTick(() => {
      emit("request", {
        pagination: prop.pagination || computedPagination.value,
        filter: prop.filter || props4.filter,
        getCellValue
      });
    });
  }
  function setPagination(val, forceServerRequest) {
    const newPagination = fixPagination$1({
      ...computedPagination.value,
      ...val
    });
    if (samePagination$1(computedPagination.value, newPagination) === true) {
      if (isServerSide.value === true && forceServerRequest === true) {
        sendServerRequest(newPagination);
      }
      return;
    }
    if (isServerSide.value === true) {
      sendServerRequest(newPagination);
      return;
    }
    if (props4.pagination !== void 0 && props4["onUpdate:pagination"] !== void 0) {
      emit("update:pagination", newPagination);
    } else {
      innerPagination.value = newPagination;
    }
  }
  return {
    innerPagination,
    computedPagination,
    isServerSide,
    requestServerInteraction,
    setPagination
  };
}
function useTablePagination$1(vm2, innerPagination, computedPagination, isServerSide, setPagination, filteredSortedRowsNumber) {
  const { props: props4, emit, proxy: { $q } } = vm2;
  const computedRowsNumber = computed(() => isServerSide.value === true ? computedPagination.value.rowsNumber || 0 : filteredSortedRowsNumber.value);
  const firstRowIndex = computed(() => {
    const { page, rowsPerPage } = computedPagination.value;
    return (page - 1) * rowsPerPage;
  });
  const lastRowIndex = computed(() => {
    const { page, rowsPerPage } = computedPagination.value;
    return page * rowsPerPage;
  });
  const isFirstPage = computed(() => computedPagination.value.page === 1);
  const pagesNumber = computed(() => computedPagination.value.rowsPerPage === 0 ? 1 : Math.max(
    1,
    Math.ceil(computedRowsNumber.value / computedPagination.value.rowsPerPage)
  ));
  const isLastPage = computed(() => lastRowIndex.value === 0 ? true : computedPagination.value.page >= pagesNumber.value);
  const computedRowsPerPageOptions = computed(() => {
    const opts = props4.rowsPerPageOptions.includes(innerPagination.value.rowsPerPage) ? props4.rowsPerPageOptions : [innerPagination.value.rowsPerPage].concat(props4.rowsPerPageOptions);
    return opts.map((count) => ({
      label: count === 0 ? $q.lang.table.allRows : "" + count,
      value: count
    }));
  });
  watch(pagesNumber, (lastPage2, oldLastPage) => {
    if (lastPage2 === oldLastPage) {
      return;
    }
    const currentPage = computedPagination.value.page;
    if (lastPage2 && !currentPage) {
      setPagination({ page: 1 });
    } else if (lastPage2 < currentPage) {
      setPagination({ page: lastPage2 });
    }
  });
  function firstPage() {
    setPagination({ page: 1 });
  }
  function prevPage() {
    const { page } = computedPagination.value;
    if (page > 1) {
      setPagination({ page: page - 1 });
    }
  }
  function nextPage() {
    const { page, rowsPerPage } = computedPagination.value;
    if (lastRowIndex.value > 0 && page * rowsPerPage < computedRowsNumber.value) {
      setPagination({ page: page + 1 });
    }
  }
  function lastPage() {
    setPagination({ page: pagesNumber.value });
  }
  if (props4["onUpdate:pagination"] !== void 0) {
    emit("update:pagination", { ...computedPagination.value });
  }
  return {
    firstRowIndex,
    lastRowIndex,
    isFirstPage,
    isLastPage,
    pagesNumber,
    computedRowsPerPageOptions,
    computedRowsNumber,
    firstPage,
    prevPage,
    nextPage,
    lastPage
  };
}
var useTableRowSelectionProps$1 = {
  selection: {
    type: String,
    default: "none",
    validator: (v) => ["single", "multiple", "none"].includes(v)
  },
  selected: {
    type: Array,
    default: () => []
  }
};
var useTableRowSelectionEmits$1 = ["update:selected", "selection"];
function useTableRowSelection$1(props4, emit, computedRows, getRowKey) {
  const selectedKeys = computed(() => {
    const keys2 = {};
    props4.selected.map(getRowKey.value).forEach((key) => {
      keys2[key] = true;
    });
    return keys2;
  });
  const hasSelectionMode = computed(() => {
    return props4.selection !== "none";
  });
  const singleSelection = computed(() => {
    return props4.selection === "single";
  });
  const multipleSelection = computed(() => {
    return props4.selection === "multiple";
  });
  const allRowsSelected = computed(
    () => computedRows.value.length !== 0 && computedRows.value.every(
      (row) => selectedKeys.value[getRowKey.value(row)] === true
    )
  );
  const someRowsSelected = computed(
    () => allRowsSelected.value !== true && computedRows.value.some((row) => selectedKeys.value[getRowKey.value(row)] === true)
  );
  const rowsSelectedNumber = computed(() => props4.selected.length);
  function isRowSelected(key) {
    return selectedKeys.value[key] === true;
  }
  function clearSelection2() {
    emit("update:selected", []);
  }
  function updateSelection(keys2, rows, added, evt) {
    emit("selection", { rows, added, keys: keys2, evt });
    const payload = singleSelection.value === true ? added === true ? rows : [] : added === true ? props4.selected.concat(rows) : props4.selected.filter(
      (row) => keys2.includes(getRowKey.value(row)) === false
    );
    emit("update:selected", payload);
  }
  return {
    hasSelectionMode,
    singleSelection,
    multipleSelection,
    allRowsSelected,
    someRowsSelected,
    rowsSelectedNumber,
    isRowSelected,
    clearSelection: clearSelection2,
    updateSelection
  };
}
function getVal$1(val) {
  return Array.isArray(val) ? val.slice() : [];
}
var useTableRowExpandProps$1 = {
  expanded: Array
  // v-model:expanded
};
var useTableRowExpandEmits$1 = ["update:expanded"];
function useTableRowExpand$1(props4, emit) {
  const innerExpanded = ref$1(getVal$1(props4.expanded));
  watch(() => props4.expanded, (val) => {
    innerExpanded.value = getVal$1(val);
  });
  function isRowExpanded(key) {
    return innerExpanded.value.includes(key);
  }
  function setExpanded(val) {
    if (props4.expanded !== void 0) {
      emit("update:expanded", val);
    } else {
      innerExpanded.value = val;
    }
  }
  function updateExpanded(key, add2) {
    const target2 = innerExpanded.value.slice();
    const index2 = target2.indexOf(key);
    if (add2 === true) {
      if (index2 === -1) {
        target2.push(key);
        setExpanded(target2);
      }
    } else if (index2 !== -1) {
      target2.splice(index2, 1);
      setExpanded(target2);
    }
  }
  return {
    isRowExpanded,
    setExpanded,
    updateExpanded
  };
}
var useTableColumnSelectionProps$1 = {
  visibleColumns: Array
};
function useTableColumnSelection$1(props4, computedPagination, hasSelectionMode) {
  const colList = computed(() => {
    if (props4.columns !== void 0) {
      return props4.columns;
    }
    const row = props4.rows[0];
    return row !== void 0 ? Object.keys(row).map((name2) => ({
      name: name2,
      label: name2.toUpperCase(),
      field: name2,
      align: isNumber$1(row[name2]) ? "right" : "left",
      sortable: true
    })) : [];
  });
  const computedCols = computed(() => {
    const { sortBy, descending } = computedPagination.value;
    const cols = props4.visibleColumns !== void 0 ? colList.value.filter((col) => col.required === true || props4.visibleColumns.includes(col.name) === true) : colList.value;
    return cols.map((col) => {
      const align = col.align || "right";
      const alignClass = `text-${align}`;
      return {
        ...col,
        align,
        __iconClass: `q-table__sort-icon q-table__sort-icon--${align}`,
        __thClass: alignClass + (col.headerClasses !== void 0 ? " " + col.headerClasses : "") + (col.sortable === true ? " sortable" : "") + (col.name === sortBy ? ` sorted ${descending === true ? "sort-desc" : ""}` : ""),
        __tdStyle: col.style !== void 0 ? typeof col.style !== "function" ? () => col.style : col.style : () => null,
        __tdClass: col.classes !== void 0 ? typeof col.classes !== "function" ? () => alignClass + " " + col.classes : (row) => alignClass + " " + col.classes(row) : () => alignClass
      };
    });
  });
  const computedColsMap = computed(() => {
    const names2 = {};
    computedCols.value.forEach((col) => {
      names2[col.name] = col;
    });
    return names2;
  });
  const computedColspan = computed(() => {
    return props4.tableColspan !== void 0 ? props4.tableColspan : computedCols.value.length + (hasSelectionMode.value === true ? 1 : 0);
  });
  return {
    colList,
    computedCols,
    computedColsMap,
    computedColspan
  };
}
var bottomClass$1 = "q-table__bottom row items-center";
var virtScrollPassthroughProps$1 = {};
commonVirtScrollPropsList$1.forEach((p2) => {
  virtScrollPassthroughProps$1[p2] = {};
});
var QTable_default = createComponent$1({
  name: "QTable",
  props: {
    rows: {
      type: Array,
      required: true
    },
    rowKey: {
      type: [String, Function],
      default: "id"
    },
    columns: Array,
    loading: Boolean,
    iconFirstPage: String,
    iconPrevPage: String,
    iconNextPage: String,
    iconLastPage: String,
    title: String,
    hideHeader: Boolean,
    grid: Boolean,
    gridHeader: Boolean,
    dense: Boolean,
    flat: Boolean,
    bordered: Boolean,
    square: Boolean,
    separator: {
      type: String,
      default: "horizontal",
      validator: (v) => ["horizontal", "vertical", "cell", "none"].includes(v)
    },
    wrapCells: Boolean,
    virtualScroll: Boolean,
    virtualScrollTarget: {},
    ...virtScrollPassthroughProps$1,
    noDataLabel: String,
    noResultsLabel: String,
    loadingLabel: String,
    selectedRowsLabel: Function,
    rowsPerPageLabel: String,
    paginationLabel: Function,
    color: {
      type: String,
      default: "grey-8"
    },
    titleClass: [String, Array, Object],
    tableStyle: [String, Array, Object],
    tableClass: [String, Array, Object],
    tableHeaderStyle: [String, Array, Object],
    tableHeaderClass: [String, Array, Object],
    cardContainerClass: [String, Array, Object],
    cardContainerStyle: [String, Array, Object],
    cardStyle: [String, Array, Object],
    cardClass: [String, Array, Object],
    hideBottom: Boolean,
    hideSelectedBanner: Boolean,
    hideNoData: Boolean,
    hidePagination: Boolean,
    onRowClick: Function,
    onRowDblclick: Function,
    onRowContextmenu: Function,
    ...useDarkProps$1,
    ...useFullscreenProps$1,
    ...useTableColumnSelectionProps$1,
    ...useTableFilterProps$1,
    ...useTablePaginationProps$1,
    ...useTableRowExpandProps$1,
    ...useTableRowSelectionProps$1,
    ...useTableSortProps$1
  },
  emits: [
    "request",
    "virtualScroll",
    ...useFullscreenEmits$1,
    ...useTableRowExpandEmits$1,
    ...useTableRowSelectionEmits$1
  ],
  setup(props4, { slots, emit }) {
    const vm2 = getCurrentInstance();
    const { proxy: { $q } } = vm2;
    const isDark = use_dark_default$1(props4, $q);
    const { inFullscreen, toggleFullscreen } = use_fullscreen_default$1();
    const getRowKey = computed(() => typeof props4.rowKey === "function" ? props4.rowKey : (row) => row[props4.rowKey]);
    const rootRef = ref$1(null);
    const virtScrollRef = ref$1(null);
    const hasVirtScroll = computed(() => props4.grid !== true && props4.virtualScroll === true);
    const cardDefaultClass = computed(
      () => " q-table__card" + (isDark.value === true ? " q-table__card--dark q-dark" : "") + (props4.square === true ? " q-table--square" : "") + (props4.flat === true ? " q-table--flat" : "") + (props4.bordered === true ? " q-table--bordered" : "")
    );
    const __containerClass = computed(
      () => `q-table__container q-table--${props4.separator}-separator column no-wrap` + (props4.grid === true ? " q-table--grid" : cardDefaultClass.value) + (isDark.value === true ? " q-table--dark" : "") + (props4.dense === true ? " q-table--dense" : "") + (props4.wrapCells === false ? " q-table--no-wrap" : "") + (inFullscreen.value === true ? " fullscreen scroll" : "")
    );
    const containerClass = computed(
      () => __containerClass.value + (props4.loading === true ? " q-table--loading" : "")
    );
    watch(
      () => props4.tableStyle + props4.tableClass + props4.tableHeaderStyle + props4.tableHeaderClass + __containerClass.value,
      () => {
        hasVirtScroll.value === true && virtScrollRef.value !== null && virtScrollRef.value.reset();
      }
    );
    const {
      innerPagination,
      computedPagination,
      isServerSide,
      requestServerInteraction,
      setPagination
    } = useTablePaginationState$1(vm2, getCellValue);
    const { computedFilterMethod } = useTableFilter$1(props4, setPagination);
    const { isRowExpanded, setExpanded, updateExpanded } = useTableRowExpand$1(props4, emit);
    const filteredSortedRows = computed(() => {
      let rows = props4.rows;
      if (isServerSide.value === true || rows.length === 0) {
        return rows;
      }
      const { sortBy, descending } = computedPagination.value;
      if (props4.filter) {
        rows = computedFilterMethod.value(rows, props4.filter, computedCols.value, getCellValue);
      }
      if (columnToSort.value !== null) {
        rows = computedSortMethod.value(
          props4.rows === rows ? rows.slice() : rows,
          sortBy,
          descending
        );
      }
      return rows;
    });
    const filteredSortedRowsNumber = computed(() => filteredSortedRows.value.length);
    const computedRows = computed(() => {
      let rows = filteredSortedRows.value;
      if (isServerSide.value === true) {
        return rows;
      }
      const { rowsPerPage } = computedPagination.value;
      if (rowsPerPage !== 0) {
        if (firstRowIndex.value === 0 && props4.rows !== rows) {
          if (rows.length > lastRowIndex.value) {
            rows = rows.slice(0, lastRowIndex.value);
          }
        } else {
          rows = rows.slice(firstRowIndex.value, lastRowIndex.value);
        }
      }
      return rows;
    });
    const {
      hasSelectionMode,
      singleSelection,
      multipleSelection,
      allRowsSelected,
      someRowsSelected,
      rowsSelectedNumber,
      isRowSelected,
      clearSelection: clearSelection2,
      updateSelection
    } = useTableRowSelection$1(props4, emit, computedRows, getRowKey);
    const { colList, computedCols, computedColsMap, computedColspan } = useTableColumnSelection$1(props4, computedPagination, hasSelectionMode);
    const { columnToSort, computedSortMethod, sort } = useTableSort$1(props4, computedPagination, colList, setPagination);
    const {
      firstRowIndex,
      lastRowIndex,
      isFirstPage,
      isLastPage,
      pagesNumber,
      computedRowsPerPageOptions,
      computedRowsNumber,
      firstPage,
      prevPage,
      nextPage,
      lastPage
    } = useTablePagination$1(vm2, innerPagination, computedPagination, isServerSide, setPagination, filteredSortedRowsNumber);
    const nothingToDisplay = computed(() => computedRows.value.length === 0);
    const virtProps = computed(() => {
      const acc = {};
      commonVirtScrollPropsList$1.forEach((p2) => {
        acc[p2] = props4[p2];
      });
      if (acc.virtualScrollItemSize === void 0) {
        acc.virtualScrollItemSize = props4.dense === true ? 28 : 48;
      }
      return acc;
    });
    function resetVirtualScroll() {
      hasVirtScroll.value === true && virtScrollRef.value.reset();
    }
    function getBody() {
      if (props4.grid === true) {
        return getGridBody();
      }
      const header = props4.hideHeader !== true ? getTHead : null;
      if (hasVirtScroll.value === true) {
        const topRow = slots["top-row"];
        const bottomRow = slots["bottom-row"];
        const virtSlots = {
          default: (props5) => getTBodyTR(props5.item, slots.body, props5.index)
        };
        if (topRow !== void 0) {
          const topContent = h("tbody", topRow({ cols: computedCols.value }));
          virtSlots.before = header === null ? () => topContent : () => [header()].concat(topContent);
        } else if (header !== null) {
          virtSlots.before = header;
        }
        if (bottomRow !== void 0) {
          virtSlots.after = () => h("tbody", bottomRow({ cols: computedCols.value }));
        }
        return h(QVirtualScroll_default$1, {
          ref: virtScrollRef,
          class: props4.tableClass,
          style: props4.tableStyle,
          ...virtProps.value,
          scrollTarget: props4.virtualScrollTarget,
          items: computedRows.value,
          type: "__qtable",
          tableColspan: computedColspan.value,
          onVirtualScroll: onVScroll
        }, virtSlots);
      }
      const child = [
        getTBody()
      ];
      if (header !== null) {
        child.unshift(header());
      }
      return get_table_middle_default$1({
        class: ["q-table__middle scroll", props4.tableClass],
        style: props4.tableStyle
      }, child);
    }
    function scrollTo(toIndex, edge) {
      if (virtScrollRef.value !== null) {
        virtScrollRef.value.scrollTo(toIndex, edge);
        return;
      }
      toIndex = parseInt(toIndex, 10);
      const rowEl = rootRef.value.querySelector(`tbody tr:nth-of-type(${toIndex + 1})`);
      if (rowEl !== null) {
        const scrollTarget = rootRef.value.querySelector(".q-table__middle.scroll");
        const offsetTop = rowEl.offsetTop - props4.virtualScrollStickySizeStart;
        const direction = offsetTop < scrollTarget.scrollTop ? "decrease" : "increase";
        scrollTarget.scrollTop = offsetTop;
        emit("virtualScroll", {
          index: toIndex,
          from: 0,
          to: innerPagination.value.rowsPerPage - 1,
          direction
        });
      }
    }
    function onVScroll(info) {
      emit("virtualScroll", info);
    }
    function getProgress() {
      return [
        h(QLinearProgress_default$1, {
          class: "q-table__linear-progress",
          color: props4.color,
          dark: isDark.value,
          indeterminate: true,
          trackColor: "transparent"
        })
      ];
    }
    function getTBodyTR(row, bodySlot, pageIndex) {
      const key = getRowKey.value(row), selected = isRowSelected(key);
      if (bodySlot !== void 0) {
        return bodySlot(
          getBodyScope({
            key,
            row,
            pageIndex,
            __trClass: selected ? "selected" : ""
          })
        );
      }
      const bodyCell = slots["body-cell"], child = computedCols.value.map((col) => {
        const bodyCellCol = slots[`body-cell-${col.name}`], slot = bodyCellCol !== void 0 ? bodyCellCol : bodyCell;
        return slot !== void 0 ? slot(getBodyCellScope({ key, row, pageIndex, col })) : h("td", {
          class: col.__tdClass(row),
          style: col.__tdStyle(row)
        }, getCellValue(col, row));
      });
      if (hasSelectionMode.value === true) {
        const slot = slots["body-selection"];
        const content = slot !== void 0 ? slot(getBodySelectionScope({ key, row, pageIndex })) : [
          h(QCheckbox_default$1, {
            modelValue: selected,
            color: props4.color,
            dark: isDark.value,
            dense: props4.dense,
            "onUpdate:modelValue": (adding, evt) => {
              updateSelection([key], [row], adding, evt);
            }
          })
        ];
        child.unshift(
          h("td", { class: "q-table--col-auto-width" }, content)
        );
      }
      const data = { key, class: { selected } };
      if (props4.onRowClick !== void 0) {
        data.class["cursor-pointer"] = true;
        data.onClick = (evt) => {
          emit("rowClick", evt, row, pageIndex);
        };
      }
      if (props4.onRowDblclick !== void 0) {
        data.class["cursor-pointer"] = true;
        data.onDblclick = (evt) => {
          emit("rowDblclick", evt, row, pageIndex);
        };
      }
      if (props4.onRowContextmenu !== void 0) {
        data.class["cursor-pointer"] = true;
        data.onContextmenu = (evt) => {
          emit("rowContextmenu", evt, row, pageIndex);
        };
      }
      return h("tr", data, child);
    }
    function getTBody() {
      const body = slots.body, topRow = slots["top-row"], bottomRow = slots["bottom-row"];
      let child = computedRows.value.map(
        (row, pageIndex) => getTBodyTR(row, body, pageIndex)
      );
      if (topRow !== void 0) {
        child = topRow({ cols: computedCols.value }).concat(child);
      }
      if (bottomRow !== void 0) {
        child = child.concat(bottomRow({ cols: computedCols.value }));
      }
      return h("tbody", child);
    }
    function getBodyScope(data) {
      injectBodyCommonScope(data);
      data.cols = data.cols.map(
        (col) => injectProp$1({ ...col }, "value", () => getCellValue(col, data.row))
      );
      return data;
    }
    function getBodyCellScope(data) {
      injectBodyCommonScope(data);
      injectProp$1(data, "value", () => getCellValue(data.col, data.row));
      return data;
    }
    function getBodySelectionScope(data) {
      injectBodyCommonScope(data);
      return data;
    }
    function injectBodyCommonScope(data) {
      Object.assign(data, {
        cols: computedCols.value,
        colsMap: computedColsMap.value,
        sort,
        rowIndex: firstRowIndex.value + data.pageIndex,
        color: props4.color,
        dark: isDark.value,
        dense: props4.dense
      });
      hasSelectionMode.value === true && injectProp$1(
        data,
        "selected",
        () => isRowSelected(data.key),
        (adding, evt) => {
          updateSelection([data.key], [data.row], adding, evt);
        }
      );
      injectProp$1(
        data,
        "expand",
        () => isRowExpanded(data.key),
        (adding) => {
          updateExpanded(data.key, adding);
        }
      );
    }
    function getCellValue(col, row) {
      const val = typeof col.field === "function" ? col.field(row) : row[col.field];
      return col.format !== void 0 ? col.format(val, row) : val;
    }
    const marginalsScope = computed(() => ({
      pagination: computedPagination.value,
      pagesNumber: pagesNumber.value,
      isFirstPage: isFirstPage.value,
      isLastPage: isLastPage.value,
      firstPage,
      prevPage,
      nextPage,
      lastPage,
      inFullscreen: inFullscreen.value,
      toggleFullscreen
    }));
    function getTopDiv() {
      const top = slots.top, topLeft = slots["top-left"], topRight = slots["top-right"], topSelection = slots["top-selection"], hasSelection = hasSelectionMode.value === true && topSelection !== void 0 && rowsSelectedNumber.value > 0, topClass = "q-table__top relative-position row items-center";
      if (top !== void 0) {
        return h("div", { class: topClass }, [top(marginalsScope.value)]);
      }
      let child;
      if (hasSelection === true) {
        child = topSelection(marginalsScope.value).slice();
      } else {
        child = [];
        if (topLeft !== void 0) {
          child.push(
            h("div", { class: "q-table__control" }, [
              topLeft(marginalsScope.value)
            ])
          );
        } else if (props4.title) {
          child.push(
            h("div", { class: "q-table__control" }, [
              h("div", {
                class: ["q-table__title", props4.titleClass]
              }, props4.title)
            ])
          );
        }
      }
      if (topRight !== void 0) {
        child.push(
          h("div", { class: "q-table__separator col" })
        );
        child.push(
          h("div", { class: "q-table__control" }, [
            topRight(marginalsScope.value)
          ])
        );
      }
      if (child.length === 0) {
        return;
      }
      return h("div", { class: topClass }, child);
    }
    const headerSelectedValue = computed(() => someRowsSelected.value === true ? null : allRowsSelected.value);
    function getTHead() {
      const child = getTHeadTR();
      if (props4.loading === true && slots.loading === void 0) {
        child.push(
          h("tr", { class: "q-table__progress" }, [
            h("th", {
              class: "relative-position",
              colspan: computedColspan.value
            }, getProgress())
          ])
        );
      }
      return h("thead", child);
    }
    function getTHeadTR() {
      const header = slots.header, headerCell = slots["header-cell"];
      if (header !== void 0) {
        return header(
          getHeaderScope({ header: true })
        ).slice();
      }
      const child = computedCols.value.map((col) => {
        const headerCellCol = slots[`header-cell-${col.name}`], slot = headerCellCol !== void 0 ? headerCellCol : headerCell, props5 = getHeaderScope({ col });
        return slot !== void 0 ? slot(props5) : h(QTh_default$1, {
          key: col.name,
          props: props5
        }, () => col.label);
      });
      if (singleSelection.value === true && props4.grid !== true) {
        child.unshift(
          h("th", { class: "q-table--col-auto-width" }, " ")
        );
      } else if (multipleSelection.value === true) {
        const slot = slots["header-selection"];
        const content = slot !== void 0 ? slot(getHeaderScope({})) : [
          h(QCheckbox_default$1, {
            color: props4.color,
            modelValue: headerSelectedValue.value,
            dark: isDark.value,
            dense: props4.dense,
            "onUpdate:modelValue": onMultipleSelectionSet
          })
        ];
        child.unshift(
          h("th", { class: "q-table--col-auto-width" }, content)
        );
      }
      return [
        h("tr", {
          class: props4.tableHeaderClass,
          style: props4.tableHeaderStyle
        }, child)
      ];
    }
    function getHeaderScope(data) {
      Object.assign(data, {
        cols: computedCols.value,
        sort,
        colsMap: computedColsMap.value,
        color: props4.color,
        dark: isDark.value,
        dense: props4.dense
      });
      if (multipleSelection.value === true) {
        injectProp$1(
          data,
          "selected",
          () => headerSelectedValue.value,
          onMultipleSelectionSet
        );
      }
      return data;
    }
    function onMultipleSelectionSet(val) {
      if (someRowsSelected.value === true) {
        val = false;
      }
      updateSelection(
        computedRows.value.map(getRowKey.value),
        computedRows.value,
        val
      );
    }
    const navIcon = computed(() => {
      const ico = [
        props4.iconFirstPage || $q.iconSet.table.firstPage,
        props4.iconPrevPage || $q.iconSet.table.prevPage,
        props4.iconNextPage || $q.iconSet.table.nextPage,
        props4.iconLastPage || $q.iconSet.table.lastPage
      ];
      return $q.lang.rtl === true ? ico.reverse() : ico;
    });
    function getBottomDiv() {
      if (props4.hideBottom === true) {
        return;
      }
      if (nothingToDisplay.value === true) {
        if (props4.hideNoData === true) {
          return;
        }
        const message = props4.loading === true ? props4.loadingLabel || $q.lang.table.loading : props4.filter ? props4.noResultsLabel || $q.lang.table.noResults : props4.noDataLabel || $q.lang.table.noData;
        const noData = slots["no-data"];
        const children = noData !== void 0 ? [noData({ message, icon: $q.iconSet.table.warning, filter: props4.filter })] : [
          h(QIcon_default$1, {
            class: "q-table__bottom-nodata-icon",
            name: $q.iconSet.table.warning
          }),
          message
        ];
        return h("div", { class: bottomClass$1 + " q-table__bottom--nodata" }, children);
      }
      const bottom = slots.bottom;
      if (bottom !== void 0) {
        return h("div", { class: bottomClass$1 }, [bottom(marginalsScope.value)]);
      }
      const child = props4.hideSelectedBanner !== true && hasSelectionMode.value === true && rowsSelectedNumber.value > 0 ? [
        h("div", { class: "q-table__control" }, [
          h("div", [
            (props4.selectedRowsLabel || $q.lang.table.selectedRecords)(rowsSelectedNumber.value)
          ])
        ])
      ] : [];
      if (props4.hidePagination !== true) {
        return h("div", {
          class: bottomClass$1 + " justify-end"
        }, getPaginationDiv(child));
      }
      if (child.length !== 0) {
        return h("div", { class: bottomClass$1 }, child);
      }
    }
    function onPagSelection(pag) {
      setPagination({
        page: 1,
        rowsPerPage: pag.value
      });
    }
    function getPaginationDiv(child) {
      let control;
      const { rowsPerPage } = computedPagination.value, paginationLabel = props4.paginationLabel || $q.lang.table.pagination, paginationSlot = slots.pagination, hasOpts = props4.rowsPerPageOptions.length > 1;
      child.push(
        h("div", { class: "q-table__separator col" })
      );
      if (hasOpts === true) {
        child.push(
          h("div", { class: "q-table__control" }, [
            h("span", { class: "q-table__bottom-item" }, [
              props4.rowsPerPageLabel || $q.lang.table.recordsPerPage
            ]),
            h(QSelect_default$1, {
              class: "q-table__select inline q-table__bottom-item",
              color: props4.color,
              modelValue: rowsPerPage,
              options: computedRowsPerPageOptions.value,
              displayValue: rowsPerPage === 0 ? $q.lang.table.allRows : rowsPerPage,
              dark: isDark.value,
              borderless: true,
              dense: true,
              optionsDense: true,
              optionsCover: true,
              "onUpdate:modelValue": onPagSelection
            })
          ])
        );
      }
      if (paginationSlot !== void 0) {
        control = paginationSlot(marginalsScope.value);
      } else {
        control = [
          h("span", rowsPerPage !== 0 ? { class: "q-table__bottom-item" } : {}, [
            rowsPerPage ? paginationLabel(firstRowIndex.value + 1, Math.min(lastRowIndex.value, computedRowsNumber.value), computedRowsNumber.value) : paginationLabel(1, filteredSortedRowsNumber.value, computedRowsNumber.value)
          ])
        ];
        if (rowsPerPage !== 0 && pagesNumber.value > 1) {
          const btnProps = {
            color: props4.color,
            round: true,
            dense: true,
            flat: true
          };
          if (props4.dense === true) {
            btnProps.size = "sm";
          }
          pagesNumber.value > 2 && control.push(
            h(QBtn_default$1, {
              key: "pgFirst",
              ...btnProps,
              icon: navIcon.value[0],
              disable: isFirstPage.value,
              onClick: firstPage
            })
          );
          control.push(
            h(QBtn_default$1, {
              key: "pgPrev",
              ...btnProps,
              icon: navIcon.value[1],
              disable: isFirstPage.value,
              onClick: prevPage
            }),
            h(QBtn_default$1, {
              key: "pgNext",
              ...btnProps,
              icon: navIcon.value[2],
              disable: isLastPage.value,
              onClick: nextPage
            })
          );
          pagesNumber.value > 2 && control.push(
            h(QBtn_default$1, {
              key: "pgLast",
              ...btnProps,
              icon: navIcon.value[3],
              disable: isLastPage.value,
              onClick: lastPage
            })
          );
        }
      }
      child.push(
        h("div", { class: "q-table__control" }, control)
      );
      return child;
    }
    function getGridHeader() {
      const child = props4.gridHeader === true ? [
        h("table", { class: "q-table" }, [
          getTHead()
        ])
      ] : props4.loading === true && slots.loading === void 0 ? getProgress() : void 0;
      return h("div", { class: "q-table__middle" }, child);
    }
    function getGridBody() {
      const item = slots.item !== void 0 ? slots.item : (scope) => {
        const child = scope.cols.map(
          (col) => h("div", { class: "q-table__grid-item-row" }, [
            h("div", { class: "q-table__grid-item-title" }, [col.label]),
            h("div", { class: "q-table__grid-item-value" }, [col.value])
          ])
        );
        if (hasSelectionMode.value === true) {
          const slot = slots["body-selection"];
          const content = slot !== void 0 ? slot(scope) : [
            h(QCheckbox_default$1, {
              modelValue: scope.selected,
              color: props4.color,
              dark: isDark.value,
              dense: props4.dense,
              "onUpdate:modelValue": (adding, evt) => {
                updateSelection([scope.key], [scope.row], adding, evt);
              }
            })
          ];
          child.unshift(
            h("div", { class: "q-table__grid-item-row" }, content),
            h(QSeparator_default$1, { dark: isDark.value })
          );
        }
        const data = {
          class: [
            "q-table__grid-item-card" + cardDefaultClass.value,
            props4.cardClass
          ],
          style: props4.cardStyle
        };
        if (props4.onRowClick !== void 0 || props4.onRowDblclick !== void 0) {
          data.class[0] += " cursor-pointer";
          if (props4.onRowClick !== void 0) {
            data.onClick = (evt) => {
              emit("RowClick", evt, scope.row, scope.pageIndex);
            };
          }
          if (props4.onRowDblclick !== void 0) {
            data.onDblclick = (evt) => {
              emit("RowDblclick", evt, scope.row, scope.pageIndex);
            };
          }
        }
        return h("div", {
          class: "q-table__grid-item col-xs-12 col-sm-6 col-md-4 col-lg-3" + (scope.selected === true ? " q-table__grid-item--selected" : "")
        }, [
          h("div", data, child)
        ]);
      };
      return h("div", {
        class: [
          "q-table__grid-content row",
          props4.cardContainerClass
        ],
        style: props4.cardContainerStyle
      }, computedRows.value.map((row, pageIndex) => {
        return item(getBodyScope({
          key: getRowKey.value(row),
          row,
          pageIndex
        }));
      }));
    }
    Object.assign(vm2.proxy, {
      requestServerInteraction,
      setPagination,
      firstPage,
      prevPage,
      nextPage,
      lastPage,
      isRowSelected,
      clearSelection: clearSelection2,
      isRowExpanded,
      setExpanded,
      sort,
      resetVirtualScroll,
      scrollTo,
      getCellValue
    });
    injectMultipleProps$1(vm2.proxy, {
      filteredSortedRows: () => filteredSortedRows.value,
      computedRows: () => computedRows.value,
      computedRowsNumber: () => computedRowsNumber.value
    });
    return () => {
      const child = [getTopDiv()];
      const data = { ref: rootRef, class: containerClass.value };
      if (props4.grid === true) {
        child.push(getGridHeader());
      } else {
        Object.assign(data, {
          class: [data.class, props4.cardClass],
          style: props4.cardStyle
        });
      }
      child.push(
        getBody(),
        getBottomDiv()
      );
      if (props4.loading === true && slots.loading !== void 0) {
        child.push(
          slots.loading()
        );
      }
      return h("div", data, child);
    };
  }
});
var QTr_default = createComponent$1({
  name: "QTr",
  props: {
    props: Object,
    noHover: Boolean
  },
  setup(props4, { slots }) {
    const classes = computed(
      () => "q-tr" + (props4.props === void 0 || props4.props.header === true ? "" : " " + props4.props.__trClass) + (props4.noHover === true ? " q-tr--no-hover" : "")
    );
    return () => h("tr", { class: classes.value }, hSlot$1(slots.default));
  }
});
var QTd_default = createComponent$1({
  name: "QTd",
  props: {
    props: Object,
    autoWidth: Boolean,
    noHover: Boolean
  },
  setup(props4, { slots }) {
    const vm2 = getCurrentInstance();
    const classes = computed(
      () => "q-td" + (props4.autoWidth === true ? " q-table--col-auto-width" : "") + (props4.noHover === true ? " q-td--no-hover" : "") + " "
    );
    return () => {
      if (props4.props === void 0) {
        return h("td", { class: classes.value }, hSlot$1(slots.default));
      }
      const name2 = vm2.vnode.key;
      const col = (props4.props.colsMap !== void 0 ? props4.props.colsMap[name2] : null) || props4.props.col;
      if (col === void 0) return;
      const { row } = props4.props;
      return h("td", {
        class: classes.value + col.__tdClass(row),
        style: col.__tdStyle(row)
      }, hSlot$1(slots.default));
    };
  }
});
var QRouteTab_default = createComponent$1({
  name: "QRouteTab",
  props: {
    ...useRouterLinkProps$1,
    ...useTabProps$1
  },
  emits: useTabEmits$1,
  setup(props4, { slots, emit }) {
    const routeData = use_router_link_default$1({
      useDisableForRouterLinkProps: false
    });
    const { renderTab, $tabs } = use_tab_default$1(
      props4,
      slots,
      emit,
      {
        exact: computed(() => props4.exact),
        ...routeData
      }
    );
    watch(
      () => `${props4.name} | ${props4.exact} | ${(routeData.resolvedLink.value || {}).href}`,
      $tabs.verifyRouteModel
    );
    return () => renderTab(routeData.linkTag.value, routeData.linkAttrs.value);
  }
});
function getViewByModel$1(model, withSeconds) {
  if (model.hour !== null) {
    if (model.minute === null) {
      return "minute";
    }
  }
  return "hour";
}
function getCurrentTime$1() {
  const d32 = /* @__PURE__ */ new Date();
  return {
    hour: d32.getHours(),
    minute: d32.getMinutes(),
    second: d32.getSeconds(),
    millisecond: d32.getMilliseconds()
  };
}
createComponent$1({
  name: "QTime",
  props: {
    ...useDarkProps$1,
    ...useFormProps$1,
    ...useDatetimeProps$1,
    modelValue: {
      required: true,
      validator: (val) => typeof val === "string" || val === null
    },
    mask: {
      ...useDatetimeProps$1.mask,
      default: null
    },
    format24h: {
      type: Boolean,
      default: null
    },
    defaultDate: {
      type: String,
      validator: (v) => /^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(v)
    },
    options: Function,
    hourOptions: Array,
    minuteOptions: Array,
    secondOptions: Array,
    withSeconds: Boolean,
    nowBtn: Boolean
  },
  emits: useDatetimeEmits$1,
  setup(props4, { slots, emit }) {
    const vm2 = getCurrentInstance();
    const { $q } = vm2.proxy;
    const isDark = use_dark_default$1(props4, $q);
    const { tabindex, headerClass, getLocale: getLocale2, getCurrentDate } = use_datetime_default$1(props4, $q);
    const formAttrs = useFormAttrs$1(props4);
    const injectFormInput = useFormInject$1(formAttrs);
    let draggingClockRect, dragCache;
    const clockRef = ref$1(null);
    const mask = computed(() => getMask());
    const locale2 = computed(() => getLocale2());
    const defaultDateModel = computed(() => getDefaultDateModel());
    const model = __splitDate$1(
      props4.modelValue,
      mask.value,
      // initial mask
      locale2.value,
      // initial locale
      props4.calendar,
      defaultDateModel.value
    );
    const view = ref$1(getViewByModel$1(model));
    const innerModel = ref$1(model);
    const isAM = ref$1(model.hour === null || model.hour < 12);
    const classes = computed(
      () => `q-time q-time--${props4.landscape === true ? "landscape" : "portrait"}` + (isDark.value === true ? " q-time--dark q-dark" : "") + (props4.disable === true ? " disabled" : props4.readonly === true ? " q-time--readonly" : "") + (props4.bordered === true ? " q-time--bordered" : "") + (props4.square === true ? " q-time--square no-border-radius" : "") + (props4.flat === true ? " q-time--flat no-shadow" : "")
    );
    const stringModel = computed(() => {
      const time = innerModel.value;
      return {
        hour: time.hour === null ? "--" : computedFormat24h.value === true ? pad$1(time.hour) : String(
          isAM.value === true ? time.hour === 0 ? 12 : time.hour : time.hour > 12 ? time.hour - 12 : time.hour
        ),
        minute: time.minute === null ? "--" : pad$1(time.minute),
        second: time.second === null ? "--" : pad$1(time.second)
      };
    });
    const computedFormat24h = computed(() => props4.format24h !== null ? props4.format24h : $q.lang.date.format24h);
    const pointerStyle = computed(() => {
      const forHour = view.value === "hour", divider = forHour === true ? 12 : 60, amount = innerModel.value[view.value], degrees = Math.round(amount * (360 / divider)) - 180;
      let transform = `rotate(${degrees}deg) translateX(-50%)`;
      if (forHour === true && computedFormat24h.value === true && innerModel.value.hour >= 12) {
        transform += " scale(.7)";
      }
      return { transform };
    });
    const minLink = computed(() => innerModel.value.hour !== null);
    const secLink = computed(() => minLink.value === true && innerModel.value.minute !== null);
    const hourInSelection = computed(() => props4.hourOptions !== void 0 ? (val) => props4.hourOptions.includes(val) : props4.options !== void 0 ? (val) => props4.options(val, null, null) : null);
    const minuteInSelection = computed(() => props4.minuteOptions !== void 0 ? (val) => props4.minuteOptions.includes(val) : props4.options !== void 0 ? (val) => props4.options(innerModel.value.hour, val, null) : null);
    const secondInSelection = computed(() => props4.secondOptions !== void 0 ? (val) => props4.secondOptions.includes(val) : props4.options !== void 0 ? (val) => props4.options(innerModel.value.hour, innerModel.value.minute, val) : null);
    const validHours = computed(() => {
      if (hourInSelection.value === null) {
        return null;
      }
      const am = getValidValues(0, 11, hourInSelection.value);
      const pm = getValidValues(12, 11, hourInSelection.value);
      return { am, pm, values: am.values.concat(pm.values) };
    });
    const validMinutes = computed(() => minuteInSelection.value !== null ? getValidValues(0, 59, minuteInSelection.value) : null);
    const validSeconds = computed(() => secondInSelection.value !== null ? getValidValues(0, 59, secondInSelection.value) : null);
    const viewValidOptions = computed(() => {
      switch (view.value) {
        case "hour":
          return validHours.value;
        case "minute":
          return validMinutes.value;
        case "second":
          return validSeconds.value;
      }
    });
    const positions2 = computed(() => {
      let start, end, offset2 = 0, step = 1;
      const values = viewValidOptions.value !== null ? viewValidOptions.value.values : void 0;
      if (view.value === "hour") {
        if (computedFormat24h.value === true) {
          start = 0;
          end = 23;
        } else {
          start = 0;
          end = 11;
          if (isAM.value === false) {
            offset2 = 12;
          }
        }
      } else {
        start = 0;
        end = 55;
        step = 5;
      }
      const pos = [];
      for (let val = start, index2 = start; val <= end; val += step, index2++) {
        const actualVal = val + offset2, disable = values !== void 0 && values.includes(actualVal) === false, label = view.value === "hour" && val === 0 ? computedFormat24h.value === true ? "00" : "12" : val;
        pos.push({ val: actualVal, index: index2, disable, label });
      }
      return pos;
    });
    const clockDirectives = computed(() => {
      return [[
        TouchPan_default$1,
        onPan,
        void 0,
        {
          stop: true,
          prevent: true,
          mouse: true
        }
      ]];
    });
    watch(() => props4.modelValue, (v) => {
      const model2 = __splitDate$1(
        v,
        mask.value,
        locale2.value,
        props4.calendar,
        defaultDateModel.value
      );
      if (model2.dateHash !== innerModel.value.dateHash || model2.timeHash !== innerModel.value.timeHash) {
        innerModel.value = model2;
        if (model2.hour === null) {
          view.value = "hour";
        } else {
          isAM.value = model2.hour < 12;
        }
      }
    });
    watch([mask, locale2], () => {
      nextTick(() => {
        updateValue2();
      });
    });
    function setNow() {
      const date = {
        ...getCurrentDate(),
        ...getCurrentTime$1()
      };
      updateValue2(date);
      Object.assign(innerModel.value, date);
      view.value = "hour";
    }
    function getValidValues(start, count, testFn) {
      const values = Array.apply(null, { length: count + 1 }).map((_, index2) => {
        const i22 = index2 + start;
        return {
          index: i22,
          val: testFn(i22) === true
          // force boolean
        };
      }).filter((v) => v.val === true).map((v) => v.index);
      return {
        min: values[0],
        max: values[values.length - 1],
        values,
        threshold: count + 1
      };
    }
    function getWheelDist(a32, b22, threshold) {
      const diff2 = Math.abs(a32 - b22);
      return Math.min(diff2, threshold - diff2);
    }
    function getNormalizedClockValue(val, { min: min2, max: max2, values, threshold }) {
      if (val === min2) {
        return min2;
      }
      if (val < min2 || val > max2) {
        return getWheelDist(val, min2, threshold) <= getWheelDist(val, max2, threshold) ? min2 : max2;
      }
      const index2 = values.findIndex((v) => val <= v), before = values[index2 - 1], after = values[index2];
      return val - before <= after - val ? before : after;
    }
    function getMask() {
      return props4.calendar !== "persian" && props4.mask !== null ? props4.mask : `HH:mm${props4.withSeconds === true ? ":ss" : ""}`;
    }
    function getDefaultDateModel() {
      if (typeof props4.defaultDate !== "string") {
        const date = getCurrentDate(true);
        date.dateHash = getDayHash$1(date);
        return date;
      }
      return __splitDate$1(props4.defaultDate, "YYYY/MM/DD", void 0, props4.calendar);
    }
    function shouldAbortInteraction() {
      return vmIsDestroyed$1(vm2) === true || viewValidOptions.value !== null && (viewValidOptions.value.values.length === 0 || view.value === "hour" && computedFormat24h.value !== true && validHours.value[isAM.value === true ? "am" : "pm"].values.length === 0);
    }
    function getClockRect() {
      const clock = clockRef.value, { top, left, width: width3 } = clock.getBoundingClientRect(), dist2 = width3 / 2;
      return {
        top: top + dist2,
        left: left + dist2,
        dist: dist2 * 0.7
      };
    }
    function onPan(event) {
      if (shouldAbortInteraction() === true) {
        return;
      }
      if (event.isFirst === true) {
        draggingClockRect = getClockRect();
        dragCache = updateClock(event.evt, draggingClockRect);
        return;
      }
      dragCache = updateClock(event.evt, draggingClockRect, dragCache);
      if (event.isFinal === true) {
        draggingClockRect = false;
        dragCache = null;
        goToNextView();
      }
    }
    function goToNextView() {
      if (view.value === "hour") {
        view.value = "minute";
      } else if (props4.withSeconds && view.value === "minute") {
        view.value = "second";
      }
    }
    function updateClock(evt, clockRect, cacheVal) {
      const pos = position$1(evt), height2 = Math.abs(pos.top - clockRect.top), distance = Math.sqrt(
        Math.pow(Math.abs(pos.top - clockRect.top), 2) + Math.pow(Math.abs(pos.left - clockRect.left), 2)
      );
      let val, angle2 = Math.asin(height2 / distance) * (180 / Math.PI);
      if (pos.top < clockRect.top) {
        angle2 = clockRect.left < pos.left ? 90 - angle2 : 270 + angle2;
      } else {
        angle2 = clockRect.left < pos.left ? angle2 + 90 : 270 - angle2;
      }
      if (view.value === "hour") {
        val = angle2 / 30;
        if (validHours.value !== null) {
          const am = computedFormat24h.value !== true ? isAM.value === true : validHours.value.am.values.length !== 0 && validHours.value.pm.values.length !== 0 ? distance >= clockRect.dist : validHours.value.am.values.length !== 0;
          val = getNormalizedClockValue(
            val + (am === true ? 0 : 12),
            validHours.value[am === true ? "am" : "pm"]
          );
        } else {
          val = Math.round(val);
          if (computedFormat24h.value === true) {
            if (distance < clockRect.dist) {
              if (val < 12) {
                val += 12;
              }
            } else if (val === 12) {
              val = 0;
            }
          } else if (isAM.value === true && val === 12) {
            val = 0;
          } else if (isAM.value === false && val !== 12) {
            val += 12;
          }
        }
        if (computedFormat24h.value === true) {
          isAM.value = val < 12;
        }
      } else {
        val = Math.round(angle2 / 6) % 60;
        if (view.value === "minute" && validMinutes.value !== null) {
          val = getNormalizedClockValue(val, validMinutes.value);
        } else if (view.value === "second" && validSeconds.value !== null) {
          val = getNormalizedClockValue(val, validSeconds.value);
        }
      }
      if (cacheVal !== val) {
        setModel[view.value](val);
      }
      return val;
    }
    const setView = {
      hour() {
        view.value = "hour";
      },
      minute() {
        view.value = "minute";
      },
      second() {
        view.value = "second";
      }
    };
    function setAmOnKey(e22) {
      e22.keyCode === 13 && setAm();
    }
    function setPmOnKey(e22) {
      e22.keyCode === 13 && setPm();
    }
    function onClick(evt) {
      if (shouldAbortInteraction() !== true) {
        if ($q.platform.is.desktop !== true) {
          updateClock(evt, getClockRect());
        }
        goToNextView();
      }
    }
    function onMousedown(evt) {
      if (shouldAbortInteraction() !== true) {
        updateClock(evt, getClockRect());
      }
    }
    function onKeyupHour(e22) {
      if (e22.keyCode === 13) {
        view.value = "hour";
      } else if ([37, 39].includes(e22.keyCode)) {
        const payload = e22.keyCode === 37 ? -1 : 1;
        if (validHours.value !== null) {
          const values = computedFormat24h.value === true ? validHours.value.values : validHours.value[isAM.value === true ? "am" : "pm"].values;
          if (values.length === 0) return;
          if (innerModel.value.hour === null) {
            setHour(values[0]);
          } else {
            const index2 = (values.length + values.indexOf(innerModel.value.hour) + payload) % values.length;
            setHour(values[index2]);
          }
        } else {
          const wrap = computedFormat24h.value === true ? 24 : 12, offset2 = computedFormat24h.value !== true && isAM.value === false ? 12 : 0, val = innerModel.value.hour === null ? -payload : innerModel.value.hour;
          setHour(offset2 + (24 + val + payload) % wrap);
        }
      }
    }
    function onKeyupMinute(e22) {
      if (e22.keyCode === 13) {
        view.value = "minute";
      } else if ([37, 39].includes(e22.keyCode)) {
        const payload = e22.keyCode === 37 ? -1 : 1;
        if (validMinutes.value !== null) {
          const values = validMinutes.value.values;
          if (values.length === 0) return;
          if (innerModel.value.minute === null) {
            setMinute(values[0]);
          } else {
            const index2 = (values.length + values.indexOf(innerModel.value.minute) + payload) % values.length;
            setMinute(values[index2]);
          }
        } else {
          const val = innerModel.value.minute === null ? -payload : innerModel.value.minute;
          setMinute((60 + val + payload) % 60);
        }
      }
    }
    function onKeyupSecond(e22) {
      if (e22.keyCode === 13) {
        view.value = "second";
      } else if ([37, 39].includes(e22.keyCode)) {
        const payload = e22.keyCode === 37 ? -1 : 1;
        if (validSeconds.value !== null) {
          const values = validSeconds.value.values;
          if (values.length === 0) return;
          if (innerModel.value.seconds === null) {
            setSecond(values[0]);
          } else {
            const index2 = (values.length + values.indexOf(innerModel.value.second) + payload) % values.length;
            setSecond(values[index2]);
          }
        } else {
          const val = innerModel.value.second === null ? -payload : innerModel.value.second;
          setSecond((60 + val + payload) % 60);
        }
      }
    }
    function setHour(hour) {
      if (innerModel.value.hour !== hour) {
        innerModel.value.hour = hour;
        verifyAndUpdate();
      }
    }
    function setMinute(minute) {
      if (innerModel.value.minute !== minute) {
        innerModel.value.minute = minute;
        verifyAndUpdate();
      }
    }
    function setSecond(second) {
      if (innerModel.value.second !== second) {
        innerModel.value.second = second;
        verifyAndUpdate();
      }
    }
    const setModel = {
      hour: setHour,
      minute: setMinute,
      second: setSecond
    };
    function setAm() {
      if (isAM.value === false) {
        isAM.value = true;
        if (innerModel.value.hour !== null) {
          innerModel.value.hour -= 12;
          verifyAndUpdate();
        }
      }
    }
    function setPm() {
      if (isAM.value === true) {
        isAM.value = false;
        if (innerModel.value.hour !== null) {
          innerModel.value.hour += 12;
          verifyAndUpdate();
        }
      }
    }
    function goToViewWhenHasModel(newView) {
      const model2 = props4.modelValue;
      if (view.value !== newView && model2 !== void 0 && model2 !== null && model2 !== "" && typeof model2 !== "string") {
        view.value = newView;
      }
    }
    function verifyAndUpdate() {
      if (hourInSelection.value !== null && hourInSelection.value(innerModel.value.hour) !== true) {
        innerModel.value = __splitDate$1();
        goToViewWhenHasModel("hour");
        return;
      }
      if (minuteInSelection.value !== null && minuteInSelection.value(innerModel.value.minute) !== true) {
        innerModel.value.minute = null;
        innerModel.value.second = null;
        goToViewWhenHasModel("minute");
        return;
      }
      if (props4.withSeconds === true && secondInSelection.value !== null && secondInSelection.value(innerModel.value.second) !== true) {
        innerModel.value.second = null;
        goToViewWhenHasModel("second");
        return;
      }
      if (innerModel.value.hour === null || innerModel.value.minute === null || props4.withSeconds === true && innerModel.value.second === null) {
        return;
      }
      updateValue2();
    }
    function updateValue2(obj) {
      const date = Object.assign({ ...innerModel.value }, obj);
      const val = props4.calendar === "persian" ? pad$1(date.hour) + ":" + pad$1(date.minute) + (props4.withSeconds === true ? ":" + pad$1(date.second) : "") : formatDate$2(
        new Date(
          date.year,
          date.month === null ? null : date.month - 1,
          date.day,
          date.hour,
          date.minute,
          date.second,
          date.millisecond
        ),
        mask.value,
        locale2.value,
        date.year,
        date.timezoneOffset
      );
      date.changed = val !== props4.modelValue;
      emit("update:modelValue", val, date);
    }
    function getHeader() {
      const label = [
        h("div", {
          class: "q-time__link " + (view.value === "hour" ? "q-time__link--active" : "cursor-pointer"),
          tabindex: tabindex.value,
          onClick: setView.hour,
          onKeyup: onKeyupHour
        }, stringModel.value.hour),
        h("div", ":"),
        h(
          "div",
          minLink.value === true ? {
            class: "q-time__link " + (view.value === "minute" ? "q-time__link--active" : "cursor-pointer"),
            tabindex: tabindex.value,
            onKeyup: onKeyupMinute,
            onClick: setView.minute
          } : { class: "q-time__link" },
          stringModel.value.minute
        )
      ];
      if (props4.withSeconds === true) {
        label.push(
          h("div", ":"),
          h(
            "div",
            secLink.value === true ? {
              class: "q-time__link " + (view.value === "second" ? "q-time__link--active" : "cursor-pointer"),
              tabindex: tabindex.value,
              onKeyup: onKeyupSecond,
              onClick: setView.second
            } : { class: "q-time__link" },
            stringModel.value.second
          )
        );
      }
      const child = [
        h("div", {
          class: "q-time__header-label row items-center no-wrap",
          dir: "ltr"
        }, label)
      ];
      computedFormat24h.value === false && child.push(
        h("div", {
          class: "q-time__header-ampm column items-between no-wrap"
        }, [
          h("div", {
            class: "q-time__link " + (isAM.value === true ? "q-time__link--active" : "cursor-pointer"),
            tabindex: tabindex.value,
            onClick: setAm,
            onKeyup: setAmOnKey
          }, "AM"),
          h("div", {
            class: "q-time__link " + (isAM.value !== true ? "q-time__link--active" : "cursor-pointer"),
            tabindex: tabindex.value,
            onClick: setPm,
            onKeyup: setPmOnKey
          }, "PM")
        ])
      );
      return h("div", {
        class: "q-time__header flex flex-center no-wrap " + headerClass.value
      }, child);
    }
    function getClock() {
      const current = innerModel.value[view.value];
      return h("div", {
        class: "q-time__content col relative-position"
      }, [
        h(Transition, {
          name: "q-transition--scale"
        }, () => h("div", {
          key: "clock" + view.value,
          class: "q-time__container-parent absolute-full"
        }, [
          h("div", {
            ref: clockRef,
            class: "q-time__container-child fit overflow-hidden"
          }, [
            withDirectives(
              h("div", {
                class: "q-time__clock cursor-pointer non-selectable",
                onClick,
                onMousedown
              }, [
                h("div", { class: "q-time__clock-circle fit" }, [
                  h("div", {
                    class: "q-time__clock-pointer" + (innerModel.value[view.value] === null ? " hidden" : props4.color !== void 0 ? ` text-${props4.color}` : ""),
                    style: pointerStyle.value
                  }),
                  positions2.value.map((pos) => h("div", {
                    class: `q-time__clock-position row flex-center q-time__clock-pos-${pos.index}` + (pos.val === current ? " q-time__clock-position--active " + headerClass.value : pos.disable === true ? " q-time__clock-position--disable" : "")
                  }, [h("span", pos.label)]))
                ])
              ]),
              clockDirectives.value
            )
          ])
        ])),
        props4.nowBtn === true ? h(QBtn_default$1, {
          class: "q-time__now-button absolute",
          icon: $q.iconSet.datetime.now,
          unelevated: true,
          size: "sm",
          round: true,
          color: props4.color,
          textColor: props4.textColor,
          tabindex: tabindex.value,
          onClick: setNow
        }) : null
      ]);
    }
    vm2.proxy.setNow = setNow;
    return () => {
      const child = [getClock()];
      const def = hSlot$1(slots.default);
      def !== void 0 && child.push(
        h("div", { class: "q-time__actions" }, def)
      );
      if (props4.name !== void 0 && props4.disable !== true) {
        injectFormInput(child, "push");
      }
      return h("div", {
        class: classes.value,
        tabindex: -1
      }, [
        getHeader(),
        h("div", { class: "q-time__main col overflow-auto" }, child)
      ]);
    };
  }
});
createComponent$1({
  name: "QTimeline",
  props: {
    ...useDarkProps$1,
    color: {
      type: String,
      default: "primary"
    },
    side: {
      type: String,
      default: "right",
      validator: (v) => ["left", "right"].includes(v)
    },
    layout: {
      type: String,
      default: "dense",
      validator: (v) => ["dense", "comfortable", "loose"].includes(v)
    }
  },
  setup(props4, { slots }) {
    const vm2 = getCurrentInstance();
    const isDark = use_dark_default$1(props4, vm2.proxy.$q);
    provide(timelineKey$1, props4);
    const classes = computed(
      () => `q-timeline q-timeline--${props4.layout} q-timeline--${props4.layout}--${props4.side}` + (isDark.value === true ? " q-timeline--dark" : "")
    );
    return () => h("ul", { class: classes.value }, hSlot$1(slots.default));
  }
});
createComponent$1({
  name: "QTimelineEntry",
  props: {
    heading: Boolean,
    tag: {
      type: String,
      default: "h3"
    },
    side: {
      type: String,
      default: "right",
      validator: (v) => ["left", "right"].includes(v)
    },
    icon: String,
    avatar: String,
    color: String,
    title: String,
    subtitle: String,
    body: String
  },
  setup(props4, { slots }) {
    const $timeline = inject(timelineKey$1, emptyRenderFn$1);
    if ($timeline === emptyRenderFn$1) {
      console.error("QTimelineEntry needs to be child of QTimeline");
      return emptyRenderFn$1;
    }
    const classes = computed(
      () => `q-timeline__entry q-timeline__entry--${props4.side}` + (props4.icon !== void 0 || props4.avatar !== void 0 ? " q-timeline__entry--icon" : "")
    );
    const dotClass = computed(
      () => `q-timeline__dot text-${props4.color || $timeline.color}`
    );
    const reverse = computed(
      () => $timeline.layout === "comfortable" && $timeline.side === "left"
    );
    return () => {
      const child = hUniqueSlot$1(slots.default, []);
      if (props4.body !== void 0) {
        child.unshift(props4.body);
      }
      if (props4.heading === true) {
        const content2 = [
          h("div"),
          h("div"),
          h(
            props4.tag,
            { class: "q-timeline__heading-title" },
            child
          )
        ];
        return h("div", {
          class: "q-timeline__heading"
        }, reverse.value === true ? content2.reverse() : content2);
      }
      let dot;
      if (props4.icon !== void 0) {
        dot = [
          h(QIcon_default$1, {
            class: "row items-center justify-center",
            name: props4.icon
          })
        ];
      } else if (props4.avatar !== void 0) {
        dot = [
          h("img", {
            class: "q-timeline__dot-img",
            src: props4.avatar
          })
        ];
      }
      const content = [
        h("div", { class: "q-timeline__subtitle" }, [
          h("span", {}, hSlot$1(slots.subtitle, [props4.subtitle]))
        ]),
        h("div", { class: dotClass.value }, dot),
        h("div", { class: "q-timeline__content" }, [
          h("h6", { class: "q-timeline__title" }, hSlot$1(slots.title, [props4.title]))
        ].concat(child))
      ];
      return h("li", {
        class: classes.value
      }, reverse.value === true ? content.reverse() : content);
    };
  }
});
createComponent$1({
  name: "QToolbar",
  props: {
    inset: Boolean
  },
  setup(props4, { slots }) {
    const classes = computed(
      () => "q-toolbar row no-wrap items-center" + (props4.inset === true ? " q-toolbar--inset" : "")
    );
    return () => h("div", { class: classes.value, role: "toolbar" }, hSlot$1(slots.default));
  }
});
createComponent$1({
  name: "QToolbarTitle",
  props: {
    shrink: Boolean
  },
  setup(props4, { slots }) {
    const classes = computed(
      () => "q-toolbar__title ellipsis" + (props4.shrink === true ? " col-shrink" : "")
    );
    return () => h("div", { class: classes.value }, hSlot$1(slots.default));
  }
});
var tickStrategyOptions$1 = ["none", "strict", "leaf", "leaf-filtered"];
createComponent$1({
  name: "QTree",
  props: {
    ...useDarkProps$1,
    nodes: {
      type: Array,
      required: true
    },
    nodeKey: {
      type: String,
      required: true
    },
    labelKey: {
      type: String,
      default: "label"
    },
    childrenKey: {
      type: String,
      default: "children"
    },
    dense: Boolean,
    color: String,
    controlColor: String,
    textColor: String,
    selectedColor: String,
    icon: String,
    tickStrategy: {
      type: String,
      default: "none",
      validator: (v) => tickStrategyOptions$1.includes(v)
    },
    ticked: Array,
    // v-model:ticked
    expanded: Array,
    // v-model:expanded
    selected: {},
    // v-model:selected
    noSelectionUnset: Boolean,
    defaultExpandAll: Boolean,
    accordion: Boolean,
    filter: String,
    filterMethod: Function,
    duration: {},
    noConnectors: Boolean,
    noTransition: Boolean,
    noNodesLabel: String,
    noResultsLabel: String
  },
  emits: [
    "update:expanded",
    "update:ticked",
    "update:selected",
    "lazyLoad",
    "afterShow",
    "afterHide"
  ],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const isDark = use_dark_default$1(props4, $q);
    const lazy = ref$1({});
    const innerTicked = ref$1(props4.ticked || []);
    const innerExpanded = ref$1(props4.expanded || []);
    let blurTargets = {};
    onBeforeUpdate(() => {
      blurTargets = {};
    });
    const classes = computed(
      () => `q-tree q-tree--${props4.dense === true ? "dense" : "standard"}` + (props4.noConnectors === true ? " q-tree--no-connectors" : "") + (isDark.value === true ? " q-tree--dark" : "") + (props4.color !== void 0 ? ` text-${props4.color}` : "")
    );
    const hasSelection = computed(() => props4.selected !== void 0);
    const computedIcon = computed(() => props4.icon || $q.iconSet.tree.icon);
    const computedControlColor = computed(() => props4.controlColor || props4.color);
    const textColorClass = computed(() => props4.textColor !== void 0 ? ` text-${props4.textColor}` : "");
    const selectedColorClass = computed(() => {
      const color2 = props4.selectedColor || props4.color;
      return color2 ? ` text-${color2}` : "";
    });
    const computedFilterMethod = computed(() => props4.filterMethod !== void 0 ? props4.filterMethod : (node, filter) => {
      const filt = filter.toLowerCase();
      return node[props4.labelKey] && node[props4.labelKey].toLowerCase().indexOf(filt) !== -1;
    });
    const meta = computed(() => {
      const meta2 = {};
      const travel = (node, parent) => {
        const tickStrategy = node.tickStrategy || (parent ? parent.tickStrategy : props4.tickStrategy);
        const key = node[props4.nodeKey], isParent = node[props4.childrenKey] && Array.isArray(node[props4.childrenKey]) && node[props4.childrenKey].length !== 0, selectable = node.disabled !== true && hasSelection.value === true && node.selectable !== false, expandable = node.disabled !== true && node.expandable !== false, hasTicking = tickStrategy !== "none", strictTicking = tickStrategy === "strict", leafFilteredTicking = tickStrategy === "leaf-filtered", leafTicking = tickStrategy === "leaf" || tickStrategy === "leaf-filtered";
        let tickable = node.disabled !== true && node.tickable !== false;
        if (leafTicking === true && tickable === true && parent && parent.tickable !== true) {
          tickable = false;
        }
        let localLazy = node.lazy;
        if (localLazy === true && lazy.value[key] !== void 0 && Array.isArray(node[props4.childrenKey]) === true) {
          localLazy = lazy.value[key];
        }
        const m32 = {
          key,
          parent,
          isParent,
          lazy: localLazy,
          disabled: node.disabled,
          link: node.disabled !== true && (selectable === true || expandable === true && (isParent === true || localLazy === true)),
          children: [],
          matchesFilter: props4.filter ? computedFilterMethod.value(node, props4.filter) : true,
          selected: key === props4.selected && selectable === true,
          selectable,
          expanded: isParent === true ? innerExpanded.value.includes(key) : false,
          expandable,
          noTick: node.noTick === true || strictTicking !== true && localLazy && localLazy !== "loaded",
          tickable,
          tickStrategy,
          hasTicking,
          strictTicking,
          leafFilteredTicking,
          leafTicking,
          ticked: strictTicking === true ? innerTicked.value.includes(key) : isParent === true ? false : innerTicked.value.includes(key)
        };
        meta2[key] = m32;
        if (isParent === true) {
          m32.children = node[props4.childrenKey].map((n) => travel(n, m32));
          if (props4.filter) {
            if (m32.matchesFilter !== true) {
              m32.matchesFilter = m32.children.some((n) => n.matchesFilter);
            } else if (m32.noTick !== true && m32.disabled !== true && m32.tickable === true && leafFilteredTicking === true && m32.children.every((n) => n.matchesFilter !== true || n.noTick === true || n.tickable !== true) === true) {
              m32.tickable = false;
            }
          }
          if (m32.matchesFilter === true) {
            if (m32.noTick !== true && strictTicking !== true && m32.children.every((n) => n.noTick) === true) {
              m32.noTick = true;
            }
            if (leafTicking) {
              m32.ticked = false;
              m32.indeterminate = m32.children.some((node2) => node2.indeterminate === true);
              m32.tickable = m32.tickable === true && m32.children.some((node2) => node2.tickable);
              if (m32.indeterminate !== true) {
                const sel = m32.children.reduce((acc, meta3) => meta3.ticked === true ? acc + 1 : acc, 0);
                if (sel === m32.children.length) {
                  m32.ticked = true;
                } else if (sel > 0) {
                  m32.indeterminate = true;
                }
              }
              if (m32.indeterminate === true) {
                m32.indeterminateNextState = m32.children.every((meta3) => meta3.tickable !== true || meta3.ticked !== true);
              }
            }
          }
        }
        return m32;
      };
      props4.nodes.forEach((node) => travel(node, null));
      return meta2;
    });
    watch(() => props4.ticked, (val) => {
      innerTicked.value = val;
    });
    watch(() => props4.expanded, (val) => {
      innerExpanded.value = val;
    });
    function getNodeByKey(key) {
      const reduce = [].reduce;
      const find = (result, node) => {
        if (result || !node) {
          return result;
        }
        if (Array.isArray(node) === true) {
          return reduce.call(Object(node), find, result);
        }
        if (node[props4.nodeKey] === key) {
          return node;
        }
        if (node[props4.childrenKey]) {
          return find(null, node[props4.childrenKey]);
        }
      };
      return find(null, props4.nodes);
    }
    function getTickedNodes() {
      return innerTicked.value.map((key) => getNodeByKey(key));
    }
    function getExpandedNodes() {
      return innerExpanded.value.map((key) => getNodeByKey(key));
    }
    function isExpanded(key) {
      return key && meta.value[key] ? meta.value[key].expanded : false;
    }
    function collapseAll() {
      if (props4.expanded !== void 0) {
        emit("update:expanded", []);
      } else {
        innerExpanded.value = [];
      }
    }
    function expandAll() {
      const expanded = [];
      const travel = (node) => {
        if (node[props4.childrenKey] && node[props4.childrenKey].length !== 0) {
          if (node.expandable !== false && node.disabled !== true) {
            expanded.push(node[props4.nodeKey]);
            node[props4.childrenKey].forEach(travel);
          }
        }
      };
      props4.nodes.forEach(travel);
      if (props4.expanded !== void 0) {
        emit("update:expanded", expanded);
      } else {
        innerExpanded.value = expanded;
      }
    }
    function setExpanded(key, state2, node = getNodeByKey(key), m32 = meta.value[key]) {
      if (m32.lazy && m32.lazy !== "loaded") {
        if (m32.lazy === "loading") {
          return;
        }
        lazy.value[key] = "loading";
        if (Array.isArray(node[props4.childrenKey]) !== true) {
          node[props4.childrenKey] = [];
        }
        emit("lazyLoad", {
          node,
          key,
          done: (children) => {
            lazy.value[key] = "loaded";
            node[props4.childrenKey] = Array.isArray(children) === true ? children : [];
            nextTick(() => {
              const localMeta = meta.value[key];
              if (localMeta && localMeta.isParent === true) {
                localSetExpanded(key, true);
              }
            });
          },
          fail: () => {
            delete lazy.value[key];
            if (node[props4.childrenKey].length === 0) {
              delete node[props4.childrenKey];
            }
          }
        });
      } else if (m32.isParent === true && m32.expandable === true) {
        localSetExpanded(key, state2);
      }
    }
    function localSetExpanded(key, state2) {
      let target2 = innerExpanded.value;
      const shouldEmit = props4.expanded !== void 0;
      if (shouldEmit === true) {
        target2 = target2.slice();
      }
      if (state2) {
        if (props4.accordion) {
          if (meta.value[key]) {
            const collapse = [];
            if (meta.value[key].parent) {
              meta.value[key].parent.children.forEach((m32) => {
                if (m32.key !== key && m32.expandable === true) {
                  collapse.push(m32.key);
                }
              });
            } else {
              props4.nodes.forEach((node) => {
                const k22 = node[props4.nodeKey];
                if (k22 !== key) {
                  collapse.push(k22);
                }
              });
            }
            if (collapse.length !== 0) {
              target2 = target2.filter((k22) => collapse.includes(k22) === false);
            }
          }
        }
        target2 = target2.concat([key]).filter((key2, index2, self2) => self2.indexOf(key2) === index2);
      } else {
        target2 = target2.filter((k22) => k22 !== key);
      }
      if (shouldEmit === true) {
        emit("update:expanded", target2);
      } else {
        innerExpanded.value = target2;
      }
    }
    function isTicked(key) {
      return key && meta.value[key] ? meta.value[key].ticked : false;
    }
    function setTicked(keys2, state2) {
      let target2 = innerTicked.value;
      const shouldEmit = props4.ticked !== void 0;
      if (shouldEmit === true) {
        target2 = target2.slice();
      }
      if (state2) {
        target2 = target2.concat(keys2).filter((key, index2, self2) => self2.indexOf(key) === index2);
      } else {
        target2 = target2.filter((k22) => keys2.includes(k22) === false);
      }
      if (shouldEmit === true) {
        emit("update:ticked", target2);
      }
    }
    function getSlotScope(node, meta2, key) {
      const scope = { tree: proxy, node, key, color: props4.color, dark: isDark.value };
      injectProp$1(
        scope,
        "expanded",
        () => {
          return meta2.expanded;
        },
        (val) => {
          val !== meta2.expanded && setExpanded(key, val);
        }
      );
      injectProp$1(
        scope,
        "ticked",
        () => {
          return meta2.ticked;
        },
        (val) => {
          val !== meta2.ticked && setTicked([key], val);
        }
      );
      return scope;
    }
    function getChildren(nodes) {
      return (props4.filter ? nodes.filter((n) => meta.value[n[props4.nodeKey]].matchesFilter) : nodes).map((child) => getNode(child));
    }
    function getNodeMedia(node) {
      if (node.icon !== void 0) {
        return h(QIcon_default$1, {
          class: "q-tree__icon q-mr-sm",
          name: node.icon,
          color: node.iconColor
        });
      }
      const src = node.img || node.avatar;
      if (src) {
        return h("img", {
          class: `q-tree__${node.img ? "img" : "avatar"} q-mr-sm`,
          src
        });
      }
    }
    function onShow() {
      emit("afterShow");
    }
    function onHide() {
      emit("afterHide");
    }
    function getNode(node) {
      const key = node[props4.nodeKey], m32 = meta.value[key], header = node.header ? slots[`header-${node.header}`] || slots["default-header"] : slots["default-header"];
      const children = m32.isParent === true ? getChildren(node[props4.childrenKey]) : [];
      const isParent = children.length !== 0 || m32.lazy && m32.lazy !== "loaded";
      let body = node.body ? slots[`body-${node.body}`] || slots["default-body"] : slots["default-body"];
      const slotScope = header !== void 0 || body !== void 0 ? getSlotScope(node, m32, key) : null;
      if (body !== void 0) {
        body = h("div", { class: "q-tree__node-body relative-position" }, [
          h("div", { class: textColorClass.value }, [
            body(slotScope)
          ])
        ]);
      }
      return h("div", {
        key,
        class: `q-tree__node relative-position q-tree__node--${isParent === true ? "parent" : "child"}`
      }, [
        h("div", {
          class: "q-tree__node-header relative-position row no-wrap items-center" + (m32.link === true ? " q-tree__node--link q-hoverable q-focusable" : "") + (m32.selected === true ? " q-tree__node--selected" : "") + (m32.disabled === true ? " q-tree__node--disabled" : ""),
          tabindex: m32.link === true ? 0 : -1,
          ariaExpanded: children.length > 0 ? m32.expanded : null,
          role: "treeitem",
          onClick: (e22) => {
            onClick(node, m32, e22);
          },
          onKeypress(e22) {
            if (shouldIgnoreKey$1(e22) !== true) {
              if (e22.keyCode === 13) {
                onClick(node, m32, e22, true);
              } else if (e22.keyCode === 32) {
                onExpandClick(node, m32, e22, true);
              }
            }
          }
        }, [
          h("div", {
            class: "q-focus-helper",
            tabindex: -1,
            ref: (el) => {
              blurTargets[m32.key] = el;
            }
          }),
          m32.lazy === "loading" ? h(QSpinner_default$1, {
            class: "q-tree__spinner",
            color: computedControlColor.value
          }) : isParent === true ? h(QIcon_default$1, {
            class: "q-tree__arrow" + (m32.expanded === true ? " q-tree__arrow--rotate" : ""),
            name: computedIcon.value,
            onClick(e22) {
              onExpandClick(node, m32, e22);
            }
          }) : null,
          m32.hasTicking === true && m32.noTick !== true ? h(QCheckbox_default$1, {
            class: "q-tree__tickbox",
            modelValue: m32.indeterminate === true ? null : m32.ticked,
            color: computedControlColor.value,
            dark: isDark.value,
            dense: true,
            keepColor: true,
            disable: m32.tickable !== true,
            onKeydown: stopAndPrevent$1,
            "onUpdate:modelValue": (v) => {
              onTickedClick(m32, v);
            }
          }) : null,
          h("div", {
            class: "q-tree__node-header-content col row no-wrap items-center" + (m32.selected === true ? selectedColorClass.value : textColorClass.value)
          }, [
            header ? header(slotScope) : [
              getNodeMedia(node),
              h("div", node[props4.labelKey])
            ]
          ])
        ]),
        isParent === true ? props4.noTransition === true ? m32.expanded === true ? h("div", {
          class: "q-tree__node-collapsible" + textColorClass.value,
          key: `${key}__q`
        }, [
          body,
          h("div", {
            class: "q-tree__children" + (m32.disabled === true ? " q-tree__node--disabled" : ""),
            role: "group"
          }, children)
        ]) : null : h(QSlideTransition_default$1, {
          duration: props4.duration,
          onShow,
          onHide
        }, () => withDirectives(
          h("div", {
            class: "q-tree__node-collapsible" + textColorClass.value,
            key: `${key}__q`
          }, [
            body,
            h("div", {
              class: "q-tree__children" + (m32.disabled === true ? " q-tree__node--disabled" : ""),
              role: "group"
            }, children)
          ]),
          [[vShow, m32.expanded]]
        )) : body
      ]);
    }
    function blur(key) {
      const blurTarget = blurTargets[key];
      blurTarget && blurTarget.focus();
    }
    function onClick(node, meta2, e22, keyboard) {
      keyboard !== true && meta2.selectable !== false && blur(meta2.key);
      if (hasSelection.value && meta2.selectable) {
        if (props4.noSelectionUnset === false) {
          emit("update:selected", meta2.key !== props4.selected ? meta2.key : null);
        } else if (meta2.key !== props4.selected) {
          emit("update:selected", meta2.key === void 0 ? null : meta2.key);
        }
      } else {
        onExpandClick(node, meta2, e22, keyboard);
      }
      if (typeof node.handler === "function") {
        node.handler(node);
      }
    }
    function onExpandClick(node, meta2, e22, keyboard) {
      if (e22 !== void 0) {
        stopAndPrevent$1(e22);
      }
      keyboard !== true && meta2.selectable !== false && blur(meta2.key);
      setExpanded(meta2.key, !meta2.expanded, node, meta2);
    }
    function onTickedClick(meta2, state2) {
      if (meta2.indeterminate === true) {
        state2 = meta2.indeterminateNextState;
      }
      if (meta2.strictTicking) {
        setTicked([meta2.key], state2);
      } else if (meta2.leafTicking) {
        const keys2 = [];
        const travel = (meta3) => {
          if (meta3.isParent) {
            if (state2 !== true && meta3.noTick !== true && meta3.tickable === true) {
              keys2.push(meta3.key);
            }
            if (meta3.leafTicking === true) {
              meta3.children.forEach(travel);
            }
          } else if (meta3.noTick !== true && meta3.tickable === true && (meta3.leafFilteredTicking !== true || meta3.matchesFilter === true)) {
            keys2.push(meta3.key);
          }
        };
        travel(meta2);
        setTicked(keys2, state2);
      }
    }
    props4.defaultExpandAll === true && expandAll();
    Object.assign(proxy, {
      getNodeByKey,
      getTickedNodes,
      getExpandedNodes,
      isExpanded,
      collapseAll,
      expandAll,
      setExpanded,
      isTicked,
      setTicked
    });
    return () => {
      const children = getChildren(props4.nodes);
      return h(
        "div",
        {
          class: classes.value,
          role: "tree"
        },
        children.length === 0 ? props4.filter ? props4.noResultsLabel || $q.lang.tree.noResults : props4.noNodesLabel || $q.lang.tree.noNodes : children
      );
    };
  }
});
function getProgressLabel$1(p2) {
  return (p2 * 100).toFixed(2) + "%";
}
var coreProps$1 = {
  ...useDarkProps$1,
  ...useFileProps$1,
  label: String,
  color: String,
  textColor: String,
  square: Boolean,
  flat: Boolean,
  bordered: Boolean,
  noThumbnails: Boolean,
  thumbnailFit: {
    type: String,
    default: "cover"
  },
  autoUpload: Boolean,
  hideUploadBtn: Boolean,
  disable: Boolean,
  readonly: Boolean
};
var coreEmits$1 = [
  ...useFileEmits$1,
  "start",
  "finish",
  "added",
  "removed"
];
function getRenderer$1(getPlugin, expose) {
  const vm2 = getCurrentInstance();
  const { props: props4, slots, emit, proxy } = vm2;
  const { $q } = proxy;
  const isDark = use_dark_default$1(props4, $q);
  function updateFileStatus(file, status, uploadedSize) {
    file.__status = status;
    if (status === "idle") {
      file.__uploaded = 0;
      file.__progress = 0;
      file.__sizeLabel = humanStorageSize$1(file.size);
      file.__progressLabel = "0.00%";
      return;
    }
    if (status === "failed") {
      proxy.$forceUpdate();
      return;
    }
    file.__uploaded = status === "uploaded" ? file.size : uploadedSize;
    file.__progress = status === "uploaded" ? 1 : Math.min(0.9999, file.__uploaded / file.size);
    file.__progressLabel = getProgressLabel$1(file.__progress);
    proxy.$forceUpdate();
  }
  const editable = computed(() => props4.disable !== true && props4.readonly !== true);
  const dnd = ref$1(false);
  const rootRef = ref$1(null);
  const inputRef = ref$1(null);
  const state2 = {
    files: ref$1([]),
    queuedFiles: ref$1([]),
    uploadedFiles: ref$1([]),
    uploadedSize: ref$1(0),
    updateFileStatus,
    isAlive: () => vmIsDestroyed$1(vm2) === false
  };
  const {
    pickFiles,
    addFiles,
    onDragover,
    onDragleave,
    processFiles,
    getDndNode,
    maxFilesNumber,
    maxTotalSizeNumber
  } = use_file_default$1({ editable, dnd, getFileInput, addFilesToQueue });
  Object.assign(state2, getPlugin({
    props: props4,
    slots,
    emit,
    helpers: state2,
    exposeApi: (obj) => {
      Object.assign(state2, obj);
    }
  }));
  if (state2.isBusy === void 0) {
    state2.isBusy = ref$1(false);
  }
  const uploadSize = ref$1(0);
  const uploadProgress = computed(() => uploadSize.value === 0 ? 0 : state2.uploadedSize.value / uploadSize.value);
  const uploadProgressLabel = computed(() => getProgressLabel$1(uploadProgress.value));
  const uploadSizeLabel = computed(() => humanStorageSize$1(uploadSize.value));
  const canAddFiles = computed(
    () => editable.value === true && state2.isUploading.value !== true && (props4.multiple === true || state2.queuedFiles.value.length === 0) && (props4.maxFiles === void 0 || state2.files.value.length < maxFilesNumber.value) && (props4.maxTotalSize === void 0 || uploadSize.value < maxTotalSizeNumber.value)
  );
  const canUpload = computed(
    () => editable.value === true && state2.isBusy.value !== true && state2.isUploading.value !== true && state2.queuedFiles.value.length !== 0
  );
  provide(uploaderKey$1, renderInput);
  const classes = computed(
    () => "q-uploader column no-wrap" + (isDark.value === true ? " q-uploader--dark q-dark" : "") + (props4.bordered === true ? " q-uploader--bordered" : "") + (props4.square === true ? " q-uploader--square no-border-radius" : "") + (props4.flat === true ? " q-uploader--flat no-shadow" : "") + (props4.disable === true ? " disabled q-uploader--disable" : "") + (dnd.value === true ? " q-uploader--dnd" : "")
  );
  const colorClass = computed(
    () => "q-uploader__header" + (props4.color !== void 0 ? ` bg-${props4.color}` : "") + (props4.textColor !== void 0 ? ` text-${props4.textColor}` : "")
  );
  watch(state2.isUploading, (newVal, oldVal) => {
    if (oldVal === false && newVal === true) {
      emit("start");
    } else if (oldVal === true && newVal === false) {
      emit("finish");
    }
  });
  function reset() {
    if (props4.disable === false) {
      state2.abort();
      state2.uploadedSize.value = 0;
      uploadSize.value = 0;
      revokeImgURLs();
      state2.files.value = [];
      state2.queuedFiles.value = [];
      state2.uploadedFiles.value = [];
    }
  }
  function removeUploadedFiles() {
    if (props4.disable === false) {
      batchRemoveFiles(["uploaded"], () => {
        state2.uploadedFiles.value = [];
      });
    }
  }
  function removeQueuedFiles() {
    batchRemoveFiles(["idle", "failed"], ({ size: size2 }) => {
      uploadSize.value -= size2;
      state2.queuedFiles.value = [];
    });
  }
  function batchRemoveFiles(statusList, cb) {
    if (props4.disable === true) {
      return;
    }
    const removed = {
      files: [],
      size: 0
    };
    const localFiles = state2.files.value.filter((f) => {
      if (statusList.indexOf(f.__status) === -1) {
        return true;
      }
      removed.size += f.size;
      removed.files.push(f);
      f.__img !== void 0 && window.URL.revokeObjectURL(f.__img.src);
      return false;
    });
    if (removed.files.length !== 0) {
      state2.files.value = localFiles;
      cb(removed);
      emit("removed", removed.files);
    }
  }
  function removeFile(file) {
    if (props4.disable) return;
    if (file.__status === "uploaded") {
      state2.uploadedFiles.value = state2.uploadedFiles.value.filter((f) => f.__key !== file.__key);
    } else if (file.__status === "uploading") {
      file.__abort();
    } else {
      uploadSize.value -= file.size;
    }
    state2.files.value = state2.files.value.filter((f) => {
      if (f.__key !== file.__key) {
        return true;
      }
      f.__img !== void 0 && window.URL.revokeObjectURL(f.__img.src);
      return false;
    });
    state2.queuedFiles.value = state2.queuedFiles.value.filter((f) => f.__key !== file.__key);
    emit("removed", [file]);
  }
  function revokeImgURLs() {
    state2.files.value.forEach((f) => {
      f.__img !== void 0 && window.URL.revokeObjectURL(f.__img.src);
    });
  }
  function getFileInput() {
    return inputRef.value || rootRef.value.getElementsByClassName("q-uploader__input")[0];
  }
  function addFilesToQueue(e22, fileList) {
    const localFiles = processFiles(e22, fileList, state2.files.value, true);
    const fileInput = getFileInput();
    if (fileInput !== void 0 && fileInput !== null) {
      fileInput.value = "";
    }
    if (localFiles === void 0) return;
    localFiles.forEach((file) => {
      state2.updateFileStatus(file, "idle");
      uploadSize.value += file.size;
      if (props4.noThumbnails !== true && file.type.toUpperCase().startsWith("IMAGE")) {
        const img = new Image();
        img.src = window.URL.createObjectURL(file);
        file.__img = img;
      }
    });
    state2.files.value = state2.files.value.concat(localFiles);
    state2.queuedFiles.value = state2.queuedFiles.value.concat(localFiles);
    emit("added", localFiles);
    props4.autoUpload === true && state2.upload();
  }
  function upload() {
    canUpload.value === true && state2.upload();
  }
  function getBtn2(show, icon, fn) {
    if (show === true) {
      const data = {
        type: "a",
        key: icon,
        icon: $q.iconSet.uploader[icon],
        flat: true,
        dense: true
      };
      let child = void 0;
      if (icon === "add") {
        data.onClick = pickFiles;
        child = renderInput;
      } else {
        data.onClick = fn;
      }
      return h(QBtn_default$1, data, child);
    }
  }
  function renderInput() {
    return h("input", {
      ref: inputRef,
      class: "q-uploader__input overflow-hidden absolute-full",
      tabindex: -1,
      type: "file",
      title: "",
      // try to remove default tooltip
      accept: props4.accept,
      multiple: props4.multiple === true ? "multiple" : void 0,
      capture: props4.capture,
      onMousedown: stop$1,
      // need to stop refocus from QBtn
      onClick: pickFiles,
      onChange: addFilesToQueue
    });
  }
  function getHeader() {
    if (slots.header !== void 0) {
      return slots.header(publicApi);
    }
    return [
      h("div", {
        class: "q-uploader__header-content column"
      }, [
        h("div", {
          class: "flex flex-center no-wrap q-gutter-xs"
        }, [
          getBtn2(state2.queuedFiles.value.length !== 0, "removeQueue", removeQueuedFiles),
          getBtn2(state2.uploadedFiles.value.length !== 0, "removeUploaded", removeUploadedFiles),
          state2.isUploading.value === true ? h(QSpinner_default$1, { class: "q-uploader__spinner" }) : null,
          h("div", { class: "col column justify-center" }, [
            props4.label !== void 0 ? h("div", { class: "q-uploader__title" }, [props4.label]) : null,
            h("div", { class: "q-uploader__subtitle" }, [
              uploadSizeLabel.value + " / " + uploadProgressLabel.value
            ])
          ]),
          getBtn2(canAddFiles.value, "add"),
          getBtn2(props4.hideUploadBtn === false && canUpload.value === true, "upload", state2.upload),
          getBtn2(state2.isUploading.value, "clear", state2.abort)
        ])
      ])
    ];
  }
  function getList() {
    if (slots.list !== void 0) {
      return slots.list(publicApi);
    }
    return state2.files.value.map((file) => h("div", {
      key: file.__key,
      class: "q-uploader__file relative-position" + (props4.noThumbnails !== true && file.__img !== void 0 ? " q-uploader__file--img" : "") + (file.__status === "failed" ? " q-uploader__file--failed" : file.__status === "uploaded" ? " q-uploader__file--uploaded" : ""),
      style: props4.noThumbnails !== true && file.__img !== void 0 ? { backgroundImage: 'url("' + file.__img.src + '")', backgroundSize: props4.thumbnailFit } : null
    }, [
      h("div", {
        class: "q-uploader__file-header row flex-center no-wrap"
      }, [
        file.__status === "failed" ? h(QIcon_default$1, {
          class: "q-uploader__file-status",
          name: $q.iconSet.type.negative,
          color: "negative"
        }) : null,
        h("div", { class: "q-uploader__file-header-content col" }, [
          h("div", { class: "q-uploader__title" }, [file.name]),
          h("div", {
            class: "q-uploader__subtitle row items-center no-wrap"
          }, [
            file.__sizeLabel + " / " + file.__progressLabel
          ])
        ]),
        file.__status === "uploading" ? h(QCircularProgress_default$1, {
          value: file.__progress,
          min: 0,
          max: 1,
          indeterminate: file.__progress === 0
        }) : h(QBtn_default$1, {
          round: true,
          dense: true,
          flat: true,
          icon: $q.iconSet.uploader[file.__status === "uploaded" ? "done" : "clear"],
          onClick: () => {
            removeFile(file);
          }
        })
      ])
    ]));
  }
  onBeforeUnmount(() => {
    state2.isUploading.value === true && state2.abort();
    state2.files.value.length !== 0 && revokeImgURLs();
  });
  const publicApi = {};
  for (const key in state2) {
    if (isRef(state2[key]) === true) {
      injectProp$1(publicApi, key, () => state2[key].value);
    } else {
      publicApi[key] = state2[key];
    }
  }
  Object.assign(publicApi, {
    upload,
    reset,
    removeUploadedFiles,
    removeQueuedFiles,
    removeFile,
    pickFiles,
    addFiles
  });
  injectMultipleProps$1(publicApi, {
    canAddFiles: () => canAddFiles.value,
    canUpload: () => canUpload.value,
    uploadSizeLabel: () => uploadSizeLabel.value,
    uploadProgressLabel: () => uploadProgressLabel.value
  });
  expose({
    ...state2,
    upload,
    reset,
    removeUploadedFiles,
    removeQueuedFiles,
    removeFile,
    pickFiles,
    addFiles,
    canAddFiles,
    canUpload,
    uploadSizeLabel,
    uploadProgressLabel
  });
  return () => {
    const children = [
      h("div", { class: colorClass.value }, getHeader()),
      h("div", { class: "q-uploader__list scroll" }, getList()),
      getDndNode("uploader")
    ];
    state2.isBusy.value === true && children.push(
      h("div", {
        class: "q-uploader__overlay absolute-full flex flex-center"
      }, [h(QSpinner_default$1)])
    );
    const data = { ref: rootRef, class: classes.value };
    if (canAddFiles.value === true) {
      Object.assign(data, { onDragover, onDragleave });
    }
    return h("div", data, children);
  };
}
var trueFn$1 = () => true;
function get_emits_object_default$1(emitsArray) {
  const emitsObject = {};
  emitsArray.forEach((val) => {
    emitsObject[val] = trueFn$1;
  });
  return emitsObject;
}
var coreEmitsObject$1 = get_emits_object_default$1(coreEmits$1);
var create_uploader_component_default$1 = ({ name: name2, props: props4, emits: emits3, injectPlugin: injectPlugin2 }) => createComponent$1({
  name: name2,
  props: {
    ...coreProps$1,
    ...props4
  },
  emits: isObject$1(emits3) === true ? { ...coreEmitsObject$1, ...emits3 } : [...coreEmits$1, ...emits3],
  setup(_, { expose }) {
    return getRenderer$1(injectPlugin2, expose);
  }
});
function getFn$1(prop) {
  return typeof prop === "function" ? prop : () => prop;
}
var name$1 = "QUploader";
var props$1 = {
  url: [Function, String],
  method: {
    type: [Function, String],
    default: "POST"
  },
  fieldName: {
    type: [Function, String],
    default: () => (file) => file.name
  },
  headers: [Function, Array],
  formFields: [Function, Array],
  withCredentials: [Function, Boolean],
  sendRaw: [Function, Boolean],
  batch: [Function, Boolean],
  factory: Function
};
var emits$1 = ["factoryFailed", "uploaded", "failed", "uploading"];
function injectPlugin$1({ props: props4, emit, helpers: helpers2 }) {
  const xhrs = ref$1([]);
  const promises = ref$1([]);
  const workingThreads = ref$1(0);
  const xhrProps = computed(() => ({
    url: getFn$1(props4.url),
    method: getFn$1(props4.method),
    headers: getFn$1(props4.headers),
    formFields: getFn$1(props4.formFields),
    fieldName: getFn$1(props4.fieldName),
    withCredentials: getFn$1(props4.withCredentials),
    sendRaw: getFn$1(props4.sendRaw),
    batch: getFn$1(props4.batch)
  }));
  const isUploading = computed(() => workingThreads.value > 0);
  const isBusy = computed(() => promises.value.length !== 0);
  let abortPromises;
  function abort() {
    xhrs.value.forEach((x22) => {
      x22.abort();
    });
    if (promises.value.length !== 0) {
      abortPromises = true;
    }
  }
  function upload() {
    const queue2 = helpers2.queuedFiles.value.slice(0);
    helpers2.queuedFiles.value = [];
    if (xhrProps.value.batch(queue2)) {
      runFactory(queue2);
    } else {
      queue2.forEach((file) => {
        runFactory([file]);
      });
    }
  }
  function runFactory(files) {
    workingThreads.value++;
    if (typeof props4.factory !== "function") {
      performUpload(files, {});
      return;
    }
    const res = props4.factory(files);
    if (!res) {
      emit(
        "factoryFailed",
        new Error("QUploader: factory() does not return properly"),
        files
      );
      workingThreads.value--;
    } else if (typeof res.catch === "function" && typeof res.then === "function") {
      promises.value.push(res);
      const failed = (err) => {
        if (helpers2.isAlive() === true) {
          promises.value = promises.value.filter((p2) => p2 !== res);
          if (promises.value.length === 0) {
            abortPromises = false;
          }
          helpers2.queuedFiles.value = helpers2.queuedFiles.value.concat(files);
          files.forEach((f) => {
            helpers2.updateFileStatus(f, "failed");
          });
          emit("factoryFailed", err, files);
          workingThreads.value--;
        }
      };
      res.then((factory) => {
        if (abortPromises === true) {
          failed(new Error("Aborted"));
        } else if (helpers2.isAlive() === true) {
          promises.value = promises.value.filter((p2) => p2 !== res);
          performUpload(files, factory);
        }
      }).catch(failed);
    } else {
      performUpload(files, res || {});
    }
  }
  function performUpload(files, factory) {
    const form = new FormData(), xhr2 = new XMLHttpRequest();
    const getProp2 = (name2, arg) => {
      return factory[name2] !== void 0 ? getFn$1(factory[name2])(arg) : xhrProps.value[name2](arg);
    };
    const url = getProp2("url", files);
    if (!url) {
      console.error("q-uploader: invalid or no URL specified");
      workingThreads.value--;
      return;
    }
    const fields = getProp2("formFields", files);
    fields !== void 0 && fields.forEach((field) => {
      form.append(field.name, field.value);
    });
    let uploadIndex = 0, uploadIndexSize = 0, localUploadedSize = 0, maxUploadSize = 0, aborted;
    xhr2.upload.addEventListener("progress", (e22) => {
      if (aborted === true) return;
      const loaded = Math.min(maxUploadSize, e22.loaded);
      helpers2.uploadedSize.value += loaded - localUploadedSize;
      localUploadedSize = loaded;
      let size2 = localUploadedSize - uploadIndexSize;
      for (let i22 = uploadIndex; size2 > 0 && i22 < files.length; i22++) {
        const file = files[i22], uploaded = size2 > file.size;
        if (uploaded) {
          size2 -= file.size;
          uploadIndex++;
          uploadIndexSize += file.size;
          helpers2.updateFileStatus(file, "uploading", file.size);
        } else {
          helpers2.updateFileStatus(file, "uploading", size2);
          return;
        }
      }
    }, false);
    xhr2.onreadystatechange = () => {
      if (xhr2.readyState < 4) {
        return;
      }
      if (xhr2.status && xhr2.status < 400) {
        helpers2.uploadedFiles.value = helpers2.uploadedFiles.value.concat(files);
        files.forEach((f) => {
          helpers2.updateFileStatus(f, "uploaded");
        });
        emit("uploaded", { files, xhr: xhr2 });
      } else {
        aborted = true;
        helpers2.uploadedSize.value -= localUploadedSize;
        helpers2.queuedFiles.value = helpers2.queuedFiles.value.concat(files);
        files.forEach((f) => {
          helpers2.updateFileStatus(f, "failed");
        });
        emit("failed", { files, xhr: xhr2 });
      }
      workingThreads.value--;
      xhrs.value = xhrs.value.filter((x22) => x22 !== xhr2);
    };
    xhr2.open(
      getProp2("method", files),
      url
    );
    if (getProp2("withCredentials", files) === true) {
      xhr2.withCredentials = true;
    }
    const headers = getProp2("headers", files);
    headers !== void 0 && headers.forEach((head) => {
      xhr2.setRequestHeader(head.name, head.value);
    });
    const sendRaw = getProp2("sendRaw", files);
    files.forEach((file) => {
      helpers2.updateFileStatus(file, "uploading", 0);
      if (sendRaw !== true) {
        form.append(getProp2("fieldName", file), file, file.name);
      }
      file.xhr = xhr2;
      file.__abort = () => {
        xhr2.abort();
      };
      maxUploadSize += file.size;
    });
    emit("uploading", { files, xhr: xhr2 });
    xhrs.value.push(xhr2);
    if (sendRaw === true) {
      xhr2.send(new Blob(files));
    } else {
      xhr2.send(form);
    }
  }
  return {
    isUploading,
    isBusy,
    abort,
    upload
  };
}
var xhr_uploader_plugin_default$1 = {
  name: name$1,
  props: props$1,
  emits: emits$1,
  injectPlugin: injectPlugin$1
};
create_uploader_component_default$1(xhr_uploader_plugin_default$1);
createComponent$1({
  name: "QUploaderAddTrigger",
  setup() {
    const $trigger = inject(uploaderKey$1, emptyRenderFn$1);
    if ($trigger === emptyRenderFn$1) {
      console.error("QUploaderAddTrigger needs to be child of QUploader");
    }
    return $trigger;
  }
});
createComponent$1({
  name: "QVideo",
  props: {
    ...useRatioProps$1,
    src: {
      type: String,
      required: true
    },
    title: String,
    fetchpriority: {
      type: String,
      default: "auto"
    },
    loading: {
      type: String,
      default: "eager"
    },
    referrerpolicy: {
      type: String,
      default: "strict-origin-when-cross-origin"
    }
  },
  setup(props4) {
    const ratioStyle = use_ratio_default$1(props4);
    const classes = computed(
      () => "q-video" + (props4.ratio !== void 0 ? " q-video--responsive" : "")
    );
    return () => h("div", {
      class: classes.value,
      style: ratioStyle.value
    }, [
      h("iframe", {
        src: props4.src,
        title: props4.title,
        fetchpriority: props4.fetchpriority,
        loading: props4.loading,
        referrerpolicy: props4.referrerpolicy,
        frameborder: "0",
        allowfullscreen: true
      })
    ]);
  }
});
function getDepth$1(value2) {
  if (value2 === false) {
    return 0;
  }
  if (value2 === true || value2 === void 0) {
    return 1;
  }
  const depth = parseInt(value2, 10);
  return isNaN(depth) ? 0 : depth;
}
createDirective$1(
  {
    name: "close-popup",
    beforeMount(el, { value: value2 }) {
      const ctx = {
        depth: getDepth$1(value2),
        handler(evt) {
          ctx.depth !== 0 && setTimeout(() => {
            const proxy = getPortalProxy$1(el);
            if (proxy !== void 0) {
              closePortals$1(proxy, evt, ctx.depth);
            }
          });
        },
        handlerKey(evt) {
          isKeyCode$1(evt, 13) === true && ctx.handler(evt);
        }
      };
      el.__qclosepopup = ctx;
      el.addEventListener("click", ctx.handler);
      el.addEventListener("keyup", ctx.handlerKey);
    },
    updated(el, { value: value2, oldValue }) {
      if (value2 !== oldValue) {
        el.__qclosepopup.depth = getDepth$1(value2);
      }
    },
    beforeUnmount(el) {
      const ctx = el.__qclosepopup;
      el.removeEventListener("click", ctx.handler);
      el.removeEventListener("keyup", ctx.handlerKey);
      delete el.__qclosepopup;
    }
  }
);
var id2$1 = 0;
var offsetBase$1 = void 0;
function getAbsolutePosition$1(el, resize) {
  if (offsetBase$1 === void 0) {
    offsetBase$1 = document.createElement("div");
    offsetBase$1.style.cssText = "position: absolute; left: 0; top: 0";
    document.body.appendChild(offsetBase$1);
  }
  const boundingRect = el.getBoundingClientRect();
  const baseRect = offsetBase$1.getBoundingClientRect();
  const { marginLeft, marginRight, marginTop, marginBottom } = window.getComputedStyle(el);
  const marginH = parseInt(marginLeft, 10) + parseInt(marginRight, 10);
  const marginV = parseInt(marginTop, 10) + parseInt(marginBottom, 10);
  return {
    left: boundingRect.left - baseRect.left,
    top: boundingRect.top - baseRect.top,
    width: boundingRect.right - boundingRect.left,
    height: boundingRect.bottom - boundingRect.top,
    widthM: boundingRect.right - boundingRect.left + (resize === true ? 0 : marginH),
    heightM: boundingRect.bottom - boundingRect.top + (resize === true ? 0 : marginV),
    marginH: resize === true ? marginH : 0,
    marginV: resize === true ? marginV : 0
  };
}
function getAbsoluteSize$1(el) {
  return {
    width: el.scrollWidth,
    height: el.scrollHeight
  };
}
var styleEdges$1 = ["Top", "Right", "Bottom", "Left"];
var styleBorderRadiuses$1 = ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"];
var reStyleSkipKey$1 = /-block|-inline|block-|inline-/;
var reStyleSkipRule$1 = /(-block|-inline|block-|inline-).*:/;
function getComputedStyle2$1(el, props4) {
  const style2 = window.getComputedStyle(el);
  const fixed = {};
  for (let i22 = 0; i22 < props4.length; i22++) {
    const prop = props4[i22];
    if (style2[prop] === "") {
      if (prop === "cssText") {
        const styleLen = style2.length;
        let val = "";
        for (let i222 = 0; i222 < styleLen; i222++) {
          if (reStyleSkipKey$1.test(style2[i222]) !== true) {
            val += style2[i222] + ": " + style2[style2[i222]] + "; ";
          }
        }
        fixed[prop] = val;
      } else if (["borderWidth", "borderStyle", "borderColor"].indexOf(prop) !== -1) {
        const suffix = prop.replace("border", "");
        let val = "";
        for (let j = 0; j < styleEdges$1.length; j++) {
          const subProp = "border" + styleEdges$1[j] + suffix;
          val += style2[subProp] + " ";
        }
        fixed[prop] = val;
      } else if (prop === "borderRadius") {
        let val1 = "";
        let val2 = "";
        for (let j = 0; j < styleBorderRadiuses$1.length; j++) {
          const val = style2[styleBorderRadiuses$1[j]].split(" ");
          val1 += val[0] + " ";
          val2 += (val[1] === void 0 ? val[0] : val[1]) + " ";
        }
        fixed[prop] = val1 + "/ " + val2;
      } else {
        fixed[prop] = style2[prop];
      }
    } else {
      if (prop === "cssText") {
        fixed[prop] = style2[prop].split(";").filter((val) => reStyleSkipRule$1.test(val) !== true).join(";");
      } else {
        fixed[prop] = style2[prop];
      }
    }
  }
  return fixed;
}
var zIndexPositions$1 = ["absolute", "fixed", "relative", "sticky"];
function getMaxZIndex$1(elStart) {
  let el = elStart;
  let maxIndex = 0;
  while (el !== null && el !== document) {
    const { position: position2, zIndex } = window.getComputedStyle(el);
    const zIndexNum = Number(zIndex);
    if (zIndexNum > maxIndex && (el === elStart || zIndexPositions$1.includes(position2) === true)) {
      maxIndex = zIndexNum;
    }
    el = el.parentNode;
  }
  return maxIndex;
}
function normalizeElements$1(opts) {
  return {
    from: opts.from,
    to: opts.to !== void 0 ? opts.to : opts.from
  };
}
function normalizeOptions$1(options) {
  if (typeof options === "number") {
    options = {
      duration: options
    };
  } else if (typeof options === "function") {
    options = {
      onEnd: options
    };
  }
  return {
    ...options,
    waitFor: options.waitFor === void 0 ? 0 : options.waitFor,
    duration: isNaN(options.duration) === true ? 300 : parseInt(options.duration, 10),
    easing: typeof options.easing === "string" && options.easing.length !== 0 ? options.easing : "ease-in-out",
    delay: isNaN(options.delay) === true ? 0 : parseInt(options.delay, 10),
    fill: typeof options.fill === "string" && options.fill.length !== 0 ? options.fill : "none",
    resize: options.resize === true,
    // account for UMD too where modifiers will be lowercased to work
    useCSS: options.useCSS === true || options.usecss === true,
    // account for UMD too where modifiers will be lowercased to work
    hideFromClone: options.hideFromClone === true || options.hidefromclone === true,
    // account for UMD too where modifiers will be lowercased to work
    keepToClone: options.keepToClone === true || options.keeptoclone === true,
    tween: options.tween === true,
    tweenFromOpacity: isNaN(options.tweenFromOpacity) === true ? 0.6 : parseFloat(options.tweenFromOpacity),
    tweenToOpacity: isNaN(options.tweenToOpacity) === true ? 0.5 : parseFloat(options.tweenToOpacity)
  };
}
function getElement2$1(element) {
  const type2 = typeof element;
  return type2 === "function" ? element() : type2 === "string" ? document.querySelector(element) : element;
}
function isValidElement$1(element) {
  return element && element.ownerDocument === document && element.parentNode !== null;
}
function morph$1(_options) {
  let cancel = () => false;
  let cancelStatus = false;
  let endElementTo = true;
  const elements = normalizeElements$1(_options);
  const options = normalizeOptions$1(_options);
  const elFrom = getElement2$1(elements.from);
  if (isValidElement$1(elFrom) !== true) {
    return cancel;
  }
  typeof elFrom.qMorphCancel === "function" && elFrom.qMorphCancel();
  let animationFromClone = void 0;
  let animationFromTween = void 0;
  let animationToClone = void 0;
  let animationTo = void 0;
  const elFromParent = elFrom.parentNode;
  const elFromNext = elFrom.nextElementSibling;
  const elFromPosition = getAbsolutePosition$1(elFrom, options.resize);
  const {
    width: elFromParentWidthBefore,
    height: elFromParentHeightBefore
  } = getAbsoluteSize$1(elFromParent);
  const {
    borderWidth: elFromBorderWidth,
    borderStyle: elFromBorderStyle,
    borderColor: elFromBorderColor,
    borderRadius: elFromBorderRadius,
    backgroundColor: elFromBackground,
    transform: elFromTransform,
    position: elFromPositioningType,
    cssText: elFromCssText
  } = getComputedStyle2$1(elFrom, ["borderWidth", "borderStyle", "borderColor", "borderRadius", "backgroundColor", "transform", "position", "cssText"]);
  const elFromClassSaved = elFrom.classList.toString();
  const elFromStyleSaved = elFrom.style.cssText;
  const elFromClone = elFrom.cloneNode(true);
  const elFromTween = options.tween === true ? elFrom.cloneNode(true) : void 0;
  if (elFromTween !== void 0) {
    elFromTween.className = elFromTween.classList.toString().split(" ").filter((c3) => /^bg-/.test(c3) === false).join(" ");
  }
  options.hideFromClone === true && elFromClone.classList.add("q-morph--internal");
  elFromClone.setAttribute("aria-hidden", "true");
  elFromClone.style.transition = "none";
  elFromClone.style.animation = "none";
  elFromClone.style.pointerEvents = "none";
  elFromParent.insertBefore(elFromClone, elFromNext);
  elFrom.qMorphCancel = () => {
    cancelStatus = true;
    elFromClone.remove();
    elFromTween !== void 0 && elFromTween.remove();
    options.hideFromClone === true && elFromClone.classList.remove("q-morph--internal");
    elFrom.qMorphCancel = void 0;
  };
  const calculateFinalState = () => {
    const elTo = getElement2$1(elements.to);
    if (cancelStatus === true || isValidElement$1(elTo) !== true) {
      typeof elFrom.qMorphCancel === "function" && elFrom.qMorphCancel();
      return;
    }
    elFrom !== elTo && typeof elTo.qMorphCancel === "function" && elTo.qMorphCancel();
    options.keepToClone !== true && elTo.classList.add("q-morph--internal");
    elFromClone.classList.add("q-morph--internal");
    const {
      width: elFromParentWidthAfter,
      height: elFromParentHeightAfter
    } = getAbsoluteSize$1(elFromParent);
    const {
      width: elToParentWidthBefore,
      height: elToParentHeightBefore
    } = getAbsoluteSize$1(elTo.parentNode);
    options.hideFromClone !== true && elFromClone.classList.remove("q-morph--internal");
    elTo.qMorphCancel = () => {
      cancelStatus = true;
      elFromClone.remove();
      elFromTween !== void 0 && elFromTween.remove();
      options.hideFromClone === true && elFromClone.classList.remove("q-morph--internal");
      options.keepToClone !== true && elTo.classList.remove("q-morph--internal");
      elFrom.qMorphCancel = void 0;
      elTo.qMorphCancel = void 0;
    };
    const animate = () => {
      if (cancelStatus === true) {
        typeof elTo.qMorphCancel === "function" && elTo.qMorphCancel();
        return;
      }
      if (options.hideFromClone !== true) {
        elFromClone.classList.add("q-morph--internal");
        elFromClone.innerHTML = "";
        elFromClone.style.left = 0;
        elFromClone.style.right = "unset";
        elFromClone.style.top = 0;
        elFromClone.style.bottom = "unset";
        elFromClone.style.transform = "none";
      }
      if (options.keepToClone !== true) {
        elTo.classList.remove("q-morph--internal");
      }
      const elToParent = elTo.parentNode;
      const {
        width: elToParentWidthAfter,
        height: elToParentHeightAfter
      } = getAbsoluteSize$1(elToParent);
      const elToClone = elTo.cloneNode(options.keepToClone);
      elToClone.setAttribute("aria-hidden", "true");
      if (options.keepToClone !== true) {
        elToClone.style.left = 0;
        elToClone.style.right = "unset";
        elToClone.style.top = 0;
        elToClone.style.bottom = "unset";
        elToClone.style.transform = "none";
        elToClone.style.pointerEvents = "none";
      }
      elToClone.classList.add("q-morph--internal");
      const elToNext = elTo === elFrom && elFromParent === elToParent ? elFromClone : elTo.nextElementSibling;
      elToParent.insertBefore(elToClone, elToNext);
      const {
        borderWidth: elToBorderWidth,
        borderStyle: elToBorderStyle,
        borderColor: elToBorderColor,
        borderRadius: elToBorderRadius,
        backgroundColor: elToBackground,
        transform: elToTransform,
        position: elToPositioningType,
        cssText: elToCssText
      } = getComputedStyle2$1(elTo, ["borderWidth", "borderStyle", "borderColor", "borderRadius", "backgroundColor", "transform", "position", "cssText"]);
      const elToClassSaved = elTo.classList.toString();
      const elToStyleSaved = elTo.style.cssText;
      elTo.style.cssText = elToCssText;
      elTo.style.transform = "none";
      elTo.style.animation = "none";
      elTo.style.transition = "none";
      elTo.className = elToClassSaved.split(" ").filter((c3) => /^bg-/.test(c3) === false).join(" ");
      const elToPosition = getAbsolutePosition$1(elTo, options.resize);
      const deltaX = elFromPosition.left - elToPosition.left;
      const deltaY = elFromPosition.top - elToPosition.top;
      const scaleX = elFromPosition.width / (elToPosition.width > 0 ? elToPosition.width : 10);
      const scaleY = elFromPosition.height / (elToPosition.height > 0 ? elToPosition.height : 100);
      const elFromParentWidthDiff = elFromParentWidthBefore - elFromParentWidthAfter;
      const elFromParentHeightDiff = elFromParentHeightBefore - elFromParentHeightAfter;
      const elToParentWidthDiff = elToParentWidthAfter - elToParentWidthBefore;
      const elToParentHeightDiff = elToParentHeightAfter - elToParentHeightBefore;
      const elFromCloneWidth = Math.max(elFromPosition.widthM, elFromParentWidthDiff);
      const elFromCloneHeight = Math.max(elFromPosition.heightM, elFromParentHeightDiff);
      const elToCloneWidth = Math.max(elToPosition.widthM, elToParentWidthDiff);
      const elToCloneHeight = Math.max(elToPosition.heightM, elToParentHeightDiff);
      const elSharedSize = elFrom === elTo && ["absolute", "fixed"].includes(elToPositioningType) === false && ["absolute", "fixed"].includes(elFromPositioningType) === false;
      let elToNeedsFixedPosition = elToPositioningType === "fixed";
      let parent = elToParent;
      while (elToNeedsFixedPosition !== true && parent !== document) {
        elToNeedsFixedPosition = window.getComputedStyle(parent).position === "fixed";
        parent = parent.parentNode;
      }
      if (options.hideFromClone !== true) {
        elFromClone.style.display = "block";
        elFromClone.style.flex = "0 0 auto";
        elFromClone.style.opacity = 0;
        elFromClone.style.minWidth = "unset";
        elFromClone.style.maxWidth = "unset";
        elFromClone.style.minHeight = "unset";
        elFromClone.style.maxHeight = "unset";
        elFromClone.classList.remove("q-morph--internal");
      }
      if (options.keepToClone !== true) {
        elToClone.style.display = "block";
        elToClone.style.flex = "0 0 auto";
        elToClone.style.opacity = 0;
        elToClone.style.minWidth = "unset";
        elToClone.style.maxWidth = "unset";
        elToClone.style.minHeight = "unset";
        elToClone.style.maxHeight = "unset";
      }
      elToClone.classList.remove("q-morph--internal");
      if (typeof options.classes === "string") {
        elTo.className += " " + options.classes;
      }
      if (typeof options.style === "string") {
        elTo.style.cssText += " " + options.style;
      } else if (isObject$1(options.style) === true) {
        for (const prop in options.style) {
          elTo.style[prop] = options.style[prop];
        }
      }
      const elFromZIndex = getMaxZIndex$1(elFromClone);
      const elToZIndex = getMaxZIndex$1(elTo);
      const documentScroll = elToNeedsFixedPosition === true ? document.documentElement : { scrollLeft: 0, scrollTop: 0 };
      elTo.style.position = elToNeedsFixedPosition === true ? "fixed" : "absolute";
      elTo.style.left = `${elToPosition.left - documentScroll.scrollLeft}px`;
      elTo.style.right = "unset";
      elTo.style.top = `${elToPosition.top - documentScroll.scrollTop}px`;
      elTo.style.margin = 0;
      if (options.resize === true) {
        elTo.style.minWidth = "unset";
        elTo.style.maxWidth = "unset";
        elTo.style.minHeight = "unset";
        elTo.style.maxHeight = "unset";
        elTo.style.overflow = "hidden";
        elTo.style.overflowX = "hidden";
        elTo.style.overflowY = "hidden";
      }
      document.body.appendChild(elTo);
      if (elFromTween !== void 0) {
        elFromTween.style.cssText = elFromCssText;
        elFromTween.style.transform = "none";
        elFromTween.style.animation = "none";
        elFromTween.style.transition = "none";
        elFromTween.style.position = elTo.style.position;
        elFromTween.style.left = `${elFromPosition.left - documentScroll.scrollLeft}px`;
        elFromTween.style.right = "unset";
        elFromTween.style.top = `${elFromPosition.top - documentScroll.scrollTop}px`;
        elFromTween.style.margin = 0;
        elFromTween.style.pointerEvents = "none";
        if (options.resize === true) {
          elFromTween.style.minWidth = "unset";
          elFromTween.style.maxWidth = "unset";
          elFromTween.style.minHeight = "unset";
          elFromTween.style.maxHeight = "unset";
          elFromTween.style.overflow = "hidden";
          elFromTween.style.overflowX = "hidden";
          elFromTween.style.overflowY = "hidden";
        }
        document.body.appendChild(elFromTween);
      }
      const commonCleanup = (aborted) => {
        if (elFrom === elTo && endElementTo !== true) {
          elTo.style.cssText = elFromStyleSaved;
          elTo.className = elFromClassSaved;
        } else {
          elTo.style.cssText = elToStyleSaved;
          elTo.className = elToClassSaved;
        }
        elToClone.parentNode === elToParent && elToParent.insertBefore(elTo, elToClone);
        elFromClone.remove();
        elToClone.remove();
        elFromTween !== void 0 && elFromTween.remove();
        cancel = () => false;
        elFrom.qMorphCancel = void 0;
        elTo.qMorphCancel = void 0;
        if (typeof options.onEnd === "function") {
          options.onEnd(endElementTo === true ? "to" : "from", aborted === true);
        }
      };
      if (options.useCSS !== true && typeof elTo.animate === "function") {
        const resizeFrom = options.resize === true ? {
          transform: `translate(${deltaX}px, ${deltaY}px)`,
          width: `${elFromCloneWidth}px`,
          height: `${elFromCloneHeight}px`
        } : {
          transform: `translate(${deltaX}px, ${deltaY}px) scale(${scaleX}, ${scaleY})`
        };
        const resizeTo = options.resize === true ? {
          width: `${elToCloneWidth}px`,
          height: `${elToCloneHeight}px`
        } : {};
        const resizeFromTween = options.resize === true ? {
          width: `${elFromCloneWidth}px`,
          height: `${elFromCloneHeight}px`
        } : {};
        const resizeToTween = options.resize === true ? {
          transform: `translate(${-1 * deltaX}px, ${-1 * deltaY}px)`,
          width: `${elToCloneWidth}px`,
          height: `${elToCloneHeight}px`
        } : {
          transform: `translate(${-1 * deltaX}px, ${-1 * deltaY}px) scale(${1 / scaleX}, ${1 / scaleY})`
        };
        const tweenFrom = elFromTween !== void 0 ? { opacity: options.tweenToOpacity } : { backgroundColor: elFromBackground };
        const tweenTo = elFromTween !== void 0 ? { opacity: 1 } : { backgroundColor: elToBackground };
        animationTo = elTo.animate([
          {
            margin: 0,
            borderWidth: elFromBorderWidth,
            borderStyle: elFromBorderStyle,
            borderColor: elFromBorderColor,
            borderRadius: elFromBorderRadius,
            zIndex: elFromZIndex,
            transformOrigin: "0 0",
            ...resizeFrom,
            ...tweenFrom
          },
          {
            margin: 0,
            borderWidth: elToBorderWidth,
            borderStyle: elToBorderStyle,
            borderColor: elToBorderColor,
            borderRadius: elToBorderRadius,
            zIndex: elToZIndex,
            transformOrigin: "0 0",
            transform: elToTransform,
            ...resizeTo,
            ...tweenTo
          }
        ], {
          duration: options.duration,
          easing: options.easing,
          fill: options.fill,
          delay: options.delay
        });
        animationFromTween = elFromTween === void 0 ? void 0 : elFromTween.animate([
          {
            opacity: options.tweenFromOpacity,
            margin: 0,
            borderWidth: elFromBorderWidth,
            borderStyle: elFromBorderStyle,
            borderColor: elFromBorderColor,
            borderRadius: elFromBorderRadius,
            zIndex: elFromZIndex,
            transformOrigin: "0 0",
            transform: elFromTransform,
            ...resizeFromTween
          },
          {
            opacity: 0,
            margin: 0,
            borderWidth: elToBorderWidth,
            borderStyle: elToBorderStyle,
            borderColor: elToBorderColor,
            borderRadius: elToBorderRadius,
            zIndex: elToZIndex,
            transformOrigin: "0 0",
            ...resizeToTween
          }
        ], {
          duration: options.duration,
          easing: options.easing,
          fill: options.fill,
          delay: options.delay
        });
        animationFromClone = options.hideFromClone === true || elSharedSize === true ? void 0 : elFromClone.animate([
          {
            margin: `${elFromParentHeightDiff < 0 ? elFromParentHeightDiff / 2 : 0}px ${elFromParentWidthDiff < 0 ? elFromParentWidthDiff / 2 : 0}px`,
            width: `${elFromCloneWidth + elFromPosition.marginH}px`,
            height: `${elFromCloneHeight + elFromPosition.marginV}px`
          },
          {
            margin: 0,
            width: 0,
            height: 0
          }
        ], {
          duration: options.duration,
          easing: options.easing,
          fill: options.fill,
          delay: options.delay
        });
        animationToClone = options.keepToClone === true ? void 0 : elToClone.animate([
          elSharedSize === true ? {
            margin: `${elFromParentHeightDiff < 0 ? elFromParentHeightDiff / 2 : 0}px ${elFromParentWidthDiff < 0 ? elFromParentWidthDiff / 2 : 0}px`,
            width: `${elFromCloneWidth + elFromPosition.marginH}px`,
            height: `${elFromCloneHeight + elFromPosition.marginV}px`
          } : {
            margin: 0,
            width: 0,
            height: 0
          },
          {
            margin: `${elToParentHeightDiff < 0 ? elToParentHeightDiff / 2 : 0}px ${elToParentWidthDiff < 0 ? elToParentWidthDiff / 2 : 0}px`,
            width: `${elToCloneWidth + elToPosition.marginH}px`,
            height: `${elToCloneHeight + elToPosition.marginV}px`
          }
        ], {
          duration: options.duration,
          easing: options.easing,
          fill: options.fill,
          delay: options.delay
        });
        const cleanup = (abort) => {
          animationFromClone !== void 0 && animationFromClone.cancel();
          animationFromTween !== void 0 && animationFromTween.cancel();
          animationToClone !== void 0 && animationToClone.cancel();
          animationTo.cancel();
          animationTo.removeEventListener("finish", cleanup);
          animationTo.removeEventListener("cancel", cleanup);
          commonCleanup(abort);
          animationFromClone = void 0;
          animationFromTween = void 0;
          animationToClone = void 0;
          animationTo = void 0;
        };
        elFrom.qMorphCancel = () => {
          elFrom.qMorphCancel = void 0;
          cancelStatus = true;
          cleanup();
        };
        elTo.qMorphCancel = () => {
          elTo.qMorphCancel = void 0;
          cancelStatus = true;
          cleanup();
        };
        animationTo.addEventListener("finish", cleanup);
        animationTo.addEventListener("cancel", cleanup);
        cancel = (abort) => {
          if (cancelStatus === true || animationTo === void 0) {
            return false;
          }
          if (abort === true) {
            cleanup(true);
            return true;
          }
          endElementTo = endElementTo !== true;
          animationFromClone !== void 0 && animationFromClone.reverse();
          animationFromTween !== void 0 && animationFromTween.reverse();
          animationToClone !== void 0 && animationToClone.reverse();
          animationTo.reverse();
          return true;
        };
      } else {
        const qAnimId = `q-morph-anim-${++id2$1}`;
        const style2 = document.createElement("style");
        const resizeFrom = options.resize === true ? `
            transform: translate(${deltaX}px, ${deltaY}px);
            width: ${elFromCloneWidth}px;
            height: ${elFromCloneHeight}px;
          ` : `transform: translate(${deltaX}px, ${deltaY}px) scale(${scaleX}, ${scaleY});`;
        const resizeTo = options.resize === true ? `
            width: ${elToCloneWidth}px;
            height: ${elToCloneHeight}px;
          ` : "";
        const resizeFromTween = options.resize === true ? `
            width: ${elFromCloneWidth}px;
            height: ${elFromCloneHeight}px;
          ` : "";
        const resizeToTween = options.resize === true ? `
            transform: translate(${-1 * deltaX}px, ${-1 * deltaY}px);
            width: ${elToCloneWidth}px;
            height: ${elToCloneHeight}px;
          ` : `transform: translate(${-1 * deltaX}px, ${-1 * deltaY}px) scale(${1 / scaleX}, ${1 / scaleY});`;
        const tweenFrom = elFromTween !== void 0 ? `opacity: ${options.tweenToOpacity};` : `background-color: ${elFromBackground};`;
        const tweenTo = elFromTween !== void 0 ? "opacity: 1;" : `background-color: ${elToBackground};`;
        const keyframesFromTween = elFromTween === void 0 ? "" : `
            @keyframes ${qAnimId}-from-tween {
              0% {
                opacity: ${options.tweenFromOpacity};
                margin: 0;
                border-width: ${elFromBorderWidth};
                border-style: ${elFromBorderStyle};
                border-color: ${elFromBorderColor};
                border-radius: ${elFromBorderRadius};
                z-index: ${elFromZIndex};
                transform-origin: 0 0;
                transform: ${elFromTransform};
                ${resizeFromTween}
              }

              100% {
                opacity: 0;
                margin: 0;
                border-width: ${elToBorderWidth};
                border-style: ${elToBorderStyle};
                border-color: ${elToBorderColor};
                border-radius: ${elToBorderRadius};
                z-index: ${elToZIndex};
                transform-origin: 0 0;
                ${resizeToTween}
              }
            }
          `;
        const keyframesFrom = options.hideFromClone === true || elSharedSize === true ? "" : `
            @keyframes ${qAnimId}-from {
              0% {
                margin: ${elFromParentHeightDiff < 0 ? elFromParentHeightDiff / 2 : 0}px ${elFromParentWidthDiff < 0 ? elFromParentWidthDiff / 2 : 0}px;
                width: ${elFromCloneWidth + elFromPosition.marginH}px;
                height: ${elFromCloneHeight + elFromPosition.marginV}px;
              }

              100% {
                margin: 0;
                width: 0;
                height: 0;
              }
            }
          `;
        const keyframeToStart = elSharedSize === true ? `
            margin: ${elFromParentHeightDiff < 0 ? elFromParentHeightDiff / 2 : 0}px ${elFromParentWidthDiff < 0 ? elFromParentWidthDiff / 2 : 0}px;
            width: ${elFromCloneWidth + elFromPosition.marginH}px;
            height: ${elFromCloneHeight + elFromPosition.marginV}px;
          ` : `
            margin: 0;
            width: 0;
            height: 0;
          `;
        const keyframesTo = options.keepToClone === true ? "" : `
            @keyframes ${qAnimId}-to {
              0% {
                ${keyframeToStart}
              }

              100% {
                margin: ${elToParentHeightDiff < 0 ? elToParentHeightDiff / 2 : 0}px ${elToParentWidthDiff < 0 ? elToParentWidthDiff / 2 : 0}px;
                width: ${elToCloneWidth + elToPosition.marginH}px;
                height: ${elToCloneHeight + elToPosition.marginV}px;
              }
            }
          `;
        style2.innerHTML = `
          @keyframes ${qAnimId} {
            0% {
              margin: 0;
              border-width: ${elFromBorderWidth};
              border-style: ${elFromBorderStyle};
              border-color: ${elFromBorderColor};
              border-radius: ${elFromBorderRadius};
              background-color: ${elFromBackground};
              z-index: ${elFromZIndex};
              transform-origin: 0 0;
              ${resizeFrom}
              ${tweenFrom}
            }

            100% {
              margin: 0;
              border-width: ${elToBorderWidth};
              border-style: ${elToBorderStyle};
              border-color: ${elToBorderColor};
              border-radius: ${elToBorderRadius};
              background-color: ${elToBackground};
              z-index: ${elToZIndex};
              transform-origin: 0 0;
              transform: ${elToTransform};
              ${resizeTo}
              ${tweenTo}
            }
          }

          ${keyframesFrom}

          ${keyframesFromTween}

          ${keyframesTo}
        `;
        document.head.appendChild(style2);
        let animationDirection = "normal";
        elFromClone.style.animation = `${options.duration}ms ${options.easing} ${options.delay}ms ${animationDirection} ${options.fill} ${qAnimId}-from`;
        if (elFromTween !== void 0) {
          elFromTween.style.animation = `${options.duration}ms ${options.easing} ${options.delay}ms ${animationDirection} ${options.fill} ${qAnimId}-from-tween`;
        }
        elToClone.style.animation = `${options.duration}ms ${options.easing} ${options.delay}ms ${animationDirection} ${options.fill} ${qAnimId}-to`;
        elTo.style.animation = `${options.duration}ms ${options.easing} ${options.delay}ms ${animationDirection} ${options.fill} ${qAnimId}`;
        const cleanup = (evt) => {
          if (evt === Object(evt) && evt.animationName !== qAnimId) {
            return;
          }
          elTo.removeEventListener("animationend", cleanup);
          elTo.removeEventListener("animationcancel", cleanup);
          commonCleanup();
          style2.remove();
        };
        elFrom.qMorphCancel = () => {
          elFrom.qMorphCancel = void 0;
          cancelStatus = true;
          cleanup();
        };
        elTo.qMorphCancel = () => {
          elTo.qMorphCancel = void 0;
          cancelStatus = true;
          cleanup();
        };
        elTo.addEventListener("animationend", cleanup);
        elTo.addEventListener("animationcancel", cleanup);
        cancel = (abort) => {
          if (cancelStatus === true || !elTo || !elFromClone || !elToClone) {
            return false;
          }
          if (abort === true) {
            cleanup();
            return true;
          }
          endElementTo = endElementTo !== true;
          animationDirection = animationDirection === "normal" ? "reverse" : "normal";
          elFromClone.style.animationDirection = animationDirection;
          elFromTween.style.animationDirection = animationDirection;
          elToClone.style.animationDirection = animationDirection;
          elTo.style.animationDirection = animationDirection;
          return true;
        };
      }
    };
    if (options.waitFor > 0 || options.waitFor === "transitionend" || options.waitFor === Object(options.waitFor) && typeof options.waitFor.then === "function") {
      const delayPromise = options.waitFor > 0 ? new Promise((resolve2) => setTimeout(resolve2, options.waitFor)) : options.waitFor === "transitionend" ? new Promise((resolve2) => {
        const endFn = () => {
          if (timer2 !== null) {
            clearTimeout(timer2);
            timer2 = null;
          }
          if (elTo) {
            elTo.removeEventListener("transitionend", endFn);
            elTo.removeEventListener("transitioncancel", endFn);
          }
          resolve2();
        };
        let timer2 = setTimeout(endFn, 400);
        elTo.addEventListener("transitionend", endFn);
        elTo.addEventListener("transitioncancel", endFn);
      }) : options.waitFor;
      delayPromise.then(animate).catch(() => {
        typeof elTo.qMorphCancel === "function" && elTo.qMorphCancel();
      });
    } else {
      animate();
    }
  };
  typeof _options.onToggle === "function" && _options.onToggle();
  requestAnimationFrame(calculateFinalState);
  return (abort) => cancel(abort);
}
var morphGroups$1 = {};
var props2$1 = [
  "duration",
  "delay",
  "easing",
  "fill",
  "classes",
  "style",
  "duration",
  "resize",
  "useCSS",
  "hideFromClone",
  "keepToClone",
  "tween",
  "tweenFromOpacity",
  "tweenToOpacity",
  "waitFor",
  "onEnd"
];
var mods$1 = [
  "resize",
  "useCSS",
  "hideFromClone",
  "keepToClone",
  "tween"
];
function changeClass$1(ctx, action) {
  if (ctx.clsAction !== action) {
    ctx.clsAction = action;
    ctx.el.classList[action]("q-morph--invisible");
  }
}
function trigger2$1(group) {
  if (group.animating === true || group.queue.length < 2) {
    return;
  }
  const [from2, to2] = group.queue;
  group.animating = true;
  from2.animating = true;
  to2.animating = true;
  changeClass$1(from2, "remove");
  changeClass$1(to2, "remove");
  const cancelFn = morph$1({
    from: from2.el,
    to: to2.el,
    onToggle() {
      changeClass$1(from2, "add");
      changeClass$1(to2, "remove");
    },
    ...to2.opts,
    onEnd(dir, aborted) {
      to2.opts.onEnd !== void 0 && to2.opts.onEnd(dir, aborted);
      if (aborted === true) {
        return;
      }
      from2.animating = false;
      to2.animating = false;
      group.animating = false;
      group.cancel = void 0;
      group.queue.shift();
      trigger2$1(group);
    }
  });
  group.cancel = () => {
    cancelFn(true);
    group.cancel = void 0;
  };
}
function updateModifiers2$1(mod2, ctx) {
  const opts = ctx.opts;
  mods$1.forEach((name2) => {
    opts[name2] = mod2[name2] === true;
  });
}
function insertArgs$1(arg, ctx) {
  const opts = typeof arg === "string" && arg.length !== 0 ? arg.split(":") : [];
  ctx.name = opts[0];
  ctx.group = opts[1];
  Object.assign(ctx.opts, {
    duration: isNaN(opts[2]) === true ? 300 : parseFloat(opts[2]),
    waitFor: opts[3]
  });
}
function updateArgs$1(arg, ctx) {
  if (arg.group !== void 0) {
    ctx.group = arg.group;
  }
  if (arg.name !== void 0) {
    ctx.name = arg.name;
  }
  const opts = ctx.opts;
  props2$1.forEach((name2) => {
    if (arg[name2] !== void 0) {
      opts[name2] = arg[name2];
    }
  });
}
function updateModel$1(name2, ctx) {
  if (ctx.name === name2) {
    const group = morphGroups$1[ctx.group];
    if (group === void 0) {
      morphGroups$1[ctx.group] = {
        name: ctx.group,
        model: name2,
        queue: [ctx],
        animating: false
      };
      changeClass$1(ctx, "remove");
    } else if (group.model !== name2) {
      group.model = name2;
      group.queue.push(ctx);
      if (group.animating === false && group.queue.length === 2) {
        trigger2$1(group);
      }
    }
    return;
  }
  if (ctx.animating === false) {
    changeClass$1(ctx, "add");
  }
}
function updateValue$1(ctx, value2) {
  let model;
  if (Object(value2) === value2) {
    model = "" + value2.model;
    updateArgs$1(value2, ctx);
    updateModifiers2$1(value2, ctx);
  } else {
    model = "" + value2;
  }
  if (model !== ctx.model) {
    ctx.model = model;
    updateModel$1(model, ctx);
  } else if (ctx.animating === false && ctx.clsAction !== void 0) {
    ctx.el.classList[ctx.clsAction]("q-morph--invisible");
  }
}
createDirective$1(
  {
    name: "morph",
    mounted(el, binding) {
      const ctx = {
        el,
        animating: false,
        opts: {}
      };
      updateModifiers2$1(binding.modifiers, ctx);
      insertArgs$1(binding.arg, ctx);
      updateValue$1(ctx, binding.value);
      el.__qmorph = ctx;
    },
    updated(el, binding) {
      updateValue$1(el.__qmorph, binding.value);
    },
    beforeUnmount(el) {
      const ctx = el.__qmorph;
      const group = morphGroups$1[ctx.group];
      if (group !== void 0) {
        const index2 = group.queue.indexOf(ctx);
        if (index2 !== -1) {
          group.queue = group.queue.filter((item) => item !== ctx);
          if (group.queue.length === 0) {
            group.cancel !== void 0 && group.cancel();
            delete morphGroups$1[ctx.group];
          }
        }
      }
      if (ctx.clsAction === "add") {
        el.classList.remove("q-morph--invisible");
      }
      delete el.__qmorph;
    }
  }
);
var defaultCfg2$1 = {
  childList: true,
  subtree: true,
  attributes: true,
  characterData: true,
  attributeOldValue: true,
  characterDataOldValue: true
};
function update3$1(el, ctx, value2) {
  ctx.handler = value2;
  ctx.observer !== void 0 && ctx.observer.disconnect();
  ctx.observer = new MutationObserver((list) => {
    if (typeof ctx.handler === "function") {
      const res = ctx.handler(list);
      if (res === false || ctx.once === true) {
        destroy2$1(el);
      }
    }
  });
  ctx.observer.observe(el, ctx.opts);
}
function destroy2$1(el) {
  const ctx = el.__qmutation;
  if (ctx !== void 0) {
    ctx.observer !== void 0 && ctx.observer.disconnect();
    delete el.__qmutation;
  }
}
createDirective$1(
  {
    name: "mutation",
    mounted(el, { modifiers: { once, ...mod2 }, value: value2 }) {
      const ctx = {
        once,
        opts: Object.keys(mod2).length === 0 ? defaultCfg2$1 : mod2
      };
      update3$1(el, ctx, value2);
      el.__qmutation = ctx;
    },
    updated(el, { oldValue, value: value2 }) {
      const ctx = el.__qmutation;
      if (ctx !== void 0 && oldValue !== value2) {
        update3$1(el, ctx, value2);
      }
    },
    beforeUnmount: destroy2$1
  }
);
var { passive: passive5$1 } = listenOpts$1;
function update4$1(ctx, { value: value2, oldValue }) {
  if (typeof value2 !== "function") {
    ctx.scrollTarget.removeEventListener("scroll", ctx.scroll, passive5$1);
    return;
  }
  ctx.handler = value2;
  if (typeof oldValue !== "function") {
    ctx.scrollTarget.addEventListener("scroll", ctx.scroll, passive5$1);
    ctx.scroll();
  }
}
createDirective$1(
  {
    name: "scroll-fire",
    mounted(el, binding) {
      const ctx = {
        scrollTarget: getScrollTarget$1(el),
        scroll: debounce_default$1(() => {
          let containerBottom, elBottom;
          if (ctx.scrollTarget === window) {
            elBottom = el.getBoundingClientRect().bottom;
            containerBottom = window.innerHeight;
          } else {
            elBottom = offset$1(el).top + height$1(el);
            containerBottom = offset$1(ctx.scrollTarget).top + height$1(ctx.scrollTarget);
          }
          if (elBottom > 0 && elBottom < containerBottom) {
            ctx.scrollTarget.removeEventListener("scroll", ctx.scroll, passive5$1);
            ctx.handler(el);
          }
        }, 25)
      };
      update4$1(ctx, binding);
      el.__qscrollfire = ctx;
    },
    updated(el, binding) {
      if (binding.value !== binding.oldValue) {
        update4$1(el.__qscrollfire, binding);
      }
    },
    beforeUnmount(el) {
      const ctx = el.__qscrollfire;
      ctx.scrollTarget.removeEventListener("scroll", ctx.scroll, passive5$1);
      ctx.scroll.cancel();
      delete el.__qscrollfire;
    }
  }
);
function update5$1(ctx, { value: value2, oldValue }) {
  if (typeof value2 !== "function") {
    ctx.scrollTarget.removeEventListener("scroll", ctx.scroll, listenOpts$1.passive);
    return;
  }
  ctx.handler = value2;
  if (typeof oldValue !== "function") {
    ctx.scrollTarget.addEventListener("scroll", ctx.scroll, listenOpts$1.passive);
  }
}
createDirective$1(
  {
    name: "scroll",
    mounted(el, binding) {
      const ctx = {
        scrollTarget: getScrollTarget$1(el),
        scroll() {
          ctx.handler(
            getVerticalScrollPosition$1(ctx.scrollTarget),
            getHorizontalScrollPosition$1(ctx.scrollTarget)
          );
        }
      };
      update5$1(ctx, binding);
      el.__qscroll = ctx;
    },
    updated(el, binding) {
      if (el.__qscroll !== void 0 && binding.oldValue !== binding.value) {
        update5$1(el.__qscroll, binding);
      }
    },
    beforeUnmount(el) {
      const ctx = el.__qscroll;
      ctx.scrollTarget.removeEventListener("scroll", ctx.scroll, listenOpts$1.passive);
      delete el.__qscroll;
    }
  }
);
createDirective$1(
  {
    name: "touch-hold",
    beforeMount(el, binding) {
      const { modifiers } = binding;
      if (modifiers.mouse !== true && client$1.has.touch !== true) {
        return;
      }
      const ctx = {
        handler: binding.value,
        noop: noop$1,
        mouseStart(evt) {
          if (typeof ctx.handler === "function" && leftClick$1(evt) === true) {
            addEvt$1(ctx, "temp", [
              [document, "mousemove", "move", "passiveCapture"],
              [document, "click", "end", "notPassiveCapture"]
            ]);
            ctx.start(evt, true);
          }
        },
        touchStart(evt) {
          if (evt.target !== void 0 && typeof ctx.handler === "function") {
            const target2 = evt.target;
            addEvt$1(ctx, "temp", [
              [target2, "touchmove", "move", "passiveCapture"],
              [target2, "touchcancel", "end", "notPassiveCapture"],
              [target2, "touchend", "end", "notPassiveCapture"]
            ]);
            ctx.start(evt);
          }
        },
        start(evt, mouseEvent) {
          ctx.origin = position$1(evt);
          const startTime = Date.now();
          if (client$1.is.mobile === true) {
            document.body.classList.add("non-selectable");
            clearSelection$1();
            ctx.styleCleanup = (withDelay) => {
              ctx.styleCleanup = void 0;
              const remove2 = () => {
                document.body.classList.remove("non-selectable");
              };
              if (withDelay === true) {
                clearSelection$1();
                setTimeout(remove2, 10);
              } else {
                remove2();
              }
            };
          }
          ctx.triggered = false;
          ctx.sensitivity = mouseEvent === true ? ctx.mouseSensitivity : ctx.touchSensitivity;
          ctx.timer = setTimeout(() => {
            ctx.timer = void 0;
            clearSelection$1();
            ctx.triggered = true;
            ctx.handler({
              evt,
              touch: mouseEvent !== true,
              mouse: mouseEvent === true,
              position: ctx.origin,
              duration: Date.now() - startTime
            });
          }, ctx.duration);
        },
        move(evt) {
          const { top, left } = position$1(evt);
          if (ctx.timer !== void 0 && (Math.abs(left - ctx.origin.left) >= ctx.sensitivity || Math.abs(top - ctx.origin.top) >= ctx.sensitivity)) {
            clearTimeout(ctx.timer);
            ctx.timer = void 0;
          }
        },
        end(evt) {
          cleanEvt$1(ctx, "temp");
          ctx.styleCleanup !== void 0 && ctx.styleCleanup(ctx.triggered);
          if (ctx.triggered === true) {
            evt !== void 0 && stopAndPrevent$1(evt);
          } else if (ctx.timer !== void 0) {
            clearTimeout(ctx.timer);
            ctx.timer = void 0;
          }
        }
      };
      const data = [600, 5, 7];
      if (typeof binding.arg === "string" && binding.arg.length !== 0) {
        binding.arg.split(":").forEach((val, index2) => {
          const v = parseInt(val, 10);
          v && (data[index2] = v);
        });
      }
      [ctx.duration, ctx.touchSensitivity, ctx.mouseSensitivity] = data;
      el.__qtouchhold = ctx;
      if (modifiers.mouse === true) {
        const capture = modifiers.mouseCapture === true || modifiers.mousecapture === true ? "Capture" : "";
        addEvt$1(ctx, "main", [
          [el, "mousedown", "mouseStart", `passive${capture}`]
        ]);
      }
      client$1.has.touch === true && addEvt$1(ctx, "main", [
        [el, "touchstart", "touchStart", `passive${modifiers.capture === true ? "Capture" : ""}`],
        [el, "touchend", "noop", "notPassiveCapture"]
      ]);
    },
    updated(el, binding) {
      const ctx = el.__qtouchhold;
      if (ctx !== void 0 && binding.oldValue !== binding.value) {
        typeof binding.value !== "function" && ctx.end();
        ctx.handler = binding.value;
      }
    },
    beforeUnmount(el) {
      const ctx = el.__qtouchhold;
      if (ctx !== void 0) {
        cleanEvt$1(ctx, "main");
        cleanEvt$1(ctx, "temp");
        ctx.timer !== void 0 && clearTimeout(ctx.timer);
        ctx.styleCleanup !== void 0 && ctx.styleCleanup();
        delete el.__qtouchhold;
      }
    }
  }
);
var keyCodes3$1 = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  delete: [8, 46]
};
var keyRegex$1 = new RegExp(`^([\\d+]+|${Object.keys(keyCodes3$1).join("|")})$`, "i");
function shouldEnd$1(evt, origin) {
  const { top, left } = position$1(evt);
  return Math.abs(left - origin.left) >= 7 || Math.abs(top - origin.top) >= 7;
}
createDirective$1(
  {
    name: "touch-repeat",
    beforeMount(el, { modifiers, value: value2, arg }) {
      const keyboard = Object.keys(modifiers).reduce((acc, key) => {
        if (keyRegex$1.test(key) === true) {
          const keyCode = isNaN(parseInt(key, 10)) ? keyCodes3$1[key.toLowerCase()] : parseInt(key, 10);
          keyCode >= 0 && acc.push(keyCode);
        }
        return acc;
      }, []);
      if (modifiers.mouse !== true && client$1.has.touch !== true && keyboard.length === 0) {
        return;
      }
      const durations = typeof arg === "string" && arg.length !== 0 ? arg.split(":").map((val) => parseInt(val, 10)) : [0, 600, 300];
      const durationsLast = durations.length - 1;
      const ctx = {
        keyboard,
        handler: value2,
        noop: noop$1,
        mouseStart(evt) {
          if (ctx.event === void 0 && typeof ctx.handler === "function" && leftClick$1(evt) === true) {
            addEvt$1(ctx, "temp", [
              [document, "mousemove", "move", "passiveCapture"],
              [document, "click", "end", "notPassiveCapture"]
            ]);
            ctx.start(evt, true);
          }
        },
        keyboardStart(evt) {
          if (typeof ctx.handler === "function" && isKeyCode$1(evt, keyboard) === true) {
            if (durations[0] === 0 || ctx.event !== void 0) {
              stopAndPrevent$1(evt);
              el.focus();
              if (ctx.event !== void 0) {
                return;
              }
            }
            addEvt$1(ctx, "temp", [
              [document, "keyup", "end", "notPassiveCapture"],
              [document, "click", "end", "notPassiveCapture"]
            ]);
            ctx.start(evt, false, true);
          }
        },
        touchStart(evt) {
          if (evt.target !== void 0 && typeof ctx.handler === "function") {
            const target2 = evt.target;
            addEvt$1(ctx, "temp", [
              [target2, "touchmove", "move", "passiveCapture"],
              [target2, "touchcancel", "end", "notPassiveCapture"],
              [target2, "touchend", "end", "notPassiveCapture"]
            ]);
            ctx.start(evt);
          }
        },
        start(evt, mouseEvent, keyboardEvent) {
          if (keyboardEvent !== true) {
            ctx.origin = position$1(evt);
          }
          function styleCleanup(withDelay) {
            ctx.styleCleanup = void 0;
            document.documentElement.style.cursor = "";
            const remove2 = () => {
              document.body.classList.remove("non-selectable");
            };
            if (withDelay === true) {
              clearSelection$1();
              setTimeout(remove2, 10);
            } else {
              remove2();
            }
          }
          if (client$1.is.mobile === true) {
            document.body.classList.add("non-selectable");
            clearSelection$1();
            ctx.styleCleanup = styleCleanup;
          }
          ctx.event = {
            touch: mouseEvent !== true && keyboardEvent !== true,
            mouse: mouseEvent === true,
            keyboard: keyboardEvent === true,
            startTime: Date.now(),
            repeatCount: 0
          };
          const fn = () => {
            ctx.timer = void 0;
            if (ctx.event === void 0) {
              return;
            }
            if (ctx.event.repeatCount === 0) {
              ctx.event.evt = evt;
              if (keyboardEvent === true) {
                ctx.event.keyCode = evt.keyCode;
              } else {
                ctx.event.position = position$1(evt);
              }
              if (client$1.is.mobile !== true) {
                document.documentElement.style.cursor = "pointer";
                document.body.classList.add("non-selectable");
                clearSelection$1();
                ctx.styleCleanup = styleCleanup;
              }
            }
            ctx.event.duration = Date.now() - ctx.event.startTime;
            ctx.event.repeatCount += 1;
            ctx.handler(ctx.event);
            const index2 = durationsLast < ctx.event.repeatCount ? durationsLast : ctx.event.repeatCount;
            ctx.timer = setTimeout(fn, durations[index2]);
          };
          if (durations[0] === 0) {
            fn();
          } else {
            ctx.timer = setTimeout(fn, durations[0]);
          }
        },
        move(evt) {
          if (ctx.event !== void 0 && ctx.timer !== void 0 && shouldEnd$1(evt, ctx.origin) === true) {
            clearTimeout(ctx.timer);
            ctx.timer = void 0;
          }
        },
        end(evt) {
          if (ctx.event === void 0) {
            return;
          }
          ctx.styleCleanup !== void 0 && ctx.styleCleanup(true);
          evt !== void 0 && ctx.event.repeatCount > 0 && stopAndPrevent$1(evt);
          cleanEvt$1(ctx, "temp");
          if (ctx.timer !== void 0) {
            clearTimeout(ctx.timer);
            ctx.timer = void 0;
          }
          ctx.event = void 0;
        }
      };
      el.__qtouchrepeat = ctx;
      if (modifiers.mouse === true) {
        const capture = modifiers.mouseCapture === true || modifiers.mousecapture === true ? "Capture" : "";
        addEvt$1(ctx, "main", [
          [el, "mousedown", "mouseStart", `passive${capture}`]
        ]);
      }
      client$1.has.touch === true && addEvt$1(ctx, "main", [
        [el, "touchstart", "touchStart", `passive${modifiers.capture === true ? "Capture" : ""}`],
        [el, "touchend", "noop", "passiveCapture"]
      ]);
      if (keyboard.length !== 0) {
        const capture = modifiers.keyCapture === true || modifiers.keycapture === true ? "Capture" : "";
        addEvt$1(ctx, "main", [
          [el, "keydown", "keyboardStart", `notPassive${capture}`]
        ]);
      }
    },
    updated(el, { oldValue, value: value2 }) {
      const ctx = el.__qtouchrepeat;
      if (ctx !== void 0 && oldValue !== value2) {
        typeof value2 !== "function" && ctx.end();
        ctx.handler = value2;
      }
    },
    beforeUnmount(el) {
      const ctx = el.__qtouchrepeat;
      if (ctx !== void 0) {
        ctx.timer !== void 0 && clearTimeout(ctx.timer);
        cleanEvt$1(ctx, "main");
        cleanEvt$1(ctx, "temp");
        ctx.styleCleanup !== void 0 && ctx.styleCleanup();
        delete el.__qtouchrepeat;
      }
    }
  }
);
function getCssVar$1(propName, element = document.body) {
  if (typeof propName !== "string") {
    throw new TypeError("Expected a string as propName");
  }
  if (!(element instanceof Element)) {
    throw new TypeError("Expected a DOM element");
  }
  return getComputedStyle(element).getPropertyValue(`--q-${propName}`).trim() || null;
}
var metaValue$1;
function getProp$1() {
  return client$1.is.winphone ? "msapplication-navbutton-color" : client$1.is.safari ? "apple-mobile-web-app-status-bar-style" : "theme-color";
}
function getMetaTag$1(v) {
  const els = document.getElementsByTagName("META");
  for (const i22 in els) {
    if (els[i22].name === v) {
      return els[i22];
    }
  }
}
function setColor$1(hexColor) {
  if (metaValue$1 === void 0) {
    metaValue$1 = getProp$1();
  }
  let metaTag = getMetaTag$1(metaValue$1);
  const newTag = metaTag === void 0;
  if (newTag) {
    metaTag = document.createElement("meta");
    metaTag.setAttribute("name", metaValue$1);
  }
  metaTag.setAttribute("content", hexColor);
  if (newTag) {
    document.head.appendChild(metaTag);
  }
}
({
  set: client$1.is.mobile === true && (client$1.is.nativeMobile === true || client$1.is.winphone === true || client$1.is.safari === true || client$1.is.webkit === true || client$1.is.vivaldi === true) ? (hexColor) => {
    const val = hexColor || getCssVar$1("primary");
    if (client$1.is.nativeMobile === true && window.StatusBar) {
      window.StatusBar.backgroundColorByHexString(val);
    } else {
      setColor$1(val);
    }
  } : noop$1
});
var prefixes$1 = {};
function assignFn$1(fn) {
  Object.assign(Plugin4$1, {
    request: fn,
    exit: fn,
    toggle: fn
  });
}
function getFullscreenElement$1() {
  return document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement || null;
}
function updateEl$1() {
  const newEl = Plugin4$1.activeEl = Plugin4$1.isActive === false ? null : getFullscreenElement$1();
  changeGlobalNodesTarget$1(
    newEl === null || newEl === document.documentElement ? document.body : newEl
  );
}
function togglePluginState$1() {
  Plugin4$1.isActive = Plugin4$1.isActive === false;
  updateEl$1();
}
function promisify$1(target2, fn) {
  try {
    const res = target2[fn]();
    return res === void 0 ? Promise.resolve() : res;
  } catch (err) {
    return Promise.reject(err);
  }
}
var Plugin4$1 = createReactivePlugin$1({
  isActive: false,
  activeEl: null
}, {
  isCapable: false,
  install({ $q }) {
    $q.fullscreen = this;
  }
});
{
  prefixes$1.request = [
    "requestFullscreen",
    "msRequestFullscreen",
    "mozRequestFullScreen",
    "webkitRequestFullscreen"
  ].find((request) => document.documentElement[request] !== void 0);
  Plugin4$1.isCapable = prefixes$1.request !== void 0;
  if (Plugin4$1.isCapable === false) {
    assignFn$1(() => Promise.reject("Not capable"));
  } else {
    Object.assign(Plugin4$1, {
      request(target2) {
        const el = target2 || document.documentElement;
        const { activeEl } = Plugin4$1;
        if (el === activeEl) {
          return Promise.resolve();
        }
        const queue2 = activeEl !== null && el.contains(activeEl) === true ? Plugin4$1.exit() : Promise.resolve();
        return queue2.finally(() => promisify$1(el, prefixes$1.request));
      },
      exit() {
        return Plugin4$1.isActive === true ? promisify$1(document, prefixes$1.exit) : Promise.resolve();
      },
      toggle(target2) {
        return Plugin4$1.isActive === true ? Plugin4$1.exit() : Plugin4$1.request(target2);
      }
    });
    prefixes$1.exit = [
      "exitFullscreen",
      "msExitFullscreen",
      "mozCancelFullScreen",
      "webkitExitFullscreen"
    ].find((exit) => document[exit]);
    Plugin4$1.isActive = Boolean(getFullscreenElement$1());
    Plugin4$1.isActive === true && updateEl$1();
    [
      "onfullscreenchange",
      "onmsfullscreenchange",
      "onwebkitfullscreenchange"
    ].forEach((evt) => {
      document[evt] = togglePluginState$1;
    });
  }
}
var Plugin5$1 = createReactivePlugin$1({
  appVisible: true
}, {
  install({ $q }) {
    injectProp$1($q, "appVisible", () => this.appVisible);
  }
});
{
  let prop, evt;
  if (typeof document.hidden !== "undefined") {
    prop = "hidden";
    evt = "visibilitychange";
  } else if (typeof document.msHidden !== "undefined") {
    prop = "msHidden";
    evt = "msvisibilitychange";
  } else if (typeof document.webkitHidden !== "undefined") {
    prop = "webkitHidden";
    evt = "webkitvisibilitychange";
  }
  if (evt && typeof document[prop] !== "undefined") {
    const update6 = () => {
      Plugin5$1.appVisible = !document[prop];
    };
    document.addEventListener(evt, update6, false);
  }
}
createComponent$1({
  name: "BottomSheetComponent",
  props: {
    ...useDarkProps$1,
    title: String,
    message: String,
    actions: Array,
    grid: Boolean,
    cardClass: [String, Array, Object],
    cardStyle: [String, Array, Object]
  },
  emits: ["ok", "hide"],
  setup(props4, { emit }) {
    const { proxy } = getCurrentInstance();
    const isDark = use_dark_default$1(props4, proxy.$q);
    const dialogRef = ref$1(null);
    function show() {
      dialogRef.value.show();
    }
    function hide() {
      dialogRef.value.hide();
    }
    function onOk(action) {
      emit("ok", action);
      hide();
    }
    function onHide() {
      emit("hide");
    }
    function getGrid() {
      return props4.actions.map((action) => {
        const img = action.avatar || action.img;
        return action.label === void 0 ? h(QSeparator_default$1, {
          class: "col-all",
          dark: isDark.value
        }) : h("div", {
          class: [
            "q-bottom-sheet__item q-hoverable q-focusable cursor-pointer relative-position",
            action.class
          ],
          style: action.style,
          tabindex: 0,
          role: "listitem",
          onClick() {
            onOk(action);
          },
          onKeyup(e22) {
            e22.keyCode === 13 && onOk(action);
          }
        }, [
          h("div", { class: "q-focus-helper" }),
          action.icon ? h(QIcon_default$1, { name: action.icon, color: action.color }) : img ? h("img", {
            class: action.avatar ? "q-bottom-sheet__avatar" : "",
            src: img
          }) : h("div", { class: "q-bottom-sheet__empty-icon" }),
          h("div", action.label)
        ]);
      });
    }
    function getList() {
      return props4.actions.map((action) => {
        const img = action.avatar || action.img;
        return action.label === void 0 ? h(QSeparator_default$1, { spaced: true, dark: isDark.value }) : h(QItem_default$1, {
          class: ["q-bottom-sheet__item", action.classes],
          style: action.style,
          tabindex: 0,
          clickable: true,
          dark: isDark.value,
          onClick() {
            onOk(action);
          }
        }, () => [
          h(
            QItemSection_default$1,
            { avatar: true },
            () => action.icon ? h(QIcon_default$1, { name: action.icon, color: action.color }) : img ? h("img", {
              class: action.avatar ? "q-bottom-sheet__avatar" : "",
              src: img
            }) : null
          ),
          h(QItemSection_default$1, () => action.label)
        ]);
      });
    }
    function getCardContent() {
      const child = [];
      props4.title && child.push(
        h(QCardSection_default$1, {
          class: "q-dialog__title"
        }, () => props4.title)
      );
      props4.message && child.push(
        h(QCardSection_default$1, {
          class: "q-dialog__message"
        }, () => props4.message)
      );
      child.push(
        props4.grid === true ? h("div", {
          class: "row items-stretch justify-start",
          role: "list"
        }, getGrid()) : h("div", {
          role: "list"
        }, getList())
      );
      return child;
    }
    function getContent() {
      return [
        h(QCard_default$1, {
          class: [
            `q-bottom-sheet q-bottom-sheet--${props4.grid === true ? "grid" : "list"}` + (isDark.value === true ? " q-bottom-sheet--dark q-dark" : ""),
            props4.cardClass
          ],
          style: props4.cardStyle
        }, getCardContent)
      ];
    }
    Object.assign(proxy, { show, hide });
    return () => h(QDialog_default$1, {
      ref: dialogRef,
      position: "bottom",
      onHide
    }, getContent);
  }
});
function encode$1(string) {
  return encodeURIComponent(string);
}
function decode$1(string) {
  return decodeURIComponent(string);
}
function stringifyCookieValue$1(value2) {
  return encode$1(value2 === Object(value2) ? JSON.stringify(value2) : "" + value2);
}
function read$1(string) {
  if (string === "") {
    return string;
  }
  if (string.indexOf('"') === 0) {
    string = string.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\");
  }
  string = decode$1(string.replace(/\+/g, " "));
  try {
    const parsed = JSON.parse(string);
    if (parsed === Object(parsed) || Array.isArray(parsed) === true) {
      string = parsed;
    }
  } catch (_) {
  }
  return string;
}
function getString$1(msOffset) {
  const time = /* @__PURE__ */ new Date();
  time.setMilliseconds(time.getMilliseconds() + msOffset);
  return time.toUTCString();
}
function parseExpireString$1(str) {
  let timestamp = 0;
  const days = str.match(/(\d+)d/);
  const hours = str.match(/(\d+)h/);
  const minutes = str.match(/(\d+)m/);
  const seconds = str.match(/(\d+)s/);
  if (days) {
    timestamp += days[1] * 864e5;
  }
  if (hours) {
    timestamp += hours[1] * 36e5;
  }
  if (minutes) {
    timestamp += minutes[1] * 6e4;
  }
  if (seconds) {
    timestamp += seconds[1] * 1e3;
  }
  return timestamp === 0 ? str : getString$1(timestamp);
}
function set$1(key, val, opts = {}, ssr) {
  let expire, expireValue;
  if (opts.expires !== void 0) {
    if (Object.prototype.toString.call(opts.expires) === "[object Date]") {
      expire = opts.expires.toUTCString();
    } else if (typeof opts.expires === "string") {
      expire = parseExpireString$1(opts.expires);
    } else {
      expireValue = parseFloat(opts.expires);
      expire = isNaN(expireValue) === false ? getString$1(expireValue * 864e5) : opts.expires;
    }
  }
  const keyValue = `${encode$1(key)}=${stringifyCookieValue$1(val)}`;
  const cookie = [
    keyValue,
    expire !== void 0 ? "; Expires=" + expire : "",
    // use expires attribute, max-age is not supported by IE
    opts.path ? "; Path=" + opts.path : "",
    opts.domain ? "; Domain=" + opts.domain : "",
    opts.sameSite ? "; SameSite=" + opts.sameSite : "",
    opts.httpOnly ? "; HttpOnly" : "",
    opts.secure ? "; Secure" : "",
    opts.other ? "; " + opts.other : ""
  ].join("");
  if (ssr) {
    if (ssr.req.qCookies) {
      ssr.req.qCookies.push(cookie);
    } else {
      ssr.req.qCookies = [cookie];
    }
    ssr.res.setHeader("Set-Cookie", ssr.req.qCookies);
    let all = ssr.req.headers.cookie || "";
    if (expire !== void 0 && expireValue < 0) {
      const val2 = get$1(key, ssr);
      if (val2 !== void 0) {
        all = all.replace(`${key}=${val2}; `, "").replace(`; ${key}=${val2}`, "").replace(`${key}=${val2}`, "");
      }
    } else {
      all = all ? `${keyValue}; ${all}` : cookie;
    }
    ssr.req.headers.cookie = all;
  } else {
    document.cookie = cookie;
  }
}
function get$1(key, ssr) {
  const cookieSource = ssr ? ssr.req.headers : document, cookies = cookieSource.cookie ? cookieSource.cookie.split("; ") : [], l = cookies.length;
  let result = key ? null : {}, i22 = 0, parts, name2, cookie;
  for (; i22 < l; i22++) {
    parts = cookies[i22].split("=");
    name2 = decode$1(parts.shift());
    cookie = parts.join("=");
    if (!key) {
      result[name2] = cookie;
    } else if (key === name2) {
      result = read$1(cookie);
      break;
    }
  }
  return result;
}
function remove$1(key, options, ssr) {
  set$1(
    key,
    "",
    { expires: -1, ...options },
    ssr
  );
}
function has$4(key, ssr) {
  return get$1(key, ssr) !== null;
}
function getObject$1(ssr) {
  return {
    get: (key) => get$1(key, ssr),
    set: (key, val, opts) => set$1(key, val, opts, ssr),
    has: (key) => has$4(key, ssr),
    remove: (key, options) => remove$1(key, options, ssr),
    getAll: () => get$1(null, ssr)
  };
}
var Plugin6$1 = {
  install({ $q, ssrContext }) {
    $q.cookies = this;
  }
};
if (__QUASAR_SSR__) {
  Plugin6$1.parseSSR = (ssrContext) => {
    if (ssrContext !== void 0) {
      return getObject$1(ssrContext);
    }
  };
}
{
  Object.assign(Plugin6$1, getObject$1());
}
createComponent$1({
  name: "DialogPluginComponent",
  props: {
    ...useDarkProps$1,
    title: String,
    message: String,
    prompt: Object,
    options: Object,
    progress: [Boolean, Object],
    html: Boolean,
    ok: {
      type: [String, Object, Boolean],
      default: true
    },
    cancel: [String, Object, Boolean],
    focus: {
      type: String,
      default: "ok",
      validator: (v) => ["ok", "cancel", "none"].includes(v)
    },
    stackButtons: Boolean,
    color: String,
    cardClass: [String, Array, Object],
    cardStyle: [String, Array, Object]
  },
  emits: ["ok", "hide"],
  setup(props4, { emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const isDark = use_dark_default$1(props4, $q);
    const dialogRef = ref$1(null);
    const model = ref$1(
      props4.prompt !== void 0 ? props4.prompt.model : props4.options !== void 0 ? props4.options.model : void 0
    );
    const classes = computed(
      () => "q-dialog-plugin" + (isDark.value === true ? " q-dialog-plugin--dark q-dark" : "") + (props4.progress !== false ? " q-dialog-plugin--progress" : "")
    );
    const vmColor = computed(
      () => props4.color || (isDark.value === true ? "amber" : "primary")
    );
    const spinner = computed(() => props4.progress === false ? null : isObject$1(props4.progress) === true ? {
      component: props4.progress.spinner || QSpinner_default$1,
      props: { color: props4.progress.color || vmColor.value }
    } : {
      component: QSpinner_default$1,
      props: { color: vmColor.value }
    });
    const hasForm = computed(
      () => props4.prompt !== void 0 || props4.options !== void 0
    );
    const formProps = computed(() => {
      if (hasForm.value !== true) {
        return {};
      }
      const { model: model2, isValid: isValid2, items, ...formProps2 } = props4.prompt !== void 0 ? props4.prompt : props4.options;
      return formProps2;
    });
    const okLabel = computed(() => isObject$1(props4.ok) === true ? $q.lang.label.ok : props4.ok === true ? $q.lang.label.ok : props4.ok);
    const cancelLabel = computed(() => isObject$1(props4.cancel) === true ? $q.lang.label.cancel : props4.cancel === true ? $q.lang.label.cancel : props4.cancel);
    const okDisabled = computed(() => {
      if (props4.prompt !== void 0) {
        return props4.prompt.isValid !== void 0 && props4.prompt.isValid(model.value) !== true;
      }
      if (props4.options !== void 0) {
        return props4.options.isValid !== void 0 && props4.options.isValid(model.value) !== true;
      }
      return false;
    });
    const okProps = computed(() => ({
      color: vmColor.value,
      label: okLabel.value,
      ripple: false,
      disable: okDisabled.value,
      ...isObject$1(props4.ok) === true ? props4.ok : { flat: true },
      "data-autofocus": props4.focus === "ok" && hasForm.value !== true || void 0,
      onClick: onOk
    }));
    const cancelProps = computed(() => ({
      color: vmColor.value,
      label: cancelLabel.value,
      ripple: false,
      ...isObject$1(props4.cancel) === true ? props4.cancel : { flat: true },
      "data-autofocus": props4.focus === "cancel" && hasForm.value !== true || void 0,
      onClick: onCancel
    }));
    watch(() => props4.prompt && props4.prompt.model, onUpdateModel);
    watch(() => props4.options && props4.options.model, onUpdateModel);
    function show() {
      dialogRef.value.show();
    }
    function hide() {
      dialogRef.value.hide();
    }
    function onOk() {
      emit("ok", toRaw(model.value));
      hide();
    }
    function onCancel() {
      hide();
    }
    function onDialogHide() {
      emit("hide");
    }
    function onUpdateModel(val) {
      model.value = val;
    }
    function onInputKeyup(evt) {
      if (okDisabled.value !== true && props4.prompt.type !== "textarea" && isKeyCode$1(evt, 13) === true) {
        onOk();
      }
    }
    function getSection(classes2, text2) {
      return props4.html === true ? h(QCardSection_default$1, {
        class: classes2,
        innerHTML: text2
      }) : h(QCardSection_default$1, { class: classes2 }, () => text2);
    }
    function getPrompt() {
      return [
        h(QInput_default$1, {
          color: vmColor.value,
          dense: true,
          autofocus: true,
          dark: isDark.value,
          ...formProps.value,
          modelValue: model.value,
          "onUpdate:modelValue": onUpdateModel,
          onKeyup: onInputKeyup
        })
      ];
    }
    function getOptions() {
      return [
        h(QOptionGroup_default$1, {
          color: vmColor.value,
          options: props4.options.items,
          dark: isDark.value,
          ...formProps.value,
          modelValue: model.value,
          "onUpdate:modelValue": onUpdateModel
        })
      ];
    }
    function getButtons() {
      const child = [];
      props4.cancel && child.push(
        h(QBtn_default$1, cancelProps.value)
      );
      props4.ok && child.push(
        h(QBtn_default$1, okProps.value)
      );
      return h(QCardActions_default$1, {
        class: props4.stackButtons === true ? "items-end" : "",
        vertical: props4.stackButtons,
        align: "right"
      }, () => child);
    }
    function getCardContent() {
      const child = [];
      props4.title && child.push(
        getSection("q-dialog__title", props4.title)
      );
      props4.progress !== false && child.push(
        h(
          QCardSection_default$1,
          { class: "q-dialog__progress" },
          () => h(spinner.value.component, spinner.value.props)
        )
      );
      props4.message && child.push(
        getSection("q-dialog__message", props4.message)
      );
      if (props4.prompt !== void 0) {
        child.push(
          h(
            QCardSection_default$1,
            { class: "scroll q-dialog-plugin__form" },
            getPrompt
          )
        );
      } else if (props4.options !== void 0) {
        child.push(
          h(QSeparator_default$1, { dark: isDark.value }),
          h(
            QCardSection_default$1,
            { class: "scroll q-dialog-plugin__form" },
            getOptions
          ),
          h(QSeparator_default$1, { dark: isDark.value })
        );
      }
      if (props4.ok || props4.cancel) {
        child.push(getButtons());
      }
      return child;
    }
    function getContent() {
      return [
        h(QCard_default$1, {
          class: [
            classes.value,
            props4.cardClass
          ],
          style: props4.cardStyle,
          dark: isDark.value
        }, getCardContent)
      ];
    }
    Object.assign(proxy, { show, hide });
    return () => h(QDialog_default$1, {
      ref: dialogRef,
      onHide: onDialogHide
    }, getContent);
  }
});
var app$1;
var vm$1;
var uid2$1 = 0;
var timeout$1 = null;
var props3$1 = {};
var activeGroups$1 = {};
var originalDefaults$1 = {
  group: "__default_quasar_group__",
  delay: 0,
  message: false,
  html: false,
  spinnerSize: 80,
  spinnerColor: "",
  messageColor: "",
  backgroundColor: "",
  boxClass: "",
  spinner: QSpinner_default$1,
  customClass: ""
};
var defaults$2 = { ...originalDefaults$1 };
function registerProps$1(opts) {
  if (opts && opts.group !== void 0 && activeGroups$1[opts.group] !== void 0) {
    return Object.assign(activeGroups$1[opts.group], opts);
  }
  const newProps = isObject$1(opts) === true && opts.ignoreDefaults === true ? { ...originalDefaults$1, ...opts } : { ...defaults$2, ...opts };
  activeGroups$1[newProps.group] = newProps;
  return newProps;
}
var Plugin7$1 = createReactivePlugin$1({
  isActive: false
}, {
  show(opts) {
    props3$1 = registerProps$1(opts);
    const { group } = props3$1;
    Plugin7$1.isActive = true;
    if (app$1 !== void 0) {
      props3$1.uid = uid2$1;
      vm$1.$forceUpdate();
    } else {
      props3$1.uid = ++uid2$1;
      timeout$1 !== null && clearTimeout(timeout$1);
      timeout$1 = setTimeout(() => {
        timeout$1 = null;
        const el = createGlobalNode$1("q-loading");
        app$1 = createChildApp$1({
          name: "QLoading",
          setup() {
            onMounted(() => {
              prevent_scroll_default$1(true);
            });
            function onAfterLeave() {
              if (Plugin7$1.isActive !== true && app$1 !== void 0) {
                prevent_scroll_default$1(false);
                app$1.unmount(el);
                removeGlobalNode$1(el);
                app$1 = void 0;
                vm$1 = void 0;
              }
            }
            function getContent() {
              if (Plugin7$1.isActive !== true) {
                return null;
              }
              const content = [
                h(props3$1.spinner, {
                  class: "q-loading__spinner",
                  color: props3$1.spinnerColor,
                  size: props3$1.spinnerSize
                })
              ];
              props3$1.message && content.push(
                h("div", {
                  class: "q-loading__message" + (props3$1.messageColor ? ` text-${props3$1.messageColor}` : ""),
                  [props3$1.html === true ? "innerHTML" : "textContent"]: props3$1.message
                })
              );
              return h("div", {
                class: "q-loading fullscreen flex flex-center z-max " + props3$1.customClass.trim(),
                key: props3$1.uid
              }, [
                h("div", {
                  class: "q-loading__backdrop" + (props3$1.backgroundColor ? ` bg-${props3$1.backgroundColor}` : "")
                }),
                h("div", {
                  class: "q-loading__box column items-center " + props3$1.boxClass
                }, content)
              ]);
            }
            return () => h(Transition, {
              name: "q-transition--fade",
              appear: true,
              onAfterLeave
            }, getContent);
          }
        }, Plugin7$1.__parentApp);
        vm$1 = app$1.mount(el);
      }, props3$1.delay);
    }
    return (paramProps) => {
      if (paramProps === void 0 || Object(paramProps) !== paramProps) {
        Plugin7$1.hide(group);
        return;
      }
      Plugin7$1.show({ ...paramProps, group });
    };
  },
  hide(group) {
    if (Plugin7$1.isActive === true) {
      if (group === void 0) {
        activeGroups$1 = {};
      } else if (activeGroups$1[group] === void 0) {
        return;
      } else {
        delete activeGroups$1[group];
        const keys2 = Object.keys(activeGroups$1);
        if (keys2.length !== 0) {
          const lastGroup = keys2[keys2.length - 1];
          Plugin7$1.show({ group: lastGroup });
          return;
        }
      }
      if (timeout$1 !== null) {
        clearTimeout(timeout$1);
        timeout$1 = null;
      }
      Plugin7$1.isActive = false;
    }
  },
  setDefaults(opts) {
    {
      isObject$1(opts) === true && Object.assign(defaults$2, opts);
    }
  },
  install({ $q, parentApp }) {
    $q.loading = this;
    {
      Plugin7$1.__parentApp = parentApp;
      if ($q.config.loading !== void 0) {
        this.setDefaults($q.config.loading);
      }
    }
  }
});
var barRef$1 = ref$1(null);
var Plugin8$1 = createReactivePlugin$1({
  isActive: false
}, {
  start: noop$1,
  stop: noop$1,
  increment: noop$1,
  setDefaults: noop$1,
  install({ $q, parentApp }) {
    $q.loadingBar = this;
    if (this.__installed === true) {
      if ($q.config.loadingBar !== void 0) {
        this.setDefaults($q.config.loadingBar);
      }
      return;
    }
    const props4 = ref$1(
      $q.config.loadingBar !== void 0 ? { ...$q.config.loadingBar } : {}
    );
    function onStart() {
      Plugin8$1.isActive = true;
    }
    function onStop() {
      Plugin8$1.isActive = false;
    }
    const el = createGlobalNode$1("q-loading-bar");
    createChildApp$1({
      name: "LoadingBar",
      // hide App from Vue devtools
      devtools: { hide: true },
      setup: () => () => h(QAjaxBar_default$1, { ...props4.value, onStart, onStop, ref: barRef$1 })
    }, parentApp).mount(el);
    Object.assign(this, {
      start(speed) {
        barRef$1.value.start(speed);
      },
      stop() {
        barRef$1.value.stop();
      },
      increment() {
        barRef$1.value.increment.apply(null, arguments);
      },
      setDefaults(opts) {
        if (isObject$1(opts) === true) {
          Object.assign(props4.value, opts);
        }
      }
    });
  }
});
function encode2$1(value2) {
  if (isDate$1(value2) === true) {
    return "__q_date|" + value2.getTime();
  }
  if (isRegexp$1(value2) === true) {
    return "__q_expr|" + value2.source;
  }
  if (typeof value2 === "number") {
    return "__q_numb|" + value2;
  }
  if (typeof value2 === "boolean") {
    return "__q_bool|" + (value2 ? "1" : "0");
  }
  if (typeof value2 === "string") {
    return "__q_strn|" + value2;
  }
  if (typeof value2 === "function") {
    return "__q_strn|" + value2.toString();
  }
  if (value2 === Object(value2)) {
    return "__q_objt|" + JSON.stringify(value2);
  }
  return value2;
}
function decode2$1(value2) {
  const length = value2.length;
  if (length < 9) {
    return value2;
  }
  const type2 = value2.substring(0, 8);
  const source = value2.substring(9);
  switch (type2) {
    case "__q_date":
      const number = Number(source);
      return new Date(Number.isNaN(number) === true ? source : number);
    case "__q_expr":
      return new RegExp(source);
    case "__q_numb":
      return Number(source);
    case "__q_bool":
      return Boolean(source === "1");
    case "__q_strn":
      return "" + source;
    case "__q_objt":
      return JSON.parse(source);
    default:
      return value2;
  }
}
function getEmptyStorage$1() {
  const getVal2 = () => null;
  return {
    has: () => false,
    // alias for hasItem; TODO: remove in Qv3
    hasItem: () => false,
    getLength: () => 0,
    getItem: getVal2,
    getIndex: getVal2,
    getKey: getVal2,
    getAll: () => {
    },
    getAllKeys: () => [],
    set: noop$1,
    // alias for setItem; TODO: remove in Qv3
    setItem: noop$1,
    remove: noop$1,
    // alias for removeItem; TODO: remove in Qv3
    removeItem: noop$1,
    clear: noop$1,
    isEmpty: () => true
  };
}
function getStorage$1(type2) {
  const webStorage = window[type2 + "Storage"], get2 = (key) => {
    const item = webStorage.getItem(key);
    return item ? decode2$1(item) : null;
  };
  const hasItem = (key) => webStorage.getItem(key) !== null;
  const setItem = (key, value2) => {
    webStorage.setItem(key, encode2$1(value2));
  };
  const removeItem = (key) => {
    webStorage.removeItem(key);
  };
  return {
    has: hasItem,
    // TODO: remove in Qv3
    hasItem,
    getLength: () => webStorage.length,
    getItem: get2,
    getIndex: (index2) => {
      return index2 < webStorage.length ? get2(webStorage.key(index2)) : null;
    },
    getKey: (index2) => {
      return index2 < webStorage.length ? webStorage.key(index2) : null;
    },
    getAll: () => {
      let key;
      const result = {}, len = webStorage.length;
      for (let i22 = 0; i22 < len; i22++) {
        key = webStorage.key(i22);
        result[key] = get2(key);
      }
      return result;
    },
    getAllKeys: () => {
      const result = [], len = webStorage.length;
      for (let i22 = 0; i22 < len; i22++) {
        result.push(webStorage.key(i22));
      }
      return result;
    },
    set: setItem,
    // TODO: remove in Qv3
    setItem,
    remove: removeItem,
    // TODO: remove in Qv3
    removeItem,
    clear: () => {
      webStorage.clear();
    },
    isEmpty: () => webStorage.length === 0
  };
}
var storage$1 = client$1.has.webStorage === false ? getEmptyStorage$1() : getStorage$1("local");
var Plugin9$1 = {
  install({ $q }) {
    $q.localStorage = storage$1;
  }
};
Object.assign(Plugin9$1, storage$1);
var LocalStorage_default = Plugin9$1;
var storage2$1 = client$1.has.webStorage === false ? getEmptyStorage$1() : getStorage$1("session");
var Plugin10$1 = {
  install({ $q }) {
    $q.sessionStorage = storage2$1;
  }
};
Object.assign(Plugin10$1, storage2$1);
function useDialogPluginComponent() {
  const { emit, proxy } = getCurrentInstance();
  const dialogRef = ref$1(null);
  function show() {
    dialogRef.value.show();
  }
  function hide() {
    dialogRef.value.hide();
  }
  function onDialogOK(payload) {
    emit("ok", payload);
    hide();
  }
  function onDialogHide() {
    emit("hide");
  }
  Object.assign(proxy, { show, hide });
  return {
    dialogRef,
    onDialogHide,
    onDialogOK,
    onDialogCancel: hide
  };
}
var emits2$1 = ["ok", "hide"];
useDialogPluginComponent.emits = emits2$1;
useDialogPluginComponent.emitsObject = get_emits_object_default$1(emits2$1);
function useQuasar() {
  return inject(quasarKey);
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x22) {
  return x22 && x22.__esModule && Object.prototype.hasOwnProperty.call(x22, "default") ? x22["default"] : x22;
}
function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
  if (typeof f == "function") {
    var a32 = function a4() {
      if (this instanceof a4) {
        return Reflect.construct(f, arguments, this.constructor);
      }
      return f.apply(this, arguments);
    };
    a32.prototype = f.prototype;
  } else a32 = {};
  Object.defineProperty(a32, "__esModule", { value: true });
  Object.keys(n).forEach(function(k22) {
    var d32 = Object.getOwnPropertyDescriptor(n, k22);
    Object.defineProperty(a32, k22, d32.get ? d32 : {
      enumerable: true,
      get: function() {
        return n[k22];
      }
    });
  });
  return a32;
}
var FUNC_ERROR_TEXT = "Expected a function";
var NAN = 0 / 0;
var symbolTag$1 = "[object Symbol]";
var reTrim = /^\s+|\s+$/g;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
var freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var freeSelf$1 = typeof self == "object" && self && self.Object === Object && self;
var root$1 = freeGlobal$1 || freeSelf$1 || Function("return this")();
var objectProto$1 = Object.prototype;
var objectToString$2 = objectProto$1.toString;
var nativeMax = Math.max, nativeMin = Math.min;
var now = function() {
  return root$1.Date.now();
};
function debounce(func, wait2, options) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait2 = toNumber(wait2) || 0;
  if (isObject$2(options)) {
    leading = !!options.leading;
    maxing = "maxWait" in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait2) : maxWait;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    lastInvokeTime = time;
    timerId = setTimeout(timerExpired, wait2);
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result2 = wait2 - timeSinceLastCall;
    return maxing ? nativeMin(result2, maxWait - timeSinceLastInvoke) : result2;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait2 || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(now());
  }
  function debounced() {
    var time = now(), isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        timerId = setTimeout(timerExpired, wait2);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait2);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
function throttle(func, wait2, options) {
  var leading = true, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject$2(options)) {
    leading = "leading" in options ? !!options.leading : leading;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait2, {
    "leading": leading,
    "maxWait": wait2,
    "trailing": trailing
  });
}
function isObject$2(value2) {
  var type2 = typeof value2;
  return !!value2 && (type2 == "object" || type2 == "function");
}
function isObjectLike$1(value2) {
  return !!value2 && typeof value2 == "object";
}
function isSymbol$2(value2) {
  return typeof value2 == "symbol" || isObjectLike$1(value2) && objectToString$2.call(value2) == symbolTag$1;
}
function toNumber(value2) {
  if (typeof value2 == "number") {
    return value2;
  }
  if (isSymbol$2(value2)) {
    return NAN;
  }
  if (isObject$2(value2)) {
    var other = typeof value2.valueOf == "function" ? value2.valueOf() : value2;
    value2 = isObject$2(other) ? other + "" : other;
  }
  if (typeof value2 != "string") {
    return value2 === 0 ? value2 : +value2;
  }
  value2 = value2.replace(reTrim, "");
  var isBinary = reIsBinary.test(value2);
  return isBinary || reIsOctal.test(value2) ? freeParseInt(value2.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value2) ? NAN : +value2;
}
var lodash_throttle = throttle;
const throttle$1 = /* @__PURE__ */ getDefaultExportFromCjs(lodash_throttle);
const _sfc_main$1I = defineComponent({
  name: "Tooltip",
  components: {
    QTooltip: QTooltip_default$1
  },
  inheritAttrs: false,
  props: {
    /**
     * Automatically hide after a time when manually triggered
     */
    autoHide: {
      default: void 0,
      type: Number
    },
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Two values setting the starting position or anchor point of the Tooltip relative to its target
     */
    anchor: {
      type: String,
      default: "bottom middle"
    },
    /**
     * Render arrow (bottom|left|right|top)
     */
    arrow: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * The maximum width of the Tooltip; Size in CSS units, including unit name
     */
    maxWidth: {
      type: String,
      default: "400px"
    },
    /**
     * Model of the component; Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
     */
    modelValue: {
      type: Boolean,
      default: void 0
    },
    /**
     * An array of two numbers to offset the Tooltip horizontally and vertically in pixels
     */
    offset: {
      type: Array,
      default: () => [14, 14]
    },
    /**
     * Two values setting the Tooltip's own position relative to its target
     */
    self: {
      type: String,
      default: "top middle"
    },
    /**
     * Configure a target element to trigger Tooltip toggle; 'true' means it enables the parent DOM element, 'false' means it disables attaching events to any DOM elements; By using a String (CSS selector) it attaches the events to the specified DOM element (if it exists)
     */
    target: {
      type: [Boolean, String],
      default: true
    }
  },
  emits: [
    /**
     * Emitted when the component needs to change the model; Is also used by v-model
     *
     * @type {boolean}
     */
    "update:modelValue"
  ],
  setup(props4, { emit }) {
    const tooltipRef = ref$1(null);
    const timeout2 = ref$1(null);
    const arrowClass = computed(() => {
      switch (props4.arrow) {
        case "bottom":
          return "rv-tooltip__arrow rv-tooltip__arrow--bottom";
        case "left":
          return "rv-tooltip__arrow rv-tooltip__arrow--left";
        case "right":
          return "rv-tooltip__arrow rv-tooltip__arrow--right";
        case "top":
          return "rv-tooltip__arrow rv-tooltip__arrow--top";
        default:
          return void 0;
      }
    });
    function show(evt) {
      var _a;
      (_a = tooltipRef.value) == null ? void 0 : _a.show(evt);
      if (timeout2.value) window.clearTimeout(timeout2.value);
      if (props4.autoHide) {
        timeout2.value = window.setTimeout(() => {
          var _a2;
          (_a2 = tooltipRef.value) == null ? void 0 : _a2.hide();
        }, props4.autoHide);
      }
    }
    function onUpdate(value2) {
      emit("update:modelValue", value2);
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      arrowClass,
      onUpdate,
      show,
      tooltipRef
    };
  }
});
const _export_sfc$1 = (sfc, props4) => {
  const target2 = sfc.__vccOpts || sfc;
  for (const [key, val] of props4) {
    target2[key] = val;
  }
  return target2;
};
function _sfc_render$1B(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QTooltip = resolveComponent("QTooltip");
  return openBlock(), createBlock(_component_QTooltip, mergeProps(_ctx.dataAttrs, {
    ref: "tooltipRef",
    anchor: _ctx.anchor,
    class: ["rv-tooltip q-pa-sm text-overline shadow-6", [_ctx.arrowClass, _ctx.$props.class]],
    "data-automation": _ctx.buildId(),
    delay: 500,
    fit: true,
    "max-width": _ctx.maxWidth,
    "model-value": _ctx.modelValue,
    offset: _ctx.offset,
    self: _ctx.self,
    target: _ctx.target,
    "transition-hide": "fade",
    "transition-show": "fade",
    "onUpdate:modelValue": _ctx.onUpdate
  }), {
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["anchor", "class", "data-automation", "max-width", "model-value", "offset", "self", "target", "onUpdate:modelValue"]);
}
const Tooltip2 = /* @__PURE__ */ _export_sfc$1(_sfc_main$1I, [["render", _sfc_render$1B]]);
const COLORS = [
  "accent",
  "black-1",
  "grey-1",
  "grey-2",
  "info",
  "negative",
  "positive",
  "primary",
  "primary-fixed",
  "warning",
  "white-fixed"
];
const SIZES$2 = ["xs", "sm", "md", "lg"];
const _sfc_main$1H = defineComponent({
  name: "Button",
  components: {
    QBtn: QBtn_default$1,
    Tooltip: Tooltip2
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Label or content alignment
     */
    align: {
      type: String,
      default: "center",
      validator: (v) => ["left", "right", "center", "around", "between", "evenly"].includes(v)
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Color name for component from the Quasar Color Palette
     */
    color: {
      type: String,
      default: void 0,
      validator: (v) => COLORS.includes(v)
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Native <a> link href attribute; Has priority over the 'to' and 'replace' props
     */
    href: {
      type: String,
      default: void 0
    },
    /**
     * Icon name following Quasar convention; Make sure you have the icon library installed unless you are using 'img:' prefix
     */
    icon: {
      type: String,
      default: void 0
    },
    /**
     * Icon name following Quasar convention; Make sure you have the icon library installed unless you are using 'img:' prefix
     */
    iconRight: {
      type: String,
      default: void 0
    },
    /**
     * The text that will be shown on the button
     */
    label: {
      type: String,
      default: void 0
    },
    /**
     * Put button into loading state (displays a QSpinner -- can be overridden by using a 'loading' slot)
     */
    loading: {
      type: Boolean,
      default: false
    },
    /**
     * Render button in secondary mode
     */
    secondary: {
      type: Boolean,
      default: false
    },
    /**
     * Size in standard size name (xs|sm|md|lg)
     */
    size: {
      type: String,
      default: "md",
      validator: (v) => SIZES$2.includes(v)
    },
    /**
     * Styles applied to component
     * @type {[Array, Object, String]}
     */
    style: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Native <a> link target attribute; Use it only with 'to' or 'href' props
     */
    target: {
      type: String,
      default: void 0
    },
    /**
     * Render button in tertiary mode
     */
    tertiary: {
      type: Boolean,
      default: false
    },
    /**
     * Overrides text color (if needed); Color name from the Quasar Color Palette
     */
    textColor: {
      type: String,
      default: void 0
    },
    /**
     * Equivalent to Vue Router <router-link> 'to' property; Superseded by 'href' prop if used
     */
    to: {
      type: [Object, String],
      default: void 0
    },
    /**
     * The text that will be shown on the button tooltip
     */
    tooltip: {
      type: String,
      default: void 0
    },
    /**
     * 1) Define the button native type attribute (submit, reset, button) or 2) render component with <a> tag so you can access events even if disable or 3) Use 'href' prop and specify 'type' as a media tag
     */
    type: {
      type: String,
      default: "button"
    }
  },
  emits: [
    /**
     * Emitted when component is clicked (activated)
     *
     * @type {object}
     */
    "click"
  ],
  setup(props4, { emit }) {
    const buttonColor = computed(() => {
      if (props4.secondary && !hasLabel.value && !props4.color) return "black-1";
      return props4.color ?? "primary";
    });
    const hasLabel = computed(() => props4.label != null && props4.label !== "");
    const onClick = throttle$1(
      (event) => emit("click", event),
      200,
      { trailing: false }
    );
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      buttonColor,
      hasLabel,
      onClick
    };
  }
});
function _sfc_render$1A(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_QBtn = resolveComponent("QBtn");
  return openBlock(), createBlock(_component_QBtn, mergeProps(_ctx.dataAttrs, {
    align: _ctx.align,
    class: ["rv-button", [
      _ctx.$props.class,
      `rv-button--${_ctx.size}`,
      { "rv-button--icon-only": !_ctx.hasLabel }
    ]],
    color: _ctx.buttonColor,
    "data-automation": _ctx.buildId(),
    disable: _ctx.disable,
    flat: _ctx.tertiary,
    href: _ctx.href,
    icon: _ctx.icon,
    "icon-right": _ctx.iconRight,
    label: _ctx.label,
    loading: _ctx.loading,
    "no-caps": "",
    outline: _ctx.secondary,
    ripple: false,
    style: _ctx.style,
    target: _ctx.target,
    "text-color": _ctx.textColor,
    to: _ctx.to,
    type: _ctx.type,
    onClick: _ctx.onClick
  }), createSlots({ _: 2 }, [
    _ctx.tooltip ? {
      name: "default",
      fn: withCtx(() => [
        createVNode(_component_Tooltip, {
          "data-automation": _ctx.buildId("tooltip")
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.tooltip), 1)
          ]),
          _: 1
        }, 8, ["data-automation"])
      ]),
      key: "0"
    } : void 0,
    renderList(_ctx.$slots, (_, name2) => {
      return {
        name: name2,
        fn: withCtx((slotData) => [
          renderSlot(_ctx.$slots, name2, normalizeProps(guardReactiveProps(slotData || {})), void 0, true)
        ])
      };
    })
  ]), 1040, ["align", "class", "color", "data-automation", "disable", "flat", "href", "icon", "icon-right", "label", "loading", "outline", "style", "target", "text-color", "to", "type", "onClick"]);
}
const Button = /* @__PURE__ */ _export_sfc$1(_sfc_main$1H, [["render", _sfc_render$1A], ["__scopeId", "data-v-bdbb4238"]]);
const _sfc_main$1G = defineComponent({
  name: "ClickableArea",
  components: {
    QBtn: QBtn_default$1
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Changes background color on hover
     */
    hoverable: {
      type: Boolean,
      default: true
    },
    /**
     * Native <a> link href attribute; Has priority over the 'to' and 'replace' props
     */
    href: {
      type: String,
      default: void 0
    },
    /**
     * Styles applied to component
     * @type {[Array, Object, String]}
     */
    style: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Native <a> link target attribute; Use it only with 'to' or 'href' props
     */
    target: {
      type: String,
      default: void 0
    },
    /**
     * Equivalent to Vue Router <router-link> 'to' property; Superseded by 'href' prop if used
     */
    to: {
      type: [Object, String],
      default: void 0
    },
    /**
     * 1) Define the button native type attribute (submit, reset, button) or 2) render component with <a> tag so you can access events even if disable or 3) Use 'href' prop and specify 'type' as a media tag
     */
    type: {
      type: String,
      default: "button"
    }
  },
  emits: [
    /**
     * Emitted when component is clicked (activated)
     *
     * @type {object}
     */
    "click",
    "dragend",
    "dragleave",
    "dragover",
    "dragstart",
    "drop"
  ],
  setup(props4, { emit }) {
    const onClick = throttle$1(
      (event) => emit("click", event),
      200,
      { trailing: false }
    );
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      onClick
    };
  }
});
function _sfc_render$1z(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QBtn = resolveComponent("QBtn");
  return openBlock(), createBlock(_component_QBtn, mergeProps(_ctx.dataAttrs, {
    class: ["rv-clickable-area", [
      _ctx.$props.class,
      { "rv-clickable-area--hoverable": _ctx.hoverable && !_ctx.disable }
    ]],
    "data-automation": _ctx.buildId(),
    disable: _ctx.disable,
    href: _ctx.href,
    "no-caps": "",
    ripple: false,
    style: _ctx.style,
    target: _ctx.target,
    to: _ctx.to,
    type: _ctx.type,
    onClick: _ctx.onClick,
    onDragend: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("dragend", $event)),
    onDragleave: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("dragleave", $event)),
    onDragover: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("dragover", $event)),
    onDragstart: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("dragstart", $event)),
    onDrop: _cache[4] || (_cache[4] = ($event) => _ctx.$emit("drop", $event))
  }), {
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default", {}, void 0, true)
    ]),
    _: 3
  }, 16, ["class", "data-automation", "disable", "href", "style", "target", "to", "type", "onClick"]);
}
const ClickableArea = /* @__PURE__ */ _export_sfc$1(_sfc_main$1G, [["render", _sfc_render$1z], ["__scopeId", "data-v-35f5def3"]]);
const SIZES$1 = ["xs", "sm", "md"];
const _sfc_main$1F = defineComponent({
  name: "Checkbox",
  components: {
    ClickableArea,
    QCheckbox: QCheckbox_default$1,
    QIcon: QIcon_default$1,
    QMenu: QMenu_default$1
  },
  inheritAttrs: false,
  props: {
    /**
     * Used to align the checkbox with other components (including option group)
     */
    aligned: {
      type: Boolean,
      default: false
    },
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Dense mode; occupies less space
     */
    dense: {
      type: Boolean,
      default: false
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Label to display along the component
     */
    label: {
      type: String,
      default: void 0
    },
    /**
     * Model of the component; Either use this property (along with a listener for 'update:model-value' event) OR use v-model directive
     */
    modelValue: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      type: [Boolean, Array],
      default: void 0
    },
    /**
     * Size in standard size name (xs|sm|md)
     */
    size: {
      type: String,
      default: void 0,
      validator: (v) => SIZES$1.includes(v)
    },
    /**
     * Styles applied to component
     * @type {[Array, Object, String]}
     */
    style: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Works when model ('value') is Array. It tells the component which value should add/remove when ticked/unticked
     */
    val: {
      type: null,
      default: void 0
    }
  },
  emits: ["update:modelValue"],
  setup(props4, { emit }) {
    const showMenu = ref$1(false);
    const value2 = computed({
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      get() {
        return props4.modelValue;
      },
      set(value22) {
        emit("update:modelValue", value22);
      }
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      showMenu,
      value: value2
    };
  }
});
const _hoisted_1$1t = { class: "rv-checkbox-wrapper row items-center" };
function _sfc_render$1y(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QCheckbox = resolveComponent("QCheckbox");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_QMenu = resolveComponent("QMenu");
  const _component_ClickableArea = resolveComponent("ClickableArea");
  return openBlock(), createElementBlock("div", _hoisted_1$1t, [
    createVNode(_component_QCheckbox, mergeProps({
      ..._ctx.dataAttrs,
      ...!!_ctx.$attrs.onClick && { onClick: _ctx.$attrs.onClick }
    }, {
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.value = $event),
      class: ["rv-checkbox", [
        _ctx.$props.class,
        `rv-checkbox--${_ctx.size}`,
        {
          "rv-checkbox--aligned": _ctx.aligned,
          "rv-checkbox--with-menu": _ctx.$slots["menu"]
        }
      ]],
      "data-automation": _ctx.buildId(),
      dense: _ctx.dense,
      disable: _ctx.disable,
      label: _ctx.label,
      size: _ctx.size,
      style: _ctx.style,
      val: _ctx.val
    }), {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ]),
      _: 3
    }, 16, ["modelValue", "class", "data-automation", "dense", "disable", "label", "size", "style", "val"]),
    _ctx.$slots["menu"] ? (openBlock(), createBlock(_component_ClickableArea, {
      key: 0,
      class: normalizeClass(["rv-checkbox__menu-icon-wrapper cursor-pointer flex items-center", [`rv-checkbox__menu-icon-wrapper--${_ctx.size}`]]),
      "data-automation": "checkbox__menu-icon-wrapper",
      disable: _ctx.disable
    }, {
      default: withCtx(() => [
        createVNode(_component_QIcon, {
          "data-automation": "checkbox__menu-icon",
          name: "mdi-menu-down",
          size: "15px"
        }),
        createVNode(_component_QMenu, {
          modelValue: _ctx.showMenu,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.showMenu = $event),
          "auto-close": "",
          "data-automation": "checkbox__menu",
          self: "top left"
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "menu", {}, void 0, true)
          ]),
          _: 3
        }, 8, ["modelValue"])
      ]),
      _: 3
    }, 8, ["class", "disable"])) : createCommentVNode("", true)
  ]);
}
const Checkbox = /* @__PURE__ */ _export_sfc$1(_sfc_main$1F, [["render", _sfc_render$1y], ["__scopeId", "data-v-d0b6c497"]]);
const _sfc_main$1E = defineComponent({
  name: "ScrollArea",
  components: {
    QScrollArea: QScrollArea_default
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: "scrollArea"
    },
    /**
     * Classes applied to the Histogram
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Removes horizontal scroll
     */
    noHorizontal: {
      type: Boolean,
      default: false
    },
    /**
     * Force render the content as a normal div
     */
    noScroll: {
      type: Boolean,
      default: false
    },
    /**
     * Styles applied to component
     * @type {[Array, Object, String]}
     */
    style: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Manually control the visibility of the scrollbar; Overrides default mouse over/leave behavior
     */
    visible: {
      type: Boolean,
      default: void 0
    }
  },
  emits: ["scroll"],
  setup(props4, { emit }) {
    const scrollAreaRef = ref$1();
    const bottomVisible = ref$1(true);
    const topVisible = ref$1(true);
    function onScroll(event) {
      emit("scroll", event);
      const {
        verticalContainerSize,
        verticalPosition,
        verticalSize
      } = event;
      topVisible.value = !verticalPosition;
      bottomVisible.value = verticalSize - verticalContainerSize === verticalPosition;
    }
    function setScrollPosition(axis, offset2, duration2 = 0) {
      if (scrollAreaRef.value) scrollAreaRef.value.setScrollPosition(axis, offset2, duration2);
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      bottomVisible,
      onScroll,
      scrollAreaRef,
      setScrollPosition,
      topVisible
    };
  }
});
const _hoisted_1$1s = ["data-automation"];
function _sfc_render$1x(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QScrollArea = resolveComponent("QScrollArea");
  return !_ctx.noScroll ? (openBlock(), createBlock(_component_QScrollArea, mergeProps({ key: 0 }, {
    ..._ctx.dataAttrs,
    ..._ctx.$props.visible != null && { visible: _ctx.$props.visible }
  }, {
    ref: "scrollAreaRef",
    class: ["scroll-area", [_ctx.$props.class, { "scroll-area--no-horizontal": _ctx.noHorizontal }]],
    "data-automation": _ctx.buildId(),
    style: _ctx.style,
    onScroll: _ctx.onScroll
  }), {
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default", {}, void 0, true)
    ]),
    _: 3
  }, 16, ["class", "data-automation", "style", "onScroll"])) : (openBlock(), createElementBlock("div", {
    key: 1,
    class: normalizeClass(["scroll-area", _ctx.$props.class]),
    "data-automation": _ctx.buildId(),
    style: normalizeStyle(_ctx.style)
  }, [
    renderSlot(_ctx.$slots, "default", {}, void 0, true)
  ], 14, _hoisted_1$1s));
}
const ScrollArea = /* @__PURE__ */ _export_sfc$1(_sfc_main$1E, [["render", _sfc_render$1x], ["__scopeId", "data-v-b4e771c5"]]);
const _sfc_main$1D = defineComponent({
  name: "Dialog",
  components: {
    Button,
    QCard: QCard_default$1,
    QCardActions: QCardActions_default$1,
    QCardSection: QCardSection_default$1,
    QDialog: QDialog_default$1,
    QResizeObserver: QResizeObserver_default$1,
    ScrollArea
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: "dialog"
    },
    /**
     * Render an empty q-dialog component
     */
    empty: {
      type: Boolean,
      default: false
    },
    /**
     * Show close dialog button on the top
     */
    hideCloseButton: {
      type: Boolean,
      default: false
    },
    /**
     * Dialog width
     */
    width: {
      type: String,
      default: "400px"
    }
  },
  emits: [
    ...useDialogPluginComponent.emits,
    "on-cancel"
  ],
  setup(props4) {
    const {
      dialogRef,
      onDialogHide
    } = useDialogPluginComponent();
    const contentRef = ref$1();
    const contentHeight = ref$1(0);
    const contentHeightStyle = computed(() => `${contentHeight.value}px`);
    function hide() {
      var _a;
      (_a = dialogRef.value) == null ? void 0 : _a.hide();
    }
    function onResize(dimensions) {
      contentHeight.value = dimensions.height;
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      contentHeightStyle,
      contentRef,
      dialogRef,
      hide,
      onDialogHide,
      onResize
    };
  }
});
const _hoisted_1$1r = { ref: "contentRef" };
function _sfc_render$1w(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = resolveComponent("Button");
  const _component_QCardSection = resolveComponent("QCardSection");
  const _component_QResizeObserver = resolveComponent("QResizeObserver");
  const _component_ScrollArea = resolveComponent("ScrollArea");
  const _component_QCardActions = resolveComponent("QCardActions");
  const _component_QCard = resolveComponent("QCard");
  const _component_QDialog = resolveComponent("QDialog");
  return openBlock(), createBlock(_component_QDialog, mergeProps({
    ref: "dialogRef",
    "data-automation": _ctx.buildId()
  }, _ctx.$attrs, {
    style: {
      "--dialog-width": _ctx.width,
      "--dialog-content-height": _ctx.contentHeightStyle
    },
    onHide: _ctx.onDialogHide
  }), {
    default: withCtx(() => [
      _ctx.empty ? renderSlot(_ctx.$slots, "default", { key: 0 }, void 0, true) : (openBlock(), createBlock(_component_QCard, {
        key: 1,
        class: "rv-dialog column no-wrap"
      }, {
        default: withCtx(() => [
          !_ctx.hideCloseButton ? (openBlock(), createBlock(_component_QCardSection, {
            key: 0,
            class: "q-pb-none flex justify-end"
          }, {
            default: withCtx(() => [
              createVNode(_component_Button, {
                class: "no-padding",
                color: "black-1",
                "data-automation": _ctx.buildId("close"),
                icon: "mdi-close",
                tertiary: "",
                onClick: _ctx.hide
              }, null, 8, ["data-automation", "onClick"])
            ]),
            _: 1
          })) : createCommentVNode("", true),
          createVNode(_component_QCardSection, {
            class: "q-pt-none row justify-center items-center",
            "data-automation": _ctx.buildId("title")
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "title", {}, void 0, true)
            ]),
            _: 3
          }, 8, ["data-automation"]),
          createVNode(_component_QCardSection, {
            class: "rv-dialog__content q-px-md q-py-none",
            "data-automation": _ctx.buildId("content")
          }, {
            default: withCtx(() => [
              createVNode(_component_ScrollArea, {
                class: "full-height",
                "data-automation": _ctx.buildId("scroll")
              }, {
                default: withCtx(() => [
                  createElementVNode("div", _hoisted_1$1r, [
                    createVNode(_component_QResizeObserver, { onResize: _ctx.onResize }, null, 8, ["onResize"]),
                    renderSlot(_ctx.$slots, "default", {}, void 0, true)
                  ], 512)
                ]),
                _: 3
              }, 8, ["data-automation"])
            ]),
            _: 3
          }, 8, ["data-automation"]),
          createVNode(_component_QCardActions, {
            class: "row q-pa-md flex justify-end",
            "data-automation": _ctx.buildId("actions")
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "actions", {}, void 0, true)
            ]),
            _: 3
          }, 8, ["data-automation"])
        ]),
        _: 3
      }))
    ]),
    _: 3
  }, 16, ["data-automation", "style", "onHide"]);
}
const Dialog = /* @__PURE__ */ _export_sfc$1(_sfc_main$1D, [["render", _sfc_render$1w], ["__scopeId", "data-v-38ddab3b"]]);
function useSidebar() {
  const instance = getCurrentInstance();
  if (!instance) throw new Error("No component");
  const { emit } = instance;
  const {
    dialogRef,
    onDialogCancel,
    onDialogHide,
    onDialogOK
  } = useDialogPluginComponent();
  const saving = ref$1(false);
  function onError() {
    saving.value = false;
  }
  function onSave(data) {
    saving.value = true;
    emit("ok", {
      data,
      onDone: () => {
        if (dialogRef == null ? void 0 : dialogRef.value) onDialogCancel();
      },
      onError
    });
  }
  return {
    dialogRef,
    onCancel: onDialogCancel,
    onError,
    onHide: onDialogHide,
    onOK: onDialogOK,
    onSave,
    saving
  };
}
useSidebar.emits = useDialogPluginComponent.emits;
const _sfc_main$1C = defineComponent({
  name: "ConfirmDialog",
  components: {
    Button,
    Checkbox,
    Dialog,
    QIcon: QIcon_default$1,
    QSpace: QSpace_default
  },
  props: {
    /**
     * Text displayed on the confirmation button
     */
    actionLabel: {
      type: String,
      default: () => useI18n().t("rvai-base.general.actions.confirm")
    },
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: "confirmDialog"
    },
    /**
     * Display "Don't show again" checkbox
     */
    withDontShowAgain: {
      type: Boolean,
      default: false
    },
    /**
     * Text displayed on the cancel button
     */
    cancelLabel: {
      type: String,
      default: () => useI18n().t("rvai-base.general.actions.cancel")
    },
    /**
     * Main text
     */
    message: {
      type: String,
      required: true
    },
    /**
     * Text displayed in title
     */
    title: {
      type: String,
      default: () => useI18n().t("rvai-base.general.titles.sure")
    }
  },
  setup(props4) {
    const { t: t22 } = useI18n();
    const {
      dialogRef,
      onOK
    } = useSidebar();
    const dontShowAgain = ref$1(false);
    function ok(confirmed) {
      const payload = { confirmed };
      if (props4.withDontShowAgain) {
        payload.dontShowAgain = dontShowAgain.value;
      }
      onOK(payload);
    }
    function cancel() {
      ok(false);
    }
    function confirm() {
      ok(true);
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      cancel,
      confirm,
      dialogRef,
      dontShowAgain,
      t: t22
    };
  }
});
const _hoisted_1$1q = ["data-automation"];
const _hoisted_2$19 = ["innerHTML"];
function _sfc_render$1v(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QIcon = resolveComponent("QIcon");
  const _component_Checkbox = resolveComponent("Checkbox");
  const _component_QSpace = resolveComponent("QSpace");
  const _component_Button = resolveComponent("Button");
  const _component_Dialog = resolveComponent("Dialog");
  return openBlock(), createBlock(_component_Dialog, mergeProps({
    ref: "dialogRef",
    "data-automation": _ctx.buildId()
  }, toHandlers(_ctx.$attrs)), {
    title: withCtx(() => [
      createVNode(_component_QIcon, {
        color: "grey-2",
        "data-automation": _ctx.buildId("icon-error"),
        name: "error",
        size: "33px"
      }, null, 8, ["data-automation"]),
      createElementVNode("span", {
        class: "rv-confirm-dialog__title text-subtitle1 text-center q-ml-sm",
        "data-automation": _ctx.buildId("label")
      }, toDisplayString(_ctx.title), 9, _hoisted_1$1q)
    ]),
    default: withCtx(() => [
      createElementVNode("div", {
        innerHTML: _ctx.$sanitize(_ctx.message)
      }, null, 8, _hoisted_2$19),
      renderSlot(_ctx.$slots, "default", {}, void 0, true)
    ]),
    actions: withCtx(() => [
      _ctx.withDontShowAgain ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        createVNode(_component_Checkbox, {
          modelValue: _ctx.dontShowAgain,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.dontShowAgain = $event),
          "data-automation": _ctx.buildId("dontShowAgain"),
          label: _ctx.t("rvai-base.dialogs.confirmation.dontShowAgain")
        }, null, 8, ["modelValue", "data-automation", "label"]),
        createVNode(_component_QSpace)
      ], 64)) : createCommentVNode("", true),
      createVNode(_component_Button, {
        class: "rv-confirm-dialog__cancel-btn",
        "data-automation": _ctx.buildId("cancel"),
        label: _ctx.cancelLabel,
        secondary: "",
        size: "sm",
        onClick: _cache[1] || (_cache[1] = ($event) => _ctx.cancel())
      }, null, 8, ["data-automation", "label"]),
      createVNode(_component_Button, {
        class: "rv-confirm-dialog__confirm-btn",
        color: "primary",
        "data-automation": _ctx.buildId("confirm"),
        label: _ctx.actionLabel,
        size: "sm",
        onClick: _cache[2] || (_cache[2] = ($event) => _ctx.confirm())
      }, null, 8, ["data-automation", "label"])
    ]),
    _: 3
  }, 16, ["data-automation"]);
}
const ConfirmDialog = /* @__PURE__ */ _export_sfc$1(_sfc_main$1C, [["render", _sfc_render$1v], ["__scopeId", "data-v-f6e2b8b6"]]);
const NULL_CLASS_ID = "null";
const UNKNOWN_CLASS_ID = "999";
var CookiesPolicy = /* @__PURE__ */ ((CookiesPolicy2) => {
  CookiesPolicy2["All"] = "all";
  CookiesPolicy2["Required"] = "required";
  return CookiesPolicy2;
})(CookiesPolicy || {});
const DARK_MODE_LOCAL_STORAGE_KEY = "darkMode";
const KEY_ARROW_DOWN = "ArrowDown";
const KEY_ARROW_LEFT = "ArrowLeft";
const KEY_ARROW_RIGHT = "ArrowRight";
const KEY_ARROW_UP = "ArrowUp";
const KEY_ENTER = "Enter";
const KEY_ESC = "Esc";
const KEY_ESCAPE = "Escape";
var Layout = /* @__PURE__ */ ((Layout2) => {
  Layout2["Default"] = "default";
  Layout2["Full"] = "full";
  Layout2["LeftOnly"] = "leftOnly";
  Layout2["RightOnly"] = "rightOnly";
  Layout2["Split"] = "split";
  return Layout2;
})(Layout || {});
var PipelineHealthStatus = /* @__PURE__ */ ((PipelineHealthStatus2) => {
  PipelineHealthStatus2["Critical"] = "CRITICAL";
  PipelineHealthStatus2["Failing"] = "FAILING";
  PipelineHealthStatus2["Healthy"] = "HEALTHY";
  PipelineHealthStatus2["Overpowered"] = "OVERPOWERED";
  PipelineHealthStatus2["Unbalanced"] = "UNBALANCED";
  PipelineHealthStatus2["Underpowered"] = "UNDERPOWERED";
  PipelineHealthStatus2["Unknown"] = "UNKNOWN";
  return PipelineHealthStatus2;
})(PipelineHealthStatus || {});
var ReplicaStatus = /* @__PURE__ */ ((ReplicaStatus2) => {
  ReplicaStatus2["Error"] = "ERROR";
  ReplicaStatus2["Queued"] = "QUEUED";
  ReplicaStatus2["Running"] = "RUNNING";
  ReplicaStatus2["Starting"] = "STARTING";
  ReplicaStatus2["Unknown"] = "UNKNOWN";
  return ReplicaStatus2;
})(ReplicaStatus || {});
var SortOrders = /* @__PURE__ */ ((SortOrders2) => {
  SortOrders2["Asc"] = "asc";
  SortOrders2["Desc"] = "desc";
  return SortOrders2;
})(SortOrders || {});
var SortType = /* @__PURE__ */ ((SortType2) => {
  SortType2["Date"] = "date";
  return SortType2;
})(SortType || {});
var TableFilterType = /* @__PURE__ */ ((TableFilterType2) => {
  TableFilterType2["Date"] = "date";
  TableFilterType2["FreeText"] = "freeText";
  TableFilterType2["List"] = "list";
  TableFilterType2["Number"] = "number";
  TableFilterType2["Single"] = "single";
  return TableFilterType2;
})(TableFilterType || {});
var ShapesNoData = /* @__PURE__ */ ((ShapesNoData2) => {
  ShapesNoData2["Horizontal"] = "horizontal";
  ShapesNoData2["Square"] = "square";
  return ShapesNoData2;
})(ShapesNoData || {});
const COOKIES_POLICY = "cookiesPolicy";
const cookiesPolicy = ref$1(
  LocalStorage_default.getItem(COOKIES_POLICY) ?? null
);
function useCookiesPolicy() {
  const allowOptionalCookies = computed(() => cookiesPolicy.value === CookiesPolicy.All);
  const hasCookiesPolicy = computed(() => !!cookiesPolicy.value);
  function setCookiesPolicy(value2) {
    cookiesPolicy.value = value2;
    LocalStorage_default.set(COOKIES_POLICY, value2);
  }
  return {
    allowOptionalCookies,
    cookiesPolicy: readonly(cookiesPolicy),
    hasCookiesPolicy,
    setCookiesPolicy
  };
}
function useDarkMode() {
  const $q = useQuasar();
  function initialize2(value2) {
    if (value2 != null) {
      $q.dark.set(value2);
    } else {
      $q.dark.set(LocalStorage_default.getItem(DARK_MODE_LOCAL_STORAGE_KEY) || false);
    }
  }
  function set2(value2) {
    $q.dark.set(value2);
    LocalStorage_default.set(DARK_MODE_LOCAL_STORAGE_KEY, $q.dark.isActive);
  }
  function toggle() {
    $q.dark.toggle();
    LocalStorage_default.set(DARK_MODE_LOCAL_STORAGE_KEY, $q.dark.isActive);
  }
  return {
    initialize: initialize2,
    isDark: computed(() => $q.dark.isActive),
    set: set2,
    toggle
  };
}
var esErrors = Error;
var _eval = EvalError;
var range = RangeError;
var ref = ReferenceError;
var syntax = SyntaxError;
var type = TypeError;
var uri = URIError;
var shams = function hasSymbols() {
  if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") {
    return false;
  }
  if (typeof Symbol.iterator === "symbol") {
    return true;
  }
  var obj = {};
  var sym = Symbol("test");
  var symObj = Object(sym);
  if (typeof sym === "string") {
    return false;
  }
  if (Object.prototype.toString.call(sym) !== "[object Symbol]") {
    return false;
  }
  if (Object.prototype.toString.call(symObj) !== "[object Symbol]") {
    return false;
  }
  var symVal = 42;
  obj[sym] = symVal;
  for (sym in obj) {
    return false;
  }
  if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) {
    return false;
  }
  if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) {
    return false;
  }
  var syms = Object.getOwnPropertySymbols(obj);
  if (syms.length !== 1 || syms[0] !== sym) {
    return false;
  }
  if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
    return false;
  }
  if (typeof Object.getOwnPropertyDescriptor === "function") {
    var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
    if (descriptor.value !== symVal || descriptor.enumerable !== true) {
      return false;
    }
  }
  return true;
};
var origSymbol = typeof Symbol !== "undefined" && Symbol;
var hasSymbolSham = shams;
var hasSymbols$1 = function hasNativeSymbols() {
  if (typeof origSymbol !== "function") {
    return false;
  }
  if (typeof Symbol !== "function") {
    return false;
  }
  if (typeof origSymbol("foo") !== "symbol") {
    return false;
  }
  if (typeof Symbol("bar") !== "symbol") {
    return false;
  }
  return hasSymbolSham();
};
var test = {
  __proto__: null,
  foo: {}
};
var $Object = Object;
var hasProto$1 = function hasProto() {
  return { __proto__: test }.foo === test.foo && !(test instanceof $Object);
};
var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var toStr$1 = Object.prototype.toString;
var max = Math.max;
var funcType = "[object Function]";
var concatty = function concatty2(a32, b22) {
  var arr = [];
  for (var i22 = 0; i22 < a32.length; i22 += 1) {
    arr[i22] = a32[i22];
  }
  for (var j = 0; j < b22.length; j += 1) {
    arr[j + a32.length] = b22[j];
  }
  return arr;
};
var slicy = function slicy2(arrLike, offset2) {
  var arr = [];
  for (var i22 = offset2, j = 0; i22 < arrLike.length; i22 += 1, j += 1) {
    arr[j] = arrLike[i22];
  }
  return arr;
};
var joiny = function(arr, joiner) {
  var str = "";
  for (var i22 = 0; i22 < arr.length; i22 += 1) {
    str += arr[i22];
    if (i22 + 1 < arr.length) {
      str += joiner;
    }
  }
  return str;
};
var implementation$1 = function bind(that) {
  var target2 = this;
  if (typeof target2 !== "function" || toStr$1.apply(target2) !== funcType) {
    throw new TypeError(ERROR_MESSAGE + target2);
  }
  var args = slicy(arguments, 1);
  var bound;
  var binder = function() {
    if (this instanceof bound) {
      var result = target2.apply(
        this,
        concatty(args, arguments)
      );
      if (Object(result) === result) {
        return result;
      }
      return this;
    }
    return target2.apply(
      that,
      concatty(args, arguments)
    );
  };
  var boundLength = max(0, target2.length - args.length);
  var boundArgs = [];
  for (var i22 = 0; i22 < boundLength; i22++) {
    boundArgs[i22] = "$" + i22;
  }
  bound = Function("binder", "return function (" + joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
  if (target2.prototype) {
    var Empty = function Empty2() {
    };
    Empty.prototype = target2.prototype;
    bound.prototype = new Empty();
    Empty.prototype = null;
  }
  return bound;
};
var implementation = implementation$1;
var functionBind = Function.prototype.bind || implementation;
var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind$1 = functionBind;
var hasown = bind$1.call(call, $hasOwn);
var undefined$1;
var $Error = esErrors;
var $EvalError = _eval;
var $RangeError = range;
var $ReferenceError = ref;
var $SyntaxError$1 = syntax;
var $TypeError$3 = type;
var $URIError = uri;
var $Function = Function;
var getEvalledConstructor = function(expressionSyntax) {
  try {
    return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
  } catch (e22) {
  }
};
var $gOPD$1 = Object.getOwnPropertyDescriptor;
if ($gOPD$1) {
  try {
    $gOPD$1({}, "");
  } catch (e22) {
    $gOPD$1 = null;
  }
}
var throwTypeError = function() {
  throw new $TypeError$3();
};
var ThrowTypeError = $gOPD$1 ? function() {
  try {
    arguments.callee;
    return throwTypeError;
  } catch (calleeThrows) {
    try {
      return $gOPD$1(arguments, "callee").get;
    } catch (gOPDthrows) {
      return throwTypeError;
    }
  }
}() : throwTypeError;
var hasSymbols2 = hasSymbols$1();
var hasProto2 = hasProto$1();
var getProto = Object.getPrototypeOf || (hasProto2 ? function(x22) {
  return x22.__proto__;
} : null);
var needsEval = {};
var TypedArray = typeof Uint8Array === "undefined" || !getProto ? undefined$1 : getProto(Uint8Array);
var INTRINSICS = {
  __proto__: null,
  "%AggregateError%": typeof AggregateError === "undefined" ? undefined$1 : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined$1 : ArrayBuffer,
  "%ArrayIteratorPrototype%": hasSymbols2 && getProto ? getProto([][Symbol.iterator]()) : undefined$1,
  "%AsyncFromSyncIteratorPrototype%": undefined$1,
  "%AsyncFunction%": needsEval,
  "%AsyncGenerator%": needsEval,
  "%AsyncGeneratorFunction%": needsEval,
  "%AsyncIteratorPrototype%": needsEval,
  "%Atomics%": typeof Atomics === "undefined" ? undefined$1 : Atomics,
  "%BigInt%": typeof BigInt === "undefined" ? undefined$1 : BigInt,
  "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined$1 : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined$1 : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView === "undefined" ? undefined$1 : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": $Error,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": $EvalError,
  "%Float32Array%": typeof Float32Array === "undefined" ? undefined$1 : Float32Array,
  "%Float64Array%": typeof Float64Array === "undefined" ? undefined$1 : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined$1 : FinalizationRegistry,
  "%Function%": $Function,
  "%GeneratorFunction%": needsEval,
  "%Int8Array%": typeof Int8Array === "undefined" ? undefined$1 : Int8Array,
  "%Int16Array%": typeof Int16Array === "undefined" ? undefined$1 : Int16Array,
  "%Int32Array%": typeof Int32Array === "undefined" ? undefined$1 : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": hasSymbols2 && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
  "%JSON%": typeof JSON === "object" ? JSON : undefined$1,
  "%Map%": typeof Map === "undefined" ? undefined$1 : Map,
  "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols2 || !getProto ? undefined$1 : getProto((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise === "undefined" ? undefined$1 : Promise,
  "%Proxy%": typeof Proxy === "undefined" ? undefined$1 : Proxy,
  "%RangeError%": $RangeError,
  "%ReferenceError%": $ReferenceError,
  "%Reflect%": typeof Reflect === "undefined" ? undefined$1 : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set === "undefined" ? undefined$1 : Set,
  "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols2 || !getProto ? undefined$1 : getProto((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined$1 : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": hasSymbols2 && getProto ? getProto(""[Symbol.iterator]()) : undefined$1,
  "%Symbol%": hasSymbols2 ? Symbol : undefined$1,
  "%SyntaxError%": $SyntaxError$1,
  "%ThrowTypeError%": ThrowTypeError,
  "%TypedArray%": TypedArray,
  "%TypeError%": $TypeError$3,
  "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined$1 : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined$1 : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined$1 : Uint16Array,
  "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined$1 : Uint32Array,
  "%URIError%": $URIError,
  "%WeakMap%": typeof WeakMap === "undefined" ? undefined$1 : WeakMap,
  "%WeakRef%": typeof WeakRef === "undefined" ? undefined$1 : WeakRef,
  "%WeakSet%": typeof WeakSet === "undefined" ? undefined$1 : WeakSet
};
if (getProto) {
  try {
    null.error;
  } catch (e22) {
    var errorProto = getProto(getProto(e22));
    INTRINSICS["%Error.prototype%"] = errorProto;
  }
}
var doEval = function doEval2(name2) {
  var value2;
  if (name2 === "%AsyncFunction%") {
    value2 = getEvalledConstructor("async function () {}");
  } else if (name2 === "%GeneratorFunction%") {
    value2 = getEvalledConstructor("function* () {}");
  } else if (name2 === "%AsyncGeneratorFunction%") {
    value2 = getEvalledConstructor("async function* () {}");
  } else if (name2 === "%AsyncGenerator%") {
    var fn = doEval2("%AsyncGeneratorFunction%");
    if (fn) {
      value2 = fn.prototype;
    }
  } else if (name2 === "%AsyncIteratorPrototype%") {
    var gen = doEval2("%AsyncGenerator%");
    if (gen && getProto) {
      value2 = getProto(gen.prototype);
    }
  }
  INTRINSICS[name2] = value2;
  return value2;
};
var LEGACY_ALIASES = {
  __proto__: null,
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
};
var bind2 = functionBind;
var hasOwn$1 = hasown;
var $concat$1 = bind2.call(Function.call, Array.prototype.concat);
var $spliceApply = bind2.call(Function.apply, Array.prototype.splice);
var $replace$1 = bind2.call(Function.call, String.prototype.replace);
var $strSlice = bind2.call(Function.call, String.prototype.slice);
var $exec = bind2.call(Function.call, RegExp.prototype.exec);
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath = function stringToPath2(string) {
  var first = $strSlice(string, 0, 1);
  var last2 = $strSlice(string, -1);
  if (first === "%" && last2 !== "%") {
    throw new $SyntaxError$1("invalid intrinsic syntax, expected closing `%`");
  } else if (last2 === "%" && first !== "%") {
    throw new $SyntaxError$1("invalid intrinsic syntax, expected opening `%`");
  }
  var result = [];
  $replace$1(string, rePropName, function(match2, number, quote2, subString) {
    result[result.length] = quote2 ? $replace$1(subString, reEscapeChar, "$1") : number || match2;
  });
  return result;
};
var getBaseIntrinsic = function getBaseIntrinsic2(name2, allowMissing) {
  var intrinsicName = name2;
  var alias;
  if (hasOwn$1(LEGACY_ALIASES, intrinsicName)) {
    alias = LEGACY_ALIASES[intrinsicName];
    intrinsicName = "%" + alias[0] + "%";
  }
  if (hasOwn$1(INTRINSICS, intrinsicName)) {
    var value2 = INTRINSICS[intrinsicName];
    if (value2 === needsEval) {
      value2 = doEval(intrinsicName);
    }
    if (typeof value2 === "undefined" && !allowMissing) {
      throw new $TypeError$3("intrinsic " + name2 + " exists, but is not available. Please file an issue!");
    }
    return {
      alias,
      name: intrinsicName,
      value: value2
    };
  }
  throw new $SyntaxError$1("intrinsic " + name2 + " does not exist!");
};
var getIntrinsic = function GetIntrinsic(name2, allowMissing) {
  if (typeof name2 !== "string" || name2.length === 0) {
    throw new $TypeError$3("intrinsic name must be a non-empty string");
  }
  if (arguments.length > 1 && typeof allowMissing !== "boolean") {
    throw new $TypeError$3('"allowMissing" argument must be a boolean');
  }
  if ($exec(/^%?[^%]*%?$/, name2) === null) {
    throw new $SyntaxError$1("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  }
  var parts = stringToPath(name2);
  var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
  var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
  var intrinsicRealName = intrinsic.name;
  var value2 = intrinsic.value;
  var skipFurtherCaching = false;
  var alias = intrinsic.alias;
  if (alias) {
    intrinsicBaseName = alias[0];
    $spliceApply(parts, $concat$1([0, 1], alias));
  }
  for (var i22 = 1, isOwn = true; i22 < parts.length; i22 += 1) {
    var part = parts[i22];
    var first = $strSlice(part, 0, 1);
    var last2 = $strSlice(part, -1);
    if ((first === '"' || first === "'" || first === "`" || (last2 === '"' || last2 === "'" || last2 === "`")) && first !== last2) {
      throw new $SyntaxError$1("property names with quotes must have matching quotes");
    }
    if (part === "constructor" || !isOwn) {
      skipFurtherCaching = true;
    }
    intrinsicBaseName += "." + part;
    intrinsicRealName = "%" + intrinsicBaseName + "%";
    if (hasOwn$1(INTRINSICS, intrinsicRealName)) {
      value2 = INTRINSICS[intrinsicRealName];
    } else if (value2 != null) {
      if (!(part in value2)) {
        if (!allowMissing) {
          throw new $TypeError$3("base intrinsic for " + name2 + " exists, but the property is not available.");
        }
        return void 0;
      }
      if ($gOPD$1 && i22 + 1 >= parts.length) {
        var desc = $gOPD$1(value2, part);
        isOwn = !!desc;
        if (isOwn && "get" in desc && !("originalValue" in desc.get)) {
          value2 = desc.get;
        } else {
          value2 = value2[part];
        }
      } else {
        isOwn = hasOwn$1(value2, part);
        value2 = value2[part];
      }
      if (isOwn && !skipFurtherCaching) {
        INTRINSICS[intrinsicRealName] = value2;
      }
    }
  }
  return value2;
};
var callBind$1 = { exports: {} };
var esDefineProperty;
var hasRequiredEsDefineProperty;
function requireEsDefineProperty() {
  if (hasRequiredEsDefineProperty) return esDefineProperty;
  hasRequiredEsDefineProperty = 1;
  var GetIntrinsic3 = getIntrinsic;
  var $defineProperty2 = GetIntrinsic3("%Object.defineProperty%", true) || false;
  if ($defineProperty2) {
    try {
      $defineProperty2({}, "a", { value: 1 });
    } catch (e22) {
      $defineProperty2 = false;
    }
  }
  esDefineProperty = $defineProperty2;
  return esDefineProperty;
}
var GetIntrinsic$3 = getIntrinsic;
var $gOPD = GetIntrinsic$3("%Object.getOwnPropertyDescriptor%", true);
if ($gOPD) {
  try {
    $gOPD([], "length");
  } catch (e22) {
    $gOPD = null;
  }
}
var gopd$1 = $gOPD;
var $defineProperty$1 = requireEsDefineProperty();
var $SyntaxError = syntax;
var $TypeError$2 = type;
var gopd = gopd$1;
var defineDataProperty = function defineDataProperty2(obj, property, value2) {
  if (!obj || typeof obj !== "object" && typeof obj !== "function") {
    throw new $TypeError$2("`obj` must be an object or a function`");
  }
  if (typeof property !== "string" && typeof property !== "symbol") {
    throw new $TypeError$2("`property` must be a string or a symbol`");
  }
  if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) {
    throw new $TypeError$2("`nonEnumerable`, if provided, must be a boolean or null");
  }
  if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) {
    throw new $TypeError$2("`nonWritable`, if provided, must be a boolean or null");
  }
  if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) {
    throw new $TypeError$2("`nonConfigurable`, if provided, must be a boolean or null");
  }
  if (arguments.length > 6 && typeof arguments[6] !== "boolean") {
    throw new $TypeError$2("`loose`, if provided, must be a boolean");
  }
  var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
  var nonWritable = arguments.length > 4 ? arguments[4] : null;
  var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
  var loose = arguments.length > 6 ? arguments[6] : false;
  var desc = !!gopd && gopd(obj, property);
  if ($defineProperty$1) {
    $defineProperty$1(obj, property, {
      configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
      enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
      value: value2,
      writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
  } else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) {
    obj[property] = value2;
  } else {
    throw new $SyntaxError("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
  }
};
var $defineProperty = requireEsDefineProperty();
var hasPropertyDescriptors = function hasPropertyDescriptors2() {
  return !!$defineProperty;
};
hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
  if (!$defineProperty) {
    return null;
  }
  try {
    return $defineProperty([], "length", { value: 1 }).length !== 1;
  } catch (e22) {
    return true;
  }
};
var hasPropertyDescriptors_1 = hasPropertyDescriptors;
var GetIntrinsic$2 = getIntrinsic;
var define = defineDataProperty;
var hasDescriptors = hasPropertyDescriptors_1();
var gOPD = gopd$1;
var $TypeError$1 = type;
var $floor$1 = GetIntrinsic$2("%Math.floor%");
var setFunctionLength = function setFunctionLength2(fn, length) {
  if (typeof fn !== "function") {
    throw new $TypeError$1("`fn` is not a function");
  }
  if (typeof length !== "number" || length < 0 || length > 4294967295 || $floor$1(length) !== length) {
    throw new $TypeError$1("`length` must be a positive 32-bit integer");
  }
  var loose = arguments.length > 2 && !!arguments[2];
  var functionLengthIsConfigurable = true;
  var functionLengthIsWritable = true;
  if ("length" in fn && gOPD) {
    var desc = gOPD(fn, "length");
    if (desc && !desc.configurable) {
      functionLengthIsConfigurable = false;
    }
    if (desc && !desc.writable) {
      functionLengthIsWritable = false;
    }
  }
  if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
    if (hasDescriptors) {
      define(
        /** @type {Parameters<define>[0]} */
        fn,
        "length",
        length,
        true,
        true
      );
    } else {
      define(
        /** @type {Parameters<define>[0]} */
        fn,
        "length",
        length
      );
    }
  }
  return fn;
};
(function(module) {
  var bind3 = functionBind;
  var GetIntrinsic3 = getIntrinsic;
  var setFunctionLength$1 = setFunctionLength;
  var $TypeError2 = type;
  var $apply = GetIntrinsic3("%Function.prototype.apply%");
  var $call = GetIntrinsic3("%Function.prototype.call%");
  var $reflectApply = GetIntrinsic3("%Reflect.apply%", true) || bind3.call($call, $apply);
  var $defineProperty2 = requireEsDefineProperty();
  var $max = GetIntrinsic3("%Math.max%");
  module.exports = function callBind2(originalFunction) {
    if (typeof originalFunction !== "function") {
      throw new $TypeError2("a function is required");
    }
    var func = $reflectApply(bind3, $call, arguments);
    return setFunctionLength$1(
      func,
      1 + $max(0, originalFunction.length - (arguments.length - 1)),
      true
    );
  };
  var applyBind = function applyBind2() {
    return $reflectApply(bind3, $apply, arguments);
  };
  if ($defineProperty2) {
    $defineProperty2(module.exports, "apply", { value: applyBind });
  } else {
    module.exports.apply = applyBind;
  }
})(callBind$1);
var callBindExports = callBind$1.exports;
var GetIntrinsic$1 = getIntrinsic;
var callBind = callBindExports;
var $indexOf = callBind(GetIntrinsic$1("String.prototype.indexOf"));
var callBound$1 = function callBoundIntrinsic(name2, allowMissing) {
  var intrinsic = GetIntrinsic$1(name2, !!allowMissing);
  if (typeof intrinsic === "function" && $indexOf(name2, ".prototype.") > -1) {
    return callBind(intrinsic);
  }
  return intrinsic;
};
const __viteBrowserExternal = {};
const __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" }));
const require$$0 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
var hasMap = typeof Map === "function" && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === "function" ? mapSizeDescriptor.get : null;
var hasSet = typeof Set === "function" && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === "function" ? setSizeDescriptor.get : null;
var symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
var utilInspect = require$$0;
var inspectCustom = utilInspect.custom;
isSymbol$1(inspectCustom) ? inspectCustom : null;
function isSymbol$1(obj) {
  if (hasShammedSymbols) {
    return obj && typeof obj === "object" && obj instanceof Symbol;
  }
  if (typeof obj === "symbol") {
    return true;
  }
  if (!obj || typeof obj !== "object" || !symToString) {
    return false;
  }
  try {
    symToString.call(obj);
    return true;
  } catch (e22) {
  }
  return false;
}
var GetIntrinsic2 = getIntrinsic;
var callBound = callBound$1;
GetIntrinsic2("%WeakMap%", true);
GetIntrinsic2("%Map%", true);
callBound("WeakMap.prototype.get", true);
callBound("WeakMap.prototype.set", true);
callBound("WeakMap.prototype.has", true);
callBound("Map.prototype.get", true);
callBound("Map.prototype.set", true);
callBound("Map.prototype.has", true);
var replace = String.prototype.replace;
var percentTwenties = /%20/g;
var Format = {
  RFC3986: "RFC3986"
};
var formats$3 = {
  "default": Format.RFC3986,
  formatters: {
    RFC1738: function(value2) {
      return replace.call(value2, percentTwenties, "+");
    },
    RFC3986: function(value2) {
      return String(value2);
    }
  }
};
(function() {
  var array = [];
  for (var i22 = 0; i22 < 256; ++i22) {
    array.push("%" + ((i22 < 16 ? "0" : "") + i22.toString(16)).toUpperCase());
  }
  return array;
})();
var formats$1 = formats$3;
var defaultFormat = formats$1["default"];
({
  formatter: formats$1.formatters[defaultFormat]
});
const _sfc_main$1B = defineComponent({
  name: "InfoDialog",
  components: {
    Button,
    Dialog,
    QIcon: QIcon_default$1
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: "infoDialog"
    },
    /**
     * Text displayed on the confirmation button
     */
    actionLabel: {
      type: String,
      default: () => useI18n().t("rvai-base.general.actions.ok")
    },
    /**
     * Flag to hide close button
     */
    hasCloseButton: {
      type: Boolean,
      default: true
    },
    /**
     * Main text
     */
    message: {
      type: String,
      required: true
    },
    /**
    * Text displayed in title
    */
    title: {
      type: String,
      default: void 0
    }
  },
  setup(props4) {
    const {
      dialogRef,
      onOK
    } = useSidebar();
    function confirm() {
      onOK(true);
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      confirm,
      dialogRef
    };
  }
});
const _hoisted_1$1p = ["data-automation"];
const _hoisted_2$18 = ["innerHTML"];
function _sfc_render$1u(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QIcon = resolveComponent("QIcon");
  const _component_Button = resolveComponent("Button");
  const _component_Dialog = resolveComponent("Dialog");
  return openBlock(), createBlock(_component_Dialog, mergeProps({
    ref: "dialogRef",
    "data-automation": _ctx.buildId(),
    "hide-close-button": !_ctx.hasCloseButton
  }, toHandlers(_ctx.$attrs)), createSlots({
    default: withCtx(() => [
      createElementVNode("div", {
        class: normalizeClass(["row no-wrap items-start q-pb-none", _ctx.title ? "justify-start" : "justify-center"])
      }, [
        !_ctx.title ? (openBlock(), createBlock(_component_QIcon, {
          key: 0,
          color: "grey-2",
          "data-automation": _ctx.buildId("icon-error"),
          name: "error",
          size: "32px"
        }, null, 8, ["data-automation"])) : createCommentVNode("", true),
        createElementVNode("div", {
          class: "rv-info-dialog__context flex items-center q-ml-sm",
          innerHTML: _ctx.$sanitize(_ctx.message)
        }, null, 8, _hoisted_2$18)
      ], 2)
    ]),
    actions: withCtx(() => [
      createVNode(_component_Button, {
        color: "primary",
        "data-automation": _ctx.buildId("confirm"),
        label: _ctx.actionLabel,
        size: "sm",
        onClick: _cache[0] || (_cache[0] = ($event) => _ctx.confirm())
      }, null, 8, ["data-automation", "label"])
    ]),
    _: 2
  }, [
    _ctx.title ? {
      name: "title",
      fn: withCtx(() => [
        createVNode(_component_QIcon, {
          color: "grey-2",
          "data-automation": _ctx.buildId("icon-error"),
          name: "error",
          size: "33px"
        }, null, 8, ["data-automation"]),
        createElementVNode("span", {
          class: "rv-info-dialog__title text-subtitle1 text-center q-ml-sm",
          "data-automation": _ctx.buildId("title")
        }, toDisplayString(_ctx.title), 9, _hoisted_1$1p)
      ]),
      key: "0"
    } : void 0
  ]), 1040, ["data-automation", "hide-close-button"]);
}
const InfoDialog = /* @__PURE__ */ _export_sfc$1(_sfc_main$1B, [["render", _sfc_render$1u], ["__scopeId", "data-v-b5b3a68d"]]);
const LayoutStore = "LayoutStore dependency";
function useLayout() {
  return inject(LayoutStore);
}
function useLogo() {
  const { navigation } = useOptions();
  const logoMain = computed(() => {
    var _a;
    return ((_a = navigation.logoOptions) == null ? void 0 : _a.main) ?? "/rvai-base/logos.svg#main";
  });
  const logoRegular = computed(() => {
    var _a;
    return ((_a = navigation.logoOptions) == null ? void 0 : _a.regular) ?? "/rvai-base/logos.svg#regular";
  });
  const customLogoSrc = computed(() => {
    var _a;
    return (_a = navigation.logoOptions) == null ? void 0 : _a.customLogoSrc;
  });
  const logoAlignClasses = computed(() => {
    var _a;
    const align = ((_a = navigation.logoOptions) == null ? void 0 : _a.align) ?? "center";
    return `flex justify-${align}`;
  });
  return {
    customLogoSrc,
    logoAlignClasses,
    logoMain,
    logoRegular
  };
}
const initialState = () => ({
  backClicked: false,
  previousRoutes: []
});
const state = reactive(initialState());
function useNavigationHistory(defaultRoute, directRoute) {
  const { t: t22 } = useI18n();
  const {
    navigation: {
      backButtonLabels = {},
      homeRoute
    }
  } = useOptions();
  const router = useRouter();
  const labels = {
    ...backButtonLabels,
    ..."default" in backButtonLabels ? {} : {
      get default() {
        return t22("rvai-base.general.backBtn.default");
      }
    }
  };
  const fallbackRoute = defaultRoute ?? homeRoute ?? "/";
  const previousRoute = computed(() => {
    const lastFrom = state.previousRoutes[state.previousRoutes.length - 1];
    return lastFrom ?? fallbackRoute;
  });
  function getLabel(route) {
    const defaultKey = "default";
    const key = typeof route === "string" ? route : "name" in route ? route.name : void 0;
    return labels[key ?? defaultKey] ?? labels[defaultKey];
  }
  function getPreviousPageLabel() {
    if (directRoute) return getLabel(directRoute);
    const lastFrom = state.previousRoutes[state.previousRoutes.length - 1];
    if (!(lastFrom == null ? void 0 : lastFrom.name)) {
      return getLabel(fallbackRoute);
    } else {
      return getLabel(lastFrom);
    }
  }
  function goToRoute(route) {
    void router.push(typeof route === "string" ? { name: route } : route);
  }
  function goToPreviousPage() {
    state.backClicked = true;
    if (directRoute) {
      goToRoute(directRoute);
      return;
    }
    const lastFrom = state.previousRoutes.pop();
    if (!lastFrom) {
      goToRoute(fallbackRoute);
    } else {
      goToRoute(lastFrom);
    }
  }
  return {
    getPreviousPageLabel,
    goToPreviousPage,
    previousRoute
  };
}
const Pagination$1 = "Pagination dependency";
function usePagination() {
  const paginationComposable = inject(Pagination$1);
  if (!paginationComposable) {
    throw new Error('The pagination was not registered. Make sure you used "providePagination".');
  }
  return paginationComposable;
}
const { getPaletteColor } = colors_default;
const colorCache = /* @__PURE__ */ new Map();
function usePaletteColorsCache() {
  const { isDark } = useDarkMode();
  function getPaletteColorCache(color2) {
    let cachedColor = colorCache.get(color2);
    if (!cachedColor) {
      cachedColor = getPaletteColor(color2);
      colorCache.set(color2, cachedColor);
    }
    return cachedColor;
  }
  watch(isDark, () => {
    colorCache.clear();
  });
  return {
    getPaletteColorCache
  };
}
const PANEL_DEFAULT_SIZE = 324;
const PANEL_MAX_SIZE = 768;
const SPLIT_VIEW_MIN_SCREEN_WIDTH = 1439;
function useRightPanelSize(params) {
  const {
    minScreenWidth = SPLIT_VIEW_MIN_SCREEN_WIDTH,
    panelDefaulSize = PANEL_DEFAULT_SIZE,
    panelGap = 0,
    panelMaxSize = PANEL_MAX_SIZE
  } = {};
  const {
    isSplitLayout,
    layout
  } = useLayout();
  const rightPanelWidth = ref$1(panelDefaulSize);
  function setRightPanelWidth(screenWidth) {
    const panelWidth = isSplitLayout.value && screenWidth > minScreenWidth ? Math.round(Math.min(screenWidth * 0.4 + panelGap, panelMaxSize + panelGap)) : panelDefaulSize;
    rightPanelWidth.value = panelWidth;
  }
  watch(layout, () => {
    setRightPanelWidth(window.innerWidth);
  });
  return {
    rightPanelWidth,
    setRightPanelWidth
  };
}
const UseStepSidebarSymbol = "UseStepSidebar";
function useStepSidebar() {
  const composable = inject(UseStepSidebarSymbol);
  if (!composable) {
    throw new Error("Could not inject `UseStepSidebarComposable`. Did you forget `provideStepSidebar`?");
  }
  return composable;
}
const Table$1 = "Table dependency";
function useTable() {
  const tableComposable = inject(Table$1);
  if (!tableComposable) {
    throw new Error('The table was not registered. Make sure you used "provideTable".');
  }
  return tableComposable;
}
function useValidation(props4) {
  const {
    class: classRef,
    validation
  } = toRefs(props4);
  const error = computed(() => {
    var _a, _b;
    return !((_a = validation.value) == null ? void 0 : _a.$pending) && ((_b = validation.value) == null ? void 0 : _b.$error);
  });
  const errorMessage = computed(() => {
    var _a;
    if (!validation.value) return void 0;
    if (!validation.value.$error) return void 0;
    return (_a = validation.value.$errors[0]) == null ? void 0 : _a.$message;
  });
  const isValidated = computed(() => {
    if (!validation.value) return false;
    return validation.value.$dirty && !validation.value.$invalid;
  });
  function onBlur2() {
    var _a;
    (_a = validation.value) == null ? void 0 : _a.$touch();
  }
  return {
    classRef,
    error,
    errorMessage,
    isValidated,
    onBlur: onBlur2
  };
}
const _sfc_main$1A = defineComponent({
  name: "FieldsVisibilityDialogSection",
  components: { Checkbox },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Section item element that can be set hidden/visible
     */
    sectionItem: {
      required: true,
      type: Object
    }
  },
  setup(props4) {
    function isSectionVisible(item) {
      if (!item.fields.length) {
        return !!item.visible;
      }
      if (item.fields.every((v) => v.visible)) {
        return true;
      } else if (item.fields.every((v) => !v.visible)) {
        return false;
      } else {
        return null;
      }
    }
    function onToggleSection(field) {
      field.visible = !field.visible;
    }
    return {
      ...useAutomation(props4.dataAutomation),
      isSectionVisible,
      onToggleSection
    };
  }
});
const _hoisted_1$1o = ["data-automation"];
const _hoisted_2$17 = { class: "text-body3" };
const _hoisted_3$V = { class: "text-body3" };
function _sfc_render$1t(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Checkbox = resolveComponent("Checkbox");
  const _component_FieldsVisibilityDialogSection = resolveComponent("FieldsVisibilityDialogSection", true);
  return openBlock(), createElementBlock(Fragment, null, [
    createElementVNode("div", {
      class: "visibility-section text-black-1 q-pb-sm",
      "data-automation": _ctx.buildId()
    }, [
      createVNode(_component_Checkbox, {
        dense: "",
        disable: !_ctx.sectionItem.hideable,
        "model-value": _ctx.isSectionVisible(_ctx.sectionItem),
        size: "md",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.onToggleSection(_ctx.sectionItem))
      }, {
        default: withCtx(() => [
          createElementVNode("div", _hoisted_2$17, toDisplayString(_ctx.sectionItem.label), 1)
        ]),
        _: 1
      }, 8, ["disable", "model-value"])
    ], 8, _hoisted_1$1o),
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.sectionItem.fields, (field) => {
      return openBlock(), createElementBlock("div", {
        key: field.label,
        class: "visibility-section__fields q-mb-sm"
      }, [
        field.fields.length ? (openBlock(), createBlock(_component_FieldsVisibilityDialogSection, {
          key: 0,
          "section-item": field
        }, null, 8, ["section-item"])) : (openBlock(), createBlock(_component_Checkbox, {
          key: 1,
          modelValue: field.visible,
          "onUpdate:modelValue": ($event) => field.visible = $event,
          dense: "",
          disable: !field.hideable,
          size: "md"
        }, {
          default: withCtx(() => [
            createElementVNode("div", _hoisted_3$V, toDisplayString(field.label), 1)
          ]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue", "disable"]))
      ]);
    }), 128))
  ], 64);
}
const FieldsVisibilityDialogSection = /* @__PURE__ */ _export_sfc$1(_sfc_main$1A, [["render", _sfc_render$1t], ["__scopeId", "data-v-0476d004"]]);
const _sfc_main$1z = defineComponent({
  name: "FieldsVisibilityDialog",
  components: {
    Button,
    Checkbox,
    Dialog,
    FieldsVisibilityDialogSection
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Section item element that can be set hidden/visible
     */
    fields: {
      required: true,
      type: Object
    }
  },
  setup(props4) {
    const { t: t22 } = useI18n();
    const {
      dialogRef,
      onCancel,
      onOK
    } = useSidebar();
    const data = ref$1(
      Object.entries(props4.fields).reduce((acc, [key, v]) => ({
        ...acc,
        [key]: v.clone()
      }), {})
    );
    const allSelected = computed(() => {
      const values = Object.values(data.value);
      if (values.every((v) => v.fields.length ? v.fields.every((v2) => v2.visible) : v.visible)) {
        return true;
      } else if (values.every((v) => v.fields.length ? v.fields.every((v2) => !v2.visible) : !v.visible)) {
        return false;
      } else {
        return null;
      }
    });
    function onToggleAll(visible) {
      data.value = Object.entries(data.value).reduce((acc, [key, v]) => {
        v.visible = visible;
        return {
          ...acc,
          [key]: v
        };
      }, {});
    }
    return {
      ...useAutomation(props4.dataAutomation),
      allSelected,
      data,
      dialogRef,
      onCancel,
      onOK,
      onToggleAll,
      t: t22
    };
  }
});
const _hoisted_1$1n = { class: "text-subtitle1 q-ml-sm text-black-1" };
const _hoisted_2$16 = { class: "row q-pb-sm" };
const _hoisted_3$U = { class: "text-body3" };
function _sfc_render$1s(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Checkbox = resolveComponent("Checkbox");
  const _component_FieldsVisibilityDialogSection = resolveComponent("FieldsVisibilityDialogSection");
  const _component_Button = resolveComponent("Button");
  const _component_Dialog = resolveComponent("Dialog");
  return openBlock(), createBlock(_component_Dialog, mergeProps({
    ref: "dialogRef",
    "data-automation": _ctx.buildId()
  }, toHandlers(_ctx.$attrs)), {
    title: withCtx(() => [
      createElementVNode("span", _hoisted_1$1n, toDisplayString(_ctx.t("rvai-base.general.text.showRows")), 1)
    ]),
    default: withCtx(() => [
      createElementVNode("div", _hoisted_2$16, [
        createVNode(_component_Checkbox, {
          dense: "",
          "model-value": _ctx.allSelected,
          size: "md",
          "onUpdate:modelValue": _ctx.onToggleAll
        }, {
          default: withCtx(() => [
            createElementVNode("div", _hoisted_3$U, toDisplayString(_ctx.t("rvai-base.general.text.allRows")), 1)
          ]),
          _: 1
        }, 8, ["model-value", "onUpdate:modelValue"])
      ]),
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.data, (item) => {
        return openBlock(), createElementBlock("div", {
          key: item.label,
          class: "col q-pb-sm"
        }, [
          createVNode(_component_FieldsVisibilityDialogSection, { "section-item": item }, null, 8, ["section-item"])
        ]);
      }), 128))
    ]),
    actions: withCtx(() => [
      createVNode(_component_Button, {
        label: _ctx.t("rvai-base.general.actions.cancel"),
        secondary: "",
        size: "sm",
        onClick: _ctx.onCancel
      }, null, 8, ["label", "onClick"]),
      createVNode(_component_Button, {
        color: "primary",
        label: _ctx.t("rvai-base.general.actions.save"),
        size: "sm",
        onClick: _cache[0] || (_cache[0] = ($event) => _ctx.onOK(_ctx.data))
      }, null, 8, ["label"])
    ]),
    _: 1
  }, 16, ["data-automation"]);
}
const FieldsVisibilityDialog = /* @__PURE__ */ _export_sfc$1(_sfc_main$1z, [["render", _sfc_render$1s], ["__scopeId", "data-v-3778f85d"]]);
const iconStyles = {
  md: {
    iconSize: "1.5rem",
    size: "32px"
  },
  sm: {
    iconSize: "1rem",
    size: "24px"
  }
};
const _sfc_main$1y = defineComponent({
  name: "ActionButton",
  components: {
    QBtn: QBtn_default$1,
    QIcon: QIcon_default$1,
    Tooltip: Tooltip2
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Applies to the shortcut 'position: absolute'
     */
    absoluteShortcut: {
      type: Boolean,
      default: false
    },
    /**
     * Classes applied to the Histogram
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Styles applied to component
     * @type {[Array, Object, String]}
     */
    style: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Icon name following Quasar convention; Make sure you have the icon library installed unless you are using 'img:' prefix
     */
    icon: {
      type: String,
      default: void 0
    },
    /**
     * Icon size in CSS units, including unit name or standard size name (xs|sm|md|lg|xl)
     */
    iconSize: {
      type: String,
      default: void 0
    },
    /**
     * Shows indicator circle in top right corner of the icon
     */
    indicator: {
      type: Boolean,
      default: false
    },
    /**
     * Adds an optional text to the indicator in the top right
     */
    indicatorLabel: {
      type: String,
      default: void 0
    },
    /**
     * Put component in selected mode
     */
    selected: {
      type: Boolean,
      default: false
    },
    /**
     * The text below the button
     */
    shortcut: {
      type: String,
      default: void 0
    },
    /**
     * Condition that meets whether the shortcut will be shown
     */
    showShortcuts: {
      type: Boolean,
      default: false
    },
    /**
     * Size in standard size name (sm|md)
     */
    size: {
      type: String,
      default: "md"
    },
    /**
     * The text that will be shown on the button tooltip; Can be used as a "tooltip" property or as a slot
     */
    tooltip: {
      type: String,
      default: void 0
    }
  },
  emits: [
    /**
     * Emitted when component is clicked (activated)
     *
     * @type {object}
     */
    "click"
  ],
  setup(props4, { emit }) {
    const { isDark } = useDarkMode();
    const onClick = throttle$1(
      (event) => emit("click", event),
      200,
      { trailing: false }
    );
    const iconStyle = computed(() => {
      const style = iconStyles[props4.size];
      if (props4.iconSize) {
        style.iconSize = props4.iconSize;
      }
      return style;
    });
    const textColor = computed(() => {
      if (props4.disable) return "grey-2";
      if (props4.selected) return isDark.value ? "white--dark" : "primary";
      return "black-1";
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      iconStyle,
      isDark,
      onClick,
      textColor
    };
  }
});
const _hoisted_1$1m = ["data-automation"];
const _hoisted_2$15 = ["data-automation"];
const _hoisted_3$T = ["data-automation"];
function _sfc_render$1r(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QIcon = resolveComponent("QIcon");
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_QBtn = resolveComponent("QBtn");
  return openBlock(), createElementBlock("div", mergeProps(_ctx.dataAttrs, {
    class: "action relative-position flex column items-center",
    "data-automation": _ctx.buildId(),
    style: { "--size": _ctx.iconStyle.size }
  }), [
    createVNode(_component_QBtn, {
      class: normalizeClass(_ctx.$props.class),
      color: _ctx.isDark ? "primary-05op" : "grey-6",
      "data-automation": _ctx.buildId("button"),
      disable: _ctx.disable,
      flat: !_ctx.selected,
      style: normalizeStyle(_ctx.style),
      "text-color": _ctx.textColor,
      unelevated: "",
      onClick: _ctx.onClick
    }, {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "default", {}, void 0, true),
        _ctx.icon ? (openBlock(), createBlock(_component_QIcon, {
          key: 0,
          name: _ctx.icon,
          size: _ctx.iconStyle.iconSize
        }, null, 8, ["name", "size"])) : createCommentVNode("", true),
        _ctx.indicator ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass(["indicator", { "label row justify-center items-center": !!_ctx.indicatorLabel }])
        }, [
          _ctx.indicatorLabel ? (openBlock(), createElementBlock("span", {
            key: 0,
            "data-automation": _ctx.buildId("indicator-label")
          }, toDisplayString(_ctx.indicatorLabel), 9, _hoisted_2$15)) : createCommentVNode("", true)
        ], 2)) : createCommentVNode("", true),
        _ctx.tooltip || _ctx.$slots.tooltip ? (openBlock(), createBlock(_component_Tooltip, {
          key: 2,
          "data-automation": _ctx.buildId("tooltip"),
          offset: [14, 4]
        }, {
          default: withCtx(() => [
            _ctx.tooltip ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
              createTextVNode(toDisplayString(_ctx.tooltip), 1)
            ], 64)) : renderSlot(_ctx.$slots, "tooltip", { key: 1 }, void 0, true)
          ]),
          _: 3
        }, 8, ["data-automation"])) : createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["class", "color", "data-automation", "disable", "flat", "style", "text-color", "onClick"]),
    _ctx.showShortcuts && (_ctx.shortcut || _ctx.$slots.shortcut) ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass(["action__shortcut text-caption text-grey-2", { "absolute-center": _ctx.absoluteShortcut }]),
      "data-automation": _ctx.buildId("shortcut")
    }, [
      _ctx.shortcut ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        createTextVNode(toDisplayString(_ctx.shortcut), 1)
      ], 64)) : renderSlot(_ctx.$slots, "shortcut", { key: 1 }, void 0, true)
    ], 10, _hoisted_3$T)) : createCommentVNode("", true)
  ], 16, _hoisted_1$1m);
}
const ActionButton = /* @__PURE__ */ _export_sfc$1(_sfc_main$1y, [["render", _sfc_render$1r], ["__scopeId", "data-v-d992ada4"]]);
const _sfc_main$1x = defineComponent({
  name: "AutoHeight",
  components: {
    QResizeObserver: QResizeObserver_default$1
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    offset: {
      type: Number,
      default: 0
    }
  },
  setup(props4) {
    const height2 = ref$1(0);
    const heightStyle = computed(() => ({
      height: `${height2.value - props4.offset}px`
    }));
    function onResize(dimensions) {
      height2.value = dimensions.height;
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      heightStyle,
      onResize
    };
  }
});
const _hoisted_1$1l = ["data-automation"];
function _sfc_render$1q(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QResizeObserver = resolveComponent("QResizeObserver");
  return openBlock(), createElementBlock("div", {
    "data-automation": _ctx.buildId()
  }, [
    createVNode(_component_QResizeObserver, { onResize: _ctx.onResize }, null, 8, ["onResize"]),
    renderSlot(_ctx.$slots, "default", { heightStyle: _ctx.heightStyle })
  ], 8, _hoisted_1$1l);
}
const AutoHeight = /* @__PURE__ */ _export_sfc$1(_sfc_main$1x, [["render", _sfc_render$1q]]);
const REGEX$1 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;
function validate$1(uuid) {
  return typeof uuid === "string" && REGEX$1.test(uuid);
}
function parse(uuid) {
  if (!validate$1(uuid)) {
    throw TypeError("Invalid UUID");
  }
  var v;
  var arr = new Uint8Array(16);
  arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
  arr[1] = v >>> 16 & 255;
  arr[2] = v >>> 8 & 255;
  arr[3] = v & 255;
  arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
  arr[5] = v & 255;
  arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
  arr[7] = v & 255;
  arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
  arr[9] = v & 255;
  arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 1099511627776 & 255;
  arr[11] = v / 4294967296 & 255;
  arr[12] = v >>> 24 & 255;
  arr[13] = v >>> 16 & 255;
  arr[14] = v >>> 8 & 255;
  arr[15] = v & 255;
  return arr;
}
const { lighten } = colors_default;
const baseColor = getCssVar$1("primary") ?? "#F2209E";
const USER_COLORS = [
  "#242DDD",
  "#2457CD",
  "#2490DD",
  "#252CDC",
  "#253ECB",
  "#25AAC8",
  "#25C3AC",
  "#26A0BF",
  "#27B675",
  "#2BA19D",
  "#394FD0",
  "#3987D0",
  "#39A0D0",
  "#3A0CA3",
  "#3F37C9",
  "#4361EE",
  "#4895EF",
  "#4CC9F0",
  "#4F25CB",
  "#553ACF",
  "#5EB098",
  "#5F8FE4",
  "#5F9FE4",
  "#61BD7C",
  "#61BDBA",
  "#655FE4",
  "#6981C9",
  "#6997C9",
  "#6F6AC8",
  "#7209B7",
  "#7339D0",
  "#73C0E3",
  "#7499E3",
  "#75CDB6",
  "#7787E4",
  "#78A3DF",
  "#79D0D9",
  "#7AA3E5",
  "#7AD0A1",
  "#7CA6D2",
  "#7D24DD",
  "#7DBEE6",
  "#7ED1C1",
  "#80B6A0",
  "#82CC89",
  "#865EE5",
  "#86D192",
  "#98BAA5",
  "#A1D08F",
  "#AC5FE4",
  "#ADBCA7",
  "#B5179E",
  "#BD34C9",
  "#BED092",
  "#CE57BD",
  "#F2209E"
];
function getUserColor(userId) {
  const value2 = typeof userId === "number" ? userId : validate$1(userId) ? parse(userId)[0] : String(userId).charCodeAt(0);
  return USER_COLORS[value2 % (USER_COLORS.length - 1)];
}
function getColor(index2) {
  return lighten(baseColor, Math.max(-100, -15 * index2));
}
function roundNumberToPrecision(number, precision = 3) {
  return Number(parseFloat(String(number)).toPrecision(precision));
}
function roundToStep(number, step) {
  if (step === 0) {
    return number;
  }
  return roundNumberToPrecision(Math.floor(roundNumberToPrecision(number / step)) * step);
}
function truncateNumber(number, decimals) {
  const factor = Math.pow(10, decimals);
  return Math.trunc(number * factor) / factor;
}
function maxValueRaw(min2, inclusive) {
  return inclusive ? (value2) => !helpers.req(value2) || +value2 <= +unwrap(min2) : (value2) => !helpers.req(value2) || +value2 < +unwrap(min2);
}
function minValueRaw(min2, inclusive) {
  return inclusive ? (value2) => !helpers.req(value2) || +value2 >= +unwrap(min2) : (value2) => !helpers.req(value2) || +value2 > +unwrap(min2);
}
function conditional(condition, rule) {
  if (rule instanceof Function) {
    return rule;
  } else {
    return {
      ...rule,
      $validator: (value2, siblingState, vm2) => !unwrap(condition) || rule.$validator(value2, siblingState, vm2)
    };
  }
}
function maxValue(max2, inclusive) {
  return {
    $message: ({ $params }) => `The maximum value allowed is ${unwrap($params.max)}`,
    $params: { max: max2 },
    $validator: maxValueRaw(max2, inclusive)
  };
}
function minValue(min2, inclusive) {
  return {
    $message: ({ $params }) => `The minimum value allowed is ${unwrap($params.min)}`,
    $params: { min: min2 },
    $validator: minValueRaw(min2, inclusive)
  };
}
function minCharCountRaw(min2, regex) {
  return (value2) => !helpers.req(value2) || (value2.match(regex) ?? []).length >= unwrap(min2);
}
function minCharsCountRaw(min2, regexes) {
  return (value2) => !helpers.req(value2) || regexes.every((regex) => (value2.match(regex) ?? []).length >= unwrap(min2));
}
const _ValidationBuilder = class _ValidationBuilder2 {
  constructor(i18nPath, label, i18n) {
    __publicField(this, "_i18nPath");
    __publicField(this, "_label");
    __publicField(this, "_rules");
    __publicField(this, "_i18n");
    if (i18nPath) {
      this._i18nPath = i18nPath;
    }
    if (label) {
      this._label = label;
    }
    if (i18n) {
      this._i18n = i18n;
    }
    this._rules = {};
  }
  get label() {
    if (this._i18nPath) return this.t(this._i18nPath);
    if (this._label) return this._label;
    return this.t("rvai-base.general.inputs.field");
  }
  static withLabel(label, i18n) {
    return new _ValidationBuilder2(void 0, label, i18n);
  }
  static $t(i18nPath, i18n) {
    return new _ValidationBuilder2(i18nPath, void 0, i18n);
  }
  addRule(key, rule) {
    this._rules[key] = rule;
  }
  get arrayRequired() {
    this._rules.required = {
      $message: this.t("rvai-base.validation.isRequired", [this.label]),
      $validator: (value2) => Array.isArray(value2) && !!value2.length
    };
    return this;
  }
  arrayRequiredIf(condition) {
    this._rules.required = {
      $message: this.t("rvai-base.validation.isRequired", [this.label]),
      $params: { condition },
      $validator: (value2) => !unwrap(condition) || Array.isArray(value2) && !!value2.length
    };
    return this;
  }
  custom(fn, i18nMessagePath, i18nParams = [], key = "custom") {
    this.rules[key] = helpers.withMessage(
      () => this.t(i18nMessagePath, "value" in i18nParams ? i18nParams.value : i18nParams),
      fn
    );
    return this;
  }
  customAsync(fn, messageI18nOrRef, i18nParams = [], key = "customAsync") {
    this._rules[key] = helpers.withAsync({
      $message: typeof messageI18nOrRef === "string" ? this.t(messageI18nOrRef, unwrap(i18nParams)) : messageI18nOrRef,
      $validator: fn
    });
    return this;
  }
  customError(i18nMessagePath) {
    this._rules.customError = {
      $message: i18nMessagePath ? this.t(i18nMessagePath, [this.label]) : "",
      $params: { i18nMessagePath },
      $validator: (value2) => !helpers.req(value2) || !i18nMessagePath
    };
    return this;
  }
  customErrorWithMismatches(regEx, findSymbolsRegex, textPath) {
    this._rules.customErrorWithMismatches = helpers.withMessage(
      (v) => {
        const notAllowedSymbols = distinct(v.$model.split(findSymbolsRegex)).join("");
        return this.t(textPath, [this.label, notAllowedSymbols]);
      },
      {
        $validator: helpers.regex(regEx)
      }
    );
    return this;
  }
  get decimal() {
    this._rules.decimal = helpers.withMessage(
      this.t("rvai-base.validation.decimal", [this.label]),
      decimal
    );
    return this;
  }
  decimalIf(condition) {
    this._rules.decimal = {
      $message: this.t("rvai-base.validation.decimal", [this.label]),
      $params: { condition },
      $validator: (value2) => !helpers.req(value2) || !unwrap(condition) || isFiniteNumber(Number(value2))
    };
    return this;
  }
  get dnsLabel() {
    this._rules.regex = {
      $message: this.t("rvai-base.validation.dnsLabel", [this.label]),
      $validator: helpers.regex(/^[a-z]([a-z0-9-]{0,61}[a-z0-9])?$/)
    };
    return this;
  }
  get email() {
    this._rules.email = helpers.withMessage(
      this.t("rvai-base.validation.email"),
      email
    );
    return this;
  }
  equalTo(equalTo) {
    this._rules.equalTo = {
      $message: () => this.t("rvai-base.validation.equalTo", [this.label, equalTo]),
      $params: { equalTo },
      $validator: (value2) => !helpers.req(value2) || !equalTo || value2 === equalTo
    };
    return this;
  }
  if(condition) {
    return new IfValidationBuilder(
      this,
      condition,
      this._i18nPath,
      this._label,
      this._i18n
    );
  }
  get integer() {
    this._rules.integer = helpers.withMessage(
      this.t("rvai-base.validation.integer", [this.label]),
      integer
    );
    return this;
  }
  integerIf(condition) {
    this._rules.integer = {
      $message: this.t("rvai-base.validation.integer", [this.label]),
      $params: { condition },
      $validator: (value2) => !helpers.req(value2) || !unwrap(condition) || Number.isInteger(Number(value2))
    };
    return this;
  }
  maxLength(max2) {
    if (max2 == null) return this;
    this._rules.maxLength = helpers.withMessage(
      this.t("rvai-base.validation.maxLength", [this.label, max2]),
      maxLength(max2)
    );
    return this;
  }
  maxValue(max2, inclusive = true) {
    if (max2 == null) return this;
    this._rules.max = this._maxValue(max2, inclusive);
    return this;
  }
  maxValueIf(condition, max2, inclusive = true) {
    if (max2 == null) return this;
    this._rules.max = conditional(
      condition,
      this._maxValue(max2, inclusive)
    );
    return this;
  }
  minLowerCaseCount(min2, i18nPath = "rvai-base.validation.minLowerCaseCount") {
    this._rules.minLowerCaseCount = {
      $message: this.t(i18nPath, [this.label, min2], { plural: min2 }),
      $params: { min: min2 },
      $validator: minCharCountRaw(min2, /[a-z]/g)
    };
    return this;
  }
  minNumberCount(min2, i18nPath = "rvai-base.validation.minNumberCount") {
    this._rules.minNumberCount = {
      $message: this.t(i18nPath, [this.label, min2], { plural: min2 }),
      $params: { min: min2 },
      $validator: minCharCountRaw(min2, /[0-9]/g)
    };
    return this;
  }
  minSpecialCount(min2, i18nPath = "rvai-base.validation.minSpecialCount") {
    this._rules.minSpecialCount = {
      $message: this.t(i18nPath, [this.label, min2], { plural: min2 }),
      $params: { min: min2 },
      $validator: minCharCountRaw(min2, /[!"#$%'()*+,\-./:;<=>?@\\[\]^_`{|}~\s]/g)
    };
    return this;
  }
  minUpperAndLowerCaseCount(min2, i18nPath = "rvai-base.validation.minUpperAndLowerCaseCount") {
    this._rules.minUpperAndLowerCaseCount = {
      $message: this.t(i18nPath, [this.label, min2], { plural: min2 }),
      $params: { min: min2 },
      $validator: minCharsCountRaw(min2, [/[a-z]/g, /[A-Z]/g])
    };
    return this;
  }
  minUpperCaseCount(min2, i18nPath = "rvai-base.validation.minUpperCaseCount") {
    this._rules.minUpperCaseCount = {
      $message: this.t(i18nPath, [this.label, min2], { plural: min2 }),
      $params: { min: min2 },
      $validator: minCharCountRaw(min2, /[A-Z]/g)
    };
    return this;
  }
  minLength(min2, i18nPath = "rvai-base.validation.minLength") {
    if (min2 == null) return this;
    this._rules.minLength = helpers.withMessage(
      this.t(i18nPath, [this.label, min2]),
      minLength(min2)
    );
    return this;
  }
  minValue(min2, inclusive = true) {
    if (min2 == null) return this;
    this._rules.min = this._minValue(min2, inclusive);
    return this;
  }
  minValueIf(condition, min2, inclusive = true) {
    if (min2 == null) return this;
    this._rules.min = conditional(
      condition,
      this._minValue(min2, inclusive)
    );
    return this;
  }
  get numbersOnly() {
    this._rules.regex = {
      $message: this.t("rvai-base.validation.numbers", [this.label]),
      $validator: helpers.regex(/^[0-9]*$/)
    };
    return this;
  }
  get numeric() {
    this._rules.numeric = {
      $message: this.t("rvai-base.validation.numeric", [this.label]),
      $validator: helpers.regex(/^-?\d*(\.\d+)?$/)
    };
    return this;
  }
  oneOfRegexes(regExes) {
    this._rules.oneOfRegexes = {
      $message: this.t("rvai-base.validation.mustBeValid", [this.label]),
      $params: { regExes },
      $validator: (value2) => !helpers.req(value2) || !regExes.length || regExes.some((regex) => regex.test(value2))
    };
    return this;
  }
  regex(regEx, textPath = "rvai-base.validation.mustBeValid") {
    this._rules.regex = {
      $message: this.t(textPath, [this.label]),
      $validator: helpers.regex(regEx)
    };
    return this;
  }
  get required() {
    this._rules.required = {
      $message: this.t("rvai-base.validation.isRequired", [this.label]),
      $validator: (value2) => !!helpers.req(value2)
    };
    return this;
  }
  requiredIf(condition) {
    this._rules.required = {
      $message: this.t("rvai-base.validation.isRequired", [this.label]),
      $params: { condition },
      $validator: (value2) => !unwrap(condition) || !!helpers.req(value2)
    };
    return this;
  }
  requiredUnless(condition) {
    this._rules.required = helpers.withMessage(
      this.t("rvai-base.validation.isRequired", [this.label]),
      requiredUnless(() => !!unwrap(condition))
    );
    return this;
  }
  get rules() {
    return this._rules;
  }
  sameAs(i18nPath, val) {
    this._rules.sameAs = {
      $message: this.t("rvai-base.validation.sameAs", [this.label, this.t(i18nPath)]),
      $params: { val },
      $validator: (value2) => !helpers.req(value2) || value2 === val
    };
    return this;
  }
  get slug() {
    this._rules.regex = {
      $message: this.t("rvai-base.validation.slug", [this.label]),
      $validator: helpers.regex(/^[a-z0-9]+(?:[-_.][a-z0-9]+)*$/)
    };
    return this;
  }
  uniqueValue(values) {
    const isUnique = (value2) => {
      return !unwrap(values).filter(Boolean).map((s32) => typeof s32 === "string" ? s32.toLowerCase() : s32).includes(typeof value2 === "string" ? value2.toLowerCase() : value2);
    };
    this._rules.unique = {
      $message: this.t("rvai-base.validation.isUnique", [this.label]),
      $params: { values },
      $validator: (value2) => !helpers.req(value2) || isUnique(value2)
    };
    return this;
  }
  get url() {
    this._rules.url = {
      $message: this.t("rvai-base.validation.url", [this.label]),
      $validator: helpers.regex(/^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/)
    };
    return this;
  }
  get withoutSpaces() {
    this._rules.regex = {
      $message: this.t("rvai-base.validation.withoutSpaces", [this.label]),
      $validator: helpers.regex(/^[^\s]*$/)
    };
    return this;
  }
  get wordsAndNumbers() {
    this._rules.regex = {
      $message: this.t("rvai-base.validation.wordsAndNumbers", [this.label]),
      $validator: helpers.regex(/^[a-zA-Z0-9]*$/)
    };
    return this;
  }
  get wordsWithoutSpaces() {
    this._rules.regex = {
      $message: this.t("rvai-base.validation.wordsWithoutSpaces", [this.label]),
      $validator: helpers.regex(/^[a-zA-Z0-9_-]*$/)
    };
    return this;
  }
  get wordsWithSpaces() {
    this._rules.regex = {
      $message: this.t("rvai-base.validation.wordsWithSpaces", [this.label]),
      $validator: helpers.regex(/^[a-zA-Z0-9_\- ]*$/)
    };
    return this;
  }
  _maxValue(max2, inclusive) {
    const message = inclusive ? "rvai-base.validation.maxValue" : "rvai-base.validation.maxValueExclusive";
    return helpers.withMessage(
      this.t(message, [this.label, max2]),
      maxValue(max2, inclusive)
    );
  }
  _minValue(min2, inclusive) {
    const message = inclusive ? "rvai-base.validation.minValue" : "rvai-base.validation.minValueExclusive";
    return helpers.withMessage(
      this.t(message, [this.label, min2]),
      minValue(min2, inclusive)
    );
  }
  t(key, params, options) {
    return this.i18n.t(key, params, {
      ...options,
      missingWarn: false
    });
  }
  get i18n() {
    return this._i18n ?? _ValidationBuilder2.i18n;
  }
};
__publicField(_ValidationBuilder, "i18n");
let ValidationBuilder = _ValidationBuilder;
class IfValidationBuilder extends ValidationBuilder {
  constructor(builder, condition, i18nPath, label, i18n) {
    super(i18nPath, label, i18n);
    __publicField(this, "builder");
    __publicField(this, "condition");
    this.builder = builder;
    this.condition = condition;
  }
  end() {
    Object.entries(this._rules).forEach(([key, rule]) => {
      this.builder.addRule(
        `if_${key}`,
        conditional(this.condition, rule)
      );
    });
    return this.builder;
  }
}
const FONT_SIZE_MAP = {
  lg: "18px",
  md: "12px",
  sm: "10px",
  xl: "60px",
  xs: "7px"
};
const SIZE_MAP = {
  lg: "44px",
  md: "30px",
  sm: "24px",
  xl: "120px",
  xs: "18px"
};
const ICON_SIZE_MAP = {
  lg: "25px",
  md: "18px",
  sm: "14px",
  xl: "84px",
  xs: "10px"
};
const DEFAULT_PRIMARY = "#F2209E";
const SIZES = ["xs", "sm", "md", "lg", "xl"];
const DEFAULT_SIZE = "sm";
const COLOR_BLACK = getCssVar$1("black-1-fixed") ?? "#1F2641";
const COLOR_GREY = getCssVar$1("grey-2") ?? "#97A1BF";
const COLOR_WHITE = getCssVar$1("white-fixed") ?? "#FFFFFF";
const __default__$6 = defineComponent({
  name: "Avatar",
  components: {
    QAvatar: QAvatar_default,
    QIcon: QIcon_default$1,
    Tooltip: Tooltip2
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Color name for component from the Quasar Color Palette or HEX color
     */
    backgroundColor: {
      type: String,
      default: ""
    },
    /**
     * Color name for component from the Quasar Color Palette or HEX color
     */
    borderColor: {
      type: String,
      default: "white"
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Render component in hidable state based on boolean value if passed
     */
    hidden: {
      type: Boolean,
      default: void 0
    },
    /**
     * Icon name following Quasar convention; Make sure you have the icon library installed unless you are using 'img:' prefix
     */
    icon: {
      type: String,
      default: void 0
    },
    /**
     * The avatar iamge to be displayed. If missing, it display the initials.
     */
    image: {
      type: String,
      default: void 0
    },
    /**
     * The text displayed in the component
     */
    initials: {
      type: String,
      default: void 0
    },
    /**
     * The first 2 letters are displayed in the component
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Prevent display of "initials", show full "label"
     */
    noInitial: {
      type: Boolean,
      default: false
    },
    /**
     * Render a diagonal line
     */
    crossed: {
      type: Boolean,
      default: false
    },
    /**
     * Render logo
     */
    showLogo: {
      type: Boolean,
      default: false
    },
    /**
     * Render tooltip
     */
    showTooltip: {
      type: Boolean,
      default: true
    },
    /**
     * Size in standard size name (xs|sm|md|lg|xl)
     */
    size: {
      type: String,
      default: DEFAULT_SIZE,
      validator: (v) => SIZES.includes(v)
    },
    /**
     * Styles applied to component
     * @type {[Array, Object, String]}
     */
    style: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Text color name for component from the Quasar Color Palette
     */
    textColor: {
      type: String,
      default: ""
    },
    /**
     * UUID must be passed in tables for the correct display of tooltips
     */
    uuid: {
      type: [Number, String],
      default: void 0
    }
  },
  emits: [
    /**
     * Emitted when component is clicked
     *
     * @type {object}
     */
    "click"
  ],
  setup(props4, { emit }) {
    var _a;
    const { isDark } = useDarkMode();
    const { getPaletteColorCache } = usePaletteColorsCache();
    const isPrimaryOverridden = ((_a = getCssVar$1("primary")) == null ? void 0 : _a.toUpperCase()) !== DEFAULT_PRIMARY;
    const avatarSize = computed(() => {
      return SIZE_MAP[props4.size] ?? SIZE_MAP[DEFAULT_SIZE];
    });
    const fontSize = computed(() => {
      return FONT_SIZE_MAP[props4.size] ?? FONT_SIZE_MAP[DEFAULT_SIZE];
    });
    const iconSize = computed(() => {
      return ICON_SIZE_MAP[props4.size] ?? ICON_SIZE_MAP[DEFAULT_SIZE];
    });
    const hidable = computed(() => typeof props4.hidden === "boolean");
    const initialsValue = computed(() => {
      if (props4.initials) return props4.initials;
      const [label] = (props4.label ?? "").split("@");
      try {
        const initials = label.replace(/\([^)]*\)/g, "").replace(/[-_]/g, " ").replace(/\B([A-Z])/g, " $1").match(/\b\w/g) || [];
        const initialsPreview = initials.length > 1 ? (initials.shift() ?? "") + (initials.pop() ?? "") : label.substring(0, 2);
        return initialsPreview.toUpperCase();
      } catch {
        const initialsPreview = label.substring(0, 2);
        return initialsPreview.toUpperCase();
      }
    });
    const computedBorderColor = computed(() => isHexColor(props4.borderColor) ? props4.borderColor : getPaletteColorCache(props4.borderColor));
    const styles = computed(() => {
      let background;
      if (props4.disable) {
        background = COLOR_GREY;
      } else if (!isPrimaryOverridden && props4.uuid && !props4.showLogo && !props4.image) {
        background = getUserColor(props4.uuid);
      }
      const backgroundProps = props4.backgroundColor ? isHexColor(props4.backgroundColor) ? props4.backgroundColor : getPaletteColorCache(props4.backgroundColor) : void 0;
      const defaultBackgroundColor = isDark.value ? COLOR_WHITE : COLOR_BLACK;
      const defaultColor = isDark.value ? COLOR_BLACK : COLOR_WHITE;
      return {
        background: backgroundProps ?? background ?? defaultBackgroundColor,
        color: backgroundProps || background ? COLOR_WHITE : defaultColor
      };
    });
    function isHexColor(color2) {
      return /^#([0-9a-f]{3}){1,2}$/i.test(color2);
    }
    function onClick(event) {
      if (props4.disable) return;
      emit("click", event);
    }
    return {
      ...useAutomation(props4.dataAutomation),
      avatarSize,
      computedBorderColor,
      fontSize,
      hidable,
      iconSize,
      initialsValue,
      onClick,
      styles
    };
  }
});
const __injectCSSVars__$6 = () => {
  useCssVars((_ctx) => ({
    "45118491": _ctx.computedBorderColor
  }));
};
const __setup__$6 = __default__$6.setup;
__default__$6.setup = __setup__$6 ? (props4, ctx) => {
  __injectCSSVars__$6();
  return __setup__$6(props4, ctx);
} : __injectCSSVars__$6;
const _hoisted_1$1k = ["data-automation"];
const _hoisted_2$14 = ["data-automation"];
const _hoisted_3$S = ["data-automation"];
function _sfc_render$1p(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QIcon = resolveComponent("QIcon");
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_QAvatar = resolveComponent("QAvatar");
  return openBlock(), createElementBlock("div", {
    class: "rv-avatar-wrapper",
    "data-automation": _ctx.buildId("wrapper")
  }, [
    createVNode(_component_QAvatar, mergeProps({
      class: ["rv-avatar text-weight-medium", [_ctx.$props.class, { "rv-avatar--hidable": _ctx.hidable }]]
    }, _ctx.dataAttrs, {
      "data-automation": _ctx.buildId(),
      "font-size": _ctx.fontSize,
      icon: _ctx.icon,
      size: _ctx.avatarSize,
      style: [_ctx.styles, _ctx.style],
      "text-color": _ctx.textColor,
      onClick: _ctx.onClick
    }), {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "default", {}, () => [
          _ctx.hidden ? (openBlock(), createBlock(_component_QIcon, {
            key: 0,
            class: "rv-avatar__hidden",
            name: "rvai-base:eye-off",
            size: _ctx.iconSize
          }, null, 8, ["size"])) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            _ctx.hidable ? (openBlock(), createBlock(_component_QIcon, {
              key: 0,
              class: "rv-avatar__visible hidden",
              name: "rvai-base:eye",
              size: _ctx.iconSize
            }, null, 8, ["size"])) : createCommentVNode("", true),
            _ctx.image ? (openBlock(), createElementBlock("div", {
              key: 1,
              class: "rv-avatar__image",
              "data-automation": _ctx.buildId("image"),
              style: normalizeStyle({ "background-image": `url(${_ctx.image})` })
            }, null, 12, _hoisted_2$14)) : _ctx.showLogo ? (openBlock(), createBlock(_component_QIcon, {
              key: 2,
              class: "rv-avatar__content",
              "data-automation": _ctx.buildId("logo"),
              name: "rvai-base:robovision",
              size: _ctx.iconSize
            }, null, 8, ["data-automation", "size"])) : (openBlock(), createElementBlock("div", {
              key: 3,
              class: "rv-avatar__content",
              "data-automation": _ctx.buildId("label")
            }, toDisplayString(_ctx.noInitial ? _ctx.label : _ctx.initialsValue), 9, _hoisted_3$S))
          ], 64))
        ], true),
        renderSlot(_ctx.$slots, "extra", {}, void 0, true),
        createElementVNode("span", {
          class: normalizeClass({
            "rv-avatar--crossed": _ctx.crossed
          })
        }, null, 2),
        _ctx.showTooltip ? (openBlock(), createBlock(_component_Tooltip, {
          key: 0,
          anchor: "bottom middle",
          "data-automation": _ctx.buildId("tooltip"),
          self: "center middle"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.label), 1)
          ]),
          _: 1
        }, 8, ["data-automation"])) : createCommentVNode("", true)
      ]),
      _: 3
    }, 16, ["class", "data-automation", "font-size", "icon", "size", "style", "text-color", "onClick"])
  ], 8, _hoisted_1$1k);
}
const Avatar = /* @__PURE__ */ _export_sfc$1(__default__$6, [["render", _sfc_render$1p], ["__scopeId", "data-v-e5b54de5"]]);
const _sfc_main$1w = defineComponent({
  name: "BackButton",
  components: {
    Button,
    QIcon: QIcon_default$1,
    Tooltip: Tooltip2
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    collapseWithLeftSidebar: {
      type: Boolean,
      default: false
    },
    defaultRoute: {
      type: [Object, String],
      default: void 0
    },
    directRoute: {
      type: [Object, String],
      default: void 0
    }
  },
  setup(props4) {
    const { showLeftSidebar } = useLayout();
    const {
      getPreviousPageLabel,
      goToPreviousPage
    } = useNavigationHistory(props4.defaultRoute, props4.directRoute);
    const collapse = computed(() => {
      return props4.collapseWithLeftSidebar && !showLeftSidebar.value;
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      collapse,
      goToPreviousPage,
      label: getPreviousPageLabel()
    };
  }
});
const _hoisted_1$1j = ["data-automation"];
const _hoisted_2$13 = {
  key: 0,
  class: "text-no-wrap"
};
function _sfc_render$1o(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_Button = resolveComponent("Button");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["bg-white rounded-borders q-py-md", {
      "q-px-lg": !_ctx.collapse,
      "flex items-center justify-center": _ctx.collapse
    }]),
    "data-automation": _ctx.buildId("wrapper")
  }, [
    createVNode(_component_Button, {
      align: "left",
      class: "no-padding",
      "data-automation": _ctx.buildId(),
      size: "sm",
      tertiary: "",
      onClick: _ctx.goToPreviousPage
    }, {
      default: withCtx(() => [
        createVNode(_component_QIcon, {
          class: normalizeClass({ "q-mr-sm": !_ctx.collapse }),
          name: "mdi-chevron-left",
          size: "1.5rem"
        }, {
          default: withCtx(() => [
            _ctx.collapse ? (openBlock(), createBlock(_component_Tooltip, { key: 0 }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(_ctx.label), 1)
              ]),
              _: 1
            })) : createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class"]),
        !_ctx.collapse ? (openBlock(), createElementBlock("div", _hoisted_2$13, toDisplayString(_ctx.label), 1)) : createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["data-automation", "onClick"])
  ], 10, _hoisted_1$1j);
}
const BackButton = /* @__PURE__ */ _export_sfc$1(_sfc_main$1w, [["render", _sfc_render$1o]]);
const _sfc_main$1v = defineComponent({
  name: "Bullet",
  components: {
    Tooltip: Tooltip2
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Css color of the bullet border.
     */
    borderColor: {
      type: String,
      default: void 0
    },
    /**
     * Color name for component
     */
    color: {
      type: String,
      default: ""
    },
    /**
     * Render a diagonal line
     */
    crossed: {
      type: Boolean,
      default: false
    },
    /**
     * Render tooltip
     */
    isTooltipShown: {
      type: Boolean,
      default: true
    },
    /**
     * Render label before bullet
     */
    label: {
      type: [Number, String],
      default: void 0
    },
    /**
     * Classes applied to the label
     * @type {[Array, Object, String]}
     */
    labelClass: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Render a plus sign inside component and hides the label
     */
    more: {
      type: Boolean,
      default: false
    },
    /**
     * Render a plus sign inside component, shows label if any
     */
    moreWithLabel: {
      type: Boolean,
      default: false
    },
    /**
     * Disable rendering a border with a constrasting color
     */
    noContrastBorder: {
      type: Boolean,
      default: false
    },
    /**
     * Show bullet as a circle block
     */
    rounded: {
      type: Boolean,
      default: false
    },
    /**
     * Wrapper size (in px)
     */
    size: {
      type: [Number, String],
      default: 8
    },
    /**
     * Can be used as a "tooltip" property or as a slot
     */
    tooltip: {
      type: String,
      default: void 0
    },
    /**
     * Two values setting the starting position or anchor point of the Tooltip relative to its target
     */
    tooltipAnchor: {
      type: String,
      default: "bottom middle"
    },
    /**
     * The maximum width of the Tooltip; Size in CSS units, including unit name
     */
    tooltipMaxWidth: {
      type: String,
      default: "400px"
    },
    /**
     * Two values setting the Tooltip's own position relative to its target
     */
    tooltipSelf: {
      type: String,
      default: "center middle"
    }
  },
  setup(props4) {
    const { t: t22 } = useI18n();
    const { isDark } = useDarkMode();
    const containerSize = computed(() => {
      if (props4.rounded) return parseInt(props4.size.toString());
      return Math.round(parseInt(props4.size.toString()) * Math.SQRT2);
    });
    const moreBullet = computed(() => props4.more || props4.moreWithLabel);
    const contrastBorderColor = computed(() => {
      if (props4.borderColor) {
        if (props4.borderColor.startsWith("#")) return props4.borderColor;
        return getCssVar$1(props4.borderColor) ?? void 0;
      }
      if (props4.noContrastBorder) {
        return resolvedColor.value;
      }
      return getContrastColor(
        resolvedColor.value,
        isDark.value ? "transparent" : getCssVar$1("grey-1") ?? void 0,
        isDark.value ? getCssVar$1("grey-1") ?? void 0 : "transparent"
      );
    });
    const resolvedColor = computed(() => {
      if (props4.color.startsWith("#")) return props4.color;
      return getCssVar$1(props4.color) ?? getCssVar$1("grey-1");
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      containerSize,
      contrastBorderColor,
      moreBullet,
      resolvedColor,
      t: t22
    };
  }
});
const _hoisted_1$1i = ["data-automation"];
const _hoisted_2$12 = ["data-automation"];
const _hoisted_3$R = ["data-automation"];
const _hoisted_4$z = ["data-automation"];
const _hoisted_5$s = {
  key: 0,
  class: "plus"
};
const _hoisted_6$g = {
  key: 1,
  class: "crossed"
};
const _hoisted_7$e = {
  key: 2,
  class: "content-block"
};
function _sfc_render$1n(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tooltip = resolveComponent("Tooltip");
  return openBlock(), createElementBlock("div", {
    class: "flex inline items-center justify-center no-wrap text-center",
    "data-automation": _ctx.buildId(),
    style: normalizeStyle({
      "--container-size": `${_ctx.containerSize}px`,
      "--size": `${_ctx.size}px`
    })
  }, [
    _ctx.label != null && !_ctx.more ? (openBlock(), createElementBlock("span", {
      key: 0,
      class: normalizeClass(["text-body3 text-grey-1 q-mr-xs", _ctx.labelClass]),
      "data-automation": _ctx.buildId("label")
    }, toDisplayString(_ctx.label), 11, _hoisted_2$12)) : createCommentVNode("", true),
    createElementVNode("div", {
      class: "bullet__container relative-position flex items-center justify-center",
      "data-automation": _ctx.buildId("bullet__container")
    }, [
      createElementVNode("div", {
        class: normalizeClass(["bullet inline-block", {
          "bullet--crossed": _ctx.crossed,
          "bullet--more": _ctx.moreBullet,
          "rounded": _ctx.rounded
        }]),
        "data-automation": _ctx.buildId("bullet__container--bullet"),
        style: normalizeStyle({
          ..._ctx.color && { backgroundColor: _ctx.resolvedColor },
          "border": `1px solid ${_ctx.contrastBorderColor} !important`
        })
      }, null, 14, _hoisted_4$z),
      _ctx.moreBullet ? (openBlock(), createElementBlock("div", _hoisted_5$s, toDisplayString(_ctx.t("rvai-base.general.symbols.plus")), 1)) : _ctx.crossed ? (openBlock(), createElementBlock("div", _hoisted_6$g)) : createCommentVNode("", true),
      _ctx.$slots["content"] ? (openBlock(), createElementBlock("div", _hoisted_7$e, [
        renderSlot(_ctx.$slots, "content", {}, void 0, true)
      ])) : createCommentVNode("", true),
      _ctx.isTooltipShown && (_ctx.tooltip || _ctx.moreBullet || _ctx.$slots["tooltip"]) ? (openBlock(), createBlock(_component_Tooltip, {
        key: 3,
        anchor: _ctx.tooltipAnchor,
        "data-automation": _ctx.buildId("tooltip"),
        "max-width": _ctx.tooltipMaxWidth,
        self: _ctx.tooltipSelf
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "tooltip", {}, void 0, true),
          !_ctx.$slots["tooltip"] ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createTextVNode(toDisplayString(_ctx.moreBullet ? _ctx.label : _ctx.tooltip), 1)
          ], 64)) : createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["anchor", "data-automation", "max-width", "self"])) : createCommentVNode("", true)
    ], 8, _hoisted_3$R)
  ], 12, _hoisted_1$1i);
}
const Bullet = /* @__PURE__ */ _export_sfc$1(_sfc_main$1v, [["render", _sfc_render$1n], ["__scopeId", "data-v-b6cfb40b"]]);
const HISTOGRAM_DEFAULT_SIZE = 276;
const LABEL_MAX_WIDTH = 140;
const MIN_SPACING = 100;
const ROW_DEFAULT_MIN_HEIGHT = 8;
const ROW_DETAILED_MIN_HEIGHT = 20;
const _sfc_main$1u = defineComponent({
  name: "Histogram",
  components: {
    Bullet,
    QInnerLoading: QInnerLoading_default,
    QResizeObserver: QResizeObserver_default$1,
    QSpace: QSpace_default,
    Tooltip: Tooltip2
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Displays all info in a row (classNames, percentages, etc)
     */
    detailed: {
      type: Boolean,
      default: false
    },
    /**
     * Bar height
     */
    barHeight: {
      type: Number,
      default: void 0
    },
    /**
     * Classes applied to the Histogram
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Class distribution data
     */
    entries: {
      type: Array,
      required: true
    },
    /**
     * Displays class names and percentages
     */
    full: {
      type: Boolean,
      default: false
    },
    /**
     * Displays spinner
     */
    loading: {
      type: Boolean,
      default: false
    },
    /**
     * Component max height
     */
    maxHeight: {
      type: Number,
      default: void 0
    },
    /**
     * Emits 'update:selected' with row.id, when true
     */
    selectable: {
      type: Boolean,
      default: false
    },
    /**
     * v-model:selected; allows handling selected class
     */
    selected: {
      type: String,
      default: void 0
    },
    /**
     * Shows class name or class id
     */
    showName: {
      type: Boolean,
      default: false
    },
    /**
     * Histogram size ('sm' | 'md')
     */
    size: {
      type: String,
      default: "sm"
    }
  },
  emits: [
    /**
     * Emitted when 'selectable' property is true and bar is clicked
     */
    "update:selected"
  ],
  setup(props4, { emit }) {
    const histogramRef = ref$1(null);
    const availableWidth = ref$1(0);
    const { t: t22 } = useI18n();
    const barMargin = computed(() => props4.detailed ? 2 : 1);
    const rowMinHeight = computed(() => props4.detailed ? ROW_DETAILED_MIN_HEIGHT : ROW_DEFAULT_MIN_HEIGHT);
    const rowHeight = computed(() => {
      return Math.max(
        histogramSize.value / props4.entries.length - barMargin.value - (props4.detailed ? barMargin.value : 0),
        rowMinHeight.value
      );
    });
    const computedBarHeight = computed(() => props4.barHeight ?? Math.max(rowHeight.value, ROW_DEFAULT_MIN_HEIGHT));
    const isContentScrollable = computed(() => {
      return rowHeight.value <= rowMinHeight.value;
    });
    const histogramSize = computed(() => {
      var _a;
      return props4.maxHeight || ((_a = histogramRef.value) == null ? void 0 : _a.offsetHeight) || HISTOGRAM_DEFAULT_SIZE;
    });
    const maxCount = computed(() => Math.max(...props4.entries.map((c3) => c3.count)));
    const countLimit = computed(() => last(stepsValues.value) ?? 0);
    const entriesWithSize = computed(() => {
      const max2 = props4.full ? countLimit.value : maxCount.value;
      return props4.entries.map((c3) => {
        const size2 = max2 ? 100 * (c3.count / max2) : 0;
        return {
          ...c3,
          size: `${size2}%`
        };
      });
    });
    const labelWidth = computed(() => {
      if (props4.full) return 24;
      return (computedBarHeight.value >= 16 ? 8 : 4) * 2;
    });
    const hasSquareBackground = computed(() => !props4.full && props4.size === "sm");
    const stepsValues = computed(() => {
      if (!availableWidth.value) return [];
      const stepPow = 10 ** Math.max(0, Math.floor(Math.log10(maxCount.value)));
      const maxSteps = Math.max(1, Math.floor(availableWidth.value / MIN_SPACING));
      const minStepSize = maxCount.value / maxSteps;
      const stepSize = Math.ceil(minStepSize / stepPow) * stepPow;
      const stepsCount = Math.max(1, Math.ceil(maxCount.value / stepSize));
      return Array.from({ length: stepsCount + 1 }).map((_, index2) => index2 * stepSize);
    });
    const steps = computed(() => {
      if (!countLimit.value) return [];
      return stepsValues.value.map((s32) => [
        String(s32),
        // TODO decimal
        `${100 * s32 / countLimit.value}%`
      ]);
    });
    const stepsBars = computed(() => {
      return steps.value.map((p2) => p2[1]);
    });
    function getBulletSize() {
      return computedBarHeight.value >= 16 || props4.full || props4.detailed ? 8 : 4;
    }
    function isSelected(row) {
      return props4.selected === row.id;
    }
    function isAnnotated(row) {
      return !["null", null].includes(row.id);
    }
    function isEmpty2(row) {
      return [""].includes(row.id);
    }
    function onClick(row) {
      if (!props4.selectable) return;
      if (isSelected(row)) {
        emit("update:selected", void 0);
      } else {
        emit("update:selected", row.id);
      }
    }
    function onResize({ width }) {
      availableWidth.value = width - LABEL_MAX_WIDTH;
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      barMargin,
      computedBarHeight,
      entriesWithSize,
      getBulletSize,
      hasSquareBackground,
      histogramRef,
      histogramSize,
      isAnnotated,
      isContentScrollable,
      isEmpty: isEmpty2,
      isSelected,
      labelWidth,
      onClick,
      onResize,
      steps,
      stepsBars,
      t: t22
    };
  }
});
const _hoisted_1$1h = ["data-automation"];
const _hoisted_2$11 = ["data-automation", "onClick"];
const _hoisted_3$Q = {
  key: 2,
  class: "ellipsis"
};
const _hoisted_4$y = { class: "full-width" };
const _hoisted_5$r = ["data-automation"];
const _hoisted_6$f = {
  key: 0,
  class: "histogram__values row no-wrap items-center q-mx-sm"
};
const _hoisted_7$d = ["data-automation"];
const _hoisted_8$9 = ["data-automation"];
const _hoisted_9$8 = {
  key: 1,
  class: "histogram__pct-bar-wrapper"
};
const _hoisted_10$5 = ["data-automation"];
const _hoisted_11$5 = ["data-automation"];
const _hoisted_12$4 = { class: "histogram__pct-wrapper relative-position col-grow text-right q-pa-xs q-mt-md" };
const _hoisted_13$4 = ["data-automation"];
function _sfc_render$1m(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QInnerLoading = resolveComponent("QInnerLoading");
  const _component_QResizeObserver = resolveComponent("QResizeObserver");
  const _component_Bullet = resolveComponent("Bullet");
  const _component_QSpace = resolveComponent("QSpace");
  const _component_Tooltip = resolveComponent("Tooltip");
  return openBlock(), createElementBlock("div", {
    ref: "histogramRef",
    class: normalizeClass(["histogram relative-position row no-wrap", [
      _ctx.$props.class,
      {
        "bg-grey-5--light bg-grey-1--dark": !_ctx.full && !_ctx.detailed,
        "histogram--custom-height": _ctx.maxHeight,
        "histogram--full": _ctx.full,
        "histogram--min-height": _ctx.loading,
        "histogram--square": _ctx.hasSquareBackground
      }
    ]]),
    "data-automation": _ctx.buildId(),
    style: normalizeStyle({
      "--histogram-size": `${_ctx.histogramSize}px`
    })
  }, [
    createVNode(_component_QInnerLoading, {
      class: "z-top",
      color: "primary",
      "data-automation": _ctx.buildId("loading"),
      showing: _ctx.loading
    }, null, 8, ["data-automation", "showing"]),
    createElementVNode("div", {
      class: normalizeClass(["histogram__wrapper relative-position col", { "histogram__wrapper--scrollable": _ctx.isContentScrollable }]),
      style: normalizeStyle({
        "--bar-height": `${_ctx.computedBarHeight}px`
      })
    }, [
      _ctx.full || _ctx.detailed ? (openBlock(), createBlock(_component_QResizeObserver, {
        key: 0,
        onResize: _ctx.onResize
      }, null, 8, ["onResize"])) : createCommentVNode("", true),
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.entriesWithSize, (entry) => {
        return openBlock(), createElementBlock("div", {
          key: entry.id,
          class: normalizeClass(["histogram__entry row no-wrap", {
            "cursor-pointer": _ctx.selectable,
            "histogram__entry--full": _ctx.full,
            "histogram__entry--detailed": _ctx.detailed,
            "histogram__entry--selected": _ctx.isSelected(entry)
          }]),
          "data-automation": _ctx.buildId(`entry-${entry.id}`),
          style: normalizeStyle({
            "--bar-margin": `${_ctx.barMargin}px`,
            "--color": entry.color,
            "--entries-count": _ctx.entries.length,
            "--entry-min-height": _ctx.full || _ctx.detailed ? "20px" : `${_ctx.barHeight}px`,
            "--entry-size": entry.size
          }),
          onClick: ($event) => _ctx.onClick(entry)
        }, [
          createElementVNode("div", {
            class: normalizeClass(["histogram__label row items-center text-small text-bold col-fixed", [
              { "histogram__label--full q-pr-sm": _ctx.full || _ctx.detailed },
              { "q-ml-sm": _ctx.detailed },
              _ctx.full || _ctx.detailed || _ctx.isAnnotated(entry) ? "q-pr-sm" : "q-pr-xs"
            ]]),
            style: normalizeStyle({ ...!_ctx.full && !_ctx.detailed && { width: `${_ctx.labelWidth}px` } })
          }, [
            createElementVNode("div", {
              class: "row items-center no-wrap zero-min-width",
              style: normalizeStyle({ fontSize: _ctx.full || _ctx.detailed ? "inherit" : "6px" })
            }, [
              _ctx.isAnnotated(entry) ? (openBlock(), createBlock(_component_Bullet, {
                key: 0,
                class: "col-fixed q-mr-xs",
                color: entry.color,
                crossed: _ctx.isEmpty(entry),
                "data-automation": _ctx.buildId("bullet"),
                size: _ctx.getBulletSize()
              }, null, 8, ["color", "crossed", "data-automation", "size"])) : createCommentVNode("", true),
              entry.id === "null" ? (openBlock(), createElementBlock("div", {
                key: 1,
                style: normalizeStyle({ width: `${_ctx.labelWidth}px` })
              }, null, 4)) : createCommentVNode("", true),
              _ctx.full || _ctx.detailed ? (openBlock(), createElementBlock("div", _hoisted_3$Q, toDisplayString(_ctx.showName ? entry.name : entry.id === "null" ? _ctx.t("rvai-base.components.histogram.noLabel") : entry.id), 1)) : createCommentVNode("", true)
            ], 4)
          ], 6),
          createElementVNode("div", _hoisted_4$y, [
            createElementVNode("div", {
              class: normalizeClass(["histogram__bar relative-position z-fab", {
                "histogram__bar--none": !_ctx.isAnnotated(entry),
                "histogram__bar--empty": _ctx.isEmpty(entry)
              }]),
              "data-automation": _ctx.buildId(`entry__bar--${entry.id}`)
            }, null, 10, _hoisted_5$r)
          ]),
          _ctx.detailed ? (openBlock(), createElementBlock("div", _hoisted_6$f, [
            createElementVNode("div", {
              class: "histogram__count text-bold",
              "data-automation": _ctx.buildId(`entry__count--${entry.id}`)
            }, toDisplayString(entry.count), 9, _hoisted_7$d),
            createVNode(_component_QSpace),
            createElementVNode("div", {
              class: "histogram__percentage q-ml-xs row items-center justify-end",
              "data-automation": _ctx.buildId(`entry__percentage--${entry.id}`)
            }, toDisplayString(entry.pct), 9, _hoisted_8$9)
          ])) : createCommentVNode("", true),
          _ctx.$slots["tooltip"] ? (openBlock(), createBlock(_component_Tooltip, {
            key: 1,
            anchor: "center left",
            "data-automation": _ctx.buildId("tooltip"),
            offset: [_ctx.full ? -150 : -20, 0],
            self: "center left"
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "tooltip", { entry }, void 0, true)
            ]),
            _: 2
          }, 1032, ["data-automation", "offset"])) : createCommentVNode("", true)
        ], 14, _hoisted_2$11);
      }), 128)),
      _ctx.full ? (openBlock(), createElementBlock("div", _hoisted_9$8, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.stepsBars, (left, index2) => {
          return openBlock(), createElementBlock("div", {
            key: index2,
            class: "histogram__pct-bar",
            "data-automation": _ctx.buildId(`bar-${index2}`),
            style: normalizeStyle({ "left": left })
          }, null, 12, _hoisted_10$5);
        }), 128))
      ])) : createCommentVNode("", true),
      _ctx.full ? (openBlock(), createElementBlock("div", {
        key: 2,
        class: "histogram__footer",
        "data-automation": _ctx.buildId("footer")
      }, [
        createElementVNode("div", _hoisted_12$4, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.steps, ([count, left], index2) => {
            return openBlock(), createElementBlock("div", {
              key: index2,
              class: "histogram__pct text-bold text-grey-1",
              "data-automation": _ctx.buildId(`step-${index2}`),
              style: normalizeStyle({ "left": left })
            }, toDisplayString(count), 13, _hoisted_13$4);
          }), 128))
        ])
      ], 8, _hoisted_11$5)) : createCommentVNode("", true)
    ], 6)
  ], 14, _hoisted_1$1h);
}
const BarChart = /* @__PURE__ */ _export_sfc$1(_sfc_main$1u, [["render", _sfc_render$1m], ["__scopeId", "data-v-d010ab71"]]);
const _sfc_main$1t = defineComponent({
  name: "Separator",
  inheritAtttrs: false,
  components: {
    QSeparator: QSeparator_default$1
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: "separator"
    },
    /**
     * Dark theme color name for component from the Quasar Color Palette
     */
    colorDark: {
      type: String,
      default: "grey-2--dark"
    },
    /**
     * Light theme color name for component from the Quasar Color Palette
     */
    colorLight: {
      type: String,
      default: "grey-3--light"
    },
    /**
     * If set to true, the separator will be vertical
     */
    vertical: {
      type: Boolean,
      default: false
    }
  },
  setup(props4) {
    const { isDark } = useDarkMode();
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      isDark
    };
  }
});
function _sfc_render$1l(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QSeparator = resolveComponent("QSeparator");
  return openBlock(), createBlock(_component_QSeparator, {
    color: _ctx.isDark ? _ctx.colorDark : _ctx.colorLight,
    "data-automation": _ctx.buildId(),
    vertical: _ctx.vertical
  }, null, 8, ["color", "data-automation", "vertical"]);
}
const Separator = /* @__PURE__ */ _export_sfc$1(_sfc_main$1t, [["render", _sfc_render$1l]]);
const _sfc_main$1s = defineComponent({
  name: "Card",
  components: {
    Button,
    QMenu: QMenu_default$1,
    Separator
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Separator animated on hover,
     * if false - only when component is clickable
     */
    alwaysAnimated: {
      type: Boolean,
      default: true
    },
    /**
     * Text displayed in description
     */
    description: {
      type: String,
      default: ""
    },
    /**
     * Text displayed in title
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * Equivalent to Vue Router <router-link> 'to' property
     */
    to: {
      type: [Object, String],
      default: void 0
    }
  },
  setup(props4) {
    const headerHover = ref$1(false);
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      headerHover,
      RouterLink
    };
  }
});
const _hoisted_1$1g = ["data-automation"];
const _hoisted_2$10 = { class: "column" };
const _hoisted_3$P = ["data-automation"];
const _hoisted_4$x = ["data-automation"];
function _sfc_render$1k(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QMenu = resolveComponent("QMenu");
  const _component_Button = resolveComponent("Button");
  const _component_Separator = resolveComponent("Separator");
  return openBlock(), createElementBlock("div", {
    class: "rounded-borders bg-grey-5 q-pa-md",
    "data-automation": _ctx.buildId()
  }, [
    createElementVNode("div", {
      class: normalizeClass(["card column relative-position", {
        "card--animated": _ctx.alwaysAnimated
      }])
    }, [
      _ctx.$slots["actions"] || _ctx.$slots["header"] || _ctx.title || _ctx.description ? (openBlock(), createBlock(resolveDynamicComponent(_ctx.to && !_ctx.$slots["content"] ? _ctx.RouterLink : "div"), {
        key: 0,
        class: normalizeClass(["card__header row justify-between items-start q-pa-md", {
          "card__header--animated": _ctx.to && !_ctx.$slots["content"] && !_ctx.$slots["actions"] && !_ctx.$slots["header"],
          "card__header--clickable": _ctx.to && !_ctx.$slots["content"]
        }]),
        to: _ctx.to,
        onMouseout: _cache[1] || (_cache[1] = ($event) => _ctx.headerHover = false),
        onMouseover: _cache[2] || (_cache[2] = ($event) => _ctx.headerHover = true)
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "header", {}, () => [
            createElementVNode("div", _hoisted_2$10, [
              createElementVNode("div", {
                class: "text-subtitle3 text-black-1",
                "data-automation": _ctx.buildId("title")
              }, toDisplayString(_ctx.title), 9, _hoisted_3$P),
              createElementVNode("div", {
                "data-automation": _ctx.buildId("description")
              }, toDisplayString(_ctx.description), 9, _hoisted_4$x)
            ])
          ], true),
          _ctx.$slots["actions"] ? (openBlock(), createBlock(_component_Button, {
            key: 0,
            class: "card__dots no-padding absolute",
            color: "grey-1",
            "data-automation": _ctx.buildId("actions"),
            icon: "mdi-dots-horizontal",
            tertiary: "",
            onClick: _cache[0] || (_cache[0] = withModifiers(() => {
            }, ["stop", "prevent"]))
          }, {
            default: withCtx(() => [
              createVNode(_component_QMenu, { "auto-close": "" }, {
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, "actions", {}, void 0, true)
                ]),
                _: 3
              })
            ]),
            _: 3
          }, 8, ["data-automation"])) : createCommentVNode("", true)
        ]),
        _: 3
      }, 40, ["class", "to"])) : createCommentVNode("", true),
      _ctx.$slots["content"] ? (openBlock(), createBlock(resolveDynamicComponent(_ctx.to ? _ctx.RouterLink : "div"), {
        key: 1,
        class: "card__content",
        to: _ctx.to
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "content", {}, void 0, true)
        ]),
        _: 3
      }, 8, ["to"])) : createCommentVNode("", true),
      _ctx.$slots["bottom"] ? (openBlock(), createBlock(_component_Separator, {
        key: 2,
        class: "card__separator q-mx-md",
        color: "grey-3"
      })) : createCommentVNode("", true),
      _ctx.$slots["bottom"] ? (openBlock(), createElementBlock("div", {
        key: 3,
        class: "card__content-bottom",
        onClick: _cache[3] || (_cache[3] = withModifiers(() => {
        }, ["stop", "prevent"]))
      }, [
        renderSlot(_ctx.$slots, "bottom", {}, void 0, true)
      ])) : createCommentVNode("", true)
    ], 2)
  ], 8, _hoisted_1$1g);
}
const Card = /* @__PURE__ */ _export_sfc$1(_sfc_main$1s, [["render", _sfc_render$1k], ["__scopeId", "data-v-77361308"]]);
const _sfc_main$1r = defineComponent({
  name: "CardImage",
  components: {
    QImg: QImg_default,
    QSkeleton: QSkeleton_default
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Component height
     */
    height: {
      type: String,
      default: "101px"
    },
    /**
     * An image for a specific project type
     */
    imageUrl: {
      type: String,
      default: void 0
    },
    /**
     * Render skeleton
     */
    loading: {
      type: Boolean,
      default: false
    },
    /**
     * Default image. Shown when "imageUrl" and "thumbnailUrl" do not exist
     */
    noImageUrl: {
      type: String,
      required: true
    },
    /**
     * Default image.Thumbnail for dataset
     */
    thumbnailUrl: {
      type: String,
      default: null
    }
  },
  setup(props4) {
    const thumbnailError = ref$1(false);
    const backgroundColor = computed(() => props4.imageUrl ? "var(--q-grey-5-fixed)" : "var(--q-grey-5)");
    const backgroundImage = computed(() => {
      if (props4.thumbnailUrl || props4.imageUrl) return void 0;
      return `url("${props4.noImageUrl}")`;
    });
    function onThumbnailError() {
      thumbnailError.value = true;
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      backgroundColor,
      backgroundImage,
      onThumbnailError,
      thumbnailError
    };
  }
});
const _hoisted_1$1f = ["data-automation"];
function _sfc_render$1j(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QImg = resolveComponent("QImg");
  const _component_QSkeleton = resolveComponent("QSkeleton");
  return openBlock(), createElementBlock("div", mergeProps(_ctx.dataAttrs, {
    class: "card-image relative-position",
    "data-automation": _ctx.buildId(),
    style: {
      "background-color": _ctx.backgroundColor,
      "background-image": _ctx.backgroundImage,
      "height": _ctx.height
    }
  }), [
    _ctx.thumbnailUrl && !_ctx.thumbnailError ? (openBlock(), createBlock(_component_QImg, {
      key: 0,
      "data-automation": _ctx.buildId("thumbnailImage"),
      fit: "cover",
      height: _ctx.height,
      src: _ctx.thumbnailUrl,
      onError: _ctx.onThumbnailError
    }, null, 8, ["data-automation", "height", "src", "onError"])) : _ctx.imageUrl ? (openBlock(), createBlock(_component_QImg, {
      key: 1,
      "data-automation": _ctx.buildId("image"),
      fit: "contain",
      height: _ctx.height,
      src: _ctx.imageUrl
    }, null, 8, ["data-automation", "height", "src"])) : createCommentVNode("", true),
    _ctx.loading ? (openBlock(), createBlock(_component_QSkeleton, {
      key: 2,
      class: "absolute-full",
      "data-automation": _ctx.buildId("skeleton"),
      square: ""
    }, null, 8, ["data-automation"])) : createCommentVNode("", true)
  ], 16, _hoisted_1$1f);
}
const CardImage = /* @__PURE__ */ _export_sfc$1(_sfc_main$1r, [["render", _sfc_render$1j], ["__scopeId", "data-v-65faacea"]]);
const __default__$5 = defineComponent({
  name: "CardItem",
  components: {
    Button,
    QIcon: QIcon_default$1,
    QMenu: QMenu_default$1
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Background color name for component from the Quasar Color Palette
     */
    backgroundColor: {
      type: String,
      default: "grey-5"
    },
    /**
     * Text displayed in description
     */
    description: {
      type: String,
      default: ""
    },
    /**
     * Allow to hover component via prop
     */
    forceHover: {
      type: Boolean,
      default: false
    },
    /**
     * Showing without padding and disabled padding
     */
    inline: {
      type: Boolean,
      default: false
    },
    /**
     * Hide arrow right icon
     */
    hideIcon: {
      type: Boolean,
      default: false
    },
    /**
     * Text displayed in title
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * Equivalent to Vue Router <router-link> 'to' property
     */
    to: {
      type: [Object, String],
      default: void 0
    }
  },
  setup(props4) {
    const borderColor = computed(() => props4.backgroundColor ? getCssVar$1(props4.backgroundColor) ?? "transparent" : "transparent");
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      borderColor,
      RouterLink
    };
  }
});
const __injectCSSVars__$5 = () => {
  useCssVars((_ctx) => ({
    "7487f7ba": _ctx.borderColor
  }));
};
const __setup__$5 = __default__$5.setup;
__default__$5.setup = __setup__$5 ? (props4, ctx) => {
  __injectCSSVars__$5();
  return __setup__$5(props4, ctx);
} : __injectCSSVars__$5;
const _hoisted_1$1e = ["data-automation"];
const _hoisted_2$$ = ["data-automation"];
const _hoisted_3$O = { class: "column" };
const _hoisted_4$w = ["data-automation"];
const _hoisted_5$q = ["data-automation"];
function _sfc_render$1i(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QMenu = resolveComponent("QMenu");
  const _component_Button = resolveComponent("Button");
  const _component_QIcon = resolveComponent("QIcon");
  return openBlock(), createBlock(resolveDynamicComponent(_ctx.to ? _ctx.RouterLink : "div"), {
    class: normalizeClass(["card-item row justify-between items-center no-wrap rounded-borders", {
      "card-item--force-hover": _ctx.forceHover,
      "card-item--animated-border q-pa-md": !_ctx.inline,
      [`bg-${_ctx.backgroundColor}`]: !!_ctx.backgroundColor
    }]),
    "data-automation": _ctx.buildId(),
    to: _ctx.to
  }, {
    default: withCtx(() => [
      createElementVNode("div", {
        class: "row items-center col",
        "data-automation": _ctx.buildId("content-wrapper")
      }, [
        renderSlot(_ctx.$slots, "prepend", {}, void 0, true),
        createElementVNode("div", {
          class: "card-item__content col",
          "data-automation": _ctx.buildId("content")
        }, [
          renderSlot(_ctx.$slots, "content", {}, () => [
            createElementVNode("div", _hoisted_3$O, [
              createElementVNode("div", {
                class: "text-subtitle3 text-black-1",
                "data-automation": _ctx.buildId("title")
              }, toDisplayString(_ctx.title), 9, _hoisted_4$w),
              createElementVNode("div", {
                "data-automation": _ctx.buildId("description")
              }, toDisplayString(_ctx.description), 9, _hoisted_5$q)
            ])
          ], true)
        ], 8, _hoisted_2$$)
      ], 8, _hoisted_1$1e),
      _ctx.$slots["actions"] ? (openBlock(), createBlock(_component_Button, {
        key: 0,
        class: "card-item__dots self-start",
        color: "black-1",
        "data-automation": _ctx.buildId("actions"),
        icon: "mdi-dots-horizontal",
        tertiary: "",
        onClick: _cache[0] || (_cache[0] = withModifiers(() => {
        }, ["stop", "prevent"]))
      }, {
        default: withCtx(() => [
          createVNode(_component_QMenu, { "auto-close": "" }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "actions", {}, void 0, true)
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 8, ["data-automation"])) : createCommentVNode("", true),
      !_ctx.hideIcon && !_ctx.$slots["actions"] ? (openBlock(), createBlock(_component_QIcon, {
        key: 1,
        class: "card-item__chevron",
        color: "black-1",
        "data-automation": _ctx.buildId("chevron-icon"),
        name: "mdi-chevron-right",
        size: "24px"
      }, null, 8, ["data-automation"])) : createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["class", "data-automation", "to"]);
}
const CardItem = /* @__PURE__ */ _export_sfc$1(__default__$5, [["render", _sfc_render$1i], ["__scopeId", "data-v-c777bac7"]]);
var rn = Object.defineProperty;
var Ne = Object.getOwnPropertySymbols;
var vt = Object.prototype.hasOwnProperty, bt = Object.prototype.propertyIsEnumerable;
var mt = (t22, e22, n) => e22 in t22 ? rn(t22, e22, { enumerable: true, configurable: true, writable: true, value: n }) : t22[e22] = n, fe = (t22, e22) => {
  for (var n in e22 || (e22 = {}))
    vt.call(e22, n) && mt(t22, n, e22[n]);
  if (Ne)
    for (var n of Ne(e22))
      bt.call(e22, n) && mt(t22, n, e22[n]);
  return t22;
};
var Ve = (t22, e22) => {
  var n = {};
  for (var o in t22)
    vt.call(t22, o) && e22.indexOf(o) < 0 && (n[o] = t22[o]);
  if (t22 != null && Ne)
    for (var o of Ne(t22))
      e22.indexOf(o) < 0 && bt.call(t22, o) && (n[o] = t22[o]);
  return n;
};
const Bt = "[vue-draggable-plus]: ";
function gn(t22) {
  console.warn(Bt + t22);
}
function mn(t22) {
  console.error(Bt + t22);
}
function wt(t22, e22, n) {
  return n >= 0 && n < t22.length && t22.splice(n, 0, t22.splice(e22, 1)[0]), t22;
}
function vn(t22) {
  return t22.replace(/-(\w)/g, (e22, n) => n ? n.toUpperCase() : "");
}
function bn(t22) {
  return Object.keys(t22).reduce((e22, n) => (typeof t22[n] != "undefined" && (e22[vn(n)] = t22[n]), e22), {});
}
function Et(t22, e22) {
  return Array.isArray(t22) && t22.splice(e22, 1), t22;
}
function St(t22, e22, n) {
  return Array.isArray(t22) && t22.splice(e22, 0, n), t22;
}
function yn(t22) {
  return typeof t22 == "undefined";
}
function wn(t22) {
  return typeof t22 == "string";
}
function Dt(t22, e22, n) {
  const o = t22.children[n];
  t22.insertBefore(e22, o);
}
function qe(t22) {
  t22.parentNode && t22.parentNode.removeChild(t22);
}
function En(t22, e22 = document) {
  var o;
  let n = null;
  return typeof (e22 == null ? void 0 : e22.querySelector) == "function" ? n = (o = e22 == null ? void 0 : e22.querySelector) == null ? void 0 : o.call(e22, t22) : n = document.querySelector(t22), n || gn(`Element not found: ${t22}`), n;
}
function Sn(t22, e22, n = null) {
  return function(...o) {
    return t22.apply(n, o), e22.apply(n, o);
  };
}
function Dn(t22, e22) {
  const n = fe({}, t22);
  return Object.keys(e22).forEach((o) => {
    n[o] ? n[o] = Sn(t22[o], e22[o]) : n[o] = e22[o];
  }), n;
}
function _n(t22) {
  return t22 instanceof HTMLElement;
}
function _t(t22, e22) {
  Object.keys(t22).forEach((n) => {
    e22(n, t22[n]);
  });
}
function Tn(t22) {
  return t22.charCodeAt(0) === 111 && t22.charCodeAt(1) === 110 && // uppercase letter
  (t22.charCodeAt(2) > 122 || t22.charCodeAt(2) < 97);
}
const Cn = Object.assign;
/**!
 * Sortable 1.15.2
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function Tt(t22, e22) {
  var n = Object.keys(t22);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t22);
    e22 && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(t22, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function te(t22) {
  for (var e22 = 1; e22 < arguments.length; e22++) {
    var n = arguments[e22] != null ? arguments[e22] : {};
    e22 % 2 ? Tt(Object(n), true).forEach(function(o) {
      On(t22, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t22, Object.getOwnPropertyDescriptors(n)) : Tt(Object(n)).forEach(function(o) {
      Object.defineProperty(t22, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return t22;
}
function Xe(t22) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Xe = function(e22) {
    return typeof e22;
  } : Xe = function(e22) {
    return e22 && typeof Symbol == "function" && e22.constructor === Symbol && e22 !== Symbol.prototype ? "symbol" : typeof e22;
  }, Xe(t22);
}
function On(t22, e22, n) {
  return e22 in t22 ? Object.defineProperty(t22, e22, {
    value: n,
    enumerable: true,
    configurable: true,
    writable: true
  }) : t22[e22] = n, t22;
}
function re() {
  return re = Object.assign || function(t22) {
    for (var e22 = 1; e22 < arguments.length; e22++) {
      var n = arguments[e22];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (t22[o] = n[o]);
    }
    return t22;
  }, re.apply(this, arguments);
}
function In(t22, e22) {
  if (t22 == null)
    return {};
  var n = {}, o = Object.keys(t22), r, i22;
  for (i22 = 0; i22 < o.length; i22++)
    r = o[i22], !(e22.indexOf(r) >= 0) && (n[r] = t22[r]);
  return n;
}
function An(t22, e22) {
  if (t22 == null)
    return {};
  var n = In(t22, e22), o, r;
  if (Object.getOwnPropertySymbols) {
    var i22 = Object.getOwnPropertySymbols(t22);
    for (r = 0; r < i22.length; r++)
      o = i22[r], !(e22.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(t22, o) && (n[o] = t22[o]);
  }
  return n;
}
var xn = "1.15.2";
function oe(t22) {
  if (typeof window != "undefined" && window.navigator)
    return !!/* @__PURE__ */ navigator.userAgent.match(t22);
}
var ie = oe(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i), Ae = oe(/Edge/i), Ct = oe(/firefox/i), _e = oe(/safari/i) && !oe(/chrome/i) && !oe(/android/i), kt = oe(/iP(ad|od|hone)/i), Ht = oe(/chrome/i) && oe(/android/i), Lt = {
  capture: false,
  passive: false
};
function D22(t22, e22, n) {
  t22.addEventListener(e22, n, !ie && Lt);
}
function S32(t22, e22, n) {
  t22.removeEventListener(e22, n, !ie && Lt);
}
function Le(t22, e22) {
  if (e22) {
    if (e22[0] === ">" && (e22 = e22.substring(1)), t22)
      try {
        if (t22.matches)
          return t22.matches(e22);
        if (t22.msMatchesSelector)
          return t22.msMatchesSelector(e22);
        if (t22.webkitMatchesSelector)
          return t22.webkitMatchesSelector(e22);
      } catch (n) {
        return false;
      }
    return false;
  }
}
function Nn(t22) {
  return t22.host && t22 !== document && t22.host.nodeType ? t22.host : t22.parentNode;
}
function Z(t22, e22, n, o) {
  if (t22) {
    n = n || document;
    do {
      if (e22 != null && (e22[0] === ">" ? t22.parentNode === n && Le(t22, e22) : Le(t22, e22)) || o && t22 === n)
        return t22;
      if (t22 === n)
        break;
    } while (t22 = Nn(t22));
  }
  return null;
}
var Ot = /\s+/g;
function V(t22, e22, n) {
  if (t22 && e22)
    if (t22.classList)
      t22.classList[n ? "add" : "remove"](e22);
    else {
      var o = (" " + t22.className + " ").replace(Ot, " ").replace(" " + e22 + " ", " ");
      t22.className = (o + (n ? " " + e22 : "")).replace(Ot, " ");
    }
}
function h32(t22, e22, n) {
  var o = t22 && t22.style;
  if (o) {
    if (n === void 0)
      return document.defaultView && document.defaultView.getComputedStyle ? n = document.defaultView.getComputedStyle(t22, "") : t22.currentStyle && (n = t22.currentStyle), e22 === void 0 ? n : n[e22];
    !(e22 in o) && e22.indexOf("webkit") === -1 && (e22 = "-webkit-" + e22), o[e22] = n + (typeof n == "string" ? "" : "px");
  }
}
function ye(t22, e22) {
  var n = "";
  if (typeof t22 == "string")
    n = t22;
  else
    do {
      var o = h32(t22, "transform");
      o && o !== "none" && (n = o + " " + n);
    } while (!e22 && (t22 = t22.parentNode));
  var r = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return r && new r(n);
}
function Wt(t22, e22, n) {
  if (t22) {
    var o = t22.getElementsByTagName(e22), r = 0, i22 = o.length;
    if (n)
      for (; r < i22; r++)
        n(o[r], r);
    return o;
  }
  return [];
}
function ee() {
  var t22 = document.scrollingElement;
  return t22 || document.documentElement;
}
function M32(t22, e22, n, o, r) {
  if (!(!t22.getBoundingClientRect && t22 !== window)) {
    var i22, a32, l, s32, u22, d32, f;
    if (t22 !== window && t22.parentNode && t22 !== ee() ? (i22 = t22.getBoundingClientRect(), a32 = i22.top, l = i22.left, s32 = i22.bottom, u22 = i22.right, d32 = i22.height, f = i22.width) : (a32 = 0, l = 0, s32 = window.innerHeight, u22 = window.innerWidth, d32 = window.innerHeight, f = window.innerWidth), (e22 || n) && t22 !== window && (r = r || t22.parentNode, !ie))
      do
        if (r && r.getBoundingClientRect && (h32(r, "transform") !== "none" || n && h32(r, "position") !== "static")) {
          var m32 = r.getBoundingClientRect();
          a32 -= m32.top + parseInt(h32(r, "border-top-width")), l -= m32.left + parseInt(h32(r, "border-left-width")), s32 = a32 + i22.height, u22 = l + i22.width;
          break;
        }
      while (r = r.parentNode);
    if (o && t22 !== window) {
      var y32 = ye(r || t22), b22 = y32 && y32.a, E22 = y32 && y32.d;
      y32 && (a32 /= E22, l /= b22, f /= b22, d32 /= E22, s32 = a32 + d32, u22 = l + f);
    }
    return {
      top: a32,
      left: l,
      bottom: s32,
      right: u22,
      width: f,
      height: d32
    };
  }
}
function It(t22, e22, n) {
  for (var o = ue(t22, true), r = M32(t22)[e22]; o; ) {
    var i22 = M32(o)[n], a32 = void 0;
    if (a32 = r >= i22, !a32)
      return o;
    if (o === ee())
      break;
    o = ue(o, false);
  }
  return false;
}
function we(t22, e22, n, o) {
  for (var r = 0, i22 = 0, a32 = t22.children; i22 < a32.length; ) {
    if (a32[i22].style.display !== "none" && a32[i22] !== p.ghost && (o || a32[i22] !== p.dragged) && Z(a32[i22], n.draggable, t22, false)) {
      if (r === e22)
        return a32[i22];
      r++;
    }
    i22++;
  }
  return null;
}
function dt(t22, e22) {
  for (var n = t22.lastElementChild; n && (n === p.ghost || h32(n, "display") === "none" || e22 && !Le(n, e22)); )
    n = n.previousElementSibling;
  return n || null;
}
function K22(t22, e22) {
  var n = 0;
  if (!t22 || !t22.parentNode)
    return -1;
  for (; t22 = t22.previousElementSibling; )
    t22.nodeName.toUpperCase() !== "TEMPLATE" && t22 !== p.clone && (!e22 || Le(t22, e22)) && n++;
  return n;
}
function At(t22) {
  var e22 = 0, n = 0, o = ee();
  if (t22)
    do {
      var r = ye(t22), i22 = r.a, a32 = r.d;
      e22 += t22.scrollLeft * i22, n += t22.scrollTop * a32;
    } while (t22 !== o && (t22 = t22.parentNode));
  return [e22, n];
}
function Pn(t22, e22) {
  for (var n in t22)
    if (t22.hasOwnProperty(n)) {
      for (var o in e22)
        if (e22.hasOwnProperty(o) && e22[o] === t22[n][o])
          return Number(n);
    }
  return -1;
}
function ue(t22, e22) {
  if (!t22 || !t22.getBoundingClientRect)
    return ee();
  var n = t22, o = false;
  do
    if (n.clientWidth < n.scrollWidth || n.clientHeight < n.scrollHeight) {
      var r = h32(n);
      if (n.clientWidth < n.scrollWidth && (r.overflowX == "auto" || r.overflowX == "scroll") || n.clientHeight < n.scrollHeight && (r.overflowY == "auto" || r.overflowY == "scroll")) {
        if (!n.getBoundingClientRect || n === document.body)
          return ee();
        if (o || e22)
          return n;
        o = true;
      }
    }
  while (n = n.parentNode);
  return ee();
}
function Mn(t22, e22) {
  if (t22 && e22)
    for (var n in e22)
      e22.hasOwnProperty(n) && (t22[n] = e22[n]);
  return t22;
}
function Ke(t22, e22) {
  return Math.round(t22.top) === Math.round(e22.top) && Math.round(t22.left) === Math.round(e22.left) && Math.round(t22.height) === Math.round(e22.height) && Math.round(t22.width) === Math.round(e22.width);
}
var Te;
function Gt(t22, e22) {
  return function() {
    if (!Te) {
      var n = arguments, o = this;
      n.length === 1 ? t22.call(o, n[0]) : t22.apply(o, n), Te = setTimeout(function() {
        Te = void 0;
      }, e22);
    }
  };
}
function Fn() {
  clearTimeout(Te), Te = void 0;
}
function jt(t22, e22, n) {
  t22.scrollLeft += e22, t22.scrollTop += n;
}
function zt(t22) {
  var e22 = window.Polymer, n = window.jQuery || window.Zepto;
  return e22 && e22.dom ? e22.dom(t22).cloneNode(true) : n ? n(t22).clone(true)[0] : t22.cloneNode(true);
}
function Ut(t22, e22, n) {
  var o = {};
  return Array.from(t22.children).forEach(function(r) {
    var i22, a32, l, s32;
    if (!(!Z(r, e22.draggable, t22, false) || r.animated || r === n)) {
      var u22 = M32(r);
      o.left = Math.min((i22 = o.left) !== null && i22 !== void 0 ? i22 : 1 / 0, u22.left), o.top = Math.min((a32 = o.top) !== null && a32 !== void 0 ? a32 : 1 / 0, u22.top), o.right = Math.max((l = o.right) !== null && l !== void 0 ? l : -1 / 0, u22.right), o.bottom = Math.max((s32 = o.bottom) !== null && s32 !== void 0 ? s32 : -1 / 0, u22.bottom);
    }
  }), o.width = o.right - o.left, o.height = o.bottom - o.top, o.x = o.left, o.y = o.top, o;
}
var q22 = "Sortable" + (/* @__PURE__ */ new Date()).getTime();
function Rn() {
  var t22 = [], e22;
  return {
    captureAnimationState: function() {
      if (t22 = [], !!this.options.animation) {
        var o = [].slice.call(this.el.children);
        o.forEach(function(r) {
          if (!(h32(r, "display") === "none" || r === p.ghost)) {
            t22.push({
              target: r,
              rect: M32(r)
            });
            var i22 = te({}, t22[t22.length - 1].rect);
            if (r.thisAnimationDuration) {
              var a32 = ye(r, true);
              a32 && (i22.top -= a32.f, i22.left -= a32.e);
            }
            r.fromRect = i22;
          }
        });
      }
    },
    addAnimationState: function(o) {
      t22.push(o);
    },
    removeAnimationState: function(o) {
      t22.splice(Pn(t22, {
        target: o
      }), 1);
    },
    animateAll: function(o) {
      var r = this;
      if (!this.options.animation) {
        clearTimeout(e22), typeof o == "function" && o();
        return;
      }
      var i22 = false, a32 = 0;
      t22.forEach(function(l) {
        var s32 = 0, u22 = l.target, d32 = u22.fromRect, f = M32(u22), m32 = u22.prevFromRect, y32 = u22.prevToRect, b22 = l.rect, E22 = ye(u22, true);
        E22 && (f.top -= E22.f, f.left -= E22.e), u22.toRect = f, u22.thisAnimationDuration && Ke(m32, f) && !Ke(d32, f) && // Make sure animatingRect is on line between toRect & fromRect
        (b22.top - f.top) / (b22.left - f.left) === (d32.top - f.top) / (d32.left - f.left) && (s32 = Yn(b22, m32, y32, r.options)), Ke(f, d32) || (u22.prevFromRect = d32, u22.prevToRect = f, s32 || (s32 = r.options.animation), r.animate(u22, b22, f, s32)), s32 && (i22 = true, a32 = Math.max(a32, s32), clearTimeout(u22.animationResetTimer), u22.animationResetTimer = setTimeout(function() {
          u22.animationTime = 0, u22.prevFromRect = null, u22.fromRect = null, u22.prevToRect = null, u22.thisAnimationDuration = null;
        }, s32), u22.thisAnimationDuration = s32);
      }), clearTimeout(e22), i22 ? e22 = setTimeout(function() {
        typeof o == "function" && o();
      }, a32) : typeof o == "function" && o(), t22 = [];
    },
    animate: function(o, r, i22, a32) {
      if (a32) {
        h32(o, "transition", ""), h32(o, "transform", "");
        var l = ye(this.el), s32 = l && l.a, u22 = l && l.d, d32 = (r.left - i22.left) / (s32 || 1), f = (r.top - i22.top) / (u22 || 1);
        o.animatingX = !!d32, o.animatingY = !!f, h32(o, "transform", "translate3d(" + d32 + "px," + f + "px,0)"), this.forRepaintDummy = Xn(o), h32(o, "transition", "transform " + a32 + "ms" + (this.options.easing ? " " + this.options.easing : "")), h32(o, "transform", "translate3d(0,0,0)"), typeof o.animated == "number" && clearTimeout(o.animated), o.animated = setTimeout(function() {
          h32(o, "transition", ""), h32(o, "transform", ""), o.animated = false, o.animatingX = false, o.animatingY = false;
        }, a32);
      }
    }
  };
}
function Xn(t22) {
  return t22.offsetWidth;
}
function Yn(t22, e22, n, o) {
  return Math.sqrt(Math.pow(e22.top - t22.top, 2) + Math.pow(e22.left - t22.left, 2)) / Math.sqrt(Math.pow(e22.top - n.top, 2) + Math.pow(e22.left - n.left, 2)) * o.animation;
}
var ge = [], Je = {
  initializeByDefault: true
}, xe = {
  mount: function(e22) {
    for (var n in Je)
      Je.hasOwnProperty(n) && !(n in e22) && (e22[n] = Je[n]);
    ge.forEach(function(o) {
      if (o.pluginName === e22.pluginName)
        throw "Sortable: Cannot mount plugin ".concat(e22.pluginName, " more than once");
    }), ge.push(e22);
  },
  pluginEvent: function(e22, n, o) {
    var r = this;
    this.eventCanceled = false, o.cancel = function() {
      r.eventCanceled = true;
    };
    var i22 = e22 + "Global";
    ge.forEach(function(a32) {
      n[a32.pluginName] && (n[a32.pluginName][i22] && n[a32.pluginName][i22](te({
        sortable: n
      }, o)), n.options[a32.pluginName] && n[a32.pluginName][e22] && n[a32.pluginName][e22](te({
        sortable: n
      }, o)));
    });
  },
  initializePlugins: function(e22, n, o, r) {
    ge.forEach(function(l) {
      var s32 = l.pluginName;
      if (!(!e22.options[s32] && !l.initializeByDefault)) {
        var u22 = new l(e22, n, e22.options);
        u22.sortable = e22, u22.options = e22.options, e22[s32] = u22, re(o, u22.defaults);
      }
    });
    for (var i22 in e22.options)
      if (e22.options.hasOwnProperty(i22)) {
        var a32 = this.modifyOption(e22, i22, e22.options[i22]);
        typeof a32 != "undefined" && (e22.options[i22] = a32);
      }
  },
  getEventProperties: function(e22, n) {
    var o = {};
    return ge.forEach(function(r) {
      typeof r.eventProperties == "function" && re(o, r.eventProperties.call(n[r.pluginName], e22));
    }), o;
  },
  modifyOption: function(e22, n, o) {
    var r;
    return ge.forEach(function(i22) {
      e22[i22.pluginName] && i22.optionListeners && typeof i22.optionListeners[n] == "function" && (r = i22.optionListeners[n].call(e22[i22.pluginName], o));
    }), r;
  }
};
function Bn(t22) {
  var e22 = t22.sortable, n = t22.rootEl, o = t22.name, r = t22.targetEl, i22 = t22.cloneEl, a32 = t22.toEl, l = t22.fromEl, s32 = t22.oldIndex, u22 = t22.newIndex, d32 = t22.oldDraggableIndex, f = t22.newDraggableIndex, m32 = t22.originalEvent, y32 = t22.putSortable, b22 = t22.extraEventProperties;
  if (e22 = e22 || n && n[q22], !!e22) {
    var E22, k22 = e22.options, H32 = "on" + o.charAt(0).toUpperCase() + o.substr(1);
    window.CustomEvent && !ie && !Ae ? E22 = new CustomEvent(o, {
      bubbles: true,
      cancelable: true
    }) : (E22 = document.createEvent("Event"), E22.initEvent(o, true, true)), E22.to = a32 || n, E22.from = l || n, E22.item = r || n, E22.clone = i22, E22.oldIndex = s32, E22.newIndex = u22, E22.oldDraggableIndex = d32, E22.newDraggableIndex = f, E22.originalEvent = m32, E22.pullMode = y32 ? y32.lastPutMode : void 0;
    var F = te(te({}, b22), xe.getEventProperties(o, e22));
    for (var x22 in F)
      E22[x22] = F[x22];
    n && n.dispatchEvent(E22), k22[H32] && k22[H32].call(e22, E22);
  }
}
var kn = ["evt"], G22 = function(e22, n) {
  var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = o.evt, i22 = An(o, kn);
  xe.pluginEvent.bind(p)(e22, n, te({
    dragEl: c22,
    parentEl: A,
    ghostEl: g,
    rootEl: T22,
    nextEl: pe,
    lastDownEl: Ye,
    cloneEl: O22,
    cloneHidden: se,
    dragStarted: Ee,
    putSortable: R22,
    activeSortable: p.active,
    originalEvent: r,
    oldIndex: be,
    oldDraggableIndex: Ce,
    newIndex: $,
    newDraggableIndex: le,
    hideGhostForTarget: Kt,
    unhideGhostForTarget: Jt,
    cloneNowHidden: function() {
      se = true;
    },
    cloneNowShown: function() {
      se = false;
    },
    dispatchSortableEvent: function(l) {
      W({
        sortable: n,
        name: l,
        originalEvent: r
      });
    }
  }, i22));
};
function W(t22) {
  Bn(te({
    putSortable: R22,
    cloneEl: O22,
    targetEl: c22,
    rootEl: T22,
    oldIndex: be,
    oldDraggableIndex: Ce,
    newIndex: $,
    newDraggableIndex: le
  }, t22));
}
var c22, A, g, T22, pe, Ye, O22, se, be, $, Ce, le, Pe, R22, ve = false, We = false, Ge = [], de, J, Ze, Qe, xt, Nt, Ee, me, Oe, Ie = false, Me = false, Be, B22, et = [], at = false, je = [], Ue = typeof document != "undefined", Fe = kt, Pt = Ae || ie ? "cssFloat" : "float", Hn = Ue && !Ht && !kt && "draggable" in document.createElement("div"), Vt = function() {
  if (Ue) {
    if (ie)
      return false;
    var t22 = document.createElement("x");
    return t22.style.cssText = "pointer-events:auto", t22.style.pointerEvents === "auto";
  }
}(), $t = function(e22, n) {
  var o = h32(e22), r = parseInt(o.width) - parseInt(o.paddingLeft) - parseInt(o.paddingRight) - parseInt(o.borderLeftWidth) - parseInt(o.borderRightWidth), i22 = we(e22, 0, n), a32 = we(e22, 1, n), l = i22 && h32(i22), s32 = a32 && h32(a32), u22 = l && parseInt(l.marginLeft) + parseInt(l.marginRight) + M32(i22).width, d32 = s32 && parseInt(s32.marginLeft) + parseInt(s32.marginRight) + M32(a32).width;
  if (o.display === "flex")
    return o.flexDirection === "column" || o.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  if (o.display === "grid")
    return o.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  if (i22 && l.float && l.float !== "none") {
    var f = l.float === "left" ? "left" : "right";
    return a32 && (s32.clear === "both" || s32.clear === f) ? "vertical" : "horizontal";
  }
  return i22 && (l.display === "block" || l.display === "flex" || l.display === "table" || l.display === "grid" || u22 >= r && o[Pt] === "none" || a32 && o[Pt] === "none" && u22 + d32 > r) ? "vertical" : "horizontal";
}, Ln = function(e22, n, o) {
  var r = o ? e22.left : e22.top, i22 = o ? e22.right : e22.bottom, a32 = o ? e22.width : e22.height, l = o ? n.left : n.top, s32 = o ? n.right : n.bottom, u22 = o ? n.width : n.height;
  return r === l || i22 === s32 || r + a32 / 2 === l + u22 / 2;
}, Wn = function(e22, n) {
  var o;
  return Ge.some(function(r) {
    var i22 = r[q22].options.emptyInsertThreshold;
    if (!(!i22 || dt(r))) {
      var a32 = M32(r), l = e22 >= a32.left - i22 && e22 <= a32.right + i22, s32 = n >= a32.top - i22 && n <= a32.bottom + i22;
      if (l && s32)
        return o = r;
    }
  }), o;
}, qt = function(e22) {
  function n(i22, a32) {
    return function(l, s32, u22, d32) {
      var f = l.options.group.name && s32.options.group.name && l.options.group.name === s32.options.group.name;
      if (i22 == null && (a32 || f))
        return true;
      if (i22 == null || i22 === false)
        return false;
      if (a32 && i22 === "clone")
        return i22;
      if (typeof i22 == "function")
        return n(i22(l, s32, u22, d32), a32)(l, s32, u22, d32);
      var m32 = (a32 ? l : s32).options.group.name;
      return i22 === true || typeof i22 == "string" && i22 === m32 || i22.join && i22.indexOf(m32) > -1;
    };
  }
  var o = {}, r = e22.group;
  (!r || Xe(r) != "object") && (r = {
    name: r
  }), o.name = r.name, o.checkPull = n(r.pull, true), o.checkPut = n(r.put), o.revertClone = r.revertClone, e22.group = o;
}, Kt = function() {
  !Vt && g && h32(g, "display", "none");
}, Jt = function() {
  !Vt && g && h32(g, "display", "");
};
Ue && !Ht && document.addEventListener("click", function(t22) {
  if (We)
    return t22.preventDefault(), t22.stopPropagation && t22.stopPropagation(), t22.stopImmediatePropagation && t22.stopImmediatePropagation(), We = false, false;
}, true);
var he = function(e22) {
  if (c22) {
    e22 = e22.touches ? e22.touches[0] : e22;
    var n = Wn(e22.clientX, e22.clientY);
    if (n) {
      var o = {};
      for (var r in e22)
        e22.hasOwnProperty(r) && (o[r] = e22[r]);
      o.target = o.rootEl = n, o.preventDefault = void 0, o.stopPropagation = void 0, n[q22]._onDragOver(o);
    }
  }
}, Gn = function(e22) {
  c22 && c22.parentNode[q22]._isOutsideThisEl(e22.target);
};
function p(t22, e22) {
  if (!(t22 && t22.nodeType && t22.nodeType === 1))
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(t22));
  this.el = t22, this.options = e22 = re({}, e22), t22[q22] = this;
  var n = {
    group: null,
    sort: true,
    disabled: false,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(t22.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: false,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: true,
    direction: function() {
      return $t(t22, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: true,
    animation: 0,
    easing: null,
    setData: function(a32, l) {
      a32.setData("Text", l.textContent);
    },
    dropBubble: false,
    dragoverBubble: false,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: false,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: false,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: false,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: p.supportPointer !== false && "PointerEvent" in window && !_e,
    emptyInsertThreshold: 5
  };
  xe.initializePlugins(this, t22, n);
  for (var o in n)
    !(o in e22) && (e22[o] = n[o]);
  qt(e22);
  for (var r in this)
    r.charAt(0) === "_" && typeof this[r] == "function" && (this[r] = this[r].bind(this));
  this.nativeDraggable = e22.forceFallback ? false : Hn, this.nativeDraggable && (this.options.touchStartThreshold = 1), e22.supportPointer ? D22(t22, "pointerdown", this._onTapStart) : (D22(t22, "mousedown", this._onTapStart), D22(t22, "touchstart", this._onTapStart)), this.nativeDraggable && (D22(t22, "dragover", this), D22(t22, "dragenter", this)), Ge.push(this.el), e22.store && e22.store.get && this.sort(e22.store.get(this) || []), re(this, Rn());
}
p.prototype = /** @lends Sortable.prototype */
{
  constructor: p,
  _isOutsideThisEl: function(e22) {
    !this.el.contains(e22) && e22 !== this.el && (me = null);
  },
  _getDirection: function(e22, n) {
    return typeof this.options.direction == "function" ? this.options.direction.call(this, e22, n, c22) : this.options.direction;
  },
  _onTapStart: function(e22) {
    if (e22.cancelable) {
      var n = this, o = this.el, r = this.options, i22 = r.preventOnFilter, a32 = e22.type, l = e22.touches && e22.touches[0] || e22.pointerType && e22.pointerType === "touch" && e22, s32 = (l || e22).target, u22 = e22.target.shadowRoot && (e22.path && e22.path[0] || e22.composedPath && e22.composedPath()[0]) || s32, d32 = r.filter;
      if (Jn(o), !c22 && !(/mousedown|pointerdown/.test(a32) && e22.button !== 0 || r.disabled) && !u22.isContentEditable && !(!this.nativeDraggable && _e && s32 && s32.tagName.toUpperCase() === "SELECT") && (s32 = Z(s32, r.draggable, o, false), !(s32 && s32.animated) && Ye !== s32)) {
        if (be = K22(s32), Ce = K22(s32, r.draggable), typeof d32 == "function") {
          if (d32.call(this, e22, s32, this)) {
            W({
              sortable: n,
              rootEl: u22,
              name: "filter",
              targetEl: s32,
              toEl: o,
              fromEl: o
            }), G22("filter", n, {
              evt: e22
            }), i22 && e22.cancelable && e22.preventDefault();
            return;
          }
        } else if (d32 && (d32 = d32.split(",").some(function(f) {
          if (f = Z(u22, f.trim(), o, false), f)
            return W({
              sortable: n,
              rootEl: f,
              name: "filter",
              targetEl: s32,
              fromEl: o,
              toEl: o
            }), G22("filter", n, {
              evt: e22
            }), true;
        }), d32)) {
          i22 && e22.cancelable && e22.preventDefault();
          return;
        }
        r.handle && !Z(u22, r.handle, o, false) || this._prepareDragStart(e22, l, s32);
      }
    }
  },
  _prepareDragStart: function(e22, n, o) {
    var r = this, i22 = r.el, a32 = r.options, l = i22.ownerDocument, s32;
    if (o && !c22 && o.parentNode === i22) {
      var u22 = M32(o);
      if (T22 = i22, c22 = o, A = c22.parentNode, pe = c22.nextSibling, Ye = o, Pe = a32.group, p.dragged = c22, de = {
        target: c22,
        clientX: (n || e22).clientX,
        clientY: (n || e22).clientY
      }, xt = de.clientX - u22.left, Nt = de.clientY - u22.top, this._lastX = (n || e22).clientX, this._lastY = (n || e22).clientY, c22.style["will-change"] = "all", s32 = function() {
        if (G22("delayEnded", r, {
          evt: e22
        }), p.eventCanceled) {
          r._onDrop();
          return;
        }
        r._disableDelayedDragEvents(), !Ct && r.nativeDraggable && (c22.draggable = true), r._triggerDragStart(e22, n), W({
          sortable: r,
          name: "choose",
          originalEvent: e22
        }), V(c22, a32.chosenClass, true);
      }, a32.ignore.split(",").forEach(function(d32) {
        Wt(c22, d32.trim(), tt);
      }), D22(l, "dragover", he), D22(l, "mousemove", he), D22(l, "touchmove", he), D22(l, "mouseup", r._onDrop), D22(l, "touchend", r._onDrop), D22(l, "touchcancel", r._onDrop), Ct && this.nativeDraggable && (this.options.touchStartThreshold = 4, c22.draggable = true), G22("delayStart", this, {
        evt: e22
      }), a32.delay && (!a32.delayOnTouchOnly || n) && (!this.nativeDraggable || !(Ae || ie))) {
        if (p.eventCanceled) {
          this._onDrop();
          return;
        }
        D22(l, "mouseup", r._disableDelayedDrag), D22(l, "touchend", r._disableDelayedDrag), D22(l, "touchcancel", r._disableDelayedDrag), D22(l, "mousemove", r._delayedDragTouchMoveHandler), D22(l, "touchmove", r._delayedDragTouchMoveHandler), a32.supportPointer && D22(l, "pointermove", r._delayedDragTouchMoveHandler), r._dragStartTimer = setTimeout(s32, a32.delay);
      } else
        s32();
    }
  },
  _delayedDragTouchMoveHandler: function(e22) {
    var n = e22.touches ? e22.touches[0] : e22;
    Math.max(Math.abs(n.clientX - this._lastX), Math.abs(n.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
  },
  _disableDelayedDrag: function() {
    c22 && tt(c22), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function() {
    var e22 = this.el.ownerDocument;
    S32(e22, "mouseup", this._disableDelayedDrag), S32(e22, "touchend", this._disableDelayedDrag), S32(e22, "touchcancel", this._disableDelayedDrag), S32(e22, "mousemove", this._delayedDragTouchMoveHandler), S32(e22, "touchmove", this._delayedDragTouchMoveHandler), S32(e22, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function(e22, n) {
    n = n || e22.pointerType == "touch" && e22, !this.nativeDraggable || n ? this.options.supportPointer ? D22(document, "pointermove", this._onTouchMove) : n ? D22(document, "touchmove", this._onTouchMove) : D22(document, "mousemove", this._onTouchMove) : (D22(c22, "dragend", this), D22(T22, "dragstart", this._onDragStart));
    try {
      document.selection ? ke(function() {
        document.selection.empty();
      }) : window.getSelection().removeAllRanges();
    } catch (o) {
    }
  },
  _dragStarted: function(e22, n) {
    if (ve = false, T22 && c22) {
      G22("dragStarted", this, {
        evt: n
      }), this.nativeDraggable && D22(document, "dragover", Gn);
      var o = this.options;
      !e22 && V(c22, o.dragClass, false), V(c22, o.ghostClass, true), p.active = this, e22 && this._appendGhost(), W({
        sortable: this,
        name: "start",
        originalEvent: n
      });
    } else
      this._nulling();
  },
  _emulateDragOver: function() {
    if (J) {
      this._lastX = J.clientX, this._lastY = J.clientY, Kt();
      for (var e22 = document.elementFromPoint(J.clientX, J.clientY), n = e22; e22 && e22.shadowRoot && (e22 = e22.shadowRoot.elementFromPoint(J.clientX, J.clientY), e22 !== n); )
        n = e22;
      if (c22.parentNode[q22]._isOutsideThisEl(e22), n)
        do {
          if (n[q22]) {
            var o = void 0;
            if (o = n[q22]._onDragOver({
              clientX: J.clientX,
              clientY: J.clientY,
              target: e22,
              rootEl: n
            }), o && !this.options.dragoverBubble)
              break;
          }
          e22 = n;
        } while (n = n.parentNode);
      Jt();
    }
  },
  _onTouchMove: function(e22) {
    if (de) {
      var n = this.options, o = n.fallbackTolerance, r = n.fallbackOffset, i22 = e22.touches ? e22.touches[0] : e22, a32 = g && ye(g, true), l = g && a32 && a32.a, s32 = g && a32 && a32.d, u22 = Fe && B22 && At(B22), d32 = (i22.clientX - de.clientX + r.x) / (l || 1) + (u22 ? u22[0] - et[0] : 0) / (l || 1), f = (i22.clientY - de.clientY + r.y) / (s32 || 1) + (u22 ? u22[1] - et[1] : 0) / (s32 || 1);
      if (!p.active && !ve) {
        if (o && Math.max(Math.abs(i22.clientX - this._lastX), Math.abs(i22.clientY - this._lastY)) < o)
          return;
        this._onDragStart(e22, true);
      }
      if (g) {
        a32 ? (a32.e += d32 - (Ze || 0), a32.f += f - (Qe || 0)) : a32 = {
          a: 1,
          b: 0,
          c: 0,
          d: 1,
          e: d32,
          f
        };
        var m32 = "matrix(".concat(a32.a, ",").concat(a32.b, ",").concat(a32.c, ",").concat(a32.d, ",").concat(a32.e, ",").concat(a32.f, ")");
        h32(g, "webkitTransform", m32), h32(g, "mozTransform", m32), h32(g, "msTransform", m32), h32(g, "transform", m32), Ze = d32, Qe = f, J = i22;
      }
      e22.cancelable && e22.preventDefault();
    }
  },
  _appendGhost: function() {
    if (!g) {
      var e22 = this.options.fallbackOnBody ? document.body : T22, n = M32(c22, true, Fe, true, e22), o = this.options;
      if (Fe) {
        for (B22 = e22; h32(B22, "position") === "static" && h32(B22, "transform") === "none" && B22 !== document; )
          B22 = B22.parentNode;
        B22 !== document.body && B22 !== document.documentElement ? (B22 === document && (B22 = ee()), n.top += B22.scrollTop, n.left += B22.scrollLeft) : B22 = ee(), et = At(B22);
      }
      g = c22.cloneNode(true), V(g, o.ghostClass, false), V(g, o.fallbackClass, true), V(g, o.dragClass, true), h32(g, "transition", ""), h32(g, "transform", ""), h32(g, "box-sizing", "border-box"), h32(g, "margin", 0), h32(g, "top", n.top), h32(g, "left", n.left), h32(g, "width", n.width), h32(g, "height", n.height), h32(g, "opacity", "0.8"), h32(g, "position", Fe ? "absolute" : "fixed"), h32(g, "zIndex", "100000"), h32(g, "pointerEvents", "none"), p.ghost = g, e22.appendChild(g), h32(g, "transform-origin", xt / parseInt(g.style.width) * 100 + "% " + Nt / parseInt(g.style.height) * 100 + "%");
    }
  },
  _onDragStart: function(e22, n) {
    var o = this, r = e22.dataTransfer, i22 = o.options;
    if (G22("dragStart", this, {
      evt: e22
    }), p.eventCanceled) {
      this._onDrop();
      return;
    }
    G22("setupClone", this), p.eventCanceled || (O22 = zt(c22), O22.removeAttribute("id"), O22.draggable = false, O22.style["will-change"] = "", this._hideClone(), V(O22, this.options.chosenClass, false), p.clone = O22), o.cloneId = ke(function() {
      G22("clone", o), !p.eventCanceled && (o.options.removeCloneOnHide || T22.insertBefore(O22, c22), o._hideClone(), W({
        sortable: o,
        name: "clone"
      }));
    }), !n && V(c22, i22.dragClass, true), n ? (We = true, o._loopId = setInterval(o._emulateDragOver, 50)) : (S32(document, "mouseup", o._onDrop), S32(document, "touchend", o._onDrop), S32(document, "touchcancel", o._onDrop), r && (r.effectAllowed = "move", i22.setData && i22.setData.call(o, r, c22)), D22(document, "drop", o), h32(c22, "transform", "translateZ(0)")), ve = true, o._dragStartId = ke(o._dragStarted.bind(o, n, e22)), D22(document, "selectstart", o), Ee = true, _e && h32(document.body, "user-select", "none");
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function(e22) {
    var n = this.el, o = e22.target, r, i22, a32, l = this.options, s32 = l.group, u22 = p.active, d32 = Pe === s32, f = l.sort, m32 = R22 || u22, y32, b22 = this, E22 = false;
    if (at)
      return;
    function k22(ce, nn) {
      G22(ce, b22, te({
        evt: e22,
        isOwner: d32,
        axis: y32 ? "vertical" : "horizontal",
        revert: a32,
        dragRect: r,
        targetRect: i22,
        canSort: f,
        fromSortable: m32,
        target: o,
        completed: F,
        onMove: function(gt, on) {
          return Re(T22, n, c22, r, gt, M32(gt), e22, on);
        },
        changed: x22
      }, nn));
    }
    function H32() {
      k22("dragOverAnimationCapture"), b22.captureAnimationState(), b22 !== m32 && m32.captureAnimationState();
    }
    function F(ce) {
      return k22("dragOverCompleted", {
        insertion: ce
      }), ce && (d32 ? u22._hideClone() : u22._showClone(b22), b22 !== m32 && (V(c22, R22 ? R22.options.ghostClass : u22.options.ghostClass, false), V(c22, l.ghostClass, true)), R22 !== b22 && b22 !== p.active ? R22 = b22 : b22 === p.active && R22 && (R22 = null), m32 === b22 && (b22._ignoreWhileAnimating = o), b22.animateAll(function() {
        k22("dragOverAnimationComplete"), b22._ignoreWhileAnimating = null;
      }), b22 !== m32 && (m32.animateAll(), m32._ignoreWhileAnimating = null)), (o === c22 && !c22.animated || o === n && !o.animated) && (me = null), !l.dragoverBubble && !e22.rootEl && o !== document && (c22.parentNode[q22]._isOutsideThisEl(e22.target), !ce && he(e22)), !l.dragoverBubble && e22.stopPropagation && e22.stopPropagation(), E22 = true;
    }
    function x22() {
      $ = K22(c22), le = K22(c22, l.draggable), W({
        sortable: b22,
        name: "change",
        toEl: n,
        newIndex: $,
        newDraggableIndex: le,
        originalEvent: e22
      });
    }
    if (e22.preventDefault !== void 0 && e22.cancelable && e22.preventDefault(), o = Z(o, l.draggable, n, true), k22("dragOver"), p.eventCanceled)
      return E22;
    if (c22.contains(e22.target) || o.animated && o.animatingX && o.animatingY || b22._ignoreWhileAnimating === o)
      return F(false);
    if (We = false, u22 && !l.disabled && (d32 ? f || (a32 = A !== T22) : R22 === this || (this.lastPutMode = Pe.checkPull(this, u22, c22, e22)) && s32.checkPut(this, u22, c22, e22))) {
      if (y32 = this._getDirection(e22, o) === "vertical", r = M32(c22), k22("dragOverValid"), p.eventCanceled)
        return E22;
      if (a32)
        return A = T22, H32(), this._hideClone(), k22("revert"), p.eventCanceled || (pe ? T22.insertBefore(c22, pe) : T22.appendChild(c22)), F(true);
      var L22 = dt(n, l.draggable);
      if (!L22 || Vn(e22, y32, this) && !L22.animated) {
        if (L22 === c22)
          return F(false);
        if (L22 && n === e22.target && (o = L22), o && (i22 = M32(o)), Re(T22, n, c22, r, o, i22, e22, !!o) !== false)
          return H32(), L22 && L22.nextSibling ? n.insertBefore(c22, L22.nextSibling) : n.appendChild(c22), A = n, x22(), F(true);
      } else if (L22 && Un(e22, y32, this)) {
        var ne = we(n, 0, l, true);
        if (ne === c22)
          return F(false);
        if (o = ne, i22 = M32(o), Re(T22, n, c22, r, o, i22, e22, false) !== false)
          return H32(), n.insertBefore(c22, ne), A = n, x22(), F(true);
      } else if (o.parentNode === n) {
        i22 = M32(o);
        var j = 0, Q22, v = c22.parentNode !== n, w22 = !Ln(c22.animated && c22.toRect || r, o.animated && o.toRect || i22, y32), N = y32 ? "top" : "left", I22 = It(o, "top", "top") || It(c22, "top", "top"), _ = I22 ? I22.scrollTop : void 0;
        me !== o && (Q22 = i22[N], Ie = false, Me = !w22 && l.invertSwap || v), j = $n(e22, o, i22, y32, w22 ? 1 : l.swapThreshold, l.invertedSwapThreshold == null ? l.swapThreshold : l.invertedSwapThreshold, Me, me === o);
        var C;
        if (j !== 0) {
          var X22 = K22(c22);
          do
            X22 -= j, C = A.children[X22];
          while (C && (h32(C, "display") === "none" || C === g));
        }
        if (j === 0 || C === o)
          return F(false);
        me = o, Oe = j;
        var Y22 = o.nextElementSibling, z22 = false;
        z22 = j === 1;
        var ae = Re(T22, n, c22, r, o, i22, e22, z22);
        if (ae !== false)
          return (ae === 1 || ae === -1) && (z22 = ae === 1), at = true, setTimeout(zn, 30), H32(), z22 && !Y22 ? n.appendChild(c22) : o.parentNode.insertBefore(c22, z22 ? Y22 : o), I22 && jt(I22, 0, _ - I22.scrollTop), A = c22.parentNode, Q22 !== void 0 && !Me && (Be = Math.abs(Q22 - M32(o)[N])), x22(), F(true);
      }
      if (n.contains(c22))
        return F(false);
    }
    return false;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function() {
    S32(document, "mousemove", this._onTouchMove), S32(document, "touchmove", this._onTouchMove), S32(document, "pointermove", this._onTouchMove), S32(document, "dragover", he), S32(document, "mousemove", he), S32(document, "touchmove", he);
  },
  _offUpEvents: function() {
    var e22 = this.el.ownerDocument;
    S32(e22, "mouseup", this._onDrop), S32(e22, "touchend", this._onDrop), S32(e22, "pointerup", this._onDrop), S32(e22, "touchcancel", this._onDrop), S32(document, "selectstart", this);
  },
  _onDrop: function(e22) {
    var n = this.el, o = this.options;
    if ($ = K22(c22), le = K22(c22, o.draggable), G22("drop", this, {
      evt: e22
    }), A = c22 && c22.parentNode, $ = K22(c22), le = K22(c22, o.draggable), p.eventCanceled) {
      this._nulling();
      return;
    }
    ve = false, Me = false, Ie = false, clearInterval(this._loopId), clearTimeout(this._dragStartTimer), lt(this.cloneId), lt(this._dragStartId), this.nativeDraggable && (S32(document, "drop", this), S32(n, "dragstart", this._onDragStart)), this._offMoveEvents(), this._offUpEvents(), _e && h32(document.body, "user-select", ""), h32(c22, "transform", ""), e22 && (Ee && (e22.cancelable && e22.preventDefault(), !o.dropBubble && e22.stopPropagation()), g && g.parentNode && g.parentNode.removeChild(g), (T22 === A || R22 && R22.lastPutMode !== "clone") && O22 && O22.parentNode && O22.parentNode.removeChild(O22), c22 && (this.nativeDraggable && S32(c22, "dragend", this), tt(c22), c22.style["will-change"] = "", Ee && !ve && V(c22, R22 ? R22.options.ghostClass : this.options.ghostClass, false), V(c22, this.options.chosenClass, false), W({
      sortable: this,
      name: "unchoose",
      toEl: A,
      newIndex: null,
      newDraggableIndex: null,
      originalEvent: e22
    }), T22 !== A ? ($ >= 0 && (W({
      rootEl: A,
      name: "add",
      toEl: A,
      fromEl: T22,
      originalEvent: e22
    }), W({
      sortable: this,
      name: "remove",
      toEl: A,
      originalEvent: e22
    }), W({
      rootEl: A,
      name: "sort",
      toEl: A,
      fromEl: T22,
      originalEvent: e22
    }), W({
      sortable: this,
      name: "sort",
      toEl: A,
      originalEvent: e22
    })), R22 && R22.save()) : $ !== be && $ >= 0 && (W({
      sortable: this,
      name: "update",
      toEl: A,
      originalEvent: e22
    }), W({
      sortable: this,
      name: "sort",
      toEl: A,
      originalEvent: e22
    })), p.active && (($ == null || $ === -1) && ($ = be, le = Ce), W({
      sortable: this,
      name: "end",
      toEl: A,
      originalEvent: e22
    }), this.save()))), this._nulling();
  },
  _nulling: function() {
    G22("nulling", this), T22 = c22 = A = g = pe = O22 = Ye = se = de = J = Ee = $ = le = be = Ce = me = Oe = R22 = Pe = p.dragged = p.ghost = p.clone = p.active = null, je.forEach(function(e22) {
      e22.checked = true;
    }), je.length = Ze = Qe = 0;
  },
  handleEvent: function(e22) {
    switch (e22.type) {
      case "drop":
      case "dragend":
        this._onDrop(e22);
        break;
      case "dragenter":
      case "dragover":
        c22 && (this._onDragOver(e22), jn(e22));
        break;
      case "selectstart":
        e22.preventDefault();
        break;
    }
  },
  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function() {
    for (var e22 = [], n, o = this.el.children, r = 0, i22 = o.length, a32 = this.options; r < i22; r++)
      n = o[r], Z(n, a32.draggable, this.el, false) && e22.push(n.getAttribute(a32.dataIdAttr) || Kn(n));
    return e22;
  },
  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function(e22, n) {
    var o = {}, r = this.el;
    this.toArray().forEach(function(i22, a32) {
      var l = r.children[a32];
      Z(l, this.options.draggable, r, false) && (o[i22] = l);
    }, this), n && this.captureAnimationState(), e22.forEach(function(i22) {
      o[i22] && (r.removeChild(o[i22]), r.appendChild(o[i22]));
    }), n && this.animateAll();
  },
  /**
   * Save the current sorting
   */
  save: function() {
    var e22 = this.options.store;
    e22 && e22.set && e22.set(this);
  },
  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function(e22, n) {
    return Z(e22, n || this.options.draggable, this.el, false);
  },
  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function(e22, n) {
    var o = this.options;
    if (n === void 0)
      return o[e22];
    var r = xe.modifyOption(this, e22, n);
    typeof r != "undefined" ? o[e22] = r : o[e22] = n, e22 === "group" && qt(o);
  },
  /**
   * Destroy
   */
  destroy: function() {
    G22("destroy", this);
    var e22 = this.el;
    e22[q22] = null, S32(e22, "mousedown", this._onTapStart), S32(e22, "touchstart", this._onTapStart), S32(e22, "pointerdown", this._onTapStart), this.nativeDraggable && (S32(e22, "dragover", this), S32(e22, "dragenter", this)), Array.prototype.forEach.call(e22.querySelectorAll("[draggable]"), function(n) {
      n.removeAttribute("draggable");
    }), this._onDrop(), this._disableDelayedDragEvents(), Ge.splice(Ge.indexOf(this.el), 1), this.el = e22 = null;
  },
  _hideClone: function() {
    if (!se) {
      if (G22("hideClone", this), p.eventCanceled)
        return;
      h32(O22, "display", "none"), this.options.removeCloneOnHide && O22.parentNode && O22.parentNode.removeChild(O22), se = true;
    }
  },
  _showClone: function(e22) {
    if (e22.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (se) {
      if (G22("showClone", this), p.eventCanceled)
        return;
      c22.parentNode == T22 && !this.options.group.revertClone ? T22.insertBefore(O22, c22) : pe ? T22.insertBefore(O22, pe) : T22.appendChild(O22), this.options.group.revertClone && this.animate(c22, O22), h32(O22, "display", ""), se = false;
    }
  }
};
function jn(t22) {
  t22.dataTransfer && (t22.dataTransfer.dropEffect = "move"), t22.cancelable && t22.preventDefault();
}
function Re(t22, e22, n, o, r, i22, a32, l) {
  var s32, u22 = t22[q22], d32 = u22.options.onMove, f;
  return window.CustomEvent && !ie && !Ae ? s32 = new CustomEvent("move", {
    bubbles: true,
    cancelable: true
  }) : (s32 = document.createEvent("Event"), s32.initEvent("move", true, true)), s32.to = e22, s32.from = t22, s32.dragged = n, s32.draggedRect = o, s32.related = r || e22, s32.relatedRect = i22 || M32(e22), s32.willInsertAfter = l, s32.originalEvent = a32, t22.dispatchEvent(s32), d32 && (f = d32.call(u22, s32, a32)), f;
}
function tt(t22) {
  t22.draggable = false;
}
function zn() {
  at = false;
}
function Un(t22, e22, n) {
  var o = M32(we(n.el, 0, n.options, true)), r = Ut(n.el, n.options, g), i22 = 10;
  return e22 ? t22.clientX < r.left - i22 || t22.clientY < o.top && t22.clientX < o.right : t22.clientY < r.top - i22 || t22.clientY < o.bottom && t22.clientX < o.left;
}
function Vn(t22, e22, n) {
  var o = M32(dt(n.el, n.options.draggable)), r = Ut(n.el, n.options, g), i22 = 10;
  return e22 ? t22.clientX > r.right + i22 || t22.clientY > o.bottom && t22.clientX > o.left : t22.clientY > r.bottom + i22 || t22.clientX > o.right && t22.clientY > o.top;
}
function $n(t22, e22, n, o, r, i22, a32, l) {
  var s32 = o ? t22.clientY : t22.clientX, u22 = o ? n.height : n.width, d32 = o ? n.top : n.left, f = o ? n.bottom : n.right, m32 = false;
  if (!a32) {
    if (l && Be < u22 * r) {
      if (!Ie && (Oe === 1 ? s32 > d32 + u22 * i22 / 2 : s32 < f - u22 * i22 / 2) && (Ie = true), Ie)
        m32 = true;
      else if (Oe === 1 ? s32 < d32 + Be : s32 > f - Be)
        return -Oe;
    } else if (s32 > d32 + u22 * (1 - r) / 2 && s32 < f - u22 * (1 - r) / 2)
      return qn(e22);
  }
  return m32 = m32 || a32, m32 && (s32 < d32 + u22 * i22 / 2 || s32 > f - u22 * i22 / 2) ? s32 > d32 + u22 / 2 ? 1 : -1 : 0;
}
function qn(t22) {
  return K22(c22) < K22(t22) ? 1 : -1;
}
function Kn(t22) {
  for (var e22 = t22.tagName + t22.className + t22.src + t22.href + t22.textContent, n = e22.length, o = 0; n--; )
    o += e22.charCodeAt(n);
  return o.toString(36);
}
function Jn(t22) {
  je.length = 0;
  for (var e22 = t22.getElementsByTagName("input"), n = e22.length; n--; ) {
    var o = e22[n];
    o.checked && je.push(o);
  }
}
function ke(t22) {
  return setTimeout(t22, 0);
}
function lt(t22) {
  return clearTimeout(t22);
}
Ue && D22(document, "touchmove", function(t22) {
  (p.active || ve) && t22.cancelable && t22.preventDefault();
});
p.utils = {
  on: D22,
  off: S32,
  css: h32,
  find: Wt,
  is: function(e22, n) {
    return !!Z(e22, n, e22, false);
  },
  extend: Mn,
  throttle: Gt,
  closest: Z,
  toggleClass: V,
  clone: zt,
  index: K22,
  nextTick: ke,
  cancelNextTick: lt,
  detectDirection: $t,
  getChild: we
};
p.get = function(t22) {
  return t22[q22];
};
p.mount = function() {
  for (var t22 = arguments.length, e22 = new Array(t22), n = 0; n < t22; n++)
    e22[n] = arguments[n];
  e22[0].constructor === Array && (e22 = e22[0]), e22.forEach(function(o) {
    if (!o.prototype || !o.prototype.constructor)
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(o));
    o.utils && (p.utils = te(te({}, p.utils), o.utils)), xe.mount(o);
  });
};
p.create = function(t22, e22) {
  return new p(t22, e22);
};
p.version = xn;
var P = [], Se, st, ut = false, nt, ot, ze, De;
function Zn() {
  function t22() {
    this.defaults = {
      scroll: true,
      forceAutoScrollFallback: false,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: true
    };
    for (var e22 in this)
      e22.charAt(0) === "_" && typeof this[e22] == "function" && (this[e22] = this[e22].bind(this));
  }
  return t22.prototype = {
    dragStarted: function(n) {
      var o = n.originalEvent;
      this.sortable.nativeDraggable ? D22(document, "dragover", this._handleAutoScroll) : this.options.supportPointer ? D22(document, "pointermove", this._handleFallbackAutoScroll) : o.touches ? D22(document, "touchmove", this._handleFallbackAutoScroll) : D22(document, "mousemove", this._handleFallbackAutoScroll);
    },
    dragOverCompleted: function(n) {
      var o = n.originalEvent;
      !this.options.dragOverBubble && !o.rootEl && this._handleAutoScroll(o);
    },
    drop: function() {
      this.sortable.nativeDraggable ? S32(document, "dragover", this._handleAutoScroll) : (S32(document, "pointermove", this._handleFallbackAutoScroll), S32(document, "touchmove", this._handleFallbackAutoScroll), S32(document, "mousemove", this._handleFallbackAutoScroll)), Mt(), He(), Fn();
    },
    nulling: function() {
      ze = st = Se = ut = De = nt = ot = null, P.length = 0;
    },
    _handleFallbackAutoScroll: function(n) {
      this._handleAutoScroll(n, true);
    },
    _handleAutoScroll: function(n, o) {
      var r = this, i22 = (n.touches ? n.touches[0] : n).clientX, a32 = (n.touches ? n.touches[0] : n).clientY, l = document.elementFromPoint(i22, a32);
      if (ze = n, o || this.options.forceAutoScrollFallback || Ae || ie || _e) {
        rt(n, this.options, l, o);
        var s32 = ue(l, true);
        ut && (!De || i22 !== nt || a32 !== ot) && (De && Mt(), De = setInterval(function() {
          var u22 = ue(document.elementFromPoint(i22, a32), true);
          u22 !== s32 && (s32 = u22, He()), rt(n, r.options, u22, o);
        }, 10), nt = i22, ot = a32);
      } else {
        if (!this.options.bubbleScroll || ue(l, true) === ee()) {
          He();
          return;
        }
        rt(n, this.options, ue(l, false), false);
      }
    }
  }, re(t22, {
    pluginName: "scroll",
    initializeByDefault: true
  });
}
function He() {
  P.forEach(function(t22) {
    clearInterval(t22.pid);
  }), P = [];
}
function Mt() {
  clearInterval(De);
}
var rt = Gt(function(t22, e22, n, o) {
  if (e22.scroll) {
    var r = (t22.touches ? t22.touches[0] : t22).clientX, i22 = (t22.touches ? t22.touches[0] : t22).clientY, a32 = e22.scrollSensitivity, l = e22.scrollSpeed, s32 = ee(), u22 = false, d32;
    st !== n && (st = n, He(), Se = e22.scroll, d32 = e22.scrollFn, Se === true && (Se = ue(n, true)));
    var f = 0, m32 = Se;
    do {
      var y32 = m32, b22 = M32(y32), E22 = b22.top, k22 = b22.bottom, H32 = b22.left, F = b22.right, x22 = b22.width, L22 = b22.height, ne = void 0, j = void 0, Q22 = y32.scrollWidth, v = y32.scrollHeight, w22 = h32(y32), N = y32.scrollLeft, I22 = y32.scrollTop;
      y32 === s32 ? (ne = x22 < Q22 && (w22.overflowX === "auto" || w22.overflowX === "scroll" || w22.overflowX === "visible"), j = L22 < v && (w22.overflowY === "auto" || w22.overflowY === "scroll" || w22.overflowY === "visible")) : (ne = x22 < Q22 && (w22.overflowX === "auto" || w22.overflowX === "scroll"), j = L22 < v && (w22.overflowY === "auto" || w22.overflowY === "scroll"));
      var _ = ne && (Math.abs(F - r) <= a32 && N + x22 < Q22) - (Math.abs(H32 - r) <= a32 && !!N), C = j && (Math.abs(k22 - i22) <= a32 && I22 + L22 < v) - (Math.abs(E22 - i22) <= a32 && !!I22);
      if (!P[f])
        for (var X22 = 0; X22 <= f; X22++)
          P[X22] || (P[X22] = {});
      (P[f].vx != _ || P[f].vy != C || P[f].el !== y32) && (P[f].el = y32, P[f].vx = _, P[f].vy = C, clearInterval(P[f].pid), (_ != 0 || C != 0) && (u22 = true, P[f].pid = setInterval((function() {
        o && this.layer === 0 && p.active._onTouchMove(ze);
        var Y22 = P[this.layer].vy ? P[this.layer].vy * l : 0, z22 = P[this.layer].vx ? P[this.layer].vx * l : 0;
        typeof d32 == "function" && d32.call(p.dragged.parentNode[q22], z22, Y22, t22, ze, P[this.layer].el) !== "continue" || jt(P[this.layer].el, z22, Y22);
      }).bind({
        layer: f
      }), 24))), f++;
    } while (e22.bubbleScroll && m32 !== s32 && (m32 = ue(m32, false)));
    ut = u22;
  }
}, 30), Zt = function(e22) {
  var n = e22.originalEvent, o = e22.putSortable, r = e22.dragEl, i22 = e22.activeSortable, a32 = e22.dispatchSortableEvent, l = e22.hideGhostForTarget, s32 = e22.unhideGhostForTarget;
  if (n) {
    var u22 = o || i22;
    l();
    var d32 = n.changedTouches && n.changedTouches.length ? n.changedTouches[0] : n, f = document.elementFromPoint(d32.clientX, d32.clientY);
    s32(), u22 && !u22.el.contains(f) && (a32("spill"), this.onSpill({
      dragEl: r,
      putSortable: o
    }));
  }
};
function ht() {
}
ht.prototype = {
  startIndex: null,
  dragStart: function(e22) {
    var n = e22.oldDraggableIndex;
    this.startIndex = n;
  },
  onSpill: function(e22) {
    var n = e22.dragEl, o = e22.putSortable;
    this.sortable.captureAnimationState(), o && o.captureAnimationState();
    var r = we(this.sortable.el, this.startIndex, this.options);
    r ? this.sortable.el.insertBefore(n, r) : this.sortable.el.appendChild(n), this.sortable.animateAll(), o && o.animateAll();
  },
  drop: Zt
};
re(ht, {
  pluginName: "revertOnSpill"
});
function pt() {
}
pt.prototype = {
  onSpill: function(e22) {
    var n = e22.dragEl, o = e22.putSortable, r = o || this.sortable;
    r.captureAnimationState(), n.parentNode && n.parentNode.removeChild(n), r.animateAll();
  },
  drop: Zt
};
re(pt, {
  pluginName: "removeOnSpill"
});
p.mount(new Zn());
p.mount(pt, ht);
function Qn(t22) {
  return t22 == null ? t22 : JSON.parse(JSON.stringify(t22));
}
function eo(t22) {
  getCurrentInstance() && onUnmounted(t22);
}
function to(t22) {
  getCurrentInstance() ? onMounted(t22) : nextTick(t22);
}
let Qt = null, en = null;
function Ft(t22 = null, e22 = null) {
  Qt = t22, en = e22;
}
function no() {
  return {
    data: Qt,
    clonedData: en
  };
}
const Rt = Symbol("cloneElement");
function tn(...t22) {
  var j, Q22;
  const e22 = (j = getCurrentInstance()) == null ? void 0 : j.proxy;
  let n = null;
  const o = t22[0];
  let [, r, i22] = t22;
  Array.isArray(unref(r)) || (i22 = r, r = null);
  let a32 = null;
  const {
    immediate: l = true,
    clone: s32 = Qn,
    customUpdate: u22
  } = (Q22 = unref(i22)) != null ? Q22 : {};
  function d32(v) {
    var X22;
    const { from: w22, oldIndex: N, item: I22 } = v;
    n = Array.from(w22.childNodes);
    const _ = unref((X22 = unref(r)) == null ? void 0 : X22[N]), C = s32(_);
    Ft(_, C), I22[Rt] = C;
  }
  function f(v) {
    const w22 = v.item[Rt];
    if (!yn(w22)) {
      if (qe(v.item), isRef(r)) {
        const N = [...unref(r)];
        r.value = St(N, v.newDraggableIndex, w22);
        return;
      }
      St(unref(r), v.newDraggableIndex, w22);
    }
  }
  function m32(v) {
    const { from: w22, item: N, oldIndex: I22, oldDraggableIndex: _, pullMode: C, clone: X22 } = v;
    if (Dt(w22, N, I22), C === "clone") {
      qe(X22);
      return;
    }
    if (isRef(r)) {
      const Y22 = [...unref(r)];
      r.value = Et(Y22, _);
      return;
    }
    Et(unref(r), _);
  }
  function y32(v) {
    if (u22) {
      u22(v);
      return;
    }
    const { from: w22, item: N, oldIndex: I22, newIndex: _ } = v;
    if (qe(N), Dt(w22, N, I22), isRef(r)) {
      const C = [...unref(r)];
      r.value = wt(C, I22, _);
      return;
    }
    wt(unref(r), I22, _);
  }
  function b22(v) {
    const { newIndex: w22, oldIndex: N, from: I22, to: _ } = v;
    let C = null;
    const X22 = w22 === N && I22 === _;
    try {
      if (X22) {
        let Y22 = null;
        n == null || n.some((z22, ae) => {
          if (Y22 && (n == null ? void 0 : n.length) !== _.childNodes.length)
            return I22.insertBefore(Y22, z22.nextSibling), true;
          const ce = _.childNodes[ae];
          Y22 = _ == null ? void 0 : _.replaceChild(z22, ce);
        });
      }
    } catch (Y22) {
      C = Y22;
    } finally {
      n = null;
    }
    nextTick(() => {
      if (Ft(), C)
        throw C;
    });
  }
  const E22 = {
    onUpdate: y32,
    onStart: d32,
    onAdd: f,
    onRemove: m32,
    onEnd: b22
  };
  function k22(v) {
    const w22 = unref(o);
    return v || (v = wn(w22) ? En(w22, e22 == null ? void 0 : e22.$el) : w22), v && !_n(v) && (v = v.$el), v || mn("Root element not found"), v;
  }
  function H32() {
    var I22;
    const _ = (I22 = unref(i22)) != null ? I22 : {}, N = Ve(_, ["immediate", "clone"]);
    return _t(N, (C, X22) => {
      Tn(C) && (N[C] = (Y22, ...z22) => {
        const ae = no();
        return Cn(Y22, ae), X22(Y22, ...z22);
      });
    }), Dn(
      r === null ? {} : E22,
      N
    );
  }
  const F = (v) => {
    v = k22(v), a32 && x22.destroy(), a32 = new p(v, H32());
  };
  watch(
    () => i22,
    () => {
      a32 && _t(H32(), (v, w22) => {
        a32 == null || a32.option(v, w22);
      });
    },
    { deep: true }
  );
  const x22 = {
    option: (v, w22) => a32 == null ? void 0 : a32.option(v, w22),
    destroy: () => {
      a32 == null || a32.destroy(), a32 = null;
    },
    save: () => a32 == null ? void 0 : a32.save(),
    toArray: () => a32 == null ? void 0 : a32.toArray(),
    closest: (...v) => a32 == null ? void 0 : a32.closest(...v)
  }, L22 = () => x22 == null ? void 0 : x22.option("disabled", true), ne = () => x22 == null ? void 0 : x22.option("disabled", false);
  return to(() => {
    l && F();
  }), eo(x22.destroy), fe({ start: F, pause: L22, resume: ne }, x22);
}
const ct = [
  "update",
  "start",
  "add",
  "remove",
  "choose",
  "unchoose",
  "end",
  "sort",
  "filter",
  "clone",
  "move",
  "change"
], oo = [
  "clone",
  "animation",
  "ghostClass",
  "group",
  "sort",
  "disabled",
  "store",
  "handle",
  "draggable",
  "swapThreshold",
  "invertSwap",
  "invertedSwapThreshold",
  "removeCloneOnHide",
  "direction",
  "chosenClass",
  "dragClass",
  "ignore",
  "filter",
  "preventOnFilter",
  "easing",
  "setData",
  "dropBubble",
  "dragoverBubble",
  "dataIdAttr",
  "delay",
  "delayOnTouchOnly",
  "touchStartThreshold",
  "forceFallback",
  "fallbackClass",
  "fallbackOnBody",
  "fallbackTolerance",
  "fallbackOffset",
  "supportPointer",
  "emptyInsertThreshold",
  "scroll",
  "forceAutoScrollFallback",
  "scrollSensitivity",
  "scrollSpeed",
  "bubbleScroll",
  "modelValue",
  "tag",
  "target",
  "customUpdate",
  ...ct.map((t22) => `on${t22.replace(/^\S/, (e22) => e22.toUpperCase())}`)
], lo = defineComponent({
  name: "VueDraggable",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: oo,
  emits: ["update:modelValue", ...ct],
  setup(t22, { slots: e22, emit: n, expose: o, attrs: r }) {
    const i22 = ct.reduce((d32, f) => {
      const m32 = `on${f.replace(/^\S/, (y32) => y32.toUpperCase())}`;
      return d32[m32] = (...y32) => n(f, ...y32), d32;
    }, {}), a32 = computed(() => {
      const y32 = toRefs(t22), f = Ve(y32, ["modelValue"]), m32 = Object.entries(f).reduce((b22, [E22, k22]) => {
        const H32 = unref(k22);
        return H32 !== void 0 && (b22[E22] = H32), b22;
      }, {});
      return fe(fe({}, i22), bn(fe(fe({}, r), m32)));
    }), l = computed({
      get: () => t22.modelValue,
      set: (d32) => n("update:modelValue", d32)
    }), s32 = ref$1(), u22 = reactive(
      tn(t22.target || s32, l, a32)
    );
    return o(u22), () => {
      var d32;
      return h(t22.tag || "div", { ref: s32 }, (d32 = e22 == null ? void 0 : e22.default) == null ? void 0 : d32.call(e22, u22));
    };
  }
});
const __default__$4 = defineComponent({
  name: "Carousel",
  components: {
    QBtn: QBtn_default$1,
    QTabs: QTabs_default$1,
    VueDraggable: lo
  },
  inheritAttrs: false,
  props: {
    /**
     * Align content on left side
     */
    alignLeft: {
      type: Boolean,
      default: false
    },
    /**
     * Color name for component from the Quasar Color Palette
     */
    backgroundColor: {
      type: String,
      default: "white"
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Applies fix width to slide
     */
    fixedSlideWidth: {
      type: Number,
      default: void 0
    },
    /**
     * Gap between slides
     */
    gap: {
      type: Number,
      default: 16
    },
    /**
     * Array of images to render
     */
    items: {
      type: Array,
      required: true
    },
    /**
     * Max width per slide
     */
    maxWidthPerSlide: {
      type: Number,
      default: 608
    },
    /**
     * Min width per slide
     */
    minWidthPerSlide: {
      type: Number,
      default: 260
    },
    /**
     * Show / hide control buttons
     */
    showControls: {
      default: true,
      type: Boolean
    },
    /**
     * Enable drag and drop sorting of the carousel.
     * Make sure that items have id in order for it to work properly.
     */
    draggable: {
      default: false,
      type: Boolean
    },
    /**
     * When drag and drop is enabled we cant have index as key
     * because keys are not supposed to change.
     * If items array doesn't have id but something else, you can specify it in this prop.
     */
    draggableItemKey: {
      default: "id",
      type: String
    },
    /**
     * Allow single sample to use the whole space
     */
    singleSampleUsesAllSpace: {
      default: false,
      type: Boolean
    },
    /**
     * Animation duration on slide change
     */
    transitionTime: {
      type: String,
      default: "0.5s"
    }
  },
  emits: [
    /**
     * Emitted when component is resized
     *
     * @type {void}
     */
    "resize",
    /**
     * Emitted when items are reordered using draggable
     *
     * @type {object}
     */
    "reorder"
  ],
  setup(props4, { emit }) {
    const { isDark } = useDarkMode();
    const carouselObserverWidth = ref$1(0);
    const carouselRef = ref$1(null);
    const carouselWidth = ref$1(void 0);
    const currentIndex = ref$1(0);
    const justifyContent = ref$1("normal");
    const slideMaxWidth = ref$1(props4.maxWidthPerSlide);
    const slidesLeftSpace = ref$1(void 0);
    const slidesPerPage = ref$1(1);
    const slidesRef = ref$1(null);
    const slideWidth = ref$1(0);
    const draggedItem = ref$1();
    const sortedItems = computed({
      get() {
        return props4.items;
      },
      set(value2) {
        emit("reorder", value2, draggedItem.value);
      }
    });
    const hidedButtons = computed(() => slidesPerPage.value === props4.items.length);
    const disablePreviousButton = computed(() => !currentIndex.value);
    const disableNextButton = computed(() => currentIndex.value === props4.items.length - slidesPerPage.value);
    const translatePosition = computed(() => currentIndex.value * (slideWidth.value + props4.gap));
    function calcCarouselWithFixedSlides() {
      if (!carouselRef.value || !props4.fixedSlideWidth) return;
      const availableSlidesPerPage = Math.floor(
        (carouselRef.value.offsetWidth + props4.gap) / (props4.fixedSlideWidth + props4.gap)
      );
      const hasHiddenSlides = availableSlidesPerPage < props4.items.length;
      slidesPerPage.value = hasHiddenSlides ? availableSlidesPerPage : props4.items.length;
      slideWidth.value = props4.fixedSlideWidth;
      justifyContent.value = hasHiddenSlides || props4.alignLeft ? "normal" : "center";
      const freeSpace = carouselRef.value.offsetWidth - availableSlidesPerPage * slideWidth.value - props4.gap * (availableSlidesPerPage - 1);
      carouselWidth.value = hasHiddenSlides ? carouselRef.value.offsetWidth - freeSpace : void 0;
      slidesLeftSpace.value = hasHiddenSlides ? freeSpace / 2 : void 0;
    }
    function calcSlideMaxWidth() {
      if (carouselRef.value) {
        if (props4.items.length === 1 && props4.singleSampleUsesAllSpace) {
          slideMaxWidth.value = carouselRef.value.offsetWidth;
        } else {
          const maxWidth = carouselRef.value.offsetWidth / 2 - props4.gap / 2;
          slideMaxWidth.value = maxWidth >= props4.minWidthPerSlide ? maxWidth : props4.maxWidthPerSlide;
        }
      }
    }
    function calcSlideWidth() {
      if (carouselRef.value) {
        const slidesPerPageWithoutSpaces = Math.floor(carouselRef.value.offsetWidth / props4.minWidthPerSlide);
        const spacesWidth = props4.gap * (slidesPerPageWithoutSpaces - 1);
        const slidesPerPageWithSpaces = Math.floor(
          carouselRef.value.offsetWidth / (props4.minWidthPerSlide + spacesWidth)
        );
        slidesPerPage.value = slidesPerPageWithSpaces > props4.items.length ? props4.items.length : slidesPerPageWithSpaces;
        slideWidth.value = Math.floor(
          (carouselRef.value.offsetWidth - (slidesPerPage.value - 1) * props4.gap) / slidesPerPage.value
        );
      } else {
        slideWidth.value = 0;
      }
    }
    function onNext() {
      if (currentIndex.value !== props4.items.length - slidesPerPage.value) {
        currentIndex.value += 1;
      }
    }
    function onPrev() {
      if (currentIndex.value !== 0) {
        currentIndex.value -= 1;
      }
    }
    function resizeSlide(width) {
      emit("resize");
      calcSlideMaxWidth();
      if (props4.fixedSlideWidth) {
        calcCarouselWithFixedSlides();
      } else {
        calcSlideWidth();
      }
      if (!width || width !== carouselObserverWidth.value) {
        currentIndex.value = 0;
        if (width) {
          carouselObserverWidth.value = width;
        }
      }
    }
    function onStart(e22) {
      draggedItem.value = e22.data;
    }
    const resizeObserver = new ResizeObserver((entry) => {
      var _a;
      return resizeSlide((_a = entry[0]) == null ? void 0 : _a.contentRect.width);
    });
    const resizeWindowObserver = new ResizeObserver(() => resizeSlide());
    watch(() => props4.fixedSlideWidth, () => {
      resizeSlide();
    });
    watch(() => props4.items.length, () => {
      resizeSlide();
    });
    onMounted(() => {
      resizeSlide();
      resizeWindowObserver.observe(window.document.documentElement);
      carouselRef.value && resizeObserver.observe(carouselRef.value);
    });
    onUnmounted(() => {
      resizeObserver.disconnect();
      resizeWindowObserver.disconnect();
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      carouselRef,
      carouselWidth,
      currentIndex,
      disableNextButton,
      disablePreviousButton,
      hidedButtons,
      isDark,
      justifyContent,
      onNext,
      onPrev,
      onStart,
      slideMaxWidth,
      slideMinWidth: props4.fixedSlideWidth ?? props4.minWidthPerSlide,
      slidesLeftSpace,
      slidesPerPage,
      slidesRef,
      slideWidth,
      sortedItems,
      translatePosition
    };
  }
});
const __injectCSSVars__$4 = () => {
  useCssVars((_ctx) => ({
    "11d2a1f8": _ctx.justifyContent
  }));
};
const __setup__$4 = __default__$4.setup;
__default__$4.setup = __setup__$4 ? (props4, ctx) => {
  __injectCSSVars__$4();
  return __setup__$4(props4, ctx);
} : __injectCSSVars__$4;
const _hoisted_1$1d = ["data-automation"];
const _hoisted_2$_ = ["data-automation"];
const _hoisted_3$N = ["data-automation"];
const _hoisted_4$v = ["data-automation"];
const _hoisted_5$p = ["data-automation"];
function _sfc_render$1h(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_VueDraggable = resolveComponent("VueDraggable");
  const _component_QTabs = resolveComponent("QTabs");
  const _component_QBtn = resolveComponent("QBtn");
  return openBlock(), createElementBlock("div", mergeProps(_ctx.dataAttrs, {
    ref: "carouselRef",
    class: ["rv-carousel relative-position", [
      _ctx.$props.class,
      `bg-${_ctx.backgroundColor}`
    ]],
    "data-automation": _ctx.buildId()
  }), [
    createElementVNode("div", {
      class: "rv-carousel__slides relative-position",
      "data-automation": _ctx.buildId("slides"),
      style: normalizeStyle({
        ...!_ctx.alignLeft && _ctx.carouselWidth && { width: `${_ctx.carouselWidth}px` },
        ...!_ctx.alignLeft && _ctx.slidesLeftSpace && { marginLeft: `${_ctx.slidesLeftSpace}px` }
      })
    }, [
      createVNode(_component_QTabs, {
        class: "rv-carousel__tabs",
        shrink: "",
        stretch: ""
      }, {
        default: withCtx(() => [
          _ctx.draggable ? (openBlock(), createBlock(_component_VueDraggable, {
            key: 0,
            ref: "slidesRef",
            modelValue: _ctx.sortedItems,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.sortedItems = $event),
            class: "row no-wrap items-center self-stretch hide-scrollbar",
            "data-automation": _ctx.buildId("slides--draggable"),
            style: normalizeStyle({
              "transform": `translate(-${_ctx.translatePosition}px, 0)`,
              "transition": _ctx.transitionTime
            }),
            onStart: _ctx.onStart
          }, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.sortedItems, (item, index2) => {
                return openBlock(), createElementBlock("div", {
                  key: (item == null ? void 0 : item[_ctx.draggableItemKey]) ?? index2,
                  class: normalizeClass(["rv-carousel__slide rv-carousel__slide--draggable", { "rv-carousel__slide--draggable__dark": _ctx.isDark }]),
                  "data-automation": _ctx.buildId(`slide${index2}`),
                  style: normalizeStyle({
                    "margin-right": index2 === _ctx.sortedItems.length - 1 ? 0 : `${_ctx.gap}px`,
                    "max-width": `${_ctx.slideWidth ?? _ctx.slideMaxWidth}px`,
                    "min-width": `${_ctx.slideWidth ?? _ctx.slideMinWidth}px`,
                    "width": `${_ctx.slideWidth ?? _ctx.slideWidth}px`
                  })
                }, [
                  renderSlot(_ctx.$slots, "slide", {
                    index: index2,
                    item
                  }, void 0, true)
                ], 14, _hoisted_3$N);
              }), 128))
            ]),
            _: 3
          }, 8, ["modelValue", "data-automation", "style", "onStart"])) : (openBlock(), createElementBlock("div", {
            key: 1,
            ref: "slidesRef",
            class: "row no-wrap items-center self-stretch hide-scrollbar",
            style: normalizeStyle({
              "transform": `translate(-${_ctx.translatePosition}px, 0)`,
              "transition": _ctx.transitionTime
            })
          }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (item, index2) => {
              return openBlock(), createElementBlock("div", {
                key: index2,
                class: "rv-carousel__slide",
                "data-automation": _ctx.buildId(`slide${index2}`),
                style: normalizeStyle({
                  "margin-right": index2 === _ctx.items.length - 1 ? 0 : `${_ctx.gap}px`,
                  "max-width": `${_ctx.slideWidth ?? _ctx.slideMaxWidth}px`,
                  "min-width": `${_ctx.slideWidth ?? _ctx.slideMinWidth}px`,
                  "width": `${_ctx.slideWidth ?? _ctx.slideWidth}px`
                })
              }, [
                renderSlot(_ctx.$slots, "slide", {
                  index: index2,
                  item
                }, void 0, true)
              ], 12, _hoisted_4$v);
            }), 128))
          ], 4))
        ]),
        _: 3
      })
    ], 12, _hoisted_2$_),
    _ctx.showControls ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: "rv-carousel__control flex row space-between full-width",
      "data-automation": _ctx.buildId("control")
    }, [
      createVNode(_component_QBtn, {
        class: normalizeClass(["rv-carousel__button rv-carousel__button--left", {
          "hidden": _ctx.hidedButtons
        }]),
        color: "white",
        "data-automation": _ctx.buildId("prev"),
        dense: "",
        disabled: _ctx.disablePreviousButton,
        icon: "chevron_left",
        "text-color": "black-1",
        onClick: _ctx.onPrev,
        onDragover: _ctx.onPrev
      }, null, 8, ["class", "data-automation", "disabled", "onClick", "onDragover"]),
      createVNode(_component_QBtn, {
        class: normalizeClass(["rv-carousel__button rv-carousel__button--right", {
          "hidden": _ctx.hidedButtons
        }]),
        color: "white",
        "data-automation": _ctx.buildId("next"),
        dense: "",
        disabled: _ctx.disableNextButton,
        icon: "chevron_right",
        "text-color": "black-1",
        onClick: _ctx.onNext,
        onDragover: _ctx.onNext
      }, null, 8, ["class", "data-automation", "disabled", "onClick", "onDragover"])
    ], 8, _hoisted_5$p)) : createCommentVNode("", true)
  ], 16, _hoisted_1$1d);
}
const Carousel = /* @__PURE__ */ _export_sfc$1(__default__$4, [["render", _sfc_render$1h], ["__scopeId", "data-v-8ba8d529"]]);
const _hoisted_1$1c = ["data-automation", "stroke"];
const _sfc_main$1q = /* @__PURE__ */ defineComponent({
  __name: "ChartLineIndicator",
  props: {
    color: {
      required: true,
      type: String
    },
    dataAutomation: {
      default: "chart-line-indicator",
      type: String
    },
    lineStyle: {
      default: "solid",
      type: String
    }
  },
  setup(__props) {
    const props4 = __props;
    const { buildId } = useAutomation(props4.dataAutomation);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("svg", {
        class: normalizeClass(["chart-line-indicator", `chart-line-indicator--${__props.lineStyle}`]),
        "data-automation": unref(buildId)(),
        stroke: __props.color,
        viewBox: "0 0 16 2",
        xmlns: "http://www.w3.org/2000/svg"
      }, _cache[0] || (_cache[0] = [
        createElementVNode("path", { d: "M0,1 H 100" }, null, -1)
      ]), 10, _hoisted_1$1c);
    };
  }
});
const _hoisted_1$1b = ["data-automation"];
const _hoisted_2$Z = { key: 0 };
const _sfc_main$1p = /* @__PURE__ */ defineComponent({
  __name: "ChartTooltipContent",
  props: {
    dataAutomation: {
      default: "chart-tooltip-content",
      type: String
    },
    items: {
      default: void 0,
      type: Array
    }
  },
  setup(__props) {
    const props4 = __props;
    const { buildId } = useAutomation(props4.dataAutomation);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("table", {
        class: "chart-tooltip-content q-ma-none",
        "data-automation": unref(buildId)()
      }, [
        createElementVNode("tbody", null, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(__props.items, (item, itemIndex) => {
            return openBlock(), createElementBlock(Fragment, { key: itemIndex }, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(item.lines, (line, lineIndex) => {
                var _a;
                return openBlock(), createElementBlock("tr", {
                  key: `${line}-${lineIndex}`
                }, [
                  createElementVNode("td", null, [
                    lineIndex == 0 ? (openBlock(), createBlock(_sfc_main$1q, {
                      key: 0,
                      color: item.color,
                      "data-automation": unref(buildId)("indicator"),
                      "line-style": item.lineStyle
                    }, null, 8, ["color", "data-automation", "line-style"])) : createCommentVNode("", true)
                  ]),
                  createElementVNode("td", null, [
                    ((_a = item.highlightedLineIndices) == null ? void 0 : _a.includes(lineIndex)) ? (openBlock(), createElementBlock("b", _hoisted_2$Z, toDisplayString(line), 1)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                      createTextVNode(toDisplayString(line), 1)
                    ], 64))
                  ])
                ]);
              }), 128))
            ], 64);
          }), 128))
        ])
      ], 8, _hoisted_1$1b);
    };
  }
});
const _hoisted_1$1a = ["data-automation"];
const _hoisted_2$Y = ["data-automation"];
const _sfc_main$1o = /* @__PURE__ */ defineComponent({
  __name: "ChartTooltip",
  props: {
    caret: {
      default: () => ({
        x: 0,
        y: 0
      }),
      type: Object
    },
    chart: {
      default: void 0,
      type: Object
    },
    dataAutomation: {
      default: "chart-tooltip",
      type: String
    },
    items: {
      default: void 0,
      type: Array
    }
  },
  setup(__props) {
    const props4 = __props;
    const {
      caret,
      chart
    } = toRefs(props4);
    const { buildId } = useAutomation(props4.dataAutomation);
    const { style } = useChartTooltip(chart, caret);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", null, [
        createElementVNode("div", {
          ref: "tooltipGhost",
          class: "chart-tooltip chart-tooltip--ghost",
          "data-automation": unref(buildId)("ghost")
        }, [
          createVNode(_sfc_main$1p, {
            "data-automation": unref(buildId)("ghost-content"),
            items: __props.items
          }, null, 8, ["data-automation", "items"])
        ], 8, _hoisted_1$1a),
        createElementVNode("div", {
          class: "chart-tooltip",
          "data-automation": unref(buildId)(),
          style: normalizeStyle(unref(style))
        }, [
          createVNode(_sfc_main$1p, { items: __props.items }, null, 8, ["items"])
        ], 12, _hoisted_2$Y)
      ]);
    };
  }
});
const TWO_DAYS_IN_MS = 1728e5;
Chart$1.register(
  index,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  TimeScale,
  plugin_tooltip
);
const lineStyles = {
  dashed: {
    borderDash: [5, 4]
  },
  "dashed-long-with-offset": {
    borderDash: [10, 3],
    borderDashOffset: 5
  },
  dotted: {
    borderCapStyle: "round",
    borderDash: [0, 4]
  },
  "dotted-loosely": {
    borderCapStyle: "round",
    borderDash: [0, 10]
  },
  solid: {}
};
function buildGradient(ctx, chartArea, color2) {
  const rgbColor = colors_default.textToRgb(color2);
  const rgbColorString = `${rgbColor.r}, ${rgbColor.g}, ${rgbColor.b}`;
  const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
  gradient.addColorStop(0, `rgba(${rgbColorString}, 0)`);
  gradient.addColorStop(0.3, `rgba(${rgbColorString}, 0.3)`);
  gradient.addColorStop(0.5, `rgba(${rgbColorString}, 0.5)`);
  gradient.addColorStop(0.8, `rgba(${rgbColorString}, 0.8)`);
  gradient.addColorStop(1, `rgba(${rgbColorString}, 1)`);
  return gradient;
}
function formatDuration(value2) {
  const total = value2 / 1e3;
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor(total / 60 % 60);
  const seconds = total % 60;
  return hours ? `${hours}h ${minutes}m` : minutes ? `${minutes}m ${seconds}s` : `${seconds}s`;
}
const _sfc_main$1n = defineComponent({
  name: "Chart",
  components: {
    Bullet,
    ChartTooltip: _sfc_main$1o
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    chart: {
      type: Object,
      required: true
    },
    entries: {
      type: Array,
      default: () => []
    },
    interpolate: {
      default: false,
      type: Boolean
    },
    fill: {
      type: Boolean,
      default: false
    },
    fullHeight: {
      type: Boolean,
      default: false
    },
    maintainAspectRatio: {
      type: Boolean,
      default: false
    },
    max: {
      type: Object,
      default: void 0
    },
    min: {
      type: Object,
      default: void 0
    },
    noLegend: {
      type: Boolean,
      default: false
    },
    relativeTime: {
      type: Boolean,
      default: false
    },
    /**
    * Maximum rotation for tick labels when rotating to condense labels. Note: Rotation doesn't occur until necessary. Note: Only applicable to horizontal scales.
    * https://www.chartjs.org/docs/3.5.1/axes/cartesian/#common-tick-options-to-all-cartesian-axes
    * @default 50
    */
    labelMaxRotation: {
      type: Number,
      default: 50
    },
    showAxisLabels: {
      type: Boolean,
      default: false
    },
    xAxisTimeDisplayFormats: {
      default: void 0,
      type: Object
    },
    xAxisMaxTicksLimit: {
      default: void 0,
      type: Number
    },
    /**
     * Allows adding custom formatting for each tooltip field value. Useful in situations where we don't want to modify the entry's data.
     *
     * Example use cases:
     *  - A field that is used as an axis value but contains large numbers that we want to format inside the tooltip (eg. 2,000,000).
     *  - Formatting data of all the entries causes performance issues.
     */
    tooltipFieldFormat: {
      default: void 0,
      type: Object
    },
    /**
     * Allows specifying fields to be rendendered in bold.
     */
    tooltipHighlightedFields: {
      default: () => [],
      type: Array
    },
    /**
     * Allows specifying fields order for the tooltip (listed fields will be on top, rest will be sorted alphabetically).
     */
    tooltipPinnedFields: {
      default: () => [],
      type: Array
    },
    width: {
      type: String,
      default: "200"
    }
  },
  setup(props4) {
    const { isDark } = useDarkMode();
    const chartRef = ref$1(null);
    const show = computed(() => props4.entries.length);
    let chartInstance;
    const isShowTooltip = ref$1(false);
    const tooltipData = ref$1(null);
    const colors2 = computed(() => {
      return props4.entries.reduce((acc, entry, index2) => ({
        ...acc,
        [entry.key]: entry.color || getColor(index2)
      }), {});
    });
    const datasets = computed(() => {
      const {
        chart: {
          timeAxis,
          xAxis
        }
      } = props4;
      const datasets2 = props4.entries.map((entry) => {
        var _a;
        const color2 = colors2.value[entry.key];
        const lineStyle = lineStyles[entry.lineStyle];
        let chartData;
        if (timeAxis && props4.relativeTime && entry.data.length) {
          const x0 = new Date((_a = entry.data[0]) == null ? void 0 : _a[xAxis]).getTime();
          chartData = entry.data.map((x22) => ({
            ...x22,
            [xAxis]: new Date(x22[xAxis]).getTime() - x0 || 0
          }));
        } else {
          chartData = entry.data;
        }
        let height2;
        let width;
        let gradient;
        return {
          borderCapStyle: lineStyle == null ? void 0 : lineStyle.borderCapStyle,
          borderColor: entry.opacity ? rgbaColor(color2, entry.opacity) : color2,
          borderDash: lineStyle == null ? void 0 : lineStyle.borderDash,
          borderDashOffset: lineStyle == null ? void 0 : lineStyle.borderDashOffset,
          borderWidth: 2,
          data: chartData,
          fill: props4.fill,
          label: entry.name,
          pointBackgroundColor: color2,
          pointBorderColor: color2,
          pointRadius: (context) => {
            return context.dataIndex === context.dataset.data.length - 1 ? 4 : 0;
          },
          ...props4.interpolate && {
            cubicInterpolationMode: "monotone"
          },
          ...props4.fill && {
            backgroundColor: (ctx) => {
              const { chartArea } = ctx.chart;
              const chartWidth = chartArea.right - chartArea.left;
              const chartHeight = chartArea.bottom - chartArea.top;
              if (!chartWidth || !chartHeight) return color2;
              if (!gradient || width !== chartWidth || height2 !== chartHeight) {
                const canvasContext = chartRef.value.getContext("2d");
                gradient = buildGradient(canvasContext, chartArea, color2);
              }
              return gradient;
            }
          }
        };
      });
      return datasets2;
    });
    const tooltipIgnoredFields = computed(() => {
      return props4.entries.flatMap((entry) => entry.ignoreTooltipFields ?? []);
    });
    const tooltipEntries = computed(() => {
      const { chart } = props4;
      return props4.entries.map((entry) => entry.data.map((data) => {
        const dataFields = Object.entries(data).map(([key, value2]) => {
          var _a;
          return {
            key,
            label: ((_a = chart.labels) == null ? void 0 : _a[key]) ?? key,
            value: value2
          };
        }).filter((field) => !tooltipIgnoredFields.value.includes(field.key));
        const sortedFields = [...dataFields, ...entry.extraFields ?? []].sort((itemA, itemB) => {
          const indexA = props4.tooltipPinnedFields.indexOf(itemA.key);
          const indexB = props4.tooltipPinnedFields.indexOf(itemB.key);
          if (indexA !== -1 && indexB !== -1) {
            return indexA - indexB;
          }
          if (indexA !== -1) return -1;
          if (indexB !== -1) return 1;
          return itemA.label.localeCompare(itemB.label);
        });
        return sortedFields;
      }));
    });
    const tooltipHighlightedLineIndices = computed(
      () => tooltipEntries.value.map(
        (dataset) => dataset.map(
          (dataPoint) => dataPoint.map((field, index2) => [field, index2]).filter(([field]) => props4.tooltipHighlightedFields.includes(field.key)).map(([, index2]) => index2 + 1)
          // +1 to account for entry name
        )
      )
    );
    const tooltipLines = computed(
      () => tooltipEntries.value.map((dataset, datasetIndex) => dataset.map((dataPoint) => dataPoint.map((field) => {
        var _a;
        if ((_a = props4.tooltipFieldFormat) == null ? void 0 : _a[field.key]) {
          return `${field.label}: ${props4.tooltipFieldFormat[field.key](field.value)}`;
        }
        if (field.value instanceof Date) {
          if (props4.relativeTime) {
            const firstTime = tooltipEntries.value[datasetIndex][0].find((f) => f.key === field.key).value;
            return firstTime && `${field.label}: ${formatInterval(firstTime, field.value)}`;
          }
          return `${field.label}: ${formatDate$1(field.value, DateTemplates$1.Long)}`;
        }
        return `${field.label}: ${String(field.value)}`;
      })))
    );
    const legend = computed(() => {
      return props4.entries.map((entry) => ({
        color: colors2.value[entry.key],
        key: entry.key,
        name: entry.name
      }));
    });
    const options = computed(() => {
      var _a, _b, _c;
      const { chart } = props4;
      let xAxisLabel = ((_a = chart.labels) == null ? void 0 : _a[chart.xAxis]) || chart.xAxis;
      if (chart.xAxisUnit) xAxisLabel += ` (${chart.xAxisUnit})`;
      let yAxisLabel = ((_b = chart.labels) == null ? void 0 : _b[chart.yAxis]) || chart.yAxis;
      if (chart.yAxisUnit) yAxisLabel += ` (${chart.yAxisUnit})`;
      const labelColor = isDark.value ? getCssVar$1("white-fixed") ?? "#FFFFFF" : getCssVar$1("grey-1-fixed") ?? "#485374";
      const xAxisTicksConfig = {
        autoSkipPadding: 30,
        // Spacing between ticks
        maxRotation: props4.labelMaxRotation,
        maxTicksLimit: props4.xAxisMaxTicksLimit
      };
      const options2 = {
        animation: false,
        interaction: {
          axis: "xy",
          intersect: false,
          mode: "nearest"
        },
        maintainAspectRatio: props4.maintainAspectRatio,
        parsing: {
          xAxisKey: chart.xAxis,
          yAxisKey: chart.yAxis
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: (item) => {
                var _a2;
                return [
                  item.dataset.label ?? "",
                  ...(_a2 = tooltipLines.value[item.datasetIndex]) == null ? void 0 : _a2[item.dataIndex]
                ];
              },
              title: () => ""
            },
            enabled: false,
            external: customTooltip
          }
        },
        responsive: true,
        scales: {
          xAxis: {
            ticks: xAxisTicksConfig,
            title: {
              color: labelColor,
              display: props4.showAxisLabels,
              font: {
                lineHeight: "18px",
                size: 12,
                weight: "600"
              },
              text: xAxisLabel
            },
            type: "linear"
          },
          yAxis: {
            beginAtZero: true,
            title: {
              color: labelColor,
              display: props4.showAxisLabels,
              font: {
                lineHeight: "18px",
                size: 12,
                weight: "600"
              },
              text: yAxisLabel
            }
          }
        }
      };
      if (chart.timeAxis) {
        options2.scales = {
          ...options2.scales,
          xAxis: {
            ...(_c = options2.scales) == null ? void 0 : _c.xAxis,
            ...props4.relativeTime ? {
              ticks: {
                ...xAxisTicksConfig,
                callback: (value2) => formatDuration(value2)
              }
            } : {
              ...props4.max ? { max: props4.max } : {},
              ...props4.min ? { min: props4.min } : {},
              ticks: xAxisTicksConfig,
              time: {
                displayFormats: Object.assign({
                  hour: "MMM d HH:mm",
                  minute: "HH:mm",
                  second: "HH:mm:ss",
                  week: "MMM d"
                  /* Weeks */
                }, props4.xAxisTimeDisplayFormats),
                // This ensures that both date & time is displayed for long time spans no matter how dense datapoints are
                ...props4.min && props4.max && props4.max - props4.min > TWO_DAYS_IN_MS ? { minUnit: "hour" } : {}
              },
              type: "time"
            }
          }
        };
      }
      return options2;
    });
    function customTooltip({
      chart,
      tooltip
    }) {
      var _a;
      if (!isShowTooltip.value) return;
      if (!((_a = tooltip.body) == null ? void 0 : _a.length)) {
        tooltipData.value = null;
        return;
      }
      tooltipData.value = {
        caret: {
          x: tooltip.caretX,
          y: tooltip.caretY
        },
        chart: {
          height: chart.height,
          position: {
            x: chart.canvas.offsetLeft,
            y: chart.canvas.offsetTop
          },
          top: chart.canvas.getBoundingClientRect().top,
          width: chart.width
        },
        items: tooltip.body.map((body, index2) => ({
          color: tooltip.labelColors[index2].backgroundColor.toString(),
          highlightedLineIndices: tooltipHighlightedLineIndices.value[tooltip.dataPoints[index2].datasetIndex][index2],
          lines: body.lines,
          lineStyle: props4.entries[tooltip.dataPoints[index2].datasetIndex].lineStyle
        }))
      };
    }
    function onMouseEnter() {
      isShowTooltip.value = true;
    }
    function onMouseLeave() {
      isShowTooltip.value = false;
      tooltipData.value = null;
    }
    function rgbaColor(color2, opacity) {
      const colorString = color2.charAt(0) === "#" ? color2.substring(1, 7) : color2;
      if (colorString.length === 6) {
        const r = parseInt(colorString.substring(0, 2), 16);
        const g2 = parseInt(colorString.substring(2, 4), 16);
        const b22 = parseInt(colorString.substring(4, 6), 16);
        return `rgba(${r}, ${g2}, ${b22}, ${opacity})`;
      }
      return colorString;
    }
    onMounted(async () => {
      if (!chartRef.value) return;
      Chart$1.defaults.color = isDark.value ? getCssVar$1("white-fixed") ?? "#FFFFFF" : getCssVar$1("grey-1-fixed") ?? "#485374";
      Chart$1.defaults.borderColor = isDark.value ? getCssVar$1("grey-1-fixed") ?? "#485374" : getCssVar$1("grey-3-fixed") ?? "#DADDE3";
      const config = {
        data: {
          datasets: datasets.value
        },
        options: options.value,
        type: "line"
      };
      chartInstance = new Chart$1(chartRef.value, config);
    });
    watch([datasets, options], ([newDatasets, newOptions]) => {
      if (!chartInstance) return;
      chartInstance.options = newOptions;
      chartInstance.data.datasets = newDatasets;
      chartInstance.update();
    });
    onUnmounted(() => {
      chartInstance && chartInstance.destroy();
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      chartRef,
      isShowTooltip,
      legend,
      onMouseEnter,
      onMouseLeave,
      show,
      tooltipData
    };
  }
});
const _hoisted_1$19 = ["data-automation"];
const _hoisted_2$X = ["data-automation", "width"];
const _hoisted_3$M = { key: 0 };
const _hoisted_4$u = ["data-automation"];
const _hoisted_5$o = ["data-automation"];
function _sfc_render$1g(_ctx, _cache, $props, $setup, $data, $options) {
  var _a, _b, _c;
  const _component_ChartTooltip = resolveComponent("ChartTooltip");
  const _component_Bullet = resolveComponent("Bullet");
  return openBlock(), createElementBlock("div", {
    class: "tensorboard-chart",
    "data-automation": _ctx.buildId()
  }, [
    withDirectives(createElementVNode("div", {
      class: normalizeClass(["relative-position", { "full-height": _ctx.fullHeight }]),
      onMouseenter: _cache[0] || (_cache[0] = (...args) => _ctx.onMouseEnter && _ctx.onMouseEnter(...args)),
      onMouseleave: _cache[1] || (_cache[1] = (...args) => _ctx.onMouseLeave && _ctx.onMouseLeave(...args))
    }, [
      createElementVNode("canvas", {
        ref: "chartRef",
        "data-automation": _ctx.buildId("canvas"),
        height: "200",
        width: _ctx.width
      }, null, 8, _hoisted_2$X),
      withDirectives(createVNode(_component_ChartTooltip, {
        caret: (_a = _ctx.tooltipData) == null ? void 0 : _a.caret,
        chart: (_b = _ctx.tooltipData) == null ? void 0 : _b.chart,
        items: (_c = _ctx.tooltipData) == null ? void 0 : _c.items
      }, null, 8, ["caret", "chart", "items"]), [
        [vShow, _ctx.isShowTooltip && _ctx.tooltipData]
      ])
    ], 34), [
      [vShow, _ctx.show]
    ]),
    !_ctx.noLegend ? (openBlock(), createElementBlock("div", _hoisted_3$M, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.legend, (item) => {
        return openBlock(), createElementBlock("div", {
          key: item.key,
          class: "inline flex no-wrap items-center text-small q-mr-sm",
          "data-automation": _ctx.buildId(`item__${item.key}`)
        }, [
          createVNode(_component_Bullet, {
            color: item.color,
            "data-automation": _ctx.buildId(`item__${item.key}__bullet`)
          }, null, 8, ["color", "data-automation"]),
          createElementVNode("div", {
            class: "q-ml-xs",
            "data-automation": _ctx.buildId(`item__${item.key}__label`)
          }, toDisplayString(item.name), 9, _hoisted_5$o)
        ], 8, _hoisted_4$u);
      }), 128))
    ])) : createCommentVNode("", true)
  ], 8, _hoisted_1$19);
}
const Chart2 = /* @__PURE__ */ _export_sfc$1(_sfc_main$1n, [["render", _sfc_render$1g]]);
const _sfc_main$1m = defineComponent({
  name: "Chip",
  components: {
    QIcon: QIcon_default$1
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Color name for component from the Quasar Color Palette
     */
    backgroundColor: {
      type: String,
      default: ""
    },
    /**
     * Border applied to component
     */
    bordered: {
      type: Boolean,
      default: false
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Icon color as a Quasar variable (primary|dark|grey-1)
     */
    iconColor: {
      type: String,
      default: ""
    },
    /**
     * Icon name
     */
    iconName: {
      type: String,
      default: ""
    },
    /**
     * Shows icons, if defined, on the right
     */
    iconRight: {
      type: Boolean,
      default: false
    },
    /**
     * The text that will be shown on the button
     */
    label: {
      type: String,
      required: true
    },
    /**
     * Render chip in primary mode
     */
    primary: {
      type: Boolean,
      default: true
    },
    /**
     * Render chip in secondary mode
     */
    secondary: {
      type: Boolean,
      default: false
    },
    /**
     * Size in standard size name (sm|md)
     */
    size: {
      type: String,
      default: "sm"
    },
    /**
     * Text color name for component from the Quasar Color Palette
     */
    textColor: {
      type: String,
      default: ""
    }
  },
  setup(props4) {
    const isCustom = computed(() => props4.backgroundColor || props4.textColor);
    const isPrimary = computed(() => props4.primary && !props4.secondary && !isCustom.value);
    const isSecondary = computed(() => props4.secondary && !isCustom.value);
    const textClass = computed(() => props4.textColor ? `text-${props4.textColor}` : "");
    const backgroundClass = computed(() => props4.backgroundColor ? `bg-${props4.backgroundColor}` : "");
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      backgroundClass,
      isPrimary,
      isSecondary,
      textClass
    };
  }
});
const _hoisted_1$18 = ["data-automation"];
function _sfc_render$1f(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QIcon = resolveComponent("QIcon");
  return openBlock(), createElementBlock("div", mergeProps(_ctx.dataAttrs, {
    class: ["rv-chip", [
      {
        "rv-chip--bordered": _ctx.bordered,
        "rv-chip--primary": _ctx.isPrimary,
        "rv-chip--secondary": _ctx.isSecondary,
        "rv-chip--sm": _ctx.size === "sm",
        "rv-chip--md": _ctx.size === "md"
      },
      _ctx.backgroundClass,
      _ctx.textClass,
      _ctx.$props.class
    ]],
    "data-automation": _ctx.buildId()
  }), [
    _ctx.iconName && !_ctx.iconRight ? (openBlock(), createBlock(_component_QIcon, {
      key: 0,
      class: "rv-chip__icon rv-chip__icon--left",
      color: _ctx.iconColor,
      "data-automation": _ctx.buildId("icon"),
      name: _ctx.iconName
    }, null, 8, ["color", "data-automation", "name"])) : createCommentVNode("", true),
    createElementVNode("span", null, toDisplayString(_ctx.label), 1),
    _ctx.iconName && _ctx.iconRight ? (openBlock(), createBlock(_component_QIcon, {
      key: 1,
      class: "rv-chip__icon rv-chip__icon--right",
      color: _ctx.iconColor,
      "data-automation": _ctx.buildId("icon"),
      name: _ctx.iconName
    }, null, 8, ["color", "data-automation", "name"])) : createCommentVNode("", true)
  ], 16, _hoisted_1$18);
}
const Chip = /* @__PURE__ */ _export_sfc$1(_sfc_main$1m, [["render", _sfc_render$1f], ["__scopeId", "data-v-b4177217"]]);
const _sfc_main$1l = defineComponent({
  name: "CircularProgress",
  components: {
    QCircularProgress: QCircularProgress_default$1
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Color name for the arc progress from the Quasar Color Palette
     */
    color: {
      type: String,
      default: "primary"
    },
    /**
     * Size of text in CSS units, including unit name. Suggestion: use 'em' units to sync with component size
     */
    fontSize: {
      type: String,
      default: "1em"
    },
    /**
     * Put component into 'indeterminate' state; Ignores 'value' prop
     */
    indeterminate: {
      type: Boolean,
      default: false
    },
    /**
     * Maximum value defining 100% progress made (must be higher than 'min')
     */
    max: {
      type: Number,
      default: 100
    },
    /**
     * Minimum value defining 'no progress' (must be lower than 'max')
     */
    min: {
      type: Number,
      default: 0
    },
    /**
     * Enables the default slot and uses it (if available), otherwise it displays the 'value' prop as text;
     * Make sure the text has enough space to be displayed inside the component
     */
    showValue: {
      type: Boolean,
      default: false
    },
    /**
     * Size in CSS units, including unit name or standard size name (xs|sm|md|lg|xl)
     */
    size: {
      type: String,
      default: "1em"
    },
    /**
     * Thickness of progress arc as a ratio (0.0 < x < 1.0) of component size
     */
    thickness: {
      type: Number,
      default: 0.2
    },
    /**
     * Color name for the track of the component from the Quasar Color Palette
     */
    trackColor: {
      type: String,
      default: void 0
    },
    /**
     * Current progress (must be between min/max)
     */
    value: {
      type: Number,
      default: 0
    }
  },
  setup(props4) {
    const { isDark } = useDarkMode();
    const trackColorComputed = computed(() => {
      if (props4.trackColor) return props4.trackColor;
      return isDark.value ? "grey-1--dark" : "grey-3--light";
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      trackColorComputed
    };
  }
});
function _sfc_render$1e(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QCircularProgress = resolveComponent("QCircularProgress");
  return openBlock(), createBlock(_component_QCircularProgress, {
    class: normalizeClass(["rv-circular-progress text-primary--light text-white--dark text-center", _ctx.$props.class]),
    color: _ctx.color,
    "data-automation": _ctx.buildId(),
    "font-size": _ctx.fontSize,
    indeterminate: _ctx.indeterminate,
    max: _ctx.max,
    min: _ctx.min,
    "show-value": _ctx.showValue,
    size: _ctx.size,
    thickness: _ctx.thickness,
    "track-color": _ctx.trackColorComputed,
    value: _ctx.value
  }, {
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["class", "color", "data-automation", "font-size", "indeterminate", "max", "min", "show-value", "size", "thickness", "track-color", "value"]);
}
const CircularProgress = /* @__PURE__ */ _export_sfc$1(_sfc_main$1l, [["render", _sfc_render$1e]]);
const _sfc_main$1k = defineComponent({
  name: "EllipsisText",
  components: {
    Tooltip: Tooltip2
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Show 3dots at the beginning
     * @type {Boolean}
     */
    reverse: {
      type: Boolean,
      default: false
    },
    /**
     * Classes applied to the label
     * @type {[Array, Object, String]}
     */
    tooltipClass: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Text displayed inside the component
     */
    text: {
      type: [String, Number],
      default: void 0
    },
    /**
     * To keep spaces between working in text
     */
    textWithSpaces: {
      type: Boolean,
      default: false
    },
    /**
     * Tooltip is shown by default when overflowing text, or always shown when passing this property
     */
    tooltip: {
      type: [String],
      default: void 0
    }
  },
  setup(props4) {
    const containerRef = ref$1(null);
    const contentRef = ref$1(null);
    const overflowed = ref$1(false);
    const textContent = computed(() => {
      var _a;
      return props4.text ?? ((_a = contentRef.value) == null ? void 0 : _a.innerText) ?? "";
    });
    function checkWidth() {
      overflowed.value = !!containerRef.value && !!contentRef.value && contentRef.value.offsetWidth > containerRef.value.offsetWidth;
    }
    onMounted(checkWidth);
    watch(
      () => props4.text,
      () => {
        void nextTick(checkWidth);
      },
      { immediate: true }
    );
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      containerRef,
      contentRef,
      overflowed,
      textContent
    };
  }
});
const _hoisted_1$17 = ["data-automation"];
const _hoisted_2$W = { ref: "contentRef" };
const _hoisted_3$L = { key: 0 };
const _hoisted_4$t = { key: 1 };
function _sfc_render$1d(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tooltip = resolveComponent("Tooltip");
  return openBlock(), createElementBlock("div", {
    ref: "containerRef",
    class: normalizeClass(["rv-ellipsis-text ellipsis", [{
      "rv-ellipsis-text--overflowed": _ctx.overflowed,
      "rv-ellipsis-text--reverse": _ctx.reverse,
      "rv-ellipsis-text--with-spaces": _ctx.textWithSpaces
    }, _ctx.$props.class]]),
    "data-automation": _ctx.buildId()
  }, [
    createElementVNode("span", _hoisted_2$W, [
      renderSlot(_ctx.$slots, "default", {}, () => [
        createTextVNode(toDisplayString(_ctx.text), 1)
      ], true)
    ], 512),
    _ctx.overflowed || _ctx.tooltip ? (openBlock(), createBlock(_component_Tooltip, {
      key: 0,
      anchor: "bottom middle",
      class: normalizeClass(["rv-ellipsis-text__tooltip", _ctx.tooltipClass]),
      "data-automation": _ctx.buildId("tooltip"),
      self: "center middle"
    }, {
      default: withCtx(() => [
        _ctx.overflowed ? (openBlock(), createElementBlock("div", _hoisted_3$L, toDisplayString(_ctx.textContent), 1)) : createCommentVNode("", true),
        _ctx.tooltip ? (openBlock(), createElementBlock("div", _hoisted_4$t, toDisplayString(_ctx.tooltip), 1)) : createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["class", "data-automation"])) : createCommentVNode("", true)
  ], 10, _hoisted_1$17);
}
const EllipsisText = /* @__PURE__ */ _export_sfc$1(_sfc_main$1k, [["render", _sfc_render$1d], ["__scopeId", "data-v-c09b2f3c"]]);
const _sfc_main$1j = defineComponent({
  name: "Input",
  components: {
    EllipsisText,
    QIcon: QIcon_default$1,
    QInput: QInput_default$1,
    Tooltip: Tooltip2
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Hint for input autofill feature
     */
    autocomplete: {
      type: String,
      default: void 0
    },
    /**
     * Focus field on initial component render
     */
    autofocus: {
      type: Boolean,
      default: false
    },
    /**
     * Focus field on initial component render
     */
    autogrow: {
      type: Boolean,
      default: false
    },
    /**
     * Enables bottom slots ('error', 'hint', 'counter')
     */
    bottomSlots: {
      type: Boolean,
      default: false
    },
    /**
     * Classes applied to the component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Debounce amount (in milliseconds) when updating model
     */
    debounce: {
      type: [String, Number],
      default: 200
    },
    /**
     * Dense mode; occupies less space
     */
    dense: {
      type: Boolean,
      default: false
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Forcefully hides the error icon, always.
     */
    hideErrorIcon: {
      type: Boolean,
      default: false
    },
    /**
     * Helper (hint) text which gets placed below your wrapped form component
     */
    hint: {
      type: String,
      default: void 0
    },
    /**
     * Render info icon with tooltip. Can be used as an "info-text" property or as a slot
     */
    infoText: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to the info text
     */
    infoTextClass: {
      type: String,
      default: "rv-input__info-text"
    },
    /**
     * Classes applied to the input
     * @type {[Array, Object, String]}
     */
    inputClass: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * The text that will be shown above the input
     */
    label: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to the label
     * @type {[Array, Object, String]}
     */
    labelClass: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Model of the component; Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
     */
    modelValue: {
      type: [Number, String],
      default: void 0
    },
    /**
     * The text that will be shown next to label
     */
    optionalLabel: {
      type: String,
      default: ""
    },
    /**
     * Text that appears in the form control when it has no value set
     */
    placeholder: {
      type: String,
      default: void 0
    },
    /**
     * Put component in readonly mode
     */
    readonly: {
      type: Boolean,
      default: false
    },
    /**
     * Specifies the visible height of a text area
     */
    rows: {
      type: Number,
      default: 6
    },
    /**
     * Option to show or hide the error
     */
    showError: {
      type: Boolean,
      default: true
    },
    /**
     * Option to show or hide the error icon. Only applies if showError is false.
     */
    showErrorIcon: {
      type: Boolean,
      default: false
    },
    /**
     * Option to show or hide the error
     */
    showErrorMessage: {
      type: Boolean,
      default: true
    },
    /**
     * Show error as a tooltip of the valid icon (if enabled)
     */
    showErrorAsTooltip: {
      default: false,
      type: Boolean
    },
    /**
     * Show optional label next to label
     */
    showOptionalLabel: {
      type: Boolean,
      default: false
    },
    /**
     * Option to show or hide the validation
     */
    showValid: {
      type: Boolean,
      default: true
    },
    /**
     * The text to be displayed at the end inside the input
     */
    suffix: {
      type: String,
      default: void 0
    },
    /**
     * Global attribute indicates that its element can be focused, and where it participates in sequential keyboard navigation
     */
    tabindex: {
      type: String,
      default: void 0
    },
    /**
     * A string specifying the type of control to render
     */
    type: {
      type: String,
      default: "text"
    },
    /**
     * Validation for the component
     */
    validation: {
      type: Object,
      default: void 0
    }
  },
  emits: [
    /**
     * Emitted when component loses focus
     *
     * @type {object}
     */
    "blur",
    /**
     * Emitted when component gets focused
     *
     * @type {object}
     */
    "change",
    /**
     * Emitted when component changes
     *
     * @type {object}
     */
    "focus",
    /**
     * Emitted on keydown event
     *
     * @type {object}
     */
    "keydown",
    /**
     * Emitted on keypress event
     *
     * @type {object}
     */
    "keypress",
    /**
     * Emitted on keyup event
     *
     * @type {object}
     */
    "keyup",
    /**
     * Emitted when the user has initiated a "paste" action in input element.
     *
     * @type {object}
     */
    "paste",
    /**
     * Emitted when the component needs to change the model; Is also used by v-model
     *
     * @type {[string, number]}
     */
    "update:modelValue"
  ],
  setup(props4, { emit }) {
    const slots = useSlots();
    const { t: t22 } = useI18n();
    const input = ref$1(null);
    const errorTooltipRef = ref$1(null);
    const focused = ref$1(false);
    const {
      classRef,
      error,
      errorMessage,
      isValidated,
      onBlur: onValidationBlur
    } = useValidation(props4);
    const hasValidation = computed(() => props4.showValid && isValidated.value && props4.modelValue || props4.showError && error.value);
    const bottomSlotNames = computed(() => ["error", "hint", "counter"].filter((name2) => props4.bottomSlots && slots[name2]));
    const isTextarea = computed(() => props4.type === "textarea");
    const maxLength2 = computed(() => {
      var _a;
      if (!props4.validation) return;
      return (_a = props4.validation.maxLength) == null ? void 0 : _a.$params.max;
    });
    function blur() {
      var _a;
      (_a = input.value) == null ? void 0 : _a.blur();
    }
    function onBlur2(...args) {
      onValidationBlur();
      focused.value = false;
      emit("blur", ...args);
    }
    function onChange(...args) {
      emit("change", ...args);
    }
    function onFocus(...args) {
      emit("focus", ...args);
      focused.value = true;
    }
    function onKeydown2(...args) {
      emit("keydown", ...args);
    }
    function onKeypress(...args) {
      emit("keypress", ...args);
    }
    function onKeyup2(...args) {
      emit("keyup", ...args);
    }
    function onPaste(...args) {
      emit("paste", ...args);
    }
    function onUpdate(value2) {
      emit("update:modelValue", value2);
    }
    if (props4.showErrorAsTooltip) {
      watch(errorMessage, (value2, prevValue) => {
        if (value2 && value2 !== prevValue) {
          void nextTick(() => {
            var _a;
            (_a = errorTooltipRef.value) == null ? void 0 : _a.show();
          });
        }
      });
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      blur,
      bottomSlotNames,
      classRef,
      error,
      errorMessage,
      errorTooltipRef,
      focused,
      hasValidation,
      input,
      isTextarea,
      isValidated,
      maxLength: maxLength2,
      onBlur: onBlur2,
      onChange,
      onFocus,
      onKeydown: onKeydown2,
      onKeypress,
      onKeyup: onKeyup2,
      onPaste,
      onUpdate,
      t: t22
    };
  }
});
const _hoisted_1$16 = ["data-automation"];
const _hoisted_2$V = { class: "row no-wrap items-center full-width" };
const _hoisted_3$K = ["data-automation"];
function _sfc_render$1c(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_QInput = resolveComponent("QInput");
  return openBlock(), createElementBlock("div", mergeProps(_ctx.dataAttrs, {
    class: ["rv-input", [
      _ctx.classRef,
      {
        "rv-input--dense": _ctx.dense,
        "rv-input--disabled": _ctx.disable || _ctx.readonly,
        "rv-input--error": !!((_ctx.showError || _ctx.showErrorIcon) && _ctx.error),
        "rv-input--textarea": _ctx.isTextarea
      }
    ]],
    "data-automation": _ctx.buildId()
  }), [
    _ctx.label ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass(["rv-input__label flex justify-between items-center", _ctx.labelClass])
    }, [
      createElementVNode("span", _hoisted_2$V, [
        createVNode(_component_EllipsisText, {
          class: "text-subtitle3",
          "data-automation": _ctx.buildId("label"),
          text: _ctx.label
        }, null, 8, ["data-automation", "text"]),
        _ctx.showOptionalLabel ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "q-ml-xs",
          "data-automation": _ctx.buildId("optional")
        }, toDisplayString(_ctx.optionalLabel || _ctx.t("rvai-base.general.inputs.optional")), 9, _hoisted_3$K)) : createCommentVNode("", true),
        _ctx.infoText || _ctx.$slots["infoText"] ? (openBlock(), createBlock(_component_QIcon, {
          key: 1,
          class: "q-ml-xs info-icon",
          color: "black-1",
          "data-automation": _ctx.buildId("icon-info"),
          name: "info",
          size: "16px"
        }, {
          default: withCtx(() => [
            createVNode(_component_Tooltip, {
              anchor: "top middle",
              class: normalizeClass(_ctx.infoTextClass),
              "data-automation": _ctx.buildId("tooltip"),
              self: "bottom middle"
            }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "infoText", {}, () => [
                  createTextVNode(toDisplayString(_ctx.infoText), 1)
                ], true)
              ]),
              _: 3
            }, 8, ["class", "data-automation"])
          ]),
          _: 3
        }, 8, ["data-automation"])) : createCommentVNode("", true)
      ]),
      renderSlot(_ctx.$slots, "label-append", {}, void 0, true)
    ], 2)) : createCommentVNode("", true),
    createVNode(_component_QInput, {
      ref: "input",
      autocomplete: _ctx.autocomplete,
      autofocus: _ctx.autofocus,
      autogrow: _ctx.autogrow,
      "bottom-slots": _ctx.bottomSlots,
      debounce: _ctx.debounce,
      dense: "",
      disable: _ctx.disable || _ctx.readonly,
      error: _ctx.showError && _ctx.error,
      "error-message": _ctx.showErrorMessage ? _ctx.errorMessage : "",
      "hide-bottom-space": "",
      hint: _ctx.hint,
      "input-class": _ctx.inputClass,
      "model-value": _ctx.modelValue,
      "no-error-icon": "",
      placeholder: _ctx.placeholder,
      rows: _ctx.autogrow ? void 0 : _ctx.rows,
      standout: "",
      suffix: _ctx.suffix,
      tabindex: _ctx.tabindex,
      type: _ctx.type,
      onBlur: _ctx.onBlur,
      onChange: _ctx.onChange,
      onFocus: _ctx.onFocus,
      onKeydown: _ctx.onKeydown,
      onKeypress: _ctx.onKeypress,
      onKeyup: _ctx.onKeyup,
      onPaste: _ctx.onPaste,
      "onUpdate:modelValue": _ctx.onUpdate
    }, createSlots({
      append: withCtx((slotData) => [
        renderSlot(_ctx.$slots, "append", normalizeProps(guardReactiveProps(slotData || {})), void 0, true)
      ]),
      prepend: withCtx((slotData) => [
        renderSlot(_ctx.$slots, "prepend", normalizeProps(guardReactiveProps(slotData || {})), void 0, true)
      ]),
      _: 2
    }, [
      _ctx.showValid && _ctx.isValidated && _ctx.modelValue ? {
        name: "after",
        fn: withCtx(() => [
          createVNode(_component_QIcon, {
            key: "valid",
            color: "positive",
            "data-automation": _ctx.buildId("icon-valid"),
            name: "mdi-check-circle"
          }, null, 8, ["data-automation"])
        ]),
        key: "0"
      } : !_ctx.hideErrorIcon && (_ctx.showError || _ctx.showErrorIcon) && _ctx.error ? {
        name: "after",
        fn: withCtx(() => [
          createVNode(_component_QIcon, {
            key: "error",
            color: "negative",
            "data-automation": _ctx.buildId("icon-error"),
            name: "mdi-close-circle"
          }, {
            default: withCtx(() => [
              _ctx.showErrorAsTooltip ? (openBlock(), createBlock(_component_Tooltip, {
                key: 0,
                ref: "errorTooltipRef",
                anchor: "bottom middle",
                "auto-hide": 3e3,
                class: normalizeClass(_ctx.infoTextClass),
                offset: [0, 4],
                self: "top middle"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.errorMessage), 1)
                ]),
                _: 1
              }, 8, ["class"])) : createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["data-automation"])
        ]),
        key: "1"
      } : void 0,
      renderList(_ctx.bottomSlotNames, (name2) => {
        return {
          name: name2,
          fn: withCtx((slotData) => [
            renderSlot(_ctx.$slots, name2, normalizeProps(guardReactiveProps(slotData || {})), void 0, true)
          ])
        };
      })
    ]), 1032, ["autocomplete", "autofocus", "autogrow", "bottom-slots", "debounce", "disable", "error", "error-message", "hint", "input-class", "model-value", "placeholder", "rows", "suffix", "tabindex", "type", "onBlur", "onChange", "onFocus", "onKeydown", "onKeypress", "onKeyup", "onPaste", "onUpdate:modelValue"]),
    renderSlot(_ctx.$slots, "after", {
      focused: _ctx.focused,
      validation: _ctx.validation
    }, void 0, true),
    _ctx.isTextarea && _ctx.maxLength ? (openBlock(), createElementBlock("div", {
      key: 1,
      class: normalizeClass(["rv-input__description text-grey-1", {
        "rv-input__description--validated": _ctx.hasValidation
      }])
    }, toDisplayString(_ctx.t("rvai-base.general.inputs.maxCharacters", _ctx.maxLength)), 3)) : createCommentVNode("", true)
  ], 16, _hoisted_1$16);
}
const Input = /* @__PURE__ */ _export_sfc$1(_sfc_main$1j, [["render", _sfc_render$1c], ["__scopeId", "data-v-e9e364bd"]]);
const _sfc_main$1i = defineComponent({
  name: "ColorPicker",
  components: {
    Input,
    QColor: QColor_default
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * v-model
     */
    modelValue: {
      type: String,
      required: true
    }
  },
  emits: [
    /**
     * Emitted when component is updated
     *
     * @type {object}
     */
    "update:modelValue"
  ],
  setup(props4, { emit }) {
    const { t: t22 } = useI18n();
    const hexColorInput = computed({
      get() {
        return props4.modelValue.startsWith("#") ? props4.modelValue.substring(1).toUpperCase() : props4.modelValue.toUpperCase();
      },
      set(value2) {
        const hasHashtag = value2.startsWith("#");
        const valueWithoutHashtag = hasHashtag ? value2 == null ? void 0 : value2.slice(1) : value2;
        if (valueWithoutHashtag.match(/(\b[0-9A-F]{3}\b)|(\b[0-9A-F]{6}\b)/gi)) {
          emit("update:modelValue", `#${valueWithoutHashtag}`);
        }
      }
    });
    const red = computed({
      get() {
        return colors_default.hexToRgb(props4.modelValue).r;
      },
      set(value2) {
        setRGB(value2, "r");
      }
    });
    const green = computed({
      get() {
        return colors_default.hexToRgb(props4.modelValue).g;
      },
      set(value2) {
        setRGB(value2, "g");
      }
    });
    const blue = computed({
      get() {
        return colors_default.hexToRgb(props4.modelValue).b;
      },
      set(value2) {
        setRGB(value2, "b");
      }
    });
    function setRGB(value2, key) {
      const rgb2 = colors_default.hexToRgb(props4.modelValue);
      if (value2 > 255 || value2.toString().match(/\D/g)) {
        rgb2[key] = 255;
      } else {
        rgb2[key] = value2;
      }
      emit("update:modelValue", colors_default.rgbToHex(rgb2));
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      blue,
      green,
      hexColorInput,
      red,
      t: t22
    };
  }
});
const _hoisted_1$15 = ["data-automation"];
const _hoisted_2$U = { class: "q-pb-md flex no-wrap inputs" };
function _sfc_render$1b(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QColor = resolveComponent("QColor");
  const _component_Input = resolveComponent("Input");
  return openBlock(), createElementBlock("div", {
    class: "bg-white",
    "data-automation": _ctx.buildId()
  }, [
    createElementVNode("div", {
      style: normalizeStyle({ "--color": _ctx.modelValue })
    }, [
      createVNode(_component_QColor, {
        "data-automation": _ctx.buildId("color-picker"),
        "format-model": "hex",
        "model-value": _ctx.modelValue,
        "no-footer": "",
        "no-header": "",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.$emit("update:modelValue", $event))
      }, null, 8, ["data-automation", "model-value"])
    ], 4),
    createElementVNode("div", _hoisted_2$U, [
      createVNode(_component_Input, {
        modelValue: _ctx.hexColorInput,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.hexColorInput = $event),
        class: "color__input color__input--hex",
        "data-automation": _ctx.buildId("hex"),
        label: _ctx.t("rvai-base.components.colorPicker.hex"),
        "no-error-icon": ""
      }, null, 8, ["modelValue", "data-automation", "label"]),
      createVNode(_component_Input, {
        modelValue: _ctx.red,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.red = $event),
        class: "color__input",
        "data-automation": _ctx.buildId("red"),
        label: _ctx.t("rvai-base.components.colorPicker.rgb.r")
      }, null, 8, ["modelValue", "data-automation", "label"]),
      createVNode(_component_Input, {
        modelValue: _ctx.green,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.green = $event),
        class: "color__input",
        "data-automation": _ctx.buildId("green"),
        label: _ctx.t("rvai-base.components.colorPicker.rgb.g")
      }, null, 8, ["modelValue", "data-automation", "label"]),
      createVNode(_component_Input, {
        modelValue: _ctx.blue,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => _ctx.blue = $event),
        class: "color__input",
        "data-automation": _ctx.buildId("blue"),
        label: _ctx.t("rvai-base.components.colorPicker.rgb.b")
      }, null, 8, ["modelValue", "data-automation", "label"])
    ])
  ], 8, _hoisted_1$15);
}
const ColorPicker = /* @__PURE__ */ _export_sfc$1(_sfc_main$1i, [["render", _sfc_render$1b], ["__scopeId", "data-v-f533503d"]]);
const _sfc_main$1h = defineComponent({
  name: "ColorPickerInput",
  components: {
    ColorPicker,
    Input,
    QIcon: QIcon_default$1,
    QPopupProxy: QPopupProxy_default
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Render info icon with tooltip
     */
    infoText: {
      default: void 0,
      type: String
    },
    /**
     * The text that will be shown above the input
     */
    label: {
      default: void 0,
      type: String
    },
    /**
     * v-model
     */
    modelValue: {
      default: null,
      type: String
    },
    /**
     * Show optional label next to label
     */
    showOptionalLabel: {
      default: false,
      type: Boolean
    }
  },
  emits: [
    /**
     * Emitted when component is updated
     *
     * @type {object}
     */
    "update:modelValue"
  ],
  setup(props4, { emit }) {
    const color2 = computed({
      get() {
        var _a;
        if (!props4.modelValue) return "";
        const hasHashtag = props4.modelValue.startsWith("#");
        const valueWithoutHashtag = hasHashtag ? (_a = props4.modelValue) == null ? void 0 : _a.substring(1) : props4.modelValue;
        return `#${valueWithoutHashtag.toUpperCase()}`;
      },
      set(value2) {
        if (value2 === "") {
          emit("update:modelValue", "");
          return;
        }
        const hasHashtag = value2 == null ? void 0 : value2.startsWith("#");
        const valueWithoutHashtag = hasHashtag ? value2 == null ? void 0 : value2.substring(1) : value2;
        if (valueWithoutHashtag == null ? void 0 : valueWithoutHashtag.match(/(\b[0-9A-F]{3}\b)|(\b[0-9A-F]{6}\b)/gi)) {
          emit("update:modelValue", `#${valueWithoutHashtag}`);
        }
      }
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      color: color2
    };
  }
});
const _hoisted_1$14 = ["data-automation"];
const _hoisted_2$T = ["data-automation"];
function _sfc_render$1a(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Input = resolveComponent("Input");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_ColorPicker = resolveComponent("ColorPicker");
  const _component_QPopupProxy = resolveComponent("QPopupProxy");
  return openBlock(), createElementBlock("div", {
    class: "row no-wrap",
    "data-automation": _ctx.buildId()
  }, [
    createVNode(_component_Input, {
      modelValue: _ctx.color,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.color = $event),
      class: "full-width",
      "data-automation": _ctx.buildId("input"),
      "info-text": _ctx.infoText,
      label: _ctx.label,
      "show-optional-label": _ctx.showOptionalLabel
    }, createSlots({ _: 2 }, [
      !!_ctx.color ? {
        name: "prepend",
        fn: withCtx(() => [
          createElementVNode("div", {
            class: "color-picker__color-indicator",
            "data-automation": _ctx.buildId("color-indicator"),
            style: normalizeStyle(`background-color: ${_ctx.color}`)
          }, null, 12, _hoisted_2$T)
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["modelValue", "data-automation", "info-text", "label", "show-optional-label"]),
    !!_ctx.color ? (openBlock(), createBlock(_component_QIcon, {
      key: 0,
      class: "color-picker__success",
      color: "positive",
      "data-automation": _ctx.buildId("success"),
      name: "mdi-check-circle",
      size: "24px"
    }, null, 8, ["data-automation"])) : createCommentVNode("", true),
    createVNode(_component_QPopupProxy, {
      class: "color-picker__popup q-pa-md",
      "data-automation": _ctx.buildId("popup"),
      "no-focus": "",
      offset: [0, 5]
    }, {
      default: withCtx(() => [
        createVNode(_component_ColorPicker, {
          key: "colorPicker",
          modelValue: _ctx.color,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.color = $event),
          class: "color-picker__component",
          "data-automation": _ctx.buildId("component")
        }, null, 8, ["modelValue", "data-automation"])
      ]),
      _: 1
    }, 8, ["data-automation"])
  ], 8, _hoisted_1$14);
}
const ColorPickerInput = /* @__PURE__ */ _export_sfc$1(_sfc_main$1h, [["render", _sfc_render$1a], ["__scopeId", "data-v-f08a9c41"]]);
const __default__$3 = defineComponent({
  name: "ColorPicker",
  components: {
    ActionButton,
    QColor: QColor_default,
    QMenu: QMenu_default$1
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      default: void 0,
      type: String
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      default: false,
      type: Boolean
    },
    /**
     * v-model
     */
    modelValue: {
      required: true,
      type: String
    }
  },
  emits: [
    /**
     * Emitted when component is updated
     *
     * @type {object}
     */
    "update:modelValue"
  ],
  setup(props4, { emit }) {
    const value2 = computed({
      get() {
        return props4.modelValue;
      },
      set(value22) {
        emit("update:modelValue", value22);
      }
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      value: value2
    };
  }
});
const __injectCSSVars__$3 = () => {
  useCssVars((_ctx) => ({
    "4bd23360": _ctx.value
  }));
};
const __setup__$3 = __default__$3.setup;
__default__$3.setup = __setup__$3 ? (props4, ctx) => {
  __injectCSSVars__$3();
  return __setup__$3(props4, ctx);
} : __injectCSSVars__$3;
const _hoisted_1$13 = ["data-automation"];
const _hoisted_2$S = ["data-automation"];
function _sfc_render$19(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QColor = resolveComponent("QColor");
  const _component_QMenu = resolveComponent("QMenu");
  const _component_ActionButton = resolveComponent("ActionButton");
  return openBlock(), createElementBlock("div", {
    class: "color-picker",
    "data-automation": _ctx.buildId()
  }, [
    createVNode(_component_ActionButton, {
      "data-automation": _ctx.buildId("button"),
      disable: _ctx.disable,
      selected: "",
      tertiary: ""
    }, {
      default: withCtx(() => [
        createElementVNode("div", {
          class: "color-picker__indicator",
          "data-automation": _ctx.buildId("indicator")
        }, null, 8, _hoisted_2$S),
        createVNode(_component_QMenu, {
          anchor: "top left",
          "auto-close": "",
          offset: [0, 0],
          self: "top left"
        }, {
          default: withCtx(() => [
            createVNode(_component_QColor, {
              modelValue: _ctx.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.value = $event),
              class: "color-picker__palette q-pa-sm",
              "data-automation": _ctx.buildId("palette"),
              "default-view": "palette",
              "no-footer": "",
              "no-header": ""
            }, null, 8, ["modelValue", "data-automation"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data-automation", "disable"])
  ], 8, _hoisted_1$13);
}
const ColorPickerV2 = /* @__PURE__ */ _export_sfc$1(__default__$3, [["render", _sfc_render$19], ["__scopeId", "data-v-4f737bce"]]);
const _sfc_main$1g = defineComponent({
  name: "CombinedInputs",
  components: {
    EllipsisText,
    Input,
    QIcon: QIcon_default$1,
    Tooltip: Tooltip2
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Render text below first input
     */
    hint: {
      type: String,
      default: "Length x width"
    },
    /**
     * Render info icon with tooltip. Can be used as an "info-text" property or as a slot
     */
    infoText: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to the info text
     */
    infoTextClass: {
      type: String,
      default: "rv-combined-inputs__info-text"
    },
    /**
     * Render text above first input
     */
    label: {
      type: String,
      required: true
    },
    /**
     * Classes applied to the label
     * @type {[Array, Object, String]}
     */
    labelClass: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Text that appears in the form control when it has no value set
     */
    placeholders: {
      type: Array,
      default: () => []
    },
    /**
     * The text that will be shown next to label
     */
    optionalLabel: {
      type: String,
      default: ""
    },
    /**
     * Text displayed between inputs
     */
    separator: {
      type: String,
      default: "X"
    },
    /**
     * Show optional label next to label
     */
    showOptionalLabel: {
      type: Boolean,
      default: false
    },
    /**
     * v-model for inputs
     */
    modelValue: {
      type: Array,
      required: true
    },
    /**
     * Validation rules
     */
    validation: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      type: Array,
      default: void 0
    }
  },
  emits: [
    /**
     * Emitted when value is updated
     *
     * @type {object}
     */
    "update:model-value"
  ],
  setup(props4, { emit }) {
    const { t: t22 } = useI18n();
    const { isDark } = useDarkMode();
    const valuesRef = ref$1(props4.modelValue);
    const error = computed(() => {
      var _a;
      return (_a = props4.validation) == null ? void 0 : _a.some((v) => v == null ? void 0 : v.$error);
    });
    const errorMessage = computed(() => {
      if (!props4.validation) return void 0;
      if (props4.validation.every((v) => !v.$error)) return void 0;
      const errorMessages = props4.validation.map((v) => {
        var _a;
        return (_a = v.$errors[0]) == null ? void 0 : _a.$message;
      }).filter(Boolean);
      return errorMessages[0];
    });
    const isValidated = computed(() => {
      if (!props4.validation) return false;
      return props4.validation.every((v) => v.$dirty && !v.$invalid);
    });
    function onUpdate(value2, index2) {
      const updated = [...props4.modelValue];
      updated[index2] = value2;
      valuesRef.value = updated;
      emit("update:model-value", updated);
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      error,
      errorMessage,
      isDark,
      isValidated,
      onUpdate,
      t: t22,
      values: valuesRef
    };
  }
});
const _hoisted_1$12 = ["data-automation"];
const _hoisted_2$R = { class: "row no-wrap items-center full-width" };
const _hoisted_3$J = {
  key: 0,
  class: "q-ml-xs"
};
const _hoisted_4$s = { class: "rv-combined-inputs row justify-between no-wrap align-center" };
const _hoisted_5$n = {
  key: 0,
  class: "rv-combined-inputs__separator flex items-center q-px-sm"
};
const _hoisted_6$e = ["data-automation"];
const _hoisted_7$c = { class: "q-field__bottom" };
const _hoisted_8$8 = ["data-automation"];
const _hoisted_9$7 = { class: "q-field__bottom" };
function _sfc_render$18(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_Input = resolveComponent("Input");
  return openBlock(), createElementBlock("div", {
    "data-automation": _ctx.buildId()
  }, [
    createElementVNode("div", {
      class: normalizeClass(["rv-combined-inputs__field", { "rv-combined-inputs--disabled": _ctx.disable }])
    }, [
      _ctx.label ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(["rv-combined-inputs__label flex justify-between items-center", _ctx.labelClass])
      }, [
        createElementVNode("span", _hoisted_2$R, [
          createVNode(_component_EllipsisText, {
            class: "text-subtitle3",
            "data-automation": _ctx.buildId("label"),
            text: _ctx.label
          }, null, 8, ["data-automation", "text"]),
          _ctx.showOptionalLabel ? (openBlock(), createElementBlock("div", _hoisted_3$J, toDisplayString(_ctx.optionalLabel || _ctx.t("rvai-base.general.inputs.optional")), 1)) : createCommentVNode("", true),
          _ctx.infoText || _ctx.$slots["infoText"] ? (openBlock(), createBlock(_component_QIcon, {
            key: 1,
            class: "q-ml-xs info-icon",
            color: "black-1",
            "data-automation": _ctx.buildId("icon-info"),
            name: "info",
            size: "16px"
          }, {
            default: withCtx(() => [
              createVNode(_component_Tooltip, {
                anchor: "top middle",
                class: normalizeClass(_ctx.infoTextClass),
                self: "bottom middle"
              }, {
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, "infoText", {}, () => [
                    createTextVNode(toDisplayString(_ctx.infoText), 1)
                  ], true)
                ]),
                _: 3
              }, 8, ["class"])
            ]),
            _: 3
          }, 8, ["data-automation"])) : createCommentVNode("", true)
        ]),
        renderSlot(_ctx.$slots, "label-append", {}, void 0, true)
      ], 2)) : createCommentVNode("", true),
      createElementVNode("div", _hoisted_4$s, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.values, (value2, index2) => {
          return openBlock(), createElementBlock(Fragment, { key: index2 }, [
            index2 ? (openBlock(), createElementBlock("span", _hoisted_5$n, toDisplayString(_ctx.separator), 1)) : createCommentVNode("", true),
            createVNode(_component_Input, {
              "data-automation": _ctx.buildId(index2.toString()),
              disable: _ctx.disable,
              "model-value": value2,
              placeholder: _ctx.placeholders[index2],
              "onUpdate:modelValue": ($event) => _ctx.onUpdate($event, index2)
            }, null, 8, ["data-automation", "disable", "model-value", "placeholder", "onUpdate:modelValue"])
          ], 64);
        }), 128)),
        _ctx.isValidated ? (openBlock(), createBlock(_component_QIcon, {
          key: "valid",
          class: "rv-combined-inputs__icon q-pl-sm",
          color: "positive",
          "data-automation": _ctx.buildId("icon-valid"),
          name: "mdi-check-circle",
          size: "24px"
        }, null, 8, ["data-automation"])) : _ctx.error ? (openBlock(), createBlock(_component_QIcon, {
          key: "error",
          class: "rv-combined-inputs__icon q-pl-sm",
          color: "negative",
          "data-automation": _ctx.buildId("icon-error"),
          name: "mdi-close-circle",
          size: "24px"
        }, null, 8, ["data-automation"])) : createCommentVNode("", true)
      ]),
      _ctx.error ? (openBlock(), createElementBlock("div", {
        key: 1,
        class: "q-field--dense q-field--error",
        "data-automation": _ctx.buildId("error")
      }, [
        createElementVNode("div", _hoisted_7$c, toDisplayString(_ctx.errorMessage), 1)
      ], 8, _hoisted_6$e)) : _ctx.hint ? (openBlock(), createElementBlock("div", {
        key: 2,
        class: normalizeClass(["q-field--dense q-field--hint", { "q-field--dark": _ctx.isDark }]),
        "data-automation": _ctx.buildId("hint")
      }, [
        createElementVNode("div", _hoisted_9$7, toDisplayString(_ctx.hint), 1)
      ], 10, _hoisted_8$8)) : createCommentVNode("", true)
    ], 2)
  ], 8, _hoisted_1$12);
}
const CombinedInputs = /* @__PURE__ */ _export_sfc$1(_sfc_main$1g, [["render", _sfc_render$18], ["__scopeId", "data-v-2b7d392f"]]);
const DETAILED_ROW_MIN_HEIGHT = 24;
const _sfc_main$1f = defineComponent({
  name: "ConfusionMatrix",
  components: {
    Avatar,
    Bullet,
    EllipsisText,
    QResizeObserver: QResizeObserver_default$1,
    Tooltip: Tooltip2
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to the Histogram
     * @type {[Array, Object, String]}
     */
    classes: {
      type: Array,
      required: true
    },
    /**
     * Dense mode; occupies less space
     */
    dense: {
      type: Boolean,
      default: false
    },
    /**
     * Detailed mode; Show like in full mode
     */
    detailed: {
      type: Boolean,
      default: false
    },
    /**
     * Matrix model
     */
    matrix: {
      type: Object,
      required: true
    },
    /**
     * Set max visible rows; if not set - visible all rows
     */
    maxVisibleRows: {
      type: Number,
      default: void 0
    },
    /**
     * Allows to select multiple cells when 'command' or 'ctrl' is pressed
     */
    multipleSelection: {
      type: Boolean,
      default: false
    },
    /**
     * Overrides colors for current user avatar
     */
    overrideCurrentUserAvatar: {
      type: Boolean,
      default: false
    },
    /**
     * v-model:selected; allows handling selected entry
     */
    /**
     * Overrides the default header label for the "no annotations" column/row
     */
    noAnnotationLabel: {
      type: String,
      default: () => useI18n().t("rvai-base.components.confusionMatrix.noAnnotation")
    },
    selected: {
      type: Object,
      default: void 0
    },
    /**
     * Emits 'update:selected' with source ids, when true
     */
    selectable: {
      type: Boolean,
      default: false
    },
    /**
     * Shows class name or class id
     */
    showClassName: {
      type: Boolean,
      default: false
    },
    /**
     * Shows 'Match' text
     */
    showMatchWord: {
      type: Boolean,
      default: false
    },
    /**
     * Data source 1
     */
    source1: {
      type: Object,
      required: true
    },
    /**
     * Data source 2
     */
    source2: {
      type: Object,
      required: true
    },
    /**
     * Always render borders between cells
     */
    withBorders: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:selected"],
  setup(props4, { emit }) {
    var _a, _b, _c;
    const { t: t22 } = useI18n();
    const { isDark } = useDarkMode();
    const confusionMatrixRef = ref$1(null);
    const confusionMatrixTableRef = ref$1(null);
    const contentWidth = ref$1(0);
    const matrixWidth = ref$1(((_a = confusionMatrixRef.value) == null ? void 0 : _a.offsetWidth) ?? 0);
    const matrixHeight = ref$1(((_b = confusionMatrixRef.value) == null ? void 0 : _b.offsetHeight) ?? 0);
    const tableHeight = ref$1(((_c = confusionMatrixTableRef.value) == null ? void 0 : _c.offsetHeight) ?? 0);
    const reduced = ref$1(false);
    const classes1 = computed(() => {
      const ids = props4.matrix.getClasses1();
      return ids.map(getClass).filter(Boolean).sort(sortClasses);
    });
    const classes2 = computed(() => {
      const ids = props4.matrix.getClasses2();
      return ids.map(getClass).filter(Boolean).sort(sortClasses);
    });
    const cssVars = computed(() => {
      return {
        ...props4.maxVisibleRows && { "--max-rows": 2 + props4.maxVisibleRows },
        "--matrix-cell-width": `${matrixCellWidth.value}px`,
        "--matrix-row-height": `${matrixRowHeight.value}px`,
        "--matrix-size": `${matrixWidth.value}px`
      };
    });
    const hasSquareBackground = computed(() => props4.dense || props4.detailed);
    const matrixCellWidth = computed(() => matrixWidth.value / (classes1.value.length + 2));
    const matrixRowHeight = computed(() => {
      return Math.max(
        (props4.detailed ? tableHeight.value : matrixHeight.value) / (classes2.value.length + (props4.detailed ? 3 : 2)),
        props4.detailed ? DETAILED_ROW_MIN_HEIGHT : 0
      );
    });
    const renderBorders = computed(() => matrixWidth.value / classes2.value.length > 30);
    function getClass(id3) {
      const clazz = props4.classes.find((c3) => c3.id === id3);
      if (clazz) {
        return clazz;
      }
      return {
        color: "#ff0000",
        id: id3,
        name: id3 === NULL_CLASS_ID ? props4.noAnnotationLabel : id3
      };
    }
    function getClassName(clazz) {
      if (clazz.id === NULL_CLASS_ID) return props4.noAnnotationLabel;
      return props4.showClassName ? clazz.name ?? clazz.id : clazz.id;
    }
    function isSelected(id1, id22) {
      if (!props4.selected || !props4.selected.length) return false;
      return props4.selected.some((x22) => x22.source1 === id1 && x22.source2 === id22);
    }
    let maxTableWidth = 0;
    function calculateMatrixSize() {
      var _a2, _b2, _c2, _d;
      const count = classes2.value.length;
      if (!count) return;
      const fixed = props4.dense ? 64 : 200;
      const limit2 = props4.dense ? 16 : 100;
      const available = contentWidth.value - fixed;
      const cellWidth = available / count;
      const tableWidth = ((_a2 = confusionMatrixTableRef.value) == null ? void 0 : _a2.offsetWidth) ?? 0;
      tableHeight.value = ((_b2 = confusionMatrixTableRef.value) == null ? void 0 : _b2.offsetHeight) ?? 0;
      if (tableWidth > contentWidth.value) {
        maxTableWidth = tableWidth > maxTableWidth ? tableWidth : maxTableWidth;
      }
      reduced.value = cellWidth < limit2 || contentWidth.value < maxTableWidth;
      matrixWidth.value = ((_c2 = confusionMatrixRef.value) == null ? void 0 : _c2.offsetWidth) ?? 0;
      matrixHeight.value = ((_d = confusionMatrixRef.value) == null ? void 0 : _d.offsetHeight) ?? 0;
    }
    function onResize({ width }) {
      contentWidth.value = width;
      calculateMatrixSize();
    }
    function select(event, id1, id22) {
      var _a2;
      if (!props4.selectable) return;
      if (isSelected(id1, id22)) {
        emit(
          "update:selected",
          props4.multipleSelection && (event.metaKey || event.ctrlKey) ? (_a2 = props4.selected) == null ? void 0 : _a2.filter((x22) => !(x22.source1 === id1 && x22.source2 === id22)) : void 0
        );
      } else {
        emit(
          "update:selected",
          props4.multipleSelection && (event.metaKey || event.ctrlKey) ? [
            ...props4.selected ?? [],
            {
              source1: id1 || void 0,
              source2: id22 || void 0
            }
          ] : [{
            source1: id1 || void 0,
            source2: id22 || void 0
          }]
        );
      }
    }
    function selectAllOutliers() {
      if (!props4.selectable) return;
      emit("update:selected", props4.matrix.getOutliers());
    }
    function deselectAllOutliers() {
      var _a2;
      emit("update:selected", (_a2 = props4.selected) == null ? void 0 : _a2.filter((cell) => cell.source1 === cell.source2));
    }
    function sortClasses(a32, b22) {
      if (a32.id === NULL_CLASS_ID && b22.id !== NULL_CLASS_ID) return -1;
      if (b22.id === NULL_CLASS_ID && a32.id !== NULL_CLASS_ID) return 1;
      if (a32.id === UNKNOWN_CLASS_ID && b22.id !== UNKNOWN_CLASS_ID) return -1;
      if (b22.id === UNKNOWN_CLASS_ID && a32.id !== UNKNOWN_CLASS_ID) return 1;
      return naturalSort(a32.name, b22.name);
    }
    function generateCSV() {
      var _a2, _b2, _c2;
      const headerRow = [
        "",
        props4.source2.name,
        ...(_a2 = classes1.value) == null ? void 0 : _a2.map((item) => getClassName(item)),
        t22("rvai-base.components.confusionMatrix.matchPercentage")
      ].map((value2) => value2.toString().replace(/,/g, ".")).join(",");
      const subheaderRow = [
        props4.source1.name,
        "",
        ...(_b2 = classes1.value) == null ? void 0 : _b2.map((item) => item.id === NULL_CLASS_ID || item.id === null ? "" : item.id),
        ""
      ].map((value2) => value2.toString().replace(/,/g, ".")).join(",");
      const dataRows = classes2.value.map((class2) => {
        const row = [
          getClassName(class2),
          class2.id === NULL_CLASS_ID || class2.id === null ? "" : class2.id,
          ...classes1.value.map((class1) => props4.matrix.getValue(class2.id, class1.id)),
          props4.matrix.getMetric1(class2.id)
        ].map((value2) => value2.toString().replace(/,/g, ".")).join(",");
        return row;
      }).join("\n");
      const matchRow = [
        t22("rvai-base.components.confusionMatrix.matchPercentage"),
        "",
        ...(_c2 = classes1.value) == null ? void 0 : _c2.map((item) => props4.matrix.getMetric2(item.id)),
        props4.matrix.getMetricTotal()
      ].map((value2) => value2.toString().replace(/,/g, ".")).join(",");
      const csv = `${headerRow}
${subheaderRow}
${dataRows}
${matchRow}`;
      return csv;
    }
    watch(() => props4.detailed, (value2, prevValue) => {
      if (prevValue && !value2) {
        maxTableWidth = 0;
        calculateMatrixSize();
      }
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      classes1,
      classes2,
      confusionMatrixRef,
      confusionMatrixTableRef,
      cssVars,
      deselectAllOutliers,
      generateCSV,
      getClassName,
      hasSquareBackground,
      isDark,
      isSelected,
      NULL_CLASS_ID,
      onResize,
      reduced,
      renderBorders,
      select,
      selectAllOutliers,
      t: t22
    };
  }
});
const _hoisted_1$11 = ["data-automation"];
const _hoisted_2$Q = { class: "col-auto q-py-xs" };
const _hoisted_3$I = { class: "row no-wrap items-center text-bold" };
const _hoisted_4$r = ["data-automation"];
const _hoisted_5$m = {
  key: 0,
  class: "confusion-matrix__cell confusion-matrix__cell--header confusion-matrix__cell--left"
};
const _hoisted_6$d = { class: "row items-center text-bold no-wrap" };
const _hoisted_7$b = { class: "q-ml-sm zero-min-width" };
const _hoisted_8$7 = ["data-automation", "onClick"];
const _hoisted_9$6 = { class: "flex inline items-center no-wrap" };
const _hoisted_10$4 = ["data-automation"];
const _hoisted_11$4 = { class: "confusion-matrix__cell-wrapper" };
const _hoisted_12$3 = ["data-automation"];
const _hoisted_13$3 = ["onClick"];
const _hoisted_14$2 = ["data-automation"];
const _hoisted_15$2 = ["data-automation", "onClick"];
const _hoisted_16$1 = {
  key: 0,
  class: "confusion-matrix__cell--null"
};
const _hoisted_17$1 = {
  key: 1,
  class: "confusion-matrix__cell-value q-px-xs"
};
const _hoisted_18$1 = { class: "row no-wrap items-center q-mt-sm" };
const _hoisted_19$1 = { class: "row no-wrap items-center q-mt-sm" };
const _hoisted_20$1 = {
  key: 0,
  class: "confusion-matrix__cell--null"
};
const _hoisted_21$1 = { class: "confusion-matrix__cell-wrapper confusion-matrix__cell-value text-bold" };
const _hoisted_22 = {
  key: 0,
  class: "confusion-matrix__cell confusion-matrix__cell--left text-bold"
};
const _hoisted_23 = ["data-automation"];
const _hoisted_24 = {
  key: 0,
  class: "confusion-matrix__cell--null"
};
const _hoisted_25 = { class: "confusion-matrix__cell-value" };
const _hoisted_26 = { class: "confusion-matrix__cell-wrapper text-bold" };
function _sfc_render$17(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Avatar = resolveComponent("Avatar");
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_QResizeObserver = resolveComponent("QResizeObserver");
  const _component_Bullet = resolveComponent("Bullet");
  const _component_Tooltip = resolveComponent("Tooltip");
  return openBlock(), createElementBlock("div", {
    ref: "confusionMatrixRef",
    class: normalizeClass(["confusion-matrix bg-white text-small text-grey-1", {
      "confusion-matrix--borders-x": _ctx.withBorders,
      "confusion-matrix--borders-y": _ctx.renderBorders || _ctx.withBorders,
      "confusion-matrix--dense": _ctx.dense,
      "confusion-matrix--superdense": _ctx.dense && _ctx.reduced,
      "confusion-matrix--selectable": _ctx.selectable,
      "confusion-matrix--square": _ctx.hasSquareBackground
    }]),
    "data-automation": _ctx.buildId(),
    style: normalizeStyle(_ctx.cssVars)
  }, [
    !_ctx.dense ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass(["confusion-matrix__before row justify-center full-width bg-white", { "q-pb-xs": _ctx.detailed }])
    }, [
      createElementVNode("div", _hoisted_2$Q, [
        renderSlot(_ctx.$slots, "source2", {}, () => [
          createElementVNode("div", _hoisted_3$I, [
            createVNode(_component_Avatar, {
              "background-color": _ctx.overrideCurrentUserAvatar && _ctx.source2.isCurrent ? "white" : _ctx.source2.color,
              "border-color": _ctx.overrideCurrentUserAvatar && _ctx.source2.isCurrent ? "grey-1" : "white",
              "data-automation": _ctx.buildId("source2"),
              initials: _ctx.source2.initials,
              label: _ctx.source2.name,
              "show-logo": !_ctx.source2.initials && !_ctx.source2.isUser,
              "text-color": _ctx.overrideCurrentUserAvatar && _ctx.source2.isCurrent ? "grey-1" : "",
              uuid: _ctx.source2.id
            }, null, 8, ["background-color", "border-color", "data-automation", "initials", "label", "show-logo", "text-color", "uuid"]),
            createVNode(_component_EllipsisText, {
              class: "q-ml-sm",
              "data-automation": _ctx.buildId("source2__label"),
              text: _ctx.source2.name
            }, null, 8, ["data-automation", "text"])
          ])
        ], true)
      ])
    ], 2)) : createCommentVNode("", true),
    createElementVNode("div", {
      class: normalizeClass(["confusion-matrix__wrapper", { "confusion-matrix__wrapper--detailed": _ctx.detailed }])
    }, [
      createVNode(_component_QResizeObserver, { onResize: _ctx.onResize }, null, 8, ["onResize"]),
      createElementVNode("div", {
        ref: "confusionMatrixTableRef",
        class: "confusion-matrix__table",
        "data-automation": _ctx.buildId("table")
      }, [
        !_ctx.dense || !_ctx.reduced ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(["confusion-matrix__header bg-grey-5 text-bold", { "confusion-matrix__header--detailed": _ctx.detailed }])
        }, [
          !_ctx.dense || !_ctx.reduced ? (openBlock(), createElementBlock("div", _hoisted_5$m, [
            !_ctx.dense ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass(["confusion-matrix__cell-wrapper", { "q-ml-sm": _ctx.detailed }])
            }, [
              renderSlot(_ctx.$slots, "source1", {}, () => [
                createElementVNode("div", _hoisted_6$d, [
                  createVNode(_component_Avatar, {
                    "background-color": _ctx.overrideCurrentUserAvatar && _ctx.source1.isCurrent ? "white" : _ctx.source1.color,
                    "border-color": _ctx.overrideCurrentUserAvatar && _ctx.source1.isCurrent ? "grey-1" : "white",
                    "data-automation": _ctx.buildId("source1"),
                    initials: _ctx.source1.initials,
                    label: _ctx.source1.name,
                    "show-logo": !_ctx.source1.initials && !_ctx.source1.isUser,
                    "text-color": _ctx.overrideCurrentUserAvatar && _ctx.source1.isCurrent ? "grey-1" : "",
                    uuid: _ctx.source1.id
                  }, null, 8, ["background-color", "border-color", "data-automation", "initials", "label", "show-logo", "text-color", "uuid"]),
                  createElementVNode("div", _hoisted_7$b, [
                    createVNode(_component_EllipsisText, {
                      "data-automation": _ctx.buildId("source1__label"),
                      text: _ctx.source1.name
                    }, null, 8, ["data-automation", "text"])
                  ])
                ])
              ], true)
            ], 2)) : createCommentVNode("", true)
          ])) : createCommentVNode("", true),
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.classes2, (class2, index2) => {
            return openBlock(), createElementBlock("div", {
              key: class2.id,
              class: normalizeClass(["confusion-matrix__cell confusion-matrix__cell--header", {
                "confusion-matrix__cell--last": index2 + 1 === _ctx.classes2.length,
                "confusion-matrix__cell--selected": _ctx.isSelected(void 0, class2.id)
              }]),
              "data-automation": _ctx.buildId(`cell--header-${class2.id}`),
              onClick: ($event) => _ctx.select($event, void 0, class2.id)
            }, [
              createElementVNode("div", _hoisted_9$6, [
                class2.id !== _ctx.NULL_CLASS_ID ? (openBlock(), createBlock(_component_Bullet, {
                  key: 0,
                  class: normalizeClass(["col-fixed", {
                    "q-mr-xs": !_ctx.reduced && !_ctx.dense && class2.id !== _ctx.NULL_CLASS_ID
                  }]),
                  color: class2.color,
                  "data-automation": _ctx.buildId(`cell--header-${class2.id}__bullet`),
                  size: "8"
                }, null, 8, ["class", "color", "data-automation"])) : createCommentVNode("", true),
                !_ctx.reduced && !_ctx.dense ? (openBlock(), createBlock(_component_EllipsisText, {
                  key: 1,
                  "data-automation": _ctx.buildId(`cell--header-${class2.id}__label`),
                  text: _ctx.getClassName(class2)
                }, null, 8, ["data-automation", "text"])) : class2.id === _ctx.NULL_CLASS_ID ? (openBlock(), createElementBlock("span", {
                  key: 2,
                  "data-automation": _ctx.buildId(`cell--header-${class2.id}__label`)
                }, toDisplayString(_ctx.t("rvai-base.general.text.no")), 9, _hoisted_10$4)) : createCommentVNode("", true),
                _ctx.reduced || _ctx.dense ? (openBlock(), createBlock(_component_Tooltip, {
                  key: 3,
                  "data-automation": _ctx.buildId(`cell--header-${class2.id}__tooltip`)
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(_ctx.getClassName(class2)), 1)
                  ]),
                  _: 2
                }, 1032, ["data-automation"])) : createCommentVNode("", true)
              ])
            ], 10, _hoisted_8$7);
          }), 128)),
          createElementVNode("div", {
            class: normalizeClass(["confusion-matrix__cell confusion-matrix__cell--header confusion-matrix__cell--right", { "confusion-matrix__cell--right--detailed": _ctx.detailed }])
          }, [
            createElementVNode("div", _hoisted_11$4, toDisplayString(!_ctx.dense && !_ctx.detailed ? _ctx.t("rvai-base.components.confusionMatrix.matchPercentage") : _ctx.t("rvai-base.general.symbols.percentage")), 1)
          ], 2)
        ], 2)) : createCommentVNode("", true),
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.classes1, (class1, index1) => {
          return openBlock(), createElementBlock("div", {
            key: class1.id,
            class: normalizeClass(["confusion-matrix__row", {
              "confusion-matrix__row--last": index1 + 1 === _ctx.classes1.length
            }]),
            "data-automation": _ctx.buildId(`row-${class1.id}`)
          }, [
            !_ctx.dense || !_ctx.reduced ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass(["confusion-matrix__cell confusion-matrix__cell--left text-bold", { "confusion-matrix__cell--selected": _ctx.isSelected(class1.id, void 0) }]),
              onClick: ($event) => _ctx.select($event, class1.id, void 0)
            }, [
              createElementVNode("div", {
                class: normalizeClass(["confusion-matrix__cell-wrapper flex inline items-center no-wrap", { "q-ml-sm": _ctx.detailed }])
              }, [
                class1.id !== _ctx.NULL_CLASS_ID ? (openBlock(), createBlock(_component_Bullet, {
                  key: 0,
                  class: normalizeClass(["col-fixed", {
                    "q-mr-xs": !_ctx.dense && class1.id !== _ctx.NULL_CLASS_ID
                  }]),
                  color: class1.color,
                  "data-automation": _ctx.buildId(`row-${class1.id}__bullet`),
                  size: "8"
                }, null, 8, ["class", "color", "data-automation"])) : createCommentVNode("", true),
                !_ctx.dense ? (openBlock(), createBlock(_component_EllipsisText, {
                  key: 1,
                  "data-automation": _ctx.buildId(`row-${class1.id}__label`),
                  text: _ctx.getClassName(class1)
                }, null, 8, ["data-automation", "text"])) : class1.id === _ctx.NULL_CLASS_ID ? (openBlock(), createElementBlock("span", {
                  key: 2,
                  "data-automation": _ctx.buildId(`row-${class1.id}__label`)
                }, toDisplayString(_ctx.t("rvai-base.general.text.no")), 9, _hoisted_14$2)) : createCommentVNode("", true)
              ], 2)
            ], 10, _hoisted_13$3)) : createCommentVNode("", true),
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.classes2, (class2, index2) => {
              return openBlock(), createElementBlock("div", {
                key: class2.id,
                class: normalizeClass(["confusion-matrix__cell confusion-matrix__cell--content", {
                  "confusion-matrix__cell--last": index2 + 1 === _ctx.classes2.length,
                  "confusion-matrix__cell--selected": _ctx.isSelected(class1.id, class2.id)
                }]),
                "data-automation": _ctx.buildId(`cell--content-${class2.id}`),
                style: normalizeStyle(_ctx.matrix.getStyle(class1.id, class2.id, _ctx.isDark)),
                onClick: ($event) => _ctx.select($event, class1.id, class2.id)
              }, [
                class1.id === _ctx.NULL_CLASS_ID || class2.id === _ctx.NULL_CLASS_ID ? (openBlock(), createElementBlock("div", _hoisted_16$1)) : createCommentVNode("", true),
                !_ctx.dense ? (openBlock(), createElementBlock("div", _hoisted_17$1, toDisplayString(_ctx.matrix.getValue(class1.id, class2.id) || "-"), 1)) : createCommentVNode("", true),
                createVNode(_component_Tooltip, {
                  anchor: "center middle",
                  "data-automation": _ctx.buildId(`cell--content-${class2.id}__tooltip`),
                  self: "center left"
                }, {
                  default: withCtx(() => [
                    createElementVNode("div", null, [
                      createElementVNode("strong", null, toDisplayString(_ctx.matrix.getValue(class1.id, class2.id)), 1),
                      createTextVNode(" " + toDisplayString(_ctx.t("rvai-base.general.common.wordInBrackets", [_ctx.matrix.getPercentage(class1.id, class2.id)])), 1)
                    ]),
                    createElementVNode("div", _hoisted_18$1, [
                      createVNode(_component_Avatar, {
                        "background-color": _ctx.overrideCurrentUserAvatar && _ctx.source2.isCurrent ? "white" : _ctx.source2.color,
                        "border-color": _ctx.overrideCurrentUserAvatar && _ctx.source2.isCurrent ? "grey-1" : "white",
                        "data-automation": _ctx.buildId(`cell--content-${class2.id}__tooltip-avatar`),
                        initials: _ctx.source2.initials,
                        label: _ctx.source2.name,
                        "show-logo": !_ctx.source2.initials && !_ctx.source2.isUser,
                        "text-color": _ctx.overrideCurrentUserAvatar && _ctx.source2.isCurrent ? "grey-1" : "",
                        uuid: _ctx.source2.id
                      }, null, 8, ["background-color", "border-color", "data-automation", "initials", "label", "show-logo", "text-color", "uuid"]),
                      createVNode(_component_EllipsisText, {
                        class: "q-ml-sm",
                        "data-automation": _ctx.buildId(`cell--content-${class2.id}__tooltip-label`),
                        text: _ctx.getClassName(class2)
                      }, null, 8, ["data-automation", "text"])
                    ]),
                    createElementVNode("div", _hoisted_19$1, [
                      createVNode(_component_Avatar, {
                        "background-color": _ctx.overrideCurrentUserAvatar && _ctx.source1.isCurrent ? "white" : _ctx.source1.color,
                        "border-color": _ctx.overrideCurrentUserAvatar && _ctx.source1.isCurrent ? "grey-1" : "white",
                        "data-automation": _ctx.buildId(`cell--content-${class1.id}__tooltip-avatar`),
                        initials: _ctx.source1.initials,
                        label: _ctx.source1.name,
                        "show-logo": !_ctx.source1.initials && !_ctx.source1.isUser,
                        "text-color": _ctx.overrideCurrentUserAvatar && _ctx.source1.isCurrent ? "grey-1" : "",
                        uuid: _ctx.source1.id
                      }, null, 8, ["background-color", "border-color", "data-automation", "initials", "label", "show-logo", "text-color", "uuid"]),
                      createVNode(_component_EllipsisText, {
                        class: "q-ml-sm",
                        "data-automation": _ctx.buildId(`cell--content-${class1.id}__tooltip-label`),
                        text: _ctx.getClassName(class1)
                      }, null, 8, ["data-automation", "text"])
                    ])
                  ]),
                  _: 2
                }, 1032, ["data-automation"])
              ], 14, _hoisted_15$2);
            }), 128)),
            !_ctx.dense || !_ctx.reduced ? (openBlock(), createElementBlock("div", {
              key: 1,
              class: normalizeClass(["confusion-matrix__cell confusion-matrix__cell--match confusion-matrix__cell--right", { "confusion-matrix__cell--right--detailed": _ctx.detailed }])
            }, [
              class1.id === _ctx.NULL_CLASS_ID ? (openBlock(), createElementBlock("div", _hoisted_20$1)) : createCommentVNode("", true),
              createElementVNode("div", _hoisted_21$1, toDisplayString(_ctx.matrix.getMetric1(class1.id)), 1)
            ], 2)) : createCommentVNode("", true)
          ], 10, _hoisted_12$3);
        }), 128)),
        !_ctx.dense || !_ctx.reduced ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass(["confusion-matrix__footer bg-white", { "confusion-matrix__footer--detailed": _ctx.detailed }])
        }, [
          !_ctx.dense || !_ctx.reduced ? (openBlock(), createElementBlock("div", _hoisted_22, [
            createElementVNode("div", {
              class: normalizeClass(["confusion-matrix__cell-wrapper", { "q-ml-sm": _ctx.detailed }])
            }, toDisplayString(!_ctx.dense && !_ctx.detailed || _ctx.showMatchWord ? _ctx.t("rvai-base.components.confusionMatrix.matchPercentage") : _ctx.t("rvai-base.general.symbols.percentage")), 3)
          ])) : createCommentVNode("", true),
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.classes2, (class2, index2) => {
            return openBlock(), createElementBlock("div", {
              key: class2.id,
              class: normalizeClass(["confusion-matrix__cell text-bold", {
                "confusion-matrix__cell--last": index2 + 1 === _ctx.classes2.length
              }]),
              "data-automation": _ctx.buildId(`cell-${class2.id}`)
            }, [
              class2.id === _ctx.NULL_CLASS_ID ? (openBlock(), createElementBlock("div", _hoisted_24)) : createCommentVNode("", true),
              createElementVNode("div", _hoisted_25, toDisplayString(_ctx.matrix.getMetric2(class2.id)), 1)
            ], 10, _hoisted_23);
          }), 128)),
          createElementVNode("div", {
            class: normalizeClass(["confusion-matrix__cell confusion-matrix__cell--match confusion-matrix__cell--right", { "confusion-matrix__cell--right--detailed": _ctx.detailed }])
          }, [
            createElementVNode("div", _hoisted_26, toDisplayString(_ctx.matrix.getMetricTotal()), 1)
          ], 2)
        ], 2)) : createCommentVNode("", true)
      ], 8, _hoisted_4$r)
    ], 2)
  ], 14, _hoisted_1$11);
}
const ConfusionMatrix = /* @__PURE__ */ _export_sfc$1(_sfc_main$1f, [["render", _sfc_render$17], ["__scopeId", "data-v-bb9effb4"]]);
var Steps = /* @__PURE__ */ ((Steps2) => {
  Steps2["Action"] = "action";
  Steps2["Info"] = "info";
  return Steps2;
})(Steps || {});
const _sfc_main$1e = defineComponent({
  name: "CookiesDialog",
  components: {
    Button,
    QCard: QCard_default$1,
    QCardActions: QCardActions_default$1,
    QCardSection: QCardSection_default$1,
    QDialog: QDialog_default$1,
    QIcon: QIcon_default$1
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: "cookiesDialog"
    },
    /**
     * Provide cookies label for accept button
     */
    cookiesAcceptBtn: {
      type: String,
      default: void 0
    },
    /**
     * Provide cookies label for reject button
     */
    cookiesRejectBtn: {
      type: String,
      default: void 0
    },
    /**
     * Provide cookies title
     */
    cookiesTitle: {
      type: String,
      default: void 0
    },
    /**
     * Provide cookies URL to open in the iframe
     */
    cookiesUrl: {
      type: String,
      required: true
    },
    /**
     * Provide cookies dialog width
     */
    cookiesWidth: {
      type: String,
      default: "420px"
    }
  },
  emits: [
    ...useDialogPluginComponent.emits,
    /**
     * Emitted when a cookie policy has been accepted or rejected
     *
     * @type {object}
     */
    "set-cookies-policy"
  ],
  setup(props4) {
    const { t: t22 } = useI18n();
    const {
      dialogRef,
      onDialogCancel,
      onDialogHide,
      onDialogOK
    } = useDialogPluginComponent();
    const {
      hasCookiesPolicy,
      setCookiesPolicy
    } = useCookiesPolicy();
    const currentStep = ref$1(
      "action"
      /* Action */
    );
    function onAccept() {
      setCookiesPolicy(CookiesPolicy.All);
      onDialogOK();
    }
    function onReject() {
      setCookiesPolicy(CookiesPolicy.Required);
      onDialogOK();
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      CookiesPolicy,
      currentStep,
      dialogRef,
      hasCookiesPolicy,
      onAccept,
      onCancel: onDialogCancel,
      onHide: onDialogHide,
      onReject,
      setCookiesPolicy,
      Steps,
      t: t22
    };
  }
});
const _hoisted_1$10 = { class: "text-subtitle1 q-ml-sm" };
const _hoisted_2$P = ["data-automation"];
const _hoisted_3$H = ["data-automation", "src"];
function _sfc_render$16(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = resolveComponent("Button");
  const _component_QCardSection = resolveComponent("QCardSection");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_i18n_t = resolveComponent("i18n-t");
  const _component_QCardActions = resolveComponent("QCardActions");
  const _component_QCard = resolveComponent("QCard");
  const _component_QDialog = resolveComponent("QDialog");
  const _directive_quasar_variables = resolveDirective("quasar-variables");
  return openBlock(), createBlock(_component_QDialog, mergeProps({
    ref: "dialogRef",
    "data-automation": _ctx.buildId(),
    maximized: _ctx.currentStep === _ctx.Steps.Info,
    persistent: !_ctx.hasCookiesPolicy
  }, toHandlers(_ctx.$attrs), { onHide: _ctx.onHide }), {
    default: withCtx(() => [
      _ctx.currentStep === _ctx.Steps.Action ? (openBlock(), createBlock(_component_QCard, {
        key: 0,
        class: "rv-cookies-actions-dialog column no-wrap",
        "data-automation": _ctx.buildId("card1"),
        style: normalizeStyle({ width: _ctx.cookiesWidth })
      }, {
        default: withCtx(() => [
          _ctx.hasCookiesPolicy ? (openBlock(), createBlock(_component_QCardSection, {
            key: 0,
            class: "q-pb-none flex justify-end"
          }, {
            default: withCtx(() => [
              createVNode(_component_Button, {
                "data-automation": _ctx.buildId("close1"),
                icon: "mdi-close",
                tertiary: "",
                onClick: _ctx.onCancel
              }, null, 8, ["data-automation", "onClick"])
            ]),
            _: 1
          })) : createCommentVNode("", true),
          createVNode(_component_QCardSection, {
            class: normalizeClass(["row justify-center items-center", { "q-pt-none": _ctx.hasCookiesPolicy }])
          }, {
            default: withCtx(() => [
              createVNode(_component_QIcon, {
                color: "black-1",
                "data-automation": _ctx.buildId("icon-cookie"),
                name: "rvai-base:cookie",
                size: "36px"
              }, null, 8, ["data-automation"]),
              createElementVNode("span", _hoisted_1$10, toDisplayString(_ctx.cookiesTitle || _ctx.t("rvai-base.policiesAndLicenses.titles.cookies")), 1)
            ]),
            _: 1
          }, 8, ["class"]),
          createVNode(_component_QCardSection, { class: "rv-cookies-actions-dialog__content q-px-md q-py-none" }, {
            default: withCtx(() => [
              createVNode(_component_i18n_t, { keypath: "rvai-base.policiesAndLicenses.text.cookies" }, {
                here: withCtx(() => [
                  createElementVNode("a", {
                    class: "rv-cookies-actions-dialog__content--btn cursor-pointer",
                    "data-automation": _ctx.buildId("btn-info"),
                    onClick: _cache[0] || (_cache[0] = ($event) => _ctx.currentStep = _ctx.Steps.Info)
                  }, toDisplayString(_ctx.t("rvai-base.policiesAndLicenses.actions.cookies.here")), 9, _hoisted_2$P)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          createVNode(_component_QCardActions, { class: "row q-pa-md flex justify-end" }, {
            default: withCtx(() => [
              createVNode(_component_Button, {
                "data-automation": _ctx.buildId("reject"),
                label: _ctx.cookiesRejectBtn || _ctx.t("rvai-base.policiesAndLicenses.actions.cookies.reject"),
                secondary: "",
                onClick: _ctx.onReject
              }, null, 8, ["data-automation", "label", "onClick"]),
              createVNode(_component_Button, {
                color: "primary",
                "data-automation": _ctx.buildId("accept"),
                label: _ctx.cookiesAcceptBtn || _ctx.t("rvai-base.policiesAndLicenses.actions.cookies.accept"),
                onClick: _ctx.onAccept
              }, null, 8, ["data-automation", "label", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data-automation", "style"])) : createCommentVNode("", true),
      _ctx.currentStep === _ctx.Steps.Info ? (openBlock(), createBlock(_component_QCard, {
        key: 1,
        class: "rv-cookies-info-dialog column no-wrap",
        "data-automation": _ctx.buildId("card2")
      }, {
        default: withCtx(() => [
          createVNode(_component_QCardSection, { class: "q-pb-none flex justify-end" }, {
            default: withCtx(() => [
              createVNode(_component_Button, {
                "data-automation": _ctx.buildId("close2"),
                icon: "mdi-close",
                tertiary: "",
                onClick: _cache[1] || (_cache[1] = ($event) => _ctx.currentStep = _ctx.Steps.Action)
              }, null, 8, ["data-automation"])
            ]),
            _: 1
          }),
          createVNode(_component_QCardSection, { class: "full-width full-height" }, {
            default: withCtx(() => [
              withDirectives(createElementVNode("iframe", {
                "data-automation": _ctx.buildId("iframe"),
                frameborder: "0",
                height: "100%",
                src: _ctx.cookiesUrl,
                width: "100%"
              }, null, 8, _hoisted_3$H), [
                [_directive_quasar_variables]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data-automation"])) : createCommentVNode("", true)
    ]),
    _: 1
  }, 16, ["data-automation", "maximized", "persistent", "onHide"]);
}
const CookiesDialog = /* @__PURE__ */ _export_sfc$1(_sfc_main$1e, [["render", _sfc_render$16], ["__scopeId", "data-v-b81e446b"]]);
const _sfc_main$1d = defineComponent({
  name: "CopyContentBtn",
  components: {
    Button,
    Tooltip: Tooltip2
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    color: {
      type: String,
      default: "primary"
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Put component in 'flat' design
     */
    flat: {
      type: Boolean,
      default: true
    },
    /**
     * Icon name following Quasar convention; Make sure you have the icon library installed unless you are using 'img:' prefix
     */
    icon: {
      type: String,
      default: "mdi-content-copy"
    },
    /**
     * Text displayed next to icon
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Hides icon
     */
    noIcon: {
      type: Boolean,
      default: true
    },
    /**
     * Render button in secondary mode
     */
    secondary: {
      type: Boolean,
      default: false
    },
    /**
     * Shows default label after copying (by default 5000ms, can be changed with time-after-copying property)
     */
    showDefaultLabel: {
      type: Boolean,
      default: false
    },
    /**
     * Size in standard size name (xs|sm|md|lg)
     */
    size: {
      type: String,
      default: "md"
    },
    /**
     * The time in ms after which 'Copied' changes to default label. By default 5000ms.
     */
    timeAfterCopying: {
      type: Number,
      default: 5e3
    },
    /**
     * Text copied to clipboard
     */
    value: {
      type: String,
      required: true
    }
  },
  emits: ["click"],
  setup(props4, { emit }) {
    const { t: t22 } = useI18n();
    const copied = ref$1(false);
    const currentIcon = computed(() => {
      return props4.noIcon || copied.value ? void 0 : props4.icon;
    });
    const currentLabel = computed(() => {
      return copied.value ? t22("rvai-base.components.copyContentButton.copied") : props4.label;
    });
    async function copyToClipboard() {
      try {
        if ("clipboard" in navigator) {
          navigator.clipboard.writeText(props4.value);
        }
        const node = createNode(props4.value);
        document.body.appendChild(node);
        const selection = getSelection();
        if (!selection) throw new Error();
        selection.removeAllRanges();
        const range2 = document.createRange();
        range2.selectNodeContents(node);
        selection.addRange(range2);
        document.execCommand("copy");
        selection.removeAllRanges();
        document.body.removeChild(node);
        copied.value = true;
        if (props4.showDefaultLabel) {
          await wait(props4.timeAfterCopying);
          copied.value = false;
        }
      } catch (e22) {
        console.error("Failed to copy to clipboard", e22);
      } finally {
        emit("click");
      }
    }
    function createNode(text2) {
      const node = document.createElement("pre");
      node.style.height = "1px";
      node.style.position = "fixed";
      node.style.top = "5px";
      node.style.width = "1px";
      node.textContent = text2;
      return node;
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      copied,
      copyToClipboard,
      currentIcon,
      currentLabel,
      t: t22
    };
  }
});
function _sfc_render$15(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_Button = resolveComponent("Button");
  return openBlock(), createBlock(_component_Button, mergeProps(_ctx.dataAttrs, {
    class: ["copy-content-btn cursor-pointer", _ctx.$props.class],
    color: _ctx.disable ? "grey-2" : _ctx.color,
    "data-automation": _ctx.buildId(),
    disable: _ctx.disable,
    icon: _ctx.currentIcon,
    label: _ctx.currentLabel,
    secondary: _ctx.secondary,
    size: _ctx.size,
    tertiary: _ctx.flat,
    onClick: _cache[0] || (_cache[0] = () => _ctx.copyToClipboard())
  }), {
    default: withCtx(() => [
      !_ctx.disable && !_ctx.copied ? (openBlock(), createBlock(_component_Tooltip, { key: 0 }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(_ctx.t("rvai-base.components.copyContentButton.copy")), 1)
        ]),
        _: 1
      })) : createCommentVNode("", true)
    ]),
    _: 1
  }, 16, ["class", "color", "data-automation", "disable", "icon", "label", "secondary", "size", "tertiary"]);
}
const CopyContentBtn = /* @__PURE__ */ _export_sfc$1(_sfc_main$1d, [["render", _sfc_render$15]]);
const dateTimeSeparator = " ";
const timeSeparator = ":";
const DATE_FORMAT = "yyyy-MM-dd";
const DATE_REGEX = /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/g;
const DATE_WITH_FULL_TIME_FORMAT = "yyyy-MM-dd HH:mm:ss";
const DATE_WITH_TIME_FORMAT = "yyyy-MM-dd HH:mm";
const DATE_WITH_FULL_TIME_FORMAT_REGEX = /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])$/g;
const DATE_WITH_TIME_REGEX = /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|[01][0-9]):([0-5][0-9])$/g;
const __default__$2 = defineComponent({
  name: "DatePicker",
  components: {
    Input,
    QDate: QDate_default,
    QIcon: QIcon_default$1,
    QPopupProxy: QPopupProxy_default
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Dense mode; occupies less space
     */
    dense: {
      type: Boolean,
      default: false
    },
    /**
     * The text that will be shown above the input
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Custom localisation https://quasar.dev/vue-components/date#custom-ad-hoc-locale
     */
    locale: {
      type: Object,
      default: void 0
    },
    /**
     * if 'withTime' flag is selected, v-model has 'YYYY-MM-DD HH:mm:ss' format (or 'YYYY-MM-DD HH:mm' if withSeconds is false), otherwise 'YYYY-MM-DD'
     */
    modelValue: {
      type: String,
      required: true
    },
    /**
     * Optionally configure the days that are selectable;
     * If using a function, it receives the date as a String and must return a Boolean (is date acceptable or not);
     * If using a function then for best performance, reference it from your scope and do not define it inline;
     */
    options: {
      type: Function,
      default: () => true
    },
    /**
     * The text that will be shown above the input, next to 'label'
     */
    optionalLabel: {
      type: String,
      default: ""
    },
    /**
     * Placeholder inside input
     */
    placeholder: {
      type: String,
      default: ""
    },
    /**
     * Prevents or allows the user to clear the date value (eg. using the clear button).
     */
    clearable: {
      type: Boolean,
      default: true
    },
    /**
     * Render hint
     */
    showHint: {
      type: Boolean,
      default: true
    },
    /**
     * Render 'optional label'
     */
    showOptionalLabel: {
      type: Boolean,
      default: false
    },
    /**
     * Render validation error when input has focus
     */
    validationError: {
      type: String,
      default: ""
    },
    /**
     * Render time inputs
     */
    withTime: {
      type: Boolean,
      default: false
    },
    /**
     * Render seconds input, works with 'withTime'.
     * If false, seconds input will not be rendered and time will be in format 'HH:mm'
     */
    withSeconds: {
      type: Boolean,
      default: true
    },
    /**
     * Applies validation for component
     */
    withValidation: {
      type: Boolean,
      default: false
    },
    /**
     * Classes applied to wrapper div
     * @type {[Array, Object, String]}
     */
    wrapperClass: {
      type: [Array, Object, String],
      default: void 0
    }
  },
  emits: [
    /**
     * Emitted when component is updated
     *
     * @type {object}
     */
    "update:modelValue",
    /**
     * Emitted when input is updated
     *
     * @type {object}
     */
    "update:original-value"
  ],
  setup(props4, { emit }) {
    const { t: t22 } = useI18n();
    const isFocused = ref$1(false);
    const originalData = ref$1(props4.modelValue);
    const popupRef = ref$1(null);
    const inputRef = ref$1(null);
    const defaultLocale = {
      days: t22("rvai-base.components.datePicker.days").split("_"),
      daysShort: t22("rvai-base.components.datePicker.daysShort").split("_"),
      firstDayOfWeek: 0,
      months: t22("rvai-base.components.datePicker.months").toUpperCase().split("_"),
      monthsShort: t22("rvai-base.components.datePicker.monthsShort").toUpperCase().split("_")
    };
    const dateFormat = computed(() => {
      if (!props4.withTime) return DATE_FORMAT;
      return props4.withSeconds ? DATE_WITH_FULL_TIME_FORMAT : DATE_WITH_TIME_FORMAT;
    });
    const regex = computed(() => {
      if (!props4.withTime) return DATE_REGEX;
      return props4.withSeconds ? DATE_WITH_FULL_TIME_FORMAT_REGEX : DATE_WITH_TIME_REGEX;
    });
    const hours = ref$1("");
    function hoursBlur() {
      const v = hours.value ?? "00";
      const [
        dates,
        time
      ] = getCurrent().split(" ");
      const timeArray = time.split(":");
      const minutesString = timeArray[1] ?? "00";
      const secondsString = props4.withSeconds ? timeArray[2] ?? "00" : "";
      const regex1 = /^[0-9]$/gi;
      const regex2 = /^[0][1-9]$/gi;
      const regex3 = /^[0][1][0-9]$/gi;
      const regex4 = /^[0][2][0-3]$/gi;
      const regex5 = /^[2][0-3]$/gi;
      const regex6 = /^[1][0-9]$/gi;
      const regex7 = /^[0]+$/gi;
      const regex8 = /^[0][0][1-9]$/gi;
      const timeFormat = props4.withSeconds ? `:${secondsString}` : "";
      if (Number(v) > 23) {
        emit("update:modelValue", `${dates} 23:${minutesString}${timeFormat}`);
      } else if (regex1.test(v)) {
        emit("update:modelValue", `${dates} 0${v}:${minutesString}${timeFormat}`);
      } else if (regex2.test(v) || regex5.test(v) || regex6.test(v)) {
        emit("update:modelValue", `${dates} ${v}:${minutesString}${timeFormat}`);
      } else if (regex3.test(v) || regex4.test(v) || regex8.test(v)) {
        emit("update:modelValue", `${dates} ${v.substring(1, 3)}:${minutesString}${timeFormat}`);
      } else if (regex7.test(v)) {
        emit("update:modelValue", `${dates} 00:${minutesString}${timeFormat}`);
      }
    }
    const minutes = ref$1("");
    function minutesBlur() {
      const minutesValue = minutes.value ?? "00";
      const [
        dates,
        time
      ] = getCurrent().split(" ");
      const timeArray = time.split(":");
      const hoursString = timeArray[0] ?? "00";
      const secondsString = props4.withSeconds ? timeArray[2] ?? "00" : "";
      const regex1 = /^[0-9]$/gi;
      const regex2 = /^[0][1-9]$/gi;
      const regex3 = /^[0][0-5][0-9]$/gi;
      const regex4 = /^[1-5][0-9]$/gi;
      const regex5 = /^[0]+$/gi;
      const regex6 = /^[0][0][1-9]$/gi;
      const timeFormat = props4.withSeconds ? `:${secondsString}` : "";
      if (Number(minutesValue) > 60) {
        emit("update:modelValue", `${dates} ${hoursString}:59${timeFormat}`);
      } else if (regex1.test(minutesValue)) {
        emit("update:modelValue", `${dates} ${hoursString}:0${minutesValue}${timeFormat}`);
      } else if (regex2.test(minutesValue) || regex4.test(minutesValue)) {
        emit("update:modelValue", `${dates} ${hoursString}:${minutesValue}${timeFormat}`);
      } else if (regex3.test(minutesValue) || regex6.test(minutesValue)) {
        emit("update:modelValue", `${dates} ${hoursString}:${minutesValue.substring(1, 3)}${timeFormat}`);
      } else if (regex5.test(minutesValue)) {
        emit("update:modelValue", `${dates} ${hoursString}:00${timeFormat}`);
      }
    }
    const seconds = ref$1("");
    function secondsBlur() {
      const secondsValue = seconds.value ?? "00";
      const [
        dates,
        time
      ] = getCurrent().split(" ");
      const timeArray = time.split(":");
      const hoursString = timeArray[0] ?? "00";
      const minutesString = timeArray[1] ?? "00";
      const regex1 = /^[0-9]$/gi;
      const regex2 = /^[0][1-9]$/gi;
      const regex3 = /^[0][0-5][0-9]$/gi;
      const regex4 = /^[1-5][0-9]$/gi;
      const regex5 = /^[0]+$/gi;
      const regex6 = /^[0][0][1-9]$/gi;
      if (Number(secondsValue) > 60) {
        emit("update:modelValue", `${dates} ${hoursString}:${minutesString}:59`);
      } else if (regex1.test(secondsValue)) {
        emit("update:modelValue", `${dates} ${hoursString}:${minutesString}:0${secondsValue}`);
      } else if (regex2.test(secondsValue) || regex4.test(secondsValue)) {
        emit("update:modelValue", `${dates} ${hoursString}:${minutesString}:${secondsValue}`);
      } else if (regex3.test(secondsValue) || regex6.test(secondsValue)) {
        emit("update:modelValue", `${dates} ${hoursString}:${minutesString}:${secondsValue.substring(1, 3)}`);
      } else if (regex5.test(secondsValue)) {
        emit("update:modelValue", `${dates} ${hoursString}:${minutesString}:00`);
      }
    }
    const date = computed({
      get() {
        return props4.modelValue;
      },
      set(value2) {
        var _a;
        if (!props4.clearable && !value2) {
          return;
        }
        if (!value2) {
          emit("update:modelValue", "");
          return;
        }
        const v = getDateValue(value2);
        if (!props4.options(v)) return;
        if (v.length !== mask.value.length) return;
        if (new RegExp(regex.value).test(v)) {
          emit("update:modelValue", v);
        }
        if (popupRef.value && !props4.withTime) {
          popupRef.value.hide();
          (_a = inputRef.value) == null ? void 0 : _a.blur();
        }
      }
    });
    const mask = computed(() => {
      if (!props4.withTime) return "YYYY-MM-DD";
      return props4.withSeconds ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD HH:mm";
    });
    const messagesColor = computed(() => props4.withValidation && v$.value.$invalid ? "var(--q-negative)" : "var(--q-grey-1)");
    const validationRules = computed(() => ({
      originalData: ValidationBuilder.withLabel("Datepicker").custom(
        (value2) => !value2 || new RegExp(regex.value).test(value2),
        t22("rvai-base.components.datePicker.wrongFormat")
      ).customError(isFocused.value ? props4.validationError : "").rules
    }));
    const v$ = useVuelidate(
      validationRules,
      {
        originalData
      },
      { $autoDirty: true }
    );
    function getDateValue(value2) {
      const time = props4.withSeconds ? hours.value && minutes.value && seconds.value ? `${hours.value}:${minutes.value}:${seconds.value}` : "" : hours.value && minutes.value ? `${hours.value}:${minutes.value}` : "";
      return time && value2.split(" ")[1] !== time ? `${value2.split(" ")[0]} ${time}` : value2;
    }
    function getCurrent() {
      const today = startOfToday();
      const fullTimeFormat = props4.withSeconds ? DATE_WITH_FULL_TIME_FORMAT : DATE_WITH_TIME_FORMAT;
      if (props4.modelValue) {
        const parsed = parse$3(props4.modelValue, dateFormat.value, today);
        if (isValid(parsed)) {
          return format(parsed, fullTimeFormat);
        }
      }
      return format(today, fullTimeFormat);
    }
    function onBeforeHide() {
      var _a, _b;
      if (!props4.withTime) return;
      const timeParts = (_b = (_a = props4.modelValue) == null ? void 0 : _a.split(dateTimeSeparator)[1]) == null ? void 0 : _b.split(timeSeparator);
      const currHours = (timeParts == null ? void 0 : timeParts[0]) ?? "";
      const currMinutes = (timeParts == null ? void 0 : timeParts[1]) ?? "";
      const currSeconds = props4.withSeconds ? (timeParts == null ? void 0 : timeParts[2]) ?? "" : "";
      if (hours.value !== currHours) hoursBlur();
      if (minutes.value !== currMinutes) minutesBlur();
      if (props4.withSeconds && seconds.value !== currSeconds) secondsBlur();
    }
    function onBlur2() {
      isFocused.value = false;
      const v = originalData.value;
      if (!v) {
        originalData.value = props4.modelValue;
        return;
      }
      if (v.length !== mask.value.length || !new RegExp(regex.value).test(v) || !props4.options(v)) {
        originalData.value = props4.modelValue;
        return;
      }
      emit("update:modelValue", v);
    }
    function onFocus() {
      isFocused.value = true;
    }
    function resetDate() {
      originalData.value = "";
      emit("update:modelValue", "");
    }
    watch(() => props4.modelValue, (value2) => {
      var _a;
      originalData.value = value2;
      const timeParts = (_a = value2 == null ? void 0 : value2.split(dateTimeSeparator)[1]) == null ? void 0 : _a.split(timeSeparator);
      hours.value = (timeParts == null ? void 0 : timeParts[0]) ?? "";
      minutes.value = (timeParts == null ? void 0 : timeParts[1]) ?? "";
      seconds.value = props4.withSeconds ? (timeParts == null ? void 0 : timeParts[2]) ?? "" : "";
    }, { immediate: true });
    watch(originalData, () => {
      emit("update:original-value", originalData.value);
    }, { immediate: true });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      date,
      defaultLocale,
      hours,
      hoursBlur,
      inputRef,
      mask,
      messagesColor,
      minutes,
      minutesBlur,
      onBeforeHide,
      onBlur: onBlur2,
      onFocus,
      originalData,
      popupRef,
      resetDate,
      seconds,
      secondsBlur,
      t: t22,
      v$
    };
  }
});
const __injectCSSVars__$2 = () => {
  useCssVars((_ctx) => ({
    "5ec0f630": _ctx.messagesColor
  }));
};
const __setup__$2 = __default__$2.setup;
__default__$2.setup = __setup__$2 ? (props4, ctx) => {
  __injectCSSVars__$2();
  return __setup__$2(props4, ctx);
} : __injectCSSVars__$2;
const _hoisted_1$$ = ["data-automation"];
const _hoisted_2$O = { class: "rv-date" };
const _hoisted_3$G = ["data-automation"];
const _hoisted_4$q = {
  class: "q-mt-md q-mb-sm",
  style: { "margin-left": "13px", "margin-right": "13px" }
};
const _hoisted_5$l = {
  class: "flex flex-row no-wrap",
  style: { "margin-left": "11px", "margin-right": "11px" }
};
const _hoisted_6$c = { class: "q-px-sm flex items-center" };
const _hoisted_7$a = { class: "q-px-sm flex items-center" };
function _sfc_render$14(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Input = resolveComponent("Input");
  const _component_QDate = resolveComponent("QDate");
  const _component_QPopupProxy = resolveComponent("QPopupProxy");
  const _component_QIcon = resolveComponent("QIcon");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["rv-date-picker", [_ctx.wrapperClass, { "rv-date-picker--dense": _ctx.dense }]]),
    "data-automation": _ctx.buildId()
  }, [
    createVNode(_component_Input, {
      ref: "inputRef",
      modelValue: _ctx.originalData,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => _ctx.originalData = $event),
      "data-automation": _ctx.buildId("date"),
      hint: _ctx.showHint ? _ctx.mask : void 0,
      label: _ctx.label,
      maxlength: "0",
      "optional-label": _ctx.optionalLabel,
      placeholder: _ctx.placeholder,
      "show-optional-label": _ctx.showOptionalLabel,
      "show-valid": false,
      validation: _ctx.withValidation ? _ctx.v$.originalData : void 0,
      onBlur: _ctx.onBlur,
      onFocus: _ctx.onFocus
    }, {
      append: withCtx(() => [
        createVNode(_component_QIcon, {
          class: "cursor-pointer",
          color: "grey-1",
          "data-automation": _ctx.buildId("icon-calendar"),
          name: "rvai-base:calendar"
        }, {
          default: withCtx(() => [
            createVNode(_component_QPopupProxy, {
              ref: "popupRef",
              offset: [0, 5],
              onBeforeHide: _ctx.onBeforeHide
            }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_2$O, [
                  createVNode(_component_QDate, {
                    modelValue: _ctx.date,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.date = $event),
                    class: "rv-date",
                    "data-automation": _ctx.buildId("date-picker"),
                    locale: _ctx.locale ?? _ctx.defaultLocale,
                    mask: _ctx.mask,
                    minimal: "",
                    options: _ctx.options,
                    "years-in-month-view": false
                  }, {
                    default: withCtx(() => [
                      _ctx.withTime ? (openBlock(), createElementBlock("div", {
                        key: 0,
                        class: "border-top",
                        "data-automation": _ctx.buildId("with-time")
                      }, [
                        renderSlot(_ctx.$slots, "time-input-label", {}, () => [
                          createElementVNode("div", _hoisted_4$q, toDisplayString(_ctx.t("rvai-base.components.datePicker.selectTime")), 1)
                        ], true),
                        createElementVNode("div", _hoisted_5$l, [
                          createVNode(_component_Input, {
                            modelValue: _ctx.hours,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.hours = $event),
                            "data-automation": _ctx.buildId("hours"),
                            maxlength: "3",
                            placeholder: _ctx.t("rvai-base.components.datePicker.hh"),
                            onBlur: _ctx.hoursBlur
                          }, null, 8, ["modelValue", "data-automation", "placeholder", "onBlur"]),
                          createElementVNode("div", _hoisted_6$c, toDisplayString(_ctx.t("rvai-base.general.symbols.semicolon")), 1),
                          createVNode(_component_Input, {
                            modelValue: _ctx.minutes,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.minutes = $event),
                            "data-automation": _ctx.buildId("minutes"),
                            maxlength: "3",
                            placeholder: _ctx.t("rvai-base.components.datePicker.mm"),
                            onBlur: _ctx.minutesBlur
                          }, null, 8, ["modelValue", "data-automation", "placeholder", "onBlur"]),
                          _ctx.withSeconds ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                            createElementVNode("div", _hoisted_7$a, toDisplayString(_ctx.t("rvai-base.general.symbols.semicolon")), 1),
                            createVNode(_component_Input, {
                              modelValue: _ctx.seconds,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.seconds = $event),
                              "data-automation": _ctx.buildId("seconds"),
                              maxlength: "3",
                              placeholder: _ctx.t("rvai-base.components.datePicker.ss"),
                              onBlur: _ctx.secondsBlur
                            }, null, 8, ["modelValue", "data-automation", "placeholder", "onBlur"])
                          ], 64)) : createCommentVNode("", true)
                        ])
                      ], 8, _hoisted_3$G)) : createCommentVNode("", true)
                    ]),
                    _: 3
                  }, 8, ["modelValue", "data-automation", "locale", "mask", "options"])
                ])
              ]),
              _: 3
            }, 8, ["onBeforeHide"])
          ]),
          _: 3
        }, 8, ["data-automation"]),
        _ctx.clearable && _ctx.modelValue ? (openBlock(), createBlock(_component_QIcon, {
          key: 0,
          class: "cursor-pointer",
          color: "grey-1",
          "data-automation": _ctx.buildId("icon-close"),
          name: "rvai-base:close",
          onClick: _ctx.resetDate
        }, null, 8, ["data-automation", "onClick"])) : createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["modelValue", "data-automation", "hint", "label", "optional-label", "placeholder", "show-optional-label", "validation", "onBlur", "onFocus"])
  ], 10, _hoisted_1$$);
}
const DatePicker = /* @__PURE__ */ _export_sfc$1(__default__$2, [["render", _sfc_render$14], ["__scopeId", "data-v-945ab7da"]]);
const OUTER_THICKNESS_DEFAULT_VALUE = 0.2;
const _sfc_main$1c = defineComponent({
  name: "DoubleCircularProgress",
  components: {
    CircularProgress
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: "double-circular-progress"
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Size of text in CSS units, including unit name. Suggestion: use 'em' units to sync with component size
     */
    fontSize: {
      type: String,
      default: "8px"
    },
    /**
     * Color name for the inner arc progress from the Quasar Color Palette
     */
    innerColor: {
      type: String,
      default: "grey-2"
    },
    /**
     * Put inner component into 'indeterminate' state; Ignores 'value' prop
     */
    innerIndeterminate: {
      type: Boolean,
      default: false
    },
    /**
     * Maximum value for inner circle defining 100% progress made (must be higher than 'min')
     */
    innerMax: {
      type: Number,
      default: 100
    },
    /**
     * Minimum value for inner circle defining 'no progress' (must be lower than 'max')
     */
    innerMin: {
      type: Number,
      default: 0
    },
    /**
     * Inner component size in CSS units, including unit name or standard size name (xs|sm|md|lg|xl)
     */
    innerSize: {
      type: String,
      default: void 0
    },
    /**
     * Thickness of inner progress arc as a ratio (0.0 < x < 1.0) of component size
     */
    innerThickness: {
      type: Number,
      default: void 0
    },
    /**
     * Color name for the inner track of the component from the Quasar Color Palette
     */
    innerTrackColor: {
      type: String,
      default: void 0
    },
    /**
     * Current progress for inner component (must be between min/max)
     */
    innerValue: {
      type: Number,
      default: 0
    },
    /**
     * Color name for the outer arc progress from the Quasar Color Palette
     */
    outerColor: {
      type: String,
      default: "primary"
    },
    /**
     * Put outer component into 'indeterminate' state; Ignores 'value' prop
     */
    outerIndeterminate: {
      type: Boolean,
      default: false
    },
    /**
     * Maximum value for outer circle defining 100% progress made (must be higher than 'min')
     */
    outerMax: {
      type: Number,
      default: 100
    },
    /**
     * Minimum value for outer circle defining 'no progress' (must be lower than 'max')
     */
    outerMin: {
      type: Number,
      default: 0
    },
    /**
     * Outer component size in CSS units, including unit name or standard size name (xs|sm|md|lg|xl)
     */
    outerSize: {
      type: String,
      default: "50px"
    },
    /**
     * Thickness of outer progress arc as a ratio (0.0 < x < 1.0) of component size
     */
    outerThickness: {
      type: Number,
      default: void 0
    },
    /**
     * Color name for the outer track of the component from the Quasar Color Palette
     */
    outerTrackColor: {
      type: String,
      default: void 0
    },
    /**
     * Current progress for outer component  (must be between min/max)
     */
    outerValue: {
      type: Number,
      default: 0
    },
    /**
     * Enables the default slot and uses it (if available), otherwise it displays the 'value' prop as text;
     * Make sure the text has enough space to be displayed inside the component
     */
    showValue: {
      type: Boolean,
      default: false
    }
  },
  setup(props4) {
    const { isDark } = useDarkMode();
    const innerSizeComputed = computed(() => {
      return props4.innerSize ?? `${Math.ceil(parseInt(props4.outerSize) - parseInt(props4.outerSize) * outerThicknessComputed.value)}px`;
    });
    const innerThicknessComputed = computed(() => {
      const outerThicknessPx = parseInt(props4.outerSize) * outerThicknessComputed.value;
      const innerThickness = outerThicknessPx / parseInt(innerSizeComputed.value);
      return props4.innerThickness ?? innerThickness;
    });
    const innerTrackColorComputed = computed(() => {
      if (props4.innerTrackColor) return props4.innerTrackColor;
      return isDark.value ? "grey-1--dark" : "grey-3--light";
    });
    const outerThicknessComputed = computed(() => {
      return props4.outerThickness ?? OUTER_THICKNESS_DEFAULT_VALUE;
    });
    const outerTrackColorComputed = computed(() => {
      if (props4.outerTrackColor) return props4.outerTrackColor;
      return isDark.value ? "grey-1--dark" : "grey-3--light";
    });
    const percentage = computed(() => {
      const innerPercentage = Math.round(props4.innerValue / props4.innerMax * 100);
      const outerPercentage = Math.round(props4.outerValue / props4.outerMax * 100);
      return Math.max(innerPercentage, outerPercentage);
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      innerSizeComputed,
      innerThicknessComputed,
      innerTrackColorComputed,
      outerThicknessComputed,
      outerTrackColorComputed,
      percentage
    };
  }
});
function _sfc_render$13(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CircularProgress = resolveComponent("CircularProgress");
  return openBlock(), createBlock(_component_CircularProgress, {
    class: normalizeClass(_ctx.$props.class),
    color: _ctx.outerColor,
    "data-automation": _ctx.buildId(),
    indeterminate: _ctx.outerIndeterminate,
    max: _ctx.outerMax,
    min: _ctx.outerMin,
    "show-value": "",
    size: _ctx.outerSize,
    thickness: _ctx.outerThicknessComputed,
    "track-color": _ctx.outerTrackColorComputed,
    value: _ctx.outerValue
  }, {
    default: withCtx(() => [
      createVNode(_component_CircularProgress, {
        color: _ctx.innerColor,
        "data-automation": _ctx.buildId("inner"),
        "font-size": _ctx.fontSize,
        indeterminate: _ctx.innerIndeterminate,
        max: _ctx.innerMax,
        min: _ctx.innerMin,
        "show-value": _ctx.showValue,
        size: _ctx.innerSizeComputed,
        thickness: _ctx.innerThicknessComputed,
        "track-color": _ctx.innerTrackColorComputed,
        value: _ctx.innerValue
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default", { percentage: _ctx.percentage })
        ]),
        _: 3
      }, 8, ["color", "data-automation", "font-size", "indeterminate", "max", "min", "show-value", "size", "thickness", "track-color", "value"])
    ]),
    _: 3
  }, 8, ["class", "color", "data-automation", "indeterminate", "max", "min", "size", "thickness", "track-color", "value"]);
}
const DoubleCircularProgress = /* @__PURE__ */ _export_sfc$1(_sfc_main$1c, [["render", _sfc_render$13]]);
const _sfc_main$1b = defineComponent({
  name: "Validation",
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    validation: {
      type: Object,
      default: void 0
    }
  },
  setup(props4) {
    const {
      classRef,
      error,
      errorMessage
    } = useValidation(props4);
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      classRef,
      error,
      errorMessage
    };
  }
});
const _hoisted_1$_ = ["data-automation"];
const _hoisted_2$N = { class: "q-field--dense q-field--error" };
const _hoisted_3$F = ["data-automation"];
function _sfc_render$12(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "rv-validation",
    "data-automation": _ctx.buildId()
  }, [
    renderSlot(_ctx.$slots, "default", {}, void 0, true),
    createElementVNode("div", _hoisted_2$N, [
      _ctx.error ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(["q-field__bottom", _ctx.classRef]),
        "data-automation": _ctx.buildId("error"),
        role: "alert"
      }, toDisplayString(_ctx.errorMessage), 11, _hoisted_3$F)) : createCommentVNode("", true)
    ])
  ], 8, _hoisted_1$_);
}
const Validation = /* @__PURE__ */ _export_sfc$1(_sfc_main$1b, [["render", _sfc_render$12], ["__scopeId", "data-v-c4b1d2e6"]]);
const _sfc_main$1a = defineComponent({
  name: "Dropzone",
  components: {
    I18n: Translation,
    QIcon: QIcon_default$1,
    Validation
  },
  props: {
    /**
       * Allowed extensions (.tgz|.jpg|.png etc.)
       */
    allowedExtensions: {
      type: Array,
      default: void 0
    },
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Dense mode; occupies less space
     */
    dense: {
      type: Boolean,
      default: false
    },
    /**
     * Indicates that only directories should be available to be selected by the user in the file picker interface.
     */
    directory: {
      type: Boolean,
      default: false
    },
    /**
     * Indicates that dropzone is disabled.
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Empty state title
     */
    emptyTitle: {
      type: String,
      default: void 0
    },
    /**
     * Allowed number of files, if multiple is true
     */
    maxFiles: {
      type: Number,
      default: 1e3
    },
    /**
     * The maximum allowed size of the combined files (in bytes)
     */
    maxSize: {
      type: Number,
      default: void 0
    },
    /**
     * Model value - always an array, even if multiple is false
     */
    modelValue: {
      type: Array,
      required: true
    },
    /**
     * Allows to select more than one file
     */
    multiple: {
      type: Boolean,
      default: true
    },
    /**
     * Makes the selection of files optional. If false, will return a validation error if empty.
     */
    optional: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    /**
     * Emitted when files in the file input are clearer
     *
     * @type {object}
     */
    "clear",
    /**
     * Emitted when files in the file input are changed
     *
     * @type {object}
     */
    "update:modelValue"
  ],
  setup(props4, { emit }) {
    const { t: t22 } = useI18n();
    const inputRef = ref$1();
    const dragging = ref$1(false);
    const isDisabled = computed(() => {
      if (error.value) return true;
      if (!props4.multiple && !!props4.modelValue.length) return true;
      return props4.disable;
    });
    const error = computed(() => {
      var _a;
      if (!v$.value.$error) return void 0;
      return (_a = v$.value.$errors[0]) == null ? void 0 : _a.$message;
    });
    const extensions = computed(() => {
      var _a;
      return (_a = props4.allowedExtensions) == null ? void 0 : _a.join(", ");
    });
    const hasData = computed(() => {
      return !!props4.modelValue.length;
    });
    const icon = computed(() => {
      if (error.value) {
        return "mdi-alert-circle-outline";
      } else if (hasData.value) {
        return "mdi-check-circle";
      } else {
        return "rvai-base:arrow-circle-up";
      }
    });
    const title = computed(() => {
      if (error.value) {
        return t22("rvai-base.components.dropzone.errorTitle");
      } else if (hasData.value) {
        return t22("rvai-base.components.dropzone.dataTitle", props4.modelValue.length);
      } else if (props4.emptyTitle) {
        return props4.emptyTitle;
      } else if (props4.dense) {
        return t22("rvai-base.components.dropzone.denseTitle");
      } else {
        return t22("rvai-base.components.dropzone.emptyTitle", props4.multiple ? props4.maxFiles : 1);
      }
    });
    const totalFileSize = computed(() => {
      return props4.modelValue.reduce((acc, f) => acc + f.size, 0);
    });
    const validationRules = computed(() => ({
      value: ValidationBuilder.$t("rvai-base.general.text.theValue").custom(
        (files) => {
          const maxFiles = props4.multiple ? props4.maxFiles : 1;
          return files.length <= maxFiles;
        },
        "rvai-base.components.dropzone.validation.maxFiles",
        [props4.multiple ? props4.maxFiles : 1],
        "maxFiles"
      ).custom(
        (files) => {
          const { allowedExtensions } = props4;
          if (!(allowedExtensions == null ? void 0 : allowedExtensions.length)) return true;
          return files.every((f) => allowedExtensions.some((ext) => f.name.toLowerCase().endsWith(ext)));
        },
        "rvai-base.components.dropzone.validation.fileExtensions",
        [],
        "fileExtensions"
      ).custom(
        () => {
          const { maxSize } = props4;
          if (!maxSize) return true;
          return totalFileSize.value <= maxSize;
        },
        "rvai-base.components.dropzone.validation.maxSize",
        computed(() => [
          formatBytes(totalFileSize.value, 3),
          formatBytes(props4.maxSize ?? 0, 3)
        ]),
        "maxSize"
      ).rules
    }));
    const v$ = useVuelidate(
      validationRules,
      computed(() => ({
        value: props4.modelValue
      })),
      { $autoDirty: true }
    );
    const requiredRules = computed(() => ({
      value: ValidationBuilder.$t("rvai-base.general.text.theValue").arrayRequiredIf(!props4.optional).rules
    }));
    const vRequired$ = useVuelidate(
      requiredRules,
      computed(() => ({
        value: props4.modelValue
      })),
      { $autoDirty: true }
    );
    function onChange(files) {
      if (!files.length) return;
      emit("update:modelValue", [...props4.modelValue, ...files]);
    }
    function onClear() {
      emit("update:modelValue", []);
      emit("clear");
    }
    function onClick() {
      var _a;
      if (isDisabled.value) return;
      (_a = inputRef.value) == null ? void 0 : _a.click();
    }
    function onDragLeave(e22) {
      e22.preventDefault();
      e22.stopPropagation();
      dragging.value = false;
    }
    function onDragOver(e22) {
      e22.preventDefault();
      e22.stopPropagation();
      if (isDisabled.value) return;
      dragging.value = true;
    }
    async function onDrop(e22) {
      e22.preventDefault();
      e22.stopPropagation();
      dragging.value = false;
      if (!e22.dataTransfer || isDisabled.value) return;
      try {
        const files = await getFiles(e22.dataTransfer.items);
        const toChange = props4.multiple ? files : [files[0]];
        onChange(toChange);
      } catch (error2) {
        console.error(error2);
      }
    }
    function onFilesChanged(e22) {
      const input = e22.target;
      const files = Array.from((input == null ? void 0 : input.files) ?? []);
      onChange(files);
      input.value = "";
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      dragging,
      error,
      extensions,
      hasData,
      icon,
      inputRef,
      isDisabled,
      onClear,
      onClick,
      onDragLeave,
      onDragOver,
      onDrop,
      onFilesChanged,
      t: t22,
      title,
      v$,
      vRequired$
    };
  }
});
const _hoisted_1$Z = ["data-automation"];
const _hoisted_2$M = ["data-automation"];
const _hoisted_3$E = ["data-automation"];
const _hoisted_4$p = ["data-automation"];
const _hoisted_5$k = ["data-automation"];
const _hoisted_6$b = { class: "dropzone__link" };
const _hoisted_7$9 = ["data-automation"];
const _hoisted_8$6 = ["data-automation"];
const _hoisted_9$5 = { class: "dropzone__link" };
const _hoisted_10$3 = ["data-automation"];
const _hoisted_11$3 = ["data-automation"];
const _hoisted_12$2 = { class: "text-small" };
const _hoisted_13$2 = ["accept", "data-automation", "multiple", "webkitdirectory"];
function _sfc_render$11(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QIcon = resolveComponent("QIcon");
  const _component_I18n = resolveComponent("I18n");
  const _component_Validation = resolveComponent("Validation");
  return openBlock(), createBlock(_component_Validation, {
    "data-automation": _ctx.buildId("validation"),
    validation: _ctx.vRequired$.value
  }, {
    default: withCtx(() => [
      createElementVNode("div", {
        class: normalizeClass(["dropzone column no-wrap items-center bg-white rounded-borders text-center q-pa-lg", {
          "cursor-pointer": !_ctx.isDisabled,
          "dropzone--dragging": _ctx.dragging,
          "dropzone--disabled text-grey-2": _ctx.disable
        }]),
        "data-automation": _ctx.buildId(),
        onClick: _cache[4] || (_cache[4] = (...args) => _ctx.onClick && _ctx.onClick(...args)),
        onDragenter: _cache[5] || (_cache[5] = (...args) => _ctx.onDragOver && _ctx.onDragOver(...args)),
        onDragleave: _cache[6] || (_cache[6] = (...args) => _ctx.onDragLeave && _ctx.onDragLeave(...args)),
        onDragover: _cache[7] || (_cache[7] = (...args) => _ctx.onDragOver && _ctx.onDragOver(...args)),
        onDrop: _cache[8] || (_cache[8] = (...args) => _ctx.onDrop && _ctx.onDrop(...args))
      }, [
        createVNode(_component_QIcon, {
          class: "dropzone__icon q-mb-md",
          "data-automation": _ctx.buildId("icon"),
          name: _ctx.icon,
          size: "40px"
        }, null, 8, ["data-automation", "name"]),
        createElementVNode("div", {
          class: "text-subtitle2 text-black-1",
          "data-automation": _ctx.buildId("title")
        }, toDisplayString(_ctx.title), 9, _hoisted_2$M),
        _ctx.error ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createElementVNode("div", {
            class: "text-small",
            "data-automation": _ctx.buildId("error")
          }, toDisplayString(_ctx.error), 9, _hoisted_3$E),
          createElementVNode("div", {
            class: "text-small q-mt-sm",
            "data-automation": _ctx.buildId("description")
          }, [
            createElementVNode("span", {
              class: "cursor-pointer dropzone__link",
              onClick: _cache[0] || (_cache[0] = withModifiers((...args) => _ctx.onClear && _ctx.onClear(...args), ["stop"]))
            }, toDisplayString(_ctx.t("rvai-base.components.dropzone.retry")), 1)
          ], 8, _hoisted_4$p)
        ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          _ctx.hasData ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            _ctx.multiple ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
              !_ctx.dense ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: "text-small q-mt-sm",
                "data-automation": _ctx.buildId("maxFiles")
              }, toDisplayString(_ctx.t("rvai-base.components.dropzone.maxFiles", _ctx.maxFiles)), 9, _hoisted_5$k)) : createCommentVNode("", true),
              createVNode(_component_I18n, {
                class: "text-small q-mt-sm",
                "data-automation": _ctx.buildId("description"),
                keypath: "rvai-base.components.dropzone.dataDescription",
                scope: "global",
                tag: "div"
              }, {
                default: withCtx(() => [
                  createElementVNode("span", _hoisted_6$b, toDisplayString(_ctx.t("rvai-base.components.dropzone.addMore")), 1),
                  createElementVNode("span", {
                    class: "dropzone__link",
                    onClick: _cache[1] || (_cache[1] = withModifiers((...args) => _ctx.onClear && _ctx.onClear(...args), ["stop"]))
                  }, toDisplayString(_ctx.t("rvai-base.components.dropzone.clearAll")), 1)
                ]),
                _: 1
              }, 8, ["data-automation"])
            ], 64)) : (openBlock(), createElementBlock("div", {
              key: 1,
              class: "text-small q-mt-sm",
              "data-automation": _ctx.buildId("description")
            }, [
              createElementVNode("span", {
                class: "cursor-pointer dropzone__link",
                onClick: _cache[2] || (_cache[2] = withModifiers((...args) => _ctx.onClear && _ctx.onClear(...args), ["stop"]))
              }, toDisplayString(_ctx.t("rvai-base.components.dropzone.clearFile")), 1)
            ], 8, _hoisted_7$9))
          ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            !_ctx.dense ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: "text-small q-mt-sm",
              "data-automation": _ctx.buildId("maxFiles")
            }, toDisplayString(_ctx.t("rvai-base.components.dropzone.maxFiles", _ctx.multiple ? _ctx.maxFiles : 1)), 9, _hoisted_8$6)) : createCommentVNode("", true),
            !_ctx.dense ? (openBlock(), createBlock(_component_I18n, {
              key: 1,
              class: "text-small q-mt-sm",
              "data-automation": _ctx.buildId("description"),
              keypath: "rvai-base.components.dropzone.emptyDescription",
              scope: "global",
              tag: "div"
            }, {
              default: withCtx(() => [
                createElementVNode("span", _hoisted_9$5, toDisplayString(_ctx.t("rvai-base.components.dropzone.uploadFromComputer")), 1)
              ]),
              _: 1
            }, 8, ["data-automation"])) : createCommentVNode("", true)
          ], 64)),
          _ctx.allowedExtensions && !_ctx.dense ? (openBlock(), createElementBlock("div", {
            key: 2,
            class: "text-small q-mt-sm",
            "data-automation": _ctx.buildId("extensions")
          }, toDisplayString(_ctx.t("rvai-base.general.common.wordInBrackets", [_ctx.allowedExtensions.join(", ")])), 9, _hoisted_10$3)) : createCommentVNode("", true),
          _ctx.dragging ? (openBlock(), createElementBlock("div", {
            key: 3,
            class: "dropzone__drag column no-wrap justify-center items-center q-mt-sm",
            "data-automation": _ctx.buildId("dragging")
          }, [
            createElementVNode("div", {
              class: normalizeClass(["dropzone__drag__icon col-fixed", [
                _ctx.dense ? "q-mb-md" : "q-mb-lg",
                { "dropzone__drag__icon--dense": _ctx.dense }
              ]])
            }, [
              createVNode(_component_QIcon, {
                color: "white",
                name: "rvai-base:file-copy",
                size: _ctx.dense ? "22px" : "32px"
              }, null, 8, ["size"])
            ], 2),
            createElementVNode("div", {
              class: normalizeClass(["text-subtitle2 text-black-1", { "q-mb-sm": !_ctx.dense }])
            }, toDisplayString(_ctx.t("rvai-base.components.dropzone.dragTitle")), 3),
            createElementVNode("div", _hoisted_12$2, toDisplayString(_ctx.t("rvai-base.components.dropzone.dragDescription")), 1)
          ], 8, _hoisted_11$3)) : createCommentVNode("", true)
        ], 64)),
        createElementVNode("input", {
          ref: "inputRef",
          accept: _ctx.extensions,
          class: "hidden",
          "data-automation": _ctx.buildId("input"),
          multiple: _ctx.multiple,
          type: "file",
          webkitdirectory: _ctx.directory,
          onChange: _cache[3] || (_cache[3] = (...args) => _ctx.onFilesChanged && _ctx.onFilesChanged(...args))
        }, null, 40, _hoisted_13$2)
      ], 42, _hoisted_1$Z)
    ]),
    _: 1
  }, 8, ["data-automation", "validation"]);
}
const Dropzone = /* @__PURE__ */ _export_sfc$1(_sfc_main$1a, [["render", _sfc_render$11], ["__scopeId", "data-v-664a42f7"]]);
function isNil(value2) {
  return value2 == null;
}
var isNil_1 = isNil;
const isNil$1 = /* @__PURE__ */ getDefaultExportFromCjs(isNil_1);
const _sfc_main$19 = defineComponent({
  name: "Select",
  components: {
    EllipsisText,
    QIcon: QIcon_default$1,
    QItem: QItem_default$1,
    QItemLabel: QItemLabel_default$1,
    QItemSection: QItemSection_default$1,
    QSelect: QSelect_default$1,
    Tooltip: Tooltip2
  },
  inheritAttrs: true,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Show label inside element
     */
    caption: {
      type: String,
      default: void 0
    },
    /**
     * Show clear button
     */
    clearable: {
      type: Boolean,
      default: false
    },
    /**
     * Dense mode; occupies less space
     */
    dense: {
      type: Boolean,
      default: false
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Override default selection string, if not using 'selected' slot/scoped slot and if not using 'use-chips' prop
     */
    displayValue: {
      type: [Number, String],
      default: void 0
    },
    /**
     * Update model with the value of the selected option instead of the whole option
     */
    emitValue: {
      type: Boolean,
      default: false
    },
    /**
     * Fills the input with current value; Useful along with 'hide-selected'; Does NOT works along with 'multiple' selection
     */
    fillInput: {
      type: Boolean,
      default: false
    },
    /**
     * Hides selection; Use the underlying input tag to hold the label (instead of showing it to the right of the input) of the selected option; Only works for non 'multiple' Selects
     */
    hideSelected: {
      type: Boolean,
      default: false
    },
    /**
     * Helper (hint) text which gets placed below your wrapped form component
     */
    hint: {
      type: String,
      default: void 0
    },
    /**
     * Adds info icon and shows the text on hover
     */
    infoText: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to the info text
     */
    infoTextClass: {
      type: String,
      default: "rv-select__info-text"
    },
    /**
     * Debounce the input model update with an amount of milliseconds
     */
    inputDebounce: {
      type: [Number, String],
      default: 500
    },
    /**
     * A text label that will “float” up above the input field, once the field gets focus
     */
    label: {
      type: String,
      default: void 0
    },
    /**
     * Try to map labels of model from 'options' Array; has a small performance penalty; If you are using emit-value you will probably need to use map-options to display the label text in the select field rather than the value;  Refer to the 'Affecting model' section above
     */
    mapOptions: {
      type: Boolean,
      default: false
    },
    /**
     * Model of the component; Must be Array if using 'multiple' prop; Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
     */
    modelValue: {
      type: [Array, Number, Object, String, Boolean],
      default: void 0
    },
    /**
     * Allow multiple selection; Model must be Array
     */
    multiple: {
      type: Boolean,
      default: false
    },
    /**
     * The text that will be shown next to label
     */
    optionalLabel: {
      type: String,
      default: ""
    },
    /**
     * Property of option which holds the 'label'; If using a function then for best performance, reference it from your scope and do not define it inline
     */
    optionLabel: {
      type: String,
      default: "label"
    },
    /**
     * Property of option which holds the 'value'; If using a function then for best performance, reference it from your scope and do not define it inline
     */
    optionValue: {
      type: String,
      default: "value"
    },
    /**
     * Available options that the user can select from. For best performance freeze the list of options.
     */
    options: {
      type: [Number, Object, String, Boolean],
      default: () => []
    },
    /**
     * Dense mode for options list; occupies less space
     */
    optionsDense: {
      type: Boolean,
      default: false
    },
    /**
     * Class definitions to be attributed to the popup content
     */
    popupContentClass: {
      type: String,
      default: "rv-select__menu"
    },
    /**
     * Put component in readonly mode
     */
    readonly: {
      type: Boolean,
      default: false
    },
    /**
     * Shows label before select
     */
    showLabelBefore: {
      type: Boolean,
      default: false
    },
    /**
     * Shows optional label after base label
     */
    showOptionalLabel: {
      type: Boolean,
      default: false
    },
    /**
     * Use an input tag where users can type
     */
    useInput: {
      type: Boolean,
      default: false
    },
    /**
     * Validation for the component
     */
    validation: {
      type: Object,
      default: void 0
    }
  },
  emits: [
    "filter",
    "input-value",
    "on-popup-hide",
    "on-popup-show",
    "update:modelValue"
  ],
  setup(props4, { emit }) {
    const { t: t22 } = useI18n();
    const {
      classRef,
      error,
      errorMessage,
      isValidated,
      onBlur: onBlur2
    } = useValidation(props4);
    const selectRef = ref$1(null);
    const showCaption = ref$1(!!props4.caption);
    const optionWidth = computed(() => {
      var _a;
      const componentWidth = ((_a = selectRef.value) == null ? void 0 : _a.$el.offsetWidth) ?? 0;
      return componentWidth - 64;
    });
    const value2 = computed({
      get() {
        return props4.modelValue;
      },
      set(value22) {
        emit("update:modelValue", value22);
      }
    });
    function onFilter(...args) {
      emit("filter", ...args);
    }
    function onInput(value22) {
      emit("input-value", value22);
    }
    function onPopupHide() {
      showCaption.value = true;
      emit("on-popup-hide");
    }
    function onPopupShow() {
      showCaption.value = false;
      emit("on-popup-show");
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      classRef,
      error,
      errorMessage,
      isNil: isNil$1,
      isValidated,
      onBlur: onBlur2,
      onFilter,
      onInput,
      onPopupHide,
      onPopupShow,
      optionWidth,
      showCaption,
      t: t22,
      value: value2
    };
  }
});
const _hoisted_1$Y = ["data-automation"];
const _hoisted_2$L = {
  key: 0,
  class: "rv-select__label row no-wrap items-center"
};
const _hoisted_3$D = {
  key: 0,
  class: "q-ml-xs"
};
const _hoisted_4$o = { class: "rv-select__label text-black-1 row no-wrap items-center" };
const _hoisted_5$j = {
  key: 0,
  class: "q-ml-xs"
};
function _sfc_render$10(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_QItemLabel = resolveComponent("QItemLabel");
  const _component_QItemSection = resolveComponent("QItemSection");
  const _component_QItem = resolveComponent("QItem");
  const _component_QSelect = resolveComponent("QSelect");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["rv-select", [
      _ctx.classRef,
      {
        "rv-select--dense": _ctx.dense,
        "rv-select--disabled": _ctx.disable || _ctx.readonly
      }
    ]]),
    "data-automation": _ctx.buildId()
  }, [
    !_ctx.showLabelBefore ? (openBlock(), createElementBlock("div", _hoisted_2$L, [
      createVNode(_component_EllipsisText, {
        class: "text-subtitle3",
        "data-automation": _ctx.buildId("label")
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(_ctx.label), 1)
        ]),
        _: 1
      }, 8, ["data-automation"]),
      _ctx.showOptionalLabel ? (openBlock(), createElementBlock("div", _hoisted_3$D, toDisplayString(_ctx.optionalLabel || _ctx.t("rvai-base.general.inputs.optional")), 1)) : createCommentVNode("", true),
      _ctx.infoText || _ctx.$slots["infoText"] ? (openBlock(), createBlock(_component_QIcon, {
        key: 1,
        class: "q-ml-xs info-icon",
        color: "black-1",
        "data-automation": _ctx.buildId("icon-info"),
        name: "info",
        size: "16px"
      }, {
        default: withCtx(() => [
          createVNode(_component_Tooltip, {
            anchor: "top middle",
            class: normalizeClass(_ctx.infoTextClass),
            self: "bottom middle"
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "infoText", {}, () => [
                createTextVNode(toDisplayString(_ctx.infoText), 1)
              ], true)
            ]),
            _: 3
          }, 8, ["class"])
        ]),
        _: 3
      }, 8, ["data-automation"])) : createCommentVNode("", true)
    ])) : createCommentVNode("", true),
    createVNode(_component_QSelect, mergeProps({
      ref: "selectRef",
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.value = $event),
      clearable: _ctx.clearable,
      "data-automation": _ctx.buildId("select"),
      dense: "",
      disable: _ctx.disable || _ctx.readonly,
      "display-value": _ctx.displayValue,
      "emit-value": _ctx.emitValue,
      error: _ctx.error,
      "error-message": _ctx.errorMessage,
      "fill-input": _ctx.fillInput,
      "hide-bottom-space": "",
      "hide-selected": _ctx.hideSelected,
      hint: _ctx.hint,
      "input-debounce": _ctx.inputDebounce,
      "map-options": _ctx.mapOptions,
      multiple: _ctx.multiple,
      "no-error-icon": "",
      "option-label": _ctx.optionLabel,
      "option-value": _ctx.optionValue,
      options: _ctx.options,
      "options-dense": _ctx.optionsDense,
      "popup-content-class": _ctx.popupContentClass,
      standout: "",
      "use-input": _ctx.useInput,
      "v-model": _ctx.modelValue,
      "virtual-scroll-slice-size": 100
    }, { [toHandlerKey(_ctx.useInput && `filter`)]: _ctx.onFilter }, { [toHandlerKey(_ctx.useInput && `inputValue`)]: _ctx.onInput }, {
      onBlur: _ctx.onBlur,
      onPopupHide: _ctx.onPopupHide,
      onPopupShow: _ctx.onPopupShow
    }), createSlots({
      option: withCtx(({ itemProps, opt, selected }) => [
        createVNode(_component_QItem, mergeProps(itemProps, {
          "data-automation": _ctx.buildId(`option-${opt[_ctx.optionLabel] || opt}`)
        }), {
          default: withCtx(() => [
            createVNode(_component_QItemSection, { class: "q-item__section column q-item__section--main justify-center" }, {
              default: withCtx(() => [
                createVNode(_component_QItemLabel, { class: "q-item__label" }, {
                  default: withCtx(() => [
                    createVNode(_component_EllipsisText, {
                      style: normalizeStyle({ "width": `${_ctx.optionWidth}px` }),
                      text: opt[_ctx.optionLabel] || opt
                    }, null, 8, ["style", "text"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024),
            createVNode(_component_QItemSection, { side: "" }, {
              default: withCtx(() => [
                selected ? (openBlock(), createBlock(_component_QIcon, {
                  key: 0,
                  class: "rv-select__option--icon",
                  color: "grey-1",
                  name: "mdi-check",
                  size: "18px"
                })) : createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1040, ["data-automation"])
      ]),
      _: 2
    }, [
      _ctx.modelValue == null && _ctx.caption && _ctx.showCaption ? {
        name: "selected",
        fn: withCtx(() => [
          createVNode(_component_EllipsisText, {
            class: "rv-select__caption flex items-center",
            "data-automation": _ctx.buildId("caption"),
            text: _ctx.caption
          }, null, 8, ["data-automation", "text"])
        ]),
        key: "0"
      } : void 0,
      _ctx.isValidated && (Array.isArray(_ctx.modelValue) ? _ctx.modelValue.length : !_ctx.isNil(_ctx.modelValue)) ? {
        name: "after",
        fn: withCtx(() => [
          createVNode(_component_QIcon, {
            key: "valid",
            class: "rv-select__after--icon",
            color: "positive",
            "data-automation": _ctx.buildId("icon-valid"),
            name: "mdi-check-circle"
          }, null, 8, ["data-automation"])
        ]),
        key: "1"
      } : _ctx.error ? {
        name: "after",
        fn: withCtx(() => [
          createVNode(_component_QIcon, {
            key: "error",
            class: "rv-select__after--icon",
            color: "negative",
            "data-automation": _ctx.buildId("icon-error"),
            name: "mdi-close-circle"
          }, null, 8, ["data-automation"])
        ]),
        key: "2"
      } : void 0,
      _ctx.showLabelBefore ? {
        name: "before",
        fn: withCtx(() => [
          createElementVNode("div", _hoisted_4$o, [
            createVNode(_component_EllipsisText, { class: "text-subtitle3" }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(_ctx.label), 1)
              ]),
              _: 1
            }),
            _ctx.showOptionalLabel ? (openBlock(), createElementBlock("div", _hoisted_5$j, toDisplayString(_ctx.optionalLabel || _ctx.t("rvai-base.general.inputs.optional")), 1)) : createCommentVNode("", true)
          ])
        ]),
        key: "3"
      } : void 0,
      renderList(_ctx.$slots, (_, name2) => {
        return {
          name: name2,
          fn: withCtx((slotData) => [
            renderSlot(_ctx.$slots, name2, normalizeProps(guardReactiveProps(slotData || {})), void 0, true)
          ])
        };
      })
    ]), 1040, ["modelValue", "clearable", "data-automation", "disable", "display-value", "emit-value", "error", "error-message", "fill-input", "hide-selected", "hint", "input-debounce", "map-options", "multiple", "option-label", "option-value", "options", "options-dense", "popup-content-class", "use-input", "v-model", "onBlur", "onPopupHide", "onPopupShow"])
  ], 10, _hoisted_1$Y);
}
const Select = /* @__PURE__ */ _export_sfc$1(_sfc_main$19, [["render", _sfc_render$10], ["__scopeId", "data-v-0574184b"]]);
const _sfc_main$18 = defineComponent({
  name: "Duration",
  components: {
    Select
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * A text label that will “float” up above the select
     */
    label: {
      type: String,
      default: void 0
    },
    /**
     * Duration time in seconds
     */
    modelValue: {
      type: Number,
      required: true
    }
  },
  emits: [
    /**
     * Emitted when component value is updated
     */
    "update:modelValue"
  ],
  setup(props4) {
    const { t: t22 } = useI18n();
    const options = [
      600,
      3600,
      21600,
      86400,
      259200,
      604800,
      2678400,
      -1
    ].map((v) => ({
      label: v > 0 ? formatDuration$1(v * 1e3) : t22("rvai-base.components.duration.infinite"),
      value: v
    }));
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      options
    };
  }
});
function _sfc_render$$(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Select = resolveComponent("Select");
  return openBlock(), createBlock(_component_Select, mergeProps(_ctx.dataAttrs, {
    class: _ctx.$props.class,
    "data-automation": _ctx.buildId(),
    "emit-value": "",
    label: _ctx.label,
    "map-options": "",
    "model-value": _ctx.modelValue,
    options: _ctx.options,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.$emit("update:modelValue", $event))
  }), null, 16, ["class", "data-automation", "label", "model-value", "options"]);
}
const Duration = /* @__PURE__ */ _export_sfc$1(_sfc_main$18, [["render", _sfc_render$$]]);
const _sfc_main$17 = defineComponent({
  name: "EditableText",
  components: {
    Button,
    EllipsisText,
    Input
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Initialize the component in edit mode. Focus on the input.
     */
    defaultEdit: {
      type: Boolean,
      default: false
    },
    /**
     * Dense mode; occupies less space
     */
    dense: {
      type: Boolean,
      default: false
    },
    /**
     * Put component in disabled mode(show only plain text)
     */
    disableEdit: {
      type: Boolean,
      default: false
    },
    /**
     * The value to be displaye.
     */
    displayValue: {
      type: String,
      default: void 0
    },
    /**
     * Trigger update:model-value always. Without comparing with model-value.
    */
    emitEveryTime: {
      type: Boolean,
      default: false
    },
    /**
     * Hides the edit button. Edit can still be triggered via ref.
     */
    hideEdit: {
      type: Boolean,
      default: false
    },
    /**
     * Classes to be applied to the input component
     */
    inputClass: {
      type: [Array, String, Object],
      default: void 0
    },
    /**
     * Show 3dots at the beginning
     * @type {Boolean}
     */
    reverseEllipsisText: {
      type: Boolean,
      default: false
    },
    /**
     * Model of the component; Either use this property (along with a listener for 'update:model-value' event) OR use v-model directive
     */
    modelValue: {
      required: true,
      type: String
    },
    /**
     * Disable update on blur
     */
    noUpdateOnBlur: {
      type: Boolean,
      default: false
    },
    /**
     * Always shows disabled button
     */
    showButtonWhenDisabled: {
      type: Boolean,
      default: false
    },
    /**
     * Equivalent to Vue Router <router-link> 'to' property
     */
    to: {
      type: [Object, String],
      default: void 0
    },
    /**
     * Validation rules for the component
     */
    validationRules: {
      type: Object,
      default: void 0
    }
  },
  emits: [
    "cancel",
    "edit",
    "update:modelValue"
  ],
  setup(props4, { emit }) {
    const editing = ref$1(props4.defaultEdit);
    const inputRef = ref$1(null);
    const newValue = ref$1(props4.modelValue);
    const newValueTrimmed = ref$1(newValue.value.trim());
    const v$ = useVuelidate$1(
      { ...props4.validationRules && { newValue: props4.validationRules } },
      { newValue: newValueTrimmed },
      { $autoDirty: true }
    );
    function edit() {
      onEditClick();
    }
    function onCancel() {
      editing.value = false;
      newValue.value = props4.modelValue;
      emit("cancel");
    }
    function onBlur2() {
      if (props4.noUpdateOnBlur) {
        onCancel();
      } else {
        void onSave();
      }
    }
    function onKeyUp(evt) {
      switch (evt.key) {
        case "Enter":
          evt.stopPropagation();
          evt.preventDefault();
          return void onSave();
        case "Escape":
          evt.stopPropagation();
          evt.preventDefault();
          return onCancel();
      }
    }
    function onEditClick() {
      v$.value.$reset();
      editing.value = !props4.disableEdit;
      emit("edit");
    }
    async function onSave() {
      const isValid2 = await v$.value.$validate();
      if (!isValid2) {
        onCancel();
        return;
      }
      editing.value = false;
      if (newValueTrimmed.value !== props4.modelValue || props4.emitEveryTime) {
        emit("update:modelValue", newValueTrimmed.value);
      }
    }
    watch(() => props4.modelValue, (value2) => {
      newValue.value = value2;
    });
    watch(newValue, (v) => {
      newValueTrimmed.value = v.trim();
    });
    watch(
      editing,
      (value2) => {
        if (value2) {
          document.addEventListener("keyup", onKeyUp);
        } else {
          document.removeEventListener("keyup", onKeyUp);
        }
      },
      {
        immediate: true
      }
    );
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      edit,
      editing,
      inputRef,
      newValue,
      onBlur: onBlur2,
      onEditClick,
      onKeyUp,
      RouterLink,
      v$
    };
  }
});
const _hoisted_1$X = ["data-automation"];
const _hoisted_2$K = ["data-automation"];
const _hoisted_3$C = {
  key: 1,
  class: "editable-text__text-block flex items-center no-wrap"
};
function _sfc_render$_(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Input = resolveComponent("Input");
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_Button = resolveComponent("Button");
  return openBlock(), createElementBlock("div", {
    class: "editable-text",
    "data-automation": _ctx.buildId()
  }, [
    _ctx.editing && !_ctx.disableEdit ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: "row no-wrap items-center",
      "data-automation": _ctx.buildId("container"),
      tabindex: "0"
    }, [
      createVNode(_component_Input, {
        ref: "inputRef",
        modelValue: _ctx.newValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.newValue = $event),
        autofocus: "",
        class: "editable-text__input",
        "data-automation": _ctx.buildId("input"),
        dense: _ctx.dense,
        "show-error-as-tooltip": "",
        "show-error-message": false,
        "tab-index": 0,
        validation: _ctx.v$.newValue,
        onBlur: _ctx.onBlur
      }, null, 8, ["modelValue", "data-automation", "dense", "validation", "onBlur"])
    ], 8, _hoisted_2$K)) : (openBlock(), createElementBlock("div", _hoisted_3$C, [
      (openBlock(), createBlock(resolveDynamicComponent(_ctx.to ? _ctx.RouterLink : "div"), {
        class: normalizeClass(["editable-text__text q-mr-sm zero-min-width", { "editable-text__text--clickable": !!_ctx.to && !_ctx.disableEdit }]),
        to: _ctx.to
      }, {
        default: withCtx(() => [
          createVNode(_component_EllipsisText, {
            "data-automation": _ctx.buildId("label"),
            reverse: _ctx.reverseEllipsisText,
            text: _ctx.displayValue == null ? _ctx.modelValue : _ctx.displayValue
          }, null, 8, ["data-automation", "reverse", "text"])
        ]),
        _: 1
      }, 8, ["class", "to"])),
      _ctx.showButtonWhenDisabled ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        !_ctx.hideEdit ? (openBlock(), createBlock(_component_Button, {
          key: 0,
          class: "editable-text__edit",
          "data-automation": _ctx.buildId("edit"),
          disable: _ctx.disableEdit,
          icon: "edit",
          size: "sm",
          tertiary: "",
          "text-color": "black-1",
          onClick: withModifiers(_ctx.onEditClick, ["stop", "prevent"])
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "disabled", {}, void 0, true)
          ]),
          _: 3
        }, 8, ["data-automation", "disable", "onClick"])) : createCommentVNode("", true)
      ], 64)) : !_ctx.disableEdit && !_ctx.hideEdit ? (openBlock(), createBlock(_component_Button, {
        key: 1,
        class: "editable-text__edit",
        "data-automation": _ctx.buildId("edit"),
        icon: "edit",
        size: "sm",
        tertiary: "",
        "text-color": "black-1",
        onClick: withModifiers(_ctx.onEditClick, ["stop", "prevent"])
      }, null, 8, ["data-automation", "onClick"])) : createCommentVNode("", true)
    ]))
  ], 8, _hoisted_1$X);
}
const EditableText = /* @__PURE__ */ _export_sfc$1(_sfc_main$17, [["render", _sfc_render$_], ["__scopeId", "data-v-ae9526ee"]]);
const _sfc_main$16 = defineComponent({
  name: "Toggle",
  inheritAtttrs: false,
  components: {
    QIcon: QIcon_default$1,
    QToggle: QToggle_default$1,
    Tooltip: Tooltip2
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Dense mode; occupies less space
     */
    dense: {
      type: Boolean,
      default: false
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * What model value should be considered as unchecked/unticked/off?
     */
    falseValue: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      type: [Array, Object, String, Boolean, Number],
      default: false
    },
    /**
     * Render info icon with tooltip. Can be used as an "info-text" property or as a slot
     */
    infoText: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to the info text
     */
    infoTextClass: {
      type: String,
      default: "rv-toggle__info-text"
    },
    /**
     * Label to display along the component
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Model of the component; Either use this property (along with a listener for 'update:model-value' event) OR use v-model directive
     */
    modelValue: {
      type: [Array, Boolean],
      default: void 0
    },
    /**
     * What model value should be considered as checked/ticked/on?
     */
    trueValue: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      type: [Array, Object, String, Boolean, Number],
      default: true
    },
    /**
     * Works when model ('value') is Array. It tells the component which value should add/remove when ticked/unticked
     */
    val: {
      type: String,
      default: void 0
    }
  },
  emits: ["update:modelValue"],
  setup(props4, { emit }) {
    const value2 = computed({
      get() {
        return props4.modelValue;
      },
      set(value22) {
        emit("update:modelValue", value22);
      }
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      value: value2
    };
  }
});
const _hoisted_1$W = ["data-automation"];
const _hoisted_2$J = ["data-automation"];
function _sfc_render$Z(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_QToggle = resolveComponent("QToggle");
  return openBlock(), createElementBlock("div", {
    class: "rv-toggle row items-center",
    "data-automation": _ctx.buildId("wrapper")
  }, [
    createVNode(_component_QToggle, {
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.value = $event),
      class: normalizeClass(_ctx.$props.class),
      "data-automation": _ctx.buildId(),
      dense: _ctx.dense,
      disable: _ctx.disable,
      "false-value": _ctx.falseValue,
      "true-value": _ctx.trueValue,
      val: _ctx.val
    }, {
      default: withCtx(() => [
        _ctx.label || _ctx.$slots.default ? renderSlot(_ctx.$slots, "default", { key: 0 }, () => [
          createElementVNode("div", {
            class: "rv-toggle__label text-body3 q-ml-sm row items-center",
            "data-automation": _ctx.buildId("label")
          }, [
            createTextVNode(toDisplayString(_ctx.label) + " ", 1),
            _ctx.infoText || _ctx.$slots["infoText"] ? (openBlock(), createBlock(_component_QIcon, {
              key: 0,
              class: "q-ml-xs info-icon",
              color: "black-1",
              "data-automation": _ctx.buildId("icon-info"),
              name: "info",
              size: "16px",
              onClick: _cache[0] || (_cache[0] = withModifiers(() => {
              }, ["stop"]))
            }, {
              default: withCtx(() => [
                createVNode(_component_Tooltip, {
                  anchor: "top middle",
                  class: normalizeClass(_ctx.infoTextClass),
                  self: "bottom middle"
                }, {
                  default: withCtx(() => [
                    renderSlot(_ctx.$slots, "infoText", {}, () => [
                      createTextVNode(toDisplayString(_ctx.infoText), 1)
                    ], true)
                  ]),
                  _: 3
                }, 8, ["class"])
              ]),
              _: 3
            }, 8, ["data-automation"])) : createCommentVNode("", true)
          ], 8, _hoisted_2$J)
        ], true) : createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["modelValue", "class", "data-automation", "dense", "disable", "false-value", "true-value", "val"])
  ], 8, _hoisted_1$W);
}
const Toggle = /* @__PURE__ */ _export_sfc$1(_sfc_main$16, [["render", _sfc_render$Z], ["__scopeId", "data-v-37614148"]]);
const _sfc_main$15 = defineComponent({
  name: "ExpansionItem",
  components: {
    EllipsisText,
    QIcon: QIcon_default$1,
    QSlideTransition: QSlideTransition_default$1,
    QSpace: QSpace_default,
    Toggle
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      default: void 0,
      type: String
    },
    /**
     * Applies a generic border radius
     */
    border: {
      default: false,
      type: Boolean
    },
    /**
     * Show header below content when expanded
     */
    bottomHeader: {
      default: false,
      type: Boolean
    },
    /**
     * Apply custom class(es) to the content
     * @type {[Array, Object, String]}
     */
    contentClass: {
      default: void 0,
      type: [Array, Object, String]
    },
    /**
     * Puts expansion item into open state on initial render; Overridden by v-model if used
     */
    defaultOpened: {
      default: false,
      type: Boolean
    },
    /**
     * Apply custom class(es) to the expand icon
     * @type {[Array, Object, String]}
     */
    expandIconClass: {
      default: void 0,
      type: [Array, Object, String]
    },
    /**
     * Apply custom class(es) to the header actions
     * @type {[Array, Object, String]}
     */
    headerActionsClass: {
      default: void 0,
      type: [Array, Object, String]
    },
    /**
     * Apply custom class(es) to the header
     * @type {[Array, Object, String]}
     */
    headerClass: {
      default: void 0,
      type: [Array, Object, String]
    },
    /**
     * Applies background to all component when title is hovered
     * color name from the Quasar Color Palette
     */
    hoverBackgroundColor: {
      type: String,
      default: ""
    },
    /**
     * Apply custom class(es) to the icon item section
     * @type {[Array, Object, String]}
     */
    iconClass: {
      default: void 0,
      type: [Array, Object, String]
    },
    /**
     * Header label (unless using 'header' slot)
     */
    label: {
      default: void 0,
      type: String
    },
    /**
     * Model of the component defining the 'expanded' state; Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
     */
    modelValue: {
      default: void 0,
      type: Boolean
    },
    /**
     * Disable animation on hover
     */
    noHoverAnimation: {
      default: false,
      type: Boolean
    },
    /**
     * Show control on the right
     */
    rightIcon: {
      default: false,
      type: Boolean
    },
    /**
     * Indicates whether or not the item is toggleable.
     */
    toggleable: {
      default: true,
      type: Boolean
    },
    /**
     * Time duration to animate hide/show content
     */
    transitionDuration: {
      default: 400,
      type: Number
    },
    /**
     * Show toggle to control visibility
     */
    useToggle: {
      default: false,
      type: Boolean
    }
  },
  emits: [
    /**
     * Emitted when showing/hidden state changes; Is also used by v-model
     * @arg {Boolean} value - New state (showing/hidden)
     */
    "update:model-value"
  ],
  setup(props4, { emit }) {
    const expanded = ref$1(false);
    const hovered = ref$1(false);
    const invertIcon = computed(() => props4.rightIcon || props4.bottomHeader);
    watchEffect(() => {
      expanded.value = props4.modelValue ?? props4.defaultOpened;
    });
    function hide() {
      expanded.value = false;
      emit("update:model-value", expanded.value);
    }
    function show() {
      expanded.value = true;
      emit("update:model-value", expanded.value);
    }
    function toggle() {
      expanded.value = !expanded.value;
      emit("update:model-value", expanded.value);
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      expanded,
      hide,
      hovered,
      invertIcon,
      show,
      toggle
    };
  }
});
const _hoisted_1$V = ["data-automation"];
const _hoisted_2$I = ["data-automation"];
const _hoisted_3$B = { class: "row no-wrap items-center" };
const _hoisted_4$n = {
  key: 0,
  class: "expansion-item__content-wrapper"
};
const _hoisted_5$i = ["data-automation"];
function _sfc_render$Y(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Toggle = resolveComponent("Toggle");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_QSpace = resolveComponent("QSpace");
  const _component_QSlideTransition = resolveComponent("QSlideTransition");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass([
      "expansion-item column no-wrap",
      {
        "border-card rounded-borders q-pa-md": _ctx.border,
        "expansion-item--expanded": _ctx.expanded,
        [_ctx.hoverBackgroundColor]: _ctx.hoverBackgroundColor && _ctx.hovered,
        "expansion-item--invert-icon": _ctx.invertIcon,
        "reverse": _ctx.bottomHeader
      }
    ]),
    "data-automation": _ctx.buildId()
  }, [
    createElementVNode("div", mergeProps({
      class: ["expansion-item__header-wrapper row items-center no-wrap text-subtitle3", [
        {
          "expansion-item__header-wrapper--animated": !_ctx.noHoverAnimation && _ctx.toggleable,
          "cursor-pointer": _ctx.toggleable,
          "reverse justify-between": _ctx.rightIcon
        },
        _ctx.headerClass
      ]]
    }, {
      [toHandlerKey(_ctx.toggleable && `click`)]: _cache[1] || (_cache[1] = (...args) => _ctx.toggle && _ctx.toggle(...args))
    }, {
      onMouseout: _cache[2] || (_cache[2] = ($event) => _ctx.hovered = false),
      onMouseover: _cache[3] || (_cache[3] = ($event) => _ctx.hovered = true)
    }), [
      _ctx.toggleable ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass([
          _ctx.rightIcon ? "q-ml-sm" : "q-mr-sm",
          _ctx.iconClass
        ])
      }, [
        _ctx.useToggle ? (openBlock(), createBlock(_component_Toggle, {
          key: 0,
          modelValue: _ctx.expanded,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.expanded = $event),
          "data-automation": _ctx.buildId("toggle")
        }, null, 8, ["modelValue", "data-automation"])) : (openBlock(), createBlock(_component_QIcon, {
          key: 1,
          "aria-expanded": _ctx.expanded,
          class: normalizeClass([
            "expansion-item__icon",
            { "expansion-item__icon--rotated": _ctx.expanded },
            _ctx.expandIconClass
          ]),
          "data-automation": _ctx.buildId("icon"),
          name: _ctx.invertIcon ? "mdi-chevron-down" : "mdi-chevron-right",
          size: "sm"
        }, null, 8, ["aria-expanded", "class", "data-automation", "name"]))
      ], 2)) : createCommentVNode("", true),
      createElementVNode("div", {
        class: "expansion-item__header col zero-min-width",
        "data-automation": _ctx.buildId("header")
      }, [
        renderSlot(_ctx.$slots, "header", {}, () => [
          createElementVNode("div", _hoisted_3$B, [
            renderSlot(_ctx.$slots, "label", { expanded: _ctx.expanded }, () => [
              createVNode(_component_EllipsisText, {
                class: "zero-min-width",
                "data-automation": _ctx.buildId("header__label"),
                text: _ctx.label
              }, null, 8, ["data-automation", "text"])
            ], true),
            createVNode(_component_QSpace),
            _ctx.$slots["header-actions"] ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass(["q-pl-sm", _ctx.headerActionsClass])
            }, [
              renderSlot(_ctx.$slots, "header-actions", {}, void 0, true)
            ], 2)) : createCommentVNode("", true)
          ])
        ], true)
      ], 8, _hoisted_2$I)
    ], 16),
    createVNode(_component_QSlideTransition, { duration: _ctx.transitionDuration }, {
      default: withCtx(() => [
        _ctx.expanded ? (openBlock(), createElementBlock("div", _hoisted_4$n, [
          createElementVNode("div", {
            class: normalizeClass(_ctx.contentClass ?? "q-mt-sm"),
            "data-automation": _ctx.buildId("content")
          }, [
            renderSlot(_ctx.$slots, "default", {}, void 0, true)
          ], 10, _hoisted_5$i)
        ])) : createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["duration"])
  ], 10, _hoisted_1$V);
}
const ExpansionItem = /* @__PURE__ */ _export_sfc$1(_sfc_main$15, [["render", _sfc_render$Y], ["__scopeId", "data-v-c8edb7b9"]]);
const _sfc_main$14 = defineComponent({
  name: "ExpansionList",
  components: {
    Button
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Emits 'show-all' event when "Show all" is clicked
     */
    emitEvents: {
      type: Boolean,
      default: false
    },
    /**
     * Arrow icon will be shown on the left side of the text
     */
    iconLeft: {
      type: Boolean,
      default: false
    },
    /**
     * Items to be displayed
     */
    items: {
      type: [Object, Array],
      required: true
    },
    /**
     * Initial number of items shown
     */
    limit: {
      type: Number,
      default: 3
    },
    /**
     * Render "Show all" button
     */
    showAll: {
      type: Boolean,
      default: false
    },
    /**
     * The number of items added when "Show more" is clicked
     */
    step: {
      type: Number,
      default: 5
    },
    /**
     * Property that defines the unique key of each item (the result must be a primitive, not Object, Array, etc)
     */
    uniqueField: {
      type: String,
      default: void 0
    }
  },
  emits: [
    /**
     * Emitted when "Show all" is clicked
     */
    "show-all"
  ],
  setup(props4, { emit }) {
    const { t: t22 } = useI18n();
    const currentLimit = ref$1(props4.limit);
    const itemsLength = computed(() => {
      return Array.isArray(props4.items) ? props4.items.length : Object.keys(props4.items).length;
    });
    const itemsToShow = computed(() => {
      if (Array.isArray(props4.items)) {
        return props4.items.slice(0, currentLimit.value);
      } else {
        const entries2 = Object.entries(props4.items).slice(0, currentLimit.value);
        return fromEntries(entries2);
      }
    });
    function onShowAll() {
      if (props4.emitEvents) {
        emit("show-all");
      } else {
        currentLimit.value = itemsLength.value;
      }
    }
    function onShowLess() {
      currentLimit.value = props4.limit;
    }
    function onShowMore() {
      currentLimit.value += props4.step;
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      currentLimit,
      itemsLength,
      itemsToShow,
      onShowAll,
      onShowLess,
      onShowMore,
      t: t22
    };
  }
});
const _hoisted_1$U = ["data-automation"];
const _hoisted_2$H = ["data-automation"];
const _hoisted_3$A = {
  key: 0,
  class: "expansion-list__action q-my-sm"
};
function _sfc_render$X(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = resolveComponent("Button");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["expansion-list full-width", {
      "expansion-list--expandable": _ctx.itemsLength > _ctx.limit
    }]),
    "data-automation": _ctx.buildId()
  }, [
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.itemsToShow, (item, key) => {
      return openBlock(), createElementBlock("div", {
        key: (_ctx.uniqueField && item[_ctx.uniqueField]) ?? key,
        class: "expansion-list__content",
        "data-automation": _ctx.buildId(`content-${String(key)}`)
      }, [
        renderSlot(_ctx.$slots, "default", {
          item,
          itemKey: key
        })
      ], 8, _hoisted_2$H);
    }), 128)),
    _ctx.itemsLength > _ctx.limit ? (openBlock(), createElementBlock("div", _hoisted_3$A, [
      _ctx.showAll && _ctx.itemsLength > _ctx.currentLimit ? (openBlock(), createBlock(_component_Button, {
        key: 0,
        class: "no-padding full-width items-start",
        color: "black-1",
        "data-automation": _ctx.buildId("show-all"),
        icon: _ctx.iconLeft ? "mdi-chevron-right" : void 0,
        "icon-right": _ctx.iconLeft ? void 0 : "mdi-chevron-right",
        label: _ctx.t("rvai-base.general.actions.showAll"),
        size: "sm",
        tertiary: "",
        onClick: _ctx.onShowAll
      }, null, 8, ["data-automation", "icon", "icon-right", "label", "onClick"])) : _ctx.itemsLength > _ctx.currentLimit ? (openBlock(), createBlock(_component_Button, {
        key: 1,
        class: "no-padding full-width items-start",
        color: "black-1",
        "data-automation": _ctx.buildId("show-more"),
        icon: _ctx.iconLeft ? "mdi-chevron-down" : void 0,
        "icon-right": _ctx.iconLeft ? void 0 : "mdi-chevron-down",
        label: _ctx.t("rvai-base.general.actions.showMore"),
        size: "sm",
        tertiary: "",
        onClick: _ctx.onShowMore
      }, null, 8, ["data-automation", "icon", "icon-right", "label", "onClick"])) : (openBlock(), createBlock(_component_Button, {
        key: 2,
        class: "no-padding full-width items-start",
        color: "black-1",
        "data-automation": _ctx.buildId("show-less"),
        icon: _ctx.iconLeft ? "mdi-chevron-up" : void 0,
        "icon-right": _ctx.iconLeft ? void 0 : "mdi-chevron-up",
        label: _ctx.t("rvai-base.general.actions.showLess"),
        size: "sm",
        tertiary: "",
        onClick: _ctx.onShowLess
      }, null, 8, ["data-automation", "icon", "icon-right", "label", "onClick"]))
    ])) : createCommentVNode("", true)
  ], 10, _hoisted_1$U);
}
const ExpansionList = /* @__PURE__ */ _export_sfc$1(_sfc_main$14, [["render", _sfc_render$X]]);
const _sfc_main$13 = defineComponent({
  name: "FieldEdit",
  components: {
    Button,
    EllipsisText,
    QField: QField_default$1,
    QIcon: QIcon_default$1,
    QSpace: QSpace_default,
    Tooltip: Tooltip2
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Render info icon with tooltip. Can be used as an "info-text" property or as a slot
     */
    infoText: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to the info text
     */
    infoTextClass: {
      type: String,
      default: "rv-field-edit__info-text"
    },
    /**
     * The text that will be shown on the component
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Classes applied to the label
     * @type {[Array, Object, String]}
     */
    labelClass: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Model of the component
     * @type {[Array, Object, String]}
     */
    modelValue: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      type: [Array, Boolean, Object, String, Number],
      default: void 0
    },
    /**
     * The text that will be shown next to label
     */
    optionalLabel: {
      type: String,
      default: ""
    },
    readonly: {
      default: false,
      type: Boolean
    },
    /**
     * Shows error message
     */
    showErrorMessage: {
      type: Boolean,
      default: true
    },
    /**
     * Render optional label next to label
     */
    showOptionalLabel: {
      type: Boolean,
      default: false
    },
    /**
     * Validation for the component
     */
    validation: {
      type: Object,
      default: void 0
    }
  },
  emits: [
    /**
     * Emitted when "Add/Edit" is clicked
     */
    "on-edit"
  ],
  setup(props4, { emit }) {
    const { t: t22 } = useI18n();
    const {
      classRef,
      error,
      errorMessage,
      isValidated
    } = useValidation(props4);
    const editIcon = computed(() => {
      return isEmpty2.value ? "mdi-plus" : "mdi-pencil";
    });
    const editLabel = computed(() => {
      return isEmpty2.value ? t22("rvai-base.general.actions.add") : t22("rvai-base.general.actions.edit");
    });
    const isEmpty2 = computed(() => {
      const value2 = props4.modelValue;
      return Array.isArray(value2) ? !value2.length : !value2;
    });
    function onEdit() {
      emit("on-edit");
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      classRef,
      editIcon,
      editLabel,
      error,
      errorMessage,
      isEmpty: isEmpty2,
      isValidated,
      onEdit,
      t: t22
    };
  }
});
const _hoisted_1$T = ["data-automation"];
const _hoisted_2$G = { class: "row no-wrap items-center full-width" };
const _hoisted_3$z = {
  key: 0,
  class: "q-ml-xs",
  "data-test": "optional"
};
const _hoisted_4$m = ["data-automation"];
function _sfc_render$W(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_QSpace = resolveComponent("QSpace");
  const _component_Button = resolveComponent("Button");
  const _component_QField = resolveComponent("QField");
  return openBlock(), createElementBlock("div", mergeProps(_ctx.dataAttrs, {
    class: ["rv-field-edit", [
      _ctx.classRef,
      { "rv-field-edit--disabled": _ctx.disable }
    ]],
    "data-automation": _ctx.buildId()
  }), [
    createElementVNode("div", {
      class: normalizeClass(["rv-field-edit__label row no-wrap justify-between items-center", _ctx.labelClass])
    }, [
      createElementVNode("div", _hoisted_2$G, [
        renderSlot(_ctx.$slots, "label", {}, () => [
          createVNode(_component_EllipsisText, {
            class: "text-subtitle3",
            "data-automation": _ctx.buildId("label"),
            text: _ctx.label
          }, null, 8, ["data-automation", "text"])
        ], true),
        _ctx.showOptionalLabel ? (openBlock(), createElementBlock("div", _hoisted_3$z, toDisplayString(_ctx.optionalLabel || _ctx.t("rvai-base.general.inputs.optional")), 1)) : createCommentVNode("", true),
        _ctx.infoText || _ctx.$slots["info-text"] ? (openBlock(), createBlock(_component_QIcon, {
          key: 1,
          class: "q-ml-xs info-icon",
          color: "black-1",
          "data-automation": _ctx.buildId("icon-info"),
          name: "info",
          size: "16px"
        }, {
          default: withCtx(() => [
            createVNode(_component_Tooltip, {
              anchor: "top middle",
              class: normalizeClass(_ctx.infoTextClass),
              self: "bottom middle"
            }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "info-text", {}, () => [
                  createTextVNode(toDisplayString(_ctx.infoText), 1)
                ], true)
              ]),
              _: 3
            }, 8, ["class"])
          ]),
          _: 3
        }, 8, ["data-automation"])) : createCommentVNode("", true),
        createVNode(_component_QSpace),
        _ctx.isValidated && !_ctx.isEmpty && !_ctx.readonly ? (openBlock(), createBlock(_component_QIcon, {
          key: "valid",
          class: "rv-field-edit__status",
          color: "positive",
          "data-automation": _ctx.buildId("icon-valid"),
          name: "mdi-check-circle"
        }, null, 8, ["data-automation"])) : _ctx.error && _ctx.showErrorMessage && !_ctx.readonly ? (openBlock(), createBlock(_component_QIcon, {
          key: "error",
          class: "rv-field-edit__status",
          color: "negative",
          "data-automation": _ctx.buildId("icon-error"),
          name: "mdi-close-circle"
        }, null, 8, ["data-automation"])) : createCommentVNode("", true),
        !_ctx.readonly ? (openBlock(), createBlock(_component_Button, {
          key: 4,
          class: "q-ml-sm",
          "data-automation": _ctx.buildId("edit"),
          disable: _ctx.disable,
          icon: _ctx.editIcon,
          label: _ctx.editLabel,
          size: "sm",
          tertiary: "",
          onClick: _ctx.onEdit
        }, null, 8, ["data-automation", "disable", "icon", "label", "onClick"])) : createCommentVNode("", true),
        renderSlot(_ctx.$slots, "label-append", {}, void 0, true)
      ])
    ], 2),
    createVNode(_component_QField, {
      class: normalizeClass(["q-pa-none", { "q-pt-sm": !_ctx.isEmpty }]),
      "data-automation": _ctx.buildId("q-field"),
      dense: "",
      error: _ctx.error,
      "error-message": _ctx.showErrorMessage ? _ctx.errorMessage : "",
      "hide-bottom-space": "",
      "model-value": _ctx.modelValue,
      "no-error-icon": "",
      standout: ""
    }, {
      default: withCtx(() => [
        createElementVNode("div", {
          class: "full-width",
          "data-automation": _ctx.buildId("default-slot")
        }, [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ], 8, _hoisted_4$m)
      ]),
      _: 3
    }, 8, ["class", "data-automation", "error", "error-message", "model-value"])
  ], 16, _hoisted_1$T);
}
const FieldEdit = /* @__PURE__ */ _export_sfc$1(_sfc_main$13, [["render", _sfc_render$W], ["__scopeId", "data-v-9c203a28"]]);
const _sfc_main$12 = defineComponent({
  name: "FilePicker",
  components: {
    Button,
    EllipsisText,
    QFile: QFile_default,
    QIcon: QIcon_default$1
  },
  props: {
    /**
     * List of all accepted file extentions
     */
    acceptedFiles: {
      default: void 0,
      type: Array
    },
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      default: void 0,
      type: String
    },
    /**
     * Value to show in input while file is not selected yet
     */
    defaultValue: {
      default: "",
      type: String
    },
    /**
     * Set component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Prevent displaying hint below the input
     */
    hideHint: {
      default: false,
      type: Boolean
    },
    /**
     * Hint text below the input
     */
    hintText: {
      default: void 0,
      type: String
    },
    /**
     * Label of the input
     */
    label: {
      default: void 0,
      type: String
    },
    /**
     * Maximum allowed file size
     */
    maxFileSize: {
      default: void 0,
      type: Number
    },
    /**
     * v-model
     */
    modelValue: {
      default: void 0,
      type: File
    },
    /**
     * Show optional label next to label
     */
    showOptionalLabel: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    "update:modelValue"
  ],
  setup(props4, { emit }) {
    const { t: t22 } = useI18n();
    const inputRef = ref$1();
    const filename = ref$1("");
    const validationError = ref$1("");
    const hasValidationError = computed(() => !!validationError.value);
    const hintTextValue = computed(() => {
      var _a;
      return props4.hintText ?? ((_a = props4.acceptedFiles) == null ? void 0 : _a.map((type2) => type2.toUpperCase().replace(".", "")).join(", ")) ?? "";
    });
    function clear() {
      filename.value = "";
      validationError.value = "";
    }
    function getFormattedFileSize() {
      if (!props4.maxFileSize) return;
      const bytes = props4.maxFileSize;
      const k22 = bytes > 0 ? Math.floor(Math.log2(bytes) / 10) : 0;
      const rank = (k22 > 0 ? "KMGT"[k22 - 1] : "") + "B";
      const count = Math.floor(bytes / Math.pow(1024, k22));
      return `${count}${rank}`;
    }
    function onUpdate(value2) {
      emit("update:modelValue", value2);
      filename.value = value2.name;
      validationError.value = "";
    }
    function onRejected(rejectedEntries) {
      if (rejectedEntries.some((e22) => e22.failedPropValidation === "accept")) {
        validationError.value = t22("rvai-base.validation.wrongFormat");
      } else if (rejectedEntries.some((e22) => e22.failedPropValidation === "max-file-size")) {
        validationError.value = t22("rvai-base.validation.fileTooLarge", [getFormattedFileSize()]);
      }
      emit("update:modelValue", null);
      filename.value = rejectedEntries[0].file.name;
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      clear,
      filename,
      hasValidationError,
      hintTextValue,
      inputRef,
      onRejected,
      onUpdate,
      t: t22,
      validationError
    };
  }
});
const _hoisted_1$S = ["data-automation"];
const _hoisted_2$F = { class: "row no-wrap items-center full-width" };
const _hoisted_3$y = ["data-automation"];
const _hoisted_4$l = ["data-automation"];
const _hoisted_5$h = { class: "file-picker__filename-container full-width overflow-hidden" };
function _sfc_render$V(_ctx, _cache, $props, $setup, $data, $options) {
  var _a;
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_Button = resolveComponent("Button");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_QFile = resolveComponent("QFile");
  return openBlock(), createElementBlock("div", {
    class: "file-picker__container",
    "data-automation": _ctx.buildId()
  }, [
    renderSlot(_ctx.$slots, "label", {}, () => [
      createElementVNode("div", _hoisted_2$F, [
        createElementVNode("div", {
          class: normalizeClass(["text-black-1 text-subtitle3", { "text-grey-2": _ctx.disable }]),
          "data-automation": _ctx.buildId("label")
        }, toDisplayString(_ctx.label), 11, _hoisted_3$y),
        _ctx.showOptionalLabel ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "q-ml-xs",
          "data-automation": _ctx.buildId("optional")
        }, toDisplayString(_ctx.t("rvai-base.general.inputs.optional")), 9, _hoisted_4$l)) : createCommentVNode("", true)
      ])
    ], true),
    createVNode(_component_QFile, {
      ref: "inputRef",
      accept: (_a = _ctx.acceptedFiles) == null ? void 0 : _a.join(","),
      "bg-color": "grey-6",
      borderless: "",
      class: normalizeClass(["file-picker__input ellipsis", { "file-picker__input--disabled": _ctx.disable }]),
      "data-automation": _ctx.buildId("input"),
      disable: _ctx.disable,
      "display-value": "",
      error: !!_ctx.validationError,
      "error-message": _ctx.validationError,
      hint: _ctx.hideHint ? "" : _ctx.hintTextValue,
      "max-file-size": _ctx.maxFileSize,
      "model-value": _ctx.modelValue,
      "no-error-icon": "",
      onRejected: _ctx.onRejected,
      "onUpdate:modelValue": _ctx.onUpdate
    }, {
      default: withCtx(() => [
        createElementVNode("div", _hoisted_5$h, [
          createVNode(_component_EllipsisText, {
            class: "text-body3",
            "data-automation": _ctx.buildId("filename"),
            text: _ctx.filename || _ctx.defaultValue
          }, null, 8, ["data-automation", "text"])
        ])
      ]),
      after: withCtx(() => [
        createVNode(_component_Button, {
          "data-automation": _ctx.buildId("browse-files"),
          disable: _ctx.disable,
          label: _ctx.$t("rvai-base.general.actions.browse"),
          secondary: "",
          size: "md",
          type: "a",
          onClick: _cache[0] || (_cache[0] = withModifiers(($event) => {
            var _a2;
            return (_a2 = _ctx.inputRef) == null ? void 0 : _a2.pickFiles();
          }, ["prevent"]))
        }, null, 8, ["data-automation", "disable", "label"]),
        _ctx.validationError ? (openBlock(), createBlock(_component_QIcon, {
          key: 0,
          class: "q-ml-xs",
          color: "negative",
          "data-automation": _ctx.buildId("alert"),
          name: "rvai-base:cancel",
          size: "20px"
        }, null, 8, ["data-automation"])) : !!_ctx.filename ? (openBlock(), createBlock(_component_QIcon, {
          key: 1,
          class: "q-ml-xs",
          color: "positive",
          "data-automation": _ctx.buildId("success"),
          name: "rvai-base:success",
          size: "20px"
        }, null, 8, ["data-automation"])) : createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["accept", "class", "data-automation", "disable", "error", "error-message", "hint", "max-file-size", "model-value", "onRejected", "onUpdate:modelValue"])
  ], 8, _hoisted_1$S);
}
const FilePicker = /* @__PURE__ */ _export_sfc$1(_sfc_main$12, [["render", _sfc_render$V], ["__scopeId", "data-v-b0e895a0"]]);
const _sfc_main$11 = defineComponent({
  name: "NoData",
  components: {
    QIcon: QIcon_default$1
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to the Histogram
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    iconName: {
      type: String,
      default: ""
    },
    iconSize: {
      type: String,
      default: ""
    },
    iconShape: {
      type: String,
      default: ShapesNoData.Horizontal,
      validator: (v) => Object.values(ShapesNoData).includes(v)
    },
    subtitle: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    }
  },
  setup(props4) {
    return {
      ...useAutomation(computed(() => props4.dataAutomation))
    };
  }
});
const _hoisted_1$R = ["data-automation"];
const _hoisted_2$E = { class: "wrapper column flex-center full-width" };
const _hoisted_3$x = ["data-automation"];
const _hoisted_4$k = ["data-automation"];
const _hoisted_5$g = ["data-automation"];
function _sfc_render$U(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QIcon = resolveComponent("QIcon");
  return openBlock(), createElementBlock("div", mergeProps({
    class: ["rv-no-data text-center flex flex-center", _ctx.$props.class],
    "data-automation": _ctx.buildId()
  }, _ctx.$attrs), [
    createElementVNode("div", _hoisted_2$E, [
      _ctx.iconName ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(["icon-wrapper flex-center", { [_ctx.iconShape]: !_ctx.iconSize }]),
        "data-automation": _ctx.buildId("icon-wrapper")
      }, [
        createVNode(_component_QIcon, {
          class: normalizeClass(["icon", { "icon--full-size": !_ctx.iconSize }]),
          name: _ctx.iconName,
          size: _ctx.iconSize
        }, null, 8, ["class", "name", "size"])
      ], 10, _hoisted_3$x)) : createCommentVNode("", true),
      _ctx.title ? (openBlock(), createElementBlock("div", {
        key: 1,
        class: "text-h1 q-mt-lg",
        "data-automation": _ctx.buildId("title")
      }, toDisplayString(_ctx.title), 9, _hoisted_4$k)) : createCommentVNode("", true),
      _ctx.subtitle ? (openBlock(), createElementBlock("div", {
        key: 2,
        class: "q-mt-md text-body3",
        "data-automation": _ctx.buildId("subtitle")
      }, toDisplayString(_ctx.subtitle), 9, _hoisted_5$g)) : createCommentVNode("", true),
      createElementVNode("div", {
        class: normalizeClass(["full-width", {
          "q-mt-md": _ctx.title,
          "q-mt-lg": _ctx.subtitle
        }])
      }, [
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ], 2)
    ])
  ], 16, _hoisted_1$R);
}
const NoData = /* @__PURE__ */ _export_sfc$1(_sfc_main$11, [["render", _sfc_render$U], ["__scopeId", "data-v-378b9301"]]);
const _sfc_main$10 = defineComponent({
  name: "Radio",
  components: {
    QRadio: QRadio_default$1
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Dense mode; occupies less space
     */
    dense: {
      type: Boolean,
      default: false
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Label to display along the component
     */
    label: {
      type: String,
      default: void 0
    },
    /**
     * Model of the component; Either use this property (along with a listener for 'update:model-value' event) OR use v-model directive
     */
    modelValue: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      type: [Boolean, Number, String, Array],
      default: void 0
    },
    /**
     * The actual value of the option with which model value is changed
     */
    val: {
      type: null,
      default: void 0
    }
  },
  emits: ["update:modelValue"],
  setup(props4, { emit }) {
    const value2 = computed({
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      get() {
        return props4.modelValue;
      },
      set(value22) {
        emit("update:modelValue", value22);
      }
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      value: value2
    };
  }
});
function _sfc_render$T(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QRadio = resolveComponent("QRadio");
  return openBlock(), createBlock(_component_QRadio, mergeProps(_ctx.dataAttrs, {
    modelValue: _ctx.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.value = $event),
    class: ["rv-radio", _ctx.$props.class],
    "data-automation": _ctx.buildId(),
    dense: _ctx.dense,
    disable: _ctx.disable,
    label: _ctx.label,
    val: _ctx.val
  }), {
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default", {}, void 0, true)
    ]),
    _: 3
  }, 16, ["modelValue", "class", "data-automation", "dense", "disable", "label", "val"]);
}
const Radio = /* @__PURE__ */ _export_sfc$1(_sfc_main$10, [["render", _sfc_render$T], ["__scopeId", "data-v-b5f9518f"]]);
const _sfc_main$$ = defineComponent({
  name: "SortButton",
  components: {
    Button,
    QIcon: QIcon_default$1,
    QItem: QItem_default$1,
    QItemLabel: QItemLabel_default$1,
    QList: QList_default$1,
    QMenu: QMenu_default$1,
    Tooltip: Tooltip2
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    modelValue: {
      type: Object,
      default: void 0
    },
    sortFields: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      type: Array,
      required: true
    }
  },
  emits: [
    "update:modelValue"
  ],
  setup(props4, { emit }) {
    const { t: t22 } = useI18n();
    function onSort(value2) {
      emit("update:modelValue", value2);
    }
    onMounted(() => {
      const defaultSortField = props4.sortFields.find((f) => f.sortByDefault);
      onSort(defaultSortField || props4.sortFields[0]);
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      onSort,
      t: t22
    };
  }
});
function _sfc_render$S(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_QItemLabel = resolveComponent("QItemLabel");
  const _component_QItem = resolveComponent("QItem");
  const _component_QList = resolveComponent("QList");
  const _component_QMenu = resolveComponent("QMenu");
  const _component_Button = resolveComponent("Button");
  return openBlock(), createBlock(_component_Button, {
    class: "no-padding",
    color: "black-1",
    "data-automation": _ctx.buildId(),
    icon: "rvai-base:sort-asc",
    tertiary: ""
  }, {
    default: withCtx(() => [
      createVNode(_component_Tooltip, {
        "data-automation": _ctx.buildId("tooltip")
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(_ctx.t("rvai-base.general.actions.sort")), 1)
        ]),
        _: 1
      }, 8, ["data-automation"]),
      createVNode(_component_QMenu, {
        "auto-close": "",
        class: "sort-menu",
        self: "top right",
        style: { "min-width": "220px" }
      }, {
        default: withCtx(() => [
          createVNode(_component_QList, { separator: "" }, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.sortFields, (item) => {
                return openBlock(), createBlock(_component_QItem, {
                  key: item.name,
                  clickable: "",
                  "data-automation": _ctx.buildId(`item-${String(item.name)}`),
                  onClick: ($event) => _ctx.onSort(item)
                }, {
                  default: withCtx(() => [
                    createVNode(_component_QItemLabel, { class: "row justify-between items-center full-width" }, {
                      default: withCtx(() => [
                        createElementVNode("span", null, toDisplayString(item.label), 1),
                        _ctx.modelValue && item.label === _ctx.modelValue.label ? (openBlock(), createBlock(_component_QIcon, {
                          key: 0,
                          name: "mdi-check",
                          size: "18px"
                        })) : createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["data-automation", "onClick"]);
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data-automation"]);
}
const SortButton = /* @__PURE__ */ _export_sfc$1(_sfc_main$$, [["render", _sfc_render$S]]);
const INITIAL_DATA_SIZE = 200;
const _sfc_main$_ = defineComponent({
  name: "FilterableList",
  components: {
    Button,
    Checkbox,
    EllipsisText,
    Input,
    NoData,
    QIcon: QIcon_default$1,
    QInfiniteScroll: QInfiniteScroll_default,
    QIntersection: QIntersection_default,
    QItem: QItem_default$1,
    QItemLabel: QItemLabel_default$1,
    QItemSection: QItemSection_default$1,
    QList: QList_default$1,
    Radio,
    SortButton,
    Tooltip: Tooltip2
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Makes items in the list clickable
     */
    clickable: {
      type: Boolean,
      default: false
    },
    /**
     * Render custom item in slot #item
     */
    customItem: {
      type: Boolean,
      default: false
    },
    /**
     * Items to be displayed
     * @type {[Record<string, unknown>]}
     */
    data: {
      type: Array,
      required: true
    },
    /**
     * On hover the delete icon will be visible
     */
    deletable: {
      type: Boolean,
      default: false
    },
    /**
     * Hides 'Select all' when 'multiple' property is true
     */
    hideSelectAll: {
      type: Boolean,
      default: false
    },
    /**
     * Hides checkboxes when 'multiple' property is true
     */
    hideSelectors: {
      type: Boolean,
      default: false
    },
    /**
     *  Put item in disabled mode when immutableField is presented
     */
    immutableField: {
      type: String,
      default: void 0
    },
    /**
     *  Show data partially when scrolling
     */
    infiniteScrolling: {
      type: Boolean,
      default: false
    },
    /**
     *  Show data partially when scrolling
     */
    infiniteScrollingSize: {
      type: Number,
      default: INITIAL_DATA_SIZE
    },
    /**
     *  Render the label at the top and search button next to it
     */
    /**
     *  Classes for infinite scroll wrapper
     */
    infiniteScrollWrapperClass: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: void 0
    },
    /**
     * Model of the component; Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
     */
    modelValue: {
      type: [Array, Object],
      default: void 0
    },
    /**
     * Render checkboxes instead of radio buttons
     */
    multiple: {
      type: Boolean,
      default: false
    },
    /**
     * Allow to provide slot 'item'
     */
    nestedKey: {
      type: String,
      default: ""
    },
    /**
     * Property of option which holds the 'label'; If using a function then for best performance, reference it from your scope and do not define it inline
     */
    optionLabel: {
      type: String,
      default: "label"
    },
    /**
     * Property of option which holds the 'value'; If using a function then for best performance, reference it from your scope and do not define it inline
     */
    optionValue: {
      type: String,
      default: "value"
    },
    /**
     * Render label as radio button
     */
    notSelectedOptionLabel: {
      type: String,
      default: ""
    },
    /**
     * Disable select all checkbox
     */
    selectAllDisabled: {
      type: Boolean,
      default: false
    },
    /**
     * Show tooltip when checkbox disabled
     */
    selectAllDisabledTooltip: {
      type: String,
      default: ""
    },
    /**
     * Provides the ability to sort data
     */
    sortFields: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      type: Array,
      default: null
    },
    /**
     * Custom options to setup in Intl.Collator to sort data
     */
    sortOptions: {
      type: Object,
      default: void 0
    },
    /**
     * Disable the ability to select items
     */
    toggable: {
      type: Boolean,
      default: false
    },
    /**
     * Wraps each item with QIntersection
     */
    withIntersection: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    /**
     * Emitted when delete icon is clicked
     */
    "delete-item",
    /**
     * Emitted when item in the list is clicked
     */
    "on-click-item",
    /**
     * Emitted when data was sorted
     */
    "on-sort",
    /**
     * Emitted when items in the list are selected
     */
    "update:modelValue"
  ],
  setup(props4, { emit }) {
    const { t: t22 } = useI18n();
    const dataSize = ref$1(props4.infiniteScrollingSize);
    const filter = ref$1("");
    const infiniteScrollRef = ref$1();
    const showFilter = ref$1(false);
    const showSelectorValue = ref$1(false);
    const sortField = ref$1();
    const allSelected = computed(() => {
      if (Array.isArray(filteredData.value)) {
        const isEveryItemNotSelected = filteredData.value.filter((d32) => !props4.immutableField || !d32[props4.immutableField]).every((d32) => !selected.value.includes(d32[props4.optionValue]));
        if (isEveryItemNotSelected) return false;
        const isEveryItemSelected = filteredData.value.filter((d32) => !props4.immutableField || !d32[props4.immutableField]).every((d32) => selected.value.includes(d32[props4.optionValue]));
        if (isEveryItemSelected) return true;
        return void 0;
      }
      return false;
    });
    const sortedData = computed(() => {
      if (!sortField.value) return props4.data;
      return sortField.value.type === SortType.Date ? sortByDate(props4.data, sortField.value.name, sortField.value.order === SortOrders.Asc) : sortByKey(props4.data, sortField.value.name, sortField.value.order === SortOrders.Asc, naturalSortWrapper);
    });
    const filteredData = computed(() => {
      const needle = filter.value.toLowerCase();
      return sortedData.value.filter((i22) => String(i22[props4.optionLabel]).toLowerCase().includes(needle));
    });
    const dataToShow = computed(() => {
      return props4.infiniteScrolling ? filteredData.value.slice(0, dataSize.value) : filteredData.value;
    });
    const selected = computed(() => {
      if (!props4.modelValue) return void 0;
      return Array.isArray(props4.modelValue) ? props4.modelValue.map((x22) => x22[props4.optionValue]) : props4.modelValue[props4.optionValue];
    });
    const showSelector = computed(() => !props4.hideSelectors && (!props4.toggable || showSelectorValue.value));
    function naturalSortWrapper(a32, b22) {
      return props4.sortOptions ? new Intl.Collator(void 0, props4.sortOptions).compare(a32, b22) : naturalSort(a32, b22);
    }
    function onDeleteItem(itemValue) {
      emit("delete-item", itemValue);
    }
    function onLoad(v, done) {
      if (!props4.infiniteScrolling) return;
      if (dataSize.value !== filteredData.value.length) {
        const nextPageSize = v * props4.infiniteScrollingSize;
        dataSize.value = nextPageSize > filteredData.value.length ? filteredData.value.length : nextPageSize;
      }
      done();
    }
    function onSelectNone() {
      emit("update:modelValue", null);
    }
    function onSort(v) {
      sortField.value = v;
      resetInfinityScroll();
      emit("on-sort", v);
    }
    function onToggle(value2) {
      const payload = Array.isArray(value2) ? value2.map((v) => props4.data.find((x22) => x22[props4.optionValue] === v)) : props4.data.find((x22) => x22[props4.optionValue] === value2);
      emit("update:modelValue", payload);
    }
    function onToggleAll() {
      const filteredDataValues = filteredData.value.filter((d32) => !props4.immutableField || !d32[props4.immutableField]).map((v) => v[props4.optionValue]);
      const uniqueValues = distinct([...selected.value, ...filteredDataValues]);
      const hiddenSelectedValues = selected.value.filter((v) => !filteredData.value.some((x22) => x22[props4.optionValue] === v));
      const updateValue2 = allSelected.value ? hiddenSelectedValues : uniqueValues;
      emit(
        "update:modelValue",
        updateValue2.map((v) => props4.data.find((d32) => v === d32[props4.optionValue]))
      );
    }
    function onToggleFilter() {
      showFilter.value = !showFilter.value;
      if (!showFilter.value) {
        resetSearch();
      }
    }
    function onToggleShowSelector() {
      showSelectorValue.value = !showSelectorValue.value;
      if (!showSelectorValue.value) {
        emit("update:modelValue", props4.multiple ? [] : void 0);
      }
    }
    function resetInfinityScroll() {
      var _a;
      dataSize.value = props4.infiniteScrollingSize;
      (_a = infiniteScrollRef.value) == null ? void 0 : _a.reset();
    }
    function resetSearch() {
      filter.value = "";
      resetInfinityScroll();
    }
    function setFilter(v) {
      filter.value = v;
      resetInfinityScroll();
    }
    watch(() => props4.data, () => {
      const selection = props4.modelValue;
      if (!selection) return void 0;
      let payload;
      if (Array.isArray(selection)) {
        payload = props4.data.filter((v) => selection.some((x22) => x22[props4.optionValue] === v[props4.optionValue]));
      } else {
        payload = props4.data.find((v) => selection[props4.optionValue] === v[props4.optionValue]);
      }
      emit("update:modelValue", payload);
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      allSelected,
      dataToShow,
      filter,
      filteredData,
      infiniteScrollRef,
      // initialItemsHeight,
      // itemRefs,
      onDeleteItem,
      onLoad,
      onSelectNone,
      onSort,
      onToggle,
      onToggleAll,
      onToggleFilter,
      onToggleShowSelector,
      // onVisibilityChange,
      resetSearch,
      selected,
      setFilter,
      showFilter,
      showSelector,
      sortedData,
      sortField,
      t: t22
    };
  }
});
const _hoisted_1$Q = ["data-automation"];
const _hoisted_2$D = ["data-automation"];
const _hoisted_3$w = { class: "row no-wrap q-pl-sm" };
const _hoisted_4$j = { class: "q-mb-lg" };
const _hoisted_5$f = { class: "text-bold" };
function _sfc_render$R(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_Button = resolveComponent("Button");
  const _component_SortButton = resolveComponent("SortButton");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_Input = resolveComponent("Input");
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_Checkbox = resolveComponent("Checkbox");
  const _component_QItemSection = resolveComponent("QItemSection");
  const _component_QItemLabel = resolveComponent("QItemLabel");
  const _component_QItem = resolveComponent("QItem");
  const _component_Radio = resolveComponent("Radio");
  const _component_QInfiniteScroll = resolveComponent("QInfiniteScroll");
  const _component_NoData = resolveComponent("NoData");
  const _component_QList = resolveComponent("QList");
  return openBlock(), createElementBlock("div", {
    class: "filterable-list",
    "data-automation": _ctx.buildId()
  }, [
    _ctx.label ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: "row no-wrap full-width justify-between q-mb-sm",
      "data-automation": _ctx.buildId("label-wrapper")
    }, [
      createVNode(_component_EllipsisText, {
        class: "text-subtitle3 text-center text-black-1",
        "data-automation": _ctx.buildId("label"),
        text: _ctx.label
      }, null, 8, ["data-automation", "text"]),
      createElementVNode("div", _hoisted_3$w, [
        createVNode(_component_Button, {
          class: "no-padding",
          color: "black-1",
          "data-automation": _ctx.buildId("search"),
          disable: _ctx.data.length === 0,
          icon: "search",
          tertiary: "",
          tooltip: _ctx.t("rvai-base.general.actions.search"),
          onClick: _ctx.onToggleFilter
        }, null, 8, ["data-automation", "disable", "tooltip", "onClick"]),
        _ctx.sortFields && _ctx.sortFields.length > 0 ? (openBlock(), createBlock(_component_SortButton, {
          key: 0,
          modelValue: _ctx.sortField,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event) => _ctx.sortField = $event),
            _ctx.onSort
          ],
          class: "q-mr-sm",
          "data-automation": _ctx.buildId("sort"),
          disable: _ctx.data.length === 0,
          "sort-fields": _ctx.sortFields
        }, null, 8, ["modelValue", "data-automation", "disable", "sort-fields", "onUpdate:modelValue"])) : createCommentVNode("", true),
        _ctx.toggable ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          !_ctx.showSelector ? (openBlock(), createBlock(_component_Button, {
            key: 0,
            color: "black-1",
            "data-automation": _ctx.buildId("multi-select"),
            icon: "rvai-base:multi-select",
            size: "sm",
            tertiary: "",
            tooltip: _ctx.t("rvai-base.general.text.multiselect"),
            onClick: _ctx.onToggleShowSelector
          }, null, 8, ["data-automation", "tooltip", "onClick"])) : (openBlock(), createBlock(_component_Button, {
            key: 1,
            color: "primary",
            "data-automation": _ctx.buildId("cancel"),
            size: "sm",
            tertiary: "",
            onClick: _ctx.onToggleShowSelector
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(_ctx.t("rvai-base.general.actions.cancel")), 1)
            ]),
            _: 1
          }, 8, ["data-automation", "onClick"]))
        ], 64)) : createCommentVNode("", true)
      ])
    ], 8, _hoisted_2$D)) : createCommentVNode("", true),
    _ctx.showFilter ? (openBlock(), createBlock(_component_Input, {
      key: 1,
      autofocus: "",
      "data-automation": _ctx.buildId("searchInput"),
      icon: "search",
      "label-class": "q-pb-sm",
      "model-value": _ctx.filter,
      placeholder: _ctx.t("rvai-base.general.actions.search"),
      "onUpdate:modelValue": _ctx.setFilter
    }, {
      prepend: withCtx(() => [
        createVNode(_component_QIcon, {
          color: "black-1",
          name: "search"
        })
      ]),
      _: 1
    }, 8, ["data-automation", "model-value", "placeholder", "onUpdate:modelValue"])) : createCommentVNode("", true),
    _ctx.$slots["append-content"] ? renderSlot(_ctx.$slots, "append-content", { key: 2 }, void 0, true) : createCommentVNode("", true),
    createVNode(_component_QList, {
      "data-automation": _ctx.buildId("list")
    }, {
      default: withCtx(() => [
        _ctx.multiple && _ctx.showSelector && _ctx.filteredData.length && !_ctx.hideSelectAll ? (openBlock(), createBlock(_component_QItem, {
          key: 0,
          class: "q-pa-none",
          "data-automation": _ctx.buildId("item-multiple"),
          tag: "label"
        }, {
          default: withCtx(() => [
            _ctx.selectAllDisabledTooltip && _ctx.selectAllDisabled ? (openBlock(), createBlock(_component_Tooltip, {
              key: 0,
              anchor: "center left",
              "data-automation": _ctx.buildId("checkbox-tooltip")
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(_ctx.selectAllDisabledTooltip), 1)
              ]),
              _: 1
            }, 8, ["data-automation"])) : createCommentVNode("", true),
            createVNode(_component_QItemSection, {
              avatar: "",
              class: "filterable-list__checkbox",
              "data-automation": _ctx.buildId("avatar")
            }, {
              default: withCtx(() => [
                createVNode(_component_Checkbox, {
                  "data-automation": _ctx.buildId("checkbox"),
                  dense: "",
                  disable: _ctx.selectAllDisabled,
                  "model-value": _ctx.allSelected,
                  "onUpdate:modelValue": _ctx.onToggleAll
                }, null, 8, ["data-automation", "disable", "model-value", "onUpdate:modelValue"])
              ]),
              _: 1
            }, 8, ["data-automation"]),
            createVNode(_component_QItemSection, { class: "border-bottom q-py-sm" }, {
              default: withCtx(() => [
                createVNode(_component_QItemLabel, {
                  class: "text-subtitle3",
                  "data-automation": _ctx.buildId("selectAll")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_EllipsisText, {
                      class: normalizeClass({ "text-grey-2": _ctx.selectAllDisabled }),
                      "data-automation": _ctx.buildId("selectAll__label"),
                      text: _ctx.t("rvai-base.general.actions.selectAll")
                    }, null, 8, ["class", "data-automation", "text"])
                  ]),
                  _: 1
                }, 8, ["data-automation"])
              ]),
              _: 1
            }),
            renderSlot(_ctx.$slots, "select-all", {}, void 0, true)
          ]),
          _: 3
        }, 8, ["data-automation"])) : createCommentVNode("", true),
        _ctx.notSelectedOptionLabel ? (openBlock(), createBlock(_component_QItem, {
          key: 1,
          class: "q-pa-none",
          "data-automation": _ctx.buildId("item-not-selected"),
          tag: "label"
        }, {
          default: withCtx(() => [
            createVNode(_component_QItemSection, {
              avatar: "",
              class: "filterable-list__checkbox"
            }, {
              default: withCtx(() => [
                createVNode(_component_Radio, {
                  dense: "",
                  "model-value": _ctx.selected,
                  val: void 0,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.onSelectNone())
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }),
            createVNode(_component_QItemSection, { class: "border-bottom q-py-sm" }, {
              default: withCtx(() => [
                createVNode(_component_QItemLabel, { class: "text-subtitle3" }, {
                  default: withCtx(() => [
                    createVNode(_component_EllipsisText, {
                      "data-automation": _ctx.buildId("item-not-selected__label"),
                      text: _ctx.notSelectedOptionLabel
                    }, null, 8, ["data-automation", "text"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data-automation"])) : createCommentVNode("", true),
        _ctx.$slots["no-data"] && !_ctx.data.length ? renderSlot(_ctx.$slots, "no-data", { key: 2 }, void 0, true) : createCommentVNode("", true),
        createElementVNode("div", {
          id: "infinite-scroll-wrapper",
          class: normalizeClass(_ctx.infiniteScrollWrapperClass)
        }, [
          createVNode(_component_QInfiniteScroll, {
            ref: "infiniteScrollRef",
            class: "full-height",
            "data-automation": _ctx.buildId(`infinite-scroll`),
            offset: 250,
            "scroll-target": "#infinite-scroll-wrapper",
            onLoad: _ctx.onLoad
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "items", {
                isFiltering: !!_ctx.filter,
                items: _ctx.dataToShow
              }, () => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.dataToShow, (item, index2) => {
                  return openBlock(), createBlock(resolveDynamicComponent(_ctx.withIntersection ? "QIntersection" : "div"), {
                    key: item[_ctx.optionValue],
                    style: normalizeStyle([item.height ? `height: ${item.height}px` : ""])
                  }, {
                    default: withCtx(() => {
                      var _a;
                      return [
                        renderSlot(_ctx.$slots, "prepend-item", { item }, void 0, true),
                        createVNode(_component_QItem, {
                          class: "filterable-list__item-filtered q-pa-none",
                          clickable: _ctx.clickable,
                          "data-automation": _ctx.buildId(`item-filtered-${index2}`),
                          tag: _ctx.showSelector && ((_a = item[_ctx.nestedKey]) == null ? void 0 : _a.length) === 1 ? "label" : void 0,
                          onClick: ($event) => _ctx.$emit("on-click-item", item)
                        }, {
                          default: withCtx(() => [
                            _ctx.nestedKey && item[_ctx.nestedKey].length > 1 || _ctx.customItem ? renderSlot(_ctx.$slots, "item", {
                              key: 0,
                              item
                            }, void 0, true) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                              _ctx.showSelector ? (openBlock(), createBlock(_component_QItemSection, {
                                key: 0,
                                avatar: "",
                                class: normalizeClass(["filterable-list__item-checkbox", {
                                  "invisible": item && item[_ctx.immutableField]
                                }])
                              }, {
                                default: withCtx(() => [
                                  _ctx.multiple ? (openBlock(), createBlock(_component_Checkbox, {
                                    key: 0,
                                    "data-automation": _ctx.buildId(`item__${item[_ctx.optionValue]}__checkbox`),
                                    dense: "",
                                    disable: !!(item && item[_ctx.immutableField]),
                                    "model-value": _ctx.selected,
                                    val: item[_ctx.optionValue],
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.onToggle($event))
                                  }, null, 8, ["data-automation", "disable", "model-value", "val"])) : (openBlock(), createBlock(_component_Radio, {
                                    key: 1,
                                    "data-automation": _ctx.buildId(`item__${item[_ctx.optionValue]}__radio`),
                                    dense: "",
                                    disable: !!(item && item[_ctx.immutableField]),
                                    "model-value": _ctx.selected,
                                    val: item[_ctx.optionValue],
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.onToggle($event))
                                  }, null, 8, ["data-automation", "disable", "model-value", "val"]))
                                ]),
                                _: 2
                              }, 1032, ["class"])) : createCommentVNode("", true),
                              createVNode(_component_QItemSection, { class: "border-bottom q-py-sm" }, {
                                default: withCtx(() => [
                                  renderSlot(_ctx.$slots, "label", { item }, () => [
                                    createVNode(_component_QItemLabel, { class: "filterable-list__item-label flex no-wrap justify-between" }, {
                                      default: withCtx(() => [
                                        createVNode(_component_EllipsisText, {
                                          class: "filterable-list__item-text",
                                          "data-automation": _ctx.buildId(`item__${item[_ctx.optionValue]}__label`),
                                          text: item[_ctx.optionLabel]
                                        }, null, 8, ["data-automation", "text"]),
                                        _ctx.deletable ? (openBlock(), createBlock(_component_QIcon, {
                                          key: 0,
                                          class: "filterable-list__icon-delete-item cursor-pointer",
                                          color: "grey-1",
                                          "data-automation": _ctx.buildId("delete"),
                                          name: "delete",
                                          size: "1.5rem",
                                          onClick: ($event) => _ctx.onDeleteItem(item[_ctx.optionValue])
                                        }, null, 8, ["data-automation", "onClick"])) : createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ], true)
                                ]),
                                _: 2
                              }, 1024)
                            ], 64))
                          ]),
                          _: 2
                        }, 1032, ["clickable", "data-automation", "tag", "onClick"]),
                        renderSlot(_ctx.$slots, "append-item", { item }, void 0, true)
                      ];
                    }),
                    _: 2
                  }, 1032, ["style"]);
                }), 128))
              ], true)
            ]),
            _: 3
          }, 8, ["data-automation", "onLoad"])
        ], 2),
        !_ctx.filteredData.length && _ctx.sortedData.length !== 0 ? (openBlock(), createBlock(_component_QItemLabel, {
          key: 3,
          class: "q-py-sm q-mt-lg",
          "data-automation": _ctx.buildId("label-no-data")
        }, {
          default: withCtx(() => [
            createVNode(_component_NoData, {
              "data-automation": _ctx.buildId("noData"),
              "icon-name": "img:/rvai-base/robot-loupe.svg",
              "icon-size": "170px"
            }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_4$j, [
                  createElementVNode("span", _hoisted_5$f, toDisplayString(_ctx.t("rvai-base.general.table.sorry")) + toDisplayString(_ctx.t("rvai-base.general.symbols.comma")), 1),
                  _cache[4] || (_cache[4] = createElementVNode("br", null, null, -1)),
                  createElementVNode("span", null, toDisplayString(_ctx.t("rvai-base.general.table.noSearchResult")), 1)
                ]),
                createVNode(_component_Button, {
                  color: "primary",
                  "data-automation": _ctx.buildId("search"),
                  label: _ctx.t("rvai-base.general.table.searchAgain"),
                  size: "sm",
                  onClick: _ctx.resetSearch
                }, null, 8, ["data-automation", "label", "onClick"])
              ]),
              _: 1
            }, 8, ["data-automation"])
          ]),
          _: 1
        }, 8, ["data-automation"])) : createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["data-automation"])
  ], 8, _hoisted_1$Q);
}
const FilterableList = /* @__PURE__ */ _export_sfc$1(_sfc_main$_, [["render", _sfc_render$R], ["__scopeId", "data-v-c3ddfa9d"]]);
function useNavigation() {
  const route = useRoute();
  function matchesRouteNames(item) {
    var _a, _b;
    const currentRouteName = "name" in route && typeof route.name === "string" ? route.name : "";
    return ((_a = item.routeNames) == null ? void 0 : _a.includes(currentRouteName)) || ((_b = item.to) == null ? void 0 : _b.name) === currentRouteName;
  }
  function matchesRouteQuery(item) {
    var _a;
    const currentQuery = "query" in route ? route.query : void 0;
    if (!currentQuery || !((_a = item.matchQuery) == null ? void 0 : _a.length)) return true;
    return item.matchQuery.every((q3) => {
      var _a2;
      return !!((_a2 = item.to) == null ? void 0 : _a2.query) && item.to.query[q3] === currentQuery[q3];
    });
  }
  function matchesRoute(item) {
    return matchesRouteNames(item) && matchesRouteQuery(item);
  }
  return {
    matchesRoute,
    matchesRouteNames,
    matchesRouteQuery
  };
}
const _sfc_main$Z = {
  name: "HeaderNavigationItem",
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  setup() {
    const route = useRoute();
    const {
      matchesRoute
    } = useNavigation();
    return {
      matchesRoute,
      route
    };
  }
};
const _hoisted_1$P = {
  class: "row items-center no-wrap",
  "data-automation": "header-navigation-item"
};
function _sfc_render$Q(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RouterLink = resolveComponent("RouterLink");
  return openBlock(), createElementBlock("div", _hoisted_1$P, [
    createVNode(_component_RouterLink, {
      "active-class": $props.item.routeNames || $props.item.matchQuery ? "" : "navigation-item--active",
      class: normalizeClass(["navigation-item text-black-1 text-body3", { "navigation-item--active": $setup.matchesRoute($props.item) }]),
      "data-automation": "header-navigation-item__link",
      to: $setup.matchesRoute($props.item) ? $setup.route : $props.item.to
    }, {
      default: withCtx(() => [
        createTextVNode(toDisplayString($props.item.label), 1)
      ]),
      _: 1
    }, 8, ["active-class", "class", "to"]),
    (openBlock(), createBlock(resolveDynamicComponent($props.item.component), {
      class: "q-ml-sm",
      "data-automation": "header-navigation-item__component"
    }))
  ]);
}
const HeaderNavigationItem = /* @__PURE__ */ _export_sfc$1(_sfc_main$Z, [["render", _sfc_render$Q], ["__scopeId", "data-v-c599f3e1"]]);
const _sfc_main$Y = defineComponent({
  name: "HeaderNavigationGroupedItems",
  components: {
    HeaderNavigationItem,
    QIcon: QIcon_default$1,
    QItem: QItem_default$1,
    QItemLabel: QItemLabel_default$1,
    QItemSection: QItemSection_default$1,
    QList: QList_default$1,
    QMenu: QMenu_default$1
  },
  props: {
    navigationItems: {
      type: Array,
      default: () => []
    },
    groupLabel: {
      type: String,
      default: ""
    }
  },
  setup(props4) {
    const {
      matchesRoute
    } = useNavigation();
    const menuOpen = ref$1(false);
    const activeGroupedItem = computed(() => props4.navigationItems.find((item) => matchesRoute(item)));
    const hasSingleItem = computed(() => props4.navigationItems.length && props4.navigationItems.length === 1);
    const hasMultipleItems = computed(() => props4.navigationItems.length && props4.navigationItems.length > 1);
    return {
      activeGroupedItem,
      hasMultipleItems,
      hasSingleItem,
      matchesRoute,
      menuOpen
    };
  }
});
const _hoisted_1$O = {
  class: "navigation-item cursor-pointer row items-center no-wrap text-black-1 text-body3",
  "data-automation": "header-navigation-grouped-items"
};
const _hoisted_2$C = {
  class: "header-navigation-item",
  "data-automation": "header-navigation-grouped-items__label"
};
const _hoisted_3$v = {
  key: 0,
  class: "q-mx-sm",
  "data-automation": "header-navigation-grouped-items__separator"
};
function _sfc_render$P(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_HeaderNavigationItem = resolveComponent("HeaderNavigationItem");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_QItemLabel = resolveComponent("QItemLabel");
  const _component_QItemSection = resolveComponent("QItemSection");
  const _component_QItem = resolveComponent("QItem");
  const _component_RouterLink = resolveComponent("RouterLink");
  const _component_QList = resolveComponent("QList");
  const _component_QMenu = resolveComponent("QMenu");
  return openBlock(), createElementBlock("div", _hoisted_1$O, [
    _ctx.hasMultipleItems ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
      createElementVNode("div", _hoisted_2$C, toDisplayString(_ctx.groupLabel || _ctx.$t("rvai-base.general.text.otherCenters")), 1),
      _ctx.activeGroupedItem ? (openBlock(), createElementBlock("div", _hoisted_3$v, toDisplayString(_ctx.$t("rvai-base.general.symbols.separator")), 1)) : createCommentVNode("", true)
    ], 64)) : createCommentVNode("", true),
    _ctx.hasMultipleItems && _ctx.activeGroupedItem ? (openBlock(), createBlock(_component_HeaderNavigationItem, {
      key: 1,
      "data-automation": "header-navigation-grouped-items__active-item",
      item: _ctx.activeGroupedItem
    }, null, 8, ["item"])) : _ctx.hasSingleItem ? (openBlock(), createBlock(_component_HeaderNavigationItem, {
      key: 2,
      "data-automation": "header-navigation-grouped-items__active-item",
      item: _ctx.navigationItems[0]
    }, null, 8, ["item"])) : createCommentVNode("", true),
    _ctx.hasMultipleItems ? (openBlock(), createElementBlock(Fragment, { key: 3 }, [
      createVNode(_component_QIcon, {
        "data-automation": "header-navigation-grouped-items__icon",
        name: "arrow_drop_down",
        size: "16px"
      }),
      createVNode(_component_QMenu, {
        modelValue: _ctx.menuOpen,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.menuOpen = $event),
        anchor: "bottom right",
        "auto-close": "",
        "content-style": { width: "220px" },
        "data-automation": "header-navigation-grouped-items__menu",
        self: "top right"
      }, {
        default: withCtx(() => [
          createVNode(_component_QList, { separator: "" }, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.navigationItems, (item) => {
                return openBlock(), createBlock(_component_RouterLink, {
                  key: item.label,
                  custom: "",
                  to: item.to
                }, {
                  default: withCtx(({ navigate }) => [
                    createVNode(_component_QItem, {
                      clickable: "",
                      "data-automation": "header-navigation-grouped-items__menu-item",
                      onClick: navigate
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_QItemSection, { class: "row items-center no-wrap justify-between" }, {
                          default: withCtx(() => [
                            createVNode(_component_QItemLabel, { "data-automation": "header-navigation-grouped-items__menu-item-label" }, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString(item.label), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _ctx.matchesRoute(item) ? (openBlock(), createBlock(_component_QIcon, {
                              key: 0,
                              class: "q-ml-sm",
                              color: "grey-1",
                              "data-automation": "header-navigation-grouped-items__menu-selected-icon",
                              name: "mdi-check",
                              size: "16px"
                            })) : createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1032, ["to"]);
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 64)) : createCommentVNode("", true)
  ]);
}
const HeaderNavigationGroupedItems = /* @__PURE__ */ _export_sfc$1(_sfc_main$Y, [["render", _sfc_render$P], ["__scopeId", "data-v-cce312d8"]]);
const _sfc_main$X = defineComponent({
  name: "HeaderNavigationItems",
  components: {
    HeaderNavigationGroupedItems,
    HeaderNavigationItem,
    Separator
  },
  props: {
    navigationItems: {
      type: Array,
      default: () => []
    },
    groupedItems: {
      type: Array,
      default: () => []
    },
    groupedItemsLabel: {
      type: String,
      default: ""
    }
  }
});
const _hoisted_1$N = {
  key: 0,
  class: "header-navigation-items row items-center no-wrap",
  "data-automation": "header-navigation-items"
};
function _sfc_render$O(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_HeaderNavigationItem = resolveComponent("HeaderNavigationItem");
  const _component_Separator = resolveComponent("Separator");
  const _component_HeaderNavigationGroupedItems = resolveComponent("HeaderNavigationGroupedItems");
  return _ctx.navigationItems.length || _ctx.groupedItems.length ? (openBlock(), createElementBlock("div", _hoisted_1$N, [
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.navigationItems, (item, i22) => {
      return openBlock(), createElementBlock(Fragment, {
        key: item.label
      }, [
        createVNode(_component_HeaderNavigationItem, {
          "data-automation": "header-navigation-items__item",
          item
        }, null, 8, ["item"]),
        i22 < _ctx.navigationItems.length - 1 ? (openBlock(), createBlock(_component_Separator, {
          key: 0,
          class: "q-mx-md",
          vertical: ""
        })) : createCommentVNode("", true)
      ], 64);
    }), 128)),
    _ctx.groupedItems.length ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
      _ctx.navigationItems.length ? (openBlock(), createBlock(_component_Separator, {
        key: 0,
        class: "q-mx-md",
        vertical: ""
      })) : createCommentVNode("", true),
      createVNode(_component_HeaderNavigationGroupedItems, {
        "data-automation": "header-navigation-items__grouped-items",
        "group-label": _ctx.groupedItemsLabel,
        "navigation-items": _ctx.groupedItems
      }, null, 8, ["group-label", "navigation-items"])
    ], 64)) : createCommentVNode("", true)
  ])) : createCommentVNode("", true);
}
const HeaderNavigationItems = /* @__PURE__ */ _export_sfc$1(_sfc_main$X, [["render", _sfc_render$O]]);
const _sfc_main$W = defineComponent({
  name: "HealthIcon",
  components: {
    QIcon: QIcon_default$1,
    Tooltip: Tooltip2
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Shows different text for autoscaling deployments
     */
    autoScalingEnabled: {
      type: Boolean,
      default: false
    },
    /**
     * Pipeline health status
     */
    healthStatus: {
      type: String,
      default: void 0
    },
    /**
     * Replica status
     */
    replicaStatus: {
      type: String,
      default: void 0
    },
    /**
     * Apply running styles
     */
    running: {
      type: Boolean,
      default: false
    },
    /**
     * Icon size
     */
    size: {
      type: String,
      default: "1.5em"
    },
    /**
     * Shows tooltip
     */
    showTooltip: {
      type: Boolean,
      default: true
    },
    /**
     * Apply stopped styles
     */
    stopped: {
      type: Boolean,
      default: false
    }
  },
  setup(props4) {
    const { t: t22 } = useI18n();
    const status = computed(() => props4.healthStatus || props4.replicaStatus);
    const color2 = computed(() => {
      switch (status.value) {
        case PipelineHealthStatus.Critical:
        case PipelineHealthStatus.Failing:
        case ReplicaStatus.Error:
          return "negative";
        case PipelineHealthStatus.Healthy:
        case ReplicaStatus.Starting:
        case ReplicaStatus.Running:
          return "positive";
        case PipelineHealthStatus.Overpowered:
        case PipelineHealthStatus.Unbalanced:
        case PipelineHealthStatus.Underpowered:
          return "warning";
        case ReplicaStatus.Queued:
          return "grey-1";
        case PipelineHealthStatus.Unknown:
          return "black-1";
        default:
          return props4.stopped ? "grey-2" : props4.replicaStatus && props4.running ? "positive" : "grey-1";
      }
    });
    const icon = computed(() => {
      switch (status.value) {
        case PipelineHealthStatus.Critical:
          return "rvai-base:storage-unresponsive";
        case PipelineHealthStatus.Failing:
        case ReplicaStatus.Error:
          return "rvai-base:storage-failed";
        case ReplicaStatus.Queued:
          return "rvai-base:storage-queued";
        case PipelineHealthStatus.Healthy:
        case ReplicaStatus.Starting:
        case ReplicaStatus.Running:
          return "rvai-base:storage-healthy";
        case PipelineHealthStatus.Overpowered:
          return "rvai-base:storage-overpowered";
        case PipelineHealthStatus.Unbalanced:
          return "rvai-base:storage-unbalanced";
        case PipelineHealthStatus.Underpowered:
          return "rvai-base:storage-underpowered";
        case PipelineHealthStatus.Unknown:
          return "rvai-base:storage-unknown";
        default:
          return props4.running ? props4.replicaStatus ? "rvai-base:storage-healthy" : "rvai-base:storage-start" : "rvai-base:storage-stopped";
      }
    });
    const tooltip = computed(() => {
      switch (status.value) {
        case PipelineHealthStatus.Critical:
          return props4.autoScalingEnabled ? t22("rvai-base.components.health.autoscalingStatus.critical") : t22("rvai-base.components.health.status.critical");
        case PipelineHealthStatus.Failing:
          return t22("rvai-base.components.health.status.failing");
        case PipelineHealthStatus.Healthy:
          return t22("rvai-base.components.health.status.healthy");
        case PipelineHealthStatus.Overpowered:
          return t22("rvai-base.components.health.status.overpowered");
        case PipelineHealthStatus.Underpowered:
          return t22("rvai-base.components.health.status.underpowered");
        case PipelineHealthStatus.Unknown:
          return t22("rvai-base.components.health.status.unknown");
        case ReplicaStatus.Queued:
          return t22("rvai-base.components.health.replicaStatus.queued");
        case ReplicaStatus.Starting:
          return t22("rvai-base.components.health.replicaStatus.starting");
        case ReplicaStatus.Running:
          return t22("rvai-base.components.health.replicaStatus.running");
        case ReplicaStatus.Error:
          return t22("rvai-base.components.health.replicaStatus.error");
        default:
          return props4.stopped ? t22("rvai-base.components.health.status.stopped") : props4.replicaStatus || t22("rvai-base.components.health.status.unknown");
      }
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      color: color2,
      icon,
      tooltip
    };
  }
});
const _hoisted_1$M = ["data-automation"];
function _sfc_render$N(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QIcon = resolveComponent("QIcon");
  const _component_Tooltip = resolveComponent("Tooltip");
  return openBlock(), createElementBlock("div", {
    class: "health-icon",
    "data-automation": _ctx.buildId()
  }, [
    createVNode(_component_QIcon, {
      color: _ctx.color,
      name: _ctx.icon,
      size: _ctx.size
    }, null, 8, ["color", "name", "size"]),
    _ctx.showTooltip ? (openBlock(), createBlock(_component_Tooltip, {
      key: 0,
      offset: [0, 2]
    }, {
      default: withCtx(() => [
        createTextVNode(toDisplayString(_ctx.tooltip), 1)
      ]),
      _: 1
    })) : createCommentVNode("", true)
  ], 8, _hoisted_1$M);
}
const HealthIcon = /* @__PURE__ */ _export_sfc$1(_sfc_main$W, [["render", _sfc_render$N], ["__scopeId", "data-v-c2f71db7"]]);
const UNKNOWN_CLASS = "unknown";
const _sfc_main$V = defineComponent({
  name: "Histogram",
  components: {
    Avatar,
    BarChart,
    EllipsisText
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Displays all info in a row (classNames, percentages, etc)
     */
    detailed: {
      type: Boolean,
      default: false
    },
    /**
     * Bar height
     */
    barHeight: {
      type: Number,
      default: void 0
    },
    /**
     * Classes applied to the Histogram
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Class distribution data
     */
    classDistribution: {
      type: Object,
      required: true
    },
    /**
     * List of classes
     */
    classes: {
      type: Array,
      required: true
    },
    /**
     * Displays class names and percentages
     */
    full: {
      type: Boolean,
      default: false
    },
    /**
     * Displays spinner
     */
    loading: {
      type: Boolean,
      default: false
    },
    /**
     * Component max height
     */
    maxHeight: {
      type: Number,
      default: void 0
    },
    /**
     * Overrides colors for current user avatar
     */
    overrideCurrentUserAvatar: {
      type: Boolean,
      default: false
    },
    /**
     * Emits 'update:selected' with row.id, when true
     */
    selectable: {
      type: Boolean,
      default: false
    },
    /**
     * v-model:selected; allows handling selected class
     */
    selected: {
      type: String,
      default: void 0
    },
    /**
     * Shows class name or class id
     */
    showClassName: {
      type: Boolean,
      default: false
    },
    /**
     * Histogram size ('sm' | 'md')
     */
    size: {
      type: String,
      default: "sm"
    },
    /**
     * Sort data inside Histogram
     */
    sort: {
      type: String,
      default: void 0
    },
    /**
     * Sorting order
     */
    sortAsc: {
      type: Boolean,
      default: true
    },
    /**
     * Shows tooltip with additional information on bar hover
     */
    source: {
      type: Object,
      default: void 0
    }
  },
  emits: [
    /**
     * Emitted when 'selectable' property is true and bar is clicked
     */
    "update:selected"
  ],
  setup(props4) {
    const { t: t22 } = useI18n();
    const histogramRef = ref$1(null);
    const entries2 = computed(() => {
      const entries22 = [...props4.classDistribution.entries ?? []].filter((e22) => e22.count !== 0 || !(isNull(e22.id) || e22.id === ""));
      if (!entries22.length) {
        entries22.push({
          count: 0,
          id: null
        });
      }
      return entries22.map(({
        count,
        id: id3
      }) => {
        const clazz = id3 ? props4.classes.find((def) => def.id === id3) : void 0;
        const classColor = id3 ? (clazz == null ? void 0 : clazz.defaultColor) ?? "var(--q-primary)" : "#000";
        const className = isNull(id3) ? t22("rvai-base.components.histogram.notAnnotated") : id3 === "" ? t22("rvai-base.components.histogram.emptyAnnotation") : (clazz == null ? void 0 : clazz.name) ?? t22("rvai-base.components.histogram.unknownClass");
        const pct = totalSamples.value ? Math.min(100 * (count / totalSamples.value), 100) : 0;
        return {
          color: classColor,
          count,
          id: id3,
          name: className,
          pct: `${pct.toLocaleString(void 0, { maximumFractionDigits: 2 })}%`
        };
      });
    });
    const entriesSorted = computed(() => {
      return [...entries2.value].sort((a32, b22) => {
        const x22 = props4.sortAsc ? a32 : b22;
        const y32 = props4.sortAsc ? b22 : a32;
        switch (props4.sort) {
          case "count":
            return x22.count - y32.count;
          default:
            if (isNull(x22.id) && !isNull(y32.id)) return -1;
            if (isNull(y32.id) && !isNull(x22.id)) return 1;
            if (x22.id === "" && y32.id !== "") return -1;
            if (y32.id === "" && x22.id !== "") return 1;
            if (x22.id === UNKNOWN_CLASS && y32.id !== UNKNOWN_CLASS) return -1;
            if (y32.id === UNKNOWN_CLASS && x22.id !== UNKNOWN_CLASS) return 1;
            return naturalSort(x22.name, y32.name);
        }
      });
    });
    const totalSamples = computed(() => {
      return props4.classDistribution.total ?? 0;
    });
    function generateCSV(countAnnotations = false) {
      const headerRow = [
        t22("rvai-base.components.histogram.classId"),
        t22("rvai-base.components.histogram.className"),
        countAnnotations ? t22("rvai-base.components.histogram.annotations") : t22("rvai-base.components.histogram.samples"),
        t22("rvai-base.components.histogram.percentage")
      ].map((value2) => value2.replace(/,/g, ".")).join(",");
      const contentRows = entriesSorted.value.map((entry) => {
        const row = [
          entry.id ?? "",
          entry.name ?? "",
          entry.count ?? "",
          entry.pct ?? ""
        ].map((value2) => value2.toString().replace(/,/g, ".")).join(",");
        return row;
      }).join("\n");
      return `${headerRow}
${contentRows}`;
    }
    function isNull(id3) {
      return id3 == null || id3 === "null";
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      entriesSorted,
      generateCSV,
      histogramRef,
      t: t22
    };
  }
});
const _hoisted_1$L = { class: "column no-wrap q-mt-sm" };
const _hoisted_2$B = {
  key: 0,
  class: "row items-center q-mb-sm"
};
const _hoisted_3$u = { class: "row no-wrap" };
function _sfc_render$M(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Avatar = resolveComponent("Avatar");
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_rv_bullet = resolveComponent("rv-bullet");
  const _component_rv_ellipsis_text = resolveComponent("rv-ellipsis-text");
  const _component_BarChart = resolveComponent("BarChart");
  return openBlock(), createBlock(_component_BarChart, {
    ref: "histogramRef",
    "bar-height": _ctx.barHeight,
    class: normalizeClass(_ctx.$props.class),
    "data-automation": _ctx.buildId(),
    detailed: _ctx.detailed,
    entries: _ctx.entriesSorted,
    full: _ctx.full,
    loading: _ctx.loading,
    "max-height": _ctx.maxHeight,
    selectable: _ctx.selectable,
    selected: _ctx.selected,
    "show-name": _ctx.showClassName,
    size: _ctx.size,
    "sort-asc": _ctx.sortAsc,
    "onUpdate:selected": _cache[0] || (_cache[0] = ($event) => _ctx.$emit("update:selected", $event))
  }, createSlots({ _: 2 }, [
    !_ctx.detailed ? {
      name: "tooltip",
      fn: withCtx(({ entry }) => [
        createElementVNode("div", null, [
          createElementVNode("strong", null, toDisplayString(entry.count), 1),
          createTextVNode(" " + toDisplayString(_ctx.t("rvai-base.general.common.wordInBrackets", [entry.pct])), 1)
        ]),
        createElementVNode("div", _hoisted_1$L, [
          _ctx.source ? (openBlock(), createElementBlock("div", _hoisted_2$B, [
            createVNode(_component_Avatar, {
              "background-color": _ctx.overrideCurrentUserAvatar && _ctx.source.isCurrent ? "white" : _ctx.source.color,
              "border-color": _ctx.overrideCurrentUserAvatar && _ctx.source.isCurrent ? "grey-1" : "white",
              "data-automation": _ctx.buildId("avatar"),
              initials: _ctx.source.initials,
              label: _ctx.source.name,
              "show-logo": !_ctx.source.initials && !_ctx.source.isUser,
              "text-color": _ctx.overrideCurrentUserAvatar && _ctx.source.isCurrent ? "grey-1" : "",
              uuid: _ctx.source.id
            }, null, 8, ["background-color", "border-color", "data-automation", "initials", "label", "show-logo", "text-color", "uuid"]),
            createVNode(_component_EllipsisText, {
              class: "q-ml-sm black-1",
              "data-automation": _ctx.buildId("source"),
              text: _ctx.source.name
            }, null, 8, ["data-automation", "text"])
          ])) : createCommentVNode("", true),
          createElementVNode("div", _hoisted_3$u, [
            createVNode(_component_rv_bullet, {
              color: entry.color,
              "data-automation": _ctx.buildId("classColor")
            }, null, 8, ["color", "data-automation"]),
            createVNode(_component_rv_ellipsis_text, {
              class: "q-ml-xs",
              "data-automation": _ctx.buildId("className"),
              text: entry.name
            }, null, 8, ["data-automation", "text"])
          ])
        ])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["bar-height", "class", "data-automation", "detailed", "entries", "full", "loading", "max-height", "selectable", "selected", "show-name", "size", "sort-asc"]);
}
const Histogram = /* @__PURE__ */ _export_sfc$1(_sfc_main$V, [["render", _sfc_render$M]]);
const _sfc_main$U = defineComponent({
  name: "HistogramWrapper",
  components: {
    Avatar,
    Button,
    Histogram,
    QCard: QCard_default$1,
    QCardSection: QCardSection_default$1,
    QDialog: QDialog_default$1,
    QSpace: QSpace_default,
    Select
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Bar height; Not applied to maximized Histogram
     */
    barHeight: {
      type: Number,
      default: void 0
    },
    /**
     * Classes applied to the component; Not applied to maximized Histogram
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * List of classes
     */
    classes: {
      type: Array,
      required: true
    },
    /**
     * Annotations and samples data passed to the component
     */
    dataStats: {
      type: Object,
      required: true
    },
    /**
     * Default displaying mode
     */
    defaultMode: {
      type: String,
      default: "samples"
    },
    /**
     * Default displaying split
     */
    defaultSplit: {
      type: String,
      default: "all"
    },
    /**
     * Hides component title
     */
    hideTitle: {
      type: Boolean,
      default: false
    },
    /**
     * Overrides colors for current user avatar
     */
    overrideCurrentUserAvatar: {
      type: Boolean,
      default: false
    },
    /**
     * Histogram size ('sm' | 'md')
     */
    size: {
      type: String,
      default: "sm"
    },
    /**
     * Shows tooltip with additional information on bar hover
     */
    source: {
      type: Object,
      default: void 0
    },
    /**
     * Shows class name or class id
     */
    showClassName: {
      type: Boolean,
      default: false
    },
    /**
     * Shows component footer
     */
    showFooter: {
      type: Boolean,
      default: false
    },
    /**
     * Adds the ability to switch between annotations and samples
     */
    showMode: {
      type: Boolean,
      default: false
    },
    /**
     * Apply custom class(es) to the wrapper
     * @type {[Array, Object, String]}
     */
    wrapperClass: {
      type: [Array, Object, String],
      default: void 0
    }
  },
  setup(props4) {
    const { t: t22 } = useI18n();
    const mode = ref$1(props4.defaultMode);
    const open2 = ref$1(false);
    const sort = ref$1("name");
    const sortAsc = ref$1(true);
    const split = ref$1(props4.defaultSplit);
    const classDistribution = computed(() => {
      var _a, _b;
      return (_b = (_a = props4.dataStats) == null ? void 0 : _a[mode.value]) == null ? void 0 : _b[split.value];
    });
    const modeOptions = computed(() => {
      return [
        {
          label: t22("rvai-base.components.histogram.modes.annotations"),
          value: "annotations"
        },
        {
          label: t22("rvai-base.components.histogram.modes.samples"),
          value: "samples"
        }
      ];
    });
    const modeLabel = computed(() => {
      var _a;
      return ((_a = modeOptions.value.find((x22) => x22.value === mode.value)) == null ? void 0 : _a.label) ?? "";
    });
    const sortOptions = computed(() => {
      return [
        {
          label: t22("rvai-base.components.histogram.count"),
          value: "count"
        },
        {
          label: t22("rvai-base.components.histogram.name"),
          value: "name"
        }
      ];
    });
    const splitOptions = computed(() => {
      return [
        {
          label: t22("rvai-base.components.histogram.trainingSetup.all"),
          value: "all"
        },
        {
          label: t22("rvai-base.components.histogram.trainingSetup.test"),
          value: "test"
        },
        {
          label: t22("rvai-base.components.histogram.trainingSetup.validate"),
          value: "validation"
        },
        {
          label: t22("rvai-base.components.histogram.trainingSetup.train"),
          value: "train"
        }
      ];
    });
    const splitLabel = computed(() => {
      var _a;
      return ((_a = splitOptions.value.find((x22) => x22.value === split.value)) == null ? void 0 : _a.label) ?? "";
    });
    function resetSortAsc() {
      sortAsc.value = true;
    }
    function toggleOpen() {
      open2.value = !open2.value;
    }
    function toggleSortAsc() {
      sortAsc.value = !sortAsc.value;
    }
    function maximize() {
      open2.value = true;
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      classDistribution,
      maximize,
      mode,
      modeLabel,
      modeOptions,
      open: open2,
      resetSortAsc,
      sort,
      sortAsc,
      sortOptions,
      split,
      splitLabel,
      splitOptions,
      t: t22,
      toggleOpen,
      toggleSortAsc
    };
  }
});
const _hoisted_1$K = ["data-automation"];
const _hoisted_2$A = ["data-automation"];
const _hoisted_3$t = { class: "text-body3" };
const _hoisted_4$i = ["data-automation"];
const _hoisted_5$e = { key: 0 };
const _hoisted_6$a = { class: "text-body3" };
const _hoisted_7$8 = { class: "row no-wrap justify-end full-width q-mb-lg" };
const _hoisted_8$5 = {
  key: 0,
  class: "row q-mr-lg"
};
const _hoisted_9$4 = { class: "text-subtitle3 flex flex-center q-mr-sm" };
const _hoisted_10$2 = { class: "row q-mr-lg" };
const _hoisted_11$2 = { class: "text-subtitle3 flex flex-center q-mr-sm" };
const _hoisted_12$1 = { class: "row" };
const _hoisted_13$1 = { class: "text-subtitle3 flex flex-center q-mr-sm" };
const _hoisted_14$1 = { class: "border-card rounded-borders full-width q-px-lg q-py-md" };
const _hoisted_15$1 = {
  key: 0,
  class: "row no-wrap justify-center items-center q-mb-sm"
};
function _sfc_render$L(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QSpace = resolveComponent("QSpace");
  const _component_Button = resolveComponent("Button");
  const _component_Histogram = resolveComponent("Histogram");
  const _component_QCardSection = resolveComponent("QCardSection");
  const _component_Select = resolveComponent("Select");
  const _component_Avatar = resolveComponent("Avatar");
  const _component_QCard = resolveComponent("QCard");
  const _component_QDialog = resolveComponent("QDialog");
  return openBlock(), createElementBlock(Fragment, null, [
    createElementVNode("div", mergeProps(_ctx.dataAttrs, {
      class: ["histogram-wrapper", _ctx.wrapperClass],
      "data-automation": _ctx.buildId()
    }), [
      !_ctx.hideTitle ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: "row no-wrap q-mb-sm",
        "data-automation": _ctx.buildId("title")
      }, [
        createElementVNode("div", _hoisted_3$t, [
          renderSlot(_ctx.$slots, "title", {}, () => [
            createElementVNode("strong", null, toDisplayString(_ctx.t("rvai-base.components.histogram.chartTitle")), 1),
            createTextVNode(" " + toDisplayString(_ctx.t("rvai-base.components.histogram.classDistribution")), 1)
          ], true)
        ]),
        createVNode(_component_QSpace),
        createVNode(_component_Button, {
          class: "no-padding",
          color: "black-1",
          "data-automation": _ctx.buildId("full"),
          icon: "mdi-fullscreen",
          tertiary: "",
          onClick: _ctx.toggleOpen
        }, null, 8, ["data-automation", "onClick"])
      ], 8, _hoisted_2$A)) : createCommentVNode("", true),
      createVNode(_component_Histogram, {
        "bar-height": _ctx.barHeight,
        class: normalizeClass(_ctx.$props.class),
        "class-distribution": _ctx.classDistribution,
        classes: _ctx.classes,
        "data-automation": _ctx.buildId("1"),
        "show-class-name": _ctx.showClassName,
        size: _ctx.size,
        sort: _ctx.sort,
        "sort-asc": _ctx.sortAsc,
        source: _ctx.source
      }, null, 8, ["bar-height", "class", "class-distribution", "classes", "data-automation", "show-class-name", "size", "sort", "sort-asc", "source"]),
      _ctx.showFooter ? (openBlock(), createElementBlock("div", {
        key: 1,
        class: "text-body3 text-grey-1--light text-grey-2--dark q-mt-sm",
        "data-automation": _ctx.buildId("footer")
      }, [
        _ctx.showMode ? (openBlock(), createElementBlock("div", _hoisted_5$e, toDisplayString(_ctx.t("rvai-base.components.histogram.mode")) + " " + toDisplayString(_ctx.modeLabel), 1)) : createCommentVNode("", true),
        createElementVNode("div", null, toDisplayString(_ctx.t("rvai-base.components.histogram.split")) + " " + toDisplayString(_ctx.splitLabel), 1)
      ], 8, _hoisted_4$i)) : createCommentVNode("", true)
    ], 16, _hoisted_1$K),
    createVNode(_component_QDialog, {
      modelValue: _ctx.open,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.open = $event),
      "data-automation": _ctx.buildId("dialog"),
      "full-height": "",
      "full-width": ""
    }, {
      default: withCtx(() => [
        createVNode(_component_QCard, { class: "column no-wrap" }, {
          default: withCtx(() => [
            createVNode(_component_QCardSection, { class: "histogram-wrapper__title q-pb-none row items-center bg-white" }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_6$a, [
                  renderSlot(_ctx.$slots, "title", {}, () => [
                    createElementVNode("strong", null, toDisplayString(_ctx.t("rvai-base.components.histogram.chartTitle")), 1),
                    createTextVNode(" " + toDisplayString(_ctx.t("rvai-base.components.histogram.classDistribution")), 1)
                  ], true)
                ]),
                createVNode(_component_QSpace),
                createVNode(_component_Button, {
                  class: "no-padding",
                  "data-automation": _ctx.buildId("full-exit"),
                  icon: "mdi-fullscreen-exit",
                  tertiary: "",
                  onClick: _ctx.toggleOpen
                }, null, 8, ["data-automation", "onClick"])
              ]),
              _: 3
            }),
            createVNode(_component_QCardSection, { class: "q-pt-md row" }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_7$8, [
                  _ctx.showMode ? (openBlock(), createElementBlock("div", _hoisted_8$5, [
                    createElementVNode("div", _hoisted_9$4, toDisplayString(_ctx.t("rvai-base.components.histogram.mode")), 1),
                    createVNode(_component_Select, {
                      modelValue: _ctx.mode,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.mode = $event),
                      "data-automation": _ctx.buildId("mode"),
                      dense: "",
                      "emit-value": "",
                      "map-options": "",
                      options: _ctx.modeOptions,
                      "show-checkmark": ""
                    }, null, 8, ["modelValue", "data-automation", "options"])
                  ])) : createCommentVNode("", true),
                  createElementVNode("div", _hoisted_10$2, [
                    createElementVNode("div", _hoisted_11$2, toDisplayString(_ctx.t("rvai-base.components.histogram.split")), 1),
                    createVNode(_component_Select, {
                      modelValue: _ctx.split,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.split = $event),
                      "data-automation": _ctx.buildId("split"),
                      dense: "",
                      "emit-value": "",
                      "map-options": "",
                      options: _ctx.splitOptions,
                      "show-checkmark": ""
                    }, null, 8, ["modelValue", "data-automation", "options"])
                  ]),
                  createElementVNode("div", _hoisted_12$1, [
                    createElementVNode("div", _hoisted_13$1, toDisplayString(_ctx.t("rvai-base.general.table.sortBy")), 1),
                    createVNode(_component_Select, {
                      modelValue: _ctx.sort,
                      "onUpdate:modelValue": [
                        _cache[2] || (_cache[2] = ($event) => _ctx.sort = $event),
                        _ctx.resetSortAsc
                      ],
                      "data-automation": _ctx.buildId("sort"),
                      dense: "",
                      "emit-value": "",
                      "map-options": "",
                      options: _ctx.sortOptions,
                      "show-checkmark": ""
                    }, {
                      prepend: withCtx(() => [
                        createVNode(_component_Button, {
                          color: "grey-1",
                          "data-automation": _ctx.buildId("sort"),
                          icon: _ctx.sortAsc ? "rvai-base:sort-asc" : "rvai-base:sort-desc",
                          size: "md",
                          tertiary: "",
                          onClick: withModifiers(_ctx.toggleSortAsc, ["stop"])
                        }, null, 8, ["data-automation", "icon", "onClick"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "data-automation", "options", "onUpdate:modelValue"])
                  ])
                ]),
                createElementVNode("div", _hoisted_14$1, [
                  _ctx.source ? (openBlock(), createElementBlock("div", _hoisted_15$1, [
                    createVNode(_component_Avatar, {
                      "background-color": _ctx.overrideCurrentUserAvatar && _ctx.source.isCurrent ? "white" : _ctx.source.color,
                      "border-color": _ctx.overrideCurrentUserAvatar && _ctx.source.isCurrent ? "grey-1" : "white",
                      label: _ctx.source.name,
                      "text-color": _ctx.overrideCurrentUserAvatar && _ctx.source.isCurrent ? "grey-1" : "",
                      uuid: _ctx.source.id
                    }, null, 8, ["background-color", "border-color", "label", "text-color", "uuid"]),
                    createElementVNode("div", {
                      class: normalizeClass(["q-ml-sm text-subtitle3", _ctx.source.color ? `text-${_ctx.source.color}` : ""])
                    }, toDisplayString(_ctx.source.name), 3)
                  ])) : createCommentVNode("", true),
                  createVNode(_component_Histogram, {
                    class: "full-width",
                    "class-distribution": _ctx.classDistribution,
                    classes: _ctx.classes,
                    "data-automation": _ctx.buildId("2"),
                    full: "",
                    "show-class-name": _ctx.showClassName,
                    sort: _ctx.sort,
                    "sort-asc": _ctx.sortAsc,
                    source: _ctx.source
                  }, null, 8, ["class-distribution", "classes", "data-automation", "show-class-name", "sort", "sort-asc", "source"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["modelValue", "data-automation"])
  ], 64);
}
const HistogramWrapper = /* @__PURE__ */ _export_sfc$1(_sfc_main$U, [["render", _sfc_render$L], ["__scopeId", "data-v-158bcb51"]]);
const _hoisted_1$J = { key: 0 };
const _hoisted_2$z = ["data-automation"];
const _hoisted_3$s = ["data-automation"];
const _hoisted_4$h = ["data-automation"];
const _sfc_main$T = /* @__PURE__ */ defineComponent({
  __name: "InfoPanel",
  props: {
    class: { default: void 0 },
    color: { default: "blue" },
    compact: { type: Boolean },
    dataAutomation: { default: "info-panel" },
    icon: { default: "rvai-base:info" },
    iconSize: { default: "20px" },
    label: { default: void 0 },
    localStorageKey: { default: void 0 },
    showCloseButton: { type: Boolean, default: false }
  },
  emits: ["close"],
  setup(__props, { emit: __emit }) {
    const props4 = __props;
    const emit = __emit;
    const isClosed = ref$1(LocalStorage_default.getItem(getLocalStorageKey()) ?? false);
    const { buildId } = useAutomation(computed(() => props4.dataAutomation));
    function getLocalStorageKey() {
      if (!props4.localStorageKey) return void 0;
      return `infoPanelClosed.${props4.localStorageKey}`;
    }
    function onClose() {
      isClosed.value = true;
      if (props4.localStorageKey) {
        LocalStorage_default.set(getLocalStorageKey(), true);
      }
      emit("close");
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(QSlideTransition_default$1), null, {
        default: withCtx(() => [
          !isClosed.value ? (openBlock(), createElementBlock("div", _hoisted_1$J, [
            createElementVNode("div", {
              class: normalizeClass(["rv-info-panel text-small rounded-borders flex no-wrap", [
                _ctx.$props.class,
                `border-${_ctx.color} text-${_ctx.color}`,
                {
                  "q-px-md q-py-sm items-center": !_ctx.compact,
                  "q-pa-sm": _ctx.compact
                }
              ]]),
              "data-automation": unref(buildId)()
            }, [
              createVNode(unref(QIcon_default$1), {
                class: "q-mr-sm",
                color: _ctx.color,
                "data-automation": unref(buildId)("icon"),
                name: _ctx.icon,
                size: _ctx.iconSize
              }, null, 8, ["color", "data-automation", "name", "size"]),
              createElementVNode("div", {
                class: "info-panel__label",
                "data-automation": unref(buildId)("label")
              }, [
                renderSlot(_ctx.$slots, "label", {}, () => [
                  createTextVNode(toDisplayString(_ctx.label), 1)
                ], true)
              ], 8, _hoisted_3$s),
              _ctx.showCloseButton ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: normalizeClass(["info-panel__close", {
                  "q-pl-md": !_ctx.compact,
                  "q-pl-sm": _ctx.compact
                }]),
                "data-automation": unref(buildId)("close")
              }, [
                createVNode(Button, {
                  "aria-label": "Close",
                  class: "no-padding",
                  color: _ctx.color,
                  icon: "mdi-close",
                  tertiary: "",
                  onClick: onClose
                }, null, 8, ["color"])
              ], 10, _hoisted_4$h)) : createCommentVNode("", true)
            ], 10, _hoisted_2$z)
          ])) : createCommentVNode("", true)
        ]),
        _: 3
      });
    };
  }
});
const InfoPanel = /* @__PURE__ */ _export_sfc$1(_sfc_main$T, [["__scopeId", "data-v-2a532737"]]);
const _sfc_main$S = defineComponent({
  name: "LabelerSlider",
  components: {
    QSlider: QSlider_default$1
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Flag to hide label
     */
    label: {
      type: Boolean,
      default: true
    },
    /**
     * Maximum value of the model; Set track's maximum value
     */
    max: {
      type: Number,
      default: 100
    },
    /**
     * Minimum value of the model; Set track's minimum value
     */
    min: {
      type: Number,
      default: 0
    },
    /**
     * Model of the component (must be between min/max); Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
     */
    modelValue: {
      type: Number,
      required: true
    },
    /**
     * Work in reverse (changes direction)
     */
    reverse: {
      type: Boolean,
      default: false
    },
    /**
     * Snap on valid values, rather than sliding freely; Suggestion: use with 'step' prop
     */
    snap: {
      type: Boolean,
      default: false
    },
    /**
     * Specify step amount between valid values (> 0.0); When step equals to 0 it defines infinite granularity
     */
    step: {
      type: Number,
      default: 1
    },
    /**
     * Change the arrow direction
     */
    thumbDown: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    "update:modelValue"
  ],
  setup(props4) {
    return {
      ...useAutomation(computed(() => props4.dataAutomation))
    };
  }
});
function _sfc_render$K(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QSlider = resolveComponent("QSlider");
  return openBlock(), createBlock(_component_QSlider, mergeProps(_ctx.dataAttrs, {
    class: ["rv-labeler-slider", [{ "rv-labeler-slider--down": _ctx.thumbDown }, _ctx.$props.class]],
    "data-automation": _ctx.buildId(),
    label: _ctx.label,
    max: _ctx.max,
    min: _ctx.min,
    "model-value": _ctx.modelValue,
    reverse: _ctx.reverse,
    snap: _ctx.snap,
    step: _ctx.step,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.$emit("update:modelValue", $event))
  }), null, 16, ["class", "data-automation", "label", "max", "min", "model-value", "reverse", "snap", "step"]);
}
const LabelerSlider = /* @__PURE__ */ _export_sfc$1(_sfc_main$S, [["render", _sfc_render$K], ["__scopeId", "data-v-c8027423"]]);
const LAYOUT_LOGO = {
  [Layout.Default]: "rvai-base:layout-default",
  [Layout.RightOnly]: "rvai-base:layout-right",
  [Layout.LeftOnly]: "rvai-base:layout-left",
  [Layout.Full]: "rvai-base:layout-full",
  [Layout.Split]: "rvai-base:layout-split"
};
const _sfc_main$R = defineComponent({
  name: "LayoutButton",
  components: {
    Button,
    QIcon: QIcon_default$1,
    QItem: QItem_default$1,
    QItemLabel: QItemLabel_default$1,
    QItemSection: QItemSection_default$1,
    QList: QList_default$1,
    QMenu: QMenu_default$1
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    }
  },
  setup(props4) {
    const { t: t22 } = useI18n();
    const {
      availableLayouts,
      hasRightContent,
      layout,
      setLayout
    } = useLayout();
    const logo = computed(() => {
      return LAYOUT_LOGO[layout.value];
    });
    const options = computed(() => {
      return availableLayouts.value.map((l) => ({
        icon: LAYOUT_LOGO[l],
        label: t22(`rvai-base.general.layout.${String(l)}`),
        layout: l
      }));
    });
    const showMenu = computed(() => {
      return availableLayouts.value.length > 2;
    });
    const canChangeLayout = computed(() => {
      return availableLayouts.value.length > 1 && !!hasRightContent.value;
    });
    function onChangeLayout() {
      if (showMenu.value) return;
      const value2 = availableLayouts.value.find((l) => l !== layout.value) ?? availableLayouts.value[0];
      setLayout(value2);
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      canChangeLayout,
      layout,
      logo,
      onChangeLayout,
      options,
      setLayout,
      showMenu
    };
  }
});
function _sfc_render$J(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QIcon = resolveComponent("QIcon");
  const _component_QItemLabel = resolveComponent("QItemLabel");
  const _component_QItemSection = resolveComponent("QItemSection");
  const _component_QItem = resolveComponent("QItem");
  const _component_QList = resolveComponent("QList");
  const _component_QMenu = resolveComponent("QMenu");
  const _component_Button = resolveComponent("Button");
  return openBlock(), createBlock(_component_Button, {
    class: "bg-white",
    color: "black-1",
    "data-automation": _ctx.buildId(),
    disable: !_ctx.canChangeLayout,
    icon: _ctx.logo,
    tertiary: "",
    onClick: _ctx.onChangeLayout
  }, {
    default: withCtx(() => [
      _ctx.showMenu ? (openBlock(), createBlock(_component_QMenu, {
        key: 0,
        anchor: "bottom right",
        "auto-close": "",
        self: "top right"
      }, {
        default: withCtx(() => [
          createVNode(_component_QList, { separator: "" }, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, (item) => {
                return openBlock(), createBlock(_component_QItem, {
                  key: item.layout,
                  class: normalizeClass({ "bg-grey-6": item.layout === _ctx.layout }),
                  clickable: "",
                  "data-automation": _ctx.buildId(`option-${item.layout}`),
                  onClick: ($event) => _ctx.setLayout(item.layout)
                }, {
                  default: withCtx(() => [
                    createVNode(_component_QItemSection, null, {
                      default: withCtx(() => [
                        createVNode(_component_QItemLabel, { class: "text-body-3" }, {
                          default: withCtx(() => [
                            createVNode(_component_QIcon, {
                              class: "q-mr-sm",
                              name: item.icon,
                              size: "24px"
                            }, null, 8, ["name"]),
                            createTextVNode(" " + toDisplayString(item.label), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["class", "data-automation", "onClick"]);
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })) : createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["data-automation", "disable", "icon", "onClick"]);
}
const LayoutButton = /* @__PURE__ */ _export_sfc$1(_sfc_main$R, [["render", _sfc_render$J]]);
const __default__$1 = defineComponent({
  name: "LinearProgress",
  components: {
    QLinearProgress: QLinearProgress_default$1
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Color name for component from the Quasar Color Palette
     */
    color: {
      type: String,
      default: "primary"
    },
    /**
     * Put component into indeterminate mode
     */
    indeterminate: {
      type: Boolean,
      default: false
    },
    /**
     * Applies a small standard border-radius for a squared shape of the component
     */
    rounded: {
      type: Boolean,
      default: true
    },
    /**
     * Size in CSS units, including unit name or standard size name (xs|sm|md|lg|xl)
     */
    size: {
      type: String,
      default: "8px"
    },
    /**
     * Makes a skew line
     */
    skew: {
      type: Boolean,
      default: false
    },
    /**
     * Color name for component's track from the Quasar Color Palette
     */
    trackColor: {
      type: String,
      default: "primary-lighter"
    },
    /**
     * Progress value (0.0 < x < 1.0)
     */
    value: {
      type: Number,
      default: void 0
    },
    /**
     * Render background track
     */
    withTrack: {
      type: Boolean,
      default: true
    }
  },
  setup(props4) {
    return {
      ...useAutomation(computed(() => props4.dataAutomation))
    };
  }
});
const __injectCSSVars__$1 = () => {
  useCssVars((_ctx) => ({
    "6479ffb4": _ctx.$props.size
  }));
};
const __setup__$1 = __default__$1.setup;
__default__$1.setup = __setup__$1 ? (props4, ctx) => {
  __injectCSSVars__$1();
  return __setup__$1(props4, ctx);
} : __injectCSSVars__$1;
function _sfc_render$I(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QLinearProgress = resolveComponent("QLinearProgress");
  return openBlock(), createBlock(_component_QLinearProgress, {
    class: normalizeClass(["rv-linear-progress", {
      "rv-linear-progress--indeterminate": _ctx.indeterminate,
      "rv-linear-progress--no-track": !_ctx.withTrack,
      "rv-linear-progress--skew": _ctx.skew
    }]),
    color: _ctx.color,
    "data-automation": _ctx.buildId(),
    indeterminate: _ctx.indeterminate,
    rounded: _ctx.rounded,
    size: _ctx.size,
    style: normalizeStyle({
      "--value": `${_ctx.value * 100}%`
    }),
    "track-color": _ctx.trackColor
  }, null, 8, ["class", "color", "data-automation", "indeterminate", "rounded", "size", "style", "track-color"]);
}
const LinearProgress = /* @__PURE__ */ _export_sfc$1(__default__$1, [["render", _sfc_render$I], ["__scopeId", "data-v-3225131f"]]);
const _sfc_main$Q = /* @__PURE__ */ defineComponent({
  __name: "LocalUrl",
  props: {
    data: {
      default: void 0,
      type: Object
    },
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      default: void 0,
      type: String
    }
  },
  setup(__props) {
    const props4 = __props;
    const { buildId } = useAutomation(computed(() => props4.dataAutomation));
    const url = ref$1(null);
    onUnmounted(() => {
      url.value && URL.revokeObjectURL(url.value);
    });
    watch(
      () => props4.data,
      async (data, prevData) => {
        const blob = data && await Promise.resolve(data);
        const prevBlob = prevData && await Promise.resolve(prevData);
        if (blob === prevBlob) return;
        url.value && URL.revokeObjectURL(url.value);
        url.value = blob ? URL.createObjectURL(blob) : null;
      },
      { immediate: true }
    );
    return (_ctx, _cache) => {
      return url.value ? renderSlot(_ctx.$slots, "default", {
        key: 0,
        dataAutomation: unref(buildId)(),
        url: url.value
      }) : renderSlot(_ctx.$slots, "empty", {
        key: 1,
        dataAutomation: unref(buildId)("empty")
      });
    };
  }
});
const _hoisted_1$I = ["data-automation", "view-box"];
const _hoisted_2$y = ["xlink:href"];
const DEFAULT_REGULAR_HEIGHT = "40";
const DEFAULT_REGULAR_WIDTH = "136";
const DEFAULT_MAIN_HEIGHT = "120";
const DEFAULT_MAIN_WIDTH = "153";
const _sfc_main$P = /* @__PURE__ */ defineComponent({
  __name: "Logo",
  props: {
    /**
     * Color name for component from the Quasar Color Palette
     */
    color: {
      // in the dark mode black-1 converts to white by default
      default: "black-1",
      type: String
    },
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      default: "logo",
      type: String
    },
    /**
     * Logo (regular | main)
     */
    name: {
      default: "regular",
      type: String
    },
    /**
     * Logo size [width, height] -> [100, 50]
     */
    size: {
      default: void 0,
      type: Array
    },
    /**
     * Source of the user provided logo.
     */
    src: {
      default: void 0,
      type: String
    },
    /**
     * Styles applied to component
     * @type {[Array, Object, String]}
     */
    style: {
      default: void 0,
      type: [Array, Object, String]
    }
  },
  setup(__props) {
    const props4 = __props;
    const {
      customLogoSrc,
      logoMain,
      logoRegular
    } = useLogo();
    const { buildId } = useAutomation(computed(() => props4.dataAutomation));
    const customSize = computed(() => {
      if (!props4.size) return void 0;
      const [width, height2] = props4.size;
      return {
        "--height": `${height2}px`,
        "--width": `${width}px`
      };
    });
    const logo = computed(() => {
      switch (props4.name) {
        case "regular":
          return {
            name: customLogoSrc.value ? customLogoSrc.value : logoRegular.value,
            size: customSize.value ?? {
              "--height": `${DEFAULT_REGULAR_HEIGHT}px`,
              "--width": `${DEFAULT_REGULAR_WIDTH}px`
            },
            style: {
              height: `${DEFAULT_REGULAR_HEIGHT}px`,
              width: `${DEFAULT_REGULAR_WIDTH}px`
            },
            viewBox: `0 0 ${props4.size ? props4.size.join(" ") : `${DEFAULT_REGULAR_WIDTH} ${DEFAULT_REGULAR_HEIGHT}`}`
          };
        default:
          return {
            name: customLogoSrc.value ? customLogoSrc.value : logoMain.value,
            size: customSize.value ?? {
              "--height": `${DEFAULT_MAIN_HEIGHT}px`,
              "--width": `${DEFAULT_MAIN_WIDTH}px`
            },
            style: {
              height: `${DEFAULT_MAIN_HEIGHT}px`,
              width: `${DEFAULT_MAIN_WIDTH}px`
            },
            viewBox: `0 0 ${props4.size ? props4.size.join(" ") : `${DEFAULT_MAIN_WIDTH} ${DEFAULT_MAIN_HEIGHT}`}`
          };
      }
    });
    return (_ctx, _cache) => {
      return !!unref(customLogoSrc) ? (openBlock(), createBlock(unref(QImg_default), {
        key: 0,
        "data-automation": unref(buildId)(),
        fit: "contain",
        src: logo.value.name,
        style: normalizeStyle(logo.value.style)
      }, null, 8, ["data-automation", "src", "style"])) : (openBlock(), createElementBlock("svg", {
        key: 1,
        class: normalizeClass(["rv-logo", `text-${__props.color}`]),
        "data-automation": unref(buildId)(),
        style: normalizeStyle(logo.value.size),
        "view-box": logo.value.viewBox
      }, [
        createElementVNode("use", {
          "xlink:href": logo.value.name
        }, null, 8, _hoisted_2$y)
      ], 14, _hoisted_1$I));
    };
  }
});
const _sfc_main$O = defineComponent({
  name: "NavigationTitle",
  components: {
    Button,
    Logo: _sfc_main$P,
    RouterLink
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    collapseOverlayWithLeftSidebar: {
      type: Boolean,
      default: false
    },
    homeRoute: {
      type: [Object, String],
      default: void 0
    },
    overlay: {
      type: Boolean,
      default: false
    }
  },
  setup(props4) {
    const { logoAlignClasses } = useLogo();
    const {
      isFullLayout,
      isSidebarAnimationInprogress,
      showLeftSidebar,
      toggleNavigationBar,
      toggleShowOverlay
    } = useLayout();
    const collapse = computed(() => {
      return props4.collapseOverlayWithLeftSidebar && !showLeftSidebar.value;
    });
    function onToggle() {
      if (isSidebarAnimationInprogress.value) return;
      if (props4.overlay) {
        toggleShowOverlay();
      } else {
        toggleNavigationBar();
      }
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      collapse,
      isFullLayout,
      logoAlignClasses,
      onToggle
    };
  }
});
const _hoisted_1$H = ["data-automation"];
const _hoisted_2$x = { class: "navigation-bar__icon" };
const _hoisted_3$r = {
  key: 1,
  class: "navigation-bar__icon"
};
function _sfc_render$H(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = resolveComponent("Button");
  const _component_Logo = resolveComponent("Logo");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["navigation-bar__header row items-center", {
      "navigation-bar__header--overlay": _ctx.overlay,
      "navigation-bar__header--overlay-collapse": _ctx.collapse
    }]),
    "data-automation": _ctx.buildId()
  }, [
    createElementVNode("div", {
      class: normalizeClass(["navigation-bar__header-item row no-wrap items-center", { "justify-center": _ctx.collapse }])
    }, [
      createElementVNode("div", _hoisted_2$x, [
        createVNode(_component_Button, {
          class: "no-padding",
          color: "black-1",
          "data-automation": _ctx.buildId("menu"),
          icon: "mdi-menu",
          tertiary: "",
          onClick: _ctx.onToggle
        }, null, 8, ["data-automation", "onClick"])
      ]),
      !_ctx.isFullLayout ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        !_ctx.collapse ? (openBlock(), createBlock(resolveDynamicComponent(_ctx.homeRoute ? "RouterLink" : "div"), {
          key: 0,
          class: normalizeClass(["navigation-bar__label", _ctx.logoAlignClasses]),
          "data-automation": _ctx.buildId("link"),
          to: _ctx.homeRoute
        }, {
          default: withCtx(() => [
            createVNode(_component_Logo, {
              class: "navigation-bar__logo",
              "data-automation": _ctx.buildId("logo")
            }, null, 8, ["data-automation"])
          ]),
          _: 1
        }, 8, ["class", "data-automation", "to"])) : createCommentVNode("", true),
        !_ctx.collapse ? (openBlock(), createElementBlock("div", _hoisted_3$r)) : createCommentVNode("", true)
      ], 64)) : createCommentVNode("", true)
    ], 2)
  ], 10, _hoisted_1$H);
}
const NavigationTitle = /* @__PURE__ */ _export_sfc$1(_sfc_main$O, [["render", _sfc_render$H], ["__scopeId", "data-v-9da3fb60"]]);
const _sfc_main$N = defineComponent({
  name: "NavigationHeader",
  components: {
    Avatar,
    Button,
    EllipsisText,
    HeaderNavigationItems,
    LayoutButton,
    NavigationTitle,
    QItem: QItem_default$1,
    QItemLabel: QItemLabel_default$1,
    QList: QList_default$1,
    QMenu: QMenu_default$1,
    QSpace: QSpace_default
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    back: {
      type: Object,
      default: void 0
    },
    backDirectRoute: {
      type: Object,
      default: void 0
    },
    collapseOverlayWithLeftSidebar: {
      type: Boolean,
      default: false
    },
    iconsWidth: {
      type: String,
      default: "auto"
    },
    ignoreShowRightSidebar: {
      type: Boolean,
      default: false
    },
    navigationItems: {
      type: Array,
      default: () => []
    },
    groupedNavigationItems: {
      type: Array,
      default: () => []
    },
    groupedNavigationLabel: {
      type: String,
      default: ""
    },
    overlay: {
      type: Boolean,
      default: false
    },
    sidebarWidth: {
      type: String,
      default: "300px"
    },
    title: {
      type: String,
      required: true
    }
  },
  setup(props4) {
    const options = useOptions();
    const { t: t22 } = useI18n();
    const {
      isFullLayout,
      showLeftSidebar,
      showRightSidebar
    } = useLayout();
    const { goToPreviousPage } = useNavigationHistory(props4.back, props4.backDirectRoute);
    const menuOpen = ref$1(false);
    const actionsWidth = computed(() => {
      return showRightSidebar.value && !props4.ignoreShowRightSidebar ? props4.sidebarWidth : props4.iconsWidth;
    });
    const areNotificationsAvailable = computed(() => options.notification.areNotificationsAvailable ?? true);
    const collapse = computed(() => {
      return props4.collapseOverlayWithLeftSidebar && !showLeftSidebar.value || isFullLayout.value;
    });
    const homeRoute = computed(() => options.navigation.homeRoute);
    const notificationButton = computed(() => options.notification.component);
    const user = computed(() => options.session.currentUser);
    function onLogout() {
      if (options.session.onLogout) {
        void options.session.onLogout();
      }
    }
    function onViewProfile() {
      if (options.session.onViewProfile) {
        void options.session.onViewProfile();
      }
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      actionsWidth,
      areNotificationsAvailable,
      collapse,
      goToPreviousPage,
      homeRoute,
      menuOpen,
      notificationButton,
      onLogout,
      onViewProfile,
      options,
      t: t22,
      user
    };
  }
});
const _hoisted_1$G = ["data-automation"];
const _hoisted_2$w = ["data-automation"];
const _hoisted_3$q = {
  key: 1,
  class: "col-fixed"
};
const _hoisted_4$g = ["data-automation"];
const _hoisted_5$d = ["data-automation"];
const _hoisted_6$9 = { class: "row no-wrap q-gutter-x-sm" };
const _hoisted_7$7 = ["data-automation"];
const _hoisted_8$4 = { class: "navigation-header__icons row no-wrap justify-end items-center q-gutter-md" };
const _hoisted_9$3 = ["data-automation"];
function _sfc_render$G(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NavigationTitle = resolveComponent("NavigationTitle");
  const _component_Button = resolveComponent("Button");
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_QSpace = resolveComponent("QSpace");
  const _component_HeaderNavigationItems = resolveComponent("HeaderNavigationItems");
  const _component_QItemLabel = resolveComponent("QItemLabel");
  const _component_QItem = resolveComponent("QItem");
  const _component_QList = resolveComponent("QList");
  const _component_QMenu = resolveComponent("QMenu");
  const _component_Avatar = resolveComponent("Avatar");
  const _component_LayoutButton = resolveComponent("LayoutButton");
  return openBlock(), createElementBlock(Fragment, null, [
    createElementVNode("div", {
      class: "navigation-header bg-grey-5 row no-wrap items-center q-px-lg",
      "data-automation": _ctx.buildId()
    }, [
      _ctx.overlay || _ctx.$slots["navigation-title"] ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(["navigation-header__left", { "navigation-header__left-collapse": _ctx.collapse }]),
        "data-automation": _ctx.buildId("navigation-title-wrapper")
      }, [
        renderSlot(_ctx.$slots, "navigation-title", {}, () => [
          _ctx.overlay ? (openBlock(), createBlock(_component_NavigationTitle, {
            key: 0,
            "collapse-overlay-with-left-sidebar": _ctx.collapseOverlayWithLeftSidebar,
            "data-automation": _ctx.buildId("title"),
            "home-route": _ctx.homeRoute,
            overlay: _ctx.overlay
          }, null, 8, ["collapse-overlay-with-left-sidebar", "data-automation", "home-route", "overlay"])) : createCommentVNode("", true)
        ], true)
      ], 10, _hoisted_2$w)) : createCommentVNode("", true),
      _ctx.back || _ctx.backDirectRoute ? (openBlock(), createElementBlock("div", _hoisted_3$q, [
        createVNode(_component_Button, {
          "data-automation": _ctx.buildId("back"),
          icon: "mdi-chevron-left",
          tertiary: "",
          "text-color": "black-1",
          onClick: withModifiers(_ctx.goToPreviousPage, ["prevent"])
        }, null, 8, ["data-automation", "onClick"])
      ])) : createCommentVNode("", true),
      _ctx.$slots["title"] || _ctx.title ? renderSlot(_ctx.$slots, "title", { key: 2 }, () => [
        createVNode(_component_EllipsisText, {
          class: "text-black-1 text-subtitle1",
          "data-automation": _ctx.buildId("title"),
          text: _ctx.title
        }, null, 8, ["data-automation", "text"])
      ], true) : createCommentVNode("", true),
      _ctx.$slots["append-title"] ? (openBlock(), createElementBlock("div", {
        key: 3,
        "data-automation": _ctx.buildId("append-title")
      }, [
        renderSlot(_ctx.$slots, "append-title", {}, void 0, true)
      ], 8, _hoisted_4$g)) : createCommentVNode("", true),
      createVNode(_component_QSpace),
      _ctx.$slots["actions"] ? (openBlock(), createElementBlock("div", {
        key: 4,
        class: "navigation-header__actions q-ml-md",
        "data-automation": _ctx.buildId("actions")
      }, [
        createElementVNode("div", _hoisted_6$9, [
          renderSlot(_ctx.$slots, "actions", {}, void 0, true)
        ])
      ], 8, _hoisted_5$d)) : createCommentVNode("", true),
      _ctx.navigationItems.length ? (openBlock(), createBlock(_component_HeaderNavigationItems, {
        key: 5,
        "data-automation": _ctx.buildId("headerNavigationItems"),
        "grouped-items": _ctx.groupedNavigationItems,
        "grouped-items-label": _ctx.groupedNavigationLabel,
        "navigation-items": _ctx.navigationItems
      }, null, 8, ["data-automation", "grouped-items", "grouped-items-label", "navigation-items"])) : createCommentVNode("", true),
      createElementVNode("div", {
        class: "navigation-header__right col-fixed q-ml-lg",
        "data-automation": _ctx.buildId("right"),
        style: normalizeStyle({ width: _ctx.navigationItems.length ? "auto" : _ctx.actionsWidth })
      }, [
        createElementVNode("div", _hoisted_8$4, [
          _ctx.areNotificationsAvailable ? renderSlot(_ctx.$slots, "extra", { key: 0 }, () => [
            _ctx.notificationButton ? (openBlock(), createBlock(resolveDynamicComponent(_ctx.notificationButton), { key: 0 })) : createCommentVNode("", true)
          ], true) : createCommentVNode("", true),
          _ctx.user ? (openBlock(), createBlock(_component_Avatar, {
            key: 1,
            "background-color": _ctx.user.isCurrent ? "white" : _ctx.user.userColor,
            "border-color": _ctx.user.isCurrent ? "grey-1" : "white",
            class: "cursor-pointer",
            "data-automation": _ctx.buildId("user"),
            image: _ctx.user.userAvatar,
            initials: _ctx.user.userInitials,
            label: _ctx.user.userName,
            "show-tooltip": !_ctx.menuOpen,
            "text-color": _ctx.user.isCurrent ? "grey-1" : "",
            uuid: _ctx.user.userId
          }, {
            extra: withCtx(() => [
              createVNode(_component_QMenu, {
                modelValue: _ctx.menuOpen,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.menuOpen = $event),
                anchor: "bottom right",
                "auto-close": "",
                "content-style": { width: "220px" },
                self: "top right"
              }, {
                default: withCtx(() => [
                  createVNode(_component_QList, { separator: "" }, {
                    default: withCtx(() => [
                      _ctx.options.session.onViewProfile ? (openBlock(), createBlock(_component_QItem, {
                        key: 0,
                        clickable: "",
                        "data-automation": _ctx.buildId("btn-view-profile"),
                        onClick: _ctx.onViewProfile
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_QItemLabel, null, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(_ctx.t("rvai-base.general.actions.viewProfile")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["data-automation", "onClick"])) : createCommentVNode("", true),
                      createVNode(_component_QItem, {
                        clickable: "",
                        "data-automation": _ctx.buildId("btn-logout"),
                        onClick: _ctx.onLogout
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_QItemLabel, null, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(_ctx.t("rvai-base.general.actions.logout")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["data-automation", "onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["background-color", "border-color", "data-automation", "image", "initials", "label", "show-tooltip", "text-color", "uuid"])) : createCommentVNode("", true),
          createVNode(_component_LayoutButton, {
            "data-automation": _ctx.buildId("layout")
          }, null, 8, ["data-automation"])
        ])
      ], 12, _hoisted_7$7)
    ], 8, _hoisted_1$G),
    _ctx.$slots["sub-header"] ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: "bg-grey-5 q-px-lg q-pb-md text-black-1",
      "data-automation": _ctx.buildId("sub-header")
    }, [
      renderSlot(_ctx.$slots, "sub-header", {}, void 0, true)
    ], 8, _hoisted_9$3)) : createCommentVNode("", true)
  ], 64);
}
const NavigationHeader = /* @__PURE__ */ _export_sfc$1(_sfc_main$N, [["render", _sfc_render$G], ["__scopeId", "data-v-db1cf062"]]);
const _sfc_main$M = defineComponent({
  name: "SpinnerFixed",
  components: {
    QSpinner: QSpinner_default$1
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: "spinnerFixed"
    },
    /**
     * Spinner size
     */
    size: {
      type: String,
      default: "48px"
    }
  },
  setup(props4) {
    return {
      ...useAutomation(computed(() => props4.dataAutomation))
    };
  }
});
const _hoisted_1$F = ["data-automation"];
const _hoisted_2$v = { class: "spinner-block__background" };
const _hoisted_3$p = { class: "absolute-center" };
function _sfc_render$F(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QSpinner = resolveComponent("QSpinner");
  return openBlock(), createElementBlock("div", {
    class: "spinner-block flex justify-center",
    "data-automation": _ctx.buildId()
  }, [
    createElementVNode("div", _hoisted_2$v, [
      createElementVNode("div", _hoisted_3$p, [
        createVNode(_component_QSpinner, {
          class: "spinner-block__spinner",
          color: "primary",
          size: _ctx.size
        }, null, 8, ["size"])
      ])
    ])
  ], 8, _hoisted_1$F);
}
const SpinnerFixed = /* @__PURE__ */ _export_sfc$1(_sfc_main$M, [["render", _sfc_render$F], ["__scopeId", "data-v-7a7a872e"]]);
const _sfc_main$L = defineComponent({
  name: "MainContent",
  components: {
    NavigationHeader,
    QDrawer: QDrawer_default,
    QHeader: QHeader_default,
    QPage: QPage_default,
    QResizeObserver: QResizeObserver_default$1,
    SpinnerFixed
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    back: {
      type: Object,
      default: void 0
    },
    backDirectRoute: {
      type: Object,
      default: void 0
    },
    collapseOverlayWithLeftSidebar: {
      type: Boolean,
      default: false
    },
    contentClass: {
      type: [Array, Object, String],
      default: ""
    },
    ignoreShowRightSidebar: {
      type: Boolean,
      default: false
    },
    headerNavigationItems: {
      type: Array,
      default: () => []
    },
    groupedHeaderNavigationItems: {
      type: Array,
      default: () => []
    },
    groupedHeaderNavigationLabel: {
      type: String,
      default: ""
    },
    overlay: {
      type: Boolean,
      default: false
    },
    pageClass: {
      type: [Array, Object, String],
      default: "q-pb-lg"
    },
    sidebarWidth: {
      type: String,
      default: "300px"
    },
    showSpinner: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    }
  },
  setup(props4) {
    const {
      showLeftSidebar,
      showRightSidebar
    } = useLayout();
    const {
      rightPanelWidth,
      setRightPanelWidth
    } = useRightPanelSize();
    const collapse = computed(() => {
      return props4.collapseOverlayWithLeftSidebar && !showLeftSidebar.value;
    });
    const onResize = ({ width }) => {
      setRightPanelWidth(width);
    };
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      collapse,
      onResize,
      rightPanelWidth,
      showRightSidebar
    };
  }
});
const _hoisted_1$E = ["data-automation"];
const _hoisted_2$u = { class: "q-pr-lg" };
function _sfc_render$E(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NavigationHeader = resolveComponent("NavigationHeader");
  const _component_QHeader = resolveComponent("QHeader");
  const _component_SpinnerFixed = resolveComponent("SpinnerFixed");
  const _component_QPage = resolveComponent("QPage");
  const _component_QDrawer = resolveComponent("QDrawer");
  const _component_QResizeObserver = resolveComponent("QResizeObserver");
  return openBlock(), createElementBlock(Fragment, null, [
    createElementVNode("div", {
      class: "main-content q-px-lg bg-grey-5",
      "data-automation": _ctx.buildId()
    }, [
      createVNode(_component_QHeader, {
        class: "bg-grey-5",
        "height-hint": "72px"
      }, {
        default: withCtx(() => [
          createVNode(_component_NavigationHeader, {
            back: _ctx.back,
            "back-direct-route": _ctx.backDirectRoute,
            "collapse-overlay-with-left-sidebar": _ctx.collapseOverlayWithLeftSidebar,
            "data-automation": _ctx.buildId("header"),
            "grouped-navigation-items": _ctx.groupedHeaderNavigationItems,
            "grouped-navigation-label": _ctx.groupedHeaderNavigationLabel,
            "ignore-show-right-sidebar": _ctx.ignoreShowRightSidebar,
            "navigation-items": _ctx.headerNavigationItems,
            overlay: _ctx.overlay,
            "sidebar-width": _ctx.sidebarWidth,
            title: _ctx.title
          }, createSlots({ _: 2 }, [
            _ctx.$slots["actions"] ? {
              name: "actions",
              fn: withCtx(() => [
                renderSlot(_ctx.$slots, "actions", {}, void 0, true)
              ]),
              key: "0"
            } : void 0,
            _ctx.$slots["title"] ? {
              name: "title",
              fn: withCtx(() => [
                renderSlot(_ctx.$slots, "title", {}, void 0, true)
              ]),
              key: "1"
            } : void 0,
            _ctx.$slots["append-title"] ? {
              name: "append-title",
              fn: withCtx(() => [
                renderSlot(_ctx.$slots, "append-title", {}, void 0, true)
              ]),
              key: "2"
            } : void 0,
            _ctx.$slots["append-breadcrumbs"] ? {
              name: "append-breadcrumbs",
              fn: withCtx(() => [
                renderSlot(_ctx.$slots, "append-breadcrumbs", {}, void 0, true)
              ]),
              key: "3"
            } : void 0,
            _ctx.$slots["extra"] ? {
              name: "extra",
              fn: withCtx(() => [
                renderSlot(_ctx.$slots, "extra", {}, void 0, true)
              ]),
              key: "4"
            } : void 0,
            _ctx.$slots["sub-header"] ? {
              name: "sub-header",
              fn: withCtx(() => [
                renderSlot(_ctx.$slots, "sub-header", {}, void 0, true)
              ]),
              key: "5"
            } : void 0
          ]), 1032, ["back", "back-direct-route", "collapse-overlay-with-left-sidebar", "data-automation", "grouped-navigation-items", "grouped-navigation-label", "ignore-show-right-sidebar", "navigation-items", "overlay", "sidebar-width", "title"])
        ]),
        _: 3
      }),
      _ctx.showSpinner ? (openBlock(), createBlock(_component_SpinnerFixed, {
        key: 0,
        "data-automation": _ctx.buildId("spinner")
      }, null, 8, ["data-automation"])) : createCommentVNode("", true),
      createVNode(_component_QPage, {
        class: normalizeClass(["main-content__main-block", _ctx.pageClass]),
        "data-automation": _ctx.buildId("page")
      }, {
        default: withCtx(() => [
          _ctx.$slots["left-content"] ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(["row no-wrap", { "min-height-inherit": !_ctx.$slots["content-bottom"] }])
          }, [
            createElementVNode("div", {
              class: normalizeClass(["main-content__left-content q-mr-lg", { "main-content__left-content--collapse": _ctx.collapse }])
            }, [
              renderSlot(_ctx.$slots, "left-content", {}, void 0, true)
            ], 2),
            createElementVNode("div", {
              class: normalizeClass(["main-content__content zero-min-width", _ctx.contentClass])
            }, [
              renderSlot(_ctx.$slots, "default", {}, void 0, true)
            ], 2)
          ], 2)) : (openBlock(), createElementBlock("div", {
            key: 1,
            class: normalizeClass(["main-content__content", _ctx.contentClass])
          }, [
            renderSlot(_ctx.$slots, "default", {}, void 0, true)
          ], 2)),
          renderSlot(_ctx.$slots, "content-bottom", {}, void 0, true)
        ]),
        _: 3
      }, 8, ["class", "data-automation"]),
      _ctx.$slots.sidebar ? (openBlock(), createBlock(_component_QDrawer, {
        key: 1,
        breakpoint: 0,
        class: "bg-grey-5",
        "data-automation": _ctx.buildId("drawer"),
        "model-value": _ctx.showRightSidebar,
        side: "right",
        width: _ctx.rightPanelWidth
      }, {
        default: withCtx(() => [
          createElementVNode("div", _hoisted_2$u, [
            renderSlot(_ctx.$slots, "sidebar", {}, void 0, true)
          ])
        ]),
        _: 3
      }, 8, ["data-automation", "model-value", "width"])) : createCommentVNode("", true),
      renderSlot(_ctx.$slots, "footer", {}, void 0, true)
    ], 8, _hoisted_1$E),
    createVNode(_component_QResizeObserver, { onResize: _ctx.onResize }, null, 8, ["onResize"])
  ], 64);
}
const MainContent = /* @__PURE__ */ _export_sfc$1(_sfc_main$L, [["render", _sfc_render$E], ["__scopeId", "data-v-7dc33dc5"]]);
function isArrayOfObjects(items) {
  return items.length ? items.every((i22) => Object.prototype.toString.call(i22).includes("Object")) : false;
}
const _sfc_main$K = defineComponent({
  name: "MultipleSelect",
  components: {
    Checkbox,
    EllipsisText,
    Input,
    QChip: QChip_default$1,
    QIcon: QIcon_default$1,
    QItem: QItem_default$1,
    QItemLabel: QItemLabel_default$1,
    QItemSection: QItemSection_default$1,
    Select,
    Separator
  },
  inheritAttrs: false,
  props: {
    allSelectedText: {
      default: "",
      type: String
    },
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Update model with the value of the selected option instead of the whole option
     */
    emitValue: {
      type: Boolean,
      default: false
    },
    /**
     * Adds info icon and shows the text on hover
     */
    infoText: {
      type: String,
      default: void 0
    },
    /**
     * A text label that will “float” up above the input field, once the field gets focus
     */
    label: {
      type: String,
      default: void 0
    },
    /**
     * Model of the component; Must be Array; Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
     */
    modelValue: {
      type: [Number, Object, String, Boolean],
      required: true
    },
    /**
     * The text that will be shown next to label
     */
    optionalLabel: {
      type: String,
      default: ""
    },
    /**
     * Property of option which holds the 'label'; If using a function then for best performance, reference it from your scope and do not define it inline
     */
    optionLabel: {
      type: String,
      default: "label"
    },
    /**
     * Property of option which holds the 'value'; If using a function then for best performance, reference it from your scope and do not define it inline
     */
    optionValue: {
      type: String,
      default: "value"
    },
    /**
     * Available options that the user can select from.
     */
    options: {
      type: [Number, Object, String, Boolean],
      default: () => []
    },
    /**
     * Put component in readonly mode
     */
    readonly: {
      type: Boolean,
      default: false
    },
    /**
     * Shows optional label after base label
     */
    showOptionalLabel: {
      type: Boolean,
      default: false
    },
    /**
     * Validation for the component
     */
    validation: {
      type: Object,
      default: void 0
    },
    /**
     * Shows QChips for selected options
     */
    withChips: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    "update:modelValue"
  ],
  setup(props4, { emit }) {
    const { t: t22 } = useI18n();
    const chips = ref$1([]);
    const chipsWrapper = ref$1(null);
    const filter = ref$1("");
    const selectRef = ref$1(null);
    const wrapperWidth = ref$1(0);
    const allSelected = computed(() => {
      const isEveryItemNotSelected = filteredOptions.value.every((o) => !selectedValues.value.find((v) => v[props4.optionValue] === o[props4.optionValue]));
      if (isEveryItemNotSelected) return false;
      const isEveryItemSelected = filteredOptions.value.every((o) => !!selectedValues.value.find((v) => v[props4.optionValue] === o[props4.optionValue]));
      if (isEveryItemSelected) return true;
      return void 0;
    });
    const componentWidth = computed(() => {
      var _a;
      return ((_a = selectRef.value) == null ? void 0 : _a.$el.offsetWidth) ?? 0;
    });
    const convertedOptions = computed(() => {
      return isArrayOfObjects(props4.options) ? props4.options : props4.options.map((o) => ({
        [props4.optionLabel]: String(o),
        [props4.optionValue]: o
      }));
    });
    const filteredOptions = computed(() => {
      const needle = filter.value.toLowerCase();
      const distinctOptions = props4.withChips ? distinctByKey(
        [
          ...sortByKey(selectedValues.value, props4.optionLabel),
          ...sortByKey(convertedOptions.value, props4.optionLabel)
        ],
        props4.optionLabel
      ) : convertedOptions.value;
      return distinctOptions.filter((o) => String(o[props4.optionLabel]).toLowerCase().includes(needle));
    });
    const labelWidth = computed(() => {
      return componentWidth.value - 32 - 32;
    });
    const selectedValues = computed({
      get() {
        if (isArrayOfObjects(props4.modelValue)) return props4.modelValue;
        return props4.modelValue.map((v) => {
          const option = convertedOptions.value.find((o) => o[props4.optionValue] === v);
          return {
            [props4.optionLabel]: option ? option[props4.optionLabel] : String(v),
            [props4.optionValue]: option ? option[props4.optionValue] : String(v)
          };
        });
      },
      set(value2) {
        const checkList = props4.modelValue.length ? props4.modelValue : props4.options;
        chips.value = [];
        if (isArrayOfObjects(checkList) && !props4.emitValue) {
          emit("update:modelValue", value2);
        } else {
          emit("update:modelValue", value2.map((v) => v[props4.optionValue]));
        }
      }
    });
    const shownChipsCount = computed(() => {
      if (allSelected.value) return 0;
      const CONTAINER_SPACING = 4;
      const CHIP_GAP = 4;
      const DOTS_WIDTH = 13;
      let chipsWidth = DOTS_WIDTH + CONTAINER_SPACING;
      for (let i22 = 0; i22 < chips.value.length; i22++) {
        chipsWidth += chips.value[i22].clientWidth;
        if (i22 > 0) {
          chipsWidth += CHIP_GAP;
        }
        if (wrapperWidth.value && chipsWidth > wrapperWidth.value) return i22 === 0 ? 1 : i22;
      }
      return Number.MAX_SAFE_INTEGER;
    });
    function filterSelected(item) {
      selectedValues.value = selectedValues.value.filter((v) => v !== item);
    }
    function getRefElement(element, index2) {
      if (element) {
        chips.value[index2] = element;
      }
    }
    function onPopupHide() {
      filter.value = "";
    }
    function onToggleAll() {
      const uniqueValues = distinctByKey(
        [...selectedValues.value, ...filteredOptions.value],
        props4.optionValue
      );
      const hiddenSelectedValues = selectedValues.value.filter((v) => !filteredOptions.value.some((x22) => x22[props4.optionValue] === v[props4.optionValue]));
      selectedValues.value = allSelected.value ? hiddenSelectedValues : uniqueValues;
    }
    function resizeSelect() {
      var _a;
      wrapperWidth.value = (_a = chipsWrapper.value) == null ? void 0 : _a.offsetWidth;
    }
    const resizeObserver = new ResizeObserver(resizeSelect);
    onMounted(() => {
      resizeSelect();
      chipsWrapper.value && resizeObserver.observe(chipsWrapper.value);
    });
    onUnmounted(() => {
      resizeObserver.disconnect();
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      allSelected,
      chips,
      chipsWrapper,
      componentWidth,
      filter,
      filteredOptions,
      filterSelected,
      getRefElement,
      labelWidth,
      onPopupHide,
      onToggleAll,
      selectedValues,
      selectRef,
      shownChipsCount,
      t: t22
    };
  }
});
const _hoisted_1$D = { class: "multiple-select__no-items q-ml-md" };
const _hoisted_2$t = ["data-automation"];
const _hoisted_3$o = ["data-automation"];
function _sfc_render$D(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Checkbox = resolveComponent("Checkbox");
  const _component_QItemSection = resolveComponent("QItemSection");
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_QItemLabel = resolveComponent("QItemLabel");
  const _component_QItem = resolveComponent("QItem");
  const _component_Separator = resolveComponent("Separator");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_Input = resolveComponent("Input");
  const _component_QChip = resolveComponent("QChip");
  const _component_Select = resolveComponent("Select");
  return openBlock(), createBlock(_component_Select, mergeProps(_ctx.dataAttrs, {
    ref: "selectRef",
    modelValue: _ctx.selectedValues,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.selectedValues = $event),
    class: ["multiple-select", _ctx.$props.class],
    "data-automation": _ctx.buildId(),
    disable: _ctx.disable,
    "info-text": _ctx.infoText,
    label: _ctx.label,
    multiple: "",
    "option-label": _ctx.optionLabel,
    "option-value": _ctx.optionValue,
    "optional-label": _ctx.optionalLabel,
    options: _ctx.filteredOptions,
    readonly: _ctx.readonly,
    "show-optional-label": _ctx.showOptionalLabel,
    validation: _ctx.validation,
    onOnPopupHide: _ctx.onPopupHide
  }), createSlots({ _: 2 }, [
    _ctx.withChips ? {
      name: "option",
      fn: withCtx(({ index: index2, itemProps, opt, selected, toggleOption }) => [
        createVNode(_component_QItem, mergeProps({
          "data-automation": _ctx.buildId(`item-chips-${opt[_ctx.optionLabel]}`)
        }, itemProps), {
          default: withCtx(() => [
            createVNode(_component_QItemSection, {
              class: "q-pr-sm",
              side: ""
            }, {
              default: withCtx(() => [
                createVNode(_component_Checkbox, {
                  "data-automation": _ctx.buildId(`item-chips-${opt[_ctx.optionLabel]}__checkbox`),
                  dense: "",
                  "model-value": selected,
                  "onUpdate:modelValue": ($event) => toggleOption(opt)
                }, null, 8, ["data-automation", "model-value", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024),
            createVNode(_component_QItemSection, { class: "q-item__section column q-item__section--main justify-center" }, {
              default: withCtx(() => [
                createVNode(_component_QItemLabel, { class: "q-item__label" }, {
                  default: withCtx(() => [
                    createVNode(_component_EllipsisText, {
                      "data-automation": _ctx.buildId(`item-chips-${opt[_ctx.optionLabel]}__label`),
                      style: normalizeStyle({ "width": `${_ctx.labelWidth}px` }),
                      text: opt[_ctx.optionLabel]
                    }, null, 8, ["data-automation", "style", "text"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1040, ["data-automation"]),
        selected && index2 === _ctx.modelValue.length - 1 ? (openBlock(), createBlock(_component_Separator, { key: 0 })) : createCommentVNode("", true)
      ]),
      key: "0"
    } : {
      name: "option",
      fn: withCtx(({ itemProps, opt, selected, toggleOption }) => [
        createVNode(_component_QItem, mergeProps({
          "data-automation": _ctx.buildId(`item-${opt[_ctx.optionLabel]}`)
        }, itemProps), {
          default: withCtx(() => [
            createVNode(_component_QItemSection, {
              class: "q-pr-sm",
              side: ""
            }, {
              default: withCtx(() => [
                createVNode(_component_Checkbox, {
                  "data-automation": _ctx.buildId(`item-${opt[_ctx.optionLabel]}__checkbox`),
                  dense: "",
                  "model-value": selected,
                  "onUpdate:modelValue": ($event) => toggleOption(opt)
                }, null, 8, ["data-automation", "model-value", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024),
            createVNode(_component_QItemSection, { class: "q-item__section column q-item__section--main justify-center" }, {
              default: withCtx(() => [
                createVNode(_component_QItemLabel, { class: "q-item__label" }, {
                  default: withCtx(() => [
                    createVNode(_component_EllipsisText, {
                      "data-automation": _ctx.buildId(`item-${opt[_ctx.optionLabel]}__label`),
                      style: normalizeStyle({ "width": `${_ctx.labelWidth}px` }),
                      text: opt[_ctx.optionLabel] || opt
                    }, null, 8, ["data-automation", "style", "text"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1040, ["data-automation"])
      ]),
      key: "1"
    },
    _ctx.withChips ? {
      name: "no-option",
      fn: withCtx(() => [
        createVNode(_component_Input, {
          modelValue: _ctx.filter,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.filter = $event),
          autofocus: "",
          class: "multiple-select__search-input",
          "data-automation": _ctx.buildId("chips"),
          icon: "search",
          placeholder: _ctx.t("rvai-base.components.multipleSelect.search"),
          square: "",
          style: normalizeStyle({ "max-width": `${_ctx.componentWidth}px` })
        }, {
          prepend: withCtx(() => [
            createVNode(_component_QIcon, {
              class: "q-ml-xs q-pr-sm",
              color: "black-1",
              name: "search",
              size: "18px"
            })
          ]),
          _: 1
        }, 8, ["modelValue", "data-automation", "placeholder", "style"]),
        createElementVNode("div", _hoisted_1$D, toDisplayString(_ctx.t("rvai-base.components.multipleSelect.noItems")), 1)
      ]),
      key: "2"
    } : {
      name: "no-option",
      fn: withCtx(() => [
        createVNode(_component_QItem, {
          "data-automation": _ctx.buildId("no-items")
        }, {
          default: withCtx(() => [
            createVNode(_component_QItemSection, { class: "text-grey" }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(_ctx.t("rvai-base.components.multipleSelect.noItems")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data-automation"])
      ]),
      key: "3"
    },
    _ctx.withChips ? {
      name: "selected",
      fn: withCtx(() => [
        _ctx.allSelected ? (openBlock(), createBlock(_component_EllipsisText, {
          key: 0,
          class: "text-grey-1",
          "data-automation": _ctx.buildId("selectAll__label"),
          text: _ctx.allSelectedText || _ctx.$t("rvai-base.components.multipleSelect.allItemsSelected")
        }, null, 8, ["data-automation", "text"])) : createCommentVNode("", true),
        createElementVNode("div", {
          ref: "chipsWrapper",
          class: normalizeClass(["row no-wrap full-width overflow-hidden multiple-select__chips-container", { "multiple-select__chips-container--multiple": _ctx.selectedValues.length > 1 }])
        }, [
          !_ctx.allSelected ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(_ctx.selectedValues, (item, i22) => {
            return openBlock(), createElementBlock("div", {
              key: item[_ctx.optionValue],
              ref_for: true,
              ref: (el) => _ctx.getRefElement(el, i22),
              class: normalizeClass(["multiple-select__chip-container", {
                "multiple-select__chip-container--dots": i22 + 1 === _ctx.shownChipsCount && _ctx.selectedValues.length > 1,
                "hide": i22 + 1 > _ctx.shownChipsCount
              }]),
              "data-automation": _ctx.buildId(`item-selected-${i22}`)
            }, [
              createVNode(_component_QChip, { outline: "" }, {
                default: withCtx(() => [
                  createVNode(_component_EllipsisText, null, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(item[_ctx.optionLabel]), 1)
                    ]),
                    _: 2
                  }, 1024),
                  createVNode(_component_QIcon, {
                    class: "q-ml-xs",
                    name: "mdi-close",
                    onClick: withModifiers(($event) => _ctx.filterSelected(item), ["prevent", "stop"])
                  }, null, 8, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ], 10, _hoisted_2$t);
          }), 128)) : createCommentVNode("", true)
        ], 2),
        !_ctx.selectedValues.length ? (openBlock(), createBlock(_component_EllipsisText, {
          key: 1,
          class: "text-grey-1",
          "data-automation": _ctx.buildId("selectOption"),
          text: _ctx.t("rvai-base.components.multipleSelect.selectOption")
        }, null, 8, ["data-automation", "text"])) : createCommentVNode("", true)
      ]),
      key: "4"
    } : void 0,
    _ctx.withChips ? {
      name: "append",
      fn: withCtx(() => [
        _ctx.selectedValues.length ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "multiple-select__chip-container",
          "data-automation": _ctx.buildId("selected")
        }, [
          createVNode(_component_QChip, { outline: "" }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(_ctx.selectedValues.length) + " ", 1),
              createVNode(_component_QIcon, {
                class: "q-ml-xs",
                name: "mdi-close",
                onClick: _cache[1] || (_cache[1] = withModifiers(($event) => _ctx.selectedValues = [], ["prevent", "stop"]))
              })
            ]),
            _: 1
          })
        ], 8, _hoisted_3$o)) : createCommentVNode("", true)
      ]),
      key: "5"
    } : void 0,
    _ctx.withChips ? {
      name: "before-options",
      fn: withCtx(() => [
        createVNode(_component_Input, {
          modelValue: _ctx.filter,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.filter = $event),
          autofocus: "",
          class: "multiple-select__search-input",
          "data-automation": _ctx.buildId("input-search"),
          icon: "search",
          placeholder: _ctx.t("rvai-base.components.multipleSelect.search"),
          square: "",
          style: normalizeStyle({ "max-width": `${_ctx.componentWidth}px` })
        }, {
          prepend: withCtx(() => [
            createVNode(_component_QIcon, {
              class: "q-ml-xs q-pr-sm",
              color: "black-1",
              name: "search",
              size: "18px"
            })
          ]),
          _: 1
        }, 8, ["modelValue", "data-automation", "placeholder", "style"]),
        createVNode(_component_QItem, {
          clickable: "",
          "data-automation": _ctx.buildId("selectAll"),
          onClick: _ctx.onToggleAll
        }, {
          default: withCtx(() => [
            createVNode(_component_QItemSection, {
              class: "q-pr-sm",
              side: ""
            }, {
              default: withCtx(() => [
                createVNode(_component_Checkbox, {
                  "data-automation": _ctx.buildId("selectAll__checkbox"),
                  dense: "",
                  "model-value": _ctx.allSelected,
                  style: { "pointer-events": "none" }
                }, null, 8, ["data-automation", "model-value"])
              ]),
              _: 1
            }),
            createVNode(_component_QItemSection, { class: "q-item__section column q-item__section--main justify-center" }, {
              default: withCtx(() => [
                createVNode(_component_QItemLabel, { class: "q-item__label" }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(_ctx.t("rvai-base.components.multipleSelect.selectAll")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data-automation", "onClick"]),
        createVNode(_component_Separator, { color: "grey-3" })
      ]),
      key: "6"
    } : void 0
  ]), 1040, ["modelValue", "class", "data-automation", "disable", "info-text", "label", "option-label", "option-value", "optional-label", "options", "readonly", "show-optional-label", "validation", "onOnPopupHide"]);
}
const MultipleSelect = /* @__PURE__ */ _export_sfc$1(_sfc_main$K, [["render", _sfc_render$D], ["__scopeId", "data-v-3c1d9c00"]]);
const _sfc_main$J = defineComponent({
  name: "NavigationBarLink",
  components: {
    EllipsisText,
    QIcon: QIcon_default$1,
    QItem: QItem_default$1,
    RouterLink,
    Tooltip: Tooltip2
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    alwaysVisible: {
      type: Boolean,
      default: false
    },
    collapsedNavigationbar: {
      type: Boolean,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    menu: {
      type: Boolean,
      default: false
    },
    transitionDuration: {
      type: Number,
      default: 0
    }
  },
  setup(props4) {
    return {
      ...useAutomation(computed(() => props4.dataAutomation))
    };
  }
});
const _hoisted_1$C = ["data-automation", "href", "onClick"];
const _hoisted_2$s = { key: 0 };
function _sfc_render$C(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QIcon = resolveComponent("QIcon");
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_QItem = resolveComponent("QItem");
  const _component_RouterLink = resolveComponent("RouterLink");
  return openBlock(), createBlock(_component_RouterLink, {
    custom: "",
    to: _ctx.item.to
  }, {
    default: withCtx(({ href: href2, navigate, isExactActive }) => [
      createVNode(_component_QItem, {
        class: normalizeClass(["navigation-item q-pa-none", { "navigation-item--active": isExactActive }]),
        clickable: "",
        "data-automation": _ctx.buildId()
      }, {
        default: withCtx(() => [
          createElementVNode("a", {
            class: normalizeClass(["navigation q-py-sm q-px-lg row no-wrap items-center full-width", {
              "navigation--menu": _ctx.menu
            }]),
            "data-automation": _ctx.buildId("link"),
            href: href2,
            onClick: withModifiers(navigate, ["stop"])
          }, [
            !_ctx.menu ? (openBlock(), createElementBlock("div", _hoisted_2$s, [
              _ctx.item.icon ? (openBlock(), createBlock(_component_QIcon, {
                key: 0,
                name: _ctx.item.icon,
                size: "1.5rem"
              }, null, 8, ["name"])) : createCommentVNode("", true),
              _ctx.item.tooltip && _ctx.collapsedNavigationbar ? (openBlock(), createBlock(_component_Tooltip, {
                key: 1,
                anchor: "center left",
                arrow: "left",
                "data-automation": _ctx.buildId("tooltip"),
                offset: [-40, 0],
                self: "center left"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.item.tooltip), 1)
                ]),
                _: 1
              }, 8, ["data-automation"])) : createCommentVNode("", true)
            ])) : createCommentVNode("", true),
            createVNode(_component_EllipsisText, {
              class: normalizeClass(["navigation__label q-ml-lg text-subtitle3", { "q-mr-lg navigation__label--hidden": !_ctx.alwaysVisible && _ctx.collapsedNavigationbar }]),
              "data-automation": _ctx.buildId("label"),
              style: normalizeStyle({
                "--transition": `opacity ${_ctx.transitionDuration}ms ease-out`,
                "--transition-delay": `${_ctx.transitionDuration ? Math.max(_ctx.transitionDuration, 300) : 150}ms`
              }),
              text: _ctx.item.label
            }, null, 8, ["class", "data-automation", "style", "text"])
          ], 10, _hoisted_1$C)
        ]),
        _: 2
      }, 1032, ["class", "data-automation"])
    ]),
    _: 1
  }, 8, ["to"]);
}
const NavigationBarLink = /* @__PURE__ */ _export_sfc$1(_sfc_main$J, [["render", _sfc_render$C], ["__scopeId", "data-v-f4ebd805"]]);
var symbolTag = "[object Symbol]";
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f\\ufe20-\\ufe23", rsComboSymbolsRange = "\\u20d0-\\u20f0", rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
var rsApos = "['’]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboMarksRange + rsComboSymbolsRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
var rsLowerMisc = "(?:" + rsLower + "|" + rsMisc + ")", rsUpperMisc = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptLowerContr = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptUpperContr = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq;
var reApos = RegExp(rsApos, "g");
var reComboMark = RegExp(rsCombo, "g");
var reUnicodeWord = RegExp([
  rsUpper + "?" + rsLower + "+" + rsOptLowerContr + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
  rsUpperMisc + "+" + rsOptUpperContr + "(?=" + [rsBreak, rsUpper + rsLowerMisc, "$"].join("|") + ")",
  rsUpper + "?" + rsLowerMisc + "+" + rsOptLowerContr,
  rsUpper + "+" + rsOptUpperContr,
  rsDigits,
  rsEmoji
].join("|"), "g");
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
var deburredLetters = {
  // Latin-1 Supplement block.
  "À": "A",
  "Á": "A",
  "Â": "A",
  "Ã": "A",
  "Ä": "A",
  "Å": "A",
  "à": "a",
  "á": "a",
  "â": "a",
  "ã": "a",
  "ä": "a",
  "å": "a",
  "Ç": "C",
  "ç": "c",
  "Ð": "D",
  "ð": "d",
  "È": "E",
  "É": "E",
  "Ê": "E",
  "Ë": "E",
  "è": "e",
  "é": "e",
  "ê": "e",
  "ë": "e",
  "Ì": "I",
  "Í": "I",
  "Î": "I",
  "Ï": "I",
  "ì": "i",
  "í": "i",
  "î": "i",
  "ï": "i",
  "Ñ": "N",
  "ñ": "n",
  "Ò": "O",
  "Ó": "O",
  "Ô": "O",
  "Õ": "O",
  "Ö": "O",
  "Ø": "O",
  "ò": "o",
  "ó": "o",
  "ô": "o",
  "õ": "o",
  "ö": "o",
  "ø": "o",
  "Ù": "U",
  "Ú": "U",
  "Û": "U",
  "Ü": "U",
  "ù": "u",
  "ú": "u",
  "û": "u",
  "ü": "u",
  "Ý": "Y",
  "ý": "y",
  "ÿ": "y",
  "Æ": "Ae",
  "æ": "ae",
  "Þ": "Th",
  "þ": "th",
  "ß": "ss",
  // Latin Extended-A block.
  "Ā": "A",
  "Ă": "A",
  "Ą": "A",
  "ā": "a",
  "ă": "a",
  "ą": "a",
  "Ć": "C",
  "Ĉ": "C",
  "Ċ": "C",
  "Č": "C",
  "ć": "c",
  "ĉ": "c",
  "ċ": "c",
  "č": "c",
  "Ď": "D",
  "Đ": "D",
  "ď": "d",
  "đ": "d",
  "Ē": "E",
  "Ĕ": "E",
  "Ė": "E",
  "Ę": "E",
  "Ě": "E",
  "ē": "e",
  "ĕ": "e",
  "ė": "e",
  "ę": "e",
  "ě": "e",
  "Ĝ": "G",
  "Ğ": "G",
  "Ġ": "G",
  "Ģ": "G",
  "ĝ": "g",
  "ğ": "g",
  "ġ": "g",
  "ģ": "g",
  "Ĥ": "H",
  "Ħ": "H",
  "ĥ": "h",
  "ħ": "h",
  "Ĩ": "I",
  "Ī": "I",
  "Ĭ": "I",
  "Į": "I",
  "İ": "I",
  "ĩ": "i",
  "ī": "i",
  "ĭ": "i",
  "į": "i",
  "ı": "i",
  "Ĵ": "J",
  "ĵ": "j",
  "Ķ": "K",
  "ķ": "k",
  "ĸ": "k",
  "Ĺ": "L",
  "Ļ": "L",
  "Ľ": "L",
  "Ŀ": "L",
  "Ł": "L",
  "ĺ": "l",
  "ļ": "l",
  "ľ": "l",
  "ŀ": "l",
  "ł": "l",
  "Ń": "N",
  "Ņ": "N",
  "Ň": "N",
  "Ŋ": "N",
  "ń": "n",
  "ņ": "n",
  "ň": "n",
  "ŋ": "n",
  "Ō": "O",
  "Ŏ": "O",
  "Ő": "O",
  "ō": "o",
  "ŏ": "o",
  "ő": "o",
  "Ŕ": "R",
  "Ŗ": "R",
  "Ř": "R",
  "ŕ": "r",
  "ŗ": "r",
  "ř": "r",
  "Ś": "S",
  "Ŝ": "S",
  "Ş": "S",
  "Š": "S",
  "ś": "s",
  "ŝ": "s",
  "ş": "s",
  "š": "s",
  "Ţ": "T",
  "Ť": "T",
  "Ŧ": "T",
  "ţ": "t",
  "ť": "t",
  "ŧ": "t",
  "Ũ": "U",
  "Ū": "U",
  "Ŭ": "U",
  "Ů": "U",
  "Ű": "U",
  "Ų": "U",
  "ũ": "u",
  "ū": "u",
  "ŭ": "u",
  "ů": "u",
  "ű": "u",
  "ų": "u",
  "Ŵ": "W",
  "ŵ": "w",
  "Ŷ": "Y",
  "ŷ": "y",
  "Ÿ": "Y",
  "Ź": "Z",
  "Ż": "Z",
  "Ž": "Z",
  "ź": "z",
  "ż": "z",
  "ž": "z",
  "Ĳ": "IJ",
  "ĳ": "ij",
  "Œ": "Oe",
  "œ": "oe",
  "ŉ": "'n",
  "ſ": "ss"
};
var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal || freeSelf || Function("return this")();
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index2 = -1, length = array ? array.length : 0;
  while (++index2 < length) {
    accumulator = iteratee(accumulator, array[index2], index2, array);
  }
  return accumulator;
}
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}
function basePropertyOf(object) {
  return function(key) {
    return object == null ? void 0 : object[key];
  };
}
var deburrLetter = basePropertyOf(deburredLetters);
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}
var objectProto = Object.prototype;
var objectToString = objectProto.toString;
var Symbol$1 = root.Symbol;
var symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolToString = symbolProto ? symbolProto.toString : void 0;
function baseToString(value2) {
  if (typeof value2 == "string") {
    return value2;
  }
  if (isSymbol(value2)) {
    return symbolToString ? symbolToString.call(value2) : "";
  }
  var result = value2 + "";
  return result == "0" && 1 / value2 == -Infinity ? "-0" : result;
}
function createCompounder(callback2) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, "")), callback2, "");
  };
}
function isObjectLike(value2) {
  return !!value2 && typeof value2 == "object";
}
function isSymbol(value2) {
  return typeof value2 == "symbol" || isObjectLike(value2) && objectToString.call(value2) == symbolTag;
}
function toString$2(value2) {
  return value2 == null ? "" : baseToString(value2);
}
function deburr(string) {
  string = toString$2(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
}
var kebabCase = createCompounder(function(result, word, index2) {
  return result + (index2 ? "-" : "") + word.toLowerCase();
});
function words(string, pattern, guard) {
  string = toString$2(string);
  pattern = pattern;
  if (pattern === void 0) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}
var lodash_kebabcase = kebabCase;
const kebabCase$1 = /* @__PURE__ */ getDefaultExportFromCjs(lodash_kebabcase);
const itemHeight = 40;
function scrollAreaHeight(items) {
  return items * itemHeight;
}
const _sfc_main$I = defineComponent({
  name: "NavigationBarTree",
  components: {
    ExpansionList,
    NavigationBarLink,
    QExpansionItem: QExpansionItem_default,
    QItem: QItem_default$1,
    QList: QList_default$1,
    QMenu: QMenu_default$1,
    QSkeleton: QSkeleton_default,
    ScrollArea,
    Tooltip: Tooltip2
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    collapsedNavigationbar: {
      type: Boolean,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    transitionDuration: {
      type: Number,
      default: 0
    }
  },
  setup(props4) {
    const {
      collapsed,
      toggleCollapsed
    } = useCollapsed(props4.item.label, !props4.item.defaultOpen);
    const { currentRoute } = useRouter();
    const showMenu = ref$1(false);
    const labelClass = computed(() => `ei-${kebabCase$1(props4.item.label)}`);
    const items = computed(() => unwrap(props4.item.items) ?? []);
    const isActivePath = computed(() => items.value.some((v) => {
      var _a;
      return ((_a = v.to) == null ? void 0 : _a.name) === currentRoute.value.name;
    }));
    function toggleExpand() {
      if (props4.collapsedNavigationbar) {
        showMenu.value = true;
      } else {
        showMenu.value = false;
        toggleCollapsed();
      }
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      collapsed,
      isActivePath,
      items,
      labelClass,
      scrollAreaHeight,
      showMenu,
      toggleExpand
    };
  }
});
const _hoisted_1$B = { class: "row items-center q-ml-lg text-subtitle3 text-primary" };
function _sfc_render$B(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_QSkeleton = resolveComponent("QSkeleton");
  const _component_QItem = resolveComponent("QItem");
  const _component_NavigationBarLink = resolveComponent("NavigationBarLink");
  const _component_ScrollArea = resolveComponent("ScrollArea");
  const _component_QList = resolveComponent("QList");
  const _component_QMenu = resolveComponent("QMenu");
  const _component_ExpansionList = resolveComponent("ExpansionList");
  const _component_QExpansionItem = resolveComponent("QExpansionItem");
  return openBlock(), createBlock(_component_QExpansionItem, {
    class: normalizeClass([
      "expand-block",
      "text-subtitle3",
      _ctx.labelClass,
      _ctx.showMenu && "active",
      _ctx.collapsedNavigationbar && "expand-block--hidden"
    ]),
    "data-automation": _ctx.buildId(),
    "exact-active-class": "expand-block--active",
    "expand-icon": _ctx.items.length || _ctx.item.loading ? "mdi-chevron-down" : "none",
    icon: _ctx.item.icon,
    label: _ctx.item.label,
    "model-value": !_ctx.collapsed,
    style: normalizeStyle({
      "--transition": `opacity ${_ctx.transitionDuration}ms ease-out`,
      "--transition-delay": `${Math.max(_ctx.transitionDuration, 300)}ms`
    }),
    to: _ctx.item.to,
    "onUpdate:modelValue": _ctx.toggleExpand
  }, {
    default: withCtx(() => [
      _ctx.item.tooltip && _ctx.collapsedNavigationbar && !_ctx.showMenu ? (openBlock(), createBlock(_component_Tooltip, {
        key: 0,
        anchor: "center left",
        arrow: "left",
        "data-automation": _ctx.buildId("tooltip"),
        offset: [-40, 0],
        self: "center left",
        target: `.${_ctx.labelClass} .q-icon`
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(_ctx.item.tooltip), 1)
        ]),
        _: 1
      }, 8, ["data-automation", "target"])) : createCommentVNode("", true),
      _ctx.item.loading ? (openBlock(), createBlock(_component_QSkeleton, {
        key: 1,
        class: "q-ml-lg q-mr-md",
        "data-automation": _ctx.buildId("skeleton"),
        square: ""
      }, null, 8, ["data-automation"])) : (openBlock(), createElementBlock(Fragment, { key: 2 }, [
        createVNode(_component_QMenu, {
          modelValue: _ctx.showMenu,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.showMenu = $event),
          anchor: "center right",
          class: normalizeClass(["no-scroll", _ctx.labelClass]),
          self: "top left",
          style: { "width": "220px" },
          target: `.${_ctx.labelClass} .q-icon`
        }, {
          default: withCtx(() => [
            createVNode(_component_QList, null, {
              default: withCtx(() => [
                createVNode(_component_QItem, { class: "menu-title q-pa-none bg-white" }, {
                  default: withCtx(() => [
                    createElementVNode("div", _hoisted_1$B, toDisplayString(_ctx.item.label), 1)
                  ]),
                  _: 1
                }),
                createVNode(_component_ScrollArea, {
                  "no-horizontal": "",
                  style: normalizeStyle({
                    height: `${_ctx.scrollAreaHeight(_ctx.items.length)}px`,
                    maxHeight: "65vh"
                  })
                }, {
                  default: withCtx(() => [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (linkItem) => {
                      return openBlock(), createBlock(_component_NavigationBarLink, {
                        key: linkItem.label,
                        "always-visible": "",
                        "collapsed-navigationbar": _ctx.collapsedNavigationbar,
                        "data-automation": _ctx.buildId(`item-${linkItem.label}`),
                        item: linkItem,
                        menu: ""
                      }, null, 8, ["collapsed-navigationbar", "data-automation", "item"]);
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["style"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "class", "target"]),
        createVNode(_component_ExpansionList, {
          class: "expand-block__list",
          "data-automation": _ctx.buildId("subitems"),
          "expansion-action-class": "expand-block__actions",
          items: _ctx.items,
          limit: _ctx.item.maxItems ?? Number.MAX_SAFE_INTEGER
        }, {
          default: withCtx(({ item: linkItem }) => [
            createVNode(_component_NavigationBarLink, {
              "always-visible": "",
              "collapsed-navigationbar": _ctx.collapsedNavigationbar,
              "data-automation": _ctx.buildId("subitem-link"),
              item: linkItem
            }, null, 8, ["collapsed-navigationbar", "data-automation", "item"])
          ]),
          _: 1
        }, 8, ["data-automation", "items", "limit"])
      ], 64))
    ]),
    _: 1
  }, 8, ["class", "data-automation", "expand-icon", "icon", "label", "model-value", "style", "to", "onUpdate:modelValue"]);
}
const NavigationBarTree = /* @__PURE__ */ _export_sfc$1(_sfc_main$I, [["render", _sfc_render$B], ["__scopeId", "data-v-00f31577"]]);
const _sfc_main$H = defineComponent({
  name: "NavigationBar",
  components: {
    Button,
    Logo: _sfc_main$P,
    NavigationBarLink,
    NavigationBarTree,
    QIcon: QIcon_default$1,
    QList: QList_default$1,
    QSpace: QSpace_default,
    RouterLink,
    ScrollArea,
    Tooltip: Tooltip2
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    helpUrl: {
      type: String,
      default: void 0
    },
    homeRoute: {
      type: [Object, String],
      default: void 0
    },
    items: {
      type: Array,
      required: true
    },
    overlay: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: false
    },
    showToggle: {
      type: Boolean,
      default: false
    }
  },
  emits: ["close-overlay"],
  setup(props4) {
    const { t: t22 } = useI18n();
    const { logoAlignClasses } = useLogo();
    const {
      collapsedNavigationbar,
      collapsedNavigationbarAfterAnimation,
      isSidebarAnimationInprogress,
      toggleNavigationBar
    } = useLayout();
    const { currentRoute } = useRouter();
    const { navigation } = useOptions();
    const isCollapsed = computed(() => {
      return !props4.overlay && !!collapsedNavigationbar.value;
    });
    const navigationComponent = computed(() => navigation.component);
    const navigationBarItems = computed(() => {
      const items = unwrap(props4.items);
      return items.filter((item) => (item == null ? void 0 : item.available) !== false).map((v) => {
        var _a;
        const item = v;
        if ("items" in item) {
          const items2 = (_a = unwrap(item.items)) == null ? void 0 : _a.filter((sub) => sub.available !== false);
          return {
            ...item,
            items: (items2 == null ? void 0 : items2.length) ? items2 : void 0
          };
        } else {
          return item;
        }
      }).filter((item) => item.to || "items" in item && item.items);
    });
    function onToggle() {
      if (isSidebarAnimationInprogress.value) return;
      toggleNavigationBar();
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      collapsedNavigationbarAfterAnimation,
      currentRoute,
      isCollapsed,
      logoAlignClasses,
      navigationBarItems,
      navigationComponent,
      onToggle,
      t: t22,
      toggleNavigationBar,
      transitionDuration: navigation.delayOnSidebarToggle
    };
  }
});
const _hoisted_1$A = ["data-automation"];
const _hoisted_2$r = { class: "navigation-bar__header row items-center" };
const _hoisted_3$n = { class: "navigation-bar__header-item row no-wrap items-center" };
const _hoisted_4$f = { class: "navigation-bar__icon" };
const _hoisted_5$c = { class: "navigation-bar__icon" };
const _hoisted_6$8 = ["data-automation"];
const _hoisted_7$6 = ["data-automation"];
const _hoisted_8$3 = ["href"];
const _hoisted_9$2 = { class: "navigation-bar__label text-subtitle3" };
function _sfc_render$A(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = resolveComponent("Button");
  const _component_Logo = resolveComponent("Logo");
  const _component_NavigationBarTree = resolveComponent("NavigationBarTree");
  const _component_NavigationBarLink = resolveComponent("NavigationBarLink");
  const _component_QList = resolveComponent("QList");
  const _component_ScrollArea = resolveComponent("ScrollArea");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_Tooltip = resolveComponent("Tooltip");
  return openBlock(), createElementBlock("div", {
    class: "navigation-bar column no-wrap bg-white full-height",
    "data-automation": _ctx.buildId(),
    style: normalizeStyle({
      "--logo-transition": `opacity ${_ctx.transitionDuration ?? 200}ms ease-out`,
      "--transition-delay": `${_ctx.transitionDuration && _ctx.transitionDuration > 150 ? 0 : 150}ms`
    })
  }, [
    createElementVNode("div", _hoisted_2$r, [
      createElementVNode("div", _hoisted_3$n, [
        createElementVNode("div", _hoisted_4$f, [
          !_ctx.overlay || _ctx.showToggle ? (openBlock(), createBlock(_component_Button, {
            key: 0,
            class: "no-padding",
            color: "black-1",
            "data-automation": _ctx.buildId("menu"),
            icon: "mdi-menu",
            tertiary: "",
            onClick: _ctx.onToggle
          }, null, 8, ["data-automation", "onClick"])) : createCommentVNode("", true)
        ]),
        (openBlock(), createBlock(resolveDynamicComponent(_ctx.homeRoute ? "RouterLink" : "div"), {
          class: normalizeClass(["navigation-bar__logo-wrapper q-py-none q-px-lg", [
            _ctx.logoAlignClasses,
            { "navigation-bar__logo-wrapper--hidden": _ctx.isCollapsed }
          ]]),
          "data-automation": _ctx.buildId("link"),
          to: _ctx.homeRoute
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "logo", {}, () => [
              createVNode(_component_Logo, {
                class: "navigation-bar__logo",
                "data-automation": _ctx.buildId("logo"),
                name: "regular"
              }, null, 8, ["data-automation"])
            ], true)
          ]),
          _: 3
        }, 8, ["class", "data-automation", "to"])),
        createElementVNode("div", _hoisted_5$c, [
          _ctx.showClose && _ctx.overlay ? (openBlock(), createBlock(_component_Button, {
            key: 0,
            class: "no-padding",
            color: "black-1",
            "data-automation": _ctx.buildId("close"),
            icon: "mdi-close",
            tertiary: "",
            onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("close-overlay"))
          }, null, 8, ["data-automation"])) : createCommentVNode("", true)
        ])
      ])
    ]),
    _ctx.navigationComponent ? (openBlock(), createBlock(resolveDynamicComponent(_ctx.navigationComponent), {
      key: 0,
      collapsed: _ctx.isCollapsed,
      "collapsed-after-animation": _ctx.collapsedNavigationbarAfterAnimation,
      "help-url": _ctx.helpUrl,
      items: _ctx.items
    }, null, 8, ["collapsed", "collapsed-after-animation", "help-url", "items"])) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
      createVNode(_component_ScrollArea, {
        class: "navigation-bar__content fit",
        "data-automation": _ctx.buildId("content"),
        "no-horizontal": ""
      }, {
        default: withCtx(() => [
          createVNode(_component_QList, {
            class: normalizeClass({ "navigation-bar__list--active": _ctx.isCollapsed })
          }, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.navigationBarItems, (item) => {
                return openBlock(), createElementBlock(Fragment, {
                  key: item.label
                }, [
                  "items" in item ? (openBlock(), createBlock(_component_NavigationBarTree, {
                    key: 0,
                    "collapsed-navigationbar": _ctx.isCollapsed,
                    "data-automation": _ctx.buildId(`item-tree-${item.label}`),
                    item,
                    "transition-duration": _ctx.transitionDuration
                  }, null, 8, ["collapsed-navigationbar", "data-automation", "item", "transition-duration"])) : (openBlock(), createBlock(_component_NavigationBarLink, {
                    key: 1,
                    "collapsed-navigationbar": _ctx.isCollapsed,
                    "data-automation": _ctx.buildId(`item-link-${item.label}`),
                    item,
                    "transition-duration": _ctx.transitionDuration
                  }, null, 8, ["collapsed-navigationbar", "data-automation", "item", "transition-duration"]))
                ], 64);
              }), 128))
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _: 1
      }, 8, ["data-automation"]),
      _ctx.helpUrl ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: "navigation-bar__footer row items-center",
        "data-automation": _ctx.buildId("footer")
      }, [
        createElementVNode("div", {
          "data-automation": _ctx.buildId("help")
        }, [
          createElementVNode("a", {
            class: "navigation-bar__item row no-wrap items-center",
            href: _ctx.helpUrl,
            target: "_blank"
          }, [
            createVNode(_component_QIcon, {
              class: "navigation-bar__icon",
              name: "mdi-help-circle",
              size: "1.5rem"
            }),
            createElementVNode("div", _hoisted_9$2, toDisplayString(_ctx.t("rvai-base.general.help.title")), 1)
          ], 8, _hoisted_8$3),
          createVNode(_component_Tooltip, {
            anchor: "center right",
            arrow: "left",
            "data-automation": _ctx.buildId("help__tooltip"),
            self: "center left"
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(_ctx.t("rvai-base.general.help.hint")), 1)
            ]),
            _: 1
          }, 8, ["data-automation"])
        ], 8, _hoisted_7$6)
      ], 8, _hoisted_6$8)) : createCommentVNode("", true)
    ], 64))
  ], 12, _hoisted_1$A);
}
const NavigationBar = /* @__PURE__ */ _export_sfc$1(_sfc_main$H, [["render", _sfc_render$A], ["__scopeId", "data-v-30345922"]]);
const _sfc_main$G = defineComponent({
  name: "NavigationBarOverlay",
  components: {
    NavigationBar
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    items: {
      type: Array,
      required: true
    }
  },
  setup(props4) {
    const {
      showOverlay,
      toggleShowOverlay
    } = useLayout();
    const overlayRef = ref$1(null);
    function closeOverlay() {
      toggleShowOverlay(false);
    }
    onMounted(() => {
      toggleShowOverlay(false);
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      closeOverlay,
      overlayRef,
      showOverlay
    };
  }
});
const _hoisted_1$z = ["data-automation"];
function _sfc_render$z(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NavigationBar = resolveComponent("NavigationBar");
  return withDirectives((openBlock(), createElementBlock("div", {
    ref: "overlayRef",
    class: "navigation-bar-overlay",
    "data-automation": _ctx.buildId()
  }, [
    createVNode(_component_NavigationBar, mergeProps(_ctx.$attrs, {
      "data-automation": _ctx.buildId("navigationBar"),
      items: _ctx.items,
      overlay: "",
      "show-close": "",
      onCloseOverlay: _ctx.closeOverlay
    }), null, 16, ["data-automation", "items", "onCloseOverlay"])
  ], 8, _hoisted_1$z)), [
    [vShow, _ctx.showOverlay]
  ]);
}
const NavigationBarOverlay = /* @__PURE__ */ _export_sfc$1(_sfc_main$G, [["render", _sfc_render$z], ["__scopeId", "data-v-5a0051d1"]]);
const _sfc_main$F = defineComponent({
  name: "OptionGroup",
  components: {
    Checkbox,
    EllipsisText,
    QIntersection: QIntersection_default,
    QSpace: QSpace_default,
    Radio,
    Toggle
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Option item class
     */
    itemClass: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * A text label above the Option Group
     */
    label: {
      type: String,
      default: void 0
    },
    /**
     * Model of the component; Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
     */
    modelValue: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Property of option which holds the 'label'; If using a function then for best performance, reference it from your scope and do not define it inline
     */
    optionLabel: {
      type: String,
      default: "label"
    },
    /**
     * Available options that the user can select from.
     */
    options: {
      type: Array,
      required: true
    },
    /**
     * Property of option which holds the 'value'; If using a function then for best performance, reference it from your scope and do not define it inline
     */
    optionValue: {
      type: String,
      default: "value"
    },
    /**
     * Put component in readonly mode
     */
    readonly: {
      type: Boolean,
      default: false
    },
    /**
     * Adds separator between options
     */
    separator: {
      type: Boolean,
      default: false
    },
    /**
     * Shows select all checkbox
     */
    showSelectAll: {
      type: Boolean,
      default: false
    },
    /**
     * Shows selector on hover
     */
    showSelectorOnHover: {
      type: Boolean,
      default: false
    },
    /**
     * Checkboxes or radio buttons
     */
    type: {
      type: String,
      default: "checkbox"
    },
    /**
     * Wraps each option with QIntersection
     */
    withIntersection: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue"],
  setup(props4, { emit }) {
    const { t: t22 } = useI18n();
    const allSelected = computed(() => {
      if (!Array.isArray(props4.modelValue)) return false;
      const total = props4.options.length;
      const selected2 = props4.modelValue.length;
      if (total === 0) return false;
      if (total === selected2) return true;
      if (selected2) return void 0;
      return false;
    });
    function isOptionSelected(option) {
      return selected.value === option[props4.optionValue] || Array.isArray(selected.value) && selected.value.includes(option[props4.optionValue]);
    }
    function isSeparatorVisible(index2) {
      return props4.separator && index2 !== props4.options.length - 1;
    }
    const selected = computed({
      get() {
        return props4.modelValue;
      },
      set(value2) {
        emit("update:modelValue", value2);
      }
    });
    function toggleAllSelected(value2) {
      const selected2 = value2 ? props4.options.map((x22) => x22[props4.optionValue]) : [];
      emit("update:modelValue", selected2);
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      allSelected,
      isOptionSelected,
      isSeparatorVisible,
      selected,
      t: t22,
      toggleAllSelected
    };
  }
});
const _hoisted_1$y = ["data-automation"];
const _hoisted_2$q = ["data-automation"];
const _hoisted_3$m = ["data-automation"];
const _hoisted_4$e = { class: "rv-option-group__item-selector row justify-center q-mr-sm" };
const _hoisted_5$b = ["data-automation"];
function _sfc_render$y(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_Checkbox = resolveComponent("Checkbox");
  const _component_QSpace = resolveComponent("QSpace");
  const _component_Radio = resolveComponent("Radio");
  const _component_Toggle = resolveComponent("Toggle");
  return openBlock(), createElementBlock("div", {
    class: "rv-option-group column q-gutter-y-sm",
    "data-automation": _ctx.buildId()
  }, [
    _ctx.label ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass(["rv-option-group__label row no-wrap items-center full-width", { "rv-option-group__label--disable": _ctx.disable }]),
      "data-automation": _ctx.buildId("label")
    }, [
      createVNode(_component_EllipsisText, {
        class: "text-subtitle3",
        "data-automation": _ctx.buildId("label__text")
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(_ctx.label), 1)
        ]),
        _: 1
      }, 8, ["data-automation"])
    ], 10, _hoisted_2$q)) : createCommentVNode("", true),
    _ctx.showSelectAll && _ctx.type === "checkbox" ? (openBlock(), createElementBlock("label", {
      key: 1,
      class: normalizeClass(["rv-option-group__item row no-wrap", { "cursor-pointer": !_ctx.disable }]),
      "data-automation": _ctx.buildId("option-select-all")
    }, [
      createElementVNode("div", _hoisted_4$e, [
        createVNode(_component_Checkbox, {
          "data-automation": _ctx.buildId("selectAll"),
          dense: "",
          disable: _ctx.disable,
          "model-value": _ctx.allSelected,
          "onUpdate:modelValue": _ctx.toggleAllSelected
        }, null, 8, ["data-automation", "disable", "model-value", "onUpdate:modelValue"])
      ]),
      createElementVNode("div", {
        class: normalizeClass(["rv-option-group__item-label row no-wrap full-width", {
          "border-bottom q-pb-sm": _ctx.separator,
          "rv-option-group__item-label--disable": _ctx.disable
        }])
      }, [
        createVNode(_component_EllipsisText, {
          class: normalizeClass(["rv-option-group__text zero-min-width", [
            _ctx.itemClass,
            {
              "rv-option-group__item-label--disable": _ctx.disable
            }
          ]]),
          "data-automation": _ctx.buildId("selectAll__label"),
          text: _ctx.t("rvai-base.general.actions.selectAll")
        }, null, 8, ["class", "data-automation", "text"]),
        createVNode(_component_QSpace),
        _ctx.$slots["select-all-actions"] ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "q-ml-sm",
          "data-automation": _ctx.buildId("select-all-actions")
        }, [
          renderSlot(_ctx.$slots, "select-all-actions", {}, void 0, true)
        ], 8, _hoisted_5$b)) : createCommentVNode("", true)
      ], 2)
    ], 10, _hoisted_3$m)) : createCommentVNode("", true),
    renderSlot(_ctx.$slots, "before-options", {}, void 0, true),
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, (opt, index2) => {
      return openBlock(), createBlock(resolveDynamicComponent(_ctx.withIntersection ? "QIntersection" : "label"), {
        key: opt[_ctx.optionValue],
        class: normalizeClass(["rv-option-group__item row no-wrap full-width", {
          "cursor-pointer": !_ctx.disable && !opt.disable && !_ctx.readonly,
          "rv-option-group__item-intersection": _ctx.withIntersection
        }]),
        "data-automation": _ctx.buildId(`option-${opt[_ctx.optionValue]}`),
        "transition-duration": 0
      }, {
        default: withCtx(() => [
          createElementVNode("div", {
            class: normalizeClass(["rv-option-group__item-selector row justify-center q-mr-sm", {
              "rv-option-group__item-selector--toggle": _ctx.type === "toggle",
              "rv-option-group__item-selector--show-on-hover": _ctx.showSelectorOnHover && !_ctx.isOptionSelected(opt)
            }])
          }, [
            !_ctx.readonly ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
              _ctx.type === "checkbox" ? (openBlock(), createBlock(_component_Checkbox, {
                key: 0,
                modelValue: _ctx.selected,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.selected = $event),
                "data-automation": _ctx.buildId(`option-${opt[_ctx.optionValue]}__checkbox`),
                dense: "",
                disable: !!(_ctx.disable || opt.disable),
                val: opt[_ctx.optionValue]
              }, null, 8, ["modelValue", "data-automation", "disable", "val"])) : _ctx.type === "radio" ? (openBlock(), createBlock(_component_Radio, {
                key: 1,
                modelValue: _ctx.selected,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.selected = $event),
                "data-automation": _ctx.buildId(`option-${opt[_ctx.optionValue]}__radio`),
                dense: "",
                disable: !!(_ctx.disable || opt.disable),
                val: opt[_ctx.optionValue]
              }, null, 8, ["modelValue", "data-automation", "disable", "val"])) : _ctx.type === "toggle" ? (openBlock(), createBlock(_component_Toggle, {
                key: 2,
                modelValue: _ctx.selected,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.selected = $event),
                "data-automation": _ctx.buildId(`option-${opt[_ctx.optionValue]}__toggle`),
                disable: !!(_ctx.disable || opt.disable),
                val: opt[_ctx.optionValue]
              }, null, 8, ["modelValue", "data-automation", "disable", "val"])) : createCommentVNode("", true)
            ], 64)) : createCommentVNode("", true)
          ], 2),
          createElementVNode("div", {
            class: normalizeClass(["rv-option-group__item-label row no-wrap items-center", [
              _ctx.itemClass,
              {
                "border-bottom": _ctx.isSeparatorVisible(index2),
                "q-pb-sm": _ctx.separator || _ctx.type === "toggle",
                "rv-option-group__item-label--disable": _ctx.disable || opt.disable,
                "rv-option-group__item-label--toggle": _ctx.type === "toggle"
              }
            ]])
          }, [
            renderSlot(_ctx.$slots, "label", { option: opt }, () => [
              createVNode(_component_EllipsisText, {
                class: "rv-option-group__text",
                "data-automation": _ctx.buildId("option"),
                "data-automation-value": opt[_ctx.optionValue],
                text: opt[_ctx.optionLabel]
              }, null, 8, ["data-automation", "data-automation-value", "text"]),
              createVNode(_component_QSpace),
              renderSlot(_ctx.$slots, "after-label", { option: opt }, void 0, true)
            ], true)
          ], 2)
        ]),
        _: 2
      }, 1032, ["class", "data-automation"]);
    }), 128)),
    renderSlot(_ctx.$slots, "after-options", {}, void 0, true)
  ], 8, _hoisted_1$y);
}
const OptionGroup = /* @__PURE__ */ _export_sfc$1(_sfc_main$F, [["render", _sfc_render$y], ["__scopeId", "data-v-8928d21b"]]);
const _sfc_main$E = defineComponent({
  name: "Bullet",
  components: {
    ActionButton,
    Input,
    Select
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      default: "pagination",
      type: String
    },
    /**
     * Put navigation buttons into disabled state
     */
    loading: {
      default: false,
      type: Boolean
    },
    /**
     * Set page size options to make it managable
     */
    pageSizeOptions: {
      default: () => [],
      type: Array
    }
  },
  setup(props4) {
    const {
      canNavigate,
      goToFirstPage,
      goToLastPage,
      goToNextPage,
      goToPreviousPage,
      hasNextPage,
      hasPreviousPage,
      newPage,
      onBlur: onBlur2,
      pageCount,
      pageSize,
      pageValue,
      setPageSize
    } = usePagination();
    const input = ref$1(null);
    const disableInput = computed(() => props4.loading || !canNavigate.value);
    const disableNext = computed(() => props4.loading || !hasNextPage.value);
    const disablePrevious = computed(() => props4.loading || !hasPreviousPage.value);
    const inputWidth = computed(() => {
      const paddingX = 16;
      const pixelsPerNumber = 8;
      const minWidth = 38;
      return Math.max(String(pageCount.value).length * pixelsPerNumber + paddingX, minWidth);
    });
    function onEnter() {
      var _a;
      (_a = input.value) == null ? void 0 : _a.blur();
    }
    function onKeyPress(e22) {
      const onlyDigits = /\d/g;
      if (!onlyDigits.test(e22.key)) e22.preventDefault();
    }
    function onGlobalKeyUp(e22) {
      if (isInputElement(document.activeElement)) return;
      switch (e22.key) {
        case KEY_ARROW_LEFT:
          if (hasPreviousPage.value) {
            goToPreviousPage();
          }
          return;
        case KEY_ARROW_RIGHT:
          if (hasNextPage.value) {
            goToNextPage();
          }
      }
    }
    onMounted(() => {
      document.addEventListener("keyup", onGlobalKeyUp, false);
      if (props4.pageSizeOptions.length && !props4.pageSizeOptions.includes(pageSize.value)) {
        setPageSize(props4.pageSizeOptions[0]);
      }
    });
    onUnmounted(() => {
      document.removeEventListener("keyup", onGlobalKeyUp, false);
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      disableInput,
      disableNext,
      disablePrevious,
      goToFirstPage,
      goToLastPage,
      goToNextPage,
      goToPreviousPage,
      input,
      inputWidth,
      newPage,
      onBlur: onBlur2,
      onEnter,
      onKeyPress,
      pageCount,
      pageSize,
      pageValue,
      setPageSize
    };
  }
});
const _hoisted_1$x = ["data-automation"];
const _hoisted_2$p = ["data-automation"];
const _hoisted_3$l = ["data-automation"];
function _sfc_render$x(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ActionButton = resolveComponent("ActionButton");
  const _component_Input = resolveComponent("Input");
  const _component_Select = resolveComponent("Select");
  return openBlock(), createElementBlock("div", {
    class: "pagination row no-wrap items-center q-gutter-xs text-grey-1",
    "data-automation": _ctx.buildId(),
    style: normalizeStyle({ "--input-width": `${_ctx.inputWidth}px` })
  }, [
    createVNode(_component_ActionButton, {
      class: "pagination__first-page text-grey-1",
      "data-automation": _ctx.buildId("first-page"),
      disable: _ctx.disablePrevious,
      icon: "mdi-chevron-double-left",
      onClick: _ctx.goToFirstPage
    }, null, 8, ["data-automation", "disable", "onClick"]),
    createVNode(_component_ActionButton, {
      class: "pagination__previous-page text-grey-1",
      "data-automation": _ctx.buildId("previous-page"),
      disable: _ctx.disablePrevious,
      icon: "mdi-chevron-left",
      onClick: _ctx.goToPreviousPage
    }, null, 8, ["data-automation", "disable", "onClick"]),
    createElementVNode("div", {
      class: "pagination__current-page row no-wrap items-center",
      "data-automation": _ctx.buildId("current-page")
    }, [
      createVNode(_component_Input, {
        ref: "input",
        modelValue: _ctx.newPage,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.newPage = $event),
        class: "pagination__new-page",
        "data-automation": _ctx.buildId("page-input"),
        dense: "",
        disable: _ctx.disableInput,
        "input-class": "pagination__input text-center",
        placeholder: _ctx.pageValue,
        type: "number",
        onBlur: _ctx.onBlur,
        onKeypress: _ctx.onKeyPress,
        onKeyup: withKeys(_ctx.onEnter, ["enter"])
      }, null, 8, ["modelValue", "data-automation", "disable", "placeholder", "onBlur", "onKeypress", "onKeyup"]),
      createElementVNode("div", {
        class: normalizeClass(["pagination__page-count text-subtitle3 text-no-wrap q-ml-sm", { "pagination__page-count--disable": _ctx.disableInput }]),
        "data-automation": _ctx.buildId("page-count")
      }, toDisplayString(_ctx.$t("rvai-base.general.symbols.slash")) + " " + toDisplayString(_ctx.pageCount), 11, _hoisted_3$l)
    ], 8, _hoisted_2$p),
    createVNode(_component_ActionButton, {
      class: "pagination__next-page text-grey-1",
      "data-automation": _ctx.buildId("next-page"),
      disable: _ctx.disableNext,
      icon: "mdi-chevron-right",
      onClick: _ctx.goToNextPage
    }, null, 8, ["data-automation", "disable", "onClick"]),
    createVNode(_component_ActionButton, {
      class: "pagination__last-page text-grey-1",
      "data-automation": _ctx.buildId("last-page"),
      disable: _ctx.disableNext,
      icon: "mdi-chevron-double-right",
      onClick: _ctx.goToLastPage
    }, null, 8, ["data-automation", "disable", "onClick"]),
    _ctx.pageSizeOptions.length ? (openBlock(), createBlock(_component_Select, {
      key: 0,
      "data-automation": _ctx.buildId("page-size"),
      "model-value": _ctx.pageSize,
      options: _ctx.pageSizeOptions,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.setPageSize($event))
    }, null, 8, ["data-automation", "model-value", "options"])) : createCommentVNode("", true)
  ], 12, _hoisted_1$x);
}
const Pagination = /* @__PURE__ */ _export_sfc$1(_sfc_main$E, [["render", _sfc_render$x], ["__scopeId", "data-v-19f65d61"]]);
const _sfc_main$D = defineComponent({
  name: "PrivacyPolicyDialog",
  components: {
    Button,
    QCard: QCard_default$1,
    QCardSection: QCardSection_default$1,
    QDialog: QDialog_default$1
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: "privacyPolicyDialog"
    },
    /**
     * Provide privacy policy URL to open in the iframe
     */
    privacyPolicyUrl: {
      type: String,
      required: true
    }
  },
  emits: [
    ...useDialogPluginComponent.emits
  ],
  setup(props4) {
    const {
      dialogRef,
      onDialogCancel,
      onDialogHide
    } = useDialogPluginComponent();
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      dialogRef,
      onCancel: onDialogCancel,
      onHide: onDialogHide
    };
  }
});
const _hoisted_1$w = ["src"];
function _sfc_render$w(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = resolveComponent("Button");
  const _component_QCardSection = resolveComponent("QCardSection");
  const _component_QCard = resolveComponent("QCard");
  const _component_QDialog = resolveComponent("QDialog");
  const _directive_quasar_variables = resolveDirective("quasar-variables");
  return openBlock(), createBlock(_component_QDialog, mergeProps({
    ref: "dialogRef",
    "data-automation": _ctx.buildId(),
    maximized: ""
  }, toHandlers(_ctx.$attrs), { onHide: _ctx.onHide }), {
    default: withCtx(() => [
      createVNode(_component_QCard, { class: "rv-privacy-policy-dialog column no-wrap" }, {
        default: withCtx(() => [
          createVNode(_component_QCardSection, { class: "q-pb-none flex justify-end" }, {
            default: withCtx(() => [
              createVNode(_component_Button, {
                icon: "mdi-close",
                tertiary: "",
                onClick: _ctx.onCancel
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }),
          createVNode(_component_QCardSection, { class: "full-width full-height" }, {
            default: withCtx(() => [
              withDirectives(createElementVNode("iframe", {
                frameborder: "0",
                height: "100%",
                src: _ctx.privacyPolicyUrl,
                width: "100%"
              }, null, 8, _hoisted_1$w), [
                [_directive_quasar_variables]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 16, ["data-automation", "onHide"]);
}
const PrivacyPolicyDialog = /* @__PURE__ */ _export_sfc$1(_sfc_main$D, [["render", _sfc_render$w]]);
const _sfc_main$C = defineComponent({
  name: "TermsAndConditionsDialog",
  components: {
    Button,
    QCard: QCard_default$1,
    QCardSection: QCardSection_default$1,
    QDialog: QDialog_default$1
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: "termsAndConditionsDialog"
    },
    /**
     * Provide rems and conditions URL to open in the iframe
     */
    termsAndConditionsUrl: {
      type: String,
      required: true
    }
  },
  emits: [
    ...useDialogPluginComponent.emits
  ],
  setup(props4) {
    const {
      dialogRef,
      onDialogCancel,
      onDialogHide
    } = useDialogPluginComponent();
    const { t: t22 } = useI18n();
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      dialogRef,
      onCancel: onDialogCancel,
      onHide: onDialogHide,
      t: t22
    };
  }
});
const _hoisted_1$v = { class: "rv-terms-and-conditions-dialog__subtitle text-subtitle1 full-width" };
const _hoisted_2$o = ["src"];
function _sfc_render$v(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = resolveComponent("Button");
  const _component_QCardSection = resolveComponent("QCardSection");
  const _component_QCard = resolveComponent("QCard");
  const _component_QDialog = resolveComponent("QDialog");
  const _directive_quasar_variables = resolveDirective("quasar-variables");
  return openBlock(), createBlock(_component_QDialog, mergeProps({
    ref: "dialogRef",
    "data-automation": _ctx.buildId(),
    maximized: ""
  }, toHandlers(_ctx.$attrs), { onHide: _ctx.onHide }), {
    default: withCtx(() => [
      createVNode(_component_QCard, { class: "rv-terms-and-conditions-dialog column no-wrap overflow-hidden" }, {
        default: withCtx(() => [
          createVNode(_component_QCardSection, { class: "q-pb-none flex justify-end" }, {
            default: withCtx(() => [
              createVNode(_component_Button, {
                icon: "mdi-close",
                tertiary: "",
                onClick: _ctx.onCancel
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }),
          createVNode(_component_QCardSection, { class: "row flex-center q-mx-lg" }, {
            default: withCtx(() => [
              createElementVNode("span", _hoisted_1$v, toDisplayString(_ctx.t("rvai-base.policiesAndLicenses.titles.termsAndConditions")), 1)
            ]),
            _: 1
          }),
          createVNode(_component_QCardSection, { class: "full-width full-height q-mx-lg q-pb-none" }, {
            default: withCtx(() => [
              withDirectives(createElementVNode("iframe", {
                frameborder: "0",
                height: "100%",
                src: _ctx.termsAndConditionsUrl,
                width: "100%"
              }, null, 8, _hoisted_2$o), [
                [_directive_quasar_variables]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 16, ["data-automation", "onHide"]);
}
const TermsAndConditionsDialog = /* @__PURE__ */ _export_sfc$1(_sfc_main$C, [["render", _sfc_render$v], ["__scopeId", "data-v-e2a1a073"]]);
const _sfc_main$B = defineComponent({
  name: "PoliciesAndLicenses",
  components: {
    Button
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: "policiesAndLicenses"
    },
    /**
     * Provide cookies label for accept button
     */
    cookiesAcceptBtn: {
      type: String,
      default: void 0
    },
    /**
     * Provide cookies label for reject button
     */
    cookiesRejectBtn: {
      type: String,
      default: void 0
    },
    /**
     * Provide cookies title
     */
    cookiesTitle: {
      type: String,
      default: void 0
    },
    /**
     * Provide cookies URL to open in the iframe
     */
    cookiesUrl: {
      type: String,
      required: true
    },
    /**
     * Provide cookies dialog width
     */
    cookiesWidth: {
      type: String,
      default: "420px"
    },
    /**
     * Provide privacy policy URL to open in the iframe
     */
    privacyPolicyUrl: {
      type: String,
      required: true
    },
    /**
     * Provide rems and conditions URL to open in the iframe
     */
    termsAndConditionsUrl: {
      type: String,
      required: true
    },
    /**
     * Provide title
     */
    title: {
      default: void 0,
      type: String
    }
  },
  emits: ["on-title-click"],
  setup(props4) {
    const { hasCookiesPolicy } = useCookiesPolicy();
    const $q = useQuasar();
    const { t: t22 } = useI18n();
    const options = [
      {
        action: onOpenCookiesDialog,
        title: t22("rvai-base.policiesAndLicenses.actions.cookies.open")
      },
      {
        action: onOpenPrivacyPolicyDialog,
        title: t22("rvai-base.policiesAndLicenses.actions.privacyPolicy.open")
      },
      {
        action: onOpenTermsAndConditionsDialog,
        title: t22("rvai-base.policiesAndLicenses.actions.termsAndConditions.open")
      }
    ];
    function onOpenCookiesDialog() {
      $q.dialog({
        component: CookiesDialog,
        componentProps: {
          cookiesAcceptBtn: props4.cookiesAcceptBtn,
          cookiesRejectBtn: props4.cookiesRejectBtn,
          cookiesTitle: props4.cookiesTitle,
          cookiesUrl: props4.cookiesUrl,
          cookiesWidth: props4.cookiesWidth
        }
      });
    }
    function onOpenPrivacyPolicyDialog() {
      $q.dialog({
        component: PrivacyPolicyDialog,
        componentProps: {
          privacyPolicyUrl: props4.privacyPolicyUrl
        }
      });
    }
    function onOpenTermsAndConditionsDialog() {
      $q.dialog({
        component: TermsAndConditionsDialog,
        componentProps: {
          termsAndConditionsUrl: props4.termsAndConditionsUrl
        }
      });
    }
    onMounted(() => {
      if (!hasCookiesPolicy.value) {
        void nextTick(onOpenCookiesDialog);
      }
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      options,
      t: t22
    };
  }
});
const _hoisted_1$u = ["data-automation"];
const _hoisted_2$n = { class: "text-subtitle3" };
const _hoisted_3$k = { class: "flex flex-center full-width" };
const _hoisted_4$d = ["onClick"];
function _sfc_render$u(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = resolveComponent("Button");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["rv-policies-and-licenses flex column items-center full-width", {
      "rv-policies-and-licenses--with-title": _ctx.title,
      "justify-center": !_ctx.title
    }]),
    "data-automation": _ctx.buildId()
  }, [
    _ctx.title ? (openBlock(), createBlock(_component_Button, {
      key: 0,
      class: "q-mt-lg",
      "data-automation": _ctx.buildId("title"),
      size: "md",
      tertiary: "",
      onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("on-title-click"))
    }, {
      default: withCtx(() => [
        createElementVNode("span", _hoisted_2$n, toDisplayString(_ctx.title), 1)
      ]),
      _: 1
    }, 8, ["data-automation"])) : createCommentVNode("", true),
    createElementVNode("div", _hoisted_3$k, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, (option, index2) => {
        return openBlock(), createElementBlock(Fragment, {
          key: option.title
        }, [
          createElementVNode("span", {
            class: "rv-policies-and-licenses__action text-body2",
            onClick: option.action
          }, toDisplayString(option.title), 9, _hoisted_4$d),
          index2 !== _ctx.options.length - 1 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createTextVNode(toDisplayString(_ctx.t("rvai-base.general.symbols.pipe")), 1)
          ], 64)) : createCommentVNode("", true)
        ], 64);
      }), 128))
    ])
  ], 10, _hoisted_1$u);
}
const PoliciesAndLicenses = /* @__PURE__ */ _export_sfc$1(_sfc_main$B, [["render", _sfc_render$u], ["__scopeId", "data-v-ae47d7a9"]]);
const _sfc_main$A = defineComponent({
  name: "Range",
  components: {
    EllipsisText,
    Input,
    QIcon: QIcon_default$1,
    QRange: QRange_default,
    Tooltip: Tooltip2
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Render info icon with tooltip. Can be used as an "info-text" property or as a slot
     */
    infoText: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to the info text
     */
    infoTextClass: {
      type: String,
      default: ""
    },
    /**
     * How many numbers show after comma for float numbers
     * @type {number}
     */
    inputDecimals: {
      type: Number,
      default: void 0
    },
    /**
     * The text that will be shown above the input
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Classes applied to the label
     * @type {[Array, Object, String]}
     */
    labelClass: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Maximum value of the model; Set track's maximum value
     */
    max: {
      type: Number,
      default: 100
    },
    /**
     * Minimum value of the model; Set track's minimum value
     */
    min: {
      type: Number,
      default: 0
    },
    /**
     * Label to show instead of minimum value
     */
    minLabel: {
      type: String,
      default: ""
    },
    /**
     * Model of the component of type { min, max } (both values must be between global min/max); Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
     */
    modelValue: {
      type: Object,
      required: true
    },
    /**
     * The text that will be shown next to label
     */
    optionalLabel: {
      type: String,
      default: ""
    },
    /**
     * Shows min and max values around slider
     */
    showMinMax: {
      type: Boolean,
      default: true
    },
    /**
     * Show optional label next to label
     */
    showOptionalLabel: {
      type: Boolean,
      default: false
    },
    /**
     * Popup a label when user clicks/taps on the slider thumb and moves it
     */
    showPinLabel: {
      type: Boolean,
      default: true
    },
    /**
       * Specify step amount between valid values (> 0.0); When step equals to 0 it defines infinite granularity
       */
    step: {
      type: Number,
      default: 1
    },
    /**
     * Allow setting the values via input fields
     */
    withInput: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    /**
     * Emitted when the component needs to change the model; Is also used by v-model
     *
     * @type {RangeModel}
     */
    "update:modelValue"
  ],
  setup(props4, { emit }) {
    const maxValueString = ref$1(String(props4.modelValue.max));
    const minValueString = ref$1(String(props4.modelValue.min));
    function getParsedValue(value2) {
      const parsed = props4.inputDecimals && value2 ? truncateNumber(parseFloat(value2), props4.inputDecimals) : roundToStep(Number(value2), props4.step);
      if (isNaN(parsed)) {
        return NaN;
      }
      if (parsed < props4.min) {
        return props4.min;
      }
      if (parsed > props4.max) {
        return props4.max;
      }
      return parsed;
    }
    function onMinInputBlur() {
      const parsed = getParsedValue(minValueString.value);
      if (isNaN(parsed)) {
        minValueString.value = String(props4.modelValue.min);
        return;
      }
      const newModelValue = { ...props4.modelValue };
      if (parsed > props4.modelValue.max) {
        newModelValue.max = parsed;
        newModelValue.min = props4.modelValue.max;
      } else {
        newModelValue.min = parsed;
      }
      emit("update:modelValue", newModelValue);
    }
    function onMaxInputBlur() {
      const parsed = getParsedValue(maxValueString.value);
      if (isNaN(parsed)) {
        maxValueString.value = String(props4.modelValue.max);
        return;
      }
      const newModelValue = { ...props4.modelValue };
      if (parsed < props4.modelValue.min) {
        newModelValue.max = props4.modelValue.min;
        newModelValue.min = parsed;
      } else {
        newModelValue.max = parsed;
      }
      emit("update:modelValue", newModelValue);
    }
    watch(() => props4.modelValue, (value2) => {
      minValueString.value = String(value2.min);
      maxValueString.value = String(value2.max);
    }, { immediate: true });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      maxValueString,
      minValueString,
      onMaxInputBlur,
      onMinInputBlur
    };
  }
});
const _hoisted_1$t = ["data-automation"];
const _hoisted_2$m = ["data-automation"];
const _hoisted_3$j = { class: "row no-wrap items-center full-width" };
const _hoisted_4$c = {
  key: 0,
  class: "q-ml-xs"
};
const _hoisted_5$a = { class: "row items-center no-wrap" };
const _hoisted_6$7 = { class: "q-mr-md col-fixed" };
const _hoisted_7$5 = { class: "q-ml-md col-fixed" };
function _sfc_render$t(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_Input = resolveComponent("Input");
  const _component_QRange = resolveComponent("QRange");
  return openBlock(), createElementBlock("div", mergeProps(_ctx.dataAttrs, {
    class: ["rv-range", { "rv-range--with-input": _ctx.withInput }],
    "data-automation": _ctx.buildId()
  }), [
    _ctx.label ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass(["rv-slider__label flex justify-between items-center", _ctx.labelClass]),
      "data-automation": _ctx.buildId("label-container")
    }, [
      createElementVNode("span", _hoisted_3$j, [
        createVNode(_component_EllipsisText, {
          class: "text-subtitle3",
          "data-automation": _ctx.buildId("label"),
          text: _ctx.label
        }, null, 8, ["data-automation", "text"]),
        _ctx.showOptionalLabel ? (openBlock(), createElementBlock("div", _hoisted_4$c, toDisplayString(_ctx.optionalLabel || _ctx.$t("rvai-base.general.inputs.optional")), 1)) : createCommentVNode("", true),
        _ctx.infoText || _ctx.$slots["infoText"] ? (openBlock(), createBlock(_component_QIcon, {
          key: 1,
          class: "q-ml-xs info-icon",
          color: "black-1",
          "data-automation": _ctx.buildId("icon-info"),
          name: "info",
          size: "16px"
        }, {
          default: withCtx(() => [
            createVNode(_component_Tooltip, {
              anchor: "top middle",
              class: normalizeClass(_ctx.infoTextClass),
              "data-automation": _ctx.buildId("icon-info__tooltip"),
              self: "bottom middle"
            }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "infoText", {}, () => [
                  createTextVNode(toDisplayString(_ctx.infoText), 1)
                ], true)
              ]),
              _: 3
            }, 8, ["class", "data-automation"])
          ]),
          _: 3
        }, 8, ["data-automation"])) : createCommentVNode("", true)
      ])
    ], 10, _hoisted_2$m)) : createCommentVNode("", true),
    createElementVNode("div", _hoisted_5$a, [
      createElementVNode("div", _hoisted_6$7, [
        _ctx.withInput ? (openBlock(), createBlock(_component_Input, {
          key: 0,
          modelValue: _ctx.minValueString,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.minValueString = $event),
          class: "rv-slider__input",
          "data-automation": _ctx.buildId("min-input"),
          disable: _ctx.disable,
          "item-aligned": "center",
          "show-error": false,
          "show-error-message": false,
          "show-valid": false,
          onBlur: _ctx.onMinInputBlur,
          onKeyup: _cache[1] || (_cache[1] = withKeys(($event) => $event.target.blur(), ["enter"]))
        }, null, 8, ["modelValue", "data-automation", "disable", "onBlur"])) : _ctx.showMinMax ? (openBlock(), createBlock(_component_EllipsisText, {
          key: 1,
          class: "rv-range__limit text-grey-1",
          "data-automation": _ctx.buildId("min")
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.minLabel || _ctx.min), 1)
          ]),
          _: 1
        }, 8, ["data-automation"])) : createCommentVNode("", true)
      ]),
      createVNode(_component_QRange, {
        class: normalizeClass(_ctx.$props.class),
        "data-automation": _ctx.buildId("slider"),
        disable: _ctx.disable,
        label: _ctx.showPinLabel,
        max: _ctx.max,
        min: _ctx.min,
        "model-value": _ctx.modelValue,
        step: _ctx.step,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.$emit("update:modelValue", $event))
      }, null, 8, ["class", "data-automation", "disable", "label", "max", "min", "model-value", "step"]),
      createElementVNode("div", _hoisted_7$5, [
        _ctx.withInput ? (openBlock(), createBlock(_component_Input, {
          key: 0,
          modelValue: _ctx.maxValueString,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.maxValueString = $event),
          class: "rv-slider__input",
          "data-automation": _ctx.buildId("max-input"),
          disable: _ctx.disable,
          "item-aligned": "center",
          "show-error": false,
          "show-error-message": false,
          "show-valid": false,
          onBlur: _ctx.onMaxInputBlur,
          onKeyup: _cache[4] || (_cache[4] = withKeys(($event) => $event.target.blur(), ["enter"]))
        }, null, 8, ["modelValue", "data-automation", "disable", "onBlur"])) : _ctx.showMinMax ? (openBlock(), createBlock(_component_EllipsisText, {
          key: 1,
          class: "rv-range__limit text-grey-1",
          "data-automation": _ctx.buildId("max")
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.max), 1)
          ]),
          _: 1
        }, 8, ["data-automation"])) : createCommentVNode("", true)
      ])
    ])
  ], 16, _hoisted_1$t);
}
const Range = /* @__PURE__ */ _export_sfc$1(_sfc_main$A, [["render", _sfc_render$t], ["__scopeId", "data-v-406f86f1"]]);
const _sfc_main$z = defineComponent({
  name: "ScrollNavigation",
  components: {
    CardItem,
    QIcon: QIcon_default$1
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Elements to be shown as buttons
     */
    entries: {
      required: true,
      type: Array
    },
    /**
     * Section title
     */
    title: {
      required: true,
      type: String
    }
  },
  emits: ["on-click"],
  setup(props4) {
    return {
      ...useAutomation(computed(() => props4.dataAutomation))
    };
  }
});
const _hoisted_1$s = ["data-automation"];
const _hoisted_2$l = { class: "q-pl-lg q-pt-lg q-pb-md text-subtitle1" };
function _sfc_render$s(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QIcon = resolveComponent("QIcon");
  const _component_CardItem = resolveComponent("CardItem");
  const _component_rv_scroll_area = resolveComponent("rv-scroll-area");
  return openBlock(), createElementBlock("div", {
    class: "scroll-buttons items-start",
    "data-automation": _ctx.buildId(),
    style: normalizeStyle({
      "--items": _ctx.entries.length
    })
  }, [
    createElementVNode("div", _hoisted_2$l, toDisplayString(_ctx.title), 1),
    createVNode(_component_rv_scroll_area, {
      class: "scroll-buttons__list",
      "data-automation": _ctx.buildId("scrollArea")
    }, {
      default: withCtx(() => [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.entries, (entry, index2) => {
          return openBlock(), createBlock(_component_CardItem, {
            key: index2,
            class: normalizeClass(["scroll-buttons__item", { "scroll-buttons__item--active": entry.active }]),
            "data-automation": _ctx.buildId(`item__${index2}`),
            "hide-icon": "",
            title: entry.label,
            onClick: ($event) => _ctx.$emit("on-click", entry.to)
          }, createSlots({ _: 2 }, [
            entry.icon ? {
              name: "prepend",
              fn: withCtx(() => [
                createVNode(_component_QIcon, {
                  class: "q-mr-md",
                  name: entry.icon,
                  size: "24px"
                }, null, 8, ["name"])
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["class", "data-automation", "title", "onClick"]);
        }), 128))
      ]),
      _: 1
    }, 8, ["data-automation"])
  ], 12, _hoisted_1$s);
}
const ScrollNavigation = /* @__PURE__ */ _export_sfc$1(_sfc_main$z, [["render", _sfc_render$s], ["__scopeId", "data-v-b1bd8d7b"]]);
const __default__ = defineComponent({
  name: "SearchInput",
  components: {
    Button,
    Input,
    ScrollArea
  },
  inheritAttrs: false,
  props: {
    /**
     * Enables bottom slots ('error', 'hint', 'counter')
     */
    bottomSlots: {
      type: Boolean,
      default: false
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Clear the input when user select a value
     * @type {boolean}
     */
    clearOnSelect: {
      default: true,
      type: Boolean
    },
    /**
     * Items to be searched
     * @type {[string | number]}
     */
    data: {
      required: true,
      type: Array
    },
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      default: "searchInput",
      type: String
    },
    /**
     * Dense mode; occupies less space
     */
    dense: {
      default: false,
      type: Boolean
    },
    /**
     * Disable input element
     */
    disable: {
      default: false,
      type: Boolean
    },
    /**
     * Helper (hint) text which gets placed below your wrapped form component
     */
    hint: {
      default: void 0,
      type: String
    },
    /**
     * Max height of scrollable content
     * @type {boolean}
     */
    maxContentHeight: {
      default: 200,
      type: Number
    },
    /**
     * Model of the component; Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
     */
    modelValue: {
      required: true,
      type: String
    },
    /**
     * Text that appears in the input element when it has no value set
     */
    placeholder: {
      default: () => useI18n().t("rvai-base.general.text.search"),
      type: String
    }
  },
  emits: [
    /**
     * Emitted when the component needs to change the model; Is also used by v-model
     *
     * @type {string}
     */
    "update:modelValue",
    /**
     * Emitted when selected value from search list
     *
     * @type {string}
     */
    "select"
  ],
  setup(props4, { emit }) {
    const slots = useSlots();
    const { t: t22 } = useI18n();
    const inputRef = ref$1(null);
    const contentHeight = ref$1(0);
    const scrollAreaRef = ref$1(null);
    const selectedIndex = ref$1(void 0);
    const bottomSlotNames = computed(() => {
      return ["error", "hint", "counter"].filter((name2) => props4.bottomSlots && slots[name2]);
    });
    const search = computed({
      get() {
        return props4.modelValue;
      },
      set(value2) {
        emit("update:modelValue", value2);
      }
    });
    const contentHeightPx = computed(() => {
      return filteredData.value.length ? `${Math.min(props4.maxContentHeight, contentHeight.value)}px` : "auto";
    });
    const sortedData = computed(() => {
      return [...props4.data].sort((a32, b22) => naturalSort(a32.value, b22.value));
    });
    const filteredData = computed(() => {
      const needle = String(search.value).toLowerCase();
      return needle ? sortedData.value.filter((v) => v.label.toLowerCase().includes(needle) || v.value.toLowerCase().includes(needle)) : [];
    });
    function clear() {
      search.value = "";
      selectedIndex.value = void 0;
    }
    function focus() {
      var _a;
      void ((_a = inputRef.value) == null ? void 0 : _a.input.focus());
    }
    function handleArrowKey(e22) {
      var _a, _b, _c;
      e22.preventDefault();
      const isKeyUp = e22.key === KEY_ARROW_UP;
      selectedIndex.value = isKeyUp ? Math.max(0, (selectedIndex.value ?? 0) - 1) : Math.min(filteredData.value.length - 1, (selectedIndex.value ?? 0) + 1);
      const el = document.querySelector(`[search-input-item-index="${selectedIndex.value}"]`);
      if (!el) return;
      const offsetTop = el.offsetTop;
      const offsetBottom = offsetTop != null ? offsetTop + el.offsetHeight : 0;
      const rect = el.getBoundingClientRect();
      const visibleAreaHeight = (_a = scrollAreaRef.value) == null ? void 0 : _a.$el.clientHeight;
      const scrollPosition = ((_b = scrollAreaRef.value) == null ? void 0 : _b.scrollAreaRef.getScrollPosition().top) ?? 0;
      const isOutsideView = rect && offsetTop != null && offsetBottom != null && !!(isKeyUp ? offsetTop < scrollPosition : offsetBottom - scrollPosition > visibleAreaHeight);
      if (isOutsideView) {
        (_c = scrollAreaRef.value) == null ? void 0 : _c.setScrollPosition(
          "vertical",
          isKeyUp ? scrollPosition - rect.height : scrollPosition + rect.height
        );
      }
    }
    function handleEnter(e22) {
      if (selectedIndex.value === void 0) return;
      e22.preventDefault();
      emit("select", filteredData.value[selectedIndex.value]);
      if (props4.clearOnSelect) {
        clear();
      }
    }
    const onBlur2 = debounce_default$1(clear, 200);
    function onKeyUp(e22) {
      var _a;
      switch (e22.key) {
        case KEY_ESC:
        case KEY_ESCAPE:
          (_a = inputRef.value) == null ? void 0 : _a.input.blur();
          return;
      }
      if (filteredData.value.length) {
        switch (e22.key) {
          case KEY_ARROW_UP:
          case KEY_ARROW_DOWN:
            return handleArrowKey(e22);
          case KEY_ENTER:
            return handleEnter(e22);
        }
      }
    }
    function onMouseSelect(v) {
      emit("select", v);
      clear();
    }
    watch(() => {
      var _a;
      return (_a = inputRef.value) == null ? void 0 : _a.focused;
    }, (focused, prev) => {
      if (focused && focused !== prev) {
        document.addEventListener("keyup", onKeyUp);
      } else {
        document.removeEventListener("keyup", onKeyUp);
      }
    }, { immediate: true });
    watch(filteredData, async (v) => {
      var _a, _b;
      selectedIndex.value = v.length ? 0 : void 0;
      await nextTick();
      const scrollContentHeight = (_b = (_a = scrollAreaRef.value) == null ? void 0 : _a.$el.querySelector(".search-input__list")) == null ? void 0 : _b.clientHeight;
      if (scrollContentHeight != null) {
        contentHeight.value = scrollContentHeight;
      }
    }, { immediate: true });
    onUnmounted(() => {
      document.removeEventListener("keyup", onKeyUp);
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      bottomSlotNames,
      clear,
      contentHeightPx,
      filteredData,
      focus,
      inputRef,
      onBlur: onBlur2,
      onKeyUp,
      onMouseSelect,
      scrollAreaRef,
      search,
      selectedIndex,
      t: t22
    };
  }
});
const __injectCSSVars__ = () => {
  useCssVars((_ctx) => ({
    "2cc16c77": _ctx.contentHeightPx
  }));
};
const __setup__ = __default__.setup;
__default__.setup = __setup__ ? (props4, ctx) => {
  __injectCSSVars__();
  return __setup__(props4, ctx);
} : __injectCSSVars__;
const _hoisted_1$r = ["data-automation"];
const _hoisted_2$k = ["data-automation"];
const _hoisted_3$i = ["data-automation"];
const _hoisted_4$b = ["data-automation"];
const _hoisted_5$9 = ["data-automation", "search-input-item-index", "onClick"];
const _hoisted_6$6 = { class: "q-pa-xs q-pl-md" };
function _sfc_render$r(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = resolveComponent("Button");
  const _component_Input = resolveComponent("Input");
  const _component_ScrollArea = resolveComponent("ScrollArea");
  return openBlock(), createElementBlock("div", mergeProps(_ctx.dataAttrs, {
    class: ["search-input relative-position", _ctx.$props.class],
    "data-automation": _ctx.buildId(),
    onKeyUp: _cache[1] || (_cache[1] = (...args) => _ctx.onKeyUp && _ctx.onKeyUp(...args))
  }), [
    createVNode(_component_Input, {
      ref: "inputRef",
      modelValue: _ctx.search,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.search = $event),
      "bottom-slots": _ctx.bottomSlots,
      class: "search-input__input",
      "data-automation": _ctx.buildId("input"),
      dense: _ctx.dense,
      disable: _ctx.disable,
      hint: _ctx.hint,
      icon: "search",
      placeholder: _ctx.placeholder,
      onBlur: _ctx.onBlur,
      onKeyUp: withModifiers(_ctx.onKeyUp, ["stop", "prevent"])
    }, createSlots({
      append: withCtx(() => [
        _ctx.search ? (openBlock(), createBlock(_component_Button, {
          key: 0,
          color: "black-1",
          "data-automation": _ctx.buildId("input__close-btn"),
          icon: "close",
          size: "md",
          tertiary: "",
          onClick: _ctx.clear
        }, null, 8, ["data-automation", "onClick"])) : createCommentVNode("", true)
      ]),
      _: 2
    }, [
      renderList(_ctx.bottomSlotNames, (name2) => {
        return {
          name: name2,
          fn: withCtx((slotData) => [
            renderSlot(_ctx.$slots, name2, normalizeProps(guardReactiveProps(slotData || {})), void 0, true)
          ])
        };
      })
    ]), 1032, ["modelValue", "bottom-slots", "data-automation", "dense", "disable", "hint", "placeholder", "onBlur", "onKeyUp"]),
    _ctx.filteredData.length || _ctx.search ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: "search-input__list-wrapper bg-white rounded-borders shadow-6 absolute full-width",
      "data-automation": _ctx.buildId("list")
    }, [
      _ctx.search && !_ctx.filteredData.length ? renderSlot(_ctx.$slots, "noSearchResult", { key: 0 }, () => [
        createElementVNode("div", {
          class: "q-pa-xs q-pl-md",
          "data-automation": _ctx.buildId("list__no-match")
        }, toDisplayString(_ctx.t("rvai-base.components.searchInput.noMatches")), 9, _hoisted_3$i)
      ], true) : createCommentVNode("", true),
      createVNode(_component_ScrollArea, {
        ref: "scrollAreaRef",
        class: "full-height",
        "data-automation": _ctx.buildId("scroll"),
        "no-horizontal": ""
      }, {
        default: withCtx(() => [
          _ctx.filteredData.length || _ctx.search ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(["search-input__list rounded-borders full-height full-width", { "search-input__list--offset": _ctx.hint }]),
            "data-automation": _ctx.buildId("list")
          }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.filteredData, (item, index2) => {
              return openBlock(), createElementBlock("div", {
                key: `${item}-${index2}`,
                class: normalizeClass(["search-input__list__item", { "search-input__list__item--selected": index2 === _ctx.selectedIndex }]),
                "data-automation": _ctx.buildId("list__item"),
                "search-input-item-index": index2,
                onClick: ($event) => _ctx.onMouseSelect(item)
              }, [
                renderSlot(_ctx.$slots, "menuItem", { item }, () => [
                  createElementVNode("div", _hoisted_6$6, toDisplayString(item.label), 1)
                ], true)
              ], 10, _hoisted_5$9);
            }), 128))
          ], 10, _hoisted_4$b)) : createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["data-automation"])
    ], 8, _hoisted_2$k)) : createCommentVNode("", true)
  ], 16, _hoisted_1$r);
}
const SearchInput = /* @__PURE__ */ _export_sfc$1(__default__, [["render", _sfc_render$r], ["__scopeId", "data-v-7bbdf048"]]);
const _sfc_main$y = defineComponent({
  name: "SectionMessage",
  components: {
    QIcon: QIcon_default$1
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: "section-message"
    },
    class: {
      default: void 0,
      type: [Array, Object, String]
    },
    color: {
      default: "negative",
      type: String,
      validator: (v) => [
        "blue",
        "negative",
        "positive"
      ].includes(v)
    },
    iconName: {
      default: void 0,
      type: String
    }
  },
  setup(props4) {
    return {
      ...useAutomation(computed(() => props4.dataAutomation))
    };
  }
});
const _hoisted_1$q = ["data-automation"];
const _hoisted_2$j = ["data-automation"];
const _hoisted_3$h = ["data-automation"];
function _sfc_render$q(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_q_icon = resolveComponent("q-icon");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(_ctx.$props.class),
    "data-automation": _ctx.buildId()
  }, [
    createElementVNode("div", {
      class: normalizeClass(`rounded-borders q-px-md q-py-sm flex no-wrap items-center text-white bg-${_ctx.color}`),
      "data-automation": _ctx.buildId("main")
    }, [
      _ctx.iconName ? (openBlock(), createBlock(_component_q_icon, {
        key: 0,
        class: "q-mr-md",
        color: "white",
        "data-automation": _ctx.buildId("icon"),
        name: _ctx.iconName,
        size: "24px"
      }, null, 8, ["data-automation", "name"])) : createCommentVNode("", true),
      _ctx.$slots["default"] ? (openBlock(), createElementBlock("div", {
        key: 1,
        "data-automation": _ctx.buildId("message-slot")
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 8, _hoisted_3$h)) : createCommentVNode("", true)
    ], 10, _hoisted_2$j)
  ], 10, _hoisted_1$q);
}
const SectionMessage = /* @__PURE__ */ _export_sfc$1(_sfc_main$y, [["render", _sfc_render$q]]);
const _sfc_main$x = defineComponent({
  name: "SelectBoolean",
  components: {
    Select
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    }
  },
  setup(props4) {
    const { t: t22 } = useI18n();
    const options = computed(() => {
      return [
        {
          label: t22("rvai-base.general.text.no"),
          value: false
        },
        {
          label: t22("rvai-base.general.text.yes"),
          value: true
        }
      ];
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      options
    };
  }
});
function _sfc_render$p(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Select = resolveComponent("Select");
  return openBlock(), createBlock(_component_Select, mergeProps(_ctx.$attrs, {
    "data-automation": _ctx.buildId(),
    "emit-value": "",
    "map-options": "",
    options: _ctx.options
  }), null, 16, ["data-automation", "options"]);
}
const SelectBoolean = /* @__PURE__ */ _export_sfc$1(_sfc_main$x, [["render", _sfc_render$p]]);
const _sfc_main$w = defineComponent({
  name: "SpinnerAbsolute",
  components: {
    QSpinner: QSpinner_default$1
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: "spinnerAbsolute"
    },
    /**
     * Spinner size
     */
    size: {
      type: String,
      default: "48px"
    }
  },
  setup(props4) {
    return {
      ...useAutomation(computed(() => props4.dataAutomation))
    };
  }
});
const _hoisted_1$p = ["data-automation"];
const _hoisted_2$i = { class: "spinner-block__background absolute-full" };
const _hoisted_3$g = { class: "absolute-center" };
function _sfc_render$o(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QSpinner = resolveComponent("QSpinner");
  return openBlock(), createElementBlock("div", {
    class: "spinner-block flex justify-center",
    "data-automation": _ctx.buildId()
  }, [
    createElementVNode("div", _hoisted_2$i, [
      createElementVNode("div", _hoisted_3$g, [
        createVNode(_component_QSpinner, {
          class: "spinner-block__spinner",
          color: "primary",
          size: _ctx.size
        }, null, 8, ["size"])
      ])
    ])
  ], 8, _hoisted_1$p);
}
const SpinnerAbsolute = /* @__PURE__ */ _export_sfc$1(_sfc_main$w, [["render", _sfc_render$o], ["__scopeId", "data-v-3f9f141d"]]);
const _sfc_main$v = defineComponent({
  name: "Sidebar",
  components: {
    Button,
    Logo: _sfc_main$P,
    QCard: QCard_default$1,
    QCardActions: QCardActions_default$1,
    QCardSection: QCardSection_default$1,
    QDialog: QDialog_default$1,
    QSpace: QSpace_default,
    ScrollArea,
    SpinnerAbsolute
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Disable back button
     */
    disableBackBtn: {
      type: Boolean,
      default: false
    },
    /**
     * Disable close button
     */
    disableCloseBtn: {
      type: Boolean,
      default: false
    },
    /**
     * Focus field on initial component render
     */
    focusFirstInput: {
      type: Boolean,
      default: true
    },
    /**
     * Hide back button
     */
    hideBackBtn: {
      type: Boolean,
      default: true
    },
    /**
     * Hide close button
     */
    hideCloseBtn: {
      type: Boolean,
      default: false
    },
    /**
     * Display loading state
     */
    loading: {
      type: Boolean,
      default: false
    },
    /**
     * Stick dialog to one of the sides (top, right, bottom or left)
     */
    position: {
      type: String,
      default: "left"
    },
    /**
     * Display saving state
     */
    saving: {
      type: Boolean,
      default: false
    },
    /**
     * Text displayed in title
     */
    title: {
      type: String,
      default: ""
    }
  },
  emits: [
    ...useDialogPluginComponent.emits,
    "on-back",
    "on-cancel",
    "on-submit"
  ],
  setup(props4, { emit }) {
    const { logoAlignClasses } = useLogo();
    const {
      dialogRef,
      onDialogCancel,
      onDialogHide,
      onDialogOK
    } = useDialogPluginComponent();
    function cancel() {
      emit("on-cancel");
      onDialogCancel();
    }
    function hide() {
      var _a;
      (_a = dialogRef.value) == null ? void 0 : _a.hide();
    }
    function show() {
      var _a;
      (_a = dialogRef.value) == null ? void 0 : _a.show();
    }
    function onBack() {
      emit("on-back");
    }
    function onSubmit() {
      emit("on-submit");
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      cancel,
      dialogRef,
      hide,
      logoAlignClasses,
      onBack,
      onDialogHide,
      onDialogOK,
      onSubmit,
      show
    };
  }
});
const _hoisted_1$o = { class: "sidebar__back" };
const _hoisted_2$h = { class: "sidebar__cancel" };
const _hoisted_3$f = ["data-automation"];
const _hoisted_4$a = ["data-automation"];
const _hoisted_5$8 = ["data-automation"];
function _sfc_render$n(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = resolveComponent("Button");
  const _component_Logo = resolveComponent("Logo");
  const _component_QCardSection = resolveComponent("QCardSection");
  const _component_SpinnerAbsolute = resolveComponent("SpinnerAbsolute");
  const _component_ScrollArea = resolveComponent("ScrollArea");
  const _component_QSpace = resolveComponent("QSpace");
  const _component_QCardActions = resolveComponent("QCardActions");
  const _component_QCard = resolveComponent("QCard");
  const _component_QDialog = resolveComponent("QDialog");
  const _directive_focus = resolveDirective("focus");
  const _directive_hotkey = resolveDirective("hotkey");
  return openBlock(), createBlock(_component_QDialog, mergeProps({ ref: "dialogRef" }, _ctx.$attrs, {
    "data-automation": _ctx.buildId(),
    maximized: "",
    "no-backdrop-dismiss": "",
    position: _ctx.position,
    onHide: _ctx.onDialogHide
  }), {
    default: withCtx(() => [
      withDirectives((openBlock(), createBlock(_component_QCard, { class: "sidebar column no-wrap" }, {
        default: withCtx(() => [
          createVNode(_component_QCardSection, {
            class: "sidebar__header row no-wrap items-center q-px-lg q-pt-md q-pb-lg",
            "data-automation": _ctx.buildId("header")
          }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_1$o, [
                !_ctx.hideBackBtn ? (openBlock(), createBlock(_component_Button, {
                  key: 0,
                  class: "no-padding",
                  color: "black-1",
                  "data-automation": _ctx.buildId("back"),
                  disable: _ctx.disableBackBtn,
                  icon: "mdi-chevron-left",
                  tertiary: "",
                  onClick: _ctx.onBack
                }, null, 8, ["data-automation", "disable", "onClick"])) : createCommentVNode("", true)
              ]),
              createElementVNode("div", {
                class: normalizeClass(["sidebar__logo-wrapper", _ctx.logoAlignClasses])
              }, [
                createVNode(_component_Logo, {
                  class: "sidebar__logo",
                  "data-automation": _ctx.buildId("logo"),
                  name: "regular"
                }, null, 8, ["data-automation"])
              ], 2),
              createElementVNode("div", _hoisted_2$h, [
                !_ctx.hideCloseBtn ? (openBlock(), createBlock(_component_Button, {
                  key: 0,
                  class: "no-padding",
                  color: "black-1",
                  "data-automation": _ctx.buildId("cancel"),
                  disable: _ctx.disableCloseBtn,
                  icon: "mdi-close",
                  tertiary: "",
                  onClick: _ctx.cancel
                }, null, 8, ["data-automation", "disable", "onClick"])) : createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["data-automation"]),
          _ctx.title ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: "sidebar__title text-subtitle1 q-px-lg q-pb-md",
            "data-automation": _ctx.buildId("title")
          }, [
            createTextVNode(toDisplayString(_ctx.title) + " ", 1),
            renderSlot(_ctx.$slots, "title-append", {}, void 0, true)
          ], 8, _hoisted_3$f)) : createCommentVNode("", true),
          createVNode(_component_QCardSection, {
            class: "fit q-pa-none relative-position",
            "data-automation": _ctx.buildId("content-wrapper")
          }, {
            default: withCtx(() => [
              _ctx.loading || _ctx.saving ? (openBlock(), createBlock(_component_SpinnerAbsolute, {
                key: 0,
                "data-automation": _ctx.buildId("spinner")
              }, null, 8, ["data-automation"])) : createCommentVNode("", true),
              createVNode(_component_ScrollArea, {
                class: "full-height",
                "data-automation": _ctx.buildId("scrollArea")
              }, {
                default: withCtx(() => [
                  createElementVNode("div", {
                    class: normalizeClass(["sidebar__content q-pb-md", { "disabled no-pointer-events": _ctx.saving || _ctx.loading }]),
                    "data-automation": _ctx.buildId("content")
                  }, [
                    !_ctx.loading ? renderSlot(_ctx.$slots, "default", { key: 0 }, void 0, true) : createCommentVNode("", true)
                  ], 10, _hoisted_4$a)
                ]),
                _: 3
              }, 8, ["data-automation"])
            ]),
            _: 3
          }, 8, ["data-automation"]),
          createVNode(_component_QSpace),
          withDirectives(createVNode(_component_QCardActions, { class: "row q-pa-none z-top" }, {
            default: withCtx(() => [
              createElementVNode("div", {
                class: normalizeClass(["sidebar__actions col-grow shadow-6 q-px-lg q-py-md", { "disabled no-pointer-events": _ctx.saving || _ctx.loading }]),
                "data-automation": _ctx.buildId("actions")
              }, [
                renderSlot(_ctx.$slots, "actions", {}, void 0, true)
              ], 10, _hoisted_5$8)
            ]),
            _: 3
          }, 512), [
            [vShow, _ctx.$slots.actions]
          ])
        ]),
        _: 3
      })), [
        [_directive_focus, _ctx.focusFirstInput],
        [_directive_hotkey, { "Enter": _ctx.onSubmit }]
      ])
    ]),
    _: 3
  }, 16, ["data-automation", "position", "onHide"]);
}
const Sidebar = /* @__PURE__ */ _export_sfc$1(_sfc_main$v, [["render", _sfc_render$n], ["__scopeId", "data-v-0d8f46e6"]]);
const _sfc_main$u = defineComponent({
  name: "SidebarListClassSlugs",
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    modelValue: {
      type: Array,
      default: () => []
    },
    /**
     * Shows class name or class id
     */
    showClassName: {
      type: Boolean,
      default: true
    }
  },
  setup(props4) {
    const { t: t22 } = useI18n();
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      t: t22
    };
  }
});
const _hoisted_1$n = ["data-automation"];
const _hoisted_2$g = {
  key: 0,
  class: "sidebar-list-class-slugs__content"
};
const _hoisted_3$e = ["data-automation"];
const _hoisted_4$9 = { key: 0 };
const _hoisted_5$7 = {
  key: 1,
  class: "sidebar-list-class-slugs__content--separator q-mr-sm"
};
const _hoisted_6$5 = {
  key: 0,
  class: "sidebar-list-class-slugs__content--separator q-mr-sm"
};
const _hoisted_7$4 = {
  key: 1,
  class: "q-pb-md"
};
function _sfc_render$m(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "sidebar-list-class-slugs",
    "data-automation": _ctx.buildId()
  }, [
    _ctx.modelValue.length ? (openBlock(), createElementBlock("div", _hoisted_2$g, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.modelValue, (item, index2) => {
        return openBlock(), createElementBlock("div", {
          key: item.id,
          class: "inline-block",
          "data-automation": _ctx.buildId(`item-${item.id}`)
        }, [
          _ctx.showClassName ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createTextVNode(toDisplayString(item.name) + " ", 1),
            item.hasDifferentNames ? (openBlock(), createElementBlock("span", _hoisted_4$9, toDisplayString(_ctx.t("rvai-base.general.common.wordInBrackets", [item.id])), 1)) : createCommentVNode("", true),
            index2 < _ctx.modelValue.length - 1 ? (openBlock(), createElementBlock("span", _hoisted_5$7, toDisplayString(_ctx.t("rvai-base.general.symbols.comma")), 1)) : createCommentVNode("", true)
          ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            createTextVNode(toDisplayString(item.id) + " ", 1),
            index2 < _ctx.modelValue.length - 1 ? (openBlock(), createElementBlock("span", _hoisted_6$5, toDisplayString(_ctx.t("rvai-base.general.symbols.comma")), 1)) : createCommentVNode("", true)
          ], 64))
        ], 8, _hoisted_3$e);
      }), 128))
    ])) : (openBlock(), createElementBlock("div", _hoisted_7$4, toDisplayString(_ctx.t("rvai-base.general.common.none")), 1))
  ], 8, _hoisted_1$n);
}
const SidebarListClassSlugs = /* @__PURE__ */ _export_sfc$1(_sfc_main$u, [["render", _sfc_render$m], ["__scopeId", "data-v-0bd0435b"]]);
const _sfc_main$t = defineComponent({
  name: "SidebarLoading",
  components: {
    QIcon: QIcon_default$1
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    }
  },
  setup(props4) {
    const { t: t22 } = useI18n();
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      t: t22
    };
  }
});
const _hoisted_1$m = ["data-automation"];
const _hoisted_2$f = { class: "bg-white absolute-full z-fab" };
const _hoisted_3$d = { class: "sidebar-loading__content relative-position flex items-center column text-grey-1" };
function _sfc_render$l(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QIcon = resolveComponent("QIcon");
  return openBlock(), createElementBlock("div", {
    class: "sidebar-loading",
    "data-automation": _ctx.buildId()
  }, [
    createElementVNode("div", _hoisted_2$f, [
      createElementVNode("div", _hoisted_3$d, [
        createVNode(_component_QIcon, {
          color: "grey-2",
          name: "mdi-alert-circle",
          size: "33px"
        }),
        createElementVNode("span", null, toDisplayString(_ctx.t("rvai-base.general.text.loading")), 1),
        createElementVNode("span", null, toDisplayString(_ctx.t("rvai-base.general.text.loadingExtra")), 1)
      ])
    ])
  ], 8, _hoisted_1$m);
}
const SidebarLoading = /* @__PURE__ */ _export_sfc$1(_sfc_main$t, [["render", _sfc_render$l], ["__scopeId", "data-v-abc83384"]]);
const _sfc_main$s = defineComponent({
  name: "Slider",
  components: {
    EllipsisText,
    Input,
    QIcon: QIcon_default$1,
    QSlider: QSlider_default$1,
    Tooltip: Tooltip2
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Focus field on initial component render
     */
    autofocus: {
      type: Boolean,
      default: false
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Debounce amount (in milliseconds) when updating model
     */
    debounce: {
      type: [String, Number],
      default: 200
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Accept float values when using with-input
     */
    float: {
      type: Boolean,
      default: false
    },
    /**
     * Render info icon with tooltip. Can be used as an "info-text" property or as a slot
     */
    infoText: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to the info text
     */
    infoTextClass: {
      type: String,
      default: "rv-slider__info-text"
    },
    /**
     * Classes applied to the input
     * @type {[Array, Object, String]}
     */
    inputClass: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * How many numbers show after comma for float numbers
     * @type {number}
     */
    inputDecimals: {
      type: Number,
      default: void 0
    },
    /**
     * The text that will be shown above the input
     */
    label: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to the label
     * @type {[Array, Object, String]}
     */
    labelClass: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Override default pin value
     * @type {[Array, Object, String]}
     */
    pinValue: {
      type: [String, Number],
      default: void 0
    },
    /**
     * Display markers on the track, one for each possible value for the model
     */
    markers: {
      type: Boolean,
      default: false
    },
    /**
     * Maximum value of the model; Set track's maximum value
     */
    max: {
      type: Number,
      default: 100
    },
    /**
     * Minimum value of the model; Set track's minimum value
     */
    min: {
      type: Number,
      default: 0
    },
    /**
     * Label to show instead of minimum value
     */
    minLabel: {
      type: String,
      default: ""
    },
    /**
     * Model of the component (must be between min/max); Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
     */
    modelValue: {
      type: Number,
      required: true
    },
    /**
     * The text that will be shown next to label
     */
    optionalLabel: {
      type: String,
      default: ""
    },
    /**
     * Text that appears in the form control when it has no value set
     */
    placeholder: {
      type: String,
      default: void 0
    },
    /**
     * Put component in readonly mode
     */
    readonly: {
      type: Boolean,
      default: false
    },
    /**
     * Shows min and max values around slider
     */
    showMinMax: {
      type: Boolean,
      default: true
    },
    /**
     * Show optional label next to label
     */
    showOptionalLabel: {
      type: Boolean,
      default: false
    },
    /**
     * Flag to show/hide pin on hover
     */
    showPin: {
      type: Boolean,
      default: true
    },
    /**
     * Classes applied to the slider
     * @type {[Array, Object, String]}
     */
    sliderClass: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Specify step amount between valid values (> 0.0); When step equals to 0 it defines infinite granularity
     */
    step: {
      type: Number,
      default: 1
    },
    /**
     * The text to be displayed at the end of max
     */
    suffix: {
      type: String,
      default: void 0
    },
    /**
     * Renders input next to slider
     */
    withInput: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    /**
     * Emitted when the component needs to change the model; Is also used by v-model
     *
     * @type {[string, number]}
     */
    "update:modelValue"
  ],
  setup(props4, { emit }) {
    const { t: t22 } = useI18n();
    const stringValue = ref$1("");
    function onBlur2() {
      let parsed = props4.inputDecimals && stringValue.value ? truncateNumber(parseFloat(stringValue.value), props4.inputDecimals) : roundToStep(Number(stringValue.value), props4.step);
      if (isNaN(parsed)) {
        stringValue.value = props4.modelValue.toString();
        return;
      }
      if (parsed < props4.min) parsed = props4.min;
      if (parsed > props4.max) parsed = props4.max;
      parsed = props4.float ? parsed : ~~parsed;
      if (stringValue.value !== parsed.toString()) {
        stringValue.value = parsed.toString();
      }
      emit("update:modelValue", parsed);
    }
    function onSliderValueChange(event) {
      emit("update:modelValue", event);
    }
    watch(() => props4.modelValue, (value2) => {
      stringValue.value = String(value2);
    }, { immediate: true });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      onBlur: onBlur2,
      onSliderValueChange: props4.debounce ? debounce_default$1(onSliderValueChange, Number(props4.debounce)) : onSliderValueChange,
      stringValue,
      t: t22
    };
  }
});
const _hoisted_1$l = ["data-automation"];
const _hoisted_2$e = ["data-automation"];
const _hoisted_3$c = { class: "row no-wrap items-center full-width" };
const _hoisted_4$8 = {
  key: 0,
  class: "q-ml-xs"
};
const _hoisted_5$6 = { class: "flex justify-between full-width" };
const _hoisted_6$4 = {
  key: 0,
  class: "rv-slider__input-wrapper flex items-center justify-between"
};
function _sfc_render$k(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_QSlider = resolveComponent("QSlider");
  const _component_Input = resolveComponent("Input");
  return openBlock(), createElementBlock("div", mergeProps(_ctx.dataAttrs, {
    class: ["rv-slider", [
      _ctx.$props.class,
      {
        "rv-slider--disabled": _ctx.disable || _ctx.readonly,
        "rv-slider--with-input": _ctx.withInput
      }
    ]],
    "data-automation": _ctx.buildId()
  }), [
    _ctx.label ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass(["rv-slider__label flex justify-between items-center", _ctx.labelClass]),
      "data-automation": _ctx.buildId("label-container")
    }, [
      createElementVNode("span", _hoisted_3$c, [
        createVNode(_component_EllipsisText, {
          class: "text-subtitle3",
          "data-automation": _ctx.buildId("label"),
          text: _ctx.label
        }, null, 8, ["data-automation", "text"]),
        _ctx.showOptionalLabel ? (openBlock(), createElementBlock("div", _hoisted_4$8, toDisplayString(_ctx.optionalLabel || _ctx.t("rvai-base.general.inputs.optional")), 1)) : createCommentVNode("", true),
        _ctx.infoText || _ctx.$slots["infoText"] ? (openBlock(), createBlock(_component_QIcon, {
          key: 1,
          class: "q-ml-xs info-icon",
          color: "black-1",
          "data-automation": _ctx.buildId("icon-info"),
          name: "info",
          size: "16px"
        }, {
          default: withCtx(() => [
            createVNode(_component_Tooltip, {
              anchor: "top middle",
              class: normalizeClass(_ctx.infoTextClass),
              self: "bottom middle"
            }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "infoText", {}, () => [
                  createTextVNode(toDisplayString(_ctx.infoText), 1)
                ], true)
              ]),
              _: 3
            }, 8, ["class"])
          ]),
          _: 3
        }, 8, ["data-automation"])) : createCommentVNode("", true)
      ]),
      renderSlot(_ctx.$slots, "label-append", {}, void 0, true)
    ], 10, _hoisted_2$e)) : createCommentVNode("", true),
    createElementVNode("div", _hoisted_5$6, [
      createElementVNode("div", {
        class: normalizeClass(["rv-slider__slider-wrapper row items-center no-wrap", { "q-pr-md": _ctx.withInput }])
      }, [
        _ctx.showMinMax ? (openBlock(), createBlock(_component_EllipsisText, {
          key: 0,
          class: "rv-slider__limit q-mr-md col-fixed text-grey-1",
          "data-automation": _ctx.buildId("limit-min")
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.minLabel || _ctx.min), 1)
          ]),
          _: 1
        }, 8, ["data-automation"])) : createCommentVNode("", true),
        createVNode(_component_QSlider, {
          class: normalizeClass(["rv-slider__slider", _ctx.sliderClass]),
          "data-automation": _ctx.buildId("slider"),
          disable: _ctx.disable,
          label: _ctx.showPin,
          "label-value": _ctx.pinValue,
          markers: _ctx.markers,
          max: _ctx.max,
          min: _ctx.min,
          "model-value": _ctx.modelValue,
          readonly: _ctx.readonly,
          step: _ctx.step,
          "onUpdate:modelValue": _ctx.onSliderValueChange
        }, null, 8, ["class", "data-automation", "disable", "label", "label-value", "markers", "max", "min", "model-value", "readonly", "step", "onUpdate:modelValue"]),
        _ctx.showMinMax ? (openBlock(), createBlock(_component_EllipsisText, {
          key: 1,
          class: normalizeClass(["rv-slider__limit q-ml-md col-fixed text-grey-1", { "rv-slider__limit--suffix": _ctx.suffix }]),
          "data-automation": _ctx.buildId("limit-max")
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.max) + " " + toDisplayString(_ctx.suffix), 1)
          ]),
          _: 1
        }, 8, ["class", "data-automation"])) : createCommentVNode("", true)
      ], 2),
      _ctx.withInput ? (openBlock(), createElementBlock("div", _hoisted_6$4, [
        createVNode(_component_Input, {
          modelValue: _ctx.stringValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.stringValue = $event),
          autofocus: _ctx.autofocus,
          class: "rv-slider__input",
          "data-automation": _ctx.buildId("input"),
          debounce: _ctx.debounce,
          disable: _ctx.disable,
          "input-class": _ctx.inputClass,
          "item-aligned": "center",
          placeholder: _ctx.placeholder,
          readonly: _ctx.readonly,
          "show-error": false,
          "show-error-message": false,
          "show-valid": false,
          suffix: _ctx.suffix,
          onBlur: _ctx.onBlur,
          onKeyup: _cache[1] || (_cache[1] = withKeys(($event) => $event.target.blur(), ["enter"]))
        }, null, 8, ["modelValue", "autofocus", "data-automation", "debounce", "disable", "input-class", "placeholder", "readonly", "suffix", "onBlur"])
      ])) : createCommentVNode("", true)
    ])
  ], 16, _hoisted_1$l);
}
const Slider = /* @__PURE__ */ _export_sfc$1(_sfc_main$s, [["render", _sfc_render$k], ["__scopeId", "data-v-3e84b35c"]]);
const _sfc_main$r = defineComponent({
  name: "SortSelect",
  components: {
    QIcon: QIcon_default$1,
    QItem: QItem_default$1,
    QItemLabel: QItemLabel_default$1,
    QItemSection: QItemSection_default$1,
    Select
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: "sortSelect"
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Model of the component; Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
     */
    modelValue: {
      type: Object,
      default: null
    },
    /**
     * Available sort options that the user can select from. For best performance freeze the list of options.
     */
    options: {
      type: Array,
      required: true
    },
    /**
     * Shows label before select
     */
    showLabelBefore: {
      type: Boolean,
      default: true
    }
  },
  emits: ["update:modelValue"],
  setup(props4) {
    return {
      ...useAutomation(computed(() => props4.dataAutomation))
    };
  }
});
const _hoisted_1$k = ["data-automation"];
const _hoisted_2$d = ["data-automation"];
function _sfc_render$j(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QIcon = resolveComponent("QIcon");
  const _component_QItemLabel = resolveComponent("QItemLabel");
  const _component_QItemSection = resolveComponent("QItemSection");
  const _component_QItem = resolveComponent("QItem");
  const _component_Select = resolveComponent("Select");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["rv-sort-select", _ctx.$props.class]),
    "data-automation": _ctx.buildId()
  }, [
    _ctx.showLabelBefore ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: "text-subtitle3 flex flex-center q-mr-sm",
      "data-automation": _ctx.buildId("label")
    }, toDisplayString(_ctx.$t("rvai-base.general.table.sortBy")), 9, _hoisted_2$d)) : createCommentVNode("", true),
    createVNode(_component_Select, {
      class: "rv-sort-select__select",
      "data-automation": _ctx.buildId("select"),
      dense: "",
      "model-value": _ctx.modelValue,
      options: _ctx.options,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.$emit("update:modelValue", $event))
    }, {
      prepend: withCtx(() => [
        createVNode(_component_QIcon, {
          color: "grey-1",
          name: "rvai-base:sort-asc",
          size: "sm"
        })
      ]),
      option: withCtx((scope) => [
        createVNode(_component_QItem, mergeProps(scope.itemProps, {
          "data-automation": _ctx.buildId(`option-${scope.label}`)
        }), {
          default: withCtx(() => [
            createVNode(_component_QItemSection, { class: "rv-sort-select__item-section" }, {
              default: withCtx(() => [
                createVNode(_component_QItemLabel, null, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(scope.label), 1)
                  ]),
                  _: 2
                }, 1024),
                _ctx.modelValue && _ctx.modelValue.label === scope.label ? (openBlock(), createBlock(_component_QIcon, {
                  key: 0,
                  color: "grey-1",
                  name: "mdi-check",
                  size: "18px"
                })) : createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1040, ["data-automation"])
      ]),
      _: 1
    }, 8, ["data-automation", "model-value", "options"])
  ], 10, _hoisted_1$k);
}
const SortSelect = /* @__PURE__ */ _export_sfc$1(_sfc_main$r, [["render", _sfc_render$j], ["__scopeId", "data-v-ad1ee816"]]);
const _sfc_main$q = defineComponent({
  name: "Spinner",
  components: {
    QCircularProgress: QCircularProgress_default$1
  },
  props: {
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: "spinner"
    },
    /**
     * Spinner size
     */
    size: {
      type: String,
      default: "20px"
    }
  },
  setup(props4) {
    return {
      ...useAutomation(computed(() => props4.dataAutomation))
    };
  }
});
function _sfc_render$i(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QCircularProgress = resolveComponent("QCircularProgress");
  return openBlock(), createBlock(_component_QCircularProgress, {
    class: normalizeClass(_ctx.$props.class),
    color: "primary",
    "data-automation": _ctx.dataAutomation,
    indeterminate: "",
    rounded: "",
    size: _ctx.size,
    thickness: 0.3,
    "track-color": "grey-3"
  }, null, 8, ["class", "data-automation", "size"]);
}
const Spinner = /* @__PURE__ */ _export_sfc$1(_sfc_main$q, [["render", _sfc_render$i]]);
const _sfc_main$p = defineComponent({
  name: "StatusPanel",
  components: {
    CircularProgress,
    QIcon: QIcon_default$1
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Text displayed in title
     */
    color: {
      type: String,
      default: "primary"
    },
    /**
     * Set 'full-width' class to the component
     */
    fullWidth: {
      type: Boolean,
      default: false
    },
    /**
     * Text displayed in title
     */
    icon: {
      type: String,
      default: ""
    },
    /**
     * Text displayed in title
     */
    iconColor: {
      type: String,
      default: "positive"
    },
    /**
     * Minimum value defining 'no progress' (must be lower than 'max')
     */
    max: {
      type: [Number, String],
      default: 100
    },
    /**
     * Minimum value defining 'no progress' (must be lower than 'max')
     */
    min: {
      type: [Number, String],
      default: 0
    },
    /**
     * Text displayed in title
     */
    title: {
      type: String,
      default: () => useI18n().t("rvai-base.general.text.status")
    },
    /**
     * Text displayed in title
     */
    text: {
      type: String,
      default: ""
    },
    /**
     * Current progress (must be between min/max)
     */
    value: {
      type: [Number, String],
      required: true
    }
  },
  setup(props4) {
    return {
      ...useAutomation(computed(() => props4.dataAutomation))
    };
  }
});
const _hoisted_1$j = ["data-automation"];
const _hoisted_2$c = { class: "row no-wrap items-center full-width" };
const _hoisted_3$b = ["data-automation"];
const _hoisted_4$7 = ["data-automation"];
function _sfc_render$h(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QIcon = resolveComponent("QIcon");
  const _component_CircularProgress = resolveComponent("CircularProgress");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["status-panel column no-wrap items-center rounded-borders bg-grey-5 q-py-sm q-px-md", { "full-width": _ctx.fullWidth }]),
    "data-automation": _ctx.buildId()
  }, [
    createElementVNode("div", _hoisted_2$c, [
      createElementVNode("span", {
        class: "text-subtitle3",
        "data-automation": _ctx.buildId("title-text")
      }, toDisplayString(_ctx.title), 9, _hoisted_3$b),
      _ctx.icon ? (openBlock(), createBlock(_component_QIcon, {
        key: 0,
        class: "q-ml-xs",
        color: _ctx.iconColor,
        "data-automation": _ctx.buildId("title-icon"),
        name: _ctx.icon,
        size: "xs"
      }, null, 8, ["color", "data-automation", "name"])) : createCommentVNode("", true)
    ]),
    createVNode(_component_CircularProgress, {
      class: "q-mt-sm q-mb-xs",
      color: _ctx.color,
      "data-automation": _ctx.buildId("progress"),
      max: Number(_ctx.max),
      min: Number(_ctx.min),
      "show-value": "",
      size: "80px",
      "track-color": "grey-3",
      value: Number(_ctx.value)
    }, {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ]),
      _: 3
    }, 8, ["color", "data-automation", "max", "min", "value"]),
    _ctx.text ? (openBlock(), createElementBlock("span", {
      key: 0,
      class: "text-small",
      "data-automation": _ctx.buildId("text")
    }, toDisplayString(_ctx.text), 9, _hoisted_4$7)) : createCommentVNode("", true)
  ], 10, _hoisted_1$j);
}
const StatusPanel = /* @__PURE__ */ _export_sfc$1(_sfc_main$p, [["render", _sfc_render$h], ["__scopeId", "data-v-742b1eda"]]);
const _sfc_main$o = defineComponent({
  name: "SuspenseWithError",
  components: {
    QImg: QImg_default,
    QInnerLoading: QInnerLoading_default
  },
  setup() {
    const error = ref$1(false);
    onErrorCaptured((e22) => {
      error.value = true;
      console.error(e22);
    });
    return {
      error
    };
  }
});
const _hoisted_1$i = {
  key: 1,
  class: "q-pa-md fit column flex-center"
};
const _hoisted_2$b = { class: "text-subtitle3" };
const _hoisted_3$a = { class: "q-mt-sm text-body3" };
function _sfc_render$g(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QInnerLoading = resolveComponent("QInnerLoading");
  const _component_QImg = resolveComponent("QImg");
  return !_ctx.error ? (openBlock(), createBlock(Suspense, { key: 0 }, {
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default")
    ]),
    fallback: withCtx(() => [
      createVNode(_component_QInnerLoading, {
        color: "primary",
        showing: true
      })
    ]),
    _: 3
  })) : (openBlock(), createElementBlock("div", _hoisted_1$i, [
    createVNode(_component_QImg, {
      class: "icon",
      src: "rvai-base/not-found.svg",
      width: "75%"
    }),
    createElementVNode("div", _hoisted_2$b, toDisplayString(_ctx.$t("rvai-base.general.errors.title")), 1),
    createElementVNode("div", _hoisted_3$a, toDisplayString(_ctx.$t("rvai-base.general.errors.description")), 1)
  ]));
}
const SuspenseWithError = /* @__PURE__ */ _export_sfc$1(_sfc_main$o, [["render", _sfc_render$g]]);
const _sfc_main$n = defineComponent({
  name: "StepSidebar",
  components: {
    Button,
    Logo: _sfc_main$P,
    QCard: QCard_default$1,
    QCardSection: QCardSection_default$1,
    QDialog: QDialog_default$1,
    QIcon: QIcon_default$1,
    SuspenseWithError
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    customBackEvent: {
      type: Boolean,
      default: false
    },
    disableCloseBtn: {
      type: Boolean,
      default: false
    },
    hideBackBtn: {
      type: Boolean,
      default: false
    },
    hideCloseBtn: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: "left"
    }
  },
  emits: ["on-back"],
  setup(props4, { emit }) {
    const { logoAlignClasses } = useLogo();
    const {
      dialogRef,
      onDialogCancel,
      onDialogHide,
      onDialogOK
    } = useDialogPluginComponent();
    const {
      isCurrentStep,
      isDefaultStep,
      onBack,
      showBackButton,
      stack: stack2
    } = useStepSidebar();
    function onBackClick() {
      if (props4.customBackEvent) {
        emit("on-back");
      } else {
        onBack();
      }
    }
    function hide() {
      var _a;
      (_a = dialogRef.value) == null ? void 0 : _a.hide();
    }
    function show() {
      var _a;
      (_a = dialogRef.value) == null ? void 0 : _a.show();
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      dialogRef,
      hide,
      isCurrentStep,
      isDefaultStep,
      logoAlignClasses,
      onBackClick,
      onDialogCancel,
      onDialogHide,
      onDialogOK,
      show,
      showBackButton,
      stack: stack2
    };
  }
});
const _hoisted_1$h = { class: "sidebar__back" };
const _hoisted_2$a = { class: "sidebar__cancel" };
const _hoisted_3$9 = ["data-automation"];
const _hoisted_4$6 = ["data-automation"];
function _sfc_render$f(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = resolveComponent("Button");
  const _component_Logo = resolveComponent("Logo");
  const _component_QCardSection = resolveComponent("QCardSection");
  const _component_SuspenseWithError = resolveComponent("SuspenseWithError");
  const _component_QCard = resolveComponent("QCard");
  const _component_QDialog = resolveComponent("QDialog");
  return openBlock(), createBlock(_component_QDialog, mergeProps({ ref: "dialogRef" }, _ctx.$attrs, {
    "data-automation": _ctx.buildId(),
    maximized: "",
    "no-backdrop-dismiss": "",
    position: _ctx.position
  }), {
    default: withCtx(() => [
      createVNode(_component_QCard, { class: "sidebar column no-wrap" }, {
        default: withCtx(() => [
          createVNode(_component_QCardSection, {
            class: "sidebar__header row no-wrap items-center q-pa-md q-pt-md q-pb-lg",
            "data-automation": _ctx.buildId("header")
          }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_1$h, [
                !_ctx.hideBackBtn && _ctx.showBackButton ? (openBlock(), createBlock(_component_Button, {
                  key: 0,
                  class: "no-padding",
                  color: "black-1",
                  "data-automation": _ctx.buildId("back"),
                  icon: "mdi-chevron-left",
                  tertiary: "",
                  onClick: _ctx.onBackClick
                }, null, 8, ["data-automation", "onClick"])) : createCommentVNode("", true)
              ]),
              createElementVNode("div", {
                class: normalizeClass(["sidebar__logo-wrapper", _ctx.logoAlignClasses])
              }, [
                createVNode(_component_Logo, {
                  class: "sidebar__logo",
                  "data-automation": _ctx.buildId("logo")
                }, null, 8, ["data-automation"])
              ], 2),
              createElementVNode("div", _hoisted_2$a, [
                !_ctx.hideCloseBtn ? (openBlock(), createBlock(_component_Button, {
                  key: 0,
                  class: "no-padding",
                  color: "black-1",
                  "data-automation": _ctx.buildId("cancel"),
                  disable: _ctx.disableCloseBtn,
                  icon: "mdi-close",
                  tertiary: "",
                  onClick: _ctx.onDialogCancel
                }, null, 8, ["data-automation", "disable", "onClick"])) : createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["data-automation"]),
          withDirectives(createElementVNode("div", {
            class: "column no-wrap full-height",
            "data-automation": _ctx.buildId("content")
          }, [
            createVNode(_component_SuspenseWithError, null, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "default", {}, void 0, true)
              ]),
              _: 3
            })
          ], 8, _hoisted_3$9), [
            [vShow, _ctx.isDefaultStep]
          ]),
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.stack, (step, index2) => {
            return withDirectives((openBlock(), createElementBlock("div", {
              key: index2,
              class: "column no-wrap full-height",
              "data-automation": _ctx.buildId("stack-${index}")
            }, [
              createVNode(_component_SuspenseWithError, null, {
                default: withCtx(() => [
                  (openBlock(), createBlock(resolveDynamicComponent(step.component), mergeProps({ ref_for: true }, step.componentProps), null, 16))
                ]),
                _: 2
              }, 1024)
            ], 8, _hoisted_4$6)), [
              [vShow, _ctx.isCurrentStep(step)]
            ]);
          }), 128))
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 16, ["data-automation", "position"]);
}
const StepSidebar = /* @__PURE__ */ _export_sfc$1(_sfc_main$n, [["render", _sfc_render$f], ["__scopeId", "data-v-7f69bd2b"]]);
const _sfc_main$m = defineComponent({
  name: "StepSidebarContent",
  components: {
    QCardActions: QCardActions_default$1,
    QCardSection: QCardSection_default$1,
    QSpace: QSpace_default,
    ScrollArea,
    SidebarLoading,
    SpinnerAbsolute
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    contentClass: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Focus field on initial component render
     */
    focusFirstInput: {
      type: Boolean,
      default: true
    },
    headerClass: {
      type: [Array, Object, String],
      default: void 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadingExtended: {
      type: Boolean,
      default: false
    },
    saving: {
      type: Boolean,
      default: false
    },
    step: {
      type: Object,
      default: void 0
    },
    title: {
      type: String,
      default: ""
    }
  },
  emits: ["on-submit"],
  setup(props4, { emit }) {
    function onSubmit() {
      emit("on-submit");
    }
    return {
      onSubmit,
      ...useAutomation(computed(() => props4.dataAutomation))
    };
  }
});
const _hoisted_1$g = ["data-automation"];
function _sfc_render$e(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SpinnerAbsolute = resolveComponent("SpinnerAbsolute");
  const _component_SidebarLoading = resolveComponent("SidebarLoading");
  const _component_ScrollArea = resolveComponent("ScrollArea");
  const _component_QCardSection = resolveComponent("QCardSection");
  const _component_QSpace = resolveComponent("QSpace");
  const _component_QCardActions = resolveComponent("QCardActions");
  const _directive_focus = resolveDirective("focus");
  const _directive_hotkey = resolveDirective("hotkey");
  return openBlock(), createElementBlock(Fragment, null, [
    renderSlot(_ctx.$slots, "title", {}, () => [
      _ctx.title || _ctx.$slots["append-title"] ? (openBlock(), createElementBlock("div", mergeProps({ key: 0 }, _ctx.dataAttrs, {
        class: ["sidebar__title row items-center justify-between text-subtitle1 q-px-lg q-pb-md", _ctx.headerClass],
        "data-automation": _ctx.buildId()
      }), [
        createTextVNode(toDisplayString(_ctx.title) + " ", 1),
        renderSlot(_ctx.$slots, "append-title", {}, void 0, true)
      ], 16, _hoisted_1$g)) : createCommentVNode("", true)
    ], true),
    withDirectives((openBlock(), createBlock(_component_QCardSection, {
      class: "fit q-pa-none relative-position",
      "data-automation": _ctx.buildId("content")
    }, {
      default: withCtx(() => [
        _ctx.saving || _ctx.loading ? (openBlock(), createBlock(_component_SpinnerAbsolute, {
          key: 0,
          "data-automation": _ctx.buildId("loading")
        }, null, 8, ["data-automation"])) : createCommentVNode("", true),
        _ctx.loadingExtended ? (openBlock(), createBlock(_component_SidebarLoading, {
          key: 1,
          "data-automation": _ctx.buildId("loading-extended")
        }, null, 8, ["data-automation"])) : createCommentVNode("", true),
        createVNode(_component_ScrollArea, {
          class: "full-height",
          "data-automation": _ctx.buildId("scrollArea")
        }, {
          default: withCtx(() => [
            createElementVNode("div", {
              class: normalizeClass(["sidebar__content q-pb-md", [
                _ctx.contentClass,
                { "disabled no-pointer-events": _ctx.saving || _ctx.loading || _ctx.loadingExtended }
              ]])
            }, [
              !_ctx.loading ? renderSlot(_ctx.$slots, "default", { key: 0 }, void 0, true) : createCommentVNode("", true)
            ], 2)
          ]),
          _: 3
        }, 8, ["data-automation"])
      ]),
      _: 3
    }, 8, ["data-automation"])), [
      [_directive_focus, _ctx.focusFirstInput],
      [_directive_hotkey, { "Enter": _ctx.onSubmit }]
    ]),
    createVNode(_component_QSpace),
    _ctx.$slots["actions"] ? (openBlock(), createBlock(_component_QCardActions, {
      key: 0,
      class: "row q-pa-none z-top",
      "data-automation": _ctx.buildId("actions")
    }, {
      default: withCtx(() => [
        createElementVNode("div", {
          class: normalizeClass(["sidebar__actions col-grow shadow-6 q-px-lg q-py-md", { "disabled no-pointer-events": _ctx.saving || _ctx.loading }])
        }, [
          renderSlot(_ctx.$slots, "actions", {}, void 0, true)
        ], 2)
      ]),
      _: 3
    }, 8, ["data-automation"])) : createCommentVNode("", true)
  ], 64);
}
const StepSidebarContent = /* @__PURE__ */ _export_sfc$1(_sfc_main$m, [["render", _sfc_render$e], ["__scopeId", "data-v-74414917"]]);
const _sfc_main$l = defineComponent({
  name: "TableCard",
  components: {
    Button,
    QCard: QCard_default$1,
    QCardSection: QCardSection_default$1,
    QMenu: QMenu_default$1
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    clickableCard: {
      type: Boolean,
      default: false
    },
    cols: {
      type: Array,
      required: true
    },
    customActions: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      required: true
    },
    selecting: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    "menuChange"
  ],
  setup(props4, { emit }) {
    const menuOpen = ref$1(false);
    function onMenuChange(open2) {
      emit("menuChange", open2, props4.row);
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      menuOpen,
      onMenuChange
    };
  }
});
function _sfc_render$d(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QCardSection = resolveComponent("QCardSection");
  const _component_Button = resolveComponent("Button");
  const _component_QMenu = resolveComponent("QMenu");
  const _component_QCard = resolveComponent("QCard");
  return openBlock(), createBlock(_component_QCard, mergeProps(_ctx.$attrs, {
    class: ["rv-table-card", {
      "rv-table-card--clickable": _ctx.clickableCard
    }],
    "data-automation": _ctx.buildId()
  }), {
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "cardHeader", {}, void 0, true),
      _ctx.selecting || _ctx.$slots.cardTitle ? (openBlock(), createBlock(_component_QCardSection, {
        key: 0,
        class: "rv-table-card__title row no-wrap items-start q-pb-none"
      }, {
        default: withCtx(() => [
          _ctx.selecting ? renderSlot(_ctx.$slots, "select", { key: 0 }, void 0, true) : createCommentVNode("", true),
          renderSlot(_ctx.$slots, "cardTitle", {}, void 0, true)
        ]),
        _: 3
      })) : createCommentVNode("", true),
      _ctx.$slots["actions"] ? (openBlock(), createElementBlock("div", {
        key: 1,
        class: "rv-table-card__actions cursor-pointer",
        onClick: _cache[1] || (_cache[1] = withModifiers(() => {
        }, ["stop"]))
      }, [
        _ctx.customActions ? renderSlot(_ctx.$slots, "actions", normalizeProps(mergeProps({ key: 0 }, _ctx.row || {})), void 0, true) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          createVNode(_component_Button, {
            class: "no-padding",
            color: "grey-1",
            "data-automation": _ctx.buildId("dots"),
            icon: "mdi-dots-horizontal",
            tertiary: ""
          }, null, 8, ["data-automation"]),
          createVNode(_component_QMenu, {
            modelValue: _ctx.menuOpen,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event) => _ctx.menuOpen = $event),
              _ctx.onMenuChange
            ],
            "auto-close": ""
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "actions", {}, void 0, true)
            ]),
            _: 3
          }, 8, ["modelValue", "onUpdate:modelValue"])
        ], 64))
      ])) : createCommentVNode("", true),
      createVNode(_component_QCardSection, null, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "cardContent", {}, void 0, true)
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 16, ["class", "data-automation"]);
}
const TableCard = /* @__PURE__ */ _export_sfc$1(_sfc_main$l, [["render", _sfc_render$d], ["__scopeId", "data-v-804513b5"]]);
const _sfc_main$k = defineComponent({
  name: "Table",
  components: {
    ActionButton,
    Input,
    Select
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Show elements on the center
     */
    centered: {
      default: false,
      type: Boolean
    },
    /**
     * Hide dropdown to set items per page
     */
    hidePageSizeSelection: {
      default: false,
      type: Boolean
    },
    rowsPerPageOptions: {
      type: Array,
      default: () => [10, 20, 50, 100, 0]
    },
    /**
     * Show with space between table and pagination block§
     */
    separated: {
      default: false,
      type: Boolean
    }
  },
  setup(props4) {
    const { t: t22 } = useI18n();
    const {
      pagination,
      tableRef
    } = useTable();
    const newPage = ref$1("");
    const inputRef = ref$1();
    const computedRowsPerPageOptions = computed(() => {
      return props4.rowsPerPageOptions.map((count) => ({
        label: count === 0 ? "All" : String(count),
        // TODO i18n
        value: count
      }));
    });
    const disableRowsPerPage = computed(() => {
      const min2 = Math.min(...props4.rowsPerPageOptions.filter((c3) => !!c3));
      return (pagination.value.rowsNumber ?? 0) < min2;
    });
    const page = computed(() => pagination.value.page ?? 1);
    const rowsPerPage = computed({
      get() {
        return pagination.value.rowsPerPage ?? 0;
      },
      set(rowsPerPage2) {
        setPagination({ rowsPerPage: rowsPerPage2 });
      }
    });
    const totalPages = computed(() => {
      const rowsNumber = pagination.value.rowsNumber ?? 0;
      const rowsPerPage2 = pagination.value.rowsPerPage ?? 0;
      const pages = rowsPerPage2 ? Math.ceil(rowsNumber / rowsPerPage2) : 1;
      return Math.max(pages, 1);
    });
    function firstPage() {
      setPagination({ page: 1 });
    }
    function lastPage() {
      setPagination({ page: totalPages.value });
    }
    function nextPage() {
      if (page.value >= totalPages.value) return;
      setPagination({ page: page.value + 1 });
    }
    function previousPage() {
      if (page.value <= 1) return;
      setPagination({ page: page.value - 1 });
    }
    function setPagination(update6) {
      var _a;
      const paginationObject = {
        ...pagination.value,
        ...update6
      };
      (_a = tableRef.value) == null ? void 0 : _a.requestServerInteraction({
        pagination: {
          ...paginationObject,
          sortBy: paginationObject.sortBy ?? void 0
        }
      });
    }
    async function onBlur2() {
      let value2 = parseInt(newPage.value, 10);
      newPage.value = "";
      if (isNaN(value2) || value2 === page.value) return;
      value2 = Math.max(1, Math.min(totalPages.value, value2));
      setPagination({ page: value2 });
    }
    function onEnter() {
      var _a;
      (_a = inputRef.value) == null ? void 0 : _a.blur();
    }
    function onKeyPress(e22) {
      if (!/\d/g.test(e22.key)) e22.preventDefault();
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      computedRowsPerPageOptions,
      disableRowsPerPage,
      firstPage,
      inputRef,
      lastPage,
      newPage,
      nextPage,
      onBlur: onBlur2,
      onEnter,
      onKeyPress,
      page,
      previousPage,
      rowsPerPage,
      t: t22,
      totalPages
    };
  }
});
const _hoisted_1$f = ["data-automation"];
const _hoisted_2$9 = ["data-automation"];
const _hoisted_3$8 = ["data-automation"];
const _hoisted_4$5 = { class: "row items-center" };
const _hoisted_5$5 = { class: "text-body3 text-grey-1 block q-mr-md" };
const _hoisted_6$3 = {
  key: 1,
  class: "row items-center no-wrap q-ml-sm"
};
const _hoisted_7$3 = { class: "text-subtitle3 text-grey-1" };
const _hoisted_8$2 = ["data-automation"];
function _sfc_render$c(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Select = resolveComponent("Select");
  const _component_ActionButton = resolveComponent("ActionButton");
  const _component_Input = resolveComponent("Input");
  return openBlock(), createElementBlock("div", {
    class: "column full-width",
    "data-automation": _ctx.buildId("wrapper")
  }, [
    _ctx.separated ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: "full-width q-py-sm bg-grey-5",
      "data-automation": _ctx.buildId("separation")
    }, null, 8, _hoisted_2$9)) : createCommentVNode("", true),
    createElementVNode("div", {
      class: normalizeClass(["table-pagination row full-width bg-white", {
        "justify-center": _ctx.centered,
        "q-py-sm": _ctx.separated
      }]),
      "data-automation": _ctx.buildId()
    }, [
      createElementVNode("div", _hoisted_4$5, [
        !_ctx.hidePageSizeSelection ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createElementVNode("span", _hoisted_5$5, toDisplayString(_ctx.t("rvai-base.general.table.recordPerPage")), 1),
          createVNode(_component_Select, {
            modelValue: _ctx.rowsPerPage,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.rowsPerPage = $event),
            "data-automation": _ctx.buildId("rowsPerPage"),
            dense: "",
            disable: _ctx.disableRowsPerPage,
            "emit-value": "",
            "map-options": "",
            options: _ctx.computedRowsPerPageOptions,
            "options-dense": ""
          }, null, 8, ["modelValue", "data-automation", "disable", "options"])
        ], 64)) : createCommentVNode("", true),
        _ctx.rowsPerPage !== 0 ? (openBlock(), createElementBlock("div", _hoisted_6$3, [
          createVNode(_component_ActionButton, {
            class: "text-grey-1",
            "data-automation": _ctx.buildId("firstPage"),
            disable: _ctx.page === 1,
            icon: "mdi-chevron-double-left",
            size: "md",
            tertiary: "",
            onClick: _ctx.firstPage
          }, null, 8, ["data-automation", "disable", "onClick"]),
          createVNode(_component_ActionButton, {
            class: "text-grey-1",
            "data-automation": _ctx.buildId("previousPage"),
            disable: _ctx.page === 1,
            icon: "mdi-chevron-left",
            size: "md",
            tertiary: "",
            onClick: _ctx.previousPage
          }, null, 8, ["data-automation", "disable", "onClick"]),
          createVNode(_component_Input, {
            ref: "inputRef",
            modelValue: _ctx.newPage,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.newPage = $event),
            class: "table-pagination__input q-mx-sm",
            "data-automation": _ctx.buildId("currentPage"),
            disable: _ctx.totalPages <= 1,
            "input-class": "text-center",
            placeholder: String(_ctx.page),
            type: "number",
            onBlur: _ctx.onBlur,
            onKeypress: _ctx.onKeyPress,
            onKeyup: withKeys(_ctx.onEnter, ["enter"])
          }, null, 8, ["modelValue", "data-automation", "disable", "placeholder", "onBlur", "onKeypress", "onKeyup"]),
          createElementVNode("span", _hoisted_7$3, [
            createTextVNode(toDisplayString(_ctx.t("rvai-base.general.symbols.slash")) + " ", 1),
            createElementVNode("span", {
              "data-automation": _ctx.buildId("totalPage")
            }, toDisplayString(_ctx.totalPages), 9, _hoisted_8$2)
          ]),
          createVNode(_component_ActionButton, {
            class: "text-grey-1 q-ml-sm",
            "data-automation": _ctx.buildId("nextPage"),
            disable: _ctx.page === _ctx.totalPages,
            icon: "mdi-chevron-right",
            size: "md",
            tertiary: "",
            onClick: _ctx.nextPage
          }, null, 8, ["data-automation", "disable", "onClick"]),
          createVNode(_component_ActionButton, {
            class: "text-grey-1",
            "data-automation": _ctx.buildId("lastPage"),
            disable: _ctx.page === _ctx.totalPages,
            icon: "mdi-chevron-double-right",
            size: "md",
            tertiary: "",
            onClick: _ctx.lastPage
          }, null, 8, ["data-automation", "disable", "onClick"])
        ])) : createCommentVNode("", true)
      ])
    ], 10, _hoisted_3$8)
  ], 8, _hoisted_1$f);
}
const TablePagination = /* @__PURE__ */ _export_sfc$1(_sfc_main$k, [["render", _sfc_render$c], ["__scopeId", "data-v-5f22dc8f"]]);
const _sfc_main$j = defineComponent({
  name: "TableSortBy",
  components: {
    SortSelect
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    }
  },
  setup(props4) {
    const { t: t22 } = useI18n();
    const {
      pagination,
      selectedItem,
      sortableItems,
      tableRef
    } = useTable();
    if (pagination.value.sortBy) {
      selectedItem.value = sortableItems.value.find((i22) => i22.name === pagination.value.sortBy && pagination.value.descending === i22.descending);
    } else {
      selectedItem.value = null;
    }
    watch(selectedItem, (item) => {
      var _a;
      if (!item) return;
      (_a = tableRef.value) == null ? void 0 : _a.requestServerInteraction({
        pagination: {
          ...pagination.value,
          descending: item.descending,
          sortBy: item.name
        }
      });
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      selectedItem,
      sortableItems,
      t: t22
    };
  }
});
function _sfc_render$b(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SortSelect = resolveComponent("SortSelect");
  return openBlock(), createBlock(_component_SortSelect, {
    modelValue: _ctx.selectedItem,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.selectedItem = $event),
    class: "rv-table-sort-by row",
    "data-automation": _ctx.buildId(),
    options: _ctx.sortableItems
  }, null, 8, ["modelValue", "data-automation", "options"]);
}
const TableSortBy = /* @__PURE__ */ _export_sfc$1(_sfc_main$j, [["render", _sfc_render$b], ["__scopeId", "data-v-d84e3eb6"]]);
const SLOTS_COLUMNS = {
  "row-actions": {
    label: "",
    name: "actions"
  }
};
const _sfc_main$i = defineComponent({
  name: "Table",
  components: {
    ActionButton,
    Button,
    Checkbox,
    Input,
    NoData,
    QIcon: QIcon_default$1,
    QMenu: QMenu_default$1,
    QResizeObserver: QResizeObserver_default$1,
    QSpace: QSpace_default,
    QTable: QTable_default,
    QTd: QTd_default,
    QTh: QTh_default$1,
    QTr: QTr_default,
    TableCard,
    TablePagination,
    TableSortBy,
    Tooltip: Tooltip2
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    bottomPaginationCentered: {
      type: Boolean,
      default: false
    },
    bottomPaginationSeparated: {
      type: Boolean,
      default: false
    },
    clickableCard: {
      type: Boolean,
      default: false
    },
    defaultGrid: {
      type: Boolean,
      default: false
    },
    fakeSelection: {
      type: Boolean,
      default: false
    },
    gridClass: {
      type: Function,
      default: () => String
    },
    gridResponsive: {
      type: Boolean,
      default: true
    },
    hideGridButton: {
      type: Boolean,
      default: false
    },
    hideHeader: {
      type: Boolean,
      default: false
    },
    hideImmutableRowActions: {
      type: Boolean,
      default: true
    },
    hideListButton: {
      type: Boolean,
      default: false
    },
    hidePagination: {
      type: Boolean,
      default: true
    },
    hideRightSidebar: {
      type: Boolean,
      default: true
    },
    hidePageSizeSelection: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      required: true
    },
    noPersistConfig: {
      type: Boolean,
      default: false
    },
    rowsPerPageOptions: {
      type: Array,
      default: void 0
    },
    selected: {
      type: Array,
      default: () => void 0
    },
    selectable: {
      type: Boolean,
      default: true
    },
    selectedTitle: {
      type: String,
      default: ""
    },
    selection: {
      type: String,
      default: "multiple"
    },
    showSelectCount: {
      type: Boolean,
      default: false
    },
    showSortBy: {
      type: Boolean,
      default: false
    },
    showTopPagination: {
      type: Boolean,
      default: false
    },
    virtualScroll: {
      type: Boolean,
      default: true
    },
    withFilters: {
      type: Boolean,
      default: true
    },
    customActions: {
      type: Boolean,
      default: false
    },
    wrapperClass: {
      type: [Array, String, Object],
      default: void 0
    }
  },
  emits: [
    "card-click",
    "menuChange",
    "on-toggle-all",
    "set-columns",
    "set-grid",
    "update:selected"
  ],
  setup(props4, {
    emit,
    slots
  }) {
    const { t: t22 } = useI18n();
    const {
      allSelected,
      allSelectedValue,
      clearSelection: clearSelection2,
      columns,
      colWidth,
      disableNextButton,
      disablePreviousButton,
      enableSelection,
      filteredSelected,
      filters,
      getConfig,
      hasFilterableValues,
      hasFilters,
      hasNoData,
      hasRowActions,
      hasSearchQueryFilter,
      immutableKey,
      initializeFilters,
      isCarouselEnabled,
      nextColumn,
      onRequest,
      onResize,
      pagination,
      prevColumn,
      resetFilters,
      resetSearchQuery,
      rowKey,
      rows,
      search,
      searchable,
      selectableRows,
      selecting,
      serverLoading,
      setCarouselCalculationsEnabled,
      setConfig,
      tableRef,
      toggleAll,
      toggleSelected,
      toggleSelecting,
      totalRows,
      transformOffsetLeft,
      updateSelection
    } = useTable();
    const {
      isDefaultLayout,
      showRightSidebar,
      toggleRightSidebar
    } = useLayout();
    let scrollTicking = false;
    const config = !props4.noPersistConfig && getConfig() || void 0;
    const thRefs = ref$1([]);
    const wrapperRef = ref$1(null);
    const grid = ref$1((config == null ? void 0 : config.grid) ?? props4.defaultGrid);
    const menuOpen = ref$1(null);
    const isScrolled = ref$1(false);
    const isScrolledGrid = ref$1(false);
    const hasVerticalScroll = ref$1(false);
    const hasScrollbar2 = ref$1(false);
    const allColumns = computed(() => {
      return [
        ...columns.value,
        ...slotsColumns.value,
        isCarouselEnabled.value && {
          label: "",
          name: "carousel-next"
        }
      ].filter(Boolean);
    });
    const otherColumns = computed(() => {
      const cellSlots = Object.keys(slots).filter((x22) => x22.startsWith("body-cell-")).map((x22) => x22.replace(/^body-cell-/, ""));
      return columns.value.filter((c3) => !cellSlots.includes(c3.name));
    });
    const cssVars = computed(() => {
      return {
        "--table-col-width": colWidth.value,
        "--table-transform": `translate(-${transformOffsetLeft.value}px, 0)`
      };
    });
    const filteredRowsCount = computed(() => pagination.value.rowsNumber);
    const hasFilteredRows = computed(() => filteredRowsCount.value !== totalRows.value);
    const hasSelectedRows = computed(() => !!allSelected.value.length);
    const isFiltersPanelOpened = computed(() => isDefaultLayout.value);
    const isLoading = computed(() => props4.loading || serverLoading.value);
    const isTableEmpty = computed(() => {
      return hasNoData.value && !isLoading.value || hasNoFiltersResult.value || hasNoSearchQueryResult.value;
    });
    const hasDivider = computed(() => {
      return !disablePreviousButton.value;
    });
    const hasNoFiltersResult = computed(() => {
      return !rows.value.length && !isLoading.value && hasFilters.value;
    });
    const hasNoSearchQueryResult = computed(() => {
      return !rows.value.length && !isLoading.value && hasSearchQueryFilter.value;
    });
    const slotsColumns = computed(() => {
      return Object.keys(SLOTS_COLUMNS).filter((k22) => {
        if (k22 === "row-actions" && !hasRowActions) return false;
        return !!slots[k22];
      }).map((k22) => SLOTS_COLUMNS[k22]);
    });
    const visibleColumns = computed(() => {
      return allColumns.value.map((c3) => c3.name);
    });
    const checkForScrollbar = () => {
      if (wrapperRef.value) {
        hasScrollbar2.value = wrapperRef.value.scrollHeight > wrapperRef.value.clientHeight;
      }
    };
    function hasActionsColumn(columns2) {
      return columns2.some((v) => v.name === "actions");
    }
    function checkVirtualScrollPresented() {
      var _a;
      const children = (_a = tableRef.value) == null ? void 0 : _a.$el.children;
      if (!children) return false;
      const virtualScrollElement = [...children].find((el) => el.classList.contains("q-virtual-scroll"));
      return (virtualScrollElement == null ? void 0 : virtualScrollElement.scrollHeight) > (virtualScrollElement == null ? void 0 : virtualScrollElement.clientHeight);
    }
    function onCardClick(row) {
      if (!props4.clickableCard) return;
      emit("card-click", row);
    }
    function onCheckboxClick(row, event) {
      if (props4.fakeSelection) return;
      toggleSelected(row, event.shiftKey);
    }
    function onClearSelection() {
      clearSelection2();
      emit("on-toggle-all", false);
    }
    function onMenuChange(open2, row) {
      menuOpen.value = open2 ? row : null;
      emit("menuChange", open2, row);
    }
    function onScrollVirtual(v) {
      isScrolled.value = v.index !== 0;
    }
    function onScrollWrapper() {
      if (!scrollTicking) {
        window.requestAnimationFrame(() => {
          var _a, _b;
          isScrolledGrid.value = !!(((_a = wrapperRef.value) == null ? void 0 : _a.scrollTop) && ((_b = wrapperRef.value) == null ? void 0 : _b.scrollTop) > 0);
          scrollTicking = false;
        });
        scrollTicking = true;
      }
    }
    function onToggleAll(value2) {
      toggleAll(value2);
      emit("on-toggle-all", value2);
    }
    function setThRef(el) {
      if (el) {
        thRefs.value.push(el);
      }
    }
    function showThTooltip(index2) {
      var _a;
      const el = (_a = thRefs.value[index2]) == null ? void 0 : _a.$el;
      return !!el && el.scrollWidth > el.clientWidth;
    }
    const onVirtualScroll = throttle$1(
      (event) => {
        const isTableScrolled = event.composedPath().some((el) => {
          var _a;
          return (_a = el.classList) == null ? void 0 : _a.contains("q-virtual-scroll");
        });
        if (!isTableScrolled) return;
        if (event.deltaX > 0 && !disableNextButton.value) nextColumn();
        if (event.deltaX < 0 && !disablePreviousButton.value) prevColumn();
      },
      300,
      { trailing: false }
    );
    function setGrid(value2) {
      grid.value = value2;
      setCarouselCalculationsEnabled(!value2);
      if (!props4.noPersistConfig) setConfig({ grid: grid.value });
      emit("set-grid", value2);
    }
    watch(filteredSelected, (value2) => {
      emit("update:selected", value2);
      void nextTick(() => {
        hasVerticalScroll.value = checkVirtualScrollPresented();
      });
    });
    watch(() => props4.selected, (value2) => {
      value2 && updateSelection(value2);
    });
    watch(columns, () => {
      void initializeFilters();
    });
    onMounted(() => {
      var _a, _b;
      if (((_a = props4.selected) == null ? void 0 : _a.length) && !allSelected.value.length) {
        allSelected.value = props4.selected;
      }
      (_b = tableRef.value) == null ? void 0 : _b.requestServerInteraction();
      void initializeFilters();
      !hasNoData.value && showRightSidebar.value && props4.hideRightSidebar && toggleRightSidebar();
      isCarouselEnabled.value && document.addEventListener("wheel", onVirtualScroll);
      if (grid.value) {
        checkForScrollbar();
      }
    });
    onUpdated(() => {
      if (grid.value) {
        checkForScrollbar();
      }
    });
    onUnmounted(() => {
      isCarouselEnabled.value && document.removeEventListener("wheel", onVirtualScroll);
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      allColumns,
      allSelected,
      allSelectedValue,
      colWidth,
      cssVars,
      disableNextButton,
      disablePreviousButton,
      enableSelection,
      filteredRowsCount,
      filters,
      grid,
      hasActionsColumn,
      hasDivider,
      hasFilterableValues,
      hasFilteredRows,
      hasFilters,
      hasNoData,
      hasNoFiltersResult,
      hasNoSearchQueryResult,
      hasScrollbar: hasScrollbar2,
      hasSearchQueryFilter,
      hasSelectedRows,
      hasVerticalScroll,
      immutableKey,
      isCarouselEnabled,
      isFiltersPanelOpened,
      isLoading,
      isScrolled,
      isScrolledGrid,
      isTableEmpty,
      menuOpen,
      nextColumn,
      onCardClick,
      onCheckboxClick,
      onClearSelection,
      onMenuChange,
      onRequest,
      onResize,
      onScrollVirtual,
      onScrollWrapper,
      onToggleAll,
      otherColumns,
      pagination,
      prevColumn,
      resetFilters,
      resetSearchQuery,
      rowKey,
      rows,
      search,
      searchable,
      selectableRows,
      selecting,
      setGrid,
      setThRef,
      showThTooltip,
      t: t22,
      tableRef,
      toggleRightSidebar,
      toggleSelecting,
      totalRows,
      visibleColumns,
      wrapperRef
    };
  }
});
const _hoisted_1$e = ["data-automation"];
const _hoisted_2$8 = { class: "rv-table__top row no-wrap full-width" };
const _hoisted_3$7 = { class: "row no-wrap items-center" };
const _hoisted_4$4 = { class: "rv-table__modes row no-wrap q-gutter-x-sm" };
const _hoisted_5$4 = { class: "row q-gutter-x-sm q-ml-md" };
const _hoisted_6$2 = { class: "row no-wrap q-gutter-x-sm items-center" };
const _hoisted_7$2 = {
  key: 0,
  class: "rv-table__top-inside row no-wrap full-width"
};
const _hoisted_8$1 = {
  key: 1,
  class: "flex full-width justify-between q-px-md q-pb-sm"
};
const _hoisted_9$1 = { class: "flex flex-center" };
const _hoisted_10$1 = {
  key: 0,
  class: "text-body3 text-grey-1"
};
const _hoisted_11$1 = {
  key: 1,
  class: "text-body3 text-grey-1 q-mx-xs"
};
const _hoisted_12 = {
  key: 2,
  class: "text-body3 text-grey-1"
};
const _hoisted_13 = {
  key: 2,
  class: "flex full-width justify-between q-pt-md bg-grey-5"
};
const _hoisted_14 = { class: "flex flex-center" };
const _hoisted_15 = {
  key: 3,
  class: "flex full-width justify-end q-pt-md bg-grey-5"
};
const _hoisted_16 = { class: "rv-table__header__backplate" };
const _hoisted_17 = {
  key: 1,
  class: "rv-table__row-progress absolute",
  style: { "right": "64px", "top": "8px" }
};
const _hoisted_18 = {
  class: "absolute text-bold",
  style: { "right": "0", "z-index": "2" }
};
const _hoisted_19 = {
  class: "row no-wrap flex items-center",
  style: { "height": "32px" }
};
const _hoisted_20 = { key: 1 };
const _hoisted_21 = { key: 2 };
function _sfc_render$a(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QResizeObserver = resolveComponent("QResizeObserver");
  const _component_ActionButton = resolveComponent("ActionButton");
  const _component_TablePagination = resolveComponent("TablePagination");
  const _component_Button = resolveComponent("Button");
  const _component_QSpace = resolveComponent("QSpace");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_Input = resolveComponent("Input");
  const _component_Checkbox = resolveComponent("Checkbox");
  const _component_TableSortBy = resolveComponent("TableSortBy");
  const _component_TableCard = resolveComponent("TableCard");
  const _component_QTh = resolveComponent("QTh");
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_QTr = resolveComponent("QTr");
  const _component_QMenu = resolveComponent("QMenu");
  const _component_QTd = resolveComponent("QTd");
  const _component_QTable = resolveComponent("QTable");
  const _component_NoData = resolveComponent("NoData");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["rv-table__wrapper", _ctx.wrapperClass]),
    "data-automation": _ctx.buildId()
  }, [
    createElementVNode("div", {
      ref: "wrapperRef",
      class: normalizeClass(["rv-table", {
        "rv-table--carousel": _ctx.isCarouselEnabled,
        "rv-table--grid": _ctx.grid,
        "rv-table--list": !_ctx.grid,
        "rv-table--select": _ctx.selection !== "none",
        "rv-table--shadow": _ctx.grid && _ctx.isScrolledGrid,
        "rv-table--empty": _ctx.isTableEmpty,
        "rv-table--without-selection": !_ctx.enableSelection,
        "rv-table--pagination-separated": _ctx.bottomPaginationSeparated,
        "rv-table--with-scrollbar": _ctx.hasScrollbar
      }]),
      style: normalizeStyle(_ctx.cssVars),
      onScroll: _cache[7] || (_cache[7] = (...args) => _ctx.onScrollWrapper && _ctx.onScrollWrapper(...args))
    }, [
      createVNode(_component_QResizeObserver, { onResize: _ctx.onResize }, null, 8, ["onResize"]),
      createVNode(_component_QTable, mergeProps(_ctx.$attrs, {
        ref: "tableRef",
        pagination: _ctx.pagination,
        "onUpdate:pagination": _cache[5] || (_cache[5] = ($event) => _ctx.pagination = $event),
        selected: _ctx.allSelected,
        "onUpdate:selected": _cache[6] || (_cache[6] = ($event) => _ctx.allSelected = $event),
        "card-container-class": [
          "rv-table__grid",
          {
            "rv-table__grid--responsive": _ctx.gridResponsive,
            "hidden": !_ctx.totalRows
          }
        ],
        class: [
          "rv-table__element",
          { "rv-table--no-margin": !_ctx.totalRows }
        ],
        color: "primary",
        columns: _ctx.allColumns,
        filter: _ctx.filters,
        flat: "",
        grid: _ctx.grid,
        "hide-no-data": "",
        "hide-pagination": _ctx.hidePagination,
        "hide-selected-banner": "",
        loading: _ctx.isLoading,
        "row-key": _ctx.rowKey,
        rows: _ctx.rows,
        "rows-per-page-options": _ctx.rowsPerPageOptions,
        selection: _ctx.selection,
        separator: "none",
        "table-class": [
          _ctx.totalRows ? "rv-table__content" : "rv-table__content--hide",
          _ctx.hasVerticalScroll && "rv-table__content--with-scroll",
          _ctx.hasDivider && "rv-table__content--with-divider"
        ],
        "table-header-class": "rv-table__header",
        "virtual-scroll": _ctx.virtualScroll,
        "virtual-scroll-sticky-size-start": "56",
        "visible-columns": _ctx.visibleColumns,
        onRequest: _ctx.onRequest,
        onVirtualScroll: _ctx.onScrollVirtual
      }), createSlots({
        item: withCtx((props4) => [
          createVNode(_component_TableCard, mergeProps(props4, {
            class: _ctx.gridClass(props4.row),
            "clickable-card": !props4.row[_ctx.immutableKey] && _ctx.clickableCard,
            "custom-actions": _ctx.customActions,
            "data-automation": _ctx.buildId(`card-${props4.row[_ctx.rowKey]}`),
            selecting: _ctx.selecting,
            onClick: ($event) => !props4.row[_ctx.immutableKey] && _ctx.onCardClick(props4.row),
            onMenuChange: _ctx.onMenuChange
          }), createSlots({
            select: withCtx(() => [
              !props4.row[_ctx.immutableKey] ? (openBlock(), createBlock(_component_Checkbox, {
                key: 0,
                class: "q-mr-sm",
                "data-automation": _ctx.buildId(`card-${props4.row[_ctx.rowKey]}__checkbox`),
                dense: "",
                disable: _ctx.fakeSelection,
                "model-value": _ctx.fakeSelection ? true : props4.selected,
                onClick: ($event) => _ctx.onCheckboxClick(props4.row, $event)
              }, null, 8, ["data-automation", "disable", "model-value", "onClick"])) : createCommentVNode("", true)
            ]),
            cardHeader: withCtx(() => [
              renderSlot(_ctx.$slots, "cardHeader", normalizeProps(guardReactiveProps(props4 || {})))
            ]),
            cardTitle: withCtx(() => [
              renderSlot(_ctx.$slots, "cardTitle", normalizeProps(guardReactiveProps(props4 || {})))
            ]),
            cardContent: withCtx(() => [
              renderSlot(_ctx.$slots, "cardContent", normalizeProps(guardReactiveProps(props4 || {})))
            ]),
            _: 2
          }, [
            _ctx.$slots["row-actions"] && (!props4.row[_ctx.immutableKey] || !_ctx.hideImmutableRowActions) ? {
              name: "actions",
              fn: withCtx(() => [
                renderSlot(_ctx.$slots, "row-actions", normalizeProps(guardReactiveProps(props4 || {})))
              ]),
              key: "0"
            } : void 0
          ]), 1040, ["class", "clickable-card", "custom-actions", "data-automation", "selecting", "onClick", "onMenuChange"])
        ]),
        header: withCtx((props4) => [
          createVNode(_component_QTr, {
            class: "rv-table__header",
            props: props4
          }, {
            default: withCtx(() => [
              createVNode(_component_QTh, { class: "flex bg-grey-5--light bg-grey-1--dark" }, {
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, "select-all", {}, () => [
                    _ctx.enableSelection ? (openBlock(), createBlock(_component_Checkbox, {
                      key: 0,
                      "data-automation": _ctx.buildId("selectAll"),
                      disable: _ctx.fakeSelection || !_ctx.selectableRows.length,
                      "model-value": _ctx.fakeSelection ? true : _ctx.allSelectedValue,
                      "onUpdate:modelValue": _ctx.onToggleAll
                    }, null, 8, ["data-automation", "disable", "model-value", "onUpdate:modelValue"])) : createCommentVNode("", true)
                  ])
                ]),
                _: 3
              }),
              (openBlock(true), createElementBlock(Fragment, null, renderList(props4.cols.filter((v) => v.name !== "actions" && v.name !== "carousel-next"), (col, i22) => {
                return openBlock(), createBlock(_component_QTh, {
                  key: col.name,
                  ref_for: true,
                  ref: _ctx.setThRef,
                  class: "rv-table__header__column ellipsis",
                  props: props4,
                  style: normalizeStyle({
                    ..._ctx.isCarouselEnabled && {
                      "width": _ctx.colWidth,
                      "max-width": _ctx.colWidth,
                      "min-width": _ctx.colWidth
                    }
                  })
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(col.label) + " ", 1),
                    _ctx.showThTooltip(i22) ? (openBlock(), createBlock(_component_Tooltip, {
                      key: 0,
                      "data-automation": _ctx.buildId("thTooltip")
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(col.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["data-automation"])) : createCommentVNode("", true),
                    _ctx.isCarouselEnabled && i22 === 0 ? (openBlock(), createBlock(_component_Button, {
                      key: 1,
                      class: "rv-table__header__move-prev rv-table--transition-opacity full-height",
                      color: "grey-1",
                      "data-automation": _ctx.buildId("prevColumn"),
                      disable: _ctx.disablePreviousButton,
                      icon: "mdi-chevron-left",
                      style: normalizeStyle({
                        opacity: `${_ctx.disablePreviousButton ? 0 : 1} !important`
                      }),
                      tertiary: "",
                      onClick: withModifiers(_ctx.prevColumn, ["stop"])
                    }, null, 8, ["data-automation", "disable", "style", "onClick"])) : createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["props", "style"]);
              }), 128)),
              _ctx.hasActionsColumn(props4.cols) ? (openBlock(), createBlock(_component_QTh, {
                key: 0,
                class: "rv-table__header__column rv-table__header__column--fixed rv-table__header__action-column"
              }, {
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, "header-cell-actions")
                ]),
                _: 3
              })) : createCommentVNode("", true),
              _ctx.isCarouselEnabled ? (openBlock(), createBlock(_component_QTh, {
                key: 1,
                class: "rv-table__header__column rv-table__header__column--fixed rv-table__header__move-next"
              }, {
                default: withCtx(() => [
                  createElementVNode("div", _hoisted_16, [
                    createVNode(_component_Button, {
                      class: "rv-table__header__move-next__button rv-table--transition-opacity",
                      color: "grey-1",
                      "data-automation": _ctx.buildId("nextColumn"),
                      disable: _ctx.disableNextButton,
                      icon: "mdi-chevron-right",
                      style: normalizeStyle({
                        opacity: `${_ctx.disableNextButton ? 0 : 1} !important`
                      }),
                      tertiary: "",
                      onClick: withModifiers(_ctx.nextColumn, ["stop"])
                    }, null, 8, ["data-automation", "disable", "style", "onClick"])
                  ])
                ]),
                _: 1
              })) : createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["props"]),
          createVNode(_component_QTr, {
            class: normalizeClass(["rv-table__header__shadow-column", { "rv-table__header__shadow-column--active": _ctx.isScrolled }])
          }, {
            default: withCtx(() => [
              createVNode(_component_QTh),
              (openBlock(true), createElementBlock(Fragment, null, renderList(props4.cols.filter((v) => v.name !== "actions"), (col) => {
                return openBlock(), createBlock(_component_QTh, {
                  key: col.name
                });
              }), 128)),
              _ctx.hasActionsColumn(props4.cols) ? (openBlock(), createBlock(_component_QTh, { key: 0 })) : createCommentVNode("", true),
              _ctx.isCarouselEnabled ? (openBlock(), createBlock(_component_QTh, { key: 1 })) : createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["class"])
        ]),
        "body-cell-actions": withCtx((props4) => [
          createVNode(_component_QTd, { class: "rv-table__cell rv-table__cell--fixed rv-table__row-actions-wrapper" }, {
            default: withCtx(() => [
              !props4.row[_ctx.immutableKey] || !_ctx.hideImmutableRowActions ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: normalizeClass(["rv-table__row-actions cursor-pointer", { "rv-table__row-actions--open": _ctx.menuOpen === props4.row }])
              }, [
                _ctx.customActions ? renderSlot(_ctx.$slots, "row-actions", normalizeProps(mergeProps({ key: 0 }, props4 || {}))) : (openBlock(), createBlock(_component_Button, {
                  key: 1,
                  class: "no-padding",
                  color: "grey-1",
                  "data-automation": _ctx.buildId("dots"),
                  icon: "mdi-dots-horizontal",
                  tertiary: ""
                }, {
                  default: withCtx(() => [
                    createVNode(_component_QMenu, {
                      anchor: "bottom middle",
                      "auto-close": "",
                      self: "top middle",
                      "onUpdate:modelValue": ($event) => _ctx.onMenuChange($event, props4.row)
                    }, {
                      default: withCtx(() => [
                        renderSlot(_ctx.$slots, "row-actions", normalizeProps(guardReactiveProps(props4 || {})))
                      ]),
                      _: 2
                    }, 1032, ["onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1032, ["data-automation"]))
              ], 2)) : createCommentVNode("", true),
              _ctx.$slots["row-progress"] ? (openBlock(), createElementBlock("div", _hoisted_17, [
                createElementVNode("div", _hoisted_18, [
                  createElementVNode("div", _hoisted_19, [
                    renderSlot(_ctx.$slots, "row-progress", normalizeProps(guardReactiveProps(props4 || {})))
                  ])
                ])
              ])) : createCommentVNode("", true)
            ]),
            _: 2
          }, 1024)
        ]),
        "body-cell-carousel-next": withCtx(() => [
          createVNode(_component_QTd, { class: "rv-table__cell rv-table__cell--fixed" })
        ]),
        "body-selection": withCtx((props4) => [
          _ctx.enableSelection && !props4.row[_ctx.immutableKey] ? (openBlock(), createBlock(_component_Checkbox, {
            key: 0,
            class: "rv-table__body-selection",
            "data-automation": _ctx.buildId(`row-${props4.row[_ctx.rowKey]}__checkbox`),
            disable: _ctx.fakeSelection,
            "model-value": _ctx.fakeSelection ? true : props4.selected,
            onClick: ($event) => _ctx.onCheckboxClick(props4.row, $event)
          }, null, 8, ["data-automation", "disable", "model-value", "onClick"])) : createCommentVNode("", true)
        ]),
        loading: withCtx(() => [
          createElementVNode("div", {
            class: "rv-table__loading q-linear-progress__model absolute-full q-linear-progress__model--with-transition q-linear-progress__model--indeterminate",
            style: normalizeStyle({ ...!_ctx.hideHeader && { top: "56px" } })
          }, null, 4)
        ]),
        _: 2
      }, [
        !_ctx.hideHeader ? {
          name: "top",
          fn: withCtx(() => {
            var _a;
            return [
              createElementVNode("div", _hoisted_2$8, [
                createElementVNode("div", _hoisted_3$7, [
                  createElementVNode("div", _hoisted_4$4, [
                    !_ctx.hideGridButton ? (openBlock(), createBlock(_component_ActionButton, {
                      key: 0,
                      "data-automation": _ctx.buildId("module"),
                      icon: "mdi-view-module",
                      selected: _ctx.grid,
                      tooltip: _ctx.t("rvai-base.general.table.thumbnailsView"),
                      onClick: _cache[0] || (_cache[0] = ($event) => _ctx.setGrid(true))
                    }, null, 8, ["data-automation", "selected", "tooltip"])) : createCommentVNode("", true),
                    !_ctx.hideListButton ? (openBlock(), createBlock(_component_ActionButton, {
                      key: 1,
                      "data-automation": _ctx.buildId("list"),
                      icon: "mdi-view-list",
                      selected: !_ctx.grid,
                      tooltip: _ctx.t("rvai-base.general.table.listView"),
                      onClick: _cache[1] || (_cache[1] = ($event) => _ctx.setGrid(false))
                    }, null, 8, ["data-automation", "selected", "tooltip"])) : createCommentVNode("", true),
                    renderSlot(_ctx.$slots, "table-modes"),
                    !_ctx.hidePagination && _ctx.showTopPagination && _ctx.totalRows ? (openBlock(), createBlock(_component_TablePagination, {
                      key: 2,
                      "data-automation": _ctx.buildId("paginationTop"),
                      "rows-per-page-options": _ctx.rowsPerPageOptions
                    }, null, 8, ["data-automation", "rows-per-page-options"])) : createCommentVNode("", true)
                  ]),
                  createElementVNode("div", _hoisted_5$4, [
                    _ctx.enableSelection && _ctx.selectable && _ctx.grid ? (openBlock(), createBlock(_component_Button, {
                      key: 0,
                      color: "primary",
                      "data-automation": _ctx.buildId("select"),
                      disable: !_ctx.totalRows,
                      icon: _ctx.selecting && _ctx.totalRows ? "mdi-close" : "mdi-content-copy",
                      label: _ctx.selecting && _ctx.totalRows ? _ctx.t("rvai-base.general.table.cancel") : _ctx.t("rvai-base.general.table.select"),
                      size: "sm",
                      tertiary: "",
                      onClick: _ctx.toggleSelecting
                    }, null, 8, ["data-automation", "disable", "icon", "label", "onClick"])) : createCommentVNode("", true),
                    ((_a = _ctx.selected) == null ? void 0 : _a.length) ? renderSlot(_ctx.$slots, "actions", { key: 1 }) : createCommentVNode("", true)
                  ])
                ]),
                createVNode(_component_QSpace),
                createElementVNode("div", _hoisted_6$2, [
                  _ctx.searchable ? (openBlock(), createBlock(_component_Input, {
                    key: 0,
                    modelValue: _ctx.search,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.search = $event),
                    class: "rv-table__search",
                    "clear-icon": "mdi-close",
                    clearable: "",
                    "data-automation": _ctx.buildId("search"),
                    dense: "",
                    disable: _ctx.hasNoData,
                    placeholder: _ctx.t("rvai-base.general.table.search")
                  }, {
                    prepend: withCtx(() => [
                      createVNode(_component_QIcon, {
                        color: "grey-1",
                        name: "search"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "data-automation", "disable", "placeholder"])) : createCommentVNode("", true),
                  _ctx.withFilters ? (openBlock(), createBlock(_component_ActionButton, {
                    key: 1,
                    "data-automation": _ctx.buildId("sidebar"),
                    disable: _ctx.hasNoData || !_ctx.hasFilterableValues,
                    icon: "mdi-filter",
                    selected: _ctx.isFiltersPanelOpened || _ctx.hasFilters,
                    tooltip: _ctx.t("rvai-base.general.table.filter"),
                    onClick: _ctx.toggleRightSidebar
                  }, null, 8, ["data-automation", "disable", "selected", "tooltip", "onClick"])) : createCommentVNode("", true)
                ]),
                renderSlot(_ctx.$slots, "top-right")
              ]),
              _ctx.$slots["top-inside"] && !_ctx.grid ? (openBlock(), createElementBlock("div", _hoisted_7$2, [
                renderSlot(_ctx.$slots, "top-inside")
              ])) : createCommentVNode("", true),
              !_ctx.grid && _ctx.showSelectCount && _ctx.totalRows && (_ctx.hasSelectedRows || _ctx.hasFilteredRows) ? (openBlock(), createElementBlock("div", _hoisted_8$1, [
                createElementVNode("div", _hoisted_9$1, [
                  _ctx.hasSelectedRows ? (openBlock(), createElementBlock("div", _hoisted_10$1, toDisplayString(_ctx.allSelected.length ? _ctx.t("rvai-base.general.table.selected", [_ctx.allSelected.length, _ctx.totalRows]) : _ctx.t("rvai-base.general.table.total", [_ctx.totalRows])), 1)) : createCommentVNode("", true),
                  _ctx.hasSelectedRows && _ctx.hasFilteredRows ? (openBlock(), createElementBlock("div", _hoisted_11$1, toDisplayString(_ctx.t("rvai-base.general.symbols.dash")), 1)) : createCommentVNode("", true),
                  _ctx.hasFilteredRows ? (openBlock(), createElementBlock("div", _hoisted_12, toDisplayString(_ctx.t("rvai-base.general.table.filteredResults", [_ctx.filteredRowsCount, _ctx.totalRows])), 1)) : createCommentVNode("", true),
                  _ctx.allSelected.length ? (openBlock(), createBlock(_component_Button, {
                    key: 3,
                    class: "q-ml-xs",
                    "data-automation": _ctx.buildId("clear"),
                    label: _ctx.t("rvai-base.general.table.clear"),
                    size: "sm",
                    style: { "padding-top": "0", "padding-bottom": "0" },
                    tertiary: "",
                    onClick: _cache[3] || (_cache[3] = ($event) => _ctx.onClearSelection())
                  }, null, 8, ["data-automation", "label"])) : createCommentVNode("", true)
                ])
              ])) : _ctx.grid && _ctx.selecting && _ctx.totalRows ? (openBlock(), createElementBlock("div", _hoisted_13, [
                createElementVNode("div", _hoisted_14, [
                  createVNode(_component_Checkbox, {
                    class: "q-ml-md",
                    "data-automation": _ctx.buildId("selectAll"),
                    dense: "",
                    disable: _ctx.fakeSelection,
                    label: _ctx.t("rvai-base.general.table.selected", [_ctx.allSelected.length, _ctx.totalRows]),
                    "model-value": _ctx.fakeSelection ? true : _ctx.allSelectedValue,
                    "onUpdate:modelValue": _ctx.onToggleAll
                  }, null, 8, ["data-automation", "disable", "label", "model-value", "onUpdate:modelValue"]),
                  _ctx.allSelected.length ? (openBlock(), createBlock(_component_Button, {
                    key: 0,
                    class: "q-ml-xs",
                    "data-automation": _ctx.buildId("clear"),
                    label: _ctx.t("rvai-base.general.table.clear"),
                    size: "sm",
                    style: { "padding-top": "0", "padding-bottom": "0" },
                    tertiary: "",
                    onClick: _cache[4] || (_cache[4] = ($event) => _ctx.onClearSelection())
                  }, null, 8, ["data-automation", "label"])) : createCommentVNode("", true)
                ]),
                createVNode(_component_TableSortBy, {
                  "data-automation": _ctx.buildId("sortBy")
                }, null, 8, ["data-automation"])
              ])) : _ctx.showSortBy && _ctx.grid && _ctx.totalRows && !_ctx.selecting ? (openBlock(), createElementBlock("div", _hoisted_15, [
                createVNode(_component_TableSortBy, {
                  "data-automation": _ctx.buildId("sortBy")
                }, null, 8, ["data-automation"])
              ])) : createCommentVNode("", true)
            ];
          }),
          key: "0"
        } : void 0,
        renderList(_ctx.otherColumns, (col) => {
          return {
            name: `body-cell-${col.name}`,
            fn: withCtx((slotData) => [
              createVNode(_component_QTd, {
                classes: slotData.col.classes,
                "data-automation": _ctx.buildId(`td-body-cell-${col.name}`),
                style: normalizeStyle(slotData.col.style)
              }, {
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, `body-cell-${col.name}`, normalizeProps(guardReactiveProps(slotData || {})), () => {
                    var _a;
                    return [
                      createTextVNode(toDisplayString(((_a = _ctx.tableRef) == null ? void 0 : _a.getCellValue(slotData.col, slotData.row)) ?? ""), 1)
                    ];
                  })
                ]),
                _: 2
              }, 1032, ["classes", "data-automation", "style"])
            ])
          };
        }),
        !_ctx.hidePagination ? {
          name: "bottom",
          fn: withCtx(() => [
            createVNode(_component_TablePagination, {
              centered: _ctx.bottomPaginationCentered,
              "data-automation": _ctx.buildId("pagination"),
              "hide-page-size-selection": _ctx.hidePageSizeSelection,
              "rows-per-page-options": _ctx.rowsPerPageOptions,
              separated: _ctx.bottomPaginationSeparated
            }, null, 8, ["centered", "data-automation", "hide-page-size-selection", "rows-per-page-options", "separated"])
          ]),
          key: "1"
        } : void 0,
        renderList(_ctx.$slots, (_, name2) => {
          return {
            name: name2,
            fn: withCtx((slotData) => [
              String(name2).startsWith("body-cell-") ? (openBlock(), createBlock(_component_QTd, {
                key: name2,
                classes: slotData.col.classes,
                "data-automation": _ctx.buildId(`td-${name2}`),
                style: normalizeStyle(slotData.col.style)
              }, {
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, name2, normalizeProps(guardReactiveProps(slotData || {})))
                ]),
                _: 2
              }, 1032, ["classes", "data-automation", "style"])) : renderSlot(_ctx.$slots, name2, normalizeProps(mergeProps({ key: 1 }, slotData || {})))
            ])
          };
        })
      ]), 1040, ["pagination", "selected", "card-container-class", "class", "columns", "filter", "grid", "hide-pagination", "loading", "row-key", "rows", "rows-per-page-options", "selection", "table-class", "virtual-scroll", "visible-columns", "onRequest", "onVirtualScroll"])
    ], 38),
    _ctx.hasNoData && !_ctx.isLoading ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass(_ctx.$slots["no-data"] ? "rv-table__no-data" : "hidden")
    }, [
      renderSlot(_ctx.$slots, "no-data")
    ], 2)) : _ctx.hasNoSearchQueryResult ? (openBlock(), createElementBlock("div", _hoisted_20, [
      createVNode(_component_NoData, {
        class: "rv-table__no-data",
        "data-automation": _ctx.buildId("noData"),
        "icon-name": "img:/rvai-base/robot-search.svg",
        title: _ctx.t("rvai-base.tableFields.noQueryResults")
      }, {
        default: withCtx(() => [
          createVNode(_component_Button, {
            color: "primary",
            "data-automation": _ctx.buildId("reset-search"),
            label: _ctx.t("rvai-base.tableFields.clearSearchResults"),
            size: "sm",
            onClick: _ctx.resetSearchQuery
          }, null, 8, ["data-automation", "label", "onClick"])
        ]),
        _: 1
      }, 8, ["data-automation", "title"])
    ])) : _ctx.hasNoFiltersResult ? (openBlock(), createElementBlock("div", _hoisted_21, [
      createVNode(_component_NoData, {
        class: "rv-table__no-data",
        "data-automation": _ctx.buildId("noData"),
        "icon-name": "img:/rvai-base/robot-filters.svg",
        title: _ctx.t("rvai-base.tableFields.noFilteredResults")
      }, {
        default: withCtx(() => [
          createVNode(_component_Button, {
            color: "primary",
            "data-automation": _ctx.buildId("clear-filter"),
            label: _ctx.t("rvai-base.tableFields.clearFilter"),
            size: "sm",
            onClick: _ctx.resetFilters
          }, null, 8, ["data-automation", "label", "onClick"])
        ]),
        _: 1
      }, 8, ["data-automation", "title"])
    ])) : createCommentVNode("", true)
  ], 10, _hoisted_1$e);
}
const Table = /* @__PURE__ */ _export_sfc$1(_sfc_main$i, [["render", _sfc_render$a]]);
function useDateFilter(filter, filterValueRef) {
  var _a;
  const { updateFilters } = useTable();
  const { t: t22 } = useI18n();
  const isDate2 = ((_a = filter.value) == null ? void 0 : _a.type) === TableFilterType.Date;
  const originalValueStart = ref$1("");
  const originalValueEnd = ref$1("");
  const dateFilter = filter.value;
  const dateFilterOption = ref$1(void 0);
  const filterValue = filterValueRef.value;
  const dateValue = reactive({
    end: (filterValue == null ? void 0 : filterValue.type) === TableFilterType.Date ? filterValue.value.end : "",
    start: (filterValue == null ? void 0 : filterValue.type) === TableFilterType.Date ? filterValue.value.start : ""
  });
  const dateStart = computed({
    get() {
      return dateValue.start;
    },
    set(value2) {
      dateValue.start = value2;
      setFilters();
    }
  });
  const dateEnd = computed({
    get() {
      return dateValue.end;
    },
    set(value2) {
      dateValue.end = value2;
      setFilters();
    }
  });
  const showDefaultDateFilter = computed(() => {
    var _a2;
    return !((_a2 = dateFilter.beforeOptions) == null ? void 0 : _a2.length) || !!dateFilterOption.value && !dateFilterOption.value.hideDefaultFilter;
  });
  function endRestrictions(date) {
    return !dateStart.value || formatToSlash(date) >= formatToSlash(dateStart.value);
  }
  function onUpdateDateFilterOption(value2) {
    dateFilterOption.value = value2;
    if (value2 && value2.hideDefaultFilter) {
      dateValue.start = formatDate$1(new Date(Date.now() - Number(value2.value)));
      dateValue.end = formatDate$1(/* @__PURE__ */ new Date());
    } else {
      dateValue.start = "";
      dateValue.end = "";
    }
    setFilters();
  }
  function setDateFilterOption(start, end) {
    var _a2;
    if (!((_a2 = dateFilter.beforeOptions) == null ? void 0 : _a2.length)) return;
    if (start && end) {
      const differenceInMs = differenceInMilliseconds(new Date(end), new Date(start));
      const availableOption = dateFilter.beforeOptions.find((o) => o.value === differenceInMs);
      if (start.length > 10 && end.length > 10) {
        onUpdateDateFilterOption(availableOption);
        return;
      }
    }
    dateFilterOption.value = dateFilter.beforeOptions.find((o) => !o.hideDefaultFilter);
  }
  function setFilterByDefaultDateOption() {
    const defaultFilterOption = dateFilter.beforeOptions ? dateFilter.beforeOptions.find((o) => o.selectedByDefault) || dateFilter.beforeOptions[0] : void 0;
    onUpdateDateFilterOption(defaultFilterOption);
  }
  function setFilters() {
    if (!dateValue.start && !dateValue.end) {
      updateFilters(filter.value, void 0);
    } else {
      updateFilters(filter.value, {
        key: filter.value.key,
        type: TableFilterType.Date,
        value: {
          end: dateValue.end,
          start: dateValue.start
        }
      });
    }
  }
  function setOriginalValueEnd(value2) {
    originalValueEnd.value = value2;
  }
  function setOriginalValueStart(value2) {
    originalValueStart.value = value2;
  }
  function startRestrictions(date) {
    return !dateEnd.value || formatToSlash(date) <= formatToSlash(dateEnd.value);
  }
  function formatToSlash(date) {
    return date.replace(/\-/g, "/");
  }
  const validationRules = computed(() => {
    return {
      originalValueEnd: ValidationBuilder.$t("rvai-base.filters.date.endDate").custom(
        (value2) => originalValueStart.value && value2 ? formatToSlash(value2) >= formatToSlash(originalValueStart.value) : true,
        t22("rvai-base.filters.errors.endIsEarlier")
      ).rules,
      originalValueStart: ValidationBuilder.$t("rvai-base.filters.date.startDate").custom(
        (value2) => value2 && originalValueEnd.value ? formatToSlash(value2) <= formatToSlash(originalValueEnd.value) : true,
        t22("rvai-base.filters.errors.startIsLater")
      ).rules
    };
  });
  const v$ = useVuelidate(
    validationRules,
    {
      originalValueEnd,
      originalValueStart
    },
    { $autoDirty: true }
  );
  watch(filterValueRef, () => {
    var _a2;
    const filterValue2 = filterValueRef.value;
    dateValue.start = (filterValue2 == null ? void 0 : filterValue2.type) === TableFilterType.Date ? filterValue2.value.start : "";
    dateValue.end = (filterValue2 == null ? void 0 : filterValue2.type) === TableFilterType.Date ? filterValue2.value.end : "";
    if (!filterValue2 && ((_a2 = dateFilter.beforeOptions) == null ? void 0 : _a2.length)) {
      dateFilterOption.value = dateFilter.beforeOptions.find((o) => !o.hideDefaultFilter);
    }
  });
  onMounted(() => {
    var _a2, _b;
    if (!isDate2) return;
    if (!((_a2 = dateFilter.beforeOptions) == null ? void 0 : _a2.length)) return;
    if (!filterValueRef.value) {
      setFilterByDefaultDateOption();
    } else if (filterValueRef.value.type === TableFilterType.Date && ((_b = dateFilter.beforeOptions) == null ? void 0 : _b.length)) {
      setDateFilterOption(filterValueRef.value.value.start, filterValueRef.value.value.end);
    }
  });
  return {
    dateEnd,
    dateFilterOption,
    dateStart,
    endRestrictions,
    isDate: isDate2,
    onUpdateDateFilterOption,
    originalValueEnd,
    originalValueStart,
    setOriginalValueEnd,
    setOriginalValueStart,
    showDefaultDateFilter,
    startRestrictions,
    v$
  };
}
function useListFilter(filter, filterValueRef) {
  var _a;
  const { updateFilters } = useTable();
  const isList = ((_a = filter.value) == null ? void 0 : _a.type) === TableFilterType.List;
  const listValue = computed({
    get() {
      const filterValue = filterValueRef.value;
      return (filterValue == null ? void 0 : filterValue.type) === TableFilterType.List ? filterValue.value : [];
    },
    set(value2) {
      if (!value2.length) {
        updateFilters(filter.value, void 0);
      } else {
        updateFilters(filter.value, {
          key: filter.value.key,
          type: TableFilterType.List,
          value: value2
        });
      }
    }
  });
  return {
    isList,
    listValue
  };
}
function useNumberFilter(filter, filterValueRef) {
  var _a;
  const { updateFilters } = useTable();
  const isNumber2 = ((_a = filter.value) == null ? void 0 : _a.type) === TableFilterType.Number;
  const numberValue = computed(() => {
    const filterValue = filterValueRef.value;
    return (filterValue == null ? void 0 : filterValue.type) === TableFilterType.Number ? {
      max: filterValue.max,
      min: filterValue.min
    } : {
      max: null,
      min: null
    };
  });
  const numberRange = computed(() => {
    const {
      max: maxValue2,
      min: minValue2,
      step
    } = filter.value;
    if (maxValue2 == null || minValue2 == null) {
      return {
        max: null,
        min: null
      };
    }
    const min2 = step ? Math.floor(minValue2 / step) * step : Math.floor(minValue2);
    const max2 = step ? Math.ceil(maxValue2 / step) * step : Math.ceil(maxValue2);
    return {
      max: max2,
      min: min2
    };
  });
  function onUpdateNumber(value2) {
    const {
      max: maxValue2,
      min: minValue2
    } = value2;
    const {
      max: filterMax,
      min: filterMin
    } = numberRange.value;
    let max2 = maxValue2;
    let min2 = minValue2;
    if (filterMax != null && filterMin != null && maxValue2 != null && minValue2 != null) {
      min2 = minValue2 < filterMax ? minValue2 > filterMin ? minValue2 : filterMin : filterMax;
      max2 = maxValue2 > filterMin ? maxValue2 < filterMax ? maxValue2 : filterMax : filterMin;
      if (min2 > max2) {
        min2 = max2;
      }
    }
    updateFilters(filter.value, {
      key: filter.value.key,
      max: max2,
      min: min2,
      type: TableFilterType.Number
    });
  }
  return {
    isNumber: isNumber2,
    numberRange,
    numberValue,
    onUpdateNumber
  };
}
function useSingleFilter(filter, filterValueRef) {
  var _a;
  const { updateFilters } = useTable();
  const isSingle = ((_a = filter.value) == null ? void 0 : _a.type) === TableFilterType.Single;
  const singleValue = computed({
    get() {
      const filterValue = filterValueRef.value;
      return (filterValue == null ? void 0 : filterValue.type) === TableFilterType.Single ? filterValue.value : void 0;
    },
    set(value2) {
      updateFilters(filter.value, {
        key: filter.value.key,
        type: TableFilterType.Single,
        value: value2
      });
    }
  });
  return {
    isSingle,
    singleValue
  };
}
const _sfc_main$h$1 = defineComponent({
  name: "TableFilterItem",
  components: {
    DatePicker,
    EllipsisText,
    ExpansionItem,
    Input,
    OptionGroup,
    QItemLabel: QItemLabel_default$1,
    QRange: QRange_default,
    QSpace: QSpace_default,
    ScrollArea,
    Select
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Puts expansion item into open state on initial render; Overridden by v-model if used
     */
    defaultOpened: {
      default: false,
      type: Boolean
    },
    filterKey: {
      type: String,
      required: true
    },
    scrollMaxItems: {
      type: Number,
      default: 0
    }
  },
  setup(props4) {
    const { t: t22 } = useI18n();
    const {
      filterOptions,
      filters
    } = useTable();
    const filter = computed(() => filterOptions.value[props4.filterKey]);
    const filterValue = computed(() => filters.values[props4.filterKey]);
    const showScroll = computed(() => {
      if (filter.value.type !== TableFilterType.List && filter.value.type !== TableFilterType.Single) {
        return false;
      }
      return props4.scrollMaxItems !== 0 && filter.value.options.length > props4.scrollMaxItems;
    });
    const scrollHeight = computed(() => {
      const value2 = props4.scrollMaxItems * 32 - 8;
      return `${value2}px`;
    });
    return {
      filter,
      kebabCase: kebabCase$1,
      scrollHeight,
      showScroll,
      t: t22,
      ...useAutomation(computed(() => props4.dataAutomation)),
      ...useDateFilter(filter, filterValue),
      ...useListFilter(filter, filterValue),
      ...useNumberFilter(filter, filterValue),
      ...useSingleFilter(filter, filterValue)
    };
  }
});
const _hoisted_1$d = { class: "q-px-sm flex items-center no-wrap" };
const _hoisted_2$7 = { class: "q-mr-md" };
const _hoisted_3$6 = { class: "q-ml-md" };
const _hoisted_4$3 = { class: "row justify-between items-center q-mb-sm" };
const _hoisted_5$3 = { class: "q-mt-md" };
function _sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Select = resolveComponent("Select");
  const _component_DatePicker = resolveComponent("DatePicker");
  const _component_OptionGroup = resolveComponent("OptionGroup");
  const _component_ScrollArea = resolveComponent("ScrollArea");
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_QSpace = resolveComponent("QSpace");
  const _component_QItemLabel = resolveComponent("QItemLabel");
  const _component_QRange = resolveComponent("QRange");
  const _component_Input = resolveComponent("Input");
  const _component_ExpansionItem = resolveComponent("ExpansionItem");
  return openBlock(), createBlock(_component_ExpansionItem, mergeProps({
    "data-automation": _ctx.buildId()
  }, _ctx.$attrs, {
    "default-opened": _ctx.defaultOpened,
    label: _ctx.filter.label
  }), {
    default: withCtx(() => {
      var _a;
      return [
        createElementVNode("div", null, [
          _ctx.isDate ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            "beforeOptions" in _ctx.filter && ((_a = _ctx.filter.beforeOptions) == null ? void 0 : _a.length) ? (openBlock(), createBlock(_component_Select, {
              key: 0,
              class: normalizeClass(!_ctx.dateFilterOption || _ctx.dateFilterOption.hideDefaultFilter ? "q-mb-sm" : "q-mb-lg"),
              "data-automation": _ctx.buildId("date-before-options"),
              "model-value": _ctx.dateFilterOption,
              options: _ctx.filter.beforeOptions,
              "onUpdate:modelValue": _ctx.onUpdateDateFilterOption
            }, null, 8, ["class", "data-automation", "model-value", "options", "onUpdate:modelValue"])) : createCommentVNode("", true),
            withDirectives(createVNode(_component_DatePicker, {
              modelValue: _ctx.dateStart,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.dateStart = $event),
              "data-automation": _ctx.buildId("start-date"),
              options: _ctx.startRestrictions,
              placeholder: _ctx.t("rvai-base.filters.date.startDate"),
              "validation-error": _ctx.v$.originalValueStart.$error ? _ctx.v$.originalValueStart.$errors[0].$message : "",
              "with-validation": "",
              "wrapper-class": "q-mb-md",
              "onUpdate:originalValue": _ctx.setOriginalValueStart
            }, null, 8, ["modelValue", "data-automation", "options", "placeholder", "validation-error", "onUpdate:originalValue"]), [
              [vShow, _ctx.showDefaultDateFilter]
            ]),
            withDirectives(createVNode(_component_DatePicker, {
              modelValue: _ctx.dateEnd,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.dateEnd = $event),
              "data-automation": _ctx.buildId("end-date"),
              options: _ctx.endRestrictions,
              placeholder: _ctx.t("rvai-base.filters.date.endDate"),
              "validation-error": _ctx.v$.originalValueEnd.$error ? _ctx.v$.originalValueEnd.$errors[0].$message : "",
              "with-validation": "",
              "onUpdate:originalValue": _ctx.setOriginalValueEnd
            }, null, 8, ["modelValue", "data-automation", "options", "placeholder", "validation-error", "onUpdate:originalValue"]), [
              [vShow, _ctx.showDefaultDateFilter]
            ])
          ], 64)) : _ctx.isList ? (openBlock(), createBlock(_component_ScrollArea, {
            key: 1,
            "no-horizontal": "",
            "no-scroll": !_ctx.showScroll,
            style: normalizeStyle(_ctx.showScroll && {
              height: _ctx.scrollHeight
            })
          }, {
            default: withCtx(() => [
              createVNode(_component_OptionGroup, {
                modelValue: _ctx.listValue,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.listValue = $event),
                "data-automation": _ctx.buildId("options"),
                options: "options" in _ctx.filter ? _ctx.filter.options : [],
                type: "checkbox"
              }, {
                "after-label": withCtx(({ option }) => [
                  createElementVNode("div", null, toDisplayString(_ctx.t("rvai-base.general.common.wordInBrackets", [option.count])), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "data-automation", "options"])
            ]),
            _: 1
          }, 8, ["no-scroll", "style"])) : _ctx.isSingle ? (openBlock(), createBlock(_component_ScrollArea, {
            key: 2,
            "no-horizontal": "",
            "no-scroll": !_ctx.showScroll,
            style: normalizeStyle(_ctx.showScroll && {
              height: _ctx.scrollHeight
            })
          }, {
            default: withCtx(() => [
              createVNode(_component_OptionGroup, {
                modelValue: _ctx.singleValue,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.singleValue = $event),
                "data-automation": _ctx.buildId("options"),
                options: "options" in _ctx.filter ? _ctx.filter.options : [],
                type: "radio"
              }, {
                label: withCtx(({ option }) => [
                  createVNode(_component_QItemLabel, {
                    class: "row no-wrap full-width text-grey-1",
                    "data-automation": _ctx.buildId(`option-single-${_ctx.kebabCase(option.label)}`)
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_EllipsisText, {
                        text: option.label
                      }, null, 8, ["text"]),
                      createVNode(_component_QSpace),
                      createElementVNode("div", null, toDisplayString(_ctx.t("rvai-base.general.common.wordInBrackets", [option.count])), 1)
                    ]),
                    _: 2
                  }, 1032, ["data-automation"])
                ]),
                _: 1
              }, 8, ["modelValue", "data-automation", "options"])
            ]),
            _: 1
          }, 8, ["no-scroll", "style"])) : _ctx.isNumber ? (openBlock(), createElementBlock(Fragment, { key: 3 }, [
            createElementVNode("div", _hoisted_1$d, [
              createElementVNode("span", _hoisted_2$7, toDisplayString(_ctx.numberRange.min), 1),
              createVNode(_component_QRange, {
                "data-automation": _ctx.buildId("range"),
                label: "",
                max: _ctx.numberRange.max,
                min: _ctx.numberRange.min,
                "model-value": _ctx.numberValue,
                step: _ctx.filter.step,
                onChange: _ctx.onUpdateNumber
              }, null, 8, ["data-automation", "max", "min", "model-value", "step", "onChange"]),
              createElementVNode("span", _hoisted_3$6, toDisplayString(_ctx.numberRange.max), 1)
            ]),
            createElementVNode("div", _hoisted_4$3, [
              createVNode(_component_Input, {
                modelValue: _ctx.numberValue.min,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => _ctx.numberValue.min = $event),
                class: "col-5",
                "data-automation": _ctx.buildId("min"),
                label: _ctx.t("rvai-base.general.inputs.from"),
                onChange: _cache[5] || (_cache[5] = ($event) => _ctx.onUpdateNumber({ min: Number($event), max: _ctx.numberValue.max }))
              }, null, 8, ["modelValue", "data-automation", "label"]),
              createElementVNode("span", _hoisted_5$3, toDisplayString(_ctx.t("rvai-base.general.symbols.dash")), 1),
              createVNode(_component_Input, {
                modelValue: _ctx.numberValue.max,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => _ctx.numberValue.max = $event),
                class: "col-5",
                "data-automation": _ctx.buildId("max"),
                label: _ctx.t("rvai-base.general.inputs.until"),
                onChange: _cache[7] || (_cache[7] = ($event) => _ctx.onUpdateNumber({ min: _ctx.numberValue.min, max: Number($event) }))
              }, null, 8, ["modelValue", "data-automation", "label"])
            ])
          ], 64)) : createCommentVNode("", true)
        ])
      ];
    }),
    _: 1
  }, 16, ["data-automation", "default-opened", "label"]);
}
const TableFilterItem = /* @__PURE__ */ _export_sfc$1(_sfc_main$h$1, [["render", _sfc_render$9]]);
const _sfc_main$g$1 = defineComponent({
  name: "TableFilter",
  components: {
    Button,
    QList: QList_default$1,
    TableFilterItem
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * The maximum number of items to display in a filter item. If set to 0, all items are shown. Default: 0
     */
    scrollMaxItems: {
      type: Number,
      default: 0
    }
  },
  setup(props4) {
    const { t: t22 } = useI18n();
    const { setHasRightContent } = useLayout();
    const {
      filterOptionsOpenedByDefault,
      hasFilters,
      resetFilters,
      visibleFilterOptions
    } = useTable();
    function hasValue(option) {
      return option.type === TableFilterType.Number ? option.max !== 0 : option.options.length !== 0;
    }
    function isDateFilter(option) {
      return option.type === TableFilterType.Date;
    }
    watch(
      visibleFilterOptions,
      () => {
        setHasRightContent(!!Object.keys(visibleFilterOptions.value).length);
      },
      { immediate: true }
    );
    onUnmounted(() => {
      setHasRightContent(true);
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      filterOptionsOpenedByDefault,
      hasFilters,
      hasValue,
      isDateFilter,
      kebabCase: kebabCase$1,
      resetFilters,
      t: t22,
      visibleFilterOptions
    };
  }
});
const _hoisted_1$c = ["data-automation"];
const _hoisted_2$6 = { class: "flex justify-between q-mb-sm" };
const _hoisted_3$5 = { class: "text-subtitle1" };
function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = resolveComponent("Button");
  const _component_TableFilterItem = resolveComponent("TableFilterItem");
  const _component_QList = resolveComponent("QList");
  return openBlock(), createElementBlock("div", mergeProps(_ctx.dataAttrs, {
    class: "rv-table-filter q-px-lg q-py-md bg-white rounded-borders",
    "data-automation": _ctx.buildId()
  }), [
    createElementVNode("div", _hoisted_2$6, [
      createElementVNode("div", _hoisted_3$5, toDisplayString(_ctx.t("rvai-base.general.text.filter")), 1),
      _ctx.hasFilters ? (openBlock(), createBlock(_component_Button, {
        key: 0,
        class: "text-capitalize",
        "data-automation": _ctx.buildId("clear"),
        label: _ctx.t("rvai-base.general.text.clear"),
        size: "sm",
        tertiary: "",
        onClick: _ctx.resetFilters
      }, null, 8, ["data-automation", "label", "onClick"])) : createCommentVNode("", true)
    ]),
    createVNode(_component_QList, null, {
      default: withCtx(() => [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.visibleFilterOptions, (option, key) => {
          return openBlock(), createElementBlock(Fragment, { key }, [
            _ctx.hasValue(option) || _ctx.isDateFilter(option) ? (openBlock(), createBlock(_component_TableFilterItem, {
              key: 0,
              class: "q-py-sm",
              "data-automation": _ctx.buildId(`item-${_ctx.kebabCase(key)}`),
              "default-opened": _ctx.filterOptionsOpenedByDefault.includes(key),
              "filter-key": key,
              "scroll-max-items": _ctx.scrollMaxItems
            }, null, 8, ["data-automation", "default-opened", "filter-key", "scroll-max-items"])) : createCommentVNode("", true)
          ], 64);
        }), 128))
      ]),
      _: 1
    })
  ], 16, _hoisted_1$c);
}
const TableFilter = /* @__PURE__ */ _export_sfc$1(_sfc_main$g$1, [["render", _sfc_render$8], ["__scopeId", "data-v-eaa8c6c9"]]);
const _sfc_main$f$1 = defineComponent({
  name: "TableList",
  components: {
    EllipsisText,
    Tooltip: Tooltip2
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    disable: {
      type: Boolean,
      default: false
    },
    emptyValue: {
      type: String,
      default: void 0
    },
    multipleRows: {
      type: Boolean,
      default: false
    },
    values: {
      type: Array,
      required: true
    }
  },
  setup(props4) {
    const { t: t22 } = useI18n();
    const tooltip = computed(() => props4.values.slice(1).join(", "));
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      t: t22,
      tooltip
    };
  }
});
const _hoisted_1$b = ["data-automation"];
const _hoisted_2$5 = {
  key: 0,
  class: "rv-table-list cursor-pointer"
};
const _hoisted_3$4 = { class: "show-more" };
const _hoisted_4$2 = { class: "show-more" };
const _hoisted_5$2 = { key: 3 };
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_Tooltip = resolveComponent("Tooltip");
  return _ctx.values.length > 1 && !_ctx.multipleRows ? (openBlock(), createElementBlock("span", {
    key: 0,
    class: normalizeClass(["row no-wrap", { "text-grey-2": _ctx.disable }]),
    "data-automation": _ctx.buildId()
  }, [
    createVNode(_component_EllipsisText, {
      text: _ctx.values[0]
    }, null, 8, ["text"]),
    _ctx.values.length > 1 ? (openBlock(), createElementBlock("div", _hoisted_2$5, [
      createElementVNode("span", null, toDisplayString(_ctx.t("rvai-base.general.symbols.comma") + " "), 1),
      createElementVNode("span", _hoisted_3$4, toDisplayString(_ctx.t("rvai-base.general.text.more", [_ctx.values.length - 1])), 1),
      createVNode(_component_Tooltip, {
        arrow: "top",
        offset: [0, 10]
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(_ctx.tooltip), 1)
        ]),
        _: 1
      })
    ])) : createCommentVNode("", true)
  ], 10, _hoisted_1$b)) : _ctx.values.length > 1 && _ctx.multipleRows ? (openBlock(), createElementBlock("div", {
    key: 1,
    class: normalizeClass(["rv-table-list cursor-pointer", { "text-grey-2": _ctx.disable }])
  }, [
    createVNode(_component_EllipsisText, {
      text: _ctx.values[0]
    }, null, 8, ["text"]),
    createElementVNode("span", _hoisted_4$2, toDisplayString(_ctx.t("rvai-base.general.text.more", [_ctx.values.length - 1])), 1),
    createVNode(_component_Tooltip, {
      anchor: "bottom left",
      arrow: "top",
      self: "center left"
    }, {
      default: withCtx(() => [
        createTextVNode(toDisplayString(_ctx.tooltip), 1)
      ]),
      _: 1
    })
  ], 2)) : _ctx.values.length === 1 ? (openBlock(), createElementBlock("span", {
    key: 2,
    class: normalizeClass(["rv-table-list", { "text-grey-2": _ctx.disable }])
  }, [
    createVNode(_component_EllipsisText, {
      text: _ctx.values[0]
    }, null, 8, ["text"])
  ], 2)) : (openBlock(), createElementBlock("span", _hoisted_5$2, toDisplayString(_ctx.emptyValue), 1));
}
const TableList = /* @__PURE__ */ _export_sfc$1(_sfc_main$f$1, [["render", _sfc_render$7], ["__scopeId", "data-v-f9dfed45"]]);
const _sfc_main$e$1 = /* @__PURE__ */ defineComponent({
  __name: "Tabs",
  props: {
    dataAutomation: {
      default: void 0,
      type: String
    },
    modelValue: {
      default: void 0,
      type: [String, Number, void 0]
    },
    optionLabel: {
      default: "label",
      type: String
    },
    options: {
      required: true,
      type: Array
    },
    optionValue: {
      default: "name",
      type: String
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props4 = __props;
    const emit = __emit;
    const { buildId } = useAutomation(props4.dataAutomation);
    const selectedTab = computed({
      get() {
        return props4.modelValue;
      },
      set(value2) {
        emit("update:modelValue", value2);
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(QTabs_default$1), {
        modelValue: selectedTab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => selectedTab.value = $event),
        class: "tab-container bg-white rounded-borders",
        "data-automation": unref(buildId)(),
        dense: "",
        "indicator-color": "primary",
        "inline-label": "",
        "narrow-indicator": "",
        shrink: "",
        stretch: ""
      }, {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList(__props.options, (option) => {
            return openBlock(), createBlock(resolveDynamicComponent(option.to ? unref(QRouteTab_default) : unref(QTab_default$1)), {
              key: option[__props.optionValue],
              class: "q-px-sm",
              "content-class": "q-px-sm text-body3",
              "data-automation": unref(buildId)(`tab-${option[__props.optionValue]}`),
              exact: option.exact,
              label: option[__props.optionLabel],
              name: option[__props.optionValue],
              "no-caps": "",
              ripple: false,
              to: option.to
            }, null, 8, ["data-automation", "exact", "label", "name", "to"]);
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "data-automation"]);
    };
  }
});
const Tabs = /* @__PURE__ */ _export_sfc$1(_sfc_main$e$1, [["__scopeId", "data-v-94338ea0"]]);
const _sfc_main$d$1 = defineComponent({
  name: "UsersGroup",
  components: {
    Avatar
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    idKey: {
      type: String,
      required: true
    },
    labelKey: {
      type: String,
      required: true
    },
    maxLength: {
      type: Number,
      default: 10
    },
    overrideCurrentUserAvatar: {
      type: Boolean,
      default: false
    },
    users: {
      type: Array,
      required: true
    }
  },
  setup(props4) {
    const { t: t22 } = useI18n();
    const filteredUsers = computed(() => {
      return props4.users.length > props4.maxLength ? props4.users.slice(0, props4.maxLength - 1) : props4.users;
    });
    const hidden = computed(() => {
      return props4.users.length - filteredUsers.value.length;
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      filteredUsers,
      hidden,
      t: t22
    };
  }
});
const _hoisted_1$a = ["data-automation"];
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Avatar = resolveComponent("Avatar");
  return openBlock(), createElementBlock("div", {
    "data-automation": _ctx.buildId()
  }, [
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.filteredUsers, (user, index2) => {
      return openBlock(), createBlock(_component_Avatar, mergeProps({
        key: user[_ctx.idKey],
        ref_for: true
      }, _ctx.$attrs, {
        "background-color": _ctx.overrideCurrentUserAvatar && user.isCurrent ? "white" : user.color,
        "border-color": _ctx.overrideCurrentUserAvatar && user.isCurrent ? "grey-1" : "white",
        class: "users-group__avatar",
        "data-automation": _ctx.buildId(`${user[_ctx.idKey]}`),
        label: user[_ctx.labelKey],
        style: { zIndex: _ctx.filteredUsers.length - index2 },
        "text-color": _ctx.overrideCurrentUserAvatar && user.isCurrent ? "grey-1" : "",
        uuid: user[_ctx.idKey]
      }), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default", mergeProps({ ref_for: true }, user || {}), void 0, true)
        ]),
        _: 2
      }, 1040, ["background-color", "border-color", "data-automation", "label", "style", "text-color", "uuid"]);
    }), 128)),
    _ctx.hidden ? (openBlock(), createBlock(_component_Avatar, mergeProps({ key: 0 }, _ctx.$attrs, {
      class: "users-group__avatar",
      "data-automation": _ctx.buildId("hidden"),
      label: _ctx.t("rvai-base.general.text.more", [_ctx.hidden]),
      "no-initial": "",
      style: { zIndex: 0 }
    }), null, 16, ["data-automation", "label"])) : createCommentVNode("", true)
  ], 8, _hoisted_1$a);
}
const UsersGroup = /* @__PURE__ */ _export_sfc$1(_sfc_main$d$1, [["render", _sfc_render$6], ["__scopeId", "data-v-7ca79855"]]);
const _sfc_main$c$1 = defineComponent({
  name: "ValidationTooltip",
  components: {
    Bullet,
    Tooltip: Tooltip2
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    exclude: {
      type: Array,
      default: () => []
    },
    /**
     * The text that will be shown above the input
     */
    label: {
      type: String,
      default: void 0
    },
    /**
     * Model of the component; Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
     */
    modelValue: {
      type: Boolean,
      default: false
    },
    /**
     * Validation for the component
     */
    validation: {
      type: Object,
      required: true
    }
  },
  emits: [
    /**
     * Emitted when the component needs to change the model; Is also used by v-model
     *
     * @type {[string, number]}
     */
    "update:modelValue"
  ],
  setup(props4) {
    const { t: t22 } = useI18n();
    const results = computed(() => {
      return Object.entries(props4.validation).filter(([key]) => !key.startsWith("$") && !props4.exclude.includes(key)).map(([key, rule]) => {
        return {
          key,
          message: rule.$message,
          valid: props4.validation.$dirty ? !rule.$invalid : void 0
        };
      });
    });
    function iconColor(valid) {
      if (valid) {
        return "positive";
      } else if (valid === false) {
        return "negative";
      } else {
        return "grey-1-fixed";
      }
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      iconColor,
      results,
      t: t22
    };
  }
});
const _hoisted_1$9 = {
  key: 0,
  class: "q-ml-xs"
};
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Bullet = resolveComponent("Bullet");
  const _component_Tooltip = resolveComponent("Tooltip");
  return openBlock(), createBlock(_component_Tooltip, mergeProps(_ctx.dataAttrs, {
    anchor: "bottom left",
    arrow: "top",
    class: "text-grey-1-fixed text-small",
    "data-automation": _ctx.buildId(),
    "model-value": _ctx.modelValue,
    offset: [0, 4],
    self: "top left",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.$emit("update:modelValue", $event))
  }), {
    default: withCtx(() => [
      _ctx.label ? (openBlock(), createElementBlock("div", _hoisted_1$9, toDisplayString(_ctx.label), 1)) : createCommentVNode("", true),
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.results, (entry) => {
        return openBlock(), createElementBlock("div", {
          key: entry.key,
          class: normalizeClass(["row no-wrap", { "text-negative": entry.valid === false }])
        }, [
          createVNode(_component_Bullet, {
            class: "q-mx-sm",
            color: _ctx.iconColor(entry.valid),
            "no-contrast-border": "",
            rounded: "",
            size: "4"
          }, null, 8, ["color"]),
          createTextVNode(" " + toDisplayString(entry.message), 1)
        ], 2);
      }), 128))
    ]),
    _: 1
  }, 16, ["data-automation", "model-value"]);
}
const ValidationTooltip = /* @__PURE__ */ _export_sfc$1(_sfc_main$c$1, [["render", _sfc_render$5]]);
const _hoisted_1$8 = ["data-automation"];
const _sfc_main$b$1 = /* @__PURE__ */ defineComponent({
  __name: "WaferMapWarning",
  props: {
    dataAutomation: {
      default: "wafer-map-warning",
      type: String
    },
    fullscreen: {
      default: false,
      type: Boolean
    },
    samplesCount: {
      required: true,
      type: Number
    },
    totalCount: {
      required: true,
      type: Number
    }
  },
  setup(__props) {
    const props4 = __props;
    const { buildId } = useAutomation(props4.dataAutomation);
    return (_ctx, _cache) => {
      const _component_q_icon = resolveComponent("q-icon");
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["border-blue text-small rounded-borders q-pa-sm q-mb-md flex no-wrap text-blue", { "items-center": __props.fullscreen }]),
        "data-automation": unref(buildId)()
      }, [
        createVNode(_component_q_icon, {
          class: "q-mr-sm",
          color: "blue",
          "data-automation": unref(buildId)("icon"),
          name: "mdi-information",
          size: "24px"
        }, null, 8, ["data-automation"]),
        createElementVNode("div", null, toDisplayString(_ctx.$t("rvai-base.components.waferMap.locationMissing", [__props.totalCount - __props.samplesCount, __props.totalCount])), 1)
      ], 10, _hoisted_1$8);
    };
  }
});
const emptyWaferBackground = "data:image/svg+xml,%3csvg%20width='1800'%20height='1800'%20viewBox='0%200%201800%201800'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='900'%20cy='900'%20r='900'%20fill='%23F5F6F9'%20/%3e%3c/svg%3e";
const _hoisted_1$7$1 = { class: "row full-width row no-wrap justify-end q-mb-md" };
const _hoisted_2$4 = { class: "row no-wrap offset-4 col-4 justify-center items-center" };
const _hoisted_3$3 = { class: "row no-wrap col-4 justify-end" };
const _hoisted_4$1 = {
  key: 0,
  class: "row justify-center"
};
const _hoisted_5$1 = {
  key: 1,
  class: "q-gutter-sm z-top"
};
const _hoisted_6$1 = { class: "absolute-top-right wafer-map__controls__splitview--top z-top q-mr-md" };
const _hoisted_7$1 = {
  key: 0,
  class: "row no-wrap items-center q-mt-sm"
};
const _hoisted_8$a = { class: "flex row no-wrap q-mt-sm" };
const _hoisted_9 = { style: { "min-width": "49px" } };
const _hoisted_10 = { style: { "min-width": "49px" } };
const _hoisted_11 = { style: { "min-width": "58px" } };
const canvasSpacing = 32;
const zoomRatio = 0.4;
const _sfc_main$a$1 = /* @__PURE__ */ defineComponent({
  __name: "WaferMapChart",
  props: {
    annotationSources: {
      default: void 0,
      type: Array
    },
    backgroundImage: {
      default: emptyWaferBackground,
      type: String
    },
    dataset: {
      required: true,
      type: Object
    },
    fullscreen: {
      default: false,
      type: Boolean
    },
    isSplitView: {
      default: false,
      type: Boolean
    },
    modelValue: {
      required: true,
      type: Array
    }
  },
  emits: ["resetBackground", "toggleFullscreen", "update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    var _a;
    const props4 = __props;
    const emit = __emit;
    const { t: t22 } = useI18n();
    const { getPaletteColorCache } = usePaletteColorsCache();
    const greyPaletteColor = getPaletteColorCache("grey-3");
    const primaryPaletteColor = getPaletteColorCache("primary");
    const canvas = ref$1();
    const disableZoomOut = ref$1(true);
    const disableResetView = ref$1(true);
    const scatterplotRef = ref$1();
    const showTooltip = ref$1(false);
    const tooltip = ref$1();
    const mouseMode = ref$1("panZoom");
    const isSkipSelectionSync = ref$1(false);
    const canvasClientHeight = ref$1((_a = canvas.value) == null ? void 0 : _a.clientHeight);
    __expose({
      canvasClientHeight
    });
    const selection = computed(() => props4.modelValue);
    const classesColors = computed(() => props4.dataset.classes.map((c3) => c3.id === "unannotated" ? greyPaletteColor : c3.color));
    const classesNames = computed(() => props4.dataset.classes.map((c3) => c3.id === "unannotated" ? t22("rvai-base.components.waferMap.notAnnotated") : c3.name));
    const points = computed(() => props4.dataset.dataPoints);
    const sampleInfo = computed(() => props4.dataset.samples);
    const samplesCount = computed(() => props4.dataset.samplesCount);
    const totalSampleCount = computed(() => props4.dataset.totalCount);
    const showMissingPointsInfo = computed(() => totalSampleCount.value !== samplesCount.value);
    const lassoActive = computed(() => mouseMode.value === "lasso");
    const menuItems = computed(() => [
      {
        disabled: !selection.value.length,
        label: t22("rvai-base.components.waferMap.deselect"),
        onClick: deselectHandler
      },
      {
        disabled: disableResetView.value,
        label: t22("rvai-base.components.waferMap.resetZoomLevel"),
        onClick: resetView
      }
    ]);
    async function createScatterplotView() {
      const scatterplot = createScatterplot({
        backgroundImage: props4.backgroundImage,
        canvas: canvas.value,
        pointSize: 5
      });
      const isMac = window.navigator.userAgent.toLocaleUpperCase().indexOf("MAC") !== -1;
      scatterplot.set({
        colorBy: "w",
        // @ts-expect-error fix for regl-scatterplot
        keyMap: {
          alt: "rotate",
          // I opened a bug on the regl-scatterplot github because we can't set both.
          ...isMac ? { cmd: "merge" } : { ctrl: "merge" },
          shift: "lasso"
        },
        lassoColor: primaryPaletteColor,
        pointColor: classesColors.value,
        // Sometimes when we only have unannotated data, the color on hover changes to white, this fixes it
        // @ts-expect-error regl-scatterplot accepts hex colors but types expect RGB arrays
        pointColorActive: classesColors.value,
        // @ts-expect-error regl-scatterplot accepts hex colors but types expect RGB arrays
        pointColorHover: classesColors.value
      });
      scatterplot.subscribe("pointOver", pointOverHandler);
      scatterplot.subscribe("pointOut", pointOutHandler);
      scatterplot.subscribe("view", viewHandler);
      scatterplot.subscribe("select", selectHandler);
      scatterplot.subscribe("deselect", deselectHandler);
      scatterplot.subscribe("lassoEnd", () => {
        mouseMode.value = "panZoom";
      });
      scatterplot.get("camera").setScaleBounds([1, Infinity]);
      await scatterplot.draw(points.value);
      scatterplotRef.value = scatterplot;
      updateSelection(props4.modelValue);
    }
    function createTooltip(pointIndex) {
      var _a2, _b, _c, _d;
      const { height: height2 } = scatterplotRef.value.get("canvas").getBoundingClientRect();
      const [x22, y32] = scatterplotRef.value.getScreenPosition(pointIndex);
      const classIndex = getClassIndex(pointIndex);
      const sampleData = (_a2 = sampleInfo.value) == null ? void 0 : _a2[pointIndex];
      const tooltipHeight = 94;
      const averagePointSizeInPixels = 10;
      let verticalOffset = -y32 - tooltipHeight / 4;
      if (Math.abs(verticalOffset) + tooltipHeight > height2) {
        verticalOffset = -y32 + tooltipHeight + averagePointSizeInPixels;
      }
      const offset2 = [-x22, verticalOffset];
      tooltip.value = {
        classColor: (_b = classesColors.value) == null ? void 0 : _b[classIndex],
        classLabel: (_c = classesNames.value) == null ? void 0 : _c[classIndex],
        offset: offset2,
        sampleName: sampleData == null ? void 0 : sampleData.name,
        sourceData: getSourceData((_d = sampleData == null ? void 0 : sampleData.metadata) == null ? void 0 : _d.source_id)
      };
      showTooltip.value = true;
    }
    function getClassIndex(pointIndex) {
      var _a2;
      return (_a2 = points.value[pointIndex]) == null ? void 0 : _a2[3];
    }
    function getSourceData(id3) {
      var _a2, _b;
      if (!id3) return;
      return (_b = (_a2 = props4 == null ? void 0 : props4.annotationSources) == null ? void 0 : _a2.filter((s32) => s32.id === id3)) == null ? void 0 : _b[0];
    }
    function onResize({
      height: height2,
      width
    }) {
      var _a2;
      (_a2 = scatterplotRef.value) == null ? void 0 : _a2.set({
        height: height2 - canvasSpacing,
        width: width - canvasSpacing
      });
      emit("resetBackground");
    }
    const selectHandler = ({ points: points2 }) => {
      const sampleIds = points2.map((p2) => {
        var _a2, _b;
        return (_b = (_a2 = sampleInfo == null ? void 0 : sampleInfo.value) == null ? void 0 : _a2[p2]) == null ? void 0 : _b.id;
      }).filter(Boolean);
      isSkipSelectionSync.value = true;
      emit("update:modelValue", sampleIds);
    };
    const deselectHandler = () => {
      emit("update:modelValue", []);
    };
    function pointOutHandler() {
      tooltip.value = null;
      showTooltip.value = false;
    }
    function pointOverHandler(pointIndex) {
      createTooltip(pointIndex);
    }
    function resetView() {
      emit("resetBackground");
      scatterplotRef.value.reset();
    }
    function viewHandler(event) {
      disableZoomOut.value = event.camera.distance[0] === 1 && event.camera.distance[1] === 1;
      disableResetView.value = disableZoomOut.value && event.camera.target[0] === 0 && event.camera.target[1] === 0;
    }
    function zoomIn() {
      const camera = scatterplotRef.value.get("camera");
      const distance = camera.distance[0] - camera.distance[0] * zoomRatio;
      scatterplotRef.value.zoomToLocation(
        camera.target,
        distance,
        { transition: true }
      );
    }
    function zoomOut() {
      const camera = scatterplotRef.value.get("camera");
      const distance = camera.distance[0] / (1 - zoomRatio);
      scatterplotRef.value.zoomToLocation(
        camera.target,
        distance < 1 ? distance : 1,
        { transition: true }
      );
    }
    function updateSelection(value2) {
      if (!(sampleInfo.value && scatterplotRef.value)) return;
      const sampleIndices = [];
      for (let i22 = 0; i22 < (sampleInfo == null ? void 0 : sampleInfo.value.length); i22++) {
        const sample2 = sampleInfo == null ? void 0 : sampleInfo.value[i22];
        if ((sample2 == null ? void 0 : sample2.id) && value2.includes(sample2.id)) {
          sampleIndices.push(i22);
        }
        if (value2.length === sampleIndices.length) {
          break;
        }
      }
      scatterplotRef.value.select(sampleIndices, { preventEvent: true });
    }
    function toggleLasso() {
      mouseMode.value = mouseMode.value === "lasso" ? "panZoom" : "lasso";
    }
    watch(mouseMode, (value2) => {
      if (canvas.value) {
        if (value2 === "lasso") {
          scatterplotRef.value.set({ mouseMode: "lasso" });
          canvas.value.style.cursor = "crosshair";
        } else {
          scatterplotRef.value.set({ mouseMode: "panZoom" });
          canvas.value.style.cursor = "default";
        }
      }
    });
    watch(selection, (value2) => {
      if (value2.length === 0 || !isSkipSelectionSync.value) {
        updateSelection(value2);
      }
      isSkipSelectionSync.value = false;
    });
    watch(() => props4.backgroundImage, (backgroundImage) => {
      var _a2;
      (_a2 = scatterplotRef.value) == null ? void 0 : _a2.set({
        backgroundImage
      });
    });
    watch(points, (current, prev) => {
      if (!arrayShallowEqual(prev, current)) {
        scatterplotRef == null ? void 0 : scatterplotRef.value.draw(points.value);
      }
    }, { deep: true });
    watch(() => {
      var _a2;
      return (_a2 = canvas.value) == null ? void 0 : _a2.clientHeight;
    }, (height2) => {
      canvasClientHeight.value = height2;
    }, { immediate: true });
    onUnmounted(() => {
      var _a2;
      (_a2 = scatterplotRef.value) == null ? void 0 : _a2.destroy();
    });
    onMounted(async () => {
      await createScatterplotView();
    });
    return (_ctx, _cache) => {
      const _component_i18n_t = resolveComponent("i18n-t");
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", {
          class: normalizeClass(["canvas-wrapper", { "canvas-wrapper--border q-pa-md rounded-borders": __props.isSplitView }]),
          "data-automation": "wafer-map-chart"
        }, [
          createElementVNode("div", {
            class: normalizeClass(["wafer-map__controls__container__top", __props.fullscreen ? "wafer-map__controls__container__top--fullscreen" : "absolute-top-right"])
          }, [
            __props.fullscreen ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
              createElementVNode("div", _hoisted_1$7$1, [
                createElementVNode("div", _hoisted_2$4, [
                  createVNode(_component_i18n_t, {
                    keypath: "rvai-base.components.waferMap.selectedCount",
                    tag: "div"
                  }, {
                    selectedSamples: withCtx(() => [
                      createElementVNode("strong", null, toDisplayString(selection.value.length), 1)
                    ]),
                    totalSamples: withCtx(() => [
                      createElementVNode("strong", null, toDisplayString(samplesCount.value), 1)
                    ]),
                    _: 1
                  }),
                  createVNode(Button, {
                    class: "q-ml-sm",
                    "data-automation": "wafer-map__controls__deselect",
                    disable: !selection.value.length,
                    label: _ctx.$t("rvai-base.components.waferMap.deselect"),
                    size: "sm",
                    tertiary: "",
                    onClick: deselectHandler
                  }, null, 8, ["disable", "label"])
                ]),
                createElementVNode("div", _hoisted_3$3, [
                  createVNode(Button, {
                    class: "wafer-map__controls__lasso z-top bg-white shadow",
                    color: lassoActive.value ? "primary" : "black-1",
                    "data-automation": "wafer-map__lasso-select",
                    icon: "rvai-base:lasso",
                    label: _ctx.$t("rvai-base.components.waferMap.makeFreehandSelection"),
                    size: "sm",
                    tertiary: "",
                    onClick: withModifiers(toggleLasso, ["stop"])
                  }, null, 8, ["color", "label"])
                ])
              ]),
              showMissingPointsInfo.value ? (openBlock(), createElementBlock("div", _hoisted_4$1, [
                createVNode(_sfc_main$b$1, {
                  fullscreen: "",
                  "samples-count": samplesCount.value,
                  "total-count": totalSampleCount.value
                }, null, 8, ["samples-count", "total-count"])
              ])) : createCommentVNode("", true)
            ], 64)) : !__props.isSplitView ? (openBlock(), createElementBlock("div", _hoisted_5$1, [
              createVNode(Button, {
                class: normalizeClass(["bg-white shadow", { "bg-grey-6": lassoActive.value }]),
                color: lassoActive.value ? "primary" : "black-1",
                "data-automation": "wafer-map__lasso-select",
                icon: "rvai-base:lasso",
                secondary: "",
                size: "xs",
                onClick: withModifiers(toggleLasso, ["stop"])
              }, {
                default: withCtx(() => [
                  createVNode(Tooltip2, {
                    anchor: "top middle",
                    "data-automation": "wafer-map__reset-view--tooltip",
                    self: "center end"
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(_ctx.$t("rvai-base.components.waferMap.makeFreehandSelection")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["class", "color"]),
              createVNode(Button, {
                class: "bg-white shadow",
                "data-automation": "wafer-map__controls__full-screen",
                icon: "fullscreen",
                secondary: "",
                size: "xs",
                onClick: _cache[0] || (_cache[0] = withModifiers(($event) => _ctx.$emit("toggleFullscreen"), ["stop"]))
              })
            ])) : createCommentVNode("", true)
          ], 2),
          __props.isSplitView ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createVNode(Button, {
              class: "absolute-top-left wafer-map__controls__splitview--top wafer-map__controls__lasso bg-white q-ml-md shadow",
              color: lassoActive.value ? "primary" : "black-1",
              "data-automation": "wafer-map__lasso-select",
              icon: "rvai-base:lasso",
              label: _ctx.$t("rvai-base.components.waferMap.makeFreehandSelection"),
              size: "sm",
              tertiary: "",
              onClick: withModifiers(toggleLasso, ["stop"])
            }, null, 8, ["color", "label"]),
            createElementVNode("div", _hoisted_6$1, [
              createVNode(Button, {
                class: "wafer-map__controls__deselect bg-white q-mx-sm",
                "data-automation": "wafer-map__controls__deselect",
                disable: !selection.value.length,
                label: _ctx.$t("rvai-base.components.waferMap.deselect"),
                size: "sm",
                tertiary: "",
                onClick: deselectHandler
              }, null, 8, ["disable", "label"]),
              createVNode(Button, {
                class: "bg-white shadow",
                "data-automation": "wafer-map__controls__full-screen",
                icon: "fullscreen",
                secondary: "",
                size: "xs",
                onClick: _cache[1] || (_cache[1] = withModifiers(($event) => _ctx.$emit("toggleFullscreen"), ["stop"]))
              })
            ])
          ], 64)) : createCommentVNode("", true),
          createElementVNode("canvas", {
            ref_key: "canvas",
            ref: canvas,
            class: "canvas bg-white",
            "data-automation": "wafer-map__canvas"
          }, null, 512),
          createVNode(unref(QResizeObserver_default$1), { onResize }),
          !!tooltip.value ? (openBlock(), createBlock(Tooltip2, {
            key: 1,
            modelValue: showTooltip.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => showTooltip.value = $event),
            anchor: "top left",
            "data-automation": "wafer-map__data-tooltip",
            "max-width": "170px",
            offset: tooltip.value.offset,
            self: "top middle",
            target: ".canvas"
          }, {
            default: withCtx(() => {
              var _a2, _b, _c, _d, _e2, _f, _g, _h, _i, _j, _k;
              return [
                createElementVNode("strong", null, [
                  createVNode(EllipsisText, {
                    "data-automation": "sampleName",
                    text: tooltip.value.sampleName
                  }, null, 8, ["text"])
                ]),
                ((_a2 = tooltip.value.sourceData) == null ? void 0 : _a2.id) ? (openBlock(), createElementBlock("div", _hoisted_7$1, [
                  createVNode(Avatar, {
                    "background-color": ((_b = tooltip.value.sourceData) == null ? void 0 : _b.isCurrent) ? "white" : (_c = tooltip.value.sourceData) == null ? void 0 : _c.color,
                    "border-color": ((_d = tooltip.value.sourceData) == null ? void 0 : _d.isCurrent) ? "grey-1" : void 0,
                    "data-automation": "source-avatar",
                    label: (_e2 = tooltip.value.sourceData) == null ? void 0 : _e2.name,
                    "show-logo": !((_f = tooltip.value.sourceData) == null ? void 0 : _f.isUser),
                    size: "sm",
                    "text-color": ((_g = tooltip.value.sourceData) == null ? void 0 : _g.isCurrent) ? "grey-1" : "",
                    uuid: (_h = tooltip.value.sourceData) == null ? void 0 : _h.id
                  }, null, 8, ["background-color", "border-color", "label", "show-logo", "text-color", "uuid"]),
                  createVNode(EllipsisText, {
                    class: "q-ml-xs",
                    "data-automation": "source-name",
                    text: (_i = tooltip.value.sourceData) == null ? void 0 : _i.name
                  }, null, 8, ["text"])
                ])) : createCommentVNode("", true),
                createElementVNode("div", _hoisted_8$a, [
                  ((_j = tooltip.value.sourceData) == null ? void 0 : _j.id) ? (openBlock(), createBlock(Bullet, {
                    key: 0,
                    class: "q-ml-xs",
                    color: tooltip.value.classColor,
                    "data-automation": "class-color",
                    size: "12"
                  }, null, 8, ["color"])) : createCommentVNode("", true),
                  createVNode(EllipsisText, {
                    class: normalizeClass({ "q-ml-sm": (_k = tooltip.value.sourceData) == null ? void 0 : _k.id }),
                    "data-automation": "class-name",
                    text: tooltip.value.classLabel
                  }, null, 8, ["class", "text"])
                ])
              ];
            }),
            _: 1
          }, 8, ["modelValue", "offset"])) : createCommentVNode("", true)
        ], 2),
        createElementVNode("div", {
          class: normalizeClass(["wafer-map__controls__container__bottom absolute-bottom-right column z-top", { "wafer-map__controls__container__bottom--fullscreen": __props.fullscreen || __props.isSplitView }])
        }, [
          __props.fullscreen || __props.isSplitView ? (openBlock(), createBlock(Button, {
            key: 0,
            class: normalizeClass(["bg-white q-mt-sm shadow", { "q-mr-md": __props.isSplitView }]),
            "data-automation": "wafer-map__reset-view",
            icon: "mdi-refresh",
            secondary: "",
            size: "xs",
            onClick: withModifiers(resetView, ["stop"])
          }, {
            default: withCtx(() => [
              createVNode(Tooltip2, {
                anchor: "center left",
                "data-automation": "wafer-map__reset-view--tooltip",
                self: "center right"
              }, {
                default: withCtx(() => [
                  createElementVNode("div", _hoisted_9, toDisplayString(_ctx.$t("rvai-base.components.waferMap.resetZoomLevel")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["class"])) : (openBlock(), createBlock(Button, {
            key: 1,
            class: "bg-white shadow",
            "data-automation": "wafer-map__reset-view",
            icon: "rvai-base:meat-ball",
            secondary: "",
            size: "xs"
          }, {
            default: withCtx(() => [
              createVNode(unref(QMenu_default$1), {
                anchor: "bottom left",
                "auto-close": "",
                offset: [4, 0],
                self: "bottom right"
              }, {
                default: withCtx(() => [
                  createVNode(unref(QList_default$1), { separator: "" }, {
                    default: withCtx(() => [
                      (openBlock(true), createElementBlock(Fragment, null, renderList(menuItems.value, (menuItem) => {
                        return openBlock(), createBlock(unref(QItem_default$1), {
                          key: menuItem.label,
                          clickable: "",
                          disable: menuItem.disabled,
                          onClick: menuItem.onClick
                        }, {
                          default: withCtx(() => [
                            createVNode(unref(QItemLabel_default$1), null, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString(menuItem.label), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["disable", "onClick"]);
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })),
          __props.fullscreen || __props.isSplitView ? (openBlock(), createBlock(Button, {
            key: 2,
            class: normalizeClass(["bg-white q-mt-sm shadow", { "q-mr-md": __props.isSplitView }]),
            "data-automation": "wafer-map__zoom-in",
            icon: "mdi-plus",
            secondary: "",
            size: "xs",
            onClick: withModifiers(zoomIn, ["stop"])
          }, {
            default: withCtx(() => [
              createVNode(Tooltip2, {
                anchor: "center left",
                "data-automation": "wafer-map__zoom-in--tooltip",
                self: "center right"
              }, {
                default: withCtx(() => [
                  createElementVNode("div", _hoisted_10, toDisplayString(_ctx.$t("rvai-base.components.waferMap.zoomIn")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["class"])) : createCommentVNode("", true),
          __props.fullscreen || __props.isSplitView ? (openBlock(), createBlock(Button, {
            key: 3,
            class: normalizeClass(["bg-white q-mt-sm shadow", { "q-mr-md q-mb-md": __props.isSplitView }]),
            "data-automation": "wafer-map__zoom-out",
            disable: disableZoomOut.value,
            icon: "mdi-minus",
            secondary: "",
            size: "xs",
            onClick: withModifiers(zoomOut, ["stop"])
          }, {
            default: withCtx(() => [
              createVNode(Tooltip2, {
                anchor: "center left",
                "data-automation": "wafer-map__zoom-out--tooltip",
                self: "center right"
              }, {
                default: withCtx(() => [
                  createElementVNode("div", _hoisted_11, toDisplayString(_ctx.$t("rvai-base.components.waferMap.zoomOut")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["class", "disable"])) : createCommentVNode("", true)
        ], 2)
      ], 64);
    };
  }
});
const WaferMapChart = /* @__PURE__ */ _export_sfc$1(_sfc_main$a$1, [["__scopeId", "data-v-ea6b47ce"]]);
const _hoisted_1$6$1 = ["data-automation"];
const _hoisted_2$3 = ["data-automation"];
const _hoisted_3$2 = ["data-automation"];
const _sfc_main$9$1 = /* @__PURE__ */ defineComponent({
  __name: "WaferMapChartFilters",
  props: {
    dataAutomation: {
      default: "wafer-map-chart-filters",
      type: String
    }
  },
  setup(__props) {
    const props4 = __props;
    const { buildId } = useAutomation(props4.dataAutomation);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "border-card rounded-borders q-mb-md",
        "data-automation": unref(buildId)()
      }, [
        createVNode(ExpansionItem, {
          class: "q-px-lg q-py-md",
          "data-automation": unref(buildId)("expansion-item"),
          "default-opened": "",
          label: _ctx.$t("rvai-base.components.waferMap.chartSpecificFilters"),
          "no-hover-animation": ""
        }, {
          default: withCtx(() => [
            createElementVNode("div", {
              class: "text-body3",
              "data-automation": unref(buildId)("annotation-source")
            }, toDisplayString(_ctx.$t("rvai-base.components.waferMap.annotationSource")), 9, _hoisted_2$3),
            createElementVNode("div", {
              class: "text-subtitle3",
              "data-automation": unref(buildId)("last-updated-annotations")
            }, toDisplayString(_ctx.$t("rvai-base.components.waferMap.lastUpdatedAnnotations")), 9, _hoisted_3$2)
          ]),
          _: 1
        }, 8, ["data-automation", "label"])
      ], 8, _hoisted_1$6$1);
    };
  }
});
const _hoisted_1$5$1 = ["data-automation"];
const _hoisted_2$2 = ["data-automation"];
const _hoisted_3$1 = ["data-automation"];
const _sfc_main$8$1 = /* @__PURE__ */ defineComponent({
  __name: "WaferMapChartLegend",
  props: {
    classes: {
      required: true,
      type: Array
    },
    dataAutomation: {
      default: "wafer-map-chart-legend",
      type: String
    }
  },
  setup(__props) {
    const props4 = __props;
    const { buildId } = useAutomation(props4.dataAutomation);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "border-card rounded-borders",
        "data-automation": unref(buildId)()
      }, [
        createVNode(ExpansionItem, {
          class: "q-px-lg q-py-md full-height",
          "content-class": "full-height q-mt-sm",
          "data-automation": unref(buildId)("expansion-item"),
          "default-opened": "",
          label: _ctx.$t("rvai-base.components.waferMap.annotations"),
          "no-hover-animation": ""
        }, {
          default: withCtx(() => [
            __props.classes.length ? (openBlock(), createBlock(ScrollArea, {
              key: 0,
              class: "annotation-class-item__list full-height col-grow",
              "data-automation": unref(buildId)("annotation-class-item__list"),
              "no-horizontal": ""
            }, {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(__props.classes, (annotationClass) => {
                  return openBlock(), createElementBlock("div", {
                    key: annotationClass.id,
                    class: "row no-wrap items-center q-pb-sm",
                    "data-automation": unref(buildId)("annotation-class-item")
                  }, [
                    createVNode(Bullet, {
                      class: "q-pr-sm",
                      color: annotationClass.color,
                      "data-automation": unref(buildId)("annotation-class-item__bullet"),
                      "is-tooltip-shown": false,
                      size: 8,
                      style: normalizeStyle({ visibility: annotationClass.id === "unannotated" ? "hidden" : "visible" })
                    }, null, 8, ["color", "data-automation", "style"]),
                    createVNode(EllipsisText, {
                      "data-automation": unref(buildId)("annotation-class-item__name"),
                      text: annotationClass.name
                    }, null, 8, ["data-automation", "text"])
                  ], 8, _hoisted_2$2);
                }), 128))
              ]),
              _: 1
            }, 8, ["data-automation"])) : (openBlock(), createElementBlock("div", {
              key: 1,
              "data-automation": unref(buildId)("no-items")
            }, toDisplayString(_ctx.$t("rvai-base.components.waferMap.noItems")), 9, _hoisted_3$1))
          ]),
          _: 1
        }, 8, ["data-automation", "label"])
      ], 8, _hoisted_1$5$1);
    };
  }
});
const WaferMapChartLegend = /* @__PURE__ */ _export_sfc$1(_sfc_main$8$1, [["__scopeId", "data-v-6993da7d"]]);
const _hoisted_1$4$1 = ["data-automation"];
const _hoisted_2$1$1 = { key: 0 };
const _sfc_main$7$1 = /* @__PURE__ */ defineComponent({
  __name: "WaferMapError",
  props: {
    dataAutomation: {
      default: "wafer-map-error",
      type: String
    },
    loadingFailed: {
      default: false,
      type: Boolean
    }
  },
  setup(__props) {
    const props4 = __props;
    const { buildId } = useAutomation(props4.dataAutomation);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "wafer-map-error relative-position flex items-center justify-center column text-grey-1 full-height full-width bg-grey-5 text-center",
        "data-automation": unref(buildId)()
      }, [
        createElementVNode("div", null, toDisplayString(__props.loadingFailed ? _ctx.$t("rvai-base.general.text.loadingFailed") : _ctx.$t("rvai-base.components.waferMap.noPositions")), 1),
        __props.loadingFailed ? (openBlock(), createElementBlock("div", _hoisted_2$1$1, toDisplayString(_ctx.$t("rvai-base.components.waferMap.loadingFailedExtra")), 1)) : createCommentVNode("", true)
      ], 8, _hoisted_1$4$1);
    };
  }
});
const WaferMapError = /* @__PURE__ */ _export_sfc$1(_sfc_main$7$1, [["__scopeId", "data-v-d7cba4ff"]]);
const _hoisted_1$3$1 = ["data-automation"];
const _sfc_main$6$1 = /* @__PURE__ */ defineComponent({
  __name: "WaferMapLoader",
  props: {
    dataAutomation: {
      default: "wafer-map-loader",
      type: String
    }
  },
  setup(__props) {
    const props4 = __props;
    const { buildId } = useAutomation(props4.dataAutomation);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "relative-position flex items-center justify-center column text-grey-1 full-height full-width bg-grey-5",
        "data-automation": unref(buildId)()
      }, [
        createVNode(unref(QSpinner_default$1), {
          color: "primary",
          "data-automation": unref(buildId)("spinner"),
          size: "40px"
        }, null, 8, ["data-automation"]),
        createElementVNode("span", null, toDisplayString(_ctx.$t("rvai-base.general.text.loading")), 1),
        createElementVNode("span", null, toDisplayString(_ctx.$t("rvai-base.general.text.loadingExtra")), 1)
      ], 8, _hoisted_1$3$1);
    };
  }
});
const _hoisted_1$2$1 = ["data-automation"];
const _hoisted_2$1a = ["data-automation"];
const _hoisted_3$W = ["data-automation"];
const _hoisted_4$A = ["data-automation"];
const _hoisted_5$t = ["data-automation"];
const _hoisted_6$h = ["data-automation"];
const _hoisted_7$f = ["data-automation"];
const annotationSourceHeight = 64;
const _sfc_main$5$1 = /* @__PURE__ */ defineComponent({
  __name: "WaferMap",
  props: {
    annotationSources: {
      default: void 0,
      type: Array
    },
    backgroundImage: {
      default: void 0,
      type: String
    },
    dataset: {
      default: () => ({}),
      type: Object
    },
    fullscreen: {
      default: false,
      type: Boolean
    },
    isPartiallyLoaded: {
      default: false,
      type: Boolean
    },
    isSplitView: {
      default: false,
      type: Boolean
    },
    loading: {
      default: false,
      type: Boolean
    },
    loadingFailed: {
      default: false,
      type: Boolean
    },
    modelValue: {
      required: true,
      type: Array
    }
  },
  emits: ["resetBackground", "resize", "toggleFullscreen", "update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const emit = __emit;
    const props4 = __props;
    const wrapperRef = ref$1();
    const canvasRef = ref$1();
    const canvasFullscreenRef = ref$1();
    __expose({
      canvasFullscreenRef,
      canvasRef,
      wrapperRef
    });
    const { buildId } = useAutomation("wafer-map");
    const selection = computed(() => props4.modelValue);
    const classes = computed(() => {
      var _a;
      return ((_a = props4.dataset) == null ? void 0 : _a.classes) ?? [];
    });
    const warningHeight = computed(() => {
      const blockHeight = props4.fullscreen ? 58 : 70;
      return props4.isPartiallyLoaded ? blockHeight : 0;
    });
    async function onResize({
      width
    }) {
      emit("resize", {
        annotationSourceHeight,
        warningHeight: warningHeight.value,
        width
      });
    }
    return (_ctx, _cache) => {
      var _a, _b;
      return openBlock(), createElementBlock("div", {
        ref_key: "wrapperRef",
        ref: wrapperRef,
        class: normalizeClass(["full-height bg-white", {
          "flex no-wrap q-pt-md": __props.fullscreen
        }]),
        "data-automation": unref(buildId)(),
        style: normalizeStyle({
          "--annotation-source-height": `${annotationSourceHeight}px`,
          "--warning-height": `${warningHeight.value}px`
        })
      }, [
        createVNode(unref(QResizeObserver_default$1), { onResize }),
        __props.loading ? (openBlock(), createBlock(_sfc_main$6$1, { key: 0 })) : __props.loadingFailed || !((_b = (_a = __props.dataset) == null ? void 0 : _a.dataPoints) == null ? void 0 : _b.length) ? (openBlock(), createBlock(WaferMapError, {
          key: 1,
          "loading-failed": __props.loadingFailed
        }, null, 8, ["loading-failed"])) : __props.fullscreen ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
          createElementVNode("div", {
            class: "wafer-map__sidepanel column no-wrap",
            "data-automation": unref(buildId)("sidepanel")
          }, [
            createVNode(_sfc_main$9$1),
            createVNode(WaferMapChartLegend, { classes: classes.value }, null, 8, ["classes"])
          ], 8, _hoisted_2$1a),
          createElementVNode("div", {
            class: normalizeClass(["wafer-map__fullscreen", {
              "border-card rounded-borders full-width q-pa-md": __props.fullscreen
            }]),
            "data-automation": unref(buildId)("fullscreen-container")
          }, [
            createElementVNode("div", {
              class: normalizeClass(["relative-position", __props.isPartiallyLoaded ? "wafer-map__fullscreen--partial" : "wafer-map__fullscreen--full"]),
              "data-automation": unref(buildId)("fullscreen-wrapper")
            }, [
              createVNode(WaferMapChart, {
                ref_key: "canvasFullscreenRef",
                ref: canvasFullscreenRef,
                modelValue: selection.value,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event) => selection.value = $event),
                  _cache[2] || (_cache[2] = ($event) => emit("update:modelValue", $event))
                ],
                "annotation-sources": __props.annotationSources,
                "background-image": __props.backgroundImage,
                dataset: __props.dataset,
                fullscreen: __props.fullscreen,
                onResetBackground: _cache[1] || (_cache[1] = ($event) => emit("resetBackground"))
              }, null, 8, ["modelValue", "annotation-sources", "background-image", "dataset", "fullscreen"])
            ], 10, _hoisted_4$A)
          ], 10, _hoisted_3$W)
        ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 3 }, [
          createElementVNode("div", {
            class: "wafer-map__annotation-source",
            "data-automation": unref(buildId)("annotation-source")
          }, [
            createElementVNode("div", {
              class: "text-body3",
              "data-automation": unref(buildId)("annotation-source__label")
            }, toDisplayString(_ctx.$t("rvai-base.components.waferMap.annotationSource")), 9, _hoisted_6$h),
            createElementVNode("div", {
              class: "text-subtitle3",
              "data-automation": unref(buildId)("annotation-source__last-updated")
            }, toDisplayString(_ctx.$t("rvai-base.components.waferMap.lastUpdatedAnnotations")), 9, _hoisted_7$f)
          ], 8, _hoisted_5$t),
          __props.isPartiallyLoaded ? (openBlock(), createBlock(_sfc_main$b$1, {
            key: 0,
            fullscreen: __props.fullscreen,
            "samples-count": __props.dataset.samplesCount,
            "total-count": __props.dataset.totalCount
          }, null, 8, ["fullscreen", "samples-count", "total-count"])) : createCommentVNode("", true),
          createVNode(WaferMapChart, {
            ref_key: "canvasRef",
            ref: canvasRef,
            modelValue: selection.value,
            "onUpdate:modelValue": [
              _cache[3] || (_cache[3] = ($event) => selection.value = $event),
              _cache[6] || (_cache[6] = ($event) => emit("update:modelValue", $event))
            ],
            "annotation-sources": __props.annotationSources,
            "background-image": __props.backgroundImage,
            dataset: __props.dataset,
            "is-split-view": __props.isSplitView,
            onResetBackground: _cache[4] || (_cache[4] = ($event) => emit("resetBackground")),
            onToggleFullscreen: _cache[5] || (_cache[5] = ($event) => emit("toggleFullscreen", true))
          }, null, 8, ["modelValue", "annotation-sources", "background-image", "dataset", "is-split-view"])
        ], 64))
      ], 14, _hoisted_1$2$1);
    };
  }
});
const components$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ActionButton,
  AutoHeight,
  Avatar,
  BackButton,
  BarChart,
  Bullet,
  Button,
  Card,
  CardImage,
  CardItem,
  Carousel,
  Chart: Chart2,
  ChartLineIndicator: _sfc_main$1q,
  Checkbox,
  Chip,
  CircularProgress,
  ClickableArea,
  ColorPicker,
  ColorPickerInput,
  ColorPickerV2,
  CombinedInputs,
  ConfirmDialog,
  ConfusionMatrix,
  CookiesDialog,
  CopyContentBtn,
  DatePicker,
  Dialog,
  DoubleCircularProgress,
  Dropzone,
  Duration,
  EditableText,
  EllipsisText,
  ExpansionItem,
  ExpansionList,
  FieldEdit,
  FieldsVisibilityDialog,
  FilePicker,
  FilterableList,
  HeaderNavigationItems,
  HealthIcon,
  Histogram,
  HistogramWrapper,
  InfoDialog,
  InfoPanel,
  Input,
  LabelerSlider,
  LayoutButton,
  LinearProgress,
  LocalUrl: _sfc_main$Q,
  Logo: _sfc_main$P,
  MainContent,
  MultipleSelect,
  NavigationBar,
  NavigationBarLink,
  NavigationBarOverlay,
  NavigationBarTree,
  NavigationHeader,
  NavigationTitle,
  NoData,
  OptionGroup,
  Pagination,
  PoliciesAndLicenses,
  PrivacyPolicyDialog,
  Radio,
  Range,
  ScrollArea,
  ScrollNavigation,
  SearchInput,
  SectionMessage,
  Select,
  SelectBoolean,
  Separator,
  Sidebar,
  SidebarListClassSlugs,
  SidebarLoading,
  Slider,
  SortButton,
  SortSelect,
  Spinner,
  SpinnerAbsolute,
  SpinnerFixed,
  StatusPanel,
  StepSidebar,
  StepSidebarContent,
  SuspenseWithError,
  Table,
  TableCard,
  TableFilter,
  TableFilterItem,
  TableList,
  TableSortBy,
  Tabs,
  TermsAndConditionsDialog,
  Toggle,
  Tooltip: Tooltip2,
  UsersGroup,
  Validation,
  ValidationTooltip,
  WaferMap: _sfc_main$5$1
}, Symbol.toStringTag, { value: "Module" }));
defineComponent({
  name: "FullLayout",
  components: {
    NavigationBarOverlay,
    QLayout: QLayout_default,
    QPageContainer: QPageContainer_default,
    RouterView
  },
  setup() {
    const {
      showOverlay,
      toggleShowOverlay,
      watchRoute
    } = useLayout();
    const { navigation } = useOptions();
    const overlayRef = ref$1(null);
    const helpUrl = computed(() => navigation.helpUrl);
    const homeRoute = computed(() => navigation.homeRoute);
    const items = computed(() => navigation.items ?? []);
    function closeOverlay() {
      toggleShowOverlay(false);
    }
    onMounted(() => {
      toggleShowOverlay(false);
    });
    watchRoute([
      Layout.Default,
      Layout.LeftOnly
    ]);
    return {
      closeOverlay,
      helpUrl,
      homeRoute,
      items,
      overlayRef,
      showOverlay
    };
  }
});
defineComponent({
  name: "MainLayout",
  components: {
    NavigationBar,
    QDrawer: QDrawer_default,
    QLayout: QLayout_default,
    QPageContainer: QPageContainer_default,
    RouterView
  },
  setup() {
    const {
      collapsedNavigationbar,
      collapsedNavigationbarAfterAnimation,
      watchRoute
    } = useLayout();
    const { navigation } = useOptions();
    const helpUrl = computed(() => navigation.helpUrl);
    const homeRoute = computed(() => navigation.homeRoute);
    const items = computed(() => navigation.items ?? []);
    watchRoute([
      Layout.Default,
      Layout.LeftOnly
    ]);
    return {
      collapsedNavigationbar,
      collapsedNavigationbarAfterAnimation,
      helpUrl,
      homeRoute,
      items
    };
  }
});
const BREAK_POINT$1 = 1536;
const SPLIT_VIEW_BREAK_POINT = 1920;
const SPLIT_ALLOWED_BREAK_POINT = 1440;
defineComponent({
  name: "LabelerLayout",
  components: {
    NavigationBar,
    NavigationBarOverlay,
    QDrawer: QDrawer_default,
    QLayout: QLayout_default,
    QPageContainer: QPageContainer_default,
    QResizeObserver: QResizeObserver_default$1,
    RouterView
  },
  setup() {
    const {
      availableLayouts,
      collapsedNavigationbar,
      collapsedNavigationbarAfterAnimation,
      isFullLayout,
      isSplitLayout,
      layout,
      setAvailableLayouts,
      setSmallScreen,
      showOverlay,
      smallScreen,
      toggleNavigationBar,
      toggleShowOverlay,
      watchRoute
    } = useLayout();
    const { navigation } = useOptions();
    const screenWidth = ref$1(window.innerWidth);
    const helpUrl = computed(() => navigation.helpUrl);
    const homeRoute = computed(() => navigation.homeRoute);
    const items = computed(() => navigation.items ?? []);
    const isSplitLayoutSmallScreen = computed(() => {
      return isSplitLayout.value && screenWidth.value < SPLIT_VIEW_BREAK_POINT;
    });
    const minDrawerWidth = computed(() => {
      return isFullLayout.value || isSplitLayoutSmallScreen.value ? 0 : 72;
    });
    watchRoute([
      Layout.Default,
      Layout.Full,
      Layout.LeftOnly,
      Layout.RightOnly,
      Layout.Split
    ]);
    const onResize = ({ width }) => {
      screenWidth.value = width;
      if (width < SPLIT_ALLOWED_BREAK_POINT) {
        setAvailableLayouts(availableLayouts.value.filter((v) => v !== Layout.Split));
      } else {
        setAvailableLayouts(distinct([...availableLayouts.value, Layout.Split]));
      }
      if (width <= BREAK_POINT$1 || isSplitLayout.value && width < SPLIT_VIEW_BREAK_POINT) {
        setSmallScreen(true);
        toggleNavigationBar(true);
      } else {
        setSmallScreen(false);
      }
    };
    function closeOverlay() {
      toggleNavigationBar(true);
      toggleShowOverlay(false);
    }
    function closeOverlayOnSmallScreen() {
      if (smallScreen.value) {
        closeOverlay();
      }
    }
    onBeforeRouteLeave(closeOverlayOnSmallScreen);
    onBeforeRouteUpdate(closeOverlayOnSmallScreen);
    watch(isFullLayout, (value2) => {
      if (value2) closeOverlay();
    });
    return {
      closeOverlay,
      collapsedNavigationbar,
      collapsedNavigationbarAfterAnimation,
      helpUrl,
      homeRoute,
      items,
      layout,
      minDrawerWidth,
      onResize,
      showOverlay,
      smallScreen
    };
  }
});
const BREAK_POINT = 1536;
defineComponent({
  name: "ResponsiveLayout",
  components: {
    NavigationBar,
    QDrawer: QDrawer_default,
    QLayout: QLayout_default,
    QPageContainer: QPageContainer_default,
    QResizeObserver: QResizeObserver_default$1,
    RouterView
  },
  setup() {
    const {
      collapsedNavigationbar,
      collapsedNavigationbarAfterAnimation,
      setSmallScreen,
      smallScreen,
      toggleNavigationBar,
      watchRoute
    } = useLayout();
    const { navigation } = useOptions();
    const helpUrl = computed(() => navigation.helpUrl);
    const homeRoute = computed(() => navigation.homeRoute);
    const items = computed(() => navigation.items ?? []);
    watchRoute([
      Layout.Default,
      Layout.LeftOnly
    ]);
    const onResize = ({ width }) => {
      if (width <= BREAK_POINT) {
        setSmallScreen(true);
        toggleNavigationBar(true);
      } else {
        setSmallScreen(false);
      }
    };
    function closeOverlay() {
      toggleNavigationBar(true);
    }
    function closeOverlayOnSmallScreen() {
      if (smallScreen.value) {
        closeOverlay();
      }
    }
    onBeforeRouteLeave(closeOverlayOnSmallScreen);
    onBeforeRouteUpdate(closeOverlayOnSmallScreen);
    return {
      closeOverlay,
      collapsedNavigationbar,
      collapsedNavigationbarAfterAnimation,
      helpUrl,
      homeRoute,
      items,
      onResize,
      smallScreen
    };
  }
});
var lodash_merge = { exports: {} };
lodash_merge.exports;
(function(module, exports) {
  var LARGE_ARRAY_SIZE = 200;
  var HASH_UNDEFINED = "__lodash_hash_undefined__";
  var HOT_COUNT = 800, HOT_SPAN = 16;
  var MAX_SAFE_INTEGER = 9007199254740991;
  var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
  var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
  var reIsHostCtor = /^\[object .+?Constructor\]$/;
  var reIsUint = /^(?:0|[1-9]\d*)$/;
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
  var freeGlobal2 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  var freeSelf2 = typeof self == "object" && self && self.Object === Object && self;
  var root2 = freeGlobal2 || freeSelf2 || Function("return this")();
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var freeProcess = moduleExports && freeGlobal2.process;
  var nodeUtil = function() {
    try {
      var types = freeModule && freeModule.require && freeModule.require("util").types;
      if (types) {
        return types;
      }
      return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e22) {
    }
  }();
  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
  function apply2(func, thisArg, args) {
    switch (args.length) {
      case 0:
        return func.call(thisArg);
      case 1:
        return func.call(thisArg, args[0]);
      case 2:
        return func.call(thisArg, args[0], args[1]);
      case 3:
        return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }
  function baseTimes(n, iteratee) {
    var index2 = -1, result = Array(n);
    while (++index2 < n) {
      result[index2] = iteratee(index2);
    }
    return result;
  }
  function baseUnary(func) {
    return function(value2) {
      return func(value2);
    };
  }
  function getValue(object, key) {
    return object == null ? void 0 : object[key];
  }
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }
  var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto2 = Object.prototype;
  var coreJsData = root2["__core-js_shared__"];
  var funcToString = funcProto.toString;
  var hasOwnProperty = objectProto2.hasOwnProperty;
  var maskSrcKey = function() {
    var uid3 = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid3 ? "Symbol(src)_1." + uid3 : "";
  }();
  var nativeObjectToString = objectProto2.toString;
  var objectCtorString = funcToString.call(Object);
  var reIsNative = RegExp(
    "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  var Buffer2 = moduleExports ? root2.Buffer : void 0, Symbol2 = root2.Symbol, Uint8Array2 = root2.Uint8Array;
  Buffer2 ? Buffer2.allocUnsafe : void 0;
  var getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto2.propertyIsEnumerable, splice2 = arrayProto.splice, symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
  var defineProperty = function() {
    try {
      var func = getNative(Object, "defineProperty");
      func({}, "", {});
      return func;
    } catch (e22) {
    }
  }();
  var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0, nativeMax2 = Math.max, nativeNow = Date.now;
  var Map2 = getNative(root2, "Map"), nativeCreate = getNative(Object, "create");
  var baseCreate = /* @__PURE__ */ function() {
    function object() {
    }
    return function(proto) {
      if (!isObject2(proto)) {
        return {};
      }
      if (objectCreate) {
        return objectCreate(proto);
      }
      object.prototype = proto;
      var result = new object();
      object.prototype = void 0;
      return result;
    };
  }();
  function Hash(entries2) {
    var index2 = -1, length = entries2 == null ? 0 : entries2.length;
    this.clear();
    while (++index2 < length) {
      var entry = entries2[index2];
      this.set(entry[0], entry[1]);
    }
  }
  function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
  }
  function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }
  function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
      var result = data[key];
      return result === HASH_UNDEFINED ? void 0 : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : void 0;
  }
  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== void 0 : hasOwnProperty.call(data, key);
  }
  function hashSet(key, value2) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value2 === void 0 ? HASH_UNDEFINED : value2;
    return this;
  }
  Hash.prototype.clear = hashClear;
  Hash.prototype["delete"] = hashDelete;
  Hash.prototype.get = hashGet;
  Hash.prototype.has = hashHas;
  Hash.prototype.set = hashSet;
  function ListCache(entries2) {
    var index2 = -1, length = entries2 == null ? 0 : entries2.length;
    this.clear();
    while (++index2 < length) {
      var entry = entries2[index2];
      this.set(entry[0], entry[1]);
    }
  }
  function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
  }
  function listCacheDelete(key) {
    var data = this.__data__, index2 = assocIndexOf(data, key);
    if (index2 < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index2 == lastIndex) {
      data.pop();
    } else {
      splice2.call(data, index2, 1);
    }
    --this.size;
    return true;
  }
  function listCacheGet(key) {
    var data = this.__data__, index2 = assocIndexOf(data, key);
    return index2 < 0 ? void 0 : data[index2][1];
  }
  function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
  }
  function listCacheSet(key, value2) {
    var data = this.__data__, index2 = assocIndexOf(data, key);
    if (index2 < 0) {
      ++this.size;
      data.push([key, value2]);
    } else {
      data[index2][1] = value2;
    }
    return this;
  }
  ListCache.prototype.clear = listCacheClear;
  ListCache.prototype["delete"] = listCacheDelete;
  ListCache.prototype.get = listCacheGet;
  ListCache.prototype.has = listCacheHas;
  ListCache.prototype.set = listCacheSet;
  function MapCache(entries2) {
    var index2 = -1, length = entries2 == null ? 0 : entries2.length;
    this.clear();
    while (++index2 < length) {
      var entry = entries2[index2];
      this.set(entry[0], entry[1]);
    }
  }
  function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
      "hash": new Hash(),
      "map": new (Map2 || ListCache)(),
      "string": new Hash()
    };
  }
  function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
  }
  function mapCacheGet(key) {
    return getMapData(this, key).get(key);
  }
  function mapCacheHas(key) {
    return getMapData(this, key).has(key);
  }
  function mapCacheSet(key, value2) {
    var data = getMapData(this, key), size2 = data.size;
    data.set(key, value2);
    this.size += data.size == size2 ? 0 : 1;
    return this;
  }
  MapCache.prototype.clear = mapCacheClear;
  MapCache.prototype["delete"] = mapCacheDelete;
  MapCache.prototype.get = mapCacheGet;
  MapCache.prototype.has = mapCacheHas;
  MapCache.prototype.set = mapCacheSet;
  function Stack(entries2) {
    var data = this.__data__ = new ListCache(entries2);
    this.size = data.size;
  }
  function stackClear() {
    this.__data__ = new ListCache();
    this.size = 0;
  }
  function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
  }
  function stackGet(key) {
    return this.__data__.get(key);
  }
  function stackHas(key) {
    return this.__data__.has(key);
  }
  function stackSet(key, value2) {
    var data = this.__data__;
    if (data instanceof ListCache) {
      var pairs = data.__data__;
      if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
        pairs.push([key, value2]);
        this.size = ++data.size;
        return this;
      }
      data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value2);
    this.size = data.size;
    return this;
  }
  Stack.prototype.clear = stackClear;
  Stack.prototype["delete"] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;
  function arrayLikeKeys(value2, inherited) {
    var isArr = isArray2(value2), isArg = !isArr && isArguments(value2), isBuff = !isArr && !isArg && isBuffer3(value2), isType = !isArr && !isArg && !isBuff && isTypedArray(value2), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value2.length, String) : [], length = result.length;
    for (var key in value2) {
      if (!(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
      (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
      isIndex(key, length)))) {
        result.push(key);
      }
    }
    return result;
  }
  function assignMergeValue(object, key, value2) {
    if (value2 !== void 0 && !eq2(object[key], value2) || value2 === void 0 && !(key in object)) {
      baseAssignValue(object, key, value2);
    }
  }
  function assignValue(object, key, value2) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq2(objValue, value2)) || value2 === void 0 && !(key in object)) {
      baseAssignValue(object, key, value2);
    }
  }
  function assocIndexOf(array, key) {
    var length = array.length;
    while (length--) {
      if (eq2(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }
  function baseAssignValue(object, key, value2) {
    if (key == "__proto__" && defineProperty) {
      defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value2,
        "writable": true
      });
    } else {
      object[key] = value2;
    }
  }
  var baseFor = createBaseFor();
  function baseGetTag(value2) {
    if (value2 == null) {
      return value2 === void 0 ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value2) ? getRawTag(value2) : objectToString2(value2);
  }
  function baseIsArguments(value2) {
    return isObjectLike2(value2) && baseGetTag(value2) == argsTag;
  }
  function baseIsNative(value2) {
    if (!isObject2(value2) || isMasked(value2)) {
      return false;
    }
    var pattern = isFunction2(value2) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value2));
  }
  function baseIsTypedArray(value2) {
    return isObjectLike2(value2) && isLength(value2.length) && !!typedArrayTags[baseGetTag(value2)];
  }
  function baseKeysIn(object) {
    if (!isObject2(object)) {
      return nativeKeysIn(object);
    }
    var isProto = isPrototype(object), result = [];
    for (var key in object) {
      if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) {
        result.push(key);
      }
    }
    return result;
  }
  function baseMerge(object, source, srcIndex, customizer, stack2) {
    if (object === source) {
      return;
    }
    baseFor(source, function(srcValue, key) {
      stack2 || (stack2 = new Stack());
      if (isObject2(srcValue)) {
        baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack2);
      } else {
        var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack2) : void 0;
        if (newValue === void 0) {
          newValue = srcValue;
        }
        assignMergeValue(object, key, newValue);
      }
    }, keysIn);
  }
  function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack2) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack2.get(srcValue);
    if (stacked) {
      assignMergeValue(object, key, stacked);
      return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack2) : void 0;
    var isCommon = newValue === void 0;
    if (isCommon) {
      var isArr = isArray2(srcValue), isBuff = !isArr && isBuffer3(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
      newValue = srcValue;
      if (isArr || isBuff || isTyped) {
        if (isArray2(objValue)) {
          newValue = objValue;
        } else if (isArrayLikeObject(objValue)) {
          newValue = copyArray(objValue);
        } else if (isBuff) {
          isCommon = false;
          newValue = cloneBuffer(srcValue);
        } else if (isTyped) {
          isCommon = false;
          newValue = cloneTypedArray(srcValue);
        } else {
          newValue = [];
        }
      } else if (isPlainObject2(srcValue) || isArguments(srcValue)) {
        newValue = objValue;
        if (isArguments(objValue)) {
          newValue = toPlainObject(objValue);
        } else if (!isObject2(objValue) || isFunction2(objValue)) {
          newValue = initCloneObject(srcValue);
        }
      } else {
        isCommon = false;
      }
    }
    if (isCommon) {
      stack2.set(srcValue, newValue);
      mergeFunc(newValue, srcValue, srcIndex, customizer, stack2);
      stack2["delete"](srcValue);
    }
    assignMergeValue(object, key, newValue);
  }
  function baseRest(func, start) {
    return setToString(overRest(func, start, identity2), func + "");
  }
  var baseSetToString = !defineProperty ? identity2 : function(func, string) {
    return defineProperty(func, "toString", {
      "configurable": true,
      "enumerable": false,
      "value": constant(string),
      "writable": true
    });
  };
  function cloneBuffer(buffer, isDeep) {
    {
      return buffer.slice();
    }
  }
  function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array2(result).set(new Uint8Array2(arrayBuffer));
    return result;
  }
  function cloneTypedArray(typedArray, isDeep) {
    var buffer = cloneArrayBuffer(typedArray.buffer);
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
  }
  function copyArray(source, array) {
    var index2 = -1, length = source.length;
    array || (array = Array(length));
    while (++index2 < length) {
      array[index2] = source[index2];
    }
    return array;
  }
  function copyObject(source, props4, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index2 = -1, length = props4.length;
    while (++index2 < length) {
      var key = props4[index2];
      var newValue = void 0;
      if (newValue === void 0) {
        newValue = source[key];
      }
      if (isNew) {
        baseAssignValue(object, key, newValue);
      } else {
        assignValue(object, key, newValue);
      }
    }
    return object;
  }
  function createAssigner(assigner) {
    return baseRest(function(object, sources) {
      var index2 = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : void 0, guard = length > 2 ? sources[2] : void 0;
      customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : void 0;
      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        customizer = length < 3 ? void 0 : customizer;
        length = 1;
      }
      object = Object(object);
      while (++index2 < length) {
        var source = sources[index2];
        if (source) {
          assigner(object, source, index2, customizer);
        }
      }
      return object;
    });
  }
  function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
      var index2 = -1, iterable = Object(object), props4 = keysFunc(object), length = props4.length;
      while (length--) {
        var key = props4[++index2];
        if (iteratee(iterable[key], key, iterable) === false) {
          break;
        }
      }
      return object;
    };
  }
  function getMapData(map2, key) {
    var data = map2.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
  }
  function getNative(object, key) {
    var value2 = getValue(object, key);
    return baseIsNative(value2) ? value2 : void 0;
  }
  function getRawTag(value2) {
    var isOwn = hasOwnProperty.call(value2, symToStringTag), tag = value2[symToStringTag];
    try {
      value2[symToStringTag] = void 0;
      var unmasked = true;
    } catch (e22) {
    }
    var result = nativeObjectToString.call(value2);
    if (unmasked) {
      if (isOwn) {
        value2[symToStringTag] = tag;
      } else {
        delete value2[symToStringTag];
      }
    }
    return result;
  }
  function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
  }
  function isIndex(value2, length) {
    var type2 = typeof value2;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type2 == "number" || type2 != "symbol" && reIsUint.test(value2)) && (value2 > -1 && value2 % 1 == 0 && value2 < length);
  }
  function isIterateeCall(value2, index2, object) {
    if (!isObject2(object)) {
      return false;
    }
    var type2 = typeof index2;
    if (type2 == "number" ? isArrayLike(object) && isIndex(index2, object.length) : type2 == "string" && index2 in object) {
      return eq2(object[index2], value2);
    }
    return false;
  }
  function isKeyable(value2) {
    var type2 = typeof value2;
    return type2 == "string" || type2 == "number" || type2 == "symbol" || type2 == "boolean" ? value2 !== "__proto__" : value2 === null;
  }
  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }
  function isPrototype(value2) {
    var Ctor = value2 && value2.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto2;
    return value2 === proto;
  }
  function nativeKeysIn(object) {
    var result = [];
    if (object != null) {
      for (var key in Object(object)) {
        result.push(key);
      }
    }
    return result;
  }
  function objectToString2(value2) {
    return nativeObjectToString.call(value2);
  }
  function overRest(func, start, transform) {
    start = nativeMax2(start === void 0 ? func.length - 1 : start, 0);
    return function() {
      var args = arguments, index2 = -1, length = nativeMax2(args.length - start, 0), array = Array(length);
      while (++index2 < length) {
        array[index2] = args[start + index2];
      }
      index2 = -1;
      var otherArgs = Array(start + 1);
      while (++index2 < start) {
        otherArgs[index2] = args[index2];
      }
      otherArgs[start] = transform(array);
      return apply2(func, this, otherArgs);
    };
  }
  function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") {
      return;
    }
    if (key == "__proto__") {
      return;
    }
    return object[key];
  }
  var setToString = shortOut(baseSetToString);
  function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
      var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
      lastCalled = stamp;
      if (remaining > 0) {
        if (++count >= HOT_COUNT) {
          return arguments[0];
        }
      } else {
        count = 0;
      }
      return func.apply(void 0, arguments);
    };
  }
  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e22) {
      }
      try {
        return func + "";
      } catch (e22) {
      }
    }
    return "";
  }
  function eq2(value2, other) {
    return value2 === other || value2 !== value2 && other !== other;
  }
  var isArguments = baseIsArguments(/* @__PURE__ */ function() {
    return arguments;
  }()) ? baseIsArguments : function(value2) {
    return isObjectLike2(value2) && hasOwnProperty.call(value2, "callee") && !propertyIsEnumerable.call(value2, "callee");
  };
  var isArray2 = Array.isArray;
  function isArrayLike(value2) {
    return value2 != null && isLength(value2.length) && !isFunction2(value2);
  }
  function isArrayLikeObject(value2) {
    return isObjectLike2(value2) && isArrayLike(value2);
  }
  var isBuffer3 = nativeIsBuffer || stubFalse;
  function isFunction2(value2) {
    if (!isObject2(value2)) {
      return false;
    }
    var tag = baseGetTag(value2);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
  }
  function isLength(value2) {
    return typeof value2 == "number" && value2 > -1 && value2 % 1 == 0 && value2 <= MAX_SAFE_INTEGER;
  }
  function isObject2(value2) {
    var type2 = typeof value2;
    return value2 != null && (type2 == "object" || type2 == "function");
  }
  function isObjectLike2(value2) {
    return value2 != null && typeof value2 == "object";
  }
  function isPlainObject2(value2) {
    if (!isObjectLike2(value2) || baseGetTag(value2) != objectTag) {
      return false;
    }
    var proto = getPrototype(value2);
    if (proto === null) {
      return true;
    }
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
  }
  var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
  function toPlainObject(value2) {
    return copyObject(value2, keysIn(value2));
  }
  function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeysIn(object);
  }
  var merge3 = createAssigner(function(object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
  });
  function constant(value2) {
    return function() {
      return value2;
    };
  }
  function identity2(value2) {
    return value2;
  }
  function stubFalse() {
    return false;
  }
  module.exports = merge3;
})(lodash_merge, lodash_merge.exports);
lodash_merge.exports;
Object.entries(components$2).forEach(([componentName, component]) => {
});
const _hoisted_1$7 = { key: 0 };
const _hoisted_2$1 = {
  key: 0,
  class: "text-body3 multiline"
};
const _hoisted_3 = {
  key: 1,
  class: "column"
};
const _hoisted_4 = { class: "row no-wrap items-baseline q-pr-xs" };
const _hoisted_5 = { class: "text-subtitle3 multiline" };
const _hoisted_6 = {
  key: 2,
  class: "row no-wrap items-baseline"
};
const _hoisted_7 = { class: "row no-wrap items-baseline" };
const _hoisted_8 = { class: "single-line text-subtitle3 q-pl-xs" };
const _sfc_main$h = /* @__PURE__ */ defineComponent({
  __name: "ReadOnlyParam",
  props: {
    name: {
      required: true,
      type: String
    },
    value: {
      default: void 0,
      type: [Number, String, Boolean]
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  setup(__props) {
    const props4 = __props;
    const { t: $t2 } = useI18n();
    const multiline = computed(() => typeof props4.value === "string" && props4.value.includes("\n"));
    return (_ctx, _cache) => {
      var _a, _b;
      const _component_rv_ellipsis_text = resolveComponent("rv-ellipsis-text");
      return __props.valueOnly ? (openBlock(), createElementBlock("div", _hoisted_1$7, [
        multiline.value ? (openBlock(), createElementBlock("div", _hoisted_2$1, [
          createVNode(_component_rv_ellipsis_text, {
            text: ((_a = __props.value) == null ? void 0 : _a.toString()) ?? unref($t2)("rvai-params.general.none")
          }, null, 8, ["text"])
        ])) : (openBlock(), createBlock(_component_rv_ellipsis_text, {
          key: 1,
          class: "text-body3",
          text: ((_b = __props.value) == null ? void 0 : _b.toString()) ?? unref($t2)("rvai-params.general.none")
        }, null, 8, ["text"]))
      ])) : multiline.value ? (openBlock(), createElementBlock("div", _hoisted_3, [
        createElementVNode("div", _hoisted_4, [
          createVNode(_component_rv_ellipsis_text, {
            class: "text-body3",
            text: __props.name
          }, null, 8, ["text"]),
          createTextVNode(" " + toDisplayString(unref($t2)("rvai-params.general.symbols.colon")), 1)
        ]),
        createElementVNode("div", _hoisted_5, toDisplayString(__props.value ?? unref($t2)("rvai-params.general.none")), 1)
      ])) : (openBlock(), createElementBlock("div", _hoisted_6, [
        createVNode(_component_rv_ellipsis_text, {
          class: "text-body3",
          text: __props.name
        }, null, 8, ["text"]),
        createElementVNode("div", _hoisted_7, [
          createTextVNode(toDisplayString(unref($t2)("rvai-params.general.symbols.colon")) + " ", 1),
          createElementVNode("span", _hoisted_8, toDisplayString(__props.value ?? unref($t2)("rvai-params.general.none")), 1)
        ])
      ]));
    };
  }
});
const _export_sfc = (sfc, props4) => {
  const target2 = sfc.__vccOpts || sfc;
  for (const [key, val] of props4) {
    target2[key] = val;
  }
  return target2;
};
const ReadOnlyParam = /* @__PURE__ */ _export_sfc(_sfc_main$h, [["__scopeId", "data-v-932d28a2"]]);
const _sfc_main$g = /* @__PURE__ */ defineComponent({
  __name: "BooleanParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: Boolean
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props4 = __props;
    const i18nInstance = useI18n();
    const emit = __emit;
    const value2 = computed({
      get() {
        return props4.modelValue;
      },
      set(value22) {
        const updated = value22 != null ? buildParameterValue("Boolean", value22) : void 0;
        emit("update:modelValue", updated);
      }
    });
    const valueLabel = computed(() => {
      switch (value2.value) {
        case true:
          return i18nInstance.t("rvai-params.general.yes");
        case false:
          return i18nInstance.t("rvai-params.general.no");
        default:
          return i18nInstance.t("rvai-params.general.unset");
      }
    });
    const rules = computed(() => ({
      value: ValidationBuilder.withLabel(props4.definition.name, i18nInstance).requiredIf(!props4.definition.optional).rules
    }));
    const state2 = computed(() => ({
      value: value2.value
    }));
    useVuelidate(rules, state2, { $autoDirty: true });
    return (_ctx, _cache) => {
      const _component_rv_toggle = resolveComponent("rv-toggle");
      return !__props.readonly ? (openBlock(), createBlock(_component_rv_toggle, {
        key: 0,
        modelValue: value2.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => value2.value = $event),
        class: "q-py-sm",
        disable: __props.disable,
        "info-text": __props.definition.description ?? void 0,
        label: __props.definition.name
      }, null, 8, ["modelValue", "disable", "info-text", "label"])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: valueLabel.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const _sfc_main$f = /* @__PURE__ */ defineComponent({
  __name: "DictBoolParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: Object
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props4 = __props;
    const i18nInstance = useI18n();
    const { t: $t2 } = i18nInstance;
    const emit = __emit;
    const allSelected = computed(() => {
      var _a;
      return [...((_a = props4.modelValue) == null ? void 0 : _a.values()) ?? []].every((e3) => e3.value);
    });
    const hasSelected = computed(() => {
      var _a;
      return [...((_a = props4.modelValue) == null ? void 0 : _a.values()) ?? []].some((e3) => e3.value);
    });
    const options = computed(() => {
      var _a;
      return ((_a = props4.definition.keys) == null ? void 0 : _a.enum) || [];
    });
    const selected = computed({
      get() {
        var _a;
        return [...((_a = props4.modelValue) == null ? void 0 : _a.entries()) ?? []].filter(([, { value: value22 }]) => value22).map(([key]) => key);
      },
      set(value22) {
        const items = options.value.map((opt) => [opt, value22.includes(opt)]);
        const updatedValue = ParameterDict.new().addItems(items).build();
        emit("update:modelValue", updatedValue);
      }
    });
    const value2 = computed(() => {
      var _a;
      if (!hasSelected.value) return void 0;
      if (allSelected.value) return $t2("rvai-params.general.allSelected");
      return [...((_a = props4.modelValue) == null ? void 0 : _a.entries()) ?? []].filter(([, { value: value22 }]) => value22).map(([key]) => key).join("\n");
    });
    const rules = computed(() => ({
      selected: ValidationBuilder.withLabel(props4.definition.name, i18nInstance).rules
    }));
    const v$ = useVuelidate(rules, { selected: selected.value }, { $autoDirty: true });
    return (_ctx, _cache) => {
      const _component_rv_multiple_select = resolveComponent("rv-multiple-select");
      return !__props.readonly ? (openBlock(), createBlock(_component_rv_multiple_select, {
        key: 0,
        modelValue: selected.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => selected.value = $event),
        "all-selected-text": unref($t2)("rvai-params.general.allSelected"),
        class: "dict-param full-width",
        disable: __props.disable,
        "info-text": __props.definition.description,
        label: __props.definition.name,
        options: options.value,
        validation: unref(v$).selected,
        "with-chips": ""
      }, null, 8, ["modelValue", "all-selected-text", "disable", "info-text", "label", "options", "validation"])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: value2.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
    if (!getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
  }
  return getRandomValues(rnds8);
}
const REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function validate(uuid) {
  return typeof uuid === "string" && REGEX.test(uuid);
}
var byteToHex = [];
for (var i3 = 0; i3 < 256; ++i3) {
  byteToHex.push((i3 + 256).toString(16).substr(1));
}
function stringify(arr) {
  var offset2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  var uuid = (byteToHex[arr[offset2 + 0]] + byteToHex[arr[offset2 + 1]] + byteToHex[arr[offset2 + 2]] + byteToHex[arr[offset2 + 3]] + "-" + byteToHex[arr[offset2 + 4]] + byteToHex[arr[offset2 + 5]] + "-" + byteToHex[arr[offset2 + 6]] + byteToHex[arr[offset2 + 7]] + "-" + byteToHex[arr[offset2 + 8]] + byteToHex[arr[offset2 + 9]] + "-" + byteToHex[arr[offset2 + 10]] + byteToHex[arr[offset2 + 11]] + byteToHex[arr[offset2 + 12]] + byteToHex[arr[offset2 + 13]] + byteToHex[arr[offset2 + 14]] + byteToHex[arr[offset2 + 15]]).toLowerCase();
  if (!validate(uuid)) {
    throw TypeError("Stringified UUID is invalid");
  }
  return uuid;
}
function v4(options, buf2, offset2) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)();
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  return stringify(rnds);
}
const _sfc_main$e = /* @__PURE__ */ defineComponent({
  __name: "DictKeyValueParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: Object
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props4 = __props;
    const emit = __emit;
    const i18nInstance = useI18n();
    const { t: $t2 } = i18nInstance;
    function getDefaultValue() {
      var _a;
      const emptyValue = {
        id: v4(),
        row: ["", ""]
      };
      const entries2 = [...((_a = props4.modelValue) == null ? void 0 : _a.entries()) ?? []];
      if (entries2.length > 0) {
        return entries2.map(([key, node]) => ({
          id: node.id,
          row: [key, node.value]
        }));
      }
      return [emptyValue];
    }
    const rows = ref$1(getDefaultValue());
    function removeRow(rowIndex) {
      rows.value = rows.value.filter((_, i3) => i3 !== rowIndex);
      updateValue2();
    }
    function setDictValue(value22, rowIndex) {
      const id3 = rows.value[rowIndex] ? rows.value[rowIndex].id : v4();
      rows.value[rowIndex] = {
        id: id3,
        row: value22
      };
      updateValue2();
    }
    async function updateValue2() {
      const updatedValue = ParameterDict.new().addItems(rows.value.filter(({ row }) => {
        const [key, value22] = row;
        return !!key || !!value22;
      }).map(({ row }) => row)).build();
      emit("update:modelValue", updatedValue);
      await nextTick();
      v$.value.$validate();
    }
    const value2 = computed(() => {
      var _a;
      const entries2 = [...((_a = props4.modelValue) == null ? void 0 : _a.entries()) ?? []];
      if (!entries2.length || entries2.every(([key]) => !key)) return void 0;
      return entries2.map(([key, { value: value22 }]) => `${key}: ${value22}`).join("\n");
    });
    const rules = computed(() => rows.value.reduce((acc, {
      id: id3,
      row: [key, value22]
    }) => {
      var _a, _b, _c, _d, _e2;
      return {
        ...acc,
        [`${id3}-key`]: ValidationBuilder.withLabel(props4.definition.name, i18nInstance).custom(
          (key2) => {
            const equalKeysCount = rows.value.filter(({ row }) => {
              return row[0] === key2;
            }).length;
            return equalKeysCount < 2;
          },
          "rvai-params.errors.duplicatedKeys",
          [],
          "duplicatedKeys"
        ).custom(
          (key2) => {
            if (value22) return !!key2.trim();
            return true;
          },
          "rvai-params.errors.bothAreRequired",
          [],
          "requiredIf"
        ).custom(
          (key2) => {
            if (rows.value.length > 1) return !!key2.trim();
            return true;
          },
          "rvai-params.errors.bothAreRequired",
          [],
          "requiredIfHasOtherKeyValue"
        ).maxLength((_a = props4.definition.keys) == null ? void 0 : _a.maxLength).minLength((_b = props4.definition.keys) == null ? void 0 : _b.minLength).oneOfRegexes(((_d = (_c = props4.definition.keys) == null ? void 0 : _c.pattern) == null ? void 0 : _d.map((p2) => new RegExp(p2))) ?? []).rules,
        [`${id3}-value`]: ValidationBuilder.withLabel(props4.definition.name, i18nInstance).custom(
          (value3) => {
            if (key && !props4.definition.values.optional) return !!value3.trim();
            return true;
          },
          "rvai-params.errors.bothAreRequired",
          [],
          "requiredIf"
        ).maxLength("maxLength" in props4.definition.values ? props4.definition.values.maxLength : null).minLength("minLength" in props4.definition.values ? props4.definition.values.minLength : null).oneOfRegexes(
          "pattern" in props4.definition.values ? ((_e2 = props4.definition.values.pattern) == null ? void 0 : _e2.map((p2) => new RegExp(p2))) ?? [] : []
        ).rules
      };
    }, {}));
    const dataForValidation = computed(() => rows.value.reduce((acc, {
      id: id3,
      row: [key, value22]
    }) => ({
      ...acc,
      [`${id3}-key`]: key,
      [`${id3}-value`]: value22
    }), {}));
    const v$ = useVuelidate(rules, dataForValidation, { $autoDirty: true });
    watch(() => props4.modelValue, (curr, prev) => {
      const previousEntries = [...(prev == null ? void 0 : prev.entries()) ?? []];
      if (!previousEntries.length) return;
      const currentEntries = [...(curr == null ? void 0 : curr.entries()) ?? []];
      if (!currentEntries.length) {
        rows.value = getDefaultValue();
        updateValue2();
      }
    });
    return (_ctx, _cache) => {
      const _component_rv_combined_inputs = resolveComponent("rv-combined-inputs");
      const _component_rv_button = resolveComponent("rv-button");
      return !__props.readonly ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(rows.value, (v, i3) => {
        return openBlock(), createElementBlock("div", {
          key: v.id,
          class: "dict-key-value-param row full-width no-wrap justify-between items-start"
        }, [
          createVNode(_component_rv_combined_inputs, {
            class: normalizeClass(["dict-key-value-param__row", {
              "q-mb-md": rows.value.length - 1 !== i3
            }]),
            "data-automation": "dict-key-value-param__row",
            disable: __props.disable,
            hint: "",
            "info-text": __props.definition.description,
            label: i3 ? "" : __props.definition.name,
            "model-value": v.row,
            placeholders: [unref($t2)("rvai-params.general.key"), unref($t2)("rvai-params.general.value")],
            readonly: __props.readonly,
            separator: ":",
            "show-optional-label": __props.definition.optional,
            validation: [unref(v$)[`${v.id}-key`], unref(v$)[`${v.id}-value`]],
            "onUpdate:modelValue": ($event) => setDictValue($event, i3)
          }, null, 8, ["class", "disable", "info-text", "label", "model-value", "placeholders", "readonly", "show-optional-label", "validation", "onUpdate:modelValue"]),
          !__props.readonly ? (openBlock(), createBlock(_component_rv_button, {
            key: 0,
            class: normalizeClass(["dict-key-value-param__btn q-ml-sm", {
              "dict-key-value-param__btn--first-row": !i3
            }]),
            "data-automation": "dict-key-value-param__add",
            disable: !v.row[0].length || !v.row[1].length || !!rows.value[i3 + 1],
            icon: "mdi-plus",
            size: "sm",
            tertiary: "",
            onClick: ($event) => setDictValue(["", ""], i3 + 1)
          }, null, 8, ["class", "disable", "onClick"])) : createCommentVNode("", true),
          !__props.readonly ? (openBlock(), createBlock(_component_rv_button, {
            key: 1,
            class: normalizeClass(["dict-key-value-param__btn q-ml-sm", {
              "dict-key-value-param__btn--first-row": !i3
            }]),
            "data-automation": "dict-key-value-param__remove",
            disable: rows.value.length === 1,
            icon: "mdi-delete",
            size: "sm",
            tertiary: "",
            onClick: ($event) => removeRow(i3)
          }, null, 8, ["class", "disable", "onClick"])) : createCommentVNode("", true)
        ]);
      }), 128)) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: value2.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const DictKeyValueParam = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["__scopeId", "data-v-a5b1acd6"]]);
const _sfc_main$d = /* @__PURE__ */ defineComponent({
  __name: "EnumParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: String
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props4 = __props;
    const emit = __emit;
    const value2 = computed({
      get() {
        return props4.modelValue;
      },
      set(value22) {
        const updated = value22 != null ? buildParameterValue("Text", value22) : value22;
        emit("update:modelValue", updated);
      }
    });
    const i18nInstance = useI18n();
    const rules = computed(() => ({
      value: ValidationBuilder.withLabel(props4.definition.name, i18nInstance).requiredIf(!props4.definition.optional).rules
    }));
    const state2 = computed(() => ({
      value: value2.value
    }));
    const v$ = useVuelidate(rules, state2, { $autoDirty: true });
    return (_ctx, _cache) => {
      const _component_rv_select = resolveComponent("rv-select");
      return !__props.readonly ? (openBlock(), createBlock(_component_rv_select, {
        key: 0,
        modelValue: value2.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => value2.value = $event),
        disable: __props.disable,
        "info-text": __props.definition.description,
        label: __props.definition.name,
        options: __props.definition.enum ?? [],
        readonly: __props.readonly,
        "show-optional-label": __props.definition.optional,
        validation: unref(v$).value
      }, null, 8, ["modelValue", "disable", "info-text", "label", "options", "readonly", "show-optional-label", "validation"])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: value2.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const _hoisted_1$6 = {
  key: 0,
  class: "file-param"
};
const _sfc_main$c = /* @__PURE__ */ defineComponent({
  __name: "FileParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: Object
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props4 = __props;
    const emit = __emit;
    const file = ref$1([]);
    const value2 = computed(() => file.value && file.value.length ? file.value[0].name : void 0);
    async function updateValue2(value22) {
      file.value = value22;
      if (value22 && value22.length) {
        emit("update:modelValue", await Blob$1.fromFile(value22[0]));
      } else {
        clearAll();
      }
    }
    function clearAll() {
      emit("update:modelValue", void 0);
    }
    return (_ctx, _cache) => {
      const _component_rv_dropzone = resolveComponent("rv-dropzone");
      return !__props.readonly ? (openBlock(), createElementBlock("div", _hoisted_1$6, [
        createVNode(_component_rv_dropzone, {
          "allowed-extensions": props4.definition.extension,
          disable: __props.disable,
          "max-files": 1,
          "model-value": __props.modelValue,
          multiple: false,
          onClear: clearAll,
          "onUpdate:modelValue": updateValue2
        }, null, 8, ["allowed-extensions", "disable", "model-value"])
      ])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: value2.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const _hoisted_1$5 = {
  key: 0,
  class: "row no-wrap items-end"
};
const _sfc_main$b = /* @__PURE__ */ defineComponent({
  __name: "FloatParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: [Object, Number]
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    var _a;
    const props4 = __props;
    const emit = __emit;
    const i18nInstance = useI18n();
    const isSlider = computed(() => props4.definition.widget === "slider" && props4.definition.maximum != null && props4.definition.minimum != null);
    const valueRef = ref$1(typeof props4.modelValue === "number" ? props4.modelValue : (_a = props4.modelValue) == null ? void 0 : _a.value);
    const isPercentage = computed(() => props4.definition.widget === "percentage");
    const value2 = computed({
      get() {
        return isPercentage.value && valueRef.value ? valueRef.value * 100 : valueRef.value;
      },
      set(value22) {
        valueRef.value = isPercentage.value && value22 ? value22 / 100 : value22;
        if (valueRef.value == null) {
          emit("update:modelValue", void 0);
        } else {
          const parsed = Number(valueRef.value);
          if (!isNaN(parsed)) {
            const updated = buildParameterValue("Float", parsed);
            emit("update:modelValue", updated);
          }
        }
      }
    });
    const maxValue2 = computed(() => props4.definition.exclusiveMaximum ?? props4.definition.maximum);
    const hasMaxValue = computed(() => maxValue2.value != null);
    const maxValueExclusive = computed(() => props4.definition.exclusiveMaximum != null);
    const minValue2 = computed(() => props4.definition.minimum ?? props4.definition.exclusiveMinimum);
    const hasMinValue = computed(() => minValue2.value != null);
    const minValueExclusive = computed(() => props4.definition.exclusiveMinimum != null);
    const rules = computed(() => ({
      value: ValidationBuilder.withLabel(props4.definition.name, i18nInstance).requiredIf(!props4.definition.optional).numeric.decimal.minValueIf(hasMinValue.value, minValue2.value, !minValueExclusive.value).maxValueIf(hasMaxValue.value, maxValue2.value, !maxValueExclusive.value).rules
    }));
    const state2 = computed(() => ({
      value: valueRef.value
    }));
    const v$ = useVuelidate(rules, state2, { $autoDirty: true });
    watch(
      () => props4.modelValue,
      () => {
        var _a2;
        const newValue = typeof props4.modelValue === "number" ? props4.modelValue : (_a2 = props4.modelValue) == null ? void 0 : _a2.value;
        if (Number(valueRef.value) !== Number(newValue)) {
          valueRef.value = newValue;
        }
      }
    );
    return (_ctx, _cache) => {
      const _component_rv_slider = resolveComponent("rv-slider");
      const _component_rv_input = resolveComponent("rv-input");
      return !__props.readonly ? (openBlock(), createElementBlock("div", _hoisted_1$5, [
        isSlider.value ? (openBlock(), createBlock(_component_rv_slider, {
          key: 0,
          modelValue: value2.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => value2.value = $event),
          class: "full-width",
          disable: __props.disable,
          float: "",
          "info-text": __props.definition.description,
          "input-decimals": 3,
          label: __props.definition.name,
          max: __props.definition.maximum,
          min: __props.definition.minimum,
          readonly: __props.readonly,
          "show-optional-label": __props.definition.optional,
          step: 0.1,
          suffix: isPercentage.value ? "%" : void 0,
          validation: unref(v$).value,
          "with-input": ""
        }, null, 8, ["modelValue", "disable", "info-text", "label", "max", "min", "readonly", "show-optional-label", "suffix", "validation"])) : (openBlock(), createBlock(_component_rv_input, {
          key: 1,
          modelValue: value2.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => value2.value = $event),
          class: "full-width",
          disable: __props.disable,
          "info-text": __props.definition.description,
          label: __props.definition.name,
          readonly: __props.readonly,
          "show-optional-label": __props.definition.optional,
          suffix: isPercentage.value ? "%" : void 0,
          validation: unref(v$).value
        }, null, 8, ["modelValue", "disable", "info-text", "label", "readonly", "show-optional-label", "suffix", "validation"]))
      ])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: value2.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const _sfc_main$a = /* @__PURE__ */ defineComponent({
  __name: "FloatRangeParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: [Object]
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props4 = __props;
    const emit = __emit;
    const i18nInstance = useI18n();
    const defaultValues = computed(() => Object.assign({
      lowerBound: 0.3,
      lowerInclusive: false,
      upperBound: 0.5,
      upperInclusive: false
    }, props4.definition.default));
    const valueRef = ref$1(getRangeValue(props4.modelValue));
    const value2 = computed({
      get() {
        return valueRef.value;
      },
      set(value22) {
        var _a, _b;
        valueRef.value = value22;
        emit(
          "update:modelValue",
          buildParameterValue("FloatRange", {
            lowerBound: valueRef.value.min,
            lowerInclusive: ((_a = props4.modelValue) == null ? void 0 : _a.lowerInclusive) ?? defaultValues.value.lowerInclusive,
            upperBound: valueRef.value.max,
            upperInclusive: ((_b = props4.modelValue) == null ? void 0 : _b.upperInclusive) ?? defaultValues.value.upperInclusive
          })
        );
      }
    });
    const maxValue2 = computed(() => props4.definition.exclusiveMaximum ?? props4.definition.maximum);
    const hasMaxValue = computed(() => maxValue2.value != null);
    const maxValueExclusive = computed(() => props4.definition.exclusiveMaximum != null);
    const minValue2 = computed(() => props4.definition.minimum ?? props4.definition.exclusiveMinimum);
    const hasMinValue = computed(() => minValue2.value != null);
    const minValueExclusive = computed(() => props4.definition.exclusiveMinimum != null);
    const rules = computed(() => ({
      max: ValidationBuilder.withLabel(props4.definition.name, i18nInstance).requiredIf(!props4.definition.optional).numeric.decimal.maxValueIf(hasMaxValue.value, maxValue2.value, !maxValueExclusive.value).rules,
      min: ValidationBuilder.withLabel(props4.definition.name, i18nInstance).requiredIf(!props4.definition.optional).numeric.decimal.minValueIf(hasMinValue.value, minValue2.value, !minValueExclusive.value).rules
    }));
    const state2 = computed(() => ({
      max: valueRef.value.max,
      min: valueRef.value.min
    }));
    const v$ = useVuelidate(rules, state2, { $autoDirty: true });
    function getRangeValue(value22) {
      return {
        max: (value22 == null ? void 0 : value22.upperBound) ?? defaultValues.value.upperBound,
        min: (value22 == null ? void 0 : value22.lowerBound) ?? defaultValues.value.lowerBound
      };
    }
    watch(
      () => props4.modelValue,
      (newValue) => {
        valueRef.value = getRangeValue(newValue);
      }
    );
    return (_ctx, _cache) => {
      const _component_rv_range = resolveComponent("rv-range");
      return !__props.readonly ? (openBlock(), createBlock(_component_rv_range, {
        key: 0,
        modelValue: value2.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => value2.value = $event),
        class: "full-width",
        disable: __props.disable,
        "info-text": __props.definition.description ?? void 0,
        "input-decimals": 3,
        label: __props.definition.name,
        max: __props.definition.maximum ?? void 0,
        min: __props.definition.minimum ?? void 0,
        "show-optional-label": __props.definition.optional,
        step: 0.1,
        validation: unref(v$).value,
        "with-input": ""
      }, null, 8, ["modelValue", "disable", "info-text", "label", "max", "min", "show-optional-label", "validation"])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: props4.modelValue ? `${props4.modelValue.lowerBound} - ${props4.modelValue.upperBound}` : void 0,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
/*!
 * Quasar Framework v2.18.2
 * (c) 2015-present Razvan Stoenescu
 * Released under the MIT License.
 */
var attachPoint = null;
function getAttachPoint() {
  if (attachPoint !== null) return attachPoint;
  return attachPoint = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {};
}
if (typeof __QUASAR_SSR__ !== "boolean") {
  getAttachPoint().__QUASAR_SSR__ = false;
}
if (typeof __QUASAR_SSR_CLIENT__ !== "boolean") {
  getAttachPoint().__QUASAR_SSR_CLIENT__ = false;
}
if (typeof __QUASAR_SSR_PWA__ !== "boolean") {
  getAttachPoint().__QUASAR_SSR_PWA__ = false;
}
function injectProp(target2, propName, get2, set2) {
  Object.defineProperty(target2, propName, {
    get: get2,
    set: set2,
    enumerable: true
  });
  return target2;
}
function injectMultipleProps(target2, props4) {
  for (const key in props4) {
    injectProp(target2, key, props4[key]);
  }
  return target2;
}
var isRuntimeSsrPreHydration = ref$1(
  __QUASAR_SSR_CLIENT__ && (__QUASAR_SSR_PWA__ ? document.body.getAttribute("data-server-rendered") !== null : true)
);
var preHydrationBrowser;
function getMatch(userAgent2, platformMatch) {
  const match2 = /(edg|edge|edga|edgios)\/([\w.]+)/.exec(userAgent2) || /(opr)[\/]([\w.]+)/.exec(userAgent2) || /(vivaldi)[\/]([\w.]+)/.exec(userAgent2) || /(chrome|crios)[\/]([\w.]+)/.exec(userAgent2) || /(version)(applewebkit)[\/]([\w.]+).*(safari)[\/]([\w.]+)/.exec(userAgent2) || /(webkit)[\/]([\w.]+).*(version)[\/]([\w.]+).*(safari)[\/]([\w.]+)/.exec(userAgent2) || /(firefox|fxios)[\/]([\w.]+)/.exec(userAgent2) || /(webkit)[\/]([\w.]+)/.exec(userAgent2) || /(opera)(?:.*version|)[\/]([\w.]+)/.exec(userAgent2) || [];
  return {
    browser: match2[5] || match2[3] || match2[1] || "",
    version: match2[4] || match2[2] || "0",
    platform: platformMatch[0] || ""
  };
}
function getPlatformMatch(userAgent2) {
  return /(ipad)/.exec(userAgent2) || /(ipod)/.exec(userAgent2) || /(windows phone)/.exec(userAgent2) || /(iphone)/.exec(userAgent2) || /(kindle)/.exec(userAgent2) || /(silk)/.exec(userAgent2) || /(android)/.exec(userAgent2) || /(win)/.exec(userAgent2) || /(mac)/.exec(userAgent2) || /(linux)/.exec(userAgent2) || /(cros)/.exec(userAgent2) || /(playbook)/.exec(userAgent2) || /(bb)/.exec(userAgent2) || /(blackberry)/.exec(userAgent2) || [];
}
var hasTouch = "ontouchstart" in window || window.navigator.maxTouchPoints > 0;
function getPlatform(UA) {
  const userAgent2 = UA.toLowerCase();
  const platformMatch = getPlatformMatch(userAgent2);
  const matched = getMatch(userAgent2, platformMatch);
  const browser = {
    mobile: false,
    desktop: false,
    cordova: false,
    capacitor: false,
    nativeMobile: false,
    // nativeMobileWrapper: void 0,
    electron: false,
    bex: false,
    linux: false,
    mac: false,
    win: false,
    cros: false,
    chrome: false,
    firefox: false,
    opera: false,
    safari: false,
    vivaldi: false,
    edge: false,
    edgeChromium: false,
    ie: false,
    webkit: false,
    android: false,
    ios: false,
    ipad: false,
    iphone: false,
    ipod: false,
    kindle: false,
    winphone: false,
    blackberry: false,
    playbook: false,
    silk: false
  };
  if (matched.browser) {
    browser[matched.browser] = true;
    browser.version = matched.version;
    browser.versionNumber = parseInt(matched.version, 10);
  }
  if (matched.platform) {
    browser[matched.platform] = true;
  }
  const knownMobiles = browser.android || browser.ios || browser.bb || browser.blackberry || browser.ipad || browser.iphone || browser.ipod || browser.kindle || browser.playbook || browser.silk || browser["windows phone"];
  if (knownMobiles === true || userAgent2.indexOf("mobile") !== -1) {
    browser.mobile = true;
  } else {
    browser.desktop = true;
  }
  if (browser["windows phone"]) {
    browser.winphone = true;
    delete browser["windows phone"];
  }
  if (browser.edga || browser.edgios || browser.edg) {
    browser.edge = true;
    matched.browser = "edge";
  } else if (browser.crios) {
    browser.chrome = true;
    matched.browser = "chrome";
  } else if (browser.fxios) {
    browser.firefox = true;
    matched.browser = "firefox";
  }
  if (browser.ipod || browser.ipad || browser.iphone) {
    browser.ios = true;
  }
  if (browser.vivaldi) {
    matched.browser = "vivaldi";
    browser.vivaldi = true;
  }
  if (
    // Chrome, Opera 15+, Vivaldi and Safari are webkit based browsers
    browser.chrome || browser.opr || browser.safari || browser.vivaldi || browser.mobile === true && browser.ios !== true && knownMobiles !== true
  ) {
    browser.webkit = true;
  }
  if (browser.opr) {
    matched.browser = "opera";
    browser.opera = true;
  }
  if (browser.safari) {
    if (browser.blackberry || browser.bb) {
      matched.browser = "blackberry";
      browser.blackberry = true;
    } else if (browser.playbook) {
      matched.browser = "playbook";
      browser.playbook = true;
    } else if (browser.android) {
      matched.browser = "android";
      browser.android = true;
    } else if (browser.kindle) {
      matched.browser = "kindle";
      browser.kindle = true;
    } else if (browser.silk) {
      matched.browser = "silk";
      browser.silk = true;
    }
  }
  browser.name = matched.browser;
  browser.platform = matched.platform;
  {
    if (userAgent2.indexOf("electron") !== -1) {
      browser.electron = true;
    } else if (document.location.href.indexOf("-extension://") !== -1) {
      browser.bex = true;
    } else {
      if (window.Capacitor !== void 0) {
        browser.capacitor = true;
        browser.nativeMobile = true;
        browser.nativeMobileWrapper = "capacitor";
      } else if (window._cordovaNative !== void 0 || window.cordova !== void 0) {
        browser.cordova = true;
        browser.nativeMobile = true;
        browser.nativeMobileWrapper = "cordova";
      }
      if (isRuntimeSsrPreHydration.value === true) {
        preHydrationBrowser = { is: { ...browser } };
      }
      if (hasTouch === true && browser.mac === true && (browser.desktop === true && browser.safari === true || browser.nativeMobile === true && browser.android !== true && browser.ios !== true && browser.ipad !== true)) {
        delete browser.mac;
        delete browser.desktop;
        const platform = Math.min(window.innerHeight, window.innerWidth) > 414 ? "ipad" : "iphone";
        Object.assign(browser, {
          mobile: true,
          ios: true,
          platform,
          [platform]: true
        });
      }
      if (browser.mobile !== true && window.navigator.userAgentData && window.navigator.userAgentData.mobile) {
        delete browser.desktop;
        browser.mobile = true;
      }
    }
  }
  return browser;
}
var userAgent = navigator.userAgent || navigator.vendor || window.opera;
var ssrClient = {
  has: {
    touch: false,
    webStorage: false
  },
  within: { iframe: false }
};
var client = {
  userAgent,
  is: getPlatform(userAgent),
  has: {
    touch: hasTouch
  },
  within: {
    iframe: window.self !== window.top
  }
};
var Platform = {
  install(opts) {
    const { $q } = opts;
    if (isRuntimeSsrPreHydration.value === true) {
      opts.onSSRHydrated.push(() => {
        Object.assign($q.platform, client);
        isRuntimeSsrPreHydration.value = false;
      });
      $q.platform = reactive(this);
    } else {
      $q.platform = this;
    }
  }
};
{
  let hasWebStorage;
  injectProp(client.has, "webStorage", () => {
    if (hasWebStorage !== void 0) {
      return hasWebStorage;
    }
    try {
      if (window.localStorage) {
        hasWebStorage = true;
        return true;
      }
    } catch (_) {
    }
    hasWebStorage = false;
    return false;
  });
  Object.assign(Platform, client);
  if (isRuntimeSsrPreHydration.value === true) {
    Object.assign(Platform, preHydrationBrowser, ssrClient);
    preHydrationBrowser = null;
  }
}
var Platform_default = Platform;
function createComponent(raw) {
  return markRaw(defineComponent(raw));
}
function createDirective(raw) {
  return markRaw(raw);
}
var createReactivePlugin = (state2, plugin2) => {
  const reactiveState = reactive(state2);
  for (const name2 in state2) {
    injectProp(
      plugin2,
      name2,
      () => reactiveState[name2],
      (val) => {
        reactiveState[name2] = val;
      }
    );
  }
  return plugin2;
};
var listenOpts = {
  hasPassive: false,
  passiveCapture: true,
  notPassiveCapture: true
};
try {
  const opts = Object.defineProperty({}, "passive", {
    get() {
      Object.assign(listenOpts, {
        hasPassive: true,
        passive: { passive: true },
        notPassive: { passive: false },
        passiveCapture: { passive: true, capture: true },
        notPassiveCapture: { passive: false, capture: true }
      });
    }
  });
  window.addEventListener("qtest", null, opts);
  window.removeEventListener("qtest", null, opts);
} catch (_) {
}
function noop() {
}
function leftClick(e3) {
  return e3.button === 0;
}
function position(e3) {
  if (e3.touches && e3.touches[0]) {
    e3 = e3.touches[0];
  } else if (e3.changedTouches && e3.changedTouches[0]) {
    e3 = e3.changedTouches[0];
  } else if (e3.targetTouches && e3.targetTouches[0]) {
    e3 = e3.targetTouches[0];
  }
  return {
    top: e3.clientY,
    left: e3.clientX
  };
}
function getEventPath(e3) {
  if (e3.path) {
    return e3.path;
  }
  if (e3.composedPath) {
    return e3.composedPath();
  }
  const path = [];
  let el = e3.target;
  while (el) {
    path.push(el);
    if (el.tagName === "HTML") {
      path.push(document);
      path.push(window);
      return path;
    }
    el = el.parentElement;
  }
}
function stop(e3) {
  e3.stopPropagation();
}
function prevent(e3) {
  e3.cancelable !== false && e3.preventDefault();
}
function stopAndPrevent(e3) {
  e3.cancelable !== false && e3.preventDefault();
  e3.stopPropagation();
}
function preventDraggable(el, status) {
  if (el === void 0 || status === true && el.__dragPrevented === true) {
    return;
  }
  const fn = status === true ? (el2) => {
    el2.__dragPrevented = true;
    el2.addEventListener("dragstart", prevent, listenOpts.notPassiveCapture);
  } : (el2) => {
    delete el2.__dragPrevented;
    el2.removeEventListener("dragstart", prevent, listenOpts.notPassiveCapture);
  };
  el.querySelectorAll("a, img").forEach(fn);
}
function addEvt(ctx, targetName, events) {
  const name2 = `__q_${targetName}_evt`;
  ctx[name2] = ctx[name2] !== void 0 ? ctx[name2].concat(events) : events;
  events.forEach((evt) => {
    evt[0].addEventListener(evt[1], ctx[evt[2]], listenOpts[evt[3]]);
  });
}
function cleanEvt(ctx, targetName) {
  const name2 = `__q_${targetName}_evt`;
  if (ctx[name2] !== void 0) {
    ctx[name2].forEach((evt) => {
      evt[0].removeEventListener(evt[1], ctx[evt[2]], listenOpts[evt[3]]);
    });
    ctx[name2] = void 0;
  }
}
function debounce_default(fn, wait2 = 250, immediate) {
  let timer2 = null;
  function debounced() {
    const args = arguments;
    const later = () => {
      timer2 = null;
      {
        fn.apply(this, args);
      }
    };
    if (timer2 !== null) {
      clearTimeout(timer2);
    }
    timer2 = setTimeout(later, wait2);
  }
  debounced.cancel = () => {
    timer2 !== null && clearTimeout(timer2);
  };
  return debounced;
}
var SIZE_LIST = ["sm", "md", "lg", "xl"];
var { passive } = listenOpts;
createReactivePlugin({
  width: 0,
  height: 0,
  name: "xs",
  sizes: {
    sm: 600,
    md: 1024,
    lg: 1440,
    xl: 1920
  },
  lt: {
    sm: true,
    md: true,
    lg: true,
    xl: true
  },
  gt: {
    xs: false,
    sm: false,
    md: false,
    lg: false
  },
  xs: true,
  sm: false,
  md: false,
  lg: false,
  xl: false
}, {
  setSizes: noop,
  setDebounce: noop,
  install({ $q, onSSRHydrated }) {
    var _a;
    $q.screen = this;
    if (this.__installed === true) {
      if ($q.config.screen !== void 0) {
        if ($q.config.screen.bodyClasses === false) {
          document.body.classList.remove(`screen--${this.name}`);
        } else {
          this.__update(true);
        }
      }
      return;
    }
    const { visualViewport } = window;
    const target2 = visualViewport || window;
    const scrollingElement = document.scrollingElement || document.documentElement;
    const getSize = visualViewport === void 0 || client.is.mobile === true ? () => [
      Math.max(window.innerWidth, scrollingElement.clientWidth),
      Math.max(window.innerHeight, scrollingElement.clientHeight)
    ] : () => [
      visualViewport.width * visualViewport.scale + window.innerWidth - scrollingElement.clientWidth,
      visualViewport.height * visualViewport.scale + window.innerHeight - scrollingElement.clientHeight
    ];
    const classes = ((_a = $q.config.screen) == null ? void 0 : _a.bodyClasses) === true;
    this.__update = (force) => {
      const [w3, h138] = getSize();
      if (h138 !== this.height) {
        this.height = h138;
      }
      if (w3 !== this.width) {
        this.width = w3;
      } else if (force !== true) {
        return;
      }
      let s4 = this.sizes;
      this.gt.xs = w3 >= s4.sm;
      this.gt.sm = w3 >= s4.md;
      this.gt.md = w3 >= s4.lg;
      this.gt.lg = w3 >= s4.xl;
      this.lt.sm = w3 < s4.sm;
      this.lt.md = w3 < s4.md;
      this.lt.lg = w3 < s4.lg;
      this.lt.xl = w3 < s4.xl;
      this.xs = this.lt.sm;
      this.sm = this.gt.xs === true && this.lt.md === true;
      this.md = this.gt.sm === true && this.lt.lg === true;
      this.lg = this.gt.md === true && this.lt.xl === true;
      this.xl = this.gt.lg;
      s4 = this.xs === true && "xs" || this.sm === true && "sm" || this.md === true && "md" || this.lg === true && "lg" || "xl";
      if (s4 !== this.name) {
        if (classes === true) {
          document.body.classList.remove(`screen--${this.name}`);
          document.body.classList.add(`screen--${s4}`);
        }
        this.name = s4;
      }
    };
    let updateEvt, updateSizes = {}, updateDebounce = 16;
    this.setSizes = (sizes) => {
      SIZE_LIST.forEach((name2) => {
        if (sizes[name2] !== void 0) {
          updateSizes[name2] = sizes[name2];
        }
      });
    };
    this.setDebounce = (deb) => {
      updateDebounce = deb;
    };
    const start = () => {
      const style2 = getComputedStyle(document.body);
      if (style2.getPropertyValue("--q-size-sm")) {
        SIZE_LIST.forEach((name2) => {
          this.sizes[name2] = parseInt(style2.getPropertyValue(`--q-size-${name2}`), 10);
        });
      }
      this.setSizes = (sizes) => {
        SIZE_LIST.forEach((name2) => {
          if (sizes[name2]) {
            this.sizes[name2] = sizes[name2];
          }
        });
        this.__update(true);
      };
      this.setDebounce = (delay) => {
        updateEvt !== void 0 && target2.removeEventListener("resize", updateEvt, passive);
        updateEvt = delay > 0 ? debounce_default(this.__update, delay) : this.__update;
        target2.addEventListener("resize", updateEvt, passive);
      };
      this.setDebounce(updateDebounce);
      if (Object.keys(updateSizes).length !== 0) {
        this.setSizes(updateSizes);
        updateSizes = void 0;
      } else {
        this.__update();
      }
      classes === true && this.name === "xs" && document.body.classList.add("screen--xs");
    };
    if (isRuntimeSsrPreHydration.value === true) {
      onSSRHydrated.push(start);
    } else {
      start();
    }
  }
});
var Plugin = createReactivePlugin({
  isActive: false,
  mode: false
}, {
  __media: void 0,
  set(val) {
    Plugin.mode = val;
    if (val === "auto") {
      if (Plugin.__media === void 0) {
        Plugin.__media = window.matchMedia("(prefers-color-scheme: dark)");
        Plugin.__updateMedia = () => {
          Plugin.set("auto");
        };
        Plugin.__media.addListener(Plugin.__updateMedia);
      }
      val = Plugin.__media.matches;
    } else if (Plugin.__media !== void 0) {
      Plugin.__media.removeListener(Plugin.__updateMedia);
      Plugin.__media = void 0;
    }
    Plugin.isActive = val === true;
    document.body.classList.remove(`body--${val === true ? "light" : "dark"}`);
    document.body.classList.add(`body--${val === true ? "dark" : "light"}`);
  },
  toggle() {
    {
      Plugin.set(Plugin.isActive === false);
    }
  },
  install({ $q, ssrContext }) {
    const dark = __QUASAR_SSR_CLIENT__ ? document.body.classList.contains("body--dark") : $q.config.dark;
    $q.dark = this;
    if (this.__installed !== true) {
      this.set(dark !== void 0 ? dark : false);
    }
  }
});
function shouldIgnoreKey(evt) {
  return evt !== Object(evt) || evt.isComposing === true || evt.qKeyEvent === true;
}
function isKeyCode(evt, keyCodes4) {
  return shouldIgnoreKey(evt) === true ? false : [].concat(keyCodes4).includes(evt.keyCode);
}
var en_US_default = {
  isoName: "en-US",
  nativeName: "English (US)",
  label: {
    clear: "Clear",
    ok: "OK",
    cancel: "Cancel",
    close: "Close",
    set: "Set",
    select: "Select",
    reset: "Reset",
    remove: "Remove",
    update: "Update",
    create: "Create",
    search: "Search",
    filter: "Filter",
    refresh: "Refresh",
    expand: (label) => label ? `Expand "${label}"` : "Expand",
    collapse: (label) => label ? `Collapse "${label}"` : "Collapse"
  },
  date: {
    days: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
    daysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
    months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
    monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
    firstDayOfWeek: 0,
    // 0-6, 0 - Sunday, 1 Monday, ...
    format24h: false,
    pluralDay: "days",
    prevMonth: "Previous month",
    nextMonth: "Next month",
    prevYear: "Previous year",
    nextYear: "Next year",
    today: "Today",
    prevRangeYears: (range2) => `Previous ${range2} years`,
    nextRangeYears: (range2) => `Next ${range2} years`
  },
  table: {
    noData: "No data available",
    noResults: "No matching records found",
    loading: "Loading...",
    selectedRecords: (rows) => rows === 1 ? "1 record selected." : (rows === 0 ? "No" : rows) + " records selected.",
    recordsPerPage: "Records per page:",
    allRows: "All",
    pagination: (start, end, total) => start + "-" + end + " of " + total,
    columns: "Columns"
  },
  pagination: {
    first: "First page",
    prev: "Previous page",
    next: "Next page",
    last: "Last page"
  },
  editor: {
    url: "URL",
    bold: "Bold",
    italic: "Italic",
    strikethrough: "Strikethrough",
    underline: "Underline",
    unorderedList: "Unordered List",
    orderedList: "Ordered List",
    subscript: "Subscript",
    superscript: "Superscript",
    hyperlink: "Hyperlink",
    toggleFullscreen: "Toggle Fullscreen",
    quote: "Quote",
    left: "Left align",
    center: "Center align",
    right: "Right align",
    justify: "Justify align",
    print: "Print",
    outdent: "Decrease indentation",
    indent: "Increase indentation",
    removeFormat: "Remove formatting",
    formatting: "Formatting",
    fontSize: "Font Size",
    align: "Align",
    hr: "Insert Horizontal Rule",
    undo: "Undo",
    redo: "Redo",
    heading1: "Heading 1",
    heading2: "Heading 2",
    heading3: "Heading 3",
    heading4: "Heading 4",
    heading5: "Heading 5",
    heading6: "Heading 6",
    paragraph: "Paragraph",
    code: "Code",
    size1: "Very small",
    size2: "A bit small",
    size3: "Normal",
    size4: "Medium-large",
    size5: "Big",
    size6: "Very big",
    size7: "Maximum",
    defaultFont: "Default Font",
    viewSource: "View Source"
  },
  tree: {
    noNodes: "No nodes available",
    noResults: "No matching nodes found"
  }
};
function getLocale() {
  const val = Array.isArray(navigator.languages) === true && navigator.languages.length !== 0 ? navigator.languages[0] : navigator.language;
  if (typeof val === "string") {
    return val.split(/[-_]/).map((v, i3) => i3 === 0 ? v.toLowerCase() : i3 > 1 || v.length < 4 ? v.toUpperCase() : v[0].toUpperCase() + v.slice(1).toLowerCase()).join("-");
  }
}
var Plugin2 = createReactivePlugin({
  __qLang: {}
}, {
  // props: object
  // __langConfig: object
  getLocale,
  set(langObject = en_US_default, ssrContext) {
    const lang = {
      ...langObject,
      rtl: langObject.rtl === true,
      getLocale
    };
    {
      lang.set = Plugin2.set;
      if (Plugin2.__langConfig === void 0 || Plugin2.__langConfig.noHtmlAttrs !== true) {
        const el = document.documentElement;
        el.setAttribute("dir", lang.rtl === true ? "rtl" : "ltr");
        el.setAttribute("lang", lang.isoName);
      }
      Object.assign(Plugin2.__qLang, lang);
    }
  },
  install({ $q, lang, ssrContext }) {
    {
      $q.lang = Plugin2.__qLang;
      Plugin2.__langConfig = $q.config.lang;
      if (this.__installed === true) {
        lang !== void 0 && this.set(lang);
      } else {
        this.props = new Proxy(this.__qLang, {
          get() {
            return Reflect.get(...arguments);
          },
          ownKeys(target2) {
            return Reflect.ownKeys(target2).filter((key) => key !== "set" && key !== "getLocale");
          }
        });
        this.set(lang || en_US_default);
      }
    }
  }
});
var Lang_default = Plugin2;
var material_icons_default = {
  name: "material-icons",
  type: {
    positive: "check_circle",
    negative: "warning",
    info: "info",
    warning: "priority_high"
  },
  arrow: {
    up: "arrow_upward",
    right: "arrow_forward",
    down: "arrow_downward",
    left: "arrow_back",
    dropdown: "arrow_drop_down"
  },
  chevron: {
    left: "chevron_left",
    right: "chevron_right"
  },
  colorPicker: {
    spectrum: "gradient",
    tune: "tune",
    palette: "style"
  },
  pullToRefresh: {
    icon: "refresh"
  },
  carousel: {
    left: "chevron_left",
    right: "chevron_right",
    up: "keyboard_arrow_up",
    down: "keyboard_arrow_down",
    navigationIcon: "lens"
  },
  chip: {
    remove: "cancel",
    selected: "check"
  },
  datetime: {
    arrowLeft: "chevron_left",
    arrowRight: "chevron_right",
    now: "access_time",
    today: "today"
  },
  editor: {
    bold: "format_bold",
    italic: "format_italic",
    strikethrough: "strikethrough_s",
    underline: "format_underlined",
    unorderedList: "format_list_bulleted",
    orderedList: "format_list_numbered",
    subscript: "vertical_align_bottom",
    superscript: "vertical_align_top",
    hyperlink: "link",
    toggleFullscreen: "fullscreen",
    quote: "format_quote",
    left: "format_align_left",
    center: "format_align_center",
    right: "format_align_right",
    justify: "format_align_justify",
    print: "print",
    outdent: "format_indent_decrease",
    indent: "format_indent_increase",
    removeFormat: "format_clear",
    formatting: "text_format",
    fontSize: "format_size",
    align: "format_align_left",
    hr: "remove",
    undo: "undo",
    redo: "redo",
    heading: "format_size",
    code: "code",
    size: "format_size",
    font: "font_download",
    viewSource: "code"
  },
  expansionItem: {
    icon: "keyboard_arrow_down",
    denseIcon: "arrow_drop_down"
  },
  fab: {
    icon: "add",
    activeIcon: "close"
  },
  field: {
    clear: "cancel",
    error: "error"
  },
  pagination: {
    first: "first_page",
    prev: "keyboard_arrow_left",
    next: "keyboard_arrow_right",
    last: "last_page"
  },
  rating: {
    icon: "grade"
  },
  stepper: {
    done: "check",
    active: "edit",
    error: "warning"
  },
  tabs: {
    left: "chevron_left",
    right: "chevron_right",
    up: "keyboard_arrow_up",
    down: "keyboard_arrow_down"
  },
  table: {
    arrowUp: "arrow_upward",
    warning: "warning",
    firstPage: "first_page",
    prevPage: "chevron_left",
    nextPage: "chevron_right",
    lastPage: "last_page"
  },
  tree: {
    icon: "play_arrow"
  },
  uploader: {
    done: "done",
    clear: "clear",
    add: "add_box",
    upload: "cloud_upload",
    removeQueue: "clear_all",
    removeUploaded: "done_all"
  }
};
var Plugin3 = createReactivePlugin({
  iconMapFn: null,
  __qIconSet: {}
}, {
  // props: object
  set(setObject, ssrContext) {
    const def = { ...setObject };
    {
      def.set = Plugin3.set;
      Object.assign(Plugin3.__qIconSet, def);
    }
  },
  install({ $q, iconSet, ssrContext }) {
    {
      if ($q.config.iconMapFn !== void 0) {
        this.iconMapFn = $q.config.iconMapFn;
      }
      $q.iconSet = this.__qIconSet;
      injectProp($q, "iconMapFn", () => this.iconMapFn, (val) => {
        this.iconMapFn = val;
      });
      if (this.__installed === true) {
        iconSet !== void 0 && this.set(iconSet);
      } else {
        this.props = new Proxy(this.__qIconSet, {
          get() {
            return Reflect.get(...arguments);
          },
          ownKeys(target2) {
            return Reflect.ownKeys(target2).filter((key) => key !== "set");
          }
        });
        this.set(iconSet || material_icons_default);
      }
    }
  }
});
var timelineKey = "_q_t_";
var stepperKey = "_q_s_";
var layoutKey = "_q_l_";
var pageContainerKey = "_q_pc_";
var fabKey = "_q_f_";
var formKey = "_q_fo_";
var tabsKey = "_q_tabs_";
var uploaderKey = "_q_u_";
function emptyRenderFn() {
}
var globalConfig = {};
function isDeepEqual(a4, b3) {
  if (a4 === b3) {
    return true;
  }
  if (a4 !== null && b3 !== null && typeof a4 === "object" && typeof b3 === "object") {
    if (a4.constructor !== b3.constructor) {
      return false;
    }
    let length, i3;
    if (a4.constructor === Array) {
      length = a4.length;
      if (length !== b3.length) {
        return false;
      }
      for (i3 = length; i3-- !== 0; ) {
        if (isDeepEqual(a4[i3], b3[i3]) !== true) {
          return false;
        }
      }
      return true;
    }
    if (a4.constructor === Map) {
      if (a4.size !== b3.size) {
        return false;
      }
      let iter = a4.entries();
      i3 = iter.next();
      while (i3.done !== true) {
        if (b3.has(i3.value[0]) !== true) {
          return false;
        }
        i3 = iter.next();
      }
      iter = a4.entries();
      i3 = iter.next();
      while (i3.done !== true) {
        if (isDeepEqual(i3.value[1], b3.get(i3.value[0])) !== true) {
          return false;
        }
        i3 = iter.next();
      }
      return true;
    }
    if (a4.constructor === Set) {
      if (a4.size !== b3.size) {
        return false;
      }
      const iter = a4.entries();
      i3 = iter.next();
      while (i3.done !== true) {
        if (b3.has(i3.value[0]) !== true) {
          return false;
        }
        i3 = iter.next();
      }
      return true;
    }
    if (a4.buffer != null && a4.buffer.constructor === ArrayBuffer) {
      length = a4.length;
      if (length !== b3.length) {
        return false;
      }
      for (i3 = length; i3-- !== 0; ) {
        if (a4[i3] !== b3[i3]) {
          return false;
        }
      }
      return true;
    }
    if (a4.constructor === RegExp) {
      return a4.source === b3.source && a4.flags === b3.flags;
    }
    if (a4.valueOf !== Object.prototype.valueOf) {
      return a4.valueOf() === b3.valueOf();
    }
    if (a4.toString !== Object.prototype.toString) {
      return a4.toString() === b3.toString();
    }
    const keys2 = Object.keys(a4).filter((key) => a4[key] !== void 0);
    length = keys2.length;
    if (length !== Object.keys(b3).filter((key) => b3[key] !== void 0).length) {
      return false;
    }
    for (i3 = length; i3-- !== 0; ) {
      const key = keys2[i3];
      if (isDeepEqual(a4[key], b3[key]) !== true) {
        return false;
      }
    }
    return true;
  }
  return a4 !== a4 && b3 !== b3;
}
function isObject(v) {
  return v !== null && typeof v === "object" && Array.isArray(v) !== true;
}
function isDate(v) {
  return Object.prototype.toString.call(v) === "[object Date]";
}
function isRegexp(v) {
  return Object.prototype.toString.call(v) === "[object RegExp]";
}
function isNumber(v) {
  return typeof v === "number" && isFinite(v);
}
function createChildApp(appCfg, parentApp) {
  const app2 = createApp(appCfg);
  app2.config.globalProperties = parentApp.config.globalProperties;
  const { reload, ...appContext } = parentApp._context;
  Object.assign(app2._context, appContext);
  return app2;
}
var units = ["B", "KB", "MB", "GB", "TB", "PB"];
function humanStorageSize(bytes, decimals = 1) {
  let u3 = 0;
  while (parseInt(bytes, 10) >= 1024 && u3 < units.length - 1) {
    bytes /= 1024;
    ++u3;
  }
  return `${bytes.toFixed(decimals)}${units[u3]}`;
}
function between(v, min2, max2) {
  return max2 <= min2 ? min2 : Math.min(max2, Math.max(min2, v));
}
function normalizeToInterval(v, min2, max2) {
  if (max2 <= min2) {
    return min2;
  }
  const size2 = max2 - min2 + 1;
  let index2 = min2 + (v - min2) % size2;
  if (index2 < min2) {
    index2 = size2 + index2;
  }
  return index2 === 0 ? 0 : index2;
}
function pad(v, length = 2, char = "0") {
  if (v === void 0 || v === null) {
    return v;
  }
  const val = "" + v;
  return val.length >= length ? val : new Array(length - val.length + 1).join(char) + val;
}
var xhr = XMLHttpRequest;
var open = xhr.prototype.open;
var positionValues = ["top", "right", "bottom", "left"];
var stack = [];
var highjackCount = 0;
function translate({ p: p2, pos, active, horiz, reverse, dir }) {
  let x3 = 1, y4 = 1;
  if (horiz === true) {
    if (reverse === true) {
      x3 = -1;
    }
    if (pos === "bottom") {
      y4 = -1;
    }
    return { transform: `translate3d(${x3 * (p2 - 100)}%,${active ? 0 : y4 * -200}%,0)` };
  }
  if (reverse === true) {
    y4 = -1;
  }
  if (pos === "right") {
    x3 = -1;
  }
  return { transform: `translate3d(${active ? 0 : dir * x3 * -200}%,${y4 * (p2 - 100)}%,0)` };
}
function inc(p2, amount) {
  if (typeof amount !== "number") {
    if (p2 < 25) {
      amount = Math.random() * 3 + 3;
    } else if (p2 < 65) {
      amount = Math.random() * 3;
    } else if (p2 < 85) {
      amount = Math.random() * 2;
    } else if (p2 < 99) {
      amount = 0.6;
    } else {
      amount = 0;
    }
  }
  return between(p2 + amount, 0, 100);
}
function highjackAjax(stackEntry) {
  highjackCount++;
  stack.push(stackEntry);
  if (highjackCount > 1) return;
  xhr.prototype.open = function(_, url) {
    const stopStack = [];
    const loadStart = () => {
      stack.forEach((entry) => {
        if (entry.hijackFilter.value === null || entry.hijackFilter.value(url) === true) {
          entry.start();
          stopStack.push(entry.stop);
        }
      });
    };
    const loadEnd = () => {
      stopStack.forEach((stop2) => {
        stop2();
      });
    };
    this.addEventListener("loadstart", loadStart, { once: true });
    this.addEventListener("loadend", loadEnd, { once: true });
    open.apply(this, arguments);
  };
}
function restoreAjax(start) {
  stack = stack.filter((entry) => entry.start !== start);
  highjackCount = Math.max(0, highjackCount - 1);
  if (highjackCount === 0) {
    xhr.prototype.open = open;
  }
}
var QAjaxBar_default = createComponent({
  name: "QAjaxBar",
  props: {
    position: {
      type: String,
      default: "top",
      validator: (val) => positionValues.includes(val)
    },
    size: {
      type: String,
      default: "2px"
    },
    color: String,
    skipHijack: Boolean,
    reverse: Boolean,
    hijackFilter: Function
  },
  emits: ["start", "stop"],
  setup(props4, { emit }) {
    const { proxy } = getCurrentInstance();
    const progress = ref$1(0);
    const onScreen = ref$1(false);
    const animate = ref$1(true);
    let sessions = 0, timer2 = null, speed;
    const classes = computed(
      () => `q-loading-bar q-loading-bar--${props4.position}` + (props4.color !== void 0 ? ` bg-${props4.color}` : "") + (animate.value === true ? "" : " no-transition")
    );
    const horizontal = computed(() => props4.position === "top" || props4.position === "bottom");
    const sizeProp = computed(() => horizontal.value === true ? "height" : "width");
    const style2 = computed(() => {
      const active = onScreen.value;
      const obj = translate({
        p: progress.value,
        pos: props4.position,
        active,
        horiz: horizontal.value,
        reverse: proxy.$q.lang.rtl === true && ["top", "bottom"].includes(props4.position) ? props4.reverse === false : props4.reverse,
        dir: proxy.$q.lang.rtl === true ? -1 : 1
      });
      obj[sizeProp.value] = props4.size;
      obj.opacity = active ? 1 : 0;
      return obj;
    });
    const attributes = computed(() => onScreen.value === true ? {
      role: "progressbar",
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-valuenow": progress.value
    } : { "aria-hidden": "true" });
    function start(newSpeed = 300) {
      const oldSpeed = speed;
      speed = Math.max(0, newSpeed) || 0;
      sessions++;
      if (sessions > 1) {
        if (oldSpeed === 0 && newSpeed > 0) {
          planNextStep();
        } else if (timer2 !== null && oldSpeed > 0 && newSpeed <= 0) {
          clearTimeout(timer2);
          timer2 = null;
        }
        return sessions;
      }
      timer2 !== null && clearTimeout(timer2);
      emit("start");
      progress.value = 0;
      timer2 = setTimeout(() => {
        timer2 = null;
        animate.value = true;
        newSpeed > 0 && planNextStep();
      }, onScreen._value === true ? 500 : 1);
      if (onScreen._value !== true) {
        onScreen.value = true;
        animate.value = false;
      }
      return sessions;
    }
    function increment(amount) {
      if (sessions > 0) {
        progress.value = inc(progress.value, amount);
      }
      return sessions;
    }
    function stop2() {
      sessions = Math.max(0, sessions - 1);
      if (sessions > 0) {
        return sessions;
      }
      if (timer2 !== null) {
        clearTimeout(timer2);
        timer2 = null;
      }
      emit("stop");
      const end = () => {
        animate.value = true;
        progress.value = 100;
        timer2 = setTimeout(() => {
          timer2 = null;
          onScreen.value = false;
        }, 1e3);
      };
      if (progress.value === 0) {
        timer2 = setTimeout(end, 1);
      } else {
        end();
      }
      return sessions;
    }
    function planNextStep() {
      if (progress.value < 100) {
        timer2 = setTimeout(() => {
          timer2 = null;
          increment();
          planNextStep();
        }, speed);
      }
    }
    let hijacked;
    onMounted(() => {
      if (props4.skipHijack !== true) {
        hijacked = true;
        highjackAjax({
          start,
          stop: stop2,
          hijackFilter: computed(() => props4.hijackFilter || null)
        });
      }
    });
    onBeforeUnmount(() => {
      timer2 !== null && clearTimeout(timer2);
      hijacked === true && restoreAjax(start);
    });
    Object.assign(proxy, { start, stop: stop2, increment });
    return () => h("div", {
      class: classes.value,
      style: style2.value,
      ...attributes.value
    });
  }
});
var useSizeDefaults = {
  xs: 18,
  sm: 24,
  md: 32,
  lg: 38,
  xl: 46
};
var useSizeProps = {
  size: String
};
function use_size_default(props4, sizes = useSizeDefaults) {
  return computed(() => props4.size !== void 0 ? { fontSize: props4.size in sizes ? `${sizes[props4.size]}px` : props4.size } : null);
}
function hSlot(slot, otherwise) {
  return slot !== void 0 ? slot() || otherwise : otherwise;
}
function hUniqueSlot(slot, otherwise) {
  if (slot !== void 0) {
    const vnode = slot();
    if (vnode !== void 0 && vnode !== null) {
      return vnode.slice();
    }
  }
  return otherwise;
}
function hMergeSlot(slot, source) {
  return slot !== void 0 ? source.concat(slot()) : source;
}
function hMergeSlotSafely(slot, source) {
  if (slot === void 0) {
    return source;
  }
  return source !== void 0 ? source.concat(slot()) : slot();
}
function hDir(tag, data, children, key, condition, getDirsFn) {
  data.key = key + condition;
  const vnode = h(tag, data, children);
  return condition === true ? withDirectives(vnode, getDirsFn()) : vnode;
}
var defaultViewBox = "0 0 24 24";
var sameFn = (i3) => i3;
var ionFn = (i3) => `ionicons ${i3}`;
var libMap = {
  "mdi-": (i3) => `mdi ${i3}`,
  "icon-": sameFn,
  // fontawesome equiv
  "bt-": (i3) => `bt ${i3}`,
  "eva-": (i3) => `eva ${i3}`,
  "ion-md": ionFn,
  "ion-ios": ionFn,
  "ion-logo": ionFn,
  "iconfont ": sameFn,
  "ti-": (i3) => `themify-icon ${i3}`,
  "bi-": (i3) => `bootstrap-icons ${i3}`,
  "i-": sameFn
  // UnoCSS pure icons
};
var matMap = {
  o_: "-outlined",
  r_: "-round",
  s_: "-sharp"
};
var symMap = {
  sym_o_: "-outlined",
  sym_r_: "-rounded",
  sym_s_: "-sharp"
};
var libRE = new RegExp("^(" + Object.keys(libMap).join("|") + ")");
var matRE = new RegExp("^(" + Object.keys(matMap).join("|") + ")");
var symRE = new RegExp("^(" + Object.keys(symMap).join("|") + ")");
var mRE = /^[Mm]\s?[-+]?\.?\d/;
var imgRE = /^img:/;
var svgUseRE = /^svguse:/;
var ionRE = /^ion-/;
var faRE = /^(fa-(classic|sharp|solid|regular|light|brands|duotone|thin)|[lf]a[srlbdk]?) /;
var QIcon_default = createComponent({
  name: "QIcon",
  props: {
    ...useSizeProps,
    tag: {
      type: String,
      default: "i"
    },
    name: String,
    color: String,
    left: Boolean,
    right: Boolean
  },
  setup(props4, { slots }) {
    const { proxy: { $q } } = getCurrentInstance();
    const sizeStyle = use_size_default(props4);
    const classes = computed(
      () => "q-icon" + (props4.left === true ? " on-left" : "") + (props4.right === true ? " on-right" : "") + (props4.color !== void 0 ? ` text-${props4.color}` : "")
    );
    const type2 = computed(() => {
      let cls;
      let icon = props4.name;
      if (icon === "none" || !icon) {
        return { none: true };
      }
      if ($q.iconMapFn !== null) {
        const res = $q.iconMapFn(icon);
        if (res !== void 0) {
          if (res.icon !== void 0) {
            icon = res.icon;
            if (icon === "none" || !icon) {
              return { none: true };
            }
          } else {
            return {
              cls: res.cls,
              content: res.content !== void 0 ? res.content : " "
            };
          }
        }
      }
      if (mRE.test(icon) === true) {
        const [def, viewBox = defaultViewBox] = icon.split("|");
        return {
          svg: true,
          viewBox,
          nodes: def.split("&&").map((path) => {
            const [d4, style2, transform] = path.split("@@");
            return h("path", { style: style2, d: d4, transform });
          })
        };
      }
      if (imgRE.test(icon) === true) {
        return {
          img: true,
          src: icon.substring(4)
        };
      }
      if (svgUseRE.test(icon) === true) {
        const [def, viewBox = defaultViewBox] = icon.split("|");
        return {
          svguse: true,
          src: def.substring(7),
          viewBox
        };
      }
      let content = " ";
      const matches = icon.match(libRE);
      if (matches !== null) {
        cls = libMap[matches[1]](icon);
      } else if (faRE.test(icon) === true) {
        cls = icon;
      } else if (ionRE.test(icon) === true) {
        cls = `ionicons ion-${$q.platform.is.ios === true ? "ios" : "md"}${icon.substring(3)}`;
      } else if (symRE.test(icon) === true) {
        cls = "notranslate material-symbols";
        const matches2 = icon.match(symRE);
        if (matches2 !== null) {
          icon = icon.substring(6);
          cls += symMap[matches2[1]];
        }
        content = icon;
      } else {
        cls = "notranslate material-icons";
        const matches2 = icon.match(matRE);
        if (matches2 !== null) {
          icon = icon.substring(2);
          cls += matMap[matches2[1]];
        }
        content = icon;
      }
      return {
        cls,
        content
      };
    });
    return () => {
      const data = {
        class: classes.value,
        style: sizeStyle.value,
        "aria-hidden": "true"
      };
      if (type2.value.none === true) {
        return h(props4.tag, data, hSlot(slots.default));
      }
      if (type2.value.img === true) {
        return h(props4.tag, data, hMergeSlot(slots.default, [
          h("img", { src: type2.value.src })
        ]));
      }
      if (type2.value.svg === true) {
        return h(props4.tag, data, hMergeSlot(slots.default, [
          h("svg", {
            viewBox: type2.value.viewBox || "0 0 24 24"
          }, type2.value.nodes)
        ]));
      }
      if (type2.value.svguse === true) {
        return h(props4.tag, data, hMergeSlot(slots.default, [
          h("svg", {
            viewBox: type2.value.viewBox
          }, [
            h("use", { "xlink:href": type2.value.src })
          ])
        ]));
      }
      if (type2.value.cls !== void 0) {
        data.class += " " + type2.value.cls;
      }
      return h(props4.tag, data, hMergeSlot(slots.default, [
        type2.value.content
      ]));
    };
  }
});
createComponent({
  name: "QAvatar",
  props: {
    ...useSizeProps,
    fontSize: String,
    color: String,
    textColor: String,
    icon: String,
    square: Boolean,
    rounded: Boolean
  },
  setup(props4, { slots }) {
    const sizeStyle = use_size_default(props4);
    const classes = computed(
      () => "q-avatar" + (props4.color ? ` bg-${props4.color}` : "") + (props4.textColor ? ` text-${props4.textColor} q-chip--colored` : "") + (props4.square === true ? " q-avatar--square" : props4.rounded === true ? " rounded-borders" : "")
    );
    const contentStyle = computed(() => props4.fontSize ? { fontSize: props4.fontSize } : null);
    return () => {
      const icon = props4.icon !== void 0 ? [h(QIcon_default, { name: props4.icon })] : void 0;
      return h("div", {
        class: classes.value,
        style: sizeStyle.value
      }, [
        h("div", {
          class: "q-avatar__content row flex-center overflow-hidden",
          style: contentStyle.value
        }, hMergeSlotSafely(slots.default, icon))
      ]);
    };
  }
});
var alignValues = ["top", "middle", "bottom"];
createComponent({
  name: "QBadge",
  props: {
    color: String,
    textColor: String,
    floating: Boolean,
    transparent: Boolean,
    multiLine: Boolean,
    outline: Boolean,
    rounded: Boolean,
    label: [Number, String],
    align: {
      type: String,
      validator: (v) => alignValues.includes(v)
    }
  },
  setup(props4, { slots }) {
    const style2 = computed(() => {
      return props4.align !== void 0 ? { verticalAlign: props4.align } : null;
    });
    const classes = computed(() => {
      const text2 = props4.outline === true ? props4.color || props4.textColor : props4.textColor;
      return `q-badge flex inline items-center no-wrap q-badge--${props4.multiLine === true ? "multi" : "single"}-line` + (props4.outline === true ? " q-badge--outline" : props4.color !== void 0 ? ` bg-${props4.color}` : "") + (text2 !== void 0 ? ` text-${text2}` : "") + (props4.floating === true ? " q-badge--floating" : "") + (props4.rounded === true ? " q-badge--rounded" : "") + (props4.transparent === true ? " q-badge--transparent" : "");
    });
    return () => h("div", {
      class: classes.value,
      style: style2.value,
      role: "status",
      "aria-label": props4.label
    }, hMergeSlot(slots.default, props4.label !== void 0 ? [props4.label] : []));
  }
});
var useDarkProps = {
  dark: {
    type: Boolean,
    default: null
  }
};
function use_dark_default(props4, $q) {
  return computed(() => props4.dark === null ? $q.dark.isActive : props4.dark);
}
createComponent({
  name: "QBanner",
  props: {
    ...useDarkProps,
    inlineActions: Boolean,
    dense: Boolean,
    rounded: Boolean
  },
  setup(props4, { slots }) {
    const { proxy: { $q } } = getCurrentInstance();
    const isDark = use_dark_default(props4, $q);
    const classes = computed(
      () => "q-banner row items-center" + (props4.dense === true ? " q-banner--dense" : "") + (isDark.value === true ? " q-banner--dark q-dark" : "") + (props4.rounded === true ? " rounded-borders" : "")
    );
    const actionClass = computed(
      () => `q-banner__actions row items-center justify-end col-${props4.inlineActions === true ? "auto" : "all"}`
    );
    return () => {
      const child = [
        h("div", {
          class: "q-banner__avatar col-auto row items-center self-start"
        }, hSlot(slots.avatar)),
        h("div", {
          class: "q-banner__content col text-body2"
        }, hSlot(slots.default))
      ];
      const actions = hSlot(slots.action);
      actions !== void 0 && child.push(
        h("div", { class: actionClass.value }, actions)
      );
      return h("div", {
        class: classes.value + (props4.inlineActions === false && actions !== void 0 ? " q-banner--top-padding" : ""),
        role: "alert"
      }, child);
    };
  }
});
createComponent({
  name: "QBar",
  props: {
    ...useDarkProps,
    dense: Boolean
  },
  setup(props4, { slots }) {
    const { proxy: { $q } } = getCurrentInstance();
    const isDark = use_dark_default(props4, $q);
    const classes = computed(
      () => `q-bar row no-wrap items-center q-bar--${props4.dense === true ? "dense" : "standard"}  q-bar--${isDark.value === true ? "dark" : "light"}`
    );
    return () => h("div", {
      class: classes.value,
      role: "toolbar"
    }, hSlot(slots.default));
  }
});
var alignMap = {
  left: "start",
  center: "center",
  right: "end",
  between: "between",
  around: "around",
  evenly: "evenly",
  stretch: "stretch"
};
var alignValues2 = Object.keys(alignMap);
var useAlignProps = {
  align: {
    type: String,
    validator: (v) => alignValues2.includes(v)
  }
};
function use_align_default(props4) {
  return computed(() => {
    const align = props4.align === void 0 ? props4.vertical === true ? "stretch" : "left" : props4.align;
    return `${props4.vertical === true ? "items" : "justify"}-${alignMap[align]}`;
  });
}
function getParentProxy(proxy) {
  if (Object(proxy.$parent) === proxy.$parent) {
    return proxy.$parent;
  }
  let { parent } = proxy.$;
  while (Object(parent) === parent) {
    if (Object(parent.proxy) === parent.proxy) {
      return parent.proxy;
    }
    parent = parent.parent;
  }
}
function fillNormalizedVNodes(children, vnode) {
  if (typeof vnode.type === "symbol") {
    if (Array.isArray(vnode.children) === true) {
      vnode.children.forEach((child) => {
        fillNormalizedVNodes(children, child);
      });
    }
  } else {
    children.add(vnode);
  }
}
function getNormalizedVNodes(vnodes) {
  const children = /* @__PURE__ */ new Set();
  vnodes.forEach((vnode) => {
    fillNormalizedVNodes(children, vnode);
  });
  return Array.from(children);
}
function vmHasRouter(vm2) {
  return vm2.appContext.config.globalProperties.$router !== void 0;
}
function vmIsDestroyed(vm2) {
  return vm2.isUnmounted === true || vm2.isDeactivated === true;
}
var disabledValues = ["", true];
createComponent({
  name: "QBreadcrumbs",
  props: {
    ...useAlignProps,
    separator: {
      type: String,
      default: "/"
    },
    separatorColor: String,
    activeColor: {
      type: String,
      default: "primary"
    },
    gutter: {
      type: String,
      validator: (v) => ["none", "xs", "sm", "md", "lg", "xl"].includes(v),
      default: "sm"
    }
  },
  setup(props4, { slots }) {
    const alignClass = use_align_default(props4);
    const classes = computed(
      () => `flex items-center ${alignClass.value}${props4.gutter === "none" ? "" : ` q-gutter-${props4.gutter}`}`
    );
    const sepClass = computed(() => props4.separatorColor ? ` text-${props4.separatorColor}` : "");
    const activeClass = computed(() => ` text-${props4.activeColor}`);
    return () => {
      if (slots.default === void 0) return;
      const vnodes = getNormalizedVNodes(
        hSlot(slots.default)
      );
      if (vnodes.length === 0) return;
      let els = 1;
      const child = [], len = vnodes.filter((c3) => {
        var _a;
        return ((_a = c3.type) == null ? void 0 : _a.name) === "QBreadcrumbsEl";
      }).length, separator = slots.separator !== void 0 ? slots.separator : () => props4.separator;
      vnodes.forEach((comp) => {
        var _a;
        if (((_a = comp.type) == null ? void 0 : _a.name) === "QBreadcrumbsEl") {
          const middle = els < len;
          const disabled = comp.props !== null && disabledValues.includes(comp.props.disable);
          const cls = (middle === true ? "" : " q-breadcrumbs--last") + (disabled !== true && middle === true ? activeClass.value : "");
          els++;
          child.push(
            h("div", {
              class: `flex items-center${cls}`
            }, [comp])
          );
          if (middle === true) {
            child.push(
              h("div", {
                class: "q-breadcrumbs__separator" + sepClass.value
              }, separator())
            );
          }
        } else {
          child.push(comp);
        }
      });
      return h("div", {
        class: "q-breadcrumbs"
      }, [
        h("div", { class: classes.value }, child)
      ]);
    };
  }
});
function getOriginalPath(record) {
  return record ? record.aliasOf ? record.aliasOf.path : record.path : "";
}
function isSameRouteRecord(a4, b3) {
  return (a4.aliasOf || a4) === (b3.aliasOf || b3);
}
function includesParams(outer, inner) {
  for (const key in inner) {
    const innerValue = inner[key], outerValue = outer[key];
    if (typeof innerValue === "string") {
      if (innerValue !== outerValue) {
        return false;
      }
    } else if (Array.isArray(outerValue) === false || outerValue.length !== innerValue.length || innerValue.some((value2, i3) => value2 !== outerValue[i3])) {
      return false;
    }
  }
  return true;
}
function isEquivalentArray(a4, b3) {
  return Array.isArray(b3) === true ? a4.length === b3.length && a4.every((value2, i3) => value2 === b3[i3]) : a4.length === 1 && a4[0] === b3;
}
function isSameRouteLocationParamsValue(a4, b3) {
  return Array.isArray(a4) === true ? isEquivalentArray(a4, b3) : Array.isArray(b3) === true ? isEquivalentArray(b3, a4) : a4 === b3;
}
function isSameRouteLocationParams(a4, b3) {
  if (Object.keys(a4).length !== Object.keys(b3).length) {
    return false;
  }
  for (const key in a4) {
    if (isSameRouteLocationParamsValue(a4[key], b3[key]) === false) {
      return false;
    }
  }
  return true;
}
var useRouterLinkNonMatchingProps = {
  // router-link
  to: [String, Object],
  replace: Boolean,
  // regular <a> link
  href: String,
  target: String,
  // state
  disable: Boolean
};
var useRouterLinkProps = {
  ...useRouterLinkNonMatchingProps,
  // router-link
  exact: Boolean,
  activeClass: {
    type: String,
    default: "q-router-link--active"
  },
  exactActiveClass: {
    type: String,
    default: "q-router-link--exact-active"
  }
};
function use_router_link_default({ fallbackTag, useDisableForRouterLinkProps = true } = {}) {
  const vm2 = getCurrentInstance();
  const { props: props4, proxy, emit } = vm2;
  const hasRouter = vmHasRouter(vm2);
  const hasHrefLink = computed(() => props4.disable !== true && props4.href !== void 0);
  const hasRouterLinkProps = useDisableForRouterLinkProps === true ? computed(
    () => hasRouter === true && props4.disable !== true && hasHrefLink.value !== true && props4.to !== void 0 && props4.to !== null && props4.to !== ""
  ) : computed(
    () => hasRouter === true && hasHrefLink.value !== true && props4.to !== void 0 && props4.to !== null && props4.to !== ""
  );
  const resolvedLink = computed(() => hasRouterLinkProps.value === true ? getLink(props4.to) : null);
  const hasRouterLink = computed(() => resolvedLink.value !== null);
  const hasLink = computed(() => hasHrefLink.value === true || hasRouterLink.value === true);
  const linkTag = computed(() => props4.type === "a" || hasLink.value === true ? "a" : props4.tag || fallbackTag || "div");
  const linkAttrs = computed(() => hasHrefLink.value === true ? {
    href: props4.href,
    target: props4.target
  } : hasRouterLink.value === true ? {
    href: resolvedLink.value.href,
    target: props4.target
  } : {});
  const linkActiveIndex = computed(() => {
    if (hasRouterLink.value === false) {
      return -1;
    }
    const { matched } = resolvedLink.value, { length } = matched, routeMatched = matched[length - 1];
    if (routeMatched === void 0) {
      return -1;
    }
    const currentMatched = proxy.$route.matched;
    if (currentMatched.length === 0) {
      return -1;
    }
    const index2 = currentMatched.findIndex(
      isSameRouteRecord.bind(null, routeMatched)
    );
    if (index2 !== -1) {
      return index2;
    }
    const parentRecordPath = getOriginalPath(matched[length - 2]);
    return (
      // we are dealing with nested routes
      length > 1 && getOriginalPath(routeMatched) === parentRecordPath && currentMatched[currentMatched.length - 1].path !== parentRecordPath ? currentMatched.findIndex(
        isSameRouteRecord.bind(null, matched[length - 2])
      ) : index2
    );
  });
  const linkIsActive = computed(
    () => hasRouterLink.value === true && linkActiveIndex.value !== -1 && includesParams(proxy.$route.params, resolvedLink.value.params)
  );
  const linkIsExactActive = computed(
    () => linkIsActive.value === true && linkActiveIndex.value === proxy.$route.matched.length - 1 && isSameRouteLocationParams(proxy.$route.params, resolvedLink.value.params)
  );
  const linkClass = computed(() => hasRouterLink.value === true ? linkIsExactActive.value === true ? ` ${props4.exactActiveClass} ${props4.activeClass}` : props4.exact === true ? "" : linkIsActive.value === true ? ` ${props4.activeClass}` : "" : "");
  function getLink(to2) {
    try {
      return proxy.$router.resolve(to2);
    } catch (_) {
    }
    return null;
  }
  function navigateToRouterLink(e3, { returnRouterError, to: to2 = props4.to, replace: replace2 = props4.replace } = {}) {
    if (props4.disable === true) {
      e3.preventDefault();
      return Promise.resolve(false);
    }
    if (
      // don't redirect with control keys;
      // should match RouterLink from Vue Router
      e3.metaKey || e3.altKey || e3.ctrlKey || e3.shiftKey || e3.button !== void 0 && e3.button !== 0 || props4.target === "_blank"
    ) {
      return Promise.resolve(false);
    }
    e3.preventDefault();
    const promise = proxy.$router[replace2 === true ? "replace" : "push"](to2);
    return returnRouterError === true ? promise : promise.then(() => {
    }).catch(() => {
    });
  }
  function navigateOnClick(e3) {
    if (hasRouterLink.value === true) {
      const go = (opts) => navigateToRouterLink(e3, opts);
      emit("click", e3, go);
      e3.defaultPrevented !== true && go();
    } else {
      emit("click", e3);
    }
  }
  return {
    hasRouterLink,
    hasHrefLink,
    hasLink,
    linkTag,
    resolvedLink,
    linkIsActive,
    linkIsExactActive,
    linkClass,
    linkAttrs,
    getLink,
    navigateToRouterLink,
    navigateOnClick
  };
}
createComponent({
  name: "QBreadcrumbsEl",
  props: {
    ...useRouterLinkProps,
    label: String,
    icon: String,
    tag: {
      type: String,
      default: "span"
    }
  },
  emits: ["click"],
  setup(props4, { slots }) {
    const { linkTag, linkAttrs, linkClass, navigateOnClick } = use_router_link_default();
    const data = computed(() => {
      return {
        class: "q-breadcrumbs__el q-link flex inline items-center relative-position " + (props4.disable !== true ? "q-link--focusable" + linkClass.value : "q-breadcrumbs__el--disable"),
        ...linkAttrs.value,
        onClick: navigateOnClick
      };
    });
    const iconClass = computed(
      () => "q-breadcrumbs__el-icon" + (props4.label !== void 0 ? " q-breadcrumbs__el-icon--with-label" : "")
    );
    return () => {
      const child = [];
      props4.icon !== void 0 && child.push(
        h(QIcon_default, {
          class: iconClass.value,
          name: props4.icon
        })
      );
      props4.label !== void 0 && child.push(props4.label);
      return h(
        linkTag.value,
        { ...data.value },
        hMergeSlot(slots.default, child)
      );
    };
  }
});
var useSpinnerProps = {
  size: {
    type: [String, Number],
    default: "1em"
  },
  color: String
};
function useSpinner(props4) {
  return {
    cSize: computed(() => props4.size in useSizeDefaults ? `${useSizeDefaults[props4.size]}px` : props4.size),
    classes: computed(
      () => "q-spinner" + (props4.color ? ` text-${props4.color}` : "")
    )
  };
}
var QSpinner_default = createComponent({
  name: "QSpinner",
  props: {
    ...useSpinnerProps,
    thickness: {
      type: Number,
      default: 5
    }
  },
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value + " q-spinner-mat",
      width: cSize.value,
      height: cSize.value,
      viewBox: "25 25 50 50"
    }, [
      h("circle", {
        class: "path",
        cx: "50",
        cy: "50",
        r: "20",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": props4.thickness,
        "stroke-miterlimit": "10"
      })
    ]);
  }
});
function offset(el) {
  if (el === window) {
    return { top: 0, left: 0 };
  }
  const { top, left } = el.getBoundingClientRect();
  return { top, left };
}
function height(el) {
  return el === window ? window.innerHeight : el.getBoundingClientRect().height;
}
function css(element, css2) {
  const style2 = element.style;
  for (const prop in css2) {
    style2[prop] = css2[prop];
  }
}
function getElement(el) {
  if (el === void 0 || el === null) {
    return void 0;
  }
  if (typeof el === "string") {
    try {
      return document.querySelector(el) || void 0;
    } catch (err) {
      return void 0;
    }
  }
  const target2 = unref(el);
  if (target2) {
    return target2.$el || target2;
  }
}
function childHasFocus(el, focusedEl) {
  if (el === void 0 || el === null || el.contains(focusedEl) === true) {
    return true;
  }
  for (let next = el.nextElementSibling; next !== null; next = next.nextElementSibling) {
    if (next.contains(focusedEl)) {
      return true;
    }
  }
  return false;
}
function throttle_default(fn, limit2 = 250) {
  let wait2 = false, result;
  return function() {
    if (wait2 === false) {
      wait2 = true;
      setTimeout(() => {
        wait2 = false;
      }, limit2);
      result = fn.apply(this, arguments);
    }
    return result;
  };
}
function showRipple(evt, el, ctx, forceCenter) {
  ctx.modifiers.stop === true && stop(evt);
  const color2 = ctx.modifiers.color;
  let center = ctx.modifiers.center;
  center = center === true || forceCenter === true;
  const node = document.createElement("span"), innerNode = document.createElement("span"), pos = position(evt), { left, top, width: width3, height: height2 } = el.getBoundingClientRect(), diameter2 = Math.sqrt(width3 * width3 + height2 * height2), radius2 = diameter2 / 2, centerX = `${(width3 - diameter2) / 2}px`, x3 = center ? centerX : `${pos.left - left - radius2}px`, centerY = `${(height2 - diameter2) / 2}px`, y4 = center ? centerY : `${pos.top - top - radius2}px`;
  innerNode.className = "q-ripple__inner";
  css(innerNode, {
    height: `${diameter2}px`,
    width: `${diameter2}px`,
    transform: `translate3d(${x3},${y4},0) scale3d(.2,.2,1)`,
    opacity: 0
  });
  node.className = `q-ripple${color2 ? " text-" + color2 : ""}`;
  node.setAttribute("dir", "ltr");
  node.appendChild(innerNode);
  el.appendChild(node);
  const abort = () => {
    node.remove();
    clearTimeout(timer2);
  };
  ctx.abort.push(abort);
  let timer2 = setTimeout(() => {
    innerNode.classList.add("q-ripple__inner--enter");
    innerNode.style.transform = `translate3d(${centerX},${centerY},0) scale3d(1,1,1)`;
    innerNode.style.opacity = 0.2;
    timer2 = setTimeout(() => {
      innerNode.classList.remove("q-ripple__inner--enter");
      innerNode.classList.add("q-ripple__inner--leave");
      innerNode.style.opacity = 0;
      timer2 = setTimeout(() => {
        node.remove();
        ctx.abort.splice(ctx.abort.indexOf(abort), 1);
      }, 275);
    }, 250);
  }, 50);
}
function updateModifiers(ctx, { modifiers, value: value2, arg }) {
  const cfg = Object.assign({}, ctx.cfg.ripple, modifiers, value2);
  ctx.modifiers = {
    early: cfg.early === true,
    stop: cfg.stop === true,
    center: cfg.center === true,
    color: cfg.color || arg,
    keyCodes: [].concat(cfg.keyCodes || 13)
  };
}
var Ripple_default = createDirective(
  {
    name: "ripple",
    beforeMount(el, binding) {
      const cfg = binding.instance.$.appContext.config.globalProperties.$q.config || {};
      if (cfg.ripple === false) return;
      const ctx = {
        cfg,
        enabled: binding.value !== false,
        modifiers: {},
        abort: [],
        start(evt) {
          if (ctx.enabled === true && evt.qSkipRipple !== true && evt.type === (ctx.modifiers.early === true ? "pointerdown" : "click")) {
            showRipple(evt, el, ctx, evt.qKeyEvent === true);
          }
        },
        keystart: throttle_default((evt) => {
          if (ctx.enabled === true && evt.qSkipRipple !== true && isKeyCode(evt, ctx.modifiers.keyCodes) === true && evt.type === `key${ctx.modifiers.early === true ? "down" : "up"}`) {
            showRipple(evt, el, ctx, true);
          }
        }, 300)
      };
      updateModifiers(ctx, binding);
      el.__qripple = ctx;
      addEvt(ctx, "main", [
        [el, "pointerdown", "start", "passive"],
        [el, "click", "start", "passive"],
        [el, "keydown", "keystart", "passive"],
        [el, "keyup", "keystart", "passive"]
      ]);
    },
    updated(el, binding) {
      if (binding.oldValue !== binding.value) {
        const ctx = el.__qripple;
        if (ctx !== void 0) {
          ctx.enabled = binding.value !== false;
          if (ctx.enabled === true && Object(binding.value) === binding.value) {
            updateModifiers(ctx, binding);
          }
        }
      }
    },
    beforeUnmount(el) {
      const ctx = el.__qripple;
      if (ctx !== void 0) {
        ctx.abort.forEach((fn) => {
          fn();
        });
        cleanEvt(ctx, "main");
        delete el._qripple;
      }
    }
  }
);
var btnPadding = {
  none: 0,
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32
};
var defaultSizes = {
  xs: 8,
  sm: 10,
  md: 14,
  lg: 20,
  xl: 24
};
var formTypes = ["button", "submit", "reset"];
var mediaTypeRE = /[^\s]\/[^\s]/;
var btnDesignOptions = ["flat", "outline", "push", "unelevated"];
function getBtnDesign(props4, defaultValue) {
  if (props4.flat === true) return "flat";
  if (props4.outline === true) return "outline";
  if (props4.push === true) return "push";
  if (props4.unelevated === true) return "unelevated";
  return defaultValue;
}
function getBtnDesignAttr(props4) {
  const design = getBtnDesign(props4);
  return design !== void 0 ? { [design]: true } : {};
}
var nonRoundBtnProps = {
  ...useSizeProps,
  ...useRouterLinkNonMatchingProps,
  type: {
    type: String,
    default: "button"
  },
  label: [Number, String],
  icon: String,
  iconRight: String,
  ...btnDesignOptions.reduce(
    (acc, val) => (acc[val] = Boolean) && acc,
    {}
  ),
  square: Boolean,
  rounded: Boolean,
  glossy: Boolean,
  size: String,
  fab: Boolean,
  fabMini: Boolean,
  padding: String,
  color: String,
  textColor: String,
  noCaps: Boolean,
  noWrap: Boolean,
  dense: Boolean,
  tabindex: [Number, String],
  ripple: {
    type: [Boolean, Object],
    default: true
  },
  align: {
    ...useAlignProps.align,
    default: "center"
  },
  stack: Boolean,
  stretch: Boolean,
  loading: {
    type: Boolean,
    default: null
  },
  disable: Boolean
};
var useBtnProps = {
  ...nonRoundBtnProps,
  round: Boolean
};
function use_btn_default(props4) {
  const sizeStyle = use_size_default(props4, defaultSizes);
  const alignClass = use_align_default(props4);
  const { hasRouterLink, hasLink, linkTag, linkAttrs, navigateOnClick } = use_router_link_default({
    fallbackTag: "button"
  });
  const style2 = computed(() => {
    const obj = props4.fab === false && props4.fabMini === false ? sizeStyle.value : {};
    return props4.padding !== void 0 ? Object.assign({}, obj, {
      padding: props4.padding.split(/\s+/).map((v) => v in btnPadding ? btnPadding[v] + "px" : v).join(" "),
      minWidth: "0",
      minHeight: "0"
    }) : obj;
  });
  const isRounded = computed(
    () => props4.rounded === true || props4.fab === true || props4.fabMini === true
  );
  const isActionable = computed(
    () => props4.disable !== true && props4.loading !== true
  );
  const tabIndex = computed(() => isActionable.value === true ? props4.tabindex || 0 : -1);
  const design = computed(() => getBtnDesign(props4, "standard"));
  const attributes = computed(() => {
    const acc = { tabindex: tabIndex.value };
    if (hasLink.value === true) {
      Object.assign(acc, linkAttrs.value);
    } else if (formTypes.includes(props4.type) === true) {
      acc.type = props4.type;
    }
    if (linkTag.value === "a") {
      if (props4.disable === true) {
        acc["aria-disabled"] = "true";
      } else if (acc.href === void 0) {
        acc.role = "button";
      }
      if (hasRouterLink.value !== true && mediaTypeRE.test(props4.type) === true) {
        acc.type = props4.type;
      }
    } else if (props4.disable === true) {
      acc.disabled = "";
      acc["aria-disabled"] = "true";
    }
    if (props4.loading === true && props4.percentage !== void 0) {
      Object.assign(acc, {
        role: "progressbar",
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": props4.percentage
      });
    }
    return acc;
  });
  const classes = computed(() => {
    let colors2;
    if (props4.color !== void 0) {
      if (props4.flat === true || props4.outline === true) {
        colors2 = `text-${props4.textColor || props4.color}`;
      } else {
        colors2 = `bg-${props4.color} text-${props4.textColor || "white"}`;
      }
    } else if (props4.textColor) {
      colors2 = `text-${props4.textColor}`;
    }
    const shape = props4.round === true ? "round" : `rectangle${isRounded.value === true ? " q-btn--rounded" : props4.square === true ? " q-btn--square" : ""}`;
    return `q-btn--${design.value} q-btn--${shape}` + (colors2 !== void 0 ? " " + colors2 : "") + (isActionable.value === true ? " q-btn--actionable q-focusable q-hoverable" : props4.disable === true ? " disabled" : "") + (props4.fab === true ? " q-btn--fab" : props4.fabMini === true ? " q-btn--fab-mini" : "") + (props4.noCaps === true ? " q-btn--no-uppercase" : "") + (props4.dense === true ? " q-btn--dense" : "") + (props4.stretch === true ? " no-border-radius self-stretch" : "") + (props4.glossy === true ? " glossy" : "") + (props4.square ? " q-btn--square" : "");
  });
  const innerClasses = computed(
    () => alignClass.value + (props4.stack === true ? " column" : " row") + (props4.noWrap === true ? " no-wrap text-no-wrap" : "") + (props4.loading === true ? " q-btn__content--hidden" : "")
  );
  return {
    classes,
    style: style2,
    innerClasses,
    attributes,
    hasLink,
    linkTag,
    navigateOnClick,
    isActionable
  };
}
var { passiveCapture } = listenOpts;
var touchTarget = null;
var keyboardTarget = null;
var mouseTarget = null;
var QBtn_default = createComponent({
  name: "QBtn",
  props: {
    ...useBtnProps,
    percentage: Number,
    darkPercentage: Boolean,
    onTouchstart: [Function, Array]
  },
  emits: ["click", "keydown", "mousedown", "keyup"],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const {
      classes,
      style: style2,
      innerClasses,
      attributes,
      hasLink,
      linkTag,
      navigateOnClick,
      isActionable
    } = use_btn_default(props4);
    const rootRef = ref$1(null);
    const blurTargetRef = ref$1(null);
    let localTouchTargetEl = null, avoidMouseRipple, mouseTimer = null;
    const hasLabel = computed(
      () => props4.label !== void 0 && props4.label !== null && props4.label !== ""
    );
    const ripple = computed(() => props4.disable === true || props4.ripple === false ? false : {
      keyCodes: hasLink.value === true ? [13, 32] : [13],
      ...props4.ripple === true ? {} : props4.ripple
    });
    const rippleProps = computed(() => ({ center: props4.round }));
    const percentageStyle = computed(() => {
      const val = Math.max(0, Math.min(100, props4.percentage));
      return val > 0 ? { transition: "transform 0.6s", transform: `translateX(${val - 100}%)` } : {};
    });
    const onEvents = computed(() => {
      if (props4.loading === true) {
        return {
          onMousedown: onLoadingEvt,
          onTouchstart: onLoadingEvt,
          onClick: onLoadingEvt,
          onKeydown: onLoadingEvt,
          onKeyup: onLoadingEvt
        };
      }
      if (isActionable.value === true) {
        const acc = {
          onClick,
          onKeydown: onKeydown2,
          onMousedown
        };
        if (proxy.$q.platform.has.touch === true) {
          const suffix = props4.onTouchstart !== void 0 ? "" : "Passive";
          acc[`onTouchstart${suffix}`] = onTouchstart;
        }
        return acc;
      }
      return {
        // needed; especially for disabled <a> tags
        onClick: stopAndPrevent
      };
    });
    const nodeProps = computed(() => ({
      ref: rootRef,
      class: "q-btn q-btn-item non-selectable no-outline " + classes.value,
      style: style2.value,
      ...attributes.value,
      ...onEvents.value
    }));
    function onClick(e3) {
      if (rootRef.value === null) return;
      if (e3 !== void 0) {
        if (e3.defaultPrevented === true) return;
        const el = document.activeElement;
        if (props4.type === "submit" && el !== document.body && rootRef.value.contains(el) === false && el.contains(rootRef.value) === false) {
          e3.qAvoidFocus !== true && rootRef.value.focus();
          const onClickCleanup = () => {
            var _a;
            document.removeEventListener("keydown", stopAndPrevent, true);
            document.removeEventListener("keyup", onClickCleanup, passiveCapture);
            (_a = rootRef.value) == null ? void 0 : _a.removeEventListener("blur", onClickCleanup, passiveCapture);
          };
          document.addEventListener("keydown", stopAndPrevent, true);
          document.addEventListener("keyup", onClickCleanup, passiveCapture);
          rootRef.value.addEventListener("blur", onClickCleanup, passiveCapture);
        }
      }
      navigateOnClick(e3);
    }
    function onKeydown2(e3) {
      if (rootRef.value === null) return;
      emit("keydown", e3);
      if (isKeyCode(e3, [13, 32]) === true && keyboardTarget !== rootRef.value) {
        keyboardTarget !== null && cleanup();
        if (e3.defaultPrevented !== true) {
          e3.qAvoidFocus !== true && rootRef.value.focus();
          keyboardTarget = rootRef.value;
          rootRef.value.classList.add("q-btn--active");
          document.addEventListener("keyup", onPressEnd, true);
          rootRef.value.addEventListener("blur", onPressEnd, passiveCapture);
        }
        stopAndPrevent(e3);
      }
    }
    function onTouchstart(e3) {
      if (rootRef.value === null) return;
      emit("touchstart", e3);
      if (e3.defaultPrevented === true) return;
      if (touchTarget !== rootRef.value) {
        touchTarget !== null && cleanup();
        touchTarget = rootRef.value;
        localTouchTargetEl = e3.target;
        localTouchTargetEl.addEventListener("touchcancel", onPressEnd, passiveCapture);
        localTouchTargetEl.addEventListener("touchend", onPressEnd, passiveCapture);
      }
      avoidMouseRipple = true;
      mouseTimer !== null && clearTimeout(mouseTimer);
      mouseTimer = setTimeout(() => {
        mouseTimer = null;
        avoidMouseRipple = false;
      }, 200);
    }
    function onMousedown(e3) {
      if (rootRef.value === null) return;
      e3.qSkipRipple = avoidMouseRipple === true;
      emit("mousedown", e3);
      if (e3.defaultPrevented !== true && mouseTarget !== rootRef.value) {
        mouseTarget !== null && cleanup();
        mouseTarget = rootRef.value;
        rootRef.value.classList.add("q-btn--active");
        document.addEventListener("mouseup", onPressEnd, passiveCapture);
      }
    }
    function onPressEnd(e3) {
      if (rootRef.value === null) return;
      if ((e3 == null ? void 0 : e3.type) === "blur" && document.activeElement === rootRef.value) return;
      if ((e3 == null ? void 0 : e3.type) === "keyup") {
        if (keyboardTarget === rootRef.value && isKeyCode(e3, [13, 32]) === true) {
          const evt = new MouseEvent("click", e3);
          evt.qKeyEvent = true;
          e3.defaultPrevented === true && prevent(evt);
          e3.cancelBubble === true && stop(evt);
          rootRef.value.dispatchEvent(evt);
          stopAndPrevent(e3);
          e3.qKeyEvent = true;
        }
        emit("keyup", e3);
      }
      cleanup();
    }
    function cleanup(destroying) {
      var _a, _b;
      const blurTarget = blurTargetRef.value;
      if (destroying !== true && (touchTarget === rootRef.value || mouseTarget === rootRef.value) && blurTarget !== null && blurTarget !== document.activeElement) {
        blurTarget.setAttribute("tabindex", -1);
        blurTarget.focus();
      }
      if (touchTarget === rootRef.value) {
        if (localTouchTargetEl !== null) {
          localTouchTargetEl.removeEventListener("touchcancel", onPressEnd, passiveCapture);
          localTouchTargetEl.removeEventListener("touchend", onPressEnd, passiveCapture);
        }
        touchTarget = localTouchTargetEl = null;
      }
      if (mouseTarget === rootRef.value) {
        document.removeEventListener("mouseup", onPressEnd, passiveCapture);
        mouseTarget = null;
      }
      if (keyboardTarget === rootRef.value) {
        document.removeEventListener("keyup", onPressEnd, true);
        (_a = rootRef.value) == null ? void 0 : _a.removeEventListener("blur", onPressEnd, passiveCapture);
        keyboardTarget = null;
      }
      (_b = rootRef.value) == null ? void 0 : _b.classList.remove("q-btn--active");
    }
    function onLoadingEvt(evt) {
      stopAndPrevent(evt);
      evt.qSkipRipple = true;
    }
    onBeforeUnmount(() => {
      cleanup(true);
    });
    Object.assign(proxy, {
      click: (e3) => {
        if (isActionable.value === true) {
          onClick(e3);
        }
      }
    });
    return () => {
      let inner = [];
      props4.icon !== void 0 && inner.push(
        h(QIcon_default, {
          name: props4.icon,
          left: props4.stack !== true && hasLabel.value === true,
          role: "img"
        })
      );
      hasLabel.value === true && inner.push(
        h("span", { class: "block" }, [props4.label])
      );
      inner = hMergeSlot(slots.default, inner);
      if (props4.iconRight !== void 0 && props4.round === false) {
        inner.push(
          h(QIcon_default, {
            name: props4.iconRight,
            right: props4.stack !== true && hasLabel.value === true,
            role: "img"
          })
        );
      }
      const child = [
        h("span", {
          class: "q-focus-helper",
          ref: blurTargetRef
        })
      ];
      if (props4.loading === true && props4.percentage !== void 0) {
        child.push(
          h("span", {
            class: "q-btn__progress absolute-full overflow-hidden" + (props4.darkPercentage === true ? " q-btn__progress--dark" : "")
          }, [
            h("span", {
              class: "q-btn__progress-indicator fit block",
              style: percentageStyle.value
            })
          ])
        );
      }
      child.push(
        h("span", {
          class: "q-btn__content text-center col items-center q-anchor--skip " + innerClasses.value
        }, inner)
      );
      props4.loading !== null && child.push(
        h(Transition, {
          name: "q-transition--fade"
        }, () => props4.loading === true ? [
          h("span", {
            key: "loading",
            class: "absolute-full flex flex-center"
          }, slots.loading !== void 0 ? slots.loading() : [h(QSpinner_default)])
        ] : null)
      );
      return withDirectives(
        h(
          linkTag.value,
          nodeProps.value,
          child
        ),
        [[
          Ripple_default,
          ripple.value,
          void 0,
          rippleProps.value
        ]]
      );
    };
  }
});
var QBtnGroup_default = createComponent({
  name: "QBtnGroup",
  props: {
    unelevated: Boolean,
    outline: Boolean,
    flat: Boolean,
    rounded: Boolean,
    square: Boolean,
    push: Boolean,
    stretch: Boolean,
    glossy: Boolean,
    spread: Boolean
  },
  setup(props4, { slots }) {
    const classes = computed(() => {
      const cls = ["unelevated", "outline", "flat", "rounded", "square", "push", "stretch", "glossy"].filter((t3) => props4[t3] === true).map((t3) => `q-btn-group--${t3}`).join(" ");
      return `q-btn-group row no-wrap${cls.length !== 0 ? " " + cls : ""}` + (props4.spread === true ? " q-btn-group--spread" : " inline");
    });
    return () => h("div", { class: classes.value }, hSlot(slots.default));
  }
});
function clearSelection() {
  if (window.getSelection !== void 0) {
    const selection = window.getSelection();
    if (selection.empty !== void 0) {
      selection.empty();
    } else if (selection.removeAllRanges !== void 0) {
      selection.removeAllRanges();
      Platform_default.is.mobile !== true && selection.addRange(document.createRange());
    }
  } else if (document.selection !== void 0) {
    document.selection.empty();
  }
}
var useAnchorStaticProps = {
  /* SSR does not know about Element */
  target: {
    type: [Boolean, String, Element],
    default: true
  },
  noParentEvent: Boolean
};
var useAnchorProps = {
  ...useAnchorStaticProps,
  contextMenu: Boolean
};
function use_anchor_default({
  showing,
  avoidEmit,
  // required for QPopupProxy (true)
  configureAnchorEl
  // optional
}) {
  const { props: props4, proxy, emit } = getCurrentInstance();
  const anchorEl = ref$1(null);
  let touchTimer = null;
  function canShow(evt) {
    return anchorEl.value === null ? false : evt === void 0 || evt.touches === void 0 || evt.touches.length <= 1;
  }
  const anchorEvents = {};
  if (configureAnchorEl === void 0) {
    Object.assign(anchorEvents, {
      hide(evt) {
        proxy.hide(evt);
      },
      toggle(evt) {
        proxy.toggle(evt);
        evt.qAnchorHandled = true;
      },
      toggleKey(evt) {
        isKeyCode(evt, 13) === true && anchorEvents.toggle(evt);
      },
      contextClick(evt) {
        proxy.hide(evt);
        prevent(evt);
        nextTick(() => {
          proxy.show(evt);
          evt.qAnchorHandled = true;
        });
      },
      prevent,
      mobileTouch(evt) {
        anchorEvents.mobileCleanup(evt);
        if (canShow(evt) !== true) return;
        proxy.hide(evt);
        anchorEl.value.classList.add("non-selectable");
        const target2 = evt.target;
        addEvt(anchorEvents, "anchor", [
          [target2, "touchmove", "mobileCleanup", "passive"],
          [target2, "touchend", "mobileCleanup", "passive"],
          [target2, "touchcancel", "mobileCleanup", "passive"],
          [anchorEl.value, "contextmenu", "prevent", "notPassive"]
        ]);
        touchTimer = setTimeout(() => {
          touchTimer = null;
          proxy.show(evt);
          evt.qAnchorHandled = true;
        }, 300);
      },
      mobileCleanup(evt) {
        anchorEl.value.classList.remove("non-selectable");
        if (touchTimer !== null) {
          clearTimeout(touchTimer);
          touchTimer = null;
        }
        if (showing.value === true && evt !== void 0) {
          clearSelection();
        }
      }
    });
    configureAnchorEl = function(context = props4.contextMenu) {
      if (props4.noParentEvent === true || anchorEl.value === null) return;
      let evts;
      if (context === true) {
        if (proxy.$q.platform.is.mobile === true) {
          evts = [
            [anchorEl.value, "touchstart", "mobileTouch", "passive"]
          ];
        } else {
          evts = [
            [anchorEl.value, "mousedown", "hide", "passive"],
            [anchorEl.value, "contextmenu", "contextClick", "notPassive"]
          ];
        }
      } else {
        evts = [
          [anchorEl.value, "click", "toggle", "passive"],
          [anchorEl.value, "keyup", "toggleKey", "passive"]
        ];
      }
      addEvt(anchorEvents, "anchor", evts);
    };
  }
  function unconfigureAnchorEl() {
    cleanEvt(anchorEvents, "anchor");
  }
  function setAnchorEl(el) {
    anchorEl.value = el;
    while (anchorEl.value.classList.contains("q-anchor--skip")) {
      anchorEl.value = anchorEl.value.parentNode;
    }
    configureAnchorEl();
  }
  function pickAnchorEl() {
    if (props4.target === false || props4.target === "" || proxy.$el.parentNode === null) {
      anchorEl.value = null;
    } else if (props4.target === true) {
      setAnchorEl(proxy.$el.parentNode);
    } else {
      let el = props4.target;
      if (typeof props4.target === "string") {
        try {
          el = document.querySelector(props4.target);
        } catch (err) {
          el = void 0;
        }
      }
      if (el !== void 0 && el !== null) {
        anchorEl.value = el.$el || el;
        configureAnchorEl();
      } else {
        anchorEl.value = null;
        console.error(`Anchor: target "${props4.target}" not found`);
      }
    }
  }
  watch(() => props4.contextMenu, (val) => {
    if (anchorEl.value !== null) {
      unconfigureAnchorEl();
      configureAnchorEl(val);
    }
  });
  watch(() => props4.target, () => {
    if (anchorEl.value !== null) {
      unconfigureAnchorEl();
    }
    pickAnchorEl();
  });
  watch(() => props4.noParentEvent, (val) => {
    if (anchorEl.value !== null) {
      if (val === true) {
        unconfigureAnchorEl();
      } else {
        configureAnchorEl();
      }
    }
  });
  onMounted(() => {
    pickAnchorEl();
    if (avoidEmit !== true && props4.modelValue === true && anchorEl.value === null) {
      emit("update:modelValue", false);
    }
  });
  onBeforeUnmount(() => {
    touchTimer !== null && clearTimeout(touchTimer);
    unconfigureAnchorEl();
  });
  return {
    anchorEl,
    canShow,
    anchorEvents
  };
}
function use_scroll_target_default(props4, configureScrollTarget) {
  const localScrollTarget = ref$1(null);
  let scrollFn;
  function changeScrollEvent(scrollTarget, fn) {
    const fnProp = `${fn !== void 0 ? "add" : "remove"}EventListener`;
    const fnHandler = fn !== void 0 ? fn : scrollFn;
    if (scrollTarget !== window) {
      scrollTarget[fnProp]("scroll", fnHandler, listenOpts.passive);
    }
    window[fnProp]("scroll", fnHandler, listenOpts.passive);
    scrollFn = fn;
  }
  function unconfigureScrollTarget() {
    if (localScrollTarget.value !== null) {
      changeScrollEvent(localScrollTarget.value);
      localScrollTarget.value = null;
    }
  }
  const noParentEventWatcher = watch(() => props4.noParentEvent, () => {
    if (localScrollTarget.value !== null) {
      unconfigureScrollTarget();
      configureScrollTarget();
    }
  });
  onBeforeUnmount(noParentEventWatcher);
  return {
    localScrollTarget,
    unconfigureScrollTarget,
    changeScrollEvent
  };
}
var useModelToggleProps = {
  modelValue: {
    type: Boolean,
    default: null
  },
  "onUpdate:modelValue": [Function, Array]
};
var useModelToggleEmits = [
  "beforeShow",
  "show",
  "beforeHide",
  "hide"
];
function use_model_toggle_default({
  showing,
  canShow,
  // optional
  hideOnRouteChange,
  // optional
  handleShow,
  // optional
  handleHide,
  // optional
  processOnMount
  // optional
}) {
  const vm2 = getCurrentInstance();
  const { props: props4, emit, proxy } = vm2;
  let payload;
  function toggle(evt) {
    if (showing.value === true) {
      hide(evt);
    } else {
      show(evt);
    }
  }
  function show(evt) {
    if (props4.disable === true || (evt == null ? void 0 : evt.qAnchorHandled) === true || canShow !== void 0 && canShow(evt) !== true) return;
    const listener = props4["onUpdate:modelValue"] !== void 0;
    if (listener === true && true) {
      emit("update:modelValue", true);
      payload = evt;
      nextTick(() => {
        if (payload === evt) {
          payload = void 0;
        }
      });
    }
    if (props4.modelValue === null || listener === false || false) {
      processShow(evt);
    }
  }
  function processShow(evt) {
    if (showing.value === true) return;
    showing.value = true;
    emit("beforeShow", evt);
    if (handleShow !== void 0) {
      handleShow(evt);
    } else {
      emit("show", evt);
    }
  }
  function hide(evt) {
    if (props4.disable === true) return;
    const listener = props4["onUpdate:modelValue"] !== void 0;
    if (listener === true && true) {
      emit("update:modelValue", false);
      payload = evt;
      nextTick(() => {
        if (payload === evt) {
          payload = void 0;
        }
      });
    }
    if (props4.modelValue === null || listener === false || false) {
      processHide(evt);
    }
  }
  function processHide(evt) {
    if (showing.value === false) return;
    showing.value = false;
    emit("beforeHide", evt);
    if (handleHide !== void 0) {
      handleHide(evt);
    } else {
      emit("hide", evt);
    }
  }
  function processModelChange(val) {
    if (props4.disable === true && val === true) {
      if (props4["onUpdate:modelValue"] !== void 0) {
        emit("update:modelValue", false);
      }
    } else if (val === true !== showing.value) {
      const fn = val === true ? processShow : processHide;
      fn(payload);
    }
  }
  watch(() => props4.modelValue, processModelChange);
  if (hideOnRouteChange !== void 0 && vmHasRouter(vm2) === true) {
    watch(() => proxy.$route.fullPath, () => {
      if (hideOnRouteChange.value === true && showing.value === true) {
        hide();
      }
    });
  }
  processOnMount === true && onMounted(() => {
    processModelChange(props4.modelValue);
  });
  const publicMethods = { show, hide, toggle };
  Object.assign(proxy, publicMethods);
  return publicMethods;
}
var queue = [];
var waitFlags = [];
function clearFlag(flag) {
  waitFlags = waitFlags.filter((entry) => entry !== flag);
}
function addFocusWaitFlag(flag) {
  clearFlag(flag);
  waitFlags.push(flag);
}
function removeFocusWaitFlag(flag) {
  clearFlag(flag);
  if (waitFlags.length === 0 && queue.length !== 0) {
    queue[queue.length - 1]();
    queue = [];
  }
}
function addFocusFn(fn) {
  if (waitFlags.length === 0) {
    fn();
  } else {
    queue.push(fn);
  }
}
function removeFocusFn(fn) {
  queue = queue.filter((entry) => entry !== fn);
}
var nodesList = [];
var portalTypeList = [];
var portalIndex = 1;
var target = document.body;
function createGlobalNode(id3, portalType) {
  const el = document.createElement("div");
  el.id = portalType !== void 0 ? `q-portal--${portalType}--${portalIndex++}` : id3;
  if (globalConfig.globalNodes !== void 0) {
    const cls = globalConfig.globalNodes.class;
    if (cls !== void 0) {
      el.className = cls;
    }
  }
  target.appendChild(el);
  nodesList.push(el);
  portalTypeList.push(portalType);
  return el;
}
function removeGlobalNode(el) {
  const nodeIndex = nodesList.indexOf(el);
  nodesList.splice(nodeIndex, 1);
  portalTypeList.splice(nodeIndex, 1);
  el.remove();
}
function changeGlobalNodesTarget(newTarget) {
  if (newTarget === target) return;
  target = newTarget;
  if (target === document.body || portalTypeList.reduce((acc, type2) => type2 === "dialog" ? acc + 1 : acc, 0) < 2) {
    nodesList.forEach((node) => {
      if (node.contains(target) === false) {
        target.appendChild(node);
      }
    });
    return;
  }
  const lastDialogIndex = portalTypeList.lastIndexOf("dialog");
  for (let i3 = 0; i3 < nodesList.length; i3++) {
    const el = nodesList[i3];
    if ((i3 === lastDialogIndex || portalTypeList[i3] !== "dialog") && el.contains(target) === false) {
      target.appendChild(el);
    }
  }
}
var portalProxyList = [];
function getPortalProxy(el) {
  return portalProxyList.find(
    (proxy) => proxy.contentEl !== null && proxy.contentEl.contains(el)
  );
}
function closePortalMenus(proxy, evt) {
  do {
    if (proxy.$options.name === "QMenu") {
      proxy.hide(evt);
      if (proxy.$props.separateClosePopup === true) {
        return getParentProxy(proxy);
      }
    } else if (proxy.__qPortal === true) {
      const parent = getParentProxy(proxy);
      if ((parent == null ? void 0 : parent.$options.name) === "QPopupProxy") {
        proxy.hide(evt);
        return parent;
      } else {
        return proxy;
      }
    }
    proxy = getParentProxy(proxy);
  } while (proxy !== void 0 && proxy !== null);
}
function closePortals(proxy, evt, depth) {
  while (depth !== 0 && proxy !== void 0 && proxy !== null) {
    if (proxy.__qPortal === true) {
      depth--;
      if (proxy.$options.name === "QMenu") {
        proxy = closePortalMenus(proxy, evt);
        continue;
      }
      proxy.hide(evt);
    }
    proxy = getParentProxy(proxy);
  }
}
var QPortal = createComponent({
  name: "QPortal",
  setup(_, { slots }) {
    return () => slots.default();
  }
});
function isOnGlobalDialog(vm2) {
  vm2 = vm2.parent;
  while (vm2 !== void 0 && vm2 !== null) {
    if (vm2.type.name === "QGlobalDialog") {
      return true;
    }
    if (vm2.type.name === "QDialog" || vm2.type.name === "QMenu") {
      return false;
    }
    vm2 = vm2.parent;
  }
  return false;
}
function use_portal_default(vm2, innerRef, renderPortalContent, type2) {
  const portalIsActive = ref$1(false);
  const portalIsAccessible = ref$1(false);
  let portalEl = null;
  const focusObj = {};
  const onGlobalDialog = type2 === "dialog" && isOnGlobalDialog(vm2);
  function showPortal(isReady) {
    if (isReady === true) {
      removeFocusWaitFlag(focusObj);
      portalIsAccessible.value = true;
      return;
    }
    portalIsAccessible.value = false;
    if (portalIsActive.value === false) {
      if (onGlobalDialog === false && portalEl === null) {
        portalEl = createGlobalNode(false, type2);
      }
      portalIsActive.value = true;
      portalProxyList.push(vm2.proxy);
      addFocusWaitFlag(focusObj);
    }
  }
  function hidePortal(isReady) {
    portalIsAccessible.value = false;
    if (isReady !== true) return;
    removeFocusWaitFlag(focusObj);
    portalIsActive.value = false;
    const index2 = portalProxyList.indexOf(vm2.proxy);
    if (index2 !== -1) {
      portalProxyList.splice(index2, 1);
    }
    if (portalEl !== null) {
      removeGlobalNode(portalEl);
      portalEl = null;
    }
  }
  onUnmounted(() => {
    hidePortal(true);
  });
  vm2.proxy.__qPortal = true;
  injectProp(vm2.proxy, "contentEl", () => innerRef.value);
  return {
    showPortal,
    hidePortal,
    portalIsActive,
    portalIsAccessible,
    renderPortal: () => onGlobalDialog === true ? renderPortalContent() : portalIsActive.value === true ? [h(Teleport, { to: portalEl }, h(QPortal, renderPortalContent))] : void 0
  };
}
var useTransitionProps = {
  transitionShow: {
    type: String,
    default: "fade"
  },
  transitionHide: {
    type: String,
    default: "fade"
  },
  transitionDuration: {
    type: [String, Number],
    default: 300
  }
};
function use_transition_default(props4, defaultShowFn = () => {
}, defaultHideFn = () => {
}) {
  return {
    transitionProps: computed(() => {
      const show = `q-transition--${props4.transitionShow || defaultShowFn()}`;
      const hide = `q-transition--${props4.transitionHide || defaultHideFn()}`;
      return {
        appear: true,
        enterFromClass: `${show}-enter-from`,
        enterActiveClass: `${show}-enter-active`,
        enterToClass: `${show}-enter-to`,
        leaveFromClass: `${hide}-leave-from`,
        leaveActiveClass: `${hide}-leave-active`,
        leaveToClass: `${hide}-leave-to`
      };
    }),
    transitionStyle: computed(() => `--q-transition-duration: ${props4.transitionDuration}ms`)
  };
}
function use_tick_default() {
  let tickFn;
  const vm2 = getCurrentInstance();
  function removeTick() {
    tickFn = void 0;
  }
  onDeactivated(removeTick);
  onBeforeUnmount(removeTick);
  return {
    removeTick,
    registerTick(fn) {
      tickFn = fn;
      nextTick(() => {
        if (tickFn === fn) {
          vmIsDestroyed(vm2) === false && tickFn();
          tickFn = void 0;
        }
      });
    }
  };
}
function use_timeout_default() {
  let timer2 = null;
  const vm2 = getCurrentInstance();
  function removeTimeout() {
    if (timer2 !== null) {
      clearTimeout(timer2);
      timer2 = null;
    }
  }
  onDeactivated(removeTimeout);
  onBeforeUnmount(removeTimeout);
  return {
    removeTimeout,
    registerTimeout(fn, delay) {
      removeTimeout();
      if (vmIsDestroyed(vm2) === false) {
        timer2 = setTimeout(() => {
          timer2 = null;
          fn();
        }, delay);
      }
    }
  };
}
var scrollTargetProp = [Element, String];
var scrollTargets = [null, document, document.body, document.scrollingElement, document.documentElement];
function getScrollTarget(el, targetEl) {
  let target2 = getElement(targetEl);
  if (target2 === void 0) {
    if (el === void 0 || el === null) {
      return window;
    }
    target2 = el.closest(".scroll,.scroll-y,.overflow-auto");
  }
  return scrollTargets.includes(target2) ? window : target2;
}
function getScrollHeight(el) {
  return (el === window ? document.body : el).scrollHeight;
}
function getVerticalScrollPosition(scrollTarget) {
  return scrollTarget === window ? window.pageYOffset || window.scrollY || document.body.scrollTop || 0 : scrollTarget.scrollTop;
}
function getHorizontalScrollPosition(scrollTarget) {
  return scrollTarget === window ? window.pageXOffset || window.scrollX || document.body.scrollLeft || 0 : scrollTarget.scrollLeft;
}
function animVerticalScrollTo(el, to2, duration2 = 0) {
  const prevTime = arguments[3] === void 0 ? performance.now() : arguments[3];
  const pos = getVerticalScrollPosition(el);
  if (duration2 <= 0) {
    if (pos !== to2) {
      setScroll(el, to2);
    }
    return;
  }
  requestAnimationFrame((nowTime) => {
    const frameTime = nowTime - prevTime;
    const newPos = pos + (to2 - pos) / Math.max(frameTime, duration2) * frameTime;
    setScroll(el, newPos);
    if (newPos !== to2) {
      animVerticalScrollTo(el, to2, duration2 - frameTime, nowTime);
    }
  });
}
function animHorizontalScrollTo(el, to2, duration2 = 0) {
  const prevTime = arguments[3] === void 0 ? performance.now() : arguments[3];
  const pos = getHorizontalScrollPosition(el);
  if (duration2 <= 0) {
    if (pos !== to2) {
      setHorizontalScroll(el, to2);
    }
    return;
  }
  requestAnimationFrame((nowTime) => {
    const frameTime = nowTime - prevTime;
    const newPos = pos + (to2 - pos) / Math.max(frameTime, duration2) * frameTime;
    setHorizontalScroll(el, newPos);
    if (newPos !== to2) {
      animHorizontalScrollTo(el, to2, duration2 - frameTime, nowTime);
    }
  });
}
function setScroll(scrollTarget, offset2) {
  if (scrollTarget === window) {
    window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, offset2);
    return;
  }
  scrollTarget.scrollTop = offset2;
}
function setHorizontalScroll(scrollTarget, offset2) {
  if (scrollTarget === window) {
    window.scrollTo(offset2, window.pageYOffset || window.scrollY || document.body.scrollTop || 0);
    return;
  }
  scrollTarget.scrollLeft = offset2;
}
function setVerticalScrollPosition(scrollTarget, offset2, duration2) {
  if (duration2) {
    animVerticalScrollTo(scrollTarget, offset2, duration2);
    return;
  }
  setScroll(scrollTarget, offset2);
}
function setHorizontalScrollPosition(scrollTarget, offset2, duration2) {
  if (duration2) {
    animHorizontalScrollTo(scrollTarget, offset2, duration2);
    return;
  }
  setHorizontalScroll(scrollTarget, offset2);
}
var size;
function getScrollbarWidth() {
  if (size !== void 0) {
    return size;
  }
  const inner = document.createElement("p"), outer = document.createElement("div");
  css(inner, {
    width: "100%",
    height: "200px"
  });
  css(outer, {
    position: "absolute",
    top: "0px",
    left: "0px",
    visibility: "hidden",
    width: "200px",
    height: "150px",
    overflow: "hidden"
  });
  outer.appendChild(inner);
  document.body.appendChild(outer);
  const w1 = inner.offsetWidth;
  outer.style.overflow = "scroll";
  let w22 = inner.offsetWidth;
  if (w1 === w22) {
    w22 = outer.clientWidth;
  }
  outer.remove();
  size = w1 - w22;
  return size;
}
function hasScrollbar(el, onY = true) {
  if (!el || el.nodeType !== Node.ELEMENT_NODE) {
    return false;
  }
  return onY ? el.scrollHeight > el.clientHeight && (el.classList.contains("scroll") || el.classList.contains("overflow-auto") || ["auto", "scroll"].includes(window.getComputedStyle(el)["overflow-y"])) : el.scrollWidth > el.clientWidth && (el.classList.contains("scroll") || el.classList.contains("overflow-auto") || ["auto", "scroll"].includes(window.getComputedStyle(el)["overflow-x"]));
}
var handlers = [];
var escDown;
function onKeydown(evt) {
  escDown = evt.keyCode === 27;
}
function onBlur() {
  if (escDown === true) {
    escDown = false;
  }
}
function onKeyup(evt) {
  if (escDown === true) {
    escDown = false;
    if (isKeyCode(evt, 27) === true) {
      handlers[handlers.length - 1](evt);
    }
  }
}
function update(action) {
  window[action]("keydown", onKeydown);
  window[action]("blur", onBlur);
  window[action]("keyup", onKeyup);
  escDown = false;
}
function addEscapeKey(fn) {
  if (client.is.desktop === true) {
    handlers.push(fn);
    if (handlers.length === 1) {
      update("addEventListener");
    }
  }
}
function removeEscapeKey(fn) {
  const index2 = handlers.indexOf(fn);
  if (index2 !== -1) {
    handlers.splice(index2, 1);
    if (handlers.length === 0) {
      update("removeEventListener");
    }
  }
}
var handlers2 = [];
function trigger(e3) {
  handlers2[handlers2.length - 1](e3);
}
function addFocusout(fn) {
  if (client.is.desktop === true) {
    handlers2.push(fn);
    if (handlers2.length === 1) {
      document.body.addEventListener("focusin", trigger);
    }
  }
}
function removeFocusout(fn) {
  const index2 = handlers2.indexOf(fn);
  if (index2 !== -1) {
    handlers2.splice(index2, 1);
    if (handlers2.length === 0) {
      document.body.removeEventListener("focusin", trigger);
    }
  }
}
var { notPassiveCapture } = listenOpts;
var registeredList = [];
function globalHandler(evt) {
  const target2 = evt.target;
  if (target2 === void 0 || target2.nodeType === 8 || target2.classList.contains("no-pointer-events") === true) return;
  let portalIndex2 = portalProxyList.length - 1;
  while (portalIndex2 >= 0) {
    const proxy = portalProxyList[portalIndex2].$;
    if (proxy.type.name === "QTooltip") {
      portalIndex2--;
      continue;
    }
    if (proxy.type.name !== "QDialog") {
      break;
    }
    if (proxy.props.seamless !== true) return;
    portalIndex2--;
  }
  for (let i3 = registeredList.length - 1; i3 >= 0; i3--) {
    const state2 = registeredList[i3];
    if ((state2.anchorEl.value === null || state2.anchorEl.value.contains(target2) === false) && (target2 === document.body || state2.innerRef.value !== null && state2.innerRef.value.contains(target2) === false)) {
      evt.qClickOutside = true;
      state2.onClickOutside(evt);
    } else {
      return;
    }
  }
}
function addClickOutside(clickOutsideProps) {
  registeredList.push(clickOutsideProps);
  if (registeredList.length === 1) {
    document.addEventListener("mousedown", globalHandler, notPassiveCapture);
    document.addEventListener("touchstart", globalHandler, notPassiveCapture);
  }
}
function removeClickOutside(clickOutsideProps) {
  const index2 = registeredList.findIndex((h138) => h138 === clickOutsideProps);
  if (index2 !== -1) {
    registeredList.splice(index2, 1);
    if (registeredList.length === 0) {
      document.removeEventListener("mousedown", globalHandler, notPassiveCapture);
      document.removeEventListener("touchstart", globalHandler, notPassiveCapture);
    }
  }
}
var vpLeft;
var vpTop;
function validatePosition(pos) {
  const parts = pos.split(" ");
  if (parts.length !== 2) {
    return false;
  }
  if (["top", "center", "bottom"].includes(parts[0]) !== true) {
    console.error("Anchor/Self position must start with one of top/center/bottom");
    return false;
  }
  if (["left", "middle", "right", "start", "end"].includes(parts[1]) !== true) {
    console.error("Anchor/Self position must end with one of left/middle/right/start/end");
    return false;
  }
  return true;
}
function validateOffset(val) {
  if (!val) {
    return true;
  }
  if (val.length !== 2) {
    return false;
  }
  if (typeof val[0] !== "number" || typeof val[1] !== "number") {
    return false;
  }
  return true;
}
var horizontalPos = {
  "start#ltr": "left",
  "start#rtl": "right",
  "end#ltr": "right",
  "end#rtl": "left"
};
["left", "middle", "right"].forEach((pos) => {
  horizontalPos[`${pos}#ltr`] = pos;
  horizontalPos[`${pos}#rtl`] = pos;
});
function parsePosition(pos, rtl) {
  const parts = pos.split(" ");
  return {
    vertical: parts[0],
    horizontal: horizontalPos[`${parts[1]}#${rtl === true ? "rtl" : "ltr"}`]
  };
}
function getAnchorProps(el, offset2) {
  let { top, left, right, bottom, width: width3, height: height2 } = el.getBoundingClientRect();
  if (offset2 !== void 0) {
    top -= offset2[1];
    left -= offset2[0];
    bottom += offset2[1];
    right += offset2[0];
    width3 += offset2[0];
    height2 += offset2[1];
  }
  return {
    top,
    bottom,
    height: height2,
    left,
    right,
    width: width3,
    middle: left + (right - left) / 2,
    center: top + (bottom - top) / 2
  };
}
function getAbsoluteAnchorProps(el, absoluteOffset, offset2) {
  let { top, left } = el.getBoundingClientRect();
  top += absoluteOffset.top;
  left += absoluteOffset.left;
  if (offset2 !== void 0) {
    top += offset2[1];
    left += offset2[0];
  }
  return {
    top,
    bottom: top + 1,
    height: 1,
    left,
    right: left + 1,
    width: 1,
    middle: left,
    center: top
  };
}
function getTargetProps(width3, height2) {
  return {
    top: 0,
    center: height2 / 2,
    bottom: height2,
    left: 0,
    middle: width3 / 2,
    right: width3
  };
}
function getTopLeftProps(anchorProps, targetProps, anchorOrigin, selfOrigin) {
  return {
    top: anchorProps[anchorOrigin.vertical] - targetProps[selfOrigin.vertical],
    left: anchorProps[anchorOrigin.horizontal] - targetProps[selfOrigin.horizontal]
  };
}
function setPosition(cfg, retryNumber = 0) {
  if (cfg.targetEl === null || cfg.anchorEl === null || retryNumber > 5) return;
  if (cfg.targetEl.offsetHeight === 0 || cfg.targetEl.offsetWidth === 0) {
    setTimeout(() => {
      setPosition(cfg, retryNumber + 1);
    }, 10);
    return;
  }
  const {
    targetEl,
    offset: offset2,
    anchorEl,
    anchorOrigin,
    selfOrigin,
    absoluteOffset,
    fit,
    cover,
    maxHeight,
    maxWidth
  } = cfg;
  if (client.is.ios === true && window.visualViewport !== void 0) {
    const el = document.body.style;
    const { offsetLeft: left, offsetTop: top } = window.visualViewport;
    if (left !== vpLeft) {
      el.setProperty("--q-pe-left", left + "px");
      vpLeft = left;
    }
    if (top !== vpTop) {
      el.setProperty("--q-pe-top", top + "px");
      vpTop = top;
    }
  }
  const { scrollLeft, scrollTop } = targetEl;
  const anchorProps = absoluteOffset === void 0 ? getAnchorProps(anchorEl, cover === true ? [0, 0] : offset2) : getAbsoluteAnchorProps(anchorEl, absoluteOffset, offset2);
  Object.assign(targetEl.style, {
    top: 0,
    left: 0,
    minWidth: null,
    minHeight: null,
    maxWidth,
    maxHeight,
    visibility: "visible"
  });
  const { offsetWidth: origElWidth, offsetHeight: origElHeight } = targetEl;
  const { elWidth, elHeight } = fit === true || cover === true ? { elWidth: Math.max(anchorProps.width, origElWidth), elHeight: cover === true ? Math.max(anchorProps.height, origElHeight) : origElHeight } : { elWidth: origElWidth, elHeight: origElHeight };
  let elStyle = { maxWidth, maxHeight };
  if (fit === true || cover === true) {
    elStyle.minWidth = anchorProps.width + "px";
    if (cover === true) {
      elStyle.minHeight = anchorProps.height + "px";
    }
  }
  Object.assign(targetEl.style, elStyle);
  const targetProps = getTargetProps(elWidth, elHeight);
  let props4 = getTopLeftProps(anchorProps, targetProps, anchorOrigin, selfOrigin);
  if (absoluteOffset === void 0 || offset2 === void 0) {
    applyBoundaries(props4, anchorProps, targetProps, anchorOrigin, selfOrigin);
  } else {
    const { top, left } = props4;
    applyBoundaries(props4, anchorProps, targetProps, anchorOrigin, selfOrigin);
    let hasChanged = false;
    if (props4.top !== top) {
      hasChanged = true;
      const offsetY = 2 * offset2[1];
      anchorProps.center = anchorProps.top -= offsetY;
      anchorProps.bottom -= offsetY + 2;
    }
    if (props4.left !== left) {
      hasChanged = true;
      const offsetX = 2 * offset2[0];
      anchorProps.middle = anchorProps.left -= offsetX;
      anchorProps.right -= offsetX + 2;
    }
    if (hasChanged === true) {
      props4 = getTopLeftProps(anchorProps, targetProps, anchorOrigin, selfOrigin);
      applyBoundaries(props4, anchorProps, targetProps, anchorOrigin, selfOrigin);
    }
  }
  elStyle = {
    top: props4.top + "px",
    left: props4.left + "px"
  };
  if (props4.maxHeight !== void 0) {
    elStyle.maxHeight = props4.maxHeight + "px";
    if (anchorProps.height > props4.maxHeight) {
      elStyle.minHeight = elStyle.maxHeight;
    }
  }
  if (props4.maxWidth !== void 0) {
    elStyle.maxWidth = props4.maxWidth + "px";
    if (anchorProps.width > props4.maxWidth) {
      elStyle.minWidth = elStyle.maxWidth;
    }
  }
  Object.assign(targetEl.style, elStyle);
  if (targetEl.scrollTop !== scrollTop) {
    targetEl.scrollTop = scrollTop;
  }
  if (targetEl.scrollLeft !== scrollLeft) {
    targetEl.scrollLeft = scrollLeft;
  }
}
function applyBoundaries(props4, anchorProps, targetProps, anchorOrigin, selfOrigin) {
  const currentHeight = targetProps.bottom, currentWidth = targetProps.right, margin = getScrollbarWidth(), innerHeight = window.innerHeight - margin, innerWidth = document.body.clientWidth;
  if (props4.top < 0 || props4.top + currentHeight > innerHeight) {
    if (selfOrigin.vertical === "center") {
      props4.top = anchorProps[anchorOrigin.vertical] > innerHeight / 2 ? Math.max(0, innerHeight - currentHeight) : 0;
      props4.maxHeight = Math.min(currentHeight, innerHeight);
    } else if (anchorProps[anchorOrigin.vertical] > innerHeight / 2) {
      const anchorY = Math.min(
        innerHeight,
        anchorOrigin.vertical === "center" ? anchorProps.center : anchorOrigin.vertical === selfOrigin.vertical ? anchorProps.bottom : anchorProps.top
      );
      props4.maxHeight = Math.min(currentHeight, anchorY);
      props4.top = Math.max(0, anchorY - currentHeight);
    } else {
      props4.top = Math.max(
        0,
        anchorOrigin.vertical === "center" ? anchorProps.center : anchorOrigin.vertical === selfOrigin.vertical ? anchorProps.top : anchorProps.bottom
      );
      props4.maxHeight = Math.min(currentHeight, innerHeight - props4.top);
    }
  }
  if (props4.left < 0 || props4.left + currentWidth > innerWidth) {
    props4.maxWidth = Math.min(currentWidth, innerWidth);
    if (selfOrigin.horizontal === "middle") {
      props4.left = anchorProps[anchorOrigin.horizontal] > innerWidth / 2 ? Math.max(0, innerWidth - currentWidth) : 0;
    } else if (anchorProps[anchorOrigin.horizontal] > innerWidth / 2) {
      const anchorX = Math.min(
        innerWidth,
        anchorOrigin.horizontal === "middle" ? anchorProps.middle : anchorOrigin.horizontal === selfOrigin.horizontal ? anchorProps.right : anchorProps.left
      );
      props4.maxWidth = Math.min(currentWidth, anchorX);
      props4.left = Math.max(0, anchorX - props4.maxWidth);
    } else {
      props4.left = Math.max(
        0,
        anchorOrigin.horizontal === "middle" ? anchorProps.middle : anchorOrigin.horizontal === selfOrigin.horizontal ? anchorProps.left : anchorProps.right
      );
      props4.maxWidth = Math.min(currentWidth, innerWidth - props4.left);
    }
  }
}
var QMenu_default = createComponent({
  name: "QMenu",
  inheritAttrs: false,
  props: {
    ...useAnchorProps,
    ...useModelToggleProps,
    ...useDarkProps,
    ...useTransitionProps,
    persistent: Boolean,
    autoClose: Boolean,
    separateClosePopup: Boolean,
    noEscDismiss: Boolean,
    noRouteDismiss: Boolean,
    noRefocus: Boolean,
    noFocus: Boolean,
    fit: Boolean,
    cover: Boolean,
    square: Boolean,
    anchor: {
      type: String,
      validator: validatePosition
    },
    self: {
      type: String,
      validator: validatePosition
    },
    offset: {
      type: Array,
      validator: validateOffset
    },
    scrollTarget: scrollTargetProp,
    touchPosition: Boolean,
    maxHeight: {
      type: String,
      default: null
    },
    maxWidth: {
      type: String,
      default: null
    }
  },
  emits: [
    ...useModelToggleEmits,
    "click",
    "escapeKey"
  ],
  setup(props4, { slots, emit, attrs }) {
    let refocusTarget = null, absoluteOffset, unwatchPosition, avoidAutoClose;
    const vm2 = getCurrentInstance();
    const { proxy } = vm2;
    const { $q } = proxy;
    const innerRef = ref$1(null);
    const showing = ref$1(false);
    const hideOnRouteChange = computed(
      () => props4.persistent !== true && props4.noRouteDismiss !== true
    );
    const isDark = use_dark_default(props4, $q);
    const { registerTick, removeTick } = use_tick_default();
    const { registerTimeout } = use_timeout_default();
    const { transitionProps, transitionStyle } = use_transition_default(props4);
    const { localScrollTarget, changeScrollEvent, unconfigureScrollTarget } = use_scroll_target_default(props4, configureScrollTarget);
    const { anchorEl, canShow } = use_anchor_default({ showing });
    const { hide } = use_model_toggle_default({
      showing,
      canShow,
      handleShow,
      handleHide,
      hideOnRouteChange,
      processOnMount: true
    });
    const { showPortal, hidePortal, renderPortal } = use_portal_default(vm2, innerRef, renderPortalContent, "menu");
    const clickOutsideProps = {
      anchorEl,
      innerRef,
      onClickOutside(e3) {
        if (props4.persistent !== true && showing.value === true) {
          hide(e3);
          if (
            // always prevent touch event
            e3.type === "touchstart" || e3.target.classList.contains("q-dialog__backdrop")
          ) {
            stopAndPrevent(e3);
          }
          return true;
        }
      }
    };
    const anchorOrigin = computed(
      () => parsePosition(
        props4.anchor || (props4.cover === true ? "center middle" : "bottom start"),
        $q.lang.rtl
      )
    );
    const selfOrigin = computed(() => props4.cover === true ? anchorOrigin.value : parsePosition(props4.self || "top start", $q.lang.rtl));
    const menuClass = computed(
      () => (props4.square === true ? " q-menu--square" : "") + (isDark.value === true ? " q-menu--dark q-dark" : "")
    );
    const onEvents = computed(() => props4.autoClose === true ? { onClick: onAutoClose } : {});
    const handlesFocus = computed(
      () => showing.value === true && props4.persistent !== true
    );
    watch(handlesFocus, (val) => {
      if (val === true) {
        addEscapeKey(onEscapeKey);
        addClickOutside(clickOutsideProps);
      } else {
        removeEscapeKey(onEscapeKey);
        removeClickOutside(clickOutsideProps);
      }
    });
    function focus() {
      addFocusFn(() => {
        let node = innerRef.value;
        if (node && node.contains(document.activeElement) !== true) {
          node = node.querySelector("[autofocus][tabindex], [data-autofocus][tabindex]") || node.querySelector("[autofocus] [tabindex], [data-autofocus] [tabindex]") || node.querySelector("[autofocus], [data-autofocus]") || node;
          node.focus({ preventScroll: true });
        }
      });
    }
    function handleShow(evt) {
      refocusTarget = props4.noRefocus === false ? document.activeElement : null;
      addFocusout(onFocusout);
      showPortal();
      configureScrollTarget();
      absoluteOffset = void 0;
      if (evt !== void 0 && (props4.touchPosition || props4.contextMenu)) {
        const pos = position(evt);
        if (pos.left !== void 0) {
          const { top, left } = anchorEl.value.getBoundingClientRect();
          absoluteOffset = { left: pos.left - left, top: pos.top - top };
        }
      }
      if (unwatchPosition === void 0) {
        unwatchPosition = watch(
          () => $q.screen.width + "|" + $q.screen.height + "|" + props4.self + "|" + props4.anchor + "|" + $q.lang.rtl,
          updatePosition
        );
      }
      if (props4.noFocus !== true) {
        document.activeElement.blur();
      }
      registerTick(() => {
        updatePosition();
        props4.noFocus !== true && focus();
      });
      registerTimeout(() => {
        if ($q.platform.is.ios === true) {
          avoidAutoClose = props4.autoClose;
          innerRef.value.click();
        }
        updatePosition();
        showPortal(true);
        emit("show", evt);
      }, props4.transitionDuration);
    }
    function handleHide(evt) {
      removeTick();
      hidePortal();
      anchorCleanup(true);
      if (refocusTarget !== null && // menu was hidden from code or ESC plugin
      (evt === void 0 || evt.qClickOutside !== true)) {
        (((evt == null ? void 0 : evt.type.indexOf("key")) === 0 ? refocusTarget.closest('[tabindex]:not([tabindex^="-"])') : void 0) || refocusTarget).focus();
        refocusTarget = null;
      }
      registerTimeout(() => {
        hidePortal(true);
        emit("hide", evt);
      }, props4.transitionDuration);
    }
    function anchorCleanup(hiding) {
      absoluteOffset = void 0;
      if (unwatchPosition !== void 0) {
        unwatchPosition();
        unwatchPosition = void 0;
      }
      if (hiding === true || showing.value === true) {
        removeFocusout(onFocusout);
        unconfigureScrollTarget();
        removeClickOutside(clickOutsideProps);
        removeEscapeKey(onEscapeKey);
      }
      if (hiding !== true) {
        refocusTarget = null;
      }
    }
    function configureScrollTarget() {
      if (anchorEl.value !== null || props4.scrollTarget !== void 0) {
        localScrollTarget.value = getScrollTarget(anchorEl.value, props4.scrollTarget);
        changeScrollEvent(localScrollTarget.value, updatePosition);
      }
    }
    function onAutoClose(e3) {
      if (avoidAutoClose !== true) {
        closePortalMenus(proxy, e3);
        emit("click", e3);
      } else {
        avoidAutoClose = false;
      }
    }
    function onFocusout(evt) {
      if (handlesFocus.value === true && props4.noFocus !== true && childHasFocus(innerRef.value, evt.target) !== true) {
        focus();
      }
    }
    function onEscapeKey(evt) {
      if (props4.noEscDismiss !== true) {
        emit("escapeKey");
        hide(evt);
      }
    }
    function updatePosition() {
      setPosition({
        targetEl: innerRef.value,
        offset: props4.offset,
        anchorEl: anchorEl.value,
        anchorOrigin: anchorOrigin.value,
        selfOrigin: selfOrigin.value,
        absoluteOffset,
        fit: props4.fit,
        cover: props4.cover,
        maxHeight: props4.maxHeight,
        maxWidth: props4.maxWidth
      });
    }
    function renderPortalContent() {
      return h(
        Transition,
        transitionProps.value,
        () => showing.value === true ? h("div", {
          role: "menu",
          ...attrs,
          ref: innerRef,
          tabindex: -1,
          class: [
            "q-menu q-position-engine scroll" + menuClass.value,
            attrs.class
          ],
          style: [
            attrs.style,
            transitionStyle.value
          ],
          ...onEvents.value
        }, hSlot(slots.default)) : null
      );
    }
    onBeforeUnmount(anchorCleanup);
    Object.assign(proxy, { focus, updatePosition });
    return renderPortal;
  }
});
var buf;
var bufIdx = 0;
var hexBytes = new Array(256);
for (let i3 = 0; i3 < 256; i3++) {
  hexBytes[i3] = (i3 + 256).toString(16).substring(1);
}
var randomBytes = (() => {
  const lib = typeof crypto !== "undefined" ? crypto : typeof window !== "undefined" ? window.crypto || window.msCrypto : void 0;
  if (lib !== void 0) {
    if (lib.randomBytes !== void 0) {
      return lib.randomBytes;
    }
    if (lib.getRandomValues !== void 0) {
      return (n) => {
        const bytes = new Uint8Array(n);
        lib.getRandomValues(bytes);
        return bytes;
      };
    }
  }
  return (n) => {
    const r = [];
    for (let i3 = n; i3 > 0; i3--) {
      r.push(Math.floor(Math.random() * 256));
    }
    return r;
  };
})();
var BUFFER_SIZE = 4096;
function uid_default() {
  if (buf === void 0 || bufIdx + 16 > BUFFER_SIZE) {
    bufIdx = 0;
    buf = randomBytes(BUFFER_SIZE);
  }
  const b3 = Array.prototype.slice.call(buf, bufIdx, bufIdx += 16);
  b3[6] = b3[6] & 15 | 64;
  b3[8] = b3[8] & 63 | 128;
  return hexBytes[b3[0]] + hexBytes[b3[1]] + hexBytes[b3[2]] + hexBytes[b3[3]] + "-" + hexBytes[b3[4]] + hexBytes[b3[5]] + "-" + hexBytes[b3[6]] + hexBytes[b3[7]] + "-" + hexBytes[b3[8]] + hexBytes[b3[9]] + "-" + hexBytes[b3[10]] + hexBytes[b3[11]] + hexBytes[b3[12]] + hexBytes[b3[13]] + hexBytes[b3[14]] + hexBytes[b3[15]];
}
function parseValue(val) {
  return val === void 0 || val === null ? null : val;
}
function getId(val, required) {
  return val === void 0 || val === null ? required === true ? `f_${uid_default()}` : null : val;
}
function use_id_default({ getValue, required = true } = {}) {
  if (isRuntimeSsrPreHydration.value === true) {
    const id3 = getValue !== void 0 ? ref$1(parseValue(getValue())) : ref$1(null);
    if (required === true && id3.value === null) {
      onMounted(() => {
        id3.value = `f_${uid_default()}`;
      });
    }
    if (getValue !== void 0) {
      watch(getValue, (newId) => {
        id3.value = getId(newId, required);
      });
    }
    return id3;
  }
  return getValue !== void 0 ? computed(() => getId(getValue(), required)) : ref$1(`f_${uid_default()}`);
}
var btnPropsList = Object.keys(nonRoundBtnProps);
function passBtnProps(props4) {
  return btnPropsList.reduce((acc, key) => {
    const val = props4[key];
    if (val !== void 0) {
      acc[key] = val;
    }
    return acc;
  }, {});
}
var QBtnDropdown_default = createComponent({
  name: "QBtnDropdown",
  props: {
    ...nonRoundBtnProps,
    ...useTransitionProps,
    modelValue: Boolean,
    split: Boolean,
    dropdownIcon: String,
    contentClass: [Array, String, Object],
    contentStyle: [Array, String, Object],
    cover: Boolean,
    persistent: Boolean,
    noEscDismiss: Boolean,
    noRouteDismiss: Boolean,
    autoClose: Boolean,
    noRefocus: Boolean,
    noFocus: Boolean,
    menuAnchor: {
      type: String,
      default: "bottom end"
    },
    menuSelf: {
      type: String,
      default: "top end"
    },
    menuOffset: Array,
    disableMainBtn: Boolean,
    disableDropdown: Boolean,
    noIconAnimation: Boolean,
    toggleAriaLabel: String
  },
  emits: ["update:modelValue", "click", "beforeShow", "show", "beforeHide", "hide"],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const showing = ref$1(props4.modelValue);
    const menuRef = ref$1(null);
    const targetUid = use_id_default();
    const ariaAttrs = computed(() => {
      const acc = {
        "aria-expanded": showing.value === true ? "true" : "false",
        "aria-haspopup": "true",
        "aria-controls": targetUid.value,
        "aria-label": props4.toggleAriaLabel || proxy.$q.lang.label[showing.value === true ? "collapse" : "expand"](props4.label)
      };
      if (props4.disable === true || (props4.split === false && props4.disableMainBtn === true || props4.disableDropdown === true)) {
        acc["aria-disabled"] = "true";
      }
      return acc;
    });
    const iconClass = computed(
      () => "q-btn-dropdown__arrow" + (showing.value === true && props4.noIconAnimation === false ? " rotate-180" : "") + (props4.split === false ? " q-btn-dropdown__arrow-container" : "")
    );
    const btnDesignAttr = computed(() => getBtnDesignAttr(props4));
    const btnProps = computed(() => passBtnProps(props4));
    watch(() => props4.modelValue, (val) => {
      var _a;
      (_a = menuRef.value) == null ? void 0 : _a[val ? "show" : "hide"]();
    });
    watch(() => props4.split, hide);
    function onBeforeShow(e3) {
      showing.value = true;
      emit("beforeShow", e3);
    }
    function onShow(e3) {
      emit("show", e3);
      emit("update:modelValue", true);
    }
    function onBeforeHide(e3) {
      showing.value = false;
      emit("beforeHide", e3);
    }
    function onHide(e3) {
      emit("hide", e3);
      emit("update:modelValue", false);
    }
    function onClick(e3) {
      emit("click", e3);
    }
    function onClickHide(e3) {
      stop(e3);
      hide();
      emit("click", e3);
    }
    function toggle(evt) {
      var _a;
      (_a = menuRef.value) == null ? void 0 : _a.toggle(evt);
    }
    function show(evt) {
      var _a;
      (_a = menuRef.value) == null ? void 0 : _a.show(evt);
    }
    function hide(evt) {
      var _a;
      (_a = menuRef.value) == null ? void 0 : _a.hide(evt);
    }
    Object.assign(proxy, {
      show,
      hide,
      toggle
    });
    onMounted(() => {
      props4.modelValue === true && show();
    });
    return () => {
      const Arrow = [
        h(QIcon_default, {
          class: iconClass.value,
          name: props4.dropdownIcon || proxy.$q.iconSet.arrow.dropdown
        })
      ];
      props4.disableDropdown !== true && Arrow.push(
        h(QMenu_default, {
          ref: menuRef,
          id: targetUid.value,
          class: props4.contentClass,
          style: props4.contentStyle,
          cover: props4.cover,
          fit: true,
          persistent: props4.persistent,
          noEscDismiss: props4.noEscDismiss,
          noRouteDismiss: props4.noRouteDismiss,
          autoClose: props4.autoClose,
          noFocus: props4.noFocus,
          noRefocus: props4.noRefocus,
          anchor: props4.menuAnchor,
          self: props4.menuSelf,
          offset: props4.menuOffset,
          separateClosePopup: true,
          transitionShow: props4.transitionShow,
          transitionHide: props4.transitionHide,
          transitionDuration: props4.transitionDuration,
          onBeforeShow,
          onShow,
          onBeforeHide,
          onHide
        }, slots.default)
      );
      if (props4.split === false) {
        return h(QBtn_default, {
          class: "q-btn-dropdown q-btn-dropdown--simple",
          ...btnProps.value,
          ...ariaAttrs.value,
          disable: props4.disable === true || props4.disableMainBtn === true,
          noWrap: true,
          round: false,
          onClick
        }, {
          default: () => hSlot(slots.label, []).concat(Arrow),
          loading: slots.loading
        });
      }
      return h(QBtnGroup_default, {
        class: "q-btn-dropdown q-btn-dropdown--split no-wrap q-btn-item",
        rounded: props4.rounded,
        square: props4.square,
        ...btnDesignAttr.value,
        glossy: props4.glossy,
        stretch: props4.stretch
      }, () => [
        h(QBtn_default, {
          class: "q-btn-dropdown--current",
          ...btnProps.value,
          disable: props4.disable === true || props4.disableMainBtn === true,
          noWrap: true,
          round: false,
          onClick: onClickHide
        }, {
          default: slots.label,
          loading: slots.loading
        }),
        h(QBtn_default, {
          class: "q-btn-dropdown__arrow-container q-anchor--skip",
          ...ariaAttrs.value,
          ...btnDesignAttr.value,
          disable: props4.disable === true || props4.disableDropdown === true,
          rounded: props4.rounded,
          color: props4.color,
          textColor: props4.textColor,
          dense: props4.dense,
          size: props4.size,
          padding: props4.padding,
          ripple: props4.ripple
        }, () => Arrow)
      ]);
    };
  }
});
var useFormProps = {
  name: String
};
function useFormAttrs(props4) {
  return computed(() => ({
    type: "hidden",
    name: props4.name,
    value: props4.modelValue
  }));
}
function useFormInject(formAttrs = {}) {
  return (child, action, className) => {
    child[action](
      h("input", {
        class: "hidden" + (className || ""),
        ...formAttrs.value
      })
    );
  };
}
function useFormInputNameAttr(props4) {
  return computed(() => props4.name || props4.for);
}
createComponent({
  name: "QBtnToggle",
  props: {
    ...useFormProps,
    modelValue: {
      required: true
    },
    options: {
      type: Array,
      required: true,
      validator: (v) => v.every(
        (opt) => ("label" in opt || "icon" in opt || "slot" in opt) && "value" in opt
      )
    },
    // To avoid seeing the active raise shadow through
    // the transparent button, give it a color (even white)
    color: String,
    textColor: String,
    toggleColor: {
      type: String,
      default: "primary"
    },
    toggleTextColor: String,
    outline: Boolean,
    flat: Boolean,
    unelevated: Boolean,
    rounded: Boolean,
    push: Boolean,
    glossy: Boolean,
    size: String,
    padding: String,
    noCaps: Boolean,
    noWrap: Boolean,
    dense: Boolean,
    readonly: Boolean,
    disable: Boolean,
    stack: Boolean,
    stretch: Boolean,
    spread: Boolean,
    clearable: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    }
  },
  emits: ["update:modelValue", "clear", "click"],
  setup(props4, { slots, emit }) {
    const hasActiveValue = computed(
      () => props4.options.find((opt) => opt.value === props4.modelValue) !== void 0
    );
    const formAttrs = computed(() => ({
      type: "hidden",
      name: props4.name,
      value: props4.modelValue
    }));
    const injectFormInput = useFormInject(formAttrs);
    const btnDesignAttr = computed(() => getBtnDesignAttr(props4));
    const btnOptionDesign = computed(() => ({
      rounded: props4.rounded,
      dense: props4.dense,
      ...btnDesignAttr.value
    }));
    const btnOptions = computed(() => props4.options.map((item, i3) => {
      const { attrs, value: value2, slot, ...opt } = item;
      return {
        slot,
        props: {
          key: i3,
          "aria-pressed": value2 === props4.modelValue ? "true" : "false",
          ...attrs,
          ...opt,
          ...btnOptionDesign.value,
          disable: props4.disable === true || opt.disable === true,
          // Options that come from the button specific options first, then from general props
          color: value2 === props4.modelValue ? mergeOpt(opt, "toggleColor") : mergeOpt(opt, "color"),
          textColor: value2 === props4.modelValue ? mergeOpt(opt, "toggleTextColor") : mergeOpt(opt, "textColor"),
          noCaps: mergeOpt(opt, "noCaps") === true,
          noWrap: mergeOpt(opt, "noWrap") === true,
          size: mergeOpt(opt, "size"),
          padding: mergeOpt(opt, "padding"),
          ripple: mergeOpt(opt, "ripple"),
          stack: mergeOpt(opt, "stack") === true,
          stretch: mergeOpt(opt, "stretch") === true,
          onClick(e3) {
            set2(value2, item, e3);
          }
        }
      };
    }));
    function set2(value2, opt, e3) {
      if (props4.readonly !== true) {
        if (props4.modelValue === value2) {
          if (props4.clearable === true) {
            emit("update:modelValue", null, null);
            emit("clear");
          }
        } else {
          emit("update:modelValue", value2, opt);
        }
        emit("click", e3);
      }
    }
    function mergeOpt(opt, key) {
      return opt[key] === void 0 ? props4[key] : opt[key];
    }
    function getContent() {
      const child = btnOptions.value.map((opt) => {
        return h(QBtn_default, opt.props, opt.slot !== void 0 ? slots[opt.slot] : void 0);
      });
      if (props4.name !== void 0 && props4.disable !== true && hasActiveValue.value === true) {
        injectFormInput(child, "push");
      }
      return hMergeSlot(slots.default, child);
    }
    return () => h(QBtnGroup_default, {
      class: "q-btn-toggle",
      ...btnDesignAttr.value,
      rounded: props4.rounded,
      stretch: props4.stretch,
      glossy: props4.glossy,
      spread: props4.spread
    }, getContent);
  }
});
var QCard_default = createComponent({
  name: "QCard",
  props: {
    ...useDarkProps,
    tag: {
      type: String,
      default: "div"
    },
    square: Boolean,
    flat: Boolean,
    bordered: Boolean
  },
  setup(props4, { slots }) {
    const { proxy: { $q } } = getCurrentInstance();
    const isDark = use_dark_default(props4, $q);
    const classes = computed(
      () => "q-card" + (isDark.value === true ? " q-card--dark q-dark" : "") + (props4.bordered === true ? " q-card--bordered" : "") + (props4.square === true ? " q-card--square no-border-radius" : "") + (props4.flat === true ? " q-card--flat no-shadow" : "")
    );
    return () => h(props4.tag, { class: classes.value }, hSlot(slots.default));
  }
});
var QCardSection_default = createComponent({
  name: "QCardSection",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    horizontal: Boolean
  },
  setup(props4, { slots }) {
    const classes = computed(
      () => `q-card__section q-card__section--${props4.horizontal === true ? "horiz row no-wrap" : "vert"}`
    );
    return () => h(props4.tag, { class: classes.value }, hSlot(slots.default));
  }
});
var QCardActions_default = createComponent({
  name: "QCardActions",
  props: {
    ...useAlignProps,
    vertical: Boolean
  },
  setup(props4, { slots }) {
    const alignClass = use_align_default(props4);
    const classes = computed(
      () => `q-card__actions ${alignClass.value} q-card__actions--${props4.vertical === true ? "vert column" : "horiz row"}`
    );
    return () => h("div", { class: classes.value }, hSlot(slots.default));
  }
});
var modifiersAll = {
  left: true,
  right: true,
  up: true,
  down: true,
  horizontal: true,
  vertical: true
};
var directionList = Object.keys(modifiersAll);
modifiersAll.all = true;
function getModifierDirections(mod2) {
  const dir = {};
  for (const direction of directionList) {
    if (mod2[direction] === true) {
      dir[direction] = true;
    }
  }
  if (Object.keys(dir).length === 0) {
    return modifiersAll;
  }
  if (dir.horizontal === true) {
    dir.left = dir.right = true;
  } else if (dir.left === true && dir.right === true) {
    dir.horizontal = true;
  }
  if (dir.vertical === true) {
    dir.up = dir.down = true;
  } else if (dir.up === true && dir.down === true) {
    dir.vertical = true;
  }
  if (dir.horizontal === true && dir.vertical === true) {
    dir.all = true;
  }
  return dir;
}
var avoidNodeNamesList = ["INPUT", "TEXTAREA"];
function shouldStart(evt, ctx) {
  return ctx.event === void 0 && evt.target !== void 0 && evt.target.draggable !== true && typeof ctx.handler === "function" && avoidNodeNamesList.includes(evt.target.nodeName.toUpperCase()) === false && (evt.qClonedBy === void 0 || evt.qClonedBy.indexOf(ctx.uid) === -1);
}
function parseArg(arg) {
  const data = [0.06, 6, 50];
  if (typeof arg === "string" && arg.length) {
    arg.split(":").forEach((val, index2) => {
      const v = parseFloat(val);
      v && (data[index2] = v);
    });
  }
  return data;
}
var TouchSwipe_default = createDirective(
  {
    name: "touch-swipe",
    beforeMount(el, { value: value2, arg, modifiers }) {
      if (modifiers.mouse !== true && client.has.touch !== true) return;
      const mouseCapture = modifiers.mouseCapture === true ? "Capture" : "";
      const ctx = {
        handler: value2,
        sensitivity: parseArg(arg),
        direction: getModifierDirections(modifiers),
        noop,
        mouseStart(evt) {
          if (shouldStart(evt, ctx) && leftClick(evt)) {
            addEvt(ctx, "temp", [
              [document, "mousemove", "move", `notPassive${mouseCapture}`],
              [document, "mouseup", "end", "notPassiveCapture"]
            ]);
            ctx.start(evt, true);
          }
        },
        touchStart(evt) {
          if (shouldStart(evt, ctx)) {
            const target2 = evt.target;
            addEvt(ctx, "temp", [
              [target2, "touchmove", "move", "notPassiveCapture"],
              [target2, "touchcancel", "end", "notPassiveCapture"],
              [target2, "touchend", "end", "notPassiveCapture"]
            ]);
            ctx.start(evt);
          }
        },
        start(evt, mouseEvent) {
          client.is.firefox === true && preventDraggable(el, true);
          const pos = position(evt);
          ctx.event = {
            x: pos.left,
            y: pos.top,
            time: Date.now(),
            mouse: mouseEvent === true,
            dir: false
          };
        },
        move(evt) {
          if (ctx.event === void 0) return;
          if (ctx.event.dir !== false) {
            stopAndPrevent(evt);
            return;
          }
          const time = Date.now() - ctx.event.time;
          if (time === 0) return;
          const pos = position(evt), distX = pos.left - ctx.event.x, absX = Math.abs(distX), distY = pos.top - ctx.event.y, absY = Math.abs(distY);
          if (ctx.event.mouse !== true) {
            if (absX < ctx.sensitivity[1] && absY < ctx.sensitivity[1]) {
              ctx.end(evt);
              return;
            }
          } else if (window.getSelection().toString() !== "") {
            ctx.end(evt);
            return;
          } else if (absX < ctx.sensitivity[2] && absY < ctx.sensitivity[2]) {
            return;
          }
          const velX = absX / time, velY = absY / time;
          if (ctx.direction.vertical === true && absX < absY && absX < 100 && velY > ctx.sensitivity[0]) {
            ctx.event.dir = distY < 0 ? "up" : "down";
          }
          if (ctx.direction.horizontal === true && absX > absY && absY < 100 && velX > ctx.sensitivity[0]) {
            ctx.event.dir = distX < 0 ? "left" : "right";
          }
          if (ctx.direction.up === true && absX < absY && distY < 0 && absX < 100 && velY > ctx.sensitivity[0]) {
            ctx.event.dir = "up";
          }
          if (ctx.direction.down === true && absX < absY && distY > 0 && absX < 100 && velY > ctx.sensitivity[0]) {
            ctx.event.dir = "down";
          }
          if (ctx.direction.left === true && absX > absY && distX < 0 && absY < 100 && velX > ctx.sensitivity[0]) {
            ctx.event.dir = "left";
          }
          if (ctx.direction.right === true && absX > absY && distX > 0 && absY < 100 && velX > ctx.sensitivity[0]) {
            ctx.event.dir = "right";
          }
          if (ctx.event.dir !== false) {
            stopAndPrevent(evt);
            if (ctx.event.mouse === true) {
              document.body.classList.add("no-pointer-events--children");
              document.body.classList.add("non-selectable");
              clearSelection();
              ctx.styleCleanup = (withDelay) => {
                ctx.styleCleanup = void 0;
                document.body.classList.remove("non-selectable");
                const remove2 = () => {
                  document.body.classList.remove("no-pointer-events--children");
                };
                if (withDelay === true) {
                  setTimeout(remove2, 50);
                } else {
                  remove2();
                }
              };
            }
            ctx.handler({
              evt,
              touch: ctx.event.mouse !== true,
              mouse: ctx.event.mouse,
              direction: ctx.event.dir,
              duration: time,
              distance: {
                x: absX,
                y: absY
              }
            });
          } else {
            ctx.end(evt);
          }
        },
        end(evt) {
          var _a;
          if (ctx.event === void 0) return;
          cleanEvt(ctx, "temp");
          client.is.firefox === true && preventDraggable(el, false);
          (_a = ctx.styleCleanup) == null ? void 0 : _a.call(ctx, true);
          if (evt !== void 0 && ctx.event.dir !== false) stopAndPrevent(evt);
          ctx.event = void 0;
        }
      };
      el.__qtouchswipe = ctx;
      if (modifiers.mouse === true) {
        const capture = modifiers.mouseCapture === true || modifiers.mousecapture === true ? "Capture" : "";
        addEvt(ctx, "main", [
          [el, "mousedown", "mouseStart", `passive${capture}`]
        ]);
      }
      client.has.touch === true && addEvt(ctx, "main", [
        [el, "touchstart", "touchStart", `passive${modifiers.capture === true ? "Capture" : ""}`],
        [el, "touchmove", "noop", "notPassiveCapture"]
        // cannot be passive (ex: iOS scroll)
      ]);
    },
    updated(el, bindings) {
      const ctx = el.__qtouchswipe;
      if (ctx !== void 0) {
        if (bindings.oldValue !== bindings.value) {
          typeof bindings.value !== "function" && ctx.end();
          ctx.handler = bindings.value;
        }
        ctx.direction = getModifierDirections(bindings.modifiers);
      }
    },
    beforeUnmount(el) {
      var _a;
      const ctx = el.__qtouchswipe;
      if (ctx !== void 0) {
        cleanEvt(ctx, "main");
        cleanEvt(ctx, "temp");
        client.is.firefox === true && preventDraggable(el, false);
        (_a = ctx.styleCleanup) == null ? void 0 : _a.call(ctx);
        delete el.__qtouchswipe;
      }
    }
  }
);
function use_render_cache_default() {
  let cache = /* @__PURE__ */ Object.create(null);
  return {
    getCache: (key, defaultValue) => cache[key] === void 0 ? cache[key] = typeof defaultValue === "function" ? defaultValue() : defaultValue : cache[key],
    setCache(key, obj) {
      cache[key] = obj;
    },
    hasCache(key) {
      return Object.hasOwnProperty.call(cache, key);
    },
    clearCache(key) {
      if (key !== void 0) {
        delete cache[key];
      } else {
        cache = /* @__PURE__ */ Object.create(null);
      }
    }
  };
}
var usePanelChildProps = {
  name: { required: true },
  disable: Boolean
};
var PanelWrapper = {
  setup(_, { slots }) {
    return () => h("div", {
      class: "q-panel scroll",
      role: "tabpanel"
    }, hSlot(slots.default));
  }
};
var usePanelProps = {
  modelValue: {
    required: true
  },
  animated: Boolean,
  infinite: Boolean,
  swipeable: Boolean,
  vertical: Boolean,
  transitionPrev: String,
  transitionNext: String,
  transitionDuration: {
    type: [String, Number],
    default: 300
  },
  keepAlive: Boolean,
  keepAliveInclude: [String, Array, RegExp],
  keepAliveExclude: [String, Array, RegExp],
  keepAliveMax: Number
};
var usePanelEmits = ["update:modelValue", "beforeTransition", "transition"];
function use_panel_default() {
  const { props: props4, emit, proxy } = getCurrentInstance();
  const { getCache } = use_render_cache_default();
  const { registerTimeout } = use_timeout_default();
  let panels, forcedPanelTransition;
  const panelTransition = ref$1(null);
  const panelIndex = { value: null };
  function onSwipe(evt) {
    const dir = props4.vertical === true ? "up" : "left";
    goToPanelByOffset((proxy.$q.lang.rtl === true ? -1 : 1) * (evt.direction === dir ? 1 : -1));
  }
  const panelDirectives = computed(() => {
    return [[
      TouchSwipe_default,
      onSwipe,
      void 0,
      {
        horizontal: props4.vertical !== true,
        vertical: props4.vertical,
        mouse: true
      }
    ]];
  });
  const transitionPrev = computed(
    () => props4.transitionPrev || `slide-${props4.vertical === true ? "down" : "right"}`
  );
  const transitionNext = computed(
    () => props4.transitionNext || `slide-${props4.vertical === true ? "up" : "left"}`
  );
  const transitionStyle = computed(
    () => `--q-transition-duration: ${props4.transitionDuration}ms`
  );
  const contentKey = computed(() => typeof props4.modelValue === "string" || typeof props4.modelValue === "number" ? props4.modelValue : String(props4.modelValue));
  const keepAliveProps = computed(() => ({
    include: props4.keepAliveInclude,
    exclude: props4.keepAliveExclude,
    max: props4.keepAliveMax
  }));
  const needsUniqueKeepAliveWrapper = computed(
    () => props4.keepAliveInclude !== void 0 || props4.keepAliveExclude !== void 0
  );
  watch(() => props4.modelValue, (newVal, oldVal) => {
    const index2 = isValidPanelName(newVal) === true ? getPanelIndex(newVal) : -1;
    if (forcedPanelTransition !== true) {
      updatePanelTransition(
        index2 === -1 ? 0 : index2 < getPanelIndex(oldVal) ? -1 : 1
      );
    }
    if (panelIndex.value !== index2) {
      panelIndex.value = index2;
      emit("beforeTransition", newVal, oldVal);
      registerTimeout(() => {
        emit("transition", newVal, oldVal);
      }, props4.transitionDuration);
    }
  });
  function nextPanel() {
    goToPanelByOffset(1);
  }
  function previousPanel() {
    goToPanelByOffset(-1);
  }
  function goToPanel(name2) {
    emit("update:modelValue", name2);
  }
  function isValidPanelName(name2) {
    return name2 !== void 0 && name2 !== null && name2 !== "";
  }
  function getPanelIndex(name2) {
    return panels.findIndex((panel) => {
      return panel.props.name === name2 && panel.props.disable !== "" && panel.props.disable !== true;
    });
  }
  function getEnabledPanels() {
    return panels.filter((panel) => {
      return panel.props.disable !== "" && panel.props.disable !== true;
    });
  }
  function updatePanelTransition(direction) {
    const val = direction !== 0 && props4.animated === true && panelIndex.value !== -1 ? "q-transition--" + (direction === -1 ? transitionPrev.value : transitionNext.value) : null;
    if (panelTransition.value !== val) {
      panelTransition.value = val;
    }
  }
  function goToPanelByOffset(direction, startIndex = panelIndex.value) {
    let index2 = startIndex + direction;
    while (index2 !== -1 && index2 < panels.length) {
      const opt = panels[index2];
      if (opt !== void 0 && opt.props.disable !== "" && opt.props.disable !== true) {
        updatePanelTransition(direction);
        forcedPanelTransition = true;
        emit("update:modelValue", opt.props.name);
        setTimeout(() => {
          forcedPanelTransition = false;
        });
        return;
      }
      index2 += direction;
    }
    if (props4.infinite === true && panels.length !== 0 && startIndex !== -1 && startIndex !== panels.length) {
      goToPanelByOffset(direction, direction === -1 ? panels.length : -1);
    }
  }
  function updatePanelIndex() {
    const index2 = getPanelIndex(props4.modelValue);
    if (panelIndex.value !== index2) {
      panelIndex.value = index2;
    }
    return true;
  }
  function getPanelContentChild() {
    const panel = isValidPanelName(props4.modelValue) === true && updatePanelIndex() && panels[panelIndex.value];
    return props4.keepAlive === true ? [
      h(KeepAlive, keepAliveProps.value, [
        h(
          needsUniqueKeepAliveWrapper.value === true ? getCache(contentKey.value, () => ({ ...PanelWrapper, name: contentKey.value })) : PanelWrapper,
          { key: contentKey.value, style: transitionStyle.value },
          () => panel
        )
      ])
    ] : [
      h("div", {
        class: "q-panel scroll",
        style: transitionStyle.value,
        key: contentKey.value,
        role: "tabpanel"
      }, [panel])
    ];
  }
  function getPanelContent() {
    if (panels.length === 0) return;
    return props4.animated === true ? [h(Transition, { name: panelTransition.value }, getPanelContentChild)] : getPanelContentChild();
  }
  function updatePanelsList(slots) {
    panels = getNormalizedVNodes(
      hSlot(slots.default, [])
    ).filter(
      (panel) => panel.props !== null && panel.props.slot === void 0 && isValidPanelName(panel.props.name) === true
    );
    return panels.length;
  }
  function getPanels() {
    return panels;
  }
  Object.assign(proxy, {
    next: nextPanel,
    previous: previousPanel,
    goTo: goToPanel
  });
  return {
    panelIndex,
    panelDirectives,
    updatePanelsList,
    updatePanelIndex,
    getPanelContent,
    getEnabledPanels,
    getPanels,
    isValidPanelName,
    keepAliveProps,
    needsUniqueKeepAliveWrapper,
    goToPanelByOffset,
    goToPanel,
    nextPanel,
    previousPanel
  };
}
var counter = 0;
var useFullscreenProps = {
  fullscreen: Boolean,
  noRouteFullscreenExit: Boolean
};
var useFullscreenEmits = ["update:fullscreen", "fullscreen"];
function use_fullscreen_default() {
  const vm2 = getCurrentInstance();
  const { props: props4, emit, proxy } = vm2;
  let fullscreenFillerNode, container;
  const inFullscreen = ref$1(false);
  vmHasRouter(vm2) === true && watch(() => proxy.$route.fullPath, () => {
    props4.noRouteFullscreenExit !== true && exitFullscreen();
  });
  watch(() => props4.fullscreen, (v) => {
    if (inFullscreen.value !== v) {
      toggleFullscreen();
    }
  });
  watch(inFullscreen, (v) => {
    emit("update:fullscreen", v);
    emit("fullscreen", v);
  });
  function toggleFullscreen() {
    if (inFullscreen.value === true) {
      exitFullscreen();
    } else {
      setFullscreen();
    }
  }
  function setFullscreen() {
    if (inFullscreen.value === true) return;
    inFullscreen.value = true;
    container = proxy.$el.parentNode;
    container.replaceChild(fullscreenFillerNode, proxy.$el);
    document.body.appendChild(proxy.$el);
    counter++;
    if (counter === 1) {
      document.body.classList.add("q-body--fullscreen-mixin");
    }
  }
  function exitFullscreen() {
    if (inFullscreen.value !== true) return;
    container.replaceChild(proxy.$el, fullscreenFillerNode);
    inFullscreen.value = false;
    counter = Math.max(0, counter - 1);
    if (counter === 0) {
      document.body.classList.remove("q-body--fullscreen-mixin");
      if (proxy.$el.scrollIntoView !== void 0) {
        setTimeout(() => {
          proxy.$el.scrollIntoView();
        });
      }
    }
  }
  onBeforeMount(() => {
    fullscreenFillerNode = document.createElement("span");
  });
  onMounted(() => {
    props4.fullscreen === true && setFullscreen();
  });
  onBeforeUnmount(exitFullscreen);
  Object.assign(proxy, {
    toggleFullscreen,
    setFullscreen,
    exitFullscreen
  });
  return {
    inFullscreen,
    toggleFullscreen
  };
}
var navigationPositionOptions = ["top", "right", "bottom", "left"];
var controlTypeOptions = ["regular", "flat", "outline", "push", "unelevated"];
createComponent({
  name: "QCarousel",
  props: {
    ...useDarkProps,
    ...usePanelProps,
    ...useFullscreenProps,
    transitionPrev: {
      // usePanelParentProps override
      type: String,
      default: "fade"
    },
    transitionNext: {
      // usePanelParentProps override
      type: String,
      default: "fade"
    },
    height: String,
    padding: Boolean,
    controlColor: String,
    controlTextColor: String,
    controlType: {
      type: String,
      validator: (v) => controlTypeOptions.includes(v),
      default: "flat"
    },
    autoplay: [Number, Boolean],
    arrows: Boolean,
    prevIcon: String,
    nextIcon: String,
    navigation: Boolean,
    navigationPosition: {
      type: String,
      validator: (v) => navigationPositionOptions.includes(v)
    },
    navigationIcon: String,
    navigationActiveIcon: String,
    thumbnails: Boolean
  },
  emits: [
    ...useFullscreenEmits,
    ...usePanelEmits
  ],
  setup(props4, { slots }) {
    const { proxy: { $q } } = getCurrentInstance();
    const isDark = use_dark_default(props4, $q);
    let timer2 = null, panelsLen;
    const {
      updatePanelsList,
      getPanelContent,
      panelDirectives,
      goToPanel,
      previousPanel,
      nextPanel,
      getEnabledPanels,
      panelIndex
    } = use_panel_default();
    const { inFullscreen } = use_fullscreen_default();
    const style2 = computed(() => inFullscreen.value !== true && props4.height !== void 0 ? { height: props4.height } : {});
    const direction = computed(() => props4.vertical === true ? "vertical" : "horizontal");
    const navigationPosition = computed(
      () => props4.navigationPosition || (props4.vertical === true ? "right" : "bottom")
    );
    const classes = computed(
      () => `q-carousel q-panel-parent q-carousel--with${props4.padding === true ? "" : "out"}-padding` + (inFullscreen.value === true ? " fullscreen" : "") + (isDark.value === true ? " q-carousel--dark q-dark" : "") + (props4.arrows === true ? ` q-carousel--arrows-${direction.value}` : "") + (props4.navigation === true ? ` q-carousel--navigation-${navigationPosition.value}` : "")
    );
    const arrowIcons = computed(() => {
      const ico = [
        props4.prevIcon || $q.iconSet.carousel[props4.vertical === true ? "up" : "left"],
        props4.nextIcon || $q.iconSet.carousel[props4.vertical === true ? "down" : "right"]
      ];
      return props4.vertical === false && $q.lang.rtl === true ? ico.reverse() : ico;
    });
    const navIcon = computed(() => props4.navigationIcon || $q.iconSet.carousel.navigationIcon);
    const navActiveIcon = computed(() => props4.navigationActiveIcon || navIcon.value);
    const controlProps = computed(() => ({
      color: props4.controlColor,
      textColor: props4.controlTextColor,
      round: true,
      [props4.controlType]: true,
      dense: true
    }));
    watch(() => props4.modelValue, () => {
      if (props4.autoplay) {
        startTimer();
      }
    });
    watch(() => props4.autoplay, (val) => {
      if (val) {
        startTimer();
      } else if (timer2 !== null) {
        clearTimeout(timer2);
        timer2 = null;
      }
    });
    function startTimer() {
      const duration2 = isNumber(props4.autoplay) === true ? Math.abs(props4.autoplay) : 5e3;
      timer2 !== null && clearTimeout(timer2);
      timer2 = setTimeout(() => {
        timer2 = null;
        if (duration2 >= 0) {
          nextPanel();
        } else {
          previousPanel();
        }
      }, duration2);
    }
    onMounted(() => {
      props4.autoplay && startTimer();
    });
    onBeforeUnmount(() => {
      timer2 !== null && clearTimeout(timer2);
    });
    function getNavigationContainer(type2, mapping) {
      return h("div", {
        class: `q-carousel__control q-carousel__navigation no-wrap absolute flex q-carousel__navigation--${type2} q-carousel__navigation--${navigationPosition.value}` + (props4.controlColor !== void 0 ? ` text-${props4.controlColor}` : "")
      }, [
        h("div", {
          class: "q-carousel__navigation-inner flex flex-center no-wrap"
        }, getEnabledPanels().map(mapping))
      ]);
    }
    function getContent() {
      const node = [];
      if (props4.navigation === true) {
        const fn = slots["navigation-icon"] !== void 0 ? slots["navigation-icon"] : (opts) => h(QBtn_default, {
          key: "nav" + opts.name,
          class: `q-carousel__navigation-icon q-carousel__navigation-icon--${opts.active === true ? "" : "in"}active`,
          ...opts.btnProps,
          onClick: opts.onClick
        });
        const maxIndex = panelsLen - 1;
        node.push(
          getNavigationContainer("buttons", (panel, index2) => {
            const name2 = panel.props.name;
            const active = panelIndex.value === index2;
            return fn({
              index: index2,
              maxIndex,
              name: name2,
              active,
              btnProps: {
                icon: active === true ? navActiveIcon.value : navIcon.value,
                size: "sm",
                ...controlProps.value
              },
              onClick: () => {
                goToPanel(name2);
              }
            });
          })
        );
      } else if (props4.thumbnails === true) {
        const color2 = props4.controlColor !== void 0 ? ` text-${props4.controlColor}` : "";
        node.push(getNavigationContainer("thumbnails", (panel) => {
          const slide = panel.props;
          return h("img", {
            key: "tmb#" + slide.name,
            class: `q-carousel__thumbnail q-carousel__thumbnail--${slide.name === props4.modelValue ? "" : "in"}active` + color2,
            src: slide.imgSrc || slide["img-src"],
            onClick: () => {
              goToPanel(slide.name);
            }
          });
        }));
      }
      if (props4.arrows === true && panelIndex.value >= 0) {
        if (props4.infinite === true || panelIndex.value > 0) {
          node.push(
            h("div", {
              key: "prev",
              class: `q-carousel__control q-carousel__arrow q-carousel__prev-arrow q-carousel__prev-arrow--${direction.value} absolute flex flex-center`
            }, [
              h(QBtn_default, {
                icon: arrowIcons.value[0],
                ...controlProps.value,
                onClick: previousPanel
              })
            ])
          );
        }
        if (props4.infinite === true || panelIndex.value < panelsLen - 1) {
          node.push(
            h("div", {
              key: "next",
              class: `q-carousel__control q-carousel__arrow q-carousel__next-arrow q-carousel__next-arrow--${direction.value} absolute flex flex-center`
            }, [
              h(QBtn_default, {
                icon: arrowIcons.value[1],
                ...controlProps.value,
                onClick: nextPanel
              })
            ])
          );
        }
      }
      return hMergeSlot(slots.control, node);
    }
    return () => {
      panelsLen = updatePanelsList(slots);
      return h("div", {
        class: classes.value,
        style: style2.value
      }, [
        hDir(
          "div",
          { class: "q-carousel__slides-container" },
          getPanelContent(),
          "sl-cont",
          props4.swipeable,
          () => panelDirectives.value
        )
      ].concat(getContent()));
    };
  }
});
createComponent({
  name: "QCarouselSlide",
  props: {
    ...usePanelChildProps,
    imgSrc: String
  },
  setup(props4, { slots }) {
    const style2 = computed(() => props4.imgSrc ? { backgroundImage: `url("${props4.imgSrc}")` } : {});
    return () => h("div", {
      class: "q-carousel__slide",
      style: style2.value
    }, hSlot(slots.default));
  }
});
createComponent({
  name: "QCarouselControl",
  props: {
    position: {
      type: String,
      default: "bottom-right",
      validator: (v) => [
        "top-right",
        "top-left",
        "bottom-right",
        "bottom-left",
        "top",
        "right",
        "bottom",
        "left"
      ].includes(v)
    },
    offset: {
      type: Array,
      default: () => [18, 18],
      validator: (v) => v.length === 2
    }
  },
  setup(props4, { slots }) {
    const classes = computed(() => `q-carousel__control absolute absolute-${props4.position}`);
    const style2 = computed(() => ({
      margin: `${props4.offset[1]}px ${props4.offset[0]}px`
    }));
    return () => h("div", {
      class: classes.value,
      style: style2.value
    }, hSlot(slots.default));
  }
});
createComponent({
  name: "QChatMessage",
  props: {
    sent: Boolean,
    label: String,
    bgColor: String,
    textColor: String,
    name: String,
    avatar: String,
    text: Array,
    stamp: String,
    size: String,
    labelHtml: Boolean,
    nameHtml: Boolean,
    textHtml: Boolean,
    stampHtml: Boolean
  },
  setup(props4, { slots }) {
    const op = computed(() => props4.sent === true ? "sent" : "received");
    const textClass = computed(
      () => `q-message-text-content q-message-text-content--${op.value}` + (props4.textColor !== void 0 ? ` text-${props4.textColor}` : "")
    );
    const messageClass = computed(
      () => `q-message-text q-message-text--${op.value}` + (props4.bgColor !== void 0 ? ` text-${props4.bgColor}` : "")
    );
    const containerClass = computed(
      () => "q-message-container row items-end no-wrap" + (props4.sent === true ? " reverse" : "")
    );
    const sizeClass = computed(() => props4.size !== void 0 ? `col-${props4.size}` : "");
    const domProps = computed(() => ({
      msg: props4.textHtml === true ? "innerHTML" : "textContent",
      stamp: props4.stampHtml === true ? "innerHTML" : "textContent",
      name: props4.nameHtml === true ? "innerHTML" : "textContent",
      label: props4.labelHtml === true ? "innerHTML" : "textContent"
    }));
    function wrapStamp(node) {
      if (slots.stamp !== void 0) {
        return [node, h("div", { class: "q-message-stamp" }, slots.stamp())];
      }
      if (props4.stamp) {
        return [
          node,
          h("div", {
            class: "q-message-stamp",
            [domProps.value.stamp]: props4.stamp
          })
        ];
      }
      return [node];
    }
    function getText(contentList, withSlots) {
      const content = withSlots === true ? contentList.length > 1 ? (text2) => text2 : (text2) => h("div", [text2]) : (text2) => h("div", { [domProps.value.msg]: text2 });
      return contentList.map((msg, index2) => h("div", {
        key: index2,
        class: messageClass.value
      }, [
        h("div", { class: textClass.value }, wrapStamp(content(msg)))
      ]));
    }
    return () => {
      const container = [];
      if (slots.avatar !== void 0) {
        container.push(slots.avatar());
      } else if (props4.avatar !== void 0) {
        container.push(
          h("img", {
            class: `q-message-avatar q-message-avatar--${op.value}`,
            src: props4.avatar,
            "aria-hidden": "true"
          })
        );
      }
      const msg = [];
      if (slots.name !== void 0) {
        msg.push(
          h("div", { class: `q-message-name q-message-name--${op.value}` }, slots.name())
        );
      } else if (props4.name !== void 0) {
        msg.push(
          h("div", {
            class: `q-message-name q-message-name--${op.value}`,
            [domProps.value.name]: props4.name
          })
        );
      }
      if (slots.default !== void 0) {
        msg.push(
          getText(
            getNormalizedVNodes(slots.default()),
            true
          )
        );
      } else if (props4.text !== void 0) {
        msg.push(getText(props4.text));
      }
      container.push(
        h("div", { class: sizeClass.value }, msg)
      );
      const child = [];
      if (slots.label !== void 0) {
        child.push(
          h("div", { class: "q-message-label" }, slots.label())
        );
      } else if (props4.label !== void 0) {
        child.push(
          h("div", {
            class: "q-message-label",
            [domProps.value.label]: props4.label
          })
        );
      }
      child.push(
        h("div", { class: containerClass.value }, container)
      );
      return h("div", {
        class: `q-message q-message-${op.value}`
      }, child);
    };
  }
});
function use_refocus_target_default(props4, rootRef) {
  const refocusRef = ref$1(null);
  const refocusTargetEl = computed(() => {
    if (props4.disable === true) {
      return null;
    }
    return h("span", {
      ref: refocusRef,
      class: "no-outline",
      tabindex: -1
    });
  });
  function refocusTarget(e3) {
    const root2 = rootRef.value;
    if ((e3 == null ? void 0 : e3.qAvoidFocus) === true) return;
    if ((e3 == null ? void 0 : e3.type.indexOf("key")) === 0) {
      if (document.activeElement !== root2 && (root2 == null ? void 0 : root2.contains(document.activeElement)) === true) {
        root2.focus();
      }
    } else if (refocusRef.value !== null && (e3 === void 0 || (root2 == null ? void 0 : root2.contains(e3.target)) === true)) {
      refocusRef.value.focus();
    }
  }
  return {
    refocusTargetEl,
    refocusTarget
  };
}
var option_sizes_default = {
  xs: 30,
  sm: 35,
  md: 40,
  lg: 50,
  xl: 60
};
var useCheckboxProps = {
  ...useDarkProps,
  ...useSizeProps,
  ...useFormProps,
  modelValue: {
    required: true,
    default: null
  },
  val: {},
  trueValue: { default: true },
  falseValue: { default: false },
  indeterminateValue: { default: null },
  checkedIcon: String,
  uncheckedIcon: String,
  indeterminateIcon: String,
  toggleOrder: {
    type: String,
    validator: (v) => v === "tf" || v === "ft"
  },
  toggleIndeterminate: Boolean,
  label: String,
  leftLabel: Boolean,
  color: String,
  keepColor: Boolean,
  dense: Boolean,
  disable: Boolean,
  tabindex: [String, Number]
};
var useCheckboxEmits = ["update:modelValue"];
function use_checkbox_default(type2, getInner) {
  const { props: props4, slots, emit, proxy } = getCurrentInstance();
  const { $q } = proxy;
  const isDark = use_dark_default(props4, $q);
  const rootRef = ref$1(null);
  const { refocusTargetEl, refocusTarget } = use_refocus_target_default(props4, rootRef);
  const sizeStyle = use_size_default(props4, option_sizes_default);
  const modelIsArray = computed(
    () => props4.val !== void 0 && Array.isArray(props4.modelValue)
  );
  const index2 = computed(() => {
    const val = toRaw(props4.val);
    return modelIsArray.value === true ? props4.modelValue.findIndex((opt) => toRaw(opt) === val) : -1;
  });
  const isTrue = computed(() => modelIsArray.value === true ? index2.value !== -1 : toRaw(props4.modelValue) === toRaw(props4.trueValue));
  const isFalse = computed(() => modelIsArray.value === true ? index2.value === -1 : toRaw(props4.modelValue) === toRaw(props4.falseValue));
  const isIndeterminate = computed(
    () => isTrue.value === false && isFalse.value === false
  );
  const tabindex = computed(() => props4.disable === true ? -1 : props4.tabindex || 0);
  const classes = computed(
    () => `q-${type2} cursor-pointer no-outline row inline no-wrap items-center` + (props4.disable === true ? " disabled" : "") + (isDark.value === true ? ` q-${type2}--dark` : "") + (props4.dense === true ? ` q-${type2}--dense` : "") + (props4.leftLabel === true ? " reverse" : "")
  );
  const innerClass = computed(() => {
    const state2 = isTrue.value === true ? "truthy" : isFalse.value === true ? "falsy" : "indet";
    const color2 = props4.color !== void 0 && (props4.keepColor === true || (type2 === "toggle" ? isTrue.value === true : isFalse.value !== true)) ? ` text-${props4.color}` : "";
    return `q-${type2}__inner relative-position non-selectable q-${type2}__inner--${state2}${color2}`;
  });
  const formAttrs = computed(() => {
    const prop = { type: "checkbox" };
    props4.name !== void 0 && Object.assign(prop, {
      // see https://vuejs.org/guide/extras/render-function.html#creating-vnodes (.prop)
      ".checked": isTrue.value,
      "^checked": isTrue.value === true ? "checked" : void 0,
      name: props4.name,
      value: modelIsArray.value === true ? props4.val : props4.trueValue
    });
    return prop;
  });
  const injectFormInput = useFormInject(formAttrs);
  const attributes = computed(() => {
    const attrs = {
      tabindex: tabindex.value,
      role: type2 === "toggle" ? "switch" : "checkbox",
      "aria-label": props4.label,
      "aria-checked": isIndeterminate.value === true ? "mixed" : isTrue.value === true ? "true" : "false"
    };
    if (props4.disable === true) {
      attrs["aria-disabled"] = "true";
    }
    return attrs;
  });
  function onClick(e3) {
    if (e3 !== void 0) {
      stopAndPrevent(e3);
      refocusTarget(e3);
    }
    if (props4.disable !== true) {
      emit("update:modelValue", getNextValue(), e3);
    }
  }
  function getNextValue() {
    if (modelIsArray.value === true) {
      if (isTrue.value === true) {
        const val = props4.modelValue.slice();
        val.splice(index2.value, 1);
        return val;
      }
      return props4.modelValue.concat([props4.val]);
    }
    if (isTrue.value === true) {
      if (props4.toggleOrder !== "ft" || props4.toggleIndeterminate === false) {
        return props4.falseValue;
      }
    } else if (isFalse.value === true) {
      if (props4.toggleOrder === "ft" || props4.toggleIndeterminate === false) {
        return props4.trueValue;
      }
    } else {
      return props4.toggleOrder !== "ft" ? props4.trueValue : props4.falseValue;
    }
    return props4.indeterminateValue;
  }
  function onKeydown2(e3) {
    if (e3.keyCode === 13 || e3.keyCode === 32) {
      stopAndPrevent(e3);
    }
  }
  function onKeyup2(e3) {
    if (e3.keyCode === 13 || e3.keyCode === 32) {
      onClick(e3);
    }
  }
  const getInnerContent = getInner(isTrue, isIndeterminate);
  Object.assign(proxy, { toggle: onClick });
  return () => {
    const inner = getInnerContent();
    props4.disable !== true && injectFormInput(
      inner,
      "unshift",
      ` q-${type2}__native absolute q-ma-none q-pa-none`
    );
    const child = [
      h("div", {
        class: innerClass.value,
        style: sizeStyle.value,
        "aria-hidden": "true"
      }, inner)
    ];
    if (refocusTargetEl.value !== null) {
      child.push(refocusTargetEl.value);
    }
    const label = props4.label !== void 0 ? hMergeSlot(slots.default, [props4.label]) : hSlot(slots.default);
    label !== void 0 && child.push(
      h("div", {
        class: `q-${type2}__label q-anchor--skip`
      }, label)
    );
    return h("div", {
      ref: rootRef,
      class: classes.value,
      ...attributes.value,
      onClick,
      onKeydown: onKeydown2,
      onKeyup: onKeyup2
    }, child);
  };
}
var createBgNode = () => h("div", {
  key: "svg",
  class: "q-checkbox__bg absolute"
}, [
  h("svg", {
    class: "q-checkbox__svg fit absolute-full",
    viewBox: "0 0 24 24"
  }, [
    h("path", {
      class: "q-checkbox__truthy",
      fill: "none",
      d: "M1.73,12.91 8.1,19.28 22.79,4.59"
    }),
    h("path", {
      class: "q-checkbox__indet",
      d: "M4,14H20V10H4"
    })
  ])
]);
var QCheckbox_default = createComponent({
  name: "QCheckbox",
  props: useCheckboxProps,
  emits: useCheckboxEmits,
  setup(props4) {
    const bgNode = createBgNode();
    function getInner(isTrue, isIndeterminate) {
      const icon = computed(
        () => (isTrue.value === true ? props4.checkedIcon : isIndeterminate.value === true ? props4.indeterminateIcon : props4.uncheckedIcon) || null
      );
      return () => icon.value !== null ? [
        h("div", {
          key: "icon",
          class: "q-checkbox__icon-container absolute-full flex flex-center no-wrap"
        }, [
          h(QIcon_default, {
            class: "q-checkbox__icon",
            name: icon.value
          })
        ])
      ] : [bgNode];
    }
    return use_checkbox_default("checkbox", getInner);
  }
});
var defaultSizes2 = {
  xs: 8,
  sm: 10,
  md: 14,
  lg: 20,
  xl: 24
};
var QChip_default = createComponent({
  name: "QChip",
  props: {
    ...useDarkProps,
    ...useSizeProps,
    dense: Boolean,
    icon: String,
    iconRight: String,
    iconRemove: String,
    iconSelected: String,
    label: [String, Number],
    color: String,
    textColor: String,
    modelValue: {
      type: Boolean,
      default: true
    },
    selected: {
      type: Boolean,
      default: null
    },
    square: Boolean,
    outline: Boolean,
    clickable: Boolean,
    removable: Boolean,
    removeAriaLabel: String,
    tabindex: [String, Number],
    disable: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    }
  },
  emits: ["update:modelValue", "update:selected", "remove", "click"],
  setup(props4, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const isDark = use_dark_default(props4, $q);
    const sizeStyle = use_size_default(props4, defaultSizes2);
    const hasLeftIcon = computed(() => props4.selected === true || props4.icon !== void 0);
    const leftIcon = computed(() => props4.selected === true ? props4.iconSelected || $q.iconSet.chip.selected : props4.icon);
    const removeIcon = computed(() => props4.iconRemove || $q.iconSet.chip.remove);
    const isClickable = computed(
      () => props4.disable === false && (props4.clickable === true || props4.selected !== null)
    );
    const classes = computed(() => {
      const text2 = props4.outline === true ? props4.color || props4.textColor : props4.textColor;
      return "q-chip row inline no-wrap items-center" + (props4.outline === false && props4.color !== void 0 ? ` bg-${props4.color}` : "") + (text2 ? ` text-${text2} q-chip--colored` : "") + (props4.disable === true ? " disabled" : "") + (props4.dense === true ? " q-chip--dense" : "") + (props4.outline === true ? " q-chip--outline" : "") + (props4.selected === true ? " q-chip--selected" : "") + (isClickable.value === true ? " q-chip--clickable cursor-pointer non-selectable q-hoverable" : "") + (props4.square === true ? " q-chip--square" : "") + (isDark.value === true ? " q-chip--dark q-dark" : "");
    });
    const attributes = computed(() => {
      const chip = props4.disable === true ? { tabindex: -1, "aria-disabled": "true" } : { tabindex: props4.tabindex || 0 };
      const remove2 = {
        ...chip,
        role: "button",
        "aria-hidden": "false",
        "aria-label": props4.removeAriaLabel || $q.lang.label.remove
      };
      return { chip, remove: remove2 };
    });
    function onKeyup2(e3) {
      e3.keyCode === 13 && onClick(e3);
    }
    function onClick(e3) {
      if (!props4.disable) {
        emit("update:selected", !props4.selected);
        emit("click", e3);
      }
    }
    function onRemove(e3) {
      if (e3.keyCode === void 0 || e3.keyCode === 13) {
        stopAndPrevent(e3);
        if (props4.disable === false) {
          emit("update:modelValue", false);
          emit("remove");
        }
      }
    }
    function getContent() {
      const child = [];
      isClickable.value === true && child.push(
        h("div", { class: "q-focus-helper" })
      );
      hasLeftIcon.value === true && child.push(
        h(QIcon_default, {
          class: "q-chip__icon q-chip__icon--left",
          name: leftIcon.value
        })
      );
      const label = props4.label !== void 0 ? [h("div", { class: "ellipsis" }, [props4.label])] : void 0;
      child.push(
        h("div", {
          class: "q-chip__content col row no-wrap items-center q-anchor--skip"
        }, hMergeSlotSafely(slots.default, label))
      );
      props4.iconRight && child.push(
        h(QIcon_default, {
          class: "q-chip__icon q-chip__icon--right",
          name: props4.iconRight
        })
      );
      props4.removable === true && child.push(
        h(QIcon_default, {
          class: "q-chip__icon q-chip__icon--remove cursor-pointer",
          name: removeIcon.value,
          ...attributes.value.remove,
          onClick: onRemove,
          onKeyup: onRemove
        })
      );
      return child;
    }
    return () => {
      if (props4.modelValue === false) return;
      const data = {
        class: classes.value,
        style: sizeStyle.value
      };
      isClickable.value === true && Object.assign(
        data,
        attributes.value.chip,
        { onClick, onKeyup: onKeyup2 }
      );
      return hDir(
        "div",
        data,
        getContent(),
        "ripple",
        props4.ripple !== false && props4.disable !== true,
        () => [[Ripple_default, props4.ripple]]
      );
    };
  }
});
var useCircularCommonProps = {
  ...useSizeProps,
  min: {
    type: Number,
    default: 0
  },
  max: {
    type: Number,
    default: 100
  },
  color: String,
  centerColor: String,
  trackColor: String,
  fontSize: String,
  rounded: Boolean,
  // ratio
  thickness: {
    type: Number,
    default: 0.2,
    validator: (v) => v >= 0 && v <= 1
  },
  angle: {
    type: Number,
    default: 0
  },
  showValue: Boolean,
  reverse: Boolean,
  instantFeedback: Boolean
};
var radius = 50;
var diameter = 2 * radius;
var circumference = diameter * Math.PI;
var strokeDashArray = Math.round(circumference * 1e3) / 1e3;
var QCircularProgress_default = createComponent({
  name: "QCircularProgress",
  props: {
    ...useCircularCommonProps,
    value: {
      type: Number,
      default: 0
    },
    animationSpeed: {
      type: [String, Number],
      default: 600
    },
    indeterminate: Boolean
  },
  setup(props4, { slots }) {
    const { proxy: { $q } } = getCurrentInstance();
    const sizeStyle = use_size_default(props4);
    const svgStyle = computed(() => {
      const angle2 = ($q.lang.rtl === true ? -1 : 1) * props4.angle;
      return {
        transform: props4.reverse !== ($q.lang.rtl === true) ? `scale3d(-1, 1, 1) rotate3d(0, 0, 1, ${-90 - angle2}deg)` : `rotate3d(0, 0, 1, ${angle2 - 90}deg)`
      };
    });
    const circleStyle = computed(() => props4.instantFeedback !== true && props4.indeterminate !== true ? { transition: `stroke-dashoffset ${props4.animationSpeed}ms ease 0s, stroke ${props4.animationSpeed}ms ease` } : "");
    const viewBox = computed(() => diameter / (1 - props4.thickness / 2));
    const viewBoxAttr = computed(
      () => `${viewBox.value / 2} ${viewBox.value / 2} ${viewBox.value} ${viewBox.value}`
    );
    const normalized = computed(() => between(props4.value, props4.min, props4.max));
    const range2 = computed(() => props4.max - props4.min);
    const strokeWidth = computed(() => props4.thickness / 2 * viewBox.value);
    const strokeDashOffset = computed(() => {
      const dashRatio = (props4.max - normalized.value) / range2.value;
      const dashGap = props4.rounded === true && normalized.value < props4.max && dashRatio < 0.25 ? strokeWidth.value / 2 * (1 - dashRatio / 0.25) : 0;
      return circumference * dashRatio + dashGap;
    });
    function getCircle({ thickness, offset: offset2, color: color2, cls, rounded }) {
      return h("circle", {
        class: "q-circular-progress__" + cls + (color2 !== void 0 ? ` text-${color2}` : ""),
        style: circleStyle.value,
        fill: "transparent",
        stroke: "currentColor",
        "stroke-width": thickness,
        "stroke-dasharray": strokeDashArray,
        "stroke-dashoffset": offset2,
        "stroke-linecap": rounded,
        cx: viewBox.value,
        cy: viewBox.value,
        r: radius
      });
    }
    return () => {
      const svgChild = [];
      props4.centerColor !== void 0 && props4.centerColor !== "transparent" && svgChild.push(
        h("circle", {
          class: `q-circular-progress__center text-${props4.centerColor}`,
          fill: "currentColor",
          r: radius - strokeWidth.value / 2,
          cx: viewBox.value,
          cy: viewBox.value
        })
      );
      props4.trackColor !== void 0 && props4.trackColor !== "transparent" && svgChild.push(
        getCircle({
          cls: "track",
          thickness: strokeWidth.value,
          offset: 0,
          color: props4.trackColor
        })
      );
      svgChild.push(
        getCircle({
          cls: "circle",
          thickness: strokeWidth.value,
          offset: strokeDashOffset.value,
          color: props4.color,
          rounded: props4.rounded === true ? "round" : void 0
        })
      );
      const child = [
        h("svg", {
          class: "q-circular-progress__svg",
          style: svgStyle.value,
          viewBox: viewBoxAttr.value,
          "aria-hidden": "true"
        }, svgChild)
      ];
      props4.showValue === true && child.push(
        h("div", {
          class: "q-circular-progress__text absolute-full row flex-center content-center",
          style: { fontSize: props4.fontSize }
        }, slots.default !== void 0 ? slots.default() : [h("div", normalized.value)])
      );
      return h("div", {
        class: `q-circular-progress q-circular-progress--${props4.indeterminate === true ? "in" : ""}determinate`,
        style: sizeStyle.value,
        role: "progressbar",
        "aria-valuemin": props4.min,
        "aria-valuemax": props4.max,
        "aria-valuenow": props4.indeterminate === true ? void 0 : normalized.value
      }, hMergeSlotSafely(slots.internal, child));
    };
  }
});
function getChanges(evt, ctx, isFinal) {
  const pos = position(evt);
  let dir, distX = pos.left - ctx.event.x, distY = pos.top - ctx.event.y, absX = Math.abs(distX), absY = Math.abs(distY);
  const direction = ctx.direction;
  if (direction.horizontal === true && direction.vertical !== true) {
    dir = distX < 0 ? "left" : "right";
  } else if (direction.horizontal !== true && direction.vertical === true) {
    dir = distY < 0 ? "up" : "down";
  } else if (direction.up === true && distY < 0) {
    dir = "up";
    if (absX > absY) {
      if (direction.left === true && distX < 0) {
        dir = "left";
      } else if (direction.right === true && distX > 0) {
        dir = "right";
      }
    }
  } else if (direction.down === true && distY > 0) {
    dir = "down";
    if (absX > absY) {
      if (direction.left === true && distX < 0) {
        dir = "left";
      } else if (direction.right === true && distX > 0) {
        dir = "right";
      }
    }
  } else if (direction.left === true && distX < 0) {
    dir = "left";
    if (absX < absY) {
      if (direction.up === true && distY < 0) {
        dir = "up";
      } else if (direction.down === true && distY > 0) {
        dir = "down";
      }
    }
  } else if (direction.right === true && distX > 0) {
    dir = "right";
    if (absX < absY) {
      if (direction.up === true && distY < 0) {
        dir = "up";
      } else if (direction.down === true && distY > 0) {
        dir = "down";
      }
    }
  }
  let synthetic = false;
  if (dir === void 0 && isFinal === false) {
    if (ctx.event.isFirst === true || ctx.event.lastDir === void 0) {
      return {};
    }
    dir = ctx.event.lastDir;
    synthetic = true;
    if (dir === "left" || dir === "right") {
      pos.left -= distX;
      absX = 0;
      distX = 0;
    } else {
      pos.top -= distY;
      absY = 0;
      distY = 0;
    }
  }
  return {
    synthetic,
    payload: {
      evt,
      touch: ctx.event.mouse !== true,
      mouse: ctx.event.mouse === true,
      position: pos,
      direction: dir,
      isFirst: ctx.event.isFirst,
      isFinal: isFinal === true,
      duration: Date.now() - ctx.event.time,
      distance: {
        x: absX,
        y: absY
      },
      offset: {
        x: distX,
        y: distY
      },
      delta: {
        x: pos.left - ctx.event.lastX,
        y: pos.top - ctx.event.lastY
      }
    }
  };
}
var uid = 0;
var TouchPan_default = createDirective(
  {
    name: "touch-pan",
    beforeMount(el, { value: value2, modifiers }) {
      if (modifiers.mouse !== true && client.has.touch !== true) return;
      function handleEvent(evt, mouseEvent) {
        if (modifiers.mouse === true && mouseEvent === true) {
          stopAndPrevent(evt);
        } else {
          modifiers.stop === true && stop(evt);
          modifiers.prevent === true && prevent(evt);
        }
      }
      const ctx = {
        uid: "qvtp_" + uid++,
        handler: value2,
        modifiers,
        direction: getModifierDirections(modifiers),
        noop,
        mouseStart(evt) {
          if (shouldStart(evt, ctx) && leftClick(evt)) {
            addEvt(ctx, "temp", [
              [document, "mousemove", "move", "notPassiveCapture"],
              [document, "mouseup", "end", "passiveCapture"]
            ]);
            ctx.start(evt, true);
          }
        },
        touchStart(evt) {
          if (shouldStart(evt, ctx)) {
            const target2 = evt.target;
            addEvt(ctx, "temp", [
              [target2, "touchmove", "move", "notPassiveCapture"],
              [target2, "touchcancel", "end", "passiveCapture"],
              [target2, "touchend", "end", "passiveCapture"]
            ]);
            ctx.start(evt);
          }
        },
        start(evt, mouseEvent) {
          client.is.firefox === true && preventDraggable(el, true);
          ctx.lastEvt = evt;
          if (mouseEvent === true || modifiers.stop === true) {
            if (ctx.direction.all !== true && (mouseEvent !== true || ctx.modifiers.mouseAllDir !== true && ctx.modifiers.mousealldir !== true)) {
              const clone2 = evt.type.indexOf("mouse") !== -1 ? new MouseEvent(evt.type, evt) : new TouchEvent(evt.type, evt);
              evt.defaultPrevented === true && prevent(clone2);
              evt.cancelBubble === true && stop(clone2);
              Object.assign(clone2, {
                qKeyEvent: evt.qKeyEvent,
                qClickOutside: evt.qClickOutside,
                qAnchorHandled: evt.qAnchorHandled,
                qClonedBy: evt.qClonedBy === void 0 ? [ctx.uid] : evt.qClonedBy.concat(ctx.uid)
              });
              ctx.initialEvent = {
                target: evt.target,
                event: clone2
              };
            }
            stop(evt);
          }
          const { left, top } = position(evt);
          ctx.event = {
            x: left,
            y: top,
            time: Date.now(),
            mouse: mouseEvent === true,
            detected: false,
            isFirst: true,
            isFinal: false,
            lastX: left,
            lastY: top
          };
        },
        move(evt) {
          if (ctx.event === void 0) return;
          const pos = position(evt), distX = pos.left - ctx.event.x, distY = pos.top - ctx.event.y;
          if (distX === 0 && distY === 0) return;
          ctx.lastEvt = evt;
          const isMouseEvt = ctx.event.mouse === true;
          const start = () => {
            handleEvent(evt, isMouseEvt);
            let cursor;
            if (modifiers.preserveCursor !== true && modifiers.preservecursor !== true) {
              cursor = document.documentElement.style.cursor || "";
              document.documentElement.style.cursor = "grabbing";
            }
            isMouseEvt === true && document.body.classList.add("no-pointer-events--children");
            document.body.classList.add("non-selectable");
            clearSelection();
            ctx.styleCleanup = (withDelayedFn) => {
              ctx.styleCleanup = void 0;
              if (cursor !== void 0) {
                document.documentElement.style.cursor = cursor;
              }
              document.body.classList.remove("non-selectable");
              if (isMouseEvt === true) {
                const remove2 = () => {
                  document.body.classList.remove("no-pointer-events--children");
                };
                if (withDelayedFn !== void 0) {
                  setTimeout(() => {
                    remove2();
                    withDelayedFn();
                  }, 50);
                } else {
                  remove2();
                }
              } else if (withDelayedFn !== void 0) {
                withDelayedFn();
              }
            };
          };
          if (ctx.event.detected === true) {
            ctx.event.isFirst !== true && handleEvent(evt, ctx.event.mouse);
            const { payload, synthetic } = getChanges(evt, ctx, false);
            if (payload !== void 0) {
              if (ctx.handler(payload) === false) {
                ctx.end(evt);
              } else {
                if (ctx.styleCleanup === void 0 && ctx.event.isFirst === true) {
                  start();
                }
                ctx.event.lastX = payload.position.left;
                ctx.event.lastY = payload.position.top;
                ctx.event.lastDir = synthetic === true ? void 0 : payload.direction;
                ctx.event.isFirst = false;
              }
            }
            return;
          }
          if (ctx.direction.all === true || isMouseEvt === true && (ctx.modifiers.mouseAllDir === true || ctx.modifiers.mousealldir === true)) {
            start();
            ctx.event.detected = true;
            ctx.move(evt);
            return;
          }
          const absX = Math.abs(distX), absY = Math.abs(distY);
          if (absX !== absY) {
            if (ctx.direction.horizontal === true && absX > absY || ctx.direction.vertical === true && absX < absY || ctx.direction.up === true && absX < absY && distY < 0 || ctx.direction.down === true && absX < absY && distY > 0 || ctx.direction.left === true && absX > absY && distX < 0 || ctx.direction.right === true && absX > absY && distX > 0) {
              ctx.event.detected = true;
              ctx.move(evt);
            } else {
              ctx.end(evt, true);
            }
          }
        },
        end(evt, abort) {
          var _a;
          if (ctx.event === void 0) return;
          cleanEvt(ctx, "temp");
          client.is.firefox === true && preventDraggable(el, false);
          if (abort === true) {
            (_a = ctx.styleCleanup) == null ? void 0 : _a.call(ctx);
            if (ctx.event.detected !== true && ctx.initialEvent !== void 0) {
              ctx.initialEvent.target.dispatchEvent(ctx.initialEvent.event);
            }
          } else if (ctx.event.detected === true) {
            ctx.event.isFirst === true && ctx.handler(getChanges(evt === void 0 ? ctx.lastEvt : evt, ctx).payload);
            const { payload } = getChanges(evt === void 0 ? ctx.lastEvt : evt, ctx, true);
            const fn = () => {
              ctx.handler(payload);
            };
            if (ctx.styleCleanup !== void 0) {
              ctx.styleCleanup(fn);
            } else {
              fn();
            }
          }
          ctx.event = void 0;
          ctx.initialEvent = void 0;
          ctx.lastEvt = void 0;
        }
      };
      el.__qtouchpan = ctx;
      if (modifiers.mouse === true) {
        const capture = modifiers.mouseCapture === true || modifiers.mousecapture === true ? "Capture" : "";
        addEvt(ctx, "main", [
          [el, "mousedown", "mouseStart", `passive${capture}`]
        ]);
      }
      client.has.touch === true && addEvt(ctx, "main", [
        [el, "touchstart", "touchStart", `passive${modifiers.capture === true ? "Capture" : ""}`],
        [el, "touchmove", "noop", "notPassiveCapture"]
        // cannot be passive (ex: iOS scroll)
      ]);
    },
    updated(el, bindings) {
      const ctx = el.__qtouchpan;
      if (ctx !== void 0) {
        if (bindings.oldValue !== bindings.value) {
          typeof value !== "function" && ctx.end();
          ctx.handler = bindings.value;
        }
        ctx.direction = getModifierDirections(bindings.modifiers);
      }
    },
    beforeUnmount(el) {
      var _a;
      const ctx = el.__qtouchpan;
      if (ctx !== void 0) {
        ctx.event !== void 0 && ctx.end();
        cleanEvt(ctx, "main");
        cleanEvt(ctx, "temp");
        client.is.firefox === true && preventDraggable(el, false);
        (_a = ctx.styleCleanup) == null ? void 0 : _a.call(ctx);
        delete el.__qtouchpan;
      }
    }
  }
);
var markerPrefixClass = "q-slider__marker-labels";
var defaultMarkerConvertFn = (v) => ({ value: v });
var defaultMarkerLabelRenderFn = ({ marker }) => h("div", {
  key: marker.value,
  style: marker.style,
  class: marker.classes
}, marker.label);
var keyCodes = [34, 37, 40, 33, 39, 38];
var useSliderProps = {
  ...useDarkProps,
  ...useFormProps,
  min: {
    type: Number,
    default: 0
  },
  max: {
    type: Number,
    default: 100
  },
  innerMin: Number,
  innerMax: Number,
  step: {
    type: Number,
    default: 1,
    validator: (v) => v >= 0
  },
  snap: Boolean,
  vertical: Boolean,
  reverse: Boolean,
  color: String,
  markerLabelsClass: String,
  label: Boolean,
  labelColor: String,
  labelTextColor: String,
  labelAlways: Boolean,
  switchLabelSide: Boolean,
  markers: [Boolean, Number],
  markerLabels: [Boolean, Array, Object, Function],
  switchMarkerLabelsSide: Boolean,
  trackImg: String,
  trackColor: String,
  innerTrackImg: String,
  innerTrackColor: String,
  selectionColor: String,
  selectionImg: String,
  thumbSize: {
    type: String,
    default: "20px"
  },
  trackSize: {
    type: String,
    default: "4px"
  },
  disable: Boolean,
  readonly: Boolean,
  dense: Boolean,
  tabindex: [String, Number],
  thumbColor: String,
  thumbPath: {
    type: String,
    default: "M 4, 10 a 6,6 0 1,0 12,0 a 6,6 0 1,0 -12,0"
  }
};
var useSliderEmits = ["pan", "update:modelValue", "change"];
function use_slider_default({ updateValue: updateValue2, updatePosition, getDragging, formAttrs }) {
  const { props: props4, emit, slots, proxy: { $q } } = getCurrentInstance();
  const isDark = use_dark_default(props4, $q);
  const injectFormInput = useFormInject(formAttrs);
  const active = ref$1(false);
  const preventFocus = ref$1(false);
  const focus = ref$1(false);
  const dragging = ref$1(false);
  const axis = computed(() => props4.vertical === true ? "--v" : "--h");
  const labelSide = computed(() => "-" + (props4.switchLabelSide === true ? "switched" : "standard"));
  const isReversed = computed(() => props4.vertical === true ? props4.reverse === true : props4.reverse !== ($q.lang.rtl === true));
  const innerMin = computed(() => isNaN(props4.innerMin) === true || props4.innerMin < props4.min ? props4.min : props4.innerMin);
  const innerMax = computed(() => isNaN(props4.innerMax) === true || props4.innerMax > props4.max ? props4.max : props4.innerMax);
  const editable = computed(() => props4.disable !== true && props4.readonly !== true && innerMin.value < innerMax.value);
  const roundValueFn = computed(() => {
    if (props4.step === 0) {
      return (v) => v;
    }
    const decimals = (String(props4.step).trim().split(".")[1] || "").length;
    return (v) => parseFloat(v.toFixed(decimals));
  });
  const keyStep = computed(() => props4.step === 0 ? 1 : props4.step);
  const tabindex = computed(() => editable.value === true ? props4.tabindex || 0 : -1);
  const trackLen = computed(() => props4.max - props4.min);
  const innerBarLen = computed(() => innerMax.value - innerMin.value);
  const innerMinRatio = computed(() => convertModelToRatio(innerMin.value));
  const innerMaxRatio = computed(() => convertModelToRatio(innerMax.value));
  const positionProp = computed(() => props4.vertical === true ? isReversed.value === true ? "bottom" : "top" : isReversed.value === true ? "right" : "left");
  const sizeProp = computed(() => props4.vertical === true ? "height" : "width");
  const thicknessProp = computed(() => props4.vertical === true ? "width" : "height");
  const orientation = computed(() => props4.vertical === true ? "vertical" : "horizontal");
  const attributes = computed(() => {
    const acc = {
      role: "slider",
      "aria-valuemin": innerMin.value,
      "aria-valuemax": innerMax.value,
      "aria-orientation": orientation.value,
      "data-step": props4.step
    };
    if (props4.disable === true) {
      acc["aria-disabled"] = "true";
    } else if (props4.readonly === true) {
      acc["aria-readonly"] = "true";
    }
    return acc;
  });
  const classes = computed(
    () => `q-slider q-slider${axis.value} q-slider--${active.value === true ? "" : "in"}active inline no-wrap ` + (props4.vertical === true ? "row" : "column") + (props4.disable === true ? " disabled" : " q-slider--enabled" + (editable.value === true ? " q-slider--editable" : "")) + (focus.value === "both" ? " q-slider--focus" : "") + (props4.label || props4.labelAlways === true ? " q-slider--label" : "") + (props4.labelAlways === true ? " q-slider--label-always" : "") + (isDark.value === true ? " q-slider--dark" : "") + (props4.dense === true ? " q-slider--dense q-slider--dense" + axis.value : "")
  );
  function getPositionClass(name2) {
    const cls = "q-slider__" + name2;
    return `${cls} ${cls}${axis.value} ${cls}${axis.value}${labelSide.value}`;
  }
  function getAxisClass(name2) {
    const cls = "q-slider__" + name2;
    return `${cls} ${cls}${axis.value}`;
  }
  const selectionBarClass = computed(() => {
    const color2 = props4.selectionColor || props4.color;
    return "q-slider__selection absolute" + (color2 !== void 0 ? ` text-${color2}` : "");
  });
  const markerClass = computed(() => getAxisClass("markers") + " absolute overflow-hidden");
  const trackContainerClass = computed(() => getAxisClass("track-container"));
  const pinClass = computed(() => getPositionClass("pin"));
  const labelClass = computed(() => getPositionClass("label"));
  const textContainerClass = computed(() => getPositionClass("text-container"));
  const markerLabelsContainerClass = computed(
    () => getPositionClass("marker-labels-container") + (props4.markerLabelsClass !== void 0 ? ` ${props4.markerLabelsClass}` : "")
  );
  const trackClass = computed(
    () => "q-slider__track relative-position no-outline" + (props4.trackColor !== void 0 ? ` bg-${props4.trackColor}` : "")
  );
  const trackStyle = computed(() => {
    const acc = { [thicknessProp.value]: props4.trackSize };
    if (props4.trackImg !== void 0) {
      acc.backgroundImage = `url(${props4.trackImg}) !important`;
    }
    return acc;
  });
  const innerBarClass = computed(
    () => "q-slider__inner absolute" + (props4.innerTrackColor !== void 0 ? ` bg-${props4.innerTrackColor}` : "")
  );
  const innerBarStyle = computed(() => {
    const innerDiff = innerMaxRatio.value - innerMinRatio.value;
    const acc = {
      [positionProp.value]: `${100 * innerMinRatio.value}%`,
      [sizeProp.value]: innerDiff === 0 ? "2px" : `${100 * innerDiff}%`
    };
    if (props4.innerTrackImg !== void 0) {
      acc.backgroundImage = `url(${props4.innerTrackImg}) !important`;
    }
    return acc;
  });
  function convertRatioToModel(ratio) {
    const { min: min2, max: max2, step } = props4;
    let model = min2 + ratio * (max2 - min2);
    if (step > 0) {
      const modulo = (model - innerMin.value) % step;
      model += (Math.abs(modulo) >= step / 2 ? (modulo < 0 ? -1 : 1) * step : 0) - modulo;
    }
    model = roundValueFn.value(model);
    return between(model, innerMin.value, innerMax.value);
  }
  function convertModelToRatio(model) {
    return trackLen.value === 0 ? 0 : (model - props4.min) / trackLen.value;
  }
  function getDraggingRatio(evt, dragging2) {
    const pos = position(evt), val = props4.vertical === true ? between((pos.top - dragging2.top) / dragging2.height, 0, 1) : between((pos.left - dragging2.left) / dragging2.width, 0, 1);
    return between(
      isReversed.value === true ? 1 - val : val,
      innerMinRatio.value,
      innerMaxRatio.value
    );
  }
  const markerStep = computed(
    () => isNumber(props4.markers) === true ? props4.markers : keyStep.value
  );
  const markerTicks = computed(() => {
    const acc = [];
    const step = markerStep.value;
    const max2 = props4.max;
    let value2 = props4.min;
    do {
      acc.push(value2);
      value2 += step;
    } while (value2 < max2);
    acc.push(max2);
    return acc;
  });
  const markerLabelClass = computed(() => {
    const prefix = ` ${markerPrefixClass}${axis.value}-`;
    return markerPrefixClass + `${prefix}${props4.switchMarkerLabelsSide === true ? "switched" : "standard"}${prefix}${isReversed.value === true ? "rtl" : "ltr"}`;
  });
  const markerLabelsList = computed(() => {
    if (props4.markerLabels === false) {
      return null;
    }
    return getMarkerList(props4.markerLabels).map((entry, index2) => ({
      index: index2,
      value: entry.value,
      label: entry.label || entry.value,
      classes: markerLabelClass.value + (entry.classes !== void 0 ? " " + entry.classes : ""),
      style: {
        ...getMarkerLabelStyle(entry.value),
        ...entry.style || {}
      }
    }));
  });
  const markerScope = computed(() => ({
    markerList: markerLabelsList.value,
    markerMap: markerLabelsMap.value,
    classes: markerLabelClass.value,
    // TODO ts definition
    getStyle: getMarkerLabelStyle
  }));
  const markerStyle = computed(() => {
    const size2 = innerBarLen.value === 0 ? "2px" : 100 * markerStep.value / innerBarLen.value;
    return {
      ...innerBarStyle.value,
      backgroundSize: props4.vertical === true ? `2px ${size2}%` : `${size2}% 2px`
    };
  });
  function getMarkerList(def) {
    if (def === false) {
      return null;
    }
    if (def === true) {
      return markerTicks.value.map(defaultMarkerConvertFn);
    }
    if (typeof def === "function") {
      return markerTicks.value.map((value2) => {
        const item = def(value2);
        return isObject(item) === true ? { ...item, value: value2 } : { value: value2, label: item };
      });
    }
    const filterFn = ({ value: value2 }) => value2 >= props4.min && value2 <= props4.max;
    if (Array.isArray(def) === true) {
      return def.map((item) => isObject(item) === true ? item : { value: item }).filter(filterFn);
    }
    return Object.keys(def).map((key) => {
      const item = def[key];
      const value2 = Number(key);
      return isObject(item) === true ? { ...item, value: value2 } : { value: value2, label: item };
    }).filter(filterFn);
  }
  function getMarkerLabelStyle(val) {
    return { [positionProp.value]: `${100 * (val - props4.min) / trackLen.value}%` };
  }
  const markerLabelsMap = computed(() => {
    if (props4.markerLabels === false) {
      return null;
    }
    const acc = {};
    markerLabelsList.value.forEach((entry) => {
      acc[entry.value] = entry;
    });
    return acc;
  });
  function getMarkerLabelsContent() {
    if (slots["marker-label-group"] !== void 0) {
      return slots["marker-label-group"](markerScope.value);
    }
    const fn = slots["marker-label"] || defaultMarkerLabelRenderFn;
    return markerLabelsList.value.map((marker) => fn({
      marker,
      ...markerScope.value
    }));
  }
  const panDirective = computed(() => {
    return [[
      TouchPan_default,
      onPan,
      void 0,
      {
        [orientation.value]: true,
        prevent: true,
        stop: true,
        mouse: true,
        mouseAllDir: true
      }
    ]];
  });
  function onPan(event) {
    if (event.isFinal === true) {
      if (dragging.value !== void 0) {
        updatePosition(event.evt);
        event.touch === true && updateValue2(true);
        dragging.value = void 0;
        emit("pan", "end");
      }
      active.value = false;
      focus.value = false;
    } else if (event.isFirst === true) {
      dragging.value = getDragging(event.evt);
      updatePosition(event.evt);
      updateValue2();
      active.value = true;
      emit("pan", "start");
    } else {
      updatePosition(event.evt);
      updateValue2();
    }
  }
  function onBlur2() {
    focus.value = false;
  }
  function onActivate(evt) {
    updatePosition(evt, getDragging(evt));
    updateValue2();
    preventFocus.value = true;
    active.value = true;
    document.addEventListener("mouseup", onDeactivate, true);
  }
  function onDeactivate() {
    preventFocus.value = false;
    active.value = false;
    updateValue2(true);
    onBlur2();
    document.removeEventListener("mouseup", onDeactivate, true);
  }
  function onMobileClick(evt) {
    updatePosition(evt, getDragging(evt));
    updateValue2(true);
  }
  function onKeyup2(evt) {
    if (keyCodes.includes(evt.keyCode)) {
      updateValue2(true);
    }
  }
  function getTextContainerStyle(ratio) {
    if (props4.vertical === true) {
      return null;
    }
    const p2 = $q.lang.rtl !== props4.reverse ? 1 - ratio : ratio;
    return {
      transform: `translateX(calc(${2 * p2 - 1} * ${props4.thumbSize} / 2 + ${50 - 100 * p2}%))`
    };
  }
  function getThumbRenderFn(thumb) {
    const focusClass = computed(() => preventFocus.value === false && (focus.value === thumb.focusValue || focus.value === "both") ? " q-slider--focus" : "");
    const classes2 = computed(
      () => `q-slider__thumb q-slider__thumb${axis.value} q-slider__thumb${axis.value}-${isReversed.value === true ? "rtl" : "ltr"} absolute non-selectable` + focusClass.value + (thumb.thumbColor.value !== void 0 ? ` text-${thumb.thumbColor.value}` : "")
    );
    const style2 = computed(() => ({
      width: props4.thumbSize,
      height: props4.thumbSize,
      [positionProp.value]: `${100 * thumb.ratio.value}%`,
      zIndex: focus.value === thumb.focusValue ? 2 : void 0
    }));
    const pinColor = computed(() => thumb.labelColor.value !== void 0 ? ` text-${thumb.labelColor.value}` : "");
    const textContainerStyle = computed(() => getTextContainerStyle(thumb.ratio.value));
    const textClass = computed(() => "q-slider__text" + (thumb.labelTextColor.value !== void 0 ? ` text-${thumb.labelTextColor.value}` : ""));
    return () => {
      const thumbContent = [
        h("svg", {
          class: "q-slider__thumb-shape absolute-full",
          viewBox: "0 0 20 20",
          "aria-hidden": "true"
        }, [
          h("path", { d: props4.thumbPath })
        ]),
        h("div", { class: "q-slider__focus-ring fit" })
      ];
      if (props4.label === true || props4.labelAlways === true) {
        thumbContent.push(
          h("div", {
            class: pinClass.value + " absolute fit no-pointer-events" + pinColor.value
          }, [
            h("div", {
              class: labelClass.value,
              style: { minWidth: props4.thumbSize }
            }, [
              h("div", {
                class: textContainerClass.value,
                style: textContainerStyle.value
              }, [
                h("span", { class: textClass.value }, thumb.label.value)
              ])
            ])
          ])
        );
        if (props4.name !== void 0 && props4.disable !== true) {
          injectFormInput(thumbContent, "push");
        }
      }
      return h("div", {
        class: classes2.value,
        style: style2.value,
        ...thumb.getNodeData()
      }, thumbContent);
    };
  }
  function getContent(selectionBarStyle, trackContainerTabindex, trackContainerEvents, injectThumb) {
    const trackContent = [];
    props4.innerTrackColor !== "transparent" && trackContent.push(
      h("div", {
        key: "inner",
        class: innerBarClass.value,
        style: innerBarStyle.value
      })
    );
    props4.selectionColor !== "transparent" && trackContent.push(
      h("div", {
        key: "selection",
        class: selectionBarClass.value,
        style: selectionBarStyle.value
      })
    );
    props4.markers !== false && trackContent.push(
      h("div", {
        key: "marker",
        class: markerClass.value,
        style: markerStyle.value
      })
    );
    injectThumb(trackContent);
    const content = [
      hDir(
        "div",
        {
          key: "trackC",
          class: trackContainerClass.value,
          tabindex: trackContainerTabindex.value,
          ...trackContainerEvents.value
        },
        [
          h("div", {
            class: trackClass.value,
            style: trackStyle.value
          }, trackContent)
        ],
        "slide",
        editable.value,
        () => panDirective.value
      )
    ];
    if (props4.markerLabels !== false) {
      const action = props4.switchMarkerLabelsSide === true ? "unshift" : "push";
      content[action](
        h("div", {
          key: "markerL",
          class: markerLabelsContainerClass.value
        }, getMarkerLabelsContent())
      );
    }
    return content;
  }
  onBeforeUnmount(() => {
    document.removeEventListener("mouseup", onDeactivate, true);
  });
  return {
    state: {
      active,
      focus,
      preventFocus,
      dragging,
      editable,
      classes,
      tabindex,
      attributes,
      roundValueFn,
      keyStep,
      trackLen,
      innerMin,
      innerMinRatio,
      innerMax,
      innerMaxRatio,
      positionProp,
      sizeProp,
      isReversed
    },
    methods: {
      onActivate,
      onMobileClick,
      onBlur: onBlur2,
      onKeyup: onKeyup2,
      getContent,
      getThumbRenderFn,
      convertRatioToModel,
      convertModelToRatio,
      getDraggingRatio
    }
  };
}
var getNodeData = () => ({});
var QSlider_default = createComponent({
  name: "QSlider",
  props: {
    ...useSliderProps,
    modelValue: {
      required: true,
      default: null,
      validator: (v) => typeof v === "number" || v === null
    },
    labelValue: [String, Number]
  },
  emits: useSliderEmits,
  setup(props4, { emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const { state: state2, methods } = use_slider_default({
      updateValue: updateValue2,
      updatePosition,
      getDragging,
      formAttrs: useFormAttrs(props4)
    });
    const rootRef = ref$1(null);
    const curRatio = ref$1(0);
    const model = ref$1(0);
    function normalizeModel() {
      model.value = props4.modelValue === null ? state2.innerMin.value : between(props4.modelValue, state2.innerMin.value, state2.innerMax.value);
    }
    watch(
      () => `${props4.modelValue}|${state2.innerMin.value}|${state2.innerMax.value}`,
      normalizeModel
    );
    normalizeModel();
    const modelRatio = computed(() => methods.convertModelToRatio(model.value));
    const ratio = computed(() => state2.active.value === true ? curRatio.value : modelRatio.value);
    const selectionBarStyle = computed(() => {
      const acc = {
        [state2.positionProp.value]: `${100 * state2.innerMinRatio.value}%`,
        [state2.sizeProp.value]: `${100 * (ratio.value - state2.innerMinRatio.value)}%`
      };
      if (props4.selectionImg !== void 0) {
        acc.backgroundImage = `url(${props4.selectionImg}) !important`;
      }
      return acc;
    });
    const getThumb = methods.getThumbRenderFn({
      focusValue: true,
      getNodeData,
      ratio,
      label: computed(() => props4.labelValue !== void 0 ? props4.labelValue : model.value),
      thumbColor: computed(() => props4.thumbColor || props4.color),
      labelColor: computed(() => props4.labelColor),
      labelTextColor: computed(() => props4.labelTextColor)
    });
    const trackContainerEvents = computed(() => {
      if (state2.editable.value !== true) {
        return {};
      }
      return $q.platform.is.mobile === true ? { onClick: methods.onMobileClick } : {
        onMousedown: methods.onActivate,
        onFocus,
        onBlur: methods.onBlur,
        onKeydown: onKeydown2,
        onKeyup: methods.onKeyup
      };
    });
    function updateValue2(change) {
      if (model.value !== props4.modelValue) {
        emit("update:modelValue", model.value);
      }
      change === true && emit("change", model.value);
    }
    function getDragging() {
      return rootRef.value.getBoundingClientRect();
    }
    function updatePosition(event, dragging = state2.dragging.value) {
      const ratio2 = methods.getDraggingRatio(event, dragging);
      model.value = methods.convertRatioToModel(ratio2);
      curRatio.value = props4.snap !== true || props4.step === 0 ? ratio2 : methods.convertModelToRatio(model.value);
    }
    function onFocus() {
      state2.focus.value = true;
    }
    function onKeydown2(evt) {
      if (keyCodes.includes(evt.keyCode) === false) return;
      stopAndPrevent(evt);
      const stepVal = ([34, 33].includes(evt.keyCode) ? 10 : 1) * state2.keyStep.value, offset2 = ([34, 37, 40].includes(evt.keyCode) ? -1 : 1) * (state2.isReversed.value === true ? -1 : 1) * (props4.vertical === true ? -1 : 1) * stepVal;
      model.value = between(
        state2.roundValueFn.value(model.value + offset2),
        state2.innerMin.value,
        state2.innerMax.value
      );
      updateValue2();
    }
    return () => {
      const content = methods.getContent(
        selectionBarStyle,
        state2.tabindex,
        trackContainerEvents,
        (node) => {
          node.push(getThumb());
        }
      );
      return h("div", {
        ref: rootRef,
        class: state2.classes.value + (props4.modelValue === null ? " q-slider--no-value" : ""),
        ...state2.attributes.value,
        "aria-valuenow": props4.modelValue
      }, content);
    };
  }
});
function use_hydration_default() {
  const isHydrated = ref$1(!isRuntimeSsrPreHydration.value);
  if (isHydrated.value === false) {
    onMounted(() => {
      isHydrated.value = true;
    });
  }
  return { isHydrated };
}
var hasObserver = typeof ResizeObserver !== "undefined";
var resizeProps = hasObserver === true ? {} : {
  style: "display:block;position:absolute;top:0;left:0;right:0;bottom:0;height:100%;width:100%;overflow:hidden;pointer-events:none;z-index:-1;",
  url: "about:blank"
};
var QResizeObserver_default = createComponent({
  name: "QResizeObserver",
  props: {
    debounce: {
      type: [String, Number],
      default: 100
    }
  },
  emits: ["resize"],
  setup(props4, { emit }) {
    let timer2 = null, targetEl, size2 = { width: -1, height: -1 };
    function trigger3(immediately) {
      if (immediately === true || props4.debounce === 0 || props4.debounce === "0") {
        emitEvent();
      } else if (timer2 === null) {
        timer2 = setTimeout(emitEvent, props4.debounce);
      }
    }
    function emitEvent() {
      if (timer2 !== null) {
        clearTimeout(timer2);
        timer2 = null;
      }
      if (targetEl) {
        const { offsetWidth: width3, offsetHeight: height2 } = targetEl;
        if (width3 !== size2.width || height2 !== size2.height) {
          size2 = { width: width3, height: height2 };
          emit("resize", size2);
        }
      }
    }
    const { proxy } = getCurrentInstance();
    proxy.trigger = trigger3;
    if (hasObserver === true) {
      let observer;
      const init = (stop2) => {
        targetEl = proxy.$el.parentNode;
        if (targetEl) {
          observer = new ResizeObserver(trigger3);
          observer.observe(targetEl);
          emitEvent();
        } else if (stop2 !== true) {
          nextTick(() => {
            init(true);
          });
        }
      };
      onMounted(() => {
        init();
      });
      onBeforeUnmount(() => {
        timer2 !== null && clearTimeout(timer2);
        if (observer !== void 0) {
          if (observer.disconnect !== void 0) {
            observer.disconnect();
          } else if (targetEl) {
            observer.unobserve(targetEl);
          }
        }
      });
      return noop;
    } else {
      let cleanup = function() {
        if (timer2 !== null) {
          clearTimeout(timer2);
          timer2 = null;
        }
        if (curDocView !== void 0) {
          if (curDocView.removeEventListener !== void 0) {
            curDocView.removeEventListener("resize", trigger3, listenOpts.passive);
          }
          curDocView = void 0;
        }
      }, onObjLoad = function() {
        cleanup();
        if (targetEl == null ? void 0 : targetEl.contentDocument) {
          curDocView = targetEl.contentDocument.defaultView;
          curDocView.addEventListener("resize", trigger3, listenOpts.passive);
          emitEvent();
        }
      };
      const { isHydrated } = use_hydration_default();
      let curDocView;
      onMounted(() => {
        nextTick(() => {
          targetEl = proxy.$el;
          targetEl && onObjLoad();
        });
      });
      onBeforeUnmount(cleanup);
      return () => {
        if (isHydrated.value === true) {
          return h("object", {
            class: "q--avoid-card-border",
            style: resizeProps.style,
            tabindex: -1,
            // fix for Firefox
            type: "text/html",
            data: resizeProps.url,
            "aria-hidden": "true",
            onLoad: onObjLoad
          });
        }
      };
    }
  }
});
var rtlHasScrollBug = false;
if (!__QUASAR_SSR__) {
  const scroller = document.createElement("div");
  scroller.setAttribute("dir", "rtl");
  Object.assign(scroller.style, {
    width: "1px",
    height: "1px",
    overflow: "auto"
  });
  const spacer = document.createElement("div");
  Object.assign(spacer.style, {
    width: "1000px",
    height: "1px"
  });
  document.body.appendChild(scroller);
  scroller.appendChild(spacer);
  scroller.scrollLeft = -1e3;
  rtlHasScrollBug = scroller.scrollLeft >= 0;
  scroller.remove();
}
function getIndicatorClass(color2, top, vertical) {
  const pos = vertical === true ? ["left", "right"] : ["top", "bottom"];
  return `absolute-${top === true ? pos[0] : pos[1]}${color2 ? ` text-${color2}` : ""}`;
}
var alignValues3 = ["left", "center", "right", "justify"];
var QTabs_default = createComponent({
  name: "QTabs",
  props: {
    modelValue: [Number, String],
    align: {
      type: String,
      default: "center",
      validator: (v) => alignValues3.includes(v)
    },
    breakpoint: {
      type: [String, Number],
      default: 600
    },
    vertical: Boolean,
    shrink: Boolean,
    stretch: Boolean,
    activeClass: String,
    activeColor: String,
    activeBgColor: String,
    indicatorColor: String,
    leftIcon: String,
    rightIcon: String,
    outsideArrows: Boolean,
    mobileArrows: Boolean,
    switchIndicator: Boolean,
    narrowIndicator: Boolean,
    inlineLabel: Boolean,
    noCaps: Boolean,
    dense: Boolean,
    contentClass: String,
    "onUpdate:modelValue": [Function, Array]
  },
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const { registerTick: registerScrollTick } = use_tick_default();
    const { registerTick: registerUpdateArrowsTick } = use_tick_default();
    const { registerTick: registerAnimateTick } = use_tick_default();
    const { registerTimeout: registerFocusTimeout, removeTimeout: removeFocusTimeout } = use_timeout_default();
    const { registerTimeout: registerScrollToTabTimeout, removeTimeout: removeScrollToTabTimeout } = use_timeout_default();
    const rootRef = ref$1(null);
    const contentRef = ref$1(null);
    const currentModel = ref$1(props4.modelValue);
    const scrollable = ref$1(false);
    const leftArrow = ref$1(true);
    const rightArrow = ref$1(false);
    const justify = ref$1(false);
    const tabDataList = [];
    const tabDataListLen = ref$1(0);
    const hasFocus = ref$1(false);
    let animateTimer = null, scrollTimer = null, unwatchRoute;
    const tabProps = computed(() => ({
      activeClass: props4.activeClass,
      activeColor: props4.activeColor,
      activeBgColor: props4.activeBgColor,
      indicatorClass: getIndicatorClass(
        props4.indicatorColor,
        props4.switchIndicator,
        props4.vertical
      ),
      narrowIndicator: props4.narrowIndicator,
      inlineLabel: props4.inlineLabel,
      noCaps: props4.noCaps
    }));
    const hasActiveTab = computed(() => {
      const len = tabDataListLen.value;
      const val = currentModel.value;
      for (let i3 = 0; i3 < len; i3++) {
        if (tabDataList[i3].name.value === val) {
          return true;
        }
      }
      return false;
    });
    const alignClass = computed(() => {
      const align = scrollable.value === true ? "left" : justify.value === true ? "justify" : props4.align;
      return `q-tabs__content--align-${align}`;
    });
    const classes = computed(
      () => `q-tabs row no-wrap items-center q-tabs--${scrollable.value === true ? "" : "not-"}scrollable q-tabs--${props4.vertical === true ? "vertical" : "horizontal"} q-tabs__arrows--${props4.outsideArrows === true ? "outside" : "inside"} q-tabs--mobile-with${props4.mobileArrows === true ? "" : "out"}-arrows` + (props4.dense === true ? " q-tabs--dense" : "") + (props4.shrink === true ? " col-shrink" : "") + (props4.stretch === true ? " self-stretch" : "")
    );
    const innerClass = computed(
      () => "q-tabs__content scroll--mobile row no-wrap items-center self-stretch hide-scrollbar relative-position " + alignClass.value + (props4.contentClass !== void 0 ? ` ${props4.contentClass}` : "")
    );
    const domProps = computed(() => props4.vertical === true ? { container: "height", content: "offsetHeight", scroll: "scrollHeight" } : { container: "width", content: "offsetWidth", scroll: "scrollWidth" });
    const isRTL = computed(() => props4.vertical !== true && $q.lang.rtl === true);
    const rtlPosCorrection = computed(() => rtlHasScrollBug === false && isRTL.value === true);
    watch(isRTL, updateArrows);
    watch(() => props4.modelValue, (name2) => {
      updateModel2({ name: name2, setCurrent: true, skipEmit: true });
    });
    watch(() => props4.outsideArrows, recalculateScroll);
    function updateModel2({ name: name2, setCurrent, skipEmit }) {
      if (currentModel.value === name2) return;
      if (skipEmit !== true && props4["onUpdate:modelValue"] !== void 0) {
        emit("update:modelValue", name2);
      }
      if (setCurrent === true || props4["onUpdate:modelValue"] === void 0) {
        animate(currentModel.value, name2);
        currentModel.value = name2;
      }
    }
    function recalculateScroll() {
      registerScrollTick(() => {
        rootRef.value && updateContainer({
          width: rootRef.value.offsetWidth,
          height: rootRef.value.offsetHeight
        });
      });
    }
    function updateContainer(domSize) {
      if (domProps.value === void 0 || contentRef.value === null) return;
      const size2 = domSize[domProps.value.container], scrollSize = Math.min(
        contentRef.value[domProps.value.scroll],
        Array.prototype.reduce.call(
          contentRef.value.children,
          (acc, el) => acc + (el[domProps.value.content] || 0),
          0
        )
      ), scroll = size2 > 0 && scrollSize > size2;
      scrollable.value = scroll;
      scroll === true && registerUpdateArrowsTick(updateArrows);
      justify.value = size2 < parseInt(props4.breakpoint, 10);
    }
    function animate(oldName, newName) {
      const oldTab = oldName !== void 0 && oldName !== null && oldName !== "" ? tabDataList.find((tab) => tab.name.value === oldName) : null, newTab = newName !== void 0 && newName !== null && newName !== "" ? tabDataList.find((tab) => tab.name.value === newName) : null;
      if (hadActivated === true) {
        hadActivated = false;
      } else if (oldTab && newTab) {
        const oldEl = oldTab.tabIndicatorRef.value, newEl = newTab.tabIndicatorRef.value;
        if (animateTimer !== null) {
          clearTimeout(animateTimer);
          animateTimer = null;
        }
        oldEl.style.transition = "none";
        oldEl.style.transform = "none";
        newEl.style.transition = "none";
        newEl.style.transform = "none";
        const oldPos = oldEl.getBoundingClientRect(), newPos = newEl.getBoundingClientRect();
        newEl.style.transform = props4.vertical === true ? `translate3d(0,${oldPos.top - newPos.top}px,0) scale3d(1,${newPos.height ? oldPos.height / newPos.height : 1},1)` : `translate3d(${oldPos.left - newPos.left}px,0,0) scale3d(${newPos.width ? oldPos.width / newPos.width : 1},1,1)`;
        registerAnimateTick(() => {
          animateTimer = setTimeout(() => {
            animateTimer = null;
            newEl.style.transition = "transform .25s cubic-bezier(.4, 0, .2, 1)";
            newEl.style.transform = "none";
          }, 70);
        });
      }
      if (newTab && scrollable.value === true) {
        scrollToTabEl(newTab.rootRef.value);
      }
    }
    function scrollToTabEl(el) {
      const { left, width: width3, top, height: height2 } = contentRef.value.getBoundingClientRect(), newPos = el.getBoundingClientRect();
      let offset2 = props4.vertical === true ? newPos.top - top : newPos.left - left;
      if (offset2 < 0) {
        contentRef.value[props4.vertical === true ? "scrollTop" : "scrollLeft"] += Math.floor(offset2);
        updateArrows();
        return;
      }
      offset2 += props4.vertical === true ? newPos.height - height2 : newPos.width - width3;
      if (offset2 > 0) {
        contentRef.value[props4.vertical === true ? "scrollTop" : "scrollLeft"] += Math.ceil(offset2);
        updateArrows();
      }
    }
    function updateArrows() {
      const content = contentRef.value;
      if (content === null) return;
      const rect = content.getBoundingClientRect(), pos = props4.vertical === true ? content.scrollTop : Math.abs(content.scrollLeft);
      if (isRTL.value === true) {
        leftArrow.value = Math.ceil(pos + rect.width) < content.scrollWidth - 1;
        rightArrow.value = pos > 0;
      } else {
        leftArrow.value = pos > 0;
        rightArrow.value = props4.vertical === true ? Math.ceil(pos + rect.height) < content.scrollHeight : Math.ceil(pos + rect.width) < content.scrollWidth;
      }
    }
    function animScrollTo(value2) {
      scrollTimer !== null && clearInterval(scrollTimer);
      scrollTimer = setInterval(() => {
        if (scrollTowards(value2) === true) {
          stopAnimScroll();
        }
      }, 5);
    }
    function scrollToStart() {
      animScrollTo(rtlPosCorrection.value === true ? Number.MAX_SAFE_INTEGER : 0);
    }
    function scrollToEnd() {
      animScrollTo(rtlPosCorrection.value === true ? 0 : Number.MAX_SAFE_INTEGER);
    }
    function stopAnimScroll() {
      if (scrollTimer !== null) {
        clearInterval(scrollTimer);
        scrollTimer = null;
      }
    }
    function onKbdNavigate(keyCode, fromEl) {
      const tabs = Array.prototype.filter.call(
        contentRef.value.children,
        (el) => el === fromEl || el.matches && el.matches(".q-tab.q-focusable") === true
      );
      const len = tabs.length;
      if (len === 0) return;
      if (keyCode === 36) {
        scrollToTabEl(tabs[0]);
        tabs[0].focus();
        return true;
      }
      if (keyCode === 35) {
        scrollToTabEl(tabs[len - 1]);
        tabs[len - 1].focus();
        return true;
      }
      const dirPrev = keyCode === (props4.vertical === true ? 38 : 37);
      const dirNext = keyCode === (props4.vertical === true ? 40 : 39);
      const dir = dirPrev === true ? -1 : dirNext === true ? 1 : void 0;
      if (dir !== void 0) {
        const rtlDir = isRTL.value === true ? -1 : 1;
        const index2 = tabs.indexOf(fromEl) + dir * rtlDir;
        if (index2 >= 0 && index2 < len) {
          scrollToTabEl(tabs[index2]);
          tabs[index2].focus({ preventScroll: true });
        }
        return true;
      }
    }
    const posFn = computed(() => rtlPosCorrection.value === true ? { get: (content) => Math.abs(content.scrollLeft), set: (content, pos) => {
      content.scrollLeft = -pos;
    } } : props4.vertical === true ? { get: (content) => content.scrollTop, set: (content, pos) => {
      content.scrollTop = pos;
    } } : { get: (content) => content.scrollLeft, set: (content, pos) => {
      content.scrollLeft = pos;
    } });
    function scrollTowards(value2) {
      const content = contentRef.value, { get: get2, set: set2 } = posFn.value;
      let done = false, pos = get2(content);
      const direction = value2 < pos ? -1 : 1;
      pos += direction * 5;
      if (pos < 0) {
        done = true;
        pos = 0;
      } else if (direction === -1 && pos <= value2 || direction === 1 && pos >= value2) {
        done = true;
        pos = value2;
      }
      set2(content, pos);
      updateArrows();
      return done;
    }
    function hasQueryIncluded(targetQuery, matchingQuery) {
      for (const key in targetQuery) {
        if (targetQuery[key] !== matchingQuery[key]) {
          return false;
        }
      }
      return true;
    }
    function updateActiveRoute() {
      let name2 = null, bestScore = { matchedLen: 0, queryDiff: 9999, hrefLen: 0 };
      const list = tabDataList.filter((tab) => {
        var _a;
        return ((_a = tab.routeData) == null ? void 0 : _a.hasRouterLink.value) === true;
      });
      const { hash: currentHash, query: currentQuery } = proxy.$route;
      const currentQueryLen = Object.keys(currentQuery).length;
      for (const tab of list) {
        const exact = tab.routeData.exact.value === true;
        if (tab.routeData[exact === true ? "linkIsExactActive" : "linkIsActive"].value !== true) {
          continue;
        }
        const { hash, query, matched, href: href2 } = tab.routeData.resolvedLink.value;
        const queryLen = Object.keys(query).length;
        if (exact === true) {
          if (hash !== currentHash) {
            continue;
          }
          if (queryLen !== currentQueryLen || hasQueryIncluded(currentQuery, query) === false) {
            continue;
          }
          name2 = tab.name.value;
          break;
        }
        if (hash !== "" && hash !== currentHash) {
          continue;
        }
        if (queryLen !== 0 && hasQueryIncluded(query, currentQuery) === false) {
          continue;
        }
        const newScore = {
          matchedLen: matched.length,
          queryDiff: currentQueryLen - queryLen,
          hrefLen: href2.length - hash.length
        };
        if (newScore.matchedLen > bestScore.matchedLen) {
          name2 = tab.name.value;
          bestScore = newScore;
          continue;
        } else if (newScore.matchedLen !== bestScore.matchedLen) {
          continue;
        }
        if (newScore.queryDiff < bestScore.queryDiff) {
          name2 = tab.name.value;
          bestScore = newScore;
        } else if (newScore.queryDiff !== bestScore.queryDiff) {
          continue;
        }
        if (newScore.hrefLen > bestScore.hrefLen) {
          name2 = tab.name.value;
          bestScore = newScore;
        }
      }
      if (name2 === null && tabDataList.some((tab) => tab.routeData === void 0 && tab.name.value === currentModel.value) === true) {
        hadActivated = false;
        return;
      }
      updateModel2({ name: name2, setCurrent: true });
    }
    function onFocusin(e3) {
      removeFocusTimeout();
      if (hasFocus.value !== true && rootRef.value !== null && e3.target && typeof e3.target.closest === "function") {
        const tab = e3.target.closest(".q-tab");
        if (tab && rootRef.value.contains(tab) === true) {
          hasFocus.value = true;
          scrollable.value === true && scrollToTabEl(tab);
        }
      }
    }
    function onFocusout() {
      registerFocusTimeout(() => {
        hasFocus.value = false;
      }, 30);
    }
    function verifyRouteModel() {
      if ($tabs.avoidRouteWatcher === false) {
        registerScrollToTabTimeout(updateActiveRoute);
      } else {
        removeScrollToTabTimeout();
      }
    }
    function watchRoute() {
      if (unwatchRoute === void 0) {
        const unwatch = watch(() => proxy.$route.fullPath, verifyRouteModel);
        unwatchRoute = () => {
          unwatch();
          unwatchRoute = void 0;
        };
      }
    }
    function registerTab(tabData) {
      tabDataList.push(tabData);
      tabDataListLen.value++;
      recalculateScroll();
      if (tabData.routeData === void 0 || proxy.$route === void 0) {
        registerScrollToTabTimeout(() => {
          if (scrollable.value === true) {
            const value2 = currentModel.value;
            const newTab = value2 !== void 0 && value2 !== null && value2 !== "" ? tabDataList.find((tab) => tab.name.value === value2) : null;
            newTab && scrollToTabEl(newTab.rootRef.value);
          }
        });
      } else {
        watchRoute();
        if (tabData.routeData.hasRouterLink.value === true) {
          verifyRouteModel();
        }
      }
    }
    function unregisterTab(tabData) {
      tabDataList.splice(tabDataList.indexOf(tabData), 1);
      tabDataListLen.value--;
      recalculateScroll();
      if (unwatchRoute !== void 0 && tabData.routeData !== void 0) {
        if (tabDataList.every((tab) => tab.routeData === void 0) === true) {
          unwatchRoute();
        }
        verifyRouteModel();
      }
    }
    const $tabs = {
      currentModel,
      tabProps,
      hasFocus,
      hasActiveTab,
      registerTab,
      unregisterTab,
      verifyRouteModel,
      updateModel: updateModel2,
      onKbdNavigate,
      avoidRouteWatcher: false
      // false | string (uid)
    };
    provide(tabsKey, $tabs);
    function cleanup() {
      animateTimer !== null && clearTimeout(animateTimer);
      stopAnimScroll();
      unwatchRoute == null ? void 0 : unwatchRoute();
    }
    let hadRouteWatcher, hadActivated;
    onBeforeUnmount(cleanup);
    onDeactivated(() => {
      hadRouteWatcher = unwatchRoute !== void 0;
      cleanup();
    });
    onActivated(() => {
      if (hadRouteWatcher === true) {
        watchRoute();
        hadActivated = true;
        verifyRouteModel();
      }
      recalculateScroll();
    });
    return () => {
      return h("div", {
        ref: rootRef,
        class: classes.value,
        role: "tablist",
        onFocusin,
        onFocusout
      }, [
        h(QResizeObserver_default, { onResize: updateContainer }),
        h("div", {
          ref: contentRef,
          class: innerClass.value,
          onScroll: updateArrows
        }, hSlot(slots.default)),
        h(QIcon_default, {
          class: "q-tabs__arrow q-tabs__arrow--left absolute q-tab__icon" + (leftArrow.value === true ? "" : " q-tabs__arrow--faded"),
          name: props4.leftIcon || $q.iconSet.tabs[props4.vertical === true ? "up" : "left"],
          onMousedownPassive: scrollToStart,
          onTouchstartPassive: scrollToStart,
          onMouseupPassive: stopAnimScroll,
          onMouseleavePassive: stopAnimScroll,
          onTouchendPassive: stopAnimScroll
        }),
        h(QIcon_default, {
          class: "q-tabs__arrow q-tabs__arrow--right absolute q-tab__icon" + (rightArrow.value === true ? "" : " q-tabs__arrow--faded"),
          name: props4.rightIcon || $q.iconSet.tabs[props4.vertical === true ? "down" : "right"],
          onMousedownPassive: scrollToEnd,
          onTouchstartPassive: scrollToEnd,
          onMouseupPassive: stopAnimScroll,
          onMouseleavePassive: stopAnimScroll,
          onTouchendPassive: stopAnimScroll
        })
      ]);
    };
  }
});
var id = 0;
var useTabEmits = ["click", "keydown"];
var useTabProps = {
  icon: String,
  label: [Number, String],
  alert: [Boolean, String],
  alertIcon: String,
  name: {
    type: [Number, String],
    default: () => `t_${id++}`
  },
  noCaps: Boolean,
  tabindex: [String, Number],
  disable: Boolean,
  contentClass: String,
  ripple: {
    type: [Boolean, Object],
    default: true
  }
};
function use_tab_default(props4, slots, emit, routeData) {
  const $tabs = inject(tabsKey, emptyRenderFn);
  if ($tabs === emptyRenderFn) {
    console.error("QTab/QRouteTab component needs to be child of QTabs");
    return emptyRenderFn;
  }
  const { proxy } = getCurrentInstance();
  const blurTargetRef = ref$1(null);
  const rootRef = ref$1(null);
  const tabIndicatorRef = ref$1(null);
  const ripple = computed(() => props4.disable === true || props4.ripple === false ? false : Object.assign(
    { keyCodes: [13, 32], early: true },
    props4.ripple === true ? {} : props4.ripple
  ));
  const isActive = computed(() => $tabs.currentModel.value === props4.name);
  const classes = computed(
    () => "q-tab relative-position self-stretch flex flex-center text-center" + (isActive.value === true ? " q-tab--active" + ($tabs.tabProps.value.activeClass ? " " + $tabs.tabProps.value.activeClass : "") + ($tabs.tabProps.value.activeColor ? ` text-${$tabs.tabProps.value.activeColor}` : "") + ($tabs.tabProps.value.activeBgColor ? ` bg-${$tabs.tabProps.value.activeBgColor}` : "") : " q-tab--inactive") + (props4.icon && props4.label && $tabs.tabProps.value.inlineLabel === false ? " q-tab--full" : "") + (props4.noCaps === true || $tabs.tabProps.value.noCaps === true ? " q-tab--no-caps" : "") + (props4.disable === true ? " disabled" : " q-focusable q-hoverable cursor-pointer") + (routeData !== void 0 ? routeData.linkClass.value : "")
  );
  const innerClass = computed(
    () => "q-tab__content self-stretch flex-center relative-position q-anchor--skip non-selectable " + ($tabs.tabProps.value.inlineLabel === true ? "row no-wrap q-tab__content--inline" : "column") + (props4.contentClass !== void 0 ? ` ${props4.contentClass}` : "")
  );
  const tabIndex = computed(() => props4.disable === true || $tabs.hasFocus.value === true || isActive.value === false && $tabs.hasActiveTab.value === true ? -1 : props4.tabindex || 0);
  function onClick(e3, keyboard) {
    var _a;
    if (keyboard !== true && (e3 == null ? void 0 : e3.qAvoidFocus) !== true) {
      (_a = blurTargetRef.value) == null ? void 0 : _a.focus();
    }
    if (props4.disable === true) {
      if ((routeData == null ? void 0 : routeData.hasRouterLink.value) === true) {
        stopAndPrevent(e3);
      }
      return;
    }
    if (routeData === void 0) {
      $tabs.updateModel({ name: props4.name });
      emit("click", e3);
      return;
    }
    if (routeData.hasRouterLink.value === true) {
      const go = (opts = {}) => {
        let hardError;
        const reqId = opts.to === void 0 || isDeepEqual(opts.to, props4.to) === true ? $tabs.avoidRouteWatcher = uid_default() : null;
        return routeData.navigateToRouterLink(e3, { ...opts, returnRouterError: true }).catch((err) => {
          hardError = err;
        }).then((softError) => {
          var _a2;
          if (reqId === $tabs.avoidRouteWatcher) {
            $tabs.avoidRouteWatcher = false;
            if (hardError === void 0 && (softError === void 0 || ((_a2 = softError.message) == null ? void 0 : _a2.startsWith("Avoided redundant navigation")) === true)) {
              $tabs.updateModel({ name: props4.name });
            }
          }
          if (opts.returnRouterError === true) {
            return hardError !== void 0 ? Promise.reject(hardError) : softError;
          }
        });
      };
      emit("click", e3, go);
      e3.defaultPrevented !== true && go();
      return;
    }
    emit("click", e3);
  }
  function onKeydown2(e3) {
    if (isKeyCode(e3, [13, 32])) {
      onClick(e3, true);
    } else if (shouldIgnoreKey(e3) !== true && e3.keyCode >= 35 && e3.keyCode <= 40 && e3.altKey !== true && e3.metaKey !== true) {
      $tabs.onKbdNavigate(e3.keyCode, proxy.$el) === true && stopAndPrevent(e3);
    }
    emit("keydown", e3);
  }
  function getContent() {
    const narrow = $tabs.tabProps.value.narrowIndicator, content = [], indicator = h("div", {
      ref: tabIndicatorRef,
      class: [
        "q-tab__indicator",
        $tabs.tabProps.value.indicatorClass
      ]
    });
    props4.icon !== void 0 && content.push(
      h(QIcon_default, {
        class: "q-tab__icon",
        name: props4.icon
      })
    );
    props4.label !== void 0 && content.push(
      h("div", { class: "q-tab__label" }, props4.label)
    );
    props4.alert !== false && content.push(
      props4.alertIcon !== void 0 ? h(QIcon_default, {
        class: "q-tab__alert-icon",
        color: props4.alert !== true ? props4.alert : void 0,
        name: props4.alertIcon
      }) : h("div", {
        class: "q-tab__alert" + (props4.alert !== true ? ` text-${props4.alert}` : "")
      })
    );
    narrow === true && content.push(indicator);
    const node = [
      h("div", { class: "q-focus-helper", tabindex: -1, ref: blurTargetRef }),
      h("div", { class: innerClass.value }, hMergeSlot(slots.default, content))
    ];
    narrow === false && node.push(indicator);
    return node;
  }
  const tabData = {
    name: computed(() => props4.name),
    rootRef,
    tabIndicatorRef,
    routeData
  };
  onBeforeUnmount(() => {
    $tabs.unregisterTab(tabData);
  });
  onMounted(() => {
    $tabs.registerTab(tabData);
  });
  function renderTab(tag, customData) {
    const data = {
      ref: rootRef,
      class: classes.value,
      tabindex: tabIndex.value,
      role: "tab",
      "aria-selected": isActive.value === true ? "true" : "false",
      "aria-disabled": props4.disable === true ? "true" : void 0,
      onClick,
      onKeydown: onKeydown2,
      ...customData
    };
    return withDirectives(
      h(tag, data, getContent()),
      [[Ripple_default, ripple.value]]
    );
  }
  return { renderTab, $tabs };
}
var QTab_default = createComponent({
  name: "QTab",
  props: useTabProps,
  emits: useTabEmits,
  setup(props4, { slots, emit }) {
    const { renderTab } = use_tab_default(props4, slots, emit);
    return () => renderTab("div");
  }
});
var QTabPanels_default = createComponent({
  name: "QTabPanels",
  props: {
    ...usePanelProps,
    ...useDarkProps
  },
  emits: usePanelEmits,
  setup(props4, { slots }) {
    const vm2 = getCurrentInstance();
    const isDark = use_dark_default(props4, vm2.proxy.$q);
    const { updatePanelsList, getPanelContent, panelDirectives } = use_panel_default();
    const classes = computed(
      () => "q-tab-panels q-panel-parent" + (isDark.value === true ? " q-tab-panels--dark q-dark" : "")
    );
    return () => {
      updatePanelsList(slots);
      return hDir(
        "div",
        { class: classes.value },
        getPanelContent(),
        "pan",
        props4.swipeable,
        () => panelDirectives.value
      );
    };
  }
});
var QTabPanel_default = createComponent({
  name: "QTabPanel",
  props: usePanelChildProps,
  setup(_, { slots }) {
    return () => h("div", { class: "q-tab-panel", role: "tabpanel" }, hSlot(slots.default));
  }
});
var hex = /^#[0-9a-fA-F]{3}([0-9a-fA-F]{3})?$/;
var hexa = /^#[0-9a-fA-F]{4}([0-9a-fA-F]{4})?$/;
var hexOrHexa = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/;
var rgb = /^rgb\(((0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),){2}(0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5])\)$/;
var rgba = /^rgba\(((0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),){2}(0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),(0|0\.[0-9]+[1-9]|0\.[1-9]+|1)\)$/;
var testPattern = {
  date: (v) => /^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(v),
  time: (v) => /^([0-1]?\d|2[0-3]):[0-5]\d$/.test(v),
  fulltime: (v) => /^([0-1]?\d|2[0-3]):[0-5]\d:[0-5]\d$/.test(v),
  timeOrFulltime: (v) => /^([0-1]?\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/.test(v),
  // -- RFC 5322 --
  // -- Added in v2.6.6 --
  // This is a basic helper validation.
  // For something more complex (like RFC 822) you should write and use your own rule.
  // We won't be accepting PRs to enhance the one below because of the reason above.
  // eslint-disable-next-line
  email: (v) => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v),
  hexColor: (v) => hex.test(v),
  hexaColor: (v) => hexa.test(v),
  hexOrHexaColor: (v) => hexOrHexa.test(v),
  rgbColor: (v) => rgb.test(v),
  rgbaColor: (v) => rgba.test(v),
  rgbOrRgbaColor: (v) => rgb.test(v) || rgba.test(v),
  hexOrRgbColor: (v) => hex.test(v) || rgb.test(v),
  hexaOrRgbaColor: (v) => hexa.test(v) || rgba.test(v),
  anyColor: (v) => hexOrHexa.test(v) || rgb.test(v) || rgba.test(v)
};
var reRGBA = /^rgb(a)?\((\d{1,3}),(\d{1,3}),(\d{1,3}),?([01]?\.?\d*?)?\)$/;
function rgbToHex({ r, g: g2, b: b3, a: a4 }) {
  const alpha2 = a4 !== void 0;
  r = Math.round(r);
  g2 = Math.round(g2);
  b3 = Math.round(b3);
  if (r > 255 || g2 > 255 || b3 > 255 || alpha2 && a4 > 100) {
    throw new TypeError("Expected 3 numbers below 256 (and optionally one below 100)");
  }
  a4 = alpha2 ? (Math.round(255 * a4 / 100) | 1 << 8).toString(16).slice(1) : "";
  return "#" + (b3 | g2 << 8 | r << 16 | 1 << 24).toString(16).slice(1) + a4;
}
function rgbToString({ r, g: g2, b: b3, a: a4 }) {
  return `rgb${a4 !== void 0 ? "a" : ""}(${r},${g2},${b3}${a4 !== void 0 ? "," + a4 / 100 : ""})`;
}
function hexToRgb(hex2) {
  if (typeof hex2 !== "string") {
    throw new TypeError("Expected a string");
  }
  hex2 = hex2.replace(/^#/, "");
  if (hex2.length === 3) {
    hex2 = hex2[0] + hex2[0] + hex2[1] + hex2[1] + hex2[2] + hex2[2];
  } else if (hex2.length === 4) {
    hex2 = hex2[0] + hex2[0] + hex2[1] + hex2[1] + hex2[2] + hex2[2] + hex2[3] + hex2[3];
  }
  const num = parseInt(hex2, 16);
  return hex2.length > 6 ? { r: num >> 24 & 255, g: num >> 16 & 255, b: num >> 8 & 255, a: Math.round((num & 255) / 2.55) } : { r: num >> 16, g: num >> 8 & 255, b: num & 255 };
}
function hsvToRgb({ h: h138, s: s4, v, a: a4 }) {
  let r, g2, b3;
  s4 = s4 / 100;
  v = v / 100;
  h138 = h138 / 360;
  const i3 = Math.floor(h138 * 6), f = h138 * 6 - i3, p2 = v * (1 - s4), q3 = v * (1 - f * s4), t3 = v * (1 - (1 - f) * s4);
  switch (i3 % 6) {
    case 0:
      r = v;
      g2 = t3;
      b3 = p2;
      break;
    case 1:
      r = q3;
      g2 = v;
      b3 = p2;
      break;
    case 2:
      r = p2;
      g2 = v;
      b3 = t3;
      break;
    case 3:
      r = p2;
      g2 = q3;
      b3 = v;
      break;
    case 4:
      r = t3;
      g2 = p2;
      b3 = v;
      break;
    case 5:
      r = v;
      g2 = p2;
      b3 = q3;
      break;
  }
  return {
    r: Math.round(r * 255),
    g: Math.round(g2 * 255),
    b: Math.round(b3 * 255),
    a: a4
  };
}
function rgbToHsv({ r, g: g2, b: b3, a: a4 }) {
  const max2 = Math.max(r, g2, b3), min2 = Math.min(r, g2, b3), d4 = max2 - min2, s4 = max2 === 0 ? 0 : d4 / max2, v = max2 / 255;
  let h138;
  switch (max2) {
    case min2:
      h138 = 0;
      break;
    case r:
      h138 = g2 - b3 + d4 * (g2 < b3 ? 6 : 0);
      h138 /= 6 * d4;
      break;
    case g2:
      h138 = b3 - r + d4 * 2;
      h138 /= 6 * d4;
      break;
    case b3:
      h138 = r - g2 + d4 * 4;
      h138 /= 6 * d4;
      break;
  }
  return {
    h: Math.round(h138 * 360),
    s: Math.round(s4 * 100),
    v: Math.round(v * 100),
    a: a4
  };
}
function textToRgb(str) {
  if (typeof str !== "string") {
    throw new TypeError("Expected a string");
  }
  const color2 = str.replace(/ /g, "");
  const m4 = reRGBA.exec(color2);
  if (m4 === null) {
    return hexToRgb(color2);
  }
  const rgb2 = {
    r: Math.min(255, parseInt(m4[2], 10)),
    g: Math.min(255, parseInt(m4[3], 10)),
    b: Math.min(255, parseInt(m4[4], 10))
  };
  if (m4[1]) {
    const alpha2 = parseFloat(m4[5]);
    rgb2.a = Math.min(1, isNaN(alpha2) === true ? 1 : alpha2) * 100;
  }
  return rgb2;
}
function luminosity(color2) {
  if (typeof color2 !== "string" && (!color2 || color2.r === void 0)) {
    throw new TypeError("Expected a string or a {r, g, b} object as color");
  }
  const rgb2 = typeof color2 === "string" ? textToRgb(color2) : color2, r = rgb2.r / 255, g2 = rgb2.g / 255, b3 = rgb2.b / 255, R3 = r <= 0.03928 ? r / 12.92 : Math.pow((r + 0.055) / 1.055, 2.4), G3 = g2 <= 0.03928 ? g2 / 12.92 : Math.pow((g2 + 0.055) / 1.055, 2.4), B3 = b3 <= 0.03928 ? b3 / 12.92 : Math.pow((b3 + 0.055) / 1.055, 2.4);
  return 0.2126 * R3 + 0.7152 * G3 + 0.0722 * B3;
}
var palette = [
  "rgb(255,204,204)",
  "rgb(255,230,204)",
  "rgb(255,255,204)",
  "rgb(204,255,204)",
  "rgb(204,255,230)",
  "rgb(204,255,255)",
  "rgb(204,230,255)",
  "rgb(204,204,255)",
  "rgb(230,204,255)",
  "rgb(255,204,255)",
  "rgb(255,153,153)",
  "rgb(255,204,153)",
  "rgb(255,255,153)",
  "rgb(153,255,153)",
  "rgb(153,255,204)",
  "rgb(153,255,255)",
  "rgb(153,204,255)",
  "rgb(153,153,255)",
  "rgb(204,153,255)",
  "rgb(255,153,255)",
  "rgb(255,102,102)",
  "rgb(255,179,102)",
  "rgb(255,255,102)",
  "rgb(102,255,102)",
  "rgb(102,255,179)",
  "rgb(102,255,255)",
  "rgb(102,179,255)",
  "rgb(102,102,255)",
  "rgb(179,102,255)",
  "rgb(255,102,255)",
  "rgb(255,51,51)",
  "rgb(255,153,51)",
  "rgb(255,255,51)",
  "rgb(51,255,51)",
  "rgb(51,255,153)",
  "rgb(51,255,255)",
  "rgb(51,153,255)",
  "rgb(51,51,255)",
  "rgb(153,51,255)",
  "rgb(255,51,255)",
  "rgb(255,0,0)",
  "rgb(255,128,0)",
  "rgb(255,255,0)",
  "rgb(0,255,0)",
  "rgb(0,255,128)",
  "rgb(0,255,255)",
  "rgb(0,128,255)",
  "rgb(0,0,255)",
  "rgb(128,0,255)",
  "rgb(255,0,255)",
  "rgb(245,0,0)",
  "rgb(245,123,0)",
  "rgb(245,245,0)",
  "rgb(0,245,0)",
  "rgb(0,245,123)",
  "rgb(0,245,245)",
  "rgb(0,123,245)",
  "rgb(0,0,245)",
  "rgb(123,0,245)",
  "rgb(245,0,245)",
  "rgb(214,0,0)",
  "rgb(214,108,0)",
  "rgb(214,214,0)",
  "rgb(0,214,0)",
  "rgb(0,214,108)",
  "rgb(0,214,214)",
  "rgb(0,108,214)",
  "rgb(0,0,214)",
  "rgb(108,0,214)",
  "rgb(214,0,214)",
  "rgb(163,0,0)",
  "rgb(163,82,0)",
  "rgb(163,163,0)",
  "rgb(0,163,0)",
  "rgb(0,163,82)",
  "rgb(0,163,163)",
  "rgb(0,82,163)",
  "rgb(0,0,163)",
  "rgb(82,0,163)",
  "rgb(163,0,163)",
  "rgb(92,0,0)",
  "rgb(92,46,0)",
  "rgb(92,92,0)",
  "rgb(0,92,0)",
  "rgb(0,92,46)",
  "rgb(0,92,92)",
  "rgb(0,46,92)",
  "rgb(0,0,92)",
  "rgb(46,0,92)",
  "rgb(92,0,92)",
  "rgb(255,255,255)",
  "rgb(205,205,205)",
  "rgb(178,178,178)",
  "rgb(153,153,153)",
  "rgb(127,127,127)",
  "rgb(102,102,102)",
  "rgb(76,76,76)",
  "rgb(51,51,51)",
  "rgb(25,25,25)",
  "rgb(0,0,0)"
];
var thumbPath = "M5 5 h10 v10 h-10 v-10 z";
var alphaTrackImg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAH0lEQVQoU2NkYGAwZkAFZ5G5jPRRgOYEVDeB3EBjBQBOZwTVugIGyAAAAABJRU5ErkJggg==";
createComponent({
  name: "QColor",
  props: {
    ...useDarkProps,
    ...useFormProps,
    modelValue: String,
    defaultValue: String,
    defaultView: {
      type: String,
      default: "spectrum",
      validator: (v) => ["spectrum", "tune", "palette"].includes(v)
    },
    formatModel: {
      type: String,
      default: "auto",
      validator: (v) => ["auto", "hex", "rgb", "hexa", "rgba"].includes(v)
    },
    palette: Array,
    noHeader: Boolean,
    noHeaderTabs: Boolean,
    noFooter: Boolean,
    square: Boolean,
    flat: Boolean,
    bordered: Boolean,
    disable: Boolean,
    readonly: Boolean
  },
  emits: ["update:modelValue", "change"],
  setup(props4, { emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const isDark = use_dark_default(props4, $q);
    const { getCache } = use_render_cache_default();
    const spectrumRef = ref$1(null);
    const errorIconRef = ref$1(null);
    const forceHex = computed(() => props4.formatModel === "auto" ? null : props4.formatModel.indexOf("hex") !== -1);
    const forceAlpha = computed(() => props4.formatModel === "auto" ? null : props4.formatModel.indexOf("a") !== -1);
    const topView = ref$1(
      props4.formatModel === "auto" ? props4.modelValue === void 0 || props4.modelValue === null || props4.modelValue === "" || props4.modelValue.startsWith("#") ? "hex" : "rgb" : props4.formatModel.startsWith("hex") ? "hex" : "rgb"
    );
    const view = ref$1(props4.defaultView);
    const model = ref$1(parseModel(props4.modelValue || props4.defaultValue));
    const editable = computed(() => props4.disable !== true && props4.readonly !== true);
    const isHex2 = computed(
      () => props4.modelValue === void 0 || props4.modelValue === null || props4.modelValue === "" || props4.modelValue.startsWith("#")
    );
    const isOutputHex = computed(() => forceHex.value !== null ? forceHex.value : isHex2.value);
    const formAttrs = computed(() => ({
      type: "hidden",
      name: props4.name,
      value: model.value[isOutputHex.value === true ? "hex" : "rgb"]
    }));
    const injectFormInput = useFormInject(formAttrs);
    const hasAlpha = computed(() => forceAlpha.value !== null ? forceAlpha.value : model.value.a !== void 0);
    const currentBgColor = computed(() => ({
      backgroundColor: model.value.rgb || "#000"
    }));
    const headerClass = computed(() => {
      const light = model.value.a !== void 0 && model.value.a < 65 ? true : luminosity(model.value) > 0.4;
      return `q-color-picker__header-content q-color-picker__header-content--${light ? "light" : "dark"}`;
    });
    const spectrumStyle = computed(() => ({
      background: `hsl(${model.value.h},100%,50%)`
    }));
    const spectrumPointerStyle = computed(() => ({
      top: `${100 - model.value.v}%`,
      [$q.lang.rtl === true ? "right" : "left"]: `${model.value.s}%`
    }));
    const computedPalette = computed(() => props4.palette !== void 0 && props4.palette.length !== 0 ? props4.palette : palette);
    const classes = computed(
      () => "q-color-picker" + (props4.bordered === true ? " q-color-picker--bordered" : "") + (props4.square === true ? " q-color-picker--square no-border-radius" : "") + (props4.flat === true ? " q-color-picker--flat no-shadow" : "") + (props4.disable === true ? " disabled" : "") + (isDark.value === true ? " q-color-picker--dark q-dark" : "")
    );
    const attributes = computed(() => props4.disable === true ? { "aria-disabled": "true" } : {});
    const spectrumDirective = computed(() => {
      return [[
        TouchPan_default,
        onSpectrumPan,
        void 0,
        { prevent: true, stop: true, mouse: true }
      ]];
    });
    watch(() => props4.modelValue, (v) => {
      const localModel = parseModel(v || props4.defaultValue);
      if (localModel.hex !== model.value.hex) {
        model.value = localModel;
      }
    });
    watch(() => props4.defaultValue, (v) => {
      if (!props4.modelValue && v) {
        const localModel = parseModel(v);
        if (localModel.hex !== model.value.hex) {
          model.value = localModel;
        }
      }
    });
    function updateModel2(rgb2, change) {
      model.value.hex = rgbToHex(rgb2);
      model.value.rgb = rgbToString(rgb2);
      model.value.r = rgb2.r;
      model.value.g = rgb2.g;
      model.value.b = rgb2.b;
      model.value.a = rgb2.a;
      const value2 = model.value[isOutputHex.value === true ? "hex" : "rgb"];
      emit("update:modelValue", value2);
      change === true && emit("change", value2);
    }
    function parseModel(v) {
      const alpha2 = forceAlpha.value !== void 0 ? forceAlpha.value : props4.formatModel === "auto" ? null : props4.formatModel.indexOf("a") !== -1;
      if (typeof v !== "string" || v.length === 0 || testPattern.anyColor(v.replace(/ /g, "")) !== true) {
        return {
          h: 0,
          s: 0,
          v: 0,
          r: 0,
          g: 0,
          b: 0,
          a: alpha2 === true ? 100 : void 0,
          hex: void 0,
          rgb: void 0
        };
      }
      const model2 = textToRgb(v);
      if (alpha2 === true && model2.a === void 0) {
        model2.a = 100;
      }
      model2.hex = rgbToHex(model2);
      model2.rgb = rgbToString(model2);
      return Object.assign(model2, rgbToHsv(model2));
    }
    function changeSpectrum(left, top, change) {
      const panel = spectrumRef.value;
      if (panel === null) return;
      const width3 = panel.clientWidth, height2 = panel.clientHeight, rect = panel.getBoundingClientRect();
      let x3 = Math.min(width3, Math.max(0, left - rect.left));
      if ($q.lang.rtl === true) {
        x3 = width3 - x3;
      }
      const y4 = Math.min(height2, Math.max(0, top - rect.top)), s4 = Math.round(100 * x3 / width3), v = Math.round(100 * Math.max(0, Math.min(1, -(y4 / height2) + 1))), rgb2 = hsvToRgb({
        h: model.value.h,
        s: s4,
        v,
        a: hasAlpha.value === true ? model.value.a : void 0
      });
      model.value.s = s4;
      model.value.v = v;
      updateModel2(rgb2, change);
    }
    function onHue(val, change) {
      const h138 = Math.round(val);
      const rgb2 = hsvToRgb({
        h: h138,
        s: model.value.s,
        v: model.value.v,
        a: hasAlpha.value === true ? model.value.a : void 0
      });
      model.value.h = h138;
      updateModel2(rgb2, change);
    }
    function onHueChange(val) {
      onHue(val, true);
    }
    function onNumericChange(value2, formatModel, max2, evt, change) {
      evt !== void 0 && stop(evt);
      if (!/^[0-9]+$/.test(value2)) {
        change === true && proxy.$forceUpdate();
        return;
      }
      const val = Math.floor(Number(value2));
      if (val < 0 || val > max2) {
        change === true && proxy.$forceUpdate();
        return;
      }
      const rgb2 = {
        r: formatModel === "r" ? val : model.value.r,
        g: formatModel === "g" ? val : model.value.g,
        b: formatModel === "b" ? val : model.value.b,
        a: hasAlpha.value === true ? formatModel === "a" ? val : model.value.a : void 0
      };
      if (formatModel !== "a") {
        const hsv = rgbToHsv(rgb2);
        model.value.h = hsv.h;
        model.value.s = hsv.s;
        model.value.v = hsv.v;
      }
      updateModel2(rgb2, change);
      if (change !== true && (evt == null ? void 0 : evt.target.selectionEnd) !== void 0) {
        const index2 = evt.target.selectionEnd;
        nextTick(() => {
          evt.target.setSelectionRange(index2, index2);
        });
      }
    }
    function onEditorChange(evt, change) {
      let rgb2;
      const inp = evt.target.value;
      stop(evt);
      if (topView.value === "hex") {
        if (inp.length !== (hasAlpha.value === true ? 9 : 7) || !/^#[0-9A-Fa-f]+$/.test(inp)) {
          return true;
        }
        rgb2 = hexToRgb(inp);
      } else {
        let model2;
        if (!inp.endsWith(")")) {
          return true;
        } else if (hasAlpha.value !== true && inp.startsWith("rgb(")) {
          model2 = inp.substring(4, inp.length - 1).split(",").map((n) => parseInt(n, 10));
          if (model2.length !== 3 || !/^rgb\([0-9]{1,3},[0-9]{1,3},[0-9]{1,3}\)$/.test(inp)) {
            return true;
          }
        } else if (hasAlpha.value === true && inp.startsWith("rgba(")) {
          model2 = inp.substring(5, inp.length - 1).split(",");
          if (model2.length !== 4 || !/^rgba\([0-9]{1,3},[0-9]{1,3},[0-9]{1,3},(0|0\.[0-9]+[1-9]|0\.[1-9]+|1)\)$/.test(inp)) {
            return true;
          }
          for (let i3 = 0; i3 < 3; i3++) {
            const v2 = parseInt(model2[i3], 10);
            if (v2 < 0 || v2 > 255) {
              return true;
            }
            model2[i3] = v2;
          }
          const v = parseFloat(model2[3]);
          if (v < 0 || v > 1) {
            return true;
          }
          model2[3] = v;
        } else {
          return true;
        }
        if (model2[0] < 0 || model2[0] > 255 || model2[1] < 0 || model2[1] > 255 || model2[2] < 0 || model2[2] > 255 || hasAlpha.value === true && (model2[3] < 0 || model2[3] > 1)) {
          return true;
        }
        rgb2 = {
          r: model2[0],
          g: model2[1],
          b: model2[2],
          a: hasAlpha.value === true ? model2[3] * 100 : void 0
        };
      }
      const hsv = rgbToHsv(rgb2);
      model.value.h = hsv.h;
      model.value.s = hsv.s;
      model.value.v = hsv.v;
      updateModel2(rgb2, change);
      if (change !== true) {
        const index2 = evt.target.selectionEnd;
        nextTick(() => {
          evt.target.setSelectionRange(index2, index2);
        });
      }
    }
    function onPalettePick(color2) {
      const def = parseModel(color2);
      const rgb2 = { r: def.r, g: def.g, b: def.b, a: def.a };
      if (rgb2.a === void 0) {
        rgb2.a = model.value.a;
      }
      model.value.h = def.h;
      model.value.s = def.s;
      model.value.v = def.v;
      updateModel2(rgb2, true);
    }
    function onSpectrumPan(evt) {
      if (evt.isFinal) {
        changeSpectrum(
          evt.position.left,
          evt.position.top,
          true
        );
      } else {
        onSpectrumChange(evt);
      }
    }
    const onSpectrumChange = throttle_default(
      (evt) => {
        changeSpectrum(evt.position.left, evt.position.top);
      },
      20
    );
    function onSpectrumClick(evt) {
      changeSpectrum(
        evt.pageX - window.pageXOffset,
        evt.pageY - window.pageYOffset,
        true
      );
    }
    function onActivate(evt) {
      changeSpectrum(
        evt.pageX - window.pageXOffset,
        evt.pageY - window.pageYOffset
      );
    }
    function updateErrorIcon(val) {
      if (errorIconRef.value !== null) {
        errorIconRef.value.$el.style.opacity = val ? 1 : 0;
      }
    }
    function setTopView(val) {
      topView.value = val;
    }
    function getHeader() {
      const child = [];
      props4.noHeaderTabs !== true && child.push(
        h(QTabs_default, {
          class: "q-color-picker__header-tabs",
          modelValue: topView.value,
          dense: true,
          align: "justify",
          "onUpdate:modelValue": setTopView
        }, () => [
          h(QTab_default, {
            label: "HEX" + (hasAlpha.value === true ? "A" : ""),
            name: "hex",
            ripple: false
          }),
          h(QTab_default, {
            label: "RGB" + (hasAlpha.value === true ? "A" : ""),
            name: "rgb",
            ripple: false
          })
        ])
      );
      child.push(
        h("div", {
          class: "q-color-picker__header-banner row flex-center no-wrap"
        }, [
          h("input", {
            class: "fit",
            value: model.value[topView.value],
            ...editable.value !== true ? { readonly: true } : {},
            ...getCache("topIn", {
              onInput: (evt) => {
                updateErrorIcon(onEditorChange(evt) === true);
              },
              onChange: stop,
              onBlur: (evt) => {
                onEditorChange(evt, true) === true && proxy.$forceUpdate();
                updateErrorIcon(false);
              }
            })
          }),
          h(QIcon_default, {
            ref: errorIconRef,
            class: "q-color-picker__error-icon absolute no-pointer-events",
            name: $q.iconSet.type.negative
          })
        ])
      );
      return h("div", {
        class: "q-color-picker__header relative-position overflow-hidden"
      }, [
        h("div", { class: "q-color-picker__header-bg absolute-full" }),
        h("div", {
          class: headerClass.value,
          style: currentBgColor.value
        }, child)
      ]);
    }
    function getContent() {
      return h(QTabPanels_default, {
        modelValue: view.value,
        animated: true
      }, () => [
        h(QTabPanel_default, {
          class: "q-color-picker__spectrum-tab overflow-hidden",
          name: "spectrum"
        }, getSpectrumTab),
        h(QTabPanel_default, {
          class: "q-pa-md q-color-picker__tune-tab",
          name: "tune"
        }, getTuneTab),
        h(QTabPanel_default, {
          class: "q-color-picker__palette-tab",
          name: "palette"
        }, getPaletteTab)
      ]);
    }
    function setView(val) {
      view.value = val;
    }
    function getFooter() {
      return h("div", {
        class: "q-color-picker__footer relative-position overflow-hidden"
      }, [
        h(QTabs_default, {
          class: "absolute-full",
          modelValue: view.value,
          dense: true,
          align: "justify",
          "onUpdate:modelValue": setView
        }, () => [
          h(QTab_default, {
            icon: $q.iconSet.colorPicker.spectrum,
            name: "spectrum",
            ripple: false
          }),
          h(QTab_default, {
            icon: $q.iconSet.colorPicker.tune,
            name: "tune",
            ripple: false
          }),
          h(QTab_default, {
            icon: $q.iconSet.colorPicker.palette,
            name: "palette",
            ripple: false
          })
        ])
      ]);
    }
    function getSpectrumTab() {
      const data = {
        ref: spectrumRef,
        class: "q-color-picker__spectrum non-selectable relative-position cursor-pointer" + (editable.value !== true ? " readonly" : ""),
        style: spectrumStyle.value,
        ...editable.value === true ? {
          onClick: onSpectrumClick,
          onMousedown: onActivate
        } : {}
      };
      const child = [
        h("div", { style: { paddingBottom: "100%" } }),
        h("div", { class: "q-color-picker__spectrum-white absolute-full" }),
        h("div", { class: "q-color-picker__spectrum-black absolute-full" }),
        h("div", {
          class: "absolute",
          style: spectrumPointerStyle.value
        }, [
          model.value.hex !== void 0 ? h("div", { class: "q-color-picker__spectrum-circle" }) : null
        ])
      ];
      const sliders = [
        h(QSlider_default, {
          class: "q-color-picker__hue non-selectable",
          modelValue: model.value.h,
          min: 0,
          max: 360,
          trackSize: "8px",
          innerTrackColor: "transparent",
          selectionColor: "transparent",
          readonly: editable.value !== true,
          thumbPath,
          "onUpdate:modelValue": onHue,
          onChange: onHueChange
        })
      ];
      hasAlpha.value === true && sliders.push(
        h(QSlider_default, {
          class: "q-color-picker__alpha non-selectable",
          modelValue: model.value.a,
          min: 0,
          max: 100,
          trackSize: "8px",
          trackColor: "white",
          innerTrackColor: "transparent",
          selectionColor: "transparent",
          trackImg: alphaTrackImg,
          readonly: editable.value !== true,
          hideSelection: true,
          thumbPath,
          ...getCache("alphaSlide", {
            "onUpdate:modelValue": (value2) => onNumericChange(value2, "a", 100),
            onChange: (value2) => onNumericChange(value2, "a", 100, void 0, true)
          })
        })
      );
      return [
        hDir("div", data, child, "spec", editable.value, () => spectrumDirective.value),
        h("div", { class: "q-color-picker__sliders" }, sliders)
      ];
    }
    function getTuneTab() {
      return [
        h("div", { class: "row items-center no-wrap" }, [
          h("div", "R"),
          h(QSlider_default, {
            modelValue: model.value.r,
            min: 0,
            max: 255,
            color: "red",
            dark: isDark.value,
            readonly: editable.value !== true,
            ...getCache("rSlide", {
              "onUpdate:modelValue": (value2) => onNumericChange(value2, "r", 255),
              onChange: (value2) => onNumericChange(value2, "r", 255, void 0, true)
            })
          }),
          h("input", {
            value: model.value.r,
            maxlength: 3,
            readonly: editable.value !== true,
            onChange: stop,
            ...getCache("rIn", {
              onInput: (evt) => onNumericChange(evt.target.value, "r", 255, evt),
              onBlur: (evt) => onNumericChange(evt.target.value, "r", 255, evt, true)
            })
          })
        ]),
        h("div", { class: "row items-center no-wrap" }, [
          h("div", "G"),
          h(QSlider_default, {
            modelValue: model.value.g,
            min: 0,
            max: 255,
            color: "green",
            dark: isDark.value,
            readonly: editable.value !== true,
            ...getCache("gSlide", {
              "onUpdate:modelValue": (value2) => onNumericChange(value2, "g", 255),
              onChange: (value2) => onNumericChange(value2, "g", 255, void 0, true)
            })
          }),
          h("input", {
            value: model.value.g,
            maxlength: 3,
            readonly: editable.value !== true,
            onChange: stop,
            ...getCache("gIn", {
              onInput: (evt) => onNumericChange(evt.target.value, "g", 255, evt),
              onBlur: (evt) => onNumericChange(evt.target.value, "g", 255, evt, true)
            })
          })
        ]),
        h("div", { class: "row items-center no-wrap" }, [
          h("div", "B"),
          h(QSlider_default, {
            modelValue: model.value.b,
            min: 0,
            max: 255,
            color: "blue",
            readonly: editable.value !== true,
            dark: isDark.value,
            ...getCache("bSlide", {
              "onUpdate:modelValue": (value2) => onNumericChange(value2, "b", 255),
              onChange: (value2) => onNumericChange(value2, "b", 255, void 0, true)
            })
          }),
          h("input", {
            value: model.value.b,
            maxlength: 3,
            readonly: editable.value !== true,
            onChange: stop,
            ...getCache("bIn", {
              onInput: (evt) => onNumericChange(evt.target.value, "b", 255, evt),
              onBlur: (evt) => onNumericChange(evt.target.value, "b", 255, evt, true)
            })
          })
        ]),
        hasAlpha.value === true ? h("div", { class: "row items-center no-wrap" }, [
          h("div", "A"),
          h(QSlider_default, {
            modelValue: model.value.a,
            color: "grey",
            readonly: editable.value !== true,
            dark: isDark.value,
            ...getCache("aSlide", {
              "onUpdate:modelValue": (value2) => onNumericChange(value2, "a", 100),
              onChange: (value2) => onNumericChange(value2, "a", 100, void 0, true)
            })
          }),
          h("input", {
            value: model.value.a,
            maxlength: 3,
            readonly: editable.value !== true,
            onChange: stop,
            ...getCache("aIn", {
              onInput: (evt) => onNumericChange(evt.target.value, "a", 100, evt),
              onBlur: (evt) => onNumericChange(evt.target.value, "a", 100, evt, true)
            })
          })
        ]) : null
      ];
    }
    function getPaletteTab() {
      const fn = (color2) => h("div", {
        class: "q-color-picker__cube col-auto",
        style: { backgroundColor: color2 },
        ...editable.value === true ? getCache("palette#" + color2, {
          onClick: () => {
            onPalettePick(color2);
          }
        }) : {}
      });
      return [
        h("div", {
          class: "row items-center q-color-picker__palette-rows" + (editable.value === true ? " q-color-picker__palette-rows--editable" : "")
        }, computedPalette.value.map(fn))
      ];
    }
    return () => {
      const child = [getContent()];
      if (props4.name !== void 0 && props4.disable !== true) {
        injectFormInput(child, "push");
      }
      props4.noHeader !== true && child.unshift(
        getHeader()
      );
      props4.noFooter !== true && child.push(
        getFooter()
      );
      return h("div", {
        class: classes.value,
        ...attributes.value
      }, child);
    };
  }
});
var breaks = [
  -61,
  9,
  38,
  199,
  426,
  686,
  756,
  818,
  1111,
  1181,
  1210,
  1635,
  2060,
  2097,
  2192,
  2262,
  2324,
  2394,
  2456,
  3178
];
function toJalaali(gy, gm, gd) {
  if (Object.prototype.toString.call(gy) === "[object Date]") {
    gd = gy.getDate();
    gm = gy.getMonth() + 1;
    gy = gy.getFullYear();
  }
  return d2j(g2d(gy, gm, gd));
}
function toGregorian(jy, jm, jd) {
  return d2g(j2d(jy, jm, jd));
}
function isLeapJalaaliYear(jy) {
  return jalCalLeap(jy) === 0;
}
function jalaaliMonthLength(jy, jm) {
  if (jm <= 6) return 31;
  if (jm <= 11) return 30;
  if (isLeapJalaaliYear(jy)) return 30;
  return 29;
}
function jalCalLeap(jy) {
  const bl = breaks.length;
  let jp = breaks[0], jm, jump, leap, n, i3;
  if (jy < jp || jy >= breaks[bl - 1]) {
    throw new Error("Invalid Jalaali year " + jy);
  }
  for (i3 = 1; i3 < bl; i3 += 1) {
    jm = breaks[i3];
    jump = jm - jp;
    if (jy < jm) {
      break;
    }
    jp = jm;
  }
  n = jy - jp;
  if (jump - n < 6) {
    n = n - jump + div(jump + 4, 33) * 33;
  }
  leap = mod(mod(n + 1, 33) - 1, 4);
  if (leap === -1) {
    leap = 4;
  }
  return leap;
}
function jalCal(jy, withoutLeap) {
  const bl = breaks.length, gy = jy + 621;
  let leapJ = -14, jp = breaks[0], jm, jump, leap, n, i3;
  if (jy < jp || jy >= breaks[bl - 1]) {
    throw new Error("Invalid Jalaali year " + jy);
  }
  for (i3 = 1; i3 < bl; i3 += 1) {
    jm = breaks[i3];
    jump = jm - jp;
    if (jy < jm) {
      break;
    }
    leapJ = leapJ + div(jump, 33) * 8 + div(mod(jump, 33), 4);
    jp = jm;
  }
  n = jy - jp;
  leapJ = leapJ + div(n, 33) * 8 + div(mod(n, 33) + 3, 4);
  if (mod(jump, 33) === 4 && jump - n === 4) {
    leapJ += 1;
  }
  const leapG = div(gy, 4) - div((div(gy, 100) + 1) * 3, 4) - 150;
  const march = 20 + leapJ - leapG;
  if (!withoutLeap) {
    if (jump - n < 6) {
      n = n - jump + div(jump + 4, 33) * 33;
    }
    leap = mod(mod(n + 1, 33) - 1, 4);
    if (leap === -1) {
      leap = 4;
    }
  }
  return {
    leap,
    gy,
    march
  };
}
function j2d(jy, jm, jd) {
  const r = jalCal(jy, true);
  return g2d(r.gy, 3, r.march) + (jm - 1) * 31 - div(jm, 7) * (jm - 7) + jd - 1;
}
function d2j(jdn) {
  const gy = d2g(jdn).gy;
  let jy = gy - 621, jd, jm, k3;
  const r = jalCal(jy, false), jdn1f = g2d(gy, 3, r.march);
  k3 = jdn - jdn1f;
  if (k3 >= 0) {
    if (k3 <= 185) {
      jm = 1 + div(k3, 31);
      jd = mod(k3, 31) + 1;
      return {
        jy,
        jm,
        jd
      };
    } else {
      k3 -= 186;
    }
  } else {
    jy -= 1;
    k3 += 179;
    if (r.leap === 1) {
      k3 += 1;
    }
  }
  jm = 7 + div(k3, 30);
  jd = mod(k3, 30) + 1;
  return {
    jy,
    jm,
    jd
  };
}
function g2d(gy, gm, gd) {
  let d4 = div((gy + div(gm - 8, 6) + 100100) * 1461, 4) + div(153 * mod(gm + 9, 12) + 2, 5) + gd - 34840408;
  d4 = d4 - div(div(gy + 100100 + div(gm - 8, 6), 100) * 3, 4) + 752;
  return d4;
}
function d2g(jdn) {
  let j = 4 * jdn + 139361631;
  j = j + div(div(4 * jdn + 183187720, 146097) * 3, 4) * 4 - 3908;
  const i3 = div(mod(j, 1461), 4) * 5 + 308, gd = div(mod(i3, 153), 5) + 1, gm = mod(div(i3, 153), 12) + 1, gy = div(j, 1461) - 100100 + div(8 - gm, 6);
  return {
    gy,
    gm,
    gd
  };
}
function div(a4, b3) {
  return ~~(a4 / b3);
}
function mod(a4, b3) {
  return a4 - ~~(a4 / b3) * b3;
}
var calendars = ["gregorian", "persian"];
var useDatetimeProps = {
  // should define modelValue in the target component
  mask: {
    type: String
  },
  locale: Object,
  calendar: {
    type: String,
    validator: (v) => calendars.includes(v),
    default: "gregorian"
  },
  landscape: Boolean,
  color: String,
  textColor: String,
  square: Boolean,
  flat: Boolean,
  bordered: Boolean,
  readonly: Boolean,
  disable: Boolean
};
var useDatetimeEmits = ["update:modelValue"];
function getDayHash(date) {
  return date.year + "/" + pad(date.month) + "/" + pad(date.day);
}
function use_datetime_default(props4, $q) {
  const editable = computed(() => {
    return props4.disable !== true && props4.readonly !== true;
  });
  const tabindex = computed(() => {
    return editable.value === true ? 0 : -1;
  });
  const headerClass = computed(() => {
    const cls = [];
    props4.color !== void 0 && cls.push(`bg-${props4.color}`);
    props4.textColor !== void 0 && cls.push(`text-${props4.textColor}`);
    return cls.join(" ");
  });
  function getLocale2() {
    return props4.locale !== void 0 ? { ...$q.lang.date, ...props4.locale } : $q.lang.date;
  }
  function getCurrentDate(dateOnly) {
    const d4 = /* @__PURE__ */ new Date();
    const timeFill = dateOnly === true ? null : 0;
    if (props4.calendar === "persian") {
      const jDate = toJalaali(d4);
      return {
        year: jDate.jy,
        month: jDate.jm,
        day: jDate.jd
      };
    }
    return {
      year: d4.getFullYear(),
      month: d4.getMonth() + 1,
      day: d4.getDate(),
      hour: timeFill,
      minute: timeFill,
      second: timeFill,
      millisecond: timeFill
    };
  }
  return {
    editable,
    tabindex,
    headerClass,
    getLocale: getLocale2,
    getCurrentDate
  };
}
var MILLISECONDS_IN_DAY = 864e5;
var MILLISECONDS_IN_HOUR = 36e5;
var MILLISECONDS_IN_MINUTE = 6e4;
var defaultMask = "YYYY-MM-DDTHH:mm:ss.SSSZ";
var token = /\[((?:[^\]\\]|\\]|\\)*)\]|do|d{1,4}|Mo|M{1,4}|m{1,2}|wo|w{1,2}|Qo|Do|DDDo|D{1,4}|YY(?:YY)?|H{1,2}|h{1,2}|s{1,2}|S{1,3}|Z{1,2}|a{1,2}|[AQExX]/g;
var reverseToken = /(\[[^\]]*\])|do|d{1,4}|Mo|M{1,4}|m{1,2}|wo|w{1,2}|Qo|Do|DDDo|D{1,4}|YY(?:YY)?|H{1,2}|h{1,2}|s{1,2}|S{1,3}|Z{1,2}|a{1,2}|[AQExX]|([.*+:?^,\s${}()|\\]+)/g;
var regexStore = {};
function getRegexData(mask, dateLocale) {
  const days = "(" + dateLocale.days.join("|") + ")", key = mask + days;
  if (regexStore[key] !== void 0) {
    return regexStore[key];
  }
  const daysShort = "(" + dateLocale.daysShort.join("|") + ")", months = "(" + dateLocale.months.join("|") + ")", monthsShort = "(" + dateLocale.monthsShort.join("|") + ")";
  const map2 = {};
  let index2 = 0;
  const regexText = mask.replace(reverseToken, (match2) => {
    index2++;
    switch (match2) {
      case "YY":
        map2.YY = index2;
        return "(-?\\d{1,2})";
      case "YYYY":
        map2.YYYY = index2;
        return "(-?\\d{1,4})";
      case "M":
        map2.M = index2;
        return "(\\d{1,2})";
      case "Mo":
        map2.M = index2++;
        return "(\\d{1,2}(st|nd|rd|th))";
      case "MM":
        map2.M = index2;
        return "(\\d{2})";
      case "MMM":
        map2.MMM = index2;
        return monthsShort;
      case "MMMM":
        map2.MMMM = index2;
        return months;
      case "D":
        map2.D = index2;
        return "(\\d{1,2})";
      case "Do":
        map2.D = index2++;
        return "(\\d{1,2}(st|nd|rd|th))";
      case "DD":
        map2.D = index2;
        return "(\\d{2})";
      case "H":
        map2.H = index2;
        return "(\\d{1,2})";
      case "HH":
        map2.H = index2;
        return "(\\d{2})";
      case "h":
        map2.h = index2;
        return "(\\d{1,2})";
      case "hh":
        map2.h = index2;
        return "(\\d{2})";
      case "m":
        map2.m = index2;
        return "(\\d{1,2})";
      case "mm":
        map2.m = index2;
        return "(\\d{2})";
      case "s":
        map2.s = index2;
        return "(\\d{1,2})";
      case "ss":
        map2.s = index2;
        return "(\\d{2})";
      case "S":
        map2.S = index2;
        return "(\\d{1})";
      case "SS":
        map2.S = index2;
        return "(\\d{2})";
      case "SSS":
        map2.S = index2;
        return "(\\d{3})";
      case "A":
        map2.A = index2;
        return "(AM|PM)";
      case "a":
        map2.a = index2;
        return "(am|pm)";
      case "aa":
        map2.aa = index2;
        return "(a\\.m\\.|p\\.m\\.)";
      case "ddd":
        return daysShort;
      case "dddd":
        return days;
      case "Q":
      case "d":
      case "E":
        return "(\\d{1})";
      case "do":
        index2++;
        return "(\\d{1}(st|nd|rd|th))";
      case "Qo":
        return "(1st|2nd|3rd|4th)";
      case "DDD":
      case "DDDD":
        return "(\\d{1,3})";
      case "DDDo":
        index2++;
        return "(\\d{1,3}(st|nd|rd|th))";
      case "w":
        return "(\\d{1,2})";
      case "wo":
        index2++;
        return "(\\d{1,2}(st|nd|rd|th))";
      case "ww":
        return "(\\d{2})";
      case "Z":
        map2.Z = index2;
        return "(Z|[+-]\\d{2}:\\d{2})";
      case "ZZ":
        map2.ZZ = index2;
        return "(Z|[+-]\\d{2}\\d{2})";
      case "X":
        map2.X = index2;
        return "(-?\\d+)";
      case "x":
        map2.x = index2;
        return "(-?\\d{4,})";
      default:
        index2--;
        if (match2[0] === "[") {
          match2 = match2.substring(1, match2.length - 1);
        }
        return match2.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
  });
  const res = { map: map2, regex: new RegExp("^" + regexText) };
  regexStore[key] = res;
  return res;
}
function getDateLocale(paramDateLocale, langProps) {
  return paramDateLocale !== void 0 ? paramDateLocale : langProps !== void 0 ? langProps.date : en_US_default.date;
}
function formatTimezone(offset2, delimeter = "") {
  const sign2 = offset2 > 0 ? "-" : "+", absOffset = Math.abs(offset2), hours = Math.floor(absOffset / 60), minutes = absOffset % 60;
  return sign2 + pad(hours) + delimeter + pad(minutes);
}
function __splitDate(str, mask, dateLocale, calendar, defaultModel) {
  const date = {
    year: null,
    month: null,
    day: null,
    hour: null,
    minute: null,
    second: null,
    millisecond: null,
    timezoneOffset: null,
    dateHash: null,
    timeHash: null
  };
  defaultModel !== void 0 && Object.assign(date, defaultModel);
  if (str === void 0 || str === null || str === "" || typeof str !== "string") {
    return date;
  }
  if (mask === void 0) {
    mask = defaultMask;
  }
  const langOpts = getDateLocale(dateLocale, Lang_default.props), months = langOpts.months, monthsShort = langOpts.monthsShort;
  const { regex, map: map2 } = getRegexData(mask, langOpts);
  const match2 = str.match(regex);
  if (match2 === null) {
    return date;
  }
  let tzString = "";
  if (map2.X !== void 0 || map2.x !== void 0) {
    const stamp = parseInt(match2[map2.X !== void 0 ? map2.X : map2.x], 10);
    if (isNaN(stamp) === true || stamp < 0) {
      return date;
    }
    const d4 = new Date(stamp * (map2.X !== void 0 ? 1e3 : 1));
    date.year = d4.getFullYear();
    date.month = d4.getMonth() + 1;
    date.day = d4.getDate();
    date.hour = d4.getHours();
    date.minute = d4.getMinutes();
    date.second = d4.getSeconds();
    date.millisecond = d4.getMilliseconds();
  } else {
    if (map2.YYYY !== void 0) {
      date.year = parseInt(match2[map2.YYYY], 10);
    } else if (map2.YY !== void 0) {
      const y4 = parseInt(match2[map2.YY], 10);
      date.year = y4 < 0 ? y4 : 2e3 + y4;
    }
    if (map2.M !== void 0) {
      date.month = parseInt(match2[map2.M], 10);
      if (date.month < 1 || date.month > 12) {
        return date;
      }
    } else if (map2.MMM !== void 0) {
      date.month = monthsShort.indexOf(match2[map2.MMM]) + 1;
    } else if (map2.MMMM !== void 0) {
      date.month = months.indexOf(match2[map2.MMMM]) + 1;
    }
    if (map2.D !== void 0) {
      date.day = parseInt(match2[map2.D], 10);
      if (date.year === null || date.month === null || date.day < 1) {
        return date;
      }
      const maxDay = calendar !== "persian" ? new Date(date.year, date.month, 0).getDate() : jalaaliMonthLength(date.year, date.month);
      if (date.day > maxDay) {
        return date;
      }
    }
    if (map2.H !== void 0) {
      date.hour = parseInt(match2[map2.H], 10) % 24;
    } else if (map2.h !== void 0) {
      date.hour = parseInt(match2[map2.h], 10) % 12;
      if (map2.A && match2[map2.A] === "PM" || map2.a && match2[map2.a] === "pm" || map2.aa && match2[map2.aa] === "p.m.") {
        date.hour += 12;
      }
      date.hour = date.hour % 24;
    }
    if (map2.m !== void 0) {
      date.minute = parseInt(match2[map2.m], 10) % 60;
    }
    if (map2.s !== void 0) {
      date.second = parseInt(match2[map2.s], 10) % 60;
    }
    if (map2.S !== void 0) {
      date.millisecond = parseInt(match2[map2.S], 10) * 10 ** (3 - match2[map2.S].length);
    }
    if (map2.Z !== void 0 || map2.ZZ !== void 0) {
      tzString = map2.Z !== void 0 ? match2[map2.Z].replace(":", "") : match2[map2.ZZ];
      date.timezoneOffset = (tzString[0] === "+" ? -1 : 1) * (60 * tzString.slice(1, 3) + 1 * tzString.slice(3, 5));
    }
  }
  date.dateHash = pad(date.year, 4) + "/" + pad(date.month) + "/" + pad(date.day);
  date.timeHash = pad(date.hour) + ":" + pad(date.minute) + ":" + pad(date.second) + tzString;
  return date;
}
function getWeekOfYear(date) {
  const thursday = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  thursday.setDate(thursday.getDate() - (thursday.getDay() + 6) % 7 + 3);
  const firstThursday = new Date(thursday.getFullYear(), 0, 4);
  firstThursday.setDate(firstThursday.getDate() - (firstThursday.getDay() + 6) % 7 + 3);
  const ds = thursday.getTimezoneOffset() - firstThursday.getTimezoneOffset();
  thursday.setHours(thursday.getHours() - ds);
  const weekDiff = (thursday - firstThursday) / (MILLISECONDS_IN_DAY * 7);
  return 1 + Math.floor(weekDiff);
}
function startOfDate(date, unit, utc) {
  const t3 = new Date(date), prefix = `set${utc === true ? "UTC" : ""}`;
  switch (unit) {
    case "year":
    case "years":
      t3[`${prefix}Month`](0);
    case "month":
    case "months":
      t3[`${prefix}Date`](1);
    case "day":
    case "days":
    case "date":
      t3[`${prefix}Hours`](0);
    case "hour":
    case "hours":
      t3[`${prefix}Minutes`](0);
    case "minute":
    case "minutes":
      t3[`${prefix}Seconds`](0);
    case "second":
    case "seconds":
      t3[`${prefix}Milliseconds`](0);
  }
  return t3;
}
function getDiff(t3, sub, interval) {
  return (t3.getTime() - t3.getTimezoneOffset() * MILLISECONDS_IN_MINUTE - (sub.getTime() - sub.getTimezoneOffset() * MILLISECONDS_IN_MINUTE)) / interval;
}
function getDateDiff(date, subtract, unit = "days") {
  const t3 = new Date(date), sub = new Date(subtract);
  switch (unit) {
    case "years":
    case "year":
      return t3.getFullYear() - sub.getFullYear();
    case "months":
    case "month":
      return (t3.getFullYear() - sub.getFullYear()) * 12 + t3.getMonth() - sub.getMonth();
    case "days":
    case "day":
    case "date":
      return getDiff(startOfDate(t3, "day"), startOfDate(sub, "day"), MILLISECONDS_IN_DAY);
    case "hours":
    case "hour":
      return getDiff(startOfDate(t3, "hour"), startOfDate(sub, "hour"), MILLISECONDS_IN_HOUR);
    case "minutes":
    case "minute":
      return getDiff(startOfDate(t3, "minute"), startOfDate(sub, "minute"), MILLISECONDS_IN_MINUTE);
    case "seconds":
    case "second":
      return getDiff(startOfDate(t3, "second"), startOfDate(sub, "second"), 1e3);
  }
}
function getDayOfYear(date) {
  return getDateDiff(date, startOfDate(date, "year"), "days") + 1;
}
function getOrdinal(n) {
  if (n >= 11 && n <= 13) {
    return `${n}th`;
  }
  switch (n % 10) {
    case 1:
      return `${n}st`;
    case 2:
      return `${n}nd`;
    case 3:
      return `${n}rd`;
  }
  return `${n}th`;
}
var formatter = {
  // Year: 00, 01, ..., 99
  YY(date, dateLocale, forcedYear) {
    const y4 = this.YYYY(date, dateLocale, forcedYear) % 100;
    return y4 >= 0 ? pad(y4) : "-" + pad(Math.abs(y4));
  },
  // Year: 1900, 1901, ..., 2099
  YYYY(date, _dateLocale, forcedYear) {
    return forcedYear !== void 0 && forcedYear !== null ? forcedYear : date.getFullYear();
  },
  // Month: 1, 2, ..., 12
  M(date) {
    return date.getMonth() + 1;
  },
  // Month: 1st, 2nd, ..., 12th
  Mo(date) {
    return getOrdinal(date.getMonth() + 1);
  },
  // Month: 01, 02, ..., 12
  MM(date) {
    return pad(date.getMonth() + 1);
  },
  // Month Short Name: Jan, Feb, ...
  MMM(date, dateLocale) {
    return dateLocale.monthsShort[date.getMonth()];
  },
  // Month Name: January, February, ...
  MMMM(date, dateLocale) {
    return dateLocale.months[date.getMonth()];
  },
  // Quarter: 1, 2, 3, 4
  Q(date) {
    return Math.ceil((date.getMonth() + 1) / 3);
  },
  // Quarter: 1st, 2nd, 3rd, 4th
  Qo(date) {
    return getOrdinal(this.Q(date));
  },
  // Day of month: 1, 2, ..., 31
  D(date) {
    return date.getDate();
  },
  // Day of month: 1st, 2nd, ..., 31st
  Do(date) {
    return getOrdinal(date.getDate());
  },
  // Day of month: 01, 02, ..., 31
  DD(date) {
    return pad(date.getDate());
  },
  // Day of year: 1, 2, ..., 366
  DDD(date) {
    return getDayOfYear(date);
  },
  // Day of year: 1st, 2nd, ..., 366th
  DDDo(date) {
    return getOrdinal(getDayOfYear(date));
  },
  // Day of year: 001, 002, ..., 366
  DDDD(date) {
    return pad(getDayOfYear(date), 3);
  },
  // Day of week: 0, 1, ..., 6
  d(date) {
    return date.getDay();
  },
  // Day of week: 0th, 1st, ..., 6th
  do(date) {
    return getOrdinal(date.getDay());
  },
  // Day of week: Su, Mo, ...
  dd(date, dateLocale) {
    return dateLocale.days[date.getDay()].slice(0, 2);
  },
  // Day of week: Sun, Mon, ...
  ddd(date, dateLocale) {
    return dateLocale.daysShort[date.getDay()];
  },
  // Day of week: Sunday, Monday, ...
  dddd(date, dateLocale) {
    return dateLocale.days[date.getDay()];
  },
  // Day of ISO week: 1, 2, ..., 7
  E(date) {
    return date.getDay() || 7;
  },
  // Week of Year: 1 2 ... 52 53
  w(date) {
    return getWeekOfYear(date);
  },
  // Week of Year: 1st 2nd ... 52nd 53rd
  wo(date) {
    return getOrdinal(getWeekOfYear(date));
  },
  // Week of Year: 01 02 ... 52 53
  ww(date) {
    return pad(getWeekOfYear(date));
  },
  // Hour: 0, 1, ... 23
  H(date) {
    return date.getHours();
  },
  // Hour: 00, 01, ..., 23
  HH(date) {
    return pad(date.getHours());
  },
  // Hour: 1, 2, ..., 12
  h(date) {
    const hours = date.getHours();
    return hours === 0 ? 12 : hours > 12 ? hours % 12 : hours;
  },
  // Hour: 01, 02, ..., 12
  hh(date) {
    return pad(this.h(date));
  },
  // Minute: 0, 1, ..., 59
  m(date) {
    return date.getMinutes();
  },
  // Minute: 00, 01, ..., 59
  mm(date) {
    return pad(date.getMinutes());
  },
  // Second: 0, 1, ..., 59
  s(date) {
    return date.getSeconds();
  },
  // Second: 00, 01, ..., 59
  ss(date) {
    return pad(date.getSeconds());
  },
  // 1/10 of second: 0, 1, ..., 9
  S(date) {
    return Math.floor(date.getMilliseconds() / 100);
  },
  // 1/100 of second: 00, 01, ..., 99
  SS(date) {
    return pad(Math.floor(date.getMilliseconds() / 10));
  },
  // Millisecond: 000, 001, ..., 999
  SSS(date) {
    return pad(date.getMilliseconds(), 3);
  },
  // Meridiem: AM, PM
  A(date) {
    return date.getHours() < 12 ? "AM" : "PM";
  },
  // Meridiem: am, pm
  a(date) {
    return date.getHours() < 12 ? "am" : "pm";
  },
  // Meridiem: a.m., p.m.
  aa(date) {
    return date.getHours() < 12 ? "a.m." : "p.m.";
  },
  // Timezone: -01:00, +00:00, ... +12:00
  Z(date, _dateLocale, _forcedYear, forcedTimezoneOffset) {
    const tzOffset = forcedTimezoneOffset === void 0 || forcedTimezoneOffset === null ? date.getTimezoneOffset() : forcedTimezoneOffset;
    return formatTimezone(tzOffset, ":");
  },
  // Timezone: -0100, +0000, ... +1200
  ZZ(date, _dateLocale, _forcedYear, forcedTimezoneOffset) {
    const tzOffset = forcedTimezoneOffset === void 0 || forcedTimezoneOffset === null ? date.getTimezoneOffset() : forcedTimezoneOffset;
    return formatTimezone(tzOffset);
  },
  // Seconds timestamp: 512969520
  X(date) {
    return Math.floor(date.getTime() / 1e3);
  },
  // Milliseconds timestamp: 512969520900
  x(date) {
    return date.getTime();
  }
};
function formatDate(val, mask, dateLocale, __forcedYear, __forcedTimezoneOffset) {
  if (val !== 0 && !val || val === Infinity || val === -Infinity) return;
  const date = new Date(val);
  if (isNaN(date)) return;
  if (mask === void 0) {
    mask = defaultMask;
  }
  const locale2 = getDateLocale(dateLocale, Lang_default.props);
  return mask.replace(
    token,
    (match2, text2) => match2 in formatter ? formatter[match2](date, locale2, __forcedYear, __forcedTimezoneOffset) : text2 === void 0 ? match2 : text2.split("\\]").join("]")
  );
}
var yearsInterval = 20;
var views = ["Calendar", "Years", "Months"];
var viewIsValid = (v) => views.includes(v);
var yearMonthValidator = (v) => /^-?[\d]+\/[0-1]\d$/.test(v);
var lineStr = " — ";
function getMonthHash(date) {
  return date.year + "/" + pad(date.month);
}
createComponent({
  name: "QDate",
  props: {
    ...useDatetimeProps,
    ...useFormProps,
    ...useDarkProps,
    modelValue: {
      required: true,
      validator: (val) => typeof val === "string" || Array.isArray(val) === true || Object(val) === val || val === null
    },
    multiple: Boolean,
    range: Boolean,
    title: String,
    subtitle: String,
    mask: {
      ...useDatetimeProps.mask,
      // this mask is forced
      // when using persian calendar
      default: "YYYY/MM/DD"
    },
    defaultYearMonth: {
      type: String,
      validator: yearMonthValidator
    },
    yearsInMonthView: Boolean,
    events: [Array, Function],
    eventColor: [String, Function],
    emitImmediately: Boolean,
    options: [Array, Function],
    navigationMinYearMonth: {
      type: String,
      validator: yearMonthValidator
    },
    navigationMaxYearMonth: {
      type: String,
      validator: yearMonthValidator
    },
    noUnset: Boolean,
    firstDayOfWeek: [String, Number],
    todayBtn: Boolean,
    minimal: Boolean,
    defaultView: {
      type: String,
      default: "Calendar",
      validator: viewIsValid
    }
  },
  emits: [
    ...useDatetimeEmits,
    "rangeStart",
    "rangeEnd",
    "navigation"
  ],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const isDark = use_dark_default(props4, $q);
    const { getCache } = use_render_cache_default();
    const { tabindex, headerClass, getLocale: getLocale2, getCurrentDate } = use_datetime_default(props4, $q);
    let lastEmitValue;
    const formAttrs = useFormAttrs(props4);
    const injectFormInput = useFormInject(formAttrs);
    const blurTargetRef = ref$1(null);
    const innerMask = ref$1(getMask());
    const innerLocale = ref$1(getLocale2());
    const mask = computed(() => getMask());
    const locale2 = computed(() => getLocale2());
    const today = computed(() => getCurrentDate());
    const viewModel = ref$1(getViewModel(innerMask.value, innerLocale.value));
    const view = ref$1(props4.defaultView);
    const direction = computed(() => $q.lang.rtl === true ? "right" : "left");
    const monthDirection = ref$1(direction.value);
    const yearDirection = ref$1(direction.value);
    const year = viewModel.value.year;
    const startYear = ref$1(year - year % yearsInterval - (year < 0 ? yearsInterval : 0));
    const editRange = ref$1(null);
    const classes = computed(() => {
      const type2 = props4.landscape === true ? "landscape" : "portrait";
      return `q-date q-date--${type2} q-date--${type2}-${props4.minimal === true ? "minimal" : "standard"}` + (isDark.value === true ? " q-date--dark q-dark" : "") + (props4.bordered === true ? " q-date--bordered" : "") + (props4.square === true ? " q-date--square no-border-radius" : "") + (props4.flat === true ? " q-date--flat no-shadow" : "") + (props4.disable === true ? " disabled" : props4.readonly === true ? " q-date--readonly" : "");
    });
    const computedColor = computed(() => {
      return props4.color || "primary";
    });
    const computedTextColor = computed(() => {
      return props4.textColor || "white";
    });
    const isImmediate = computed(
      () => props4.emitImmediately === true && props4.multiple !== true && props4.range !== true
    );
    const normalizedModel = computed(() => Array.isArray(props4.modelValue) === true ? props4.modelValue : props4.modelValue !== null && props4.modelValue !== void 0 ? [props4.modelValue] : []);
    const daysModel = computed(
      () => normalizedModel.value.filter((date) => typeof date === "string").map((date) => decodeString(date, innerMask.value, innerLocale.value)).filter(
        (date) => date.dateHash !== null && date.day !== null && date.month !== null && date.year !== null
      )
    );
    const rangeModel = computed(() => {
      const fn = (date) => decodeString(date, innerMask.value, innerLocale.value);
      return normalizedModel.value.filter((date) => isObject(date) === true && date.from !== void 0 && date.to !== void 0).map((range2) => ({ from: fn(range2.from), to: fn(range2.to) })).filter((range2) => range2.from.dateHash !== null && range2.to.dateHash !== null && range2.from.dateHash < range2.to.dateHash);
    });
    const getNativeDateFn = computed(() => props4.calendar !== "persian" ? (model) => new Date(model.year, model.month - 1, model.day) : (model) => {
      const gDate = toGregorian(model.year, model.month, model.day);
      return new Date(gDate.gy, gDate.gm - 1, gDate.gd);
    });
    const encodeObjectFn = computed(() => props4.calendar === "persian" ? getDayHash : (date, mask2, locale22) => formatDate(
      new Date(
        date.year,
        date.month - 1,
        date.day,
        date.hour,
        date.minute,
        date.second,
        date.millisecond
      ),
      mask2 === void 0 ? innerMask.value : mask2,
      locale22 === void 0 ? innerLocale.value : locale22,
      date.year,
      date.timezoneOffset
    ));
    const daysInModel = computed(
      () => daysModel.value.length + rangeModel.value.reduce(
        (acc, range2) => acc + 1 + getDateDiff(
          getNativeDateFn.value(range2.to),
          getNativeDateFn.value(range2.from)
        ),
        0
      )
    );
    const headerTitle = computed(() => {
      if (props4.title !== void 0 && props4.title !== null && props4.title.length !== 0) {
        return props4.title;
      }
      if (editRange.value !== null) {
        const model2 = editRange.value.init;
        const date2 = getNativeDateFn.value(model2);
        return innerLocale.value.daysShort[date2.getDay()] + ", " + innerLocale.value.monthsShort[model2.month - 1] + " " + model2.day + lineStr + "?";
      }
      if (daysInModel.value === 0) {
        return lineStr;
      }
      if (daysInModel.value > 1) {
        return `${daysInModel.value} ${innerLocale.value.pluralDay}`;
      }
      const model = daysModel.value[0];
      const date = getNativeDateFn.value(model);
      if (isNaN(date.valueOf()) === true) {
        return lineStr;
      }
      if (innerLocale.value.headerTitle !== void 0) {
        return innerLocale.value.headerTitle(date, model);
      }
      return innerLocale.value.daysShort[date.getDay()] + ", " + innerLocale.value.monthsShort[model.month - 1] + " " + model.day;
    });
    const minSelectedModel = computed(() => {
      const model = daysModel.value.concat(rangeModel.value.map((range2) => range2.from)).sort((a4, b3) => a4.year - b3.year || a4.month - b3.month);
      return model[0];
    });
    const maxSelectedModel = computed(() => {
      const model = daysModel.value.concat(rangeModel.value.map((range2) => range2.to)).sort((a4, b3) => b3.year - a4.year || b3.month - a4.month);
      return model[0];
    });
    const headerSubtitle = computed(() => {
      if (props4.subtitle !== void 0 && props4.subtitle !== null && props4.subtitle.length !== 0) {
        return props4.subtitle;
      }
      if (daysInModel.value === 0) {
        return lineStr;
      }
      if (daysInModel.value > 1) {
        const from2 = minSelectedModel.value;
        const to2 = maxSelectedModel.value;
        const month = innerLocale.value.monthsShort;
        return month[from2.month - 1] + (from2.year !== to2.year ? " " + from2.year + lineStr + month[to2.month - 1] + " " : from2.month !== to2.month ? lineStr + month[to2.month - 1] : "") + " " + to2.year;
      }
      return daysModel.value[0].year;
    });
    const dateArrow = computed(() => {
      const val = [$q.iconSet.datetime.arrowLeft, $q.iconSet.datetime.arrowRight];
      return $q.lang.rtl === true ? val.reverse() : val;
    });
    const computedFirstDayOfWeek = computed(() => props4.firstDayOfWeek !== void 0 ? Number(props4.firstDayOfWeek) : innerLocale.value.firstDayOfWeek);
    const daysOfWeek = computed(() => {
      const days2 = innerLocale.value.daysShort, first = computedFirstDayOfWeek.value;
      return first > 0 ? days2.slice(first, 7).concat(days2.slice(0, first)) : days2;
    });
    const daysInMonth2 = computed(() => {
      const date = viewModel.value;
      return props4.calendar !== "persian" ? new Date(date.year, date.month, 0).getDate() : jalaaliMonthLength(date.year, date.month);
    });
    const evtColor = computed(() => typeof props4.eventColor === "function" ? props4.eventColor : () => props4.eventColor);
    const minNav = computed(() => {
      if (props4.navigationMinYearMonth === void 0) {
        return null;
      }
      const data = props4.navigationMinYearMonth.split("/");
      return { year: parseInt(data[0], 10), month: parseInt(data[1], 10) };
    });
    const maxNav = computed(() => {
      if (props4.navigationMaxYearMonth === void 0) {
        return null;
      }
      const data = props4.navigationMaxYearMonth.split("/");
      return { year: parseInt(data[0], 10), month: parseInt(data[1], 10) };
    });
    const navBoundaries = computed(() => {
      const data = {
        month: { prev: true, next: true },
        year: { prev: true, next: true }
      };
      if (minNav.value !== null && minNav.value.year >= viewModel.value.year) {
        data.year.prev = false;
        if (minNav.value.year === viewModel.value.year && minNav.value.month >= viewModel.value.month) {
          data.month.prev = false;
        }
      }
      if (maxNav.value !== null && maxNav.value.year <= viewModel.value.year) {
        data.year.next = false;
        if (maxNav.value.year === viewModel.value.year && maxNav.value.month <= viewModel.value.month) {
          data.month.next = false;
        }
      }
      return data;
    });
    const daysMap = computed(() => {
      const map2 = {};
      daysModel.value.forEach((entry) => {
        const hash = getMonthHash(entry);
        if (map2[hash] === void 0) {
          map2[hash] = [];
        }
        map2[hash].push(entry.day);
      });
      return map2;
    });
    const rangeMap2 = computed(() => {
      const map2 = {};
      rangeModel.value.forEach((entry) => {
        const hashFrom = getMonthHash(entry.from);
        const hashTo = getMonthHash(entry.to);
        if (map2[hashFrom] === void 0) {
          map2[hashFrom] = [];
        }
        map2[hashFrom].push({
          from: entry.from.day,
          to: hashFrom === hashTo ? entry.to.day : void 0,
          range: entry
        });
        if (hashFrom < hashTo) {
          let hash;
          const { year: year2, month } = entry.from;
          const cur = month < 12 ? { year: year2, month: month + 1 } : { year: year2 + 1, month: 1 };
          while ((hash = getMonthHash(cur)) <= hashTo) {
            if (map2[hash] === void 0) {
              map2[hash] = [];
            }
            map2[hash].push({
              from: void 0,
              to: hash === hashTo ? entry.to.day : void 0,
              range: entry
            });
            cur.month++;
            if (cur.month > 12) {
              cur.year++;
              cur.month = 1;
            }
          }
        }
      });
      return map2;
    });
    const rangeView = computed(() => {
      if (editRange.value === null) return;
      const { init, initHash, final, finalHash } = editRange.value;
      const [from2, to2] = initHash <= finalHash ? [init, final] : [final, init];
      const fromHash = getMonthHash(from2);
      const toHash = getMonthHash(to2);
      if (fromHash !== viewMonthHash.value && toHash !== viewMonthHash.value) return;
      const view2 = {};
      if (fromHash === viewMonthHash.value) {
        view2.from = from2.day;
        view2.includeFrom = true;
      } else {
        view2.from = 1;
      }
      if (toHash === viewMonthHash.value) {
        view2.to = to2.day;
        view2.includeTo = true;
      } else {
        view2.to = daysInMonth2.value;
      }
      return view2;
    });
    const viewMonthHash = computed(() => getMonthHash(viewModel.value));
    const selectionDaysMap = computed(() => {
      const map2 = {};
      if (props4.options === void 0) {
        for (let i3 = 1; i3 <= daysInMonth2.value; i3++) {
          map2[i3] = true;
        }
        return map2;
      }
      const fn = typeof props4.options === "function" ? props4.options : (date) => props4.options.includes(date);
      for (let i3 = 1; i3 <= daysInMonth2.value; i3++) {
        const dayHash = viewMonthHash.value + "/" + pad(i3);
        map2[i3] = fn(dayHash);
      }
      return map2;
    });
    const eventDaysMap = computed(() => {
      const map2 = {};
      if (props4.events === void 0) {
        for (let i3 = 1; i3 <= daysInMonth2.value; i3++) {
          map2[i3] = false;
        }
      } else {
        const fn = typeof props4.events === "function" ? props4.events : (date) => props4.events.includes(date);
        for (let i3 = 1; i3 <= daysInMonth2.value; i3++) {
          const dayHash = viewMonthHash.value + "/" + pad(i3);
          map2[i3] = fn(dayHash) === true && evtColor.value(dayHash);
        }
      }
      return map2;
    });
    const viewDays = computed(() => {
      let date, endDay;
      const { year: year2, month } = viewModel.value;
      if (props4.calendar !== "persian") {
        date = new Date(year2, month - 1, 1);
        endDay = new Date(year2, month - 1, 0).getDate();
      } else {
        const gDate = toGregorian(year2, month, 1);
        date = new Date(gDate.gy, gDate.gm - 1, gDate.gd);
        let prevJM = month - 1;
        let prevJY = year2;
        if (prevJM === 0) {
          prevJM = 12;
          prevJY--;
        }
        endDay = jalaaliMonthLength(prevJY, prevJM);
      }
      return {
        days: date.getDay() - computedFirstDayOfWeek.value - 1,
        endDay
      };
    });
    const days = computed(() => {
      const res = [];
      const { days: days2, endDay } = viewDays.value;
      const len = days2 < 0 ? days2 + 7 : days2;
      if (len < 6) {
        for (let i3 = endDay - len; i3 <= endDay; i3++) {
          res.push({ i: i3, fill: true });
        }
      }
      const index2 = res.length;
      for (let i3 = 1; i3 <= daysInMonth2.value; i3++) {
        const day = { i: i3, event: eventDaysMap.value[i3], classes: [] };
        if (selectionDaysMap.value[i3] === true) {
          day.in = true;
          day.flat = true;
        }
        res.push(day);
      }
      if (daysMap.value[viewMonthHash.value] !== void 0) {
        daysMap.value[viewMonthHash.value].forEach((day) => {
          const i3 = index2 + day - 1;
          Object.assign(res[i3], {
            selected: true,
            unelevated: true,
            flat: false,
            color: computedColor.value,
            textColor: computedTextColor.value
          });
        });
      }
      if (rangeMap2.value[viewMonthHash.value] !== void 0) {
        rangeMap2.value[viewMonthHash.value].forEach((entry) => {
          if (entry.from !== void 0) {
            const from2 = index2 + entry.from - 1;
            const to2 = index2 + (entry.to || daysInMonth2.value) - 1;
            for (let day = from2; day <= to2; day++) {
              Object.assign(res[day], {
                range: entry.range,
                unelevated: true,
                color: computedColor.value,
                textColor: computedTextColor.value
              });
            }
            Object.assign(res[from2], {
              rangeFrom: true,
              flat: false
            });
            entry.to !== void 0 && Object.assign(res[to2], {
              rangeTo: true,
              flat: false
            });
          } else if (entry.to !== void 0) {
            const to2 = index2 + entry.to - 1;
            for (let day = index2; day <= to2; day++) {
              Object.assign(res[day], {
                range: entry.range,
                unelevated: true,
                color: computedColor.value,
                textColor: computedTextColor.value
              });
            }
            Object.assign(res[to2], {
              flat: false,
              rangeTo: true
            });
          } else {
            const to2 = index2 + daysInMonth2.value - 1;
            for (let day = index2; day <= to2; day++) {
              Object.assign(res[day], {
                range: entry.range,
                unelevated: true,
                color: computedColor.value,
                textColor: computedTextColor.value
              });
            }
          }
        });
      }
      if (rangeView.value !== void 0) {
        const from2 = index2 + rangeView.value.from - 1;
        const to2 = index2 + rangeView.value.to - 1;
        for (let day = from2; day <= to2; day++) {
          res[day].color = computedColor.value;
          res[day].editRange = true;
        }
        if (rangeView.value.includeFrom === true) {
          res[from2].editRangeFrom = true;
        }
        if (rangeView.value.includeTo === true) {
          res[to2].editRangeTo = true;
        }
      }
      if (viewModel.value.year === today.value.year && viewModel.value.month === today.value.month) {
        res[index2 + today.value.day - 1].today = true;
      }
      const left = res.length % 7;
      if (left > 0) {
        const afterDays = 7 - left;
        for (let i3 = 1; i3 <= afterDays; i3++) {
          res.push({ i: i3, fill: true });
        }
      }
      res.forEach((day) => {
        let cls = "q-date__calendar-item ";
        if (day.fill === true) {
          cls += "q-date__calendar-item--fill";
        } else {
          cls += `q-date__calendar-item--${day.in === true ? "in" : "out"}`;
          if (day.range !== void 0) {
            cls += ` q-date__range${day.rangeTo === true ? "-to" : day.rangeFrom === true ? "-from" : ""}`;
          }
          if (day.editRange === true) {
            cls += ` q-date__edit-range${day.editRangeFrom === true ? "-from" : ""}${day.editRangeTo === true ? "-to" : ""}`;
          }
          if (day.range !== void 0 || day.editRange === true) {
            cls += ` text-${day.color}`;
          }
        }
        day.classes = cls;
      });
      return res;
    });
    const attributes = computed(() => props4.disable === true ? { "aria-disabled": "true" } : {});
    watch(() => props4.modelValue, (v) => {
      if (lastEmitValue === JSON.stringify(v)) {
        lastEmitValue = 0;
      } else {
        const model = getViewModel(innerMask.value, innerLocale.value);
        updateViewModel(model.year, model.month, model);
      }
    });
    watch(view, () => {
      if (blurTargetRef.value !== null && proxy.$el.contains(document.activeElement) === true) {
        blurTargetRef.value.focus();
      }
    });
    watch(() => viewModel.value.year + "|" + viewModel.value.month, () => {
      emit("navigation", { year: viewModel.value.year, month: viewModel.value.month });
    });
    watch(mask, (val) => {
      updateValue2(val, innerLocale.value, "mask");
      innerMask.value = val;
    });
    watch(locale2, (val) => {
      updateValue2(innerMask.value, val, "locale");
      innerLocale.value = val;
    });
    function setLastValue(v) {
      lastEmitValue = JSON.stringify(v);
    }
    function setToday() {
      const { year: year2, month, day } = today.value;
      const date = {
        // contains more props than needed (hour, minute, second, millisecond)
        // but those aren't used in the processing of this "date" variable
        ...viewModel.value,
        // overwriting with today's date
        year: year2,
        month,
        day
      };
      const monthMap = daysMap.value[getMonthHash(date)];
      if (monthMap === void 0 || monthMap.includes(date.day) === false) {
        addToModel(date);
      }
      setCalendarTo(date.year, date.month);
    }
    function setView(viewMode) {
      if (viewIsValid(viewMode) === true) {
        view.value = viewMode;
      }
    }
    function offsetCalendar(type2, descending) {
      if (["month", "year"].includes(type2)) {
        const fn = type2 === "month" ? goToMonth : goToYear;
        fn(descending === true ? -1 : 1);
      }
    }
    function setCalendarTo(year2, month) {
      view.value = "Calendar";
      updateViewModel(year2, month);
    }
    function setEditingRange(from2, to2) {
      if (props4.range === false || !from2) {
        editRange.value = null;
        return;
      }
      const init = Object.assign({ ...viewModel.value }, from2);
      const final = to2 !== void 0 ? Object.assign({ ...viewModel.value }, to2) : init;
      editRange.value = {
        init,
        initHash: getDayHash(init),
        final,
        finalHash: getDayHash(final)
      };
      setCalendarTo(init.year, init.month);
    }
    function getMask() {
      return props4.calendar === "persian" ? "YYYY/MM/DD" : props4.mask;
    }
    function decodeString(date, mask2, locale22) {
      return __splitDate(
        date,
        mask2,
        locale22,
        props4.calendar,
        {
          hour: 0,
          minute: 0,
          second: 0,
          millisecond: 0
        }
      );
    }
    function getViewModel(mask2, locale22) {
      const model = Array.isArray(props4.modelValue) === true ? props4.modelValue : props4.modelValue ? [props4.modelValue] : [];
      if (model.length === 0) {
        return getDefaultViewModel();
      }
      const target2 = model[model.length - 1];
      const decoded = decodeString(
        target2.from !== void 0 ? target2.from : target2,
        mask2,
        locale22
      );
      return decoded.dateHash === null ? getDefaultViewModel() : decoded;
    }
    function getDefaultViewModel() {
      let year2, month;
      if (props4.defaultYearMonth !== void 0) {
        const d4 = props4.defaultYearMonth.split("/");
        year2 = parseInt(d4[0], 10);
        month = parseInt(d4[1], 10);
      } else {
        const d4 = today.value !== void 0 ? today.value : getCurrentDate();
        year2 = d4.year;
        month = d4.month;
      }
      return {
        year: year2,
        month,
        day: 1,
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
        dateHash: year2 + "/" + pad(month) + "/01"
      };
    }
    function goToMonth(offset2) {
      let year2 = viewModel.value.year;
      let month = Number(viewModel.value.month) + offset2;
      if (month === 13) {
        month = 1;
        year2++;
      } else if (month === 0) {
        month = 12;
        year2--;
      }
      updateViewModel(year2, month);
      isImmediate.value === true && emitImmediately("month");
    }
    function goToYear(offset2) {
      const year2 = Number(viewModel.value.year) + offset2;
      updateViewModel(year2, viewModel.value.month);
      isImmediate.value === true && emitImmediately("year");
    }
    function setYear(year2) {
      updateViewModel(year2, viewModel.value.month);
      view.value = props4.defaultView === "Years" ? "Months" : "Calendar";
      isImmediate.value === true && emitImmediately("year");
    }
    function setMonth(month) {
      updateViewModel(viewModel.value.year, month);
      view.value = "Calendar";
      isImmediate.value === true && emitImmediately("month");
    }
    function toggleDate(date, monthHash) {
      const month = daysMap.value[monthHash];
      const fn = (month == null ? void 0 : month.includes(date.day)) === true ? removeFromModel : addToModel;
      fn(date);
    }
    function getShortDate(date) {
      return { year: date.year, month: date.month, day: date.day };
    }
    function updateViewModel(year2, month, time) {
      if (minNav.value !== null && year2 <= minNav.value.year) {
        if (month < minNav.value.month || year2 < minNav.value.year) {
          month = minNav.value.month;
        }
        year2 = minNav.value.year;
      }
      if (maxNav.value !== null && year2 >= maxNav.value.year) {
        if (month > maxNav.value.month || year2 > maxNav.value.year) {
          month = maxNav.value.month;
        }
        year2 = maxNav.value.year;
      }
      if (time !== void 0) {
        const { hour, minute, second, millisecond, timezoneOffset, timeHash } = time;
        Object.assign(viewModel.value, { hour, minute, second, millisecond, timezoneOffset, timeHash });
      }
      const newHash = year2 + "/" + pad(month) + "/01";
      if (newHash !== viewModel.value.dateHash) {
        monthDirection.value = viewModel.value.dateHash < newHash === ($q.lang.rtl !== true) ? "left" : "right";
        if (year2 !== viewModel.value.year) {
          yearDirection.value = monthDirection.value;
        }
        nextTick(() => {
          startYear.value = year2 - year2 % yearsInterval - (year2 < 0 ? yearsInterval : 0);
          Object.assign(viewModel.value, {
            year: year2,
            month,
            day: 1,
            dateHash: newHash
          });
        });
      }
    }
    function emitValue(val, action, date) {
      const value2 = val !== null && val.length === 1 && props4.multiple === false ? val[0] : val;
      const { reason, details } = getEmitParams(action, date);
      setLastValue(value2);
      emit("update:modelValue", value2, reason, details);
    }
    function emitImmediately(reason) {
      const date = daysModel.value[0] !== void 0 && daysModel.value[0].dateHash !== null ? { ...daysModel.value[0] } : { ...viewModel.value };
      nextTick(() => {
        date.year = viewModel.value.year;
        date.month = viewModel.value.month;
        const maxDay = props4.calendar !== "persian" ? new Date(date.year, date.month, 0).getDate() : jalaaliMonthLength(date.year, date.month);
        date.day = Math.min(Math.max(1, date.day), maxDay);
        const value2 = encodeEntry(date);
        const { details } = getEmitParams("", date);
        setLastValue(value2);
        emit("update:modelValue", value2, reason, details);
      });
    }
    function getEmitParams(action, date) {
      return date.from !== void 0 ? {
        reason: `${action}-range`,
        details: {
          ...getShortDate(date.target),
          from: getShortDate(date.from),
          to: getShortDate(date.to)
        }
      } : {
        reason: `${action}-day`,
        details: getShortDate(date)
      };
    }
    function encodeEntry(date, mask2, locale22) {
      return date.from !== void 0 ? { from: encodeObjectFn.value(date.from, mask2, locale22), to: encodeObjectFn.value(date.to, mask2, locale22) } : encodeObjectFn.value(date, mask2, locale22);
    }
    function addToModel(date) {
      let value2;
      if (props4.multiple === true) {
        if (date.from !== void 0) {
          const fromHash = getDayHash(date.from);
          const toHash = getDayHash(date.to);
          const days2 = daysModel.value.filter((day) => day.dateHash < fromHash || day.dateHash > toHash);
          const ranges = rangeModel.value.filter(({ from: from2, to: to2 }) => to2.dateHash < fromHash || from2.dateHash > toHash);
          value2 = days2.concat(ranges).concat(date).map((entry) => encodeEntry(entry));
        } else {
          const model = normalizedModel.value.slice();
          model.push(encodeEntry(date));
          value2 = model;
        }
      } else {
        value2 = encodeEntry(date);
      }
      emitValue(value2, "add", date);
    }
    function removeFromModel(date) {
      if (props4.noUnset === true) return;
      let model = null;
      if (props4.multiple === true && Array.isArray(props4.modelValue) === true) {
        const val = encodeEntry(date);
        if (date.from !== void 0) {
          model = props4.modelValue.filter(
            (date2) => date2.from !== void 0 ? date2.from !== val.from && date2.to !== val.to : true
          );
        } else {
          model = props4.modelValue.filter((date2) => date2 !== val);
        }
        if (model.length === 0) {
          model = null;
        }
      }
      emitValue(model, "remove", date);
    }
    function updateValue2(mask2, locale22, reason) {
      const model = daysModel.value.concat(rangeModel.value).map((entry) => encodeEntry(entry, mask2, locale22)).filter((entry) => {
        return entry.from !== void 0 ? entry.from.dateHash !== null && entry.to.dateHash !== null : entry.dateHash !== null;
      });
      const value2 = (props4.multiple === true ? model : model[0]) || null;
      setLastValue(value2);
      emit("update:modelValue", value2, reason);
    }
    function getHeader() {
      if (props4.minimal === true) return;
      return h("div", {
        class: "q-date__header " + headerClass.value
      }, [
        h("div", {
          class: "relative-position"
        }, [
          h(Transition, {
            name: "q-transition--fade"
          }, () => h("div", {
            key: "h-yr-" + headerSubtitle.value,
            class: "q-date__header-subtitle q-date__header-link " + (view.value === "Years" ? "q-date__header-link--active" : "cursor-pointer"),
            tabindex: tabindex.value,
            ...getCache("vY", {
              onClick() {
                view.value = "Years";
              },
              onKeyup(e3) {
                e3.keyCode === 13 && (view.value = "Years");
              }
            })
          }, [headerSubtitle.value]))
        ]),
        h("div", {
          class: "q-date__header-title relative-position flex no-wrap"
        }, [
          h("div", {
            class: "relative-position col"
          }, [
            h(Transition, {
              name: "q-transition--fade"
            }, () => h("div", {
              key: "h-sub" + headerTitle.value,
              class: "q-date__header-title-label q-date__header-link " + (view.value === "Calendar" ? "q-date__header-link--active" : "cursor-pointer"),
              tabindex: tabindex.value,
              ...getCache("vC", {
                onClick() {
                  view.value = "Calendar";
                },
                onKeyup(e3) {
                  e3.keyCode === 13 && (view.value = "Calendar");
                }
              })
            }, [headerTitle.value]))
          ]),
          props4.todayBtn === true ? h(QBtn_default, {
            class: "q-date__header-today self-start",
            icon: $q.iconSet.datetime.today,
            "aria-label": $q.lang.date.today,
            flat: true,
            size: "sm",
            round: true,
            tabindex: tabindex.value,
            onClick: setToday
          }) : null
        ])
      ]);
    }
    function getNavigation({ label, type: type2, key, dir, goTo, boundaries, cls }) {
      return [
        h("div", {
          class: "row items-center q-date__arrow"
        }, [
          h(QBtn_default, {
            round: true,
            dense: true,
            size: "sm",
            flat: true,
            icon: dateArrow.value[0],
            "aria-label": type2 === "Years" ? $q.lang.date.prevYear : $q.lang.date.prevMonth,
            tabindex: tabindex.value,
            disable: boundaries.prev === false,
            ...getCache("go-#" + type2, { onClick() {
              goTo(-1);
            } })
          })
        ]),
        h("div", {
          class: "relative-position overflow-hidden flex flex-center" + cls
        }, [
          h(Transition, {
            name: "q-transition--jump-" + dir
          }, () => h("div", { key }, [
            h(QBtn_default, {
              flat: true,
              dense: true,
              noCaps: true,
              label,
              tabindex: tabindex.value,
              ...getCache("view#" + type2, { onClick: () => {
                view.value = type2;
              } })
            })
          ]))
        ]),
        h("div", {
          class: "row items-center q-date__arrow"
        }, [
          h(QBtn_default, {
            round: true,
            dense: true,
            size: "sm",
            flat: true,
            icon: dateArrow.value[1],
            "aria-label": type2 === "Years" ? $q.lang.date.nextYear : $q.lang.date.nextMonth,
            tabindex: tabindex.value,
            disable: boundaries.next === false,
            ...getCache("go+#" + type2, { onClick() {
              goTo(1);
            } })
          })
        ])
      ];
    }
    const renderViews = {
      Calendar: () => [
        h("div", {
          key: "calendar-view",
          class: "q-date__view q-date__calendar"
        }, [
          h("div", {
            class: "q-date__navigation row items-center no-wrap"
          }, getNavigation({
            label: innerLocale.value.months[viewModel.value.month - 1],
            type: "Months",
            key: viewModel.value.month,
            dir: monthDirection.value,
            goTo: goToMonth,
            boundaries: navBoundaries.value.month,
            cls: " col"
          }).concat(getNavigation({
            label: viewModel.value.year,
            type: "Years",
            key: viewModel.value.year,
            dir: yearDirection.value,
            goTo: goToYear,
            boundaries: navBoundaries.value.year,
            cls: ""
          }))),
          h("div", {
            class: "q-date__calendar-weekdays row items-center no-wrap"
          }, daysOfWeek.value.map((day) => h("div", { class: "q-date__calendar-item" }, [h("div", day)]))),
          h("div", {
            class: "q-date__calendar-days-container relative-position overflow-hidden"
          }, [
            h(Transition, {
              name: "q-transition--slide-" + monthDirection.value
            }, () => h("div", {
              key: viewMonthHash.value,
              class: "q-date__calendar-days fit"
            }, days.value.map((day) => h("div", { class: day.classes }, [
              day.in === true ? h(
                QBtn_default,
                {
                  class: day.today === true ? "q-date__today" : "",
                  dense: true,
                  flat: day.flat,
                  unelevated: day.unelevated,
                  color: day.color,
                  textColor: day.textColor,
                  label: day.i,
                  tabindex: tabindex.value,
                  ...getCache("day#" + day.i, {
                    onClick: () => {
                      onDayClick(day.i);
                    },
                    onMouseover: () => {
                      onDayMouseover(day.i);
                    }
                  })
                },
                day.event !== false ? () => h("div", { class: "q-date__event bg-" + day.event }) : null
              ) : h("div", "" + day.i)
            ]))))
          ])
        ])
      ],
      Months() {
        const currentYear = viewModel.value.year === today.value.year;
        const isDisabled = (month) => {
          return minNav.value !== null && viewModel.value.year === minNav.value.year && minNav.value.month > month || maxNav.value !== null && viewModel.value.year === maxNav.value.year && maxNav.value.month < month;
        };
        const content = innerLocale.value.monthsShort.map((month, i3) => {
          const active = viewModel.value.month === i3 + 1;
          return h("div", {
            class: "q-date__months-item flex flex-center"
          }, [
            h(QBtn_default, {
              class: currentYear === true && today.value.month === i3 + 1 ? "q-date__today" : null,
              flat: active !== true,
              label: month,
              unelevated: active,
              color: active === true ? computedColor.value : null,
              textColor: active === true ? computedTextColor.value : null,
              tabindex: tabindex.value,
              disable: isDisabled(i3 + 1),
              ...getCache("month#" + i3, { onClick: () => {
                setMonth(i3 + 1);
              } })
            })
          ]);
        });
        props4.yearsInMonthView === true && content.unshift(
          h("div", { class: "row no-wrap full-width" }, [
            getNavigation({
              label: viewModel.value.year,
              type: "Years",
              key: viewModel.value.year,
              dir: yearDirection.value,
              goTo: goToYear,
              boundaries: navBoundaries.value.year,
              cls: " col"
            })
          ])
        );
        return h("div", {
          key: "months-view",
          class: "q-date__view q-date__months flex flex-center"
        }, content);
      },
      Years() {
        const start = startYear.value, stop2 = start + yearsInterval, years = [];
        const isDisabled = (year2) => {
          return minNav.value !== null && minNav.value.year > year2 || maxNav.value !== null && maxNav.value.year < year2;
        };
        for (let i3 = start; i3 <= stop2; i3++) {
          const active = viewModel.value.year === i3;
          years.push(
            h("div", {
              class: "q-date__years-item flex flex-center"
            }, [
              h(QBtn_default, {
                key: "yr" + i3,
                class: today.value.year === i3 ? "q-date__today" : null,
                flat: !active,
                label: i3,
                dense: true,
                unelevated: active,
                color: active === true ? computedColor.value : null,
                textColor: active === true ? computedTextColor.value : null,
                tabindex: tabindex.value,
                disable: isDisabled(i3),
                ...getCache("yr#" + i3, { onClick: () => {
                  setYear(i3);
                } })
              })
            ])
          );
        }
        return h("div", {
          class: "q-date__view q-date__years flex flex-center"
        }, [
          h("div", {
            class: "col-auto"
          }, [
            h(QBtn_default, {
              round: true,
              dense: true,
              flat: true,
              icon: dateArrow.value[0],
              "aria-label": $q.lang.date.prevRangeYears(yearsInterval),
              tabindex: tabindex.value,
              disable: isDisabled(start),
              ...getCache("y-", { onClick: () => {
                startYear.value -= yearsInterval;
              } })
            })
          ]),
          h("div", {
            class: "q-date__years-content col self-stretch row items-center"
          }, years),
          h("div", {
            class: "col-auto"
          }, [
            h(QBtn_default, {
              round: true,
              dense: true,
              flat: true,
              icon: dateArrow.value[1],
              "aria-label": $q.lang.date.nextRangeYears(yearsInterval),
              tabindex: tabindex.value,
              disable: isDisabled(stop2),
              ...getCache("y+", { onClick: () => {
                startYear.value += yearsInterval;
              } })
            })
          ])
        ]);
      }
    };
    function onDayClick(dayIndex) {
      const day = { ...viewModel.value, day: dayIndex };
      if (props4.range === false) {
        toggleDate(day, viewMonthHash.value);
        return;
      }
      if (editRange.value === null) {
        const dayProps = days.value.find((day2) => day2.fill !== true && day2.i === dayIndex);
        if (props4.noUnset !== true && dayProps.range !== void 0) {
          removeFromModel({ target: day, from: dayProps.range.from, to: dayProps.range.to });
          return;
        }
        if (dayProps.selected === true) {
          removeFromModel(day);
          return;
        }
        const initHash = getDayHash(day);
        editRange.value = {
          init: day,
          initHash,
          final: day,
          finalHash: initHash
        };
        emit("rangeStart", getShortDate(day));
      } else {
        const initHash = editRange.value.initHash, finalHash = getDayHash(day), payload = initHash <= finalHash ? { from: editRange.value.init, to: day } : { from: day, to: editRange.value.init };
        editRange.value = null;
        addToModel(initHash === finalHash ? day : { target: day, ...payload });
        emit("rangeEnd", {
          from: getShortDate(payload.from),
          to: getShortDate(payload.to)
        });
      }
    }
    function onDayMouseover(dayIndex) {
      if (editRange.value !== null) {
        const final = { ...viewModel.value, day: dayIndex };
        Object.assign(editRange.value, {
          final,
          finalHash: getDayHash(final)
        });
      }
    }
    Object.assign(proxy, {
      setToday,
      setView,
      offsetCalendar,
      setCalendarTo,
      setEditingRange
    });
    return () => {
      const content = [
        h("div", {
          class: "q-date__content col relative-position"
        }, [
          h(Transition, {
            name: "q-transition--fade"
          }, renderViews[view.value])
        ])
      ];
      const def = hSlot(slots.default);
      def !== void 0 && content.push(
        h("div", { class: "q-date__actions" }, def)
      );
      if (props4.name !== void 0 && props4.disable !== true) {
        injectFormInput(content, "push");
      }
      return h("div", {
        class: classes.value,
        ...attributes.value
      }, [
        getHeader(),
        h("div", {
          ref: blurTargetRef,
          class: "q-date__main col column",
          tabindex: -1
        }, content)
      ]);
    };
  }
});
function use_history_default(showing, hide, hideOnRouteChange) {
  function removeFromHistory() {
  }
  onBeforeUnmount(() => {
    showing.value === true && removeFromHistory();
  });
  return {
    removeFromHistory,
    addToHistory() {
    }
  };
}
var registered = 0;
var scrollPositionX;
var scrollPositionY;
var maxScrollTop;
var vpPendingUpdate = false;
var bodyLeft;
var bodyTop;
var href;
var closeTimer = null;
function onWheel(e3) {
  if (shouldPreventScroll(e3)) {
    stopAndPrevent(e3);
  }
}
function shouldPreventScroll(e3) {
  if (e3.target === document.body || e3.target.classList.contains("q-layout__backdrop")) {
    return true;
  }
  const path = getEventPath(e3), shift = e3.shiftKey && !e3.deltaX, scrollY = !shift && Math.abs(e3.deltaX) <= Math.abs(e3.deltaY), delta = shift || scrollY ? e3.deltaY : e3.deltaX;
  for (let index2 = 0; index2 < path.length; index2++) {
    const el = path[index2];
    if (hasScrollbar(el, scrollY)) {
      return scrollY ? delta < 0 && el.scrollTop === 0 ? true : delta > 0 && el.scrollTop + el.clientHeight === el.scrollHeight : delta < 0 && el.scrollLeft === 0 ? true : delta > 0 && el.scrollLeft + el.clientWidth === el.scrollWidth;
    }
  }
  return true;
}
function onAppleScroll(e3) {
  if (e3.target === document) {
    document.scrollingElement.scrollTop = document.scrollingElement.scrollTop;
  }
}
function onAppleResize(evt) {
  if (vpPendingUpdate === true) return;
  vpPendingUpdate = true;
  requestAnimationFrame(() => {
    vpPendingUpdate = false;
    const { height: height2 } = evt.target, { clientHeight, scrollTop } = document.scrollingElement;
    if (maxScrollTop === void 0 || height2 !== window.innerHeight) {
      maxScrollTop = clientHeight - height2;
      document.scrollingElement.scrollTop = scrollTop;
    }
    if (scrollTop > maxScrollTop) {
      document.scrollingElement.scrollTop -= Math.ceil((scrollTop - maxScrollTop) / 8);
    }
  });
}
function apply(action) {
  const body = document.body, hasViewport = window.visualViewport !== void 0;
  if (action === "add") {
    const { overflowY, overflowX } = window.getComputedStyle(body);
    scrollPositionX = getHorizontalScrollPosition(window);
    scrollPositionY = getVerticalScrollPosition(window);
    bodyLeft = body.style.left;
    bodyTop = body.style.top;
    href = window.location.href;
    body.style.left = `-${scrollPositionX}px`;
    body.style.top = `-${scrollPositionY}px`;
    if (overflowX !== "hidden" && (overflowX === "scroll" || body.scrollWidth > window.innerWidth)) {
      body.classList.add("q-body--force-scrollbar-x");
    }
    if (overflowY !== "hidden" && (overflowY === "scroll" || body.scrollHeight > window.innerHeight)) {
      body.classList.add("q-body--force-scrollbar-y");
    }
    body.classList.add("q-body--prevent-scroll");
    document.qScrollPrevented = true;
    if (client.is.ios === true) {
      if (hasViewport === true) {
        window.scrollTo(0, 0);
        window.visualViewport.addEventListener("resize", onAppleResize, listenOpts.passiveCapture);
        window.visualViewport.addEventListener("scroll", onAppleResize, listenOpts.passiveCapture);
        window.scrollTo(0, 0);
      } else {
        window.addEventListener("scroll", onAppleScroll, listenOpts.passiveCapture);
      }
    }
  }
  if (client.is.desktop === true && client.is.mac === true) {
    window[`${action}EventListener`]("wheel", onWheel, listenOpts.notPassive);
  }
  if (action === "remove") {
    if (client.is.ios === true) {
      if (hasViewport === true) {
        window.visualViewport.removeEventListener("resize", onAppleResize, listenOpts.passiveCapture);
        window.visualViewport.removeEventListener("scroll", onAppleResize, listenOpts.passiveCapture);
      } else {
        window.removeEventListener("scroll", onAppleScroll, listenOpts.passiveCapture);
      }
    }
    body.classList.remove("q-body--prevent-scroll");
    body.classList.remove("q-body--force-scrollbar-x");
    body.classList.remove("q-body--force-scrollbar-y");
    document.qScrollPrevented = false;
    body.style.left = bodyLeft;
    body.style.top = bodyTop;
    if (window.location.href === href) {
      window.scrollTo(scrollPositionX, scrollPositionY);
    }
    maxScrollTop = void 0;
  }
}
function prevent_scroll_default(state2) {
  let action = "add";
  if (state2 === true) {
    registered++;
    if (closeTimer !== null) {
      clearTimeout(closeTimer);
      closeTimer = null;
      return;
    }
    if (registered > 1) return;
  } else {
    if (registered === 0) return;
    registered--;
    if (registered > 0) return;
    action = "remove";
    if (client.is.ios === true && client.is.nativeMobile === true) {
      closeTimer !== null && clearTimeout(closeTimer);
      closeTimer = setTimeout(() => {
        apply(action);
        closeTimer = null;
      }, 100);
      return;
    }
  }
  apply(action);
}
function use_prevent_scroll_default() {
  let currentState;
  return {
    preventBodyScroll(state2) {
      if (state2 !== currentState && (currentState !== void 0 || state2 === true)) {
        currentState = state2;
        prevent_scroll_default(state2);
      }
    }
  };
}
var maximizedModals = 0;
var positionClass = {
  standard: "fixed-full flex-center",
  top: "fixed-top justify-center",
  bottom: "fixed-bottom justify-center",
  right: "fixed-right items-center",
  left: "fixed-left items-center"
};
var defaultTransitions = {
  standard: ["scale", "scale"],
  top: ["slide-down", "slide-up"],
  bottom: ["slide-up", "slide-down"],
  right: ["slide-left", "slide-right"],
  left: ["slide-right", "slide-left"]
};
var QDialog_default = createComponent({
  name: "QDialog",
  inheritAttrs: false,
  props: {
    ...useModelToggleProps,
    ...useTransitionProps,
    transitionShow: String,
    // override useTransitionProps
    transitionHide: String,
    // override useTransitionProps
    persistent: Boolean,
    autoClose: Boolean,
    allowFocusOutside: Boolean,
    noEscDismiss: Boolean,
    noBackdropDismiss: Boolean,
    noRouteDismiss: Boolean,
    noRefocus: Boolean,
    noFocus: Boolean,
    noShake: Boolean,
    seamless: Boolean,
    maximized: Boolean,
    fullWidth: Boolean,
    fullHeight: Boolean,
    square: Boolean,
    backdropFilter: String,
    position: {
      type: String,
      default: "standard",
      validator: (val) => ["standard", "top", "bottom", "left", "right"].includes(val)
    }
  },
  emits: [
    ...useModelToggleEmits,
    "shake",
    "click",
    "escapeKey"
  ],
  setup(props4, { slots, emit, attrs }) {
    const vm2 = getCurrentInstance();
    const innerRef = ref$1(null);
    const showing = ref$1(false);
    const animating = ref$1(false);
    let shakeTimeout = null, refocusTarget = null, isMaximized, avoidAutoClose;
    const hideOnRouteChange = computed(
      () => props4.persistent !== true && props4.noRouteDismiss !== true && props4.seamless !== true
    );
    const { preventBodyScroll } = use_prevent_scroll_default();
    const { registerTimeout } = use_timeout_default();
    const { registerTick, removeTick } = use_tick_default();
    const { transitionProps, transitionStyle } = use_transition_default(
      props4,
      () => defaultTransitions[props4.position][0],
      () => defaultTransitions[props4.position][1]
    );
    const backdropStyle = computed(() => transitionStyle.value + (props4.backdropFilter !== void 0 ? `;backdrop-filter:${props4.backdropFilter};-webkit-backdrop-filter:${props4.backdropFilter}` : ""));
    const { showPortal, hidePortal, portalIsAccessible, renderPortal } = use_portal_default(
      vm2,
      innerRef,
      renderPortalContent,
      "dialog"
    );
    const { hide } = use_model_toggle_default({
      showing,
      hideOnRouteChange,
      handleShow,
      handleHide,
      processOnMount: true
    });
    use_history_default(showing);
    const classes = computed(
      () => `q-dialog__inner flex no-pointer-events q-dialog__inner--${props4.maximized === true ? "maximized" : "minimized"} q-dialog__inner--${props4.position} ${positionClass[props4.position]}` + (animating.value === true ? " q-dialog__inner--animating" : "") + (props4.fullWidth === true ? " q-dialog__inner--fullwidth" : "") + (props4.fullHeight === true ? " q-dialog__inner--fullheight" : "") + (props4.square === true ? " q-dialog__inner--square" : "")
    );
    const useBackdrop = computed(() => showing.value === true && props4.seamless !== true);
    const onEvents = computed(() => props4.autoClose === true ? { onClick: onAutoClose } : {});
    const rootClasses = computed(() => [
      `q-dialog fullscreen no-pointer-events q-dialog--${useBackdrop.value === true ? "modal" : "seamless"}`,
      attrs.class
    ]);
    watch(() => props4.maximized, (state2) => {
      showing.value === true && updateMaximized(state2);
    });
    watch(useBackdrop, (val) => {
      preventBodyScroll(val);
      if (val === true) {
        addFocusout(onFocusChange);
        addEscapeKey(onEscapeKey);
      } else {
        removeFocusout(onFocusChange);
        removeEscapeKey(onEscapeKey);
      }
    });
    function handleShow(evt) {
      var _a;
      refocusTarget = props4.noRefocus === false && document.activeElement !== null ? document.activeElement : null;
      updateMaximized(props4.maximized);
      showPortal();
      animating.value = true;
      if (props4.noFocus !== true) {
        (_a = document.activeElement) == null ? void 0 : _a.blur();
        registerTick(focus);
      } else {
        removeTick();
      }
      registerTimeout(() => {
        if (vm2.proxy.$q.platform.is.ios === true) {
          if (props4.seamless !== true && document.activeElement) {
            const { top, bottom } = document.activeElement.getBoundingClientRect(), { innerHeight } = window, height2 = window.visualViewport !== void 0 ? window.visualViewport.height : innerHeight;
            if (top > 0 && bottom > height2 / 2) {
              document.scrollingElement.scrollTop = Math.min(
                document.scrollingElement.scrollHeight - height2,
                bottom >= innerHeight ? Infinity : Math.ceil(document.scrollingElement.scrollTop + bottom - height2 / 2)
              );
            }
            document.activeElement.scrollIntoView();
          }
          avoidAutoClose = true;
          innerRef.value.click();
          avoidAutoClose = false;
        }
        showPortal(true);
        animating.value = false;
        emit("show", evt);
      }, props4.transitionDuration);
    }
    function handleHide(evt) {
      removeTick();
      cleanup(true);
      animating.value = true;
      hidePortal();
      if (refocusTarget !== null) {
        (((evt == null ? void 0 : evt.type.indexOf("key")) === 0 ? refocusTarget.closest('[tabindex]:not([tabindex^="-"])') : void 0) || refocusTarget).focus();
        refocusTarget = null;
      }
      registerTimeout(() => {
        hidePortal(true);
        animating.value = false;
        emit("hide", evt);
      }, props4.transitionDuration);
    }
    function focus(selector) {
      addFocusFn(() => {
        let node = innerRef.value;
        if (node === null) return;
        if (selector !== void 0) {
          const target2 = node.querySelector(selector);
          if (target2 !== null) {
            target2.focus({ preventScroll: true });
            return;
          }
        }
        if (node.contains(document.activeElement) !== true) {
          node = node.querySelector("[autofocus][tabindex], [data-autofocus][tabindex]") || node.querySelector("[autofocus] [tabindex], [data-autofocus] [tabindex]") || node.querySelector("[autofocus], [data-autofocus]") || node;
          node.focus({ preventScroll: true });
        }
      });
    }
    function shake(focusTarget) {
      if (focusTarget && typeof focusTarget.focus === "function") {
        focusTarget.focus({ preventScroll: true });
      } else {
        focus();
      }
      emit("shake");
      const node = innerRef.value;
      if (node !== null) {
        node.classList.remove("q-animate--scale");
        node.classList.add("q-animate--scale");
        shakeTimeout !== null && clearTimeout(shakeTimeout);
        shakeTimeout = setTimeout(() => {
          shakeTimeout = null;
          if (innerRef.value !== null) {
            node.classList.remove("q-animate--scale");
            focus();
          }
        }, 170);
      }
    }
    function onEscapeKey() {
      if (props4.seamless !== true) {
        if (props4.persistent === true || props4.noEscDismiss === true) {
          props4.maximized !== true && props4.noShake !== true && shake();
        } else {
          emit("escapeKey");
          hide();
        }
      }
    }
    function cleanup(hiding) {
      if (shakeTimeout !== null) {
        clearTimeout(shakeTimeout);
        shakeTimeout = null;
      }
      if (hiding === true || showing.value === true) {
        updateMaximized(false);
        if (props4.seamless !== true) {
          preventBodyScroll(false);
          removeFocusout(onFocusChange);
          removeEscapeKey(onEscapeKey);
        }
      }
      if (hiding !== true) {
        refocusTarget = null;
      }
    }
    function updateMaximized(active) {
      if (active === true) {
        if (isMaximized !== true) {
          maximizedModals < 1 && document.body.classList.add("q-body--dialog");
          maximizedModals++;
          isMaximized = true;
        }
      } else if (isMaximized === true) {
        if (maximizedModals < 2) {
          document.body.classList.remove("q-body--dialog");
        }
        maximizedModals--;
        isMaximized = false;
      }
    }
    function onAutoClose(e3) {
      if (avoidAutoClose !== true) {
        hide(e3);
        emit("click", e3);
      }
    }
    function onBackdropClick(e3) {
      if (props4.persistent !== true && props4.noBackdropDismiss !== true) {
        hide(e3);
      } else if (props4.noShake !== true) {
        shake();
      }
    }
    function onFocusChange(evt) {
      if (props4.allowFocusOutside !== true && portalIsAccessible.value === true && childHasFocus(innerRef.value, evt.target) !== true) {
        focus('[tabindex]:not([tabindex="-1"])');
      }
    }
    Object.assign(vm2.proxy, {
      // expose public methods
      focus,
      shake,
      // private but needed by QSelect
      __updateRefocusTarget(target2) {
        refocusTarget = target2 || null;
      }
    });
    onBeforeUnmount(cleanup);
    function renderPortalContent() {
      return h("div", {
        role: "dialog",
        "aria-modal": useBackdrop.value === true ? "true" : "false",
        ...attrs,
        class: rootClasses.value
      }, [
        h(Transition, {
          name: "q-transition--fade",
          appear: true
        }, () => useBackdrop.value === true ? h("div", {
          class: "q-dialog__backdrop fixed-full",
          style: backdropStyle.value,
          "aria-hidden": "true",
          tabindex: -1,
          onClick: onBackdropClick
        }) : null),
        h(
          Transition,
          transitionProps.value,
          () => showing.value === true ? h("div", {
            ref: innerRef,
            class: classes.value,
            style: transitionStyle.value,
            tabindex: -1,
            ...onEvents.value
          }, hSlot(slots.default)) : null
        )
      ]);
    }
    return renderPortal;
  }
});
var duration = 150;
createComponent({
  name: "QDrawer",
  inheritAttrs: false,
  props: {
    ...useModelToggleProps,
    ...useDarkProps,
    side: {
      type: String,
      default: "left",
      validator: (v) => ["left", "right"].includes(v)
    },
    width: {
      type: Number,
      default: 300
    },
    mini: Boolean,
    miniToOverlay: Boolean,
    miniWidth: {
      type: Number,
      default: 57
    },
    noMiniAnimation: Boolean,
    breakpoint: {
      type: Number,
      default: 1023
    },
    showIfAbove: Boolean,
    behavior: {
      type: String,
      validator: (v) => ["default", "desktop", "mobile"].includes(v),
      default: "default"
    },
    bordered: Boolean,
    elevated: Boolean,
    overlay: Boolean,
    persistent: Boolean,
    noSwipeOpen: Boolean,
    noSwipeClose: Boolean,
    noSwipeBackdrop: Boolean
  },
  emits: [
    ...useModelToggleEmits,
    "onLayout",
    "miniState"
  ],
  setup(props4, { slots, emit, attrs }) {
    const vm2 = getCurrentInstance();
    const { proxy: { $q } } = vm2;
    const isDark = use_dark_default(props4, $q);
    const { preventBodyScroll } = use_prevent_scroll_default();
    const { registerTimeout, removeTimeout } = use_timeout_default();
    const $layout = inject(layoutKey, emptyRenderFn);
    if ($layout === emptyRenderFn) {
      console.error("QDrawer needs to be child of QLayout");
      return emptyRenderFn;
    }
    let lastDesktopState, timerMini = null, layoutTotalWidthWatcher;
    const belowBreakpoint = ref$1(
      props4.behavior === "mobile" || props4.behavior !== "desktop" && $layout.totalWidth.value <= props4.breakpoint
    );
    const isMini = computed(
      () => props4.mini === true && belowBreakpoint.value !== true
    );
    const size2 = computed(() => isMini.value === true ? props4.miniWidth : props4.width);
    const showing = ref$1(
      props4.showIfAbove === true && belowBreakpoint.value === false ? true : props4.modelValue === true
    );
    const hideOnRouteChange = computed(
      () => props4.persistent !== true && (belowBreakpoint.value === true || onScreenOverlay.value === true)
    );
    function handleShow(evt, noEvent) {
      evt !== false && $layout.animate();
      applyPosition(0);
      if (belowBreakpoint.value === true) {
        const otherInstance = $layout.instances[otherSide.value];
        if ((otherInstance == null ? void 0 : otherInstance.belowBreakpoint) === true) {
          otherInstance.hide(false);
        }
        applyBackdrop(1);
        $layout.isContainer.value !== true && preventBodyScroll(true);
      } else {
        applyBackdrop(0);
        evt !== false && setScrollable(false);
      }
      registerTimeout(() => {
        evt !== false && setScrollable(true);
        noEvent !== true && emit("show", evt);
      }, duration);
    }
    function handleHide(evt, noEvent) {
      evt !== false && $layout.animate();
      applyBackdrop(0);
      applyPosition(stateDirection.value * size2.value);
      cleanup();
      if (noEvent !== true) {
        registerTimeout(() => {
          emit("hide", evt);
        }, duration);
      } else {
        removeTimeout();
      }
    }
    const { show, hide } = use_model_toggle_default({
      showing,
      hideOnRouteChange,
      handleShow,
      handleHide
    });
    use_history_default(showing);
    const instance = {
      belowBreakpoint,
      hide
    };
    const rightSide = computed(() => props4.side === "right");
    const stateDirection = computed(
      () => ($q.lang.rtl === true ? -1 : 1) * (rightSide.value === true ? 1 : -1)
    );
    const flagBackdropBg = ref$1(0);
    const flagPanning = ref$1(false);
    const flagMiniAnimate = ref$1(false);
    const flagContentPosition = ref$1(
      // starting with "hidden" for SSR
      size2.value * stateDirection.value
    );
    const otherSide = computed(() => rightSide.value === true ? "left" : "right");
    const offset2 = computed(() => showing.value === true && belowBreakpoint.value === false && props4.overlay === false ? props4.miniToOverlay === true ? props4.miniWidth : size2.value : 0);
    const fixed = computed(
      () => props4.overlay === true || props4.miniToOverlay === true || $layout.view.value.indexOf(rightSide.value ? "R" : "L") !== -1 || $q.platform.is.ios === true && $layout.isContainer.value === true
    );
    const onLayout = computed(
      () => props4.overlay === false && showing.value === true && belowBreakpoint.value === false
    );
    const onScreenOverlay = computed(
      () => props4.overlay === true && showing.value === true && belowBreakpoint.value === false
    );
    const backdropClass = computed(
      () => "fullscreen q-drawer__backdrop" + (showing.value === false && flagPanning.value === false ? " hidden" : "")
    );
    const backdropStyle = computed(() => ({
      backgroundColor: `rgba(0,0,0,${flagBackdropBg.value * 0.4})`
    }));
    const headerSlot = computed(() => rightSide.value === true ? $layout.rows.value.top[2] === "r" : $layout.rows.value.top[0] === "l");
    const footerSlot = computed(() => rightSide.value === true ? $layout.rows.value.bottom[2] === "r" : $layout.rows.value.bottom[0] === "l");
    const aboveStyle = computed(() => {
      const css2 = {};
      if ($layout.header.space === true && headerSlot.value === false) {
        if (fixed.value === true) {
          css2.top = `${$layout.header.offset}px`;
        } else if ($layout.header.space === true) {
          css2.top = `${$layout.header.size}px`;
        }
      }
      if ($layout.footer.space === true && footerSlot.value === false) {
        if (fixed.value === true) {
          css2.bottom = `${$layout.footer.offset}px`;
        } else if ($layout.footer.space === true) {
          css2.bottom = `${$layout.footer.size}px`;
        }
      }
      return css2;
    });
    const style2 = computed(() => {
      const style3 = {
        width: `${size2.value}px`,
        transform: `translateX(${flagContentPosition.value}px)`
      };
      return belowBreakpoint.value === true ? style3 : Object.assign(style3, aboveStyle.value);
    });
    const contentClass = computed(
      () => "q-drawer__content fit " + ($layout.isContainer.value !== true ? "scroll" : "overflow-auto")
    );
    const classes = computed(
      () => `q-drawer q-drawer--${props4.side}` + (flagMiniAnimate.value === true ? " q-drawer--mini-animate" : "") + (props4.bordered === true ? " q-drawer--bordered" : "") + (isDark.value === true ? " q-drawer--dark q-dark" : "") + (flagPanning.value === true ? " no-transition" : showing.value === true ? "" : " q-layout--prevent-focus") + (belowBreakpoint.value === true ? " fixed q-drawer--on-top q-drawer--mobile q-drawer--top-padding" : ` q-drawer--${isMini.value === true ? "mini" : "standard"}` + (fixed.value === true || onLayout.value !== true ? " fixed" : "") + (props4.overlay === true || props4.miniToOverlay === true ? " q-drawer--on-top" : "") + (headerSlot.value === true ? " q-drawer--top-padding" : ""))
    );
    const openDirective = computed(() => {
      const dir = $q.lang.rtl === true ? props4.side : otherSide.value;
      return [[
        TouchPan_default,
        onOpenPan,
        void 0,
        {
          [dir]: true,
          mouse: true
        }
      ]];
    });
    const contentCloseDirective = computed(() => {
      const dir = $q.lang.rtl === true ? otherSide.value : props4.side;
      return [[
        TouchPan_default,
        onClosePan,
        void 0,
        {
          [dir]: true,
          mouse: true
        }
      ]];
    });
    const backdropCloseDirective = computed(() => {
      const dir = $q.lang.rtl === true ? otherSide.value : props4.side;
      return [[
        TouchPan_default,
        onClosePan,
        void 0,
        {
          [dir]: true,
          mouse: true,
          mouseAllDir: true
        }
      ]];
    });
    function updateBelowBreakpoint() {
      updateLocal(belowBreakpoint, props4.behavior === "mobile" || props4.behavior !== "desktop" && $layout.totalWidth.value <= props4.breakpoint);
    }
    watch(belowBreakpoint, (val) => {
      if (val === true) {
        lastDesktopState = showing.value;
        showing.value === true && hide(false);
      } else if (props4.overlay === false && props4.behavior !== "mobile" && lastDesktopState !== false) {
        if (showing.value === true) {
          applyPosition(0);
          applyBackdrop(0);
          cleanup();
        } else {
          show(false);
        }
      }
    });
    watch(() => props4.side, (newSide, oldSide) => {
      if ($layout.instances[oldSide] === instance) {
        $layout.instances[oldSide] = void 0;
        $layout[oldSide].space = false;
        $layout[oldSide].offset = 0;
      }
      $layout.instances[newSide] = instance;
      $layout[newSide].size = size2.value;
      $layout[newSide].space = onLayout.value;
      $layout[newSide].offset = offset2.value;
    });
    watch($layout.totalWidth, () => {
      if ($layout.isContainer.value === true || document.qScrollPrevented !== true) {
        updateBelowBreakpoint();
      }
    });
    watch(
      () => props4.behavior + props4.breakpoint,
      updateBelowBreakpoint
    );
    watch($layout.isContainer, (val) => {
      showing.value === true && preventBodyScroll(val !== true);
      val === true && updateBelowBreakpoint();
    });
    watch($layout.scrollbarWidth, () => {
      applyPosition(showing.value === true ? 0 : void 0);
    });
    watch(offset2, (val) => {
      updateLayout("offset", val);
    });
    watch(onLayout, (val) => {
      emit("onLayout", val);
      updateLayout("space", val);
    });
    watch(rightSide, () => {
      applyPosition();
    });
    watch(size2, (val) => {
      applyPosition();
      updateSizeOnLayout(props4.miniToOverlay, val);
    });
    watch(() => props4.miniToOverlay, (val) => {
      updateSizeOnLayout(val, size2.value);
    });
    watch(() => $q.lang.rtl, () => {
      applyPosition();
    });
    watch(() => props4.mini, () => {
      if (props4.noMiniAnimation) return;
      if (props4.modelValue === true) {
        animateMini();
        $layout.animate();
      }
    });
    watch(isMini, (val) => {
      emit("miniState", val);
    });
    function applyPosition(position2) {
      if (position2 === void 0) {
        nextTick(() => {
          position2 = showing.value === true ? 0 : size2.value;
          applyPosition(stateDirection.value * position2);
        });
      } else {
        if ($layout.isContainer.value === true && rightSide.value === true && (belowBreakpoint.value === true || Math.abs(position2) === size2.value)) {
          position2 += stateDirection.value * $layout.scrollbarWidth.value;
        }
        flagContentPosition.value = position2;
      }
    }
    function applyBackdrop(x3) {
      flagBackdropBg.value = x3;
    }
    function setScrollable(v) {
      const action = v === true ? "remove" : $layout.isContainer.value !== true ? "add" : "";
      action !== "" && document.body.classList[action]("q-body--drawer-toggle");
    }
    function animateMini() {
      timerMini !== null && clearTimeout(timerMini);
      if (vm2.proxy && vm2.proxy.$el) {
        vm2.proxy.$el.classList.add("q-drawer--mini-animate");
      }
      flagMiniAnimate.value = true;
      timerMini = setTimeout(() => {
        var _a, _b;
        timerMini = null;
        flagMiniAnimate.value = false;
        (_b = (_a = vm2 == null ? void 0 : vm2.proxy) == null ? void 0 : _a.$el) == null ? void 0 : _b.classList.remove("q-drawer--mini-animate");
      }, 150);
    }
    function onOpenPan(evt) {
      if (showing.value !== false) {
        return;
      }
      const width3 = size2.value, position2 = between(evt.distance.x, 0, width3);
      if (evt.isFinal === true) {
        const opened = position2 >= Math.min(75, width3);
        if (opened === true) {
          show();
        } else {
          $layout.animate();
          applyBackdrop(0);
          applyPosition(stateDirection.value * width3);
        }
        flagPanning.value = false;
        return;
      }
      applyPosition(
        ($q.lang.rtl === true ? rightSide.value !== true : rightSide.value) ? Math.max(width3 - position2, 0) : Math.min(0, position2 - width3)
      );
      applyBackdrop(
        between(position2 / width3, 0, 1)
      );
      if (evt.isFirst === true) {
        flagPanning.value = true;
      }
    }
    function onClosePan(evt) {
      if (showing.value !== true) {
        return;
      }
      const width3 = size2.value, dir = evt.direction === props4.side, position2 = ($q.lang.rtl === true ? dir !== true : dir) ? between(evt.distance.x, 0, width3) : 0;
      if (evt.isFinal === true) {
        const opened = Math.abs(position2) < Math.min(75, width3);
        if (opened === true) {
          $layout.animate();
          applyBackdrop(1);
          applyPosition(0);
        } else {
          hide();
        }
        flagPanning.value = false;
        return;
      }
      applyPosition(stateDirection.value * position2);
      applyBackdrop(between(1 - position2 / width3, 0, 1));
      if (evt.isFirst === true) {
        flagPanning.value = true;
      }
    }
    function cleanup() {
      preventBodyScroll(false);
      setScrollable(true);
    }
    function updateLayout(prop, val) {
      $layout.update(props4.side, prop, val);
    }
    function updateLocal(prop, val) {
      if (prop.value !== val) {
        prop.value = val;
      }
    }
    function updateSizeOnLayout(miniToOverlay, size3) {
      updateLayout("size", miniToOverlay === true ? props4.miniWidth : size3);
    }
    $layout.instances[props4.side] = instance;
    updateSizeOnLayout(props4.miniToOverlay, size2.value);
    updateLayout("space", onLayout.value);
    updateLayout("offset", offset2.value);
    if (props4.showIfAbove === true && props4.modelValue !== true && showing.value === true && props4["onUpdate:modelValue"] !== void 0) {
      emit("update:modelValue", true);
    }
    onMounted(() => {
      emit("onLayout", onLayout.value);
      emit("miniState", isMini.value);
      lastDesktopState = props4.showIfAbove === true;
      const fn = () => {
        const action = showing.value === true ? handleShow : handleHide;
        action(false, true);
      };
      if ($layout.totalWidth.value !== 0) {
        nextTick(fn);
        return;
      }
      layoutTotalWidthWatcher = watch($layout.totalWidth, () => {
        layoutTotalWidthWatcher();
        layoutTotalWidthWatcher = void 0;
        if (showing.value === false && props4.showIfAbove === true && belowBreakpoint.value === false) {
          show(false);
        } else {
          fn();
        }
      });
    });
    onBeforeUnmount(() => {
      layoutTotalWidthWatcher == null ? void 0 : layoutTotalWidthWatcher();
      if (timerMini !== null) {
        clearTimeout(timerMini);
        timerMini = null;
      }
      showing.value === true && cleanup();
      if ($layout.instances[props4.side] === instance) {
        $layout.instances[props4.side] = void 0;
        updateLayout("size", 0);
        updateLayout("offset", 0);
        updateLayout("space", false);
      }
    });
    return () => {
      const child = [];
      if (belowBreakpoint.value === true) {
        props4.noSwipeOpen === false && child.push(
          withDirectives(
            h("div", {
              key: "open",
              class: `q-drawer__opener fixed-${props4.side}`,
              "aria-hidden": "true"
            }),
            openDirective.value
          )
        );
        child.push(
          hDir(
            "div",
            {
              ref: "backdrop",
              class: backdropClass.value,
              style: backdropStyle.value,
              "aria-hidden": "true",
              onClick: hide
            },
            void 0,
            "backdrop",
            props4.noSwipeBackdrop !== true && showing.value === true,
            () => backdropCloseDirective.value
          )
        );
      }
      const mini = isMini.value === true && slots.mini !== void 0;
      const content = [
        h(
          "div",
          {
            ...attrs,
            key: "" + mini,
            // required otherwise Vue will not diff correctly
            class: [
              contentClass.value,
              attrs.class
            ]
          },
          mini === true ? slots.mini() : hSlot(slots.default)
        )
      ];
      if (props4.elevated === true && showing.value === true) {
        content.push(
          h("div", {
            class: "q-layout__shadow absolute-full overflow-hidden no-pointer-events"
          })
        );
      }
      child.push(
        hDir(
          "aside",
          { ref: "content", class: classes.value, style: style2.value },
          content,
          "contentclose",
          props4.noSwipeClose !== true && belowBreakpoint.value === true,
          () => contentCloseDirective.value
        )
      );
      return h("div", { class: "q-drawer-container" }, child);
    };
  }
});
function getBlockElement(el, parent) {
  if (parent && el === parent) {
    return null;
  }
  const nodeName = el.nodeName.toLowerCase();
  if (["div", "li", "ul", "ol", "blockquote"].includes(nodeName) === true) {
    return el;
  }
  const style2 = window.getComputedStyle ? window.getComputedStyle(el) : el.currentStyle, display = style2.display;
  if (display === "block" || display === "table") {
    return el;
  }
  return getBlockElement(el.parentNode);
}
function isChildOf(el, parent, orSame) {
  return !el || el === document.body ? false : orSame === true && el === parent || (parent === document ? document.body : parent).contains(el.parentNode);
}
function createRange(node, chars, range2) {
  if (!range2) {
    range2 = document.createRange();
    range2.selectNode(node);
    range2.setStart(node, 0);
  }
  if (chars.count === 0) {
    range2.setEnd(node, chars.count);
  } else if (chars.count > 0) {
    if (node.nodeType === Node.TEXT_NODE) {
      if (node.textContent.length < chars.count) {
        chars.count -= node.textContent.length;
      } else {
        range2.setEnd(node, chars.count);
        chars.count = 0;
      }
    } else {
      for (let lp = 0; chars.count !== 0 && lp < node.childNodes.length; lp++) {
        range2 = createRange(node.childNodes[lp], chars, range2);
      }
    }
  }
  return range2;
}
var urlRegex = /^https?:\/\//;
var Caret2 = class {
  constructor(el, eVm) {
    this.el = el;
    this.eVm = eVm;
    this._range = null;
  }
  get selection() {
    if (this.el) {
      const sel = document.getSelection();
      if (isChildOf(sel.anchorNode, this.el, true) && isChildOf(sel.focusNode, this.el, true)) {
        return sel;
      }
    }
    return null;
  }
  get hasSelection() {
    return this.selection !== null ? this.selection.toString().length !== 0 : false;
  }
  get range() {
    const sel = this.selection;
    if (sel == null ? void 0 : sel.rangeCount) {
      return sel.getRangeAt(0);
    }
    return this._range;
  }
  get parent() {
    const range2 = this.range;
    if (range2 !== null) {
      const node = range2.startContainer;
      return node.nodeType === document.ELEMENT_NODE ? node : node.parentNode;
    }
    return null;
  }
  get blockParent() {
    const parent = this.parent;
    if (parent !== null) {
      return getBlockElement(parent, this.el);
    }
    return null;
  }
  save(range2 = this.range) {
    if (range2 !== null) {
      this._range = range2;
    }
  }
  restore(range2 = this._range) {
    const r = document.createRange(), sel = document.getSelection();
    if (range2 !== null) {
      r.setStart(range2.startContainer, range2.startOffset);
      r.setEnd(range2.endContainer, range2.endOffset);
      sel.removeAllRanges();
      sel.addRange(r);
    } else {
      sel.selectAllChildren(this.el);
      sel.collapseToEnd();
    }
  }
  savePosition() {
    let charCount = -1, node;
    const selection = document.getSelection(), parentEl = this.el.parentNode;
    if (selection.focusNode && isChildOf(selection.focusNode, parentEl)) {
      node = selection.focusNode;
      charCount = selection.focusOffset;
      while (node && node !== parentEl) {
        if (node !== this.el && node.previousSibling) {
          node = node.previousSibling;
          charCount += node.textContent.length;
        } else {
          node = node.parentNode;
        }
      }
    }
    this.savedPos = charCount;
  }
  restorePosition(length = 0) {
    if (this.savedPos > 0 && this.savedPos < length) {
      const selection = window.getSelection(), range2 = createRange(this.el, { count: this.savedPos });
      if (range2) {
        range2.collapse(false);
        selection.removeAllRanges();
        selection.addRange(range2);
      }
    }
  }
  hasParent(name2, spanLevel) {
    const el = spanLevel ? this.parent : this.blockParent;
    return el !== null ? el.nodeName.toLowerCase() === name2.toLowerCase() : false;
  }
  hasParents(list, recursive, el = this.parent) {
    if (el === null) {
      return false;
    }
    if (list.includes(el.nodeName.toLowerCase()) === true) {
      return true;
    }
    return recursive === true ? this.hasParents(list, recursive, el.parentNode) : false;
  }
  is(cmd, param) {
    if (this.selection === null) {
      return false;
    }
    switch (cmd) {
      case "formatBlock":
        return param === "DIV" && this.parent === this.el || this.hasParent(param, param === "PRE");
      case "link":
        return this.hasParent("A", true);
      case "fontSize":
        return document.queryCommandValue(cmd) === param;
      case "fontName":
        const res = document.queryCommandValue(cmd);
        return res === `"${param}"` || res === param;
      case "fullscreen":
        return this.eVm.inFullscreen.value;
      case "viewsource":
        return this.eVm.isViewingSource.value;
      case void 0:
        return false;
      default:
        const state2 = document.queryCommandState(cmd);
        return param !== void 0 ? state2 === param : state2;
    }
  }
  getParentAttribute(attrib) {
    if (this.parent !== null) {
      return this.parent.getAttribute(attrib);
    }
    return null;
  }
  can(name2) {
    if (name2 === "outdent") {
      return this.hasParents(["blockquote", "li"], true);
    }
    if (name2 === "indent") {
      return this.hasParents(["li"], true);
    }
    if (name2 === "link") {
      return this.selection !== null || this.is("link");
    }
  }
  apply(cmd, param, done = noop) {
    if (cmd === "formatBlock") {
      if (["BLOCKQUOTE", "H1", "H2", "H3", "H4", "H5", "H6"].includes(param) && this.is(cmd, param)) {
        cmd = "outdent";
        param = null;
      }
      if (param === "PRE" && this.is(cmd, "PRE")) {
        param = "P";
      }
    } else if (cmd === "print") {
      done();
      const win = window.open();
      win.document.write(`
        <!doctype html>
        <html>
          <head>
            <title>Print - ${document.title}</title>
          </head>
          <body>
            <div>${this.el.innerHTML}</div>
          </body>
        </html>
      `);
      win.print();
      win.close();
      return;
    } else if (cmd === "link") {
      const link = this.getParentAttribute("href");
      if (link === null) {
        const selection = this.selectWord(this.selection);
        const url = selection ? selection.toString() : "";
        if (!url.length && (!this.range || !this.range.cloneContents().querySelector("img"))) return;
        this.eVm.editLinkUrl.value = urlRegex.test(url) ? url : "https://";
        document.execCommand("createLink", false, this.eVm.editLinkUrl.value);
        this.save(selection.getRangeAt(0));
      } else {
        this.eVm.editLinkUrl.value = link;
        this.range.selectNodeContents(this.parent);
        this.save();
      }
      return;
    } else if (cmd === "fullscreen") {
      this.eVm.toggleFullscreen();
      done();
      return;
    } else if (cmd === "viewsource") {
      this.eVm.isViewingSource.value = this.eVm.isViewingSource.value === false;
      this.eVm.setContent(this.eVm.props.modelValue);
      done();
      return;
    }
    document.execCommand(cmd, false, param);
    done();
  }
  selectWord(sel) {
    if (sel === null || sel.isCollapsed !== true || /* IE 11 */
    sel.modify === void 0) {
      return sel;
    }
    const range2 = document.createRange();
    range2.setStart(sel.anchorNode, sel.anchorOffset);
    range2.setEnd(sel.focusNode, sel.focusOffset);
    const direction = range2.collapsed ? ["backward", "forward"] : ["forward", "backward"];
    range2.detach();
    const endNode = sel.focusNode, endOffset = sel.focusOffset;
    sel.collapse(sel.anchorNode, sel.anchorOffset);
    sel.modify("move", direction[0], "character");
    sel.modify("move", direction[1], "word");
    sel.extend(endNode, endOffset);
    sel.modify("extend", direction[1], "character");
    sel.modify("extend", direction[0], "word");
    return sel;
  }
};
var QTooltip_default = createComponent({
  name: "QTooltip",
  inheritAttrs: false,
  props: {
    ...useAnchorStaticProps,
    ...useModelToggleProps,
    ...useTransitionProps,
    maxHeight: {
      type: String,
      default: null
    },
    maxWidth: {
      type: String,
      default: null
    },
    transitionShow: {
      ...useTransitionProps.transitionShow,
      default: "jump-down"
    },
    transitionHide: {
      ...useTransitionProps.transitionHide,
      default: "jump-up"
    },
    anchor: {
      type: String,
      default: "bottom middle",
      validator: validatePosition
    },
    self: {
      type: String,
      default: "top middle",
      validator: validatePosition
    },
    offset: {
      type: Array,
      default: () => [14, 14],
      validator: validateOffset
    },
    scrollTarget: scrollTargetProp,
    delay: {
      type: Number,
      default: 0
    },
    hideDelay: {
      type: Number,
      default: 0
    },
    persistent: Boolean
  },
  emits: [
    ...useModelToggleEmits
  ],
  setup(props4, { slots, emit, attrs }) {
    let unwatchPosition, observer;
    const vm2 = getCurrentInstance();
    const { proxy: { $q } } = vm2;
    const innerRef = ref$1(null);
    const showing = ref$1(false);
    const anchorOrigin = computed(() => parsePosition(props4.anchor, $q.lang.rtl));
    const selfOrigin = computed(() => parsePosition(props4.self, $q.lang.rtl));
    const hideOnRouteChange = computed(() => props4.persistent !== true);
    const { registerTick, removeTick } = use_tick_default();
    const { registerTimeout } = use_timeout_default();
    const { transitionProps, transitionStyle } = use_transition_default(props4);
    const { localScrollTarget, changeScrollEvent, unconfigureScrollTarget } = use_scroll_target_default(props4, configureScrollTarget);
    const { anchorEl, canShow, anchorEvents } = use_anchor_default({ showing, configureAnchorEl });
    const { show, hide } = use_model_toggle_default({
      showing,
      canShow,
      handleShow,
      handleHide,
      hideOnRouteChange,
      processOnMount: true
    });
    Object.assign(anchorEvents, { delayShow, delayHide });
    const { showPortal, hidePortal, renderPortal } = use_portal_default(vm2, innerRef, renderPortalContent, "tooltip");
    if ($q.platform.is.mobile === true) {
      const clickOutsideProps = {
        anchorEl,
        innerRef,
        onClickOutside(e3) {
          hide(e3);
          if (e3.target.classList.contains("q-dialog__backdrop")) {
            stopAndPrevent(e3);
          }
          return true;
        }
      };
      const hasClickOutside = computed(
        () => (
          // it doesn't has external model
          // (null is the default value)
          props4.modelValue === null && props4.persistent !== true && showing.value === true
        )
      );
      watch(hasClickOutside, (val) => {
        const fn = val === true ? addClickOutside : removeClickOutside;
        fn(clickOutsideProps);
      });
      onBeforeUnmount(() => {
        removeClickOutside(clickOutsideProps);
      });
    }
    function handleShow(evt) {
      showPortal();
      registerTick(() => {
        observer = new MutationObserver(() => updatePosition());
        observer.observe(innerRef.value, { attributes: false, childList: true, characterData: true, subtree: true });
        updatePosition();
        configureScrollTarget();
      });
      if (unwatchPosition === void 0) {
        unwatchPosition = watch(
          () => $q.screen.width + "|" + $q.screen.height + "|" + props4.self + "|" + props4.anchor + "|" + $q.lang.rtl,
          updatePosition
        );
      }
      registerTimeout(() => {
        showPortal(true);
        emit("show", evt);
      }, props4.transitionDuration);
    }
    function handleHide(evt) {
      removeTick();
      hidePortal();
      anchorCleanup();
      registerTimeout(() => {
        hidePortal(true);
        emit("hide", evt);
      }, props4.transitionDuration);
    }
    function anchorCleanup() {
      if (observer !== void 0) {
        observer.disconnect();
        observer = void 0;
      }
      if (unwatchPosition !== void 0) {
        unwatchPosition();
        unwatchPosition = void 0;
      }
      unconfigureScrollTarget();
      cleanEvt(anchorEvents, "tooltipTemp");
    }
    function updatePosition() {
      setPosition({
        targetEl: innerRef.value,
        offset: props4.offset,
        anchorEl: anchorEl.value,
        anchorOrigin: anchorOrigin.value,
        selfOrigin: selfOrigin.value,
        maxHeight: props4.maxHeight,
        maxWidth: props4.maxWidth
      });
    }
    function delayShow(evt) {
      if ($q.platform.is.mobile === true) {
        clearSelection();
        document.body.classList.add("non-selectable");
        const target2 = anchorEl.value;
        const evts = ["touchmove", "touchcancel", "touchend", "click"].map((e3) => [target2, e3, "delayHide", "passiveCapture"]);
        addEvt(anchorEvents, "tooltipTemp", evts);
      }
      registerTimeout(() => {
        show(evt);
      }, props4.delay);
    }
    function delayHide(evt) {
      if ($q.platform.is.mobile === true) {
        cleanEvt(anchorEvents, "tooltipTemp");
        clearSelection();
        setTimeout(() => {
          document.body.classList.remove("non-selectable");
        }, 10);
      }
      registerTimeout(() => {
        hide(evt);
      }, props4.hideDelay);
    }
    function configureAnchorEl() {
      if (props4.noParentEvent === true || anchorEl.value === null) return;
      const evts = $q.platform.is.mobile === true ? [
        [anchorEl.value, "touchstart", "delayShow", "passive"]
      ] : [
        [anchorEl.value, "mouseenter", "delayShow", "passive"],
        [anchorEl.value, "mouseleave", "delayHide", "passive"]
      ];
      addEvt(anchorEvents, "anchor", evts);
    }
    function configureScrollTarget() {
      if (anchorEl.value !== null || props4.scrollTarget !== void 0) {
        localScrollTarget.value = getScrollTarget(anchorEl.value, props4.scrollTarget);
        const fn = props4.noParentEvent === true ? updatePosition : hide;
        changeScrollEvent(localScrollTarget.value, fn);
      }
    }
    function getTooltipContent() {
      return showing.value === true ? h("div", {
        ...attrs,
        ref: innerRef,
        class: [
          "q-tooltip q-tooltip--style q-position-engine no-pointer-events",
          attrs.class
        ],
        style: [
          attrs.style,
          transitionStyle.value
        ],
        role: "tooltip"
      }, hSlot(slots.default)) : null;
    }
    function renderPortalContent() {
      return h(Transition, transitionProps.value, getTooltipContent);
    }
    onBeforeUnmount(anchorCleanup);
    Object.assign(vm2.proxy, { updatePosition });
    return renderPortal;
  }
});
var QItem_default = createComponent({
  name: "QItem",
  props: {
    ...useDarkProps,
    ...useRouterLinkProps,
    tag: {
      type: String,
      default: "div"
    },
    active: {
      type: Boolean,
      default: null
    },
    clickable: Boolean,
    dense: Boolean,
    insetLevel: Number,
    tabindex: [String, Number],
    focused: Boolean,
    manualFocus: Boolean
  },
  emits: ["click", "keyup"],
  setup(props4, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const isDark = use_dark_default(props4, $q);
    const { hasLink, linkAttrs, linkClass, linkTag, navigateOnClick } = use_router_link_default();
    const rootRef = ref$1(null);
    const blurTargetRef = ref$1(null);
    const isActionable = computed(
      () => props4.clickable === true || hasLink.value === true || props4.tag === "label"
    );
    const isClickable = computed(
      () => props4.disable !== true && isActionable.value === true
    );
    const classes = computed(
      () => "q-item q-item-type row no-wrap" + (props4.dense === true ? " q-item--dense" : "") + (isDark.value === true ? " q-item--dark" : "") + (hasLink.value === true && props4.active === null ? linkClass.value : props4.active === true ? ` q-item--active${props4.activeClass !== void 0 ? ` ${props4.activeClass}` : ""}` : "") + (props4.disable === true ? " disabled" : "") + (isClickable.value === true ? " q-item--clickable q-link cursor-pointer " + (props4.manualFocus === true ? "q-manual-focusable" : "q-focusable q-hoverable") + (props4.focused === true ? " q-manual-focusable--focused" : "") : "")
    );
    const style2 = computed(() => {
      if (props4.insetLevel === void 0) {
        return null;
      }
      const dir = $q.lang.rtl === true ? "Right" : "Left";
      return {
        ["padding" + dir]: 16 + props4.insetLevel * 56 + "px"
      };
    });
    function onClick(e3) {
      if (isClickable.value === true) {
        if (blurTargetRef.value !== null && e3.qAvoidFocus !== true) {
          if (e3.qKeyEvent !== true && document.activeElement === rootRef.value) {
            blurTargetRef.value.focus();
          } else if (document.activeElement === blurTargetRef.value) {
            rootRef.value.focus();
          }
        }
        navigateOnClick(e3);
      }
    }
    function onKeyup2(e3) {
      if (isClickable.value === true && isKeyCode(e3, [13, 32]) === true) {
        stopAndPrevent(e3);
        e3.qKeyEvent = true;
        const evt = new MouseEvent("click", e3);
        evt.qKeyEvent = true;
        rootRef.value.dispatchEvent(evt);
      }
      emit("keyup", e3);
    }
    function getContent() {
      const child = hUniqueSlot(slots.default, []);
      isClickable.value === true && child.unshift(
        h("div", { class: "q-focus-helper", tabindex: -1, ref: blurTargetRef })
      );
      return child;
    }
    return () => {
      const data = {
        ref: rootRef,
        class: classes.value,
        style: style2.value,
        role: "listitem",
        onClick,
        onKeyup: onKeyup2
      };
      if (isClickable.value === true) {
        data.tabindex = props4.tabindex || "0";
        Object.assign(data, linkAttrs.value);
      } else if (isActionable.value === true) {
        data["aria-disabled"] = "true";
      }
      return h(
        linkTag.value,
        data,
        getContent()
      );
    };
  }
});
var QItemSection_default = createComponent({
  name: "QItemSection",
  props: {
    avatar: Boolean,
    thumbnail: Boolean,
    side: Boolean,
    top: Boolean,
    noWrap: Boolean
  },
  setup(props4, { slots }) {
    const classes = computed(
      () => `q-item__section column q-item__section--${props4.avatar === true || props4.side === true || props4.thumbnail === true ? "side" : "main"}` + (props4.top === true ? " q-item__section--top justify-start" : " justify-center") + (props4.avatar === true ? " q-item__section--avatar" : "") + (props4.thumbnail === true ? " q-item__section--thumbnail" : "") + (props4.noWrap === true ? " q-item__section--nowrap" : "")
    );
    return () => h("div", { class: classes.value }, hSlot(slots.default));
  }
});
function run(e3, btn, eVm) {
  if (btn.handler) {
    btn.handler(e3, eVm, eVm.caret);
  } else {
    eVm.runCmd(btn.cmd, btn.param);
  }
}
function getGroup(children) {
  return h("div", { class: "q-editor__toolbar-group" }, children);
}
function getBtn(eVm, btn, clickHandler, active = false) {
  const toggled = active || (btn.type === "toggle" ? btn.toggled ? btn.toggled(eVm) : btn.cmd && eVm.caret.is(btn.cmd, btn.param) : false), child = [];
  if (eVm.$q.platform.is.desktop && (btn.tip || btn.htmlTip)) {
    const Key = btn.key ? h("div", [
      h("small", `(CTRL + ${String.fromCharCode(btn.key)})`)
    ]) : null;
    child.push(
      h(QTooltip_default, { delay: 1e3 }, () => [
        h("div", btn.htmlTip ? { innerHTML: btn.htmlTip } : btn.tip),
        Key
      ])
    );
  }
  return h(QBtn_default, {
    ...eVm.buttonProps.value,
    icon: btn.icon !== null ? btn.icon : void 0,
    color: toggled ? btn.toggleColor || eVm.props.toolbarToggleColor : btn.color || eVm.props.toolbarColor,
    textColor: toggled && !eVm.props.toolbarPush ? null : btn.textColor || eVm.props.toolbarTextColor,
    label: btn.label,
    "aria-label": btn.label == null ? btn.tip : void 0,
    disable: btn.disable ? typeof btn.disable === "function" ? btn.disable(eVm) : true : false,
    size: "sm",
    onClick(e3) {
      clickHandler == null ? void 0 : clickHandler();
      run(e3, btn, eVm);
    }
  }, () => child);
}
function getDropdown(eVm, btn) {
  const onlyIcons = btn.list === "only-icons";
  let label = btn.label, icon = btn.icon !== null ? btn.icon : void 0, contentClass, Items;
  function closeDropdown() {
    Dropdown.component.proxy.hide();
  }
  if (onlyIcons) {
    Items = btn.options.map((btn2) => {
      const active = btn2.type === void 0 ? eVm.caret.is(btn2.cmd, btn2.param) : false;
      if (active) {
        label = btn2.tip;
        icon = btn2.icon !== null ? btn2.icon : void 0;
      }
      return getBtn(eVm, btn2, closeDropdown, active);
    });
    contentClass = eVm.toolbarBackgroundClass.value;
    Items = [
      getGroup(Items)
    ];
  } else {
    const activeClass = eVm.props.toolbarToggleColor !== void 0 ? `text-${eVm.props.toolbarToggleColor}` : null;
    const inactiveClass = eVm.props.toolbarTextColor !== void 0 ? `text-${eVm.props.toolbarTextColor}` : null;
    const noIcons = btn.list === "no-icons";
    Items = btn.options.map((btn2) => {
      const disable = btn2.disable ? btn2.disable(eVm) : false;
      const active = btn2.type === void 0 ? eVm.caret.is(btn2.cmd, btn2.param) : false;
      if (active) {
        label = btn2.tip;
        icon = btn2.icon !== null ? btn2.icon : void 0;
      }
      const htmlTip = btn2.htmlTip;
      return h(QItem_default, {
        active,
        activeClass,
        clickable: true,
        disable,
        dense: true,
        onClick(e3) {
          var _a;
          closeDropdown();
          (e3 == null ? void 0 : e3.qAvoidFocus) !== true && ((_a = eVm.contentRef.value) == null ? void 0 : _a.focus());
          eVm.caret.restore();
          run(e3, btn2, eVm);
        }
      }, () => [
        noIcons === true ? null : h(
          QItemSection_default,
          {
            class: active ? activeClass : inactiveClass,
            side: true
          },
          () => h(QIcon_default, { name: btn2.icon !== null ? btn2.icon : void 0 })
        ),
        h(
          QItemSection_default,
          htmlTip ? () => h("div", { class: "text-no-wrap", innerHTML: btn2.htmlTip }) : btn2.tip ? () => h("div", { class: "text-no-wrap" }, btn2.tip) : void 0
        )
      ]);
    });
    contentClass = [eVm.toolbarBackgroundClass.value, inactiveClass];
  }
  const highlight = btn.highlight && label !== btn.label;
  const Dropdown = h(QBtnDropdown_default, {
    ...eVm.buttonProps.value,
    noCaps: true,
    noWrap: true,
    color: highlight ? eVm.props.toolbarToggleColor : eVm.props.toolbarColor,
    textColor: highlight && !eVm.props.toolbarPush ? null : eVm.props.toolbarTextColor,
    label: btn.fixedLabel ? btn.label : label,
    icon: btn.fixedIcon ? btn.icon !== null ? btn.icon : void 0 : icon,
    contentClass,
    onShow: (evt) => eVm.emit("dropdownShow", evt),
    onHide: (evt) => eVm.emit("dropdownHide", evt),
    onBeforeShow: (evt) => eVm.emit("dropdownBeforeShow", evt),
    onBeforeHide: (evt) => eVm.emit("dropdownBeforeHide", evt)
  }, () => Items);
  return Dropdown;
}
function getToolbar(eVm) {
  if (eVm.caret) {
    return eVm.buttons.value.filter((f) => {
      return !eVm.isViewingSource.value || f.find((fb) => fb.cmd === "viewsource");
    }).map((group) => getGroup(
      group.map((btn) => {
        if (eVm.isViewingSource.value && btn.cmd !== "viewsource") {
          return false;
        }
        if (btn.type === "slot") {
          return hSlot(eVm.slots[btn.slot]);
        }
        if (btn.type === "dropdown") {
          return getDropdown(eVm, btn);
        }
        return getBtn(eVm, btn);
      })
    ));
  }
}
function getFonts(defaultFont, defaultFontLabel, defaultFontIcon, fonts = {}) {
  const aliases = Object.keys(fonts);
  if (aliases.length === 0) {
    return {};
  }
  const def = {
    default_font: {
      cmd: "fontName",
      param: defaultFont,
      icon: defaultFontIcon,
      tip: defaultFontLabel
    }
  };
  aliases.forEach((alias) => {
    const name2 = fonts[alias];
    def[alias] = {
      cmd: "fontName",
      param: name2,
      icon: defaultFontIcon,
      tip: name2,
      htmlTip: `<font face="${name2}">${name2}</font>`
    };
  });
  return def;
}
function getLinkEditor(eVm) {
  if (eVm.caret) {
    const color2 = eVm.props.toolbarColor || eVm.props.toolbarTextColor;
    let link = eVm.editLinkUrl.value;
    const updateLink = () => {
      eVm.caret.restore();
      if (link !== eVm.editLinkUrl.value) {
        document.execCommand("createLink", false, link === "" ? " " : link);
      }
      eVm.editLinkUrl.value = null;
    };
    return [
      h("div", { class: `q-mx-xs text-${color2}` }, `${eVm.$q.lang.editor.url}: `),
      h("input", {
        key: "qedt_btm_input",
        class: "col q-editor__link-input",
        value: link,
        onInput: (evt) => {
          stop(evt);
          link = evt.target.value;
        },
        onKeydown: (evt) => {
          if (shouldIgnoreKey(evt) === true) return;
          switch (evt.keyCode) {
            case 13:
              prevent(evt);
              return updateLink();
            case 27:
              prevent(evt);
              eVm.caret.restore();
              if (!eVm.editLinkUrl.value || eVm.editLinkUrl.value === "https://") {
                document.execCommand("unlink");
              }
              eVm.editLinkUrl.value = null;
              break;
          }
        }
      }),
      getGroup([
        h(QBtn_default, {
          key: "qedt_btm_rem",
          ...eVm.buttonProps.value,
          label: eVm.$q.lang.label.remove,
          noCaps: true,
          onClick: () => {
            eVm.caret.restore();
            document.execCommand("unlink");
            eVm.editLinkUrl.value = null;
          }
        }),
        h(QBtn_default, {
          key: "qedt_btm_upd",
          ...eVm.buttonProps.value,
          label: eVm.$q.lang.label.update,
          noCaps: true,
          onClick: updateLink
        })
      ])
    ];
  }
}
var listenerRE = /^on[A-Z]/;
function use_split_attrs_default() {
  const { attrs, vnode } = getCurrentInstance();
  const acc = {
    listeners: ref$1({}),
    attributes: ref$1({})
  };
  function update6() {
    const attributes = {};
    const listeners = {};
    for (const key in attrs) {
      if (key !== "class" && key !== "style" && listenerRE.test(key) === false) {
        attributes[key] = attrs[key];
      }
    }
    for (const key in vnode.props) {
      if (listenerRE.test(key) === true) {
        listeners[key] = vnode.props[key];
      }
    }
    acc.attributes.value = attributes;
    acc.listeners.value = listeners;
  }
  onBeforeUpdate(update6);
  update6();
  return acc;
}
var toString = Object.prototype.toString;
var hasOwn = Object.prototype.hasOwnProperty;
var notPlainObject = new Set(
  ["Boolean", "Number", "String", "Function", "Array", "Date", "RegExp"].map((name2) => "[object " + name2 + "]")
);
function isPlainObject(obj) {
  if (obj !== Object(obj) || notPlainObject.has(toString.call(obj)) === true) {
    return false;
  }
  if (obj.constructor && hasOwn.call(obj, "constructor") === false && hasOwn.call(obj.constructor.prototype, "isPrototypeOf") === false) {
    return false;
  }
  let key;
  for (key in obj) {
  }
  return key === void 0 || hasOwn.call(obj, key);
}
function extend() {
  let options, name2, src, copy, copyIsArray, clone2, target2 = arguments[0] || {}, i3 = 1, deep = false;
  const length = arguments.length;
  if (typeof target2 === "boolean") {
    deep = target2;
    target2 = arguments[1] || {};
    i3 = 2;
  }
  if (Object(target2) !== target2 && typeof target2 !== "function") {
    target2 = {};
  }
  if (length === i3) {
    target2 = this;
    i3--;
  }
  for (; i3 < length; i3++) {
    if ((options = arguments[i3]) !== null) {
      for (name2 in options) {
        src = target2[name2];
        copy = options[name2];
        if (target2 === copy) {
          continue;
        }
        if (deep === true && copy && ((copyIsArray = Array.isArray(copy)) || isPlainObject(copy) === true)) {
          if (copyIsArray === true) {
            clone2 = Array.isArray(src) === true ? src : [];
          } else {
            clone2 = isPlainObject(src) === true ? src : {};
          }
          target2[name2] = extend(deep, clone2, copy);
        } else if (copy !== void 0) {
          target2[name2] = copy;
        }
      }
    }
  }
  return target2;
}
createComponent({
  name: "QEditor",
  props: {
    ...useDarkProps,
    ...useFullscreenProps,
    modelValue: {
      type: String,
      required: true
    },
    readonly: Boolean,
    disable: Boolean,
    minHeight: {
      type: String,
      default: "10rem"
    },
    maxHeight: String,
    height: String,
    definitions: Object,
    fonts: Object,
    placeholder: String,
    toolbar: {
      type: Array,
      validator: (v) => v.length === 0 || v.every((group) => group.length),
      // long line on purpose for API validation purposes:
      default: () => [["left", "center", "right", "justify"], ["bold", "italic", "underline", "strike"], ["undo", "redo"]]
    },
    toolbarColor: String,
    toolbarBg: String,
    toolbarTextColor: String,
    toolbarToggleColor: {
      type: String,
      default: "primary"
    },
    toolbarOutline: Boolean,
    toolbarPush: Boolean,
    toolbarRounded: Boolean,
    paragraphTag: {
      type: String,
      validator: (v) => ["div", "p"].includes(v),
      default: "div"
    },
    contentStyle: Object,
    contentClass: [Object, Array, String],
    square: Boolean,
    flat: Boolean,
    dense: Boolean
  },
  emits: [
    ...useFullscreenEmits,
    "update:modelValue",
    "keydown",
    "click",
    "focus",
    "blur",
    "dropdownShow",
    "dropdownHide",
    "dropdownBeforeShow",
    "dropdownBeforeHide",
    "linkShow",
    "linkHide"
  ],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const isDark = use_dark_default(props4, $q);
    const { inFullscreen, toggleFullscreen } = use_fullscreen_default();
    const splitAttrs = use_split_attrs_default();
    const rootRef = ref$1(null);
    const contentRef = ref$1(null);
    const editLinkUrl = ref$1(null);
    const isViewingSource = ref$1(false);
    const editable = computed(() => !props4.readonly && !props4.disable);
    let defaultFont, offsetBottom;
    let lastEmit = props4.modelValue;
    {
      document.execCommand("defaultParagraphSeparator", false, props4.paragraphTag);
      defaultFont = window.getComputedStyle(document.body).fontFamily;
    }
    const toolbarBackgroundClass = computed(() => props4.toolbarBg ? ` bg-${props4.toolbarBg}` : "");
    const buttonProps = computed(() => {
      const flat = props4.toolbarOutline !== true && props4.toolbarPush !== true;
      return {
        type: "a",
        flat,
        noWrap: true,
        outline: props4.toolbarOutline,
        push: props4.toolbarPush,
        rounded: props4.toolbarRounded,
        dense: true,
        color: props4.toolbarColor,
        disable: !editable.value,
        size: "sm"
      };
    });
    const buttonDef = computed(() => {
      const e3 = $q.lang.editor, i3 = $q.iconSet.editor;
      return {
        bold: { cmd: "bold", icon: i3.bold, tip: e3.bold, key: 66 },
        italic: { cmd: "italic", icon: i3.italic, tip: e3.italic, key: 73 },
        strike: { cmd: "strikeThrough", icon: i3.strikethrough, tip: e3.strikethrough, key: 83 },
        underline: { cmd: "underline", icon: i3.underline, tip: e3.underline, key: 85 },
        unordered: { cmd: "insertUnorderedList", icon: i3.unorderedList, tip: e3.unorderedList },
        ordered: { cmd: "insertOrderedList", icon: i3.orderedList, tip: e3.orderedList },
        subscript: { cmd: "subscript", icon: i3.subscript, tip: e3.subscript, htmlTip: "x<subscript>2</subscript>" },
        superscript: { cmd: "superscript", icon: i3.superscript, tip: e3.superscript, htmlTip: "x<superscript>2</superscript>" },
        link: { cmd: "link", disable: (eVm2) => eVm2.caret && !eVm2.caret.can("link"), icon: i3.hyperlink, tip: e3.hyperlink, key: 76 },
        fullscreen: { cmd: "fullscreen", icon: i3.toggleFullscreen, tip: e3.toggleFullscreen, key: 70 },
        viewsource: { cmd: "viewsource", icon: i3.viewSource, tip: e3.viewSource },
        quote: { cmd: "formatBlock", param: "BLOCKQUOTE", icon: i3.quote, tip: e3.quote, key: 81 },
        left: { cmd: "justifyLeft", icon: i3.left, tip: e3.left },
        center: { cmd: "justifyCenter", icon: i3.center, tip: e3.center },
        right: { cmd: "justifyRight", icon: i3.right, tip: e3.right },
        justify: { cmd: "justifyFull", icon: i3.justify, tip: e3.justify },
        print: { type: "no-state", cmd: "print", icon: i3.print, tip: e3.print, key: 80 },
        outdent: { type: "no-state", disable: (eVm2) => eVm2.caret && !eVm2.caret.can("outdent"), cmd: "outdent", icon: i3.outdent, tip: e3.outdent },
        indent: { type: "no-state", disable: (eVm2) => eVm2.caret && !eVm2.caret.can("indent"), cmd: "indent", icon: i3.indent, tip: e3.indent },
        removeFormat: { type: "no-state", cmd: "removeFormat", icon: i3.removeFormat, tip: e3.removeFormat },
        hr: { type: "no-state", cmd: "insertHorizontalRule", icon: i3.hr, tip: e3.hr },
        undo: { type: "no-state", cmd: "undo", icon: i3.undo, tip: e3.undo, key: 90 },
        redo: { type: "no-state", cmd: "redo", icon: i3.redo, tip: e3.redo, key: 89 },
        h1: { cmd: "formatBlock", param: "H1", icon: i3.heading1 || i3.heading, tip: e3.heading1, htmlTip: `<h1 class="q-ma-none">${e3.heading1}</h1>` },
        h2: { cmd: "formatBlock", param: "H2", icon: i3.heading2 || i3.heading, tip: e3.heading2, htmlTip: `<h2 class="q-ma-none">${e3.heading2}</h2>` },
        h3: { cmd: "formatBlock", param: "H3", icon: i3.heading3 || i3.heading, tip: e3.heading3, htmlTip: `<h3 class="q-ma-none">${e3.heading3}</h3>` },
        h4: { cmd: "formatBlock", param: "H4", icon: i3.heading4 || i3.heading, tip: e3.heading4, htmlTip: `<h4 class="q-ma-none">${e3.heading4}</h4>` },
        h5: { cmd: "formatBlock", param: "H5", icon: i3.heading5 || i3.heading, tip: e3.heading5, htmlTip: `<h5 class="q-ma-none">${e3.heading5}</h5>` },
        h6: { cmd: "formatBlock", param: "H6", icon: i3.heading6 || i3.heading, tip: e3.heading6, htmlTip: `<h6 class="q-ma-none">${e3.heading6}</h6>` },
        p: { cmd: "formatBlock", param: props4.paragraphTag, icon: i3.heading, tip: e3.paragraph },
        code: { cmd: "formatBlock", param: "PRE", icon: i3.code, htmlTip: `<code>${e3.code}</code>` },
        "size-1": { cmd: "fontSize", param: "1", icon: i3.size1 || i3.size, tip: e3.size1, htmlTip: `<font size="1">${e3.size1}</font>` },
        "size-2": { cmd: "fontSize", param: "2", icon: i3.size2 || i3.size, tip: e3.size2, htmlTip: `<font size="2">${e3.size2}</font>` },
        "size-3": { cmd: "fontSize", param: "3", icon: i3.size3 || i3.size, tip: e3.size3, htmlTip: `<font size="3">${e3.size3}</font>` },
        "size-4": { cmd: "fontSize", param: "4", icon: i3.size4 || i3.size, tip: e3.size4, htmlTip: `<font size="4">${e3.size4}</font>` },
        "size-5": { cmd: "fontSize", param: "5", icon: i3.size5 || i3.size, tip: e3.size5, htmlTip: `<font size="5">${e3.size5}</font>` },
        "size-6": { cmd: "fontSize", param: "6", icon: i3.size6 || i3.size, tip: e3.size6, htmlTip: `<font size="6">${e3.size6}</font>` },
        "size-7": { cmd: "fontSize", param: "7", icon: i3.size7 || i3.size, tip: e3.size7, htmlTip: `<font size="7">${e3.size7}</font>` }
      };
    });
    const buttons = computed(() => {
      const userDef = props4.definitions || {};
      const def = props4.definitions || props4.fonts ? extend(
        true,
        {},
        buttonDef.value,
        userDef,
        getFonts(
          defaultFont,
          $q.lang.editor.defaultFont,
          $q.iconSet.editor.font,
          props4.fonts
        )
      ) : buttonDef.value;
      return props4.toolbar.map(
        (group) => group.map((token2) => {
          if (token2.options) {
            return {
              type: "dropdown",
              icon: token2.icon,
              label: token2.label,
              size: "sm",
              dense: true,
              fixedLabel: token2.fixedLabel,
              fixedIcon: token2.fixedIcon,
              highlight: token2.highlight,
              list: token2.list,
              options: token2.options.map((item) => def[item])
            };
          }
          const obj = def[token2];
          if (obj) {
            return obj.type === "no-state" || userDef[token2] && (obj.cmd === void 0 || buttonDef.value[obj.cmd] && buttonDef.value[obj.cmd].type === "no-state") ? obj : Object.assign({ type: "toggle" }, obj);
          } else {
            return {
              type: "slot",
              slot: token2
            };
          }
        })
      );
    });
    const eVm = {
      $q,
      props: props4,
      slots,
      emit,
      // caret (will get injected after mount)
      inFullscreen,
      toggleFullscreen,
      runCmd,
      isViewingSource,
      editLinkUrl,
      toolbarBackgroundClass,
      buttonProps,
      contentRef,
      buttons,
      setContent
    };
    watch(() => props4.modelValue, (v) => {
      if (lastEmit !== v) {
        lastEmit = v;
        setContent(v, true);
      }
    });
    watch(editLinkUrl, (v) => {
      emit(`link${v ? "Show" : "Hide"}`);
    });
    const hasToolbar = computed(() => props4.toolbar && props4.toolbar.length !== 0);
    const keys2 = computed(() => {
      const k3 = {}, add2 = (btn) => {
        if (btn.key) {
          k3[btn.key] = {
            cmd: btn.cmd,
            param: btn.param
          };
        }
      };
      buttons.value.forEach((group) => {
        group.forEach((token2) => {
          if (token2.options) {
            token2.options.forEach(add2);
          } else {
            add2(token2);
          }
        });
      });
      return k3;
    });
    const innerStyle = computed(() => inFullscreen.value ? props4.contentStyle : [
      {
        minHeight: props4.minHeight,
        height: props4.height,
        maxHeight: props4.maxHeight
      },
      props4.contentStyle
    ]);
    const classes = computed(
      () => `q-editor q-editor--${isViewingSource.value === true ? "source" : "default"}` + (props4.disable === true ? " disabled" : "") + (inFullscreen.value === true ? " fullscreen column" : "") + (props4.square === true ? " q-editor--square no-border-radius" : "") + (props4.flat === true ? " q-editor--flat" : "") + (props4.dense === true ? " q-editor--dense" : "") + (isDark.value === true ? " q-editor--dark q-dark" : "")
    );
    const innerClass = computed(() => [
      props4.contentClass,
      "q-editor__content",
      { col: inFullscreen.value, "overflow-auto": inFullscreen.value || props4.maxHeight }
    ]);
    const attributes = computed(() => props4.disable === true ? { "aria-disabled": "true" } : {});
    function onInput() {
      if (contentRef.value !== null) {
        const prop = `inner${isViewingSource.value === true ? "Text" : "HTML"}`;
        const val = contentRef.value[prop];
        if (val !== props4.modelValue) {
          lastEmit = val;
          emit("update:modelValue", val);
        }
      }
    }
    function onKeydown2(e3) {
      emit("keydown", e3);
      if (e3.ctrlKey !== true || shouldIgnoreKey(e3) === true) {
        refreshToolbar();
        return;
      }
      const key = e3.keyCode;
      const target2 = keys2.value[key];
      if (target2 !== void 0) {
        const { cmd, param } = target2;
        stopAndPrevent(e3);
        runCmd(cmd, param, false);
      }
    }
    function onClick(e3) {
      refreshToolbar();
      emit("click", e3);
    }
    function onBlur2(e3) {
      if (contentRef.value !== null) {
        const { scrollTop, scrollHeight } = contentRef.value;
        offsetBottom = scrollHeight - scrollTop;
      }
      eVm.caret.save();
      emit("blur", e3);
    }
    function onFocus(e3) {
      nextTick(() => {
        if (contentRef.value !== null && offsetBottom !== void 0) {
          contentRef.value.scrollTop = contentRef.value.scrollHeight - offsetBottom;
        }
      });
      emit("focus", e3);
    }
    function onFocusin(e3) {
      const root2 = rootRef.value;
      if (root2 !== null && root2.contains(e3.target) === true && (e3.relatedTarget === null || root2.contains(e3.relatedTarget) !== true)) {
        const prop = `inner${isViewingSource.value === true ? "Text" : "HTML"}`;
        eVm.caret.restorePosition(contentRef.value[prop].length);
        refreshToolbar();
      }
    }
    function onFocusout(e3) {
      const root2 = rootRef.value;
      if (root2 !== null && root2.contains(e3.target) === true && (e3.relatedTarget === null || root2.contains(e3.relatedTarget) !== true)) {
        eVm.caret.savePosition();
        refreshToolbar();
      }
    }
    function onPointerStart() {
      offsetBottom = void 0;
    }
    function onSelectionchange(e3) {
      eVm.caret.save();
    }
    function setContent(v, restorePosition) {
      if (contentRef.value !== null) {
        if (restorePosition === true) {
          eVm.caret.savePosition();
        }
        const prop = `inner${isViewingSource.value === true ? "Text" : "HTML"}`;
        contentRef.value[prop] = v;
        if (restorePosition === true) {
          eVm.caret.restorePosition(contentRef.value[prop].length);
          refreshToolbar();
        }
      }
    }
    function runCmd(cmd, param, update6 = true) {
      focus();
      eVm.caret.restore();
      eVm.caret.apply(cmd, param, () => {
        focus();
        eVm.caret.save();
        if (update6) {
          refreshToolbar();
        }
      });
    }
    function refreshToolbar() {
      setTimeout(() => {
        editLinkUrl.value = null;
        proxy.$forceUpdate();
      }, 1);
    }
    function focus() {
      addFocusFn(() => {
        var _a;
        (_a = contentRef.value) == null ? void 0 : _a.focus({ preventScroll: true });
      });
    }
    function getContentEl() {
      return contentRef.value;
    }
    onMounted(() => {
      eVm.caret = proxy.caret = new Caret2(contentRef.value, eVm);
      setContent(props4.modelValue);
      refreshToolbar();
      document.addEventListener("selectionchange", onSelectionchange);
    });
    onBeforeUnmount(() => {
      document.removeEventListener("selectionchange", onSelectionchange);
    });
    Object.assign(proxy, {
      runCmd,
      refreshToolbar,
      focus,
      getContentEl
    });
    return () => {
      let toolbars;
      if (hasToolbar.value) {
        const bars = [
          h("div", {
            key: "qedt_top",
            class: "q-editor__toolbar row no-wrap scroll-x" + toolbarBackgroundClass.value
          }, getToolbar(eVm))
        ];
        editLinkUrl.value !== null && bars.push(
          h("div", {
            key: "qedt_btm",
            class: "q-editor__toolbar row no-wrap items-center scroll-x" + toolbarBackgroundClass.value
          }, getLinkEditor(eVm))
        );
        toolbars = h("div", {
          key: "toolbar_ctainer",
          class: "q-editor__toolbars-container"
        }, bars);
      }
      return h("div", {
        ref: rootRef,
        class: classes.value,
        style: { height: inFullscreen.value === true ? "100%" : null },
        ...attributes.value,
        onFocusin,
        onFocusout
      }, [
        toolbars,
        h("div", {
          ref: contentRef,
          style: innerStyle.value,
          class: innerClass.value,
          contenteditable: editable.value,
          placeholder: props4.placeholder,
          ...{},
          ...splitAttrs.listeners.value,
          onInput,
          onKeydown: onKeydown2,
          onClick,
          onBlur: onBlur2,
          onFocus,
          // clean saved scroll position
          onMousedown: onPointerStart,
          onTouchstartPassive: onPointerStart
        })
      ]);
    };
  }
});
var QItemLabel_default = createComponent({
  name: "QItemLabel",
  props: {
    overline: Boolean,
    caption: Boolean,
    header: Boolean,
    lines: [Number, String]
  },
  setup(props4, { slots }) {
    const parsedLines = computed(() => parseInt(props4.lines, 10));
    const classes = computed(
      () => "q-item__label" + (props4.overline === true ? " q-item__label--overline text-overline" : "") + (props4.caption === true ? " q-item__label--caption text-caption" : "") + (props4.header === true ? " q-item__label--header" : "") + (parsedLines.value === 1 ? " ellipsis" : "")
    );
    const style2 = computed(() => {
      return props4.lines !== void 0 && parsedLines.value > 1 ? {
        overflow: "hidden",
        display: "-webkit-box",
        "-webkit-box-orient": "vertical",
        "-webkit-line-clamp": parsedLines.value
      } : null;
    });
    return () => h("div", {
      style: style2.value,
      class: classes.value
    }, hSlot(slots.default));
  }
});
var QSlideTransition_default = createComponent({
  name: "QSlideTransition",
  props: {
    appear: Boolean,
    duration: {
      type: Number,
      default: 300
    }
  },
  emits: ["show", "hide"],
  setup(props4, { slots, emit }) {
    let animating = false, doneFn, element;
    let timer2 = null, timerFallback = null, animListener, lastEvent;
    function cleanup() {
      doneFn == null ? void 0 : doneFn();
      doneFn = null;
      animating = false;
      if (timer2 !== null) {
        clearTimeout(timer2);
        timer2 = null;
      }
      if (timerFallback !== null) {
        clearTimeout(timerFallback);
        timerFallback = null;
      }
      element == null ? void 0 : element.removeEventListener("transitionend", animListener);
      animListener = null;
    }
    function begin(el, height2, done) {
      if (height2 !== void 0) {
        el.style.height = `${height2}px`;
      }
      el.style.transition = `height ${props4.duration}ms cubic-bezier(.25, .8, .50, 1)`;
      animating = true;
      doneFn = done;
    }
    function end(el, event) {
      el.style.overflowY = null;
      el.style.height = null;
      el.style.transition = null;
      cleanup();
      event !== lastEvent && emit(event);
    }
    function onEnter(el, done) {
      let pos = 0;
      element = el;
      if (animating === true) {
        cleanup();
        pos = el.offsetHeight === el.scrollHeight ? 0 : void 0;
      } else {
        lastEvent = "hide";
        el.style.overflowY = "hidden";
      }
      begin(el, pos, done);
      timer2 = setTimeout(() => {
        timer2 = null;
        el.style.height = `${el.scrollHeight}px`;
        animListener = (evt) => {
          timerFallback = null;
          if (Object(evt) !== evt || evt.target === el) {
            end(el, "show");
          }
        };
        el.addEventListener("transitionend", animListener);
        timerFallback = setTimeout(animListener, props4.duration * 1.1);
      }, 100);
    }
    function onLeave(el, done) {
      let pos;
      element = el;
      if (animating === true) {
        cleanup();
      } else {
        lastEvent = "show";
        el.style.overflowY = "hidden";
        pos = el.scrollHeight;
      }
      begin(el, pos, done);
      timer2 = setTimeout(() => {
        timer2 = null;
        el.style.height = 0;
        animListener = (evt) => {
          timerFallback = null;
          if (Object(evt) !== evt || evt.target === el) {
            end(el, "hide");
          }
        };
        el.addEventListener("transitionend", animListener);
        timerFallback = setTimeout(animListener, props4.duration * 1.1);
      }, 100);
    }
    onBeforeUnmount(() => {
      animating === true && cleanup();
    });
    return () => h(Transition, {
      css: false,
      appear: props4.appear,
      onEnter,
      onLeave
    }, slots.default);
  }
});
var insetMap = {
  true: "inset",
  item: "item-inset",
  "item-thumbnail": "item-thumbnail-inset"
};
var margins = {
  xs: 2,
  sm: 4,
  md: 8,
  lg: 16,
  xl: 24
};
var QSeparator_default = createComponent({
  name: "QSeparator",
  props: {
    ...useDarkProps,
    spaced: [Boolean, String],
    inset: [Boolean, String],
    vertical: Boolean,
    color: String,
    size: String
  },
  setup(props4) {
    const vm2 = getCurrentInstance();
    const isDark = use_dark_default(props4, vm2.proxy.$q);
    const orientation = computed(() => props4.vertical === true ? "vertical" : "horizontal");
    const orientClass = computed(() => ` q-separator--${orientation.value}`);
    const insetClass = computed(() => props4.inset !== false ? `${orientClass.value}-${insetMap[props4.inset]}` : "");
    const classes = computed(
      () => `q-separator${orientClass.value}${insetClass.value}` + (props4.color !== void 0 ? ` bg-${props4.color}` : "") + (isDark.value === true ? " q-separator--dark" : "")
    );
    const style2 = computed(() => {
      const acc = {};
      if (props4.size !== void 0) {
        acc[props4.vertical === true ? "width" : "height"] = props4.size;
      }
      if (props4.spaced !== false) {
        const size2 = props4.spaced === true ? `${margins.md}px` : props4.spaced in margins ? `${margins[props4.spaced]}px` : props4.spaced;
        const dir = props4.vertical === true ? ["Left", "Right"] : ["Top", "Bottom"];
        acc[`margin${dir[0]}`] = acc[`margin${dir[1]}`] = size2;
      }
      return acc;
    });
    return () => h("hr", {
      class: classes.value,
      style: style2.value,
      "aria-orientation": orientation.value
    });
  }
});
var itemGroups = shallowReactive({});
var LINK_PROPS = Object.keys(useRouterLinkProps);
createComponent({
  name: "QExpansionItem",
  props: {
    ...useRouterLinkProps,
    ...useModelToggleProps,
    ...useDarkProps,
    icon: String,
    label: String,
    labelLines: [Number, String],
    caption: String,
    captionLines: [Number, String],
    dense: Boolean,
    toggleAriaLabel: String,
    expandIcon: String,
    expandedIcon: String,
    expandIconClass: [Array, String, Object],
    duration: {},
    headerInsetLevel: Number,
    contentInsetLevel: Number,
    expandSeparator: Boolean,
    defaultOpened: Boolean,
    hideExpandIcon: Boolean,
    expandIconToggle: Boolean,
    switchToggleSide: Boolean,
    denseToggle: Boolean,
    group: String,
    popup: Boolean,
    headerStyle: [Array, String, Object],
    headerClass: [Array, String, Object]
  },
  emits: [
    ...useModelToggleEmits,
    "click",
    "afterShow",
    "afterHide"
  ],
  setup(props4, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const isDark = use_dark_default(props4, $q);
    const showing = ref$1(
      props4.modelValue !== null ? props4.modelValue : props4.defaultOpened
    );
    const blurTargetRef = ref$1(null);
    const targetUid = use_id_default();
    const { show, hide, toggle } = use_model_toggle_default({ showing });
    let uniqueId, exitGroup;
    const classes = computed(
      () => `q-expansion-item q-item-type q-expansion-item--${showing.value === true ? "expanded" : "collapsed"} q-expansion-item--${props4.popup === true ? "popup" : "standard"}`
    );
    const contentStyle = computed(() => {
      if (props4.contentInsetLevel === void 0) {
        return null;
      }
      const dir = $q.lang.rtl === true ? "Right" : "Left";
      return {
        ["padding" + dir]: props4.contentInsetLevel * 56 + "px"
      };
    });
    const hasLink = computed(
      () => props4.disable !== true && (props4.href !== void 0 || props4.to !== void 0 && props4.to !== null && props4.to !== "")
    );
    const linkProps = computed(() => {
      const acc = {};
      LINK_PROPS.forEach((key) => {
        acc[key] = props4[key];
      });
      return acc;
    });
    const isClickable = computed(
      () => hasLink.value === true || props4.expandIconToggle !== true
    );
    const expansionIcon = computed(() => props4.expandedIcon !== void 0 && showing.value === true ? props4.expandedIcon : props4.expandIcon || $q.iconSet.expansionItem[props4.denseToggle === true ? "denseIcon" : "icon"]);
    const activeToggleIcon = computed(
      () => props4.disable !== true && (hasLink.value === true || props4.expandIconToggle === true)
    );
    const headerSlotScope = computed(() => ({
      expanded: showing.value === true,
      detailsId: targetUid.value,
      toggle,
      show,
      hide
    }));
    const toggleAriaAttrs = computed(() => {
      const toggleAriaLabel = props4.toggleAriaLabel !== void 0 ? props4.toggleAriaLabel : $q.lang.label[showing.value === true ? "collapse" : "expand"](props4.label);
      return {
        role: "button",
        "aria-expanded": showing.value === true ? "true" : "false",
        "aria-controls": targetUid.value,
        "aria-label": toggleAriaLabel
      };
    });
    watch(() => props4.group, (name2) => {
      exitGroup == null ? void 0 : exitGroup();
      name2 !== void 0 && enterGroup();
    });
    function onHeaderClick(e3) {
      hasLink.value !== true && toggle(e3);
      emit("click", e3);
    }
    function toggleIconKeyboard(e3) {
      e3.keyCode === 13 && toggleIcon(e3, true);
    }
    function toggleIcon(e3, keyboard) {
      var _a;
      if (keyboard !== true && e3.qAvoidFocus !== true) {
        (_a = blurTargetRef.value) == null ? void 0 : _a.focus();
      }
      toggle(e3);
      stopAndPrevent(e3);
    }
    function onShow() {
      emit("afterShow");
    }
    function onHide() {
      emit("afterHide");
    }
    function enterGroup() {
      if (uniqueId === void 0) {
        uniqueId = uid_default();
      }
      if (showing.value === true) {
        itemGroups[props4.group] = uniqueId;
      }
      const show2 = watch(showing, (val) => {
        if (val === true) {
          itemGroups[props4.group] = uniqueId;
        } else if (itemGroups[props4.group] === uniqueId) {
          delete itemGroups[props4.group];
        }
      });
      const group = watch(
        () => itemGroups[props4.group],
        (val, oldVal) => {
          if (oldVal === uniqueId && val !== void 0 && val !== uniqueId) {
            hide();
          }
        }
      );
      exitGroup = () => {
        show2();
        group();
        if (itemGroups[props4.group] === uniqueId) {
          delete itemGroups[props4.group];
        }
        exitGroup = void 0;
      };
    }
    function getToggleIcon() {
      const data = {
        class: [
          `q-focusable relative-position cursor-pointer${props4.denseToggle === true && props4.switchToggleSide === true ? " items-end" : ""}`,
          props4.expandIconClass
        ],
        side: props4.switchToggleSide !== true,
        avatar: props4.switchToggleSide
      };
      const child = [
        h(QIcon_default, {
          class: "q-expansion-item__toggle-icon" + (props4.expandedIcon === void 0 && showing.value === true ? " q-expansion-item__toggle-icon--rotated" : ""),
          name: expansionIcon.value
        })
      ];
      if (activeToggleIcon.value === true) {
        Object.assign(data, {
          tabindex: 0,
          ...toggleAriaAttrs.value,
          onClick: toggleIcon,
          onKeyup: toggleIconKeyboard
        });
        child.unshift(
          h("div", {
            ref: blurTargetRef,
            class: "q-expansion-item__toggle-focus q-icon q-focus-helper q-focus-helper--rounded",
            tabindex: -1
          })
        );
      }
      return h(QItemSection_default, data, () => child);
    }
    function getHeaderChild() {
      let child;
      if (slots.header !== void 0) {
        child = [].concat(slots.header(headerSlotScope.value));
      } else {
        child = [
          h(QItemSection_default, () => [
            h(QItemLabel_default, { lines: props4.labelLines }, () => props4.label || ""),
            props4.caption ? h(QItemLabel_default, { lines: props4.captionLines, caption: true }, () => props4.caption) : null
          ])
        ];
        props4.icon && child[props4.switchToggleSide === true ? "push" : "unshift"](
          h(QItemSection_default, {
            side: props4.switchToggleSide === true,
            avatar: props4.switchToggleSide !== true
          }, () => h(QIcon_default, { name: props4.icon }))
        );
      }
      if (props4.disable !== true && props4.hideExpandIcon !== true) {
        child[props4.switchToggleSide === true ? "unshift" : "push"](
          getToggleIcon()
        );
      }
      return child;
    }
    function getHeader() {
      const data = {
        ref: "item",
        style: props4.headerStyle,
        class: props4.headerClass,
        dark: isDark.value,
        disable: props4.disable,
        dense: props4.dense,
        insetLevel: props4.headerInsetLevel
      };
      if (isClickable.value === true) {
        data.clickable = true;
        data.onClick = onHeaderClick;
        Object.assign(
          data,
          hasLink.value === true ? linkProps.value : toggleAriaAttrs.value
        );
      }
      return h(QItem_default, data, getHeaderChild);
    }
    function getTransitionChild() {
      return withDirectives(
        h("div", {
          key: "e-content",
          class: "q-expansion-item__content relative-position",
          style: contentStyle.value,
          id: targetUid.value
        }, hSlot(slots.default)),
        [[
          vShow,
          showing.value
        ]]
      );
    }
    function getContent() {
      const node = [
        getHeader(),
        h(QSlideTransition_default, {
          duration: props4.duration,
          onShow,
          onHide
        }, getTransitionChild)
      ];
      if (props4.expandSeparator === true) {
        node.push(
          h(QSeparator_default, {
            class: "q-expansion-item__border q-expansion-item__border--top absolute-top",
            dark: isDark.value
          }),
          h(QSeparator_default, {
            class: "q-expansion-item__border q-expansion-item__border--bottom absolute-bottom",
            dark: isDark.value
          })
        );
      }
      return node;
    }
    props4.group !== void 0 && enterGroup();
    onBeforeUnmount(() => {
      exitGroup == null ? void 0 : exitGroup();
    });
    return () => h("div", { class: classes.value }, [
      h("div", { class: "q-expansion-item__container relative-position" }, getContent())
    ]);
  }
});
var labelPositions = ["top", "right", "bottom", "left"];
var useFabProps = {
  type: {
    type: String,
    default: "a"
  },
  outline: Boolean,
  push: Boolean,
  flat: Boolean,
  unelevated: Boolean,
  color: String,
  textColor: String,
  glossy: Boolean,
  square: Boolean,
  padding: String,
  label: {
    type: [String, Number],
    default: ""
  },
  labelPosition: {
    type: String,
    default: "right",
    validator: (v) => labelPositions.includes(v)
  },
  externalLabel: Boolean,
  hideLabel: {
    type: Boolean
  },
  labelClass: [Array, String, Object],
  labelStyle: [Array, String, Object],
  disable: Boolean,
  tabindex: [Number, String]
};
function use_fab_default(props4, showing) {
  return {
    formClass: computed(
      () => `q-fab--form-${props4.square === true ? "square" : "rounded"}`
    ),
    stacked: computed(
      () => props4.externalLabel === false && ["top", "bottom"].includes(props4.labelPosition)
    ),
    labelProps: computed(() => {
      if (props4.externalLabel === true) {
        const hideLabel = props4.hideLabel === null ? showing.value === false : props4.hideLabel;
        return {
          action: "push",
          data: {
            class: [
              props4.labelClass,
              `q-fab__label q-tooltip--style q-fab__label--external q-fab__label--external-${props4.labelPosition}` + (hideLabel === true ? " q-fab__label--external-hidden" : "")
            ],
            style: props4.labelStyle
          }
        };
      }
      return {
        action: ["left", "top"].includes(props4.labelPosition) ? "unshift" : "push",
        data: {
          class: [
            props4.labelClass,
            `q-fab__label q-fab__label--internal q-fab__label--internal-${props4.labelPosition}` + (props4.hideLabel === true ? " q-fab__label--internal-hidden" : "")
          ],
          style: props4.labelStyle
        }
      };
    })
  };
}
var directions = ["up", "right", "down", "left"];
var alignValues4 = ["left", "center", "right"];
createComponent({
  name: "QFab",
  props: {
    ...useFabProps,
    ...useModelToggleProps,
    icon: String,
    activeIcon: String,
    hideIcon: Boolean,
    hideLabel: {
      ...useFabProps.hideLabel,
      default: null
    },
    direction: {
      type: String,
      default: "right",
      validator: (v) => directions.includes(v)
    },
    persistent: Boolean,
    verticalActionsAlign: {
      type: String,
      default: "center",
      validator: (v) => alignValues4.includes(v)
    }
  },
  emits: useModelToggleEmits,
  setup(props4, { slots }) {
    const triggerRef = ref$1(null);
    const showing = ref$1(props4.modelValue === true);
    const targetUid = use_id_default();
    const { proxy: { $q } } = getCurrentInstance();
    const { formClass, labelProps } = use_fab_default(props4, showing);
    const hideOnRouteChange = computed(() => props4.persistent !== true);
    const { hide, toggle } = use_model_toggle_default({
      showing,
      hideOnRouteChange
    });
    const slotScope = computed(() => ({ opened: showing.value }));
    const classes = computed(
      () => `q-fab z-fab row inline justify-center q-fab--align-${props4.verticalActionsAlign} ${formClass.value}` + (showing.value === true ? " q-fab--opened" : " q-fab--closed")
    );
    const actionClass = computed(
      () => `q-fab__actions flex no-wrap inline q-fab__actions--${props4.direction} q-fab__actions--${showing.value === true ? "opened" : "closed"}`
    );
    const actionAttrs = computed(() => {
      const attrs = {
        id: targetUid.value,
        role: "menu"
      };
      if (showing.value !== true) {
        attrs["aria-hidden"] = "true";
      }
      return attrs;
    });
    const iconHolderClass = computed(
      () => `q-fab__icon-holder  q-fab__icon-holder--${showing.value === true ? "opened" : "closed"}`
    );
    function getIcon(kebab, camel) {
      const slotFn = slots[kebab];
      const classes2 = `q-fab__${kebab} absolute-full`;
      return slotFn === void 0 ? h(QIcon_default, { class: classes2, name: props4[camel] || $q.iconSet.fab[camel] }) : h("div", { class: classes2 }, slotFn(slotScope.value));
    }
    function getTriggerContent() {
      const child = [];
      props4.hideIcon !== true && child.push(
        h("div", { class: iconHolderClass.value }, [
          getIcon("icon", "icon"),
          getIcon("active-icon", "activeIcon")
        ])
      );
      if (props4.label !== "" || slots.label !== void 0) {
        child[labelProps.value.action](
          h("div", labelProps.value.data, slots.label !== void 0 ? slots.label(slotScope.value) : [props4.label])
        );
      }
      return hMergeSlot(slots.tooltip, child);
    }
    provide(fabKey, {
      showing,
      onChildClick(evt) {
        var _a;
        hide(evt);
        if ((evt == null ? void 0 : evt.qAvoidFocus) !== true) {
          (_a = triggerRef.value) == null ? void 0 : _a.$el.focus();
        }
      }
    });
    return () => h("div", {
      class: classes.value
    }, [
      h(QBtn_default, {
        ref: triggerRef,
        class: formClass.value,
        ...props4,
        noWrap: true,
        stack: props4.stacked,
        align: void 0,
        icon: void 0,
        label: void 0,
        noCaps: true,
        fab: true,
        "aria-expanded": showing.value === true ? "true" : "false",
        "aria-haspopup": "true",
        "aria-controls": targetUid.value,
        onClick: toggle
      }, getTriggerContent),
      h("div", { class: actionClass.value, ...actionAttrs.value }, hSlot(slots.default))
    ]);
  }
});
var anchorMap = {
  start: "self-end",
  center: "self-center",
  end: "self-start"
};
var anchorValues = Object.keys(anchorMap);
createComponent({
  name: "QFabAction",
  props: {
    ...useFabProps,
    icon: {
      type: String,
      default: ""
    },
    anchor: {
      type: String,
      validator: (v) => anchorValues.includes(v)
    },
    to: [String, Object],
    replace: Boolean
  },
  emits: ["click"],
  setup(props4, { slots, emit }) {
    const $fab = inject(fabKey, () => ({
      showing: { value: true },
      onChildClick: noop
    }));
    const { formClass, labelProps } = use_fab_default(props4, $fab.showing);
    const classes = computed(() => {
      const align = anchorMap[props4.anchor];
      return formClass.value + (align !== void 0 ? ` ${align}` : "");
    });
    const isDisabled = computed(
      () => props4.disable === true || $fab.showing.value !== true
    );
    function click(e3) {
      $fab.onChildClick(e3);
      emit("click", e3);
    }
    function getContent() {
      const child = [];
      if (slots.icon !== void 0) {
        child.push(slots.icon());
      } else if (props4.icon !== "") {
        child.push(
          h(QIcon_default, { name: props4.icon })
        );
      }
      if (props4.label !== "" || slots.label !== void 0) {
        child[labelProps.value.action](
          h("div", labelProps.value.data, slots.label !== void 0 ? slots.label() : [props4.label])
        );
      }
      return hMergeSlot(slots.default, child);
    }
    const vm2 = getCurrentInstance();
    Object.assign(vm2.proxy, { click });
    return () => h(QBtn_default, {
      class: classes.value,
      ...props4,
      noWrap: true,
      stack: props4.stacked,
      icon: void 0,
      label: void 0,
      noCaps: true,
      fabMini: true,
      disable: isDisabled.value,
      onClick: click
    }, getContent);
  }
});
function use_form_child_default({ validate: validate2, resetValidation, requiresQForm }) {
  const $form = inject(formKey, false);
  if ($form !== false) {
    const { props: props4, proxy } = getCurrentInstance();
    Object.assign(proxy, { validate: validate2, resetValidation });
    watch(() => props4.disable, (val) => {
      if (val === true) {
        typeof resetValidation === "function" && resetValidation();
        $form.unbindComponent(proxy);
      } else {
        $form.bindComponent(proxy);
      }
    });
    onMounted(() => {
      props4.disable !== true && $form.bindComponent(proxy);
    });
    onBeforeUnmount(() => {
      props4.disable !== true && $form.unbindComponent(proxy);
    });
  } else if (requiresQForm === true) {
    console.error("Parent QForm not found on useFormChild()!");
  }
}
var lazyRulesValues = [true, false, "ondemand"];
var useValidateProps = {
  modelValue: {},
  error: {
    type: Boolean,
    default: null
  },
  errorMessage: String,
  noErrorIcon: Boolean,
  rules: Array,
  reactiveRules: Boolean,
  lazyRules: {
    type: [Boolean, String],
    default: false,
    // statement unneeded but avoids future vue implementation changes
    validator: (v) => lazyRulesValues.includes(v)
  }
};
function use_validate_default(focused, innerLoading) {
  const { props: props4, proxy } = getCurrentInstance();
  const innerError = ref$1(false);
  const innerErrorMessage = ref$1(null);
  const isDirtyModel = ref$1(false);
  use_form_child_default({ validate: validate2, resetValidation });
  let validateIndex = 0, unwatchRules;
  const hasRules = computed(
    () => props4.rules !== void 0 && props4.rules !== null && props4.rules.length !== 0
  );
  const canDebounceValidate = computed(() => props4.disable !== true && hasRules.value === true && innerLoading.value === false);
  const hasError = computed(
    () => props4.error === true || innerError.value === true
  );
  const errorMessage = computed(() => typeof props4.errorMessage === "string" && props4.errorMessage.length !== 0 ? props4.errorMessage : innerErrorMessage.value);
  watch(() => props4.modelValue, () => {
    isDirtyModel.value = true;
    if (canDebounceValidate.value === true && props4.lazyRules === false) {
      debouncedValidate();
    }
  });
  function onRulesChange() {
    if (props4.lazyRules !== "ondemand" && canDebounceValidate.value === true && isDirtyModel.value === true) {
      debouncedValidate();
    }
  }
  watch(() => props4.reactiveRules, (val) => {
    if (val === true) {
      if (unwatchRules === void 0) {
        unwatchRules = watch(() => props4.rules, onRulesChange, { immediate: true, deep: true });
      }
    } else if (unwatchRules !== void 0) {
      unwatchRules();
      unwatchRules = void 0;
    }
  }, { immediate: true });
  watch(() => props4.lazyRules, onRulesChange);
  watch(focused, (val) => {
    if (val === true) {
      isDirtyModel.value = true;
    } else if (canDebounceValidate.value === true && props4.lazyRules !== "ondemand") {
      debouncedValidate();
    }
  });
  function resetValidation() {
    validateIndex++;
    innerLoading.value = false;
    isDirtyModel.value = false;
    innerError.value = false;
    innerErrorMessage.value = null;
    debouncedValidate.cancel();
  }
  function validate2(val = props4.modelValue) {
    if (props4.disable === true || hasRules.value === false) {
      return true;
    }
    const index2 = ++validateIndex;
    const setDirty = innerLoading.value !== true ? () => {
      isDirtyModel.value = true;
    } : () => {
    };
    const update6 = (err, msg) => {
      err === true && setDirty();
      innerError.value = err;
      innerErrorMessage.value = msg || null;
      innerLoading.value = false;
    };
    const promises = [];
    for (let i3 = 0; i3 < props4.rules.length; i3++) {
      const rule = props4.rules[i3];
      let res;
      if (typeof rule === "function") {
        res = rule(val, testPattern);
      } else if (typeof rule === "string" && testPattern[rule] !== void 0) {
        res = testPattern[rule](val);
      }
      if (res === false || typeof res === "string") {
        update6(true, res);
        return false;
      } else if (res !== true && res !== void 0) {
        promises.push(res);
      }
    }
    if (promises.length === 0) {
      update6(false);
      return true;
    }
    innerLoading.value = true;
    return Promise.all(promises).then(
      (res) => {
        if (res === void 0 || Array.isArray(res) === false || res.length === 0) {
          index2 === validateIndex && update6(false);
          return true;
        }
        const msg = res.find((r) => r === false || typeof r === "string");
        index2 === validateIndex && update6(msg !== void 0, msg);
        return msg === void 0;
      },
      (e3) => {
        if (index2 === validateIndex) {
          console.error(e3);
          update6(true);
        }
        return false;
      }
    );
  }
  const debouncedValidate = debounce_default(validate2, 0);
  onBeforeUnmount(() => {
    unwatchRules == null ? void 0 : unwatchRules();
    debouncedValidate.cancel();
  });
  Object.assign(proxy, { resetValidation, validate: validate2 });
  injectProp(proxy, "hasError", () => hasError.value);
  return {
    isDirtyModel,
    hasRules,
    hasError,
    errorMessage,
    validate: validate2,
    resetValidation
  };
}
function fieldValueIsFilled(val) {
  return val !== void 0 && val !== null && ("" + val).length !== 0;
}
var useNonInputFieldProps = {
  ...useDarkProps,
  ...useValidateProps,
  label: String,
  stackLabel: Boolean,
  hint: String,
  hideHint: Boolean,
  prefix: String,
  suffix: String,
  labelColor: String,
  color: String,
  bgColor: String,
  filled: Boolean,
  outlined: Boolean,
  borderless: Boolean,
  standout: [Boolean, String],
  square: Boolean,
  loading: Boolean,
  labelSlot: Boolean,
  bottomSlots: Boolean,
  hideBottomSpace: Boolean,
  rounded: Boolean,
  dense: Boolean,
  itemAligned: Boolean,
  counter: Boolean,
  clearable: Boolean,
  clearIcon: String,
  disable: Boolean,
  readonly: Boolean,
  autofocus: Boolean,
  for: String
};
var useFieldProps = {
  ...useNonInputFieldProps,
  maxlength: [Number, String]
};
var useFieldEmits = ["update:modelValue", "clear", "focus", "blur"];
function useFieldState({ requiredForAttr = true, tagProp, changeEvent = false } = {}) {
  const { props: props4, proxy } = getCurrentInstance();
  const isDark = use_dark_default(props4, proxy.$q);
  const targetUid = use_id_default({
    required: requiredForAttr,
    getValue: () => props4.for
  });
  return {
    requiredForAttr,
    changeEvent,
    tag: tagProp === true ? computed(() => props4.tag) : { value: "label" },
    isDark,
    editable: computed(
      () => props4.disable !== true && props4.readonly !== true
    ),
    innerLoading: ref$1(false),
    focused: ref$1(false),
    hasPopupOpen: false,
    splitAttrs: use_split_attrs_default(),
    targetUid,
    rootRef: ref$1(null),
    targetRef: ref$1(null),
    controlRef: ref$1(null)
    /**
         * user supplied additionals:
    
         * innerValue - computed
         * floatingLabel - computed
         * inputRef - computed
    
         * fieldClass - computed
         * hasShadow - computed
    
         * controlEvents - Object with fn(e)
    
         * getControl - fn
         * getInnerAppend - fn
         * getControlChild - fn
         * getShadowControl - fn
         * showPopup - fn
         */
  };
}
function use_field_default(state2) {
  const { props: props4, emit, slots, attrs, proxy } = getCurrentInstance();
  const { $q } = proxy;
  let focusoutTimer = null;
  if (state2.hasValue === void 0) {
    state2.hasValue = computed(() => fieldValueIsFilled(props4.modelValue));
  }
  if (state2.emitValue === void 0) {
    state2.emitValue = (value2) => {
      emit("update:modelValue", value2);
    };
  }
  if (state2.controlEvents === void 0) {
    state2.controlEvents = {
      onFocusin: onControlFocusin,
      onFocusout: onControlFocusout
    };
  }
  Object.assign(state2, {
    clearValue,
    onControlFocusin,
    onControlFocusout,
    focus
  });
  if (state2.computedCounter === void 0) {
    state2.computedCounter = computed(() => {
      if (props4.counter !== false) {
        const len = typeof props4.modelValue === "string" || typeof props4.modelValue === "number" ? ("" + props4.modelValue).length : Array.isArray(props4.modelValue) === true ? props4.modelValue.length : 0;
        const max2 = props4.maxlength !== void 0 ? props4.maxlength : props4.maxValues;
        return len + (max2 !== void 0 ? " / " + max2 : "");
      }
    });
  }
  const {
    isDirtyModel,
    hasRules,
    hasError,
    errorMessage,
    resetValidation
  } = use_validate_default(state2.focused, state2.innerLoading);
  const floatingLabel = state2.floatingLabel !== void 0 ? computed(() => props4.stackLabel === true || state2.focused.value === true || state2.floatingLabel.value === true) : computed(() => props4.stackLabel === true || state2.focused.value === true || state2.hasValue.value === true);
  const shouldRenderBottom = computed(
    () => props4.bottomSlots === true || props4.hint !== void 0 || hasRules.value === true || props4.counter === true || props4.error !== null
  );
  const styleType = computed(() => {
    if (props4.filled === true) {
      return "filled";
    }
    if (props4.outlined === true) {
      return "outlined";
    }
    if (props4.borderless === true) {
      return "borderless";
    }
    if (props4.standout) {
      return "standout";
    }
    return "standard";
  });
  const classes = computed(
    () => `q-field row no-wrap items-start q-field--${styleType.value}` + (state2.fieldClass !== void 0 ? ` ${state2.fieldClass.value}` : "") + (props4.rounded === true ? " q-field--rounded" : "") + (props4.square === true ? " q-field--square" : "") + (floatingLabel.value === true ? " q-field--float" : "") + (hasLabel.value === true ? " q-field--labeled" : "") + (props4.dense === true ? " q-field--dense" : "") + (props4.itemAligned === true ? " q-field--item-aligned q-item-type" : "") + (state2.isDark.value === true ? " q-field--dark" : "") + (state2.getControl === void 0 ? " q-field--auto-height" : "") + (state2.focused.value === true ? " q-field--focused" : "") + (hasError.value === true ? " q-field--error" : "") + (hasError.value === true || state2.focused.value === true ? " q-field--highlighted" : "") + (props4.hideBottomSpace !== true && shouldRenderBottom.value === true ? " q-field--with-bottom" : "") + (props4.disable === true ? " q-field--disabled" : props4.readonly === true ? " q-field--readonly" : "")
  );
  const contentClass = computed(
    () => "q-field__control relative-position row no-wrap" + (props4.bgColor !== void 0 ? ` bg-${props4.bgColor}` : "") + (hasError.value === true ? " text-negative" : typeof props4.standout === "string" && props4.standout.length !== 0 && state2.focused.value === true ? ` ${props4.standout}` : props4.color !== void 0 ? ` text-${props4.color}` : "")
  );
  const hasLabel = computed(
    () => props4.labelSlot === true || props4.label !== void 0
  );
  const labelClass = computed(
    () => "q-field__label no-pointer-events absolute ellipsis" + (props4.labelColor !== void 0 && hasError.value !== true ? ` text-${props4.labelColor}` : "")
  );
  const controlSlotScope = computed(() => ({
    id: state2.targetUid.value,
    editable: state2.editable.value,
    focused: state2.focused.value,
    floatingLabel: floatingLabel.value,
    modelValue: props4.modelValue,
    emitValue: state2.emitValue
  }));
  const attributes = computed(() => {
    const acc = {};
    if (state2.targetUid.value) {
      acc.for = state2.targetUid.value;
    }
    if (props4.disable === true) {
      acc["aria-disabled"] = "true";
    }
    return acc;
  });
  function focusHandler() {
    var _a;
    const el = document.activeElement;
    let target2 = (_a = state2.targetRef) == null ? void 0 : _a.value;
    if (target2 && (el === null || el.id !== state2.targetUid.value)) {
      target2.hasAttribute("tabindex") === true || (target2 = target2.querySelector("[tabindex]"));
      if (target2 !== el) {
        target2 == null ? void 0 : target2.focus({ preventScroll: true });
      }
    }
  }
  function focus() {
    addFocusFn(focusHandler);
  }
  function blur() {
    removeFocusFn(focusHandler);
    const el = document.activeElement;
    if (el !== null && state2.rootRef.value.contains(el)) {
      el.blur();
    }
  }
  function onControlFocusin(e3) {
    if (focusoutTimer !== null) {
      clearTimeout(focusoutTimer);
      focusoutTimer = null;
    }
    if (state2.editable.value === true && state2.focused.value === false) {
      state2.focused.value = true;
      emit("focus", e3);
    }
  }
  function onControlFocusout(e3, then) {
    focusoutTimer !== null && clearTimeout(focusoutTimer);
    focusoutTimer = setTimeout(() => {
      focusoutTimer = null;
      if (document.hasFocus() === true && (state2.hasPopupOpen === true || state2.controlRef === void 0 || state2.controlRef.value === null || state2.controlRef.value.contains(document.activeElement) !== false)) return;
      if (state2.focused.value === true) {
        state2.focused.value = false;
        emit("blur", e3);
      }
      then == null ? void 0 : then();
    });
  }
  function clearValue(e3) {
    var _a;
    stopAndPrevent(e3);
    if ($q.platform.is.mobile !== true) {
      const el = ((_a = state2.targetRef) == null ? void 0 : _a.value) || state2.rootRef.value;
      el.focus();
    } else if (state2.rootRef.value.contains(document.activeElement) === true) {
      document.activeElement.blur();
    }
    if (props4.type === "file") {
      state2.inputRef.value.value = null;
    }
    emit("update:modelValue", null);
    state2.changeEvent === true && emit("change", null);
    emit("clear", props4.modelValue);
    nextTick(() => {
      const isDirty = isDirtyModel.value;
      resetValidation();
      isDirtyModel.value = isDirty;
    });
  }
  function onClearableKeyup(evt) {
    [13, 32].includes(evt.keyCode) && clearValue(evt);
  }
  function getContent() {
    const node = [];
    slots.prepend !== void 0 && node.push(
      h("div", {
        class: "q-field__prepend q-field__marginal row no-wrap items-center",
        key: "prepend",
        onClick: prevent
      }, slots.prepend())
    );
    node.push(
      h("div", {
        class: "q-field__control-container col relative-position row no-wrap q-anchor--skip"
      }, getControlContainer())
    );
    hasError.value === true && props4.noErrorIcon === false && node.push(
      getInnerAppendNode("error", [
        h(QIcon_default, { name: $q.iconSet.field.error, color: "negative" })
      ])
    );
    if (props4.loading === true || state2.innerLoading.value === true) {
      node.push(
        getInnerAppendNode(
          "inner-loading-append",
          slots.loading !== void 0 ? slots.loading() : [h(QSpinner_default, { color: props4.color })]
        )
      );
    } else if (props4.clearable === true && state2.hasValue.value === true && state2.editable.value === true) {
      node.push(
        getInnerAppendNode("inner-clearable-append", [
          h(QIcon_default, {
            class: "q-field__focusable-action",
            name: props4.clearIcon || $q.iconSet.field.clear,
            tabindex: 0,
            role: "button",
            "aria-hidden": "false",
            "aria-label": $q.lang.label.clear,
            onKeyup: onClearableKeyup,
            onClick: clearValue
          })
        ])
      );
    }
    slots.append !== void 0 && node.push(
      h("div", {
        class: "q-field__append q-field__marginal row no-wrap items-center",
        key: "append",
        onClick: prevent
      }, slots.append())
    );
    state2.getInnerAppend !== void 0 && node.push(
      getInnerAppendNode("inner-append", state2.getInnerAppend())
    );
    state2.getControlChild !== void 0 && node.push(
      state2.getControlChild()
    );
    return node;
  }
  function getControlContainer() {
    const node = [];
    props4.prefix !== void 0 && props4.prefix !== null && node.push(
      h("div", {
        class: "q-field__prefix no-pointer-events row items-center"
      }, props4.prefix)
    );
    if (state2.getShadowControl !== void 0 && state2.hasShadow.value === true) {
      node.push(
        state2.getShadowControl()
      );
    }
    if (state2.getControl !== void 0) {
      node.push(state2.getControl());
    } else if (slots.rawControl !== void 0) {
      node.push(slots.rawControl());
    } else if (slots.control !== void 0) {
      node.push(
        h("div", {
          ref: state2.targetRef,
          class: "q-field__native row",
          tabindex: -1,
          ...state2.splitAttrs.attributes.value,
          "data-autofocus": props4.autofocus === true || void 0
        }, slots.control(controlSlotScope.value))
      );
    }
    hasLabel.value === true && node.push(
      h("div", {
        class: labelClass.value
      }, hSlot(slots.label, props4.label))
    );
    props4.suffix !== void 0 && props4.suffix !== null && node.push(
      h("div", {
        class: "q-field__suffix no-pointer-events row items-center"
      }, props4.suffix)
    );
    return node.concat(hSlot(slots.default));
  }
  function getBottom() {
    let msg, key;
    if (hasError.value === true) {
      if (errorMessage.value !== null) {
        msg = [h("div", { role: "alert" }, errorMessage.value)];
        key = `q--slot-error-${errorMessage.value}`;
      } else {
        msg = hSlot(slots.error);
        key = "q--slot-error";
      }
    } else if (props4.hideHint !== true || state2.focused.value === true) {
      if (props4.hint !== void 0) {
        msg = [h("div", props4.hint)];
        key = `q--slot-hint-${props4.hint}`;
      } else {
        msg = hSlot(slots.hint);
        key = "q--slot-hint";
      }
    }
    const hasCounter = props4.counter === true || slots.counter !== void 0;
    if (props4.hideBottomSpace === true && hasCounter === false && msg === void 0) return;
    const main = h("div", {
      key,
      class: "q-field__messages col"
    }, msg);
    return h("div", {
      class: "q-field__bottom row items-start q-field__bottom--" + (props4.hideBottomSpace !== true ? "animated" : "stale"),
      onClick: prevent
    }, [
      props4.hideBottomSpace === true ? main : h(Transition, { name: "q-transition--field-message" }, () => main),
      hasCounter === true ? h("div", {
        class: "q-field__counter"
      }, slots.counter !== void 0 ? slots.counter() : state2.computedCounter.value) : null
    ]);
  }
  function getInnerAppendNode(key, content) {
    return content === null ? null : h("div", {
      key,
      class: "q-field__append q-field__marginal row no-wrap items-center q-anchor--skip"
    }, content);
  }
  let shouldActivate = false;
  onDeactivated(() => {
    shouldActivate = true;
  });
  onActivated(() => {
    shouldActivate === true && props4.autofocus === true && proxy.focus();
  });
  props4.autofocus === true && onMounted(() => {
    proxy.focus();
  });
  onBeforeUnmount(() => {
    focusoutTimer !== null && clearTimeout(focusoutTimer);
  });
  Object.assign(proxy, { focus, blur });
  return function renderField() {
    const labelAttrs = state2.getControl === void 0 && slots.control === void 0 ? {
      ...state2.splitAttrs.attributes.value,
      "data-autofocus": props4.autofocus === true || void 0,
      ...attributes.value
    } : attributes.value;
    return h(state2.tag.value, {
      ref: state2.rootRef,
      class: [
        classes.value,
        attrs.class
      ],
      style: attrs.style,
      ...labelAttrs
    }, [
      slots.before !== void 0 ? h("div", {
        class: "q-field__before q-field__marginal row no-wrap items-center",
        onClick: prevent
      }, slots.before()) : null,
      h("div", {
        class: "q-field__inner relative-position col self-stretch"
      }, [
        h("div", {
          ref: state2.controlRef,
          class: contentClass.value,
          tabindex: -1,
          ...state2.controlEvents
        }, getContent()),
        shouldRenderBottom.value === true ? getBottom() : null
      ]),
      slots.after !== void 0 ? h("div", {
        class: "q-field__after q-field__marginal row no-wrap items-center",
        onClick: prevent
      }, slots.after()) : null
    ]);
  };
}
var QField_default = createComponent({
  name: "QField",
  inheritAttrs: false,
  props: {
    ...useFieldProps,
    tag: {
      type: String,
      default: "label"
    }
  },
  emits: useFieldEmits,
  setup() {
    return use_field_default(
      useFieldState({ tagProp: true })
    );
  }
});
function filterFiles(files, rejectedFiles, failedPropValidation, filterFn) {
  const acceptedFiles = [];
  files.forEach((file) => {
    if (filterFn(file) === true) {
      acceptedFiles.push(file);
    } else {
      rejectedFiles.push({ failedPropValidation, file });
    }
  });
  return acceptedFiles;
}
function stopAndPreventDrag(e3) {
  if (e3 == null ? void 0 : e3.dataTransfer) {
    e3.dataTransfer.dropEffect = "copy";
  }
  stopAndPrevent(e3);
}
var useFileProps = {
  multiple: Boolean,
  accept: String,
  capture: String,
  maxFileSize: [Number, String],
  maxTotalSize: [Number, String],
  maxFiles: [Number, String],
  filter: Function
};
var useFileEmits = ["rejected"];
function use_file_default({
  editable,
  dnd,
  getFileInput,
  addFilesToQueue
}) {
  const { props: props4, emit, proxy } = getCurrentInstance();
  const dndRef = ref$1(null);
  const extensions = computed(() => props4.accept !== void 0 ? props4.accept.split(",").map((ext) => {
    ext = ext.trim();
    if (ext === "*") {
      return "*/";
    } else if (ext.endsWith("/*")) {
      ext = ext.slice(0, ext.length - 1);
    }
    return ext.toUpperCase();
  }) : null);
  const maxFilesNumber = computed(() => parseInt(props4.maxFiles, 10));
  const maxTotalSizeNumber = computed(() => parseInt(props4.maxTotalSize, 10));
  function pickFiles(e3) {
    var _a;
    if (editable.value) {
      if (e3 !== Object(e3)) {
        e3 = { target: null };
      }
      if (((_a = e3.target) == null ? void 0 : _a.matches('input[type="file"]')) === true) {
        e3.clientX === 0 && e3.clientY === 0 && stop(e3);
      } else {
        const input = getFileInput();
        if (input !== e3.target) input == null ? void 0 : input.click(e3);
      }
    }
  }
  function addFiles(files) {
    if (editable.value && files) {
      addFilesToQueue(null, files);
    }
  }
  function processFiles(e3, filesToProcess, currentFileList, append) {
    let files = Array.from(filesToProcess || e3.target.files);
    const rejectedFiles = [];
    const done = () => {
      if (rejectedFiles.length !== 0) {
        emit("rejected", rejectedFiles);
      }
    };
    if (props4.accept !== void 0 && extensions.value.indexOf("*/") === -1) {
      files = filterFiles(files, rejectedFiles, "accept", (file) => {
        return extensions.value.some((ext) => file.type.toUpperCase().startsWith(ext) || file.name.toUpperCase().endsWith(ext));
      });
      if (files.length === 0) {
        return done();
      }
    }
    if (props4.maxFileSize !== void 0) {
      const maxFileSize = parseInt(props4.maxFileSize, 10);
      files = filterFiles(files, rejectedFiles, "max-file-size", (file) => {
        return file.size <= maxFileSize;
      });
      if (files.length === 0) {
        return done();
      }
    }
    if (props4.multiple !== true && files.length !== 0) {
      files = [files[0]];
    }
    files.forEach((file) => {
      file.__key = file.webkitRelativePath + file.lastModified + file.name + file.size;
    });
    if (append === true) {
      const filenameMap = currentFileList.map((entry) => entry.__key);
      files = filterFiles(files, rejectedFiles, "duplicate", (file) => {
        return filenameMap.includes(file.__key) === false;
      });
    }
    if (files.length === 0) {
      return done();
    }
    if (props4.maxTotalSize !== void 0) {
      let size2 = append === true ? currentFileList.reduce((total, file) => total + file.size, 0) : 0;
      files = filterFiles(files, rejectedFiles, "max-total-size", (file) => {
        size2 += file.size;
        return size2 <= maxTotalSizeNumber.value;
      });
      if (files.length === 0) {
        return done();
      }
    }
    if (typeof props4.filter === "function") {
      const filteredFiles = props4.filter(files);
      files = filterFiles(files, rejectedFiles, "filter", (file) => {
        return filteredFiles.includes(file);
      });
    }
    if (props4.maxFiles !== void 0) {
      let filesNumber = append === true ? currentFileList.length : 0;
      files = filterFiles(files, rejectedFiles, "max-files", () => {
        filesNumber++;
        return filesNumber <= maxFilesNumber.value;
      });
      if (files.length === 0) {
        return done();
      }
    }
    done();
    if (files.length !== 0) {
      return files;
    }
  }
  function onDragover(e3) {
    stopAndPreventDrag(e3);
    dnd.value !== true && (dnd.value = true);
  }
  function onDragleave(e3) {
    stopAndPrevent(e3);
    const gone = e3.relatedTarget !== null || client.is.safari !== true ? e3.relatedTarget !== dndRef.value : document.elementsFromPoint(e3.clientX, e3.clientY).includes(dndRef.value) === false;
    gone === true && (dnd.value = false);
  }
  function onDrop(e3) {
    stopAndPreventDrag(e3);
    const files = e3.dataTransfer.files;
    if (files.length !== 0) {
      addFilesToQueue(null, files);
    }
    dnd.value = false;
  }
  function getDndNode(type2) {
    if (dnd.value === true) {
      return h("div", {
        ref: dndRef,
        class: `q-${type2}__dnd absolute-full`,
        onDragenter: stopAndPreventDrag,
        onDragover: stopAndPreventDrag,
        onDragleave,
        onDrop
      });
    }
  }
  Object.assign(proxy, { pickFiles, addFiles });
  return {
    pickFiles,
    addFiles,
    onDragover,
    onDragleave,
    processFiles,
    getDndNode,
    maxFilesNumber,
    maxTotalSizeNumber
  };
}
function use_file_dom_props_default(props4, typeGuard) {
  function getFormDomProps() {
    const model = props4.modelValue;
    try {
      const dt2 = "DataTransfer" in window ? new DataTransfer() : "ClipboardEvent" in window ? new ClipboardEvent("").clipboardData : void 0;
      if (Object(model) === model) {
        ("length" in model ? Array.from(model) : [model]).forEach((file) => {
          dt2.items.add(file);
        });
      }
      return {
        files: dt2.files
      };
    } catch (e3) {
      return {
        files: void 0
      };
    }
  }
  return typeGuard === true ? computed(() => {
    if (props4.type !== "file") return;
    return getFormDomProps();
  }) : computed(getFormDomProps);
}
createComponent({
  name: "QFile",
  inheritAttrs: false,
  props: {
    ...useNonInputFieldProps,
    ...useFormProps,
    ...useFileProps,
    /* SSR does not know about File & FileList */
    modelValue: [File, FileList, Array],
    append: Boolean,
    useChips: Boolean,
    displayValue: [String, Number],
    tabindex: {
      type: [String, Number],
      default: 0
    },
    counterLabel: Function,
    inputClass: [Array, String, Object],
    inputStyle: [Array, String, Object]
  },
  emits: [
    ...useFieldEmits,
    ...useFileEmits
  ],
  setup(props4, { slots, emit, attrs }) {
    const { proxy } = getCurrentInstance();
    const state2 = useFieldState();
    const inputRef = ref$1(null);
    const dnd = ref$1(false);
    const nameProp = useFormInputNameAttr(props4);
    const {
      pickFiles,
      onDragover,
      onDragleave,
      processFiles,
      getDndNode
    } = use_file_default({ editable: state2.editable, dnd, getFileInput, addFilesToQueue });
    const formDomProps = use_file_dom_props_default(props4);
    const innerValue = computed(() => Object(props4.modelValue) === props4.modelValue ? "length" in props4.modelValue ? Array.from(props4.modelValue) : [props4.modelValue] : []);
    const hasValue = computed(() => fieldValueIsFilled(innerValue.value));
    const selectedString = computed(
      () => innerValue.value.map((file) => file.name).join(", ")
    );
    const totalSize = computed(
      () => humanStorageSize(
        innerValue.value.reduce((acc, file) => acc + file.size, 0)
      )
    );
    const counterProps = computed(() => ({
      totalSize: totalSize.value,
      filesNumber: innerValue.value.length,
      maxFiles: props4.maxFiles
    }));
    const inputAttrs = computed(() => ({
      tabindex: -1,
      type: "file",
      title: "",
      // try to remove default tooltip,
      accept: props4.accept,
      capture: props4.capture,
      name: nameProp.value,
      ...attrs,
      id: state2.targetUid.value,
      disabled: state2.editable.value !== true
    }));
    const fieldClass = computed(
      () => "q-file q-field--auto-height" + (dnd.value === true ? " q-file--dnd" : "")
    );
    const isAppending = computed(
      () => props4.multiple === true && props4.append === true
    );
    function removeAtIndex(index2) {
      const files = innerValue.value.slice();
      files.splice(index2, 1);
      emitValue(files);
    }
    function removeFile(file) {
      const index2 = innerValue.value.indexOf(file);
      if (index2 !== -1) {
        removeAtIndex(index2);
      }
    }
    function emitValue(files) {
      emit("update:modelValue", props4.multiple === true ? files : files[0]);
    }
    function onKeydown2(e3) {
      e3.keyCode === 13 && prevent(e3);
    }
    function onKeyup2(e3) {
      if (e3.keyCode === 13 || e3.keyCode === 32) {
        pickFiles(e3);
      }
    }
    function getFileInput() {
      return inputRef.value;
    }
    function addFilesToQueue(e3, fileList) {
      const files = processFiles(e3, fileList, innerValue.value, isAppending.value);
      const fileInput = getFileInput();
      if (fileInput !== void 0 && fileInput !== null) {
        fileInput.value = "";
      }
      if (files === void 0) return;
      if (props4.multiple === true ? props4.modelValue && files.every((f) => innerValue.value.includes(f)) : props4.modelValue === files[0]) return;
      emitValue(
        isAppending.value === true ? innerValue.value.concat(files) : files
      );
    }
    function getFiller() {
      return [
        h("input", {
          class: [props4.inputClass, "q-file__filler"],
          style: props4.inputStyle
        })
      ];
    }
    function getSelection2() {
      if (slots.file !== void 0) {
        return innerValue.value.length === 0 ? getFiller() : innerValue.value.map(
          (file, index2) => slots.file({ index: index2, file, ref: this })
        );
      }
      if (slots.selected !== void 0) {
        return innerValue.value.length === 0 ? getFiller() : slots.selected({ files: innerValue.value, ref: this });
      }
      if (props4.useChips === true) {
        return innerValue.value.length === 0 ? getFiller() : innerValue.value.map((file, i3) => h(QChip_default, {
          key: "file-" + i3,
          removable: state2.editable.value,
          dense: true,
          textColor: props4.color,
          tabindex: props4.tabindex,
          onRemove: () => {
            removeAtIndex(i3);
          }
        }, () => h("span", {
          class: "ellipsis",
          textContent: file.name
        })));
      }
      const textContent = props4.displayValue !== void 0 ? props4.displayValue : selectedString.value;
      return textContent.length !== 0 ? [
        h("div", {
          class: props4.inputClass,
          style: props4.inputStyle,
          textContent
        })
      ] : getFiller();
    }
    function getInput() {
      const data = {
        ref: inputRef,
        ...inputAttrs.value,
        ...formDomProps.value,
        class: "q-field__input fit absolute-full cursor-pointer",
        onChange: addFilesToQueue
      };
      if (props4.multiple === true) {
        data.multiple = true;
      }
      return h("input", data);
    }
    Object.assign(state2, {
      fieldClass,
      emitValue,
      hasValue,
      inputRef,
      innerValue,
      floatingLabel: computed(
        () => hasValue.value === true || fieldValueIsFilled(props4.displayValue)
      ),
      computedCounter: computed(() => {
        if (props4.counterLabel !== void 0) {
          return props4.counterLabel(counterProps.value);
        }
        const max2 = props4.maxFiles;
        return `${innerValue.value.length}${max2 !== void 0 ? " / " + max2 : ""} (${totalSize.value})`;
      }),
      getControlChild: () => getDndNode("file"),
      getControl: () => {
        const data = {
          ref: state2.targetRef,
          class: "q-field__native row items-center cursor-pointer",
          tabindex: props4.tabindex
        };
        if (state2.editable.value === true) {
          Object.assign(data, { onDragover, onDragleave, onKeydown: onKeydown2, onKeyup: onKeyup2 });
        }
        return h("div", data, [getInput()].concat(getSelection2()));
      }
    });
    Object.assign(proxy, {
      removeAtIndex,
      removeFile,
      getNativeElement: () => inputRef.value
      // deprecated
    });
    injectProp(proxy, "nativeEl", () => inputRef.value);
    return use_field_default(state2);
  }
});
createComponent({
  name: "QFooter",
  props: {
    modelValue: {
      type: Boolean,
      default: true
    },
    reveal: Boolean,
    bordered: Boolean,
    elevated: Boolean,
    heightHint: {
      type: [String, Number],
      default: 50
    }
  },
  emits: ["reveal", "focusin"],
  setup(props4, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const $layout = inject(layoutKey, emptyRenderFn);
    if ($layout === emptyRenderFn) {
      console.error("QFooter needs to be child of QLayout");
      return emptyRenderFn;
    }
    const size2 = ref$1(parseInt(props4.heightHint, 10));
    const revealed = ref$1(true);
    const windowHeight = ref$1(
      isRuntimeSsrPreHydration.value === true || $layout.isContainer.value === true ? 0 : window.innerHeight
    );
    const fixed = computed(
      () => props4.reveal === true || $layout.view.value.indexOf("F") !== -1 || $q.platform.is.ios && $layout.isContainer.value === true
    );
    const containerHeight = computed(() => $layout.isContainer.value === true ? $layout.containerHeight.value : windowHeight.value);
    const offset2 = computed(() => {
      if (props4.modelValue !== true) {
        return 0;
      }
      if (fixed.value === true) {
        return revealed.value === true ? size2.value : 0;
      }
      const offset3 = $layout.scroll.value.position + containerHeight.value + size2.value - $layout.height.value;
      return offset3 > 0 ? offset3 : 0;
    });
    const hidden = computed(
      () => props4.modelValue !== true || fixed.value === true && revealed.value !== true
    );
    const revealOnFocus = computed(
      () => props4.modelValue === true && hidden.value === true && props4.reveal === true
    );
    const classes = computed(
      () => "q-footer q-layout__section--marginal " + (fixed.value === true ? "fixed" : "absolute") + "-bottom" + (props4.bordered === true ? " q-footer--bordered" : "") + (hidden.value === true ? " q-footer--hidden" : "") + (props4.modelValue !== true ? " q-layout--prevent-focus" + (fixed.value !== true ? " hidden" : "") : "")
    );
    const style2 = computed(() => {
      const view = $layout.rows.value.bottom, css2 = {};
      if (view[0] === "l" && $layout.left.space === true) {
        css2[$q.lang.rtl === true ? "right" : "left"] = `${$layout.left.size}px`;
      }
      if (view[2] === "r" && $layout.right.space === true) {
        css2[$q.lang.rtl === true ? "left" : "right"] = `${$layout.right.size}px`;
      }
      return css2;
    });
    function updateLayout(prop, val) {
      $layout.update("footer", prop, val);
    }
    function updateLocal(prop, val) {
      if (prop.value !== val) {
        prop.value = val;
      }
    }
    function onResize({ height: height2 }) {
      updateLocal(size2, height2);
      updateLayout("size", height2);
    }
    function updateRevealed() {
      if (props4.reveal !== true) return;
      const { direction, position: position2, inflectionPoint } = $layout.scroll.value;
      updateLocal(revealed, direction === "up" || position2 - inflectionPoint < 100 || $layout.height.value - containerHeight.value - position2 - size2.value < 300);
    }
    function onFocusin(evt) {
      if (revealOnFocus.value === true) {
        updateLocal(revealed, true);
      }
      emit("focusin", evt);
    }
    watch(() => props4.modelValue, (val) => {
      updateLayout("space", val);
      updateLocal(revealed, true);
      $layout.animate();
    });
    watch(offset2, (val) => {
      updateLayout("offset", val);
    });
    watch(() => props4.reveal, (val) => {
      val === false && updateLocal(revealed, props4.modelValue);
    });
    watch(revealed, (val) => {
      $layout.animate();
      emit("reveal", val);
    });
    watch([size2, $layout.scroll, $layout.height], updateRevealed);
    watch(() => $q.screen.height, (val) => {
      $layout.isContainer.value !== true && updateLocal(windowHeight, val);
    });
    const instance = {};
    $layout.instances.footer = instance;
    props4.modelValue === true && updateLayout("size", size2.value);
    updateLayout("space", props4.modelValue);
    updateLayout("offset", offset2.value);
    onBeforeUnmount(() => {
      if ($layout.instances.footer === instance) {
        $layout.instances.footer = void 0;
        updateLayout("size", 0);
        updateLayout("offset", 0);
        updateLayout("space", false);
      }
    });
    return () => {
      const child = hMergeSlot(slots.default, [
        h(QResizeObserver_default, {
          debounce: 0,
          onResize
        })
      ]);
      props4.elevated === true && child.push(
        h("div", {
          class: "q-layout__shadow absolute-full overflow-hidden no-pointer-events"
        })
      );
      return h("footer", {
        class: classes.value,
        style: style2.value,
        onFocusin
      }, child);
    };
  }
});
createComponent({
  name: "QForm",
  props: {
    autofocus: Boolean,
    noErrorFocus: Boolean,
    noResetFocus: Boolean,
    greedy: Boolean,
    onSubmit: Function
  },
  emits: ["reset", "validationSuccess", "validationError"],
  setup(props4, { slots, emit }) {
    const vm2 = getCurrentInstance();
    const rootRef = ref$1(null);
    let validateIndex = 0;
    const registeredComponents = [];
    function validate2(shouldFocus) {
      const focus2 = typeof shouldFocus === "boolean" ? shouldFocus : props4.noErrorFocus !== true;
      const index2 = ++validateIndex;
      const emitEvent = (res, ref73) => {
        emit(`validation${res === true ? "Success" : "Error"}`, ref73);
      };
      const validateComponent = (comp) => {
        const valid = comp.validate();
        return typeof valid.then === "function" ? valid.then(
          (valid2) => ({ valid: valid2, comp }),
          (err) => ({ valid: false, comp, err })
        ) : Promise.resolve({ valid, comp });
      };
      const errorsPromise = props4.greedy === true ? Promise.all(registeredComponents.map(validateComponent)).then((res) => res.filter((r) => r.valid !== true)) : registeredComponents.reduce(
        (acc, comp) => acc.then(() => {
          return validateComponent(comp).then((r) => {
            if (r.valid === false) {
              return Promise.reject(r);
            }
          });
        }),
        Promise.resolve()
      ).catch((error) => [error]);
      return errorsPromise.then((errors) => {
        if (errors === void 0 || errors.length === 0) {
          index2 === validateIndex && emitEvent(true);
          return true;
        }
        if (index2 === validateIndex) {
          const { comp, err } = errors[0];
          err !== void 0 && console.error(err);
          emitEvent(false, comp);
          if (focus2 === true) {
            const activeError = errors.find(({ comp: comp2 }) => typeof comp2.focus === "function" && vmIsDestroyed(comp2.$) === false);
            if (activeError !== void 0) {
              activeError.comp.focus();
            }
          }
        }
        return false;
      });
    }
    function resetValidation() {
      validateIndex++;
      registeredComponents.forEach((comp) => {
        typeof comp.resetValidation === "function" && comp.resetValidation();
      });
    }
    function submit(evt) {
      evt !== void 0 && stopAndPrevent(evt);
      const index2 = validateIndex + 1;
      validate2().then((val) => {
        if (index2 === validateIndex && val === true) {
          if (props4.onSubmit !== void 0) {
            emit("submit", evt);
          } else if ((evt == null ? void 0 : evt.target) !== void 0 && typeof evt.target.submit === "function") {
            evt.target.submit();
          }
        }
      });
    }
    function reset(evt) {
      evt !== void 0 && stopAndPrevent(evt);
      emit("reset");
      nextTick(() => {
        resetValidation();
        if (props4.autofocus === true && props4.noResetFocus !== true) {
          focus();
        }
      });
    }
    function focus() {
      addFocusFn(() => {
        if (rootRef.value === null) return;
        const target2 = rootRef.value.querySelector("[autofocus][tabindex], [data-autofocus][tabindex]") || rootRef.value.querySelector("[autofocus] [tabindex], [data-autofocus] [tabindex]") || rootRef.value.querySelector("[autofocus], [data-autofocus]") || Array.prototype.find.call(rootRef.value.querySelectorAll("[tabindex]"), (el) => el.tabIndex !== -1);
        target2 == null ? void 0 : target2.focus({ preventScroll: true });
      });
    }
    provide(formKey, {
      bindComponent(vmProxy) {
        registeredComponents.push(vmProxy);
      },
      unbindComponent(vmProxy) {
        const index2 = registeredComponents.indexOf(vmProxy);
        if (index2 !== -1) {
          registeredComponents.splice(index2, 1);
        }
      }
    });
    let shouldActivate = false;
    onDeactivated(() => {
      shouldActivate = true;
    });
    onActivated(() => {
      shouldActivate === true && props4.autofocus === true && focus();
    });
    onMounted(() => {
      props4.autofocus === true && focus();
    });
    Object.assign(vm2.proxy, {
      validate: validate2,
      resetValidation,
      submit,
      reset,
      focus,
      getValidationComponents: () => registeredComponents
    });
    return () => h("form", {
      class: "q-form",
      ref: rootRef,
      onSubmit: submit,
      onReset: reset
    }, hSlot(slots.default));
  }
});
createComponent({
  name: "QHeader",
  props: {
    modelValue: {
      type: Boolean,
      default: true
    },
    reveal: Boolean,
    revealOffset: {
      type: Number,
      default: 250
    },
    bordered: Boolean,
    elevated: Boolean,
    heightHint: {
      type: [String, Number],
      default: 50
    }
  },
  emits: ["reveal", "focusin"],
  setup(props4, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const $layout = inject(layoutKey, emptyRenderFn);
    if ($layout === emptyRenderFn) {
      console.error("QHeader needs to be child of QLayout");
      return emptyRenderFn;
    }
    const size2 = ref$1(parseInt(props4.heightHint, 10));
    const revealed = ref$1(true);
    const fixed = computed(
      () => props4.reveal === true || $layout.view.value.indexOf("H") !== -1 || $q.platform.is.ios && $layout.isContainer.value === true
    );
    const offset2 = computed(() => {
      if (props4.modelValue !== true) {
        return 0;
      }
      if (fixed.value === true) {
        return revealed.value === true ? size2.value : 0;
      }
      const offset3 = size2.value - $layout.scroll.value.position;
      return offset3 > 0 ? offset3 : 0;
    });
    const hidden = computed(
      () => props4.modelValue !== true || fixed.value === true && revealed.value !== true
    );
    const revealOnFocus = computed(
      () => props4.modelValue === true && hidden.value === true && props4.reveal === true
    );
    const classes = computed(
      () => "q-header q-layout__section--marginal " + (fixed.value === true ? "fixed" : "absolute") + "-top" + (props4.bordered === true ? " q-header--bordered" : "") + (hidden.value === true ? " q-header--hidden" : "") + (props4.modelValue !== true ? " q-layout--prevent-focus" : "")
    );
    const style2 = computed(() => {
      const view = $layout.rows.value.top, css2 = {};
      if (view[0] === "l" && $layout.left.space === true) {
        css2[$q.lang.rtl === true ? "right" : "left"] = `${$layout.left.size}px`;
      }
      if (view[2] === "r" && $layout.right.space === true) {
        css2[$q.lang.rtl === true ? "left" : "right"] = `${$layout.right.size}px`;
      }
      return css2;
    });
    function updateLayout(prop, val) {
      $layout.update("header", prop, val);
    }
    function updateLocal(prop, val) {
      if (prop.value !== val) {
        prop.value = val;
      }
    }
    function onResize({ height: height2 }) {
      updateLocal(size2, height2);
      updateLayout("size", height2);
    }
    function onFocusin(evt) {
      if (revealOnFocus.value === true) {
        updateLocal(revealed, true);
      }
      emit("focusin", evt);
    }
    watch(() => props4.modelValue, (val) => {
      updateLayout("space", val);
      updateLocal(revealed, true);
      $layout.animate();
    });
    watch(offset2, (val) => {
      updateLayout("offset", val);
    });
    watch(() => props4.reveal, (val) => {
      val === false && updateLocal(revealed, props4.modelValue);
    });
    watch(revealed, (val) => {
      $layout.animate();
      emit("reveal", val);
    });
    watch($layout.scroll, (scroll) => {
      props4.reveal === true && updateLocal(
        revealed,
        scroll.direction === "up" || scroll.position <= props4.revealOffset || scroll.position - scroll.inflectionPoint < 100
      );
    });
    const instance = {};
    $layout.instances.header = instance;
    props4.modelValue === true && updateLayout("size", size2.value);
    updateLayout("space", props4.modelValue);
    updateLayout("offset", offset2.value);
    onBeforeUnmount(() => {
      if ($layout.instances.header === instance) {
        $layout.instances.header = void 0;
        updateLayout("size", 0);
        updateLayout("offset", 0);
        updateLayout("space", false);
      }
    });
    return () => {
      const child = hUniqueSlot(slots.default, []);
      props4.elevated === true && child.push(
        h("div", {
          class: "q-layout__shadow absolute-full overflow-hidden no-pointer-events"
        })
      );
      child.push(
        h(QResizeObserver_default, {
          debounce: 0,
          onResize
        })
      );
      return h("header", {
        class: classes.value,
        style: style2.value,
        onFocusin
      }, child);
    };
  }
});
var useRatioProps = {
  ratio: [String, Number]
};
function use_ratio_default(props4, naturalRatio) {
  return computed(() => {
    const ratio = Number(
      props4.ratio || (naturalRatio !== void 0 ? naturalRatio.value : void 0)
    );
    return isNaN(ratio) !== true && ratio > 0 ? { paddingBottom: `${100 / ratio}%` } : null;
  });
}
var defaultRatio = 1.7778;
createComponent({
  name: "QImg",
  props: {
    ...useRatioProps,
    src: String,
    srcset: String,
    sizes: String,
    alt: String,
    crossorigin: String,
    decoding: String,
    referrerpolicy: String,
    draggable: Boolean,
    loading: {
      type: String,
      default: "lazy"
    },
    loadingShowDelay: {
      type: [Number, String],
      default: 0
    },
    fetchpriority: {
      type: String,
      default: "auto"
    },
    width: String,
    height: String,
    initialRatio: {
      type: [Number, String],
      default: defaultRatio
    },
    placeholderSrc: String,
    errorSrc: String,
    fit: {
      type: String,
      default: "cover"
    },
    position: {
      type: String,
      default: "50% 50%"
    },
    imgClass: String,
    imgStyle: Object,
    noSpinner: Boolean,
    noNativeMenu: Boolean,
    noTransition: Boolean,
    spinnerColor: String,
    spinnerSize: String
  },
  emits: ["load", "error"],
  setup(props4, { slots, emit }) {
    const naturalRatio = ref$1(props4.initialRatio);
    const ratioStyle = use_ratio_default(props4, naturalRatio);
    const vm2 = getCurrentInstance();
    const { registerTimeout: registerLoadTimeout, removeTimeout: removeLoadTimeout } = use_timeout_default();
    const { registerTimeout: registerLoadShowTimeout, removeTimeout: removeLoadShowTimeout } = use_timeout_default();
    const placeholderImg = computed(() => props4.placeholderSrc !== void 0 ? { src: props4.placeholderSrc } : null);
    const errorImg = computed(() => props4.errorSrc !== void 0 ? { src: props4.errorSrc, __qerror: true } : null);
    const images = [
      ref$1(null),
      ref$1(placeholderImg.value)
    ];
    const position2 = ref$1(0);
    const isLoading = ref$1(false);
    const hasError = ref$1(false);
    const classes = computed(
      () => `q-img q-img--${props4.noNativeMenu === true ? "no-" : ""}menu`
    );
    const style2 = computed(() => ({
      width: props4.width,
      height: props4.height
    }));
    const imgClass = computed(
      () => `q-img__image ${props4.imgClass !== void 0 ? props4.imgClass + " " : ""}q-img__image--with${props4.noTransition === true ? "out" : ""}-transition q-img__image--`
    );
    const imgStyle = computed(() => ({
      ...props4.imgStyle,
      objectFit: props4.fit,
      objectPosition: props4.position
    }));
    function setLoading() {
      removeLoadShowTimeout();
      if (props4.loadingShowDelay === 0) {
        isLoading.value = true;
        return;
      }
      registerLoadShowTimeout(() => {
        isLoading.value = true;
      }, props4.loadingShowDelay);
    }
    function clearLoading() {
      removeLoadShowTimeout();
      isLoading.value = false;
    }
    function onLoad({ target: target2 }) {
      if (vmIsDestroyed(vm2) === false) {
        removeLoadTimeout();
        naturalRatio.value = target2.naturalHeight === 0 ? 0.5 : target2.naturalWidth / target2.naturalHeight;
        waitForCompleteness(target2, 1);
      }
    }
    function waitForCompleteness(target2, count) {
      if (count === 1e3 || vmIsDestroyed(vm2) === true) return;
      if (target2.complete === true) {
        onReady(target2);
      } else {
        registerLoadTimeout(() => {
          waitForCompleteness(target2, count + 1);
        }, 50);
      }
    }
    function onReady(target2) {
      if (vmIsDestroyed(vm2) === true) return;
      position2.value = position2.value ^ 1;
      images[position2.value].value = null;
      clearLoading();
      if (target2.getAttribute("__qerror") !== "true") {
        hasError.value = false;
      }
      emit("load", target2.currentSrc || target2.src);
    }
    function onError(err) {
      removeLoadTimeout();
      clearLoading();
      hasError.value = true;
      images[position2.value].value = errorImg.value;
      images[position2.value ^ 1].value = placeholderImg.value;
      emit("error", err);
    }
    function getImage(index2) {
      const img = images[index2].value;
      const data = {
        key: "img_" + index2,
        class: imgClass.value,
        style: imgStyle.value,
        alt: props4.alt,
        crossorigin: props4.crossorigin,
        decoding: props4.decoding,
        referrerpolicy: props4.referrerpolicy,
        height: props4.height,
        width: props4.width,
        loading: props4.loading,
        fetchpriority: props4.fetchpriority,
        "aria-hidden": "true",
        draggable: props4.draggable,
        ...img
      };
      if (position2.value === index2) {
        Object.assign(data, {
          class: data.class + "current",
          onLoad,
          onError
        });
      } else {
        data.class += "loaded";
      }
      return h(
        "div",
        { class: "q-img__container absolute-full", key: "img" + index2 },
        h("img", data)
      );
    }
    function getContent() {
      if (isLoading.value === false) {
        return h("div", {
          key: "content",
          class: "q-img__content absolute-full q-anchor--skip"
        }, hSlot(slots[hasError.value === true ? "error" : "default"]));
      }
      return h("div", {
        key: "loading",
        class: "q-img__loading absolute-full flex flex-center"
      }, slots.loading !== void 0 ? slots.loading() : props4.noSpinner === true ? void 0 : [
        h(QSpinner_default, {
          color: props4.spinnerColor,
          size: props4.spinnerSize
        })
      ]);
    }
    {
      let watchSrc = function() {
        watch(
          () => props4.src || props4.srcset || props4.sizes ? {
            src: props4.src,
            srcset: props4.srcset,
            sizes: props4.sizes
          } : null,
          (imgProps) => {
            removeLoadTimeout();
            hasError.value = false;
            if (imgProps === null) {
              clearLoading();
              images[position2.value ^ 1].value = placeholderImg.value;
            } else {
              setLoading();
            }
            images[position2.value].value = imgProps;
          },
          { immediate: true }
        );
      };
      if (isRuntimeSsrPreHydration.value === true) {
        onMounted(watchSrc);
      } else {
        watchSrc();
      }
    }
    return () => {
      const content = [];
      if (ratioStyle.value !== null) {
        content.push(
          h("div", { key: "filler", style: ratioStyle.value })
        );
      }
      if (images[0].value !== null) {
        content.push(
          getImage(0)
        );
      }
      if (images[1].value !== null) {
        content.push(
          getImage(1)
        );
      }
      content.push(
        h(Transition, { name: "q-transition--fade" }, getContent)
      );
      return h("div", {
        key: "main",
        class: classes.value,
        style: style2.value,
        role: "img",
        "aria-label": props4.alt
      }, content);
    };
  }
});
var { passive: passive2 } = listenOpts;
createComponent({
  name: "QInfiniteScroll",
  props: {
    offset: {
      type: Number,
      default: 500
    },
    debounce: {
      type: [String, Number],
      default: 100
    },
    scrollTarget: scrollTargetProp,
    initialIndex: {
      type: Number,
      default: 0
    },
    disable: Boolean,
    reverse: Boolean
  },
  emits: ["load"],
  setup(props4, { slots, emit }) {
    const isFetching = ref$1(false);
    const isWorking = ref$1(true);
    const rootRef = ref$1(null);
    const loadingRef = ref$1(null);
    let index2 = props4.initialIndex;
    let localScrollTarget, poll;
    const classes = computed(
      () => "q-infinite-scroll__loading" + (isFetching.value === true ? "" : " invisible")
    );
    function immediatePoll() {
      if (props4.disable === true || isFetching.value === true || isWorking.value === false) return;
      const scrollHeight = getScrollHeight(localScrollTarget), scrollPosition = getVerticalScrollPosition(localScrollTarget), containerHeight = height(localScrollTarget);
      if (props4.reverse === false) {
        if (Math.round(scrollPosition + containerHeight + props4.offset) >= Math.round(scrollHeight)) {
          trigger3();
        }
      } else if (Math.round(scrollPosition) <= props4.offset) {
        trigger3();
      }
    }
    function trigger3() {
      if (props4.disable === true || isFetching.value === true || isWorking.value === false) return;
      index2++;
      isFetching.value = true;
      const heightBefore = getScrollHeight(localScrollTarget);
      emit("load", index2, (isDone) => {
        if (isWorking.value === true) {
          isFetching.value = false;
          nextTick(() => {
            if (props4.reverse === true) {
              const heightAfter = getScrollHeight(localScrollTarget), scrollPosition = getVerticalScrollPosition(localScrollTarget), heightDifference = heightAfter - heightBefore;
              setVerticalScrollPosition(localScrollTarget, scrollPosition + heightDifference);
            }
            if (isDone === true) {
              stop2();
            } else if (rootRef.value) {
              rootRef.value.closest("body") && poll();
            }
          });
        }
      });
    }
    function reset() {
      index2 = 0;
    }
    function resume() {
      if (isWorking.value === false) {
        isWorking.value = true;
        localScrollTarget.addEventListener("scroll", poll, passive2);
      }
      immediatePoll();
    }
    function stop2() {
      var _a;
      if (isWorking.value === true) {
        isWorking.value = false;
        isFetching.value = false;
        localScrollTarget.removeEventListener("scroll", poll, passive2);
        (_a = poll == null ? void 0 : poll.cancel) == null ? void 0 : _a.call(poll);
      }
    }
    function updateScrollTarget() {
      if (localScrollTarget && isWorking.value === true) {
        localScrollTarget.removeEventListener("scroll", poll, passive2);
      }
      localScrollTarget = getScrollTarget(rootRef.value, props4.scrollTarget);
      if (isWorking.value === true) {
        localScrollTarget.addEventListener("scroll", poll, passive2);
        if (props4.reverse === true) {
          const scrollHeight = getScrollHeight(localScrollTarget), containerHeight = height(localScrollTarget);
          setVerticalScrollPosition(localScrollTarget, scrollHeight - containerHeight);
        }
        immediatePoll();
      }
    }
    function setIndex(newIndex) {
      index2 = newIndex;
    }
    function setDebounce(val) {
      val = parseInt(val, 10);
      const oldPoll = poll;
      poll = val <= 0 ? immediatePoll : debounce_default(immediatePoll, isNaN(val) === true ? 100 : val);
      if (localScrollTarget && isWorking.value === true) {
        if (oldPoll !== void 0) {
          localScrollTarget.removeEventListener("scroll", oldPoll, passive2);
        }
        localScrollTarget.addEventListener("scroll", poll, passive2);
      }
    }
    function updateSvgAnimations(isRetry) {
      if (renderLoadingSlot.value === true) {
        if (loadingRef.value === null) {
          isRetry !== true && nextTick(() => {
            updateSvgAnimations(true);
          });
          return;
        }
        const action = `${isFetching.value === true ? "un" : ""}pauseAnimations`;
        Array.from(loadingRef.value.getElementsByTagName("svg")).forEach((el) => {
          el[action]();
        });
      }
    }
    const renderLoadingSlot = computed(() => props4.disable !== true && isWorking.value === true);
    watch([isFetching, renderLoadingSlot], () => {
      updateSvgAnimations();
    });
    watch(() => props4.disable, (val) => {
      if (val === true) {
        stop2();
      } else {
        resume();
      }
    });
    watch(() => props4.reverse, () => {
      if (isFetching.value === false && isWorking.value === true) {
        immediatePoll();
      }
    });
    watch(() => props4.scrollTarget, updateScrollTarget);
    watch(() => props4.debounce, setDebounce);
    let scrollPos = false;
    onActivated(() => {
      if (scrollPos !== false && localScrollTarget) {
        setVerticalScrollPosition(localScrollTarget, scrollPos);
      }
    });
    onDeactivated(() => {
      scrollPos = localScrollTarget ? getVerticalScrollPosition(localScrollTarget) : false;
    });
    onBeforeUnmount(() => {
      if (isWorking.value === true) {
        localScrollTarget.removeEventListener("scroll", poll, passive2);
      }
    });
    onMounted(() => {
      setDebounce(props4.debounce);
      updateScrollTarget();
      isFetching.value === false && updateSvgAnimations();
    });
    const vm2 = getCurrentInstance();
    Object.assign(vm2.proxy, {
      poll: () => {
        poll == null ? void 0 : poll();
      },
      trigger: trigger3,
      stop: stop2,
      reset,
      resume,
      setIndex,
      updateScrollTarget
    });
    return () => {
      const child = hUniqueSlot(slots.default, []);
      if (renderLoadingSlot.value === true) {
        child[props4.reverse === false ? "push" : "unshift"](
          h("div", { ref: loadingRef, class: classes.value }, hSlot(slots.loading))
        );
      }
      return h("div", {
        class: "q-infinite-scroll",
        ref: rootRef
      }, child);
    };
  }
});
createComponent({
  name: "QInnerLoading",
  props: {
    ...useDarkProps,
    ...useTransitionProps,
    showing: Boolean,
    color: String,
    size: {
      type: [String, Number],
      default: "42px"
    },
    label: String,
    labelClass: String,
    labelStyle: [String, Array, Object]
  },
  setup(props4, { slots }) {
    const vm2 = getCurrentInstance();
    const isDark = use_dark_default(props4, vm2.proxy.$q);
    const { transitionProps, transitionStyle } = use_transition_default(props4);
    const classes = computed(
      () => "q-inner-loading q--avoid-card-border absolute-full column flex-center" + (isDark.value === true ? " q-inner-loading--dark" : "")
    );
    const labelClass = computed(
      () => "q-inner-loading__label" + (props4.labelClass !== void 0 ? ` ${props4.labelClass}` : "")
    );
    function getInner() {
      const child = [
        h(QSpinner_default, {
          size: props4.size,
          color: props4.color
        })
      ];
      if (props4.label !== void 0) {
        child.push(
          h("div", {
            class: labelClass.value,
            style: props4.labelStyle
          }, [props4.label])
        );
      }
      return child;
    }
    function getContent() {
      return props4.showing === true ? h(
        "div",
        { class: classes.value, style: transitionStyle.value },
        slots.default !== void 0 ? slots.default() : getInner()
      ) : null;
    }
    return () => h(Transition, transitionProps.value, getContent);
  }
});
var NAMED_MASKS = {
  date: "####/##/##",
  datetime: "####/##/## ##:##",
  time: "##:##",
  fulltime: "##:##:##",
  phone: "(###) ### - ####",
  card: "#### #### #### ####"
};
var TOKENS = {
  "#": { pattern: "[\\d]", negate: "[^\\d]" },
  S: { pattern: "[a-zA-Z]", negate: "[^a-zA-Z]" },
  N: { pattern: "[0-9a-zA-Z]", negate: "[^0-9a-zA-Z]" },
  A: { pattern: "[a-zA-Z]", negate: "[^a-zA-Z]", transform: (v) => v.toLocaleUpperCase() },
  a: { pattern: "[a-zA-Z]", negate: "[^a-zA-Z]", transform: (v) => v.toLocaleLowerCase() },
  X: { pattern: "[0-9a-zA-Z]", negate: "[^0-9a-zA-Z]", transform: (v) => v.toLocaleUpperCase() },
  x: { pattern: "[0-9a-zA-Z]", negate: "[^0-9a-zA-Z]", transform: (v) => v.toLocaleLowerCase() }
};
var KEYS = Object.keys(TOKENS);
KEYS.forEach((key) => {
  TOKENS[key].regex = new RegExp(TOKENS[key].pattern);
});
var tokenRegexMask = new RegExp("\\\\([^.*+?^${}()|([\\]])|([.*+?^${}()|[\\]])|([" + KEYS.join("") + "])|(.)", "g");
var escRegex = /[.*+?^${}()|[\]\\]/g;
var MARKER = String.fromCharCode(1);
var useMaskProps = {
  mask: String,
  reverseFillMask: Boolean,
  fillMask: [Boolean, String],
  unmaskedValue: Boolean
};
function use_mask_default(props4, emit, emitValue, inputRef) {
  let maskMarked, maskReplaced, computedMask, computedUnmask, pastedTextStart, selectionAnchor;
  const hasMask = ref$1(null);
  const innerValue = ref$1(getInitialMaskedValue());
  function getIsTypeText() {
    return props4.autogrow === true || ["textarea", "text", "search", "url", "tel", "password"].includes(props4.type);
  }
  watch(() => props4.type + props4.autogrow, updateMaskInternals);
  watch(() => props4.mask, (v) => {
    if (v !== void 0) {
      updateMaskValue(innerValue.value, true);
    } else {
      const val = unmaskValue(innerValue.value);
      updateMaskInternals();
      props4.modelValue !== val && emit("update:modelValue", val);
    }
  });
  watch(() => props4.fillMask + props4.reverseFillMask, () => {
    hasMask.value === true && updateMaskValue(innerValue.value, true);
  });
  watch(() => props4.unmaskedValue, () => {
    hasMask.value === true && updateMaskValue(innerValue.value);
  });
  function getInitialMaskedValue() {
    updateMaskInternals();
    if (hasMask.value === true) {
      const masked = maskValue(unmaskValue(props4.modelValue));
      return props4.fillMask !== false ? fillWithMask(masked) : masked;
    }
    return props4.modelValue;
  }
  function getPaddedMaskMarked(size2) {
    if (size2 < maskMarked.length) {
      return maskMarked.slice(-size2);
    }
    let pad2 = "", localMaskMarked = maskMarked;
    const padPos = localMaskMarked.indexOf(MARKER);
    if (padPos !== -1) {
      for (let i3 = size2 - localMaskMarked.length; i3 > 0; i3--) {
        pad2 += MARKER;
      }
      localMaskMarked = localMaskMarked.slice(0, padPos) + pad2 + localMaskMarked.slice(padPos);
    }
    return localMaskMarked;
  }
  function updateMaskInternals() {
    hasMask.value = props4.mask !== void 0 && props4.mask.length !== 0 && getIsTypeText();
    if (hasMask.value === false) {
      computedUnmask = void 0;
      maskMarked = "";
      maskReplaced = "";
      return;
    }
    const localComputedMask = NAMED_MASKS[props4.mask] === void 0 ? props4.mask : NAMED_MASKS[props4.mask], fillChar = typeof props4.fillMask === "string" && props4.fillMask.length !== 0 ? props4.fillMask.slice(0, 1) : "_", fillCharEscaped = fillChar.replace(escRegex, "\\$&"), unmask = [], extract = [], mask = [];
    let firstMatch = props4.reverseFillMask === true, unmaskChar = "", negateChar = "";
    localComputedMask.replace(tokenRegexMask, (_, char1, esc, token2, char2) => {
      if (token2 !== void 0) {
        const c3 = TOKENS[token2];
        mask.push(c3);
        negateChar = c3.negate;
        if (firstMatch === true) {
          extract.push("(?:" + negateChar + "+)?(" + c3.pattern + "+)?(?:" + negateChar + "+)?(" + c3.pattern + "+)?");
          firstMatch = false;
        }
        extract.push("(?:" + negateChar + "+)?(" + c3.pattern + ")?");
      } else if (esc !== void 0) {
        unmaskChar = "\\" + (esc === "\\" ? "" : esc);
        mask.push(esc);
        unmask.push("([^" + unmaskChar + "]+)?" + unmaskChar + "?");
      } else {
        const c3 = char1 !== void 0 ? char1 : char2;
        unmaskChar = c3 === "\\" ? "\\\\\\\\" : c3.replace(escRegex, "\\\\$&");
        mask.push(c3);
        unmask.push("([^" + unmaskChar + "]+)?" + unmaskChar + "?");
      }
    });
    const unmaskMatcher = new RegExp(
      "^" + unmask.join("") + "(" + (unmaskChar === "" ? "." : "[^" + unmaskChar + "]") + "+)?" + (unmaskChar === "" ? "" : "[" + unmaskChar + "]*") + "$"
    ), extractLast = extract.length - 1, extractMatcher = extract.map((re2, index2) => {
      if (index2 === 0 && props4.reverseFillMask === true) {
        return new RegExp("^" + fillCharEscaped + "*" + re2);
      } else if (index2 === extractLast) {
        return new RegExp(
          "^" + re2 + "(" + (negateChar === "" ? "." : negateChar) + "+)?" + (props4.reverseFillMask === true ? "$" : fillCharEscaped + "*")
        );
      }
      return new RegExp("^" + re2);
    });
    computedMask = mask;
    computedUnmask = (val) => {
      const unmaskMatch = unmaskMatcher.exec(props4.reverseFillMask === true ? val : val.slice(0, mask.length + 1));
      if (unmaskMatch !== null) {
        val = unmaskMatch.slice(1).join("");
      }
      const extractMatch = [], extractMatcherLength = extractMatcher.length;
      for (let i3 = 0, str = val; i3 < extractMatcherLength; i3++) {
        const m4 = extractMatcher[i3].exec(str);
        if (m4 === null) {
          break;
        }
        str = str.slice(m4.shift().length);
        extractMatch.push(...m4);
      }
      if (extractMatch.length !== 0) {
        return extractMatch.join("");
      }
      return val;
    };
    maskMarked = mask.map((v) => typeof v === "string" ? v : MARKER).join("");
    maskReplaced = maskMarked.split(MARKER).join(fillChar);
  }
  function updateMaskValue(rawVal, updateMaskInternalsFlag, inputType) {
    const inp = inputRef.value, end = inp.selectionEnd, endReverse = inp.value.length - end, unmasked = unmaskValue(rawVal);
    updateMaskInternalsFlag === true && updateMaskInternals();
    const preMasked = maskValue(unmasked), masked = props4.fillMask !== false ? fillWithMask(preMasked) : preMasked, changed2 = innerValue.value !== masked;
    inp.value !== masked && (inp.value = masked);
    changed2 === true && (innerValue.value = masked);
    document.activeElement === inp && nextTick(() => {
      if (masked === maskReplaced) {
        const cursor = props4.reverseFillMask === true ? maskReplaced.length : 0;
        inp.setSelectionRange(cursor, cursor, "forward");
        return;
      }
      if (inputType === "insertFromPaste" && props4.reverseFillMask !== true) {
        const maxEnd = inp.selectionEnd;
        let cursor = end - 1;
        for (let i3 = pastedTextStart; i3 <= cursor && i3 < maxEnd; i3++) {
          if (maskMarked[i3] !== MARKER) {
            cursor++;
          }
        }
        moveCursor.right(inp, cursor);
        return;
      }
      if (["deleteContentBackward", "deleteContentForward"].indexOf(inputType) !== -1) {
        const cursor = props4.reverseFillMask === true ? end === 0 ? masked.length > preMasked.length ? 1 : 0 : Math.max(0, masked.length - (masked === maskReplaced ? 0 : Math.min(preMasked.length, endReverse) + 1)) + 1 : end;
        inp.setSelectionRange(cursor, cursor, "forward");
        return;
      }
      if (props4.reverseFillMask === true) {
        if (changed2 === true) {
          const cursor = Math.max(0, masked.length - (masked === maskReplaced ? 0 : Math.min(preMasked.length, endReverse + 1)));
          if (cursor === 1 && end === 1) {
            inp.setSelectionRange(cursor, cursor, "forward");
          } else {
            moveCursor.rightReverse(inp, cursor);
          }
        } else {
          const cursor = masked.length - endReverse;
          inp.setSelectionRange(cursor, cursor, "backward");
        }
      } else {
        if (changed2 === true) {
          const cursor = Math.max(0, maskMarked.indexOf(MARKER), Math.min(preMasked.length, end) - 1);
          moveCursor.right(inp, cursor);
        } else {
          const cursor = end - 1;
          moveCursor.right(inp, cursor);
        }
      }
    });
    const val = props4.unmaskedValue === true ? unmaskValue(masked) : masked;
    if (String(props4.modelValue) !== val && (props4.modelValue !== null || val !== "")) {
      emitValue(val, true);
    }
  }
  function moveCursorForPaste(inp, start, end) {
    const preMasked = maskValue(unmaskValue(inp.value));
    start = Math.max(0, maskMarked.indexOf(MARKER), Math.min(preMasked.length, start));
    pastedTextStart = start;
    inp.setSelectionRange(start, end, "forward");
  }
  const moveCursor = {
    left(inp, cursor) {
      const noMarkBefore = maskMarked.slice(cursor - 1).indexOf(MARKER) === -1;
      let i3 = Math.max(0, cursor - 1);
      for (; i3 >= 0; i3--) {
        if (maskMarked[i3] === MARKER) {
          cursor = i3;
          noMarkBefore === true && cursor++;
          break;
        }
      }
      if (i3 < 0 && maskMarked[cursor] !== void 0 && maskMarked[cursor] !== MARKER) {
        return moveCursor.right(inp, 0);
      }
      cursor >= 0 && inp.setSelectionRange(cursor, cursor, "backward");
    },
    right(inp, cursor) {
      const limit2 = inp.value.length;
      let i3 = Math.min(limit2, cursor + 1);
      for (; i3 <= limit2; i3++) {
        if (maskMarked[i3] === MARKER) {
          cursor = i3;
          break;
        } else if (maskMarked[i3 - 1] === MARKER) {
          cursor = i3;
        }
      }
      if (i3 > limit2 && maskMarked[cursor - 1] !== void 0 && maskMarked[cursor - 1] !== MARKER) {
        return moveCursor.left(inp, limit2);
      }
      inp.setSelectionRange(cursor, cursor, "forward");
    },
    leftReverse(inp, cursor) {
      const localMaskMarked = getPaddedMaskMarked(inp.value.length);
      let i3 = Math.max(0, cursor - 1);
      for (; i3 >= 0; i3--) {
        if (localMaskMarked[i3 - 1] === MARKER) {
          cursor = i3;
          break;
        } else if (localMaskMarked[i3] === MARKER) {
          cursor = i3;
          if (i3 === 0) {
            break;
          }
        }
      }
      if (i3 < 0 && localMaskMarked[cursor] !== void 0 && localMaskMarked[cursor] !== MARKER) {
        return moveCursor.rightReverse(inp, 0);
      }
      cursor >= 0 && inp.setSelectionRange(cursor, cursor, "backward");
    },
    rightReverse(inp, cursor) {
      const limit2 = inp.value.length, localMaskMarked = getPaddedMaskMarked(limit2), noMarkBefore = localMaskMarked.slice(0, cursor + 1).indexOf(MARKER) === -1;
      let i3 = Math.min(limit2, cursor + 1);
      for (; i3 <= limit2; i3++) {
        if (localMaskMarked[i3 - 1] === MARKER) {
          cursor = i3;
          cursor > 0 && noMarkBefore === true && cursor--;
          break;
        }
      }
      if (i3 > limit2 && localMaskMarked[cursor - 1] !== void 0 && localMaskMarked[cursor - 1] !== MARKER) {
        return moveCursor.leftReverse(inp, limit2);
      }
      inp.setSelectionRange(cursor, cursor, "forward");
    }
  };
  function onMaskedClick(e3) {
    emit("click", e3);
    selectionAnchor = void 0;
  }
  function onMaskedKeydown(e3) {
    emit("keydown", e3);
    if (shouldIgnoreKey(e3) === true || e3.altKey === true) return;
    const inp = inputRef.value, start = inp.selectionStart, end = inp.selectionEnd;
    if (!e3.shiftKey) {
      selectionAnchor = void 0;
    }
    if (e3.keyCode === 37 || e3.keyCode === 39) {
      if (e3.shiftKey && selectionAnchor === void 0) {
        selectionAnchor = inp.selectionDirection === "forward" ? start : end;
      }
      const fn = moveCursor[(e3.keyCode === 39 ? "right" : "left") + (props4.reverseFillMask === true ? "Reverse" : "")];
      e3.preventDefault();
      fn(inp, selectionAnchor === start ? end : start);
      if (e3.shiftKey) {
        const cursor = inp.selectionStart;
        inp.setSelectionRange(Math.min(selectionAnchor, cursor), Math.max(selectionAnchor, cursor), "forward");
      }
    } else if (e3.keyCode === 8 && props4.reverseFillMask !== true && start === end) {
      moveCursor.left(inp, start);
      inp.setSelectionRange(inp.selectionStart, end, "backward");
    } else if (e3.keyCode === 46 && props4.reverseFillMask === true && start === end) {
      moveCursor.rightReverse(inp, end);
      inp.setSelectionRange(start, inp.selectionEnd, "forward");
    }
  }
  function maskValue(val) {
    if (val === void 0 || val === null || val === "") {
      return "";
    }
    if (props4.reverseFillMask === true) {
      return maskValueReverse(val);
    }
    const mask = computedMask;
    let valIndex = 0, output = "";
    for (let maskIndex = 0; maskIndex < mask.length; maskIndex++) {
      const valChar = val[valIndex], maskDef = mask[maskIndex];
      if (typeof maskDef === "string") {
        output += maskDef;
      } else if (valChar !== void 0 && maskDef.regex.test(valChar)) {
        output += maskDef.transform !== void 0 ? maskDef.transform(valChar) : valChar;
        valIndex++;
      } else {
        return output;
      }
    }
    return output;
  }
  function maskValueReverse(val) {
    const mask = computedMask, firstTokenIndex = maskMarked.indexOf(MARKER);
    let valIndex = val.length - 1, output = "";
    for (let maskIndex = mask.length - 1; maskIndex >= 0 && valIndex !== -1; maskIndex--) {
      const maskDef = mask[maskIndex];
      let valChar = val[valIndex];
      if (typeof maskDef === "string") {
        output = maskDef + output;
      } else if (valChar !== void 0 && maskDef.regex.test(valChar)) {
        do {
          output = (maskDef.transform !== void 0 ? maskDef.transform(valChar) : valChar) + output;
          valIndex--;
          valChar = val[valIndex];
        } while (firstTokenIndex === maskIndex && valChar !== void 0 && maskDef.regex.test(valChar));
      } else {
        return output;
      }
    }
    return output;
  }
  function unmaskValue(val) {
    return typeof val !== "string" || computedUnmask === void 0 ? typeof val === "number" ? computedUnmask("" + val) : val : computedUnmask(val);
  }
  function fillWithMask(val) {
    if (maskReplaced.length - val.length <= 0) {
      return val;
    }
    return props4.reverseFillMask === true && val.length !== 0 ? maskReplaced.slice(0, -val.length) + val : val + maskReplaced.slice(val.length);
  }
  return {
    innerValue,
    hasMask,
    moveCursorForPaste,
    updateMaskValue,
    onMaskedKeydown,
    onMaskedClick
  };
}
var isJapanese = /[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf]/;
var isChinese = /[\u4e00-\u9fff\u3400-\u4dbf\u{20000}-\u{2a6df}\u{2a700}-\u{2b73f}\u{2b740}-\u{2b81f}\u{2b820}-\u{2ceaf}\uf900-\ufaff\u3300-\u33ff\ufe30-\ufe4f\uf900-\ufaff\u{2f800}-\u{2fa1f}]/u;
var isKorean = /[\u3131-\u314e\u314f-\u3163\uac00-\ud7a3]/;
var isPlainText = /[a-z0-9_ -]$/i;
function use_key_composition_default(onInput) {
  return function onComposition(e3) {
    if (e3.type === "compositionend" || e3.type === "change") {
      if (e3.target.qComposing !== true) return;
      e3.target.qComposing = false;
      onInput(e3);
    } else if (e3.type === "compositionupdate" && e3.target.qComposing !== true && typeof e3.data === "string") {
      const isComposing = client.is.firefox === true ? isPlainText.test(e3.data) === false : isJapanese.test(e3.data) === true || isChinese.test(e3.data) === true || isKorean.test(e3.data) === true;
      if (isComposing === true) {
        e3.target.qComposing = true;
      }
    }
  };
}
var QInput_default = createComponent({
  name: "QInput",
  inheritAttrs: false,
  props: {
    ...useFieldProps,
    ...useMaskProps,
    ...useFormProps,
    // override of useFieldProps > modelValue
    modelValue: [String, Number, FileList],
    shadowText: String,
    type: {
      type: String,
      default: "text"
    },
    debounce: [String, Number],
    autogrow: Boolean,
    // makes a textarea
    inputClass: [Array, String, Object],
    inputStyle: [Array, String, Object]
  },
  emits: [
    ...useFieldEmits,
    "paste",
    "change",
    "keydown",
    "click",
    "animationend"
  ],
  setup(props4, { emit, attrs }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const temp = {};
    let emitCachedValue = NaN, typedNumber, stopValueWatcher, emitTimer = null, emitValueFn;
    const inputRef = ref$1(null);
    const nameProp = useFormInputNameAttr(props4);
    const {
      innerValue,
      hasMask,
      moveCursorForPaste,
      updateMaskValue,
      onMaskedKeydown,
      onMaskedClick
    } = use_mask_default(props4, emit, emitValue, inputRef);
    const formDomProps = use_file_dom_props_default(
      props4,
      /* type guard */
      true
    );
    const hasValue = computed(() => fieldValueIsFilled(innerValue.value));
    const onComposition = use_key_composition_default(onInput);
    const state2 = useFieldState({ changeEvent: true });
    const isTextarea = computed(
      () => props4.type === "textarea" || props4.autogrow === true
    );
    const isTypeText = computed(
      () => isTextarea.value === true || ["text", "search", "url", "tel", "password"].includes(props4.type)
    );
    const onEvents = computed(() => {
      const evt = {
        ...state2.splitAttrs.listeners.value,
        onInput,
        onPaste,
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        onChange,
        onBlur: onFinishEditing,
        onFocus: stop
      };
      evt.onCompositionstart = evt.onCompositionupdate = evt.onCompositionend = onComposition;
      if (hasMask.value === true) {
        evt.onKeydown = onMaskedKeydown;
        evt.onClick = onMaskedClick;
      }
      if (props4.autogrow === true) {
        evt.onAnimationend = onAnimationend;
      }
      return evt;
    });
    const inputAttrs = computed(() => {
      const attrs2 = {
        tabindex: 0,
        "data-autofocus": props4.autofocus === true || void 0,
        rows: props4.type === "textarea" ? 6 : void 0,
        "aria-label": props4.label,
        name: nameProp.value,
        ...state2.splitAttrs.attributes.value,
        id: state2.targetUid.value,
        maxlength: props4.maxlength,
        disabled: props4.disable === true,
        readonly: props4.readonly === true
      };
      if (isTextarea.value === false) {
        attrs2.type = props4.type;
      }
      if (props4.autogrow === true) {
        attrs2.rows = 1;
      }
      return attrs2;
    });
    watch(() => props4.type, () => {
      if (inputRef.value) {
        inputRef.value.value = props4.modelValue;
      }
    });
    watch(() => props4.modelValue, (v) => {
      if (hasMask.value === true) {
        if (stopValueWatcher === true) {
          stopValueWatcher = false;
          if (String(v) === emitCachedValue) return;
        }
        updateMaskValue(v);
      } else if (innerValue.value !== v) {
        innerValue.value = v;
        if (props4.type === "number" && temp.hasOwnProperty("value") === true) {
          if (typedNumber === true) {
            typedNumber = false;
          } else {
            delete temp.value;
          }
        }
      }
      props4.autogrow === true && nextTick(adjustHeight);
    });
    watch(() => props4.autogrow, (val) => {
      if (val === true) {
        nextTick(adjustHeight);
      } else if (inputRef.value !== null && attrs.rows > 0) {
        inputRef.value.style.height = "auto";
      }
    });
    watch(() => props4.dense, () => {
      props4.autogrow === true && nextTick(adjustHeight);
    });
    function focus() {
      addFocusFn(() => {
        const el = document.activeElement;
        if (inputRef.value !== null && inputRef.value !== el && (el === null || el.id !== state2.targetUid.value)) {
          inputRef.value.focus({ preventScroll: true });
        }
      });
    }
    function select() {
      var _a;
      (_a = inputRef.value) == null ? void 0 : _a.select();
    }
    function onPaste(e3) {
      if (hasMask.value === true && props4.reverseFillMask !== true) {
        const inp = e3.target;
        moveCursorForPaste(inp, inp.selectionStart, inp.selectionEnd);
      }
      emit("paste", e3);
    }
    function onInput(e3) {
      if (!e3 || !e3.target) return;
      if (props4.type === "file") {
        emit("update:modelValue", e3.target.files);
        return;
      }
      const val = e3.target.value;
      if (e3.target.qComposing === true) {
        temp.value = val;
        return;
      }
      if (hasMask.value === true) {
        updateMaskValue(val, false, e3.inputType);
      } else {
        emitValue(val);
        if (isTypeText.value === true && e3.target === document.activeElement) {
          const { selectionStart, selectionEnd } = e3.target;
          if (selectionStart !== void 0 && selectionEnd !== void 0) {
            nextTick(() => {
              if (e3.target === document.activeElement && val.indexOf(e3.target.value) === 0) {
                e3.target.setSelectionRange(selectionStart, selectionEnd);
              }
            });
          }
        }
      }
      props4.autogrow === true && adjustHeight();
    }
    function onAnimationend(e3) {
      emit("animationend", e3);
      adjustHeight();
    }
    function emitValue(val, stopWatcher) {
      emitValueFn = () => {
        emitTimer = null;
        if (props4.type !== "number" && temp.hasOwnProperty("value") === true) {
          delete temp.value;
        }
        if (props4.modelValue !== val && emitCachedValue !== val) {
          emitCachedValue = val;
          stopWatcher === true && (stopValueWatcher = true);
          emit("update:modelValue", val);
          nextTick(() => {
            emitCachedValue === val && (emitCachedValue = NaN);
          });
        }
        emitValueFn = void 0;
      };
      if (props4.type === "number") {
        typedNumber = true;
        temp.value = val;
      }
      if (props4.debounce !== void 0) {
        emitTimer !== null && clearTimeout(emitTimer);
        temp.value = val;
        emitTimer = setTimeout(emitValueFn, props4.debounce);
      } else {
        emitValueFn();
      }
    }
    function adjustHeight() {
      requestAnimationFrame(() => {
        const inp = inputRef.value;
        if (inp !== null) {
          const parentStyle = inp.parentNode.style;
          const { scrollTop } = inp;
          const { overflowY, maxHeight } = $q.platform.is.firefox === true ? {} : window.getComputedStyle(inp);
          const changeOverflow = overflowY !== void 0 && overflowY !== "scroll";
          changeOverflow === true && (inp.style.overflowY = "hidden");
          parentStyle.marginBottom = inp.scrollHeight - 1 + "px";
          inp.style.height = "1px";
          inp.style.height = inp.scrollHeight + "px";
          changeOverflow === true && (inp.style.overflowY = parseInt(maxHeight, 10) < inp.scrollHeight ? "auto" : "hidden");
          parentStyle.marginBottom = "";
          inp.scrollTop = scrollTop;
        }
      });
    }
    function onChange(e3) {
      onComposition(e3);
      if (emitTimer !== null) {
        clearTimeout(emitTimer);
        emitTimer = null;
      }
      emitValueFn == null ? void 0 : emitValueFn();
      emit("change", e3.target.value);
    }
    function onFinishEditing(e3) {
      e3 !== void 0 && stop(e3);
      if (emitTimer !== null) {
        clearTimeout(emitTimer);
        emitTimer = null;
      }
      emitValueFn == null ? void 0 : emitValueFn();
      typedNumber = false;
      stopValueWatcher = false;
      delete temp.value;
      props4.type !== "file" && setTimeout(() => {
        if (inputRef.value !== null) {
          inputRef.value.value = innerValue.value !== void 0 ? innerValue.value : "";
        }
      });
    }
    function getCurValue() {
      return temp.hasOwnProperty("value") === true ? temp.value : innerValue.value !== void 0 ? innerValue.value : "";
    }
    onBeforeUnmount(() => {
      onFinishEditing();
    });
    onMounted(() => {
      props4.autogrow === true && adjustHeight();
    });
    Object.assign(state2, {
      innerValue,
      fieldClass: computed(
        () => `q-${isTextarea.value === true ? "textarea" : "input"}` + (props4.autogrow === true ? " q-textarea--autogrow" : "")
      ),
      hasShadow: computed(
        () => props4.type !== "file" && typeof props4.shadowText === "string" && props4.shadowText.length !== 0
      ),
      inputRef,
      emitValue,
      hasValue,
      floatingLabel: computed(
        () => hasValue.value === true && (props4.type !== "number" || isNaN(innerValue.value) === false) || fieldValueIsFilled(props4.displayValue)
      ),
      getControl: () => {
        return h(isTextarea.value === true ? "textarea" : "input", {
          ref: inputRef,
          class: [
            "q-field__native q-placeholder",
            props4.inputClass
          ],
          style: props4.inputStyle,
          ...inputAttrs.value,
          ...onEvents.value,
          ...props4.type !== "file" ? { value: getCurValue() } : formDomProps.value
        });
      },
      getShadowControl: () => {
        return h("div", {
          class: "q-field__native q-field__shadow absolute-bottom no-pointer-events" + (isTextarea.value === true ? "" : " text-no-wrap")
        }, [
          h("span", { class: "invisible" }, getCurValue()),
          h("span", props4.shadowText)
        ]);
      }
    });
    const renderFn = use_field_default(state2);
    Object.assign(proxy, {
      focus,
      select,
      getNativeElement: () => inputRef.value
      // deprecated
    });
    injectProp(proxy, "nativeEl", () => inputRef.value);
    return renderFn;
  }
});
var defaultCfg = {
  threshold: 0,
  root: null,
  rootMargin: "0px"
};
function update2(el, ctx, value2) {
  var _a;
  let handler, cfg, changed2;
  if (typeof value2 === "function") {
    handler = value2;
    cfg = defaultCfg;
    changed2 = ctx.cfg === void 0;
  } else {
    handler = value2.handler;
    cfg = Object.assign({}, defaultCfg, value2.cfg);
    changed2 = ctx.cfg === void 0 || isDeepEqual(ctx.cfg, cfg) === false;
  }
  if (ctx.handler !== handler) {
    ctx.handler = handler;
  }
  if (changed2 === true) {
    ctx.cfg = cfg;
    (_a = ctx.observer) == null ? void 0 : _a.unobserve(el);
    ctx.observer = new IntersectionObserver(([entry]) => {
      if (typeof ctx.handler === "function") {
        if (entry.rootBounds === null && document.body.contains(el) === true) {
          ctx.observer.unobserve(el);
          ctx.observer.observe(el);
          return;
        }
        const res = ctx.handler(entry, ctx.observer);
        if (res === false || ctx.once === true && entry.isIntersecting === true) {
          destroy(el);
        }
      }
    }, cfg);
    ctx.observer.observe(el);
  }
}
function destroy(el) {
  var _a;
  const ctx = el.__qvisible;
  if (ctx !== void 0) {
    (_a = ctx.observer) == null ? void 0 : _a.unobserve(el);
    delete el.__qvisible;
  }
}
var Intersection_default = createDirective(
  {
    name: "intersection",
    mounted(el, { modifiers, value: value2 }) {
      const ctx = {
        once: modifiers.once === true
      };
      update2(el, ctx, value2);
      el.__qvisible = ctx;
    },
    updated(el, binding) {
      const ctx = el.__qvisible;
      ctx !== void 0 && update2(el, ctx, binding.value);
    },
    beforeUnmount: destroy
  }
);
createComponent({
  name: "QIntersection",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    once: Boolean,
    transition: String,
    transitionDuration: {
      type: [String, Number],
      default: 300
    },
    ssrPrerender: Boolean,
    margin: String,
    threshold: [Number, Array],
    root: {
      default: null
    },
    disable: Boolean,
    onVisibility: Function
  },
  setup(props4, { slots, emit }) {
    const showing = ref$1(isRuntimeSsrPreHydration.value === true ? props4.ssrPrerender : false);
    const intersectionProps = computed(() => props4.root !== void 0 || props4.margin !== void 0 || props4.threshold !== void 0 ? {
      handler: trigger3,
      cfg: {
        root: props4.root,
        rootMargin: props4.margin,
        threshold: props4.threshold
      }
    } : trigger3);
    const hasDirective = computed(
      () => props4.disable !== true && (isRuntimeSsrPreHydration.value !== true || props4.once !== true || props4.ssrPrerender !== true)
    );
    const directives = computed(() => {
      return [[
        Intersection_default,
        intersectionProps.value,
        void 0,
        { once: props4.once }
      ]];
    });
    const transitionStyle = computed(
      () => `--q-transition-duration: ${props4.transitionDuration}ms`
    );
    function trigger3(entry) {
      if (showing.value !== entry.isIntersecting) {
        showing.value = entry.isIntersecting;
        props4.onVisibility !== void 0 && emit("visibility", showing.value);
      }
    }
    function getContent() {
      if (showing.value === true) {
        return [h("div", { key: "content", style: transitionStyle.value }, hSlot(slots.default))];
      }
      if (slots.hidden !== void 0) {
        return [h("div", { key: "hidden", style: transitionStyle.value }, slots.hidden())];
      }
    }
    return () => {
      const child = props4.transition ? [
        h(Transition, {
          name: "q-transition--" + props4.transition
        }, getContent)
      ] : getContent();
      return hDir(
        props4.tag,
        { class: "q-intersection" },
        child,
        "main",
        hasDirective.value,
        () => directives.value
      );
    };
  }
});
var roleAttrExceptions = ["ul", "ol"];
var QList_default = createComponent({
  name: "QList",
  props: {
    ...useDarkProps,
    bordered: Boolean,
    dense: Boolean,
    separator: Boolean,
    padding: Boolean,
    tag: {
      type: String,
      default: "div"
    }
  },
  setup(props4, { slots }) {
    const vm2 = getCurrentInstance();
    const isDark = use_dark_default(props4, vm2.proxy.$q);
    const role = computed(
      () => roleAttrExceptions.includes(props4.tag) ? null : "list"
    );
    const classes = computed(
      () => "q-list" + (props4.bordered === true ? " q-list--bordered" : "") + (props4.dense === true ? " q-list--dense" : "") + (props4.separator === true ? " q-list--separator" : "") + (isDark.value === true ? " q-list--dark" : "") + (props4.padding === true ? " q-list--padding" : "")
    );
    return () => h(props4.tag, { class: classes.value, role: role.value }, hSlot(slots.default));
  }
});
var keyCodes2 = [34, 37, 40, 33, 39, 38];
var commonPropsName = Object.keys(useCircularCommonProps);
createComponent({
  name: "QKnob",
  props: {
    ...useFormProps,
    ...useCircularCommonProps,
    modelValue: {
      type: Number,
      required: true
    },
    innerMin: Number,
    innerMax: Number,
    step: {
      type: Number,
      default: 1,
      validator: (v) => v >= 0
    },
    tabindex: {
      type: [Number, String],
      default: 0
    },
    disable: Boolean,
    readonly: Boolean
  },
  emits: ["update:modelValue", "change", "dragValue"],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const model = ref$1(props4.modelValue);
    const dragging = ref$1(false);
    const innerMin = computed(() => isNaN(props4.innerMin) === true || props4.innerMin < props4.min ? props4.min : props4.innerMin);
    const innerMax = computed(() => isNaN(props4.innerMax) === true || props4.innerMax > props4.max ? props4.max : props4.innerMax);
    let centerPosition;
    function normalizeModel() {
      model.value = props4.modelValue === null ? innerMin.value : between(props4.modelValue, innerMin.value, innerMax.value);
      updateValue2(true);
    }
    watch(
      () => `${props4.modelValue}|${innerMin.value}|${innerMax.value}`,
      normalizeModel
    );
    normalizeModel();
    const editable = computed(() => props4.disable === false && props4.readonly === false);
    const classes = computed(
      () => "q-knob non-selectable" + (editable.value === true ? " q-knob--editable" : props4.disable === true ? " disabled" : "")
    );
    const decimals = computed(() => (String(props4.step).trim().split(".")[1] || "").length);
    const step = computed(() => props4.step === 0 ? 1 : props4.step);
    const instantFeedback = computed(() => props4.instantFeedback === true || dragging.value === true);
    const onEvents = $q.platform.is.mobile === true ? computed(() => editable.value === true ? { onClick } : {}) : computed(() => editable.value === true ? {
      onMousedown,
      onClick,
      onKeydown: onKeydown2,
      onKeyup: onKeyup2
    } : {});
    const attrs = computed(() => editable.value === true ? { tabindex: props4.tabindex } : { [`aria-${props4.disable === true ? "disabled" : "readonly"}`]: "true" });
    const circularProps = computed(() => {
      const agg = {};
      commonPropsName.forEach((name2) => {
        agg[name2] = props4[name2];
      });
      return agg;
    });
    function pan(event) {
      if (event.isFinal) {
        updatePosition(event.evt, true);
        dragging.value = false;
      } else if (event.isFirst) {
        updateCenterPosition();
        dragging.value = true;
        updatePosition(event.evt);
      } else {
        updatePosition(event.evt);
      }
    }
    const directives = computed(() => {
      return [[
        TouchPan_default,
        pan,
        void 0,
        { prevent: true, stop: true, mouse: true }
      ]];
    });
    function updateCenterPosition() {
      const { top, left, width: width3, height: height2 } = proxy.$el.getBoundingClientRect();
      centerPosition = {
        top: top + height2 / 2,
        left: left + width3 / 2
      };
    }
    function onMousedown(evt) {
      updateCenterPosition();
      updatePosition(evt);
    }
    function onClick(evt) {
      updateCenterPosition();
      updatePosition(evt, true);
    }
    function onKeydown2(evt) {
      if (keyCodes2.includes(evt.keyCode) === false) return;
      stopAndPrevent(evt);
      const stepVal = ([34, 33].includes(evt.keyCode) ? 10 : 1) * step.value, offset2 = [34, 37, 40].includes(evt.keyCode) ? -stepVal : stepVal;
      model.value = between(
        parseFloat((model.value + offset2).toFixed(decimals.value)),
        innerMin.value,
        innerMax.value
      );
      updateValue2();
    }
    function updatePosition(evt, change) {
      const pos = position(evt), height2 = Math.abs(pos.top - centerPosition.top), distance = Math.sqrt(
        height2 ** 2 + Math.abs(pos.left - centerPosition.left) ** 2
      );
      let angle2 = Math.asin(height2 / distance) * (180 / Math.PI);
      if (pos.top < centerPosition.top) {
        angle2 = centerPosition.left < pos.left ? 90 - angle2 : 270 + angle2;
      } else {
        angle2 = centerPosition.left < pos.left ? angle2 + 90 : 270 - angle2;
      }
      if ($q.lang.rtl === true) {
        angle2 = normalizeToInterval(-angle2 - props4.angle, 0, 360);
      } else if (props4.angle) {
        angle2 = normalizeToInterval(angle2 - props4.angle, 0, 360);
      }
      if (props4.reverse === true) {
        angle2 = 360 - angle2;
      }
      let newModel = props4.min + angle2 / 360 * (props4.max - props4.min);
      if (step.value !== 0) {
        const modulo = newModel % step.value;
        newModel = newModel - modulo + (Math.abs(modulo) >= step.value / 2 ? (modulo < 0 ? -1 : 1) * step.value : 0);
        newModel = parseFloat(newModel.toFixed(decimals.value));
      }
      newModel = between(newModel, innerMin.value, innerMax.value);
      emit("dragValue", newModel);
      if (model.value !== newModel) {
        model.value = newModel;
      }
      updateValue2(change);
    }
    function onKeyup2(evt) {
      if (keyCodes2.includes(evt.keyCode)) {
        updateValue2(true);
      }
    }
    function updateValue2(change) {
      props4.modelValue !== model.value && emit("update:modelValue", model.value);
      change === true && emit("change", model.value);
    }
    const formAttrs = useFormAttrs(props4);
    function getNameInput() {
      return h("input", formAttrs.value);
    }
    return () => {
      const data = {
        class: classes.value,
        role: "slider",
        "aria-valuemin": innerMin.value,
        "aria-valuemax": innerMax.value,
        "aria-valuenow": props4.modelValue,
        ...attrs.value,
        ...circularProps.value,
        value: model.value,
        instantFeedback: instantFeedback.value,
        ...onEvents.value
      };
      const child = {
        default: slots.default
      };
      if (editable.value === true && props4.name !== void 0) {
        child.internal = getNameInput;
      }
      return hDir(
        QCircularProgress_default,
        data,
        child,
        "knob",
        editable.value,
        () => directives.value
      );
    };
  }
});
var { passive: passive3 } = listenOpts;
var axisValues = ["both", "horizontal", "vertical"];
var QScrollObserver_default = createComponent({
  name: "QScrollObserver",
  props: {
    axis: {
      type: String,
      validator: (v) => axisValues.includes(v),
      default: "vertical"
    },
    debounce: [String, Number],
    scrollTarget: scrollTargetProp
  },
  emits: ["scroll"],
  setup(props4, { emit }) {
    const scroll = {
      position: {
        top: 0,
        left: 0
      },
      direction: "down",
      directionChanged: false,
      delta: {
        top: 0,
        left: 0
      },
      inflectionPoint: {
        top: 0,
        left: 0
      }
    };
    let clearTimer = null, localScrollTarget, parentEl;
    watch(() => props4.scrollTarget, () => {
      unconfigureScrollTarget();
      configureScrollTarget();
    });
    function emitEvent() {
      clearTimer == null ? void 0 : clearTimer();
      const top = Math.max(0, getVerticalScrollPosition(localScrollTarget));
      const left = getHorizontalScrollPosition(localScrollTarget);
      const delta = {
        top: top - scroll.position.top,
        left: left - scroll.position.left
      };
      if (props4.axis === "vertical" && delta.top === 0 || props4.axis === "horizontal" && delta.left === 0) return;
      const curDir = Math.abs(delta.top) >= Math.abs(delta.left) ? delta.top < 0 ? "up" : "down" : delta.left < 0 ? "left" : "right";
      scroll.position = { top, left };
      scroll.directionChanged = scroll.direction !== curDir;
      scroll.delta = delta;
      if (scroll.directionChanged === true) {
        scroll.direction = curDir;
        scroll.inflectionPoint = scroll.position;
      }
      emit("scroll", { ...scroll });
    }
    function configureScrollTarget() {
      localScrollTarget = getScrollTarget(parentEl, props4.scrollTarget);
      localScrollTarget.addEventListener("scroll", trigger3, passive3);
      trigger3(true);
    }
    function unconfigureScrollTarget() {
      if (localScrollTarget !== void 0) {
        localScrollTarget.removeEventListener("scroll", trigger3, passive3);
        localScrollTarget = void 0;
      }
    }
    function trigger3(immediately) {
      if (immediately === true || props4.debounce === 0 || props4.debounce === "0") {
        emitEvent();
      } else if (clearTimer === null) {
        const [timer2, fn] = props4.debounce ? [setTimeout(emitEvent, props4.debounce), clearTimeout] : [requestAnimationFrame(emitEvent), cancelAnimationFrame];
        clearTimer = () => {
          fn(timer2);
          clearTimer = null;
        };
      }
    }
    const { proxy } = getCurrentInstance();
    watch(() => proxy.$q.lang.rtl, emitEvent);
    onMounted(() => {
      parentEl = proxy.$el.parentNode;
      configureScrollTarget();
    });
    onBeforeUnmount(() => {
      clearTimer == null ? void 0 : clearTimer();
      unconfigureScrollTarget();
    });
    Object.assign(proxy, {
      trigger: trigger3,
      getPosition: () => scroll
    });
    return noop;
  }
});
createComponent({
  name: "QLayout",
  props: {
    container: Boolean,
    view: {
      type: String,
      default: "hhh lpr fff",
      validator: (v) => /^(h|l)h(h|r) lpr (f|l)f(f|r)$/.test(v.toLowerCase())
    },
    onScroll: Function,
    onScrollHeight: Function,
    onResize: Function
  },
  setup(props4, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const rootRef = ref$1(null);
    const height2 = ref$1($q.screen.height);
    const width3 = ref$1(props4.container === true ? 0 : $q.screen.width);
    const scroll = ref$1({ position: 0, direction: "down", inflectionPoint: 0 });
    const containerHeight = ref$1(0);
    const scrollbarWidth = ref$1(isRuntimeSsrPreHydration.value === true ? 0 : getScrollbarWidth());
    const classes = computed(
      () => "q-layout q-layout--" + (props4.container === true ? "containerized" : "standard")
    );
    const style2 = computed(() => props4.container === false ? { minHeight: $q.screen.height + "px" } : null);
    const targetStyle = computed(() => scrollbarWidth.value !== 0 ? { [$q.lang.rtl === true ? "left" : "right"]: `${scrollbarWidth.value}px` } : null);
    const targetChildStyle = computed(() => scrollbarWidth.value !== 0 ? {
      [$q.lang.rtl === true ? "right" : "left"]: 0,
      [$q.lang.rtl === true ? "left" : "right"]: `-${scrollbarWidth.value}px`,
      width: `calc(100% + ${scrollbarWidth.value}px)`
    } : null);
    function onPageScroll(data) {
      if (props4.container === true || document.qScrollPrevented !== true) {
        const info = {
          position: data.position.top,
          direction: data.direction,
          directionChanged: data.directionChanged,
          inflectionPoint: data.inflectionPoint.top,
          delta: data.delta.top
        };
        scroll.value = info;
        props4.onScroll !== void 0 && emit("scroll", info);
      }
    }
    function onPageResize(data) {
      const { height: newHeight, width: newWidth } = data;
      let resized = false;
      if (height2.value !== newHeight) {
        resized = true;
        height2.value = newHeight;
        props4.onScrollHeight !== void 0 && emit("scrollHeight", newHeight);
        updateScrollbarWidth();
      }
      if (width3.value !== newWidth) {
        resized = true;
        width3.value = newWidth;
      }
      if (resized === true && props4.onResize !== void 0) {
        emit("resize", data);
      }
    }
    function onContainerResize({ height: height3 }) {
      if (containerHeight.value !== height3) {
        containerHeight.value = height3;
        updateScrollbarWidth();
      }
    }
    function updateScrollbarWidth() {
      if (props4.container === true) {
        const width4 = height2.value > containerHeight.value ? getScrollbarWidth() : 0;
        if (scrollbarWidth.value !== width4) {
          scrollbarWidth.value = width4;
        }
      }
    }
    let animateTimer = null;
    const $layout = {
      instances: {},
      view: computed(() => props4.view),
      isContainer: computed(() => props4.container),
      rootRef,
      height: height2,
      containerHeight,
      scrollbarWidth,
      totalWidth: computed(() => width3.value + scrollbarWidth.value),
      rows: computed(() => {
        const rows = props4.view.toLowerCase().split(" ");
        return {
          top: rows[0].split(""),
          middle: rows[1].split(""),
          bottom: rows[2].split("")
        };
      }),
      header: reactive({ size: 0, offset: 0, space: false }),
      right: reactive({ size: 300, offset: 0, space: false }),
      footer: reactive({ size: 0, offset: 0, space: false }),
      left: reactive({ size: 300, offset: 0, space: false }),
      scroll,
      animate() {
        if (animateTimer !== null) {
          clearTimeout(animateTimer);
        } else {
          document.body.classList.add("q-body--layout-animate");
        }
        animateTimer = setTimeout(() => {
          animateTimer = null;
          document.body.classList.remove("q-body--layout-animate");
        }, 155);
      },
      update(part, prop, val) {
        $layout[part][prop] = val;
      }
    };
    provide(layoutKey, $layout);
    if (getScrollbarWidth() > 0) {
      let restoreScrollbar = function() {
        timer2 = null;
        el.classList.remove("hide-scrollbar");
      }, hideScrollbar = function() {
        if (timer2 === null) {
          if (el.scrollHeight > $q.screen.height) return;
          el.classList.add("hide-scrollbar");
        } else {
          clearTimeout(timer2);
        }
        timer2 = setTimeout(restoreScrollbar, 300);
      }, updateScrollEvent = function(action) {
        if (timer2 !== null && action === "remove") {
          clearTimeout(timer2);
          restoreScrollbar();
        }
        window[`${action}EventListener`]("resize", hideScrollbar);
      };
      let timer2 = null;
      const el = document.body;
      watch(
        () => props4.container !== true ? "add" : "remove",
        updateScrollEvent
      );
      props4.container !== true && updateScrollEvent("add");
      onUnmounted(() => {
        updateScrollEvent("remove");
      });
    }
    return () => {
      const content = hMergeSlot(slots.default, [
        h(QScrollObserver_default, { onScroll: onPageScroll }),
        h(QResizeObserver_default, { onResize: onPageResize })
      ]);
      const layout = h("div", {
        class: classes.value,
        style: style2.value,
        ref: props4.container === true ? void 0 : rootRef,
        tabindex: -1
      }, content);
      if (props4.container === true) {
        return h("div", {
          class: "q-layout-container overflow-hidden",
          ref: rootRef
        }, [
          h(QResizeObserver_default, { onResize: onContainerResize }),
          h("div", {
            class: "absolute-full",
            style: targetStyle.value
          }, [
            h("div", {
              class: "scroll",
              style: targetChildStyle.value
            }, [layout])
          ])
        ]);
      }
      return layout;
    };
  }
});
var separatorValues = ["horizontal", "vertical", "cell", "none"];
var QMarkupTable_default = createComponent({
  name: "QMarkupTable",
  props: {
    ...useDarkProps,
    dense: Boolean,
    flat: Boolean,
    bordered: Boolean,
    square: Boolean,
    wrapCells: Boolean,
    separator: {
      type: String,
      default: "horizontal",
      validator: (v) => separatorValues.includes(v)
    }
  },
  setup(props4, { slots }) {
    const vm2 = getCurrentInstance();
    const isDark = use_dark_default(props4, vm2.proxy.$q);
    const classes = computed(
      () => `q-markup-table q-table__container q-table__card q-table--${props4.separator}-separator` + (isDark.value === true ? " q-table--dark q-table__card--dark q-dark" : "") + (props4.dense === true ? " q-table--dense" : "") + (props4.flat === true ? " q-table--flat" : "") + (props4.bordered === true ? " q-table--bordered" : "") + (props4.square === true ? " q-table--square" : "") + (props4.wrapCells === false ? " q-table--no-wrap" : "")
    );
    return () => h("div", {
      class: classes.value
    }, [
      h("table", { class: "q-table" }, hSlot(slots.default))
    ]);
  }
});
createComponent({
  name: "QNoSsr",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    placeholder: String
  },
  setup(props4, { slots }) {
    const { isHydrated } = use_hydration_default();
    return () => {
      if (isHydrated.value === true) {
        const node2 = hSlot(slots.default);
        return node2 === void 0 ? node2 : node2.length > 1 ? h(props4.tag, {}, node2) : node2[0];
      }
      const data = {
        class: "q-no-ssr-placeholder"
      };
      const node = hSlot(slots.placeholder);
      if (node !== void 0) {
        return node.length > 1 ? h(props4.tag, data, node) : node[0];
      }
      if (props4.placeholder !== void 0) {
        return h(props4.tag, data, props4.placeholder);
      }
    };
  }
});
var createSvg = () => h("svg", {
  key: "svg",
  class: "q-radio__bg absolute non-selectable",
  viewBox: "0 0 24 24"
}, [
  h("path", {
    d: "M12,22a10,10 0 0 1 -10,-10a10,10 0 0 1 10,-10a10,10 0 0 1 10,10a10,10 0 0 1 -10,10m0,-22a12,12 0 0 0 -12,12a12,12 0 0 0 12,12a12,12 0 0 0 12,-12a12,12 0 0 0 -12,-12"
  }),
  h("path", {
    class: "q-radio__check",
    d: "M12,6a6,6 0 0 0 -6,6a6,6 0 0 0 6,6a6,6 0 0 0 6,-6a6,6 0 0 0 -6,-6"
  })
]);
var QRadio_default = createComponent({
  name: "QRadio",
  props: {
    ...useDarkProps,
    ...useSizeProps,
    ...useFormProps,
    modelValue: { required: true },
    val: { required: true },
    label: String,
    leftLabel: Boolean,
    checkedIcon: String,
    uncheckedIcon: String,
    color: String,
    keepColor: Boolean,
    dense: Boolean,
    disable: Boolean,
    tabindex: [String, Number]
  },
  emits: ["update:modelValue"],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const isDark = use_dark_default(props4, proxy.$q);
    const sizeStyle = use_size_default(props4, option_sizes_default);
    const rootRef = ref$1(null);
    const { refocusTargetEl, refocusTarget } = use_refocus_target_default(props4, rootRef);
    const isTrue = computed(() => toRaw(props4.modelValue) === toRaw(props4.val));
    const classes = computed(
      () => "q-radio cursor-pointer no-outline row inline no-wrap items-center" + (props4.disable === true ? " disabled" : "") + (isDark.value === true ? " q-radio--dark" : "") + (props4.dense === true ? " q-radio--dense" : "") + (props4.leftLabel === true ? " reverse" : "")
    );
    const innerClass = computed(() => {
      const color2 = props4.color !== void 0 && (props4.keepColor === true || isTrue.value === true) ? ` text-${props4.color}` : "";
      return `q-radio__inner relative-position q-radio__inner--${isTrue.value === true ? "truthy" : "falsy"}${color2}`;
    });
    const icon = computed(
      () => (isTrue.value === true ? props4.checkedIcon : props4.uncheckedIcon) || null
    );
    const tabindex = computed(() => props4.disable === true ? -1 : props4.tabindex || 0);
    const formAttrs = computed(() => {
      const prop = { type: "radio" };
      props4.name !== void 0 && Object.assign(prop, {
        // see https://vuejs.org/guide/extras/render-function.html#creating-vnodes (.prop)
        ".checked": isTrue.value === true,
        "^checked": isTrue.value === true ? "checked" : void 0,
        name: props4.name,
        value: props4.val
      });
      return prop;
    });
    const injectFormInput = useFormInject(formAttrs);
    function onClick(e3) {
      if (e3 !== void 0) {
        stopAndPrevent(e3);
        refocusTarget(e3);
      }
      if (props4.disable !== true && isTrue.value !== true) {
        emit("update:modelValue", props4.val, e3);
      }
    }
    function onKeydown2(e3) {
      if (e3.keyCode === 13 || e3.keyCode === 32) {
        stopAndPrevent(e3);
      }
    }
    function onKeyup2(e3) {
      if (e3.keyCode === 13 || e3.keyCode === 32) {
        onClick(e3);
      }
    }
    Object.assign(proxy, { set: onClick });
    const svg2 = createSvg();
    return () => {
      const content = icon.value !== null ? [
        h("div", {
          key: "icon",
          class: "q-radio__icon-container absolute-full flex flex-center no-wrap"
        }, [
          h(QIcon_default, {
            class: "q-radio__icon",
            name: icon.value
          })
        ])
      ] : [svg2];
      props4.disable !== true && injectFormInput(
        content,
        "unshift",
        " q-radio__native q-ma-none q-pa-none"
      );
      const child = [
        h("div", {
          class: innerClass.value,
          style: sizeStyle.value,
          "aria-hidden": "true"
        }, content)
      ];
      if (refocusTargetEl.value !== null) {
        child.push(refocusTargetEl.value);
      }
      const label = props4.label !== void 0 ? hMergeSlot(slots.default, [props4.label]) : hSlot(slots.default);
      label !== void 0 && child.push(
        h("div", {
          class: "q-radio__label q-anchor--skip"
        }, label)
      );
      return h("div", {
        ref: rootRef,
        class: classes.value,
        tabindex: tabindex.value,
        role: "radio",
        "aria-label": props4.label,
        "aria-checked": isTrue.value === true ? "true" : "false",
        "aria-disabled": props4.disable === true ? "true" : void 0,
        onClick,
        onKeydown: onKeydown2,
        onKeyup: onKeyup2
      }, child);
    };
  }
});
var QToggle_default = createComponent({
  name: "QToggle",
  props: {
    ...useCheckboxProps,
    icon: String,
    iconColor: String
  },
  emits: useCheckboxEmits,
  setup(props4) {
    function getInner(isTrue, isIndeterminate) {
      const icon = computed(
        () => (isTrue.value === true ? props4.checkedIcon : isIndeterminate.value === true ? props4.indeterminateIcon : props4.uncheckedIcon) || props4.icon
      );
      const color2 = computed(() => isTrue.value === true ? props4.iconColor : null);
      return () => [
        h("div", { class: "q-toggle__track" }),
        h(
          "div",
          {
            class: "q-toggle__thumb absolute flex flex-center no-wrap"
          },
          icon.value !== void 0 ? [
            h(QIcon_default, {
              name: icon.value,
              color: color2.value
            })
          ] : void 0
        )
      ];
    }
    return use_checkbox_default("toggle", getInner);
  }
});
var components$1 = {
  radio: QRadio_default,
  checkbox: QCheckbox_default,
  toggle: QToggle_default
};
var typeValues = Object.keys(components$1);
function getPropValueFn(userPropName, defaultPropName) {
  if (typeof userPropName === "function") return userPropName;
  const propName = userPropName !== void 0 ? userPropName : defaultPropName;
  return (opt) => opt[propName];
}
var QOptionGroup_default = createComponent({
  name: "QOptionGroup",
  props: {
    ...useDarkProps,
    modelValue: {
      required: true
    },
    options: {
      type: Array,
      validator: (opts) => opts.every(isObject),
      default: () => []
    },
    optionValue: [Function, String],
    optionLabel: [Function, String],
    optionDisable: [Function, String],
    name: String,
    type: {
      type: String,
      default: "radio",
      validator: (v) => typeValues.includes(v)
    },
    color: String,
    keepColor: Boolean,
    dense: Boolean,
    size: String,
    leftLabel: Boolean,
    inline: Boolean,
    disable: Boolean
  },
  emits: ["update:modelValue"],
  setup(props4, { emit, slots }) {
    const { proxy: { $q } } = getCurrentInstance();
    const arrayModel = Array.isArray(props4.modelValue);
    if (props4.type === "radio") {
      if (arrayModel === true) {
        console.error("q-option-group: model should not be array");
      }
    } else if (arrayModel === false) {
      console.error("q-option-group: model should be array in your case");
    }
    const isDark = use_dark_default(props4, $q);
    const component = computed(() => components$1[props4.type]);
    const getOptionValue = computed(() => getPropValueFn(props4.optionValue, "value"));
    const getOptionLabel = computed(() => getPropValueFn(props4.optionLabel, "label"));
    const getOptionDisable = computed(() => getPropValueFn(props4.optionDisable, "disable"));
    const innerOptions = computed(() => props4.options.map((opt) => ({
      val: getOptionValue.value(opt),
      name: opt.name === void 0 ? props4.name : opt.name,
      disable: props4.disable || getOptionDisable.value(opt),
      leftLabel: opt.leftLabel === void 0 ? props4.leftLabel : opt.leftLabel,
      color: opt.color === void 0 ? props4.color : opt.color,
      checkedIcon: opt.checkedIcon,
      uncheckedIcon: opt.uncheckedIcon,
      dark: opt.dark === void 0 ? isDark.value : opt.dark,
      size: opt.size === void 0 ? props4.size : opt.size,
      dense: props4.dense,
      keepColor: opt.keepColor === void 0 ? props4.keepColor : opt.keepColor
    })));
    const classes = computed(
      () => "q-option-group q-gutter-x-sm" + (props4.inline === true ? " q-option-group--inline" : "")
    );
    const attrs = computed(() => {
      const attrs2 = { role: "group" };
      if (props4.type === "radio") {
        attrs2.role = "radiogroup";
        if (props4.disable === true) {
          attrs2["aria-disabled"] = "true";
        }
      }
      return attrs2;
    });
    function onUpdateModelValue(value2) {
      emit("update:modelValue", value2);
    }
    return () => h("div", {
      class: classes.value,
      ...attrs.value
    }, props4.options.map((opt, i3) => {
      const child = slots["label-" + i3] !== void 0 ? () => slots["label-" + i3](opt) : slots.label !== void 0 ? () => slots.label(opt) : void 0;
      return h("div", [
        h(component.value, {
          label: child === void 0 ? getOptionLabel.value(opt) : null,
          modelValue: props4.modelValue,
          "onUpdate:modelValue": onUpdateModelValue,
          ...innerOptions.value[i3]
        }, child)
      ]);
    }));
  }
});
createComponent({
  name: "QPage",
  props: {
    padding: Boolean,
    styleFn: Function
  },
  setup(props4, { slots }) {
    const { proxy: { $q } } = getCurrentInstance();
    const $layout = inject(layoutKey, emptyRenderFn);
    if ($layout === emptyRenderFn) {
      console.error("QPage needs to be a deep child of QLayout");
      return emptyRenderFn;
    }
    const $pageContainer = inject(pageContainerKey, emptyRenderFn);
    if ($pageContainer === emptyRenderFn) {
      console.error("QPage needs to be child of QPageContainer");
      return emptyRenderFn;
    }
    const style2 = computed(() => {
      const offset2 = ($layout.header.space === true ? $layout.header.size : 0) + ($layout.footer.space === true ? $layout.footer.size : 0);
      if (typeof props4.styleFn === "function") {
        const height2 = $layout.isContainer.value === true ? $layout.containerHeight.value : $q.screen.height;
        return props4.styleFn(offset2, height2);
      }
      return {
        minHeight: $layout.isContainer.value === true ? $layout.containerHeight.value - offset2 + "px" : $q.screen.height === 0 ? offset2 !== 0 ? `calc(100vh - ${offset2}px)` : "100vh" : $q.screen.height - offset2 + "px"
      };
    });
    const classes = computed(
      () => `q-page${props4.padding === true ? " q-layout-padding" : ""}`
    );
    return () => h("main", {
      class: classes.value,
      style: style2.value
    }, hSlot(slots.default));
  }
});
createComponent({
  name: "QPageContainer",
  setup(_, { slots }) {
    const { proxy: { $q } } = getCurrentInstance();
    const $layout = inject(layoutKey, emptyRenderFn);
    if ($layout === emptyRenderFn) {
      console.error("QPageContainer needs to be child of QLayout");
      return emptyRenderFn;
    }
    provide(pageContainerKey, true);
    const style2 = computed(() => {
      const css2 = {};
      if ($layout.header.space === true) {
        css2.paddingTop = `${$layout.header.size}px`;
      }
      if ($layout.right.space === true) {
        css2[`padding${$q.lang.rtl === true ? "Left" : "Right"}`] = `${$layout.right.size}px`;
      }
      if ($layout.footer.space === true) {
        css2.paddingBottom = `${$layout.footer.size}px`;
      }
      if ($layout.left.space === true) {
        css2[`padding${$q.lang.rtl === true ? "Right" : "Left"}`] = `${$layout.left.size}px`;
      }
      return css2;
    });
    return () => h("div", {
      class: "q-page-container",
      style: style2.value
    }, hSlot(slots.default));
  }
});
var usePageStickyProps = {
  position: {
    type: String,
    default: "bottom-right",
    validator: (v) => [
      "top-right",
      "top-left",
      "bottom-right",
      "bottom-left",
      "top",
      "right",
      "bottom",
      "left"
    ].includes(v)
  },
  offset: {
    type: Array,
    validator: (v) => v.length === 2
  },
  expand: Boolean
};
function use_page_sticky_default() {
  const { props: props4, proxy: { $q } } = getCurrentInstance();
  const $layout = inject(layoutKey, emptyRenderFn);
  if ($layout === emptyRenderFn) {
    console.error("QPageSticky needs to be child of QLayout");
    return emptyRenderFn;
  }
  const attach = computed(() => {
    const pos = props4.position;
    return {
      top: pos.indexOf("top") !== -1,
      right: pos.indexOf("right") !== -1,
      bottom: pos.indexOf("bottom") !== -1,
      left: pos.indexOf("left") !== -1,
      vertical: pos === "top" || pos === "bottom",
      horizontal: pos === "left" || pos === "right"
    };
  });
  const top = computed(() => $layout.header.offset);
  const right = computed(() => $layout.right.offset);
  const bottom = computed(() => $layout.footer.offset);
  const left = computed(() => $layout.left.offset);
  const style2 = computed(() => {
    let posX = 0, posY = 0;
    const side = attach.value;
    const dir = $q.lang.rtl === true ? -1 : 1;
    if (side.top === true && top.value !== 0) {
      posY = `${top.value}px`;
    } else if (side.bottom === true && bottom.value !== 0) {
      posY = `${-bottom.value}px`;
    }
    if (side.left === true && left.value !== 0) {
      posX = `${dir * left.value}px`;
    } else if (side.right === true && right.value !== 0) {
      posX = `${-dir * right.value}px`;
    }
    const css2 = { transform: `translate(${posX}, ${posY})` };
    if (props4.offset) {
      css2.margin = `${props4.offset[1]}px ${props4.offset[0]}px`;
    }
    if (side.vertical === true) {
      if (left.value !== 0) {
        css2[$q.lang.rtl === true ? "right" : "left"] = `${left.value}px`;
      }
      if (right.value !== 0) {
        css2[$q.lang.rtl === true ? "left" : "right"] = `${right.value}px`;
      }
    } else if (side.horizontal === true) {
      if (top.value !== 0) {
        css2.top = `${top.value}px`;
      }
      if (bottom.value !== 0) {
        css2.bottom = `${bottom.value}px`;
      }
    }
    return css2;
  });
  const classes = computed(
    () => `q-page-sticky row flex-center fixed-${props4.position} q-page-sticky--${props4.expand === true ? "expand" : "shrink"}`
  );
  function getStickyContent(slots) {
    const content = hSlot(slots.default);
    return h(
      "div",
      {
        class: classes.value,
        style: style2.value
      },
      props4.expand === true ? content : [h("div", content)]
    );
  }
  return {
    $layout,
    getStickyContent
  };
}
createComponent({
  name: "QPageScroller",
  props: {
    ...usePageStickyProps,
    scrollOffset: {
      type: Number,
      default: 1e3
    },
    reverse: Boolean,
    duration: {
      type: Number,
      default: 300
    },
    offset: {
      ...usePageStickyProps.offset,
      default: () => [18, 18]
    }
  },
  emits: ["click"],
  setup(props4, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const { $layout, getStickyContent } = use_page_sticky_default();
    const rootRef = ref$1(null);
    let heightWatcher;
    const scrollHeight = computed(() => $layout.height.value - ($layout.isContainer.value === true ? $layout.containerHeight.value : $q.screen.height));
    function isVisible() {
      return props4.reverse === true ? scrollHeight.value - $layout.scroll.value.position > props4.scrollOffset : $layout.scroll.value.position > props4.scrollOffset;
    }
    const showing = ref$1(isVisible());
    function updateVisibility() {
      const newVal = isVisible();
      if (showing.value !== newVal) {
        showing.value = newVal;
      }
    }
    function updateReverse() {
      if (props4.reverse === true) {
        if (heightWatcher === void 0) {
          heightWatcher = watch(scrollHeight, updateVisibility);
        }
      } else {
        cleanup();
      }
    }
    watch($layout.scroll, updateVisibility);
    watch(() => props4.reverse, updateReverse);
    function cleanup() {
      if (heightWatcher !== void 0) {
        heightWatcher();
        heightWatcher = void 0;
      }
    }
    function onClick(e3) {
      const target2 = getScrollTarget(
        $layout.isContainer.value === true ? rootRef.value : $layout.rootRef.value
      );
      setVerticalScrollPosition(
        target2,
        props4.reverse === true ? $layout.height.value : 0,
        props4.duration
      );
      emit("click", e3);
    }
    function getContent() {
      return showing.value === true ? h("div", {
        ref: rootRef,
        class: "q-page-scroller",
        onClick
      }, getStickyContent(slots)) : null;
    }
    updateReverse();
    onBeforeUnmount(cleanup);
    return () => h(
      Transition,
      { name: "q-transition--fade" },
      getContent
    );
  }
});
createComponent({
  name: "QPageSticky",
  props: usePageStickyProps,
  setup(_, { slots }) {
    const { getStickyContent } = use_page_sticky_default();
    return () => getStickyContent(slots);
  }
});
function getBool(val, otherwise) {
  return [true, false].includes(val) ? val : otherwise;
}
createComponent({
  name: "QPagination",
  props: {
    ...useDarkProps,
    modelValue: {
      type: Number,
      required: true
    },
    min: {
      type: [Number, String],
      default: 1
    },
    max: {
      type: [Number, String],
      required: true
    },
    maxPages: {
      type: [Number, String],
      default: 0,
      validator: (v) => (typeof v === "string" ? parseInt(v, 10) : v) >= 0
    },
    inputStyle: [Array, String, Object],
    inputClass: [Array, String, Object],
    size: String,
    disable: Boolean,
    input: Boolean,
    iconPrev: String,
    iconNext: String,
    iconFirst: String,
    iconLast: String,
    toFn: Function,
    boundaryLinks: {
      type: Boolean,
      default: null
    },
    boundaryNumbers: {
      type: Boolean,
      default: null
    },
    directionLinks: {
      type: Boolean,
      default: null
    },
    ellipses: {
      type: Boolean,
      default: null
    },
    ripple: {
      type: [Boolean, Object],
      default: null
    },
    round: Boolean,
    rounded: Boolean,
    flat: Boolean,
    outline: Boolean,
    unelevated: Boolean,
    push: Boolean,
    glossy: Boolean,
    color: {
      type: String,
      default: "primary"
    },
    textColor: String,
    activeDesign: {
      type: String,
      default: "",
      values: (v) => v === "" || btnDesignOptions.includes(v)
    },
    activeColor: String,
    activeTextColor: String,
    gutter: String,
    padding: {
      type: String,
      default: "3px 2px"
    }
  },
  emits: ["update:modelValue"],
  setup(props4, { emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const isDark = use_dark_default(props4, $q);
    const minProp = computed(() => parseInt(props4.min, 10));
    const maxProp = computed(() => parseInt(props4.max, 10));
    const maxPagesProp = computed(() => parseInt(props4.maxPages, 10));
    const inputPlaceholder = computed(() => model.value + " / " + maxProp.value);
    const boundaryLinksProp = computed(() => getBool(props4.boundaryLinks, props4.input));
    const boundaryNumbersProp = computed(() => getBool(props4.boundaryNumbers, !props4.input));
    const directionLinksProp = computed(() => getBool(props4.directionLinks, props4.input));
    const ellipsesProp = computed(() => getBool(props4.ellipses, !props4.input));
    const newPage = ref$1(null);
    const model = computed({
      get: () => props4.modelValue,
      set: (val) => {
        val = parseInt(val, 10);
        if (props4.disable || isNaN(val)) return;
        const value2 = between(val, minProp.value, maxProp.value);
        if (props4.modelValue !== value2) {
          emit("update:modelValue", value2);
        }
      }
    });
    watch(() => `${minProp.value}|${maxProp.value}`, () => {
      model.value = props4.modelValue;
    });
    const classes = computed(
      () => "q-pagination row no-wrap items-center" + (props4.disable === true ? " disabled" : "")
    );
    const gutterProp = computed(() => props4.gutter in btnPadding ? `${btnPadding[props4.gutter]}px` : props4.gutter || null);
    const gutterStyle = computed(() => gutterProp.value !== null ? `--q-pagination-gutter-parent:-${gutterProp.value};--q-pagination-gutter-child:${gutterProp.value}` : null);
    const icons = computed(() => {
      const ico = [
        props4.iconFirst || $q.iconSet.pagination.first,
        props4.iconPrev || $q.iconSet.pagination.prev,
        props4.iconNext || $q.iconSet.pagination.next,
        props4.iconLast || $q.iconSet.pagination.last
      ];
      return $q.lang.rtl === true ? ico.reverse() : ico;
    });
    const attrs = computed(() => ({
      "aria-disabled": props4.disable === true ? "true" : "false",
      role: "navigation"
    }));
    const btnDesignProp = computed(() => getBtnDesign(props4, "flat"));
    const btnProps = computed(() => ({
      [btnDesignProp.value]: true,
      round: props4.round,
      rounded: props4.rounded,
      padding: props4.padding,
      color: props4.color,
      textColor: props4.textColor,
      size: props4.size,
      ripple: props4.ripple !== null ? props4.ripple : true
    }));
    const btnActiveDesignProp = computed(() => {
      const acc = { [btnDesignProp.value]: false };
      if (props4.activeDesign !== "") {
        acc[props4.activeDesign] = true;
      }
      return acc;
    });
    const activeBtnProps = computed(() => ({
      ...btnActiveDesignProp.value,
      color: props4.activeColor || props4.color,
      textColor: props4.activeTextColor || props4.textColor
    }));
    const btnConfig = computed(() => {
      let maxPages = Math.max(
        maxPagesProp.value,
        1 + (ellipsesProp.value ? 2 : 0) + (boundaryNumbersProp.value ? 2 : 0)
      );
      const acc = {
        pgFrom: minProp.value,
        pgTo: maxProp.value,
        ellipsesStart: false,
        ellipsesEnd: false,
        boundaryStart: false,
        boundaryEnd: false,
        marginalStyle: {
          minWidth: `${Math.max(2, String(maxProp.value).length)}em`
        }
      };
      if (maxPagesProp.value && maxPages < maxProp.value - minProp.value + 1) {
        maxPages = 1 + Math.floor(maxPages / 2) * 2;
        acc.pgFrom = Math.max(minProp.value, Math.min(maxProp.value - maxPages + 1, props4.modelValue - Math.floor(maxPages / 2)));
        acc.pgTo = Math.min(maxProp.value, acc.pgFrom + maxPages - 1);
        if (boundaryNumbersProp.value) {
          acc.boundaryStart = true;
          acc.pgFrom++;
        }
        if (ellipsesProp.value && acc.pgFrom > minProp.value + (boundaryNumbersProp.value ? 1 : 0)) {
          acc.ellipsesStart = true;
          acc.pgFrom++;
        }
        if (boundaryNumbersProp.value) {
          acc.boundaryEnd = true;
          acc.pgTo--;
        }
        if (ellipsesProp.value && acc.pgTo < maxProp.value - (boundaryNumbersProp.value ? 1 : 0)) {
          acc.ellipsesEnd = true;
          acc.pgTo--;
        }
      }
      return acc;
    });
    function set2(value2) {
      model.value = value2;
    }
    function setByOffset(offset2) {
      model.value = model.value + offset2;
    }
    const inputEvents = computed(() => {
      function updateModel2() {
        model.value = newPage.value;
        newPage.value = null;
      }
      return {
        "onUpdate:modelValue": (val) => {
          newPage.value = val;
        },
        onKeyup: (e3) => {
          isKeyCode(e3, 13) === true && updateModel2();
        },
        onBlur: updateModel2
      };
    });
    function getBtn2(cfg, page, active) {
      const data = {
        "aria-label": page,
        "aria-current": "false",
        ...btnProps.value,
        ...cfg
      };
      if (active === true) {
        Object.assign(data, {
          "aria-current": "true",
          ...activeBtnProps.value
        });
      }
      if (page !== void 0) {
        if (props4.toFn !== void 0) {
          data.to = props4.toFn(page);
        } else {
          data.onClick = () => {
            set2(page);
          };
        }
      }
      return h(QBtn_default, data);
    }
    Object.assign(proxy, { set: set2, setByOffset });
    return () => {
      const contentStart = [];
      const contentEnd = [];
      let contentMiddle;
      if (boundaryLinksProp.value === true) {
        contentStart.push(
          getBtn2({
            key: "bls",
            disable: props4.disable || props4.modelValue <= minProp.value,
            icon: icons.value[0],
            "aria-label": $q.lang.pagination.first
          }, minProp.value)
        );
        contentEnd.unshift(
          getBtn2({
            key: "ble",
            disable: props4.disable || props4.modelValue >= maxProp.value,
            icon: icons.value[3],
            "aria-label": $q.lang.pagination.last
          }, maxProp.value)
        );
      }
      if (directionLinksProp.value === true) {
        contentStart.push(
          getBtn2({
            key: "bdp",
            disable: props4.disable || props4.modelValue <= minProp.value,
            icon: icons.value[1],
            "aria-label": $q.lang.pagination.prev
          }, props4.modelValue - 1)
        );
        contentEnd.unshift(
          getBtn2({
            key: "bdn",
            disable: props4.disable || props4.modelValue >= maxProp.value,
            icon: icons.value[2],
            "aria-label": $q.lang.pagination.next
          }, props4.modelValue + 1)
        );
      }
      if (props4.input !== true) {
        contentMiddle = [];
        const { pgFrom, pgTo, marginalStyle: style2 } = btnConfig.value;
        if (btnConfig.value.boundaryStart === true) {
          const active = minProp.value === props4.modelValue;
          contentStart.push(
            getBtn2({
              key: "bns",
              style: style2,
              disable: props4.disable,
              label: minProp.value
            }, minProp.value, active)
          );
        }
        if (btnConfig.value.boundaryEnd === true) {
          const active = maxProp.value === props4.modelValue;
          contentEnd.unshift(
            getBtn2({
              key: "bne",
              style: style2,
              disable: props4.disable,
              label: maxProp.value
            }, maxProp.value, active)
          );
        }
        if (btnConfig.value.ellipsesStart === true) {
          contentStart.push(
            getBtn2({
              key: "bes",
              style: style2,
              disable: props4.disable,
              label: "…",
              ripple: false
            }, pgFrom - 1)
          );
        }
        if (btnConfig.value.ellipsesEnd === true) {
          contentEnd.unshift(
            getBtn2({
              key: "bee",
              style: style2,
              disable: props4.disable,
              label: "…",
              ripple: false
            }, pgTo + 1)
          );
        }
        for (let i3 = pgFrom; i3 <= pgTo; i3++) {
          contentMiddle.push(
            getBtn2({
              key: `bpg${i3}`,
              style: style2,
              disable: props4.disable,
              label: i3
            }, i3, i3 === props4.modelValue)
          );
        }
      }
      return h("div", {
        class: classes.value,
        ...attrs.value
      }, [
        h("div", {
          class: "q-pagination__content row no-wrap items-center",
          style: gutterStyle.value
        }, [
          ...contentStart,
          props4.input === true ? h(QInput_default, {
            class: "inline",
            style: { width: `${inputPlaceholder.value.length / 1.5}em` },
            type: "number",
            dense: true,
            value: newPage.value,
            disable: props4.disable,
            dark: isDark.value,
            borderless: true,
            inputClass: props4.inputClass,
            inputStyle: props4.inputStyle,
            placeholder: inputPlaceholder.value,
            min: minProp.value,
            max: maxProp.value,
            ...inputEvents.value
          }) : h("div", {
            class: "q-pagination__middle row justify-center"
          }, contentMiddle),
          ...contentEnd
        ])
      ]);
    };
  }
});
function frame_debounce_default(fn) {
  let wait2 = false, frame, callArgs;
  function debounced() {
    callArgs = arguments;
    if (wait2 === true) return;
    wait2 = true;
    frame = window.requestAnimationFrame(() => {
      fn.apply(this, callArgs);
      callArgs = void 0;
      wait2 = false;
    });
  }
  debounced.cancel = () => {
    window.cancelAnimationFrame(frame);
    wait2 = false;
  };
  return debounced;
}
var { passive: passive4 } = listenOpts;
createComponent({
  name: "QParallax",
  props: {
    src: String,
    height: {
      type: Number,
      default: 500
    },
    speed: {
      type: Number,
      default: 1,
      validator: (v) => v >= 0 && v <= 1
    },
    scrollTarget: scrollTargetProp,
    onScroll: Function
  },
  setup(props4, { slots, emit }) {
    const percentScrolled = ref$1(0);
    const rootRef = ref$1(null);
    const mediaParentRef = ref$1(null);
    const mediaRef = ref$1(null);
    let isWorking, mediaEl, mediaHeight, resizeHandler, observer, localScrollTarget;
    watch(() => props4.height, () => {
      isWorking === true && updatePos();
    });
    watch(() => props4.scrollTarget, () => {
      if (isWorking === true) {
        stop2();
        start();
      }
    });
    let update6 = (percentage) => {
      percentScrolled.value = percentage;
      props4.onScroll !== void 0 && emit("scroll", percentage);
    };
    function updatePos() {
      let containerTop, containerHeight, containerBottom;
      if (localScrollTarget === window) {
        containerTop = 0;
        containerBottom = containerHeight = window.innerHeight;
      } else {
        containerTop = offset(localScrollTarget).top;
        containerHeight = height(localScrollTarget);
        containerBottom = containerTop + containerHeight;
      }
      const top = offset(rootRef.value).top;
      const bottom = top + props4.height;
      if (observer !== void 0 || bottom > containerTop && top < containerBottom) {
        const percent = (containerBottom - top) / (props4.height + containerHeight);
        setPos((mediaHeight - props4.height) * percent * props4.speed);
        update6(percent);
      }
    }
    let setPos = (offset2) => {
      mediaEl.style.transform = `translate3d(-50%,${Math.round(offset2)}px,0)`;
    };
    function onResize() {
      mediaHeight = mediaEl.naturalHeight || mediaEl.videoHeight || height(mediaEl);
      isWorking === true && updatePos();
    }
    function start() {
      isWorking = true;
      localScrollTarget = getScrollTarget(rootRef.value, props4.scrollTarget);
      localScrollTarget.addEventListener("scroll", updatePos, passive4);
      window.addEventListener("resize", resizeHandler, passive4);
      updatePos();
    }
    function stop2() {
      if (isWorking === true) {
        isWorking = false;
        localScrollTarget.removeEventListener("scroll", updatePos, passive4);
        window.removeEventListener("resize", resizeHandler, passive4);
        localScrollTarget = void 0;
        setPos.cancel();
        update6.cancel();
        resizeHandler.cancel();
      }
    }
    onMounted(() => {
      setPos = frame_debounce_default(setPos);
      update6 = frame_debounce_default(update6);
      resizeHandler = frame_debounce_default(onResize);
      mediaEl = slots.media !== void 0 ? mediaParentRef.value.children[0] : mediaRef.value;
      mediaEl.onload = mediaEl.onloadstart = mediaEl.loadedmetadata = onResize;
      onResize();
      mediaEl.style.display = "initial";
      if (window.IntersectionObserver !== void 0) {
        observer = new IntersectionObserver((entries2) => {
          const fn = entries2[0].isIntersecting === true ? start : stop2;
          fn();
        });
        observer.observe(rootRef.value);
      } else {
        start();
      }
    });
    onBeforeUnmount(() => {
      stop2();
      observer == null ? void 0 : observer.disconnect();
      mediaEl.onload = mediaEl.onloadstart = mediaEl.loadedmetadata = null;
    });
    return () => {
      return h("div", {
        ref: rootRef,
        class: "q-parallax",
        style: { height: `${props4.height}px` }
      }, [
        h("div", {
          ref: mediaParentRef,
          class: "q-parallax__media absolute-full"
        }, slots.media !== void 0 ? slots.media() : [
          h("img", {
            ref: mediaRef,
            src: props4.src
          })
        ]),
        h(
          "div",
          { class: "q-parallax__content absolute-full column flex-center" },
          slots.content !== void 0 ? slots.content({ percentScrolled: percentScrolled.value }) : hSlot(slots.default)
        )
      ]);
    };
  }
});
function cloneDeep(data, hash = /* @__PURE__ */ new WeakMap()) {
  if (Object(data) !== data) return data;
  if (hash.has(data)) return hash.get(data);
  const result = data instanceof Date ? new Date(data) : data instanceof RegExp ? new RegExp(data.source, data.flags) : data instanceof Set ? /* @__PURE__ */ new Set() : data instanceof Map ? /* @__PURE__ */ new Map() : typeof data.constructor !== "function" ? /* @__PURE__ */ Object.create(null) : data.prototype !== void 0 && typeof data.prototype.constructor === "function" ? data : new data.constructor();
  if (typeof data.constructor === "function" && typeof data.valueOf === "function") {
    const val = data.valueOf();
    if (Object(val) !== val) {
      const result2 = new data.constructor(val);
      hash.set(data, result2);
      return result2;
    }
  }
  hash.set(data, result);
  if (data instanceof Set) {
    data.forEach((val) => {
      result.add(cloneDeep(val, hash));
    });
  } else if (data instanceof Map) {
    data.forEach((val, key) => {
      result.set(key, cloneDeep(val, hash));
    });
  }
  return Object.assign(
    result,
    ...Object.keys(data).map((key) => ({ [key]: cloneDeep(data[key], hash) }))
  );
}
createComponent({
  name: "QPopupEdit",
  props: {
    modelValue: {
      required: true
    },
    title: String,
    buttons: Boolean,
    labelSet: String,
    labelCancel: String,
    color: {
      type: String,
      default: "primary"
    },
    validate: {
      type: Function,
      default: () => true
    },
    autoSave: Boolean,
    /* menu props overrides */
    cover: {
      type: Boolean,
      default: true
    },
    /* end of menu props */
    disable: Boolean
  },
  emits: [
    "update:modelValue",
    "save",
    "cancel",
    "beforeShow",
    "show",
    "beforeHide",
    "hide"
  ],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const menuRef = ref$1(null);
    const initialValue = ref$1("");
    const currentModel = ref$1("");
    let validated = false;
    const scope = computed(() => {
      return injectProp({
        initialValue: initialValue.value,
        validate: props4.validate,
        set: set2,
        cancel,
        updatePosition
      }, "value", () => currentModel.value, (val) => {
        currentModel.value = val;
      });
    });
    function set2() {
      if (props4.validate(currentModel.value) === false) return;
      if (hasModelChanged() === true) {
        emit("save", currentModel.value, initialValue.value);
        emit("update:modelValue", currentModel.value);
      }
      closeMenu();
    }
    function cancel() {
      if (hasModelChanged() === true) {
        emit("cancel", currentModel.value, initialValue.value);
      }
      closeMenu();
    }
    function updatePosition() {
      nextTick(() => {
        menuRef.value.updatePosition();
      });
    }
    function hasModelChanged() {
      return isDeepEqual(currentModel.value, initialValue.value) === false;
    }
    function closeMenu() {
      validated = true;
      menuRef.value.hide();
    }
    function onBeforeShow() {
      validated = false;
      initialValue.value = cloneDeep(props4.modelValue);
      currentModel.value = cloneDeep(props4.modelValue);
      emit("beforeShow");
    }
    function onShow() {
      emit("show");
    }
    function onBeforeHide() {
      if (validated === false && hasModelChanged() === true) {
        if (props4.autoSave === true && props4.validate(currentModel.value) === true) {
          emit("save", currentModel.value, initialValue.value);
          emit("update:modelValue", currentModel.value);
        } else {
          emit("cancel", currentModel.value, initialValue.value);
        }
      }
      emit("beforeHide");
    }
    function onHide() {
      emit("hide");
    }
    function getContent() {
      const child = slots.default !== void 0 ? [].concat(slots.default(scope.value)) : [];
      props4.title && child.unshift(
        h("div", { class: "q-dialog__title q-mt-sm q-mb-sm" }, props4.title)
      );
      props4.buttons === true && child.push(
        h("div", { class: "q-popup-edit__buttons row justify-center no-wrap" }, [
          h(QBtn_default, {
            flat: true,
            color: props4.color,
            label: props4.labelCancel || $q.lang.label.cancel,
            onClick: cancel
          }),
          h(QBtn_default, {
            flat: true,
            color: props4.color,
            label: props4.labelSet || $q.lang.label.set,
            onClick: set2
          })
        ])
      );
      return child;
    }
    Object.assign(proxy, {
      set: set2,
      cancel,
      show(e3) {
        var _a;
        (_a = menuRef.value) == null ? void 0 : _a.show(e3);
      },
      hide(e3) {
        var _a;
        (_a = menuRef.value) == null ? void 0 : _a.hide(e3);
      },
      updatePosition
    });
    return () => {
      if (props4.disable === true) return;
      return h(QMenu_default, {
        ref: menuRef,
        class: "q-popup-edit",
        cover: props4.cover,
        onBeforeShow,
        onShow,
        onBeforeHide,
        onHide,
        onEscapeKey: cancel
      }, getContent);
    };
  }
});
createComponent({
  name: "QPopupProxy",
  props: {
    ...useAnchorProps,
    breakpoint: {
      type: [String, Number],
      default: 450
    }
  },
  emits: ["show", "hide"],
  setup(props4, { slots, emit, attrs }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const showing = ref$1(false);
    const popupRef = ref$1(null);
    const breakpoint = computed(() => parseInt(props4.breakpoint, 10));
    const { canShow } = use_anchor_default({ showing });
    function getType() {
      return $q.screen.width < breakpoint.value || $q.screen.height < breakpoint.value ? "dialog" : "menu";
    }
    const type2 = ref$1(getType());
    const popupProps = computed(
      () => type2.value === "menu" ? { maxHeight: "99vh" } : {}
    );
    watch(() => getType(), (val) => {
      if (showing.value !== true) {
        type2.value = val;
      }
    });
    function onShow(evt) {
      showing.value = true;
      emit("show", evt);
    }
    function onHide(evt) {
      showing.value = false;
      type2.value = getType();
      emit("hide", evt);
    }
    Object.assign(proxy, {
      show(evt) {
        canShow(evt) === true && popupRef.value.show(evt);
      },
      hide(evt) {
        popupRef.value.hide(evt);
      },
      toggle(evt) {
        popupRef.value.toggle(evt);
      }
    });
    injectProp(proxy, "currentComponent", () => ({
      type: type2.value,
      ref: popupRef.value
    }));
    return () => {
      const data = {
        ref: popupRef,
        ...popupProps.value,
        ...attrs,
        onShow,
        onHide
      };
      let component;
      if (type2.value === "dialog") {
        component = QDialog_default;
      } else {
        component = QMenu_default;
        Object.assign(data, {
          target: props4.target,
          contextMenu: props4.contextMenu,
          noParentEvent: true,
          separateClosePopup: true
        });
      }
      return h(component, data, slots.default);
    };
  }
});
var defaultSizes3 = {
  xs: 2,
  sm: 4,
  md: 6,
  lg: 10,
  xl: 14
};
function width2(val, reverse, $q) {
  return {
    transform: reverse === true ? `translateX(${$q.lang.rtl === true ? "-" : ""}100%) scale3d(${-val},1,1)` : `scale3d(${val},1,1)`
  };
}
var QLinearProgress_default = createComponent({
  name: "QLinearProgress",
  props: {
    ...useDarkProps,
    ...useSizeProps,
    value: {
      type: Number,
      default: 0
    },
    buffer: Number,
    color: String,
    trackColor: String,
    reverse: Boolean,
    stripe: Boolean,
    indeterminate: Boolean,
    query: Boolean,
    rounded: Boolean,
    animationSpeed: {
      type: [String, Number],
      default: 2100
    },
    instantFeedback: Boolean
  },
  setup(props4, { slots }) {
    const { proxy } = getCurrentInstance();
    const isDark = use_dark_default(props4, proxy.$q);
    const sizeStyle = use_size_default(props4, defaultSizes3);
    const motion = computed(() => props4.indeterminate === true || props4.query === true);
    const widthReverse = computed(() => props4.reverse !== props4.query);
    const style2 = computed(() => ({
      ...sizeStyle.value !== null ? sizeStyle.value : {},
      "--q-linear-progress-speed": `${props4.animationSpeed}ms`
    }));
    const classes = computed(
      () => "q-linear-progress" + (props4.color !== void 0 ? ` text-${props4.color}` : "") + (props4.reverse === true || props4.query === true ? " q-linear-progress--reverse" : "") + (props4.rounded === true ? " rounded-borders" : "")
    );
    const trackStyle = computed(() => width2(props4.buffer !== void 0 ? props4.buffer : 1, widthReverse.value, proxy.$q));
    const transitionSuffix = computed(() => `with${props4.instantFeedback === true ? "out" : ""}-transition`);
    const trackClass = computed(
      () => `q-linear-progress__track absolute-full q-linear-progress__track--${transitionSuffix.value} q-linear-progress__track--${isDark.value === true ? "dark" : "light"}` + (props4.trackColor !== void 0 ? ` bg-${props4.trackColor}` : "")
    );
    const modelStyle = computed(() => width2(motion.value === true ? 1 : props4.value, widthReverse.value, proxy.$q));
    const modelClass = computed(
      () => `q-linear-progress__model absolute-full q-linear-progress__model--${transitionSuffix.value} q-linear-progress__model--${motion.value === true ? "in" : ""}determinate`
    );
    const stripeStyle = computed(() => ({ width: `${props4.value * 100}%` }));
    const stripeClass = computed(
      () => `q-linear-progress__stripe absolute-${props4.reverse === true ? "right" : "left"} q-linear-progress__stripe--${transitionSuffix.value}`
    );
    return () => {
      const child = [
        h("div", {
          class: trackClass.value,
          style: trackStyle.value
        }),
        h("div", {
          class: modelClass.value,
          style: modelStyle.value
        })
      ];
      props4.stripe === true && motion.value === false && child.push(
        h("div", {
          class: stripeClass.value,
          style: stripeStyle.value
        })
      );
      return h("div", {
        class: classes.value,
        style: style2.value,
        role: "progressbar",
        "aria-valuemin": 0,
        "aria-valuemax": 1,
        "aria-valuenow": props4.indeterminate === true ? void 0 : props4.value
      }, hMergeSlot(slots.default, child));
    };
  }
});
var PULLER_HEIGHT = 40;
var OFFSET_TOP = 20;
createComponent({
  name: "QPullToRefresh",
  props: {
    color: String,
    bgColor: String,
    icon: String,
    noMouse: Boolean,
    disable: Boolean,
    scrollTarget: scrollTargetProp
  },
  emits: ["refresh"],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const state2 = ref$1("pull");
    const pullRatio = ref$1(0);
    const pulling = ref$1(false);
    const pullPosition = ref$1(-PULLER_HEIGHT);
    const animating = ref$1(false);
    const positionCSS = ref$1({});
    const style2 = computed(() => ({
      opacity: pullRatio.value,
      transform: `translateY(${pullPosition.value}px) rotate(${pullRatio.value * 360}deg)`
    }));
    const classes = computed(
      () => "q-pull-to-refresh__puller row flex-center" + (animating.value === true ? " q-pull-to-refresh__puller--animating" : "") + (props4.bgColor !== void 0 ? ` bg-${props4.bgColor}` : "")
    );
    function pull(event) {
      if (event.isFinal === true) {
        if (pulling.value === true) {
          pulling.value = false;
          if (state2.value === "pulled") {
            state2.value = "refreshing";
            animateTo({ pos: OFFSET_TOP });
            trigger3();
          } else if (state2.value === "pull") {
            animateTo({ pos: -PULLER_HEIGHT, ratio: 0 });
          }
        }
        return;
      }
      if (animating.value === true || state2.value === "refreshing") {
        return false;
      }
      if (event.isFirst === true) {
        if (getVerticalScrollPosition(localScrollTarget) !== 0 || event.direction !== "down") {
          if (pulling.value === true) {
            pulling.value = false;
            state2.value = "pull";
            animateTo({ pos: -PULLER_HEIGHT, ratio: 0 });
          }
          return false;
        }
        pulling.value = true;
        const { top, left } = proxy.$el.getBoundingClientRect();
        positionCSS.value = {
          top: top + "px",
          left: left + "px",
          width: window.getComputedStyle(proxy.$el).getPropertyValue("width")
        };
      }
      prevent(event.evt);
      const distance = Math.min(140, Math.max(0, event.distance.y));
      pullPosition.value = distance - PULLER_HEIGHT;
      pullRatio.value = between(distance / (OFFSET_TOP + PULLER_HEIGHT), 0, 1);
      const newState = pullPosition.value > OFFSET_TOP ? "pulled" : "pull";
      if (state2.value !== newState) {
        state2.value = newState;
      }
    }
    const directives = computed(() => {
      const modifiers = { down: true };
      if (props4.noMouse !== true) {
        modifiers.mouse = true;
      }
      return [[
        TouchPan_default,
        pull,
        void 0,
        modifiers
      ]];
    });
    const contentClass = computed(
      () => `q-pull-to-refresh__content${pulling.value === true ? " no-pointer-events" : ""}`
    );
    function trigger3() {
      emit("refresh", () => {
        animateTo({ pos: -PULLER_HEIGHT, ratio: 0 }, () => {
          state2.value = "pull";
        });
      });
    }
    let localScrollTarget, timer2 = null;
    function animateTo({ pos, ratio }, done) {
      animating.value = true;
      pullPosition.value = pos;
      if (ratio !== void 0) {
        pullRatio.value = ratio;
      }
      timer2 !== null && clearTimeout(timer2);
      timer2 = setTimeout(() => {
        timer2 = null;
        animating.value = false;
        done == null ? void 0 : done();
      }, 300);
    }
    function updateScrollTarget() {
      localScrollTarget = getScrollTarget(proxy.$el, props4.scrollTarget);
    }
    watch(() => props4.scrollTarget, updateScrollTarget);
    onMounted(updateScrollTarget);
    onBeforeUnmount(() => {
      timer2 !== null && clearTimeout(timer2);
    });
    Object.assign(proxy, { trigger: trigger3, updateScrollTarget });
    return () => {
      const child = [
        h("div", { class: contentClass.value }, hSlot(slots.default)),
        h("div", {
          class: "q-pull-to-refresh__puller-container fixed row flex-center no-pointer-events z-top",
          style: positionCSS.value
        }, [
          h("div", {
            class: classes.value,
            style: style2.value
          }, [
            state2.value !== "refreshing" ? h(QIcon_default, {
              name: props4.icon || $q.iconSet.pullToRefresh.icon,
              color: props4.color,
              size: "32px"
            }) : h(QSpinner_default, {
              size: "24px",
              color: props4.color
            })
          ])
        ])
      ];
      return hDir(
        "div",
        { class: "q-pull-to-refresh" },
        child,
        "main",
        props4.disable === false,
        () => directives.value
      );
    };
  }
});
var dragType = {
  MIN: 0,
  RANGE: 1,
  MAX: 2
};
createComponent({
  name: "QRange",
  props: {
    ...useSliderProps,
    modelValue: {
      type: Object,
      default: () => ({ min: null, max: null }),
      validator: (v) => "min" in v && "max" in v
    },
    dragRange: Boolean,
    dragOnlyRange: Boolean,
    leftLabelColor: String,
    leftLabelTextColor: String,
    rightLabelColor: String,
    rightLabelTextColor: String,
    leftLabelValue: [String, Number],
    rightLabelValue: [String, Number],
    leftThumbColor: String,
    rightThumbColor: String
  },
  emits: useSliderEmits,
  setup(props4, { emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const { state: state2, methods } = use_slider_default({
      updateValue: updateValue2,
      updatePosition,
      getDragging,
      formAttrs: computed(() => ({
        type: "hidden",
        name: props4.name,
        value: `${props4.modelValue.min}|${props4.modelValue.max}`
      }))
    });
    const rootRef = ref$1(null);
    const curMinRatio = ref$1(0);
    const curMaxRatio = ref$1(0);
    const model = ref$1({ min: 0, max: 0 });
    function normalizeModel() {
      model.value.min = props4.modelValue.min === null ? state2.innerMin.value : between(props4.modelValue.min, state2.innerMin.value, state2.innerMax.value);
      model.value.max = props4.modelValue.max === null ? state2.innerMax.value : between(props4.modelValue.max, state2.innerMin.value, state2.innerMax.value);
    }
    watch(
      () => `${props4.modelValue.min}|${props4.modelValue.max}|${state2.innerMin.value}|${state2.innerMax.value}`,
      normalizeModel
    );
    normalizeModel();
    const modelMinRatio = computed(() => methods.convertModelToRatio(model.value.min));
    const modelMaxRatio = computed(() => methods.convertModelToRatio(model.value.max));
    const ratioMin = computed(() => state2.active.value === true ? curMinRatio.value : modelMinRatio.value);
    const ratioMax = computed(() => state2.active.value === true ? curMaxRatio.value : modelMaxRatio.value);
    const selectionBarStyle = computed(() => {
      const acc = {
        [state2.positionProp.value]: `${100 * ratioMin.value}%`,
        [state2.sizeProp.value]: `${100 * (ratioMax.value - ratioMin.value)}%`
      };
      if (props4.selectionImg !== void 0) {
        acc.backgroundImage = `url(${props4.selectionImg}) !important`;
      }
      return acc;
    });
    const trackContainerEvents = computed(() => {
      if (state2.editable.value !== true) {
        return {};
      }
      if ($q.platform.is.mobile === true) {
        return { onClick: methods.onMobileClick };
      }
      const evt = { onMousedown: methods.onActivate };
      if (props4.dragRange === true || props4.dragOnlyRange === true) {
        Object.assign(evt, {
          onFocus: () => {
            state2.focus.value = "both";
          },
          onBlur: methods.onBlur,
          onKeydown: onKeydown2,
          onKeyup: methods.onKeyup
        });
      }
      return evt;
    });
    function getEvents(side) {
      return $q.platform.is.mobile !== true && state2.editable.value === true && props4.dragOnlyRange !== true ? {
        onFocus: () => {
          state2.focus.value = side;
        },
        onBlur: methods.onBlur,
        onKeydown: onKeydown2,
        onKeyup: methods.onKeyup
      } : {};
    }
    const thumbTabindex = computed(() => props4.dragOnlyRange !== true ? state2.tabindex.value : null);
    const trackContainerTabindex = computed(() => $q.platform.is.mobile !== true && (props4.dragRange || props4.dragOnlyRange === true) ? state2.tabindex.value : null);
    const minThumbRef = ref$1(null);
    const minEvents = computed(() => getEvents("min"));
    const getMinThumb = methods.getThumbRenderFn({
      focusValue: "min",
      getNodeData: () => ({
        ref: minThumbRef,
        key: "tmin",
        ...minEvents.value,
        tabindex: thumbTabindex.value
      }),
      ratio: ratioMin,
      label: computed(() => props4.leftLabelValue !== void 0 ? props4.leftLabelValue : model.value.min),
      thumbColor: computed(() => props4.leftThumbColor || props4.thumbColor || props4.color),
      labelColor: computed(() => props4.leftLabelColor || props4.labelColor),
      labelTextColor: computed(() => props4.leftLabelTextColor || props4.labelTextColor)
    });
    const maxEvents = computed(() => getEvents("max"));
    const getMaxThumb = methods.getThumbRenderFn({
      focusValue: "max",
      getNodeData: () => ({
        ...maxEvents.value,
        key: "tmax",
        tabindex: thumbTabindex.value
      }),
      ratio: ratioMax,
      label: computed(() => props4.rightLabelValue !== void 0 ? props4.rightLabelValue : model.value.max),
      thumbColor: computed(() => props4.rightThumbColor || props4.thumbColor || props4.color),
      labelColor: computed(() => props4.rightLabelColor || props4.labelColor),
      labelTextColor: computed(() => props4.rightLabelTextColor || props4.labelTextColor)
    });
    function updateValue2(change) {
      if (model.value.min !== props4.modelValue.min || model.value.max !== props4.modelValue.max) {
        emit("update:modelValue", { ...model.value });
      }
      change === true && emit("change", { ...model.value });
    }
    function getDragging(event) {
      const { left, top, width: width3, height: height2 } = rootRef.value.getBoundingClientRect(), sensitivity = props4.dragOnlyRange === true ? 0 : props4.vertical === true ? minThumbRef.value.offsetHeight / (2 * height2) : minThumbRef.value.offsetWidth / (2 * width3);
      const dragging = {
        left,
        top,
        width: width3,
        height: height2,
        valueMin: model.value.min,
        valueMax: model.value.max,
        ratioMin: modelMinRatio.value,
        ratioMax: modelMaxRatio.value
      };
      const ratio = methods.getDraggingRatio(event, dragging);
      if (props4.dragOnlyRange !== true && ratio < dragging.ratioMin + sensitivity) {
        dragging.type = dragType.MIN;
      } else if (props4.dragOnlyRange === true || ratio < dragging.ratioMax - sensitivity) {
        if (props4.dragRange === true || props4.dragOnlyRange === true) {
          dragging.type = dragType.RANGE;
          Object.assign(dragging, {
            offsetRatio: ratio,
            offsetModel: methods.convertRatioToModel(ratio),
            rangeValue: dragging.valueMax - dragging.valueMin,
            rangeRatio: dragging.ratioMax - dragging.ratioMin
          });
        } else {
          dragging.type = dragging.ratioMax - ratio < ratio - dragging.ratioMin ? dragType.MAX : dragType.MIN;
        }
      } else {
        dragging.type = dragType.MAX;
      }
      return dragging;
    }
    function updatePosition(event, dragging = state2.dragging.value) {
      let pos;
      const ratio = methods.getDraggingRatio(event, dragging);
      const localModel = methods.convertRatioToModel(ratio);
      switch (dragging.type) {
        case dragType.MIN:
          if (ratio <= dragging.ratioMax) {
            pos = {
              minR: ratio,
              maxR: dragging.ratioMax,
              min: localModel,
              max: dragging.valueMax
            };
            state2.focus.value = "min";
          } else {
            pos = {
              minR: dragging.ratioMax,
              maxR: ratio,
              min: dragging.valueMax,
              max: localModel
            };
            state2.focus.value = "max";
          }
          break;
        case dragType.MAX:
          if (ratio >= dragging.ratioMin) {
            pos = {
              minR: dragging.ratioMin,
              maxR: ratio,
              min: dragging.valueMin,
              max: localModel
            };
            state2.focus.value = "max";
          } else {
            pos = {
              minR: ratio,
              maxR: dragging.ratioMin,
              min: localModel,
              max: dragging.valueMin
            };
            state2.focus.value = "min";
          }
          break;
        case dragType.RANGE:
          const ratioDelta = ratio - dragging.offsetRatio, minR = between(dragging.ratioMin + ratioDelta, state2.innerMinRatio.value, state2.innerMaxRatio.value - dragging.rangeRatio), modelDelta = localModel - dragging.offsetModel, min2 = between(dragging.valueMin + modelDelta, state2.innerMin.value, state2.innerMax.value - dragging.rangeValue);
          pos = {
            minR,
            maxR: minR + dragging.rangeRatio,
            min: state2.roundValueFn.value(min2),
            max: state2.roundValueFn.value(min2 + dragging.rangeValue)
          };
          state2.focus.value = "both";
          break;
      }
      model.value = model.value.min === null || model.value.max === null ? { min: pos.min || props4.min, max: pos.max || props4.max } : { min: pos.min, max: pos.max };
      if (props4.snap !== true || props4.step === 0) {
        curMinRatio.value = pos.minR;
        curMaxRatio.value = pos.maxR;
      } else {
        curMinRatio.value = methods.convertModelToRatio(model.value.min);
        curMaxRatio.value = methods.convertModelToRatio(model.value.max);
      }
    }
    function onKeydown2(evt) {
      if (keyCodes.includes(evt.keyCode) === false) return;
      stopAndPrevent(evt);
      const stepVal = ([34, 33].includes(evt.keyCode) ? 10 : 1) * state2.keyStep.value, offset2 = ([34, 37, 40].includes(evt.keyCode) ? -1 : 1) * (state2.isReversed.value === true ? -1 : 1) * (props4.vertical === true ? -1 : 1) * stepVal;
      if (state2.focus.value === "both") {
        const interval = model.value.max - model.value.min;
        const min2 = between(
          state2.roundValueFn.value(model.value.min + offset2),
          state2.innerMin.value,
          state2.innerMax.value - interval
        );
        model.value = {
          min: min2,
          max: state2.roundValueFn.value(min2 + interval)
        };
      } else if (state2.focus.value === false) {
        return;
      } else {
        const which = state2.focus.value;
        model.value = {
          ...model.value,
          [which]: between(
            state2.roundValueFn.value(model.value[which] + offset2),
            which === "min" ? state2.innerMin.value : model.value.min,
            which === "max" ? state2.innerMax.value : model.value.max
          )
        };
      }
      updateValue2();
    }
    return () => {
      const content = methods.getContent(
        selectionBarStyle,
        trackContainerTabindex,
        trackContainerEvents,
        (node) => {
          node.push(
            getMinThumb(),
            getMaxThumb()
          );
        }
      );
      return h("div", {
        ref: rootRef,
        class: "q-range " + state2.classes.value + (props4.modelValue.min === null || props4.modelValue.max === null ? " q-slider--no-value" : ""),
        ...state2.attributes.value,
        "aria-valuenow": props4.modelValue.min + "|" + props4.modelValue.max
      }, content);
    };
  }
});
createComponent({
  name: "QRating",
  props: {
    ...useSizeProps,
    ...useFormProps,
    modelValue: {
      type: Number,
      required: true
    },
    max: {
      type: [String, Number],
      default: 5
    },
    icon: [String, Array],
    iconHalf: [String, Array],
    iconSelected: [String, Array],
    iconAriaLabel: [String, Array],
    color: [String, Array],
    colorHalf: [String, Array],
    colorSelected: [String, Array],
    noReset: Boolean,
    noDimming: Boolean,
    readonly: Boolean,
    disable: Boolean
  },
  emits: ["update:modelValue"],
  setup(props4, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const sizeStyle = use_size_default(props4);
    const formAttrs = useFormAttrs(props4);
    const injectFormInput = useFormInject(formAttrs);
    const mouseModel = ref$1(0);
    let iconRefs = {};
    const editable = computed(
      () => props4.readonly !== true && props4.disable !== true
    );
    const classes = computed(
      () => `q-rating row inline items-center q-rating--${editable.value === true ? "" : "non-"}editable` + (props4.noDimming === true ? " q-rating--no-dimming" : "") + (props4.disable === true ? " disabled" : "") + (props4.color !== void 0 && Array.isArray(props4.color) === false ? ` text-${props4.color}` : "")
    );
    const iconData = computed(() => {
      const iconLen = Array.isArray(props4.icon) === true ? props4.icon.length : 0, selIconLen = Array.isArray(props4.iconSelected) === true ? props4.iconSelected.length : 0, halfIconLen = Array.isArray(props4.iconHalf) === true ? props4.iconHalf.length : 0, colorLen = Array.isArray(props4.color) === true ? props4.color.length : 0, selColorLen = Array.isArray(props4.colorSelected) === true ? props4.colorSelected.length : 0, halfColorLen = Array.isArray(props4.colorHalf) === true ? props4.colorHalf.length : 0;
      return {
        iconLen,
        icon: iconLen > 0 ? props4.icon[iconLen - 1] : props4.icon,
        selIconLen,
        selIcon: selIconLen > 0 ? props4.iconSelected[selIconLen - 1] : props4.iconSelected,
        halfIconLen,
        halfIcon: halfIconLen > 0 ? props4.iconHalf[selIconLen - 1] : props4.iconHalf,
        colorLen,
        color: colorLen > 0 ? props4.color[colorLen - 1] : props4.color,
        selColorLen,
        selColor: selColorLen > 0 ? props4.colorSelected[selColorLen - 1] : props4.colorSelected,
        halfColorLen,
        halfColor: halfColorLen > 0 ? props4.colorHalf[halfColorLen - 1] : props4.colorHalf
      };
    });
    const iconLabel = computed(() => {
      if (typeof props4.iconAriaLabel === "string") {
        const label = props4.iconAriaLabel.length !== 0 ? `${props4.iconAriaLabel} ` : "";
        return (i3) => `${label}${i3}`;
      }
      if (Array.isArray(props4.iconAriaLabel) === true) {
        const iMax = props4.iconAriaLabel.length;
        if (iMax > 0) {
          return (i3) => props4.iconAriaLabel[Math.min(i3, iMax) - 1];
        }
      }
      return (i3, label) => `${label} ${i3}`;
    });
    const stars = computed(() => {
      const acc = [], icons = iconData.value, ceil = Math.ceil(props4.modelValue), tabindex = editable.value === true ? 0 : null;
      const halfIndex = props4.iconHalf === void 0 || ceil === props4.modelValue ? -1 : ceil;
      for (let i3 = 1; i3 <= props4.max; i3++) {
        const active = mouseModel.value === 0 && props4.modelValue >= i3 || mouseModel.value > 0 && mouseModel.value >= i3, half = halfIndex === i3 && mouseModel.value < i3, exSelected = mouseModel.value > 0 && (half === true ? ceil : props4.modelValue) >= i3 && mouseModel.value < i3, color2 = half === true ? i3 <= icons.halfColorLen ? props4.colorHalf[i3 - 1] : icons.halfColor : icons.selColor !== void 0 && active === true ? i3 <= icons.selColorLen ? props4.colorSelected[i3 - 1] : icons.selColor : i3 <= icons.colorLen ? props4.color[i3 - 1] : icons.color, name2 = (half === true ? i3 <= icons.halfIconLen ? props4.iconHalf[i3 - 1] : icons.halfIcon : icons.selIcon !== void 0 && (active === true || exSelected === true) ? i3 <= icons.selIconLen ? props4.iconSelected[i3 - 1] : icons.selIcon : i3 <= icons.iconLen ? props4.icon[i3 - 1] : icons.icon) || $q.iconSet.rating.icon;
        acc.push({
          name: (half === true ? i3 <= icons.halfIconLen ? props4.iconHalf[i3 - 1] : icons.halfIcon : icons.selIcon !== void 0 && (active === true || exSelected === true) ? i3 <= icons.selIconLen ? props4.iconSelected[i3 - 1] : icons.selIcon : i3 <= icons.iconLen ? props4.icon[i3 - 1] : icons.icon) || $q.iconSet.rating.icon,
          attrs: {
            tabindex,
            role: "radio",
            "aria-checked": props4.modelValue === i3 ? "true" : "false",
            "aria-label": iconLabel.value(i3, name2)
          },
          iconClass: "q-rating__icon" + (active === true || half === true ? " q-rating__icon--active" : "") + (exSelected === true ? " q-rating__icon--exselected" : "") + (mouseModel.value === i3 ? " q-rating__icon--hovered" : "") + (color2 !== void 0 ? ` text-${color2}` : "")
        });
      }
      return acc;
    });
    const attributes = computed(() => {
      const attrs = { role: "radiogroup" };
      if (props4.disable === true) {
        attrs["aria-disabled"] = "true";
      }
      if (props4.readonly === true) {
        attrs["aria-readonly"] = "true";
      }
      return attrs;
    });
    function set2(value2) {
      if (editable.value === true) {
        const model = between(parseInt(value2, 10), 1, parseInt(props4.max, 10)), newVal = props4.noReset !== true && props4.modelValue === model ? 0 : model;
        newVal !== props4.modelValue && emit("update:modelValue", newVal);
        mouseModel.value = 0;
      }
    }
    function setHoverValue(value2) {
      if (editable.value === true) {
        mouseModel.value = value2;
      }
    }
    function onKeyup2(e3, i3) {
      switch (e3.keyCode) {
        case 13:
        case 32:
          set2(i3);
          return stopAndPrevent(e3);
        case 37:
        case 40:
          if (iconRefs[`rt${i3 - 1}`]) {
            iconRefs[`rt${i3 - 1}`].focus();
          }
          return stopAndPrevent(e3);
        case 39:
        case 38:
          if (iconRefs[`rt${i3 + 1}`]) {
            iconRefs[`rt${i3 + 1}`].focus();
          }
          return stopAndPrevent(e3);
      }
    }
    function resetMouseModel() {
      mouseModel.value = 0;
    }
    onBeforeUpdate(() => {
      iconRefs = {};
    });
    return () => {
      const child = [];
      stars.value.forEach(({ iconClass, name: name2, attrs }, index2) => {
        const i3 = index2 + 1;
        child.push(
          h("div", {
            key: i3,
            ref: (el) => {
              iconRefs[`rt${i3}`] = el;
            },
            class: "q-rating__icon-container flex flex-center",
            ...attrs,
            onClick() {
              set2(i3);
            },
            onMouseover() {
              setHoverValue(i3);
            },
            onMouseout: resetMouseModel,
            onFocus() {
              setHoverValue(i3);
            },
            onBlur: resetMouseModel,
            onKeyup(e3) {
              onKeyup2(e3, i3);
            }
          }, hMergeSlot(
            slots[`tip-${i3}`],
            [h(QIcon_default, { class: iconClass, name: name2 })]
          ))
        );
      });
      if (props4.name !== void 0 && props4.disable !== true) {
        injectFormInput(child, "push");
      }
      return h("div", {
        class: classes.value,
        style: sizeStyle.value,
        ...attributes.value
      }, child);
    };
  }
});
createComponent({
  name: "QResponsive",
  props: useRatioProps,
  setup(props4, { slots }) {
    const ratioStyle = use_ratio_default(props4);
    return () => h("div", {
      class: "q-responsive"
    }, [
      h("div", {
        class: "q-responsive__filler overflow-hidden"
      }, [
        h("div", { style: ratioStyle.value })
      ]),
      h("div", {
        class: "q-responsive__content absolute-full fit"
      }, hSlot(slots.default))
    ]);
  }
});
var ScrollAreaControls_default = createComponent({
  props: [
    "store",
    "barStyle",
    "verticalBarStyle",
    "horizontalBarStyle"
  ],
  setup(props4) {
    return () => [
      h("div", {
        class: props4.store.scroll.vertical.barClass.value,
        style: [props4.barStyle, props4.verticalBarStyle],
        "aria-hidden": "true",
        onMousedown: props4.store.onVerticalMousedown
      }),
      h("div", {
        class: props4.store.scroll.horizontal.barClass.value,
        style: [props4.barStyle, props4.horizontalBarStyle],
        "aria-hidden": "true",
        onMousedown: props4.store.onHorizontalMousedown
      }),
      withDirectives(
        h("div", {
          ref: props4.store.scroll.vertical.ref,
          class: props4.store.scroll.vertical.thumbClass.value,
          style: props4.store.scroll.vertical.style.value,
          "aria-hidden": "true"
        }),
        props4.store.thumbVertDir
      ),
      withDirectives(
        h("div", {
          ref: props4.store.scroll.horizontal.ref,
          class: props4.store.scroll.horizontal.thumbClass.value,
          style: props4.store.scroll.horizontal.style.value,
          "aria-hidden": "true"
        }),
        props4.store.thumbHorizDir
      )
    ];
  }
});
var axisList = ["vertical", "horizontal"];
var dirProps = {
  vertical: { offset: "offsetY", scroll: "scrollTop", dir: "down", dist: "y" },
  horizontal: { offset: "offsetX", scroll: "scrollLeft", dir: "right", dist: "x" }
};
var panOpts = {
  prevent: true,
  mouse: true,
  mouseAllDir: true
};
var getMinThumbSize = (size2) => size2 >= 250 ? 50 : Math.ceil(size2 / 5);
createComponent({
  name: "QScrollArea",
  props: {
    ...useDarkProps,
    thumbStyle: Object,
    verticalThumbStyle: Object,
    horizontalThumbStyle: Object,
    barStyle: [Array, String, Object],
    verticalBarStyle: [Array, String, Object],
    horizontalBarStyle: [Array, String, Object],
    verticalOffset: {
      type: Array,
      default: [0, 0]
    },
    horizontalOffset: {
      type: Array,
      default: [0, 0]
    },
    contentStyle: [Array, String, Object],
    contentActiveStyle: [Array, String, Object],
    delay: {
      type: [String, Number],
      default: 1e3
    },
    visible: {
      type: Boolean,
      default: null
    },
    tabindex: [String, Number],
    onScroll: Function
  },
  setup(props4, { slots, emit }) {
    const tempShowing = ref$1(false);
    const panning = ref$1(false);
    const hover = ref$1(false);
    const container = {
      vertical: ref$1(0),
      horizontal: ref$1(0)
    };
    const scroll = {
      vertical: {
        ref: ref$1(null),
        position: ref$1(0),
        size: ref$1(0)
      },
      horizontal: {
        ref: ref$1(null),
        position: ref$1(0),
        size: ref$1(0)
      }
    };
    const { proxy } = getCurrentInstance();
    const isDark = use_dark_default(props4, proxy.$q);
    let timer2 = null, panRefPos;
    const targetRef = ref$1(null);
    const classes = computed(
      () => "q-scrollarea" + (isDark.value === true ? " q-scrollarea--dark" : "")
    );
    Object.assign(container, {
      verticalInner: computed(() => container.vertical.value - props4.verticalOffset[0] - props4.verticalOffset[1]),
      horizontalInner: computed(() => container.horizontal.value - props4.horizontalOffset[0] - props4.horizontalOffset[1])
    });
    scroll.vertical.percentage = computed(() => {
      const diff2 = scroll.vertical.size.value - container.vertical.value;
      if (diff2 <= 0) {
        return 0;
      }
      const p2 = between(scroll.vertical.position.value / diff2, 0, 1);
      return Math.round(p2 * 1e4) / 1e4;
    });
    scroll.vertical.thumbHidden = computed(() => (props4.visible === null ? hover.value : props4.visible) !== true && tempShowing.value === false && panning.value === false || scroll.vertical.size.value <= container.vertical.value + 1);
    scroll.vertical.thumbStart = computed(() => props4.verticalOffset[0] + scroll.vertical.percentage.value * (container.verticalInner.value - scroll.vertical.thumbSize.value));
    scroll.vertical.thumbSize = computed(
      () => Math.round(
        between(
          container.verticalInner.value * container.verticalInner.value / scroll.vertical.size.value,
          getMinThumbSize(container.verticalInner.value),
          container.verticalInner.value
        )
      )
    );
    scroll.vertical.style = computed(() => ({
      ...props4.thumbStyle,
      ...props4.verticalThumbStyle,
      top: `${scroll.vertical.thumbStart.value}px`,
      height: `${scroll.vertical.thumbSize.value}px`,
      right: `${props4.horizontalOffset[1]}px`
    }));
    scroll.vertical.thumbClass = computed(() => "q-scrollarea__thumb q-scrollarea__thumb--v absolute-right" + (scroll.vertical.thumbHidden.value === true ? " q-scrollarea__thumb--invisible" : ""));
    scroll.vertical.barClass = computed(() => "q-scrollarea__bar q-scrollarea__bar--v absolute-right" + (scroll.vertical.thumbHidden.value === true ? " q-scrollarea__bar--invisible" : ""));
    scroll.horizontal.percentage = computed(() => {
      const diff2 = scroll.horizontal.size.value - container.horizontal.value;
      if (diff2 <= 0) {
        return 0;
      }
      const p2 = between(Math.abs(scroll.horizontal.position.value) / diff2, 0, 1);
      return Math.round(p2 * 1e4) / 1e4;
    });
    scroll.horizontal.thumbHidden = computed(() => (props4.visible === null ? hover.value : props4.visible) !== true && tempShowing.value === false && panning.value === false || scroll.horizontal.size.value <= container.horizontal.value + 1);
    scroll.horizontal.thumbStart = computed(() => props4.horizontalOffset[0] + scroll.horizontal.percentage.value * (container.horizontalInner.value - scroll.horizontal.thumbSize.value));
    scroll.horizontal.thumbSize = computed(
      () => Math.round(
        between(
          container.horizontalInner.value * container.horizontalInner.value / scroll.horizontal.size.value,
          getMinThumbSize(container.horizontalInner.value),
          container.horizontalInner.value
        )
      )
    );
    scroll.horizontal.style = computed(() => ({
      ...props4.thumbStyle,
      ...props4.horizontalThumbStyle,
      [proxy.$q.lang.rtl === true ? "right" : "left"]: `${scroll.horizontal.thumbStart.value}px`,
      width: `${scroll.horizontal.thumbSize.value}px`,
      bottom: `${props4.verticalOffset[1]}px`
    }));
    scroll.horizontal.thumbClass = computed(() => "q-scrollarea__thumb q-scrollarea__thumb--h absolute-bottom" + (scroll.horizontal.thumbHidden.value === true ? " q-scrollarea__thumb--invisible" : ""));
    scroll.horizontal.barClass = computed(() => "q-scrollarea__bar q-scrollarea__bar--h absolute-bottom" + (scroll.horizontal.thumbHidden.value === true ? " q-scrollarea__bar--invisible" : ""));
    const mainStyle = computed(() => scroll.vertical.thumbHidden.value === true && scroll.horizontal.thumbHidden.value === true ? props4.contentStyle : props4.contentActiveStyle);
    function getScroll() {
      const info = {};
      axisList.forEach((axis) => {
        const data = scroll[axis];
        Object.assign(info, {
          [axis + "Position"]: data.position.value,
          [axis + "Percentage"]: data.percentage.value,
          [axis + "Size"]: data.size.value,
          [axis + "ContainerSize"]: container[axis].value,
          [axis + "ContainerInnerSize"]: container[axis + "Inner"].value
        });
      });
      return info;
    }
    const emitScroll = debounce_default(() => {
      const info = getScroll();
      info.ref = proxy;
      emit("scroll", info);
    }, 0);
    function localSetScrollPosition(axis, offset2, duration2) {
      if (axisList.includes(axis) === false) {
        console.error("[QScrollArea]: wrong first param of setScrollPosition (vertical/horizontal)");
        return;
      }
      const fn = axis === "vertical" ? setVerticalScrollPosition : setHorizontalScrollPosition;
      fn(targetRef.value, offset2, duration2);
    }
    function updateContainer({ height: height2, width: width3 }) {
      let change = false;
      if (container.vertical.value !== height2) {
        container.vertical.value = height2;
        change = true;
      }
      if (container.horizontal.value !== width3) {
        container.horizontal.value = width3;
        change = true;
      }
      change === true && startTimer();
    }
    function updateScroll({ position: position2 }) {
      let change = false;
      if (scroll.vertical.position.value !== position2.top) {
        scroll.vertical.position.value = position2.top;
        change = true;
      }
      if (scroll.horizontal.position.value !== position2.left) {
        scroll.horizontal.position.value = position2.left;
        change = true;
      }
      change === true && startTimer();
    }
    function updateScrollSize({ height: height2, width: width3 }) {
      if (scroll.horizontal.size.value !== width3) {
        scroll.horizontal.size.value = width3;
        startTimer();
      }
      if (scroll.vertical.size.value !== height2) {
        scroll.vertical.size.value = height2;
        startTimer();
      }
    }
    function onPanThumb(e3, axis) {
      const data = scroll[axis];
      if (e3.isFirst === true) {
        if (data.thumbHidden.value === true) return;
        panRefPos = data.position.value;
        panning.value = true;
      } else if (panning.value !== true) {
        return;
      }
      if (e3.isFinal === true) {
        panning.value = false;
      }
      const dProp = dirProps[axis];
      const multiplier = (data.size.value - container[axis].value) / (container[axis + "Inner"].value - data.thumbSize.value);
      const distance = e3.distance[dProp.dist];
      const pos = panRefPos + (e3.direction === dProp.dir ? 1 : -1) * distance * multiplier;
      setScroll3(pos, axis);
    }
    function onMousedown(evt, axis) {
      const data = scroll[axis];
      if (data.thumbHidden.value !== true) {
        const startOffset = axis === "vertical" ? props4.verticalOffset[0] : props4.horizontalOffset[0];
        const offset2 = evt[dirProps[axis].offset] - startOffset;
        const thumbStart = data.thumbStart.value - startOffset;
        if (offset2 < thumbStart || offset2 > thumbStart + data.thumbSize.value) {
          const targetThumbStart = offset2 - data.thumbSize.value / 2;
          const percentage = between(targetThumbStart / (container[axis + "Inner"].value - data.thumbSize.value), 0, 1);
          setScroll3(percentage * Math.max(0, data.size.value - container[axis].value), axis);
        }
        if (data.ref.value !== null) {
          data.ref.value.dispatchEvent(new MouseEvent(evt.type, evt));
        }
      }
    }
    function startTimer() {
      tempShowing.value = true;
      timer2 !== null && clearTimeout(timer2);
      timer2 = setTimeout(() => {
        timer2 = null;
        tempShowing.value = false;
      }, props4.delay);
      props4.onScroll !== void 0 && emitScroll();
    }
    function setScroll3(offset2, axis) {
      targetRef.value[dirProps[axis].scroll] = offset2;
    }
    let mouseEventTimer = null;
    function onMouseenter() {
      if (mouseEventTimer !== null) {
        clearTimeout(mouseEventTimer);
      }
      mouseEventTimer = setTimeout(() => {
        mouseEventTimer = null;
        hover.value = true;
      }, proxy.$q.platform.is.ios ? 50 : 0);
    }
    function onMouseleave() {
      if (mouseEventTimer !== null) {
        clearTimeout(mouseEventTimer);
        mouseEventTimer = null;
      }
      hover.value = false;
    }
    let scrollPosition = null;
    watch(() => proxy.$q.lang.rtl, (rtl) => {
      if (targetRef.value !== null) {
        setHorizontalScrollPosition(
          targetRef.value,
          Math.abs(scroll.horizontal.position.value) * (rtl === true ? -1 : 1)
        );
      }
    });
    onDeactivated(() => {
      scrollPosition = {
        top: scroll.vertical.position.value,
        left: scroll.horizontal.position.value
      };
    });
    onActivated(() => {
      if (scrollPosition === null) return;
      const scrollTarget = targetRef.value;
      if (scrollTarget !== null) {
        setHorizontalScrollPosition(scrollTarget, scrollPosition.left);
        setVerticalScrollPosition(scrollTarget, scrollPosition.top);
      }
    });
    onBeforeUnmount(emitScroll.cancel);
    Object.assign(proxy, {
      getScrollTarget: () => targetRef.value,
      getScroll,
      getScrollPosition: () => ({
        top: scroll.vertical.position.value,
        left: scroll.horizontal.position.value
      }),
      getScrollPercentage: () => ({
        top: scroll.vertical.percentage.value,
        left: scroll.horizontal.percentage.value
      }),
      setScrollPosition: localSetScrollPosition,
      setScrollPercentage(axis, percentage, duration2) {
        localSetScrollPosition(
          axis,
          percentage * (scroll[axis].size.value - container[axis].value) * (axis === "horizontal" && proxy.$q.lang.rtl === true ? -1 : 1),
          duration2
        );
      }
    });
    const store = {
      scroll,
      thumbVertDir: [[
        TouchPan_default,
        (e3) => {
          onPanThumb(e3, "vertical");
        },
        void 0,
        { vertical: true, ...panOpts }
      ]],
      thumbHorizDir: [[
        TouchPan_default,
        (e3) => {
          onPanThumb(e3, "horizontal");
        },
        void 0,
        { horizontal: true, ...panOpts }
      ]],
      onVerticalMousedown(evt) {
        onMousedown(evt, "vertical");
      },
      onHorizontalMousedown(evt) {
        onMousedown(evt, "horizontal");
      }
    };
    return () => {
      return h("div", {
        class: classes.value,
        onMouseenter,
        onMouseleave
      }, [
        h("div", {
          ref: targetRef,
          class: "q-scrollarea__container scroll relative-position fit hide-scrollbar",
          tabindex: props4.tabindex !== void 0 ? props4.tabindex : void 0
        }, [
          h("div", {
            class: "q-scrollarea__content absolute",
            style: mainStyle.value
          }, hMergeSlot(slots.default, [
            h(QResizeObserver_default, {
              debounce: 0,
              onResize: updateScrollSize
            })
          ])),
          h(QScrollObserver_default, {
            axis: "both",
            onScroll: updateScroll
          })
        ]),
        h(QResizeObserver_default, {
          debounce: 0,
          onResize: updateContainer
        }),
        h(ScrollAreaControls_default, {
          store,
          barStyle: props4.barStyle,
          verticalBarStyle: props4.verticalBarStyle,
          horizontalBarStyle: props4.horizontalBarStyle
        })
      ]);
    };
  }
});
var aggBucketSize = 1e3;
var scrollToEdges = [
  "start",
  "center",
  "end",
  "start-force",
  "center-force",
  "end-force"
];
var filterProto = Array.prototype.filter;
var setOverflowAnchor = __QUASAR_SSR__ || window.getComputedStyle(document.body).overflowAnchor === void 0 ? noop : function(contentEl, index2) {
  if (contentEl === null) return;
  if (contentEl._qOverflowAnimationFrame !== void 0) {
    cancelAnimationFrame(contentEl._qOverflowAnimationFrame);
  }
  contentEl._qOverflowAnimationFrame = requestAnimationFrame(() => {
    if (contentEl === null) return;
    contentEl._qOverflowAnimationFrame = void 0;
    const children = contentEl.children || [];
    filterProto.call(children, (el2) => el2.dataset && el2.dataset.qVsAnchor !== void 0).forEach((el2) => {
      delete el2.dataset.qVsAnchor;
    });
    const el = children[index2];
    if (el == null ? void 0 : el.dataset) {
      el.dataset.qVsAnchor = "";
    }
  });
};
function sumFn(acc, h138) {
  return acc + h138;
}
function getScrollDetails(parent, child, beforeRef, afterRef, horizontal, rtl, stickyStart, stickyEnd) {
  const parentCalc = parent === window ? document.scrollingElement || document.documentElement : parent, propElSize = horizontal === true ? "offsetWidth" : "offsetHeight", details = {
    scrollStart: 0,
    scrollViewSize: -stickyStart - stickyEnd,
    scrollMaxSize: 0,
    offsetStart: -stickyStart,
    offsetEnd: -stickyEnd
  };
  if (horizontal === true) {
    if (parent === window) {
      details.scrollStart = window.pageXOffset || window.scrollX || document.body.scrollLeft || 0;
      details.scrollViewSize += document.documentElement.clientWidth;
    } else {
      details.scrollStart = parentCalc.scrollLeft;
      details.scrollViewSize += parentCalc.clientWidth;
    }
    details.scrollMaxSize = parentCalc.scrollWidth;
    if (rtl === true) {
      details.scrollStart = (rtlHasScrollBug === true ? details.scrollMaxSize - details.scrollViewSize : 0) - details.scrollStart;
    }
  } else {
    if (parent === window) {
      details.scrollStart = window.pageYOffset || window.scrollY || document.body.scrollTop || 0;
      details.scrollViewSize += document.documentElement.clientHeight;
    } else {
      details.scrollStart = parentCalc.scrollTop;
      details.scrollViewSize += parentCalc.clientHeight;
    }
    details.scrollMaxSize = parentCalc.scrollHeight;
  }
  if (beforeRef !== null) {
    for (let el = beforeRef.previousElementSibling; el !== null; el = el.previousElementSibling) {
      if (el.classList.contains("q-virtual-scroll--skip") === false) {
        details.offsetStart += el[propElSize];
      }
    }
  }
  if (afterRef !== null) {
    for (let el = afterRef.nextElementSibling; el !== null; el = el.nextElementSibling) {
      if (el.classList.contains("q-virtual-scroll--skip") === false) {
        details.offsetEnd += el[propElSize];
      }
    }
  }
  if (child !== parent) {
    const parentRect = parentCalc.getBoundingClientRect(), childRect = child.getBoundingClientRect();
    if (horizontal === true) {
      details.offsetStart += childRect.left - parentRect.left;
      details.offsetEnd -= childRect.width;
    } else {
      details.offsetStart += childRect.top - parentRect.top;
      details.offsetEnd -= childRect.height;
    }
    if (parent !== window) {
      details.offsetStart += details.scrollStart;
    }
    details.offsetEnd += details.scrollMaxSize - details.offsetStart;
  }
  return details;
}
function setScroll2(parent, scroll, horizontal, rtl) {
  if (scroll === "end") {
    scroll = (parent === window ? document.body : parent)[horizontal === true ? "scrollWidth" : "scrollHeight"];
  }
  if (parent === window) {
    if (horizontal === true) {
      if (rtl === true) {
        scroll = (rtlHasScrollBug === true ? document.body.scrollWidth - document.documentElement.clientWidth : 0) - scroll;
      }
      window.scrollTo(scroll, window.pageYOffset || window.scrollY || document.body.scrollTop || 0);
    } else {
      window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, scroll);
    }
  } else if (horizontal === true) {
    if (rtl === true) {
      scroll = (rtlHasScrollBug === true ? parent.scrollWidth - parent.offsetWidth : 0) - scroll;
    }
    parent.scrollLeft = scroll;
  } else {
    parent.scrollTop = scroll;
  }
}
function sumSize(sizeAgg, size2, from2, to2) {
  if (from2 >= to2) {
    return 0;
  }
  const lastTo = size2.length, fromAgg = Math.floor(from2 / aggBucketSize), toAgg = Math.floor((to2 - 1) / aggBucketSize) + 1;
  let total = sizeAgg.slice(fromAgg, toAgg).reduce(sumFn, 0);
  if (from2 % aggBucketSize !== 0) {
    total -= size2.slice(fromAgg * aggBucketSize, from2).reduce(sumFn, 0);
  }
  if (to2 % aggBucketSize !== 0 && to2 !== lastTo) {
    total -= size2.slice(to2, toAgg * aggBucketSize).reduce(sumFn, 0);
  }
  return total;
}
var commonVirtScrollProps = {
  virtualScrollSliceSize: {
    type: [Number, String],
    default: 10
  },
  virtualScrollSliceRatioBefore: {
    type: [Number, String],
    default: 1
  },
  virtualScrollSliceRatioAfter: {
    type: [Number, String],
    default: 1
  },
  virtualScrollItemSize: {
    type: [Number, String],
    default: 24
  },
  virtualScrollStickySizeStart: {
    type: [Number, String],
    default: 0
  },
  virtualScrollStickySizeEnd: {
    type: [Number, String],
    default: 0
  },
  tableColspan: [Number, String]
};
var commonVirtScrollPropsList = Object.keys(commonVirtScrollProps);
var useVirtualScrollProps = {
  virtualScrollHorizontal: Boolean,
  onVirtualScroll: Function,
  ...commonVirtScrollProps
};
function useVirtualScroll({
  virtualScrollLength,
  getVirtualScrollTarget,
  getVirtualScrollEl,
  virtualScrollItemSizeComputed
  // optional
}) {
  const vm2 = getCurrentInstance();
  const { props: props4, emit, proxy } = vm2;
  const { $q } = proxy;
  let prevScrollStart, prevToIndex, localScrollViewSize, virtualScrollSizesAgg = [], virtualScrollSizes;
  const virtualScrollPaddingBefore = ref$1(0);
  const virtualScrollPaddingAfter = ref$1(0);
  const virtualScrollSliceSizeComputed = ref$1({});
  const beforeRef = ref$1(null);
  const afterRef = ref$1(null);
  const contentRef = ref$1(null);
  const virtualScrollSliceRange = ref$1({ from: 0, to: 0 });
  const colspanAttr = computed(() => props4.tableColspan !== void 0 ? props4.tableColspan : 100);
  if (virtualScrollItemSizeComputed === void 0) {
    virtualScrollItemSizeComputed = computed(() => props4.virtualScrollItemSize);
  }
  const needsReset = computed(() => virtualScrollItemSizeComputed.value + ";" + props4.virtualScrollHorizontal);
  const needsSliceRecalc = computed(
    () => needsReset.value + ";" + props4.virtualScrollSliceRatioBefore + ";" + props4.virtualScrollSliceRatioAfter
  );
  watch(needsSliceRecalc, () => {
    setVirtualScrollSize();
  });
  watch(needsReset, reset);
  function reset() {
    localResetVirtualScroll(prevToIndex, true);
  }
  function refresh(toIndex) {
    localResetVirtualScroll(toIndex === void 0 ? prevToIndex : toIndex);
  }
  function scrollTo(toIndex, edge) {
    const scrollEl = getVirtualScrollTarget();
    if (scrollEl === void 0 || scrollEl === null || scrollEl.nodeType === 8) return;
    const scrollDetails = getScrollDetails(
      scrollEl,
      getVirtualScrollEl(),
      beforeRef.value,
      afterRef.value,
      props4.virtualScrollHorizontal,
      $q.lang.rtl,
      props4.virtualScrollStickySizeStart,
      props4.virtualScrollStickySizeEnd
    );
    localScrollViewSize !== scrollDetails.scrollViewSize && setVirtualScrollSize(scrollDetails.scrollViewSize);
    setVirtualScrollSliceRange(
      scrollEl,
      scrollDetails,
      Math.min(virtualScrollLength.value - 1, Math.max(0, parseInt(toIndex, 10) || 0)),
      0,
      scrollToEdges.indexOf(edge) !== -1 ? edge : prevToIndex !== -1 && toIndex > prevToIndex ? "end" : "start"
    );
  }
  function localOnVirtualScrollEvt() {
    const scrollEl = getVirtualScrollTarget();
    if (scrollEl === void 0 || scrollEl === null || scrollEl.nodeType === 8) return;
    const scrollDetails = getScrollDetails(
      scrollEl,
      getVirtualScrollEl(),
      beforeRef.value,
      afterRef.value,
      props4.virtualScrollHorizontal,
      $q.lang.rtl,
      props4.virtualScrollStickySizeStart,
      props4.virtualScrollStickySizeEnd
    ), listLastIndex = virtualScrollLength.value - 1, listEndOffset = scrollDetails.scrollMaxSize - scrollDetails.offsetStart - scrollDetails.offsetEnd - virtualScrollPaddingAfter.value;
    if (prevScrollStart === scrollDetails.scrollStart) return;
    if (scrollDetails.scrollMaxSize <= 0) {
      setVirtualScrollSliceRange(scrollEl, scrollDetails, 0, 0);
      return;
    }
    localScrollViewSize !== scrollDetails.scrollViewSize && setVirtualScrollSize(scrollDetails.scrollViewSize);
    updateVirtualScrollSizes(virtualScrollSliceRange.value.from);
    const scrollMaxStart = Math.floor(scrollDetails.scrollMaxSize - Math.max(scrollDetails.scrollViewSize, scrollDetails.offsetEnd) - Math.min(virtualScrollSizes[listLastIndex], scrollDetails.scrollViewSize / 2));
    if (scrollMaxStart > 0 && Math.ceil(scrollDetails.scrollStart) >= scrollMaxStart) {
      setVirtualScrollSliceRange(
        scrollEl,
        scrollDetails,
        listLastIndex,
        scrollDetails.scrollMaxSize - scrollDetails.offsetEnd - virtualScrollSizesAgg.reduce(sumFn, 0)
      );
      return;
    }
    let toIndex = 0, listOffset = scrollDetails.scrollStart - scrollDetails.offsetStart, offset2 = listOffset;
    if (listOffset <= listEndOffset && listOffset + scrollDetails.scrollViewSize >= virtualScrollPaddingBefore.value) {
      listOffset -= virtualScrollPaddingBefore.value;
      toIndex = virtualScrollSliceRange.value.from;
      offset2 = listOffset;
    } else {
      for (let j = 0; listOffset >= virtualScrollSizesAgg[j] && toIndex < listLastIndex; j++) {
        listOffset -= virtualScrollSizesAgg[j];
        toIndex += aggBucketSize;
      }
    }
    while (listOffset > 0 && toIndex < listLastIndex) {
      listOffset -= virtualScrollSizes[toIndex];
      if (listOffset > -scrollDetails.scrollViewSize) {
        toIndex++;
        offset2 = listOffset;
      } else {
        offset2 = virtualScrollSizes[toIndex] + listOffset;
      }
    }
    setVirtualScrollSliceRange(
      scrollEl,
      scrollDetails,
      toIndex,
      offset2
    );
  }
  function setVirtualScrollSliceRange(scrollEl, scrollDetails, toIndex, offset2, align) {
    const alignForce = typeof align === "string" && align.indexOf("-force") !== -1;
    const alignEnd = alignForce === true ? align.replace("-force", "") : align;
    const alignRange = alignEnd !== void 0 ? alignEnd : "start";
    let from2 = Math.max(0, toIndex - virtualScrollSliceSizeComputed.value[alignRange]), to2 = from2 + virtualScrollSliceSizeComputed.value.total;
    if (to2 > virtualScrollLength.value) {
      to2 = virtualScrollLength.value;
      from2 = Math.max(0, to2 - virtualScrollSliceSizeComputed.value.total);
    }
    prevScrollStart = scrollDetails.scrollStart;
    const rangeChanged = from2 !== virtualScrollSliceRange.value.from || to2 !== virtualScrollSliceRange.value.to;
    if (rangeChanged === false && alignEnd === void 0) {
      emitScroll(toIndex);
      return;
    }
    const { activeElement } = document;
    const contentEl = contentRef.value;
    if (rangeChanged === true && contentEl !== null && contentEl !== activeElement && contentEl.contains(activeElement) === true) {
      contentEl.addEventListener("focusout", onBlurRefocusFn);
      setTimeout(() => {
        contentEl == null ? void 0 : contentEl.removeEventListener("focusout", onBlurRefocusFn);
      });
    }
    setOverflowAnchor(contentEl, toIndex - from2);
    const sizeBefore = alignEnd !== void 0 ? virtualScrollSizes.slice(from2, toIndex).reduce(sumFn, 0) : 0;
    if (rangeChanged === true) {
      const tempTo = to2 >= virtualScrollSliceRange.value.from && from2 <= virtualScrollSliceRange.value.to ? virtualScrollSliceRange.value.to : to2;
      virtualScrollSliceRange.value = { from: from2, to: tempTo };
      virtualScrollPaddingBefore.value = sumSize(virtualScrollSizesAgg, virtualScrollSizes, 0, from2);
      virtualScrollPaddingAfter.value = sumSize(virtualScrollSizesAgg, virtualScrollSizes, to2, virtualScrollLength.value);
      requestAnimationFrame(() => {
        if (virtualScrollSliceRange.value.to !== to2 && prevScrollStart === scrollDetails.scrollStart) {
          virtualScrollSliceRange.value = { from: virtualScrollSliceRange.value.from, to: to2 };
          virtualScrollPaddingAfter.value = sumSize(virtualScrollSizesAgg, virtualScrollSizes, to2, virtualScrollLength.value);
        }
      });
    }
    requestAnimationFrame(() => {
      if (prevScrollStart !== scrollDetails.scrollStart) return;
      if (rangeChanged === true) {
        updateVirtualScrollSizes(from2);
      }
      const sizeAfter = virtualScrollSizes.slice(from2, toIndex).reduce(sumFn, 0), posStart = sizeAfter + scrollDetails.offsetStart + virtualScrollPaddingBefore.value, posEnd = posStart + virtualScrollSizes[toIndex];
      let scrollPosition = posStart + offset2;
      if (alignEnd !== void 0) {
        const sizeDiff = sizeAfter - sizeBefore;
        const scrollStart = scrollDetails.scrollStart + sizeDiff;
        scrollPosition = alignForce !== true && scrollStart < posStart && posEnd < scrollStart + scrollDetails.scrollViewSize ? scrollStart : alignEnd === "end" ? posEnd - scrollDetails.scrollViewSize : posStart - (alignEnd === "start" ? 0 : Math.round((scrollDetails.scrollViewSize - virtualScrollSizes[toIndex]) / 2));
      }
      prevScrollStart = scrollPosition;
      setScroll2(
        scrollEl,
        scrollPosition,
        props4.virtualScrollHorizontal,
        $q.lang.rtl
      );
      emitScroll(toIndex);
    });
  }
  function updateVirtualScrollSizes(from2) {
    const contentEl = contentRef.value;
    if (contentEl) {
      const children = filterProto.call(
        contentEl.children,
        (el) => el.classList && el.classList.contains("q-virtual-scroll--skip") === false
      ), childrenLength = children.length, sizeFn = props4.virtualScrollHorizontal === true ? (el) => el.getBoundingClientRect().width : (el) => el.offsetHeight;
      let index2 = from2, size2, diff2;
      for (let i3 = 0; i3 < childrenLength; ) {
        size2 = sizeFn(children[i3]);
        i3++;
        while (i3 < childrenLength && children[i3].classList.contains("q-virtual-scroll--with-prev") === true) {
          size2 += sizeFn(children[i3]);
          i3++;
        }
        diff2 = size2 - virtualScrollSizes[index2];
        if (diff2 !== 0) {
          virtualScrollSizes[index2] += diff2;
          virtualScrollSizesAgg[Math.floor(index2 / aggBucketSize)] += diff2;
        }
        index2++;
      }
    }
  }
  function onBlurRefocusFn() {
    var _a;
    (_a = contentRef.value) == null ? void 0 : _a.focus();
  }
  function localResetVirtualScroll(toIndex, fullReset) {
    const defaultSize = 1 * virtualScrollItemSizeComputed.value;
    if (fullReset === true || Array.isArray(virtualScrollSizes) === false) {
      virtualScrollSizes = [];
    }
    const oldVirtualScrollSizesLength = virtualScrollSizes.length;
    virtualScrollSizes.length = virtualScrollLength.value;
    for (let i3 = virtualScrollLength.value - 1; i3 >= oldVirtualScrollSizesLength; i3--) {
      virtualScrollSizes[i3] = defaultSize;
    }
    const jMax = Math.floor((virtualScrollLength.value - 1) / aggBucketSize);
    virtualScrollSizesAgg = [];
    for (let j = 0; j <= jMax; j++) {
      let size2 = 0;
      const iMax = Math.min((j + 1) * aggBucketSize, virtualScrollLength.value);
      for (let i3 = j * aggBucketSize; i3 < iMax; i3++) {
        size2 += virtualScrollSizes[i3];
      }
      virtualScrollSizesAgg.push(size2);
    }
    prevToIndex = -1;
    prevScrollStart = void 0;
    virtualScrollPaddingBefore.value = sumSize(virtualScrollSizesAgg, virtualScrollSizes, 0, virtualScrollSliceRange.value.from);
    virtualScrollPaddingAfter.value = sumSize(virtualScrollSizesAgg, virtualScrollSizes, virtualScrollSliceRange.value.to, virtualScrollLength.value);
    if (toIndex >= 0) {
      updateVirtualScrollSizes(virtualScrollSliceRange.value.from);
      nextTick(() => {
        scrollTo(toIndex);
      });
    } else {
      onVirtualScrollEvt();
    }
  }
  function setVirtualScrollSize(scrollViewSize) {
    if (scrollViewSize === void 0 && typeof window !== "undefined") {
      const scrollEl = getVirtualScrollTarget();
      if (scrollEl !== void 0 && scrollEl !== null && scrollEl.nodeType !== 8) {
        scrollViewSize = getScrollDetails(
          scrollEl,
          getVirtualScrollEl(),
          beforeRef.value,
          afterRef.value,
          props4.virtualScrollHorizontal,
          $q.lang.rtl,
          props4.virtualScrollStickySizeStart,
          props4.virtualScrollStickySizeEnd
        ).scrollViewSize;
      }
    }
    localScrollViewSize = scrollViewSize;
    const virtualScrollSliceRatioBefore = parseFloat(props4.virtualScrollSliceRatioBefore) || 0;
    const virtualScrollSliceRatioAfter = parseFloat(props4.virtualScrollSliceRatioAfter) || 0;
    const multiplier = 1 + virtualScrollSliceRatioBefore + virtualScrollSliceRatioAfter;
    const view = scrollViewSize === void 0 || scrollViewSize <= 0 ? 1 : Math.ceil(scrollViewSize / virtualScrollItemSizeComputed.value);
    const baseSize = Math.max(
      1,
      view,
      Math.ceil((props4.virtualScrollSliceSize > 0 ? props4.virtualScrollSliceSize : 10) / multiplier)
    );
    virtualScrollSliceSizeComputed.value = {
      total: Math.ceil(baseSize * multiplier),
      start: Math.ceil(baseSize * virtualScrollSliceRatioBefore),
      center: Math.ceil(baseSize * (0.5 + virtualScrollSliceRatioBefore)),
      end: Math.ceil(baseSize * (1 + virtualScrollSliceRatioBefore)),
      view
    };
  }
  function padVirtualScroll(tag, content) {
    const paddingSize = props4.virtualScrollHorizontal === true ? "width" : "height";
    const style2 = {
      ["--q-virtual-scroll-item-" + paddingSize]: virtualScrollItemSizeComputed.value + "px"
    };
    return [
      tag === "tbody" ? h(tag, {
        class: "q-virtual-scroll__padding",
        key: "before",
        ref: beforeRef
      }, [
        h("tr", [
          h("td", {
            style: { [paddingSize]: `${virtualScrollPaddingBefore.value}px`, ...style2 },
            colspan: colspanAttr.value
          })
        ])
      ]) : h(tag, {
        class: "q-virtual-scroll__padding",
        key: "before",
        ref: beforeRef,
        style: { [paddingSize]: `${virtualScrollPaddingBefore.value}px`, ...style2 }
      }),
      h(tag, {
        class: "q-virtual-scroll__content",
        key: "content",
        ref: contentRef,
        tabindex: -1
      }, content.flat()),
      tag === "tbody" ? h(tag, {
        class: "q-virtual-scroll__padding",
        key: "after",
        ref: afterRef
      }, [
        h("tr", [
          h("td", {
            style: { [paddingSize]: `${virtualScrollPaddingAfter.value}px`, ...style2 },
            colspan: colspanAttr.value
          })
        ])
      ]) : h(tag, {
        class: "q-virtual-scroll__padding",
        key: "after",
        ref: afterRef,
        style: { [paddingSize]: `${virtualScrollPaddingAfter.value}px`, ...style2 }
      })
    ];
  }
  function emitScroll(index2) {
    if (prevToIndex !== index2) {
      props4.onVirtualScroll !== void 0 && emit("virtualScroll", {
        index: index2,
        from: virtualScrollSliceRange.value.from,
        to: virtualScrollSliceRange.value.to - 1,
        direction: index2 < prevToIndex ? "decrease" : "increase",
        ref: proxy
      });
      prevToIndex = index2;
    }
  }
  setVirtualScrollSize();
  const onVirtualScrollEvt = debounce_default(
    localOnVirtualScrollEvt,
    $q.platform.is.ios === true ? 120 : 35
  );
  onBeforeMount(() => {
    setVirtualScrollSize();
  });
  let shouldActivate = false;
  onDeactivated(() => {
    shouldActivate = true;
  });
  onActivated(() => {
    if (shouldActivate !== true) return;
    const scrollEl = getVirtualScrollTarget();
    if (prevScrollStart !== void 0 && scrollEl !== void 0 && scrollEl !== null && scrollEl.nodeType !== 8) {
      setScroll2(
        scrollEl,
        prevScrollStart,
        props4.virtualScrollHorizontal,
        $q.lang.rtl
      );
    } else {
      scrollTo(prevToIndex);
    }
  });
  __QUASAR_SSR__ || onBeforeUnmount(() => {
    onVirtualScrollEvt.cancel();
  });
  Object.assign(proxy, { scrollTo, reset, refresh });
  return {
    virtualScrollSliceRange,
    virtualScrollSliceSizeComputed,
    setVirtualScrollSize,
    onVirtualScrollEvt,
    localResetVirtualScroll,
    padVirtualScroll,
    scrollTo,
    reset,
    refresh
  };
}
var validateNewValueMode = (v) => ["add", "add-unique", "toggle"].includes(v);
var reEscapeList = ".*+?^${}()|[]\\";
var fieldPropsList = Object.keys(useFieldProps);
function getPropValueFn2(userPropName, defaultPropName) {
  if (typeof userPropName === "function") return userPropName;
  const propName = userPropName !== void 0 ? userPropName : defaultPropName;
  return (opt) => opt !== null && typeof opt === "object" && propName in opt ? opt[propName] : opt;
}
var QSelect_default = createComponent({
  name: "QSelect",
  inheritAttrs: false,
  props: {
    ...useVirtualScrollProps,
    ...useFormProps,
    ...useFieldProps,
    // override of useFieldProps > modelValue
    modelValue: {
      required: true
    },
    multiple: Boolean,
    displayValue: [String, Number],
    displayValueHtml: Boolean,
    dropdownIcon: String,
    options: {
      type: Array,
      default: () => []
    },
    optionValue: [Function, String],
    optionLabel: [Function, String],
    optionDisable: [Function, String],
    hideSelected: Boolean,
    hideDropdownIcon: Boolean,
    fillInput: Boolean,
    maxValues: [Number, String],
    optionsDense: Boolean,
    optionsDark: {
      type: Boolean,
      default: null
    },
    optionsSelectedClass: String,
    optionsHtml: Boolean,
    optionsCover: Boolean,
    menuShrink: Boolean,
    menuAnchor: String,
    menuSelf: String,
    menuOffset: Array,
    popupContentClass: String,
    popupContentStyle: [String, Array, Object],
    popupNoRouteDismiss: Boolean,
    useInput: Boolean,
    useChips: Boolean,
    newValueMode: {
      type: String,
      validator: validateNewValueMode
    },
    mapOptions: Boolean,
    emitValue: Boolean,
    disableTabSelection: Boolean,
    inputDebounce: {
      type: [Number, String],
      default: 500
    },
    inputClass: [Array, String, Object],
    inputStyle: [Array, String, Object],
    tabindex: {
      type: [String, Number],
      default: 0
    },
    autocomplete: String,
    transitionShow: {},
    transitionHide: {},
    transitionDuration: {},
    behavior: {
      type: String,
      validator: (v) => ["default", "menu", "dialog"].includes(v),
      default: "default"
    },
    // override of useVirtualScrollProps > virtualScrollItemSize (no default)
    virtualScrollItemSize: useVirtualScrollProps.virtualScrollItemSize.type,
    onNewValue: Function,
    onFilter: Function
  },
  emits: [
    ...useFieldEmits,
    "add",
    "remove",
    "inputValue",
    "keyup",
    "keypress",
    "keydown",
    "popupShow",
    "popupHide",
    "filterAbort"
  ],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const menu = ref$1(false);
    const dialog = ref$1(false);
    const optionIndex = ref$1(-1);
    const inputValue = ref$1("");
    const dialogFieldFocused = ref$1(false);
    const innerLoadingIndicator = ref$1(false);
    let filterTimer = null, inputValueTimer = null, innerValueCache, hasDialog, userInputValue, filterId = null, defaultInputValue, transitionShowComputed, searchBuffer, searchBufferExp;
    const inputRef = ref$1(null);
    const targetRef = ref$1(null);
    const menuRef = ref$1(null);
    const dialogRef = ref$1(null);
    const menuContentRef = ref$1(null);
    const nameProp = useFormInputNameAttr(props4);
    const onComposition = use_key_composition_default(onInput);
    const virtualScrollLength = computed(() => Array.isArray(props4.options) ? props4.options.length : 0);
    const virtualScrollItemSizeComputed = computed(() => props4.virtualScrollItemSize === void 0 ? props4.optionsDense === true ? 24 : 48 : props4.virtualScrollItemSize);
    const {
      virtualScrollSliceRange,
      virtualScrollSliceSizeComputed,
      localResetVirtualScroll,
      padVirtualScroll,
      onVirtualScrollEvt,
      scrollTo,
      setVirtualScrollSize
    } = useVirtualScroll({
      virtualScrollLength,
      getVirtualScrollTarget,
      getVirtualScrollEl,
      virtualScrollItemSizeComputed
    });
    const state2 = useFieldState();
    const innerValue = computed(() => {
      const mapNull = props4.mapOptions === true && props4.multiple !== true, val = props4.modelValue !== void 0 && (props4.modelValue !== null || mapNull === true) ? props4.multiple === true && Array.isArray(props4.modelValue) ? props4.modelValue : [props4.modelValue] : [];
      if (props4.mapOptions === true && Array.isArray(props4.options) === true) {
        const cache = props4.mapOptions === true && innerValueCache !== void 0 ? innerValueCache : [];
        const values = val.map((v) => getOption(v, cache));
        return props4.modelValue === null && mapNull === true ? values.filter((v) => v !== null) : values;
      }
      return val;
    });
    const innerFieldProps = computed(() => {
      const acc = {};
      fieldPropsList.forEach((key) => {
        const val = props4[key];
        if (val !== void 0) {
          acc[key] = val;
        }
      });
      return acc;
    });
    const isOptionsDark = computed(() => props4.optionsDark === null ? state2.isDark.value : props4.optionsDark);
    const hasValue = computed(() => fieldValueIsFilled(innerValue.value));
    const computedInputClass = computed(() => {
      let cls = "q-field__input q-placeholder col";
      if (props4.hideSelected === true || innerValue.value.length === 0) {
        return [cls, props4.inputClass];
      }
      cls += " q-field__input--padding";
      return props4.inputClass === void 0 ? cls : [cls, props4.inputClass];
    });
    const menuContentClass = computed(
      () => (props4.virtualScrollHorizontal === true ? "q-virtual-scroll--horizontal" : "") + (props4.popupContentClass ? " " + props4.popupContentClass : "")
    );
    const noOptions = computed(() => virtualScrollLength.value === 0);
    const selectedString = computed(
      () => innerValue.value.map((opt) => getOptionLabel.value(opt)).join(", ")
    );
    const ariaCurrentValue = computed(() => props4.displayValue !== void 0 ? props4.displayValue : selectedString.value);
    const needsHtmlFn = computed(() => props4.optionsHtml === true ? () => true : (opt) => (opt == null ? void 0 : opt.html) === true);
    const valueAsHtml = computed(() => props4.displayValueHtml === true || props4.displayValue === void 0 && (props4.optionsHtml === true || innerValue.value.some(needsHtmlFn.value)));
    const tabindex = computed(() => state2.focused.value === true ? props4.tabindex : -1);
    const comboboxAttrs = computed(() => {
      const attrs = {
        tabindex: props4.tabindex,
        role: "combobox",
        "aria-label": props4.label,
        "aria-readonly": props4.readonly === true ? "true" : "false",
        "aria-autocomplete": props4.useInput === true ? "list" : "none",
        "aria-expanded": menu.value === true ? "true" : "false",
        "aria-controls": `${state2.targetUid.value}_lb`
      };
      if (optionIndex.value >= 0) {
        attrs["aria-activedescendant"] = `${state2.targetUid.value}_${optionIndex.value}`;
      }
      return attrs;
    });
    const listboxAttrs = computed(() => ({
      id: `${state2.targetUid.value}_lb`,
      role: "listbox",
      "aria-multiselectable": props4.multiple === true ? "true" : "false"
    }));
    const selectedScope = computed(() => {
      return innerValue.value.map((opt, i3) => ({
        index: i3,
        opt,
        html: needsHtmlFn.value(opt),
        selected: true,
        removeAtIndex: removeAtIndexAndFocus,
        toggleOption,
        tabindex: tabindex.value
      }));
    });
    const optionScope = computed(() => {
      if (virtualScrollLength.value === 0) {
        return [];
      }
      const { from: from2, to: to2 } = virtualScrollSliceRange.value;
      return props4.options.slice(from2, to2).map((opt, i3) => {
        const disable = isOptionDisabled.value(opt) === true;
        const active = isOptionSelected(opt) === true;
        const index2 = from2 + i3;
        const itemProps = {
          clickable: true,
          active,
          activeClass: computedOptionsSelectedClass.value,
          manualFocus: true,
          focused: false,
          disable,
          tabindex: -1,
          dense: props4.optionsDense,
          dark: isOptionsDark.value,
          role: "option",
          "aria-selected": active === true ? "true" : "false",
          id: `${state2.targetUid.value}_${index2}`,
          onClick: () => {
            toggleOption(opt);
          }
        };
        if (disable !== true) {
          optionIndex.value === index2 && (itemProps.focused = true);
          if ($q.platform.is.desktop === true) {
            itemProps.onMousemove = () => {
              menu.value === true && setOptionIndex(index2);
            };
          }
        }
        return {
          index: index2,
          opt,
          html: needsHtmlFn.value(opt),
          label: getOptionLabel.value(opt),
          selected: itemProps.active,
          focused: itemProps.focused,
          toggleOption,
          setOptionIndex,
          itemProps
        };
      });
    });
    const dropdownArrowIcon = computed(() => props4.dropdownIcon !== void 0 ? props4.dropdownIcon : $q.iconSet.arrow.dropdown);
    const squaredMenu = computed(
      () => props4.optionsCover === false && props4.outlined !== true && props4.standout !== true && props4.borderless !== true && props4.rounded !== true
    );
    const computedOptionsSelectedClass = computed(() => props4.optionsSelectedClass !== void 0 ? props4.optionsSelectedClass : props4.color !== void 0 ? `text-${props4.color}` : "");
    const getOptionValue = computed(() => getPropValueFn2(props4.optionValue, "value"));
    const getOptionLabel = computed(() => getPropValueFn2(props4.optionLabel, "label"));
    const isOptionDisabled = computed(() => getPropValueFn2(props4.optionDisable, "disable"));
    const innerOptionsValue = computed(() => innerValue.value.map(getOptionValue.value));
    const inputControlEvents = computed(() => {
      const evt = {
        onInput,
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        onChange: onComposition,
        onKeydown: onTargetKeydown,
        onKeyup: onTargetAutocomplete,
        onKeypress: onTargetKeypress,
        onFocus: selectInputText,
        onClick(e3) {
          hasDialog === true && stop(e3);
        }
      };
      evt.onCompositionstart = evt.onCompositionupdate = evt.onCompositionend = onComposition;
      return evt;
    });
    watch(innerValue, (val) => {
      innerValueCache = val;
      if (props4.useInput === true && props4.fillInput === true && props4.multiple !== true && state2.innerLoading.value !== true && (dialog.value !== true && menu.value !== true || hasValue.value !== true)) {
        userInputValue !== true && resetInputValue();
        if (dialog.value === true || menu.value === true) {
          filter("");
        }
      }
    }, { immediate: true });
    watch(() => props4.fillInput, resetInputValue);
    watch(menu, updateMenu);
    watch(virtualScrollLength, rerenderMenu);
    function getEmittingOptionValue(opt) {
      return props4.emitValue === true ? getOptionValue.value(opt) : opt;
    }
    function removeAtIndex(index2) {
      if (index2 !== -1 && index2 < innerValue.value.length) {
        if (props4.multiple === true) {
          const model = props4.modelValue.slice();
          emit("remove", { index: index2, value: model.splice(index2, 1)[0] });
          emit("update:modelValue", model);
        } else {
          emit("update:modelValue", null);
        }
      }
    }
    function removeAtIndexAndFocus(index2) {
      removeAtIndex(index2);
      state2.focus();
    }
    function add2(opt, unique) {
      const val = getEmittingOptionValue(opt);
      if (props4.multiple !== true) {
        props4.fillInput === true && updateInputValue(
          getOptionLabel.value(opt),
          true,
          true
        );
        emit("update:modelValue", val);
        return;
      }
      if (innerValue.value.length === 0) {
        emit("add", { index: 0, value: val });
        emit("update:modelValue", props4.multiple === true ? [val] : val);
        return;
      }
      if (unique === true && isOptionSelected(opt) === true) return;
      if (props4.maxValues !== void 0 && props4.modelValue.length >= props4.maxValues) return;
      const model = props4.modelValue.slice();
      emit("add", { index: model.length, value: val });
      model.push(val);
      emit("update:modelValue", model);
    }
    function toggleOption(opt, keepOpen) {
      var _a;
      if (state2.editable.value !== true || opt === void 0 || isOptionDisabled.value(opt) === true) return;
      const optValue = getOptionValue.value(opt);
      if (props4.multiple !== true) {
        if (keepOpen !== true) {
          updateInputValue(
            props4.fillInput === true ? getOptionLabel.value(opt) : "",
            true,
            true
          );
          hidePopup();
        }
        (_a = targetRef.value) == null ? void 0 : _a.focus();
        if (innerValue.value.length === 0 || isDeepEqual(getOptionValue.value(innerValue.value[0]), optValue) !== true) {
          emit("update:modelValue", props4.emitValue === true ? optValue : opt);
        }
        return;
      }
      if (hasDialog !== true || dialogFieldFocused.value === true) {
        state2.focus();
      }
      selectInputText();
      if (innerValue.value.length === 0) {
        const val = props4.emitValue === true ? optValue : opt;
        emit("add", { index: 0, value: val });
        emit("update:modelValue", props4.multiple === true ? [val] : val);
        return;
      }
      const model = props4.modelValue.slice(), index2 = innerOptionsValue.value.findIndex((v) => isDeepEqual(v, optValue));
      if (index2 !== -1) {
        emit("remove", { index: index2, value: model.splice(index2, 1)[0] });
      } else {
        if (props4.maxValues !== void 0 && model.length >= props4.maxValues) return;
        const val = props4.emitValue === true ? optValue : opt;
        emit("add", { index: model.length, value: val });
        model.push(val);
      }
      emit("update:modelValue", model);
    }
    function setOptionIndex(index2) {
      if ($q.platform.is.desktop !== true) return;
      const val = index2 !== -1 && index2 < virtualScrollLength.value ? index2 : -1;
      if (optionIndex.value !== val) {
        optionIndex.value = val;
      }
    }
    function moveOptionSelection(offset2 = 1, skipInputValue) {
      if (menu.value === true) {
        let index2 = optionIndex.value;
        do {
          index2 = normalizeToInterval(
            index2 + offset2,
            -1,
            virtualScrollLength.value - 1
          );
        } while (index2 !== -1 && index2 !== optionIndex.value && isOptionDisabled.value(props4.options[index2]) === true);
        if (optionIndex.value !== index2) {
          setOptionIndex(index2);
          scrollTo(index2);
          if (skipInputValue !== true && props4.useInput === true && props4.fillInput === true) {
            setInputValue(
              index2 >= 0 ? getOptionLabel.value(props4.options[index2]) : defaultInputValue,
              true
            );
          }
        }
      }
    }
    function getOption(value2, valueCache) {
      const fn = (opt) => isDeepEqual(getOptionValue.value(opt), value2);
      return props4.options.find(fn) || valueCache.find(fn) || value2;
    }
    function isOptionSelected(opt) {
      const val = getOptionValue.value(opt);
      return innerOptionsValue.value.find((v) => isDeepEqual(v, val)) !== void 0;
    }
    function selectInputText(e3) {
      if (props4.useInput === true && targetRef.value !== null && (e3 === void 0 || targetRef.value === e3.target && e3.target.value === selectedString.value)) {
        targetRef.value.select();
      }
    }
    function onTargetKeyup(e3) {
      if (isKeyCode(e3, 27) === true && menu.value === true) {
        stop(e3);
        hidePopup();
        resetInputValue();
      }
      emit("keyup", e3);
    }
    function onTargetAutocomplete(e3) {
      const { value: value2 } = e3.target;
      if (e3.keyCode !== void 0) {
        onTargetKeyup(e3);
        return;
      }
      e3.target.value = "";
      if (filterTimer !== null) {
        clearTimeout(filterTimer);
        filterTimer = null;
      }
      if (inputValueTimer !== null) {
        clearTimeout(inputValueTimer);
        inputValueTimer = null;
      }
      resetInputValue();
      if (typeof value2 === "string" && value2.length !== 0) {
        const needle = value2.toLocaleLowerCase();
        const findFn = (extractFn) => {
          const option = props4.options.find((opt) => String(extractFn.value(opt)).toLocaleLowerCase() === needle);
          if (option === void 0) return false;
          if (innerValue.value.indexOf(option) === -1) {
            toggleOption(option);
          } else {
            hidePopup();
          }
          return true;
        };
        const fillFn = (afterFilter) => {
          if (findFn(getOptionValue) !== true && afterFilter !== true && findFn(getOptionLabel) !== true) {
            filter(value2, true, () => fillFn(true));
          }
        };
        fillFn();
      } else {
        state2.clearValue(e3);
      }
    }
    function onTargetKeypress(e3) {
      emit("keypress", e3);
    }
    function onTargetKeydown(e3) {
      emit("keydown", e3);
      if (shouldIgnoreKey(e3) === true) return;
      const newValueModeValid = inputValue.value.length !== 0 && (props4.newValueMode !== void 0 || props4.onNewValue !== void 0);
      const tabShouldSelect = e3.shiftKey !== true && props4.disableTabSelection !== true && props4.multiple !== true && (optionIndex.value !== -1 || newValueModeValid === true);
      if (e3.keyCode === 27) {
        prevent(e3);
        return;
      }
      if (e3.keyCode === 9 && tabShouldSelect === false) {
        closeMenu();
        return;
      }
      if (e3.target === void 0 || e3.target.id !== state2.targetUid.value || state2.editable.value !== true) return;
      if (e3.keyCode === 40 && state2.innerLoading.value !== true && menu.value === false) {
        stopAndPrevent(e3);
        showPopup();
        return;
      }
      if (e3.keyCode === 8 && (props4.useChips === true || props4.clearable === true) && props4.hideSelected !== true && inputValue.value.length === 0) {
        if (props4.multiple === true && Array.isArray(props4.modelValue) === true) {
          removeAtIndex(props4.modelValue.length - 1);
        } else if (props4.multiple !== true && props4.modelValue !== null) {
          emit("update:modelValue", null);
        }
        return;
      }
      if ((e3.keyCode === 35 || e3.keyCode === 36) && (typeof inputValue.value !== "string" || inputValue.value.length === 0)) {
        stopAndPrevent(e3);
        optionIndex.value = -1;
        moveOptionSelection(e3.keyCode === 36 ? 1 : -1, props4.multiple);
      }
      if ((e3.keyCode === 33 || e3.keyCode === 34) && virtualScrollSliceSizeComputed.value !== void 0) {
        stopAndPrevent(e3);
        optionIndex.value = Math.max(
          -1,
          Math.min(
            virtualScrollLength.value,
            optionIndex.value + (e3.keyCode === 33 ? -1 : 1) * virtualScrollSliceSizeComputed.value.view
          )
        );
        moveOptionSelection(e3.keyCode === 33 ? 1 : -1, props4.multiple);
      }
      if (e3.keyCode === 38 || e3.keyCode === 40) {
        stopAndPrevent(e3);
        moveOptionSelection(e3.keyCode === 38 ? -1 : 1, props4.multiple);
      }
      const optionsLength = virtualScrollLength.value;
      if (searchBuffer === void 0 || searchBufferExp < Date.now()) {
        searchBuffer = "";
      }
      if (optionsLength > 0 && props4.useInput !== true && e3.key !== void 0 && e3.key.length === 1 && e3.altKey === false && e3.ctrlKey === false && e3.metaKey === false && (e3.keyCode !== 32 || searchBuffer.length !== 0)) {
        menu.value !== true && showPopup(e3);
        const char = e3.key.toLocaleLowerCase(), keyRepeat = searchBuffer.length === 1 && searchBuffer[0] === char;
        searchBufferExp = Date.now() + 1500;
        if (keyRepeat === false) {
          stopAndPrevent(e3);
          searchBuffer += char;
        }
        const searchRe = new RegExp("^" + searchBuffer.split("").map((l) => reEscapeList.indexOf(l) !== -1 ? "\\" + l : l).join(".*"), "i");
        let index2 = optionIndex.value;
        if (keyRepeat === true || index2 < 0 || searchRe.test(getOptionLabel.value(props4.options[index2])) !== true) {
          do {
            index2 = normalizeToInterval(index2 + 1, -1, optionsLength - 1);
          } while (index2 !== optionIndex.value && (isOptionDisabled.value(props4.options[index2]) === true || searchRe.test(getOptionLabel.value(props4.options[index2])) !== true));
        }
        if (optionIndex.value !== index2) {
          nextTick(() => {
            setOptionIndex(index2);
            scrollTo(index2);
            if (index2 >= 0 && props4.useInput === true && props4.fillInput === true) {
              setInputValue(getOptionLabel.value(props4.options[index2]), true);
            }
          });
        }
        return;
      }
      if (e3.keyCode !== 13 && (e3.keyCode !== 32 || props4.useInput === true || searchBuffer !== "") && (e3.keyCode !== 9 || tabShouldSelect === false)) return;
      e3.keyCode !== 9 && stopAndPrevent(e3);
      if (optionIndex.value !== -1 && optionIndex.value < optionsLength) {
        toggleOption(props4.options[optionIndex.value]);
        return;
      }
      if (newValueModeValid === true) {
        const done = (val, mode) => {
          var _a;
          if (mode) {
            if (validateNewValueMode(mode) !== true) return;
          } else {
            mode = props4.newValueMode;
          }
          updateInputValue("", props4.multiple !== true, true);
          if (val === void 0 || val === null) return;
          const fn = mode === "toggle" ? toggleOption : add2;
          fn(val, mode === "add-unique");
          if (props4.multiple !== true) {
            (_a = targetRef.value) == null ? void 0 : _a.focus();
            hidePopup();
          }
        };
        if (props4.onNewValue !== void 0) {
          emit("newValue", inputValue.value, done);
        } else {
          done(inputValue.value);
        }
        if (props4.multiple !== true) return;
      }
      if (menu.value === true) {
        closeMenu();
      } else if (state2.innerLoading.value !== true) {
        showPopup();
      }
    }
    function getVirtualScrollEl() {
      return hasDialog === true ? menuContentRef.value : menuRef.value !== null && menuRef.value.contentEl !== null ? menuRef.value.contentEl : void 0;
    }
    function getVirtualScrollTarget() {
      return getVirtualScrollEl();
    }
    function getSelection2() {
      if (props4.hideSelected === true) {
        return [];
      }
      if (slots["selected-item"] !== void 0) {
        return selectedScope.value.map((scope) => slots["selected-item"](scope)).slice();
      }
      if (slots.selected !== void 0) {
        return [].concat(slots.selected());
      }
      if (props4.useChips === true) {
        return selectedScope.value.map((scope, i3) => h(QChip_default, {
          key: "option-" + i3,
          removable: state2.editable.value === true && isOptionDisabled.value(scope.opt) !== true,
          dense: true,
          textColor: props4.color,
          tabindex: tabindex.value,
          onRemove() {
            scope.removeAtIndex(i3);
          }
        }, () => h("span", {
          class: "ellipsis",
          [scope.html === true ? "innerHTML" : "textContent"]: getOptionLabel.value(scope.opt)
        })));
      }
      return [
        h("span", {
          class: "ellipsis",
          [valueAsHtml.value === true ? "innerHTML" : "textContent"]: ariaCurrentValue.value
        })
      ];
    }
    function getAllOptions() {
      if (noOptions.value === true) {
        return slots["no-option"] !== void 0 ? slots["no-option"]({ inputValue: inputValue.value }) : void 0;
      }
      const fn = slots.option !== void 0 ? slots.option : (scope) => {
        return h(QItem_default, {
          key: scope.index,
          ...scope.itemProps
        }, () => {
          return h(
            QItemSection_default,
            () => h(
              QItemLabel_default,
              () => h("span", {
                [scope.html === true ? "innerHTML" : "textContent"]: scope.label
              })
            )
          );
        });
      };
      let options = padVirtualScroll("div", optionScope.value.map(fn));
      if (slots["before-options"] !== void 0) {
        options = slots["before-options"]().concat(options);
      }
      return hMergeSlot(slots["after-options"], options);
    }
    function getInput(fromDialog, isTarget) {
      const attrs = isTarget === true ? { ...comboboxAttrs.value, ...state2.splitAttrs.attributes.value } : void 0;
      const data = {
        ref: isTarget === true ? targetRef : void 0,
        key: "i_t",
        class: computedInputClass.value,
        style: props4.inputStyle,
        value: inputValue.value !== void 0 ? inputValue.value : "",
        // required for Android in order to show ENTER key when in form
        type: "search",
        ...attrs,
        id: isTarget === true ? state2.targetUid.value : void 0,
        maxlength: props4.maxlength,
        autocomplete: props4.autocomplete,
        "data-autofocus": fromDialog === true || props4.autofocus === true || void 0,
        disabled: props4.disable === true,
        readonly: props4.readonly === true,
        ...inputControlEvents.value
      };
      if (fromDialog !== true && hasDialog === true) {
        if (Array.isArray(data.class) === true) {
          data.class = [...data.class, "no-pointer-events"];
        } else {
          data.class += " no-pointer-events";
        }
      }
      return h("input", data);
    }
    function onInput(e3) {
      if (filterTimer !== null) {
        clearTimeout(filterTimer);
        filterTimer = null;
      }
      if (inputValueTimer !== null) {
        clearTimeout(inputValueTimer);
        inputValueTimer = null;
      }
      if (e3 && e3.target && e3.target.qComposing === true) return;
      setInputValue(e3.target.value || "");
      userInputValue = true;
      defaultInputValue = inputValue.value;
      if (state2.focused.value !== true && (hasDialog !== true || dialogFieldFocused.value === true)) {
        state2.focus();
      }
      if (props4.onFilter !== void 0) {
        filterTimer = setTimeout(() => {
          filterTimer = null;
          filter(inputValue.value);
        }, props4.inputDebounce);
      }
    }
    function setInputValue(val, emitImmediately) {
      if (inputValue.value !== val) {
        inputValue.value = val;
        if (emitImmediately === true || props4.inputDebounce === 0 || props4.inputDebounce === "0") {
          emit("inputValue", val);
        } else {
          inputValueTimer = setTimeout(() => {
            inputValueTimer = null;
            emit("inputValue", val);
          }, props4.inputDebounce);
        }
      }
    }
    function updateInputValue(val, noFiltering, internal) {
      userInputValue = internal !== true;
      if (props4.useInput === true) {
        setInputValue(val, true);
        if (noFiltering === true || internal !== true) {
          defaultInputValue = val;
        }
        noFiltering !== true && filter(val);
      }
    }
    function filter(val, keepClosed, afterUpdateFn) {
      if (props4.onFilter === void 0 || keepClosed !== true && state2.focused.value !== true) return;
      if (state2.innerLoading.value === true) {
        emit("filterAbort");
      } else {
        state2.innerLoading.value = true;
        innerLoadingIndicator.value = true;
      }
      if (val !== "" && props4.multiple !== true && innerValue.value.length !== 0 && userInputValue !== true && val === getOptionLabel.value(innerValue.value[0])) {
        val = "";
      }
      const localFilterId = setTimeout(() => {
        menu.value === true && (menu.value = false);
      }, 10);
      filterId !== null && clearTimeout(filterId);
      filterId = localFilterId;
      emit(
        "filter",
        val,
        (fn, afterFn) => {
          if ((keepClosed === true || state2.focused.value === true) && filterId === localFilterId) {
            clearTimeout(filterId);
            typeof fn === "function" && fn();
            innerLoadingIndicator.value = false;
            nextTick(() => {
              state2.innerLoading.value = false;
              if (state2.editable.value === true) {
                if (keepClosed === true) {
                  menu.value === true && hidePopup();
                } else if (menu.value === true) {
                  updateMenu(true);
                } else {
                  menu.value = true;
                }
              }
              typeof afterFn === "function" && nextTick(() => {
                afterFn(proxy);
              });
              typeof afterUpdateFn === "function" && nextTick(() => {
                afterUpdateFn(proxy);
              });
            });
          }
        },
        () => {
          if (state2.focused.value === true && filterId === localFilterId) {
            clearTimeout(filterId);
            state2.innerLoading.value = false;
            innerLoadingIndicator.value = false;
          }
          menu.value === true && (menu.value = false);
        }
      );
    }
    function getMenu() {
      return h(QMenu_default, {
        ref: menuRef,
        class: menuContentClass.value,
        style: props4.popupContentStyle,
        modelValue: menu.value,
        fit: props4.menuShrink !== true,
        cover: props4.optionsCover === true && noOptions.value !== true && props4.useInput !== true,
        anchor: props4.menuAnchor,
        self: props4.menuSelf,
        offset: props4.menuOffset,
        dark: isOptionsDark.value,
        noParentEvent: true,
        noRefocus: true,
        noFocus: true,
        noRouteDismiss: props4.popupNoRouteDismiss,
        square: squaredMenu.value,
        transitionShow: props4.transitionShow,
        transitionHide: props4.transitionHide,
        transitionDuration: props4.transitionDuration,
        separateClosePopup: true,
        ...listboxAttrs.value,
        onScrollPassive: onVirtualScrollEvt,
        onBeforeShow: onControlPopupShow,
        onBeforeHide: onMenuBeforeHide,
        onShow: onMenuShow
      }, getAllOptions);
    }
    function onMenuBeforeHide(e3) {
      onControlPopupHide(e3);
      closeMenu();
    }
    function onMenuShow() {
      setVirtualScrollSize();
    }
    function onDialogFieldFocus(e3) {
      var _a;
      stop(e3);
      (_a = targetRef.value) == null ? void 0 : _a.focus();
      dialogFieldFocused.value = true;
      window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, 0);
    }
    function onDialogFieldBlur(e3) {
      stop(e3);
      nextTick(() => {
        dialogFieldFocused.value = false;
      });
    }
    function getDialog() {
      const content = [
        h(QField_default, {
          class: `col-auto ${state2.fieldClass.value}`,
          ...innerFieldProps.value,
          for: state2.targetUid.value,
          dark: isOptionsDark.value,
          square: true,
          loading: innerLoadingIndicator.value,
          itemAligned: false,
          filled: true,
          stackLabel: inputValue.value.length !== 0,
          ...state2.splitAttrs.listeners.value,
          onFocus: onDialogFieldFocus,
          onBlur: onDialogFieldBlur
        }, {
          ...slots,
          rawControl: () => state2.getControl(true),
          before: void 0,
          after: void 0
        })
      ];
      menu.value === true && content.push(
        h("div", {
          ref: menuContentRef,
          class: menuContentClass.value + " scroll",
          style: props4.popupContentStyle,
          ...listboxAttrs.value,
          onClick: prevent,
          onScrollPassive: onVirtualScrollEvt
        }, getAllOptions())
      );
      return h(QDialog_default, {
        ref: dialogRef,
        modelValue: dialog.value,
        position: props4.useInput === true ? "top" : void 0,
        transitionShow: transitionShowComputed,
        transitionHide: props4.transitionHide,
        transitionDuration: props4.transitionDuration,
        noRouteDismiss: props4.popupNoRouteDismiss,
        onBeforeShow: onControlPopupShow,
        onBeforeHide: onDialogBeforeHide,
        onHide: onDialogHide,
        onShow: onDialogShow
      }, () => h("div", {
        class: "q-select__dialog" + (isOptionsDark.value === true ? " q-select__dialog--dark q-dark" : "") + (dialogFieldFocused.value === true ? " q-select__dialog--focused" : "")
      }, content));
    }
    function onDialogBeforeHide(e3) {
      onControlPopupHide(e3);
      if (dialogRef.value !== null) {
        dialogRef.value.__updateRefocusTarget(
          state2.rootRef.value.querySelector(".q-field__native > [tabindex]:last-child")
        );
      }
      state2.focused.value = false;
    }
    function onDialogHide(e3) {
      hidePopup();
      state2.focused.value === false && emit("blur", e3);
      resetInputValue();
    }
    function onDialogShow() {
      const el = document.activeElement;
      if ((el === null || el.id !== state2.targetUid.value) && targetRef.value !== null && targetRef.value !== el) {
        targetRef.value.focus();
      }
      setVirtualScrollSize();
    }
    function closeMenu() {
      if (dialog.value === true) return;
      optionIndex.value = -1;
      if (menu.value === true) {
        menu.value = false;
      }
      if (state2.focused.value === false) {
        if (filterId !== null) {
          clearTimeout(filterId);
          filterId = null;
        }
        if (state2.innerLoading.value === true) {
          emit("filterAbort");
          state2.innerLoading.value = false;
          innerLoadingIndicator.value = false;
        }
      }
    }
    function showPopup(e3) {
      if (state2.editable.value !== true) return;
      if (hasDialog === true) {
        state2.onControlFocusin(e3);
        dialog.value = true;
        nextTick(() => {
          state2.focus();
        });
      } else {
        state2.focus();
      }
      if (props4.onFilter !== void 0) {
        filter(inputValue.value);
      } else if (noOptions.value !== true || slots["no-option"] !== void 0) {
        menu.value = true;
      }
    }
    function hidePopup() {
      dialog.value = false;
      closeMenu();
    }
    function resetInputValue() {
      props4.useInput === true && updateInputValue(
        props4.multiple !== true && props4.fillInput === true && innerValue.value.length !== 0 ? getOptionLabel.value(innerValue.value[0]) || "" : "",
        true,
        true
      );
    }
    function updateMenu(show) {
      let optionIndex2 = -1;
      if (show === true) {
        if (innerValue.value.length !== 0) {
          const val = getOptionValue.value(innerValue.value[0]);
          optionIndex2 = props4.options.findIndex((v) => isDeepEqual(getOptionValue.value(v), val));
        }
        localResetVirtualScroll(optionIndex2);
      }
      setOptionIndex(optionIndex2);
    }
    function rerenderMenu(newLength, oldLength) {
      if (menu.value === true && state2.innerLoading.value === false) {
        localResetVirtualScroll(-1, true);
        nextTick(() => {
          if (menu.value === true && state2.innerLoading.value === false) {
            if (newLength > oldLength) {
              localResetVirtualScroll();
            } else {
              updateMenu(true);
            }
          }
        });
      }
    }
    function updateMenuPosition() {
      if (dialog.value === false && menuRef.value !== null) {
        menuRef.value.updatePosition();
      }
    }
    function onControlPopupShow(e3) {
      e3 !== void 0 && stop(e3);
      emit("popupShow", e3);
      state2.hasPopupOpen = true;
      state2.onControlFocusin(e3);
    }
    function onControlPopupHide(e3) {
      e3 !== void 0 && stop(e3);
      emit("popupHide", e3);
      state2.hasPopupOpen = false;
      state2.onControlFocusout(e3);
    }
    function updatePreState() {
      hasDialog = $q.platform.is.mobile !== true && props4.behavior !== "dialog" ? false : props4.behavior !== "menu" && (props4.useInput === true ? slots["no-option"] !== void 0 || props4.onFilter !== void 0 || noOptions.value === false : true);
      transitionShowComputed = $q.platform.is.ios === true && hasDialog === true && props4.useInput === true ? "fade" : props4.transitionShow;
    }
    onBeforeUpdate(updatePreState);
    onUpdated(updateMenuPosition);
    updatePreState();
    onBeforeUnmount(() => {
      filterTimer !== null && clearTimeout(filterTimer);
      inputValueTimer !== null && clearTimeout(inputValueTimer);
    });
    Object.assign(proxy, {
      showPopup,
      hidePopup,
      removeAtIndex,
      add: add2,
      toggleOption,
      getOptionIndex: () => optionIndex.value,
      setOptionIndex,
      moveOptionSelection,
      filter,
      updateMenuPosition,
      updateInputValue,
      isOptionSelected,
      getEmittingOptionValue,
      isOptionDisabled: (...args) => isOptionDisabled.value.apply(null, args) === true,
      getOptionValue: (...args) => getOptionValue.value.apply(null, args),
      getOptionLabel: (...args) => getOptionLabel.value.apply(null, args)
    });
    Object.assign(state2, {
      innerValue,
      fieldClass: computed(
        () => `q-select q-field--auto-height q-select--with${props4.useInput !== true ? "out" : ""}-input q-select--with${props4.useChips !== true ? "out" : ""}-chips q-select--${props4.multiple === true ? "multiple" : "single"}`
      ),
      inputRef,
      targetRef,
      hasValue,
      showPopup,
      floatingLabel: computed(
        () => props4.hideSelected !== true && hasValue.value === true || typeof inputValue.value === "number" || inputValue.value.length !== 0 || fieldValueIsFilled(props4.displayValue)
      ),
      getControlChild: () => {
        if (state2.editable.value !== false && (dialog.value === true || noOptions.value !== true || slots["no-option"] !== void 0)) {
          return hasDialog === true ? getDialog() : getMenu();
        } else if (state2.hasPopupOpen === true) {
          state2.hasPopupOpen = false;
        }
      },
      controlEvents: {
        onFocusin(e3) {
          state2.onControlFocusin(e3);
        },
        onFocusout(e3) {
          state2.onControlFocusout(e3, () => {
            resetInputValue();
            closeMenu();
          });
        },
        onClick(e3) {
          var _a;
          prevent(e3);
          if (hasDialog !== true && menu.value === true) {
            closeMenu();
            (_a = targetRef.value) == null ? void 0 : _a.focus();
            return;
          }
          showPopup(e3);
        }
      },
      getControl: (fromDialog) => {
        const child = getSelection2();
        const isTarget = fromDialog === true || dialog.value !== true || hasDialog !== true;
        if (props4.useInput === true) {
          child.push(getInput(fromDialog, isTarget));
        } else if (state2.editable.value === true) {
          const attrs2 = isTarget === true ? comboboxAttrs.value : void 0;
          child.push(
            h("input", {
              ref: isTarget === true ? targetRef : void 0,
              key: "d_t",
              class: "q-select__focus-target",
              id: isTarget === true ? state2.targetUid.value : void 0,
              value: ariaCurrentValue.value,
              readonly: true,
              "data-autofocus": fromDialog === true || props4.autofocus === true || void 0,
              ...attrs2,
              onKeydown: onTargetKeydown,
              onKeyup: onTargetKeyup,
              onKeypress: onTargetKeypress
            })
          );
          if (isTarget === true && typeof props4.autocomplete === "string" && props4.autocomplete.length !== 0) {
            child.push(
              h("input", {
                class: "q-select__autocomplete-input",
                autocomplete: props4.autocomplete,
                tabindex: -1,
                onKeyup: onTargetAutocomplete
              })
            );
          }
        }
        if (nameProp.value !== void 0 && props4.disable !== true && innerOptionsValue.value.length !== 0) {
          const opts = innerOptionsValue.value.map((value2) => h("option", { value: value2, selected: true }));
          child.push(
            h("select", {
              class: "hidden",
              name: nameProp.value,
              multiple: props4.multiple
            }, opts)
          );
        }
        const attrs = props4.useInput === true || isTarget !== true ? void 0 : state2.splitAttrs.attributes.value;
        return h("div", {
          class: "q-field__native row items-center",
          ...attrs,
          ...state2.splitAttrs.listeners.value
        }, child);
      },
      getInnerAppend: () => props4.loading !== true && innerLoadingIndicator.value !== true && props4.hideDropdownIcon !== true ? [
        h(QIcon_default, {
          class: "q-select__dropdown-icon" + (menu.value === true ? " rotate-180" : ""),
          name: dropdownArrowIcon.value
        })
      ] : null
    });
    return use_field_default(state2);
  }
});
var skeletonTypes = [
  "text",
  "rect",
  "circle",
  "QBtn",
  "QBadge",
  "QChip",
  "QToolbar",
  "QCheckbox",
  "QRadio",
  "QToggle",
  "QSlider",
  "QRange",
  "QInput",
  "QAvatar"
];
var skeletonAnimations = [
  "wave",
  "pulse",
  "pulse-x",
  "pulse-y",
  "fade",
  "blink",
  "none"
];
createComponent({
  name: "QSkeleton",
  props: {
    ...useDarkProps,
    tag: {
      type: String,
      default: "div"
    },
    type: {
      type: String,
      validator: (v) => skeletonTypes.includes(v),
      default: "rect"
    },
    animation: {
      type: String,
      validator: (v) => skeletonAnimations.includes(v),
      default: "wave"
    },
    animationSpeed: {
      type: [String, Number],
      default: 1500
    },
    square: Boolean,
    bordered: Boolean,
    size: String,
    width: String,
    height: String
  },
  setup(props4, { slots }) {
    const vm2 = getCurrentInstance();
    const isDark = use_dark_default(props4, vm2.proxy.$q);
    const style2 = computed(() => {
      const size2 = props4.size !== void 0 ? [props4.size, props4.size] : [props4.width, props4.height];
      return {
        "--q-skeleton-speed": `${props4.animationSpeed}ms`,
        width: size2[0],
        height: size2[1]
      };
    });
    const classes = computed(
      () => `q-skeleton q-skeleton--${isDark.value === true ? "dark" : "light"} q-skeleton--type-${props4.type}` + (props4.animation !== "none" ? ` q-skeleton--anim q-skeleton--anim-${props4.animation}` : "") + (props4.square === true ? " q-skeleton--square" : "") + (props4.bordered === true ? " q-skeleton--bordered" : "")
    );
    return () => h(props4.tag, {
      class: classes.value,
      style: style2.value
    }, hSlot(slots.default));
  }
});
var slotsDef = [
  ["left", "center", "start", "width"],
  ["right", "center", "end", "width"],
  ["top", "start", "center", "height"],
  ["bottom", "end", "center", "height"]
];
createComponent({
  name: "QSlideItem",
  props: {
    ...useDarkProps,
    leftColor: String,
    rightColor: String,
    topColor: String,
    bottomColor: String,
    onSlide: Function
  },
  emits: ["action", "top", "right", "bottom", "left"],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const isDark = use_dark_default(props4, $q);
    const { getCache } = use_render_cache_default();
    const contentRef = ref$1(null);
    let timer2 = null, pan = {}, dirRefs = {}, dirContentRefs = {};
    const langDir = computed(() => $q.lang.rtl === true ? { left: "right", right: "left" } : { left: "left", right: "right" });
    const classes = computed(
      () => "q-slide-item q-item-type overflow-hidden" + (isDark.value === true ? " q-slide-item--dark q-dark" : "")
    );
    function reset() {
      contentRef.value.style.transform = "translate(0,0)";
    }
    function emitSlide(side, ratio, isReset) {
      props4.onSlide !== void 0 && emit("slide", { side, ratio, isReset });
    }
    function onPan(evt) {
      const node = contentRef.value;
      if (evt.isFirst) {
        pan = {
          dir: null,
          size: { left: 0, right: 0, top: 0, bottom: 0 },
          scale: 0
        };
        node.classList.add("no-transition");
        slotsDef.forEach((slotName) => {
          if (slots[slotName[0]] !== void 0) {
            const node2 = dirContentRefs[slotName[0]];
            node2.style.transform = "scale(1)";
            pan.size[slotName[0]] = node2.getBoundingClientRect()[slotName[3]];
          }
        });
        pan.axis = evt.direction === "up" || evt.direction === "down" ? "Y" : "X";
      } else if (evt.isFinal) {
        node.classList.remove("no-transition");
        if (pan.scale === 1) {
          node.style.transform = `translate${pan.axis}(${pan.dir * 100}%)`;
          timer2 !== null && clearTimeout(timer2);
          timer2 = setTimeout(() => {
            timer2 = null;
            emit(pan.showing, { reset });
            emit("action", { side: pan.showing, reset });
          }, 230);
        } else {
          node.style.transform = "translate(0,0)";
          emitSlide(pan.showing, 0, true);
        }
        return;
      } else {
        evt.direction = pan.axis === "X" ? evt.offset.x < 0 ? "left" : "right" : evt.offset.y < 0 ? "up" : "down";
      }
      if (slots.left === void 0 && evt.direction === langDir.value.right || slots.right === void 0 && evt.direction === langDir.value.left || slots.top === void 0 && evt.direction === "down" || slots.bottom === void 0 && evt.direction === "up") {
        node.style.transform = "translate(0,0)";
        return;
      }
      let showing, dir, dist2;
      if (pan.axis === "X") {
        dir = evt.direction === "left" ? -1 : 1;
        showing = dir === 1 ? langDir.value.left : langDir.value.right;
        dist2 = evt.distance.x;
      } else {
        dir = evt.direction === "up" ? -2 : 2;
        showing = dir === 2 ? "top" : "bottom";
        dist2 = evt.distance.y;
      }
      if (pan.dir !== null && Math.abs(dir) !== Math.abs(pan.dir)) return;
      if (pan.dir !== dir) {
        ["left", "right", "top", "bottom"].forEach((d4) => {
          if (dirRefs[d4]) {
            dirRefs[d4].style.visibility = showing === d4 ? "visible" : "hidden";
          }
        });
        pan.showing = showing;
        pan.dir = dir;
      }
      pan.scale = Math.max(0, Math.min(1, (dist2 - 40) / pan.size[showing]));
      node.style.transform = `translate${pan.axis}(${dist2 * dir / Math.abs(dir)}px)`;
      dirContentRefs[showing].style.transform = `scale(${pan.scale})`;
      emitSlide(showing, pan.scale, false);
    }
    onBeforeUpdate(() => {
      dirRefs = {};
      dirContentRefs = {};
    });
    onBeforeUnmount(() => {
      timer2 !== null && clearTimeout(timer2);
    });
    Object.assign(proxy, { reset });
    return () => {
      const content = [], slotsList = {
        left: slots[langDir.value.right] !== void 0,
        right: slots[langDir.value.left] !== void 0,
        up: slots.bottom !== void 0,
        down: slots.top !== void 0
      }, dirs = Object.keys(slotsList).filter((key) => slotsList[key] === true);
      slotsDef.forEach((slotName) => {
        const dir = slotName[0];
        if (slots[dir] !== void 0) {
          content.push(
            h("div", {
              key: dir,
              ref: (el) => {
                dirRefs[dir] = el;
              },
              class: `q-slide-item__${dir} absolute-full row no-wrap items-${slotName[1]} justify-${slotName[2]}` + (props4[dir + "Color"] !== void 0 ? ` bg-${props4[dir + "Color"]}` : "")
            }, [
              h("div", { ref: (el) => {
                dirContentRefs[dir] = el;
              } }, slots[dir]())
            ])
          );
        }
      });
      const node = h("div", {
        key: `${dirs.length === 0 ? "only-" : ""} content`,
        ref: contentRef,
        class: "q-slide-item__content"
      }, hSlot(slots.default));
      if (dirs.length === 0) {
        content.push(node);
      } else {
        content.push(
          withDirectives(node, getCache("dir#" + dirs.join(""), () => {
            const modifiers = {
              prevent: true,
              stop: true,
              mouse: true
            };
            dirs.forEach((dir) => {
              modifiers[dir] = true;
            });
            return [[
              TouchPan_default,
              onPan,
              void 0,
              modifiers
            ]];
          }))
        );
      }
      return h("div", { class: classes.value }, content);
    };
  }
});
createComponent({
  name: "QSpace",
  setup() {
    const space = h("div", { class: "q-space" });
    return () => space;
  }
});
var innerHTML = '<g transform="matrix(1 0 0 -1 0 80)"><rect width="10" height="20" rx="3"><animate attributeName="height" begin="0s" dur="4.3s" values="20;45;57;80;64;32;66;45;64;23;66;13;64;56;34;34;2;23;76;79;20" calcMode="linear" repeatCount="indefinite"></animate></rect><rect x="15" width="10" height="80" rx="3"><animate attributeName="height" begin="0s" dur="2s" values="80;55;33;5;75;23;73;33;12;14;60;80" calcMode="linear" repeatCount="indefinite"></animate></rect><rect x="30" width="10" height="50" rx="3"><animate attributeName="height" begin="0s" dur="1.4s" values="50;34;78;23;56;23;34;76;80;54;21;50" calcMode="linear" repeatCount="indefinite"></animate></rect><rect x="45" width="10" height="30" rx="3"><animate attributeName="height" begin="0s" dur="2s" values="30;45;13;80;56;72;45;76;34;23;67;30" calcMode="linear" repeatCount="indefinite"></animate></rect></g>';
createComponent({
  name: "QSpinnerAudio",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      fill: "currentColor",
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 55 80",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML
    });
  }
});
var innerHTML2 = '<g transform="translate(1 1)" stroke-width="2" fill="none" fill-rule="evenodd"><circle cx="5" cy="50" r="5"><animate attributeName="cy" begin="0s" dur="2.2s" values="50;5;50;50" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="cx" begin="0s" dur="2.2s" values="5;27;49;5" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="27" cy="5" r="5"><animate attributeName="cy" begin="0s" dur="2.2s" from="5" to="5" values="5;50;50;5" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="cx" begin="0s" dur="2.2s" from="27" to="27" values="27;49;5;27" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="49" cy="50" r="5"><animate attributeName="cy" begin="0s" dur="2.2s" values="50;50;5;50" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="cx" from="49" to="49" begin="0s" dur="2.2s" values="49;5;27;49" calcMode="linear" repeatCount="indefinite"></animate></circle></g>';
createComponent({
  name: "QSpinnerBall",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      stroke: "currentColor",
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 57 57",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML2
    });
  }
});
var innerHTML3 = '<rect y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.5s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="y" begin="0.5s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"></animate></rect><rect x="30" y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.25s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="y" begin="0.25s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"></animate></rect><rect x="60" width="15" height="140" rx="6"><animate attributeName="height" begin="0s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="y" begin="0s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"></animate></rect><rect x="90" y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.25s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="y" begin="0.25s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"></animate></rect><rect x="120" y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.5s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="y" begin="0.5s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"></animate></rect>';
createComponent({
  name: "QSpinnerBars",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      fill: "currentColor",
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 135 140",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML3
    });
  }
});
var innerHTML4 = '<rect x="25" y="25" width="50" height="50" fill="none" stroke-width="4" stroke="currentColor"><animateTransform id="spinnerBox" attributeName="transform" type="rotate" from="0 50 50" to="180 50 50" dur="0.5s" begin="rectBox.end"></animateTransform></rect><rect x="27" y="27" width="46" height="50" fill="currentColor"><animate id="rectBox" attributeName="height" begin="0s;spinnerBox.end" dur="1.3s" from="50" to="0" fill="freeze"></animate></rect>';
createComponent({
  name: "QSpinnerBox",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML4
    });
  }
});
var innerHTML5 = '<circle cx="50" cy="50" r="48" fill="none" stroke-width="4" stroke-miterlimit="10" stroke="currentColor"></circle><line stroke-linecap="round" stroke-width="4" stroke-miterlimit="10" stroke="currentColor" x1="50" y1="50" x2="85" y2="50.5"><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="2s" repeatCount="indefinite"></animateTransform></line><line stroke-linecap="round" stroke-width="4" stroke-miterlimit="10" stroke="currentColor" x1="50" y1="50" x2="49.5" y2="74"><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="15s" repeatCount="indefinite"></animateTransform></line>';
createComponent({
  name: "QSpinnerClock",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML5
    });
  }
});
var innerHTML6 = '<rect x="0" y="0" width="100" height="100" fill="none"></rect><path d="M78,19H22c-6.6,0-12,5.4-12,12v31c0,6.6,5.4,12,12,12h37.2c0.4,3,1.8,5.6,3.7,7.6c2.4,2.5,5.1,4.1,9.1,4 c-1.4-2.1-2-7.2-2-10.3c0-0.4,0-0.8,0-1.3h8c6.6,0,12-5.4,12-12V31C90,24.4,84.6,19,78,19z" fill="currentColor"></path><circle cx="30" cy="47" r="5" fill="#fff"><animate attributeName="opacity" from="0" to="1" values="0;1;1" keyTimes="0;0.2;1" dur="1s" repeatCount="indefinite"></animate></circle><circle cx="50" cy="47" r="5" fill="#fff"><animate attributeName="opacity" from="0" to="1" values="0;0;1;1" keyTimes="0;0.2;0.4;1" dur="1s" repeatCount="indefinite"></animate></circle><circle cx="70" cy="47" r="5" fill="#fff"><animate attributeName="opacity" from="0" to="1" values="0;0;1;1" keyTimes="0;0.4;0.6;1" dur="1s" repeatCount="indefinite"></animate></circle>';
createComponent({
  name: "QSpinnerComment",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      innerHTML: innerHTML6
    });
  }
});
var innerHTML7 = '<rect x="0" y="0" width="100" height="100" fill="none"></rect><g transform="translate(25 25)"><rect x="-20" y="-20" width="40" height="40" fill="currentColor" opacity="0.9"><animateTransform attributeName="transform" type="scale" from="1.5" to="1" repeatCount="indefinite" begin="0s" dur="1s" calcMode="spline" keySplines="0.2 0.8 0.2 0.8" keyTimes="0;1"></animateTransform></rect></g><g transform="translate(75 25)"><rect x="-20" y="-20" width="40" height="40" fill="currentColor" opacity="0.8"><animateTransform attributeName="transform" type="scale" from="1.5" to="1" repeatCount="indefinite" begin="0.1s" dur="1s" calcMode="spline" keySplines="0.2 0.8 0.2 0.8" keyTimes="0;1"></animateTransform></rect></g><g transform="translate(25 75)"><rect x="-20" y="-20" width="40" height="40" fill="currentColor" opacity="0.7"><animateTransform attributeName="transform" type="scale" from="1.5" to="1" repeatCount="indefinite" begin="0.3s" dur="1s" calcMode="spline" keySplines="0.2 0.8 0.2 0.8" keyTimes="0;1"></animateTransform></rect></g><g transform="translate(75 75)"><rect x="-20" y="-20" width="40" height="40" fill="currentColor" opacity="0.6"><animateTransform attributeName="transform" type="scale" from="1.5" to="1" repeatCount="indefinite" begin="0.2s" dur="1s" calcMode="spline" keySplines="0.2 0.8 0.2 0.8" keyTimes="0;1"></animateTransform></rect></g>';
createComponent({
  name: "QSpinnerCube",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      innerHTML: innerHTML7
    });
  }
});
var innerHTML8 = '<circle cx="15" cy="15" r="15"><animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="60" cy="15" r="9" fill-opacity=".3"><animate attributeName="r" from="9" to="9" begin="0s" dur="0.8s" values="9;15;9" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="fill-opacity" from=".5" to=".5" begin="0s" dur="0.8s" values=".5;1;.5" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="105" cy="15" r="15"><animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite"></animate></circle>';
createComponent({
  name: "QSpinnerDots",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      fill: "currentColor",
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 120 30",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML8
    });
  }
});
var innerHTML9 = '<g transform="translate(20 50)"><rect x="-10" y="-30" width="20" height="60" fill="currentColor" opacity="0.6"><animateTransform attributeName="transform" type="scale" from="2" to="1" begin="0s" repeatCount="indefinite" dur="1s" calcMode="spline" keySplines="0.1 0.9 0.4 1" keyTimes="0;1" values="2;1"></animateTransform></rect></g><g transform="translate(50 50)"><rect x="-10" y="-30" width="20" height="60" fill="currentColor" opacity="0.8"><animateTransform attributeName="transform" type="scale" from="2" to="1" begin="0.1s" repeatCount="indefinite" dur="1s" calcMode="spline" keySplines="0.1 0.9 0.4 1" keyTimes="0;1" values="2;1"></animateTransform></rect></g><g transform="translate(80 50)"><rect x="-10" y="-30" width="20" height="60" fill="currentColor" opacity="0.9"><animateTransform attributeName="transform" type="scale" from="2" to="1" begin="0.2s" repeatCount="indefinite" dur="1s" calcMode="spline" keySplines="0.1 0.9 0.4 1" keyTimes="0;1" values="2;1"></animateTransform></rect></g>';
createComponent({
  name: "QSpinnerFacebook",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 100 100",
      xmlns: "http://www.w3.org/2000/svg",
      preserveAspectRatio: "xMidYMid",
      innerHTML: innerHTML9
    });
  }
});
var innerHTML10 = '<g transform="translate(-20,-20)"><path d="M79.9,52.6C80,51.8,80,50.9,80,50s0-1.8-0.1-2.6l-5.1-0.4c-0.3-2.4-0.9-4.6-1.8-6.7l4.2-2.9c-0.7-1.6-1.6-3.1-2.6-4.5 L70,35c-1.4-1.9-3.1-3.5-4.9-4.9l2.2-4.6c-1.4-1-2.9-1.9-4.5-2.6L59.8,27c-2.1-0.9-4.4-1.5-6.7-1.8l-0.4-5.1C51.8,20,50.9,20,50,20 s-1.8,0-2.6,0.1l-0.4,5.1c-2.4,0.3-4.6,0.9-6.7,1.8l-2.9-4.1c-1.6,0.7-3.1,1.6-4.5,2.6l2.1,4.6c-1.9,1.4-3.5,3.1-5,4.9l-4.5-2.1 c-1,1.4-1.9,2.9-2.6,4.5l4.1,2.9c-0.9,2.1-1.5,4.4-1.8,6.8l-5,0.4C20,48.2,20,49.1,20,50s0,1.8,0.1,2.6l5,0.4 c0.3,2.4,0.9,4.7,1.8,6.8l-4.1,2.9c0.7,1.6,1.6,3.1,2.6,4.5l4.5-2.1c1.4,1.9,3.1,3.5,5,4.9l-2.1,4.6c1.4,1,2.9,1.9,4.5,2.6l2.9-4.1 c2.1,0.9,4.4,1.5,6.7,1.8l0.4,5.1C48.2,80,49.1,80,50,80s1.8,0,2.6-0.1l0.4-5.1c2.3-0.3,4.6-0.9,6.7-1.8l2.9,4.2 c1.6-0.7,3.1-1.6,4.5-2.6L65,69.9c1.9-1.4,3.5-3,4.9-4.9l4.6,2.2c1-1.4,1.9-2.9,2.6-4.5L73,59.8c0.9-2.1,1.5-4.4,1.8-6.7L79.9,52.6 z M50,65c-8.3,0-15-6.7-15-15c0-8.3,6.7-15,15-15s15,6.7,15,15C65,58.3,58.3,65,50,65z" fill="currentColor"><animateTransform attributeName="transform" type="rotate" from="90 50 50" to="0 50 50" dur="1s" repeatCount="indefinite"></animateTransform></path></g><g transform="translate(20,20) rotate(15 50 50)"><path d="M79.9,52.6C80,51.8,80,50.9,80,50s0-1.8-0.1-2.6l-5.1-0.4c-0.3-2.4-0.9-4.6-1.8-6.7l4.2-2.9c-0.7-1.6-1.6-3.1-2.6-4.5 L70,35c-1.4-1.9-3.1-3.5-4.9-4.9l2.2-4.6c-1.4-1-2.9-1.9-4.5-2.6L59.8,27c-2.1-0.9-4.4-1.5-6.7-1.8l-0.4-5.1C51.8,20,50.9,20,50,20 s-1.8,0-2.6,0.1l-0.4,5.1c-2.4,0.3-4.6,0.9-6.7,1.8l-2.9-4.1c-1.6,0.7-3.1,1.6-4.5,2.6l2.1,4.6c-1.9,1.4-3.5,3.1-5,4.9l-4.5-2.1 c-1,1.4-1.9,2.9-2.6,4.5l4.1,2.9c-0.9,2.1-1.5,4.4-1.8,6.8l-5,0.4C20,48.2,20,49.1,20,50s0,1.8,0.1,2.6l5,0.4 c0.3,2.4,0.9,4.7,1.8,6.8l-4.1,2.9c0.7,1.6,1.6,3.1,2.6,4.5l4.5-2.1c1.4,1.9,3.1,3.5,5,4.9l-2.1,4.6c1.4,1,2.9,1.9,4.5,2.6l2.9-4.1 c2.1,0.9,4.4,1.5,6.7,1.8l0.4,5.1C48.2,80,49.1,80,50,80s1.8,0,2.6-0.1l0.4-5.1c2.3-0.3,4.6-0.9,6.7-1.8l2.9,4.2 c1.6-0.7,3.1-1.6,4.5-2.6L65,69.9c1.9-1.4,3.5-3,4.9-4.9l4.6,2.2c1-1.4,1.9-2.9,2.6-4.5L73,59.8c0.9-2.1,1.5-4.4,1.8-6.7L79.9,52.6 z M50,65c-8.3,0-15-6.7-15-15c0-8.3,6.7-15,15-15s15,6.7,15,15C65,58.3,58.3,65,50,65z" fill="currentColor"><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="90 50 50" dur="1s" repeatCount="indefinite"></animateTransform></path></g>';
createComponent({
  name: "QSpinnerGears",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML10
    });
  }
});
var innerHTML11 = '<circle cx="12.5" cy="12.5" r="12.5"><animate attributeName="fill-opacity" begin="0s" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="12.5" cy="52.5" r="12.5" fill-opacity=".5"><animate attributeName="fill-opacity" begin="100ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="52.5" cy="12.5" r="12.5"><animate attributeName="fill-opacity" begin="300ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="52.5" cy="52.5" r="12.5"><animate attributeName="fill-opacity" begin="600ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="92.5" cy="12.5" r="12.5"><animate attributeName="fill-opacity" begin="800ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="92.5" cy="52.5" r="12.5"><animate attributeName="fill-opacity" begin="400ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="12.5" cy="92.5" r="12.5"><animate attributeName="fill-opacity" begin="700ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="52.5" cy="92.5" r="12.5"><animate attributeName="fill-opacity" begin="500ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="92.5" cy="92.5" r="12.5"><animate attributeName="fill-opacity" begin="200ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle>';
createComponent({
  name: "QSpinnerGrid",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      fill: "currentColor",
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 105 105",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML11
    });
  }
});
var innerHTML12 = '<path d="M30.262 57.02L7.195 40.723c-5.84-3.976-7.56-12.06-3.842-18.063 3.715-6 11.467-7.65 17.306-3.68l4.52 3.76 2.6-5.274c3.716-6.002 11.47-7.65 17.304-3.68 5.84 3.97 7.56 12.054 3.842 18.062L34.49 56.118c-.897 1.512-2.793 1.915-4.228.9z" fill-opacity=".5"><animate attributeName="fill-opacity" begin="0s" dur="1.4s" values="0.5;1;0.5" calcMode="linear" repeatCount="indefinite"></animate></path><path d="M105.512 56.12l-14.44-24.272c-3.716-6.008-1.996-14.093 3.843-18.062 5.835-3.97 13.588-2.322 17.306 3.68l2.6 5.274 4.52-3.76c5.84-3.97 13.593-2.32 17.308 3.68 3.718 6.003 1.998 14.088-3.842 18.064L109.74 57.02c-1.434 1.014-3.33.61-4.228-.9z" fill-opacity=".5"><animate attributeName="fill-opacity" begin="0.7s" dur="1.4s" values="0.5;1;0.5" calcMode="linear" repeatCount="indefinite"></animate></path><path d="M67.408 57.834l-23.01-24.98c-5.864-6.15-5.864-16.108 0-22.248 5.86-6.14 15.37-6.14 21.234 0L70 16.168l4.368-5.562c5.863-6.14 15.375-6.14 21.235 0 5.863 6.14 5.863 16.098 0 22.247l-23.007 24.98c-1.43 1.556-3.757 1.556-5.188 0z"></path>';
createComponent({
  name: "QSpinnerHearts",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      fill: "currentColor",
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 140 64",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML12
    });
  }
});
var innerHTML13 = '<g><path fill="none" stroke="currentColor" stroke-width="5" stroke-miterlimit="10" d="M58.4,51.7c-0.9-0.9-1.4-2-1.4-2.3s0.5-0.4,1.4-1.4 C70.8,43.8,79.8,30.5,80,15.5H70H30H20c0.2,15,9.2,28.1,21.6,32.3c0.9,0.9,1.4,1.2,1.4,1.5s-0.5,1.6-1.4,2.5 C29.2,56.1,20.2,69.5,20,85.5h10h40h10C79.8,69.5,70.8,55.9,58.4,51.7z"></path><clipPath id="uil-hourglass-clip1"><rect x="15" y="20" width="70" height="25"><animate attributeName="height" from="25" to="0" dur="1s" repeatCount="indefinite" values="25;0;0" keyTimes="0;0.5;1"></animate><animate attributeName="y" from="20" to="45" dur="1s" repeatCount="indefinite" values="20;45;45" keyTimes="0;0.5;1"></animate></rect></clipPath><clipPath id="uil-hourglass-clip2"><rect x="15" y="55" width="70" height="25"><animate attributeName="height" from="0" to="25" dur="1s" repeatCount="indefinite" values="0;25;25" keyTimes="0;0.5;1"></animate><animate attributeName="y" from="80" to="55" dur="1s" repeatCount="indefinite" values="80;55;55" keyTimes="0;0.5;1"></animate></rect></clipPath><path d="M29,23c3.1,11.4,11.3,19.5,21,19.5S67.9,34.4,71,23H29z" clip-path="url(#uil-hourglass-clip1)" fill="currentColor"></path><path d="M71.6,78c-3-11.6-11.5-20-21.5-20s-18.5,8.4-21.5,20H71.6z" clip-path="url(#uil-hourglass-clip2)" fill="currentColor"></path><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="180 50 50" repeatCount="indefinite" dur="1s" values="0 50 50;0 50 50;180 50 50" keyTimes="0;0.7;1"></animateTransform></g>';
createComponent({
  name: "QSpinnerHourglass",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML13
    });
  }
});
var innerHTML14 = '<path d="M24.3,30C11.4,30,5,43.3,5,50s6.4,20,19.3,20c19.3,0,32.1-40,51.4-40C88.6,30,95,43.3,95,50s-6.4,20-19.3,20C56.4,70,43.6,30,24.3,30z" fill="none" stroke="currentColor" stroke-width="8" stroke-dasharray="10.691205342610678 10.691205342610678" stroke-dashoffset="0"><animate attributeName="stroke-dashoffset" from="0" to="21.382410685221355" begin="0" dur="2s" repeatCount="indefinite" fill="freeze"></animate></path>';
createComponent({
  name: "QSpinnerInfinity",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      innerHTML: innerHTML14
    });
  }
});
var innerHTML15 = '<g stroke-width="4" stroke-linecap="round"><line y1="17" y2="29" transform="translate(32,32) rotate(180)"><animate attributeName="stroke-opacity" dur="750ms" values="1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0;1" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(210)"><animate attributeName="stroke-opacity" dur="750ms" values="0;1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(240)"><animate attributeName="stroke-opacity" dur="750ms" values=".1;0;1;.85;.7;.65;.55;.45;.35;.25;.15;.1" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(270)"><animate attributeName="stroke-opacity" dur="750ms" values=".15;.1;0;1;.85;.7;.65;.55;.45;.35;.25;.15" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(300)"><animate attributeName="stroke-opacity" dur="750ms" values=".25;.15;.1;0;1;.85;.7;.65;.55;.45;.35;.25" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(330)"><animate attributeName="stroke-opacity" dur="750ms" values=".35;.25;.15;.1;0;1;.85;.7;.65;.55;.45;.35" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(0)"><animate attributeName="stroke-opacity" dur="750ms" values=".45;.35;.25;.15;.1;0;1;.85;.7;.65;.55;.45" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(30)"><animate attributeName="stroke-opacity" dur="750ms" values=".55;.45;.35;.25;.15;.1;0;1;.85;.7;.65;.55" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(60)"><animate attributeName="stroke-opacity" dur="750ms" values=".65;.55;.45;.35;.25;.15;.1;0;1;.85;.7;.65" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(90)"><animate attributeName="stroke-opacity" dur="750ms" values=".7;.65;.55;.45;.35;.25;.15;.1;0;1;.85;.7" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(120)"><animate attributeName="stroke-opacity" dur="750ms" values=".85;.7;.65;.55;.45;.35;.25;.15;.1;0;1;.85" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(150)"><animate attributeName="stroke-opacity" dur="750ms" values="1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0;1" repeatCount="indefinite"></animate></line></g>';
createComponent({
  name: "QSpinnerIos",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      stroke: "currentColor",
      fill: "currentColor",
      viewBox: "0 0 64 64",
      innerHTML: innerHTML15
    });
  }
});
var innerHTML16 = '<circle cx="50" cy="50" r="44" fill="none" stroke-width="4" stroke-opacity=".5" stroke="currentColor"></circle><circle cx="8" cy="54" r="6" fill="currentColor" stroke-width="3" stroke="currentColor"><animateTransform attributeName="transform" type="rotate" from="0 50 48" to="360 50 52" dur="2s" repeatCount="indefinite"></animateTransform></circle>';
createComponent({
  name: "QSpinnerOrbit",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML16
    });
  }
});
var innerHTML17 = '<g transform="translate(1 1)" stroke-width="2" fill="none" fill-rule="evenodd"><circle stroke-opacity=".5" cx="18" cy="18" r="18"></circle><path d="M36 18c0-9.94-8.06-18-18-18"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite"></animateTransform></path></g>';
createComponent({
  name: "QSpinnerOval",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      stroke: "currentColor",
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 38 38",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML17
    });
  }
});
var innerHTML18 = '<path d="M0 50A50 50 0 0 1 50 0L50 50L0 50" fill="currentColor" opacity="0.5"><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="0.8s" repeatCount="indefinite"></animateTransform></path><path d="M50 0A50 50 0 0 1 100 50L50 50L50 0" fill="currentColor" opacity="0.5"><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="1.6s" repeatCount="indefinite"></animateTransform></path><path d="M100 50A50 50 0 0 1 50 100L50 50L100 50" fill="currentColor" opacity="0.5"><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="2.4s" repeatCount="indefinite"></animateTransform></path><path d="M50 100A50 50 0 0 1 0 50L50 50L50 100" fill="currentColor" opacity="0.5"><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="3.2s" repeatCount="indefinite"></animateTransform></path>';
createComponent({
  name: "QSpinnerPie",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML18
    });
  }
});
var innerHTML19 = '<g fill="none" fill-rule="evenodd" stroke-width="2"><circle cx="22" cy="22" r="1"><animate attributeName="r" begin="0s" dur="1.8s" values="1; 20" calcMode="spline" keyTimes="0; 1" keySplines="0.165, 0.84, 0.44, 1" repeatCount="indefinite"></animate><animate attributeName="stroke-opacity" begin="0s" dur="1.8s" values="1; 0" calcMode="spline" keyTimes="0; 1" keySplines="0.3, 0.61, 0.355, 1" repeatCount="indefinite"></animate></circle><circle cx="22" cy="22" r="1"><animate attributeName="r" begin="-0.9s" dur="1.8s" values="1; 20" calcMode="spline" keyTimes="0; 1" keySplines="0.165, 0.84, 0.44, 1" repeatCount="indefinite"></animate><animate attributeName="stroke-opacity" begin="-0.9s" dur="1.8s" values="1; 0" calcMode="spline" keyTimes="0; 1" keySplines="0.3, 0.61, 0.355, 1" repeatCount="indefinite"></animate></circle></g>';
createComponent({
  name: "QSpinnerPuff",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      stroke: "currentColor",
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 44 44",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML19
    });
  }
});
var innerHTML20 = '<g transform="scale(0.55)"><circle cx="30" cy="150" r="30" fill="currentColor"><animate attributeName="opacity" from="0" to="1" dur="1s" begin="0" repeatCount="indefinite" keyTimes="0;0.5;1" values="0;1;1"></animate></circle><path d="M90,150h30c0-49.7-40.3-90-90-90v30C63.1,90,90,116.9,90,150z" fill="currentColor"><animate attributeName="opacity" from="0" to="1" dur="1s" begin="0.1" repeatCount="indefinite" keyTimes="0;0.5;1" values="0;1;1"></animate></path><path d="M150,150h30C180,67.2,112.8,0,30,0v30C96.3,30,150,83.7,150,150z" fill="currentColor"><animate attributeName="opacity" from="0" to="1" dur="1s" begin="0.2" repeatCount="indefinite" keyTimes="0;0.5;1" values="0;1;1"></animate></path></g>';
createComponent({
  name: "QSpinnerRadio",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML20
    });
  }
});
var innerHTML21 = '<g fill="none" fill-rule="evenodd" transform="translate(1 1)" stroke-width="2"><circle cx="22" cy="22" r="6"><animate attributeName="r" begin="1.5s" dur="3s" values="6;22" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="stroke-opacity" begin="1.5s" dur="3s" values="1;0" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="stroke-width" begin="1.5s" dur="3s" values="2;0" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="22" cy="22" r="6"><animate attributeName="r" begin="3s" dur="3s" values="6;22" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="stroke-opacity" begin="3s" dur="3s" values="1;0" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="stroke-width" begin="3s" dur="3s" values="2;0" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="22" cy="22" r="8"><animate attributeName="r" begin="0s" dur="1.5s" values="6;1;2;3;4;5;6" calcMode="linear" repeatCount="indefinite"></animate></circle></g>';
createComponent({
  name: "QSpinnerRings",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      stroke: "currentColor",
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 45 45",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML21
    });
  }
});
var innerHTML22 = '<defs><linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a"><stop stop-color="currentColor" stop-opacity="0" offset="0%"></stop><stop stop-color="currentColor" stop-opacity=".631" offset="63.146%"></stop><stop stop-color="currentColor" offset="100%"></stop></linearGradient></defs><g transform="translate(1 1)" fill="none" fill-rule="evenodd"><path d="M36 18c0-9.94-8.06-18-18-18" stroke="url(#a)" stroke-width="2"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.9s" repeatCount="indefinite"></animateTransform></path><circle fill="currentColor" cx="36" cy="18" r="1"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.9s" repeatCount="indefinite"></animateTransform></circle></g>';
createComponent({
  name: "QSpinnerTail",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 38 38",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML22
    });
  }
});
createComponent({
  name: "QSplitter",
  props: {
    ...useDarkProps,
    modelValue: {
      type: Number,
      required: true
    },
    reverse: Boolean,
    unit: {
      type: String,
      default: "%",
      validator: (v) => ["%", "px"].includes(v)
    },
    limits: {
      type: Array,
      validator: (v) => {
        if (v.length !== 2) return false;
        if (typeof v[0] !== "number" || typeof v[1] !== "number") return false;
        return v[0] >= 0 && v[0] <= v[1];
      }
    },
    emitImmediately: Boolean,
    horizontal: Boolean,
    disable: Boolean,
    beforeClass: [Array, String, Object],
    afterClass: [Array, String, Object],
    separatorClass: [Array, String, Object],
    separatorStyle: [Array, String, Object]
  },
  emits: ["update:modelValue"],
  setup(props4, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const isDark = use_dark_default(props4, $q);
    const rootRef = ref$1(null);
    const sideRefs = {
      before: ref$1(null),
      after: ref$1(null)
    };
    const classes = computed(
      () => `q-splitter no-wrap ${props4.horizontal === true ? "q-splitter--horizontal column" : "q-splitter--vertical row"} q-splitter--${props4.disable === true ? "disabled" : "workable"}` + (isDark.value === true ? " q-splitter--dark" : "")
    );
    const propName = computed(() => props4.horizontal === true ? "height" : "width");
    const side = computed(() => props4.reverse !== true ? "before" : "after");
    const computedLimits = computed(() => props4.limits !== void 0 ? props4.limits : props4.unit === "%" ? [10, 90] : [50, Infinity]);
    function getCSSValue(value2) {
      return (props4.unit === "%" ? value2 : Math.round(value2)) + props4.unit;
    }
    const styles = computed(() => ({
      [side.value]: {
        [propName.value]: getCSSValue(props4.modelValue)
      }
    }));
    let __dir, __maxValue, __value, __multiplier, __normalized;
    function pan(evt) {
      if (evt.isFirst === true) {
        const size2 = rootRef.value.getBoundingClientRect()[propName.value];
        __dir = props4.horizontal === true ? "up" : "left";
        __maxValue = props4.unit === "%" ? 100 : size2;
        __value = Math.min(__maxValue, computedLimits.value[1], Math.max(computedLimits.value[0], props4.modelValue));
        __multiplier = (props4.reverse !== true ? 1 : -1) * (props4.horizontal === true ? 1 : $q.lang.rtl === true ? -1 : 1) * (props4.unit === "%" ? size2 === 0 ? 0 : 100 / size2 : 1);
        rootRef.value.classList.add("q-splitter--active");
        return;
      }
      if (evt.isFinal === true) {
        if (__normalized !== props4.modelValue) {
          emit("update:modelValue", __normalized);
        }
        rootRef.value.classList.remove("q-splitter--active");
        return;
      }
      const val = __value + __multiplier * (evt.direction === __dir ? -1 : 1) * evt.distance[props4.horizontal === true ? "y" : "x"];
      __normalized = Math.min(__maxValue, computedLimits.value[1], Math.max(computedLimits.value[0], val));
      sideRefs[side.value].value.style[propName.value] = getCSSValue(__normalized);
      if (props4.emitImmediately === true && props4.modelValue !== __normalized) {
        emit("update:modelValue", __normalized);
      }
    }
    const sepDirective = computed(() => {
      return [[
        TouchPan_default,
        pan,
        void 0,
        {
          [props4.horizontal === true ? "vertical" : "horizontal"]: true,
          prevent: true,
          stop: true,
          mouse: true,
          mouseAllDir: true
        }
      ]];
    });
    function normalize2(val, limits) {
      if (val < limits[0]) {
        emit("update:modelValue", limits[0]);
      } else if (val > limits[1]) {
        emit("update:modelValue", limits[1]);
      }
    }
    watch(() => props4.modelValue, (v) => {
      normalize2(v, computedLimits.value);
    });
    watch(() => props4.limits, () => {
      nextTick(() => {
        normalize2(props4.modelValue, computedLimits.value);
      });
    });
    return () => {
      const child = [
        h("div", {
          ref: sideRefs.before,
          class: [
            "q-splitter__panel q-splitter__before" + (props4.reverse === true ? " col" : ""),
            props4.beforeClass
          ],
          style: styles.value.before
        }, hSlot(slots.before)),
        h("div", {
          class: [
            "q-splitter__separator",
            props4.separatorClass
          ],
          style: props4.separatorStyle,
          "aria-disabled": props4.disable === true ? "true" : void 0
        }, [
          hDir(
            "div",
            { class: "q-splitter__separator-area absolute-full" },
            hSlot(slots.separator),
            "sep",
            props4.disable !== true,
            () => sepDirective.value
          )
        ]),
        h("div", {
          ref: sideRefs.after,
          class: [
            "q-splitter__panel q-splitter__after" + (props4.reverse === true ? "" : " col"),
            props4.afterClass
          ],
          style: styles.value.after
        }, hSlot(slots.after))
      ];
      return h("div", {
        class: classes.value,
        ref: rootRef
      }, hMergeSlot(slots.default, child));
    };
  }
});
var StepHeader_default = createComponent({
  name: "StepHeader",
  props: {
    stepper: {},
    step: {},
    goToPanel: Function
  },
  setup(props4, { attrs }) {
    const { proxy: { $q } } = getCurrentInstance();
    const blurRef = ref$1(null);
    const isActive = computed(() => props4.stepper.modelValue === props4.step.name);
    const isDisable = computed(() => {
      const opt = props4.step.disable;
      return opt === true || opt === "";
    });
    const isError = computed(() => {
      const opt = props4.step.error;
      return opt === true || opt === "";
    });
    const isDone = computed(() => {
      const opt = props4.step.done;
      return isDisable.value === false && (opt === true || opt === "");
    });
    const headerNav = computed(() => {
      const opt = props4.step.headerNav, nav = opt === true || opt === "" || opt === void 0;
      return isDisable.value === false && props4.stepper.headerNav && nav;
    });
    const hasPrefix = computed(() => {
      return props4.step.prefix && (isActive.value === false || props4.stepper.activeIcon === "none") && (isError.value === false || props4.stepper.errorIcon === "none") && (isDone.value === false || props4.stepper.doneIcon === "none");
    });
    const icon = computed(() => {
      const defaultIcon = props4.step.icon || props4.stepper.inactiveIcon;
      if (isActive.value === true) {
        const icon2 = props4.step.activeIcon || props4.stepper.activeIcon;
        return icon2 === "none" ? defaultIcon : icon2 || $q.iconSet.stepper.active;
      }
      if (isError.value === true) {
        const icon2 = props4.step.errorIcon || props4.stepper.errorIcon;
        return icon2 === "none" ? defaultIcon : icon2 || $q.iconSet.stepper.error;
      }
      if (isDisable.value === false && isDone.value === true) {
        const icon2 = props4.step.doneIcon || props4.stepper.doneIcon;
        return icon2 === "none" ? defaultIcon : icon2 || $q.iconSet.stepper.done;
      }
      return defaultIcon;
    });
    const color2 = computed(() => {
      const errorColor = isError.value === true ? props4.step.errorColor || props4.stepper.errorColor : void 0;
      if (isActive.value === true) {
        const color22 = props4.step.activeColor || props4.stepper.activeColor || props4.step.color;
        return color22 !== void 0 ? color22 : errorColor;
      }
      if (errorColor !== void 0) {
        return errorColor;
      }
      if (isDisable.value === false && isDone.value === true) {
        return props4.step.doneColor || props4.stepper.doneColor || props4.step.color || props4.stepper.inactiveColor;
      }
      return props4.step.color || props4.stepper.inactiveColor;
    });
    const classes = computed(() => {
      return "q-stepper__tab col-grow flex items-center no-wrap relative-position" + (color2.value !== void 0 ? ` text-${color2.value}` : "") + (isError.value === true ? " q-stepper__tab--error q-stepper__tab--error-with-" + (hasPrefix.value === true ? "prefix" : "icon") : "") + (isActive.value === true ? " q-stepper__tab--active" : "") + (isDone.value === true ? " q-stepper__tab--done" : "") + (headerNav.value === true ? " q-stepper__tab--navigation q-focusable q-hoverable" : "") + (isDisable.value === true ? " q-stepper__tab--disabled" : "");
    });
    const ripple = computed(() => props4.stepper.headerNav !== true ? false : headerNav.value);
    function onActivate() {
      var _a;
      (_a = blurRef.value) == null ? void 0 : _a.focus();
      isActive.value === false && props4.goToPanel(props4.step.name);
    }
    function onKeyup2(e3) {
      if (e3.keyCode === 13 && isActive.value === false) {
        props4.goToPanel(props4.step.name);
      }
    }
    return () => {
      const data = { class: classes.value };
      if (headerNav.value === true) {
        data.onClick = onActivate;
        data.onKeyup = onKeyup2;
        Object.assign(
          data,
          isDisable.value === true ? { tabindex: -1, "aria-disabled": "true" } : { tabindex: attrs.tabindex || 0 }
        );
      }
      const child = [
        h("div", { class: "q-focus-helper", tabindex: -1, ref: blurRef }),
        h("div", { class: "q-stepper__dot row flex-center q-stepper__line relative-position" }, [
          h("span", { class: "row flex-center" }, [
            hasPrefix.value === true ? props4.step.prefix : h(QIcon_default, { name: icon.value })
          ])
        ])
      ];
      if (props4.step.title !== void 0 && props4.step.title !== null) {
        const content = [
          h("div", { class: "q-stepper__title" }, props4.step.title)
        ];
        if (props4.step.caption !== void 0 && props4.step.caption !== null) {
          content.push(
            h("div", { class: "q-stepper__caption" }, props4.step.caption)
          );
        }
        child.push(
          h("div", {
            class: "q-stepper__label q-stepper__line relative-position"
          }, content)
        );
      }
      return withDirectives(
        h("div", data, child),
        [[Ripple_default, ripple.value]]
      );
    };
  }
});
function getStepWrapper(slots) {
  return h("div", {
    class: "q-stepper__step-content"
  }, [
    h("div", {
      class: "q-stepper__step-inner"
    }, hSlot(slots.default))
  ]);
}
var PanelWrapper2 = {
  setup(_, { slots }) {
    return () => getStepWrapper(slots);
  }
};
createComponent({
  name: "QStep",
  props: {
    ...usePanelChildProps,
    icon: String,
    color: String,
    title: {
      type: String,
      required: true
    },
    caption: String,
    prefix: [String, Number],
    doneIcon: String,
    doneColor: String,
    activeIcon: String,
    activeColor: String,
    errorIcon: String,
    errorColor: String,
    headerNav: {
      type: Boolean,
      default: true
    },
    done: Boolean,
    error: Boolean,
    onScroll: [Function, Array]
  },
  setup(props4, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const $stepper = inject(stepperKey, emptyRenderFn);
    if ($stepper === emptyRenderFn) {
      console.error("QStep needs to be a child of QStepper");
      return emptyRenderFn;
    }
    const { getCache } = use_render_cache_default();
    const rootRef = ref$1(null);
    const isActive = computed(() => $stepper.value.modelValue === props4.name);
    const scrollEvent = computed(() => $q.platform.is.ios !== true && $q.platform.is.chrome === true || isActive.value !== true || $stepper.value.vertical !== true ? {} : {
      onScroll(e3) {
        const { target: target2 } = e3;
        if (target2.scrollTop > 0) {
          target2.scrollTop = 0;
        }
        props4.onScroll !== void 0 && emit("scroll", e3);
      }
    });
    const contentKey = computed(() => typeof props4.name === "string" || typeof props4.name === "number" ? props4.name : String(props4.name));
    function getStepContent() {
      const vertical = $stepper.value.vertical;
      if (vertical === true && $stepper.value.keepAlive === true) {
        return h(
          KeepAlive,
          $stepper.value.keepAliveProps.value,
          isActive.value === true ? [
            h(
              $stepper.value.needsUniqueKeepAliveWrapper.value === true ? getCache(contentKey.value, () => ({ ...PanelWrapper2, name: contentKey.value })) : PanelWrapper2,
              { key: contentKey.value },
              slots.default
            )
          ] : void 0
        );
      }
      return vertical !== true || isActive.value === true ? getStepWrapper(slots) : void 0;
    }
    return () => h(
      "div",
      { ref: rootRef, class: "q-stepper__step", role: "tabpanel", ...scrollEvent.value },
      $stepper.value.vertical === true ? [
        h(StepHeader_default, {
          stepper: $stepper.value,
          step: props4,
          goToPanel: $stepper.value.goToPanel
        }),
        $stepper.value.animated === true ? h(QSlideTransition_default, getStepContent) : getStepContent()
      ] : [getStepContent()]
    );
  }
});
var camelRE = /(-\w)/g;
function camelizeProps(props4) {
  const acc = {};
  for (const key in props4) {
    const newKey = key.replace(camelRE, (m4) => m4[1].toUpperCase());
    acc[newKey] = props4[key];
  }
  return acc;
}
createComponent({
  name: "QStepper",
  props: {
    ...useDarkProps,
    ...usePanelProps,
    flat: Boolean,
    bordered: Boolean,
    alternativeLabels: Boolean,
    headerNav: Boolean,
    contracted: Boolean,
    headerClass: String,
    inactiveColor: String,
    inactiveIcon: String,
    doneIcon: String,
    doneColor: String,
    activeIcon: String,
    activeColor: String,
    errorIcon: String,
    errorColor: String
  },
  emits: usePanelEmits,
  setup(props4, { slots }) {
    const vm2 = getCurrentInstance();
    const isDark = use_dark_default(props4, vm2.proxy.$q);
    const {
      updatePanelsList,
      isValidPanelName,
      updatePanelIndex,
      getPanelContent,
      getPanels,
      panelDirectives,
      goToPanel,
      keepAliveProps,
      needsUniqueKeepAliveWrapper
    } = use_panel_default();
    provide(stepperKey, computed(() => ({
      goToPanel,
      keepAliveProps,
      needsUniqueKeepAliveWrapper,
      ...props4
    })));
    const classes = computed(
      () => `q-stepper q-stepper--${props4.vertical === true ? "vertical" : "horizontal"}` + (props4.flat === true ? " q-stepper--flat" : "") + (props4.bordered === true ? " q-stepper--bordered" : "") + (isDark.value === true ? " q-stepper--dark q-dark" : "")
    );
    const headerClasses = computed(
      () => `q-stepper__header row items-stretch justify-between q-stepper__header--${props4.alternativeLabels === true ? "alternative" : "standard"}-labels` + (props4.flat === false || props4.bordered === true ? " q-stepper__header--border" : "") + (props4.contracted === true ? " q-stepper__header--contracted" : "") + (props4.headerClass !== void 0 ? ` ${props4.headerClass}` : "")
    );
    function getContent() {
      const top = hSlot(slots.message, []);
      if (props4.vertical === true) {
        isValidPanelName(props4.modelValue) && updatePanelIndex();
        const content = h("div", {
          class: "q-stepper__content"
        }, hSlot(slots.default));
        return top === void 0 ? [content] : top.concat(content);
      }
      return [
        h(
          "div",
          { class: headerClasses.value },
          getPanels().map((panel) => {
            const step = camelizeProps(panel.props);
            return h(StepHeader_default, {
              key: step.name,
              stepper: props4,
              step,
              goToPanel
            });
          })
        ),
        top,
        hDir(
          "div",
          { class: "q-stepper__content q-panel-parent" },
          getPanelContent(),
          "cont",
          props4.swipeable,
          () => panelDirectives.value
        )
      ];
    }
    return () => {
      updatePanelsList(slots);
      return h("div", {
        class: classes.value
      }, hMergeSlot(slots.navigation, getContent()));
    };
  }
});
createComponent({
  name: "QStepperNavigation",
  setup(_, { slots }) {
    return () => h("div", { class: "q-stepper__nav" }, hSlot(slots.default));
  }
});
var QTh_default = createComponent({
  name: "QTh",
  props: {
    props: Object,
    autoWidth: Boolean
  },
  emits: ["click"],
  setup(props4, { slots, emit }) {
    const vm2 = getCurrentInstance();
    const { proxy: { $q } } = vm2;
    const onClick = (evt) => {
      emit("click", evt);
    };
    return () => {
      if (props4.props === void 0) {
        return h("th", {
          class: props4.autoWidth === true ? "q-table--col-auto-width" : "",
          onClick
        }, hSlot(slots.default));
      }
      let col, child;
      const name2 = vm2.vnode.key;
      if (name2) {
        col = props4.props.colsMap[name2];
        if (col === void 0) return;
      } else {
        col = props4.props.col;
      }
      if (col.sortable === true) {
        const action = col.align === "right" ? "unshift" : "push";
        child = hUniqueSlot(slots.default, []);
        child[action](
          h(QIcon_default, {
            class: col.__iconClass,
            name: $q.iconSet.table.arrowUp
          })
        );
      } else {
        child = hSlot(slots.default);
      }
      const data = {
        class: col.__thClass + (props4.autoWidth === true ? " q-table--col-auto-width" : ""),
        style: col.headerStyle,
        onClick: (evt) => {
          col.sortable === true && props4.props.sort(col);
          onClick(evt);
        }
      };
      return h("th", data, child);
    };
  }
});
function get_table_middle_default(props4, content) {
  return h("div", props4, [
    h("table", { class: "q-table" }, content)
  ]);
}
var comps = {
  list: QList_default,
  table: QMarkupTable_default
};
var typeOptions = ["list", "table", "__qtable"];
var QVirtualScroll_default = createComponent({
  name: "QVirtualScroll",
  props: {
    ...useVirtualScrollProps,
    type: {
      type: String,
      default: "list",
      validator: (v) => typeOptions.includes(v)
    },
    items: {
      type: Array,
      default: () => []
    },
    itemsFn: Function,
    itemsSize: Number,
    scrollTarget: scrollTargetProp
  },
  setup(props4, { slots, attrs }) {
    let localScrollTarget;
    const rootRef = ref$1(null);
    const virtualScrollLength = computed(() => props4.itemsSize >= 0 && props4.itemsFn !== void 0 ? parseInt(props4.itemsSize, 10) : Array.isArray(props4.items) ? props4.items.length : 0);
    const {
      virtualScrollSliceRange,
      localResetVirtualScroll,
      padVirtualScroll,
      onVirtualScrollEvt
    } = useVirtualScroll({
      virtualScrollLength,
      getVirtualScrollTarget,
      getVirtualScrollEl
    });
    const virtualScrollScope = computed(() => {
      if (virtualScrollLength.value === 0) {
        return [];
      }
      const mapFn = (item, i3) => ({
        index: virtualScrollSliceRange.value.from + i3,
        item
      });
      return props4.itemsFn === void 0 ? props4.items.slice(virtualScrollSliceRange.value.from, virtualScrollSliceRange.value.to).map(mapFn) : props4.itemsFn(virtualScrollSliceRange.value.from, virtualScrollSliceRange.value.to - virtualScrollSliceRange.value.from).map(mapFn);
    });
    const classes = computed(
      () => "q-virtual-scroll q-virtual-scroll" + (props4.virtualScrollHorizontal === true ? "--horizontal" : "--vertical") + (props4.scrollTarget !== void 0 ? "" : " scroll")
    );
    const attributes = computed(() => props4.scrollTarget !== void 0 ? {} : { tabindex: 0 });
    watch(virtualScrollLength, () => {
      localResetVirtualScroll();
    });
    watch(() => props4.scrollTarget, () => {
      unconfigureScrollTarget();
      configureScrollTarget();
    });
    function getVirtualScrollEl() {
      return rootRef.value.$el || rootRef.value;
    }
    function getVirtualScrollTarget() {
      return localScrollTarget;
    }
    function configureScrollTarget() {
      localScrollTarget = getScrollTarget(getVirtualScrollEl(), props4.scrollTarget);
      localScrollTarget.addEventListener("scroll", onVirtualScrollEvt, listenOpts.passive);
    }
    function unconfigureScrollTarget() {
      if (localScrollTarget !== void 0) {
        localScrollTarget.removeEventListener("scroll", onVirtualScrollEvt, listenOpts.passive);
        localScrollTarget = void 0;
      }
    }
    function __getVirtualChildren() {
      let child = padVirtualScroll(
        props4.type === "list" ? "div" : "tbody",
        virtualScrollScope.value.map(slots.default)
      );
      if (slots.before !== void 0) {
        child = slots.before().concat(child);
      }
      return hMergeSlot(slots.after, child);
    }
    onBeforeMount(() => {
      localResetVirtualScroll();
    });
    onMounted(() => {
      configureScrollTarget();
    });
    onActivated(() => {
      configureScrollTarget();
    });
    onDeactivated(() => {
      unconfigureScrollTarget();
    });
    onBeforeUnmount(() => {
      unconfigureScrollTarget();
    });
    return () => {
      if (slots.default === void 0) {
        console.error("QVirtualScroll: default scoped slot is required for rendering");
        return;
      }
      return props4.type === "__qtable" ? get_table_middle_default(
        { ref: rootRef, class: "q-table__middle " + classes.value },
        __getVirtualChildren()
      ) : h(comps[props4.type], {
        ...attrs,
        ref: rootRef,
        class: [attrs.class, classes.value],
        ...attributes.value
      }, __getVirtualChildren);
    };
  }
});
function sortDate(a4, b3) {
  return new Date(a4) - new Date(b3);
}
var useTableSortProps = {
  sortMethod: Function,
  binaryStateSort: Boolean,
  columnSortOrder: {
    type: String,
    validator: (v) => v === "ad" || v === "da",
    default: "ad"
  }
};
function useTableSort(props4, computedPagination, colList, setPagination) {
  const columnToSort = computed(() => {
    const { sortBy } = computedPagination.value;
    return sortBy ? colList.value.find((def) => def.name === sortBy) || null : null;
  });
  const computedSortMethod = computed(() => props4.sortMethod !== void 0 ? props4.sortMethod : (data, sortBy, descending) => {
    const col = colList.value.find((def) => def.name === sortBy);
    if (col === void 0 || col.field === void 0) {
      return data;
    }
    const dir = descending === true ? -1 : 1, val = typeof col.field === "function" ? (v) => col.field(v) : (v) => v[col.field];
    return data.sort((a4, b3) => {
      let A2 = val(a4), B3 = val(b3);
      if (col.rawSort !== void 0) {
        return col.rawSort(A2, B3, a4, b3) * dir;
      }
      if (A2 === null || A2 === void 0) {
        return -1 * dir;
      }
      if (B3 === null || B3 === void 0) {
        return 1 * dir;
      }
      if (col.sort !== void 0) {
        return col.sort(A2, B3, a4, b3) * dir;
      }
      if (isNumber(A2) === true && isNumber(B3) === true) {
        return (A2 - B3) * dir;
      }
      if (isDate(A2) === true && isDate(B3) === true) {
        return sortDate(A2, B3) * dir;
      }
      if (typeof A2 === "boolean" && typeof B3 === "boolean") {
        return (A2 - B3) * dir;
      }
      [A2, B3] = [A2, B3].map((s4) => (s4 + "").toLocaleString().toLowerCase());
      return A2 < B3 ? -1 * dir : A2 === B3 ? 0 : dir;
    });
  });
  function sort(col) {
    let sortOrder = props4.columnSortOrder;
    if (isObject(col) === true) {
      if (col.sortOrder) {
        sortOrder = col.sortOrder;
      }
      col = col.name;
    } else {
      const def = colList.value.find((def2) => def2.name === col);
      if (def == null ? void 0 : def.sortOrder) {
        sortOrder = def.sortOrder;
      }
    }
    let { sortBy, descending } = computedPagination.value;
    if (sortBy !== col) {
      sortBy = col;
      descending = sortOrder === "da";
    } else if (props4.binaryStateSort === true) {
      descending = !descending;
    } else if (descending === true) {
      if (sortOrder === "ad") {
        sortBy = null;
      } else {
        descending = false;
      }
    } else {
      if (sortOrder === "ad") {
        descending = true;
      } else {
        sortBy = null;
      }
    }
    setPagination({ sortBy, descending, page: 1 });
  }
  return {
    columnToSort,
    computedSortMethod,
    sort
  };
}
var useTableFilterProps = {
  filter: [String, Object],
  filterMethod: Function
};
function useTableFilter(props4, setPagination) {
  const computedFilterMethod = computed(() => props4.filterMethod !== void 0 ? props4.filterMethod : (rows, terms, cols, cellValue) => {
    const lowerTerms = terms ? terms.toLowerCase() : "";
    return rows.filter(
      (row) => cols.some((col) => {
        const val = cellValue(col, row) + "";
        const haystack = val === "undefined" || val === "null" ? "" : val.toLowerCase();
        return haystack.indexOf(lowerTerms) !== -1;
      })
    );
  });
  watch(
    () => props4.filter,
    () => {
      nextTick(() => {
        setPagination({ page: 1 }, true);
      });
    },
    { deep: true }
  );
  return { computedFilterMethod };
}
function samePagination(oldPag, newPag) {
  for (const prop in newPag) {
    if (newPag[prop] !== oldPag[prop]) {
      return false;
    }
  }
  return true;
}
function fixPagination(p2) {
  if (p2.page < 1) {
    p2.page = 1;
  }
  if (p2.rowsPerPage !== void 0 && p2.rowsPerPage < 1) {
    p2.rowsPerPage = 0;
  }
  return p2;
}
var useTablePaginationProps = {
  pagination: Object,
  rowsPerPageOptions: {
    type: Array,
    default: () => [5, 7, 10, 15, 20, 25, 50, 0]
  },
  "onUpdate:pagination": [Function, Array]
};
function useTablePaginationState(vm2, getCellValue) {
  const { props: props4, emit } = vm2;
  const innerPagination = ref$1(
    Object.assign({
      sortBy: null,
      descending: false,
      page: 1,
      rowsPerPage: props4.rowsPerPageOptions.length !== 0 ? props4.rowsPerPageOptions[0] : 5
    }, props4.pagination)
  );
  const computedPagination = computed(() => {
    const pag = props4["onUpdate:pagination"] !== void 0 ? { ...innerPagination.value, ...props4.pagination } : innerPagination.value;
    return fixPagination(pag);
  });
  const isServerSide = computed(() => computedPagination.value.rowsNumber !== void 0);
  function sendServerRequest(pagination) {
    requestServerInteraction({
      pagination,
      filter: props4.filter
    });
  }
  function requestServerInteraction(prop = {}) {
    nextTick(() => {
      emit("request", {
        pagination: prop.pagination || computedPagination.value,
        filter: prop.filter || props4.filter,
        getCellValue
      });
    });
  }
  function setPagination(val, forceServerRequest) {
    const newPagination = fixPagination({
      ...computedPagination.value,
      ...val
    });
    if (samePagination(computedPagination.value, newPagination) === true) {
      if (isServerSide.value === true && forceServerRequest === true) {
        sendServerRequest(newPagination);
      }
      return;
    }
    if (isServerSide.value === true) {
      sendServerRequest(newPagination);
      return;
    }
    if (props4.pagination !== void 0 && props4["onUpdate:pagination"] !== void 0) {
      emit("update:pagination", newPagination);
    } else {
      innerPagination.value = newPagination;
    }
  }
  return {
    innerPagination,
    computedPagination,
    isServerSide,
    requestServerInteraction,
    setPagination
  };
}
function useTablePagination(vm2, innerPagination, computedPagination, isServerSide, setPagination, filteredSortedRowsNumber) {
  const { props: props4, emit, proxy: { $q } } = vm2;
  const computedRowsNumber = computed(() => isServerSide.value === true ? computedPagination.value.rowsNumber || 0 : filteredSortedRowsNumber.value);
  const firstRowIndex = computed(() => {
    const { page, rowsPerPage } = computedPagination.value;
    return (page - 1) * rowsPerPage;
  });
  const lastRowIndex = computed(() => {
    const { page, rowsPerPage } = computedPagination.value;
    return page * rowsPerPage;
  });
  const isFirstPage = computed(() => computedPagination.value.page === 1);
  const pagesNumber = computed(() => computedPagination.value.rowsPerPage === 0 ? 1 : Math.max(
    1,
    Math.ceil(computedRowsNumber.value / computedPagination.value.rowsPerPage)
  ));
  const isLastPage = computed(() => lastRowIndex.value === 0 ? true : computedPagination.value.page >= pagesNumber.value);
  const computedRowsPerPageOptions = computed(() => {
    const opts = props4.rowsPerPageOptions.includes(innerPagination.value.rowsPerPage) ? props4.rowsPerPageOptions : [innerPagination.value.rowsPerPage].concat(props4.rowsPerPageOptions);
    return opts.map((count) => ({
      label: count === 0 ? $q.lang.table.allRows : "" + count,
      value: count
    }));
  });
  watch(pagesNumber, (lastPage2, oldLastPage) => {
    if (lastPage2 === oldLastPage) return;
    const currentPage = computedPagination.value.page;
    if (lastPage2 && !currentPage) {
      setPagination({ page: 1 });
    } else if (lastPage2 < currentPage) {
      setPagination({ page: lastPage2 });
    }
  });
  function firstPage() {
    setPagination({ page: 1 });
  }
  function prevPage() {
    const { page } = computedPagination.value;
    if (page > 1) {
      setPagination({ page: page - 1 });
    }
  }
  function nextPage() {
    const { page, rowsPerPage } = computedPagination.value;
    if (lastRowIndex.value > 0 && page * rowsPerPage < computedRowsNumber.value) {
      setPagination({ page: page + 1 });
    }
  }
  function lastPage() {
    setPagination({ page: pagesNumber.value });
  }
  if (props4["onUpdate:pagination"] !== void 0) {
    emit("update:pagination", { ...computedPagination.value });
  }
  return {
    firstRowIndex,
    lastRowIndex,
    isFirstPage,
    isLastPage,
    pagesNumber,
    computedRowsPerPageOptions,
    computedRowsNumber,
    firstPage,
    prevPage,
    nextPage,
    lastPage
  };
}
var useTableRowSelectionProps = {
  selection: {
    type: String,
    default: "none",
    validator: (v) => ["single", "multiple", "none"].includes(v)
  },
  selected: {
    type: Array,
    default: () => []
  }
};
var useTableRowSelectionEmits = ["update:selected", "selection"];
function useTableRowSelection(props4, emit, computedRows, getRowKey) {
  const selectedKeys = computed(() => {
    const keys2 = {};
    props4.selected.map(getRowKey.value).forEach((key) => {
      keys2[key] = true;
    });
    return keys2;
  });
  const hasSelectionMode = computed(() => {
    return props4.selection !== "none";
  });
  const singleSelection = computed(() => {
    return props4.selection === "single";
  });
  const multipleSelection = computed(() => {
    return props4.selection === "multiple";
  });
  const allRowsSelected = computed(
    () => computedRows.value.length !== 0 && computedRows.value.every(
      (row) => selectedKeys.value[getRowKey.value(row)] === true
    )
  );
  const someRowsSelected = computed(
    () => allRowsSelected.value !== true && computedRows.value.some((row) => selectedKeys.value[getRowKey.value(row)] === true)
  );
  const rowsSelectedNumber = computed(() => props4.selected.length);
  function isRowSelected(key) {
    return selectedKeys.value[key] === true;
  }
  function clearSelection2() {
    emit("update:selected", []);
  }
  function updateSelection(keys2, rows, added, evt) {
    emit("selection", { rows, added, keys: keys2, evt });
    const payload = singleSelection.value === true ? added === true ? rows : [] : added === true ? props4.selected.concat(rows) : props4.selected.filter(
      (row) => keys2.includes(getRowKey.value(row)) === false
    );
    emit("update:selected", payload);
  }
  return {
    hasSelectionMode,
    singleSelection,
    multipleSelection,
    allRowsSelected,
    someRowsSelected,
    rowsSelectedNumber,
    isRowSelected,
    clearSelection: clearSelection2,
    updateSelection
  };
}
function getVal(val) {
  return Array.isArray(val) ? val.slice() : [];
}
var useTableRowExpandProps = {
  expanded: Array
  // v-model:expanded
};
var useTableRowExpandEmits = ["update:expanded"];
function useTableRowExpand(props4, emit) {
  const innerExpanded = ref$1(getVal(props4.expanded));
  watch(() => props4.expanded, (val) => {
    innerExpanded.value = getVal(val);
  });
  function isRowExpanded(key) {
    return innerExpanded.value.includes(key);
  }
  function setExpanded(val) {
    if (props4.expanded !== void 0) {
      emit("update:expanded", val);
    } else {
      innerExpanded.value = val;
    }
  }
  function updateExpanded(key, add2) {
    const target2 = innerExpanded.value.slice();
    const index2 = target2.indexOf(key);
    if (add2 === true) {
      if (index2 === -1) {
        target2.push(key);
        setExpanded(target2);
      }
    } else if (index2 !== -1) {
      target2.splice(index2, 1);
      setExpanded(target2);
    }
  }
  return {
    isRowExpanded,
    setExpanded,
    updateExpanded
  };
}
var useTableColumnSelectionProps = {
  visibleColumns: Array
};
function useTableColumnSelection(props4, computedPagination, hasSelectionMode) {
  const colList = computed(() => {
    if (props4.columns !== void 0) {
      return props4.columns;
    }
    const row = props4.rows[0];
    return row !== void 0 ? Object.keys(row).map((name2) => ({
      name: name2,
      label: name2.toUpperCase(),
      field: name2,
      align: isNumber(row[name2]) ? "right" : "left",
      sortable: true
    })) : [];
  });
  const computedCols = computed(() => {
    const { sortBy, descending } = computedPagination.value;
    const cols = props4.visibleColumns !== void 0 ? colList.value.filter((col) => col.required === true || props4.visibleColumns.includes(col.name) === true) : colList.value;
    return cols.map((col) => {
      const align = col.align || "right";
      const alignClass = `text-${align}`;
      return {
        ...col,
        align,
        __iconClass: `q-table__sort-icon q-table__sort-icon--${align}`,
        __thClass: alignClass + (col.headerClasses !== void 0 ? " " + col.headerClasses : "") + (col.sortable === true ? " sortable" : "") + (col.name === sortBy ? ` sorted ${descending === true ? "sort-desc" : ""}` : ""),
        __tdStyle: col.style !== void 0 ? typeof col.style !== "function" ? () => col.style : col.style : () => null,
        __tdClass: col.classes !== void 0 ? typeof col.classes !== "function" ? () => alignClass + " " + col.classes : (row) => alignClass + " " + col.classes(row) : () => alignClass
      };
    });
  });
  const computedColsMap = computed(() => {
    const names2 = {};
    computedCols.value.forEach((col) => {
      names2[col.name] = col;
    });
    return names2;
  });
  const computedColspan = computed(() => {
    return props4.tableColspan !== void 0 ? props4.tableColspan : computedCols.value.length + (hasSelectionMode.value === true ? 1 : 0);
  });
  return {
    colList,
    computedCols,
    computedColsMap,
    computedColspan
  };
}
var bottomClass = "q-table__bottom row items-center";
var virtScrollPassthroughProps = {};
commonVirtScrollPropsList.forEach((p2) => {
  virtScrollPassthroughProps[p2] = {};
});
createComponent({
  name: "QTable",
  props: {
    rows: {
      type: Array,
      required: true
    },
    rowKey: {
      type: [String, Function],
      default: "id"
    },
    columns: Array,
    loading: Boolean,
    iconFirstPage: String,
    iconPrevPage: String,
    iconNextPage: String,
    iconLastPage: String,
    title: String,
    hideHeader: Boolean,
    grid: Boolean,
    gridHeader: Boolean,
    dense: Boolean,
    flat: Boolean,
    bordered: Boolean,
    square: Boolean,
    separator: {
      type: String,
      default: "horizontal",
      validator: (v) => ["horizontal", "vertical", "cell", "none"].includes(v)
    },
    wrapCells: Boolean,
    virtualScroll: Boolean,
    virtualScrollTarget: {},
    ...virtScrollPassthroughProps,
    noDataLabel: String,
    noResultsLabel: String,
    loadingLabel: String,
    selectedRowsLabel: Function,
    rowsPerPageLabel: String,
    paginationLabel: Function,
    color: {
      type: String,
      default: "grey-8"
    },
    titleClass: [String, Array, Object],
    tableStyle: [String, Array, Object],
    tableClass: [String, Array, Object],
    tableHeaderStyle: [String, Array, Object],
    tableHeaderClass: [String, Array, Object],
    tableRowStyleFn: Function,
    tableRowClassFn: Function,
    cardContainerClass: [String, Array, Object],
    cardContainerStyle: [String, Array, Object],
    cardStyle: [String, Array, Object],
    cardClass: [String, Array, Object],
    cardStyleFn: Function,
    cardClassFn: Function,
    hideBottom: Boolean,
    hideSelectedBanner: Boolean,
    hideNoData: Boolean,
    hidePagination: Boolean,
    onRowClick: Function,
    onRowDblclick: Function,
    onRowContextmenu: Function,
    ...useDarkProps,
    ...useFullscreenProps,
    ...useTableColumnSelectionProps,
    ...useTableFilterProps,
    ...useTablePaginationProps,
    ...useTableRowExpandProps,
    ...useTableRowSelectionProps,
    ...useTableSortProps
  },
  emits: [
    "request",
    "virtualScroll",
    ...useFullscreenEmits,
    ...useTableRowExpandEmits,
    ...useTableRowSelectionEmits
  ],
  setup(props4, { slots, emit }) {
    const vm2 = getCurrentInstance();
    const { proxy: { $q } } = vm2;
    const isDark = use_dark_default(props4, $q);
    const { inFullscreen, toggleFullscreen } = use_fullscreen_default();
    const getRowKey = computed(() => typeof props4.rowKey === "function" ? props4.rowKey : (row) => row[props4.rowKey]);
    const rootRef = ref$1(null);
    const virtScrollRef = ref$1(null);
    const hasVirtScroll = computed(() => props4.grid !== true && props4.virtualScroll === true);
    const cardDefaultClass = computed(
      () => " q-table__card" + (isDark.value === true ? " q-table__card--dark q-dark" : "") + (props4.square === true ? " q-table--square" : "") + (props4.flat === true ? " q-table--flat" : "") + (props4.bordered === true ? " q-table--bordered" : "")
    );
    const containerClass = computed(
      () => `q-table__container q-table--${props4.separator}-separator column no-wrap` + (props4.grid === true ? " q-table--grid" : cardDefaultClass.value) + (isDark.value === true ? " q-table--dark" : "") + (props4.dense === true ? " q-table--dense" : "") + (props4.wrapCells === false ? " q-table--no-wrap" : "") + (inFullscreen.value === true ? " fullscreen scroll" : "")
    );
    const rootContainerClass = computed(
      () => containerClass.value + (props4.loading === true ? " q-table--loading" : "")
    );
    watch(
      () => props4.tableStyle + props4.tableClass + props4.tableHeaderStyle + props4.tableHeaderClass + containerClass.value,
      () => {
        var _a;
        hasVirtScroll.value === true && ((_a = virtScrollRef.value) == null ? void 0 : _a.reset());
      }
    );
    const {
      innerPagination,
      computedPagination,
      isServerSide,
      requestServerInteraction,
      setPagination
    } = useTablePaginationState(vm2, getCellValue);
    const { computedFilterMethod } = useTableFilter(props4, setPagination);
    const { isRowExpanded, setExpanded, updateExpanded } = useTableRowExpand(props4, emit);
    const filteredSortedRows = computed(() => {
      let rows = props4.rows;
      if (isServerSide.value === true || rows.length === 0) {
        return rows;
      }
      const { sortBy, descending } = computedPagination.value;
      if (props4.filter) {
        rows = computedFilterMethod.value(rows, props4.filter, computedCols.value, getCellValue);
      }
      if (columnToSort.value !== null) {
        rows = computedSortMethod.value(
          props4.rows === rows ? rows.slice() : rows,
          sortBy,
          descending
        );
      }
      return rows;
    });
    const filteredSortedRowsNumber = computed(() => filteredSortedRows.value.length);
    const computedRows = computed(() => {
      let rows = filteredSortedRows.value;
      if (isServerSide.value === true) {
        return rows;
      }
      const { rowsPerPage } = computedPagination.value;
      if (rowsPerPage !== 0) {
        if (firstRowIndex.value === 0 && props4.rows !== rows) {
          if (rows.length > lastRowIndex.value) {
            rows = rows.slice(0, lastRowIndex.value);
          }
        } else {
          rows = rows.slice(firstRowIndex.value, lastRowIndex.value);
        }
      }
      return rows;
    });
    const {
      hasSelectionMode,
      singleSelection,
      multipleSelection,
      allRowsSelected,
      someRowsSelected,
      rowsSelectedNumber,
      isRowSelected,
      clearSelection: clearSelection2,
      updateSelection
    } = useTableRowSelection(props4, emit, computedRows, getRowKey);
    const { colList, computedCols, computedColsMap, computedColspan } = useTableColumnSelection(props4, computedPagination, hasSelectionMode);
    const { columnToSort, computedSortMethod, sort } = useTableSort(props4, computedPagination, colList, setPagination);
    const {
      firstRowIndex,
      lastRowIndex,
      isFirstPage,
      isLastPage,
      pagesNumber,
      computedRowsPerPageOptions,
      computedRowsNumber,
      firstPage,
      prevPage,
      nextPage,
      lastPage
    } = useTablePagination(vm2, innerPagination, computedPagination, isServerSide, setPagination, filteredSortedRowsNumber);
    const nothingToDisplay = computed(() => computedRows.value.length === 0);
    const virtProps = computed(() => {
      const acc = {};
      commonVirtScrollPropsList.forEach((p2) => {
        acc[p2] = props4[p2];
      });
      if (acc.virtualScrollItemSize === void 0) {
        acc.virtualScrollItemSize = props4.dense === true ? 28 : 48;
      }
      return acc;
    });
    function resetVirtualScroll() {
      hasVirtScroll.value === true && virtScrollRef.value.reset();
    }
    function getBody() {
      if (props4.grid === true) {
        return getGridBody();
      }
      const header = props4.hideHeader !== true ? getTHead : null;
      if (hasVirtScroll.value === true) {
        const topRow = slots["top-row"];
        const bottomRow = slots["bottom-row"];
        const virtSlots = {
          default: (props5) => getTBodyTR(props5.item, slots.body, props5.index)
        };
        if (topRow !== void 0) {
          const topContent = h("tbody", topRow({ cols: computedCols.value }));
          virtSlots.before = header === null ? () => topContent : () => [header()].concat(topContent);
        } else if (header !== null) {
          virtSlots.before = header;
        }
        if (bottomRow !== void 0) {
          virtSlots.after = () => h("tbody", bottomRow({ cols: computedCols.value }));
        }
        return h(QVirtualScroll_default, {
          ref: virtScrollRef,
          class: props4.tableClass,
          style: props4.tableStyle,
          ...virtProps.value,
          scrollTarget: props4.virtualScrollTarget,
          items: computedRows.value,
          type: "__qtable",
          tableColspan: computedColspan.value,
          onVirtualScroll: onVScroll
        }, virtSlots);
      }
      const child = [
        getTBody()
      ];
      if (header !== null) {
        child.unshift(header());
      }
      return get_table_middle_default({
        class: ["q-table__middle scroll", props4.tableClass],
        style: props4.tableStyle
      }, child);
    }
    function scrollTo(toIndex, edge) {
      if (virtScrollRef.value !== null) {
        virtScrollRef.value.scrollTo(toIndex, edge);
        return;
      }
      toIndex = parseInt(toIndex, 10);
      const rowEl = rootRef.value.querySelector(`tbody tr:nth-of-type(${toIndex + 1})`);
      if (rowEl !== null) {
        const scrollTarget = rootRef.value.querySelector(".q-table__middle.scroll");
        const offsetTop = rowEl.offsetTop - props4.virtualScrollStickySizeStart;
        const direction = offsetTop < scrollTarget.scrollTop ? "decrease" : "increase";
        scrollTarget.scrollTop = offsetTop;
        emit("virtualScroll", {
          index: toIndex,
          from: 0,
          to: innerPagination.value.rowsPerPage - 1,
          direction
        });
      }
    }
    function onVScroll(info) {
      emit("virtualScroll", info);
    }
    function getProgress() {
      return [
        h(QLinearProgress_default, {
          class: "q-table__linear-progress",
          color: props4.color,
          dark: isDark.value,
          indeterminate: true,
          trackColor: "transparent"
        })
      ];
    }
    function getTBodyTR(row, bodySlot, pageIndex) {
      const key = getRowKey.value(row), selected = isRowSelected(key);
      if (bodySlot !== void 0) {
        const cfg = {
          key,
          row,
          pageIndex,
          __trClass: selected ? "selected" : ""
        };
        if (props4.tableRowStyleFn !== void 0) {
          cfg.__trStyle = props4.tableRowStyleFn(row);
        }
        if (props4.tableRowClassFn !== void 0) {
          const cls = props4.tableRowClassFn(row);
          if (cls) {
            cfg.__trClass = `${cls} ${cfg.__trClass}`;
          }
        }
        return bodySlot(
          getBodyScope(cfg)
        );
      }
      const bodyCell = slots["body-cell"], child = computedCols.value.map((col) => {
        const bodyCellCol = slots[`body-cell-${col.name}`], slot = bodyCellCol !== void 0 ? bodyCellCol : bodyCell;
        return slot !== void 0 ? slot(getBodyCellScope({ key, row, pageIndex, col })) : h("td", {
          class: col.__tdClass(row),
          style: col.__tdStyle(row)
        }, getCellValue(col, row));
      });
      if (hasSelectionMode.value === true) {
        const slot = slots["body-selection"];
        const content = slot !== void 0 ? slot(getBodySelectionScope({ key, row, pageIndex })) : [
          h(QCheckbox_default, {
            modelValue: selected,
            color: props4.color,
            dark: isDark.value,
            dense: props4.dense,
            "onUpdate:modelValue": (adding, evt) => {
              updateSelection([key], [row], adding, evt);
            }
          })
        ];
        child.unshift(
          h("td", { class: "q-table--col-auto-width" }, content)
        );
      }
      const data = { key, class: { selected } };
      if (props4.onRowClick !== void 0) {
        data.class["cursor-pointer"] = true;
        data.onClick = (evt) => {
          emit("rowClick", evt, row, pageIndex);
        };
      }
      if (props4.onRowDblclick !== void 0) {
        data.class["cursor-pointer"] = true;
        data.onDblclick = (evt) => {
          emit("rowDblclick", evt, row, pageIndex);
        };
      }
      if (props4.onRowContextmenu !== void 0) {
        data.class["cursor-pointer"] = true;
        data.onContextmenu = (evt) => {
          emit("rowContextmenu", evt, row, pageIndex);
        };
      }
      if (props4.tableRowStyleFn !== void 0) {
        data.style = props4.tableRowStyleFn(row);
      }
      if (props4.tableRowClassFn !== void 0) {
        const cls = props4.tableRowClassFn(row);
        if (cls) {
          data.class[cls] = true;
        }
      }
      return h("tr", data, child);
    }
    function getTBody() {
      const body = slots.body, topRow = slots["top-row"], bottomRow = slots["bottom-row"];
      let child = computedRows.value.map(
        (row, pageIndex) => getTBodyTR(row, body, pageIndex)
      );
      if (topRow !== void 0) {
        child = topRow({ cols: computedCols.value }).concat(child);
      }
      if (bottomRow !== void 0) {
        child = child.concat(bottomRow({ cols: computedCols.value }));
      }
      return h("tbody", child);
    }
    function getBodyScope(data) {
      injectBodyCommonScope(data);
      data.cols = data.cols.map(
        (col) => injectProp({ ...col }, "value", () => getCellValue(col, data.row))
      );
      return data;
    }
    function getBodyCellScope(data) {
      injectBodyCommonScope(data);
      injectProp(data, "value", () => getCellValue(data.col, data.row));
      return data;
    }
    function getBodySelectionScope(data) {
      injectBodyCommonScope(data);
      return data;
    }
    function injectBodyCommonScope(data) {
      Object.assign(data, {
        cols: computedCols.value,
        colsMap: computedColsMap.value,
        sort,
        rowIndex: firstRowIndex.value + data.pageIndex,
        color: props4.color,
        dark: isDark.value,
        dense: props4.dense
      });
      hasSelectionMode.value === true && injectProp(
        data,
        "selected",
        () => isRowSelected(data.key),
        (adding, evt) => {
          updateSelection([data.key], [data.row], adding, evt);
        }
      );
      injectProp(
        data,
        "expand",
        () => isRowExpanded(data.key),
        (adding) => {
          updateExpanded(data.key, adding);
        }
      );
    }
    function getCellValue(col, row) {
      const val = typeof col.field === "function" ? col.field(row) : row[col.field];
      return col.format !== void 0 ? col.format(val, row) : val;
    }
    const marginalsScope = computed(() => ({
      pagination: computedPagination.value,
      pagesNumber: pagesNumber.value,
      isFirstPage: isFirstPage.value,
      isLastPage: isLastPage.value,
      firstPage,
      prevPage,
      nextPage,
      lastPage,
      inFullscreen: inFullscreen.value,
      toggleFullscreen
    }));
    function getTopDiv() {
      const top = slots.top, topLeft = slots["top-left"], topRight = slots["top-right"], topSelection = slots["top-selection"], hasSelection = hasSelectionMode.value === true && topSelection !== void 0 && rowsSelectedNumber.value > 0, topClass = "q-table__top relative-position row items-center";
      if (top !== void 0) {
        return h("div", { class: topClass }, [top(marginalsScope.value)]);
      }
      let child;
      if (hasSelection === true) {
        child = topSelection(marginalsScope.value).slice();
      } else {
        child = [];
        if (topLeft !== void 0) {
          child.push(
            h("div", { class: "q-table__control" }, [
              topLeft(marginalsScope.value)
            ])
          );
        } else if (props4.title) {
          child.push(
            h("div", { class: "q-table__control" }, [
              h("div", {
                class: ["q-table__title", props4.titleClass]
              }, props4.title)
            ])
          );
        }
      }
      if (topRight !== void 0) {
        child.push(
          h("div", { class: "q-table__separator col" })
        );
        child.push(
          h("div", { class: "q-table__control" }, [
            topRight(marginalsScope.value)
          ])
        );
      }
      if (child.length === 0) return;
      return h("div", { class: topClass }, child);
    }
    const headerSelectedValue = computed(() => someRowsSelected.value === true ? null : allRowsSelected.value);
    function getTHead() {
      const child = getTHeadTR();
      if (props4.loading === true && slots.loading === void 0) {
        child.push(
          h("tr", { class: "q-table__progress" }, [
            h("th", {
              class: "relative-position",
              colspan: computedColspan.value
            }, getProgress())
          ])
        );
      }
      return h("thead", child);
    }
    function getTHeadTR() {
      const header = slots.header, headerCell = slots["header-cell"];
      if (header !== void 0) {
        return header(
          getHeaderScope({ header: true })
        ).slice();
      }
      const child = computedCols.value.map((col) => {
        const headerCellCol = slots[`header-cell-${col.name}`], slot = headerCellCol !== void 0 ? headerCellCol : headerCell, props5 = getHeaderScope({ col });
        return slot !== void 0 ? slot(props5) : h(QTh_default, {
          key: col.name,
          props: props5
        }, () => col.label);
      });
      if (singleSelection.value === true && props4.grid !== true) {
        child.unshift(
          h("th", { class: "q-table--col-auto-width" }, " ")
        );
      } else if (multipleSelection.value === true) {
        const slot = slots["header-selection"];
        const content = slot !== void 0 ? slot(getHeaderScope({})) : [
          h(QCheckbox_default, {
            color: props4.color,
            modelValue: headerSelectedValue.value,
            dark: isDark.value,
            dense: props4.dense,
            "onUpdate:modelValue": onMultipleSelectionSet
          })
        ];
        child.unshift(
          h("th", { class: "q-table--col-auto-width" }, content)
        );
      }
      return [
        h("tr", {
          class: props4.tableHeaderClass,
          style: props4.tableHeaderStyle
        }, child)
      ];
    }
    function getHeaderScope(data) {
      Object.assign(data, {
        cols: computedCols.value,
        sort,
        colsMap: computedColsMap.value,
        color: props4.color,
        dark: isDark.value,
        dense: props4.dense
      });
      if (multipleSelection.value === true) {
        injectProp(
          data,
          "selected",
          () => headerSelectedValue.value,
          onMultipleSelectionSet
        );
      }
      return data;
    }
    function onMultipleSelectionSet(val) {
      if (someRowsSelected.value === true) {
        val = false;
      }
      updateSelection(
        computedRows.value.map(getRowKey.value),
        computedRows.value,
        val
      );
    }
    const navIcon = computed(() => {
      const ico = [
        props4.iconFirstPage || $q.iconSet.table.firstPage,
        props4.iconPrevPage || $q.iconSet.table.prevPage,
        props4.iconNextPage || $q.iconSet.table.nextPage,
        props4.iconLastPage || $q.iconSet.table.lastPage
      ];
      return $q.lang.rtl === true ? ico.reverse() : ico;
    });
    function getBottomDiv() {
      if (props4.hideBottom === true) return;
      if (nothingToDisplay.value === true) {
        if (props4.hideNoData === true) return;
        const message = props4.loading === true ? props4.loadingLabel || $q.lang.table.loading : props4.filter ? props4.noResultsLabel || $q.lang.table.noResults : props4.noDataLabel || $q.lang.table.noData;
        const noData = slots["no-data"];
        const children = noData !== void 0 ? [noData({ message, icon: $q.iconSet.table.warning, filter: props4.filter })] : [
          h(QIcon_default, {
            class: "q-table__bottom-nodata-icon",
            name: $q.iconSet.table.warning
          }),
          message
        ];
        return h("div", { class: bottomClass + " q-table__bottom--nodata" }, children);
      }
      const bottom = slots.bottom;
      if (bottom !== void 0) {
        return h("div", { class: bottomClass }, [bottom(marginalsScope.value)]);
      }
      const child = props4.hideSelectedBanner !== true && hasSelectionMode.value === true && rowsSelectedNumber.value > 0 ? [
        h("div", { class: "q-table__control" }, [
          h("div", [
            (props4.selectedRowsLabel || $q.lang.table.selectedRecords)(rowsSelectedNumber.value)
          ])
        ])
      ] : [];
      if (props4.hidePagination !== true) {
        return h("div", {
          class: bottomClass + " justify-end"
        }, getPaginationDiv(child));
      }
      if (child.length !== 0) {
        return h("div", { class: bottomClass }, child);
      }
    }
    function onPagSelection(pag) {
      setPagination({
        page: 1,
        rowsPerPage: pag.value
      });
    }
    function getPaginationDiv(child) {
      let control;
      const { rowsPerPage } = computedPagination.value, paginationLabel = props4.paginationLabel || $q.lang.table.pagination, paginationSlot = slots.pagination, hasOpts = props4.rowsPerPageOptions.length > 1;
      child.push(
        h("div", { class: "q-table__separator col" })
      );
      hasOpts === true && child.push(
        h("div", { class: "q-table__control" }, [
          h("span", { class: "q-table__bottom-item" }, [
            props4.rowsPerPageLabel || $q.lang.table.recordsPerPage
          ]),
          h(QSelect_default, {
            class: "q-table__select inline q-table__bottom-item",
            color: props4.color,
            modelValue: rowsPerPage,
            options: computedRowsPerPageOptions.value,
            displayValue: rowsPerPage === 0 ? $q.lang.table.allRows : rowsPerPage,
            dark: isDark.value,
            borderless: true,
            dense: true,
            optionsDense: true,
            optionsCover: true,
            "onUpdate:modelValue": onPagSelection
          })
        ])
      );
      if (paginationSlot !== void 0) {
        control = paginationSlot(marginalsScope.value);
      } else {
        control = [
          h("span", rowsPerPage !== 0 ? { class: "q-table__bottom-item" } : {}, [
            rowsPerPage ? paginationLabel(firstRowIndex.value + 1, Math.min(lastRowIndex.value, computedRowsNumber.value), computedRowsNumber.value) : paginationLabel(1, filteredSortedRowsNumber.value, computedRowsNumber.value)
          ])
        ];
        if (rowsPerPage !== 0 && pagesNumber.value > 1) {
          const btnProps = {
            color: props4.color,
            round: true,
            dense: true,
            flat: true
          };
          if (props4.dense === true) {
            btnProps.size = "sm";
          }
          pagesNumber.value > 2 && control.push(
            h(QBtn_default, {
              key: "pgFirst",
              ...btnProps,
              icon: navIcon.value[0],
              disable: isFirstPage.value,
              "aria-label": $q.lang.pagination.first,
              onClick: firstPage
            })
          );
          control.push(
            h(QBtn_default, {
              key: "pgPrev",
              ...btnProps,
              icon: navIcon.value[1],
              disable: isFirstPage.value,
              "aria-label": $q.lang.pagination.prev,
              onClick: prevPage
            }),
            h(QBtn_default, {
              key: "pgNext",
              ...btnProps,
              icon: navIcon.value[2],
              disable: isLastPage.value,
              "aria-label": $q.lang.pagination.next,
              onClick: nextPage
            })
          );
          pagesNumber.value > 2 && control.push(
            h(QBtn_default, {
              key: "pgLast",
              ...btnProps,
              icon: navIcon.value[3],
              disable: isLastPage.value,
              "aria-label": $q.lang.pagination.last,
              onClick: lastPage
            })
          );
        }
      }
      child.push(
        h("div", { class: "q-table__control" }, control)
      );
      return child;
    }
    function getGridHeader() {
      const child = props4.gridHeader === true ? [
        h("table", { class: "q-table" }, [
          getTHead()
        ])
      ] : props4.loading === true && slots.loading === void 0 ? getProgress() : void 0;
      return h("div", { class: "q-table__middle" }, child);
    }
    function getGridBody() {
      const item = slots.item !== void 0 ? slots.item : (scope) => {
        const child = scope.cols.map(
          (col) => h("div", { class: "q-table__grid-item-row" }, [
            h("div", { class: "q-table__grid-item-title" }, [col.label]),
            h("div", { class: "q-table__grid-item-value" }, [col.value])
          ])
        );
        if (hasSelectionMode.value === true) {
          const slot = slots["body-selection"];
          const content = slot !== void 0 ? slot(scope) : [
            h(QCheckbox_default, {
              modelValue: scope.selected,
              color: props4.color,
              dark: isDark.value,
              dense: props4.dense,
              "onUpdate:modelValue": (adding, evt) => {
                updateSelection([scope.key], [scope.row], adding, evt);
              }
            })
          ];
          child.unshift(
            h("div", { class: "q-table__grid-item-row" }, content),
            h(QSeparator_default, { dark: isDark.value })
          );
        }
        const data = {
          class: [
            "q-table__grid-item-card" + cardDefaultClass.value,
            props4.cardClass
          ],
          style: props4.cardStyle
        };
        if (props4.cardStyleFn !== void 0) {
          data.style = [data.style, props4.cardStyleFn(scope.row)];
        }
        if (props4.cardClassFn !== void 0) {
          const cls = props4.cardClassFn(scope.row);
          if (cls) {
            data.class[0] += ` ${cls}`;
          }
        }
        if (props4.onRowClick !== void 0 || props4.onRowDblclick !== void 0 || props4.onRowContextmenu !== void 0) {
          data.class[0] += " cursor-pointer";
          if (props4.onRowClick !== void 0) {
            data.onClick = (evt) => {
              emit("RowClick", evt, scope.row, scope.pageIndex);
            };
          }
          if (props4.onRowDblclick !== void 0) {
            data.onDblclick = (evt) => {
              emit("RowDblclick", evt, scope.row, scope.pageIndex);
            };
          }
          if (props4.onRowContextmenu !== void 0) {
            data.onContextmenu = (evt) => {
              emit("rowContextmenu", evt, scope.row, scope.pageIndex);
            };
          }
        }
        return h("div", {
          class: "q-table__grid-item col-xs-12 col-sm-6 col-md-4 col-lg-3" + (scope.selected === true ? " q-table__grid-item--selected" : "")
        }, [
          h("div", data, child)
        ]);
      };
      return h("div", {
        class: [
          "q-table__grid-content row",
          props4.cardContainerClass
        ],
        style: props4.cardContainerStyle
      }, computedRows.value.map((row, pageIndex) => {
        return item(getBodyScope({
          key: getRowKey.value(row),
          row,
          pageIndex
        }));
      }));
    }
    Object.assign(vm2.proxy, {
      requestServerInteraction,
      setPagination,
      firstPage,
      prevPage,
      nextPage,
      lastPage,
      isRowSelected,
      clearSelection: clearSelection2,
      isRowExpanded,
      setExpanded,
      sort,
      resetVirtualScroll,
      scrollTo,
      getCellValue
    });
    injectMultipleProps(vm2.proxy, {
      filteredSortedRows: () => filteredSortedRows.value,
      computedRows: () => computedRows.value,
      computedRowsNumber: () => computedRowsNumber.value
    });
    return () => {
      const child = [getTopDiv()];
      const data = { ref: rootRef, class: rootContainerClass.value };
      if (props4.grid === true) {
        child.push(getGridHeader());
      } else {
        Object.assign(data, {
          class: [data.class, props4.cardClass],
          style: props4.cardStyle
        });
      }
      child.push(
        getBody(),
        getBottomDiv()
      );
      if (props4.loading === true && slots.loading !== void 0) {
        child.push(
          slots.loading()
        );
      }
      return h("div", data, child);
    };
  }
});
createComponent({
  name: "QTr",
  props: {
    props: Object,
    noHover: Boolean
  },
  setup(props4, { slots }) {
    const classes = computed(
      () => "q-tr" + (props4.props === void 0 || props4.props.header === true ? "" : " " + props4.props.__trClass) + (props4.noHover === true ? " q-tr--no-hover" : "")
    );
    return () => {
      var _a;
      return h("tr", {
        style: (_a = props4.props) == null ? void 0 : _a.__trStyle,
        class: classes.value
      }, hSlot(slots.default));
    };
  }
});
createComponent({
  name: "QTd",
  props: {
    props: Object,
    autoWidth: Boolean,
    noHover: Boolean
  },
  setup(props4, { slots }) {
    const vm2 = getCurrentInstance();
    const classes = computed(
      () => "q-td" + (props4.autoWidth === true ? " q-table--col-auto-width" : "") + (props4.noHover === true ? " q-td--no-hover" : "") + " "
    );
    return () => {
      if (props4.props === void 0) {
        return h("td", { class: classes.value }, hSlot(slots.default));
      }
      const name2 = vm2.vnode.key;
      const col = (props4.props.colsMap !== void 0 ? props4.props.colsMap[name2] : null) || props4.props.col;
      if (col === void 0) return;
      const { row } = props4.props;
      return h("td", {
        class: classes.value + col.__tdClass(row),
        style: col.__tdStyle(row)
      }, hSlot(slots.default));
    };
  }
});
createComponent({
  name: "QRouteTab",
  props: {
    ...useRouterLinkProps,
    ...useTabProps
  },
  emits: useTabEmits,
  setup(props4, { slots, emit }) {
    const routeData = use_router_link_default({
      useDisableForRouterLinkProps: false
    });
    const { renderTab, $tabs } = use_tab_default(
      props4,
      slots,
      emit,
      {
        exact: computed(() => props4.exact),
        ...routeData
      }
    );
    watch(
      () => `${props4.name} | ${props4.exact} | ${(routeData.resolvedLink.value || {}).href}`,
      $tabs.verifyRouteModel
    );
    return () => renderTab(routeData.linkTag.value, routeData.linkAttrs.value);
  }
});
function getViewByModel(model, withSeconds) {
  if (model.hour !== null) {
    if (model.minute === null) {
      return "minute";
    }
  }
  return "hour";
}
function getCurrentTime() {
  const d4 = /* @__PURE__ */ new Date();
  return {
    hour: d4.getHours(),
    minute: d4.getMinutes(),
    second: d4.getSeconds(),
    millisecond: d4.getMilliseconds()
  };
}
createComponent({
  name: "QTime",
  props: {
    ...useDarkProps,
    ...useFormProps,
    ...useDatetimeProps,
    modelValue: {
      required: true,
      validator: (val) => typeof val === "string" || val === null
    },
    mask: {
      ...useDatetimeProps.mask,
      default: null
    },
    format24h: {
      type: Boolean,
      default: null
    },
    defaultDate: {
      type: String,
      validator: (v) => /^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(v)
    },
    options: Function,
    hourOptions: Array,
    minuteOptions: Array,
    secondOptions: Array,
    withSeconds: Boolean,
    nowBtn: Boolean
  },
  emits: useDatetimeEmits,
  setup(props4, { slots, emit }) {
    const vm2 = getCurrentInstance();
    const { $q } = vm2.proxy;
    const isDark = use_dark_default(props4, $q);
    const { tabindex, headerClass, getLocale: getLocale2, getCurrentDate } = use_datetime_default(props4, $q);
    const formAttrs = useFormAttrs(props4);
    const injectFormInput = useFormInject(formAttrs);
    let draggingClockRect, dragCache;
    const clockRef = ref$1(null);
    const mask = computed(() => getMask());
    const locale2 = computed(() => getLocale2());
    const defaultDateModel = computed(() => getDefaultDateModel());
    const model = __splitDate(
      props4.modelValue,
      mask.value,
      // initial mask
      locale2.value,
      // initial locale
      props4.calendar,
      defaultDateModel.value
    );
    const view = ref$1(getViewByModel(model));
    const innerModel = ref$1(model);
    const isAM = ref$1(model.hour === null || model.hour < 12);
    const classes = computed(
      () => `q-time q-time--${props4.landscape === true ? "landscape" : "portrait"}` + (isDark.value === true ? " q-time--dark q-dark" : "") + (props4.disable === true ? " disabled" : props4.readonly === true ? " q-time--readonly" : "") + (props4.bordered === true ? " q-time--bordered" : "") + (props4.square === true ? " q-time--square no-border-radius" : "") + (props4.flat === true ? " q-time--flat no-shadow" : "")
    );
    const stringModel = computed(() => {
      const time = innerModel.value;
      return {
        hour: time.hour === null ? "--" : computedFormat24h.value === true ? pad(time.hour) : String(
          isAM.value === true ? time.hour === 0 ? 12 : time.hour : time.hour > 12 ? time.hour - 12 : time.hour
        ),
        minute: time.minute === null ? "--" : pad(time.minute),
        second: time.second === null ? "--" : pad(time.second)
      };
    });
    const computedFormat24h = computed(() => props4.format24h !== null ? props4.format24h : $q.lang.date.format24h);
    const pointerStyle = computed(() => {
      const forHour = view.value === "hour", divider = forHour === true ? 12 : 60, amount = innerModel.value[view.value], degrees = Math.round(amount * (360 / divider)) - 180;
      let transform = `rotate(${degrees}deg) translateX(-50%)`;
      if (forHour === true && computedFormat24h.value === true && innerModel.value.hour >= 12) {
        transform += " scale(.7)";
      }
      return { transform };
    });
    const minLink = computed(() => innerModel.value.hour !== null);
    const secLink = computed(() => minLink.value === true && innerModel.value.minute !== null);
    const hourInSelection = computed(() => props4.hourOptions !== void 0 ? (val) => props4.hourOptions.includes(val) : props4.options !== void 0 ? (val) => props4.options(val, null, null) : null);
    const minuteInSelection = computed(() => props4.minuteOptions !== void 0 ? (val) => props4.minuteOptions.includes(val) : props4.options !== void 0 ? (val) => props4.options(innerModel.value.hour, val, null) : null);
    const secondInSelection = computed(() => props4.secondOptions !== void 0 ? (val) => props4.secondOptions.includes(val) : props4.options !== void 0 ? (val) => props4.options(innerModel.value.hour, innerModel.value.minute, val) : null);
    const validHours = computed(() => {
      if (hourInSelection.value === null) {
        return null;
      }
      const am = getValidValues(0, 11, hourInSelection.value);
      const pm = getValidValues(12, 11, hourInSelection.value);
      return { am, pm, values: am.values.concat(pm.values) };
    });
    const validMinutes = computed(() => minuteInSelection.value !== null ? getValidValues(0, 59, minuteInSelection.value) : null);
    const validSeconds = computed(() => secondInSelection.value !== null ? getValidValues(0, 59, secondInSelection.value) : null);
    const viewValidOptions = computed(() => {
      switch (view.value) {
        case "hour":
          return validHours.value;
        case "minute":
          return validMinutes.value;
        case "second":
          return validSeconds.value;
      }
    });
    const positions2 = computed(() => {
      let start, end, offset2 = 0, step = 1;
      const values = viewValidOptions.value !== null ? viewValidOptions.value.values : void 0;
      if (view.value === "hour") {
        if (computedFormat24h.value === true) {
          start = 0;
          end = 23;
        } else {
          start = 0;
          end = 11;
          if (isAM.value === false) {
            offset2 = 12;
          }
        }
      } else {
        start = 0;
        end = 55;
        step = 5;
      }
      const pos = [];
      for (let val = start, index2 = start; val <= end; val += step, index2++) {
        const actualVal = val + offset2, disable = (values == null ? void 0 : values.includes(actualVal)) === false, label = view.value === "hour" && val === 0 ? computedFormat24h.value === true ? "00" : "12" : val;
        pos.push({ val: actualVal, index: index2, disable, label });
      }
      return pos;
    });
    const clockDirectives = computed(() => {
      return [[
        TouchPan_default,
        onPan,
        void 0,
        {
          stop: true,
          prevent: true,
          mouse: true
        }
      ]];
    });
    watch(() => props4.modelValue, (v) => {
      const model2 = __splitDate(
        v,
        mask.value,
        locale2.value,
        props4.calendar,
        defaultDateModel.value
      );
      if (model2.dateHash !== innerModel.value.dateHash || model2.timeHash !== innerModel.value.timeHash) {
        innerModel.value = model2;
        if (model2.hour === null) {
          view.value = "hour";
        } else {
          isAM.value = model2.hour < 12;
        }
      }
    });
    watch([mask, locale2], () => {
      nextTick(() => {
        updateValue2();
      });
    });
    function setNow() {
      const date = {
        ...getCurrentDate(),
        ...getCurrentTime()
      };
      updateValue2(date);
      Object.assign(innerModel.value, date);
      view.value = "hour";
    }
    function getValidValues(start, count, testFn) {
      const values = Array.apply(null, { length: count + 1 }).map((_, index2) => {
        const i3 = index2 + start;
        return {
          index: i3,
          val: testFn(i3) === true
          // force boolean
        };
      }).filter((v) => v.val === true).map((v) => v.index);
      return {
        min: values[0],
        max: values[values.length - 1],
        values,
        threshold: count + 1
      };
    }
    function getWheelDist(a4, b3, threshold) {
      const diff2 = Math.abs(a4 - b3);
      return Math.min(diff2, threshold - diff2);
    }
    function getNormalizedClockValue(val, { min: min2, max: max2, values, threshold }) {
      if (val === min2) {
        return min2;
      }
      if (val < min2 || val > max2) {
        return getWheelDist(val, min2, threshold) <= getWheelDist(val, max2, threshold) ? min2 : max2;
      }
      const index2 = values.findIndex((v) => val <= v), before = values[index2 - 1], after = values[index2];
      return val - before <= after - val ? before : after;
    }
    function getMask() {
      return props4.calendar !== "persian" && props4.mask !== null ? props4.mask : `HH:mm${props4.withSeconds === true ? ":ss" : ""}`;
    }
    function getDefaultDateModel() {
      if (typeof props4.defaultDate !== "string") {
        const date = getCurrentDate(true);
        date.dateHash = getDayHash(date);
        return date;
      }
      return __splitDate(props4.defaultDate, "YYYY/MM/DD", void 0, props4.calendar);
    }
    function shouldAbortInteraction() {
      return vmIsDestroyed(vm2) === true || viewValidOptions.value !== null && (viewValidOptions.value.values.length === 0 || view.value === "hour" && computedFormat24h.value !== true && validHours.value[isAM.value === true ? "am" : "pm"].values.length === 0);
    }
    function getClockRect() {
      const clock = clockRef.value, { top, left, width: width3 } = clock.getBoundingClientRect(), dist2 = width3 / 2;
      return {
        top: top + dist2,
        left: left + dist2,
        dist: dist2 * 0.7
      };
    }
    function onPan(event) {
      if (shouldAbortInteraction() === true) return;
      if (event.isFirst === true) {
        draggingClockRect = getClockRect();
        dragCache = updateClock(event.evt, draggingClockRect);
        return;
      }
      dragCache = updateClock(event.evt, draggingClockRect, dragCache);
      if (event.isFinal === true) {
        draggingClockRect = false;
        dragCache = null;
        goToNextView();
      }
    }
    function goToNextView() {
      if (view.value === "hour") {
        view.value = "minute";
      } else if (props4.withSeconds && view.value === "minute") {
        view.value = "second";
      }
    }
    function updateClock(evt, clockRect, cacheVal) {
      const pos = position(evt), height2 = Math.abs(pos.top - clockRect.top), distance = Math.sqrt(
        Math.pow(Math.abs(pos.top - clockRect.top), 2) + Math.pow(Math.abs(pos.left - clockRect.left), 2)
      );
      let val, angle2 = Math.asin(height2 / distance) * (180 / Math.PI);
      if (pos.top < clockRect.top) {
        angle2 = clockRect.left < pos.left ? 90 - angle2 : 270 + angle2;
      } else {
        angle2 = clockRect.left < pos.left ? angle2 + 90 : 270 - angle2;
      }
      if (view.value === "hour") {
        val = angle2 / 30;
        if (validHours.value !== null) {
          const am = computedFormat24h.value !== true ? isAM.value === true : validHours.value.am.values.length !== 0 && validHours.value.pm.values.length !== 0 ? distance >= clockRect.dist : validHours.value.am.values.length !== 0;
          val = getNormalizedClockValue(
            val + (am === true ? 0 : 12),
            validHours.value[am === true ? "am" : "pm"]
          );
        } else {
          val = Math.round(val);
          if (computedFormat24h.value === true) {
            if (distance < clockRect.dist) {
              if (val < 12) {
                val += 12;
              }
            } else if (val === 12) {
              val = 0;
            }
          } else if (isAM.value === true && val === 12) {
            val = 0;
          } else if (isAM.value === false && val !== 12) {
            val += 12;
          }
        }
        if (computedFormat24h.value === true) {
          isAM.value = val < 12;
        }
      } else {
        val = Math.round(angle2 / 6) % 60;
        if (view.value === "minute" && validMinutes.value !== null) {
          val = getNormalizedClockValue(val, validMinutes.value);
        } else if (view.value === "second" && validSeconds.value !== null) {
          val = getNormalizedClockValue(val, validSeconds.value);
        }
      }
      if (cacheVal !== val) {
        setModel[view.value](val);
      }
      return val;
    }
    const setView = {
      hour() {
        view.value = "hour";
      },
      minute() {
        view.value = "minute";
      },
      second() {
        view.value = "second";
      }
    };
    function setAmOnKey(e3) {
      e3.keyCode === 13 && setAm();
    }
    function setPmOnKey(e3) {
      e3.keyCode === 13 && setPm();
    }
    function onClick(evt) {
      if (shouldAbortInteraction() !== true) {
        if ($q.platform.is.desktop !== true) {
          updateClock(evt, getClockRect());
        }
        goToNextView();
      }
    }
    function onMousedown(evt) {
      if (shouldAbortInteraction() !== true) {
        updateClock(evt, getClockRect());
      }
    }
    function onKeyupHour(e3) {
      if (e3.keyCode === 13) {
        view.value = "hour";
      } else if ([37, 39].includes(e3.keyCode)) {
        const payload = e3.keyCode === 37 ? -1 : 1;
        if (validHours.value !== null) {
          const values = computedFormat24h.value === true ? validHours.value.values : validHours.value[isAM.value === true ? "am" : "pm"].values;
          if (values.length === 0) return;
          if (innerModel.value.hour === null) {
            setHour(values[0]);
          } else {
            const index2 = (values.length + values.indexOf(innerModel.value.hour) + payload) % values.length;
            setHour(values[index2]);
          }
        } else {
          const wrap = computedFormat24h.value === true ? 24 : 12, offset2 = computedFormat24h.value !== true && isAM.value === false ? 12 : 0, val = innerModel.value.hour === null ? -payload : innerModel.value.hour;
          setHour(offset2 + (24 + val + payload) % wrap);
        }
      }
    }
    function onKeyupMinute(e3) {
      if (e3.keyCode === 13) {
        view.value = "minute";
      } else if ([37, 39].includes(e3.keyCode)) {
        const payload = e3.keyCode === 37 ? -1 : 1;
        if (validMinutes.value !== null) {
          const values = validMinutes.value.values;
          if (values.length === 0) return;
          if (innerModel.value.minute === null) {
            setMinute(values[0]);
          } else {
            const index2 = (values.length + values.indexOf(innerModel.value.minute) + payload) % values.length;
            setMinute(values[index2]);
          }
        } else {
          const val = innerModel.value.minute === null ? -payload : innerModel.value.minute;
          setMinute((60 + val + payload) % 60);
        }
      }
    }
    function onKeyupSecond(e3) {
      if (e3.keyCode === 13) {
        view.value = "second";
      } else if ([37, 39].includes(e3.keyCode)) {
        const payload = e3.keyCode === 37 ? -1 : 1;
        if (validSeconds.value !== null) {
          const values = validSeconds.value.values;
          if (values.length === 0) return;
          if (innerModel.value.seconds === null) {
            setSecond(values[0]);
          } else {
            const index2 = (values.length + values.indexOf(innerModel.value.second) + payload) % values.length;
            setSecond(values[index2]);
          }
        } else {
          const val = innerModel.value.second === null ? -payload : innerModel.value.second;
          setSecond((60 + val + payload) % 60);
        }
      }
    }
    function setHour(hour) {
      if (innerModel.value.hour !== hour) {
        innerModel.value.hour = hour;
        verifyAndUpdate();
      }
    }
    function setMinute(minute) {
      if (innerModel.value.minute !== minute) {
        innerModel.value.minute = minute;
        verifyAndUpdate();
      }
    }
    function setSecond(second) {
      if (innerModel.value.second !== second) {
        innerModel.value.second = second;
        verifyAndUpdate();
      }
    }
    const setModel = {
      hour: setHour,
      minute: setMinute,
      second: setSecond
    };
    function setAm() {
      if (isAM.value === false) {
        isAM.value = true;
        if (innerModel.value.hour !== null) {
          innerModel.value.hour -= 12;
          verifyAndUpdate();
        }
      }
    }
    function setPm() {
      if (isAM.value === true) {
        isAM.value = false;
        if (innerModel.value.hour !== null) {
          innerModel.value.hour += 12;
          verifyAndUpdate();
        }
      }
    }
    function goToViewWhenHasModel(newView) {
      const model2 = props4.modelValue;
      if (view.value !== newView && model2 !== void 0 && model2 !== null && model2 !== "" && typeof model2 !== "string") {
        view.value = newView;
      }
    }
    function verifyAndUpdate() {
      if (hourInSelection.value !== null && hourInSelection.value(innerModel.value.hour) !== true) {
        innerModel.value = __splitDate();
        goToViewWhenHasModel("hour");
        return;
      }
      if (minuteInSelection.value !== null && minuteInSelection.value(innerModel.value.minute) !== true) {
        innerModel.value.minute = null;
        innerModel.value.second = null;
        goToViewWhenHasModel("minute");
        return;
      }
      if (props4.withSeconds === true && secondInSelection.value !== null && secondInSelection.value(innerModel.value.second) !== true) {
        innerModel.value.second = null;
        goToViewWhenHasModel("second");
        return;
      }
      if (innerModel.value.hour === null || innerModel.value.minute === null || props4.withSeconds === true && innerModel.value.second === null) return;
      updateValue2();
    }
    function updateValue2(obj) {
      const date = Object.assign({ ...innerModel.value }, obj);
      const val = props4.calendar === "persian" ? pad(date.hour) + ":" + pad(date.minute) + (props4.withSeconds === true ? ":" + pad(date.second) : "") : formatDate(
        new Date(
          date.year,
          date.month === null ? null : date.month - 1,
          date.day,
          date.hour,
          date.minute,
          date.second,
          date.millisecond
        ),
        mask.value,
        locale2.value,
        date.year,
        date.timezoneOffset
      );
      date.changed = val !== props4.modelValue;
      emit("update:modelValue", val, date);
    }
    function getHeader() {
      const label = [
        h("div", {
          class: "q-time__link " + (view.value === "hour" ? "q-time__link--active" : "cursor-pointer"),
          tabindex: tabindex.value,
          onClick: setView.hour,
          onKeyup: onKeyupHour
        }, stringModel.value.hour),
        h("div", ":"),
        h(
          "div",
          minLink.value === true ? {
            class: "q-time__link " + (view.value === "minute" ? "q-time__link--active" : "cursor-pointer"),
            tabindex: tabindex.value,
            onKeyup: onKeyupMinute,
            onClick: setView.minute
          } : { class: "q-time__link" },
          stringModel.value.minute
        )
      ];
      if (props4.withSeconds === true) {
        label.push(
          h("div", ":"),
          h(
            "div",
            secLink.value === true ? {
              class: "q-time__link " + (view.value === "second" ? "q-time__link--active" : "cursor-pointer"),
              tabindex: tabindex.value,
              onKeyup: onKeyupSecond,
              onClick: setView.second
            } : { class: "q-time__link" },
            stringModel.value.second
          )
        );
      }
      const child = [
        h("div", {
          class: "q-time__header-label row items-center no-wrap",
          dir: "ltr"
        }, label)
      ];
      computedFormat24h.value === false && child.push(
        h("div", {
          class: "q-time__header-ampm column items-between no-wrap"
        }, [
          h("div", {
            class: "q-time__link " + (isAM.value === true ? "q-time__link--active" : "cursor-pointer"),
            tabindex: tabindex.value,
            onClick: setAm,
            onKeyup: setAmOnKey
          }, "AM"),
          h("div", {
            class: "q-time__link " + (isAM.value !== true ? "q-time__link--active" : "cursor-pointer"),
            tabindex: tabindex.value,
            onClick: setPm,
            onKeyup: setPmOnKey
          }, "PM")
        ])
      );
      return h("div", {
        class: "q-time__header flex flex-center no-wrap " + headerClass.value
      }, child);
    }
    function getClock() {
      const current = innerModel.value[view.value];
      return h("div", {
        class: "q-time__content col relative-position"
      }, [
        h(Transition, {
          name: "q-transition--scale"
        }, () => h("div", {
          key: "clock" + view.value,
          class: "q-time__container-parent absolute-full"
        }, [
          h("div", {
            ref: clockRef,
            class: "q-time__container-child fit overflow-hidden"
          }, [
            withDirectives(
              h("div", {
                class: "q-time__clock cursor-pointer non-selectable",
                onClick,
                onMousedown
              }, [
                h("div", { class: "q-time__clock-circle fit" }, [
                  h("div", {
                    class: "q-time__clock-pointer" + (innerModel.value[view.value] === null ? " hidden" : props4.color !== void 0 ? ` text-${props4.color}` : ""),
                    style: pointerStyle.value
                  }),
                  positions2.value.map((pos) => h("div", {
                    class: `q-time__clock-position row flex-center q-time__clock-pos-${pos.index}` + (pos.val === current ? " q-time__clock-position--active " + headerClass.value : pos.disable === true ? " q-time__clock-position--disable" : "")
                  }, [h("span", pos.label)]))
                ])
              ]),
              clockDirectives.value
            )
          ])
        ])),
        props4.nowBtn === true ? h(QBtn_default, {
          class: "q-time__now-button absolute",
          icon: $q.iconSet.datetime.now,
          unelevated: true,
          size: "sm",
          round: true,
          color: props4.color,
          textColor: props4.textColor,
          tabindex: tabindex.value,
          onClick: setNow
        }) : null
      ]);
    }
    vm2.proxy.setNow = setNow;
    return () => {
      const child = [getClock()];
      const def = hSlot(slots.default);
      def !== void 0 && child.push(
        h("div", { class: "q-time__actions" }, def)
      );
      if (props4.name !== void 0 && props4.disable !== true) {
        injectFormInput(child, "push");
      }
      return h("div", {
        class: classes.value,
        tabindex: -1
      }, [
        getHeader(),
        h("div", { class: "q-time__main col overflow-auto" }, child)
      ]);
    };
  }
});
createComponent({
  name: "QTimeline",
  props: {
    ...useDarkProps,
    color: {
      type: String,
      default: "primary"
    },
    side: {
      type: String,
      default: "right",
      validator: (v) => ["left", "right"].includes(v)
    },
    layout: {
      type: String,
      default: "dense",
      validator: (v) => ["dense", "comfortable", "loose"].includes(v)
    }
  },
  setup(props4, { slots }) {
    const vm2 = getCurrentInstance();
    const isDark = use_dark_default(props4, vm2.proxy.$q);
    provide(timelineKey, props4);
    const classes = computed(
      () => `q-timeline q-timeline--${props4.layout} q-timeline--${props4.layout}--${props4.side}` + (isDark.value === true ? " q-timeline--dark" : "")
    );
    return () => h("ul", { class: classes.value }, hSlot(slots.default));
  }
});
createComponent({
  name: "QTimelineEntry",
  props: {
    heading: Boolean,
    tag: {
      type: String,
      default: "h3"
    },
    side: {
      type: String,
      default: "right",
      validator: (v) => ["left", "right"].includes(v)
    },
    icon: String,
    avatar: String,
    color: String,
    title: String,
    subtitle: String,
    body: String
  },
  setup(props4, { slots }) {
    const $timeline = inject(timelineKey, emptyRenderFn);
    if ($timeline === emptyRenderFn) {
      console.error("QTimelineEntry needs to be child of QTimeline");
      return emptyRenderFn;
    }
    const classes = computed(
      () => `q-timeline__entry q-timeline__entry--${props4.side}` + (props4.icon !== void 0 || props4.avatar !== void 0 ? " q-timeline__entry--icon" : "")
    );
    const dotClass = computed(
      () => `q-timeline__dot text-${props4.color || $timeline.color}`
    );
    const reverse = computed(
      () => $timeline.layout === "comfortable" && $timeline.side === "left"
    );
    return () => {
      const child = hUniqueSlot(slots.default, []);
      if (props4.body !== void 0) {
        child.unshift(props4.body);
      }
      if (props4.heading === true) {
        const content2 = [
          h("div"),
          h("div"),
          h(
            props4.tag,
            { class: "q-timeline__heading-title" },
            child
          )
        ];
        return h("div", {
          class: "q-timeline__heading"
        }, reverse.value === true ? content2.reverse() : content2);
      }
      let dot;
      if (props4.icon !== void 0) {
        dot = [
          h(QIcon_default, {
            class: "row items-center justify-center",
            name: props4.icon
          })
        ];
      } else if (props4.avatar !== void 0) {
        dot = [
          h("img", {
            class: "q-timeline__dot-img",
            src: props4.avatar
          })
        ];
      }
      const content = [
        h("div", { class: "q-timeline__subtitle" }, [
          h("span", {}, hSlot(slots.subtitle, [props4.subtitle]))
        ]),
        h("div", { class: dotClass.value }, dot),
        h("div", { class: "q-timeline__content" }, [
          h("h6", { class: "q-timeline__title" }, hSlot(slots.title, [props4.title]))
        ].concat(child))
      ];
      return h("li", {
        class: classes.value
      }, reverse.value === true ? content.reverse() : content);
    };
  }
});
createComponent({
  name: "QToolbar",
  props: {
    inset: Boolean
  },
  setup(props4, { slots }) {
    const classes = computed(
      () => "q-toolbar row no-wrap items-center" + (props4.inset === true ? " q-toolbar--inset" : "")
    );
    return () => h("div", { class: classes.value, role: "toolbar" }, hSlot(slots.default));
  }
});
createComponent({
  name: "QToolbarTitle",
  props: {
    shrink: Boolean
  },
  setup(props4, { slots }) {
    const classes = computed(
      () => "q-toolbar__title ellipsis" + (props4.shrink === true ? " col-shrink" : "")
    );
    return () => h("div", { class: classes.value }, hSlot(slots.default));
  }
});
var tickStrategyOptions = ["none", "strict", "leaf", "leaf-filtered"];
createComponent({
  name: "QTree",
  props: {
    ...useDarkProps,
    nodes: {
      type: Array,
      required: true
    },
    nodeKey: {
      type: String,
      required: true
    },
    labelKey: {
      type: String,
      default: "label"
    },
    childrenKey: {
      type: String,
      default: "children"
    },
    dense: Boolean,
    color: String,
    controlColor: String,
    textColor: String,
    selectedColor: String,
    icon: String,
    tickStrategy: {
      type: String,
      default: "none",
      validator: (v) => tickStrategyOptions.includes(v)
    },
    ticked: Array,
    // v-model:ticked
    expanded: Array,
    // v-model:expanded
    selected: {},
    // v-model:selected
    noSelectionUnset: Boolean,
    defaultExpandAll: Boolean,
    accordion: Boolean,
    filter: String,
    filterMethod: Function,
    duration: {},
    noConnectors: Boolean,
    noTransition: Boolean,
    noNodesLabel: String,
    noResultsLabel: String
  },
  emits: [
    "update:expanded",
    "update:ticked",
    "update:selected",
    "lazyLoad",
    "afterShow",
    "afterHide"
  ],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const isDark = use_dark_default(props4, $q);
    const lazy = ref$1({});
    const innerTicked = ref$1(props4.ticked || []);
    const innerExpanded = ref$1(props4.expanded || []);
    let blurTargets = {};
    onBeforeUpdate(() => {
      blurTargets = {};
    });
    const classes = computed(
      () => `q-tree q-tree--${props4.dense === true ? "dense" : "standard"}` + (props4.noConnectors === true ? " q-tree--no-connectors" : "") + (isDark.value === true ? " q-tree--dark" : "") + (props4.color !== void 0 ? ` text-${props4.color}` : "")
    );
    const hasSelection = computed(() => props4.selected !== void 0);
    const computedIcon = computed(() => props4.icon || $q.iconSet.tree.icon);
    const computedControlColor = computed(() => props4.controlColor || props4.color);
    const textColorClass = computed(() => props4.textColor !== void 0 ? ` text-${props4.textColor}` : "");
    const selectedColorClass = computed(() => {
      const color2 = props4.selectedColor || props4.color;
      return color2 ? ` text-${color2}` : "";
    });
    const computedFilterMethod = computed(() => props4.filterMethod !== void 0 ? props4.filterMethod : (node, filter) => {
      const filt = filter.toLowerCase();
      return node[props4.labelKey] && node[props4.labelKey].toLowerCase().indexOf(filt) !== -1;
    });
    const meta = computed(() => {
      const meta2 = {};
      const travel = (node, parent) => {
        const tickStrategy = node.tickStrategy || (parent ? parent.tickStrategy : props4.tickStrategy);
        const key = node[props4.nodeKey], isParent = node[props4.childrenKey] && Array.isArray(node[props4.childrenKey]) && node[props4.childrenKey].length !== 0, selectable = node.disabled !== true && hasSelection.value === true && node.selectable !== false, expandable = node.disabled !== true && node.expandable !== false, hasTicking = tickStrategy !== "none", strictTicking = tickStrategy === "strict", leafFilteredTicking = tickStrategy === "leaf-filtered", leafTicking = tickStrategy === "leaf" || tickStrategy === "leaf-filtered";
        let tickable = node.disabled !== true && node.tickable !== false;
        if (leafTicking === true && tickable === true && parent && parent.tickable !== true) {
          tickable = false;
        }
        let localLazy = node.lazy;
        if (localLazy === true && lazy.value[key] !== void 0 && Array.isArray(node[props4.childrenKey]) === true) {
          localLazy = lazy.value[key];
        }
        const m4 = {
          key,
          parent,
          isParent,
          lazy: localLazy,
          disabled: node.disabled,
          link: node.disabled !== true && (selectable === true || expandable === true && (isParent === true || localLazy === true)),
          children: [],
          matchesFilter: props4.filter ? computedFilterMethod.value(node, props4.filter) : true,
          selected: key === props4.selected && selectable === true,
          selectable,
          expanded: isParent === true ? innerExpanded.value.includes(key) : false,
          expandable,
          noTick: node.noTick === true || strictTicking !== true && localLazy && localLazy !== "loaded",
          tickable,
          tickStrategy,
          hasTicking,
          strictTicking,
          leafFilteredTicking,
          leafTicking,
          ticked: strictTicking === true ? innerTicked.value.includes(key) : isParent === true ? false : innerTicked.value.includes(key)
        };
        meta2[key] = m4;
        if (isParent === true) {
          m4.children = node[props4.childrenKey].map((n) => travel(n, m4));
          if (props4.filter) {
            if (m4.matchesFilter !== true) {
              m4.matchesFilter = m4.children.some((n) => n.matchesFilter);
            } else if (m4.noTick !== true && m4.disabled !== true && m4.tickable === true && leafFilteredTicking === true && m4.children.every((n) => n.matchesFilter !== true || n.noTick === true || n.tickable !== true) === true) {
              m4.tickable = false;
            }
          }
          if (m4.matchesFilter === true) {
            if (m4.noTick !== true && strictTicking !== true && m4.children.every((n) => n.noTick) === true) {
              m4.noTick = true;
            }
            if (leafTicking) {
              m4.ticked = false;
              m4.indeterminate = m4.children.some((node2) => node2.indeterminate === true);
              m4.tickable = m4.tickable === true && m4.children.some((node2) => node2.tickable);
              if (m4.indeterminate !== true) {
                const sel = m4.children.reduce((acc, meta3) => meta3.ticked === true ? acc + 1 : acc, 0);
                if (sel === m4.children.length) {
                  m4.ticked = true;
                } else if (sel > 0) {
                  m4.indeterminate = true;
                }
              }
              if (m4.indeterminate === true) {
                m4.indeterminateNextState = m4.children.every((meta3) => meta3.tickable !== true || meta3.ticked !== true);
              }
            }
          }
        }
        return m4;
      };
      props4.nodes.forEach((node) => travel(node, null));
      return meta2;
    });
    watch(() => props4.ticked, (val) => {
      innerTicked.value = val;
    });
    watch(() => props4.expanded, (val) => {
      innerExpanded.value = val;
    });
    function getNodeByKey(key) {
      const reduce = [].reduce;
      const find = (result, node) => {
        if (result || !node) {
          return result;
        }
        if (Array.isArray(node) === true) {
          return reduce.call(Object(node), find, result);
        }
        if (node[props4.nodeKey] === key) {
          return node;
        }
        if (node[props4.childrenKey]) {
          return find(null, node[props4.childrenKey]);
        }
      };
      return find(null, props4.nodes);
    }
    function getTickedNodes() {
      return innerTicked.value.map((key) => getNodeByKey(key));
    }
    function getExpandedNodes() {
      return innerExpanded.value.map((key) => getNodeByKey(key));
    }
    function isExpanded(key) {
      return key && meta.value[key] ? meta.value[key].expanded : false;
    }
    function collapseAll() {
      if (props4.expanded !== void 0) {
        emit("update:expanded", []);
      } else {
        innerExpanded.value = [];
      }
    }
    function expandAll() {
      const expanded = [];
      const travel = (node) => {
        if (node[props4.childrenKey] && node[props4.childrenKey].length !== 0) {
          if (node.expandable !== false && node.disabled !== true) {
            expanded.push(node[props4.nodeKey]);
            node[props4.childrenKey].forEach(travel);
          }
        }
      };
      props4.nodes.forEach(travel);
      if (props4.expanded !== void 0) {
        emit("update:expanded", expanded);
      } else {
        innerExpanded.value = expanded;
      }
    }
    function setExpanded(key, state2, node = getNodeByKey(key), m4 = meta.value[key]) {
      if (m4.lazy && m4.lazy !== "loaded") {
        if (m4.lazy === "loading") return;
        lazy.value[key] = "loading";
        if (Array.isArray(node[props4.childrenKey]) !== true) {
          node[props4.childrenKey] = [];
        }
        emit("lazyLoad", {
          node,
          key,
          done: (children) => {
            lazy.value[key] = "loaded";
            node[props4.childrenKey] = Array.isArray(children) === true ? children : [];
            nextTick(() => {
              const localMeta = meta.value[key];
              if ((localMeta == null ? void 0 : localMeta.isParent) === true) {
                localSetExpanded(key, true);
              }
            });
          },
          fail: () => {
            delete lazy.value[key];
            if (node[props4.childrenKey].length === 0) {
              delete node[props4.childrenKey];
            }
          }
        });
      } else if (m4.isParent === true && m4.expandable === true) {
        localSetExpanded(key, state2);
      }
    }
    function localSetExpanded(key, state2) {
      let target2 = innerExpanded.value;
      const shouldEmit = props4.expanded !== void 0;
      if (shouldEmit === true) {
        target2 = target2.slice();
      }
      if (state2) {
        if (props4.accordion) {
          if (meta.value[key]) {
            const collapse = [];
            if (meta.value[key].parent) {
              meta.value[key].parent.children.forEach((m4) => {
                if (m4.key !== key && m4.expandable === true) {
                  collapse.push(m4.key);
                }
              });
            } else {
              props4.nodes.forEach((node) => {
                const k3 = node[props4.nodeKey];
                if (k3 !== key) {
                  collapse.push(k3);
                }
              });
            }
            if (collapse.length !== 0) {
              target2 = target2.filter((k3) => collapse.includes(k3) === false);
            }
          }
        }
        target2 = target2.concat([key]).filter((key2, index2, self2) => self2.indexOf(key2) === index2);
      } else {
        target2 = target2.filter((k3) => k3 !== key);
      }
      if (shouldEmit === true) {
        emit("update:expanded", target2);
      } else {
        innerExpanded.value = target2;
      }
    }
    function isTicked(key) {
      return key && meta.value[key] ? meta.value[key].ticked : false;
    }
    function setTicked(keys2, state2) {
      let target2 = innerTicked.value;
      const shouldEmit = props4.ticked !== void 0;
      if (shouldEmit === true) {
        target2 = target2.slice();
      }
      if (state2) {
        target2 = target2.concat(keys2).filter((key, index2, self2) => self2.indexOf(key) === index2);
      } else {
        target2 = target2.filter((k3) => keys2.includes(k3) === false);
      }
      if (shouldEmit === true) {
        emit("update:ticked", target2);
      }
    }
    function getSlotScope(node, meta2, key) {
      const scope = { tree: proxy, node, key, color: props4.color, dark: isDark.value };
      injectProp(
        scope,
        "expanded",
        () => {
          return meta2.expanded;
        },
        (val) => {
          val !== meta2.expanded && setExpanded(key, val);
        }
      );
      injectProp(
        scope,
        "ticked",
        () => {
          return meta2.ticked;
        },
        (val) => {
          val !== meta2.ticked && setTicked([key], val);
        }
      );
      return scope;
    }
    function getChildren(nodes) {
      return (props4.filter ? nodes.filter((n) => meta.value[n[props4.nodeKey]].matchesFilter) : nodes).map((child) => getNode(child));
    }
    function getNodeMedia(node) {
      if (node.icon !== void 0) {
        return h(QIcon_default, {
          class: "q-tree__icon q-mr-sm",
          name: node.icon,
          color: node.iconColor
        });
      }
      const src = node.img || node.avatar;
      if (src) {
        return h("img", {
          class: `q-tree__${node.img ? "img" : "avatar"} q-mr-sm`,
          src
        });
      }
    }
    function onShow() {
      emit("afterShow");
    }
    function onHide() {
      emit("afterHide");
    }
    function getNode(node) {
      const key = node[props4.nodeKey], m4 = meta.value[key], header = node.header ? slots[`header-${node.header}`] || slots["default-header"] : slots["default-header"];
      const children = m4.isParent === true ? getChildren(node[props4.childrenKey]) : [];
      const isParent = children.length !== 0 || m4.lazy && m4.lazy !== "loaded";
      let body = node.body ? slots[`body-${node.body}`] || slots["default-body"] : slots["default-body"];
      const slotScope = header !== void 0 || body !== void 0 ? getSlotScope(node, m4, key) : null;
      if (body !== void 0) {
        body = h("div", { class: "q-tree__node-body relative-position" }, [
          h("div", { class: textColorClass.value }, [
            body(slotScope)
          ])
        ]);
      }
      return h("div", {
        key,
        class: `q-tree__node relative-position q-tree__node--${isParent === true ? "parent" : "child"}`
      }, [
        h("div", {
          class: "q-tree__node-header relative-position row no-wrap items-center" + (m4.link === true ? " q-tree__node--link q-hoverable q-focusable" : "") + (m4.selected === true ? " q-tree__node--selected" : "") + (m4.disabled === true ? " q-tree__node--disabled" : ""),
          tabindex: m4.link === true ? 0 : -1,
          ariaExpanded: children.length > 0 ? m4.expanded : null,
          role: "treeitem",
          onClick: (e3) => {
            onClick(node, m4, e3);
          },
          onKeypress(e3) {
            if (shouldIgnoreKey(e3) !== true) {
              if (e3.keyCode === 13) {
                onClick(node, m4, e3, true);
              } else if (e3.keyCode === 32) {
                onExpandClick(node, m4, e3, true);
              }
            }
          }
        }, [
          h("div", {
            class: "q-focus-helper",
            tabindex: -1,
            ref: (el) => {
              blurTargets[m4.key] = el;
            }
          }),
          m4.lazy === "loading" ? h(QSpinner_default, {
            class: "q-tree__spinner",
            color: computedControlColor.value
          }) : isParent === true ? h(QIcon_default, {
            class: "q-tree__arrow" + (m4.expanded === true ? " q-tree__arrow--rotate" : ""),
            name: computedIcon.value,
            onClick(e3) {
              onExpandClick(node, m4, e3);
            }
          }) : null,
          m4.hasTicking === true && m4.noTick !== true ? h(QCheckbox_default, {
            class: "q-tree__tickbox",
            modelValue: m4.indeterminate === true ? null : m4.ticked,
            color: computedControlColor.value,
            dark: isDark.value,
            dense: true,
            keepColor: true,
            disable: m4.tickable !== true,
            onKeydown: stopAndPrevent,
            "onUpdate:modelValue": (v) => {
              onTickedClick(m4, v);
            }
          }) : null,
          h("div", {
            class: "q-tree__node-header-content col row no-wrap items-center" + (m4.selected === true ? selectedColorClass.value : textColorClass.value)
          }, [
            header ? header(slotScope) : [
              getNodeMedia(node),
              h("div", node[props4.labelKey])
            ]
          ])
        ]),
        isParent === true ? props4.noTransition === true ? m4.expanded === true ? h("div", {
          class: "q-tree__node-collapsible" + textColorClass.value,
          key: `${key}__q`
        }, [
          body,
          h("div", {
            class: "q-tree__children" + (m4.disabled === true ? " q-tree__node--disabled" : ""),
            role: "group"
          }, children)
        ]) : null : h(QSlideTransition_default, {
          duration: props4.duration,
          onShow,
          onHide
        }, () => withDirectives(
          h("div", {
            class: "q-tree__node-collapsible" + textColorClass.value,
            key: `${key}__q`
          }, [
            body,
            h("div", {
              class: "q-tree__children" + (m4.disabled === true ? " q-tree__node--disabled" : ""),
              role: "group"
            }, children)
          ]),
          [[vShow, m4.expanded]]
        )) : body
      ]);
    }
    function blur(key) {
      var _a;
      (_a = blurTargets[key]) == null ? void 0 : _a.focus();
    }
    function onClick(node, meta2, e3, keyboard) {
      keyboard !== true && meta2.selectable !== false && blur(meta2.key);
      if (hasSelection.value && meta2.selectable) {
        if (props4.noSelectionUnset === false) {
          emit("update:selected", meta2.key !== props4.selected ? meta2.key : null);
        } else if (meta2.key !== props4.selected) {
          emit("update:selected", meta2.key === void 0 ? null : meta2.key);
        }
      } else {
        onExpandClick(node, meta2, e3, keyboard);
      }
      if (typeof node.handler === "function") {
        node.handler(node);
      }
    }
    function onExpandClick(node, meta2, e3, keyboard) {
      if (e3 !== void 0) {
        stopAndPrevent(e3);
      }
      keyboard !== true && meta2.selectable !== false && blur(meta2.key);
      setExpanded(meta2.key, !meta2.expanded, node, meta2);
    }
    function onTickedClick(meta2, state2) {
      if (meta2.indeterminate === true) {
        state2 = meta2.indeterminateNextState;
      }
      if (meta2.strictTicking) {
        setTicked([meta2.key], state2);
      } else if (meta2.leafTicking) {
        const keys2 = [];
        const travel = (meta3) => {
          if (meta3.isParent) {
            if (state2 !== true && meta3.noTick !== true && meta3.tickable === true) {
              keys2.push(meta3.key);
            }
            if (meta3.leafTicking === true) {
              meta3.children.forEach(travel);
            }
          } else if (meta3.noTick !== true && meta3.tickable === true && (meta3.leafFilteredTicking !== true || meta3.matchesFilter === true)) {
            keys2.push(meta3.key);
          }
        };
        travel(meta2);
        setTicked(keys2, state2);
      }
    }
    props4.defaultExpandAll === true && expandAll();
    Object.assign(proxy, {
      getNodeByKey,
      getTickedNodes,
      getExpandedNodes,
      isExpanded,
      collapseAll,
      expandAll,
      setExpanded,
      isTicked,
      setTicked
    });
    return () => {
      const children = getChildren(props4.nodes);
      return h(
        "div",
        {
          class: classes.value,
          role: "tree"
        },
        children.length === 0 ? props4.filter ? props4.noResultsLabel || $q.lang.tree.noResults : props4.noNodesLabel || $q.lang.tree.noNodes : children
      );
    };
  }
});
function getProgressLabel(p2) {
  return (p2 * 100).toFixed(2) + "%";
}
var coreProps = {
  ...useDarkProps,
  ...useFileProps,
  label: String,
  color: String,
  textColor: String,
  square: Boolean,
  flat: Boolean,
  bordered: Boolean,
  noThumbnails: Boolean,
  thumbnailFit: {
    type: String,
    default: "cover"
  },
  autoUpload: Boolean,
  hideUploadBtn: Boolean,
  disable: Boolean,
  readonly: Boolean
};
var coreEmits = [
  ...useFileEmits,
  "start",
  "finish",
  "added",
  "removed"
];
function getRenderer(getPlugin, expose) {
  const vm2 = getCurrentInstance();
  const { props: props4, slots, emit, proxy } = vm2;
  const { $q } = proxy;
  const isDark = use_dark_default(props4, $q);
  function updateFileStatus(file, status, uploadedSize) {
    file.__status = status;
    if (status === "idle") {
      file.__uploaded = 0;
      file.__progress = 0;
      file.__sizeLabel = humanStorageSize(file.size);
      file.__progressLabel = "0.00%";
      return;
    }
    if (status === "failed") {
      proxy.$forceUpdate();
      return;
    }
    file.__uploaded = status === "uploaded" ? file.size : uploadedSize;
    file.__progress = status === "uploaded" ? 1 : Math.min(0.9999, file.__uploaded / file.size);
    file.__progressLabel = getProgressLabel(file.__progress);
    proxy.$forceUpdate();
  }
  const editable = computed(() => props4.disable !== true && props4.readonly !== true);
  const dnd = ref$1(false);
  const rootRef = ref$1(null);
  const inputRef = ref$1(null);
  const state2 = {
    files: ref$1([]),
    queuedFiles: ref$1([]),
    uploadedFiles: ref$1([]),
    uploadedSize: ref$1(0),
    updateFileStatus,
    isAlive: () => vmIsDestroyed(vm2) === false
  };
  const {
    pickFiles,
    addFiles,
    onDragover,
    onDragleave,
    processFiles,
    getDndNode,
    maxFilesNumber,
    maxTotalSizeNumber
  } = use_file_default({ editable, dnd, getFileInput, addFilesToQueue });
  Object.assign(state2, getPlugin({
    props: props4,
    slots,
    emit,
    helpers: state2,
    exposeApi: (obj) => {
      Object.assign(state2, obj);
    }
  }));
  if (state2.isBusy === void 0) {
    state2.isBusy = ref$1(false);
  }
  const uploadSize = ref$1(0);
  const uploadProgress = computed(() => uploadSize.value === 0 ? 0 : state2.uploadedSize.value / uploadSize.value);
  const uploadProgressLabel = computed(() => getProgressLabel(uploadProgress.value));
  const uploadSizeLabel = computed(() => humanStorageSize(uploadSize.value));
  const canAddFiles = computed(
    () => editable.value === true && state2.isUploading.value !== true && (props4.multiple === true || state2.queuedFiles.value.length === 0) && (props4.maxFiles === void 0 || state2.files.value.length < maxFilesNumber.value) && (props4.maxTotalSize === void 0 || uploadSize.value < maxTotalSizeNumber.value)
  );
  const canUpload = computed(
    () => editable.value === true && state2.isBusy.value !== true && state2.isUploading.value !== true && state2.queuedFiles.value.length !== 0
  );
  provide(uploaderKey, renderInput);
  const classes = computed(
    () => "q-uploader column no-wrap" + (isDark.value === true ? " q-uploader--dark q-dark" : "") + (props4.bordered === true ? " q-uploader--bordered" : "") + (props4.square === true ? " q-uploader--square no-border-radius" : "") + (props4.flat === true ? " q-uploader--flat no-shadow" : "") + (props4.disable === true ? " disabled q-uploader--disable" : "") + (dnd.value === true ? " q-uploader--dnd" : "")
  );
  const colorClass = computed(
    () => "q-uploader__header" + (props4.color !== void 0 ? ` bg-${props4.color}` : "") + (props4.textColor !== void 0 ? ` text-${props4.textColor}` : "")
  );
  watch(state2.isUploading, (newVal, oldVal) => {
    if (oldVal === false && newVal === true) {
      emit("start");
    } else if (oldVal === true && newVal === false) {
      emit("finish");
    }
  });
  function reset() {
    if (props4.disable === false) {
      state2.abort();
      state2.uploadedSize.value = 0;
      uploadSize.value = 0;
      revokeImgURLs();
      state2.files.value = [];
      state2.queuedFiles.value = [];
      state2.uploadedFiles.value = [];
    }
  }
  function removeUploadedFiles() {
    if (props4.disable === false) {
      batchRemoveFiles(["uploaded"], () => {
        state2.uploadedFiles.value = [];
      });
    }
  }
  function removeQueuedFiles() {
    batchRemoveFiles(["idle", "failed"], ({ size: size2 }) => {
      uploadSize.value -= size2;
      state2.queuedFiles.value = [];
    });
  }
  function batchRemoveFiles(statusList, cb) {
    if (props4.disable === true) return;
    const removed = {
      files: [],
      size: 0
    };
    const localFiles = state2.files.value.filter((f) => {
      if (statusList.indexOf(f.__status) === -1) {
        return true;
      }
      removed.size += f.size;
      removed.files.push(f);
      f.__img !== void 0 && window.URL.revokeObjectURL(f.__img.src);
      return false;
    });
    if (removed.files.length !== 0) {
      state2.files.value = localFiles;
      cb(removed);
      emit("removed", removed.files);
    }
  }
  function removeFile(file) {
    if (props4.disable) return;
    if (file.__status === "uploaded") {
      state2.uploadedFiles.value = state2.uploadedFiles.value.filter((f) => f.__key !== file.__key);
    } else if (file.__status === "uploading") {
      file.__abort();
    } else {
      uploadSize.value -= file.size;
    }
    state2.files.value = state2.files.value.filter((f) => {
      if (f.__key !== file.__key) {
        return true;
      }
      f.__img !== void 0 && window.URL.revokeObjectURL(f.__img.src);
      return false;
    });
    state2.queuedFiles.value = state2.queuedFiles.value.filter((f) => f.__key !== file.__key);
    emit("removed", [file]);
  }
  function revokeImgURLs() {
    state2.files.value.forEach((f) => {
      f.__img !== void 0 && window.URL.revokeObjectURL(f.__img.src);
    });
  }
  function getFileInput() {
    return inputRef.value || rootRef.value.getElementsByClassName("q-uploader__input")[0];
  }
  function addFilesToQueue(e3, fileList) {
    const localFiles = processFiles(e3, fileList, state2.files.value, true);
    const fileInput = getFileInput();
    if (fileInput !== void 0 && fileInput !== null) {
      fileInput.value = "";
    }
    if (localFiles === void 0) return;
    localFiles.forEach((file) => {
      state2.updateFileStatus(file, "idle");
      uploadSize.value += file.size;
      if (props4.noThumbnails !== true && file.type.toUpperCase().startsWith("IMAGE")) {
        const img = new Image();
        img.src = window.URL.createObjectURL(file);
        file.__img = img;
      }
    });
    state2.files.value = state2.files.value.concat(localFiles);
    state2.queuedFiles.value = state2.queuedFiles.value.concat(localFiles);
    emit("added", localFiles);
    props4.autoUpload === true && state2.upload();
  }
  function upload() {
    canUpload.value === true && state2.upload();
  }
  function getBtn2(show, icon, fn) {
    if (show === true) {
      const data = {
        type: "a",
        key: icon,
        icon: $q.iconSet.uploader[icon],
        flat: true,
        dense: true
      };
      let child = void 0;
      if (icon === "add") {
        data.onClick = pickFiles;
        child = renderInput;
      } else {
        data.onClick = fn;
      }
      return h(QBtn_default, data, child);
    }
  }
  function renderInput() {
    return h("input", {
      ref: inputRef,
      class: "q-uploader__input overflow-hidden absolute-full",
      tabindex: -1,
      type: "file",
      title: "",
      // try to remove default tooltip
      accept: props4.accept,
      multiple: props4.multiple === true ? "multiple" : void 0,
      capture: props4.capture,
      onMousedown: stop,
      // need to stop refocus from QBtn
      onClick: pickFiles,
      onChange: addFilesToQueue
    });
  }
  function getHeader() {
    if (slots.header !== void 0) {
      return slots.header(publicApi);
    }
    return [
      h("div", {
        class: "q-uploader__header-content column"
      }, [
        h("div", {
          class: "flex flex-center no-wrap q-gutter-xs"
        }, [
          getBtn2(state2.queuedFiles.value.length !== 0, "removeQueue", removeQueuedFiles),
          getBtn2(state2.uploadedFiles.value.length !== 0, "removeUploaded", removeUploadedFiles),
          state2.isUploading.value === true ? h(QSpinner_default, { class: "q-uploader__spinner" }) : null,
          h("div", { class: "col column justify-center" }, [
            props4.label !== void 0 ? h("div", { class: "q-uploader__title" }, [props4.label]) : null,
            h("div", { class: "q-uploader__subtitle" }, [
              uploadSizeLabel.value + " / " + uploadProgressLabel.value
            ])
          ]),
          getBtn2(canAddFiles.value, "add"),
          getBtn2(props4.hideUploadBtn === false && canUpload.value === true, "upload", state2.upload),
          getBtn2(state2.isUploading.value, "clear", state2.abort)
        ])
      ])
    ];
  }
  function getList() {
    if (slots.list !== void 0) {
      return slots.list(publicApi);
    }
    return state2.files.value.map((file) => h("div", {
      key: file.__key,
      class: "q-uploader__file relative-position" + (props4.noThumbnails !== true && file.__img !== void 0 ? " q-uploader__file--img" : "") + (file.__status === "failed" ? " q-uploader__file--failed" : file.__status === "uploaded" ? " q-uploader__file--uploaded" : ""),
      style: props4.noThumbnails !== true && file.__img !== void 0 ? { backgroundImage: 'url("' + file.__img.src + '")', backgroundSize: props4.thumbnailFit } : null
    }, [
      h("div", {
        class: "q-uploader__file-header row flex-center no-wrap"
      }, [
        file.__status === "failed" ? h(QIcon_default, {
          class: "q-uploader__file-status",
          name: $q.iconSet.type.negative,
          color: "negative"
        }) : null,
        h("div", { class: "q-uploader__file-header-content col" }, [
          h("div", { class: "q-uploader__title" }, [file.name]),
          h("div", {
            class: "q-uploader__subtitle row items-center no-wrap"
          }, [
            file.__sizeLabel + " / " + file.__progressLabel
          ])
        ]),
        file.__status === "uploading" ? h(QCircularProgress_default, {
          value: file.__progress,
          min: 0,
          max: 1,
          indeterminate: file.__progress === 0
        }) : h(QBtn_default, {
          round: true,
          dense: true,
          flat: true,
          icon: $q.iconSet.uploader[file.__status === "uploaded" ? "done" : "clear"],
          onClick: () => {
            removeFile(file);
          }
        })
      ])
    ]));
  }
  onBeforeUnmount(() => {
    state2.isUploading.value === true && state2.abort();
    state2.files.value.length !== 0 && revokeImgURLs();
  });
  const publicApi = {};
  for (const key in state2) {
    if (isRef(state2[key]) === true) {
      injectProp(publicApi, key, () => state2[key].value);
    } else {
      publicApi[key] = state2[key];
    }
  }
  Object.assign(publicApi, {
    upload,
    reset,
    removeUploadedFiles,
    removeQueuedFiles,
    removeFile,
    pickFiles,
    addFiles
  });
  injectMultipleProps(publicApi, {
    canAddFiles: () => canAddFiles.value,
    canUpload: () => canUpload.value,
    uploadSizeLabel: () => uploadSizeLabel.value,
    uploadProgressLabel: () => uploadProgressLabel.value
  });
  expose({
    ...state2,
    upload,
    reset,
    removeUploadedFiles,
    removeQueuedFiles,
    removeFile,
    pickFiles,
    addFiles,
    canAddFiles,
    canUpload,
    uploadSizeLabel,
    uploadProgressLabel
  });
  return () => {
    const children = [
      h("div", { class: colorClass.value }, getHeader()),
      h("div", { class: "q-uploader__list scroll" }, getList()),
      getDndNode("uploader")
    ];
    state2.isBusy.value === true && children.push(
      h("div", {
        class: "q-uploader__overlay absolute-full flex flex-center"
      }, [h(QSpinner_default)])
    );
    const data = { ref: rootRef, class: classes.value };
    if (canAddFiles.value === true) {
      Object.assign(data, { onDragover, onDragleave });
    }
    return h("div", data, children);
  };
}
var trueFn = () => true;
function get_emits_object_default(emitsArray) {
  const emitsObject = {};
  emitsArray.forEach((val) => {
    emitsObject[val] = trueFn;
  });
  return emitsObject;
}
var coreEmitsObject = get_emits_object_default(coreEmits);
var create_uploader_component_default = ({ name: name2, props: props4, emits: emits3, injectPlugin: injectPlugin2 }) => createComponent({
  name: name2,
  props: {
    ...coreProps,
    ...props4
  },
  emits: isObject(emits3) === true ? { ...coreEmitsObject, ...emits3 } : [...coreEmits, ...emits3],
  setup(_, { expose }) {
    return getRenderer(injectPlugin2, expose);
  }
});
function getFn(prop) {
  return typeof prop === "function" ? prop : () => prop;
}
var name = "QUploader";
var props = {
  url: [Function, String],
  method: {
    type: [Function, String],
    default: "POST"
  },
  fieldName: {
    type: [Function, String],
    default: () => (file) => file.name
  },
  headers: [Function, Array],
  formFields: [Function, Array],
  withCredentials: [Function, Boolean],
  sendRaw: [Function, Boolean],
  batch: [Function, Boolean],
  factory: Function
};
var emits = ["factoryFailed", "uploaded", "failed", "uploading"];
function injectPlugin({ props: props4, emit, helpers: helpers2 }) {
  const xhrs = ref$1([]);
  const promises = ref$1([]);
  const workingThreads = ref$1(0);
  const xhrProps = computed(() => ({
    url: getFn(props4.url),
    method: getFn(props4.method),
    headers: getFn(props4.headers),
    formFields: getFn(props4.formFields),
    fieldName: getFn(props4.fieldName),
    withCredentials: getFn(props4.withCredentials),
    sendRaw: getFn(props4.sendRaw),
    batch: getFn(props4.batch)
  }));
  const isUploading = computed(() => workingThreads.value > 0);
  const isBusy = computed(() => promises.value.length !== 0);
  let abortPromises;
  function abort() {
    xhrs.value.forEach((x3) => {
      x3.abort();
    });
    if (promises.value.length !== 0) {
      abortPromises = true;
    }
  }
  function upload() {
    const queue2 = helpers2.queuedFiles.value.slice(0);
    helpers2.queuedFiles.value = [];
    if (xhrProps.value.batch(queue2)) {
      runFactory(queue2);
    } else {
      queue2.forEach((file) => {
        runFactory([file]);
      });
    }
  }
  function runFactory(files) {
    workingThreads.value++;
    if (typeof props4.factory !== "function") {
      performUpload(files, {});
      return;
    }
    const res = props4.factory(files);
    if (!res) {
      emit(
        "factoryFailed",
        new Error("QUploader: factory() does not return properly"),
        files
      );
      workingThreads.value--;
    } else if (typeof res.catch === "function" && typeof res.then === "function") {
      promises.value.push(res);
      const failed = (err) => {
        if (helpers2.isAlive() === true) {
          promises.value = promises.value.filter((p2) => p2 !== res);
          if (promises.value.length === 0) {
            abortPromises = false;
          }
          helpers2.queuedFiles.value = helpers2.queuedFiles.value.concat(files);
          files.forEach((f) => {
            helpers2.updateFileStatus(f, "failed");
          });
          emit("factoryFailed", err, files);
          workingThreads.value--;
        }
      };
      res.then((factory) => {
        if (abortPromises === true) {
          failed(new Error("Aborted"));
        } else if (helpers2.isAlive() === true) {
          promises.value = promises.value.filter((p2) => p2 !== res);
          performUpload(files, factory);
        }
      }).catch(failed);
    } else {
      performUpload(files, res || {});
    }
  }
  function performUpload(files, factory) {
    const form = new FormData(), xhr2 = new XMLHttpRequest();
    const getProp2 = (name2, arg) => {
      return factory[name2] !== void 0 ? getFn(factory[name2])(arg) : xhrProps.value[name2](arg);
    };
    const url = getProp2("url", files);
    if (!url) {
      console.error("q-uploader: invalid or no URL specified");
      workingThreads.value--;
      return;
    }
    const fields = getProp2("formFields", files);
    fields !== void 0 && fields.forEach((field) => {
      form.append(field.name, field.value);
    });
    let uploadIndex = 0, uploadIndexSize = 0, localUploadedSize = 0, maxUploadSize = 0, aborted;
    xhr2.upload.addEventListener("progress", (e3) => {
      if (aborted === true) return;
      const loaded = Math.min(maxUploadSize, e3.loaded);
      helpers2.uploadedSize.value += loaded - localUploadedSize;
      localUploadedSize = loaded;
      let size2 = localUploadedSize - uploadIndexSize;
      for (let i3 = uploadIndex; size2 > 0 && i3 < files.length; i3++) {
        const file = files[i3], uploaded = size2 > file.size;
        if (uploaded) {
          size2 -= file.size;
          uploadIndex++;
          uploadIndexSize += file.size;
          helpers2.updateFileStatus(file, "uploading", file.size);
        } else {
          helpers2.updateFileStatus(file, "uploading", size2);
          return;
        }
      }
    }, false);
    xhr2.onreadystatechange = () => {
      if (xhr2.readyState < 4) return;
      if (xhr2.status && xhr2.status < 400) {
        helpers2.uploadedFiles.value = helpers2.uploadedFiles.value.concat(files);
        files.forEach((f) => {
          helpers2.updateFileStatus(f, "uploaded");
        });
        emit("uploaded", { files, xhr: xhr2 });
      } else {
        aborted = true;
        helpers2.uploadedSize.value -= localUploadedSize;
        helpers2.queuedFiles.value = helpers2.queuedFiles.value.concat(files);
        files.forEach((f) => {
          helpers2.updateFileStatus(f, "failed");
        });
        emit("failed", { files, xhr: xhr2 });
      }
      workingThreads.value--;
      xhrs.value = xhrs.value.filter((x3) => x3 !== xhr2);
    };
    xhr2.open(
      getProp2("method", files),
      url
    );
    if (getProp2("withCredentials", files) === true) {
      xhr2.withCredentials = true;
    }
    const headers = getProp2("headers", files);
    headers !== void 0 && headers.forEach((head) => {
      xhr2.setRequestHeader(head.name, head.value);
    });
    const sendRaw = getProp2("sendRaw", files);
    files.forEach((file) => {
      helpers2.updateFileStatus(file, "uploading", 0);
      if (sendRaw !== true) {
        form.append(getProp2("fieldName", file), file, file.name);
      }
      file.xhr = xhr2;
      file.__abort = () => {
        xhr2.abort();
      };
      maxUploadSize += file.size;
    });
    emit("uploading", { files, xhr: xhr2 });
    xhrs.value.push(xhr2);
    if (sendRaw === true) {
      xhr2.send(new Blob(files));
    } else {
      xhr2.send(form);
    }
  }
  return {
    isUploading,
    isBusy,
    abort,
    upload
  };
}
var xhr_uploader_plugin_default = {
  name,
  props,
  emits,
  injectPlugin
};
create_uploader_component_default(xhr_uploader_plugin_default);
createComponent({
  name: "QUploaderAddTrigger",
  setup() {
    const $trigger = inject(uploaderKey, emptyRenderFn);
    if ($trigger === emptyRenderFn) {
      console.error("QUploaderAddTrigger needs to be child of QUploader");
    }
    return $trigger;
  }
});
createComponent({
  name: "QVideo",
  props: {
    ...useRatioProps,
    src: {
      type: String,
      required: true
    },
    title: String,
    fetchpriority: {
      type: String,
      default: "auto"
    },
    loading: {
      type: String,
      default: "eager"
    },
    referrerpolicy: {
      type: String,
      default: "strict-origin-when-cross-origin"
    }
  },
  setup(props4) {
    const ratioStyle = use_ratio_default(props4);
    const classes = computed(
      () => "q-video" + (props4.ratio !== void 0 ? " q-video--responsive" : "")
    );
    return () => h("div", {
      class: classes.value,
      style: ratioStyle.value
    }, [
      h("iframe", {
        src: props4.src,
        title: props4.title,
        fetchpriority: props4.fetchpriority,
        loading: props4.loading,
        referrerpolicy: props4.referrerpolicy,
        frameborder: "0",
        allowfullscreen: true
      })
    ]);
  }
});
function getDepth(value2) {
  if (value2 === false) {
    return 0;
  }
  if (value2 === true || value2 === void 0) {
    return 1;
  }
  const depth = parseInt(value2, 10);
  return isNaN(depth) ? 0 : depth;
}
createDirective(
  {
    name: "close-popup",
    beforeMount(el, { value: value2 }) {
      const ctx = {
        depth: getDepth(value2),
        handler(evt) {
          ctx.depth !== 0 && setTimeout(() => {
            const proxy = getPortalProxy(el);
            if (proxy !== void 0) {
              closePortals(proxy, evt, ctx.depth);
            }
          });
        },
        handlerKey(evt) {
          isKeyCode(evt, 13) === true && ctx.handler(evt);
        }
      };
      el.__qclosepopup = ctx;
      el.addEventListener("click", ctx.handler);
      el.addEventListener("keyup", ctx.handlerKey);
    },
    updated(el, { value: value2, oldValue }) {
      if (value2 !== oldValue) {
        el.__qclosepopup.depth = getDepth(value2);
      }
    },
    beforeUnmount(el) {
      const ctx = el.__qclosepopup;
      el.removeEventListener("click", ctx.handler);
      el.removeEventListener("keyup", ctx.handlerKey);
      delete el.__qclosepopup;
    }
  }
);
var id2 = 0;
var offsetBase = void 0;
function getAbsolutePosition(el, resize) {
  if (offsetBase === void 0) {
    offsetBase = document.createElement("div");
    offsetBase.style.cssText = "position: absolute; left: 0; top: 0";
    document.body.appendChild(offsetBase);
  }
  const boundingRect = el.getBoundingClientRect();
  const baseRect = offsetBase.getBoundingClientRect();
  const { marginLeft, marginRight, marginTop, marginBottom } = window.getComputedStyle(el);
  const marginH = parseInt(marginLeft, 10) + parseInt(marginRight, 10);
  const marginV = parseInt(marginTop, 10) + parseInt(marginBottom, 10);
  return {
    left: boundingRect.left - baseRect.left,
    top: boundingRect.top - baseRect.top,
    width: boundingRect.right - boundingRect.left,
    height: boundingRect.bottom - boundingRect.top,
    widthM: boundingRect.right - boundingRect.left + (resize === true ? 0 : marginH),
    heightM: boundingRect.bottom - boundingRect.top + (resize === true ? 0 : marginV),
    marginH: resize === true ? marginH : 0,
    marginV: resize === true ? marginV : 0
  };
}
function getAbsoluteSize(el) {
  return {
    width: el.scrollWidth,
    height: el.scrollHeight
  };
}
var styleEdges = ["Top", "Right", "Bottom", "Left"];
var styleBorderRadiuses = ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"];
var reStyleSkipKey = /-block|-inline|block-|inline-/;
var reStyleSkipRule = /(-block|-inline|block-|inline-).*:/;
function getComputedStyle2(el, props4) {
  const style2 = window.getComputedStyle(el);
  const fixed = {};
  for (let i3 = 0; i3 < props4.length; i3++) {
    const prop = props4[i3];
    if (style2[prop] === "") {
      if (prop === "cssText") {
        const styleLen = style2.length;
        let val = "";
        for (let i22 = 0; i22 < styleLen; i22++) {
          if (reStyleSkipKey.test(style2[i22]) !== true) {
            val += style2[i22] + ": " + style2[style2[i22]] + "; ";
          }
        }
        fixed[prop] = val;
      } else if (["borderWidth", "borderStyle", "borderColor"].indexOf(prop) !== -1) {
        const suffix = prop.replace("border", "");
        let val = "";
        for (let j = 0; j < styleEdges.length; j++) {
          const subProp = "border" + styleEdges[j] + suffix;
          val += style2[subProp] + " ";
        }
        fixed[prop] = val;
      } else if (prop === "borderRadius") {
        let val1 = "";
        let val2 = "";
        for (let j = 0; j < styleBorderRadiuses.length; j++) {
          const val = style2[styleBorderRadiuses[j]].split(" ");
          val1 += val[0] + " ";
          val2 += (val[1] === void 0 ? val[0] : val[1]) + " ";
        }
        fixed[prop] = val1 + "/ " + val2;
      } else {
        fixed[prop] = style2[prop];
      }
    } else {
      if (prop === "cssText") {
        fixed[prop] = style2[prop].split(";").filter((val) => reStyleSkipRule.test(val) !== true).join(";");
      } else {
        fixed[prop] = style2[prop];
      }
    }
  }
  return fixed;
}
var zIndexPositions = ["absolute", "fixed", "relative", "sticky"];
function getMaxZIndex(elStart) {
  let el = elStart;
  let maxIndex = 0;
  while (el !== null && el !== document) {
    const { position: position2, zIndex } = window.getComputedStyle(el);
    const zIndexNum = Number(zIndex);
    if (zIndexNum > maxIndex && (el === elStart || zIndexPositions.includes(position2) === true)) {
      maxIndex = zIndexNum;
    }
    el = el.parentNode;
  }
  return maxIndex;
}
function normalizeElements(opts) {
  return {
    from: opts.from,
    to: opts.to !== void 0 ? opts.to : opts.from
  };
}
function normalizeOptions(options) {
  if (typeof options === "number") {
    options = {
      duration: options
    };
  } else if (typeof options === "function") {
    options = {
      onEnd: options
    };
  }
  return {
    ...options,
    waitFor: options.waitFor === void 0 ? 0 : options.waitFor,
    duration: isNaN(options.duration) === true ? 300 : parseInt(options.duration, 10),
    easing: typeof options.easing === "string" && options.easing.length !== 0 ? options.easing : "ease-in-out",
    delay: isNaN(options.delay) === true ? 0 : parseInt(options.delay, 10),
    fill: typeof options.fill === "string" && options.fill.length !== 0 ? options.fill : "none",
    resize: options.resize === true,
    // account for UMD too where modifiers will be lowercased to work
    useCSS: options.useCSS === true || options.usecss === true,
    // account for UMD too where modifiers will be lowercased to work
    hideFromClone: options.hideFromClone === true || options.hidefromclone === true,
    // account for UMD too where modifiers will be lowercased to work
    keepToClone: options.keepToClone === true || options.keeptoclone === true,
    tween: options.tween === true,
    tweenFromOpacity: isNaN(options.tweenFromOpacity) === true ? 0.6 : parseFloat(options.tweenFromOpacity),
    tweenToOpacity: isNaN(options.tweenToOpacity) === true ? 0.5 : parseFloat(options.tweenToOpacity)
  };
}
function getElement2(element) {
  const type2 = typeof element;
  return type2 === "function" ? element() : type2 === "string" ? document.querySelector(element) : element;
}
function isValidElement(element) {
  return element && element.ownerDocument === document && element.parentNode !== null;
}
function morph(_options) {
  let cancel = () => false;
  let cancelStatus = false;
  let endElementTo = true;
  const elements = normalizeElements(_options);
  const options = normalizeOptions(_options);
  const elFrom = getElement2(elements.from);
  if (isValidElement(elFrom) !== true) {
    return cancel;
  }
  typeof elFrom.qMorphCancel === "function" && elFrom.qMorphCancel();
  let animationFromClone = void 0;
  let animationFromTween = void 0;
  let animationToClone = void 0;
  let animationTo = void 0;
  const elFromParent = elFrom.parentNode;
  const elFromNext = elFrom.nextElementSibling;
  const elFromPosition = getAbsolutePosition(elFrom, options.resize);
  const {
    width: elFromParentWidthBefore,
    height: elFromParentHeightBefore
  } = getAbsoluteSize(elFromParent);
  const {
    borderWidth: elFromBorderWidth,
    borderStyle: elFromBorderStyle,
    borderColor: elFromBorderColor,
    borderRadius: elFromBorderRadius,
    backgroundColor: elFromBackground,
    transform: elFromTransform,
    position: elFromPositioningType,
    cssText: elFromCssText
  } = getComputedStyle2(elFrom, ["borderWidth", "borderStyle", "borderColor", "borderRadius", "backgroundColor", "transform", "position", "cssText"]);
  const elFromClassSaved = elFrom.classList.toString();
  const elFromStyleSaved = elFrom.style.cssText;
  const elFromClone = elFrom.cloneNode(true);
  const elFromTween = options.tween === true ? elFrom.cloneNode(true) : void 0;
  if (elFromTween !== void 0) {
    elFromTween.className = elFromTween.classList.toString().split(" ").filter((c3) => /^bg-/.test(c3) === false).join(" ");
  }
  options.hideFromClone === true && elFromClone.classList.add("q-morph--internal");
  elFromClone.setAttribute("aria-hidden", "true");
  elFromClone.style.transition = "none";
  elFromClone.style.animation = "none";
  elFromClone.style.pointerEvents = "none";
  elFromParent.insertBefore(elFromClone, elFromNext);
  elFrom.qMorphCancel = () => {
    cancelStatus = true;
    elFromClone.remove();
    elFromTween == null ? void 0 : elFromTween.remove();
    options.hideFromClone === true && elFromClone.classList.remove("q-morph--internal");
    elFrom.qMorphCancel = void 0;
  };
  const calculateFinalState = () => {
    const elTo = getElement2(elements.to);
    if (cancelStatus === true || isValidElement(elTo) !== true) {
      typeof elFrom.qMorphCancel === "function" && elFrom.qMorphCancel();
      return;
    }
    elFrom !== elTo && typeof elTo.qMorphCancel === "function" && elTo.qMorphCancel();
    options.keepToClone !== true && elTo.classList.add("q-morph--internal");
    elFromClone.classList.add("q-morph--internal");
    const {
      width: elFromParentWidthAfter,
      height: elFromParentHeightAfter
    } = getAbsoluteSize(elFromParent);
    const {
      width: elToParentWidthBefore,
      height: elToParentHeightBefore
    } = getAbsoluteSize(elTo.parentNode);
    options.hideFromClone !== true && elFromClone.classList.remove("q-morph--internal");
    elTo.qMorphCancel = () => {
      cancelStatus = true;
      elFromClone.remove();
      elFromTween == null ? void 0 : elFromTween.remove();
      options.hideFromClone === true && elFromClone.classList.remove("q-morph--internal");
      options.keepToClone !== true && elTo.classList.remove("q-morph--internal");
      elFrom.qMorphCancel = void 0;
      elTo.qMorphCancel = void 0;
    };
    const animate = () => {
      if (cancelStatus === true) {
        typeof elTo.qMorphCancel === "function" && elTo.qMorphCancel();
        return;
      }
      if (options.hideFromClone !== true) {
        elFromClone.classList.add("q-morph--internal");
        elFromClone.innerHTML = "";
        elFromClone.style.left = 0;
        elFromClone.style.right = "unset";
        elFromClone.style.top = 0;
        elFromClone.style.bottom = "unset";
        elFromClone.style.transform = "none";
      }
      if (options.keepToClone !== true) {
        elTo.classList.remove("q-morph--internal");
      }
      const elToParent = elTo.parentNode;
      const {
        width: elToParentWidthAfter,
        height: elToParentHeightAfter
      } = getAbsoluteSize(elToParent);
      const elToClone = elTo.cloneNode(options.keepToClone);
      elToClone.setAttribute("aria-hidden", "true");
      if (options.keepToClone !== true) {
        elToClone.style.left = 0;
        elToClone.style.right = "unset";
        elToClone.style.top = 0;
        elToClone.style.bottom = "unset";
        elToClone.style.transform = "none";
        elToClone.style.pointerEvents = "none";
      }
      elToClone.classList.add("q-morph--internal");
      const elToNext = elTo === elFrom && elFromParent === elToParent ? elFromClone : elTo.nextElementSibling;
      elToParent.insertBefore(elToClone, elToNext);
      const {
        borderWidth: elToBorderWidth,
        borderStyle: elToBorderStyle,
        borderColor: elToBorderColor,
        borderRadius: elToBorderRadius,
        backgroundColor: elToBackground,
        transform: elToTransform,
        position: elToPositioningType,
        cssText: elToCssText
      } = getComputedStyle2(elTo, ["borderWidth", "borderStyle", "borderColor", "borderRadius", "backgroundColor", "transform", "position", "cssText"]);
      const elToClassSaved = elTo.classList.toString();
      const elToStyleSaved = elTo.style.cssText;
      elTo.style.cssText = elToCssText;
      elTo.style.transform = "none";
      elTo.style.animation = "none";
      elTo.style.transition = "none";
      elTo.className = elToClassSaved.split(" ").filter((c3) => /^bg-/.test(c3) === false).join(" ");
      const elToPosition = getAbsolutePosition(elTo, options.resize);
      const deltaX = elFromPosition.left - elToPosition.left;
      const deltaY = elFromPosition.top - elToPosition.top;
      const scaleX = elFromPosition.width / (elToPosition.width > 0 ? elToPosition.width : 10);
      const scaleY = elFromPosition.height / (elToPosition.height > 0 ? elToPosition.height : 100);
      const elFromParentWidthDiff = elFromParentWidthBefore - elFromParentWidthAfter;
      const elFromParentHeightDiff = elFromParentHeightBefore - elFromParentHeightAfter;
      const elToParentWidthDiff = elToParentWidthAfter - elToParentWidthBefore;
      const elToParentHeightDiff = elToParentHeightAfter - elToParentHeightBefore;
      const elFromCloneWidth = Math.max(elFromPosition.widthM, elFromParentWidthDiff);
      const elFromCloneHeight = Math.max(elFromPosition.heightM, elFromParentHeightDiff);
      const elToCloneWidth = Math.max(elToPosition.widthM, elToParentWidthDiff);
      const elToCloneHeight = Math.max(elToPosition.heightM, elToParentHeightDiff);
      const elSharedSize = elFrom === elTo && ["absolute", "fixed"].includes(elToPositioningType) === false && ["absolute", "fixed"].includes(elFromPositioningType) === false;
      let elToNeedsFixedPosition = elToPositioningType === "fixed";
      let parent = elToParent;
      while (elToNeedsFixedPosition !== true && parent !== document) {
        elToNeedsFixedPosition = window.getComputedStyle(parent).position === "fixed";
        parent = parent.parentNode;
      }
      if (options.hideFromClone !== true) {
        elFromClone.style.display = "block";
        elFromClone.style.flex = "0 0 auto";
        elFromClone.style.opacity = 0;
        elFromClone.style.minWidth = "unset";
        elFromClone.style.maxWidth = "unset";
        elFromClone.style.minHeight = "unset";
        elFromClone.style.maxHeight = "unset";
        elFromClone.classList.remove("q-morph--internal");
      }
      if (options.keepToClone !== true) {
        elToClone.style.display = "block";
        elToClone.style.flex = "0 0 auto";
        elToClone.style.opacity = 0;
        elToClone.style.minWidth = "unset";
        elToClone.style.maxWidth = "unset";
        elToClone.style.minHeight = "unset";
        elToClone.style.maxHeight = "unset";
      }
      elToClone.classList.remove("q-morph--internal");
      if (typeof options.classes === "string") {
        elTo.className += " " + options.classes;
      }
      if (typeof options.style === "string") {
        elTo.style.cssText += " " + options.style;
      } else if (isObject(options.style) === true) {
        for (const prop in options.style) {
          elTo.style[prop] = options.style[prop];
        }
      }
      const elFromZIndex = getMaxZIndex(elFromClone);
      const elToZIndex = getMaxZIndex(elTo);
      const documentScroll = elToNeedsFixedPosition === true ? document.documentElement : { scrollLeft: 0, scrollTop: 0 };
      elTo.style.position = elToNeedsFixedPosition === true ? "fixed" : "absolute";
      elTo.style.left = `${elToPosition.left - documentScroll.scrollLeft}px`;
      elTo.style.right = "unset";
      elTo.style.top = `${elToPosition.top - documentScroll.scrollTop}px`;
      elTo.style.margin = 0;
      if (options.resize === true) {
        elTo.style.minWidth = "unset";
        elTo.style.maxWidth = "unset";
        elTo.style.minHeight = "unset";
        elTo.style.maxHeight = "unset";
        elTo.style.overflow = "hidden";
        elTo.style.overflowX = "hidden";
        elTo.style.overflowY = "hidden";
      }
      document.body.appendChild(elTo);
      if (elFromTween !== void 0) {
        elFromTween.style.cssText = elFromCssText;
        elFromTween.style.transform = "none";
        elFromTween.style.animation = "none";
        elFromTween.style.transition = "none";
        elFromTween.style.position = elTo.style.position;
        elFromTween.style.left = `${elFromPosition.left - documentScroll.scrollLeft}px`;
        elFromTween.style.right = "unset";
        elFromTween.style.top = `${elFromPosition.top - documentScroll.scrollTop}px`;
        elFromTween.style.margin = 0;
        elFromTween.style.pointerEvents = "none";
        if (options.resize === true) {
          elFromTween.style.minWidth = "unset";
          elFromTween.style.maxWidth = "unset";
          elFromTween.style.minHeight = "unset";
          elFromTween.style.maxHeight = "unset";
          elFromTween.style.overflow = "hidden";
          elFromTween.style.overflowX = "hidden";
          elFromTween.style.overflowY = "hidden";
        }
        document.body.appendChild(elFromTween);
      }
      const commonCleanup = (aborted) => {
        if (elFrom === elTo && endElementTo !== true) {
          elTo.style.cssText = elFromStyleSaved;
          elTo.className = elFromClassSaved;
        } else {
          elTo.style.cssText = elToStyleSaved;
          elTo.className = elToClassSaved;
        }
        if (elToClone.parentNode === elToParent) {
          elToParent.insertBefore(elTo, elToClone);
        }
        elFromClone.remove();
        elToClone.remove();
        elFromTween == null ? void 0 : elFromTween.remove();
        cancel = () => false;
        elFrom.qMorphCancel = void 0;
        elTo.qMorphCancel = void 0;
        if (typeof options.onEnd === "function") {
          options.onEnd(endElementTo === true ? "to" : "from", aborted === true);
        }
      };
      if (options.useCSS !== true && typeof elTo.animate === "function") {
        const resizeFrom = options.resize === true ? {
          transform: `translate(${deltaX}px, ${deltaY}px)`,
          width: `${elFromCloneWidth}px`,
          height: `${elFromCloneHeight}px`
        } : {
          transform: `translate(${deltaX}px, ${deltaY}px) scale(${scaleX}, ${scaleY})`
        };
        const resizeTo = options.resize === true ? {
          width: `${elToCloneWidth}px`,
          height: `${elToCloneHeight}px`
        } : {};
        const resizeFromTween = options.resize === true ? {
          width: `${elFromCloneWidth}px`,
          height: `${elFromCloneHeight}px`
        } : {};
        const resizeToTween = options.resize === true ? {
          transform: `translate(${-1 * deltaX}px, ${-1 * deltaY}px)`,
          width: `${elToCloneWidth}px`,
          height: `${elToCloneHeight}px`
        } : {
          transform: `translate(${-1 * deltaX}px, ${-1 * deltaY}px) scale(${1 / scaleX}, ${1 / scaleY})`
        };
        const tweenFrom = elFromTween !== void 0 ? { opacity: options.tweenToOpacity } : { backgroundColor: elFromBackground };
        const tweenTo = elFromTween !== void 0 ? { opacity: 1 } : { backgroundColor: elToBackground };
        animationTo = elTo.animate([
          {
            margin: 0,
            borderWidth: elFromBorderWidth,
            borderStyle: elFromBorderStyle,
            borderColor: elFromBorderColor,
            borderRadius: elFromBorderRadius,
            zIndex: elFromZIndex,
            transformOrigin: "0 0",
            ...resizeFrom,
            ...tweenFrom
          },
          {
            margin: 0,
            borderWidth: elToBorderWidth,
            borderStyle: elToBorderStyle,
            borderColor: elToBorderColor,
            borderRadius: elToBorderRadius,
            zIndex: elToZIndex,
            transformOrigin: "0 0",
            transform: elToTransform,
            ...resizeTo,
            ...tweenTo
          }
        ], {
          duration: options.duration,
          easing: options.easing,
          fill: options.fill,
          delay: options.delay
        });
        animationFromTween = elFromTween === void 0 ? void 0 : elFromTween.animate([
          {
            opacity: options.tweenFromOpacity,
            margin: 0,
            borderWidth: elFromBorderWidth,
            borderStyle: elFromBorderStyle,
            borderColor: elFromBorderColor,
            borderRadius: elFromBorderRadius,
            zIndex: elFromZIndex,
            transformOrigin: "0 0",
            transform: elFromTransform,
            ...resizeFromTween
          },
          {
            opacity: 0,
            margin: 0,
            borderWidth: elToBorderWidth,
            borderStyle: elToBorderStyle,
            borderColor: elToBorderColor,
            borderRadius: elToBorderRadius,
            zIndex: elToZIndex,
            transformOrigin: "0 0",
            ...resizeToTween
          }
        ], {
          duration: options.duration,
          easing: options.easing,
          fill: options.fill,
          delay: options.delay
        });
        animationFromClone = options.hideFromClone === true || elSharedSize === true ? void 0 : elFromClone.animate([
          {
            margin: `${elFromParentHeightDiff < 0 ? elFromParentHeightDiff / 2 : 0}px ${elFromParentWidthDiff < 0 ? elFromParentWidthDiff / 2 : 0}px`,
            width: `${elFromCloneWidth + elFromPosition.marginH}px`,
            height: `${elFromCloneHeight + elFromPosition.marginV}px`
          },
          {
            margin: 0,
            width: 0,
            height: 0
          }
        ], {
          duration: options.duration,
          easing: options.easing,
          fill: options.fill,
          delay: options.delay
        });
        animationToClone = options.keepToClone === true ? void 0 : elToClone.animate([
          elSharedSize === true ? {
            margin: `${elFromParentHeightDiff < 0 ? elFromParentHeightDiff / 2 : 0}px ${elFromParentWidthDiff < 0 ? elFromParentWidthDiff / 2 : 0}px`,
            width: `${elFromCloneWidth + elFromPosition.marginH}px`,
            height: `${elFromCloneHeight + elFromPosition.marginV}px`
          } : {
            margin: 0,
            width: 0,
            height: 0
          },
          {
            margin: `${elToParentHeightDiff < 0 ? elToParentHeightDiff / 2 : 0}px ${elToParentWidthDiff < 0 ? elToParentWidthDiff / 2 : 0}px`,
            width: `${elToCloneWidth + elToPosition.marginH}px`,
            height: `${elToCloneHeight + elToPosition.marginV}px`
          }
        ], {
          duration: options.duration,
          easing: options.easing,
          fill: options.fill,
          delay: options.delay
        });
        const cleanup = (abort) => {
          animationFromClone == null ? void 0 : animationFromClone.cancel();
          animationFromTween == null ? void 0 : animationFromTween.cancel();
          animationToClone == null ? void 0 : animationToClone.cancel();
          animationTo.cancel();
          animationTo.removeEventListener("finish", cleanup);
          animationTo.removeEventListener("cancel", cleanup);
          commonCleanup(abort);
          animationFromClone = void 0;
          animationFromTween = void 0;
          animationToClone = void 0;
          animationTo = void 0;
        };
        elFrom.qMorphCancel = () => {
          elFrom.qMorphCancel = void 0;
          cancelStatus = true;
          cleanup();
        };
        elTo.qMorphCancel = () => {
          elTo.qMorphCancel = void 0;
          cancelStatus = true;
          cleanup();
        };
        animationTo.addEventListener("finish", cleanup);
        animationTo.addEventListener("cancel", cleanup);
        cancel = (abort) => {
          if (cancelStatus === true || animationTo === void 0) {
            return false;
          }
          if (abort === true) {
            cleanup(true);
            return true;
          }
          endElementTo = endElementTo !== true;
          animationFromClone == null ? void 0 : animationFromClone.reverse();
          animationFromTween == null ? void 0 : animationFromTween.reverse();
          animationToClone == null ? void 0 : animationToClone.reverse();
          animationTo.reverse();
          return true;
        };
      } else {
        const qAnimId = `q-morph-anim-${++id2}`;
        const style2 = document.createElement("style");
        const resizeFrom = options.resize === true ? `
            transform: translate(${deltaX}px, ${deltaY}px);
            width: ${elFromCloneWidth}px;
            height: ${elFromCloneHeight}px;
          ` : `transform: translate(${deltaX}px, ${deltaY}px) scale(${scaleX}, ${scaleY});`;
        const resizeTo = options.resize === true ? `
            width: ${elToCloneWidth}px;
            height: ${elToCloneHeight}px;
          ` : "";
        const resizeFromTween = options.resize === true ? `
            width: ${elFromCloneWidth}px;
            height: ${elFromCloneHeight}px;
          ` : "";
        const resizeToTween = options.resize === true ? `
            transform: translate(${-1 * deltaX}px, ${-1 * deltaY}px);
            width: ${elToCloneWidth}px;
            height: ${elToCloneHeight}px;
          ` : `transform: translate(${-1 * deltaX}px, ${-1 * deltaY}px) scale(${1 / scaleX}, ${1 / scaleY});`;
        const tweenFrom = elFromTween !== void 0 ? `opacity: ${options.tweenToOpacity};` : `background-color: ${elFromBackground};`;
        const tweenTo = elFromTween !== void 0 ? "opacity: 1;" : `background-color: ${elToBackground};`;
        const keyframesFromTween = elFromTween === void 0 ? "" : `
            @keyframes ${qAnimId}-from-tween {
              0% {
                opacity: ${options.tweenFromOpacity};
                margin: 0;
                border-width: ${elFromBorderWidth};
                border-style: ${elFromBorderStyle};
                border-color: ${elFromBorderColor};
                border-radius: ${elFromBorderRadius};
                z-index: ${elFromZIndex};
                transform-origin: 0 0;
                transform: ${elFromTransform};
                ${resizeFromTween}
              }

              100% {
                opacity: 0;
                margin: 0;
                border-width: ${elToBorderWidth};
                border-style: ${elToBorderStyle};
                border-color: ${elToBorderColor};
                border-radius: ${elToBorderRadius};
                z-index: ${elToZIndex};
                transform-origin: 0 0;
                ${resizeToTween}
              }
            }
          `;
        const keyframesFrom = options.hideFromClone === true || elSharedSize === true ? "" : `
            @keyframes ${qAnimId}-from {
              0% {
                margin: ${elFromParentHeightDiff < 0 ? elFromParentHeightDiff / 2 : 0}px ${elFromParentWidthDiff < 0 ? elFromParentWidthDiff / 2 : 0}px;
                width: ${elFromCloneWidth + elFromPosition.marginH}px;
                height: ${elFromCloneHeight + elFromPosition.marginV}px;
              }

              100% {
                margin: 0;
                width: 0;
                height: 0;
              }
            }
          `;
        const keyframeToStart = elSharedSize === true ? `
            margin: ${elFromParentHeightDiff < 0 ? elFromParentHeightDiff / 2 : 0}px ${elFromParentWidthDiff < 0 ? elFromParentWidthDiff / 2 : 0}px;
            width: ${elFromCloneWidth + elFromPosition.marginH}px;
            height: ${elFromCloneHeight + elFromPosition.marginV}px;
          ` : `
            margin: 0;
            width: 0;
            height: 0;
          `;
        const keyframesTo = options.keepToClone === true ? "" : `
            @keyframes ${qAnimId}-to {
              0% {
                ${keyframeToStart}
              }

              100% {
                margin: ${elToParentHeightDiff < 0 ? elToParentHeightDiff / 2 : 0}px ${elToParentWidthDiff < 0 ? elToParentWidthDiff / 2 : 0}px;
                width: ${elToCloneWidth + elToPosition.marginH}px;
                height: ${elToCloneHeight + elToPosition.marginV}px;
              }
            }
          `;
        style2.innerHTML = `
          @keyframes ${qAnimId} {
            0% {
              margin: 0;
              border-width: ${elFromBorderWidth};
              border-style: ${elFromBorderStyle};
              border-color: ${elFromBorderColor};
              border-radius: ${elFromBorderRadius};
              background-color: ${elFromBackground};
              z-index: ${elFromZIndex};
              transform-origin: 0 0;
              ${resizeFrom}
              ${tweenFrom}
            }

            100% {
              margin: 0;
              border-width: ${elToBorderWidth};
              border-style: ${elToBorderStyle};
              border-color: ${elToBorderColor};
              border-radius: ${elToBorderRadius};
              background-color: ${elToBackground};
              z-index: ${elToZIndex};
              transform-origin: 0 0;
              transform: ${elToTransform};
              ${resizeTo}
              ${tweenTo}
            }
          }

          ${keyframesFrom}

          ${keyframesFromTween}

          ${keyframesTo}
        `;
        document.head.appendChild(style2);
        let animationDirection = "normal";
        elFromClone.style.animation = `${options.duration}ms ${options.easing} ${options.delay}ms ${animationDirection} ${options.fill} ${qAnimId}-from`;
        if (elFromTween !== void 0) {
          elFromTween.style.animation = `${options.duration}ms ${options.easing} ${options.delay}ms ${animationDirection} ${options.fill} ${qAnimId}-from-tween`;
        }
        elToClone.style.animation = `${options.duration}ms ${options.easing} ${options.delay}ms ${animationDirection} ${options.fill} ${qAnimId}-to`;
        elTo.style.animation = `${options.duration}ms ${options.easing} ${options.delay}ms ${animationDirection} ${options.fill} ${qAnimId}`;
        const cleanup = (evt) => {
          if (evt === Object(evt) && evt.animationName !== qAnimId) return;
          elTo.removeEventListener("animationend", cleanup);
          elTo.removeEventListener("animationcancel", cleanup);
          commonCleanup();
          style2.remove();
        };
        elFrom.qMorphCancel = () => {
          elFrom.qMorphCancel = void 0;
          cancelStatus = true;
          cleanup();
        };
        elTo.qMorphCancel = () => {
          elTo.qMorphCancel = void 0;
          cancelStatus = true;
          cleanup();
        };
        elTo.addEventListener("animationend", cleanup);
        elTo.addEventListener("animationcancel", cleanup);
        cancel = (abort) => {
          if (cancelStatus === true || !elTo || !elFromClone || !elToClone) {
            return false;
          }
          if (abort === true) {
            cleanup();
            return true;
          }
          endElementTo = endElementTo !== true;
          animationDirection = animationDirection === "normal" ? "reverse" : "normal";
          elFromClone.style.animationDirection = animationDirection;
          elFromTween.style.animationDirection = animationDirection;
          elToClone.style.animationDirection = animationDirection;
          elTo.style.animationDirection = animationDirection;
          return true;
        };
      }
    };
    if (options.waitFor > 0 || options.waitFor === "transitionend" || options.waitFor === Object(options.waitFor) && typeof options.waitFor.then === "function") {
      const delayPromise = options.waitFor > 0 ? new Promise((resolve2) => setTimeout(resolve2, options.waitFor)) : options.waitFor === "transitionend" ? new Promise((resolve2) => {
        const endFn = () => {
          if (timer2 !== null) {
            clearTimeout(timer2);
            timer2 = null;
          }
          if (elTo) {
            elTo.removeEventListener("transitionend", endFn);
            elTo.removeEventListener("transitioncancel", endFn);
          }
          resolve2();
        };
        let timer2 = setTimeout(endFn, 400);
        elTo.addEventListener("transitionend", endFn);
        elTo.addEventListener("transitioncancel", endFn);
      }) : options.waitFor;
      delayPromise.then(animate).catch(() => {
        typeof elTo.qMorphCancel === "function" && elTo.qMorphCancel();
      });
    } else {
      animate();
    }
  };
  typeof _options.onToggle === "function" && _options.onToggle();
  requestAnimationFrame(calculateFinalState);
  return (abort) => cancel(abort);
}
var morphGroups = {};
var props2 = [
  "duration",
  "delay",
  "easing",
  "fill",
  "classes",
  "style",
  "duration",
  "resize",
  "useCSS",
  "hideFromClone",
  "keepToClone",
  "tween",
  "tweenFromOpacity",
  "tweenToOpacity",
  "waitFor",
  "onEnd"
];
var mods = [
  "resize",
  "useCSS",
  "hideFromClone",
  "keepToClone",
  "tween"
];
function changeClass(ctx, action) {
  if (ctx.clsAction !== action) {
    ctx.clsAction = action;
    ctx.el.classList[action]("q-morph--invisible");
  }
}
function trigger2(group) {
  if (group.animating === true || group.queue.length < 2) return;
  const [from2, to2] = group.queue;
  group.animating = true;
  from2.animating = true;
  to2.animating = true;
  changeClass(from2, "remove");
  changeClass(to2, "remove");
  const cancelFn = morph({
    from: from2.el,
    to: to2.el,
    onToggle() {
      changeClass(from2, "add");
      changeClass(to2, "remove");
    },
    ...to2.opts,
    onEnd(dir, aborted) {
      var _a, _b;
      (_b = (_a = to2.opts).onEnd) == null ? void 0 : _b.call(_a, dir, aborted);
      if (aborted === true) return;
      from2.animating = false;
      to2.animating = false;
      group.animating = false;
      group.cancel = void 0;
      group.queue.shift();
      trigger2(group);
    }
  });
  group.cancel = () => {
    cancelFn(true);
    group.cancel = void 0;
  };
}
function updateModifiers2(mod2, ctx) {
  const opts = ctx.opts;
  mods.forEach((name2) => {
    opts[name2] = mod2[name2] === true;
  });
}
function insertArgs(arg, ctx) {
  const opts = typeof arg === "string" && arg.length !== 0 ? arg.split(":") : [];
  ctx.name = opts[0];
  ctx.group = opts[1];
  Object.assign(ctx.opts, {
    duration: isNaN(opts[2]) === true ? 300 : parseFloat(opts[2]),
    waitFor: opts[3]
  });
}
function updateArgs(arg, ctx) {
  if (arg.group !== void 0) {
    ctx.group = arg.group;
  }
  if (arg.name !== void 0) {
    ctx.name = arg.name;
  }
  const opts = ctx.opts;
  props2.forEach((name2) => {
    if (arg[name2] !== void 0) {
      opts[name2] = arg[name2];
    }
  });
}
function updateModel(name2, ctx) {
  if (ctx.name === name2) {
    const group = morphGroups[ctx.group];
    if (group === void 0) {
      morphGroups[ctx.group] = {
        name: ctx.group,
        model: name2,
        queue: [ctx],
        animating: false
      };
      changeClass(ctx, "remove");
    } else if (group.model !== name2) {
      group.model = name2;
      group.queue.push(ctx);
      if (group.animating === false && group.queue.length === 2) {
        trigger2(group);
      }
    }
    return;
  }
  if (ctx.animating === false) {
    changeClass(ctx, "add");
  }
}
function updateValue(ctx, value2) {
  let model;
  if (Object(value2) === value2) {
    model = "" + value2.model;
    updateArgs(value2, ctx);
    updateModifiers2(value2, ctx);
  } else {
    model = "" + value2;
  }
  if (model !== ctx.model) {
    ctx.model = model;
    updateModel(model, ctx);
  } else if (ctx.animating === false && ctx.clsAction !== void 0) {
    ctx.el.classList[ctx.clsAction]("q-morph--invisible");
  }
}
createDirective(
  {
    name: "morph",
    mounted(el, binding) {
      const ctx = {
        el,
        animating: false,
        opts: {}
      };
      updateModifiers2(binding.modifiers, ctx);
      insertArgs(binding.arg, ctx);
      updateValue(ctx, binding.value);
      el.__qmorph = ctx;
    },
    updated(el, binding) {
      updateValue(el.__qmorph, binding.value);
    },
    beforeUnmount(el) {
      var _a;
      const ctx = el.__qmorph;
      const group = morphGroups[ctx.group];
      if (group !== void 0) {
        const index2 = group.queue.indexOf(ctx);
        if (index2 !== -1) {
          group.queue = group.queue.filter((item) => item !== ctx);
          if (group.queue.length === 0) {
            (_a = group.cancel) == null ? void 0 : _a.call(group);
            delete morphGroups[ctx.group];
          }
        }
      }
      if (ctx.clsAction === "add") {
        el.classList.remove("q-morph--invisible");
      }
      delete el.__qmorph;
    }
  }
);
var defaultCfg2 = {
  childList: true,
  subtree: true,
  attributes: true,
  characterData: true,
  attributeOldValue: true,
  characterDataOldValue: true
};
function update3(el, ctx, value2) {
  var _a;
  ctx.handler = value2;
  (_a = ctx.observer) == null ? void 0 : _a.disconnect();
  ctx.observer = new MutationObserver((list) => {
    if (typeof ctx.handler === "function") {
      const res = ctx.handler(list);
      if (res === false || ctx.once === true) {
        destroy2(el);
      }
    }
  });
  ctx.observer.observe(el, ctx.opts);
}
function destroy2(el) {
  var _a;
  const ctx = el.__qmutation;
  if (ctx !== void 0) {
    (_a = ctx.observer) == null ? void 0 : _a.disconnect();
    delete el.__qmutation;
  }
}
createDirective(
  {
    name: "mutation",
    mounted(el, { modifiers: { once, ...mod2 }, value: value2 }) {
      const ctx = {
        once,
        opts: Object.keys(mod2).length === 0 ? defaultCfg2 : mod2
      };
      update3(el, ctx, value2);
      el.__qmutation = ctx;
    },
    updated(el, { oldValue, value: value2 }) {
      const ctx = el.__qmutation;
      if (ctx !== void 0 && oldValue !== value2) {
        update3(el, ctx, value2);
      }
    },
    beforeUnmount: destroy2
  }
);
var { passive: passive5 } = listenOpts;
function update4(ctx, { value: value2, oldValue }) {
  if (typeof value2 !== "function") {
    ctx.scrollTarget.removeEventListener("scroll", ctx.scroll, passive5);
    return;
  }
  ctx.handler = value2;
  if (typeof oldValue !== "function") {
    ctx.scrollTarget.addEventListener("scroll", ctx.scroll, passive5);
    ctx.scroll();
  }
}
createDirective(
  {
    name: "scroll-fire",
    mounted(el, binding) {
      const ctx = {
        scrollTarget: getScrollTarget(el),
        scroll: debounce_default(() => {
          let containerBottom, elBottom;
          if (ctx.scrollTarget === window) {
            elBottom = el.getBoundingClientRect().bottom;
            containerBottom = window.innerHeight;
          } else {
            elBottom = offset(el).top + height(el);
            containerBottom = offset(ctx.scrollTarget).top + height(ctx.scrollTarget);
          }
          if (elBottom > 0 && elBottom < containerBottom) {
            ctx.scrollTarget.removeEventListener("scroll", ctx.scroll, passive5);
            ctx.handler(el);
          }
        }, 25)
      };
      update4(ctx, binding);
      el.__qscrollfire = ctx;
    },
    updated(el, binding) {
      if (binding.value !== binding.oldValue) {
        update4(el.__qscrollfire, binding);
      }
    },
    beforeUnmount(el) {
      const ctx = el.__qscrollfire;
      ctx.scrollTarget.removeEventListener("scroll", ctx.scroll, passive5);
      ctx.scroll.cancel();
      delete el.__qscrollfire;
    }
  }
);
function update5(ctx, { value: value2, oldValue }) {
  if (typeof value2 !== "function") {
    ctx.scrollTarget.removeEventListener("scroll", ctx.scroll, listenOpts.passive);
    return;
  }
  ctx.handler = value2;
  if (typeof oldValue !== "function") {
    ctx.scrollTarget.addEventListener("scroll", ctx.scroll, listenOpts.passive);
  }
}
createDirective(
  {
    name: "scroll",
    mounted(el, binding) {
      const ctx = {
        scrollTarget: getScrollTarget(el),
        scroll() {
          ctx.handler(
            getVerticalScrollPosition(ctx.scrollTarget),
            getHorizontalScrollPosition(ctx.scrollTarget)
          );
        }
      };
      update5(ctx, binding);
      el.__qscroll = ctx;
    },
    updated(el, binding) {
      if (el.__qscroll !== void 0 && binding.oldValue !== binding.value) {
        update5(el.__qscroll, binding);
      }
    },
    beforeUnmount(el) {
      const ctx = el.__qscroll;
      ctx.scrollTarget.removeEventListener("scroll", ctx.scroll, listenOpts.passive);
      delete el.__qscroll;
    }
  }
);
createDirective(
  {
    name: "touch-hold",
    beforeMount(el, binding) {
      const { modifiers } = binding;
      if (modifiers.mouse !== true && client.has.touch !== true) return;
      const ctx = {
        handler: binding.value,
        noop,
        mouseStart(evt) {
          if (typeof ctx.handler === "function" && leftClick(evt) === true) {
            addEvt(ctx, "temp", [
              [document, "mousemove", "move", "passiveCapture"],
              [document, "click", "end", "notPassiveCapture"]
            ]);
            ctx.start(evt, true);
          }
        },
        touchStart(evt) {
          if (evt.target !== void 0 && typeof ctx.handler === "function") {
            const target2 = evt.target;
            addEvt(ctx, "temp", [
              [target2, "touchmove", "move", "passiveCapture"],
              [target2, "touchcancel", "end", "notPassiveCapture"],
              [target2, "touchend", "end", "notPassiveCapture"]
            ]);
            ctx.start(evt);
          }
        },
        start(evt, mouseEvent) {
          ctx.origin = position(evt);
          const startTime = Date.now();
          if (client.is.mobile === true) {
            document.body.classList.add("non-selectable");
            clearSelection();
            ctx.styleCleanup = (withDelay) => {
              ctx.styleCleanup = void 0;
              const remove2 = () => {
                document.body.classList.remove("non-selectable");
              };
              if (withDelay === true) {
                clearSelection();
                setTimeout(remove2, 10);
              } else {
                remove2();
              }
            };
          }
          ctx.triggered = false;
          ctx.sensitivity = mouseEvent === true ? ctx.mouseSensitivity : ctx.touchSensitivity;
          ctx.timer = setTimeout(() => {
            ctx.timer = void 0;
            clearSelection();
            ctx.triggered = true;
            ctx.handler({
              evt,
              touch: mouseEvent !== true,
              mouse: mouseEvent === true,
              position: ctx.origin,
              duration: Date.now() - startTime
            });
          }, ctx.duration);
        },
        move(evt) {
          const { top, left } = position(evt);
          if (ctx.timer !== void 0 && (Math.abs(left - ctx.origin.left) >= ctx.sensitivity || Math.abs(top - ctx.origin.top) >= ctx.sensitivity)) {
            clearTimeout(ctx.timer);
            ctx.timer = void 0;
          }
        },
        end(evt) {
          var _a;
          cleanEvt(ctx, "temp");
          (_a = ctx.styleCleanup) == null ? void 0 : _a.call(ctx, ctx.triggered);
          if (ctx.triggered === true) {
            evt !== void 0 && stopAndPrevent(evt);
          } else if (ctx.timer !== void 0) {
            clearTimeout(ctx.timer);
            ctx.timer = void 0;
          }
        }
      };
      const data = [600, 5, 7];
      if (typeof binding.arg === "string" && binding.arg.length !== 0) {
        binding.arg.split(":").forEach((val, index2) => {
          const v = parseInt(val, 10);
          v && (data[index2] = v);
        });
      }
      [ctx.duration, ctx.touchSensitivity, ctx.mouseSensitivity] = data;
      el.__qtouchhold = ctx;
      if (modifiers.mouse === true) {
        const capture = modifiers.mouseCapture === true || modifiers.mousecapture === true ? "Capture" : "";
        addEvt(ctx, "main", [
          [el, "mousedown", "mouseStart", `passive${capture}`]
        ]);
      }
      client.has.touch === true && addEvt(ctx, "main", [
        [el, "touchstart", "touchStart", `passive${modifiers.capture === true ? "Capture" : ""}`],
        [el, "touchend", "noop", "notPassiveCapture"]
      ]);
    },
    updated(el, binding) {
      const ctx = el.__qtouchhold;
      if (ctx !== void 0 && binding.oldValue !== binding.value) {
        typeof binding.value !== "function" && ctx.end();
        ctx.handler = binding.value;
      }
    },
    beforeUnmount(el) {
      var _a;
      const ctx = el.__qtouchhold;
      if (ctx !== void 0) {
        cleanEvt(ctx, "main");
        cleanEvt(ctx, "temp");
        ctx.timer !== void 0 && clearTimeout(ctx.timer);
        (_a = ctx.styleCleanup) == null ? void 0 : _a.call(ctx);
        delete el.__qtouchhold;
      }
    }
  }
);
var keyCodes3 = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  delete: [8, 46]
};
var keyRegex = new RegExp(`^([\\d+]+|${Object.keys(keyCodes3).join("|")})$`, "i");
function shouldEnd(evt, origin) {
  const { top, left } = position(evt);
  return Math.abs(left - origin.left) >= 7 || Math.abs(top - origin.top) >= 7;
}
createDirective(
  {
    name: "touch-repeat",
    beforeMount(el, { modifiers, value: value2, arg }) {
      const keyboard = Object.keys(modifiers).reduce((acc, key) => {
        if (keyRegex.test(key) === true) {
          const keyCode = isNaN(parseInt(key, 10)) ? keyCodes3[key.toLowerCase()] : parseInt(key, 10);
          keyCode >= 0 && acc.push(keyCode);
        }
        return acc;
      }, []);
      if (modifiers.mouse !== true && client.has.touch !== true && keyboard.length === 0) return;
      const durations = typeof arg === "string" && arg.length !== 0 ? arg.split(":").map((val) => parseInt(val, 10)) : [0, 600, 300];
      const durationsLast = durations.length - 1;
      const ctx = {
        keyboard,
        handler: value2,
        noop,
        mouseStart(evt) {
          if (ctx.event === void 0 && typeof ctx.handler === "function" && leftClick(evt) === true) {
            addEvt(ctx, "temp", [
              [document, "mousemove", "move", "passiveCapture"],
              [document, "click", "end", "notPassiveCapture"]
            ]);
            ctx.start(evt, true);
          }
        },
        keyboardStart(evt) {
          if (typeof ctx.handler === "function" && isKeyCode(evt, keyboard) === true) {
            if (durations[0] === 0 || ctx.event !== void 0) {
              stopAndPrevent(evt);
              el.focus();
              if (ctx.event !== void 0) return;
            }
            addEvt(ctx, "temp", [
              [document, "keyup", "end", "notPassiveCapture"],
              [document, "click", "end", "notPassiveCapture"]
            ]);
            ctx.start(evt, false, true);
          }
        },
        touchStart(evt) {
          if (evt.target !== void 0 && typeof ctx.handler === "function") {
            const target2 = evt.target;
            addEvt(ctx, "temp", [
              [target2, "touchmove", "move", "passiveCapture"],
              [target2, "touchcancel", "end", "notPassiveCapture"],
              [target2, "touchend", "end", "notPassiveCapture"]
            ]);
            ctx.start(evt);
          }
        },
        start(evt, mouseEvent, keyboardEvent) {
          if (keyboardEvent !== true) {
            ctx.origin = position(evt);
          }
          function styleCleanup(withDelay) {
            ctx.styleCleanup = void 0;
            document.documentElement.style.cursor = "";
            const remove2 = () => {
              document.body.classList.remove("non-selectable");
            };
            if (withDelay === true) {
              clearSelection();
              setTimeout(remove2, 10);
            } else {
              remove2();
            }
          }
          if (client.is.mobile === true) {
            document.body.classList.add("non-selectable");
            clearSelection();
            ctx.styleCleanup = styleCleanup;
          }
          ctx.event = {
            touch: mouseEvent !== true && keyboardEvent !== true,
            mouse: mouseEvent === true,
            keyboard: keyboardEvent === true,
            startTime: Date.now(),
            repeatCount: 0
          };
          const fn = () => {
            ctx.timer = void 0;
            if (ctx.event === void 0) return;
            if (ctx.event.repeatCount === 0) {
              ctx.event.evt = evt;
              if (keyboardEvent === true) {
                ctx.event.keyCode = evt.keyCode;
              } else {
                ctx.event.position = position(evt);
              }
              if (client.is.mobile !== true) {
                document.documentElement.style.cursor = "pointer";
                document.body.classList.add("non-selectable");
                clearSelection();
                ctx.styleCleanup = styleCleanup;
              }
            }
            ctx.event.duration = Date.now() - ctx.event.startTime;
            ctx.event.repeatCount += 1;
            ctx.handler(ctx.event);
            const index2 = durationsLast < ctx.event.repeatCount ? durationsLast : ctx.event.repeatCount;
            ctx.timer = setTimeout(fn, durations[index2]);
          };
          if (durations[0] === 0) {
            fn();
          } else {
            ctx.timer = setTimeout(fn, durations[0]);
          }
        },
        move(evt) {
          if (ctx.event !== void 0 && ctx.timer !== void 0 && shouldEnd(evt, ctx.origin) === true) {
            clearTimeout(ctx.timer);
            ctx.timer = void 0;
          }
        },
        end(evt) {
          var _a;
          if (ctx.event === void 0) return;
          (_a = ctx.styleCleanup) == null ? void 0 : _a.call(ctx, true);
          if (evt !== void 0 && ctx.event.repeatCount > 0) stopAndPrevent(evt);
          cleanEvt(ctx, "temp");
          if (ctx.timer !== void 0) {
            clearTimeout(ctx.timer);
            ctx.timer = void 0;
          }
          ctx.event = void 0;
        }
      };
      el.__qtouchrepeat = ctx;
      if (modifiers.mouse === true) {
        const capture = modifiers.mouseCapture === true || modifiers.mousecapture === true ? "Capture" : "";
        addEvt(ctx, "main", [
          [el, "mousedown", "mouseStart", `passive${capture}`]
        ]);
      }
      client.has.touch === true && addEvt(ctx, "main", [
        [el, "touchstart", "touchStart", `passive${modifiers.capture === true ? "Capture" : ""}`],
        [el, "touchend", "noop", "passiveCapture"]
      ]);
      if (keyboard.length !== 0) {
        const capture = modifiers.keyCapture === true || modifiers.keycapture === true ? "Capture" : "";
        addEvt(ctx, "main", [
          [el, "keydown", "keyboardStart", `notPassive${capture}`]
        ]);
      }
    },
    updated(el, { oldValue, value: value2 }) {
      const ctx = el.__qtouchrepeat;
      if (ctx !== void 0 && oldValue !== value2) {
        typeof value2 !== "function" && ctx.end();
        ctx.handler = value2;
      }
    },
    beforeUnmount(el) {
      var _a;
      const ctx = el.__qtouchrepeat;
      if (ctx !== void 0) {
        ctx.timer !== void 0 && clearTimeout(ctx.timer);
        cleanEvt(ctx, "main");
        cleanEvt(ctx, "temp");
        (_a = ctx.styleCleanup) == null ? void 0 : _a.call(ctx);
        delete el.__qtouchrepeat;
      }
    }
  }
);
function getCssVar(propName, element = document.body) {
  if (!(element instanceof Element)) {
    throw new TypeError("Expected a DOM element");
  }
  return getComputedStyle(element).getPropertyValue(`--q-${propName}`).trim() || null;
}
var metaValue;
function getProp() {
  return client.is.winphone ? "msapplication-navbutton-color" : "theme-color";
}
function getMetaTag(v) {
  const els = document.getElementsByTagName("META");
  for (const i3 in els) {
    if (els[i3].name === v) {
      return els[i3];
    }
  }
}
function setColor(hexColor) {
  if (metaValue === void 0) {
    metaValue = getProp();
  }
  let metaTag = getMetaTag(metaValue);
  const newTag = metaTag === void 0;
  if (newTag) {
    metaTag = document.createElement("meta");
    metaTag.setAttribute("name", metaValue);
  }
  metaTag.setAttribute("content", hexColor);
  if (newTag) {
    document.head.appendChild(metaTag);
  }
}
({
  set: client.is.mobile === true && (client.is.nativeMobile === true || client.is.winphone === true || client.is.safari === true || client.is.webkit === true || client.is.vivaldi === true) ? (hexColor) => {
    const val = hexColor || getCssVar("primary");
    if (client.is.nativeMobile === true && window.StatusBar) {
      window.StatusBar.backgroundColorByHexString(val);
    } else {
      setColor(val);
    }
  } : noop
});
var prefixes = {};
function assignFn(fn) {
  Object.assign(Plugin4, {
    request: fn,
    exit: fn,
    toggle: fn
  });
}
function getFullscreenElement() {
  return document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement || null;
}
function updateEl() {
  const newEl = Plugin4.activeEl = Plugin4.isActive === false ? null : getFullscreenElement();
  changeGlobalNodesTarget(
    newEl === null || newEl === document.documentElement ? document.body : newEl
  );
}
function togglePluginState() {
  Plugin4.isActive = Plugin4.isActive === false;
  updateEl();
}
function promisify(target2, fn) {
  try {
    const res = target2[fn]();
    return res === void 0 ? Promise.resolve() : res;
  } catch (err) {
    return Promise.reject(err);
  }
}
var Plugin4 = createReactivePlugin({
  isActive: false,
  activeEl: null
}, {
  isCapable: false,
  install({ $q }) {
    $q.fullscreen = this;
  }
});
{
  prefixes.request = [
    "requestFullscreen",
    "msRequestFullscreen",
    "mozRequestFullScreen",
    "webkitRequestFullscreen"
  ].find((request) => document.documentElement[request] !== void 0);
  Plugin4.isCapable = prefixes.request !== void 0;
  if (Plugin4.isCapable === false) {
    assignFn(() => Promise.reject("Not capable"));
  } else {
    Object.assign(Plugin4, {
      request(target2) {
        const el = target2 || document.documentElement;
        const { activeEl } = Plugin4;
        if (el === activeEl) {
          return Promise.resolve();
        }
        const queue2 = activeEl !== null && el.contains(activeEl) === true ? Plugin4.exit() : Promise.resolve();
        return queue2.finally(() => promisify(el, prefixes.request));
      },
      exit() {
        return Plugin4.isActive === true ? promisify(document, prefixes.exit) : Promise.resolve();
      },
      toggle(target2) {
        return Plugin4.isActive === true ? Plugin4.exit() : Plugin4.request(target2);
      }
    });
    prefixes.exit = [
      "exitFullscreen",
      "msExitFullscreen",
      "mozCancelFullScreen",
      "webkitExitFullscreen"
    ].find((exit) => document[exit]);
    Plugin4.isActive = Boolean(getFullscreenElement());
    Plugin4.isActive === true && updateEl();
    [
      "onfullscreenchange",
      "onmsfullscreenchange",
      "onwebkitfullscreenchange"
    ].forEach((evt) => {
      document[evt] = togglePluginState;
    });
  }
}
var Plugin5 = createReactivePlugin({
  appVisible: true
}, {
  install({ $q }) {
    injectProp($q, "appVisible", () => this.appVisible);
  }
});
{
  let prop, evt;
  if (typeof document.hidden !== "undefined") {
    prop = "hidden";
    evt = "visibilitychange";
  } else if (typeof document.msHidden !== "undefined") {
    prop = "msHidden";
    evt = "msvisibilitychange";
  } else if (typeof document.webkitHidden !== "undefined") {
    prop = "webkitHidden";
    evt = "webkitvisibilitychange";
  }
  if (evt && typeof document[prop] !== "undefined") {
    const update6 = () => {
      Plugin5.appVisible = !document[prop];
    };
    document.addEventListener(evt, update6, false);
  }
}
createComponent({
  name: "BottomSheetComponent",
  props: {
    ...useDarkProps,
    title: String,
    message: String,
    actions: Array,
    grid: Boolean,
    cardClass: [String, Array, Object],
    cardStyle: [String, Array, Object]
  },
  emits: ["ok", "hide"],
  setup(props4, { emit }) {
    const { proxy } = getCurrentInstance();
    const isDark = use_dark_default(props4, proxy.$q);
    const dialogRef = ref$1(null);
    function show() {
      dialogRef.value.show();
    }
    function hide() {
      dialogRef.value.hide();
    }
    function onOk(action) {
      emit("ok", action);
      hide();
    }
    function onHide() {
      emit("hide");
    }
    function getGrid() {
      return props4.actions.map((action) => {
        const img = action.avatar || action.img;
        return action.label === void 0 ? h(QSeparator_default, {
          class: "col-all",
          dark: isDark.value
        }) : h("div", {
          class: [
            "q-bottom-sheet__item q-hoverable q-focusable cursor-pointer relative-position",
            action.class
          ],
          style: action.style,
          tabindex: 0,
          role: "listitem",
          onClick() {
            onOk(action);
          },
          onKeyup(e3) {
            e3.keyCode === 13 && onOk(action);
          }
        }, [
          h("div", { class: "q-focus-helper" }),
          action.icon ? h(QIcon_default, { name: action.icon, color: action.color }) : img ? h("img", {
            class: action.avatar ? "q-bottom-sheet__avatar" : "",
            src: img
          }) : h("div", { class: "q-bottom-sheet__empty-icon" }),
          h("div", action.label)
        ]);
      });
    }
    function getList() {
      return props4.actions.map((action) => {
        const img = action.avatar || action.img;
        return action.label === void 0 ? h(QSeparator_default, { spaced: true, dark: isDark.value }) : h(QItem_default, {
          class: ["q-bottom-sheet__item", action.classes],
          style: action.style,
          tabindex: 0,
          clickable: true,
          dark: isDark.value,
          onClick() {
            onOk(action);
          }
        }, () => [
          h(
            QItemSection_default,
            { avatar: true },
            () => action.icon ? h(QIcon_default, { name: action.icon, color: action.color }) : img ? h("img", {
              class: action.avatar ? "q-bottom-sheet__avatar" : "",
              src: img
            }) : null
          ),
          h(QItemSection_default, () => action.label)
        ]);
      });
    }
    function getCardContent() {
      const child = [];
      props4.title && child.push(
        h(QCardSection_default, {
          class: "q-dialog__title"
        }, () => props4.title)
      );
      props4.message && child.push(
        h(QCardSection_default, {
          class: "q-dialog__message"
        }, () => props4.message)
      );
      child.push(
        props4.grid === true ? h("div", {
          class: "row items-stretch justify-start",
          role: "list"
        }, getGrid()) : h("div", {
          role: "list"
        }, getList())
      );
      return child;
    }
    function getContent() {
      return [
        h(QCard_default, {
          class: [
            `q-bottom-sheet q-bottom-sheet--${props4.grid === true ? "grid" : "list"}` + (isDark.value === true ? " q-bottom-sheet--dark q-dark" : ""),
            props4.cardClass
          ],
          style: props4.cardStyle
        }, getCardContent)
      ];
    }
    Object.assign(proxy, { show, hide });
    return () => h(QDialog_default, {
      ref: dialogRef,
      position: "bottom",
      onHide
    }, getContent);
  }
});
function encode(string) {
  return encodeURIComponent(string);
}
function decode(string) {
  return decodeURIComponent(string);
}
function stringifyCookieValue(value2) {
  return encode(value2 === Object(value2) ? JSON.stringify(value2) : "" + value2);
}
function read(string) {
  if (string === "") {
    return string;
  }
  if (string.indexOf('"') === 0) {
    string = string.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\");
  }
  string = decode(string.replace(/\+/g, " "));
  try {
    const parsed = JSON.parse(string);
    if (parsed === Object(parsed) || Array.isArray(parsed) === true) {
      string = parsed;
    }
  } catch (_) {
  }
  return string;
}
function getString(msOffset) {
  const time = /* @__PURE__ */ new Date();
  time.setMilliseconds(time.getMilliseconds() + msOffset);
  return time.toUTCString();
}
function parseExpireString(str) {
  let timestamp = 0;
  const days = str.match(/(\d+)d/);
  const hours = str.match(/(\d+)h/);
  const minutes = str.match(/(\d+)m/);
  const seconds = str.match(/(\d+)s/);
  if (days) {
    timestamp += days[1] * 864e5;
  }
  if (hours) {
    timestamp += hours[1] * 36e5;
  }
  if (minutes) {
    timestamp += minutes[1] * 6e4;
  }
  if (seconds) {
    timestamp += seconds[1] * 1e3;
  }
  return timestamp === 0 ? str : getString(timestamp);
}
function set(key, val, opts = {}, ssr) {
  let expire, expireValue;
  if (opts.expires !== void 0) {
    if (Object.prototype.toString.call(opts.expires) === "[object Date]") {
      expire = opts.expires.toUTCString();
    } else if (typeof opts.expires === "string") {
      expire = parseExpireString(opts.expires);
    } else {
      expireValue = parseFloat(opts.expires);
      expire = isNaN(expireValue) === false ? getString(expireValue * 864e5) : opts.expires;
    }
  }
  const keyValue = `${encode(key)}=${stringifyCookieValue(val)}`;
  const cookie = [
    keyValue,
    expire !== void 0 ? "; Expires=" + expire : "",
    // use expires attribute, max-age is not supported by IE
    opts.path ? "; Path=" + opts.path : "",
    opts.domain ? "; Domain=" + opts.domain : "",
    opts.sameSite ? "; SameSite=" + opts.sameSite : "",
    opts.httpOnly ? "; HttpOnly" : "",
    opts.secure ? "; Secure" : "",
    opts.other ? "; " + opts.other : ""
  ].join("");
  if (ssr) {
    if (ssr.req.qCookies) {
      ssr.req.qCookies.push(cookie);
    } else {
      ssr.req.qCookies = [cookie];
    }
    ssr.res.setHeader("Set-Cookie", ssr.req.qCookies);
    let all = ssr.req.headers.cookie || "";
    if (expire !== void 0 && expireValue < 0) {
      const val2 = get(key, ssr);
      if (val2 !== void 0) {
        all = all.replace(`${key}=${val2}; `, "").replace(`; ${key}=${val2}`, "").replace(`${key}=${val2}`, "");
      }
    } else {
      all = all ? `${keyValue}; ${all}` : cookie;
    }
    ssr.req.headers.cookie = all;
  } else {
    document.cookie = cookie;
  }
}
function get(key, ssr) {
  const cookieSource = ssr ? ssr.req.headers : document, cookies = cookieSource.cookie ? cookieSource.cookie.split("; ") : [], l = cookies.length;
  let result = key ? null : {}, i3 = 0, parts, name2, cookie;
  for (; i3 < l; i3++) {
    parts = cookies[i3].split("=");
    name2 = decode(parts.shift());
    cookie = parts.join("=");
    if (!key) {
      result[name2] = cookie;
    } else if (key === name2) {
      result = read(cookie);
      break;
    }
  }
  return result;
}
function remove(key, options, ssr) {
  set(
    key,
    "",
    { expires: -1, ...options },
    ssr
  );
}
function has(key, ssr) {
  return get(key, ssr) !== null;
}
function getObject(ssr) {
  return {
    get: (key) => get(key, ssr),
    set: (key, val, opts) => set(key, val, opts, ssr),
    has: (key) => has(key, ssr),
    remove: (key, options) => remove(key, options, ssr),
    getAll: () => get(null, ssr)
  };
}
var Plugin6 = {
  install({ $q, ssrContext }) {
    $q.cookies = this;
  }
};
if (__QUASAR_SSR__) {
  Plugin6.parseSSR = (ssrContext) => {
    if (ssrContext !== void 0) {
      return getObject(ssrContext);
    }
  };
}
{
  Object.assign(Plugin6, getObject());
}
createComponent({
  name: "DialogPluginComponent",
  props: {
    ...useDarkProps,
    title: String,
    message: String,
    prompt: Object,
    options: Object,
    progress: [Boolean, Object],
    html: Boolean,
    ok: {
      type: [String, Object, Boolean],
      default: true
    },
    cancel: [String, Object, Boolean],
    focus: {
      type: String,
      default: "ok",
      validator: (v) => ["ok", "cancel", "none"].includes(v)
    },
    stackButtons: Boolean,
    color: String,
    cardClass: [String, Array, Object],
    cardStyle: [String, Array, Object]
  },
  emits: ["ok", "hide"],
  setup(props4, { emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const isDark = use_dark_default(props4, $q);
    const dialogRef = ref$1(null);
    const model = ref$1(
      props4.prompt !== void 0 ? props4.prompt.model : props4.options !== void 0 ? props4.options.model : void 0
    );
    const classes = computed(
      () => "q-dialog-plugin" + (isDark.value === true ? " q-dialog-plugin--dark q-dark" : "") + (props4.progress !== false ? " q-dialog-plugin--progress" : "")
    );
    const vmColor = computed(
      () => props4.color || (isDark.value === true ? "amber" : "primary")
    );
    const spinner = computed(() => props4.progress === false ? null : isObject(props4.progress) === true ? {
      component: props4.progress.spinner || QSpinner_default,
      props: { color: props4.progress.color || vmColor.value }
    } : {
      component: QSpinner_default,
      props: { color: vmColor.value }
    });
    const hasForm = computed(
      () => props4.prompt !== void 0 || props4.options !== void 0
    );
    const formProps = computed(() => {
      if (hasForm.value !== true) {
        return {};
      }
      const { model: model2, isValid: isValid2, items, ...formProps2 } = props4.prompt !== void 0 ? props4.prompt : props4.options;
      return formProps2;
    });
    const okLabel = computed(() => isObject(props4.ok) === true ? $q.lang.label.ok : props4.ok === true ? $q.lang.label.ok : props4.ok);
    const cancelLabel = computed(() => isObject(props4.cancel) === true ? $q.lang.label.cancel : props4.cancel === true ? $q.lang.label.cancel : props4.cancel);
    const okDisabled = computed(() => {
      if (props4.prompt !== void 0) {
        return props4.prompt.isValid !== void 0 && props4.prompt.isValid(model.value) !== true;
      }
      if (props4.options !== void 0) {
        return props4.options.isValid !== void 0 && props4.options.isValid(model.value) !== true;
      }
      return false;
    });
    const okProps = computed(() => ({
      color: vmColor.value,
      label: okLabel.value,
      ripple: false,
      disable: okDisabled.value,
      ...isObject(props4.ok) === true ? props4.ok : { flat: true },
      "data-autofocus": props4.focus === "ok" && hasForm.value !== true || void 0,
      onClick: onOk
    }));
    const cancelProps = computed(() => ({
      color: vmColor.value,
      label: cancelLabel.value,
      ripple: false,
      ...isObject(props4.cancel) === true ? props4.cancel : { flat: true },
      "data-autofocus": props4.focus === "cancel" && hasForm.value !== true || void 0,
      onClick: onCancel
    }));
    watch(() => props4.prompt && props4.prompt.model, onUpdateModel);
    watch(() => props4.options && props4.options.model, onUpdateModel);
    function show() {
      dialogRef.value.show();
    }
    function hide() {
      dialogRef.value.hide();
    }
    function onOk() {
      emit("ok", toRaw(model.value));
      hide();
    }
    function onCancel() {
      hide();
    }
    function onDialogHide() {
      emit("hide");
    }
    function onUpdateModel(val) {
      model.value = val;
    }
    function onInputKeyup(evt) {
      if (okDisabled.value !== true && props4.prompt.type !== "textarea" && isKeyCode(evt, 13) === true) {
        onOk();
      }
    }
    function getSection(classes2, text2) {
      return props4.html === true ? h(QCardSection_default, {
        class: classes2,
        innerHTML: text2
      }) : h(QCardSection_default, { class: classes2 }, () => text2);
    }
    function getPrompt() {
      return [
        h(QInput_default, {
          color: vmColor.value,
          dense: true,
          autofocus: true,
          dark: isDark.value,
          ...formProps.value,
          modelValue: model.value,
          "onUpdate:modelValue": onUpdateModel,
          onKeyup: onInputKeyup
        })
      ];
    }
    function getOptions() {
      return [
        h(QOptionGroup_default, {
          color: vmColor.value,
          options: props4.options.items,
          dark: isDark.value,
          ...formProps.value,
          modelValue: model.value,
          "onUpdate:modelValue": onUpdateModel
        })
      ];
    }
    function getButtons() {
      const child = [];
      props4.cancel && child.push(
        h(QBtn_default, cancelProps.value)
      );
      props4.ok && child.push(
        h(QBtn_default, okProps.value)
      );
      return h(QCardActions_default, {
        class: props4.stackButtons === true ? "items-end" : "",
        vertical: props4.stackButtons,
        align: "right"
      }, () => child);
    }
    function getCardContent() {
      const child = [];
      props4.title && child.push(
        getSection("q-dialog__title", props4.title)
      );
      props4.progress !== false && child.push(
        h(
          QCardSection_default,
          { class: "q-dialog__progress" },
          () => h(spinner.value.component, spinner.value.props)
        )
      );
      props4.message && child.push(
        getSection("q-dialog__message", props4.message)
      );
      if (props4.prompt !== void 0) {
        child.push(
          h(
            QCardSection_default,
            { class: "scroll q-dialog-plugin__form" },
            getPrompt
          )
        );
      } else if (props4.options !== void 0) {
        child.push(
          h(QSeparator_default, { dark: isDark.value }),
          h(
            QCardSection_default,
            { class: "scroll q-dialog-plugin__form" },
            getOptions
          ),
          h(QSeparator_default, { dark: isDark.value })
        );
      }
      if (props4.ok || props4.cancel) {
        child.push(getButtons());
      }
      return child;
    }
    function getContent() {
      return [
        h(QCard_default, {
          class: [
            classes.value,
            props4.cardClass
          ],
          style: props4.cardStyle,
          dark: isDark.value
        }, getCardContent)
      ];
    }
    Object.assign(proxy, { show, hide });
    return () => h(QDialog_default, {
      ref: dialogRef,
      onHide: onDialogHide
    }, getContent);
  }
});
var app;
var vm;
var uid2 = 0;
var timeout = null;
var props3 = {};
var activeGroups = {};
var originalDefaults = {
  group: "__default_quasar_group__",
  delay: 0,
  message: false,
  html: false,
  spinnerSize: 80,
  spinnerColor: "",
  messageColor: "",
  backgroundColor: "",
  boxClass: "",
  spinner: QSpinner_default,
  customClass: ""
};
var defaults = { ...originalDefaults };
function registerProps(opts) {
  if ((opts == null ? void 0 : opts.group) !== void 0 && activeGroups[opts.group] !== void 0) {
    return Object.assign(activeGroups[opts.group], opts);
  }
  const newProps = isObject(opts) === true && opts.ignoreDefaults === true ? { ...originalDefaults, ...opts } : { ...defaults, ...opts };
  activeGroups[newProps.group] = newProps;
  return newProps;
}
var Plugin7 = createReactivePlugin({
  isActive: false
}, {
  show(opts) {
    props3 = registerProps(opts);
    const { group } = props3;
    Plugin7.isActive = true;
    if (app !== void 0) {
      props3.uid = uid2;
      vm.$forceUpdate();
    } else {
      props3.uid = ++uid2;
      timeout !== null && clearTimeout(timeout);
      timeout = setTimeout(() => {
        timeout = null;
        const el = createGlobalNode("q-loading");
        app = createChildApp({
          name: "QLoading",
          setup() {
            onMounted(() => {
              prevent_scroll_default(true);
            });
            function onAfterLeave() {
              if (Plugin7.isActive !== true && app !== void 0) {
                prevent_scroll_default(false);
                app.unmount(el);
                removeGlobalNode(el);
                app = void 0;
                vm = void 0;
              }
            }
            function getContent() {
              if (Plugin7.isActive !== true) {
                return null;
              }
              const content = [
                h(props3.spinner, {
                  class: "q-loading__spinner",
                  color: props3.spinnerColor,
                  size: props3.spinnerSize
                })
              ];
              props3.message && content.push(
                h("div", {
                  class: "q-loading__message" + (props3.messageColor ? ` text-${props3.messageColor}` : ""),
                  [props3.html === true ? "innerHTML" : "textContent"]: props3.message
                })
              );
              return h("div", {
                class: "q-loading fullscreen flex flex-center z-max " + props3.customClass.trim(),
                key: props3.uid
              }, [
                h("div", {
                  class: "q-loading__backdrop" + (props3.backgroundColor ? ` bg-${props3.backgroundColor}` : "")
                }),
                h("div", {
                  class: "q-loading__box column items-center " + props3.boxClass
                }, content)
              ]);
            }
            return () => h(Transition, {
              name: "q-transition--fade",
              appear: true,
              onAfterLeave
            }, getContent);
          }
        }, Plugin7.__parentApp);
        vm = app.mount(el);
      }, props3.delay);
    }
    return (paramProps) => {
      if (paramProps === void 0 || Object(paramProps) !== paramProps) {
        Plugin7.hide(group);
        return;
      }
      Plugin7.show({ ...paramProps, group });
    };
  },
  hide(group) {
    if (Plugin7.isActive === true) {
      if (group === void 0) {
        activeGroups = {};
      } else if (activeGroups[group] === void 0) {
        return;
      } else {
        delete activeGroups[group];
        const keys2 = Object.keys(activeGroups);
        if (keys2.length !== 0) {
          const lastGroup = keys2[keys2.length - 1];
          Plugin7.show({ group: lastGroup });
          return;
        }
      }
      if (timeout !== null) {
        clearTimeout(timeout);
        timeout = null;
      }
      Plugin7.isActive = false;
    }
  },
  setDefaults(opts) {
    {
      isObject(opts) === true && Object.assign(defaults, opts);
    }
  },
  install({ $q, parentApp }) {
    $q.loading = this;
    {
      Plugin7.__parentApp = parentApp;
      if ($q.config.loading !== void 0) {
        this.setDefaults($q.config.loading);
      }
    }
  }
});
var barRef = ref$1(null);
var Plugin8 = createReactivePlugin({
  isActive: false
}, {
  start: noop,
  stop: noop,
  increment: noop,
  setDefaults: noop,
  install({ $q, parentApp }) {
    $q.loadingBar = this;
    if (this.__installed === true) {
      if ($q.config.loadingBar !== void 0) {
        this.setDefaults($q.config.loadingBar);
      }
      return;
    }
    const props4 = ref$1(
      $q.config.loadingBar !== void 0 ? { ...$q.config.loadingBar } : {}
    );
    function onStart() {
      Plugin8.isActive = true;
    }
    function onStop() {
      Plugin8.isActive = false;
    }
    const el = createGlobalNode("q-loading-bar");
    createChildApp({
      name: "LoadingBar",
      // hide App from Vue devtools
      devtools: { hide: true },
      setup: () => () => h(QAjaxBar_default, { ...props4.value, onStart, onStop, ref: barRef })
    }, parentApp).mount(el);
    Object.assign(this, {
      start(speed) {
        barRef.value.start(speed);
      },
      stop() {
        barRef.value.stop();
      },
      increment() {
        barRef.value.increment.apply(null, arguments);
      },
      setDefaults(opts) {
        if (isObject(opts) === true) {
          Object.assign(props4.value, opts);
        }
      }
    });
  }
});
function encode2(value2) {
  if (isDate(value2) === true) {
    return "__q_date|" + value2.getTime();
  }
  if (isRegexp(value2) === true) {
    return "__q_expr|" + value2.source;
  }
  if (typeof value2 === "number") {
    return "__q_numb|" + value2;
  }
  if (typeof value2 === "boolean") {
    return "__q_bool|" + (value2 ? "1" : "0");
  }
  if (typeof value2 === "string") {
    return "__q_strn|" + value2;
  }
  if (typeof value2 === "function") {
    return "__q_strn|" + value2.toString();
  }
  if (value2 === Object(value2)) {
    return "__q_objt|" + JSON.stringify(value2);
  }
  return value2;
}
function decode2(value2) {
  const length = value2.length;
  if (length < 9) {
    return value2;
  }
  const type2 = value2.substring(0, 8);
  const source = value2.substring(9);
  switch (type2) {
    case "__q_date":
      const number = Number(source);
      return new Date(Number.isNaN(number) === true ? source : number);
    case "__q_expr":
      return new RegExp(source);
    case "__q_numb":
      return Number(source);
    case "__q_bool":
      return Boolean(source === "1");
    case "__q_strn":
      return "" + source;
    case "__q_objt":
      return JSON.parse(source);
    default:
      return value2;
  }
}
function getEmptyStorage() {
  const getVal2 = () => null;
  return {
    has: () => false,
    // alias for hasItem; TODO: remove in Qv3
    hasItem: () => false,
    getLength: () => 0,
    getItem: getVal2,
    getIndex: getVal2,
    getKey: getVal2,
    getAll: () => {
    },
    getAllKeys: () => [],
    set: noop,
    // alias for setItem; TODO: remove in Qv3
    setItem: noop,
    remove: noop,
    // alias for removeItem; TODO: remove in Qv3
    removeItem: noop,
    clear: noop,
    isEmpty: () => true
  };
}
function getStorage(type2) {
  const webStorage = window[type2 + "Storage"], get2 = (key) => {
    const item = webStorage.getItem(key);
    return item ? decode2(item) : null;
  };
  const hasItem = (key) => webStorage.getItem(key) !== null;
  const setItem = (key, value2) => {
    webStorage.setItem(key, encode2(value2));
  };
  const removeItem = (key) => {
    webStorage.removeItem(key);
  };
  return {
    has: hasItem,
    // TODO: remove in Qv3
    hasItem,
    getLength: () => webStorage.length,
    getItem: get2,
    getIndex: (index2) => {
      return index2 < webStorage.length ? get2(webStorage.key(index2)) : null;
    },
    getKey: (index2) => {
      return index2 < webStorage.length ? webStorage.key(index2) : null;
    },
    getAll: () => {
      let key;
      const result = {}, len = webStorage.length;
      for (let i3 = 0; i3 < len; i3++) {
        key = webStorage.key(i3);
        result[key] = get2(key);
      }
      return result;
    },
    getAllKeys: () => {
      const result = [], len = webStorage.length;
      for (let i3 = 0; i3 < len; i3++) {
        result.push(webStorage.key(i3));
      }
      return result;
    },
    set: setItem,
    // TODO: remove in Qv3
    setItem,
    remove: removeItem,
    // TODO: remove in Qv3
    removeItem,
    clear: () => {
      webStorage.clear();
    },
    isEmpty: () => webStorage.length === 0
  };
}
var storage = client.has.webStorage === false ? getEmptyStorage() : getStorage("local");
var Plugin9 = {
  install({ $q }) {
    $q.localStorage = storage;
  }
};
Object.assign(Plugin9, storage);
var storage2 = client.has.webStorage === false ? getEmptyStorage() : getStorage("session");
var Plugin10 = {
  install({ $q }) {
    $q.sessionStorage = storage2;
  }
};
Object.assign(Plugin10, storage2);
var emits2 = ["ok", "hide"];
get_emits_object_default(emits2);
const _hoisted_1$4 = {
  key: 0,
  class: "text-small text-grey-1 q-pt-md"
};
const _sfc_main$9 = /* @__PURE__ */ defineComponent({
  __name: "GroupParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: Object
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props4 = __props;
    const emit = __emit;
    const expanded = ref$1(false);
    function onUpdateParam(key, value2) {
      emit("update:modelValue", {
        ...props4.modelValue && props4.modelValue,
        [key]: value2
      });
    }
    return (_ctx, _cache) => {
      const _component_rv_ellipsis_text = resolveComponent("rv-ellipsis-text");
      const _component_rv_parameter = resolveComponent("rv-parameter");
      const _component_rv_expansion_item = resolveComponent("rv-expansion-item");
      return openBlock(), createBlock(_component_rv_expansion_item, {
        modelValue: expanded.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => expanded.value = $event),
        class: "rv-group-param",
        dense: "",
        "switch-toggle-side": ""
      }, {
        header: withCtx(() => [
          createVNode(unref(QItemSection_default), null, {
            default: withCtx(() => [
              createVNode(_component_rv_ellipsis_text, {
                class: "text-subtitle3",
                disable: __props.disable,
                text: __props.definition.name
              }, null, 8, ["disable", "text"])
            ]),
            _: 1
          })
        ]),
        default: withCtx(() => [
          __props.definition.description ? (openBlock(), createElementBlock("div", _hoisted_1$4, toDisplayString(__props.definition.description), 1)) : createCommentVNode("", true),
          (openBlock(true), createElementBlock(Fragment, null, renderList(__props.definition.fields, (param, key) => {
            return openBlock(), createBlock(_component_rv_parameter, {
              key,
              class: "q-my-md q-mx-sm",
              definition: param,
              disable: __props.disable,
              "model-value": __props.modelValue ? __props.modelValue[key] : void 0,
              readonly: __props.readonly,
              "value-only": __props.valueOnly,
              "onUpdate:modelValue": ($event) => onUpdateParam(key, $event)
            }, null, 8, ["definition", "disable", "model-value", "readonly", "value-only", "onUpdate:modelValue"]);
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});
const _hoisted_1$3 = {
  key: 0,
  class: "row no-wrap items-end"
};
const _sfc_main$8 = /* @__PURE__ */ defineComponent({
  __name: "IntegerParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: [Object, Number]
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    var _a;
    const props4 = __props;
    const emit = __emit;
    const i18nInstance = useI18n();
    const valueRef = ref$1(typeof props4.modelValue === "number" ? props4.modelValue : (_a = props4.modelValue) == null ? void 0 : _a.value);
    const value2 = computed({
      get() {
        return valueRef.value;
      },
      set(value22) {
        valueRef.value = value22;
        if (value22 == null) {
          emit("update:modelValue", void 0);
        } else {
          const parsed = Number(value22);
          if (!isNaN(parsed)) {
            const updated = buildParameterValue("Integer", parsed);
            emit("update:modelValue", updated);
          }
        }
      }
    });
    const isSlider = computed(() => props4.definition.widget === "slider" && props4.definition.maximum != null && props4.definition.minimum != null);
    const maxValue2 = computed(() => props4.definition.exclusiveMaximum ?? props4.definition.maximum);
    const hasMaxValue = computed(() => maxValue2.value != null);
    const maxValueExclusive = computed(() => props4.definition.exclusiveMaximum != null);
    const minValue2 = computed(() => props4.definition.minimum ?? props4.definition.exclusiveMinimum);
    const hasMinValue = computed(() => minValue2.value != null);
    const minValueExclusive = computed(() => props4.definition.exclusiveMinimum != null);
    const rules = computed(() => ({
      value: ValidationBuilder.withLabel(props4.definition.name, i18nInstance).requiredIf(!props4.definition.optional).numeric.integer.minValueIf(hasMinValue.value, minValue2.value, !minValueExclusive.value).maxValueIf(hasMaxValue.value, maxValue2.value, !maxValueExclusive.value).rules
    }));
    const state2 = computed(() => ({
      value: value2.value
    }));
    const v$ = useVuelidate(rules, state2, { $autoDirty: true });
    watch(
      () => props4.modelValue,
      () => {
        var _a2;
        const newValue = typeof props4.modelValue === "number" ? props4.modelValue : (_a2 = props4.modelValue) == null ? void 0 : _a2.value;
        if (Number(valueRef.value) !== Number(newValue)) {
          valueRef.value = newValue;
        }
      }
    );
    return (_ctx, _cache) => {
      const _component_rv_slider = resolveComponent("rv-slider");
      const _component_rv_input = resolveComponent("rv-input");
      return !__props.readonly ? (openBlock(), createElementBlock("div", _hoisted_1$3, [
        isSlider.value ? (openBlock(), createBlock(_component_rv_slider, {
          key: 0,
          modelValue: value2.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => value2.value = $event),
          class: "full-width",
          disable: __props.disable,
          "info-text": __props.definition.description,
          label: __props.definition.name,
          max: __props.definition.maximum,
          min: __props.definition.minimum,
          readonly: __props.readonly,
          "show-optional-label": __props.definition.optional,
          validation: unref(v$).value,
          "with-input": ""
        }, null, 8, ["modelValue", "disable", "info-text", "label", "max", "min", "readonly", "show-optional-label", "validation"])) : (openBlock(), createBlock(_component_rv_input, {
          key: 1,
          modelValue: value2.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => value2.value = $event),
          class: "full-width",
          disable: __props.disable,
          "info-text": __props.definition.description,
          label: __props.definition.name,
          readonly: __props.readonly,
          "show-optional-label": __props.definition.optional,
          validation: unref(v$).value
        }, null, 8, ["modelValue", "disable", "info-text", "label", "readonly", "show-optional-label", "validation"]))
      ])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: value2.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const _hoisted_1$2 = { key: 1 };
const _hoisted_2 = { class: "no-wrap flex-inline max-width-full" };
const _sfc_main$7 = /* @__PURE__ */ defineComponent({
  __name: "ListParam",
  props: {
    dataDependencies: {
      default: void 0,
      type: Object
    },
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: Object
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props4 = __props;
    const i18nInstance = useI18n();
    const { t: $t2 } = i18nInstance;
    const emit = __emit;
    const classes = computed(() => {
      var _a;
      return ((_a = props4.dataDependencies) == null ? void 0 : _a.classes) ?? [];
    });
    const options = computed(() => {
      return classes.value.map((c3) => ({
        color: c3.color,
        label: c3.name,
        value: c3.id
      }));
    });
    const selectedRef = ref$1(getSelectedOptionsValue(props4.modelValue));
    const selected = computed({
      get() {
        return selectedRef.value;
      },
      set(value2) {
        selectedRef.value = value2;
        const updatedValue = ParameterList$1.new().addValues(value2.map((o) => [o.value, new Label(o.value)])).build();
        emit("update:modelValue", updatedValue);
      }
    });
    const hasSelected = computed(() => {
      return selected.value.length > 0;
    });
    const allSelected = computed(() => {
      return classes.value.length > 0 && classes.value.every((c3) => selected.value.some((s4) => s4.value === c3.id));
    });
    const rules = computed(() => ({
      selected: ValidationBuilder.withLabel(props4.definition.name, i18nInstance).custom(
        (value2) => props4.definition.optional || value2.length > 0,
        "rvai-params.errors.selectionRequired"
      ).rules
    }));
    const state2 = computed(() => ({
      selected: selected.value
    }));
    const v$ = useVuelidate(rules, state2, { $autoDirty: true });
    function getSelectOptionValue(parameterNode) {
      var _a;
      return {
        color: (_a = classes.value.find((e3) => e3.id === parameterNode.key)) == null ? void 0 : _a.color,
        label: parameterNode.key,
        value: parameterNode.key
      };
    }
    function getSelectedOptionsValue(value2) {
      return (value2 ?? []).map(getSelectOptionValue);
    }
    watch(
      () => props4.dataDependencies,
      () => {
        selectedRef.value = getSelectedOptionsValue(props4.modelValue);
      }
    );
    watch(
      () => props4.modelValue,
      (newValue) => {
        selectedRef.value = getSelectedOptionsValue(newValue);
      }
    );
    return (_ctx, _cache) => {
      const _component_rv_multiple_select = resolveComponent("rv-multiple-select");
      const _component_rv_bullet = resolveComponent("rv-bullet");
      const _component_rv_ellipsis_text = resolveComponent("rv-ellipsis-text");
      return !__props.readonly ? (openBlock(), createBlock(_component_rv_multiple_select, {
        key: 0,
        modelValue: selected.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => selected.value = $event),
        "all-selected-text": unref($t2)("rvai-params.general.allSelected"),
        class: "full-width",
        disable: __props.disable,
        "info-text": __props.definition.description ?? void 0,
        label: __props.definition.name,
        options: options.value,
        validation: unref(v$).selected,
        "with-chips": ""
      }, null, 8, ["modelValue", "all-selected-text", "disable", "info-text", "label", "options", "validation"])) : (openBlock(), createElementBlock("div", _hoisted_1$2, [
        hasSelected.value && !allSelected.value ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(selected.value, (option) => {
          return openBlock(), createElementBlock("div", {
            key: option.value,
            class: "full-width q-pb-sm"
          }, [
            createElementVNode("div", _hoisted_2, [
              createVNode(_component_rv_bullet, {
                class: "q-pr-sm",
                color: option.color,
                "is-tooltip-shown": false,
                size: 8
              }, null, 8, ["color"]),
              createVNode(_component_rv_ellipsis_text, {
                class: "zero-min-width",
                text: option.value
              }, null, 8, ["text"])
            ])
          ]);
        }), 128)) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
          name: __props.definition.name,
          value: allSelected.value ? unref($t2)("rvai-params.general.allSelected") : void 0,
          "value-only": __props.valueOnly
        }), null, 16, ["name", "value", "value-only"]))
      ]));
    };
  }
});
const ListParam = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["__scopeId", "data-v-0c7b8b9d"]]);
const _sfc_main$6 = /* @__PURE__ */ defineComponent({
  __name: "Size2DParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: Object
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    var _a, _b;
    const props4 = __props;
    const emit = __emit;
    const i18nInstance = useI18n();
    const currentValue = reactive({
      height: String(((_a = props4.modelValue) == null ? void 0 : _a.height) ?? ""),
      width: String(((_b = props4.modelValue) == null ? void 0 : _b.width) ?? "")
    });
    const arrayValue = computed({
      get() {
        return [currentValue.width, currentValue.height];
      },
      set(value2) {
        const [width, height2] = value2;
        Object.assign(currentValue, {
          height: height2,
          width
        });
        emitUpdate();
      }
    });
    const readOnlyValue = computed(() => {
      if (!props4.modelValue) return void 0;
      const {
        height: height2,
        width
      } = props4.modelValue;
      return `${width} x ${height2}`;
    });
    watch(() => props4.modelValue, (value2) => {
      Object.assign(currentValue, {
        height: String((value2 == null ? void 0 : value2.height) ?? ""),
        width: String((value2 == null ? void 0 : value2.width) ?? "")
      });
    });
    function emitUpdate() {
      const {
        height: height2,
        width
      } = currentValue;
      if (!height2 || !width) {
        return emit("update:modelValue", void 0);
      }
      const parsedHeight = Number(height2);
      const parsedWidth = Number(width);
      if (parsedHeight != null && !isNaN(parsedHeight) && parsedWidth != null && !isNaN(parsedWidth)) {
        emit("update:modelValue", new Size2D(parsedHeight, parsedWidth));
      } else {
        return emit("update:modelValue", void 0);
      }
    }
    const rules = computed(() => {
      var _a2, _b2, _c, _d, _e2, _f, _g, _h, _i, _j;
      return {
        height: ValidationBuilder.withLabel(props4.definition.name, i18nInstance).requiredIf(!props4.definition.optional).numeric.minValueIf(!props4.definition.optional && ((_a2 = props4.definition.minSize) == null ? void 0 : _a2.width) != null, (_b2 = props4.definition.minSize) == null ? void 0 : _b2.width).maxValueIf(!props4.definition.optional && ((_c = props4.definition.maxSize) == null ? void 0 : _c.width) != null, (_d = props4.definition.maxSize) == null ? void 0 : _d.width).equalTo((_e2 = props4.definition.exactSize) == null ? void 0 : _e2.width).rules,
        width: ValidationBuilder.withLabel(props4.definition.name, i18nInstance).requiredIf(!props4.definition.optional).numeric.minValueIf(!props4.definition.optional && ((_f = props4.definition.minSize) == null ? void 0 : _f.width) != null, (_g = props4.definition.minSize) == null ? void 0 : _g.width).maxValueIf(!props4.definition.optional && ((_h = props4.definition.maxSize) == null ? void 0 : _h.width) != null, (_i = props4.definition.maxSize) == null ? void 0 : _i.width).equalTo((_j = props4.definition.exactSize) == null ? void 0 : _j.width).rules
      };
    });
    const v$ = useVuelidate(
      rules,
      currentValue,
      { $autoDirty: true }
    );
    return (_ctx, _cache) => {
      const _component_rv_combined_inputs = resolveComponent("rv-combined-inputs");
      return !__props.readonly ? (openBlock(), createBlock(_component_rv_combined_inputs, {
        key: 0,
        modelValue: arrayValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => arrayValue.value = $event),
        class: "size2d-param full-width",
        disable: __props.disable,
        hint: "Width x height",
        "info-text": __props.definition.description,
        label: __props.definition.name,
        readonly: __props.readonly,
        separator: "x",
        validation: [unref(v$).width, unref(v$).height]
      }, null, 8, ["modelValue", "disable", "info-text", "label", "readonly", "validation"])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: readOnlyValue.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const Size2DParam = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["__scopeId", "data-v-deffc5d2"]]);
const _sfc_main$5 = /* @__PURE__ */ defineComponent({
  __name: "TextParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: String
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const VALID_TYPES = [
      "text",
      "password",
      "textarea",
      "time",
      "date",
      "datetime-local"
    ];
    const props4 = __props;
    const emit = __emit;
    const i18nInstance = useI18n();
    const value2 = computed({
      get() {
        return props4.modelValue;
      },
      set(value22) {
        const updated = value22 ? buildParameterValue("Text", value22) : null;
        emit("update:modelValue", updated);
      }
    });
    const type2 = computed(() => {
      const { widget } = props4.definition;
      if (widget && VALID_TYPES.includes(widget)) {
        return widget;
      } else {
        return void 0;
      }
    });
    const rules = computed(() => {
      var _a, _b, _c, _d;
      return {
        value: ValidationBuilder.withLabel(props4.definition.name, i18nInstance).requiredIf(!props4.definition.optional).maxLength((_a = props4.definition) == null ? void 0 : _a.maxLength).minLength((_b = props4.definition) == null ? void 0 : _b.minLength).oneOfRegexes(((_d = (_c = props4.definition) == null ? void 0 : _c.pattern) == null ? void 0 : _d.map((p2) => new RegExp(p2))) ?? []).rules
      };
    });
    const state2 = computed(() => ({
      value: value2.value
    }));
    const v$ = useVuelidate(rules, state2, { $autoDirty: true });
    return (_ctx, _cache) => {
      const _component_rv_input = resolveComponent("rv-input");
      return !__props.readonly ? (openBlock(), createBlock(_component_rv_input, {
        key: 0,
        modelValue: value2.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => value2.value = $event),
        disable: __props.disable,
        "info-text": __props.definition.description,
        label: __props.definition.name,
        readonly: __props.readonly,
        "show-optional-label": __props.definition.optional,
        type: type2.value,
        validation: unref(v$).value
      }, null, 8, ["modelValue", "disable", "info-text", "label", "readonly", "show-optional-label", "type", "validation"])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: value2.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const _sfc_main$4 = defineComponent({
  components: {
    QIcon: QIcon_default
  },
  inheritAttrs: false,
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    hideLabel: {
      default: false,
      type: Boolean
    }
  }
});
const _hoisted_1$1 = { class: "row no-wrap items-center" };
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_rv_ellipsis_text = resolveComponent("rv-ellipsis-text");
  const _component_rv_tooltip = resolveComponent("rv-tooltip");
  const _component_QIcon = resolveComponent("QIcon");
  return openBlock(), createElementBlock("div", _hoisted_1$1, [
    !_ctx.hideLabel ? (openBlock(), createBlock(_component_rv_ellipsis_text, mergeProps({ key: 0 }, _ctx.$attrs, {
      class: "text-subtitle3",
      disable: _ctx.disable,
      text: _ctx.definition.name
    }), null, 16, ["disable", "text"])) : createCommentVNode("", true),
    _ctx.definition.description ? (openBlock(), createBlock(_component_QIcon, {
      key: 1,
      class: "info-icon q-mx-xs",
      color: "dark",
      name: "info",
      size: "16px"
    }, {
      default: withCtx(() => [
        createVNode(_component_rv_tooltip, null, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.definition.description), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    })) : createCommentVNode("", true)
  ]);
}
const ParamTitle = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$1]]);
const _hoisted_1 = { key: 0 };
const _sfc_main$3 = /* @__PURE__ */ defineComponent({
  __name: "UnsupportedParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: [Number, Object, String, Boolean]
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  setup(__props) {
    const props4 = __props;
    const value2 = computed(() => {
      return JSON.stringify(props4.modelValue, null, 2) ?? "(Unsupported type)";
    });
    return (_ctx, _cache) => {
      return !__props.readonly ? (openBlock(), createElementBlock("div", _hoisted_1, [
        createVNode(ParamTitle, {
          definition: __props.definition,
          disable: __props.disable
        }, null, 8, ["definition", "disable"]),
        createElementVNode("span", {
          class: normalizeClass(["text-body3 text-grey-1", { "disabled": __props.disable }])
        }, " Unsupported parameter type (" + toDisplayString(__props.definition.type) + ") ", 3)
      ])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: value2.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  __name: "UriParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: String
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props4 = __props;
    const isWebhookUrl = computed(() => {
      const { widget } = props4.definition;
      return widget === "webhook";
    });
    const url = ref$1(props4.modelValue);
    const emit = __emit;
    function onBlur2() {
      try {
        const urlObject = url.value ? buildParameterValue("URI", url.value) : void 0;
        url.value = urlObject ? urlObject.toString() : "";
        emit("update:modelValue", urlObject);
      } catch (err) {
        console.log(err);
      }
    }
    const uriRegex = /(?<scheme>.*):\/\/(?<authority>[^/]*)(?:\/(?<path>[^/?]*))?(?:\?(?<query>[^#]*))?(?:#(?<fragment>.*))?/;
    const urlRegex2 = /^https?:\/\/(\S+(?::\S+@))?([a-zA-Z0-9-:]+\.)*[a-zA-Z0-9-:]{2,}(\/[^\s]*)?$/;
    const rules = computed(() => ({
      value: ValidationBuilder.withLabel(props4.definition.name).requiredIf(!props4.definition.optional).regex(isWebhookUrl.value ? urlRegex2 : uriRegex).rules
    }));
    const state2 = computed(() => ({
      value: url.value
    }));
    const v$ = useVuelidate(rules, state2, { $autoDirty: true });
    return (_ctx, _cache) => {
      const _component_rv_input = resolveComponent("rv-input");
      return !__props.readonly ? (openBlock(), createBlock(_component_rv_input, {
        key: 0,
        modelValue: url.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => url.value = $event),
        "bottom-slots": "",
        disable: __props.disable,
        "info-text": __props.definition.description,
        label: __props.definition.name,
        readonly: __props.readonly,
        "show-optional-label": __props.definition.optional,
        validation: unref(v$).value,
        onBlur: onBlur2
      }, null, 8, ["modelValue", "disable", "info-text", "label", "readonly", "show-optional-label", "validation"])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: url.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const ComponentMap = {
  Blob: _sfc_main$c,
  Boolean: _sfc_main$g,
  // these 2 components are not implemented for the correct
  // param type. they should be revisited if they are ever needed.
  // Box2D: Box2DParam,
  // Box3D: Box3DParam,
  Float: _sfc_main$b,
  FloatRange: _sfc_main$a,
  Integer: _sfc_main$8,
  List: ListParam,
  Object: _sfc_main$9,
  Size2D: Size2DParam,
  Text: _sfc_main$5,
  URI: _sfc_main$2
};
function mapToComponent(definition, extraComponents = []) {
  var _a, _b;
  for (const entry of extraComponents) {
    if (entry.supports(definition)) {
      return entry.component;
    }
  }
  if (definition.type === "Text" && ((_a = definition.enum) == null ? void 0 : _a.length)) {
    return _sfc_main$d;
  }
  if (definition.type === "Dict" && definition.values.type === "Boolean" && ((_b = definition.keys) == null ? void 0 : _b.enum) != null) {
    return _sfc_main$f;
  }
  if (definition.type === "Dict" && definition.values.type === "Text") {
    return DictKeyValueParam;
  }
  const component = ComponentMap[definition.type];
  if (!component) {
    console.warn(`Could not find component for param ${definition.name} with type ${definition.type}`);
    return _sfc_main$3;
  }
  return component;
}
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "Parameter",
  props: {
    dataDependencies: {
      default: void 0,
      type: Object
    },
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: [Number, Object, String, Boolean]
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props4 = __props;
    const emit = __emit;
    const { extraComponents } = useOptions$1();
    const ParamComponent = mapToComponent(props4.definition, extraComponents);
    function onUpdateModelValue(value2, isDefaultValue) {
      emit("update:modelValue", value2, isDefaultValue);
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(ParamComponent), {
        "data-dependencies": __props.dataDependencies,
        definition: __props.definition,
        disable: __props.disable,
        "model-value": __props.modelValue,
        readonly: __props.readonly,
        "value-only": __props.valueOnly,
        "onUpdate:modelValue": onUpdateModelValue
      }, null, 8, ["data-dependencies", "definition", "disable", "model-value", "readonly", "value-only"]);
    };
  }
});
var HttpStatusCode;
(function(HttpStatusCode2) {
  HttpStatusCode2[HttpStatusCode2["CONTINUE"] = 100] = "CONTINUE";
  HttpStatusCode2[HttpStatusCode2["SWITCHING_PROTOCOLS"] = 101] = "SWITCHING_PROTOCOLS";
  HttpStatusCode2[HttpStatusCode2["PROCESSING"] = 102] = "PROCESSING";
  HttpStatusCode2[HttpStatusCode2["OK"] = 200] = "OK";
  HttpStatusCode2[HttpStatusCode2["CREATED"] = 201] = "CREATED";
  HttpStatusCode2[HttpStatusCode2["ACCEPTED"] = 202] = "ACCEPTED";
  HttpStatusCode2[HttpStatusCode2["NON_AUTHORITATIVE_INFORMATION"] = 203] = "NON_AUTHORITATIVE_INFORMATION";
  HttpStatusCode2[HttpStatusCode2["NO_CONTENT"] = 204] = "NO_CONTENT";
  HttpStatusCode2[HttpStatusCode2["RESET_CONTENT"] = 205] = "RESET_CONTENT";
  HttpStatusCode2[HttpStatusCode2["PARTIAL_CONTENT"] = 206] = "PARTIAL_CONTENT";
  HttpStatusCode2[HttpStatusCode2["MULTI_STATUS"] = 207] = "MULTI_STATUS";
  HttpStatusCode2[HttpStatusCode2["ALREADY_REPORTED"] = 208] = "ALREADY_REPORTED";
  HttpStatusCode2[HttpStatusCode2["IM_USED"] = 226] = "IM_USED";
  HttpStatusCode2[HttpStatusCode2["MULTIPLE_CHOICES"] = 300] = "MULTIPLE_CHOICES";
  HttpStatusCode2[HttpStatusCode2["MOVED_PERMANENTLY"] = 301] = "MOVED_PERMANENTLY";
  HttpStatusCode2[HttpStatusCode2["FOUND"] = 302] = "FOUND";
  HttpStatusCode2[HttpStatusCode2["SEE_OTHER"] = 303] = "SEE_OTHER";
  HttpStatusCode2[HttpStatusCode2["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
  HttpStatusCode2[HttpStatusCode2["USE_PROXY"] = 305] = "USE_PROXY";
  HttpStatusCode2[HttpStatusCode2["SWITCH_PROXY"] = 306] = "SWITCH_PROXY";
  HttpStatusCode2[HttpStatusCode2["TEMPORARY_REDIRECT"] = 307] = "TEMPORARY_REDIRECT";
  HttpStatusCode2[HttpStatusCode2["PERMANENT_REDIRECT"] = 308] = "PERMANENT_REDIRECT";
  HttpStatusCode2[HttpStatusCode2["BAD_REQUEST"] = 400] = "BAD_REQUEST";
  HttpStatusCode2[HttpStatusCode2["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
  HttpStatusCode2[HttpStatusCode2["PAYMENT_REQUIRED"] = 402] = "PAYMENT_REQUIRED";
  HttpStatusCode2[HttpStatusCode2["FORBIDDEN"] = 403] = "FORBIDDEN";
  HttpStatusCode2[HttpStatusCode2["NOT_FOUND"] = 404] = "NOT_FOUND";
  HttpStatusCode2[HttpStatusCode2["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
  HttpStatusCode2[HttpStatusCode2["NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
  HttpStatusCode2[HttpStatusCode2["PROXY_AUTHENTICATION_REQUIRED"] = 407] = "PROXY_AUTHENTICATION_REQUIRED";
  HttpStatusCode2[HttpStatusCode2["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
  HttpStatusCode2[HttpStatusCode2["CONFLICT"] = 409] = "CONFLICT";
  HttpStatusCode2[HttpStatusCode2["GONE"] = 410] = "GONE";
  HttpStatusCode2[HttpStatusCode2["LENGTH_REQUIRED"] = 411] = "LENGTH_REQUIRED";
  HttpStatusCode2[HttpStatusCode2["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
  HttpStatusCode2[HttpStatusCode2["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
  HttpStatusCode2[HttpStatusCode2["URI_TOO_LONG"] = 414] = "URI_TOO_LONG";
  HttpStatusCode2[HttpStatusCode2["UNSUPPORTED_MEDIA_TYPE"] = 415] = "UNSUPPORTED_MEDIA_TYPE";
  HttpStatusCode2[HttpStatusCode2["RANGE_NOT_SATISFIABLE"] = 416] = "RANGE_NOT_SATISFIABLE";
  HttpStatusCode2[HttpStatusCode2["EXPECTATION_FAILED"] = 417] = "EXPECTATION_FAILED";
  HttpStatusCode2[HttpStatusCode2["I_AM_A_TEAPOT"] = 418] = "I_AM_A_TEAPOT";
  HttpStatusCode2[HttpStatusCode2["MISDIRECTED_REQUEST"] = 421] = "MISDIRECTED_REQUEST";
  HttpStatusCode2[HttpStatusCode2["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
  HttpStatusCode2[HttpStatusCode2["LOCKED"] = 423] = "LOCKED";
  HttpStatusCode2[HttpStatusCode2["FAILED_DEPENDENCY"] = 424] = "FAILED_DEPENDENCY";
  HttpStatusCode2[HttpStatusCode2["UPGRADE_REQUIRED"] = 426] = "UPGRADE_REQUIRED";
  HttpStatusCode2[HttpStatusCode2["PRECONDITION_REQUIRED"] = 428] = "PRECONDITION_REQUIRED";
  HttpStatusCode2[HttpStatusCode2["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
  HttpStatusCode2[HttpStatusCode2["REQUEST_HEADER_FIELDS_TOO_LARGE"] = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE";
  HttpStatusCode2[HttpStatusCode2["UNAVAILABLE_FOR_LEGAL_REASONS"] = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS";
  HttpStatusCode2[HttpStatusCode2["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
  HttpStatusCode2[HttpStatusCode2["NOT_IMPLEMENTED"] = 501] = "NOT_IMPLEMENTED";
  HttpStatusCode2[HttpStatusCode2["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
  HttpStatusCode2[HttpStatusCode2["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
  HttpStatusCode2[HttpStatusCode2["GATEWAY_TIMEOUT"] = 504] = "GATEWAY_TIMEOUT";
  HttpStatusCode2[HttpStatusCode2["HTTP_VERSION_NOT_SUPPORTED"] = 505] = "HTTP_VERSION_NOT_SUPPORTED";
  HttpStatusCode2[HttpStatusCode2["VARIANT_ALSO_NEGOTIATES"] = 506] = "VARIANT_ALSO_NEGOTIATES";
  HttpStatusCode2[HttpStatusCode2["INSUFFICIENT_STORAGE"] = 507] = "INSUFFICIENT_STORAGE";
  HttpStatusCode2[HttpStatusCode2["LOOP_DETECTED"] = 508] = "LOOP_DETECTED";
  HttpStatusCode2[HttpStatusCode2["NOT_EXTENDED"] = 510] = "NOT_EXTENDED";
  HttpStatusCode2[HttpStatusCode2["NETWORK_AUTHENTICATION_REQUIRED"] = 511] = "NETWORK_AUTHENTICATION_REQUIRED";
})(HttpStatusCode || (HttpStatusCode = {}));
new Intl.Collator(void 0, {
  numeric: true,
  sensitivity: "base"
}).compare;
function groupBy(array, key) {
  return array.reduce((map2, t3) => {
    const groupKey = t3[key];
    const group = map2.get(groupKey);
    if (group) {
      group.push(t3);
    } else {
      map2.set(groupKey, [t3]);
    }
    return map2;
  }, /* @__PURE__ */ new Map());
}
var DateTemplates;
(function(DateTemplates2) {
  DateTemplates2["Days"] = "MMMM d";
  DateTemplates2["Long"] = "yyyy-MM-dd HH:mm:ss";
  DateTemplates2["Short"] = "yyyy-MM-dd";
})(DateTemplates || (DateTemplates = {}));
({
  isMac: (() => {
    try {
      return window.navigator.platform.toUpperCase().indexOf("MAC") >= 0;
    } catch {
      return false;
    }
  })()
});
function isEmpty(object) {
  return object ? Object.keys(object).length === 0 : false;
}
const ORDER_LAST = 9999;
const _sfc_main = defineComponent({
  name: "ParameterList",
  props: {
    advancedParamsClass: {
      default: void 0,
      type: [Array, Object, String]
    },
    groups: {
      default: () => [],
      type: Array
    },
    fields: {
      required: true,
      type: Array
    },
    groupId: {
      default: void 0,
      type: String
    },
    readonly: {
      default: false,
      type: Boolean
    },
    values: {
      default: void 0,
      type: Object
    }
  },
  setup(props4) {
    const { t: $t2 } = useI18n();
    const expanded = ref$1(false);
    const groupedParams = computed(() => groupBy(props4.fields, "groupId"));
    const allParams = computed(() => props4.groupId ? groupedParams.value.get(props4.groupId) : groupedParams.value.get(null));
    const visibleParams = computed(() => {
      var _a;
      return (_a = allParams.value) == null ? void 0 : _a.filter((p2) => !isHiddenParam(p2));
    });
    const params = computed(() => {
      var _a;
      return (_a = visibleParams.value) == null ? void 0 : _a.filter((p2) => !isAdvanceParam(p2));
    });
    const advancedParams = computed(() => {
      var _a;
      return (_a = visibleParams.value) == null ? void 0 : _a.filter(isAdvanceParam);
    });
    function getGroupOrder(group) {
      const idx = props4.fields.findIndex((p2) => p2.groupId === group.id);
      return idx >= 0 ? idx : void 0;
    }
    function getOrder(v) {
      const idx = props4.fields.indexOf(v);
      return idx >= 0 ? idx : void 0;
    }
    function isAdvanceParam(v) {
      var _a;
      return ((_a = v == null ? void 0 : v.metadata) == null ? void 0 : _a.expertise) === "advanced";
    }
    function isHiddenParam(v) {
      var _a;
      return ((_a = v == null ? void 0 : v.metadata) == null ? void 0 : _a.visibility) === "hidden";
    }
    function showGroup(group) {
      if (!group.toggles || isEmpty(group.toggles)) return true;
      return Object.entries(group.toggles).every(([toggleKey, toggleValue]) => {
        var _a;
        const paramValue = (_a = props4.values) == null ? void 0 : _a[toggleKey];
        return paramValue === toggleValue;
      });
    }
    return {
      $t: $t2,
      advancedParams,
      expanded,
      getGroupOrder,
      getOrder,
      groupedParams,
      ORDER_LAST,
      params,
      showGroup
    };
  }
});
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  var _a;
  const _component_ParameterList = resolveComponent("ParameterList", true);
  const _component_rv_expansion_item = resolveComponent("rv-expansion-item");
  const _component_rv_ellipsis_text = resolveComponent("rv-ellipsis-text");
  return openBlock(), createElementBlock("div", normalizeProps(guardReactiveProps(_ctx.$attrs)), [
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.groups, (group) => {
      return openBlock(), createElementBlock(Fragment, {
        key: group.id
      }, [
        _ctx.showGroup(group) ? (openBlock(), createBlock(_component_rv_expansion_item, {
          key: 0,
          border: "",
          class: "q-mb-sm",
          "content-class": {
            "q-mt-sm": _ctx.readonly,
            "q-pt-md": !_ctx.readonly
          },
          "default-opened": "",
          label: group.name,
          style: normalizeStyle({ order: _ctx.getGroupOrder(group) })
        }, {
          default: withCtx(() => [
            createVNode(_component_ParameterList, mergeProps({ ref_for: true }, _ctx.$attrs, {
              fields: _ctx.fields,
              "group-id": group.id,
              groups: group.subGroups,
              readonly: _ctx.readonly,
              values: _ctx.values
            }), {
              param: withCtx(({ param: nested }) => [
                createElementVNode("div", {
                  style: normalizeStyle({ order: _ctx.getOrder(nested) })
                }, [
                  renderSlot(_ctx.$slots, "param", { param: nested })
                ], 4)
              ]),
              _: 2
            }, 1040, ["fields", "group-id", "groups", "readonly", "values"])
          ]),
          _: 2
        }, 1032, ["content-class", "label", "style"])) : createCommentVNode("", true)
      ], 64);
    }), 128)),
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.params, (param) => {
      return openBlock(), createElementBlock("div", {
        key: param.key,
        style: normalizeStyle({ order: _ctx.getOrder(param) })
      }, [
        renderSlot(_ctx.$slots, "param", { param })
      ], 4);
    }), 128)),
    ((_a = _ctx.advancedParams) == null ? void 0 : _a.length) ? (openBlock(), createBlock(_component_rv_expansion_item, {
      key: 0,
      modelValue: _ctx.expanded,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.expanded = $event),
      class: normalizeClass(["advanced-parameters q-pa-md border-card rounded-borders", { "q-mt-sm": _ctx.readonly }]),
      "content-class": _ctx.advancedParamsClass,
      "header-class": { "q-mb-md": _ctx.expanded && !_ctx.readonly },
      style: normalizeStyle({ order: _ctx.ORDER_LAST })
    }, {
      label: withCtx(() => [
        createVNode(_component_rv_ellipsis_text, {
          class: "zero-min-width text-subtitle3",
          text: _ctx.$t("rvai-params.general.text.advancedParams")
        }, null, 8, ["text"])
      ]),
      default: withCtx(() => [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.advancedParams, (param) => {
          return openBlock(), createElementBlock("div", {
            key: param.key,
            style: normalizeStyle({ order: _ctx.getOrder(param) })
          }, [
            renderSlot(_ctx.$slots, "param", { param })
          ], 4);
        }), 128))
      ]),
      _: 3
    }, 8, ["modelValue", "class", "content-class", "header-class", "style"])) : createCommentVNode("", true)
  ], 16);
}
const ParameterList = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
const components = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ParamTitle,
  Parameter: _sfc_main$1,
  ParameterList,
  ReadOnlyParam
}, Symbol.toStringTag, { value: "Module" }));
const componentProps = {
  definition: {
    required: true,
    type: Object
  },
  disable: {
    default: false,
    type: Boolean
  },
  modelValue: {
    default: void 0,
    type: [Number, Object, String, Boolean]
  },
  readonly: {
    default: false,
    type: Boolean
  },
  valueOnly: {
    default: false,
    type: Boolean
  }
};
const newMessages = {
  "rvai-params": {
    errors: {
      bothAreRequired: "Both key and value are required",
      duplicatedKeys: "Keys should be unique",
      selectionRequired: "This field requires at least one selection"
    },
    general: {
      allSelected: "All selected",
      key: "key",
      no: "No",
      none: "None",
      text: {
        advancedParams: "Advanced parameters"
      },
      symbols: {
        colon: ":"
      },
      unset: "Unset",
      value: "value",
      yes: "Yes"
    }
  }
};
function initializeI18n() {
  const i18n = useI18n();
  i18n.mergeLocaleMessage("en", newMessages);
}
function initialize(options) {
  initializeI18n();
  provideOptions(options);
}
const PREFIX = "Rv";
const install = function(app2) {
  Object.entries(components).forEach(([name2, component]) => {
    app2.component(`${PREFIX}${name2}`, component);
  });
};
const plugin = { install };
export {
  ParamTitle,
  _sfc_main$1 as Parameter,
  ParameterList,
  ReadOnlyParam,
  componentProps,
  plugin as default,
  initialize,
  provideOptions,
  useOptions$1 as useOptions
};
//# sourceMappingURL=index.es.js.map
